
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9b81"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9b81"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("bNos8", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $j5wbN = parcelRequire("j5wbN");

var $dtE14 = parcelRequire("dtE14");

var $d4mGr = parcelRequire("d4mGr");

var $4X6M3 = parcelRequire("4X6M3");

var $lThBY = parcelRequire("lThBY");

var $2oD7l = parcelRequire("2oD7l");

var $hAaqX = parcelRequire("hAaqX");

var $5A24j = parcelRequire("5A24j");

var $1c3ii = parcelRequire("1c3ii");
var $89673d226db80b47$var$loadQuery = $1c3ii.loadQuery;

var $9pgH3 = parcelRequire("9pgH3");

var $eLBQT = parcelRequire("eLBQT");

var $jwpXG = parcelRequire("jwpXG");

var $9KXWY = parcelRequire("9KXWY");

var $3QqxT = parcelRequire("3QqxT");

var $6RH4A = parcelRequire("6RH4A");

var $2rQPf = parcelRequire("2rQPf");

var $dAN4o = parcelRequire("dAN4o");

var $fH4DL = parcelRequire("fH4DL");

var $hASCV = parcelRequire("hASCV");

var $1tdq5 = parcelRequire("1tdq5");

var $4fG2B = parcelRequire("4fG2B");

var $jc1m1 = parcelRequire("jc1m1");

var $5v24M = parcelRequire("5v24M");

var $eJz0f = parcelRequire("eJz0f");
/**
 * The public interface to react-relay.
 * Currently contains both Relay Hooks and legacy Container APIs.
 * Will eventually only export the interface from ./hooks.js.
 */ module.exports = {
    ConnectionHandler: $eJz0f.ConnectionHandler,
    QueryRenderer: $lThBY,
    LocalQueryRenderer: $d4mGr,
    MutationTypes: $eJz0f.MutationTypes,
    RangeOperations: $eJz0f.RangeOperations,
    ReactRelayContext: $j5wbN,
    applyOptimisticMutation: $eJz0f.applyOptimisticMutation,
    commitLocalUpdate: $eJz0f.commitLocalUpdate,
    commitMutation: $eJz0f.commitMutation,
    createFragmentContainer: $dtE14.createContainer,
    createPaginationContainer: $4X6M3.createContainer,
    createRefetchContainer: $2oD7l.createContainer,
    fetchQuery_DEPRECATED: $eJz0f.fetchQuery_DEPRECATED,
    graphql: $eJz0f.graphql,
    readInlineData: $eJz0f.readInlineData,
    requestSubscription: $eJz0f.requestSubscription,
    // Relay Hooks
    EntryPointContainer: $hAaqX,
    RelayEnvironmentProvider: $eLBQT,
    ProfilerContext: $9pgH3,
    fetchQuery: $eJz0f.fetchQuery,
    loadQuery: $89673d226db80b47$var$loadQuery,
    loadEntryPoint: $5A24j,
    useClientQuery: $jwpXG,
    useFragment: $3QqxT,
    useLazyLoadQuery: $6RH4A,
    useEntryPointLoader: $9KXWY,
    useQueryLoader: $hASCV,
    useMutation: $2rQPf,
    usePaginationFragment: $dAN4o,
    usePreloadedQuery: $fH4DL,
    useRefetchableFragment: $1tdq5,
    useRelayEnvironment: $4fG2B,
    useSubscribeToInvalidationState: $jc1m1,
    useSubscription: $5v24M
};

});
parcelRegister("j5wbN", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $de577414e5b4a9da$var$createRelayContext = $eJz0f.__internal.createRelayContext;
module.exports = $de577414e5b4a9da$var$createRelayContext($acw62);

});
parcelRegister("eJz0f", function(module, exports) {
/**
 * Relay v15.0.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("6yIWp"));

});
parcelRegister("6yIWp", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7uWVM = parcelRequire("7uWVM");

var $dGCyA = parcelRequire("dGCyA");

var $ils74 = parcelRequire("ils74");

var $5wpCP = parcelRequire("5wpCP");

var $8CB0r = parcelRequire("8CB0r");

var $aq9ZM = parcelRequire("aq9ZM");

var $io2Di = parcelRequire("io2Di");

var $f8nQK = parcelRequire("f8nQK");

var $cuefK = parcelRequire("cuefK");

var $hIn3L = parcelRequire("hIn3L");

var $l6QXA = parcelRequire("l6QXA");

var $lmXME = parcelRequire("lmXME");

var $f0RKF = parcelRequire("f0RKF");

var $1PcQ6 = parcelRequire("1PcQ6");

var $aW0zg = parcelRequire("aW0zg");

var $gucor = parcelRequire("gucor");

var $i2E13 = parcelRequire("i2E13");
var $4c68c76f4451a21f$var$generateClientID = $i2E13.generateClientID, $4c68c76f4451a21f$var$generateUniqueClientID = $i2E13.generateUniqueClientID, $4c68c76f4451a21f$var$isClientID = $i2E13.isClientID;

var $lWuAe = parcelRequire("lWuAe");

var $ftuXr = parcelRequire("ftuXr");

var $i7dei = parcelRequire("i7dei");

var $2MLqe = parcelRequire("2MLqe");

var $fkd0X = parcelRequire("fkd0X");

var $7V8U5 = parcelRequire("7V8U5");

var $40tQb = parcelRequire("40tQb");

var $iEVza = parcelRequire("iEVza");

var $idJ2w = parcelRequire("idJ2w");

var $6rSHS = parcelRequire("6rSHS");

var $cGYI4 = parcelRequire("cGYI4");

var $L6WFS = parcelRequire("L6WFS");

var $5DrBw = parcelRequire("5DrBw");

var $5o6zS = parcelRequire("5o6zS");

var $2DcyS = parcelRequire("2DcyS");

var $c18RI = parcelRequire("c18RI");

var $9fUzq = parcelRequire("9fUzq");

var $7sl3K = parcelRequire("7sl3K");

var $k9Ckr = parcelRequire("k9Ckr");

var $leZHb = parcelRequire("leZHb");

var $5UXry = parcelRequire("5UXry");

var $k0hcd = parcelRequire("k0hcd");

var $7U4ur = parcelRequire("7U4ur");

var $2i5iW = parcelRequire("2i5iW");

var $8tEVh = parcelRequire("8tEVh");

var $402wI = parcelRequire("402wI");

var $47Vax = parcelRequire("47Vax");

var $1Q5mH = parcelRequire("1Q5mH");

var $iyRh8 = parcelRequire("iyRh8");

var $9DGaB = parcelRequire("9DGaB");

var $84X73 = parcelRequire("84X73");

var $7gvgi = parcelRequire("7gvgi");

var $ii2WU = parcelRequire("ii2WU");

var $dsOUI = parcelRequire("dsOUI");

var $9JzHH = parcelRequire("9JzHH");

var $aLywI = parcelRequire("aLywI");

var $8Q6tr = parcelRequire("8Q6tr");

var $hpvi1 = parcelRequire("hpvi1");
var $4c68c76f4451a21f$var$mapStr, $4c68c76f4451a21f$var$setStr, $4c68c76f4451a21f$var$promiseStr, $4c68c76f4451a21f$var$objStr;
/**
 * The public interface to Relay Runtime.
 */ module.exports = {
    // Core API
    Environment: $7V8U5,
    Network: $cuefK,
    Observable: $hIn3L,
    QueryResponseCache: $l6QXA,
    RecordSource: $L6WFS,
    Record: $iEVza,
    ReplaySubject: $aLywI,
    Store: $6rSHS,
    areEqualSelectors: $idJ2w.areEqualSelectors,
    createFragmentSpecResolver: $lWuAe,
    createNormalizationSelector: $idJ2w.createNormalizationSelector,
    createOperationDescriptor: $40tQb.createOperationDescriptor,
    createReaderSelector: $idJ2w.createReaderSelector,
    createRequestDescriptor: $40tQb.createRequestDescriptor,
    getArgumentValues: $5DrBw.getArgumentValues,
    getDataIDsFromFragment: $idJ2w.getDataIDsFromFragment,
    getDataIDsFromObject: $idJ2w.getDataIDsFromObject,
    getNode: $aW0zg.getNode,
    getFragment: $aW0zg.getFragment,
    getInlineDataFragment: $aW0zg.getInlineDataFragment,
    getModuleComponentKey: $5DrBw.getModuleComponentKey,
    getModuleOperationKey: $5DrBw.getModuleOperationKey,
    getPaginationFragment: $aW0zg.getPaginationFragment,
    getPluralSelector: $idJ2w.getPluralSelector,
    getRefetchableFragment: $aW0zg.getRefetchableFragment,
    getRequest: $aW0zg.getRequest,
    getRequestIdentifier: $8tEVh,
    getSelector: $idJ2w.getSelector,
    getSelectorsFromObject: $idJ2w.getSelectorsFromObject,
    getSingularSelector: $idJ2w.getSingularSelector,
    getStorageKey: $5DrBw.getStorageKey,
    getVariablesFromFragment: $idJ2w.getVariablesFromFragment,
    getVariablesFromObject: $idJ2w.getVariablesFromObject,
    getVariablesFromPluralFragment: $idJ2w.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $idJ2w.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $47Vax,
    graphql: $aW0zg.graphql,
    isFragment: $aW0zg.isFragment,
    isInlineDataFragment: $aW0zg.isInlineDataFragment,
    isRequest: $aW0zg.isRequest,
    readInlineData: $2MLqe,
    // Declarative mutation API
    MutationTypes: $f8nQK.MutationTypes,
    RangeOperations: $f8nQK.RangeOperations,
    // Extensions
    DefaultHandlerProvider: $5wpCP,
    ConnectionHandler: $7uWVM,
    MutationHandlers: $ils74,
    VIEWER_ID: $2DcyS.VIEWER_ID,
    VIEWER_TYPE: $2DcyS.VIEWER_TYPE,
    // Helpers (can be implemented via the above API)
    applyOptimisticMutation: $8CB0r,
    commitLocalUpdate: $aq9ZM,
    commitMutation: $io2Di,
    fetchQuery: $lmXME,
    fetchQuery_DEPRECATED: $f0RKF,
    isRelayModernEnvironment: $i7dei,
    requestSubscription: $c18RI,
    // Configuration interface for legacy or special uses
    ConnectionInterface: $dGCyA,
    // Utilities
    PreloadableQueryRegistry: $gucor,
    RelayProfiler: $9JzHH,
    createPayloadFor3DField: $9fUzq,
    // INTERNAL-ONLY: These exports might be removed at any point.
    RelayConcreteNode: $84X73,
    RelayError: $ii2WU,
    RelayFeatureFlags: $dsOUI,
    DEFAULT_HANDLE_KEY: $7gvgi.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $5DrBw.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $5DrBw.FRAGMENT_OWNER_KEY,
    ID_KEY: $5DrBw.ID_KEY,
    REF_KEY: $5DrBw.REF_KEY,
    REFS_KEY: $5DrBw.REFS_KEY,
    ROOT_ID: $5DrBw.ROOT_ID,
    ROOT_TYPE: $5DrBw.ROOT_TYPE,
    TYPENAME_KEY: $5DrBw.TYPENAME_KEY,
    deepFreeze: $7sl3K,
    generateClientID: $4c68c76f4451a21f$var$generateClientID,
    generateUniqueClientID: $4c68c76f4451a21f$var$generateUniqueClientID,
    getRelayHandleKey: $2i5iW,
    isClientID: $4c68c76f4451a21f$var$isClientID,
    isPromise: $1Q5mH,
    isScalarAndEqual: $iyRh8,
    recycleNodesInto: $9DGaB,
    stableCopy: $8Q6tr,
    getFragmentIdentifier: $k9Ckr,
    getRefetchMetadata: $7U4ur,
    getPaginationMetadata: $leZHb,
    getPaginationVariables: $5UXry,
    getPendingOperationsForFragment: $k0hcd,
    getValueAtPath: $402wI,
    __internal: {
        ResolverFragments: $5o6zS,
        OperationTracker: $cGYI4,
        createRelayContext: $ftuXr,
        getOperationVariables: $fkd0X.getOperationVariables,
        fetchQuery: $1PcQ6.fetchQuery,
        fetchQueryDeduped: $1PcQ6.fetchQueryDeduped,
        getPromiseForActiveRequest: $1PcQ6.getPromiseForActiveRequest,
        getObservableForActiveRequest: $1PcQ6.getObservableForActiveRequest,
        withProvidedVariables: $hpvi1
    }
};

});
parcelRegister("7uWVM", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $i2E13 = parcelRequire("i2E13");
var $57590c391e395ad0$var$generateClientID = $i2E13.generateClientID;

var $5DrBw = parcelRequire("5DrBw");
var $57590c391e395ad0$var$getStableStorageKey = $5DrBw.getStableStorageKey;

var $2i5iW = parcelRequire("2i5iW");

var $dGCyA = parcelRequire("dGCyA");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $57590c391e395ad0$var$CONNECTION = "connection";
// Per-instance incrementing index used to generate unique edge IDs
var $57590c391e395ad0$var$NEXT_EDGE_INDEX = "__connection_next_edge_index";
/**
 * @public
 *
 * A default runtime handler for connection fields that appends newly fetched
 * edges onto the end of a connection, regardless of the arguments used to fetch
 * those edges.
 */ function $57590c391e395ad0$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $dGCyA.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    // In rare cases the handleKey field may be unset even though the client
    // connection record exists, in this case new edges should still be merged
    // into the existing client connection record (and the field reset to point
    // to that record).
    var clientConnectionID = $57590c391e395ad0$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        // Initial fetch with data: copy fields from the server record
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $57590c391e395ad0$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $57590c391e395ad0$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($57590c391e395ad0$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) // If the handleKey field was unset but the client connection record
        // existed, update the field to point to the record
        record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        // Subsequent fetches:
        // - updated fields on the connection
        // - merge prev/next edges, de-duplicating by node id
        // - synthesize page info fields
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $57590c391e395ad0$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        // Reset EDGES and PAGE_INFO fields
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                // Forward pagination from the end of the connection: append edges
                if (clientPageInfo && args.after === clientPageInfo.getValue(END_CURSOR)) {
                    var nodeIDs = new Set();
                    $57590c391e395ad0$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $57590c391e395ad0$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                // Backward pagination from the start of the connection: prepend edges
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $57590c391e395ad0$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $57590c391e395ad0$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else // The connection was refetched from the beginning/end: replace edges
            nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else // $FlowFixMe[incompatible-type]
        nextEdges = prevEdges;
        // Update edges only if they were updated, the null check is
        // for Flow (prevEdges could be null).
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        // Page info should be updated even if no new edge were returned.
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) // The connection was refetched from the beginning/end: replace
            // page_info
            clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === "string") clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === "string") clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
/**
 * @public
 *
 * Given a record and the name of the schema field for which a connection was
 * fetched, returns the linked connection record.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * The `friends` connection record can be accessed with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = ConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   // Access fields on the connection:
 *   const edges = friends.getLinkedRecords('edges');
 * }
 * ```
 *
 * TODO: t15733312
 * Currently we haven't run into this case yet, but we need to add a `getConnections`
 * that returns an array of the connections under the same `key` regardless of the variables.
 */ function $57590c391e395ad0$var$getConnection(record, key, filters) {
    var handleKey = $2i5iW($57590c391e395ad0$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
/**
 * @public
 *
 * Given a record ID, the key of a connection field, and optional filters used
 * to identify the connection, returns the connection ID.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<user-id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *     edges {
 *       node {
 *         id
 *       }
 *     }
 *   }
 * }
 * ```
 *
 * The ID of the `friends` connection record can be accessed with:
 *
 * ```
 * store => {
 *   const connectionID = ConnectionHandler.getConnectionID('<user-id>', 'FriendsFragment_friends');
 * }
 * ```
 */ function $57590c391e395ad0$var$getConnectionID(recordID, key, filters) {
    var handleKey = $2i5iW($57590c391e395ad0$var$CONNECTION, key, null);
    var storageKey = $57590c391e395ad0$var$getStableStorageKey(handleKey, filters);
    return $57590c391e395ad0$var$generateClientID(recordID, storageKey);
}
/**
 * @public
 *
 * Inserts an edge after the given cursor, or at the end of the list if no
 * cursor is provided.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * An edge can be appended with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = ConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   const edge = store.create('<edge-id>', 'FriendsEdge');
 *   ConnectionHandler.insertEdgeAfter(friends, edge);
 * }
 * ```
 */ function $57590c391e395ad0$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $dGCyA.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
/**
 * @public
 *
 * Creates an edge for a connection record, given a node and edge type.
 */ function $57590c391e395ad0$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $dGCyA.get(), NODE = _ConnectionInterface$3.NODE;
    // An index-based client ID could easily conflict (unless it was
    // auto-incrementing, but there is nowhere to the store the id)
    // Instead, construct a client ID based on the connection ID and node ID,
    // which will only conflict if the same node is added to the same connection
    // twice. This is acceptable since the `insertEdge*` functions ignore
    // duplicates.
    var edgeID = $57590c391e395ad0$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue("cursor") == null) // Always use null instead of undefined value for cursor
    // to avoid considering it as missing data
    edge.setValue(null, "cursor");
    return edge;
}
/**
 * @public
 *
 * Inserts an edge before the given cursor, or at the beginning of the list if
 * no cursor is provided.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * An edge can be prepended with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = ConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   const edge = store.create('<edge-id>', 'FriendsEdge');
 *   ConnectionHandler.insertEdgeBefore(friends, edge);
 * }
 * ```
 */ function $57590c391e395ad0$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $dGCyA.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
/**
 * @public
 *
 * Remove any edges whose `node.id` matches the given id.
 */ function $57590c391e395ad0$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $dGCyA.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
/**
 * @internal
 *
 * Creates a copy of an edge with a unique ID based on per-connection-instance
 * incrementing edge index. This is necessary to avoid collisions between edges,
 * which can occur because (edge) client IDs are assigned deterministically
 * based on the path from the nearest node with an id.
 *
 * Example: if the first N edges of the same connection are refetched, the edges
 * from the second fetch will be assigned the same IDs as the first fetch, even
 * though the nodes they point to may be different (or the same and in different
 * order).
 */ function $57590c391e395ad0$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $dGCyA.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($57590c391e395ad0$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === "number") && $aaXwj(false);
    var edgeID = $57590c391e395ad0$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue("cursor") == null) // Always use null instead of undefined value for cursor
    // to avoid considering it as missing data
    connectionEdge.setValue(null, "cursor");
    connection.setValue(edgeIndex + 1, $57590c391e395ad0$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
/**
 * @internal
 *
 * Adds the source edges to the target edges, skipping edges with
 * duplicate node ids.
 */ function $57590c391e395ad0$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $dGCyA.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $57590c391e395ad0$var$buildConnectionEdge,
    createEdge: $57590c391e395ad0$var$createEdge,
    deleteNode: $57590c391e395ad0$var$deleteNode,
    getConnection: $57590c391e395ad0$var$getConnection,
    getConnectionID: $57590c391e395ad0$var$getConnectionID,
    insertEdgeAfter: $57590c391e395ad0$var$insertEdgeAfter,
    insertEdgeBefore: $57590c391e395ad0$var$insertEdgeBefore,
    update: $57590c391e395ad0$var$update
};

});
parcelRegister("i2E13", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $dsOUI = parcelRequire("dsOUI");

var $1pW7i = parcelRequire("1pW7i");
var $d227743bd67f9787$var$intern = $1pW7i.intern;
var $d227743bd67f9787$var$PREFIX = "client:";
function $d227743bd67f9787$var$generateClientID(id, storageKey, index) {
    var internedId = $dsOUI.STRING_INTERN_LEVEL <= 0 ? id : $d227743bd67f9787$var$intern(id, $dsOUI.MAX_DATA_ID_LENGTH);
    var key = internedId + ":" + storageKey;
    if (index != null) key += ":" + index;
    if (key.indexOf($d227743bd67f9787$var$PREFIX) !== 0) key = $d227743bd67f9787$var$PREFIX + key;
    return key;
}
function $d227743bd67f9787$var$isClientID(id) {
    return id.indexOf($d227743bd67f9787$var$PREFIX) === 0;
}
var $d227743bd67f9787$var$localID = 0;
function $d227743bd67f9787$var$generateUniqueClientID() {
    return "".concat($d227743bd67f9787$var$PREFIX, "local:").concat($d227743bd67f9787$var$localID++);
}
// Client objects backed by Relay Resolvers may not be able to provide a
// globally unique ID, so we provide a namespace.
function $d227743bd67f9787$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($d227743bd67f9787$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ":" + index;
    return key;
}
module.exports = {
    generateClientID: $d227743bd67f9787$var$generateClientID,
    generateClientObjectClientID: $d227743bd67f9787$var$generateClientObjectClientID,
    generateUniqueClientID: $d227743bd67f9787$var$generateUniqueClientID,
    isClientID: $d227743bd67f9787$var$isClientID
};

});
parcelRegister("dsOUI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $9cd562468f31220f$var$RelayFeatureFlags = {
    ENABLE_CLIENT_EDGES: false,
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_PARTIAL_RENDERING_DEFAULT: true,
    ENABLE_REACT_FLIGHT_COMPONENT_FIELD: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    USE_REACT_CACHE: false,
    USE_REACT_CACHE_LEGACY_TIMEOUTS: true,
    ENABLE_QUERY_RENDERER_SET_STATE_PREVENTION: false
};
module.exports = $9cd562468f31220f$var$RelayFeatureFlags;

});

parcelRegister("1pW7i", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $108534fc88e2163a$var$internTable = new Map();
var $108534fc88e2163a$var$nextIndex = 1;
var $108534fc88e2163a$var$digits = $108534fc88e2163a$var$initDigitTable();
// Character used as the prefix for interned strings. The specific character is
// chosen to reduce the likelihood that non-interned input strings need to be
// escaped (choosing eg a-Z would increase the likelihood we need to escape)
var $108534fc88e2163a$var$INTERN_PREFIX = "	";
// Character used as the prefix of escaped strings. As above, this is also
// chosen to be unlikely in normal input strings.
var $108534fc88e2163a$var$ESCAPE_PREFIX = "\v";
function $108534fc88e2163a$var$initDigitTable() {
    // disable lint because digits isn't defined when this function is called
    // eslint-disable-next-line no-shadow
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
// Escape a string so that it cannot conflict with an interned string
function $108534fc88e2163a$var$escape(str) {
    if (// "\t<digit>..." -> "\v\t<digit>..."
    str[0] === $108534fc88e2163a$var$INTERN_PREFIX && $108534fc88e2163a$var$digits.has(str[1]) || // "\v..." -> "\v\v..."
    str[0] === $108534fc88e2163a$var$ESCAPE_PREFIX) return $108534fc88e2163a$var$ESCAPE_PREFIX + str;
    return str;
}
// Interns the input string if its length equals or exceeds the given `limit`,
// returning a shorter replacement string that is uniquely associated with the
// input: multiple calls to intern() for the equivalent input strings (and limit)
// will always return the exact same string.
// Strings shorter than the limit are not interned but are escaped if they
// could conflict with interned strings.
function $108534fc88e2163a$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $108534fc88e2163a$var$escape(str);
    var internedString = $108534fc88e2163a$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $108534fc88e2163a$var$INTERN_PREFIX + $108534fc88e2163a$var$nextIndex++;
    $108534fc88e2163a$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $108534fc88e2163a$var$intern
};

});


parcelRegister("5DrBw", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $41a601e2d7f3969a$var$_interopRequireDefault = $1jnue.default;

var $41a601e2d7f3969a$var$_toConsumableArray2 = $41a601e2d7f3969a$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $2i5iW = parcelRequire("2i5iW");

var $84X73 = parcelRequire("84X73");

var $8Q6tr = parcelRequire("8Q6tr");

var $aaXwj = parcelRequire("aaXwj");
var $41a601e2d7f3969a$var$VARIABLE = $84X73.VARIABLE, $41a601e2d7f3969a$var$LITERAL = $84X73.LITERAL, $41a601e2d7f3969a$var$OBJECT_VALUE = $84X73.OBJECT_VALUE, $41a601e2d7f3969a$var$LIST_VALUE = $84X73.LIST_VALUE;
var $41a601e2d7f3969a$var$MODULE_COMPONENT_KEY_PREFIX = "__module_component_";
var $41a601e2d7f3969a$var$MODULE_OPERATION_KEY_PREFIX = "__module_operation_";
function $41a601e2d7f3969a$var$getArgumentValue(arg, variables) {
    if (arg.kind === $41a601e2d7f3969a$var$VARIABLE) // Variables are provided at runtime and are not guaranteed to be stable.
    return $41a601e2d7f3969a$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $41a601e2d7f3969a$var$LITERAL) // The Relay compiler generates stable ConcreteArgument values.
    return arg.value;
    else if (arg.kind === $41a601e2d7f3969a$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $41a601e2d7f3969a$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $41a601e2d7f3969a$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($41a601e2d7f3969a$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
/**
 * Returns the values of field/fragment arguments as an object keyed by argument
 * names. Guaranteed to return a result with stable ordered nested values.
 */ function $41a601e2d7f3969a$var$getArgumentValues(args, variables) {
    var values = {};
    args.forEach(function(arg) {
        values[arg.name] = $41a601e2d7f3969a$var$getArgumentValue(arg, variables);
    });
    return values;
}
/**
 * Given a handle field and variable values, returns a key that can be used to
 * uniquely identify the combination of the handle name and argument values.
 *
 * Note: the word "storage" here refers to the fact this key is primarily used
 * when writing the results of a key in a normalized graph or "store". This
 * name was used in previous implementations of Relay internals and is also
 * used here for consistency.
 */ function $41a601e2d7f3969a$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $2i5iW(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) // "Sort" the arguments by argument name: this is done by the compiler for
    // user-supplied arguments but the dynamic argument must also be in sorted
    // order.  Note that dynamic key argument name is double-underscore-
    // -prefixed, and a double-underscore prefix is disallowed for user-supplied
    // argument names, so there's no need to actually sort.
    filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $41a601e2d7f3969a$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $41a601e2d7f3969a$var$formatStorageKey(handleName, $41a601e2d7f3969a$var$getArgumentValues(filterArgs, variables));
}
/**
 * Given a field and variable values, returns a key that can be used to
 * uniquely identify the combination of the field name and argument values.
 *
 * Note: the word "storage" here refers to the fact this key is primarily used
 * when writing the results of a key in a normalized graph or "store". This
 * name was used in previous implementations of Relay internals and is also
 * used here for consistency.
 */ function $41a601e2d7f3969a$var$getStorageKey(field, variables) {
    if (field.storageKey) // TODO T23663664: Handle nodes do not yet define a static storageKey.
    return field.storageKey;
    var args = $41a601e2d7f3969a$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $41a601e2d7f3969a$var$formatStorageKey(name, $41a601e2d7f3969a$var$getArgumentValues(args, variables)) : name;
}
/**
 * Given a field the method returns an array of arguments.
 * For Relay resolver fields, we store arguments on the field and fragment
 * and this method return combined list of arguments.
 */ function $41a601e2d7f3969a$var$getArguments(field) {
    if (field.kind === "RelayResolver" || field.kind === "RelayLiveResolver") {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === "undefined" ? undefined : field.args;
    return args;
}
/**
 * Given a `name` (eg. "foo") and an object representing argument values
 * (eg. `{orberBy: "name", first: 10}`) returns a unique storage key
 * (ie. `foo{"first":10,"orderBy":"name"}`).
 *
 * This differs from getStorageKey which requires a ConcreteNode where arguments
 * are assumed to already be sorted into a stable order.
 */ function $41a601e2d7f3969a$var$getStableStorageKey(name, args) {
    return $41a601e2d7f3969a$var$formatStorageKey(name, $8Q6tr(args));
}
/**
 * Given a name and argument values, format a storage key.
 *
 * Arguments and the values within them are expected to be ordered in a stable
 * alphabetical ordering.
 */ function $41a601e2d7f3969a$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ":" + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "undefined"));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(","), ")");
}
/**
 * Given Variables and a variable name, return a variable value with
 * all values in a stable order.
 */ function $41a601e2d7f3969a$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $aaXwj(false);
    return $8Q6tr(variables[name]);
}
function $41a601e2d7f3969a$var$getModuleComponentKey(documentName) {
    return "".concat($41a601e2d7f3969a$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $41a601e2d7f3969a$var$getModuleOperationKey(documentName) {
    return "".concat($41a601e2d7f3969a$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
/**
 * Constants shared by all implementations of RecordSource/MutableRecordSource/etc.
 */ var $41a601e2d7f3969a$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: "__actorIdentifier",
    CLIENT_EDGE_TRAVERSAL_PATH: "__clientEdgeTraversalPath",
    FRAGMENTS_KEY: "__fragments",
    FRAGMENT_OWNER_KEY: "__fragmentOwner",
    FRAGMENT_PROP_NAME_KEY: "__fragmentPropName",
    MODULE_COMPONENT_KEY: "__module_component",
    // alias returned by Reader
    ID_KEY: "__id",
    REF_KEY: "__ref",
    REFS_KEY: "__refs",
    ROOT_ID: "client:root",
    ROOT_TYPE: "__Root",
    TYPENAME_KEY: "__typename",
    INVALIDATED_AT_KEY: "__invalidated_at",
    IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: "__isWithinUnmatchedTypeRefinement",
    RELAY_RESOLVER_VALUE_KEY: "__resolverValue",
    RELAY_RESOLVER_INVALIDATION_KEY: "__resolverValueMayBeInvalid",
    RELAY_RESOLVER_SNAPSHOT_KEY: "__resolverSnapshot",
    RELAY_RESOLVER_ERROR_KEY: "__resolverError",
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: "__resolverOutputTypeRecordIDs",
    formatStorageKey: $41a601e2d7f3969a$var$formatStorageKey,
    getArgumentValue: $41a601e2d7f3969a$var$getArgumentValue,
    getArgumentValues: $41a601e2d7f3969a$var$getArgumentValues,
    getHandleStorageKey: $41a601e2d7f3969a$var$getHandleStorageKey,
    getStorageKey: $41a601e2d7f3969a$var$getStorageKey,
    getStableStorageKey: $41a601e2d7f3969a$var$getStableStorageKey,
    getModuleComponentKey: $41a601e2d7f3969a$var$getModuleComponentKey,
    getModuleOperationKey: $41a601e2d7f3969a$var$getModuleOperationKey
};
module.exports = $41a601e2d7f3969a$var$RelayStoreUtils;

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2i5iW", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7gvgi = parcelRequire("7gvgi");
var $1ab160947d145632$var$DEFAULT_HANDLE_KEY = $7gvgi.DEFAULT_HANDLE_KEY;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * Helper to create a unique name for a handle field based on the handle name, handle key and
 * source field.
 */ function $1ab160947d145632$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $1ab160947d145632$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $aaXwj(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $1ab160947d145632$var$getRelayHandleKey;

});
parcelRegister("7gvgi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
module.exports = {
    DEFAULT_HANDLE_KEY: ""
};

});

parcelRegister("aaXwj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $768901fea8dbe440$var$invariant;

});


parcelRegister("84X73", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Represents a common GraphQL request that can be executed, an `operation`
 * containing information to normalize the results, and a `fragment` derived
 * from that operation to read the response data (masking data from child
 * fragments).
 */ /**
 * Contains the parameters required for executing a GraphQL request.
 * The operation can either be provided as a persisted `id` or `text`. If given
 * in `text` format, a `cacheID` as a hash of the text should be set to be used
 * for local caching.
 */ var $5e1c8d0443ff7a9c$var$RelayConcreteNode = {
    ACTOR_CHANGE: "ActorChange",
    CONDITION: "Condition",
    CLIENT_COMPONENT: "ClientComponent",
    CLIENT_EDGE_TO_SERVER_OBJECT: "ClientEdgeToServerObject",
    CLIENT_EDGE_TO_CLIENT_OBJECT: "ClientEdgeToClientObject",
    CLIENT_EXTENSION: "ClientExtension",
    DEFER: "Defer",
    CONNECTION: "Connection",
    FLIGHT_FIELD: "FlightField",
    FRAGMENT: "Fragment",
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_DATA_FRAGMENT_SPREAD: "InlineDataFragmentSpread",
    INLINE_DATA_FRAGMENT: "InlineDataFragment",
    INLINE_FRAGMENT: "InlineFragment",
    LINKED_FIELD: "LinkedField",
    LINKED_HANDLE: "LinkedHandle",
    LITERAL: "Literal",
    LIST_VALUE: "ListValue",
    LOCAL_ARGUMENT: "LocalArgument",
    MODULE_IMPORT: "ModuleImport",
    ALIASED_FRAGMENT_SPREAD: "AliasedFragmentSpread",
    ALIASED_INLINE_FRAGMENT_SPREAD: "AliasedInlineFragmentSpread",
    RELAY_RESOLVER: "RelayResolver",
    RELAY_LIVE_RESOLVER: "RelayLiveResolver",
    REQUIRED_FIELD: "RequiredField",
    OBJECT_VALUE: "ObjectValue",
    OPERATION: "Operation",
    REQUEST: "Request",
    ROOT_ARGUMENT: "RootArgument",
    SCALAR_FIELD: "ScalarField",
    SCALAR_HANDLE: "ScalarHandle",
    SPLIT_OPERATION: "SplitOperation",
    STREAM: "Stream",
    TYPE_DISCRIMINATOR: "TypeDiscriminator",
    UPDATABLE_QUERY: "UpdatableQuery",
    VARIABLE: "Variable"
};
module.exports = $5e1c8d0443ff7a9c$var$RelayConcreteNode;

});

parcelRegister("8Q6tr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Creates a copy of the provided value, ensuring any nested objects have their
 * keys sorted such that equivalent values would have identical JSON.stringify
 * results.
 */ function $66f833a5f98ccb7b$var$stableCopy(value) {
    if (!value || typeof value !== "object") return value;
    if (Array.isArray(value)) return value.map($66f833a5f98ccb7b$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $66f833a5f98ccb7b$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $66f833a5f98ccb7b$var$stableCopy;

});


parcelRegister("dGCyA", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $9f6d1b37ea106d00$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $9f6d1b37ea106d00$var$config = {
    CURSOR: "cursor",
    EDGES: "edges",
    END_CURSOR: "endCursor",
    HAS_NEXT_PAGE: "hasNextPage",
    HAS_PREV_PAGE: "hasPreviousPage",
    NODE: "node",
    PAGE_INFO_TYPE: "PageInfo",
    PAGE_INFO: "pageInfo",
    START_CURSOR: "startCursor"
};
/**
 * @internal
 *
 * Defines logic relevant to the informal "Connection" GraphQL interface.
 */ var $9f6d1b37ea106d00$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $9f6d1b37ea106d00$var$config = newConfig;
    },
    get: function get() {
        return $9f6d1b37ea106d00$var$config;
    },
    /**
   * Checks whether a call exists strictly to encode which parts of a connection
   * to fetch. Fields that only differ by connection call values should have the
   * same identity.
   */ isConnectionCall: function isConnectionCall(call) {
        return $9f6d1b37ea106d00$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $9f6d1b37ea106d00$var$ConnectionInterface;

});

parcelRegister("8Fbfi", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $9Nafg = parcelRequire("9Nafg");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $64eae03bc3a3aaf1$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = "Warning: " + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $64eae03bc3a3aaf1$var$warning = $9Nafg;
module.exports = $64eae03bc3a3aaf1$var$warning;

});
parcelRegister("9Nafg", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $7210a323e2a92597$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $7210a323e2a92597$var$emptyFunction = function emptyFunction() {};
$7210a323e2a92597$var$emptyFunction.thatReturns = $7210a323e2a92597$var$makeEmptyFunction;
$7210a323e2a92597$var$emptyFunction.thatReturnsFalse = $7210a323e2a92597$var$makeEmptyFunction(false);
$7210a323e2a92597$var$emptyFunction.thatReturnsTrue = $7210a323e2a92597$var$makeEmptyFunction(true);
$7210a323e2a92597$var$emptyFunction.thatReturnsNull = $7210a323e2a92597$var$makeEmptyFunction(null);
$7210a323e2a92597$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$7210a323e2a92597$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $7210a323e2a92597$var$emptyFunction;

});



parcelRegister("ils74", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d5affed47439a513$var$_interopRequireDefault = $1jnue.default;

var $d5affed47439a513$var$_createForOfIteratorHelper2 = $d5affed47439a513$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $7uWVM = parcelRequire("7uWVM");

var $dGCyA = parcelRequire("dGCyA");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $d5affed47439a513$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === "string") store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === "string") store["delete"](id);
            });
        }
    }
};
var $d5affed47439a513$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aaXwj(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === "string") {
                var _iterator = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $7uWVM.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $d5affed47439a513$var$AppendEdgeHandler = {
    update: $d5affed47439a513$var$edgeUpdater($7uWVM.insertEdgeAfter)
};
var $d5affed47439a513$var$PrependEdgeHandler = {
    update: $d5affed47439a513$var$edgeUpdater($7uWVM.insertEdgeBefore)
};
var $d5affed47439a513$var$AppendNodeHandler = {
    update: $d5affed47439a513$var$nodeUpdater($7uWVM.insertEdgeAfter)
};
var $d5affed47439a513$var$PrependNodeHandler = {
    update: $d5affed47439a513$var$nodeUpdater($7uWVM.insertEdgeBefore)
};
function $d5affed47439a513$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aaXwj(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $dGCyA.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord("node");
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $7uWVM.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $aaXwj(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $d5affed47439a513$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $aaXwj(false);
        !(edgeTypeName != null) && $aaXwj(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $dGCyA.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $7uWVM.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $aaXwj(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $d5affed47439a513$var$AppendEdgeHandler,
    DeleteRecordHandler: $d5affed47439a513$var$DeleteRecordHandler,
    PrependEdgeHandler: $d5affed47439a513$var$PrependEdgeHandler,
    AppendNodeHandler: $d5affed47439a513$var$AppendNodeHandler,
    PrependNodeHandler: $d5affed47439a513$var$PrependNodeHandler,
    DeleteEdgeHandler: $d5affed47439a513$var$DeleteEdgeHandler
};

});
parcelRegister("8QL5z", function(module, exports) {

var $72a6v = parcelRequire("72a6v");
function $6717b4f17c8c4903$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $72a6v(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $6717b4f17c8c4903$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5wpCP", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7uWVM = parcelRequire("7uWVM");

var $ils74 = parcelRequire("ils74");

var $aaXwj = parcelRequire("aaXwj");
function $4053d1890bfd378c$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case "connection":
            return $7uWVM;
        case "deleteRecord":
            return $ils74.DeleteRecordHandler;
        case "deleteEdge":
            return $ils74.DeleteEdgeHandler;
        case "appendEdge":
            return $ils74.AppendEdgeHandler;
        case "prependEdge":
            return $ils74.PrependEdgeHandler;
        case "appendNode":
            return $ils74.AppendNodeHandler;
        case "prependNode":
            return $ils74.PrependNodeHandler;
    }
    $aaXwj(false);
}
module.exports = $4053d1890bfd378c$var$RelayDefaultHandlerProvider;

});

parcelRegister("8CB0r", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $646e93f9dde74190$var$getRequest = $aW0zg.getRequest;

var $i7dei = parcelRequire("i7dei");

var $40tQb = parcelRequire("40tQb");
var $646e93f9dde74190$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $f8nQK = parcelRequire("f8nQK");

var $aaXwj = parcelRequire("aaXwj");
/**
 * Higher-level helper function to execute a mutation against a specific
 * environment.
 */ function $646e93f9dde74190$var$applyOptimisticMutation(environment, config) {
    !$i7dei(environment) && $aaXwj(false);
    var mutation = $646e93f9dde74190$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== "mutation") throw new Error("commitMutation: Expected mutation operation");
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $646e93f9dde74190$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $f8nQK.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $646e93f9dde74190$var$applyOptimisticMutation;

});
parcelRegister("aW0zg", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
// The type of a graphql`...` tagged template expression.
/**
 * Runtime function to correspond to the `graphql` tagged template function.
 * All calls to this function should be transformed by the plugin.
 */ function $7f5fc2e5a5fd33cd$var$graphql(strings) {
    $aaXwj(false);
}
function $7f5fc2e5a5fd33cd$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === "function") node = node();
    else if (node["default"]) // Support for languages that work (best) with ES6 modules, such as TypeScript.
    node = node["default"];
    return node;
}
function $7f5fc2e5a5fd33cd$var$isFragment(node) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof fragment === "object" && fragment !== null && fragment.kind === $84X73.FRAGMENT;
}
function $7f5fc2e5a5fd33cd$var$isRequest(node) {
    var request = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof request === "object" && request !== null && request.kind === $84X73.REQUEST;
}
function $7f5fc2e5a5fd33cd$var$isUpdatableQuery(node) {
    var updatableQuery = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof updatableQuery === "object" && updatableQuery !== null && updatableQuery.kind === $84X73.UPDATABLE_QUERY;
}
function $7f5fc2e5a5fd33cd$var$isInlineDataFragment(node) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof fragment === "object" && fragment !== null && fragment.kind === $84X73.INLINE_DATA_FRAGMENT;
}
function $7f5fc2e5a5fd33cd$var$getFragment(taggedNode) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isFragment(fragment) && $aaXwj(false);
    return fragment;
}
function $7f5fc2e5a5fd33cd$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $7f5fc2e5a5fd33cd$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== "object" || connection === null || typeof connection !== "object") return null;
    return fragment;
}
function $7f5fc2e5a5fd33cd$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $7f5fc2e5a5fd33cd$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== "object") return null;
    return fragment;
}
function $7f5fc2e5a5fd33cd$var$getRequest(taggedNode) {
    var request = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isRequest(request) && $aaXwj(false);
    return request;
}
function $7f5fc2e5a5fd33cd$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isUpdatableQuery(updatableQuery) && $aaXwj(false);
    return updatableQuery;
}
function $7f5fc2e5a5fd33cd$var$getInlineDataFragment(taggedNode) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isInlineDataFragment(fragment) && $aaXwj(false);
    return fragment;
}
module.exports = {
    getFragment: $7f5fc2e5a5fd33cd$var$getFragment,
    getNode: $7f5fc2e5a5fd33cd$var$getNode,
    getPaginationFragment: $7f5fc2e5a5fd33cd$var$getPaginationFragment,
    getRefetchableFragment: $7f5fc2e5a5fd33cd$var$getRefetchableFragment,
    getRequest: $7f5fc2e5a5fd33cd$var$getRequest,
    getUpdatableQuery: $7f5fc2e5a5fd33cd$var$getUpdatableQuery,
    getInlineDataFragment: $7f5fc2e5a5fd33cd$var$getInlineDataFragment,
    graphql: $7f5fc2e5a5fd33cd$var$graphql,
    isFragment: $7f5fc2e5a5fd33cd$var$isFragment,
    isRequest: $7f5fc2e5a5fd33cd$var$isRequest,
    isUpdatableQuery: $7f5fc2e5a5fd33cd$var$isUpdatableQuery,
    isInlineDataFragment: $7f5fc2e5a5fd33cd$var$isInlineDataFragment
};

});

parcelRegister("i7dei", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Determine if a given value is an object that implements the `Environment`
 * interface defined in `RelayStoreTypes`.
 *
 * Use a sigil for detection to avoid a realm-specific instanceof check, and to
 * aid in module tree-shaking to avoid requiring all of RelayRuntime just to
 * detect its environment.
 */ function $d3032490695fa8db$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment["@@RelayModernEnvironment"]);
}
module.exports = $d3032490695fa8db$var$isRelayModernEnvironment;

});

parcelRegister("40tQb", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("7sl3K");

var $8tEVh = parcelRequire("8tEVh");

var $fkd0X = parcelRequire("fkd0X");
var $2eae4f3dd2b213dd$var$getOperationVariables = $fkd0X.getOperationVariables;

var $idJ2w = parcelRequire("idJ2w");
var $2eae4f3dd2b213dd$var$createNormalizationSelector = $idJ2w.createNormalizationSelector, $2eae4f3dd2b213dd$var$createReaderSelector = $idJ2w.createReaderSelector;

var $5DrBw = parcelRequire("5DrBw");
var $2eae4f3dd2b213dd$var$ROOT_ID = $5DrBw.ROOT_ID;
/**
 * Creates an instance of the `OperationDescriptor` type defined in
 * `RelayStoreTypes` given an operation and some variables. The input variables
 * are filtered to exclude variables that do not match defined arguments on the
 * operation, and default values are populated for null values.
 */ function $2eae4f3dd2b213dd$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $2eae4f3dd2b213dd$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $2eae4f3dd2b213dd$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $2eae4f3dd2b213dd$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $2eae4f3dd2b213dd$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $2eae4f3dd2b213dd$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $2eae4f3dd2b213dd$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $8tEVh(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $2eae4f3dd2b213dd$var$createOperationDescriptor,
    createRequestDescriptor: $2eae4f3dd2b213dd$var$createRequestDescriptor
};

});
parcelRegister("7sl3K", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Recursively "deep" freezes the supplied object.
 *
 * For convenience, and for consistency with the behavior of `Object.freeze`,
 * returns the now-frozen original object.
 */ function $56db7beab1ad986a$var$deepFreeze(object) {
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === "object" && !Object.isFrozen(property)) $56db7beab1ad986a$var$deepFreeze(property);
    });
    return object;
}
module.exports = $56db7beab1ad986a$var$deepFreeze;

});

parcelRegister("8tEVh", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $8Q6tr = parcelRequire("8Q6tr");

var $aaXwj = parcelRequire("aaXwj");
/**
 * Returns a stable identifier for the given pair of `RequestParameters` +
 * variables.
 */ function $62c0c69921390dde$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $aaXwj(false);
    return requestID + JSON.stringify($8Q6tr(variables));
}
module.exports = $62c0c69921390dde$var$getRequestIdentifier;

});

parcelRegister("fkd0X", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b282d1b1083e0ac3$var$_interopRequireDefault = $1jnue.default;

var $b282d1b1083e0ac3$var$_objectSpread2 = $b282d1b1083e0ac3$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5DrBw = parcelRequire("5DrBw");
var $b282d1b1083e0ac3$var$getArgumentValues = $5DrBw.getArgumentValues;

var $aaXwj = parcelRequire("aaXwj");
/**
 * Determines the variables that are in scope for a fragment given the variables
 * in scope at the root query as well as any arguments applied at the fragment
 * spread via `@arguments`.
 *
 * Note that this is analagous to determining function arguments given a function call.
 */ function $b282d1b1083e0ac3$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    // TODO: Support for legacy ReaderInlineDataFragmentSpread nodes.
    // Remove this once all we've updated the ReaderInlineDataFragmentSpread
    // type to indicate that all compiled artifacts have been updated.
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $b282d1b1083e0ac3$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case "LocalArgument":
                variables[definition.name] = definition.defaultValue;
                break;
            case "RootArgument":
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    /*
           * Global variables passed as values of @arguments are not required to
           * be declared unless they are used by the callee fragment or a
           * descendant. In this case, the root variable may not be defined when
           * resolving the callee's variables. The value is explicitly set to
           * undefined to conform to the check in
           * RelayStoreUtils.getStableVariableValue() that variable keys are all
           * present.
           */ variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $aaXwj(false);
        }
    });
    return variables || argumentVariables;
}
/**
 * Determines the variables that are in scope for a given operation given values
 * for some/all of its arguments.
 * - extraneous input variables are filtered from the output
 * - missing variables are set to default values (if given in the
 * operation's definition).
 * - variables with provider modules are added
 */ function $b282d1b1083e0ac3$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $b282d1b1083e0ac3$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $b282d1b1083e0ac3$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $b282d1b1083e0ac3$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $b282d1b1083e0ac3$var$getLocalVariables,
    getFragmentVariables: $b282d1b1083e0ac3$var$getFragmentVariables,
    getOperationVariables: $b282d1b1083e0ac3$var$getOperationVariables
};

});
parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("idJ2w", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $fkd0X = parcelRequire("fkd0X");
var $d43c60d633c5fc6f$var$getFragmentVariables = $fkd0X.getFragmentVariables;

var $5DrBw = parcelRequire("5DrBw");
var $d43c60d633c5fc6f$var$CLIENT_EDGE_TRAVERSAL_PATH = $5DrBw.CLIENT_EDGE_TRAVERSAL_PATH, $d43c60d633c5fc6f$var$FRAGMENT_OWNER_KEY = $5DrBw.FRAGMENT_OWNER_KEY, $d43c60d633c5fc6f$var$FRAGMENTS_KEY = $5DrBw.FRAGMENTS_KEY, $d43c60d633c5fc6f$var$ID_KEY = $5DrBw.ID_KEY, $d43c60d633c5fc6f$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $5DrBw.IS_WITHIN_UNMATCHED_TYPE_REFINEMENT;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * @public
 *
 * Given the result `item` from a parent that fetched `fragment`, creates a
 * selector that can be used to read the results of that fragment for that item.
 *
 * Example:
 *
 * Given two fragments as follows:
 *
 * ```
 * fragment Parent on User {
 *   id
 *   ...Child
 * }
 * fragment Child on User {
 *   name
 * }
 * ```
 *
 * And given some object `parent` that is the results of `Parent` for id "4",
 * the results of `Child` can be accessed by first getting a selector and then
 * using that selector to `lookup()` the results against the environment:
 *
 * ```
 * const childSelector = getSingularSelector(queryVariables, Child, parent);
 * const childData = environment.lookup(childSelector).data;
 * ```
 */ function $d43c60d633c5fc6f$var$getSingularSelector(fragment, item) {
    !(typeof item === "object" && item !== null && !Array.isArray(item)) && $aaXwj(false);
    var dataID = item[$d43c60d633c5fc6f$var$ID_KEY];
    var fragments = item[$d43c60d633c5fc6f$var$FRAGMENTS_KEY];
    var mixedOwner = item[$d43c60d633c5fc6f$var$FRAGMENT_OWNER_KEY];
    var isWithinUnmatchedTypeRefinement = item[$d43c60d633c5fc6f$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
    var mixedClientEdgeTraversalPath = item[$d43c60d633c5fc6f$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === "string" && typeof fragments === "object" && fragments !== null && typeof fragments[fragment.name] === "object" && fragments[fragment.name] !== null && typeof mixedOwner === "object" && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $d43c60d633c5fc6f$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        return $d43c60d633c5fc6f$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
/**
 * @public
 *
 * Given the result `items` from a parent that fetched `fragment`, creates a
 * selector that can be used to read the results of that fragment on those
 * items. This is similar to `getSingularSelector` but for "plural" fragments that
 * expect an array of results and therefore return an array of selectors.
 */ function $d43c60d633c5fc6f$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $d43c60d633c5fc6f$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: "PluralReaderSelector",
        selectors: selectors
    };
}
function $d43c60d633c5fc6f$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getSingularSelector(fragment, item);
    }
}
/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts the selectors for those fragments from the results.
 *
 * The canonical use-case for this function is ReactRelayFragmentContainer, which
 * uses this function to convert (props, fragments) into selectors so that it
 * can read the results to pass to the inner component.
 */ function $d43c60d633c5fc6f$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $d43c60d633c5fc6f$var$getSelector(fragment, item);
    }
    return selectors;
}
/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts a mapping of keys -> id(s) of the results.
 *
 * Similar to `getSelectorsFromObject()`, this function can be useful in
 * determining the "identity" of the props passed to a component.
 */ function $d43c60d633c5fc6f$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $d43c60d633c5fc6f$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $d43c60d633c5fc6f$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getDataID(fragment, item);
    }
}
/**
 * @internal
 */ function $d43c60d633c5fc6f$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $d43c60d633c5fc6f$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
/**
 * @internal
 */ function $d43c60d633c5fc6f$var$getDataID(fragment, item) {
    !(typeof item === "object" && item !== null && !Array.isArray(item)) && $aaXwj(false);
    var dataID = item[$d43c60d633c5fc6f$var$ID_KEY];
    if (typeof dataID === "string") return dataID;
    return null;
}
/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts the merged variables that would be in scope for those
 * fragments/results.
 *
 * This can be useful in determing what varaibles were used to fetch the data
 * for a Relay container, for example.
 */ function $d43c60d633c5fc6f$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $d43c60d633c5fc6f$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $d43c60d633c5fc6f$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $d43c60d633c5fc6f$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $d43c60d633c5fc6f$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $d43c60d633c5fc6f$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $d43c60d633c5fc6f$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $d43c60d633c5fc6f$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.owner === thatSelector.owner && thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $ewhZB(thisSelector.variables, thatSelector.variables);
}
/**
 * @public
 *
 * Determine if two selectors are equal (represent the same selection). Note
 * that this function returns `false` when the two queries/fragments are
 * different objects, even if they select the same fields.
 */ function $d43c60d633c5fc6f$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === "SingularReaderSelector" && b.kind === "SingularReaderSelector") return $d43c60d633c5fc6f$var$areEqualSingularSelectors(a, b);
    else if (a.kind === "PluralReaderSelector" && b.kind === "PluralReaderSelector") return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $d43c60d633c5fc6f$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $d43c60d633c5fc6f$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: "SingularReaderSelector",
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $d43c60d633c5fc6f$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $d43c60d633c5fc6f$var$areEqualSelectors,
    createReaderSelector: $d43c60d633c5fc6f$var$createReaderSelector,
    createNormalizationSelector: $d43c60d633c5fc6f$var$createNormalizationSelector,
    getDataIDsFromFragment: $d43c60d633c5fc6f$var$getDataIDsFromFragment,
    getDataIDsFromObject: $d43c60d633c5fc6f$var$getDataIDsFromObject,
    getSingularSelector: $d43c60d633c5fc6f$var$getSingularSelector,
    getPluralSelector: $d43c60d633c5fc6f$var$getPluralSelector,
    getSelector: $d43c60d633c5fc6f$var$getSelector,
    getSelectorsFromObject: $d43c60d633c5fc6f$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $d43c60d633c5fc6f$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $d43c60d633c5fc6f$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $d43c60d633c5fc6f$var$getVariablesFromFragment,
    getVariablesFromObject: $d43c60d633c5fc6f$var$getVariablesFromObject
};

});
parcelRegister("ewhZB", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $a92202c86788587e$var$aStackPool = [];
var $a92202c86788587e$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $a92202c86788587e$var$areEqual(a, b) {
    var aStack = $a92202c86788587e$var$aStackPool.length ? $a92202c86788587e$var$aStackPool.pop() : [];
    var bStack = $a92202c86788587e$var$bStackPool.length ? $a92202c86788587e$var$bStackPool.pop() : [];
    var result = $a92202c86788587e$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $a92202c86788587e$var$aStackPool.push(aStack);
    $a92202c86788587e$var$bStackPool.push(bStack);
    return result;
}
function $a92202c86788587e$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != "object" || typeof b != "object") return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case "[object String]":
            return a == String(b);
        case "[object Number]":
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case "[object Date]":
        case "[object Boolean]":
            return +a == +b;
        case "[object RegExp]":
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === "[object Array]") {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$a92202c86788587e$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty("valueOf") && b.hasOwnProperty("valueOf")) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$a92202c86788587e$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $a92202c86788587e$var$areEqual;

});



parcelRegister("f8nQK", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b04a1a720cd8549f$var$_interopRequireDefault = $1jnue.default;

var $b04a1a720cd8549f$var$_createForOfIteratorHelper2 = $b04a1a720cd8549f$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $7uWVM = parcelRequire("7uWVM");
parcelRequire("8Fbfi");
var $b04a1a720cd8549f$var$MutationTypes = Object.freeze({
    RANGE_ADD: "RANGE_ADD",
    RANGE_DELETE: "RANGE_DELETE",
    NODE_DELETE: "NODE_DELETE"
});
var $b04a1a720cd8549f$var$RangeOperations = Object.freeze({
    APPEND: "append",
    PREPEND: "prepend"
});
function $b04a1a720cd8549f$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case "NODE_DELETE":
                var nodeDeleteResult = $b04a1a720cd8549f$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case "RANGE_ADD":
                var rangeAddResult = $b04a1a720cd8549f$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case "RANGE_DELETE":
                var rangeDeleteResult = $b04a1a720cd8549f$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $b04a1a720cd8549f$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $b04a1a720cd8549f$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === "string") store["delete"](id);
        });
    };
}
function $b04a1a720cd8549f$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $b04a1a720cd8549f$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $b04a1a720cd8549f$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $7uWVM.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $7uWVM.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case "append":
                        $7uWVM.insertEdgeAfter(connection, clientEdge);
                        break;
                    case "prepend":
                        $7uWVM.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $b04a1a720cd8549f$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $b04a1a720cd8549f$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        // the type of data should come from a type parameter associated with ConcreteRequest,
        // but ConcreteRequest does not contain a type parameter. Hence, we use a FlowFixMe.
        // $FlowFixMe[incompatible-use] see above
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $b04a1a720cd8549f$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === "object") deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === "object" && typeof idObject.id === "string") deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === "string") deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === "string" && typeof deletedIDField === "object") {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === "string") deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === "string") deleteIDs.push(id);
            });
        }
        $b04a1a720cd8549f$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $b04a1a720cd8549f$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    // Should never enter loop except edge cases
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $b04a1a720cd8549f$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $7uWVM.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $7uWVM.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $b04a1a720cd8549f$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === "LinkedField") return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $b04a1a720cd8549f$var$MutationTypes,
    RangeOperations: $b04a1a720cd8549f$var$RangeOperations,
    convert: $b04a1a720cd8549f$var$convert
};

});


parcelRegister("aq9ZM", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $796415fa72badc05$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $796415fa72badc05$var$commitLocalUpdate;

});

parcelRegister("io2Di", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d62c82af7e9aad49$var$_interopRequireDefault = $1jnue.default;

var $d62c82af7e9aad49$var$_toConsumableArray2 = $d62c82af7e9aad49$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $aW0zg = parcelRequire("aW0zg");
var $d62c82af7e9aad49$var$getRequest = $aW0zg.getRequest;

var $i2E13 = parcelRequire("i2E13");
var $d62c82af7e9aad49$var$generateUniqueClientID = $i2E13.generateUniqueClientID;

var $i7dei = parcelRequire("i7dei");

var $40tQb = parcelRequire("40tQb");
var $d62c82af7e9aad49$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $f8nQK = parcelRequire("f8nQK");
parcelRequire("eJlOZ");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * Higher-level helper function to execute a mutation against a specific
 * environment.
 */ function $d62c82af7e9aad49$var$commitMutation(environment, config) {
    !$i7dei(environment) && $aaXwj(false);
    var mutation = $d62c82af7e9aad49$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== "mutation") throw new Error("commitMutation: Expected mutation operation");
    if (mutation.kind !== "Request") throw new Error("commitMutation: Expected mutation to be of type request");
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $d62c82af7e9aad49$var$createOperationDescriptor(mutation, variables, cacheConfig, $d62c82af7e9aad49$var$generateUniqueClientID());
    // TODO: remove this check after we fix flow.
    if (typeof optimisticResponse === "function") optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $f8nQK.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $d62c82af7e9aad49$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $d62c82af7e9aad49$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $d62c82af7e9aad49$var$commitMutation;

});
parcelRegister("eJlOZ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $ab9631f3b88eb2a3$var$_interopRequireDefault = $1jnue.default;

var $ab9631f3b88eb2a3$var$_objectSpread2 = $ab9631f3b88eb2a3$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $84X73 = parcelRequire("84X73");
var $ab9631f3b88eb2a3$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $ab9631f3b88eb2a3$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $ab9631f3b88eb2a3$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $ab9631f3b88eb2a3$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $ab9631f3b88eb2a3$var$CONDITION = $84X73.CONDITION, $ab9631f3b88eb2a3$var$DEFER = $84X73.DEFER, $ab9631f3b88eb2a3$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $ab9631f3b88eb2a3$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $ab9631f3b88eb2a3$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $ab9631f3b88eb2a3$var$LINKED_FIELD = $84X73.LINKED_FIELD, $ab9631f3b88eb2a3$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $ab9631f3b88eb2a3$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $ab9631f3b88eb2a3$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $ab9631f3b88eb2a3$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $ab9631f3b88eb2a3$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $ab9631f3b88eb2a3$var$STREAM = $84X73.STREAM, $ab9631f3b88eb2a3$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR;
parcelRequire("8Fbfi");
// $FlowFixMe[method-unbinding] added when improving typing for this parameters
var $ab9631f3b88eb2a3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ab9631f3b88eb2a3$var$validateMutation = function validateMutation() {};
var $ab9631f3b88eb2a3$var$addFieldToDiff, $ab9631f3b88eb2a3$var$validateSelections, $ab9631f3b88eb2a3$var$validateSelection, $ab9631f3b88eb2a3$var$validateModuleImport, $ab9631f3b88eb2a3$var$validateAbstractKey, $ab9631f3b88eb2a3$var$validateField, $ab9631f3b88eb2a3$var$validateOptimisticResponse;
module.exports = $ab9631f3b88eb2a3$var$validateMutation;

});


parcelRegister("cuefK", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $hpvi1 = parcelRequire("hpvi1");

var $5naHI = parcelRequire("5naHI");
var $917357bfb6bdf8e6$var$convertFetch = $5naHI.convertFetch;

var $aaXwj = parcelRequire("aaXwj");
/**
 * Creates an implementation of the `Network` interface defined in
 * `RelayNetworkTypes` given `fetch` and `subscribe` functions.
 */ function $917357bfb6bdf8e6$var$create(fetchFn, subscribe) {
    // Convert to functions that returns RelayObservable.
    var observeFetch = $917357bfb6bdf8e6$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $hpvi1(variables, request.providedVariables);
        if (request.operationKind === "subscription") {
            !subscribe && $aaXwj(false);
            !!uploadables && $aaXwj(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $aaXwj(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $917357bfb6bdf8e6$var$create
};

});
parcelRegister("hpvi1", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("ewhZB");
parcelRequire("8Fbfi");
var $cacd0af5e6b60d25$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
var $cacd0af5e6b60d25$var$debugCache = $cacd0af5e6b60d25$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $cacd0af5e6b60d25$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            // people like to ignore these warnings, so use the cache to
            // enforce that we only compute the value the first time
            if (!$cacd0af5e6b60d25$var$debugCache.has(providerFunction)) {
                $cacd0af5e6b60d25$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $cacd0af5e6b60d25$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$cacd0af5e6b60d25$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $cacd0af5e6b60d25$var$withProvidedVariables;

});

parcelRegister("5naHI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $hIn3L = parcelRequire("hIn3L");
/**
 * Converts a FetchFunction into an ExecuteFunction for use by RelayNetwork.
 */ function $3e97675b302b9d4f$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        // Note: We allow FetchFunction to directly return Error to indicate
        // a failure to fetch. To avoid handling this special case throughout the
        // Relay codebase, it is explicitly handled here.
        if (result instanceof Error) return $hIn3L.create(function(sink) {
            return sink.error(result);
        });
        return $hIn3L.from(result);
    };
}
module.exports = {
    convertFetch: $3e97675b302b9d4f$var$convertFetch
};

});
parcelRegister("hIn3L", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1Q5mH = parcelRequire("1Q5mH");
/**
 * A Subscription object is returned from .subscribe(), which can be
 * unsubscribed or checked to see if the resulting subscription has closed.
 */ var $ce586ee2e2d76b42$var$hostReportError = $ce586ee2e2d76b42$var$swallowError;
/**
 * Limited implementation of ESObservable, providing the limited set of behavior
 * Relay networking requires.
 *
 * Observables retain the benefit of callbacks which can be called
 * synchronously, avoiding any UI jitter, while providing a compositional API,
 * which simplifies logic and prevents mishandling of errors compared to
 * the direct use of callback functions.
 *
 * ESObservable: https://github.com/tc39/proposal-observable
 */ var $ce586ee2e2d76b42$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    /**
   * When an emitted error event is not handled by an Observer, it is reported
   * to the host environment (what the ESObservable spec refers to as
   * "HostReportErrors()").
   *
   * The default implementation in development rethrows thrown errors, and
   * logs emitted error events to the console, while in production does nothing
   * (swallowing unhandled errors).
   *
   * Called during application initialization, this method allows
   * application-specific handling of unhandled errors. Allowing, for example,
   * integration with error logging or developer tools.
   *
   * A second parameter `isUncaughtThrownError` is true when the unhandled error
   * was thrown within an Observer handler, and false when the unhandled error
   * was an unhandled emitted event.
   *
   *  - Uncaught thrown errors typically represent avoidable errors thrown from
   *    application code, which should be handled with a try/catch block, and
   *    usually have useful stack traces.
   *
   *  - Unhandled emitted event errors typically represent unavoidable events in
   *    application flow such as network failure, and may not have useful
   *    stack traces.
   */ RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $ce586ee2e2d76b42$var$hostReportError = callback;
    } /**
   * Accepts various kinds of data sources, and always returns a RelayObservable
   * useful for accepting the result of a user-provided FetchFunction.
   */ ;
    RelayObservable.from = function from(obj) {
        return $ce586ee2e2d76b42$var$isObservable(obj) ? $ce586ee2e2d76b42$var$fromObservable(obj) : $1Q5mH(obj) ? $ce586ee2e2d76b42$var$fromPromise(obj) : $ce586ee2e2d76b42$var$fromValue(obj);
    } /**
   * Similar to promise.catch(), observable.catch() handles error events, and
   * provides an alternative observable to use in it's place.
   *
   * If the catch handler throws a new error, it will appear as an error event
   * on the resulting Observable.
   */ ;
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    } /**
   * Returns a new Observable which first yields values from this Observable,
   * then yields values from the next Observable. This is useful for chaining
   * together Observables of finite length.
   */ ;
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    } /**
   * Returns a new Observable which returns the same values as this one, but
   * modified so that the provided Observer is called to perform a side-effects
   * for all events emitted by the source.
   *
   * Any errors that are thrown in the side-effect Observer are unhandled, and
   * do not affect the source Observable or its Observer.
   *
   * This is useful for when debugging your Observables or performing other
   * side-effects such as logging or performance monitoring.
   */ ;
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $ce586ee2e2d76b42$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both("start"),
                next: both("next"),
                error: both("error"),
                complete: both("complete"),
                unsubscribe: both("unsubscribe")
            });
        });
    } /**
   * Returns a new Observable which returns the same values as this one, but
   * modified so that the finally callback is performed after completion,
   * whether normal or due to error or unsubscription.
   *
   * This is useful for cleanup such as resource finalization.
   */ ;
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    } /**
   * Returns a new Observable which is identical to this one, unless this
   * Observable completes before yielding any values, in which case the new
   * Observable will yield the values from the alternate Observable.
   *
   * If this Observable does yield values, the alternate is never subscribed to.
   *
   * This is useful for scenarios where values may come from multiple sources
   * which should be tried in order, i.e. from a cache before a network.
   */ ;
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current.unsubscribe();
            };
        });
    } /**
   * Observable's primary API: returns an unsubscribable Subscription to the
   * source of this Observable.
   *
   * Note: A sink may be passed directly to .subscribe() as its observer,
   * allowing for easily composing Observables.
   */ ;
    _proto.subscribe = function subscribe(observer) {
        return $ce586ee2e2d76b42$var$_subscribe(this._source, observer);
    } /**
   * Returns a new Observerable where each value has been transformed by
   * the mapping function.
   */ ;
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    } /**
   * Returns a new Observable where each value is replaced with a new Observable
   * by the mapping function, the results of which returned as a single
   * merged Observable.
   */ ;
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    } /**
   * Returns a new Observable which first mirrors this Observable, then when it
   * completes, waits for `pollInterval` milliseconds before re-subscribing to
   * this Observable again, looping in this manner until unsubscribed.
   *
   * The returned Observable never completes.
   */ ;
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    } /**
   * Returns a Promise which resolves when this Observable yields a first value
   * or when it completes with no value.
   *
   * NOTE: The source Observable is *NOT* canceled when the returned Promise
   * resolves. The Observable is always run to completion.
   */ ;
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}(); // Use declarations to teach Flow how to check isObservable.
function $ce586ee2e2d76b42$var$isObservable(obj) {
    return typeof obj === "object" && obj !== null && typeof obj.subscribe === "function";
}
function $ce586ee2e2d76b42$var$fromObservable(obj) {
    return obj instanceof $ce586ee2e2d76b42$var$RelayObservable ? obj : $ce586ee2e2d76b42$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $ce586ee2e2d76b42$var$fromPromise(promise) {
    return $ce586ee2e2d76b42$var$RelayObservable.create(function(sink) {
        // Since sink methods do not throw, the resulting Promise can be ignored.
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $ce586ee2e2d76b42$var$fromValue(value) {
    return $ce586ee2e2d76b42$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $ce586ee2e2d76b42$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    // Ideally we would simply describe a `get closed()` method on the Sink and
    // Subscription objects below, however not all flow environments we expect
    // Relay to be used within will support property getters, and many minifier
    // tools still do not support ES5 syntax. Instead, we can use defineProperty.
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, "closed", {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $ce586ee2e2d76b42$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    // Create a Subscription.
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                // Tell Observer that unsubscribe was called.
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $ce586ee2e2d76b42$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    // Tell Observer that observation is about to begin.
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $ce586ee2e2d76b42$var$hostReportError(error, true);
    }
    // If closed already, don't bother creating a Sink.
    if (closed) return subscription;
    // Create a Sink respecting subscription state and cleanup.
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $ce586ee2e2d76b42$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $ce586ee2e2d76b42$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $ce586ee2e2d76b42$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $ce586ee2e2d76b42$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    // If anything goes wrong during observing the source, handle the error.
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    // If closed before the source function existed, cleanup now.
    if (closed) doCleanup();
    return subscription;
}
function $ce586ee2e2d76b42$var$swallowError(_error, _isUncaughtThrownError) {
// do nothing.
}
module.exports = $ce586ee2e2d76b42$var$RelayObservable;

});
parcelRegister("1Q5mH", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $156ecf273d8def1c$var$isPromise(p) {
    return !!p && typeof p.then === "function";
}
module.exports = $156ecf273d8def1c$var$isPromise;

});




parcelRegister("l6QXA", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $f5e33d43325eef4a$var$_interopRequireDefault = $1jnue.default;

var $f5e33d43325eef4a$var$_objectSpread2 = $f5e33d43325eef4a$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $8Q6tr = parcelRequire("8Q6tr");

var $aaXwj = parcelRequire("aaXwj");
/**
 * A cache for storing query responses, featuring:
 * - `get` with TTL
 * - cache size limiting, with least-recently *updated* entries purged first
 */ var $f5e33d43325eef4a$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $aaXwj(false);
        !(ttl > 0) && $aaXwj(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $f5e33d43325eef4a$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$f5e33d43325eef4a$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $f5e33d43325eef4a$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey); // deletion resets key ordering
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        // Purge least-recently updated key when max size reached
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $f5e33d43325eef4a$var$getCacheKey(queryID, variables) {
    return JSON.stringify($8Q6tr({
        queryID: queryID,
        variables: variables
    }));
}
/**
 * Determine whether a response fetched at `fetchTime` is still valid given
 * some `ttl`.
 */ function $f5e33d43325eef4a$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $f5e33d43325eef4a$var$RelayQueryResponseCache;

});

parcelRegister("lmXME", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $f8ea06d4c222f58c$var$_interopRequireDefault = $1jnue.default;

var $f8ea06d4c222f58c$var$_objectSpread2 = $f8ea06d4c222f58c$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $hIn3L = parcelRequire("hIn3L");

var $40tQb = parcelRequire("40tQb");
var $f8ea06d4c222f58c$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $47Vax = parcelRequire("47Vax");

var $1PcQ6 = parcelRequire("1PcQ6");

var $aW0zg = parcelRequire("aW0zg");
var $f8ea06d4c222f58c$var$getRequest = $aW0zg.getRequest;

var $aaXwj = parcelRequire("aaXwj");
/**
 * Fetches the given query and variables on the provided environment,
 * and de-dupes identical in-flight requests.
 *
 * Observing a request:
 * ====================
 * fetchQuery returns an Observable which you can call .subscribe()
 * on. Subscribe optionally takes an Observer, which you can provide to
 * observe network events:
 *
 * ```
 * fetchQuery(environment, query, variables).subscribe({
 *   // Called when network requests starts
 *   start: (subsctiption) => {},
 *
 *   // Called after a payload is received and written to the local store
 *   next: (payload) => {},
 *
 *   // Called when network requests errors
 *   error: (error) => {},
 *
 *   // Called when network requests fully completes
 *   complete: () => {},
 *
 *   // Called when network request is unsubscribed
 *   unsubscribe: (subscription) => {},
 * });
 * ```
 *
 * Request Promise:
 * ================
 * The obervable can be converted to a Promise with .toPromise(), which will
 * resolve to a snapshot of the query data when the first response is received
 * from the server.
 *
 * ```
 * fetchQuery(environment, query, variables).toPromise().then((data) => {
 *   // ...
 * });
 * ```
 *
 * In-flight request de-duping:
 * ============================
 * By default, calling fetchQuery multiple times with the same
 * environment, query and variables will not initiate a new request if a request
 * for those same parameters is already in flight.
 *
 * A request is marked in-flight from the moment it starts until the moment it
 * fully completes, regardless of error or successful completion.
 *
 * NOTE: If the request completes _synchronously_, calling fetchQuery
 * a second time with the same arguments in the same tick will _NOT_ de-dupe
 * the request given that it will no longer be in-flight.
 *
 *
 * Data Retention:
 * ===============
 * This function will NOT retain query data, meaning that it is not guaranteed
 * that the fetched data will remain in the Relay store after the request has
 * completed.
 * If you need to retain the query data outside of the network request,
 * you need to use `environment.retain()`.
 *
 *
 * Cancelling requests:
 * ====================
 * If the disposable returned by subscribe is called while the
 * request is in-flight, the request will be cancelled.
 *
 * ```
 * const disposable = fetchQuery(...).subscribe(...);
 *
 * // This will cancel the request if it is in-flight.
 * disposable.dispose();
 * ```
 * NOTE: When using .toPromise(), the request cannot be cancelled.
 */ function $f8ea06d4c222f58c$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $f8ea06d4c222f58c$var$getRequest(query);
    !(queryNode.params.operationKind === "query") && $aaXwj(false);
    var networkCacheConfig = (0, $f8ea06d4c222f58c$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $f8ea06d4c222f58c$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : "network-only";
    function readData(snapshot) {
        $47Vax(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors);
        /* $FlowFixMe[incompatible-return] we assume readData returns the right
     * data just having written it from network or checked availability. */ return snapshot.data;
    }
    switch(fetchPolicy){
        case "network-only":
            return $f8ea06d4c222f58c$var$getNetworkObservable(environment, operation).map(readData);
        case "store-or-network":
            if (environment.check(operation).status === "available") return $hIn3L.from(environment.lookup(operation.fragment)).map(readData);
            return $f8ea06d4c222f58c$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error("fetchQuery: Invalid fetchPolicy " + fetchPolicy);
    }
}
function $f8ea06d4c222f58c$var$getNetworkObservable(environment, operation) {
    return $1PcQ6.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $f8ea06d4c222f58c$var$fetchQuery;

});
parcelRegister("47Vax", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $301429753d16228d$var$_interopRequireDefault = $1jnue.default;

var $301429753d16228d$var$_createForOfIteratorHelper2 = $301429753d16228d$var$_interopRequireDefault((parcelRequire("8QL5z")));
function $301429753d16228d$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors) {
    var _iterator = (0, $301429753d16228d$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.requiredFieldLogger({
                kind: "relay_resolver.error",
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case "THROW":
            var _missingRequiredField = missingRequiredFields.field, path = _missingRequiredField.path, owner = _missingRequiredField.owner;
            // This gives the consumer the chance to throw their own error if they so wish.
            environment.requiredFieldLogger({
                kind: "missing_field.throw",
                owner: owner,
                fieldPath: path
            });
            throw new Error("Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'."));
        case "LOG":
            missingRequiredFields.fields.forEach(function(_ref) {
                var path = _ref.path, owner = _ref.owner;
                environment.requiredFieldLogger({
                    kind: "missing_field.log",
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = $301429753d16228d$var$handlePotentialSnapshotErrors;

});

parcelRegister("1PcQ6", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $hIn3L = parcelRequire("hIn3L");

var $dsOUI = parcelRequire("dsOUI");

var $aLywI = parcelRequire("aLywI");

var $aaXwj = parcelRequire("aaXwj");
var $1544837bc9a02b7e$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
var $1544837bc9a02b7e$var$requestCachesByEnvironment = $1544837bc9a02b7e$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
/**
 * Fetches the given query and variables on the provided environment,
 * and de-dupes identical in-flight requests.
 *
 * Observing a request:
 * ====================
 * fetchQuery returns an Observable which you can call .subscribe()
 * on. subscribe() takes an Observer, which you can provide to
 * observe network events:
 *
 * ```
 * fetchQuery(environment, query, variables).subscribe({
 *   // Called when network requests starts
 *   start: (subscription) => {},
 *
 *   // Called after a payload is received and written to the local store
 *   next: (payload) => {},
 *
 *   // Called when network requests errors
 *   error: (error) => {},
 *
 *   // Called when network requests fully completes
 *   complete: () => {},
 *
 *   // Called when network request is unsubscribed
 *   unsubscribe: (subscription) => {},
 * });
 * ```
 *
 * In-flight request de-duping:
 * ============================
 * By default, calling fetchQuery multiple times with the same
 * environment, query and variables will not initiate a new request if a request
 * for those same parameters is already in flight.
 *
 * A request is marked in-flight from the moment it starts until the moment it
 * fully completes, regardless of error or successful completion.
 *
 * NOTE: If the request completes _synchronously_, calling fetchQuery
 * a second time with the same arguments in the same tick will _NOT_ de-dupe
 * the request given that it will no longer be in-flight.
 *
 *
 * Data Retention:
 * ===============
 * This function will not retain any query data outside the scope of the
 * request, which means it is not guaranteed that it won't be garbage
 * collected after the request completes.
 * If you need to retain data, you can do so manually with environment.retain().
 *
 * Cancelling requests:
 * ====================
 * If the subscription returned by subscribe is called while the
 * request is in-flight, the request will be cancelled.
 *
 * ```
 * const subscription = fetchQuery(...).subscribe(...);
 *
 * // This will cancel the request if it is in-flight.
 * subscription.unsubscribe();
 * ```
 */ function $1544837bc9a02b7e$var$fetchQuery(environment, operation) {
    return $1544837bc9a02b7e$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
/**
 * Low-level implementation details of `fetchQuery`.
 *
 * `fetchQueryDeduped` can also be used to share a single cache for
 * requests that aren't using `fetchQuery` directly (e.g. because they don't
 * have an `OperationDescriptor` when they are called).
 */ function $1544837bc9a02b7e$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $hIn3L.create(function(sink) {
        var requestCache = $1544837bc9a02b7e$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $aLywI(),
                    subjectForInFlightStatus: new $aLywI(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $aaXwj(false);
        return $1544837bc9a02b7e$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $hIn3L.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $hIn3L.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
/**
 * If a request is active for the given query, variables and environment,
 * this function will return a Promise that will resolve when that request
 * stops being active (receives a final payload), and the data has been saved
 * to the store.
 * If no request is active, null will be returned
 */ function $1544837bc9a02b7e$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $1544837bc9a02b7e$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    if ($dsOUI.USE_REACT_CACHE) {
        var existing = cachedRequest.promise;
        if (existing) return existing;
    }
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $1544837bc9a02b7e$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                /*
         * The underlying `RelayReplaySubject` will synchronously replay events
         * as soon as we subscribe, but since we want the *next* asynchronous
         * one, we'll ignore them until the replay finishes.
         */ if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    if ($dsOUI.USE_REACT_CACHE) {
        // React Suspense should get thrown the same promise each time, so we cache it.
        // However, the promise gets resolved on each payload, so subsequently we need
        // to provide a new fresh promise that isn't already resolved. (When the feature
        // flag is off we do this in QueryResource.)
        cachedRequest.promise = promise;
        var cleanup = function cleanup() {
            cachedRequest.promise = null;
        };
        promise.then(cleanup, cleanup);
    }
    return promise;
}
/**
 * If there is a pending request for the given query, returns an Observable of
 * *all* its responses. Existing responses are published synchronously and
 * subsequent responses are published asynchronously. Returns null if there is
 * no pending request. This is similar to fetchQuery() except that it will not
 * issue a fetch if there isn't already one pending.
 */ function $1544837bc9a02b7e$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $1544837bc9a02b7e$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $1544837bc9a02b7e$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getRequestCache(environment) {
    var cached = $1544837bc9a02b7e$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $1544837bc9a02b7e$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $aaXwj(false);
    return cached;
}
module.exports = {
    fetchQuery: $1544837bc9a02b7e$var$fetchQuery,
    fetchQueryDeduped: $1544837bc9a02b7e$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $1544837bc9a02b7e$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $1544837bc9a02b7e$var$getObservableForActiveRequest
};

});
parcelRegister("aLywI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $7d69136d8cd658ab$var$_interopRequireDefault = $1jnue.default;

var $7d69136d8cd658ab$var$_createForOfIteratorHelper2 = $7d69136d8cd658ab$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $7d69136d8cd658ab$var$_defineProperty2 = $7d69136d8cd658ab$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $hIn3L = parcelRequire("hIn3L");

var $aaXwj = parcelRequire("aaXwj");
/**
 * An implementation of a `ReplaySubject` for Relay Observables.
 *
 * Records events provided and synchronously plays them back to new subscribers,
 * as well as forwarding new asynchronous events.
 */ var $7d69136d8cd658ab$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_events", []);
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $hIn3L.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case "complete":
                        sink.complete();
                        break;
                    case "error":
                        sink.error(event.error);
                        break;
                    case "next":
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $aaXwj(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: "complete"
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: "error",
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: "next",
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $7d69136d8cd658ab$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $7d69136d8cd658ab$var$RelayReplaySubject;

});



parcelRegister("f0RKF", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $40tQb = parcelRequire("40tQb");
var $aee08d16fabb6df7$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $aW0zg = parcelRequire("aW0zg");
var $aee08d16fabb6df7$var$getRequest = $aW0zg.getRequest;
/**
 * A helper function to fetch the results of a query. Note that results for
 * fragment spreads are masked: fields must be explicitly listed in the query in
 * order to be accessible in the result object.
 */ function $aee08d16fabb6df7$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $aee08d16fabb6df7$var$getRequest(taggedNode);
    if (query.params.operationKind !== "query") throw new Error("fetchQuery: Expected query operation");
    var operation = $aee08d16fabb6df7$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $aee08d16fabb6df7$var$fetchQuery_DEPRECATED;

});

parcelRegister("gucor", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $c0090fb264c4455a$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                // We do *not* want to throw in this tick, as this callback is executed
                // while a query is required for the very first time.
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $c0090fb264c4455a$var$preloadableQueryRegistry = new $c0090fb264c4455a$var$PreloadableQueryRegistry();
module.exports = $c0090fb264c4455a$var$preloadableQueryRegistry;

});

parcelRegister("lWuAe", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $eXtFn = parcelRequire("eXtFn");
parcelRequire("8Fbfi");
function $ff96bcfe11da0932$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $eXtFn(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $ff96bcfe11da0932$var$createFragmentSpecResolver;

});
parcelRegister("eXtFn", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $ae3d968518c600f2$var$_interopRequireDefault = $1jnue.default;

var $ae3d968518c600f2$var$_objectSpread2 = $ae3d968518c600f2$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $ae3d968518c600f2$var$_defineProperty2 = $ae3d968518c600f2$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $k0hcd = parcelRequire("k0hcd");

var $47Vax = parcelRequire("47Vax");

var $iyRh8 = parcelRequire("iyRh8");

var $9DGaB = parcelRequire("9DGaB");

var $dsOUI = parcelRequire("dsOUI");

var $40tQb = parcelRequire("40tQb");
var $ae3d968518c600f2$var$createRequestDescriptor = $40tQb.createRequestDescriptor;

var $idJ2w = parcelRequire("idJ2w");
var $ae3d968518c600f2$var$areEqualSelectors = $idJ2w.areEqualSelectors, $ae3d968518c600f2$var$createReaderSelector = $idJ2w.createReaderSelector, $ae3d968518c600f2$var$getSelectorsFromObject = $idJ2w.getSelectorsFromObject;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * A utility for resolving and subscribing to the results of a fragment spec
 * (key -> fragment mapping) given some "props" that determine the root ID
 * and variables to use when reading each fragment. When props are changed via
 * `setProps()`, the resolver will update its results and subscriptions
 * accordingly. Internally, the resolver:
 * - Converts the fragment map & props map into a map of `Selector`s.
 * - Removes any resolvers for any props that became null.
 * - Creates resolvers for any props that became non-null.
 * - Updates resolvers with the latest props.
 *
 * This utility is implemented as an imperative, stateful API for performance
 * reasons: reusing previous resolvers, callback functions, and subscriptions
 * all helps to reduce object allocation and thereby decrease GC time.
 *
 * The `resolve()` function is also lazy and memoized: changes in the store mark
 * the resolver as stale and notify the caller, and the actual results are
 * recomputed the first time `resolve()` is called.
 */ var $ae3d968518c600f2$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $ae3d968518c600f2$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === "function") _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $ae3d968518c600f2$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            // Avoid mapping the object multiple times, which could occur if data for
            // multiple keys changes in the same event loop.
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $ae3d968518c600f2$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$iyRh8(_nextItem, prevItem)) {
                        nextData = nextData || (0, $ae3d968518c600f2$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($dsOUI.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $ae3d968518c600f2$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === "PluralReaderSelector") {
                if (resolver == null) resolver = new $ae3d968518c600f2$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $ae3d968518c600f2$var$SelectorListResolver) && $aaXwj(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $ae3d968518c600f2$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $ae3d968518c600f2$var$SelectorResolver) && $aaXwj(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
/**
 * A resolver for a single Selector.
 */ var $ae3d968518c600f2$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $ae3d968518c600f2$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($dsOUI.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            // NOTE: This branch exists to handle the case in which:
            // - A RelayModern container is rendered as a descendant of a Relay Hook
            //   root using a "partial" renderPolicy (this means that eargerly
            //   reading any cached data that is available instead of blocking
            //   at the root until the whole query is fetched).
            // - A parent Relay Hook didnt' suspend earlier on data being fetched,
            //   either because the fragment data for the parent was available, or
            //   the parent fragment didn't have any data dependencies.
            // Even though our Flow types reflect the possiblity of null data, there
            // might still be cases where it's not handled at runtime becuase the
            // Flow types are being ignored, or simply not being used (for example,
            // the case reported here: https://fburl.com/srnbucf8, was due to
            // misuse of Flow types here: https://fburl.com/g3m0mqqh).
            // Additionally, even though the null data might be handled without a
            // runtime error, we might not suspend when we intended to if a parent
            // Relay Hook (e.g. that is using @defer) decided not to suspend becuase
            // it's immediate data was already available (even if it was deferred),
            // or it didn't actually need any data (was just spreading other fragments).
            // This should eventually go away with something like @optional, where we only
            // suspend at specific boundaries depending on whether the boundary
            // can be fulfilled or not.
            var pendingOperationsResult = $k0hcd(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: "suspense.fragment",
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $47Vax(this._environment, this._missingRequiredFields, this._relayResolverErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $ae3d968518c600f2$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $9DGaB(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($ewhZB(variables, this._selector.variables)) // If we're not actually setting new variables, we don't actually want
        // to create a new fragment owner, since areEqualSelectors relies on
        // owner identity.
        // In fact, we don't even need to try to attempt to set a new selector.
        // When fragment ownership is not enabled, setSelector will also bail
        // out since the selector doesn't really change, so we're doing it here
        // earlier.
        return;
        // NOTE: We manually create the request descriptor here instead of
        // calling createOperationDescriptor() because we want to set a
        // descriptor with *unaltered* variables as the fragment owner.
        // This is a hack that allows us to preserve existing (broken)
        // behavior of RelayModern containers while using fragment ownership
        // to propagate variables instead of Context.
        // For more details, see the summary of D13999308
        var requestDescriptor = $ae3d968518c600f2$var$createRequestDescriptor(request, variables);
        var selector = $ae3d968518c600f2$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
/**
 * A resolver for an array of Selectors.
 */ var $ae3d968518c600f2$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $ae3d968518c600f2$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($ae3d968518c600f2$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            // Avoid mapping the array multiple times, which could occur if data for
            // multiple indices changes in the same event loop.
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $ae3d968518c600f2$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $ae3d968518c600f2$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $ae3d968518c600f2$var$RelayModernFragmentSpecResolver;

});
parcelRegister("k0hcd", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1PcQ6 = parcelRequire("1PcQ6");
var $e901258517dd2062$var$getPromiseForActiveRequest = $1PcQ6.getPromiseForActiveRequest;
function $e901258517dd2062$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $e901258517dd2062$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(",")) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = "Unknown pending operation";
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    // $FlowExpectedError[prop-missing] Expando to annotate Promises.
    promise.displayName = promiseDisplayName;
    // In order to monitor the efficacy of RelayOperationTracker, we log
    // enough information to track whether we are suspending on the fragment
    // owner's operation, or some other operation.
    environment.__log({
        name: "pendingoperation.found",
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $e901258517dd2062$var$getPendingOperationsForFragment;

});

parcelRegister("iyRh8", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * A fast test to determine if two values are equal scalars:
 * - compares scalars such as booleans, strings, numbers by value
 * - compares functions by identity
 * - returns false for complex values, since these cannot be cheaply tested for
 *   equality (use `areEquals` instead)
 */ function $d834ba5add34a187$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== "object");
}
module.exports = $d834ba5add34a187$var$isScalarAndEqual;

});

parcelRegister("9DGaB", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $704877a5fa33902c$var$hasWeakSetDefined = typeof WeakSet !== "undefined";
var $704877a5fa33902c$var$hasWeakMapDefined = typeof WeakMap !== "undefined";
/**
 * Recycles subtrees from `prevData` by replacing equal subtrees in `nextData`.
 */ function $704877a5fa33902c$var$recycleNodesInto(prevData, nextData) {
    if (prevData === nextData || typeof prevData !== "object" || prevData instanceof Set || prevData instanceof Map || $704877a5fa33902c$var$hasWeakSetDefined && prevData instanceof WeakSet || $704877a5fa33902c$var$hasWeakMapDefined && prevData instanceof WeakMap || !prevData || typeof nextData !== "object" || nextData instanceof Set || nextData instanceof Map || $704877a5fa33902c$var$hasWeakSetDefined && nextData instanceof WeakSet || $704877a5fa33902c$var$hasWeakMapDefined && nextData instanceof WeakMap || !nextData) return nextData;
    var canRecycle = false;
    // Assign local variables to preserve Flow type refinement.
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
        var prevValue = prevArray[ii];
        var nextValue = $704877a5fa33902c$var$recycleNodesInto(prevValue, nextItem);
        if (nextValue !== nextArray[ii]) nextArray[ii] = nextValue;
        return wasEqual && nextValue === prevArray[ii];
    }, true) && prevArray.length === nextArray.length;
    else if (!prevArray && !nextArray) {
        // Assign local variables to preserve Flow type refinement.
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $704877a5fa33902c$var$recycleNodesInto(prevValue, nextObject[key]);
            if (nextValue !== nextObject[key]) // $FlowFixMe[cannot-write]
            nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $704877a5fa33902c$var$recycleNodesInto;

});



parcelRegister("ftuXr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
// Ideally, we'd just import the type of the react module, but this causes Flow
// problems.
var $b4419401ed64c419$var$relayContext;
var $b4419401ed64c419$var$firstReact;
function $b4419401ed64c419$var$createRelayContext(react) {
    if (!$b4419401ed64c419$var$relayContext) {
        $b4419401ed64c419$var$relayContext = react.createContext(null);
        $b4419401ed64c419$var$firstReact = react;
    }
    !(react === $b4419401ed64c419$var$firstReact) && $aaXwj(false);
    return $b4419401ed64c419$var$relayContext;
}
module.exports = $b4419401ed64c419$var$createRelayContext;

});

parcelRegister("2MLqe", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $2074d97b262ae00c$var$getInlineDataFragment = $aW0zg.getInlineDataFragment;

var $5DrBw = parcelRequire("5DrBw");
var $2074d97b262ae00c$var$FRAGMENTS_KEY = $5DrBw.FRAGMENTS_KEY;

var $aaXwj = parcelRequire("aaXwj");
function $2074d97b262ae00c$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $2074d97b262ae00c$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === "object") && $aaXwj(false);
    // $FlowFixMe[incompatible-use]
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$2074d97b262ae00c$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $aaXwj(false);
    return inlineData;
}
module.exports = $2074d97b262ae00c$var$readInlineData;

});

parcelRegister("7V8U5", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $5c44c35fa5be72ec$var$_interopRequireDefault = $1jnue.default;

var $5c44c35fa5be72ec$var$_objectSpread2 = $5c44c35fa5be72ec$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5wpCP = parcelRequire("5wpCP");

var $lbx0y = parcelRequire("lbx0y");
var $5c44c35fa5be72ec$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $lbx0y.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $5c44c35fa5be72ec$var$assertInternalActorIdentifier = $lbx0y.assertInternalActorIdentifier;

var $hIn3L = parcelRequire("hIn3L");

var $hRVdm = parcelRequire("hRVdm");

var $cGYI4 = parcelRequire("cGYI4");

var $frXF3 = parcelRequire("frXF3");

var $dsOUI = parcelRequire("dsOUI");

var $aNE7V = parcelRequire("aNE7V");

var $9YoSM = parcelRequire("9YoSM");

var $fziBd = parcelRequire("fziBd");

var $kkibE = parcelRequire("kkibE");

var $L6WFS = parcelRequire("L6WFS");
parcelRequire("aaXwj");
var $5c44c35fa5be72ec$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$requiredField, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var reactFlightPayloadDeserializer = config.reactFlightPayloadDeserializer;
        var reactFlightServerErrorHandler = config.reactFlightServerErrorHandler;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $5c44c35fa5be72ec$var$emptyFunction;
        this.requiredFieldLogger = (_config$requiredField = config.requiredFieldLogger) !== null && _config$requiredField !== void 0 ? _config$requiredField : $9YoSM;
        this._defaultRenderPolicy = ((_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : $dsOUI.ENABLE_PARTIAL_RENDERING_DEFAULT === true) ? "partial" : "full";
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $hRVdm(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $aNE7V;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $kkibE(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $5wpCP, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this.__setNet = function(newNet) {
            return _this._network = $hRVdm(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $cGYI4();
        this._reactFlightPayloadDeserializer = reactFlightPayloadDeserializer;
        this._reactFlightServerErrorHandler = reactFlightServerErrorHandler;
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        // Register this Relay Environment with Relay DevTools if it exists.
        // Note: this must always be the last step in the constructor.
        $frXF3(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === "active";
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $hIn3L.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$5c44c35fa5be72ec$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $hIn3L.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $L6WFS.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $5c44c35fa5be72ec$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Query operation, each result of which is then
   * normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to: environment.execute({...}).subscribe({...}).
   */ ;
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Subscription operation, each result of which is then
   * normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to: environment.execute({...}).subscribe({...}).
   */ ;
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Mutation operation, the result of which is then normalized and
   * committed to the publish queue along with an optional optimistic response
   * or updater.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to:
   * environment.executeMutation({...}).subscribe({...}).
   */ ;
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $5c44c35fa5be72ec$var$_objectSpread2["default"])((0, $5c44c35fa5be72ec$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Query or Subscription operation responses, the result of which is
   * then normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to:
   * environment.executeWithSource({...}).subscribe({...}).
   */ ;
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : "", ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $hIn3L.create(function(sink) {
            var executor = $fziBd.execute({
                actorIdentifier: $5c44c35fa5be72ec$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                reactFlightPayloadDeserializer: _this10._reactFlightPayloadDeserializer,
                reactFlightServerErrorHandler: _this10._reactFlightServerErrorHandler,
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                // NOTE: Some product tests expect `Network.execute` to be called only
                //       when the Observable is executed.
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $5c44c35fa5be72ec$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === "Operation" && operation.root.node.clientAbstractTypes != null;
}
// Add a sigil for detection by `isRelayModernEnvironment()` to avoid a
// realm-specific instanceof check, and to aid in module tree-shaking to
// avoid requiring all of RelayRuntime just to detect its environment.
$5c44c35fa5be72ec$var$RelayModernEnvironment.prototype["@@RelayModernEnvironment"] = true;
function $5c44c35fa5be72ec$var$emptyFunction() {}
module.exports = $5c44c35fa5be72ec$var$RelayModernEnvironment;

});
parcelRegister("lbx0y", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
var $f6c43abf5dba782e$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = "INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE";
function $f6c43abf5dba782e$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $f6c43abf5dba782e$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $aaXwj(false);
}
module.exports = {
    assertInternalActorIdentifier: $f6c43abf5dba782e$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error("Not Implemented");
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $f6c43abf5dba782e$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});

parcelRegister("hRVdm", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $8d9GR = parcelRequire("8d9GR");
/**
 * Wraps the network with logging to ensure that network requests are
 * always logged. Relying on each network callsite to be wrapped is
 * untenable and will eventually lead to holes in the logging.
 * NOTE: This function takes an environment instance, because Relay
 * devtools will mutate the `env.__log` method, and the devtools rely
 * on it to receive network events.
 */ function $d023c481fc97ad8a$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $8d9GR();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: "network.start",
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: "network.next",
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: "network.error",
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: "network.complete",
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: "network.unsubscribe",
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: "network.info",
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $d023c481fc97ad8a$var$wrapNetworkWithLogObserver;

});
parcelRegister("8d9GR", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $5fa70df10d32675b$var$id = 100000;
function $5fa70df10d32675b$var$generateID() {
    return $5fa70df10d32675b$var$id++;
}
module.exports = $5fa70df10d32675b$var$generateID;

});


parcelRegister("cGYI4", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $93d87ff7f5810dab$var$_interopRequireDefault = $1jnue.default;

var $93d87ff7f5810dab$var$_createForOfIteratorHelper2 = $93d87ff7f5810dab$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
var $93d87ff7f5810dab$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    /**
   * Update the map of current processing operations with the set of
   * affected owners and notify subscribers
   */ var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) // In this case the `ownerIdentifier` already affected by some operations
                // We just need to detect, is it the same operation that we already
                // have in the list, or it's a new operation
                {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    // This is a new `ownerIdentifier` that is affected by the operation
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        // No new owners were affected by this operation, we may stop here
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        // But, if some owners were affected we need to add them to
        // the `_pendingOperationsToOwners` set
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    } /**
   * Once pending operation is completed we need to remove it
   * from all tracking maps
   */ ;
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        // These were the owners affected only by `pendingOperationIdentifier`
        var completedOwnersIdentifier = new Set();
        // These were the owners affected by `pendingOperationIdentifier`
        // and some other operations
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        // Complete subscriptions for all owners, affected by `pendingOperationIdentifier`
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        // Update all ownerIdentifier that were updated by `pendingOperationIdentifier` but still
        // are affected by other operations
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        // Finally, remove pending operation identifier
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $aaXwj(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $93d87ff7f5810dab$var$RelayOperationTracker;

});

parcelRegister("frXF3", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $b3f7a81de500bc6e$var$registerEnvironmentWithDevTools(environment) {
    // Register this Relay Environment with Relay DevTools if it exists.
    // Note: this must always be the last step in the constructor.
    var _global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $b3f7a81de500bc6e$var$registerEnvironmentWithDevTools;

});

parcelRegister("aNE7V", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $2DcyS = parcelRequire("2DcyS");
var $7dcd9b58ce562edd$var$VIEWER_ID = $2DcyS.VIEWER_ID, $7dcd9b58ce562edd$var$VIEWER_TYPE = $2DcyS.VIEWER_TYPE;
function $7dcd9b58ce562edd$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $7dcd9b58ce562edd$var$VIEWER_TYPE) return fieldValue.id == null ? $7dcd9b58ce562edd$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $7dcd9b58ce562edd$var$defaultGetDataID;

});
parcelRegister("2DcyS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $i2E13 = parcelRequire("i2E13");
var $1ea8f7bea0f67876$var$generateClientID = $i2E13.generateClientID;

var $5DrBw = parcelRequire("5DrBw");
var $1ea8f7bea0f67876$var$ROOT_ID = $5DrBw.ROOT_ID;
var $1ea8f7bea0f67876$var$VIEWER_ID = $1ea8f7bea0f67876$var$generateClientID($1ea8f7bea0f67876$var$ROOT_ID, "viewer");
var $1ea8f7bea0f67876$var$VIEWER_TYPE = "Viewer";
module.exports = {
    VIEWER_ID: $1ea8f7bea0f67876$var$VIEWER_ID,
    VIEWER_TYPE: $1ea8f7bea0f67876$var$VIEWER_TYPE
};

});


parcelRegister("9YoSM", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $742d04d35d97ad69$var$defaultRequiredFieldLogger = function defaultRequiredFieldLogger(event) {};
module.exports = $742d04d35d97ad69$var$defaultRequiredFieldLogger;

});

parcelRegister("fziBd", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b5588d4de8532a6d$var$_interopRequireDefault = $1jnue.default;

var $b5588d4de8532a6d$var$_objectSpread2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $b5588d4de8532a6d$var$_createForOfIteratorHelper2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $b5588d4de8532a6d$var$_defineProperty2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $b5588d4de8532a6d$var$_toConsumableArray2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $hIn3L = parcelRequire("hIn3L");

var $8d9GR = parcelRequire("8d9GR");

var $dLcej = parcelRequire("dLcej");

var $ii2WU = parcelRequire("ii2WU");

var $dsOUI = parcelRequire("dsOUI");

var $8Q6tr = parcelRequire("8Q6tr");

var $8gN8q = parcelRequire("8gN8q");

var $i2E13 = parcelRequire("i2E13");
var $b5588d4de8532a6d$var$generateClientID = $i2E13.generateClientID, $b5588d4de8532a6d$var$generateUniqueClientID = $i2E13.generateUniqueClientID;

var $fkd0X = parcelRequire("fkd0X");
var $b5588d4de8532a6d$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $idJ2w = parcelRequire("idJ2w");
var $b5588d4de8532a6d$var$createNormalizationSelector = $idJ2w.createNormalizationSelector, $b5588d4de8532a6d$var$createReaderSelector = $idJ2w.createReaderSelector;

var $L6WFS = parcelRequire("L6WFS");

var $gDmh2 = parcelRequire("gDmh2");

var $5DrBw = parcelRequire("5DrBw");
var $b5588d4de8532a6d$var$ROOT_TYPE = $5DrBw.ROOT_TYPE, $b5588d4de8532a6d$var$TYPENAME_KEY = $5DrBw.TYPENAME_KEY, $b5588d4de8532a6d$var$getStorageKey = $5DrBw.getStorageKey;

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $b5588d4de8532a6d$var$execute(config) {
    return new $b5588d4de8532a6d$var$Executor(config);
}
/**
 * Coordinates the execution of a query, handling network callbacks
 * including optimistic payloads, standard payloads, resolution of match
 * dependencies, etc.
 */ var $b5588d4de8532a6d$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, _reactFlightPayloadDeserializer = _ref2.reactFlightPayloadDeserializer, reactFlightServerErrorHandler = _ref2.reactFlightServerErrorHandler, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log;
        (0, $b5588d4de8532a6d$var$_defineProperty2["default"])(this, "_deserializeReactFlightPayloadWithLogging", function(tree) {
            var reactFlightPayloadDeserializer = _this._reactFlightPayloadDeserializer;
            !(typeof reactFlightPayloadDeserializer === "function") && $aaXwj(false);
            var _withDuration = $8gN8q(function() {
                return reactFlightPayloadDeserializer(tree);
            }), duration = _withDuration[0], result = _withDuration[1];
            _this._log({
                name: "execute.flight.payload_deserialize",
                executeId: _this._executeId,
                operationName: _this._operation.request.node.params.name,
                duration: duration
            });
            return result;
        });
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $8d9GR();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = "started";
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._reactFlightPayloadDeserializer = _reactFlightPayloadDeserializer;
        this._reactFlightServerErrorHandler = reactFlightServerErrorHandler;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === "subscription";
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        var id = this._nextSubscriptionId++;
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: "execute.start",
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    // Cancel any pending execution tasks and mark the executor as completed.
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === "completed") return;
        this._state = "completed";
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            // OK: run revert on cancel
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case "started":
                activeState = "active";
                break;
            case "loading_incremental":
                activeState = "active";
                break;
            case "completed":
                activeState = "inactive";
                break;
            case "loading_final":
                activeState = this._pendingModulePayloadsCount > 0 ? "active" : "inactive";
                break;
            default:
                this._state;
                $aaXwj(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $hIn3L.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: "execute.complete",
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: "execute.error",
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration2 = $8gN8q(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration2[0];
            _this4._log({
                name: "execute.next",
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty("errors")) // Skip extensions-only payloads
            return;
            else if (response.data == null) {
                // Error if any other payload in the batch is missing data, regardless of whether
                // it had `errors` or not.
                var errors = response.hasOwnProperty("errors") && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join("\n") : "(No errors)";
                var error = $ii2WU.create("RelayNetwork", "No data returned for operation `" + _this5._operation.request.node.params.name + "`, got error(s):\n" + messages + "\n\nSee the error `source` property for more information.");
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                // In V8, Error objects keep the closure scope chain alive until the
                // err.stack property is accessed.
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    } /**
   * This method return boolean to indicate if the optimistic
   * response has been handled
   */ ;
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $aaXwj(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== "started") $aaXwj(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === "completed") return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            // no results with data, nothing to process
            // this can occur with extensions-only payloads
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = "loading_final";
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        // Next, handle optimistic responses
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $b5588d4de8532a6d$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        // In theory this doesn't preserve the ordering of the batch.
        // The idea is that a batch is always:
        //  * at most one non-incremental payload
        //  * followed by zero or more incremental payloads
        // The non-incremental payload can appear if the server sends a batch
        // with the initial payload followed by some early-to-resolve incremental
        // payloads (although, can that even happen?)
        if (hasNonIncrementalResponses) {
            // For subscriptions, to avoid every new payload from overwriting existing
            // data from previous payloads, assign a unique rootID for every new
            // non-incremental payload.
            if (this._isSubscriptionOperation) {
                var nextID = $b5588d4de8532a6d$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $b5588d4de8532a6d$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $b5588d4de8532a6d$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            // We attach the id to allow the `requestSubscription` to read from the store using
            // the current id in its `onNext` callback
            if (responsesWithData[0].extensions == null) // $FlowFixMe[cannot-write]
            responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        // OK: run once after each new payload
        // If we have non-incremental responses, we passing `this._operation` to
        // the publish queue here, which will later be passed to the store (via
        // notify) to indicate that this operation caused the store to update
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $aaXwj(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = $b5588d4de8532a6d$var$normalizeResponse(response, this._operation.root, $b5588d4de8532a6d$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
                reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $b5588d4de8532a6d$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $L6WFS.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        // OK: only called on construction and when receiving an optimistic payload from network,
        // which doesn't fall-through to the regular next() handling
        this._runPublishQueue();
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case "ModuleImportPayload":
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case "ActorPayload":
                            break;
                        default:
                            followupPayload;
                            $aaXwj(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    } /**
   * Normalize Data for @module payload, and actor-specific payload
   */ ;
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === "SplitOperation" && followupPayload.kind === "ModuleImportPayload") variables = $b5588d4de8532a6d$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $b5588d4de8532a6d$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return $b5588d4de8532a6d$var$normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
            reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $dLcej(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $b5588d4de8532a6d$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        // $FlowFixMe[unused-promise]
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== "started") return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                // OK: always have to run() after an module import resolves async
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = $b5588d4de8532a6d$var$normalizeResponse(payloadPart, _this8._operation.root, $b5588d4de8532a6d$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                reactFlightPayloadDeserializer: _this8._reactFlightPayloadDeserializer != null ? _this8._deserializeReactFlightPayloadWithLogging : null,
                reactFlightServerErrorHandler: _this8._reactFlightServerErrorHandler,
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    } /**
   * Handles any follow-up actions for a Relay payload for @match, @defer,
   * and @stream directives.
   */ ;
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === "completed") return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? "loading_final" : "loading_incremental";
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== "loading_final";
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === "loading_final") {
                    // But eagerly process any deferred payloads
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === "defer") relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    } /**
   * Processes a ModuleImportPayload, asynchronously resolving the normalization
   * AST and using it to normalize the field data into a RelayResponsePayload.
   * The resulting payload may contain other incremental payloads (match,
   * defer, stream, etc); these are handled by calling
   * `_processPayloadFollowups()`.
   */ ;
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case "ModuleImportPayload":
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) // If the operation module is available synchronously, normalize the
                // data synchronously.
                this._processFollowupPayloadWithNormalizationNode(followupPayload, $dLcej(node));
                else {
                    // Otherwise load the operation module and schedule a task to normalize
                    // the data when the module is available.
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    // Observable.from(operationLoader.load()) wouldn't catch synchronous
                    // errors thrown by the load function, which is user-defined. Guard
                    // against that with Observable.from(new Promise(<work>)).
                    var networkObservable = $hIn3L.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $hIn3L.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $dLcej(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $dsOUI.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration3 = $8gN8q(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                // OK: always have to run after an async module import resolves
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(// $FlowFixMe[incompatible-call] `shouldScheduleAsyncStoreUpdate` check should cover `null` case
                                                batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration3[0];
                                            _this10._log({
                                                name: "execute.async.module",
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case "ActorPayload":
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $aaXwj(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    } /**
   * The executor now knows that GraphQL responses are expected for a given
   * label/path:
   * - Store the placeholder in order to process any future responses that may
   *   arrive.
   * - Then process any responses that had already arrived.
   *
   * The placeholder contains the normalization selector, path (for nested
   * defer/stream), and other metadata used to normalize the incremental
   * response(s).
   */ ;
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        // Update the label => path => placeholder map
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join(".");
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === "response" ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: "placeholder",
            placeholder: placeholder
        });
        // Store references to the parent node to allow detecting concurrent
        // modifications to the parent before items arrive and to replay
        // handle field payloads to account for new information on source records.
        var parentID;
        if (placeholder.kind === "stream") parentID = placeholder.parentID;
        else if (placeholder.kind === "defer") parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $aaXwj(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $b5588d4de8532a6d$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return(// handlers applied to the streamed field itself
            fieldPayload.dataID === parentID || // handlers applied to a field on an ancestor object, where
            // ancestor.field links to the parent record (example: connections)
            fieldID === parentID);
        });
        // If an incremental payload exists for some id that record should also
        // exist.
        !(parentRecord != null) && $aaXwj(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            // If a previous entry exists, merge the previous/next records and
            // payloads together.
            nextParentRecord = $iEVza.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $b5588d4de8532a6d$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        // If there were any queued responses, process them now that placeholders
        // are in place
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    } /**
   * Lookup the placeholder the describes how to process an incremental
   * response, normalize/publish it, and process any nested defer/match/stream
   * metadata.
   */ ;
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf("$defer$") !== -1) {
                var pathKey = path.map(String).join(".");
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: "response",
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === "response") {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === "defer") && $aaXwj(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                // @stream payload path values end in the field name and item index,
                // but Relay records paths relative to the parent of the stream node:
                // therefore we strip the last two elements just to lookup the path
                // (the item index is used later to insert the element in the list)
                var _pathKey = path.slice(0, -2).map(String).join(".");
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: "response",
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === "response") {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === "stream") && $aaXwj(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = $b5588d4de8532a6d$var$normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
            reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        // Load the version of the parent record from which this incremental data
        // was derived
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aaXwj(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $L6WFS.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    } /**
   * Process the data for one item in a @stream field.
   */ ;
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        // Find the LinkedField where @stream was applied
        var field = node.selections[0];
        !(field != null && field.kind === "LinkedField" && field.plural === true) && $aaXwj(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        // Publish the new item and update the parent record to set
        // field[index] = item *if* the parent record hasn't been concurrently
        // modified.
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) // parent has since been deleted, stream data is stale
            return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) // field has since been deleted, stream data is stale
            return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) // field has been modified by something other than this query,
            // stream data is stale
            return;
            // parent.field has not been concurrently modified:
            // update `parent.field[index] = item`
            var nextItems = (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        // Now that the parent record has been updated to include the new item,
        // also update any handle fields that are derived from the parent record.
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $L6WFS.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === "object") && $aaXwj(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $b5588d4de8532a6d$var$getStorageKey(field, variables);
        // Load the version of the parent record from which this incremental data
        // was derived
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aaXwj(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        // Load the field value (items) that were created by *this* query executor
        // in order to check if there has been any concurrent modifications by some
        // other operation.
        var prevIDs = $iEVza.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $aaXwj(false);
        // Determine the index in the field of the new item
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $aaXwj(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$b5588d4de8532a6d$var$TYPENAME_KEY];
        !(typeof typeName === "string") && $aaXwj(false);
        // Determine the __id of the new item: this must equal the value that would
        // be assigned had the item not been streamed
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : // Reuse previously generated client IDs
        $b5588d4de8532a6d$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === "string") && $aaXwj(false);
        // Build a selector to normalize the item data with
        var selector = $b5588d4de8532a6d$var$createNormalizationSelector(field, itemID, variables);
        // Update the cached version of the parent record to reflect the new item:
        // this is used when subsequent stream payloads arrive to see if there
        // have been concurrent modifications to the list
        var nextParentRecord = $iEVza.clone(parentRecord);
        var nextIDs = (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $iEVza.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = $b5588d4de8532a6d$var$normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
            reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $aaXwj(false);
        return operationLoader;
    };
    return Executor;
}();
function $b5588d4de8532a6d$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $aaXwj(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $b5588d4de8532a6d$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions3;
    var data = response.data, errors = response.errors;
    var source = $L6WFS.create();
    var record = $iEVza.create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $gDmh2.normalize(source, selector, data, options);
    return (0, $b5588d4de8532a6d$var$_objectSpread2["default"])((0, $b5588d4de8532a6d$var$_objectSpread2["default"])({}, relayPayload), {}, {
        errors: errors,
        isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
    });
}
function $b5588d4de8532a6d$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($8Q6tr(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : ""; // null-check for flow
}
function $b5588d4de8532a6d$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $aaXwj(false);
}
module.exports = {
    execute: $b5588d4de8532a6d$var$execute
};

});
parcelRegister("dLcej", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");
var $a04926bca1273feb$var$REQUEST = $84X73.REQUEST, $a04926bca1273feb$var$SPLIT_OPERATION = $84X73.SPLIT_OPERATION;
/**
 * OperationLoaders can return either a NormalizationSplitOperation or
 * ConcreteRequest.
 */ function $a04926bca1273feb$var$getOperation(node) {
    switch(node.kind){
        case $a04926bca1273feb$var$REQUEST:
            return node.operation;
        case $a04926bca1273feb$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $a04926bca1273feb$var$getOperation;

});

parcelRegister("ii2WU", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * @private
 */ function $d50c3210f90a2db7$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ] // skip frame (code=2) twice
    });
    // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $d50c3210f90a2db7$var$createError.apply(void 0, [
            "error",
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $d50c3210f90a2db7$var$createError.apply(void 0, [
            "warn",
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("8gN8q", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $6055ee83fd5ed8c7$var$_window, $6055ee83fd5ed8c7$var$_window$performance;
var $6055ee83fd5ed8c7$var$isPerformanceNowAvailable = typeof window !== "undefined" && typeof (($6055ee83fd5ed8c7$var$_window = window) === null || $6055ee83fd5ed8c7$var$_window === void 0 ? void 0 : ($6055ee83fd5ed8c7$var$_window$performance = $6055ee83fd5ed8c7$var$_window.performance) === null || $6055ee83fd5ed8c7$var$_window$performance === void 0 ? void 0 : $6055ee83fd5ed8c7$var$_window$performance.now) === "function";
function $6055ee83fd5ed8c7$var$currentTimestamp() {
    if ($6055ee83fd5ed8c7$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $6055ee83fd5ed8c7$var$withDuration(cb) {
    var startTime = $6055ee83fd5ed8c7$var$currentTimestamp();
    var result = cb();
    return [
        $6055ee83fd5ed8c7$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $6055ee83fd5ed8c7$var$withDuration;

});

parcelRegister("iEVza", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d9589ddf5ce64fbc$var$_interopRequireDefault = $1jnue.default;

var $d9589ddf5ce64fbc$var$_objectSpread2 = $d9589ddf5ce64fbc$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $7sl3K = parcelRequire("7sl3K");

var $i2E13 = parcelRequire("i2E13");
var $d9589ddf5ce64fbc$var$generateClientObjectClientID = $i2E13.generateClientObjectClientID, $d9589ddf5ce64fbc$var$isClientID = $i2E13.isClientID;

var $l1FnP = parcelRequire("l1FnP");
var $d9589ddf5ce64fbc$var$isSuspenseSentinel = $l1FnP.isSuspenseSentinel;

var $5DrBw = parcelRequire("5DrBw");
var $d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY = $5DrBw.ACTOR_IDENTIFIER_KEY, $d9589ddf5ce64fbc$var$ID_KEY = $5DrBw.ID_KEY, $d9589ddf5ce64fbc$var$INVALIDATED_AT_KEY = $5DrBw.INVALIDATED_AT_KEY, $d9589ddf5ce64fbc$var$REF_KEY = $5DrBw.REF_KEY, $d9589ddf5ce64fbc$var$REFS_KEY = $5DrBw.REFS_KEY, $d9589ddf5ce64fbc$var$RELAY_RESOLVER_VALUE_KEY = $5DrBw.RELAY_RESOLVER_VALUE_KEY, $d9589ddf5ce64fbc$var$ROOT_ID = $5DrBw.ROOT_ID, $d9589ddf5ce64fbc$var$TYPENAME_KEY = $5DrBw.TYPENAME_KEY;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * @public
 *
 * Low-level record manipulation methods.
 *
 * A note about perf: we use long-hand property access rather than computed
 * properties in this file for speed ie.
 *
 *    const object = {};
 *    object[KEY] = value;
 *    record[storageKey] = object;
 *
 * instead of:
 *
 *    record[storageKey] = {
 *      [KEY]: value,
 *    };
 *
 * The latter gets transformed by Babel into something like:
 *
 *    function _defineProperty(obj, key, value) {
 *      if (key in obj) {
 *        Object.defineProperty(obj, key, {
 *          value: value,
 *          enumerable: true,
 *          configurable: true,
 *          writable: true,
 *        });
 *      } else {
 *        obj[key] = value;
 *      }
 *      return obj;
 *    }
 *
 *    record[storageKey] = _defineProperty({}, KEY, value);
 *
 * A quick benchmark shows that computed property access is an order of
 * magnitude slower (times in seconds for 100,000 iterations):
 *
 *               best     avg     sd
 *    computed 0.02175 0.02292 0.00113
 *      manual 0.00110 0.00123 0.00008
 */ /**
 * @public
 *
 * Clone a record.
 */ function $d9589ddf5ce64fbc$var$clone(record) {
    return (0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])({}, record);
}
/**
 * @public
 *
 * Copies all fields from `source` to `sink`, excluding `__id` and `__typename`.
 *
 * NOTE: This function does not treat `id` specially. To preserve the id,
 * manually reset it after calling this function. Also note that values are
 * copied by reference and not value; callers should ensure that values are
 * copied on write.
 */ function $d9589ddf5ce64fbc$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $d9589ddf5ce64fbc$var$ID_KEY && key !== $d9589ddf5ce64fbc$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
/**
 * @public
 *
 * Create a new record.
 */ function $d9589ddf5ce64fbc$var$create(dataID, typeName) {
    // See perf note above for why we aren't using computed property access.
    var record = {};
    record[$d9589ddf5ce64fbc$var$ID_KEY] = dataID;
    record[$d9589ddf5ce64fbc$var$TYPENAME_KEY] = typeName;
    return record;
}
/**
 * @public
 *
 * Get the record's `id` if available or the client-generated identifier.
 */ function $d9589ddf5ce64fbc$var$getDataID(record) {
    return record[$d9589ddf5ce64fbc$var$ID_KEY];
}
/**
 * @public
 *
 * Get the concrete type of the record.
 */ function $d9589ddf5ce64fbc$var$getType(record) {
    return record[$d9589ddf5ce64fbc$var$TYPENAME_KEY];
}
/**
 * @public
 *
 * Get a scalar (non-link) field value.
 */ function $d9589ddf5ce64fbc$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === "object") !(!value.hasOwnProperty($d9589ddf5ce64fbc$var$REF_KEY) && !value.hasOwnProperty($d9589ddf5ce64fbc$var$REFS_KEY)) && $aaXwj(false);
    return value;
}
/**
 * @public
 *
 * Get the value of a field as a reference to another record. Throws if the
 * field has a different type.
 */ function $d9589ddf5ce64fbc$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    // We reassign here so that the JSON.stringify call in invariant does not invalidate the
    // non-maybe refinement from above.
    var link = maybeLink;
    !(typeof link === "object" && link && typeof link[$d9589ddf5ce64fbc$var$REF_KEY] === "string") && $aaXwj(false);
    // $FlowFixMe[incompatible-return]
    return link[$d9589ddf5ce64fbc$var$REF_KEY];
}
/**
 * @public
 *
 * Get the value of a field as a list of references to other records. Throws if
 * the field has a different type.
 */ function $d9589ddf5ce64fbc$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === "object" && Array.isArray(links[$d9589ddf5ce64fbc$var$REFS_KEY])) && $aaXwj(false);
    // assume items of the array are ids
    return links[$d9589ddf5ce64fbc$var$REFS_KEY];
}
/**
 * @public
 *
 * Returns the epoch at which the record was invalidated, if it
 * ever was; otherwise returns null;
 */ function $d9589ddf5ce64fbc$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$d9589ddf5ce64fbc$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== "number") // If the record has never been invalidated, it isn't stale.
    return null;
    return invalidatedAt;
}
/**
 * @public
 *
 * Compares the fields of a previous and new record, returning either the
 * previous record if all fields are equal or a new record (with merged fields)
 * if any fields have changed.
 */ function $d9589ddf5ce64fbc$var$update(prevRecord, nextRecord) {
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var updated = null;
    var keys = Object.keys(nextRecord);
    for(var ii = 0; ii < keys.length; ii++){
        var key = keys[ii];
        if (updated || !$ewhZB(prevRecord[key], nextRecord[key])) {
            updated = updated !== null ? updated : (0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])({}, prevRecord);
            updated[key] = nextRecord[key];
        }
    }
    return updated !== null ? updated : prevRecord;
}
/**
 * @public
 *
 * Returns a new record with the contents of the given records. Fields in the
 * second record will overwrite identical fields in the first record.
 */ function $d9589ddf5ce64fbc$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    return (0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])((0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])({}, record1), record2);
}
/**
 * @public
 *
 * Prevent modifications to the record. Attempts to call `set*` functions on a
 * frozen record will fatal at runtime.
 */ function $d9589ddf5ce64fbc$var$freeze(record) {
    $7sl3K(record);
}
/**
 * @public
 *
 * Set the value of a storageKey to a scalar.
 */ function $d9589ddf5ce64fbc$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
/**
 * @public
 *
 * Set the value of a field to a reference to another record.
 */ function $d9589ddf5ce64fbc$var$setLinkedRecordID(record, storageKey, linkedID) {
    // See perf note above for why we aren't using computed property access.
    var link = {};
    link[$d9589ddf5ce64fbc$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
/**
 * @public
 *
 * Set the value of a field to a list of references other records.
 */ function $d9589ddf5ce64fbc$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    // See perf note above for why we aren't using computed property access.
    var links = {};
    links[$d9589ddf5ce64fbc$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
/**
 * @public
 *
 * Set the value of a field to a reference to another record in the actor specific store.
 */ function $d9589ddf5ce64fbc$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    // See perf note above for why we aren't using computed property access.
    var link = {};
    link[$d9589ddf5ce64fbc$var$REF_KEY] = linkedID;
    link[$d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
/**
 * @public
 *
 * Get link to a record and the actor identifier for the store.
 */ function $d9589ddf5ce64fbc$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === "object" && typeof link[$d9589ddf5ce64fbc$var$REF_KEY] === "string" && link[$d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY] != null) && $aaXwj(false);
    return [
        link[$d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY],
        link[$d9589ddf5ce64fbc$var$REF_KEY]
    ];
}
function $d9589ddf5ce64fbc$var$getResolverLinkedRecordID(record, typeName) {
    var id = $d9589ddf5ce64fbc$var$getValue(record, $d9589ddf5ce64fbc$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $d9589ddf5ce64fbc$var$isSuspenseSentinel(id)) return null;
    // TODD: Deprecate client edges that return just id.
    if (typeof id === "object") id = id.id;
    !(typeof id === "string") && $aaXwj(false);
    return $d9589ddf5ce64fbc$var$generateClientObjectClientID(typeName, id);
}
function $d9589ddf5ce64fbc$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $d9589ddf5ce64fbc$var$getValue(record, $d9589ddf5ce64fbc$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $d9589ddf5ce64fbc$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $aaXwj(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        // TODD: Deprecate client edges that return just id.
        if (typeof id === "object") id = id.id;
        !(typeof id === "string") && $aaXwj(false);
        return $d9589ddf5ce64fbc$var$generateClientObjectClientID(typeName, id);
    });
}
module.exports = {
    clone: $d9589ddf5ce64fbc$var$clone,
    copyFields: $d9589ddf5ce64fbc$var$copyFields,
    create: $d9589ddf5ce64fbc$var$create,
    freeze: $d9589ddf5ce64fbc$var$freeze,
    getDataID: $d9589ddf5ce64fbc$var$getDataID,
    getInvalidationEpoch: $d9589ddf5ce64fbc$var$getInvalidationEpoch,
    getLinkedRecordID: $d9589ddf5ce64fbc$var$getLinkedRecordID,
    getLinkedRecordIDs: $d9589ddf5ce64fbc$var$getLinkedRecordIDs,
    getType: $d9589ddf5ce64fbc$var$getType,
    getValue: $d9589ddf5ce64fbc$var$getValue,
    merge: $d9589ddf5ce64fbc$var$merge,
    setValue: $d9589ddf5ce64fbc$var$setValue,
    setLinkedRecordID: $d9589ddf5ce64fbc$var$setLinkedRecordID,
    setLinkedRecordIDs: $d9589ddf5ce64fbc$var$setLinkedRecordIDs,
    update: $d9589ddf5ce64fbc$var$update,
    getActorLinkedRecordID: $d9589ddf5ce64fbc$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $d9589ddf5ce64fbc$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $d9589ddf5ce64fbc$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $d9589ddf5ce64fbc$var$getResolverLinkedRecordIDs
};

});
parcelRegister("l1FnP", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $f4e9cad1aec721eb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $f4e9cad1aec721eb$var$suspenseSentinel() {
    // $FlowFixMe[incompatible-return]
    return $f4e9cad1aec721eb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $f4e9cad1aec721eb$var$isSuspenseSentinel(value) {
    return value === $f4e9cad1aec721eb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $f4e9cad1aec721eb$var$isSuspenseSentinel,
    suspenseSentinel: $f4e9cad1aec721eb$var$suspenseSentinel
};

});


parcelRegister("L6WFS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $08d9c71b03d8ee3d$var$_interopRequireDefault = $1jnue.default;

var $08d9c71b03d8ee3d$var$_createForOfIteratorHelper2 = $08d9c71b03d8ee3d$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $bZtyP = parcelRequire("bZtyP");
var $08d9c71b03d8ee3d$var$EXISTENT = $bZtyP.EXISTENT, $08d9c71b03d8ee3d$var$NONEXISTENT = $bZtyP.NONEXISTENT, $08d9c71b03d8ee3d$var$UNKNOWN = $bZtyP.UNKNOWN;
/**
 * An implementation of the `MutableRecordSource` interface (defined in
 * `RelayStoreTypes`) that holds all records in memory (JS Map).
 */ var $08d9c71b03d8ee3d$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            _this._records.set(key, records[key]);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $08d9c71b03d8ee3d$var$UNKNOWN;
        return this._records.get(dataID) == null ? $08d9c71b03d8ee3d$var$NONEXISTENT : $08d9c71b03d8ee3d$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $08d9c71b03d8ee3d$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
                obj[key] = value;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $08d9c71b03d8ee3d$var$RelayRecordSource;

});
parcelRegister("bZtyP", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $8bac5257a9f264bc$var$RelayRecordState = {
    /**
   * Record exists (either fetched from the server or produced by a local,
   * optimistic update).
   */ EXISTENT: "EXISTENT",
    /**
   * Record is known not to exist (either as the result of a mutation, or
   * because the server returned `null` when queried for the record).
   */ NONEXISTENT: "NONEXISTENT",
    /**
   * Record State is unknown because it has not yet been fetched from the
   * server.
   */ UNKNOWN: "UNKNOWN"
};
module.exports = $8bac5257a9f264bc$var$RelayRecordState;

});


parcelRegister("gDmh2", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $c1c190f56a797e52$var$_interopRequireDefault = $1jnue.default;

var $c1c190f56a797e52$var$_createForOfIteratorHelper2 = $c1c190f56a797e52$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $c1c190f56a797e52$var$_toConsumableArray2 = $c1c190f56a797e52$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $5hGP9 = parcelRequire("5hGP9");
var $c1c190f56a797e52$var$ACTOR_IDENTIFIER_FIELD_NAME = $5hGP9.ACTOR_IDENTIFIER_FIELD_NAME, $c1c190f56a797e52$var$getActorIdentifierFromPayload = $5hGP9.getActorIdentifierFromPayload;

var $84X73 = parcelRequire("84X73");
var $c1c190f56a797e52$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $c1c190f56a797e52$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $c1c190f56a797e52$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $c1c190f56a797e52$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $c1c190f56a797e52$var$CONDITION = $84X73.CONDITION, $c1c190f56a797e52$var$DEFER = $84X73.DEFER, $c1c190f56a797e52$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $c1c190f56a797e52$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $c1c190f56a797e52$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $c1c190f56a797e52$var$LINKED_FIELD = $84X73.LINKED_FIELD, $c1c190f56a797e52$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $c1c190f56a797e52$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $c1c190f56a797e52$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $c1c190f56a797e52$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $c1c190f56a797e52$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $c1c190f56a797e52$var$STREAM = $84X73.STREAM, $c1c190f56a797e52$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR;

var $dsOUI = parcelRequire("dsOUI");

var $i2E13 = parcelRequire("i2E13");
var $c1c190f56a797e52$var$generateClientID = $i2E13.generateClientID, $c1c190f56a797e52$var$isClientID = $i2E13.isClientID;

var $fkd0X = parcelRequire("fkd0X");
var $c1c190f56a797e52$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $idJ2w = parcelRequire("idJ2w");
var $c1c190f56a797e52$var$createNormalizationSelector = $idJ2w.createNormalizationSelector;

var $53GBi = parcelRequire("53GBi");
var $c1c190f56a797e52$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY = $53GBi.REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY, $c1c190f56a797e52$var$REACT_FLIGHT_TREE_STORAGE_KEY = $53GBi.REACT_FLIGHT_TREE_STORAGE_KEY, $c1c190f56a797e52$var$REACT_FLIGHT_TYPE_NAME = $53GBi.REACT_FLIGHT_TYPE_NAME, $c1c190f56a797e52$var$refineToReactFlightPayloadData = $53GBi.refineToReactFlightPayloadData;

var $5DrBw = parcelRequire("5DrBw");
var $c1c190f56a797e52$var$ROOT_ID = $5DrBw.ROOT_ID, $c1c190f56a797e52$var$ROOT_TYPE = $5DrBw.ROOT_TYPE, $c1c190f56a797e52$var$TYPENAME_KEY = $5DrBw.TYPENAME_KEY, $c1c190f56a797e52$var$getArgumentValues = $5DrBw.getArgumentValues, $c1c190f56a797e52$var$getHandleStorageKey = $5DrBw.getHandleStorageKey, $c1c190f56a797e52$var$getModuleComponentKey = $5DrBw.getModuleComponentKey, $c1c190f56a797e52$var$getModuleOperationKey = $5DrBw.getModuleOperationKey, $c1c190f56a797e52$var$getStorageKey = $5DrBw.getStorageKey;

var $kRPAW = parcelRequire("kRPAW");
var $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE = $kRPAW.TYPE_SCHEMA_TYPE, $c1c190f56a797e52$var$generateTypeID = $kRPAW.generateTypeID;
parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * Normalizes the results of a query and standard GraphQL response, writing the
 * normalized records/fields into the given MutableRecordSource.
 */ function $c1c190f56a797e52$var$normalize(recordSource, selector, response, options) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $c1c190f56a797e52$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response);
}
/**
 * @private
 *
 * Helper for handling payloads.
 */ var $c1c190f56a797e52$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._reactFlightPayloadDeserializer = options.reactFlightPayloadDeserializer;
        this._reactFlightServerErrorHandler = options.reactFlightServerErrorHandler;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data) {
        var record = this._recordSource.get(dataID);
        !record && $aaXwj(false);
        this._assignClientAbstractTypes(node);
        this._traverseSelections(node, record, data);
        return {
            errors: null,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $c1c190f56a797e52$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $c1c190f56a797e52$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $iEVza.create(typeID, $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $iEVza.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$c1c190f56a797e52$var$TYPENAME_KEY];
        !(typeName != null) && $aaXwj(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $c1c190f56a797e52$var$SCALAR_FIELD:
                case $c1c190f56a797e52$var$LINKED_FIELD:
                    this._normalizeField(node, selection, record, data);
                    break;
                case $c1c190f56a797e52$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $c1c190f56a797e52$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $c1c190f56a797e52$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $iEVza.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $iEVza.getType(record);
                        var typeID = $c1c190f56a797e52$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $iEVza.create(typeID, $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $iEVza.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $c1c190f56a797e52$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $iEVza.getType(record);
                    var _typeID = $c1c190f56a797e52$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $iEVza.create(_typeID, $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $iEVza.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $c1c190f56a797e52$var$LINKED_HANDLE:
                case $c1c190f56a797e52$var$SCALAR_HANDLE:
                    var args = selection.args ? $c1c190f56a797e52$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $c1c190f56a797e52$var$getStorageKey(selection, this._variables);
                    var handleKey = $c1c190f56a797e52$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $iEVza.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $c1c190f56a797e52$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $c1c190f56a797e52$var$MODULE_IMPORT:
                    this._normalizeModuleImport(node, selection, record, data);
                    break;
                case $c1c190f56a797e52$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $c1c190f56a797e52$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $c1c190f56a797e52$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) this._normalizeFlightField(node, selection, record, data);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $c1c190f56a797e52$var$ACTOR_CHANGE:
                    this._normalizeActorChange(node, selection, record, data);
                    break;
                case $c1c190f56a797e52$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) // If defer is disabled there will be no additional response chunk:
        // normalize the data already present.
        this._traverseSelections(defer, record, data);
        else // Otherwise data *for this selection* should not be present: enqueue
        // metadata to process the subsequent response chunk.
        this._incrementalPlaceholders.push({
            kind: "defer",
            data: data,
            label: defer.label,
            path: (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path),
            selector: $c1c190f56a797e52$var$createNormalizationSelector(defer, $iEVza.getDataID(record), this._variables),
            typeName: $iEVza.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        // Always normalize regardless of whether streaming is enabled or not,
        // this populates the initial array value (including any items when
        // initial_count > 0).
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) // If streaming is enabled, *also* emit metadata to process any
        // response chunks that may be delivered.
        this._incrementalPlaceholders.push({
            kind: "stream",
            label: stream.label,
            path: (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path),
            parentID: $iEVza.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(parent, moduleImport, record, data) {
        !(typeof data === "object" && data) && $aaXwj(false);
        var typeName = $iEVza.getType(record);
        var componentKey = $c1c190f56a797e52$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $iEVza.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $c1c190f56a797e52$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $iEVza.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: "ModuleImportPayload",
            args: moduleImport.args,
            data: data,
            dataID: $iEVza.getDataID(record),
            operationReference: operationReference,
            path: (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(parent, selection, record, data) {
        !(typeof data === "object" && data) && $aaXwj(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $c1c190f56a797e52$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                // Fields may be missing in the response in two main cases:
                // - Inside a client extension: the server will not generally return
                //   values for these fields, but a local update may provide them.
                // - Inside an abstract type refinement where the concrete type does
                //   not conform to the interface/union.
                // However an otherwise-required field may also be missing if the server
                // is configured to skip fields with `null` values, in which case the
                // client is assumed to be correctly configured with
                // treatMissingFieldsAsNull=true.
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) // Field not expected to exist regardless of whether the server is pruning null
                // fields or not.
                return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        if (selection.kind === $c1c190f56a797e52$var$SCALAR_FIELD) $iEVza.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $c1c190f56a797e52$var$LINKED_FIELD) {
            this._path.push(responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._path.pop();
        } else {
            selection;
            $aaXwj(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(parent, selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === "object" && data) && $aaXwj(false);
        var responseKey = field.alias || field.name;
        var storageKey = $c1c190f56a797e52$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $c1c190f56a797e52$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        // $FlowFixMe[incompatible-call]
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(// $FlowFixMe[incompatible-call]
        fieldValue, typeName) || $iEVza.getLinkedRecordID(record, storageKey) || $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), storageKey);
        !(typeof nextID === "string") && $aaXwj(false);
        $iEVza.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: "ActorPayload",
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeFlightField = function _normalizeFlightField(parent, selection, record, data) {
        var responseKey = selection.alias || selection.name;
        var storageKey = $c1c190f56a797e52$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                // Flight field may be missing in the response if:
                // - It is inside an abstract type refinement where the concrete type does
                //   not conform to the interface/union.
                // However an otherwise-required field may also be missing if the server
                // is configured to skip fields with `null` values, in which case the
                // client is assumed to be correctly configured with
                // treatMissingFieldsAsNull=true.
                if (this._isUnmatchedAbstractType) // Field not expected to exist regardless of whether the server is pruning null
                // fields or not.
                return;
                else // Not optional and the server is not pruning null fields: field is expected
                // to be present
                !this._treatMissingFieldsAsNull && $aaXwj(false);
            }
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        var reactFlightPayload = $c1c190f56a797e52$var$refineToReactFlightPayloadData(fieldValue);
        var reactFlightPayloadDeserializer = this._reactFlightPayloadDeserializer;
        !(reactFlightPayload != null) && $aaXwj(false);
        !(typeof reactFlightPayloadDeserializer === "function") && $aaXwj(false);
        if (reactFlightPayload.errors.length > 0) {
            if (typeof this._reactFlightServerErrorHandler === "function") this._reactFlightServerErrorHandler(reactFlightPayload.status, reactFlightPayload.errors);
        }
        var reactFlightID = $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), $c1c190f56a797e52$var$getStorageKey(selection, this._variables));
        var reactFlightClientResponseRecord = this._recordSource.get(reactFlightID);
        if (reactFlightClientResponseRecord == null) {
            reactFlightClientResponseRecord = $iEVza.create(reactFlightID, $c1c190f56a797e52$var$REACT_FLIGHT_TYPE_NAME);
            this._recordSource.set(reactFlightID, reactFlightClientResponseRecord);
        }
        if (reactFlightPayload.tree == null) {
            // We create the flight record with a null value for the tree
            // and empty reachable definitions
            $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_TREE_STORAGE_KEY, null);
            $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY, []);
            $iEVza.setLinkedRecordID(record, storageKey, reactFlightID);
            return;
        }
        // We store the deserialized reactFlightClientResponse in a separate
        // record and link it to the parent record. This is so we can GC the Flight
        // tree later even if the parent record is still reachable.
        var reactFlightClientResponse = reactFlightPayloadDeserializer(reactFlightPayload.tree);
        $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_TREE_STORAGE_KEY, reactFlightClientResponse);
        var reachableExecutableDefinitions = [];
        var _iterator2 = (0, $c1c190f56a797e52$var$_createForOfIteratorHelper2["default"])(reactFlightPayload.queries), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var query = _step2.value;
                if (query.response.data != null) this._followupPayloads.push({
                    kind: "ModuleImportPayload",
                    args: null,
                    data: query.response.data,
                    dataID: $c1c190f56a797e52$var$ROOT_ID,
                    operationReference: query.module,
                    path: [],
                    typeName: $c1c190f56a797e52$var$ROOT_TYPE,
                    variables: query.variables,
                    actorIdentifier: this._actorIdentifier
                });
                reachableExecutableDefinitions.push({
                    module: query.module,
                    variables: query.variables
                });
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        var _iterator3 = (0, $c1c190f56a797e52$var$_createForOfIteratorHelper2["default"])(reactFlightPayload.fragments), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var fragment = _step3.value;
                if (fragment.response.data != null) this._followupPayloads.push({
                    kind: "ModuleImportPayload",
                    args: null,
                    data: fragment.response.data,
                    dataID: fragment.__id,
                    operationReference: fragment.module,
                    path: [],
                    typeName: fragment.__typename,
                    variables: fragment.variables,
                    actorIdentifier: this._actorIdentifier
                });
                reachableExecutableDefinitions.push({
                    module: fragment.module,
                    variables: fragment.variables
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY, reachableExecutableDefinitions);
        $iEVza.setLinkedRecordID(record, storageKey, reactFlightID);
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === "object" && fieldValue) && $aaXwj(false);
        var nextID = this._getDataId(// $FlowFixMe[incompatible-variance]
        fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || // Reuse previously generated client IDs
        $iEVza.getLinkedRecordID(record, storageKey) || $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), storageKey);
        !(typeof nextID === "string") && $aaXwj(false);
        $iEVza.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            // $FlowFixMe[incompatible-variance]
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $iEVza.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        // $FlowFixMe[incompatible-variance]
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $aaXwj(false);
        var prevIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            // validate response data
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            !(typeof item === "object") && $aaXwj(false);
            var nextID = _this._getDataId(// $FlowFixMe[incompatible-variance]
            item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || // Reuse previously generated client IDs:
            $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === "string") && $aaXwj(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                // $FlowFixMe[incompatible-variance]
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $iEVza.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            // $FlowFixMe[incompatible-variance]
            _this._traverseSelections(field, nextRecord, item);
            _this._path.pop();
        });
        $iEVza.setLinkedRecordIDs(record, storageKey, nextIDs);
    } /**
   * Warns if the type of the record does not match the type of the field/payload.
   */ ;
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $iEVza.getDataID(record);
    } /**
   * Warns if a single response contains conflicting fields with the same id
   */ ;
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    } /**
   * Warns if a single response contains conflicting fields with the same id
   */ ;
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(record, prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $c1c190f56a797e52$var$normalize
};

});
parcelRegister("5hGP9", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME = "actor_key";

var $lbx0y = parcelRequire("lbx0y");
var $3d8fc23a57d7fcd6$var$getActorIdentifier = $lbx0y.getActorIdentifier;
function $3d8fc23a57d7fcd6$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === "object" && typeof payload[$3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME] === "string") return $3d8fc23a57d7fcd6$var$getActorIdentifier(payload[$3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $3d8fc23a57d7fcd6$var$getActorIdentifierFromPayload
};

});

parcelRegister("53GBi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");
var $3aee472679212327$var$getType = $iEVza.getType;

var $aaXwj = parcelRequire("aaXwj");
// Reachable (client) executable definitions encountered while server component
// rendering
var $3aee472679212327$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY = "executableDefinitions";
var $3aee472679212327$var$REACT_FLIGHT_TREE_STORAGE_KEY = "tree";
var $3aee472679212327$var$REACT_FLIGHT_TYPE_NAME = "ReactFlightComponent";
function $3aee472679212327$var$refineToReactFlightPayloadData(payload) {
    if (payload == null || typeof payload !== "object" || typeof payload.status !== "string" || !Array.isArray(payload.tree) && payload.tree !== null || !Array.isArray(payload.queries) || !Array.isArray(payload.fragments) || !Array.isArray(payload.errors)) return null;
    return payload;
}
function $3aee472679212327$var$getReactFlightClientResponse(record) {
    !($3aee472679212327$var$getType(record) === $3aee472679212327$var$REACT_FLIGHT_TYPE_NAME) && $aaXwj(false);
    return record[$3aee472679212327$var$REACT_FLIGHT_TREE_STORAGE_KEY];
}
module.exports = {
    REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY: $3aee472679212327$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY,
    REACT_FLIGHT_TREE_STORAGE_KEY: $3aee472679212327$var$REACT_FLIGHT_TREE_STORAGE_KEY,
    REACT_FLIGHT_TYPE_NAME: $3aee472679212327$var$REACT_FLIGHT_TYPE_NAME,
    getReactFlightClientResponse: $3aee472679212327$var$getReactFlightClientResponse,
    refineToReactFlightPayloadData: $3aee472679212327$var$refineToReactFlightPayloadData
};

});

parcelRegister("kRPAW", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $f310c78a7436bcf6$var$PREFIX = "client:__type:";
var $f310c78a7436bcf6$var$TYPE_SCHEMA_TYPE = "__TypeSchema";
function $f310c78a7436bcf6$var$generateTypeID(typeName) {
    return $f310c78a7436bcf6$var$PREFIX + typeName;
}
function $f310c78a7436bcf6$var$isTypeID(id) {
    return id.indexOf($f310c78a7436bcf6$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $f310c78a7436bcf6$var$generateTypeID,
    isTypeID: $f310c78a7436bcf6$var$isTypeID,
    TYPE_SCHEMA_TYPE: $f310c78a7436bcf6$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("kkibE", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $ecc3c86f01f852a8$var$_global$ErrorUtils$ap, $ecc3c86f01f852a8$var$_global$ErrorUtils;

var $2Zzcm = parcelRequire("2Zzcm");

var $RmER8 = parcelRequire("RmER8");

var $h9Hf6 = parcelRequire("h9Hf6");

var $5WA3P = parcelRequire("5WA3P");

var $L6WFS = parcelRequire("L6WFS");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $ecc3c86f01f852a8$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : undefined;
var $ecc3c86f01f852a8$var$applyWithGuard = ($ecc3c86f01f852a8$var$_global$ErrorUtils$ap = $ecc3c86f01f852a8$var$_global === null || $ecc3c86f01f852a8$var$_global === void 0 ? void 0 : ($ecc3c86f01f852a8$var$_global$ErrorUtils = $ecc3c86f01f852a8$var$_global.ErrorUtils) === null || $ecc3c86f01f852a8$var$_global$ErrorUtils === void 0 ? void 0 : $ecc3c86f01f852a8$var$_global$ErrorUtils.applyWithGuard) !== null && $ecc3c86f01f852a8$var$_global$ErrorUtils$ap !== void 0 ? $ecc3c86f01f852a8$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
/**
 * Coordinates the concurrent modification of a `Store` due to optimistic and
 * non-revertable client updates and server payloads:
 * - Applies optimistic updates.
 * - Reverts optimistic updates, rebasing any subsequent updates.
 * - Commits client updates (typically for client schema extensions).
 * - Commits server updates:
 *   - Normalizes query/mutation/subscription responses.
 *   - Executes handlers for "handle" fields.
 *   - Reverts and reapplies pending optimistic updates.
 */ var $ecc3c86f01f852a8$var$RelayPublishQueue = /*#__PURE__*/ function() {
    // True if the next `run()` should apply the backup and rerun all optimistic
    // updates performing a rebase.
    // Payloads to apply or Sources to publish to the store with the next `run()`.
    // $FlowFixMe[unclear-type] See explanation below.
    // Optimistic updaters to add with the next `run()`.
    // $FlowFixMe[unclear-type] See explanation below.
    // Optimistic updaters that are already added and might be rerun in order to
    // rebase them.
    // $FlowFixMe[unclear-type] See explanation below.
    // For _pendingOptimisticUpdates, _appliedOptimisticUpdates, and _pendingData,
    // we want to parametrize by "any" since the type is effectively
    // "the union of all T's that PublishQueue's methods were called with".
    // Garbage collection hold, should rerun gc on dispose
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    /**
   * Schedule applying an optimistic updates on the next `run()`.
   */ var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $aaXwj(false);
        this._pendingOptimisticUpdates.add(updater);
    } /**
   * Schedule reverting an optimistic updates on the next `run()`.
   */ ;
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) // Reverted before it was applied
        this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    } /**
   * Schedule a revert of all optimistic updates on the next `run()`.
   */ ;
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    } /**
   * Schedule applying a payload to the store on the next `run()`.
   */ ;
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "payload",
            operation: operation,
            payload: payload,
            updater: updater
        });
    } /**
   * Schedule an updater to mutate the store on the next `run()` typically to
   * update client schema fields.
   */ ;
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "updater",
            updater: updater
        });
    } /**
   * Schedule a publish to the store from the provided source on the next
   * `run()`. As an example, to update the store with substituted fields that
   * are missing in the store.
   */ ;
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "source",
            source: source
        });
    } /**
   * Execute all queued up operations from the other public methods.
   */ ;
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = // this._pendingBackupRebase is true if an applied optimistic
        // update has potentially been reverted or if this._pendingData is not empty.
        !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    } /**
   * _publishSourceFromPayload will return a boolean indicating if the
   * publish caused the store to be globally invalidated.
   */ ;
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $2Zzcm(this._store.getSource(), source);
        var recordSourceProxy = new $RmER8(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aaXwj(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $aaXwj(false);
            var recordSourceSelectorProxy = new $h9Hf6(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $ecc3c86f01f852a8$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    } /**
   * _commitData will return a boolean indicating if any of
   * the pending commits caused the store to be globally invalidated.
   */ ;
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === "payload") {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === "source") {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $L6WFS.create();
                var mutator = new $2Zzcm(_this2._store.getSource(), sink);
                var recordSourceProxy = new $RmER8(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $ecc3c86f01f852a8$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, "RelayPublishQueue:commitData");
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    } /**
   * Note that unlike _commitData, _applyUpdates will NOT return a boolean
   * indicating if the store was globally invalidated, since invalidating the
   * store during an optimistic update is a no-op.
   */ ;
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $L6WFS.create();
        var mutator = new $2Zzcm(this._store.getSource(), sink);
        var recordSourceProxy = new $RmER8(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        // $FlowFixMe[unclear-type] see explanation above.
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $ecc3c86f01f852a8$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, "RelayPublishQueue:applyUpdates");
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $ecc3c86f01f852a8$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $h9Hf6(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $ecc3c86f01f852a8$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, "RelayPublishQueue:applyUpdates");
                }
            }
        };
        // rerun all updaters in case we are running a rebase
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        // apply any new updaters
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $ecc3c86f01f852a8$var$lookupSelector(source, selector) {
    var selectorData = $5WA3P.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $ecc3c86f01f852a8$var$RelayPublishQueue;

});
parcelRegister("2Zzcm", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");

var $bZtyP = parcelRequire("bZtyP");
var $22dc94f00d1a854e$var$EXISTENT = $bZtyP.EXISTENT;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * Wrapper API that is an amalgam of the `RelayModernRecord` API and
 * `MutableRecordSource` interface, implementing copy-on-write semantics for records
 * in a record source.
 *
 * Modifications are applied to fresh copies of records:
 * - Records in `base` are never modified.
 * - Modifications cause a fresh version of a record to be created in `sink`.
 *   These sink records contain only modified fields.
 */ var $22dc94f00d1a854e$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    /**
   * **UNSTABLE**
   * This method is likely to be removed in an upcoming release
   * and should not be relied upon.
   * TODO T41593196: Remove unstable_getRawRecordWithChanges
   */ var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $iEVza.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $iEVza.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $iEVza.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $aaXwj(false);
            sinkRecord = $iEVza.create(dataID, $iEVza.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $aaXwj(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $iEVza.copyFields(baseSource, sink);
        if (sinkSource) $iEVza.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $iEVza.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $22dc94f00d1a854e$var$EXISTENT && this._sink.getStatus(dataID) !== $22dc94f00d1a854e$var$EXISTENT) && $aaXwj(false);
        var record = $iEVza.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $iEVza.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $iEVza.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iEVza.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iEVza.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iEVza.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $22dc94f00d1a854e$var$RelayRecordSourceMutator;

});

parcelRegister("RmER8", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");

var $bZtyP = parcelRequire("bZtyP");
var $0a0686c092d9048b$var$EXISTENT = $bZtyP.EXISTENT, $0a0686c092d9048b$var$NONEXISTENT = $bZtyP.NONEXISTENT;

var $5DrBw = parcelRequire("5DrBw");
var $0a0686c092d9048b$var$ROOT_ID = $5DrBw.ROOT_ID, $0a0686c092d9048b$var$ROOT_TYPE = $5DrBw.ROOT_TYPE;

var $drJF0 = parcelRequire("drJF0");
var $0a0686c092d9048b$var$_readUpdatableFragment = $drJF0.readUpdatableFragment;

var $ah1KR = parcelRequire("ah1KR");
var $0a0686c092d9048b$var$_readUpdatableQuery = $ah1KR.readUpdatableQuery;

var $1ZqjF = parcelRequire("1ZqjF");

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * A helper for manipulating a `RecordSource` via an imperative/OO-style API.
 */ var $0a0686c092d9048b$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $0a0686c092d9048b$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $0a0686c092d9048b$var$EXISTENT) _this.create(dataID, $iEVza.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $0a0686c092d9048b$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aaXwj(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        // For flow
        !record && $aaXwj(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $0a0686c092d9048b$var$ROOT_ID) && $aaXwj(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $0a0686c092d9048b$var$EXISTENT) this._proxies[dataID] = new $1ZqjF(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $0a0686c092d9048b$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($0a0686c092d9048b$var$ROOT_ID);
        if (!root) root = this.create($0a0686c092d9048b$var$ROOT_ID, $0a0686c092d9048b$var$ROOT_TYPE);
        !(root && root.getType() === $0a0686c092d9048b$var$ROOT_TYPE) && $aaXwj(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $0a0686c092d9048b$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $0a0686c092d9048b$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $0a0686c092d9048b$var$RelayRecordSourceProxy;

});
parcelRegister("drJF0", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $9ca1372eb2f8e38b$var$getFragment = $aW0zg.getFragment;

var $idJ2w = parcelRequire("idJ2w");
var $9ca1372eb2f8e38b$var$getVariablesFromFragment = $idJ2w.getVariablesFromFragment;

var $5DrBw = parcelRequire("5DrBw");
var $9ca1372eb2f8e38b$var$ID_KEY = $5DrBw.ID_KEY;

var $9hh34 = parcelRequire("9hh34");
var $9ca1372eb2f8e38b$var$createUpdatableProxy = $9hh34.createUpdatableProxy;

var $aaXwj = parcelRequire("aaXwj");
// Note: plural fragment references are currently not supported
function $9ca1372eb2f8e38b$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $9ca1372eb2f8e38b$var$getFragment(fragment);
    var fragmentVariables = $9ca1372eb2f8e38b$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    // $FlowFixMe[prop-missing] it's there, we just don't include it in the type
    var id = fragmentReference[$9ca1372eb2f8e38b$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $aaXwj(false);
    return {
        // $FlowFixMe[incompatible-call]
        updatableData: $9ca1372eb2f8e38b$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $9ca1372eb2f8e38b$var$readUpdatableFragment
};

});
parcelRegister("9hh34", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $6c12ed122216a4ab$var$_interopRequireDefault = $1jnue.default;

var $6c12ed122216a4ab$var$_createForOfIteratorHelper2 = $6c12ed122216a4ab$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $5DrBw = parcelRequire("5DrBw");
var $6c12ed122216a4ab$var$getArgumentValues = $5DrBw.getArgumentValues;

var $84X73 = parcelRequire("84X73");
var $6c12ed122216a4ab$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $6c12ed122216a4ab$var$ALIASED_FRAGMENT_SPREAD = $84X73.ALIASED_FRAGMENT_SPREAD, $6c12ed122216a4ab$var$ALIASED_INLINE_FRAGMENT_SPREAD = $84X73.ALIASED_INLINE_FRAGMENT_SPREAD, $6c12ed122216a4ab$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $6c12ed122216a4ab$var$CLIENT_EDGE_TO_SERVER_OBJECT = $84X73.CLIENT_EDGE_TO_SERVER_OBJECT, $6c12ed122216a4ab$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $6c12ed122216a4ab$var$CONDITION = $84X73.CONDITION, $6c12ed122216a4ab$var$DEFER = $84X73.DEFER, $6c12ed122216a4ab$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $6c12ed122216a4ab$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $6c12ed122216a4ab$var$INLINE_DATA_FRAGMENT_SPREAD = $84X73.INLINE_DATA_FRAGMENT_SPREAD, $6c12ed122216a4ab$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $6c12ed122216a4ab$var$LINKED_FIELD = $84X73.LINKED_FIELD, $6c12ed122216a4ab$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $6c12ed122216a4ab$var$RELAY_LIVE_RESOLVER = $84X73.RELAY_LIVE_RESOLVER, $6c12ed122216a4ab$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $6c12ed122216a4ab$var$REQUIRED_FIELD = $84X73.REQUIRED_FIELD, $6c12ed122216a4ab$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $6c12ed122216a4ab$var$STREAM = $84X73.STREAM;
var $6c12ed122216a4ab$var$nonUpdatableKeys = [
    "id",
    "__id",
    "__typename",
    "js"
];
function $6c12ed122216a4ab$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    // unless ReaderSelection carries more type information, we will never be able
    // to flowtype mutableUpdatableProxy without a type assertion.
    // $FlowFixMe[unclear-type]
    return mutableUpdatableProxy;
}
function $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $6c12ed122216a4ab$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $6c12ed122216a4ab$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $6c12ed122216a4ab$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $6c12ed122216a4ab$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $6c12ed122216a4ab$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $6c12ed122216a4ab$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            // Flow incorrect assumes that the return value for the get method must match
                            // the set parameter.
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $6c12ed122216a4ab$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $6c12ed122216a4ab$var$nonUpdatableKeys.includes(selection.name) ? undefined : // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
                        function(newValue) {
                            var _selection$args2;
                            var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            // $FlowFixMe[prop-missing] Typesafe updaters should prevent people from using untyped values
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $6c12ed122216a4ab$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $6c12ed122216a4ab$var$CLIENT_EXTENSION:
                    $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $6c12ed122216a4ab$var$FRAGMENT_SPREAD:
                    break;
                case $6c12ed122216a4ab$var$CONDITION:
                case $6c12ed122216a4ab$var$ACTOR_CHANGE:
                case $6c12ed122216a4ab$var$ALIASED_FRAGMENT_SPREAD:
                case $6c12ed122216a4ab$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $6c12ed122216a4ab$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $6c12ed122216a4ab$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $6c12ed122216a4ab$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $6c12ed122216a4ab$var$DEFER:
                case $6c12ed122216a4ab$var$FLIGHT_FIELD:
                case $6c12ed122216a4ab$var$MODULE_IMPORT:
                case $6c12ed122216a4ab$var$RELAY_LIVE_RESOLVER:
                case $6c12ed122216a4ab$var$REQUIRED_FIELD:
                case $6c12ed122216a4ab$var$STREAM:
                case $6c12ed122216a4ab$var$RELAY_RESOLVER:
                    // These types of reader nodes are not currently handled.
                    throw new Error("Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.");
                default:
                    selection.kind;
                    throw new Error("Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.");
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $6c12ed122216a4ab$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error("Do not assign null to plural linked fields; assign an empty array instead.");
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error("When assigning an array of items, none of the items should be null or undefined.");
                var __id = item.__id;
                if (__id == null) throw new Error("The __id field must be present on each item passed to the setter. This indicates a bug in Relay.");
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $6c12ed122216a4ab$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error("The __id field must be present on the argument. This indicates a bug in Relay.");
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $6c12ed122216a4ab$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $6c12ed122216a4ab$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $6c12ed122216a4ab$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                // Flow incorrect assumes that the return value for the get method must match
                // the set parameter.
                // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
                return updatableProxy;
            } else return linkedRecord;
        // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
        });
        else return linkedRecords;
    };
}
function $6c12ed122216a4ab$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $6c12ed122216a4ab$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $6c12ed122216a4ab$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            // Flow incorrect assumes that the return value for the get method must match
            // the set parameter.
            // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $6c12ed122216a4ab$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === "linked") {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $6c12ed122216a4ab$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === "pluralLinked") {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $6c12ed122216a4ab$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === "scalar") {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $6c12ed122216a4ab$var$createUpdatableProxy
};

});


parcelRegister("ah1KR", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $77acda5d157b1b63$var$getUpdatableQuery = $aW0zg.getUpdatableQuery;

var $9hh34 = parcelRequire("9hh34");
var $77acda5d157b1b63$var$createUpdatableProxy = $9hh34.createUpdatableProxy;
function $77acda5d157b1b63$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $77acda5d157b1b63$var$getUpdatableQuery(query);
    return {
        // $FlowFixMe[incompatible-call]
        updatableData: $77acda5d157b1b63$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $77acda5d157b1b63$var$readUpdatableQuery
};

});

parcelRegister("1ZqjF", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $i2E13 = parcelRequire("i2E13");
var $172fe6c8479de1a6$var$generateClientID = $i2E13.generateClientID;

var $5DrBw = parcelRequire("5DrBw");
var $172fe6c8479de1a6$var$getStableStorageKey = $5DrBw.getStableStorageKey;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * A helper class for manipulating a given record from a record source via an
 * imperative/OO-style API.
 */ var $172fe6c8479de1a6$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $aaXwj(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$172fe6c8479de1a6$var$isValidLeafValue(value) && $aaXwj(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $aaXwj(false);
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
            var clientID = $172fe6c8479de1a6$var$generateClientID(this.getDataID(), storageKey);
            // NOTE: it's possible that a client record for this field exists
            // but the field itself was unset.
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $aaXwj(false);
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $172fe6c8479de1a6$var$isValidLeafValue(value) {
    return value == null || typeof value !== "object" || Array.isArray(value) && value.every($172fe6c8479de1a6$var$isValidLeafValue);
}
module.exports = $172fe6c8479de1a6$var$RelayRecordProxy;

});


parcelRegister("h9Hf6", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $5DrBw = parcelRequire("5DrBw");
var $c7d4d200cf928b69$var$ROOT_TYPE = $5DrBw.ROOT_TYPE, $c7d4d200cf928b69$var$getStorageKey = $5DrBw.getStorageKey;

var $drJF0 = parcelRequire("drJF0");
var $c7d4d200cf928b69$var$_readUpdatableFragment = $drJF0.readUpdatableFragment;

var $ah1KR = parcelRequire("ah1KR");
var $c7d4d200cf928b69$var$_readUpdatableQuery = $ah1KR.readUpdatableQuery;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * A subclass of RecordSourceProxy that provides convenience methods for
 * accessing the root fields of a given query/mutation. These fields accept
 * complex arguments and it can be tedious to re-construct the correct sets of
 * arguments to pass to e.g. `getRoot().getLinkedRecord()`.
 */ var $c7d4d200cf928b69$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $c7d4d200cf928b69$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === "LinkedField" && selection.name === fieldName || selection.kind === "RequiredField" && selection.field.name === fieldName;
        });
        if (field && field.kind === "RequiredField") field = field.field;
        !(field && field.kind === "LinkedField") && $aaXwj(false);
        !(field.plural === plural) && $aaXwj(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $c7d4d200cf928b69$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $c7d4d200cf928b69$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $c7d4d200cf928b69$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $c7d4d200cf928b69$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $c7d4d200cf928b69$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("5WA3P", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $453e576ecc8ee4b3$var$_interopRequireDefault = $1jnue.default;

var $453e576ecc8ee4b3$var$_createForOfIteratorHelper2 = $453e576ecc8ee4b3$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $453e576ecc8ee4b3$var$_defineProperty2 = $453e576ecc8ee4b3$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $453e576ecc8ee4b3$var$_toConsumableArray2 = $453e576ecc8ee4b3$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $84X73 = parcelRequire("84X73");
var $453e576ecc8ee4b3$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $453e576ecc8ee4b3$var$ALIASED_FRAGMENT_SPREAD = $84X73.ALIASED_FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$ALIASED_INLINE_FRAGMENT_SPREAD = $84X73.ALIASED_INLINE_FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_SERVER_OBJECT = $84X73.CLIENT_EDGE_TO_SERVER_OBJECT, $453e576ecc8ee4b3$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $453e576ecc8ee4b3$var$CONDITION = $84X73.CONDITION, $453e576ecc8ee4b3$var$DEFER = $84X73.DEFER, $453e576ecc8ee4b3$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $453e576ecc8ee4b3$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$INLINE_DATA_FRAGMENT_SPREAD = $84X73.INLINE_DATA_FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $453e576ecc8ee4b3$var$LINKED_FIELD = $84X73.LINKED_FIELD, $453e576ecc8ee4b3$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $453e576ecc8ee4b3$var$RELAY_LIVE_RESOLVER = $84X73.RELAY_LIVE_RESOLVER, $453e576ecc8ee4b3$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $453e576ecc8ee4b3$var$REQUIRED_FIELD = $84X73.REQUIRED_FIELD, $453e576ecc8ee4b3$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $453e576ecc8ee4b3$var$STREAM = $84X73.STREAM;

var $dsOUI = parcelRequire("dsOUI");

var $l1FnP = parcelRequire("l1FnP");
var $453e576ecc8ee4b3$var$isSuspenseSentinel = $l1FnP.isSuspenseSentinel;

var $fkd0X = parcelRequire("fkd0X");

var $iEVza = parcelRequire("iEVza");

var $53GBi = parcelRequire("53GBi");
var $453e576ecc8ee4b3$var$getReactFlightClientResponse = $53GBi.getReactFlightClientResponse;

var $5DrBw = parcelRequire("5DrBw");
var $453e576ecc8ee4b3$var$CLIENT_EDGE_TRAVERSAL_PATH = $5DrBw.CLIENT_EDGE_TRAVERSAL_PATH, $453e576ecc8ee4b3$var$FRAGMENT_OWNER_KEY = $5DrBw.FRAGMENT_OWNER_KEY, $453e576ecc8ee4b3$var$FRAGMENT_PROP_NAME_KEY = $5DrBw.FRAGMENT_PROP_NAME_KEY, $453e576ecc8ee4b3$var$FRAGMENTS_KEY = $5DrBw.FRAGMENTS_KEY, $453e576ecc8ee4b3$var$ID_KEY = $5DrBw.ID_KEY, $453e576ecc8ee4b3$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $5DrBw.IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $453e576ecc8ee4b3$var$MODULE_COMPONENT_KEY = $5DrBw.MODULE_COMPONENT_KEY, $453e576ecc8ee4b3$var$ROOT_ID = $5DrBw.ROOT_ID, $453e576ecc8ee4b3$var$getArgumentValues = $5DrBw.getArgumentValues, $453e576ecc8ee4b3$var$getModuleComponentKey = $5DrBw.getModuleComponentKey, $453e576ecc8ee4b3$var$getStorageKey = $5DrBw.getStorageKey;

var $5wZNL = parcelRequire("5wZNL");
var $453e576ecc8ee4b3$var$NoopResolverCache = $5wZNL.NoopResolverCache;

var $5o6zS = parcelRequire("5o6zS");
var $453e576ecc8ee4b3$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $5o6zS.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $453e576ecc8ee4b3$var$withResolverContext = $5o6zS.withResolverContext;

var $kRPAW = parcelRequire("kRPAW");
var $453e576ecc8ee4b3$var$generateTypeID = $kRPAW.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
function $453e576ecc8ee4b3$var$read(recordSource, selector, resolverCache) {
    var reader = new $453e576ecc8ee4b3$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $453e576ecc8ee4b3$var$NoopResolverCache());
    return reader.read();
}
/**
 * @private
 */ var $453e576ecc8ee4b3$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = $dsOUI.ENABLE_CLIENT_EDGES && (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        // Relay historically allowed child fragments to be read even if the root object
        // did not match the type of the fragment: either the root object has a different
        // concrete type than the fragment (for concrete fragments) or the root object does
        // not conform to the interface/union for abstract fragments.
        // For suspense purposes, however, we want to accurately compute whether any data
        // is missing: but if the fragment type doesn't match (or a parent type didn't
        // match), then no data is expected to be present.
        // By default data is expected to be present unless this selector was read out
        // from within a non-matching type refinement in a parent fragment:
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        // If this is a concrete fragment and the concrete type of the record does not
        // match, then no data is expected to be present.
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $iEVza.getType(record);
            if (recordType !== node.type && // The root record type is a special `__Root` type and may not match the
            // type on the ast, so ignore type mismatches at the root.
            // We currently detect whether we're at the root by checking against ROOT_ID,
            // but this does not work for mutations/subscriptions which generate unique
            // root ids. This is acceptable in practice as we don't read data for mutations/
            // subscriptions in a situation where we would use isMissingData to decide whether
            // to suspend or not.
            // TODO T96653810: Correctly detect reading from root of mutation/subscription
            dataID !== $453e576ecc8ee4b3$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        // If this is an abstract fragment (and the precise refinement GK is enabled)
        // then data is only expected to be present if the record type is known to
        // implement the interface. If we aren't sure whether the record implements
        // the interface, that itself constitutes "expected" data being missing.
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) // Type known to not implement the interface
            isDataExpectedToBePresent = false;
            else if (implementsInterface == null) // Don't know if the type implements the interface or not
            this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: $dsOUI.ENABLE_CLIENT_EDGES && this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors
        };
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if ($dsOUI.ENABLE_CLIENT_EDGES && this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            // Top can be null if we've traversed past a client edge into an ordinary
            // client extension field; we never want to fetch in response to missing
            // data off of a client extension field.
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action, _record) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === "THROW") // Chained @required directives may cause a parent `@required(action:
        // THROW)` field to become null, so the first missing field we
        // encounter is likely to be the root cause of the error.
        return;
        var owner = this._fragmentName;
        switch(action){
            case "THROW":
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case "LOG":
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) /* had all expected data */ {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $453e576ecc8ee4b3$var$REQUIRED_FIELD:
                    var fieldValue = this._readRequiredField(selection, record, data);
                    if (fieldValue == null) {
                        var action = selection.action;
                        if (action !== "NONE") this._maybeReportUnexpectedNull(selection.path, action, record);
                        // We are going to throw, or our parent is going to get nulled out.
                        // Either way, sibling values are going to be ignored, so we can
                        // bail early here as an optimization.
                        return false;
                    }
                    break;
                case $453e576ecc8ee4b3$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $453e576ecc8ee4b3$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $453e576ecc8ee4b3$var$RELAY_LIVE_RESOLVER:
                case $453e576ecc8ee4b3$var$RELAY_RESOLVER:
                    if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                    this._readResolverField(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $453e576ecc8ee4b3$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var _fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (_fieldValue === false) _fieldValue = null;
                    data[selection.name] = _fieldValue;
                    break;
                case $453e576ecc8ee4b3$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$DEFER:
                case $453e576ecc8ee4b3$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    if ($dsOUI.ENABLE_CLIENT_EDGES) this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    // The only case where we want to suspend due to missing data off of
                    // a client extension is if we reached a client edge that we might be
                    // able to fetch, or there is a missing data in one of the live resolvers.
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    if ($dsOUI.ENABLE_CLIENT_EDGES) this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $453e576ecc8ee4b3$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $453e576ecc8ee4b3$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) this._readFlightField(selection, record, data);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $453e576ecc8ee4b3$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    if ($dsOUI.ENABLE_CLIENT_EDGES) this._readClientEdge(selection, record, data);
                    else throw new Error("Client edges are not yet supported.");
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        }
        return true;
    };
    _proto._readRequiredField = function _readRequiredField(selection, record, data) {
        switch(selection.field.kind){
            case $453e576ecc8ee4b3$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $453e576ecc8ee4b3$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $453e576ecc8ee4b3$var$RELAY_RESOLVER:
                if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                return this._readResolverField(selection.field, record, data);
            case $453e576ecc8ee4b3$var$RELAY_LIVE_RESOLVER:
                if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                return this._readResolverField(selection.field, record, data);
            case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $aaXwj(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _this = this;
        var _field$alias;
        var fragment = field.fragment;
        var parentRecordID = $iEVza.getDataID(record);
        // Found when reading the resolver fragment, which can happen either when
        // evaluating the resolver and it calls readFragment, or when checking if the
        // inputs have changed since a previous evaluation:
        var snapshot;
        // The function `getDataForResolverFragment` serves two purposes:
        // 1. To memoize reads of the resolver's root fragment. This is important
        //    because we may read it twice. Once to check if the results have changed
        //    since last read, and once when we actually evaluate.
        // 2. To intercept the snapshot so that it can be cached by the resolver
        //    cache. This is what enables the change detection described in #1.
        //
        // Note: In the future this can be moved into the ResolverCache.
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) // It was already read when checking for input staleness; no need to read it again.
            // Note that the variables like fragmentSeenRecordIDs in the outer closure will have
            // already been set and will still be used in this case.
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $453e576ecc8ee4b3$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        // This function `evaluate` tells the resolver cache how to read this
        // resolver. It returns an `EvaluationResult` which gives the resolver cache:
        // * `resolverResult` The value returned by the resolver function
        // * `snapshot` The snapshot returned when reading the resolver's root fragment (if it has one)
        // * `error` If the resolver throws, its error is caught (inside
        //   `getResolverValue`) and converted into an error object.
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $453e576ecc8ee4b3$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $453e576ecc8ee4b3$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $453e576ecc8ee4b3$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $453e576ecc8ee4b3$var$getResolverValue(field, _this._variables, key, _this._fragmentName), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $453e576ecc8ee4b3$var$getResolverValue(field, _this._variables, null, _this._fragmentName), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        // The resolver's root fragment (if there is one) may be missing data, have
        // errors, or be in a suspended state. Here we propagate those cases
        // upwards to mimic the behavior of having traversed into that fragment directly.
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var missing = _step.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator2 = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missingResolverField = _step2.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            var _iterator3 = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var error = _step3.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        // If the resolver errored, we track that as part of our traversal so that
        // the errors can be attached to this read's snapshot. This allows the error
        // to be logged.
        if (resolverError) this._resolverErrors.push(resolverError);
        // The resolver itself creates a record in the store. We record that we've
        // read this record so that subscribers to this snapshot also subscribe to
        // this resolver.
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        // If this resolver, or a dependency of this resolver, has suspended, we
        // need to report that in our snapshot. The `suspenseID` is the key in to
        // store where the suspended LiveState value lives. This ID allows readers
        // of the snapshot to subscribe to updates on that live resolver so that
        // they know when to unsuspend.
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(field.path),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator4 = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var recordID = _step4.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
        var applicationName = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        data[applicationName] = result;
        return result;
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _backingField$alias;
        var backingField = field.backingField;
        // Because ReaderClientExtension doesn't have `alias` or `name` and so I don't know
        // how to get its applicationName or storageKey yet:
        !(backingField.kind !== "ClientExtension") && $aaXwj(false);
        var applicationName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        // At this point, backingFieldData is an object with a single key (applicationName)
        // whose value is the value returned from the resolver, or a suspense sentinel.
        var clientEdgeResolverResponse = backingFieldData[applicationName];
        if (clientEdgeResolverResponse == null || $453e576ecc8ee4b3$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[applicationName] = clientEdgeResolverResponse;
            return;
        }
        var validClientEdgeResolverResponse = $453e576ecc8ee4b3$var$assertValidClientEdgeResolverResponse(field, clientEdgeResolverResponse);
        switch(validClientEdgeResolverResponse.kind){
            case "PluralConcrete":
                var storeIDs = $453e576ecc8ee4b3$var$getStoreIDsForPluralClientEdgeResolver(field, validClientEdgeResolverResponse.ids, this._resolverCache);
                this._clientEdgeTraversalPath.push(null);
                data[applicationName] = this._readLinkedIds(field.linkedField, storeIDs, record, data);
                this._clientEdgeTraversalPath.pop();
                break;
            case "SingularConcrete":
                var _getStoreIDAndTravers = $453e576ecc8ee4b3$var$getStoreIDAndTraversalPathSegmentForSingularClientEdgeResolver(field, validClientEdgeResolverResponse.id, this._resolverCache), storeID = _getStoreIDAndTravers[0], traversalPathSegment = _getStoreIDAndTravers[1];
                this._clientEdgeTraversalPath.push(traversalPathSegment);
                var prevData = data[applicationName];
                !(prevData == null || typeof prevData === "object") && $aaXwj(false);
                data[applicationName] = this._traverse(field.linkedField, storeID, // $FlowFixMe[incompatible-variance]
                prevData);
                this._clientEdgeTraversalPath.pop();
                break;
            default:
                validClientEdgeResolverResponse.kind;
        }
    };
    _proto._readFlightField = function _readFlightField(field, record, data) {
        var _field$alias2;
        var applicationName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var reactFlightClientResponseRecordID = $iEVza.getLinkedRecordID(record, storageKey);
        if (reactFlightClientResponseRecordID == null) {
            data[applicationName] = reactFlightClientResponseRecordID;
            if (reactFlightClientResponseRecordID === undefined) this._markDataAsMissing();
            return reactFlightClientResponseRecordID;
        }
        var reactFlightClientResponseRecord = this._recordSource.get(reactFlightClientResponseRecordID);
        this._seenRecords.add(reactFlightClientResponseRecordID);
        if (reactFlightClientResponseRecord == null) {
            data[applicationName] = reactFlightClientResponseRecord;
            if (reactFlightClientResponseRecord === undefined) this._markDataAsMissing();
            return reactFlightClientResponseRecord;
        }
        var clientResponse = $453e576ecc8ee4b3$var$getReactFlightClientResponse(reactFlightClientResponseRecord);
        data[applicationName] = clientResponse;
        return clientResponse;
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var applicationName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var value = $iEVza.getValue(record, storageKey);
        if (value === undefined) this._markDataAsMissing();
        data[applicationName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var applicationName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[applicationName] = linkedID;
            if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[applicationName];
        !(prevData == null || typeof prevData === "object") && $aaXwj(false);
        // $FlowFixMe[incompatible-variance]
        var value = this._traverse(field, linkedID, prevData);
        data[applicationName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var applicationName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var externalRef = $iEVza.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[applicationName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            return data[applicationName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, {
            __id: dataID
        }, fragmentRef);
        data[applicationName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[applicationName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var linkedIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this2 = this;
        var _field$alias6;
        var applicationName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[applicationName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[applicationName];
        !(prevData == null || Array.isArray(prevData)) && $aaXwj(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this2._markDataAsMissing();
                // $FlowFixMe[cannot-write]
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === "object") && $aaXwj(false);
            // $FlowFixMe[cannot-write]
            // $FlowFixMe[incompatible-variance]
            linkedArray[nextIndex] = _this2._traverse(field, linkedID, prevItem);
        });
        data[applicationName] = linkedArray;
        return linkedArray;
    } /**
   * Reads a ReaderModuleImport, which was generated from using the @module
   * directive.
   */ ;
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        // Determine the component module from the store: if the field is missing
        // it means we don't know what component to render the match with.
        var componentKey = $453e576ecc8ee4b3$var$getModuleComponentKey(moduleImport.documentName);
        var component = $iEVza.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        // Otherwise, read the fragment and module associated to the concrete
        // type, and put that data with the result:
        // - For the matched fragment, create the relevant fragment pointer and add
        //   the expected fragmentPropName
        // - For the matched module, create a reference to the module
        this._createFragmentPointer({
            kind: "FragmentSpread",
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$453e576ecc8ee4b3$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$453e576ecc8ee4b3$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            // concrete type refinement: only read data if the type exactly matches
            var typeName = $iEVza.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) // This selection does not match the fragment spread. Do nothing.
            return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) // Type known to not implement the interface, no data expected
            return null;
            else if (implementsInterface == null) {
                // Don't know if the type implements the interface or not
                this._markDataAsMissing();
                // Judgement call here. In some cases this will cause us to hide data that is actually valid.
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return fieldData;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            // concrete type refinement: only read data if the type exactly matches
            var typeName = $iEVza.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) // This selection does not match the fragment spread. Do nothing.
            return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) // Bubble up null due to a missing @required field
                return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            // store flags to reset after reading
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            // @required is not allowed within inline fragments on abstract types, so
            // we can ignore the `hasMissingData` result of `_traverseSelections`.
            this._traverseSelections(inlineFragment.selections, record, data);
            // Reset
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                // Type known to not implement the interface, no data expected
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                // Don't know if the type implements the interface or not
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === "object" && fragmentPointers != null) && $aaXwj(false);
        if (data[$453e576ecc8ee4b3$var$ID_KEY] == null) data[$453e576ecc8ee4b3$var$ID_KEY] = $iEVza.getDataID(record);
        // $FlowFixMe[cannot-write] - writing into read-only field
        fragmentPointers[fragmentSpread.name] = fragmentSpread.args ? $453e576ecc8ee4b3$var$getArgumentValues(fragmentSpread.args, this._variables) : {};
        data[$453e576ecc8ee4b3$var$FRAGMENT_OWNER_KEY] = this._owner;
        data[$453e576ecc8ee4b3$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = this._isWithinUnmatchedTypeRefinement;
        if ($dsOUI.ENABLE_CLIENT_EDGES) {
            if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$453e576ecc8ee4b3$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
        }
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === "object" && fragmentPointers != null) && $aaXwj(false);
        if (data[$453e576ecc8ee4b3$var$ID_KEY] == null) data[$453e576ecc8ee4b3$var$ID_KEY] = $iEVza.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        // If the inline fragment spread has arguments, we need to temporarily
        // switch this._variables to include the fragment spread's arguments
        // for the duration of its traversal.
        var argumentVariables = fragmentSpreadOrFragment.args ? $453e576ecc8ee4b3$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $fkd0X.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        // Put the parent variables back
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        // $FlowFixMe[cannot-write] - writing into read-only field
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === "THROW") return;
        if (additional.action === "THROW") {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: "LOG",
            fields: [].concat((0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $iEVza.getType(record);
        var typeRecord = this._recordSource.get($453e576ecc8ee4b3$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $iEVza.getValue(typeRecord, abstractKey) : null;
        // $FlowFixMe Casting record value
        return implementsInterface;
    };
    return RelayReader;
}(); // Constructs the arguments for a resolver function and then evaluates it.
//
// If the resolver's fragment is missing data (query is in-flight, a dependency
// field is suspending, or is missing required fields) then `readFragment` will
// throw `RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL`. This function ensures that
// we catch that error and instead create an error object which can be
// propagated to the reader snapshot.
function $453e576ecc8ee4b3$var$getResolverValue(field, variables, fragmentKey, ownerName) {
    // Support for languages that work (best) with ES6 modules, such as TypeScript.
    var resolverFunction = typeof field.resolverModule === "function" ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $453e576ecc8ee4b3$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $453e576ecc8ee4b3$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else {
            var _field$path;
            // `field.path` is typed as nullable while we rollout compiler changes.
            var path = (_field$path = field.path) !== null && _field$path !== void 0 ? _field$path : "[UNKNOWN]";
            resolverError = {
                field: {
                    path: path,
                    owner: ownerName
                },
                error: e
            };
        }
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $453e576ecc8ee4b3$var$assertValidClientEdgeResolverResponse(field, clientEdgeResolverResponse) {
    if (field.linkedField.plural) {
        !Array.isArray(clientEdgeResolverResponse) && $aaXwj(false);
        return {
            kind: "PluralConcrete",
            ids: clientEdgeResolverResponse.map(function(response) {
                return $453e576ecc8ee4b3$var$extractIdFromResponse(response, "Expected this plural Client Edge Relay Resolver to return an array containing IDs or objects with shape {id}.");
            })
        };
    } else return {
        kind: "SingularConcrete",
        id: $453e576ecc8ee4b3$var$extractIdFromResponse(clientEdgeResolverResponse, "Expected this Client Edge Relay Resolver to return an ID of type `string` or an object with shape {id}.")
    };
}
// For weak objects:
// The return value of a client edge resolver is the entire object (though,
// strong objects become DataIDs or arrays thereof). However, when being read
// out, these raw objects are turned into DataIDs or arrays thereof.
//
// For strong objects:
// For a singular field, the return value of a client edge resolver is a DataID
// (i.e. a string). If the edge points to a client type, we namespace the
// ID with the typename by calling resolverCache.ensureClientRecord.
function $453e576ecc8ee4b3$var$getStoreIDAndTraversalPathSegmentForSingularClientEdgeResolver(field, clientEdgeResolverResponse, resolverCache) {
    if (field.kind === $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
        if (field.backingField.normalizationInfo == null) {
            var concreteType = field.concreteType;
            !(concreteType != null) && $aaXwj(false);
            // @edgeTo case where we need to ensure that the record has `id` field
            return [
                resolverCache.ensureClientRecord(clientEdgeResolverResponse, concreteType),
                null
            ];
        } else // The normalization process in LiveResolverCache should take care of generating the correct ID.
        return [
            clientEdgeResolverResponse,
            null
        ];
    } else return [
        clientEdgeResolverResponse,
        {
            readerClientEdge: field,
            clientEdgeDestinationID: clientEdgeResolverResponse
        }
    ];
}
// For weak objects:
// The return value of a client edge resolver is the entire object (though,
// strong objects become DataIDs or arrays thereof). However, when being read
// out, these raw objects are turned into DataIDs or arrays thereof.
//
// For strong objects:
// For a plural field, the return value of a client edge resolver is an
// array of DataID's. If the edge points to a client type, we namespace the
// IDs with the typename by calling resolverCache.ensureClientRecord.
function $453e576ecc8ee4b3$var$getStoreIDsForPluralClientEdgeResolver(field, clientEdgeResolverResponse, resolverCache) {
    if (field.kind === $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
        if (field.backingField.normalizationInfo == null) {
            var concreteType = field.concreteType;
            !(concreteType != null) && $aaXwj(false);
            // @edgeTo case where we need to ensure that the record has `id` field
            return clientEdgeResolverResponse.map(function(id) {
                return resolverCache.ensureClientRecord(id, concreteType);
            });
        } else // The normalization process in LiveResolverCache should take care of generating the correct ID.
        return clientEdgeResolverResponse;
    } else $aaXwj(false);
}
function $453e576ecc8ee4b3$var$extractIdFromResponse(individualResponse, errorMessage) {
    if (typeof individualResponse === "string") return individualResponse;
    else if (typeof individualResponse === "object" && individualResponse != null && typeof individualResponse.id === "string") return individualResponse.id;
    $aaXwj(false);
}
module.exports = {
    read: $453e576ecc8ee4b3$var$read
};

});
parcelRegister("5wZNL", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $406fe16a9d65f6ff$var$_interopRequireDefault = $1jnue.default;

var $406fe16a9d65f6ff$var$_createForOfIteratorHelper2 = $406fe16a9d65f6ff$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $9DGaB = parcelRequire("9DGaB");

var $84X73 = parcelRequire("84X73");
var $406fe16a9d65f6ff$var$RELAY_LIVE_RESOLVER = $84X73.RELAY_LIVE_RESOLVER;

var $i2E13 = parcelRequire("i2E13");
var $406fe16a9d65f6ff$var$generateClientID = $i2E13.generateClientID;

var $iEVza = parcelRequire("iEVza");

var $5DrBw = parcelRequire("5DrBw");
var $406fe16a9d65f6ff$var$RELAY_RESOLVER_ERROR_KEY = $5DrBw.RELAY_RESOLVER_ERROR_KEY, $406fe16a9d65f6ff$var$RELAY_RESOLVER_INVALIDATION_KEY = $5DrBw.RELAY_RESOLVER_INVALIDATION_KEY, $406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY = $5DrBw.RELAY_RESOLVER_SNAPSHOT_KEY, $406fe16a9d65f6ff$var$RELAY_RESOLVER_VALUE_KEY = $5DrBw.RELAY_RESOLVER_VALUE_KEY, $406fe16a9d65f6ff$var$getStorageKey = $5DrBw.getStorageKey;

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
// $FlowFixMe[unclear-type] - will always be empty
var $406fe16a9d65f6ff$var$emptySet = new Set();
var $406fe16a9d65f6ff$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $406fe16a9d65f6ff$var$RELAY_LIVE_RESOLVER) && $aaXwj(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $aaXwj(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $406fe16a9d65f6ff$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $406fe16a9d65f6ff$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        // NOTE: Be very careful with `record` in this scope. After `evaluate` has
        // been called, the `record` we have here may have been replaced in the
        // Relay store with a new record containing new information about nested
        // resolvers on this parent record.
        var record = recordSource.get(recordID);
        !(record != null) && $aaXwj(false);
        var storageKey = $406fe16a9d65f6ff$var$getStorageKey(field, variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            // Cache miss; evaluate the selector and store the result in a new record:
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $406fe16a9d65f6ff$var$generateClientID(recordID, storageKey);
            linkedRecord = $iEVza.create(linkedID, "__RELAY_RESOLVER__");
            var evaluationResult = evaluate();
            $iEVza.setValue(linkedRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $iEVza.setValue(linkedRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $iEVza.setValue(linkedRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            // Link the resolver value record to the resolver field of the record being read:
            // Note: We get a fresh instance of the parent record from the record
            // source, because it may have been updated when we traversed into child
            // resolvers.
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $aaXwj(false);
            var nextRecord = $iEVza.clone(currentRecord);
            $iEVza.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                // Put records observed by the resolver into the dependency graph:
                var fragmentStorageKey = $406fe16a9d65f6ff$var$getStorageKey(field.fragment, variables);
                var resolverID = $406fe16a9d65f6ff$var$generateClientID(recordID, fragmentStorageKey);
                $406fe16a9d65f6ff$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $406fe16a9d65f6ff$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $406fe16a9d65f6ff$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $406fe16a9d65f6ff$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        // $FlowFixMe[incompatible-type] - will always be empty
        var answer = linkedRecord[$406fe16a9d65f6ff$var$RELAY_RESOLVER_VALUE_KEY];
        // $FlowFixMe[incompatible-type] - casting mixed
        var snapshot = linkedRecord[$406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY];
        // $FlowFixMe[incompatible-type] - casting mixed
        var error = linkedRecord[$406fe16a9d65f6ff$var$RELAY_RESOLVER_ERROR_KEY];
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs // Mutated in place
    ) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $406fe16a9d65f6ff$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $406fe16a9d65f6ff$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $406fe16a9d65f6ff$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $406fe16a9d65f6ff$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, // Written to
    updatedDataIDs // Mutated in place
    ) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $iEVza.clone(record);
        $iEVza.setValue(nextRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$iEVza.getValue(record, $406fe16a9d65f6ff$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        // $FlowFixMe[incompatible-type] - storing values in records is not typed
        var snapshot = $iEVza.getValue(record, $406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $9DGaB(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $aaXwj(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $aaXwj(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $406fe16a9d65f6ff$var$NoopResolverCache,
    RecordResolverCache: $406fe16a9d65f6ff$var$RecordResolverCache
};

});

parcelRegister("5o6zS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $3ec44bd552cc4ea2$var$getFragment = $aW0zg.getFragment;

var $idJ2w = parcelRequire("idJ2w");
var $3ec44bd552cc4ea2$var$getSelector = $idJ2w.getSelector;

var $aaXwj = parcelRequire("aaXwj");
// When we call the user-supplied resolver function, it will in turn call
// `readFragment`, but that's a global function -- it needs information
// about what resolver is being executed, which is supplied by putting the
// info on this stack before we call the resolver function.
var $3ec44bd552cc4ea2$var$contextStack = [];
function $3ec44bd552cc4ea2$var$withResolverContext(context, cb) {
    $3ec44bd552cc4ea2$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $3ec44bd552cc4ea2$var$contextStack.pop();
    }
}
// NOTE: these declarations are copied from 'useFragment'; it would be good
// to figure out how to share the same type signature between the two functions.
// The declarations ensure that the type of the returned data is:
//   - non-nullable if the provided ref type is non-nullable
//   - nullable if the provided ref type is nullable
//   - array of non-nullable if the provided ref type is an array of
//     non-nullable refs
//   - array of nullable if the provided ref type is an array of nullable refs
function $3ec44bd552cc4ea2$var$readFragment(fragmentInput, fragmentKey) {
    if (!$3ec44bd552cc4ea2$var$contextStack.length) throw new Error("readFragment should be called only from within a Relay Resolver function.");
    var context = $3ec44bd552cc4ea2$var$contextStack[$3ec44bd552cc4ea2$var$contextStack.length - 1];
    var fragmentNode = $3ec44bd552cc4ea2$var$getFragment(fragmentInput);
    var fragmentSelector = $3ec44bd552cc4ea2$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $aaXwj(false);
    !(fragmentSelector.kind === "SingularReaderSelector") && $aaXwj(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $3ec44bd552cc4ea2$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $3ec44bd552cc4ea2$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $3ec44bd552cc4ea2$var$readFragment,
    withResolverContext: $3ec44bd552cc4ea2$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $3ec44bd552cc4ea2$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});




parcelRegister("6rSHS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $4b1fb34eb9714cd2$var$_interopRequireDefault = $1jnue.default;

var $4b1fb34eb9714cd2$var$_createForOfIteratorHelper2 = $4b1fb34eb9714cd2$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $4b1fb34eb9714cd2$var$_defineProperty2 = $4b1fb34eb9714cd2$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $lbx0y = parcelRequire("lbx0y");
var $4b1fb34eb9714cd2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $lbx0y.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $4b1fb34eb9714cd2$var$assertInternalActorIdentifier = $lbx0y.assertInternalActorIdentifier;
parcelRequire("7sl3K");

var $dsOUI = parcelRequire("dsOUI");

var $bUD3L = parcelRequire("bUD3L");

var $g2tqF = parcelRequire("g2tqF");

var $aNE7V = parcelRequire("aNE7V");

var $iEVza = parcelRequire("iEVza");

var $3J7dZ = parcelRequire("3J7dZ");

var $5WA3P = parcelRequire("5WA3P");

var $6vcfy = parcelRequire("6vcfy");

var $53GBi = parcelRequire("53GBi");

var $kTplQ = parcelRequire("kTplQ");

var $5DrBw = parcelRequire("5DrBw");

var $5DrBw = parcelRequire("5DrBw");
var $4b1fb34eb9714cd2$var$ROOT_ID = $5DrBw.ROOT_ID, $4b1fb34eb9714cd2$var$ROOT_TYPE = $5DrBw.ROOT_TYPE;

var $5wZNL = parcelRequire("5wZNL");
var $4b1fb34eb9714cd2$var$RecordResolverCache = $5wZNL.RecordResolverCache;

var $aaXwj = parcelRequire("aaXwj");
var $4b1fb34eb9714cd2$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
/**
 * @public
 *
 * An implementation of the `Store` interface defined in `RelayStoreTypes`.
 *
 * Note that a Store takes ownership of all records provided to it: other
 * objects may continue to hold a reference to such records but may not mutate
 * them. The static Relay core is architected to avoid mutating records that may have been
 * passed to a store: operations that mutate records will either create fresh
 * records or clone existing records and modify the clones. Record immutability
 * is also enforced in development mode by freezing all records passed to a store.
 */ var $4b1fb34eb9714cd2$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $4b1fb34eb9714cd2$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $4b1fb34eb9714cd2$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $bUD3L;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $aNE7V;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $4b1fb34eb9714cd2$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $kTplQ(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $4b1fb34eb9714cd2$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        // Check if store has been globally invalidated
        if (globalInvalidationEpoch != null) {
            // If so, check if the operation we're checking was last written
            // before or after invalidation occurred.
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) // If the operation was written /before/ global invalidation occurred,
            // or if this operation has never been written to the store before,
            // we will consider the data for this operation to be stale
            // (i.e. not resolvable from the store).
            return {
                status: "stale"
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $4b1fb34eb9714cd2$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $4b1fb34eb9714cd2$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $g2tqF.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $4b1fb34eb9714cd2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $4b1fb34eb9714cd2$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            // Ensure each retain can only dispose once
            if (disposed) return;
            disposed = true;
            // For Flow: guard against the entry somehow not existing
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            // Decrement the ref count: if it becomes zero it is eligible
            // for release.
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    // If the release buffer is now over-full, remove the least-recently
                    // added entry and schedule a GC. Note that all items in the release
                    // buffer have a refCount of 0.
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) // This entry should be in the release buffer, but it no longer belongs
            // there since it's retained. Remove it to maintain the invariant that
            // all release buffer entries have a refCount of 0.
            this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            // If we've previously retained this operation, increment the refCount
            rootEntry.refCount += 1;
        } else // Otherwise create a new entry for the operation
        this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $5WA3P.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: "store.notify.start",
            sourceOperation: sourceOperation
        });
        // Increment the current write when notifying after executing
        // a set of changes to the store.
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($dsOUI.ENABLE_RELAY_RESOLVERS) // When a record is updated, we need to also handle records that depend on it,
        // specifically Relay Resolver result records containing results based on the
        // updated records. This both adds to updatedRecordIDs and invalidates any
        // cached data as needed.
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: "store.notify.complete",
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        // If a source operation was provided (indicating the operation
        // that produced this update to the store), record the current epoch
        // at which this operation was written.
        if (sourceOperation != null) {
            // We only track the epoch at which the operation was written if
            // it was previously retained, to keep the size of our operation
            // epoch map bounded. If a query wasn't retained, we assume it can
            // may be deleted at any moment and thus is not relevant for us to track
            // for the purposes of invalidation.
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === "query" && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                // The operation isn't retained but there is space in the release buffer:
                // temporarily track this operation in case the data can be reused soon.
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $4b1fb34eb9714cd2$var$updateTargetFromSource(target, source, // We increment the current epoch at the end of the set of updates,
        // in notify(). Here, we pass what will be the incremented value of
        // the epoch to use to write to invalidated records.
        this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        // NOTE: log *after* processing the source so that even if a bad log function
        // mutates the source, it doesn't affect Relay processing of it.
        var log = this.__log;
        if (log != null) log({
            name: "store.publish",
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return "RelayModernStore()";
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $iEVza.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set("global", this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        // Check if global invalidation has changed
        if (currentInvalidations.get("global") !== prevInvalidations.get("global")) return true;
        // Check if the invalidation state for any of the ids has changed.
        var _iterator = (0, $4b1fb34eb9714cd2$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aaXwj(false);
        var log = this.__log;
        if (log != null) log({
            name: "store.snapshot"
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $3J7dZ.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $aaXwj(false);
        var log = this.__log;
        if (log != null) log({
            name: "store.restore"
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    } /**
   * Run a full GC synchronously.
   */ ;
    _proto.__gc = function __gc() {
        // Don't run GC while there are optimistic updates applied
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        /* eslint-disable no-labels */ top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            // Mark all records that are traversable from a root
            var _iterator2 = (0, $4b1fb34eb9714cd2$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $6vcfy.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    // Yield for other work after each operation
                    yield;
                    // If the store was updated, restart
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: "store.gc",
                references: references
            });
            // Sweep records without references
            if (references.size === 0) // Short-circuit if *nothing* is referenced
            this._recordSource.clear();
            else {
                // Evict any unreferenced nodes
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $4b1fb34eb9714cd2$var$initializeRecordSource(target) {
    if (!target.has($4b1fb34eb9714cd2$var$ROOT_ID)) {
        var rootRecord = $iEVza.create($4b1fb34eb9714cd2$var$ROOT_ID, $4b1fb34eb9714cd2$var$ROOT_TYPE);
        target.set($4b1fb34eb9714cd2$var$ROOT_ID, rootRecord);
    }
}
/**
 * Updates the target with information from source, also updating a mapping of
 * which records in the target were changed as a result.
 * Additionally, will mark records as invalidated at the current write epoch
 * given the set of record ids marked as stale in this update.
 */ function $4b1fb34eb9714cd2$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    // First, update any records that were marked for invalidation.
    // For each provided dataID that was invalidated, we write the
    // INVALIDATED_AT_KEY on the record, indicating
    // the epoch at which the record was invalidated.
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        // If record was deleted during the update (and also invalidated),
        // we don't need to count it as an invalidated id
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) // If the target record exists, use it to set the epoch
        // at which it was invalidated. This record will be updated with
        // any changes from source in the section below
        // where we update the target records based on the source.
        nextRecord = $iEVza.clone(targetRecord);
        else // If the target record doesn't exist, it means that a new record
        // in the source was created (and also invalidated), so we use that
        // record to set the epoch at which it was invalidated. This record
        // will be updated with any changes from source in the section below
        // where we update the target records based on the source.
        nextRecord = sourceRecord != null ? $iEVza.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $iEVza.setValue(nextRecord, $5DrBw.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    // Update the target based on the changes present in source
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            // ReactFlightClientResponses are lazy and only materialize when readRoot
            // is called when we read the field, so if the record is a Flight field
            // we always use the new record's data regardless of whether
            // it actually changed. Let React take care of reconciliation instead.
            var nextRecord = $iEVza.getType(targetRecord) === $53GBi.REACT_FLIGHT_TYPE_NAME ? sourceRecord : $iEVza.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        } // don't add explicit undefined
    }
}
/**
 * Returns an OperationAvailability given the Availability returned
 * by checking an operation, and when that operation was last written to the store.
 * Specifically, the provided Availability of an operation will contain the
 * value of when a record referenced by the operation was most recently
 * invalidated; given that value, and given when this operation was last
 * written to the store, this function will return the overall
 * OperationAvailability for the operation.
 */ function $4b1fb34eb9714cd2$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === "number") {
        // If some record referenced by this operation is stale, then the operation itself is stale
        // if either the operation itself was never written *or* the operation was last written
        // before the most recent invalidation of its reachable records.
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: "stale"
        };
    }
    if (status === "missing") return {
        status: "missing"
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: "stale"
        };
    }
    // There were no invalidations of any reachable records *or* the operation is known to have
    // been fetched after the most recent record invalidation.
    return {
        status: "available",
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $4b1fb34eb9714cd2$var$RelayModernStore;

});
parcelRegister("bUD3L", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $8ac3391c71be934a$var$resolvedPromise = Promise.resolve();
/**
 * An alternative to setImmediate based on Promise.
 */ function $8ac3391c71be934a$var$resolveImmediate(callback) {
    $8ac3391c71be934a$var$resolvedPromise.then(callback)["catch"]($8ac3391c71be934a$var$throwNext);
}
function $8ac3391c71be934a$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $8ac3391c71be934a$var$resolveImmediate;

});

parcelRegister("g2tqF", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $bad3a9440255aed3$var$_interopRequireDefault = $1jnue.default;

var $bad3a9440255aed3$var$_createForOfIteratorHelper2 = $bad3a9440255aed3$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $2Zzcm = parcelRequire("2Zzcm");

var $RmER8 = parcelRequire("RmER8");

var $dLcej = parcelRequire("dLcej");

var $84X73 = parcelRequire("84X73");

var $dsOUI = parcelRequire("dsOUI");

var $i2E13 = parcelRequire("i2E13");
var $bad3a9440255aed3$var$isClientID = $i2E13.isClientID;

var $ihZWi = parcelRequire("ihZWi");

var $fqaM4 = parcelRequire("fqaM4");

var $fkd0X = parcelRequire("fkd0X");
var $bad3a9440255aed3$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $bZtyP = parcelRequire("bZtyP");
var $bad3a9440255aed3$var$EXISTENT = $bZtyP.EXISTENT, $bad3a9440255aed3$var$UNKNOWN = $bZtyP.UNKNOWN;

var $53GBi = parcelRequire("53GBi");

var $5DrBw = parcelRequire("5DrBw");

var $kRPAW = parcelRequire("kRPAW");
var $bad3a9440255aed3$var$TYPE_SCHEMA_TYPE = $kRPAW.TYPE_SCHEMA_TYPE, $bad3a9440255aed3$var$generateTypeID = $kRPAW.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
var $bad3a9440255aed3$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $bad3a9440255aed3$var$CONDITION = $84X73.CONDITION, $bad3a9440255aed3$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $bad3a9440255aed3$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $bad3a9440255aed3$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $bad3a9440255aed3$var$DEFER = $84X73.DEFER, $bad3a9440255aed3$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $bad3a9440255aed3$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $bad3a9440255aed3$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $bad3a9440255aed3$var$LINKED_FIELD = $84X73.LINKED_FIELD, $bad3a9440255aed3$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $bad3a9440255aed3$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $bad3a9440255aed3$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $bad3a9440255aed3$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $bad3a9440255aed3$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $bad3a9440255aed3$var$STREAM = $84X73.STREAM, $bad3a9440255aed3$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR;
var $bad3a9440255aed3$var$ROOT_ID = $5DrBw.ROOT_ID, $bad3a9440255aed3$var$getModuleOperationKey = $5DrBw.getModuleOperationKey, $bad3a9440255aed3$var$getStorageKey = $5DrBw.getStorageKey, $bad3a9440255aed3$var$getArgumentValues = $5DrBw.getArgumentValues;
/**
 * Synchronously check whether the records required to fulfill the given
 * `selector` are present in `source`.
 *
 * If a field is missing, it uses the provided handlers to attempt to substitute
 * data. The `target` will store all records that are modified because of a
 * successful substitution.
 *
 * If all records are present, returns `true`, otherwise `false`.
 */ function $bad3a9440255aed3$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $bad3a9440255aed3$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
/**
 * @private
 */ var $bad3a9440255aed3$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $2Zzcm(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $RmER8(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: "missing",
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: "available",
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === "id" && field.alias == null && $bad3a9440255aed3$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $bad3a9440255aed3$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === "scalar") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $bad3a9440255aed3$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === "linked") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $bad3a9440255aed3$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $bad3a9440255aed3$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === "pluralLinked") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $bad3a9440255aed3$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $bad3a9440255aed3$var$UNKNOWN) this._handleMissing();
        if (status === $bad3a9440255aed3$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $iEVza.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $bad3a9440255aed3$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $bad3a9440255aed3$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $bad3a9440255aed3$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        // concrete type refinement: only check data if the type exactly matches
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        // Abstract refinement: check data depending on whether the type
                        // conforms to the interface/union or not:
                        // - Type known to _not_ implement the interface: don't check the selections.
                        // - Type is known _to_ implement the interface: check selections.
                        // - Unknown whether the type implements the interface: don't check the selections
                        //   and treat the data as missing; we do this because the Relay Compiler
                        //   guarantees that the type discriminator will always be fetched.
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $aaXwj(false);
                        var _typeID = $bad3a9440255aed3$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) // unsure if the type implements the interface: data is
                        // missing so don't bother reading the fragment
                        _this2._handleMissing();
                         // else false: known to not implement the interface
                    }
                    break;
                case $bad3a9440255aed3$var$LINKED_HANDLE:
                    // Handles have no selections themselves; traverse the original field
                    // where the handle was set-up instead.
                    var handleField = $ihZWi(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $bad3a9440255aed3$var$SCALAR_HANDLE:
                    var _handleField = $fqaM4(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $bad3a9440255aed3$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$DEFER:
                case $bad3a9440255aed3$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $bad3a9440255aed3$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $bad3a9440255aed3$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $bad3a9440255aed3$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $bad3a9440255aed3$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $aaXwj(false);
                    var typeID = $bad3a9440255aed3$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) // unsure if the type implements the interface: data is
                    // missing
                    _this2._handleMissing();
                     // else: if it does or doesn't implement, we don't need to check or skip anything else
                    break;
                case $bad3a9440255aed3$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) _this2._checkFlightField(selection, dataID);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $bad3a9440255aed3$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $bad3a9440255aed3$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        var operationKey = $bad3a9440255aed3$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $dLcej(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $bad3a9440255aed3$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else // If the fragment is not available, we assume that the data cannot have been
        // processed yet and must therefore be missing.
        this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $iEVza.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._checkFlightField = function _checkFlightField(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID == null) {
            if (linkedID === undefined) {
                this._handleMissing();
                return;
            }
            return;
        }
        var tree = this._mutator.getValue(linkedID, $53GBi.REACT_FLIGHT_TREE_STORAGE_KEY);
        var reachableExecutableDefinitions = this._mutator.getValue(linkedID, $53GBi.REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY);
        if (tree == null || !Array.isArray(reachableExecutableDefinitions)) {
            this._handleMissing();
            return;
        }
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        // In Flight, the variables that are in scope for reachable executable
        // definitions aren't the same as what's in scope for the outer query.
        var prevVariables = this._variables;
        // $FlowFixMe[incompatible-cast]
        var _iterator4 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(reachableExecutableDefinitions), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var definition = _step4.value;
                this._variables = definition.variables;
                var normalizationRootNode = operationLoader.get(definition.module);
                if (normalizationRootNode != null) {
                    var operation = $dLcej(normalizationRootNode);
                    this._traverseSelections(operation.selections, $bad3a9440255aed3$var$ROOT_ID);
                } else // If the fragment is not available, we assume that the data cannot have
                // been processed yet and must therefore be missing.
                this._handleMissing();
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        this._variables = prevVariables;
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator5 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var concreteType = _step5.value;
                    var typeID = $bad3a9440255aed3$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $bad3a9440255aed3$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $bad3a9440255aed3$var$check
};

});
parcelRegister("ihZWi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");
var $d509dc638a4294ee$var$LINKED_FIELD = $84X73.LINKED_FIELD;

var $5DrBw = parcelRequire("5DrBw");
var $d509dc638a4294ee$var$getHandleStorageKey = $5DrBw.getHandleStorageKey;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
/**
 * @private
 *
 * Creates a clone of the supplied `handleField` by finding the original linked
 * field (on which the handle was declared) among the sibling `selections`, and
 * copying its selections into the clone.
 */ function $d509dc638a4294ee$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $d509dc638a4294ee$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $ewhZB(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $d509dc638a4294ee$var$LINKED_FIELD) && $aaXwj(false);
    var handleKey = $d509dc638a4294ee$var$getHandleStorageKey(handleField, variables);
    return {
        kind: "LinkedField",
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $d509dc638a4294ee$var$cloneRelayHandleSourceField;

});

parcelRegister("fqaM4", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");
var $b3a1a442480bc680$var$SCALAR_FIELD = $84X73.SCALAR_FIELD;

var $5DrBw = parcelRequire("5DrBw");
var $b3a1a442480bc680$var$getHandleStorageKey = $5DrBw.getHandleStorageKey;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
/**
 * @private
 *
 * Creates a clone of the supplied `handleField` by finding the original scalar
 * field (on which the handle was declared) among the sibling `selections`.
 */ function $b3a1a442480bc680$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $b3a1a442480bc680$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $ewhZB(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $b3a1a442480bc680$var$SCALAR_FIELD) && $aaXwj(false);
    var handleKey = $b3a1a442480bc680$var$getHandleStorageKey(handleField, variables);
    return {
        kind: "ScalarField",
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $b3a1a442480bc680$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("3J7dZ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2b6b2dc144c245e7$var$_interopRequireDefault = $1jnue.default;

var $2b6b2dc144c245e7$var$_objectSpread2 = $2b6b2dc144c245e7$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $L6WFS = parcelRequire("L6WFS");

var $aaXwj = parcelRequire("aaXwj");
var $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL = Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
});
/**
 * An implementation of MutableRecordSource that represents a base RecordSource
 * with optimistic updates stacked on top: records with optimistic updates
 * shadow the base version of the record rather than updating/replacing them.
 */ var $2b6b2dc144c245e7$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $L6WFS.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return "UNKNOWN";
        else if (record === null) return "NONEXISTENT";
        else return "EXISTENT";
    };
    _proto.clear = function clear() {
        this._base = $L6WFS.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $2b6b2dc144c245e7$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = record;
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $2b6b2dc144c245e7$var$create(base) {
    return new $2b6b2dc144c245e7$var$RelayOptimisticRecordSource(base);
}
function $2b6b2dc144c245e7$var$getOptimisticRecordIDs(source) {
    !(source instanceof $2b6b2dc144c245e7$var$RelayOptimisticRecordSource) && $aaXwj(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $2b6b2dc144c245e7$var$create,
    getOptimisticRecordIDs: $2b6b2dc144c245e7$var$getOptimisticRecordIDs
};

});

parcelRegister("6vcfy", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $4bbf23ea7c0204c5$var$_interopRequireDefault = $1jnue.default;

var $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2 = $4bbf23ea7c0204c5$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $dLcej = parcelRequire("dLcej");

var $84X73 = parcelRequire("84X73");

var $dsOUI = parcelRequire("dsOUI");

var $ihZWi = parcelRequire("ihZWi");

var $9VD3P = parcelRequire("9VD3P");

var $fkd0X = parcelRequire("fkd0X");
var $4bbf23ea7c0204c5$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $53GBi = parcelRequire("53GBi");

var $5DrBw = parcelRequire("5DrBw");

var $kRPAW = parcelRequire("kRPAW");
var $4bbf23ea7c0204c5$var$generateTypeID = $kRPAW.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
var $4bbf23ea7c0204c5$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $4bbf23ea7c0204c5$var$CONDITION = $84X73.CONDITION, $4bbf23ea7c0204c5$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $4bbf23ea7c0204c5$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $4bbf23ea7c0204c5$var$DEFER = $84X73.DEFER, $4bbf23ea7c0204c5$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $4bbf23ea7c0204c5$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $4bbf23ea7c0204c5$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $4bbf23ea7c0204c5$var$LINKED_FIELD = $84X73.LINKED_FIELD, $4bbf23ea7c0204c5$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $4bbf23ea7c0204c5$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $4bbf23ea7c0204c5$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $4bbf23ea7c0204c5$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $4bbf23ea7c0204c5$var$STREAM = $84X73.STREAM, $4bbf23ea7c0204c5$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR, $4bbf23ea7c0204c5$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $4bbf23ea7c0204c5$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $4bbf23ea7c0204c5$var$ROOT_ID = $5DrBw.ROOT_ID, $4bbf23ea7c0204c5$var$getStorageKey = $5DrBw.getStorageKey, $4bbf23ea7c0204c5$var$getModuleOperationKey = $5DrBw.getModuleOperationKey;
function $4bbf23ea7c0204c5$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $4bbf23ea7c0204c5$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
/**
 * @private
 */ var $4bbf23ea7c0204c5$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === "Operation" || node.kind === "SplitOperation") this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            /* eslint-disable no-fallthrough */ switch(selection.kind){
                case $4bbf23ea7c0204c5$var$ACTOR_CHANGE:
                    // TODO: T89695151 Support multi-actor record sources in RelayReferenceMarker.js
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $4bbf23ea7c0204c5$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $4bbf23ea7c0204c5$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $iEVza.getType(record);
                        if (typeName != null && typeName === selection.type || // Our root record has a special type of `__Root` which may not
                        // match the schema type of Query/Mutation or whatever the schema
                        // specifies.
                        //
                        // If we have an inline fragment on a concrete type within an
                        // operation root, and our query has been validated, we know that
                        // concrete type must match, since the operation selection must be
                        // on a concrete type.
                        typeName === $5DrBw.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $iEVza.getType(record);
                        var typeID = $4bbf23ea7c0204c5$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $4bbf23ea7c0204c5$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $4bbf23ea7c0204c5$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $4bbf23ea7c0204c5$var$LINKED_HANDLE:
                    // The selections for a "handle" field are the same as those of the
                    // original linked field where the handle was applied. Reference marking
                    // therefore requires traversing the original field selections against
                    // the synthesized client field.
                    //
                    // TODO: Instead of finding the source field in `selections`, change
                    // the concrete structure to allow shared subtrees, and have the linked
                    // handle directly refer to the same selections as the LinkedField that
                    // it was split from.
                    var handleField = $ihZWi(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $4bbf23ea7c0204c5$var$DEFER:
                case $4bbf23ea7c0204c5$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$SCALAR_FIELD:
                case $4bbf23ea7c0204c5$var$SCALAR_HANDLE:
                    break;
                case $4bbf23ea7c0204c5$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $iEVza.getType(record);
                    var _typeID = $4bbf23ea7c0204c5$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $4bbf23ea7c0204c5$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $4bbf23ea7c0204c5$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) _this._traverseFlightField(selection, record);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $4bbf23ea7c0204c5$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $4bbf23ea7c0204c5$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            // Mark all @outputType record IDs
            var outputTypeRecordIDs = $9VD3P(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) // TODO: Handle retaining abstract client edges to client types.
            return;
            if (linkedField.plural) {
                var dataIDs = $iEVza.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $iEVza.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var dataID = $iEVza.getLinkedRecordID(record, storageKey);
        // If the resolver value has been created, we should retain it.
        // This record contains our cached resolver value, and potential Live
        // Resolver subscription.
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) // Mark the contents of the resolver's data dependencies.
        this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        var operationKey = $4bbf23ea7c0204c5$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $iEVza.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $dLcej(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $4bbf23ea7c0204c5$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    // Otherwise, if the operation is not available, we assume that the data
    // cannot have been processed yet and therefore isn't in the store to
    // begin with.
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var linkedIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    _proto._traverseFlightField = function _traverseFlightField(field, record) {
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._references.add(linkedID);
        var reactFlightClientResponseRecord = this._recordSource.get(linkedID);
        if (reactFlightClientResponseRecord == null) return;
        var reachableExecutableDefinitions = $iEVza.getValue(reactFlightClientResponseRecord, $53GBi.REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY);
        if (!Array.isArray(reachableExecutableDefinitions)) return;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        // In Flight, the variables that are in scope for reachable executable
        // definitions aren't the same as what's in scope for the outer query.
        var prevVariables = this._variables;
        // $FlowFixMe[incompatible-cast]
        var _iterator3 = (0, $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2["default"])(reachableExecutableDefinitions), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var definition = _step3.value;
                this._variables = definition.variables;
                var operationReference = definition.module;
                var normalizationRootNode = operationLoader.get(operationReference);
                if (normalizationRootNode != null) {
                    var operation = $dLcej(normalizationRootNode);
                    this._traverse(operation, $4bbf23ea7c0204c5$var$ROOT_ID);
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._variables = prevVariables;
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $4bbf23ea7c0204c5$var$mark
};

});
parcelRegister("9VD3P", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");

var $5DrBw = parcelRequire("5DrBw");
var $73a7bc93037d64ca$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $5DrBw.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $aaXwj = parcelRequire("aaXwj");
function $73a7bc93037d64ca$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $iEVza.getValue(record, $73a7bc93037d64ca$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $aaXwj(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $73a7bc93037d64ca$var$getOutputTypeRecordIDs;

});


parcelRegister("kTplQ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("7sl3K");

var $9DGaB = parcelRequire("9DGaB");

var $dsOUI = parcelRequire("dsOUI");

var $5Fpm6 = parcelRequire("5Fpm6");

var $5WA3P = parcelRequire("5WA3P");
var $f35c9bedd581f4a1$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            // Backup occurs after writing a new "final" payload(s) and before (re)applying
            // optimistic changes. Each subscription's `snapshot` represents what was *last
            // published to the subscriber*, which notably may include previous optimistic
            // updates. Therefore a subscription can be in any of the following states:
            // - stale=true: This subscription was restored to a different value than
            //   `snapshot`. That means this subscription has changes relative to its base,
            //   but its base has changed (we just applied a final payload): recompute
            //   a backup so that we can later restore to the state the subscription
            //   should be in.
            // - stale=false: This subscription was restored to the same value as
            //   `snapshot`. That means this subscription does *not* have changes relative
            //   to its base, so the current `snapshot` is valid to use as a backup.
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $5WA3P.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $9DGaB(snapshot.data, backup.data);
            backup.data = nextData; // backup owns the snapshot and can safely mutate
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    } /**
   * Notifies the callback for the subscription if the data for the associated
   * snapshot has changed.
   * Additionally, updates the subscription snapshot with the latest snapshot,
   * and marks it as not stale.
   * Returns the owner (RequestDescriptor) if the subscription was affected by the
   * latest update, or null if it was not affected.
   */ ;
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $5Fpm6(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $5WA3P.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $9DGaB(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $dsOUI.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: "store.notify.subscription",
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
    };
    return RelayStoreSubscriptions;
}();
module.exports = $f35c9bedd581f4a1$var$RelayStoreSubscriptions;

});
parcelRegister("5Fpm6", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $4204732eb29cddc5$var$ITERATOR_KEY = Symbol.iterator;
function $4204732eb29cddc5$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    // $FlowFixMe[incompatible-use]: Set is an iterable type, accessing its iterator is allowed.
    var iterator = seenRecords[$4204732eb29cddc5$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $4204732eb29cddc5$var$hasOverlappingIDs;

});



parcelRegister("c18RI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $f8nQK = parcelRequire("f8nQK");

var $aW0zg = parcelRequire("aW0zg");
var $8bfc74816abb9335$var$getRequest = $aW0zg.getRequest;

var $40tQb = parcelRequire("40tQb");
var $8bfc74816abb9335$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $idJ2w = parcelRequire("idJ2w");
var $8bfc74816abb9335$var$createReaderSelector = $idJ2w.createReaderSelector;
parcelRequire("8Fbfi");
function $8bfc74816abb9335$var$requestSubscription(environment, config) {
    var subscription = $8bfc74816abb9335$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== "subscription") throw new Error("requestSubscription: Must use Subscription operation");
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $8bfc74816abb9335$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $f8nQK.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === "string") selector = $8bfc74816abb9335$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                // $FlowFixMe[incompatible-cast]
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $8bfc74816abb9335$var$requestSubscription;

});

parcelRegister("9fUzq", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $6bd1657ac6a11654$var$_interopRequireDefault = $1jnue.default;

var $6bd1657ac6a11654$var$_objectSpread2 = $6bd1657ac6a11654$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5DrBw = parcelRequire("5DrBw");
var $6bd1657ac6a11654$var$getModuleComponentKey = $5DrBw.getModuleComponentKey, $6bd1657ac6a11654$var$getModuleOperationKey = $5DrBw.getModuleOperationKey;
function $6bd1657ac6a11654$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $6bd1657ac6a11654$var$_objectSpread2["default"])({}, response);
    // $FlowFixMe[prop-missing]
    data[$6bd1657ac6a11654$var$getModuleComponentKey(name)] = component;
    // $FlowFixMe[prop-missing]
    data[$6bd1657ac6a11654$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $6bd1657ac6a11654$var$createPayloadFor3DField;

});

parcelRegister("k9Ckr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $idJ2w = parcelRequire("idJ2w");
var $eac26137970f79c4$var$getDataIDsFromFragment = $idJ2w.getDataIDsFromFragment, $eac26137970f79c4$var$getSelector = $idJ2w.getSelector, $eac26137970f79c4$var$getVariablesFromFragment = $idJ2w.getVariablesFromFragment;

var $hXXaI = parcelRequire("hXXaI");

var $dsOUI = parcelRequire("dsOUI");

var $8Q6tr = parcelRequire("8Q6tr");

var $1pW7i = parcelRequire("1pW7i");
var $eac26137970f79c4$var$intern = $1pW7i.intern;
function $eac26137970f79c4$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $eac26137970f79c4$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? "null" : selector.kind === "SingularReaderSelector" ? selector.owner.identifier : "[" + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(",") + "]";
    var fragmentVariables = $eac26137970f79c4$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $eac26137970f79c4$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($dsOUI.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === "undefined" ? "missing" : dataIDs == null ? "null" : Array.isArray(dataIDs) ? "[" + dataIDs.join(",") + "]" : dataIDs;
        ids = $dsOUI.STRING_INTERN_LEVEL <= 1 ? ids : $eac26137970f79c4$var$intern(ids, $dsOUI.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + "/" + fragmentNode.name + "/" + (fragmentVariables == null || $hXXaI(fragmentVariables) ? "{}" : JSON.stringify($8Q6tr(fragmentVariables))) + "/" + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "missing";
        _ids = $dsOUI.STRING_INTERN_LEVEL <= 1 ? _ids : $eac26137970f79c4$var$intern(_ids, $dsOUI.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + "/" + fragmentNode.name + "/" + JSON.stringify($8Q6tr(fragmentVariables)) + "/" + _ids;
    }
}
module.exports = $eac26137970f79c4$var$getFragmentIdentifier;

});
parcelRegister("hXXaI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
// $FlowFixMe[method-unbinding] added when improving typing for this parameters
var $d145d8a2e4f68eb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d145d8a2e4f68eb2$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($d145d8a2e4f68eb2$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $d145d8a2e4f68eb2$var$isEmptyObject;

});


parcelRegister("leZHb", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7U4ur = parcelRequire("7U4ur");

var $aaXwj = parcelRequire("aaXwj");
function $f76ac337ef5e9221$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $7U4ur(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $aaXwj(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $aaXwj(false);
    var identifierField = refetchMetadata.identifierField;
    !(identifierField == null || typeof identifierField === "string") && $aaXwj(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $f76ac337ef5e9221$var$getPaginationMetadata;

});
parcelRegister("7U4ur", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
function $5c113ef78376fb1e$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $aaXwj(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $aaXwj(false);
    // handle both commonjs and es modules
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== "string") && $aaXwj(false);
    var identifierField = refetchMetadata.identifierField;
    !(identifierField == null || typeof identifierField === "string") && $aaXwj(false);
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierField: identifierField,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $5c113ef78376fb1e$var$getRefetchMetadata;

});


parcelRegister("5UXry", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $44f04aea96fbae50$var$_interopRequireDefault = $1jnue.default;

var $44f04aea96fbae50$var$_defineProperty2 = $44f04aea96fbae50$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $44f04aea96fbae50$var$_objectSpread4 = $44f04aea96fbae50$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $44f04aea96fbae50$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === "backward") {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $aaXwj(false);
        var _paginationVariables = (0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $aaXwj(false);
    var paginationVariables = (0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $44f04aea96fbae50$var$getPaginationVariables;

});

parcelRegister("402wI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2e991f3c1da01eee$var$_interopRequireDefault = $1jnue.default;

var $2e991f3c1da01eee$var$_createForOfIteratorHelper2 = $2e991f3c1da01eee$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
function $2e991f3c1da01eee$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $2e991f3c1da01eee$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === "number") {
                !Array.isArray(result) && $aaXwj(false);
                result = result[key];
            } else {
                !(typeof result === "object" && !Array.isArray(result)) && $aaXwj(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $2e991f3c1da01eee$var$getValueAtPath;

});

parcelRegister("9JzHH", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $7164030bf567370b$var$profileHandlersByName = {};
var $7164030bf567370b$var$defaultProfiler = {
    stop: function stop() {}
};
/**
 * @public
 *
 * Instruments methods to allow profiling various parts of Relay. Profiling code
 * in Relay consists of three steps:
 *
 *  - Instrument the function to be profiled.
 *  - Attach handlers to the instrumented function.
 *  - Run the code which triggers the handlers.
 *
 * Handlers attached to instrumented methods are called with an instrumentation
 * name and a callback that must be synchronously executed:
 *
 *   instrumentedMethod.attachHandler(function(name, callback) {
 *     const start = performance.now();
 *     callback();
 *     console.log('Duration', performance.now() - start);
 *   });
 *
 * Handlers for profiles are callbacks that return a stop method:
 *
 *   RelayProfiler.attachProfileHandler('profileName', (name, state) => {
 *     const start = performance.now();
 *     return function stop(name, state) {
 *       console.log(`Duration (${name})`, performance.now() - start);
 *     }
 *   });
 */ var $7164030bf567370b$var$RelayProfiler = {
    /**
   * Instruments profiling for arbitrarily asynchronous code by a name.
   *
   *   const timerProfiler = RelayProfiler.profile('timeout');
   *   setTimeout(function() {
   *     timerProfiler.stop();
   *   }, 1000);
   *
   *   RelayProfiler.attachProfileHandler('timeout', ...);
   *
   * Arbitrary state can also be passed into `profile` as a second argument. The
   * attached profile handlers will receive this as the second argument.
   */ profile: function profile(name, state) {
        var handlers = $7164030bf567370b$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $7164030bf567370b$var$defaultProfiler;
    },
    /**
   * Attaches a handler to profiles with the supplied name.
   */ attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$7164030bf567370b$var$profileHandlersByName.hasOwnProperty(name)) $7164030bf567370b$var$profileHandlersByName[name] = [];
        $7164030bf567370b$var$profileHandlersByName[name].push(handler);
    },
    /**
   * Detaches a handler attached via `attachProfileHandler`.
   */ detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($7164030bf567370b$var$profileHandlersByName.hasOwnProperty(name)) $7164030bf567370b$var$removeFromArray($7164030bf567370b$var$profileHandlersByName[name], handler);
    }
};
function $7164030bf567370b$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $7164030bf567370b$var$RelayProfiler;

});




parcelRegister("dtE14", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $9cfd0632bd918039$var$_interopRequireDefault = $1jnue.default;

var $9cfd0632bd918039$var$_objectSpread2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $9cfd0632bd918039$var$_objectWithoutPropertiesLoose2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("c05no")));

var $9cfd0632bd918039$var$_assertThisInitialized2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $9cfd0632bd918039$var$_inheritsLoose2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $9cfd0632bd918039$var$_defineProperty2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("g5Zhu")));
var $9cfd0632bd918039$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lSLpg = parcelRequire("lSLpg");

var $3ixBO = parcelRequire("3ixBO");
var $9cfd0632bd918039$var$getContainerName = $3ixBO.getContainerName;

var $6IwOm = parcelRequire("6IwOm");
var $9cfd0632bd918039$var$assertRelayContext = $6IwOm.assertRelayContext;

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $9cfd0632bd918039$var$createFragmentSpecResolver = $eJz0f.createFragmentSpecResolver, $9cfd0632bd918039$var$getDataIDsFromObject = $eJz0f.getDataIDsFromObject, $9cfd0632bd918039$var$isScalarAndEqual = $eJz0f.isScalarAndEqual;
/**
 * Composes a React component class, returning a new class that intercepts
 * props, resolving them with the provided fragments and subscribing for
 * updates.
 */ function $9cfd0632bd918039$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $9cfd0632bd918039$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $9cfd0632bd918039$var$_inheritsLoose2["default"])(_class, _React$Component);
        // $FlowFixMe[missing-local-annot]
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $9cfd0632bd918039$var$_defineProperty2["default"])((0, $9cfd0632bd918039$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return(// If this event belongs to the current data source, update.
                    // Otherwise we should ignore it.
                    resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $9cfd0632bd918039$var$getRelayProp(updatedState.relayProp.environment)
                    } : null);
                });
            });
            var relayContext = $9cfd0632bd918039$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            // Do not provide a subscription/callback here.
            // It is possible for this render to be interrupted or aborted,
            // In which case the subscription would cause a leak.
            // We will add the subscription in componentDidMount().
            var resolver = $9cfd0632bd918039$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $9cfd0632bd918039$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        /**
     * When new props are received, read data for the new props and subscribe
     * for updates. Props may be the same in which case previous data and
     * subscriptions can be reused.
     */ _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            // Any props change could impact the query, so we mirror props in state.
            // This is an unusual pattern, but necessary for this container usecase.
            var prevProps = prevState.prevProps;
            var relayContext = $9cfd0632bd918039$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $9cfd0632bd918039$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $9cfd0632bd918039$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            // If the environment has changed or props point to new records then
            // previously fetched data and any pending fetches no longer apply:
            // - Existing references are on the old environment.
            // - Existing references are based on old variables.
            // - Pending fetches are for the previous records.
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$ewhZB(prevIDs, nextIDs)) {
                // Do not provide a subscription/callback here.
                // It is possible for this render to be interrupted or aborted,
                // In which case the subscription would cause a leak.
                // We will add the subscription in componentDidUpdate().
                resolver = $9cfd0632bd918039$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $9cfd0632bd918039$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $9cfd0632bd918039$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            // Short-circuit if any Relay-related data has changed
            if (nextState.data !== this.state.data) return true;
            // Otherwise, for convenience short-circuit if all non-Relay props
            // are scalar and equal
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === "__relayContext") {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$9cfd0632bd918039$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        } /**
     * Render new data for the existing props/context.
     */ ;
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            // External values could change between render and commit.
            // Check for this case, even though it requires an extra store read.
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            // Event listeners are only safe to add during the commit phase,
            // So they won't leak if render is interrupted or errors.
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            // External values could change between render and commit.
            // Check for this case, even though it requires an extra store read.
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $9cfd0632bd918039$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $9cfd0632bd918039$var$_excluded);
            return $acw62.createElement(Component, (0, $9cfd0632bd918039$var$_objectSpread2["default"])((0, $9cfd0632bd918039$var$_objectSpread2["default"])((0, $9cfd0632bd918039$var$_objectSpread2["default"])({}, props), this.state.data), {}, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($acw62.Component), (0, $9cfd0632bd918039$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $9cfd0632bd918039$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
/**
 * Wrap the basic `createContainer()` function with logic to adapt to the
 * `context.relay.environment` in which it is rendered. Specifically, the
 * extraction of the environment-specific version of fragments in the
 * `fragmentSpec` is memoized once per environment, rather than once per
 * instance of the container constructed/rendered.
 */ function $9cfd0632bd918039$var$createContainer(Component, fragmentSpec) {
    // $FlowFixMe[incompatible-return]
    return $lSLpg(Component, fragmentSpec, $9cfd0632bd918039$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $9cfd0632bd918039$var$createContainer
};

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $aAhot(t, o);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lSLpg", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $fee36a111fa579ba$var$_interopRequireDefault = $1jnue.default;

var $fee36a111fa579ba$var$_extends2 = $fee36a111fa579ba$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $9RnpX = parcelRequire("9RnpX");

var $3ixBO = parcelRequire("3ixBO");
var $fee36a111fa579ba$var$getComponentName = $3ixBO.getComponentName, $fee36a111fa579ba$var$getContainerName = $3ixBO.getContainerName;

var $j5wbN = parcelRequire("j5wbN");

var $7WvV7 = parcelRequire("7WvV7");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $fee36a111fa579ba$var$getFragment = $eJz0f.getFragment;
var $fee36a111fa579ba$var$useContext = $acw62.useContext;
/**
 * Helper to create the Relay HOCs with ref forwarding, setting the displayName
 * and reading the React context.
 */ function $fee36a111fa579ba$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    // Sanity-check user-defined fragment input
    var containerName = $fee36a111fa579ba$var$getContainerName(ComponentClass);
    $9RnpX($fee36a111fa579ba$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $fee36a111fa579ba$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function forwardRef(props, ref) {
        var _queryRendererContext;
        var context = $fee36a111fa579ba$var$useContext($j5wbN);
        !(context != null) && $aaXwj(false);
        var queryRendererContext = $fee36a111fa579ba$var$useContext($7WvV7);
        return /*#__PURE__*/ $acw62.createElement(Container, (0, $fee36a111fa579ba$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    forwardRef.displayName = containerName;
    var ForwardContainer = $acw62.forwardRef(forwardRef);
    // $FlowFixMe[incompatible-return]
    return ForwardContainer;
}
module.exports = $fee36a111fa579ba$var$buildReactRelayContainer;

});
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9RnpX", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
/**
 * Fail fast if the user supplies invalid fragments as input.
 */ function $72db3a93f5da1b8a$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === "object") && $aaXwj(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === "object" || typeof fragment === "function")) && $aaXwj(false);
    }
}
module.exports = $72db3a93f5da1b8a$var$assertFragmentMap;

});

parcelRegister("3ixBO", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $266d1f901031532e$var$getComponentName(component) {
    return component.displayName || component.name || "Component";
}
function $266d1f901031532e$var$getContainerName(Component) {
    return "Relay(" + $266d1f901031532e$var$getComponentName(Component) + ")";
}
module.exports = {
    getComponentName: $266d1f901031532e$var$getComponentName,
    getContainerName: $266d1f901031532e$var$getContainerName
};

});

parcelRegister("7WvV7", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $acw62 = parcelRequire("acw62");
module.exports = $acw62.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("6IwOm", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $9oOwi = parcelRequire("9oOwi");

var $aaXwj = parcelRequire("aaXwj");
/**
 * Asserts that the input is a matches the `RelayContext` type defined in
 * `RelayEnvironmentTypes` and returns it as that type.
 */ function $4e404dc609e87032$var$assertRelayContext(relay) {
    !$4e404dc609e87032$var$isRelayContext(relay) && $aaXwj(false);
    return relay;
}
/**
 * Determine if the input is a plain object that matches the `RelayContext`
 * type defined in `RelayEnvironmentTypes`.
 */ function $4e404dc609e87032$var$isRelayContext(context) {
    return typeof context === "object" && context !== null && !Array.isArray(context) && $9oOwi(context.environment);
}
module.exports = {
    assertRelayContext: $4e404dc609e87032$var$assertRelayContext,
    isRelayContext: $4e404dc609e87032$var$isRelayContext
};

});
parcelRegister("9oOwi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Determine if a given value is an object that implements the `Environment`
 * interface defined in `RelayEnvironmentTypes`.
 */ function $6d7d8b201d442cc1$var$isRelayEnvironment(environment) {
    return typeof environment === "object" && environment !== null && // TODO: add applyMutation/sendMutation once ready in both cores
    typeof environment.check === "function" && typeof environment.lookup === "function" && typeof environment.retain === "function" && typeof environment.execute === "function" && typeof environment.subscribe === "function";
}
module.exports = $6d7d8b201d442cc1$var$isRelayEnvironment;

});



parcelRegister("d4mGr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $j5wbN = parcelRequire("j5wbN");

var $7WvV7 = parcelRequire("7WvV7");

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $983d3e946124bafe$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $983d3e946124bafe$var$deepFreeze = $eJz0f.deepFreeze, $983d3e946124bafe$var$getRequest = $eJz0f.getRequest;
var $983d3e946124bafe$var$useLayoutEffect = $acw62.useLayoutEffect, $983d3e946124bafe$var$useState = $acw62.useState, $983d3e946124bafe$var$useRef = $acw62.useRef, $983d3e946124bafe$var$useMemo = $acw62.useMemo;
var $983d3e946124bafe$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $983d3e946124bafe$var$useDeepCompare(value) {
    var latestValue = $acw62.useRef(value);
    if (!$ewhZB(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $983d3e946124bafe$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $983d3e946124bafe$var$useDeepCompare(variables);
    var operation = $983d3e946124bafe$var$useMemo(function() {
        var request = $983d3e946124bafe$var$getRequest(query);
        return $983d3e946124bafe$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $983d3e946124bafe$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    // Use a ref to prevent rendering twice when data changes
    // because of props change
    var dataRef = $983d3e946124bafe$var$useRef(null);
    var _useState = $983d3e946124bafe$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $983d3e946124bafe$var$useRef(null);
    var snapshot = $983d3e946124bafe$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        // Run effects here so that the data can be retained
        // and subscribed before the component commits
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $983d3e946124bafe$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $acw62.createElement($7WvV7.Provider, {
        value: $983d3e946124bafe$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $983d3e946124bafe$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("4X6M3", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $39b1ed4e037781da$var$_interopRequireDefault = $1jnue.default;

var $39b1ed4e037781da$var$_extends2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("c05no")));

var $39b1ed4e037781da$var$_assertThisInitialized2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $39b1ed4e037781da$var$_inheritsLoose2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $39b1ed4e037781da$var$_defineProperty2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $39b1ed4e037781da$var$_objectSpread3 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("cbdLd")));
var $39b1ed4e037781da$var$_excluded = [
    "componentRef"
], $39b1ed4e037781da$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $39b1ed4e037781da$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lSLpg = parcelRequire("lSLpg");

var $lFfnI = parcelRequire("lFfnI");

var $3ixBO = parcelRequire("3ixBO");
var $39b1ed4e037781da$var$getComponentName = $3ixBO.getComponentName, $39b1ed4e037781da$var$getContainerName = $3ixBO.getContainerName;

var $j5wbN = parcelRequire("j5wbN");

var $twtDt = parcelRequire("twtDt");

var $6IwOm = parcelRequire("6IwOm");
var $39b1ed4e037781da$var$assertRelayContext = $6IwOm.assertRelayContext;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $39b1ed4e037781da$var$ConnectionInterface = $eJz0f.ConnectionInterface, $39b1ed4e037781da$var$Observable = $eJz0f.Observable, $39b1ed4e037781da$var$RelayFeatureFlags = $eJz0f.RelayFeatureFlags, $39b1ed4e037781da$var$createFragmentSpecResolver = $eJz0f.createFragmentSpecResolver, $39b1ed4e037781da$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $39b1ed4e037781da$var$getDataIDsFromObject = $eJz0f.getDataIDsFromObject, $39b1ed4e037781da$var$getRequest = $eJz0f.getRequest, $39b1ed4e037781da$var$getVariablesFromObject = $eJz0f.getVariablesFromObject, $39b1ed4e037781da$var$isScalarAndEqual = $eJz0f.isScalarAndEqual;
parcelRequire("8Fbfi");
var $39b1ed4e037781da$var$FORWARD = "forward";
/**
 * Extends the functionality of RelayFragmentContainer by providing a mechanism
 * to load more data from a connection.
 *
 * # Configuring a PaginationContainer
 *
 * PaginationContainer accepts the standard FragmentContainer arguments and an
 * additional `connectionConfig` argument:
 *
 * - `Component`: the component to be wrapped/rendered.
 * - `fragments`: an object whose values are `graphql` fragments. The object
 *   keys determine the prop names by which fragment data is available.
 * - `connectionConfig`: an object that determines how to load more connection
 *   data. Details below.
 *
 * # Loading More Data
 *
 * Use `props.relay.hasMore()` to determine if there are more items to load.
 *
 * ```
 * hasMore(): boolean
 * ```
 *
 * Use `props.relay.isLoading()` to determine if a previous call to `loadMore()`
 * is still pending. This is convenient for avoiding duplicate load calls.
 *
 * ```
 * isLoading(): boolean
 * ```
 *
 * Use `props.relay.loadMore()` to load more items. This will return null if
 * there are no more items to fetch, otherwise it will fetch more items and
 * return a Disposable that can be used to cancel the fetch.
 *
 * `pageSize` should be the number of *additional* items to fetch (not the
 * total).
 *
 * ```
 * loadMore(pageSize: number, callback: ?(error: ?Error) => void): ?Disposable
 * ```
 *
 * A complete example:
 *
 * ```
 * class Foo extends React.Component {
 *   ...
 *   _onEndReached() {
 *     if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
 *       return;
 *     }
 *     this.props.relay.loadMore(10);
 *   }
 *   ...
 * }
 * ```
 *
 * # Connection Config
 *
 * Here's an example, followed by details of each config property:
 *
 * ```
 * ReactRelayPaginationContainer.createContainer(
 *   Component,
 *   {
 *     user: graphql`fragment FriendsFragment on User {
 *       friends(after: $afterCursor first: $count) @connection {
 *         edges { ... }
 *         pageInfo {
 *           startCursor
 *           endCursor
 *           hasNextPage
 *           hasPreviousPage
 *         }
 *       }
 *     }`,
 *   },
 *   {
 *     direction: 'forward',
 *     getConnectionFromProps(props) {
 *       return props.user && props.user.friends;
 *     },
 *     getFragmentVariables(vars, totalCount) {
 *       // The component presumably wants *all* edges, not just those after
 *       // the cursor, so notice that we don't set $afterCursor here.
 *       return {
 *         ...vars,
 *         count: totalCount,
 *       };
 *     },
 *     getVariables(props, {count, cursor}, fragmentVariables) {
 *       return {
 *         id: props.user.id,
 *         afterCursor: cursor,
 *         count,
 *       },
 *     },
 *     query: graphql`
 *       query FriendsQuery($id: ID!, $afterCursor: ID, $count: Int!) {
 *         node(id: $id) {
 *           ...FriendsFragment
 *         }
 *       }
 *     `,
 *   }
 * );
 * ```
 *
 * ## Config Properties
 *
 * - `direction`: Either "forward" to indicate forward pagination using
 *   after/first, or "backward" to indicate backward pagination using
 *   before/last.
 * - `getConnectionFromProps(props)`: PaginationContainer doesn't magically know
 *   which connection data you mean to fetch more of (a container might fetch
 *   multiple connections, but can only paginate one of them). This function is
 *   given the fragment props only (not full props), and should return the
 *   connection data. See the above example that returns the friends data via
 *   `props.user.friends`.
 * - `getFragmentVariables(previousVars, totalCount)`: Given the previous variables
 *   and the new total number of items, get the variables to use when reading
 *   your fragments. Typically this means setting whatever your local "count"
 *   variable is to the value of `totalCount`. See the example.
 * - `getVariables(props, {count, cursor})`: Get the variables to use when
 *   fetching the pagination `query`. You may determine the root object id from
 *   props (see the example that uses `props.user.id`) and may also set whatever
 *   variables you use for the after/first/before/last calls based on the count
 *   and cursor.
 * - `query`: A query to use when fetching more connection data. This should
 *   typically reference one of the container's fragment (as in the example)
 *   to ensure that all the necessary fields for sub-components are fetched.
 */ function $39b1ed4e037781da$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $aaXwj(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== "object") return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $39b1ed4e037781da$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $aaXwj(false);
    return function(prevVars, totalCount) {
        return (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, prevVars), {}, (0, $39b1ed4e037781da$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $39b1ed4e037781da$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        // HACK: metadata is always set to `undefined` in classic. In modern, even
        // if empty, it is set to null (never undefined). We use that knowlege to
        // check if we're dealing with classic or modern
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $aaXwj(false);
            !!foundConnectionMetadata && $aaXwj(false);
            foundConnectionMetadata = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $aaXwj(false);
    return foundConnectionMetadata || {};
}
function $39b1ed4e037781da$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === "function" ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === "function" && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $39b1ed4e037781da$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $39b1ed4e037781da$var$getComponentName(Component);
    var containerName = $39b1ed4e037781da$var$getContainerName(Component);
    var metadata = $39b1ed4e037781da$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $39b1ed4e037781da$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $aaXwj(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $39b1ed4e037781da$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $39b1ed4e037781da$var$_inheritsLoose2["default"])(_class, _React$Component);
        // $FlowFixMe[missing-local-annot]
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage("refetchConnection")) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $39b1ed4e037781da$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage("loadMore")) return {
                    dispose: function dispose() {}
                };
                var observer = $39b1ed4e037781da$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $39b1ed4e037781da$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $39b1ed4e037781da$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $39b1ed4e037781da$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        } /**
     * When new props are received, read data for the new props and subscribe
     * for updates. Props may be the same in which case previous data and
     * subscriptions can be reused.
     */ ;
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $39b1ed4e037781da$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $39b1ed4e037781da$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $39b1ed4e037781da$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $lFfnI(fragments, this.props);
            var nextRootVariables = $lFfnI(fragments, nextProps);
            // If the environment has changed or props point to new records then
            // previously fetched data and any pending fetches no longer apply:
            // - Existing references are on the old environment.
            // - Existing references are based on old variables.
            // - Pending fetches are for the previous records.
            if (relayContext.environment !== this.state.prevContext.environment || !$ewhZB(prevRootVariables, nextRootVariables) || !$ewhZB(prevIDs, nextIDs)) {
                this._cleanup();
                // Child containers rely on context.relay being mutated (for gDSFP).
                if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            // Short-circuit if any Relay-related data has changed
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            // Otherwise, for convenience short-circuit if all non-Relay props
            // are scalar and equal
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === "__relayContext") {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$39b1ed4e037781da$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            // External values could change between render and commit.
            // Check for this case, even though it requires an extra store read.
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            // Event listeners are only safe to add during the commit phase,
            // So they won't leak if render is interrupted or errors.
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            // External values could change between render and commit.
            // Check for this case, even though it requires an extra store read.
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        } /**
     * Render new data for the existing props/context.
     */ ;
        _proto._getConnectionData = function _getConnectionData() {
            // Extract connection data and verify there are more edges to fetch
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $39b1ed4e037781da$var$_excluded);
            var props = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $39b1ed4e037781da$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === "object") && $aaXwj(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $aaXwj(false);
            !(typeof pageInfo === "object") && $aaXwj(false);
            var hasMore = direction === $39b1ed4e037781da$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $39b1ed4e037781da$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== "boolean" || edges.length !== 0 && typeof cursor === "undefined") return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $twtDt();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $39b1ed4e037781da$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $39b1ed4e037781da$var$_excluded2);
            var props = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $lFfnI(fragments, restProps);
            fragmentVariables = $39b1ed4e037781da$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === "object" && fetchVariables !== null) && $aaXwj(false);
            fetchVariables = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $39b1ed4e037781da$var$getRequest(connectionConfig.query);
            var operation = $39b1ed4e037781da$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                // Workaround slightly different handling for connection in different
                // core implementations:
                // - Classic core requires the count to be explicitly incremented
                // - Modern core automatically appends new items, updating the count
                //   isn't required to see new data.
                //
                // `setState` is only required if changing the variables would change the
                // resolved data.
                // TODO #14894725: remove PaginationContainer equal check
                if (!$ewhZB(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $39b1ed4e037781da$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next(); // pass void to public observer's `next`
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $39b1ed4e037781da$var$_excluded3);
            return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $acw62.createElement(Component, (0, $39b1ed4e037781da$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($acw62.Component), (0, $39b1ed4e037781da$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
/**
 * Wrap the basic `createContainer()` function with logic to adapt to the
 * `context.relay.environment` in which it is rendered. Specifically, the
 * extraction of the environment-specific version of fragments in the
 * `fragmentSpec` is memoized once per environment, rather than once per
 * instance of the container constructed/rendered.
 */ function $39b1ed4e037781da$var$createContainer(Component, fragmentSpec, connectionConfig) {
    // $FlowFixMe[incompatible-return]
    return $lSLpg(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $39b1ed4e037781da$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $39b1ed4e037781da$var$createContainer
};

});
parcelRegister("lFfnI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $fc595bc5ba55864e$var$_interopRequireDefault = $1jnue.default;

var $fc595bc5ba55864e$var$_objectSpread2 = $fc595bc5ba55864e$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $eJz0f = parcelRequire("eJz0f");
var $fc595bc5ba55864e$var$getSelector = $eJz0f.getSelector;
function $fc595bc5ba55864e$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    // NOTE: For extra safety, we make sure the rootVariables include the
    // variables from all owners in this fragmentSpec, even though they
    // should all point to the same owner
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $fc595bc5ba55864e$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === "PluralReaderSelector" ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $fc595bc5ba55864e$var$_objectSpread2["default"])((0, $fc595bc5ba55864e$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $fc595bc5ba55864e$var$getRootVariablesForFragments;

});

parcelRegister("twtDt", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $058be6cd9ce208dc$var$_interopRequireDefault = $1jnue.default;

var $058be6cd9ce208dc$var$_defineProperty2 = $058be6cd9ce208dc$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $aaXwj = parcelRequire("aaXwj");

var $eJz0f = parcelRequire("eJz0f");
var $058be6cd9ce208dc$var$fetchQuery = $eJz0f.__internal.fetchQuery, $058be6cd9ce208dc$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $058be6cd9ce208dc$var$isRelayModernEnvironment = $eJz0f.isRelayModernEnvironment;
var $058be6cd9ce208dc$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $058be6cd9ce208dc$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $058be6cd9ce208dc$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === "store-and-network" || fetchPolicy === "store-or-network") {
            if (environment.check(operation).status === "available") {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            // We don't reset '_didFetchFinish' because another callback may be set
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            // We may have partially fulfilled the request, so let the next request
            // or the unmount dispose of the references.
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            // Let the next request or the unmount code dispose of the references.
            // We may have partially fulfilled the request.
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$058be6cd9ce208dc$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $058be6cd9ce208dc$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $aaXwj(false);
        if (typeof onDataChange === "function") {
            // Mutate the most recent fetchOptions in place,
            // So that in-progress requests can access the updated callback.
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                // We don't reset '_didFetchFinish' because another callback may be set
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    } /**
   * `fetch` fetches the data for the given operation.
   * If a result is immediately available synchronously, it will be synchronously
   * returned by this function.
   *
   * Otherwise, the fetched result will be communicated via the `onDataChange` callback.
   * `onDataChange` will be called with the first result (**if it wasn't returned synchronously**),
   * and then subsequently whenever the data changes.
   */ ;
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) // $FlowFixMe[incompatible-use]
        this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $058be6cd9ce208dc$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                // If we received a response,
                // Make a note that to notify the callback when it's later added.
                _this2._didFetchFinish = true;
                _this2._error = null;
                // Only notify of the first result if `next` is being called **asynchronously**
                // (i.e. after `fetch` has returned).
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                // If we received a response when we didn't have a change callback,
                // Make a note that to notify the callback when it's later added.
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                // Only notify of error if `error` is being called **asynchronously**
                // (i.e. after `fetch` has returned).
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $aaXwj(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null // If there are onDataChangeCallbacks they will be reused
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        // order is important, dispose of pendingFetch before selectionReferences
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $aaXwj(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        // `_onQueryDataAvailable` can be called synchronously the first time and can be called
        // multiple times by network layers that support data subscriptions.
        // Wait until the first payload to call `onDataChange` and subscribe for data updates.
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        // Subscribe to changes in the data of the root fragment
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            // Read from this._fetchOptions in case onDataChange() was lazily added.
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $058be6cd9ce208dc$var$ReactRelayQueryFetcher;

});


parcelRegister("lThBY", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $fefc654fde92ad78$var$_interopRequireDefault = $1jnue.default;

var $fefc654fde92ad78$var$_objectSpread2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $fefc654fde92ad78$var$_assertThisInitialized2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $fefc654fde92ad78$var$_inheritsLoose2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $fefc654fde92ad78$var$_defineProperty2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $j5wbN = parcelRequire("j5wbN");

var $twtDt = parcelRequire("twtDt");

var $7WvV7 = parcelRequire("7WvV7");

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $fefc654fde92ad78$var$RelayFeatureFlags = $eJz0f.RelayFeatureFlags;

var $eJz0f = parcelRequire("eJz0f");
var $fefc654fde92ad78$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $fefc654fde92ad78$var$deepFreeze = $eJz0f.deepFreeze, $fefc654fde92ad78$var$getRequest = $eJz0f.getRequest;
/**
 * React may double-fire the constructor, and we call 'fetch' in the
 * constructor. If a request is already in flight from a previous call to the
 * constructor, just reuse the query fetcher and wait for the response.
 */ var $fefc654fde92ad78$var$requestCache = {};
var $fefc654fde92ad78$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
/**
 * @public
 *
 * Orchestrates fetching and rendering data for a single view or view hierarchy:
 * - Fetches the query/variables using the given network implementation.
 * - Normalizes the response(s) to that query, publishing them to the given
 *   store.
 * - Renders the pending/fail/success states with the provided render function.
 * - Subscribes for updates to the root data and re-renders with any changes.
 */ var $fefc654fde92ad78$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $fefc654fde92ad78$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        // Callbacks are attached to the current instance and shared with static
        // lifecyles by bundling with state. This is okay to do because the
        // callbacks don't change in reaction to props. However we should not
        // "leak" them before mounting (since we would be unable to clean up). For
        // that reason, we define them as null initially and fill them in after
        // mounting to avoid leaking memory.
        (0, $fefc654fde92ad78$var$_defineProperty2["default"])((0, $fefc654fde92ad78$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $fefc654fde92ad78$var$requestCache[prevRequestCacheKey];
                // Don't update state if nothing has changed.
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $fefc654fde92ad78$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $fefc654fde92ad78$var$getRequest(query);
            requestCacheKey = $fefc654fde92ad78$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $fefc654fde92ad78$var$requestCache[requestCacheKey] ? $fefc654fde92ad78$var$requestCache[requestCacheKey].queryFetcher : new $twtDt();
        } else queryFetcher = new $twtDt();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $fefc654fde92ad78$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $fefc654fde92ad78$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$ewhZB(prevState.prevPropsVariables, nextProps.variables)) return $fefc654fde92ad78$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            // This block only runs if the component has previously "unmounted"
            // due to it being hidden by the Offscreen API, or during fast refresh.
            // At this point, the current cached resource will have been disposed
            // by the previous cleanup, so instead of attempting to
            // do our regular commit setup, so that the query is re-evaluated
            // (and potentially cause a refetch).
            this._maybeHiddenOrFastRefresh = false;
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState(function(prevState) {
                var newState = $fefc654fde92ad78$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $fefc654fde92ad78$var$requestCache[requestCacheKey] != null) {
                    if ($fefc654fde92ad78$var$RelayFeatureFlags.ENABLE_QUERY_RENDERER_SET_STATE_PREVENTION) {
                        var fetchResult = queryFetcher.getFetchResult();
                        if (fetchResult != null) {
                            var _fetchResult$snapshot, _fetchResult$error;
                            var snapshot = (_fetchResult$snapshot = fetchResult.snapshot) !== null && _fetchResult$snapshot !== void 0 ? _fetchResult$snapshot : null;
                            var error = (_fetchResult$error = fetchResult.error) !== null && _fetchResult$error !== void 0 ? _fetchResult$error : null;
                            var prevRequestCacheKey = prevState.requestCacheKey;
                            if (prevRequestCacheKey != null) delete $fefc654fde92ad78$var$requestCache[prevRequestCacheKey];
                            newState.renderProps = $fefc654fde92ad78$var$getRenderProps(error, snapshot, queryFetcher, prevState.retryCallbacks);
                            newState.snapshot = snapshot;
                            newState.requestCacheKey = null;
                        } else queryFetcher.setOnDataChange(_this2._handleDataChange);
                    } else queryFetcher.setOnDataChange(_this2._handleDataChange);
                }
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        // We don't need to cache the request after the component commits
        if (requestCacheKey) delete $fefc654fde92ad78$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $fefc654fde92ad78$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $fefc654fde92ad78$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        // Re-initialize the ReactRelayQueryFetcher with callbacks.
        // If data has changed since constructions, this will re-render.
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        // We don't need to cache the request after the component commits
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $fefc654fde92ad78$var$requestCache[requestCacheKey];
            // HACK
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $acw62.createElement($7WvV7.Provider, {
            value: $fefc654fde92ad78$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($acw62.Component);
function $fefc654fde92ad78$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        // `props: null` indicates that the data is being fetched (i.e. loading)
        retry: null
    };
}
function $fefc654fde92ad78$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        // `props: {}` indicates no data available
        retry: null
    };
}
function $fefc654fde92ad78$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === "function") retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === "function") // If retrying after an error and no synchronous result available,
            // reset the render props
            retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $fefc654fde92ad78$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $fefc654fde92ad78$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $fefc654fde92ad78$var$getRequest(query);
        var requestCacheKey = $fefc654fde92ad78$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $fefc654fde92ad78$var$requestCache[requestCacheKey] ? $fefc654fde92ad78$var$requestCache[requestCacheKey].queryFetcher : new $twtDt(prevSelectionReferences);
    } else queryFetcher = new $twtDt(prevSelectionReferences);
    return (0, $fefc654fde92ad78$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $fefc654fde92ad78$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $fefc654fde92ad78$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $fefc654fde92ad78$var$getRequest(query);
        var operation = $fefc654fde92ad78$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === "string" && $fefc654fde92ad78$var$requestCache[requestCacheKey]) {
            // This same request is already in flight.
            var snapshot = $fefc654fde92ad78$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) // Use the cached response
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else // Render loading state
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            // Use network data first, since it may be fresher
            var _snapshot = querySnapshot || storeSnapshot;
            // cache the request to avoid duplicate requests
            requestCacheKey = requestCacheKey || $fefc654fde92ad78$var$getRequestCacheKey(request.params, props.variables);
            $fefc654fde92ad78$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $fefc654fde92ad78$var$getEmptyRenderProps(),
            requestCacheKey: null // if there is an error, don't cache request
        };
    }
}
module.exports = $fefc654fde92ad78$var$ReactRelayQueryRenderer;

});

parcelRegister("2oD7l", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $1bec2a90a13db051$var$_interopRequireDefault = $1jnue.default;

var $1bec2a90a13db051$var$_extends2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $1bec2a90a13db051$var$_objectWithoutPropertiesLoose2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("c05no")));

var $1bec2a90a13db051$var$_objectSpread2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $1bec2a90a13db051$var$_assertThisInitialized2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $1bec2a90a13db051$var$_inheritsLoose2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $1bec2a90a13db051$var$_defineProperty2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("g5Zhu")));
var $1bec2a90a13db051$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lSLpg = parcelRequire("lSLpg");

var $lFfnI = parcelRequire("lFfnI");

var $3ixBO = parcelRequire("3ixBO");
var $1bec2a90a13db051$var$getContainerName = $3ixBO.getContainerName;

var $j5wbN = parcelRequire("j5wbN");

var $twtDt = parcelRequire("twtDt");

var $6IwOm = parcelRequire("6IwOm");
var $1bec2a90a13db051$var$assertRelayContext = $6IwOm.assertRelayContext;

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $1bec2a90a13db051$var$Observable = $eJz0f.Observable, $1bec2a90a13db051$var$createFragmentSpecResolver = $eJz0f.createFragmentSpecResolver, $1bec2a90a13db051$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $1bec2a90a13db051$var$getDataIDsFromObject = $eJz0f.getDataIDsFromObject, $1bec2a90a13db051$var$getRequest = $eJz0f.getRequest, $1bec2a90a13db051$var$getVariablesFromObject = $eJz0f.getVariablesFromObject, $1bec2a90a13db051$var$isScalarAndEqual = $eJz0f.isScalarAndEqual;
parcelRequire("8Fbfi");
/**
 * Composes a React component class, returning a new class that intercepts
 * props, resolving them with the provided fragments and subscribing for
 * updates.
 */ function $1bec2a90a13db051$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $1bec2a90a13db051$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $1bec2a90a13db051$var$_inheritsLoose2["default"])(_class, _React$Component);
        // $FlowFixMe[missing-local-annot]
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $1bec2a90a13db051$var$_defineProperty2["default"])((0, $1bec2a90a13db051$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return(// If this event belongs to the current data source, update.
                    // Otherwise we should ignore it.
                    resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null);
                });
            });
            (0, $1bec2a90a13db051$var$_defineProperty2["default"])((0, $1bec2a90a13db051$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $1bec2a90a13db051$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $lFfnI(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === "function" ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $1bec2a90a13db051$var$_objectSpread2["default"])((0, $1bec2a90a13db051$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $1bec2a90a13db051$var$_objectSpread2["default"])((0, $1bec2a90a13db051$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === "function" ? {
                    // callback is not exectued on complete or unsubscribe
                    // for backward compatibility
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $1bec2a90a13db051$var$getRequest(taggedNode);
                var operation = $1bec2a90a13db051$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                // TODO: T26288752 find a better way
                _this.state.localVariables = fetchVariables;
                // Cancel any previously running refetch.
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                // Declare refetchSubscription before assigning it in .start(), since
                // synchronous completion may call callbacks .subscribe() returns.
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    // TODO (T26430099): Cleanup old references
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $1bec2a90a13db051$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    // Finalizing a refetch should only clear this._refetchSubscription
                    // if the finizing subscription is the most recent call.
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $1bec2a90a13db051$var$_objectSpread2["default"])((0, $1bec2a90a13db051$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $1bec2a90a13db051$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            // Do not provide a subscription/callback here.
            // It is possible for this render to be interrupted or aborted,
            // In which case the subscription would cause a leak.
            // We will add the subscription in componentDidMount().
            var resolver = $1bec2a90a13db051$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $1bec2a90a13db051$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            // If the environment has changed or props point to new records then
            // previously fetched data and any pending fetches no longer apply:
            // - Existing references are on the old environment.
            // - Existing references are based on old variables.
            // - Pending fetches are for the previous records.
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        } /**
     * When new props are received, read data for the new props and add it to
     * state. Props may be the same in which case previous data can be reused.
     */ ;
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            // Any props change could impact the query, so we mirror props in state.
            // This is an unusual pattern, but necessary for this container usecase.
            var prevProps = prevState.prevProps;
            var relayContext = $1bec2a90a13db051$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $1bec2a90a13db051$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $1bec2a90a13db051$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $lFfnI(fragments, prevProps);
            var nextRootVariables = $lFfnI(fragments, nextProps);
            var resolver = prevState.resolver;
            // If the environment has changed or props point to new records then
            // previously fetched data and any pending fetches no longer apply:
            // - Existing references are on the old environment.
            // - Existing references are based on old variables.
            // - Pending fetches are for the previous records.
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$ewhZB(prevRootVariables, nextRootVariables) || !$ewhZB(prevIDs, nextIDs)) {
                // Do not provide a subscription/callback here.
                // It is possible for this render to be interrupted or aborted,
                // In which case the subscription would cause a leak.
                // We will add the subscription in componentDidUpdate().
                resolver = $1bec2a90a13db051$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $1bec2a90a13db051$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            // Short-circuit if any Relay-related data has changed
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            // Otherwise, for convenience short-circuit if all non-Relay props
            // are scalar and equal
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === "__relayContext") {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$1bec2a90a13db051$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            // External values could change between render and commit.
            // Check for this case, even though it requires an extra store read.
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            // Event listeners are only safe to add during the commit phase,
            // So they won't leak if render is interrupted or errors.
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            // External values could change between render and commit.
            // Check for this case, even though it requires an extra store read.
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        } /**
     * Render new data for the existing props/context.
     */ ;
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $1bec2a90a13db051$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $twtDt();
            return this._queryFetcher;
        };
        // $FlowFixMe[missing-local-annot]
        _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $1bec2a90a13db051$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $1bec2a90a13db051$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $acw62.createElement(Component, (0, $1bec2a90a13db051$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($acw62.Component), (0, $1bec2a90a13db051$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $1bec2a90a13db051$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
/**
 * Wrap the basic `createContainer()` function with logic to adapt to the
 * `context.relay.environment` in which it is rendered. Specifically, the
 * extraction of the environment-specific version of fragments in the
 * `fragmentSpec` is memoized once per environment, rather than once per
 * instance of the container constructed/rendered.
 */ function $1bec2a90a13db051$var$createContainer(Component, fragmentSpec, taggedNode) {
    // $FlowFixMe[incompatible-return]
    return $lSLpg(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $1bec2a90a13db051$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $1bec2a90a13db051$var$createContainer
};

});

parcelRegister("hAaqX", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $9pgH3 = parcelRequire("9pgH3");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $cccde464a8681a62$var$useContext = $acw62.useContext, $cccde464a8681a62$var$useEffect = $acw62.useEffect;
parcelRequire("8Fbfi");
function $cccde464a8681a62$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $cccde464a8681a62$var$useContext($9pgH3);
    var environment = $4fG2B();
    $cccde464a8681a62$var$useEffect(function() {
        environment.__log({
            name: "entrypoint.root.consume",
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $cccde464a8681a62$var$EntryPointContainer;

});
parcelRegister("9pgH3", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ // This contextual profiler can be used to wrap a react sub-tree. It will bind
// the RelayProfiler during the render phase of these components. Allows
// collecting metrics for a specific part of your application.
"use strict";

var $acw62 = parcelRequire("acw62");
var $6d9365d86eab27b6$var$ProfilerContext = $acw62.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $6d9365d86eab27b6$var$ProfilerContext;

});

parcelRegister("4fG2B", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $j5wbN = parcelRequire("j5wbN");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $31892c9d9c950969$var$useContext = $acw62.useContext;
function $31892c9d9c950969$var$useRelayEnvironment() {
    var context = $31892c9d9c950969$var$useContext($j5wbN);
    !(context != null) && $aaXwj(false);
    return context.environment;
}
module.exports = $31892c9d9c950969$var$useRelayEnvironment;

});


parcelRegister("5A24j", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1c3ii = parcelRequire("1c3ii");
var $4101eb50f14405be$var$loadQuery = $1c3ii.loadQuery;
function $4101eb50f14405be$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    // Start loading the code for the entrypoint
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            // $FlowFixMe[underconstrained-implicit-instantiation]
            preloadedQueries[queryPropName] = $4101eb50f14405be$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: "loadEntryPoint"
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $4101eb50f14405be$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            // On certain platforms, getting an es6 module with a default export from a JSResource will return an object like
            // {default: module}, so let's assume that if the "component" has a static property named "default"
            // that it's actually an es6 module wrapper, so unwrap it. This won't work for React classes with a static property named "default", but
            // that's probably a worthwhile trade-off.
            var component = // $FlowIgnore[prop-missing]
            componentModule["default"] != null ? componentModule["default"] : componentModule;
            // $FlowFixMe[incompatible-cast] - trust me Flow, its entryPoint component
            return component;
        },
        // $FlowFixMe[unsafe-getters-setters] - this has no side effects
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $4101eb50f14405be$var$loadEntryPoint;

});
parcelRegister("1c3ii", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $0de97792fcab6c65$var$_interopRequireDefault = $1jnue.default;

var $0de97792fcab6c65$var$_objectSpread2 = $0de97792fcab6c65$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $0de97792fcab6c65$var$fetchQueryDeduped = $eJz0f.__internal.fetchQueryDeduped, $0de97792fcab6c65$var$Observable = $eJz0f.Observable, $0de97792fcab6c65$var$PreloadableQueryRegistry = $eJz0f.PreloadableQueryRegistry, $0de97792fcab6c65$var$RelayFeatureFlags = $eJz0f.RelayFeatureFlags, $0de97792fcab6c65$var$ReplaySubject = $eJz0f.ReplaySubject, $0de97792fcab6c65$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $0de97792fcab6c65$var$getRequest = $eJz0f.getRequest, $0de97792fcab6c65$var$getRequestIdentifier = $eJz0f.getRequestIdentifier;
parcelRequire("8Fbfi");
var $0de97792fcab6c65$var$RenderDispatcher = null;
var $0de97792fcab6c65$var$fetchKey = 100001;
function $0de97792fcab6c65$var$useTrackLoadQueryInRender() {
    if ($0de97792fcab6c65$var$RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        // Flow does not know of React internals (rightly so), but we need to
        // ensure here that this function isn't called inside render.
        $0de97792fcab6c65$var$RenderDispatcher = (_React$__SECRET_INTER = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function $0de97792fcab6c65$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    // This code ensures that we don't call loadQuery during render.
    var CurrentDispatcher = (_React$__SECRET_INTER3 = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    // Every time you call loadQuery, we will generate a new fetchKey.
    // This will ensure that every query reference that is created and
    // passed to usePreloadedQuery is independently evaluated,
    // even if they are for the same query/variables.
    // Specifically, we want to avoid a case where we try to refetch a
    // query by calling loadQuery a second time, and have the Suspense
    // cache in usePreloadedQuery reuse the cached result instead of
    // re-evaluating the new query ref and triggering a refetch if
    // necessary.
    $0de97792fcab6c65$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : "store-or-network";
    var networkCacheConfig = (0, $0de97792fcab6c65$var$_objectSpread2["default"])((0, $0de97792fcab6c65$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    // executeWithNetworkSource will retain and execute an operation
    // against the Relay store, given an Observable that would provide
    // the network events for the operation.
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    // N.B. For loadQuery, we unconventionally want to return an Observable
    // that isn't lazily executed, meaning that we don't want to wait
    // until the returned Observable is subscribed to to actually start
    // fetching and executing an operation; i.e. we want to execute the
    // operation eagerly, when loadQuery is called.
    // For this reason, we use an intermediate executionSubject which
    // allows us to capture the events that occur during the eager execution
    // of the operation, and then replay them to the Observable we
    // ultimately return.
    var executionSubject = new $0de97792fcab6c65$var$ReplaySubject();
    var returnedObservable = $0de97792fcab6c65$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    // makeNetworkRequest will immediately start a raw network request if
    // one isn't already in flight and return an Observable that when
    // subscribed to will replay the network events that have occured so far,
    // as well as subsequent events.
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        // N.B. this function is called synchronously or not at all
        // didMakeNetworkRequest is safe to rely on in the returned value
        // Even if the request gets deduped below, we still wan't to return an
        // observable that provides the replayed network events for the query,
        // so we set this to true before deduping, to guarantee that the
        // `source` observable is returned.
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $0de97792fcab6c65$var$ReplaySubject();
        if ($0de97792fcab6c65$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            // Here, we are calling fetchQueryDeduped at the network layer level,
            // which ensures that only a single network request is active for a given
            // (environment, identifier) pair.
            // Since network requests can be started /before/ we have the query ast
            // necessary to process the results, we need to dedupe the raw requests
            // separately from deduping the operation execution; specifically,
            // if `loadQuery` is called multiple times before the query ast is available,
            // we still want the network request to be deduped.
            // - If a duplicate active network request is found, it will return an
            // Observable that replays the events of the already active request.
            // - If no duplicate active network request is found, it will call the fetchFn
            // to start the request, and return an Observable that will replay
            // the events from the network request.
            // We provide an extra key to the identifier to distinguish deduping
            // of raw network requests vs deduping of operation executions.
            var identifier = "raw-network-request-" + $0de97792fcab6c65$var$getRequestIdentifier(params, variables);
            observable = $0de97792fcab6c65$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $0de97792fcab6c65$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($0de97792fcab6c65$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) // N.B. at this point, if we're calling execute with a query ast (OperationDescriptor),
        // we are guaranteed to have started a network request. We set this to
        // true here as well since `makeNetworkRequest` might get skipped in the case
        // where the query ast is already available and the query executions get deduped.
        // Even if the execution gets deduped below, we still wan't to return
        // an observable that provides the replayed network events for the query,
        // so we set this to true before deduping, to guarantee that the `source`
        // observable is returned.
        didMakeNetworkRequest = true;
        // Here, we are calling fetchQueryDeduped, which ensures that only
        // a single operation is active for a given (environment, identifier) pair,
        // and also tracks the active state of the operation, which is necessary
        // for our Suspense infra to later be able to suspend (or not) on
        // active operations. Even though we already dedupe raw network requests,
        // we also need to dedupe and keep track operation execution for our Suspense
        // infra, and we also want to avoid processing responses more than once, for
        // the cases where `loadQuery` might be called multiple times after the query ast
        // is available.
        // - If a duplicate active operation is found, it will return an
        // Observable that replays the events of the already active operation.
        // - If no duplicate active operation is found, it will call the fetchFn
        // to execute the operation, and return an Observable that will provide
        // the events for executing the operation.
        var _fetchQueryDeduped$su = $0de97792fcab6c65$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $0de97792fcab6c65$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === "store-only") return;
        // N.B. If the fetch policy allows fulfillment from the store but the
        // environment already has the data for that operation cached in the store,
        // then we do nothing.
        var shouldFetch = fetchPolicy !== "store-or-network" || environment.check(operation).status !== "available";
        if (shouldFetch) executeDeduped(operation, function() {
            // N.B. Since we have the operation synchronously available here,
            // we can immediately fetch and execute the operation.
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === "PreloadableConcreteRequest") {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $aaXwj(false);
        var _module = $0de97792fcab6c65$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            // If the module isn't synchronously available, we launch the
            // network request immediately if the fetchPolicy might produce
            // a network fetch, regardless of the state of the store cache. We
            // do this because we can't check if a query is cached without the
            // ast, and we know that if we don't have the query ast
            // available, then this query could've never been written to the
            // store in the first place, so it couldn't have been cached.
            var networkObservable = fetchPolicy === "store-only" ? null : makeNetworkRequest(params);
            // $FlowFixMe[method-unbinding] added when improving typing for this parameters
            var _PreloadableQueryRegi = $0de97792fcab6c65$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $0de97792fcab6c65$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $0de97792fcab6c65$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: "PreloadedQuery",
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $0de97792fcab6c65$var$fetchKey,
        id: queryId,
        // $FlowFixMe[unsafe-getters-setters] - this has no side effects
        get isDisposed () {
            return isDisposed || isReleased;
        },
        // $FlowFixMe[unsafe-getters-setters] - this has no side effects
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $0de97792fcab6c65$var$loadQuery,
    useTrackLoadQueryInRender: $0de97792fcab6c65$var$useTrackLoadQueryInRender
};

});


parcelRegister("eLBQT", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $j5wbN = parcelRequire("j5wbN");

var $acw62 = parcelRequire("acw62");
var $ac02d11be19a6f4b$var$useMemo = $acw62.useMemo;
function $ac02d11be19a6f4b$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $ac02d11be19a6f4b$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
        value: context
    }, children);
}
module.exports = $ac02d11be19a6f4b$var$RelayEnvironmentProvider;

});

parcelRegister("jwpXG", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $e36524ec094ac92e$var$_interopRequireDefault = $1jnue.default;

var $e36524ec094ac92e$var$_objectSpread2 = $e36524ec094ac92e$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $6RH4A = parcelRequire("6RH4A");
/**
 * This hook can be used to render client-only queries.
 * These queries are consist of queries for client-only data,
 * schematized via local schema extensions and/or Relay resolvers.
 */ function $e36524ec094ac92e$var$useClientQuery(gqlQuery, variables, options) {
    // $FlowFixMe[incompatible-type] client queries can be used with useLazyLoadQuery, but only with `store-only` policy.
    var query = gqlQuery;
    return $6RH4A(query, variables, (0, $e36524ec094ac92e$var$_objectSpread2["default"])((0, $e36524ec094ac92e$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: "store-only"
    }));
}
module.exports = $e36524ec094ac92e$var$useClientQuery;

});
parcelRegister("6RH4A", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1c3ii = parcelRequire("1c3ii");
var $4ff91ab98f673877$var$useTrackLoadQueryInRender = $1c3ii.useTrackLoadQueryInRender;

var $03QWz = parcelRequire("03QWz");

var $lbcmO = parcelRequire("lbcmO");

var $4fG2B = parcelRequire("4fG2B");

var $eJz0f = parcelRequire("eJz0f");
var $4ff91ab98f673877$var$fetchQuery = $eJz0f.__internal.fetchQuery;
// This separate type export is only needed as long as we are injecting
// a separate hooks implementation in ./HooksImplementation -- it can
// be removed after we stop doing that.
function $4ff91ab98f673877$var$useLazyLoadQuery(gqlQuery, variables, options) {
    // We need to use this hook in order to be able to track if
    // loadQuery was called during render
    $4ff91ab98f673877$var$useTrackLoadQueryInRender();
    var environment = $4fG2B();
    var query = $lbcmO(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $03QWz({
        componentDisplayName: "useLazyLoadQuery()",
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $4ff91ab98f673877$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $4ff91ab98f673877$var$useLazyLoadQuery;

});
parcelRegister("03QWz", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $9pgH3 = parcelRequire("9pgH3");

var $i2nMq = parcelRequire("i2nMq");
var $00b95970b654f37e$var$getQueryCacheIdentifier = $i2nMq.getQueryCacheIdentifier, $00b95970b654f37e$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $fzOCt = parcelRequire("fzOCt");

var $ljhVv = parcelRequire("ljhVv");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $00b95970b654f37e$var$useContext = $acw62.useContext, $00b95970b654f37e$var$useEffect = $acw62.useEffect, $00b95970b654f37e$var$useState = $acw62.useState, $00b95970b654f37e$var$useRef = $acw62.useRef;
function $00b95970b654f37e$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $4fG2B();
    var profilerContext = $00b95970b654f37e$var$useContext($9pgH3);
    var QueryResource = $00b95970b654f37e$var$getQueryResourceForEnvironment(environment);
    var _useState = $00b95970b654f37e$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $fzOCt(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : "");
    var cacheIdentifier = $00b95970b654f37e$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $00b95970b654f37e$var$useRef(false);
    $00b95970b654f37e$var$useEffect(function() {
        return function() {
            // Attempt to detect if the component was
            // hidden (by Offscreen API), or fast refresh occured;
            // Only in these situations would the effect cleanup
            // for "unmounting" run multiple times, so if
            // we are ever able to read this ref with a value
            // of true, it means that one of these cases
            // has happened.
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $00b95970b654f37e$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            // This block only runs if the component has previously "unmounted"
            // due to it being hidden by the Offscreen API, or during fast refresh.
            // At this point, the current cached resource will have been disposed
            // by the previous cleanup, so instead of attempting to
            // do our regular commit setup, which would incorrectly attempt to
            // retain a cached query resource that was disposed, we need to force
            // a re-render so that the cache entry for this query is re-intiliazed and
            // and re-evaluated (and potentially cause a refetch).
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    // NOTE: We disable react-hooks-deps warning because the `environment`
    // and `cacheIdentifier` identities are capturing all information about whether
    // the effect should be re-executed and the query re-retained.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        environment,
        cacheIdentifier
    ]);
    $00b95970b654f37e$var$useEffect(function() {
        // Release any temporary retain that's not released. At this point, if the
        // cacheIdentifier doesn't change, the query is still permanently retained,
        // and the temporary retain is redundant.
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    // This effect is intended to run on every commit, thus no dependency
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var _useFragmentNode = $ljhVv(fragmentNode, fragmentRef, componentDisplayName), data = _useFragmentNode.data;
    return data;
}
module.exports = $00b95970b654f37e$var$useLazyLoadQueryNode;

});
parcelRegister("i2nMq", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d21adc1d9490b1db$var$_interopRequireDefault = $1jnue.default;

var $d21adc1d9490b1db$var$_objectSpread2 = $d21adc1d9490b1db$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $d21adc1d9490b1db$var$_defineProperty2 = $d21adc1d9490b1db$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $i3k6C = parcelRequire("i3k6C");

var $fTQd2 = parcelRequire("fTQd2");

var $aaXwj = parcelRequire("aaXwj");

var $eJz0f = parcelRequire("eJz0f");
var $d21adc1d9490b1db$var$isPromise = $eJz0f.isPromise;
parcelRequire("8Fbfi");
var $d21adc1d9490b1db$var$CACHE_CAPACITY = 1000;
var $d21adc1d9490b1db$var$DEFAULT_FETCH_POLICY = "store-or-network";
var $d21adc1d9490b1db$var$DEFAULT_LIVE_FETCH_POLICY = "store-and-network";
var $d21adc1d9490b1db$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
function $d21adc1d9490b1db$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $d21adc1d9490b1db$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $d21adc1d9490b1db$var$operationIsLiveQuery(operation) ? $d21adc1d9490b1db$var$DEFAULT_LIVE_FETCH_POLICY : $d21adc1d9490b1db$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $d21adc1d9490b1db$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $d21adc1d9490b1db$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $d21adc1d9490b1db$var$nextID = 200000;
function $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $d21adc1d9490b1db$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $fTQd2(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                // Normally if this entry never commits, the request would've ended by the
                // time this timeout expires and the temporary retain is released. However,
                // we need to do this for live queries which remain open indefinitely.
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $d21adc1d9490b1db$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $d21adc1d9490b1db$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $d21adc1d9490b1db$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $i3k6C.create($d21adc1d9490b1db$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $d21adc1d9490b1db$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    } /**
   * This function should be called during a Component's render function,
   * to either read an existing cached value for the query, or fetch the query
   * and suspend.
   */ ;
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $d21adc1d9490b1db$var$operationIsLiveQuery(operation) ? $d21adc1d9490b1db$var$DEFAULT_LIVE_FETCH_POLICY : $d21adc1d9490b1db$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        // 1. Check if there's a cached value for this operation, and reuse it if
        // it's available
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) // 2. If a cached value isn't available, try fetching the operation.
        // _fetchAndSaveQuery will update the cache with either a Promise or
        // an Error to throw, or a QueryResult to return.
        cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $d21adc1d9490b1db$var$_objectSpread2["default"])((0, $d21adc1d9490b1db$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                // 4. If the request is cancelled, make sure to dispose
                // of the temporary retain; this will ensure that a promise
                // doesn't remain unnecessarily cached until the temporary retain
                // expires. Not clearing the temporary retain might cause the
                // query to incorrectly re-suspend.
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        // 3. Temporarily retain here in render phase. When the component reading
        // the operation is committed, we will transfer ownership of data retention
        // to the component.
        // In case the component never commits (mounts or updates) from this render,
        // this data retention hold will auto-release itself after a timeout.
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($d21adc1d9490b1db$var$isPromise(cachedValue)) {
            environment.__log({
                name: "suspense.query",
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    } /**
   * This function should be called during a component's commit phase
   * (e.g. inside useEffect), in order to retain the operation in the Relay store
   * and transfer ownership of the operation to the component lifecycle.
   */ ;
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: "queryresource.retain",
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $d21adc1d9490b1db$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        // NOTE: Running `check` will write missing data to the store using any
        // missing data handlers specified on the environment;
        // We run it here first to make the handlers get a chance to populate
        // missing data.
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === "available";
        var canPartialRender = hasFullQuery || renderPolicy === "partial" && queryStatus !== "stale";
        var shouldFetch;
        var shouldAllowRender;
        // Different definitions for Promise in our repos can cause this variable
        // to cause errors when synced elsewhere
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case "store-only":
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case "store-or-network":
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case "store-and-network":
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case "network-only":
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        // NOTE: If this value is false, we will cache a promise for this
        // query, which means we will suspend here at this query root.
        // If it's true, we will cache the query resource and allow rendering to
        // continue.
        if (shouldAllowRender) {
            var queryResult = $d21adc1d9490b1db$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $d21adc1d9490b1db$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $d21adc1d9490b1db$var$_objectSpread2["default"])((0, $d21adc1d9490b1db$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                // Only live queries should have their network requests canceled.
                                if ($d21adc1d9490b1db$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    // If, this is the first thing we receive for the query,
                    // before any other payload handled is error, we will cache and
                    // re-throw that error later.
                    // We will ignore errors for any incremental payloads we receive.
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                // $FlowExpectedError[prop-missing] Expando to annotate Promises.
                networkPromise.displayName = "Relay(" + operation.fragment.node.name + ")";
                _cacheEntry2 = $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $aaXwj(false);
        environment.__log({
            name: "queryresource.fetch",
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $d21adc1d9490b1db$var$createQueryResource(environment) {
    return new $d21adc1d9490b1db$var$QueryResourceImpl(environment);
}
var $d21adc1d9490b1db$var$dataResources = $d21adc1d9490b1db$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $d21adc1d9490b1db$var$getQueryResourceForEnvironment(environment) {
    var cached = $d21adc1d9490b1db$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $d21adc1d9490b1db$var$createQueryResource(environment);
    $d21adc1d9490b1db$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $d21adc1d9490b1db$var$createQueryResource,
    getQueryResourceForEnvironment: $d21adc1d9490b1db$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $d21adc1d9490b1db$var$getQueryCacheIdentifier
};

});
parcelRegister("i3k6C", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
/**
 * JS maps (both plain objects and Map) maintain key insertion
 * order, which means there is an easy way to simulate LRU behavior
 * that should also perform quite well:
 *
 * To insert a new value, first delete the key from the inner _map,
 * then _map.set(k, v). By deleting and reinserting, you ensure that the
 * map sees the key as the last inserted key.
 *
 * Get does the same: if the key is present, delete and reinsert it.
 */ var $d2481a674cf40986$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $aaXwj(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $d2481a674cf40986$var$create(capacity) {
    return new $d2481a674cf40986$var$LRUCache(capacity);
}
module.exports = {
    create: $d2481a674cf40986$var$create
};

});

parcelRegister("fTQd2", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b9347dbf28b75b10$var$_interopRequireDefault = $1jnue.default;

var $b9347dbf28b75b10$var$_defineProperty2 = $b9347dbf28b75b10$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $aaXwj = parcelRequire("aaXwj");
var $b9347dbf28b75b10$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
/**
 * Allows you to retain a resource as part of a component lifecycle accounting
 * for Suspense. You temporarily retain the resource during render, then
 * permanently retain it during commit and release it during unmount.
 */ var $b9347dbf28b75b10$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $b9347dbf28b75b10$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $b9347dbf28b75b10$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $b9347dbf28b75b10$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        !(_this._retainDisposable != null) && $aaXwj(false);
                        _this._retainDisposable.dispose();
                        _this._retainDisposable = null;
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        // If we're executing in a server environment, there's no need
        // to create temporary retains, since the component will never commit.
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        // temporaryRetain is called during the render phase. However,
        // given that we can't tell if this render will eventually commit or not,
        // we create a timer to autodispose of this retain in case the associated
        // component never commits.
        // If the component /does/ commit, permanentRetain will clear this timeout
        // and permanently retain the data.
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $b9347dbf28b75b10$var$TEMPORARY_RETAIN_DURATION_MS);
        // NOTE: Since temporaryRetain can be called multiple times, we release
        // the previous temporary retain after we re-establish a new one, since
        // we only ever need a single temporary retain until the permanent retain is
        // established.
        // temporaryRetain may be called multiple times by React during the render
        // phase, as well as multiple times by other query components that are
        // rendering the same query/variables.
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $b9347dbf28b75b10$var$SuspenseResource;

});


parcelRegister("fzOCt", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $fciVy = parcelRequire("fciVy");

var $acw62 = parcelRequire("acw62");
var $b57163e50945b80f$var$useCallback = $acw62.useCallback, $b57163e50945b80f$var$useEffect = $acw62.useEffect;
/**
 * This hook returns a mutable React ref that holds the value of whether a
 * fetch request is in flight. The reason this is a mutable ref instead of
 * state is because we don't actually want to trigger an update when this
 * changes, but instead synchronously keep track of whether the network request
 * is in flight, for example in order to bail out of a request if one is
 * already in flight. If this was state, due to the nature of concurrent
 * updates, this value wouldn't be in sync with when the request is actually
 * in flight.
 * The additional functions returned by this Hook can be used to mutate
 * the ref.
 */ function $b57163e50945b80f$var$useFetchTrackingRef() {
    var subscriptionRef = $fciVy(null);
    var isFetchingRef = $fciVy(false);
    var disposeFetch = $b57163e50945b80f$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $b57163e50945b80f$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $b57163e50945b80f$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    // Dipose of ongoing fetch on unmount
    $b57163e50945b80f$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $b57163e50945b80f$var$useFetchTrackingRef;

});
parcelRegister("fciVy", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $acw62 = parcelRequire("acw62");
var $b106a88b9e17ad00$var$useMemo = $acw62.useMemo;
/**
 * Like `useRef`, but does not warn when accessed during render. It's a bad
 * pattern to read or write from a ref during render as it does not trigger
 * a rerender and might result in bugs.
 */ function $b106a88b9e17ad00$var$useUnsafeRef_DEPRECATED(init) {
    return $b106a88b9e17ad00$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $b106a88b9e17ad00$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("ljhVv", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $5wdCj = parcelRequire("5wdCj");
var $f83947233f75b6a7$var$getFragmentResourceForEnvironment = $5wdCj.getFragmentResourceForEnvironment;

var $4fG2B = parcelRequire("4fG2B");

var $fciVy = parcelRequire("fciVy");

var $acw62 = parcelRequire("acw62");
var $f83947233f75b6a7$var$useEffect = $acw62.useEffect, $f83947233f75b6a7$var$useState = $acw62.useState;

var $eJz0f = parcelRequire("eJz0f");
var $f83947233f75b6a7$var$getFragmentIdentifier = $eJz0f.getFragmentIdentifier;
parcelRequire("8Fbfi");
function $f83947233f75b6a7$var$useFragmentNode(fragmentNode, fragmentRef, componentDisplayName) {
    var environment = $4fG2B();
    var FragmentResource = $f83947233f75b6a7$var$getFragmentResourceForEnvironment(environment);
    var isMountedRef = $fciVy(false);
    var _useState = $f83947233f75b6a7$var$useState(0), forceUpdate = _useState[1];
    var fragmentIdentifier = $f83947233f75b6a7$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    // Read fragment data; this might suspend.
    var fragmentResult = FragmentResource.readWithIdentifier(fragmentNode, fragmentRef, fragmentIdentifier, componentDisplayName);
    var isListeningForUpdatesRef = $fciVy(true);
    function enableStoreUpdates() {
        isListeningForUpdatesRef.current = true;
        var didMissUpdates = FragmentResource.checkMissedUpdates(fragmentResult)[0];
        if (didMissUpdates) handleDataUpdate();
    }
    function disableStoreUpdates() {
        isListeningForUpdatesRef.current = false;
    }
    function handleDataUpdate() {
        if (isMountedRef.current === false || isListeningForUpdatesRef.current === false) return;
        // React bails out on noop state updates as an optimization.
        // If we want to force an update via setState, we need to pass an value.
        // The actual value can be arbitrary though, e.g. an incremented number.
        forceUpdate(function(count) {
            return count + 1;
        });
    }
    // Establish Relay store subscriptions in the commit phase, only if
    // rendering for the first time, or if we need to subscribe to new data
    // If the fragment identifier changes, it means that the variables on the
    // fragment owner changed, or the fragment ref points to different records.
    // In this case, we need to resubscribe to the Relay store.
    $f83947233f75b6a7$var$useEffect(function() {
        isMountedRef.current = true;
        var disposable = FragmentResource.subscribe(fragmentResult, handleDataUpdate);
        return function() {
            // When unmounting or resubscribing to new data, clean up current
            // subscription. This will also make sure fragment data is no longer
            // cached so that next time it its read, it will be freshly read from
            // the Relay store
            isMountedRef.current = false;
            disposable.dispose();
        };
    // NOTE: We disable react-hooks-deps warning because environment and fragmentIdentifier
    // is capturing all information about whether the effect should be re-ran.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        environment,
        fragmentIdentifier
    ]);
    return {
        // $FlowFixMe[incompatible-return]
        data: fragmentResult.data,
        disableStoreUpdates: disableStoreUpdates,
        enableStoreUpdates: enableStoreUpdates
    };
}
module.exports = $f83947233f75b6a7$var$useFragmentNode;

});
parcelRegister("5wdCj", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $404a80f5e5ba2bd0$var$_interopRequireDefault = $1jnue.default;

var $404a80f5e5ba2bd0$var$_objectSpread2 = $404a80f5e5ba2bd0$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $404a80f5e5ba2bd0$var$_defineProperty2 = $404a80f5e5ba2bd0$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $404a80f5e5ba2bd0$var$_toConsumableArray2 = $404a80f5e5ba2bd0$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $i3k6C = parcelRequire("i3k6C");

var $i2nMq = parcelRequire("i2nMq");
var $404a80f5e5ba2bd0$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $fTQd2 = parcelRequire("fTQd2");

var $aaXwj = parcelRequire("aaXwj");

var $eJz0f = parcelRequire("eJz0f");
var $404a80f5e5ba2bd0$var$_require2$__internal = $eJz0f.__internal, $404a80f5e5ba2bd0$var$fetchQuery = $404a80f5e5ba2bd0$var$_require2$__internal.fetchQuery, $404a80f5e5ba2bd0$var$getPromiseForActiveRequest = $404a80f5e5ba2bd0$var$_require2$__internal.getPromiseForActiveRequest, $404a80f5e5ba2bd0$var$RelayFeatureFlags = $eJz0f.RelayFeatureFlags, $404a80f5e5ba2bd0$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $404a80f5e5ba2bd0$var$getFragmentIdentifier = $eJz0f.getFragmentIdentifier, $404a80f5e5ba2bd0$var$getPendingOperationsForFragment = $eJz0f.getPendingOperationsForFragment, $404a80f5e5ba2bd0$var$getSelector = $eJz0f.getSelector, $404a80f5e5ba2bd0$var$getVariablesFromFragment = $eJz0f.getVariablesFromFragment, $404a80f5e5ba2bd0$var$handlePotentialSnapshotErrors = $eJz0f.handlePotentialSnapshotErrors, $404a80f5e5ba2bd0$var$isPromise = $eJz0f.isPromise, $404a80f5e5ba2bd0$var$recycleNodesInto = $eJz0f.recycleNodesInto;
var $404a80f5e5ba2bd0$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
// TODO: Fix to not rely on LRU. If the number of active fragments exceeds this
// capacity, readSpec() will fail to find cached entries and break object
// identity even if data hasn't changed.
var $404a80f5e5ba2bd0$var$CACHE_CAPACITY = 1000000;
// this is frozen so that users don't accidentally push data into the array
var $404a80f5e5ba2bd0$var$CONSTANT_READONLY_EMPTY_ARRAY = Object.freeze([]);
function $404a80f5e5ba2bd0$var$isMissingData(snapshot) {
    if (Array.isArray(snapshot)) return snapshot.some(function(s) {
        return s.isMissingData;
    });
    return snapshot.isMissingData;
}
function $404a80f5e5ba2bd0$var$hasMissingClientEdges(snapshot) {
    var _snapshot$missingClie, _snapshot$missingClie2;
    if (Array.isArray(snapshot)) return snapshot.some(function(s) {
        var _s$missingClientEdges, _s$missingClientEdges2;
        return ((_s$missingClientEdges = (_s$missingClientEdges2 = s.missingClientEdges) === null || _s$missingClientEdges2 === void 0 ? void 0 : _s$missingClientEdges2.length) !== null && _s$missingClientEdges !== void 0 ? _s$missingClientEdges : 0) > 0;
    });
    return ((_snapshot$missingClie = (_snapshot$missingClie2 = snapshot.missingClientEdges) === null || _snapshot$missingClie2 === void 0 ? void 0 : _snapshot$missingClie2.length) !== null && _snapshot$missingClie !== void 0 ? _snapshot$missingClie : 0) > 0;
}
function $404a80f5e5ba2bd0$var$missingLiveResolverFields(snapshot) {
    if (Array.isArray(snapshot)) return snapshot.map(function(s) {
        return s.missingLiveResolverFields;
    }).filter(Boolean).flat();
    return snapshot.missingLiveResolverFields;
}
function $404a80f5e5ba2bd0$var$singularOrPluralForEach(snapshot, f) {
    if (Array.isArray(snapshot)) snapshot.forEach(f);
    else f(snapshot);
}
function $404a80f5e5ba2bd0$var$getFragmentResult(cacheKey, snapshot, storeEpoch) {
    if (Array.isArray(snapshot)) return {
        cacheKey: cacheKey,
        snapshot: snapshot,
        data: snapshot.map(function(s) {
            return s.data;
        }),
        isMissingData: $404a80f5e5ba2bd0$var$isMissingData(snapshot),
        storeEpoch: storeEpoch
    };
    return {
        cacheKey: cacheKey,
        snapshot: snapshot,
        data: snapshot.data,
        isMissingData: $404a80f5e5ba2bd0$var$isMissingData(snapshot),
        storeEpoch: storeEpoch
    };
}
/**
 * The purpose of this cache is to allow information to be passed from an
 * initial read which suspends through to the commit that follows a subsequent
 * successful read. Specifically, the QueryResource result for the data fetch
 * is passed through so that that query can be retained on commit.
 */ var $404a80f5e5ba2bd0$var$ClientEdgeQueryResultsCache = /*#__PURE__*/ function() {
    function ClientEdgeQueryResultsCache(environment) {
        (0, $404a80f5e5ba2bd0$var$_defineProperty2["default"])(this, "_cache", new Map());
        (0, $404a80f5e5ba2bd0$var$_defineProperty2["default"])(this, "_retainCounts", new Map());
        this._environment = environment;
    }
    var _proto = ClientEdgeQueryResultsCache.prototype;
    _proto.get = function get(fragmentIdentifier) {
        var _this$_cache$get$, _this$_cache$get;
        return (_this$_cache$get$ = (_this$_cache$get = this._cache.get(fragmentIdentifier)) === null || _this$_cache$get === void 0 ? void 0 : _this$_cache$get[0]) !== null && _this$_cache$get$ !== void 0 ? _this$_cache$get$ : undefined;
    };
    _proto.recordQueryResults = function recordQueryResults(fragmentIdentifier, value // may be mutated after being passed here
    ) {
        var _this = this;
        var existing = this._cache.get(fragmentIdentifier);
        if (!existing) {
            var suspenseResource = new $fTQd2(function() {
                return _this._retain(fragmentIdentifier);
            });
            this._cache.set(fragmentIdentifier, [
                value,
                suspenseResource
            ]);
            suspenseResource.temporaryRetain(this._environment);
        } else {
            var existingResults = existing[0], _suspenseResource = existing[1];
            value.forEach(function(queryResult) {
                existingResults.push(queryResult);
            });
            _suspenseResource.temporaryRetain(this._environment);
        }
    };
    _proto._retain = function _retain(id) {
        var _this2 = this;
        var _this$_retainCounts$g;
        var retainCount = ((_this$_retainCounts$g = this._retainCounts.get(id)) !== null && _this$_retainCounts$g !== void 0 ? _this$_retainCounts$g : 0) + 1;
        this._retainCounts.set(id, retainCount);
        return {
            dispose: function dispose() {
                var _this$_retainCounts$g2;
                var newRetainCount = ((_this$_retainCounts$g2 = _this2._retainCounts.get(id)) !== null && _this$_retainCounts$g2 !== void 0 ? _this$_retainCounts$g2 : 0) - 1;
                if (newRetainCount > 0) _this2._retainCounts.set(id, newRetainCount);
                else {
                    _this2._retainCounts["delete"](id);
                    _this2._cache["delete"](id);
                }
            }
        };
    };
    return ClientEdgeQueryResultsCache;
}();
var $404a80f5e5ba2bd0$var$FragmentResourceImpl = /*#__PURE__*/ function() {
    function FragmentResourceImpl(environment) {
        this._environment = environment;
        this._cache = $i3k6C.create($404a80f5e5ba2bd0$var$CACHE_CAPACITY);
        if ($404a80f5e5ba2bd0$var$RelayFeatureFlags.ENABLE_CLIENT_EDGES) this._clientEdgeQueryResultsCache = new $404a80f5e5ba2bd0$var$ClientEdgeQueryResultsCache(environment);
    }
    /**
   * This function should be called during a Component's render function,
   * to read the data for a fragment, or suspend if the fragment is being
   * fetched.
   */ var _proto2 = FragmentResourceImpl.prototype;
    _proto2.read = function read(fragmentNode, fragmentRef, componentDisplayName, fragmentKey) {
        return this.readWithIdentifier(fragmentNode, fragmentRef, $404a80f5e5ba2bd0$var$getFragmentIdentifier(fragmentNode, fragmentRef), componentDisplayName, fragmentKey);
    } /**
   * Like `read`, but with a pre-computed fragmentIdentifier that should be
   * equal to `getFragmentIdentifier(fragmentNode, fragmentRef)` from the
   * arguments.
   */ ;
    _proto2.readWithIdentifier = function readWithIdentifier(fragmentNode, fragmentRef, fragmentIdentifier, componentDisplayName, fragmentKey) {
        var _this3 = this;
        var _fragmentNode$metadat, _fragmentNode$metadat2, _missingLiveResolverF2, _missingLiveResolverF3;
        var environment = this._environment;
        // If fragmentRef is null or undefined, pass it directly through.
        // This is a convenience when consuming fragments via a HOC API, when the
        // prop corresponding to the fragment ref might be passed as null.
        if (fragmentRef == null) return {
            cacheKey: fragmentIdentifier,
            data: null,
            isMissingData: false,
            snapshot: null,
            storeEpoch: 0
        };
        var storeEpoch = environment.getStore().getEpoch();
        // If fragmentRef is plural, ensure that it is an array.
        // If it's empty, return the empty array directly before doing any more work.
        if ((fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true) {
            !Array.isArray(fragmentRef) && $aaXwj(false);
            if (fragmentRef.length === 0) return {
                cacheKey: fragmentIdentifier,
                data: $404a80f5e5ba2bd0$var$CONSTANT_READONLY_EMPTY_ARRAY,
                isMissingData: false,
                snapshot: $404a80f5e5ba2bd0$var$CONSTANT_READONLY_EMPTY_ARRAY,
                storeEpoch: storeEpoch
            };
        }
        // Now we actually attempt to read the fragment:
        // 1. Check if there's a cached value for this fragment
        var cachedValue = this._cache.get(fragmentIdentifier);
        if (cachedValue != null) {
            var _missingLiveResolverF;
            if (cachedValue.kind === "pending" && $404a80f5e5ba2bd0$var$isPromise(cachedValue.promise)) {
                environment.__log({
                    name: "suspense.fragment",
                    data: cachedValue.result.data,
                    fragment: fragmentNode,
                    isRelayHooks: true,
                    isMissingData: cachedValue.result.isMissingData,
                    isPromiseCached: true,
                    pendingOperations: cachedValue.pendingOperations
                });
                throw cachedValue.promise;
            }
            if (cachedValue.kind === "done" && cachedValue.result.snapshot && !((_missingLiveResolverF = $404a80f5e5ba2bd0$var$missingLiveResolverFields(cachedValue.result.snapshot)) !== null && _missingLiveResolverF !== void 0 && _missingLiveResolverF.length)) {
                this._throwOrLogErrorsInSnapshot(// $FlowFixMe[incompatible-call]
                cachedValue.result.snapshot);
                // This cache gets populated directly whenever the store notifies us of
                // an update. That mechanism does not check for missing data, or
                // in-flight requests.
                if (cachedValue.result.isMissingData) environment.__log({
                    name: "fragmentresource.missing_data",
                    data: cachedValue.result.data,
                    fragment: fragmentNode,
                    isRelayHooks: true,
                    cached: true
                });
                return cachedValue.result;
            }
        }
        // 2. If not, try reading the fragment from the Relay store.
        // If the snapshot has data, return it and save it in cache
        var fragmentSelector = $404a80f5e5ba2bd0$var$getSelector(fragmentNode, fragmentRef);
        !(fragmentSelector != null) && $aaXwj(false);
        var snapshot = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }) : environment.lookup(fragmentSelector);
        var fragmentResult = $404a80f5e5ba2bd0$var$getFragmentResult(fragmentIdentifier, snapshot, storeEpoch);
        if (!fragmentResult.isMissingData) {
            this._throwOrLogErrorsInSnapshot(snapshot);
            this._cache.set(fragmentIdentifier, {
                kind: "done",
                result: fragmentResult
            });
            return fragmentResult;
        }
        // 3. If we don't have data in the store, there's two cases where we should
        // suspend to await the data: First if any client edges were traversed where
        // the destination record was missing data; in that case we initiate a query
        // here to fetch the missing data. Second, there may already be a request
        // in flight for the fragment's parent query, or for another operation that
        //  may affect the parent's query data, such as a mutation or subscription.
        // For any of these cases we can get a promise, which we will cache and
        // suspend on.
        // First, initiate a query for any client edges that were missing data:
        var clientEdgeRequests = null;
        if ($404a80f5e5ba2bd0$var$RelayFeatureFlags.ENABLE_CLIENT_EDGES && ((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true && $404a80f5e5ba2bd0$var$hasMissingClientEdges(snapshot)) {
            clientEdgeRequests = [];
            var queryResource = $404a80f5e5ba2bd0$var$getQueryResourceForEnvironment(this._environment);
            var queryResults = [];
            $404a80f5e5ba2bd0$var$singularOrPluralForEach(snapshot, function(snap) {
                var _snap$missingClientEd;
                (_snap$missingClientEd = snap.missingClientEdges) === null || _snap$missingClientEd === void 0 || _snap$missingClientEd.forEach(function(_ref) {
                    var _clientEdgeRequests;
                    var request = _ref.request, clientEdgeDestinationID = _ref.clientEdgeDestinationID;
                    var _this3$_performClient = _this3._performClientEdgeQuery(queryResource, fragmentNode, fragmentRef, request, clientEdgeDestinationID), queryResult = _this3$_performClient.queryResult, requestDescriptor = _this3$_performClient.requestDescriptor;
                    queryResults.push(queryResult);
                    (_clientEdgeRequests = clientEdgeRequests) === null || _clientEdgeRequests === void 0 || _clientEdgeRequests.push(requestDescriptor);
                });
            });
            // Store the query so that it can be retained when our own fragment is
            // subscribed to. This merges with any existing query results:
            !(this._clientEdgeQueryResultsCache != null) && $aaXwj(false);
            this._clientEdgeQueryResultsCache.recordQueryResults(fragmentIdentifier, queryResults);
        }
        var clientEdgePromises = [];
        if ($404a80f5e5ba2bd0$var$RelayFeatureFlags.ENABLE_CLIENT_EDGES && clientEdgeRequests) clientEdgePromises = clientEdgeRequests.map(function(request) {
            return $404a80f5e5ba2bd0$var$getPromiseForActiveRequest(_this3._environment, request);
        }).filter(Boolean);
        // Finally look for operations in flight for our parent query:
        var fragmentOwner = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var parentQueryPromiseResult = this._getAndSavePromiseForFragmentRequestInFlight(fragmentIdentifier, fragmentNode, fragmentOwner, fragmentResult);
        var parentQueryPromiseResultPromise = parentQueryPromiseResult === null || parentQueryPromiseResult === void 0 ? void 0 : parentQueryPromiseResult.promise; // for refinement
        var missingResolverFieldPromises = (_missingLiveResolverF2 = (_missingLiveResolverF3 = $404a80f5e5ba2bd0$var$missingLiveResolverFields(snapshot)) === null || _missingLiveResolverF3 === void 0 ? void 0 : _missingLiveResolverF3.map(function(_ref2) {
            var liveStateID = _ref2.liveStateID;
            var store = environment.getStore();
            // $FlowFixMe[prop-missing] This is expected to be a LiveResolverStore
            return store.getLiveResolverPromise(liveStateID);
        })) !== null && _missingLiveResolverF2 !== void 0 ? _missingLiveResolverF2 : [];
        if (clientEdgePromises.length || missingResolverFieldPromises.length || $404a80f5e5ba2bd0$var$isPromise(parentQueryPromiseResultPromise)) {
            var _parentQueryPromiseRe, _clientEdgeRequests2;
            environment.__log({
                name: "suspense.fragment",
                data: fragmentResult.data,
                fragment: fragmentNode,
                isRelayHooks: true,
                isPromiseCached: false,
                isMissingData: fragmentResult.isMissingData,
                // TODO! Attach information here about missing live resolver fields
                pendingOperations: [].concat((0, $404a80f5e5ba2bd0$var$_toConsumableArray2["default"])((_parentQueryPromiseRe = parentQueryPromiseResult === null || parentQueryPromiseResult === void 0 ? void 0 : parentQueryPromiseResult.pendingOperations) !== null && _parentQueryPromiseRe !== void 0 ? _parentQueryPromiseRe : []), (0, $404a80f5e5ba2bd0$var$_toConsumableArray2["default"])((_clientEdgeRequests2 = clientEdgeRequests) !== null && _clientEdgeRequests2 !== void 0 ? _clientEdgeRequests2 : []))
            });
            var promises = [];
            if (clientEdgePromises.length > 0) promises = promises.concat(clientEdgePromises);
            if (missingResolverFieldPromises.length > 0) promises = promises.concat(missingResolverFieldPromises);
            if (promises.length > 0) {
                if (parentQueryPromiseResultPromise) promises.push(parentQueryPromiseResultPromise);
                throw Promise.all(promises);
            }
            // Note: we are re-throwing the `parentQueryPromiseResultPromise` here,
            // because some of our suspense-related code is relying on the instance equality
            // of thrown promises. See FragmentResource-test.js
            if (parentQueryPromiseResultPromise) throw parentQueryPromiseResultPromise;
        }
        this._throwOrLogErrorsInSnapshot(snapshot);
        // At this point, there's nothing we can do. We don't have all the expected
        // data, but there's no indication the missing data will be fulfilled. So we
        // choose to return potentially non-typesafe data. The data returned here
        // might not match the generated types for this fragment/operation.
        environment.__log({
            name: "fragmentresource.missing_data",
            data: fragmentResult.data,
            fragment: fragmentNode,
            isRelayHooks: true,
            cached: false
        });
        return $404a80f5e5ba2bd0$var$getFragmentResult(fragmentIdentifier, snapshot, storeEpoch);
    };
    _proto2._performClientEdgeQuery = function _performClientEdgeQuery(queryResource, fragmentNode, fragmentRef, request, clientEdgeDestinationID) {
        var originalVariables = $404a80f5e5ba2bd0$var$getVariablesFromFragment(fragmentNode, fragmentRef);
        var variables = (0, $404a80f5e5ba2bd0$var$_objectSpread2["default"])((0, $404a80f5e5ba2bd0$var$_objectSpread2["default"])({}, originalVariables), {}, {
            id: clientEdgeDestinationID // TODO should be a reserved name
        });
        var operation = $404a80f5e5ba2bd0$var$createOperationDescriptor(request, variables, {} //  TODO cacheConfig should probably inherent from parent operation
        );
        var fetchObservable = $404a80f5e5ba2bd0$var$fetchQuery(this._environment, operation);
        var queryResult = queryResource.prepare(operation, fetchObservable);
        return {
            requestDescriptor: operation.request,
            queryResult: queryResult
        };
    };
    _proto2._throwOrLogErrorsInSnapshot = function _throwOrLogErrorsInSnapshot(snapshot) {
        var _this4 = this;
        if (Array.isArray(snapshot)) snapshot.forEach(function(s) {
            $404a80f5e5ba2bd0$var$handlePotentialSnapshotErrors(_this4._environment, s.missingRequiredFields, s.relayResolverErrors);
        });
        else $404a80f5e5ba2bd0$var$handlePotentialSnapshotErrors(this._environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors);
    };
    _proto2.readSpec = function readSpec(fragmentNodes, fragmentRefs, componentDisplayName) {
        var result = {};
        for(var key in fragmentNodes)result[key] = this.read(fragmentNodes[key], fragmentRefs[key], componentDisplayName, key);
        return result;
    };
    _proto2.subscribe = function subscribe(fragmentResult, callback) {
        var _this5 = this;
        var environment = this._environment;
        var cacheKey = fragmentResult.cacheKey;
        var renderedSnapshot = fragmentResult.snapshot;
        if (!renderedSnapshot) return {
            dispose: function dispose() {}
        };
        // 1. Check for any updates missed during render phase
        // TODO(T44066760): More efficiently detect if we missed an update
        var _this$checkMissedUpda = this.checkMissedUpdates(fragmentResult), didMissUpdates = _this$checkMissedUpda[0], currentSnapshot = _this$checkMissedUpda[1];
        // 2. If an update was missed, notify the component so it updates with
        // the latest data.
        if (didMissUpdates) callback();
        // 3. Establish subscriptions on the snapshot(s)
        var disposables = [];
        if (Array.isArray(renderedSnapshot)) {
            !Array.isArray(currentSnapshot) && $aaXwj(false);
            currentSnapshot.forEach(function(snapshot, idx) {
                disposables.push(environment.subscribe(snapshot, function(latestSnapshot) {
                    var storeEpoch = environment.getStore().getEpoch();
                    _this5._updatePluralSnapshot(cacheKey, currentSnapshot, latestSnapshot, idx, storeEpoch);
                    callback();
                }));
            });
        } else {
            !(currentSnapshot != null && !Array.isArray(currentSnapshot)) && $aaXwj(false);
            disposables.push(environment.subscribe(currentSnapshot, function(latestSnapshot) {
                var storeEpoch = environment.getStore().getEpoch();
                _this5._cache.set(cacheKey, {
                    kind: "done",
                    result: $404a80f5e5ba2bd0$var$getFragmentResult(cacheKey, latestSnapshot, storeEpoch)
                });
                callback();
            }));
        }
        if ($404a80f5e5ba2bd0$var$RelayFeatureFlags.ENABLE_CLIENT_EDGES) {
            var _this$_clientEdgeQuer, _this$_clientEdgeQuer2;
            var clientEdgeQueryResults = (_this$_clientEdgeQuer = (_this$_clientEdgeQuer2 = this._clientEdgeQueryResultsCache) === null || _this$_clientEdgeQuer2 === void 0 ? void 0 : _this$_clientEdgeQuer2.get(cacheKey)) !== null && _this$_clientEdgeQuer !== void 0 ? _this$_clientEdgeQuer : undefined;
            if (clientEdgeQueryResults !== null && clientEdgeQueryResults !== void 0 && clientEdgeQueryResults.length) {
                var queryResource = $404a80f5e5ba2bd0$var$getQueryResourceForEnvironment(this._environment);
                clientEdgeQueryResults.forEach(function(queryResult) {
                    disposables.push(queryResource.retain(queryResult));
                });
            }
        }
        return {
            dispose: function dispose() {
                disposables.forEach(function(s) {
                    return s.dispose();
                });
                _this5._cache["delete"](cacheKey);
            }
        };
    };
    _proto2.subscribeSpec = function subscribeSpec(fragmentResults, callback) {
        var _this6 = this;
        var disposables = Object.keys(fragmentResults).map(function(key) {
            return _this6.subscribe(fragmentResults[key], callback);
        });
        return {
            dispose: function dispose() {
                disposables.forEach(function(disposable) {
                    disposable.dispose();
                });
            }
        };
    };
    _proto2.checkMissedUpdates = function checkMissedUpdates(fragmentResult) {
        var environment = this._environment;
        var renderedSnapshot = fragmentResult.snapshot;
        if (!renderedSnapshot) return [
            false,
            null
        ];
        var storeEpoch = null;
        // Bail out if the store hasn't been written since last read
        storeEpoch = environment.getStore().getEpoch();
        if (fragmentResult.storeEpoch === storeEpoch) return [
            false,
            fragmentResult.snapshot
        ];
        var cacheKey = fragmentResult.cacheKey;
        if (Array.isArray(renderedSnapshot)) {
            var didMissUpdates = false;
            var currentSnapshots = [];
            renderedSnapshot.forEach(function(snapshot, idx) {
                var currentSnapshot = environment.lookup(snapshot.selector);
                var renderData = snapshot.data;
                var currentData = currentSnapshot.data;
                var updatedData = $404a80f5e5ba2bd0$var$recycleNodesInto(renderData, currentData);
                if (updatedData !== renderData) {
                    currentSnapshot = (0, $404a80f5e5ba2bd0$var$_objectSpread2["default"])((0, $404a80f5e5ba2bd0$var$_objectSpread2["default"])({}, currentSnapshot), {}, {
                        data: updatedData
                    });
                    didMissUpdates = true;
                }
                currentSnapshots[idx] = currentSnapshot;
            });
            // Only update the cache when the data is changed to avoid
            // returning different `data` instances
            if (didMissUpdates) this._cache.set(cacheKey, {
                kind: "done",
                result: $404a80f5e5ba2bd0$var$getFragmentResult(cacheKey, currentSnapshots, storeEpoch)
            });
            return [
                didMissUpdates,
                currentSnapshots
            ];
        }
        var currentSnapshot = environment.lookup(renderedSnapshot.selector);
        var renderData = renderedSnapshot.data;
        var currentData = currentSnapshot.data;
        var updatedData = $404a80f5e5ba2bd0$var$recycleNodesInto(renderData, currentData);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors
        };
        if (updatedData !== renderData) this._cache.set(cacheKey, {
            kind: "done",
            result: $404a80f5e5ba2bd0$var$getFragmentResult(cacheKey, updatedCurrentSnapshot, storeEpoch)
        });
        return [
            updatedData !== renderData,
            updatedCurrentSnapshot
        ];
    };
    _proto2.checkMissedUpdatesSpec = function checkMissedUpdatesSpec(fragmentResults) {
        var _this7 = this;
        return Object.keys(fragmentResults).some(function(key) {
            return _this7.checkMissedUpdates(fragmentResults[key])[0];
        });
    };
    _proto2._getAndSavePromiseForFragmentRequestInFlight = function _getAndSavePromiseForFragmentRequestInFlight(cacheKey, fragmentNode, fragmentOwner, fragmentResult) {
        var _this8 = this;
        var pendingOperationsResult = $404a80f5e5ba2bd0$var$getPendingOperationsForFragment(this._environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult == null) return null;
        // When the Promise for the request resolves, we need to make sure to
        // update the cache with the latest data available in the store before
        // resolving the Promise
        var networkPromise = pendingOperationsResult.promise;
        var pendingOperations = pendingOperationsResult.pendingOperations;
        var promise = networkPromise.then(function() {
            _this8._cache["delete"](cacheKey);
        })["catch"](function(error) {
            _this8._cache["delete"](cacheKey);
        });
        // $FlowExpectedError[prop-missing] Expando to annotate Promises.
        promise.displayName = networkPromise.displayName;
        this._cache.set(cacheKey, {
            kind: "pending",
            pendingOperations: pendingOperations,
            promise: promise,
            result: fragmentResult
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    _proto2._updatePluralSnapshot = function _updatePluralSnapshot(cacheKey, baseSnapshots, latestSnapshot, idx, storeEpoch) {
        var _currentFragmentResul;
        var currentFragmentResult = this._cache.get(cacheKey);
        if ($404a80f5e5ba2bd0$var$isPromise(currentFragmentResult)) {
            $404a80f5e5ba2bd0$var$reportInvalidCachedData(latestSnapshot.selector.node.name);
            return;
        }
        var currentSnapshot = currentFragmentResult === null || currentFragmentResult === void 0 ? void 0 : (_currentFragmentResul = currentFragmentResult.result) === null || _currentFragmentResul === void 0 ? void 0 : _currentFragmentResul.snapshot;
        if (currentSnapshot && !Array.isArray(currentSnapshot)) {
            $404a80f5e5ba2bd0$var$reportInvalidCachedData(latestSnapshot.selector.node.name);
            return;
        }
        var nextSnapshots = currentSnapshot ? (0, $404a80f5e5ba2bd0$var$_toConsumableArray2["default"])(currentSnapshot) : (0, $404a80f5e5ba2bd0$var$_toConsumableArray2["default"])(baseSnapshots);
        nextSnapshots[idx] = latestSnapshot;
        this._cache.set(cacheKey, {
            kind: "done",
            result: $404a80f5e5ba2bd0$var$getFragmentResult(cacheKey, nextSnapshots, storeEpoch)
        });
    };
    return FragmentResourceImpl;
}();
function $404a80f5e5ba2bd0$var$reportInvalidCachedData(nodeName) {
    $aaXwj(false);
}
function $404a80f5e5ba2bd0$var$createFragmentResource(environment) {
    return new $404a80f5e5ba2bd0$var$FragmentResourceImpl(environment);
}
var $404a80f5e5ba2bd0$var$dataResources = $404a80f5e5ba2bd0$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $404a80f5e5ba2bd0$var$getFragmentResourceForEnvironment(environment) {
    var cached = $404a80f5e5ba2bd0$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $404a80f5e5ba2bd0$var$createFragmentResource(environment);
    $404a80f5e5ba2bd0$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createFragmentResource: $404a80f5e5ba2bd0$var$createFragmentResource,
    getFragmentResourceForEnvironment: $404a80f5e5ba2bd0$var$getFragmentResourceForEnvironment
};

});



parcelRegister("lbcmO", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $lt6Hp = parcelRequire("lt6Hp");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $f6b437df3eecd49f$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $f6b437df3eecd49f$var$getRequest = $eJz0f.getRequest;
var $f6b437df3eecd49f$var$useMemo = $acw62.useMemo;
function $f6b437df3eecd49f$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $lt6Hp(variables);
    var memoCacheConfig = $lt6Hp(cacheConfig || {});
    return $f6b437df3eecd49f$var$useMemo(function() {
        return $f6b437df3eecd49f$var$createOperationDescriptor($f6b437df3eecd49f$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $f6b437df3eecd49f$var$useMemoOperationDescriptor;

});
parcelRegister("lt6Hp", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");
var $fa1180b51395b55c$var$useState = $acw62.useState;
/**
 * Memoizes the passed in `variables` object based on `areEqual` equality.
 * This is useful when a `variables` object is used as a value in a depencency
 * array as it might often be constructed during render.
 */ function $fa1180b51395b55c$var$useMemoVariables(variables) {
    var _useState = $fa1180b51395b55c$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($ewhZB(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $fa1180b51395b55c$var$useMemoVariables;

});




parcelRegister("9KXWY", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $71a6e9ce88b1800c$var$_interopRequireDefault = $1jnue.default;

var $71a6e9ce88b1800c$var$_createForOfIteratorHelper2 = $71a6e9ce88b1800c$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $5A24j = parcelRequire("5A24j");

var $1c3ii = parcelRequire("1c3ii");
var $71a6e9ce88b1800c$var$useTrackLoadQueryInRender = $1c3ii.useTrackLoadQueryInRender;

var $epnQn = parcelRequire("epnQn");

var $acw62 = parcelRequire("acw62");
var $71a6e9ce88b1800c$var$useCallback = $acw62.useCallback, $71a6e9ce88b1800c$var$useEffect = $acw62.useEffect, $71a6e9ce88b1800c$var$useRef = $acw62.useRef, $71a6e9ce88b1800c$var$useState = $acw62.useState;
var $71a6e9ce88b1800c$var$initialNullEntryPointReferenceState = {
    kind: "NullEntryPointReference"
};
function $71a6e9ce88b1800c$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    /**
   * We want to always call `entryPointReference.dispose()` for every call to
   * `setEntryPointReference(loadEntryPoint(...))` so that no leaks of data in Relay
   * stores will occur.
   *
   * However, a call to `setState(newState)` is not always followed by a commit where
   * this value is reflected in the state. Thus, we cannot reliably clean up each ref
   * with `useEffect(() => () => entryPointReference.dispose(), [entryPointReference])`.
   *
   * Instead, we keep track of each call to `loadEntryPoint` in a ref.
   * Relying on the fact that if a state change commits, no state changes that were
   * initiated prior to the currently committing state change will ever subsequently
   * commit, we can safely dispose of all preloaded entry point references
   * associated with state changes initiated prior to the currently committing state
   * change.
   *
   * Finally, when the hook unmounts, we also dispose of all remaining uncommitted
   * entry point references.
   */ $71a6e9ce88b1800c$var$useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $71a6e9ce88b1800c$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $epnQn();
    var undisposedEntryPointReferencesRef = $71a6e9ce88b1800c$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $71a6e9ce88b1800c$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $71a6e9ce88b1800c$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $71a6e9ce88b1800c$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: "NullEntryPointReference"
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $71a6e9ce88b1800c$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $5A24j(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $71a6e9ce88b1800c$var$useRef(false);
    $71a6e9ce88b1800c$var$useEffect(function() {
        return function() {
            // Attempt to detect if the component was
            // hidden (by Offscreen API), or fast refresh occured;
            // Only in these situations would the effect cleanup
            // for "unmounting" run multiple times, so if
            // we are ever able to read this ref with a value
            // of true, it means that one of these cases
            // has happened.
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $71a6e9ce88b1800c$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            // This block only runs if the component has previously "unmounted"
            // due to it being hidden by the Offscreen API, or during fast refresh.
            // At this point, the current entryPointReference will have been disposed
            // by the previous cleanup, so instead of attempting to
            // do our regular commit setup, which would incorrectly leave our
            // current entryPointReference disposed, we need to load the entryPoint again
            // and force a re-render by calling entryPointLoaderCallback again,
            // so that the entryPointReference's queries are correctly re-retained, and
            // potentially refetched if necessary.
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== "NullEntryPointReference" && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        // When a new entryPointReference is committed, we iterate over all
        // entrypoint refs in undisposedEntryPointReferences and dispose all of
        // the refs that aren't the currently committed one. This ensures
        // that we don't leave any dangling entrypoint references for the
        // case that loadEntryPoint is called multiple times before commit; when
        // this happens, multiple state updates will be scheduled, but only one
        // will commit, meaning that we need to keep track of and dispose any
        // query references that don't end up committing.
        // - We are relying on the fact that sets iterate in insertion order, and we
        // can remove items from a set as we iterate over it (i.e. no iterator
        // invalidation issues.) Thus, it is safe to loop through
        // undisposedEntryPointReferences until we find entryPointReference, and
        // remove and dispose all previous references.
        // - We are guaranteed to find entryPointReference in the set, because if a
        // state change results in a commit, no state changes initiated prior to that
        // one will be committed, and we are disposing and removing references
        // associated with commits that were initiated prior to the currently
        // committing state change. (A useEffect callback is called during the commit
        // phase.)
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $71a6e9ce88b1800c$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== "NullEntryPointReference") undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $71a6e9ce88b1800c$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            // undisposedEntryPointReferences.current is never reassigned
            // eslint-disable-next-line react-hooks/exhaustive-deps
            var _iterator2 = (0, $71a6e9ce88b1800c$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== "NullEntryPointReference") unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === "NullEntryPointReference" ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $71a6e9ce88b1800c$var$useLoadEntryPoint;

});
parcelRegister("epnQn", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $acw62 = parcelRequire("acw62");
var $a7d5e55a6ec2b789$var$useEffect = $acw62.useEffect, $a7d5e55a6ec2b789$var$useRef = $acw62.useRef;
function $a7d5e55a6ec2b789$var$useIsMountedRef() {
    var isMountedRef = $a7d5e55a6ec2b789$var$useRef(true);
    $a7d5e55a6ec2b789$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $a7d5e55a6ec2b789$var$useIsMountedRef;

});


parcelRegister("3QqxT", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $fKRfW = parcelRequire("fKRfW");

var $1c3ii = parcelRequire("1c3ii");
var $2ccad1d442117d14$var$useTrackLoadQueryInRender = $1c3ii.useTrackLoadQueryInRender;

var $ljhVv = parcelRequire("ljhVv");

var $eYEgc = parcelRequire("eYEgc");

var $acw62 = parcelRequire("acw62");
var $2ccad1d442117d14$var$useDebugValue = $acw62.useDebugValue;

var $eJz0f = parcelRequire("eJz0f");
var $2ccad1d442117d14$var$getFragment = $eJz0f.getFragment;
function $2ccad1d442117d14$var$useFragment_LEGACY(fragment, key) {
    // We need to use this hook in order to be able to track if
    // loadQuery was called during render
    $2ccad1d442117d14$var$useTrackLoadQueryInRender();
    var fragmentNode = $2ccad1d442117d14$var$getFragment(fragment);
    $eYEgc(fragmentNode, "first argument of useFragment()");
    var _useFragmentNode = $ljhVv(fragmentNode, key, "useFragment()"), data = _useFragmentNode.data;
    return data;
}
function $2ccad1d442117d14$var$useFragment(fragment, key) {
    var impl = $fKRfW.get();
    if (impl) // $FlowFixMe This is safe because impl.useFragment has the type of useFragment...
    return impl.useFragment(fragment, key);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    return $2ccad1d442117d14$var$useFragment_LEGACY(fragment, key);
}
module.exports = $2ccad1d442117d14$var$useFragment;

});
parcelRegister("fKRfW", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("8Fbfi");
var $b784766cc6cbdb02$var$implementation = null;
function $b784766cc6cbdb02$var$inject(impl) {
    $b784766cc6cbdb02$var$implementation = impl;
}
function $b784766cc6cbdb02$var$get() {
    return $b784766cc6cbdb02$var$implementation;
}
module.exports = {
    inject: $b784766cc6cbdb02$var$inject,
    get: $b784766cc6cbdb02$var$get
};

});

parcelRegister("eYEgc", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("fciVy");
parcelRequire("8Fbfi");
function $02d05a6bd98090d2$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $02d05a6bd98090d2$var$useStaticFragmentNodeWarning;

});


parcelRegister("2rQPf", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $1c87146c0f3b6dc9$var$_interopRequireDefault = $1jnue.default;

var $1c87146c0f3b6dc9$var$_objectSpread2 = $1c87146c0f3b6dc9$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $epnQn = parcelRequire("epnQn");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $1c87146c0f3b6dc9$var$defaultCommitMutation = $eJz0f.commitMutation;
var $1c87146c0f3b6dc9$var$useState = $acw62.useState, $1c87146c0f3b6dc9$var$useEffect = $acw62.useEffect, $1c87146c0f3b6dc9$var$useRef = $acw62.useRef, $1c87146c0f3b6dc9$var$useCallback = $acw62.useCallback;
function $1c87146c0f3b6dc9$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1c87146c0f3b6dc9$var$defaultCommitMutation;
    var environment = $4fG2B();
    var isMountedRef = $epnQn();
    var environmentRef = $1c87146c0f3b6dc9$var$useRef(environment);
    var mutationRef = $1c87146c0f3b6dc9$var$useRef(mutation);
    var inFlightMutationsRef = $1c87146c0f3b6dc9$var$useRef(new Set());
    var _useState = $1c87146c0f3b6dc9$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $1c87146c0f3b6dc9$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $1c87146c0f3b6dc9$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $1c87146c0f3b6dc9$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $1c87146c0f3b6dc9$var$_objectSpread2["default"])((0, $1c87146c0f3b6dc9$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $1c87146c0f3b6dc9$var$useMutation;

});

parcelRegister("dAN4o", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $9e54b364225a7706$var$_interopRequireDefault = $1jnue.default;

var $9e54b364225a7706$var$_objectSpread2 = $9e54b364225a7706$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $fKRfW = parcelRequire("fKRfW");

var $7OZAN = parcelRequire("7OZAN");

var $9C62v = parcelRequire("9C62v");

var $eYEgc = parcelRequire("eYEgc");

var $acw62 = parcelRequire("acw62");
var $9e54b364225a7706$var$useCallback = $acw62.useCallback, $9e54b364225a7706$var$useDebugValue = $acw62.useDebugValue, $9e54b364225a7706$var$useState = $acw62.useState;

var $eJz0f = parcelRequire("eJz0f");
var $9e54b364225a7706$var$getFragment = $eJz0f.getFragment, $9e54b364225a7706$var$getFragmentIdentifier = $eJz0f.getFragmentIdentifier, $9e54b364225a7706$var$getPaginationMetadata = $eJz0f.getPaginationMetadata;
// This separate type export is only needed as long as we are injecting
// a separate hooks implementation in ./HooksImplementation -- it can
// be removed after we stop doing that.
function $9e54b364225a7706$var$usePaginationFragment_LEGACY(fragmentInput, parentFragmentRef) {
    var fragmentNode = $9e54b364225a7706$var$getFragment(fragmentInput);
    $eYEgc(fragmentNode, "first argument of usePaginationFragment()");
    var componentDisplayName = "usePaginationFragment()";
    var _getPaginationMetadat = $9e54b364225a7706$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata, identifierField = _getPaginationMetadat.identifierField;
    var _useRefetchableFragme = $9C62v(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $9e54b364225a7706$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    // Backward pagination
    var _useLoadMore = $9e54b364225a7706$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: "backward",
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        identifierField: identifierField,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    // Forward pagination
    var _useLoadMore2 = $9e54b364225a7706$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: "forward",
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        identifierField: identifierField,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $9e54b364225a7706$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $9e54b364225a7706$var$_objectSpread2["default"])((0, $9e54b364225a7706$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $9e54b364225a7706$var$useLoadMore(args) {
    var _useState = $9e54b364225a7706$var$useState(false), isLoadingMore = _useState[0], setIsLoadingMore = _useState[1];
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $7OZAN((0, $9e54b364225a7706$var$_objectSpread2["default"])((0, $9e54b364225a7706$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
function $9e54b364225a7706$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var impl = $fKRfW.get();
    if (impl) return impl.usePaginationFragment(fragmentInput, parentFragmentRef);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    return $9e54b364225a7706$var$usePaginationFragment_LEGACY(fragmentInput, parentFragmentRef);
}
module.exports = $9e54b364225a7706$var$usePaginationFragment;

});
parcelRegister("7OZAN", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $5b1cfaea4824f818$var$_interopRequireDefault = $1jnue.default;

var $5b1cfaea4824f818$var$_objectSpread2 = $5b1cfaea4824f818$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $fzOCt = parcelRequire("fzOCt");

var $epnQn = parcelRequire("epnQn");

var $jCnVf = parcelRequire("jCnVf");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $5b1cfaea4824f818$var$useCallback = $acw62.useCallback, $5b1cfaea4824f818$var$useEffect = $acw62.useEffect, $5b1cfaea4824f818$var$useState = $acw62.useState;

var $eJz0f = parcelRequire("eJz0f");
var $5b1cfaea4824f818$var$fetchQuery = $eJz0f.__internal.fetchQuery, $5b1cfaea4824f818$var$ConnectionInterface = $eJz0f.ConnectionInterface, $5b1cfaea4824f818$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $5b1cfaea4824f818$var$getPaginationVariables = $eJz0f.getPaginationVariables, $5b1cfaea4824f818$var$getSelector = $eJz0f.getSelector, $5b1cfaea4824f818$var$getValueAtPath = $eJz0f.getValueAtPath;
parcelRequire("8Fbfi");
function $5b1cfaea4824f818$var$useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset, identifierField = args.identifierField;
    var environment = $4fG2B();
    var _useFetchTrackingRef = $fzOCt(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var identifierValue = identifierField != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierField] : null;
    var isMountedRef = $epnQn();
    var _useState = $5b1cfaea4824f818$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $5b1cfaea4824f818$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $jCnVf(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $5b1cfaea4824f818$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    // Dispose of pagination requests in flight when unmounting
    $5b1cfaea4824f818$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $5b1cfaea4824f818$var$useCallback(function(count, options) {
        // TODO(T41131846): Fetch/Caching policies for loadMore
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $5b1cfaea4824f818$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== "PluralReaderSelector") && $aaXwj(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $5b1cfaea4824f818$var$_objectSpread2["default"])((0, $5b1cfaea4824f818$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $5b1cfaea4824f818$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $5b1cfaea4824f818$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        // If the query needs an identifier value ('id' or similar) and one
        // was not explicitly provided, read it from the fragment data.
        if (identifierField != null) {
            // @refetchable fragments are guaranteed to have an `id` selection
            // if the type is Node, implements Node, or is @fetchable. Double-check
            // that there actually is a value at runtime.
            typeof identifierValue;
            paginationVariables.id = identifierValue;
        }
        var paginationQuery = $5b1cfaea4824f818$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $5b1cfaea4824f818$var$fetchQuery(environment, paginationQuery).subscribe((0, $5b1cfaea4824f818$var$_objectSpread2["default"])((0, $5b1cfaea4824f818$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, // NOTE: We disable react-hooks-deps warning because all values
    // inside paginationMetadata are static
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function $5b1cfaea4824f818$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $5b1cfaea4824f818$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $5b1cfaea4824f818$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === "object") && $aaXwj(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $aaXwj(false);
    !(typeof pageInfo === "object") && $aaXwj(false);
    var cursor = direction === "forward" ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === "string") && $aaXwj(false);
    var hasMore;
    if (direction === "forward") hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $5b1cfaea4824f818$var$useLoadMoreFunction;

});
parcelRegister("jCnVf", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $eJz0f = parcelRequire("eJz0f");
var $e4841f682ea31b56$var$getObservableForActiveRequest = $eJz0f.__internal.getObservableForActiveRequest, $e4841f682ea31b56$var$getSelector = $eJz0f.getSelector;
var $e4841f682ea31b56$var$useEffect = $acw62.useEffect, $e4841f682ea31b56$var$useState = $acw62.useState, $e4841f682ea31b56$var$useMemo = $acw62.useMemo;
function $e4841f682ea31b56$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $4fG2B();
    var observable = $e4841f682ea31b56$var$useMemo(function() {
        var selector = $e4841f682ea31b56$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === "SingularReaderSelector") && $aaXwj(false);
        return $e4841f682ea31b56$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $e4841f682ea31b56$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $e4841f682ea31b56$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $e4841f682ea31b56$var$useIsOperationNodeActive;

});


parcelRegister("9C62v", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $6ffc58f1c319ff08$var$_interopRequireDefault = $1jnue.default;

var $6ffc58f1c319ff08$var$_objectSpread2 = $6ffc58f1c319ff08$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5wdCj = parcelRequire("5wdCj");
var $6ffc58f1c319ff08$var$getFragmentResourceForEnvironment = $5wdCj.getFragmentResourceForEnvironment;

var $9pgH3 = parcelRequire("9pgH3");

var $i2nMq = parcelRequire("i2nMq");
var $6ffc58f1c319ff08$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $ljhVv = parcelRequire("ljhVv");

var $epnQn = parcelRequire("epnQn");

var $hASCV = parcelRequire("hASCV");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $6ffc58f1c319ff08$var$useCallback = $acw62.useCallback, $6ffc58f1c319ff08$var$useContext = $acw62.useContext, $6ffc58f1c319ff08$var$useReducer = $acw62.useReducer;

var $eJz0f = parcelRequire("eJz0f");
var $6ffc58f1c319ff08$var$fetchQuery = $eJz0f.__internal.fetchQuery, $6ffc58f1c319ff08$var$createOperationDescriptor = $eJz0f.createOperationDescriptor, $6ffc58f1c319ff08$var$getFragmentIdentifier = $eJz0f.getFragmentIdentifier, $6ffc58f1c319ff08$var$getRefetchMetadata = $eJz0f.getRefetchMetadata, $6ffc58f1c319ff08$var$getSelector = $eJz0f.getSelector, $6ffc58f1c319ff08$var$getValueAtPath = $eJz0f.getValueAtPath;
parcelRequire("8Fbfi");
function $6ffc58f1c319ff08$var$reducer(state, action) {
    switch(action.type){
        case "refetch":
            var _action$refetchEnviro;
            return (0, $6ffc58f1c319ff08$var$_objectSpread2["default"])((0, $6ffc58f1c319ff08$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case "reset":
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error("useRefetchableFragmentNode: Unexpected action type");
    }
}
function $6ffc58f1c319ff08$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $4fG2B();
    var _getRefetchMetadata = $6ffc58f1c319ff08$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierField = _getRefetchMetadata.identifierField;
    var fragmentIdentifier = $6ffc58f1c319ff08$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $6ffc58f1c319ff08$var$useReducer($6ffc58f1c319ff08$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $6ffc58f1c319ff08$var$getQueryResourceForEnvironment(environment);
    var FragmentResource = $6ffc58f1c319ff08$var$getFragmentResourceForEnvironment(environment);
    var profilerContext = $6ffc58f1c319ff08$var$useContext($9pgH3);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $hASCV(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: "reset",
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        // If refetch was called, we expect to have a refetchQuery and queryRef
        // in state, since both state updates to set the refetchQuery and the
        // queryRef occur simultaneously.
        // In this case, we need to read the refetched query data (potentially
        // suspending if it's in flight), and extract the new fragment ref
        // from the query in order read the current @refetchable fragment
        // with the updated fragment owner as the new refetchQuery.
        // Before observing the refetch, record the current ID and typename
        // so that, if we are refetching existing data on
        // a field that implements Node, after refetching we
        // can validate that the received data is consistent
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        // The queryRef.source obtained from useQueryLoader will be
        // an observable we can consume /if/ a network request was
        // started. Otherwise, given that QueryResource.prepare
        // always expects an observable we fall back to a new network
        // observable. Note however that if loadQuery did not make a network
        // request, we don't expect to make one here, unless the state of
        // the cache has changed between the call to refetch and this
        // render.
        var fetchObservable = queryRef.source != null ? queryRef.source : $6ffc58f1c319ff08$var$fetchQuery(environment, refetchQuery);
        // Now wwe can we read the refetch query here using the
        // queryRef provided from useQueryLoader. Note that the
        // network request is started during the call to refetch,
        // but if the refetch query is still in flight, we will suspend
        // at this point:
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = FragmentResource.read(queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $aaXwj(false);
        // After reading/fetching the refetch query, we extract from the
        // refetch query response the new fragment ref we need to use to read
        // the fragment. The new fragment ref will point to the refetch query
        // as its fragment owner.
        var refetchedFragmentRef = $6ffc58f1c319ff08$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    // We read and subscribe to the fragment using useFragmentNode.
    // If refetch was called, we read the fragment using the new computed
    // fragment ref from the refetch query response; otherwise, we use the
    // fragment ref passed by the caller as normal.
    var _useFragmentNode = $ljhVv(fragmentNode, fragmentRef, componentDisplayName), fragmentData = _useFragmentNode.data, disableStoreUpdates = _useFragmentNode.disableStoreUpdates, enableStoreUpdates = _useFragmentNode.enableStoreUpdates;
    var refetch = $6ffc58f1c319ff08$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierField, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch,
        disableStoreUpdates: disableStoreUpdates,
        enableStoreUpdates: enableStoreUpdates
    };
}
function $6ffc58f1c319ff08$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierField, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $epnQn();
    var identifierValue = identifierField != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierField] : null;
    return $6ffc58f1c319ff08$var$useCallback(function(providedRefetchVariables, options) {
        // Bail out and warn if we're trying to refetch after the component
        // has unmounted
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $6ffc58f1c319ff08$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === "PluralReaderSelector") {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        // A user of `useRefetchableFragment()` may pass a subset of
        // all variables required by the fragment when calling `refetch()`.
        // We fill in any variables not passed by the call to `refetch()` with the
        // variables from the original parent fragment owner.
        var refetchVariables = (0, $6ffc58f1c319ff08$var$_objectSpread2["default"])((0, $6ffc58f1c319ff08$var$_objectSpread2["default"])((0, $6ffc58f1c319ff08$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        // If the query needs an identifier value ('id' or similar) and one
        // was not explicitly provided, read it from the fragment data.
        if (identifierField != null && !providedRefetchVariables.hasOwnProperty("id")) {
            // @refetchable fragments are guaranteed to have an `id` selection
            // if the type is Node, implements Node, or is @fetchable. Double-check
            // that there actually is a value at runtime.
            typeof identifierValue;
            refetchVariables.id = identifierValue;
        }
        var refetchQuery = $6ffc58f1c319ff08$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        // We call loadQuery which will start a network request if necessary
        // and update the querRef from useQueryLoader.
        // Note the following:
        // - loadQuery will dispose of any previously refetched queries.
        // - We use the variables extracted off the OperationDescriptor
        // so that they have been filtered out to include only the
        // variables actually declared in the query.
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: "refetch"
        });
        dispatch({
            type: "refetch",
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, // NOTE: We disable react-hooks-deps warning because:
    //   - We know fragmentRefPathInResponse is static, so it can be omitted from
    //     deps
    //   - We know fragmentNode is static, so it can be omitted from deps.
    //   - fragmentNode and parentFragmentRef are also captured by including
    //     fragmentIdentifier
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $6ffc58f1c319ff08$var$debugFunctions;
module.exports = $6ffc58f1c319ff08$var$useRefetchableFragmentNode;

});
parcelRegister("hASCV", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $ccf02c33d689ea63$var$_interopRequireDefault = $1jnue.default;

var $ccf02c33d689ea63$var$_createForOfIteratorHelper2 = $ccf02c33d689ea63$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $1c3ii = parcelRequire("1c3ii");
var $ccf02c33d689ea63$var$loadQuery = $1c3ii.loadQuery, $ccf02c33d689ea63$var$useTrackLoadQueryInRender = $1c3ii.useTrackLoadQueryInRender;

var $epnQn = parcelRequire("epnQn");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $ccf02c33d689ea63$var$useCallback = $acw62.useCallback, $ccf02c33d689ea63$var$useEffect = $acw62.useEffect, $ccf02c33d689ea63$var$useRef = $acw62.useRef, $ccf02c33d689ea63$var$useState = $acw62.useState;

var $eJz0f = parcelRequire("eJz0f");
var $ccf02c33d689ea63$var$getRequest = $eJz0f.getRequest;
var $ccf02c33d689ea63$var$initialNullQueryReferenceState = {
    kind: "NullQueryReference"
};
function $ccf02c33d689ea63$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === "PreloadableConcreteRequest") return preloadableRequest.params.metadata.live !== undefined;
    var request = $ccf02c33d689ea63$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $ccf02c33d689ea63$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    /**
   * We want to always call `queryReference.dispose()` for every call to
   * `setQueryReference(loadQuery(...))` so that no leaks of data in Relay stores
   * will occur.
   *
   * However, a call to `setState(newState)` is not always followed by a commit where
   * this value is reflected in the state. Thus, we cannot reliably clean up each
   * ref with `useEffect(() => () => queryReference.dispose(), [queryReference])`.
   *
   * Instead, we keep track of each call to `loadQuery` in a ref.
   * Relying on the fact that if a state change commits, no state changes that were
   * initiated prior to the currently committing state change will ever subsequently
   * commit, we can safely dispose of all preloaded query references
   * associated with state changes initiated prior to the currently committing state
   * change.
   *
   * Finally, when the hook unmounts, we also dispose of all remaining uncommitted
   * query references.
   */ var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $ccf02c33d689ea63$var$initialNullQueryReferenceState;
    var environment = $4fG2B();
    $ccf02c33d689ea63$var$useTrackLoadQueryInRender();
    var isMountedRef = $epnQn();
    var undisposedQueryReferencesRef = $ccf02c33d689ea63$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $ccf02c33d689ea63$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $ccf02c33d689ea63$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        // Rendering the query reference makes it "managed" by this hook, so
        // we start keeping track of it so we can dispose it when it is no longer
        // necessary here
        // TODO(T78446637): Handle disposal of managed query references in
        // components that were never mounted after rendering
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $ccf02c33d689ea63$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($ccf02c33d689ea63$var$initialNullQueryReferenceState);
            setQueryReference($ccf02c33d689ea63$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $ccf02c33d689ea63$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty("__environment") ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $ccf02c33d689ea63$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $ccf02c33d689ea63$var$useRef(false);
    $ccf02c33d689ea63$var$useEffect(function() {
        return function() {
            // Attempt to detect if the component was
            // hidden (by Offscreen API), or fast refresh occured;
            // Only in these situations would the effect cleanup
            // for "unmounting" run multiple times, so if
            // we are ever able to read this ref with a value
            // of true, it means that one of these cases
            // has happened.
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $ccf02c33d689ea63$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            // This block only runs if the component has previously "unmounted"
            // due to it being hidden by the Offscreen API, or during fast refresh.
            // At this point, the current queryReference will have been disposed
            // by the previous cleanup, so instead of attempting to
            // do our regular commit setup, which would incorrectly leave our
            // current queryReference disposed, we need to load the query again
            // and force a re-render by calling queryLoaderCallback again,
            // so that the queryReference is correctly re-retained, and
            // potentially refetched if necessary.
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== "NullQueryReference") queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        // When a new queryReference is committed, we iterate over all
        // query references in undisposedQueryReferences and dispose all of
        // the refs that aren't the currently committed one. This ensures
        // that we don't leave any dangling query references for the
        // case that loadQuery is called multiple times before commit; when
        // this happens, multiple state updates will be scheduled, but only one
        // will commit, meaning that we need to keep track of and dispose any
        // query references that don't end up committing.
        // - We are relying on the fact that sets iterate in insertion order, and we
        // can remove items from a set as we iterate over it (i.e. no iterator
        // invalidation issues.) Thus, it is safe to loop through
        // undisposedQueryReferences until we find queryReference, and
        // remove and dispose all previous references.
        // - We are guaranteed to find queryReference in the set, because if a
        // state update results in a commit, no state updates initiated prior to that
        // one will be committed, and we are disposing and removing references
        // associated with updates that were scheduled prior to the currently
        // committing state change. (A useEffect callback is called during the commit
        // phase.)
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $ccf02c33d689ea63$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== "NullQueryReference") {
                        if ($ccf02c33d689ea63$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $ccf02c33d689ea63$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            // undisposedQueryReferences.current is never reassigned
            // eslint-disable-next-line react-hooks/exhaustive-deps
            var _iterator2 = (0, $ccf02c33d689ea63$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== "NullQueryReference") {
                        if ($ccf02c33d689ea63$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === "NullQueryReference" ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $ccf02c33d689ea63$var$useQueryLoader;

});



parcelRegister("fH4DL", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1c3ii = parcelRequire("1c3ii");
var $b6ce78a9352dcf1e$var$useTrackLoadQueryInRender = $1c3ii.useTrackLoadQueryInRender;

var $03QWz = parcelRequire("03QWz");

var $lbcmO = parcelRequire("lbcmO");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $b6ce78a9352dcf1e$var$useDebugValue = $acw62.useDebugValue;

var $eJz0f = parcelRequire("eJz0f");
var $b6ce78a9352dcf1e$var$_require3$__internal = $eJz0f.__internal, $b6ce78a9352dcf1e$var$fetchQueryDeduped = $b6ce78a9352dcf1e$var$_require3$__internal.fetchQueryDeduped, $b6ce78a9352dcf1e$var$fetchQuery = $b6ce78a9352dcf1e$var$_require3$__internal.fetchQuery;
parcelRequire("8Fbfi");
function $b6ce78a9352dcf1e$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    // We need to use this hook in order to be able to track if
    // loadQuery was called during render
    $b6ce78a9352dcf1e$var$useTrackLoadQueryInRender();
    var environment = $4fG2B();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $lbcmO(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === "PreloadedQuery_DEPRECATED") {
        !(operation.request.node.params.name === preloadedQuery.name) && $aaXwj(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: "usePreloadedQuery()",
            fetchKey: fetchKey,
            fetchObservable: $b6ce78a9352dcf1e$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $b6ce78a9352dcf1e$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) // If the source observable exists and the environments match, reuse
        // the source observable.
        // If the source observable happens to be empty, we need to fall back
        // and re-execute and de-dupe the query (at render time).
        fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else // if (source == null)
        // If the source observable does not exist, we need to
        // fall back and re-execute and de-dupe the query (at render time).
        fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: "usePreloadedQuery()",
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $03QWz(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $b6ce78a9352dcf1e$var$usePreloadedQuery;

});

parcelRegister("1tdq5", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $fKRfW = parcelRequire("fKRfW");

var $9C62v = parcelRequire("9C62v");

var $eYEgc = parcelRequire("eYEgc");

var $acw62 = parcelRequire("acw62");
var $1122e8be893ed8ab$var$useDebugValue = $acw62.useDebugValue;

var $eJz0f = parcelRequire("eJz0f");
var $1122e8be893ed8ab$var$getFragment = $eJz0f.getFragment;
function $1122e8be893ed8ab$var$useRefetchableFragment_LEGACY(fragmentInput, fragmentRef) {
    var fragmentNode = $1122e8be893ed8ab$var$getFragment(fragmentInput);
    $eYEgc(fragmentNode, "first argument of useRefetchableFragment()");
    var _useRefetchableFragme = $9C62v(fragmentNode, fragmentRef, "useRefetchableFragment()"), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    return [
        fragmentData,
        refetch
    ];
}
function $1122e8be893ed8ab$var$useRefetchableFragment(fragmentInput, parentFragmentRef) {
    var impl = $fKRfW.get();
    if (impl) return impl.useRefetchableFragment(fragmentInput, parentFragmentRef);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    return $1122e8be893ed8ab$var$useRefetchableFragment_LEGACY(fragmentInput, parentFragmentRef);
}
module.exports = $1122e8be893ed8ab$var$useRefetchableFragment;

});

parcelRegister("jc1m1", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $df90303d28a83b73$var$useEffect = $acw62.useEffect, $df90303d28a83b73$var$useRef = $acw62.useRef;
/**
 * This hook subscribes a callback to the invalidation state of the given data
 * ids.
 * Any time the invalidation state of the given data ids changes, the provided
 * callback will be called.
 * If new ids or a new callback are provided, the subscription will be
 * re-established and the previous one will be disposed.
 * The subscription will automatically be disposed on unmount
 */ function $df90303d28a83b73$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $4fG2B();
    var disposableRef = $df90303d28a83b73$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join("");
    $df90303d28a83b73$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    // Intentionally excluding dataIDs, since we're using stableDataIDs
    // instead
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $df90303d28a83b73$var$useSubscribeToInvalidationState;

});

parcelRegister("5v24M", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $401175455cbde4cc$var$useEffect = $acw62.useEffect;

var $eJz0f = parcelRequire("eJz0f");
var $401175455cbde4cc$var$requestSubscription = $eJz0f.requestSubscription;
function $401175455cbde4cc$var$useSubscription(config, requestSubscriptionFn) {
    // N.B. this will re-subscribe every render if config or requestSubscriptionFn
    // are not memoized.
    // Please do not pass an object defined in-line.
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $401175455cbde4cc$var$requestSubscription;
    var environment = $4fG2B();
    $401175455cbde4cc$var$useEffect(function() {
        // $FlowFixMe[method-unbinding] added when improving typing for this parameters
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $401175455cbde4cc$var$useSubscription;

});


parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("PQUkW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $09617a006c45b4bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<192a9501fd19331053e02f90641a24ce>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $09617a006c45b4bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "location",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "company",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aaid",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isProfileOwnerConsented",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ProfileHeaderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ProfileHeaderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "0dbebd2eccbc970c64b2d1a265d2e13a",
            "id": null,
            "metadata": {},
            "name": "ProfileHeaderQuery",
            "operationKind": "query",
            "text": "query ProfileHeaderQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n      ... on UnifiedProfile {\n        role\n        username\n        location\n        company\n        aaid\n        isProfileOwnerConsented\n        id\n      }\n    }\n  }\n}\n"
        }
    };
}();
$09617a006c45b4bb$var$node.hash = "5731eb3bb0340efb3bb1afba7d93b69c";
var $09617a006c45b4bb$export$2e2bcd8739ae039 = $09617a006c45b4bb$var$node;

});

parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
"use strict";
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("k04tT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1a8d05118d0f84b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8420705df6bcb29184d2551f0e6e1e1b>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a8d05118d0f84b1$var$node = {
    "kind": "InlineDataFragment",
    "name": "UnifiedProfileFragment"
};
$1a8d05118d0f84b1$var$node.hash = "83600c81da532c36a91267a4fb5bf6af";
var $1a8d05118d0f84b1$export$2e2bcd8739ae039 = $1a8d05118d0f84b1$var$node;

});

parcelRegister("fBk32", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84fe66734a4dc5b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d7ee1c1d6daf84ebca43ff0cb90cfcc>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84fe66734a4dc5b1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "aaid"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "aaid"
        },
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v5 = [
        v4 /*: any*/ ,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "company",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aaid",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountInternalId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "products",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "internalId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "websiteUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "youtubeUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrivate",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPersonalView",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLinkedView",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isProfileBanned",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isProfileOwnerConsented",
            "storageKey": null
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UnifiedProfileQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v3 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "InlineDataFragmentSpread",
                                            "name": "UnifiedProfileFragment",
                                            "selections": v5 /*: any*/ ,
                                            "args": null,
                                            "argumentDefinitions": []
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "atlassianProducts",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AtlassianProductsFragment"
                                        }
                                    ],
                                    "type": "UnifiedAtlassianProductConnection",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UnifiedProfileQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v3 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v5 /*: any*/ ,
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "atlassianProducts",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedAtlassianProductEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "cursor",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UnifiedAtlassianProduct",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "productId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "title",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "type",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "viewHref",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalCount",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedAtlassianProductConnection",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6dba7149ad9a27085c3682894effb09d",
            "id": null,
            "metadata": {},
            "name": "UnifiedProfileQuery",
            "operationKind": "query",
            "text": "query UnifiedProfileQuery(\n  $aaid: String\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(aaid: $aaid, unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        ...UnifiedProfileFragment\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n    atlassianProducts {\n      __typename\n      ... on UnifiedAtlassianProductConnection {\n        ...AtlassianProductsFragment\n      }\n    }\n  }\n}\n\nfragment AtlassianProductsFragment on UnifiedAtlassianProductConnection {\n  edges {\n    cursor\n    node {\n      id\n      productId\n      title\n      type\n      viewHref\n    }\n  }\n  totalCount\n}\n\nfragment UnifiedProfileFragment on UnifiedProfile {\n  id\n  bio\n  company\n  aaid\n  linkedinUrl\n  accountInternalId\n  location\n  products\n  role\n  internalId\n  username\n  websiteUrl\n  xUrl\n  youtubeUrl\n  isPrivate\n  isPersonalView\n  isLinkedView\n  isProfileBanned\n  isProfileOwnerConsented\n}\n"
        }
    };
}();
$84fe66734a4dc5b1$var$node.hash = "115e9f07c2f9dd14c0a4762e8efce747";
var $84fe66734a4dc5b1$export$2e2bcd8739ae039 = $84fe66734a4dc5b1$var$node;

});

parcelRegister("59shu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3fe720af5a1f2196$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ce8a393b1f27a7b9a7f4ca8cc469f87>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fe720af5a1f2196$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "aaid"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aaid",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailId",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "internalId",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLinked",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isManaged",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPrimary",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isForumsModerator",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "picture",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedLinkedAccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAccount",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            v7 /*: any*/ ,
                            v8 /*: any*/ ,
                            v11 /*: any*/ ,
                            v10 /*: any*/ 
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedPageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedLinkedAccountConnection",
        "abstractKey": null
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "UnifiedAccountQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "account",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "linkedAccounts",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedAccount",
                                    "abstractKey": null
                                },
                                v13 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UnifiedAccountQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "account",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "linkedAccounts",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedAccount",
                                    "abstractKey": null
                                },
                                v13 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "7b185e4468ff394604f615bca098628a",
            "id": null,
            "metadata": {},
            "name": "UnifiedAccountQuery",
            "operationKind": "query",
            "text": "query UnifiedAccountQuery(\n  $aaid: String!\n) {\n  unified {\n    account(aaid: $aaid) {\n      __typename\n      ... on UnifiedAccount {\n        id\n        aaid\n        emailId\n        internalId\n        isLinked\n        isManaged\n        isPrimary\n        isForumsModerator\n        picture\n        nickname\n        linkedAccounts {\n          __typename\n          ... on UnifiedLinkedAccountConnection {\n            edges {\n              node {\n                id\n                aaid\n                emailId\n                internalId\n                isLinked\n                isManaged\n                isPrimary\n                nickname\n                picture\n              }\n              cursor\n            }\n            totalCount\n            pageInfo {\n              endCursor\n              hasNextPage\n              hasPreviousPage\n              startCursor\n            }\n          }\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n        }\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$3fe720af5a1f2196$var$node.hash = "33efd2bb3841b81d065848dd612f699f";
var $3fe720af5a1f2196$export$2e2bcd8739ae039 = $3fe720af5a1f2196$var$node;

});

parcelRegister("am7fE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5104ed96fa992f66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69bdcc782317d4e6e8ba97127e901b98>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5104ed96fa992f66$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
    }, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountStatus",
        "storageKey": null
    }, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "picture",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AtlassianAccountUserQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AtlassianAccountUserFragment"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AtlassianAccountUserQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                v0 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "type": "AtlassianAccountUser",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "7d5ee8d4a42df8125ee378a819cf0be7",
            "id": null,
            "metadata": {},
            "name": "AtlassianAccountUserQuery",
            "operationKind": "query",
            "text": "query AtlassianAccountUserQuery {\n  me {\n    user {\n      __typename\n      accountId\n      accountStatus\n      name\n      ... on AtlassianAccountUser {\n        email\n        nickname\n        picture\n        ...AtlassianAccountUserFragment\n      }\n      id\n    }\n  }\n}\n\nfragment AtlassianAccountUserFragment on AtlassianAccountUser {\n  id\n  email\n  nickname\n  name\n  accountId\n  accountStatus\n  picture\n}\n"
        }
    };
}();
$5104ed96fa992f66$var$node.hash = "a743a411d81393e057da5117241d38ac";
var $5104ed96fa992f66$export$2e2bcd8739ae039 = $5104ed96fa992f66$var$node;

});

parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8HV7i", function(module, exports) {

var $g3LWB = parcelRequire("g3LWB");

var $dxaB1 = parcelRequire("dxaB1");

var $clik2 = parcelRequire("clik2");

var $ffJvR = parcelRequire("ffJvR");

var $akdiQ = parcelRequire("akdiQ");

var $jqdgk = parcelRequire("jqdgk");

var $fj05i = parcelRequire("fj05i");
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict";
    var r = $dxaB1(), e = r.m($656ea513998a70a9$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $fj05i(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $g3LWB(r, e);
            },
            AsyncIterator: $akdiQ,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $ffJvR : $clik2)(a(r), e, t, o, u);
            },
            keys: $jqdgk,
            values: $fj05i
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g3LWB", function(module, exports) {
function $bb121de08fcbfcd5$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $bb121de08fcbfcd5$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dxaB1", function(module, exports) {

var $bvtjp = parcelRequire("bvtjp");
function $9da69396b6a55ef6$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $bvtjp(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($bvtjp(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $bvtjp(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $bvtjp(u, "constructor", GeneratorFunctionPrototype), $bvtjp(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $bvtjp(GeneratorFunctionPrototype, o, "GeneratorFunction"), $bvtjp(u), $bvtjp(u, o, "Generator"), $bvtjp(u, n, function() {
        return this;
    }), $bvtjp(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $9da69396b6a55ef6$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $9da69396b6a55ef6$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bvtjp", function(module, exports) {
function $860953b56aa6b685$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $860953b56aa6b685$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $860953b56aa6b685$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $860953b56aa6b685$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $860953b56aa6b685$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("clik2", function(module, exports) {

var $ffJvR = parcelRequire("ffJvR");
function $8fc5a89a7b8dab85$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $ffJvR(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $8fc5a89a7b8dab85$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ffJvR", function(module, exports) {

var $dxaB1 = parcelRequire("dxaB1");

var $akdiQ = parcelRequire("akdiQ");
function $b1ab8fa4d5e48c1f$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $akdiQ($dxaB1().w(r, e, t, o), n || Promise);
}
module.exports = $b1ab8fa4d5e48c1f$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("akdiQ", function(module, exports) {

var $g3LWB = parcelRequire("g3LWB");

var $bvtjp = parcelRequire("bvtjp");
function $78461755ff54e6c7$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $g3LWB ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($bvtjp($78461755ff54e6c7$var$AsyncIterator.prototype), $bvtjp($78461755ff54e6c7$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $bvtjp(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $78461755ff54e6c7$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("jqdgk", function(module, exports) {
function $e23abba3e573ae7a$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $e23abba3e573ae7a$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fj05i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b248b2228601290d$var$_typeof = $41YNz.default;
function $b248b2228601290d$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($b248b2228601290d$var$_typeof(e) + " is not iterable");
}
module.exports = $b248b2228601290d$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jS1H0", function(module, exports) {
"use strict";
var $e7745f9a4dcdc92a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7745f9a4dcdc92a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e7745f9a4dcdc92a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9vgpJ")).Diagnostics;
    }
});

var $1x5ek = parcelRequire("1x5ek");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $1x5ek.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("aJqAw")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1Y0sQ")).Storage;
    }
});

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1TJvm")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("hgBBj")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("ig6km")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("fFRwz")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("9vgpJ")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1uA6T")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("90xfN")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("3izdo")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("iS0Os")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("c7j2m")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("gXsA7")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("aJqAw")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("bMivU")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("7JCXg")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("2juun")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("eHhOb")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("ibDZT")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("f87Bk")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("eSDjJ")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("df3hs")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("8VJP4")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("cyM0i")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("kAAfI")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("20vLv")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("9HWUG")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("3XJjC")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("72E2N")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("6A2Ba")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("cYkgq")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("fVgBI")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1Q38X")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("i0Ijk")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1Y0sQ")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("hpdMt")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("jif12")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("sNl0d")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("elNQX")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("gjSL0")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("9D94r")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("cJJ9J")), module.exports);
Object.assign((0, (parcelRequire("1TJvm"))._getStatsigGlobal)(), {
    Log: (parcelRequire("aJqAw")).Log,
    SDK_VERSION: (parcelRequire("72E2N")).SDK_VERSION
});

});
parcelRegister("1TJvm", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $161e39cde079670c$var$_a, $161e39cde079670c$var$_b, $161e39cde079670c$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $aJqAw = parcelRequire("aJqAw");
const $161e39cde079670c$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== "undefined" ? __STATSIG__ : $161e39cde079670c$var$statsigGlobal;
    } catch (e) {
        return $161e39cde079670c$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $161e39cde079670c$var$_getStatsigGlobal;
const $161e39cde079670c$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $161e39cde079670c$var$_getStatsigGlobalFlag;
const $161e39cde079670c$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $aJqAw.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $161e39cde079670c$var$_getInstance;
const $161e39cde079670c$var$GLOBAL_KEY = "__STATSIG__";
const $161e39cde079670c$var$_window = typeof window !== "undefined" ? window : {};
const $161e39cde079670c$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $161e39cde079670c$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $161e39cde079670c$var$statsigGlobal = ($161e39cde079670c$var$_c = ($161e39cde079670c$var$_b = ($161e39cde079670c$var$_a = $161e39cde079670c$var$_window[$161e39cde079670c$var$GLOBAL_KEY]) !== null && $161e39cde079670c$var$_a !== void 0 ? $161e39cde079670c$var$_a : $161e39cde079670c$var$_global[$161e39cde079670c$var$GLOBAL_KEY]) !== null && $161e39cde079670c$var$_b !== void 0 ? $161e39cde079670c$var$_b : $161e39cde079670c$var$_globalThis[$161e39cde079670c$var$GLOBAL_KEY]) !== null && $161e39cde079670c$var$_c !== void 0 ? $161e39cde079670c$var$_c : {
    instance: module.exports._getInstance
};
$161e39cde079670c$var$_window[$161e39cde079670c$var$GLOBAL_KEY] = $161e39cde079670c$var$statsigGlobal;
$161e39cde079670c$var$_global[$161e39cde079670c$var$GLOBAL_KEY] = $161e39cde079670c$var$statsigGlobal;
$161e39cde079670c$var$_globalThis[$161e39cde079670c$var$GLOBAL_KEY] = $161e39cde079670c$var$statsigGlobal;

});
parcelRegister("aJqAw", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $7d02bb34903f983d$var$DEBUG = " DEBUG ";
const $7d02bb34903f983d$var$_INFO = "  INFO ";
const $7d02bb34903f983d$var$_WARN = "  WARN ";
const $7d02bb34903f983d$var$ERROR = " ERROR ";
function $7d02bb34903f983d$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $7d02bb34903f983d$var$Log {
    static info(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Info) console.info($7d02bb34903f983d$var$_INFO, ...$7d02bb34903f983d$var$addTag(args));
    }
    static debug(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Debug) console.debug($7d02bb34903f983d$var$DEBUG, ...$7d02bb34903f983d$var$addTag(args));
    }
    static warn(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Warn) console.warn($7d02bb34903f983d$var$_WARN, ...$7d02bb34903f983d$var$addTag(args));
    }
    static error(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Error) console.error($7d02bb34903f983d$var$ERROR, ...$7d02bb34903f983d$var$addTag(args));
    }
}
module.exports.Log = $7d02bb34903f983d$var$Log;
$7d02bb34903f983d$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("9vgpJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $6eb3bdc3e880d863$var$MARKER_MAP = new Map();
const $6eb3bdc3e880d863$var$ACT_START = "start";
const $6eb3bdc3e880d863$var$ACT_END = "end";
const $6eb3bdc3e880d863$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $6eb3bdc3e880d863$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker({}, $6eb3bdc3e880d863$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $6eb3bdc3e880d863$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker(data, $6eb3bdc3e880d863$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker(data, $6eb3bdc3e880d863$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker({}, $6eb3bdc3e880d863$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker(data, $6eb3bdc3e880d863$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $6eb3bdc3e880d863$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $6eb3bdc3e880d863$var$_safeGetField(e, "code"),
            name: $6eb3bdc3e880d863$var$_safeGetField(e, "name"),
            message: $6eb3bdc3e880d863$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $6eb3bdc3e880d863$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $6eb3bdc3e880d863$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $6eb3bdc3e880d863$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $6eb3bdc3e880d863$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $6eb3bdc3e880d863$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $6eb3bdc3e880d863$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $6eb3bdc3e880d863$var$MARKER_MAP.set(sdkKey, markers);
}
function $6eb3bdc3e880d863$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("1x5ek", function(module, exports) {
"use strict";
var $11dcee1bd8902280$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $hgBBj = parcelRequire("hgBBj");

var $c7j2m = parcelRequire("c7j2m");

var $aJqAw = parcelRequire("aJqAw");

var $7JCXg = parcelRequire("7JCXg");

var $f87Bk = parcelRequire("f87Bk");

var $3XJjC = parcelRequire("3XJjC");

var $6A2Ba = parcelRequire("6A2Ba");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $sNl0d = parcelRequire("sNl0d");

var $gjSL0 = parcelRequire("gjSL0");
const $11dcee1bd8902280$var$DEFAULT_QUEUE_SIZE = 100;
const $11dcee1bd8902280$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $11dcee1bd8902280$var$MAX_DEDUPER_KEYS = 1000;
const $11dcee1bd8902280$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $11dcee1bd8902280$var$MAX_FAILED_LOGS = 500;
const $11dcee1bd8902280$var$QUICK_FLUSH_WINDOW_MS = 200;
const $11dcee1bd8902280$var$EVENT_LOGGER_MAP = {};
const $11dcee1bd8902280$var$RetryFailedLogsTrigger = {
    Startup: "startup",
    GainedFocus: "gained_focus"
};
class $11dcee1bd8902280$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $11dcee1bd8902280$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $11dcee1bd8902280$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($11dcee1bd8902280$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $6A2Ba.LoggingEnabledOption.disabled : $6A2Ba.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $aJqAw.Log.warn("Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.");
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $11dcee1bd8902280$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $sNl0d.UrlConfiguration($7JCXg.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $f87Bk._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always") return;
        $11dcee1bd8902280$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $gjSL0._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $11dcee1bd8902280$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($11dcee1bd8902280$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $11dcee1bd8902280$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $11dcee1bd8902280$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey), $11dcee1bd8902280$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always" && (0, $f87Bk._isServerEnv)()) return false;
        if (!(0, $3XJjC._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $hgBBj._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $11dcee1bd8902280$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $11dcee1bd8902280$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === "disabled") {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $gjSL0._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $aJqAw.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $aJqAw.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$7JCXg.NetworkParam.EventCount]: String(events.length)
            },
            credentials: "same-origin"
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $11dcee1bd8902280$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $1Y0sQ._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $aJqAw.Log.warn("Unable to save failed logs to storage");
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
                if (!$1Y0sQ.Storage.isReady()) yield $1Y0sQ.Storage.isReadyResolver();
                const events = (0, $1Y0sQ._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $11dcee1bd8902280$var$RetryFailedLogsTrigger.Startup) $1Y0sQ.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $11dcee1bd8902280$var$RetryFailedLogsTrigger.GainedFocus) $1Y0sQ.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $aJqAw.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $c7j2m._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $aJqAw.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $f87Bk._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $11dcee1bd8902280$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $11dcee1bd8902280$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $11dcee1bd8902280$var$EventLogger;

});
parcelRegister("hgBBj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $c7j2m = parcelRequire("c7j2m");
function $c921190cb6191442$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $c7j2m._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $c921190cb6191442$var$_getUserStorageKey;
function $c921190cb6191442$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $c921190cb6191442$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $c7j2m._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $c921190cb6191442$var$_getStorageKey;

});
parcelRegister("c7j2m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $jif12 = parcelRequire("jif12");
const $8d24e7d3a4faa2d1$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $8d24e7d3a4faa2d1$var$_DJB2;
const $8d24e7d3a4faa2d1$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $8d24e7d3a4faa2d1$var$_DJB2Object;
const $8d24e7d3a4faa2d1$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $jif12._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $8d24e7d3a4faa2d1$var$_getSortedObject;

});
parcelRegister("jif12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $e0bb5896df65cfcc$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $e0bb5896df65cfcc$var$_typeOf;
function $e0bb5896df65cfcc$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : x === null ? "null" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $e0bb5896df65cfcc$var$_isTypeMatch;

});



parcelRegister("7JCXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("f87Bk", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $b03d7fc4181c0b52$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $b03d7fc4181c0b52$var$_getWindowSafe;
const $b03d7fc4181c0b52$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $b03d7fc4181c0b52$var$_getDocumentSafe;
const $b03d7fc4181c0b52$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $b03d7fc4181c0b52$var$_isServerEnv;
const $b03d7fc4181c0b52$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $b03d7fc4181c0b52$var$_addWindowEventListenerSafe;
const $b03d7fc4181c0b52$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $b03d7fc4181c0b52$var$_addDocumentEventListenerSafe;
const $b03d7fc4181c0b52$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $b03d7fc4181c0b52$var$_getCurrentPageUrlSafe;
const $b03d7fc4181c0b52$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return "beforeunload";
    const eventType = "onpagehide" in win ? "pagehide" : "beforeunload";
    return eventType;
};
module.exports._getUnloadEvent = $b03d7fc4181c0b52$var$_getUnloadEvent;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("3XJjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $2e2a087b59135670$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $2e2a087b59135670$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $2e2a087b59135670$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $2e2a087b59135670$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $2e2a087b59135670$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $2e2a087b59135670$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $2e2a087b59135670$var$GATE_EXPOSURE_NAME || eventName === $2e2a087b59135670$var$CONFIG_EXPOSURE_NAME || eventName === $2e2a087b59135670$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $2e2a087b59135670$var$_isExposureEvent;
const $2e2a087b59135670$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $2e2a087b59135670$var$_createExposure($2e2a087b59135670$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $2e2a087b59135670$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $2e2a087b59135670$var$_createGateExposure;
function $2e2a087b59135670$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $2e2a087b59135670$var$_mapExposures;
const $2e2a087b59135670$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $2e2a087b59135670$var$_createExposure($2e2a087b59135670$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $2e2a087b59135670$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $2e2a087b59135670$var$_createConfigExposure;
const $2e2a087b59135670$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $2e2a087b59135670$var$_createExposure($2e2a087b59135670$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $2e2a087b59135670$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $2e2a087b59135670$var$_createLayerParameterExposure;
const $2e2a087b59135670$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("6A2Ba", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: "d",
    /** Compress request bodies unless a network proxy is configured */ Enabled: "e",
    /** Always compress request bodies, even when a proxy is configured */ Forced: "f"
};
module.exports.LoggingEnabledOption = {
    disabled: "disabled",
    browserOnly: "browser-only",
    always: "always"
};

});

parcelRegister("1Y0sQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $f87Bk = parcelRequire("f87Bk");
const $16ebc13608dd52ec$var$inMemoryStore = {};
const $16ebc13608dd52ec$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$16ebc13608dd52ec$var$inMemoryStore[key] ? $16ebc13608dd52ec$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $16ebc13608dd52ec$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $16ebc13608dd52ec$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($16ebc13608dd52ec$var$inMemoryStore)
};
let $16ebc13608dd52ec$var$_localStorageProvider = null;
try {
    const win = (0, $f87Bk._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $16ebc13608dd52ec$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $aJqAw.Log.warn("Failed to setup localStorageProvider.");
}
let $16ebc13608dd52ec$var$_main = $16ebc13608dd52ec$var$_localStorageProvider !== null && $16ebc13608dd52ec$var$_localStorageProvider !== void 0 ? $16ebc13608dd52ec$var$_localStorageProvider : $16ebc13608dd52ec$var$_inMemoryProvider;
let $16ebc13608dd52ec$var$_current = $16ebc13608dd52ec$var$_main;
function $16ebc13608dd52ec$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($16ebc13608dd52ec$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === "QuotaExceededError") {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith("statsig."));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$16ebc13608dd52ec$var$_current.isReady(),
    isReadyResolver: ()=>$16ebc13608dd52ec$var$_current.isReadyResolver(),
    getProviderName: ()=>$16ebc13608dd52ec$var$_current.getProviderName(),
    getItem: (key)=>$16ebc13608dd52ec$var$_inMemoryBreaker(()=>$16ebc13608dd52ec$var$_current.getItem(key)),
    setItem: (key, value)=>$16ebc13608dd52ec$var$_inMemoryBreaker(()=>$16ebc13608dd52ec$var$_current.setItem(key, value)),
    removeItem: (key)=>$16ebc13608dd52ec$var$_current.removeItem(key),
    getAllKeys: ()=>$16ebc13608dd52ec$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $16ebc13608dd52ec$var$_main = newProvider;
        $16ebc13608dd52ec$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $16ebc13608dd52ec$var$_current = $16ebc13608dd52ec$var$_inMemoryProvider;
        else $16ebc13608dd52ec$var$_current = $16ebc13608dd52ec$var$_main;
    }
};
function $16ebc13608dd52ec$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : "null");
}
module.exports._getObjectFromStorage = $16ebc13608dd52ec$var$_getObjectFromStorage;
function $16ebc13608dd52ec$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $16ebc13608dd52ec$var$_setObjectInStorage;

});

parcelRegister("sNl0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $c7j2m = parcelRequire("c7j2m");

var $7JCXg = parcelRequire("7JCXg");
const $0568e316ac889a5f$var$ENDPOINT_DNS_KEY_MAP = {
    [$7JCXg.Endpoint._initialize]: "i",
    [$7JCXg.Endpoint._rgstr]: "e",
    [$7JCXg.Endpoint._download_config_specs]: "d"
};
class $0568e316ac889a5f$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0568e316ac889a5f$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $7JCXg.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(",");
        return (0, $c7j2m._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $0568e316ac889a5f$var$UrlConfiguration;

});

parcelRegister("gjSL0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $f87Bk = parcelRequire("f87Bk");
const $be18e54c302a5617$var$FOREGROUND = "foreground";
const $be18e54c302a5617$var$BACKGROUND = "background";
const $be18e54c302a5617$var$LISTENERS = [];
let $be18e54c302a5617$var$current = $be18e54c302a5617$var$FOREGROUND;
let $be18e54c302a5617$var$isUnloading = false;
const $be18e54c302a5617$var$_isCurrentlyVisible = ()=>{
    return $be18e54c302a5617$var$current === $be18e54c302a5617$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $be18e54c302a5617$var$_isCurrentlyVisible;
const $be18e54c302a5617$var$_isUnloading = ()=>$be18e54c302a5617$var$isUnloading;
module.exports._isUnloading = $be18e54c302a5617$var$_isUnloading;
const $be18e54c302a5617$var$_subscribeToVisiblityChanged = (listener)=>{
    $be18e54c302a5617$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $be18e54c302a5617$var$_subscribeToVisiblityChanged;
const $be18e54c302a5617$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $be18e54c302a5617$var$current) return;
    $be18e54c302a5617$var$current = visibility;
    $be18e54c302a5617$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $be18e54c302a5617$var$_notifyVisibilityChanged;
(0, $f87Bk._addWindowEventListenerSafe)("focus", ()=>{
    $be18e54c302a5617$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($be18e54c302a5617$var$FOREGROUND);
});
(0, $f87Bk._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($be18e54c302a5617$var$BACKGROUND));
(0, $f87Bk._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $be18e54c302a5617$var$FOREGROUND : $be18e54c302a5617$var$BACKGROUND);
});
(0, $f87Bk._addWindowEventListenerSafe)((0, $f87Bk._getUnloadEvent)(), ()=>{
    $be18e54c302a5617$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($be18e54c302a5617$var$BACKGROUND);
});

});


parcelRegister("72E2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.22.0";
let $0152b4c71326a69f$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$0152b4c71326a69f$var$metadata,
    add: (additions)=>{
        $0152b4c71326a69f$var$metadata = Object.assign(Object.assign({}, $0152b4c71326a69f$var$metadata), additions);
    }
};

});

parcelRegister("ig6km", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fFRwz", function(module, exports) {
"use strict";
var $b694342f590c9e15$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $cyM0i = parcelRequire("cyM0i");

var $i0Ijk = parcelRequire("i0Ijk");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $hpdMt = parcelRequire("hpdMt");
const $b694342f590c9e15$var$CACHE_LIMIT = 10;
class $b694342f590c9e15$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $b694342f590c9e15$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $i0Ijk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $i0Ijk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $b694342f590c9e15$var$_makeDataAdapterResult("Bootstrap", data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $cyM0i.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $b694342f590c9e15$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1Y0sQ.Storage.isReady()) yield $1Y0sQ.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $aJqAw.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $b694342f590c9e15$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $i0Ijk._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $b694342f590c9e15$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $aJqAw.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $hpdMt._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $cyM0i.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $b694342f590c9e15$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $b694342f590c9e15$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $aJqAw.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $1Y0sQ.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($1Y0sQ.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $hpdMt._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $1Y0sQ.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $1Y0sQ._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $b694342f590c9e15$var$_getEvictableKey(lastModifiedTimeMap, $b694342f590c9e15$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $1Y0sQ.Storage.removeItem(evictable);
        }
        (0, $1Y0sQ._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $b694342f590c9e15$var$DataAdapterCore;
function $b694342f590c9e15$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $i0Ijk._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $b694342f590c9e15$var$_makeDataAdapterResult;
class $b694342f590c9e15$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $aJqAw.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $b694342f590c9e15$var$_getEvictableKey(this._data, $b694342f590c9e15$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $b694342f590c9e15$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === "object" && typeof current === "object") return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("cyM0i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $hgBBj = parcelRequire("hgBBj");

var $aJqAw = parcelRequire("aJqAw");

var $f87Bk = parcelRequire("f87Bk");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $elNQX = parcelRequire("elNQX");
const $025c18590c6ad1c0$var$PROMISE_MAP = {};
const $025c18590c6ad1c0$var$COOKIE_ENABLED_MAP = {};
const $025c18590c6ad1c0$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($025c18590c6ad1c0$var$DISABLED_MAP[sdkKey]) return null;
        if ($025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] != null) return $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $025c18590c6ad1c0$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] = stableID;
            $025c18590c6ad1c0$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $025c18590c6ad1c0$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $elNQX.getUUID)();
        $025c18590c6ad1c0$var$_persistToStorage(stableID, sdkKey);
        $025c18590c6ad1c0$var$_persistToCookie(stableID, sdkKey);
        $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] = override;
        $025c18590c6ad1c0$var$_persistToStorage(override, sdkKey);
        $025c18590c6ad1c0$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $025c18590c6ad1c0$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $025c18590c6ad1c0$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $025c18590c6ad1c0$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $hgBBj._getStorageKey)(sdkKey)}`;
}
function $025c18590c6ad1c0$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $025c18590c6ad1c0$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $1Y0sQ._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $aJqAw.Log.warn("Failed to save StableID to storage");
    }
}
function $025c18590c6ad1c0$var$_loadFromStorage(sdkKey) {
    const storageKey = $025c18590c6ad1c0$var$_getStableIDStorageKey(sdkKey);
    return (0, $1Y0sQ._getObjectFromStorage)(storageKey);
}
function $025c18590c6ad1c0$var$_loadFromCookie(sdkKey) {
    if (!$025c18590c6ad1c0$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $f87Bk._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split("=");
        if (key === $025c18590c6ad1c0$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $025c18590c6ad1c0$var$_persistToCookie(stableID, sdkKey) {
    if (!$025c18590c6ad1c0$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$025c18590c6ad1c0$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $025c18590c6ad1c0$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $hgBBj._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("elNQX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $a729b2a1ca571392$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $a729b2a1ca571392$var$getUUID;

});


parcelRegister("i0Ijk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $c7j2m = parcelRequire("c7j2m");

var $aJqAw = parcelRequire("aJqAw");
function $d1ca9940db31dd85$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $aJqAw.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $d1ca9940db31dd85$var$_normalizeUser;
function $d1ca9940db31dd85$var$_getFullUserHash(user) {
    return user ? (0, $c7j2m._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $d1ca9940db31dd85$var$_getFullUserHash;

});

parcelRegister("hpdMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $aJqAw = parcelRequire("aJqAw");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $cabf7614283886ac$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $aJqAw.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $cabf7614283886ac$var$_typedJsonParse;

});


parcelRegister("1uA6T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("90xfN", function(module, exports) {
"use strict";
var $68ede8a43d4e9f9a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $eSDjJ = parcelRequire("eSDjJ");

var $72E2N = parcelRequire("72E2N");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $68ede8a43d4e9f9a$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $68ede8a43d4e9f9a$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $68ede8a43d4e9f9a$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $68ede8a43d4e9f9a$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $aJqAw.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$68ede8a43d4e9f9a$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($68ede8a43d4e9f9a$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $68ede8a43d4e9f9a$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $eSDjJ.SDKType._get(this._sdkKey);
                    const statsigMetadata = $72E2N.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $68ede8a43d4e9f9a$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $68ede8a43d4e9f9a$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $68ede8a43d4e9f9a$var$ErrorBoundary;
function $68ede8a43d4e9f9a$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $68ede8a43d4e9f9a$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $68ede8a43d4e9f9a$var$UNKNOWN_ERROR;
    }
}
function $68ede8a43d4e9f9a$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $68ede8a43d4e9f9a$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case "number":
            case "bigint":
            case "boolean":
                loggingCopy[String(option)] = value;
                break;
            case "string":
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = "set";
                break;
            case "object":
                if (option === "environment") loggingCopy["environment"] = value;
                else if (option === "networkConfig") loggingCopy["networkConfig"] = value;
                else loggingCopy[String(option)] = value != null ? "set" : "unset";
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("eSDjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $ad549b702f98e4fb$var$SDK_CLIENT = {};
let $ad549b702f98e4fb$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $ad549b702f98e4fb$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($ad549b702f98e4fb$var$suffix !== null && $ad549b702f98e4fb$var$suffix !== void 0 ? $ad549b702f98e4fb$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $ad549b702f98e4fb$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$ad549b702f98e4fb$var$suffix || $ad549b702f98e4fb$var$suffix === "-react") $ad549b702f98e4fb$var$suffix = "-" + binding;
    }
};

});


parcelRegister("3izdo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iS0Os", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gXsA7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bMivU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _configList: "cl",
    _layer: "l",
    _paramStore: "p"
};
const $893289d933952143$var$EXIST_KEYS = new Set([]);
const $893289d933952143$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $893289d933952143$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($893289d933952143$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($893289d933952143$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $893289d933952143$var$createMemoKey;

});

parcelRegister("2juun", function(module, exports) {
"use strict";
var $1af5019a825c5b76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $1TJvm = parcelRequire("1TJvm");

var $1TJvm = parcelRequire("1TJvm");

var $9vgpJ = parcelRequire("9vgpJ");

var $aJqAw = parcelRequire("aJqAw");

var $7JCXg = parcelRequire("7JCXg");

var $ekhnC = parcelRequire("ekhnC");

var $cJJ9J = parcelRequire("cJJ9J");

var $eSDjJ = parcelRequire("eSDjJ");

var $f87Bk = parcelRequire("f87Bk");

var $df3hs = parcelRequire("df3hs");

var $cyM0i = parcelRequire("cyM0i");

var $20vLv = parcelRequire("20vLv");

var $72E2N = parcelRequire("72E2N");

var $6A2Ba = parcelRequire("6A2Ba");

var $gjSL0 = parcelRequire("gjSL0");
const $1af5019a825c5b76$var$DEFAULT_TIMEOUT_MS = 10000;
const $1af5019a825c5b76$var$BACKOFF_BASE_MS = 500;
const $1af5019a825c5b76$var$BACKOFF_MAX_MS = 30000;
const $1af5019a825c5b76$var$RATE_LIMIT_WINDOW_MS = 1000;
const $1af5019a825c5b76$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $1af5019a825c5b76$var$LEAK_RATE = $1af5019a825c5b76$var$RATE_LIMIT_MAX_REQ_COUNT / $1af5019a825c5b76$var$RATE_LIMIT_WINDOW_MS;
const $1af5019a825c5b76$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $1af5019a825c5b76$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $1af5019a825c5b76$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $ekhnC.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$1af5019a825c5b76$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs("POST", args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$1af5019a825c5b76$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $aJqAw.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $gjSL0._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $1af5019a825c5b76$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $1af5019a825c5b76$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $1af5019a825c5b76$var$_getErrorMessage(abortController, error);
                const timedOut = $1af5019a825c5b76$var$_didTimeout(abortController);
                $1af5019a825c5b76$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$1af5019a825c5b76$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $20vLv.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $aJqAw.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $1af5019a825c5b76$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $6A2Ba.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $6A2Ba.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $1af5019a825c5b76$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $1af5019a825c5b76$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $7JCXg.Endpoint._initialize || args.urlConfig.endpoint === $7JCXg.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$7JCXg.NetworkParam.SdkKey]: args.sdkKey,
            [$7JCXg.NetworkParam.SdkType]: $eSDjJ.SDKType._get(args.sdkKey),
            [$7JCXg.NetworkParam.SdkVersion]: $72E2N.SDK_VERSION,
            [$7JCXg.NetworkParam.Time]: String(Date.now()),
            [$7JCXg.NetworkParam.SessionID]: $df3hs.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join("&");
        return `${url}${query ? `?${query}` : ""}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $f87Bk._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $1TJvm._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$7JCXg.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $aJqAw.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== "string" || !$1af5019a825c5b76$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($aJqAw.Log.error);
                writer.close().catch($aJqAw.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$7JCXg.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $aJqAw.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $1af5019a825c5b76$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $1af5019a825c5b76$var$NetworkCore;
const $1af5019a825c5b76$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $aJqAw.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $1af5019a825c5b76$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $cyM0i.StableID.get(sdkKey);
    const sessionID = $df3hs.SessionID.get(sdkKey);
    const sdkType = $eSDjJ.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $72E2N.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $1af5019a825c5b76$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $1TJvm._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cJJ9J.SDKFlags.get(args.sdkKey, "enable_log_event_compression") === true;
    switch(options.logEventCompressionMode){
        case $6A2Ba.LogEventCompressionMode.Disabled:
            return false;
        case $6A2Ba.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $6A2Ba.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $1af5019a825c5b76$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string") return controller.signal.reason;
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $1af5019a825c5b76$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string" && controller.signal.reason.includes("Timeout");
    return timeout || false;
}
function $1af5019a825c5b76$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $7JCXg.Endpoint._initialize) return;
    $9vgpJ.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $1af5019a825c5b76$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $7JCXg.Endpoint._initialize) return;
    $9vgpJ.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $9vgpJ.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $1af5019a825c5b76$var$_exponentialBackoff(attempt) {
    return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($1af5019a825c5b76$var$BACKOFF_BASE_MS * (attempt * attempt), $1af5019a825c5b76$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("ekhnC", function(module, exports) {
"use strict";
var $a6e06a37714d50a7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $lGf2U = parcelRequire("lGf2U");

var $c7j2m = parcelRequire("c7j2m");

var $aJqAw = parcelRequire("aJqAw");

var $1Y0sQ = parcelRequire("1Y0sQ");
const $a6e06a37714d50a7$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $a6e06a37714d50a7$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $a6e06a37714d50a7$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $a6e06a37714d50a7$var$DEFAULT_TTL_MS;
        $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $a6e06a37714d50a7$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $a6e06a37714d50a7$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$a6e06a37714d50a7$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $a6e06a37714d50a7$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $a6e06a37714d50a7$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $a6e06a37714d50a7$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $lGf2U._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $a6e06a37714d50a7$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $a6e06a37714d50a7$var$NetworkFallbackResolver;
function $a6e06a37714d50a7$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $a6e06a37714d50a7$var$_isDomainFailure;
function $a6e06a37714d50a7$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $c7j2m._DJB2)(sdkKey)}`;
}
function $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $a6e06a37714d50a7$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $1Y0sQ.Storage.removeItem(hashKey);
        return;
    }
    $1Y0sQ.Storage.setItem(hashKey, JSON.stringify(info));
}
function $a6e06a37714d50a7$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $a6e06a37714d50a7$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $1Y0sQ.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $aJqAw.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $a6e06a37714d50a7$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("lGf2U", function(module, exports) {
"use strict";
var $fc8931065cea88e7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $fc8931065cea88e7$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $fc8931065cea88e7$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $fc8931065cea88e7$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $fc8931065cea88e7$var$MAX_START_LOOKUP = 200;
function $fc8931065cea88e7$var$_fetchTxtRecords(networkFunc) {
    return $fc8931065cea88e7$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($fc8931065cea88e7$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $fc8931065cea88e7$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $fc8931065cea88e7$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $fc8931065cea88e7$var$_fetchTxtRecords;
function $fc8931065cea88e7$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $fc8931065cea88e7$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $fc8931065cea88e7$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("cJJ9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $945cb70a7fdffe7f$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $945cb70a7fdffe7f$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $945cb70a7fdffe7f$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("df3hs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $1TJvm = parcelRequire("1TJvm");

var $hgBBj = parcelRequire("hgBBj");

var $aJqAw = parcelRequire("aJqAw");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $elNQX = parcelRequire("elNQX");
const $9a3f388b2b7cd749$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $9a3f388b2b7cd749$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $9a3f388b2b7cd749$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey] == null) $9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey] = $9a3f388b2b7cd749$var$_loadSession(sdkKey);
        const session = $9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey];
        return $9a3f388b2b7cd749$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey] = $9a3f388b2b7cd749$var$_overrideSessionId(override, sdkKey);
    }
};
function $9a3f388b2b7cd749$var$_loadSession(sdkKey) {
    let data = $9a3f388b2b7cd749$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $elNQX.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $9a3f388b2b7cd749$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $9a3f388b2b7cd749$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($9a3f388b2b7cd749$var$_isIdle(data) || $9a3f388b2b7cd749$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $elNQX.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }
    data.lastUpdate = now;
    $9a3f388b2b7cd749$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $9a3f388b2b7cd749$var$_createSessionTimeout(sdkKey, $9a3f388b2b7cd749$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $9a3f388b2b7cd749$var$_createSessionTimeout(sdkKey, $9a3f388b2b7cd749$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $9a3f388b2b7cd749$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $1TJvm._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $9a3f388b2b7cd749$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $9a3f388b2b7cd749$var$MAX_SESSION_IDLE_TIME;
}
function $9a3f388b2b7cd749$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $9a3f388b2b7cd749$var$MAX_SESSION_AGE;
}
function $9a3f388b2b7cd749$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $hgBBj._getStorageKey)(sdkKey)}`;
}
function $9a3f388b2b7cd749$var$_persistToStorage(session, sdkKey) {
    const storageKey = $9a3f388b2b7cd749$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $1Y0sQ._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $aJqAw.Log.warn("Failed to save SessionID");
    }
}
function $9a3f388b2b7cd749$var$_loadFromStorage(sdkKey) {
    const storageKey = $9a3f388b2b7cd749$var$_getSessionIDStorageKey(sdkKey);
    return (0, $1Y0sQ._getObjectFromStorage)(storageKey);
}

});

parcelRegister("20vLv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("eHhOb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ibDZT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8VJP4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $68073103b59827f9$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $68073103b59827f9$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $68073103b59827f9$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === "object" && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $68073103b59827f9$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $68073103b59827f9$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $68073103b59827f9$var$_fastApproxSizeOf;

});

parcelRegister("kAAfI", function(module, exports) {
"use strict";
var $efd34a7219933b37$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $1TJvm = parcelRequire("1TJvm");

var $1TJvm = parcelRequire("1TJvm");

var $90xfN = parcelRequire("90xfN");

var $1x5ek = parcelRequire("1x5ek");

var $aJqAw = parcelRequire("aJqAw");

var $bMivU = parcelRequire("bMivU");

var $f87Bk = parcelRequire("f87Bk");

var $df3hs = parcelRequire("df3hs");

var $cyM0i = parcelRequire("cyM0i");

var $6A2Ba = parcelRequire("6A2Ba");

var $1Y0sQ = parcelRequire("1Y0sQ");
const $efd34a7219933b37$var$MAX_MEMO_CACHE_SIZE = 3000;
class $efd34a7219933b37$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($aJqAw.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $1Y0sQ.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $df3hs.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $1Y0sQ.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $cyM0i.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $cyM0i.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $1x5ek.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $90xfN.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $1Y0sQ.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError("OA::loadFromStorage", e));
        this._primeReadyRipcord();
        $efd34a7219933b37$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? "disabled" : "browser-only");
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $1Y0sQ.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $cyM0i.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($6A2Ba.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $efd34a7219933b37$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $aJqAw.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $bMivU.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $efd34a7219933b37$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $efd34a7219933b37$var$StatsigClientBase;
function $efd34a7219933b37$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $f87Bk._isServerEnv)()) return;
    const statsigGlobal = (0, $1TJvm._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $aJqAw.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("9HWUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("cYkgq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fVgBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $jif12 = parcelRequire("jif12");
function $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : "",
        __evaluation: evaluation,
        value: value
    };
}
function $b9790fc30884dec5$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $b9790fc30884dec5$var$_makeFeatureGate;
function $b9790fc30884dec5$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $b9790fc30884dec5$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $b9790fc30884dec5$var$_makeDynamicConfig;
function $b9790fc30884dec5$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $b9790fc30884dec5$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $b9790fc30884dec5$var$_makeExperiment;
function $b9790fc30884dec5$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $b9790fc30884dec5$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $b9790fc30884dec5$var$_makeLayer;
function $b9790fc30884dec5$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $b9790fc30884dec5$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $b9790fc30884dec5$var$_mergeOverride;
function $b9790fc30884dec5$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $jif12._isTypeMatch)(found, fallback)) {
            $aJqAw.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $b9790fc30884dec5$var$_makeTypedGet;

});

parcelRegister("1Q38X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9D94r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $702ecacc1b02df37$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $702ecacc1b02df37$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("j8Gpr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03f86cbf4091cea96938f1feb145f315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $deefa94c76745ddf$var$_react = $deefa94c76745ddf$var$_interopRequireDefault((parcelRequire("acw62")));

var $deefa94c76745ddf$var$_UNSAFE_baseNew = $deefa94c76745ddf$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $deefa94c76745ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $deefa94c76745ddf$var$CloseIcon = (props)=>/*#__PURE__*/ $deefa94c76745ddf$var$_react.default.createElement($deefa94c76745ddf$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$deefa94c76745ddf$var$CloseIcon.displayName = "CloseIcon";
var $deefa94c76745ddf$var$_default = module.exports.default = $deefa94c76745ddf$var$CloseIcon;

});
parcelRegister("lwLxe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1Opy5")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("1Opy5")).Icon);

var $1Opy5 = parcelRequire("1Opy5");

});
parcelRegister("1Opy5", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $151e476b7c1fb167$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $151e476b7c1fb167$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $fai5X = parcelRequire("fai5X");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $151e476b7c1fb167$var$commonSVGStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $151e476b7c1fb167$var$svgStyles = (0, $gyDKM.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $151e476b7c1fb167$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $151e476b7c1fb167$var$utilityIconStyles = (0, $gyDKM.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $151e476b7c1fb167$var$scaleStyles = (0, $gyDKM.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $151e476b7c1fb167$var$baseHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $151e476b7c1fb167$var$scaleSize = (0, $gyDKM.css)({
    width: "inherit",
    height: "inherit"
});
var $151e476b7c1fb167$var$sizeMap = {
    core: {
        none: (0, $gyDKM.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $gyDKM.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $gyDKM.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $gyDKM.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $gyDKM.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $151e476b7c1fb167$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $151e476b7c1fb167$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $151e476b7c1fb167$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $fai5X.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $gyDKM.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $151e476b7c1fb167$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $151e476b7c1fb167$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $151e476b7c1fb167$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $gyDKM.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $151e476b7c1fb167$var$iconStyles,
            $151e476b7c1fb167$var$baseHcmStyles,
            shouldScale && $151e476b7c1fb167$var$scaleStyles,
            props.type === "utility" && $151e476b7c1fb167$var$utilityIconStyles
        ]
    }, (0, $gyDKM.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $151e476b7c1fb167$var$commonSVGStyles,
            $151e476b7c1fb167$var$svgStyles,
            shouldScale ? $151e476b7c1fb167$var$scaleSize : props.type === "utility" ? $151e476b7c1fb167$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $151e476b7c1fb167$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $151e476b7c1fb167$export$2e2bcd8739ae039 = $151e476b7c1fb167$export$f04a61298a47a40f;

});
parcelRegister("gyDKM", function(module, exports) {

$parcel$export(module.exports, "css", () => $c0dea88c07cfb741$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $c0dea88c07cfb741$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $c0dea88c07cfb741$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $c0dea88c07cfb741$export$c8a8987d4410bf2d);

var $aFuPx = parcelRequire("aFuPx");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $kKPGI = parcelRequire("kKPGI");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $c0dea88c07cfb741$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $aFuPx.h).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $aFuPx.E);
    createElementArgArray[1] = (0, $aFuPx.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($c0dea88c07cfb741$export$c8a8987d4410bf2d || ($c0dea88c07cfb741$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $c0dea88c07cfb741$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $aFuPx.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $aFuPx.T)));
    if (!(0, $aFuPx.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $kKPGI.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $kKPGI.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $c0dea88c07cfb741$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $c0dea88c07cfb741$export$d25ddfdf17c3ad3e() {
    var insertable = $c0dea88c07cfb741$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $c0dea88c07cfb741$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $c0dea88c07cfb741$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $c0dea88c07cfb741$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $kKPGI.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $aFuPx.i) && res !== undefined) rules += res;
        }
        if (!(0, $aFuPx.i)) return rules;
    });
    if (!(0, $aFuPx.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $c0dea88c07cfb741$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $aFuPx.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $aFuPx.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $aFuPx.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $c0dea88c07cfb741$var$merge(cache.registered, css, $c0dea88c07cfb741$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $aFuPx.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($c0dea88c07cfb741$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("aFuPx", function(module, exports) {

$parcel$export(module.exports, "a", () => $7c45a5f17ac30c7f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $7c45a5f17ac30c7f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $7c45a5f17ac30c7f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $7c45a5f17ac30c7f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $7c45a5f17ac30c7f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $7c45a5f17ac30c7f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $7c45a5f17ac30c7f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $hgWyK = parcelRequire("hgWyK");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $kKPGI = parcelRequire("kKPGI");
var $7c45a5f17ac30c7f$export$407448d2b89b1813 = false;
var $7c45a5f17ac30c7f$export$23f2a1d2818174ef = typeof document !== "undefined";
var $7c45a5f17ac30c7f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: "css"
}) : null);
var $7c45a5f17ac30c7f$export$e7094788287c5e9b = $7c45a5f17ac30c7f$var$EmotionCacheContext.Provider;
var $7c45a5f17ac30c7f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($7c45a5f17ac30c7f$var$EmotionCacheContext);
};
var $7c45a5f17ac30c7f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($7c45a5f17ac30c7f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$7c45a5f17ac30c7f$export$23f2a1d2818174ef) $7c45a5f17ac30c7f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($7c45a5f17ac30c7f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($7c45a5f17ac30c7f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $7c45a5f17ac30c7f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $7c45a5f17ac30c7f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($7c45a5f17ac30c7f$export$971d5caa766a69d7);
};
var $7c45a5f17ac30c7f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $7c45a5f17ac30c7f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $7c45a5f17ac30c7f$var$getTheme(outerTheme, theme);
    });
});
var $7c45a5f17ac30c7f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($7c45a5f17ac30c7f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $7c45a5f17ac30c7f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($7c45a5f17ac30c7f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $7c45a5f17ac30c7f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($7c45a5f17ac30c7f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $hgWyK.default)(WithTheme, Component);
}
var $7c45a5f17ac30c7f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $7c45a5f17ac30c7f$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $7c45a5f17ac30c7f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($7c45a5f17ac30c7f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$7c45a5f17ac30c7f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $7c45a5f17ac30c7f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $kKPGI.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$7c45a5f17ac30c7f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7c45a5f17ac30c7f$var$Emotion = /* #__PURE__ */ $7c45a5f17ac30c7f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$7c45a5f17ac30c7f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($7c45a5f17ac30c7f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($7c45a5f17ac30c7f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $7c45a5f17ac30c7f$var$typePropName && !$7c45a5f17ac30c7f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7c45a5f17ac30c7f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $7c45a5f17ac30c7f$export$a9c23c6ac3fc3eca = $7c45a5f17ac30c7f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== "undefined";
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hgWyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9315b0040da91bc$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c9315b0040da91bc$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dNL7g"));

});



parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== "undefined";
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, "-$&").toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("kKPGI", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $f1c032a933162ade$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $f1c032a933162ade$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $f1c032a933162ade$var$isBrowser = typeof document !== "undefined";
var $f1c032a933162ade$var$syncFallback = function syncFallback(create) {
    return create();
};
var $f1c032a933162ade$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $f1c032a933162ade$export$db21c7ffa21794e7 = !$f1c032a933162ade$var$isBrowser ? $f1c032a933162ade$var$syncFallback : $f1c032a933162ade$var$useInsertionEffect || $f1c032a933162ade$var$syncFallback;
var $f1c032a933162ade$export$811a713a7276cb9d = $f1c032a933162ade$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("fai5X", function(module, exports) {

$parcel$export(module.exports, "fg", () => $b0a5d381a4f3050a$export$b40ec24ac8275656);

var $bPw7t = parcelRequire("bPw7t");
function $b0a5d381a4f3050a$export$ba05d765b8392e5e(flagResolver) {
    (0, $bPw7t.setBooleanResolver)(flagResolver);
}
function $b0a5d381a4f3050a$export$470e5c2be1411c89(name) {
    return (0, $bPw7t.resolveBooleanFlag)(name);
}
function $b0a5d381a4f3050a$export$b40ec24ac8275656(name) {
    return (0, $bPw7t.resolveBooleanFlag)(name);
}

});
parcelRegister("bPw7t", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $89cd5f61ff5893e0$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $89cd5f61ff5893e0$export$6333b6aff9fc6275);

var $281S2 = parcelRequire("281S2");

var $hPtJY = parcelRequire("hPtJY");
var $89cd5f61ff5893e0$var$pkgName = "@atlaskit/platform-feature-flags";
var $89cd5f61ff5893e0$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $89cd5f61ff5893e0$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $89cd5f61ff5893e0$var$ENV_ENABLE_PLATFORM_FF = $89cd5f61ff5893e0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $89cd5f61ff5893e0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $89cd5f61ff5893e0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $89cd5f61ff5893e0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $89cd5f61ff5893e0$var$ENV_ENABLE_PLATFORM_FF || $89cd5f61ff5893e0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $89cd5f61ff5893e0$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $89cd5f61ff5893e0$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$89cd5f61ff5893e0$var$globalVar[$89cd5f61ff5893e0$export$7e41b1b2bdee3f98] = $89cd5f61ff5893e0$var$globalVar[$89cd5f61ff5893e0$export$7e41b1b2bdee3f98] || $89cd5f61ff5893e0$var$DEFAULT_PFF_GLOBAL;
function $89cd5f61ff5893e0$export$f2b591175b3e424c(resolver) {
    $89cd5f61ff5893e0$var$globalVar[$89cd5f61ff5893e0$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $89cd5f61ff5893e0$export$6333b6aff9fc6275(flagKey) {
    if ($89cd5f61ff5893e0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $281S2.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $89cd5f61ff5893e0$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $89cd5f61ff5893e0$var$globalVar[$89cd5f61ff5893e0$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("281S2", function(module, exports) {

$parcel$export(module.exports, "debug", () => $18cdc79ad0699130$export$1c9f709888824e05);
var $18cdc79ad0699130$var$_ref, $18cdc79ad0699130$var$_process, $18cdc79ad0699130$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $18cdc79ad0699130$var$TESTS_MODE = ($18cdc79ad0699130$var$_ref = (globalThis === null || globalThis === void 0 || ($18cdc79ad0699130$var$_process = globalThis.process) === null || $18cdc79ad0699130$var$_process === void 0 || ($18cdc79ad0699130$var$_process = $18cdc79ad0699130$var$_process.env) === null || $18cdc79ad0699130$var$_process === void 0 ? void 0 : $18cdc79ad0699130$var$_process.JEST_WORKER_ID) !== undefined, $18cdc79ad0699130$var$_ref !== void 0) ? $18cdc79ad0699130$var$_ref : false;
var $18cdc79ad0699130$var$DEBUG_MODE = !$18cdc79ad0699130$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($18cdc79ad0699130$var$_process2 = globalThis.process) === null || $18cdc79ad0699130$var$_process2 === void 0 || ($18cdc79ad0699130$var$_process2 = $18cdc79ad0699130$var$_process2.env) === null || $18cdc79ad0699130$var$_process2 === void 0 ? void 0 : $18cdc79ad0699130$var$_process2.NODE_ENV) !== "production";
var $18cdc79ad0699130$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$18cdc79ad0699130$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("krRSk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfe67a5a24a2dcfb0853d331aeb2068>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee301ec76f90d4a7$var$_react = $ee301ec76f90d4a7$var$_interopRequireDefault((parcelRequire("acw62")));

var $ee301ec76f90d4a7$var$_UNSAFE_baseNew = $ee301ec76f90d4a7$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $ee301ec76f90d4a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee301ec76f90d4a7$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $ee301ec76f90d4a7$var$_react.default.createElement($ee301ec76f90d4a7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
    }, props));
$ee301ec76f90d4a7$var$ArrowUpRightIcon.displayName = "ArrowUpRightIcon";
var $ee301ec76f90d4a7$var$_default = module.exports.default = $ee301ec76f90d4a7$var$ArrowUpRightIcon;

});

parcelRegister("bZH1Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8cb0749e395cf6d25ab2f6745905850>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bb6c54902b67648$var$_react = $8bb6c54902b67648$var$_interopRequireDefault((parcelRequire("acw62")));

var $8bb6c54902b67648$var$_UNSAFE_baseNew = $8bb6c54902b67648$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $8bb6c54902b67648$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bb6c54902b67648$var$DownloadIcon = (props)=>/*#__PURE__*/ $8bb6c54902b67648$var$_react.default.createElement($8bb6c54902b67648$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$8bb6c54902b67648$var$DownloadIcon.displayName = "DownloadIcon";
var $8bb6c54902b67648$var$_default = module.exports.default = $8bb6c54902b67648$var$DownloadIcon;

});

parcelRegister("9dzbE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d611fb3947c00fee344914368e144168>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b609f52acb58df4$var$_react = $6b609f52acb58df4$var$_interopRequireDefault((parcelRequire("acw62")));

var $6b609f52acb58df4$var$_UNSAFE_baseNew = $6b609f52acb58df4$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $6b609f52acb58df4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b609f52acb58df4$var$LocationIcon = (props)=>/*#__PURE__*/ $6b609f52acb58df4$var$_react.default.createElement($6b609f52acb58df4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$6b609f52acb58df4$var$LocationIcon.displayName = "LocationIcon";
var $6b609f52acb58df4$var$_default = module.exports.default = $6b609f52acb58df4$var$LocationIcon;

});

parcelRegister("4eiSD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28198ce9e0c3202094e2855b88c09086>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31471d753a82660f$var$_react = $31471d753a82660f$var$_interopRequireDefault((parcelRequire("acw62")));

var $31471d753a82660f$var$_UNSAFE_baseNew = $31471d753a82660f$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $31471d753a82660f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31471d753a82660f$var$AddIcon = (props)=>/*#__PURE__*/ $31471d753a82660f$var$_react.default.createElement($31471d753a82660f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$31471d753a82660f$var$AddIcon.displayName = "AddIcon";
var $31471d753a82660f$var$_default = module.exports.default = $31471d753a82660f$var$AddIcon;

});

parcelRegister("krsZn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee1cd0d8c0687df4$var$_react = $ee1cd0d8c0687df4$var$_interopRequireDefault((parcelRequire("acw62")));

var $ee1cd0d8c0687df4$var$_UNSAFE_baseNew = $ee1cd0d8c0687df4$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $ee1cd0d8c0687df4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee1cd0d8c0687df4$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $ee1cd0d8c0687df4$var$_react.default.createElement($ee1cd0d8c0687df4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$ee1cd0d8c0687df4$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $ee1cd0d8c0687df4$var$_default = module.exports.default = $ee1cd0d8c0687df4$var$ArrowLeftIcon;

});

parcelRegister("4ireU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $320df90adac26d94$var$_react = $320df90adac26d94$var$_interopRequireDefault((parcelRequire("acw62")));

var $320df90adac26d94$var$_UNSAFE_baseNew = $320df90adac26d94$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $320df90adac26d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $320df90adac26d94$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $320df90adac26d94$var$_react.default.createElement($320df90adac26d94$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$320df90adac26d94$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $320df90adac26d94$var$_default = module.exports.default = $320df90adac26d94$var$ArrowRightIcon;

});

parcelRegister("fxIqr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b50c660f787d38af$var$_react = $b50c660f787d38af$var$_interopRequireDefault((parcelRequire("acw62")));

var $b50c660f787d38af$var$_UNSAFE_baseNew = $b50c660f787d38af$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $b50c660f787d38af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b50c660f787d38af$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $b50c660f787d38af$var$_react.default.createElement($b50c660f787d38af$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$b50c660f787d38af$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $b50c660f787d38af$var$_default = module.exports.default = $b50c660f787d38af$var$ArrowUpIcon;

});

parcelRegister("6rQeH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b1dc8ab07e745ea$var$_react = $4b1dc8ab07e745ea$var$_interopRequireDefault((parcelRequire("acw62")));

var $4b1dc8ab07e745ea$var$_UNSAFE_baseNew = $4b1dc8ab07e745ea$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $4b1dc8ab07e745ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b1dc8ab07e745ea$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $4b1dc8ab07e745ea$var$_react.default.createElement($4b1dc8ab07e745ea$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$4b1dc8ab07e745ea$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $4b1dc8ab07e745ea$var$_default = module.exports.default = $4b1dc8ab07e745ea$var$CheckMarkIcon;

});

parcelRegister("b49fW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02143ef5aec1fe40$var$_react = $02143ef5aec1fe40$var$_interopRequireDefault((parcelRequire("acw62")));

var $02143ef5aec1fe40$var$_UNSAFE_baseNew = $02143ef5aec1fe40$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $02143ef5aec1fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02143ef5aec1fe40$var$SuccessIcon = (props)=>/*#__PURE__*/ $02143ef5aec1fe40$var$_react.default.createElement($02143ef5aec1fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$02143ef5aec1fe40$var$SuccessIcon.displayName = "SuccessIcon";
var $02143ef5aec1fe40$var$_default = module.exports.default = $02143ef5aec1fe40$var$SuccessIcon;

});

parcelRegister("jZpwj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8d7829cd29f4eb2$var$_react = $e8d7829cd29f4eb2$var$_interopRequireDefault((parcelRequire("acw62")));

var $e8d7829cd29f4eb2$var$_UNSAFE_baseNew = $e8d7829cd29f4eb2$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $e8d7829cd29f4eb2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8d7829cd29f4eb2$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $e8d7829cd29f4eb2$var$_react.default.createElement($e8d7829cd29f4eb2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$e8d7829cd29f4eb2$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $e8d7829cd29f4eb2$var$_default = module.exports.default = $e8d7829cd29f4eb2$var$CheckCircleIcon;

});

parcelRegister("heRj3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8cd18023c131ea3$var$_react = $c8cd18023c131ea3$var$_interopRequireDefault((parcelRequire("acw62")));

var $c8cd18023c131ea3$var$_UNSAFE_baseNew = $c8cd18023c131ea3$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $c8cd18023c131ea3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8cd18023c131ea3$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c8cd18023c131ea3$var$_react.default.createElement($c8cd18023c131ea3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$c8cd18023c131ea3$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $c8cd18023c131ea3$var$_default = module.exports.default = $c8cd18023c131ea3$var$ChevronDownIcon;

});

parcelRegister("dm3im", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8fe2ce803180ed$var$_react = $9b8fe2ce803180ed$var$_interopRequireDefault((parcelRequire("acw62")));

var $9b8fe2ce803180ed$var$_UNSAFE_baseNew = $9b8fe2ce803180ed$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $9b8fe2ce803180ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8fe2ce803180ed$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $9b8fe2ce803180ed$var$_react.default.createElement($9b8fe2ce803180ed$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: "utility"
    }, props));
$9b8fe2ce803180ed$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $9b8fe2ce803180ed$var$_default = module.exports.default = $9b8fe2ce803180ed$var$ChevronLeftIcon;

});

parcelRegister("ioczj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d63437c067e99464$var$_react = $d63437c067e99464$var$_interopRequireDefault((parcelRequire("acw62")));

var $d63437c067e99464$var$_UNSAFE_baseNew = $d63437c067e99464$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $d63437c067e99464$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d63437c067e99464$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $d63437c067e99464$var$_react.default.createElement($d63437c067e99464$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: "utility"
    }, props));
$d63437c067e99464$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $d63437c067e99464$var$_default = module.exports.default = $d63437c067e99464$var$ChevronRightIcon;

});

parcelRegister("hw8Qv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f998c57d427ae10203b04c2186c5e29c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc0c4972b54e8612$var$_react = $cc0c4972b54e8612$var$_interopRequireDefault((parcelRequire("acw62")));

var $cc0c4972b54e8612$var$_UNSAFE_baseNew = $cc0c4972b54e8612$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $cc0c4972b54e8612$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc0c4972b54e8612$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $cc0c4972b54e8612$var$_react.default.createElement($cc0c4972b54e8612$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: "utility"
    }, props));
$cc0c4972b54e8612$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $cc0c4972b54e8612$var$_default = module.exports.default = $cc0c4972b54e8612$var$ChevronUpIcon;

});

parcelRegister("cHXsv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94079f781d270d0d$var$_react = $94079f781d270d0d$var$_interopRequireDefault((parcelRequire("acw62")));

var $94079f781d270d0d$var$_UNSAFE_baseNew = $94079f781d270d0d$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $94079f781d270d0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94079f781d270d0d$var$CopyIcon = (props)=>/*#__PURE__*/ $94079f781d270d0d$var$_react.default.createElement($94079f781d270d0d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$94079f781d270d0d$var$CopyIcon.displayName = "CopyIcon";
var $94079f781d270d0d$var$_default = module.exports.default = $94079f781d270d0d$var$CopyIcon;

});

parcelRegister("9Ot7V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $724f608c0a215ec6$var$_react = $724f608c0a215ec6$var$_interopRequireDefault((parcelRequire("acw62")));

var $724f608c0a215ec6$var$_UNSAFE_baseNew = $724f608c0a215ec6$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $724f608c0a215ec6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $724f608c0a215ec6$var$EditIcon = (props)=>/*#__PURE__*/ $724f608c0a215ec6$var$_react.default.createElement($724f608c0a215ec6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$724f608c0a215ec6$var$EditIcon.displayName = "EditIcon";
var $724f608c0a215ec6$var$_default = module.exports.default = $724f608c0a215ec6$var$EditIcon;

});

parcelRegister("hvFVY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc84bee668fd63ce995277b659b1b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbf5dc2951f34d2f$var$_react = $cbf5dc2951f34d2f$var$_interopRequireDefault((parcelRequire("acw62")));

var $cbf5dc2951f34d2f$var$_UNSAFE_baseNew = $cbf5dc2951f34d2f$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $cbf5dc2951f34d2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbf5dc2951f34d2f$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $cbf5dc2951f34d2f$var$_react.default.createElement($cbf5dc2951f34d2f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M1 5.917h6m-6 4.166h6m6.625.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$cbf5dc2951f34d2f$var$ContentWrapRightIcon.displayName = "ContentWrapRightIcon";
var $cbf5dc2951f34d2f$var$_default = module.exports.default = $cbf5dc2951f34d2f$var$ContentWrapRightIcon;

});

parcelRegister("g0fSr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba68f64e5ef0fb53$var$_react = $ba68f64e5ef0fb53$var$_interopRequireDefault((parcelRequire("acw62")));

var $ba68f64e5ef0fb53$var$_UNSAFE_baseNew = $ba68f64e5ef0fb53$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $ba68f64e5ef0fb53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba68f64e5ef0fb53$var$InformationIcon = (props)=>/*#__PURE__*/ $ba68f64e5ef0fb53$var$_react.default.createElement($ba68f64e5ef0fb53$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$ba68f64e5ef0fb53$var$InformationIcon.displayName = "InformationIcon";
var $ba68f64e5ef0fb53$var$_default = module.exports.default = $ba68f64e5ef0fb53$var$InformationIcon;

});

parcelRegister("9FdSp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7092b4fc0e060213$var$_react = $7092b4fc0e060213$var$_interopRequireDefault((parcelRequire("acw62")));

var $7092b4fc0e060213$var$_UNSAFE_baseNew = $7092b4fc0e060213$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $7092b4fc0e060213$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7092b4fc0e060213$var$GridIcon = (props)=>/*#__PURE__*/ $7092b4fc0e060213$var$_react.default.createElement($7092b4fc0e060213$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$7092b4fc0e060213$var$GridIcon.displayName = "GridIcon";
var $7092b4fc0e060213$var$_default = module.exports.default = $7092b4fc0e060213$var$GridIcon;

});

parcelRegister("cghCB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a48a035a6b6ee27b8a00a2b1992b2cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ed4a5f0394dcc1a$var$_react = $8ed4a5f0394dcc1a$var$_interopRequireDefault((parcelRequire("acw62")));

var $8ed4a5f0394dcc1a$var$_UNSAFE_baseNew = $8ed4a5f0394dcc1a$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $8ed4a5f0394dcc1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ed4a5f0394dcc1a$var$ClockIcon = (props)=>/*#__PURE__*/ $8ed4a5f0394dcc1a$var$_react.default.createElement($8ed4a5f0394dcc1a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$8ed4a5f0394dcc1a$var$ClockIcon.displayName = "ClockIcon";
var $8ed4a5f0394dcc1a$var$_default = module.exports.default = $8ed4a5f0394dcc1a$var$ClockIcon;

});

parcelRegister("jbxFH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2df9b6d4b219d15d7e01ad6e3eb71a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df7929e111b0e824$var$_react = $df7929e111b0e824$var$_interopRequireDefault((parcelRequire("acw62")));

var $df7929e111b0e824$var$_UNSAFE_baseNew = $df7929e111b0e824$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $df7929e111b0e824$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df7929e111b0e824$var$HeartIcon = (props)=>/*#__PURE__*/ $df7929e111b0e824$var$_react.default.createElement($df7929e111b0e824$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
    }, props));
$df7929e111b0e824$var$HeartIcon.displayName = "HeartIcon";
var $df7929e111b0e824$var$_default = module.exports.default = $df7929e111b0e824$var$HeartIcon;

});

parcelRegister("9ZaBa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7452082ca0213585$var$_react = $7452082ca0213585$var$_interopRequireDefault((parcelRequire("acw62")));

var $7452082ca0213585$var$_UNSAFE_baseNew = $7452082ca0213585$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $7452082ca0213585$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7452082ca0213585$var$ErrorIcon = (props)=>/*#__PURE__*/ $7452082ca0213585$var$_react.default.createElement($7452082ca0213585$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$7452082ca0213585$var$ErrorIcon.displayName = "ErrorIcon";
var $7452082ca0213585$var$_default = module.exports.default = $7452082ca0213585$var$ErrorIcon;

});

parcelRegister("8c0xc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f6fdbd492326116$var$_react = $5f6fdbd492326116$var$_interopRequireDefault((parcelRequire("acw62")));

var $5f6fdbd492326116$var$_UNSAFE_baseNew = $5f6fdbd492326116$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $5f6fdbd492326116$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f6fdbd492326116$var$UploadIcon = (props)=>/*#__PURE__*/ $5f6fdbd492326116$var$_react.default.createElement($5f6fdbd492326116$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$5f6fdbd492326116$var$UploadIcon.displayName = "UploadIcon";
var $5f6fdbd492326116$var$_default = module.exports.default = $5f6fdbd492326116$var$UploadIcon;

});

parcelRegister("jxvJO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e33235fde7b24564b92256907cba586>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e399b7df3ce5c56b$var$_react = $e399b7df3ce5c56b$var$_interopRequireDefault((parcelRequire("acw62")));

var $e399b7df3ce5c56b$var$_UNSAFE_baseNew = $e399b7df3ce5c56b$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $e399b7df3ce5c56b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e399b7df3ce5c56b$var$FilterIcon = (props)=>/*#__PURE__*/ $e399b7df3ce5c56b$var$_react.default.createElement($e399b7df3ce5c56b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$e399b7df3ce5c56b$var$FilterIcon.displayName = "FilterIcon";
var $e399b7df3ce5c56b$var$_default = module.exports.default = $e399b7df3ce5c56b$var$FilterIcon;

});

parcelRegister("6BHTj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cf83ea2338092f3$var$_react = $4cf83ea2338092f3$var$_interopRequireDefault((parcelRequire("acw62")));

var $4cf83ea2338092f3$var$_UNSAFE_baseNew = $4cf83ea2338092f3$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $4cf83ea2338092f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cf83ea2338092f3$var$ImageIcon = (props)=>/*#__PURE__*/ $4cf83ea2338092f3$var$_react.default.createElement($4cf83ea2338092f3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$4cf83ea2338092f3$var$ImageIcon.displayName = "ImageIcon";
var $4cf83ea2338092f3$var$_default = module.exports.default = $4cf83ea2338092f3$var$ImageIcon;

});

parcelRegister("lHibX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fcbbb9a88c76bf68$var$_react = $fcbbb9a88c76bf68$var$_interopRequireDefault((parcelRequire("acw62")));

var $fcbbb9a88c76bf68$var$_UNSAFE_baseNew = $fcbbb9a88c76bf68$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $fcbbb9a88c76bf68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fcbbb9a88c76bf68$var$LinkIcon = (props)=>/*#__PURE__*/ $fcbbb9a88c76bf68$var$_react.default.createElement($fcbbb9a88c76bf68$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$fcbbb9a88c76bf68$var$LinkIcon.displayName = "LinkIcon";
var $fcbbb9a88c76bf68$var$_default = module.exports.default = $fcbbb9a88c76bf68$var$LinkIcon;

});

parcelRegister("1CLjn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7319a8e7b6756c4415855e934f6695>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12ee0a2275d55e13$var$_react = $12ee0a2275d55e13$var$_interopRequireDefault((parcelRequire("acw62")));

var $12ee0a2275d55e13$var$_UNSAFE_baseNew = $12ee0a2275d55e13$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $12ee0a2275d55e13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12ee0a2275d55e13$var$ZoomInIcon = (props)=>/*#__PURE__*/ $12ee0a2275d55e13$var$_react.default.createElement($12ee0a2275d55e13$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h3m3 0H7m0 0V4m0 3v3"/>`
    }, props));
$12ee0a2275d55e13$var$ZoomInIcon.displayName = "ZoomInIcon";
var $12ee0a2275d55e13$var$_default = module.exports.default = $12ee0a2275d55e13$var$ZoomInIcon;

});

parcelRegister("3JsYz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f96a81b9e560eaf29acabc60a3927a4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b7c0d113386e6b3$var$_react = $2b7c0d113386e6b3$var$_interopRequireDefault((parcelRequire("acw62")));

var $2b7c0d113386e6b3$var$_UNSAFE_baseNew = $2b7c0d113386e6b3$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $2b7c0d113386e6b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b7c0d113386e6b3$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $2b7c0d113386e6b3$var$_react.default.createElement($2b7c0d113386e6b3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h6"/>`
    }, props));
$2b7c0d113386e6b3$var$ZoomOutIcon.displayName = "ZoomOutIcon";
var $2b7c0d113386e6b3$var$_default = module.exports.default = $2b7c0d113386e6b3$var$ZoomOutIcon;

});

parcelRegister("hPYVq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9176a30c0755d77947ceea47f5dcd51a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfc6758d03481610$var$_react = $cfc6758d03481610$var$_interopRequireDefault((parcelRequire("acw62")));

var $cfc6758d03481610$var$_UNSAFE_baseNew = $cfc6758d03481610$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $cfc6758d03481610$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfc6758d03481610$var$MenuIcon = (props)=>/*#__PURE__*/ $cfc6758d03481610$var$_react.default.createElement($cfc6758d03481610$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$cfc6758d03481610$var$MenuIcon.displayName = "MenuIcon";
var $cfc6758d03481610$var$_default = module.exports.default = $cfc6758d03481610$var$MenuIcon;

});

parcelRegister("4Um32", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4cbb05f695c79bf1a6c2a07fef2f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $392d7ea9b8f93fc7$var$_react = $392d7ea9b8f93fc7$var$_interopRequireDefault((parcelRequire("acw62")));

var $392d7ea9b8f93fc7$var$_UNSAFE_baseNew = $392d7ea9b8f93fc7$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $392d7ea9b8f93fc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $392d7ea9b8f93fc7$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $392d7ea9b8f93fc7$var$_react.default.createElement($392d7ea9b8f93fc7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$392d7ea9b8f93fc7$var$ShowMoreVerticalIcon.displayName = "ShowMoreVerticalIcon";
var $392d7ea9b8f93fc7$var$_default = module.exports.default = $392d7ea9b8f93fc7$var$ShowMoreVerticalIcon;

});

parcelRegister("gxuTp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0a7b108bd3089bd$var$_react = $c0a7b108bd3089bd$var$_interopRequireDefault((parcelRequire("acw62")));

var $c0a7b108bd3089bd$var$_UNSAFE_baseNew = $c0a7b108bd3089bd$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $c0a7b108bd3089bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0a7b108bd3089bd$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $c0a7b108bd3089bd$var$_react.default.createElement($c0a7b108bd3089bd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$c0a7b108bd3089bd$var$AlignLeftIcon.displayName = "AlignLeftIcon";
var $c0a7b108bd3089bd$var$_default = module.exports.default = $c0a7b108bd3089bd$var$AlignLeftIcon;

});

parcelRegister("5rGJ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f709dad43f73152$var$_react = $3f709dad43f73152$var$_interopRequireDefault((parcelRequire("acw62")));

var $3f709dad43f73152$var$_UNSAFE_baseNew = $3f709dad43f73152$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $3f709dad43f73152$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f709dad43f73152$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $3f709dad43f73152$var$_react.default.createElement($3f709dad43f73152$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$3f709dad43f73152$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $3f709dad43f73152$var$_default = module.exports.default = $3f709dad43f73152$var$QuestionCircleIcon;

});

parcelRegister("gW3Gy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c544ebf3fbb79ded$var$_react = $c544ebf3fbb79ded$var$_interopRequireDefault((parcelRequire("acw62")));

var $c544ebf3fbb79ded$var$_UNSAFE_baseNew = $c544ebf3fbb79ded$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $c544ebf3fbb79ded$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c544ebf3fbb79ded$var$RefreshIcon = (props)=>/*#__PURE__*/ $c544ebf3fbb79ded$var$_react.default.createElement($c544ebf3fbb79ded$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c544ebf3fbb79ded$var$RefreshIcon.displayName = "RefreshIcon";
var $c544ebf3fbb79ded$var$_default = module.exports.default = $c544ebf3fbb79ded$var$RefreshIcon;

});

parcelRegister("fYNPR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaf30f230bb1e005401a7fdb410093c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba231de8372c3c2e$var$_react = $ba231de8372c3c2e$var$_interopRequireDefault((parcelRequire("acw62")));

var $ba231de8372c3c2e$var$_UNSAFE_baseNew = $ba231de8372c3c2e$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $ba231de8372c3c2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba231de8372c3c2e$var$SearchIcon = (props)=>/*#__PURE__*/ $ba231de8372c3c2e$var$_react.default.createElement($ba231de8372c3c2e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$ba231de8372c3c2e$var$SearchIcon.displayName = "SearchIcon";
var $ba231de8372c3c2e$var$_default = module.exports.default = $ba231de8372c3c2e$var$SearchIcon;

});

parcelRegister("dy5hX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c415ea6f37a3ed0eb78bc36e015407f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd28d892fd726b1$var$_react = $9dd28d892fd726b1$var$_interopRequireDefault((parcelRequire("acw62")));

var $9dd28d892fd726b1$var$_UNSAFE_baseNew = $9dd28d892fd726b1$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $9dd28d892fd726b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9dd28d892fd726b1$var$SettingsIcon = (props)=>/*#__PURE__*/ $9dd28d892fd726b1$var$_react.default.createElement($9dd28d892fd726b1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$9dd28d892fd726b1$var$SettingsIcon.displayName = "SettingsIcon";
var $9dd28d892fd726b1$var$_default = module.exports.default = $9dd28d892fd726b1$var$SettingsIcon;

});

parcelRegister("4pTYx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3374eacce42ca53d$var$_react = $3374eacce42ca53d$var$_interopRequireDefault((parcelRequire("acw62")));

var $3374eacce42ca53d$var$_UNSAFE_baseNew = $3374eacce42ca53d$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $3374eacce42ca53d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3374eacce42ca53d$var$ShareIcon = (props)=>/*#__PURE__*/ $3374eacce42ca53d$var$_react.default.createElement($3374eacce42ca53d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$3374eacce42ca53d$var$ShareIcon.displayName = "ShareIcon";
var $3374eacce42ca53d$var$_default = module.exports.default = $3374eacce42ca53d$var$ShareIcon;

});

parcelRegister("9w6gj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6edbf5bd5e77e7d2$var$_react = $6edbf5bd5e77e7d2$var$_interopRequireDefault((parcelRequire("acw62")));

var $6edbf5bd5e77e7d2$var$_UNSAFE_baseNew = $6edbf5bd5e77e7d2$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $6edbf5bd5e77e7d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6edbf5bd5e77e7d2$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $6edbf5bd5e77e7d2$var$_react.default.createElement($6edbf5bd5e77e7d2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
    }, props));
$6edbf5bd5e77e7d2$var$StarUnstarredIcon.displayName = "StarUnstarredIcon";
var $6edbf5bd5e77e7d2$var$_default = module.exports.default = $6edbf5bd5e77e7d2$var$StarUnstarredIcon;

});

parcelRegister("fV9BG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84516badc93a96e757d14d99cc61886d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b973a19d418c3ddf$var$_react = $b973a19d418c3ddf$var$_interopRequireDefault((parcelRequire("acw62")));

var $b973a19d418c3ddf$var$_UNSAFE_baseNew = $b973a19d418c3ddf$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $b973a19d418c3ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b973a19d418c3ddf$var$StarStarredIcon = (props)=>/*#__PURE__*/ $b973a19d418c3ddf$var$_react.default.createElement($b973a19d418c3ddf$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$b973a19d418c3ddf$var$StarStarredIcon.displayName = "StarStarredIcon";
var $b973a19d418c3ddf$var$_default = module.exports.default = $b973a19d418c3ddf$var$StarStarredIcon;

});

parcelRegister("2Hh3G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f6cd462119aef2f$var$_react = $1f6cd462119aef2f$var$_interopRequireDefault((parcelRequire("acw62")));

var $1f6cd462119aef2f$var$_UNSAFE_baseNew = $1f6cd462119aef2f$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $1f6cd462119aef2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f6cd462119aef2f$var$WarningIcon = (props)=>/*#__PURE__*/ $1f6cd462119aef2f$var$_react.default.createElement($1f6cd462119aef2f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$1f6cd462119aef2f$var$WarningIcon.displayName = "WarningIcon";
var $1f6cd462119aef2f$var$_default = module.exports.default = $1f6cd462119aef2f$var$WarningIcon;

});

parcelRegister("4Olsf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("26Cra")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("26Cra")).Icon);

var $26Cra = parcelRequire("26Cra");

});
parcelRegister("26Cra", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $1889f5253dbcf4d7$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $1889f5253dbcf4d7$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $1D06j = parcelRequire("1D06j");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $1889f5253dbcf4d7$var$svgStyles = null;
var $1889f5253dbcf4d7$var$iconStyles = null;
var $1889f5253dbcf4d7$var$smallIconStyles = null;
var $1889f5253dbcf4d7$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $1889f5253dbcf4d7$var$baseHcmStyles = null;
var $1889f5253dbcf4d7$var$scaleSize = null;
var $1889f5253dbcf4d7$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1889f5253dbcf4d7$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1889f5253dbcf4d7$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $1889f5253dbcf4d7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $1889f5253dbcf4d7$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $1D06j.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === "small" && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $1D06j.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === "small" ? $1889f5253dbcf4d7$var$coreSizeSmall[spacing] : $1889f5253dbcf4d7$var$coreSizeMedium[spacing]
        ])
    }));
});
var $1889f5253dbcf4d7$export$2e2bcd8739ae039 = $1889f5253dbcf4d7$export$f04a61298a47a40f;

});
parcelRegister("1D06j", function(module, exports) {

$parcel$export(module.exports, "default", () => $12f982fb43e879cc$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $12f982fb43e879cc$var$ATOMIC_GROUP_LENGTH = 5;
function $12f982fb43e879cc$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $12f982fb43e879cc$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("f5kcw", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $afb6fe1d65af2a75$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $afb6fe1d65af2a75$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $afb6fe1d65af2a75$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $afb6fe1d65af2a75$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $afb6fe1d65af2a75$export$352e418ed5b6193a);
var $afb6fe1d65af2a75$export$4ef52930e33717cd = "data-theme";
var $afb6fe1d65af2a75$export$cb374d25ded7f6ab = "data-subtree-theme";
var $afb6fe1d65af2a75$export$a00eac3f8684bcd0 = "data-color-mode";
var $afb6fe1d65af2a75$export$2112803007239c61 = "data-contrast-mode";
var $afb6fe1d65af2a75$export$352e418ed5b6193a = "data-custom-theme";
var $afb6fe1d65af2a75$export$6f0c6fb8c80fcc92 = "ds";
var $afb6fe1d65af2a75$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $afb6fe1d65af2a75$export$dddac1532e822863 = "--".concat($afb6fe1d65af2a75$export$6f0c6fb8c80fcc92, "-token-not-found");
var $afb6fe1d65af2a75$export$9d7b58831ae93caa = "--".concat($afb6fe1d65af2a75$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("ahbug", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $77b46701de807b6c$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $77b46701de807b6c$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $77b46701de807b6c$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $77b46701de807b6c$export$2e2bcd8739ae039);

var $ltooA = parcelRequire("ltooA");
var $77b46701de807b6c$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $77b46701de807b6c$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $77b46701de807b6c$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "spacing",
    "shape",
    "typography",
    "motion"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $77b46701de807b6c$var$themeOverrideIds = [];
var $77b46701de807b6c$export$92ba366331403db2 = [].concat($77b46701de807b6c$export$7d43e72a58e3283f, $77b46701de807b6c$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $77b46701de807b6c$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-motion": {
        id: "motion",
        displayName: "Motion",
        palette: "motionPalette",
        attributes: {
            type: "motion"
        }
    }
};
var $77b46701de807b6c$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: function shape() {
        if ((0, $ltooA.fg)("platform-dst-shape-theme-default")) return "shape";
        return undefined;
    },
    spacing: "spacing",
    typography: "typography",
    motion: function motion() {
        if ((0, $ltooA.fg)("platform-dst-motion-theme-default")) return "motion";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $77b46701de807b6c$export$2e2bcd8739ae039 = $77b46701de807b6c$var$themeConfig;

});
parcelRegister("ltooA", function(module, exports) {

$parcel$export(module.exports, "fg", () => $fa1f3adb8706799e$export$b40ec24ac8275656);

var $LXQUz = parcelRequire("LXQUz");
function $fa1f3adb8706799e$export$ba05d765b8392e5e(flagResolver) {
    (0, $LXQUz.setBooleanResolver)(flagResolver);
}
function $fa1f3adb8706799e$export$470e5c2be1411c89(name) {
    return (0, $LXQUz.resolveBooleanFlag)(name);
}
function $fa1f3adb8706799e$export$b40ec24ac8275656(name) {
    return (0, $LXQUz.resolveBooleanFlag)(name);
}

});
parcelRegister("LXQUz", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $0902d157d71d2032$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $0902d157d71d2032$export$6333b6aff9fc6275);

var $k5qh3 = parcelRequire("k5qh3");

var $cHzEV = parcelRequire("cHzEV");

var $hPtJY = parcelRequire("hPtJY");
var $0902d157d71d2032$var$pkgName = "@atlaskit/platform-feature-flags";
var $0902d157d71d2032$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $0902d157d71d2032$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $0902d157d71d2032$var$ENV_ENABLE_PLATFORM_FF = $0902d157d71d2032$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $0902d157d71d2032$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $0902d157d71d2032$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $0902d157d71d2032$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $0902d157d71d2032$var$ENV_ENABLE_PLATFORM_FF || $0902d157d71d2032$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $0902d157d71d2032$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $0902d157d71d2032$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98] = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98] || $0902d157d71d2032$var$DEFAULT_PFF_GLOBAL;
function $0902d157d71d2032$export$f2b591175b3e424c(resolver) {
    $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $0902d157d71d2032$export$6333b6aff9fc6275(flagKey) {
    if ($0902d157d71d2032$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cHzEV.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $0902d157d71d2032$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $k5qh3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("k5qh3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9f8a7c42435822f$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $ihYhP = parcelRequire("ihYhP");

var $95dDe = parcelRequire("95dDe");



var $e9f8a7c42435822f$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e9f8a7c42435822f$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e9f8a7c42435822f$var$_FeatureGates = $e9f8a7c42435822f$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "client", new (0, $ihYhP.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e9f8a7c42435822f$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $e9f8a7c42435822f$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e9f8a7c42435822f$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e9f8a7c42435822f$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e9f8a7c42435822f$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e9f8a7c42435822f$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeCalled", $e9f8a7c42435822f$var$_FeatureGates.client.initializeCalled.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeCompleted", $e9f8a7c42435822f$var$_FeatureGates.client.initializeCompleted.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initialize", $e9f8a7c42435822f$var$_FeatureGates.client.initialize.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeWithProvider", $e9f8a7c42435822f$var$_FeatureGates.client.initializeWithProvider.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeFromValues", $e9f8a7c42435822f$var$_FeatureGates.client.initializeFromValues.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "manuallyLogGateExposure", $e9f8a7c42435822f$var$_FeatureGates.client.manuallyLogGateExposure.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getExperiment", $e9f8a7c42435822f$var$_FeatureGates.client.getExperiment.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "manuallyLogExperimentExposure", $e9f8a7c42435822f$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "manuallyLogLayerExposure", $e9f8a7c42435822f$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "shutdownStatsig", $e9f8a7c42435822f$var$_FeatureGates.client.shutdownStatsig.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "overrideGate", $e9f8a7c42435822f$var$_FeatureGates.client.overrideGate.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "clearGateOverride", $e9f8a7c42435822f$var$_FeatureGates.client.clearGateOverride.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "overrideConfig", $e9f8a7c42435822f$var$_FeatureGates.client.overrideConfig.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "clearConfigOverride", $e9f8a7c42435822f$var$_FeatureGates.client.clearConfigOverride.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "setOverrides", $e9f8a7c42435822f$var$_FeatureGates.client.setOverrides.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getOverrides", $e9f8a7c42435822f$var$_FeatureGates.client.getOverrides.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "clearAllOverrides", $e9f8a7c42435822f$var$_FeatureGates.client.clearAllOverrides.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "isCurrentUser", $e9f8a7c42435822f$var$_FeatureGates.client.isCurrentUser.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "onGateUpdated", $e9f8a7c42435822f$var$_FeatureGates.client.onGateUpdated.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "onExperimentValueUpdated", $e9f8a7c42435822f$var$_FeatureGates.client.onExperimentValueUpdated.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "onAnyUpdated", $e9f8a7c42435822f$var$_FeatureGates.client.onAnyUpdated.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "updateUser", $e9f8a7c42435822f$var$_FeatureGates.client.updateUser.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "updateUserWithProvider", $e9f8a7c42435822f$var$_FeatureGates.client.updateUserWithProvider.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "updateUserWithValues", $e9f8a7c42435822f$var$_FeatureGates.client.updateUserWithValues.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getPackageVersion", $e9f8a7c42435822f$var$_FeatureGates.client.getPackageVersion.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getLayer", $e9f8a7c42435822f$var$_FeatureGates.client.getLayer.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getLayerValue", $e9f8a7c42435822f$var$_FeatureGates.client.getLayerValue.bind($e9f8a7c42435822f$var$_FeatureGates.client));
var $e9f8a7c42435822f$var$boundFGJS = $e9f8a7c42435822f$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e9f8a7c42435822f$var$FeatureGates;
    else {
        var $e9f8a7c42435822f$var$_boundFGJS, $e9f8a7c42435822f$var$_boundFGJS$getPackage;
        $e9f8a7c42435822f$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e9f8a7c42435822f$var$boundVersion = (($e9f8a7c42435822f$var$_boundFGJS = $e9f8a7c42435822f$var$boundFGJS) === null || $e9f8a7c42435822f$var$_boundFGJS === void 0 || ($e9f8a7c42435822f$var$_boundFGJS$getPackage = $e9f8a7c42435822f$var$_boundFGJS.getPackageVersion) === null || $e9f8a7c42435822f$var$_boundFGJS$getPackage === void 0 ? void 0 : $e9f8a7c42435822f$var$_boundFGJS$getPackage.call($e9f8a7c42435822f$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($e9f8a7c42435822f$var$boundVersion !== (0, $95dDe.CLIENT_VERSION)) {
            var $e9f8a7c42435822f$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e9f8a7c42435822f$var$boundVersion, " when module version ").concat((0, $95dDe.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e9f8a7c42435822f$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e9f8a7c42435822f$export$2e2bcd8739ae039 = $e9f8a7c42435822f$var$boundFGJS;

});
parcelRegister("ihYhP", function(module, exports) {

$parcel$export(module.exports, "Client", () => $d5089430a0b807cf$export$1f2bb630327ac4b6);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $49JF1 = parcelRequire("49JF1");

var $cu1O2 = parcelRequire("cu1O2");

var $1FlXM = parcelRequire("1FlXM");

var $cgoqa = parcelRequire("cgoqa");

var $3G7ch = parcelRequire("3G7ch");

var $wC5uA = parcelRequire("wC5uA");

var $e7j5k = parcelRequire("e7j5k");

var $9UzjC = parcelRequire("9UzjC");

var $fUDja = parcelRequire("fUDja");

var $4if7L = parcelRequire("4if7L");

var $95dDe = parcelRequire("95dDe");
var $d5089430a0b807cf$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $d5089430a0b807cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5089430a0b807cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5089430a0b807cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5089430a0b807cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5089430a0b807cf$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $d5089430a0b807cf$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $d5089430a0b807cf$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9UzjC.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subscriptions", new (0, $cu1O2.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dataAdapter", new (0, $e7j5k.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9UzjC.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $4if7L.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $4if7L.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $95dDe.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $d5089430a0b807cf$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $95dDe.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $fUDja.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $4if7L.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $wC5uA.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $1FlXM.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $1FlXM.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $3G7ch.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $4if7L.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $4if7L.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $d5089430a0b807cf$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $wC5uA.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $wC5uA.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $d5089430a0b807cf$var$_objectSpread($d5089430a0b807cf$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $4if7L.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $d5089430a0b807cf$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $d5089430a0b807cf$var$_objectSpread($d5089430a0b807cf$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $d5089430a0b807cf$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $fUDja.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(newClientOptions, $d5089430a0b807cf$var$_excluded);
                                this.user = (0, $4if7L.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $d5089430a0b807cf$var$_objectSpread($d5089430a0b807cf$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $49JF1.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $49JF1.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $49JF1.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $49JF1.StatsigClient)($d5089430a0b807cf$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $4if7L.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $95dDe.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $cgoqa.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $cgoqa.Layer).fromLayer((0, $49JF1._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fOd0O", function(module, exports) {
function $b8259e79f5c77a6f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b8259e79f5c77a6f$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h1Oiy", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
module.exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}

});

parcelRegister("49JF1", function(module, exports) {
"use strict";
var $306b6bf2e1481351$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $306b6bf2e1481351$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $306b6bf2e1481351$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $eW9f7 = parcelRequire("eW9f7");
module.exports.StatsigClient = $eW9f7.default;

$306b6bf2e1481351$var$__exportStar((parcelRequire("jS1H0")), module.exports);
const $306b6bf2e1481351$var$__STATSIG__ = Object.assign((0, (parcelRequire("jS1H0"))._getStatsigGlobal)(), {
    StatsigClient: $eW9f7.default
});
module.exports.default = $306b6bf2e1481351$var$__STATSIG__;

});
parcelRegister("eW9f7", function(module, exports) {
"use strict";
var $adfda6e7b7bfaec8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jS1H0 = parcelRequire("jS1H0");

var $lOMkS = parcelRequire("lOMkS");

var $57TdV = parcelRequire("57TdV");

var $3XUKG = parcelRequire("3XUKG");

var $lm8vs = parcelRequire("lm8vs");
class $adfda6e7b7bfaec8$var$StatsigClient extends $jS1H0.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $jS1H0._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $adfda6e7b7bfaec8$var$StatsigClient) return instance;
        $jS1H0.Log.warn((0, $jS1H0._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $adfda6e7b7bfaec8$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $jS1H0.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $57TdV.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $lm8vs.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($jS1H0.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($jS1H0.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($jS1H0.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($jS1H0.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($jS1H0.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($jS1H0.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $lOMkS.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $jS1H0.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $jS1H0.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $jS1H0.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $jS1H0.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $jS1H0.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $jS1H0.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $jS1H0.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $jS1H0.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($jS1H0.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $jS1H0.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $jS1H0.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $jS1H0.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $jS1H0.StatsigSession.get(this._sdkKey),
            stableID: $jS1H0.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: "log_event_called",
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jS1H0.Storage.isReady()) yield $jS1H0.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $jS1H0.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $jS1H0.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $jS1H0._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $jS1H0.StableID.setOverride(stableIdOverride, this._sdkKey);
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $jS1H0._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $jS1H0._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $jS1H0._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $jS1H0._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $jS1H0._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $jS1H0._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $jS1H0._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $jS1H0._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $jS1H0._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $jS1H0._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $3XUKG._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $3XUKG._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $adfda6e7b7bfaec8$var$StatsigClient;

});
parcelRegister("lOMkS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jS1H0 = parcelRequire("jS1H0");
class $fe23c2f7fbd126a5$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $jS1H0._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $jS1H0._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $jS1H0.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $jS1H0._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $jS1H0.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $jS1H0._getFullUserHash)(userForComparison) !== (0, $jS1H0._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $fe23c2f7fbd126a5$var$EvaluationStore;

});

parcelRegister("57TdV", function(module, exports) {
"use strict";
var $3bb8716e35f9d378$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jS1H0 = parcelRequire("jS1H0");

var $1QLj7 = parcelRequire("1QLj7");
class $3bb8716e35f9d378$var$StatsigNetwork extends $jS1H0.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $jS1H0.UrlConfiguration($jS1H0.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $3bb8716e35f9d378$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $jS1H0._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : "djb2");
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $3bb8716e35f9d378$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $1QLj7._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $3bb8716e35f9d378$var$StatsigNetwork;

});
parcelRegister("1QLj7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $jS1H0 = parcelRequire("jS1H0");
const $158f580e41d6770b$var$MAX_DELTAS_SORT_DEPTH = 2;
function $158f580e41d6770b$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $jS1H0._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $158f580e41d6770b$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $158f580e41d6770b$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $jS1H0._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $158f580e41d6770b$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $158f580e41d6770b$var$_resolveDeltasResponse;
function $158f580e41d6770b$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $158f580e41d6770b$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $158f580e41d6770b$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $158f580e41d6770b$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $158f580e41d6770b$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $158f580e41d6770b$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("3XUKG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $jS1H0 = parcelRequire("jS1H0");
const $2e32e78462c75b4d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $2e32e78462c75b4d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $jS1H0._isTypeMatch)(value, fallback);
}
function $2e32e78462c75b4d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $2e32e78462c75b4d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $2e32e78462c75b4d$var$_shouldLogExposure(options) ? undefined : $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $2e32e78462c75b4d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $2e32e78462c75b4d$var$_shouldLogExposure(options) ? undefined : $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $2e32e78462c75b4d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $2e32e78462c75b4d$var$_shouldLogExposure(options) ? undefined : $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $2e32e78462c75b4d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $2e32e78462c75b4d$var$_shouldLogExposure(options) ? undefined : $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $2e32e78462c75b4d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $jS1H0._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $2e32e78462c75b4d$var$_getMappedStaticValue(param, options);
            case "gate":
                return $2e32e78462c75b4d$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $2e32e78462c75b4d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $2e32e78462c75b4d$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $2e32e78462c75b4d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $2e32e78462c75b4d$var$_makeParamStoreGetter;

});

parcelRegister("lm8vs", function(module, exports) {
"use strict";
var $f8c2403f327db5d2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $jS1H0 = parcelRequire("jS1H0");

var $57TdV = parcelRequire("57TdV");
class $f8c2403f327db5d2$var$StatsigEvaluationsDataAdapter extends $jS1H0.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $57TdV.default) this._network = network;
        else this._network = new $57TdV.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $jS1H0._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $jS1H0._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $jS1H0.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $f8c2403f327db5d2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $jS1H0._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$jS1H0.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $jS1H0._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $f8c2403f327db5d2$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("cu1O2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9169b004f895749f$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $3vRz3 = parcelRequire("3vRz3");
function $9169b004f895749f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9169b004f895749f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9169b004f895749f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9169b004f895749f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9169b004f895749f$export$a66cbd9b2289cd78 = "@all-features";
var $9169b004f895749f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($9169b004f895749f$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($9169b004f895749f$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($9169b004f895749f$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $9169b004f895749f$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("3vRz3", function(module, exports) {
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});


parcelRegister("1FlXM", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $136aa836460b1c7b$export$6dc24881a3d96325);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $4if7L = parcelRequire("4if7L");
var $136aa836460b1c7b$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $4if7L.migrateEvaluationDetails)(experiment.details), (0, $4if7L.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("4if7L", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $32049334f4adf9e6$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $32049334f4adf9e6$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $32049334f4adf9e6$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $32049334f4adf9e6$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $32049334f4adf9e6$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $32049334f4adf9e6$export$55fd683752d01e67);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $jI482 = parcelRequire("jI482");

var $3G7ch = parcelRequire("3G7ch");

var $fUDja = parcelRequire("fUDja");
var $32049334f4adf9e6$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $32049334f4adf9e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32049334f4adf9e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32049334f4adf9e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32049334f4adf9e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32049334f4adf9e6$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $32049334f4adf9e6$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $jI482.isFedRamp)() ? (0, $fUDja.PerimeterType).FEDRAMP_MODERATE : (0, $fUDja.PerimeterType).COMMERCIAL
    }, options);
};
var $32049334f4adf9e6$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $32049334f4adf9e6$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $32049334f4adf9e6$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $32049334f4adf9e6$var$_excluded);
    return $32049334f4adf9e6$var$_objectSpread($32049334f4adf9e6$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $32049334f4adf9e6$var$evaluationReasonMappings = Object.entries((0, $3G7ch.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $32049334f4adf9e6$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $32049334f4adf9e6$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $3G7ch.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $32049334f4adf9e6$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === "string") // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("jI482", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $e595543b1fb9ad0d$export$64d6499adf9b2e51);

var $br8j2 = parcelRequire("br8j2");
function $e595543b1fb9ad0d$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $br8j2.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("br8j2", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $8538a8bc95aace94$export$ce553301d55c2fd8);
var $8538a8bc95aace94$export$ce553301d55c2fd8 = "fedramp-moderate";
var $8538a8bc95aace94$export$f005e2e9f707cb5f = "commercial";
var $8538a8bc95aace94$export$bd6b5a7802d76127 = "fedramp-fedex";
var $8538a8bc95aace94$export$a739cd5aac835909 = "stg";
var $8538a8bc95aace94$export$42dd0cdd351a4a9 = "prod";
var $8538a8bc95aace94$export$404582bc18fe4d9e = "dev";

});


parcelRegister("3G7ch", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $2adae0817e9e9054$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $2adae0817e9e9054$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("fUDja", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $b95a93c0274070b4$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $b95a93c0274070b4$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $b95a93c0274070b4$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $b95a93c0274070b4$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $b95a93c0274070b4$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("cgoqa", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $8ed9ec3005bc0ac3$export$936d0764594b6eb3);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $4if7L = parcelRequire("4if7L");
var $8ed9ec3005bc0ac3$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $4if7L.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $4if7L.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $4if7L.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("wC5uA", function(module, exports) {

$parcel$export(module.exports, "default", () => $062088acc5b471e6$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $fUDja = parcelRequire("fUDja");

var $95dDe = parcelRequire("95dDe");

var $i8K72 = parcelRequire("i8K72");
function $062088acc5b471e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $062088acc5b471e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $062088acc5b471e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $062088acc5b471e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $062088acc5b471e6$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $062088acc5b471e6$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $062088acc5b471e6$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $062088acc5b471e6$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $062088acc5b471e6$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $062088acc5b471e6$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $062088acc5b471e6$export$4e8a0415edbfa1f7 = "https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net";
var $062088acc5b471e6$export$cb3cd156f70d7e94 = "oasis-stg.com/flags";
var $062088acc5b471e6$export$921fbc6cdfd4eee0 = "atlassian-isolated.net/flags";
var $062088acc5b471e6$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $062088acc5b471e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $i8K72.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $i8K72.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $062088acc5b471e6$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $fUDja.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $fUDja.FeatureGateEnvironment).Production:
                        return $062088acc5b471e6$export$18c93900db9358a4;
                    case (0, $fUDja.FeatureGateEnvironment).Staging:
                        return $062088acc5b471e6$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $fUDja.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $fUDja.FeatureGateEnvironment).Development:
                        return $062088acc5b471e6$export$f058dbf75c3bc647;
                    case (0, $fUDja.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $062088acc5b471e6$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $062088acc5b471e6$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $062088acc5b471e6$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $062088acc5b471e6$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $95dDe.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $062088acc5b471e6$export$4e8a0415edbfa1f7.replace("%s", isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($062088acc5b471e6$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($062088acc5b471e6$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== "undefined" && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("95dDe", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $69cf27a9f3c583a9$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $69cf27a9f3c583a9$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("i8K72", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $d34cbe5bd7e463d8$export$286baf652d0b1206);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $in7St = parcelRequire("in7St");
function $d34cbe5bd7e463d8$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $d34cbe5bd7e463d8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $d34cbe5bd7e463d8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d34cbe5bd7e463d8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d34cbe5bd7e463d8$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ResponseError);
        return $d34cbe5bd7e463d8$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($in7St)))(Error));

});
parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("in7St", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $aAhot = parcelRequire("aAhot");

var $8NOJo = parcelRequire("8NOJo");

var $ieMd9 = parcelRequire("ieMd9");
function $d6007c48accfcb1b$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $d6007c48accfcb1b$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$8NOJo(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $ieMd9(t, arguments, $cGTaw(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $aAhot(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d6007c48accfcb1b$var$_wrapNativeSuper(t);
}
module.exports = $d6007c48accfcb1b$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8NOJo", function(module, exports) {
function $668a4079c2bb95d6$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $668a4079c2bb95d6$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ieMd9", function(module, exports) {

var $5HCVq = parcelRequire("5HCVq");

var $aAhot = parcelRequire("aAhot");
function $d46eee8acbe6979e$var$_construct(t, e, r) {
    if ($5HCVq()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $aAhot(p, r.prototype), p;
}
module.exports = $d46eee8acbe6979e$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("e7j5k", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $a47086014aff2308$export$55fffef3474104af);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $49JF1 = parcelRequire("49JF1");
function $a47086014aff2308$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a47086014aff2308$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a47086014aff2308$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a47086014aff2308$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a47086014aff2308$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a47086014aff2308$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a47086014aff2308$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a47086014aff2308$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a47086014aff2308$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a47086014aff2308$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NoFetchDataAdapter);
        _this = $a47086014aff2308$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $49JF1.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $a47086014aff2308$var$_objectSpread($a47086014aff2308$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $49JF1._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $a47086014aff2308$var$_objectSpread($a47086014aff2308$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $49JF1._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $49JF1._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $49JF1.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $a47086014aff2308$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $a47086014aff2308$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $49JF1.DataAdapterCore));

});
parcelRegister("dpL0o", function(module, exports) {

var $fkEbL = parcelRequire("fkEbL");
function $9c4212772a6002f0$var$_get() {
    return module.exports = $9c4212772a6002f0$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $fkEbL(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9c4212772a6002f0$var$_get.apply(null, arguments);
}
module.exports = $9c4212772a6002f0$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fkEbL", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");
function $b297e5ebd9b2c4c7$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $cGTaw(t)););
    return t;
}
module.exports = $b297e5ebd9b2c4c7$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("9UzjC", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $7374bcf3464a7aea$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $7374bcf3464a7aea$export$bcb28fbac1def494);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $jS1H0 = parcelRequire("jS1H0");
function $7374bcf3464a7aea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7374bcf3464a7aea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7374bcf3464a7aea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7374bcf3464a7aea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7374bcf3464a7aea$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7374bcf3464a7aea$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7374bcf3464a7aea$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7374bcf3464a7aea$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7374bcf3464a7aea$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7374bcf3464a7aea$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $7374bcf3464a7aea$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $7374bcf3464a7aea$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $7374bcf3464a7aea$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $7374bcf3464a7aea$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $7374bcf3464a7aea$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PersistentOverrideAdapter);
        this._overrides = $7374bcf3464a7aea$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $7374bcf3464a7aea$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $7374bcf3464a7aea$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $7374bcf3464a7aea$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($7374bcf3464a7aea$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($7374bcf3464a7aea$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $7374bcf3464a7aea$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $jS1H0._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, $7374bcf3464a7aea$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($7374bcf3464a7aea$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current.details), {}, {
                        reason: $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $7374bcf3464a7aea$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($7374bcf3464a7aea$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $jS1H0._makeTypedGet)(current.name, overridden),
                    details: $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current.details), {}, {
                        reason: $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($7374bcf3464a7aea$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $jS1H0._makeTypedGet)(current.name, overridden),
                    details: $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current.details), {}, {
                        reason: $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("cHzEV", function(module, exports) {

$parcel$export(module.exports, "debug", () => $93f52950e219c08b$export$1c9f709888824e05);
var $93f52950e219c08b$var$_process, $93f52950e219c08b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $93f52950e219c08b$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($93f52950e219c08b$var$_process = globalThis.process) === null || $93f52950e219c08b$var$_process === void 0 || ($93f52950e219c08b$var$_process = $93f52950e219c08b$var$_process.env) === null || $93f52950e219c08b$var$_process === void 0 ? void 0 : $93f52950e219c08b$var$_process.JEST_WORKER_ID) !== undefined;
var $93f52950e219c08b$var$DEBUG_MODE = !$93f52950e219c08b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($93f52950e219c08b$var$_process2 = globalThis.process) === null || $93f52950e219c08b$var$_process2 === void 0 || ($93f52950e219c08b$var$_process2 = $93f52950e219c08b$var$_process2.env) === null || $93f52950e219c08b$var$_process2 === void 0 ? void 0 : $93f52950e219c08b$var$_process2.NODE_ENV) !== "production";
var $93f52950e219c08b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$93f52950e219c08b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("9W3Vk", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $73bc92fd7d6bee15$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $73bc92fd7d6bee15$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $73bc92fd7d6bee15$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $73bc92fd7d6bee15$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $73bc92fd7d6bee15$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $73bc92fd7d6bee15$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $73bc92fd7d6bee15$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $73bc92fd7d6bee15$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $73bc92fd7d6bee15$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $73bc92fd7d6bee15$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $73bc92fd7d6bee15$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $73bc92fd7d6bee15$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $73bc92fd7d6bee15$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $73bc92fd7d6bee15$export$b36dbdb4f463f05c(hex) {
    if (!$73bc92fd7d6bee15$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $73bc92fd7d6bee15$export$1212645cf40ebf71(hex)
    ];
}
function $73bc92fd7d6bee15$export$5a544e13ad4e1fa5(hex) {
    if (!$73bc92fd7d6bee15$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $73bc92fd7d6bee15$export$47ea145a83f50dc0(hex) {
    if (!$73bc92fd7d6bee15$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $73bc92fd7d6bee15$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $73bc92fd7d6bee15$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $73bc92fd7d6bee15$export$d061e26956a60b0a(foreground, background) {
    if (!$73bc92fd7d6bee15$var$isValidHex(foreground) || !$73bc92fd7d6bee15$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $73bc92fd7d6bee15$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $73bc92fd7d6bee15$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $73bc92fd7d6bee15$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $73bc92fd7d6bee15$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $73bc92fd7d6bee15$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $73bc92fd7d6bee15$var$rgbToLab(rgbA);
    var labB = $73bc92fd7d6bee15$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $73bc92fd7d6bee15$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("h5UgX", function(module, exports) {

$parcel$export(module.exports, "hash", () => $c71e8dd35e947334$export$d6af199866bfb566);
var $c71e8dd35e947334$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("8kb6x", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kt5RR").then(()=>parcelRequire("gKi7n"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("6nlZT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6oBgq").then(()=>parcelRequire("ljyd3"));

});

parcelRegister("jK9WO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fdiTK").then(()=>parcelRequire("9oJMX"));

});

parcelRegister("8QWPm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5v3vl").then(()=>parcelRequire("3kF4Q"));

});

parcelRegister("1946u", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5r62H").then(()=>parcelRequire("2zRsI"));

});

parcelRegister("hPYcV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("llPW1").then(()=>parcelRequire("9RwOw"));

});

parcelRegister("ijsTl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a5989").then(()=>parcelRequire("j5gsV"));

});

parcelRegister("elFhU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2LSma").then(()=>parcelRequire("2DE01"));

});

parcelRegister("4M54S", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h9Wjp").then(()=>parcelRequire("9qVrn"));

});

parcelRegister("UibT8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l2csn").then(()=>parcelRequire("6X1fk"));

});

parcelRegister("ludeB", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $fa46aa6b1aeabb25$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $fa46aa6b1aeabb25$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $fa46aa6b1aeabb25$export$e673f367da2ff23e);

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");

var $cwX6g = parcelRequire("cwX6g");

var $f5kcw = parcelRequire("f5kcw");

var $h5UgX = parcelRequire("h5UgX");
function $fa46aa6b1aeabb25$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $h5UgX.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $f5kcw.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $f5kcw.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $fa46aa6b1aeabb25$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.from(document.head.querySelectorAll("style[".concat((0, $f5kcw.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $f5kcw.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $fa46aa6b1aeabb25$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $cwX6g.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("cwX6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f65136ee94c099$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c184d9a6e3b52bd2ab053939ce9ad>>
 * @codegenCommand yarn build tokens
 */ var $91f65136ee94c099$var$tokens = {
    "motion.avatar.enter": "--ds-avatar-enter",
    "motion.avatar.exit": "--ds-avatar-exit",
    "motion.avatar.hovered": "--ds-avatar-hovered",
    "motion.content.enter.long": "--ds-content-enter-long",
    "motion.content.enter.medium": "--ds-content-enter-medium",
    "motion.content.enter.short": "--ds-content-enter-short",
    "motion.content.exit.long": "--ds-content-exit-long",
    "motion.content.exit.medium": "--ds-content-exit-medium",
    "motion.content.exit.short": "--ds-content-exit-short",
    "motion.flag.enter": "--ds-flag-enter",
    "motion.flag.exit": "--ds-flag-exit",
    "motion.flag.reposition": "--ds-flag-reposition",
    "motion.modal.enter": "--ds-modal-enter",
    "motion.modal.exit": "--ds-modal-exit",
    "motion.popup.enter.bottom": "--ds-popup-enter-bottom",
    "motion.popup.enter.left": "--ds-popup-enter-left",
    "motion.popup.enter.right": "--ds-popup-enter-right",
    "motion.popup.enter.top": "--ds-popup-enter-top",
    "motion.popup.exit.bottom": "--ds-popup-exit-bottom",
    "motion.popup.exit.left": "--ds-popup-exit-left",
    "motion.popup.exit.right": "--ds-popup-exit-right",
    "motion.popup.exit.top": "--ds-popup-exit-top",
    "motion.spotlight.enter": "--ds-spotlight-enter",
    "motion.spotlight.exit": "--ds-spotlight-exit",
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.danger.bolder": "--ds-text-danger-bolder",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.warning.bolder": "--ds-text-warning-bolder",
    "color.text.success": "--ds-text-success",
    "color.text.success.bolder": "--ds-text-success-bolder",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.discovery.bolder": "--ds-text-discovery-bolder",
    "color.text.information": "--ds-text-information",
    "color.text.information.bolder": "--ds-text-information-bolder",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.subtler": "--ds-background-danger-subtler",
    "color.background.danger.subtler.hovered": "--ds-background-danger-subtler-hovered",
    "color.background.danger.subtler.pressed": "--ds-background-danger-subtler-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.subtler": "--ds-background-warning-subtler",
    "color.background.warning.subtler.hovered": "--ds-background-warning-subtler-hovered",
    "color.background.warning.subtler.pressed": "--ds-background-warning-subtler-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.subtler": "--ds-background-success-subtler",
    "color.background.success.subtler.hovered": "--ds-background-success-subtler-hovered",
    "color.background.success.subtler.pressed": "--ds-background-success-subtler-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.subtler": "--ds-background-discovery-subtler",
    "color.background.discovery.subtler.hovered": "--ds-background-discovery-subtler-hovered",
    "color.background.discovery.subtler.pressed": "--ds-background-discovery-subtler-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.subtler": "--ds-background-information-subtler",
    "color.background.information.subtler.hovered": "--ds-background-information-subtler-hovered",
    "color.background.information.subtler.pressed": "--ds-background-information-subtler-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.metric.large": "--ds-font-metric-large",
    "font.metric.medium": "--ds-font-metric-medium",
    "font.metric.small": "--ds-font-metric-small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "radius.xsmall": "--ds-radius-xsmall",
    "radius.small": "--ds-radius-small",
    "radius.medium": "--ds-radius-medium",
    "radius.large": "--ds-radius-large",
    "radius.xlarge": "--ds-radius-xlarge",
    "radius.xxlarge": "--ds-radius-xxlarge",
    "radius.full": "--ds-radius-full",
    "radius.tile": "--ds-radius-tile",
    "border.width": "--ds-border-width",
    "border.width.selected": "--ds-border-width-selected",
    "border.width.focused": "--ds-border-width-focused"
};
var $91f65136ee94c099$export$2e2bcd8739ae039 = $91f65136ee94c099$var$tokens;

});


parcelRegister("14wq7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aLm7e").then(()=>parcelRequire("70tjv"));

});

parcelRegister("9EzYg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f51491040268dbfa9258c45e59f2b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7073c092fc2ee7bd$var$_react = $7073c092fc2ee7bd$var$_interopRequireDefault((parcelRequire("acw62")));

var $7073c092fc2ee7bd$var$_baseNew = $7073c092fc2ee7bd$var$_interopRequireDefault((parcelRequire("4reSe")));
function $7073c092fc2ee7bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7073c092fc2ee7bd$var$PersonIcon = (props)=>/*#__PURE__*/ $7073c092fc2ee7bd$var$_react.default.createElement($7073c092fc2ee7bd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$7073c092fc2ee7bd$var$PersonIcon.displayName = "PersonIcon";
var $7073c092fc2ee7bd$var$_default = module.exports.default = $7073c092fc2ee7bd$var$PersonIcon;

});
parcelRegister("4reSe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8DGjz")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("8DGjz")).Icon);

var $8DGjz = parcelRequire("8DGjz");

});
parcelRegister("8DGjz", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $64a2ca098c57c4bb$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $64a2ca098c57c4bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $64a2ca098c57c4bb$var$commonSVGStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $64a2ca098c57c4bb$var$svgStyles = (0, $gyDKM.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $64a2ca098c57c4bb$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $64a2ca098c57c4bb$var$utilityIconStyles = (0, $gyDKM.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $64a2ca098c57c4bb$var$scaleStyles = (0, $gyDKM.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $64a2ca098c57c4bb$var$baseHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $64a2ca098c57c4bb$var$scaleSize = (0, $gyDKM.css)({
    width: "inherit",
    height: "inherit"
});
var $64a2ca098c57c4bb$var$sizeMap = {
    core: {
        none: (0, $gyDKM.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $gyDKM.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $gyDKM.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $gyDKM.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $gyDKM.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $64a2ca098c57c4bb$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $64a2ca098c57c4bb$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $64a2ca098c57c4bb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $gyDKM.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $64a2ca098c57c4bb$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $64a2ca098c57c4bb$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $64a2ca098c57c4bb$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $gyDKM.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $64a2ca098c57c4bb$var$iconStyles,
            $64a2ca098c57c4bb$var$baseHcmStyles,
            shouldScale && $64a2ca098c57c4bb$var$scaleStyles,
            props.type === "utility" && $64a2ca098c57c4bb$var$utilityIconStyles
        ]
    }, (0, $gyDKM.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $64a2ca098c57c4bb$var$commonSVGStyles,
            $64a2ca098c57c4bb$var$svgStyles,
            shouldScale ? $64a2ca098c57c4bb$var$scaleSize : props.type === "utility" ? $64a2ca098c57c4bb$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $64a2ca098c57c4bb$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $64a2ca098c57c4bb$export$2e2bcd8739ae039 = $64a2ca098c57c4bb$export$f04a61298a47a40f;

});



parcelRegister("cjWe6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f846cebe3ebe956$var$_react = $8f846cebe3ebe956$var$_interopRequireDefault((parcelRequire("acw62")));

var $9SiAL = parcelRequire("9SiAL");

var $8f846cebe3ebe956$var$_person = $8f846cebe3ebe956$var$_interopRequireDefault((parcelRequire("9EzYg")));
function $8f846cebe3ebe956$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8f846cebe3ebe956$var$PersonIcon = (props)=>/*#__PURE__*/ $8f846cebe3ebe956$var$_react.default.createElement($9SiAL.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $8f846cebe3ebe956$var$_person.default
    }));
$8f846cebe3ebe956$var$PersonIcon.displayName = "PersonIcon";
var $8f846cebe3ebe956$var$_default = module.exports.default = $8f846cebe3ebe956$var$PersonIcon;

});
parcelRegister("9SiAL", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $73079427a2a45847$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $3BhvJ = parcelRequire("3BhvJ");
var $73079427a2a45847$var$_excluded = [
    "dangerouslySetGlyph"
];
var $73079427a2a45847$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $73079427a2a45847$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $73079427a2a45847$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $73079427a2a45847$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $73079427a2a45847$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3BhvJ.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("3BhvJ", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $29f2690e752384cb$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $i2b0z = parcelRequire("i2b0z");

var $13qFm = parcelRequire("13qFm");
function $29f2690e752384cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29f2690e752384cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29f2690e752384cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29f2690e752384cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $29f2690e752384cb$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $29f2690e752384cb$var$_objectSpread($29f2690e752384cb$var$_objectSpread({}, (0, $i2b0z.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $29f2690e752384cb$var$baseHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $29f2690e752384cb$var$primaryEqualsSecondaryHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $29f2690e752384cb$var$secondaryTransparentHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $29f2690e752384cb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $gyDKM.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $i2b0z.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $gyDKM.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $13qFm.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $29f2690e752384cb$var$iconStyles,
            $29f2690e752384cb$var$baseHcmStyles,
            primaryColor === secondaryColor && $29f2690e752384cb$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $29f2690e752384cb$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gyDKM.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $29f2690e752384cb$export$2e2bcd8739ae039 = $29f2690e752384cb$export$f04a61298a47a40f;

});
parcelRegister("i2b0z", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $03635ec5afdbe99f$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $03635ec5afdbe99f$export$3eb7d6130acfda37);

var $iKX0r = parcelRequire("iKX0r");

var $gyDKM = parcelRequire("gyDKM");
var $03635ec5afdbe99f$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $03635ec5afdbe99f$var$smallStyles = (0, $gyDKM.css)((0, $iKX0r.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $03635ec5afdbe99f$var$mediumStyles = (0, $gyDKM.css)((0, $iKX0r.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $03635ec5afdbe99f$var$largeStyles = (0, $gyDKM.css)((0, $iKX0r.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $03635ec5afdbe99f$var$xlargeStyles = (0, $gyDKM.css)((0, $iKX0r.dimensions).xlarge);
var $03635ec5afdbe99f$export$ef0ad74202575b64 = {
    small: $03635ec5afdbe99f$var$smallStyles,
    medium: $03635ec5afdbe99f$var$mediumStyles,
    large: $03635ec5afdbe99f$var$largeStyles,
    xlarge: $03635ec5afdbe99f$var$xlargeStyles
};
var $03635ec5afdbe99f$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $iKX0r.dimensions)[size];
    return undefined;
};

});
parcelRegister("iKX0r", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $da7a4b45403b071f$export$62ad7b0c781000e9);
var $da7a4b45403b071f$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $da7a4b45403b071f$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $da7a4b45403b071f$export$62ad7b0c781000e9 = {
    small: {
        width: $da7a4b45403b071f$export$c647cb0ee6e282fe.small,
        height: $da7a4b45403b071f$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $da7a4b45403b071f$export$c647cb0ee6e282fe.medium,
        height: $da7a4b45403b071f$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $da7a4b45403b071f$export$c647cb0ee6e282fe.large,
        height: $da7a4b45403b071f$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $da7a4b45403b071f$export$c647cb0ee6e282fe.xlarge,
        height: $da7a4b45403b071f$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("13qFm", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $0c4ac19345585e5c$export$18cb9425622d4e06);
var $0c4ac19345585e5c$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("jx3Bs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08061a6d953c7d73b57c2e6e0bdac389>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e383e4ec05286049$var$_react = $e383e4ec05286049$var$_interopRequireDefault((parcelRequire("acw62")));

var $e383e4ec05286049$var$_baseNew = $e383e4ec05286049$var$_interopRequireDefault((parcelRequire("4reSe")));
function $e383e4ec05286049$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e383e4ec05286049$var$ReleaseIcon = (props)=>/*#__PURE__*/ $e383e4ec05286049$var$_react.default.createElement($e383e4ec05286049$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$e383e4ec05286049$var$ReleaseIcon.displayName = "ReleaseIcon";
var $e383e4ec05286049$var$_default = module.exports.default = $e383e4ec05286049$var$ReleaseIcon;

});

parcelRegister("fxKJj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b50e2fa4771e84f5$var$_react = $b50e2fa4771e84f5$var$_interopRequireDefault((parcelRequire("acw62")));

var $9SiAL = parcelRequire("9SiAL");

var $b50e2fa4771e84f5$var$_release = $b50e2fa4771e84f5$var$_interopRequireDefault((parcelRequire("jx3Bs")));
function $b50e2fa4771e84f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b50e2fa4771e84f5$var$ShipIcon = (props)=>/*#__PURE__*/ $b50e2fa4771e84f5$var$_react.default.createElement($9SiAL.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $b50e2fa4771e84f5$var$_release.default
    }));
$b50e2fa4771e84f5$var$ShipIcon.displayName = "ShipIcon";
var $b50e2fa4771e84f5$var$_default = module.exports.default = $b50e2fa4771e84f5$var$ShipIcon;

});

parcelRegister("l9kYV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11bb746989e6f2f05a6a45e4a2d4e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f65ab6bce4fa1fb6$var$_react = $f65ab6bce4fa1fb6$var$_interopRequireDefault((parcelRequire("acw62")));

var $f65ab6bce4fa1fb6$var$_baseNew = $f65ab6bce4fa1fb6$var$_interopRequireDefault((parcelRequire("5fjbT")));
function $f65ab6bce4fa1fb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f65ab6bce4fa1fb6$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f65ab6bce4fa1fb6$var$_react.default.createElement($f65ab6bce4fa1fb6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$f65ab6bce4fa1fb6$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $f65ab6bce4fa1fb6$var$_default = module.exports.default = $f65ab6bce4fa1fb6$var$ChevronDownIcon;

});
parcelRegister("5fjbT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5yS8J")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("5yS8J")).Icon);

var $5yS8J = parcelRequire("5yS8J");

});
parcelRegister("5yS8J", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $40ca1fc29b0747fc$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $40ca1fc29b0747fc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $40ca1fc29b0747fc$var$commonSVGStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $40ca1fc29b0747fc$var$svgStyles = (0, $gyDKM.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $40ca1fc29b0747fc$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $40ca1fc29b0747fc$var$utilityIconStyles = (0, $gyDKM.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $40ca1fc29b0747fc$var$scaleStyles = (0, $gyDKM.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $40ca1fc29b0747fc$var$baseHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $40ca1fc29b0747fc$var$scaleSize = (0, $gyDKM.css)({
    width: "inherit",
    height: "inherit"
});
var $40ca1fc29b0747fc$var$sizeMap = {
    core: {
        none: (0, $gyDKM.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $gyDKM.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $gyDKM.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $gyDKM.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $gyDKM.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $40ca1fc29b0747fc$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $40ca1fc29b0747fc$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $40ca1fc29b0747fc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $gyDKM.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $40ca1fc29b0747fc$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $40ca1fc29b0747fc$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $40ca1fc29b0747fc$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $gyDKM.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $40ca1fc29b0747fc$var$iconStyles,
            $40ca1fc29b0747fc$var$baseHcmStyles,
            shouldScale && $40ca1fc29b0747fc$var$scaleStyles,
            props.type === "utility" && $40ca1fc29b0747fc$var$utilityIconStyles
        ]
    }, (0, $gyDKM.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $40ca1fc29b0747fc$var$commonSVGStyles,
            $40ca1fc29b0747fc$var$svgStyles,
            shouldScale ? $40ca1fc29b0747fc$var$scaleSize : props.type === "utility" ? $40ca1fc29b0747fc$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $40ca1fc29b0747fc$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $40ca1fc29b0747fc$export$2e2bcd8739ae039 = $40ca1fc29b0747fc$export$f04a61298a47a40f;

});



parcelRegister("84K5U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e1273d71cb75cfa$var$_react = $5e1273d71cb75cfa$var$_interopRequireDefault((parcelRequire("acw62")));

var $2ZCmw = parcelRequire("2ZCmw");

var $5e1273d71cb75cfa$var$_chevronDown = $5e1273d71cb75cfa$var$_interopRequireDefault((parcelRequire("l9kYV")));
function $5e1273d71cb75cfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5e1273d71cb75cfa$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5e1273d71cb75cfa$var$_react.default.createElement($2ZCmw.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $5e1273d71cb75cfa$var$_chevronDown.default,
        iconType: "utility"
    }));
$5e1273d71cb75cfa$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $5e1273d71cb75cfa$var$_default = module.exports.default = $5e1273d71cb75cfa$var$ChevronDownIcon;

});
parcelRegister("2ZCmw", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $22df093d3e742b58$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $egsWc = parcelRequire("egsWc");
var $22df093d3e742b58$var$_excluded = [
    "dangerouslySetGlyph"
];
var $22df093d3e742b58$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $22df093d3e742b58$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $22df093d3e742b58$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $22df093d3e742b58$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $22df093d3e742b58$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $egsWc.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("egsWc", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $a62901c2a727f848$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $jyxdk = parcelRequire("jyxdk");

var $lAEgw = parcelRequire("lAEgw");
function $a62901c2a727f848$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a62901c2a727f848$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a62901c2a727f848$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a62901c2a727f848$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $a62901c2a727f848$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $a62901c2a727f848$var$_objectSpread($a62901c2a727f848$var$_objectSpread({}, (0, $jyxdk.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $a62901c2a727f848$var$baseHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $a62901c2a727f848$var$primaryEqualsSecondaryHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $a62901c2a727f848$var$secondaryTransparentHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $a62901c2a727f848$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $gyDKM.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $jyxdk.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $gyDKM.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $lAEgw.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $a62901c2a727f848$var$iconStyles,
            $a62901c2a727f848$var$baseHcmStyles,
            primaryColor === secondaryColor && $a62901c2a727f848$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $a62901c2a727f848$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gyDKM.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $a62901c2a727f848$export$2e2bcd8739ae039 = $a62901c2a727f848$export$f04a61298a47a40f;

});
parcelRegister("jyxdk", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $e3caf4e641343fdc$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $e3caf4e641343fdc$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $e3caf4e641343fdc$export$3eb7d6130acfda37);

var $jJc0U = parcelRequire("jJc0U");

var $gyDKM = parcelRequire("gyDKM");
var $e3caf4e641343fdc$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e3caf4e641343fdc$var$smallStyles = (0, $gyDKM.css)((0, $jJc0U.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e3caf4e641343fdc$var$mediumStyles = (0, $gyDKM.css)((0, $jJc0U.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e3caf4e641343fdc$var$largeStyles = (0, $gyDKM.css)((0, $jJc0U.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e3caf4e641343fdc$var$xlargeStyles = (0, $gyDKM.css)((0, $jJc0U.dimensions).xlarge);
var $e3caf4e641343fdc$export$ef0ad74202575b64 = {
    small: $e3caf4e641343fdc$var$smallStyles,
    medium: $e3caf4e641343fdc$var$mediumStyles,
    large: $e3caf4e641343fdc$var$largeStyles,
    xlarge: $e3caf4e641343fdc$var$xlargeStyles
};
var $e3caf4e641343fdc$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $jJc0U.dimensions)[size];
    return undefined;
};

});
parcelRegister("jJc0U", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $e5cb89f3f5e8acbc$export$62ad7b0c781000e9);
var $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $e5cb89f3f5e8acbc$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $e5cb89f3f5e8acbc$export$62ad7b0c781000e9 = {
    small: {
        width: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.small,
        height: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.medium,
        height: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.large,
        height: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.xlarge,
        height: $e5cb89f3f5e8acbc$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("lAEgw", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $fb7c31acefe78935$export$18cb9425622d4e06);
var $fb7c31acefe78935$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("609qU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45ea0f5ed96700c7$var$_react = $45ea0f5ed96700c7$var$_interopRequireDefault((parcelRequire("acw62")));

var $45ea0f5ed96700c7$var$_baseNew = $45ea0f5ed96700c7$var$_interopRequireDefault((parcelRequire("b0spf")));
function $45ea0f5ed96700c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45ea0f5ed96700c7$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $45ea0f5ed96700c7$var$_react.default.createElement($45ea0f5ed96700c7$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$45ea0f5ed96700c7$var$StatusErrorIcon.displayName = "StatusErrorIcon";
var $45ea0f5ed96700c7$var$_default = module.exports.default = $45ea0f5ed96700c7$var$StatusErrorIcon;

});
parcelRegister("b0spf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("kdtcB")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("kdtcB")).Icon);

var $kdtcB = parcelRequire("kdtcB");

});
parcelRegister("kdtcB", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $eb7bac855b84e4ab$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $eb7bac855b84e4ab$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $eb7bac855b84e4ab$var$svgStyles = null;
var $eb7bac855b84e4ab$var$iconStyles = null;
var $eb7bac855b84e4ab$var$utilityIconStyles = null;
var $eb7bac855b84e4ab$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $eb7bac855b84e4ab$var$baseHcmStyles = null;
var $eb7bac855b84e4ab$var$scaleSize = null;
var $eb7bac855b84e4ab$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $eb7bac855b84e4ab$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $eb7bac855b84e4ab$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $eb7bac855b84e4ab$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $eb7bac855b84e4ab$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $eb7bac855b84e4ab$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $acw62.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $eb7bac855b84e4ab$var$baseSizeMap[type];
    var viewBoxPadding = $eb7bac855b84e4ab$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $luEYg.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $luEYg.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $eb7bac855b84e4ab$var$utilSizes[spacing] : size === "small" ? $eb7bac855b84e4ab$var$coreSizeSmall[spacing] : $eb7bac855b84e4ab$var$coreSizeMedium[spacing]
        ])
    }));
});
var $eb7bac855b84e4ab$export$2e2bcd8739ae039 = $eb7bac855b84e4ab$export$f04a61298a47a40f;

});
parcelRegister("luEYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5c2e4787210c13$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $fa5c2e4787210c13$var$ATOMIC_GROUP_LENGTH = 5;
function $fa5c2e4787210c13$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $fa5c2e4787210c13$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("bDnoG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87857c6d7ce2e8e6$var$_react = $87857c6d7ce2e8e6$var$_interopRequireDefault((parcelRequire("acw62")));

var $e5bvb = parcelRequire("e5bvb");
function $87857c6d7ce2e8e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $87857c6d7ce2e8e6$var$ErrorIcon = (props)=>/*#__PURE__*/ $87857c6d7ce2e8e6$var$_react.default.createElement($e5bvb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$87857c6d7ce2e8e6$var$ErrorIcon.displayName = "ErrorIcon";
var $87857c6d7ce2e8e6$var$_default = module.exports.default = $87857c6d7ce2e8e6$var$ErrorIcon;

});
parcelRegister("e5bvb", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $a40a74604a3b5618$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
function $a40a74604a3b5618$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a40a74604a3b5618$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a40a74604a3b5618$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a40a74604a3b5618$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $a40a74604a3b5618$var$iconStyles = null;
var $a40a74604a3b5618$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $a40a74604a3b5618$var$baseHcmStyles = null;
var $a40a74604a3b5618$var$primaryEqualsSecondaryHcmStyles = null;
var $a40a74604a3b5618$var$secondaryTransparentHcmStyles = null;
var $a40a74604a3b5618$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $acw62.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $a40a74604a3b5618$var$_objectSpread($a40a74604a3b5618$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $luEYg.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $a40a74604a3b5618$var$sizeStyles[size]
        ])
    }));
});
var $a40a74604a3b5618$export$2e2bcd8739ae039 = $a40a74604a3b5618$export$f04a61298a47a40f;

});


parcelRegister("17TwJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d2184658463c348$var$_react = $0d2184658463c348$var$_interopRequireDefault((parcelRequire("acw62")));

var $0d2184658463c348$var$_baseNew = $0d2184658463c348$var$_interopRequireDefault((parcelRequire("b0spf")));
function $0d2184658463c348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d2184658463c348$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $0d2184658463c348$var$_react.default.createElement($0d2184658463c348$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$0d2184658463c348$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $0d2184658463c348$var$_default = module.exports.default = $0d2184658463c348$var$StatusSuccessIcon;

});

parcelRegister("y8qtd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0669b64e6c75fe3f$var$_react = $0669b64e6c75fe3f$var$_interopRequireDefault((parcelRequire("acw62")));

var $e5bvb = parcelRequire("e5bvb");
function $0669b64e6c75fe3f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0669b64e6c75fe3f$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $0669b64e6c75fe3f$var$_react.default.createElement($e5bvb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$0669b64e6c75fe3f$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $0669b64e6c75fe3f$var$_default = module.exports.default = $0669b64e6c75fe3f$var$EditorSuccessIcon;

});

parcelRegister("b0drB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b6fc123789ae26535b6e4ca13d1b4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $802a1f83d88dc8ab$var$_react = $802a1f83d88dc8ab$var$_interopRequireDefault((parcelRequire("acw62")));

var $802a1f83d88dc8ab$var$_UNSAFE_baseNew = $802a1f83d88dc8ab$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $802a1f83d88dc8ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $802a1f83d88dc8ab$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $802a1f83d88dc8ab$var$_react.default.createElement($802a1f83d88dc8ab$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$802a1f83d88dc8ab$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $802a1f83d88dc8ab$var$_default = module.exports.default = $802a1f83d88dc8ab$var$ShowMoreHorizontalIcon;

});

parcelRegister("5jvkr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("kJSex")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("kJSex")).Icon);

var $kJSex = parcelRequire("kJSex");

});
parcelRegister("kJSex", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $f192143c50ccae09$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $f192143c50ccae09$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $f192143c50ccae09$var$svgStyles = null;
var $f192143c50ccae09$var$iconStyles = null;
var $f192143c50ccae09$var$smallIconStyles = null;
var $f192143c50ccae09$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $f192143c50ccae09$var$baseHcmStyles = null;
var $f192143c50ccae09$var$scaleSize = null;
var $f192143c50ccae09$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f192143c50ccae09$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f192143c50ccae09$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $f192143c50ccae09$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $f192143c50ccae09$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $7lEDz.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === "small" && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $7lEDz.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === "small" ? $f192143c50ccae09$var$coreSizeSmall[spacing] : $f192143c50ccae09$var$coreSizeMedium[spacing]
        ])
    }));
});
var $f192143c50ccae09$export$2e2bcd8739ae039 = $f192143c50ccae09$export$f04a61298a47a40f;

});
parcelRegister("7lEDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $559a0447fe6c1727$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $559a0447fe6c1727$var$ATOMIC_GROUP_LENGTH = 5;
function $559a0447fe6c1727$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $559a0447fe6c1727$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("eKnnT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("fqEmD")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("fqEmD")).Icon);

var $fqEmD = parcelRequire("fqEmD");

});
parcelRegister("fqEmD", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $b3b8982b11345bea$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $b3b8982b11345bea$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $b3b8982b11345bea$var$svgStyles = null;
var $b3b8982b11345bea$var$iconStyles = null;
var $b3b8982b11345bea$var$smallIconStyles = null;
var $b3b8982b11345bea$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $b3b8982b11345bea$var$baseHcmStyles = null;
var $b3b8982b11345bea$var$scaleSize = null;
var $b3b8982b11345bea$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b3b8982b11345bea$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b3b8982b11345bea$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $b3b8982b11345bea$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $b3b8982b11345bea$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $iJ0kj.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === "small" && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $iJ0kj.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === "small" ? $b3b8982b11345bea$var$coreSizeSmall[spacing] : $b3b8982b11345bea$var$coreSizeMedium[spacing]
        ])
    }));
});
var $b3b8982b11345bea$export$2e2bcd8739ae039 = $b3b8982b11345bea$export$f04a61298a47a40f;

});
parcelRegister("iJ0kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $da1caed874e1df05$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $da1caed874e1df05$var$ATOMIC_GROUP_LENGTH = 5;
function $da1caed874e1df05$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $da1caed874e1df05$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("dyg5j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("iKwEp")).default);
$parcel$export(module.exports, "ModalTransition", () => (parcelRequire("d3iWI")).default);
$parcel$export(module.exports, "ModalHeader", () => (parcelRequire("diRzd")).default);
$parcel$export(module.exports, "ModalTitle", () => (parcelRequire("lBcre")).default);
$parcel$export(module.exports, "ModalBody", () => (parcelRequire("88rak")).default);
$parcel$export(module.exports, "ModalFooter", () => (parcelRequire("hvoRm")).default);
$parcel$export(module.exports, "CloseButton", () => (parcelRequire("fn3nv")).CloseButton);
$parcel$export(module.exports, "useModal", () => (parcelRequire("2CLkt")).useModal);

var $iKwEp = parcelRequire("iKwEp");

var $d3iWI = parcelRequire("d3iWI");

var $diRzd = parcelRequire("diRzd");

var $lBcre = parcelRequire("lBcre");

var $88rak = parcelRequire("88rak");

var $hvoRm = parcelRequire("hvoRm");

var $fn3nv = parcelRequire("fn3nv");

var $2CLkt = parcelRequire("2CLkt");

});
parcelRegister("iKwEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $da65d9a151744525$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $hsD2P = parcelRequire("hsD2P");

var $rZzKT = parcelRequire("rZzKT");

var $5YNKq = parcelRequire("5YNKq");

var $cBc12 = parcelRequire("cBc12");

var $1kc0P = parcelRequire("1kc0P");

var $foCtm = parcelRequire("foCtm");

var $1NLnE = parcelRequire("1NLnE");

var $izA8S = parcelRequire("izA8S");

var $kRSiU = parcelRequire("kRSiU");

var $iUSVU = parcelRequire("iUSVU");

var $lvAPw = parcelRequire("lvAPw");

var $51SSA = parcelRequire("51SSA");
var $da65d9a151744525$var$fillScreenStyles = (0, $dnfL5.css)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $da65d9a151744525$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector(".aui-blanket:not([hidden])")) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === "function") return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $da65d9a151744525$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $1kc0P.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $lvAPw.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $5YNKq.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $1kc0P.default),
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.4.0"
    });
    var onBlanketClicked = (0, $acw62.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $acw62.useCallback)(function(element) {
        return $da65d9a151744525$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $51SSA.default)();
    var modalDialogWithBlanket = (0, $dnfL5.jsx)((0, $cBc12.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $dnfL5.jsx)((0, $iUSVU.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose)
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $dnfL5.jsx)((0, $foCtm.Layering), {
        isDisabled: false
    }, (0, $dnfL5.jsx)((0, $izA8S.default), {
        zIndex: (0, $kRSiU.layers).modal()
    }, (0, $dnfL5.jsx)((0, $1NLnE.default), null, function(fadeInProps) {
        return (0, $dnfL5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, fadeInProps, {
            css: $da65d9a151744525$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $dnfL5.jsx)((0, $hsD2P.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $dnfL5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($rZzKT))), null), shouldScrollInViewport ? (0, $dnfL5.jsx)((0, $rZzKT.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $da65d9a151744525$export$2e2bcd8739ae039 = $da65d9a151744525$var$ModalWrapper;

});
parcelRegister("dnfL5", function(module, exports) {

$parcel$export(module.exports, "css", () => $9bc9a5a5c89334b6$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $9bc9a5a5c89334b6$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $9bc9a5a5c89334b6$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $9bc9a5a5c89334b6$export$c8a8987d4410bf2d);

var $8u8Lp = parcelRequire("8u8Lp");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $Ivf4A = parcelRequire("Ivf4A");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $9bc9a5a5c89334b6$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $8u8Lp.h).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8u8Lp.E);
    createElementArgArray[1] = (0, $8u8Lp.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($9bc9a5a5c89334b6$export$c8a8987d4410bf2d || ($9bc9a5a5c89334b6$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $9bc9a5a5c89334b6$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8u8Lp.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $8u8Lp.T)));
    if (!(0, $8u8Lp.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $Ivf4A.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $Ivf4A.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $9bc9a5a5c89334b6$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $9bc9a5a5c89334b6$export$d25ddfdf17c3ad3e() {
    var insertable = $9bc9a5a5c89334b6$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $9bc9a5a5c89334b6$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $9bc9a5a5c89334b6$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $9bc9a5a5c89334b6$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $Ivf4A.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $8u8Lp.i) && res !== undefined) rules += res;
        }
        if (!(0, $8u8Lp.i)) return rules;
    });
    if (!(0, $8u8Lp.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9bc9a5a5c89334b6$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8u8Lp.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $8u8Lp.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $8u8Lp.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $9bc9a5a5c89334b6$var$merge(cache.registered, css, $9bc9a5a5c89334b6$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $8u8Lp.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9bc9a5a5c89334b6$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("8u8Lp", function(module, exports) {

$parcel$export(module.exports, "a", () => $62d7ec55d81159f3$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $62d7ec55d81159f3$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $62d7ec55d81159f3$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $62d7ec55d81159f3$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $62d7ec55d81159f3$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $62d7ec55d81159f3$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $62d7ec55d81159f3$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $4ReVQ = parcelRequire("4ReVQ");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $Ivf4A = parcelRequire("Ivf4A");
var $62d7ec55d81159f3$export$407448d2b89b1813 = false;
var $62d7ec55d81159f3$export$23f2a1d2818174ef = typeof document !== "undefined";
var $62d7ec55d81159f3$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: "css"
}) : null);
var $62d7ec55d81159f3$export$e7094788287c5e9b = $62d7ec55d81159f3$var$EmotionCacheContext.Provider;
var $62d7ec55d81159f3$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($62d7ec55d81159f3$var$EmotionCacheContext);
};
var $62d7ec55d81159f3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($62d7ec55d81159f3$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$62d7ec55d81159f3$export$23f2a1d2818174ef) $62d7ec55d81159f3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($62d7ec55d81159f3$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($62d7ec55d81159f3$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $62d7ec55d81159f3$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $62d7ec55d81159f3$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($62d7ec55d81159f3$export$971d5caa766a69d7);
};
var $62d7ec55d81159f3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $62d7ec55d81159f3$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $62d7ec55d81159f3$var$getTheme(outerTheme, theme);
    });
});
var $62d7ec55d81159f3$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($62d7ec55d81159f3$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $62d7ec55d81159f3$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($62d7ec55d81159f3$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $62d7ec55d81159f3$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($62d7ec55d81159f3$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $4ReVQ.default)(WithTheme, Component);
}
var $62d7ec55d81159f3$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $62d7ec55d81159f3$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $62d7ec55d81159f3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($62d7ec55d81159f3$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$62d7ec55d81159f3$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $62d7ec55d81159f3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $Ivf4A.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$62d7ec55d81159f3$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $62d7ec55d81159f3$var$Emotion = /* #__PURE__ */ $62d7ec55d81159f3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$62d7ec55d81159f3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($62d7ec55d81159f3$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($62d7ec55d81159f3$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $62d7ec55d81159f3$var$typePropName && !$62d7ec55d81159f3$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($62d7ec55d81159f3$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $62d7ec55d81159f3$export$a9c23c6ac3fc3eca = $62d7ec55d81159f3$var$Emotion;

});
parcelRegister("4ReVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3897b1dde58b2e13$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $3897b1dde58b2e13$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});

parcelRegister("Ivf4A", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $085c58354bdb5452$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $085c58354bdb5452$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $085c58354bdb5452$var$isBrowser = typeof document !== "undefined";
var $085c58354bdb5452$var$syncFallback = function syncFallback(create) {
    return create();
};
var $085c58354bdb5452$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $085c58354bdb5452$export$db21c7ffa21794e7 = !$085c58354bdb5452$var$isBrowser ? $085c58354bdb5452$var$syncFallback : $085c58354bdb5452$var$useInsertionEffect || $085c58354bdb5452$var$syncFallback;
var $085c58354bdb5452$export$811a713a7276cb9d = $085c58354bdb5452$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("hsD2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6356a9e0c3b960$export$2e2bcd8739ae039);

var $9fH49 = parcelRequire("9fH49");

var $cb6356a9e0c3b960$export$2e2bcd8739ae039 = (0, $9fH49.default);

});
parcelRegister("9fH49", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc6ebca1fe5d2f1$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $kZXYR = parcelRequire("kZXYR");

var $8fTBd = parcelRequire("8fTBd");
var $6bc6ebca1fe5d2f1$var$FocusLockCombination = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kZXYR.default), (0, $8nd05.default)({
        sideCar: (0, $8fTBd.default),
        ref: ref
    }, props));
});
var $6bc6ebca1fe5d2f1$var$_ref = (0, $kZXYR.default).propTypes || {}, $6bc6ebca1fe5d2f1$var$sideCar = $6bc6ebca1fe5d2f1$var$_ref.sideCar, $6bc6ebca1fe5d2f1$var$propTypes = (0, $1En50.default)($6bc6ebca1fe5d2f1$var$_ref, [
    "sideCar"
]);
$6bc6ebca1fe5d2f1$var$FocusLockCombination.propTypes = {};
var $6bc6ebca1fe5d2f1$export$2e2bcd8739ae039 = $6bc6ebca1fe5d2f1$var$FocusLockCombination;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("kZXYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f498081473a3ec11$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $4xUU2 = parcelRequire("4xUU2");

var $lQHA9 = parcelRequire("lQHA9");

var $jEez9 = parcelRequire("jEez9");

var $gSvCn = parcelRequire("gSvCn");

var $fBc34 = parcelRequire("fBc34");
var $f498081473a3ec11$var$emptyArray = [];
var $f498081473a3ec11$var$FocusLock = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $acw62.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $acw62.useRef)();
    var isActive = (0, $acw62.useRef)(false);
    var originalFocusedElement = (0, $acw62.useRef)(null);
    var _useState2 = (0, $acw62.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $f498081473a3ec11$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $acw62.useState)({}), id = _useState3[0];
    var onActivation = (0, $acw62.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $acw62.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $acw62.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $acw62.useCallback)(function(event) {
        if (isActive.current) (0, $gSvCn.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $gSvCn.mediumBlur).useMedium;
    var setObserveNode = (0, $acw62.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $8nd05.default)((_extends2 = {}, _extends2[0, $4xUU2.FOCUS_DISABLED] = disabled && "disabled", _extends2[0, $4xUU2.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $lQHA9.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $acw62.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $jEez9.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $jEez9.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SideCar, {
        id: id,
        sideCar: (0, $gSvCn.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, (0, $8nd05.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fBc34.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $jEez9.hiddenGuard)
    }));
});
$f498081473a3ec11$var$FocusLock.propTypes = {};
var $f498081473a3ec11$export$2e2bcd8739ae039 = $f498081473a3ec11$var$FocusLock;

});
parcelRegister("4xUU2", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $34f6623b57e1a1c8$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $34f6623b57e1a1c8$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $34f6623b57e1a1c8$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $34f6623b57e1a1c8$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $34f6623b57e1a1c8$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $34f6623b57e1a1c8$export$4f9a06cb7441a087 = "data-focus-lock";
var $34f6623b57e1a1c8$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $34f6623b57e1a1c8$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $34f6623b57e1a1c8$export$70e9b4a1820af101 = "data-autofocus-inside";
var $34f6623b57e1a1c8$export$134ebef29fd94853 = "data-no-autofocus";

});

parcelRegister("lQHA9", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $fe8042c5a5eb96e2$export$74665b213cb5c4cf);

var $acw62 = parcelRequire("acw62");

var $6Df3g = parcelRequire("6Df3g");

var $1gHlE = parcelRequire("1gHlE");
var $fe8042c5a5eb96e2$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $fe8042c5a5eb96e2$var$currentValues = new WeakMap();
function $fe8042c5a5eb96e2$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $1gHlE.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $6Df3g.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $fe8042c5a5eb96e2$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $fe8042c5a5eb96e2$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $6Df3g.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $6Df3g.assignRef)(ref, current_1);
            });
        }
        $fe8042c5a5eb96e2$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("6Df3g", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $4d420f89c4a166d0$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $4d420f89c4a166d0$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("1gHlE", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $0ec8e9231ba7123c$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
function $0ec8e9231ba7123c$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("jEez9", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $e4dd0d3a17ffdc2c$export$b8c7b07253306600);

var $acw62 = parcelRequire("acw62");

var $e4dd0d3a17ffdc2c$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $e4dd0d3a17ffdc2c$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $e4dd0d3a17ffdc2c$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $e4dd0d3a17ffdc2c$export$b8c7b07253306600
    }));
};
$e4dd0d3a17ffdc2c$var$InFocusGuard.propTypes = {};
var $e4dd0d3a17ffdc2c$export$2e2bcd8739ae039 = $e4dd0d3a17ffdc2c$var$InFocusGuard;

});

parcelRegister("gSvCn", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $c49a3723ef22df33$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $c49a3723ef22df33$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $c49a3723ef22df33$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $c49a3723ef22df33$export$892cbf28e5518020);

var $b0ZyL = parcelRequire("b0ZyL");
var $c49a3723ef22df33$export$5733e022b1d538cb = (0, $b0ZyL.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $c49a3723ef22df33$export$b3e9a9312f73723c = (0, $b0ZyL.createMedium)();
var $c49a3723ef22df33$export$3a1d52767cbc07b8 = (0, $b0ZyL.createMedium)();
var $c49a3723ef22df33$export$892cbf28e5518020 = (0, $b0ZyL.createSidecarMedium)({
    async: true,
    ssr: typeof document !== "undefined"
});

});
parcelRegister("b0ZyL", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $804f72427f0cc30d$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $804f72427f0cc30d$export$e13ec7dd7a14088d);

var $7WQrb = parcelRequire("7WQrb");
function $804f72427f0cc30d$var$ItoI(a) {
    return a;
}
function $804f72427f0cc30d$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $804f72427f0cc30d$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $804f72427f0cc30d$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $804f72427f0cc30d$var$ItoI;
    return $804f72427f0cc30d$var$innerCreateMedium(defaults, middleware);
}
function $804f72427f0cc30d$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $804f72427f0cc30d$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__exportStar", () => $5c96a02c592fcff1$export$f33643c0debef087);
$parcel$export(module.exports, "__spreadArrays", () => $5c96a02c592fcff1$export$6388937ca91ccae8);
$parcel$export(module.exports, "__importDefault", () => $5c96a02c592fcff1$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});



parcelRegister("fBc34", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $b5b3a8503cdec998$export$f5272e9b1168239c);

var $acw62 = parcelRequire("acw62");
var $b5b3a8503cdec998$export$f5272e9b1168239c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);

});


parcelRegister("8fTBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $602ada49323aa395$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $3nk4s = parcelRequire("3nk4s");

var $jW7tt = parcelRequire("jW7tt");
var $5rKE2 = parcelRequire("5rKE2");
var $fpTn0 = parcelRequire("fpTn0");
var $kuWmi = parcelRequire("kuWmi");
var $6nqmI = parcelRequire("6nqmI");
var $dltQK = parcelRequire("dltQK");parcelRequire("iQq8m");
var $abhGZ = parcelRequire("abhGZ");

var $anpLa = parcelRequire("anpLa");

var $gSvCn = parcelRequire("gSvCn");
var $602ada49323aa395$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $602ada49323aa395$var$isFreeFocus = function isFreeFocus() {
    return $602ada49323aa395$var$focusOnBody() || (0, $6nqmI.focusIsHidden)();
};
var $602ada49323aa395$var$lastActiveTrap = null;
var $602ada49323aa395$var$lastActiveFocus = null;
var $602ada49323aa395$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $602ada49323aa395$var$lastPortaledElement = null;
var $602ada49323aa395$var$focusWasOutsideWindow = false;
var $602ada49323aa395$var$windowFocused = false;
var $602ada49323aa395$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $602ada49323aa395$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($602ada49323aa395$var$lastActiveTrap.whiteList || $602ada49323aa395$var$defaultWhitelist)(activeElement);
};
var $602ada49323aa395$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $602ada49323aa395$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $602ada49323aa395$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $602ada49323aa395$var$lastPortaledElement && $602ada49323aa395$var$lastPortaledElement.portaledElement === element;
};
function $602ada49323aa395$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $602ada49323aa395$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($602ada49323aa395$var$focusWasOutsideWindow);
    return $602ada49323aa395$var$focusWasOutsideWindow === "meanwhile";
};
var $602ada49323aa395$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $602ada49323aa395$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $602ada49323aa395$var$checkInHost(activeElement, area, area);
    });
};
var $602ada49323aa395$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $dltQK.getFocusableNodes)(nodes, new Map());
};
var $602ada49323aa395$var$isNotFocusable = function isNotFocusable(node) {
    return !$602ada49323aa395$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $602ada49323aa395$var$activateTrap = function activateTrap() {
    var result = false;
    if ($602ada49323aa395$var$lastActiveTrap) {
        var _lastActiveTrap = $602ada49323aa395$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $602ada49323aa395$var$lastPortaledElement && $602ada49323aa395$var$lastPortaledElement.portaledElement;
        if ($602ada49323aa395$var$focusOnBody() && $602ada49323aa395$var$lastActiveFocus && $602ada49323aa395$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($602ada49323aa395$var$lastActiveFocus) || $602ada49323aa395$var$isNotFocusable($602ada49323aa395$var$lastActiveFocus)) {
                var newTarget = $602ada49323aa395$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $anpLa.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$602ada49323aa395$var$focusWasOutside(crossFrame) || !noFocusGuards || !$602ada49323aa395$var$lastActiveFocus || $602ada49323aa395$var$windowFocused) return false;
                var nodes = $602ada49323aa395$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $602ada49323aa395$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $602ada49323aa395$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$602ada49323aa395$var$isFreeFocus() || !$602ada49323aa395$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $kuWmi.focusInside)(workingArea) || activeElement && $602ada49323aa395$var$withinHost(activeElement, workingArea) || $602ada49323aa395$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$602ada49323aa395$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $abhGZ.moveFocusInside)(workingArea, $602ada49323aa395$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $602ada49323aa395$var$lastPortaledElement = {};
                        }
                    }
                    $602ada49323aa395$var$lastActiveFocus = document && document.activeElement;
                    if ($602ada49323aa395$var$lastActiveFocus !== document.body) $602ada49323aa395$var$tryRestoreFocus = (0, $jW7tt.captureFocusRestore)($602ada49323aa395$var$lastActiveFocus);
                    $602ada49323aa395$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $5rKE2.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $602ada49323aa395$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $602ada49323aa395$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $602ada49323aa395$var$onTrap = function onTrap(event) {
    if ($602ada49323aa395$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $602ada49323aa395$var$onBlur = function onBlur() {
    return (0, $anpLa.deferAction)($602ada49323aa395$var$activateTrap);
};
var $602ada49323aa395$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $602ada49323aa395$var$recordPortal(currentNode, source);
};
var $602ada49323aa395$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $602ada49323aa395$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onBlur: $602ada49323aa395$var$onBlur,
        onFocus: $602ada49323aa395$var$onFocus
    }, children);
};
$602ada49323aa395$var$FocusTrap.propTypes = {};
var $602ada49323aa395$var$onWindowFocus = function onWindowFocus() {
    $602ada49323aa395$var$windowFocused = true;
};
var $602ada49323aa395$var$onWindowBlur = function onWindowBlur() {
    $602ada49323aa395$var$windowFocused = false;
    $602ada49323aa395$var$focusWasOutsideWindow = "just";
    (0, $anpLa.deferAction)(function() {
        $602ada49323aa395$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $602ada49323aa395$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $602ada49323aa395$var$onTrap);
    document.addEventListener("focusout", $602ada49323aa395$var$onBlur);
    window.addEventListener("focus", $602ada49323aa395$var$onWindowFocus);
    window.addEventListener("blur", $602ada49323aa395$var$onWindowBlur);
};
var $602ada49323aa395$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $602ada49323aa395$var$onTrap);
    document.removeEventListener("focusout", $602ada49323aa395$var$onBlur);
    window.removeEventListener("focus", $602ada49323aa395$var$onWindowFocus);
    window.removeEventListener("blur", $602ada49323aa395$var$onWindowBlur);
};
function $602ada49323aa395$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $602ada49323aa395$var$focusLockAPI = {
    moveFocusInside: (0, $abhGZ.moveFocusInside),
    focusInside: (0, $kuWmi.focusInside),
    focusNextElement: (0, $fpTn0.focusNextElement),
    focusPrevElement: (0, $fpTn0.focusPrevElement),
    focusFirstElement: (0, $fpTn0.focusFirstElement),
    focusLastElement: (0, $fpTn0.focusLastElement),
    captureFocusRestore: (0, $jW7tt.captureFocusRestore)
};
function $602ada49323aa395$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$602ada49323aa395$var$lastActiveTrap) $602ada49323aa395$var$attachHandler();
    var lastTrap = $602ada49323aa395$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $602ada49323aa395$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $602ada49323aa395$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($602ada49323aa395$var$focusLockAPI);
        $602ada49323aa395$var$activateTrap(true);
        (0, $anpLa.deferAction)($602ada49323aa395$var$activateTrap);
    } else {
        $602ada49323aa395$var$detachHandler();
        $602ada49323aa395$var$lastActiveFocus = null;
    }
}
(0, $gSvCn.mediumFocus).assignSyncMedium($602ada49323aa395$var$onFocus);
(0, $gSvCn.mediumBlur).assignMedium($602ada49323aa395$var$onBlur);
(0, $gSvCn.mediumEffect).assignMedium(function(cb) {
    return cb($602ada49323aa395$var$focusLockAPI);
});
var $602ada49323aa395$export$2e2bcd8739ae039 = (0, $3nk4s.default)($602ada49323aa395$var$reducePropsToState, $602ada49323aa395$var$handleStateChangeOnClient)($602ada49323aa395$var$FocusWatcher);

});
parcelRegister("3nk4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $275316c4188dc0a8$export$2e2bcd8739ae039);

var $g7ajw = parcelRequire("g7ajw");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");
function $275316c4188dc0a8$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $g7ajw.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $kSlfw.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $275316c4188dc0a8$export$2e2bcd8739ae039 = $275316c4188dc0a8$var$withSideEffect;

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("jW7tt", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", () => $e8393b55a6e31e11$export$d357db6e554ff59a);

var $dltQK = parcelRequire("dltQK");
function $e8393b55a6e31e11$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === "undefined") return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $e8393b55a6e31e11$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $e8393b55a6e31e11$var$weakRef(currentElement),
            parent: $e8393b55a6e31e11$var$weakRef(currentElement.parentElement),
            left: $e8393b55a6e31e11$var$weakRef(currentElement.previousElementSibling),
            right: $e8393b55a6e31e11$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $e8393b55a6e31e11$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $e8393b55a6e31e11$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $dltQK.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $e8393b55a6e31e11$export$d357db6e554ff59a = function(targetElement) {
    var location = $e8393b55a6e31e11$export$5061a7725be48ff9(targetElement);
    return function() {
        return $e8393b55a6e31e11$var$restoreFocusTo(location);
    };
};

});
parcelRegister("dltQK", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $9b74641517b143d6$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $9b74641517b143d6$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $9b74641517b143d6$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $9b74641517b143d6$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $9b74641517b143d6$export$2344b14b097df817);

var $gISUS = parcelRequire("gISUS");

var $3RvZh = parcelRequire("3RvZh");

var $jLhGk = parcelRequire("jLhGk");

var $hcteO = parcelRequire("hcteO");
var $9b74641517b143d6$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $gISUS.toArray)(nodes).filter(function(node) {
        return (0, $3RvZh.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $3RvZh.notHiddenInput)(node);
    });
};
var $9b74641517b143d6$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $gISUS.toArray)(nodes).filter(function(node) {
        return (0, $3RvZh.isAutoFocusAllowedCached)(cache, node);
    });
};
var $9b74641517b143d6$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $jLhGk.orderByTabIndex)($9b74641517b143d6$export$6266a5cd5915dc33((0, $hcteO.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9b74641517b143d6$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $jLhGk.orderByTabIndex)($9b74641517b143d6$export$6266a5cd5915dc33((0, $hcteO.getFocusables)(topNodes), visibilityCache), false);
};
var $9b74641517b143d6$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9b74641517b143d6$export$6266a5cd5915dc33((0, $hcteO.getParentAutofocusables)(topNode), visibilityCache);
};
var $9b74641517b143d6$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9b74641517b143d6$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $gISUS.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9b74641517b143d6$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9b74641517b143d6$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("gISUS", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $c2cb5aa387a37a50$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $c2cb5aa387a37a50$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $c2cb5aa387a37a50$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $c2cb5aa387a37a50$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c2cb5aa387a37a50$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $c2cb5aa387a37a50$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("3RvZh", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $2cff22612808ae96$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $2cff22612808ae96$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $2cff22612808ae96$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $2cff22612808ae96$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $2cff22612808ae96$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $2cff22612808ae96$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $2cff22612808ae96$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $2cff22612808ae96$export$4e62c701997796c1);

var $4xUU2 = parcelRequire("4xUU2");
var $2cff22612808ae96$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $2cff22612808ae96$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2cff22612808ae96$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2cff22612808ae96$var$isInert = function(node) {
    return node.hasAttribute("inert");
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $2cff22612808ae96$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2cff22612808ae96$var$isTopNode(node) || !$2cff22612808ae96$var$isElementHidden(node) && !$2cff22612808ae96$var$isInert(node) && checkParent($2cff22612808ae96$var$getParentNode(node));
};
var $2cff22612808ae96$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isVisibleUncached(node, $2cff22612808ae96$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2cff22612808ae96$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2cff22612808ae96$var$isTopNode(node) ? $2cff22612808ae96$export$b8550e27de209d85(node) ? checkParent($2cff22612808ae96$var$getParentNode(node)) : false : true;
};
var $2cff22612808ae96$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isAutoFocusAllowedUncached(node, $2cff22612808ae96$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2cff22612808ae96$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2cff22612808ae96$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $2cff22612808ae96$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $2cff22612808ae96$export$9d74f6fbc6f469d0 = function(node) {
    return $2cff22612808ae96$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $2cff22612808ae96$export$8197b0ea56b3b055 = function(node) {
    return !(($2cff22612808ae96$export$88a6ceeed5737ba3(node) || $2cff22612808ae96$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $2cff22612808ae96$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $4xUU2.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $2cff22612808ae96$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2cff22612808ae96$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2cff22612808ae96$export$602e5a0d338d7750 = function(node) {
    return !$2cff22612808ae96$export$d94b8b58ec2f30eb(node);
};
var $2cff22612808ae96$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("jLhGk", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $e6301f5798625d25$export$cb40ee071f0d5226);

var $gISUS = parcelRequire("gISUS");
var $e6301f5798625d25$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $e6301f5798625d25$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute("tabindex")) return 0;
    }
    return node.tabIndex;
};
var $e6301f5798625d25$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $gISUS.toArray)(nodes).map(function(node, index) {
        var tabIndex = $e6301f5798625d25$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($e6301f5798625d25$export$350ee6c095d98996);
};

});

parcelRegister("hcteO", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $c85a3cad3fc06f20$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $c85a3cad3fc06f20$export$853fa94d922e78b9);

var $4xUU2 = parcelRequire("4xUU2");

var $gISUS = parcelRequire("gISUS");

var $dIr1i = parcelRequire("dIr1i");
var $c85a3cad3fc06f20$var$queryTabbables = (0, $dIr1i.tabbables).join(",");
var $c85a3cad3fc06f20$var$queryGuardTabbables = "".concat($c85a3cad3fc06f20$var$queryTabbables, ", [data-focus-guard]");
var $c85a3cad3fc06f20$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $gISUS.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c85a3cad3fc06f20$var$queryGuardTabbables : $c85a3cad3fc06f20$var$queryTabbables) ? [
            child
        ] : [], $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c85a3cad3fc06f20$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c85a3cad3fc06f20$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c85a3cad3fc06f20$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c85a3cad3fc06f20$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $gISUS.toArray)(parent.parentNode.querySelectorAll($c85a3cad3fc06f20$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c85a3cad3fc06f20$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $4xUU2.FOCUS_AUTO), "]"));
    return (0, $gISUS.toArray)(parentFocus).map(function(node) {
        return $c85a3cad3fc06f20$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("dIr1i", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $9fc4580037f02fd3$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $9fc4580037f02fd3$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];

});




parcelRegister("5rKE2", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", () => $3f73a80c2e676402$export$f89ac71e91767111);

var $aDKsi = parcelRequire("aDKsi");

var $3RvZh = parcelRequire("3RvZh");

var $71FKX = parcelRequire("71FKX");

var $jLhGk = parcelRequire("jLhGk");

var $hcteO = parcelRequire("hcteO");
var $3f73a80c2e676402$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $aDKsi.getAllAffectedNodes)(topNode).filter((0, $3RvZh.isNotAGuard));
    var commonParent = (0, $71FKX.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $jLhGk.orderByTabIndex)((0, $hcteO.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $hcteO.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $3RvZh.isGuard)(node)
        };
    });
};

});
parcelRegister("aDKsi", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $7bf194f892d90e1b$export$7e87c4720b9b279b);

var $4xUU2 = parcelRequire("4xUU2");

var $gISUS = parcelRequire("gISUS");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $7bf194f892d90e1b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $7bf194f892d90e1b$var$getTopParent = function(node) {
    return node.parentNode ? $7bf194f892d90e1b$var$getTopParent(node.parentNode) : node;
};
var $7bf194f892d90e1b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $gISUS.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $4xUU2.FOCUS_GROUP));
        acc.push.apply(acc, group ? $7bf194f892d90e1b$var$filterNested((0, $gISUS.toArray)($7bf194f892d90e1b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $4xUU2.FOCUS_GROUP), '="').concat(group, '"]:not([').concat((0, $4xUU2.FOCUS_DISABLED), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("71FKX", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $51d90458d728fe34$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $51d90458d728fe34$export$8f99714c70a37db1);

var $dltQK = parcelRequire("dltQK");

var $gISUS = parcelRequire("gISUS");
var $51d90458d728fe34$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $51d90458d728fe34$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $51d90458d728fe34$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $51d90458d728fe34$var$getParents(nodeA);
    var parentsB = $51d90458d728fe34$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $51d90458d728fe34$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $gISUS.asArray)(baseActiveElement);
    var leftEntries = (0, $gISUS.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $51d90458d728fe34$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $51d90458d728fe34$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $dltQK.contains)(common, topCommon)) topCommon = common;
                else topCommon = $51d90458d728fe34$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $51d90458d728fe34$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $dltQK.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("fpTn0", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", () => $b394242c3b6cfaf1$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $b394242c3b6cfaf1$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $b394242c3b6cfaf1$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $b394242c3b6cfaf1$export$6a79073ddabfd6c3);

var $3M0af = parcelRequire("3M0af");

var $dltQK = parcelRequire("dltQK");

var $gISUS = parcelRequire("gISUS");
var $b394242c3b6cfaf1$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error("no element or scope given");
        return {};
    }
    var shards = (0, $gISUS.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $dltQK.contains)(shard, element);
    })) {
        console.error("Active element is not contained in the scope");
        return {};
    }
    var focusables = useTabbables ? (0, $dltQK.getTabbableNodes)(shards, new Map()) : (0, $dltQK.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $b394242c3b6cfaf1$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $dltQK.getTabbableNodes)((0, $gISUS.asArray)(shards), new Map()) : (0, $dltQK.getFocusableNodes)((0, $gISUS.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $b394242c3b6cfaf1$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $b394242c3b6cfaf1$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $b394242c3b6cfaf1$var$defaultOptions(options);
    var solution = $b394242c3b6cfaf1$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $3M0af.focusOn)(target.node, newOptions.focusOptions);
};
var $b394242c3b6cfaf1$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $b394242c3b6cfaf1$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $b394242c3b6cfaf1$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $b394242c3b6cfaf1$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $3M0af.focusOn)(node.node, options.focusOptions);
};
var $b394242c3b6cfaf1$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "first");
};
var $b394242c3b6cfaf1$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "last");
};

});
parcelRegister("3M0af", function(module, exports) {

$parcel$export(module.exports, "focusOn", () => $2bf5fb6846f8e2c5$export$c12b3da842c43a8);
var $2bf5fb6846f8e2c5$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("kuWmi", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $eec3e0cab722c011$export$20115f8da7baa6fa);

var $dltQK = parcelRequire("dltQK");

var $aDKsi = parcelRequire("aDKsi");

var $gISUS = parcelRequire("gISUS");

var $fzXrW = parcelRequire("fzXrW");
var $eec3e0cab722c011$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $eec3e0cab722c011$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $gISUS.toArray)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $eec3e0cab722c011$var$focusInFrame(node, activeElement);
    }));
};
var $eec3e0cab722c011$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $fzXrW.getActiveElement)((0, $gISUS.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $aDKsi.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $dltQK.contains)(node, activeElement) || $eec3e0cab722c011$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("fzXrW", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $b5783d59678393a3$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $kPikV = parcelRequire("kPikV");
var $b5783d59678393a3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $kPikV.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("kPikV", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $f296cb52f860ecc3$export$78d20aae35adef88);
var $f296cb52f860ecc3$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("6nqmI", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $4a4957b2dfe49f02$export$be6b21806d3fd485);

var $4xUU2 = parcelRequire("4xUU2");

var $dltQK = parcelRequire("dltQK");

var $gISUS = parcelRequire("gISUS");

var $fzXrW = parcelRequire("fzXrW");
var $4a4957b2dfe49f02$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $fzXrW.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $gISUS.toArray)(inDocument.querySelectorAll("[".concat((0, $4xUU2.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $dltQK.contains)(node, activeElement);
    });
};

});

parcelRegister("iQq8m", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("abhGZ")).moveFocusInside);

var $4xUU2 = parcelRequire("4xUU2");

var $kuWmi = parcelRequire("kuWmi");

var $6nqmI = parcelRequire("6nqmI");


var $5rKE2 = parcelRequire("5rKE2");

var $abhGZ = parcelRequire("abhGZ");

var $jW7tt = parcelRequire("jW7tt");

var $fpTn0 = parcelRequire("fpTn0");

var $dltQK = parcelRequire("dltQK");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $db815af593127be9$export$1a988e7317c65621 = $4xUU2;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $db815af593127be9$var$deprecated_default_moveFocusInside = (0, $abhGZ.moveFocusInside);
var $db815af593127be9$export$2e2bcd8739ae039 //
 = $db815af593127be9$var$deprecated_default_moveFocusInside;

});
parcelRegister("abhGZ", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => $7698a7d35ed86651$export$cd599851e879a025);

var $3M0af = parcelRequire("3M0af");

var $izOTH = parcelRequire("izOTH");
var $7698a7d35ed86651$var$guardCount = 0;
var $7698a7d35ed86651$var$lockDisabled = false;
var $7698a7d35ed86651$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $izOTH.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($7698a7d35ed86651$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($7698a7d35ed86651$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7698a7d35ed86651$var$lockDisabled = true;
            setTimeout(function() {
                $7698a7d35ed86651$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7698a7d35ed86651$var$guardCount++;
        (0, $3M0af.focusOn)(focusable.node, options.focusOptions);
        $7698a7d35ed86651$var$guardCount--;
    }
};

});
parcelRegister("izOTH", function(module, exports) {

$parcel$export(module.exports, "focusSolver", () => $d862fa039a3b3c25$export$305758c744b57f6f);

var $8aGXY = parcelRequire("8aGXY");

var $dltQK = parcelRequire("dltQK");

var $aDKsi = parcelRequire("aDKsi");

var $gISUS = parcelRequire("gISUS");

var $Tyr80 = parcelRequire("Tyr80");

var $fzXrW = parcelRequire("fzXrW");

var $3RvZh = parcelRequire("3RvZh");

var $71FKX = parcelRequire("71FKX");
var $d862fa039a3b3c25$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $3RvZh.isDefined));
};
var $d862fa039a3b3c25$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $fzXrW.getActiveElement)((0, $gISUS.asArray)(topNode).length > 0 ? document : (0, $gISUS.getFirst)(topNode).ownerDocument);
    var entries = (0, $aDKsi.getAllAffectedNodes)(topNode).filter((0, $3RvZh.isNotAGuard));
    var commonParent = (0, $71FKX.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $dltQK.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $3RvZh.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $dltQK.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $d862fa039a3b3c25$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $8aGXY.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $8aGXY.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $Tyr80.pickAutofocus)(anyFocusable, innerTabbable, (0, $71FKX.allParentAutofocusables)(entries, visibilityCache)) || (0, $Tyr80.pickAutofocus)(anyFocusable, innerFocusables, (0, $71FKX.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("8aGXY", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $5f30961e5fc5285a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $5f30961e5fc5285a$export$65842178e9bb4205);

var $4nUQF = parcelRequire("4nUQF");

var $7iGR6 = parcelRequire("7iGR6");

var $3RvZh = parcelRequire("3RvZh");
var $5f30961e5fc5285a$export$85710b12cf912438 = "NEW_FOCUS";
var $5f30961e5fc5285a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $3RvZh.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $5f30961e5fc5285a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $5f30961e5fc5285a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $4nUQF.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $7iGR6.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $7iGR6.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("4nUQF", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $3315685220e94b72$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $3315685220e94b72$export$4a5a72a7124e45f9);

var $3RvZh = parcelRequire("3RvZh");
var $3315685220e94b72$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $3RvZh.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $3315685220e94b72$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $3RvZh.isRadioElement)(node) && node.name) return $3315685220e94b72$var$findSelectedRadio(node, nodes);
    return node;
};
var $3315685220e94b72$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($3315685220e94b72$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("7iGR6", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $550b7510239b204f$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $550b7510239b204f$export$e06728ee87c96122);

var $4nUQF = parcelRequire("4nUQF");
var $550b7510239b204f$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $4nUQF.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $550b7510239b204f$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $4nUQF.correctNode)(node, nodes));
};

});


parcelRegister("Tyr80", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $0a6fd98cd390fe5b$export$cfb742983e257555);

var $dltQK = parcelRequire("dltQK");

var $7iGR6 = parcelRequire("7iGR6");

var $3RvZh = parcelRequire("3RvZh");
var $0a6fd98cd390fe5b$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $3RvZh.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0a6fd98cd390fe5b$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $dltQK.filterAutoFocusable)(nodes.filter($0a6fd98cd390fe5b$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $7iGR6.pickFirstFocus)(autoFocusable);
    return (0, $7iGR6.pickFirstFocus)((0, $dltQK.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("anpLa", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $78e008b40b5ae0ba$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $78e008b40b5ae0ba$export$c613fed06e332533);
function $78e008b40b5ae0ba$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $78e008b40b5ae0ba$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $78e008b40b5ae0ba$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};

});




parcelRegister("rZzKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e2Nte = parcelRequire("e2Nte");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $05424961d45ef195$var$_interopRequireDefault($e2Nte).default;
    }
});

var $7S4JX = parcelRequire("7S4JX");
Object.defineProperty(module.exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $7S4JX.TouchScrollable;
    }
});
function $05424961d45ef195$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("e2Nte", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a397a067088df685$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $a397a067088df685$var$_react2 = $a397a067088df685$var$_interopRequireDefault($acw62);

var $djCxr = parcelRequire("djCxr");

var $7S4JX = parcelRequire("7S4JX");

var $51R21 = parcelRequire("51R21");
var $a397a067088df685$var$_withLockSheet2 = $a397a067088df685$var$_interopRequireDefault($51R21);

var $1xt0w = parcelRequire("1xt0w");
var $a397a067088df685$var$_withTouchListeners2 = $a397a067088df685$var$_interopRequireDefault($1xt0w);

var $aWxIl = parcelRequire("aWxIl");
function $a397a067088df685$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a397a067088df685$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a397a067088df685$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a397a067088df685$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a397a067088df685$var$ScrollLock = function(_PureComponent) {
    $a397a067088df685$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $a397a067088df685$var$_classCallCheck(this, ScrollLock);
        return $a397a067088df685$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $a397a067088df685$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$djCxr.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $a397a067088df685$var$_react2.default.createElement($7S4JX.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($acw62.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $a397a067088df685$var$compose = (0, $aWxIl.pipe)($a397a067088df685$var$_withTouchListeners2.default, $a397a067088df685$var$_withLockSheet2.default);
var $a397a067088df685$var$SheetLock = $a397a067088df685$var$compose($a397a067088df685$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $a397a067088df685$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $a397a067088df685$var$_react2.default.createElement($a397a067088df685$var$SheetLock, props) : props.children;
};
$a397a067088df685$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $a397a067088df685$var$LockToggle;

});
parcelRegister("djCxr", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("7S4JX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $5bb140df60bf4afd$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5bb140df60bf4afd$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $djCxr = parcelRequire("djCxr");

var $aWxIl = parcelRequire("aWxIl");
function $5bb140df60bf4afd$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5bb140df60bf4afd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bb140df60bf4afd$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5bb140df60bf4afd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5bb140df60bf4afd$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $5bb140df60bf4afd$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $5bb140df60bf4afd$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5bb140df60bf4afd$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $5bb140df60bf4afd$var$_possibleConstructorReturn(_this, _ret);
    }
    $5bb140df60bf4afd$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$djCxr.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $aWxIl.preventInertiaScroll, $aWxIl.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $aWxIl.allowTouchMove, $aWxIl.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$djCxr.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $aWxIl.preventInertiaScroll, $aWxIl.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $aWxIl.allowTouchMove, $aWxIl.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $5bb140df60bf4afd$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $acw62.cloneElement)(children, $5bb140df60bf4afd$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($acw62.PureComponent);

});
parcelRegister("aWxIl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $7f797916b36ee382$var$preventTouchMove;
module.exports.allowTouchMove = $7f797916b36ee382$var$allowTouchMove;
module.exports.preventInertiaScroll = $7f797916b36ee382$var$preventInertiaScroll;
module.exports.isTouchDevice = $7f797916b36ee382$var$isTouchDevice;
module.exports.camelToKebab = $7f797916b36ee382$var$camelToKebab;
module.exports.parse = $7f797916b36ee382$var$parse;
module.exports.getPadding = $7f797916b36ee382$var$getPadding;
module.exports.getWindowHeight = $7f797916b36ee382$var$getWindowHeight;
module.exports.getDocumentHeight = $7f797916b36ee382$var$getDocumentHeight;
module.exports.makeStyleTag = $7f797916b36ee382$var$makeStyleTag;
module.exports.injectStyles = $7f797916b36ee382$var$injectStyles;
module.exports.insertStyleTag = $7f797916b36ee382$var$insertStyleTag;

var $djCxr = parcelRequire("djCxr");
var $7f797916b36ee382$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $7f797916b36ee382$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $7f797916b36ee382$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $7f797916b36ee382$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $7f797916b36ee382$var$isTouchDevice() {
    if (!$djCxr.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $7f797916b36ee382$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $7f797916b36ee382$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $7f797916b36ee382$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $7f797916b36ee382$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($7f797916b36ee382$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $7f797916b36ee382$var$getPadding() {
    if (!$djCxr.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $7f797916b36ee382$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($djCxr.canUseDOM) return window.innerHeight * multiplier;
}
function $7f797916b36ee382$var$getDocumentHeight() {
    if ($djCxr.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $7f797916b36ee382$var$makeStyleTag() {
    if (!$djCxr.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $7f797916b36ee382$var$injectStyles(tag, css) {
    if (!$djCxr.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $7f797916b36ee382$var$insertStyleTag(tag) {
    if (!$djCxr.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}

});


parcelRegister("51R21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3a962eb574069425$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $3a962eb574069425$var$withLockSheet;

var $acw62 = parcelRequire("acw62");
var $3a962eb574069425$var$_react2 = $3a962eb574069425$var$_interopRequireDefault($acw62);

var $aWxIl = parcelRequire("aWxIl");
function $3a962eb574069425$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3a962eb574069425$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a962eb574069425$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3a962eb574069425$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $3a962eb574069425$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $3a962eb574069425$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $3a962eb574069425$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $3a962eb574069425$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $aWxIl.makeStyleTag)();
                if (!sheet) return;
                (0, $aWxIl.injectStyles)(sheet, styles);
                (0, $aWxIl.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $aWxIl.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $aWxIl.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $3a962eb574069425$var$_possibleConstructorReturn(_this, _ret);
        }
        $3a962eb574069425$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $3a962eb574069425$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($acw62.PureComponent);
}

});

parcelRegister("1xt0w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $11ef5fc45c0ed579$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $11ef5fc45c0ed579$var$withTouchListeners;

var $acw62 = parcelRequire("acw62");
var $11ef5fc45c0ed579$var$_react2 = $11ef5fc45c0ed579$var$_interopRequireDefault($acw62);

var $djCxr = parcelRequire("djCxr");

var $aWxIl = parcelRequire("aWxIl");
function $11ef5fc45c0ed579$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11ef5fc45c0ed579$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11ef5fc45c0ed579$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $11ef5fc45c0ed579$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $11ef5fc45c0ed579$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $11ef5fc45c0ed579$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $11ef5fc45c0ed579$var$_classCallCheck(this, TouchProvider);
            return $11ef5fc45c0ed579$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $11ef5fc45c0ed579$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$djCxr.canUseDOM || !(0, $aWxIl.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $aWxIl.preventTouchMove, $aWxIl.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$djCxr.canUseDOM || !(0, $aWxIl.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $aWxIl.preventTouchMove, $aWxIl.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $11ef5fc45c0ed579$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($acw62.PureComponent);
}

});



parcelRegister("5YNKq", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $45a92537da7cd298$export$a4687b0234b40e28);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $hfYBe = parcelRequire("hfYBe");

var $3R1KE = parcelRequire("3R1KE");
function $45a92537da7cd298$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45a92537da7cd298$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45a92537da7cd298$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45a92537da7cd298$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $45a92537da7cd298$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hfYBe.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3R1KE.useTrackedRef)(analyticsData);
    var fnRef = (0, $3R1KE.useTrackedRef)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $45a92537da7cd298$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("hfYBe", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $c902d829d509afbd$export$5bf35293e545f20c);

var $6Bvm3 = parcelRequire("6Bvm3");

var $bAVd1 = parcelRequire("bAVd1");

var $j9U3N = parcelRequire("j9U3N");
function $c902d829d509afbd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $j9U3N.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $bAVd1.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("6Bvm3", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", () => $4cee852ff321daee$export$33752cf3ee811995);

var $acw62 = parcelRequire("acw62");
function $4cee852ff321daee$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $4cee852ff321daee$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $acw62.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $acw62.useRef)(true);
    var committed = (0, $acw62.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $4cee852ff321daee$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $acw62.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $4cee852ff321daee$export$33752cf3ee811995(callback, inputs) {
    return $4cee852ff321daee$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $4cee852ff321daee$export$1538c33de8887b59 = $4cee852ff321daee$export$b6feb8998cd9b342;
var $4cee852ff321daee$export$35808ee640e87ca7 = $4cee852ff321daee$export$33752cf3ee811995;

});

parcelRegister("bAVd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $870f6f056b591391$export$2e2bcd8739ae039);

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $4RS3t = parcelRequire("4RS3t");
function $870f6f056b591391$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $870f6f056b591391$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $870f6f056b591391$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($870f6f056b591391$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $870f6f056b591391$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $870f6f056b591391$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $870f6f056b591391$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $870f6f056b591391$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $870f6f056b591391$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $870f6f056b591391$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4RS3t.default));

});
parcelRegister("4RS3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $38b60ada03fb3333$export$2e2bcd8739ae039);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $38b60ada03fb3333$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $38b60ada03fb3333$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $38b60ada03fb3333$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $38b60ada03fb3333$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $38b60ada03fb3333$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $38b60ada03fb3333$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $38b60ada03fb3333$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $38b60ada03fb3333$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $38b60ada03fb3333$var$_objectSpread($38b60ada03fb3333$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("j9U3N", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $df2a57fe2aa1ed9f$export$d1f587f82ad51c4);

var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $df2a57fe2aa1ed9f$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};

});
parcelRegister("9ZLvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $746ea9a911a720f1$export$2e2bcd8739ae039);

var $92BWw = parcelRequire("92BWw");
var $746ea9a911a720f1$export$2e2bcd8739ae039 = (0, $92BWw.default);

});
parcelRegister("92BWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6951bb9d9d303f9a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $6951bb9d9d303f9a$var$AnalyticsNextContext = (0, $acw62.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $6951bb9d9d303f9a$export$2e2bcd8739ae039 = $6951bb9d9d303f9a$var$AnalyticsNextContext;

});




parcelRegister("3R1KE", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $2ce7ae24b463f78d$export$1d27a74659855e44);

var $acw62 = parcelRequire("acw62");
var $2ce7ae24b463f78d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("cBc12", function(module, exports) {

$parcel$export(module.exports, "default", () => $92c242caaf335d09$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $5cymf = parcelRequire("5cymf");

var $73Y26 = parcelRequire("73Y26");

var $gGhQ4 = parcelRequire("gGhQ4");

var $4tNr8 = parcelRequire("4tNr8");

function $92c242caaf335d09$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92c242caaf335d09$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92c242caaf335d09$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92c242caaf335d09$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $92c242caaf335d09$var$packageName = "@atlaskit/blanket";
var $92c242caaf335d09$var$packageVersion = "15.0.8";
var $92c242caaf335d09$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $92c242caaf335d09$var$packageName,
    packageVersion: $92c242caaf335d09$var$packageVersion
};
var $92c242caaf335d09$var$baseStyles = null;
var $92c242caaf335d09$var$shouldAllowClickThroughStyles = null;
var $92c242caaf335d09$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $92c242caaf335d09$var$Blanket = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $gGhQ4.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $acw62.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $73Y26.usePlatformLeafEventHandler)($92c242caaf335d09$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $92c242caaf335d09$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $acw62.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $acw62.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $9dvtP.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $5cymf.default)("var(--ds-blanket, ".concat((0, $4tNr8.N100A), ")"))
        }
    }, children);
}));
$92c242caaf335d09$var$Blanket.displayName = "Blanket";
var $92c242caaf335d09$export$2e2bcd8739ae039 = $92c242caaf335d09$var$Blanket;

});
parcelRegister("9dvtP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5dbf3efbbf4cdf$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6b5dbf3efbbf4cdf$var$ATOMIC_GROUP_LENGTH = 5;
function $6b5dbf3efbbf4cdf$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $6b5dbf3efbbf4cdf$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("5cymf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c98b981a1405cfc$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $3c98b981a1405cfc$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("73Y26", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $52476180ee6a0d19$export$a4687b0234b40e28);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $kloAy = parcelRequire("kloAy");

var $1At3I = parcelRequire("1At3I");
function $52476180ee6a0d19$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52476180ee6a0d19$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52476180ee6a0d19$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52476180ee6a0d19$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $52476180ee6a0d19$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kloAy.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1At3I.useTrackedRef)(analyticsData);
    var fnRef = (0, $1At3I.useTrackedRef)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $52476180ee6a0d19$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("kloAy", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $ecf8d796ed2a71c3$export$5bf35293e545f20c);

var $6Bvm3 = parcelRequire("6Bvm3");

var $dZYFP = parcelRequire("dZYFP");

var $cNWbe = parcelRequire("cNWbe");
function $ecf8d796ed2a71c3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $cNWbe.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $dZYFP.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dZYFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a310096788558fe5$export$2e2bcd8739ae039);

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $ggwVg = parcelRequire("ggwVg");
function $a310096788558fe5$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a310096788558fe5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a310096788558fe5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a310096788558fe5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a310096788558fe5$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a310096788558fe5$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a310096788558fe5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $a310096788558fe5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $a310096788558fe5$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a310096788558fe5$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $ggwVg.default));

});
parcelRegister("ggwVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd77adb676e45e55$export$2e2bcd8739ae039);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $bd77adb676e45e55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bd77adb676e45e55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bd77adb676e45e55$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bd77adb676e45e55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bd77adb676e45e55$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $bd77adb676e45e55$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $bd77adb676e45e55$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $bd77adb676e45e55$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $bd77adb676e45e55$var$_objectSpread($bd77adb676e45e55$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("cNWbe", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $952730fb5636c39c$export$d1f587f82ad51c4);

var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $952730fb5636c39c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};

});


parcelRegister("1At3I", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $127fb1b5df472eb6$export$1d27a74659855e44);

var $acw62 = parcelRequire("acw62");
var $127fb1b5df472eb6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("gGhQ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24e6807ba97af20$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $c24e6807ba97af20$export$2e2bcd8739ae039() {}

});

parcelRegister("4tNr8", function(module, exports) {

$parcel$export(module.exports, "N100A", () => $343037ec3d6d118a$export$486ab785e4bac3c6);
// Reds
var $343037ec3d6d118a$export$4b84fd0e2c617bd = "#FFEBE6";
var $343037ec3d6d118a$export$b34b069eff244586 = "#FFBDAD";
var $343037ec3d6d118a$export$be802dd0d8b57f35 = "#FF8F73";
var $343037ec3d6d118a$export$60847d42f9da92a6 = "#FF7452";
var $343037ec3d6d118a$export$4a7404f376229999 = "#FF5630";
var $343037ec3d6d118a$export$2010d0fb4295b346 = "#DE350B";
var $343037ec3d6d118a$export$2837b5a1a71d5c02 = "#BF2600";
var $343037ec3d6d118a$export$8d9596b529bbb9cf = "#FFFAE6";
var $343037ec3d6d118a$export$41060a744ab0b7ae = "#FFF0B3";
var $343037ec3d6d118a$export$1cc05bbbf340e559 = "#FFE380";
var $343037ec3d6d118a$export$5aae31392d72caaa = "#FFC400";
var $343037ec3d6d118a$export$c6930421db9fa514 = "#FFAB00";
var $343037ec3d6d118a$export$59619663aa6500fb = "#FF991F";
var $343037ec3d6d118a$export$874739ea9e379ab6 = "#FF8B00";
var $343037ec3d6d118a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $343037ec3d6d118a$export$69a3bf21b9686c2b = "#ABF5D1";
var $343037ec3d6d118a$export$afbce1382ec95f73 = "#79F2C0";
var $343037ec3d6d118a$export$747d86715d4175de = "#57D9A3";
var $343037ec3d6d118a$export$940e1f69e873f202 = "#36B37E";
var $343037ec3d6d118a$export$a49394138f7b8e85 = "#00875A";
var $343037ec3d6d118a$export$6fa04827ac68a4fb = "#006644";
var $343037ec3d6d118a$export$226de0355ed012f8 = "#DEEBFF";
var $343037ec3d6d118a$export$8c13c2ee36917869 = "#B3D4FF";
var $343037ec3d6d118a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $343037ec3d6d118a$export$215b7063051591f1 = "#2684FF";
var $343037ec3d6d118a$export$e62e8919cca44969 = "#0065FF";
var $343037ec3d6d118a$export$b3de0ae08da2ce64 = "#0052CC";
var $343037ec3d6d118a$export$a6ee3d71bc067634 = "#0747A6";
var $343037ec3d6d118a$export$67f15409e87642a1 = "#669DF1";
var $343037ec3d6d118a$export$f0539dbc42dbb067 = "#8FB8F6";
var $343037ec3d6d118a$export$363e4475840015bb = "#EAE6FF";
var $343037ec3d6d118a$export$4b0a4417ed59760f = "#C0B6F2";
var $343037ec3d6d118a$export$6011520a64d9a187 = "#998DD9";
var $343037ec3d6d118a$export$a7175d4e9206bc80 = "#8777D9";
var $343037ec3d6d118a$export$b48405b95304b5a1 = "#6554C0";
var $343037ec3d6d118a$export$c71e4279dd54a18d = "#5243AA";
var $343037ec3d6d118a$export$147899de772240ec = "#403294";
var $343037ec3d6d118a$export$2cf711fe14c66f06 = "#E6FCFF";
var $343037ec3d6d118a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $343037ec3d6d118a$export$776c9c497ef08533 = "#79E2F2";
var $343037ec3d6d118a$export$69cb3ca10c1e330e = "#00C7E6";
var $343037ec3d6d118a$export$9dc1ef0f3f48059b = "#00B8D9";
var $343037ec3d6d118a$export$7c835c78b6fcdef8 = "#00A3BF";
var $343037ec3d6d118a$export$6036577f95c3877e = "#008DA6";
var $343037ec3d6d118a$export$29a4f05edc054374 = "#FFFFFF";
var $343037ec3d6d118a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $343037ec3d6d118a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $343037ec3d6d118a$export$3e51e8f1440314ba = "#EBECF0";
var $343037ec3d6d118a$export$1ce2d1575d444ceb = "#DFE1E6";
var $343037ec3d6d118a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $343037ec3d6d118a$export$c2e91cbeada39b8b = "#B3BAC5";
var $343037ec3d6d118a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $343037ec3d6d118a$export$eaa8c8a70ac22806 = "#97A0AF";
var $343037ec3d6d118a$export$7c87d337fb91a97d = "#8993A4";
var $343037ec3d6d118a$export$d6447c357493214f = "#7A869A";
var $343037ec3d6d118a$export$f563ee71e9ee74cd = "#6B778C";
var $343037ec3d6d118a$export$e2ef2124cf4024b1 = "#5E6C84";
var $343037ec3d6d118a$export$eece5f492e429f08 = "#505F79";
var $343037ec3d6d118a$export$c39c0fe0f26207ae = "#42526E";
var $343037ec3d6d118a$export$7090862dc3038a9f = "#344563";
var $343037ec3d6d118a$export$ad0bacf983b7ddaa = "#253858";
var $343037ec3d6d118a$export$7d61b15e0da132af = "#172B4D";
var $343037ec3d6d118a$export$fbda843f0a27fe96 = "#091E42";
var $343037ec3d6d118a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $343037ec3d6d118a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $343037ec3d6d118a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $343037ec3d6d118a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $343037ec3d6d118a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $343037ec3d6d118a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $343037ec3d6d118a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $343037ec3d6d118a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $343037ec3d6d118a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $343037ec3d6d118a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $343037ec3d6d118a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $343037ec3d6d118a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $343037ec3d6d118a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $343037ec3d6d118a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $343037ec3d6d118a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $343037ec3d6d118a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $343037ec3d6d118a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $343037ec3d6d118a$export$2f6319cf7d736c2a = "#E6EDFA";
var $343037ec3d6d118a$export$95126bc8884d6634 = "#DCE5F5";
var $343037ec3d6d118a$export$8338d8c35d44ff1 = "#CED9EB";
var $343037ec3d6d118a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $343037ec3d6d118a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $343037ec3d6d118a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $343037ec3d6d118a$export$97e81faa16a182c7 = "#8C9CB8";
var $343037ec3d6d118a$export$bfe21c59123ecf33 = "#7988A3";
var $343037ec3d6d118a$export$ee82aa2ea6a1558 = "#67758F";
var $343037ec3d6d118a$export$682927c6ed76be02 = "#56637A";
var $343037ec3d6d118a$export$91fd9994c5be9757 = "#455166";
var $343037ec3d6d118a$export$d281fbfe3cff2df6 = "#3B475C";
var $343037ec3d6d118a$export$3902c91d8b98a753 = "#313D52";
var $343037ec3d6d118a$export$8e8133c1ba5845b5 = "#283447";
var $343037ec3d6d118a$export$33ff357f6620b39 = "#202B3D";
var $343037ec3d6d118a$export$633847cf062b69e0 = "#1B2638";
var $343037ec3d6d118a$export$9776a6e503bdbf76 = "#121A29";
var $343037ec3d6d118a$export$6c813d5160dff5db = "#0E1624";
var $343037ec3d6d118a$export$3d4f271a500072a = "#0D1424";
var $343037ec3d6d118a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $343037ec3d6d118a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $343037ec3d6d118a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $343037ec3d6d118a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $343037ec3d6d118a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $343037ec3d6d118a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $343037ec3d6d118a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $343037ec3d6d118a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $343037ec3d6d118a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $343037ec3d6d118a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $343037ec3d6d118a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $343037ec3d6d118a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $343037ec3d6d118a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $343037ec3d6d118a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $343037ec3d6d118a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $343037ec3d6d118a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $343037ec3d6d118a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $343037ec3d6d118a$export$d2adc5dedf09fced = "#292A2E";
var $343037ec3d6d118a$export$f51762073d2bb381 = "#94C748";
var $343037ec3d6d118a$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("1kc0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70fa2155ec54e8$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $0f70fa2155ec54e8$export$2e2bcd8739ae039() {}

});

parcelRegister("foCtm", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $b356f0bf88c94195$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $b356f0bf88c94195$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $b356f0bf88c94195$export$7c885f891c940977);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $1kc0P = parcelRequire("1kc0P");

var $ltooA = parcelRequire("ltooA");
function $b356f0bf88c94195$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b356f0bf88c94195$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b356f0bf88c94195$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b356f0bf88c94195$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b356f0bf88c94195$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $b356f0bf88c94195$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $1kc0P.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $b356f0bf88c94195$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($b356f0bf88c94195$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $acw62.useRef)((0, $ltooA.fg)("layering-top-level-use-array") ? Math.random().toString(36) : "");
    if (!(0, $ltooA.fg)("layering-top-level-use-array")) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $ltooA.fg)("layering-top-level-use-array")) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $ltooA.fg)("layering-top-level-use-array")) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b356f0bf88c94195$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $b356f0bf88c94195$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var layerList = (0, $acw62.useRef)([]);
    var value = (0, $acw62.useMemo)(function() {
        return $b356f0bf88c94195$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $ltooA.fg)("layering-top-level-use-array") ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b356f0bf88c94195$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $b356f0bf88c94195$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($b356f0bf88c94195$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b356f0bf88c94195$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b356f0bf88c94195$var$LayeringProvider, null, content);
};

});

parcelRegister("1NLnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ff1ecedbc531e2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dJltf = parcelRequire("dJltf");
var $14ff1ecedbc531e2$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $14ff1ecedbc531e2$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $14ff1ecedbc531e2$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dJltf.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $14ff1ecedbc531e2$export$2e2bcd8739ae039 = $14ff1ecedbc531e2$var$FadeIn;

});
parcelRegister("dJltf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff021f97d57589f$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");

var $9LTnL = parcelRequire("9LTnL");

var $fZQEc = parcelRequire("fZQEc");

var $dY9UQ = parcelRequire("dY9UQ");

var $ocesl = parcelRequire("ocesl");

var $3foOM = parcelRequire("3foOM");
var $9ff021f97d57589f$var$zoomIn = null;
var $9ff021f97d57589f$var$zoomOut = null;
var $9ff021f97d57589f$var$fadeIn = null;
var $9ff021f97d57589f$var$fadeOut = null;
var $9ff021f97d57589f$var$fadeInFromTop = null;
var $9ff021f97d57589f$var$fadeOutFromTop = null;
var $9ff021f97d57589f$var$fadeInFromLeft = null;
var $9ff021f97d57589f$var$fadeOutFromLeft = null;
var $9ff021f97d57589f$var$fadeInFromBottom = null;
var $9ff021f97d57589f$var$fadeOutFromBottom = null;
var $9ff021f97d57589f$var$fadeInFromRight = null;
var $9ff021f97d57589f$var$fadeOutFromRight = null;
var $9ff021f97d57589f$var$fadeInFromTopConstant = null;
var $9ff021f97d57589f$var$fadeOutFromTopConstant = null;
var $9ff021f97d57589f$var$fadeInFromLeftConstant = null;
var $9ff021f97d57589f$var$fadeOutFromLeftConstant = null;
var $9ff021f97d57589f$var$fadeInFromBottomConstant = null;
var $9ff021f97d57589f$var$fadeOutFromBottomConstant = null;
var $9ff021f97d57589f$var$fadeInFromRightConstant = null;
var $9ff021f97d57589f$var$fadeOutFromRightConstant = null;
var $9ff021f97d57589f$var$slideInFromTop = null;
var $9ff021f97d57589f$var$slideOutFromTop = null;
var $9ff021f97d57589f$var$slideInFromRight = null;
var $9ff021f97d57589f$var$slideOutFromRight = null;
var $9ff021f97d57589f$var$slideInFromBottom = null;
var $9ff021f97d57589f$var$slideOutFromBottom = null;
var $9ff021f97d57589f$var$slideInFromLeft = null;
var $9ff021f97d57589f$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9ff021f97d57589f$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $3foOM.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $ocesl.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $dY9UQ.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $9LTnL.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $fZQEc.exitingDurations)[duration] : (0, $fZQEc.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $9dvtP.default)([
            (0, $9dvtP.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $9dvtP.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $9dvtP.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $9dvtP.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $9dvtP.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $9dvtP.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $9dvtP.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $9dvtP.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $9dvtP.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $9dvtP.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $9dvtP.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $9dvtP.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-40-out" && (0, $9dvtP.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === "ease-in-60-out" && (0, $9dvtP.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === "ease-in-80-out" && (0, $9dvtP.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $9dvtP.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $9dvtP.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $9dvtP.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $9dvtP.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-40-out" && (0, $9dvtP.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-60-out" && (0, $9dvtP.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-80-out" && (0, $9dvtP.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $9dvtP.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $9dvtP.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $9dvtP.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $9dvtP.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $9dvtP.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $9dvtP.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $9dvtP.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $9dvtP.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $9dvtP.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $9dvtP.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $9dvtP.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $9dvtP.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $9dvtP.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $9dvtP.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $9dvtP.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $9dvtP.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $9dvtP.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $9dvtP.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $9dvtP.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $9dvtP.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $9dvtP.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $9dvtP.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $9dvtP.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $9dvtP.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $9dvtP.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $9dvtP.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $9dvtP.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $9dvtP.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $9dvtP.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $9ff021f97d57589f$export$2e2bcd8739ae039 = $9ff021f97d57589f$var$EnteringMotion;

});
parcelRegister("9LTnL", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", () => $71d376990c506ec3$export$b7baf7667a68d87c);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $71d376990c506ec3$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $71d376990c506ec3$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$71d376990c506ec3$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $71d376990c506ec3$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($71d376990c506ec3$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$71d376990c506ec3$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $71d376990c506ec3$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $71d376990c506ec3$export$ff7706047246b98b = function prefersReducedMotion() {
    return $71d376990c506ec3$export$f0f789643ba5a83c;
};

});
parcelRegister("8fY35", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $gYwVX = parcelRequire("gYwVX");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $gYwVX.bind;
    }
});

var $h6VkO = parcelRequire("h6VkO");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $h6VkO.bindAll;
    }
});

});
parcelRegister("gYwVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $c5bbcbe38ba49ef4$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $c5bbcbe38ba49ef4$var$bind;

});

parcelRegister("h6VkO", function(module, exports) {
"use strict";
var $c74f78a9926000a3$var$__assign = module.exports && module.exports.__assign || function() {
    $c74f78a9926000a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c74f78a9926000a3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $gYwVX = parcelRequire("gYwVX");
function $c74f78a9926000a3$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $c74f78a9926000a3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c74f78a9926000a3$var$__assign($c74f78a9926000a3$var$__assign({}, original), {
        options: $c74f78a9926000a3$var$__assign($c74f78a9926000a3$var$__assign({}, $c74f78a9926000a3$var$toOptions(sharedOptions)), $c74f78a9926000a3$var$toOptions(original.options))
    });
    return binding;
}
function $c74f78a9926000a3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c74f78a9926000a3$var$getBinding(original, sharedOptions);
        return (0, $gYwVX.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $c74f78a9926000a3$var$bindAll;

});



parcelRegister("fZQEc", function(module, exports) {

$parcel$export(module.exports, "durations", () => $ba5564349761acaf$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $ba5564349761acaf$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $ba5564349761acaf$export$368bacef0dacbe05 = 25;
var $ba5564349761acaf$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $ba5564349761acaf$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $ba5564349761acaf$export$30fa1a2e62ae150c = {
    none: $ba5564349761acaf$export$38b928a7167ce124.none,
    small: $ba5564349761acaf$export$38b928a7167ce124.small * $ba5564349761acaf$var$EXITING_MOTION_MULTIPLIER,
    medium: $ba5564349761acaf$export$38b928a7167ce124.medium * $ba5564349761acaf$var$EXITING_MOTION_MULTIPLIER,
    large: $ba5564349761acaf$export$38b928a7167ce124.large * $ba5564349761acaf$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("dY9UQ", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", () => $029fe152ad8b0a5d$export$4f34107a2b00f39c);

var $acw62 = parcelRequire("acw62");
var $029fe152ad8b0a5d$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $029fe152ad8b0a5d$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $029fe152ad8b0a5d$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $029fe152ad8b0a5d$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $029fe152ad8b0a5d$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("ocesl", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", () => $048bbb0f16f04ebf$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $048bbb0f16f04ebf$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $048bbb0f16f04ebf$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $048bbb0f16f04ebf$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($048bbb0f16f04ebf$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $048bbb0f16f04ebf$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $048bbb0f16f04ebf$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($048bbb0f16f04ebf$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $048bbb0f16f04ebf$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $048bbb0f16f04ebf$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $048bbb0f16f04ebf$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $048bbb0f16f04ebf$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $048bbb0f16f04ebf$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $048bbb0f16f04ebf$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $048bbb0f16f04ebf$var$childrenToArray(previousChildren);
    var current = $048bbb0f16f04ebf$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $048bbb0f16f04ebf$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $048bbb0f16f04ebf$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $048bbb0f16f04ebf$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $048bbb0f16f04ebf$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $048bbb0f16f04ebf$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($048bbb0f16f04ebf$var$ExitingContext);
};
$048bbb0f16f04ebf$var$ExitingPersistence.displayName = "ExitingPersistence";
var $048bbb0f16f04ebf$export$2e2bcd8739ae039 = $048bbb0f16f04ebf$var$ExitingPersistence;

});

parcelRegister("3foOM", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", () => $25d6062858b9a9e1$export$25c7213fc07ec080);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $6YJfY = parcelRequire("6YJfY");

var $khYaa = parcelRequire("khYaa");

var $k8CTX = parcelRequire("k8CTX");
var $25d6062858b9a9e1$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $6YJfY.default)
    };
});
var $25d6062858b9a9e1$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $k8CTX.useUniqueId)();
    var context = (0, $acw62.useContext)($25d6062858b9a9e1$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $25d6062858b9a9e1$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $khYaa.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($25d6062858b9a9e1$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $25d6062858b9a9e1$export$2e2bcd8739ae039 = $25d6062858b9a9e1$var$StaggeredEntrance;

});
parcelRegister("6YJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $514b73ae7d57b3e2$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $514b73ae7d57b3e2$export$2e2bcd8739ae039() {}

});

parcelRegister("khYaa", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $ec5410506f3607ed$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
var $ec5410506f3607ed$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);

});

parcelRegister("k8CTX", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $ea92bb053532d0fb$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $ea92bb053532d0fb$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("izA8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85787f04e13c20e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $d6N4a = parcelRequire("d6N4a");

var $dFn9e = parcelRequire("dFn9e");

var $lXQhN = parcelRequire("lXQhN");

var $673AU = parcelRequire("673AU");
function $d85787f04e13c20e$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $lXQhN.default)(mountStrategy);
    (0, $673AU.default)(zIndex);
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6N4a.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dFn9e.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("d6N4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $98b1e567e7f39b2c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cyPm7 = parcelRequire("cyPm7");
function $98b1e567e7f39b2c$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $cyPm7.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $cyPm7.appendPortalContainerIfNotAppended)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $cyPm7.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}

});
parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});

parcelRegister("cyPm7", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $92507f35c6e9c4ac$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $92507f35c6e9c4ac$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $92507f35c6e9c4ac$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $92507f35c6e9c4ac$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $92507f35c6e9c4ac$export$95029ca7aca2989e);

var $6I0Mi = parcelRequire("6I0Mi");
var $92507f35c6e9c4ac$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $6I0Mi.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $92507f35c6e9c4ac$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $92507f35c6e9c4ac$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $6I0Mi.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $6I0Mi.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $92507f35c6e9c4ac$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $92507f35c6e9c4ac$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $92507f35c6e9c4ac$var$getPortalParent().removeChild(container);
};
var $92507f35c6e9c4ac$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $92507f35c6e9c4ac$var$getPortalParent().appendChild(container);
};
var $92507f35c6e9c4ac$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $92507f35c6e9c4ac$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($92507f35c6e9c4ac$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $6I0Mi.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $92507f35c6e9c4ac$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($92507f35c6e9c4ac$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $6I0Mi.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $6I0Mi.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $92507f35c6e9c4ac$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("6I0Mi", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", () => $4e2774a121ec72b9$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $4e2774a121ec72b9$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $4e2774a121ec72b9$export$13f57c02915787b3);
var $4e2774a121ec72b9$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $4e2774a121ec72b9$export$72f415121273627e = "body > .atlaskit-portal-container";
var $4e2774a121ec72b9$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("dFn9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f310f5e97b94d24$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $gnpyK = parcelRequire("gnpyK");

var $cyPm7 = parcelRequire("cyPm7");
function $9f310f5e97b94d24$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $gnpyK.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $cyPm7.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $cyPm7.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("gnpyK", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $bec29eead2b64012$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $bec29eead2b64012$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});


parcelRegister("lXQhN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd7aa8fedaa1004$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $gnpyK = parcelRequire("gnpyK");
var $ffd7aa8fedaa1004$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $gnpyK.useIsomorphicLayoutEffect) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ffd7aa8fedaa1004$export$2e2bcd8739ae039 = $ffd7aa8fedaa1004$var$useIsSubsequentRender;

});

parcelRegister("673AU", function(module, exports) {

$parcel$export(module.exports, "default", () => $47362f4d1bd83a93$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5Ymcq = parcelRequire("5Ymcq");

var $2WgcQ = parcelRequire("2WgcQ");
var $47362f4d1bd83a93$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $2WgcQ.default)((0, $5Ymcq.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $2WgcQ.default)((0, $5Ymcq.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $47362f4d1bd83a93$export$2e2bcd8739ae039 = $47362f4d1bd83a93$var$useFirePortalEvent;

});
parcelRegister("5Ymcq", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $4593c6aa12f50f60$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $4593c6aa12f50f60$export$80816bd900e5bd00);
var $4593c6aa12f50f60$export$ed5835cc67e87f72 = "akPortalMount";
var $4593c6aa12f50f60$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("2WgcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $223d91beb184de5a$export$2e2bcd8739ae039);
var $223d91beb184de5a$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $223d91beb184de5a$var$getLayerName = function getLayerName(zIndex) {
    return $223d91beb184de5a$var$zIndexToName.hasOwnProperty(zIndex) ? $223d91beb184de5a$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $223d91beb184de5a$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $223d91beb184de5a$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $223d91beb184de5a$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $223d91beb184de5a$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("kRSiU", function(module, exports) {

$parcel$export(module.exports, "layers", () => $f312e18480461c18$export$7be255094ccdc533);

var $oRlJS = parcelRequire("oRlJS");

var $9itI1 = parcelRequire("9itI1");
var $f312e18480461c18$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $f312e18480461c18$export$c93026a968943f95 = "light";
var $f312e18480461c18$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $f312e18480461c18$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f312e18480461c18$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f312e18480461c18$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9itI1.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f312e18480461c18$export$6d8204c2cb2e06b8() / 4;
    (0, $oRlJS.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f312e18480461c18$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f312e18480461c18$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f312e18480461c18$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $oRlJS.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $f312e18480461c18$export$ba1d834b86d72a09 = $f312e18480461c18$export$a1b3edb637fb4f35;
var $f312e18480461c18$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9itI1.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9itI1.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9itI1.N30A), ")")
            }
        }
    };
};

});
parcelRegister("oRlJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $04aba02155f8b286$export$2e2bcd8739ae039);

var $dstGB = parcelRequire("dstGB");

var $hPtJY = parcelRequire("hPtJY");
function $04aba02155f8b286$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $dstGB.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $04aba02155f8b286$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}

});
parcelRegister("dstGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc4eaec711d4c42$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $9cc4eaec711d4c42$var$printed = {};
function $9cc4eaec711d4c42$export$2e2bcd8739ae039(message) {
    if ($9cc4eaec711d4c42$var$printed[message]) return;
    $9cc4eaec711d4c42$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});


parcelRegister("9itI1", function(module, exports) {

$parcel$export(module.exports, "R400", () => $6c4cd7158ce51afd$export$2010d0fb4295b346);
$parcel$export(module.exports, "B200", () => $6c4cd7158ce51afd$export$215b7063051591f1);
$parcel$export(module.exports, "N0", () => $6c4cd7158ce51afd$export$29a4f05edc054374);
$parcel$export(module.exports, "N30", () => $6c4cd7158ce51afd$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N500", () => $6c4cd7158ce51afd$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N800", () => $6c4cd7158ce51afd$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $6c4cd7158ce51afd$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N20A", () => $6c4cd7158ce51afd$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $6c4cd7158ce51afd$export$920c0d5c49070351);
$parcel$export(module.exports, "N60A", () => $6c4cd7158ce51afd$export$d2d3bedfb276cac0);
// Reds
var $6c4cd7158ce51afd$export$4b84fd0e2c617bd = "#FFEBE6";
var $6c4cd7158ce51afd$export$b34b069eff244586 = "#FFBDAD";
var $6c4cd7158ce51afd$export$be802dd0d8b57f35 = "#FF8F73";
var $6c4cd7158ce51afd$export$60847d42f9da92a6 = "#FF7452";
var $6c4cd7158ce51afd$export$4a7404f376229999 = "#FF5630";
var $6c4cd7158ce51afd$export$2010d0fb4295b346 = "#DE350B";
var $6c4cd7158ce51afd$export$2837b5a1a71d5c02 = "#BF2600";
var $6c4cd7158ce51afd$export$8d9596b529bbb9cf = "#FFFAE6";
var $6c4cd7158ce51afd$export$41060a744ab0b7ae = "#FFF0B3";
var $6c4cd7158ce51afd$export$1cc05bbbf340e559 = "#FFE380";
var $6c4cd7158ce51afd$export$5aae31392d72caaa = "#FFC400";
var $6c4cd7158ce51afd$export$c6930421db9fa514 = "#FFAB00";
var $6c4cd7158ce51afd$export$59619663aa6500fb = "#FF991F";
var $6c4cd7158ce51afd$export$874739ea9e379ab6 = "#FF8B00";
var $6c4cd7158ce51afd$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $6c4cd7158ce51afd$export$69a3bf21b9686c2b = "#ABF5D1";
var $6c4cd7158ce51afd$export$afbce1382ec95f73 = "#79F2C0";
var $6c4cd7158ce51afd$export$747d86715d4175de = "#57D9A3";
var $6c4cd7158ce51afd$export$940e1f69e873f202 = "#36B37E";
var $6c4cd7158ce51afd$export$a49394138f7b8e85 = "#00875A";
var $6c4cd7158ce51afd$export$6fa04827ac68a4fb = "#006644";
var $6c4cd7158ce51afd$export$226de0355ed012f8 = "#DEEBFF";
var $6c4cd7158ce51afd$export$8c13c2ee36917869 = "#B3D4FF";
var $6c4cd7158ce51afd$export$ecfc1dff386a3e7a = "#4C9AFF";
var $6c4cd7158ce51afd$export$215b7063051591f1 = "#2684FF";
var $6c4cd7158ce51afd$export$e62e8919cca44969 = "#0065FF";
var $6c4cd7158ce51afd$export$b3de0ae08da2ce64 = "#0052CC";
var $6c4cd7158ce51afd$export$a6ee3d71bc067634 = "#0747A6";
var $6c4cd7158ce51afd$export$67f15409e87642a1 = "#669DF1";
var $6c4cd7158ce51afd$export$f0539dbc42dbb067 = "#8FB8F6";
var $6c4cd7158ce51afd$export$363e4475840015bb = "#EAE6FF";
var $6c4cd7158ce51afd$export$4b0a4417ed59760f = "#C0B6F2";
var $6c4cd7158ce51afd$export$6011520a64d9a187 = "#998DD9";
var $6c4cd7158ce51afd$export$a7175d4e9206bc80 = "#8777D9";
var $6c4cd7158ce51afd$export$b48405b95304b5a1 = "#6554C0";
var $6c4cd7158ce51afd$export$c71e4279dd54a18d = "#5243AA";
var $6c4cd7158ce51afd$export$147899de772240ec = "#403294";
var $6c4cd7158ce51afd$export$2cf711fe14c66f06 = "#E6FCFF";
var $6c4cd7158ce51afd$export$7a8f4d33f6f9772c = "#B3F5FF";
var $6c4cd7158ce51afd$export$776c9c497ef08533 = "#79E2F2";
var $6c4cd7158ce51afd$export$69cb3ca10c1e330e = "#00C7E6";
var $6c4cd7158ce51afd$export$9dc1ef0f3f48059b = "#00B8D9";
var $6c4cd7158ce51afd$export$7c835c78b6fcdef8 = "#00A3BF";
var $6c4cd7158ce51afd$export$6036577f95c3877e = "#008DA6";
var $6c4cd7158ce51afd$export$29a4f05edc054374 = "#FFFFFF";
var $6c4cd7158ce51afd$export$e655ef011c4aa1a2 = "#FAFBFC";
var $6c4cd7158ce51afd$export$9fdfb749e33cdf97 = "#F4F5F7";
var $6c4cd7158ce51afd$export$3e51e8f1440314ba = "#EBECF0";
var $6c4cd7158ce51afd$export$1ce2d1575d444ceb = "#DFE1E6";
var $6c4cd7158ce51afd$export$8754fc7e6d8b3000 = "#C1C7D0";
var $6c4cd7158ce51afd$export$c2e91cbeada39b8b = "#B3BAC5";
var $6c4cd7158ce51afd$export$5f71e19f3a7ad9de = "#A5ADBA";
var $6c4cd7158ce51afd$export$eaa8c8a70ac22806 = "#97A0AF";
var $6c4cd7158ce51afd$export$7c87d337fb91a97d = "#8993A4";
var $6c4cd7158ce51afd$export$d6447c357493214f = "#7A869A";
var $6c4cd7158ce51afd$export$f563ee71e9ee74cd = "#6B778C";
var $6c4cd7158ce51afd$export$e2ef2124cf4024b1 = "#5E6C84";
var $6c4cd7158ce51afd$export$eece5f492e429f08 = "#505F79";
var $6c4cd7158ce51afd$export$c39c0fe0f26207ae = "#42526E";
var $6c4cd7158ce51afd$export$7090862dc3038a9f = "#344563";
var $6c4cd7158ce51afd$export$ad0bacf983b7ddaa = "#253858";
var $6c4cd7158ce51afd$export$7d61b15e0da132af = "#172B4D";
var $6c4cd7158ce51afd$export$fbda843f0a27fe96 = "#091E42";
var $6c4cd7158ce51afd$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $6c4cd7158ce51afd$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $6c4cd7158ce51afd$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $6c4cd7158ce51afd$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $6c4cd7158ce51afd$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $6c4cd7158ce51afd$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $6c4cd7158ce51afd$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $6c4cd7158ce51afd$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $6c4cd7158ce51afd$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $6c4cd7158ce51afd$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $6c4cd7158ce51afd$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $6c4cd7158ce51afd$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $6c4cd7158ce51afd$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $6c4cd7158ce51afd$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $6c4cd7158ce51afd$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $6c4cd7158ce51afd$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $6c4cd7158ce51afd$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $6c4cd7158ce51afd$export$2f6319cf7d736c2a = "#E6EDFA";
var $6c4cd7158ce51afd$export$95126bc8884d6634 = "#DCE5F5";
var $6c4cd7158ce51afd$export$8338d8c35d44ff1 = "#CED9EB";
var $6c4cd7158ce51afd$export$5368d76ae4fbbda7 = "#B8C7E0";
var $6c4cd7158ce51afd$export$9f0a771d16ec8d36 = "#ABBBD6";
var $6c4cd7158ce51afd$export$abcf8c38338b4aa5 = "#9FB0CC";
var $6c4cd7158ce51afd$export$97e81faa16a182c7 = "#8C9CB8";
var $6c4cd7158ce51afd$export$bfe21c59123ecf33 = "#7988A3";
var $6c4cd7158ce51afd$export$ee82aa2ea6a1558 = "#67758F";
var $6c4cd7158ce51afd$export$682927c6ed76be02 = "#56637A";
var $6c4cd7158ce51afd$export$91fd9994c5be9757 = "#455166";
var $6c4cd7158ce51afd$export$d281fbfe3cff2df6 = "#3B475C";
var $6c4cd7158ce51afd$export$3902c91d8b98a753 = "#313D52";
var $6c4cd7158ce51afd$export$8e8133c1ba5845b5 = "#283447";
var $6c4cd7158ce51afd$export$33ff357f6620b39 = "#202B3D";
var $6c4cd7158ce51afd$export$633847cf062b69e0 = "#1B2638";
var $6c4cd7158ce51afd$export$9776a6e503bdbf76 = "#121A29";
var $6c4cd7158ce51afd$export$6c813d5160dff5db = "#0E1624";
var $6c4cd7158ce51afd$export$3d4f271a500072a = "#0D1424";
var $6c4cd7158ce51afd$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $6c4cd7158ce51afd$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $6c4cd7158ce51afd$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $6c4cd7158ce51afd$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $6c4cd7158ce51afd$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $6c4cd7158ce51afd$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $6c4cd7158ce51afd$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $6c4cd7158ce51afd$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $6c4cd7158ce51afd$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $6c4cd7158ce51afd$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $6c4cd7158ce51afd$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $6c4cd7158ce51afd$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $6c4cd7158ce51afd$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $6c4cd7158ce51afd$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $6c4cd7158ce51afd$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $6c4cd7158ce51afd$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $6c4cd7158ce51afd$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $6c4cd7158ce51afd$export$d2adc5dedf09fced = "#292A2E";
var $6c4cd7158ce51afd$export$f51762073d2bb381 = "#94C748";
var $6c4cd7158ce51afd$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("iUSVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc58117ca9b386e1$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $g1536 = parcelRequire("g1536");

var $kQM5X = parcelRequire("kQM5X");

var $l8Mix = parcelRequire("l8Mix");

var $ea4YF = parcelRequire("ea4YF");

var $eijE5 = parcelRequire("eijE5");

var $1NLnE = parcelRequire("1NLnE");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");

var $7sxmN = parcelRequire("7sxmN");

var $9itI1 = parcelRequire("9itI1");

var $iLzeT = parcelRequire("iLzeT");

var $38Qyh = parcelRequire("38Qyh");

var $771ne = parcelRequire("771ne");

var $3OXAn = parcelRequire("3OXAn");

var $jAyT7 = parcelRequire("jAyT7");

var $4AKJg = parcelRequire("4AKJg");

var $39waV = parcelRequire("39waV");

var $cao2S = parcelRequire("cao2S");
var $dc58117ca9b386e1$var$dialogStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $9itI1.N0), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $9itI1.N900), ")")
}, (0, $iLzeT.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $9itI1.N0), ")")), "pointerEvents", "auto"), (0, $7sxmN.media).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $9itI1.N30A), ", 0 2px 1px ").concat((0, $9itI1.N30A), ", 0 0 20px -6px ").concat((0, $9itI1.N60A)), ")"),
    marginInlineEnd: "inherit",
    marginInlineStart: "inherit"
}), "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}));
var $dc58117ca9b386e1$var$viewportScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $7sxmN.media).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $dc58117ca9b386e1$var$bodyScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $7sxmN.media).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $dc58117ca9b386e1$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $l8Mix.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $acw62.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $iedos.combine)((0, $3OXAn.disableDraggingToCrossOriginIFramesForElement)(), (0, $4AKJg.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $jAyT7.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $kQM5X.default)((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $771ne.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $acw62.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        };
    }, [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $eijE5.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $eijE5.useLayering)(), currentLevel = _useLayering.currentLevel;
    return (0, $dnfL5.jsx)((0, $cao2S.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $dnfL5.jsx)((0, $38Qyh.ModalContext).Provider, {
        value: modalDialogContext
    }, (0, $dnfL5.jsx)((0, $38Qyh.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, (0, $dnfL5.jsx)((0, $1NLnE.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $dnfL5.jsx)((0, $ea4YF.default), null, (0, $dnfL5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $g1536.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-width": (0, $39waV.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-height": (0, $39waV.dialogHeight)(height)
            },
            css: [
                $dc58117ca9b386e1$var$dialogStyles,
                shouldScrollInViewport ? $dc58117ca9b386e1$var$viewportScrollStyles : $dc58117ca9b386e1$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dc58117ca9b386e1$export$2e2bcd8739ae039 = $dc58117ca9b386e1$var$ModalDialog;

});
parcelRegister("g1536", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba90a7f298064b31$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $ba90a7f298064b31$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("kQM5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ddf8aa2f3f77e7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $f2ddf8aa2f3f77e7$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("l8Mix", function(module, exports) {

$parcel$export(module.exports, "useId", () => $f63fcf54cac5d284$export$f680877a34711e37);
$parcel$export(module.exports, "useIdSeed", () => $f63fcf54cac5d284$export$6ee17796e3d70de2);

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $98BOi = parcelRequire("98BOi");

var $ltooA = parcelRequire("ltooA");
var $f63fcf54cac5d284$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $f63fcf54cac5d284$var$react18UseId = ($f63fcf54cac5d284$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $f63fcf54cac5d284$var$_React$useId !== void 0 ? $f63fcf54cac5d284$var$_React$useId : undefined;
function $f63fcf54cac5d284$export$f680877a34711e37() {
    if ($f63fcf54cac5d284$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) return $f63fcf54cac5d284$var$react18UseId();
    return "uid".concat((0, $98BOi.useUID)());
}
var $f63fcf54cac5d284$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($f63fcf54cac5d284$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $f63fcf54cac5d284$export$6ee17796e3d70de2() {
    if ($f63fcf54cac5d284$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        var uid = $f63fcf54cac5d284$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $98BOi.useUIDSeed)();
}

});
parcelRegister("98BOi", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $6a7230c059daf6a2$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $6a7230c059daf6a2$export$bb5ca5fba6fb4f1f);

var $acw62 = parcelRequire("acw62");

var $jd6WV = parcelRequire("jd6WV");
var $6a7230c059daf6a2$var$generateUID = function(context) {
    var quartz = context || (0, $jd6WV.counter);
    var prefix = (0, $jd6WV.getPrefix)(quartz);
    var id = (0, $jd6WV.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $6a7230c059daf6a2$var$useUIDState = function() {
    var context = (0, $acw62.useContext)((0, $jd6WV.source));
    var uid = (0, $acw62.useState)(function() {
        return $6a7230c059daf6a2$var$generateUID(context);
    })[0];
    return uid;
};
var $6a7230c059daf6a2$export$87d05f07e65211f1 = function() {
    var uid = $6a7230c059daf6a2$var$useUIDState().uid;
    return uid;
};
var $6a7230c059daf6a2$export$bb5ca5fba6fb4f1f = function() {
    var gen = $6a7230c059daf6a2$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("jd6WV", function(module, exports) {

$parcel$export(module.exports, "counter", () => $dfc49f3a847c5026$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $dfc49f3a847c5026$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $dfc49f3a847c5026$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $dfc49f3a847c5026$export$36e24695f02d4503);

var $acw62 = parcelRequire("acw62");

var $bvN7H = parcelRequire("bvN7H");
var $dfc49f3a847c5026$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $bvN7H.generateUID)()
    };
};
var $dfc49f3a847c5026$export$e575061ef2a070eb = $dfc49f3a847c5026$export$1921362e86c73c88();
var $dfc49f3a847c5026$export$b4d5da5f34fb77ad = $acw62.createContext($dfc49f3a847c5026$export$1921362e86c73c88());
var $dfc49f3a847c5026$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $dfc49f3a847c5026$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});
parcelRegister("bvN7H", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $8618b1cfcf017c84$export$bdbb4cbb3078e58d);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $8618b1cfcf017c84$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $8618b1cfcf017c84$export$e2a22331486dcca0 = $8618b1cfcf017c84$export$bdbb4cbb3078e58d();

});




parcelRegister("ea4YF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4f5dc4ab594823e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
var $a4f5dc4ab594823e$var$BORDER_WIDTH = 2;
var $a4f5dc4ab594823e$var$baseFocusOutsideStyles = (0, $dnfL5.css)({
    outline: "".concat($a4f5dc4ab594823e$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $a4f5dc4ab594823e$var$BORDER_WIDTH
});
var $a4f5dc4ab594823e$var$baseInsetStyles = (0, $dnfL5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$a4f5dc4ab594823e$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $a4f5dc4ab594823e$var$focusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $a4f5dc4ab594823e$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $a4f5dc4ab594823e$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $a4f5dc4ab594823e$var$insetFocusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $a4f5dc4ab594823e$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $a4f5dc4ab594823e$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $a4f5dc4ab594823e$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $a4f5dc4ab594823e$var$baseInsetStyles : $a4f5dc4ab594823e$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $a4f5dc4ab594823e$var$insetFocusRingStyles : $a4f5dc4ab594823e$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $dnfL5.jsx)((0, $dnfL5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$a4f5dc4ab594823e$var$FocusRing.displayName = "FocusRing";
var $a4f5dc4ab594823e$export$2e2bcd8739ae039 = $a4f5dc4ab594823e$var$FocusRing;

});

parcelRegister("eijE5", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $a681fc5531e93d20$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $a681fc5531e93d20$export$c8b4d54e03dee6ed);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $ltooA = parcelRequire("ltooA");

var $foCtm = parcelRequire("foCtm");
function $a681fc5531e93d20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a681fc5531e93d20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a681fc5531e93d20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a681fc5531e93d20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a681fc5531e93d20$var$ESCAPE = "Escape";
function $a681fc5531e93d20$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _useLayering = $a681fc5531e93d20$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $a681fc5531e93d20$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $a681fc5531e93d20$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $acw62.useContext)((0, $foCtm.LevelContext));
    var _useContext = (0, $acw62.useContext)((0, $foCtm.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        if ((0, $ltooA.fg)("layering-top-level-use-array")) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $a681fc5531e93d20$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $ltooA.fg)("layering-top-level-use-array") ? {
        layerList: layerList
    } : {});
}

});

parcelRegister("cXz1d", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("iedos")).combine);

var $iedos = parcelRequire("iedos");

});
parcelRegister("iedos", function(module, exports) {

$parcel$export(module.exports, "combine", () => $d453ec773833617e$export$1be1fc439b849fdf);
/** Create a new combined function that will call all the provided functions */ function $d453ec773833617e$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("7sxmN", function(module, exports) {

$parcel$export(module.exports, "media", () => $56e507d4c59c7bf6$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $56e507d4c59c7bf6$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $56e507d4c59c7bf6$export$c881183ca713c214 = $56e507d4c59c7bf6$export$987d49ffe1b0900f;

});

parcelRegister("iLzeT", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $da97f38dcc1a1963$export$9d7b58831ae93caa);
var $da97f38dcc1a1963$export$4ef52930e33717cd = "data-theme";
var $da97f38dcc1a1963$export$a00eac3f8684bcd0 = "data-color-mode";
var $da97f38dcc1a1963$export$2112803007239c61 = "data-contrast-mode";
var $da97f38dcc1a1963$export$352e418ed5b6193a = "data-custom-theme";
var $da97f38dcc1a1963$export$6f0c6fb8c80fcc92 = "ds";
var $da97f38dcc1a1963$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $da97f38dcc1a1963$export$dddac1532e822863 = "--".concat($da97f38dcc1a1963$export$6f0c6fb8c80fcc92, "-token-not-found");
var $da97f38dcc1a1963$export$9d7b58831ae93caa = "--".concat($da97f38dcc1a1963$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("38Qyh", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $249ae22a89a70afc$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $249ae22a89a70afc$export$dece24112a937f92);

var $acw62 = parcelRequire("acw62");
var $249ae22a89a70afc$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $249ae22a89a70afc$export$dece24112a937f92 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});

parcelRegister("771ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $52da40a66553bcaf$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $52da40a66553bcaf$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $acw62.useRef)(null);
    var onMotionFinish = (0, $acw62.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("3OXAn", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $2c84431bae0ab11d$export$ec28e97c7d8b1b35);

var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("lLUpG");
var $9eYWs = parcelRequire("9eYWs");

var $fIk2e = parcelRequire("fIk2e");
function $2c84431bae0ab11d$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: "pointerdown",
            listener: stop
        },
        {
            // The user did not start a drag
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: "dragstart",
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $9eYWs.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor);
}
function $2c84431bae0ab11d$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $2c84431bae0ab11d$var$api = (0, $fIk2e.makeFixForAdapter)({
    watchForInteractionStart: $2c84431bae0ab11d$var$watchForInteractionStart,
    watchForInteractionEnd: $2c84431bae0ab11d$var$watchForInteractionEnd
});
function $2c84431bae0ab11d$export$ec28e97c7d8b1b35() {
    return $2c84431bae0ab11d$var$api.registerUsage();
}

});
parcelRegister("lLUpG", function(module, exports) {

$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("9eYWs")).monitorForElements);

var $9eYWs = parcelRequire("9eYWs");
 // Payload for the draggable being dragged

});
parcelRegister("9eYWs", function(module, exports) {

$parcel$export(module.exports, "monitorForElements", () => $6ba4b1aafdc6c74e$export$59a074bac4c54f54);

var $02Ztr = parcelRequire("02Ztr");

var $8fY35 = parcelRequire("8fY35");

var $kk6Dv = parcelRequire("kk6Dv");

var $6QCyH = parcelRequire("6QCyH");

var $6WHuD = parcelRequire("6WHuD");

var $iedos = parcelRequire("iedos");

var $deJG5 = parcelRequire("deJG5");

var $axaCz = parcelRequire("axaCz");

var $6AMEG = parcelRequire("6AMEG");

var $5ZupI = parcelRequire("5ZupI");

var $sJ9rD = parcelRequire("sJ9rD");

var $hZyk4 = parcelRequire("hZyk4");

var $kBeST = parcelRequire("kBeST");
var $6ba4b1aafdc6c74e$var$draggableRegistry = new WeakMap();
function $6ba4b1aafdc6c74e$var$addToRegistry(args) {
    $6ba4b1aafdc6c74e$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $6ba4b1aafdc6c74e$var$draggableRegistry.delete(args.element);
    };
}
var $6ba4b1aafdc6c74e$var$honeyPotFix = (0, $6QCyH.makeHoneyPotFix)();
var $6ba4b1aafdc6c74e$var$adapter = (0, $6WHuD.makeAdapter)({
    typeKey: "element",
    defaultDropEffect: "move",
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $iedos.combine)($6ba4b1aafdc6c74e$var$honeyPotFix.bindEvents(), (0, $8fY35.bind)(document, {
            type: "dragstart",
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $6ba4b1aafdc6c74e$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $5ZupI.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $kk6Dv.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : "");
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $6AMEG.isAndroid)() && !event.dataTransfer.types.includes((0, $sJ9rD.textMediaType)) && !event.dataTransfer.types.includes((0, $hZyk4.URLMediaType))) event.dataTransfer.setData((0, $sJ9rD.textMediaType), (0, $6AMEG.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $kBeST.elementAdapterNativeDataKey), "");
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: "element",
                    payload: payload,
                    startedFrom: "internal"
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $6ba4b1aafdc6c74e$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $6ba4b1aafdc6c74e$var$honeyPotFix.getOnPostDispatch()
});
var $6ba4b1aafdc6c74e$export$e7140b68045b5036 = $6ba4b1aafdc6c74e$var$adapter.dropTarget;
var $6ba4b1aafdc6c74e$export$59a074bac4c54f54 = $6ba4b1aafdc6c74e$var$adapter.monitor;
function $6ba4b1aafdc6c74e$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $iedos.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $6ba4b1aafdc6c74e$var$adapter.registerUsage(), $6ba4b1aafdc6c74e$var$addToRegistry(args), (0, $axaCz.addAttribute)(args.element, {
        attribute: "draggable",
        value: "true"
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $deJG5.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("kk6Dv", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $ecbad2b94d3ba5d7$export$81d0353f25f5dd);

var $02Ztr = parcelRequire("02Ztr");

var $3s8a4 = parcelRequire("3s8a4");
function $ecbad2b94d3ba5d7$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $3s8a4.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("3s8a4", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $283a5152aff51e26$export$821bdcd739a2706b);

var $7Oabr = parcelRequire("7Oabr");
function $283a5152aff51e26$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $7Oabr.honeyPotDataAttribute));
}

});
parcelRegister("7Oabr", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", () => $5af51a2135a003ac$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $5af51a2135a003ac$export$6eafea55f7947469 = "data-pdnd-honey-pot";

});



parcelRegister("6QCyH", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $4fc58260d57fd988$export$8ecad27c959e89e0);

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $d2wQL = parcelRequire("d2wQL");

var $7Oabr = parcelRequire("7Oabr");
function $4fc58260d57fd988$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fc58260d57fd988$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fc58260d57fd988$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fc58260d57fd988$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4fc58260d57fd988$var$honeyPotSize = 2;
var $4fc58260d57fd988$var$halfHoneyPotSize = $4fc58260d57fd988$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $4fc58260d57fd988$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $4fc58260d57fd988$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $4fc58260d57fd988$var$halfHoneyPotSize,
        y: point.y - $4fc58260d57fd988$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4fc58260d57fd988$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4fc58260d57fd988$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $4fc58260d57fd988$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $4fc58260d57fd988$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $4fc58260d57fd988$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $4fc58260d57fd988$var$preventGoingForwardsOffScreen($4fc58260d57fd988$var$preventGoingBackwardsOffScreen($4fc58260d57fd988$var$pullBackByHalfHoneyPotSize($4fc58260d57fd988$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $4fc58260d57fd988$var$honeyPotSize,
        height: $4fc58260d57fd988$var$honeyPotSize
    });
}
function $4fc58260d57fd988$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $4fc58260d57fd988$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $4fc58260d57fd988$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement("div");
    element.setAttribute((0, $7Oabr.honeyPotDataAttribute), "true");
    // can shift during the drag thanks to Firefox
    var clientRect = $4fc58260d57fd988$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $4fc58260d57fd988$var$_objectSpread($4fc58260d57fd988$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: "transparent",
        position: "fixed",
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: "border-box"
    }, $4fc58260d57fd988$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: "auto",
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $d2wQL.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $8fY35.bind)(window, {
        type: "pointermove",
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $4fc58260d57fd988$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $4fc58260d57fd988$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($4fc58260d57fd988$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $8fY35.bindAll)(window, [
            {
                type: "pointerdown",
                listener: cleanup
            },
            {
                type: "pointermove",
                listener: cleanup
            },
            {
                type: "focusin",
                listener: cleanup
            },
            {
                type: "focusout",
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: "dragstart",
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: "dragenter",
                listener: cleanup
            },
            {
                type: "dragover",
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $4fc58260d57fd988$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $8fY35.bind)(window, {
            type: "pointermove",
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === "onDragStart") {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $4fc58260d57fd988$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === "onDrop") {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("d2wQL", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", () => $97e4f199c1b7193b$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $97e4f199c1b7193b$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("6WHuD", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $50e9e5adc7c613fd$export$2aa3a33160990d96);

var $bWDmX = parcelRequire("bWDmX");

var $jfTID = parcelRequire("jfTID");

var $2mqZv = parcelRequire("2mqZv");

var $i1b4Y = parcelRequire("i1b4Y");
function $50e9e5adc7c613fd$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $i1b4Y.makeMonitor)();
    var dropTargetAPI = (0, $2mqZv.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $bWDmX.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $bWDmX.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $jfTID.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("bWDmX", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $8b23a668efba0488$export$3efdceeb8ca25c51);

var $fUHKi = parcelRequire("fUHKi");

var $8fY35 = parcelRequire("8fY35");

var $kk6Dv = parcelRequire("kk6Dv");

var $3s8a4 = parcelRequire("3s8a4");

var $ac4A8 = parcelRequire("ac4A8");

var $guUqI = parcelRequire("guUqI");

var $5ZupI = parcelRequire("5ZupI");

var $dY2vp = parcelRequire("dY2vp");
var $8b23a668efba0488$var$globalState = {
    isActive: false
};
function $8b23a668efba0488$var$canStart() {
    return !$8b23a668efba0488$var$globalState.isActive;
}
function $8b23a668efba0488$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $8b23a668efba0488$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $8b23a668efba0488$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$8b23a668efba0488$var$canStart()) return;
    var initial = $8b23a668efba0488$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $8b23a668efba0488$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $8b23a668efba0488$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $dY2vp.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $8b23a668efba0488$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $5ZupI.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $3s8a4.isHoneyPotElement)(event.target) ? (0, $kk6Dv.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $8b23a668efba0488$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $8b23a668efba0488$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: "dragover",
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: "dragenter",
            listener: onUpdateEvent
        },
        {
            type: "dragleave",
            listener: function listener(event) {
                if (!(0, $ac4A8.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === "external") cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: "drop",
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $5ZupI.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $8b23a668efba0488$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === "external" ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: "dragend",
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $5ZupI.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $guUqI.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $8b23a668efba0488$var$getNativeSetDragImage(event)
    });
}
function $8b23a668efba0488$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $8b23a668efba0488$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $5ZupI.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === "external") return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $8b23a668efba0488$export$3efdceeb8ca25c51 = {
    canStart: $8b23a668efba0488$var$canStart,
    start: $8b23a668efba0488$var$start
};

});
parcelRegister("ac4A8", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $76be943fd292ee18$export$57d220c74e84a273);

var $6enBj = parcelRequire("6enBj");

var $iXb9E = parcelRequire("iXb9E");

var $fCUWk = parcelRequire("fCUWk");

var $kVTd4 = parcelRequire("kVTd4");
function $76be943fd292ee18$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== "dragleave") return false;
    if ((0, $iXb9E.isSafari)()) return (0, $fCUWk.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $6enBj.isFirefox)()) return (0, $kVTd4.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("6enBj", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $48965b868d61cb9c$export$b7d78993b74f766d);

var $deJG5 = parcelRequire("deJG5");
var $48965b868d61cb9c$export$b7d78993b74f766d = (0, $deJG5.once)(function isFirefox() {
    return navigator.userAgent.includes("Firefox");
});

});
parcelRegister("deJG5", function(module, exports) {

$parcel$export(module.exports, "once", () => $9a3003d7f2341560$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $9a3003d7f2341560$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("iXb9E", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $dcc663c8d046b643$export$95df08bae54cb4df);

var $deJG5 = parcelRequire("deJG5");
var $dcc663c8d046b643$export$95df08bae54cb4df = (0, $deJG5.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes("AppleWebKit") && !userAgent.includes("Chrome");
});

});

parcelRegister("fCUWk", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $b60692aace78371d$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $b60692aace78371d$export$f21837c338005454);

var $8fY35 = parcelRequire("8fY35");

var $iXb9E = parcelRequire("iXb9E");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $b60692aace78371d$var$symbols = {
    isLeavingWindow: Symbol("leaving"),
    isEnteringWindow: Symbol("entering")
};
function $b60692aace78371d$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $iXb9E.isSafari)()) return false;
    return dragEnter.hasOwnProperty($b60692aace78371d$var$symbols.isEnteringWindow);
}
function $b60692aace78371d$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $iXb9E.isSafari)()) return false;
    return dragLeave.hasOwnProperty($b60692aace78371d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === "undefined") return;
    if (!(0, $iXb9E.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: "drop",
            listener: resetState
        },
        {
            type: "dragend",
            listener: resetState
        },
        {
            type: "dragenter",
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$b60692aace78371d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: "dragleave",
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$b60692aace78371d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("kVTd4", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $f3d3f50eeb4a63d6$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $f3d3f50eeb4a63d6$var$isNodeLike(target) {
    return "nodeName" in target;
}
function $f3d3f50eeb4a63d6$export$e46810fef53b5b0e(eventTarget) {
    return $f3d3f50eeb4a63d6$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("guUqI", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $c02b3882c40dbd96$export$ac5e5b0daf997b2);
function $c02b3882c40dbd96$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: "pointerdown",
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("5ZupI", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $45ca3dcf5eb7145b$export$7c112ceec8941e67);
function $45ca3dcf5eb7145b$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("dY2vp", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $a2b2d2813eb5c722$export$9f13ecc44e83d682);

var $ciU3d = parcelRequire("ciU3d");
var $a2b2d2813eb5c722$var$scheduleOnDrag = (0, $ciU3d.default)(function(fn) {
    return fn();
});
var $a2b2d2813eb5c722$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $a2b2d2813eb5c722$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: "onGenerateDragPreview",
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $a2b2d2813eb5c722$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: "onDragStart",
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $a2b2d2813eb5c722$var$dragStart.flush();
            $a2b2d2813eb5c722$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: "onDropTargetChange",
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $a2b2d2813eb5c722$var$scheduleOnDrag(function() {
                $a2b2d2813eb5c722$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: "onDrag",
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $a2b2d2813eb5c722$var$dragStart.flush();
            $a2b2d2813eb5c722$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: "onDrop",
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("ciU3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f52a5054f09a665$export$2e2bcd8739ae039);
var $8f52a5054f09a665$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8f52a5054f09a665$export$2e2bcd8739ae039 = $8f52a5054f09a665$var$rafSchd;

});



parcelRegister("jfTID", function(module, exports) {

$parcel$export(module.exports, "register", () => $e04aa3a457000d64$export$6503ec6e8aabbaf);
// Extending `Map` to allow us to link Key and Values together
var $e04aa3a457000d64$var$ledger = new Map();
function $e04aa3a457000d64$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $e04aa3a457000d64$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $e04aa3a457000d64$var$ledger.set(typeKey, initial);
    return initial;
}
function $e04aa3a457000d64$export$6503ec6e8aabbaf(args) {
    var entry = $e04aa3a457000d64$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $e04aa3a457000d64$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("2mqZv", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $1b8292b88c4a57a8$export$47d10e7bd9c81890);

var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");

var $iedos = parcelRequire("iedos");

var $deJG5 = parcelRequire("deJG5");

var $axaCz = parcelRequire("axaCz");
function $1b8292b88c4a57a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8292b88c4a57a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8292b88c4a57a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8292b88c4a57a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8292b88c4a57a8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1b8292b88c4a57a8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1b8292b88c4a57a8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1b8292b88c4a57a8$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $1b8292b88c4a57a8$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $iedos.combine)((0, $axaCz.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: "true"
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $deJG5.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $1b8292b88c4a57a8$var$copyReverse(current);
        var actualCaptureOrdered = $1b8292b88c4a57a8$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $1b8292b88c4a57a8$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("axaCz", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $7ab53996d2b59441$export$5dcb5c23b6ba980a);
function $7ab53996d2b59441$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("i1b4Y", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $d1e0ea191414d51e$export$5dd4ed888d5b12ca);

var $g5Zhu = parcelRequire("g5Zhu");

var $deJG5 = parcelRequire("deJG5");
function $d1e0ea191414d51e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d1e0ea191414d51e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d1e0ea191414d51e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d1e0ea191414d51e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d1e0ea191414d51e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d1e0ea191414d51e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d1e0ea191414d51e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1e0ea191414d51e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1e0ea191414d51e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1e0ea191414d51e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1e0ea191414d51e$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $d1e0ea191414d51e$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $deJG5.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === "onGenerateDragPreview") {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $d1e0ea191414d51e$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === "onDrop") {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("6AMEG", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $4ccbd8c1d4cf98a2$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $4ccbd8c1d4cf98a2$export$aceb3ed8b7f7bd2c);

var $deJG5 = parcelRequire("deJG5");
var $4ccbd8c1d4cf98a2$export$a11b0059900ceec8 = (0, $deJG5.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes("android");
});
var $4ccbd8c1d4cf98a2$export$aceb3ed8b7f7bd2c = "pdnd:android-fallback";

});

parcelRegister("sJ9rD", function(module, exports) {

$parcel$export(module.exports, "textMediaType", () => $0565a3c110eeed03$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $0565a3c110eeed03$export$fd3d00026297c0ad = "text/plain";

});

parcelRegister("hZyk4", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", () => $d192c1f59100e50e$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $d192c1f59100e50e$export$4c44a460f123106 = "text/uri-list";

});

parcelRegister("kBeST", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $eff2cf0ca066f9dd$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $eff2cf0ca066f9dd$export$c9c4cc54e73b125d = "application/vnd.pdnd";

});



parcelRegister("fIk2e", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", () => $b70a819d19a5dd63$export$a74bff2507e6126b);

var $fUHKi = parcelRequire("fUHKi");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $b70a819d19a5dd63$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? "" : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $b70a819d19a5dd63$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $b70a819d19a5dd63$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith("data:")) return false;
    return !$b70a819d19a5dd63$var$hasSameOrigin(window.location.href, iframe.src);
}
var $b70a819d19a5dd63$var$registry = new Map();
function $b70a819d19a5dd63$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll("iframe")).filter($b70a819d19a5dd63$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $b70a819d19a5dd63$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $b70a819d19a5dd63$var$setStyle(iframe, {
                    property: "pointer-events",
                    rule: "none",
                    priority: "important"
                }),
                count: 1
            };
            $b70a819d19a5dd63$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $b70a819d19a5dd63$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $iedos.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $b70a819d19a5dd63$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $b70a819d19a5dd63$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("jAyT7", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $e42c71294e6c9b6a$export$27d79116d3a4e7d5);
parcelRequire("6oVK7");
var $2IBLj = parcelRequire("2IBLj");

var $fIk2e = parcelRequire("fIk2e");
function $e42c71294e6c9b6a$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $2IBLj.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $e42c71294e6c9b6a$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $2IBLj.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $e42c71294e6c9b6a$var$api = (0, $fIk2e.makeFixForAdapter)({
    watchForInteractionStart: $e42c71294e6c9b6a$var$watchForInteractionStart,
    watchForInteractionEnd: $e42c71294e6c9b6a$var$watchForInteractionEnd
});
function $e42c71294e6c9b6a$export$27d79116d3a4e7d5() {
    return $e42c71294e6c9b6a$var$api.registerUsage();
}

});
parcelRegister("6oVK7", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("2IBLj")).monitorForExternal);

var $2IBLj = parcelRequire("2IBLj");
 // The data that is being dragged

});
parcelRegister("2IBLj", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => $1facfb95e9b24d1e$export$bb1740f3194979c1);

var $fUHKi = parcelRequire("fUHKi");

var $8fY35 = parcelRequire("8fY35");

var $6WHuD = parcelRequire("6WHuD");

var $6AMEG = parcelRequire("6AMEG");

var $36MzF = parcelRequire("36MzF");

var $guUqI = parcelRequire("guUqI");

var $sJ9rD = parcelRequire("sJ9rD");

var $kBeST = parcelRequire("kBeST");
function $1facfb95e9b24d1e$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $kBeST.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $sJ9rD.textMediaType) && value === (0, $6AMEG.androidFallbackText)) return false;
    return true;
}
function $1facfb95e9b24d1e$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $1facfb95e9b24d1e$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $1facfb95e9b24d1e$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === "file" || $1facfb95e9b24d1e$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $1facfb95e9b24d1e$var$didDragStartLocally = false;
var $1facfb95e9b24d1e$var$adapter = (0, $6WHuD.makeAdapter)({
    typeKey: "external",
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: "copy",
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $8fY35.bind)(window, {
            type: "dragenter",
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($1facfb95e9b24d1e$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $36MzF.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $1facfb95e9b24d1e$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: "external",
                        startedFrom: "external",
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $1facfb95e9b24d1e$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$1facfb95e9b24d1e$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $1facfb95e9b24d1e$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $1facfb95e9b24d1e$var$adapter.dropTarget(args);
}
function $1facfb95e9b24d1e$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $1facfb95e9b24d1e$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === "undefined") return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $1facfb95e9b24d1e$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: "idle"
    };
    var state = idle;
    function clear() {
        if (state.type !== "dragging") return;
        $1facfb95e9b24d1e$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "dragend",
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $guUqI.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $8fY35.bind)(window, {
        type: "dragstart",
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== "idle") return;
            // set our global flag
            $1facfb95e9b24d1e$var$didDragStartLocally = true;
            state = {
                type: "dragging",
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("36MzF", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", () => $24379c7d8f4fe1c5$export$d1c6f249e893cdf4);

var $6enBj = parcelRequire("6enBj");

var $iXb9E = parcelRequire("iXb9E");

var $fCUWk = parcelRequire("fCUWk");

var $kVTd4 = parcelRequire("kVTd4");
function $24379c7d8f4fe1c5$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== "dragenter") return false;
    if ((0, $iXb9E.isSafari)()) return (0, $fCUWk.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $6enBj.isFirefox)()) return (0, $kVTd4.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("4AKJg", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $357ec5a0b5a72a43$export$9c0606fcefb5d1e2);

var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("4Gj2B");
var $gzujt = parcelRequire("gzujt");

var $fIk2e = parcelRequire("fIk2e");
function $357ec5a0b5a72a43$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // User is starting another interaction
            type: "pointerdown",
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            type: "dragstart",
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $gzujt.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $357ec5a0b5a72a43$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $357ec5a0b5a72a43$var$api = (0, $fIk2e.makeFixForAdapter)({
    watchForInteractionStart: $357ec5a0b5a72a43$var$watchForInteractionStart,
    watchForInteractionEnd: $357ec5a0b5a72a43$var$watchForInteractionEnd
});
function $357ec5a0b5a72a43$export$9c0606fcefb5d1e2() {
    return $357ec5a0b5a72a43$var$api.registerUsage();
}

});
parcelRegister("4Gj2B", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("gzujt")).monitorForTextSelection);

var $gzujt = parcelRequire("gzujt");
 // Payload for the text selection being dragged

});
parcelRegister("gzujt", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => $c1076dc7700d1760$export$2e178e3647f5e6e9);

var $8fY35 = parcelRequire("8fY35");

var $6QCyH = parcelRequire("6QCyH");

var $6WHuD = parcelRequire("6WHuD");

var $iedos = parcelRequire("iedos");

var $iXb9E = parcelRequire("iXb9E");

var $fHgUL = parcelRequire("fHgUL");

var $sJ9rD = parcelRequire("sJ9rD");

var $kBeST = parcelRequire("kBeST");
function $c1076dc7700d1760$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $iXb9E.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $sJ9rD.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $c1076dc7700d1760$var$honeyPotFix = (0, $6QCyH.makeHoneyPotFix)();
var $c1076dc7700d1760$var$adapter = (0, $6WHuD.makeAdapter)({
    typeKey: "text-selection",
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: "copy",
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $iedos.combine)($c1076dc7700d1760$var$honeyPotFix.bindEvents(), (0, $8fY35.bind)(window, {
            type: "dragstart",
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $kBeST.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $sJ9rD.textMediaType))) return;
                var target = $c1076dc7700d1760$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $sJ9rD.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $fHgUL.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: "text-selection",
                        startedFrom: "internal",
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $c1076dc7700d1760$var$honeyPotFix.getOnPostDispatch()
});
function $c1076dc7700d1760$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $c1076dc7700d1760$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === "undefined") return;
    $c1076dc7700d1760$var$adapter.registerUsage();
})();
function $c1076dc7700d1760$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $c1076dc7700d1760$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("fHgUL", function(module, exports) {

$parcel$export(module.exports, "HTMLMediaType", () => $b6d7fe08f1b93598$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $b6d7fe08f1b93598$export$338a9f6c7a1f02b0 = "text/html";

});




parcelRegister("39waV", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $24bb2bb6129bfd9e$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $24bb2bb6129bfd9e$export$ceba93bf0bdd16f2);
var $24bb2bb6129bfd9e$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $24bb2bb6129bfd9e$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = $24bb2bb6129bfd9e$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($24bb2bb6129bfd9e$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $24bb2bb6129bfd9e$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};

});

parcelRegister("cao2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db91219471cdf49$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $7hYes = parcelRequire("7hYes");

var $fZQEc = parcelRequire("fZQEc");

var $7sxmN = parcelRequire("7sxmN");

var $kRSiU = parcelRequire("kRSiU");
var $8db91219471cdf49$var$gutter = 60;
var $8db91219471cdf49$var$maxWidthDimensions = "calc(100vw - ".concat($8db91219471cdf49$var$gutter * 2, "px)");
var $8db91219471cdf49$var$maxHeightDimensions = "calc(100vh - ".concat($8db91219471cdf49$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $8db91219471cdf49$var$positionerStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $kRSiU.layers).modal(),
    flexDirection: "column",
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $8db91219471cdf49$var$viewportScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    height: "auto",
    position: "relative"
}, (0, $7sxmN.media).above.xs, {
    margin: "".concat($8db91219471cdf49$var$gutter, "px auto"),
    pointerEvents: "none"
}));
var $8db91219471cdf49$var$bodyScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $7sxmN.media).above.xs, {
    maxWidth: $8db91219471cdf49$var$maxWidthDimensions,
    maxHeight: $8db91219471cdf49$var$maxHeightDimensions,
    position: "absolute",
    insetBlockStart: "".concat($8db91219471cdf49$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    pointerEvents: "none"
}));
var $8db91219471cdf49$var$stackTransitionStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $fZQEc.durations).medium, "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $7hYes.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $8db91219471cdf49$var$stackTransformStyles = (0, $dnfL5.css)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $8db91219471cdf49$var$stackIdleStyles = (0, $dnfL5.css)({
    transform: "none"
});
var $8db91219471cdf49$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $dnfL5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--modal-dialog-translate-y": "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $8db91219471cdf49$var$positionerStyles,
            $8db91219471cdf49$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $8db91219471cdf49$var$stackTransformStyles : $8db91219471cdf49$var$stackIdleStyles,
            shouldScrollInViewport ? $8db91219471cdf49$var$viewportScrollStyles : $8db91219471cdf49$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8db91219471cdf49$export$2e2bcd8739ae039 = $8db91219471cdf49$var$Positioner;

});
parcelRegister("7hYes", function(module, exports) {

$parcel$export(module.exports, "easeInOut", () => $54e8d7ce42cfd12b$export$c07234257a03d5e9);
var $54e8d7ce42cfd12b$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $54e8d7ce42cfd12b$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $54e8d7ce42cfd12b$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";
var $54e8d7ce42cfd12b$export$fc825baa2ef870d0 = "cubic-bezier(0.4,0,0,1)";
var $54e8d7ce42cfd12b$export$816ee5d79b5bd9a5 = "cubic-bezier(0.6,0,0,1)";
var $54e8d7ce42cfd12b$export$53ce3390a1a8f2a2 = "cubic-bezier(0.8,0,0,1)";
var $54e8d7ce42cfd12b$export$45db2fc2f15997e7 = "cubic-bezier(0,0,1,1)";

});



parcelRegister("lvAPw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa890feb48f8f8ac$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jVviY = parcelRequire("jVviY");

var $g64ZQ = parcelRequire("g64ZQ");

var $5yDp6 = parcelRequire("5yDp6");

var $ocesl = parcelRequire("ocesl");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $fa890feb48f8f8ac$var$modalStackRegister = [];
function $fa890feb48f8f8ac$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $ocesl.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $5yDp6.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $g64ZQ.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $jVviY.default)(function() {
        var newStackIndex = $fa890feb48f8f8ac$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $acw62.useEffect)(function() {
        var currentStackIndex = $fa890feb48f8f8ac$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $fa890feb48f8f8ac$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $fa890feb48f8f8ac$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $fa890feb48f8f8ac$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $fa890feb48f8f8ac$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $fa890feb48f8f8ac$var$modalStackRegister.splice(currentStackIndex, 1);
                $fa890feb48f8f8ac$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $acw62.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("jVviY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e81b9fb52922b9f2$export$2e2bcd8739ae039);

var $bZsgk = parcelRequire("bZsgk");
function $e81b9fb52922b9f2$export$2e2bcd8739ae039(callback) {
    var ref = (0, $bZsgk.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("bZsgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bab508de3aa2c22$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $8bab508de3aa2c22$var$uniqueReferencedValue = {};
function $8bab508de3aa2c22$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $acw62.useRef)($8bab508de3aa2c22$var$uniqueReferencedValue);
    if (ref.current === $8bab508de3aa2c22$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("g64ZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8115140b45c252$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $bb8115140b45c252$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("5yDp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $40beb1884da81b44$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $40beb1884da81b44$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $acw62.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("51SSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a979da27c569a7f$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $3a979da27c569a7f$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $3a979da27c569a7f$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $acw62.useLayoutEffect)(function() {
        setScrollTopOffset($3a979da27c569a7f$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $acw62.useCallback)(function() {
        if ($3a979da27c569a7f$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("d3iWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $980a4076f7f390f8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $ocesl = parcelRequire("ocesl");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $980a4076f7f390f8$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ocesl.default), {
        appear: true
    }, props.children);
};
var $980a4076f7f390f8$export$2e2bcd8739ae039 = $980a4076f7f390f8$var$ModalTransition;

});

parcelRegister("diRzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9af6821d9c91fd73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $iOqRO = parcelRequire("iOqRO");
var $fs8lP = parcelRequire("fs8lP");
var $jHXsO = parcelRequire("jHXsO");

var $fn3nv = parcelRequire("fn3nv");

var $2CLkt = parcelRequire("2CLkt");
var $9af6821d9c91fd73$var$headerStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
var $9af6821d9c91fd73$var$gridStyles = (0, $jHXsO.xcss)({
    width: "100%"
});
var $9af6821d9c91fd73$var$closeContainerStyles = (0, $jHXsO.xcss)({
    gridArea: "close"
});
var $9af6821d9c91fd73$var$titleContainerStyles = (0, $jHXsO.xcss)({
    gridArea: "title"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $9af6821d9c91fd73$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $2CLkt.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return (0, $dnfL5.jsx)("div", {
        css: $9af6821d9c91fd73$var$headerStyles,
        "data-testid": testId
    }, shouldShowCloseButton ? (0, $dnfL5.jsx)((0, $fs8lP.default), {
        gap: "space.200",
        templateAreas: [
            "title close"
        ],
        xcss: $9af6821d9c91fd73$var$gridStyles
    }, (0, $dnfL5.jsx)((0, $iOqRO.default), {
        xcss: $9af6821d9c91fd73$var$titleContainerStyles,
        justifyContent: "start",
        alignItems: "center"
    }, children), (0, $dnfL5.jsx)((0, $iOqRO.default), {
        xcss: $9af6821d9c91fd73$var$closeContainerStyles,
        justifyContent: "end"
    }, (0, $dnfL5.jsx)((0, $fn3nv.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    }))) : children);
};
var $9af6821d9c91fd73$export$2e2bcd8739ae039 = $9af6821d9c91fd73$var$ModalHeader;

});
parcelRegister("iOqRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $db21bcb2cd46387a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $9LxfM = parcelRequire("9LxfM");

var $jHXsO = parcelRequire("jHXsO");
var $db21bcb2cd46387a$var$justifyContentMap = {
    start: (0, $dnfL5.css)({
        justifyContent: "start"
    }),
    center: (0, $dnfL5.css)({
        justifyContent: "center"
    }),
    end: (0, $dnfL5.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $dnfL5.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $dnfL5.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $dnfL5.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $dnfL5.css)({
        justifyContent: "stretch"
    })
};
var $db21bcb2cd46387a$var$flexDirectionMap = {
    column: (0, $dnfL5.css)({
        flexDirection: "column"
    }),
    row: (0, $dnfL5.css)({
        flexDirection: "row"
    })
};
var $db21bcb2cd46387a$var$flexWrapMap = {
    wrap: (0, $dnfL5.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $dnfL5.css)({
        flexWrap: "nowrap"
    })
};
var $db21bcb2cd46387a$var$alignItemsMap = {
    start: (0, $dnfL5.css)({
        alignItems: "start"
    }),
    center: (0, $dnfL5.css)({
        alignItems: "center"
    }),
    baseline: (0, $dnfL5.css)({
        alignItems: "baseline"
    }),
    end: (0, $dnfL5.css)({
        alignItems: "end"
    }),
    stretch: (0, $dnfL5.css)({
        alignItems: "stretch"
    })
};
var $db21bcb2cd46387a$var$baseStyles = (0, $dnfL5.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $db21bcb2cd46387a$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $jHXsO.parseXcss)(xcss);
    return (0, $dnfL5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $db21bcb2cd46387a$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9LxfM.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9LxfM.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9LxfM.spaceStylesMap).rowGap[rowGap],
            alignItems && $db21bcb2cd46387a$var$alignItemsMap[alignItems],
            direction && $db21bcb2cd46387a$var$flexDirectionMap[direction],
            justifyContent && $db21bcb2cd46387a$var$justifyContentMap[justifyContent],
            wrap && $db21bcb2cd46387a$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$db21bcb2cd46387a$var$Flex.displayName = "Flex";
var $db21bcb2cd46387a$export$2e2bcd8739ae039 = $db21bcb2cd46387a$var$Flex;

});
parcelRegister("9LxfM", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $71c24c519808a968$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $71c24c519808a968$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $71c24c519808a968$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $71c24c519808a968$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $71c24c519808a968$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $71c24c519808a968$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $71c24c519808a968$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $71c24c519808a968$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $71c24c519808a968$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $71c24c519808a968$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $71c24c519808a968$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $71c24c519808a968$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $71c24c519808a968$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $71c24c519808a968$export$3c7e9587132614b4);
$parcel$export(module.exports, "spaceStylesMap", () => $71c24c519808a968$export$bf46c3f9eeafc71f);

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $2coum = parcelRequire("2coum");
function $71c24c519808a968$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71c24c519808a968$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71c24c519808a968$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71c24c519808a968$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71c24c519808a968$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $71c24c519808a968$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $71c24c519808a968$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $71c24c519808a968$export$632685d741f3dbbf = $71c24c519808a968$var$_objectSpread($71c24c519808a968$var$_objectSpread({}, $71c24c519808a968$export$958d0ae7f2977ae4), $71c24c519808a968$export$d2dc61f58390201c);
var $71c24c519808a968$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $71c24c519808a968$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $71c24c519808a968$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $71c24c519808a968$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $71c24c519808a968$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $71c24c519808a968$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $71c24c519808a968$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $71c24c519808a968$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $71c24c519808a968$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $71c24c519808a968$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $71c24c519808a968$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $71c24c519808a968$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $71c24c519808a968$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $71c24c519808a968$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $71c24c519808a968$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $71c24c519808a968$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $71c24c519808a968$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $71c24c519808a968$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $71c24c519808a968$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $71c24c519808a968$export$e615f061ca585a6c = $71c24c519808a968$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $71c24c519808a968$export$ca0f9c2de39ffed7(spacingProperty, $71c24c519808a968$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $71c24c519808a968$export$bf46c3f9eeafc71f = $71c24c519808a968$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $71c24c519808a968$export$ca0f9c2de39ffed7(spacingProperty, $71c24c519808a968$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $71c24c519808a968$export$e7af83bafe7f9e63 = $71c24c519808a968$export$ca0f9c2de39ffed7("backgroundColor", $71c24c519808a968$export$d1d79bf68ac056bd);
var $71c24c519808a968$export$3a1bcba60b23d7f0 = $71c24c519808a968$export$ca0f9c2de39ffed7("color", $71c24c519808a968$export$8473307aa00d6ea1);
var $71c24c519808a968$export$45f3f4fe16f9f7d5 = $71c24c519808a968$export$ca0f9c2de39ffed7("fontWeight", $71c24c519808a968$export$303e322c6b1ed114);
var $71c24c519808a968$export$68cc305da27dbaa4 = $71c24c519808a968$export$ca0f9c2de39ffed7("fontFamily", $71c24c519808a968$export$3c7e9587132614b4);
var $71c24c519808a968$export$128f10c238242f83 = $71c24c519808a968$export$ca0f9c2de39ffed7("font", $71c24c519808a968$export$6ffa317d5e70375);
var $71c24c519808a968$export$219d364c0da35ae4 = $71c24c519808a968$export$ca0f9c2de39ffed7("font", $71c24c519808a968$export$236bfe3a33ef1292);
var $71c24c519808a968$export$38845ca010b93505 = $71c24c519808a968$export$ca0f9c2de39ffed7("fontWeight", $71c24c519808a968$export$855cfd311192d666);
var $71c24c519808a968$export$ff257d957d48c421 = $71c24c519808a968$export$ca0f9c2de39ffed7((0, $2coum.CURRENT_SURFACE_CSS_VAR), $71c24c519808a968$export$41a358c9c2356760);
var $71c24c519808a968$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $71c24c519808a968$export$41a358c9c2356760[color] !== undefined;
};
var $71c24c519808a968$export$7001ce64d9ff7c7f = $71c24c519808a968$export$ca0f9c2de39ffed7("font", $71c24c519808a968$export$b805719bc8cb376);

});
parcelRegister("2coum", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $199fb2b65e439b03$export$9d7b58831ae93caa);
var $199fb2b65e439b03$export$4ef52930e33717cd = "data-theme";
var $199fb2b65e439b03$export$a00eac3f8684bcd0 = "data-color-mode";
var $199fb2b65e439b03$export$2112803007239c61 = "data-contrast-mode";
var $199fb2b65e439b03$export$352e418ed5b6193a = "data-custom-theme";
var $199fb2b65e439b03$export$6f0c6fb8c80fcc92 = "ds";
var $199fb2b65e439b03$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $199fb2b65e439b03$export$dddac1532e822863 = "--".concat($199fb2b65e439b03$export$6f0c6fb8c80fcc92, "-token-not-found");
var $199fb2b65e439b03$export$9d7b58831ae93caa = "--".concat($199fb2b65e439b03$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("jHXsO", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $e59028b4fa1742c1$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $e59028b4fa1742c1$export$f6c783d06584602c);

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");

var $9LxfM = parcelRequire("9LxfM");

var $hPtJY = parcelRequire("hPtJY");
function $e59028b4fa1742c1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e59028b4fa1742c1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e59028b4fa1742c1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e59028b4fa1742c1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e59028b4fa1742c1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e59028b4fa1742c1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e59028b4fa1742c1$export$9a199fbafee0014e = {
    backgroundColor: (0, $9LxfM.backgroundColorMap),
    blockSize: (0, $9LxfM.dimensionMap),
    borderBlockColor: (0, $9LxfM.borderColorMap),
    borderBlockEndColor: (0, $9LxfM.borderColorMap),
    borderBlockEndWidth: (0, $9LxfM.borderWidthMap),
    borderBlockStartColor: (0, $9LxfM.borderColorMap),
    borderBlockStartWidth: (0, $9LxfM.borderWidthMap),
    borderBlockWidth: (0, $9LxfM.borderWidthMap),
    borderBottomColor: (0, $9LxfM.borderColorMap),
    borderBottomLeftRadius: (0, $9LxfM.borderRadiusMap),
    borderBottomRightRadius: (0, $9LxfM.borderRadiusMap),
    borderBottomWidth: (0, $9LxfM.borderWidthMap),
    borderColor: (0, $9LxfM.borderColorMap),
    borderEndEndRadius: (0, $9LxfM.borderRadiusMap),
    borderEndStartRadius: (0, $9LxfM.borderRadiusMap),
    borderInlineColor: (0, $9LxfM.borderColorMap),
    borderInlineEndColor: (0, $9LxfM.borderColorMap),
    borderInlineEndWidth: (0, $9LxfM.borderWidthMap),
    borderInlineStartColor: (0, $9LxfM.borderColorMap),
    borderInlineStartWidth: (0, $9LxfM.borderWidthMap),
    borderInlineWidth: (0, $9LxfM.borderWidthMap),
    borderLeftColor: (0, $9LxfM.borderColorMap),
    borderLeftWidth: (0, $9LxfM.borderWidthMap),
    borderRadius: (0, $9LxfM.borderRadiusMap),
    borderRightColor: (0, $9LxfM.borderColorMap),
    borderRightWidth: (0, $9LxfM.borderWidthMap),
    borderStartEndRadius: (0, $9LxfM.borderRadiusMap),
    borderStartStartRadius: (0, $9LxfM.borderRadiusMap),
    borderTopColor: (0, $9LxfM.borderColorMap),
    borderTopLeftRadius: (0, $9LxfM.borderRadiusMap),
    borderTopRightRadius: (0, $9LxfM.borderRadiusMap),
    borderTopWidth: (0, $9LxfM.borderWidthMap),
    borderWidth: (0, $9LxfM.borderWidthMap),
    bottom: (0, $9LxfM.allSpaceMap),
    boxShadow: (0, $9LxfM.shadowMap),
    color: (0, $9LxfM.textColorMap),
    columnGap: (0, $9LxfM.positiveSpaceMap),
    font: (0, $9LxfM.fontMap),
    fontFamily: (0, $9LxfM.fontFamilyMap),
    fontWeight: (0, $9LxfM.fontWeightMap),
    gap: (0, $9LxfM.positiveSpaceMap),
    height: (0, $9LxfM.dimensionMap),
    inlineSize: (0, $9LxfM.dimensionMap),
    inset: (0, $9LxfM.allSpaceMap),
    insetBlock: (0, $9LxfM.allSpaceMap),
    insetBlockEnd: (0, $9LxfM.allSpaceMap),
    insetBlockStart: (0, $9LxfM.allSpaceMap),
    insetInline: (0, $9LxfM.allSpaceMap),
    insetInlineEnd: (0, $9LxfM.allSpaceMap),
    insetInlineStart: (0, $9LxfM.allSpaceMap),
    left: (0, $9LxfM.allSpaceMap),
    margin: (0, $9LxfM.allSpaceMap),
    marginBlock: (0, $9LxfM.allSpaceMap),
    marginBlockEnd: (0, $9LxfM.allSpaceMap),
    marginBlockStart: (0, $9LxfM.allSpaceMap),
    marginBottom: (0, $9LxfM.allSpaceMap),
    marginInline: (0, $9LxfM.allSpaceMap),
    marginInlineEnd: (0, $9LxfM.allSpaceMap),
    marginInlineStart: (0, $9LxfM.allSpaceMap),
    marginLeft: (0, $9LxfM.allSpaceMap),
    marginRight: (0, $9LxfM.allSpaceMap),
    marginTop: (0, $9LxfM.allSpaceMap),
    maxBlockSize: (0, $9LxfM.dimensionMap),
    maxHeight: (0, $9LxfM.dimensionMap),
    maxInlineSize: (0, $9LxfM.dimensionMap),
    maxWidth: (0, $9LxfM.dimensionMap),
    minBlockSize: (0, $9LxfM.dimensionMap),
    minHeight: (0, $9LxfM.dimensionMap),
    minInlineSize: (0, $9LxfM.dimensionMap),
    minWidth: (0, $9LxfM.dimensionMap),
    opacity: (0, $9LxfM.opacityMap),
    outlineColor: (0, $9LxfM.borderColorMap),
    outlineOffset: (0, $9LxfM.allSpaceMap),
    outlineWidth: (0, $9LxfM.borderWidthMap),
    padding: (0, $9LxfM.positiveSpaceMap),
    paddingBlock: (0, $9LxfM.positiveSpaceMap),
    paddingBlockEnd: (0, $9LxfM.positiveSpaceMap),
    paddingBlockStart: (0, $9LxfM.positiveSpaceMap),
    paddingBottom: (0, $9LxfM.positiveSpaceMap),
    paddingInline: (0, $9LxfM.positiveSpaceMap),
    paddingInlineEnd: (0, $9LxfM.positiveSpaceMap),
    paddingInlineStart: (0, $9LxfM.positiveSpaceMap),
    paddingLeft: (0, $9LxfM.positiveSpaceMap),
    paddingRight: (0, $9LxfM.positiveSpaceMap),
    paddingTop: (0, $9LxfM.positiveSpaceMap),
    right: (0, $9LxfM.allSpaceMap),
    rowGap: (0, $9LxfM.positiveSpaceMap),
    top: (0, $9LxfM.allSpaceMap),
    width: (0, $9LxfM.dimensionMap),
    zIndex: (0, $9LxfM.layerMap)
};
var $e59028b4fa1742c1$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $e59028b4fa1742c1$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $e59028b4fa1742c1$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e59028b4fa1742c1$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e59028b4fa1742c1$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e59028b4fa1742c1$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $e59028b4fa1742c1$var$safeSelectors.test(key)) {
            styleObj[key] = $e59028b4fa1742c1$var$_transformStyles(value);
            return;
        }
        if ($e59028b4fa1742c1$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e59028b4fa1742c1$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e59028b4fa1742c1$export$9a199fbafee0014e)) return;
        var tokenValue = $e59028b4fa1742c1$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e59028b4fa1742c1$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e59028b4fa1742c1$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $e59028b4fa1742c1$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $e59028b4fa1742c1$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e59028b4fa1742c1$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e59028b4fa1742c1$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e59028b4fa1742c1$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e59028b4fa1742c1$export$f6c783d06584602c(style) {
    return $e59028b4fa1742c1$var$baseXcss(style);
}

});


parcelRegister("fs8lP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fff2e7b25cf8cb$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $9LxfM = parcelRequire("9LxfM");

var $jHXsO = parcelRequire("jHXsO");
var $b3fff2e7b25cf8cb$var$gridTemplateAreasVar = "--ds-grid--grid-template-areas";
var $b3fff2e7b25cf8cb$var$gridTemplateColumnsVar = "--ds-grid--grid-template-columns";
var $b3fff2e7b25cf8cb$var$gridTemplateRowsVar = "--ds-grid--grid-template-rows";
var $b3fff2e7b25cf8cb$var$justifyContentMap = {
    start: (0, $dnfL5.css)({
        justifyContent: "start"
    }),
    center: (0, $dnfL5.css)({
        justifyContent: "center"
    }),
    end: (0, $dnfL5.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $dnfL5.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $dnfL5.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $dnfL5.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $dnfL5.css)({
        justifyContent: "stretch"
    })
};
var $b3fff2e7b25cf8cb$var$justifyItemsMap = {
    start: (0, $dnfL5.css)({
        justifyItems: "start"
    }),
    center: (0, $dnfL5.css)({
        justifyItems: "center"
    }),
    end: (0, $dnfL5.css)({
        justifyItems: "end"
    }),
    stretch: (0, $dnfL5.css)({
        justifyItems: "stretch"
    })
};
var $b3fff2e7b25cf8cb$var$alignContentMap = {
    start: (0, $dnfL5.css)({
        alignContent: "start"
    }),
    center: (0, $dnfL5.css)({
        alignContent: "center"
    }),
    end: (0, $dnfL5.css)({
        alignContent: "end"
    }),
    "space-between": (0, $dnfL5.css)({
        alignContent: "space-between"
    }),
    "space-around": (0, $dnfL5.css)({
        alignContent: "space-around"
    }),
    "space-evenly": (0, $dnfL5.css)({
        alignContent: "space-evenly"
    }),
    stretch: (0, $dnfL5.css)({
        alignContent: "stretch"
    })
};
var $b3fff2e7b25cf8cb$var$alignItemsMap = {
    start: (0, $dnfL5.css)({
        alignItems: "start"
    }),
    center: (0, $dnfL5.css)({
        alignItems: "center"
    }),
    baseline: (0, $dnfL5.css)({
        alignItems: "baseline"
    }),
    end: (0, $dnfL5.css)({
        alignItems: "end"
    })
};
var $b3fff2e7b25cf8cb$var$baseStyles = (0, $dnfL5.css)({
    display: "grid",
    boxSizing: "border-box",
    gridTemplateAreas: "var(".concat($b3fff2e7b25cf8cb$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($b3fff2e7b25cf8cb$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($b3fff2e7b25cf8cb$var$gridTemplateRowsVar, ")")
});
var $b3fff2e7b25cf8cb$var$gridAutoFlowMap = {
    row: (0, $dnfL5.css)({
        gridAutoFlow: "row"
    }),
    column: (0, $dnfL5.css)({
        gridAutoFlow: "column"
    }),
    dense: (0, $dnfL5.css)({
        gridAutoFlow: "dense"
    }),
    "row dense": (0, $dnfL5.css)({
        gridAutoFlow: "row dense"
    }),
    "column dense": (0, $dnfL5.css)({
        gridAutoFlow: "column dense"
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $b3fff2e7b25cf8cb$var$Grid = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || "div";
    var resolvedStyles = (0, $jHXsO.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $acw62.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $b3fff2e7b25cf8cb$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return '"'.concat(str, '"');
        }).join("\n") || "initial" : "initial"), $b3fff2e7b25cf8cb$var$gridTemplateColumnsVar, gridTemplateColumns || "initial"), $b3fff2e7b25cf8cb$var$gridTemplateRowsVar, gridTemplateRows || "initial");
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $dnfL5.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $b3fff2e7b25cf8cb$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9LxfM.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9LxfM.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9LxfM.spaceStylesMap).rowGap[rowGap],
            alignItems && $b3fff2e7b25cf8cb$var$alignItemsMap[alignItems],
            alignContent && $b3fff2e7b25cf8cb$var$alignContentMap[alignContent],
            justifyContent && $b3fff2e7b25cf8cb$var$justifyContentMap[justifyContent],
            autoFlow && $b3fff2e7b25cf8cb$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$b3fff2e7b25cf8cb$var$Grid.displayName = "Grid";
var $b3fff2e7b25cf8cb$export$2e2bcd8739ae039 = $b3fff2e7b25cf8cb$var$Grid;

});

parcelRegister("fn3nv", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $b30b9fd4dc9cea3e$export$de65de8213222d10);

var $acw62 = parcelRequire("acw62");

var $fh583 = parcelRequire("fh583");

var $ewnfF = parcelRequire("ewnfF");
var $b30b9fd4dc9cea3e$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fh583.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ewnfF))),
        label: label || "Close Modal",
        onClick: onClick
    });
};

});
parcelRegister("fh583", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ec6c10458e6a1b$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $203BW = parcelRequire("203BW");

var $bxGpw = parcelRequire("bxGpw");

var $hDDVR = parcelRequire("hDDVR");

var $4NcZd = parcelRequire("4NcZd");

var $bMW2M = parcelRequire("bMW2M");

var $aAM97 = parcelRequire("aAM97");
var $b1ec6c10458e6a1b$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $b1ec6c10458e6a1b$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $b1ec6c10458e6a1b$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b1ec6c10458e6a1b$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $b1ec6c10458e6a1b$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4NcZd.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bMW2M.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aAM97.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hDDVR.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bxGpw.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4NcZd.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $203BW.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bMW2M.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aAM97.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hDDVR.default), null, label)));
    });
}));
$b1ec6c10458e6a1b$var$IconButton.displayName = "IconButton";
var $b1ec6c10458e6a1b$export$2e2bcd8739ae039 = $b1ec6c10458e6a1b$var$IconButton;

});
parcelRegister("203BW", function(module, exports) {

$parcel$export(module.exports, "default", () => $174e61f1a1fb6ca9$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $174e61f1a1fb6ca9$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("bxGpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8673aca9ce34de43$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $hi6fR = parcelRequire("hi6fR");

var $1kc0P = parcelRequire("1kc0P");

var $lLQA9 = parcelRequire("lLQA9");

var $2eeKg = parcelRequire("2eeKg");

var $1Ge8s = parcelRequire("1Ge8s");

var $ocesl = parcelRequire("ocesl");
var $1NLnE = parcelRequire("1NLnE");

var $cMeaX = parcelRequire("cMeaX");

var $izA8S = parcelRequire("izA8S");

var $kRSiU = parcelRequire("kRSiU");

var $4LcJs = parcelRequire("4LcJs");

var $cgstD = parcelRequire("cgstD");

var $eqGjR = parcelRequire("eqGjR");

var $2IbKS = parcelRequire("2IbKS");

var $bu06k = parcelRequire("bu06k");
function $8673aca9ce34de43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8673aca9ce34de43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8673aca9ce34de43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8673aca9ce34de43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8673aca9ce34de43$var$tooltipZIndex = (0, $kRSiU.layers).tooltip();
var $8673aca9ce34de43$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.4"
};
// Inverts motion direction
var $8673aca9ce34de43$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $8673aca9ce34de43$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $8673aca9ce34de43$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $2IbKS.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $1kc0P.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $1kc0P.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $hi6fR.usePlatformLeafSyntheticEventHandler)($8673aca9ce34de43$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $8673aca9ce34de43$var$analyticsAttributes));
    var onHideHandler = (0, $hi6fR.usePlatformLeafSyntheticEventHandler)($8673aca9ce34de43$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $8673aca9ce34de43$var$analyticsAttributes));
    var apiRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $acw62.useRef)(null);
    var containerRef = (0, $acw62.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $acw62.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $2eeKg.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $2eeKg.default)(onShowHandler);
    var onHideHandlerStable = (0, $2eeKg.default)(onHideHandler);
    var delayStable = (0, $2eeKg.default)(delay);
    var canAppearStable = (0, $2eeKg.default)(canAppear);
    var hasCalledShowHandler = (0, $acw62.useRef)(false);
    var start = (0, $acw62.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $acw62.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        return (0, $4LcJs.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $acw62.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $cgstD.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $acw62.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $lLQA9.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $acw62.useEffect)(function() {
        if (state === "hide") return 0, $1kc0P.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $bu06k.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $bu06k.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $acw62.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $acw62.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $acw62.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $acw62.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    (0, $1Ge8s.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $eqGjR.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $acw62.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children($8673aca9ce34de43$var$_objectSpread($8673aca9ce34de43$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $izA8S.default), {
        zIndex: $8673aca9ce34de43$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cMeaX.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $8673aca9ce34de43$var$invertedDirection[$8673aca9ce34de43$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ocesl.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1NLnE.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $8673aca9ce34de43$var$_objectSpread($8673aca9ce34de43$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$8673aca9ce34de43$var$Tooltip.displayName = "Tooltip";
var $8673aca9ce34de43$export$2e2bcd8739ae039 = $8673aca9ce34de43$var$Tooltip;

});
parcelRegister("hi6fR", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $c968f8328b9d5833$export$1a04351537078b55);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $hfYBe = parcelRequire("hfYBe");

var $3R1KE = parcelRequire("3R1KE");
function $c968f8328b9d5833$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c968f8328b9d5833$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c968f8328b9d5833$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c968f8328b9d5833$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c968f8328b9d5833$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hfYBe.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3R1KE.useTrackedRef)(analyticsData);
    var fnRef = (0, $3R1KE.useTrackedRef)(fn);
    var handler = (0, $acw62.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c968f8328b9d5833$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("lLQA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd96c674d213c4aa$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $ltooA = parcelRequire("ltooA");

var $8oEIX = parcelRequire("8oEIX");
function $fd96c674d213c4aa$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $8oEIX.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $ltooA.fg)("platform_only_attach_escape_handler_on_view")) return;
        return (0, $8fY35.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("8oEIX", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", () => $61d02797cf0a4a10$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $61d02797cf0a4a10$export$390330c10ff2b9a1 = "ArrowUp";
var $61d02797cf0a4a10$export$a80636c6f41931fe = "ArrowDown";
var $61d02797cf0a4a10$export$4af703091671bc = "Home";
var $61d02797cf0a4a10$export$e2bc30913faa5db7 = "End";
var $61d02797cf0a4a10$export$10f6869ed0a7d75b = "Tab";
var $61d02797cf0a4a10$export$8152f929a25a0ff4 = "Enter";
var $61d02797cf0a4a10$export$e51a3576c045c8d5 = "Space";
var $61d02797cf0a4a10$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("2eeKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $19f853a9dd0f940f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $19f853a9dd0f940f$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("1Ge8s", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $1394adab91f679c3$export$469bb693f11edc7f);

var $acw62 = parcelRequire("acw62");

var $kQcXF = parcelRequire("kQcXF");

var $f9Rt7 = parcelRequire("f9Rt7");
function $1394adab91f679c3$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $acw62.useContext)((0, $kQcXF.OpenLayerObserverContext));
    var namespace = (0, $f9Rt7.useOpenLayerObserverNamespace)();
    (0, $acw62.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("kQcXF", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", () => $f2c2b7d7f9570cb1$export$5fbf4d7fae6cdc00);

var $acw62 = parcelRequire("acw62");
var $f2c2b7d7f9570cb1$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});

parcelRegister("f9Rt7", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $b0912c102d79f411$export$1d57e79091cc3046);

var $acw62 = parcelRequire("acw62");

var $7QCNx = parcelRequire("7QCNx");
function $b0912c102d79f411$export$1d57e79091cc3046() {
    var namespace = (0, $acw62.useContext)((0, $7QCNx.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("7QCNx", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $5b6b7c3610d878be$export$644a49f3b8c50fcd);

var $acw62 = parcelRequire("acw62");
var $5b6b7c3610d878be$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $acw62.createContext)(null);

});



parcelRegister("cMeaX", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $94d4f6bc0e7c882a$export$badac9ada3a0bdf9);

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $bqx5F = parcelRequire("bqx5F");

var $emHAF = parcelRequire("emHAF");

// Export types from PopperJS / React Popper
var $94d4f6bc0e7c882a$var$viewportPadding = 5;
var $94d4f6bc0e7c882a$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $94d4f6bc0e7c882a$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $94d4f6bc0e7c882a$var$defaultChildrenFn() {
    return null;
}
var $94d4f6bc0e7c882a$var$defaultOffset = [
    0,
    8
];
function $94d4f6bc0e7c882a$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $94d4f6bc0e7c882a$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $94d4f6bc0e7c882a$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $94d4f6bc0e7c882a$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $emHAF.getMaxSizeModifiers)({
            viewportPadding: $94d4f6bc0e7c882a$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($94d4f6bc0e7c882a$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bqx5F.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("bqx5F", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $851bca7c9c9c0033$export$badac9ada3a0bdf9);

var $acw62 = parcelRequire("acw62");

var $6Hh1R = parcelRequire("6Hh1R");

var $evS7p = parcelRequire("evS7p");

var $939uC = parcelRequire("939uC");
var $851bca7c9c9c0033$var$NOOP = function NOOP() {
    return void 0;
};
var $851bca7c9c9c0033$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $851bca7c9c9c0033$var$EMPTY_MODIFIERS = [];
function $851bca7c9c9c0033$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $851bca7c9c9c0033$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $6Hh1R.ManagerReferenceNodeContext));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $evS7p.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $939uC.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $851bca7c9c9c0033$var$NOOP,
            update: update || $851bca7c9c9c0033$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $evS7p.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("6Hh1R", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $4e03f7d1669d75a8$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $4e03f7d1669d75a8$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $4e03f7d1669d75a8$export$d0d38e7dec7a1a61);

var $acw62 = parcelRequire("acw62");
var $4e03f7d1669d75a8$export$3dbd3405086fec7b = $acw62.createContext();
var $4e03f7d1669d75a8$export$cbabb21c2529b130 = $acw62.createContext();
function $4e03f7d1669d75a8$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($4e03f7d1669d75a8$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($4e03f7d1669d75a8$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("evS7p", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $a90df0c481f567f3$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $a90df0c481f567f3$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $a90df0c481f567f3$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $a90df0c481f567f3$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a90df0c481f567f3$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $a90df0c481f567f3$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a90df0c481f567f3$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a90df0c481f567f3$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $a90df0c481f567f3$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a90df0c481f567f3$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a90df0c481f567f3$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("939uC", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $696bc1f7af8fb02e$export$f4d5bf230a36dd6e);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $evS7p = parcelRequire("evS7p");
var $696bc1f7af8fb02e$var$EMPTY_MODIFIERS = [];
var $696bc1f7af8fb02e$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $696bc1f7af8fb02e$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $evS7p.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $evS7p.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $evS7p.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $evS7p.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === "html" || (0, $oKPBf.default)(offsetParent) === "body" && (0, $huVQQ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === "rtl") x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === "x" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("ai2Pb", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("emHAF", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", () => $a754eee4ca1ec1a6$export$6d8c2b45c99d6e3f);

var $02Ztr = parcelRequire("02Ztr");
function $a754eee4ca1ec1a6$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("4LcJs", function(module, exports) {

$parcel$export(module.exports, "register", () => $37756d90c122a3c0$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $8fY35 = parcelRequire("8fY35");
var $37756d90c122a3c0$var$registrations = new Set();
var $37756d90c122a3c0$var$cleanupEndEventListeners = null;
function $37756d90c122a3c0$var$onDragStart() {
    if ($37756d90c122a3c0$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $37756d90c122a3c0$var$cleanupEndEventListeners = (0, $8fY35.bindAll)(window, [
        {
            type: "dragend",
            listener: $37756d90c122a3c0$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $37756d90c122a3c0$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $37756d90c122a3c0$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($37756d90c122a3c0$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $37756d90c122a3c0$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $37756d90c122a3c0$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $37756d90c122a3c0$var$cleanupEndEventListeners = null;
    var clone = Array.from($37756d90c122a3c0$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $37756d90c122a3c0$var$bindStartEvents() {
    return (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: $37756d90c122a3c0$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $37756d90c122a3c0$var$onDragStart
        }
    ]);
}
var $37756d90c122a3c0$var$cleanupStartEventListeners = null;
function $37756d90c122a3c0$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$37756d90c122a3c0$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $37756d90c122a3c0$var$cleanupStartEventListeners = $37756d90c122a3c0$var$bindStartEvents();
    $37756d90c122a3c0$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $37756d90c122a3c0$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $37756d90c122a3c0$var$registrations.delete(registration);
        if ($37756d90c122a3c0$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $37756d90c122a3c0$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $37756d90c122a3c0$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("cgstD", function(module, exports) {

$parcel$export(module.exports, "show", () => $8edd1197fb0ff030$export$57bf213be019eeb0);

var $kDp0V = parcelRequire("kDp0V");
// This file is a singleton for managing tooltips
var $8edd1197fb0ff030$var$active = null;
function $8edd1197fb0ff030$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($8edd1197fb0ff030$var$active && $8edd1197fb0ff030$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $kDp0V.clearScheduled)();
            $8edd1197fb0ff030$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $kDp0V.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $kDp0V.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $kDp0V.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($8edd1197fb0ff030$var$active && $8edd1197fb0ff030$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($8edd1197fb0ff030$var$active) {
            (0, $kDp0V.clearScheduled)();
            $8edd1197fb0ff030$var$active.entry.hide({
                isImmediate: true
            });
            $8edd1197fb0ff030$var$active.entry.done();
            $8edd1197fb0ff030$var$active = null;
        }
        // this tooltip is now the active tooltip
        $8edd1197fb0ff030$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $kDp0V.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("kDp0V", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $f05ada6aca5fa5b9$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $f05ada6aca5fa5b9$export$5f4d6617421d489b);
var $f05ada6aca5fa5b9$var$delayId = null;
function $f05ada6aca5fa5b9$export$eaf678f6f93f5250() {
    if ($f05ada6aca5fa5b9$var$delayId != null) {
        window.clearTimeout($f05ada6aca5fa5b9$var$delayId);
        $f05ada6aca5fa5b9$var$delayId = null;
    }
}
function $f05ada6aca5fa5b9$export$5f4d6617421d489b(fn, delay) {
    $f05ada6aca5fa5b9$export$eaf678f6f93f5250();
    $f05ada6aca5fa5b9$var$delayId = window.setTimeout(function() {
        $f05ada6aca5fa5b9$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("eqGjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8145226542bd909$export$2e2bcd8739ae039);

var $l8Mix = parcelRequire("l8Mix");
function $a8145226542bd909$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $l8Mix.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("2IbKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f98cf25480c29fb$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $5cymf = parcelRequire("5cymf");

var $9itI1 = parcelRequire("9itI1");

var $kxGyV = parcelRequire("kxGyV");
function $1f98cf25480c29fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f98cf25480c29fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f98cf25480c29fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f98cf25480c29fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1f98cf25480c29fb$var$baseStyles = null;
var $1f98cf25480c29fb$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $1f98cf25480c29fb$var$TooltipContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement((0, $kxGyV.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9dvtP.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $1f98cf25480c29fb$var$_objectSpread($1f98cf25480c29fb$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $5cymf.default)("var(--ds-background-neutral-bold, ".concat((0, $9itI1.N800), ")")),
            "--_ywovvi": (0, $5cymf.default)("var(--ds-text-inverse, ".concat((0, $9itI1.N0), ")"))
        })
    }, children);
});
$1f98cf25480c29fb$var$TooltipContainer.displayName = "TooltipContainer";
var $1f98cf25480c29fb$export$2e2bcd8739ae039 = $1f98cf25480c29fb$var$TooltipContainer;

});
parcelRegister("kxGyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef47e7ba5735f4be$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $kRSiU = parcelRequire("kRSiU");
function $ef47e7ba5735f4be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef47e7ba5735f4be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef47e7ba5735f4be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef47e7ba5735f4be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef47e7ba5735f4be$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $ef47e7ba5735f4be$var$primitiveStyles = (0, $dnfL5.css)({
    zindex: "var(".concat($ef47e7ba5735f4be$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $ef47e7ba5735f4be$var$TooltipPrimitive = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $ef47e7ba5735f4be$var$_objectSpread($ef47e7ba5735f4be$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $ef47e7ba5735f4be$var$VAR_PRIMITIVE_ZINDEX, (0, $kRSiU.layers).tooltip()));
    return (0, $dnfL5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $dnfL5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $ef47e7ba5735f4be$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$ef47e7ba5735f4be$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $ef47e7ba5735f4be$export$2e2bcd8739ae039 = $ef47e7ba5735f4be$var$TooltipPrimitive;

});


parcelRegister("bu06k", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $85c2931de2bf088e$export$642213d516a9b928);
function $85c2931de2bf088e$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("hDDVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd750de1ba1e50bf$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $cd750de1ba1e50bf$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $cd750de1ba1e50bf$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9dvtP.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $cd750de1ba1e50bf$export$2e2bcd8739ae039 = $cd750de1ba1e50bf$var$VisuallyHidden;

});

parcelRegister("4NcZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d5cfd7ea0085e9$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $9dvtP = parcelRequire("9dvtP");

var $acw62 = parcelRequire("acw62");

var $3rfDA = parcelRequire("3rfDA");

var $203BW = parcelRequire("203BW");

var $aH3LH = parcelRequire("aH3LH");

var $awQoQ = parcelRequire("awQoQ");

var $ltooA = parcelRequire("ltooA");

var $y1ZSe = parcelRequire("y1ZSe");

var $hDDVR = parcelRequire("hDDVR");

var $b2OLr = parcelRequire("b2OLr");

var $ecClW = parcelRequire("ecClW");

var $GFhRr = parcelRequire("GFhRr");
var $37d5cfd7ea0085e9$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $37d5cfd7ea0085e9$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $37d5cfd7ea0085e9$var$LOADING_LABEL = ", Loading";
var $37d5cfd7ea0085e9$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $37d5cfd7ea0085e9$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $37d5cfd7ea0085e9$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $37d5cfd7ea0085e9$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $37d5cfd7ea0085e9$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $37d5cfd7ea0085e9$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $37d5cfd7ea0085e9$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $37d5cfd7ea0085e9$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $37d5cfd7ea0085e9$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $37d5cfd7ea0085e9$var$_excluded);
    var localRef = (0, $acw62.useRef)(null);
    var splitButtonContext = (0, $b2OLr.useSplitButtonContext)();
    var loadingLabelId = (0, $awQoQ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $ltooA.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $aH3LH.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $37d5cfd7ea0085e9$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $y1ZSe.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $203BW.default)([
            localRef,
            ref
        ]),
        xcss: (0, $3rfDA.cx)($37d5cfd7ea0085e9$var$styles.base, appearance === "default" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $37d5cfd7ea0085e9$var$defaultStyles.rootRefreshed : $37d5cfd7ea0085e9$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $37d5cfd7ea0085e9$var$defaultStyles.interactiveRefreshed : $37d5cfd7ea0085e9$var$defaultStyles.interactive), appearance === "primary" && $37d5cfd7ea0085e9$var$primaryStyles.root, appearance === "primary" && isInteractive && $37d5cfd7ea0085e9$var$primaryStyles.interactive, appearance === "warning" && $37d5cfd7ea0085e9$var$warningStyles.root, appearance === "warning" && isInteractive && $37d5cfd7ea0085e9$var$warningStyles.interactive, appearance === "danger" && $37d5cfd7ea0085e9$var$dangerStyles.root, appearance === "danger" && isInteractive && $37d5cfd7ea0085e9$var$dangerStyles.interactive, appearance === "discovery" && $37d5cfd7ea0085e9$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $37d5cfd7ea0085e9$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $37d5cfd7ea0085e9$var$subtleStyles.rootRefreshed : $37d5cfd7ea0085e9$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $37d5cfd7ea0085e9$var$subtleStyles.interactiveRefreshed : $37d5cfd7ea0085e9$var$subtleStyles.interactive), $37d5cfd7ea0085e9$var$styles.linkDecorationUnset, isSelected && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $37d5cfd7ea0085e9$var$selectedStyles.rootRefreshed : $37d5cfd7ea0085e9$var$selectedStyles.root), isSelected && isSplitButton && $37d5cfd7ea0085e9$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $37d5cfd7ea0085e9$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $37d5cfd7ea0085e9$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $37d5cfd7ea0085e9$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $37d5cfd7ea0085e9$var$selectedStyles.discovery, isDisabled && $37d5cfd7ea0085e9$var$styles.disabled, isCircle && !isSplitButton && $37d5cfd7ea0085e9$var$styles.circle, spacing === "compact" && $37d5cfd7ea0085e9$var$styles.spacingCompact, hasIconBefore && $37d5cfd7ea0085e9$var$styles.buttonIconBefore, shouldFitContainer && $37d5cfd7ea0085e9$var$styles.fullWidth, hasIconAfter && $37d5cfd7ea0085e9$var$styles.buttonIconAfter, isIconButton && $37d5cfd7ea0085e9$var$styles.iconButton, isIconButton && spacing === "compact" && $37d5cfd7ea0085e9$var$styles.iconButtonCompact, isLoading && $37d5cfd7ea0085e9$var$styles.loading, isSplitButton && $37d5cfd7ea0085e9$var$styles.splitButton, isNavigationSplitButton && $37d5cfd7ea0085e9$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($37d5cfd7ea0085e9$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $ecClW.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $9dvtP.default)([
            $37d5cfd7ea0085e9$var$styles.loadingOverlay
        ])
    }, (0, $GFhRr.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hDDVR.default), {
        id: loadingLabelId
    }, $37d5cfd7ea0085e9$var$LOADING_LABEL)));
});
var $37d5cfd7ea0085e9$export$2e2bcd8739ae039 = $37d5cfd7ea0085e9$var$ButtonBase;

});
parcelRegister("3rfDA", function(module, exports) {

$parcel$export(module.exports, "cx", () => $28100603ae501c2c$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("acw62");


var $3U1FJ = parcelRequire("3U1FJ");
var $28100603ae501c2c$var$_createStrictAPI = (0, $3U1FJ.createStrictAPI)(), $28100603ae501c2c$var$XCSSProp = $28100603ae501c2c$var$_createStrictAPI.XCSSProp, $28100603ae501c2c$export$dbf350e5966cf602 = $28100603ae501c2c$var$_createStrictAPI.css, $28100603ae501c2c$export$eb1ecd84a24ee424 = $28100603ae501c2c$var$_createStrictAPI.cssMap, $28100603ae501c2c$export$a274e22fb40f762e = $28100603ae501c2c$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("3U1FJ", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", () => $2d77e61fef6c6467$export$39716b4af53f4ad);

var $2Hz4N = parcelRequire("2Hz4N");

var $8tQx1 = parcelRequire("8tQx1");
function $2d77e61fef6c6467$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $2Hz4N.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $2Hz4N.createStrictSetupError)();
        },
        cx: $8tQx1.cx,
        XCSSProp () {
            throw (0, $2Hz4N.createStrictSetupError)();
        }
    };
}

});
parcelRegister("2Hz4N", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", () => $1f7ace620ccc9a9e$export$c4df1cb0c2b4d77c);
const $1f7ace620ccc9a9e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $1f7ace620ccc9a9e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("8tQx1", function(module, exports) {

$parcel$export(module.exports, "cx", () => $62c9c7d35df69672$export$a274e22fb40f762e);

var $9dvtP = parcelRequire("9dvtP");
const $62c9c7d35df69672$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9dvtP.default)(actualStyles);
};

});



parcelRegister("aH3LH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c90d7dbd52f3373$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $7c90d7dbd52f3373$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("awQoQ", function(module, exports) {

$parcel$export(module.exports, "useId", () => $7aa58a0b4dcb00be$export$f680877a34711e37);

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $98BOi = parcelRequire("98BOi");

var $ltooA = parcelRequire("ltooA");
var $7aa58a0b4dcb00be$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $7aa58a0b4dcb00be$var$react18UseId = ($7aa58a0b4dcb00be$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $7aa58a0b4dcb00be$var$_React$useId !== void 0 ? $7aa58a0b4dcb00be$var$_React$useId : undefined;
function $7aa58a0b4dcb00be$export$f680877a34711e37() {
    if ($7aa58a0b4dcb00be$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $7aa58a0b4dcb00be$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $98BOi.useUID)());
}
var $7aa58a0b4dcb00be$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($7aa58a0b4dcb00be$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $7aa58a0b4dcb00be$export$6ee17796e3d70de2() {
    if ($7aa58a0b4dcb00be$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $7aa58a0b4dcb00be$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $98BOi.useUIDSeed)();
}

});

parcelRegister("y1ZSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0664b9a5428fcb43$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $8tQx1 = parcelRequire("8tQx1");

var $5YNKq = parcelRequire("5YNKq");

var $oYoPL = parcelRequire("oYoPL");

var $338gG = parcelRequire("338gG");

var $a1XXW = parcelRequire("a1XXW");
var $0664b9a5428fcb43$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $0664b9a5428fcb43$var$_excluded2 = [
    "className"
];
var $0664b9a5428fcb43$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $0664b9a5428fcb43$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $oYoPL.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $0664b9a5428fcb43$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $338gG.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $5YNKq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $0664b9a5428fcb43$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $a1XXW.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        style: style
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $8tQx1.cx)($0664b9a5428fcb43$var$styles.root, isDisabled && $0664b9a5428fcb43$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $0664b9a5428fcb43$export$2e2bcd8739ae039 = $0664b9a5428fcb43$var$Pressable;

});
parcelRegister("oYoPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b11818f825a418$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $04b11818f825a418$export$2e2bcd8739ae039() {}

});

parcelRegister("338gG", function(module, exports) {

$parcel$export(module.exports, "default", () => $238810c50a555013$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $238810c50a555013$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});

parcelRegister("a1XXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d88358cd9e8ba7$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $5cymf = parcelRequire("5cymf");
var $74d88358cd9e8ba7$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $74d88358cd9e8ba7$var$_excluded2 = [
    "className"
];
function $74d88358cd9e8ba7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74d88358cd9e8ba7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74d88358cd9e8ba7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74d88358cd9e8ba7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74d88358cd9e8ba7$var$focusRingStyles = null;
var $74d88358cd9e8ba7$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $74d88358cd9e8ba7$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $74d88358cd9e8ba7$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $74d88358cd9e8ba7$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9dvtP.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $74d88358cd9e8ba7$var$_objectSpread($74d88358cd9e8ba7$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $5cymf.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $74d88358cd9e8ba7$export$2e2bcd8739ae039 = $74d88358cd9e8ba7$var$Focusable;

});


parcelRegister("b2OLr", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", () => $80a742525927cdbc$export$47e2c6fdb142d947);

var $acw62 = parcelRequire("acw62");
var $80a742525927cdbc$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $80a742525927cdbc$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $acw62.useContext)($80a742525927cdbc$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("ecClW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56fefc3d3610075$export$2e2bcd8739ae039);
function $a56fefc3d3610075$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $a56fefc3d3610075$var$tabKeyCode = 9;
function $a56fefc3d3610075$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $a56fefc3d3610075$var$tabKeyCode) return;
    $a56fefc3d3610075$var$abort(event);
}
function $a56fefc3d3610075$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $a56fefc3d3610075$var$abort,
        onMouseUpCapture: $a56fefc3d3610075$var$abort,
        onKeyDownCapture: $a56fefc3d3610075$var$onKey,
        onKeyUpCapture: $a56fefc3d3610075$var$onKey,
        onTouchStartCapture: $a56fefc3d3610075$var$abort,
        onTouchEndCapture: $a56fefc3d3610075$var$abort,
        onPointerDownCapture: $a56fefc3d3610075$var$abort,
        onPointerUpCapture: $a56fefc3d3610075$var$abort,
        onClickCapture: $a56fefc3d3610075$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $a56fefc3d3610075$var$abort
    } : events;
}

});

parcelRegister("GFhRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0803f31ceac98975$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4odHV = parcelRequire("4odHV");
function $0803f31ceac98975$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $0803f31ceac98975$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $0803f31ceac98975$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4odHV.default), {
        size: $0803f31ceac98975$var$getIconSpacing(spacing),
        appearance: $0803f31ceac98975$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("4odHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $33240957ea6cf6fa$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9dvtP = parcelRequire("9dvtP");

var $acw62 = parcelRequire("acw62");

var $338gG = parcelRequire("338gG");

var $9itI1 = parcelRequire("9itI1");

var $fTzDl = parcelRequire("fTzDl");
/**
 * Returns the appropriate circle stroke color.
 */ function $33240957ea6cf6fa$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $9itI1.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $9itI1.N0), ")");
}
var $33240957ea6cf6fa$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $33240957ea6cf6fa$var$loadIn = null;
var $33240957ea6cf6fa$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $33240957ea6cf6fa$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $33240957ea6cf6fa$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $fTzDl.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $33240957ea6cf6fa$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $338gG.default));
    $33240957ea6cf6fa$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9dvtP.default)([
            $33240957ea6cf6fa$var$styles.wrapperStyles,
            $33240957ea6cf6fa$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $9dvtP.default)([
            $33240957ea6cf6fa$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $9dvtP.default)([
            $33240957ea6cf6fa$var$styles.circleStyles
        ])
    })));
}));
var $33240957ea6cf6fa$export$2e2bcd8739ae039 = $33240957ea6cf6fa$var$Spinner;

});
parcelRegister("fTzDl", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $b927a22ca6601f31$export$4e9f1640bbe7a1a8);
var $b927a22ca6601f31$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("bMW2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $895133b54121a6a6$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9dvtP = parcelRequire("9dvtP");

var $acw62 = parcelRequire("acw62");
var $895133b54121a6a6$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $895133b54121a6a6$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $9dvtP.default)([
            $895133b54121a6a6$var$styles.common,
            type === "text" && $895133b54121a6a6$var$styles.text,
            type === "icon" && $895133b54121a6a6$var$styles.icon,
            isLoading && $895133b54121a6a6$var$styles.fade,
            position === "before" && $895133b54121a6a6$var$styles.beforeIcon,
            position === "after" && $895133b54121a6a6$var$styles.afterIcon
        ])
    }, children);
};
var $895133b54121a6a6$export$2e2bcd8739ae039 = $895133b54121a6a6$var$Content;

});

parcelRegister("aAM97", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b629cfd95bc28ed$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $7b629cfd95bc28ed$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $7b629cfd95bc28ed$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $7b629cfd95bc28ed$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $7b629cfd95bc28ed$export$2e2bcd8739ae039 = $7b629cfd95bc28ed$var$IconRenderer;

});


parcelRegister("ewnfF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a926172534ef3419$var$_react = $a926172534ef3419$var$_interopRequireDefault((parcelRequire("acw62")));

var $a926172534ef3419$var$_close = $a926172534ef3419$var$_interopRequireDefault((parcelRequire("cJzZw")));

var $a926172534ef3419$var$_cross = $a926172534ef3419$var$_interopRequireDefault((parcelRequire("gUwPo")));
function $a926172534ef3419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a926172534ef3419$var$CloseIcon = (props)=>/*#__PURE__*/ $a926172534ef3419$var$_react.default.createElement($a926172534ef3419$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $a926172534ef3419$var$_cross.default
    }, props));
$a926172534ef3419$var$CloseIcon.Name = "CloseIconMigration";
var $a926172534ef3419$var$_default = module.exports.default = $a926172534ef3419$var$CloseIcon;

});
parcelRegister("cJzZw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94559b2652706582$var$_react = $94559b2652706582$var$_interopRequireDefault((parcelRequire("acw62")));

var $94559b2652706582$var$_baseNew = $94559b2652706582$var$_interopRequireDefault((parcelRequire("lxrKg")));
function $94559b2652706582$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94559b2652706582$var$CloseIcon = (props)=>/*#__PURE__*/ $94559b2652706582$var$_react.default.createElement($94559b2652706582$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$94559b2652706582$var$CloseIcon.displayName = "CloseIcon";
var $94559b2652706582$var$_default = module.exports.default = $94559b2652706582$var$CloseIcon;

});
parcelRegister("lxrKg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("dqGmu")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("dqGmu")).Icon);

var $dqGmu = parcelRequire("dqGmu");

});
parcelRegister("dqGmu", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $9c6e903f33925055$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $9c6e903f33925055$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $9c6e903f33925055$var$commonSVGStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $9c6e903f33925055$var$svgStyles = (0, $dnfL5.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $9c6e903f33925055$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $9c6e903f33925055$var$utilityIconStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $9c6e903f33925055$var$scaleStyles = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $9c6e903f33925055$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $9c6e903f33925055$var$scaleSize = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
var $9c6e903f33925055$var$sizeMap = {
    core: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $9c6e903f33925055$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $9c6e903f33925055$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $9c6e903f33925055$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $dnfL5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $9c6e903f33925055$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $9c6e903f33925055$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $9c6e903f33925055$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $dnfL5.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $9c6e903f33925055$var$iconStyles,
            $9c6e903f33925055$var$baseHcmStyles,
            shouldScale && $9c6e903f33925055$var$scaleStyles,
            props.type === "utility" && $9c6e903f33925055$var$utilityIconStyles
        ]
    }, (0, $dnfL5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $9c6e903f33925055$var$commonSVGStyles,
            $9c6e903f33925055$var$svgStyles,
            shouldScale ? $9c6e903f33925055$var$scaleSize : props.type === "utility" ? $9c6e903f33925055$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $9c6e903f33925055$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $9c6e903f33925055$export$2e2bcd8739ae039 = $9c6e903f33925055$export$f04a61298a47a40f;

});



parcelRegister("gUwPo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4fb573ff5863452$var$_react = $c4fb573ff5863452$var$_interopRequireDefault((parcelRequire("acw62")));

var $5abBF = parcelRequire("5abBF");

var $c4fb573ff5863452$var$_close = $c4fb573ff5863452$var$_interopRequireDefault((parcelRequire("cJzZw")));
function $c4fb573ff5863452$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4fb573ff5863452$var$CrossIcon = (props)=>/*#__PURE__*/ $c4fb573ff5863452$var$_react.default.createElement($5abBF.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $c4fb573ff5863452$var$_close.default
    }));
$c4fb573ff5863452$var$CrossIcon.displayName = "CrossIcon";
var $c4fb573ff5863452$var$_default = module.exports.default = $c4fb573ff5863452$var$CrossIcon;

});
parcelRegister("5abBF", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $3c26e3c3616557da$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $7F9F3 = parcelRequire("7F9F3");
var $3c26e3c3616557da$var$_excluded = [
    "dangerouslySetGlyph"
];
var $3c26e3c3616557da$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $3c26e3c3616557da$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3c26e3c3616557da$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $3c26e3c3616557da$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $3c26e3c3616557da$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7F9F3.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("7F9F3", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $5943db3c45f1f309$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $3ZLXI = parcelRequire("3ZLXI");

var $1gQ7t = parcelRequire("1gQ7t");
function $5943db3c45f1f309$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5943db3c45f1f309$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5943db3c45f1f309$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5943db3c45f1f309$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $5943db3c45f1f309$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $5943db3c45f1f309$var$_objectSpread($5943db3c45f1f309$var$_objectSpread({}, (0, $3ZLXI.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $5943db3c45f1f309$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $5943db3c45f1f309$var$primaryEqualsSecondaryHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $5943db3c45f1f309$var$secondaryTransparentHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $5943db3c45f1f309$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $dnfL5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $3ZLXI.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $dnfL5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $1gQ7t.getBackground)(),
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $5943db3c45f1f309$var$iconStyles,
            $5943db3c45f1f309$var$baseHcmStyles,
            primaryColor === secondaryColor && $5943db3c45f1f309$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $5943db3c45f1f309$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dnfL5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $5943db3c45f1f309$export$2e2bcd8739ae039 = $5943db3c45f1f309$export$f04a61298a47a40f;

});
parcelRegister("3ZLXI", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $2e8c45ddffa1aad5$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $2e8c45ddffa1aad5$export$3eb7d6130acfda37);

var $b6oIt = parcelRequire("b6oIt");

var $dnfL5 = parcelRequire("dnfL5");
var $2e8c45ddffa1aad5$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $2e8c45ddffa1aad5$var$smallStyles = (0, $dnfL5.css)((0, $b6oIt.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $2e8c45ddffa1aad5$var$mediumStyles = (0, $dnfL5.css)((0, $b6oIt.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $2e8c45ddffa1aad5$var$largeStyles = (0, $dnfL5.css)((0, $b6oIt.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $2e8c45ddffa1aad5$var$xlargeStyles = (0, $dnfL5.css)((0, $b6oIt.dimensions).xlarge);
var $2e8c45ddffa1aad5$export$ef0ad74202575b64 = {
    small: $2e8c45ddffa1aad5$var$smallStyles,
    medium: $2e8c45ddffa1aad5$var$mediumStyles,
    large: $2e8c45ddffa1aad5$var$largeStyles,
    xlarge: $2e8c45ddffa1aad5$var$xlargeStyles
};
var $2e8c45ddffa1aad5$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $b6oIt.dimensions)[size];
    return undefined;
};

});
parcelRegister("b6oIt", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $81536d680280adfe$export$62ad7b0c781000e9);
var $81536d680280adfe$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $81536d680280adfe$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $81536d680280adfe$export$62ad7b0c781000e9 = {
    small: {
        width: $81536d680280adfe$export$c647cb0ee6e282fe.small,
        height: $81536d680280adfe$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $81536d680280adfe$export$c647cb0ee6e282fe.medium,
        height: $81536d680280adfe$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $81536d680280adfe$export$c647cb0ee6e282fe.large,
        height: $81536d680280adfe$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $81536d680280adfe$export$c647cb0ee6e282fe.xlarge,
        height: $81536d680280adfe$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("1gQ7t", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $0ecfb6ee41f3f23a$export$18cb9425622d4e06);
var $0ecfb6ee41f3f23a$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});






parcelRegister("2CLkt", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $1e93d7fc5728c9fe$export$33ffd74ebf07f060);

var $acw62 = parcelRequire("acw62");

var $38Qyh = parcelRequire("38Qyh");
var $1e93d7fc5728c9fe$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $acw62.useContext)((0, $38Qyh.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});


parcelRegister("lBcre", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb96b3a3fcbc8660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dnfL5 = parcelRequire("dnfL5");

var $erwi7 = parcelRequire("erwi7");

var $dnJxG = parcelRequire("dnJxG");

var $9itI1 = parcelRequire("9itI1");

var $2CLkt = parcelRequire("2CLkt");
var $fb96b3a3fcbc8660$var$iconColor = {
    danger: "var(--ds-icon-danger, ".concat((0, $9itI1.R400), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};
var $fb96b3a3fcbc8660$var$iconStyles = (0, $dnfL5.css)({
    flex: "0 0 auto",
    // The following properties have been added purely to avoid a global style override in Jira breaking alignment between the icon and title text.
    // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-legacy-frontend/jira-atlaskit-module/src/main/resources/jira-atlaskit-module/css/adg3-general-overrides.less?at=master#24
    // When the override is removed, these can be removed.
    color: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "inherit",
    fontStyle: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontWeight: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "inherit"
});
var $fb96b3a3fcbc8660$var$titleStyles = (0, $dnfL5.css)({
    display: "flex",
    minWidth: 0,
    margin: "var(--ds-space-0, 0px)",
    gap: "var(--ds-space-100, 8px)",
    font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
var $fb96b3a3fcbc8660$var$textStyles = (0, $dnfL5.css)({
    minWidth: 0,
    /**
   * This ensures that the element fills the whole header space
   * and its content does not overflow (since flex items don't
   * shrink past its content size by default).
   */ flex: "1 1 auto",
    wordWrap: "break-word"
});
var $fb96b3a3fcbc8660$var$truncatedTextStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $fb96b3a3fcbc8660$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($erwi7))) : (0, (/*@__PURE__*/$parcel$interopDefault($dnJxG)));
    return (0, $dnfL5.jsx)("span", {
        css: $fb96b3a3fcbc8660$var$iconStyles
    }, (0, $dnfL5.jsx)(Icon, {
        label: appearance,
        color: $fb96b3a3fcbc8660$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $fb96b3a3fcbc8660$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $2CLkt.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return(// eslint-disable-next-line @atlaskit/design-system/use-heading
    (0, $dnfL5.jsx)("h1", {
        css: $fb96b3a3fcbc8660$var$titleStyles,
        "data-testid": testId
    }, appearance && (0, $dnfL5.jsx)($fb96b3a3fcbc8660$var$TitleIcon, {
        appearance: appearance
    }), (0, $dnfL5.jsx)("span", {
        id: titleId,
        css: [
            $fb96b3a3fcbc8660$var$textStyles,
            !isMultiline && $fb96b3a3fcbc8660$var$truncatedTextStyles
        ],
        "data-testid": testId && "".concat(testId, "-text")
    }, children)));
};
var $fb96b3a3fcbc8660$export$2e2bcd8739ae039 = $fb96b3a3fcbc8660$var$ModalTitle;

});
parcelRegister("erwi7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a83ca2aafcef288d$var$_react = $a83ca2aafcef288d$var$_interopRequireDefault((parcelRequire("acw62")));

var $a83ca2aafcef288d$var$_error = $a83ca2aafcef288d$var$_interopRequireDefault((parcelRequire("1i4me")));

var $a83ca2aafcef288d$var$_error2 = $a83ca2aafcef288d$var$_interopRequireDefault((parcelRequire("gn1pT")));
function $a83ca2aafcef288d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a83ca2aafcef288d$var$ErrorIcon = (props)=>/*#__PURE__*/ $a83ca2aafcef288d$var$_react.default.createElement($a83ca2aafcef288d$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $a83ca2aafcef288d$var$_error2.default
    }, props));
$a83ca2aafcef288d$var$ErrorIcon.Name = "ErrorIconMigration";
var $a83ca2aafcef288d$var$_default = module.exports.default = $a83ca2aafcef288d$var$ErrorIcon;

});
parcelRegister("1i4me", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f0ada3766e05585$var$_react = $0f0ada3766e05585$var$_interopRequireDefault((parcelRequire("acw62")));

var $0f0ada3766e05585$var$_baseNew = $0f0ada3766e05585$var$_interopRequireDefault((parcelRequire("lxrKg")));
function $0f0ada3766e05585$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f0ada3766e05585$var$ErrorIcon = (props)=>/*#__PURE__*/ $0f0ada3766e05585$var$_react.default.createElement($0f0ada3766e05585$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$0f0ada3766e05585$var$ErrorIcon.displayName = "ErrorIcon";
var $0f0ada3766e05585$var$_default = module.exports.default = $0f0ada3766e05585$var$ErrorIcon;

});

parcelRegister("gn1pT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beafe4a6e6a5c51a$var$_react = $beafe4a6e6a5c51a$var$_interopRequireDefault((parcelRequire("acw62")));

var $5abBF = parcelRequire("5abBF");

var $beafe4a6e6a5c51a$var$_error = $beafe4a6e6a5c51a$var$_interopRequireDefault((parcelRequire("1i4me")));
function $beafe4a6e6a5c51a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $beafe4a6e6a5c51a$var$ErrorIcon = (props)=>/*#__PURE__*/ $beafe4a6e6a5c51a$var$_react.default.createElement($5abBF.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $beafe4a6e6a5c51a$var$_error.default
    }));
$beafe4a6e6a5c51a$var$ErrorIcon.displayName = "ErrorIcon";
var $beafe4a6e6a5c51a$var$_default = module.exports.default = $beafe4a6e6a5c51a$var$ErrorIcon;

});


parcelRegister("dnJxG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9be0c01988c166bb$var$_react = $9be0c01988c166bb$var$_interopRequireDefault((parcelRequire("acw62")));

var $9be0c01988c166bb$var$_warning = $9be0c01988c166bb$var$_interopRequireDefault((parcelRequire("k1u5B")));

var $9be0c01988c166bb$var$_warning2 = $9be0c01988c166bb$var$_interopRequireDefault((parcelRequire("kTq2H")));
function $9be0c01988c166bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9be0c01988c166bb$var$WarningIcon = (props)=>/*#__PURE__*/ $9be0c01988c166bb$var$_react.default.createElement($9be0c01988c166bb$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $9be0c01988c166bb$var$_warning2.default
    }, props));
$9be0c01988c166bb$var$WarningIcon.Name = "WarningIconMigration";
var $9be0c01988c166bb$var$_default = module.exports.default = $9be0c01988c166bb$var$WarningIcon;

});
parcelRegister("k1u5B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e93b3dc4c15bf0ba$var$_react = $e93b3dc4c15bf0ba$var$_interopRequireDefault((parcelRequire("acw62")));

var $e93b3dc4c15bf0ba$var$_baseNew = $e93b3dc4c15bf0ba$var$_interopRequireDefault((parcelRequire("lxrKg")));
function $e93b3dc4c15bf0ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e93b3dc4c15bf0ba$var$WarningIcon = (props)=>/*#__PURE__*/ $e93b3dc4c15bf0ba$var$_react.default.createElement($e93b3dc4c15bf0ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$e93b3dc4c15bf0ba$var$WarningIcon.displayName = "WarningIcon";
var $e93b3dc4c15bf0ba$var$_default = module.exports.default = $e93b3dc4c15bf0ba$var$WarningIcon;

});

parcelRegister("kTq2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f35d2537c69967f3$var$_react = $f35d2537c69967f3$var$_interopRequireDefault((parcelRequire("acw62")));

var $5abBF = parcelRequire("5abBF");

var $f35d2537c69967f3$var$_warning = $f35d2537c69967f3$var$_interopRequireDefault((parcelRequire("k1u5B")));
function $f35d2537c69967f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f35d2537c69967f3$var$WarningIcon = (props)=>/*#__PURE__*/ $f35d2537c69967f3$var$_react.default.createElement($5abBF.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $f35d2537c69967f3$var$_warning.default
    }));
$f35d2537c69967f3$var$WarningIcon.displayName = "WarningIcon";
var $f35d2537c69967f3$var$_default = module.exports.default = $f35d2537c69967f3$var$WarningIcon;

});



parcelRegister("88rak", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ec42499ed1d9d42$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $rZzKT = parcelRequire("rZzKT");

var $ltooA = parcelRequire("ltooA");

var $2CLkt = parcelRequire("2CLkt");

var $jPODm = parcelRequire("jPODm");

var $45eSG = parcelRequire("45eSG");
var $5ec42499ed1d9d42$var$bodyStyles = (0, $dnfL5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
var $5ec42499ed1d9d42$var$fontStyles = (0, $dnfL5.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $5ec42499ed1d9d42$var$bodyScrollStyles = (0, $dnfL5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $5ec42499ed1d9d42$var$viewportScrollStyles = (0, $dnfL5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $5ec42499ed1d9d42$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2CLkt.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $45eSG.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $dnfL5.jsx)("div", {
        css: [
            $5ec42499ed1d9d42$var$bodyStyles,
            $5ec42499ed1d9d42$var$viewportScrollStyles,
            (0, $ltooA.fg)("platform_ads_explicit_font_styles") && $5ec42499ed1d9d42$var$fontStyles
        ],
        "data-testid": testId
    }, children) : (0, $dnfL5.jsx)((0, $rZzKT.TouchScrollable), null, (0, $dnfL5.jsx)((0, $jPODm.default), {
        testId: userDefinedTestId || modalTestId
    }, (0, $dnfL5.jsx)("div", {
        css: [
            $5ec42499ed1d9d42$var$bodyStyles,
            $5ec42499ed1d9d42$var$bodyScrollStyles,
            (0, $ltooA.fg)("platform_ads_explicit_font_styles") && $5ec42499ed1d9d42$var$fontStyles
        ],
        "data-testid": testId
    }, children)));
};
var $5ec42499ed1d9d42$export$2e2bcd8739ae039 = $5ec42499ed1d9d42$var$ModalBody;

});
parcelRegister("jPODm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70a0e9187442adb$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $8fY35 = parcelRequire("8fY35");

var $ciU3d = parcelRequire("ciU3d");

var $g1536 = parcelRequire("g1536");

var $1kc0P = parcelRequire("1kc0P");

var $jVviY = parcelRequire("jVviY");

var $ea4YF = parcelRequire("ea4YF");

var $7sxmN = parcelRequire("7sxmN");

var $9itI1 = parcelRequire("9itI1");
var $e70a0e9187442adb$var$keylineColor = "var(--ds-border, ".concat((0, $9itI1.N30), ")");
var $e70a0e9187442adb$var$baseStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $7sxmN.media).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $e70a0e9187442adb$var$keylineHeight = 2;
var $e70a0e9187442adb$var$topKeylineStyles = (0, $dnfL5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $e70a0e9187442adb$var$keylineColor)
});
var $e70a0e9187442adb$var$bottomKeylineStyles = (0, $dnfL5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $e70a0e9187442adb$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $e70a0e9187442adb$var$ScrollContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $acw62.useEffect)(function() {
        var schedule = (0, $ciU3d.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $jVviY.default)((0, $ciU3d.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $e70a0e9187442adb$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $e70a0e9187442adb$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $acw62.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $8fY35.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $8fY35.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $1kc0P.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $dnfL5.jsx)((0, $ea4YF.default), {
        isInset: true
    }, (0, $dnfL5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $g1536.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $e70a0e9187442adb$var$baseStyles,
            showTopKeyline && $e70a0e9187442adb$var$topKeylineStyles,
            showBottomKeyline && $e70a0e9187442adb$var$bottomKeylineStyles
        ]
    }, children));
});
$e70a0e9187442adb$var$ScrollContainer.displayName = "ScrollContainer";
var $e70a0e9187442adb$export$2e2bcd8739ae039 = $e70a0e9187442adb$var$ScrollContainer;

});

parcelRegister("45eSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f932c1af30b1280$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $38Qyh = parcelRequire("38Qyh");
function $2f932c1af30b1280$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $acw62.useContext)((0, $38Qyh.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("hvoRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe89d8564ad665e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dnfL5 = parcelRequire("dnfL5");

var $2CLkt = parcelRequire("2CLkt");
var $cbe89d8564ad665e$var$footerStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $cbe89d8564ad665e$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2CLkt.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $dnfL5.jsx)("div", {
        css: $cbe89d8564ad665e$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $cbe89d8564ad665e$export$2e2bcd8739ae039 = $cbe89d8564ad665e$var$ModalFooter;

});


parcelRegister("fJTfv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5auEi")).default);
$parcel$export(module.exports, "LinkButton", () => (parcelRequire("1xy0A")).default);
$parcel$export(module.exports, "IconButton", () => (parcelRequire("ex8zQ")).default);
$parcel$export(module.exports, "LinkIconButton", () => (parcelRequire("fR0Px")).default);
$parcel$export(module.exports, "SplitButton", () => (parcelRequire("8lsKp")).SplitButton);

var $5auEi = parcelRequire("5auEi");

var $1xy0A = parcelRequire("1xy0A");

var $ex8zQ = parcelRequire("ex8zQ");

var $fR0Px = parcelRequire("fR0Px");

var $8lsKp = parcelRequire("8lsKp");

});
parcelRegister("5auEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c35a92e350d30d2$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $kX2bW = parcelRequire("kX2bW");

var $eKQ8o = parcelRequire("eKQ8o");
var $3c35a92e350d30d2$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $3c35a92e350d30d2$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $3c35a92e350d30d2$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3c35a92e350d30d2$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $3c35a92e350d30d2$var$_excluded2);
    var baseProps = (0, $eKQ8o.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kX2bW.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$3c35a92e350d30d2$var$Button.displayName = "Button";
var $3c35a92e350d30d2$export$2e2bcd8739ae039 = $3c35a92e350d30d2$var$Button;

});
parcelRegister("kX2bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40b048500f88479$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $jmqGD = parcelRequire("jmqGD");

var $8Fp8I = parcelRequire("8Fp8I");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $gV2F5 = parcelRequire("gV2F5");

var $8uEB5 = parcelRequire("8uEB5");
var $f40b048500f88479$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $f40b048500f88479$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $f40b048500f88479$var$focusRingStyles = (0, $dnfL5.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $gV2F5.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $gV2F5.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $gV2F5.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $f40b048500f88479$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $f40b048500f88479$var$enabledStyles = (0, $dnfL5.css)({
    cursor: "pointer"
});
var $f40b048500f88479$var$disabledStyles = (0, $dnfL5.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $f40b048500f88479$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8Fp8I.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $f40b048500f88479$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $5ZZ0M.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $jmqGD.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $f40b048500f88479$var$_excluded2);
    var resolvedStyles = (0, $8uEB5.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $dnfL5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $f40b048500f88479$var$baseStyles,
            $f40b048500f88479$var$focusRingStyles,
            isDisabled ? $f40b048500f88479$var$disabledStyles : $f40b048500f88479$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $gV2F5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $gV2F5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $gV2F5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $gV2F5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $gV2F5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $gV2F5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $gV2F5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $gV2F5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $f40b048500f88479$export$2e2bcd8739ae039 = $f40b048500f88479$var$Pressable;

});
parcelRegister("jmqGD", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $e184c5cc614e2f7f$export$a4687b0234b40e28);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8xLFK = parcelRequire("8xLFK");

var $5i9fe = parcelRequire("5i9fe");
function $e184c5cc614e2f7f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e184c5cc614e2f7f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e184c5cc614e2f7f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e184c5cc614e2f7f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e184c5cc614e2f7f$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8xLFK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $5i9fe.useTrackedRef)(analyticsData);
    var fnRef = (0, $5i9fe.useTrackedRef)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e184c5cc614e2f7f$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("8xLFK", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $6386628b7bea6536$export$5bf35293e545f20c);

var $6Bvm3 = parcelRequire("6Bvm3");

var $e3Hec = parcelRequire("e3Hec");

var $i6h2G = parcelRequire("i6h2G");
function $6386628b7bea6536$export$5bf35293e545f20c() {
    var analyticsContext = (0, $i6h2G.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $e3Hec.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("e3Hec", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c2e0af4fd563b7$export$2e2bcd8739ae039);

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $37VIw = parcelRequire("37VIw");
function $a3c2e0af4fd563b7$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a3c2e0af4fd563b7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a3c2e0af4fd563b7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a3c2e0af4fd563b7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a3c2e0af4fd563b7$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a3c2e0af4fd563b7$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a3c2e0af4fd563b7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $a3c2e0af4fd563b7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $a3c2e0af4fd563b7$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a3c2e0af4fd563b7$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $37VIw.default));

});
parcelRegister("37VIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $246ecbf5efed795d$export$2e2bcd8739ae039);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $246ecbf5efed795d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $246ecbf5efed795d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $246ecbf5efed795d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $246ecbf5efed795d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $246ecbf5efed795d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $246ecbf5efed795d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $246ecbf5efed795d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $246ecbf5efed795d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $246ecbf5efed795d$var$_objectSpread($246ecbf5efed795d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("i6h2G", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $d2d601c4fb00550c$export$d1f587f82ad51c4);

var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $d2d601c4fb00550c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};

});


parcelRegister("5i9fe", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $3da5ce03ee33be14$export$1d27a74659855e44);

var $acw62 = parcelRequire("acw62");
var $3da5ce03ee33be14$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("8Fp8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f5a73d72d63bb8$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $64f5a73d72d63bb8$export$2e2bcd8739ae039() {}

});

parcelRegister("5ZZ0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $01208c49d164d1dd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $01208c49d164d1dd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});

parcelRegister("gV2F5", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $c51408c12a582155$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $c51408c12a582155$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $c51408c12a582155$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $c51408c12a582155$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $c51408c12a582155$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $c51408c12a582155$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $c51408c12a582155$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $c51408c12a582155$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $c51408c12a582155$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $c51408c12a582155$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $c51408c12a582155$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $c51408c12a582155$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $c51408c12a582155$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $c51408c12a582155$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $c51408c12a582155$export$e615f061ca585a6c);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $c51408c12a582155$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $c51408c12a582155$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $c51408c12a582155$export$5e65a44e5b6ecadb);

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $ldEg9 = parcelRequire("ldEg9");
function $c51408c12a582155$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c51408c12a582155$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c51408c12a582155$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c51408c12a582155$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c51408c12a582155$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $c51408c12a582155$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $c51408c12a582155$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $c51408c12a582155$export$632685d741f3dbbf = $c51408c12a582155$var$_objectSpread($c51408c12a582155$var$_objectSpread({}, $c51408c12a582155$export$958d0ae7f2977ae4), $c51408c12a582155$export$d2dc61f58390201c);
var $c51408c12a582155$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $c51408c12a582155$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $c51408c12a582155$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $c51408c12a582155$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $c51408c12a582155$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $c51408c12a582155$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $c51408c12a582155$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $c51408c12a582155$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $c51408c12a582155$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $c51408c12a582155$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $c51408c12a582155$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $c51408c12a582155$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $c51408c12a582155$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $c51408c12a582155$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $c51408c12a582155$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $c51408c12a582155$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $c51408c12a582155$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $c51408c12a582155$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $c51408c12a582155$export$e615f061ca585a6c = $c51408c12a582155$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c51408c12a582155$export$ca0f9c2de39ffed7(spacingProperty, $c51408c12a582155$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c51408c12a582155$export$bf46c3f9eeafc71f = $c51408c12a582155$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c51408c12a582155$export$ca0f9c2de39ffed7(spacingProperty, $c51408c12a582155$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c51408c12a582155$export$e7af83bafe7f9e63 = $c51408c12a582155$export$ca0f9c2de39ffed7("backgroundColor", $c51408c12a582155$export$d1d79bf68ac056bd);
var $c51408c12a582155$export$3a1bcba60b23d7f0 = $c51408c12a582155$export$ca0f9c2de39ffed7("color", $c51408c12a582155$export$8473307aa00d6ea1);
var $c51408c12a582155$export$45f3f4fe16f9f7d5 = $c51408c12a582155$export$ca0f9c2de39ffed7("fontWeight", $c51408c12a582155$export$303e322c6b1ed114);
var $c51408c12a582155$export$68cc305da27dbaa4 = $c51408c12a582155$export$ca0f9c2de39ffed7("fontFamily", $c51408c12a582155$export$3c7e9587132614b4);
var $c51408c12a582155$export$128f10c238242f83 = $c51408c12a582155$export$ca0f9c2de39ffed7("font", $c51408c12a582155$export$6ffa317d5e70375);
var $c51408c12a582155$export$219d364c0da35ae4 = $c51408c12a582155$export$ca0f9c2de39ffed7("font", $c51408c12a582155$export$236bfe3a33ef1292);
var $c51408c12a582155$export$38845ca010b93505 = $c51408c12a582155$export$ca0f9c2de39ffed7("fontWeight", $c51408c12a582155$export$855cfd311192d666);
var $c51408c12a582155$export$ff257d957d48c421 = $c51408c12a582155$export$ca0f9c2de39ffed7((0, $ldEg9.CURRENT_SURFACE_CSS_VAR), $c51408c12a582155$export$41a358c9c2356760);
var $c51408c12a582155$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $c51408c12a582155$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("ldEg9", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $f72a0a9216e5cd23$export$9d7b58831ae93caa);
var $f72a0a9216e5cd23$export$4ef52930e33717cd = "data-theme";
var $f72a0a9216e5cd23$export$a00eac3f8684bcd0 = "data-color-mode";
var $f72a0a9216e5cd23$export$2112803007239c61 = "data-contrast-mode";
var $f72a0a9216e5cd23$export$352e418ed5b6193a = "data-custom-theme";
var $f72a0a9216e5cd23$export$2faeed762aac6741 = "light";
var $f72a0a9216e5cd23$export$6f0c6fb8c80fcc92 = "ds";
var $f72a0a9216e5cd23$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $f72a0a9216e5cd23$export$dddac1532e822863 = "--".concat($f72a0a9216e5cd23$export$6f0c6fb8c80fcc92, "-token-not-found");
var $f72a0a9216e5cd23$export$9d7b58831ae93caa = "--".concat($f72a0a9216e5cd23$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("8uEB5", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $62f09dcf5d564102$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $62f09dcf5d564102$export$f6c783d06584602c);

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");

var $gV2F5 = parcelRequire("gV2F5");

var $hPtJY = parcelRequire("hPtJY");
function $62f09dcf5d564102$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $62f09dcf5d564102$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $62f09dcf5d564102$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $62f09dcf5d564102$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $62f09dcf5d564102$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $62f09dcf5d564102$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $62f09dcf5d564102$export$9a199fbafee0014e = {
    backgroundColor: (0, $gV2F5.backgroundColorMap),
    blockSize: (0, $gV2F5.dimensionMap),
    borderBlockColor: (0, $gV2F5.borderColorMap),
    borderBlockEndColor: (0, $gV2F5.borderColorMap),
    borderBlockEndWidth: (0, $gV2F5.borderWidthMap),
    borderBlockStartColor: (0, $gV2F5.borderColorMap),
    borderBlockStartWidth: (0, $gV2F5.borderWidthMap),
    borderBlockWidth: (0, $gV2F5.borderWidthMap),
    borderBottomColor: (0, $gV2F5.borderColorMap),
    borderBottomLeftRadius: (0, $gV2F5.borderRadiusMap),
    borderBottomRightRadius: (0, $gV2F5.borderRadiusMap),
    borderBottomWidth: (0, $gV2F5.borderWidthMap),
    borderColor: (0, $gV2F5.borderColorMap),
    borderEndEndRadius: (0, $gV2F5.borderRadiusMap),
    borderEndStartRadius: (0, $gV2F5.borderRadiusMap),
    borderInlineColor: (0, $gV2F5.borderColorMap),
    borderInlineEndColor: (0, $gV2F5.borderColorMap),
    borderInlineEndWidth: (0, $gV2F5.borderWidthMap),
    borderInlineStartColor: (0, $gV2F5.borderColorMap),
    borderInlineStartWidth: (0, $gV2F5.borderWidthMap),
    borderInlineWidth: (0, $gV2F5.borderWidthMap),
    borderLeftColor: (0, $gV2F5.borderColorMap),
    borderLeftWidth: (0, $gV2F5.borderWidthMap),
    borderRadius: (0, $gV2F5.borderRadiusMap),
    borderRightColor: (0, $gV2F5.borderColorMap),
    borderRightWidth: (0, $gV2F5.borderWidthMap),
    borderStartEndRadius: (0, $gV2F5.borderRadiusMap),
    borderStartStartRadius: (0, $gV2F5.borderRadiusMap),
    borderTopColor: (0, $gV2F5.borderColorMap),
    borderTopLeftRadius: (0, $gV2F5.borderRadiusMap),
    borderTopRightRadius: (0, $gV2F5.borderRadiusMap),
    borderTopWidth: (0, $gV2F5.borderWidthMap),
    borderWidth: (0, $gV2F5.borderWidthMap),
    bottom: (0, $gV2F5.allSpaceMap),
    boxShadow: (0, $gV2F5.shadowMap),
    color: (0, $gV2F5.textColorMap),
    columnGap: (0, $gV2F5.positiveSpaceMap),
    font: (0, $gV2F5.fontMap),
    fontFamily: (0, $gV2F5.fontFamilyMap),
    fontWeight: (0, $gV2F5.fontWeightMap),
    gap: (0, $gV2F5.positiveSpaceMap),
    height: (0, $gV2F5.dimensionMap),
    inlineSize: (0, $gV2F5.dimensionMap),
    inset: (0, $gV2F5.allSpaceMap),
    insetBlock: (0, $gV2F5.allSpaceMap),
    insetBlockEnd: (0, $gV2F5.allSpaceMap),
    insetBlockStart: (0, $gV2F5.allSpaceMap),
    insetInline: (0, $gV2F5.allSpaceMap),
    insetInlineEnd: (0, $gV2F5.allSpaceMap),
    insetInlineStart: (0, $gV2F5.allSpaceMap),
    left: (0, $gV2F5.allSpaceMap),
    margin: (0, $gV2F5.allSpaceMap),
    marginBlock: (0, $gV2F5.allSpaceMap),
    marginBlockEnd: (0, $gV2F5.allSpaceMap),
    marginBlockStart: (0, $gV2F5.allSpaceMap),
    marginBottom: (0, $gV2F5.allSpaceMap),
    marginInline: (0, $gV2F5.allSpaceMap),
    marginInlineEnd: (0, $gV2F5.allSpaceMap),
    marginInlineStart: (0, $gV2F5.allSpaceMap),
    marginLeft: (0, $gV2F5.allSpaceMap),
    marginRight: (0, $gV2F5.allSpaceMap),
    marginTop: (0, $gV2F5.allSpaceMap),
    maxBlockSize: (0, $gV2F5.dimensionMap),
    maxHeight: (0, $gV2F5.dimensionMap),
    maxInlineSize: (0, $gV2F5.dimensionMap),
    maxWidth: (0, $gV2F5.dimensionMap),
    minBlockSize: (0, $gV2F5.dimensionMap),
    minHeight: (0, $gV2F5.dimensionMap),
    minInlineSize: (0, $gV2F5.dimensionMap),
    minWidth: (0, $gV2F5.dimensionMap),
    opacity: (0, $gV2F5.opacityMap),
    outlineColor: (0, $gV2F5.borderColorMap),
    outlineOffset: (0, $gV2F5.positiveSpaceMap),
    outlineWidth: (0, $gV2F5.borderWidthMap),
    padding: (0, $gV2F5.positiveSpaceMap),
    paddingBlock: (0, $gV2F5.positiveSpaceMap),
    paddingBlockEnd: (0, $gV2F5.positiveSpaceMap),
    paddingBlockStart: (0, $gV2F5.positiveSpaceMap),
    paddingBottom: (0, $gV2F5.positiveSpaceMap),
    paddingInline: (0, $gV2F5.positiveSpaceMap),
    paddingInlineEnd: (0, $gV2F5.positiveSpaceMap),
    paddingInlineStart: (0, $gV2F5.positiveSpaceMap),
    paddingLeft: (0, $gV2F5.positiveSpaceMap),
    paddingRight: (0, $gV2F5.positiveSpaceMap),
    paddingTop: (0, $gV2F5.positiveSpaceMap),
    right: (0, $gV2F5.allSpaceMap),
    rowGap: (0, $gV2F5.positiveSpaceMap),
    top: (0, $gV2F5.allSpaceMap),
    width: (0, $gV2F5.dimensionMap),
    zIndex: (0, $gV2F5.layerMap)
};
var $62f09dcf5d564102$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $62f09dcf5d564102$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $62f09dcf5d564102$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $62f09dcf5d564102$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $62f09dcf5d564102$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($62f09dcf5d564102$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $62f09dcf5d564102$var$safeSelectors.test(key)) {
            styleObj[key] = $62f09dcf5d564102$var$_transformStyles(value);
            return;
        }
        if ($62f09dcf5d564102$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($62f09dcf5d564102$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $62f09dcf5d564102$export$9a199fbafee0014e)) return;
        var tokenValue = $62f09dcf5d564102$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $62f09dcf5d564102$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $62f09dcf5d564102$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $62f09dcf5d564102$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $62f09dcf5d564102$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $62f09dcf5d564102$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $62f09dcf5d564102$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$62f09dcf5d564102$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $62f09dcf5d564102$export$f6c783d06584602c(style) {
    return $62f09dcf5d564102$var$baseXcss(style);
}

});


parcelRegister("eKQ8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $abddcd6355918bd4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $i9C2O = parcelRequire("i9C2O");

var $28LTS = parcelRequire("28LTS");

var $l3DEQ = parcelRequire("l3DEQ");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $abddcd6355918bd4$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $l3DEQ.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9C2O.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28LTS.default), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9C2O.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9C2O.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28LTS.default), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $abddcd6355918bd4$export$2e2bcd8739ae039 = $abddcd6355918bd4$var$useDefaultButton;

});
parcelRegister("i9C2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37694192d229f8a$export$2e2bcd8739ae039);

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $3cNTD = parcelRequire("3cNTD");
var $8uEB5 = parcelRequire("8uEB5");
var $d37694192d229f8a$var$textStyles = (0, $8uEB5.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $d37694192d229f8a$var$iconStyles = (0, $8uEB5.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: "none"
});
var $d37694192d229f8a$var$commonStyles = (0, $8uEB5.xcss)({
    transition: "opacity 0.3s"
});
var $d37694192d229f8a$var$fadeStyles = (0, $8uEB5.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $d37694192d229f8a$var$beforeIconStyles = (0, $8uEB5.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $d37694192d229f8a$var$afterIconStyles = (0, $8uEB5.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $d37694192d229f8a$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cNTD.default), {
        as: "span",
        xcss: [
            $d37694192d229f8a$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(type === "text" ? [
            $d37694192d229f8a$var$textStyles
        ] : [
            $d37694192d229f8a$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(isLoading ? [
            $d37694192d229f8a$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(position === "before" ? [
            $d37694192d229f8a$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(position === "after" ? [
            $d37694192d229f8a$var$afterIconStyles
        ] : []))
    }, children);
};
var $d37694192d229f8a$export$2e2bcd8739ae039 = $d37694192d229f8a$var$Content;

});
parcelRegister("3cNTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $25593273d6717e98$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $bNoxA = parcelRequire("bNoxA");

var $gV2F5 = parcelRequire("gV2F5");

var $8uEB5 = parcelRequire("8uEB5");
var $25593273d6717e98$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $25593273d6717e98$var$_excluded2 = [
    "className"
];
var $25593273d6717e98$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $25593273d6717e98$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $25593273d6717e98$var$_excluded2);
    var resolvedStyles = (0, $8uEB5.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $25593273d6717e98$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $gV2F5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gV2F5.isSurfaceColorToken)(backgroundColor) && (0, $gV2F5.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $gV2F5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $gV2F5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $gV2F5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $gV2F5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $gV2F5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $gV2F5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $gV2F5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $dnfL5.jsx)((0, $bNoxA.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $25593273d6717e98$export$2e2bcd8739ae039 = $25593273d6717e98$export$e71c4d32a2263218;
var $25593273d6717e98$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("bNoxA", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $89674e996f8d21f1$export$1ca2a26fecb070ae);

var $acw62 = parcelRequire("acw62");
var $89674e996f8d21f1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $89674e996f8d21f1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($89674e996f8d21f1$export$1ca2a26fecb070ae);
};
$89674e996f8d21f1$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("28LTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f17c1764d9b71d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $18f17c1764d9b71d$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $18f17c1764d9b71d$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $18f17c1764d9b71d$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $18f17c1764d9b71d$export$2e2bcd8739ae039 = $18f17c1764d9b71d$var$IconRenderer;

});

parcelRegister("l3DEQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f548a3f99ffdb00c$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $ktKrw = parcelRequire("ktKrw");

var $6LYcs = parcelRequire("6LYcs");

var $lNWR1 = parcelRequire("lNWR1");

var $ltooA = parcelRequire("ltooA");

var $3cNTD = parcelRequire("3cNTD");
var $8uEB5 = parcelRequire("8uEB5");

var $5XtxN = parcelRequire("5XtxN");

var $gq1Fg = parcelRequire("gq1Fg");

var $jGZSH = parcelRequire("jGZSH");

var $7Fize = parcelRequire("7Fize");

var $4sCMo = parcelRequire("4sCMo");

var $eoiyN = parcelRequire("eoiyN");
function $f548a3f99ffdb00c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f548a3f99ffdb00c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f548a3f99ffdb00c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f548a3f99ffdb00c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// If updating `buttonStyles`, also update `buttonStylesWithRem`.
var $f548a3f99ffdb00c$var$buttonStyles = (0, $8uEB5.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: "font.body",
    fontWeight: "font.weight.medium",
    paddingBlock: "space.075",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $f548a3f99ffdb00c$var$buttonStylesWithRem = (0, $8uEB5.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "2rem",
    font: "font.body",
    fontWeight: "font.weight.medium",
    paddingBlock: "space.075",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $f548a3f99ffdb00c$var$defaultInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($5XtxN.N500, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($5XtxN.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($5XtxN.B400, ")")
    }
});
var $f548a3f99ffdb00c$var$defaultInteractiveRefreshedStyles = (0, $8uEB5.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $f548a3f99ffdb00c$var$defaultStyles = (0, $8uEB5.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($5XtxN.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($5XtxN.N500, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($5XtxN.N500, ")")
    }
});
var $f548a3f99ffdb00c$var$defaultRefreshedStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    }
});
var $f548a3f99ffdb00c$var$primaryStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $f548a3f99ffdb00c$var$primaryInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $f548a3f99ffdb00c$var$warningStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $f548a3f99ffdb00c$var$warningInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $f548a3f99ffdb00c$var$dangerStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $f548a3f99ffdb00c$var$dangerInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $f548a3f99ffdb00c$var$discoveryStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $f548a3f99ffdb00c$var$discoveryInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $f548a3f99ffdb00c$var$subtleStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $f548a3f99ffdb00c$var$subtleRefreshedStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    }
});
var $f548a3f99ffdb00c$var$subtleInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $f548a3f99ffdb00c$var$subtleInteractiveRefreshedStyles = (0, $8uEB5.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $f548a3f99ffdb00c$var$linkDecorationUnsetStyles = (0, $8uEB5.xcss)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $f548a3f99ffdb00c$var$disabledStyles = (0, $8uEB5.xcss)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($5XtxN.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($5XtxN.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($5XtxN.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    "::after": {
        content: "none"
    }
});
var $f548a3f99ffdb00c$var$selectedStyles = (0, $8uEB5.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($5XtxN.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")")
    }
});
var $f548a3f99ffdb00c$var$selectedRefreshedStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    }
});
var $f548a3f99ffdb00c$var$selectedInsideSplitButtonStyles = (0, $8uEB5.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $f548a3f99ffdb00c$var$selectedInteractiveStyles = (0, $8uEB5.xcss)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($5XtxN.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($5XtxN.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f548a3f99ffdb00c$var$selectedWarningStyles = (0, $8uEB5.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($5XtxN.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($5XtxN.N800, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($5XtxN.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($5XtxN.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f548a3f99ffdb00c$var$selectedDangerStyles = (0, $8uEB5.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($5XtxN.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($5XtxN.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($5XtxN.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f548a3f99ffdb00c$var$selectedDiscoveryStyles = (0, $8uEB5.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($5XtxN.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
// If updating `spacingCompactStyles`, also update `spacingCompactStylesWithRem`.
var $f548a3f99ffdb00c$var$spacingCompactStyles = (0, $8uEB5.xcss)({
    columnGap: "space.050",
    height: "".concat(24 / 14, "em"),
    paddingBlock: "space.025",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $f548a3f99ffdb00c$var$spacingCompactStylesWithRem = (0, $8uEB5.xcss)({
    columnGap: "space.050",
    height: "1.5rem",
    paddingBlock: "space.025",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $f548a3f99ffdb00c$var$circleStyles = (0, $8uEB5.xcss)({
    borderRadius: "border.radius.circle"
});
var $f548a3f99ffdb00c$var$fullWidthStyles = (0, $8uEB5.xcss)({
    width: "100%"
});
var $f548a3f99ffdb00c$var$loadingStyles = (0, $8uEB5.xcss)({
    cursor: "progress"
});
// If updating `iconButtonStyles`, also update `iconButtonStylesWithRem`.
var $f548a3f99ffdb00c$var$iconButtonStyles = (0, $8uEB5.xcss)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $f548a3f99ffdb00c$var$iconButtonStylesWithRem = (0, $8uEB5.xcss)({
    height: "2rem",
    width: "2rem",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
// If updating `iconButtonCompactStyles`, also update `iconButtonCompactStylesWithRem`.
var $f548a3f99ffdb00c$var$iconButtonCompactStyles = (0, $8uEB5.xcss)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $f548a3f99ffdb00c$var$iconButtonCompactStylesWithRem = (0, $8uEB5.xcss)({
    width: "1.5rem",
    height: "1.5rem"
});
var $f548a3f99ffdb00c$var$buttonIconBeforeStyles = (0, $8uEB5.xcss)({
    paddingInlineStart: "space.100"
});
var $f548a3f99ffdb00c$var$buttonIconAfterStyles = (0, $8uEB5.xcss)({
    paddingInlineEnd: "space.100"
});
var $f548a3f99ffdb00c$var$splitButtonStyles = (0, $8uEB5.xcss)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $f548a3f99ffdb00c$var$navigationSplitButtonStyles = (0, $8uEB5.xcss)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $f548a3f99ffdb00c$var$loadingOverlayStyles = (0, $8uEB5.xcss)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $f548a3f99ffdb00c$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $acw62.useRef)(null);
    var splitButtonContext = (0, $jGZSH.useSplitButtonContext)();
    var loadingLabelId = (0, $lNWR1.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $ltooA.fg)("platform-component-visual-refresh") ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $6LYcs.default)(localRef, autoFocus);
    return $f548a3f99ffdb00c$var$_objectSpread({
        ref: (0, $ktKrw.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $f548a3f99ffdb00c$var$buttonStylesWithRem : $f548a3f99ffdb00c$var$buttonStyles,
            appearance === "default" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $f548a3f99ffdb00c$var$defaultRefreshedStyles : $f548a3f99ffdb00c$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $f548a3f99ffdb00c$var$defaultInteractiveRefreshedStyles : $f548a3f99ffdb00c$var$defaultInteractiveStyles),
            appearance === "primary" && $f548a3f99ffdb00c$var$primaryStyles,
            appearance === "primary" && isInteractive && $f548a3f99ffdb00c$var$primaryInteractiveStyles,
            appearance === "warning" && $f548a3f99ffdb00c$var$warningStyles,
            appearance === "warning" && isInteractive && $f548a3f99ffdb00c$var$warningInteractiveStyles,
            appearance === "danger" && $f548a3f99ffdb00c$var$dangerStyles,
            appearance === "danger" && isInteractive && $f548a3f99ffdb00c$var$dangerInteractiveStyles,
            appearance === "discovery" && $f548a3f99ffdb00c$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $f548a3f99ffdb00c$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $f548a3f99ffdb00c$var$subtleRefreshedStyles : $f548a3f99ffdb00c$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $f548a3f99ffdb00c$var$subtleInteractiveRefreshedStyles : $f548a3f99ffdb00c$var$subtleInteractiveStyles),
            $f548a3f99ffdb00c$var$linkDecorationUnsetStyles,
            isSelected && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $f548a3f99ffdb00c$var$selectedRefreshedStyles : $f548a3f99ffdb00c$var$selectedStyles),
            isSelected && isSplitButton && $f548a3f99ffdb00c$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $f548a3f99ffdb00c$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $f548a3f99ffdb00c$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $f548a3f99ffdb00c$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $f548a3f99ffdb00c$var$selectedDiscoveryStyles,
            isDisabled && $f548a3f99ffdb00c$var$disabledStyles,
            isCircle && !isSplitButton && $f548a3f99ffdb00c$var$circleStyles,
            spacing === "compact" && ((0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $f548a3f99ffdb00c$var$spacingCompactStylesWithRem : $f548a3f99ffdb00c$var$spacingCompactStyles),
            hasIconBefore && $f548a3f99ffdb00c$var$buttonIconBeforeStyles,
            hasIconAfter && $f548a3f99ffdb00c$var$buttonIconAfterStyles,
            isIconButton && ((0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $f548a3f99ffdb00c$var$iconButtonStylesWithRem : $f548a3f99ffdb00c$var$iconButtonStyles),
            isIconButton && spacing === "compact" && ((0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $f548a3f99ffdb00c$var$iconButtonCompactStylesWithRem : $f548a3f99ffdb00c$var$iconButtonCompactStyles),
            shouldFitContainer && $f548a3f99ffdb00c$var$fullWidthStyles,
            isLoading && $f548a3f99ffdb00c$var$loadingStyles,
            isSplitButton && $f548a3f99ffdb00c$var$splitButtonStyles,
            isNavigationSplitButton && $f548a3f99ffdb00c$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jGZSH.SplitButtonContext).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cNTD.default), {
            as: "span",
            xcss: $f548a3f99ffdb00c$var$loadingOverlayStyles
        }, (0, $eoiyN.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gq1Fg.default), {
            id: loadingLabelId
        }, (0, $4sCMo.LOADING_LABEL))),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $4sCMo.LOADING_LABEL)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $7Fize.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $f548a3f99ffdb00c$export$2e2bcd8739ae039 = $f548a3f99ffdb00c$var$useButtonBase;

});
parcelRegister("ktKrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee8a8aa67a016236$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $ee8a8aa67a016236$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("6LYcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee5d44b0138a0b5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $4ee5d44b0138a0b5$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("lNWR1", function(module, exports) {

$parcel$export(module.exports, "useId", () => $fdfbd3cb370f3a2d$export$f680877a34711e37);
$parcel$export(module.exports, "useIdSeed", () => $fdfbd3cb370f3a2d$export$6ee17796e3d70de2);

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $98BOi = parcelRequire("98BOi");

var $ltooA = parcelRequire("ltooA");
var $fdfbd3cb370f3a2d$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $fdfbd3cb370f3a2d$var$react18UseId = ($fdfbd3cb370f3a2d$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $fdfbd3cb370f3a2d$var$_React$useId !== void 0 ? $fdfbd3cb370f3a2d$var$_React$useId : undefined;
function $fdfbd3cb370f3a2d$export$f680877a34711e37() {
    if ($fdfbd3cb370f3a2d$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $fdfbd3cb370f3a2d$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $98BOi.useUID)());
}
var $fdfbd3cb370f3a2d$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($fdfbd3cb370f3a2d$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $fdfbd3cb370f3a2d$export$6ee17796e3d70de2() {
    if ($fdfbd3cb370f3a2d$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $fdfbd3cb370f3a2d$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $98BOi.useUIDSeed)();
}

});

parcelRegister("5XtxN", function(module, exports) {

$parcel$export(module.exports, "R500", () => $45696148fe27ebba$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y400", () => $45696148fe27ebba$export$59619663aa6500fb);
$parcel$export(module.exports, "B75", () => $45696148fe27ebba$export$8c13c2ee36917869);
$parcel$export(module.exports, "B200", () => $45696148fe27ebba$export$215b7063051591f1);
$parcel$export(module.exports, "B400", () => $45696148fe27ebba$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "N0", () => $45696148fe27ebba$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $45696148fe27ebba$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $45696148fe27ebba$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $45696148fe27ebba$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N100", () => $45696148fe27ebba$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $45696148fe27ebba$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $45696148fe27ebba$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N500", () => $45696148fe27ebba$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N700", () => $45696148fe27ebba$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $45696148fe27ebba$export$7d61b15e0da132af);
$parcel$export(module.exports, "N20A", () => $45696148fe27ebba$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $45696148fe27ebba$export$920c0d5c49070351);
$parcel$export(module.exports, "N50A", () => $45696148fe27ebba$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $45696148fe27ebba$export$d2d3bedfb276cac0);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $45696148fe27ebba$export$4b84fd0e2c617bd = "#FFEBE6";
var $45696148fe27ebba$export$b34b069eff244586 = "#FFBDAD";
var $45696148fe27ebba$export$be802dd0d8b57f35 = "#FF8F73";
var $45696148fe27ebba$export$60847d42f9da92a6 = "#FF7452";
var $45696148fe27ebba$export$4a7404f376229999 = "#FF5630";
var $45696148fe27ebba$export$2010d0fb4295b346 = "#DE350B";
var $45696148fe27ebba$export$2837b5a1a71d5c02 = "#BF2600";
var $45696148fe27ebba$export$8d9596b529bbb9cf = "#FFFAE6";
var $45696148fe27ebba$export$41060a744ab0b7ae = "#FFF0B3";
var $45696148fe27ebba$export$1cc05bbbf340e559 = "#FFE380";
var $45696148fe27ebba$export$5aae31392d72caaa = "#FFC400";
var $45696148fe27ebba$export$c6930421db9fa514 = "#FFAB00";
var $45696148fe27ebba$export$59619663aa6500fb = "#FF991F";
var $45696148fe27ebba$export$874739ea9e379ab6 = "#FF8B00";
var $45696148fe27ebba$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $45696148fe27ebba$export$69a3bf21b9686c2b = "#ABF5D1";
var $45696148fe27ebba$export$afbce1382ec95f73 = "#79F2C0";
var $45696148fe27ebba$export$747d86715d4175de = "#57D9A3";
var $45696148fe27ebba$export$940e1f69e873f202 = "#36B37E";
var $45696148fe27ebba$export$a49394138f7b8e85 = "#00875A";
var $45696148fe27ebba$export$6fa04827ac68a4fb = "#006644";
var $45696148fe27ebba$export$226de0355ed012f8 = "#DEEBFF";
var $45696148fe27ebba$export$8c13c2ee36917869 = "#B3D4FF";
var $45696148fe27ebba$export$ecfc1dff386a3e7a = "#4C9AFF";
var $45696148fe27ebba$export$215b7063051591f1 = "#2684FF";
var $45696148fe27ebba$export$e62e8919cca44969 = "#0065FF";
var $45696148fe27ebba$export$b3de0ae08da2ce64 = "#0052CC";
var $45696148fe27ebba$export$a6ee3d71bc067634 = "#0747A6";
var $45696148fe27ebba$export$67f15409e87642a1 = "#669DF1";
var $45696148fe27ebba$export$f0539dbc42dbb067 = "#8FB8F6";
var $45696148fe27ebba$export$363e4475840015bb = "#EAE6FF";
var $45696148fe27ebba$export$4b0a4417ed59760f = "#C0B6F2";
var $45696148fe27ebba$export$6011520a64d9a187 = "#998DD9";
var $45696148fe27ebba$export$a7175d4e9206bc80 = "#8777D9";
var $45696148fe27ebba$export$b48405b95304b5a1 = "#6554C0";
var $45696148fe27ebba$export$c71e4279dd54a18d = "#5243AA";
var $45696148fe27ebba$export$147899de772240ec = "#403294";
var $45696148fe27ebba$export$2cf711fe14c66f06 = "#E6FCFF";
var $45696148fe27ebba$export$7a8f4d33f6f9772c = "#B3F5FF";
var $45696148fe27ebba$export$776c9c497ef08533 = "#79E2F2";
var $45696148fe27ebba$export$69cb3ca10c1e330e = "#00C7E6";
var $45696148fe27ebba$export$9dc1ef0f3f48059b = "#00B8D9";
var $45696148fe27ebba$export$7c835c78b6fcdef8 = "#00A3BF";
var $45696148fe27ebba$export$6036577f95c3877e = "#008DA6";
var $45696148fe27ebba$export$29a4f05edc054374 = "#FFFFFF";
var $45696148fe27ebba$export$e655ef011c4aa1a2 = "#FAFBFC";
var $45696148fe27ebba$export$9fdfb749e33cdf97 = "#F4F5F7";
var $45696148fe27ebba$export$3e51e8f1440314ba = "#EBECF0";
var $45696148fe27ebba$export$1ce2d1575d444ceb = "#DFE1E6";
var $45696148fe27ebba$export$8754fc7e6d8b3000 = "#C1C7D0";
var $45696148fe27ebba$export$c2e91cbeada39b8b = "#B3BAC5";
var $45696148fe27ebba$export$5f71e19f3a7ad9de = "#A5ADBA";
var $45696148fe27ebba$export$eaa8c8a70ac22806 = "#97A0AF";
var $45696148fe27ebba$export$7c87d337fb91a97d = "#8993A4";
var $45696148fe27ebba$export$d6447c357493214f = "#7A869A";
var $45696148fe27ebba$export$f563ee71e9ee74cd = "#6B778C";
var $45696148fe27ebba$export$e2ef2124cf4024b1 = "#5E6C84";
var $45696148fe27ebba$export$eece5f492e429f08 = "#505F79";
var $45696148fe27ebba$export$c39c0fe0f26207ae = "#42526E";
var $45696148fe27ebba$export$7090862dc3038a9f = "#344563";
var $45696148fe27ebba$export$ad0bacf983b7ddaa = "#253858";
var $45696148fe27ebba$export$7d61b15e0da132af = "#172B4D";
var $45696148fe27ebba$export$fbda843f0a27fe96 = "#091E42";
var $45696148fe27ebba$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $45696148fe27ebba$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $45696148fe27ebba$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $45696148fe27ebba$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $45696148fe27ebba$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $45696148fe27ebba$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $45696148fe27ebba$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $45696148fe27ebba$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $45696148fe27ebba$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $45696148fe27ebba$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $45696148fe27ebba$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $45696148fe27ebba$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $45696148fe27ebba$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $45696148fe27ebba$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $45696148fe27ebba$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $45696148fe27ebba$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $45696148fe27ebba$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $45696148fe27ebba$export$2f6319cf7d736c2a = "#E6EDFA";
var $45696148fe27ebba$export$95126bc8884d6634 = "#DCE5F5";
var $45696148fe27ebba$export$8338d8c35d44ff1 = "#CED9EB";
var $45696148fe27ebba$export$5368d76ae4fbbda7 = "#B8C7E0";
var $45696148fe27ebba$export$9f0a771d16ec8d36 = "#ABBBD6";
var $45696148fe27ebba$export$abcf8c38338b4aa5 = "#9FB0CC";
var $45696148fe27ebba$export$97e81faa16a182c7 = "#8C9CB8";
var $45696148fe27ebba$export$bfe21c59123ecf33 = "#7988A3";
var $45696148fe27ebba$export$ee82aa2ea6a1558 = "#67758F";
var $45696148fe27ebba$export$682927c6ed76be02 = "#56637A";
var $45696148fe27ebba$export$91fd9994c5be9757 = "#455166";
var $45696148fe27ebba$export$d281fbfe3cff2df6 = "#3B475C";
var $45696148fe27ebba$export$3902c91d8b98a753 = "#313D52";
var $45696148fe27ebba$export$8e8133c1ba5845b5 = "#283447";
var $45696148fe27ebba$export$33ff357f6620b39 = "#202B3D";
var $45696148fe27ebba$export$633847cf062b69e0 = "#1B2638";
var $45696148fe27ebba$export$9776a6e503bdbf76 = "#121A29";
var $45696148fe27ebba$export$6c813d5160dff5db = "#0E1624";
var $45696148fe27ebba$export$3d4f271a500072a = "#0D1424";
var $45696148fe27ebba$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $45696148fe27ebba$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $45696148fe27ebba$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $45696148fe27ebba$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $45696148fe27ebba$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $45696148fe27ebba$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $45696148fe27ebba$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $45696148fe27ebba$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $45696148fe27ebba$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $45696148fe27ebba$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $45696148fe27ebba$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $45696148fe27ebba$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $45696148fe27ebba$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $45696148fe27ebba$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $45696148fe27ebba$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $45696148fe27ebba$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $45696148fe27ebba$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $45696148fe27ebba$export$d2adc5dedf09fced = "#292A2E";
var $45696148fe27ebba$export$f51762073d2bb381 = "#94C748";
var $45696148fe27ebba$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("gq1Fg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf405d9b84df866c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dnfL5 = parcelRequire("dnfL5");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $bf405d9b84df866c$var$visuallyHiddenStyles = (0, $dnfL5.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $bf405d9b84df866c$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $dnfL5.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $bf405d9b84df866c$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $bf405d9b84df866c$export$2e2bcd8739ae039 = $bf405d9b84df866c$var$VisuallyHidden;

});

parcelRegister("jGZSH", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $e561f0df21e34b99$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $e561f0df21e34b99$export$47e2c6fdb142d947);

var $acw62 = parcelRequire("acw62");
var $e561f0df21e34b99$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e561f0df21e34b99$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $acw62.useContext)($e561f0df21e34b99$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("7Fize", function(module, exports) {

$parcel$export(module.exports, "default", () => $594ac3cdfa71cb07$export$2e2bcd8739ae039);
function $594ac3cdfa71cb07$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $594ac3cdfa71cb07$var$tabKeyCode = 9;
function $594ac3cdfa71cb07$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $594ac3cdfa71cb07$var$tabKeyCode) return;
    $594ac3cdfa71cb07$var$abort(event);
}
function $594ac3cdfa71cb07$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $594ac3cdfa71cb07$var$abort,
        onMouseUpCapture: $594ac3cdfa71cb07$var$abort,
        onKeyDownCapture: $594ac3cdfa71cb07$var$onKey,
        onKeyUpCapture: $594ac3cdfa71cb07$var$onKey,
        onTouchStartCapture: $594ac3cdfa71cb07$var$abort,
        onTouchEndCapture: $594ac3cdfa71cb07$var$abort,
        onPointerDownCapture: $594ac3cdfa71cb07$var$abort,
        onPointerUpCapture: $594ac3cdfa71cb07$var$abort,
        onClickCapture: $594ac3cdfa71cb07$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $594ac3cdfa71cb07$var$abort
    } : events;
}

});

parcelRegister("4sCMo", function(module, exports) {

$parcel$export(module.exports, "LOADING_LABEL", () => $33f7dbc4cc36aee4$export$d4c5499dc806c969);
var $33f7dbc4cc36aee4$export$d4c5499dc806c969 = ", Loading";

});

parcelRegister("eoiyN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a1b43f280b026a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7d1TM = parcelRequire("7d1TM");
function $a7a1b43f280b026a$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $a7a1b43f280b026a$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $a7a1b43f280b026a$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7d1TM.default), {
        size: $a7a1b43f280b026a$var$getIconSpacing(spacing),
        appearance: $a7a1b43f280b026a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("7d1TM", function(module, exports) {

$parcel$export(module.exports, "default", () => $53fb385d6d73f043$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9dvtP = parcelRequire("9dvtP");

var $acw62 = parcelRequire("acw62");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $5XtxN = parcelRequire("5XtxN");

var $9yTKR = parcelRequire("9yTKR");
/**
 * Returns the appropriate circle stroke color.
 */ function $53fb385d6d73f043$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $5XtxN.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $5XtxN.N0), ")");
}
var $53fb385d6d73f043$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $53fb385d6d73f043$var$loadIn = null;
var $53fb385d6d73f043$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $53fb385d6d73f043$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $53fb385d6d73f043$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $9yTKR.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $53fb385d6d73f043$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $5ZZ0M.default));
    $53fb385d6d73f043$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9dvtP.default)([
            $53fb385d6d73f043$var$styles.wrapperStyles,
            $53fb385d6d73f043$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $9dvtP.default)([
            $53fb385d6d73f043$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $9dvtP.default)([
            $53fb385d6d73f043$var$styles.circleStyles
        ])
    })));
}));
var $53fb385d6d73f043$export$2e2bcd8739ae039 = $53fb385d6d73f043$var$Spinner;

});
parcelRegister("9yTKR", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $6f6289c914fa0a13$export$4e9f1640bbe7a1a8);
var $6f6289c914fa0a13$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






parcelRegister("1xy0A", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f340e1fc194f88$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jIJoC = parcelRequire("jIJoC");

var $eKQ8o = parcelRequire("eKQ8o");
var $11f340e1fc194f88$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $11f340e1fc194f88$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $11f340e1fc194f88$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $11f340e1fc194f88$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $11f340e1fc194f88$var$_excluded2);
    var baseProps = (0, $eKQ8o.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "link",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jIJoC.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? "link" : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $11f340e1fc194f88$var$WithRef = /*#__PURE__*/ (0, $acw62.forwardRef)($11f340e1fc194f88$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $11f340e1fc194f88$var$LinkButton = /*#__PURE__*/ (0, $acw62.memo)($11f340e1fc194f88$var$WithRef);
var $11f340e1fc194f88$export$2e2bcd8739ae039 = $11f340e1fc194f88$var$LinkButton;

});
parcelRegister("jIJoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b4792593db5c99$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $bv4qN = parcelRequire("bv4qN");

var $jmqGD = parcelRequire("jmqGD");

var $gBTNE = parcelRequire("gBTNE");

var $8Fp8I = parcelRequire("8Fp8I");

var $lNWR1 = parcelRequire("lNWR1");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $gq1Fg = parcelRequire("gq1Fg");

var $gV2F5 = parcelRequire("gV2F5");

var $8uEB5 = parcelRequire("8uEB5");
var $03b4792593db5c99$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $03b4792593db5c99$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $03b4792593db5c99$var$focusRingStyles = (0, $dnfL5.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $gV2F5.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $gV2F5.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $gV2F5.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $03b4792593db5c99$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    textDecoration: "underline"
});
var $03b4792593db5c99$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $03b4792593db5c99$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $03b4792593db5c99$var$OPENS_NEW_WINDOW_LABEL = "(opens new window)";
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $03b4792593db5c99$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8Fp8I.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $03b4792593db5c99$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $5ZZ0M.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $lNWR1.useId)();
    var onClick = (0, $jmqGD.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $03b4792593db5c99$var$_excluded2);
    var resolvedStyles = (0, $8uEB5.parseXcss)(xcss);
    var RouterLink = (0, $gBTNE.default)();
    var isExternal = typeof href === "string" && $03b4792593db5c99$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $03b4792593db5c99$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(href) === "object";
    (0, $bv4qN.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $03b4792593db5c99$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $03b4792593db5c99$var$baseStyles,
            $03b4792593db5c99$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $gV2F5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $gV2F5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $gV2F5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $gV2F5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $gV2F5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $gV2F5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $gV2F5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $gV2F5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $dnfL5.jsx)((0, $gq1Fg.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $03b4792593db5c99$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $03b4792593db5c99$var$Anchor = /*#__PURE__*/ (0, $acw62.forwardRef)($03b4792593db5c99$var$AnchorNoRef);
var $03b4792593db5c99$export$2e2bcd8739ae039 = $03b4792593db5c99$var$Anchor;

});
parcelRegister("bv4qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});

parcelRegister("gBTNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17b62b9b57762f6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1mNrs = parcelRequire("1mNrs");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $c17b62b9b57762f6$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $acw62.useContext)((0, $1mNrs.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $c17b62b9b57762f6$export$2e2bcd8739ae039 = $c17b62b9b57762f6$var$useRouterLink;

});
parcelRegister("1mNrs", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $0fee329e951ab7bf$export$2931e0ee690eee88);

var $acw62 = parcelRequire("acw62");
var $0fee329e951ab7bf$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $acw62.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $0fee329e951ab7bf$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0fee329e951ab7bf$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $0fee329e951ab7bf$export$2e2bcd8739ae039 = $0fee329e951ab7bf$var$RouterLinkProvider;

});




parcelRegister("ex8zQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a94acd0100dcddbe$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $kX2bW = parcelRequire("kX2bW");

var $6xdv4 = parcelRequire("6xdv4");

var $bDR2g = parcelRequire("bDR2g");
var $a94acd0100dcddbe$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $a94acd0100dcddbe$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $a94acd0100dcddbe$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a94acd0100dcddbe$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $a94acd0100dcddbe$var$_excluded2);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $bDR2g.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xdv4.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kX2bW.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
                // Top level props
                "aria-labelledby": baseProps["aria-labelledby"],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kX2bW.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$a94acd0100dcddbe$var$IconButton.displayName = "IconButton";
var $a94acd0100dcddbe$export$2e2bcd8739ae039 = $a94acd0100dcddbe$var$IconButton;

});
parcelRegister("6xdv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c204c026d17e101$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $96Ysd = parcelRequire("96Ysd");

var $8Fp8I = parcelRequire("8Fp8I");

var $lwuw9 = parcelRequire("lwuw9");

var $cmWAs = parcelRequire("cmWAs");

var $jsXt1 = parcelRequire("jsXt1");

var $aXr2X = parcelRequire("aXr2X");
var $9Vm2Y = parcelRequire("9Vm2Y");

var $lotGV = parcelRequire("lotGV");

var $8RdnZ = parcelRequire("8RdnZ");

var $cFKGy = parcelRequire("cFKGy");

var $jK360 = parcelRequire("jK360");

var $bEBzM = parcelRequire("bEBzM");

var $5PsSE = parcelRequire("5PsSE");

var $k0J32 = parcelRequire("k0J32");

var $cwQgS = parcelRequire("cwQgS");
function $4c204c026d17e101$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c204c026d17e101$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c204c026d17e101$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c204c026d17e101$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c204c026d17e101$var$tooltipZIndex = (0, $cFKGy.layers).tooltip();
var $4c204c026d17e101$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.2.0"
};
// Inverts motion direction
var $4c204c026d17e101$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $4c204c026d17e101$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $4c204c026d17e101$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $k0J32.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8Fp8I.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8Fp8I.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $96Ysd.usePlatformLeafSyntheticEventHandler)($4c204c026d17e101$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $4c204c026d17e101$var$analyticsAttributes));
    var onHideHandler = (0, $96Ysd.usePlatformLeafSyntheticEventHandler)($4c204c026d17e101$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $4c204c026d17e101$var$analyticsAttributes));
    var apiRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $acw62.useRef)(null);
    var containerRef = (0, $acw62.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $acw62.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $cmWAs.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $cmWAs.default)(onShowHandler);
    var onHideHandlerStable = (0, $cmWAs.default)(onHideHandler);
    var delayStable = (0, $cmWAs.default)(delay);
    var canAppearStable = (0, $cmWAs.default)(canAppear);
    var hasCalledShowHandler = (0, $acw62.useRef)(false);
    var start = (0, $acw62.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $acw62.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        return (0, $jK360.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $acw62.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $bEBzM.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $acw62.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $lwuw9.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $acw62.useEffect)(function() {
        if (state === "hide") return 0, $8Fp8I.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $cwQgS.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $cwQgS.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $acw62.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $acw62.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $acw62.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $acw62.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    (0, $jsXt1.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $5PsSE.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $acw62.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children($4c204c026d17e101$var$_objectSpread($4c204c026d17e101$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8RdnZ.default), {
        zIndex: $4c204c026d17e101$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lotGV.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $4c204c026d17e101$var$invertedDirection[$4c204c026d17e101$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aXr2X.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9Vm2Y.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $4c204c026d17e101$var$_objectSpread($4c204c026d17e101$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$4c204c026d17e101$var$Tooltip.displayName = "Tooltip";
var $4c204c026d17e101$export$2e2bcd8739ae039 = $4c204c026d17e101$var$Tooltip;

});
parcelRegister("96Ysd", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $6a2391824944bf7c$export$1a04351537078b55);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8xLFK = parcelRequire("8xLFK");

var $5i9fe = parcelRequire("5i9fe");
function $6a2391824944bf7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a2391824944bf7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a2391824944bf7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a2391824944bf7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6a2391824944bf7c$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8xLFK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $5i9fe.useTrackedRef)(analyticsData);
    var fnRef = (0, $5i9fe.useTrackedRef)(fn);
    var handler = (0, $acw62.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $6a2391824944bf7c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("lwuw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fab4424b2ef75b1d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $dXy8E = parcelRequire("dXy8E");
function $fab4424b2ef75b1d$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $dXy8E.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("dXy8E", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", () => $a29b443ad73e180b$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $a29b443ad73e180b$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_HOME", () => $a29b443ad73e180b$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $a29b443ad73e180b$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $a29b443ad73e180b$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $a29b443ad73e180b$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $a29b443ad73e180b$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $a29b443ad73e180b$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $a29b443ad73e180b$export$390330c10ff2b9a1 = "ArrowUp";
var $a29b443ad73e180b$export$a80636c6f41931fe = "ArrowDown";
var $a29b443ad73e180b$export$4af703091671bc = "Home";
var $a29b443ad73e180b$export$e2bc30913faa5db7 = "End";
var $a29b443ad73e180b$export$10f6869ed0a7d75b = "Tab";
var $a29b443ad73e180b$export$8152f929a25a0ff4 = "Enter";
var $a29b443ad73e180b$export$e51a3576c045c8d5 = "Space";
var $a29b443ad73e180b$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("cmWAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9014fc42566f22cd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9014fc42566f22cd$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("jsXt1", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $e2bec2c259ca1195$export$469bb693f11edc7f);

var $acw62 = parcelRequire("acw62");

var $5zlGe = parcelRequire("5zlGe");
function $e2bec2c259ca1195$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $acw62.useContext)((0, $5zlGe.OpenLayerObserverContext));
    (0, $acw62.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("5zlGe", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", () => $40e109d9b294b7ad$export$5fbf4d7fae6cdc00);

var $acw62 = parcelRequire("acw62");
var $40e109d9b294b7ad$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});


parcelRegister("aXr2X", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", () => $7fa464f50e935d44$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $7fa464f50e935d44$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $15Iwc = parcelRequire("15Iwc");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $7fa464f50e935d44$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $7fa464f50e935d44$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($7fa464f50e935d44$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $7fa464f50e935d44$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7fa464f50e935d44$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7fa464f50e935d44$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $7fa464f50e935d44$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $7fa464f50e935d44$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $7fa464f50e935d44$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $7fa464f50e935d44$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $7fa464f50e935d44$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $7fa464f50e935d44$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $15Iwc.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $7fa464f50e935d44$var$childrenToArray(previousChildren);
    var current = $7fa464f50e935d44$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $7fa464f50e935d44$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $7fa464f50e935d44$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $7fa464f50e935d44$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $7fa464f50e935d44$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $7fa464f50e935d44$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($7fa464f50e935d44$var$ExitingContext);
};
$7fa464f50e935d44$var$ExitingPersistence.displayName = "ExitingPersistence";
var $7fa464f50e935d44$export$2e2bcd8739ae039 = $7fa464f50e935d44$var$ExitingPersistence;

});
parcelRegister("15Iwc", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", () => $0cb8ca80fb3a1915$export$b7baf7667a68d87c);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $0cb8ca80fb3a1915$export$f0f789643ba5a83c);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $0cb8ca80fb3a1915$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $0cb8ca80fb3a1915$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$0cb8ca80fb3a1915$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $0cb8ca80fb3a1915$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($0cb8ca80fb3a1915$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$0cb8ca80fb3a1915$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $0cb8ca80fb3a1915$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $0cb8ca80fb3a1915$export$ff7706047246b98b = function prefersReducedMotion() {
    return $0cb8ca80fb3a1915$export$f0f789643ba5a83c;
};

});


parcelRegister("9Vm2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $739a89f90b433068$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jhmoX = parcelRequire("jhmoX");
function $739a89f90b433068$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $739a89f90b433068$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $739a89f90b433068$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $739a89f90b433068$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $739a89f90b433068$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $739a89f90b433068$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $739a89f90b433068$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $739a89f90b433068$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $739a89f90b433068$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $739a89f90b433068$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $739a89f90b433068$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $739a89f90b433068$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $739a89f90b433068$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $739a89f90b433068$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jhmoX.default), {
        duration: duration,
        enteringAnimation: $739a89f90b433068$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $739a89f90b433068$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $739a89f90b433068$export$2e2bcd8739ae039 = $739a89f90b433068$var$FadeIn;

});
parcelRegister("jhmoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e090fb4f617ec12d$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $15Iwc = parcelRequire("15Iwc");

var $cD0eL = parcelRequire("cD0eL");

var $e3d2i = parcelRequire("e3d2i");

var $aXr2X = parcelRequire("aXr2X");

var $gg5Ec = parcelRequire("gg5Ec");
function $e090fb4f617ec12d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e090fb4f617ec12d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e090fb4f617ec12d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e090fb4f617ec12d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $e090fb4f617ec12d$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $gg5Ec.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $aXr2X.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $e3d2i.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $cD0eL.exitingDurations)[duration] : (0, $cD0eL.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dnfL5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? cx(css($e090fb4f617ec12d$var$_objectSpread($e090fb4f617ec12d$var$_objectSpread({}, (0, $15Iwc.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationFillMode: "backwards",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $dnfL5.keyframes)(enteringAnimation),
                animationPlayState: "running"
            })), paused && css({
                animationPlayState: "paused"
            }), duration === "small" && css({
                animationDuration: "100ms"
            }), duration === "medium" && css({
                animationDuration: "350ms"
            }), duration === "large" && css({
                animationDuration: "700ms"
            }), isExiting && duration === "small" && css({
                animationDuration: "50ms"
            }), isExiting && duration === "medium" && css({
                animationDuration: "175ms"
            }), isExiting && duration === "large" && css({
                animationDuration: "350ms"
            }), isExiting && css({
                animationDelay: "0ms",
                animationFillMode: "forwards",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $dnfL5.keyframes)(exitingAnimation)
            }), !isExiting && animationTimingFunction === "linear" && css({
                animationTimingFunction: "cubic-bezier(0,0,1,1)"
            }), !isExiting && animationTimingFunction === "ease-out" && css({
                animationTimingFunction: "cubic-bezier(0.2,0,0,1)"
            }), !isExiting && animationTimingFunction === "ease-in" && css({
                animationTimingFunction: "cubic-bezier(0.8,0,0,0.8)"
            }), !isExiting && animationTimingFunction === "ease-in-out" && css({
                animationTimingFunction: "cubic-bezier(0.15,1,0.3,1)"
            }), isExiting && animationTimingFunction === "linear" && css({
                animationTimingFunction: "cubic-bezier(0,0,1,1)"
            }), isExiting && animationTimingFunctionExiting === "ease-out" && css({
                animationTimingFunction: "cubic-bezier(0.2,0,0,1)"
            }), isExiting && animationTimingFunctionExiting === "ease-in" && css({
                animationTimingFunction: "cubic-bezier(0.8,0,0,0.8)"
            }), isExiting && animationTimingFunctionExiting === "ease-in-out" && css({
                animationTimingFunction: "cubic-bezier(0.15,1,0.3,1)"
            })) : ""
        }, state);
    });
};
var $e090fb4f617ec12d$export$2e2bcd8739ae039 = $e090fb4f617ec12d$var$EnteringMotion;

});
parcelRegister("cD0eL", function(module, exports) {

$parcel$export(module.exports, "durations", () => $93194fa4d980c905$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $93194fa4d980c905$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $93194fa4d980c905$export$368bacef0dacbe05 = 25;
var $93194fa4d980c905$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $93194fa4d980c905$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $93194fa4d980c905$export$30fa1a2e62ae150c = {
    none: $93194fa4d980c905$export$38b928a7167ce124.none,
    small: $93194fa4d980c905$export$38b928a7167ce124.small * $93194fa4d980c905$var$EXITING_MOTION_MULTIPLIER,
    medium: $93194fa4d980c905$export$38b928a7167ce124.medium * $93194fa4d980c905$var$EXITING_MOTION_MULTIPLIER,
    large: $93194fa4d980c905$export$38b928a7167ce124.large * $93194fa4d980c905$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("e3d2i", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", () => $a3ab752ab794bde4$export$4f34107a2b00f39c);

var $acw62 = parcelRequire("acw62");
var $a3ab752ab794bde4$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $a3ab752ab794bde4$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a3ab752ab794bde4$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $a3ab752ab794bde4$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a3ab752ab794bde4$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("gg5Ec", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", () => $bd62856e3acad54c$export$25c7213fc07ec080);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8Fp8I = parcelRequire("8Fp8I");

var $5SYIx = parcelRequire("5SYIx");

var $5hP1V = parcelRequire("5hP1V");
var $bd62856e3acad54c$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $8Fp8I.default)
    };
});
var $bd62856e3acad54c$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $5hP1V.useUniqueId)();
    var context = (0, $acw62.useContext)($bd62856e3acad54c$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $bd62856e3acad54c$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $5SYIx.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bd62856e3acad54c$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $bd62856e3acad54c$export$2e2bcd8739ae039 = $bd62856e3acad54c$var$StaggeredEntrance;

});
parcelRegister("5SYIx", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $4491181c4f69a136$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
var $4491181c4f69a136$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);

});

parcelRegister("5hP1V", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $3d961fcb1665d839$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $3d961fcb1665d839$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("lotGV", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $f932def3c493a54a$export$badac9ada3a0bdf9);

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $bqx5F = parcelRequire("bqx5F");

var $iY8pz = parcelRequire("iY8pz");

// Export types from PopperJS / React Popper
var $f932def3c493a54a$var$viewportPadding = 5;
var $f932def3c493a54a$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $f932def3c493a54a$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $f932def3c493a54a$var$defaultChildrenFn() {
    return null;
}
var $f932def3c493a54a$var$defaultOffset = [
    0,
    8
];
function $f932def3c493a54a$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $f932def3c493a54a$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $f932def3c493a54a$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $f932def3c493a54a$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $iY8pz.getMaxSizeModifiers)({
            viewportPadding: $f932def3c493a54a$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($f932def3c493a54a$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bqx5F.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("iY8pz", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", () => $dcf45ae9244051f0$export$6d8c2b45c99d6e3f);

var $02Ztr = parcelRequire("02Ztr");
function $dcf45ae9244051f0$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("8RdnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $672da81be7ca5b3e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $cjBu0 = parcelRequire("cjBu0");

var $astSF = parcelRequire("astSF");

var $if2nf = parcelRequire("if2nf");

var $8l4y9 = parcelRequire("8l4y9");
function $672da81be7ca5b3e$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $if2nf.default)(mountStrategy);
    (0, $8l4y9.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjBu0.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $astSF.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("cjBu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7455be7a6ba7e6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2D1nS = parcelRequire("2D1nS");
function $8f7455be7a6ba7e6$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $2D1nS.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $2D1nS.appendPortalContainerIfNotAppended)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $2D1nS.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}

});
parcelRegister("2D1nS", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $1ea04c1f9d393eb7$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $1ea04c1f9d393eb7$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $1ea04c1f9d393eb7$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $1ea04c1f9d393eb7$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $1ea04c1f9d393eb7$export$95029ca7aca2989e);

var $cHr2S = parcelRequire("cHr2S");
var $1ea04c1f9d393eb7$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $cHr2S.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $1ea04c1f9d393eb7$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $1ea04c1f9d393eb7$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $cHr2S.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $cHr2S.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $1ea04c1f9d393eb7$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $1ea04c1f9d393eb7$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $1ea04c1f9d393eb7$var$getPortalParent().removeChild(container);
};
var $1ea04c1f9d393eb7$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $1ea04c1f9d393eb7$var$getPortalParent().appendChild(container);
};
var $1ea04c1f9d393eb7$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $1ea04c1f9d393eb7$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($1ea04c1f9d393eb7$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $cHr2S.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $1ea04c1f9d393eb7$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($1ea04c1f9d393eb7$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $cHr2S.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $cHr2S.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $1ea04c1f9d393eb7$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("cHr2S", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", () => $93ee7adc8de8aeda$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $93ee7adc8de8aeda$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $93ee7adc8de8aeda$export$13f57c02915787b3);
var $93ee7adc8de8aeda$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $93ee7adc8de8aeda$export$72f415121273627e = "body > .atlaskit-portal-container";
var $93ee7adc8de8aeda$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("astSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $79d3b2939555529d$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $ltooA = parcelRequire("ltooA");

var $bYAbr = parcelRequire("bYAbr");

var $2D1nS = parcelRequire("2D1nS");
function $79d3b2939555529d$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $bYAbr.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $2D1nS.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $2D1nS.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $ltooA.fg)("platform_design_system_suspend_portal_children") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("bYAbr", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $024005a36aca3dd8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $024005a36aca3dd8$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});


parcelRegister("if2nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47b781fb30f7d2e$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $bYAbr = parcelRequire("bYAbr");
var $d47b781fb30f7d2e$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $bYAbr.useIsomorphicLayoutEffect) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $d47b781fb30f7d2e$export$2e2bcd8739ae039 = $d47b781fb30f7d2e$var$useIsSubsequentRender;

});

parcelRegister("8l4y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6123d0625f10b154$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eYyee = parcelRequire("eYyee");

var $XdoYh = parcelRequire("XdoYh");
var $6123d0625f10b154$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $XdoYh.default)((0, $eYyee.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $XdoYh.default)((0, $eYyee.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $6123d0625f10b154$export$2e2bcd8739ae039 = $6123d0625f10b154$var$useFirePortalEvent;

});
parcelRegister("eYyee", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $ae713862168cb931$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $ae713862168cb931$export$80816bd900e5bd00);
var $ae713862168cb931$export$ed5835cc67e87f72 = "akPortalMount";
var $ae713862168cb931$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("XdoYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b1fe81d2cb332a6$export$2e2bcd8739ae039);
var $0b1fe81d2cb332a6$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $0b1fe81d2cb332a6$var$getLayerName = function getLayerName(zIndex) {
    return $0b1fe81d2cb332a6$var$zIndexToName.hasOwnProperty(zIndex) ? $0b1fe81d2cb332a6$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $0b1fe81d2cb332a6$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $0b1fe81d2cb332a6$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $0b1fe81d2cb332a6$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $0b1fe81d2cb332a6$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("cFKGy", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $939d871d84b72bf2$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "layers", () => $939d871d84b72bf2$export$7be255094ccdc533);

var $gbB1D = parcelRequire("gbB1D");

var $5XtxN = parcelRequire("5XtxN");
var $939d871d84b72bf2$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $939d871d84b72bf2$export$c93026a968943f95 = "light";
var $939d871d84b72bf2$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $939d871d84b72bf2$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $939d871d84b72bf2$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $939d871d84b72bf2$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5XtxN.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $939d871d84b72bf2$export$6d8204c2cb2e06b8() / 4;
    (0, $gbB1D.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $939d871d84b72bf2$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $939d871d84b72bf2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $939d871d84b72bf2$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $gbB1D.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $939d871d84b72bf2$export$ba1d834b86d72a09 = $939d871d84b72bf2$export$a1b3edb637fb4f35;
var $939d871d84b72bf2$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5XtxN.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5XtxN.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5XtxN.N30A), ")")
            }
        }
    };
};

});
parcelRegister("gbB1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8a64e8d47007a3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "propDeprecationWarning", () => $bc8a64e8d47007a3$export$eb1decd851a5ae56);

var $hbdwH = parcelRequire("hbdwH");

var $hPtJY = parcelRequire("hPtJY");
function $bc8a64e8d47007a3$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $hbdwH.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $bc8a64e8d47007a3$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}

});
parcelRegister("hbdwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c81df4d37150b29d$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $c81df4d37150b29d$var$printed = {};
function $c81df4d37150b29d$export$2e2bcd8739ae039(message) {
    if ($c81df4d37150b29d$var$printed[message]) return;
    $c81df4d37150b29d$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("jK360", function(module, exports) {

$parcel$export(module.exports, "register", () => $e5f4b6f66653eb61$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $8fY35 = parcelRequire("8fY35");
var $e5f4b6f66653eb61$var$registrations = new Set();
var $e5f4b6f66653eb61$var$cleanupEndEventListeners = null;
function $e5f4b6f66653eb61$var$onDragStart() {
    if ($e5f4b6f66653eb61$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $e5f4b6f66653eb61$var$cleanupEndEventListeners = (0, $8fY35.bindAll)(window, [
        {
            type: "dragend",
            listener: $e5f4b6f66653eb61$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $e5f4b6f66653eb61$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $e5f4b6f66653eb61$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($e5f4b6f66653eb61$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $e5f4b6f66653eb61$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $e5f4b6f66653eb61$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $e5f4b6f66653eb61$var$cleanupEndEventListeners = null;
    var clone = Array.from($e5f4b6f66653eb61$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $e5f4b6f66653eb61$var$bindStartEvents() {
    return (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: $e5f4b6f66653eb61$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $e5f4b6f66653eb61$var$onDragStart
        }
    ]);
}
var $e5f4b6f66653eb61$var$cleanupStartEventListeners = null;
function $e5f4b6f66653eb61$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$e5f4b6f66653eb61$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $e5f4b6f66653eb61$var$cleanupStartEventListeners = $e5f4b6f66653eb61$var$bindStartEvents();
    $e5f4b6f66653eb61$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $e5f4b6f66653eb61$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $e5f4b6f66653eb61$var$registrations.delete(registration);
        if ($e5f4b6f66653eb61$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $e5f4b6f66653eb61$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $e5f4b6f66653eb61$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("bEBzM", function(module, exports) {

$parcel$export(module.exports, "show", () => $87c093f7f2f7c6c4$export$57bf213be019eeb0);

var $9isGb = parcelRequire("9isGb");
// This file is a singleton for managing tooltips
var $87c093f7f2f7c6c4$var$active = null;
function $87c093f7f2f7c6c4$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($87c093f7f2f7c6c4$var$active && $87c093f7f2f7c6c4$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $9isGb.clearScheduled)();
            $87c093f7f2f7c6c4$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $9isGb.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $9isGb.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $9isGb.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($87c093f7f2f7c6c4$var$active && $87c093f7f2f7c6c4$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($87c093f7f2f7c6c4$var$active) {
            (0, $9isGb.clearScheduled)();
            $87c093f7f2f7c6c4$var$active.entry.hide({
                isImmediate: true
            });
            $87c093f7f2f7c6c4$var$active.entry.done();
            $87c093f7f2f7c6c4$var$active = null;
        }
        // this tooltip is now the active tooltip
        $87c093f7f2f7c6c4$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $9isGb.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("9isGb", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $6c4c0aa1423d571f$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $6c4c0aa1423d571f$export$5f4d6617421d489b);
var $6c4c0aa1423d571f$var$delayId = null;
function $6c4c0aa1423d571f$export$eaf678f6f93f5250() {
    if ($6c4c0aa1423d571f$var$delayId != null) {
        window.clearTimeout($6c4c0aa1423d571f$var$delayId);
        $6c4c0aa1423d571f$var$delayId = null;
    }
}
function $6c4c0aa1423d571f$export$5f4d6617421d489b(fn, delay) {
    $6c4c0aa1423d571f$export$eaf678f6f93f5250();
    $6c4c0aa1423d571f$var$delayId = window.setTimeout(function() {
        $6c4c0aa1423d571f$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("5PsSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e81e3c430de8a2$export$2e2bcd8739ae039);

var $lNWR1 = parcelRequire("lNWR1");
function $43e81e3c430de8a2$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $lNWR1.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("k0J32", function(module, exports) {

$parcel$export(module.exports, "default", () => $e916c054e2b8714e$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $5cymf = parcelRequire("5cymf");

var $5XtxN = parcelRequire("5XtxN");

var $gnf5p = parcelRequire("gnf5p");
function $e916c054e2b8714e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e916c054e2b8714e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e916c054e2b8714e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e916c054e2b8714e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e916c054e2b8714e$var$baseStyles = null;
var $e916c054e2b8714e$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $e916c054e2b8714e$var$TooltipContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement((0, $gnf5p.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9dvtP.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $e916c054e2b8714e$var$_objectSpread($e916c054e2b8714e$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $5cymf.default)("var(--ds-background-neutral-bold, ".concat((0, $5XtxN.N800), ")")),
            "--_ywovvi": (0, $5cymf.default)("var(--ds-text-inverse, ".concat((0, $5XtxN.N0), ")"))
        })
    }, children);
});
$e916c054e2b8714e$var$TooltipContainer.displayName = "TooltipContainer";
var $e916c054e2b8714e$export$2e2bcd8739ae039 = $e916c054e2b8714e$var$TooltipContainer;

});
parcelRegister("gnf5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $beba7f29d53daf2f$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $cFKGy = parcelRequire("cFKGy");
function $beba7f29d53daf2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $beba7f29d53daf2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $beba7f29d53daf2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $beba7f29d53daf2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $beba7f29d53daf2f$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $beba7f29d53daf2f$var$primitiveStyles = (0, $dnfL5.css)({
    zindex: "var(".concat($beba7f29d53daf2f$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $beba7f29d53daf2f$var$TooltipPrimitive = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $beba7f29d53daf2f$var$_objectSpread($beba7f29d53daf2f$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $beba7f29d53daf2f$var$VAR_PRIMITIVE_ZINDEX, (0, $cFKGy.layers).tooltip()));
    return (0, $dnfL5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $dnfL5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $beba7f29d53daf2f$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$beba7f29d53daf2f$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $beba7f29d53daf2f$export$2e2bcd8739ae039 = $beba7f29d53daf2f$var$TooltipPrimitive;

});


parcelRegister("cwQgS", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $91f105262777c8ba$export$642213d516a9b928);
function $91f105262777c8ba$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("bDR2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $879c79ff1d8df190$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gq1Fg = parcelRequire("gq1Fg");

var $i9C2O = parcelRequire("i9C2O");

var $28LTS = parcelRequire("28LTS");

var $l3DEQ = parcelRequire("l3DEQ");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $879c79ff1d8df190$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var isCircle = shape === "circle";
    var baseProps = (0, $l3DEQ.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9C2O.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28LTS.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gq1Fg.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $879c79ff1d8df190$export$2e2bcd8739ae039 = $879c79ff1d8df190$var$useIconButton;

});


parcelRegister("fR0Px", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ac7326164ca28d$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jIJoC = parcelRequire("jIJoC");

var $6xdv4 = parcelRequire("6xdv4");

var $bDR2g = parcelRequire("bDR2g");
var $b8ac7326164ca28d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "href",
    "icon",
    "interactionName",
    "isDisabled",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip"
], $b8ac7326164ca28d$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $b8ac7326164ca28d$var$LinkIconButtonBase = function LinkIconButtonBase(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, href = _ref.href, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b8ac7326164ca28d$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $b8ac7326164ca28d$var$_excluded2);
    var baseProps = (0, $bDR2g.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "link",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xdv4.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jIJoC.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
                "aria-labelledby": baseProps["aria-labelledby"],
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture,
                href: baseProps.isDisabled ? undefined : href,
                role: baseProps.isDisabled ? "link" : undefined,
                "aria-disabled": baseProps.isDisabled === true ? true : undefined
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jIJoC.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? "link" : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $b8ac7326164ca28d$var$WithRef = /*#__PURE__*/ (0, $acw62.forwardRef)($b8ac7326164ca28d$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ var $b8ac7326164ca28d$var$LinkIconButton = /*#__PURE__*/ (0, $acw62.memo)($b8ac7326164ca28d$var$WithRef);
var $b8ac7326164ca28d$export$2e2bcd8739ae039 = $b8ac7326164ca28d$var$LinkIconButton;

});

parcelRegister("8lsKp", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $61369590c0921c18$export$651ad66661acd392);

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");

var $jGZSH = parcelRequire("jGZSH");

var $3Fk0H = parcelRequire("3Fk0H");
function $61369590c0921c18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61369590c0921c18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61369590c0921c18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61369590c0921c18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $61369590c0921c18$var$baseDividerStyles = (0, $dnfL5.css)({
    width: "var(--ds-border-width, 1px)",
    position: "relative",
    // This is 1 so it appears above buttons by default.
    // When buttons are selected they have a zIndex of 2 applied.
    // See use-button-base.tsx.
    zIndex: 1
});
var $61369590c0921c18$var$dividerDisabledStyles = (0, $dnfL5.css)({
    backgroundColor: "var(--ds-text-disabled, #091E4224)",
    cursor: "not-allowed",
    opacity: 0.51
});
var $61369590c0921c18$var$dividerDisabledRefreshedStyles = (0, $dnfL5.css)({
    backgroundColor: "var(--ds-border-disabled, #091E4224)",
    cursor: "not-allowed"
});
var $61369590c0921c18$var$dividerAppearance = {
    default: (0, $dnfL5.css)({
        backgroundColor: "var(--ds-text, #172B4D)",
        opacity: 0.51
    }),
    primary: (0, $dnfL5.css)({
        backgroundColor: "var(--ds-text-inverse, #FFF)",
        opacity: 0.64
    }),
    navigation: (0, $dnfL5.css)({
        height: "16px",
        margin: "var(--ds-space-100, 8px)".concat(" -0.5px"),
        backgroundColor: "var(--ds-text-subtle, #0052cc)",
        opacity: 0.62
    })
};
var $61369590c0921c18$var$dividerRefreshedAppearance = $61369590c0921c18$var$_objectSpread($61369590c0921c18$var$_objectSpread({}, $61369590c0921c18$var$dividerAppearance), {}, {
    default: (0, $dnfL5.css)({
        backgroundColor: "var(--ds-border, #091E4224)"
    }),
    primary: (0, $dnfL5.css)({
        backgroundColor: "var(--ds-border-inverse, #FFF)",
        opacity: 0.64
    })
});
var $61369590c0921c18$var$dividerRefreshedOffsetStyles = (0, $dnfL5.css)({
    marginInline: "calc(0px - ".concat("var(--ds-border-width, 1px)", ")")
});
var $61369590c0921c18$var$dividerHeight = {
    default: (0, $dnfL5.css)({
        height: "".concat(32 / 14, "em")
    }),
    compact: (0, $dnfL5.css)({
        height: "".concat(24 / 14, "em")
    })
};
var $61369590c0921c18$var$dividerHeightWithRem = {
    default: (0, $dnfL5.css)({
        height: "2rem"
    }),
    compact: (0, $dnfL5.css)({
        height: "1.5rem"
    })
};
var $61369590c0921c18$var$defaultDividerHeight = {
    // The divider height is calculated by subtracting twice the border width from the button height.
    // This ensures the divider does not intersect with the button's border, avoiding visual issues
    // caused by overlapping alpha colors (color.border) at the intersection.
    default: (0, $dnfL5.css)({
        height: "calc(".concat(32 / 14, "em - ", "var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    }),
    compact: (0, $dnfL5.css)({
        height: "calc(".concat(24 / 14, "em - ", "var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    })
};
var $61369590c0921c18$var$defaultDividerHeightWithRem = {
    // The divider height is calculated by subtracting twice the border width from the button height.
    // This ensures the divider does not intersect with the button's border, avoiding visual issues
    // caused by overlapping alpha colors (color.border) at the intersection.
    default: (0, $dnfL5.css)({
        height: "calc(2rem - ".concat("var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    }),
    compact: (0, $dnfL5.css)({
        height: "calc(1.5rem - ".concat("var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    })
};
var $61369590c0921c18$export$2e0a83ec2e27ecbb = function Divider(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    // Pulling these out of the below `css` prop to avoid nested ternaries
    var defaultDividerHeightStyles = (0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $61369590c0921c18$var$defaultDividerHeightWithRem : $61369590c0921c18$var$defaultDividerHeight;
    var dividerHeightStyles = (0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $61369590c0921c18$var$dividerHeightWithRem : $61369590c0921c18$var$dividerHeight;
    return(// I find it funny to provide a div for Divider
    (0, $dnfL5.jsx)("div", {
        css: [
            $61369590c0921c18$var$baseDividerStyles,
            appearance === "default" && !isDisabled && (0, $ltooA.fg)("platform-component-visual-refresh") ? defaultDividerHeightStyles[spacing] : dividerHeightStyles[spacing],
            isDisabled && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $61369590c0921c18$var$dividerDisabledRefreshedStyles : $61369590c0921c18$var$dividerDisabledStyles),
            !isDisabled && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $61369590c0921c18$var$dividerRefreshedAppearance[appearance] : $61369590c0921c18$var$dividerAppearance[appearance]),
            (0, $ltooA.fg)("platform-component-visual-refresh") && $61369590c0921c18$var$dividerRefreshedOffsetStyles
        ]
    }));
};
var $61369590c0921c18$var$splitButtonStyles = (0, $dnfL5.css)({
    display: "inline-flex",
    position: "relative",
    alignItems: "center",
    whiteSpace: "nowrap"
});
var $61369590c0921c18$var$primaryButtonStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "button,a": {
        borderEndEndRadius: 0,
        borderStartEndRadius: 0
    }
});
var $61369590c0921c18$var$secondaryButtonStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "button,a": {
        borderEndStartRadius: 0,
        borderStartStartRadius: 0
    }
});
var $61369590c0921c18$var$defaultAppearanceContainerStyles = (0, $dnfL5.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    outlineColor: "var(--ds-border, #091E4224)",
    outlineOffset: "calc(0px - ".concat("var(--ds-border-width, 1px)", ")"),
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width, 1px)"
});
var $61369590c0921c18$export$994ba1b4c598f7 = function SplitButtonContainer(_ref2) {
    var appearance = _ref2.appearance, children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled;
    return (0, $dnfL5.jsx)("div", {
        css: [
            appearance === "default" && !isDisabled && (0, $ltooA.fg)("platform-component-visual-refresh") && $61369590c0921c18$var$defaultAppearanceContainerStyles,
            $61369590c0921c18$var$splitButtonStyles
        ]
    }, children);
};
var $61369590c0921c18$export$651ad66661acd392 = function SplitButton(_ref3) {
    var children = _ref3.children, _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? "default" : _ref3$appearance, _ref3$spacing = _ref3.spacing, spacing = _ref3$spacing === void 0 ? "default" : _ref3$spacing, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled;
    var _getActions = (0, $3Fk0H.getActions)(children), PrimaryAction = _getActions.PrimaryAction, SecondaryAction = _getActions.SecondaryAction;
    return (0, $dnfL5.jsx)($61369590c0921c18$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, (0, $dnfL5.jsx)((0, $jGZSH.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, (0, $dnfL5.jsx)("div", {
        css: $61369590c0921c18$var$primaryButtonStyles
    }, PrimaryAction), (0, $dnfL5.jsx)($61369590c0921c18$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), (0, $dnfL5.jsx)("div", {
        css: $61369590c0921c18$var$secondaryButtonStyles
    }, SecondaryAction)));
};
var $61369590c0921c18$export$e3ca81100b492e15 = function SplitButtonWithSlots(_ref4) {
    var primaryAction = _ref4.primaryAction, secondaryAction = _ref4.secondaryAction, _ref4$appearance = _ref4.appearance, appearance = _ref4$appearance === void 0 ? "default" : _ref4$appearance, _ref4$spacing = _ref4.spacing, spacing = _ref4$spacing === void 0 ? "default" : _ref4$spacing, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled;
    return (0, $dnfL5.jsx)($61369590c0921c18$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, (0, $dnfL5.jsx)((0, $jGZSH.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, (0, $dnfL5.jsx)("div", {
        css: $61369590c0921c18$var$primaryButtonStyles
    }, primaryAction), (0, $dnfL5.jsx)($61369590c0921c18$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), (0, $dnfL5.jsx)("div", {
        css: $61369590c0921c18$var$secondaryButtonStyles
    }, secondaryAction)));
};

});
parcelRegister("3Fk0H", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $2ab4b90a150d51f5$export$fe3955935f564b31);

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $hPtJY = parcelRequire("hPtJY");
var $2ab4b90a150d51f5$export$fe3955935f564b31 = function getActions(children) {
    var _Children$toArray = (0, $acw62.Children).toArray(children), _Children$toArray2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Children$toArray, 2), PrimaryAction = _Children$toArray2[0], SecondaryAction = _Children$toArray2[1];
    typeof $hPtJY;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});



parcelRegister("j22Yz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ddb0832b1b77e554$var$Environment;
(function(Environment) {
    Environment["TEST"] = "test";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
})($ddb0832b1b77e554$var$Environment = module.exports.Environment || (module.exports.Environment = {}));
var $ddb0832b1b77e554$var$XIDItemType;
(function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
})($ddb0832b1b77e554$var$XIDItemType = module.exports.XIDItemType || (module.exports.XIDItemType = {}));
var $ddb0832b1b77e554$var$XIDState;
(function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
})($ddb0832b1b77e554$var$XIDState = module.exports.XIDState || (module.exports.XIDState = {}));
var $ddb0832b1b77e554$var$XIDGenerateMode;
(function(XIDGenerateMode) {
    XIDGenerateMode["XC_ONLY"] = "XC_ONLY";
    XIDGenerateMode["UID_ONLY"] = "UID_ONLY";
    XIDGenerateMode["CACHE_ONLY"] = "CACHE_ONLY";
    XIDGenerateMode["XC_UID"] = "XC_UID";
    XIDGenerateMode["CACHE_XC_UID"] = "CACHE_XC_UID";
})($ddb0832b1b77e554$var$XIDGenerateMode = module.exports.XIDGenerateMode || (module.exports.XIDGenerateMode = {}));

});

parcelRegister("cSbQH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95f3b82b2127a3ee$export$2e2bcd8739ae039);

var $jXety = parcelRequire("jXety");

var $eFAmG = parcelRequire("eFAmG");

var $5UcuM = parcelRequire("5UcuM");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $95f3b82b2127a3ee$var$setTimeoutFunc = setTimeout;
function $95f3b82b2127a3ee$var$isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function $95f3b82b2127a3ee$var$noop() {}
// Polyfill for Function.prototype.bind
function $95f3b82b2127a3ee$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $95f3b82b2127a3ee$var$Promise(fn) {
    if (!(this instanceof $95f3b82b2127a3ee$var$Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $95f3b82b2127a3ee$var$doResolve(fn, this);
}
function $95f3b82b2127a3ee$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $95f3b82b2127a3ee$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $95f3b82b2127a3ee$var$resolve : $95f3b82b2127a3ee$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $95f3b82b2127a3ee$var$reject(deferred.promise, e);
            return;
        }
        $95f3b82b2127a3ee$var$resolve(deferred.promise, ret);
    });
}
function $95f3b82b2127a3ee$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof $95f3b82b2127a3ee$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $95f3b82b2127a3ee$var$finale(self);
                return;
            } else if (typeof then === "function") {
                $95f3b82b2127a3ee$var$doResolve($95f3b82b2127a3ee$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $95f3b82b2127a3ee$var$finale(self);
    } catch (e) {
        $95f3b82b2127a3ee$var$reject(self, e);
    }
}
function $95f3b82b2127a3ee$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $95f3b82b2127a3ee$var$finale(self);
}
function $95f3b82b2127a3ee$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $95f3b82b2127a3ee$var$Promise._immediateFn(function() {
        if (!self._handled) $95f3b82b2127a3ee$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$95f3b82b2127a3ee$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $95f3b82b2127a3ee$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $95f3b82b2127a3ee$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $95f3b82b2127a3ee$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $95f3b82b2127a3ee$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $95f3b82b2127a3ee$var$reject(self, ex);
    }
}
$95f3b82b2127a3ee$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$95f3b82b2127a3ee$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($95f3b82b2127a3ee$var$noop);
    $95f3b82b2127a3ee$var$handle(this, new $95f3b82b2127a3ee$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$95f3b82b2127a3ee$var$Promise.prototype["finally"] = (0, $jXety.default);
$95f3b82b2127a3ee$var$Promise.all = function(arr) {
    return new $95f3b82b2127a3ee$var$Promise(function(resolve, reject) {
        if (!$95f3b82b2127a3ee$var$isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$95f3b82b2127a3ee$var$Promise.any = (0, $5UcuM.default);
$95f3b82b2127a3ee$var$Promise.allSettled = (0, $eFAmG.default);
$95f3b82b2127a3ee$var$Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === $95f3b82b2127a3ee$var$Promise) return value;
    return new $95f3b82b2127a3ee$var$Promise(function(resolve) {
        resolve(value);
    });
};
$95f3b82b2127a3ee$var$Promise.reject = function(value) {
    return new $95f3b82b2127a3ee$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$95f3b82b2127a3ee$var$Promise.race = function(arr) {
    return new $95f3b82b2127a3ee$var$Promise(function(resolve, reject) {
        if (!$95f3b82b2127a3ee$var$isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)$95f3b82b2127a3ee$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$95f3b82b2127a3ee$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $95f3b82b2127a3ee$var$setTimeoutFunc(fn, 0);
};
$95f3b82b2127a3ee$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
var $95f3b82b2127a3ee$export$2e2bcd8739ae039 = $95f3b82b2127a3ee$var$Promise;

});
parcelRegister("jXety", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86ec1941a88c97e$export$2e2bcd8739ae039);
/**
 * @this {Promise}
 */ function $e86ec1941a88c97e$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $e86ec1941a88c97e$export$2e2bcd8739ae039 = $e86ec1941a88c97e$var$finallyConstructor;

});

parcelRegister("eFAmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae11a54844710ec$export$2e2bcd8739ae039);
function $aae11a54844710ec$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError(typeof arr + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $aae11a54844710ec$export$2e2bcd8739ae039 = $aae11a54844710ec$var$allSettled;

});

parcelRegister("5UcuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $44cbe00ec87cae2b$export$2e2bcd8739ae039);
/**
 * @constructor
 */ function $44cbe00ec87cae2b$var$AggregateError(errors, message) {
    this.name = "AggregateError", this.errors = errors;
    this.message = message || "";
}
$44cbe00ec87cae2b$var$AggregateError.prototype = Error.prototype;
function $44cbe00ec87cae2b$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError("Promise.any accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $44cbe00ec87cae2b$var$AggregateError(rejectionReasons, "All promises were rejected"));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $44cbe00ec87cae2b$export$2e2bcd8739ae039 = $44cbe00ec87cae2b$var$any;

});


parcelRegister("11P39", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03f86cbf4091cea96938f1feb145f315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bfd7be31eeecbc4$var$_react = $0bfd7be31eeecbc4$var$_interopRequireDefault((parcelRequire("acw62")));

var $0bfd7be31eeecbc4$var$_UNSAFE_baseNew = $0bfd7be31eeecbc4$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $0bfd7be31eeecbc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bfd7be31eeecbc4$var$CloseIcon = (props)=>/*#__PURE__*/ $0bfd7be31eeecbc4$var$_react.default.createElement($0bfd7be31eeecbc4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$0bfd7be31eeecbc4$var$CloseIcon.displayName = "CloseIcon";
var $0bfd7be31eeecbc4$var$_default = module.exports.default = $0bfd7be31eeecbc4$var$CloseIcon;

});
parcelRegister("j9ueQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1qSlQ")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("1qSlQ")).Icon);

var $1qSlQ = parcelRequire("1qSlQ");

});
parcelRegister("1qSlQ", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $10b2612ee1e07d20$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $10b2612ee1e07d20$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $8Z5xg = parcelRequire("8Z5xg");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $10b2612ee1e07d20$var$commonSVGStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $10b2612ee1e07d20$var$svgStyles = (0, $dnfL5.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $10b2612ee1e07d20$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $10b2612ee1e07d20$var$utilityIconStyles = (0, $dnfL5.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $10b2612ee1e07d20$var$scaleStyles = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $10b2612ee1e07d20$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $10b2612ee1e07d20$var$scaleSize = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
var $10b2612ee1e07d20$var$sizeMap = {
    core: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $10b2612ee1e07d20$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $10b2612ee1e07d20$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $10b2612ee1e07d20$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $8Z5xg.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $dnfL5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $10b2612ee1e07d20$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $10b2612ee1e07d20$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $10b2612ee1e07d20$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $dnfL5.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $10b2612ee1e07d20$var$iconStyles,
            $10b2612ee1e07d20$var$baseHcmStyles,
            shouldScale && $10b2612ee1e07d20$var$scaleStyles,
            props.type === "utility" && $10b2612ee1e07d20$var$utilityIconStyles
        ]
    }, (0, $dnfL5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $10b2612ee1e07d20$var$commonSVGStyles,
            $10b2612ee1e07d20$var$svgStyles,
            shouldScale ? $10b2612ee1e07d20$var$scaleSize : props.type === "utility" ? $10b2612ee1e07d20$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $10b2612ee1e07d20$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $10b2612ee1e07d20$export$2e2bcd8739ae039 = $10b2612ee1e07d20$export$f04a61298a47a40f;

});
parcelRegister("8Z5xg", function(module, exports) {

$parcel$export(module.exports, "fg", () => $68a85078cb110245$export$b40ec24ac8275656);

var $jH6xZ = parcelRequire("jH6xZ");
function $68a85078cb110245$export$ba05d765b8392e5e(flagResolver) {
    (0, $jH6xZ.setBooleanResolver)(flagResolver);
}
function $68a85078cb110245$export$470e5c2be1411c89(name) {
    return (0, $jH6xZ.resolveBooleanFlag)(name);
}
function $68a85078cb110245$export$b40ec24ac8275656(name) {
    return (0, $jH6xZ.resolveBooleanFlag)(name);
}

});
parcelRegister("jH6xZ", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $e5671ca0d8435871$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $e5671ca0d8435871$export$6333b6aff9fc6275);

var $dBDNK = parcelRequire("dBDNK");

var $hPtJY = parcelRequire("hPtJY");
var $e5671ca0d8435871$var$pkgName = "@atlaskit/platform-feature-flags";
var $e5671ca0d8435871$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $e5671ca0d8435871$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $e5671ca0d8435871$var$ENV_ENABLE_PLATFORM_FF = $e5671ca0d8435871$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $e5671ca0d8435871$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e5671ca0d8435871$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $e5671ca0d8435871$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e5671ca0d8435871$var$ENV_ENABLE_PLATFORM_FF || $e5671ca0d8435871$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $e5671ca0d8435871$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $e5671ca0d8435871$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$e5671ca0d8435871$var$globalVar[$e5671ca0d8435871$export$7e41b1b2bdee3f98] = $e5671ca0d8435871$var$globalVar[$e5671ca0d8435871$export$7e41b1b2bdee3f98] || $e5671ca0d8435871$var$DEFAULT_PFF_GLOBAL;
function $e5671ca0d8435871$export$f2b591175b3e424c(resolver) {
    $e5671ca0d8435871$var$globalVar[$e5671ca0d8435871$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $e5671ca0d8435871$export$6333b6aff9fc6275(flagKey) {
    if ($e5671ca0d8435871$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $dBDNK.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e5671ca0d8435871$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $e5671ca0d8435871$var$globalVar[$e5671ca0d8435871$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("dBDNK", function(module, exports) {

$parcel$export(module.exports, "debug", () => $9e7d9ac62ca30fb6$export$1c9f709888824e05);
var $9e7d9ac62ca30fb6$var$_ref, $9e7d9ac62ca30fb6$var$_process, $9e7d9ac62ca30fb6$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9e7d9ac62ca30fb6$var$TESTS_MODE = ($9e7d9ac62ca30fb6$var$_ref = (globalThis === null || globalThis === void 0 || ($9e7d9ac62ca30fb6$var$_process = globalThis.process) === null || $9e7d9ac62ca30fb6$var$_process === void 0 || ($9e7d9ac62ca30fb6$var$_process = $9e7d9ac62ca30fb6$var$_process.env) === null || $9e7d9ac62ca30fb6$var$_process === void 0 ? void 0 : $9e7d9ac62ca30fb6$var$_process.JEST_WORKER_ID) !== undefined, $9e7d9ac62ca30fb6$var$_ref !== void 0) ? $9e7d9ac62ca30fb6$var$_ref : false;
var $9e7d9ac62ca30fb6$var$DEBUG_MODE = !$9e7d9ac62ca30fb6$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9e7d9ac62ca30fb6$var$_process2 = globalThis.process) === null || $9e7d9ac62ca30fb6$var$_process2 === void 0 || ($9e7d9ac62ca30fb6$var$_process2 = $9e7d9ac62ca30fb6$var$_process2.env) === null || $9e7d9ac62ca30fb6$var$_process2 === void 0 ? void 0 : $9e7d9ac62ca30fb6$var$_process2.NODE_ENV) !== "production";
var $9e7d9ac62ca30fb6$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9e7d9ac62ca30fb6$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("gaDMh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfe67a5a24a2dcfb0853d331aeb2068>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc5c6f848a502dc6$var$_react = $bc5c6f848a502dc6$var$_interopRequireDefault((parcelRequire("acw62")));

var $bc5c6f848a502dc6$var$_UNSAFE_baseNew = $bc5c6f848a502dc6$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $bc5c6f848a502dc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc5c6f848a502dc6$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $bc5c6f848a502dc6$var$_react.default.createElement($bc5c6f848a502dc6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
    }, props));
$bc5c6f848a502dc6$var$ArrowUpRightIcon.displayName = "ArrowUpRightIcon";
var $bc5c6f848a502dc6$var$_default = module.exports.default = $bc5c6f848a502dc6$var$ArrowUpRightIcon;

});

parcelRegister("aKcQU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8cb0749e395cf6d25ab2f6745905850>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d282b7bf05ef5d9$var$_react = $7d282b7bf05ef5d9$var$_interopRequireDefault((parcelRequire("acw62")));

var $7d282b7bf05ef5d9$var$_UNSAFE_baseNew = $7d282b7bf05ef5d9$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $7d282b7bf05ef5d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d282b7bf05ef5d9$var$DownloadIcon = (props)=>/*#__PURE__*/ $7d282b7bf05ef5d9$var$_react.default.createElement($7d282b7bf05ef5d9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$7d282b7bf05ef5d9$var$DownloadIcon.displayName = "DownloadIcon";
var $7d282b7bf05ef5d9$var$_default = module.exports.default = $7d282b7bf05ef5d9$var$DownloadIcon;

});

parcelRegister("lrwzu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d611fb3947c00fee344914368e144168>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9c562959727a20b$var$_react = $f9c562959727a20b$var$_interopRequireDefault((parcelRequire("acw62")));

var $f9c562959727a20b$var$_UNSAFE_baseNew = $f9c562959727a20b$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $f9c562959727a20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9c562959727a20b$var$LocationIcon = (props)=>/*#__PURE__*/ $f9c562959727a20b$var$_react.default.createElement($f9c562959727a20b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$f9c562959727a20b$var$LocationIcon.displayName = "LocationIcon";
var $f9c562959727a20b$var$_default = module.exports.default = $f9c562959727a20b$var$LocationIcon;

});

parcelRegister("jnEWh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28198ce9e0c3202094e2855b88c09086>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1bfebf497c2c419$var$_react = $e1bfebf497c2c419$var$_interopRequireDefault((parcelRequire("acw62")));

var $e1bfebf497c2c419$var$_UNSAFE_baseNew = $e1bfebf497c2c419$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $e1bfebf497c2c419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1bfebf497c2c419$var$AddIcon = (props)=>/*#__PURE__*/ $e1bfebf497c2c419$var$_react.default.createElement($e1bfebf497c2c419$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$e1bfebf497c2c419$var$AddIcon.displayName = "AddIcon";
var $e1bfebf497c2c419$var$_default = module.exports.default = $e1bfebf497c2c419$var$AddIcon;

});

parcelRegister("5kCbU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1c71efbfb5f5b4$var$_react = $3e1c71efbfb5f5b4$var$_interopRequireDefault((parcelRequire("acw62")));

var $3e1c71efbfb5f5b4$var$_UNSAFE_baseNew = $3e1c71efbfb5f5b4$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $3e1c71efbfb5f5b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e1c71efbfb5f5b4$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $3e1c71efbfb5f5b4$var$_react.default.createElement($3e1c71efbfb5f5b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$3e1c71efbfb5f5b4$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $3e1c71efbfb5f5b4$var$_default = module.exports.default = $3e1c71efbfb5f5b4$var$ArrowLeftIcon;

});

parcelRegister("ePDXu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc4d30e53d86507$var$_react = $acc4d30e53d86507$var$_interopRequireDefault((parcelRequire("acw62")));

var $acc4d30e53d86507$var$_UNSAFE_baseNew = $acc4d30e53d86507$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $acc4d30e53d86507$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc4d30e53d86507$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc4d30e53d86507$var$_react.default.createElement($acc4d30e53d86507$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$acc4d30e53d86507$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $acc4d30e53d86507$var$_default = module.exports.default = $acc4d30e53d86507$var$ArrowRightIcon;

});

parcelRegister("3jPeh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26aae285c5ce77dd$var$_react = $26aae285c5ce77dd$var$_interopRequireDefault((parcelRequire("acw62")));

var $26aae285c5ce77dd$var$_UNSAFE_baseNew = $26aae285c5ce77dd$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $26aae285c5ce77dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26aae285c5ce77dd$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $26aae285c5ce77dd$var$_react.default.createElement($26aae285c5ce77dd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$26aae285c5ce77dd$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $26aae285c5ce77dd$var$_default = module.exports.default = $26aae285c5ce77dd$var$ArrowUpIcon;

});

parcelRegister("eIST3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab7fc026f56848e8$var$_react = $ab7fc026f56848e8$var$_interopRequireDefault((parcelRequire("acw62")));

var $ab7fc026f56848e8$var$_UNSAFE_baseNew = $ab7fc026f56848e8$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $ab7fc026f56848e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab7fc026f56848e8$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab7fc026f56848e8$var$_react.default.createElement($ab7fc026f56848e8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$ab7fc026f56848e8$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $ab7fc026f56848e8$var$_default = module.exports.default = $ab7fc026f56848e8$var$CheckMarkIcon;

});

parcelRegister("k08bI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8fa28b4203edf50$var$_react = $e8fa28b4203edf50$var$_interopRequireDefault((parcelRequire("acw62")));

var $e8fa28b4203edf50$var$_UNSAFE_baseNew = $e8fa28b4203edf50$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $e8fa28b4203edf50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8fa28b4203edf50$var$SuccessIcon = (props)=>/*#__PURE__*/ $e8fa28b4203edf50$var$_react.default.createElement($e8fa28b4203edf50$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$e8fa28b4203edf50$var$SuccessIcon.displayName = "SuccessIcon";
var $e8fa28b4203edf50$var$_default = module.exports.default = $e8fa28b4203edf50$var$SuccessIcon;

});

parcelRegister("9H17v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70e8ff9c10511e80$var$_react = $70e8ff9c10511e80$var$_interopRequireDefault((parcelRequire("acw62")));

var $70e8ff9c10511e80$var$_UNSAFE_baseNew = $70e8ff9c10511e80$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $70e8ff9c10511e80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70e8ff9c10511e80$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $70e8ff9c10511e80$var$_react.default.createElement($70e8ff9c10511e80$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$70e8ff9c10511e80$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $70e8ff9c10511e80$var$_default = module.exports.default = $70e8ff9c10511e80$var$CheckCircleIcon;

});

parcelRegister("dSnoq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1a276e05d24bd98$var$_react = $a1a276e05d24bd98$var$_interopRequireDefault((parcelRequire("acw62")));

var $a1a276e05d24bd98$var$_UNSAFE_baseNew = $a1a276e05d24bd98$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $a1a276e05d24bd98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1a276e05d24bd98$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a1a276e05d24bd98$var$_react.default.createElement($a1a276e05d24bd98$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$a1a276e05d24bd98$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $a1a276e05d24bd98$var$_default = module.exports.default = $a1a276e05d24bd98$var$ChevronDownIcon;

});

parcelRegister("3gck4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fc6cbbfb0f8ad2$var$_react = $25fc6cbbfb0f8ad2$var$_interopRequireDefault((parcelRequire("acw62")));

var $25fc6cbbfb0f8ad2$var$_UNSAFE_baseNew = $25fc6cbbfb0f8ad2$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $25fc6cbbfb0f8ad2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fc6cbbfb0f8ad2$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $25fc6cbbfb0f8ad2$var$_react.default.createElement($25fc6cbbfb0f8ad2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: "utility"
    }, props));
$25fc6cbbfb0f8ad2$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $25fc6cbbfb0f8ad2$var$_default = module.exports.default = $25fc6cbbfb0f8ad2$var$ChevronLeftIcon;

});

parcelRegister("cLpFk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94adc8777c8f5fa0$var$_react = $94adc8777c8f5fa0$var$_interopRequireDefault((parcelRequire("acw62")));

var $94adc8777c8f5fa0$var$_UNSAFE_baseNew = $94adc8777c8f5fa0$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $94adc8777c8f5fa0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94adc8777c8f5fa0$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $94adc8777c8f5fa0$var$_react.default.createElement($94adc8777c8f5fa0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: "utility"
    }, props));
$94adc8777c8f5fa0$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $94adc8777c8f5fa0$var$_default = module.exports.default = $94adc8777c8f5fa0$var$ChevronRightIcon;

});

parcelRegister("1ZV7N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f998c57d427ae10203b04c2186c5e29c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1747ccc29b5b2c4b$var$_react = $1747ccc29b5b2c4b$var$_interopRequireDefault((parcelRequire("acw62")));

var $1747ccc29b5b2c4b$var$_UNSAFE_baseNew = $1747ccc29b5b2c4b$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $1747ccc29b5b2c4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1747ccc29b5b2c4b$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $1747ccc29b5b2c4b$var$_react.default.createElement($1747ccc29b5b2c4b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: "utility"
    }, props));
$1747ccc29b5b2c4b$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $1747ccc29b5b2c4b$var$_default = module.exports.default = $1747ccc29b5b2c4b$var$ChevronUpIcon;

});

parcelRegister("foaze", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3414b551c9df0fc$var$_react = $b3414b551c9df0fc$var$_interopRequireDefault((parcelRequire("acw62")));

var $b3414b551c9df0fc$var$_UNSAFE_baseNew = $b3414b551c9df0fc$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $b3414b551c9df0fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3414b551c9df0fc$var$CopyIcon = (props)=>/*#__PURE__*/ $b3414b551c9df0fc$var$_react.default.createElement($b3414b551c9df0fc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$b3414b551c9df0fc$var$CopyIcon.displayName = "CopyIcon";
var $b3414b551c9df0fc$var$_default = module.exports.default = $b3414b551c9df0fc$var$CopyIcon;

});

parcelRegister("kW30k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3db8e00864ae3e0$var$_react = $f3db8e00864ae3e0$var$_interopRequireDefault((parcelRequire("acw62")));

var $f3db8e00864ae3e0$var$_UNSAFE_baseNew = $f3db8e00864ae3e0$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $f3db8e00864ae3e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3db8e00864ae3e0$var$EditIcon = (props)=>/*#__PURE__*/ $f3db8e00864ae3e0$var$_react.default.createElement($f3db8e00864ae3e0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$f3db8e00864ae3e0$var$EditIcon.displayName = "EditIcon";
var $f3db8e00864ae3e0$var$_default = module.exports.default = $f3db8e00864ae3e0$var$EditIcon;

});

parcelRegister("1LQ8Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc84bee668fd63ce995277b659b1b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14a2a076681a978c$var$_react = $14a2a076681a978c$var$_interopRequireDefault((parcelRequire("acw62")));

var $14a2a076681a978c$var$_UNSAFE_baseNew = $14a2a076681a978c$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $14a2a076681a978c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14a2a076681a978c$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $14a2a076681a978c$var$_react.default.createElement($14a2a076681a978c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M1 5.917h6m-6 4.166h6m6.625.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$14a2a076681a978c$var$ContentWrapRightIcon.displayName = "ContentWrapRightIcon";
var $14a2a076681a978c$var$_default = module.exports.default = $14a2a076681a978c$var$ContentWrapRightIcon;

});

parcelRegister("kjbKN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec8eb3098dd18436$var$_react = $ec8eb3098dd18436$var$_interopRequireDefault((parcelRequire("acw62")));

var $ec8eb3098dd18436$var$_UNSAFE_baseNew = $ec8eb3098dd18436$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $ec8eb3098dd18436$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec8eb3098dd18436$var$InformationIcon = (props)=>/*#__PURE__*/ $ec8eb3098dd18436$var$_react.default.createElement($ec8eb3098dd18436$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$ec8eb3098dd18436$var$InformationIcon.displayName = "InformationIcon";
var $ec8eb3098dd18436$var$_default = module.exports.default = $ec8eb3098dd18436$var$InformationIcon;

});

parcelRegister("9ttUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e5e057b33ca778d$var$_react = $6e5e057b33ca778d$var$_interopRequireDefault((parcelRequire("acw62")));

var $6e5e057b33ca778d$var$_UNSAFE_baseNew = $6e5e057b33ca778d$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $6e5e057b33ca778d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e5e057b33ca778d$var$GridIcon = (props)=>/*#__PURE__*/ $6e5e057b33ca778d$var$_react.default.createElement($6e5e057b33ca778d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$6e5e057b33ca778d$var$GridIcon.displayName = "GridIcon";
var $6e5e057b33ca778d$var$_default = module.exports.default = $6e5e057b33ca778d$var$GridIcon;

});

parcelRegister("ddr8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a48a035a6b6ee27b8a00a2b1992b2cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99f188ef283c9f1c$var$_react = $99f188ef283c9f1c$var$_interopRequireDefault((parcelRequire("acw62")));

var $99f188ef283c9f1c$var$_UNSAFE_baseNew = $99f188ef283c9f1c$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $99f188ef283c9f1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99f188ef283c9f1c$var$ClockIcon = (props)=>/*#__PURE__*/ $99f188ef283c9f1c$var$_react.default.createElement($99f188ef283c9f1c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$99f188ef283c9f1c$var$ClockIcon.displayName = "ClockIcon";
var $99f188ef283c9f1c$var$_default = module.exports.default = $99f188ef283c9f1c$var$ClockIcon;

});

parcelRegister("4OiYq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2df9b6d4b219d15d7e01ad6e3eb71a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $380a8cb8c5bfd360$var$_react = $380a8cb8c5bfd360$var$_interopRequireDefault((parcelRequire("acw62")));

var $380a8cb8c5bfd360$var$_UNSAFE_baseNew = $380a8cb8c5bfd360$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $380a8cb8c5bfd360$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $380a8cb8c5bfd360$var$HeartIcon = (props)=>/*#__PURE__*/ $380a8cb8c5bfd360$var$_react.default.createElement($380a8cb8c5bfd360$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
    }, props));
$380a8cb8c5bfd360$var$HeartIcon.displayName = "HeartIcon";
var $380a8cb8c5bfd360$var$_default = module.exports.default = $380a8cb8c5bfd360$var$HeartIcon;

});

parcelRegister("au6Na", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a21f98076ed04e6$var$_react = $7a21f98076ed04e6$var$_interopRequireDefault((parcelRequire("acw62")));

var $7a21f98076ed04e6$var$_UNSAFE_baseNew = $7a21f98076ed04e6$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $7a21f98076ed04e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a21f98076ed04e6$var$ErrorIcon = (props)=>/*#__PURE__*/ $7a21f98076ed04e6$var$_react.default.createElement($7a21f98076ed04e6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$7a21f98076ed04e6$var$ErrorIcon.displayName = "ErrorIcon";
var $7a21f98076ed04e6$var$_default = module.exports.default = $7a21f98076ed04e6$var$ErrorIcon;

});

parcelRegister("8ubK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62da3bb893ae19fa$var$_react = $62da3bb893ae19fa$var$_interopRequireDefault((parcelRequire("acw62")));

var $62da3bb893ae19fa$var$_UNSAFE_baseNew = $62da3bb893ae19fa$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $62da3bb893ae19fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62da3bb893ae19fa$var$UploadIcon = (props)=>/*#__PURE__*/ $62da3bb893ae19fa$var$_react.default.createElement($62da3bb893ae19fa$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$62da3bb893ae19fa$var$UploadIcon.displayName = "UploadIcon";
var $62da3bb893ae19fa$var$_default = module.exports.default = $62da3bb893ae19fa$var$UploadIcon;

});

parcelRegister("7IcEl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e33235fde7b24564b92256907cba586>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59d674718f4f5d63$var$_react = $59d674718f4f5d63$var$_interopRequireDefault((parcelRequire("acw62")));

var $59d674718f4f5d63$var$_UNSAFE_baseNew = $59d674718f4f5d63$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $59d674718f4f5d63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59d674718f4f5d63$var$FilterIcon = (props)=>/*#__PURE__*/ $59d674718f4f5d63$var$_react.default.createElement($59d674718f4f5d63$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$59d674718f4f5d63$var$FilterIcon.displayName = "FilterIcon";
var $59d674718f4f5d63$var$_default = module.exports.default = $59d674718f4f5d63$var$FilterIcon;

});

parcelRegister("1iipD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f15c13479fa21cd$var$_react = $0f15c13479fa21cd$var$_interopRequireDefault((parcelRequire("acw62")));

var $0f15c13479fa21cd$var$_UNSAFE_baseNew = $0f15c13479fa21cd$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $0f15c13479fa21cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f15c13479fa21cd$var$ImageIcon = (props)=>/*#__PURE__*/ $0f15c13479fa21cd$var$_react.default.createElement($0f15c13479fa21cd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$0f15c13479fa21cd$var$ImageIcon.displayName = "ImageIcon";
var $0f15c13479fa21cd$var$_default = module.exports.default = $0f15c13479fa21cd$var$ImageIcon;

});

parcelRegister("9si9u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e24cf3127d56690$var$_react = $6e24cf3127d56690$var$_interopRequireDefault((parcelRequire("acw62")));

var $6e24cf3127d56690$var$_UNSAFE_baseNew = $6e24cf3127d56690$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $6e24cf3127d56690$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e24cf3127d56690$var$LinkIcon = (props)=>/*#__PURE__*/ $6e24cf3127d56690$var$_react.default.createElement($6e24cf3127d56690$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$6e24cf3127d56690$var$LinkIcon.displayName = "LinkIcon";
var $6e24cf3127d56690$var$_default = module.exports.default = $6e24cf3127d56690$var$LinkIcon;

});

parcelRegister("g8M0Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7319a8e7b6756c4415855e934f6695>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc02a3053be3cd13$var$_react = $bc02a3053be3cd13$var$_interopRequireDefault((parcelRequire("acw62")));

var $bc02a3053be3cd13$var$_UNSAFE_baseNew = $bc02a3053be3cd13$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $bc02a3053be3cd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc02a3053be3cd13$var$ZoomInIcon = (props)=>/*#__PURE__*/ $bc02a3053be3cd13$var$_react.default.createElement($bc02a3053be3cd13$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h3m3 0H7m0 0V4m0 3v3"/>`
    }, props));
$bc02a3053be3cd13$var$ZoomInIcon.displayName = "ZoomInIcon";
var $bc02a3053be3cd13$var$_default = module.exports.default = $bc02a3053be3cd13$var$ZoomInIcon;

});

parcelRegister("8FjZq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f96a81b9e560eaf29acabc60a3927a4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64f1a89e2dc86116$var$_react = $64f1a89e2dc86116$var$_interopRequireDefault((parcelRequire("acw62")));

var $64f1a89e2dc86116$var$_UNSAFE_baseNew = $64f1a89e2dc86116$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $64f1a89e2dc86116$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64f1a89e2dc86116$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $64f1a89e2dc86116$var$_react.default.createElement($64f1a89e2dc86116$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h6"/>`
    }, props));
$64f1a89e2dc86116$var$ZoomOutIcon.displayName = "ZoomOutIcon";
var $64f1a89e2dc86116$var$_default = module.exports.default = $64f1a89e2dc86116$var$ZoomOutIcon;

});

parcelRegister("3RUVz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9176a30c0755d77947ceea47f5dcd51a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d127aef97db0676$var$_react = $2d127aef97db0676$var$_interopRequireDefault((parcelRequire("acw62")));

var $2d127aef97db0676$var$_UNSAFE_baseNew = $2d127aef97db0676$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $2d127aef97db0676$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d127aef97db0676$var$MenuIcon = (props)=>/*#__PURE__*/ $2d127aef97db0676$var$_react.default.createElement($2d127aef97db0676$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$2d127aef97db0676$var$MenuIcon.displayName = "MenuIcon";
var $2d127aef97db0676$var$_default = module.exports.default = $2d127aef97db0676$var$MenuIcon;

});

parcelRegister("58lkt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4cbb05f695c79bf1a6c2a07fef2f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bce3ea98fd12098$var$_react = $3bce3ea98fd12098$var$_interopRequireDefault((parcelRequire("acw62")));

var $3bce3ea98fd12098$var$_UNSAFE_baseNew = $3bce3ea98fd12098$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $3bce3ea98fd12098$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bce3ea98fd12098$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $3bce3ea98fd12098$var$_react.default.createElement($3bce3ea98fd12098$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$3bce3ea98fd12098$var$ShowMoreVerticalIcon.displayName = "ShowMoreVerticalIcon";
var $3bce3ea98fd12098$var$_default = module.exports.default = $3bce3ea98fd12098$var$ShowMoreVerticalIcon;

});

parcelRegister("8TOG6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67aac55e9d85e6e1$var$_react = $67aac55e9d85e6e1$var$_interopRequireDefault((parcelRequire("acw62")));

var $67aac55e9d85e6e1$var$_UNSAFE_baseNew = $67aac55e9d85e6e1$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $67aac55e9d85e6e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67aac55e9d85e6e1$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $67aac55e9d85e6e1$var$_react.default.createElement($67aac55e9d85e6e1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$67aac55e9d85e6e1$var$AlignLeftIcon.displayName = "AlignLeftIcon";
var $67aac55e9d85e6e1$var$_default = module.exports.default = $67aac55e9d85e6e1$var$AlignLeftIcon;

});

parcelRegister("aS8XK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ea5e6520e546d95$var$_react = $7ea5e6520e546d95$var$_interopRequireDefault((parcelRequire("acw62")));

var $7ea5e6520e546d95$var$_UNSAFE_baseNew = $7ea5e6520e546d95$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $7ea5e6520e546d95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ea5e6520e546d95$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $7ea5e6520e546d95$var$_react.default.createElement($7ea5e6520e546d95$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$7ea5e6520e546d95$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $7ea5e6520e546d95$var$_default = module.exports.default = $7ea5e6520e546d95$var$QuestionCircleIcon;

});

parcelRegister("eDEui", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa841d3839fb4848$var$_react = $aa841d3839fb4848$var$_interopRequireDefault((parcelRequire("acw62")));

var $aa841d3839fb4848$var$_UNSAFE_baseNew = $aa841d3839fb4848$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $aa841d3839fb4848$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa841d3839fb4848$var$RefreshIcon = (props)=>/*#__PURE__*/ $aa841d3839fb4848$var$_react.default.createElement($aa841d3839fb4848$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$aa841d3839fb4848$var$RefreshIcon.displayName = "RefreshIcon";
var $aa841d3839fb4848$var$_default = module.exports.default = $aa841d3839fb4848$var$RefreshIcon;

});

parcelRegister("kI7jx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaf30f230bb1e005401a7fdb410093c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f13d972b0dcf06fc$var$_react = $f13d972b0dcf06fc$var$_interopRequireDefault((parcelRequire("acw62")));

var $f13d972b0dcf06fc$var$_UNSAFE_baseNew = $f13d972b0dcf06fc$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $f13d972b0dcf06fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f13d972b0dcf06fc$var$SearchIcon = (props)=>/*#__PURE__*/ $f13d972b0dcf06fc$var$_react.default.createElement($f13d972b0dcf06fc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$f13d972b0dcf06fc$var$SearchIcon.displayName = "SearchIcon";
var $f13d972b0dcf06fc$var$_default = module.exports.default = $f13d972b0dcf06fc$var$SearchIcon;

});

parcelRegister("dwwhx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c415ea6f37a3ed0eb78bc36e015407f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d874e0774691882$var$_react = $9d874e0774691882$var$_interopRequireDefault((parcelRequire("acw62")));

var $9d874e0774691882$var$_UNSAFE_baseNew = $9d874e0774691882$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $9d874e0774691882$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d874e0774691882$var$SettingsIcon = (props)=>/*#__PURE__*/ $9d874e0774691882$var$_react.default.createElement($9d874e0774691882$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$9d874e0774691882$var$SettingsIcon.displayName = "SettingsIcon";
var $9d874e0774691882$var$_default = module.exports.default = $9d874e0774691882$var$SettingsIcon;

});

parcelRegister("6QGpd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fc87e4a05b87e25$var$_react = $4fc87e4a05b87e25$var$_interopRequireDefault((parcelRequire("acw62")));

var $4fc87e4a05b87e25$var$_UNSAFE_baseNew = $4fc87e4a05b87e25$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $4fc87e4a05b87e25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fc87e4a05b87e25$var$ShareIcon = (props)=>/*#__PURE__*/ $4fc87e4a05b87e25$var$_react.default.createElement($4fc87e4a05b87e25$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$4fc87e4a05b87e25$var$ShareIcon.displayName = "ShareIcon";
var $4fc87e4a05b87e25$var$_default = module.exports.default = $4fc87e4a05b87e25$var$ShareIcon;

});

parcelRegister("eIfnO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab611b85ab8fa87f$var$_react = $ab611b85ab8fa87f$var$_interopRequireDefault((parcelRequire("acw62")));

var $ab611b85ab8fa87f$var$_UNSAFE_baseNew = $ab611b85ab8fa87f$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $ab611b85ab8fa87f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab611b85ab8fa87f$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $ab611b85ab8fa87f$var$_react.default.createElement($ab611b85ab8fa87f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
    }, props));
$ab611b85ab8fa87f$var$StarUnstarredIcon.displayName = "StarUnstarredIcon";
var $ab611b85ab8fa87f$var$_default = module.exports.default = $ab611b85ab8fa87f$var$StarUnstarredIcon;

});

parcelRegister("fqs5t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84516badc93a96e757d14d99cc61886d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3af1249e6228942$var$_react = $b3af1249e6228942$var$_interopRequireDefault((parcelRequire("acw62")));

var $b3af1249e6228942$var$_UNSAFE_baseNew = $b3af1249e6228942$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $b3af1249e6228942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3af1249e6228942$var$StarStarredIcon = (props)=>/*#__PURE__*/ $b3af1249e6228942$var$_react.default.createElement($b3af1249e6228942$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$b3af1249e6228942$var$StarStarredIcon.displayName = "StarStarredIcon";
var $b3af1249e6228942$var$_default = module.exports.default = $b3af1249e6228942$var$StarStarredIcon;

});

parcelRegister("51kdZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a7cbbed20ea5326$var$_react = $3a7cbbed20ea5326$var$_interopRequireDefault((parcelRequire("acw62")));

var $3a7cbbed20ea5326$var$_UNSAFE_baseNew = $3a7cbbed20ea5326$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $3a7cbbed20ea5326$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a7cbbed20ea5326$var$WarningIcon = (props)=>/*#__PURE__*/ $3a7cbbed20ea5326$var$_react.default.createElement($3a7cbbed20ea5326$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3a7cbbed20ea5326$var$WarningIcon.displayName = "WarningIcon";
var $3a7cbbed20ea5326$var$_default = module.exports.default = $3a7cbbed20ea5326$var$WarningIcon;

});

parcelRegister("6Zqnk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("bs8tN")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("bs8tN")).Icon);

var $bs8tN = parcelRequire("bs8tN");

});
parcelRegister("bs8tN", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $8568e3145445b46f$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $8568e3145445b46f$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $eosOa = parcelRequire("eosOa");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8568e3145445b46f$var$svgStyles = null;
var $8568e3145445b46f$var$iconStyles = null;
var $8568e3145445b46f$var$smallIconStyles = null;
var $8568e3145445b46f$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8568e3145445b46f$var$baseHcmStyles = null;
var $8568e3145445b46f$var$scaleSize = null;
var $8568e3145445b46f$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8568e3145445b46f$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8568e3145445b46f$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $8568e3145445b46f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $8568e3145445b46f$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $eosOa.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === "small" && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $eosOa.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === "small" ? $8568e3145445b46f$var$coreSizeSmall[spacing] : $8568e3145445b46f$var$coreSizeMedium[spacing]
        ])
    }));
});
var $8568e3145445b46f$export$2e2bcd8739ae039 = $8568e3145445b46f$export$f04a61298a47a40f;

});
parcelRegister("eosOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a9a746c0fc8f51$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a7a9a746c0fc8f51$var$ATOMIC_GROUP_LENGTH = 5;
function $a7a9a746c0fc8f51$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $a7a9a746c0fc8f51$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("A96et", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $06ca6be2290a38a8$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $06ca6be2290a38a8$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $06ca6be2290a38a8$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $06ca6be2290a38a8$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $06ca6be2290a38a8$export$352e418ed5b6193a);
var $06ca6be2290a38a8$export$4ef52930e33717cd = "data-theme";
var $06ca6be2290a38a8$export$cb374d25ded7f6ab = "data-subtree-theme";
var $06ca6be2290a38a8$export$a00eac3f8684bcd0 = "data-color-mode";
var $06ca6be2290a38a8$export$2112803007239c61 = "data-contrast-mode";
var $06ca6be2290a38a8$export$352e418ed5b6193a = "data-custom-theme";
var $06ca6be2290a38a8$export$6f0c6fb8c80fcc92 = "ds";
var $06ca6be2290a38a8$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $06ca6be2290a38a8$export$dddac1532e822863 = "--".concat($06ca6be2290a38a8$export$6f0c6fb8c80fcc92, "-token-not-found");
var $06ca6be2290a38a8$export$9d7b58831ae93caa = "--".concat($06ca6be2290a38a8$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("d5ByG", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $9878e04cf3cc44b6$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $9878e04cf3cc44b6$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $9878e04cf3cc44b6$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $9878e04cf3cc44b6$export$2e2bcd8739ae039);

var $ltooA = parcelRequire("ltooA");
var $9878e04cf3cc44b6$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $9878e04cf3cc44b6$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $9878e04cf3cc44b6$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "spacing",
    "shape",
    "typography",
    "motion"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $9878e04cf3cc44b6$var$themeOverrideIds = [];
var $9878e04cf3cc44b6$export$92ba366331403db2 = [].concat($9878e04cf3cc44b6$export$7d43e72a58e3283f, $9878e04cf3cc44b6$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $9878e04cf3cc44b6$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-motion": {
        id: "motion",
        displayName: "Motion",
        palette: "motionPalette",
        attributes: {
            type: "motion"
        }
    }
};
var $9878e04cf3cc44b6$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: function shape() {
        if ((0, $ltooA.fg)("platform-dst-shape-theme-default")) return "shape";
        return undefined;
    },
    spacing: "spacing",
    typography: "typography",
    motion: function motion() {
        if ((0, $ltooA.fg)("platform-dst-motion-theme-default")) return "motion";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $9878e04cf3cc44b6$export$2e2bcd8739ae039 = $9878e04cf3cc44b6$var$themeConfig;

});

parcelRegister("2ddH8", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $19c76b253c53df65$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $19c76b253c53df65$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $19c76b253c53df65$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $19c76b253c53df65$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $19c76b253c53df65$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $19c76b253c53df65$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $19c76b253c53df65$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $19c76b253c53df65$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $19c76b253c53df65$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $19c76b253c53df65$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $19c76b253c53df65$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $19c76b253c53df65$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $19c76b253c53df65$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $19c76b253c53df65$export$b36dbdb4f463f05c(hex) {
    if (!$19c76b253c53df65$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $19c76b253c53df65$export$1212645cf40ebf71(hex)
    ];
}
function $19c76b253c53df65$export$5a544e13ad4e1fa5(hex) {
    if (!$19c76b253c53df65$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $19c76b253c53df65$export$47ea145a83f50dc0(hex) {
    if (!$19c76b253c53df65$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $19c76b253c53df65$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $19c76b253c53df65$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $19c76b253c53df65$export$d061e26956a60b0a(foreground, background) {
    if (!$19c76b253c53df65$var$isValidHex(foreground) || !$19c76b253c53df65$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $19c76b253c53df65$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $19c76b253c53df65$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $19c76b253c53df65$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $19c76b253c53df65$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $19c76b253c53df65$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $19c76b253c53df65$var$rgbToLab(rgbA);
    var labB = $19c76b253c53df65$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $19c76b253c53df65$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("jbywj", function(module, exports) {

$parcel$export(module.exports, "hash", () => $df79d2642d3ba0b8$export$d6af199866bfb566);
var $df79d2642d3ba0b8$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("lKBXP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k1DDw").then(()=>parcelRequire("1VcF7"));

});

parcelRegister("1LwJp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bS2iH").then(()=>parcelRequire("bi97d"));

});

parcelRegister("fJtit", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kcwHJ").then(()=>parcelRequire("eqtml"));

});

parcelRegister("dBEO0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("juWTg").then(()=>parcelRequire("hndRr"));

});

parcelRegister("2drUC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3xWkM").then(()=>parcelRequire("eNAwY"));

});

parcelRegister("i8T9x", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eZx3b").then(()=>parcelRequire("7QaQF"));

});

parcelRegister("lN5ZJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gfxZh").then(()=>parcelRequire("jqavc"));

});

parcelRegister("f6LYk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cjYzQ").then(()=>parcelRequire("hVLR4"));

});

parcelRegister("fPTwb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9kwQW").then(()=>parcelRequire("fCVja"));

});

parcelRegister("3ImuY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8x0Qw").then(()=>parcelRequire("bPWiZ"));

});

parcelRegister("375e4", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $244614507dfe8350$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $244614507dfe8350$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $244614507dfe8350$export$e673f367da2ff23e);

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");

var $6591b = parcelRequire("6591b");

var $A96et = parcelRequire("A96et");

var $jbywj = parcelRequire("jbywj");
function $244614507dfe8350$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $jbywj.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $A96et.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $A96et.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $244614507dfe8350$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.from(document.head.querySelectorAll("style[".concat((0, $A96et.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $A96et.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $244614507dfe8350$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $6591b.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("6591b", function(module, exports) {

$parcel$export(module.exports, "default", () => $46da3482cb4cde9c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c184d9a6e3b52bd2ab053939ce9ad>>
 * @codegenCommand yarn build tokens
 */ var $46da3482cb4cde9c$var$tokens = {
    "motion.avatar.enter": "--ds-avatar-enter",
    "motion.avatar.exit": "--ds-avatar-exit",
    "motion.avatar.hovered": "--ds-avatar-hovered",
    "motion.content.enter.long": "--ds-content-enter-long",
    "motion.content.enter.medium": "--ds-content-enter-medium",
    "motion.content.enter.short": "--ds-content-enter-short",
    "motion.content.exit.long": "--ds-content-exit-long",
    "motion.content.exit.medium": "--ds-content-exit-medium",
    "motion.content.exit.short": "--ds-content-exit-short",
    "motion.flag.enter": "--ds-flag-enter",
    "motion.flag.exit": "--ds-flag-exit",
    "motion.flag.reposition": "--ds-flag-reposition",
    "motion.modal.enter": "--ds-modal-enter",
    "motion.modal.exit": "--ds-modal-exit",
    "motion.popup.enter.bottom": "--ds-popup-enter-bottom",
    "motion.popup.enter.left": "--ds-popup-enter-left",
    "motion.popup.enter.right": "--ds-popup-enter-right",
    "motion.popup.enter.top": "--ds-popup-enter-top",
    "motion.popup.exit.bottom": "--ds-popup-exit-bottom",
    "motion.popup.exit.left": "--ds-popup-exit-left",
    "motion.popup.exit.right": "--ds-popup-exit-right",
    "motion.popup.exit.top": "--ds-popup-exit-top",
    "motion.spotlight.enter": "--ds-spotlight-enter",
    "motion.spotlight.exit": "--ds-spotlight-exit",
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.danger.bolder": "--ds-text-danger-bolder",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.warning.bolder": "--ds-text-warning-bolder",
    "color.text.success": "--ds-text-success",
    "color.text.success.bolder": "--ds-text-success-bolder",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.discovery.bolder": "--ds-text-discovery-bolder",
    "color.text.information": "--ds-text-information",
    "color.text.information.bolder": "--ds-text-information-bolder",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.subtler": "--ds-background-danger-subtler",
    "color.background.danger.subtler.hovered": "--ds-background-danger-subtler-hovered",
    "color.background.danger.subtler.pressed": "--ds-background-danger-subtler-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.subtler": "--ds-background-warning-subtler",
    "color.background.warning.subtler.hovered": "--ds-background-warning-subtler-hovered",
    "color.background.warning.subtler.pressed": "--ds-background-warning-subtler-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.subtler": "--ds-background-success-subtler",
    "color.background.success.subtler.hovered": "--ds-background-success-subtler-hovered",
    "color.background.success.subtler.pressed": "--ds-background-success-subtler-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.subtler": "--ds-background-discovery-subtler",
    "color.background.discovery.subtler.hovered": "--ds-background-discovery-subtler-hovered",
    "color.background.discovery.subtler.pressed": "--ds-background-discovery-subtler-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.subtler": "--ds-background-information-subtler",
    "color.background.information.subtler.hovered": "--ds-background-information-subtler-hovered",
    "color.background.information.subtler.pressed": "--ds-background-information-subtler-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.metric.large": "--ds-font-metric-large",
    "font.metric.medium": "--ds-font-metric-medium",
    "font.metric.small": "--ds-font-metric-small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "radius.xsmall": "--ds-radius-xsmall",
    "radius.small": "--ds-radius-small",
    "radius.medium": "--ds-radius-medium",
    "radius.large": "--ds-radius-large",
    "radius.xlarge": "--ds-radius-xlarge",
    "radius.xxlarge": "--ds-radius-xxlarge",
    "radius.full": "--ds-radius-full",
    "radius.tile": "--ds-radius-tile",
    "border.width": "--ds-border-width",
    "border.width.selected": "--ds-border-width-selected",
    "border.width.focused": "--ds-border-width-focused"
};
var $46da3482cb4cde9c$export$2e2bcd8739ae039 = $46da3482cb4cde9c$var$tokens;

});


parcelRegister("lQLK6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eDrsH").then(()=>parcelRequire("jmrfH"));

});

parcelRegister("9kTCw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f51491040268dbfa9258c45e59f2b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cc120539a0e78a7$var$_react = $6cc120539a0e78a7$var$_interopRequireDefault((parcelRequire("acw62")));

var $6cc120539a0e78a7$var$_baseNew = $6cc120539a0e78a7$var$_interopRequireDefault((parcelRequire("4U6D5")));
function $6cc120539a0e78a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cc120539a0e78a7$var$PersonIcon = (props)=>/*#__PURE__*/ $6cc120539a0e78a7$var$_react.default.createElement($6cc120539a0e78a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$6cc120539a0e78a7$var$PersonIcon.displayName = "PersonIcon";
var $6cc120539a0e78a7$var$_default = module.exports.default = $6cc120539a0e78a7$var$PersonIcon;

});
parcelRegister("4U6D5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("iwq7i")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("iwq7i")).Icon);

var $iwq7i = parcelRequire("iwq7i");

});
parcelRegister("iwq7i", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $d7bf79657d35ed3d$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $d7bf79657d35ed3d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $d7bf79657d35ed3d$var$commonSVGStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $d7bf79657d35ed3d$var$svgStyles = (0, $dnfL5.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $d7bf79657d35ed3d$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $d7bf79657d35ed3d$var$utilityIconStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $d7bf79657d35ed3d$var$scaleStyles = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $d7bf79657d35ed3d$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $d7bf79657d35ed3d$var$scaleSize = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
var $d7bf79657d35ed3d$var$sizeMap = {
    core: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $d7bf79657d35ed3d$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $d7bf79657d35ed3d$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $d7bf79657d35ed3d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $dnfL5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $d7bf79657d35ed3d$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $d7bf79657d35ed3d$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $d7bf79657d35ed3d$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $dnfL5.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $d7bf79657d35ed3d$var$iconStyles,
            $d7bf79657d35ed3d$var$baseHcmStyles,
            shouldScale && $d7bf79657d35ed3d$var$scaleStyles,
            props.type === "utility" && $d7bf79657d35ed3d$var$utilityIconStyles
        ]
    }, (0, $dnfL5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $d7bf79657d35ed3d$var$commonSVGStyles,
            $d7bf79657d35ed3d$var$svgStyles,
            shouldScale ? $d7bf79657d35ed3d$var$scaleSize : props.type === "utility" ? $d7bf79657d35ed3d$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $d7bf79657d35ed3d$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $d7bf79657d35ed3d$export$2e2bcd8739ae039 = $d7bf79657d35ed3d$export$f04a61298a47a40f;

});



parcelRegister("epzNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7df2c4ebe406233$var$_react = $a7df2c4ebe406233$var$_interopRequireDefault((parcelRequire("acw62")));

var $faoYT = parcelRequire("faoYT");

var $a7df2c4ebe406233$var$_person = $a7df2c4ebe406233$var$_interopRequireDefault((parcelRequire("9kTCw")));
function $a7df2c4ebe406233$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a7df2c4ebe406233$var$PersonIcon = (props)=>/*#__PURE__*/ $a7df2c4ebe406233$var$_react.default.createElement($faoYT.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $a7df2c4ebe406233$var$_person.default
    }));
$a7df2c4ebe406233$var$PersonIcon.displayName = "PersonIcon";
var $a7df2c4ebe406233$var$_default = module.exports.default = $a7df2c4ebe406233$var$PersonIcon;

});
parcelRegister("faoYT", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $b0ab2aeb2ce37867$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $kWX2B = parcelRequire("kWX2B");
var $b0ab2aeb2ce37867$var$_excluded = [
    "dangerouslySetGlyph"
];
var $b0ab2aeb2ce37867$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $b0ab2aeb2ce37867$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b0ab2aeb2ce37867$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $b0ab2aeb2ce37867$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $b0ab2aeb2ce37867$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kWX2B.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("kWX2B", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $f40705b699f31858$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $2O6Gv = parcelRequire("2O6Gv");

var $fJ6tt = parcelRequire("fJ6tt");
function $f40705b699f31858$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f40705b699f31858$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f40705b699f31858$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f40705b699f31858$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $f40705b699f31858$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $f40705b699f31858$var$_objectSpread($f40705b699f31858$var$_objectSpread({}, (0, $2O6Gv.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $f40705b699f31858$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $f40705b699f31858$var$primaryEqualsSecondaryHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $f40705b699f31858$var$secondaryTransparentHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $f40705b699f31858$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $dnfL5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $2O6Gv.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $dnfL5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $fJ6tt.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $f40705b699f31858$var$iconStyles,
            $f40705b699f31858$var$baseHcmStyles,
            primaryColor === secondaryColor && $f40705b699f31858$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $f40705b699f31858$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dnfL5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $f40705b699f31858$export$2e2bcd8739ae039 = $f40705b699f31858$export$f04a61298a47a40f;

});
parcelRegister("2O6Gv", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $20b56fb1a6f52d7c$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $20b56fb1a6f52d7c$export$3eb7d6130acfda37);

var $6PNX0 = parcelRequire("6PNX0");

var $dnfL5 = parcelRequire("dnfL5");
var $20b56fb1a6f52d7c$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $20b56fb1a6f52d7c$var$smallStyles = (0, $dnfL5.css)((0, $6PNX0.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $20b56fb1a6f52d7c$var$mediumStyles = (0, $dnfL5.css)((0, $6PNX0.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $20b56fb1a6f52d7c$var$largeStyles = (0, $dnfL5.css)((0, $6PNX0.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $20b56fb1a6f52d7c$var$xlargeStyles = (0, $dnfL5.css)((0, $6PNX0.dimensions).xlarge);
var $20b56fb1a6f52d7c$export$ef0ad74202575b64 = {
    small: $20b56fb1a6f52d7c$var$smallStyles,
    medium: $20b56fb1a6f52d7c$var$mediumStyles,
    large: $20b56fb1a6f52d7c$var$largeStyles,
    xlarge: $20b56fb1a6f52d7c$var$xlargeStyles
};
var $20b56fb1a6f52d7c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $6PNX0.dimensions)[size];
    return undefined;
};

});
parcelRegister("6PNX0", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $4f9e40ad6a07e76e$export$62ad7b0c781000e9);
var $4f9e40ad6a07e76e$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $4f9e40ad6a07e76e$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $4f9e40ad6a07e76e$export$62ad7b0c781000e9 = {
    small: {
        width: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.small,
        height: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.medium,
        height: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.large,
        height: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.xlarge,
        height: $4f9e40ad6a07e76e$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("fJ6tt", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $b73014a7ced46269$export$18cb9425622d4e06);
var $b73014a7ced46269$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("gBEIc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08061a6d953c7d73b57c2e6e0bdac389>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c16fae9a23a7763d$var$_react = $c16fae9a23a7763d$var$_interopRequireDefault((parcelRequire("acw62")));

var $c16fae9a23a7763d$var$_baseNew = $c16fae9a23a7763d$var$_interopRequireDefault((parcelRequire("4U6D5")));
function $c16fae9a23a7763d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c16fae9a23a7763d$var$ReleaseIcon = (props)=>/*#__PURE__*/ $c16fae9a23a7763d$var$_react.default.createElement($c16fae9a23a7763d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$c16fae9a23a7763d$var$ReleaseIcon.displayName = "ReleaseIcon";
var $c16fae9a23a7763d$var$_default = module.exports.default = $c16fae9a23a7763d$var$ReleaseIcon;

});

parcelRegister("b9unQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81e81a85d31081e4$var$_react = $81e81a85d31081e4$var$_interopRequireDefault((parcelRequire("acw62")));

var $faoYT = parcelRequire("faoYT");

var $81e81a85d31081e4$var$_release = $81e81a85d31081e4$var$_interopRequireDefault((parcelRequire("gBEIc")));
function $81e81a85d31081e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $81e81a85d31081e4$var$ShipIcon = (props)=>/*#__PURE__*/ $81e81a85d31081e4$var$_react.default.createElement($faoYT.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $81e81a85d31081e4$var$_release.default
    }));
$81e81a85d31081e4$var$ShipIcon.displayName = "ShipIcon";
var $81e81a85d31081e4$var$_default = module.exports.default = $81e81a85d31081e4$var$ShipIcon;

});

parcelRegister("cSZPM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11bb746989e6f2f05a6a45e4a2d4e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $961a7e2630920972$var$_react = $961a7e2630920972$var$_interopRequireDefault((parcelRequire("acw62")));

var $961a7e2630920972$var$_baseNew = $961a7e2630920972$var$_interopRequireDefault((parcelRequire("Xh9Pa")));
function $961a7e2630920972$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $961a7e2630920972$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $961a7e2630920972$var$_react.default.createElement($961a7e2630920972$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$961a7e2630920972$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $961a7e2630920972$var$_default = module.exports.default = $961a7e2630920972$var$ChevronDownIcon;

});
parcelRegister("Xh9Pa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7CGOq")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("7CGOq")).Icon);

var $7CGOq = parcelRequire("7CGOq");

});
parcelRegister("7CGOq", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $58cd4a9f088cec9e$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $58cd4a9f088cec9e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $58cd4a9f088cec9e$var$commonSVGStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $58cd4a9f088cec9e$var$svgStyles = (0, $dnfL5.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $58cd4a9f088cec9e$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $58cd4a9f088cec9e$var$utilityIconStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $58cd4a9f088cec9e$var$scaleStyles = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $58cd4a9f088cec9e$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $58cd4a9f088cec9e$var$scaleSize = (0, $dnfL5.css)({
    width: "inherit",
    height: "inherit"
});
var $58cd4a9f088cec9e$var$sizeMap = {
    core: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $dnfL5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $dnfL5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $dnfL5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $58cd4a9f088cec9e$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $58cd4a9f088cec9e$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $58cd4a9f088cec9e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $dnfL5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $58cd4a9f088cec9e$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $58cd4a9f088cec9e$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $58cd4a9f088cec9e$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $dnfL5.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $58cd4a9f088cec9e$var$iconStyles,
            $58cd4a9f088cec9e$var$baseHcmStyles,
            shouldScale && $58cd4a9f088cec9e$var$scaleStyles,
            props.type === "utility" && $58cd4a9f088cec9e$var$utilityIconStyles
        ]
    }, (0, $dnfL5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $58cd4a9f088cec9e$var$commonSVGStyles,
            $58cd4a9f088cec9e$var$svgStyles,
            shouldScale ? $58cd4a9f088cec9e$var$scaleSize : props.type === "utility" ? $58cd4a9f088cec9e$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $58cd4a9f088cec9e$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $58cd4a9f088cec9e$export$2e2bcd8739ae039 = $58cd4a9f088cec9e$export$f04a61298a47a40f;

});



parcelRegister("gw5Wo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0643e3bb908f9d3$var$_react = $c0643e3bb908f9d3$var$_interopRequireDefault((parcelRequire("acw62")));

var $2eZ64 = parcelRequire("2eZ64");

var $c0643e3bb908f9d3$var$_chevronDown = $c0643e3bb908f9d3$var$_interopRequireDefault((parcelRequire("cSZPM")));
function $c0643e3bb908f9d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0643e3bb908f9d3$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c0643e3bb908f9d3$var$_react.default.createElement($2eZ64.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $c0643e3bb908f9d3$var$_chevronDown.default,
        iconType: "utility"
    }));
$c0643e3bb908f9d3$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $c0643e3bb908f9d3$var$_default = module.exports.default = $c0643e3bb908f9d3$var$ChevronDownIcon;

});
parcelRegister("2eZ64", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $1a1c48260bf52a3e$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $bOVcE = parcelRequire("bOVcE");
var $1a1c48260bf52a3e$var$_excluded = [
    "dangerouslySetGlyph"
];
var $1a1c48260bf52a3e$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $1a1c48260bf52a3e$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $1a1c48260bf52a3e$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $1a1c48260bf52a3e$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $1a1c48260bf52a3e$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOVcE.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("bOVcE", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $89b0bc9193879cc1$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $iPMlH = parcelRequire("iPMlH");

var $dsTof = parcelRequire("dsTof");
function $89b0bc9193879cc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89b0bc9193879cc1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89b0bc9193879cc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89b0bc9193879cc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $89b0bc9193879cc1$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $89b0bc9193879cc1$var$_objectSpread($89b0bc9193879cc1$var$_objectSpread({}, (0, $iPMlH.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $89b0bc9193879cc1$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $89b0bc9193879cc1$var$primaryEqualsSecondaryHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $89b0bc9193879cc1$var$secondaryTransparentHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $89b0bc9193879cc1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $dnfL5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $iPMlH.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $dnfL5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $dsTof.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $89b0bc9193879cc1$var$iconStyles,
            $89b0bc9193879cc1$var$baseHcmStyles,
            primaryColor === secondaryColor && $89b0bc9193879cc1$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $89b0bc9193879cc1$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dnfL5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $89b0bc9193879cc1$export$2e2bcd8739ae039 = $89b0bc9193879cc1$export$f04a61298a47a40f;

});
parcelRegister("iPMlH", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $db627e8a5b325194$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $db627e8a5b325194$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $db627e8a5b325194$export$3eb7d6130acfda37);

var $7aiKs = parcelRequire("7aiKs");

var $dnfL5 = parcelRequire("dnfL5");
var $db627e8a5b325194$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db627e8a5b325194$var$smallStyles = (0, $dnfL5.css)((0, $7aiKs.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db627e8a5b325194$var$mediumStyles = (0, $dnfL5.css)((0, $7aiKs.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db627e8a5b325194$var$largeStyles = (0, $dnfL5.css)((0, $7aiKs.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db627e8a5b325194$var$xlargeStyles = (0, $dnfL5.css)((0, $7aiKs.dimensions).xlarge);
var $db627e8a5b325194$export$ef0ad74202575b64 = {
    small: $db627e8a5b325194$var$smallStyles,
    medium: $db627e8a5b325194$var$mediumStyles,
    large: $db627e8a5b325194$var$largeStyles,
    xlarge: $db627e8a5b325194$var$xlargeStyles
};
var $db627e8a5b325194$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7aiKs.dimensions)[size];
    return undefined;
};

});
parcelRegister("7aiKs", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $53780296d2aba6f5$export$62ad7b0c781000e9);
var $53780296d2aba6f5$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $53780296d2aba6f5$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $53780296d2aba6f5$export$62ad7b0c781000e9 = {
    small: {
        width: $53780296d2aba6f5$export$c647cb0ee6e282fe.small,
        height: $53780296d2aba6f5$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $53780296d2aba6f5$export$c647cb0ee6e282fe.medium,
        height: $53780296d2aba6f5$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $53780296d2aba6f5$export$c647cb0ee6e282fe.large,
        height: $53780296d2aba6f5$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $53780296d2aba6f5$export$c647cb0ee6e282fe.xlarge,
        height: $53780296d2aba6f5$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("dsTof", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $9cd8db318fe84567$export$18cb9425622d4e06);
var $9cd8db318fe84567$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("hkroK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9d98ea3a702c438$var$_react = $c9d98ea3a702c438$var$_interopRequireDefault((parcelRequire("acw62")));

var $c9d98ea3a702c438$var$_baseNew = $c9d98ea3a702c438$var$_interopRequireDefault((parcelRequire("itWPA")));
function $c9d98ea3a702c438$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9d98ea3a702c438$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $c9d98ea3a702c438$var$_react.default.createElement($c9d98ea3a702c438$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$c9d98ea3a702c438$var$StatusErrorIcon.displayName = "StatusErrorIcon";
var $c9d98ea3a702c438$var$_default = module.exports.default = $c9d98ea3a702c438$var$StatusErrorIcon;

});
parcelRegister("itWPA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cc9AK")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("cc9AK")).Icon);

var $cc9AK = parcelRequire("cc9AK");

});
parcelRegister("cc9AK", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $8e0e0bbced91c3ba$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $8e0e0bbced91c3ba$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8e0e0bbced91c3ba$var$svgStyles = null;
var $8e0e0bbced91c3ba$var$iconStyles = null;
var $8e0e0bbced91c3ba$var$utilityIconStyles = null;
var $8e0e0bbced91c3ba$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8e0e0bbced91c3ba$var$baseHcmStyles = null;
var $8e0e0bbced91c3ba$var$scaleSize = null;
var $8e0e0bbced91c3ba$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8e0e0bbced91c3ba$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8e0e0bbced91c3ba$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8e0e0bbced91c3ba$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $8e0e0bbced91c3ba$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $8e0e0bbced91c3ba$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $acw62.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $8e0e0bbced91c3ba$var$baseSizeMap[type];
    var viewBoxPadding = $8e0e0bbced91c3ba$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9dvtP.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9dvtP.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $8e0e0bbced91c3ba$var$utilSizes[spacing] : size === "small" ? $8e0e0bbced91c3ba$var$coreSizeSmall[spacing] : $8e0e0bbced91c3ba$var$coreSizeMedium[spacing]
        ])
    }));
});
var $8e0e0bbced91c3ba$export$2e2bcd8739ae039 = $8e0e0bbced91c3ba$export$f04a61298a47a40f;

});



parcelRegister("fj2nS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b24a7ad17b49bf48$var$_react = $b24a7ad17b49bf48$var$_interopRequireDefault((parcelRequire("acw62")));

var $7sSwO = parcelRequire("7sSwO");
function $b24a7ad17b49bf48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b24a7ad17b49bf48$var$ErrorIcon = (props)=>/*#__PURE__*/ $b24a7ad17b49bf48$var$_react.default.createElement($7sSwO.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$b24a7ad17b49bf48$var$ErrorIcon.displayName = "ErrorIcon";
var $b24a7ad17b49bf48$var$_default = module.exports.default = $b24a7ad17b49bf48$var$ErrorIcon;

});
parcelRegister("7sSwO", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $56f572180cf59cf0$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
function $56f572180cf59cf0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56f572180cf59cf0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56f572180cf59cf0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56f572180cf59cf0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $56f572180cf59cf0$var$iconStyles = null;
var $56f572180cf59cf0$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $56f572180cf59cf0$var$baseHcmStyles = null;
var $56f572180cf59cf0$var$primaryEqualsSecondaryHcmStyles = null;
var $56f572180cf59cf0$var$secondaryTransparentHcmStyles = null;
var $56f572180cf59cf0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $acw62.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $56f572180cf59cf0$var$_objectSpread($56f572180cf59cf0$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9dvtP.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $56f572180cf59cf0$var$sizeStyles[size]
        ])
    }));
});
var $56f572180cf59cf0$export$2e2bcd8739ae039 = $56f572180cf59cf0$export$f04a61298a47a40f;

});


parcelRegister("8GMJF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65380cd12630b425$var$_react = $65380cd12630b425$var$_interopRequireDefault((parcelRequire("acw62")));

var $65380cd12630b425$var$_baseNew = $65380cd12630b425$var$_interopRequireDefault((parcelRequire("itWPA")));
function $65380cd12630b425$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65380cd12630b425$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $65380cd12630b425$var$_react.default.createElement($65380cd12630b425$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$65380cd12630b425$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $65380cd12630b425$var$_default = module.exports.default = $65380cd12630b425$var$StatusSuccessIcon;

});

parcelRegister("cKFez", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0265519d85a5315f$var$_react = $0265519d85a5315f$var$_interopRequireDefault((parcelRequire("acw62")));

var $7sSwO = parcelRequire("7sSwO");
function $0265519d85a5315f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0265519d85a5315f$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $0265519d85a5315f$var$_react.default.createElement($7sSwO.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$0265519d85a5315f$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $0265519d85a5315f$var$_default = module.exports.default = $0265519d85a5315f$var$EditorSuccessIcon;

});

parcelRegister("lNKMg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b6fc123789ae26535b6e4ca13d1b4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdf27596143b2f99$var$_react = $fdf27596143b2f99$var$_interopRequireDefault((parcelRequire("acw62")));

var $fdf27596143b2f99$var$_UNSAFE_baseNew = $fdf27596143b2f99$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $fdf27596143b2f99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdf27596143b2f99$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $fdf27596143b2f99$var$_react.default.createElement($fdf27596143b2f99$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$fdf27596143b2f99$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $fdf27596143b2f99$var$_default = module.exports.default = $fdf27596143b2f99$var$ShowMoreHorizontalIcon;

});

parcelRegister("4WWnO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("jnpZj")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("jnpZj")).Icon);

var $jnpZj = parcelRequire("jnpZj");

});
parcelRegister("jnpZj", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $e1b452f3c8fbf7b2$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $e1b452f3c8fbf7b2$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $79zlf = parcelRequire("79zlf");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e1b452f3c8fbf7b2$var$svgStyles = null;
var $e1b452f3c8fbf7b2$var$iconStyles = null;
var $e1b452f3c8fbf7b2$var$smallIconStyles = null;
var $e1b452f3c8fbf7b2$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $e1b452f3c8fbf7b2$var$baseHcmStyles = null;
var $e1b452f3c8fbf7b2$var$scaleSize = null;
var $e1b452f3c8fbf7b2$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e1b452f3c8fbf7b2$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e1b452f3c8fbf7b2$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $e1b452f3c8fbf7b2$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $e1b452f3c8fbf7b2$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $79zlf.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === "small" && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $79zlf.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === "small" ? $e1b452f3c8fbf7b2$var$coreSizeSmall[spacing] : $e1b452f3c8fbf7b2$var$coreSizeMedium[spacing]
        ])
    }));
});
var $e1b452f3c8fbf7b2$export$2e2bcd8739ae039 = $e1b452f3c8fbf7b2$export$f04a61298a47a40f;

});
parcelRegister("79zlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5354c9c549ab0d7c$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5354c9c549ab0d7c$var$ATOMIC_GROUP_LENGTH = 5;
function $5354c9c549ab0d7c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $5354c9c549ab0d7c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("gQkqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c4315997ca70789f$var$_react = $c4315997ca70789f$var$_interopRequireDefault((parcelRequire("acw62")));

var $c4315997ca70789f$var$_spinner = $c4315997ca70789f$var$_interopRequireDefault((parcelRequire("d7p9y")));
function $c4315997ca70789f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c4315997ca70789f$var$LoadingSpinner = function LoadingSpinner() {
    return /*#__PURE__*/ $c4315997ca70789f$var$_react["default"].createElement("div", {
        style: $c4315997ca70789f$var$spinnerStyles
    }, /*#__PURE__*/ $c4315997ca70789f$var$_react["default"].createElement($c4315997ca70789f$var$_spinner["default"], {
        interactionName: "load",
        size: "xlarge"
    }));
};
var $c4315997ca70789f$var$_default = module.exports["default"] = $c4315997ca70789f$var$LoadingSpinner;
var $c4315997ca70789f$var$spinnerStyles = {
    position: "fixed",
    left: "50%",
    top: "350px"
};

});
parcelRegister("d7p9y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8VyKT")).default);

var $8VyKT = parcelRequire("8VyKT");

});
parcelRegister("8VyKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $67fe9b4d2a92e525$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $90CJ8 = parcelRequire("90CJ8");

var $ckWGp = parcelRequire("ckWGp");
/**
 * Returns the appropriate circle stroke color.
 */ function $67fe9b4d2a92e525$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $90CJ8.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $90CJ8.N0), ")");
}
var $67fe9b4d2a92e525$var$rotate = (0, $dnfL5.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $67fe9b4d2a92e525$var$rotateStyles = (0, $dnfL5.css)({
    animation: "".concat($67fe9b4d2a92e525$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $67fe9b4d2a92e525$var$loadIn = (0, $dnfL5.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $67fe9b4d2a92e525$var$loadInStyles = (0, $dnfL5.css)({
    animation: "".concat($67fe9b4d2a92e525$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $67fe9b4d2a92e525$var$wrapperStyles = (0, $dnfL5.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $67fe9b4d2a92e525$var$circleStyles = (0, $dnfL5.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $67fe9b4d2a92e525$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $67fe9b4d2a92e525$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $ckWGp.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $67fe9b4d2a92e525$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $5ZZ0M.default));
    $67fe9b4d2a92e525$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $dnfL5.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $67fe9b4d2a92e525$var$wrapperStyles,
            $67fe9b4d2a92e525$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $dnfL5.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $67fe9b4d2a92e525$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $dnfL5.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $67fe9b4d2a92e525$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $67fe9b4d2a92e525$export$2e2bcd8739ae039 = $67fe9b4d2a92e525$var$Spinner;

});
parcelRegister("90CJ8", function(module, exports) {

$parcel$export(module.exports, "N0", () => $68f22783f6d3d625$export$29a4f05edc054374);
$parcel$export(module.exports, "N500", () => $68f22783f6d3d625$export$c39c0fe0f26207ae);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $68f22783f6d3d625$export$4b84fd0e2c617bd = "#FFEBE6";
var $68f22783f6d3d625$export$b34b069eff244586 = "#FFBDAD";
var $68f22783f6d3d625$export$be802dd0d8b57f35 = "#FF8F73";
var $68f22783f6d3d625$export$60847d42f9da92a6 = "#FF7452";
var $68f22783f6d3d625$export$4a7404f376229999 = "#FF5630";
var $68f22783f6d3d625$export$2010d0fb4295b346 = "#DE350B";
var $68f22783f6d3d625$export$2837b5a1a71d5c02 = "#BF2600";
var $68f22783f6d3d625$export$8d9596b529bbb9cf = "#FFFAE6";
var $68f22783f6d3d625$export$41060a744ab0b7ae = "#FFF0B3";
var $68f22783f6d3d625$export$1cc05bbbf340e559 = "#FFE380";
var $68f22783f6d3d625$export$5aae31392d72caaa = "#FFC400";
var $68f22783f6d3d625$export$c6930421db9fa514 = "#FFAB00";
var $68f22783f6d3d625$export$59619663aa6500fb = "#FF991F";
var $68f22783f6d3d625$export$874739ea9e379ab6 = "#FF8B00";
var $68f22783f6d3d625$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $68f22783f6d3d625$export$69a3bf21b9686c2b = "#ABF5D1";
var $68f22783f6d3d625$export$afbce1382ec95f73 = "#79F2C0";
var $68f22783f6d3d625$export$747d86715d4175de = "#57D9A3";
var $68f22783f6d3d625$export$940e1f69e873f202 = "#36B37E";
var $68f22783f6d3d625$export$a49394138f7b8e85 = "#00875A";
var $68f22783f6d3d625$export$6fa04827ac68a4fb = "#006644";
var $68f22783f6d3d625$export$226de0355ed012f8 = "#DEEBFF";
var $68f22783f6d3d625$export$8c13c2ee36917869 = "#B3D4FF";
var $68f22783f6d3d625$export$ecfc1dff386a3e7a = "#4C9AFF";
var $68f22783f6d3d625$export$215b7063051591f1 = "#2684FF";
var $68f22783f6d3d625$export$e62e8919cca44969 = "#0065FF";
var $68f22783f6d3d625$export$b3de0ae08da2ce64 = "#0052CC";
var $68f22783f6d3d625$export$a6ee3d71bc067634 = "#0747A6";
var $68f22783f6d3d625$export$67f15409e87642a1 = "#669DF1";
var $68f22783f6d3d625$export$f0539dbc42dbb067 = "#8FB8F6";
var $68f22783f6d3d625$export$363e4475840015bb = "#EAE6FF";
var $68f22783f6d3d625$export$4b0a4417ed59760f = "#C0B6F2";
var $68f22783f6d3d625$export$6011520a64d9a187 = "#998DD9";
var $68f22783f6d3d625$export$a7175d4e9206bc80 = "#8777D9";
var $68f22783f6d3d625$export$b48405b95304b5a1 = "#6554C0";
var $68f22783f6d3d625$export$c71e4279dd54a18d = "#5243AA";
var $68f22783f6d3d625$export$147899de772240ec = "#403294";
var $68f22783f6d3d625$export$2cf711fe14c66f06 = "#E6FCFF";
var $68f22783f6d3d625$export$7a8f4d33f6f9772c = "#B3F5FF";
var $68f22783f6d3d625$export$776c9c497ef08533 = "#79E2F2";
var $68f22783f6d3d625$export$69cb3ca10c1e330e = "#00C7E6";
var $68f22783f6d3d625$export$9dc1ef0f3f48059b = "#00B8D9";
var $68f22783f6d3d625$export$7c835c78b6fcdef8 = "#00A3BF";
var $68f22783f6d3d625$export$6036577f95c3877e = "#008DA6";
var $68f22783f6d3d625$export$29a4f05edc054374 = "#FFFFFF";
var $68f22783f6d3d625$export$e655ef011c4aa1a2 = "#FAFBFC";
var $68f22783f6d3d625$export$9fdfb749e33cdf97 = "#F4F5F7";
var $68f22783f6d3d625$export$3e51e8f1440314ba = "#EBECF0";
var $68f22783f6d3d625$export$1ce2d1575d444ceb = "#DFE1E6";
var $68f22783f6d3d625$export$8754fc7e6d8b3000 = "#C1C7D0";
var $68f22783f6d3d625$export$c2e91cbeada39b8b = "#B3BAC5";
var $68f22783f6d3d625$export$5f71e19f3a7ad9de = "#A5ADBA";
var $68f22783f6d3d625$export$eaa8c8a70ac22806 = "#97A0AF";
var $68f22783f6d3d625$export$7c87d337fb91a97d = "#8993A4";
var $68f22783f6d3d625$export$d6447c357493214f = "#7A869A";
var $68f22783f6d3d625$export$f563ee71e9ee74cd = "#6B778C";
var $68f22783f6d3d625$export$e2ef2124cf4024b1 = "#5E6C84";
var $68f22783f6d3d625$export$eece5f492e429f08 = "#505F79";
var $68f22783f6d3d625$export$c39c0fe0f26207ae = "#42526E";
var $68f22783f6d3d625$export$7090862dc3038a9f = "#344563";
var $68f22783f6d3d625$export$ad0bacf983b7ddaa = "#253858";
var $68f22783f6d3d625$export$7d61b15e0da132af = "#172B4D";
var $68f22783f6d3d625$export$fbda843f0a27fe96 = "#091E42";
var $68f22783f6d3d625$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $68f22783f6d3d625$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $68f22783f6d3d625$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $68f22783f6d3d625$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $68f22783f6d3d625$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $68f22783f6d3d625$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $68f22783f6d3d625$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $68f22783f6d3d625$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $68f22783f6d3d625$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $68f22783f6d3d625$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $68f22783f6d3d625$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $68f22783f6d3d625$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $68f22783f6d3d625$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $68f22783f6d3d625$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $68f22783f6d3d625$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $68f22783f6d3d625$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $68f22783f6d3d625$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $68f22783f6d3d625$export$2f6319cf7d736c2a = "#E6EDFA";
var $68f22783f6d3d625$export$95126bc8884d6634 = "#DCE5F5";
var $68f22783f6d3d625$export$8338d8c35d44ff1 = "#CED9EB";
var $68f22783f6d3d625$export$5368d76ae4fbbda7 = "#B8C7E0";
var $68f22783f6d3d625$export$9f0a771d16ec8d36 = "#ABBBD6";
var $68f22783f6d3d625$export$abcf8c38338b4aa5 = "#9FB0CC";
var $68f22783f6d3d625$export$97e81faa16a182c7 = "#8C9CB8";
var $68f22783f6d3d625$export$bfe21c59123ecf33 = "#7988A3";
var $68f22783f6d3d625$export$ee82aa2ea6a1558 = "#67758F";
var $68f22783f6d3d625$export$682927c6ed76be02 = "#56637A";
var $68f22783f6d3d625$export$91fd9994c5be9757 = "#455166";
var $68f22783f6d3d625$export$d281fbfe3cff2df6 = "#3B475C";
var $68f22783f6d3d625$export$3902c91d8b98a753 = "#313D52";
var $68f22783f6d3d625$export$8e8133c1ba5845b5 = "#283447";
var $68f22783f6d3d625$export$33ff357f6620b39 = "#202B3D";
var $68f22783f6d3d625$export$633847cf062b69e0 = "#1B2638";
var $68f22783f6d3d625$export$9776a6e503bdbf76 = "#121A29";
var $68f22783f6d3d625$export$6c813d5160dff5db = "#0E1624";
var $68f22783f6d3d625$export$3d4f271a500072a = "#0D1424";
var $68f22783f6d3d625$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $68f22783f6d3d625$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $68f22783f6d3d625$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $68f22783f6d3d625$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $68f22783f6d3d625$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $68f22783f6d3d625$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $68f22783f6d3d625$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $68f22783f6d3d625$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $68f22783f6d3d625$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $68f22783f6d3d625$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $68f22783f6d3d625$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $68f22783f6d3d625$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $68f22783f6d3d625$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $68f22783f6d3d625$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $68f22783f6d3d625$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $68f22783f6d3d625$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $68f22783f6d3d625$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $68f22783f6d3d625$export$d2adc5dedf09fced = "#292A2E";
var $68f22783f6d3d625$export$f51762073d2bb381 = "#94C748";
var $68f22783f6d3d625$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("ckWGp", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $8fb4df865f5e3f5b$export$4e9f1640bbe7a1a8);
var $8fb4df865f5e3f5b$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("8R0Eu", function(module, exports) {

$parcel$export(module.exports, "extract", () => $6723c76f4b64d4d8$export$f9380c9a627682d3, (v) => $6723c76f4b64d4d8$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $6723c76f4b64d4d8$export$98e6a39c04603d36, (v) => $6723c76f4b64d4d8$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $6723c76f4b64d4d8$export$fac44ee5b035f737, (v) => $6723c76f4b64d4d8$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $6723c76f4b64d4d8$export$7a5253c0f62e0150, (v) => $6723c76f4b64d4d8$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $6723c76f4b64d4d8$export$a8c1621ea79325d3, (v) => $6723c76f4b64d4d8$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $6723c76f4b64d4d8$export$357523c63a2253b9, (v) => $6723c76f4b64d4d8$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $6723c76f4b64d4d8$export$44c361b8ec72ef7f, (v) => $6723c76f4b64d4d8$export$44c361b8ec72ef7f = v);
var $6723c76f4b64d4d8$export$f9380c9a627682d3;
var $6723c76f4b64d4d8$export$98e6a39c04603d36;
var $6723c76f4b64d4d8$export$fac44ee5b035f737;
var $6723c76f4b64d4d8$export$7a5253c0f62e0150;
var $6723c76f4b64d4d8$export$a8c1621ea79325d3;
var $6723c76f4b64d4d8$export$357523c63a2253b9;
var $6723c76f4b64d4d8$export$44c361b8ec72ef7f;
"use strict";

var $3sG8k = parcelRequire("3sG8k");

var $5yzCy = parcelRequire("5yzCy");

var $KvXt7 = parcelRequire("KvXt7");

var $4IJyT = parcelRequire("4IJyT");
const $6723c76f4b64d4d8$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $6723c76f4b64d4d8$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6723c76f4b64d4d8$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $6723c76f4b64d4d8$var$encode(key, options),
                            "[",
                            $6723c76f4b64d4d8$var$encode(index, options),
                            "]=",
                            $6723c76f4b64d4d8$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6723c76f4b64d4d8$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $6723c76f4b64d4d8$var$encode(key, options),
                            "[]=",
                            $6723c76f4b64d4d8$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $6723c76f4b64d4d8$var$encode(key, options),
                            "=",
                            $6723c76f4b64d4d8$var$encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            $6723c76f4b64d4d8$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $6723c76f4b64d4d8$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $6723c76f4b64d4d8$var$encode(key, options),
                            "=",
                            $6723c76f4b64d4d8$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $6723c76f4b64d4d8$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $6723c76f4b64d4d8$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $6723c76f4b64d4d8$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$6723c76f4b64d4d8$var$decode(item, options)) : value === null ? value : $6723c76f4b64d4d8$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $6723c76f4b64d4d8$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $6723c76f4b64d4d8$var$encode(value, options) {
    if (options.encode) return options.strict ? $3sG8k(value) : encodeURIComponent(value);
    return value;
}
function $6723c76f4b64d4d8$var$decode(value, options) {
    if (options.decode) return $5yzCy(value);
    return value;
}
function $6723c76f4b64d4d8$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $6723c76f4b64d4d8$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $6723c76f4b64d4d8$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $6723c76f4b64d4d8$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $6723c76f4b64d4d8$var$extract(input) {
    input = $6723c76f4b64d4d8$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $6723c76f4b64d4d8$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $6723c76f4b64d4d8$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $6723c76f4b64d4d8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $6723c76f4b64d4d8$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $KvXt7(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator"
        ].includes(options.arrayFormat) ? value : $6723c76f4b64d4d8$var$decode(value, options);
        formatter($6723c76f4b64d4d8$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $6723c76f4b64d4d8$var$parseValue(value[k], options);
        else ret[key] = $6723c76f4b64d4d8$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $6723c76f4b64d4d8$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$6723c76f4b64d4d8$export$f9380c9a627682d3 = $6723c76f4b64d4d8$var$extract;
$6723c76f4b64d4d8$export$98e6a39c04603d36 = $6723c76f4b64d4d8$var$parse;
$6723c76f4b64d4d8$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $6723c76f4b64d4d8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $6723c76f4b64d4d8$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $6723c76f4b64d4d8$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $6723c76f4b64d4d8$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return $6723c76f4b64d4d8$var$encode(key, options) + "=" + $6723c76f4b64d4d8$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$6723c76f4b64d4d8$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $KvXt7(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $6723c76f4b64d4d8$var$parse($6723c76f4b64d4d8$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $6723c76f4b64d4d8$var$decode(hash, options)
    } : {});
};
$6723c76f4b64d4d8$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $6723c76f4b64d4d8$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $6723c76f4b64d4d8$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $6723c76f4b64d4d8$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $6723c76f4b64d4d8$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $6723c76f4b64d4d8$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$6723c76f4b64d4d8$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$6723c76f4b64d4d8$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $6723c76f4b64d4d8$export$7a5253c0f62e0150(input, options);
    return $6723c76f4b64d4d8$export$a8c1621ea79325d3({
        url: url,
        query: $4IJyT(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$6723c76f4b64d4d8$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $6723c76f4b64d4d8$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("3sG8k", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("5yzCy", function(module, exports) {
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("KvXt7", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("4IJyT", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("jj25f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2Jd9c")).default);
$parcel$export(module.exports, "apdexType", () => (parcelRequire("3emEs")).apdexType);
$parcel$export(module.exports, "envType", () => (parcelRequire("3emEs")).envType);
$parcel$export(module.exports, "eventType", () => (parcelRequire("3emEs")).eventType);
$parcel$export(module.exports, "originType", () => (parcelRequire("3emEs")).originType);
$parcel$export(module.exports, "platformType", () => (parcelRequire("3emEs")).platformType);
$parcel$export(module.exports, "tenantType", () => (parcelRequire("3emEs")).tenantType);
$parcel$export(module.exports, "userType", () => (parcelRequire("3emEs")).userType);
$parcel$export(module.exports, "originTracingType", () => (parcelRequire("3emEs")).originTracingType);
$parcel$export(module.exports, "TypeAheadHelper", () => (parcelRequire("88GdW")).default);
$parcel$export(module.exports, "DwellTimeHelper", () => (parcelRequire("9Gk3L")).default);
$parcel$export(module.exports, "DwellTimeHelperWithBrowserInteraction", () => (parcelRequire("ljrx0")).default);
$parcel$export(module.exports, "CompressionRule", () => (parcelRequire("ujAQi")).CompressionRule);
$parcel$export(module.exports, "ResilienceMechanism", () => (parcelRequire("baTre")).ResilienceMechanism);
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => (parcelRequire("dOhR7")).StopLowPriorityEventDelayReason);
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => (parcelRequire("dCk84")).STARGATE_PROXY_PATH);
$parcel$export(module.exports, "perimeterType", () => (parcelRequire("3emEs")).perimeterType);
$parcel$export(module.exports, "aliasType", () => (parcelRequire("3emEs")).aliasType);
$parcel$export(module.exports, "groupType", () => (parcelRequire("3emEs")).groupType);
$parcel$export(module.exports, "productEmbedType", () => (parcelRequire("3emEs")).productEmbedType);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2Jd9c = parcelRequire("2Jd9c");

var $3emEs = parcelRequire("3emEs");

var $9Gk3L = parcelRequire("9Gk3L");

var $ljrx0 = parcelRequire("ljrx0");

var $ujAQi = parcelRequire("ujAQi");

var $dOhR7 = parcelRequire("dOhR7");

var $baTre = parcelRequire("baTre");

var $dCk84 = parcelRequire("dCk84");

var $88GdW = parcelRequire("88GdW");

});
parcelRegister("2Jd9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fc9fb8ca02583ba$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $3taTl = parcelRequire("3taTl");

var $jzh7P = parcelRequire("jzh7P");

var $3emEs = parcelRequire("3emEs");

var $aGGqc = parcelRequire("aGGqc");

var $cLGdw = parcelRequire("cLGdw");

var $d8Ako = parcelRequire("d8Ako");

var $dfrhp = parcelRequire("dfrhp");

var $d6RLs = parcelRequire("d6RLs");

var $3eFOQ = parcelRequire("3eFOQ");

var $9AIOF = parcelRequire("9AIOF");

var $bvwZF = parcelRequire("bvwZF");

var $kklyA = parcelRequire("kklyA");

var $iR8R0 = parcelRequire("iR8R0");

var $1lTQd = parcelRequire("1lTQd");

var $jctJE = parcelRequire("jctJE");

var $lwRyj = parcelRequire("lwRyj");

var $lh8UB = parcelRequire("lh8UB");

var $kxtNv = parcelRequire("kxtNv");

var $iPlmd = parcelRequire("iPlmd");

var $eVN6I = parcelRequire("eVN6I");

var $98f64 = parcelRequire("98f64");

var $dCk84 = parcelRequire("dCk84");

var $eh3tt = parcelRequire("eh3tt");

var $ifahf = parcelRequire("ifahf");

var $bswAe = parcelRequire("bswAe");

var $6gFBA = parcelRequire("6gFBA");

var $04nKV = parcelRequire("04nKV");

var $9Ap7b = parcelRequire("9Ap7b");

var $aIR4t = parcelRequire("aIR4t");

var $eNyK8 = parcelRequire("eNyK8");

var $2gINR = parcelRequire("2gINR");

var $7yyBr = parcelRequire("7yyBr");

var $b20JC = parcelRequire("b20JC");

var $dDyod = parcelRequire("dDyod");

var $4n57s = parcelRequire("4n57s");

var $fGJG7 = parcelRequire("fGJG7");

var $dtGPf = parcelRequire("dtGPf");

var $2mBBM = parcelRequire("2mBBM");

var $1oU01 = parcelRequire("1oU01");
function $1fc9fb8ca02583ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fc9fb8ca02583ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fc9fb8ca02583ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fc9fb8ca02583ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1fc9fb8ca02583ba$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $1fc9fb8ca02583ba$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createSubproductGetter", (subproduct)=>(0, $3eFOQ.default)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $3eFOQ.default)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($1fc9fb8ca02583ba$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (_unused) {
                this._safeSessionStorage.removeItem($1fc9fb8ca02583ba$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($1fc9fb8ca02583ba$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $3emEs.eventType).UI:
                case (0, $3emEs.eventType).OPERATIONAL:
                case (0, $3emEs.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $3emEs.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $3emEs.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearEmbeddedProduct", ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setSubproduct", (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $3emEs.tenantType).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $lh8UB.isType)((0, $3emEs.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $iPlmd.objectValues)((0, $3emEs.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setCollaborationContextInfo", (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error("Missing collaborationContextAri");
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearCollaborationContextInfo", ()=>{
            this._collaborationContextInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $7yyBr.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error("Missing aliasType");
            if (!(0, $lh8UB.isType)((0, $3emEs.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $iPlmd.objectValues)((0, $3emEs.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error("Missing groupType");
            if (!(0, $lh8UB.isType)((0, $3emEs.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $iPlmd.objectValues)((0, $3emEs.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getCurrentSessionId", ()=>this._sessionTracking.getCurrentSessionId());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $1fc9fb8ca02583ba$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "appendUIViewedAttributes", (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = $1fc9fb8ca02583ba$var$_objectSpread($1fc9fb8ca02583ba$var$_objectSpread({}, this._uiViewedAttributes), attributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $3emEs.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $4n57s.validateScreenEvent)(screenName);
            (0, $2gINR.validateContainers)(screenContainers);
            const builtEvent = (0, $d6RLs.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $1fc9fb8ca02583ba$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $2mBBM.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $fGJG7.validateTrackEvent)(event);
            const builtEvent = (0, $cLGdw.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $3emEs.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $d8Ako.buildActionName)(event), builtEvent, this._context, (0, $2mBBM.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendUIEvent", (event, callback)=>{
            (0, $dtGPf.validateUIEvent)(event);
            const builtEvent = (0, $cLGdw.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $3emEs.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $d8Ako.buildActionName)(event), builtEvent, this._context, (0, $2mBBM.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $b20JC.validateOperationalEvent)(event);
            const builtEvent = (0, $cLGdw.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $3emEs.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $d8Ako.buildActionName)(event), builtEvent, this._context, (0, $2mBBM.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "signalUserActive", ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createUIViewedEvent", (callback)=>{
            return new (0, $9Ap7b.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopLowPriorityEventDelay", ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $3emEs.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $3emEs.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $3emEs.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $3emEs.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $3emEs.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $iPlmd.objectValues)((0, $3emEs.eventType))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setResponseCallback", (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $lh8UB.isType)((0, $3emEs.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $iPlmd.objectValues)((0, $3emEs.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $3emEs.originType).WEB;
        else if (!(0, $lh8UB.isType)((0, $3emEs.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $iPlmd.objectValues)((0, $3emEs.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $3emEs.originType).WEB ? (0, $3emEs.platformType).WEB : (0, $3emEs.platformType).DESKTOP;
        else (0, $dDyod.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $3taTl.isFedrampModerate)()) productInfo.perimeter = (0, $3emEs.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn("Failed to auto-detect perimeter: %s", e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $3emEs.perimeterType).COMMERCIAL;
        if (!(0, $lh8UB.isType)((0, $3emEs.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $iPlmd.objectValues)((0, $3emEs.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $jzh7P.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn("Failed to auto-detect isolation context: %s", e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = $1fc9fb8ca02583ba$var$_objectSpread($1fc9fb8ca02583ba$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $jctJE.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext["embeddedType"],
                embeddedFromProduct: this._embeddedContext["embeddedFromProduct"],
                embeddedFromSubproduct: this._embeddedContext["embeddedFromSubproduct"],
                embeddedFromTopLevelDomain: this._embeddedContext["embeddedFromTopLevelDomain"]
            });
            if ((0, $lwRyj.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext["embeddedType"],
                embeddedFromTopLevelDomain: this._embeddedContext["embeddedFromTopLevelDomain"]
            });
        }
        this._context = (0, $dfrhp.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $ifahf.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $dCk84.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $1oU01.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $1lTQd.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $iR8R0.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $kxtNv.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $98f64.default)();
        this._tabTracking = new (0, $bswAe.default)();
        this._sessionTracking = new (0, $eh3tt.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $6gFBA.default)();
        this._originTracing = new (0, $eVN6I.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $aGGqc.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $bvwZF.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $kklyA.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $04nKV.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $eNyK8.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $9AIOF.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === "boolean") return !settings.disableMetadataCalls;
        return !(0, $aIR4t.TestSupport).isGeminiVREnvironment() && !(0, $aIR4t.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === "boolean") return !settings.disableEventCalls;
        return !(0, $aIR4t.TestSupport).isGeminiVREnvironment() && !(0, $aIR4t.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("3taTl", function(module, exports) {

$parcel$export(module.exports, "isFedrampModerate", () => $286c876254117dbb$export$104cb891a6e90b3a);

var $8GL4H = parcelRequire("8GL4H");

var $d3xzk = parcelRequire("d3xzk");
function $286c876254117dbb$export$104cb891a6e90b3a() {
    if (typeof document === "undefined") {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $d3xzk.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $8GL4H.FEDRAMP_MODERATE);
}

});
parcelRegister("8GL4H", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $6536c30e66bd6706$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $6536c30e66bd6706$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $6536c30e66bd6706$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $6536c30e66bd6706$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $6536c30e66bd6706$export$a0ffa0598c95dfb7);
var $6536c30e66bd6706$export$ce553301d55c2fd8 = "fedramp-moderate";
var $6536c30e66bd6706$export$f005e2e9f707cb5f = "commercial";
var $6536c30e66bd6706$export$17b81a3d6c98013c = "isolated-cloud";
var $6536c30e66bd6706$export$a739cd5aac835909 = "staging";
var $6536c30e66bd6706$export$42dd0cdd351a4a9 = "prod";
var $6536c30e66bd6706$export$404582bc18fe4d9e = "dev";
var $6536c30e66bd6706$export$87285944378c596 = "Atl-Ctx-Perimeter";
var $6536c30e66bd6706$export$715603e81922c3ec = "Atl-Ctx-Isolation-Context-Domain";
var $6536c30e66bd6706$export$a0ffa0598c95dfb7 = "Atl-Ctx-Isolation-Context-Id";
var $6536c30e66bd6706$export$74814ca8786924c3 = "Bifrost-Atl-Ctx-Cloud-Service-Provider";
var $6536c30e66bd6706$export$b61e047ddcc35726 = "GCP";
var $6536c30e66bd6706$export$1baf17f3e645a2b2 = "AWS";

});

parcelRegister("d3xzk", function(module, exports) {

$parcel$export(module.exports, "parseAtlCtxCookies", () => $981598443d5cb87d$export$3fa7b7af96286cc9);

var $8GL4H = parcelRequire("8GL4H");

var $4V65e = parcelRequire("4V65e");
function $981598443d5cb87d$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === "undefined") return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $4V65e.getRawCookieValue)((0, $8GL4H.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $4V65e.getRawCookieValue)((0, $8GL4H.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $4V65e.getRawCookieValue)((0, $8GL4H.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn("Failed to parse atl-ctx cookies:", e);
        return undefined;
    }
}

});
parcelRegister("4V65e", function(module, exports) {

$parcel$export(module.exports, "getRawCookieValue", () => $3951345314f46439$export$aa09aab30a92256c);

var $02Ztr = parcelRequire("02Ztr");
function $3951345314f46439$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3951345314f46439$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3951345314f46439$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3951345314f46439$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3951345314f46439$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3951345314f46439$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3951345314f46439$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(";");
    var _iterator = $3951345314f46439$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split("="), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});



parcelRegister("jzh7P", function(module, exports) {

$parcel$export(module.exports, "isolationContextId", () => $e3ee91edf45bee3f$export$839b022803d38d4d);

var $d3xzk = parcelRequire("d3xzk");

var $lAjSg = parcelRequire("lAjSg");
function $e3ee91edf45bee3f$export$839b022803d38d4d() {
    if (typeof document === "undefined") {
        var _globalThis$ssrContex;
        // @ts-ignore
        return (0, $lAjSg.isIsolatedCloud)() ? (_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.icName : undefined;
    }
    var atlCtxCookieValues = (0, $d3xzk.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("lAjSg", function(module, exports) {

$parcel$export(module.exports, "isIsolatedCloud", () => $fb6c6062dac6c0ee$export$9186ccba8effc5de);

var $fgvTF = parcelRequire("fgvTF");

var $d3xzk = parcelRequire("d3xzk");
function $fb6c6062dac6c0ee$export$9186ccba8effc5de() {
    if (typeof document === "undefined") {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInIC) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $d3xzk.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $fgvTF.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("fgvTF", function(module, exports) {

$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $b1d117ab57a666fb$export$d8347b4aae768c2d);

var $8GL4H = parcelRequire("8GL4H");
var $b1d117ab57a666fb$export$d8347b4aae768c2d = [
    (0, $8GL4H.COMMERCIAL)
];

});



parcelRegister("3emEs", function(module, exports) {

$parcel$export(module.exports, "envType", () => $25a4400c7401e51c$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $25a4400c7401e51c$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $25a4400c7401e51c$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $25a4400c7401e51c$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $25a4400c7401e51c$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $25a4400c7401e51c$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $25a4400c7401e51c$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $25a4400c7401e51c$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $25a4400c7401e51c$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $25a4400c7401e51c$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $25a4400c7401e51c$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $25a4400c7401e51c$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $25a4400c7401e51c$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $25a4400c7401e51c$export$e73680b18d9b7c6e);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


let $25a4400c7401e51c$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $25a4400c7401e51c$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $25a4400c7401e51c$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $25a4400c7401e51c$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $25a4400c7401e51c$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $25a4400c7401e51c$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
let $25a4400c7401e51c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $25a4400c7401e51c$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $25a4400c7401e51c$export$809831be6c4c6227 = Object.freeze([
    $25a4400c7401e51c$export$6b4f396210e539f3.DESKTOP,
    $25a4400c7401e51c$export$6b4f396210e539f3.MAC,
    $25a4400c7401e51c$export$6b4f396210e539f3.LINUX,
    $25a4400c7401e51c$export$6b4f396210e539f3.WINDOWS
]);
const $25a4400c7401e51c$export$19c579398ad213e7 = Object.freeze([
    $25a4400c7401e51c$export$6b4f396210e539f3.WEB,
    $25a4400c7401e51c$export$6b4f396210e539f3.MOBILE_WEB
]);
let $25a4400c7401e51c$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
let $25a4400c7401e51c$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $25a4400c7401e51c$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $25a4400c7401e51c$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $25a4400c7401e51c$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("aGGqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7ebba6300b6275$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $3emEs = parcelRequire("3emEs");

var $lh8UB = parcelRequire("lh8UB");

var $98f64 = parcelRequire("98f64");

var $4jP9S = parcelRequire("4jP9S");
function $7c7ebba6300b6275$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c7ebba6300b6275$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c7ebba6300b6275$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c7ebba6300b6275$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $7c7ebba6300b6275$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $7c7ebba6300b6275$var$_objectSpread($7c7ebba6300b6275$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $3emEs.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $3emEs.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $3emEs.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $lh8UB.isType)((0, $3emEs.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $3emEs.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $7c7ebba6300b6275$var$_objectSpread($7c7ebba6300b6275$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $98f64.default))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $4jP9S.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($7c7ebba6300b6275$var$_objectSpread($7c7ebba6300b6275$var$_objectSpread($7c7ebba6300b6275$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("lh8UB", function(module, exports) {

$parcel$export(module.exports, "isType", () => $f7d2193aac96b62a$export$26b9f946b448f23e);
function $f7d2193aac96b62a$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("98f64", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a6092575b651db8$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");
class $6a6092575b651db8$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== "undefined") {
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this._isHidden = document.msHidden;
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._isHidden = document.webkitHidden;
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("4jP9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $32509eb9e7f1816c$export$2e2bcd8739ae039);
class $32509eb9e7f1816c$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("cLGdw", function(module, exports) {

$parcel$export(module.exports, "buildActionEvent", () => $94ba9f3ec2cc2cd8$export$7bf451af4a8e3dd9);

var $g5Zhu = parcelRequire("g5Zhu");

var $9lihP = parcelRequire("9lihP");

var $k7lJ0 = parcelRequire("k7lJ0");

var $gu3tN = parcelRequire("gu3tN");

var $1iS4X = parcelRequire("1iS4X");

var $jTyvq = parcelRequire("jTyvq");

var $lbZRs = parcelRequire("lbZRs");

var $aZmVu = parcelRequire("aZmVu");

var $17Wsx = parcelRequire("17Wsx");

var $9ibYJ = parcelRequire("9ibYJ");

var $jOfuE = parcelRequire("jOfuE");

var $hM1c4 = parcelRequire("hM1c4");
function $94ba9f3ec2cc2cd8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94ba9f3ec2cc2cd8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94ba9f3ec2cc2cd8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94ba9f3ec2cc2cd8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94ba9f3ec2cc2cd8$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $aZmVu.buildProductFields)(productInfo, (0, $hM1c4.extractProductOverrides)(event));
    const tenantFields = (0, $17Wsx.buildTenantFields)(tenantInfo);
    const orgFields = (0, $lbZRs.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $jOfuE.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $gu3tN.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $9ibYJ.buildUserFields)(userInfo);
    const actionFields = (0, $9lihP.buildActionFields)(event, actionEventType);
    return $94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread($94ba9f3ec2cc2cd8$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), (0, $1iS4X.buildEventOverrides)(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), collaborationContextFields), (0, $k7lJ0.buildAliases)(aliases)), (0, $jTyvq.buildGroups)(groups));
}

});
parcelRegister("9lihP", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", () => $6cd44286ffddfb56$export$655ecf7241feac42);

var $g5Zhu = parcelRequire("g5Zhu");

var $abasB = parcelRequire("abasB");
function $6cd44286ffddfb56$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cd44286ffddfb56$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cd44286ffddfb56$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cd44286ffddfb56$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6cd44286ffddfb56$export$655ecf7241feac42(event, actionEventType) {
    return $6cd44286ffddfb56$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, (0, $abasB.buildContainersWithName)(event.containers));
}

});
parcelRegister("abasB", function(module, exports) {

$parcel$export(module.exports, "buildContainersWithName", () => $76930bae5f3cb3bd$export$f045f238d77c002a);

var $aCCbZ = parcelRequire("aCCbZ");

var $8o7dw = parcelRequire("8o7dw");

var $3L5C3 = parcelRequire("3L5C3");
function $76930bae5f3cb3bd$export$f045f238d77c002a(containers) {
    if ((0, $3L5C3.isNotEmptyObject)(containers)) {
        const validContainers = (0, $8o7dw.filterAndBuildContainers)(containers);
        return (0, $aCCbZ.buildAttributesWithName)("containers", validContainers);
    }
    return undefined;
}

});
parcelRegister("aCCbZ", function(module, exports) {

$parcel$export(module.exports, "buildAttributesWithName", () => $7bbb143a236649ec$export$55b70947967d0b50);

var $3L5C3 = parcelRequire("3L5C3");
function $7bbb143a236649ec$export$55b70947967d0b50(name, attrObject) {
    return (0, $3L5C3.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("3L5C3", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyObject", () => $2bca1d71fc2705f8$export$e0287cc73292b477);

var $l3Lvn = parcelRequire("l3Lvn");
function $2bca1d71fc2705f8$export$e0287cc73292b477(obj) {
    return (0, $l3Lvn.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("l3Lvn", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $f54eba4d012ed43a$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $f54eba4d012ed43a$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $f54eba4d012ed43a$var$isObjectObject(o) {
    return $f54eba4d012ed43a$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $f54eba4d012ed43a$export$53b83ca8eaab0383(o) {
    if ($f54eba4d012ed43a$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($f54eba4d012ed43a$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("8o7dw", function(module, exports) {

$parcel$export(module.exports, "filterAndBuildContainers", () => $61b629c8baef7c9a$export$3f5115a568819c1a);
function $61b629c8baef7c9a$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("k7lJ0", function(module, exports) {

$parcel$export(module.exports, "buildAliases", () => $ea55502edee77aaa$export$2c4ef8ee173bbcaa);

var $3L5C3 = parcelRequire("3L5C3");
function $ea55502edee77aaa$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $3L5C3.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("gu3tN", function(module, exports) {

$parcel$export(module.exports, "buildCollaborationContextFields", () => $c00225a35b483894$export$d138783ff9effae1);
function $c00225a35b483894$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("1iS4X", function(module, exports) {

$parcel$export(module.exports, "buildEventOverrides", () => $0f316bdc3acc0687$export$469803cc371327c2);
function $0f316bdc3acc0687$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("jTyvq", function(module, exports) {

$parcel$export(module.exports, "buildGroups", () => $e7bdeb89ca485310$export$680f59e10d3eb269);

var $3L5C3 = parcelRequire("3L5C3");
function $e7bdeb89ca485310$export$680f59e10d3eb269(groups) {
    if ((0, $3L5C3.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("lbZRs", function(module, exports) {

$parcel$export(module.exports, "buildOrgFields", () => $f6da9c67aef0c685$export$19ccbe55c9aa75d5);
function $f6da9c67aef0c685$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("aZmVu", function(module, exports) {

$parcel$export(module.exports, "buildProductFields", () => $80016290333d30fd$export$bd1896e45d2ef8e8);

var $dmuc1 = parcelRequire("dmuc1");
function $80016290333d30fd$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $dmuc1.getProductField)(productInfo.env, overrides.env);
    const product = (0, $dmuc1.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $dmuc1.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $dmuc1.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $dmuc1.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $dmuc1.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("dmuc1", function(module, exports) {

$parcel$export(module.exports, "getProductField", () => $9ba4c020b20f4411$export$690c718dc8037b2e);
function $9ba4c020b20f4411$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("17Wsx", function(module, exports) {

$parcel$export(module.exports, "buildTenantFields", () => $0d23cab3b83026b9$export$ab02ab56ae59d840);
function $0d23cab3b83026b9$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("9ibYJ", function(module, exports) {

$parcel$export(module.exports, "buildUserFields", () => $6c3f16335ef6f42d$export$4557a3fdd8921d68);
function $6c3f16335ef6f42d$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("jOfuE", function(module, exports) {

$parcel$export(module.exports, "buildWorkspaceFields", () => $e6beb480de031cdf$export$73c41604cd4b31da);
function $e6beb480de031cdf$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("hM1c4", function(module, exports) {

$parcel$export(module.exports, "extractProductOverrides", () => $cf07d862540fe20a$export$e3d99b4bfec06f6e);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $cf07d862540fe20a$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("d8Ako", function(module, exports) {

$parcel$export(module.exports, "buildActionName", () => $990833ab91dccaa9$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $990833ab91dccaa9$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("dfrhp", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $9a51d64b5215821b$export$3a7fe28f9bf4f3d9);

var $jcMgg = parcelRequire("jcMgg");
const $9a51d64b5215821b$var$libraryVersion = "5.30.0";
function $9a51d64b5215821b$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $jcMgg.validationMode).QUIET;
    if (environment.includes("prod")) return (0, $jcMgg.validationMode).QUIET;
    return (0, $jcMgg.validationMode).COMPLETE;
}
function $9a51d64b5215821b$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $9a51d64b5215821b$var$libraryVersion
            },
            validationMode: $9a51d64b5215821b$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("jcMgg", function(module, exports) {

$parcel$export(module.exports, "validationMode", () => $dfb49300ae2fbf84$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
let $dfb49300ae2fbf84$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("d6RLs", function(module, exports) {

$parcel$export(module.exports, "buildScreenEvent", () => $98b58a6c7bb04044$export$c7d9a5f56acc4b19);

var $g5Zhu = parcelRequire("g5Zhu");

var $3emEs = parcelRequire("3emEs");

var $k7lJ0 = parcelRequire("k7lJ0");

var $aCCbZ = parcelRequire("aCCbZ");

var $gu3tN = parcelRequire("gu3tN");

var $abasB = parcelRequire("abasB");

var $1iS4X = parcelRequire("1iS4X");

var $jTyvq = parcelRequire("jTyvq");

var $lbZRs = parcelRequire("lbZRs");

var $aZmVu = parcelRequire("aZmVu");

var $17Wsx = parcelRequire("17Wsx");

var $9ibYJ = parcelRequire("9ibYJ");

var $jOfuE = parcelRequire("jOfuE");
function $98b58a6c7bb04044$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98b58a6c7bb04044$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98b58a6c7bb04044$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98b58a6c7bb04044$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $98b58a6c7bb04044$var$buildAttributes(attributes) {
    return (0, $aCCbZ.buildAttributesWithName)("attributes", attributes);
}
function $98b58a6c7bb04044$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $aCCbZ.buildAttributesWithName)("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $98b58a6c7bb04044$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $aZmVu.buildProductFields)(productInfo);
    const tenantFields = (0, $17Wsx.buildTenantFields)(tenantInfo);
    const userFields = (0, $9ibYJ.buildUserFields)(userInfo);
    const orgFields = (0, $lbZRs.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $jOfuE.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $gu3tN.buildCollaborationContextFields)(collaborationContextInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $3emEs.eventType).SCREEN
    };
    return $98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread($98b58a6c7bb04044$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $98b58a6c7bb04044$var$buildAttributes(attributes)), $98b58a6c7bb04044$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), (0, $abasB.buildContainersWithName)(containers)), (0, $1iS4X.buildEventOverrides)(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), collaborationContextFields), (0, $k7lJ0.buildAliases)(aliases)), (0, $jTyvq.buildGroups)(groups));
}

});

parcelRegister("3eFOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b31e4a5eb1a260$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $25b31e4a5eb1a260$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $25b31e4a5eb1a260$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($25b31e4a5eb1a260$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("9AIOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fba3d69114aab15$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $6BMho = parcelRequire("6BMho");
var $5aeOH = parcelRequire("5aeOH");
var $jGeFe = parcelRequire("jGeFe");

var $3emEs = parcelRequire("3emEs");

var $kS1ye = parcelRequire("kS1ye");
const $6fba3d69114aab15$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $5aeOH.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $6fba3d69114aab15$export$2e2bcd8739ae039 {
    constructor(options){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "validProduct", false);
        this.isEnabled = options.perimeter !== (0, $3emEs.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ""
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $jGeFe.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $kS1ye.default)($6fba3d69114aab15$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $5aeOH.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $5aeOH.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (_unused) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $6BMho.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: "corrupted",
            actionSubject: "interactionSession",
            attributes: {
                url: this.urlValidation.url
            },
            source: "interactionComponent",
            tags: [
                "navigationExperiences"
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("6BMho", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfba616f7f754f8$export$2e2bcd8739ae039);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $g5Zhu = parcelRequire("g5Zhu");

var $49fh7 = parcelRequire("49fh7");

var $3taTl = parcelRequire("3taTl");

var $99gYJ = parcelRequire("99gYJ");

var $e7WCo = parcelRequire("e7WCo");

var $hioX8 = parcelRequire("hioX8");
var $4cfba616f7f754f8$export$b9dd752fb13352ce = "interactionSession.source";
var $4cfba616f7f754f8$export$e04e3c50573f9af7 = "interactionSession.bridge";
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ var $4cfba616f7f754f8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsCrossProductInteractionClient);
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getCurrentInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getPreviousInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getBridge", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($4cfba616f7f754f8$export$e04e3c50573f9af7) : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getInteractionSource", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($4cfba616f7f754f8$export$b9dd752fb13352ce) : null;
    });
    var shouldDisable = (0, $99gYJ.fg)("use_frontend_feature_encoding_sdk_platform") ? !(0, $49fh7.isFeatureEnabled)("atlassian-analytics", "atlassian-analytics-cross-product-interaction-client") : (0, $3taTl.isFedrampModerate)();
    this.isEnabled = !shouldDisable;
    if (this.isEnabled) {
        // Get singleton interaction session tracking instance
        this.interactionSessionTracking = (0, $e7WCo.default).getInstance();
        var isValidPersistedId = false;
        if (this.interactionSessionTracking) {
            if (interactionSessionOptions) {
                this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
            }
        }
        this.safeSessionStorage = new (0, $hioX8.default)();
        // Store other interaction session parameters directly in session storage if ID has been validated
        if (isValidPersistedId) {
            bridge && this.safeSessionStorage.setItem($4cfba616f7f754f8$export$e04e3c50573f9af7, bridge);
            interactionSource && this.safeSessionStorage.setItem($4cfba616f7f754f8$export$b9dd752fb13352ce, interactionSource);
        }
    }
});

});
parcelRegister("49fh7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $gCTcd = parcelRequire("gCTcd");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $gCTcd.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $gCTcd.isFeatureEnabled;
    }
});

});
parcelRegister("gCTcd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $aQDHF = parcelRequire("aQDHF");

var $a5GzP = parcelRequire("a5GzP");

var $kdKWG = parcelRequire("kdKWG");

var $lrbYW = parcelRequire("lrbYW");
const $c1ab02bd81eabd4e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
function $c1ab02bd81eabd4e$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $c1ab02bd81eabd4e$var$getBoundaryKey();
    return (0, $a5GzP.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $c1ab02bd81eabd4e$var$isEnvironmentBlockEnabled;
function $c1ab02bd81eabd4e$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $kdKWG.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $c1ab02bd81eabd4e$var$getBoundaryKey();
    const aemResult = (0, $a5GzP.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) {
        if ((0, $lrbYW.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        const metadata = (0, $a5GzP.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if (metadata && metadata.auditPhase) return $c1ab02bd81eabd4e$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
module.exports.isFeatureEnabled = $c1ab02bd81eabd4e$var$isFeatureEnabled;
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $c1ab02bd81eabd4e$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $lrbYW.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $a5GzP.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $lrbYW.isSSR)() && localStorage.getItem(`${$c1ab02bd81eabd4e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $c1ab02bd81eabd4e$var$shouldEnableForAudit;
function $c1ab02bd81eabd4e$var$getBoundaryKey() {
    if ((0, $aQDHF.isFedrampModerate)()) return $a5GzP.FED_MOD_KEY;
    if ((0, $aQDHF.isIsolatedCloud)()) return $a5GzP.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $a5GzP.COMMERCIAL_KEY;
}
function $c1ab02bd81eabd4e$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$c1ab02bd81eabd4e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $c1ab02bd81eabd4e$var$configureAuditState;
function $c1ab02bd81eabd4e$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$c1ab02bd81eabd4e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $c1ab02bd81eabd4e$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $c1ab02bd81eabd4e$var$isFeatureEnabled,
    overrideFeature: $kdKWG.overrideFeature,
    clearFeatureOverride: $kdKWG.clearFeatureOverride,
    clearAllOverrides: $kdKWG.clearAllOverrides,
    configureAuditState: $c1ab02bd81eabd4e$var$configureAuditState,
    clearAuditState: $c1ab02bd81eabd4e$var$clearAuditState
};

});
parcelRegister("aQDHF", function(module, exports) {

$parcel$export(module.exports, "isIsolatedCloud", () => $7e5d8ef8fb8623b0$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $7e5d8ef8fb8623b0$export$104cb891a6e90b3a);

var $ddfc1 = parcelRequire("ddfc1");

var $g4BTV = parcelRequire("g4BTV");
function $7e5d8ef8fb8623b0$export$9186ccba8effc5de() {
    var atlCtxCookieValues = (0, $g4BTV.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $ddfc1.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $7e5d8ef8fb8623b0$export$104cb891a6e90b3a() {
    var atlCtxCookieValues = (0, $g4BTV.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $ddfc1.FEDRAMP_MODERATE);
}
function $7e5d8ef8fb8623b0$export$80638ee198476daf() {
    var atlCtxCookieValues = (0, $g4BTV.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $7e5d8ef8fb8623b0$export$839b022803d38d4d() {
    var atlCtxCookieValues = (0, $g4BTV.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("ddfc1", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $99e8463e833d31d5$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $99e8463e833d31d5$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $99e8463e833d31d5$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $99e8463e833d31d5$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $99e8463e833d31d5$export$a0ffa0598c95dfb7);
var $99e8463e833d31d5$export$ce553301d55c2fd8 = "fedramp-moderate";
var $99e8463e833d31d5$export$f005e2e9f707cb5f = "commercial";
var $99e8463e833d31d5$export$a739cd5aac835909 = "staging";
var $99e8463e833d31d5$export$42dd0cdd351a4a9 = "prod";
var $99e8463e833d31d5$export$404582bc18fe4d9e = "dev";
var $99e8463e833d31d5$export$d8347b4aae768c2d = [
    $99e8463e833d31d5$export$f005e2e9f707cb5f
];
var $99e8463e833d31d5$export$b1b1ccc8f3e7f954 = [
    $99e8463e833d31d5$export$f005e2e9f707cb5f,
    $99e8463e833d31d5$export$ce553301d55c2fd8
];
var $99e8463e833d31d5$export$87285944378c596 = "Atl-Ctx-Perimeter";
var $99e8463e833d31d5$export$715603e81922c3ec = "Atl-Ctx-Isolation-Context-Domain";
var $99e8463e833d31d5$export$a0ffa0598c95dfb7 = "Atl-Ctx-Isolation-Context-Id";

});

parcelRegister("g4BTV", function(module, exports) {

$parcel$export(module.exports, "parseAtlCtxCookies", () => $bb3a6b6aa725d3a4$export$3fa7b7af96286cc9);

var $02Ztr = parcelRequire("02Ztr");

var $ddfc1 = parcelRequire("ddfc1");
function $bb3a6b6aa725d3a4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bb3a6b6aa725d3a4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bb3a6b6aa725d3a4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bb3a6b6aa725d3a4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bb3a6b6aa725d3a4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bb3a6b6aa725d3a4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $bb3a6b6aa725d3a4$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(";");
    var _iterator = $bb3a6b6aa725d3a4$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split("="), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
function $bb3a6b6aa725d3a4$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === "undefined") return undefined;
        var cookies = global.document.cookie;
        var perimeter = $bb3a6b6aa725d3a4$var$getRawCookieValue((0, $ddfc1.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = $bb3a6b6aa725d3a4$var$getRawCookieValue((0, $ddfc1.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = $bb3a6b6aa725d3a4$var$getRawCookieValue((0, $ddfc1.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn("Failed to parse atl-ctx cookies:", e);
        return undefined;
    }
}

});


parcelRegister("a5GzP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $lskyC = parcelRequire("lskyC");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $lskyC.isEnvironmentBlockEnabledForBoundary;
    }
});

var $lskyC = parcelRequire("lskyC");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $lskyC.isFeatureEnabledForBoundary;
    }
});

var $lskyC = parcelRequire("lskyC");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $lskyC.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $4oVam = parcelRequire("4oVam");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $4oVam.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $4oVam.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $4oVam.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $4oVam.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $4oVam.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("lskyC", function(module, exports) {
"use strict";
var $f9ec28c523fbc563$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $f9ec28c523fbc563$var$sdk_data_json_1 = $f9ec28c523fbc563$var$__importDefault((parcelRequire("auPFT")));
const $f9ec28c523fbc563$var$aemEnvironmentBlockData = $f9ec28c523fbc563$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $f9ec28c523fbc563$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($f9ec28c523fbc563$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $f9ec28c523fbc563$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $f9ec28c523fbc563$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $f9ec28c523fbc563$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $f9ec28c523fbc563$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $f9ec28c523fbc563$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $f9ec28c523fbc563$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($f9ec28c523fbc563$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $f9ec28c523fbc563$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$f9ec28c523fbc563$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $f9ec28c523fbc563$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $f9ec28c523fbc563$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $f9ec28c523fbc563$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$f9ec28c523fbc563$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $f9ec28c523fbc563$var$getFeatureAvailabilityMetadataForBoundary;
function $f9ec28c523fbc563$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $f9ec28c523fbc563$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$f9ec28c523fbc563$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("auPFT", function(module, exports) {
module.exports = JSON.parse('{"compositionKeyMap":{"cc":"commercial-cloud","ic":"isolated-cloud-commercial","fm":"fedramp-moderate"},"environmentBlocks":{"adminhub":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"admin-hub-threat-detection-system-for-custom-domains":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-access-requests":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-add-app-beta-grid":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-add-app-collections-grid":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-add-app-discover-grid":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-add-app-enterprise-grid":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-add-app-standalone-apps-grid":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-add-product":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-admin-insights":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-ai-enabled-apps":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-api-token-controls":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-app-requests":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-app-updates":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-application-tunnels":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-apps-discovery":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-atlassian-intelligence":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-audit-log":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-authentication-policies":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-automations":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-backup-and-restore":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-billing-console":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-billing-preview":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-byok":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-cart":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-cmk-encryption":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-code-intelligence":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-connected-emoji":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-connected-sources":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-connector-protection":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-contacts":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-custom-domain-email-notification":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-custom-domains":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-data-classifications":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-data-management":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-data-residency":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-data-security-policies":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-data-transfer":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-delta-migrations":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-disaster-recovery":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-discover-apps-shadow-it":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-discover-new-products":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-enable-user-merge":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-encryption":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-environments":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-experiment-controls":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-external-user-security":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-footprint":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-freeze-windows":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-guard-detect-alerts":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-guard-detect-detections":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-help":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-hippa-compliance":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-jsm-scim":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-link-bitbucket":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-llm":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-login-customisation":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-managed-accounts-export":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-marketplace-apps":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-mcp-settings":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-mobile-app-policy":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-nested-side-navigation":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-org-audit-logs":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-org-create":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-org-deletion":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-org-transfer":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-performance-monitoring":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-platform-usage":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-policies":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-product-insights-workflow-discovery":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-product-insights":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-product-links":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-product-recommendation":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-product-urls":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-release-tracks":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-revamped-organization-overview":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-rovo-access":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-rovo-chat-protection":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-rovo-insights":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-rovo-mcp-server":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-rovo-settings":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-saml-sso":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-sandbox":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-security-checklist":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-sensitive-data-policies":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-signup":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-site-rename":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-site-transfer":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-system-health":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-team-site-assignment":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-teams":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-teamwork-graph-cli":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-units":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-use-available-apps":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-user-access-invites":{"compositions":{"cc":true,"ic":true,"fm":true}},"adminhub-user-access-settings":{"compositions":{"cc":true,"ic":false,"fm":false}},"adminhub-user-connected-apps":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-user-counts":{"compositions":{"cc":true,"ic":true,"fm":false}},"adminhub-user-last-active-timestamp":{"compositions":{"cc":true,"ic":false,"fm":true}},"adminhub-workspaces-table-plans":{"compositions":{"cc":true,"ic":false,"fm":true}},"core-adminhub":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"assets":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"assets-data-manager":{"compositions":{"cc":true,"ic":true,"fm":true}},"assets-recent-items":{"compositions":{"cc":true,"ic":false,"fm":true}},"assets-reports":{"compositions":{"cc":true,"ic":false,"fm":true}},"assets-rovo-search":{"compositions":{"cc":true,"ic":false,"fm":false}},"core-assets":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"atlassian-analytics":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{"atlassian-analytics-3p-data-source-connections":{"compositions":{"cc":true,"ic":false,"fm":false}},"atlassian-analytics-chart-dashboard-pdf-png-exports":{"compositions":{"cc":true,"ic":false,"fm":false}},"atlassian-analytics-chart-templates":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-charts":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-comments":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-commerce-sentry":{"compositions":{"cc":true,"ic":false,"fm":false}},"atlassian-analytics-cross-product-interaction-client":{"compositions":{"cc":true,"ic":false,"fm":false}},"atlassian-analytics-dashboard-subscriptions":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-dashboard-templates":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-dashboards":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-data-lake-connections":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-analytics-data-shares":{"compositions":{"cc":true,"ic":false,"fm":false}},"atlassian-analytics-jira-align-enterprise-insights-connections":{"compositions":{"cc":true,"ic":false,"fm":false}},"core-atlassian-analytics":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"bitbucket":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"bitbucket-development-events-and-status":{"compositions":{"cc":true,"ic":false,"fm":false}},"bitbucket-merge-queue":{"compositions":{"cc":true,"ic":false,"fm":false}},"bitbucket-slack-app":{"compositions":{"cc":true,"ic":false,"fm":false}},"bitbucket-ssh-key-validation":{"compositions":{"cc":true,"ic":false,"fm":false}},"pipelines":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"chat":{"compositions":{"cc":true,"ic":true,"fm":false},"features":{}},"compass":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"confluence":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"ccma":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-ai":{"compositions":{"cc":true,"ic":false,"fm":false}},"confluence-anonymous-access":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-comment-and-header-links":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-company-hub":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-content-archiving":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-content-manager":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-databases":{"compositions":{"cc":true,"ic":true,"fm":false},"availabilityMetadata":{"fm":{"auditPhase":"internal-audit"}}},"confluence-editing-experience":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-edition-awareness":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-editor-offline-storage":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-embedded-pages":{"compositions":{"cc":true,"ic":false,"fm":false}},"confluence-employee-directory":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-forge-apps-sidebar":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-inline-comments-in-edit-mode":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-inspect-permissions":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-invitations":{"compositions":{"cc":true,"ic":false,"fm":true}},"confluence-loom-integration":{"compositions":{"cc":true,"ic":false,"fm":false}},"confluence-mission-control":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-mobile-app":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-ms-teams-integration":{"compositions":{"cc":true,"ic":false,"fm":true}},"confluence-page-analytics":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-pages-blogs-folders":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-premium-onboarding":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-presenter-mode":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-public-links":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-questions-native-experience":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-questions":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-recap":{"compositions":{"cc":true,"ic":false,"fm":false}},"confluence-search":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-server":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-share-to-slack-button":{"compositions":{"cc":true,"ic":false,"fm":false}},"confluence-single-space-guests":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-slack-integration":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-slides":{"compositions":{"cc":true,"ic":false,"fm":false}},"confluence-smart-links":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-space-analytics":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-team-calendars":{"compositions":{"cc":true,"ic":true,"fm":false}},"confluence-update-page-owners":{"compositions":{"cc":true,"ic":true,"fm":true}},"confluence-whiteboards":{"compositions":{"cc":true,"ic":true,"fm":false},"availabilityMetadata":{"fm":{"auditPhase":"internal-audit"}}},"core-confluence":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"customer-service-management":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"dx":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"feedback":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"focus":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"asks-and-planning":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"goals":{"compositions":{"cc":true,"ic":true,"fm":false},"features":{}},"guard-premium":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"home":{"compositions":{"cc":true,"ic":true,"fm":false},"features":{"home-org-chart-analytics-pipeline":{"compositions":{"cc":true,"ic":false,"fm":false}},"home-status-backend":{"compositions":{"cc":true,"ic":true,"fm":false}}}},"jira":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-jira":{"compositions":{"cc":true,"ic":true,"fm":true}},"issue-transition-customisation-for-srb":{"compositions":{"cc":true,"ic":true,"fm":false}},"jcma-x2c":{"compositions":{"cc":true,"ic":false,"fm":true}},"jcma":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-admin-oauth-credentials":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-ai-issue-classification":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-ai-snippet":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-ai-upsell-in-editor-free":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-apps-menu":{"compositions":{"cc":true,"ic":false,"fm":true}},"jira-atlassian-intelligence":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-atlassian-vs-code-extension":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-audit-log":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-backlogs":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-boards-and-views":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-calendar-view":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-company-managed-projects":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-components":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-dashboard-public-sharing":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-demux":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-development-hub":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-development-tab-druid-metric-cards":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-development-tab":{"compositions":{"cc":true,"ic":false,"fm":true}},"jira-devinfo-async-pull-request-icon":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-devops-toolchain":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-edition-awareness":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-figma-integration":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-forms":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-github-for-jira":{"compositions":{"cc":true,"ic":false,"fm":true}},"jira-github-workflows":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-goals-nav":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-import-work-sidebar":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-in-product-help":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-insights":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-invite-people":{"compositions":{"cc":true,"ic":false,"fm":true}},"jira-issue":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-jpd-nav-recommendations":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-jpd-roadmap-on-timeline-cross-sell":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-loom-banner":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-marketplace-sidebar-recommendations":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-mobile-app":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-ms-teams-integration":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-next-best-task":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-oasis-reports":{"compositions":{"cc":true,"ic":false,"fm":true}},"jira-opsgenie":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-plans":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-project-archiving":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-project-issue-navigator":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-project-templates":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-project-theme-unsplash":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-quickstart-pages":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-releases":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-roadmap-in-nav":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-share":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-site-optimiser":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-slack":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-smart-links":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-smart-related-issues":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-software-devops":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-software-reports-cycle-time":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-software-reports-deployment-frequency":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-spreadsheets-integration":{"compositions":{"cc":true,"ic":false,"fm":false}},"jira-synced-blocks":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-team-managed-projects":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-unsplash":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-whiteboards-backlog-experiment":{"compositions":{"cc":true,"ic":false,"fm":true}},"jira-work-item-archiving":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-work-suggestions":{"compositions":{"cc":true,"ic":true,"fm":false}},"jira-workflow-configuration":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-your-work-dashboard":{"compositions":{"cc":true,"ic":true,"fm":true}},"modern-issue-transition-connect-app-fields":{"compositions":{"cc":true,"ic":true,"fm":false}}}},"jira-align":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"jira-product-discovery":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"jira-service-management":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-jira-service-management":{"compositions":{"cc":true,"ic":true,"fm":true}},"jira-service-management-help-center":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-ai-ops":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-ai-services":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-alert-notifications":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-analytics-dashboards":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-approvals":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-assets-vertical":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-automation-playbook":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-boysenberry":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-canned-responses":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-change-ai-risk-assessment":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-change-calendar":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-change-management-deployment-vendors":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-change-management":{"compositions":{"cc":true,"ic":false,"fm":true}},"jsm-change-risk-assessment":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-change-risk-reporter-configuration":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-chat-ops-ic-custom-apps":{"compositions":{"cc":false,"ic":true,"fm":false}},"jsm-chat-ops":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-chat":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-cloud-megatron":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-csat":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-csm-functionality":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-customer-access-internal-account":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-customer-notifications":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-customer-service-management":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-deployment-gating":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-deployment-tracking":{"compositions":{"cc":true,"ic":false,"fm":true}},"jsm-developer-escalations":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-email-requests":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-embeddable-widget":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-entity-migration":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-err-governance-api":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-external-customer-accounts":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-external-customer-single-sign-on":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-external-customer-user-provisioning":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-forms":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-halp-admin-panel":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-help-center-change-password":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-help-center-password-login":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-help-center-rovo-agent":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-help-center-virtual-agent":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-help-center":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-incident-conference-calls":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-incident-management-integration":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-issue":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-journey-builder":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-knowledge-base":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-multi-language-support":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-on-call-schedule":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-ops-genie-reporting":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-opsgenie-conference-management":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-opsgenie-devops":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-portal-only-account-scim":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-post-incident-reviews":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-queues":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-related-issues":{"compositions":{"cc":true,"ic":false,"fm":true}},"jsm-reports-operations":{"compositions":{"cc":true,"ic":true,"fm":false}},"jsm-request-intake":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-services":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-shield":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-sla-management":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-status-page-integration":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-surveys":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-templates-and-views":{"compositions":{"cc":true,"ic":true,"fm":true}},"jsm-virtual-service-agent":{"compositions":{"cc":true,"ic":false,"fm":false}},"jsm-workforce":{"compositions":{"cc":true,"ic":false,"fm":false}},"opsgenie":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"loom":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"loom-ai-evaluation":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"projects":{"compositions":{"cc":true,"ic":true,"fm":false},"features":{}},"rovo":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"rovo-ai-app-availability":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-ai-atlassian-intelligence-app-availability":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-ai-generative-ai-editor":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-ai-machine-learning":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-ai-natural-language-in-automation-rule-creation":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-ai-projects":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-ai-smart-features-based-on-machine-learning-tecton-ai":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-editor-ai-panels":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"rovo-dev":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"rovo-dev-agents":{"compositions":{"cc":true,"ic":false,"fm":false}},"rovo-dev-code-assist":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"statuspage":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"studio":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"talent":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"teams":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"teams-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"teams-profile-media-token-fetch":{"compositions":{"cc":true,"ic":true,"fm":false}},"teams-third-party-invites":{"compositions":{"cc":true,"ic":false,"fm":false}},"user-provided-banners-on-profile-pictures":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"trello":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"trello-ms-teams-integration":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"anti-abuse-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{"core-anti-abuse-platform":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"application-tunnels":{"compositions":{"cc":true,"ic":true,"fm":false},"features":{"core-application-tunnels":{"compositions":{"cc":true,"ic":true,"fm":false}}}},"atlassian-cli":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"atlassian-new-platform":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"atlassian-visualization-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{"atlassian-visualization-platform-kamino":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-visualization-platform-manifold":{"compositions":{"cc":true,"ic":false,"fm":true}},"atlassian-visualization-platform-rovo-skills":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"central-ai":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{"ai-3p-connections":{"compositions":{"cc":true,"ic":false,"fm":false}},"ai-managed-objects":{"compositions":{"cc":true,"ic":false,"fm":false}},"ai-safety":{"compositions":{"cc":true,"ic":false,"fm":false}},"collaboration-graph":{"compositions":{"cc":true,"ic":false,"fm":false}},"gen-ai":{"compositions":{"cc":true,"ic":false,"fm":false}},"knowledge-ai":{"compositions":{"cc":true,"ic":false,"fm":false}},"knowledge-discovery":{"compositions":{"cc":true,"ic":false,"fm":false}},"machine-learning-platform":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"collaboration-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-collaboration-platform":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"commerce-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment":{"compositions":{"cc":true,"ic":true,"fm":true}},"commerce-platform-self-serve":{"compositions":{"cc":true,"ic":true,"fm":true}},"core-commerce-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"customer-data-lake":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-customer-data-lake":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"customer-support-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{}},"ecosystem-forge":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-ecosystem-forge":{"compositions":{"cc":true,"ic":true,"fm":true}},"dac-get-help-widget":{"compositions":{"cc":true,"ic":false,"fm":false}},"developer-atlassian-community":{"compositions":{"cc":true,"ic":false,"fm":false}},"docs-atlassian-com":{"compositions":{"cc":true,"ic":false,"fm":false}},"ecosystem-oauth":{"compositions":{"cc":true,"ic":true,"fm":true}},"expression-playground":{"compositions":{"cc":true,"ic":false,"fm":false}},"forge-cli":{"compositions":{"cc":true,"ic":true,"fm":false}},"forge-remote-capabilities":{"compositions":{"cc":true,"ic":true,"fm":true}},"forge-storage-service-rockmelon":{"compositions":{"cc":true,"ic":true,"fm":false}},"forge-system-apps":{"compositions":{"cc":true,"ic":true,"fm":true}},"forge-ui-ic-cdn-auth":{"compositions":{"cc":false,"ic":true,"fm":false}}}},"editor-collaboration-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"block-service":{"compositions":{"cc":true,"ic":true,"fm":true}},"core-editor-collaboration-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"real-time-presence":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"experience-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{"core-experience-platform":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"gasv3":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-gasv3":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"growth-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"bxp-signup":{"compositions":{"cc":true,"ic":true,"fm":true}},"core-growth-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"identity":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-identity":{"compositions":{"cc":true,"ic":true,"fm":true}},"identity-mail-proxy":{"compositions":{"cc":true,"ic":true,"fm":true}},"identity-virality":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"learning-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{}},"marketplace":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"marketplace-app-discovery":{"compositions":{"cc":true,"ic":true,"fm":true}},"marketplace-app-migrations":{"compositions":{"cc":true,"ic":true,"fm":true}},"marketplace-atlassian-labs":{"compositions":{"cc":true,"ic":true,"fm":true}},"marketplace-audit-logs":{"compositions":{"cc":true,"ic":true,"fm":false}},"marketplace-self-service-purchase-provision-install":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"migrations":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"agc-migrations":{"compositions":{"cc":true,"ic":true,"fm":true}},"commercial-cloud-to-agc":{"compositions":{"cc":true,"ic":true,"fm":false}},"data-center-to-agc":{"compositions":{"cc":true,"ic":true,"fm":false}},"migration-link-fixing":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"migrations-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"brie":{"compositions":{"cc":true,"ic":true,"fm":true}},"core-migrations-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"data-center-to-cloud-migration":{"compositions":{"cc":true,"ic":false,"fm":false}},"media-migration":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"navigation":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-navigation":{"compositions":{"cc":true,"ic":true,"fm":true}},"navigation-home-entry-mode":{"compositions":{"cc":true,"ic":true,"fm":false}},"navigation-identity-ic-routing":{"compositions":{"cc":false,"ic":true,"fm":false}},"navigation-switcher-discovery":{"compositions":{"cc":true,"ic":true,"fm":false}},"navigation-switcher-rovo-scas-visibility":{"compositions":{"cc":true,"ic":true,"fm":false}}}},"notification-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-notification-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"notifications-fpn-link":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"post-office":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-post-office":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"product-integrations-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-product-integrations-platform":{"compositions":{"cc":true,"ic":false,"fm":true}},"external-user-directory-integration":{"compositions":{"cc":true,"ic":false,"fm":false}},"google-workspace-apps-integrations":{"compositions":{"cc":true,"ic":false,"fm":false}},"sign-in-with-slack-usage-analytics":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"search":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-search":{"compositions":{"cc":true,"ic":true,"fm":true}},"search-townsquare-tab":{"compositions":{"cc":true,"ic":true,"fm":false}}}},"smartlinks":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-smartlinks":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"user-management":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-user-management":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"user-recommendations":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-user-recommendations":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"atlassian-graphql-gateway":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-atlassian-graphql-gateway":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"atlassian-platform-deployer":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"automation-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"automation-platform-actions":{"compositions":{"cc":true,"ic":true,"fm":false}},"automation-platform-automation-templates":{"compositions":{"cc":true,"ic":true,"fm":true}},"automation-platform-branches":{"compositions":{"cc":true,"ic":true,"fm":false}},"automation-platform-conditions":{"compositions":{"cc":true,"ic":true,"fm":false}},"automation-platform-event-processing":{"compositions":{"cc":true,"ic":true,"fm":true}},"automation-platform-frontend":{"compositions":{"cc":true,"ic":false,"fm":true}},"automation-platform-natural-language-rule-builder":{"compositions":{"cc":true,"ic":true,"fm":true}},"automation-platform-rule-builder":{"compositions":{"cc":true,"ic":true,"fm":true}},"automation-platform-templates":{"compositions":{"cc":true,"ic":true,"fm":true}},"automation-platform-triggers":{"compositions":{"cc":true,"ic":true,"fm":false}},"core-automation-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"bifrost":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-bifrost":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"build-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"cell-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{}},"cloud-management":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"cloud-security":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"compliance-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"consent-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"consenthub":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"core-network-automation":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-core-network-automation":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"core-network-automation-cna-theia":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-core-network-automation-cna-theia":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"core-network-automation-l2":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-core-network-automation-l2":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"cross-gateway":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-cross-gateway":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"customer-data-lake-layer2":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"data-access-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-access-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-classification-governance-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-classification-governance-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-depot-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-depot-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-exchange-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"aqui":{"compositions":{"cc":true,"ic":false,"fm":false}},"eureka":{"compositions":{"cc":true,"ic":true,"fm":true}},"kamino":{"compositions":{"cc":true,"ic":true,"fm":true}},"shipyard":{"compositions":{"cc":true,"ic":true,"fm":true}},"topic-osb":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-exchange-platform-l3":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-exchange-platform-l3":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-management-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-management-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"ers-import":{"compositions":{"cc":true,"ic":true,"fm":true}},"ers":{"compositions":{"cc":true,"ic":true,"fm":true}},"sql":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-platform-services":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-platform-services":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-store-gateway":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-data-store-gateway":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"data-telemetry-platform":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{"core-data-telemetry-platform":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"decisions-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-decisions-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"experimentation":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"detection-and-response-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"disaster-recovery":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"edge":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-edge":{"compositions":{"cc":true,"ic":true,"fm":true}},"edge-cloudfront":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"encryption-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"cryptor":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"environment-management-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"flight-deck-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"golden-ami":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"incident-management-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"infrastructure":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-infrastructure":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"internal-data-lake":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"airlock-platform":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"internal-edge":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-internal-edge":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"internal-edge-httpbin":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-internal-edge-httpbin":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"job-execution-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-job-execution-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"kitt-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"kitt-fleet":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"media-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-media-platform":{"compositions":{"cc":true,"ic":false,"fm":true}},"media-cdn-delivery":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"messaging-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"micros-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"network-fabric":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-network-fabric":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"observability-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"sentry-opsgenie-integration":{"compositions":{"cc":true,"ic":true,"fm":false}},"tracing":{"compositions":{"cc":true,"ic":true,"fm":false}}}},"pollinator":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-pollinator":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"pollinator-l2":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-pollinator-l2":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"provisioning":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-provisioning":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"rate-limiting-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-rate-limiting-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"resiliency-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"secrets":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"security-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"service-to-service-fabric":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"slauth-auth-slack-notification-platform":{"compositions":{"cc":true,"ic":false,"fm":false},"features":{}},"sliver":{"compositions":{"cc":true,"ic":true,"fm":false},"features":{}},"staff-authentication-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}},"streamhub":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-streamhub":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"targeting-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-targeting-platform":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"teamwork-graph-platform":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-teamwork-graph-platform":{"compositions":{"cc":true,"ic":true,"fm":true}},"flock":{"compositions":{"cc":true,"ic":false,"fm":true}}}},"tenant-catalogue-service-record":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-tenant-catalogue-service-record":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"tenant-context":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-tenant-context":{"compositions":{"cc":true,"ic":true,"fm":true}}}},"tenant-lifecycle":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{"core-tenant-platform":{"compositions":{"cc":true,"ic":false,"fm":true}},"tenant-passivation-removal":{"compositions":{"cc":true,"ic":false,"fm":false}}}},"vdi":{"compositions":{"cc":true,"ic":false,"fm":true},"features":{}},"workplace-technology-solutions":{"compositions":{"cc":true,"ic":true,"fm":true},"features":{}}}}');

});


parcelRegister("4oVam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $3345bf4fc1e633af$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($3345bf4fc1e633af$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $3345bf4fc1e633af$var$UnderAuditPhase = {}));

});


parcelRegister("kdKWG", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $eb896fefa5393b41$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $eb896fefa5393b41$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $eb896fefa5393b41$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $eb896fefa5393b41$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $eb896fefa5393b41$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$eb896fefa5393b41$var$isBrowserEnvironment()) return null;
    const map = $eb896fefa5393b41$var$getOverridesMap();
    const key = $eb896fefa5393b41$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $eb896fefa5393b41$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $eb896fefa5393b41$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$eb896fefa5393b41$var$isBrowserEnvironment()) return;
    const map = $eb896fefa5393b41$var$getOverridesMap();
    map[$eb896fefa5393b41$var$buildKey(environmentBlockName, featureName)] = value;
    $eb896fefa5393b41$var$setOverridesMap(map);
}
module.exports.overrideFeature = $eb896fefa5393b41$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $eb896fefa5393b41$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$eb896fefa5393b41$var$isBrowserEnvironment()) return;
    const map = $eb896fefa5393b41$var$getOverridesMap();
    delete map[$eb896fefa5393b41$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $eb896fefa5393b41$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $eb896fefa5393b41$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $eb896fefa5393b41$var$clearAllOverrides() {
    if (!$eb896fefa5393b41$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $eb896fefa5393b41$var$clearAllOverrides;

});

parcelRegister("lrbYW", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $f9b569f21caf3df6$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $hPtJY !== "undefined" && $hPtJY && $hPtJY.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $f9b569f21caf3df6$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $f9b569f21caf3df6$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $f9b569f21caf3df6$var$getEnvironmentType;

});



parcelRegister("99gYJ", function(module, exports) {

$parcel$export(module.exports, "fg", () => $6a921fe61656b2ce$export$b40ec24ac8275656);

var $cGUVj = parcelRequire("cGUVj");
function $6a921fe61656b2ce$export$b40ec24ac8275656(name) {
    return (0, $cGUVj.resolveBooleanFlag)(name);
}

});
parcelRegister("cGUVj", function(module, exports) {

$parcel$export(module.exports, "resolveBooleanFlag", () => $93d5901179d9dd9f$export$6333b6aff9fc6275);

var $cYxe5 = parcelRequire("cYxe5");

var $3KsQO = parcelRequire("3KsQO");

var $8u2o4 = parcelRequire("8u2o4");

var $2hyDS = parcelRequire("2hyDS");

var $aLZib = parcelRequire("aLZib");

var $jJuBG = parcelRequire("jJuBG");
var $93d5901179d9dd9f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $8u2o4.ENV_ENABLE_PLATFORM_FF) || (0, $2hyDS.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $93d5901179d9dd9f$export$6333b6aff9fc6275(flagKey) {
    if ($93d5901179d9dd9f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3KsQO.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $jJuBG.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $aLZib.globalVar)[0, $jJuBG.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $aLZib.globalVar)[0, $jJuBG.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $cYxe5.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $aLZib.globalVar)[0, $jJuBG.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("cYxe5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9724dcae18b4e927$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $7Rlas = parcelRequire("7Rlas");

var $1IWl1 = parcelRequire("1IWl1");



var $9724dcae18b4e927$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $9724dcae18b4e927$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$9724dcae18b4e927$var$_FeatureGates = $9724dcae18b4e927$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "client", new (0, $7Rlas.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$9724dcae18b4e927$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $9724dcae18b4e927$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $9724dcae18b4e927$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$9724dcae18b4e927$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $9724dcae18b4e927$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $9724dcae18b4e927$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "initializeCalled", $9724dcae18b4e927$var$_FeatureGates.client.initializeCalled.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "initializeCompleted", $9724dcae18b4e927$var$_FeatureGates.client.initializeCompleted.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "waitUntilInitializeCompleted", $9724dcae18b4e927$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "initialize", $9724dcae18b4e927$var$_FeatureGates.client.initialize.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "initializeWithProvider", $9724dcae18b4e927$var$_FeatureGates.client.initializeWithProvider.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "initializeFromValues", $9724dcae18b4e927$var$_FeatureGates.client.initializeFromValues.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "manuallyLogGateExposure", $9724dcae18b4e927$var$_FeatureGates.client.manuallyLogGateExposure.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getExperiment", $9724dcae18b4e927$var$_FeatureGates.client.getExperiment.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "manuallyLogExperimentExposure", $9724dcae18b4e927$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "manuallyLogLayerExposure", $9724dcae18b4e927$var$_FeatureGates.client.manuallyLogLayerExposure.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "shutdownStatsig", $9724dcae18b4e927$var$_FeatureGates.client.shutdownStatsig.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "overrideGate", $9724dcae18b4e927$var$_FeatureGates.client.overrideGate.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "clearGateOverride", $9724dcae18b4e927$var$_FeatureGates.client.clearGateOverride.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "overrideConfig", $9724dcae18b4e927$var$_FeatureGates.client.overrideConfig.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "clearConfigOverride", $9724dcae18b4e927$var$_FeatureGates.client.clearConfigOverride.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "setOverrides", $9724dcae18b4e927$var$_FeatureGates.client.setOverrides.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getOverrides", $9724dcae18b4e927$var$_FeatureGates.client.getOverrides.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "clearAllOverrides", $9724dcae18b4e927$var$_FeatureGates.client.clearAllOverrides.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "isCurrentUser", $9724dcae18b4e927$var$_FeatureGates.client.isCurrentUser.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "onGateUpdated", $9724dcae18b4e927$var$_FeatureGates.client.onGateUpdated.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "onExperimentValueUpdated", $9724dcae18b4e927$var$_FeatureGates.client.onExperimentValueUpdated.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "onAnyUpdated", $9724dcae18b4e927$var$_FeatureGates.client.onAnyUpdated.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "updateUser", $9724dcae18b4e927$var$_FeatureGates.client.updateUser.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "updateUserWithProvider", $9724dcae18b4e927$var$_FeatureGates.client.updateUserWithProvider.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "updateUserWithValues", $9724dcae18b4e927$var$_FeatureGates.client.updateUserWithValues.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getPackageVersion", $9724dcae18b4e927$var$_FeatureGates.client.getPackageVersion.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getTargetApp", $9724dcae18b4e927$var$_FeatureGates.client.getTargetApp.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getLayer", $9724dcae18b4e927$var$_FeatureGates.client.getLayer.bind($9724dcae18b4e927$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($9724dcae18b4e927$var$FeatureGates, "getLayerValue", $9724dcae18b4e927$var$_FeatureGates.client.getLayerValue.bind($9724dcae18b4e927$var$_FeatureGates.client));
var $9724dcae18b4e927$var$boundFGJS = $9724dcae18b4e927$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $9724dcae18b4e927$var$FeatureGates;
    else {
        var $9724dcae18b4e927$var$_boundFGJS, $9724dcae18b4e927$var$_boundFGJS$getPackage;
        $9724dcae18b4e927$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $9724dcae18b4e927$var$boundVersion = (($9724dcae18b4e927$var$_boundFGJS = $9724dcae18b4e927$var$boundFGJS) === null || $9724dcae18b4e927$var$_boundFGJS === void 0 || ($9724dcae18b4e927$var$_boundFGJS$getPackage = $9724dcae18b4e927$var$_boundFGJS.getPackageVersion) === null || $9724dcae18b4e927$var$_boundFGJS$getPackage === void 0 ? void 0 : $9724dcae18b4e927$var$_boundFGJS$getPackage.call($9724dcae18b4e927$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($9724dcae18b4e927$var$boundVersion !== (0, $1IWl1.CLIENT_VERSION)) {
            var $9724dcae18b4e927$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($9724dcae18b4e927$var$boundVersion, " when module version ").concat((0, $1IWl1.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($9724dcae18b4e927$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $9724dcae18b4e927$export$2e2bcd8739ae039 = $9724dcae18b4e927$var$boundFGJS;

});
parcelRegister("7Rlas", function(module, exports) {

$parcel$export(module.exports, "Client", () => $5b8de71e96de99d2$export$1f2bb630327ac4b6);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $73HSG = parcelRequire("73HSG");

var $a1QTr = parcelRequire("a1QTr");

var $5bbpE = parcelRequire("5bbpE");

var $454RB = parcelRequire("454RB");

var $3KgqK = parcelRequire("3KgqK");

var $2S1No = parcelRequire("2S1No");

var $jJadi = parcelRequire("jJadi");

var $9B3at = parcelRequire("9B3at");

var $cnmk8 = parcelRequire("cnmk8");

var $d14r4 = parcelRequire("d14r4");

var $SLO0B = parcelRequire("SLO0B");

var $eKAHt = parcelRequire("eKAHt");

var $aJs0Q = parcelRequire("aJs0Q");

var $dxS0M = parcelRequire("dxS0M");

var $1IWl1 = parcelRequire("1IWl1");
var $5b8de71e96de99d2$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $5b8de71e96de99d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5b8de71e96de99d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5b8de71e96de99d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5b8de71e96de99d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5b8de71e96de99d2$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $5b8de71e96de99d2$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $5b8de71e96de99d2$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $SLO0B.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subscriptions", new (0, $a1QTr.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dataAdapter", new (0, $d14r4.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $SLO0B.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $9B3at.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $eKAHt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $9B3at.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $eKAHt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $1IWl1.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $5b8de71e96de99d2$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $1IWl1.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $dxS0M.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $9B3at.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $eKAHt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $9B3at.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $jJadi.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can wait until initialized.");
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $5bbpE.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $5bbpE.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $3KgqK.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $eKAHt.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $eKAHt.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $5b8de71e96de99d2$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $jJadi.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $jJadi.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $5b8de71e96de99d2$var$_objectSpread($5b8de71e96de99d2$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $cnmk8.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $5b8de71e96de99d2$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $5b8de71e96de99d2$var$_objectSpread($5b8de71e96de99d2$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $5b8de71e96de99d2$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $dxS0M.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(newClientOptions, $5b8de71e96de99d2$var$_excluded);
                                frontendUser = (0, $aJs0Q.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $2S1No.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $5b8de71e96de99d2$var$_objectSpread($5b8de71e96de99d2$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $73HSG.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $73HSG.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $73HSG.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $73HSG.StatsigClient)($5b8de71e96de99d2$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $aJs0Q.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $2S1No.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $1IWl1.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $454RB.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $454RB.Layer).fromLayer((0, $73HSG._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("73HSG", function(module, exports) {
"use strict";
var $523ada0c9cafe73c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $523ada0c9cafe73c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $523ada0c9cafe73c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $fNhE8 = parcelRequire("fNhE8");
module.exports.StatsigClient = $fNhE8.default;

$523ada0c9cafe73c$var$__exportStar((parcelRequire("159T0")), module.exports);
const $523ada0c9cafe73c$var$__STATSIG__ = Object.assign((0, (parcelRequire("159T0"))._getStatsigGlobal)(), {
    StatsigClient: $fNhE8.default
});
module.exports.default = $523ada0c9cafe73c$var$__STATSIG__;

});
parcelRegister("159T0", function(module, exports) {
"use strict";
var $0c9ded4539aa1f67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0c9ded4539aa1f67$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0c9ded4539aa1f67$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("43Ohs")).Diagnostics;
    }
});

var $6kjqP = parcelRequire("6kjqP");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $6kjqP.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hwEEg")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5dmxo")).Storage;
    }
});

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("ahWyx")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("48byg")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("56nDO")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("2FggB")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("43Ohs")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("6eLYe")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("lLGXO")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("9Erzk")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("3OzBC")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("a1DgY")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("jMFCw")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("hwEEg")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("huNva")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("6fq8a")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("aGXN7")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("kRlsg")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("5qBIy")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("cYoTo")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("j5H4v")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("eFwwu")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("apy3u")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("dAAYy")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("8LKDe")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("krPcG")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("eaL8S")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("hxIUF")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("7rc6R")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("22z2t")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("huJaB")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("8RJKO")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("6WVR5")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("iHpQh")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("5dmxo")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("50bgC")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("4hEwe")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("11yWm")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("asfpr")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("3JVmL")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("5DLSe")), module.exports);

$0c9ded4539aa1f67$var$__exportStar((parcelRequire("fwbEQ")), module.exports);
Object.assign((0, (parcelRequire("ahWyx"))._getStatsigGlobal)(), {
    Log: (parcelRequire("hwEEg")).Log,
    SDK_VERSION: (parcelRequire("7rc6R")).SDK_VERSION
});

});
parcelRegister("ahWyx", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $77d8e9eacead1425$var$_a, $77d8e9eacead1425$var$_b, $77d8e9eacead1425$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $hwEEg = parcelRequire("hwEEg");
const $77d8e9eacead1425$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== "undefined" ? __STATSIG__ : $77d8e9eacead1425$var$statsigGlobal;
    } catch (e) {
        return $77d8e9eacead1425$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $77d8e9eacead1425$var$_getStatsigGlobal;
const $77d8e9eacead1425$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $77d8e9eacead1425$var$_getStatsigGlobalFlag;
const $77d8e9eacead1425$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $hwEEg.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $77d8e9eacead1425$var$_getInstance;
const $77d8e9eacead1425$var$GLOBAL_KEY = "__STATSIG__";
const $77d8e9eacead1425$var$_window = typeof window !== "undefined" ? window : {};
const $77d8e9eacead1425$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $77d8e9eacead1425$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $77d8e9eacead1425$var$statsigGlobal = ($77d8e9eacead1425$var$_c = ($77d8e9eacead1425$var$_b = ($77d8e9eacead1425$var$_a = $77d8e9eacead1425$var$_window[$77d8e9eacead1425$var$GLOBAL_KEY]) !== null && $77d8e9eacead1425$var$_a !== void 0 ? $77d8e9eacead1425$var$_a : $77d8e9eacead1425$var$_global[$77d8e9eacead1425$var$GLOBAL_KEY]) !== null && $77d8e9eacead1425$var$_b !== void 0 ? $77d8e9eacead1425$var$_b : $77d8e9eacead1425$var$_globalThis[$77d8e9eacead1425$var$GLOBAL_KEY]) !== null && $77d8e9eacead1425$var$_c !== void 0 ? $77d8e9eacead1425$var$_c : {
    instance: module.exports._getInstance
};
$77d8e9eacead1425$var$_window[$77d8e9eacead1425$var$GLOBAL_KEY] = $77d8e9eacead1425$var$statsigGlobal;
$77d8e9eacead1425$var$_global[$77d8e9eacead1425$var$GLOBAL_KEY] = $77d8e9eacead1425$var$statsigGlobal;
$77d8e9eacead1425$var$_globalThis[$77d8e9eacead1425$var$GLOBAL_KEY] = $77d8e9eacead1425$var$statsigGlobal;

});
parcelRegister("hwEEg", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $cc24f4c02cf3149e$var$DEBUG = " DEBUG ";
const $cc24f4c02cf3149e$var$_INFO = "  INFO ";
const $cc24f4c02cf3149e$var$_WARN = "  WARN ";
const $cc24f4c02cf3149e$var$ERROR = " ERROR ";
function $cc24f4c02cf3149e$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $cc24f4c02cf3149e$var$Log {
    static info(...args) {
        if ($cc24f4c02cf3149e$var$Log.level >= module.exports.LogLevel.Info) console.info($cc24f4c02cf3149e$var$_INFO, ...$cc24f4c02cf3149e$var$addTag(args));
    }
    static debug(...args) {
        if ($cc24f4c02cf3149e$var$Log.level >= module.exports.LogLevel.Debug) console.debug($cc24f4c02cf3149e$var$DEBUG, ...$cc24f4c02cf3149e$var$addTag(args));
    }
    static warn(...args) {
        if ($cc24f4c02cf3149e$var$Log.level >= module.exports.LogLevel.Warn) console.warn($cc24f4c02cf3149e$var$_WARN, ...$cc24f4c02cf3149e$var$addTag(args));
    }
    static error(...args) {
        if ($cc24f4c02cf3149e$var$Log.level >= module.exports.LogLevel.Error) console.error($cc24f4c02cf3149e$var$ERROR, ...$cc24f4c02cf3149e$var$addTag(args));
    }
}
module.exports.Log = $cc24f4c02cf3149e$var$Log;
$cc24f4c02cf3149e$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("43Ohs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $2f4e71eeb0fd50b2$var$MARKER_MAP = new Map();
const $2f4e71eeb0fd50b2$var$ACT_START = "start";
const $2f4e71eeb0fd50b2$var$ACT_END = "end";
const $2f4e71eeb0fd50b2$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $2f4e71eeb0fd50b2$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, $2f4e71eeb0fd50b2$var$_createMarker({}, $2f4e71eeb0fd50b2$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, $2f4e71eeb0fd50b2$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $2f4e71eeb0fd50b2$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, $2f4e71eeb0fd50b2$var$_createMarker(data, $2f4e71eeb0fd50b2$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, $2f4e71eeb0fd50b2$var$_createMarker(data, $2f4e71eeb0fd50b2$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, $2f4e71eeb0fd50b2$var$_createMarker({}, $2f4e71eeb0fd50b2$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, $2f4e71eeb0fd50b2$var$_createMarker(data, $2f4e71eeb0fd50b2$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $2f4e71eeb0fd50b2$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $2f4e71eeb0fd50b2$var$_safeGetField(e, "code"),
            name: $2f4e71eeb0fd50b2$var$_safeGetField(e, "name"),
            message: $2f4e71eeb0fd50b2$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $2f4e71eeb0fd50b2$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $2f4e71eeb0fd50b2$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $2f4e71eeb0fd50b2$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $2f4e71eeb0fd50b2$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $2f4e71eeb0fd50b2$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $2f4e71eeb0fd50b2$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $2f4e71eeb0fd50b2$var$MARKER_MAP.set(sdkKey, markers);
}
function $2f4e71eeb0fd50b2$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("6kjqP", function(module, exports) {
"use strict";
var $49b3af13a86b3501$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $48byg = parcelRequire("48byg");

var $a1DgY = parcelRequire("a1DgY");

var $hwEEg = parcelRequire("hwEEg");

var $6fq8a = parcelRequire("6fq8a");

var $cYoTo = parcelRequire("cYoTo");

var $hxIUF = parcelRequire("hxIUF");

var $22z2t = parcelRequire("22z2t");

var $5dmxo = parcelRequire("5dmxo");

var $11yWm = parcelRequire("11yWm");

var $3JVmL = parcelRequire("3JVmL");
const $49b3af13a86b3501$var$DEFAULT_QUEUE_SIZE = 100;
const $49b3af13a86b3501$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $49b3af13a86b3501$var$MAX_DEDUPER_KEYS = 1000;
const $49b3af13a86b3501$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $49b3af13a86b3501$var$MAX_FAILED_LOGS = 500;
const $49b3af13a86b3501$var$QUICK_FLUSH_WINDOW_MS = 200;
const $49b3af13a86b3501$var$EVENT_LOGGER_MAP = {};
class $49b3af13a86b3501$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $49b3af13a86b3501$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $49b3af13a86b3501$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $22z2t.LoggingEnabledOption.disabled : $22z2t.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $hwEEg.Log.warn("Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.");
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $49b3af13a86b3501$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $11yWm.UrlConfiguration($6fq8a.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === "disabled" && loggingEnabled !== "disabled") {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $5dmxo._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $5dmxo.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $49b3af13a86b3501$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $cYoTo._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always") return;
        $49b3af13a86b3501$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $3JVmL._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $49b3af13a86b3501$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $49b3af13a86b3501$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $49b3af13a86b3501$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $49b3af13a86b3501$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $49b3af13a86b3501$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $49b3af13a86b3501$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$49b3af13a86b3501$var$EventLogger._safeFlushAndForget(this._sdkKey), $49b3af13a86b3501$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always" && (0, $cYoTo._isServerEnv)()) return false;
        if (!(0, $hxIUF._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $48byg._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $49b3af13a86b3501$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $49b3af13a86b3501$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $49b3af13a86b3501$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === "disabled") {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $3JVmL._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $hwEEg.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $hwEEg.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $49b3af13a86b3501$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$6fq8a.NetworkParam.EventCount]: String(events.length)
            },
            credentials: "same-origin"
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $49b3af13a86b3501$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $5dmxo._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $hwEEg.Log.warn("Unable to save failed logs to storage");
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $5dmxo._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$49b3af13a86b3501$var$__awaiter(this, void 0, void 0, function*() {
                if (!$5dmxo.Storage.isReady()) yield $5dmxo.Storage.isReadyResolver();
                const events = (0, $5dmxo._getObjectFromStorage)(storageKey);
                if (!events) return;
                $5dmxo.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $hwEEg.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $a1DgY._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $hwEEg.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $cYoTo._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $49b3af13a86b3501$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $49b3af13a86b3501$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $49b3af13a86b3501$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $49b3af13a86b3501$var$EventLogger;

});
parcelRegister("48byg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $a1DgY = parcelRequire("a1DgY");
function $3020deb611ef6f94$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $a1DgY._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $3020deb611ef6f94$var$_getUserStorageKey;
function $3020deb611ef6f94$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $3020deb611ef6f94$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $a1DgY._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $3020deb611ef6f94$var$_getStorageKey;

});
parcelRegister("a1DgY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $4hEwe = parcelRequire("4hEwe");
const $74c876265ee3c0bf$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $74c876265ee3c0bf$var$_DJB2;
const $74c876265ee3c0bf$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $74c876265ee3c0bf$var$_DJB2Object;
const $74c876265ee3c0bf$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $4hEwe._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $74c876265ee3c0bf$var$_getSortedObject;

});
parcelRegister("4hEwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $31e82e22e90fe158$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $31e82e22e90fe158$var$_typeOf;
function $31e82e22e90fe158$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : x === null ? "null" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $31e82e22e90fe158$var$_isTypeMatch;

});



parcelRegister("6fq8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("cYoTo", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $971e65bad4202b0e$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $971e65bad4202b0e$var$_getWindowSafe;
const $971e65bad4202b0e$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $971e65bad4202b0e$var$_getDocumentSafe;
const $971e65bad4202b0e$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $971e65bad4202b0e$var$_isServerEnv;
const $971e65bad4202b0e$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $971e65bad4202b0e$var$_addWindowEventListenerSafe;
const $971e65bad4202b0e$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $971e65bad4202b0e$var$_addDocumentEventListenerSafe;
const $971e65bad4202b0e$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $971e65bad4202b0e$var$_getCurrentPageUrlSafe;
const $971e65bad4202b0e$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return "beforeunload";
    const eventType = "onpagehide" in win ? "pagehide" : "beforeunload";
    return eventType;
};
module.exports._getUnloadEvent = $971e65bad4202b0e$var$_getUnloadEvent;

});

parcelRegister("hxIUF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $cc585b89cf761865$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $cc585b89cf761865$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $cc585b89cf761865$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $cc585b89cf761865$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $cc585b89cf761865$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $cc585b89cf761865$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $cc585b89cf761865$var$GATE_EXPOSURE_NAME || eventName === $cc585b89cf761865$var$CONFIG_EXPOSURE_NAME || eventName === $cc585b89cf761865$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $cc585b89cf761865$var$_isExposureEvent;
const $cc585b89cf761865$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $cc585b89cf761865$var$_createExposure($cc585b89cf761865$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $cc585b89cf761865$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $cc585b89cf761865$var$_createGateExposure;
function $cc585b89cf761865$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $cc585b89cf761865$var$_mapExposures;
const $cc585b89cf761865$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $cc585b89cf761865$var$_createExposure($cc585b89cf761865$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $cc585b89cf761865$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $cc585b89cf761865$var$_createConfigExposure;
const $cc585b89cf761865$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $cc585b89cf761865$var$_createExposure($cc585b89cf761865$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $cc585b89cf761865$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $cc585b89cf761865$var$_createLayerParameterExposure;
const $cc585b89cf761865$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("22z2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: "d",
    /** Compress request bodies unless a network proxy is configured */ Enabled: "e",
    /** Always compress request bodies, even when a proxy is configured */ Forced: "f"
};
module.exports.LoggingEnabledOption = {
    disabled: "disabled",
    browserOnly: "browser-only",
    always: "always"
};

});

parcelRegister("5dmxo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $hwEEg = parcelRequire("hwEEg");

var $cYoTo = parcelRequire("cYoTo");
const $3cbfa61f6a9aad61$var$inMemoryStore = {};
const $3cbfa61f6a9aad61$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$3cbfa61f6a9aad61$var$inMemoryStore[key] ? $3cbfa61f6a9aad61$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $3cbfa61f6a9aad61$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $3cbfa61f6a9aad61$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($3cbfa61f6a9aad61$var$inMemoryStore)
};
let $3cbfa61f6a9aad61$var$_localStorageProvider = null;
try {
    const win = (0, $cYoTo._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $3cbfa61f6a9aad61$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $hwEEg.Log.warn("Failed to setup localStorageProvider.");
}
let $3cbfa61f6a9aad61$var$_main = $3cbfa61f6a9aad61$var$_localStorageProvider !== null && $3cbfa61f6a9aad61$var$_localStorageProvider !== void 0 ? $3cbfa61f6a9aad61$var$_localStorageProvider : $3cbfa61f6a9aad61$var$_inMemoryProvider;
let $3cbfa61f6a9aad61$var$_current = $3cbfa61f6a9aad61$var$_main;
function $3cbfa61f6a9aad61$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($3cbfa61f6a9aad61$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$3cbfa61f6a9aad61$var$_current.isReady(),
    isReadyResolver: ()=>$3cbfa61f6a9aad61$var$_current.isReadyResolver(),
    getProviderName: ()=>$3cbfa61f6a9aad61$var$_current.getProviderName(),
    getItem: (key)=>$3cbfa61f6a9aad61$var$_inMemoryBreaker(()=>$3cbfa61f6a9aad61$var$_current.getItem(key)),
    setItem: (key, value)=>$3cbfa61f6a9aad61$var$_inMemoryBreaker(()=>$3cbfa61f6a9aad61$var$_current.setItem(key, value)),
    removeItem: (key)=>$3cbfa61f6a9aad61$var$_current.removeItem(key),
    getAllKeys: ()=>$3cbfa61f6a9aad61$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $3cbfa61f6a9aad61$var$_main = newProvider;
        $3cbfa61f6a9aad61$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $3cbfa61f6a9aad61$var$_current = $3cbfa61f6a9aad61$var$_inMemoryProvider;
        else $3cbfa61f6a9aad61$var$_current = $3cbfa61f6a9aad61$var$_main;
    }
};
function $3cbfa61f6a9aad61$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : "null");
    } catch (e) {
        $hwEEg.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $3cbfa61f6a9aad61$var$_getObjectFromStorage;
function $3cbfa61f6a9aad61$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $3cbfa61f6a9aad61$var$_setObjectInStorage;

});

parcelRegister("11yWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $a1DgY = parcelRequire("a1DgY");

var $6fq8a = parcelRequire("6fq8a");
const $0bf0fcdfb073aa79$var$ENDPOINT_DNS_KEY_MAP = {
    [$6fq8a.Endpoint._initialize]: "i",
    [$6fq8a.Endpoint._rgstr]: "e",
    [$6fq8a.Endpoint._download_config_specs]: "d"
};
class $0bf0fcdfb073aa79$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0bf0fcdfb073aa79$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $6fq8a.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(",");
        return (0, $a1DgY._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $0bf0fcdfb073aa79$var$UrlConfiguration;

});

parcelRegister("3JVmL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $cYoTo = parcelRequire("cYoTo");
const $2b9212d12de6b93c$var$FOREGROUND = "foreground";
const $2b9212d12de6b93c$var$BACKGROUND = "background";
const $2b9212d12de6b93c$var$LISTENERS = [];
let $2b9212d12de6b93c$var$current = $2b9212d12de6b93c$var$FOREGROUND;
let $2b9212d12de6b93c$var$isUnloading = false;
const $2b9212d12de6b93c$var$_isCurrentlyVisible = ()=>{
    return $2b9212d12de6b93c$var$current === $2b9212d12de6b93c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $2b9212d12de6b93c$var$_isCurrentlyVisible;
const $2b9212d12de6b93c$var$_isUnloading = ()=>$2b9212d12de6b93c$var$isUnloading;
module.exports._isUnloading = $2b9212d12de6b93c$var$_isUnloading;
const $2b9212d12de6b93c$var$_subscribeToVisiblityChanged = (listener)=>{
    $2b9212d12de6b93c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $2b9212d12de6b93c$var$_subscribeToVisiblityChanged;
const $2b9212d12de6b93c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $2b9212d12de6b93c$var$current) return;
    $2b9212d12de6b93c$var$current = visibility;
    $2b9212d12de6b93c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $2b9212d12de6b93c$var$_notifyVisibilityChanged;
(0, $cYoTo._addWindowEventListenerSafe)("focus", ()=>{
    $2b9212d12de6b93c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($2b9212d12de6b93c$var$FOREGROUND);
});
(0, $cYoTo._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($2b9212d12de6b93c$var$BACKGROUND));
(0, $cYoTo._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $2b9212d12de6b93c$var$FOREGROUND : $2b9212d12de6b93c$var$BACKGROUND);
});
(0, $cYoTo._addWindowEventListenerSafe)((0, $cYoTo._getUnloadEvent)(), ()=>{
    $2b9212d12de6b93c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($2b9212d12de6b93c$var$BACKGROUND);
});

});


parcelRegister("7rc6R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.30.2";
let $56a472c3e5c22e71$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$56a472c3e5c22e71$var$metadata,
    add: (additions)=>{
        $56a472c3e5c22e71$var$metadata = Object.assign(Object.assign({}, $56a472c3e5c22e71$var$metadata), additions);
    }
};

});

parcelRegister("56nDO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2FggB", function(module, exports) {
"use strict";
var $1f0c0754025a31ce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $hwEEg = parcelRequire("hwEEg");

var $dAAYy = parcelRequire("dAAYy");

var $iHpQh = parcelRequire("iHpQh");

var $5dmxo = parcelRequire("5dmxo");

var $50bgC = parcelRequire("50bgC");
const $1f0c0754025a31ce$var$CACHE_LIMIT = 10;
const $1f0c0754025a31ce$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $1f0c0754025a31ce$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $1f0c0754025a31ce$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $1f0c0754025a31ce$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $iHpQh._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $iHpQh._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $1f0c0754025a31ce$var$_makeDataAdapterResult("Bootstrap", data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $dAAYy.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $1f0c0754025a31ce$var$__awaiter(this, void 0, void 0, function*() {
            if (!$5dmxo.Storage.isReady()) yield $5dmxo.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $hwEEg.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $1f0c0754025a31ce$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $iHpQh._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $1f0c0754025a31ce$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $hwEEg.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $50bgC._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $dAAYy.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $1f0c0754025a31ce$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $1f0c0754025a31ce$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $hwEEg.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $5dmxo.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($5dmxo.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $50bgC._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $1f0c0754025a31ce$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $5dmxo.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes("QuotaExceededError") || error.toString().includes("QUOTA_EXCEEDED_ERR")) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $5dmxo._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $1f0c0754025a31ce$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $5dmxo.Storage.removeItem(evictable);
        }
        (0, $5dmxo._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $1f0c0754025a31ce$var$DataAdapterCore;
function $1f0c0754025a31ce$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $iHpQh._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $1f0c0754025a31ce$var$_makeDataAdapterResult;
class $1f0c0754025a31ce$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $hwEEg.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $1f0c0754025a31ce$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $1f0c0754025a31ce$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === "object" && typeof valueB === "object") return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("dAAYy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $48byg = parcelRequire("48byg");

var $hwEEg = parcelRequire("hwEEg");

var $cYoTo = parcelRequire("cYoTo");

var $5dmxo = parcelRequire("5dmxo");

var $asfpr = parcelRequire("asfpr");
const $9e4b51c6e95190c7$var$PROMISE_MAP = {};
const $9e4b51c6e95190c7$var$COOKIE_ENABLED_MAP = {};
const $9e4b51c6e95190c7$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($9e4b51c6e95190c7$var$DISABLED_MAP[sdkKey]) return null;
        if ($9e4b51c6e95190c7$var$PROMISE_MAP[sdkKey] != null) return $9e4b51c6e95190c7$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $9e4b51c6e95190c7$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $9e4b51c6e95190c7$var$PROMISE_MAP[sdkKey] = stableID;
            $9e4b51c6e95190c7$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $9e4b51c6e95190c7$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $asfpr.getUUID)();
        $9e4b51c6e95190c7$var$_persistToStorage(stableID, sdkKey);
        $9e4b51c6e95190c7$var$_persistToCookie(stableID, sdkKey);
        $9e4b51c6e95190c7$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $9e4b51c6e95190c7$var$PROMISE_MAP[sdkKey] = override;
        $9e4b51c6e95190c7$var$_persistToStorage(override, sdkKey);
        $9e4b51c6e95190c7$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $9e4b51c6e95190c7$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $9e4b51c6e95190c7$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $9e4b51c6e95190c7$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $48byg._getStorageKey)(sdkKey)}`;
}
function $9e4b51c6e95190c7$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $9e4b51c6e95190c7$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $5dmxo._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $hwEEg.Log.warn("Failed to save StableID to storage");
    }
}
function $9e4b51c6e95190c7$var$_loadFromStorage(sdkKey) {
    const storageKey = $9e4b51c6e95190c7$var$_getStableIDStorageKey(sdkKey);
    return (0, $5dmxo._getObjectFromStorage)(storageKey);
}
function $9e4b51c6e95190c7$var$_loadFromCookie(sdkKey) {
    if (!$9e4b51c6e95190c7$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $cYoTo._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split("=");
        if (key === $9e4b51c6e95190c7$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $9e4b51c6e95190c7$var$_persistToCookie(stableID, sdkKey) {
    if (!$9e4b51c6e95190c7$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $cYoTo._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$9e4b51c6e95190c7$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $9e4b51c6e95190c7$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $48byg._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $9e4b51c6e95190c7$var$getCookieName;

});
parcelRegister("asfpr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $79c878e64ca0d16f$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $79c878e64ca0d16f$var$getUUID;

});


parcelRegister("iHpQh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $a1DgY = parcelRequire("a1DgY");

var $hwEEg = parcelRequire("hwEEg");
function $d9d049def0db6879$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $hwEEg.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $d9d049def0db6879$var$_normalizeUser;
function $d9d049def0db6879$var$_getFullUserHash(user) {
    return user ? (0, $a1DgY._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $d9d049def0db6879$var$_getFullUserHash;

});

parcelRegister("50bgC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $hwEEg = parcelRequire("hwEEg");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $3a45b1435d0b2c9f$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $hwEEg.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $3a45b1435d0b2c9f$var$_typedJsonParse;

});


parcelRegister("6eLYe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lLGXO", function(module, exports) {
"use strict";
var $fd8f507add828e64$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $hwEEg = parcelRequire("hwEEg");

var $j5H4v = parcelRequire("j5H4v");

var $7rc6R = parcelRequire("7rc6R");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $fd8f507add828e64$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $fd8f507add828e64$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $fd8f507add828e64$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $fd8f507add828e64$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $hwEEg.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$fd8f507add828e64$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($fd8f507add828e64$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $fd8f507add828e64$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $j5H4v.SDKType._get(this._sdkKey);
                    const statsigMetadata = $7rc6R.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $fd8f507add828e64$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $fd8f507add828e64$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $fd8f507add828e64$var$ErrorBoundary;
function $fd8f507add828e64$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $fd8f507add828e64$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $fd8f507add828e64$var$UNKNOWN_ERROR;
    }
}
function $fd8f507add828e64$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $fd8f507add828e64$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case "number":
            case "bigint":
            case "boolean":
                loggingCopy[String(option)] = value;
                break;
            case "string":
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = "set";
                break;
            case "object":
                if (option === "environment") loggingCopy["environment"] = value;
                else if (option === "networkConfig") loggingCopy["networkConfig"] = value;
                else loggingCopy[String(option)] = value != null ? "set" : "unset";
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("j5H4v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $de5fe513b2d7a5d3$var$SDK_CLIENT = {};
let $de5fe513b2d7a5d3$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $de5fe513b2d7a5d3$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($de5fe513b2d7a5d3$var$suffix !== null && $de5fe513b2d7a5d3$var$suffix !== void 0 ? $de5fe513b2d7a5d3$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $de5fe513b2d7a5d3$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$de5fe513b2d7a5d3$var$suffix || $de5fe513b2d7a5d3$var$suffix === "-react") $de5fe513b2d7a5d3$var$suffix = "-" + binding;
    }
};

});


parcelRegister("9Erzk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3OzBC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jMFCw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("huNva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _configList: "cl",
    _layer: "l",
    _paramStore: "p"
};
const $cbcba304d8eb5503$var$EXIST_KEYS = new Set([]);
const $cbcba304d8eb5503$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $cbcba304d8eb5503$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($cbcba304d8eb5503$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($cbcba304d8eb5503$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $cbcba304d8eb5503$var$createMemoKey;

});

parcelRegister("aGXN7", function(module, exports) {
"use strict";
var $7c8c34e9300f23bb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $ahWyx = parcelRequire("ahWyx");

var $ahWyx = parcelRequire("ahWyx");

var $43Ohs = parcelRequire("43Ohs");

var $hwEEg = parcelRequire("hwEEg");

var $6fq8a = parcelRequire("6fq8a");

var $fZs5f = parcelRequire("fZs5f");

var $fwbEQ = parcelRequire("fwbEQ");

var $j5H4v = parcelRequire("j5H4v");

var $cYoTo = parcelRequire("cYoTo");

var $eFwwu = parcelRequire("eFwwu");

var $dAAYy = parcelRequire("dAAYy");

var $krPcG = parcelRequire("krPcG");

var $7rc6R = parcelRequire("7rc6R");

var $22z2t = parcelRequire("22z2t");

var $3JVmL = parcelRequire("3JVmL");
const $7c8c34e9300f23bb$var$DEFAULT_TIMEOUT_MS = 10000;
const $7c8c34e9300f23bb$var$BACKOFF_BASE_MS = 500;
const $7c8c34e9300f23bb$var$BACKOFF_MAX_MS = 30000;
const $7c8c34e9300f23bb$var$RATE_LIMIT_WINDOW_MS = 1000;
const $7c8c34e9300f23bb$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $7c8c34e9300f23bb$var$LEAK_RATE = $7c8c34e9300f23bb$var$RATE_LIMIT_MAX_REQ_COUNT / $7c8c34e9300f23bb$var$RATE_LIMIT_WINDOW_MS;
const $7c8c34e9300f23bb$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $7c8c34e9300f23bb$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $7c8c34e9300f23bb$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $fZs5f.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$7c8c34e9300f23bb$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs("POST", args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $7c8c34e9300f23bb$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $7c8c34e9300f23bb$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$7c8c34e9300f23bb$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $hwEEg.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $3JVmL._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $7c8c34e9300f23bb$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $7c8c34e9300f23bb$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $7c8c34e9300f23bb$var$_getErrorMessage(error);
                const timedOut = $7c8c34e9300f23bb$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "", reqTimedOut);
                $7c8c34e9300f23bb$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$7c8c34e9300f23bb$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $krPcG.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $hwEEg.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $7c8c34e9300f23bb$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $22z2t.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $22z2t.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $7c8c34e9300f23bb$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $7c8c34e9300f23bb$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $6fq8a.Endpoint._initialize || args.urlConfig.endpoint === $6fq8a.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$6fq8a.NetworkParam.SdkKey]: args.sdkKey,
            [$6fq8a.NetworkParam.SdkType]: $j5H4v.SDKType._get(args.sdkKey),
            [$6fq8a.NetworkParam.SdkVersion]: $7rc6R.SDK_VERSION,
            [$6fq8a.NetworkParam.Time]: String(Date.now()),
            [$6fq8a.NetworkParam.SessionID]: $eFwwu.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join("&");
        return `${url}${query ? `?${query}` : ""}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $cYoTo._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $ahWyx._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$6fq8a.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $hwEEg.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $7c8c34e9300f23bb$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== "string" || !$7c8c34e9300f23bb$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($hwEEg.Log.error);
                writer.close().catch($hwEEg.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$6fq8a.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $hwEEg.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $7c8c34e9300f23bb$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $7c8c34e9300f23bb$var$NetworkCore;
const $7c8c34e9300f23bb$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $hwEEg.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $7c8c34e9300f23bb$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $dAAYy.StableID.get(sdkKey);
    const sessionID = $eFwwu.SessionID.get(sdkKey);
    const sdkType = $j5H4v.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $7rc6R.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $7c8c34e9300f23bb$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $ahWyx._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $fwbEQ.SDKFlags.get(args.sdkKey, "enable_log_event_compression") === true;
    switch(options.logEventCompressionMode){
        case $22z2t.LogEventCompressionMode.Disabled:
            return false;
        case $22z2t.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $22z2t.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $7c8c34e9300f23bb$var$_getErrorMessage(error) {
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $7c8c34e9300f23bb$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes("Timeout"); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $7c8c34e9300f23bb$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $6fq8a.Endpoint._initialize) return;
    $43Ohs.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $7c8c34e9300f23bb$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $6fq8a.Endpoint._initialize) return;
    $43Ohs.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $43Ohs.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $7c8c34e9300f23bb$var$_exponentialBackoff(attempt) {
    return $7c8c34e9300f23bb$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($7c8c34e9300f23bb$var$BACKOFF_BASE_MS * (attempt * attempt), $7c8c34e9300f23bb$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("fZs5f", function(module, exports) {
"use strict";
var $ba425659d8c041ad$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $fHJaH = parcelRequire("fHJaH");

var $a1DgY = parcelRequire("a1DgY");

var $hwEEg = parcelRequire("hwEEg");

var $5dmxo = parcelRequire("5dmxo");
const $ba425659d8c041ad$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $ba425659d8c041ad$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $ba425659d8c041ad$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $ba425659d8c041ad$var$DEFAULT_TTL_MS;
        $ba425659d8c041ad$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $ba425659d8c041ad$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $ba425659d8c041ad$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $ba425659d8c041ad$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$ba425659d8c041ad$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $ba425659d8c041ad$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $ba425659d8c041ad$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $ba425659d8c041ad$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $ba425659d8c041ad$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $fHJaH._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $ba425659d8c041ad$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $ba425659d8c041ad$var$NetworkFallbackResolver;
function $ba425659d8c041ad$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $ba425659d8c041ad$var$_isDomainFailure;
function $ba425659d8c041ad$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $a1DgY._DJB2)(sdkKey)}`;
}
function $ba425659d8c041ad$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $ba425659d8c041ad$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $5dmxo.Storage.removeItem(hashKey);
        return;
    }
    $5dmxo.Storage.setItem(hashKey, JSON.stringify(info));
}
function $ba425659d8c041ad$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $ba425659d8c041ad$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $5dmxo.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $hwEEg.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $ba425659d8c041ad$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("fHJaH", function(module, exports) {
"use strict";
var $b6ede94e7aadc46c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $b6ede94e7aadc46c$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $b6ede94e7aadc46c$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $b6ede94e7aadc46c$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $b6ede94e7aadc46c$var$MAX_START_LOOKUP = 200;
function $b6ede94e7aadc46c$var$_fetchTxtRecords(networkFunc) {
    return $b6ede94e7aadc46c$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($b6ede94e7aadc46c$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $b6ede94e7aadc46c$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $b6ede94e7aadc46c$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $b6ede94e7aadc46c$var$_fetchTxtRecords;
function $b6ede94e7aadc46c$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $b6ede94e7aadc46c$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $b6ede94e7aadc46c$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("fwbEQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $b4c2e32bdb4cfb7d$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $b4c2e32bdb4cfb7d$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $b4c2e32bdb4cfb7d$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("eFwwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $ahWyx = parcelRequire("ahWyx");

var $48byg = parcelRequire("48byg");

var $hwEEg = parcelRequire("hwEEg");

var $5dmxo = parcelRequire("5dmxo");

var $asfpr = parcelRequire("asfpr");
const $aade1f6b14fafcfe$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $aade1f6b14fafcfe$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $aade1f6b14fafcfe$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($aade1f6b14fafcfe$var$PROMISE_MAP[sdkKey] == null) $aade1f6b14fafcfe$var$PROMISE_MAP[sdkKey] = $aade1f6b14fafcfe$var$_loadSession(sdkKey);
        const session = $aade1f6b14fafcfe$var$PROMISE_MAP[sdkKey];
        return $aade1f6b14fafcfe$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $aade1f6b14fafcfe$var$PROMISE_MAP[sdkKey] = $aade1f6b14fafcfe$var$_overrideSessionId(override, sdkKey);
    }
};
function $aade1f6b14fafcfe$var$_loadSession(sdkKey) {
    let data = $aade1f6b14fafcfe$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $asfpr.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $aade1f6b14fafcfe$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $aade1f6b14fafcfe$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($aade1f6b14fafcfe$var$_isIdle(data) || $aade1f6b14fafcfe$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $asfpr.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }
    data.lastUpdate = now;
    $aade1f6b14fafcfe$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $aade1f6b14fafcfe$var$_createSessionTimeout(sdkKey, $aade1f6b14fafcfe$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $aade1f6b14fafcfe$var$_createSessionTimeout(sdkKey, $aade1f6b14fafcfe$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $aade1f6b14fafcfe$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $ahWyx._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $aade1f6b14fafcfe$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $aade1f6b14fafcfe$var$MAX_SESSION_IDLE_TIME;
}
function $aade1f6b14fafcfe$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $aade1f6b14fafcfe$var$MAX_SESSION_AGE;
}
function $aade1f6b14fafcfe$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $48byg._getStorageKey)(sdkKey)}`;
}
function $aade1f6b14fafcfe$var$_persistToStorage(session, sdkKey) {
    const storageKey = $aade1f6b14fafcfe$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $5dmxo._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $hwEEg.Log.warn("Failed to save SessionID");
    }
}
function $aade1f6b14fafcfe$var$_loadFromStorage(sdkKey) {
    const storageKey = $aade1f6b14fafcfe$var$_getSessionIDStorageKey(sdkKey);
    return (0, $5dmxo._getObjectFromStorage)(storageKey);
}

});

parcelRegister("krPcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("kRlsg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5qBIy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("apy3u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $7946a7d5e39afbe2$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $7946a7d5e39afbe2$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $7946a7d5e39afbe2$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === "object" && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $7946a7d5e39afbe2$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $7946a7d5e39afbe2$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $7946a7d5e39afbe2$var$_fastApproxSizeOf;

});

parcelRegister("8LKDe", function(module, exports) {
"use strict";
var $6626e2989c9509e4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $ahWyx = parcelRequire("ahWyx");

var $ahWyx = parcelRequire("ahWyx");

var $lLGXO = parcelRequire("lLGXO");

var $6kjqP = parcelRequire("6kjqP");

var $hwEEg = parcelRequire("hwEEg");

var $huNva = parcelRequire("huNva");

var $cYoTo = parcelRequire("cYoTo");

var $eFwwu = parcelRequire("eFwwu");

var $dAAYy = parcelRequire("dAAYy");

var $22z2t = parcelRequire("22z2t");

var $5dmxo = parcelRequire("5dmxo");
const $6626e2989c9509e4$var$MAX_MEMO_CACHE_SIZE = 3000;
class $6626e2989c9509e4$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($hwEEg.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $5dmxo.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $eFwwu.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $5dmxo.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $dAAYy.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $dAAYy.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $6kjqP.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $lLGXO.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $5dmxo.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError("OA::loadFromStorage", e));
        this._primeReadyRipcord();
        $6626e2989c9509e4$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? "disabled" : "browser-only");
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $5dmxo.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $dAAYy.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($22z2t.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $6626e2989c9509e4$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $hwEEg.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $huNva.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $6626e2989c9509e4$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $6626e2989c9509e4$var$StatsigClientBase;
function $6626e2989c9509e4$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $cYoTo._isServerEnv)()) return;
    const statsigGlobal = (0, $ahWyx._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $hwEEg.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("eaL8S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("huJaB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8RJKO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $hwEEg = parcelRequire("hwEEg");

var $4hEwe = parcelRequire("4hEwe");
function $01aa6e831692b951$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : "",
        __evaluation: evaluation,
        value: value
    };
}
function $01aa6e831692b951$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $01aa6e831692b951$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $01aa6e831692b951$var$_makeFeatureGate;
function $01aa6e831692b951$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $01aa6e831692b951$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $01aa6e831692b951$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $01aa6e831692b951$var$_makeDynamicConfig;
function $01aa6e831692b951$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $01aa6e831692b951$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $01aa6e831692b951$var$_makeExperiment;
function $01aa6e831692b951$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $01aa6e831692b951$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $01aa6e831692b951$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $01aa6e831692b951$var$_makeLayer;
function $01aa6e831692b951$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $01aa6e831692b951$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $01aa6e831692b951$var$_mergeOverride;
function $01aa6e831692b951$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $4hEwe._isTypeMatch)(found, fallback)) {
            $hwEEg.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $01aa6e831692b951$var$_makeTypedGet;

});

parcelRegister("6WVR5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5DLSe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $41b5bb02e362d451$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $41b5bb02e362d451$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("fNhE8", function(module, exports) {
"use strict";
var $b7f91ecb8f240e14$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $159T0 = parcelRequire("159T0");

var $4beE9 = parcelRequire("4beE9");

var $YRhLx = parcelRequire("YRhLx");

var $vglej = parcelRequire("vglej");

var $46Ta1 = parcelRequire("46Ta1");
class $b7f91ecb8f240e14$var$StatsigClient extends $159T0.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $159T0._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $b7f91ecb8f240e14$var$StatsigClient) return instance;
        $159T0.Log.warn((0, $159T0._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $b7f91ecb8f240e14$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $159T0.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $YRhLx.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $46Ta1.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($159T0.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($159T0.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($159T0.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($159T0.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($159T0.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($159T0.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $4beE9.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $159T0.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $159T0.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $b7f91ecb8f240e14$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $159T0.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $159T0.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $b7f91ecb8f240e14$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $b7f91ecb8f240e14$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $159T0.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $159T0.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $159T0.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $159T0.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($159T0.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $159T0.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $159T0.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $159T0.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $159T0.Log.error("Failed to parse user");
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $159T0.StatsigSession.get(this._sdkKey),
            stableID: $159T0.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: "log_event_called",
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $b7f91ecb8f240e14$var$__awaiter(this, void 0, void 0, function*() {
            if (!$159T0.Storage.isReady()) yield $159T0.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $159T0.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $159T0.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $159T0._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$159T0.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$159T0.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $159T0.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $159T0._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $159T0._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $159T0._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $159T0._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $159T0._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $159T0._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $159T0._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $159T0._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $159T0._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $159T0._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $vglej._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $vglej._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $b7f91ecb8f240e14$var$StatsigClient;

});
parcelRegister("4beE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $159T0 = parcelRequire("159T0");

var $3X2RJ = parcelRequire("3X2RJ");

var $ddo3d = parcelRequire("ddo3d");
class $30b38d08e00d1db5$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $159T0._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $159T0._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === "init-v2") this._values = new $ddo3d.V2InitializeContainer(values);
        else this._values = new $3X2RJ.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $159T0.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $159T0.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $159T0._getFullUserHash)(userForComparison) !== (0, $159T0._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $30b38d08e00d1db5$var$EvaluationStore;

});
parcelRegister("3X2RJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $159T0 = parcelRequire("159T0");
class $2e091ad134bcc72f$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $159T0._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $2e091ad134bcc72f$var$V1InitializeContainer;

});

parcelRegister("ddo3d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $159T0 = parcelRequire("159T0");
class $99ef2544c0d5feb3$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : "default",
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ""
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : "",
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === "stableID"
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === "stableID",
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : "",
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $159T0._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $99ef2544c0d5feb3$var$V2InitializeContainer;

});


parcelRegister("YRhLx", function(module, exports) {
"use strict";
var $0b6ef01c5aa2b6dd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $159T0 = parcelRequire("159T0");

var $jEYJu = parcelRequire("jEYJu");
class $0b6ef01c5aa2b6dd$var$StatsigNetwork extends $159T0.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $159T0.UrlConfiguration($159T0.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $0b6ef01c5aa2b6dd$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $159T0._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : "djb2");
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $0b6ef01c5aa2b6dd$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $jEYJu._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $0b6ef01c5aa2b6dd$var$StatsigNetwork;

});
parcelRegister("jEYJu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $159T0 = parcelRequire("159T0");
const $e500dd01153bf1c1$var$MAX_DELTAS_SORT_DEPTH = 2;
function $e500dd01153bf1c1$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $159T0._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $e500dd01153bf1c1$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $e500dd01153bf1c1$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $159T0._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $e500dd01153bf1c1$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $e500dd01153bf1c1$var$_resolveDeltasResponse;
function $e500dd01153bf1c1$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $e500dd01153bf1c1$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $e500dd01153bf1c1$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $e500dd01153bf1c1$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $e500dd01153bf1c1$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $e500dd01153bf1c1$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("vglej", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $159T0 = parcelRequire("159T0");
const $05df926e1ec3384c$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $05df926e1ec3384c$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $05df926e1ec3384c$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $159T0._isTypeMatch)(value, fallback);
}
function $05df926e1ec3384c$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $05df926e1ec3384c$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $05df926e1ec3384c$var$_shouldLogExposure(options) ? undefined : $05df926e1ec3384c$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $05df926e1ec3384c$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $05df926e1ec3384c$var$_shouldLogExposure(options) ? undefined : $05df926e1ec3384c$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($05df926e1ec3384c$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $05df926e1ec3384c$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $05df926e1ec3384c$var$_shouldLogExposure(options) ? undefined : $05df926e1ec3384c$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($05df926e1ec3384c$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $05df926e1ec3384c$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $05df926e1ec3384c$var$_shouldLogExposure(options) ? undefined : $05df926e1ec3384c$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($05df926e1ec3384c$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $05df926e1ec3384c$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $159T0._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $05df926e1ec3384c$var$_getMappedStaticValue(param, options);
            case "gate":
                return $05df926e1ec3384c$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $05df926e1ec3384c$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $05df926e1ec3384c$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $05df926e1ec3384c$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $05df926e1ec3384c$var$_makeParamStoreGetter;

});

parcelRegister("46Ta1", function(module, exports) {
"use strict";
var $2fe282bd25718a95$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $159T0 = parcelRequire("159T0");

var $YRhLx = parcelRequire("YRhLx");
class $2fe282bd25718a95$var$StatsigEvaluationsDataAdapter extends $159T0.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $YRhLx.default) this._network = network;
        else this._network = new $YRhLx.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $159T0._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $159T0._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $159T0.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $2fe282bd25718a95$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $159T0._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$159T0.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $159T0._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $2fe282bd25718a95$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("a1QTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d306ddc3ce8c8f$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $3vRz3 = parcelRequire("3vRz3");
function $74d306ddc3ce8c8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74d306ddc3ce8c8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74d306ddc3ce8c8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74d306ddc3ce8c8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74d306ddc3ce8c8f$export$a66cbd9b2289cd78 = "@all-features";
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $74d306ddc3ce8c8f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $74d306ddc3ce8c8f$var$_objectSpread($74d306ddc3ce8c8f$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $74d306ddc3ce8c8f$var$_objectSpread($74d306ddc3ce8c8f$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $74d306ddc3ce8c8f$var$_objectSpread($74d306ddc3ce8c8f$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $74d306ddc3ce8c8f$var$_objectSpread($74d306ddc3ce8c8f$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($74d306ddc3ce8c8f$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($74d306ddc3ce8c8f$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($74d306ddc3ce8c8f$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $74d306ddc3ce8c8f$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("5bbpE", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $3c56d52b12f96307$export$6dc24881a3d96325);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $9plgP = parcelRequire("9plgP");

var $gG83c = parcelRequire("gG83c");
var $3c56d52b12f96307$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $9plgP.migrateEvaluationDetails)(experiment.details), (0, $gG83c.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("9plgP", function(module, exports) {

$parcel$export(module.exports, "migrateEvaluationDetails", () => $6d96f2b43704407b$export$18ad168d3dbac899);

var $02Ztr = parcelRequire("02Ztr");

var $3KgqK = parcelRequire("3KgqK");
var $6d96f2b43704407b$var$evaluationReasonMappings = Object.entries((0, $3KgqK.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $6d96f2b43704407b$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $6d96f2b43704407b$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $3KgqK.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("3KgqK", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $2ba269b181d2dde6$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $2ba269b181d2dde6$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: "Error",
    LocalOverride: "LocalOverride",
    Unrecognized: "Unrecognized",
    Uninitialized: "Uninitialized",
    NetworkNotModified: "NetworkNotModified",
    Network: "Network",
    InvalidBootstrap: "InvalidBootstrap",
    Bootstrap: "Bootstrap",
    Cache: "Cache",
    // For when we could not migrate the reason from the new client
    Unknown: "Unknown"
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("gG83c", function(module, exports) {

$parcel$export(module.exports, "migrateSecondaryExposures", () => $c246d041f980d797$export$55fd683752d01e67);
var $c246d041f980d797$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === "string") // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("454RB", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $2f8b66d77d794997$export$936d0764594b6eb3);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $9plgP = parcelRequire("9plgP");

var $gG83c = parcelRequire("gG83c");
var $2f8b66d77d794997$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $9plgP.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $gG83c.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $gG83c.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("2S1No", function(module, exports) {

$parcel$export(module.exports, "deepAssign", () => $21720480ca3fc2ea$export$1148cb79ceecd5fa);

var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");
function $21720480ca3fc2ea$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $21720480ca3fc2ea$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(src) === "object" && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(dst) === "object" && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $21720480ca3fc2ea$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $21720480ca3fc2ea$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(sources)));
}

});

parcelRegister("jJadi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5ca247301f936e9$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $dxS0M = parcelRequire("dxS0M");

var $1IWl1 = parcelRequire("1IWl1");

var $aiiGv = parcelRequire("aiiGv");
function $e5ca247301f936e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5ca247301f936e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5ca247301f936e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5ca247301f936e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e5ca247301f936e9$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $e5ca247301f936e9$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $e5ca247301f936e9$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $e5ca247301f936e9$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $e5ca247301f936e9$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $e5ca247301f936e9$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $e5ca247301f936e9$export$4e8a0415edbfa1f7 = "https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net";
var $e5ca247301f936e9$export$cb3cd156f70d7e94 = "oasis-stg.com/flags";
var $e5ca247301f936e9$export$921fbc6cdfd4eee0 = "atlassian-isolated.net/flags";
var $e5ca247301f936e9$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $e5ca247301f936e9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error("Failed to retrieve client sdk key");
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error("Failed to retrieve experiment values");
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $aiiGv.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $aiiGv.ResponseError)("Unexpected 204 response");
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $e5ca247301f936e9$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $dxS0M.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $dxS0M.FeatureGateEnvironment).Production:
                        return $e5ca247301f936e9$export$18c93900db9358a4;
                    case (0, $dxS0M.FeatureGateEnvironment).Staging:
                        return $e5ca247301f936e9$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $dxS0M.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $dxS0M.FeatureGateEnvironment).Development:
                        return $e5ca247301f936e9$export$f058dbf75c3bc647;
                    case (0, $dxS0M.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $e5ca247301f936e9$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $e5ca247301f936e9$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $e5ca247301f936e9$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $e5ca247301f936e9$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $1IWl1.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $e5ca247301f936e9$export$4e8a0415edbfa1f7.replace("%s", isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($e5ca247301f936e9$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($e5ca247301f936e9$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== "undefined" && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("dxS0M", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $9dc840fe361972b2$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $9dc840fe361972b2$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9dc840fe361972b2$export$479e7351a733299 = {
    Development: "development",
    Staging: "staging",
    Production: "production"
};
var $9dc840fe361972b2$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: "commercial",
    FEDRAMP_MODERATE: "fedramp-moderate"
};
var $9dc840fe361972b2$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("1IWl1", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $141727354f2a5163$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $141727354f2a5163$export$a59f8d67326bd1cb = "6.0.1";

});

parcelRegister("aiiGv", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $77ea14363ca44d68$export$286baf652d0b1206);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $in7St = parcelRequire("in7St");
function $77ea14363ca44d68$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $77ea14363ca44d68$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $77ea14363ca44d68$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($77ea14363ca44d68$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $77ea14363ca44d68$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ResponseError);
        return $77ea14363ca44d68$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($in7St)))(Error));

});


parcelRegister("9B3at", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $6fca06d5a2f8187f$export$d119b37e5f788b43);

var $g5Zhu = parcelRequire("g5Zhu");

var $cX70D = parcelRequire("cX70D");

var $dxS0M = parcelRequire("dxS0M");
function $6fca06d5a2f8187f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fca06d5a2f8187f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fca06d5a2f8187f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fca06d5a2f8187f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6fca06d5a2f8187f$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $6fca06d5a2f8187f$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $cX70D.isFedRamp)() ? (0, $dxS0M.PerimeterType).FEDRAMP_MODERATE : (0, $dxS0M.PerimeterType).COMMERCIAL
    }, options);
};

});
parcelRegister("cX70D", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $96e06e9a67bc12b6$export$64d6499adf9b2e51);

var $3sgs9 = parcelRequire("3sgs9");
function $96e06e9a67bc12b6$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $3sgs9.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("3sgs9", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $2840bfd8bd166f37$export$ce553301d55c2fd8);
var $2840bfd8bd166f37$export$ce553301d55c2fd8 = "fedramp-moderate";
var $2840bfd8bd166f37$export$f005e2e9f707cb5f = "commercial";
var $2840bfd8bd166f37$export$bd6b5a7802d76127 = "fedramp-fedex";
var $2840bfd8bd166f37$export$a739cd5aac835909 = "stg";
var $2840bfd8bd166f37$export$42dd0cdd351a4a9 = "prod";
var $2840bfd8bd166f37$export$404582bc18fe4d9e = "dev";

});



parcelRegister("cnmk8", function(module, exports) {

$parcel$export(module.exports, "migrateInitializationOptions", () => $9028f30f219a1156$export$202946b690d26d22);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");
var $9028f30f219a1156$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9028f30f219a1156$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9028f30f219a1156$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9028f30f219a1156$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9028f30f219a1156$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9028f30f219a1156$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $9028f30f219a1156$var$_excluded);
    return $9028f30f219a1156$var$_objectSpread($9028f30f219a1156$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("d14r4", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $979ecf2f9fcff38f$export$55fffef3474104af);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $73HSG = parcelRequire("73HSG");
function $979ecf2f9fcff38f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $979ecf2f9fcff38f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $979ecf2f9fcff38f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $979ecf2f9fcff38f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $979ecf2f9fcff38f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $979ecf2f9fcff38f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $979ecf2f9fcff38f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($979ecf2f9fcff38f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $979ecf2f9fcff38f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $979ecf2f9fcff38f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NoFetchDataAdapter);
        _this = $979ecf2f9fcff38f$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $73HSG.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $979ecf2f9fcff38f$var$_objectSpread($979ecf2f9fcff38f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $73HSG._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $979ecf2f9fcff38f$var$_objectSpread($979ecf2f9fcff38f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $73HSG._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $73HSG._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $73HSG.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $979ecf2f9fcff38f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $979ecf2f9fcff38f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $73HSG.DataAdapterCore));

});

parcelRegister("SLO0B", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $0a4a207474da2744$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $0a4a207474da2744$export$bcb28fbac1def494);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $159T0 = parcelRequire("159T0");
function $0a4a207474da2744$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a4a207474da2744$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a4a207474da2744$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a4a207474da2744$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a4a207474da2744$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0a4a207474da2744$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0a4a207474da2744$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0a4a207474da2744$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0a4a207474da2744$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0a4a207474da2744$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0a4a207474da2744$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $0a4a207474da2744$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $0a4a207474da2744$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $0a4a207474da2744$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0a4a207474da2744$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $0a4a207474da2744$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PersistentOverrideAdapter);
        this._overrides = $0a4a207474da2744$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0a4a207474da2744$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0a4a207474da2744$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0a4a207474da2744$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0a4a207474da2744$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($0a4a207474da2744$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0a4a207474da2744$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $159T0._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, $0a4a207474da2744$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0a4a207474da2744$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, current.details), {}, {
                        reason: $0a4a207474da2744$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0a4a207474da2744$var$djb2MapKey((0, $159T0._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0a4a207474da2744$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0a4a207474da2744$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $159T0._makeTypedGet)(current.name, overridden),
                    details: $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, current.details), {}, {
                        reason: $0a4a207474da2744$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0a4a207474da2744$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $159T0._makeTypedGet)(current.name, overridden),
                    details: $0a4a207474da2744$var$_objectSpread($0a4a207474da2744$var$_objectSpread({}, current.details), {}, {
                        reason: $0a4a207474da2744$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("eKAHt", function(module, exports) {

$parcel$export(module.exports, "shallowEquals", () => $abd1d471e54a18c0$export$fa1c2bbf4100b8bc);

var $02Ztr = parcelRequire("02Ztr");
var $abd1d471e54a18c0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("aJs0Q", function(module, exports) {

$parcel$export(module.exports, "toStatsigUser", () => $7d03d6123d4304fc$export$3dad1db244472f32);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");
var $7d03d6123d4304fc$var$_excluded = [
    "stableId"
];
function $7d03d6123d4304fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d03d6123d4304fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d03d6123d4304fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d03d6123d4304fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d03d6123d4304fc$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(identifiers, $7d03d6123d4304fc$var$_excluded);
    var user = {
        customIDs: $7d03d6123d4304fc$var$_objectSpread($7d03d6123d4304fc$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("3KsQO", function(module, exports) {

$parcel$export(module.exports, "debug", () => $2bac0c1f9d067e48$export$1c9f709888824e05);
var $2bac0c1f9d067e48$var$_process, $2bac0c1f9d067e48$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2bac0c1f9d067e48$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($2bac0c1f9d067e48$var$_process = globalThis.process) === null || $2bac0c1f9d067e48$var$_process === void 0 || ($2bac0c1f9d067e48$var$_process = $2bac0c1f9d067e48$var$_process.env) === null || $2bac0c1f9d067e48$var$_process === void 0 ? void 0 : $2bac0c1f9d067e48$var$_process.JEST_WORKER_ID) !== undefined;
var $2bac0c1f9d067e48$var$DEBUG_MODE = !$2bac0c1f9d067e48$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($2bac0c1f9d067e48$var$_process2 = globalThis.process) === null || $2bac0c1f9d067e48$var$_process2 === void 0 || ($2bac0c1f9d067e48$var$_process2 = $2bac0c1f9d067e48$var$_process2.env) === null || $2bac0c1f9d067e48$var$_process2 === void 0 ? void 0 : $2bac0c1f9d067e48$var$_process2.NODE_ENV) !== "production";
var $2bac0c1f9d067e48$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2bac0c1f9d067e48$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("8u2o4", function(module, exports) {

$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $62d2fa1e97f6d2fe$export$b574c24e1e6490f5);

var $jJuBG = parcelRequire("jJuBG");
var $62d2fa1e97f6d2fe$export$b574c24e1e6490f5 = (0, $jJuBG.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("jJuBG", function(module, exports) {

$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $e5d9f62caaf12d70$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $e5d9f62caaf12d70$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $e5d9f62caaf12d70$export$75f4a1454eff2805);

var $hPtJY = parcelRequire("hPtJY");
var $e5d9f62caaf12d70$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $e5d9f62caaf12d70$export$407f05df8e3ce9f3 = "@atlaskit/platform-feature-flags";
var $e5d9f62caaf12d70$export$75f4a1454eff2805 = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";

});


parcelRegister("2hyDS", function(module, exports) {

$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $1a980a89602aeb07$export$92f8b531feaeb23d);

var $jJuBG = parcelRequire("jJuBG");
var $1a980a89602aeb07$export$92f8b531feaeb23d = (0, $jJuBG.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("aLZib", function(module, exports) {

$parcel$export(module.exports, "globalVar", () => $7d7dd68c36f70b84$export$54ea85357b4e0159);

var $jJuBG = parcelRequire("jJuBG");
var $7d7dd68c36f70b84$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $7d7dd68c36f70b84$export$54ea85357b4e0159 = typeof window !== "undefined" ? window : globalThis;
$7d7dd68c36f70b84$export$54ea85357b4e0159[0, $jJuBG.PFF_GLOBAL_KEY] = $7d7dd68c36f70b84$export$54ea85357b4e0159[0, $jJuBG.PFF_GLOBAL_KEY] || $7d7dd68c36f70b84$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("e7WCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48f307fe088bfb8$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6b8HT = parcelRequire("6b8HT");
var $a48f307fe088bfb8$export$7bc189309d2ad463 = "analyticsInteractionSesssionTrackingClient";
var $a48f307fe088bfb8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function GlobalInteractionSessionTracking() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, GlobalInteractionSessionTracking);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(GlobalInteractionSessionTracking, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                var interactionSessionTracking;
                try {
                    // Check if InteractionSessionTracking in global window object
                    if ($a48f307fe088bfb8$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$a48f307fe088bfb8$export$7bc189309d2ad463];
                    else {
                        // Initialise InteractionSessionTracking on global window object
                        window[$a48f307fe088bfb8$export$7bc189309d2ad463] = new (0, $6b8HT.default)();
                        interactionSessionTracking = window[$a48f307fe088bfb8$export$7bc189309d2ad463];
                    }
                } catch (error) {
                // Silently swallow exception
                }
                return interactionSessionTracking;
            }
        }
    ]);
}();

});
parcelRegister("6b8HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $47fa862f550ba456$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $hioX8 = parcelRequire("hioX8");
var $47fa862f550ba456$var$INTERACTION_SESSION_ID_STORAGE_KEY = "interactionSession.id";
var $47fa862f550ba456$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = "interactionSession.id.prev";
var $47fa862f550ba456$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = "interactionSession.expiry";
var $47fa862f550ba456$export$285f6bddd927a06d = 1800000; // 30 minutes
var $47fa862f550ba456$export$d050a4cab1b9f734 = 86400000; // 24 hours
var $47fa862f550ba456$export$a92e915d70316eb2 = 5000; // 5 seconds
var $47fa862f550ba456$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $47fa862f550ba456$var$INTEGER_REGEX = /^\d+$/;
var $47fa862f550ba456$export$5d4c4eab0863aae3 = "interactionSessionIdUpdated";
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ var $47fa862f550ba456$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // This callback function will be called whenever a new session ID is generated
    // It expects a function that sends an operational analytics event, with
    // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
    // an InteractionSession object containing the new session ID and previous session ID.
    function InteractionSessionTracking() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, InteractionSessionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "analyticsReady", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "generateNewSessionId", function() {
            if (!_this.analyticsReady) return null;
            var currentSessionId = _this.safeSessionStorage.getItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            var newSessionId = Date.now().toString();
            _this.safeSessionStorage.setItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            var _this$getCurrentSessi = _this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi.isValidSession;
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                _this.safeSessionStorage.setItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                _this.sendInteractionSessionEvent("renewed");
            } else _this.sendInteractionSessionEvent("started");
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($47fa862f550ba456$export$5d4c4eab0863aae3));
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "updateSessionExpiry", function() {
            var expiry = Date.now() + _this.sessionExpiryTime;
            _this.safeSessionStorage.setItem($47fa862f550ba456$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "debouncedUpdateSessionExpiry", function(currentExpiry) {
            var updateSessionExpiry = _this.updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this.sessionExpiryDebounceThresholdPercentage * _this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (_this.sessionExpiryDebounceTimer) clearTimeout(_this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this.sessionExpiryDebounceTimer = setTimeout(function() {
                    updateSessionExpiry();
                }, _this.sessionExpiryDebounce);
            }
        });
        this.sessionExpiryTime = $47fa862f550ba456$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $47fa862f550ba456$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $47fa862f550ba456$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $hioX8.default)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(InteractionSessionTracking, [
        {
            key: "getCurrentInteractionSessionId",
            value: function getCurrentInteractionSessionId() {
                try {
                    var _this$getCurrentSessi2 = this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi2.isValidSession, sessionExpiry = _this$getCurrentSessi2.sessionExpiry, sessionId = _this$getCurrentSessi2.sessionId;
                    // If we have an existing valid session we can return the sessionId straight away
                    if (isValidSession) {
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return sessionId;
                    }
                    // To generate a new session ID we must ensure analytics is ready
                    if (this.analyticsReady) {
                        // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                        // into issues of calls attempting to read the session ID before a valid expiry had been set
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return this.generateNewSessionId();
                    }
                } catch (err) {
                // Silently swallow exception
                }
                return null;
            }
        },
        {
            key: "getPreviousInteractionSessionId",
            value: function getPreviousInteractionSessionId() {
                return this.safeSessionStorage.getItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            }
        },
        {
            key: "setInteractionSessionId",
            value: function setInteractionSessionId(persistedSessionId) {
                if (this.validateSessionId(persistedSessionId)) {
                    var currentSessionId = this.safeSessionStorage.getItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                    // If we are already on the required session ID, just return true and make no changes
                    // This can happen if the persisted session ID in options is the same as the current session ID
                    // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
                    // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
                    if (currentSessionId === persistedSessionId) return false;
                    // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
                    // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
                    this.debouncedUpdateSessionExpiry(0);
                    this.safeSessionStorage.setItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
                    this.safeSessionStorage.removeItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
                    document.dispatchEvent(new Event($47fa862f550ba456$export$5d4c4eab0863aae3));
                    return true;
                }
                return false;
            }
        },
        {
            key: "setAnalyticsCallback",
            value: function setAnalyticsCallback(sendEventCallback) {
                if (this.analyticsReady) // If we already have a valid callback, don't over-write it
                return;
                if (sendEventCallback && typeof sendEventCallback === "function") {
                    this.sendEventCallback = sendEventCallback;
                    this.analyticsReady = true;
                } else this.analyticsReady = false;
            }
        },
        {
            key: "validateSessionId",
            value: function validateSessionId(sessionId) {
                // Check if persisted session ID can parse as valid Unix timestamp
                if (sessionId && $47fa862f550ba456$var$INTEGER_REGEX.test(sessionId)) {
                    var sessionAge = Date.now() - parseInt(sessionId, 10);
                    // Validate that timestamp is not a future time, and is also within the TTL
                    if (sessionAge >= 0 && sessionAge <= $47fa862f550ba456$export$d050a4cab1b9f734) return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentSessionParams",
            value: function getCurrentSessionParams() {
                var sessionId = this.safeSessionStorage.getItem($47fa862f550ba456$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this.safeSessionStorage.getItem($47fa862f550ba456$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
                if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "sendInteractionSessionEvent",
            value: function sendInteractionSessionEvent(action) {
                this.sendEventCallback && this.sendEventCallback({
                    action: action,
                    actionSubject: "interactionSession",
                    source: "interactionComponent",
                    tags: [
                        "navigationExperiences"
                    ] // InteractionSession events will be registered under this platform product
                });
            }
        }
    ]);
}();

});
parcelRegister("hioX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9777934a3437dd0$export$2e2bcd8739ae039);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $cpMH6 = parcelRequire("cpMH6");

var $fegH5 = parcelRequire("fegH5");
function $c9777934a3437dd0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $c9777934a3437dd0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $c9777934a3437dd0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c9777934a3437dd0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $c9777934a3437dd0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, _default);
        var storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $cpMH6.default);
        } catch (err) {
            storageToUse = (0, $cpMH6.default);
        }
        return $c9777934a3437dd0$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(_default, _SafeStorage);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(_default);
}((0, $fegH5.default));

});
parcelRegister("cpMH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $909d977d33c319a8$export$2e2bcd8739ae039);

var $h8LpN = parcelRequire("h8LpN");
// eslint-disable-next-line import/no-anonymous-default-export
var $909d977d33c319a8$var$inmemorystorage = new (0, $h8LpN.InMemoryStore)();
var $909d977d33c319a8$export$2e2bcd8739ae039 = $909d977d33c319a8$var$inmemorystorage;

});
parcelRegister("h8LpN", function(module, exports) {

$parcel$export(module.exports, "InMemoryStore", () => $c7a7f6ae2e56d815$export$90e3e001bcac59c7);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $g5Zhu = parcelRequire("g5Zhu");
var $c7a7f6ae2e56d815$export$90e3e001bcac59c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function InMemoryStore() {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, InMemoryStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "data", {});
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "length", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", function(key, value) {
        _this.data[key] = value;
        _this.length = Object.keys(_this.data).length;
        return value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", function(key) {
        if (key in _this.data) return _this.data[key];
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", function(key) {
        if (key in _this.data) delete _this.data[key];
        _this.length = Object.keys(_this.data).length;
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", function() {
        _this.data = {};
        _this.length = 0;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", function(index) {
        return Object.keys(_this.data)[index];
    });
});

});


parcelRegister("fegH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1651ce6cbd19136$export$2e2bcd8739ae039);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $g5Zhu = parcelRequire("g5Zhu");

var $l6ETK = parcelRequire("l6ETK");

var $cpMH6 = parcelRequire("cpMH6");

var $hJVxo = parcelRequire("hJVxo");
var $b1651ce6cbd19136$export$41c06fdd37b7e9a5 = "awc";
var $b1651ce6cbd19136$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
var $b1651ce6cbd19136$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function SafeStorage(storageToUse) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, SafeStorage);
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getStore", function() {
        return _this.store;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", function(key) {
        return _this.store.getItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", function(key) {
        return _this.store.removeItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", function(key, value) {
        try {
            _this.store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this.store.setItem(_this.createKey(key), value);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "swapToInMemory", function() {
        if (_this.store === (0, $cpMH6.default) || typeof window === "undefined") return;
        var keys = Object.keys(_this.store || {});
        var inMemoryStorage;
        if ((0, $hJVxo.isSupported)(window[$b1651ce6cbd19136$export$770aa8bc07b3de03])) inMemoryStorage = window[$b1651ce6cbd19136$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $cpMH6.default);
            if (!window[$b1651ce6cbd19136$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$b1651ce6cbd19136$export$770aa8bc07b3de03] = (0, $cpMH6.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this.store = inMemoryStorage;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", function() {
        return _this.store.clear();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", function(index) {
        return _this.store.key(index);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getPrefix", function() {
        return _this.prefix;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createKey", function(key) {
        if (_this.prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($b1651ce6cbd19136$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== (0, $l6ETK.envType).PROD) prefixes.push(options.envPrefix);
    this.prefix = prefixes.join("-");
    if ((0, $hJVxo.isSupported)(storageToUse)) this.store = storageToUse;
    else this.swapToInMemory();
});

});
parcelRegister("l6ETK", function(module, exports) {

$parcel$export(module.exports, "envType", () => $f5d9e205d24cc86e$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $f5d9e205d24cc86e$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("hJVxo", function(module, exports) {

$parcel$export(module.exports, "isSupported", () => $cea34561f7221bfd$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $cea34561f7221bfd$export$48c17662a6902497(store) {
    var TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        var key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("5aeOH", function(module, exports) {

$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $3c29613564a87c6a$export$81d16f1428ce0486);
var $3c29613564a87c6a$export$81d16f1428ce0486 = "xpis";
var $3c29613564a87c6a$export$2e3999ec51334ffe = function generateUrlWithParams(url, bridge, interactionSessionId, product, subProduct) {
    var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
    var interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    var paramValueEncoded = btoa(JSON.stringify(interactionSession));
    var partialUrl = false;
    var urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch (_unused) {
        urlObj = new URL(url, "http://localhost/");
        partialUrl = true;
    }
    urlObj.searchParams.set($3c29613564a87c6a$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("jGeFe", function(module, exports) {

$parcel$export(module.exports, "validProducts", () => $e53d508d737fc7aa$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var $e53d508d737fc7aa$export$b1e8b4360a046e61 = [
    "jira",
    "confluence",
    "townsquare",
    "loom",
    "atlassianStudio",
    "bitbucket",
    "admin",
    "mercury",
    "trello",
    "analyticsVisualizationPlatform"
];

});

parcelRegister("kS1ye", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31a0dcd6870cd64$export$2e2bcd8739ae039);

var $hMelT = parcelRequire("hMelT");

var $bvwZF = parcelRequire("bvwZF");

var $h7VX5 = parcelRequire("h7VX5");
const $f31a0dcd6870cd64$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $bvwZF.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $hMelT.parseUrl)(removedFragmentURL);
    const captureParams = (0, $h7VX5.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $h7VX5.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $hMelT.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f31a0dcd6870cd64$export$2e2bcd8739ae039 = $f31a0dcd6870cd64$var$urlParamExtractor;

});
parcelRegister("hMelT", function(module, exports) {

$parcel$export(module.exports, "extract", () => $cf120d67add8fcd1$export$f9380c9a627682d3, (v) => $cf120d67add8fcd1$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $cf120d67add8fcd1$export$98e6a39c04603d36, (v) => $cf120d67add8fcd1$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $cf120d67add8fcd1$export$fac44ee5b035f737, (v) => $cf120d67add8fcd1$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $cf120d67add8fcd1$export$7a5253c0f62e0150, (v) => $cf120d67add8fcd1$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $cf120d67add8fcd1$export$a8c1621ea79325d3, (v) => $cf120d67add8fcd1$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $cf120d67add8fcd1$export$357523c63a2253b9, (v) => $cf120d67add8fcd1$export$357523c63a2253b9 = v);
var $cf120d67add8fcd1$export$f9380c9a627682d3;
var $cf120d67add8fcd1$export$98e6a39c04603d36;
var $cf120d67add8fcd1$export$fac44ee5b035f737;
var $cf120d67add8fcd1$export$7a5253c0f62e0150;
var $cf120d67add8fcd1$export$a8c1621ea79325d3;
var $cf120d67add8fcd1$export$357523c63a2253b9;
var $cf120d67add8fcd1$export$44c361b8ec72ef7f;
"use strict";

var $3sG8k = parcelRequire("3sG8k");

var $5yzCy = parcelRequire("5yzCy");

var $KvXt7 = parcelRequire("KvXt7");

var $4IJyT = parcelRequire("4IJyT");
const $cf120d67add8fcd1$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $cf120d67add8fcd1$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $cf120d67add8fcd1$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            "[",
                            $cf120d67add8fcd1$var$encode(index, options),
                            "]=",
                            $cf120d67add8fcd1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            "[]=",
                            $cf120d67add8fcd1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            ":list=",
                            $cf120d67add8fcd1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $cf120d67add8fcd1$var$encode(key, options),
                                keyValueSep,
                                $cf120d67add8fcd1$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $cf120d67add8fcd1$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $cf120d67add8fcd1$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $cf120d67add8fcd1$var$encode(key, options),
                            "=",
                            $cf120d67add8fcd1$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $cf120d67add8fcd1$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $cf120d67add8fcd1$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $cf120d67add8fcd1$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$cf120d67add8fcd1$var$decode(item, options)) : value === null ? value : $cf120d67add8fcd1$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $cf120d67add8fcd1$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$cf120d67add8fcd1$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $cf120d67add8fcd1$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $cf120d67add8fcd1$var$encode(value, options) {
    if (options.encode) return options.strict ? $3sG8k(value) : encodeURIComponent(value);
    return value;
}
function $cf120d67add8fcd1$var$decode(value, options) {
    if (options.decode) return $5yzCy(value);
    return value;
}
function $cf120d67add8fcd1$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $cf120d67add8fcd1$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $cf120d67add8fcd1$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $cf120d67add8fcd1$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $cf120d67add8fcd1$var$extract(input) {
    input = $cf120d67add8fcd1$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $cf120d67add8fcd1$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $cf120d67add8fcd1$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $cf120d67add8fcd1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $cf120d67add8fcd1$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $KvXt7(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $cf120d67add8fcd1$var$decode(value, options);
        formatter($cf120d67add8fcd1$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $cf120d67add8fcd1$var$parseValue(value[k], options);
        else ret[key] = $cf120d67add8fcd1$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $cf120d67add8fcd1$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$cf120d67add8fcd1$export$f9380c9a627682d3 = $cf120d67add8fcd1$var$extract;
$cf120d67add8fcd1$export$98e6a39c04603d36 = $cf120d67add8fcd1$var$parse;
$cf120d67add8fcd1$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $cf120d67add8fcd1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $cf120d67add8fcd1$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $cf120d67add8fcd1$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $cf120d67add8fcd1$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $cf120d67add8fcd1$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $cf120d67add8fcd1$var$encode(key, options) + "=" + $cf120d67add8fcd1$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$cf120d67add8fcd1$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $KvXt7(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $cf120d67add8fcd1$var$parse($cf120d67add8fcd1$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $cf120d67add8fcd1$var$decode(hash, options)
    } : {});
};
$cf120d67add8fcd1$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$cf120d67add8fcd1$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $cf120d67add8fcd1$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $cf120d67add8fcd1$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $cf120d67add8fcd1$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $cf120d67add8fcd1$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $cf120d67add8fcd1$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$cf120d67add8fcd1$var$encodeFragmentIdentifier] ? $cf120d67add8fcd1$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$cf120d67add8fcd1$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$cf120d67add8fcd1$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $cf120d67add8fcd1$export$7a5253c0f62e0150(input, options);
    return $cf120d67add8fcd1$export$a8c1621ea79325d3({
        url: url,
        query: $4IJyT(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$cf120d67add8fcd1$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $cf120d67add8fcd1$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("bvwZF", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $860c2ecd52d2c577$export$600dd5bf1b049f11);
const $860c2ecd52d2c577$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);

});

parcelRegister("h7VX5", function(module, exports) {

$parcel$export(module.exports, "mapKeys", () => $c7800b2ef6e5817d$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $c7800b2ef6e5817d$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $c7800b2ef6e5817d$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $c7800b2ef6e5817d$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $c7800b2ef6e5817d$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $c7800b2ef6e5817d$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $c7800b2ef6e5817d$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $c7800b2ef6e5817d$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $c7800b2ef6e5817d$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $c7800b2ef6e5817d$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $c7800b2ef6e5817d$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $c7800b2ef6e5817d$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $c7800b2ef6e5817d$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$c7800b2ef6e5817d$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $c7800b2ef6e5817d$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("kklyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc665a050b0d477$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $1ENQS = parcelRequire("1ENQS");

var $b5SZG = parcelRequire("b5SZG");

var $dOhR7 = parcelRequire("dOhR7");
class $ecc665a050b0d477$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startLowPriorityEventDelay", (timeout = (0, $1ENQS.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $1ENQS.MAX_DELAY_TIMEOUT)) : (0, $1ENQS.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $dOhR7.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopLowPriorityEventDelay", (reason = (0, $dOhR7.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $b5SZG.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("1ENQS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $13503263d962fe31$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $13503263d962fe31$export$8575e30be0feb909);
const $13503263d962fe31$export$cf090d5281b5ae06 = 10000;
const $13503263d962fe31$export$8575e30be0feb909 = 30000;

});

parcelRegister("b5SZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $813ad1f852ab2090$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $d8Ako = parcelRequire("d8Ako");

var $h7VX5 = parcelRequire("h7VX5");

var $hlyNU = parcelRequire("hlyNU");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $813ad1f852ab2090$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $813ad1f852ab2090$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $813ad1f852ab2090$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $813ad1f852ab2090$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $813ad1f852ab2090$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $h7VX5.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $h7VX5.equals)(group.userInfo, args.userInfo) && (0, $h7VX5.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $d8Ako.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $hlyNU.default)(compressionRules);
    }
}

});
parcelRegister("hlyNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca0f652ba5524ddb$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $9lihP = parcelRequire("9lihP");

var $h7VX5 = parcelRequire("h7VX5");

var $ujAQi = parcelRequire("ujAQi");
function $ca0f652ba5524ddb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca0f652ba5524ddb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca0f652ba5524ddb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca0f652ba5524ddb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ca0f652ba5524ddb$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $9lihP.buildActionFields)(event, event.eventType);
                    contextFields = (0, $h7VX5.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $h7VX5.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$ca0f652ba5524ddb$var$_objectSpread($ca0f652ba5524ddb$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $ujAQi.CompressionRule))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("ujAQi", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", () => $05b20043cea36d44$export$89b3253ddfd2e6e8);

var $g5Zhu = parcelRequire("g5Zhu");

var $cZL4D = parcelRequire("cZL4D");

var $h7VX5 = parcelRequire("h7VX5");

var $h54gC = parcelRequire("h54gC");

var $5vg30 = parcelRequire("5vg30");
class $05b20043cea36d44$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $cZL4D.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $h7VX5.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $5vg30.validateActionEventType)(event.eventType);
                (0, $h54gC.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("cZL4D", function(module, exports) {

$parcel$export(module.exports, "isActionEventType", () => $975fb2625585bc1b$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3emEs = parcelRequire("3emEs");
function $975fb2625585bc1b$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $3emEs.eventType).OPERATIONAL:
        case (0, $3emEs.eventType).TRACK:
        case (0, $3emEs.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("h54gC", function(module, exports) {

$parcel$export(module.exports, "validateActionEvent", () => $c6f636a6cbde666f$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2gINR = parcelRequire("2gINR");
function $c6f636a6cbde666f$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    (0, $2gINR.validateContainers)(event.containers);
}

});
parcelRegister("2gINR", function(module, exports) {

$parcel$export(module.exports, "validateContainers", () => $1a6fd45fcdb72c41$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3RbyK = parcelRequire("3RbyK");
function $1a6fd45fcdb72c41$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>(0, $3RbyK.validateContainersObject)(container));
}

});
parcelRegister("3RbyK", function(module, exports) {

$parcel$export(module.exports, "validateContainersObject", () => $2cef49cc433ea9d5$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $l3Lvn = parcelRequire("l3Lvn");
function $2cef49cc433ea9d5$export$df8ff30e3c960006(container) {
    if (!(0, $l3Lvn.isPlainObject)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}

});



parcelRegister("5vg30", function(module, exports) {

$parcel$export(module.exports, "validateActionEventType", () => $401c4bac900943d9$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3emEs = parcelRequire("3emEs");

var $cZL4D = parcelRequire("cZL4D");
const $401c4bac900943d9$var$actionEventTypes = Object.freeze([
    (0, $3emEs.eventType).OPERATIONAL,
    (0, $3emEs.eventType).TRACK,
    (0, $3emEs.eventType).UI
]);
function $401c4bac900943d9$export$4a8d7476662aebcc(type) {
    if (!(0, $cZL4D.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$401c4bac900943d9$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("dOhR7", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $a0ddcba152d3d997$export$fa6e3729c21cb8f);
let $a0ddcba152d3d997$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("iR8R0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba40b70e88a84b7$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $iHHOT = parcelRequire("iHHOT");

var $aY3N4 = parcelRequire("aY3N4");

var $eNyK8 = parcelRequire("eNyK8");

var $WMjuX = parcelRequire("WMjuX");

var $6hJp8 = parcelRequire("6hJp8");

var $gOXOu = parcelRequire("gOXOu");

var $5Umcg = parcelRequire("5Umcg");

var $31Uyb = parcelRequire("31Uyb");

var $iRiir = parcelRequire("iRiir");

var $gz095 = parcelRequire("gz095");

var $hTfdX = parcelRequire("hTfdX");

var $gmHX7 = parcelRequire("gmHX7");

var $eIxx9 = parcelRequire("eIxx9");

var $bOwjO = parcelRequire("bOwjO");

var $jN3O4 = parcelRequire("jN3O4");

var $12WUI = parcelRequire("12WUI");
function $dba40b70e88a84b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dba40b70e88a84b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dba40b70e88a84b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dba40b70e88a84b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $dba40b70e88a84b7$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $dba40b70e88a84b7$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $dba40b70e88a84b7$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $dba40b70e88a84b7$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "originTracingClient", null);
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendEvents", async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            });
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                var _this$originTracingCl;
                const response = await (0, $bOwjO.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this$originTracingCl = this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $iRiir.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $hTfdX.LastError)("ServerBusyError", error);
                else {
                    const errorName = error instanceof Error && (0, $jN3O4.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : "Unknown";
                    this.lastSendEventsError = new (0, $hTfdX.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        });
        this.options = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $5Umcg.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || "",
            enableMetadataCalls: typeof options.enableMetadataCalls === "boolean" ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === "boolean" ? options.enableEventCalls : true
        });
        this.user = new (0, $12WUI.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $aY3N4.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $iHHOT.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $jN3O4.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $jN3O4.SegmentEventTypes).TRACK,
            properties: (0, $eIxx9.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $jN3O4.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $jN3O4.SegmentEventTypes).PAGE,
            properties: (0, $eIxx9.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $jN3O4.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $jN3O4.SegmentEventTypes).IDENTIFY,
            traits: (0, $eIxx9.prepareEventProperties)(builtEvent)
        });
        const event = $dba40b70e88a84b7$var$_objectSpread($dba40b70e88a84b7$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $gmHX7.prepareEventContext)(context);
        const segmentContext = (0, $gOXOu.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $eNyK8.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== "object") return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === "props") continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === "number" && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === "object") this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (_unused) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $dba40b70e88a84b7$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $dba40b70e88a84b7$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ""), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $dba40b70e88a84b7$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $WMjuX.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $dba40b70e88a84b7$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $31Uyb.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $6hJp8.AnalyticsResponse)(success, statusCode, (0, $gz095.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $gz095.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $gz095.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $gz095.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $31Uyb.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $6hJp8.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($dba40b70e88a84b7$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $31Uyb.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $6hJp8.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $31Uyb.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $6hJp8.AnalyticsResponse)(false, -1, (0, $gz095.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($dba40b70e88a84b7$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("iHHOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9de3be045862d69$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5fkVL = parcelRequire("5fkVL");

var $baTre = parcelRequire("baTre");
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d9de3be045862d69$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $5fkVL.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("5fkVL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $3d1e96daf04ca143$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $3d1e96daf04ca143$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $9CAms = parcelRequire("9CAms");

var $1LQ8W = parcelRequire("1LQ8W");

var $4JY5s = parcelRequire("4JY5s");

var $biJaX = parcelRequire("biJaX");

var $ctJfP = parcelRequire("ctJfP");

var $aY3N4 = parcelRequire("aY3N4");

var $8dyB8 = parcelRequire("8dyB8");

var $hPyCe = parcelRequire("hPyCe");

var $6IUhI = parcelRequire("6IUhI");

var $baTre = parcelRequire("baTre");
function $3d1e96daf04ca143$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d1e96daf04ca143$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d1e96daf04ca143$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d1e96daf04ca143$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3d1e96daf04ca143$var$ONE_MINUTE = 60000;
const $3d1e96daf04ca143$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $3d1e96daf04ca143$var$ONE_MINUTE,
    minRetryDelay: $3d1e96daf04ca143$var$ONE_MINUTE,
    maxRetryDelay: $3d1e96daf04ca143$var$ONE_MINUTE
};
const $3d1e96daf04ca143$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $3d1e96daf04ca143$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $4JY5s.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $3d1e96daf04ca143$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $hPyCe.default)($3d1e96daf04ca143$var$_objectSpread($3d1e96daf04ca143$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $hPyCe.default)($3d1e96daf04ca143$var$_objectSpread($3d1e96daf04ca143$var$_objectSpread({}, $3d1e96daf04ca143$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $3d1e96daf04ca143$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $aY3N4.default)();
        this.networkStatus = new (0, $8dyB8.default)((status)=>{
            if (status === (0, $baTre.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $biJaX.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $baTre.NetworkStatusEnum).OFFLINE) {
            done((0, $6IUhI.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $ctJfP.CallbackProcessingErrorName)) {
                done((0, $6IUhI.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $9CAms.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $1LQ8W.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $biJaX.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $6IUhI.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $6IUhI.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $6IUhI.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $3d1e96daf04ca143$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $3d1e96daf04ca143$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $3d1e96daf04ca143$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $3d1e96daf04ca143$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $3d1e96daf04ca143$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $3d1e96daf04ca143$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $3d1e96daf04ca143$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $3d1e96daf04ca143$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $3d1e96daf04ca143$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("9CAms", function(module, exports) {

$parcel$export(module.exports, "default", () => $7013de453e79babe$export$2e2bcd8739ae039);

var $bxsxf = parcelRequire("bxsxf");

var $4ybeV = parcelRequire("4ybeV");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $7013de453e79babe$var$validSuffixs = Object.values((0, $bxsxf.LocalStorageKeySuffix));
var $7013de453e79babe$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $7013de453e79babe$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $bxsxf.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $4ybeV.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("bxsxf", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", () => $8668e94945f07056$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $8668e94945f07056$export$8bb2c1fb2b1765a9);
let $8668e94945f07056$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $8668e94945f07056$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("4ybeV", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", () => $35030e5a39ea76c1$export$8433d54f767cbec5);

var $bxsxf = parcelRequire("bxsxf");
const $35030e5a39ea76c1$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $bxsxf.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $bxsxf.LocalStorageKeySuffix).ACK}`,
        [(0, $bxsxf.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $bxsxf.LocalStorageKeySuffix).QUEUE}`,
        [(0, $bxsxf.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $bxsxf.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $bxsxf.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $bxsxf.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $bxsxf.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $bxsxf.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("1LQ8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a2a0d0207a0388$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $eNyK8 = parcelRequire("eNyK8");

var $bxsxf = parcelRequire("bxsxf");

var $4ybeV = parcelRequire("4ybeV");
function $14a2a0d0207a0388$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14a2a0d0207a0388$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14a2a0d0207a0388$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14a2a0d0207a0388$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $14a2a0d0207a0388$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $14a2a0d0207a0388$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $bxsxf.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $bxsxf.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (_unused) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_unused2) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $14a2a0d0207a0388$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $14a2a0d0207a0388$var$promisedSetTimeout((0, $bxsxf.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $bxsxf.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $14a2a0d0207a0388$var$promisedSetTimeout((0, $bxsxf.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $bxsxf.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $14a2a0d0207a0388$var$reclaim(options, callback);
};
const $14a2a0d0207a0388$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $14a2a0d0207a0388$var$_objectSpread($14a2a0d0207a0388$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $14a2a0d0207a0388$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $14a2a0d0207a0388$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $14a2a0d0207a0388$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $14a2a0d0207a0388$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $eNyK8.default)();
    const queuesToReclaim = $14a2a0d0207a0388$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$14a2a0d0207a0388$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $4ybeV.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("eNyK8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac609792293ad893$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $ac609792293ad893$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === "function") return g.crypto.randomUUID();
    } catch (_unused) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === "x" ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("4JY5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3739f9705587c279$export$2e2bcd8739ae039);

var $5gPWT = parcelRequire("5gPWT");
var $3739f9705587c279$export$2e2bcd8739ae039 = (0, $5gPWT.default);

});
parcelRegister("5gPWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d66be58b9e29d08$export$2e2bcd8739ae039);

var $biJaX = parcelRequire("biJaX");

var $d3zdn = parcelRequire("d3zdn");

var $lMx1f = parcelRequire("lMx1f");

var $aMq0Y = parcelRequire("aMq0Y");

var $8uT4i = parcelRequire("8uT4i");

var $5OQup = parcelRequire("5OQup");
class $3d66be58b9e29d08$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $d3zdn.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $8uT4i.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $lMx1f.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $5OQup.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $biJaX.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $biJaX.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $aMq0Y.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $biJaX.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $5OQup.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $biJaX.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("biJaX", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $83a46b15c0184880$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $83a46b15c0184880$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $83a46b15c0184880$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $83a46b15c0184880$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $83a46b15c0184880$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $83a46b15c0184880$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $83a46b15c0184880$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $83a46b15c0184880$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $83a46b15c0184880$export$7710d69e6f450f20);
const $83a46b15c0184880$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $83a46b15c0184880$export$8cad224051643259 = "analytics-web-client";
const $83a46b15c0184880$export$3d8420be07b276ab = "analytics-resilience";
const $83a46b15c0184880$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $83a46b15c0184880$export$89d9c1ff8ac91862 = "timeAdded";
const $83a46b15c0184880$export$a37d385bcd713809 = "retryAttempts";
const $83a46b15c0184880$export$6d8635fed0e4b14d = 15000;
let $83a46b15c0184880$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $83a46b15c0184880$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("d3zdn", function(module, exports) {

$parcel$export(module.exports, "createOptionsWithDefaults", () => $9816df1198ea95b7$export$ddc6718318090f71);

var $2eFP3 = parcelRequire("2eFP3");
const $9816df1198ea95b7$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $2eFP3.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $2eFP3.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("2eFP3", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", () => $1a0d54a11d189705$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $1a0d54a11d189705$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $1a0d54a11d189705$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $1a0d54a11d189705$export$1188664dfff364c8);
const $1a0d54a11d189705$export$b6df3d334cec060f = 7;
const $1a0d54a11d189705$export$14ef152a03a4b6ee = 60000;
const $1a0d54a11d189705$export$da9ab7b2fd5998e8 = 10;
const $1a0d54a11d189705$export$1188664dfff364c8 = 8000;

});


parcelRegister("lMx1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb7b192ffad17c7$export$2e2bcd8739ae039);
const $fdb7b192ffad17c7$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $fdb7b192ffad17c7$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $fdb7b192ffad17c7$export$2e2bcd8739ae039.prototype);
        this.name = $fdb7b192ffad17c7$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("aMq0Y", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $7d9291092b59dac5$export$74101021e0969375);

var $3SRU7 = parcelRequire("3SRU7");

var $ctJfP = parcelRequire("ctJfP");

var $4R0jZ = parcelRequire("4R0jZ");
const $7d9291092b59dac5$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $3SRU7.AbandonWriteErrorName) || errorWithName.name === (0, $ctJfP.CallbackProcessingErrorName) || errorWithName.name === (0, $4R0jZ.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("3SRU7", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", () => $2d403a7698cea29d$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $2d403a7698cea29d$export$2e2bcd8739ae039);
const $2d403a7698cea29d$export$ba95206613c96b28 = "AbandonWriteError";
class $2d403a7698cea29d$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2d403a7698cea29d$export$2e2bcd8739ae039.prototype);
        this.name = $2d403a7698cea29d$export$ba95206613c96b28;
    }
}

});

parcelRegister("ctJfP", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", () => $915b4c0b7c0662b9$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $915b4c0b7c0662b9$export$2e2bcd8739ae039);
const $915b4c0b7c0662b9$export$a409c8de90e11e14 = "CallbackProcessingError";
class $915b4c0b7c0662b9$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $915b4c0b7c0662b9$export$2e2bcd8739ae039.prototype);
        this.name = $915b4c0b7c0662b9$export$a409c8de90e11e14;
    }
}

});

parcelRegister("4R0jZ", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", () => $388c5c7b8ff67bf1$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $388c5c7b8ff67bf1$export$2e2bcd8739ae039);
const $388c5c7b8ff67bf1$export$7e7aee9a953465ec = "InvalidPolicyError";
class $388c5c7b8ff67bf1$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $388c5c7b8ff67bf1$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("8uT4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $62fbd77aad2702f5$export$2e2bcd8739ae039);

var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $80tzI = parcelRequire("80tzI");

var $biJaX = parcelRequire("biJaX");

var $8qzv0 = parcelRequire("8qzv0");

var $d3zdn = parcelRequire("d3zdn");

var $2eFP3 = parcelRequire("2eFP3");

var $ctJfP = parcelRequire("ctJfP");

var $4R0jZ = parcelRequire("4R0jZ");

var $lMx1f = parcelRequire("lMx1f");

var $aMq0Y = parcelRequire("aMq0Y");

var $biwgV = parcelRequire("biwgV");

var $iuiKP = parcelRequire("iuiKP");

var $axary = parcelRequire("axary");
const $62fbd77aad2702f5$var$_excluded = [
    "item"
], $62fbd77aad2702f5$var$_excluded2 = [
    "items"
];
function $62fbd77aad2702f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62fbd77aad2702f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62fbd77aad2702f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62fbd77aad2702f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $62fbd77aad2702f5$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== "undefined") {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn("IndexedDB timed out.");
                        reject(new (0, $lMx1f.default)());
                    }, (0, $biJaX.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $biJaX.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                        const db = request.result;
                        const store = db.createObjectStore((0, $biJaX.RESILIENCE_STORE_NAME), {
                            keyPath: "id"
                        });
                        store.createIndex((0, $biJaX.TIME_TO_PROCESS_AFTER_INDEX), (0, $biJaX.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $biJaX.RETRY_INDEX), (0, $biJaX.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $biJaX.TIME_ADDED_INDEX), (0, $biJaX.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $biJaX.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            "namespace",
                            "timeAdded"
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $lMx1f.default)());
                    };
                    try {
                        await (0, $axary.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn("IndexedDB failed to initialise.", error);
                        reject(new (0, $lMx1f.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $lMx1f.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "addItem", async (item, options = {}, policy = (0, $biJaX.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $8qzv0.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $biJaX.GuardPolicy).IGNORE) throw new (0, $4R0jZ.default)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $aMq0Y.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "bulkAddItem", async (itemOptions, policy = (0, $biJaX.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $62fbd77aad2702f5$var$_excluded);
                return (0, $8qzv0.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $aMq0Y.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItems", async (count = (0, $2eFP3.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $2eFP3.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $biJaX.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $62fbd77aad2702f5$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $2eFP3.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $iuiKP.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $iuiKP.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $80tzI.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $80tzI.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $biJaX.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $axary.requestToPromise)(request);
            await (0, $80tzI.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "processItems", async (processFn, count = (0, $2eFP3.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_await$this$getItems, $62fbd77aad2702f5$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $ctJfP.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $axary.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $biJaX.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $biJaX.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $d3zdn.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $lMx1f.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $biwgV.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $biJaX.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("80tzI", function(module, exports) {

$parcel$export(module.exports, "commitTransaction", () => $5d4543d4ff1fe37a$export$feab8418f018df89);

var $jqQLr = parcelRequire("jqQLr");
const $5d4543d4ff1fe37a$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return (0, $jqQLr.transactionToPromise)(transaction);
};

});
parcelRegister("jqQLr", function(module, exports) {

$parcel$export(module.exports, "transactionToPromise", () => $e2595fea56781477$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $e2595fea56781477$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("8qzv0", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", () => $622c49d69e3da5ea$export$aec476f33d77be11);

var $eNyK8 = parcelRequire("eNyK8");
const $622c49d69e3da5ea$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $eNyK8.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("biwgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $839a68b3706c0c27$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $80tzI = parcelRequire("80tzI");

var $biJaX = parcelRequire("biJaX");

var $3SRU7 = parcelRequire("3SRU7");

var $axary = parcelRequire("axary");
class $839a68b3706c0c27$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $biJaX.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $axary.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $biJaX.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $biJaX.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $biJaX.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $biJaX.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $axary.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $80tzI.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $3SRU7.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $biJaX.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $axary.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("axary", function(module, exports) {

$parcel$export(module.exports, "requestToPromise", () => $7ab5164f3cd4cc45$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $7ab5164f3cd4cc45$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("iuiKP", function(module, exports) {

$parcel$export(module.exports, "monitorErrorsOnRequest", () => $d7599387bf25042a$export$342d941b6f724995);
// For requests that are not mission critical
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $d7599387bf25042a$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};

});


parcelRegister("5OQup", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ca5695c3061a5e$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $biJaX = parcelRequire("biJaX");

var $8qzv0 = parcelRequire("8qzv0");

var $d3zdn = parcelRequire("d3zdn");

var $2eFP3 = parcelRequire("2eFP3");

var $ctJfP = parcelRequire("ctJfP");

var $4R0jZ = parcelRequire("4R0jZ");

var $2yS8G = parcelRequire("2yS8G");
const $43ca5695c3061a5e$var$_excluded = [
    "item"
], $43ca5695c3061a5e$var$_excluded2 = [
    "items"
];
function $43ca5695c3061a5e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43ca5695c3061a5e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43ca5695c3061a5e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43ca5695c3061a5e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $43ca5695c3061a5e$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $d3zdn.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $2yS8G.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $biJaX.GuardPolicy).ABANDON) {
        if (policy === (0, $biJaX.GuardPolicy).IGNORE) throw new (0, $4R0jZ.default)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $8qzv0.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $biJaX.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $43ca5695c3061a5e$var$_excluded);
            return (0, $8qzv0.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $biJaX.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $2eFP3.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $2eFP3.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $2eFP3.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($43ca5695c3061a5e$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $2eFP3.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$synchronousGetI, $43ca5695c3061a5e$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $ctJfP.default)(error);
        }
    }
    storeType() {
        return (0, $biJaX.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("2yS8G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd8c0a25384e9fe$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $biJaX = parcelRequire("biJaX");

var $3SRU7 = parcelRequire("3SRU7");
class $1dd8c0a25384e9fe$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $biJaX.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $biJaX.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $biJaX.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $3SRU7.default)((0, $biJaX.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("aY3N4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc272b379cefdd7$export$2e2bcd8739ae039);

var $flkwx = parcelRequire("flkwx");
let $7fc272b379cefdd7$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7fc272b379cefdd7$export$2e2bcd8739ae039 = ()=>{
    if (!$7fc272b379cefdd7$var$cachedMetricsClient) $7fc272b379cefdd7$var$cachedMetricsClient = new (0, $flkwx.MetricsCollector)();
    return $7fc272b379cefdd7$var$cachedMetricsClient;
};

});
parcelRegister("flkwx", function(module, exports) {

$parcel$export(module.exports, "MetricsCollector", () => $b2b8bcc3968029c7$export$4b62ee5120ab50a8);

var $g5Zhu = parcelRequire("g5Zhu");

var $baTre = parcelRequire("baTre");
class $b2b8bcc3968029c7$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resilienceMechanism", (0, $baTre.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}

});
parcelRegister("baTre", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", () => $822ba1bd58dc48a4$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $822ba1bd58dc48a4$export$ee138fa712d11b84);
let $822ba1bd58dc48a4$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $822ba1bd58dc48a4$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("8dyB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fba600a33d850de$export$2e2bcd8739ae039);

var $baTre = parcelRequire("baTre");
class $5fba600a33d850de$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>this._networkChangeCallback((0, $baTre.NetworkStatusEnum).OFFLINE));
            window.addEventListener("online", ()=>this._networkChangeCallback((0, $baTre.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>this._networkChangeCallback((0, $baTre.NetworkStatusEnum).OFFLINE));
            window.addEventListener("online", ()=>this._networkChangeCallback((0, $baTre.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $baTre.NetworkStatusEnum).ONLINE;
        return (0, $baTre.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("hPyCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb20d0cdeecf350$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $2boIh = parcelRequire("2boIh");

var $6IUhI = parcelRequire("6IUhI");
const $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $cfb20d0cdeecf350$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $cfb20d0cdeecf350$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "schedule", ({ immediate: immediate } = {})=>{
            if (typeof window === "undefined") return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $cfb20d0cdeecf350$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $cfb20d0cdeecf350$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $cfb20d0cdeecf350$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $cfb20d0cdeecf350$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearTimeout", ()=>{
            if (typeof window !== "undefined" && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $6IUhI.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $6IUhI.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $2boIh.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $6IUhI.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $cfb20d0cdeecf350$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $cfb20d0cdeecf350$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $cfb20d0cdeecf350$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $cfb20d0cdeecf350$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $cfb20d0cdeecf350$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $2boIh.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("2boIh", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", () => $196fc75aa978b82e$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $196fc75aa978b82e$export$590a718599f8f8b3);

var $g5Zhu = parcelRequire("g5Zhu");
let $196fc75aa978b82e$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $196fc75aa978b82e$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $196fc75aa978b82e$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "callbackStatus", $196fc75aa978b82e$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $196fc75aa978b82e$export$ef3353088fca369c.IDLE:
            case $196fc75aa978b82e$export$ef3353088fca369c.TIMED_OUT:
            case $196fc75aa978b82e$export$ef3353088fca369c.COMPLETED:
                if (event === $196fc75aa978b82e$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $196fc75aa978b82e$export$ef3353088fca369c.RUNNING;
                break;
            case $196fc75aa978b82e$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $196fc75aa978b82e$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $196fc75aa978b82e$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $196fc75aa978b82e$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $196fc75aa978b82e$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === "undefined") return;
        this.transitionCallbackStatus(this.callbackStatus, $196fc75aa978b82e$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $196fc75aa978b82e$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $196fc75aa978b82e$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $196fc75aa978b82e$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== "undefined" && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("6IUhI", function(module, exports) {

$parcel$export(module.exports, "DoneState", () => $4e52831f00635a47$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $4e52831f00635a47$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("WMjuX", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", () => $0b0ae4f2581f013f$export$c21270cab66ab290);

var $hVbYW = parcelRequire("hVbYW");
async function $0b0ae4f2581f013f$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $hVbYW.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("hVbYW", function(module, exports) {

$parcel$export(module.exports, "attachXidToSingleEvent", () => $d0c10de635f96b1a$export$c9c3aaf655d6f275);

var $g5Zhu = parcelRequire("g5Zhu");

var $jN3O4 = parcelRequire("jN3O4");
function $d0c10de635f96b1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0c10de635f96b1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0c10de635f96b1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0c10de635f96b1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d0c10de635f96b1a$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $jN3O4.SegmentEventTypes).PAGE || item.msg.type === (0, $jN3O4.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $d0c10de635f96b1a$var$_objectSpread($d0c10de635f96b1a$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $jN3O4.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $d0c10de635f96b1a$var$_objectSpread($d0c10de635f96b1a$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}

});
parcelRegister("jN3O4", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", () => $e6858bd0fb7de9a4$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $e6858bd0fb7de9a4$export$96f086dcf574a9e2);
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
let $e6858bd0fb7de9a4$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $e6858bd0fb7de9a4$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $e6858bd0fb7de9a4$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $e6858bd0fb7de9a4$export$96f086dcf574a9e2 = [
    "FetchError",
    "AbortError",
    "TypeError"
];

});



parcelRegister("6hJp8", function(module, exports) {

$parcel$export(module.exports, "AnalyticsResponse", () => $49378cf78986f932$export$133650fcdde1b226);
class $49378cf78986f932$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("gOXOu", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $c3efb683e569d319$export$3a7fe28f9bf4f3d9);

var $g5Zhu = parcelRequire("g5Zhu");

var $57P17 = parcelRequire("57P17");
function $c3efb683e569d319$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3efb683e569d319$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3efb683e569d319$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3efb683e569d319$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Shallow removal of all falsey properties from an object, returning a new object.
const $c3efb683e569d319$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $c3efb683e569d319$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = $c3efb683e569d319$var$_objectSpread($c3efb683e569d319$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = $c3efb683e569d319$var$_objectSpread($c3efb683e569d319$var$_objectSpread({}, result.excludedProperties), (0, $57P17.nestedRemoveUndefinedValues)(overrides.excludedProperties, "$.excludedProperties"));
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = $c3efb683e569d319$var$_objectSpread($c3efb683e569d319$var$_objectSpread({}, result.userConsents), (0, $57P17.nestedRemoveUndefinedValues)(overrides.userConsents, "$.userConsents"));
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $c3efb683e569d319$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("57P17", function(module, exports) {

$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $3bb52e24225582cd$export$2250ccecd1e040fd);
// @ts-ignore
// This function will essentially deepClone as well
const $3bb52e24225582cd$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== "object") return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("5Umcg", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $44d36685b6842dad$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $44d36685b6842dad$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $44d36685b6842dad$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $44d36685b6842dad$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $44d36685b6842dad$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $44d36685b6842dad$export$6f1c008dd0c3b67e);
const $44d36685b6842dad$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $44d36685b6842dad$export$8fddcd1eff390364 = 60000; // 60 seconds
const $44d36685b6842dad$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $44d36685b6842dad$export$6649d5c857717efe = 5000; // 5 seconds
const $44d36685b6842dad$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $44d36685b6842dad$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("31Uyb", function(module, exports) {

$parcel$export(module.exports, "EventResponse", () => $234d54d346498f75$export$51e0b986fdbf3840);
class $234d54d346498f75$export$51e0b986fdbf3840 {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("iRiir", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $dbab5e845f3940bd$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $dbab5e845f3940bd$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("gz095", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $c0f00723f510199f$export$ba118f9de1e5ac63);
const $c0f00723f510199f$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        "OK"
    ],
    [
        400,
        "Bad Request"
    ],
    [
        401,
        "Unauthorized"
    ],
    [
        402,
        "Payment Required"
    ],
    [
        403,
        "Forbidden"
    ],
    [
        404,
        "Not Found"
    ],
    [
        405,
        "Method Not Allowed"
    ],
    [
        406,
        "Not Acceptable"
    ],
    [
        407,
        "Proxy Authentication Required"
    ],
    [
        408,
        "Request Timeout"
    ],
    [
        409,
        "Conflict"
    ],
    [
        410,
        "Gone"
    ],
    [
        411,
        "Length Required"
    ],
    [
        412,
        "Precondition Failed"
    ],
    [
        413,
        "Payload Too Large"
    ],
    [
        414,
        "URI Too Long"
    ],
    [
        415,
        "Unsupported Media Type"
    ],
    [
        416,
        "Requested range not satisfiable"
    ],
    [
        417,
        "Expectation Failed"
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        "Unprocessable Entity"
    ],
    [
        423,
        "Locked"
    ],
    [
        424,
        "Failed Dependency"
    ],
    [
        425,
        "Too Early"
    ],
    [
        426,
        "Upgrade Required"
    ],
    [
        428,
        "Precondition Required"
    ],
    [
        429,
        "Too Many Requests"
    ],
    [
        431,
        "Request Header Fields Too Large"
    ],
    [
        451,
        "Unavailable For Legal Reasons"
    ],
    [
        500,
        "Internal Server Error"
    ],
    [
        501,
        "Not Implemented"
    ],
    [
        502,
        "Bad Gateway"
    ],
    [
        503,
        "Service Unavailable"
    ],
    [
        504,
        "Gateway Timeout"
    ],
    [
        505,
        "HTTP Version not supported"
    ],
    [
        506,
        "Variant Also Negotiates"
    ],
    [
        507,
        "Insufficient Storage"
    ],
    [
        508,
        "Loop Detected"
    ],
    [
        509,
        "Bandwidth Limit Exceeded"
    ],
    [
        510,
        "Not Extended"
    ],
    [
        511,
        "Network Authentication Required"
    ],
    [
        -1,
        "Unknown Status"
    ]
]);

});

parcelRegister("hTfdX", function(module, exports) {

$parcel$export(module.exports, "LastError", () => $d06361e972bb0749$export$a63e16b3351b8c36);

var $iRiir = parcelRequire("iRiir");
class $d06361e972bb0749$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $iRiir.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("gmHX7", function(module, exports) {

$parcel$export(module.exports, "prepareEventContext", () => $bea0cb7c17d8b517$export$6b26e26d40264200);
// @ts-ignore

var $gBvHc = parcelRequire("gBvHc");

var $57P17 = parcelRequire("57P17");
const $bea0cb7c17d8b517$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $57P17.nestedRemoveUndefinedValues)(context, "$.context");
    return (0, (/*@__PURE__*/$parcel$interopDefault($gBvHc)))(propertiesWithoutUndefined);
};

});
parcelRegister("gBvHc", function(module, exports) {
"use strict";

var $5uCx6 = parcelRequire("5uCx6");
/**
 * Expose `traverse`.
 */ module.exports = $c168b02aa2d0b720$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $c168b02aa2d0b720$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $c168b02aa2d0b720$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $c168b02aa2d0b720$var$traverseArray(input, strict);
    else if ($5uCx6.is(input, strict)) return $5uCx6.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $c168b02aa2d0b720$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $c168b02aa2d0b720$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $c168b02aa2d0b720$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $c168b02aa2d0b720$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("5uCx6", function(module, exports) {

$parcel$export(module.exports, "parse", () => $3ffda4e754dfe2c2$export$98e6a39c04603d36, (v) => $3ffda4e754dfe2c2$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $3ffda4e754dfe2c2$export$226b3eccf92c9ed9, (v) => $3ffda4e754dfe2c2$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $3ffda4e754dfe2c2$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $3ffda4e754dfe2c2$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $3ffda4e754dfe2c2$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$3ffda4e754dfe2c2$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $3ffda4e754dfe2c2$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$3ffda4e754dfe2c2$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $3ffda4e754dfe2c2$var$matcher.test(string);
};

});



parcelRegister("eIxx9", function(module, exports) {

$parcel$export(module.exports, "prepareEventProperties", () => $ab6f2fd15fb6a9a1$export$44d22e5fb02cc68e);
// @ts-ignore

var $gBvHc = parcelRequire("gBvHc");

var $57P17 = parcelRequire("57P17");
const $ab6f2fd15fb6a9a1$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $57P17.nestedRemoveUndefinedValues)(properties, "$.properties");
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gBvHc)))(propertiesWithoutUndefined);
};

});

parcelRegister("bOwjO", function(module, exports) {

$parcel$export(module.exports, "sendEvents", () => $899d6f00c3e0c52f$export$8e8f0180c1b41fad);

var $g5Zhu = parcelRequire("g5Zhu");

var $jk22o = parcelRequire("jk22o");

var $iRiir = parcelRequire("iRiir");
function $899d6f00c3e0c52f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $899d6f00c3e0c52f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $899d6f00c3e0c52f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $899d6f00c3e0c52f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $899d6f00c3e0c52f$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $899d6f00c3e0c52f$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $899d6f00c3e0c52f$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $899d6f00c3e0c52f$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status !== 200) throw new (0, $iRiir.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch (_unused) {}
    throw new (0, $iRiir.FetchError)("Invalid HTTP Response (Invalid response body)", 200, "Invalid response body");
};
const $899d6f00c3e0c52f$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $899d6f00c3e0c52f$var$getCorsForUrl = (0, $jk22o.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});
parcelRegister("jk22o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e111773323c0bcc0$export$2e2bcd8739ae039);
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("12WUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c33ad66833170d6$export$2e2bcd8739ae039);

var $86sxN = parcelRequire("86sxN");

var $76ZC2 = parcelRequire("76ZC2");

var $4onAo = parcelRequire("4onAo");

var $k4E1V = parcelRequire("k4E1V");

var $eNyK8 = parcelRequire("eNyK8");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $0c33ad66833170d6$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $0c33ad66833170d6$var$SAFE = "SAFE";
const $0c33ad66833170d6$var$UNSAFE = "UNSAFE";
const $0c33ad66833170d6$var$NOT_FOUND = "NOT_FOUND";
const $0c33ad66833170d6$var$COOKIE = "COOKIE";
const $0c33ad66833170d6$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $0c33ad66833170d6$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $k4E1V.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $4onAo.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $76ZC2.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $76ZC2.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $0c33ad66833170d6$var$LOCAL_STORAGE ? this.store.getItem((0, $76ZC2.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $76ZC2.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $0c33ad66833170d6$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $0c33ad66833170d6$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (_unused) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $0c33ad66833170d6$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($0c33ad66833170d6$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $86sxN.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $0c33ad66833170d6$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $0c33ad66833170d6$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $0c33ad66833170d6$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $0c33ad66833170d6$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($0c33ad66833170d6$var$COOKIE);
        switch(cookieValue.type){
            case $0c33ad66833170d6$var$SAFE:
            case $0c33ad66833170d6$var$UNSAFE:
                this.store.setItem((0, $76ZC2.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $0c33ad66833170d6$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === "function" ? customAnonymousIdGenerator : ()=>{
            return (0, $eNyK8.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("86sxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e650688c0910592$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $lm2ga = parcelRequire("lm2ga");

var $4LmDH = parcelRequire("4LmDH");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $5e650688c0910592$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var sign = $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $lm2ga.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("gdr0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $fSwVM.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("lm2ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8bd67cac91ee19b$export$2e2bcd8739ae039);

var $9vfYB = parcelRequire("9vfYB");

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $cJfMa.default)(dirtyDateLeft);
    var startOfDayRight = (0, $cJfMa.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9vfYB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9vfYB.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("9vfYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb366e006a8b659$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("cJfMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9445ecc5e7cfb647$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("76ZC2", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", () => $52d8e2ecb9502005$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $52d8e2ecb9502005$export$d4cb17942ea57c95);
let $52d8e2ecb9502005$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $52d8e2ecb9502005$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $52d8e2ecb9502005$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === "https:";
    } catch (err) {
        return false;
    }
};
const $52d8e2ecb9502005$export$d4cb17942ea57c95 = {
    [$52d8e2ecb9502005$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $52d8e2ecb9502005$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: $52d8e2ecb9502005$var$isSecure(),
        path: "/"
    }),
    [$52d8e2ecb9502005$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $52d8e2ecb9502005$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: $52d8e2ecb9502005$var$isSecure(),
        path: "/"
    }),
    [$52d8e2ecb9502005$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $52d8e2ecb9502005$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: $52d8e2ecb9502005$var$isSecure(),
        path: "/"
    })
};

});

parcelRegister("4onAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $332bb2ff89e018d2$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $8Nbse = parcelRequire("8Nbse");

var $76ZC2 = parcelRequire("76ZC2");

var $5W1B8 = parcelRequire("5W1B8");

var $eazuD = parcelRequire("eazuD");
function $332bb2ff89e018d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $332bb2ff89e018d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $332bb2ff89e018d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $332bb2ff89e018d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $332bb2ff89e018d2$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $eazuD.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))) : new (0, $5W1B8.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $76ZC2.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $76ZC2.AllAnalyticsCookies)[name].getKey(), value, $332bb2ff89e018d2$var$_objectSpread($332bb2ff89e018d2$var$_objectSpread({}, (0, $76ZC2.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $eazuD.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $76ZC2.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $76ZC2.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $76ZC2.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $76ZC2.AllAnalyticsCookies)[name].getKey(), $332bb2ff89e018d2$var$_objectSpread({}, options));
    }
}

});
parcelRegister("8Nbse", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === "__proto__") continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    return api;
});

});

parcelRegister("5W1B8", function(module, exports) {

$parcel$export(module.exports, "default", () => $45239bdd0bf0b0f7$export$2e2bcd8739ae039);

var $k4E1V = parcelRequire("k4E1V");
class $45239bdd0bf0b0f7$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $k4E1V.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("k4E1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9d33b7f0c397ca4$export$2e2bcd8739ae039);

var $i1TYg = parcelRequire("i1TYg");

var $4nUvj = parcelRequire("4nUvj");
class $e9d33b7f0c397ca4$export$2e2bcd8739ae039 extends (0, $4nUvj.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $i1TYg.default);
        } catch (err) {
            storageToUse = (0, $i1TYg.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("i1TYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d203bca434220611$export$2e2bcd8739ae039);

var $dmsRJ = parcelRequire("dmsRJ");
// eslint-disable-next-line import/no-anonymous-default-export
const $d203bca434220611$var$inmemorystorage = new (0, $dmsRJ.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d203bca434220611$export$2e2bcd8739ae039 = $d203bca434220611$var$inmemorystorage;

});
parcelRegister("dmsRJ", function(module, exports) {

$parcel$export(module.exports, "InMemoryStore", () => $9ba3b88ab110f193$export$90e3e001bcac59c7);

var $g5Zhu = parcelRequire("g5Zhu");
class $9ba3b88ab110f193$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}

});


parcelRegister("4nUvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $331523f3ba09be90$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $3emEs = parcelRequire("3emEs");

var $i1TYg = parcelRequire("i1TYg");

var $1PvQn = parcelRequire("1PvQn");
const $331523f3ba09be90$export$41c06fdd37b7e9a5 = "awc";
const $331523f3ba09be90$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
class $331523f3ba09be90$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $i1TYg.default) || typeof globalThis === "undefined") return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $1PvQn.isSupported)(globalThis[$331523f3ba09be90$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$331523f3ba09be90$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $i1TYg.default);
                if (!globalThis[$331523f3ba09be90$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$331523f3ba09be90$export$770aa8bc07b3de03] = (0, $i1TYg.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($331523f3ba09be90$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $3emEs.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ((0, $1PvQn.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("1PvQn", function(module, exports) {

$parcel$export(module.exports, "isSupported", () => $1553416620c68347$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1553416620c68347$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("eazuD", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", () => $a50d88109762d9b6$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $a50d88109762d9b6$export$de6821eed3d5f32d);

var $8Nbse = parcelRequire("8Nbse");

var $jk22o = parcelRequire("jk22o");

var $76ZC2 = parcelRequire("76ZC2");
const $a50d88109762d9b6$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $a50d88109762d9b6$export$eb80e1beaa8dacf8 = (0, $76ZC2.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $a50d88109762d9b6$export$19164982d36535d8 = "tld_test";
const $a50d88109762d9b6$export$de6821eed3d5f32d = (0, $jk22o.default)(()=>{
    if (typeof location === "undefined") return "";
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).set($a50d88109762d9b6$export$eb80e1beaa8dacf8, $a50d88109762d9b6$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get($a50d88109762d9b6$export$eb80e1beaa8dacf8) === $a50d88109762d9b6$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).remove($a50d88109762d9b6$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("1lTQd", function(module, exports) {

$parcel$export(module.exports, "MetadataClient", () => $0fc3117ff93bc5f8$export$1ac223ae496131c9);

var $g5Zhu = parcelRequire("g5Zhu");

var $dnnk6 = parcelRequire("dnnk6");

var $8dyB8 = parcelRequire("8dyB8");

var $5fkVL = parcelRequire("5fkVL");

var $hPyCe = parcelRequire("hPyCe");

var $6IUhI = parcelRequire("6IUhI");

var $baTre = parcelRequire("baTre");

var $aIR4t = parcelRequire("aIR4t");

var $5Umcg = parcelRequire("5Umcg");

var $iRiir = parcelRequire("iRiir");

var $gk4LS = parcelRequire("gk4LS");

var $6fRvB = parcelRequire("6fRvB");

var $jN3O4 = parcelRequire("jN3O4");
var $0fc3117ff93bc5f8$var$_MetadataClient;
function $0fc3117ff93bc5f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fc3117ff93bc5f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fc3117ff93bc5f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fc3117ff93bc5f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $0fc3117ff93bc5f8$export$1ac223ae496131c9 {
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ""
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = "PENDING";
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $dnnk6.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? "PRODUCT_HOST" : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $5Umcg.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $5Umcg.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $hPyCe.default)($0fc3117ff93bc5f8$var$_objectSpread($0fc3117ff93bc5f8$var$_objectSpread({}, this._options), {}, {
            waitInterval: (0, $5Umcg.DEFAULT_METADATA_REFRESH_INTERVAL)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $0fc3117ff93bc5f8$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $8dyB8.default)((status)=>{
            if (status === (0, $baTre.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $aIR4t.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $gk4LS.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $5Umcg.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $6fRvB.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = "FETCHED";
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = "FAILED";
            if (error instanceof (0, $iRiir.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = "ServerBusyError";
            else this._lastErrorReason = error instanceof Error && (0, $jN3O4.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : "Unknown";
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $baTre.NetworkStatusEnum).OFFLINE) {
            done((0, $6IUhI.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $6IUhI.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (_unused) {
            done((0, $6IUhI.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $5Umcg.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $5fkVL.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $5fkVL.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $5fkVL.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $5fkVL.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}
$0fc3117ff93bc5f8$var$_MetadataClient = $0fc3117ff93bc5f8$export$1ac223ae496131c9;
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($0fc3117ff93bc5f8$export$1ac223ae496131c9, "INITIAL_REFRESH_DELAY", 1);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($0fc3117ff93bc5f8$export$1ac223ae496131c9, "Factory", (apiHostProtocol, apiHost, product)=>{
    return new $0fc3117ff93bc5f8$var$_MetadataClient(apiHostProtocol, apiHost, product);
});

});
parcelRegister("dnnk6", function(module, exports) {

$parcel$export(module.exports, "isStargateProxyPath", () => $9bcf83df6aa61860$export$83a9dd8d74be72c);

var $dCk84 = parcelRequire("dCk84");
function $9bcf83df6aa61860$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $dCk84.stargateProxyUrl)();
}

});
parcelRegister("dCk84", function(module, exports) {

$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $9e9e703ad8f17d89$export$5df9262e102d0c32);
$parcel$export(module.exports, "stargateProxyUrl", () => $9e9e703ad8f17d89$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $9e9e703ad8f17d89$export$18c0b81944902eae);

var $3emEs = parcelRequire("3emEs");

const $9e9e703ad8f17d89$var$PROD_HOST = "as.atlassian.com/api/v1";
const $9e9e703ad8f17d89$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $9e9e703ad8f17d89$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $9e9e703ad8f17d89$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $9e9e703ad8f17d89$var$FEDRAMP_STAGING_HOST = "as.staging.atl-paas-us-gov-mod.net/api/v1";
const $9e9e703ad8f17d89$var$FEDRAMP_PROD_HOST = "as.atlassian-us-gov-mod.com/api/v1";
const $9e9e703ad8f17d89$var$STARGATE_FEDRAMP_STAGING_HOST = "api.stg.atlassian-us-gov-mod.com/gasv3/api/v1";
const $9e9e703ad8f17d89$var$STARGATE_FEDRAMP_PROD_HOST = "api.atlassian-us-gov-mod.com/gasv3/api/v1";
const $9e9e703ad8f17d89$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $9e9e703ad8f17d89$export$78e02cfb66671ad0() {
    return (typeof window !== "undefined" ? window.location.host : "") + $9e9e703ad8f17d89$export$5df9262e102d0c32;
}
const $9e9e703ad8f17d89$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $3emEs.envType).LOCAL || env === (0, $3emEs.envType).DEV) throw Error("No LOCAL or DEV environments for FedRAMP.");
    if (env === (0, $3emEs.envType).PROD && envOverride) throw Error("Cannot override to FedRAMP Sandbox for Prod.");
    if (!useStargate) return env === (0, $3emEs.envType).PROD ? $9e9e703ad8f17d89$var$FEDRAMP_PROD_HOST : $9e9e703ad8f17d89$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $3emEs.envType).PROD ? $9e9e703ad8f17d89$var$STARGATE_FEDRAMP_PROD_HOST : $9e9e703ad8f17d89$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $9e9e703ad8f17d89$export$78e02cfb66671ad0();
};
const $9e9e703ad8f17d89$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $3emEs.envType).PROD ? $9e9e703ad8f17d89$var$PROD_HOST : $9e9e703ad8f17d89$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $3emEs.envType).PROD ? $9e9e703ad8f17d89$var$STARGATE_PROD_HOST : $9e9e703ad8f17d89$var$STARGATE_STAGING_HOST;
    return $9e9e703ad8f17d89$export$78e02cfb66671ad0();
};
function $9e9e703ad8f17d89$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error("IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.");
        return $9e9e703ad8f17d89$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $3emEs.perimeterType).FEDRAMP_MODERATE) return $9e9e703ad8f17d89$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $9e9e703ad8f17d89$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("aIR4t", function(module, exports) {

$parcel$export(module.exports, "TestSupport", () => $7ce72e4b3f0b06d3$export$44b578549c42d779);

var $g5Zhu = parcelRequire("g5Zhu");
class $7ce72e4b3f0b06d3$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith("__gemini_") && k.endsWith("__")) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($7ce72e4b3f0b06d3$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($7ce72e4b3f0b06d3$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($7ce72e4b3f0b06d3$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($7ce72e4b3f0b06d3$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === "boolean") return value;
        }
        return undefined;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($7ce72e4b3f0b06d3$export$44b578549c42d779, "DISABLE_METADATA_CALLS_PROPERTY", "__awc_disable_metadata_calls__");
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($7ce72e4b3f0b06d3$export$44b578549c42d779, "DISABLE_EVENT_CALLS_PROPERTY", "__awc_disable_event_calls__");
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($7ce72e4b3f0b06d3$export$44b578549c42d779, "DISABLE_FETCH_CALLS_PROPERTY", "__awc_disable_fetch_calls__");
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($7ce72e4b3f0b06d3$export$44b578549c42d779, "SYNTHETIC_FLAG_OVERRIDE_PROPERTY", "__awc_synthetic_flag_override__");

});

parcelRegister("gk4LS", function(module, exports) {

$parcel$export(module.exports, "fetchMetadata", () => $be22370f335bd094$export$55b0d0261469055);

var $g5Zhu = parcelRequire("g5Zhu");

var $jk22o = parcelRequire("jk22o");

var $iRiir = parcelRequire("iRiir");
function $be22370f335bd094$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be22370f335bd094$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be22370f335bd094$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be22370f335bd094$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $be22370f335bd094$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $be22370f335bd094$var$createRequestAbortController(timeout, signal);
    const corsOptions = $be22370f335bd094$var$getCorsForUrl(url);
    const metadataUrl = url + "?" + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ""}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ""}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ""}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ""}`
    }).toString();
    const response = await fetch(metadataUrl, $be22370f335bd094$var$_objectSpread({
        method: "GET",
        signal: requestAbortController.signal
    }, corsOptions));
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $iRiir.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $be22370f335bd094$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener("abort", ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $be22370f335bd094$var$getCorsForUrl = (0, $jk22o.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});

parcelRegister("6fRvB", function(module, exports) {

$parcel$export(module.exports, "MetadataResponse", () => $48dda68494b979aa$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $48dda68494b979aa$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === "string" || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : "";
        return new $48dda68494b979aa$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith("http") ? url : null);
    }
}

});


parcelRegister("jctJE", function(module, exports) {

$parcel$export(module.exports, "isFirstParty", () => $dfa6342339492fd0$export$f56713ced121eb91);

var $3emEs = parcelRequire("3emEs");
const $dfa6342339492fd0$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $3emEs.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("lwRyj", function(module, exports) {

$parcel$export(module.exports, "isThirdParty", () => $fac620836d4f9791$export$ab34f90cc32c8960);

var $3emEs = parcelRequire("3emEs");
const $fac620836d4f9791$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $3emEs.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("kxtNv", function(module, exports) {

$parcel$export(module.exports, "LoggingResponseCallback", () => $ef3e00e2ac227c5c$export$48361b6ed38f1b0);
class $ef3e00e2ac227c5c$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $ef3e00e2ac227c5c$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn("Validation report for event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn("GASv3 submission failed with HTTP Status Code %d: %s", response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn("Event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log("GASv3 submission failed with HTTP Status Code %d: %s", response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug("Event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("iPlmd", function(module, exports) {

$parcel$export(module.exports, "objectValues", () => $db4d8e8d744eef5a$export$ad1854f4a08c15f8);
function $db4d8e8d744eef5a$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("eVN6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $adec7b4637af7cd8$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $3emEs = parcelRequire("3emEs");

var $kS1ye = parcelRequire("kS1ye");
class $adec7b4637af7cd8$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "pendingCleanup", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $3emEs.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $kS1ye.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $kS1ye.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        });
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>"event" in item.msg && item.msg.event === $adec7b4637af7cd8$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch (_unused) {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($adec7b4637af7cd8$export$2e2bcd8739ae039, "messageEvent", "origin landed");

});

parcelRegister("eh3tt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a645592c8bb0e384$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $cXTdp = parcelRequire("cXTdp");

var $6wHwM = parcelRequire("6wHwM");

var $k4E1V = parcelRequire("k4E1V");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $a645592c8bb0e384$var$SESSION_ID_STORAGE_KEY = "session.id";
const $a645592c8bb0e384$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $a645592c8bb0e384$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $a645592c8bb0e384$export$285f6bddd927a06d = 1800000;
const $a645592c8bb0e384$export$a92e915d70316eb2 = 5000;
const $a645592c8bb0e384$export$de43760b2dc10c19 = 0.9;
class $a645592c8bb0e384$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($a645592c8bb0e384$var$SESSION_ID_STORAGE_KEY, newSessionId);
            if ((0, $cXTdp.fg)("awc_session_id_early_exit")) {
                // If session is not valid at this point, something has gone wrong with Local Storage access
                // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
                // gating roll-out of this early exit condition
                const { isValidSession: isValidSession } = this._getCurrentSessionParams();
                if (!isValidSession) return "";
            }
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($a645592c8bb0e384$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $a645592c8bb0e384$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $a645592c8bb0e384$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $a645592c8bb0e384$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $6wHwM.NOOP);
        this._safeLocalStorage = new (0, $k4E1V.default)();
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($a645592c8bb0e384$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($a645592c8bb0e384$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $a645592c8bb0e384$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
   * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
   * read a null value from storage, in which case we will return empty String
   */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
}

});
parcelRegister("cXTdp", function(module, exports) {

$parcel$export(module.exports, "fg", () => $9705d356df7a8858$export$b40ec24ac8275656);

var $5oElz = parcelRequire("5oElz");
function $9705d356df7a8858$export$b40ec24ac8275656(name) {
    return (0, $5oElz.resolveBooleanFlag)(name);
}

});
parcelRegister("5oElz", function(module, exports) {

$parcel$export(module.exports, "resolveBooleanFlag", () => $3ede7db33c4c8c4f$export$6333b6aff9fc6275);

var $5qVaK = parcelRequire("5qVaK");

var $eTt10 = parcelRequire("eTt10");

var $6dYxx = parcelRequire("6dYxx");

var $2g6CI = parcelRequire("2g6CI");

var $2BAnE = parcelRequire("2BAnE");

var $jaJgG = parcelRequire("jaJgG");
var $3ede7db33c4c8c4f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $6dYxx.ENV_ENABLE_PLATFORM_FF) || (0, $2g6CI.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $3ede7db33c4c8c4f$export$6333b6aff9fc6275(flagKey) {
    if ($3ede7db33c4c8c4f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $eTt10.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $jaJgG.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $2BAnE.globalVar)[0, $jaJgG.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $2BAnE.globalVar)[0, $jaJgG.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $5qVaK.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $2BAnE.globalVar)[0, $jaJgG.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("5qVaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f4bbaad80b3930e$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $iQLTC = parcelRequire("iQLTC");

var $4tdHF = parcelRequire("4tdHF");



var $3f4bbaad80b3930e$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $3f4bbaad80b3930e$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$3f4bbaad80b3930e$var$_FeatureGates = $3f4bbaad80b3930e$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "client", new (0, $iQLTC.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$3f4bbaad80b3930e$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $3f4bbaad80b3930e$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $3f4bbaad80b3930e$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$3f4bbaad80b3930e$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $3f4bbaad80b3930e$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $3f4bbaad80b3930e$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "initializeCalled", $3f4bbaad80b3930e$var$_FeatureGates.client.initializeCalled.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "initializeCompleted", $3f4bbaad80b3930e$var$_FeatureGates.client.initializeCompleted.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "waitUntilInitializeCompleted", $3f4bbaad80b3930e$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "initialize", $3f4bbaad80b3930e$var$_FeatureGates.client.initialize.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "initializeWithProvider", $3f4bbaad80b3930e$var$_FeatureGates.client.initializeWithProvider.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "initializeFromValues", $3f4bbaad80b3930e$var$_FeatureGates.client.initializeFromValues.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "manuallyLogGateExposure", $3f4bbaad80b3930e$var$_FeatureGates.client.manuallyLogGateExposure.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getExperiment", $3f4bbaad80b3930e$var$_FeatureGates.client.getExperiment.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "manuallyLogExperimentExposure", $3f4bbaad80b3930e$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "manuallyLogLayerExposure", $3f4bbaad80b3930e$var$_FeatureGates.client.manuallyLogLayerExposure.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "shutdownStatsig", $3f4bbaad80b3930e$var$_FeatureGates.client.shutdownStatsig.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "overrideGate", $3f4bbaad80b3930e$var$_FeatureGates.client.overrideGate.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "clearGateOverride", $3f4bbaad80b3930e$var$_FeatureGates.client.clearGateOverride.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "overrideConfig", $3f4bbaad80b3930e$var$_FeatureGates.client.overrideConfig.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "clearConfigOverride", $3f4bbaad80b3930e$var$_FeatureGates.client.clearConfigOverride.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "setOverrides", $3f4bbaad80b3930e$var$_FeatureGates.client.setOverrides.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getOverrides", $3f4bbaad80b3930e$var$_FeatureGates.client.getOverrides.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "clearAllOverrides", $3f4bbaad80b3930e$var$_FeatureGates.client.clearAllOverrides.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "isCurrentUser", $3f4bbaad80b3930e$var$_FeatureGates.client.isCurrentUser.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "onGateUpdated", $3f4bbaad80b3930e$var$_FeatureGates.client.onGateUpdated.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "onExperimentValueUpdated", $3f4bbaad80b3930e$var$_FeatureGates.client.onExperimentValueUpdated.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "onAnyUpdated", $3f4bbaad80b3930e$var$_FeatureGates.client.onAnyUpdated.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "updateUser", $3f4bbaad80b3930e$var$_FeatureGates.client.updateUser.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "updateUserWithProvider", $3f4bbaad80b3930e$var$_FeatureGates.client.updateUserWithProvider.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "updateUserWithValues", $3f4bbaad80b3930e$var$_FeatureGates.client.updateUserWithValues.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getPackageVersion", $3f4bbaad80b3930e$var$_FeatureGates.client.getPackageVersion.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getTargetApp", $3f4bbaad80b3930e$var$_FeatureGates.client.getTargetApp.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getLayer", $3f4bbaad80b3930e$var$_FeatureGates.client.getLayer.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3f4bbaad80b3930e$var$FeatureGates, "getLayerValue", $3f4bbaad80b3930e$var$_FeatureGates.client.getLayerValue.bind($3f4bbaad80b3930e$var$_FeatureGates.client));
var $3f4bbaad80b3930e$var$boundFGJS = $3f4bbaad80b3930e$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $3f4bbaad80b3930e$var$FeatureGates;
    else {
        var $3f4bbaad80b3930e$var$_boundFGJS, $3f4bbaad80b3930e$var$_boundFGJS$getPackage;
        $3f4bbaad80b3930e$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $3f4bbaad80b3930e$var$boundVersion = (($3f4bbaad80b3930e$var$_boundFGJS = $3f4bbaad80b3930e$var$boundFGJS) === null || $3f4bbaad80b3930e$var$_boundFGJS === void 0 || ($3f4bbaad80b3930e$var$_boundFGJS$getPackage = $3f4bbaad80b3930e$var$_boundFGJS.getPackageVersion) === null || $3f4bbaad80b3930e$var$_boundFGJS$getPackage === void 0 ? void 0 : $3f4bbaad80b3930e$var$_boundFGJS$getPackage.call($3f4bbaad80b3930e$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($3f4bbaad80b3930e$var$boundVersion !== (0, $4tdHF.CLIENT_VERSION)) {
            var $3f4bbaad80b3930e$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($3f4bbaad80b3930e$var$boundVersion, " when module version ").concat((0, $4tdHF.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($3f4bbaad80b3930e$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $3f4bbaad80b3930e$export$2e2bcd8739ae039 = $3f4bbaad80b3930e$var$boundFGJS;

});
parcelRegister("iQLTC", function(module, exports) {

$parcel$export(module.exports, "Client", () => $db923c7c21aa1e32$export$1f2bb630327ac4b6);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $6crSc = parcelRequire("6crSc");

var $2rQTM = parcelRequire("2rQTM");

var $47B1e = parcelRequire("47B1e");

var $4MZpw = parcelRequire("4MZpw");

var $6AmhW = parcelRequire("6AmhW");

var $jVZ0A = parcelRequire("jVZ0A");

var $lRRuc = parcelRequire("lRRuc");

var $ez4gp = parcelRequire("ez4gp");

var $j7vSW = parcelRequire("j7vSW");

var $6NMA1 = parcelRequire("6NMA1");

var $gEc9j = parcelRequire("gEc9j");

var $17EY4 = parcelRequire("17EY4");

var $Clr4q = parcelRequire("Clr4q");

var $117Ap = parcelRequire("117Ap");

var $4tdHF = parcelRequire("4tdHF");
var $db923c7c21aa1e32$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $db923c7c21aa1e32$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db923c7c21aa1e32$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db923c7c21aa1e32$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db923c7c21aa1e32$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $db923c7c21aa1e32$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $db923c7c21aa1e32$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $db923c7c21aa1e32$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $gEc9j.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subscriptions", new (0, $2rQTM.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dataAdapter", new (0, $6NMA1.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $gEc9j.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $ez4gp.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $17EY4.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $ez4gp.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $17EY4.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $4tdHF.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $db923c7c21aa1e32$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $4tdHF.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $117Ap.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $ez4gp.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $17EY4.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $ez4gp.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $lRRuc.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can wait until initialized.");
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $47B1e.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $47B1e.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $6AmhW.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $17EY4.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $17EY4.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $db923c7c21aa1e32$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $lRRuc.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $lRRuc.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $db923c7c21aa1e32$var$_objectSpread($db923c7c21aa1e32$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $j7vSW.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $db923c7c21aa1e32$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $db923c7c21aa1e32$var$_objectSpread($db923c7c21aa1e32$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $db923c7c21aa1e32$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $117Ap.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(newClientOptions, $db923c7c21aa1e32$var$_excluded);
                                frontendUser = (0, $Clr4q.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $jVZ0A.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $db923c7c21aa1e32$var$_objectSpread($db923c7c21aa1e32$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $6crSc.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $6crSc.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $6crSc.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $6crSc.StatsigClient)($db923c7c21aa1e32$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $Clr4q.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $jVZ0A.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $4tdHF.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $4MZpw.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $4MZpw.Layer).fromLayer((0, $6crSc._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("6crSc", function(module, exports) {
"use strict";
var $48397c182e190a62$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $48397c182e190a62$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $48397c182e190a62$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $ec6z6 = parcelRequire("ec6z6");
module.exports.StatsigClient = $ec6z6.default;

$48397c182e190a62$var$__exportStar((parcelRequire("82VcB")), module.exports);
const $48397c182e190a62$var$__STATSIG__ = Object.assign((0, (parcelRequire("82VcB"))._getStatsigGlobal)(), {
    StatsigClient: $ec6z6.default
});
module.exports.default = $48397c182e190a62$var$__STATSIG__;

});
parcelRegister("82VcB", function(module, exports) {
"use strict";
var $5dbae1d228f39a14$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5dbae1d228f39a14$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5dbae1d228f39a14$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("gfCHK")).Diagnostics;
    }
});

var $6GweH = parcelRequire("6GweH");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $6GweH.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("gCtHs")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hGOw7")).Storage;
    }
});

$5dbae1d228f39a14$var$__exportStar((parcelRequire("jYwMq")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("2wvYd")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("lfqHQ")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("9Opl1")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("gfCHK")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("3C11z")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("8sFL5")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("fm4BL")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("jUtD0")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("7F8t1")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("6Nn3q")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("gCtHs")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("hEeEr")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("6a2rM")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("cyDYz")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("6fxpx")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("4mLTS")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("2iKKu")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("j6MqL")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("299Wl")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("ecp1P")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("b2evf")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("6mhv0")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("8v5xV")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("ifozV")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("9iHvo")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("8UnMj")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("9UhWu")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("hGR8j")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("1wcBx")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("5siSQ")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("eztrt")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("hGOw7")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("4GVQd")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("aFFpr")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("kkf8Y")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("eFGgW")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("euONI")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("kfvk4")), module.exports);

$5dbae1d228f39a14$var$__exportStar((parcelRequire("19qao")), module.exports);
Object.assign((0, (parcelRequire("jYwMq"))._getStatsigGlobal)(), {
    Log: (parcelRequire("gCtHs")).Log,
    SDK_VERSION: (parcelRequire("8UnMj")).SDK_VERSION
});

});
parcelRegister("jYwMq", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $e8ad0c60ba9644e4$var$_a, $e8ad0c60ba9644e4$var$_b, $e8ad0c60ba9644e4$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $gCtHs = parcelRequire("gCtHs");
const $e8ad0c60ba9644e4$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== "undefined" ? __STATSIG__ : $e8ad0c60ba9644e4$var$statsigGlobal;
    } catch (e) {
        return $e8ad0c60ba9644e4$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $e8ad0c60ba9644e4$var$_getStatsigGlobal;
const $e8ad0c60ba9644e4$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $e8ad0c60ba9644e4$var$_getStatsigGlobalFlag;
const $e8ad0c60ba9644e4$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $gCtHs.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $e8ad0c60ba9644e4$var$_getInstance;
const $e8ad0c60ba9644e4$var$GLOBAL_KEY = "__STATSIG__";
const $e8ad0c60ba9644e4$var$_window = typeof window !== "undefined" ? window : {};
const $e8ad0c60ba9644e4$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $e8ad0c60ba9644e4$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $e8ad0c60ba9644e4$var$statsigGlobal = ($e8ad0c60ba9644e4$var$_c = ($e8ad0c60ba9644e4$var$_b = ($e8ad0c60ba9644e4$var$_a = $e8ad0c60ba9644e4$var$_window[$e8ad0c60ba9644e4$var$GLOBAL_KEY]) !== null && $e8ad0c60ba9644e4$var$_a !== void 0 ? $e8ad0c60ba9644e4$var$_a : $e8ad0c60ba9644e4$var$_global[$e8ad0c60ba9644e4$var$GLOBAL_KEY]) !== null && $e8ad0c60ba9644e4$var$_b !== void 0 ? $e8ad0c60ba9644e4$var$_b : $e8ad0c60ba9644e4$var$_globalThis[$e8ad0c60ba9644e4$var$GLOBAL_KEY]) !== null && $e8ad0c60ba9644e4$var$_c !== void 0 ? $e8ad0c60ba9644e4$var$_c : {
    instance: module.exports._getInstance
};
$e8ad0c60ba9644e4$var$_window[$e8ad0c60ba9644e4$var$GLOBAL_KEY] = $e8ad0c60ba9644e4$var$statsigGlobal;
$e8ad0c60ba9644e4$var$_global[$e8ad0c60ba9644e4$var$GLOBAL_KEY] = $e8ad0c60ba9644e4$var$statsigGlobal;
$e8ad0c60ba9644e4$var$_globalThis[$e8ad0c60ba9644e4$var$GLOBAL_KEY] = $e8ad0c60ba9644e4$var$statsigGlobal;

});
parcelRegister("gCtHs", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $c1973bbe35ce43ba$var$DEBUG = " DEBUG ";
const $c1973bbe35ce43ba$var$_INFO = "  INFO ";
const $c1973bbe35ce43ba$var$_WARN = "  WARN ";
const $c1973bbe35ce43ba$var$ERROR = " ERROR ";
function $c1973bbe35ce43ba$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $c1973bbe35ce43ba$var$Log {
    static info(...args) {
        if ($c1973bbe35ce43ba$var$Log.level >= module.exports.LogLevel.Info) console.info($c1973bbe35ce43ba$var$_INFO, ...$c1973bbe35ce43ba$var$addTag(args));
    }
    static debug(...args) {
        if ($c1973bbe35ce43ba$var$Log.level >= module.exports.LogLevel.Debug) console.debug($c1973bbe35ce43ba$var$DEBUG, ...$c1973bbe35ce43ba$var$addTag(args));
    }
    static warn(...args) {
        if ($c1973bbe35ce43ba$var$Log.level >= module.exports.LogLevel.Warn) console.warn($c1973bbe35ce43ba$var$_WARN, ...$c1973bbe35ce43ba$var$addTag(args));
    }
    static error(...args) {
        if ($c1973bbe35ce43ba$var$Log.level >= module.exports.LogLevel.Error) console.error($c1973bbe35ce43ba$var$ERROR, ...$c1973bbe35ce43ba$var$addTag(args));
    }
}
module.exports.Log = $c1973bbe35ce43ba$var$Log;
$c1973bbe35ce43ba$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("gfCHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $bd4c11f725ec4bd8$var$MARKER_MAP = new Map();
const $bd4c11f725ec4bd8$var$ACT_START = "start";
const $bd4c11f725ec4bd8$var$ACT_END = "end";
const $bd4c11f725ec4bd8$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $bd4c11f725ec4bd8$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $bd4c11f725ec4bd8$var$_addMarker(sdkKey, $bd4c11f725ec4bd8$var$_createMarker({}, $bd4c11f725ec4bd8$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $bd4c11f725ec4bd8$var$_addMarker(sdkKey, $bd4c11f725ec4bd8$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $bd4c11f725ec4bd8$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $bd4c11f725ec4bd8$var$_addMarker(sdkKey, $bd4c11f725ec4bd8$var$_createMarker(data, $bd4c11f725ec4bd8$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $bd4c11f725ec4bd8$var$_addMarker(sdkKey, $bd4c11f725ec4bd8$var$_createMarker(data, $bd4c11f725ec4bd8$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $bd4c11f725ec4bd8$var$_addMarker(sdkKey, $bd4c11f725ec4bd8$var$_createMarker({}, $bd4c11f725ec4bd8$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $bd4c11f725ec4bd8$var$_addMarker(sdkKey, $bd4c11f725ec4bd8$var$_createMarker(data, $bd4c11f725ec4bd8$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $bd4c11f725ec4bd8$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $bd4c11f725ec4bd8$var$_safeGetField(e, "code"),
            name: $bd4c11f725ec4bd8$var$_safeGetField(e, "name"),
            message: $bd4c11f725ec4bd8$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $bd4c11f725ec4bd8$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $bd4c11f725ec4bd8$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $bd4c11f725ec4bd8$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $bd4c11f725ec4bd8$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $bd4c11f725ec4bd8$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $bd4c11f725ec4bd8$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $bd4c11f725ec4bd8$var$MARKER_MAP.set(sdkKey, markers);
}
function $bd4c11f725ec4bd8$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("6GweH", function(module, exports) {
"use strict";
var $4ddfabbfb8b8a3e2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $2wvYd = parcelRequire("2wvYd");

var $7F8t1 = parcelRequire("7F8t1");

var $gCtHs = parcelRequire("gCtHs");

var $6a2rM = parcelRequire("6a2rM");

var $2iKKu = parcelRequire("2iKKu");

var $9iHvo = parcelRequire("9iHvo");

var $9UhWu = parcelRequire("9UhWu");

var $hGOw7 = parcelRequire("hGOw7");

var $kkf8Y = parcelRequire("kkf8Y");

var $euONI = parcelRequire("euONI");
const $4ddfabbfb8b8a3e2$var$DEFAULT_QUEUE_SIZE = 100;
const $4ddfabbfb8b8a3e2$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $4ddfabbfb8b8a3e2$var$MAX_DEDUPER_KEYS = 1000;
const $4ddfabbfb8b8a3e2$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $4ddfabbfb8b8a3e2$var$MAX_FAILED_LOGS = 500;
const $4ddfabbfb8b8a3e2$var$QUICK_FLUSH_WINDOW_MS = 200;
const $4ddfabbfb8b8a3e2$var$EVENT_LOGGER_MAP = {};
class $4ddfabbfb8b8a3e2$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $4ddfabbfb8b8a3e2$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $4ddfabbfb8b8a3e2$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $9UhWu.LoggingEnabledOption.disabled : $9UhWu.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $gCtHs.Log.warn("Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.");
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $4ddfabbfb8b8a3e2$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $kkf8Y.UrlConfiguration($6a2rM.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === "disabled" && loggingEnabled !== "disabled") {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $hGOw7._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $hGOw7.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $4ddfabbfb8b8a3e2$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $2iKKu._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always") return;
        $4ddfabbfb8b8a3e2$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $euONI._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $4ddfabbfb8b8a3e2$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $4ddfabbfb8b8a3e2$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $4ddfabbfb8b8a3e2$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $4ddfabbfb8b8a3e2$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $4ddfabbfb8b8a3e2$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $4ddfabbfb8b8a3e2$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$4ddfabbfb8b8a3e2$var$EventLogger._safeFlushAndForget(this._sdkKey), $4ddfabbfb8b8a3e2$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always" && (0, $2iKKu._isServerEnv)()) return false;
        if (!(0, $9iHvo._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $2wvYd._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $4ddfabbfb8b8a3e2$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $4ddfabbfb8b8a3e2$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $4ddfabbfb8b8a3e2$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === "disabled") {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $euONI._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $gCtHs.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $gCtHs.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $4ddfabbfb8b8a3e2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$6a2rM.NetworkParam.EventCount]: String(events.length)
            },
            credentials: "same-origin"
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $4ddfabbfb8b8a3e2$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $hGOw7._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $gCtHs.Log.warn("Unable to save failed logs to storage");
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $hGOw7._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$4ddfabbfb8b8a3e2$var$__awaiter(this, void 0, void 0, function*() {
                if (!$hGOw7.Storage.isReady()) yield $hGOw7.Storage.isReadyResolver();
                const events = (0, $hGOw7._getObjectFromStorage)(storageKey);
                if (!events) return;
                $hGOw7.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $gCtHs.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $7F8t1._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $gCtHs.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $2iKKu._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $4ddfabbfb8b8a3e2$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $4ddfabbfb8b8a3e2$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $4ddfabbfb8b8a3e2$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $4ddfabbfb8b8a3e2$var$EventLogger;

});
parcelRegister("2wvYd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $7F8t1 = parcelRequire("7F8t1");
function $1d675e90fb62b438$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $7F8t1._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $1d675e90fb62b438$var$_getUserStorageKey;
function $1d675e90fb62b438$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $1d675e90fb62b438$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $7F8t1._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $1d675e90fb62b438$var$_getStorageKey;

});
parcelRegister("7F8t1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $aFFpr = parcelRequire("aFFpr");
const $5942ee1d5df5611b$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $5942ee1d5df5611b$var$_DJB2;
const $5942ee1d5df5611b$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $5942ee1d5df5611b$var$_DJB2Object;
const $5942ee1d5df5611b$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $aFFpr._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $5942ee1d5df5611b$var$_getSortedObject;

});
parcelRegister("aFFpr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $7c4ddac56d30ef85$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $7c4ddac56d30ef85$var$_typeOf;
function $7c4ddac56d30ef85$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : x === null ? "null" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $7c4ddac56d30ef85$var$_isTypeMatch;

});



parcelRegister("6a2rM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("2iKKu", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $1ad18693feb8f4be$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $1ad18693feb8f4be$var$_getWindowSafe;
const $1ad18693feb8f4be$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $1ad18693feb8f4be$var$_getDocumentSafe;
const $1ad18693feb8f4be$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $1ad18693feb8f4be$var$_isServerEnv;
const $1ad18693feb8f4be$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $1ad18693feb8f4be$var$_addWindowEventListenerSafe;
const $1ad18693feb8f4be$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $1ad18693feb8f4be$var$_addDocumentEventListenerSafe;
const $1ad18693feb8f4be$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $1ad18693feb8f4be$var$_getCurrentPageUrlSafe;
const $1ad18693feb8f4be$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return "beforeunload";
    const eventType = "onpagehide" in win ? "pagehide" : "beforeunload";
    return eventType;
};
module.exports._getUnloadEvent = $1ad18693feb8f4be$var$_getUnloadEvent;

});

parcelRegister("9iHvo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $6c578aba530a6738$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $6c578aba530a6738$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $6c578aba530a6738$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $6c578aba530a6738$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $6c578aba530a6738$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $6c578aba530a6738$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $6c578aba530a6738$var$GATE_EXPOSURE_NAME || eventName === $6c578aba530a6738$var$CONFIG_EXPOSURE_NAME || eventName === $6c578aba530a6738$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $6c578aba530a6738$var$_isExposureEvent;
const $6c578aba530a6738$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $6c578aba530a6738$var$_createExposure($6c578aba530a6738$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $6c578aba530a6738$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $6c578aba530a6738$var$_createGateExposure;
function $6c578aba530a6738$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $6c578aba530a6738$var$_mapExposures;
const $6c578aba530a6738$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $6c578aba530a6738$var$_createExposure($6c578aba530a6738$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $6c578aba530a6738$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $6c578aba530a6738$var$_createConfigExposure;
const $6c578aba530a6738$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $6c578aba530a6738$var$_createExposure($6c578aba530a6738$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $6c578aba530a6738$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $6c578aba530a6738$var$_createLayerParameterExposure;
const $6c578aba530a6738$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("9UhWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: "d",
    /** Compress request bodies unless a network proxy is configured */ Enabled: "e",
    /** Always compress request bodies, even when a proxy is configured */ Forced: "f"
};
module.exports.LoggingEnabledOption = {
    disabled: "disabled",
    browserOnly: "browser-only",
    always: "always"
};

});

parcelRegister("hGOw7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $gCtHs = parcelRequire("gCtHs");

var $2iKKu = parcelRequire("2iKKu");
const $ce0d8b8630ba13be$var$inMemoryStore = {};
const $ce0d8b8630ba13be$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$ce0d8b8630ba13be$var$inMemoryStore[key] ? $ce0d8b8630ba13be$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $ce0d8b8630ba13be$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $ce0d8b8630ba13be$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($ce0d8b8630ba13be$var$inMemoryStore)
};
let $ce0d8b8630ba13be$var$_localStorageProvider = null;
try {
    const win = (0, $2iKKu._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $ce0d8b8630ba13be$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $gCtHs.Log.warn("Failed to setup localStorageProvider.");
}
let $ce0d8b8630ba13be$var$_main = $ce0d8b8630ba13be$var$_localStorageProvider !== null && $ce0d8b8630ba13be$var$_localStorageProvider !== void 0 ? $ce0d8b8630ba13be$var$_localStorageProvider : $ce0d8b8630ba13be$var$_inMemoryProvider;
let $ce0d8b8630ba13be$var$_current = $ce0d8b8630ba13be$var$_main;
function $ce0d8b8630ba13be$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($ce0d8b8630ba13be$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$ce0d8b8630ba13be$var$_current.isReady(),
    isReadyResolver: ()=>$ce0d8b8630ba13be$var$_current.isReadyResolver(),
    getProviderName: ()=>$ce0d8b8630ba13be$var$_current.getProviderName(),
    getItem: (key)=>$ce0d8b8630ba13be$var$_inMemoryBreaker(()=>$ce0d8b8630ba13be$var$_current.getItem(key)),
    setItem: (key, value)=>$ce0d8b8630ba13be$var$_inMemoryBreaker(()=>$ce0d8b8630ba13be$var$_current.setItem(key, value)),
    removeItem: (key)=>$ce0d8b8630ba13be$var$_current.removeItem(key),
    getAllKeys: ()=>$ce0d8b8630ba13be$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $ce0d8b8630ba13be$var$_main = newProvider;
        $ce0d8b8630ba13be$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $ce0d8b8630ba13be$var$_current = $ce0d8b8630ba13be$var$_inMemoryProvider;
        else $ce0d8b8630ba13be$var$_current = $ce0d8b8630ba13be$var$_main;
    }
};
function $ce0d8b8630ba13be$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : "null");
    } catch (e) {
        $gCtHs.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $ce0d8b8630ba13be$var$_getObjectFromStorage;
function $ce0d8b8630ba13be$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $ce0d8b8630ba13be$var$_setObjectInStorage;

});

parcelRegister("kkf8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $7F8t1 = parcelRequire("7F8t1");

var $6a2rM = parcelRequire("6a2rM");
const $ecc16c1e6ddd3931$var$ENDPOINT_DNS_KEY_MAP = {
    [$6a2rM.Endpoint._initialize]: "i",
    [$6a2rM.Endpoint._rgstr]: "e",
    [$6a2rM.Endpoint._download_config_specs]: "d"
};
class $ecc16c1e6ddd3931$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $ecc16c1e6ddd3931$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $6a2rM.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(",");
        return (0, $7F8t1._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $ecc16c1e6ddd3931$var$UrlConfiguration;

});

parcelRegister("euONI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $2iKKu = parcelRequire("2iKKu");
const $a8db46099d7e1ebe$var$FOREGROUND = "foreground";
const $a8db46099d7e1ebe$var$BACKGROUND = "background";
const $a8db46099d7e1ebe$var$LISTENERS = [];
let $a8db46099d7e1ebe$var$current = $a8db46099d7e1ebe$var$FOREGROUND;
let $a8db46099d7e1ebe$var$isUnloading = false;
const $a8db46099d7e1ebe$var$_isCurrentlyVisible = ()=>{
    return $a8db46099d7e1ebe$var$current === $a8db46099d7e1ebe$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $a8db46099d7e1ebe$var$_isCurrentlyVisible;
const $a8db46099d7e1ebe$var$_isUnloading = ()=>$a8db46099d7e1ebe$var$isUnloading;
module.exports._isUnloading = $a8db46099d7e1ebe$var$_isUnloading;
const $a8db46099d7e1ebe$var$_subscribeToVisiblityChanged = (listener)=>{
    $a8db46099d7e1ebe$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $a8db46099d7e1ebe$var$_subscribeToVisiblityChanged;
const $a8db46099d7e1ebe$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $a8db46099d7e1ebe$var$current) return;
    $a8db46099d7e1ebe$var$current = visibility;
    $a8db46099d7e1ebe$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $a8db46099d7e1ebe$var$_notifyVisibilityChanged;
(0, $2iKKu._addWindowEventListenerSafe)("focus", ()=>{
    $a8db46099d7e1ebe$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($a8db46099d7e1ebe$var$FOREGROUND);
});
(0, $2iKKu._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($a8db46099d7e1ebe$var$BACKGROUND));
(0, $2iKKu._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $a8db46099d7e1ebe$var$FOREGROUND : $a8db46099d7e1ebe$var$BACKGROUND);
});
(0, $2iKKu._addWindowEventListenerSafe)((0, $2iKKu._getUnloadEvent)(), ()=>{
    $a8db46099d7e1ebe$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($a8db46099d7e1ebe$var$BACKGROUND);
});

});


parcelRegister("8UnMj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.30.2";
let $67c5ff8b291c99de$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$67c5ff8b291c99de$var$metadata,
    add: (additions)=>{
        $67c5ff8b291c99de$var$metadata = Object.assign(Object.assign({}, $67c5ff8b291c99de$var$metadata), additions);
    }
};

});

parcelRegister("lfqHQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9Opl1", function(module, exports) {
"use strict";
var $724c70306fba8fce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $gCtHs = parcelRequire("gCtHs");

var $b2evf = parcelRequire("b2evf");

var $eztrt = parcelRequire("eztrt");

var $hGOw7 = parcelRequire("hGOw7");

var $4GVQd = parcelRequire("4GVQd");
const $724c70306fba8fce$var$CACHE_LIMIT = 10;
const $724c70306fba8fce$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $724c70306fba8fce$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $724c70306fba8fce$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $724c70306fba8fce$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $eztrt._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $eztrt._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $724c70306fba8fce$var$_makeDataAdapterResult("Bootstrap", data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $b2evf.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $724c70306fba8fce$var$__awaiter(this, void 0, void 0, function*() {
            if (!$hGOw7.Storage.isReady()) yield $hGOw7.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $gCtHs.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $724c70306fba8fce$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $eztrt._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $724c70306fba8fce$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $gCtHs.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $4GVQd._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $b2evf.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $724c70306fba8fce$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $724c70306fba8fce$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $gCtHs.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $hGOw7.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($hGOw7.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $4GVQd._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $724c70306fba8fce$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $hGOw7.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes("QuotaExceededError") || error.toString().includes("QUOTA_EXCEEDED_ERR")) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $hGOw7._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $724c70306fba8fce$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $hGOw7.Storage.removeItem(evictable);
        }
        (0, $hGOw7._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $724c70306fba8fce$var$DataAdapterCore;
function $724c70306fba8fce$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $eztrt._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $724c70306fba8fce$var$_makeDataAdapterResult;
class $724c70306fba8fce$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $gCtHs.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $724c70306fba8fce$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $724c70306fba8fce$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === "object" && typeof valueB === "object") return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("b2evf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $2wvYd = parcelRequire("2wvYd");

var $gCtHs = parcelRequire("gCtHs");

var $2iKKu = parcelRequire("2iKKu");

var $hGOw7 = parcelRequire("hGOw7");

var $eFGgW = parcelRequire("eFGgW");
const $808b219f38ad4efd$var$PROMISE_MAP = {};
const $808b219f38ad4efd$var$COOKIE_ENABLED_MAP = {};
const $808b219f38ad4efd$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($808b219f38ad4efd$var$DISABLED_MAP[sdkKey]) return null;
        if ($808b219f38ad4efd$var$PROMISE_MAP[sdkKey] != null) return $808b219f38ad4efd$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $808b219f38ad4efd$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $808b219f38ad4efd$var$PROMISE_MAP[sdkKey] = stableID;
            $808b219f38ad4efd$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $808b219f38ad4efd$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $eFGgW.getUUID)();
        $808b219f38ad4efd$var$_persistToStorage(stableID, sdkKey);
        $808b219f38ad4efd$var$_persistToCookie(stableID, sdkKey);
        $808b219f38ad4efd$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $808b219f38ad4efd$var$PROMISE_MAP[sdkKey] = override;
        $808b219f38ad4efd$var$_persistToStorage(override, sdkKey);
        $808b219f38ad4efd$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $808b219f38ad4efd$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $808b219f38ad4efd$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $808b219f38ad4efd$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $2wvYd._getStorageKey)(sdkKey)}`;
}
function $808b219f38ad4efd$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $808b219f38ad4efd$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $hGOw7._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $gCtHs.Log.warn("Failed to save StableID to storage");
    }
}
function $808b219f38ad4efd$var$_loadFromStorage(sdkKey) {
    const storageKey = $808b219f38ad4efd$var$_getStableIDStorageKey(sdkKey);
    return (0, $hGOw7._getObjectFromStorage)(storageKey);
}
function $808b219f38ad4efd$var$_loadFromCookie(sdkKey) {
    if (!$808b219f38ad4efd$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $2iKKu._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split("=");
        if (key === $808b219f38ad4efd$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $808b219f38ad4efd$var$_persistToCookie(stableID, sdkKey) {
    if (!$808b219f38ad4efd$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $2iKKu._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$808b219f38ad4efd$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $808b219f38ad4efd$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $2wvYd._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $808b219f38ad4efd$var$getCookieName;

});
parcelRegister("eFGgW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $aae5af6bab7de4ba$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $aae5af6bab7de4ba$var$getUUID;

});


parcelRegister("eztrt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $7F8t1 = parcelRequire("7F8t1");

var $gCtHs = parcelRequire("gCtHs");
function $a9bb2c304501d266$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $gCtHs.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $a9bb2c304501d266$var$_normalizeUser;
function $a9bb2c304501d266$var$_getFullUserHash(user) {
    return user ? (0, $7F8t1._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $a9bb2c304501d266$var$_getFullUserHash;

});

parcelRegister("4GVQd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $gCtHs = parcelRequire("gCtHs");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $36a7f3b2cf6b08d3$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $gCtHs.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $36a7f3b2cf6b08d3$var$_typedJsonParse;

});


parcelRegister("3C11z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8sFL5", function(module, exports) {
"use strict";
var $6291549e3968c07e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $gCtHs = parcelRequire("gCtHs");

var $j6MqL = parcelRequire("j6MqL");

var $8UnMj = parcelRequire("8UnMj");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $6291549e3968c07e$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $6291549e3968c07e$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $6291549e3968c07e$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $6291549e3968c07e$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $gCtHs.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$6291549e3968c07e$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($6291549e3968c07e$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $6291549e3968c07e$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $j6MqL.SDKType._get(this._sdkKey);
                    const statsigMetadata = $8UnMj.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $6291549e3968c07e$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $6291549e3968c07e$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $6291549e3968c07e$var$ErrorBoundary;
function $6291549e3968c07e$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $6291549e3968c07e$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $6291549e3968c07e$var$UNKNOWN_ERROR;
    }
}
function $6291549e3968c07e$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $6291549e3968c07e$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case "number":
            case "bigint":
            case "boolean":
                loggingCopy[String(option)] = value;
                break;
            case "string":
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = "set";
                break;
            case "object":
                if (option === "environment") loggingCopy["environment"] = value;
                else if (option === "networkConfig") loggingCopy["networkConfig"] = value;
                else loggingCopy[String(option)] = value != null ? "set" : "unset";
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("j6MqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $de94253108db44c2$var$SDK_CLIENT = {};
let $de94253108db44c2$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $de94253108db44c2$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($de94253108db44c2$var$suffix !== null && $de94253108db44c2$var$suffix !== void 0 ? $de94253108db44c2$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $de94253108db44c2$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$de94253108db44c2$var$suffix || $de94253108db44c2$var$suffix === "-react") $de94253108db44c2$var$suffix = "-" + binding;
    }
};

});


parcelRegister("fm4BL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jUtD0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6Nn3q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hEeEr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _configList: "cl",
    _layer: "l",
    _paramStore: "p"
};
const $cd91898d71b17ca4$var$EXIST_KEYS = new Set([]);
const $cd91898d71b17ca4$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $cd91898d71b17ca4$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($cd91898d71b17ca4$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($cd91898d71b17ca4$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $cd91898d71b17ca4$var$createMemoKey;

});

parcelRegister("cyDYz", function(module, exports) {
"use strict";
var $9247ab622f26a55f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $jYwMq = parcelRequire("jYwMq");

var $jYwMq = parcelRequire("jYwMq");

var $gfCHK = parcelRequire("gfCHK");

var $gCtHs = parcelRequire("gCtHs");

var $6a2rM = parcelRequire("6a2rM");

var $34ZHP = parcelRequire("34ZHP");

var $19qao = parcelRequire("19qao");

var $j6MqL = parcelRequire("j6MqL");

var $2iKKu = parcelRequire("2iKKu");

var $299Wl = parcelRequire("299Wl");

var $b2evf = parcelRequire("b2evf");

var $8v5xV = parcelRequire("8v5xV");

var $8UnMj = parcelRequire("8UnMj");

var $9UhWu = parcelRequire("9UhWu");

var $euONI = parcelRequire("euONI");
const $9247ab622f26a55f$var$DEFAULT_TIMEOUT_MS = 10000;
const $9247ab622f26a55f$var$BACKOFF_BASE_MS = 500;
const $9247ab622f26a55f$var$BACKOFF_MAX_MS = 30000;
const $9247ab622f26a55f$var$RATE_LIMIT_WINDOW_MS = 1000;
const $9247ab622f26a55f$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $9247ab622f26a55f$var$LEAK_RATE = $9247ab622f26a55f$var$RATE_LIMIT_MAX_REQ_COUNT / $9247ab622f26a55f$var$RATE_LIMIT_WINDOW_MS;
const $9247ab622f26a55f$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $9247ab622f26a55f$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $9247ab622f26a55f$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $34ZHP.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$9247ab622f26a55f$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs("POST", args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $9247ab622f26a55f$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $9247ab622f26a55f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$9247ab622f26a55f$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $gCtHs.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $euONI._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $9247ab622f26a55f$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $9247ab622f26a55f$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $9247ab622f26a55f$var$_getErrorMessage(error);
                const timedOut = $9247ab622f26a55f$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "", reqTimedOut);
                $9247ab622f26a55f$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$9247ab622f26a55f$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $8v5xV.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $gCtHs.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $9247ab622f26a55f$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $9UhWu.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $9UhWu.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $9247ab622f26a55f$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $9247ab622f26a55f$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $6a2rM.Endpoint._initialize || args.urlConfig.endpoint === $6a2rM.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$6a2rM.NetworkParam.SdkKey]: args.sdkKey,
            [$6a2rM.NetworkParam.SdkType]: $j6MqL.SDKType._get(args.sdkKey),
            [$6a2rM.NetworkParam.SdkVersion]: $8UnMj.SDK_VERSION,
            [$6a2rM.NetworkParam.Time]: String(Date.now()),
            [$6a2rM.NetworkParam.SessionID]: $299Wl.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join("&");
        return `${url}${query ? `?${query}` : ""}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $2iKKu._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $jYwMq._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$6a2rM.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $gCtHs.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $9247ab622f26a55f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== "string" || !$9247ab622f26a55f$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($gCtHs.Log.error);
                writer.close().catch($gCtHs.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$6a2rM.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $gCtHs.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $9247ab622f26a55f$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $9247ab622f26a55f$var$NetworkCore;
const $9247ab622f26a55f$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $gCtHs.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $9247ab622f26a55f$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $b2evf.StableID.get(sdkKey);
    const sessionID = $299Wl.SessionID.get(sdkKey);
    const sdkType = $j6MqL.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $8UnMj.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $9247ab622f26a55f$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $jYwMq._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $19qao.SDKFlags.get(args.sdkKey, "enable_log_event_compression") === true;
    switch(options.logEventCompressionMode){
        case $9UhWu.LogEventCompressionMode.Disabled:
            return false;
        case $9UhWu.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $9UhWu.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $9247ab622f26a55f$var$_getErrorMessage(error) {
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $9247ab622f26a55f$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes("Timeout"); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $9247ab622f26a55f$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $6a2rM.Endpoint._initialize) return;
    $gfCHK.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $9247ab622f26a55f$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $6a2rM.Endpoint._initialize) return;
    $gfCHK.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $gfCHK.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $9247ab622f26a55f$var$_exponentialBackoff(attempt) {
    return $9247ab622f26a55f$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($9247ab622f26a55f$var$BACKOFF_BASE_MS * (attempt * attempt), $9247ab622f26a55f$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("34ZHP", function(module, exports) {
"use strict";
var $23e19c5601c94f8c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $cIeBF = parcelRequire("cIeBF");

var $7F8t1 = parcelRequire("7F8t1");

var $gCtHs = parcelRequire("gCtHs");

var $hGOw7 = parcelRequire("hGOw7");
const $23e19c5601c94f8c$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $23e19c5601c94f8c$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $23e19c5601c94f8c$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $23e19c5601c94f8c$var$DEFAULT_TTL_MS;
        $23e19c5601c94f8c$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $23e19c5601c94f8c$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $23e19c5601c94f8c$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $23e19c5601c94f8c$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$23e19c5601c94f8c$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $23e19c5601c94f8c$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $23e19c5601c94f8c$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $23e19c5601c94f8c$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $23e19c5601c94f8c$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $cIeBF._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $23e19c5601c94f8c$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $23e19c5601c94f8c$var$NetworkFallbackResolver;
function $23e19c5601c94f8c$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $23e19c5601c94f8c$var$_isDomainFailure;
function $23e19c5601c94f8c$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $7F8t1._DJB2)(sdkKey)}`;
}
function $23e19c5601c94f8c$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $23e19c5601c94f8c$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $hGOw7.Storage.removeItem(hashKey);
        return;
    }
    $hGOw7.Storage.setItem(hashKey, JSON.stringify(info));
}
function $23e19c5601c94f8c$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $23e19c5601c94f8c$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $hGOw7.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $gCtHs.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $23e19c5601c94f8c$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("cIeBF", function(module, exports) {
"use strict";
var $9414ecac04d7427c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $9414ecac04d7427c$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $9414ecac04d7427c$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $9414ecac04d7427c$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $9414ecac04d7427c$var$MAX_START_LOOKUP = 200;
function $9414ecac04d7427c$var$_fetchTxtRecords(networkFunc) {
    return $9414ecac04d7427c$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($9414ecac04d7427c$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $9414ecac04d7427c$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $9414ecac04d7427c$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $9414ecac04d7427c$var$_fetchTxtRecords;
function $9414ecac04d7427c$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $9414ecac04d7427c$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $9414ecac04d7427c$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("19qao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $0d6aede194f19fd1$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $0d6aede194f19fd1$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $0d6aede194f19fd1$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("299Wl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $jYwMq = parcelRequire("jYwMq");

var $2wvYd = parcelRequire("2wvYd");

var $gCtHs = parcelRequire("gCtHs");

var $hGOw7 = parcelRequire("hGOw7");

var $eFGgW = parcelRequire("eFGgW");
const $190421e849459381$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $190421e849459381$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $190421e849459381$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($190421e849459381$var$PROMISE_MAP[sdkKey] == null) $190421e849459381$var$PROMISE_MAP[sdkKey] = $190421e849459381$var$_loadSession(sdkKey);
        const session = $190421e849459381$var$PROMISE_MAP[sdkKey];
        return $190421e849459381$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $190421e849459381$var$PROMISE_MAP[sdkKey] = $190421e849459381$var$_overrideSessionId(override, sdkKey);
    }
};
function $190421e849459381$var$_loadSession(sdkKey) {
    let data = $190421e849459381$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $eFGgW.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $190421e849459381$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $190421e849459381$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($190421e849459381$var$_isIdle(data) || $190421e849459381$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $eFGgW.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }
    data.lastUpdate = now;
    $190421e849459381$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $190421e849459381$var$_createSessionTimeout(sdkKey, $190421e849459381$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $190421e849459381$var$_createSessionTimeout(sdkKey, $190421e849459381$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $190421e849459381$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $jYwMq._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $190421e849459381$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $190421e849459381$var$MAX_SESSION_IDLE_TIME;
}
function $190421e849459381$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $190421e849459381$var$MAX_SESSION_AGE;
}
function $190421e849459381$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $2wvYd._getStorageKey)(sdkKey)}`;
}
function $190421e849459381$var$_persistToStorage(session, sdkKey) {
    const storageKey = $190421e849459381$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $hGOw7._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $gCtHs.Log.warn("Failed to save SessionID");
    }
}
function $190421e849459381$var$_loadFromStorage(sdkKey) {
    const storageKey = $190421e849459381$var$_getSessionIDStorageKey(sdkKey);
    return (0, $hGOw7._getObjectFromStorage)(storageKey);
}

});

parcelRegister("8v5xV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("6fxpx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4mLTS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ecp1P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $a56599d66daf7f1f$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $a56599d66daf7f1f$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $a56599d66daf7f1f$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === "object" && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $a56599d66daf7f1f$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $a56599d66daf7f1f$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $a56599d66daf7f1f$var$_fastApproxSizeOf;

});

parcelRegister("6mhv0", function(module, exports) {
"use strict";
var $4a125f19ba75fc97$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $jYwMq = parcelRequire("jYwMq");

var $jYwMq = parcelRequire("jYwMq");

var $8sFL5 = parcelRequire("8sFL5");

var $6GweH = parcelRequire("6GweH");

var $gCtHs = parcelRequire("gCtHs");

var $hEeEr = parcelRequire("hEeEr");

var $2iKKu = parcelRequire("2iKKu");

var $299Wl = parcelRequire("299Wl");

var $b2evf = parcelRequire("b2evf");

var $9UhWu = parcelRequire("9UhWu");

var $hGOw7 = parcelRequire("hGOw7");
const $4a125f19ba75fc97$var$MAX_MEMO_CACHE_SIZE = 3000;
class $4a125f19ba75fc97$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($gCtHs.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $hGOw7.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $299Wl.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $hGOw7.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $b2evf.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $b2evf.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $6GweH.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $8sFL5.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $hGOw7.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError("OA::loadFromStorage", e));
        this._primeReadyRipcord();
        $4a125f19ba75fc97$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? "disabled" : "browser-only");
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $hGOw7.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $b2evf.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($9UhWu.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $4a125f19ba75fc97$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $gCtHs.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $hEeEr.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $4a125f19ba75fc97$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $4a125f19ba75fc97$var$StatsigClientBase;
function $4a125f19ba75fc97$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $2iKKu._isServerEnv)()) return;
    const statsigGlobal = (0, $jYwMq._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $gCtHs.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("ifozV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("hGR8j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1wcBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $gCtHs = parcelRequire("gCtHs");

var $aFFpr = parcelRequire("aFFpr");
function $11b28e9684f06030$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : "",
        __evaluation: evaluation,
        value: value
    };
}
function $11b28e9684f06030$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $11b28e9684f06030$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $11b28e9684f06030$var$_makeFeatureGate;
function $11b28e9684f06030$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $11b28e9684f06030$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $11b28e9684f06030$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $11b28e9684f06030$var$_makeDynamicConfig;
function $11b28e9684f06030$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $11b28e9684f06030$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $11b28e9684f06030$var$_makeExperiment;
function $11b28e9684f06030$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $11b28e9684f06030$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $11b28e9684f06030$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $11b28e9684f06030$var$_makeLayer;
function $11b28e9684f06030$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $11b28e9684f06030$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $11b28e9684f06030$var$_mergeOverride;
function $11b28e9684f06030$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $aFFpr._isTypeMatch)(found, fallback)) {
            $gCtHs.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $11b28e9684f06030$var$_makeTypedGet;

});

parcelRegister("5siSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kfvk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $ebdd816c9874d81d$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $ebdd816c9874d81d$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("ec6z6", function(module, exports) {
"use strict";
var $a557475cc0ee45bc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $82VcB = parcelRequire("82VcB");

var $lHden = parcelRequire("lHden");

var $6dzza = parcelRequire("6dzza");

var $5UbNO = parcelRequire("5UbNO");

var $5oki8 = parcelRequire("5oki8");
class $a557475cc0ee45bc$var$StatsigClient extends $82VcB.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $82VcB._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $a557475cc0ee45bc$var$StatsigClient) return instance;
        $82VcB.Log.warn((0, $82VcB._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $a557475cc0ee45bc$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $82VcB.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $6dzza.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $5oki8.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($82VcB.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($82VcB.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($82VcB.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($82VcB.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($82VcB.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($82VcB.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $lHden.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $82VcB.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $82VcB.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $a557475cc0ee45bc$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $82VcB.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $82VcB.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $a557475cc0ee45bc$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $a557475cc0ee45bc$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $82VcB.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $82VcB.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $82VcB.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $82VcB.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($82VcB.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $82VcB.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $82VcB.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $82VcB.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $82VcB.Log.error("Failed to parse user");
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $82VcB.StatsigSession.get(this._sdkKey),
            stableID: $82VcB.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: "log_event_called",
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $a557475cc0ee45bc$var$__awaiter(this, void 0, void 0, function*() {
            if (!$82VcB.Storage.isReady()) yield $82VcB.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $82VcB.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $82VcB.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $82VcB._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$82VcB.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$82VcB.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $82VcB.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $82VcB._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $82VcB._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $82VcB._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $82VcB._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $82VcB._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $82VcB._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $82VcB._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $82VcB._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $82VcB._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $82VcB._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $5UbNO._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $5UbNO._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $a557475cc0ee45bc$var$StatsigClient;

});
parcelRegister("lHden", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $82VcB = parcelRequire("82VcB");

var $3ZGKo = parcelRequire("3ZGKo");

var $gFGAt = parcelRequire("gFGAt");
class $fcb7e083abf56c5c$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $82VcB._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $82VcB._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === "init-v2") this._values = new $gFGAt.V2InitializeContainer(values);
        else this._values = new $3ZGKo.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $82VcB.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $82VcB.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $82VcB._getFullUserHash)(userForComparison) !== (0, $82VcB._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $fcb7e083abf56c5c$var$EvaluationStore;

});
parcelRegister("3ZGKo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $82VcB = parcelRequire("82VcB");
class $2e883a4c4c634415$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $82VcB._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $2e883a4c4c634415$var$V1InitializeContainer;

});

parcelRegister("gFGAt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $82VcB = parcelRequire("82VcB");
class $c231829f5ebfc0d8$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : "default",
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ""
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : "",
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === "stableID"
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === "stableID",
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : "",
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $82VcB._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $c231829f5ebfc0d8$var$V2InitializeContainer;

});


parcelRegister("6dzza", function(module, exports) {
"use strict";
var $486f8baf04887d44$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $82VcB = parcelRequire("82VcB");

var $8gGLW = parcelRequire("8gGLW");
class $486f8baf04887d44$var$StatsigNetwork extends $82VcB.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $82VcB.UrlConfiguration($82VcB.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $486f8baf04887d44$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $82VcB._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : "djb2");
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $486f8baf04887d44$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $8gGLW._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $486f8baf04887d44$var$StatsigNetwork;

});
parcelRegister("8gGLW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $82VcB = parcelRequire("82VcB");
const $6050ff0c1391f37a$var$MAX_DELTAS_SORT_DEPTH = 2;
function $6050ff0c1391f37a$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $82VcB._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $6050ff0c1391f37a$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $6050ff0c1391f37a$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $82VcB._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $6050ff0c1391f37a$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $6050ff0c1391f37a$var$_resolveDeltasResponse;
function $6050ff0c1391f37a$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $6050ff0c1391f37a$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $6050ff0c1391f37a$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $6050ff0c1391f37a$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $6050ff0c1391f37a$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $6050ff0c1391f37a$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("5UbNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $82VcB = parcelRequire("82VcB");
const $44cb56711569cfab$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $44cb56711569cfab$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $44cb56711569cfab$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $82VcB._isTypeMatch)(value, fallback);
}
function $44cb56711569cfab$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $44cb56711569cfab$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $44cb56711569cfab$var$_shouldLogExposure(options) ? undefined : $44cb56711569cfab$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $44cb56711569cfab$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $44cb56711569cfab$var$_shouldLogExposure(options) ? undefined : $44cb56711569cfab$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($44cb56711569cfab$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $44cb56711569cfab$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $44cb56711569cfab$var$_shouldLogExposure(options) ? undefined : $44cb56711569cfab$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($44cb56711569cfab$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $44cb56711569cfab$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $44cb56711569cfab$var$_shouldLogExposure(options) ? undefined : $44cb56711569cfab$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($44cb56711569cfab$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $44cb56711569cfab$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $82VcB._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $44cb56711569cfab$var$_getMappedStaticValue(param, options);
            case "gate":
                return $44cb56711569cfab$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $44cb56711569cfab$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $44cb56711569cfab$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $44cb56711569cfab$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $44cb56711569cfab$var$_makeParamStoreGetter;

});

parcelRegister("5oki8", function(module, exports) {
"use strict";
var $3eceef1d738def2a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $82VcB = parcelRequire("82VcB");

var $6dzza = parcelRequire("6dzza");
class $3eceef1d738def2a$var$StatsigEvaluationsDataAdapter extends $82VcB.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $6dzza.default) this._network = network;
        else this._network = new $6dzza.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $82VcB._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $82VcB._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $82VcB.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $3eceef1d738def2a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $82VcB._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$82VcB.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $82VcB._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $3eceef1d738def2a$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("2rQTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8722fb85685979$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $3vRz3 = parcelRequire("3vRz3");
function $1c8722fb85685979$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c8722fb85685979$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c8722fb85685979$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c8722fb85685979$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c8722fb85685979$export$a66cbd9b2289cd78 = "@all-features";
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $1c8722fb85685979$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $1c8722fb85685979$var$_objectSpread($1c8722fb85685979$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $1c8722fb85685979$var$_objectSpread($1c8722fb85685979$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $1c8722fb85685979$var$_objectSpread($1c8722fb85685979$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $1c8722fb85685979$var$_objectSpread($1c8722fb85685979$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($1c8722fb85685979$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($1c8722fb85685979$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($1c8722fb85685979$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $1c8722fb85685979$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("47B1e", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $30048807247116f8$export$6dc24881a3d96325);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $byVVF = parcelRequire("byVVF");

var $kWrhj = parcelRequire("kWrhj");
var $30048807247116f8$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $byVVF.migrateEvaluationDetails)(experiment.details), (0, $kWrhj.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("byVVF", function(module, exports) {

$parcel$export(module.exports, "migrateEvaluationDetails", () => $86afce3266b50cc3$export$18ad168d3dbac899);

var $02Ztr = parcelRequire("02Ztr");

var $6AmhW = parcelRequire("6AmhW");
var $86afce3266b50cc3$var$evaluationReasonMappings = Object.entries((0, $6AmhW.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $86afce3266b50cc3$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $86afce3266b50cc3$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $6AmhW.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("6AmhW", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $4cb764da0696b302$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $4cb764da0696b302$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: "Error",
    LocalOverride: "LocalOverride",
    Unrecognized: "Unrecognized",
    Uninitialized: "Uninitialized",
    NetworkNotModified: "NetworkNotModified",
    Network: "Network",
    InvalidBootstrap: "InvalidBootstrap",
    Bootstrap: "Bootstrap",
    Cache: "Cache",
    // For when we could not migrate the reason from the new client
    Unknown: "Unknown"
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("kWrhj", function(module, exports) {

$parcel$export(module.exports, "migrateSecondaryExposures", () => $f3ee624ab90ef8be$export$55fd683752d01e67);
var $f3ee624ab90ef8be$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === "string") // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("4MZpw", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $37cb47fd14a6b116$export$936d0764594b6eb3);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $byVVF = parcelRequire("byVVF");

var $kWrhj = parcelRequire("kWrhj");
var $37cb47fd14a6b116$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $byVVF.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $kWrhj.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $kWrhj.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("jVZ0A", function(module, exports) {

$parcel$export(module.exports, "deepAssign", () => $e832aa3246315660$export$1148cb79ceecd5fa);

var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");
function $e832aa3246315660$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $e832aa3246315660$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(src) === "object" && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(dst) === "object" && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $e832aa3246315660$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $e832aa3246315660$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(sources)));
}

});

parcelRegister("lRRuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb8096f27f1a136$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $117Ap = parcelRequire("117Ap");

var $4tdHF = parcelRequire("4tdHF");

var $4NeqJ = parcelRequire("4NeqJ");
function $feb8096f27f1a136$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $feb8096f27f1a136$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $feb8096f27f1a136$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $feb8096f27f1a136$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $feb8096f27f1a136$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $feb8096f27f1a136$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $feb8096f27f1a136$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $feb8096f27f1a136$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $feb8096f27f1a136$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $feb8096f27f1a136$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $feb8096f27f1a136$export$4e8a0415edbfa1f7 = "https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net";
var $feb8096f27f1a136$export$cb3cd156f70d7e94 = "oasis-stg.com/flags";
var $feb8096f27f1a136$export$921fbc6cdfd4eee0 = "atlassian-isolated.net/flags";
var $feb8096f27f1a136$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $feb8096f27f1a136$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error("Failed to retrieve client sdk key");
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error("Failed to retrieve experiment values");
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $4NeqJ.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $4NeqJ.ResponseError)("Unexpected 204 response");
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $feb8096f27f1a136$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $117Ap.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $117Ap.FeatureGateEnvironment).Production:
                        return $feb8096f27f1a136$export$18c93900db9358a4;
                    case (0, $117Ap.FeatureGateEnvironment).Staging:
                        return $feb8096f27f1a136$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $117Ap.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $117Ap.FeatureGateEnvironment).Development:
                        return $feb8096f27f1a136$export$f058dbf75c3bc647;
                    case (0, $117Ap.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $feb8096f27f1a136$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $feb8096f27f1a136$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $feb8096f27f1a136$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $feb8096f27f1a136$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $4tdHF.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $feb8096f27f1a136$export$4e8a0415edbfa1f7.replace("%s", isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($feb8096f27f1a136$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($feb8096f27f1a136$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== "undefined" && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("117Ap", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $0bdbc4e35d8f5e4b$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $0bdbc4e35d8f5e4b$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $0bdbc4e35d8f5e4b$export$479e7351a733299 = {
    Development: "development",
    Staging: "staging",
    Production: "production"
};
var $0bdbc4e35d8f5e4b$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: "commercial",
    FEDRAMP_MODERATE: "fedramp-moderate"
};
var $0bdbc4e35d8f5e4b$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("4tdHF", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $3414801303ef8515$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $3414801303ef8515$export$a59f8d67326bd1cb = "6.0.1";

});

parcelRegister("4NeqJ", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $37d6ee884db08c4a$export$286baf652d0b1206);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $in7St = parcelRequire("in7St");
function $37d6ee884db08c4a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $37d6ee884db08c4a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $37d6ee884db08c4a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($37d6ee884db08c4a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $37d6ee884db08c4a$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ResponseError);
        return $37d6ee884db08c4a$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($in7St)))(Error));

});


parcelRegister("ez4gp", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $a9a7a43cd4508691$export$d119b37e5f788b43);

var $g5Zhu = parcelRequire("g5Zhu");

var $cX70D = parcelRequire("cX70D");

var $117Ap = parcelRequire("117Ap");
function $a9a7a43cd4508691$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9a7a43cd4508691$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9a7a43cd4508691$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9a7a43cd4508691$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a9a7a43cd4508691$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $a9a7a43cd4508691$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $cX70D.isFedRamp)() ? (0, $117Ap.PerimeterType).FEDRAMP_MODERATE : (0, $117Ap.PerimeterType).COMMERCIAL
    }, options);
};

});

parcelRegister("j7vSW", function(module, exports) {

$parcel$export(module.exports, "migrateInitializationOptions", () => $deb76779ebd112a2$export$202946b690d26d22);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");
var $deb76779ebd112a2$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $deb76779ebd112a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $deb76779ebd112a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $deb76779ebd112a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $deb76779ebd112a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $deb76779ebd112a2$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $deb76779ebd112a2$var$_excluded);
    return $deb76779ebd112a2$var$_objectSpread($deb76779ebd112a2$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("6NMA1", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $4f3d00ab95e0b91c$export$55fffef3474104af);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $6crSc = parcelRequire("6crSc");
function $4f3d00ab95e0b91c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f3d00ab95e0b91c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f3d00ab95e0b91c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f3d00ab95e0b91c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4f3d00ab95e0b91c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $4f3d00ab95e0b91c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $4f3d00ab95e0b91c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4f3d00ab95e0b91c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4f3d00ab95e0b91c$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $4f3d00ab95e0b91c$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NoFetchDataAdapter);
        _this = $4f3d00ab95e0b91c$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $6crSc.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $4f3d00ab95e0b91c$var$_objectSpread($4f3d00ab95e0b91c$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $6crSc._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $4f3d00ab95e0b91c$var$_objectSpread($4f3d00ab95e0b91c$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $6crSc._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $6crSc._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $6crSc.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $4f3d00ab95e0b91c$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $4f3d00ab95e0b91c$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $6crSc.DataAdapterCore));

});

parcelRegister("gEc9j", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $c1e9ce59acf271fb$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $c1e9ce59acf271fb$export$bcb28fbac1def494);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $82VcB = parcelRequire("82VcB");
function $c1e9ce59acf271fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1e9ce59acf271fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1e9ce59acf271fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1e9ce59acf271fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c1e9ce59acf271fb$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c1e9ce59acf271fb$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c1e9ce59acf271fb$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c1e9ce59acf271fb$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c1e9ce59acf271fb$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c1e9ce59acf271fb$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c1e9ce59acf271fb$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $c1e9ce59acf271fb$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $c1e9ce59acf271fb$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $c1e9ce59acf271fb$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $c1e9ce59acf271fb$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $c1e9ce59acf271fb$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PersistentOverrideAdapter);
        this._overrides = $c1e9ce59acf271fb$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $c1e9ce59acf271fb$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $c1e9ce59acf271fb$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $c1e9ce59acf271fb$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($c1e9ce59acf271fb$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($c1e9ce59acf271fb$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $c1e9ce59acf271fb$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $82VcB._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, $c1e9ce59acf271fb$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($c1e9ce59acf271fb$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, current.details), {}, {
                        reason: $c1e9ce59acf271fb$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($c1e9ce59acf271fb$var$djb2MapKey((0, $82VcB._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $c1e9ce59acf271fb$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($c1e9ce59acf271fb$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $82VcB._makeTypedGet)(current.name, overridden),
                    details: $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, current.details), {}, {
                        reason: $c1e9ce59acf271fb$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($c1e9ce59acf271fb$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $82VcB._makeTypedGet)(current.name, overridden),
                    details: $c1e9ce59acf271fb$var$_objectSpread($c1e9ce59acf271fb$var$_objectSpread({}, current.details), {}, {
                        reason: $c1e9ce59acf271fb$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("17EY4", function(module, exports) {

$parcel$export(module.exports, "shallowEquals", () => $0d16393d9ddded6e$export$fa1c2bbf4100b8bc);

var $02Ztr = parcelRequire("02Ztr");
var $0d16393d9ddded6e$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("Clr4q", function(module, exports) {

$parcel$export(module.exports, "toStatsigUser", () => $07342d6449241a8b$export$3dad1db244472f32);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");
var $07342d6449241a8b$var$_excluded = [
    "stableId"
];
function $07342d6449241a8b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07342d6449241a8b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07342d6449241a8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07342d6449241a8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $07342d6449241a8b$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(identifiers, $07342d6449241a8b$var$_excluded);
    var user = {
        customIDs: $07342d6449241a8b$var$_objectSpread($07342d6449241a8b$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("eTt10", function(module, exports) {

$parcel$export(module.exports, "debug", () => $ad7cb58e19f6dd50$export$1c9f709888824e05);
var $ad7cb58e19f6dd50$var$_process, $ad7cb58e19f6dd50$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ad7cb58e19f6dd50$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($ad7cb58e19f6dd50$var$_process = globalThis.process) === null || $ad7cb58e19f6dd50$var$_process === void 0 || ($ad7cb58e19f6dd50$var$_process = $ad7cb58e19f6dd50$var$_process.env) === null || $ad7cb58e19f6dd50$var$_process === void 0 ? void 0 : $ad7cb58e19f6dd50$var$_process.JEST_WORKER_ID) !== undefined;
var $ad7cb58e19f6dd50$var$DEBUG_MODE = !$ad7cb58e19f6dd50$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ad7cb58e19f6dd50$var$_process2 = globalThis.process) === null || $ad7cb58e19f6dd50$var$_process2 === void 0 || ($ad7cb58e19f6dd50$var$_process2 = $ad7cb58e19f6dd50$var$_process2.env) === null || $ad7cb58e19f6dd50$var$_process2 === void 0 ? void 0 : $ad7cb58e19f6dd50$var$_process2.NODE_ENV) !== "production";
var $ad7cb58e19f6dd50$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ad7cb58e19f6dd50$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("6dYxx", function(module, exports) {

$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $4882eaf319eeb317$export$b574c24e1e6490f5);

var $jaJgG = parcelRequire("jaJgG");
var $4882eaf319eeb317$export$b574c24e1e6490f5 = (0, $jaJgG.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("jaJgG", function(module, exports) {

$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $df5210d13113e797$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $df5210d13113e797$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $df5210d13113e797$export$75f4a1454eff2805);

var $hPtJY = parcelRequire("hPtJY");
var $df5210d13113e797$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $df5210d13113e797$export$407f05df8e3ce9f3 = "@atlaskit/platform-feature-flags";
var $df5210d13113e797$export$75f4a1454eff2805 = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";

});


parcelRegister("2g6CI", function(module, exports) {

$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $1a5236af7b8828e6$export$92f8b531feaeb23d);

var $jaJgG = parcelRequire("jaJgG");
var $1a5236af7b8828e6$export$92f8b531feaeb23d = (0, $jaJgG.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("2BAnE", function(module, exports) {

$parcel$export(module.exports, "globalVar", () => $1e5b41dbc69ad32d$export$54ea85357b4e0159);

var $jaJgG = parcelRequire("jaJgG");
var $1e5b41dbc69ad32d$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $1e5b41dbc69ad32d$export$54ea85357b4e0159 = typeof window !== "undefined" ? window : globalThis;
$1e5b41dbc69ad32d$export$54ea85357b4e0159[0, $jaJgG.PFF_GLOBAL_KEY] = $1e5b41dbc69ad32d$export$54ea85357b4e0159[0, $jaJgG.PFF_GLOBAL_KEY] || $1e5b41dbc69ad32d$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("6wHwM", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $4c077ef24dd17960$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $4c077ef24dd17960$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("ifahf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d481999034f4f9bb$export$2e2bcd8739ae039);

var $i1TYg = parcelRequire("i1TYg");

var $4nUvj = parcelRequire("4nUvj");
class $d481999034f4f9bb$export$2e2bcd8739ae039 extends (0, $4nUvj.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $i1TYg.default);
        } catch (err) {
            storageToUse = (0, $i1TYg.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("bswAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $857b959925cca363$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $ifahf = parcelRequire("ifahf");

var $eNyK8 = parcelRequire("eNyK8");
const $857b959925cca363$var$STORAGE_KEY = "tab.id";
class $857b959925cca363$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, $eNyK8.default)();
            this._safeSessionStorage.setItem($857b959925cca363$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $ifahf.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($857b959925cca363$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("6gFBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4904829e7108cc33$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $hMelT = parcelRequire("hMelT");

var $3emEs = parcelRequire("3emEs");

var $h7VX5 = parcelRequire("h7VX5");

var $ifahf = parcelRequire("ifahf");

var $kS1ye = parcelRequire("kS1ye");

var $eNyK8 = parcelRequire("eNyK8");
function $4904829e7108cc33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4904829e7108cc33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4904829e7108cc33$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4904829e7108cc33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4904829e7108cc33$var$STORAGE_KEY = "taskSessions";
const $4904829e7108cc33$var$INIT_KEY = "taskSessionsInit";
const $4904829e7108cc33$var$AWC_PARAM_PREFIX = "awc.";
const $4904829e7108cc33$var$TASK_SESSION_RELOAD_TIME = 3000;
class $4904829e7108cc33$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($4904829e7108cc33$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($4904829e7108cc33$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($4904829e7108cc33$var$INIT_KEY) || "0", 10) < currentTimestamp - $4904829e7108cc33$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($4904829e7108cc33$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($4904829e7108cc33$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($4904829e7108cc33$var$STORAGE_KEY) || "");
            } catch (_unused) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($4904829e7108cc33$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (_unused2) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, $eNyK8.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $hMelT.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $h7VX5.pick)(currentState, includedTaskSessions) : (0, $h7VX5.omit)(currentState, Object.values((0, $3emEs.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $4904829e7108cc33$var$_objectSpread($4904829e7108cc33$var$_objectSpread({}, (0, $h7VX5.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$4904829e7108cc33$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $hMelT.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $h7VX5.mapKeys)((0, $kS1ye.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $ifahf.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($4904829e7108cc33$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (_unused3) {}
    }
}

});

parcelRegister("04nKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d2cd44531ba4bd$export$2e2bcd8739ae039);

var $8Nbse = parcelRequire("8Nbse");

var $76ZC2 = parcelRequire("76ZC2");

var $aIR4t = parcelRequire("aIR4t");
const $00d2cd44531ba4bd$var$MAX_CACHE_SIZE = 100;
const $00d2cd44531ba4bd$var$COOKIE_NAME = (0, $76ZC2.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $00d2cd44531ba4bd$var$DEBUG_TAG = "synthetic";
class $00d2cd44531ba4bd$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === "boolean" ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === "boolean" ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $00d2cd44531ba4bd$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch (_unused) {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === "undefined" || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem("awc.ui.viewed.last.sent");
                    localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                    localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                    localStorage.removeItem("awc-local.ui.viewed.last.sent");
                } catch (_unused2) {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === "undefined" || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $00d2cd44531ba4bd$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($00d2cd44531ba4bd$var$DEBUG_TAG)) event.tags.push($00d2cd44531ba4bd$var$DEBUG_TAG);
        } else event.tags = [
            $00d2cd44531ba4bd$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $aIR4t.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get($00d2cd44531ba4bd$var$COOKIE_NAME) || "false") === true;
        } catch (_unused3) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).remove($00d2cd44531ba4bd$var$COOKIE_NAME);
        }
        return false;
    }
}
var $00d2cd44531ba4bd$export$2e2bcd8739ae039 = $00d2cd44531ba4bd$var$TestingCache;

});

parcelRegister("9Ap7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $6faaf520824975a5$export$2e2bcd8739ae039);

var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $3emEs = parcelRequire("3emEs");

var $1XIy9 = parcelRequire("1XIy9");

var $k4E1V = parcelRequire("k4E1V");
const $6faaf520824975a5$var$_excluded = [
    "embeddedProduct"
];
function $6faaf520824975a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6faaf520824975a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6faaf520824975a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6faaf520824975a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6faaf520824975a5$var$DEFAULT_DELAY = 2000; // 2 seconds
const $6faaf520824975a5$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $6faaf520824975a5$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
const $6faaf520824975a5$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = "malformed.uiviewed.last.sent";
var $6faaf520824975a5$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($6faaf520824975a5$var$SendEventDecision || {});
class $6faaf520824975a5$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "signalUserActive", ()=>{
            this._sendUserActiveEvents();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.addEventListener("focus", this._focusListener);
                window.addEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.removeEventListener("focus", this._focusListener);
                window.removeEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_parseLocalStorageData", (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || "");
            } catch (_unused) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || "NOT_SET";
            const finalTenantId = tenantId || "NOT_SET";
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || "NOT_SET";
            const finalTenantId = tenantId || "NOT_SET";
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_handleDwellTimerTriggered", ()=>{
            const document = (0, $1XIy9.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendUserActiveEvents", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$_getContext, $6faaf520824975a5$var$_excluded);
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendEvent", (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case $6faaf520824975a5$var$SendEventDecision.EligibleToSend:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, "ui", "viewed"));
                    break;
                case $6faaf520824975a5$var$SendEventDecision.UserOrTenantIncomplete:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, "malformed", "uiviewed"));
                    break;
                default:
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $3emEs.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return $6faaf520824975a5$var$SendEventDecision.UserOrTenantIncomplete;
                return $6faaf520824975a5$var$SendEventDecision.MalformedUiViewedRateLimited;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return $6faaf520824975a5$var$SendEventDecision.EligibleToSend;
            return $6faaf520824975a5$var$SendEventDecision.UiViewedRateLimited;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: "ui",
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $6faaf520824975a5$var$_objectSpread($6faaf520824975a5$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $6faaf520824975a5$var$_objectSpread($6faaf520824975a5$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $6faaf520824975a5$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $6faaf520824975a5$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $6faaf520824975a5$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $6faaf520824975a5$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $k4E1V.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("1XIy9", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $16dddbcda4546679$export$f65ca476c09acec0);
const $16dddbcda4546679$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== "undefined") return document;
    return null;
};

});


parcelRegister("7yyBr", function(module, exports) {

$parcel$export(module.exports, "validateIdentifyEvent", () => $58068cc6b5e29567$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3emEs = parcelRequire("3emEs");

var $lh8UB = parcelRequire("lh8UB");

var $iPlmd = parcelRequire("iPlmd");
function $58068cc6b5e29567$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $lh8UB.isType)((0, $3emEs.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $iPlmd.objectValues)((0, $3emEs.userType))}]`);
}

});

parcelRegister("b20JC", function(module, exports) {

$parcel$export(module.exports, "validateOperationalEvent", () => $02129682228bdaab$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $h54gC = parcelRequire("h54gC");
function $02129682228bdaab$export$1e561554275607ef(event) {
    (0, $h54gC.validateActionEvent)(event);
}

});

parcelRegister("dDyod", function(module, exports) {

$parcel$export(module.exports, "validatePlatform", () => $9ed997f0197e4d57$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3emEs = parcelRequire("3emEs");

var $lh8UB = parcelRequire("lh8UB");

var $iPlmd = parcelRequire("iPlmd");
function $9ed997f0197e4d57$export$801b46c35394d316(productInfo) {
    if (!(0, $lh8UB.isType)((0, $3emEs.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $iPlmd.objectValues)((0, $3emEs.platformType))}]`);
    if (productInfo.origin === (0, $3emEs.originType).DESKTOP && !(0, $lh8UB.isType)((0, $3emEs.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $3emEs.originType).WEB && !(0, $lh8UB.isType)((0, $3emEs.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("4n57s", function(module, exports) {

$parcel$export(module.exports, "validateScreenEvent", () => $32ed48020e1cbc9b$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $32ed48020e1cbc9b$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}

});

parcelRegister("fGJG7", function(module, exports) {

$parcel$export(module.exports, "validateTrackEvent", () => $b6be36099533c3c8$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $h54gC = parcelRequire("h54gC");
function $b6be36099533c3c8$export$8c014fd74b0c8b99(event) {
    (0, $h54gC.validateActionEvent)(event);
}

});

parcelRegister("dtGPf", function(module, exports) {

$parcel$export(module.exports, "validateUIEvent", () => $9cff34145e4bbf06$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $h54gC = parcelRequire("h54gC");
function $9cff34145e4bbf06$export$e5bac0930c812e90(event) {
    (0, $h54gC.validateActionEvent)(event);
}

});

parcelRegister("2mBBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8acf1061a4360a$export$2e2bcd8739ae039);
function $1b8acf1061a4360a$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("1oU01", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", () => $105378aa9c256719$export$fbe53bbbe682bcdd);

var $4L14e = parcelRequire("4L14e");
const $105378aa9c256719$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $4L14e.createTimeoutXid)()), (0, $4L14e.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $4L14e.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("4L14e", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", () => $376c61206d7909b6$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $376c61206d7909b6$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $376c61206d7909b6$export$fa341d0c750d705b);

var $fKtFD = parcelRequire("fKtFD");
const $376c61206d7909b6$export$545bcbd53afabfa3 = 5000;
const $376c61206d7909b6$export$af4087e36d63846 = ()=>[
        {
            type: (0, $fKtFD.XIDItemType).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $fKtFD.XIDItemType).UID,
            state: "TIMEOUT"
        }
    ];
const $376c61206d7909b6$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $fKtFD.XIDItemType).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $fKtFD.XIDItemType).UID,
            state: "UNKNOWN"
        }
    ];

});
parcelRegister("fKtFD", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", () => $b7722ad27279a3bd$export$92ca0438bcb0d396);
let $b7722ad27279a3bd$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $b7722ad27279a3bd$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("9Gk3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $70c798bd330971bb$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $cQTr7 = parcelRequire("cQTr7");

var $aIlEf = parcelRequire("aIlEf");
function $70c798bd330971bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70c798bd330971bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70c798bd330971bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70c798bd330971bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $70c798bd330971bb$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $70c798bd330971bb$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
   * of the helper.
   * - iframeDwell = enable detection of activity in iframes.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions, dwellTimeHelperOptions){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeMeInitialized", false);
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "start", ()=>{
            if (this.timeMeInitialized) throw new Error("DwellTimeHelper should only be initialised once per page load.");
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== "undefined") window.addEventListener("beforeunload", ()=>{
                this.stop();
            });
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "newPage", (eventData, searchSessionId)=>{
            (0, $aIlEf.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        });
        /**
     * This is a modified version of timeit's original listForIdleEvents function,
     * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
     * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_listForIdleEvents", ()=>{
            document.addEventListener("mousemove", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
            });
            document.addEventListener("keyup", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
            });
            document.addEventListener("touchstart", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
            });
            window.addEventListener("scroll", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
            });
            /**
       * Find all same origin iframes (same origin allow access to contentWindow.document)
       * and add event listeners to them too.
       */ const iframes = document.getElementsByTagName("iframe");
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    var _iframe$contentWindow, _iframe$contentWindow2, _iframe$contentWindow3;
                    iframe === null || iframe === void 0 || (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.document.addEventListener("mousemove", ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
                    });
                    iframe === null || iframe === void 0 || (_iframe$contentWindow2 = iframe.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.document.addEventListener("keyup", ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
                    });
                    iframe === null || iframe === void 0 || (_iframe$contentWindow3 = iframe.contentWindow) === null || _iframe$contentWindow3 === void 0 || _iframe$contentWindow3.document.addEventListener("touchstart", ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).checkIdleStateRateMs);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_initDwellTimeCounterAndPolling", ()=>{
            var _this$_dwellTimeHelpe;
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if ((_this$_dwellTimeHelpe = this._dwellTimeHelperOptions) !== null && _this$_dwellTimeHelpe !== void 0 && _this$_dwellTimeHelpe.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_pollDwellTime", (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendDwellEvent", (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($cQTr7))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: "dwelled",
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $70c798bd330971bb$var$_objectSpread($70c798bd330971bb$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error("trackCallback is required for DwellTimeHelper");
        (0, $aIlEf.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $70c798bd330971bb$var$_objectSpread($70c798bd330971bb$var$_objectSpread({}, $70c798bd330971bb$var$DEFAULT_TIMING), timingOptions);
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}

});
parcelRegister("cQTr7", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (0, module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === "function" && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener("blur", ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener("focus", ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("aIlEf", function(module, exports) {

$parcel$export(module.exports, "validateDwellBaseEvent", () => $7ccece5245bac5f3$export$39d6334da9a44984);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $7ccece5245bac5f3$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}

});


parcelRegister("ljrx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f840ba7ca34d8be1$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $2gxyj = parcelRequire("2gxyj");

var $aIlEf = parcelRequire("aIlEf");
function $f840ba7ca34d8be1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f840ba7ca34d8be1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f840ba7ca34d8be1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f840ba7ca34d8be1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f840ba7ca34d8be1$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $f840ba7ca34d8be1$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions){
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "start", ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== "undefined") window.addEventListener("beforeunload", this._onBeforeUnload);
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "newPage", (eventData, searchSessionId)=>{
            (0, $aIlEf.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setEventData", (eventData)=>{
            this._eventData = eventData;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getEventData", ()=>this._eventData);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setSearchSessionId", (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getSearchSessionId", ()=>this._searchSessionId);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "destroy", ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== "undefined") window.removeEventListener("beforeunload", this._onBeforeUnload);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_onBeforeUnload", ()=>{
            this.stop();
            this.destroy();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendDwellEvent", (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: "dwelled",
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $f840ba7ca34d8be1$var$_objectSpread($f840ba7ca34d8be1$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error("trackCallback is required for DwellTimeHelper");
        (0, $aIlEf.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $f840ba7ca34d8be1$var$_objectSpread($f840ba7ca34d8be1$var$_objectSpread({}, $f840ba7ca34d8be1$var$DEFAULT_TIMING), timingOptions);
        this.browserInteractionTime = new (0, $2gxyj.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});
parcelRegister("2gxyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a671a39680e9a24$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $1a671a39680e9a24$var$__assign = function() {
    $1a671a39680e9a24$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a671a39680e9a24$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1a671a39680e9a24$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $1a671a39680e9a24$var$isObject_1 = $1a671a39680e9a24$var$isObject;
var $1a671a39680e9a24$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
/** Detect free variable `global` from Node.js. */ var $1a671a39680e9a24$var$freeGlobal = typeof $1a671a39680e9a24$var$commonjsGlobal == "object" && $1a671a39680e9a24$var$commonjsGlobal && $1a671a39680e9a24$var$commonjsGlobal.Object === Object && $1a671a39680e9a24$var$commonjsGlobal;
var $1a671a39680e9a24$var$_freeGlobal = $1a671a39680e9a24$var$freeGlobal;
/** Detect free variable `self`. */ var $1a671a39680e9a24$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1a671a39680e9a24$var$root = $1a671a39680e9a24$var$_freeGlobal || $1a671a39680e9a24$var$freeSelf || Function("return this")();
var $1a671a39680e9a24$var$_root = $1a671a39680e9a24$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1a671a39680e9a24$var$now = function() {
    return $1a671a39680e9a24$var$_root.Date.now();
};
var $1a671a39680e9a24$var$now_1 = $1a671a39680e9a24$var$now;
/** Built-in value references. */ var $1a671a39680e9a24$var$Symbol = $1a671a39680e9a24$var$_root.Symbol;
var $1a671a39680e9a24$var$_Symbol = $1a671a39680e9a24$var$Symbol;
/** Used for built-in method references. */ var $1a671a39680e9a24$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a671a39680e9a24$var$hasOwnProperty = $1a671a39680e9a24$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a671a39680e9a24$var$nativeObjectToString = $1a671a39680e9a24$var$objectProto.toString;
/** Built-in value references. */ var $1a671a39680e9a24$var$symToStringTag = $1a671a39680e9a24$var$_Symbol ? $1a671a39680e9a24$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $1a671a39680e9a24$var$getRawTag(value) {
    var isOwn = $1a671a39680e9a24$var$hasOwnProperty.call(value, $1a671a39680e9a24$var$symToStringTag), tag = value[$1a671a39680e9a24$var$symToStringTag];
    try {
        value[$1a671a39680e9a24$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $1a671a39680e9a24$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$1a671a39680e9a24$var$symToStringTag] = tag;
        else delete value[$1a671a39680e9a24$var$symToStringTag];
    }
    return result;
}
var $1a671a39680e9a24$var$_getRawTag = $1a671a39680e9a24$var$getRawTag;
/** Used for built-in method references. */ var $1a671a39680e9a24$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a671a39680e9a24$var$nativeObjectToString$1 = $1a671a39680e9a24$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1a671a39680e9a24$var$objectToString(value) {
    return $1a671a39680e9a24$var$nativeObjectToString$1.call(value);
}
var $1a671a39680e9a24$var$_objectToString = $1a671a39680e9a24$var$objectToString;
/** `Object#toString` result references. */ var $1a671a39680e9a24$var$nullTag = "[object Null]", $1a671a39680e9a24$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $1a671a39680e9a24$var$symToStringTag$1 = $1a671a39680e9a24$var$_Symbol ? $1a671a39680e9a24$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1a671a39680e9a24$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $1a671a39680e9a24$var$undefinedTag : $1a671a39680e9a24$var$nullTag;
    return $1a671a39680e9a24$var$symToStringTag$1 && $1a671a39680e9a24$var$symToStringTag$1 in Object(value) ? $1a671a39680e9a24$var$_getRawTag(value) : $1a671a39680e9a24$var$_objectToString(value);
}
var $1a671a39680e9a24$var$_baseGetTag = $1a671a39680e9a24$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1a671a39680e9a24$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $1a671a39680e9a24$var$isObjectLike_1 = $1a671a39680e9a24$var$isObjectLike;
/** `Object#toString` result references. */ var $1a671a39680e9a24$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1a671a39680e9a24$var$isSymbol(value) {
    return typeof value == "symbol" || $1a671a39680e9a24$var$isObjectLike_1(value) && $1a671a39680e9a24$var$_baseGetTag(value) == $1a671a39680e9a24$var$symbolTag;
}
var $1a671a39680e9a24$var$isSymbol_1 = $1a671a39680e9a24$var$isSymbol;
/** Used as references for various `Number` constants. */ var $1a671a39680e9a24$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $1a671a39680e9a24$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1a671a39680e9a24$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1a671a39680e9a24$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $1a671a39680e9a24$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $1a671a39680e9a24$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1a671a39680e9a24$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($1a671a39680e9a24$var$isSymbol_1(value)) return $1a671a39680e9a24$var$NAN;
    if ($1a671a39680e9a24$var$isObject_1(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $1a671a39680e9a24$var$isObject_1(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($1a671a39680e9a24$var$reTrim, "");
    var isBinary = $1a671a39680e9a24$var$reIsBinary.test(value);
    return isBinary || $1a671a39680e9a24$var$reIsOctal.test(value) ? $1a671a39680e9a24$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1a671a39680e9a24$var$reIsBadHex.test(value) ? $1a671a39680e9a24$var$NAN : +value;
}
var $1a671a39680e9a24$var$toNumber_1 = $1a671a39680e9a24$var$toNumber;
/** Error message constants. */ var $1a671a39680e9a24$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1a671a39680e9a24$var$nativeMax = Math.max, $1a671a39680e9a24$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1a671a39680e9a24$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($1a671a39680e9a24$var$FUNC_ERROR_TEXT);
    wait = $1a671a39680e9a24$var$toNumber_1(wait) || 0;
    if ($1a671a39680e9a24$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $1a671a39680e9a24$var$nativeMax($1a671a39680e9a24$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $1a671a39680e9a24$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1a671a39680e9a24$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1a671a39680e9a24$var$now_1());
    }
    function debounced() {
        var time = $1a671a39680e9a24$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $1a671a39680e9a24$var$debounce_1 = $1a671a39680e9a24$var$debounce;
/** Error message constants. */ var $1a671a39680e9a24$var$FUNC_ERROR_TEXT$1 = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $1a671a39680e9a24$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($1a671a39680e9a24$var$FUNC_ERROR_TEXT$1);
    if ($1a671a39680e9a24$var$isObject_1(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $1a671a39680e9a24$var$debounce_1(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $1a671a39680e9a24$var$throttle_1 = $1a671a39680e9a24$var$throttle;
var $1a671a39680e9a24$var$windowIdleEvents = [
    "scroll",
    "resize"
];
var $1a671a39680e9a24$var$documentIdleEvents = [
    "wheel",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "touchstart",
    "touchmove",
    "click",
    "contextmenu"
];
var $1a671a39680e9a24$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === "visible") _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $1a671a39680e9a24$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener("visibilitychange", _this.onBrowserActiveChange);
            var throttleResetIdleTime = $1a671a39680e9a24$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $1a671a39680e9a24$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $1a671a39680e9a24$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener("visibilitychange", _this.onBrowserActiveChange);
            $1a671a39680e9a24$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $1a671a39680e9a24$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $1a671a39680e9a24$export$2e2bcd8739ae039 = $1a671a39680e9a24$var$BrowserInteractionTime;

});


parcelRegister("88GdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecfd2e073a60b69$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");
function $5ecfd2e073a60b69$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ecfd2e073a60b69$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ecfd2e073a60b69$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ecfd2e073a60b69$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * TypeAheadHelper is helper file which assists in
 * tracking analytics around typeahead components, such as mentions, in
 * a consistent way. It generates objects that can be passed into
 * an instance of analyticsWebClient to trigger events.
 *
 * Example usage:
 *
 * const typeAheadHelper = new TypeAheadHelper(
 *   webClient.sendTrackEvent,
 *   baseEvent // an object containing the action + additional context attributes
 * );
 *
 * mentionHelper.search('abc');
 * mentionHelper.searched(resultsArray);
 * mentionHelper.selected(selectedIndex);
 */ function $5ecfd2e073a60b69$var$combineWithBaseEvent(action, extraAttributes, baseEvent) {
    const event = $5ecfd2e073a60b69$var$_objectSpread({
        action: action
    }, baseEvent);
    event.attributes = $5ecfd2e073a60b69$var$_objectSpread($5ecfd2e073a60b69$var$_objectSpread({}, extraAttributes), event.attributes);
    return event;
}
class $5ecfd2e073a60b69$export$2e2bcd8739ae039 {
    /**
   * Constructs a new instance of TypeAheadHelper.
   *
   * @param {Function} onEvent the function to call when an analytics event must be fired.
   *  There will be one argument, the analytics event object.
   * @param {Object} baseEvent base event with action and context to use when triggering events.
   *  More details here: https://product-fabric.atlassian.net/wiki/x/XQCZFg
   */ constructor(onEvent, baseEvent){
        this._onEvent = onEvent;
        this._baseEvent = baseEvent;
        this._searchStartedTime = null;
        this._lastQueryResultsTime = null;
        this._queryLength = null;
        this._baseEvent = $5ecfd2e073a60b69$var$_objectSpread({}, baseEvent);
    }
    /**
   * Records the start time of the first web request
   * and a copy of the query length for sending later in an analytics event.
   *
   * It should be called before the web request is initially made.
   *
   * @param {String} query the string entered as the query
   */ search(query) {
        if (!query && query !== "") throw new Error("Missing query param");
        this._searchStartedTime = Date.now();
        this._queryLength = (query || "").length;
    }
    /**
   * searched() tracks an event representing the completion of the web request
   * to fetch results for a given typeahead query.
   *
   * Events are structured as follows:
   *
   * <actionSubject>.searched {
   *    queryLength: 12, // length in characters
   *    responseTimeMs: 5023, // time to return results in milliseconds
   *    results: [ 'abc', '123' ] // actual result content
   * }
   *
   * It should be called after the response returns from the web server.
   *
   * @param {Array} results List of results returned by the server. MUST NOT CONTAIN UGC.
   */ searched(results) {
        if (!results) throw new Error("Missing results param");
        if (this._queryLength === null) throw new Error("search() must be called before searched().");
        const responseTimeMs = Date.now() - this._searchStartedTime;
        this._lastQueryResultsTime = Date.now();
        this._lastResults = results;
        const extraAttributes = {
            responseTimeMs: responseTimeMs,
            queryLength: this._queryLength,
            results: results
        };
        const event = $5ecfd2e073a60b69$var$combineWithBaseEvent("searched", extraAttributes, this._baseEvent);
        this._onEvent(event);
    }
    /**
   * selected() tracks an event representing one of the results in the typeahead
   * being chosen.
   *
   * Events are structured as follows:
   *
   * <actionSubject>.selected {
   *    queryLength: 12,
   *    selectionIndex: 0,
   *    selectionTimeMs: 123 // ms since the response came back
   *    searchTimeMs: 123 // ms since the search was made, i.e. selection + response time
   * }
   *
   * @param {Number} selectionIndex the index of the result was selected.
   */ selected(selectionIndex) {
        if (!selectionIndex && selectionIndex !== 0) throw new Error("Missing selectionIndex param");
        if (!this._lastQueryResultsTime) throw new Error("searched() must be called before selected().");
        const now = Date.now();
        const selectionTimeMs = now - this._lastQueryResultsTime;
        const searchTimeMs = now - this._searchStartedTime;
        const selectedResultValue = this._lastResults[selectionIndex];
        const extraAttributes = {
            queryLength: this._queryLength,
            selectionIndex: selectionIndex,
            selectionTimeMs: selectionTimeMs,
            searchTimeMs: searchTimeMs,
            selectedResultValue: selectedResultValue
        };
        const event = $5ecfd2e073a60b69$var$combineWithBaseEvent("selected", extraAttributes, this._baseEvent);
        this._onEvent(event);
    }
}

});


parcelRegister("c2qi1", function(module, exports) {
"use strict";
var $8c3a1089d1fcf68b$var$__assign = module.exports && module.exports.__assign || function() {
    $8c3a1089d1fcf68b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8c3a1089d1fcf68b$var$__assign.apply(this, arguments);
};
var $8c3a1089d1fcf68b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c3a1089d1fcf68b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8c3a1089d1fcf68b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8c3a1089d1fcf68b$var$__createBinding(result, mod, k);
    }
    $8c3a1089d1fcf68b$var$__setModuleDefault(result, mod);
    return result;
};
var $8c3a1089d1fcf68b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8c3a1089d1fcf68b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8c3a1089d1fcf68b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8c3a1089d1fcf68b$var$DynamicConfig_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("B3ZgU")));

var $8c3a1089d1fcf68b$var$ErrorBoundary_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("6QBBi")));

var $b6DQS = parcelRequire("b6DQS");

var $8c3a1089d1fcf68b$var$Layer_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("bkVef")));

var $8c3a1089d1fcf68b$var$StatsigIdentity_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("46lQA")));

var $8c3a1089d1fcf68b$var$StatsigLogger_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("aDICl")));

var $8c3a1089d1fcf68b$var$StatsigNetwork_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("ht8xQ")));

var $8c3a1089d1fcf68b$var$StatsigSDKOptions_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("4By9l")));

var $8c3a1089d1fcf68b$var$StatsigStore_1 = $8c3a1089d1fcf68b$var$__importStar((parcelRequire("l5qsq")));

var $7ZHru = parcelRequire("7ZHru");

var $8c3a1089d1fcf68b$var$StatsigLocalStorage_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("bR4MN")));

var $4wUef = parcelRequire("4wUef");

var $8c3a1089d1fcf68b$var$LogEvent_1 = $8c3a1089d1fcf68b$var$__importDefault((parcelRequire("ijtU9")));

var $IO1RE = parcelRequire("IO1RE");
var $8c3a1089d1fcf68b$var$StatsigClient = /** @class */ function() {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._sdkKey = null;
        this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) isManualExposure = false;
            var allocatedExperiment = "";
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure, _this._store.getBootstrapMetadata());
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new $b6DQS.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
        this._sdkKey = sdkKey;
        this._startTime = (0, $4wUef.now)();
        this._options = new $8c3a1089d1fcf68b$var$StatsigSDKOptions_1.default(options);
        this._errorBoundary = new $8c3a1089d1fcf68b$var$ErrorBoundary_1.default(sdkKey, this._options);
        this._ready = false;
        $8c3a1089d1fcf68b$var$StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, $IO1RE.loadOverridesFromLocalStorage)();
        this._identity = new $8c3a1089d1fcf68b$var$StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new $8c3a1089d1fcf68b$var$StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new $8c3a1089d1fcf68b$var$StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new $8c3a1089d1fcf68b$var$StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function() {
                return _this._delayedSetup();
            }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function(initializeValues) {
        var _this = this;
        this._errorBoundary._capture("setInitializeValues", function() {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function() {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function() {
        return $8c3a1089d1fcf68b$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("initializeAsync", function() {
                        return $8c3a1089d1fcf68b$var$__awaiter(_this, void 0, void 0, function() {
                            var user;
                            var _this = this;
                            return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                                if (this._pendingInitPromise != null) return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                                if (this._ready) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                this._initCalled = true;
                                if (this._options.localMode) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                user = this._identity._user;
                                this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                    return;
                                }).catch(function(e) {
                                    _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                    return {
                                        success: false,
                                        message: e.message
                                    };
                                }).then(function() {
                                    return;
                                }).finally(function() {
                                    return $8c3a1089d1fcf68b$var$__awaiter(_this, void 0, void 0, function() {
                                        return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                                            this._pendingInitPromise = null;
                                            this._ready = true;
                                            this._delayedSetup();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                            });
                        });
                    }, function() {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })
                ];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function() {
        var _this = this;
        return this._errorBoundary._capture("getEvaluationDetails", function() {
            return _this._store.getGlobalEvaluationDetails();
        }, function() {
            return {
                time: Date.now(),
                reason: $8c3a1089d1fcf68b$var$StatsigStore_1.EvaluationReason.Error
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
        return this._checkGateImpl(gateName, "checkGate");
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
        return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logGateExposure = function(gateName) {
        var _this = this;
        this._errorBoundary._swallow("logGateExposure", function() {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
        return this._getConfigImpl(configName, "getConfig");
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
        return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logConfigExposure = function(configName) {
        var _this = this;
        this._errorBoundary._swallow("logConfigExposure", function() {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function(experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function(experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function(layerName) {
        return this._getLayerImpl(layerName, "getLayer");
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
        return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow("logLayerParameterExposure", function() {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
        var _this = this;
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        this._errorBoundary._swallow("logEvent", function() {
            if (!_this._logger || !_this._identity._sdkKey) throw new $b6DQS.StatsigUninitializedError($b6DQS.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            if (typeof eventName !== "string" || eventName.length === 0) return;
            var event = (0, $8c3a1089d1fcf68b$var$LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function(user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture("updateUserWithValues", function() {
            if (!_this.initializeCalled()) throw new $b6DQS.StatsigUninitializedError($b6DQS.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            fireCompletionCallback = function(success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            _this._logger.resetDedupeKeys();
            fireCompletionCallback(true, null);
            return true;
        }, function() {
            fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function(user) {
        return $8c3a1089d1fcf68b$var$__awaiter(this, void 0, void 0, function() {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                updateStartTime = Date.now();
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("updateUser", function() {
                        return $8c3a1089d1fcf68b$var$__awaiter(_this, void 0, void 0, function() {
                            var currentUser;
                            var _this = this;
                            return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.initializeCalled()) throw new $b6DQS.StatsigUninitializedError($b6DQS.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                        fireCompletionCallback = function(success, error) {
                                            var cb = _this._options.updateUserCompletionCallback;
                                            cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                        };
                                        this._identity._user = this._normalizeUser(user);
                                        this._store.updateUser();
                                        this._logger.resetDedupeKeys();
                                        if (!(this._pendingInitPromise != null)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this._pendingInitPromise
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (this._options.localMode) {
                                            fireCompletionCallback(true, null);
                                            return [
                                                2 /*return*/ ,
                                                Promise.resolve(true)
                                            ];
                                        }
                                        currentUser = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                            _this._pendingInitPromise = null;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            this._pendingInitPromise.then(function() {
                                                fireCompletionCallback(true, null);
                                                return Promise.resolve(true);
                                            }).catch(function(error) {
                                                fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                return Promise.resolve(false);
                                            })
                                        ];
                                }
                            });
                        });
                    }, function() {
                        fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                        return Promise.resolve(false);
                    })
                ];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
        var _this = this;
        this._errorBoundary._swallow("shutdown", function() {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
        var _this = this;
        return this._errorBoundary._capture("getStableID", function() {
            return _this._identity._statsigMetadata.stableID;
        }, function() {
            return "";
        });
    };
    StatsigClient.prototype.initializeCalled = function() {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function(gate, result) {
        this._setOverride("gates", gate, result);
    };
    StatsigClient.prototype.overrideConfig = function(config, result) {
        this._setOverride("configs", config, result);
    };
    StatsigClient.prototype.overrideLayer = function(layer, result) {
        this._setOverride("layers", layer, result);
    };
    StatsigClient.prototype.setOverrides = function(overrides) {
        var _this = this;
        this._errorBoundary._swallow("setOverrides", function() {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, $IO1RE.makeEmptyOverrides)();
            (0, $IO1RE.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function() {
        var _this = this;
        return this._errorBoundary._capture("getOverrides", function() {
            return _this._overrides;
        }, function() {
            return (0, $IO1RE.makeEmptyOverrides)();
        });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function() {
        var _this = this;
        this._errorBoundary._swallow("delayedSetup", function() {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function() {
            /* noop */ });
        });
    };
    StatsigClient.prototype._normalizeUser = function(user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        } catch (error) {
            throw new $b6DQS.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
        }
        if (this._options.environment != null) userCopy = $8c3a1089d1fcf68b$var$__assign($8c3a1089d1fcf68b$var$__assign({}, userCopy), {
            statsigEnvironment: this._options.environment
        });
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function() {
        if (!this._store.isLoaded()) throw new $b6DQS.StatsigUninitializedError();
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function() {
        return {
            time: Date.now(),
            reason: $8c3a1089d1fcf68b$var$StatsigStore_1.EvaluationReason.Error
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
        if (timeout === void 0) timeout = this._options.initTimeoutMs;
        return $8c3a1089d1fcf68b$var$__awaiter(this, void 0, void 0, function() {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [
                    2 /*return*/ ,
                    this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                        var _a;
                        if (!(0, $7ZHru.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : "", _this._errorBoundary)) return;
                        if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                    }).then(function(json) {
                        return $8c3a1089d1fcf68b$var$__awaiter(_this, void 0, void 0, function() {
                            var _this = this;
                            return $8c3a1089d1fcf68b$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                        return $8c3a1089d1fcf68b$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a;
                                            return $8c3a1089d1fcf68b$var$__generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        if (!(0, $7ZHru.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : "", this._errorBoundary)) return [
                                                            2 /*return*/ 
                                                        ];
                                                        if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            this._store.save(user, json)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason($8c3a1089d1fcf68b$var$StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                        _b.label = 3;
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
            var result = _this._getGateFromStore(gateName);
            if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
            return result.gate.value === true;
        }, function() {
            return false;
        });
    };
    StatsigClient.prototype._getGateFromStore = function(gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== "string" || gateName.length === 0) throw new $b6DQS.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
        var _a;
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, this._store.mapExposures((_a = gate.secondary_exposures) !== null && _a !== void 0 ? _a : []), result.evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.configs[configName]) return new $8c3a1089d1fcf68b$var$DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                reason: $8c3a1089d1fcf68b$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var result = _this._getConfigFromStore(configName);
            if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
            return result;
        }, function() {
            return _this._getEmptyConfig(configName);
        });
    };
    StatsigClient.prototype._getConfigFromStore = function(configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== "string" || configName.length === 0) throw new $b6DQS.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.layers[layerName]) return $8c3a1089d1fcf68b$var$Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                reason: $8c3a1089d1fcf68b$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function() {
            return $8c3a1089d1fcf68b$var$Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== "string" || layerName.length === 0) throw new $b6DQS.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function(configName) {
        return new $8c3a1089d1fcf68b$var$DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function(type, key, result) {
        if (result == null) delete this._overrides[type][key];
        else this._overrides[type][key] = result;
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}();
module.exports.default = $8c3a1089d1fcf68b$var$StatsigClient;

});
parcelRegister("B3ZgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $06f68c99f43608c7$var$DynamicConfig = /** @class */ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
        this._onDefaultValueFallback = null;
        this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
        this._name = configName;
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
        var _a, _b;
        var val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue;
        var actualType = Array.isArray(val) ? "array" : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) return val;
            (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) return val;
        (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
        return defaultValue;
    };
    DynamicConfig.prototype.getValue = function(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        return this.value[key];
    };
    return DynamicConfig;
}();
module.exports.default = $06f68c99f43608c7$var$DynamicConfig;

});

parcelRegister("6QBBi", function(module, exports) {
"use strict";
var $4fc4c418e3783f38$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4fc4c418e3783f38$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExceptionEndpoint = void 0;

var $b6DQS = parcelRequire("b6DQS");
module.exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
var $4fc4c418e3783f38$var$ErrorBoundary = /** @class */ function() {
    function ErrorBoundary(sdkKey, options) {
        this._seen = new Set();
        this._sdkKey = sdkKey;
        this._options = options;
    }
    ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
        this._statsigMetadata = statsigMetadata;
    };
    ErrorBoundary.prototype._swallow = function(tag, task) {
        this._capture(tag, task, function() {
            return undefined;
        });
    };
    ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
        var _this = this;
        try {
            var result = task();
            if (result instanceof Promise) return result.catch(function(e) {
                return _this._onCaught(tag, e, recover, getExtraData);
            });
            return result;
        } catch (error) {
            return this._onCaught(tag, error, recover, getExtraData);
        }
    };
    ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
        var _this = this;
        if (this._options.disableAllLogging) return;
        try {
            var impl = function() {
                return $4fc4c418e3783f38$var$__awaiter(_this, void 0, void 0, function() {
                    var extra, _a, unwrapped, isError, name, info, metadata, body;
                    var _b;
                    return $4fc4c418e3783f38$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                if (!(typeof getExtraData === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    getExtraData()
                                ];
                            case 1:
                                _a = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = null;
                                _c.label = 3;
                            case 3:
                                extra = _a;
                                unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                isError = unwrapped instanceof Error;
                                name = isError ? unwrapped.name : "No Name";
                                if (this._seen.has(name)) return [
                                    2 /*return*/ 
                                ];
                                this._seen.add(name);
                                info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                body = JSON.stringify({
                                    tag: tag,
                                    exception: name,
                                    info: info,
                                    statsigMetadata: metadata,
                                    extra: extra !== null && extra !== void 0 ? extra : {}
                                });
                                return [
                                    2 /*return*/ ,
                                    fetch(module.exports.ExceptionEndpoint, {
                                        method: "POST",
                                        headers: {
                                            "STATSIG-API-KEY": this._sdkKey,
                                            "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                            "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                            "Content-Type": "application/json",
                                            "Content-Length": "".concat(body.length)
                                        },
                                        body: body
                                    })
                                ];
                        }
                    });
                });
            };
            impl().then(function() {
            /* noop */ }).catch(function() {
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    };
    ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
        if (error instanceof $b6DQS.StatsigUninitializedError || error instanceof $b6DQS.StatsigInvalidArgumentError) throw error; // Don't catch these
        console.error("[Statsig] An unexpected exception occurred.", error);
        this._logError(tag, error, getExtraData);
        return recover();
    };
    ErrorBoundary.prototype._getDescription = function(obj) {
        try {
            return JSON.stringify(obj);
        } catch (_a) {
            return "[Statsig] Failed to get string for error.";
        }
    };
    return ErrorBoundary;
}();
module.exports.default = $4fc4c418e3783f38$var$ErrorBoundary;

});
parcelRegister("b6DQS", function(module, exports) {
"use strict";
var $815f2af962ffbe28$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSDKKeyMismatchError = module.exports.StatsigInvalidArgumentError = module.exports.StatsigUninitializedError = module.exports.StatsigErrorMessage = void 0;
var $815f2af962ffbe28$var$StatsigErrorMessage;
(function(StatsigErrorMessage) {
    StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
    StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
    StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
})($815f2af962ffbe28$var$StatsigErrorMessage = module.exports.StatsigErrorMessage || (module.exports.StatsigErrorMessage = {}));
var $815f2af962ffbe28$var$StatsigUninitializedError = /** @class */ function(_super) {
    $815f2af962ffbe28$var$__extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : $815f2af962ffbe28$var$StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error);
module.exports.StatsigUninitializedError = $815f2af962ffbe28$var$StatsigUninitializedError;
var $815f2af962ffbe28$var$StatsigInvalidArgumentError = /** @class */ function(_super) {
    $815f2af962ffbe28$var$__extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error);
module.exports.StatsigInvalidArgumentError = $815f2af962ffbe28$var$StatsigInvalidArgumentError;
var $815f2af962ffbe28$var$StatsigSDKKeyMismatchError = /** @class */ function(_super) {
    $815f2af962ffbe28$var$__extends(StatsigSDKKeyMismatchError, _super);
    function StatsigSDKKeyMismatchError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
        return _this;
    }
    return StatsigSDKKeyMismatchError;
}(Error);
module.exports.StatsigSDKKeyMismatchError = $815f2af962ffbe28$var$StatsigSDKKeyMismatchError;

});


parcelRegister("bkVef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $840df46e9872a443$var$Layer = /** @class */ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
    };
    Layer.prototype.get = function(key, defaultValue, typeGuard) {
        var _this = this;
        var val = this._value[key];
        if (val == null) return defaultValue;
        var logAndReturn = function() {
            _this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    };
    Layer.prototype.getValue = function(key, defaultValue) {
        if (defaultValue == undefined) defaultValue = null;
        var val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    };
    Layer.prototype._logLayerParameterExposure = function(parameterName) {
        var _a;
        (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
    };
    return Layer;
}();
module.exports.default = $840df46e9872a443$var$Layer;

});

parcelRegister("46lQA", function(module, exports) {
"use strict";
var $2fc8ab5bf9e01cc0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kAPRn = parcelRequire("kAPRn");

var $iFXkX = parcelRequire("iFXkX");

var $2fc8ab5bf9e01cc0$var$StatsigLocalStorage_1 = $2fc8ab5bf9e01cc0$var$__importDefault((parcelRequire("bR4MN")));

var $3mnDz = parcelRequire("3mnDz");
var $2fc8ab5bf9e01cc0$var$Identity = /** @class */ function() {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = "js-lite";
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = $3mnDz.version;
        var stableID = overrideStableID;
        stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : $2fc8ab5bf9e01cc0$var$StatsigLocalStorage_1.default.getItem($kAPRn.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion
        };
    }
    Identity.prototype.saveStableID = function() {
        if (this._statsigMetadata.stableID != null) $2fc8ab5bf9e01cc0$var$StatsigLocalStorage_1.default.setItem($kAPRn.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
    };
    Identity.prototype.getUserCacheKey = function() {
        return (0, $iFXkX.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function() {
        var uuid = "";
        for(var i = 0; i < 32; i++){
            if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
            var randomDigit = Math.random() * 16 | 0;
            if (i === 12) uuid += "4";
            else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
            else uuid += randomDigit.toString(16);
        }
        return uuid;
    };
    return Identity;
}();
module.exports.default = $2fc8ab5bf9e01cc0$var$Identity;

});
parcelRegister("kAPRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCAL_STORAGE_KEYS = module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = module.exports.STATSIG_STABLE_ID_KEY = module.exports.INTERNAL_STORE_KEY = void 0;
module.exports.INTERNAL_STORE_KEY = "STATSIG_STORE";
module.exports.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
module.exports.LOCAL_STORAGE_KEYS = {
    INTERNAL_STORE_KEY: true,
    STATSIG_STABLE_ID_KEY: true,
    STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
};

});

parcelRegister("iFXkX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserCacheKey = module.exports.getSortedObject = module.exports.djb2HashForObject = module.exports.getHashValue = module.exports.SimpleHash = void 0;
function $d98a156a04b878be$var$SimpleHash(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
module.exports.SimpleHash = $d98a156a04b878be$var$SimpleHash;
function $d98a156a04b878be$var$getHashValue(value, hash_used) {
    if (hash_used === "none") return value;
    return $d98a156a04b878be$var$SimpleHash(value);
}
module.exports.getHashValue = $d98a156a04b878be$var$getHashValue;
function $d98a156a04b878be$var$djb2HashForObject(object) {
    return $d98a156a04b878be$var$SimpleHash(JSON.stringify($d98a156a04b878be$var$getSortedObject(object)));
}
module.exports.djb2HashForObject = $d98a156a04b878be$var$djb2HashForObject;
function $d98a156a04b878be$var$getSortedObject(object) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (value instanceof Object) value = $d98a156a04b878be$var$getSortedObject(value);
        sortedObject[key] = value;
    });
    return sortedObject;
}
module.exports.getSortedObject = $d98a156a04b878be$var$getSortedObject;
function $d98a156a04b878be$var$getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
        var _c = _b[_i], type = _c[0], value = _c[1];
        key += ";".concat(type, ":").concat(value);
    }
    return $d98a156a04b878be$var$SimpleHash(key);
}
module.exports.getUserCacheKey = $d98a156a04b878be$var$getUserCacheKey;

});

parcelRegister("bR4MN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8a185b5420e3beff$var$StatsigLocalStorage = /** @class */ function() {
    function StatsigLocalStorage() {}
    StatsigLocalStorage.getItem = function(key) {
        var _a;
        try {
            if (this.isStorageAccessible()) return window.localStorage.getItem(key);
        } catch (e) {}
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigLocalStorage.setItem = function(key, value) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.setItem(key, value);
                return;
            }
        } catch (e) {}
        this.fallbackSessionCache[key] = value;
    };
    StatsigLocalStorage.removeItem = function(key) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.removeItem(key);
                return;
            }
        } catch (e) {}
        delete this.fallbackSessionCache[key];
    };
    StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
        if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
        if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
        var canAccess = this.canAccessStorageAccessible;
        if (ignoreDisabledOption) return canAccess;
        return !this.disabled && canAccess;
    };
    StatsigLocalStorage.disabled = false;
    StatsigLocalStorage.fallbackSessionCache = {};
    StatsigLocalStorage.canAccessStorageAccessible = null;
    return StatsigLocalStorage;
}();
module.exports.default = $8a185b5420e3beff$var$StatsigLocalStorage;

});

parcelRegister("3mnDz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
// Generated by genversion.
module.exports.version = "1.6.0";

});


parcelRegister("aDICl", function(module, exports) {
"use strict";
var $7bf02805c8bf3b6f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7bf02805c8bf3b6f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7bf02805c8bf3b6f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7bf02805c8bf3b6f$var$LogEvent_1 = $7bf02805c8bf3b6f$var$__importDefault((parcelRequire("ijtU9")));

var $ht8xQ = parcelRequire("ht8xQ");

var $kAPRn = parcelRequire("kAPRn");

var $7bf02805c8bf3b6f$var$StatsigLocalStorage_1 = $7bf02805c8bf3b6f$var$__importDefault((parcelRequire("bR4MN")));
var $7bf02805c8bf3b6f$var$INTERNAL_EVENT_PREFIX = "statsig::";
var $7bf02805c8bf3b6f$var$CONFIG_EXPOSURE_EVENT = $7bf02805c8bf3b6f$var$INTERNAL_EVENT_PREFIX + "config_exposure";
var $7bf02805c8bf3b6f$var$LAYER_EXPOSURE_EVENT = $7bf02805c8bf3b6f$var$INTERNAL_EVENT_PREFIX + "layer_exposure";
var $7bf02805c8bf3b6f$var$GATE_EXPOSURE_EVENT = $7bf02805c8bf3b6f$var$INTERNAL_EVENT_PREFIX + "gate_exposure";
var $7bf02805c8bf3b6f$var$LOG_FAILURE_EVENT = $7bf02805c8bf3b6f$var$INTERNAL_EVENT_PREFIX + "log_event_failed";
var $7bf02805c8bf3b6f$var$DEFAULT_VALUE_WARNING = $7bf02805c8bf3b6f$var$INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
var $7bf02805c8bf3b6f$var$MS_RETRY_LOGS_CUTOFF = 432000000;
var $7bf02805c8bf3b6f$var$MAX_BATCHES_TO_RETRY = 100;
var $7bf02805c8bf3b6f$var$MAX_FAILED_EVENTS = 1000;
var $7bf02805c8bf3b6f$var$MAX_LOCAL_STORAGE_SIZE = 1024 * $7bf02805c8bf3b6f$var$MAX_FAILED_EVENTS;
var $7bf02805c8bf3b6f$var$StatsigLogger = /** @class */ function() {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function(user, message, metadata) {
            var defaultValueEvent = (0, $7bf02805c8bf3b6f$var$LogEvent_1.default)($7bf02805c8bf3b6f$var$DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function(event) {
        if (this._options.disableAllLogging) return;
        try {
            if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
            }
        } catch (_e) {}
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
    };
    StatsigLogger.prototype.resetDedupeKeys = function() {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var gateExposure = (0, $7bf02805c8bf3b6f$var$LogEvent_1.default)($7bf02805c8bf3b6f$var$GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $7bf02805c8bf3b6f$var$LogEvent_1.default)($7bf02805c8bf3b6f$var$CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason
        ].join("|");
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $7bf02805c8bf3b6f$var$LogEvent_1.default)($7bf02805c8bf3b6f$var$LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function() {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function(isClosing) {
        var _this = this;
        if (isClosing === void 0) isClosing = false;
        if (this._queue.length === 0) return;
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
        navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now()
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network.postToEndpoint($ht8xQ.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata
        }, 3 /* retries */ , 1000 /* backoff */ , 0 /* retry attempt */ , isClosing /* useKeepalive */ ).then(function(response) {
            if (!response.ok) throw response;
        }).catch(function(error) {
            if (typeof error.text === "function") error.text().then(function(errorText) {
                _this._errorBoundary._logError($7bf02805c8bf3b6f$var$LOG_FAILURE_EVENT, error, function() {
                    return $7bf02805c8bf3b6f$var$__awaiter(_this, void 0, void 0, function() {
                        return $7bf02805c8bf3b6f$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: errorText
                                }
                            ];
                        });
                    });
                });
            });
            else _this._errorBoundary._logError($7bf02805c8bf3b6f$var$LOG_FAILURE_EVENT, error, function() {
                return $7bf02805c8bf3b6f$var$__awaiter(_this, void 0, void 0, function() {
                    return $7bf02805c8bf3b6f$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            {
                                eventCount: oldQueue.length,
                                error: error.message
                            }
                        ];
                    });
                });
            });
            processor._newFailedRequest($7bf02805c8bf3b6f$var$LOG_FAILURE_EVENT, oldQueue);
        }).finally(function() {
            return $7bf02805c8bf3b6f$var$__awaiter(_this, void 0, void 0, function() {
                return $7bf02805c8bf3b6f$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!isClosing) return [
                                3 /*break*/ ,
                                2
                            ];
                            if (this._queue.length > 0) {
                                this._addFailedRequest({
                                    events: this._queue,
                                    statsigMetadata: statsigMetadata,
                                    time: Date.now()
                                });
                                // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                this._queue = [];
                            }
                            return [
                                4 /*yield*/ ,
                                processor._saveFailedRequests()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    StatsigLogger.prototype.sendSavedRequests = function() {
        return $7bf02805c8bf3b6f$var$__awaiter(this, void 0, void 0, function() {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return $7bf02805c8bf3b6f$var$__generator(this, function(_a) {
                fireAndForget = false;
                failedRequests = $7bf02805c8bf3b6f$var$StatsigLocalStorage_1.default.getItem($kAPRn.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [
                        2 /*return*/ 
                    ];
                }
                if (failedRequests.length > $7bf02805c8bf3b6f$var$MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function(requestBody) {
                        if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint($ht8xQ.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                            if (!response.ok) throw Error(response.status + "");
                        }).catch(function(_e) {
                            if (fireAndForget) return;
                            _this._addFailedRequest(requestBody);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                } catch (_e) {} finally{
                    this._clearLocalStorageRequests();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._init = function() {
        var _this = this;
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("blur", function() {
                return _this.flush(true);
            });
            window.addEventListener("beforeunload", function() {
                return _this.flush(true);
            });
            window.addEventListener("load", function() {
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            });
        }
        if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
            _this.flush(document.visibilityState !== "visible");
        });
        if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
        return;
        if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
        return;
        var me = this;
        this._flushInterval = setInterval(function() {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function() {
            return _this.flush();
        }, 100);
        setTimeout(function() {
            return _this.flush();
        }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function(key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600000) return false;
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function() {
        return $7bf02805c8bf3b6f$var$__awaiter(this, void 0, void 0, function() {
            var requestsCopy;
            return $7bf02805c8bf3b6f$var$__generator(this, function(_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > $7bf02805c8bf3b6f$var$MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    $7bf02805c8bf3b6f$var$StatsigLocalStorage_1.default.setItem($kAPRn.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function(requestBody) {
        if (requestBody.time < Date.now() - $7bf02805c8bf3b6f$var$MS_RETRY_LOGS_CUTOFF) return;
        if (this._failedLogEvents.length > $7bf02805c8bf3b6f$var$MAX_BATCHES_TO_RETRY) return;
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > $7bf02805c8bf3b6f$var$MAX_FAILED_EVENTS) return;
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function() {
        $7bf02805c8bf3b6f$var$StatsigLocalStorage_1.default.removeItem($kAPRn.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function(name, queue) {
        if (this._loggedErrors.has(name)) return;
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now()
        });
        this._saveFailedRequests().then(function() {});
    };
    return StatsigLogger;
}();
module.exports.default = $7bf02805c8bf3b6f$var$StatsigLogger;

});
parcelRegister("ijtU9", function(module, exports) {
"use strict";
var $d55132cbc910d499$var$__assign = module.exports && module.exports.__assign || function() {
    $d55132cbc910d499$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d55132cbc910d499$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $d55132cbc910d499$var$makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
    if (value === void 0) value = null;
    if (metadata === void 0) metadata = null;
    var logUser = user;
    if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
        logUser = $d55132cbc910d499$var$__assign({}, user);
        delete logUser.privateAttributes;
    }
    return {
        time: Date.now(),
        eventName: eventName,
        statsigMetadata: statsigMetadata,
        user: logUser,
        value: value,
        metadata: metadata,
        secondaryExposures: secondaryExposures
    };
}
module.exports.default = $d55132cbc910d499$var$makeLogEvent;

});

parcelRegister("ht8xQ", function(module, exports) {
"use strict";
var $cb7bc5f20df8b709$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cb7bc5f20df8b709$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEndpoint = void 0;
var $cb7bc5f20df8b709$var$StatsigEndpoint;
(function(StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})($cb7bc5f20df8b709$var$StatsigEndpoint = module.exports.StatsigEndpoint || (module.exports.StatsigEndpoint = {}));
var $cb7bc5f20df8b709$var$NO_CONTENT = 204;
var $cb7bc5f20df8b709$var$StatsigNetwork = /** @class */ function() {
    function StatsigNetwork(options, identity, errorBoundary) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true
        };
        this.canUseKeepalive = false;
        this._options = options;
        this._identity = identity;
        this._errorBoundary = errorBoundary;
        this.leakyBucket = {};
        this._init();
    }
    StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
        var input = {
            user: user,
            statsigMetadata: this._identity._statsigMetadata,
            sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
            hash: "djb2",
            previousDerivedFields: previousDerivedFields
        };
        return this._postWithTimeout($cb7bc5f20df8b709$var$StatsigEndpoint.Initialize, input, timeout, 3);
    };
    StatsigNetwork.prototype.sendLogBeacon = function(payload) {
        if (this._options.localMode) return true;
        var url = new URL(this._options.eventLoggingApi + $cb7bc5f20df8b709$var$StatsigEndpoint.LogEventBeacon);
        url.searchParams.append("k", this._identity._sdkKey);
        payload.clientTime = Date.now() + "";
        var stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        } catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    };
    StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, retryAttempt, useKeepalive) {
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        if (retryAttempt === void 0) retryAttempt = 0;
        if (useKeepalive === void 0) useKeepalive = false;
        return $cb7bc5f20df8b709$var$__awaiter(this, void 0, void 0, function() {
            var api, url, counter, postBody, statsigMetadata, params;
            var _this = this;
            return $cb7bc5f20df8b709$var$__generator(this, function(_a) {
                if (this._options.localMode) return [
                    2 /*return*/ ,
                    Promise.reject("no network requests in localMode")
                ];
                if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                return [
                    2 /*return*/ ,
                    Promise.reject("fetch is not defined")
                ];
                if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                return [
                    2 /*return*/ ,
                    Promise.reject("window is not defined")
                ];
                api = [
                    $cb7bc5f20df8b709$var$StatsigEndpoint.Initialize
                ].includes(endpointName) ? this._options.api : retryAttempt > 0 ? this._options.eventLoggingApiForRetries : this._options.eventLoggingApi;
                url = api + endpointName;
                counter = this.leakyBucket[url];
                if (counter != null && counter >= 30) return [
                    2 /*return*/ ,
                    Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                ];
                if (counter == null) this.leakyBucket[url] = 1;
                else this.leakyBucket[url] = counter + 1;
                postBody = JSON.stringify(body);
                statsigMetadata = this._identity._statsigMetadata;
                params = {
                    method: "POST",
                    body: postBody,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "STATSIG-API-KEY": this._identity._sdkKey,
                        "STATSIG-CLIENT-TIME": Date.now() + "",
                        "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                        "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                    }
                };
                if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                return [
                    2 /*return*/ ,
                    fetch(url, params).then(function(res) {
                        return $cb7bc5f20df8b709$var$__awaiter(_this, void 0, void 0, function() {
                            var networkResponse, text, errorText;
                            return $cb7bc5f20df8b709$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        networkResponse = res;
                                        if (!(res.status === $cb7bc5f20df8b709$var$NO_CONTENT)) return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                        networkResponse.data = {
                                            has_updates: false,
                                            is_no_content: true
                                        };
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 2:
                                        text = _a.sent();
                                        networkResponse.data = JSON.parse(text);
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve(networkResponse)
                                        ];
                                    case 4:
                                        if (!this.retryCodes[res.status]) retries = 0;
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 5:
                                        errorText = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                        ];
                                }
                            });
                        });
                    }).catch(function(e) {
                        if (retries > 0) return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, retryAttempt + 1, useKeepalive).then(resolve).catch(reject);
                            }, backoff);
                        });
                        return Promise.reject(e);
                    }).finally(function() {
                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                    })
                ];
            });
        });
    };
    StatsigNetwork.prototype.supportsKeepalive = function() {
        return this.canUseKeepalive;
    };
    StatsigNetwork.prototype._init = function() {
        if (!this._options.disableNetworkKeepalive) try {
            this.canUseKeepalive = "keepalive" in new Request("");
        } catch (_e) {}
    };
    StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
        var _this = this;
        if (timeout === void 0) timeout = 0;
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        var hasTimedOut = false;
        var timer = null;
        var cachedReturnValue = null;
        var eventuals = [];
        var eventually = function(boundScope) {
            return function(fn) {
                if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                else eventuals.push(fn);
                return boundScope;
            };
        };
        if (timeout != 0) timer = new Promise(function(resolve, reject) {
            setTimeout(function() {
                hasTimedOut = true;
                reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
            }, timeout);
        });
        var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
            if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
            if (typeof res.data !== "object") {
                var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                    return $cb7bc5f20df8b709$var$__awaiter(_this, void 0, void 0, function() {
                        return $cb7bc5f20df8b709$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this._getErrorData(endpointName, body, retries, backoff, res)
                            ];
                        });
                    });
                });
                return Promise.reject(error);
            }
            var json = res.data;
            return _this._errorBoundary._capture("postWithTimeout", function() {
                return $cb7bc5f20df8b709$var$__awaiter(_this, void 0, void 0, function() {
                    return $cb7bc5f20df8b709$var$__generator(this, function(_a) {
                        cachedReturnValue = json;
                        if (hasTimedOut) {
                            eventuals.forEach(function(fn) {
                                return fn(json);
                            });
                            eventuals = [];
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(json)
                        ];
                    });
                });
            }, function() {
                return Promise.resolve({});
            }, function() {
                return $cb7bc5f20df8b709$var$__awaiter(_this, void 0, void 0, function() {
                    return $cb7bc5f20df8b709$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            this._getErrorData(endpointName, body, retries, backoff, res)
                        ];
                    });
                });
            });
        }).catch(function(e) {
            return Promise.reject(e);
        });
        var racingPromise = timer ? Promise.race([
            fetchPromise,
            timer
        ]) : fetchPromise;
        racingPromise.eventually = eventually(racingPromise);
        return racingPromise;
    };
    StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
        var _a;
        return $cb7bc5f20df8b709$var$__awaiter(this, void 0, void 0, function() {
            var headers_1;
            return $cb7bc5f20df8b709$var$__generator(this, function(_b) {
                try {
                    headers_1 = {};
                    ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                        headers_1[key] = value;
                    });
                    return [
                        2 /*return*/ ,
                        {
                            responseInfo: {
                                headers: headers_1,
                                status: res.status,
                                statusText: res.statusText,
                                type: res.type,
                                url: res.url,
                                redirected: res.redirected,
                                bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                            },
                            requestInfo: {
                                endpointName: endpointName,
                                bodySnippet: JSON.stringify(body).slice(0, 500),
                                retries: retries,
                                backoff: backoff
                            }
                        }
                    ];
                } catch (_e) {
                    return [
                        2 /*return*/ ,
                        {
                            statusText: "statsig::failed to extract extra data"
                        }
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StatsigNetwork;
}();
module.exports.default = $cb7bc5f20df8b709$var$StatsigNetwork;

});


parcelRegister("4By9l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
var $35a51b8e69d5a0ed$var$DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
var $35a51b8e69d5a0ed$var$DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
module.exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
var $35a51b8e69d5a0ed$var$StatsigSDKOptions = /** @class */ function() {
    function StatsigSDKOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (options == null) options = {};
        var api = (_a = options.api) !== null && _a !== void 0 ? _a : $35a51b8e69d5a0ed$var$DEFAULT_FEATURE_GATE_API;
        this.api = api.endsWith("/") ? api : api + "/";
        this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
        this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
        this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
            default: 10000,
            min: 1000,
            max: 60000
        });
        this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
            default: 100,
            min: 2,
            max: 500
        });
        this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
        this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
        this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
        this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : module.exports.INIT_TIMEOUT_DEFAULT_MS;
        this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
        this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
        this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
        var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : $35a51b8e69d5a0ed$var$DEFAULT_EVENT_LOGGING_API;
        this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
        var eventLoggingApiForRetries = (_m = options.eventLoggingApiForRetries) !== null && _m !== void 0 ? _m : eventLoggingApi;
        this.eventLoggingApiForRetries = eventLoggingApiForRetries.endsWith("/") ? eventLoggingApiForRetries : eventLoggingApiForRetries + "/";
        this.disableLocalStorage = (_o = options.disableLocalStorage) !== null && _o !== void 0 ? _o : false;
        this.ignoreWindowUndefined = (_p = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _p !== void 0 ? _p : false;
        this.updateUserCompletionCallback = (_q = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _q !== void 0 ? _q : null;
        this.disableAllLogging = (_r = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _r !== void 0 ? _r : false;
    }
    StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
        if (input == null) return bounds.default;
        return Math.max(Math.min(input, bounds.max), bounds.min);
    };
    return StatsigSDKOptions;
}();
module.exports.default = $35a51b8e69d5a0ed$var$StatsigSDKOptions;

});

parcelRegister("l5qsq", function(module, exports) {
"use strict";
var $f59e9687c41002d7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f59e9687c41002d7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f59e9687c41002d7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = void 0;

var $f59e9687c41002d7$var$DynamicConfig_1 = $f59e9687c41002d7$var$__importDefault((parcelRequire("B3ZgU")));

var $f59e9687c41002d7$var$Layer_1 = $f59e9687c41002d7$var$__importDefault((parcelRequire("bkVef")));

var $f59e9687c41002d7$var$BootstrapValidator_1 = $f59e9687c41002d7$var$__importDefault((parcelRequire("zcHoA")));

var $kAPRn = parcelRequire("kAPRn");

var $iFXkX = parcelRequire("iFXkX");

var $f59e9687c41002d7$var$StatsigLocalStorage_1 = $f59e9687c41002d7$var$__importDefault((parcelRequire("bR4MN")));
var $f59e9687c41002d7$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})($f59e9687c41002d7$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
var $f59e9687c41002d7$var$MAX_USER_VALUE_CACHED = 10;
var $f59e9687c41002d7$var$StatsigStore = /** @class */ function() {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = $f59e9687c41002d7$var$EvaluationReason.Uninitialized;
        if (initializeValues) this.bootstrap(initializeValues);
        else this._loadFromLocalStorage();
    }
    StatsigStore.prototype.updateUser = function() {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function(initializeValues) {
        var _a, _b, _c, _d, _f, _g, _h;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = $f59e9687c41002d7$var$BootstrapValidator_1.default.isValid(user, initializeValues) ? $f59e9687c41002d7$var$EvaluationReason.Bootstrap : $f59e9687c41002d7$var$EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = (_d = initializeValues.time) !== null && _d !== void 0 ? _d : Date.now();
            this._userValues.exposures = (_f = initializeValues.exposures) !== null && _f !== void 0 ? _f : [];
            this._userValues.hash_used = (_g = initializeValues.hash_used) !== null && _g !== void 0 ? _g : "djb2";
            this._values[key] = this._userValues;
            this._reason = reason;
            var generatorSDKInfo = (_h = initializeValues.sdkInfo) !== null && _h !== void 0 ? _h : initializeValues.sdk_info;
            this._userValues.bootstrapMetadata = {};
            if (generatorSDKInfo != null) this._userValues.bootstrapMetadata.generatorSDKInfo = generatorSDKInfo;
            if (initializeValues.user != null) this._userValues.bootstrapMetadata.user = initializeValues.user;
            if (initializeValues.time != null) this._userValues.bootstrapMetadata.lcut = initializeValues.time;
        } catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.getBootstrapMetadata = function() {
        var _a;
        return (_a = this._userValues.bootstrapMetadata) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.isLoaded = function() {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function(user) {
        var userHash = (0, $iFXkX.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.time;
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function(user) {
        var userHash = (0, $iFXkX.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function(evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
        if (updateState === void 0) updateState = true;
        return $f59e9687c41002d7$var$__awaiter(this, void 0, void 0, function() {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return $f59e9687c41002d7$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        requestedUserCacheKey = (0, $iFXkX.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                            return userValues;
                        });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = $f59e9687c41002d7$var$EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._writeValuesToStorage(this._values)
                        ];
                    case 1:
                        _a._values = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function(gateName) {
        var _a, _b;
        var gateNameHash = (0, $iFXkX.getHashValue)(gateName, this._userValues.hash_used);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: "",
            secondary_exposures: []
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) gateValue = value;
        gateValue.secondary_exposures = this.mapExposures((_b = gateValue.secondary_exposures) !== null && _b !== void 0 ? _b : []);
        details = this._getEvaluationDetails(value != null);
        return {
            evaluationDetails: details,
            gate: gateValue
        };
    };
    StatsigStore.prototype.mapExposures = function(exposures) {
        var _this = this;
        return exposures.map(function(exposure) {
            var _a;
            if (typeof exposure === "string") return ((_a = _this._userValues.exposures) !== null && _a !== void 0 ? _a : {})[exposure];
            return exposure;
        });
    };
    StatsigStore.prototype.getConfig = function(configName) {
        var _a, _b;
        var configNameHash = (0, $iFXkX.getHashValue)(configName, this._userValues.hash_used);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        } else {
            details = this._getEvaluationDetails(false);
            configValue = new $f59e9687c41002d7$var$DynamicConfig_1.default(configName, {}, "", details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
        var _a, _b, _c, _d, _f;
        var latestValue = this._getLatestValue(layerName, "layer_configs");
        var details = this._getEvaluationDetails(latestValue != null);
        return $f59e9687c41002d7$var$Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, this.mapExposures((_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures) !== null && _c !== void 0 ? _c : []), this.mapExposures((_d = latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures) !== null && _d !== void 0 ? _d : []), (_f = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _f !== void 0 ? _f : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function() {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : $f59e9687c41002d7$var$EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function() {
        this._parseCachedValues($f59e9687c41002d7$var$StatsigLocalStorage_1.default.getItem($kAPRn.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function(allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        } catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage($kAPRn.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function() {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = $f59e9687c41002d7$var$EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = $f59e9687c41002d7$var$EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function(key) {
        $f59e9687c41002d7$var$StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, $iFXkX.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function() {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
        return $f59e9687c41002d7$var$__awaiter(this, void 0, void 0, function() {
            var filteredValues;
            return $f59e9687c41002d7$var$__generator(this, function(_a) {
                filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) return 1;
                    if (b == null) return -1;
                    return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                }).slice(0, $f59e9687c41002d7$var$MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                $f59e9687c41002d7$var$StatsigLocalStorage_1.default.setItem($kAPRn.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [
                    2 /*return*/ ,
                    valuesToWrite
                ];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, $iFXkX.getHashValue)(name, this._userValues.hash_used);
        return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
    };
    StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
        var _a, _b, _c, _d;
        return new $f59e9687c41002d7$var$DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, this.mapExposures((_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures) !== null && _c !== void 0 ? _c : []), (_d = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _d !== void 0 ? _d : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
        var _a;
        if (valueExists) return {
            reason: this._reason,
            time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
        };
        else return {
            reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == $f59e9687c41002d7$var$EvaluationReason.Uninitialized ? $f59e9687c41002d7$var$EvaluationReason.Uninitialized : $f59e9687c41002d7$var$EvaluationReason.Unrecognized,
            time: Date.now()
        };
    };
    StatsigStore.prototype._resetUserValues = function() {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields,
            hash_used: data.hash_used
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
        var _this = this;
        return function(config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) return;
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType
            });
        };
    };
    return StatsigStore;
}();
module.exports.default = $f59e9687c41002d7$var$StatsigStore;

});
parcelRegister("zcHoA", function(module, exports) {
"use strict";
var $069d1ebdca06e482$var$__assign = module.exports && module.exports.__assign || function() {
    $069d1ebdca06e482$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $069d1ebdca06e482$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $069d1ebdca06e482$var$BootstrapValidator = /** @class */ function() {
    function BootstrapValidator() {}
    BootstrapValidator.isValid = function(user, values) {
        try {
            var evaluatedKeys = values["evaluated_keys"];
            if (!evaluatedKeys) {
                var user_1 = values["user"];
                if (user_1) {
                    evaluatedKeys = {};
                    evaluatedKeys["userID"] = user_1["userID"];
                    if (user_1["customIDs"]) evaluatedKeys["customIDs"] = user_1["customIDs"];
                }
            }
            if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
            var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
            var userToCompare = user == null ? null : this.copyObject(user);
            return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
        } catch (error) {
        // This is best-effort. If we fail, return true.
        }
        return true;
    };
    BootstrapValidator.validate = function(one, two) {
        if (one == null) return two == null;
        else if (two == null) return false;
        for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === "stableID") continue;
            if (typeof value !== typeof two[key]) return false;
            if (typeof value === "string") {
                if (value !== two[key]) return false;
            } else if (typeof value === "object") return this.validate(value, two[key]);
            else // unexpected
            return false;
        }
        return true;
    };
    BootstrapValidator.copyObject = function(obj) {
        if (obj == null) return null;
        var copy = {};
        if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
        if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
            var customIDs = $069d1ebdca06e482$var$__assign({}, obj.customIDs);
            delete customIDs["stableID"];
            if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
        }
        return copy;
    };
    return BootstrapValidator;
}();
module.exports.default = $069d1ebdca06e482$var$BootstrapValidator;

});


parcelRegister("7ZHru", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifySDKKeyUsed = void 0;

var $b6DQS = parcelRequire("b6DQS");

var $iFXkX = parcelRequire("iFXkX");
function $5d1fedae890beb35$var$verifySDKKeyUsed(json, sdkKey, errorBoundary) {
    var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
    if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, $iFXkX.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "")) {
        errorBoundary._logError("fetchAndSaveValues", new $b6DQS.StatsigSDKKeyMismatchError("The SDK key provided does not match the one used to generate values."));
        return false;
    }
    return true;
}
module.exports.verifySDKKeyUsed = $5d1fedae890beb35$var$verifySDKKeyUsed;

});

parcelRegister("4wUef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.difference = module.exports.now = void 0;
function $34c5c47a51fb835c$var$now() {
    if (typeof performance === "undefined" || !performance) return Date.now();
    return performance.now() | 0;
}
module.exports.now = $34c5c47a51fb835c$var$now;
function $34c5c47a51fb835c$var$difference(time) {
    return $34c5c47a51fb835c$var$now() - time;
}
module.exports.difference = $34c5c47a51fb835c$var$difference;

});

parcelRegister("IO1RE", function(module, exports) {
"use strict";
var $086aeae8053b83fc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.saveOverridesToLocalStorage = module.exports.loadOverridesFromLocalStorage = module.exports.makeEmptyOverrides = module.exports.STORAGE_KEY = void 0;

var $086aeae8053b83fc$var$StatsigLocalStorage_1 = $086aeae8053b83fc$var$__importDefault((parcelRequire("bR4MN")));
module.exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
function $086aeae8053b83fc$var$makeEmptyOverrides() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
}
module.exports.makeEmptyOverrides = $086aeae8053b83fc$var$makeEmptyOverrides;
function $086aeae8053b83fc$var$loadOverridesFromLocalStorage() {
    var raw = $086aeae8053b83fc$var$StatsigLocalStorage_1.default.getItem(module.exports.STORAGE_KEY);
    if (raw) try {
        return JSON.parse(raw);
    } catch (error) {
    // noop
    }
    return $086aeae8053b83fc$var$makeEmptyOverrides();
}
module.exports.loadOverridesFromLocalStorage = $086aeae8053b83fc$var$loadOverridesFromLocalStorage;
function $086aeae8053b83fc$var$saveOverridesToLocalStorage(overrides) {
    $086aeae8053b83fc$var$StatsigLocalStorage_1.default.setItem(module.exports.STORAGE_KEY, JSON.stringify(overrides));
}
module.exports.saveOverridesToLocalStorage = $086aeae8053b83fc$var$saveOverridesToLocalStorage;

});


parcelRegister("fEgMm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9780bc9ae46347e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<80619f5859d3bb24bcc0918c377c5edd>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9780bc9ae46347e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rank",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "acceptedAnswersCreated",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answersCreated",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "articlesCreated",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kudosReceived",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPosts",
                "storageKey": null
            }
        ],
        "type": "UnifiedForumsSnapshot",
        "abstractKey": null
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "StatsSnapshotQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "forums",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "snapshot",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedForums",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v5 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StatsSnapshotQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "forums",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "snapshot",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedForums",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        v3 /*: any*/ 
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v5 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "240bae1dfc1db346907fd5aa44217e4c",
            "id": null,
            "metadata": {},
            "name": "StatsSnapshotQuery",
            "operationKind": "query",
            "text": "query StatsSnapshotQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        forums {\n          __typename\n          ... on UnifiedForums {\n            id\n            snapshot {\n              __typename\n              ... on UnifiedForumsSnapshot {\n                id\n                rank\n                acceptedAnswersCreated\n                answersCreated\n                articlesCreated\n                kudosReceived\n                totalPosts\n              }\n              ... on UnifiedQueryError {\n                identifier\n                message\n                extensions {\n                  errorType\n                  statusCode\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$9780bc9ae46347e2$var$node.hash = "c44743427e63c17dc954262421103bd0";
var $9780bc9ae46347e2$export$2e2bcd8739ae039 = $9780bc9ae46347e2$var$node;

});

parcelRegister("6Zmxz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c7538351a6e18c67$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62e8a83843ff6a864b15efc53bd3d815>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7538351a6e18c67$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nickname",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
            }
        ],
        "type": "AtlassianAccountUser",
        "abstractKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "AtlassianAccountAnyUserQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v1 /*: any*/ ,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AtlassianAccountAnyUserQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v1 /*: any*/ ,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        v2 /*: any*/ ,
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b6e0f0528480a037829f3e1855a2ae6c",
            "id": null,
            "metadata": {},
            "name": "AtlassianAccountAnyUserQuery",
            "operationKind": "query",
            "text": "query AtlassianAccountAnyUserQuery(\n  $accountId: ID!\n) {\n  user(accountId: $accountId) {\n    __typename\n    ... on AtlassianAccountUser {\n      nickname\n      picture\n    }\n    id\n  }\n}\n"
        }
    };
}();
$c7538351a6e18c67$var$node.hash = "8752e7c61efee1493eb464e590aeee0b";
var $c7538351a6e18c67$export$2e2bcd8739ae039 = $c7538351a6e18c67$var$node;

});

parcelRegister("9CU7A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $919f3bd7ff942759$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7e22758aaca56f29521c5b6fcb0cd11>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $919f3bd7ff942759$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aaid",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isProfileOwnerConsented",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionUrl",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastCompletedDate",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedProfileBadgeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedProfileBadge",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            v8 /*: any*/ ,
                            v4 /*: any*/ ,
                            v9 /*: any*/ ,
                            v10 /*: any*/ ,
                            v11 /*: any*/ ,
                            v12 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "category",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            v13 /*: any*/ 
        ],
        "type": "UnifiedProfileBadgesConnection",
        "abstractKey": null
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedProfileBadgeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedProfileBadge",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            v8 /*: any*/ ,
                            v4 /*: any*/ ,
                            v9 /*: any*/ ,
                            v10 /*: any*/ ,
                            v11 /*: any*/ ,
                            v12 /*: any*/ 
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            v13 /*: any*/ 
        ],
        "type": "UnifiedProfileBadgesConnection",
        "abstractKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ProfileBadgesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "learning",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recentLearningAchievementBadges",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedLearning",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "badges",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ProfileBadgesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "learning",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recentLearningAchievementBadges",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedLearning",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "badges",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "cc0c5cc70de05e055caaa96d092fd49a",
            "id": null,
            "metadata": {},
            "name": "ProfileBadgesQuery",
            "operationKind": "query",
            "text": "query ProfileBadgesQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n      ... on UnifiedProfile {\n        id\n        aaid\n        isProfileOwnerConsented\n        learning {\n          __typename\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n          ... on UnifiedLearning {\n            id\n            recentLearningAchievementBadges {\n              __typename\n              ... on UnifiedProfileBadgesConnection {\n                edges {\n                  node {\n                    actionUrl\n                    description\n                    id\n                    imageUrl\n                    lastCompletedDate\n                    name\n                    type\n                    category\n                  }\n                }\n                totalCount\n              }\n            }\n          }\n        }\n        badges {\n          __typename\n          ... on UnifiedProfileBadgesConnection {\n            edges {\n              node {\n                actionUrl\n                description\n                id\n                imageUrl\n                lastCompletedDate\n                name\n                type\n              }\n            }\n            totalCount\n          }\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$919f3bd7ff942759$var$node.hash = "a7b072436cd022bad9475618b88894a0";
var $919f3bd7ff942759$export$2e2bcd8739ae039 = $919f3bd7ff942759$var$node;

});

parcelRegister("eOkFe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c047877e02b89ff2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc84e93c6764cbac21c6759d65944ff8>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c047877e02b89ff2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentLevelArt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentLevelDescription",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentLevelName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentPoints",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxPoints",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nextLevelName",
                "storageKey": null
            }
        ],
        "type": "UnifiedGamificationLevel",
        "abstractKey": null
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedGamificationRecognitionsTotal",
                "kind": "LinkedField",
                "name": "totals",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "comment",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedGamificationRecognitionsSummary",
        "abstractKey": null
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "KudosSummaryQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "gamification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "levels",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recognitionsSummary",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedGamification",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "KudosSummaryQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "gamification",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "levels",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recognitionsSummary",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "UnifiedGamification",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        v3 /*: any*/ 
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "926330b16b2faff448d0131e41869652",
            "id": null,
            "metadata": {},
            "name": "KudosSummaryQuery",
            "operationKind": "query",
            "text": "query KudosSummaryQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        gamification {\n          __typename\n          ... on UnifiedGamification {\n            levels {\n              __typename\n              ... on UnifiedGamificationLevel {\n                id\n                currentLevelArt\n                currentLevelDescription\n                currentLevelName\n                currentPoints\n                maxPoints\n                nextLevelName\n              }\n            }\n            recognitionsSummary {\n              __typename\n              ... on UnifiedGamificationRecognitionsSummary {\n                id\n                totals {\n                  comment\n                  count\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$c047877e02b89ff2$var$node.hash = "3898beb09c2dee388df7b7f38c738bc4";
var $c047877e02b89ff2$export$2e2bcd8739ae039 = $c047877e02b89ff2$var$node;

});

parcelRegister("7z092", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1c305851270bde4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<880fa5ac480a71691e387e036c777b40>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1c305851270bde4b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "aaid"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentTime",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availablePoints",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isStaff",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nextRefresh",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refreshPtsAmount",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resetPointsStatus",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeUntilRefresh",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wasForced",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wasUpdateNeeded",
                "storageKey": null
            }
        ],
        "type": "UnifiedGamificationRecognitionSchedule",
        "abstractKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "RecognitionScheduleQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "gamification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recognitionSchedule",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedGamification",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RecognitionScheduleQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "gamification",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recognitionSchedule",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "UnifiedGamification",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        v3 /*: any*/ 
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "4ee1e2029e57f0d79a37597a0b859129",
            "id": null,
            "metadata": {},
            "name": "RecognitionScheduleQuery",
            "operationKind": "query",
            "text": "query RecognitionScheduleQuery(\n  $aaid: String!\n) {\n  unified {\n    unifiedProfile(aaid: $aaid) {\n      __typename\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          statusCode\n          errorType\n        }\n      }\n      ... on UnifiedProfile {\n        gamification {\n          __typename\n          ... on UnifiedGamification {\n            recognitionSchedule {\n              __typename\n              ... on UnifiedGamificationRecognitionSchedule {\n                id\n                currentTime\n                availablePoints\n                isStaff\n                nextRefresh\n                refreshPtsAmount\n                resetPointsStatus\n                status\n                timeUntilRefresh\n                userId\n                wasForced\n                wasUpdateNeeded\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
        }
    };
}();
$1c305851270bde4b$var$node.hash = "601a9347fcfda55697b5cc4825e2992e";
var $1c305851270bde4b$export$2e2bcd8739ae039 = $1c305851270bde4b$var$node;

});

parcelRegister("hKsNu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $917aaa897b0a0a32$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e6ece6d7ea53e1273ab8b3005b2479e>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $917aaa897b0a0a32$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "comment"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "value"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedGamificationMutation",
                    "kind": "LinkedField",
                    "name": "gamification",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "comment",
                                    "variableName": "comment"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "receiverId",
                                    "variableName": "aaid"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "value",
                                    "variableName": "value"
                                }
                            ],
                            "concreteType": "UnifiedGamificationPayload",
                            "kind": "LinkedField",
                            "name": "sendRecognition",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "UnifiedGamificationMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UnifiedGamificationMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "3e4173051cfca047310d08c13126dc3f",
            "id": null,
            "metadata": {},
            "name": "UnifiedGamificationMutation",
            "operationKind": "mutation",
            "text": "mutation UnifiedGamificationMutation(\n  $aaid: String!\n  $comment: String!\n  $value: Int!\n) {\n  unified {\n    gamification {\n      sendRecognition(comment: $comment, value: $value, receiverId: $aaid) {\n        message\n        success\n        errors {\n          code\n          message\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$917aaa897b0a0a32$var$node.hash = "c41338e0b2aca590dd28960902514351";
var $917aaa897b0a0a32$export$2e2bcd8739ae039 = $917aaa897b0a0a32$var$node;

});

parcelRegister("sg1HA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $054f0c28a42c9a22$var$_react = $054f0c28a42c9a22$var$_interopRequireDefault((parcelRequire("acw62")));

var $054f0c28a42c9a22$var$_UNSAFE_baseNew = $054f0c28a42c9a22$var$_interopRequireDefault((parcelRequire("feA4o")));
function $054f0c28a42c9a22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $054f0c28a42c9a22$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $054f0c28a42c9a22$var$_react.default.createElement($054f0c28a42c9a22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$054f0c28a42c9a22$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $054f0c28a42c9a22$var$_default = module.exports.default = $054f0c28a42c9a22$var$ChevronDownIcon;

});
parcelRegister("feA4o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lvCqS")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("lvCqS")).Icon);

var $lvCqS = parcelRequire("lvCqS");

});
parcelRegister("lvCqS", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $fa8a4e1ca8c56cff$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $fa8a4e1ca8c56cff$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $7rZ3m = parcelRequire("7rZ3m");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $fa8a4e1ca8c56cff$var$commonSVGStyles = (0, $jjlaj.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $fa8a4e1ca8c56cff$var$svgStyles = (0, $jjlaj.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $fa8a4e1ca8c56cff$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $fa8a4e1ca8c56cff$var$utilityIconStyles = (0, $jjlaj.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $fa8a4e1ca8c56cff$var$scaleStyles = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $fa8a4e1ca8c56cff$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $fa8a4e1ca8c56cff$var$scaleSize = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
var $fa8a4e1ca8c56cff$var$sizeMap = {
    core: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $fa8a4e1ca8c56cff$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $fa8a4e1ca8c56cff$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $fa8a4e1ca8c56cff$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $7rZ3m.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $jjlaj.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $fa8a4e1ca8c56cff$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $fa8a4e1ca8c56cff$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $fa8a4e1ca8c56cff$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jjlaj.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $fa8a4e1ca8c56cff$var$iconStyles,
            $fa8a4e1ca8c56cff$var$baseHcmStyles,
            shouldScale && $fa8a4e1ca8c56cff$var$scaleStyles,
            props.type === "utility" && $fa8a4e1ca8c56cff$var$utilityIconStyles
        ]
    }, (0, $jjlaj.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $fa8a4e1ca8c56cff$var$commonSVGStyles,
            $fa8a4e1ca8c56cff$var$svgStyles,
            shouldScale ? $fa8a4e1ca8c56cff$var$scaleSize : props.type === "utility" ? $fa8a4e1ca8c56cff$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $fa8a4e1ca8c56cff$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $fa8a4e1ca8c56cff$export$2e2bcd8739ae039 = $fa8a4e1ca8c56cff$export$f04a61298a47a40f;

});
parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $e0f035ab0866fe47$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $e0f035ab0866fe47$export$c8a8987d4410bf2d);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== "undefined";
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: "css"
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});

parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== "undefined";
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("7rZ3m", function(module, exports) {

$parcel$export(module.exports, "fg", () => $56ca69ef55eef59b$export$b40ec24ac8275656);

var $dcEvi = parcelRequire("dcEvi");
function $56ca69ef55eef59b$export$ba05d765b8392e5e(flagResolver) {
    (0, $dcEvi.setBooleanResolver)(flagResolver);
}
function $56ca69ef55eef59b$export$470e5c2be1411c89(name) {
    return (0, $dcEvi.resolveBooleanFlag)(name);
}
function $56ca69ef55eef59b$export$b40ec24ac8275656(name) {
    return (0, $dcEvi.resolveBooleanFlag)(name);
}

});
parcelRegister("dcEvi", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $99cbd088c69ff800$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $99cbd088c69ff800$export$6333b6aff9fc6275);

var $3fNhe = parcelRequire("3fNhe");

var $hPtJY = parcelRequire("hPtJY");
var $99cbd088c69ff800$var$pkgName = "@atlaskit/platform-feature-flags";
var $99cbd088c69ff800$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $99cbd088c69ff800$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $99cbd088c69ff800$var$ENV_ENABLE_PLATFORM_FF = $99cbd088c69ff800$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $99cbd088c69ff800$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $99cbd088c69ff800$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $99cbd088c69ff800$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $99cbd088c69ff800$var$ENV_ENABLE_PLATFORM_FF || $99cbd088c69ff800$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $99cbd088c69ff800$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $99cbd088c69ff800$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$99cbd088c69ff800$var$globalVar[$99cbd088c69ff800$export$7e41b1b2bdee3f98] = $99cbd088c69ff800$var$globalVar[$99cbd088c69ff800$export$7e41b1b2bdee3f98] || $99cbd088c69ff800$var$DEFAULT_PFF_GLOBAL;
function $99cbd088c69ff800$export$f2b591175b3e424c(resolver) {
    $99cbd088c69ff800$var$globalVar[$99cbd088c69ff800$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $99cbd088c69ff800$export$6333b6aff9fc6275(flagKey) {
    if ($99cbd088c69ff800$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3fNhe.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $99cbd088c69ff800$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $99cbd088c69ff800$var$globalVar[$99cbd088c69ff800$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3fNhe", function(module, exports) {

$parcel$export(module.exports, "debug", () => $25e8ff3062fc4aa9$export$1c9f709888824e05);
var $25e8ff3062fc4aa9$var$_ref, $25e8ff3062fc4aa9$var$_process, $25e8ff3062fc4aa9$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $25e8ff3062fc4aa9$var$TESTS_MODE = ($25e8ff3062fc4aa9$var$_ref = (globalThis === null || globalThis === void 0 || ($25e8ff3062fc4aa9$var$_process = globalThis.process) === null || $25e8ff3062fc4aa9$var$_process === void 0 || ($25e8ff3062fc4aa9$var$_process = $25e8ff3062fc4aa9$var$_process.env) === null || $25e8ff3062fc4aa9$var$_process === void 0 ? void 0 : $25e8ff3062fc4aa9$var$_process.JEST_WORKER_ID) !== undefined, $25e8ff3062fc4aa9$var$_ref !== void 0) ? $25e8ff3062fc4aa9$var$_ref : false;
var $25e8ff3062fc4aa9$var$DEBUG_MODE = !$25e8ff3062fc4aa9$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($25e8ff3062fc4aa9$var$_process2 = globalThis.process) === null || $25e8ff3062fc4aa9$var$_process2 === void 0 || ($25e8ff3062fc4aa9$var$_process2 = $25e8ff3062fc4aa9$var$_process2.env) === null || $25e8ff3062fc4aa9$var$_process2 === void 0 ? void 0 : $25e8ff3062fc4aa9$var$_process2.NODE_ENV) !== "production";
var $25e8ff3062fc4aa9$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$25e8ff3062fc4aa9$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("fqvUX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f998c57d427ae10203b04c2186c5e29c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3b20ae295cad039$var$_react = $b3b20ae295cad039$var$_interopRequireDefault((parcelRequire("acw62")));

var $b3b20ae295cad039$var$_UNSAFE_baseNew = $b3b20ae295cad039$var$_interopRequireDefault((parcelRequire("feA4o")));
function $b3b20ae295cad039$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3b20ae295cad039$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $b3b20ae295cad039$var$_react.default.createElement($b3b20ae295cad039$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: "utility"
    }, props));
$b3b20ae295cad039$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $b3b20ae295cad039$var$_default = module.exports.default = $b3b20ae295cad039$var$ChevronUpIcon;

});

parcelRegister("eVxRg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03f86cbf4091cea96938f1feb145f315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ade0a712ce131adc$var$_react = $ade0a712ce131adc$var$_interopRequireDefault((parcelRequire("acw62")));

var $ade0a712ce131adc$var$_UNSAFE_baseNew = $ade0a712ce131adc$var$_interopRequireDefault((parcelRequire("feA4o")));
function $ade0a712ce131adc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ade0a712ce131adc$var$CloseIcon = (props)=>/*#__PURE__*/ $ade0a712ce131adc$var$_react.default.createElement($ade0a712ce131adc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$ade0a712ce131adc$var$CloseIcon.displayName = "CloseIcon";
var $ade0a712ce131adc$var$_default = module.exports.default = $ade0a712ce131adc$var$CloseIcon;

});

parcelRegister("ksg6x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b38abf38f585eb6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0d56bec33f5d382360c5f41c54ff17d>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b38abf38f585eb6a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortDirection"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortField"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aaid",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "identifier",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorType",
        "storageKey": null
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v16 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortDirection",
            "variableName": "sortDirection"
        },
        {
            "kind": "Variable",
            "name": "sortField",
            "variableName": "sortField"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedLearningCertificationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedLearningCertification",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "activeDate",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expireDate",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageUrl",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nameAbbr",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publicUrl",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedPageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedLearningCertificationConnection",
        "abstractKey": null
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v14 /*: any*/ ,
                    v13 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UnifiedLearningCertificationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v8 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "learning",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": v16 /*: any*/ ,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "certifications",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedLearning",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v18 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UnifiedLearningCertificationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v8 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "learning",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": v16 /*: any*/ ,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "certifications",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedLearning",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v18 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d36f42335e35cc76807476a682354f7c",
            "id": null,
            "metadata": {},
            "name": "UnifiedLearningCertificationQuery",
            "operationKind": "query",
            "text": "query UnifiedLearningCertificationQuery(\n  $username: String\n  $after: String\n  $first: Int\n  $sortDirection: UnifiedSortDirection\n  $sortField: UnifiedLearningCertificationSortField\n  $status: UnifiedLearningCertificationStatus\n  $type: [UnifiedLearningCertificationType!]\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        id\n        aaid\n        learning {\n          __typename\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              statusCode\n              errorType\n            }\n          }\n          ... on UnifiedLearning {\n            id\n            certifications(first: $first, after: $after, status: $status, type: $type, sortField: $sortField, sortDirection: $sortDirection) {\n              __typename\n              ... on UnifiedQueryError {\n                identifier\n                message\n                extensions {\n                  statusCode\n                  errorType\n                }\n              }\n              ... on UnifiedLearningCertificationConnection {\n                edges {\n                  cursor\n                  node {\n                    id\n                    activeDate\n                    expireDate\n                    imageUrl\n                    name\n                    nameAbbr\n                    status\n                    publicUrl\n                  }\n                }\n                totalCount\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                  hasPreviousPage\n                  startCursor\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$b38abf38f585eb6a$var$node.hash = "2ddf838318b1a5d4f843cda8b48d4e91";
var $b38abf38f585eb6a$export$2e2bcd8739ae039 = $b38abf38f585eb6a$var$node;

});

parcelRegister("jE992", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c22f4992053d3508$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b2c55b8c7cbb1d12d6e3f4ac884cd55>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c22f4992053d3508$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "viewHref",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aaid",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "groupMemberCount",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "topicsCount",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasHiddenAncestor",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "joinDate",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "membershipType",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedForumsGroupAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediumHref",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UnifiedForumsGroupsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "forums",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "groups",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UnifiedForumsGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "UnifiedForumsGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ],
                                                                    "type": "UnifiedForumsGroupsConnection",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedForums",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UnifiedForumsGroupsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "forums",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "groups",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UnifiedForumsGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "UnifiedForumsGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ ,
                                                                                        v3 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ],
                                                                    "type": "UnifiedForumsGroupsConnection",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "UnifiedForums",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "9ec6d48e5cfe54b883a5c248576be7eb",
            "id": null,
            "metadata": {},
            "name": "UnifiedForumsGroupsQuery",
            "operationKind": "query",
            "text": "query UnifiedForumsGroupsQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        id\n        forums {\n          __typename\n          ... on UnifiedForums {\n            id\n            groups {\n              __typename\n              ... on UnifiedForumsGroupsConnection {\n                edges {\n                  cursor\n                  node {\n                    viewHref\n                    aaid\n                    title\n                    groupMemberCount\n                    topicsCount\n                    hasHiddenAncestor\n                    joinDate\n                    membershipType\n                    avatar {\n                      mediumHref\n                    }\n                    id\n                  }\n                }\n                totalCount\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$c22f4992053d3508$var$node.hash = "85e2344a7b324f63abafd095040d91fc";
var $c22f4992053d3508$export$2e2bcd8739ae039 = $c22f4992053d3508$var$node;

});

parcelRegister("97pkx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $14e60b518b6a22a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c8d8fb725fae31a097ded301234677e>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14e60b518b6a22a4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtlassianProductsFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedAtlassianProductEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAtlassianProduct",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productId",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewHref",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
        }
    ],
    "type": "UnifiedAtlassianProductConnection",
    "abstractKey": null
};
$14e60b518b6a22a4$var$node.hash = "79dd56a563d72ba8b81c879718b3bfcd";
var $14e60b518b6a22a4$export$2e2bcd8739ae039 = $14e60b518b6a22a4$var$node;

});

parcelRegister("9gV2o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c01da25d34d93b2$var$_react = $6c01da25d34d93b2$var$_interopRequireDefault((parcelRequire("acw62")));

var $6c01da25d34d93b2$var$_UNSAFE_baseNew = $6c01da25d34d93b2$var$_interopRequireDefault((parcelRequire("58KIG")));
function $6c01da25d34d93b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c01da25d34d93b2$var$SuccessIcon = (props)=>/*#__PURE__*/ $6c01da25d34d93b2$var$_react.default.createElement($6c01da25d34d93b2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$6c01da25d34d93b2$var$SuccessIcon.displayName = "SuccessIcon";
var $6c01da25d34d93b2$var$_default = module.exports.default = $6c01da25d34d93b2$var$SuccessIcon;

});
parcelRegister("58KIG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("fGUhp")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("fGUhp")).Icon);

var $fGUhp = parcelRequire("fGUhp");

});
parcelRegister("fGUhp", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $b6c66f3db5ea0b05$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $b6c66f3db5ea0b05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $eZkTu = parcelRequire("eZkTu");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $b6c66f3db5ea0b05$var$commonSVGStyles = (0, $jjlaj.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $b6c66f3db5ea0b05$var$svgStyles = (0, $jjlaj.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $b6c66f3db5ea0b05$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $b6c66f3db5ea0b05$var$utilityIconStyles = (0, $jjlaj.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $b6c66f3db5ea0b05$var$scaleStyles = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $b6c66f3db5ea0b05$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $b6c66f3db5ea0b05$var$scaleSize = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
var $b6c66f3db5ea0b05$var$sizeMap = {
    core: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $b6c66f3db5ea0b05$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $b6c66f3db5ea0b05$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $b6c66f3db5ea0b05$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $eZkTu.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $jjlaj.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $b6c66f3db5ea0b05$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $b6c66f3db5ea0b05$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $b6c66f3db5ea0b05$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jjlaj.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $b6c66f3db5ea0b05$var$iconStyles,
            $b6c66f3db5ea0b05$var$baseHcmStyles,
            shouldScale && $b6c66f3db5ea0b05$var$scaleStyles,
            props.type === "utility" && $b6c66f3db5ea0b05$var$utilityIconStyles
        ]
    }, (0, $jjlaj.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $b6c66f3db5ea0b05$var$commonSVGStyles,
            $b6c66f3db5ea0b05$var$svgStyles,
            shouldScale ? $b6c66f3db5ea0b05$var$scaleSize : props.type === "utility" ? $b6c66f3db5ea0b05$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $b6c66f3db5ea0b05$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $b6c66f3db5ea0b05$export$2e2bcd8739ae039 = $b6c66f3db5ea0b05$export$f04a61298a47a40f;

});
parcelRegister("eZkTu", function(module, exports) {

$parcel$export(module.exports, "fg", () => $ae96f84cdc8eb9fa$export$b40ec24ac8275656);

var $k4g8A = parcelRequire("k4g8A");
function $ae96f84cdc8eb9fa$export$ba05d765b8392e5e(flagResolver) {
    (0, $k4g8A.setBooleanResolver)(flagResolver);
}
function $ae96f84cdc8eb9fa$export$470e5c2be1411c89(name) {
    return (0, $k4g8A.resolveBooleanFlag)(name);
}
function $ae96f84cdc8eb9fa$export$b40ec24ac8275656(name) {
    return (0, $k4g8A.resolveBooleanFlag)(name);
}

});
parcelRegister("k4g8A", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $e9c0b2f285297966$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $e9c0b2f285297966$export$6333b6aff9fc6275);

var $lRBgb = parcelRequire("lRBgb");

var $hPtJY = parcelRequire("hPtJY");
var $e9c0b2f285297966$var$pkgName = "@atlaskit/platform-feature-flags";
var $e9c0b2f285297966$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $e9c0b2f285297966$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $e9c0b2f285297966$var$ENV_ENABLE_PLATFORM_FF = $e9c0b2f285297966$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $e9c0b2f285297966$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e9c0b2f285297966$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $e9c0b2f285297966$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e9c0b2f285297966$var$ENV_ENABLE_PLATFORM_FF || $e9c0b2f285297966$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $e9c0b2f285297966$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $e9c0b2f285297966$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$e9c0b2f285297966$var$globalVar[$e9c0b2f285297966$export$7e41b1b2bdee3f98] = $e9c0b2f285297966$var$globalVar[$e9c0b2f285297966$export$7e41b1b2bdee3f98] || $e9c0b2f285297966$var$DEFAULT_PFF_GLOBAL;
function $e9c0b2f285297966$export$f2b591175b3e424c(resolver) {
    $e9c0b2f285297966$var$globalVar[$e9c0b2f285297966$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $e9c0b2f285297966$export$6333b6aff9fc6275(flagKey) {
    if ($e9c0b2f285297966$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $lRBgb.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e9c0b2f285297966$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $e9c0b2f285297966$var$globalVar[$e9c0b2f285297966$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("lRBgb", function(module, exports) {

$parcel$export(module.exports, "debug", () => $feab7346135a95da$export$1c9f709888824e05);
var $feab7346135a95da$var$_ref, $feab7346135a95da$var$_process, $feab7346135a95da$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $feab7346135a95da$var$TESTS_MODE = ($feab7346135a95da$var$_ref = (globalThis === null || globalThis === void 0 || ($feab7346135a95da$var$_process = globalThis.process) === null || $feab7346135a95da$var$_process === void 0 || ($feab7346135a95da$var$_process = $feab7346135a95da$var$_process.env) === null || $feab7346135a95da$var$_process === void 0 ? void 0 : $feab7346135a95da$var$_process.JEST_WORKER_ID) !== undefined, $feab7346135a95da$var$_ref !== void 0) ? $feab7346135a95da$var$_ref : false;
var $feab7346135a95da$var$DEBUG_MODE = !$feab7346135a95da$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($feab7346135a95da$var$_process2 = globalThis.process) === null || $feab7346135a95da$var$_process2 === void 0 || ($feab7346135a95da$var$_process2 = $feab7346135a95da$var$_process2.env) === null || $feab7346135a95da$var$_process2 === void 0 ? void 0 : $feab7346135a95da$var$_process2.NODE_ENV) !== "production";
var $feab7346135a95da$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$feab7346135a95da$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("dGBQZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f6c8f927a06062b$var$_react = $9f6c8f927a06062b$var$_interopRequireDefault((parcelRequire("acw62")));

var $9f6c8f927a06062b$var$_UNSAFE_baseNew = $9f6c8f927a06062b$var$_interopRequireDefault((parcelRequire("58KIG")));
function $9f6c8f927a06062b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f6c8f927a06062b$var$ErrorIcon = (props)=>/*#__PURE__*/ $9f6c8f927a06062b$var$_react.default.createElement($9f6c8f927a06062b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$9f6c8f927a06062b$var$ErrorIcon.displayName = "ErrorIcon";
var $9f6c8f927a06062b$var$_default = module.exports.default = $9f6c8f927a06062b$var$ErrorIcon;

});

parcelRegister("h8pw5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c796fa118fb97487$var$_react = $c796fa118fb97487$var$_interopRequireDefault((parcelRequire("acw62")));

var $c796fa118fb97487$var$_UNSAFE_baseNew = $c796fa118fb97487$var$_interopRequireDefault((parcelRequire("58KIG")));
function $c796fa118fb97487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c796fa118fb97487$var$InformationIcon = (props)=>/*#__PURE__*/ $c796fa118fb97487$var$_react.default.createElement($c796fa118fb97487$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c796fa118fb97487$var$InformationIcon.displayName = "InformationIcon";
var $c796fa118fb97487$var$_default = module.exports.default = $c796fa118fb97487$var$InformationIcon;

});

parcelRegister("8n8UJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618762db829b2226$var$_react = $618762db829b2226$var$_interopRequireDefault((parcelRequire("acw62")));

var $618762db829b2226$var$_UNSAFE_baseNew = $618762db829b2226$var$_interopRequireDefault((parcelRequire("58KIG")));
function $618762db829b2226$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618762db829b2226$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $618762db829b2226$var$_react.default.createElement($618762db829b2226$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$618762db829b2226$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $618762db829b2226$var$_default = module.exports.default = $618762db829b2226$var$QuestionCircleIcon;

});

parcelRegister("PPNXY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09bcf2e92b0905c6$var$_react = $09bcf2e92b0905c6$var$_interopRequireDefault((parcelRequire("acw62")));

var $09bcf2e92b0905c6$var$_UNSAFE_baseNew = $09bcf2e92b0905c6$var$_interopRequireDefault((parcelRequire("58KIG")));
function $09bcf2e92b0905c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09bcf2e92b0905c6$var$WarningIcon = (props)=>/*#__PURE__*/ $09bcf2e92b0905c6$var$_react.default.createElement($09bcf2e92b0905c6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$09bcf2e92b0905c6$var$WarningIcon.displayName = "WarningIcon";
var $09bcf2e92b0905c6$var$_default = module.exports.default = $09bcf2e92b0905c6$var$WarningIcon;

});

parcelRegister("eg3Lf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ac0a1437020f915$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1491b9f6b9d40d6117dae39b0f4a65fd>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2ac0a1437020f915$var$node = function() {
    var v0 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
            }
        ],
        "type": "UnifiedLinkInitiationPayload",
        "abstractKey": null
    }, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v2 = {
        "kind": "InlineFragment",
        "selections": [
            v1 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedMutationErrorExtension",
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "errorType",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                    },
                    v1 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedLinkingStatusPayload",
        "abstractKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "InitializeTransactionMutation",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutation",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedLinkingMutation",
                            "kind": "LinkedField",
                            "name": "linking",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "initializeLinkingWithLoggedInAccount",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "InitializeTransactionMutation",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutation",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedLinkingMutation",
                            "kind": "LinkedField",
                            "name": "linking",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "initializeLinkingWithLoggedInAccount",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        v0 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "5879943a798ed8bf43a65dc860bd8202",
            "id": null,
            "metadata": {},
            "name": "InitializeTransactionMutation",
            "operationKind": "mutation",
            "text": "mutation InitializeTransactionMutation {\n  unified {\n    linking {\n      initializeLinkingWithLoggedInAccount {\n        __typename\n        ... on UnifiedLinkInitiationPayload {\n          id\n          token\n        }\n        ... on UnifiedLinkingStatusPayload {\n          message\n          success\n          errors {\n            extensions {\n              errorType\n              statusCode\n            }\n            code\n            message\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$2ac0a1437020f915$var$node.hash = "34952189eb0eabf6fa0723e9e170f0bf";
var $2ac0a1437020f915$export$2e2bcd8739ae039 = $2ac0a1437020f915$var$node;

});

parcelRegister("bv5au", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a618b525844361ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a066467835379671abbf48a6b5db283d>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a618b525844361ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAccountMutation",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "aaid",
                                    "variableName": "aaid"
                                }
                            ],
                            "concreteType": "UnifiedLinkingStatusPayload",
                            "kind": "LinkedField",
                            "name": "unlinkAccount",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedMutationErrorExtension",
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "errorType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "storageKey": null
                                },
                                v1 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "UnlinkMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UnlinkMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "2f12a625ba6043d1ea501760b6f917d9",
            "id": null,
            "metadata": {},
            "name": "UnlinkMutation",
            "operationKind": "mutation",
            "text": "mutation UnlinkMutation(\n  $aaid: String!\n) {\n  unified {\n    account {\n      unlinkAccount(aaid: $aaid) {\n        errors {\n          extensions {\n            errorType\n            statusCode\n          }\n          code\n          message\n        }\n        message\n        success\n      }\n    }\n  }\n}\n"
        }
    };
}();
$a618b525844361ec$var$node.hash = "e1591e859d8ee59f56cf997a9f7b428c";
var $a618b525844361ec$export$2e2bcd8739ae039 = $a618b525844361ec$var$node;

});

parcelRegister("5rJ4o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $511ca6d9a699b1bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b14820bb24b6fb8d7360ce89e67a6bd4>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $511ca6d9a699b1bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAccountMutation",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "aaid",
                                    "variableName": "aaid"
                                }
                            ],
                            "concreteType": "UnifiedLinkingStatusPayload",
                            "kind": "LinkedField",
                            "name": "setPrimaryAccount",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedMutationErrorExtension",
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "errorType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "SetPrimaryAccountMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SetPrimaryAccountMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "d84f505033da6f379b276fd62cbc65f6",
            "id": null,
            "metadata": {},
            "name": "SetPrimaryAccountMutation",
            "operationKind": "mutation",
            "text": "mutation SetPrimaryAccountMutation(\n  $aaid: String!\n) {\n  unified {\n    account {\n      setPrimaryAccount(aaid: $aaid) {\n        message\n        success\n        errors {\n          message\n          code\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$511ca6d9a699b1bb$var$node.hash = "8c78998f026f1064403dafc866f65cef";
var $511ca6d9a699b1bb$export$2e2bcd8739ae039 = $511ca6d9a699b1bb$var$node;

});

parcelRegister("dON29", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $808e0e5578cb3151$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd80d30df3e81153075d98eca75f6cf8>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $808e0e5578cb3151$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "internalId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "username"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "internalId",
            "variableName": "internalId"
        },
        {
            "kind": "Variable",
            "name": "unifiedProfileUsername",
            "variableName": "username"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = [
        v3 /*: any*/ ,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "company",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aaid",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountInternalId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "products",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "internalId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "websiteUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "youtubeUrl",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrivate",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPersonalView",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLinkedView",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isProfileBanned",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isProfileOwnerConsented",
            "storageKey": null
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedQueryErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "EditProfileFormQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AtlassianAccountUserFragment"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "InlineDataFragmentSpread",
                                            "name": "UnifiedProfileFragment",
                                            "selections": v4 /*: any*/ ,
                                            "args": null,
                                            "argumentDefinitions": []
                                        }
                                    ],
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v5 /*: any*/ 
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "atlassianProducts",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AtlassianProductsFragment"
                                        }
                                    ],
                                    "type": "UnifiedAtlassianProductConnection",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditProfileFormQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "nickname",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "accountId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "accountStatus",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "picture",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "AtlassianAccountUser",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "UnifiedProfile",
                                    "abstractKey": null
                                },
                                v5 /*: any*/ 
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "atlassianProducts",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedAtlassianProductEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "cursor",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UnifiedAtlassianProduct",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "productId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "title",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "type",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "viewHref",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalCount",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "UnifiedAtlassianProductConnection",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "048227d5e4dd76b5816c905f93799c0c",
            "id": null,
            "metadata": {},
            "name": "EditProfileFormQuery",
            "operationKind": "query",
            "text": "query EditProfileFormQuery(\n  $username: String\n  $internalId: String\n) {\n  me {\n    user {\n      __typename\n      ... on AtlassianAccountUser {\n        ...AtlassianAccountUserFragment\n      }\n      id\n    }\n  }\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        ...UnifiedProfileFragment\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n    atlassianProducts {\n      __typename\n      ... on UnifiedAtlassianProductConnection {\n        ...AtlassianProductsFragment\n      }\n    }\n  }\n}\n\nfragment AtlassianAccountUserFragment on AtlassianAccountUser {\n  id\n  email\n  nickname\n  name\n  accountId\n  accountStatus\n  picture\n}\n\nfragment AtlassianProductsFragment on UnifiedAtlassianProductConnection {\n  edges {\n    cursor\n    node {\n      id\n      productId\n      title\n      type\n      viewHref\n    }\n  }\n  totalCount\n}\n\nfragment UnifiedProfileFragment on UnifiedProfile {\n  id\n  bio\n  company\n  aaid\n  linkedinUrl\n  accountInternalId\n  location\n  products\n  role\n  internalId\n  username\n  websiteUrl\n  xUrl\n  youtubeUrl\n  isPrivate\n  isPersonalView\n  isLinkedView\n  isProfileBanned\n  isProfileOwnerConsented\n}\n"
        }
    };
}();
$808e0e5578cb3151$var$node.hash = "501f45c160059c87eb9cc0d259ab3c43";
var $808e0e5578cb3151$export$2e2bcd8739ae039 = $808e0e5578cb3151$var$node;

});

parcelRegister("2XvW0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fc5cc9e185624015$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a4b6bc523be2bb7471b8151d2b591b6>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc5cc9e185624015$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "unifiedProfileInput",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "UnifiedProfilePayload",
                    "kind": "LinkedField",
                    "name": "updateUnifiedProfile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedMutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "message",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationErrorExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "errorType",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "statusCode",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "success",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedProfile",
                            "kind": "LinkedField",
                            "name": "unifiedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "company",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bio",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "aaid",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "linkedinUrl",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "location",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "accountInternalId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "products",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "role",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "username",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "internalId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "websiteUrl",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "xUrl",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "youtubeUrl",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isPrivate",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "EditProfileFormMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditProfileFormMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "577e526b040bb229f6f8a717ba3b0bcd",
            "id": null,
            "metadata": {},
            "name": "EditProfileFormMutation",
            "operationKind": "mutation",
            "text": "mutation EditProfileFormMutation(\n  $input: UnifiedProfileInput!\n) {\n  unified {\n    updateUnifiedProfile(unifiedProfileInput: $input) {\n      errors {\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n      success\n      unifiedProfile {\n        company\n        bio\n        id\n        aaid\n        linkedinUrl\n        location\n        accountInternalId\n        products\n        role\n        username\n        internalId\n        websiteUrl\n        xUrl\n        youtubeUrl\n        isPrivate\n      }\n    }\n  }\n}\n"
        }
    };
}();
$fc5cc9e185624015$var$node.hash = "2971949051bd50a34b306e64c8f2bc11";
var $fc5cc9e185624015$export$2e2bcd8739ae039 = $fc5cc9e185624015$var$node;

});

parcelRegister("81DfT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $79f37cdec79484fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dc14b0137f4d052840c21725158aaa6>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $79f37cdec79484fc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtlassianAccountUserFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nickname",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountStatus",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "picture",
            "storageKey": null
        }
    ],
    "type": "AtlassianAccountUser",
    "abstractKey": null
};
$79f37cdec79484fc$var$node.hash = "6c8ca116d302edee37d5021284c14ba5";
var $79f37cdec79484fc$export$2e2bcd8739ae039 = $79f37cdec79484fc$var$node;

});

parcelRegister("049wC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0acf909bdf6e5e65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3a63cc2ffa5f993d23a5f84cc5dd866>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0acf909bdf6e5e65$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "token"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedLinkingMutation",
                    "kind": "LinkedField",
                    "name": "linking",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "token",
                                    "variableName": "token"
                                }
                            ],
                            "concreteType": "UnifiedLinkingStatusPayload",
                            "kind": "LinkedField",
                            "name": "completeTransaction",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedMutationErrorExtension",
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "errorType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "CompleteTransactionMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CompleteTransactionMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "23b7dabc47bc666cb7fb10fd0dd1db04",
            "id": null,
            "metadata": {},
            "name": "CompleteTransactionMutation",
            "operationKind": "mutation",
            "text": "mutation CompleteTransactionMutation(\n  $token: String!\n) {\n  unified {\n    linking {\n      completeTransaction(token: $token) {\n        message\n        success\n        errors {\n          extensions {\n            errorType\n            statusCode\n          }\n          code\n          message\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$0acf909bdf6e5e65$var$node.hash = "260c1ef61c851f3e9e8e8c7daf03704b";
var $0acf909bdf6e5e65$export$2e2bcd8739ae039 = $0acf909bdf6e5e65$var$node;

});

parcelRegister("bCVIL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3c8a13337d4a084a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0409a1c73e011986dc7816530999c71b>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c8a13337d4a084a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "token"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aaid",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailId",
        "storageKey": null
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryAccountIndex",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedMutationErrorExtension",
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "errorType",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                    },
                    v8 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "UnifiedLinkingStatusPayload",
        "abstractKey": null
    }, v10 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "AuthenticateTransactionMutation",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutation",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedLinkingMutation",
                            "kind": "LinkedField",
                            "name": "linking",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v1 /*: any*/ ,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "authenticateLinkingWithLoggedInAccount",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UnifiedAccountDetails",
                                                    "kind": "LinkedField",
                                                    "name": "account2",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ ,
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UnifiedAccountDetails",
                                                    "kind": "LinkedField",
                                                    "name": "account1",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ ,
                                                    "storageKey": null
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ],
                                            "type": "UnifiedLinkAuthenticationPayload",
                                            "abstractKey": null
                                        },
                                        v9 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AuthenticateTransactionMutation",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutation",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedLinkingMutation",
                            "kind": "LinkedField",
                            "name": "linking",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v1 /*: any*/ ,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "authenticateLinkingWithLoggedInAccount",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UnifiedAccountDetails",
                                                    "kind": "LinkedField",
                                                    "name": "account2",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UnifiedAccountDetails",
                                                    "kind": "LinkedField",
                                                    "name": "account1",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": null
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ],
                                            "type": "UnifiedLinkAuthenticationPayload",
                                            "abstractKey": null
                                        },
                                        v9 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "a987e7f926cda4a45909fe2893424044",
            "id": null,
            "metadata": {},
            "name": "AuthenticateTransactionMutation",
            "operationKind": "mutation",
            "text": "mutation AuthenticateTransactionMutation(\n  $token: String!\n) {\n  unified {\n    linking {\n      authenticateLinkingWithLoggedInAccount(token: $token) {\n        __typename\n        ... on UnifiedLinkAuthenticationPayload {\n          id\n          account2 {\n            aaid\n            emailId\n            id\n          }\n          account1 {\n            aaid\n            emailId\n            id\n          }\n          token\n          primaryAccountIndex\n        }\n        ... on UnifiedLinkingStatusPayload {\n          message\n          success\n          errors {\n            extensions {\n              errorType\n              statusCode\n            }\n            code\n            message\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$3c8a13337d4a084a$var$node.hash = "2cdb850a38b204dfdb2d1aa5232d9108";
var $3c8a13337d4a084a$export$2e2bcd8739ae039 = $3c8a13337d4a084a$var$node;

});

parcelRegister("9IH1r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bc5dfda947c4696d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76ae6e82b71a91137d576a86c401f900>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc5dfda947c4696d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "aaid"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    }, v3 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedLinkingMutation",
                    "kind": "LinkedField",
                    "name": "linking",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "aaid",
                                    "variableName": "aaid"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "token",
                                    "variableName": "token"
                                }
                            ],
                            "concreteType": "UnifiedLinkingStatusPayload",
                            "kind": "LinkedField",
                            "name": "updateLinkingWithPrimaryAccountAaid",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedMutationErrorExtension",
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "errorType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateTransactionPrimaryMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UpdateTransactionPrimaryMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "f613997a50391da0d1ec234101adc710",
            "id": null,
            "metadata": {},
            "name": "UpdateTransactionPrimaryMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateTransactionPrimaryMutation(\n  $token: String!\n  $aaid: String!\n) {\n  unified {\n    linking {\n      updateLinkingWithPrimaryAccountAaid(aaid: $aaid, token: $token) {\n        message\n        success\n        errors {\n          extensions {\n            errorType\n            statusCode\n          }\n          code\n          message\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$bc5dfda947c4696d$var$node.hash = "3d74b6439534724af3f33b7203b307d9";
var $bc5dfda947c4696d$export$2e2bcd8739ae039 = $bc5dfda947c4696d$var$node;

});

parcelRegister("fST0w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $08028e002bcac653$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bae8f2400ebe95e113867e20cde18373>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $08028e002bcac653$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "khorosUserId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedProfileMutation",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "khorosUserId",
                                    "variableName": "khorosUserId"
                                }
                            ],
                            "concreteType": "UnifiedProfilePayload",
                            "kind": "LinkedField",
                            "name": "getExistingOrNewProfileFromKhorosUserId",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedMutationErrorExtension",
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "errorType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedProfile",
                                    "kind": "LinkedField",
                                    "name": "unifiedProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "accountInternalId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aaid",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "username",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "GetExistingOrNewProfileFromKhorosUserIdMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GetExistingOrNewProfileFromKhorosUserIdMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e86c7af3ce7bdb900348d3ec73235fe5",
            "id": null,
            "metadata": {},
            "name": "GetExistingOrNewProfileFromKhorosUserIdMutation",
            "operationKind": "mutation",
            "text": "mutation GetExistingOrNewProfileFromKhorosUserIdMutation(\n  $khorosUserId: String!\n) {\n  unified {\n    profile {\n      getExistingOrNewProfileFromKhorosUserId(khorosUserId: $khorosUserId) {\n        errors {\n          code\n          extensions {\n            errorType\n            statusCode\n          }\n          message\n        }\n        success\n        unifiedProfile {\n          accountInternalId\n          aaid\n          id\n          internalId\n          username\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$08028e002bcac653$var$node.hash = "e8449a80b6c5e9758301e9d45e4d0c6d";
var $08028e002bcac653$export$2e2bcd8739ae039 = $08028e002bcac653$var$node;

});

parcelRegister("5vuWi", function(module, exports) {
"use strict";
var $4027d8e9cf82c0d9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $acw62 = parcelRequire("acw62");

const $4027d8e9cf82c0d9$var$feature_gate_js_client_1 = $4027d8e9cf82c0d9$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $4027d8e9cf82c0d9$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $acw62.useRef)(options);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $4027d8e9cf82c0d9$var$feature_gate_js_client_1.default.initializeCalled() ? $4027d8e9cf82c0d9$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $4027d8e9cf82c0d9$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $4027d8e9cf82c0d9$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("26IN9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("26Mrv")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("a9hho")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("a9hho")).PerimeterType);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("1NURG")).DynamicConfig);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("1NURG")).EvaluationReason);

var $26Mrv = parcelRequire("26Mrv");
var $a9hho = parcelRequire("a9hho");
var $1NURG = parcelRequire("1NURG");

});
parcelRegister("26Mrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1891b80630e662a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("1NURG")).DynamicConfig);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("1NURG")).EvaluationReason);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("a9hho")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("a9hho")).PerimeterType);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $1NURG = parcelRequire("1NURG");

var $2zHX9 = parcelRequire("2zHX9");

var $a9hho = parcelRequire("a9hho");

var $a8TeI = parcelRequire("a8TeI");
var $1891b80630e662a4$var$_excluded = [
    "sdkKey",
    "updateUserCompletionCallback",
    "perimeter"
];
function $1891b80630e662a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1891b80630e662a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1891b80630e662a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1891b80630e662a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1891b80630e662a4$var$DEFAULT_CLIENT_KEY = "client-default-key";
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $1891b80630e662a4$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $1891b80630e662a4$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FeatureGates);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FeatureGates, null, [
        {
            key: "initialize",
            value: /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */ function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!FeatureGates.initPromise) {
                                    _context.next = 3;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 3:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptions;
                                FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes).then(function() {
                                    FeatureGates.initCompleted = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initialize", FeatureGates.initCompleted, clientOptions.apiKey);
                                });
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _FeatureGates$initOpt;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_FeatureGates$initOpt = FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then(function(analyticsWebClient) {
                    var attributes = $1891b80630e662a4$var$_objectSpread({
                        targetApp: FeatureGates.initOptions.targetApp,
                        clientVersion: (0, $a8TeI.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (FeatureGates.initOptions.environment !== (0, $a9hho.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(clientOptions, identifiers, customAttributes) {
                    var initializeValues, startTime, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                initializeValues = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                                if (!FeatureGates.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptions;
                                FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(function() {
                                    FeatureGates.initCompleted = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initializeFromValues", FeatureGates.initCompleted);
                                });
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function initializeFromValues(_x4, _x5, _x6) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(fetchOptions, identifiers, customAttributes) {
                    var initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $2zHX9.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(function(_ref) {
                                        var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context3.next = 3;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateUser(_x7, _x8, _x9) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args4 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                initializeValues = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context4.next = 4;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function updateUserWithValues(_x10, _x11) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return FeatureGates.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return FeatureGates.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    var evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($1NURG)))) : (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($1NURG))));
                    return evalMethod(gateName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        FeatureGates.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).manuallyLogGateExposure(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    var evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($1NURG)))) : (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($1NURG))));
                    return evalMethod(experimentName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        FeatureGates.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $1NURG.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $1NURG.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = FeatureGates.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).manuallyLogExperimentExposure(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).manuallyLogLayerParameterExposure(layerName, parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).overrideGate(gateName, value);
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).overrideGate(gateName, null);
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).overrideConfig(experimentName, values);
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).overrideConfig(experimentName, null);
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).setOverrides($1891b80630e662a4$var$_objectSpread({
                    gates: {},
                    configs: {},
                    layers: {}
                }, overrides));
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).setOverrides(null);
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                fromValuesClientOptions = $1891b80630e662a4$var$_objectSpread($1891b80630e662a4$var$_objectSpread({}, clientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context5.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                // values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $2zHX9.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $2zHX9.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client with experiment
                                // values if both requests are successful. Else an error would be thrown and handled by the catch
                                _context5.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context5.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context5.next = 20;
                                break;
                            case 13:
                                _context5.prev = 13;
                                _context5.t0 = _context5["catch"](1);
                                if (_context5.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context5.next = 19;
                                return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context5.t0;
                            case 20:
                                _context5.next = 22;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                            case 22:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x12, _x13, _x14) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee6(clientOptions, identifiers, customAttributes) {
                    var initializeValues, user, sdkKey, statsigOptions, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                                user = this.toStatsigUser(identifiers, customAttributes);
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                if (!clientOptions.sdkKey) clientOptions.sdkKey = $1891b80630e662a4$var$DEFAULT_CLIENT_KEY;
                                if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $1891b80630e662a4$var$DEFAULT_EVENT_LOGGING_API;
                                if (clientOptions.perimeter === (0, $a9hho.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                clientOptions.disableAllLogging = true;
                                sdkKey = clientOptions.sdkKey;
                                statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
                                _context6.prev = 9;
                                _context6.next = 12;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).initialize(sdkKey, user, statsigOptions);
                            case 12:
                                _context6.next = 21;
                                break;
                            case 14:
                                _context6.prev = 14;
                                _context6.t0 = _context6["catch"](9);
                                if (_context6.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                _context6.next = 20;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).initialize($1891b80630e662a4$var$DEFAULT_CLIENT_KEY, user, $1891b80630e662a4$var$_objectSpread($1891b80630e662a4$var$_objectSpread({}, statsigOptions), {}, {
                                    initializeValues: {}
                                }));
                            case 20:
                                throw _context6.t0;
                            case 21:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            9,
                            14
                        ]
                    ]);
                }));
                function initFromValues(_x15, _x16, _x17) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "toStatsigUser",
            value: function toStatsigUser(identifiers, customAttributes) {
                var user = {
                    customIDs: identifiers,
                    custom: customAttributes
                };
                if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                return user;
            }
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee7(getInitializeValues, identifiers, customAttributes) {
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (FeatureGates.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error("The FeatureGates client must be initialized before you can update the user.");
                            case 2:
                                if (!FeatureGates.isCurrentUser(identifiers, customAttributes)) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = FeatureGates.initPromise;
                                _context7.prev = 5;
                                _context7.next = 8;
                                return FeatureGates.initPromise;
                            case 8:
                                _context7.next = 12;
                                break;
                            case 10:
                                _context7.prev = 10;
                                _context7.t0 = _context7["catch"](5);
                            case 12:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this point.
                                // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
                                FeatureGates.initPromise = updateUserPromise.catch(function() {
                                    // If the update failed then it changed nothing, so revert back to the original promise.
                                    FeatureGates.initPromise = originalInitPromise;
                                });
                                return _context7.abrupt("return", updateUserPromise);
                            case 16:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, null, [
                        [
                            5,
                            10
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x18, _x19, _x20) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee8(initializeValuesPromise, identifiers, customAttributes) {
                    var initializeValues, user, _FeatureGates$initOpt2, _FeatureGates$initOpt3, errMsg, success;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.prev = 0;
                                _context8.next = 3;
                                return initializeValuesPromise;
                            case 3:
                                initializeValues = _context8.sent;
                                user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                _context8.next = 12;
                                break;
                            case 7:
                                _context8.prev = 7;
                                _context8.t0 = _context8["catch"](0);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
                                errMsg = _context8.t0 instanceof Error ? _context8.t0.message : JSON.stringify(_context8.t0);
                                (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
                                throw _context8.t0;
                            case 12:
                                success = (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).updateUserWithValues(user, initializeValues.experimentValues);
                                if (!success) {
                                    _context8.next = 18;
                                    break;
                                }
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                _context8.next = 19;
                                break;
                            case 18:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 19:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, null, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x21, _x22, _x23) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "toStatsigOptions",
            value: function toStatsigOptions(options, initializeValues) {
                var sdkKey = options.sdkKey, updateUserCompletionCallback = options.updateUserCompletionCallback, perimeter = options.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $1891b80630e662a4$var$_excluded);
                return $1891b80630e662a4$var$_objectSpread($1891b80630e662a4$var$_objectSpread({}, restClientOptions), {}, {
                    initializeValues: initializeValues,
                    environment: {
                        tier: options.environment
                    },
                    disableCurrentPageLogging: true
                }, options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                });
            }
        },
        {
            key: "toStatsigUpdateUserCompletionCallback",
            value: function toStatsigUpdateUserCompletionCallback(callback) {
                /**
       * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
       * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
       * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
       */ return function(_duration, success, message) {
                    callback(success, message);
                };
            }
        },
        {
            key: "shallowEquals",
            value: function shallowEquals(objectA, objectB) {
                if (!objectA && !objectB) return true;
                if (!objectA || !objectB) return false;
                var aEntries = Object.entries(objectA);
                var bEntries = Object.entries(objectB);
                if (aEntries.length !== bEntries.length) return false;
                var ascendingKeyOrder = function ascendingKeyOrder(_ref2, _ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), key1 = _ref4[0];
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 1), key2 = _ref5[0];
                    return key1.localeCompare(key2);
                };
                aEntries.sort(ascendingKeyOrder);
                bEntries.sort(ascendingKeyOrder);
                for(var i = 0; i < aEntries.length; i++){
                    var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(aEntries[i], 2), aValue = _aEntries$i[1];
                    var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(bEntries[i], 2), bValue = _bEntries$i[1];
                    if (aValue !== bValue) return false;
                }
                return true;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return 0, $a8TeI.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    var evalMethod = fireLayerExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).getLayer.bind((0, (/*@__PURE__*/$parcel$interopDefault($1NURG)))) : (0, (/*@__PURE__*/$parcel$interopDefault($1NURG))).getLayerWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($1NURG))));
                    return evalMethod(layerName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        FeatureGates.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $1NURG.Layer)._create(layerName, {}, "", {
                        time: Date.now(),
                        reason: (0, $1NURG.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = FeatureGates.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
    return FeatureGates;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "initPromise", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "initCompleted", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "hasGetExperimentErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "hasGetLayerErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "hasGetLayerValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1891b80630e662a4$var$FeatureGates, "hasCheckGateErrorOccurred", false);
var $1891b80630e662a4$var$boundFGJS = $1891b80630e662a4$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $1891b80630e662a4$var$FeatureGates;
    else {
        var $1891b80630e662a4$var$_boundFGJS, $1891b80630e662a4$var$_boundFGJS$getPackage;
        $1891b80630e662a4$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $1891b80630e662a4$var$boundVersion = (($1891b80630e662a4$var$_boundFGJS = $1891b80630e662a4$var$boundFGJS) === null || $1891b80630e662a4$var$_boundFGJS === void 0 || ($1891b80630e662a4$var$_boundFGJS$getPackage = $1891b80630e662a4$var$_boundFGJS.getPackageVersion) === null || $1891b80630e662a4$var$_boundFGJS$getPackage === void 0 ? void 0 : $1891b80630e662a4$var$_boundFGJS$getPackage.call($1891b80630e662a4$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($1891b80630e662a4$var$boundVersion !== (0, $a8TeI.CLIENT_VERSION)) {
            var $1891b80630e662a4$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($1891b80630e662a4$var$boundVersion, " when module version ").concat((0, $a8TeI.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($1891b80630e662a4$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $1891b80630e662a4$export$2e2bcd8739ae039 = $1891b80630e662a4$var$boundFGJS;

});
parcelRegister("1NURG", function(module, exports) {
"use strict";
var $15067a3da50d66f0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $15067a3da50d66f0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $15067a3da50d66f0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.Layer = module.exports.DynamicConfig = void 0;

var $b6DQS = parcelRequire("b6DQS");

var $15067a3da50d66f0$var$StatsigClient_1 = $15067a3da50d66f0$var$__importDefault((parcelRequire("c2qi1")));

var $l5qsq = parcelRequire("l5qsq");

var $B3ZgU = parcelRequire("B3ZgU");
Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function() {
        return $15067a3da50d66f0$var$__importDefault($B3ZgU).default;
    }
});

var $bkVef = parcelRequire("bkVef");
Object.defineProperty(module.exports, "Layer", {
    enumerable: true,
    get: function() {
        return $15067a3da50d66f0$var$__importDefault($bkVef).default;
    }
});

var $l5qsq = parcelRequire("l5qsq");
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function() {
        return $l5qsq.EvaluationReason;
    }
});
var $15067a3da50d66f0$var$Statsig = /** @class */ function() {
    function Statsig() {}
    Statsig.initialize = function(sdkKey, user, options) {
        var _a;
        return $15067a3da50d66f0$var$__awaiter(this, void 0, void 0, function() {
            var inst;
            return $15067a3da50d66f0$var$__generator(this, function(_b) {
                inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new $15067a3da50d66f0$var$StatsigClient_1.default(sdkKey, user, options);
                if (!Statsig.instance) Statsig.instance = inst;
                return [
                    2 /*return*/ ,
                    inst.initializeAsync()
                ];
            });
        });
    };
    Statsig.setInitializeValues = function(initializeValues) {
        Statsig._getClientX().setInitializeValues(initializeValues);
    };
    // Gate
    Statsig.checkGate = function(gateName) {
        return Statsig._getClientX().checkGate(gateName);
    };
    Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
        return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
    };
    Statsig.manuallyLogGateExposure = function(gateName) {
        Statsig._getClientX().logGateExposure(gateName);
    };
    // Config
    Statsig.getConfig = function(configName) {
        return Statsig._getClientX().getConfig(configName);
    };
    Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
        return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
    };
    Statsig.manuallyLogConfigExposure = function(configName) {
        Statsig._getClientX().logConfigExposure(configName);
    };
    // Experiment
    Statsig.getExperiment = function(experimentName) {
        return Statsig._getClientX().getExperiment(experimentName);
    };
    Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
    };
    Statsig.manuallyLogExperimentExposure = function(configName) {
        Statsig._getClientX().logExperimentExposure(configName);
    };
    // Layer
    Statsig.getLayer = function(layerName) {
        return Statsig._getClientX().getLayer(layerName);
    };
    Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
        return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
    };
    Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
        Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
    };
    Statsig.logEvent = function(eventName, value, metadata) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        return Statsig._getClientX().logEvent(eventName, value, metadata);
    };
    Statsig.updateUser = function(user) {
        return Statsig._getClientX().updateUser(user);
    };
    Statsig.updateUserWithValues = function(user, values) {
        return Statsig._getClientX().updateUserWithValues(user, values);
    };
    Statsig.shutdown = function() {
        Statsig._getClientX().shutdown();
        Statsig.instance = null;
    };
    Statsig.overrideGate = function(gate, result) {
        Statsig._getClientX().overrideGate(gate, result);
    };
    Statsig.overrideConfig = function(config, result) {
        Statsig._getClientX().overrideConfig(config, result);
    };
    Statsig.overrideLayer = function(layer, result) {
        Statsig._getClientX().overrideLayer(layer, result);
    };
    Statsig.setOverrides = function(overrides) {
        Statsig._getClientX().setOverrides(overrides);
    };
    Statsig.getOverrides = function() {
        return Statsig._getClientX().getOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
        return Statsig._getClientX().getStableID();
    };
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
        var _a, _b;
        return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: $l5qsq.EvaluationReason.Uninitialized,
            time: 0
        };
    };
    /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
        return Statsig.instance != null && Statsig.instance.initializeCalled();
    };
    Statsig._getClientX = function() {
        if (!Statsig.instance) throw new $b6DQS.StatsigUninitializedError();
        return Statsig.instance;
    };
    Statsig.instance = null;
    return Statsig;
}();
module.exports.default = $15067a3da50d66f0$var$Statsig;

});

parcelRegister("2zHX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e00f1cf7fe7e9cc$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $a9hho = parcelRequire("a9hho");

var $a8TeI = parcelRequire("a8TeI");

var $cM9dC = parcelRequire("cM9dC");
function $1e00f1cf7fe7e9cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e00f1cf7fe7e9cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e00f1cf7fe7e9cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e00f1cf7fe7e9cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1e00f1cf7fe7e9cc$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $1e00f1cf7fe7e9cc$var$PROD_BASE_URL = "https://api.atlassian.com/flags";
var $1e00f1cf7fe7e9cc$var$STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
var $1e00f1cf7fe7e9cc$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $1e00f1cf7fe7e9cc$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $1e00f1cf7fe7e9cc$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $1e00f1cf7fe7e9cc$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $1e00f1cf7fe7e9cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $cM9dC.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $cM9dC.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $a9hho.PerimeterType).COMMERCIAL;
                if (useGatewayUrl) return $1e00f1cf7fe7e9cc$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $a9hho.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $a9hho.FeatureGateEnvironment).Production:
                        return $1e00f1cf7fe7e9cc$export$18c93900db9358a4;
                    case (0, $a9hho.FeatureGateEnvironment).Staging:
                        return $1e00f1cf7fe7e9cc$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $a9hho.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $a9hho.FeatureGateEnvironment).Development:
                        return $1e00f1cf7fe7e9cc$export$f058dbf75c3bc647;
                    case (0, $a9hho.FeatureGateEnvironment).Staging:
                        return $1e00f1cf7fe7e9cc$var$STAGING_BASE_URL;
                    default:
                        return $1e00f1cf7fe7e9cc$var$PROD_BASE_URL;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $1e00f1cf7fe7e9cc$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $1e00f1cf7fe7e9cc$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $a8TeI.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
    return Fetcher;
}();

});
parcelRegister("a9hho", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $763825fd64a781e5$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $763825fd64a781e5$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options.
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $763825fd64a781e5$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $763825fd64a781e5$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});

});

parcelRegister("a8TeI", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $76257f836d2fbbb7$export$a59f8d67326bd1cb);
var $76257f836d2fbbb7$export$a59f8d67326bd1cb = "4.19.0";

});

parcelRegister("cM9dC", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $94d11e5cdd4fff24$export$286baf652d0b1206);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $in7St = parcelRequire("in7St");
function $94d11e5cdd4fff24$var$_createSuper(t) {
    var r = $94d11e5cdd4fff24$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, e);
    };
}
function $94d11e5cdd4fff24$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94d11e5cdd4fff24$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $94d11e5cdd4fff24$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ResponseError, _Error);
    var _super = $94d11e5cdd4fff24$var$_createSuper(ResponseError);
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ResponseError);
        return _super.call(this, message);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($in7St)))(Error));

});




parcelRegister("jVVXk", function(module, exports) {
"use strict";
var $e8304c0254f188db$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearOverrides = module.exports.applyOverrides = module.exports.toError = module.exports.pickChildToRender = module.exports.isClientAlreadyInCorrectState = void 0;

const $e8304c0254f188db$var$react_1 = $e8304c0254f188db$var$__importDefault((parcelRequire("acw62")));

const $e8304c0254f188db$var$feature_gate_js_client_1 = $e8304c0254f188db$var$__importDefault((parcelRequire("26IN9")));
let $e8304c0254f188db$var$hasWarnedAboutMissingOverrideSupport = false;
function $e8304c0254f188db$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default)) && ((_b = $e8304c0254f188db$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($e8304c0254f188db$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
module.exports.isClientAlreadyInCorrectState = $e8304c0254f188db$var$isClientAlreadyInCorrectState;
function $e8304c0254f188db$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $e8304c0254f188db$var$react_1.default.createElement($e8304c0254f188db$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $e8304c0254f188db$var$react_1.default.createElement($e8304c0254f188db$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
module.exports.pickChildToRender = $e8304c0254f188db$var$pickChildToRender;
function $e8304c0254f188db$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
module.exports.toError = $e8304c0254f188db$var$toError;
function $e8304c0254f188db$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$e8304c0254f188db$var$feature_gate_js_client_1.default.overrideGate || !$e8304c0254f188db$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$e8304c0254f188db$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn("Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+");
            $e8304c0254f188db$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, configName, values);
    });
}
module.exports.applyOverrides = $e8304c0254f188db$var$applyOverrides;
function $e8304c0254f188db$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, configName);
    });
}
module.exports.clearOverrides = $e8304c0254f188db$var$clearOverrides;

});


parcelRegister("1FExB", function(module, exports) {
"use strict";
var $1379116260a67eca$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $acw62 = parcelRequire("acw62");

const $1379116260a67eca$var$feature_gate_js_client_1 = $1379116260a67eca$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $1379116260a67eca$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $acw62.useRef)(options);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $1379116260a67eca$var$feature_gate_js_client_1.default.initializeCalled() ? $1379116260a67eca$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $1379116260a67eca$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: "client-default-key"
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $1379116260a67eca$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("eWJCq", function(module, exports) {
"use strict";
var $ae19de6a123fa76a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $acw62 = parcelRequire("acw62");

const $ae19de6a123fa76a$var$feature_gate_js_client_1 = $ae19de6a123fa76a$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ae19de6a123fa76a$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $acw62.useRef)(options);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ae19de6a123fa76a$var$feature_gate_js_client_1.default.initializeCalled() ? $ae19de6a123fa76a$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ae19de6a123fa76a$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ae19de6a123fa76a$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});

parcelRegister("2TRci", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f482e04a2a00b172$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87963831edea0b318d6607ca5bbc840a>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f482e04a2a00b172$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "value",
            "variableName": "aaid"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedConsentObj",
                "kind": "LinkedField",
                "name": "consentObj",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "consentKey",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "consentStatus",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "consenthubStatus",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uppConsentStatus",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
            }
        ],
        "type": "UnifiedConsentStatus",
        "abstractKey": null
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "identifier",
                "storageKey": null
            }
        ],
        "type": "UnifiedQueryError",
        "abstractKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "UnifiedConsentQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedConsentQuery",
                            "kind": "LinkedField",
                            "name": "consent",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v1 /*: any*/ ,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "getConsent",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UnifiedConsentQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQuery",
                    "kind": "LinkedField",
                    "name": "unified",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedConsentQuery",
                            "kind": "LinkedField",
                            "name": "consent",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v1 /*: any*/ ,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "getConsent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "e6bf37acf35d46e7338e8539911b151e",
            "id": null,
            "metadata": {},
            "name": "UnifiedConsentQuery",
            "operationKind": "query",
            "text": "query UnifiedConsentQuery(\n  $aaid: String!\n) {\n  unified {\n    consent {\n      getConsent(value: $aaid) {\n        __typename\n        ... on UnifiedConsentStatus {\n          id\n          consentObj {\n            consentKey\n            consentStatus\n            consenthubStatus\n            uppConsentStatus\n          }\n          updatedAt\n          value\n        }\n        ... on UnifiedQueryError {\n          code\n          identifier\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$f482e04a2a00b172$var$node.hash = "cc3c54c7483965895dc32f58e8e883a7";
var $f482e04a2a00b172$export$2e2bcd8739ae039 = $f482e04a2a00b172$var$node;

});

parcelRegister("6Jc1D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6aa2ea9592b0c1e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f65573e9e227e41fd03c2ff72680ff0>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6aa2ea9592b0c1e9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "emailId"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedMutation",
            "kind": "LinkedField",
            "name": "unified",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedCommunityMutation",
                    "kind": "LinkedField",
                    "name": "community",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "aaid",
                                    "variableName": "aaid"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "emailId",
                                    "variableName": "emailId"
                                }
                            ],
                            "concreteType": "UnifiedCommunityPayload",
                            "kind": "LinkedField",
                            "name": "initializeCommunity",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedMutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnifiedMutationErrorExtension",
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "errorType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedForumsAccount",
                                    "kind": "LinkedField",
                                    "name": "forumsProfile",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "success",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedGamificationProfile",
                                    "kind": "LinkedField",
                                    "name": "gamificationProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "userId",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnifiedProfile",
                                    "kind": "LinkedField",
                                    "name": "unifiedProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aaid",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "accountInternalId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalId",
                                            "storageKey": null
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "CommunityInitializeMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommunityInitializeMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6053cdab7b073d23091bceae14e9497a",
            "id": null,
            "metadata": {},
            "name": "CommunityInitializeMutation",
            "operationKind": "mutation",
            "text": "mutation CommunityInitializeMutation(\n  $aaid: String\n  $emailId: String\n) {\n  unified {\n    community {\n      initializeCommunity(aaid: $aaid, emailId: $emailId) {\n        errors {\n          code\n          extensions {\n            errorType\n            statusCode\n          }\n          message\n        }\n        forumsProfile {\n          id\n        }\n        success\n        gamificationProfile {\n          userId\n        }\n        unifiedProfile {\n          aaid\n          accountInternalId\n          internalId\n          id\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$6aa2ea9592b0c1e9$var$node.hash = "3946027750118d9a2d99f456520322fb";
var $6aa2ea9592b0c1e9$export$2e2bcd8739ae039 = $6aa2ea9592b0c1e9$var$node;

});

parcelRegister("5NceL", function(module, exports) {

$parcel$export(module.exports, "themeIds", () => $437b056ac5350794$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $437b056ac5350794$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $437b056ac5350794$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $437b056ac5350794$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $437b056ac5350794$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $437b056ac5350794$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-minor3"
];
var $437b056ac5350794$export$ba8a43b83ecc69f8 = [];
var $437b056ac5350794$export$92ba366331403db2 = [].concat($437b056ac5350794$export$7d43e72a58e3283f, $437b056ac5350794$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $437b056ac5350794$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-minor3": {
        id: "typography-minor3",
        displayName: "Atlassian Typography (Minor Third)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    }
};
var $437b056ac5350794$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $437b056ac5350794$export$2e2bcd8739ae039 = $437b056ac5350794$var$themeConfig;

});

parcelRegister("hM7vC", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $cf0cbe79b9488419$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $cf0cbe79b9488419$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $cf0cbe79b9488419$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $cf0cbe79b9488419$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $cf0cbe79b9488419$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $cf0cbe79b9488419$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $cf0cbe79b9488419$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $cf0cbe79b9488419$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $cf0cbe79b9488419$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $cf0cbe79b9488419$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $cf0cbe79b9488419$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $cf0cbe79b9488419$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $cf0cbe79b9488419$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $cf0cbe79b9488419$export$b36dbdb4f463f05c(hex) {
    if (!$cf0cbe79b9488419$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $cf0cbe79b9488419$export$1212645cf40ebf71(hex)
    ];
}
function $cf0cbe79b9488419$export$5a544e13ad4e1fa5(hex) {
    if (!$cf0cbe79b9488419$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $cf0cbe79b9488419$export$47ea145a83f50dc0(hex) {
    if (!$cf0cbe79b9488419$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $cf0cbe79b9488419$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $cf0cbe79b9488419$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $cf0cbe79b9488419$export$d061e26956a60b0a(foreground, background) {
    if (!$cf0cbe79b9488419$var$isValidHex(foreground) || !$cf0cbe79b9488419$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $cf0cbe79b9488419$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $cf0cbe79b9488419$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $cf0cbe79b9488419$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $cf0cbe79b9488419$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $cf0cbe79b9488419$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $cf0cbe79b9488419$var$rgbToLab(rgbA);
    var labB = $cf0cbe79b9488419$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $cf0cbe79b9488419$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("cfuBi", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $8eae9f6324a7c469$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $8eae9f6324a7c469$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $8eae9f6324a7c469$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $8eae9f6324a7c469$export$352e418ed5b6193a);
var $8eae9f6324a7c469$export$4ef52930e33717cd = "data-theme";
var $8eae9f6324a7c469$export$a00eac3f8684bcd0 = "data-color-mode";
var $8eae9f6324a7c469$export$2112803007239c61 = "data-contrast-mode";
var $8eae9f6324a7c469$export$352e418ed5b6193a = "data-custom-theme";
var $8eae9f6324a7c469$export$2faeed762aac6741 = "light";
var $8eae9f6324a7c469$export$6f0c6fb8c80fcc92 = "ds";
var $8eae9f6324a7c469$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $8eae9f6324a7c469$export$dddac1532e822863 = "--".concat($8eae9f6324a7c469$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8eae9f6324a7c469$export$9d7b58831ae93caa = "--".concat($8eae9f6324a7c469$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("klQHf", function(module, exports) {

$parcel$export(module.exports, "hash", () => $ed0ea53e8a1fecc7$export$d6af199866bfb566);
var $ed0ea53e8a1fecc7$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("8Ex6V", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("rEW7g").then(()=>parcelRequire("cusNu"));

});

parcelRegister("lH96A", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8866c").then(()=>parcelRequire("4cp9X"));

});

parcelRegister("1Lc0l", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gBdVF").then(()=>parcelRequire("1gEOj"));

});

parcelRegister("9Bi5g", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("952Nd").then(()=>parcelRequire("1u3hM"));

});

parcelRegister("3J0Ly", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7ZaF9").then(()=>parcelRequire("kI1gl"));

});

parcelRegister("b7Xwx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bs3J9").then(()=>parcelRequire("dN7zS"));

});

parcelRegister("hR0TH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6xqMO").then(()=>parcelRequire("8Qtve"));

});

parcelRegister("n9MS2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5EV3L").then(()=>parcelRequire("658iW"));

});

parcelRegister("k92Of", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aVmNA").then(()=>parcelRequire("flZwp"));

});

parcelRegister("kBQNP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("53UTJ").then(()=>parcelRequire("6IVyQ"));

});

parcelRegister("g5OPz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("EIWVS").then(()=>parcelRequire("71NW9"));

});

parcelRegister("04BA7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9Cz1S").then(()=>parcelRequire("bn01I"));

});

parcelRegister("lXhZa", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $ffbd0f3b346011dd$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $ffbd0f3b346011dd$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $ffbd0f3b346011dd$export$e673f367da2ff23e);

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");

var $1deXG = parcelRequire("1deXG");

var $cfuBi = parcelRequire("cfuBi");

var $klQHf = parcelRequire("klQHf");
function $ffbd0f3b346011dd$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $klQHf.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $cfuBi.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $cfuBi.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $ffbd0f3b346011dd$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.from(document.head.querySelectorAll("style[".concat((0, $cfuBi.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $cfuBi.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $ffbd0f3b346011dd$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $1deXG.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("1deXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e229c6308825451$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b84f3ab5de0b07fa5b6f8c5356895432>>
 * @codegenCommand yarn build tokens
 */ var $0e229c6308825451$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $0e229c6308825451$export$2e2bcd8739ae039 = $0e229c6308825451$var$tokens;

});


parcelRegister("ifbJw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4r2dB").then(()=>parcelRequire("lTRum"));

});

parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


/* App.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");
const $40e3d5b564ddd8a9$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $40e3d5b564ddd8a9$var$ATOMIC_GROUP_LENGTH = 5;
function $40e3d5b564ddd8a9$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $40e3d5b564ddd8a9$var$UNDERSCORE_UNICODE ? $40e3d5b564ddd8a9$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}


var $2d93712440e0508b$exports = {};
/**
 * Relay v15.0.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
$2d93712440e0508b$exports = (parcelRequire("bNos8"));



var $8nd05 = parcelRequire("8nd05");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $6d23e34a443a4a03$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6d23e34a443a4a03$export$e19cd5f9376f8cee || ($6d23e34a443a4a03$export$e19cd5f9376f8cee = {}));
var $6d23e34a443a4a03$var$readOnly = function(obj) {
    return obj;
};
function $6d23e34a443a4a03$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $6d23e34a443a4a03$var$BeforeUnloadEventType = "beforeunload";
var $6d23e34a443a4a03$var$HashChangeEventType = "hashchange";
var $6d23e34a443a4a03$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6d23e34a443a4a03$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $8nd05.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6d23e34a443a4a03$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $6d23e34a443a4a03$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($6d23e34a443a4a03$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($6d23e34a443a4a03$export$fe53371bee54353d(nextLocation) !== $6d23e34a443a4a03$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $8nd05.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $6d23e34a443a4a03$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $6d23e34a443a4a03$var$createKey()
        }, typeof entry === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $6d23e34a443a4a03$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $6d23e34a443a4a03$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $6d23e34a443a4a03$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $6d23e34a443a4a03$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $6d23e34a443a4a03$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $6d23e34a443a4a03$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $6d23e34a443a4a03$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $6d23e34a443a4a03$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");


var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;


var $ffc02c93f21d2d39$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $ffc02c93f21d2d39$var$noop() {
// No operation performed.
}
$ffc02c93f21d2d39$exports = $ffc02c93f21d2d39$var$noop;


const $71bcd808d0e94c1b$var$hasWindow = ()=>typeof window !== "undefined";
const $71bcd808d0e94c1b$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports)))
};
const $71bcd808d0e94c1b$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = "", search: search = "", hash: hash = "" } = $71bcd808d0e94c1b$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $71bcd808d0e94c1b$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector("#content");
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ]; // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return "POP";
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return "POP";
            }
            historyStack[historyStack.length - 1] = currentHref;
            return "REPLACE";
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return "PUSH";
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $71bcd808d0e94c1b$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $71bcd808d0e94c1b$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $71bcd808d0e94c1b$var$getLocation();
    let currentAction = "PUSH";
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        get location () {
            return currentLocation;
        },
        get length () {
            return $71bcd808d0e94c1b$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $71bcd808d0e94c1b$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === "string" ? path : (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === "string" ? path : (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $71bcd808d0e94c1b$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
        createHref: (location)=>(0, $6d23e34a443a4a03$export$fe53371bee54353d)(location)
    } : $71bcd808d0e94c1b$var$methodsPlaceholders);
};


var $cd892941f8676d0d$exports = {};
var $60bb1179aae86352$exports = {};
$60bb1179aae86352$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $cd892941f8676d0d$exports = $cd892941f8676d0d$var$pathToRegexp;
$cd892941f8676d0d$exports.parse = $cd892941f8676d0d$var$parse;
$cd892941f8676d0d$exports.compile = $cd892941f8676d0d$var$compile;
$cd892941f8676d0d$exports.tokensToFunction = $cd892941f8676d0d$var$tokensToFunction;
$cd892941f8676d0d$exports.tokensToRegExp = $cd892941f8676d0d$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $cd892941f8676d0d$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $cd892941f8676d0d$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $cd892941f8676d0d$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === "string" ? tokens[tokens.length - 1] : "");
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $cd892941f8676d0d$var$escapeGroup(pattern) : asterisk ? ".*" : $cd892941f8676d0d$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $cd892941f8676d0d$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return "[^" + $cd892941f8676d0d$var$escapeString(delimiter) + "]+?";
    return $cd892941f8676d0d$var$escapeString(prevText) + "|(?:(?!" + $cd892941f8676d0d$var$escapeString(prevText) + ")[^" + $cd892941f8676d0d$var$escapeString(delimiter) + "])+?";
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $cd892941f8676d0d$var$compile(str, options) {
    return $cd892941f8676d0d$var$tokensToFunction($cd892941f8676d0d$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $cd892941f8676d0d$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $cd892941f8676d0d$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $cd892941f8676d0d$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $cd892941f8676d0d$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $cd892941f8676d0d$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($60bb1179aae86352$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $cd892941f8676d0d$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $cd892941f8676d0d$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $cd892941f8676d0d$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $cd892941f8676d0d$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $cd892941f8676d0d$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $cd892941f8676d0d$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $cd892941f8676d0d$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $cd892941f8676d0d$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($cd892941f8676d0d$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $cd892941f8676d0d$var$flags(options));
    return $cd892941f8676d0d$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $cd892941f8676d0d$var$stringToRegexp(path, keys, options) {
    return $cd892941f8676d0d$var$tokensToRegExp($cd892941f8676d0d$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $cd892941f8676d0d$var$tokensToRegExp(tokens, keys, options) {
    if (!$60bb1179aae86352$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $cd892941f8676d0d$var$escapeString(token);
        else {
            var prefix = $cd892941f8676d0d$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $cd892941f8676d0d$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $cd892941f8676d0d$var$attachKeys(new RegExp("^" + route, $cd892941f8676d0d$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $cd892941f8676d0d$var$pathToRegexp(path, keys, options) {
    if (!$60bb1179aae86352$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $cd892941f8676d0d$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($60bb1179aae86352$exports(path)) return $cd892941f8676d0d$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $cd892941f8676d0d$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $5682d9ca04ade704$exports = {};
"use strict";
var $e72213fefeee6595$exports = {};
"use strict";
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $e72213fefeee6595$exports = function required(port, protocol) {
    protocol = protocol.split(":")[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case "http":
        case "ws":
            return port !== 80;
        case "https":
        case "wss":
            return port !== 443;
        case "ftp":
            return port !== 21;
        case "gopher":
            return port !== 70;
        case "file":
            return false;
    }
    return port !== 0;
};


var $c7ed1ca4ef6b4f89$exports = {};

$parcel$export($c7ed1ca4ef6b4f89$exports, "stringify", () => $c7ed1ca4ef6b4f89$export$fac44ee5b035f737, (v) => $c7ed1ca4ef6b4f89$export$fac44ee5b035f737 = v);
$parcel$export($c7ed1ca4ef6b4f89$exports, "parse", () => $c7ed1ca4ef6b4f89$export$98e6a39c04603d36, (v) => $c7ed1ca4ef6b4f89$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $c7ed1ca4ef6b4f89$export$fac44ee5b035f737;
var $c7ed1ca4ef6b4f89$export$98e6a39c04603d36;
"use strict";
var $c7ed1ca4ef6b4f89$var$has = Object.prototype.hasOwnProperty, $c7ed1ca4ef6b4f89$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $c7ed1ca4ef6b4f89$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $c7ed1ca4ef6b4f89$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $c7ed1ca4ef6b4f89$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $c7ed1ca4ef6b4f89$var$decode(part[1]), value = $c7ed1ca4ef6b4f89$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $c7ed1ca4ef6b4f89$var$querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if ($c7ed1ca4ef6b4f89$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $c7ed1ca4ef6b4f89$var$undef || isNaN(value))) value = "";
        key = $c7ed1ca4ef6b4f89$var$encode(key);
        value = $c7ed1ca4ef6b4f89$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
$c7ed1ca4ef6b4f89$export$fac44ee5b035f737 = $c7ed1ca4ef6b4f89$var$querystringify;
$c7ed1ca4ef6b4f89$export$98e6a39c04603d36 = $c7ed1ca4ef6b4f89$var$querystring;


var $5682d9ca04ade704$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $5682d9ca04ade704$var$CRHTLF = /[\n\r\t]/g, $5682d9ca04ade704$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $5682d9ca04ade704$var$port = /:\d+$/, $5682d9ca04ade704$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $5682d9ca04ade704$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $5682d9ca04ade704$var$trimLeft(str) {
    return (str ? str : "").toString().replace($5682d9ca04ade704$var$controlOrWhitespace, "");
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $5682d9ca04ade704$var$rules = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    function sanitize(address, url) {
        return $5682d9ca04ade704$var$isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
    },
    [
        "/",
        "pathname"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        "port",
        undefined,
        1
    ],
    [
        NaN,
        "hostname",
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $5682d9ca04ade704$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $5682d9ca04ade704$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== "undefined") globalVar = window;
    else if (typeof $parcel$global !== "undefined") globalVar = $parcel$global;
    else if (typeof self !== "undefined") globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ("blob:" === loc.protocol) finaldestination = new $5682d9ca04ade704$var$Url(unescape(loc.pathname), {});
    else if ("string" === type) {
        finaldestination = new $5682d9ca04ade704$var$Url(loc, {});
        for(key in $5682d9ca04ade704$var$ignore)delete finaldestination[key];
    } else if ("object" === type) {
        for(key in loc){
            if (key in $5682d9ca04ade704$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $5682d9ca04ade704$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $5682d9ca04ade704$var$isSpecial(scheme) {
    return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $5682d9ca04ade704$var$extractProtocol(address, location) {
    address = $5682d9ca04ade704$var$trimLeft(address);
    address = address.replace($5682d9ca04ade704$var$CRHTLF, "");
    location = location || {};
    var match = $5682d9ca04ade704$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : "";
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === "file:") {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($5682d9ca04ade704$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $5682d9ca04ade704$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $5682d9ca04ade704$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $5682d9ca04ade704$var$resolve(relative, base) {
    if (relative === "") return base;
    var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === ".") path.splice(i, 1);
        else if (path[i] === "..") {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift("");
    if (last === "." || last === "..") path.push("");
    return path.join("/");
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $5682d9ca04ade704$var$Url(address, location, parser) {
    address = $5682d9ca04ade704$var$trimLeft(address);
    address = address.replace($5682d9ca04ade704$var$CRHTLF, "");
    if (!(this instanceof $5682d9ca04ade704$var$Url)) return new $5682d9ca04ade704$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $5682d9ca04ade704$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ("object" !== type && "string" !== type) {
        parser = location;
        location = null;
    }
    if (parser && "function" !== typeof parser) parser = $c7ed1ca4ef6b4f89$exports.parse;
    location = $5682d9ca04ade704$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $5682d9ca04ade704$var$extractProtocol(address || "", location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || "";
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || $5682d9ca04ade704$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$5682d9ca04ade704$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        "pathname"
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === "function") {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ("string" === typeof parse) {
            index = parse === "@" ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ("number" === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) url.pathname = $5682d9ca04ade704$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== "/" && $5682d9ca04ade704$var$isSpecial(url.protocol)) url.pathname = "/" + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$e72213fefeee6595$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = "";
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = "";
    if (url.auth) {
        index = url.auth.indexOf(":");
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ":" + url.password : url.username;
    }
    url.origin = url.protocol !== "file:" && $5682d9ca04ade704$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $5682d9ca04ade704$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case "query":
            if ("string" === typeof value && value.length) value = (fn || $c7ed1ca4ef6b4f89$exports.parse)(value);
            url[part] = value;
            break;
        case "port":
            url[part] = value;
            if (!$e72213fefeee6595$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = "";
            } else if (value) url.host = url.hostname + ":" + value;
            break;
        case "hostname":
            url[part] = value;
            if (url.port) value += ":" + url.port;
            url.host = value;
            break;
        case "host":
            url[part] = value;
            if ($5682d9ca04ade704$var$port.test(value)) {
                value = value.split(":");
                url.port = value.pop();
                url.hostname = value.join(":");
            } else {
                url.hostname = value;
                url.port = "";
            }
            break;
        case "protocol":
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case "pathname":
        case "hash":
            if (value) {
                var char = part === "pathname" ? "/" : "#";
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case "username":
        case "password":
            url[part] = encodeURIComponent(value);
            break;
        case "auth":
            var index = value.indexOf(":");
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $5682d9ca04ade704$var$rules.length; i++){
        var ins = $5682d9ca04ade704$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
    url.origin = url.protocol !== "file:" && $5682d9ca04ade704$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $5682d9ca04ade704$var$toString(stringify) {
    if (!stringify || "function" !== typeof stringify) stringify = $c7ed1ca4ef6b4f89$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ":") protocol += ":";
    var result = protocol + (url.protocol && url.slashes || $5682d9ca04ade704$var$isSpecial(url.protocol) ? "//" : "");
    if (url.username) {
        result += url.username;
        if (url.password) result += ":" + url.password;
        result += "@";
    } else if (url.password) {
        result += ":" + url.password;
        result += "@";
    } else if (url.protocol !== "file:" && $5682d9ca04ade704$var$isSpecial(url.protocol) && !host && url.pathname !== "/") //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += "@";
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ":" || $5682d9ca04ade704$var$port.test(url.hostname) && !url.port) host += ":";
    result += host + url.pathname;
    query = "object" === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += "?" !== query.charAt(0) ? "?" + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$5682d9ca04ade704$var$Url.prototype = {
    set: $5682d9ca04ade704$var$set,
    toString: $5682d9ca04ade704$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$5682d9ca04ade704$var$Url.extractProtocol = $5682d9ca04ade704$var$extractProtocol;
$5682d9ca04ade704$var$Url.location = $5682d9ca04ade704$var$lolcation;
$5682d9ca04ade704$var$Url.trimLeft = $5682d9ca04ade704$var$trimLeft;
$5682d9ca04ade704$var$Url.qs = $c7ed1ca4ef6b4f89$exports;
$5682d9ca04ade704$exports = $5682d9ca04ade704$var$Url;


function $b3b09a7589a73470$export$37e0729cc751960b(pattern, options) {
    if (pattern === void 0) pattern = "/";
    if (options === void 0) options = {};
    const { params: params = {}, query: query = {}, basePath: basePath = "" } = options; // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5682d9ca04ade704$exports.qs).stringify(query, true);
    const pathname = pattern === "/" ? pattern : (0, $cd892941f8676d0d$exports.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ""
    };
}



const $3b1df627ec2bc28b$export$82476f982757e71e = function generatePath(pattern, params) {
    if (pattern === void 0) pattern = "/";
    return pattern === "/" ? pattern : (0, $cd892941f8676d0d$exports.compile)(pattern)(params);
};


/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $hPtJY = parcelRequire("hPtJY");
const $40dc7ae0aadcfdfd$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === "nodejs" || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes("Node.js")) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes("jsdom"));
};
const $40dc7ae0aadcfdfd$export$455cc18296abe008 = ()=>{
    if (typeof window === "undefined" || typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null) return true;
    if ($40dc7ae0aadcfdfd$var$isJsDomEnvironment()) return true;
    return false;
};




var $3p9rK = parcelRequire("3p9rK");
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

const $3772e0d80d77cbb5$var$cache = {};
const $3772e0d80d77cbb5$var$cacheLimit = 10000;
let $3772e0d80d77cbb5$var$cacheCount = 0;
function $3772e0d80d77cbb5$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $3772e0d80d77cbb5$var$cache[cacheKey] || ($3772e0d80d77cbb5$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, (/*@__PURE__*/$parcel$interopDefault($cd892941f8676d0d$exports)))(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($3772e0d80d77cbb5$var$cacheCount < $3772e0d80d77cbb5$var$cacheLimit) {
        pathCache[path] = result;
        $3772e0d80d77cbb5$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $3772e0d80d77cbb5$var$matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = "" } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== "") return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $3772e0d80d77cbb5$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $3772e0d80d77cbb5$export$2e2bcd8739ae039 = $3772e0d80d77cbb5$var$matchPath;



var $3p9rK = parcelRequire("3p9rK");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $87df97816e40d486$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split("=");
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes("!=")) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split("|").map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes("?")) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || "";
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith("(")) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || "");
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $87df97816e40d486$export$2e2bcd8739ae039 = $87df97816e40d486$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $c866d9187f6d354d$var$computeRootMatch = (pathname)=>({
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/",
        query: {}
    });
function $c866d9187f6d354d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $3772e0d80d77cbb5$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $c866d9187f6d354d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $87df97816e40d486$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $c866d9187f6d354d$export$2e2bcd8739ae039 = $c866d9187f6d354d$var$execRouteMatching;


const $91b1717ffc0107b6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $91b1717ffc0107b6$var$MAX_CACHE_SIZE = 1000;
function $91b1717ffc0107b6$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
     // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$91b1717ffc0107b6$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $91b1717ffc0107b6$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($91b1717ffc0107b6$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $91b1717ffc0107b6$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $91b1717ffc0107b6$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $4366c52d36621328$var$matchRoute = function matchRoute(routes, pathname, queryParams, basePath) {
    if (queryParams === void 0) queryParams = {};
    if (basePath === void 0) basePath = "";
    const queryParamObject = typeof queryParams === "string" ? (0, $5682d9ca04ade704$exports.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $91b1717ffc0107b6$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $c866d9187f6d354d$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $91b1717ffc0107b6$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $4366c52d36621328$export$ce5b73cebfeaa567 = function matchInvariantRoute(routes, pathname, queryParams, basePath) {
    if (basePath === void 0) basePath = "";
    return $4366c52d36621328$var$matchRoute(routes, pathname, queryParams, basePath);
};
const $4366c52d36621328$export$4e76f1d455ef7c95 = function warmupMatchRouteCache(route, pathname, queryParams, basePath) {
    if (basePath === void 0) basePath = "";
    $4366c52d36621328$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $4366c52d36621328$export$2e2bcd8739ae039 = function(routes, pathname, queryParams, basePath) {
    if (basePath === void 0) basePath = "";
    return $4366c52d36621328$var$matchRoute(routes, pathname, queryParams, basePath);
};





const $f89e874adec4a5d6$export$7c22f8f9552f689e = {
    pathname: "",
    search: "",
    hash: ""
};
const $f89e874adec4a5d6$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: "",
    url: "",
    query: {}
};
const $f89e874adec4a5d6$export$4eadc79233226325 = {
    path: "",
    component: ()=>null,
    name: ""
};
const $f89e874adec4a5d6$export$39607c9878cf5148 = (0, $71bcd808d0e94c1b$export$883c3f3b6c000133)();
const $f89e874adec4a5d6$export$1515254c8c90bebb = {
    location: $f89e874adec4a5d6$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports)))
};
const $f89e874adec4a5d6$export$fa440ddf675c8a93 = "POP";




const $7040b2dec5a7dddb$export$faed15f35ddc6f99 = function createRouterContext(route, options) {
    if (options === void 0) options = {};
    const { params: params = {}, query: query = {}, basePath: basePath = "" } = options;
    const pathname = (0, $3b1df627ec2bc28b$export$82476f982757e71e)(route.path, params);
    const matchedRoute = (0, $4366c52d36621328$export$2e2bcd8739ae039)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $f89e874adec4a5d6$export$2de13e891a662beb),
        query: query
    };
};
const $7040b2dec5a7dddb$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = "" } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $5682d9ca04ade704$exports.qs).parse(search);
    const matchedRoute = (0, $4366c52d36621328$export$2e2bcd8739ae039)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $f89e874adec4a5d6$export$4eadc79233226325),
        match: matchedRoute ? matchedRoute.match : (0, $f89e874adec4a5d6$export$2de13e891a662beb)
    };
};


const $1b8104a3d5821b84$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $1b8104a3d5821b84$export$be4ddcda4c53423d = (_ref)=>{
    let { prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch } = _ref;
    return prevContextMatch.path === nextContextMatch.path && $1b8104a3d5821b84$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $1b8104a3d5821b84$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
};





var $3p9rK = parcelRequire("3p9rK");

/* eslint-disable import/no-unresolved */ 
var $1u0KT = parcelRequire("1u0KT");

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");
const $16a7bafc81a7e985$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $16a7bafc81a7e985$var$defaults = {
    batchUpdates: "useSyncExternalStore" in (0, (/*@__PURE__*/$parcel$interopDefault($acw62))),
    devtools: false,
    middlewares: new Set(),
    mutator: $16a7bafc81a7e985$var$defaultMutator
};
var $16a7bafc81a7e985$export$2e2bcd8739ae039 = $16a7bafc81a7e985$var$defaults;


const $123976b5fa440531$var$supports = {
    scheduling () {
        return typeof window !== "undefined" && typeof MessageChannel === "function";
    }
};
var $123976b5fa440531$export$2e2bcd8739ae039 = $123976b5fa440531$var$supports;


let $670af8fa19d94fbd$var$isInsideBatchedSchedule = false;
function $670af8fa19d94fbd$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $16a7bafc81a7e985$export$2e2bcd8739ae039).batchUpdates || !(0, $123976b5fa440531$export$2e2bcd8739ae039).scheduling() || $670af8fa19d94fbd$var$isInsideBatchedSchedule) return (0, $1u0KT.unstable_batchedUpdates)(fn);
    $670af8fa19d94fbd$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $fO90s.unstable_scheduleCallback)((0, $fO90s.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $1u0KT.unstable_batchedUpdates)(fn);
        $670af8fa19d94fbd$var$isInsideBatchedSchedule = false;
    });
}


var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
"use strict";

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));



var $acw62 = parcelRequire("acw62");


const $13e1b1165581c9b3$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $13e1b1165581c9b3$var$warnings = new WeakMap();
const $13e1b1165581c9b3$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools ? $13e1b1165581c9b3$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$13e1b1165581c9b3$var$warnings.has(actionFn)) $13e1b1165581c9b3$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $13e1b1165581c9b3$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $13e1b1165581c9b3$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};



// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $005aee7619e5fa52$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $005aee7619e5fa52$var$CACHE = new WeakMap();
function $005aee7619e5fa52$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = "" + objA;
        const strB = "" + objB;
        if (strA !== strB || strA[0] === "[" && strA !== "[object Object]") return false;
         // do object comparison
        let keysA;
        if ($005aee7619e5fa52$var$CACHE.has(objA)) keysA = $005aee7619e5fa52$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $005aee7619e5fa52$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($005aee7619e5fa52$var$CACHE.has(objB)) keysB = $005aee7619e5fa52$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $005aee7619e5fa52$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$005aee7619e5fa52$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}


const $987ee9d36fade5fb$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $005aee7619e5fa52$export$2e2bcd8739ae039)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $987ee9d36fade5fb$export$2e2bcd8739ae039 = $987ee9d36fade5fb$var$updateMiddleware;


const $1aee96b21602f71e$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $987ee9d36fade5fb$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).mutator);
var $1aee96b21602f71e$export$2e2bcd8739ae039 = $1aee96b21602f71e$var$applyMiddleware;



const $dc346cd81aa1a5b4$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === "DISPATCH") switch(message.payload.type){
            case "RESET":
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case "COMMIT":
                devTools.init(storeState.getState());
                return;
            case "ROLLBACK":
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case "JUMP_TO_STATE":
            case "JUMP_TO_ACTION":
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === "ACTION") {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $dc346cd81aa1a5b4$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools === "function" ? (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools(storeState) : {};
                        devTools = $dc346cd81aa1a5b4$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $dc346cd81aa1a5b4$export$2e2bcd8739ae039 = $dc346cd81aa1a5b4$var$withDevtools;






const $f8bfb2cc6be056d4$var$QUEUE = [];
let $f8bfb2cc6be056d4$var$scheduled;
function $f8bfb2cc6be056d4$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $16a7bafc81a7e985$export$2e2bcd8739ae039).batchUpdates || !(0, $123976b5fa440531$export$2e2bcd8739ae039).scheduling()) return (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$f8bfb2cc6be056d4$var$QUEUE.includes(fn)) $f8bfb2cc6be056d4$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($f8bfb2cc6be056d4$var$scheduled) return;
    $f8bfb2cc6be056d4$var$scheduled = (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>{
        let queueFn;
        while(queueFn = $f8bfb2cc6be056d4$var$QUEUE.shift())queueFn();
        $f8bfb2cc6be056d4$var$scheduled = null;
    });
}


function $90172912008b49e0$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $f8bfb2cc6be056d4$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $1aee96b21602f71e$export$2e2bcd8739ae039)(storeState, (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).middlewares);
    return storeState;
}
var $90172912008b49e0$export$2e2bcd8739ae039 = (0, $dc346cd81aa1a5b4$export$2e2bcd8739ae039)($90172912008b49e0$var$createStoreState);


const $61bf82a671dbe4e0$export$e4d628ba0054221b = "__global__";
class $61bf82a671dbe4e0$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $61bf82a671dbe4e0$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $123976b5fa440531$export$2e2bcd8739ae039).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $90172912008b49e0$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $13e1b1165581c9b3$export$5ee1d46cd0883a22)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $61bf82a671dbe4e0$export$9d726ae4880b1060 = new $61bf82a671dbe4e0$export$acb47f32da33501e();


const $18357e59c27a6d53$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    globalRegistry: (0, $61bf82a671dbe4e0$export$9d726ae4880b1060),
    retrieveStore: (Store)=>(0, $61bf82a671dbe4e0$export$9d726ae4880b1060).getStore(Store)
}, ()=>0);



function $0af7b28a1088eb67$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $0af7b28a1088eb67$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $005aee7619e5fa52$export$2e2bcd8739ae039)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$0af7b28a1088eb67$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $0af7b28a1088eb67$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $0af7b28a1088eb67$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $005aee7619e5fa52$export$2e2bcd8739ae039)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $486088c4f937815c$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $0af7b28a1088eb67$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $0af7b28a1088eb67$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $486088c4f937815c$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === "function" && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $486088c4f937815c$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $486088c4f937815c$var$cache = new WeakMap();
function $486088c4f937815c$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$486088c4f937815c$var$cache.has(storeState)) $486088c4f937815c$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $486088c4f937815c$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $486088c4f937815c$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $486088c4f937815c$export$d2c200d79fc82f8c(selector);
}


const $b11c197a6f748a78$var$EMPTY_SELECTOR = ()=>undefined;
const $b11c197a6f748a78$var$DEFAULT_SELECTOR = (state)=>state;
function $b11c197a6f748a78$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $acw62.useContext)((0, $18357e59c27a6d53$export$841858b892ce1f4c));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $acw62.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $acw62.useMemo)(()=>selector ? (0, $486088c4f937815c$export$38d24f3c60944dd5)(selector, storeState, hasPropsArg) : selector === null ? $b11c197a6f748a78$var$EMPTY_SELECTOR : $b11c197a6f748a78$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $acw62.useState)({})[1];
        const getSnapshot = (0, $acw62.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $b11c197a6f748a78$export$7c643e1d6648e418(Store) {
    const useHook = $b11c197a6f748a78$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $b11c197a6f748a78$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $b11c197a6f748a78$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



const $8506a449c87a280c$var$_excluded = [
    "children"
], $8506a449c87a280c$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $8506a449c87a280c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8506a449c87a280c$var$noop = ()=>()=>{};
function $8506a449c87a280c$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $8506a449c87a280c$var$noop, onUpdate: onUpdate = $8506a449c87a280c$var$noop, onCleanup: onCleanup = $8506a449c87a280c$var$noop, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    if ("key" in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split("__")[0]})`;
        return $8506a449c87a280c$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $8506a449c87a280c$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $8506a449c87a280c$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $8506a449c87a280c$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $8506a449c87a280c$var$createFunctionContainer(StoreOrOptions);
}
function $8506a449c87a280c$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $acw62.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $61bf82a671dbe4e0$export$acb47f32da33501e)("__local__") : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $8506a449c87a280c$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $acw62.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $acw62.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $13e1b1165581c9b3$export$5ee1d46cd0883a22)(Store.actions, storeState, config);
            const handlers = (0, $13e1b1165581c9b3$export$5ee1d46cd0883a22)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $8506a449c87a280c$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $acw62.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $acw62.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $8506a449c87a280c$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $8506a449c87a280c$var$_objectWithoutPropertiesLoose(props, $8506a449c87a280c$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $8506a449c87a280c$var$_objectWithoutPropertiesLoose(restProps, $8506a449c87a280c$var$_excluded2);
        const ctx = (0, $acw62.useContext)((0, $18357e59c27a6d53$export$841858b892ce1f4c));
        const registry = $8506a449c87a280c$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $acw62.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $8506a449c87a280c$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $8506a449c87a280c$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $005aee7619e5fa52$export$2e2bcd8739ae039)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $acw62.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18357e59c27a6d53$export$841858b892ce1f4c).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    };
    return FunctionContainer;
}

/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $f99d8d574f57736c$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $abf782f06879c350$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), "") : "";
    return [
        name,
        (0, $f99d8d574f57736c$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join("__");
}
function $abf782f06879c350$export$f51a9068ac82ea43(_ref) {
    let { name: name = "", initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $abf782f06879c350$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}


const $5fd4d2e98591a497$var$_excluded = [
    "children"
];
function $5fd4d2e98591a497$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5fd4d2e98591a497$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $5fd4d2e98591a497$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $5fd4d2e98591a497$var$_objectWithoutPropertiesLoose(_ref, $5fd4d2e98591a497$var$_excluded);
        const api = useStore($5fd4d2e98591a497$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split("__")[0]})`;
    return Subscriber;
}






const $7bf0d9fdaa35eb7b$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
const $7bf0d9fdaa35eb7b$var$addLeadingSlash = (path)=>path.charAt(0) === "/" ? path : "/" + path;
const $7bf0d9fdaa35eb7b$export$b8ce2e8154d1dff1 = function sanitizePath(path, prefix) {
    if (prefix === void 0) prefix = "";
    if (prefix) {
        prefix = $7bf0d9fdaa35eb7b$var$stripTrailingSlash(prefix);
        prefix = $7bf0d9fdaa35eb7b$var$addLeadingSlash(prefix);
        path = $7bf0d9fdaa35eb7b$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $7bf0d9fdaa35eb7b$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp("^([a-z]+://|//)", "i");
    return regex.test(path);
};
const $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== "string" || !$7bf0d9fdaa35eb7b$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5682d9ca04ade704$exports)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5682d9ca04ade704$exports)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65 = function getRelativePath(path, prefix) {
    if (prefix === void 0) prefix = "";
    if (typeof path !== "string") return path;
    if (!$7bf0d9fdaa35eb7b$export$e83e3719fc818ee5(path)) {
        path = $7bf0d9fdaa35eb7b$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($5682d9ca04ade704$exports)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $7bf0d9fdaa35eb7b$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5682d9ca04ade704$exports.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $7bf0d9fdaa35eb7b$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $7bf0d9fdaa35eb7b$export$c9237620ff7fdf7c = (_ref)=>{
    let { context: context, prevContext: prevContext, pluginId: pluginId } = _ref;
    const sameRoute = (0, $1b8104a3d5821b84$export$be4ddcda4c53423d)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    }); // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === "resources-plugin" || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldReload;
};


const $d7dd1b3b8cc777cb$export$36d128238e6b60f5 = {
    action: (0, $f89e874adec4a5d6$export$fa440ddf675c8a93),
    basePath: "",
    location: (0, $f89e874adec4a5d6$export$39607c9878cf5148).location,
    history: (0, $f89e874adec4a5d6$export$39607c9878cf5148),
    match: (0, $f89e874adec4a5d6$export$2de13e891a662beb),
    onPrefetch: undefined,
    query: {},
    route: (0, $f89e874adec4a5d6$export$4eadc79233226325),
    routes: [],
    unlisten: null,
    plugins: []
};
const $d7dd1b3b8cc777cb$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>(_ref)=>{
            let { setState: setState, dispatch: dispatch } = _ref;
            const { basePath: basePath = "", history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)()) dispatch($d7dd1b3b8cc777cb$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>(_ref2)=>{
            let { getState: getState, setState: setState } = _ref2;
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen(function() {
                for(var _len = arguments.length, update = new Array(_len), _key = 0; _key < _len; _key++)update[_key] = arguments[_key];
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $7bf0d9fdaa35eb7b$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path)=>(_ref3)=>{
            let { getState: getState } = _ref3;
            const { history: history, basePath: basePath } = getState();
            if ((0, $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65)(path, basePath));
        },
    pushTo: function pushTo(route, attributes) {
        if (attributes === void 0) attributes = {};
        return (_ref4)=>{
            let { getState: getState } = _ref4;
            const { history: history, basePath: basePath } = getState();
            const location = (0, $b3b09a7589a73470$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, attributes, {
                basePath: basePath
            }));
            (0, $4366c52d36621328$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.push(location);
        };
    },
    replace: (path)=>(_ref5)=>{
            let { getState: getState } = _ref5;
            const { history: history, basePath: basePath } = getState();
            if ((0, $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65)(path, basePath));
        },
    replaceTo: function replaceTo(route, attributes) {
        if (attributes === void 0) attributes = {};
        return (_ref6)=>{
            let { getState: getState } = _ref6;
            const { history: history, basePath: basePath } = getState();
            const location = (0, $b3b09a7589a73470$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, attributes, {
                basePath: basePath
            }));
            (0, $4366c52d36621328$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.replace(location);
        };
    },
    goBack: ()=>(_ref7)=>{
            let { getState: getState } = _ref7;
            const { history: history } = getState(); // history@4 uses goBack(), history@5 uses back()
            if ("goBack" in history) history.goBack();
            else if ("back" in history) history.back();
            else throw new Error("History does not support goBack");
        },
    goForward: ()=>(_ref8)=>{
            let { getState: getState } = _ref8;
            const { history: history } = getState(); // history@4 uses goForward(), history@5 uses forward()
            if ("goForward" in history) history.goForward();
            else if ("forward" in history) history.forward();
            else throw new Error("History does not support goForward");
        },
    registerBlock: (blocker)=>(_ref9)=>{
            let { getState: getState } = _ref9;
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>(_ref10)=>{
            let { getState: getState } = _ref10;
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>(_ref11)=>{
            let { getState: getState } = _ref11;
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: function updateQueryParam(params, updateType) {
        if (updateType === void 0) updateType = "push";
        return (_ref12)=>{
            let { getState: getState } = _ref12;
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, existingQueryParams, params); // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $7bf0d9fdaa35eb7b$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $7bf0d9fdaa35eb7b$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        };
    },
    updatePathParam: function updatePathParam(params, updateType) {
        if (updateType === void 0) updateType = "push";
        return (_ref13)=>{
            let { getState: getState } = _ref13;
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, existingPathParams, params);
            const updatedPath = (0, $3b1df627ec2bc28b$export$82476f982757e71e)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $7bf0d9fdaa35eb7b$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $7bf0d9fdaa35eb7b$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        };
    },
    loadPlugins: ()=>(_ref14)=>{
            let { getState: getState } = _ref14;
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>(_ref15)=>{
            let { getState: getState } = _ref15;
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $d7dd1b3b8cc777cb$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5)(path)) {
                const location = (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)((0, $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c = (0, $abf782f06879c350$export$f51a9068ac82ea43)({
    initialState: $d7dd1b3b8cc777cb$export$36d128238e6b60f5,
    actions: $d7dd1b3b8cc777cb$var$actions,
    name: "router"
});
const $d7dd1b3b8cc777cb$export$d6b817abe7a77ea5 = (0, $8506a449c87a280c$export$26ae5ca175b4ec5a)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c, {
    displayName: "RouterContainer",
    onInit: ()=>(_ref16, props)=>{
            let { dispatch: dispatch } = _ref16;
            dispatch($d7dd1b3b8cc777cb$var$actions.bootstrapStore(props));
            !(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)() && dispatch($d7dd1b3b8cc777cb$var$actions.loadPlugins());
        },
    onCleanup: ()=>()=>{}
});
const $d7dd1b3b8cc777cb$export$2e249c5b0c1716a7 = (0, $5fd4d2e98591a497$export$48f338a7e080595c)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c, {
    selector: (state)=>Boolean(state.route && state.route.resources)
});
const $d7dd1b3b8cc777cb$export$9569010eab09ae9e = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c);
const $d7dd1b3b8cc777cb$export$ada49399abf7a3a1 = (0, $b11c197a6f748a78$export$7c643e1d6648e418)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c);
function $d7dd1b3b8cc777cb$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector() {
        return useHook(...arguments)[0];
    };
}
const $d7dd1b3b8cc777cb$export$5ccad187366c8494 = ()=>(0, $61bf82a671dbe4e0$export$9d726ae4880b1060).getStore($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c); // @ts-ignore accessing private store property
const $d7dd1b3b8cc777cb$export$ebf37f7e180b13a9 = ()=>$d7dd1b3b8cc777cb$export$5ccad187366c8494().storeState.getState();


const $ea45ac0bebb723d5$export$9a302a45f65d0572 = (0, $d7dd1b3b8cc777cb$export$9569010eab09ae9e);


class $872831f5c7989038$var$Redirector extends (0, $acw62.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === "object" ? "path" in to ? (0, $6d23e34a443a4a03$export$fe53371bee54353d)((0, $b3b09a7589a73470$export$37e0729cc751960b)(to.path, routeAttributes)) : (0, $6d23e34a443a4a03$export$fe53371bee54353d)(to) : to;
        const currentPath = (0, $6d23e34a443a4a03$export$fe53371bee54353d)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($872831f5c7989038$var$Redirector, "defaultProps", {
    push: false
});
const $872831f5c7989038$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($872831f5c7989038$var$Redirector, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        actions: actions,
        location: location
    }, props));
};



var $3p9rK = parcelRequire("3p9rK");


var $acw62 = parcelRequire("acw62");

const $5c5fc49f89228450$export$c36ce69a82764756 = (plugins, _ref)=>{
    let { routes: routes, history: history, basePath: basePath } = _ref;
    const context = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};



var $3p9rK = parcelRequire("3p9rK");

var $c05no = parcelRequire("c05no");



var $3p9rK = parcelRequire("3p9rK");
const $80a44afb3352f8a7$export$9ccb639b7a119f61 = ()=>Date.now();



var $3p9rK = parcelRequire("3p9rK");
const $0daa80f21dc00bb9$export$881d135f98d8d7d0 = 100;
const $0daa80f21dc00bb9$export$9ab5bdcb8a1d6c34 = false;
const $0daa80f21dc00bb9$export$12c1dc38ea1692da = 0;



var $3p9rK = parcelRequire("3p9rK");
const $09224ee6e0f14bb2$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $09224ee6e0f14bb2$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
        expiresAt: $09224ee6e0f14bb2$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;


const $ac5914e1b54c512a$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};


class $1764d5cdabf9b060$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super("Resource timed out: " + message);
        this.name = "TimeoutError";
    }
}


const $0ed746462ed56ab8$export$37d3126be6549b13 = 10000;


function $722f2912d3f13ed9$export$dc62515c8f0b52dd(_ref) {
    var _promiseOrData, _resource$maxAge;
    let { context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext } = _ref;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options; // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    } // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $ac5914e1b54c512a$export$58634b3a58ae66b7)(timeout) : null; // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === "function" ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $1764d5cdabf9b060$export$66d311bf29d5c89c)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $0daa80f21dc00bb9$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)((0, $0ed746462ed56ab8$export$37d3126be6549b13))) : resourceMaxAge
    };
}



/**
 * Utility method to created async versions of getData functions
 */ const $9887148533011f1c$var$handleGetDataLoader = (asyncImport)=>async function() {
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...arguments);
    };
const $9887148533011f1c$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $9887148533011f1c$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === "number" ? arg.maxAge : (0, $0daa80f21dc00bb9$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === "number" ? arg.maxCache : (0, $0daa80f21dc00bb9$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === "boolean" ? arg.isBrowserOnly : (0, $0daa80f21dc00bb9$export$9ab5bdcb8a1d6c34),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};



var $3p9rK = parcelRequire("3p9rK");

var $3p9rK = parcelRequire("3p9rK");



/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $056ce9d2617b7d15$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $7072c7b2c523c18c$export$fa8e33c3301e2e94 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, (0, $056ce9d2617b7d15$export$2df85a734ff5ed27), {
        expiresAt: (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)((0, $0daa80f21dc00bb9$export$12c1dc38ea1692da)),
        accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)()
    });



var $c05no = parcelRequire("c05no");

var $3p9rK = parcelRequire("3p9rK");
function $36e20b00616847b7$var$_toPropertyKey(arg) {
    var key = $36e20b00616847b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $36e20b00616847b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $36e20b00616847b7$export$11374758be89e40 = (type, key)=>(_ref)=>{
        var _prefetching$type;
        let { getState: getState } = _ref;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null ? void 0 : (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key]; // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $36e20b00616847b7$export$1e32615dc8354436 = (type, key, slice)=>(_ref2)=>{
        var _prefetching$type2, _slice$promise;
        let { setState: setState, getState: getState } = _ref2;
        const { prefetching: prefetching } = getState(); // avoid doing extra set if same value
        if ((prefetching == null ? void 0 : (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return; // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prefetching, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $36e20b00616847b7$export$704f800f263b050e = (type, key, state)=>(_ref3)=>{
        let { setState: setState, getState: getState, dispatch: dispatch } = _ref3;
        const { data: data } = getState(); // every time we override a resource we kill its prefetched
        dispatch($36e20b00616847b7$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, data, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $36e20b00616847b7$export$5fc90c33b03fffb = (type, key)=>(_ref4)=>{
        let { getState: getState } = _ref4;
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $36e20b00616847b7$export$d40f35dc5952864b = (type, key)=>(_ref5)=>{
        let { getState: getState, setState: setState } = _ref5;
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(data, [
            type
        ].map($36e20b00616847b7$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(resourceForType, [
                key
            ].map($36e20b00616847b7$var$_toPropertyKey));
            setState({
                data: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };


var $2aa0415f4fbaaef9$var$_Object$fromEntries;
const $2aa0415f4fbaaef9$var$fromEntries = ($2aa0415f4fbaaef9$var$_Object$fromEntries = Object.fromEntries) != null ? $2aa0415f4fbaaef9$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map((_ref)=>{
        let [k, v] = _ref;
        return {
            [k]: v
        };
    }));
const $2aa0415f4fbaaef9$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $2aa0415f4fbaaef9$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = "ResourceDependencyError";
    }
}
const $2aa0415f4fbaaef9$export$12600f2e0e7fb2cc = (routeResources, tuples)=>(_ref2)=>{
        var _routeResources$some;
        let { getState: getState, setState: setState, dispatch: dispatch } = _ref2;
        if (getState().executing) throw new Error("execution is already in progress");
         // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some((_ref3)=>{
            let { depends: depends } = _ref3;
            return depends == null ? void 0 : depends.length;
        })) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map((_ref4)=>{
            let [, action] = _ref4;
            return dispatch(action);
        });
         // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter((_ref5)=>{
            let [resource] = _ref5;
            return routeResources == null ? void 0 : routeResources.some($2aa0415f4fbaaef9$var$matchType(resource));
        });
        if (listedTuples.length === 0) return tuples.map((_ref6)=>{
            let [, action] = _ref6;
            return dispatch(action);
        });
         // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, _ref7)=>{
            let { type: type, depends: depends } = _ref7;
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map((_ref8)=>{
                let [{ type: type }] = _ref8;
                return type;
            })
        ]).filter((v, i, a)=>a.indexOf(v) === i); // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter((_ref9)=>{
            let [{ type: type }] = _ref9;
            return dependentTypes.includes(type);
        });
        if (dependentTuples.length === 0) return tuples.map((_ref10)=>{
            let [, action] = _ref10;
            return dispatch(action);
        });
         // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter((_ref11)=>{
            let { type: type } = _ref11;
            return dependentTypes.includes(type);
        }).reduce((acc, _ref12)=>{
            let { type: type, depends: depends } = _ref12;
            return depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ];
        }, []).filter((v, i, a)=>a.indexOf(v) === i); // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter((_ref13)=>{
            let { type: type } = _ref13;
            return dependentAndDependencyTypes.includes(type);
        }).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($2aa0415f4fbaaef9$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        }); // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map((_ref14, i)=>{
            var _getState$executing;
            let [{ type: expectedType }] = _ref14;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error("execution reached an inconsistent state");
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        }); // pick existing execution result or dispatch any remaining independent actions
        return tuples.map((_ref15)=>{
            let [resource, action] = _ref15;
            const index = executingTuples.findIndex($2aa0415f4fbaaef9$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $2aa0415f4fbaaef9$export$5f7e1fd85734e71e = (routeResources, resource, action)=>(_ref16)=>{
        let { dispatch: dispatch } = _ref16;
        return dispatch($2aa0415f4fbaaef9$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
    };
const $2aa0415f4fbaaef9$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$2aa0415f4fbaaef9$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $2aa0415f4fbaaef9$export$7d1ffac63c68405d = (resource, actionCreator)=>(_ref17)=>{
        var _tuples$findIndex;
        let { getState: getState, setState: setState } = _ref17;
        const { executing: tuples } = getState(); // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($2aa0415f4fbaaef9$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
         // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $2aa0415f4fbaaef9$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>(_ref18)=>{
        var _tuples$findIndex2;
        let { getState: getState, dispatch: dispatch } = _ref18;
        const { type: type, depends: depends } = resource; // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState(); // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($2aa0415f4fbaaef9$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $2aa0415f4fbaaef9$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
         // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($2aa0415f4fbaaef9$var$matchType({
                    type: dependency
                }))
            ]); // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach((_ref19)=>{
            let [dependency, index] = _ref19;
            if (index < 0) throw new $2aa0415f4fbaaef9$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $2aa0415f4fbaaef9$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $2aa0415f4fbaaef9$var$fromEntries(dependencyIndexTuples.map((_ref20)=>{
            let [dependencyType, index] = _ref20;
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(dependencyType, key)) || (0, $7072c7b2c523c18c$export$fa8e33c3301e2e94)(); // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $36e20b00616847b7$export$11374758be89e40)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };





const $95b99fbe63b579ee$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $95b99fbe63b579ee$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$95b99fbe63b579ee$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));



const $2219ae4670107b19$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $2219ae4670107b19$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;


const $ac03685282beddca$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $2219ae4670107b19$export$740886389191c640)(nextRoute)) return [];
    if ((0, $2219ae4670107b19$export$221027ff1aa38f82)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $95b99fbe63b579ee$export$cd7fbe7e979df558)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $95b99fbe63b579ee$export$c616b176adf9ad4a)(resource, nextRouterStoreContext, resourceStoreContext)));
};



const $de5c3ff2ee0cf07c$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $de5c3ff2ee0cf07c$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $de5c3ff2ee0cf07c$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $de5c3ff2ee0cf07c$export$89440b7623c2c75c = (resource, key)=>(_ref)=>{
        let { getState: getState, dispatch: dispatch } = _ref;
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $de5c3ff2ee0cf07c$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type, keyTobeDeleted));
    };




// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $549026d620c8a374$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = "NonError";
        if (Error.captureStackTrace) Error.captureStackTrace(this, $549026d620c8a374$var$NonError);
    }
}
const $549026d620c8a374$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
const $549026d620c8a374$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $549026d620c8a374$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = "[Circular]";
    }
    for (const property of $549026d620c8a374$var$commonProperties)if (typeof from[property] === "string") to[property] = from[property];
    return to;
}; // const serializeError = <ErrorType = any>(value: ErrorType) => {
const $549026d620c8a374$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === "object" && value !== null) return $549026d620c8a374$var$destroyCircular(value, []);
     // People sometimes throw things besides Error objects…
    if (typeof value === "function") // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
const $549026d620c8a374$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $549026d620c8a374$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $549026d620c8a374$var$NonError(value);
};


const $9ded5038a8fc11a1$export$b25d2963b8a3488a = (_ref)=>{
    let { expiresAt: expiresAt } = _ref;
    return expiresAt === null;
};
const $9ded5038a8fc11a1$var$isFresh = (resource)=>{
    if ($9ded5038a8fc11a1$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $9ded5038a8fc11a1$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null ? void 0 : (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === "TimeoutError") return false;
    if (resource.loading) return true;
    if ($9ded5038a8fc11a1$var$isFresh(resource)) return true;
    return false;
};



var $3p9rK = parcelRequire("3p9rK");
const $b194ee12835f929c$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;



const $b3237e0ad7d80117$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});




const $5d07b75cfb5fbe3b$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice) : (0, $7072c7b2c523c18c$export$fa8e33c3301e2e94)();
};
const $5d07b75cfb5fbe3b$export$6a0b1779210de0ee = (state)=>state.context;



const $cb32642adcae8951$var$_excluded = [
    "context"
], $cb32642adcae8951$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $cb32642adcae8951$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>(_ref)=>{
            let { getState: getState, dispatch: dispatch } = _ref;
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type, key));
                dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(_ref2)=>{
            let { getState: getState, dispatch: dispatch } = _ref2;
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_getState, $cb32642adcae8951$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $5d07b75cfb5fbe3b$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true // promise: existing value retained
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prevSlice, changes, {
                expiresAt: (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)(maxAge),
                accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)()
            });
            dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, newSlice)); // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async (_ref3)=>{
            let { getState: getState, dispatch: dispatch } = _ref3;
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key));
            if (cached && (0, $9ded5038a8fc11a1$export$399de8c43d0ece3c)(cached)) {
                if ((0, $9ded5038a8fc11a1$export$b25d2963b8a3488a)(cached)) {
                    const withResolvedPromise = (0, $b194ee12835f929c$export$2e4da1b414980956)(cached);
                    cached = (0, $09224ee6e0f14bb2$export$18d1d420fd588368)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)();
                dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, cached));
                return cached;
            }
            return dispatch($cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async (_ref4)=>{
            let { getState: getState, dispatch: dispatch } = _ref4;
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key)) || (0, $7072c7b2c523c18c$export$fa8e33c3301e2e94)(); // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $de5c3ff2ee0cf07c$export$89440b7623c2c75c)(resource, key));
            const loadingSlice = dispatch((0, $36e20b00616847b7$export$11374758be89e40)(type, key)) || (0, $722f2912d3f13ed9$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $2aa0415f4fbaaef9$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)()
                }))); // trigger dependent resources to also load
                dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options))); // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $1764d5cdabf9b060$export$66d311bf29d5c89c)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            } // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key));
            const finalSlice = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)(),
                expiresAt: (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)(maxAge)
            }); // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async (_ref5)=>{
            let { getState: getState, dispatch: dispatch } = _ref5;
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $36e20b00616847b7$export$11374758be89e40)(type, key)) || (0, $722f2912d3f13ed9$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $2aa0415f4fbaaef9$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            }); // save deferred value to be used also by dependants
            dispatch((0, $36e20b00616847b7$export$1e32615dc8354436)(type, key, loadingSlice)); // trigger dependent resources to also prefetch
            dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $cb32642adcae8951$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext == null ? void 0 : routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null)),
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: function requestAllResources(routerStoreContext, options) {
        if (options === void 0) options = {};
        return (_ref6)=>{
            let { dispatch: dispatch } = _ref6;
            const { route: route } = routerStoreContext || {};
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($cb32642adcae8951$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        };
    },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>(_ref7)=>{
            let { getState: getState, dispatch: dispatch } = _ref7;
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _routerStoreContext$r;
        const predicate = (0, $40dc7ae0aadcfdfd$export$455cc18296abe008)() ? (_ref8)=>{
            let { isBrowserOnly: isBrowserOnly } = _ref8;
            return !isBrowserOnly;
        } : ()=>true;
        return (0, $2aa0415f4fbaaef9$export$f71a65c89c987a02)((_routerStoreContext$r = routerStoreContext.route.resources) == null ? void 0 : _routerStoreContext$r.filter(predicate), resources.filter(predicate), (resource)=>$cb32642adcae8951$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $2aa0415f4fbaaef9$export$f71a65c89c987a02)(routerStoreContext.route.resources, resources, (resource)=>$cb32642adcae8951$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: (_ref9)=>{
        let { resourceData: resourceData, resourceContext: resourceContext } = _ref9;
        return (_ref10)=>{
            let { getState: getState, setState: setState } = _ref10;
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $b3237e0ad7d80117$export$3ceb62baab058c6b)(getNextStateValue(data, resourceData), (_ref11)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref11, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref11, $cb32642adcae8951$var$_excluded2);
                const deserializedError = !error ? null : (0, $549026d620c8a374$export$64cddc1e268e9046)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === "TimeoutError";
                return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        };
    },
    /**
   * Gets the store's context
   */ getContext: ()=>(_ref12)=>{
            let { getState: getState } = _ref12;
            return getState().context;
        },
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>(_ref13)=>{
            let { getState: getState } = _ref13;
            return (0, $b3237e0ad7d80117$export$3ceb62baab058c6b)(getState().data, (_ref14)=>{
                let { data: data, key: key, error: error, loading: loading } = _ref14;
                return {
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $549026d620c8a374$export$46ff38bc6bdea8fb)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $1764d5cdabf9b060$export$66d311bf29d5c89c) ? loading : false
                };
            });
        }
};
const $cb32642adcae8951$export$94f50dade551bd01 = (0, $abf782f06879c350$export$f51a9068ac82ea43)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $cb32642adcae8951$export$e324594224ef24da,
    name: "router-resources"
});
const $cb32642adcae8951$export$cc90fb9c37c5589d = (0, $8506a449c87a280c$export$26ae5ca175b4ec5a)($cb32642adcae8951$export$94f50dade551bd01, {
    displayName: "ResourceContainer"
});
const $cb32642adcae8951$export$fee1a6213543bd78 = (0, $5fd4d2e98591a497$export$48f338a7e080595c)($cb32642adcae8951$export$94f50dade551bd01, {
    displayName: "ResourceSelectorSubscriber",
    selector: (state, props)=>(0, $5d07b75cfb5fbe3b$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $cb32642adcae8951$export$6f6057d42352becb = ()=>(0, $61bf82a671dbe4e0$export$9d726ae4880b1060).getStore($cb32642adcae8951$export$94f50dade551bd01);
const $cb32642adcae8951$export$ac3608e0bb357c7 = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($cb32642adcae8951$export$94f50dade551bd01, {
    selector: (0, $5d07b75cfb5fbe3b$export$c9ed509724feb827)
});
const $cb32642adcae8951$export$98e41a62c9bef75e = (0, $b11c197a6f748a78$export$7c643e1d6648e418)($cb32642adcae8951$export$94f50dade551bd01);
const $cb32642adcae8951$export$e59f52df235ac7b3 = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($cb32642adcae8951$export$94f50dade551bd01, {
    selector: (0, $5d07b75cfb5fbe3b$export$6a0b1779210de0ee)
});



const $5ee70daed3bb0fac$export$a9bc0bb87abc2c4c = "resources-plugin";
const $5ee70daed3bb0fac$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions;
    const nextResources = (0, $ac03685282beddca$export$7cbbc763e2f3d65d)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $5ee70daed3bb0fac$var$beforeLoad = (_ref)=>{
    let { context: context, nextContext: nextContext } = _ref;
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions;
    const nextResources = (0, $ac03685282beddca$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $5ee70daed3bb0fac$export$23ed892c481a96fe = (_ref2)=>{
    let { context: initialResourceContext, resourceData: initialResourceData, timeout: timeout } = _ref2;
    let latestLoadedResources = Promise.resolve([]);
    (0, $cb32642adcae8951$export$6f6057d42352becb)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $5ee70daed3bb0fac$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $5ee70daed3bb0fac$var$beforeLoad,
        routeLoad: (_ref3)=>{
            let { context: context, prevContext: prevContext } = _ref3;
            const { route: route, match: match, query: query } = context; // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $5ee70daed3bb0fac$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: (_ref4)=>{
            let { context: context, nextContext: nextContext } = _ref4;
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions;
            const nextResources = (0, $ac03685282beddca$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $cb32642adcae8951$export$6f6057d42352becb)().actions.getSafeData();
        }
    };
};



const $54d5bb126d55fb0e$export$55185c17a0fcbe46 = (_ref)=>{
    let { basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, resourceContext: resourceContext, resourceData: resourceData, routes: routes } = _ref;
    (0, $acw62.useEffect)(()=>{
        const { unlisten: unlisten } = (0, $d7dd1b3b8cc777cb$export$ebf37f7e180b13a9)();
        return ()=>{
            unlisten && unlisten();
        };
    }, []);
    const pluginsWithFallback = (0, $acw62.useMemo)(()=>{
        if (plugins) return plugins; // default 'plugins' fallback for the first relase
        const resourcesPlugin = (0, $5ee70daed3bb0fac$export$23ed892c481a96fe)({
            context: resourceContext,
            resourceData: resourceData
        });
        return [
            resourcesPlugin
        ];
    }, [
        resourceContext,
        resourceData,
        plugins
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d7dd1b3b8cc777cb$export$d6b817abe7a77ea5), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: pluginsWithFallback,
        resourceContext: resourceContext,
        resourceData: resourceData,
        routes: routes
    }, children);
};
/**
 * @deprecated
 * The entry point for requesting resource data on the server.
 * Pass the result data into the router as a prop in order to hydrate it.
 */ $54d5bb126d55fb0e$export$55185c17a0fcbe46.requestResources = async (_ref2)=>{
    let { location: location, history: history, timeout: timeout, routes: routes, resourceContext: context } = _ref2;
    const resourcesPlugin = (0, $5ee70daed3bb0fac$export$23ed892c481a96fe)({
        context: context,
        resourceData: null,
        timeout: timeout
    });
    const plugins = [
        resourcesPlugin
    ];
    (0, $5c5fc49f89228450$export$c36ce69a82764756)(plugins, {
        history: history || (0, $6d23e34a443a4a03$export$2b76ad033c6e6d08)({
            initialEntries: [
                location
            ]
        }),
        routes: routes
    });
    return await resourcesPlugin.getSerializedResources();
};
function $54d5bb126d55fb0e$export$ae46f04cfaffe093(props) {
    const history = (0, $acw62.useMemo)(()=>(0, $6d23e34a443a4a03$export$2b76ad033c6e6d08)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54d5bb126d55fb0e$export$55185c17a0fcbe46, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        history: history,
        isGlobal: false
    }));
}



var $acw62 = parcelRequire("acw62");

const $9a1d980dc90c7cfe$export$402e82ff1b20594b = (0, $d7dd1b3b8cc777cb$export$ada49399abf7a3a1);


const $c5192386069651b8$export$b371fa9cf762ad06 = (_ref)=>{
    let { children: children } = _ref;
    const actions = (0, $9a1d980dc90c7cfe$export$402e82ff1b20594b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(actions));
};
$c5192386069651b8$export$b371fa9cf762ad06.displayName = "RouterActions";



var $c05no = parcelRequire("c05no");

var $acw62 = parcelRequire("acw62");


const $aa3a0e8e98413b22$var$_excluded = [
    "listen"
];
const $aa3a0e8e98413b22$export$672d721d310ff5f0 = (_ref)=>{
    let { children: children } = _ref;
    const [state, _ref2] = (0, $d7dd1b3b8cc777cb$export$9569010eab09ae9e)();
    const { listen: listen } = _ref2, actions = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref2, $aa3a0e8e98413b22$var$_excluded);
    if (!state.unlisten && !(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(state, actions));
};




var $acw62 = parcelRequire("acw62");


const $2b48cf5702e8d29d$var$createPathParamHook = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)((0, $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c), {
    selector: (_ref, _ref2)=>{
        let { match: { params: params } } = _ref;
        let { paramKey: paramKey } = _ref2;
        return params[paramKey];
    }
});
const $2b48cf5702e8d29d$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $2b48cf5702e8d29d$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $acw62.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};



var $acw62 = parcelRequire("acw62");


const $1f125c4828fc1621$var$createQueryParamHook = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)((0, $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c), {
    selector: (_ref, _ref2)=>{
        let { query: query } = _ref;
        let { paramKey: paramKey } = _ref2;
        return query[paramKey];
    }
});
const $1f125c4828fc1621$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $1f125c4828fc1621$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $acw62.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};





var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

const $1d0b9d2c09db05d6$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = "UNDEFINED";
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $1d0b9d2c09db05d6$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $1d0b9d2c09db05d6$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $d7dd1b3b8cc777cb$export$9569010eab09ae9e)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};





var $3p9rK = parcelRequire("3p9rK");

var $c05no = parcelRequire("c05no");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $af0f173a51e2a07e$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $acw62.useRef)();
    const schedule = (0, $acw62.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $acw62.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};


const $ae3337f73846c030$var$VALID_LINK_TYPES = [
    "a",
    "button"
];
const $ae3337f73846c030$export$855ece989b15eb57 = (type)=>$ae3337f73846c030$var$VALID_LINK_TYPES.includes(type) ? type : "a";


const $23982ddbe477671f$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $23982ddbe477671f$export$130b789831072f4c = (event)=>[
        "keypress",
        "keydown",
        "keyup"
    ].includes(event.type);


const $86967f23a8bebdcb$export$706ad1af8096e280 = (event, _ref)=>{
    let { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to } = _ref;
    if ((0, $23982ddbe477671f$export$130b789831072f4c)(event) && event.keyCode !== 13) return;
    onClick && onClick(event);
    if (!event.defaultPrevented && ((0, $23982ddbe477671f$export$130b789831072f4c)(event) && event.keyCode === 13 || event.button === 0) && (!target || target === "_self") && // let browser handle "target=_blank" etc.
    !(0, $23982ddbe477671f$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href);
        }
    }
};




const $e14fbd57cc703bea$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch"
];
const $e14fbd57cc703bea$var$PREFETCH_DELAY = 225;
const $e14fbd57cc703bea$var$Link = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = "_self", replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = "a", params: params, query: query, prefetch: prefetch = false } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref, $e14fbd57cc703bea$var$_excluded);
    const routerActions = (0, $d7dd1b3b8cc777cb$export$ada49399abf7a3a1)();
    const { schedule: schedule, cancel: cancel } = (0, $af0f173a51e2a07e$export$d8e6abf214c9ec0f)($e14fbd57cc703bea$var$PREFETCH_DELAY);
    const validLinkType = (0, $ae3337f73846c030$export$855ece989b15eb57)(linkType);
    const [route, setRoute] = (0, $acw62.useState)(()=>{
        if (to && typeof to !== "string") {
            if ("then" in to) to.then((r)=>setRoute("default" in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== "string" ? route && (0, $6d23e34a443a4a03$export$fe53371bee54353d)((0, $b3b09a7589a73470$export$37e0729cc751960b)(route.path, routeAttributes)) || "" : to;
    const triggerPrefetch = (0, $acw62.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== "string" && !route) return;
        const context = typeof to !== "string" && route ? (0, $7040b2dec5a7dddb$export$faed15f35ddc6f99)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context); // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $acw62.useEffect)(()=>{
        if (prefetch === "mount") schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $86967f23a8bebdcb$export$706ad1af8096e280)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ]
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === "hover") schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === "hover") cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === "hover") schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === "hover") cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === "hover") {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $acw62.createElement)(validLinkType, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        href: linkDestination,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$e14fbd57cc703bea$var$Link.displayName = "Link";
var $e14fbd57cc703bea$export$2e2bcd8739ae039 = $e14fbd57cc703bea$var$Link;



var $acw62 = parcelRequire("acw62");

const $9c1d9ab94a99f286$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    if (!route) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};










var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



const $ed08430a367fa2fa$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $cb32642adcae8951$export$98e41a62c9bef75e)();
    const { getContext: getRouterContext } = (0, $d7dd1b3b8cc777cb$export$ada49399abf7a3a1)(); // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $acw62.useMemo)(()=>(0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)((0, $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c), {
            selector: (_ref, keyArg)=>{
                let { match: match, query: query, route: route } = _ref;
                return resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext());
            }
        }), [
        resource,
        actions
    ]); // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $cb32642adcae8951$export$ac3608e0bb357c7)({
        type: resource.type,
        key: key
    }); // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $acw62.useMemo)(()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), [
        key
    ]);
    const update = (0, $acw62.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $acw62.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $acw62.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $acw62.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};


const $6cb34cba151f3b47$export$fee1a6213543bd78 = (_ref)=>{
    let { children: children, resource: resource, options: options } = _ref;
    const result = (0, $ed08430a367fa2fa$export$9f6abfd74295843b)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(result));
};




const $ccfe686fa15f1dbd$export$dee7bf9fc0ff48c3 = (fn)=>(0, $cb32642adcae8951$export$6f6057d42352becb)().storeState.subscribe(fn);




const $38e2e54fc73eaafe$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: "bar"
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ""
};







/* Profile.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");


/* TopPanel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

/* ProfileHeader.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");



var $fe73a947836bf836$var$_ProfileHeaderQuery;

const $fe73a947836bf836$export$9d9de7756b13ecf = $fe73a947836bf836$var$_ProfileHeaderQuery !== void 0 ? $fe73a947836bf836$var$_ProfileHeaderQuery : $fe73a947836bf836$var$_ProfileHeaderQuery = (parcelRequire("PQUkW"));


const $29b4de728b246ef8$export$e2de15bbd9edf9c6 = (queryParamsObj)=>{
    const queryParams = [];
    Object.keys(queryParamsObj).forEach((key, value)=>{
        queryParams.push(`${key}=${value}`);
    });
    return queryParams.join("&");
};
const $29b4de728b246ef8$export$e4d2cb79f7781e1c = (text, isHiddenTextIncluded = true)=>{
    const hangingNode = document.createElement("div");
    hangingNode.innerHTML = text;
    return (isHiddenTextIncluded ? hangingNode.textContent : hangingNode.innerText) || "";
};
const $29b4de728b246ef8$export$f67e51a786261278 = (text, isHiddenTextIncluded)=>{
    const textOnly = $29b4de728b246ef8$export$e4d2cb79f7781e1c(text, isHiddenTextIncluded);
    return textOnly.length;
};
const $29b4de728b246ef8$export$1b8f63ded5de1d1e = (url, size, defaultAvatar)=>{
    // TODO: Importing regex from constants is not working.
    // even on browser the same browser shows answer as true & false alternatively.
    if (!url || !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/gim.test(url)) throw new Error(`Invalid URL: ${url}`);
    const urlObj = new URL(url);
    if (urlObj.hostname?.startsWith("avatar-management--avatars") && !urlObj.href.includes("initials")) {
        const urlPathParts = urlObj.pathname.split("/");
        if (!urlPathParts.length) return url;
        urlPathParts[urlPathParts.length - 1] = size.toString();
        urlObj.pathname = urlPathParts.join("/");
        return urlObj.href;
    }
    // if a profile pic is returning an initials avatar url, its hostname could be
    // one among these hostnames: ['secure.gravatar.com', 'i2.wp.com'];
    return defaultAvatar || url;
};


var $4abbfa76f1e2bd65$exports = {};
"use strict";
Object.defineProperty($4abbfa76f1e2bd65$exports, "__esModule", {
    value: true
});
$4abbfa76f1e2bd65$exports.default = void 0;

var $4abbfa76f1e2bd65$var$_react = $4abbfa76f1e2bd65$var$_interopRequireDefault((parcelRequire("acw62")));

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $8254dab3a92bb0ab$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $8254dab3a92bb0ab$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $8254dab3a92bb0ab$export$62ad7b0c781000e9 = {
    small: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.small,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.medium,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.large,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.xlarge,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.xlarge
    }
};



var $jjlaj = parcelRequire("jjlaj");
var $e6f087d674393b6c$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$smallStyles = (0, $jjlaj.css)((0, $8254dab3a92bb0ab$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$mediumStyles = (0, $jjlaj.css)((0, $8254dab3a92bb0ab$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$largeStyles = (0, $jjlaj.css)((0, $8254dab3a92bb0ab$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$xlargeStyles = (0, $jjlaj.css)((0, $8254dab3a92bb0ab$export$62ad7b0c781000e9).xlarge);
var $e6f087d674393b6c$export$ef0ad74202575b64 = {
    small: $e6f087d674393b6c$var$smallStyles,
    medium: $e6f087d674393b6c$var$mediumStyles,
    large: $e6f087d674393b6c$var$largeStyles,
    xlarge: $e6f087d674393b6c$var$xlargeStyles
};
var $e6f087d674393b6c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $8254dab3a92bb0ab$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $4318718ecf5d405f$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $909afc01458e2b41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $909afc01458e2b41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $909afc01458e2b41$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $909afc01458e2b41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $909afc01458e2b41$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $909afc01458e2b41$var$_objectSpread($909afc01458e2b41$var$_objectSpread({}, (0, $e6f087d674393b6c$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $909afc01458e2b41$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $909afc01458e2b41$var$primaryEqualsSecondaryHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $909afc01458e2b41$var$secondaryTransparentHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $909afc01458e2b41$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jjlaj.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $e6f087d674393b6c$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jjlaj.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $909afc01458e2b41$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $4318718ecf5d405f$export$18cb9425622d4e06)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $909afc01458e2b41$var$iconStyles,
            $909afc01458e2b41$var$baseHcmStyles,
            primaryColor === secondaryColor && $909afc01458e2b41$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $909afc01458e2b41$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jjlaj.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $909afc01458e2b41$export$2e2bcd8739ae039 = $909afc01458e2b41$export$f04a61298a47a40f;


function $4abbfa76f1e2bd65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4abbfa76f1e2bd65$var$CameraIcon = (props)=>/*#__PURE__*/ $4abbfa76f1e2bd65$var$_react.default.createElement($909afc01458e2b41$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M2 6.994C2 5.893 2.898 5 3.99 5h16.02C21.108 5 22 5.895 22 6.994v12.012A1.997 1.997 0 0120.01 21H3.99A1.994 1.994 0 012 19.006V6.994zM4 7v12h16V7H4z"/><path d="M12 17a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z" fill-rule="nonzero"/><path d="M8 4c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1v1H8V4z"/><rect x="17" y="8" width="2" height="2" rx="1"/></g></svg>`
    }, props));
$4abbfa76f1e2bd65$var$CameraIcon.displayName = "CameraIcon";
var $4abbfa76f1e2bd65$var$_default = $4abbfa76f1e2bd65$var$CameraIcon;
$4abbfa76f1e2bd65$exports.default = $4abbfa76f1e2bd65$var$_default;



var $59d8cbc6a227cd2a$var$_UnifiedProfileFragment;

const $59d8cbc6a227cd2a$export$213ff35a3d3f0461 = $59d8cbc6a227cd2a$var$_UnifiedProfileFragment !== void 0 ? $59d8cbc6a227cd2a$var$_UnifiedProfileFragment : $59d8cbc6a227cd2a$var$_UnifiedProfileFragment = (parcelRequire("k04tT"));


var $39c545ba55bc3de2$var$_UnifiedProfileQuery;

const $39c545ba55bc3de2$export$39d254c0229da0b3 = $39c545ba55bc3de2$var$_UnifiedProfileQuery !== void 0 ? $39c545ba55bc3de2$var$_UnifiedProfileQuery : $39c545ba55bc3de2$var$_UnifiedProfileQuery = (parcelRequire("fBk32"));


var $69f7bb7bdecca370$var$_UnifiedAccountQuery;

const $69f7bb7bdecca370$export$d483224631a5893c = $69f7bb7bdecca370$var$_UnifiedAccountQuery !== void 0 ? $69f7bb7bdecca370$var$_UnifiedAccountQuery : $69f7bb7bdecca370$var$_UnifiedAccountQuery = (parcelRequire("59shu"));


var $eaaa7a866fd6fc5b$exports = {};
$eaaa7a866fd6fc5b$exports = new URL("x-icon.3a3af793.svg", import.meta.url).toString();


var $b00d9b82db872ffa$exports = {};
$b00d9b82db872ffa$exports = new URL("chevron-down.015f45dd.svg", import.meta.url).toString();


var $ba2b898ae605882c$exports = {};
$ba2b898ae605882c$exports = new URL("chevron-up.341e71dd.svg", import.meta.url).toString();


var $00322900b96ac3ac$exports = {};
$00322900b96ac3ac$exports = new URL("cover-photo.00961592.svg", import.meta.url).toString();


var $539fd25154d65022$exports = {};
$539fd25154d65022$exports = new URL("link-icon.10f40788.svg", import.meta.url).toString();


var $3d3dc7339317df4e$exports = {};
$3d3dc7339317df4e$exports = new URL("add-link.bb1e704f.svg", import.meta.url).toString();


var $6c9c4bf79e4b0623$exports = {};
$6c9c4bf79e4b0623$exports = new URL("add-link-disabled.7b05b6be.svg", import.meta.url).toString();


var $462a916399c305fe$exports = {};
$462a916399c305fe$exports = new URL("linkedin-icon.01cc0daf.svg", import.meta.url).toString();


var $2d8beca2420f46b5$exports = {};
$2d8beca2420f46b5$exports = new URL("profile-photo.2103ea77.svg", import.meta.url).toString();


var $c8f4f953ff00ae60$exports = {};
$c8f4f953ff00ae60$exports = new URL("youtube-icon.e5306d40.svg", import.meta.url).toString();


var $1119ebe5271f4c0b$exports = {};
$1119ebe5271f4c0b$exports = new URL("avatar.15768afb.png", import.meta.url).toString();


var $a805a8f660383d18$exports = {};
$a805a8f660383d18$exports = new URL("kudos.4785bf39.svg", import.meta.url).toString();


var $f691eb74fa5ba594$exports = {};
$f691eb74fa5ba594$exports = new URL("offsite.249b9488.svg", import.meta.url).toString();


var $2554c0e6dc1d8696$exports = {};
$2554c0e6dc1d8696$exports = new URL("groups.9615f777.svg", import.meta.url).toString();


var $54a8512f4af9f62a$exports = {};
$54a8512f4af9f62a$exports = new URL("teams-icon.7e043335.svg", import.meta.url).toString();


var $80f43fae5f2a7696$exports = {};
$80f43fae5f2a7696$exports = new URL("koala.1effaaf1.svg", import.meta.url).toString();


var $f37efaa995ee4197$exports = {};
$f37efaa995ee4197$exports = new URL("frog.566a6fa2.svg", import.meta.url).toString();


var $d6f94d8ef91e1f48$exports = {};
$d6f94d8ef91e1f48$exports = new URL("parrot.cde4168a.svg", import.meta.url).toString();


var $cfd5dd4fef2e3758$exports = {};
$cfd5dd4fef2e3758$exports = new URL("danger-triangle.f0b9b384.svg", import.meta.url).toString();


var $707d35ecd7f38950$exports = {};
$707d35ecd7f38950$exports = new URL("not-found.77b45078.svg", import.meta.url).toString();


var $d572cd9d3c22273f$exports = {};
$d572cd9d3c22273f$exports = new URL("padlock_Light mode_spot.5a1eeebb.svg", import.meta.url).toString();


var $ff6469b987c1ec9f$exports = {};
$ff6469b987c1ec9f$exports = new URL("certification-banner-image.4c20636d.svg", import.meta.url).toString();


var $fd39177d1a9e2c77$exports = {};
$fd39177d1a9e2c77$exports = new URL("trophy.634e454a.svg", import.meta.url).toString();


var $d4d6420dfd160f51$exports = {};
$d4d6420dfd160f51$exports = new URL("rocket.cc345ebc.svg", import.meta.url).toString();


var $915a40f482384f94$exports = {};
$915a40f482384f94$exports = new URL("medal.bff92450.svg", import.meta.url).toString();


var $954bfc0b92c489fd$exports = {};
$954bfc0b92c489fd$exports = new URL("document.20f528d4.svg", import.meta.url).toString();




const $ea571afc9b14fbb2$var$REACT_APP_UPP_API_URL = "/gateway/api/upp-service-api";
const $ea571afc9b14fbb2$export$8da38880edaaf4d0 = `${$ea571afc9b14fbb2$var$REACT_APP_UPP_API_URL}/gateway/api/graphql`;
const $ea571afc9b14fbb2$export$807b1b70df68fbc6 = {
    LOG_PATH: "/log"
};


var $5b4d113e3efb8585$var$_AtlassianAccountUserQuery;

const $5b4d113e3efb8585$export$75493bef044c2fa0 = $5b4d113e3efb8585$var$_AtlassianAccountUserQuery !== void 0 ? $5b4d113e3efb8585$var$_AtlassianAccountUserQuery : $5b4d113e3efb8585$var$_AtlassianAccountUserQuery = (parcelRequire("am7fE"));



const $77d0522707ddb581$export$2812a1fb15aca49c = "/profile";
var $77d0522707ddb581$export$a7e851dd01b7bece;
(function(IMAGE_SIZE) {
    IMAGE_SIZE[IMAGE_SIZE["SMALL"] = 128] = "SMALL";
    IMAGE_SIZE[IMAGE_SIZE["MEDIUM"] = 256] = "MEDIUM";
    IMAGE_SIZE[IMAGE_SIZE["LARGE"] = 512] = "LARGE";
    IMAGE_SIZE[IMAGE_SIZE["XLARGE"] = 1024] = "XLARGE";
})($77d0522707ddb581$export$a7e851dd01b7bece || ($77d0522707ddb581$export$a7e851dd01b7bece = {}));
var $77d0522707ddb581$export$1e6863d38ecd9f1e;
(function(DROPDOWN_ACTION_TEXT) {
    DROPDOWN_ACTION_TEXT["CHANGE_PRIMARY"] = "Change primary";
    DROPDOWN_ACTION_TEXT["MAKE_PRIMARY"] = "Make primary";
    DROPDOWN_ACTION_TEXT["UNLINK_ACCOUNT"] = "Unlink from primary";
})($77d0522707ddb581$export$1e6863d38ecd9f1e || ($77d0522707ddb581$export$1e6863d38ecd9f1e = {}));
var $77d0522707ddb581$export$8410e492fb32a9b;
(function(CERTIFICATE_NAME_ABBREVIATION) {
    CERTIFICATE_NAME_ABBREVIATION["EXPERT_EMERITUS"] = "ACP-EE";
})($77d0522707ddb581$export$8410e492fb32a9b || ($77d0522707ddb581$export$8410e492fb32a9b = {}));
var $77d0522707ddb581$export$6e66959687be02fe;
(function(CERTIFICATE_STATUS) {
    CERTIFICATE_STATUS["ACTIVE"] = "ACTIVE";
    CERTIFICATE_STATUS["EXPIRED"] = "EXPIRED";
})($77d0522707ddb581$export$6e66959687be02fe || ($77d0522707ddb581$export$6e66959687be02fe = {}));
const $77d0522707ddb581$export$9ac4f3be5daa21fe = [
    (0, (/*@__PURE__*/$parcel$interopDefault($f37efaa995ee4197$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d6f94d8ef91e1f48$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($80f43fae5f2a7696$exports)))
];
const $77d0522707ddb581$export$820ae0844b3faa33 = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/gim;
const $77d0522707ddb581$export$5fa6e6390aee07dd = "/learning/hub/certifications";
const $77d0522707ddb581$export$9e4b135057b3ea75 = "/learning/catalog";
const $77d0522707ddb581$export$9b60d67f4e046ae5 = "/forums";
const $77d0522707ddb581$export$2e0ebf9d5f4bd3e9 = "/forums/Community-Kudos-Feedback/Welcome-to-the-Atlassian-Community-Kudos-program/ba-p/2148250";
var $77d0522707ddb581$export$d2cea8e85c08e64c;
(function(SCREEN_NAME) {
    SCREEN_NAME["PROFILE"] = "profileScreen";
    SCREEN_NAME["EDIT_PROFILE"] = "editProfileScreen";
    SCREEN_NAME["CERTIFICATIONS"] = "certificationsFullListScreen";
    SCREEN_NAME["GROUPS"] = "groupsFullListScreen";
    SCREEN_NAME["BADGES"] = "badgesFullListScreen";
    SCREEN_NAME["SETTINGS"] = "unifiedProfileSettingsScreen";
    SCREEN_NAME["ERROR"] = "unifiedProfileErrorScreen";
})($77d0522707ddb581$export$d2cea8e85c08e64c || ($77d0522707ddb581$export$d2cea8e85c08e64c = {}));
const $77d0522707ddb581$export$5762c0b139f625b2 = {
    LOADING: "loading",
    ERROR: "error",
    INITIALIZED: "initialized"
};
const $77d0522707ddb581$export$525244e58866b0c7 = "/forums/s/html/@1A61952945A0A4487EA6608283EECA5F/assets/img/group-meeples.png";


/**
 * NOTE: this return true even if the logged in user is a moderator
 * We should ideally have an effort to rename this as useIsPersonalOrModeratorView
 * and rename useIsProfilePersonalView to useIsPersonalView
 * @param internalId
 * @returns
 */ const $52d03cd4712fbe1d$var$useIsPersonalView = (internalId)=>{
    const unifiedProfile = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    })?.unified?.unifiedProfile;
    let profileFragmentData;
    if (unifiedProfile && "__fragments" in unifiedProfile) profileFragmentData = (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile);
    let isForumsModerator = false;
    if (profileFragmentData) {
        const loggedInUser = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5b4d113e3efb8585$export$75493bef044c2fa0), {}, {
            fetchPolicy: "store-or-network"
        })?.me?.user;
        const accountId = loggedInUser?.accountId || "";
        const account = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $69f7bb7bdecca370$export$d483224631a5893c), {
            aaid: accountId || ""
        }, {
            fetchPolicy: "store-or-network"
        })?.unified;
        isForumsModerator = account?.account?.isForumsModerator || false;
    }
    return profileFragmentData?.isPersonalView || profileFragmentData?.isLinkedView || isForumsModerator || false;
};
var $52d03cd4712fbe1d$export$2e2bcd8739ae039 = $52d03cd4712fbe1d$var$useIsPersonalView;




var $aFuPx = parcelRequire("aFuPx");
parcelRequire("acw62");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
parcelRequire("8ajhZ");
parcelRequire("8rteH");
parcelRequire("kKPGI");
var $115bf1020744eac3$export$ffb0004e005737fa = $7b02d682eb115277$exports.Fragment;
var $115bf1020744eac3$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $aFuPx.h).call(props, "css")) return $7b02d682eb115277$exports.jsx(type, props, key);
    return $7b02d682eb115277$exports.jsx((0, $aFuPx.E), (0, $aFuPx.c)(type, props), key);
};
var $115bf1020744eac3$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $aFuPx.h).call(props, "css")) return $7b02d682eb115277$exports.jsxs(type, props, key);
    return $7b02d682eb115277$exports.jsxs((0, $aFuPx.E), (0, $aFuPx.c)(type, props), key);
};




/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $3e67a9651f260bac$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $3e67a9651f260bac$export$2e2bcd8739ae039 = $3e67a9651f260bac$var$tokens;


var $fde93e88520bfffd$export$4ef52930e33717cd = "data-theme";
var $fde93e88520bfffd$export$a00eac3f8684bcd0 = "data-color-mode";
var $fde93e88520bfffd$export$2112803007239c61 = "data-contrast-mode";
var $fde93e88520bfffd$export$352e418ed5b6193a = "data-custom-theme";
var $fde93e88520bfffd$export$2faeed762aac6741 = "light";
var $fde93e88520bfffd$export$6f0c6fb8c80fcc92 = "ds";
var $fde93e88520bfffd$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $fde93e88520bfffd$export$dddac1532e822863 = "--".concat($fde93e88520bfffd$export$6f0c6fb8c80fcc92, "-token-not-found");
var $fde93e88520bfffd$export$9d7b58831ae93caa = "--".concat($fde93e88520bfffd$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $hPtJY = parcelRequire("hPtJY");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $bf65d4d6b5d64e28$var$token(path, fallback) {
    var token = (0, $3e67a9651f260bac$export$2e2bcd8739ae039)[path];
    typeof $hPtJY;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $fde93e88520bfffd$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $bf65d4d6b5d64e28$export$2e2bcd8739ae039 = $bf65d4d6b5d64e28$var$token;



var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/**
 * An empty function which does nothing.
 */ function $232d11f435326a2b$export$2e2bcd8739ae039() {}



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $43f123995fdafb2c$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $43f123995fdafb2c$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $acw62.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $acw62.useRef)(true);
    var committed = (0, $acw62.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $43f123995fdafb2c$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $acw62.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $43f123995fdafb2c$export$33752cf3ee811995(callback, inputs) {
    return $43f123995fdafb2c$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $43f123995fdafb2c$export$1538c33de8887b59 = $43f123995fdafb2c$export$b6feb8998cd9b342;
var $43f123995fdafb2c$export$35808ee640e87ca7 = $43f123995fdafb2c$export$33752cf3ee811995;



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $196b25e5a2e91a8b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $196b25e5a2e91a8b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $196b25e5a2e91a8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $196b25e5a2e91a8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $196b25e5a2e91a8b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $196b25e5a2e91a8b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $196b25e5a2e91a8b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $196b25e5a2e91a8b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $196b25e5a2e91a8b$var$_objectSpread($196b25e5a2e91a8b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $ac8edbf7bbacfadf$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $ac8edbf7bbacfadf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $ac8edbf7bbacfadf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ac8edbf7bbacfadf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ac8edbf7bbacfadf$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ac8edbf7bbacfadf$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ac8edbf7bbacfadf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $ac8edbf7bbacfadf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $ac8edbf7bbacfadf$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $ac8edbf7bbacfadf$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $196b25e5a2e91a8b$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e8d186b3b4aecb00$var$AnalyticsNextContext = (0, $acw62.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $e8d186b3b4aecb00$export$2e2bcd8739ae039 = $e8d186b3b4aecb00$var$AnalyticsNextContext;


var $ab98e1efd591debd$export$2e2bcd8739ae039 = (0, $e8d186b3b4aecb00$export$2e2bcd8739ae039);


var $035a277161eab92e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $f8837ccb4ede2bb3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $035a277161eab92e$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $ac8edbf7bbacfadf$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $f05a12a6f1ef1d1b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $8efc87d23c89e055$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8efc87d23c89e055$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8efc87d23c89e055$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8efc87d23c89e055$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8efc87d23c89e055$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $f8837ccb4ede2bb3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $f05a12a6f1ef1d1b$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $f05a12a6f1ef1d1b$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8efc87d23c89e055$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $acw62 = parcelRequire("acw62");
function $379a1b97918ecb31$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
var $a5f357526d15ef88$var$BORDER_WIDTH = 2;
var $a5f357526d15ef88$var$baseFocusOutsideStyles = (0, $gyDKM.css)({
    outline: "".concat($a5f357526d15ef88$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $a5f357526d15ef88$var$BORDER_WIDTH
});
var $a5f357526d15ef88$var$baseInsetStyles = (0, $gyDKM.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$a5f357526d15ef88$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $a5f357526d15ef88$var$focusRingStyles = (0, $gyDKM.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $a5f357526d15ef88$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $a5f357526d15ef88$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $a5f357526d15ef88$var$insetFocusRingStyles = (0, $gyDKM.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $a5f357526d15ef88$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $a5f357526d15ef88$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $a5f357526d15ef88$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $a5f357526d15ef88$var$baseInsetStyles : $a5f357526d15ef88$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $a5f357526d15ef88$var$insetFocusRingStyles : $a5f357526d15ef88$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $gyDKM.jsx)((0, $gyDKM.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$a5f357526d15ef88$var$FocusRing.displayName = "FocusRing";
var $a5f357526d15ef88$export$2e2bcd8739ae039 = $a5f357526d15ef88$var$FocusRing;



var $acw62 = parcelRequire("acw62");
var $7d8cdc11b4cca0f3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $21d5b5168c35b941$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $21d5b5168c35b941$var$tabKeyCode = 9;
function $21d5b5168c35b941$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $21d5b5168c35b941$var$tabKeyCode) return;
    $21d5b5168c35b941$var$abort(event);
}
var $21d5b5168c35b941$var$block = {
    onMouseDownCapture: $21d5b5168c35b941$var$abort,
    onMouseUpCapture: $21d5b5168c35b941$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $21d5b5168c35b941$var$onKey,
    onKeyUpCapture: $21d5b5168c35b941$var$onKey,
    onTouchStartCapture: $21d5b5168c35b941$var$abort,
    onTouchEndCapture: $21d5b5168c35b941$var$abort,
    onPointerDownCapture: $21d5b5168c35b941$var$abort,
    onPointerUpCapture: $21d5b5168c35b941$var$abort,
    onClickCapture: $21d5b5168c35b941$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $21d5b5168c35b941$var$abort
};
var $21d5b5168c35b941$var$doNotBlock = {};
function $21d5b5168c35b941$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $21d5b5168c35b941$var$doNotBlock : $21d5b5168c35b941$var$block;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");

var $ltooA = parcelRequire("ltooA");
function $8277fc3f1df11a73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8277fc3f1df11a73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8277fc3f1df11a73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8277fc3f1df11a73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8277fc3f1df11a73$var$gridSize = 8;
var $8277fc3f1df11a73$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $8277fc3f1df11a73$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $8277fc3f1df11a73$var$lineHeights = {
    default: $8277fc3f1df11a73$var$heights.default,
    compact: $8277fc3f1df11a73$var$heights.compact,
    none: "inherit"
};
var $8277fc3f1df11a73$var$padding = {
    // 10px gutter
    default: "0 ".concat($8277fc3f1df11a73$var$gridSize + $8277fc3f1df11a73$var$gridSize / 4, "px"),
    compact: "0 ".concat($8277fc3f1df11a73$var$gridSize + $8277fc3f1df11a73$var$gridSize / 4, "px"),
    none: "0"
};
var $8277fc3f1df11a73$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($8277fc3f1df11a73$var$gridSize / 4, "px"),
    default: "0 ".concat($8277fc3f1df11a73$var$gridSize / 4, "px"),
    none: "0"
};
var $8277fc3f1df11a73$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $8277fc3f1df11a73$var$innerMargin = {
    content: "0 ".concat($8277fc3f1df11a73$var$gridSize / 4, "px"),
    icon: "0 ".concat($8277fc3f1df11a73$var$gridSize / 4, "px")
};
var $8277fc3f1df11a73$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $8277fc3f1df11a73$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    "&::after": $8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread({}, $8277fc3f1df11a73$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:hover": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:active": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $8277fc3f1df11a73$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $8277fc3f1df11a73$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #1868DB)",
    "&:hover": {
        color: "var(--ds-link, #1868DB)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: "underline"
    }
};
var $8277fc3f1df11a73$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #505258)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $8277fc3f1df11a73$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #505258)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #292A2E)",
        textDecoration: "underline"
    }
};
var $8277fc3f1df11a73$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $8277fc3f1df11a73$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $8277fc3f1df11a73$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    "&:not([disabled])::after": $8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread({}, $8277fc3f1df11a73$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $8277fc3f1df11a73$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $8277fc3f1df11a73$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: (0, $ltooA.fg)("platform-dst-shape-theme-default") ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap",
        cursor: "pointer",
        height: $8277fc3f1df11a73$var$heights[spacing],
        lineHeight: $8277fc3f1df11a73$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $8277fc3f1df11a73$var$singleIconPadding[spacing] : $8277fc3f1df11a73$var$padding[spacing],
        verticalAlign: $8277fc3f1df11a73$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, isSelected ? $8277fc3f1df11a73$var$selectedStyles : $8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread($8277fc3f1df11a73$var$_objectSpread({}, appearance === "default" && $8277fc3f1df11a73$var$defaultStyles), appearance === "primary" && $8277fc3f1df11a73$var$primaryStyles), appearance === "link" && $8277fc3f1df11a73$var$linkStyles), appearance === "subtle" && $8277fc3f1df11a73$var$subtleStyles), appearance === "subtle-link" && $8277fc3f1df11a73$var$subtleLinkStyles), appearance === "warning" && $8277fc3f1df11a73$var$warningStyles), appearance === "danger" && $8277fc3f1df11a73$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $8277fc3f1df11a73$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $8277fc3f1df11a73$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : "transparent"
            },
            "&:active": {
                backgroundColor: $8277fc3f1df11a73$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : "transparent"
            }
        }
    }, $8277fc3f1df11a73$var$hasOverlayStyles)), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $8277fc3f1df11a73$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $gyDKM.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $8277fc3f1df11a73$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $8277fc3f1df11a73$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $8277fc3f1df11a73$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $8277fc3f1df11a73$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $8277fc3f1df11a73$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $acw62 = parcelRequire("acw62");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $693189a0be03d231$var$ATOMIC_GROUP_LENGTH = 5;
function $693189a0be03d231$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $693189a0be03d231$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $5d2c35c9b72bfde0$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $5d2c35c9b72bfde0$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $693189a0be03d231$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $5d2c35c9b72bfde0$export$2e2bcd8739ae039 = $5d2c35c9b72bfde0$var$VisuallyHidden;


var $77abaf64f1e36990$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $acw62.isValidElement)(children) && children.type === (0, $5d2c35c9b72bfde0$export$2e2bcd8739ae039);
};


var $ce7b8b89093fb6c6$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $ce7b8b89093fb6c6$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $ce7b8b89093fb6c6$var$iconBeforeSpacingFixStyle = (0, $gyDKM.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $ce7b8b89093fb6c6$var$iconAfterSpacingFixStyle = (0, $gyDKM.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $ce7b8b89093fb6c6$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $77abaf64f1e36990$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $ce7b8b89093fb6c6$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $77abaf64f1e36990$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $gyDKM.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $ce7b8b89093fb6c6$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $ce7b8b89093fb6c6$var$_excluded);
    var ourRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $379a1b97918ecb31$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $acw62.useContext)((0, $7d8cdc11b4cca0f3$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $8efc87d23c89e055$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.10.6",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $gyDKM.css)((0, $8277fc3f1df11a73$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $gyDKM.jsx)((0, $a5f357526d15ef88$export$2e2bcd8739ae039), null, (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $ce7b8b89093fb6c6$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $21d5b5168c35b941$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $gyDKM.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8277fc3f1df11a73$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $ce7b8b89093fb6c6$var$getSpacingFix(children, $ce7b8b89093fb6c6$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $ce7b8b89093fb6c6$var$getChildren(children, [
        fadeStyles,
        (0, $8277fc3f1df11a73$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $gyDKM.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8277fc3f1df11a73$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $ce7b8b89093fb6c6$var$getSpacingFix(children, $ce7b8b89093fb6c6$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $gyDKM.jsx)("span", {
        css: [
            (0, $8277fc3f1df11a73$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce7b8b89093fb6c6$export$2e2bcd8739ae039 = $ce7b8b89093fb6c6$var$ButtonBase;




function $69d3dfdf232985d4$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $77abaf64f1e36990$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $e33ac5fee2d2dbc4$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e33ac5fee2d2dbc4$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e33ac5fee2d2dbc4$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $e33ac5fee2d2dbc4$var$_excluded);
    var isOnlySingleIcon = (0, $69d3dfdf232985d4$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e33ac5fee2d2dbc4$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $acw62.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e33ac5fee2d2dbc4$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $acw62.useMemo)(function() {
        return (0, $8277fc3f1df11a73$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce7b8b89093fb6c6$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e33ac5fee2d2dbc4$var$Button.displayName = "Button";
var $e33ac5fee2d2dbc4$export$2e2bcd8739ae039 = $e33ac5fee2d2dbc4$var$Button;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bb8a5bae9841f60b$var$ATOMIC_GROUP_LENGTH = 5;
function $bb8a5bae9841f60b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $bb8a5bae9841f60b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $16fcece6f6fc3cd2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


// Reds
var $446b09fa41b75162$export$4b84fd0e2c617bd = "#FFEBE6";
var $446b09fa41b75162$export$b34b069eff244586 = "#FFBDAD";
var $446b09fa41b75162$export$be802dd0d8b57f35 = "#FF8F73";
var $446b09fa41b75162$export$60847d42f9da92a6 = "#FF7452";
var $446b09fa41b75162$export$4a7404f376229999 = "#FF5630";
var $446b09fa41b75162$export$2010d0fb4295b346 = "#DE350B";
var $446b09fa41b75162$export$2837b5a1a71d5c02 = "#BF2600";
var $446b09fa41b75162$export$8d9596b529bbb9cf = "#FFFAE6";
var $446b09fa41b75162$export$41060a744ab0b7ae = "#FFF0B3";
var $446b09fa41b75162$export$1cc05bbbf340e559 = "#FFE380";
var $446b09fa41b75162$export$5aae31392d72caaa = "#FFC400";
var $446b09fa41b75162$export$c6930421db9fa514 = "#FFAB00";
var $446b09fa41b75162$export$59619663aa6500fb = "#FF991F";
var $446b09fa41b75162$export$874739ea9e379ab6 = "#FF8B00";
var $446b09fa41b75162$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $446b09fa41b75162$export$69a3bf21b9686c2b = "#ABF5D1";
var $446b09fa41b75162$export$afbce1382ec95f73 = "#79F2C0";
var $446b09fa41b75162$export$747d86715d4175de = "#57D9A3";
var $446b09fa41b75162$export$940e1f69e873f202 = "#36B37E";
var $446b09fa41b75162$export$a49394138f7b8e85 = "#00875A";
var $446b09fa41b75162$export$6fa04827ac68a4fb = "#006644";
var $446b09fa41b75162$export$226de0355ed012f8 = "#DEEBFF";
var $446b09fa41b75162$export$8c13c2ee36917869 = "#B3D4FF";
var $446b09fa41b75162$export$ecfc1dff386a3e7a = "#4C9AFF";
var $446b09fa41b75162$export$215b7063051591f1 = "#2684FF";
var $446b09fa41b75162$export$e62e8919cca44969 = "#0065FF";
var $446b09fa41b75162$export$b3de0ae08da2ce64 = "#0052CC";
var $446b09fa41b75162$export$a6ee3d71bc067634 = "#0747A6";
var $446b09fa41b75162$export$67f15409e87642a1 = "#669DF1";
var $446b09fa41b75162$export$f0539dbc42dbb067 = "#8FB8F6";
var $446b09fa41b75162$export$363e4475840015bb = "#EAE6FF";
var $446b09fa41b75162$export$4b0a4417ed59760f = "#C0B6F2";
var $446b09fa41b75162$export$6011520a64d9a187 = "#998DD9";
var $446b09fa41b75162$export$a7175d4e9206bc80 = "#8777D9";
var $446b09fa41b75162$export$b48405b95304b5a1 = "#6554C0";
var $446b09fa41b75162$export$c71e4279dd54a18d = "#5243AA";
var $446b09fa41b75162$export$147899de772240ec = "#403294";
var $446b09fa41b75162$export$2cf711fe14c66f06 = "#E6FCFF";
var $446b09fa41b75162$export$7a8f4d33f6f9772c = "#B3F5FF";
var $446b09fa41b75162$export$776c9c497ef08533 = "#79E2F2";
var $446b09fa41b75162$export$69cb3ca10c1e330e = "#00C7E6";
var $446b09fa41b75162$export$9dc1ef0f3f48059b = "#00B8D9";
var $446b09fa41b75162$export$7c835c78b6fcdef8 = "#00A3BF";
var $446b09fa41b75162$export$6036577f95c3877e = "#008DA6";
var $446b09fa41b75162$export$29a4f05edc054374 = "#FFFFFF";
var $446b09fa41b75162$export$e655ef011c4aa1a2 = "#FAFBFC";
var $446b09fa41b75162$export$9fdfb749e33cdf97 = "#F4F5F7";
var $446b09fa41b75162$export$3e51e8f1440314ba = "#EBECF0";
var $446b09fa41b75162$export$1ce2d1575d444ceb = "#DFE1E6";
var $446b09fa41b75162$export$8754fc7e6d8b3000 = "#C1C7D0";
var $446b09fa41b75162$export$c2e91cbeada39b8b = "#B3BAC5";
var $446b09fa41b75162$export$5f71e19f3a7ad9de = "#A5ADBA";
var $446b09fa41b75162$export$eaa8c8a70ac22806 = "#97A0AF";
var $446b09fa41b75162$export$7c87d337fb91a97d = "#8993A4";
var $446b09fa41b75162$export$d6447c357493214f = "#7A869A";
var $446b09fa41b75162$export$f563ee71e9ee74cd = "#6B778C";
var $446b09fa41b75162$export$e2ef2124cf4024b1 = "#5E6C84";
var $446b09fa41b75162$export$eece5f492e429f08 = "#505F79";
var $446b09fa41b75162$export$c39c0fe0f26207ae = "#42526E";
var $446b09fa41b75162$export$7090862dc3038a9f = "#344563";
var $446b09fa41b75162$export$ad0bacf983b7ddaa = "#253858";
var $446b09fa41b75162$export$7d61b15e0da132af = "#172B4D";
var $446b09fa41b75162$export$fbda843f0a27fe96 = "#091E42";
var $446b09fa41b75162$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $446b09fa41b75162$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $446b09fa41b75162$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $446b09fa41b75162$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $446b09fa41b75162$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $446b09fa41b75162$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $446b09fa41b75162$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $446b09fa41b75162$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $446b09fa41b75162$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $446b09fa41b75162$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $446b09fa41b75162$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $446b09fa41b75162$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $446b09fa41b75162$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $446b09fa41b75162$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $446b09fa41b75162$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $446b09fa41b75162$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $446b09fa41b75162$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $446b09fa41b75162$export$2f6319cf7d736c2a = "#E6EDFA";
var $446b09fa41b75162$export$95126bc8884d6634 = "#DCE5F5";
var $446b09fa41b75162$export$8338d8c35d44ff1 = "#CED9EB";
var $446b09fa41b75162$export$5368d76ae4fbbda7 = "#B8C7E0";
var $446b09fa41b75162$export$9f0a771d16ec8d36 = "#ABBBD6";
var $446b09fa41b75162$export$abcf8c38338b4aa5 = "#9FB0CC";
var $446b09fa41b75162$export$97e81faa16a182c7 = "#8C9CB8";
var $446b09fa41b75162$export$bfe21c59123ecf33 = "#7988A3";
var $446b09fa41b75162$export$ee82aa2ea6a1558 = "#67758F";
var $446b09fa41b75162$export$682927c6ed76be02 = "#56637A";
var $446b09fa41b75162$export$91fd9994c5be9757 = "#455166";
var $446b09fa41b75162$export$d281fbfe3cff2df6 = "#3B475C";
var $446b09fa41b75162$export$3902c91d8b98a753 = "#313D52";
var $446b09fa41b75162$export$8e8133c1ba5845b5 = "#283447";
var $446b09fa41b75162$export$33ff357f6620b39 = "#202B3D";
var $446b09fa41b75162$export$633847cf062b69e0 = "#1B2638";
var $446b09fa41b75162$export$9776a6e503bdbf76 = "#121A29";
var $446b09fa41b75162$export$6c813d5160dff5db = "#0E1624";
var $446b09fa41b75162$export$3d4f271a500072a = "#0D1424";
var $446b09fa41b75162$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $446b09fa41b75162$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $446b09fa41b75162$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $446b09fa41b75162$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $446b09fa41b75162$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $446b09fa41b75162$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $446b09fa41b75162$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $446b09fa41b75162$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $446b09fa41b75162$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $446b09fa41b75162$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $446b09fa41b75162$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $446b09fa41b75162$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $446b09fa41b75162$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $446b09fa41b75162$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $446b09fa41b75162$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $446b09fa41b75162$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $446b09fa41b75162$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $446b09fa41b75162$export$d2adc5dedf09fced = "#292A2E";
var $446b09fa41b75162$export$f51762073d2bb381 = "#94C748";
var $446b09fa41b75162$export$95e26d54def96891 = "#B3DF72";


var $8d8748e14f838e21$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $c3a131b51868ea06$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $446b09fa41b75162$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $446b09fa41b75162$export$29a4f05edc054374), ")");
}
var $c3a131b51868ea06$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $c3a131b51868ea06$var$loadIn = null;
var $c3a131b51868ea06$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $c3a131b51868ea06$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $c3a131b51868ea06$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $8d8748e14f838e21$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $c3a131b51868ea06$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $16fcece6f6fc3cd2$export$2e2bcd8739ae039));
    $c3a131b51868ea06$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $bb8a5bae9841f60b$export$2e2bcd8739ae039)([
            $c3a131b51868ea06$var$styles.wrapperStyles,
            $c3a131b51868ea06$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $bb8a5bae9841f60b$export$2e2bcd8739ae039)([
            $c3a131b51868ea06$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $bb8a5bae9841f60b$export$2e2bcd8739ae039)([
            $c3a131b51868ea06$var$styles.circleStyles
        ])
    })));
}));
var $c3a131b51868ea06$export$2e2bcd8739ae039 = $c3a131b51868ea06$var$Spinner;


function $caa57cc4cbaa4d5c$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $caa57cc4cbaa4d5c$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c3a131b51868ea06$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $caa57cc4cbaa4d5c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


var $cdd250fb0ff30a4f$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $cdd250fb0ff30a4f$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $cdd250fb0ff30a4f$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e33ac5fee2d2dbc4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $caa57cc4cbaa4d5c$export$2e2bcd8739ae039), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$cdd250fb0ff30a4f$var$LoadingButton.displayName = "LoadingButton";
var $cdd250fb0ff30a4f$export$2e2bcd8739ae039 = $cdd250fb0ff30a4f$var$LoadingButton;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");
var $807d5a51f7285bd1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $f2a740e5e748f6a9$export$4b84fd0e2c617bd = "#FFEBE6";
var $f2a740e5e748f6a9$export$b34b069eff244586 = "#FFBDAD";
var $f2a740e5e748f6a9$export$be802dd0d8b57f35 = "#FF8F73";
var $f2a740e5e748f6a9$export$60847d42f9da92a6 = "#FF7452";
var $f2a740e5e748f6a9$export$4a7404f376229999 = "#FF5630";
var $f2a740e5e748f6a9$export$2010d0fb4295b346 = "#DE350B";
var $f2a740e5e748f6a9$export$2837b5a1a71d5c02 = "#BF2600";
var $f2a740e5e748f6a9$export$8d9596b529bbb9cf = "#FFFAE6";
var $f2a740e5e748f6a9$export$41060a744ab0b7ae = "#FFF0B3";
var $f2a740e5e748f6a9$export$1cc05bbbf340e559 = "#FFE380";
var $f2a740e5e748f6a9$export$5aae31392d72caaa = "#FFC400";
var $f2a740e5e748f6a9$export$c6930421db9fa514 = "#FFAB00";
var $f2a740e5e748f6a9$export$59619663aa6500fb = "#FF991F";
var $f2a740e5e748f6a9$export$874739ea9e379ab6 = "#FF8B00";
var $f2a740e5e748f6a9$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f2a740e5e748f6a9$export$69a3bf21b9686c2b = "#ABF5D1";
var $f2a740e5e748f6a9$export$afbce1382ec95f73 = "#79F2C0";
var $f2a740e5e748f6a9$export$747d86715d4175de = "#57D9A3";
var $f2a740e5e748f6a9$export$940e1f69e873f202 = "#36B37E";
var $f2a740e5e748f6a9$export$a49394138f7b8e85 = "#00875A";
var $f2a740e5e748f6a9$export$6fa04827ac68a4fb = "#006644";
var $f2a740e5e748f6a9$export$226de0355ed012f8 = "#DEEBFF";
var $f2a740e5e748f6a9$export$8c13c2ee36917869 = "#B3D4FF";
var $f2a740e5e748f6a9$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f2a740e5e748f6a9$export$215b7063051591f1 = "#2684FF";
var $f2a740e5e748f6a9$export$e62e8919cca44969 = "#0065FF";
var $f2a740e5e748f6a9$export$b3de0ae08da2ce64 = "#0052CC";
var $f2a740e5e748f6a9$export$a6ee3d71bc067634 = "#0747A6";
var $f2a740e5e748f6a9$export$67f15409e87642a1 = "#669DF1";
var $f2a740e5e748f6a9$export$f0539dbc42dbb067 = "#8FB8F6";
var $f2a740e5e748f6a9$export$363e4475840015bb = "#EAE6FF";
var $f2a740e5e748f6a9$export$4b0a4417ed59760f = "#C0B6F2";
var $f2a740e5e748f6a9$export$6011520a64d9a187 = "#998DD9";
var $f2a740e5e748f6a9$export$a7175d4e9206bc80 = "#8777D9";
var $f2a740e5e748f6a9$export$b48405b95304b5a1 = "#6554C0";
var $f2a740e5e748f6a9$export$c71e4279dd54a18d = "#5243AA";
var $f2a740e5e748f6a9$export$147899de772240ec = "#403294";
var $f2a740e5e748f6a9$export$2cf711fe14c66f06 = "#E6FCFF";
var $f2a740e5e748f6a9$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f2a740e5e748f6a9$export$776c9c497ef08533 = "#79E2F2";
var $f2a740e5e748f6a9$export$69cb3ca10c1e330e = "#00C7E6";
var $f2a740e5e748f6a9$export$9dc1ef0f3f48059b = "#00B8D9";
var $f2a740e5e748f6a9$export$7c835c78b6fcdef8 = "#00A3BF";
var $f2a740e5e748f6a9$export$6036577f95c3877e = "#008DA6";
var $f2a740e5e748f6a9$export$29a4f05edc054374 = "#FFFFFF";
var $f2a740e5e748f6a9$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f2a740e5e748f6a9$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f2a740e5e748f6a9$export$3e51e8f1440314ba = "#EBECF0";
var $f2a740e5e748f6a9$export$1ce2d1575d444ceb = "#DFE1E6";
var $f2a740e5e748f6a9$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f2a740e5e748f6a9$export$c2e91cbeada39b8b = "#B3BAC5";
var $f2a740e5e748f6a9$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f2a740e5e748f6a9$export$eaa8c8a70ac22806 = "#97A0AF";
var $f2a740e5e748f6a9$export$7c87d337fb91a97d = "#8993A4";
var $f2a740e5e748f6a9$export$d6447c357493214f = "#7A869A";
var $f2a740e5e748f6a9$export$f563ee71e9ee74cd = "#6B778C";
var $f2a740e5e748f6a9$export$e2ef2124cf4024b1 = "#5E6C84";
var $f2a740e5e748f6a9$export$eece5f492e429f08 = "#505F79";
var $f2a740e5e748f6a9$export$c39c0fe0f26207ae = "#42526E";
var $f2a740e5e748f6a9$export$7090862dc3038a9f = "#344563";
var $f2a740e5e748f6a9$export$ad0bacf983b7ddaa = "#253858";
var $f2a740e5e748f6a9$export$7d61b15e0da132af = "#172B4D";
var $f2a740e5e748f6a9$export$fbda843f0a27fe96 = "#091E42";
var $f2a740e5e748f6a9$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f2a740e5e748f6a9$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f2a740e5e748f6a9$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f2a740e5e748f6a9$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f2a740e5e748f6a9$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f2a740e5e748f6a9$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f2a740e5e748f6a9$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f2a740e5e748f6a9$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f2a740e5e748f6a9$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f2a740e5e748f6a9$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f2a740e5e748f6a9$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f2a740e5e748f6a9$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f2a740e5e748f6a9$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f2a740e5e748f6a9$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f2a740e5e748f6a9$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f2a740e5e748f6a9$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f2a740e5e748f6a9$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f2a740e5e748f6a9$export$2f6319cf7d736c2a = "#E6EDFA";
var $f2a740e5e748f6a9$export$95126bc8884d6634 = "#DCE5F5";
var $f2a740e5e748f6a9$export$8338d8c35d44ff1 = "#CED9EB";
var $f2a740e5e748f6a9$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f2a740e5e748f6a9$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f2a740e5e748f6a9$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f2a740e5e748f6a9$export$97e81faa16a182c7 = "#8C9CB8";
var $f2a740e5e748f6a9$export$bfe21c59123ecf33 = "#7988A3";
var $f2a740e5e748f6a9$export$ee82aa2ea6a1558 = "#67758F";
var $f2a740e5e748f6a9$export$682927c6ed76be02 = "#56637A";
var $f2a740e5e748f6a9$export$91fd9994c5be9757 = "#455166";
var $f2a740e5e748f6a9$export$d281fbfe3cff2df6 = "#3B475C";
var $f2a740e5e748f6a9$export$3902c91d8b98a753 = "#313D52";
var $f2a740e5e748f6a9$export$8e8133c1ba5845b5 = "#283447";
var $f2a740e5e748f6a9$export$33ff357f6620b39 = "#202B3D";
var $f2a740e5e748f6a9$export$633847cf062b69e0 = "#1B2638";
var $f2a740e5e748f6a9$export$9776a6e503bdbf76 = "#121A29";
var $f2a740e5e748f6a9$export$6c813d5160dff5db = "#0E1624";
var $f2a740e5e748f6a9$export$3d4f271a500072a = "#0D1424";
var $f2a740e5e748f6a9$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f2a740e5e748f6a9$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f2a740e5e748f6a9$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f2a740e5e748f6a9$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f2a740e5e748f6a9$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f2a740e5e748f6a9$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f2a740e5e748f6a9$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f2a740e5e748f6a9$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f2a740e5e748f6a9$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f2a740e5e748f6a9$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f2a740e5e748f6a9$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f2a740e5e748f6a9$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f2a740e5e748f6a9$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f2a740e5e748f6a9$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f2a740e5e748f6a9$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f2a740e5e748f6a9$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f2a740e5e748f6a9$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $f2a740e5e748f6a9$export$d2adc5dedf09fced = "#292A2E";
var $f2a740e5e748f6a9$export$f51762073d2bb381 = "#94C748";
var $f2a740e5e748f6a9$export$95e26d54def96891 = "#B3DF72";


var $3a66feba9b0ce05d$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $9b1489024cd32216$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $f2a740e5e748f6a9$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $f2a740e5e748f6a9$export$29a4f05edc054374), ")");
}
var $9b1489024cd32216$var$rotate = (0, $gyDKM.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $9b1489024cd32216$var$rotateStyles = (0, $gyDKM.css)({
    animation: "".concat($9b1489024cd32216$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $9b1489024cd32216$var$loadIn = (0, $gyDKM.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $9b1489024cd32216$var$loadInStyles = (0, $gyDKM.css)({
    animation: "".concat($9b1489024cd32216$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $9b1489024cd32216$var$wrapperStyles = (0, $gyDKM.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $9b1489024cd32216$var$circleStyles = (0, $gyDKM.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $9b1489024cd32216$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $9b1489024cd32216$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3a66feba9b0ce05d$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $9b1489024cd32216$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $807d5a51f7285bd1$export$2e2bcd8739ae039));
    $9b1489024cd32216$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $gyDKM.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $9b1489024cd32216$var$wrapperStyles,
            $9b1489024cd32216$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $gyDKM.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $9b1489024cd32216$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $gyDKM.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $9b1489024cd32216$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $9b1489024cd32216$export$2e2bcd8739ae039 = $9b1489024cd32216$var$Spinner;



var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $52b2fad205a5d537$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52b2fad205a5d537$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52b2fad205a5d537$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52b2fad205a5d537$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $52b2fad205a5d537$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $52b2fad205a5d537$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $52b2fad205a5d537$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $52b2fad205a5d537$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $52b2fad205a5d537$var$_objectSpread($52b2fad205a5d537$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $04c83b7367047be9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $04c83b7367047be9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $04c83b7367047be9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($04c83b7367047be9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $04c83b7367047be9$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $04c83b7367047be9$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $04c83b7367047be9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $04c83b7367047be9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $04c83b7367047be9$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $04c83b7367047be9$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $52b2fad205a5d537$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $b258582a9b957391$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $057e77267a03d346$export$5bf35293e545f20c() {
    var analyticsContext = (0, $b258582a9b957391$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $04c83b7367047be9$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $d5aa6de5124a6061$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $046d229107433a39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $046d229107433a39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $046d229107433a39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $046d229107433a39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $046d229107433a39$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $057e77267a03d346$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $d5aa6de5124a6061$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $d5aa6de5124a6061$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $046d229107433a39$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $31c935e069a5f50d$export$2e2bcd8739ae039() {}



var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Character key codes which can be used in keyboard events.
 */ var $0f4f27fc9e695f22$export$390330c10ff2b9a1 = "ArrowUp";
var $0f4f27fc9e695f22$export$a80636c6f41931fe = "ArrowDown";
var $0f4f27fc9e695f22$export$4af703091671bc = "Home";
var $0f4f27fc9e695f22$export$e2bc30913faa5db7 = "End";
var $0f4f27fc9e695f22$export$10f6869ed0a7d75b = "Tab";
var $0f4f27fc9e695f22$export$8152f929a25a0ff4 = "Enter";
var $0f4f27fc9e695f22$export$e51a3576c045c8d5 = "Space";
var $0f4f27fc9e695f22$export$2bb790b9008907b4 = "Escape";


function $e2ad3643fd54e635$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $0f4f27fc9e695f22$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}



var $acw62 = parcelRequire("acw62");
function $d5017b987887d270$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $c1f29423446d4d4f$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $80f1c206dd7a0bae$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $acw62.useContext)((0, $c1f29423446d4d4f$export$5fbf4d7fae6cdc00));
    (0, $acw62.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $48a1b61d4e0d12a8$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $48a1b61d4e0d12a8$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$48a1b61d4e0d12a8$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $48a1b61d4e0d12a8$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($48a1b61d4e0d12a8$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$48a1b61d4e0d12a8$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $48a1b61d4e0d12a8$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $48a1b61d4e0d12a8$export$ff7706047246b98b = function prefersReducedMotion() {
    return $48a1b61d4e0d12a8$export$f0f789643ba5a83c;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $1220421f7136fb1d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $1220421f7136fb1d$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($1220421f7136fb1d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $1220421f7136fb1d$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1220421f7136fb1d$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1220421f7136fb1d$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $1220421f7136fb1d$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $1220421f7136fb1d$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $1220421f7136fb1d$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $1220421f7136fb1d$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $1220421f7136fb1d$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $1220421f7136fb1d$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $48a1b61d4e0d12a8$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $1220421f7136fb1d$var$childrenToArray(previousChildren);
    var current = $1220421f7136fb1d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $1220421f7136fb1d$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $1220421f7136fb1d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $1220421f7136fb1d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $1220421f7136fb1d$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $1220421f7136fb1d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($1220421f7136fb1d$var$ExitingContext);
};
$1220421f7136fb1d$var$ExitingPersistence.displayName = "ExitingPersistence";
var $1220421f7136fb1d$export$2e2bcd8739ae039 = $1220421f7136fb1d$var$ExitingPersistence;


var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $078469d2c051ee79$export$368bacef0dacbe05 = 25;
var $078469d2c051ee79$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $078469d2c051ee79$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $078469d2c051ee79$export$30fa1a2e62ae150c = {
    none: $078469d2c051ee79$export$38b928a7167ce124.none,
    small: $078469d2c051ee79$export$38b928a7167ce124.small * $078469d2c051ee79$var$EXITING_MOTION_MULTIPLIER,
    medium: $078469d2c051ee79$export$38b928a7167ce124.medium * $078469d2c051ee79$var$EXITING_MOTION_MULTIPLIER,
    large: $078469d2c051ee79$export$38b928a7167ce124.large * $078469d2c051ee79$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
var $8dcea3ebad83947d$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $8dcea3ebad83947d$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8dcea3ebad83947d$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $8dcea3ebad83947d$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8dcea3ebad83947d$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $e6429f1ab1969ae5$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $56a46c8db7ed3346$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $deb25bb04bba2762$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $31c935e069a5f50d$export$2e2bcd8739ae039)
    };
});
var $deb25bb04bba2762$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $56a46c8db7ed3346$export$c485849f2e393253)();
    var context = (0, $acw62.useContext)($deb25bb04bba2762$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $deb25bb04bba2762$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $e6429f1ab1969ae5$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($deb25bb04bba2762$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $deb25bb04bba2762$export$2e2bcd8739ae039 = $deb25bb04bba2762$var$StaggeredEntrance;


function $bf958cc5923580fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bf958cc5923580fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bf958cc5923580fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bf958cc5923580fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $bf958cc5923580fb$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $deb25bb04bba2762$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $1220421f7136fb1d$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $8dcea3ebad83947d$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $078469d2c051ee79$export$30fa1a2e62ae150c)[duration] : (0, $078469d2c051ee79$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gyDKM.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? cx(css($bf958cc5923580fb$var$_objectSpread($bf958cc5923580fb$var$_objectSpread({}, (0, $48a1b61d4e0d12a8$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationFillMode: "backwards",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $gyDKM.keyframes)(enteringAnimation),
                animationPlayState: "running"
            })), paused && css({
                animationPlayState: "paused"
            }), duration === "small" && css({
                animationDuration: "100ms"
            }), duration === "medium" && css({
                animationDuration: "350ms"
            }), duration === "large" && css({
                animationDuration: "700ms"
            }), isExiting && duration === "small" && css({
                animationDuration: "50ms"
            }), isExiting && duration === "medium" && css({
                animationDuration: "175ms"
            }), isExiting && duration === "large" && css({
                animationDuration: "350ms"
            }), isExiting && css({
                animationDelay: "0ms",
                animationFillMode: "forwards",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $gyDKM.keyframes)(exitingAnimation)
            }), !isExiting && animationTimingFunction === "linear" && css({
                animationTimingFunction: "cubic-bezier(0,0,1,1)"
            }), !isExiting && animationTimingFunction === "ease-out" && css({
                animationTimingFunction: "cubic-bezier(0.2,0,0,1)"
            }), !isExiting && animationTimingFunction === "ease-in" && css({
                animationTimingFunction: "cubic-bezier(0.8,0,0,0.8)"
            }), !isExiting && animationTimingFunction === "ease-in-out" && css({
                animationTimingFunction: "cubic-bezier(0.15,1,0.3,1)"
            }), isExiting && animationTimingFunction === "linear" && css({
                animationTimingFunction: "cubic-bezier(0,0,1,1)"
            }), isExiting && animationTimingFunctionExiting === "ease-out" && css({
                animationTimingFunction: "cubic-bezier(0.2,0,0,1)"
            }), isExiting && animationTimingFunctionExiting === "ease-in" && css({
                animationTimingFunction: "cubic-bezier(0.8,0,0,0.8)"
            }), isExiting && animationTimingFunctionExiting === "ease-in-out" && css({
                animationTimingFunction: "cubic-bezier(0.15,1,0.3,1)"
            })) : ""
        }, state);
    });
};
var $bf958cc5923580fb$export$2e2bcd8739ae039 = $bf958cc5923580fb$var$EnteringMotion;


function $6a5b2fdc0c2eb98b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a5b2fdc0c2eb98b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a5b2fdc0c2eb98b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a5b2fdc0c2eb98b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6a5b2fdc0c2eb98b$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $6a5b2fdc0c2eb98b$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $6a5b2fdc0c2eb98b$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $6a5b2fdc0c2eb98b$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $6a5b2fdc0c2eb98b$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $6a5b2fdc0c2eb98b$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $6a5b2fdc0c2eb98b$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $6a5b2fdc0c2eb98b$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $6a5b2fdc0c2eb98b$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $6a5b2fdc0c2eb98b$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bf958cc5923580fb$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $6a5b2fdc0c2eb98b$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $6a5b2fdc0c2eb98b$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $6a5b2fdc0c2eb98b$export$2e2bcd8739ae039 = $6a5b2fdc0c2eb98b$var$FadeIn;



var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $98419a3199f36288$export$3dbd3405086fec7b = $acw62.createContext();
var $98419a3199f36288$export$cbabb21c2529b130 = $acw62.createContext();
function $98419a3199f36288$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($98419a3199f36288$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($98419a3199f36288$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}



var $acw62 = parcelRequire("acw62");
var $7db6b4218872c548$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $7db6b4218872c548$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $7db6b4218872c548$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $7db6b4218872c548$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $7db6b4218872c548$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $7db6b4218872c548$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $a1f341ee92ae2898$var$EMPTY_MODIFIERS = [];
var $a1f341ee92ae2898$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $a1f341ee92ae2898$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $7db6b4218872c548$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $7db6b4218872c548$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $7db6b4218872c548$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $7db6b4218872c548$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $e4fec27400925987$var$NOOP = function NOOP() {
    return void 0;
};
var $e4fec27400925987$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $e4fec27400925987$var$EMPTY_MODIFIERS = [];
function $e4fec27400925987$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $e4fec27400925987$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $98419a3199f36288$export$3dbd3405086fec7b));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $7db6b4218872c548$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $a1f341ee92ae2898$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $e4fec27400925987$var$NOOP,
            update: update || $e4fec27400925987$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $7db6b4218872c548$export$f52c55943429c8b6)(children)(childrenProps);
}



var $02Ztr = parcelRequire("02Ztr");
function $1efc8ab813469615$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $1bbaa1cd5b6a8066$var$viewportPadding = 5;
var $1bbaa1cd5b6a8066$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $1bbaa1cd5b6a8066$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $1bbaa1cd5b6a8066$var$defaultChildrenFn() {
    return null;
}
var $1bbaa1cd5b6a8066$var$defaultOffset = [
    0,
    8
];
function $1bbaa1cd5b6a8066$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $1bbaa1cd5b6a8066$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $1bbaa1cd5b6a8066$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $1bbaa1cd5b6a8066$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $1efc8ab813469615$export$6d8c2b45c99d6e3f)({
            viewportPadding: $1bbaa1cd5b6a8066$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($1bbaa1cd5b6a8066$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4fec27400925987$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $8e55814a9e13c77d$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $8e55814a9e13c77d$export$72f415121273627e = "body > .atlaskit-portal-container";
var $8e55814a9e13c77d$export$13f57c02915787b3 = "atlaskit-portal";


var $3bfa6b1f29f9e6f3$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $8e55814a9e13c77d$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $3bfa6b1f29f9e6f3$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $3bfa6b1f29f9e6f3$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $8e55814a9e13c77d$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $8e55814a9e13c77d$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $3bfa6b1f29f9e6f3$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $3bfa6b1f29f9e6f3$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $3bfa6b1f29f9e6f3$var$getPortalParent().removeChild(container);
};
var $3bfa6b1f29f9e6f3$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $3bfa6b1f29f9e6f3$var$getPortalParent().appendChild(container);
};
var $3bfa6b1f29f9e6f3$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $3bfa6b1f29f9e6f3$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($3bfa6b1f29f9e6f3$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $8e55814a9e13c77d$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $3bfa6b1f29f9e6f3$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($3bfa6b1f29f9e6f3$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $8e55814a9e13c77d$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $8e55814a9e13c77d$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $3bfa6b1f29f9e6f3$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $b409fe16fdfbe828$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $3bfa6b1f29f9e6f3$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $3bfa6b1f29f9e6f3$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $3bfa6b1f29f9e6f3$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $f543254ac7dc91e8$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $3da6766cbf95b9d3$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $f543254ac7dc91e8$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $3bfa6b1f29f9e6f3$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $3bfa6b1f29f9e6f3$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $ltooA.fg)("platform_design_system_suspend_portal_children") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $9690d660040867f3$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $f543254ac7dc91e8$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $9690d660040867f3$export$2e2bcd8739ae039 = $9690d660040867f3$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $b39ce9eaa12874ee$export$ed5835cc67e87f72 = "akPortalMount";
var $b39ce9eaa12874ee$export$80816bd900e5bd00 = "akPortalUnmount";


var $813aca2aa168a4de$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $813aca2aa168a4de$var$getLayerName = function getLayerName(zIndex) {
    return $813aca2aa168a4de$var$zIndexToName.hasOwnProperty(zIndex) ? $813aca2aa168a4de$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $813aca2aa168a4de$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $813aca2aa168a4de$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $813aca2aa168a4de$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $813aca2aa168a4de$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $1b38ffe0889745df$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $813aca2aa168a4de$export$2e2bcd8739ae039)((0, $b39ce9eaa12874ee$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $813aca2aa168a4de$export$2e2bcd8739ae039)((0, $b39ce9eaa12874ee$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $1b38ffe0889745df$export$2e2bcd8739ae039 = $1b38ffe0889745df$var$useFirePortalEvent;


function $213447f138ad6556$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $9690d660040867f3$export$2e2bcd8739ae039)(mountStrategy);
    (0, $1b38ffe0889745df$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b409fe16fdfbe828$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3da6766cbf95b9d3$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $917002c923d7e8ec$var$printed = {};
function $917002c923d7e8ec$export$2e2bcd8739ae039(message) {
    if ($917002c923d7e8ec$var$printed[message]) return;
    $917002c923d7e8ec$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $77effb549d58a3d3$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $917002c923d7e8ec$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $77effb549d58a3d3$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4abd5946709ddc57$export$4b84fd0e2c617bd = "#FFEBE6";
var $4abd5946709ddc57$export$b34b069eff244586 = "#FFBDAD";
var $4abd5946709ddc57$export$be802dd0d8b57f35 = "#FF8F73";
var $4abd5946709ddc57$export$60847d42f9da92a6 = "#FF7452";
var $4abd5946709ddc57$export$4a7404f376229999 = "#FF5630";
var $4abd5946709ddc57$export$2010d0fb4295b346 = "#DE350B";
var $4abd5946709ddc57$export$2837b5a1a71d5c02 = "#BF2600";
var $4abd5946709ddc57$export$8d9596b529bbb9cf = "#FFFAE6";
var $4abd5946709ddc57$export$41060a744ab0b7ae = "#FFF0B3";
var $4abd5946709ddc57$export$1cc05bbbf340e559 = "#FFE380";
var $4abd5946709ddc57$export$5aae31392d72caaa = "#FFC400";
var $4abd5946709ddc57$export$c6930421db9fa514 = "#FFAB00";
var $4abd5946709ddc57$export$59619663aa6500fb = "#FF991F";
var $4abd5946709ddc57$export$874739ea9e379ab6 = "#FF8B00";
var $4abd5946709ddc57$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4abd5946709ddc57$export$69a3bf21b9686c2b = "#ABF5D1";
var $4abd5946709ddc57$export$afbce1382ec95f73 = "#79F2C0";
var $4abd5946709ddc57$export$747d86715d4175de = "#57D9A3";
var $4abd5946709ddc57$export$940e1f69e873f202 = "#36B37E";
var $4abd5946709ddc57$export$a49394138f7b8e85 = "#00875A";
var $4abd5946709ddc57$export$6fa04827ac68a4fb = "#006644";
var $4abd5946709ddc57$export$226de0355ed012f8 = "#DEEBFF";
var $4abd5946709ddc57$export$8c13c2ee36917869 = "#B3D4FF";
var $4abd5946709ddc57$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4abd5946709ddc57$export$215b7063051591f1 = "#2684FF";
var $4abd5946709ddc57$export$e62e8919cca44969 = "#0065FF";
var $4abd5946709ddc57$export$b3de0ae08da2ce64 = "#0052CC";
var $4abd5946709ddc57$export$a6ee3d71bc067634 = "#0747A6";
var $4abd5946709ddc57$export$67f15409e87642a1 = "#669DF1";
var $4abd5946709ddc57$export$f0539dbc42dbb067 = "#8FB8F6";
var $4abd5946709ddc57$export$363e4475840015bb = "#EAE6FF";
var $4abd5946709ddc57$export$4b0a4417ed59760f = "#C0B6F2";
var $4abd5946709ddc57$export$6011520a64d9a187 = "#998DD9";
var $4abd5946709ddc57$export$a7175d4e9206bc80 = "#8777D9";
var $4abd5946709ddc57$export$b48405b95304b5a1 = "#6554C0";
var $4abd5946709ddc57$export$c71e4279dd54a18d = "#5243AA";
var $4abd5946709ddc57$export$147899de772240ec = "#403294";
var $4abd5946709ddc57$export$2cf711fe14c66f06 = "#E6FCFF";
var $4abd5946709ddc57$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4abd5946709ddc57$export$776c9c497ef08533 = "#79E2F2";
var $4abd5946709ddc57$export$69cb3ca10c1e330e = "#00C7E6";
var $4abd5946709ddc57$export$9dc1ef0f3f48059b = "#00B8D9";
var $4abd5946709ddc57$export$7c835c78b6fcdef8 = "#00A3BF";
var $4abd5946709ddc57$export$6036577f95c3877e = "#008DA6";
var $4abd5946709ddc57$export$29a4f05edc054374 = "#FFFFFF";
var $4abd5946709ddc57$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4abd5946709ddc57$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4abd5946709ddc57$export$3e51e8f1440314ba = "#EBECF0";
var $4abd5946709ddc57$export$1ce2d1575d444ceb = "#DFE1E6";
var $4abd5946709ddc57$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4abd5946709ddc57$export$c2e91cbeada39b8b = "#B3BAC5";
var $4abd5946709ddc57$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4abd5946709ddc57$export$eaa8c8a70ac22806 = "#97A0AF";
var $4abd5946709ddc57$export$7c87d337fb91a97d = "#8993A4";
var $4abd5946709ddc57$export$d6447c357493214f = "#7A869A";
var $4abd5946709ddc57$export$f563ee71e9ee74cd = "#6B778C";
var $4abd5946709ddc57$export$e2ef2124cf4024b1 = "#5E6C84";
var $4abd5946709ddc57$export$eece5f492e429f08 = "#505F79";
var $4abd5946709ddc57$export$c39c0fe0f26207ae = "#42526E";
var $4abd5946709ddc57$export$7090862dc3038a9f = "#344563";
var $4abd5946709ddc57$export$ad0bacf983b7ddaa = "#253858";
var $4abd5946709ddc57$export$7d61b15e0da132af = "#172B4D";
var $4abd5946709ddc57$export$fbda843f0a27fe96 = "#091E42";
var $4abd5946709ddc57$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4abd5946709ddc57$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4abd5946709ddc57$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4abd5946709ddc57$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4abd5946709ddc57$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4abd5946709ddc57$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4abd5946709ddc57$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4abd5946709ddc57$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4abd5946709ddc57$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4abd5946709ddc57$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4abd5946709ddc57$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4abd5946709ddc57$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4abd5946709ddc57$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4abd5946709ddc57$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4abd5946709ddc57$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4abd5946709ddc57$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4abd5946709ddc57$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4abd5946709ddc57$export$2f6319cf7d736c2a = "#E6EDFA";
var $4abd5946709ddc57$export$95126bc8884d6634 = "#DCE5F5";
var $4abd5946709ddc57$export$8338d8c35d44ff1 = "#CED9EB";
var $4abd5946709ddc57$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4abd5946709ddc57$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4abd5946709ddc57$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4abd5946709ddc57$export$97e81faa16a182c7 = "#8C9CB8";
var $4abd5946709ddc57$export$bfe21c59123ecf33 = "#7988A3";
var $4abd5946709ddc57$export$ee82aa2ea6a1558 = "#67758F";
var $4abd5946709ddc57$export$682927c6ed76be02 = "#56637A";
var $4abd5946709ddc57$export$91fd9994c5be9757 = "#455166";
var $4abd5946709ddc57$export$d281fbfe3cff2df6 = "#3B475C";
var $4abd5946709ddc57$export$3902c91d8b98a753 = "#313D52";
var $4abd5946709ddc57$export$8e8133c1ba5845b5 = "#283447";
var $4abd5946709ddc57$export$33ff357f6620b39 = "#202B3D";
var $4abd5946709ddc57$export$633847cf062b69e0 = "#1B2638";
var $4abd5946709ddc57$export$9776a6e503bdbf76 = "#121A29";
var $4abd5946709ddc57$export$6c813d5160dff5db = "#0E1624";
var $4abd5946709ddc57$export$3d4f271a500072a = "#0D1424";
var $4abd5946709ddc57$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4abd5946709ddc57$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4abd5946709ddc57$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4abd5946709ddc57$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4abd5946709ddc57$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4abd5946709ddc57$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4abd5946709ddc57$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4abd5946709ddc57$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4abd5946709ddc57$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4abd5946709ddc57$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4abd5946709ddc57$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4abd5946709ddc57$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4abd5946709ddc57$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4abd5946709ddc57$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4abd5946709ddc57$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4abd5946709ddc57$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4abd5946709ddc57$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4abd5946709ddc57$export$d2adc5dedf09fced = "#292A2E";
var $4abd5946709ddc57$export$f51762073d2bb381 = "#94C748";
var $4abd5946709ddc57$export$95e26d54def96891 = "#B3DF72";


var $efdb7b2e43571369$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $efdb7b2e43571369$export$c93026a968943f95 = "light";
var $efdb7b2e43571369$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $efdb7b2e43571369$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $efdb7b2e43571369$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $efdb7b2e43571369$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $4abd5946709ddc57$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $efdb7b2e43571369$export$6d8204c2cb2e06b8() / 4;
    (0, $77effb549d58a3d3$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $efdb7b2e43571369$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $efdb7b2e43571369$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $efdb7b2e43571369$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $77effb549d58a3d3$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $efdb7b2e43571369$export$ba1d834b86d72a09 = $efdb7b2e43571369$export$a1b3edb637fb4f35;
var $efdb7b2e43571369$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $4abd5946709ddc57$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $4abd5946709ddc57$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $4abd5946709ddc57$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $8fY35 = parcelRequire("8fY35");
var $8be8d89cf472041d$var$registrations = new Set();
var $8be8d89cf472041d$var$cleanupEndEventListeners = null;
function $8be8d89cf472041d$var$onDragStart() {
    if ($8be8d89cf472041d$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $8be8d89cf472041d$var$cleanupEndEventListeners = (0, $8fY35.bindAll)(window, [
        {
            type: "dragend",
            listener: $8be8d89cf472041d$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $8be8d89cf472041d$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $8be8d89cf472041d$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($8be8d89cf472041d$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $8be8d89cf472041d$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $8be8d89cf472041d$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $8be8d89cf472041d$var$cleanupEndEventListeners = null;
    var clone = Array.from($8be8d89cf472041d$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $8be8d89cf472041d$var$bindStartEvents() {
    return (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: $8be8d89cf472041d$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $8be8d89cf472041d$var$onDragStart
        }
    ]);
}
var $8be8d89cf472041d$var$cleanupStartEventListeners = null;
function $8be8d89cf472041d$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$8be8d89cf472041d$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $8be8d89cf472041d$var$cleanupStartEventListeners = $8be8d89cf472041d$var$bindStartEvents();
    $8be8d89cf472041d$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $8be8d89cf472041d$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $8be8d89cf472041d$var$registrations.delete(registration);
        if ($8be8d89cf472041d$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $8be8d89cf472041d$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $8be8d89cf472041d$var$cleanupStartEventListeners = null;
        }
    };
}


var $2651f6352a25192e$var$delayId = null;
function $2651f6352a25192e$export$eaf678f6f93f5250() {
    if ($2651f6352a25192e$var$delayId != null) {
        window.clearTimeout($2651f6352a25192e$var$delayId);
        $2651f6352a25192e$var$delayId = null;
    }
}
function $2651f6352a25192e$export$5f4d6617421d489b(fn, delay) {
    $2651f6352a25192e$export$eaf678f6f93f5250();
    $2651f6352a25192e$var$delayId = window.setTimeout(function() {
        $2651f6352a25192e$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $e9253ae3818e798f$var$active = null;
function $e9253ae3818e798f$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($e9253ae3818e798f$var$active && $e9253ae3818e798f$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $2651f6352a25192e$export$eaf678f6f93f5250)();
            $e9253ae3818e798f$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $2651f6352a25192e$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $2651f6352a25192e$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $2651f6352a25192e$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($e9253ae3818e798f$var$active && $e9253ae3818e798f$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($e9253ae3818e798f$var$active) {
            (0, $2651f6352a25192e$export$eaf678f6f93f5250)();
            $e9253ae3818e798f$var$active.entry.hide({
                isImmediate: true
            });
            $e9253ae3818e798f$var$active.entry.done();
            $e9253ae3818e798f$var$active = null;
        }
        // this tooltip is now the active tooltip
        $e9253ae3818e798f$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $2651f6352a25192e$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $d96a26d6bced380d$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $d96a26d6bced380d$export$e2a22331486dcca0 = $d96a26d6bced380d$export$bdbb4cbb3078e58d();


var $ef8175a645d11fd8$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $d96a26d6bced380d$export$bdbb4cbb3078e58d)()
    };
};
var $ef8175a645d11fd8$export$e575061ef2a070eb = $ef8175a645d11fd8$export$1921362e86c73c88();
var $ef8175a645d11fd8$export$b4d5da5f34fb77ad = $acw62.createContext($ef8175a645d11fd8$export$1921362e86c73c88());
var $ef8175a645d11fd8$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $ef8175a645d11fd8$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};


var $e0ee72d35d886c5b$var$generateUID = function(context) {
    var quartz = context || (0, $ef8175a645d11fd8$export$e575061ef2a070eb);
    var prefix = (0, $ef8175a645d11fd8$export$36e24695f02d4503)(quartz);
    var id = (0, $ef8175a645d11fd8$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $e0ee72d35d886c5b$var$useUIDState = function() {
    var context = (0, $acw62.useContext)((0, $ef8175a645d11fd8$export$b4d5da5f34fb77ad));
    var uid = (0, $acw62.useState)(function() {
        return $e0ee72d35d886c5b$var$generateUID(context);
    })[0];
    return uid;
};
var $e0ee72d35d886c5b$export$87d05f07e65211f1 = function() {
    var uid = $e0ee72d35d886c5b$var$useUIDState().uid;
    return uid;
};
var $e0ee72d35d886c5b$export$bb5ca5fba6fb4f1f = function() {
    var gen = $e0ee72d35d886c5b$var$useUIDState().gen;
    return gen;
};



var $ltooA = parcelRequire("ltooA");
var $c88069181bc83ba8$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c88069181bc83ba8$var$react18UseId = ($c88069181bc83ba8$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $c88069181bc83ba8$var$_React$useId !== void 0 ? $c88069181bc83ba8$var$_React$useId : undefined;
function $c88069181bc83ba8$export$f680877a34711e37() {
    if ($c88069181bc83ba8$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $c88069181bc83ba8$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $e0ee72d35d886c5b$export$87d05f07e65211f1)());
}
var $c88069181bc83ba8$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($c88069181bc83ba8$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $c88069181bc83ba8$export$6ee17796e3d70de2() {
    if ($c88069181bc83ba8$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $c88069181bc83ba8$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $e0ee72d35d886c5b$export$bb5ca5fba6fb4f1f)();
}


function $044394bbb7343ff6$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $c88069181bc83ba8$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $593c55d1b5df349d$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}




var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

function $bd02ee4f3519f525$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bd02ee4f3519f525$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bd02ee4f3519f525$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bd02ee4f3519f525$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bd02ee4f3519f525$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $bd02ee4f3519f525$var$primitiveStyles = (0, $gyDKM.css)({
    zindex: "var(".concat($bd02ee4f3519f525$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $bd02ee4f3519f525$var$TooltipPrimitive = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $bd02ee4f3519f525$var$_objectSpread($bd02ee4f3519f525$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $bd02ee4f3519f525$var$VAR_PRIMITIVE_ZINDEX, (0, $efdb7b2e43571369$export$7be255094ccdc533).tooltip()));
    return (0, $gyDKM.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $gyDKM.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $bd02ee4f3519f525$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$bd02ee4f3519f525$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $bd02ee4f3519f525$export$2e2bcd8739ae039 = $bd02ee4f3519f525$var$TooltipPrimitive;


function $e9ed0acd366dee13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e9ed0acd366dee13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e9ed0acd366dee13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e9ed0acd366dee13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e9ed0acd366dee13$var$baseStyles = null;
var $e9ed0acd366dee13$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $e9ed0acd366dee13$var$TooltipContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement((0, $bd02ee4f3519f525$export$2e2bcd8739ae039), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $luEYg.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $e9ed0acd366dee13$var$_objectSpread($e9ed0acd366dee13$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $593c55d1b5df349d$export$2e2bcd8739ae039)("var(--ds-background-neutral-bold, ".concat((0, $4abd5946709ddc57$export$7d61b15e0da132af), ")")),
            "--_ywovvi": (0, $593c55d1b5df349d$export$2e2bcd8739ae039)("var(--ds-text-inverse, ".concat((0, $4abd5946709ddc57$export$29a4f05edc054374), ")"))
        })
    }, children);
});
$e9ed0acd366dee13$var$TooltipContainer.displayName = "TooltipContainer";
var $e9ed0acd366dee13$export$2e2bcd8739ae039 = $e9ed0acd366dee13$var$TooltipContainer;


function $ded0f310296affa8$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $3bb76fb59b0ba000$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bb76fb59b0ba000$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bb76fb59b0ba000$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bb76fb59b0ba000$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3bb76fb59b0ba000$var$tooltipZIndex = (0, $efdb7b2e43571369$export$7be255094ccdc533).tooltip();
var $3bb76fb59b0ba000$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.2.0"
};
// Inverts motion direction
var $3bb76fb59b0ba000$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $3bb76fb59b0ba000$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $3bb76fb59b0ba000$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $e9ed0acd366dee13$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $31c935e069a5f50d$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $31c935e069a5f50d$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $046d229107433a39$export$1a04351537078b55)($3bb76fb59b0ba000$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $3bb76fb59b0ba000$var$analyticsAttributes));
    var onHideHandler = (0, $046d229107433a39$export$1a04351537078b55)($3bb76fb59b0ba000$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $3bb76fb59b0ba000$var$analyticsAttributes));
    var apiRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $acw62.useRef)(null);
    var containerRef = (0, $acw62.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $acw62.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $d5017b987887d270$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $d5017b987887d270$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $d5017b987887d270$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $d5017b987887d270$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $d5017b987887d270$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $acw62.useRef)(false);
    var start = (0, $acw62.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $acw62.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        return (0, $8be8d89cf472041d$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $acw62.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $e9253ae3818e798f$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $acw62.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $e2ad3643fd54e635$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $acw62.useEffect)(function() {
        if (state === "hide") return 0, $31c935e069a5f50d$export$2e2bcd8739ae039;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $ded0f310296affa8$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $ded0f310296affa8$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $acw62.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $acw62.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $acw62.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $acw62.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    (0, $80f1c206dd7a0bae$export$469bb693f11edc7f)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $044394bbb7343ff6$export$2e2bcd8739ae039)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $acw62.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children($3bb76fb59b0ba000$var$_objectSpread($3bb76fb59b0ba000$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $213447f138ad6556$export$2e2bcd8739ae039), {
        zIndex: $3bb76fb59b0ba000$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bbaa1cd5b6a8066$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $3bb76fb59b0ba000$var$invertedDirection[$3bb76fb59b0ba000$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1220421f7136fb1d$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a5b2fdc0c2eb98b$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $3bb76fb59b0ba000$var$_objectSpread($3bb76fb59b0ba000$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$3bb76fb59b0ba000$var$Tooltip.displayName = "Tooltip";
var $3bb76fb59b0ba000$export$2e2bcd8739ae039 = $3bb76fb59b0ba000$var$Tooltip;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");

function $805d07e7a42f76ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $805d07e7a42f76ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $805d07e7a42f76ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $805d07e7a42f76ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $805d07e7a42f76ed$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $805d07e7a42f76ed$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $805d07e7a42f76ed$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $805d07e7a42f76ed$export$632685d741f3dbbf = $805d07e7a42f76ed$var$_objectSpread($805d07e7a42f76ed$var$_objectSpread({}, $805d07e7a42f76ed$export$958d0ae7f2977ae4), $805d07e7a42f76ed$export$d2dc61f58390201c);
var $805d07e7a42f76ed$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $805d07e7a42f76ed$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $805d07e7a42f76ed$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $805d07e7a42f76ed$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $805d07e7a42f76ed$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $805d07e7a42f76ed$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $805d07e7a42f76ed$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $805d07e7a42f76ed$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $805d07e7a42f76ed$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $805d07e7a42f76ed$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $805d07e7a42f76ed$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $805d07e7a42f76ed$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $805d07e7a42f76ed$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $805d07e7a42f76ed$export$3c7e9587132614b4 = {
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $805d07e7a42f76ed$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $805d07e7a42f76ed$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $805d07e7a42f76ed$export$e615f061ca585a6c = $805d07e7a42f76ed$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $805d07e7a42f76ed$var$getSerializedStylesMap(spacingProperty, $805d07e7a42f76ed$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $805d07e7a42f76ed$export$bf46c3f9eeafc71f = $805d07e7a42f76ed$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $805d07e7a42f76ed$var$getSerializedStylesMap(spacingProperty, $805d07e7a42f76ed$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $805d07e7a42f76ed$export$e7af83bafe7f9e63 = $805d07e7a42f76ed$var$getSerializedStylesMap("backgroundColor", $805d07e7a42f76ed$export$d1d79bf68ac056bd);
var $805d07e7a42f76ed$export$3a1bcba60b23d7f0 = $805d07e7a42f76ed$var$getSerializedStylesMap("color", $805d07e7a42f76ed$export$8473307aa00d6ea1);
var $805d07e7a42f76ed$export$45f3f4fe16f9f7d5 = $805d07e7a42f76ed$var$getSerializedStylesMap("fontWeight", $805d07e7a42f76ed$export$303e322c6b1ed114);
var $805d07e7a42f76ed$export$68cc305da27dbaa4 = $805d07e7a42f76ed$var$getSerializedStylesMap("fontFamily", $805d07e7a42f76ed$export$3c7e9587132614b4);
var $805d07e7a42f76ed$export$128f10c238242f83 = $805d07e7a42f76ed$var$getSerializedStylesMap("font", $805d07e7a42f76ed$export$6cc560b4dedf3816);
var $805d07e7a42f76ed$export$ff257d957d48c421 = $805d07e7a42f76ed$var$getSerializedStylesMap((0, $fde93e88520bfffd$export$9d7b58831ae93caa), $805d07e7a42f76ed$export$41a358c9c2356760);
var $805d07e7a42f76ed$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $805d07e7a42f76ed$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $gyDKM = parcelRequire("gyDKM");


var $hPtJY = parcelRequire("hPtJY");
function $d841ac2d6aa8bd23$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d841ac2d6aa8bd23$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d841ac2d6aa8bd23$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d841ac2d6aa8bd23$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d841ac2d6aa8bd23$var$_arrayLikeToArray(o, minLen);
}
function $d841ac2d6aa8bd23$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d841ac2d6aa8bd23$export$9a199fbafee0014e = {
    backgroundColor: (0, $805d07e7a42f76ed$export$d1d79bf68ac056bd),
    blockSize: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderBottomColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderLeftColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $805d07e7a42f76ed$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    borderWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    bottom: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    boxShadow: (0, $805d07e7a42f76ed$export$7aff6e7ba39bb774),
    color: (0, $805d07e7a42f76ed$export$8473307aa00d6ea1),
    columnGap: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    gap: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    height: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    inlineSize: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    inset: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    insetBlock: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    insetBlockEnd: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    insetBlockStart: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    insetInline: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    insetInlineEnd: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    insetInlineStart: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    left: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    margin: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginBlock: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginBlockEnd: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginBlockStart: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginBottom: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginInline: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginInlineEnd: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginInlineStart: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginLeft: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginRight: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    marginTop: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    maxBlockSize: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    maxHeight: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    maxWidth: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    minBlockSize: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    minHeight: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    minInlineSize: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    minWidth: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    opacity: (0, $805d07e7a42f76ed$export$daf94a976c798b4f),
    outlineColor: (0, $805d07e7a42f76ed$export$1531ad5bb3fbedac),
    outlineOffset: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    outlineWidth: (0, $805d07e7a42f76ed$export$e1b83c5210c471b8),
    padding: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingBlock: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingBottom: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingInline: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingLeft: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingRight: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    paddingTop: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    right: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    rowGap: (0, $805d07e7a42f76ed$export$958d0ae7f2977ae4),
    top: (0, $805d07e7a42f76ed$export$632685d741f3dbbf),
    width: (0, $805d07e7a42f76ed$export$6ccdbebca2ee545f),
    zIndex: (0, $805d07e7a42f76ed$export$b5f31a7e431d2eab)
};
var $d841ac2d6aa8bd23$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $d841ac2d6aa8bd23$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $d841ac2d6aa8bd23$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $d841ac2d6aa8bd23$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $d841ac2d6aa8bd23$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $d841ac2d6aa8bd23$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($d841ac2d6aa8bd23$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($d841ac2d6aa8bd23$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $d841ac2d6aa8bd23$export$9a199fbafee0014e)) return;
        var tokenValue = $d841ac2d6aa8bd23$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $d841ac2d6aa8bd23$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $d841ac2d6aa8bd23$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $d841ac2d6aa8bd23$var$uniqueSymbol, (0, $gyDKM.css)(transformedStyles));
};
var $d841ac2d6aa8bd23$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $d841ac2d6aa8bd23$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$d841ac2d6aa8bd23$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $d841ac2d6aa8bd23$export$f6c783d06584602c(style) {
    return $d841ac2d6aa8bd23$var$baseXcss(style);
}



var $acw62 = parcelRequire("acw62");
var $b2e858debb96a909$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $b2e858debb96a909$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($b2e858debb96a909$export$1ca2a26fecb070ae);
};
$b2e858debb96a909$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $c8593d66a3359792$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $c8593d66a3359792$var$_excluded2 = [
    "className"
];
var $c8593d66a3359792$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c8593d66a3359792$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $c8593d66a3359792$var$_excluded2);
    var resolvedStyles = (0, $d841ac2d6aa8bd23$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $c8593d66a3359792$var$baseStyles,
            backgroundColor && (0, $805d07e7a42f76ed$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $805d07e7a42f76ed$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $805d07e7a42f76ed$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $805d07e7a42f76ed$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $gyDKM.jsx)((0, $b2e858debb96a909$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $c8593d66a3359792$export$2e2bcd8739ae039 = $c8593d66a3359792$export$e71c4d32a2263218;
var $c8593d66a3359792$var$baseStyles = (0, $gyDKM.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

/** @jsx jsx */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $a9b577755822a7ff$var$justifyContentMap = {
    start: (0, $gyDKM.css)({
        justifyContent: "start"
    }),
    center: (0, $gyDKM.css)({
        justifyContent: "center"
    }),
    end: (0, $gyDKM.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $gyDKM.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $gyDKM.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $gyDKM.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $gyDKM.css)({
        justifyContent: "stretch"
    })
};
var $a9b577755822a7ff$var$flexDirectionMap = {
    column: (0, $gyDKM.css)({
        flexDirection: "column"
    }),
    row: (0, $gyDKM.css)({
        flexDirection: "row"
    })
};
var $a9b577755822a7ff$var$flexWrapMap = {
    wrap: (0, $gyDKM.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $gyDKM.css)({
        flexWrap: "nowrap"
    })
};
var $a9b577755822a7ff$var$alignItemsMap = {
    start: (0, $gyDKM.css)({
        alignItems: "start"
    }),
    center: (0, $gyDKM.css)({
        alignItems: "center"
    }),
    baseline: (0, $gyDKM.css)({
        alignItems: "baseline"
    }),
    end: (0, $gyDKM.css)({
        alignItems: "end"
    }),
    stretch: (0, $gyDKM.css)({
        alignItems: "stretch"
    })
};
var $a9b577755822a7ff$var$baseStyles = (0, $gyDKM.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $a9b577755822a7ff$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $d841ac2d6aa8bd23$export$a9c84988c8f81f2d)(xcss);
    return (0, $gyDKM.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $a9b577755822a7ff$var$baseStyles,
            gap && (0, $805d07e7a42f76ed$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $805d07e7a42f76ed$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $805d07e7a42f76ed$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $a9b577755822a7ff$var$alignItemsMap[alignItems],
            direction && $a9b577755822a7ff$var$flexDirectionMap[direction],
            justifyContent && $a9b577755822a7ff$var$justifyContentMap[justifyContent],
            wrap && $a9b577755822a7ff$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$a9b577755822a7ff$var$Flex.displayName = "Flex";
var $a9b577755822a7ff$export$2e2bcd8739ae039 = $a9b577755822a7ff$var$Flex;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $608d3c177085052d$var$flexGrowMap = {
    hug: (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $608d3c177085052d$var$separatorStyles = (0, $gyDKM.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $608d3c177085052d$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $gyDKM.jsx)("span", {
        css: $608d3c177085052d$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $608d3c177085052d$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $gyDKM.jsx)($608d3c177085052d$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $gyDKM.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $608d3c177085052d$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $gyDKM.jsx)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$608d3c177085052d$var$Inline.displayName = "Inline";
var $608d3c177085052d$export$2e2bcd8739ae039 = $608d3c177085052d$var$Inline;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $32b227fa3e7b874c$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 109.99rem)",
        xl: "@media (min-width: 110rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110rem)"
    }
};
var $32b227fa3e7b874c$export$c881183ca713c214 = $32b227fa3e7b874c$export$987d49ffe1b0900f;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $0f650ff017b0ad3b$var$flexGrowMap = {
    hug: (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $0f650ff017b0ad3b$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $0f650ff017b0ad3b$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $gyDKM.jsx)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0f650ff017b0ad3b$var$Stack.displayName = "Stack";
var $0f650ff017b0ad3b$export$2e2bcd8739ae039 = $0f650ff017b0ad3b$var$Stack;

/** @jsx jsx */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $bv4qN = parcelRequire("bv4qN");


var $5a2aa3720e25ccad$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $5a2aa3720e25ccad$var$resetStyles = (0, $gyDKM.css)({
    margin: 0
});
var $5a2aa3720e25ccad$var$strongStyles = (0, $gyDKM.css)({
    fontWeight: "bold"
});
var $5a2aa3720e25ccad$var$emStyles = (0, $gyDKM.css)({
    fontStyle: "italic"
});
var $5a2aa3720e25ccad$var$textAlignMap = {
    center: (0, $gyDKM.css)({
        textAlign: "center"
    }),
    end: (0, $gyDKM.css)({
        textAlign: "end"
    }),
    start: (0, $gyDKM.css)({
        textAlign: "start"
    })
};
var $5a2aa3720e25ccad$var$truncationStyles = (0, $gyDKM.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $5a2aa3720e25ccad$var$wordBreakMap = {
    breakAll: (0, $gyDKM.css)({
        wordBreak: "break-all"
    })
};
var $5a2aa3720e25ccad$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $5a2aa3720e25ccad$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $acw62.useContext)($5a2aa3720e25ccad$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5a2aa3720e25ccad$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $b2e858debb96a909$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $805d07e7a42f76ed$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $805d07e7a42f76ed$export$2185ce37f9bdd963)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $5a2aa3720e25ccad$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $bv4qN.default)($5a2aa3720e25ccad$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $5a2aa3720e25ccad$var$useHasTextAncestor();
    var color = $5a2aa3720e25ccad$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $gyDKM.jsx)(Component, {
        ref: ref,
        css: [
            $5a2aa3720e25ccad$var$resetStyles,
            (0, $805d07e7a42f76ed$export$128f10c238242f83)[size],
            color && (0, $805d07e7a42f76ed$export$3a1bcba60b23d7f0)[color],
            maxLines && $5a2aa3720e25ccad$var$truncationStyles,
            maxLines === 1 && $5a2aa3720e25ccad$var$wordBreakMap.breakAll,
            align && $5a2aa3720e25ccad$var$textAlignMap[align],
            weight && (0, $805d07e7a42f76ed$export$45f3f4fe16f9f7d5)[weight],
            Component === "em" && $5a2aa3720e25ccad$var$emStyles,
            Component === "strong" && $5a2aa3720e25ccad$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $gyDKM.jsx)($5a2aa3720e25ccad$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $5a2aa3720e25ccad$export$2e2bcd8739ae039 = $5a2aa3720e25ccad$var$Text;


var $224bcf757434c5a8$exports = {};
"use strict";
Object.defineProperty($224bcf757434c5a8$exports, "__esModule", {
    value: true
});
$224bcf757434c5a8$exports.default = void 0;

var $224bcf757434c5a8$var$_react = $224bcf757434c5a8$var$_interopRequireDefault((parcelRequire("acw62")));

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $fai5X = parcelRequire("fai5X");

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
var $1528f4e43ddfe203$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $1528f4e43ddfe203$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $1528f4e43ddfe203$export$62ad7b0c781000e9 = {
    small: {
        width: $1528f4e43ddfe203$export$c647cb0ee6e282fe.small,
        height: $1528f4e43ddfe203$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $1528f4e43ddfe203$export$c647cb0ee6e282fe.medium,
        height: $1528f4e43ddfe203$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $1528f4e43ddfe203$export$c647cb0ee6e282fe.large,
        height: $1528f4e43ddfe203$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $1528f4e43ddfe203$export$c647cb0ee6e282fe.xlarge,
        height: $1528f4e43ddfe203$export$c647cb0ee6e282fe.xlarge
    }
};



var $gyDKM = parcelRequire("gyDKM");
var $94a826109a371e2a$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $94a826109a371e2a$var$smallStyles = (0, $gyDKM.css)((0, $1528f4e43ddfe203$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $94a826109a371e2a$var$mediumStyles = (0, $gyDKM.css)((0, $1528f4e43ddfe203$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $94a826109a371e2a$var$largeStyles = (0, $gyDKM.css)((0, $1528f4e43ddfe203$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $94a826109a371e2a$var$xlargeStyles = (0, $gyDKM.css)((0, $1528f4e43ddfe203$export$62ad7b0c781000e9).xlarge);
var $94a826109a371e2a$export$ef0ad74202575b64 = {
    small: $94a826109a371e2a$var$smallStyles,
    medium: $94a826109a371e2a$var$mediumStyles,
    large: $94a826109a371e2a$var$largeStyles,
    xlarge: $94a826109a371e2a$var$xlargeStyles
};
var $94a826109a371e2a$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $1528f4e43ddfe203$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $8dd9d1c37c2c4e02$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $5dd70c89973ce2ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5dd70c89973ce2ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5dd70c89973ce2ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5dd70c89973ce2ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $5dd70c89973ce2ec$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $5dd70c89973ce2ec$var$_objectSpread($5dd70c89973ce2ec$var$_objectSpread({}, (0, $94a826109a371e2a$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $5dd70c89973ce2ec$var$baseHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $5dd70c89973ce2ec$var$primaryEqualsSecondaryHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $5dd70c89973ce2ec$var$secondaryTransparentHcmStyles = (0, $gyDKM.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $5dd70c89973ce2ec$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $gyDKM.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $94a826109a371e2a$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $gyDKM.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $8dd9d1c37c2c4e02$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $5dd70c89973ce2ec$var$iconStyles,
            $5dd70c89973ce2ec$var$baseHcmStyles,
            primaryColor === secondaryColor && $5dd70c89973ce2ec$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $5dd70c89973ce2ec$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gyDKM.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $5dd70c89973ce2ec$export$2e2bcd8739ae039 = $5dd70c89973ce2ec$export$f04a61298a47a40f;


var $649746fe359eec05$var$_excluded = [
    "dangerouslySetGlyph"
];
var $649746fe359eec05$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $649746fe359eec05$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $649746fe359eec05$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $fai5X.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $fai5X.fg)("platform-visual-refresh-icons-facade-button-fix") ? $649746fe359eec05$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $649746fe359eec05$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5dd70c89973ce2ec$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $649746fe359eec05$export$2e2bcd8739ae039 = $649746fe359eec05$export$3cfb73f70dfca966;



var $224bcf757434c5a8$var$_close = $224bcf757434c5a8$var$_interopRequireDefault((parcelRequire("j8Gpr")));
function $224bcf757434c5a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $224bcf757434c5a8$var$CrossIcon = (props)=>/*#__PURE__*/ $224bcf757434c5a8$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $224bcf757434c5a8$var$_close.default
    }));
$224bcf757434c5a8$var$CrossIcon.displayName = "CrossIcon";
var $224bcf757434c5a8$var$_default = $224bcf757434c5a8$exports.default = $224bcf757434c5a8$var$CrossIcon;



var $krRSk = parcelRequire("krRSk");
var $426c9189270b2d6d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9e42f0bd2701e924d060f406b40f887>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($426c9189270b2d6d$exports, "__esModule", {
    value: true
});
$426c9189270b2d6d$exports.default = void 0;

var $426c9189270b2d6d$var$_react = $426c9189270b2d6d$var$_interopRequireDefault((parcelRequire("acw62")));

var $426c9189270b2d6d$var$_UNSAFE_baseNew = $426c9189270b2d6d$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $426c9189270b2d6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $426c9189270b2d6d$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $426c9189270b2d6d$var$_react.default.createElement($426c9189270b2d6d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$426c9189270b2d6d$var$AtlassianIntelligenceIcon.displayName = "AtlassianIntelligenceIcon";
var $426c9189270b2d6d$var$_default = $426c9189270b2d6d$exports.default = $426c9189270b2d6d$var$AtlassianIntelligenceIcon;


var $890220d08eb7ec6c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($890220d08eb7ec6c$exports, "__esModule", {
    value: true
});
$890220d08eb7ec6c$exports.default = void 0;

var $890220d08eb7ec6c$var$_react = $890220d08eb7ec6c$var$_interopRequireDefault((parcelRequire("acw62")));

var $890220d08eb7ec6c$var$_UNSAFE_baseNew = $890220d08eb7ec6c$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $890220d08eb7ec6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $890220d08eb7ec6c$var$CalendarIcon = (props)=>/*#__PURE__*/ $890220d08eb7ec6c$var$_react.default.createElement($890220d08eb7ec6c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$890220d08eb7ec6c$var$CalendarIcon.displayName = "CalendarIcon";
var $890220d08eb7ec6c$var$_default = $890220d08eb7ec6c$exports.default = $890220d08eb7ec6c$var$CalendarIcon;


var $51fb804910f454f9$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($51fb804910f454f9$exports, "__esModule", {
    value: true
});
$51fb804910f454f9$exports.default = void 0;

var $51fb804910f454f9$var$_react = $51fb804910f454f9$var$_interopRequireDefault((parcelRequire("acw62")));

var $51fb804910f454f9$var$_UNSAFE_baseNew = $51fb804910f454f9$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $51fb804910f454f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51fb804910f454f9$var$CompassIcon = (props)=>/*#__PURE__*/ $51fb804910f454f9$var$_react.default.createElement($51fb804910f454f9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$51fb804910f454f9$var$CompassIcon.displayName = "CompassIcon";
var $51fb804910f454f9$var$_default = $51fb804910f454f9$exports.default = $51fb804910f454f9$var$CompassIcon;



var $bZH1Z = parcelRequire("bZH1Z");
var $63c1aeb1eeb3ba19$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79997d69990d173364910f60504b3516>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($63c1aeb1eeb3ba19$exports, "__esModule", {
    value: true
});
$63c1aeb1eeb3ba19$exports.default = void 0;

var $63c1aeb1eeb3ba19$var$_react = $63c1aeb1eeb3ba19$var$_interopRequireDefault((parcelRequire("acw62")));

var $63c1aeb1eeb3ba19$var$_UNSAFE_baseNew = $63c1aeb1eeb3ba19$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $63c1aeb1eeb3ba19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63c1aeb1eeb3ba19$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $63c1aeb1eeb3ba19$var$_react.default.createElement($63c1aeb1eeb3ba19$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
    }, props));
$63c1aeb1eeb3ba19$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $63c1aeb1eeb3ba19$var$_default = $63c1aeb1eeb3ba19$exports.default = $63c1aeb1eeb3ba19$var$LinkExternalIcon;



var $9dzbE = parcelRequire("9dzbE");
var $513b793ef4407bd4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($513b793ef4407bd4$exports, "__esModule", {
    value: true
});
$513b793ef4407bd4$exports.default = void 0;

var $513b793ef4407bd4$var$_react = $513b793ef4407bd4$var$_interopRequireDefault((parcelRequire("acw62")));

var $513b793ef4407bd4$var$_UNSAFE_baseNew = $513b793ef4407bd4$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $513b793ef4407bd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $513b793ef4407bd4$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $513b793ef4407bd4$var$_react.default.createElement($513b793ef4407bd4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$513b793ef4407bd4$var$MegaphoneIcon.displayName = "MegaphoneIcon";
var $513b793ef4407bd4$var$_default = $513b793ef4407bd4$exports.default = $513b793ef4407bd4$var$MegaphoneIcon;


var $e29d94b3c318ce90$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c2c434ab24649808044e93163bd51c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e29d94b3c318ce90$exports, "__esModule", {
    value: true
});
$e29d94b3c318ce90$exports.default = void 0;

var $e29d94b3c318ce90$var$_react = $e29d94b3c318ce90$var$_interopRequireDefault((parcelRequire("acw62")));

var $e29d94b3c318ce90$var$_UNSAFE_baseNew = $e29d94b3c318ce90$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $e29d94b3c318ce90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e29d94b3c318ce90$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $e29d94b3c318ce90$var$_react.default.createElement($e29d94b3c318ce90$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$e29d94b3c318ce90$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $e29d94b3c318ce90$var$_default = $e29d94b3c318ce90$exports.default = $e29d94b3c318ce90$var$PeopleGroupIcon;


var $81fcfa6180844492$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42f87835acc0152c23ae77c3bbeeba86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($81fcfa6180844492$exports, "__esModule", {
    value: true
});
$81fcfa6180844492$exports.default = void 0;

var $81fcfa6180844492$var$_react = $81fcfa6180844492$var$_interopRequireDefault((parcelRequire("acw62")));

var $81fcfa6180844492$var$_UNSAFE_baseNew = $81fcfa6180844492$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $81fcfa6180844492$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81fcfa6180844492$var$PersonIcon = (props)=>/*#__PURE__*/ $81fcfa6180844492$var$_react.default.createElement($81fcfa6180844492$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$81fcfa6180844492$var$PersonIcon.displayName = "PersonIcon";
var $81fcfa6180844492$var$_default = $81fcfa6180844492$exports.default = $81fcfa6180844492$var$PersonIcon;


var $3dce87e94efb0a99$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b1290bc5816db04bbec0542a218c285>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($3dce87e94efb0a99$exports, "__esModule", {
    value: true
});
$3dce87e94efb0a99$exports.default = void 0;

var $3dce87e94efb0a99$var$_react = $3dce87e94efb0a99$var$_interopRequireDefault((parcelRequire("acw62")));

var $3dce87e94efb0a99$var$_UNSAFE_baseNew = $3dce87e94efb0a99$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $3dce87e94efb0a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3dce87e94efb0a99$var$ProjectIcon = (props)=>/*#__PURE__*/ $3dce87e94efb0a99$var$_react.default.createElement($3dce87e94efb0a99$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
    }, props));
$3dce87e94efb0a99$var$ProjectIcon.displayName = "ProjectIcon";
var $3dce87e94efb0a99$var$_default = $3dce87e94efb0a99$exports.default = $3dce87e94efb0a99$var$ProjectIcon;


var $5ec528592db494f6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21cc5e8a48fa1ff0264c5abb7df80aa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5ec528592db494f6$exports, "__esModule", {
    value: true
});
$5ec528592db494f6$exports.default = void 0;

var $5ec528592db494f6$var$_react = $5ec528592db494f6$var$_interopRequireDefault((parcelRequire("acw62")));

var $5ec528592db494f6$var$_UNSAFE_baseNew = $5ec528592db494f6$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $5ec528592db494f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ec528592db494f6$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $5ec528592db494f6$var$_react.default.createElement($5ec528592db494f6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 1.75H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h2.75m0-12.5H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4.75m0-12.5v12.5M11 5.5 8.5 8l2.5 2.5"/>`
    }, props));
$5ec528592db494f6$var$SidebarCollapseIcon.displayName = "SidebarCollapseIcon";
var $5ec528592db494f6$var$_default = $5ec528592db494f6$exports.default = $5ec528592db494f6$var$SidebarCollapseIcon;


var $28a5d0ad0984536c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67bd8e50f260741b99439472e94111fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($28a5d0ad0984536c$exports, "__esModule", {
    value: true
});
$28a5d0ad0984536c$exports.default = void 0;

var $28a5d0ad0984536c$var$_react = $28a5d0ad0984536c$var$_interopRequireDefault((parcelRequire("acw62")));

var $28a5d0ad0984536c$var$_UNSAFE_baseNew = $28a5d0ad0984536c$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $28a5d0ad0984536c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28a5d0ad0984536c$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $28a5d0ad0984536c$var$_react.default.createElement($28a5d0ad0984536c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 1.75H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-2.75m0-12.5H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h9.25m0-12.5v12.5M5 5.5 7.5 8 5 10.5"/>`
    }, props));
$28a5d0ad0984536c$var$SidebarExpandIcon.displayName = "SidebarExpandIcon";
var $28a5d0ad0984536c$var$_default = $28a5d0ad0984536c$exports.default = $28a5d0ad0984536c$var$SidebarExpandIcon;


var $bcaa313d5a1a98e5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4906a52ca50c71ce3e4b4da49e7ade3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($bcaa313d5a1a98e5$exports, "__esModule", {
    value: true
});
$bcaa313d5a1a98e5$exports.default = void 0;

var $bcaa313d5a1a98e5$var$_react = $bcaa313d5a1a98e5$var$_interopRequireDefault((parcelRequire("acw62")));

var $bcaa313d5a1a98e5$var$_UNSAFE_baseNew = $bcaa313d5a1a98e5$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $bcaa313d5a1a98e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bcaa313d5a1a98e5$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $bcaa313d5a1a98e5$var$_react.default.createElement($bcaa313d5a1a98e5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.993 9.24c-1.586.69-3.176 2.118-3.176 4.234 0 1.057-4.202 1.586-2.086-3.702-1.058.475-4.98 1.747-4.98-.897 0-3.173-.25-6.346 3.98-6.346 2.453 0 4.06 0 6.036 1.267m0 0A1.25 1.25 0 0 1 12 2.75h2c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25V4q0-.105.017-.204Z"/>`
    }, props));
$bcaa313d5a1a98e5$var$ThumbsDownIcon.displayName = "ThumbsDownIcon";
var $bcaa313d5a1a98e5$var$_default = $bcaa313d5a1a98e5$exports.default = $bcaa313d5a1a98e5$var$ThumbsDownIcon;


var $93c6bdb4ac81baf8$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6198fed855ec7c0bf831f638e93e94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($93c6bdb4ac81baf8$exports, "__esModule", {
    value: true
});
$93c6bdb4ac81baf8$exports.default = void 0;

var $93c6bdb4ac81baf8$var$_react = $93c6bdb4ac81baf8$var$_interopRequireDefault((parcelRequire("acw62")));

var $93c6bdb4ac81baf8$var$_UNSAFE_baseNew = $93c6bdb4ac81baf8$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $93c6bdb4ac81baf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93c6bdb4ac81baf8$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $93c6bdb4ac81baf8$var$_react.default.createElement($93c6bdb4ac81baf8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.007 6.76c1.586-.69 3.176-2.117 3.176-4.233 0-1.057 4.202-1.586 2.086 3.702 1.058-.475 4.981-1.747 4.981.897 0 3.173-.25 6.346-4.48 6.346-2.454 0-3.561 0-5.537-1.267m0 0A1.25 1.25 0 0 1 4 13.251H2c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v4.5q0 .105-.017.204Z"/>`
    }, props));
$93c6bdb4ac81baf8$var$ThumbsUpIcon.displayName = "ThumbsUpIcon";
var $93c6bdb4ac81baf8$var$_default = $93c6bdb4ac81baf8$exports.default = $93c6bdb4ac81baf8$var$ThumbsUpIcon;


var $f5fec3964c81954d$exports = {};
"use strict";
Object.defineProperty($f5fec3964c81954d$exports, "__esModule", {
    value: true
});
$f5fec3964c81954d$exports.default = void 0;

var $f5fec3964c81954d$var$_react = $f5fec3964c81954d$var$_interopRequireDefault((parcelRequire("acw62")));


var $f5fec3964c81954d$var$_add = $f5fec3964c81954d$var$_interopRequireDefault((parcelRequire("4eiSD")));
function $f5fec3964c81954d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5fec3964c81954d$var$AddIcon = (props)=>/*#__PURE__*/ $f5fec3964c81954d$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $f5fec3964c81954d$var$_add.default
    }));
$f5fec3964c81954d$var$AddIcon.displayName = "AddIcon";
var $f5fec3964c81954d$var$_default = $f5fec3964c81954d$exports.default = $f5fec3964c81954d$var$AddIcon;


var $03edd2aa4dfebbd8$exports = {};
"use strict";
Object.defineProperty($03edd2aa4dfebbd8$exports, "__esModule", {
    value: true
});
$03edd2aa4dfebbd8$exports.default = void 0;

var $03edd2aa4dfebbd8$var$_react = $03edd2aa4dfebbd8$var$_interopRequireDefault((parcelRequire("acw62")));


var $03edd2aa4dfebbd8$var$_add = $03edd2aa4dfebbd8$var$_interopRequireDefault((parcelRequire("4eiSD")));
function $03edd2aa4dfebbd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $03edd2aa4dfebbd8$var$AddCircleIcon = (props)=>/*#__PURE__*/ $03edd2aa4dfebbd8$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $03edd2aa4dfebbd8$var$_add.default
    }));
$03edd2aa4dfebbd8$var$AddCircleIcon.displayName = "AddCircleIcon";
var $03edd2aa4dfebbd8$var$_default = $03edd2aa4dfebbd8$exports.default = $03edd2aa4dfebbd8$var$AddCircleIcon;


var $32cd67b0704c3d15$exports = {};
"use strict";
Object.defineProperty($32cd67b0704c3d15$exports, "__esModule", {
    value: true
});
$32cd67b0704c3d15$exports.default = void 0;

var $32cd67b0704c3d15$var$_react = $32cd67b0704c3d15$var$_interopRequireDefault((parcelRequire("acw62")));


var $32cd67b0704c3d15$var$_arrowLeft = $32cd67b0704c3d15$var$_interopRequireDefault((parcelRequire("krsZn")));
function $32cd67b0704c3d15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32cd67b0704c3d15$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $32cd67b0704c3d15$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $32cd67b0704c3d15$var$_arrowLeft.default
    }));
$32cd67b0704c3d15$var$ArrowLeftCircleIcon.displayName = "ArrowLeftCircleIcon";
var $32cd67b0704c3d15$var$_default = $32cd67b0704c3d15$exports.default = $32cd67b0704c3d15$var$ArrowLeftCircleIcon;


var $1a4d84fbcc800603$exports = {};
"use strict";
Object.defineProperty($1a4d84fbcc800603$exports, "__esModule", {
    value: true
});
$1a4d84fbcc800603$exports.default = void 0;

var $1a4d84fbcc800603$var$_react = $1a4d84fbcc800603$var$_interopRequireDefault((parcelRequire("acw62")));


var $1a4d84fbcc800603$var$_arrowRight = $1a4d84fbcc800603$var$_interopRequireDefault((parcelRequire("4ireU")));
function $1a4d84fbcc800603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a4d84fbcc800603$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $1a4d84fbcc800603$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $1a4d84fbcc800603$var$_arrowRight.default
    }));
$1a4d84fbcc800603$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $1a4d84fbcc800603$var$_default = $1a4d84fbcc800603$exports.default = $1a4d84fbcc800603$var$ArrowRightIcon;


var $7c984b1fac873075$exports = {};
"use strict";
Object.defineProperty($7c984b1fac873075$exports, "__esModule", {
    value: true
});
$7c984b1fac873075$exports.default = void 0;

var $7c984b1fac873075$var$_react = $7c984b1fac873075$var$_interopRequireDefault((parcelRequire("acw62")));


var $7c984b1fac873075$var$_arrowRight = $7c984b1fac873075$var$_interopRequireDefault((parcelRequire("4ireU")));
function $7c984b1fac873075$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7c984b1fac873075$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7c984b1fac873075$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $7c984b1fac873075$var$_arrowRight.default
    }));
$7c984b1fac873075$var$ArrowRightCircleIcon.displayName = "ArrowRightCircleIcon";
var $7c984b1fac873075$var$_default = $7c984b1fac873075$exports.default = $7c984b1fac873075$var$ArrowRightCircleIcon;


var $f7f8c000d42a91ba$exports = {};
"use strict";
Object.defineProperty($f7f8c000d42a91ba$exports, "__esModule", {
    value: true
});
$f7f8c000d42a91ba$exports.default = void 0;

var $f7f8c000d42a91ba$var$_react = $f7f8c000d42a91ba$var$_interopRequireDefault((parcelRequire("acw62")));


var $f7f8c000d42a91ba$var$_arrowUp = $f7f8c000d42a91ba$var$_interopRequireDefault((parcelRequire("fxIqr")));
function $f7f8c000d42a91ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7f8c000d42a91ba$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $f7f8c000d42a91ba$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $f7f8c000d42a91ba$var$_arrowUp.default
    }));
$f7f8c000d42a91ba$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $f7f8c000d42a91ba$var$_default = $f7f8c000d42a91ba$exports.default = $f7f8c000d42a91ba$var$ArrowUpIcon;


var $d2a37f70120ffbf2$exports = {};
"use strict";
Object.defineProperty($d2a37f70120ffbf2$exports, "__esModule", {
    value: true
});
$d2a37f70120ffbf2$exports.default = void 0;

var $d2a37f70120ffbf2$var$_react = $d2a37f70120ffbf2$var$_interopRequireDefault((parcelRequire("acw62")));


var $d2a37f70120ffbf2$var$_arrowUp = $d2a37f70120ffbf2$var$_interopRequireDefault((parcelRequire("fxIqr")));
function $d2a37f70120ffbf2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d2a37f70120ffbf2$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $d2a37f70120ffbf2$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
    }, props, {
        newIcon: $d2a37f70120ffbf2$var$_arrowUp.default
    }));
$d2a37f70120ffbf2$var$ArrowUpCircleIcon.displayName = "ArrowUpCircleIcon";
var $d2a37f70120ffbf2$var$_default = $d2a37f70120ffbf2$exports.default = $d2a37f70120ffbf2$var$ArrowUpCircleIcon;


var $de4dd7d1aab12c73$exports = {};
"use strict";
Object.defineProperty($de4dd7d1aab12c73$exports, "__esModule", {
    value: true
});
$de4dd7d1aab12c73$exports.default = void 0;

var $de4dd7d1aab12c73$var$_react = $de4dd7d1aab12c73$var$_interopRequireDefault((parcelRequire("acw62")));

function $de4dd7d1aab12c73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de4dd7d1aab12c73$var$BitbucketBuildsIcon = (props)=>/*#__PURE__*/ $de4dd7d1aab12c73$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 5a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1M8 5c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3"/><path d="M16.06 6h2.42c.81 0 1.47.66 1.47 1.47v1.95c0 .82-.65 1.47-1.47 1.47H16v2h2.47a3.47 3.47 0 0 0 3.48-3.47V7.47A3.47 3.47 0 0 0 18.48 4h-2.41zm-7.17 5H6.47A3.47 3.47 0 0 0 3 14.47v1.95c0 1.92 1.55 3.47 3.47 3.47h2.48v-2H6.47c-.82 0-1.47-.65-1.47-1.47v-1.95c0-.81.66-1.47 1.47-1.47h2.42z"/></g></svg>`
    }, props));
$de4dd7d1aab12c73$var$BitbucketBuildsIcon.displayName = "BitbucketBuildsIcon";
var $de4dd7d1aab12c73$var$_default = $de4dd7d1aab12c73$exports.default = $de4dd7d1aab12c73$var$BitbucketBuildsIcon;


var $ca446314eb0c0eb9$exports = {};
"use strict";
Object.defineProperty($ca446314eb0c0eb9$exports, "__esModule", {
    value: true
});
$ca446314eb0c0eb9$exports.default = void 0;

var $ca446314eb0c0eb9$var$_react = $ca446314eb0c0eb9$var$_interopRequireDefault((parcelRequire("acw62")));


var $ca446314eb0c0eb9$var$_checkMark = $ca446314eb0c0eb9$var$_interopRequireDefault((parcelRequire("6rQeH")));
function $ca446314eb0c0eb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ca446314eb0c0eb9$var$CheckIcon = (props)=>/*#__PURE__*/ $ca446314eb0c0eb9$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $ca446314eb0c0eb9$var$_checkMark.default
    }));
$ca446314eb0c0eb9$var$CheckIcon.displayName = "CheckIcon";
var $ca446314eb0c0eb9$var$_default = $ca446314eb0c0eb9$exports.default = $ca446314eb0c0eb9$var$CheckIcon;


var $ad6b6c915170de16$exports = {};
"use strict";
Object.defineProperty($ad6b6c915170de16$exports, "__esModule", {
    value: true
});
$ad6b6c915170de16$exports.default = void 0;

var $ad6b6c915170de16$var$_react = $ad6b6c915170de16$var$_interopRequireDefault((parcelRequire("acw62")));


var $ad6b6c915170de16$var$_success = $ad6b6c915170de16$var$_interopRequireDefault((parcelRequire("b49fW")));
function $ad6b6c915170de16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ad6b6c915170de16$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $ad6b6c915170de16$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $ad6b6c915170de16$var$_success.default
    }));
$ad6b6c915170de16$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $ad6b6c915170de16$var$_default = $ad6b6c915170de16$exports.default = $ad6b6c915170de16$var$CheckCircleIcon;


var $f7ac7adc054f9d02$exports = {};
"use strict";
Object.defineProperty($f7ac7adc054f9d02$exports, "__esModule", {
    value: true
});
$f7ac7adc054f9d02$exports.default = void 0;

var $f7ac7adc054f9d02$var$_react = $f7ac7adc054f9d02$var$_interopRequireDefault((parcelRequire("acw62")));


var $f7ac7adc054f9d02$var$_checkCircle = $f7ac7adc054f9d02$var$_interopRequireDefault((parcelRequire("jZpwj")));
function $f7ac7adc054f9d02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7ac7adc054f9d02$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $f7ac7adc054f9d02$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $f7ac7adc054f9d02$var$_checkCircle.default
    }));
$f7ac7adc054f9d02$var$CheckCircleOutlineIcon.displayName = "CheckCircleOutlineIcon";
var $f7ac7adc054f9d02$var$_default = $f7ac7adc054f9d02$exports.default = $f7ac7adc054f9d02$var$CheckCircleOutlineIcon;


var $b37509fddb710d14$exports = {};
"use strict";
Object.defineProperty($b37509fddb710d14$exports, "__esModule", {
    value: true
});
$b37509fddb710d14$exports.default = void 0;

var $b37509fddb710d14$var$_react = $b37509fddb710d14$var$_interopRequireDefault((parcelRequire("acw62")));


var $b37509fddb710d14$var$_chevronDown = $b37509fddb710d14$var$_interopRequireDefault((parcelRequire("heRj3")));
function $b37509fddb710d14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b37509fddb710d14$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b37509fddb710d14$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $b37509fddb710d14$var$_chevronDown.default,
        iconType: "utility"
    }));
$b37509fddb710d14$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $b37509fddb710d14$var$_default = $b37509fddb710d14$exports.default = $b37509fddb710d14$var$ChevronDownIcon;


var $9618c54ee2794487$exports = {};
"use strict";
Object.defineProperty($9618c54ee2794487$exports, "__esModule", {
    value: true
});
$9618c54ee2794487$exports.default = void 0;

var $9618c54ee2794487$var$_react = $9618c54ee2794487$var$_interopRequireDefault((parcelRequire("acw62")));


var $9618c54ee2794487$var$_chevronDown = $9618c54ee2794487$var$_interopRequireDefault((parcelRequire("heRj3")));
function $9618c54ee2794487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9618c54ee2794487$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $9618c54ee2794487$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $9618c54ee2794487$var$_chevronDown.default,
        iconType: "utility"
    }));
$9618c54ee2794487$var$ChevronDownCircleIcon.displayName = "ChevronDownCircleIcon";
var $9618c54ee2794487$var$_default = $9618c54ee2794487$exports.default = $9618c54ee2794487$var$ChevronDownCircleIcon;


var $2ebcf1483de98f7e$exports = {};
"use strict";
Object.defineProperty($2ebcf1483de98f7e$exports, "__esModule", {
    value: true
});
$2ebcf1483de98f7e$exports.default = void 0;

var $2ebcf1483de98f7e$var$_react = $2ebcf1483de98f7e$var$_interopRequireDefault((parcelRequire("acw62")));


var $2ebcf1483de98f7e$var$_chevronLeft = $2ebcf1483de98f7e$var$_interopRequireDefault((parcelRequire("dm3im")));
function $2ebcf1483de98f7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ebcf1483de98f7e$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2ebcf1483de98f7e$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $2ebcf1483de98f7e$var$_chevronLeft.default,
        iconType: "utility"
    }));
$2ebcf1483de98f7e$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $2ebcf1483de98f7e$var$_default = $2ebcf1483de98f7e$exports.default = $2ebcf1483de98f7e$var$ChevronLeftIcon;


var $ed70aa6ac2ebc0b8$exports = {};
"use strict";
Object.defineProperty($ed70aa6ac2ebc0b8$exports, "__esModule", {
    value: true
});
$ed70aa6ac2ebc0b8$exports.default = void 0;

var $ed70aa6ac2ebc0b8$var$_react = $ed70aa6ac2ebc0b8$var$_interopRequireDefault((parcelRequire("acw62")));


var $ed70aa6ac2ebc0b8$var$_chevronLeft = $ed70aa6ac2ebc0b8$var$_interopRequireDefault((parcelRequire("dm3im")));
function $ed70aa6ac2ebc0b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ed70aa6ac2ebc0b8$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $ed70aa6ac2ebc0b8$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $ed70aa6ac2ebc0b8$var$_chevronLeft.default,
        iconType: "utility"
    }));
$ed70aa6ac2ebc0b8$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $ed70aa6ac2ebc0b8$var$_default = $ed70aa6ac2ebc0b8$exports.default = $ed70aa6ac2ebc0b8$var$ChevronLeftLargeIcon;


var $3d31785cc3bc23ef$exports = {};
"use strict";
Object.defineProperty($3d31785cc3bc23ef$exports, "__esModule", {
    value: true
});
$3d31785cc3bc23ef$exports.default = void 0;

var $3d31785cc3bc23ef$var$_react = $3d31785cc3bc23ef$var$_interopRequireDefault((parcelRequire("acw62")));


var $3d31785cc3bc23ef$var$_chevronRight = $3d31785cc3bc23ef$var$_interopRequireDefault((parcelRequire("ioczj")));
function $3d31785cc3bc23ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3d31785cc3bc23ef$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $3d31785cc3bc23ef$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $3d31785cc3bc23ef$var$_chevronRight.default,
        iconType: "utility"
    }));
$3d31785cc3bc23ef$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $3d31785cc3bc23ef$var$_default = $3d31785cc3bc23ef$exports.default = $3d31785cc3bc23ef$var$ChevronRightIcon;


var $912daf77e6b778ae$exports = {};
"use strict";
Object.defineProperty($912daf77e6b778ae$exports, "__esModule", {
    value: true
});
$912daf77e6b778ae$exports.default = void 0;

var $912daf77e6b778ae$var$_react = $912daf77e6b778ae$var$_interopRequireDefault((parcelRequire("acw62")));


var $912daf77e6b778ae$var$_chevronUp = $912daf77e6b778ae$var$_interopRequireDefault((parcelRequire("hw8Qv")));
function $912daf77e6b778ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $912daf77e6b778ae$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $912daf77e6b778ae$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $912daf77e6b778ae$var$_chevronUp.default,
        iconType: "utility"
    }));
$912daf77e6b778ae$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $912daf77e6b778ae$var$_default = $912daf77e6b778ae$exports.default = $912daf77e6b778ae$var$ChevronUpIcon;


var $142d03762c98d509$exports = {};
"use strict";
Object.defineProperty($142d03762c98d509$exports, "__esModule", {
    value: true
});
$142d03762c98d509$exports.default = void 0;

var $142d03762c98d509$var$_react = $142d03762c98d509$var$_interopRequireDefault((parcelRequire("acw62")));


var $142d03762c98d509$var$_copy = $142d03762c98d509$var$_interopRequireDefault((parcelRequire("cHXsv")));
function $142d03762c98d509$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $142d03762c98d509$var$CopyIcon = (props)=>/*#__PURE__*/ $142d03762c98d509$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $142d03762c98d509$var$_copy.default
    }));
$142d03762c98d509$var$CopyIcon.displayName = "CopyIcon";
var $142d03762c98d509$var$_default = $142d03762c98d509$exports.default = $142d03762c98d509$var$CopyIcon;


var $0f35765cb16ef905$exports = {};
"use strict";
Object.defineProperty($0f35765cb16ef905$exports, "__esModule", {
    value: true
});
$0f35765cb16ef905$exports.default = void 0;

var $0f35765cb16ef905$var$_react = $0f35765cb16ef905$var$_interopRequireDefault((parcelRequire("acw62")));


var $0f35765cb16ef905$var$_download = $0f35765cb16ef905$var$_interopRequireDefault((parcelRequire("bZH1Z")));
function $0f35765cb16ef905$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0f35765cb16ef905$var$DownloadIcon = (props)=>/*#__PURE__*/ $0f35765cb16ef905$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $0f35765cb16ef905$var$_download.default
    }));
$0f35765cb16ef905$var$DownloadIcon.displayName = "DownloadIcon";
var $0f35765cb16ef905$var$_default = $0f35765cb16ef905$exports.default = $0f35765cb16ef905$var$DownloadIcon;


var $22cd6fe70d8f03d8$exports = {};
"use strict";
Object.defineProperty($22cd6fe70d8f03d8$exports, "__esModule", {
    value: true
});
$22cd6fe70d8f03d8$exports.default = void 0;

var $22cd6fe70d8f03d8$var$_react = $22cd6fe70d8f03d8$var$_interopRequireDefault((parcelRequire("acw62")));


var $22cd6fe70d8f03d8$var$_edit = $22cd6fe70d8f03d8$var$_interopRequireDefault((parcelRequire("9Ot7V")));
function $22cd6fe70d8f03d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $22cd6fe70d8f03d8$var$EditIcon = (props)=>/*#__PURE__*/ $22cd6fe70d8f03d8$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $22cd6fe70d8f03d8$var$_edit.default
    }));
$22cd6fe70d8f03d8$var$EditIcon.displayName = "EditIcon";
var $22cd6fe70d8f03d8$var$_default = $22cd6fe70d8f03d8$exports.default = $22cd6fe70d8f03d8$var$EditIcon;


var $367dba6e2103b9b2$exports = {};
"use strict";
Object.defineProperty($367dba6e2103b9b2$exports, "__esModule", {
    value: true
});
$367dba6e2103b9b2$exports.default = void 0;

var $367dba6e2103b9b2$var$_react = $367dba6e2103b9b2$var$_interopRequireDefault((parcelRequire("acw62")));


var $367dba6e2103b9b2$var$_edit = $367dba6e2103b9b2$var$_interopRequireDefault((parcelRequire("9Ot7V")));
function $367dba6e2103b9b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $367dba6e2103b9b2$var$EditFilledIcon = (props)=>/*#__PURE__*/ $367dba6e2103b9b2$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $367dba6e2103b9b2$var$_edit.default
    }));
$367dba6e2103b9b2$var$EditFilledIcon.displayName = "EditFilledIcon";
var $367dba6e2103b9b2$var$_default = $367dba6e2103b9b2$exports.default = $367dba6e2103b9b2$var$EditFilledIcon;


var $08b1b9be7ef671a2$exports = {};
"use strict";
Object.defineProperty($08b1b9be7ef671a2$exports, "__esModule", {
    value: true
});
$08b1b9be7ef671a2$exports.default = void 0;

var $08b1b9be7ef671a2$var$_react = $08b1b9be7ef671a2$var$_interopRequireDefault((parcelRequire("acw62")));


var $08b1b9be7ef671a2$var$_close = $08b1b9be7ef671a2$var$_interopRequireDefault((parcelRequire("j8Gpr")));
function $08b1b9be7ef671a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08b1b9be7ef671a2$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $08b1b9be7ef671a2$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $08b1b9be7ef671a2$var$_close.default
    }));
$08b1b9be7ef671a2$var$EditorCloseIcon.displayName = "EditorCloseIcon";
var $08b1b9be7ef671a2$var$_default = $08b1b9be7ef671a2$exports.default = $08b1b9be7ef671a2$var$EditorCloseIcon;


var $e43d19eb9134f54b$exports = {};
"use strict";
Object.defineProperty($e43d19eb9134f54b$exports, "__esModule", {
    value: true
});
$e43d19eb9134f54b$exports.default = void 0;

var $e43d19eb9134f54b$var$_react = $e43d19eb9134f54b$var$_interopRequireDefault((parcelRequire("acw62")));


var $e43d19eb9134f54b$var$_contentWrapRight = $e43d19eb9134f54b$var$_interopRequireDefault((parcelRequire("hvFVY")));
function $e43d19eb9134f54b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e43d19eb9134f54b$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $e43d19eb9134f54b$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $e43d19eb9134f54b$var$_contentWrapRight.default
    }));
$e43d19eb9134f54b$var$EditorMediaWrapRightIcon.displayName = "EditorMediaWrapRightIcon";
var $e43d19eb9134f54b$var$_default = $e43d19eb9134f54b$exports.default = $e43d19eb9134f54b$var$EditorMediaWrapRightIcon;


var $d50eca750a629ef7$exports = {};
"use strict";
Object.defineProperty($d50eca750a629ef7$exports, "__esModule", {
    value: true
});
$d50eca750a629ef7$exports.default = void 0;

var $d50eca750a629ef7$var$_react = $d50eca750a629ef7$var$_interopRequireDefault((parcelRequire("acw62")));


var $d50eca750a629ef7$var$_arrowUpRight = $d50eca750a629ef7$var$_interopRequireDefault((parcelRequire("krRSk")));
function $d50eca750a629ef7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d50eca750a629ef7$var$EditorOpenIcon = (props)=>/*#__PURE__*/ $d50eca750a629ef7$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.873 7.63c-.28 0-.344.159-.147.357l2.436 2.436-4.386 4.386a.51.51 0 0 0 0 .713l.7.7a.495.495 0 0 0 .713.001l4.387-4.386 2.436 2.436c.197.197.357.124.357-.147V8.133a.507.507 0 0 0-.503-.503z"/></svg>`
    }, props, {
        newIcon: $d50eca750a629ef7$var$_arrowUpRight.default
    }));
$d50eca750a629ef7$var$EditorOpenIcon.displayName = "EditorOpenIcon";
var $d50eca750a629ef7$var$_default = $d50eca750a629ef7$exports.default = $d50eca750a629ef7$var$EditorOpenIcon;


var $fca087c29e5c69a5$exports = {};
"use strict";
Object.defineProperty($fca087c29e5c69a5$exports, "__esModule", {
    value: true
});
$fca087c29e5c69a5$exports.default = void 0;

var $fca087c29e5c69a5$var$_react = $fca087c29e5c69a5$var$_interopRequireDefault((parcelRequire("acw62")));


var $fca087c29e5c69a5$var$_information = $fca087c29e5c69a5$var$_interopRequireDefault((parcelRequire("g0fSr")));
function $fca087c29e5c69a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fca087c29e5c69a5$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $fca087c29e5c69a5$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $fca087c29e5c69a5$var$_information.default
    }));
$fca087c29e5c69a5$var$EditorPanelIcon.displayName = "EditorPanelIcon";
var $fca087c29e5c69a5$var$_default = $fca087c29e5c69a5$exports.default = $fca087c29e5c69a5$var$EditorPanelIcon;


var $2fb596ac1dfd6a48$exports = {};
"use strict";
Object.defineProperty($2fb596ac1dfd6a48$exports, "__esModule", {
    value: true
});
$2fb596ac1dfd6a48$exports.default = void 0;

var $2fb596ac1dfd6a48$var$_react = $2fb596ac1dfd6a48$var$_interopRequireDefault((parcelRequire("acw62")));


var $2fb596ac1dfd6a48$var$_grid = $2fb596ac1dfd6a48$var$_interopRequireDefault((parcelRequire("9FdSp")));
function $2fb596ac1dfd6a48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2fb596ac1dfd6a48$var$EditorTableIcon = (props)=>/*#__PURE__*/ $2fb596ac1dfd6a48$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $2fb596ac1dfd6a48$var$_grid.default
    }));
$2fb596ac1dfd6a48$var$EditorTableIcon.displayName = "EditorTableIcon";
var $2fb596ac1dfd6a48$var$_default = $2fb596ac1dfd6a48$exports.default = $2fb596ac1dfd6a48$var$EditorTableIcon;


var $f81dad094603fd5d$exports = {};
"use strict";
Object.defineProperty($f81dad094603fd5d$exports, "__esModule", {
    value: true
});
$f81dad094603fd5d$exports.default = void 0;

var $f81dad094603fd5d$var$_react = $f81dad094603fd5d$var$_interopRequireDefault((parcelRequire("acw62")));

function $f81dad094603fd5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f81dad094603fd5d$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $f81dad094603fd5d$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$f81dad094603fd5d$var$EmojiAtlassianIcon.displayName = "EmojiAtlassianIcon";
var $f81dad094603fd5d$var$_default = $f81dad094603fd5d$exports.default = $f81dad094603fd5d$var$EmojiAtlassianIcon;


var $a8b22758b6b909fb$exports = {};
"use strict";
Object.defineProperty($a8b22758b6b909fb$exports, "__esModule", {
    value: true
});
$a8b22758b6b909fb$exports.default = void 0;

var $a8b22758b6b909fb$var$_react = $a8b22758b6b909fb$var$_interopRequireDefault((parcelRequire("acw62")));


var $a8b22758b6b909fb$var$_clock = $a8b22758b6b909fb$var$_interopRequireDefault((parcelRequire("cghCB")));
function $a8b22758b6b909fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a8b22758b6b909fb$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $a8b22758b6b909fb$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $a8b22758b6b909fb$var$_clock.default
    }));
$a8b22758b6b909fb$var$EmojiFrequentIcon.displayName = "EmojiFrequentIcon";
var $a8b22758b6b909fb$var$_default = $a8b22758b6b909fb$exports.default = $a8b22758b6b909fb$var$EmojiFrequentIcon;


var $022a88c88e22620b$exports = {};
"use strict";
Object.defineProperty($022a88c88e22620b$exports, "__esModule", {
    value: true
});
$022a88c88e22620b$exports.default = void 0;

var $022a88c88e22620b$var$_react = $022a88c88e22620b$var$_interopRequireDefault((parcelRequire("acw62")));


var $022a88c88e22620b$var$_heart = $022a88c88e22620b$var$_interopRequireDefault((parcelRequire("jbxFH")));
function $022a88c88e22620b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $022a88c88e22620b$var$EmojiSymbolsIcon = (props)=>/*#__PURE__*/ $022a88c88e22620b$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12 9.44 1.76-1.744a2.505 2.505 0 0 1 3.52 0 2.45 2.45 0 0 1 0 3.488L12 16.417l-5.28-5.232a2.45 2.45 0 0 1 0-3.49 2.505 2.505 0 0 1 3.52 0v.001zm-6.684 3.143.003.004 6.322 6.266a.51.51 0 0 0 .718 0l6.322-6.266.003-.004.004-.003a4.41 4.41 0 0 0 0-6.28 4.51 4.51 0 0 0-6.336 0l-.003.004-.004.003L12 6.65l-.345-.342-.004-.003-.003-.003a4.51 4.51 0 0 0-6.336 0 4.41 4.41 0 0 0 0 6.279z"/></svg>`
    }, props, {
        newIcon: $022a88c88e22620b$var$_heart.default
    }));
$022a88c88e22620b$var$EmojiSymbolsIcon.displayName = "EmojiSymbolsIcon";
var $022a88c88e22620b$var$_default = $022a88c88e22620b$exports.default = $022a88c88e22620b$var$EmojiSymbolsIcon;


var $b8de6cc86ff0ecdc$exports = {};
"use strict";
Object.defineProperty($b8de6cc86ff0ecdc$exports, "__esModule", {
    value: true
});
$b8de6cc86ff0ecdc$exports.default = void 0;

var $b8de6cc86ff0ecdc$var$_react = $b8de6cc86ff0ecdc$var$_interopRequireDefault((parcelRequire("acw62")));


var $b8de6cc86ff0ecdc$var$_error = $b8de6cc86ff0ecdc$var$_interopRequireDefault((parcelRequire("9ZaBa")));
function $b8de6cc86ff0ecdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b8de6cc86ff0ecdc$var$ErrorIcon = (props)=>/*#__PURE__*/ $b8de6cc86ff0ecdc$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $b8de6cc86ff0ecdc$var$_error.default
    }));
$b8de6cc86ff0ecdc$var$ErrorIcon.displayName = "ErrorIcon";
var $b8de6cc86ff0ecdc$var$_default = $b8de6cc86ff0ecdc$exports.default = $b8de6cc86ff0ecdc$var$ErrorIcon;


var $d054a043c858c0ba$exports = {};
"use strict";
Object.defineProperty($d054a043c858c0ba$exports, "__esModule", {
    value: true
});
$d054a043c858c0ba$exports.default = void 0;

var $d054a043c858c0ba$var$_react = $d054a043c858c0ba$var$_interopRequireDefault((parcelRequire("acw62")));


var $d054a043c858c0ba$var$_upload = $d054a043c858c0ba$var$_interopRequireDefault((parcelRequire("8c0xc")));
function $d054a043c858c0ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d054a043c858c0ba$var$ExportIcon = (props)=>/*#__PURE__*/ $d054a043c858c0ba$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $d054a043c858c0ba$var$_upload.default
    }));
$d054a043c858c0ba$var$ExportIcon.displayName = "ExportIcon";
var $d054a043c858c0ba$var$_default = $d054a043c858c0ba$exports.default = $d054a043c858c0ba$var$ExportIcon;


var $a7dc2edd667ae2da$exports = {};
"use strict";
Object.defineProperty($a7dc2edd667ae2da$exports, "__esModule", {
    value: true
});
$a7dc2edd667ae2da$exports.default = void 0;

var $a7dc2edd667ae2da$var$_react = $a7dc2edd667ae2da$var$_interopRequireDefault((parcelRequire("acw62")));


var $a7dc2edd667ae2da$var$_filter = $a7dc2edd667ae2da$var$_interopRequireDefault((parcelRequire("jxvJO")));
function $a7dc2edd667ae2da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a7dc2edd667ae2da$var$FilterIcon = (props)=>/*#__PURE__*/ $a7dc2edd667ae2da$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $a7dc2edd667ae2da$var$_filter.default
    }));
$a7dc2edd667ae2da$var$FilterIcon.displayName = "FilterIcon";
var $a7dc2edd667ae2da$var$_default = $a7dc2edd667ae2da$exports.default = $a7dc2edd667ae2da$var$FilterIcon;


var $f8c9b5db3aca009e$exports = {};
"use strict";
Object.defineProperty($f8c9b5db3aca009e$exports, "__esModule", {
    value: true
});
$f8c9b5db3aca009e$exports.default = void 0;

var $f8c9b5db3aca009e$var$_react = $f8c9b5db3aca009e$var$_interopRequireDefault((parcelRequire("acw62")));


var $f8c9b5db3aca009e$var$_chevronDown = $f8c9b5db3aca009e$var$_interopRequireDefault((parcelRequire("heRj3")));
function $f8c9b5db3aca009e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8c9b5db3aca009e$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $f8c9b5db3aca009e$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $f8c9b5db3aca009e$var$_chevronDown.default,
        iconType: "utility"
    }));
$f8c9b5db3aca009e$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $f8c9b5db3aca009e$var$_default = $f8c9b5db3aca009e$exports.default = $f8c9b5db3aca009e$var$HipchatChevronDownIcon;


var $4d6daabf365a3621$exports = {};
"use strict";
Object.defineProperty($4d6daabf365a3621$exports, "__esModule", {
    value: true
});
$4d6daabf365a3621$exports.default = void 0;

var $4d6daabf365a3621$var$_react = $4d6daabf365a3621$var$_interopRequireDefault((parcelRequire("acw62")));


var $4d6daabf365a3621$var$_chevronUp = $4d6daabf365a3621$var$_interopRequireDefault((parcelRequire("hw8Qv")));
function $4d6daabf365a3621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d6daabf365a3621$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $4d6daabf365a3621$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $4d6daabf365a3621$var$_chevronUp.default,
        iconType: "utility"
    }));
$4d6daabf365a3621$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $4d6daabf365a3621$var$_default = $4d6daabf365a3621$exports.default = $4d6daabf365a3621$var$HipchatChevronUpIcon;


var $adba5dedbf5ee9c0$exports = {};
"use strict";
Object.defineProperty($adba5dedbf5ee9c0$exports, "__esModule", {
    value: true
});
$adba5dedbf5ee9c0$exports.default = void 0;

var $adba5dedbf5ee9c0$var$_react = $adba5dedbf5ee9c0$var$_interopRequireDefault((parcelRequire("acw62")));


var $adba5dedbf5ee9c0$var$_image = $adba5dedbf5ee9c0$var$_interopRequireDefault((parcelRequire("6BHTj")));
function $adba5dedbf5ee9c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $adba5dedbf5ee9c0$var$ImageIcon = (props)=>/*#__PURE__*/ $adba5dedbf5ee9c0$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $adba5dedbf5ee9c0$var$_image.default
    }));
$adba5dedbf5ee9c0$var$ImageIcon.displayName = "ImageIcon";
var $adba5dedbf5ee9c0$var$_default = $adba5dedbf5ee9c0$exports.default = $adba5dedbf5ee9c0$var$ImageIcon;


var $4a9187e6958af736$exports = {};
"use strict";
Object.defineProperty($4a9187e6958af736$exports, "__esModule", {
    value: true
});
$4a9187e6958af736$exports.default = void 0;

var $4a9187e6958af736$var$_react = $4a9187e6958af736$var$_interopRequireDefault((parcelRequire("acw62")));


var $4a9187e6958af736$var$_information = $4a9187e6958af736$var$_interopRequireDefault((parcelRequire("g0fSr")));
function $4a9187e6958af736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4a9187e6958af736$var$InfoIcon = (props)=>/*#__PURE__*/ $4a9187e6958af736$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $4a9187e6958af736$var$_information.default
    }));
$4a9187e6958af736$var$InfoIcon.displayName = "InfoIcon";
var $4a9187e6958af736$var$_default = $4a9187e6958af736$exports.default = $4a9187e6958af736$var$InfoIcon;


var $125c6682bbd13fdb$exports = {};
"use strict";
Object.defineProperty($125c6682bbd13fdb$exports, "__esModule", {
    value: true
});
$125c6682bbd13fdb$exports.default = void 0;

var $125c6682bbd13fdb$var$_react = $125c6682bbd13fdb$var$_interopRequireDefault((parcelRequire("acw62")));


var $125c6682bbd13fdb$var$_link = $125c6682bbd13fdb$var$_interopRequireDefault((parcelRequire("lHibX")));
function $125c6682bbd13fdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $125c6682bbd13fdb$var$LinkIcon = (props)=>/*#__PURE__*/ $125c6682bbd13fdb$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $125c6682bbd13fdb$var$_link.default
    }));
$125c6682bbd13fdb$var$LinkIcon.displayName = "LinkIcon";
var $125c6682bbd13fdb$var$_default = $125c6682bbd13fdb$exports.default = $125c6682bbd13fdb$var$LinkIcon;


var $60aaa7a9a5689072$exports = {};
"use strict";
Object.defineProperty($60aaa7a9a5689072$exports, "__esModule", {
    value: true
});
$60aaa7a9a5689072$exports.default = void 0;

var $60aaa7a9a5689072$var$_react = $60aaa7a9a5689072$var$_interopRequireDefault((parcelRequire("acw62")));


var $60aaa7a9a5689072$var$_location = $60aaa7a9a5689072$var$_interopRequireDefault((parcelRequire("9dzbE")));
function $60aaa7a9a5689072$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $60aaa7a9a5689072$var$LocationIcon = (props)=>/*#__PURE__*/ $60aaa7a9a5689072$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $60aaa7a9a5689072$var$_location.default
    }));
$60aaa7a9a5689072$var$LocationIcon.displayName = "LocationIcon";
var $60aaa7a9a5689072$var$_default = $60aaa7a9a5689072$exports.default = $60aaa7a9a5689072$var$LocationIcon;


var $84301abb52bcbf76$exports = {};
"use strict";
Object.defineProperty($84301abb52bcbf76$exports, "__esModule", {
    value: true
});
$84301abb52bcbf76$exports.default = void 0;

var $84301abb52bcbf76$var$_react = $84301abb52bcbf76$var$_interopRequireDefault((parcelRequire("acw62")));


var $84301abb52bcbf76$var$_zoomIn = $84301abb52bcbf76$var$_interopRequireDefault((parcelRequire("1CLjn")));
function $84301abb52bcbf76$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $84301abb52bcbf76$var$MediaServicesZoomInIcon = (props)=>/*#__PURE__*/ $84301abb52bcbf76$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2z"/></svg>`
    }, props, {
        newIcon: $84301abb52bcbf76$var$_zoomIn.default
    }));
$84301abb52bcbf76$var$MediaServicesZoomInIcon.displayName = "MediaServicesZoomInIcon";
var $84301abb52bcbf76$var$_default = $84301abb52bcbf76$exports.default = $84301abb52bcbf76$var$MediaServicesZoomInIcon;


var $2ff04b2d6f0111c2$exports = {};
"use strict";
Object.defineProperty($2ff04b2d6f0111c2$exports, "__esModule", {
    value: true
});
$2ff04b2d6f0111c2$exports.default = void 0;

var $2ff04b2d6f0111c2$var$_react = $2ff04b2d6f0111c2$var$_interopRequireDefault((parcelRequire("acw62")));


var $2ff04b2d6f0111c2$var$_zoomOut = $2ff04b2d6f0111c2$var$_interopRequireDefault((parcelRequire("3JsYz")));
function $2ff04b2d6f0111c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ff04b2d6f0111c2$var$MediaServicesZoomOutIcon = (props)=>/*#__PURE__*/ $2ff04b2d6f0111c2$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $2ff04b2d6f0111c2$var$_zoomOut.default
    }));
$2ff04b2d6f0111c2$var$MediaServicesZoomOutIcon.displayName = "MediaServicesZoomOutIcon";
var $2ff04b2d6f0111c2$var$_default = $2ff04b2d6f0111c2$exports.default = $2ff04b2d6f0111c2$var$MediaServicesZoomOutIcon;


var $3ffeb0366878e88f$exports = {};
"use strict";
Object.defineProperty($3ffeb0366878e88f$exports, "__esModule", {
    value: true
});
$3ffeb0366878e88f$exports.default = void 0;

var $3ffeb0366878e88f$var$_react = $3ffeb0366878e88f$var$_interopRequireDefault((parcelRequire("acw62")));


var $3ffeb0366878e88f$var$_menu = $3ffeb0366878e88f$var$_interopRequireDefault((parcelRequire("hPYVq")));
function $3ffeb0366878e88f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ffeb0366878e88f$var$MenuIcon = (props)=>/*#__PURE__*/ $3ffeb0366878e88f$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z"/></svg>`
    }, props, {
        newIcon: $3ffeb0366878e88f$var$_menu.default
    }));
$3ffeb0366878e88f$var$MenuIcon.displayName = "MenuIcon";
var $3ffeb0366878e88f$var$_default = $3ffeb0366878e88f$exports.default = $3ffeb0366878e88f$var$MenuIcon;


var $cc33747d1cecda1d$exports = {};
"use strict";
Object.defineProperty($cc33747d1cecda1d$exports, "__esModule", {
    value: true
});
$cc33747d1cecda1d$exports.default = void 0;

var $cc33747d1cecda1d$var$_react = $cc33747d1cecda1d$var$_interopRequireDefault((parcelRequire("acw62")));


var $cc33747d1cecda1d$var$_showMoreVertical = $cc33747d1cecda1d$var$_interopRequireDefault((parcelRequire("4Um32")));
function $cc33747d1cecda1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc33747d1cecda1d$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $cc33747d1cecda1d$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $cc33747d1cecda1d$var$_showMoreVertical.default
    }));
$cc33747d1cecda1d$var$MoreVerticalIcon.displayName = "MoreVerticalIcon";
var $cc33747d1cecda1d$var$_default = $cc33747d1cecda1d$exports.default = $cc33747d1cecda1d$var$MoreVerticalIcon;


var $834b5235e5fd92db$exports = {};
"use strict";
Object.defineProperty($834b5235e5fd92db$exports, "__esModule", {
    value: true
});
$834b5235e5fd92db$exports.default = void 0;

var $834b5235e5fd92db$var$_react = $834b5235e5fd92db$var$_interopRequireDefault((parcelRequire("acw62")));


var $834b5235e5fd92db$var$_alignLeft = $834b5235e5fd92db$var$_interopRequireDefault((parcelRequire("gxuTp")));
function $834b5235e5fd92db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $834b5235e5fd92db$var$OverviewIcon = (props)=>/*#__PURE__*/ $834b5235e5fd92db$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $834b5235e5fd92db$var$_alignLeft.default
    }));
$834b5235e5fd92db$var$OverviewIcon.displayName = "OverviewIcon";
var $834b5235e5fd92db$var$_default = $834b5235e5fd92db$exports.default = $834b5235e5fd92db$var$OverviewIcon;


var $9be5747e7f75a217$exports = {};
"use strict";
Object.defineProperty($9be5747e7f75a217$exports, "__esModule", {
    value: true
});
$9be5747e7f75a217$exports.default = void 0;

var $9be5747e7f75a217$var$_react = $9be5747e7f75a217$var$_interopRequireDefault((parcelRequire("acw62")));


var $9be5747e7f75a217$var$_questionCircle = $9be5747e7f75a217$var$_interopRequireDefault((parcelRequire("5rGJ1")));
function $9be5747e7f75a217$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9be5747e7f75a217$var$QuestionIcon = (props)=>/*#__PURE__*/ $9be5747e7f75a217$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $9be5747e7f75a217$var$_questionCircle.default
    }));
$9be5747e7f75a217$var$QuestionIcon.displayName = "QuestionIcon";
var $9be5747e7f75a217$var$_default = $9be5747e7f75a217$exports.default = $9be5747e7f75a217$var$QuestionIcon;


var $e2cf0a338e6e7ec3$exports = {};
"use strict";
Object.defineProperty($e2cf0a338e6e7ec3$exports, "__esModule", {
    value: true
});
$e2cf0a338e6e7ec3$exports.default = void 0;

var $e2cf0a338e6e7ec3$var$_react = $e2cf0a338e6e7ec3$var$_interopRequireDefault((parcelRequire("acw62")));


var $e2cf0a338e6e7ec3$var$_refresh = $e2cf0a338e6e7ec3$var$_interopRequireDefault((parcelRequire("gW3Gy")));
function $e2cf0a338e6e7ec3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e2cf0a338e6e7ec3$var$RefreshIcon = (props)=>/*#__PURE__*/ $e2cf0a338e6e7ec3$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $e2cf0a338e6e7ec3$var$_refresh.default
    }));
$e2cf0a338e6e7ec3$var$RefreshIcon.displayName = "RefreshIcon";
var $e2cf0a338e6e7ec3$var$_default = $e2cf0a338e6e7ec3$exports.default = $e2cf0a338e6e7ec3$var$RefreshIcon;


var $9fe02b09e2c6116b$exports = {};
"use strict";
Object.defineProperty($9fe02b09e2c6116b$exports, "__esModule", {
    value: true
});
$9fe02b09e2c6116b$exports.default = void 0;

var $9fe02b09e2c6116b$var$_react = $9fe02b09e2c6116b$var$_interopRequireDefault((parcelRequire("acw62")));


var $9fe02b09e2c6116b$var$_search = $9fe02b09e2c6116b$var$_interopRequireDefault((parcelRequire("fYNPR")));
function $9fe02b09e2c6116b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9fe02b09e2c6116b$var$SearchIcon = (props)=>/*#__PURE__*/ $9fe02b09e2c6116b$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $9fe02b09e2c6116b$var$_search.default
    }));
$9fe02b09e2c6116b$var$SearchIcon.displayName = "SearchIcon";
var $9fe02b09e2c6116b$var$_default = $9fe02b09e2c6116b$exports.default = $9fe02b09e2c6116b$var$SearchIcon;


var $5fd3bacdb4e0d7cf$exports = {};
"use strict";
Object.defineProperty($5fd3bacdb4e0d7cf$exports, "__esModule", {
    value: true
});
$5fd3bacdb4e0d7cf$exports.default = void 0;

var $5fd3bacdb4e0d7cf$var$_react = $5fd3bacdb4e0d7cf$var$_interopRequireDefault((parcelRequire("acw62")));


var $5fd3bacdb4e0d7cf$var$_settings = $5fd3bacdb4e0d7cf$var$_interopRequireDefault((parcelRequire("dy5hX")));
function $5fd3bacdb4e0d7cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5fd3bacdb4e0d7cf$var$SettingsIcon = (props)=>/*#__PURE__*/ $5fd3bacdb4e0d7cf$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $5fd3bacdb4e0d7cf$var$_settings.default
    }));
$5fd3bacdb4e0d7cf$var$SettingsIcon.displayName = "SettingsIcon";
var $5fd3bacdb4e0d7cf$var$_default = $5fd3bacdb4e0d7cf$exports.default = $5fd3bacdb4e0d7cf$var$SettingsIcon;


var $9d0d5aadf571b450$exports = {};
"use strict";
Object.defineProperty($9d0d5aadf571b450$exports, "__esModule", {
    value: true
});
$9d0d5aadf571b450$exports.default = void 0;

var $9d0d5aadf571b450$var$_react = $9d0d5aadf571b450$var$_interopRequireDefault((parcelRequire("acw62")));


var $9d0d5aadf571b450$var$_share = $9d0d5aadf571b450$var$_interopRequireDefault((parcelRequire("4pTYx")));
function $9d0d5aadf571b450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d0d5aadf571b450$var$ShareIcon = (props)=>/*#__PURE__*/ $9d0d5aadf571b450$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9d0d5aadf571b450$var$_share.default
    }));
$9d0d5aadf571b450$var$ShareIcon.displayName = "ShareIcon";
var $9d0d5aadf571b450$var$_default = $9d0d5aadf571b450$exports.default = $9d0d5aadf571b450$var$ShareIcon;


var $593c413bca784438$exports = {};
"use strict";
Object.defineProperty($593c413bca784438$exports, "__esModule", {
    value: true
});
$593c413bca784438$exports.default = void 0;

var $593c413bca784438$var$_react = $593c413bca784438$var$_interopRequireDefault((parcelRequire("acw62")));


var $593c413bca784438$var$_starUnstarred = $593c413bca784438$var$_interopRequireDefault((parcelRequire("9w6gj")));
function $593c413bca784438$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $593c413bca784438$var$StarIcon = (props)=>/*#__PURE__*/ $593c413bca784438$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $593c413bca784438$var$_starUnstarred.default
    }));
$593c413bca784438$var$StarIcon.displayName = "StarIcon";
var $593c413bca784438$var$_default = $593c413bca784438$exports.default = $593c413bca784438$var$StarIcon;


var $8ff1f8eb7d65cd94$exports = {};
"use strict";
Object.defineProperty($8ff1f8eb7d65cd94$exports, "__esModule", {
    value: true
});
$8ff1f8eb7d65cd94$exports.default = void 0;

var $8ff1f8eb7d65cd94$var$_react = $8ff1f8eb7d65cd94$var$_interopRequireDefault((parcelRequire("acw62")));


var $8ff1f8eb7d65cd94$var$_starStarred = $8ff1f8eb7d65cd94$var$_interopRequireDefault((parcelRequire("fV9BG")));
function $8ff1f8eb7d65cd94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ff1f8eb7d65cd94$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8ff1f8eb7d65cd94$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8ff1f8eb7d65cd94$var$_starStarred.default
    }));
$8ff1f8eb7d65cd94$var$StarFilledIcon.displayName = "StarFilledIcon";
var $8ff1f8eb7d65cd94$var$_default = $8ff1f8eb7d65cd94$exports.default = $8ff1f8eb7d65cd94$var$StarFilledIcon;


var $136ca9fcf2043d4b$exports = {};
"use strict";
Object.defineProperty($136ca9fcf2043d4b$exports, "__esModule", {
    value: true
});
$136ca9fcf2043d4b$exports.default = void 0;

var $136ca9fcf2043d4b$var$_react = $136ca9fcf2043d4b$var$_interopRequireDefault((parcelRequire("acw62")));


var $136ca9fcf2043d4b$var$_warning = $136ca9fcf2043d4b$var$_interopRequireDefault((parcelRequire("2Hh3G")));
function $136ca9fcf2043d4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $136ca9fcf2043d4b$var$WarningIcon = (props)=>/*#__PURE__*/ $136ca9fcf2043d4b$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $136ca9fcf2043d4b$var$_warning.default
    }));
$136ca9fcf2043d4b$var$WarningIcon.displayName = "WarningIcon";
var $136ca9fcf2043d4b$var$_default = $136ca9fcf2043d4b$exports.default = $136ca9fcf2043d4b$var$WarningIcon;


var $3fbfec1d7cd78380$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aeea3452b156c1a88293b0f0d28d725d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($3fbfec1d7cd78380$exports, "__esModule", {
    value: true
});
$3fbfec1d7cd78380$exports.default = void 0;

var $3fbfec1d7cd78380$var$_react = $3fbfec1d7cd78380$var$_interopRequireDefault((parcelRequire("acw62")));

var $3fbfec1d7cd78380$var$_baseNew = $3fbfec1d7cd78380$var$_interopRequireDefault((parcelRequire("4Olsf")));
function $3fbfec1d7cd78380$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3fbfec1d7cd78380$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $3fbfec1d7cd78380$var$_react.default.createElement($3fbfec1d7cd78380$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$3fbfec1d7cd78380$var$GenerativeIndicatorIcon.displayName = "GenerativeIndicatorIcon";
var $3fbfec1d7cd78380$var$_default = $3fbfec1d7cd78380$exports.default = $3fbfec1d7cd78380$var$GenerativeIndicatorIcon;


var $66996c4de10cf265$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($66996c4de10cf265$exports, "__esModule", {
    value: true
});
$66996c4de10cf265$exports.default = void 0;

var $66996c4de10cf265$var$_react = $66996c4de10cf265$var$_interopRequireDefault((parcelRequire("acw62")));

var $66996c4de10cf265$var$_baseNew = $66996c4de10cf265$var$_interopRequireDefault((parcelRequire("4Olsf")));
function $66996c4de10cf265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66996c4de10cf265$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $66996c4de10cf265$var$_react.default.createElement($66996c4de10cf265$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$66996c4de10cf265$var$RoadmapsPlanIcon.displayName = "RoadmapsPlanIcon";
var $66996c4de10cf265$var$_default = $66996c4de10cf265$exports.default = $66996c4de10cf265$var$RoadmapsPlanIcon;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $446773945060669c$var$printed = {};
function $446773945060669c$export$2e2bcd8739ae039(message) {
    if ($446773945060669c$var$printed[message]) return;
    $446773945060669c$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $e25c32996edeac2f$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $446773945060669c$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $e25c32996edeac2f$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $95ad6dbea4f7d3b7$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $95ad6dbea4f7d3b7$export$c93026a968943f95 = "light";
var $95ad6dbea4f7d3b7$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $95ad6dbea4f7d3b7$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $95ad6dbea4f7d3b7$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $95ad6dbea4f7d3b7$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $95ad6dbea4f7d3b7$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $95ad6dbea4f7d3b7$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $95ad6dbea4f7d3b7$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $95ad6dbea4f7d3b7$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5e26c99fa43b3c99$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $95ad6dbea4f7d3b7$export$6d8204c2cb2e06b8() / 4;
    (0, $e25c32996edeac2f$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $95ad6dbea4f7d3b7$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $95ad6dbea4f7d3b7$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $95ad6dbea4f7d3b7$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e25c32996edeac2f$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $95ad6dbea4f7d3b7$export$ba1d834b86d72a09 = $95ad6dbea4f7d3b7$export$a1b3edb637fb4f35;
var $95ad6dbea4f7d3b7$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5e26c99fa43b3c99$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5e26c99fa43b3c99$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5e26c99fa43b3c99$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $e735e97125270579$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $95ad6dbea4f7d3b7$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $95ad6dbea4f7d3b7$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $95ad6dbea4f7d3b7$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $95ad6dbea4f7d3b7$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $ec193d4a64f1a172$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $e735e97125270579$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $ec193d4a64f1a172$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $ec193d4a64f1a172$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $e735e97125270579$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $5e26c99fa43b3c99$export$4b84fd0e2c617bd = "#FFEBE6";
var $5e26c99fa43b3c99$export$b34b069eff244586 = "#FFBDAD";
var $5e26c99fa43b3c99$export$be802dd0d8b57f35 = "#FF8F73";
var $5e26c99fa43b3c99$export$60847d42f9da92a6 = "#FF7452";
var $5e26c99fa43b3c99$export$4a7404f376229999 = "#FF5630";
var $5e26c99fa43b3c99$export$2010d0fb4295b346 = "#DE350B";
var $5e26c99fa43b3c99$export$2837b5a1a71d5c02 = "#BF2600";
var $5e26c99fa43b3c99$export$8d9596b529bbb9cf = "#FFFAE6";
var $5e26c99fa43b3c99$export$41060a744ab0b7ae = "#FFF0B3";
var $5e26c99fa43b3c99$export$1cc05bbbf340e559 = "#FFE380";
var $5e26c99fa43b3c99$export$5aae31392d72caaa = "#FFC400";
var $5e26c99fa43b3c99$export$c6930421db9fa514 = "#FFAB00";
var $5e26c99fa43b3c99$export$59619663aa6500fb = "#FF991F";
var $5e26c99fa43b3c99$export$874739ea9e379ab6 = "#FF8B00";
var $5e26c99fa43b3c99$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $5e26c99fa43b3c99$export$69a3bf21b9686c2b = "#ABF5D1";
var $5e26c99fa43b3c99$export$afbce1382ec95f73 = "#79F2C0";
var $5e26c99fa43b3c99$export$747d86715d4175de = "#57D9A3";
var $5e26c99fa43b3c99$export$940e1f69e873f202 = "#36B37E";
var $5e26c99fa43b3c99$export$a49394138f7b8e85 = "#00875A";
var $5e26c99fa43b3c99$export$6fa04827ac68a4fb = "#006644";
var $5e26c99fa43b3c99$export$226de0355ed012f8 = "#DEEBFF";
var $5e26c99fa43b3c99$export$8c13c2ee36917869 = "#B3D4FF";
var $5e26c99fa43b3c99$export$ecfc1dff386a3e7a = "#4C9AFF";
var $5e26c99fa43b3c99$export$215b7063051591f1 = "#2684FF";
var $5e26c99fa43b3c99$export$e62e8919cca44969 = "#0065FF";
var $5e26c99fa43b3c99$export$b3de0ae08da2ce64 = "#0052CC";
var $5e26c99fa43b3c99$export$a6ee3d71bc067634 = "#0747A6";
var $5e26c99fa43b3c99$export$363e4475840015bb = "#EAE6FF";
var $5e26c99fa43b3c99$export$4b0a4417ed59760f = "#C0B6F2";
var $5e26c99fa43b3c99$export$6011520a64d9a187 = "#998DD9";
var $5e26c99fa43b3c99$export$a7175d4e9206bc80 = "#8777D9";
var $5e26c99fa43b3c99$export$b48405b95304b5a1 = "#6554C0";
var $5e26c99fa43b3c99$export$c71e4279dd54a18d = "#5243AA";
var $5e26c99fa43b3c99$export$147899de772240ec = "#403294";
var $5e26c99fa43b3c99$export$2cf711fe14c66f06 = "#E6FCFF";
var $5e26c99fa43b3c99$export$7a8f4d33f6f9772c = "#B3F5FF";
var $5e26c99fa43b3c99$export$776c9c497ef08533 = "#79E2F2";
var $5e26c99fa43b3c99$export$69cb3ca10c1e330e = "#00C7E6";
var $5e26c99fa43b3c99$export$9dc1ef0f3f48059b = "#00B8D9";
var $5e26c99fa43b3c99$export$7c835c78b6fcdef8 = "#00A3BF";
var $5e26c99fa43b3c99$export$6036577f95c3877e = "#008DA6";
var $5e26c99fa43b3c99$export$29a4f05edc054374 = "#FFFFFF";
var $5e26c99fa43b3c99$export$e655ef011c4aa1a2 = "#FAFBFC";
var $5e26c99fa43b3c99$export$9fdfb749e33cdf97 = "#F4F5F7";
var $5e26c99fa43b3c99$export$3e51e8f1440314ba = "#EBECF0";
var $5e26c99fa43b3c99$export$1ce2d1575d444ceb = "#DFE1E6";
var $5e26c99fa43b3c99$export$8754fc7e6d8b3000 = "#C1C7D0";
var $5e26c99fa43b3c99$export$c2e91cbeada39b8b = "#B3BAC5";
var $5e26c99fa43b3c99$export$5f71e19f3a7ad9de = "#A5ADBA";
var $5e26c99fa43b3c99$export$eaa8c8a70ac22806 = "#97A0AF";
var $5e26c99fa43b3c99$export$7c87d337fb91a97d = "#8993A4";
var $5e26c99fa43b3c99$export$d6447c357493214f = "#7A869A";
var $5e26c99fa43b3c99$export$f563ee71e9ee74cd = "#6B778C";
var $5e26c99fa43b3c99$export$e2ef2124cf4024b1 = "#5E6C84";
var $5e26c99fa43b3c99$export$eece5f492e429f08 = "#505F79";
var $5e26c99fa43b3c99$export$c39c0fe0f26207ae = "#42526E";
var $5e26c99fa43b3c99$export$7090862dc3038a9f = "#344563";
var $5e26c99fa43b3c99$export$ad0bacf983b7ddaa = "#253858";
var $5e26c99fa43b3c99$export$7d61b15e0da132af = "#172B4D";
var $5e26c99fa43b3c99$export$fbda843f0a27fe96 = "#091E42";
var $5e26c99fa43b3c99$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $5e26c99fa43b3c99$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $5e26c99fa43b3c99$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $5e26c99fa43b3c99$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $5e26c99fa43b3c99$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $5e26c99fa43b3c99$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $5e26c99fa43b3c99$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $5e26c99fa43b3c99$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $5e26c99fa43b3c99$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $5e26c99fa43b3c99$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $5e26c99fa43b3c99$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $5e26c99fa43b3c99$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $5e26c99fa43b3c99$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $5e26c99fa43b3c99$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $5e26c99fa43b3c99$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $5e26c99fa43b3c99$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $5e26c99fa43b3c99$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $5e26c99fa43b3c99$export$2f6319cf7d736c2a = "#E6EDFA";
var $5e26c99fa43b3c99$export$95126bc8884d6634 = "#DCE5F5";
var $5e26c99fa43b3c99$export$8338d8c35d44ff1 = "#CED9EB";
var $5e26c99fa43b3c99$export$5368d76ae4fbbda7 = "#B8C7E0";
var $5e26c99fa43b3c99$export$9f0a771d16ec8d36 = "#ABBBD6";
var $5e26c99fa43b3c99$export$abcf8c38338b4aa5 = "#9FB0CC";
var $5e26c99fa43b3c99$export$97e81faa16a182c7 = "#8C9CB8";
var $5e26c99fa43b3c99$export$bfe21c59123ecf33 = "#7988A3";
var $5e26c99fa43b3c99$export$ee82aa2ea6a1558 = "#67758F";
var $5e26c99fa43b3c99$export$682927c6ed76be02 = "#56637A";
var $5e26c99fa43b3c99$export$91fd9994c5be9757 = "#455166";
var $5e26c99fa43b3c99$export$d281fbfe3cff2df6 = "#3B475C";
var $5e26c99fa43b3c99$export$3902c91d8b98a753 = "#313D52";
var $5e26c99fa43b3c99$export$8e8133c1ba5845b5 = "#283447";
var $5e26c99fa43b3c99$export$33ff357f6620b39 = "#202B3D";
var $5e26c99fa43b3c99$export$633847cf062b69e0 = "#1B2638";
var $5e26c99fa43b3c99$export$9776a6e503bdbf76 = "#121A29";
var $5e26c99fa43b3c99$export$6c813d5160dff5db = "#0E1624";
var $5e26c99fa43b3c99$export$3d4f271a500072a = "#0D1424";
var $5e26c99fa43b3c99$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $5e26c99fa43b3c99$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $5e26c99fa43b3c99$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $5e26c99fa43b3c99$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $5e26c99fa43b3c99$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $5e26c99fa43b3c99$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $5e26c99fa43b3c99$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $5e26c99fa43b3c99$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $5e26c99fa43b3c99$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $5e26c99fa43b3c99$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $5e26c99fa43b3c99$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $5e26c99fa43b3c99$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $5e26c99fa43b3c99$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $5e26c99fa43b3c99$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $5e26c99fa43b3c99$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $5e26c99fa43b3c99$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $5e26c99fa43b3c99$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $5e26c99fa43b3c99$export$8ce1fd94bee2f412 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($5e26c99fa43b3c99$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($5e26c99fa43b3c99$export$633847cf062b69e0, ")")
});
var $5e26c99fa43b3c99$export$b861914ea877b580 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($5e26c99fa43b3c99$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($5e26c99fa43b3c99$export$8c13c2ee36917869, ")")
});
var $5e26c99fa43b3c99$export$3f1b020df94387af = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($5e26c99fa43b3c99$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($5e26c99fa43b3c99$export$d281fbfe3cff2df6, ")")
});
var $5e26c99fa43b3c99$export$c0183dbab98ca63e = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($5e26c99fa43b3c99$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($5e26c99fa43b3c99$export$8e8133c1ba5845b5, ")")
});
var $5e26c99fa43b3c99$export$6f093cfa640b7166 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($5e26c99fa43b3c99$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($5e26c99fa43b3c99$export$5368d76ae4fbbda7, ")")
});
var $5e26c99fa43b3c99$export$42f8e9c698766e7a = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($5e26c99fa43b3c99$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5e26c99fa43b3c99$export$5368d76ae4fbbda7, ")")
});
var $5e26c99fa43b3c99$export$c2d157ca1c34b6e3 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($5e26c99fa43b3c99$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($5e26c99fa43b3c99$export$b3de0ae08da2ce64, ")")
});
var $5e26c99fa43b3c99$export$1905ba28d7cf066f = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($5e26c99fa43b3c99$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5e26c99fa43b3c99$export$97e81faa16a182c7, ")")
});
var $5e26c99fa43b3c99$export$bd9002130d306d39 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($5e26c99fa43b3c99$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5e26c99fa43b3c99$export$bfe21c59123ecf33, ")")
});
var $5e26c99fa43b3c99$export$46e4a324ac90507f = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($5e26c99fa43b3c99$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5e26c99fa43b3c99$export$5368d76ae4fbbda7, ")")
});
var $5e26c99fa43b3c99$export$79f3f2b82beb0d36 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($5e26c99fa43b3c99$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5e26c99fa43b3c99$export$97e81faa16a182c7, ")")
});
var $5e26c99fa43b3c99$export$7bb0d5c671655cc4 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$9fdfb749e33cdf97,
    dark: $5e26c99fa43b3c99$export$8e8133c1ba5845b5
});
var $5e26c99fa43b3c99$export$9c30223ca0a664fb = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($5e26c99fa43b3c99$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($5e26c99fa43b3c99$export$ecfc1dff386a3e7a, ")")
});
var $5e26c99fa43b3c99$export$7ed258b0728b004b = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($5e26c99fa43b3c99$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($5e26c99fa43b3c99$export$215b7063051591f1, ")")
});
var $5e26c99fa43b3c99$export$dfa920d8decc8a59 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($5e26c99fa43b3c99$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($5e26c99fa43b3c99$export$ecfc1dff386a3e7a, ")")
});
var $5e26c99fa43b3c99$export$6069e6ad5c78f632 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($5e26c99fa43b3c99$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($5e26c99fa43b3c99$export$215b7063051591f1, ")")
});
var $5e26c99fa43b3c99$export$9ad721cf3b3debe0 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($5e26c99fa43b3c99$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($5e26c99fa43b3c99$export$ecfc1dff386a3e7a, ")")
});
var $5e26c99fa43b3c99$export$2aa0182783e7e9de = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$b3de0ae08da2ce64,
    dark: $5e26c99fa43b3c99$export$ecfc1dff386a3e7a
});
var $5e26c99fa43b3c99$export$8bf7dff220b82b4a = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$9dc1ef0f3f48059b,
    dark: $5e26c99fa43b3c99$export$69cb3ca10c1e330e
});
var $5e26c99fa43b3c99$export$e13cce2a2d16a9d4 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$b48405b95304b5a1,
    dark: $5e26c99fa43b3c99$export$6011520a64d9a187
});
var $5e26c99fa43b3c99$export$a90204d1394caf30 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$4a7404f376229999,
    dark: $5e26c99fa43b3c99$export$4a7404f376229999
});
var $5e26c99fa43b3c99$export$594c5a8758200c32 = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$c6930421db9fa514,
    dark: $5e26c99fa43b3c99$export$c6930421db9fa514
});
var $5e26c99fa43b3c99$export$955a2ebd2fb142ae = (0, $ec193d4a64f1a172$export$2e2bcd8739ae039)({
    light: $5e26c99fa43b3c99$export$940e1f69e873f202,
    dark: $5e26c99fa43b3c99$export$940e1f69e873f202
});
var $5e26c99fa43b3c99$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($5e26c99fa43b3c99$export$8d43898f60b96a82, ")");
};



var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $77dbe26168790d25$var$n = function(t, e) {
    return ($77dbe26168790d25$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    })(t, e);
};
var $77dbe26168790d25$var$o, $77dbe26168790d25$var$r, $77dbe26168790d25$var$i = (function(t) {
    /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
        var e = {}.hasOwnProperty;
        function n() {
            for(var t = [], o = 0; o < arguments.length; o++){
                var r = arguments[o];
                if (r) {
                    var i = typeof r;
                    if ("string" === i || "number" === i) t.push(r);
                    else if (Array.isArray(r) && r.length) {
                        var s = n.apply(null, r);
                        s && t.push(s);
                    } else if ("object" === i) for(var l in r)e.call(r, l) && r[l] && t.push(l);
                }
            }
            return t.join(" ");
        }
        t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    }();
}($77dbe26168790d25$var$r = {
    path: $77dbe26168790d25$var$o,
    exports: {},
    require: function(t, e) {
        return function() {
            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == e && $77dbe26168790d25$var$r.path);
    }
}, $77dbe26168790d25$var$r.exports), $77dbe26168790d25$var$r.exports);
function $77dbe26168790d25$var$s(t, e, n) {
    var o, r, i, s, l;
    function a() {
        var c = Date.now() - s;
        c < e && c >= 0 ? o = setTimeout(a, e - c) : (o = null, n || (l = t.apply(i, r), i = r = null));
    }
    null == e && (e = 100);
    var c = function() {
        i = this, r = arguments, s = Date.now();
        var c = n && !o;
        return o || (o = setTimeout(a, e)), c && (l = t.apply(i, r), i = r = null), l;
    };
    return c.clear = function() {
        o && (clearTimeout(o), o = null);
    }, c.flush = function() {
        o && (l = t.apply(i, r), i = r = null, clearTimeout(o), o = null);
    }, c;
}
$77dbe26168790d25$var$s.debounce = $77dbe26168790d25$var$s;
var $77dbe26168790d25$var$l = $77dbe26168790d25$var$s;
!function(t, e) {
    void 0 === e && (e = {});
    var n = e.insertAt;
    if (t && "undefined" != typeof document) {
        var o = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
        r.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
}(".indiana-scroll-container {\n  overflow: auto;\n}\n.indiana-scroll-container--dragging {\n  scroll-behavior: auto !important;\n}\n.indiana-scroll-container--dragging > * {\n  pointer-events: none;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.indiana-scroll-container--hide-scrollbars {\n  overflow: hidden;\n  overflow: -moz-scrollbars-none;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n  display: none !important;\n  height: 0 !important;\n  width: 0 !important;\n  background: transparent !important;\n  -webkit-appearance: none !important;\n}\n.indiana-scroll-container--native-scroll {\n  overflow: auto;\n}\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab;\n}");
var $77dbe26168790d25$var$a, $77dbe26168790d25$var$c = ($77dbe26168790d25$var$a = "indiana-scroll-container", function(t, e) {
    if (!t) return $77dbe26168790d25$var$a;
    var n;
    "string" == typeof t ? n = t : e = t;
    var o = $77dbe26168790d25$var$a;
    return n && (o += "__" + n), o + (e ? Object.keys(e).reduce(function(t, n) {
        var r = e[n];
        return r && (t += " " + ("boolean" == typeof r ? o + "--" + n : o + "--" + n + "_" + r)), t;
    }, "") : "");
}), $77dbe26168790d25$var$p = function(e) {
    function o(n) {
        var o = e.call(this, n) || this;
        return o.onEndScroll = function() {
            o.scrolling = !1, !o.pressed && o.started && o.processEnd();
        }, o.onScroll = function(t) {
            var e = o.container.current;
            e.scrollLeft === o.scrollLeft && e.scrollTop === o.scrollTop || (o.scrolling = !0, o.processScroll(t), o.onEndScroll());
        }, o.onTouchStart = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.isDraggable(t.target)) {
                if (o.internal = !0, e && o.scrolling) o.pressed = !0;
                else {
                    var n = t.touches[0];
                    o.processClick(t, n.clientX, n.clientY), !e && o.props.stopPropagation && t.stopPropagation();
                }
            }
        }, o.onTouchEnd = function(t) {
            var e = o.props.nativeMobileScroll;
            o.pressed && (!o.started || o.scrolling && e ? o.pressed = !1 : o.processEnd(), o.forceUpdate());
        }, o.onTouchMove = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.pressed && (!e || !o.isMobile)) {
                var n = t.touches[0];
                n && o.processMove(t, n.clientX, n.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation();
            }
        }, o.onMouseDown = function(t) {
            o.isDraggable(t.target) && o.isScrollable() && (o.internal = !0, -1 !== o.props.buttons.indexOf(t.button) && (o.processClick(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation()));
        }, o.onMouseMove = function(t) {
            o.pressed && (o.processMove(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.onMouseUp = function(t) {
            o.pressed && (o.started ? o.processEnd() : (o.internal = !1, o.pressed = !1, o.forceUpdate(), o.props.onClick && o.props.onClick(t)), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.container = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(), o.onEndScroll = $77dbe26168790d25$var$l(o.onEndScroll, 300), o.scrolling = !1, o.started = !1, o.pressed = !1, o.internal = !1, o.getRef = o.getRef.bind(o), o;
    }
    return function(t, e) {
        function o() {
            this.constructor = t;
        }
        $77dbe26168790d25$var$n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o);
    }(o, e), o.prototype.componentDidMount = function() {
        var t = this.props.nativeMobileScroll, e = this.container.current;
        window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), window.addEventListener("touchend", this.onTouchEnd), e.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), e.addEventListener("mousedown", this.onMouseDown, {
            passive: !1
        }), t && (this.isMobile = this.isMobileDevice(), this.isMobile && this.forceUpdate());
    }, o.prototype.componentWillUnmount = function() {
        window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
    }, o.prototype.getElement = function() {
        return this.container.current;
    }, o.prototype.isMobileDevice = function() {
        return void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile");
    }, o.prototype.isDraggable = function(t) {
        var e = this.props.ignoreElements;
        if (e) {
            var n = t.closest(e);
            return null === n || n.contains(this.getElement());
        }
        return !0;
    }, o.prototype.isScrollable = function() {
        var t = this.container.current;
        return t && (t.scrollWidth > t.clientWidth || t.scrollHeight > t.clientHeight);
    }, o.prototype.processClick = function(t, e, n) {
        var o = this.container.current;
        this.scrollLeft = o.scrollLeft, this.scrollTop = o.scrollTop, this.clientX = e, this.clientY = n, this.pressed = !0;
    }, o.prototype.processStart = function(t) {
        void 0 === t && (t = !0);
        var e = this.props.onStartScroll;
        this.started = !0, t && document.body.classList.add("indiana-dragging"), e && e({
            external: !this.internal
        }), this.forceUpdate();
    }, o.prototype.processScroll = function(t) {
        if (this.started) {
            var e = this.props.onScroll;
            e && e({
                external: !this.internal
            });
        } else this.processStart(!1);
    }, o.prototype.processMove = function(t, e, n) {
        var o = this.props, r = o.horizontal, i = o.vertical, s = o.activationDistance, l = o.onScroll, a = this.container.current;
        this.started ? (r && (a.scrollLeft -= e - this.clientX), i && (a.scrollTop -= n - this.clientY), l && l({
            external: !this.internal
        }), this.clientX = e, this.clientY = n, this.scrollLeft = a.scrollLeft, this.scrollTop = a.scrollTop) : (r && Math.abs(e - this.clientX) > s || i && Math.abs(n - this.clientY) > s) && (this.clientX = e, this.clientY = n, this.processStart());
    }, o.prototype.processEnd = function() {
        var t = this.props.onEndScroll;
        this.container.current && t && t({
            external: !this.internal
        }), this.pressed = !1, this.started = !1, this.scrolling = !1, this.internal = !1, document.body.classList.remove("indiana-dragging"), this.forceUpdate();
    }, o.prototype.getRef = function(t) {
        [
            this.container,
            this.props.innerRef
        ].forEach(function(e) {
            e && ("function" == typeof e ? e(t) : e.current = t);
        });
    }, o.prototype.render = function() {
        var e = this.props, n = e.children, o = e.draggingClassName, r = e.className, s = e.style, l = e.hideScrollbars, a = e.component;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(a, {
            className: $77dbe26168790d25$var$i(r, this.pressed && o, $77dbe26168790d25$var$c({
                dragging: this.pressed,
                "hide-scrollbars": l,
                "native-scroll": this.isMobile
            })),
            style: s,
            ref: this.getRef,
            onScroll: this.onScroll
        }, n);
    }, o.defaultProps = {
        nativeMobileScroll: !0,
        hideScrollbars: !0,
        activationDistance: 10,
        vertical: !0,
        horizontal: !0,
        stopPropagation: !1,
        style: {},
        component: "div",
        buttons: [
            0
        ]
    }, o;
}((0, $acw62.PureComponent));
var $77dbe26168790d25$export$2e2bcd8739ae039 = $77dbe26168790d25$var$p;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d9f9c3011f2b7f78$var$ATOMIC_GROUP_LENGTH = 5;
function $d9f9c3011f2b7f78$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $d9f9c3011f2b7f78$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("acw62");

const $df4eda72eed2361a$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $df4eda72eed2361a$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



var $luEYg = parcelRequire("luEYg");
const $19895ff4a3bbc528$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $luEYg.default)(actualStyles);
};


function $4e07e52f103fa507$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $df4eda72eed2361a$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $df4eda72eed2361a$export$c4df1cb0c2b4d77c)();
        },
        cx: $19895ff4a3bbc528$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $df4eda72eed2361a$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $66d7dbe9bd15c487$var$strictApi = (0, $4e07e52f103fa507$export$39716b4af53f4ad)();
var $66d7dbe9bd15c487$export$dbf350e5966cf602 = $66d7dbe9bd15c487$var$strictApi.css;
var $66d7dbe9bd15c487$export$eb1ecd84a24ee424 = $66d7dbe9bd15c487$var$strictApi.cssMap;
$66d7dbe9bd15c487$var$strictApi.cssMap;
var $66d7dbe9bd15c487$export$a274e22fb40f762e = $66d7dbe9bd15c487$var$strictApi.cx;
var $66d7dbe9bd15c487$var$XCSSProp = $66d7dbe9bd15c487$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 



var $41YNz = parcelRequire("41YNz");
function $3d94fa6e7ae720e2$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") ref.current = value;
        });
    };
}




var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");
function $d9f258fd1a7d4ed3$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId().replace(/[:«»]/g, "_");
}
var $d9f258fd1a7d4ed3$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($d9f258fd1a7d4ed3$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $d9f258fd1a7d4ed3$export$6ee17796e3d70de2() {
    var uid = $d9f258fd1a7d4ed3$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}



var $ltooA = parcelRequire("ltooA");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


const $1e29e4cf6621ab38$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)(actualStyles);
};



function $0ef728659bef6f62$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_userAgentData = window.navigator["userAgentData"]) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $0ef728659bef6f62$var$isIPhone() {
    return $0ef728659bef6f62$var$testPlatform(/^iPhone/i);
}
function $0ef728659bef6f62$var$isMac() {
    return $0ef728659bef6f62$var$testPlatform(/^Mac/i);
}
function $0ef728659bef6f62$var$isIPad() {
    return $0ef728659bef6f62$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $0ef728659bef6f62$var$isMac() && navigator.maxTouchPoints > 1;
}
function $0ef728659bef6f62$var$isIOS() {
    return $0ef728659bef6f62$var$isIPhone() || $0ef728659bef6f62$var$isIPad();
}
function $0ef728659bef6f62$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $0ef728659bef6f62$export$e1865c3bedcd822b() {
    return $0ef728659bef6f62$var$isMac() || $0ef728659bef6f62$var$isIOS();
}




/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ab5e3b7f09ea4bde$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $ab5e3b7f09ea4bde$var$_excluded2 = [
    "className"
];
var $ab5e3b7f09ea4bde$var$focusRingStyles = null;
var $ab5e3b7f09ea4bde$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $ab5e3b7f09ea4bde$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $ab5e3b7f09ea4bde$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $ab5e3b7f09ea4bde$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $ab5e3b7f09ea4bde$export$2e2bcd8739ae039 = $ab5e3b7f09ea4bde$var$Focusable;


var $1a88c5a71819b8bd$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $1a88c5a71819b8bd$var$_excluded2 = [
    "className"
];
var $1a88c5a71819b8bd$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $1a88c5a71819b8bd$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $1a88c5a71819b8bd$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $7d8cdc11b4cca0f3$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $8efc87d23c89e055$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $1a88c5a71819b8bd$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $ab5e3b7f09ea4bde$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $0ef728659bef6f62$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $1e29e4cf6621ab38$export$a274e22fb40f762e)($1a88c5a71819b8bd$var$styles.root, isDisabled && $1a88c5a71819b8bd$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $1a88c5a71819b8bd$export$2e2bcd8739ae039 = $1a88c5a71819b8bd$var$Pressable;




var $acw62 = parcelRequire("acw62");
var $e45135e4a17a4e20$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e45135e4a17a4e20$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $acw62.useContext)($e45135e4a17a4e20$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $fc5a776b2e526f67$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $fc5a776b2e526f67$var$tabKeyCode = 9;
function $fc5a776b2e526f67$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $fc5a776b2e526f67$var$tabKeyCode) return;
    $fc5a776b2e526f67$var$abort(event);
}
function $fc5a776b2e526f67$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $fc5a776b2e526f67$var$abort,
        onMouseUpCapture: $fc5a776b2e526f67$var$abort,
        onKeyDownCapture: $fc5a776b2e526f67$var$onKey,
        onKeyUpCapture: $fc5a776b2e526f67$var$onKey,
        onTouchStartCapture: $fc5a776b2e526f67$var$abort,
        onTouchEndCapture: $fc5a776b2e526f67$var$abort,
        onPointerDownCapture: $fc5a776b2e526f67$var$abort,
        onPointerUpCapture: $fc5a776b2e526f67$var$abort,
        onClickCapture: $fc5a776b2e526f67$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $fc5a776b2e526f67$var$abort
    } : events;
}



var $acw62 = parcelRequire("acw62");

function $4ea1a863d99fdf59$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $4ea1a863d99fdf59$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $4ea1a863d99fdf59$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c3a131b51868ea06$export$2e2bcd8739ae039), {
        size: $4ea1a863d99fdf59$var$getIconSpacing(spacing),
        appearance: $4ea1a863d99fdf59$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $26dbdd082a36bf03$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $26dbdd082a36bf03$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $26dbdd082a36bf03$var$LOADING_LABEL = ", Loading";
var $26dbdd082a36bf03$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $26dbdd082a36bf03$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $26dbdd082a36bf03$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $26dbdd082a36bf03$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $26dbdd082a36bf03$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $26dbdd082a36bf03$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $26dbdd082a36bf03$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $26dbdd082a36bf03$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $26dbdd082a36bf03$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $26dbdd082a36bf03$var$_excluded);
    var localRef = (0, $acw62.useRef)(null);
    var splitButtonContext = (0, $e45135e4a17a4e20$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $d9f258fd1a7d4ed3$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $379a1b97918ecb31$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $26dbdd082a36bf03$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a88c5a71819b8bd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $3d94fa6e7ae720e2$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $66d7dbe9bd15c487$export$a274e22fb40f762e)($26dbdd082a36bf03$var$styles.base, (0, $ltooA.fg)("platform-dst-shape-theme-default") && $26dbdd082a36bf03$var$styles.baseT26Shape, appearance === "default" && $26dbdd082a36bf03$var$defaultStyles.root, appearance === "default" && isInteractive && $26dbdd082a36bf03$var$defaultStyles.interactive, appearance === "primary" && $26dbdd082a36bf03$var$primaryStyles.root, appearance === "primary" && isInteractive && $26dbdd082a36bf03$var$primaryStyles.interactive, appearance === "warning" && $26dbdd082a36bf03$var$warningStyles.root, appearance === "warning" && isInteractive && $26dbdd082a36bf03$var$warningStyles.interactive, appearance === "danger" && $26dbdd082a36bf03$var$dangerStyles.root, appearance === "danger" && isInteractive && $26dbdd082a36bf03$var$dangerStyles.interactive, appearance === "discovery" && $26dbdd082a36bf03$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $26dbdd082a36bf03$var$discoveryStyles.interactive, appearance === "subtle" && $26dbdd082a36bf03$var$subtleStyles.root, appearance === "subtle" && isInteractive && $26dbdd082a36bf03$var$subtleStyles.interactive, $26dbdd082a36bf03$var$styles.linkDecorationUnset, isSelected && $26dbdd082a36bf03$var$selectedStyles.root, isSelected && isSplitButton && $26dbdd082a36bf03$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $26dbdd082a36bf03$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $26dbdd082a36bf03$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $26dbdd082a36bf03$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $26dbdd082a36bf03$var$selectedStyles.discovery, isDisabled && $26dbdd082a36bf03$var$styles.disabled, isDisabled && appearance !== "default" && appearance !== "subtle" && $26dbdd082a36bf03$var$styles.sharedDisabled, isDisabled && appearance === "default" && $26dbdd082a36bf03$var$defaultStyles.disabled, isCircle && !isSplitButton && $26dbdd082a36bf03$var$styles.circle, spacing === "compact" && $26dbdd082a36bf03$var$styles.spacingCompact, spacing === "compact" && (0, $ltooA.fg)("platform-dst-shape-theme-default") && $26dbdd082a36bf03$var$styles.spacingCompactT26Shape, shouldFitContainer && $26dbdd082a36bf03$var$styles.fullWidth, hasIconBefore && $26dbdd082a36bf03$var$styles.buttonIconBefore, hasIconAfter && $26dbdd082a36bf03$var$styles.buttonIconAfter, isIconButton && $26dbdd082a36bf03$var$styles.iconButton, isIconButton && spacing === "compact" && $26dbdd082a36bf03$var$styles.iconButtonCompact, isLoading && $26dbdd082a36bf03$var$styles.loading, isSplitButton && $26dbdd082a36bf03$var$styles.splitButton, isNavigationSplitButton && $26dbdd082a36bf03$var$styles.navigationSplitButton),
        isDisabled: (0, $ltooA.fg)("platform-dst_fix_not_focusable_loading_button") ? isDisabled : isEffectivelyDisabled
    }, (0, $ltooA.fg)("platform-dst_fix_not_focusable_loading_button") && {
        "aria-live": "polite"
    }, isLoading && (0, $ltooA.fg)("platform-dst_fix_not_focusable_loading_button") && {
        "aria-disabled": true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($26dbdd082a36bf03$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $fc5a776b2e526f67$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e45135e4a17a4e20$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            $26dbdd082a36bf03$var$styles.loadingOverlay
        ])
    }, (0, $4ea1a863d99fdf59$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d2c35c9b72bfde0$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $26dbdd082a36bf03$var$LOADING_LABEL)));
});
var $26dbdd082a36bf03$export$2e2bcd8739ae039 = $26dbdd082a36bf03$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $acw62 = parcelRequire("acw62");
var $4ec7edac2a9b0517$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $4ec7edac2a9b0517$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            $4ec7edac2a9b0517$var$styles.common,
            type === "text" && $4ec7edac2a9b0517$var$styles.text,
            type === "icon" && $4ec7edac2a9b0517$var$styles.icon,
            isLoading && $4ec7edac2a9b0517$var$styles.fade
        ])
    }, children);
};
var $4ec7edac2a9b0517$export$2e2bcd8739ae039 = $4ec7edac2a9b0517$var$Content;



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
function $15983b3b4480e4e1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $15983b3b4480e4e1$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $15983b3b4480e4e1$var$isIconRenderProp(Icon);
    var iconProps = {
        label: "",
        color: "currentColor",
        size: (0, $ltooA.fg)("platform_dst_button_chevron_sizing") ? function(iconName) {
            return iconName.startsWith("Chevron") ? "small" : "medium";
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, iconProps));
};
var $15983b3b4480e4e1$export$2e2bcd8739ae039 = $15983b3b4480e4e1$var$IconRenderer;


var $d309f9e104674c66$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $d309f9e104674c66$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $d309f9e104674c66$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d309f9e104674c66$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $d309f9e104674c66$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26dbdd082a36bf03$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ec7edac2a9b0517$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $15983b3b4480e4e1$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ec7edac2a9b0517$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ec7edac2a9b0517$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $15983b3b4480e4e1$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$d309f9e104674c66$var$Button.displayName = "Button";
var $d309f9e104674c66$export$2e2bcd8739ae039 = $d309f9e104674c66$var$Button;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


function $e2a6783643de8200$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2a6783643de8200$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2a6783643de8200$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2a6783643de8200$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e2a6783643de8200$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $f8837ccb4ede2bb3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $f05a12a6f1ef1d1b$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $f05a12a6f1ef1d1b$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e2a6783643de8200$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Character key codes which can be used in keyboard events.
 */ var $ce914f2f26a18903$export$390330c10ff2b9a1 = "ArrowUp";
var $ce914f2f26a18903$export$a80636c6f41931fe = "ArrowDown";
var $ce914f2f26a18903$export$fc4577f2a2af0ae3 = "ArrowLeft";
var $ce914f2f26a18903$export$c40f9845adc73fb5 = "ArrowRight";
var $ce914f2f26a18903$export$4af703091671bc = "Home";
var $ce914f2f26a18903$export$e2bc30913faa5db7 = "End";
var $ce914f2f26a18903$export$10f6869ed0a7d75b = "Tab";
var $ce914f2f26a18903$export$8152f929a25a0ff4 = "Enter";
var $ce914f2f26a18903$export$e51a3576c045c8d5 = "Space";
var $ce914f2f26a18903$export$2bb790b9008907b4 = "Escape";


function $5f3446c461420775$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $ce914f2f26a18903$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $8fY35.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $acw62 = parcelRequire("acw62");
function $18ac0aef6852b24e$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4249ce2deeecb21c$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $160ec28377e0a5a8$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $ac7e58db656d883b$export$1d57e79091cc3046() {
    var namespace = (0, $acw62.useContext)((0, $160ec28377e0a5a8$export$644a49f3b8c50fcd));
    return namespace;
}


function $1b77518667867a93$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $acw62.useContext)((0, $4249ce2deeecb21c$export$5fbf4d7fae6cdc00));
    var namespace = (0, $ac7e58db656d883b$export$1d57e79091cc3046)();
    (0, $acw62.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $68f31dfe991398b4$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $68f31dfe991398b4$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($68f31dfe991398b4$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $68f31dfe991398b4$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $68f31dfe991398b4$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($68f31dfe991398b4$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $68f31dfe991398b4$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $68f31dfe991398b4$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $68f31dfe991398b4$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $68f31dfe991398b4$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $68f31dfe991398b4$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $68f31dfe991398b4$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $68f31dfe991398b4$var$childrenToArray(previousChildren);
    var current = $68f31dfe991398b4$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $68f31dfe991398b4$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $68f31dfe991398b4$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $ltooA.fg)("platform-dst-motion-uplift") ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $68f31dfe991398b4$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $68f31dfe991398b4$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $68f31dfe991398b4$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($68f31dfe991398b4$var$ExitingContext);
};
$68f31dfe991398b4$var$ExitingPersistence.displayName = "ExitingPersistence";
var $68f31dfe991398b4$export$2e2bcd8739ae039 = $68f31dfe991398b4$var$ExitingPersistence;


var $acw62 = parcelRequire("acw62");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $30d8f60cf8810b4f$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $30d8f60cf8810b4f$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$30d8f60cf8810b4f$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $30d8f60cf8810b4f$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($30d8f60cf8810b4f$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$30d8f60cf8810b4f$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $30d8f60cf8810b4f$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $30d8f60cf8810b4f$export$ff7706047246b98b = function prefersReducedMotion() {
    return $30d8f60cf8810b4f$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $b95fa7fbd1c21a11$export$368bacef0dacbe05 = 25;
var $b95fa7fbd1c21a11$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $b95fa7fbd1c21a11$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $b95fa7fbd1c21a11$export$30fa1a2e62ae150c = {
    none: $b95fa7fbd1c21a11$export$38b928a7167ce124.none,
    small: $b95fa7fbd1c21a11$export$38b928a7167ce124.small * $b95fa7fbd1c21a11$var$EXITING_MOTION_MULTIPLIER,
    medium: $b95fa7fbd1c21a11$export$38b928a7167ce124.medium * $b95fa7fbd1c21a11$var$EXITING_MOTION_MULTIPLIER,
    large: $b95fa7fbd1c21a11$export$38b928a7167ce124.large * $b95fa7fbd1c21a11$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
// Handle both browser and Node.js environments
var $04c7406bb0fb4e05$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $04c7406bb0fb4e05$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $04c7406bb0fb4e05$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $04c7406bb0fb4e05$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $04c7406bb0fb4e05$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $ace8b1450fafe6cf$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $1dc34d7f236f92a1$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $b761c0fb46f1b524$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $232d11f435326a2b$export$2e2bcd8739ae039)
    };
});
var $b761c0fb46f1b524$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $1dc34d7f236f92a1$export$c485849f2e393253)();
    var context = (0, $acw62.useContext)($b761c0fb46f1b524$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $b761c0fb46f1b524$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $ace8b1450fafe6cf$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b761c0fb46f1b524$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $b761c0fb46f1b524$export$2e2bcd8739ae039 = $b761c0fb46f1b524$var$StaggeredEntrance;


var $ba4445ce99f58436$var$zoomIn = null;
var $ba4445ce99f58436$var$zoomOut = null;
var $ba4445ce99f58436$var$fadeIn = null;
var $ba4445ce99f58436$var$fadeOut = null;
var $ba4445ce99f58436$var$fadeInFromTop = null;
var $ba4445ce99f58436$var$fadeOutFromTop = null;
var $ba4445ce99f58436$var$fadeInFromLeft = null;
var $ba4445ce99f58436$var$fadeOutFromLeft = null;
var $ba4445ce99f58436$var$fadeInFromBottom = null;
var $ba4445ce99f58436$var$fadeOutFromBottom = null;
var $ba4445ce99f58436$var$fadeInFromRight = null;
var $ba4445ce99f58436$var$fadeOutFromRight = null;
var $ba4445ce99f58436$var$fadeInFromTopConstant = null;
var $ba4445ce99f58436$var$fadeOutFromTopConstant = null;
var $ba4445ce99f58436$var$fadeInFromLeftConstant = null;
var $ba4445ce99f58436$var$fadeOutFromLeftConstant = null;
var $ba4445ce99f58436$var$fadeInFromBottomConstant = null;
var $ba4445ce99f58436$var$fadeOutFromBottomConstant = null;
var $ba4445ce99f58436$var$fadeInFromRightConstant = null;
var $ba4445ce99f58436$var$fadeOutFromRightConstant = null;
var $ba4445ce99f58436$var$slideInFromTop = null;
var $ba4445ce99f58436$var$slideOutFromTop = null;
var $ba4445ce99f58436$var$slideInFromRight = null;
var $ba4445ce99f58436$var$slideOutFromRight = null;
var $ba4445ce99f58436$var$slideInFromBottom = null;
var $ba4445ce99f58436$var$slideOutFromBottom = null;
var $ba4445ce99f58436$var$slideInFromLeft = null;
var $ba4445ce99f58436$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $ba4445ce99f58436$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $b761c0fb46f1b524$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $68f31dfe991398b4$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $04c7406bb0fb4e05$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $30d8f60cf8810b4f$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $b95fa7fbd1c21a11$export$30fa1a2e62ae150c)[duration] : (0, $b95fa7fbd1c21a11$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-40-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === "ease-in-60-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === "ease-in-80-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-40-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-60-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-80-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $ba4445ce99f58436$export$2e2bcd8739ae039 = $ba4445ce99f58436$var$EnteringMotion;


var $d8eaeca19d2625b4$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $d8eaeca19d2625b4$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $d8eaeca19d2625b4$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba4445ce99f58436$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $d8eaeca19d2625b4$export$2e2bcd8739ae039 = $d8eaeca19d2625b4$var$FadeIn;



var $ltooA = parcelRequire("ltooA");

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $02Ztr = parcelRequire("02Ztr");
function $3f213747921aaaf1$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $31f4eab41b02ceca$var$viewportPadding = 5;
var $31f4eab41b02ceca$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $31f4eab41b02ceca$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $31f4eab41b02ceca$var$defaultChildrenFn() {
    return null;
}
var $31f4eab41b02ceca$var$defaultOffset = [
    0,
    8
];
function $31f4eab41b02ceca$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $31f4eab41b02ceca$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $31f4eab41b02ceca$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $31f4eab41b02ceca$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $3f213747921aaaf1$export$6d8c2b45c99d6e3f)({
            viewportPadding: $31f4eab41b02ceca$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($31f4eab41b02ceca$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4fec27400925987$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $fOd0O = parcelRequire("fOd0O");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");


var $h1Oiy = parcelRequire("h1Oiy");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $g5Zhu = parcelRequire("g5Zhu");

var $ltooA = parcelRequire("ltooA");

var $f5kcw = parcelRequire("f5kcw");

var $ahbug = parcelRequire("ahbug");

var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $ahbug = parcelRequire("ahbug");
var $798155133287dc08$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape",
    "motion"
];
var $798155133287dc08$var$customThemeOptions = "UNSAFE_themeOptions";
var $798155133287dc08$var$isThemeKind = function isThemeKind(themeKind) {
    return $798155133287dc08$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $798155133287dc08$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $ahbug.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $798155133287dc08$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $798155133287dc08$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ")// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $798155133287dc08$var$isColorMode(id)) themeObject[kind] = id;
        if ($798155133287dc08$var$isThemeKind(kind) && $798155133287dc08$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $798155133287dc08$var$customThemeOptions) try {
            themeObject[$798155133287dc08$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $798155133287dc08$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $798155133287dc08$var$isColorMode(id) || // custom theme state
        kind === $798155133287dc08$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $798155133287dc08$var$isThemeKind(kind) && typeof id === "string" && $798155133287dc08$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};



var $9W3Vk = parcelRequire("9W3Vk");

var $h5UgX = parcelRequire("h5UgX");
function $c8c3a099b7b5a9bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8c3a099b7b5a9bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8c3a099b7b5a9bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8c3a099b7b5a9bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c8c3a099b7b5a9bc$var$defaultColorMode = "light";
var $c8c3a099b7b5a9bc$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $c8c3a099b7b5a9bc$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $ahbug.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $ahbug.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $ahbug.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $ahbug.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $ahbug.themeStateDefaults)["motion"]() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $ahbug.themeStateDefaults)["shape"]() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $ahbug.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $ahbug.themeStateDefaults)["typography"] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $ahbug.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $798155133287dc08$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $f5kcw.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $f5kcw.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $c8c3a099b7b5a9bc$var$defaultColorMode : colorMode);
    if ((0, $ltooA.fg)("platform_increased-contrast-themes")) result = $c8c3a099b7b5a9bc$var$_objectSpread($c8c3a099b7b5a9bc$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $f5kcw.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $c8c3a099b7b5a9bc$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $9W3Vk.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $h5UgX.hash)(optionString);
        result[0, $f5kcw.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $c8c3a099b7b5a9bc$export$2e2bcd8739ae039 = $c8c3a099b7b5a9bc$var$getThemeHtmlAttrs;


var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");

var $g5Zhu = parcelRequire("g5Zhu");

var $f5kcw = parcelRequire("f5kcw");

var $ahbug = parcelRequire("ahbug");

function $eca55eb8615bcf3e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eca55eb8615bcf3e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eca55eb8615bcf3e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eca55eb8615bcf3e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eca55eb8615bcf3e$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $ahbug.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $eca55eb8615bcf3e$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $f5kcw.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $f5kcw.THEME_DATA_ATTRIBUTE)) || "";
    return $eca55eb8615bcf3e$var$_objectSpread($eca55eb8615bcf3e$var$_objectSpread({}, (0, $798155133287dc08$export$f19b488f7c0547ee)(theme)), $eca55eb8615bcf3e$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $eca55eb8615bcf3e$export$2e2bcd8739ae039 = $eca55eb8615bcf3e$var$getGlobalTheme;



var $ahbug = parcelRequire("ahbug");

var $9W3Vk = parcelRequire("9W3Vk");

var $02Ztr = parcelRequire("02Ztr");

var $ltooA = parcelRequire("ltooA");


var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $f5kcw = parcelRequire("f5kcw");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $f6fae66094c18304$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("8kb6x"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("6nlZT"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("jK9WO"));
    },
    "dark": function dark() {
        return (parcelRequire("8QWPm"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("1946u"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("hPYcV"));
    },
    "spacing": function spacing() {
        return (parcelRequire("ijsTl"));
    },
    "typography": function typography() {
        return (parcelRequire("elFhU"));
    },
    "shape": function shape() {
        return (parcelRequire("4M54S"));
    },
    "motion": function motion() {
        return (parcelRequire("UibT8"));
    }
};
var $f6fae66094c18304$export$2e2bcd8739ae039 = $f6fae66094c18304$var$themeImportsMap;



var $f5kcw = parcelRequire("f5kcw");
var $487074ac5b1ae9b1$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $f5kcw.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $f5kcw.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $487074ac5b1ae9b1$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $487074ac5b1ae9b1$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $f6fae66094c18304$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $487074ac5b1ae9b1$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $487074ac5b1ae9b1$export$8662df6937d86fcb = "(prefers-contrast: more)";


var $84bca69d8f2fd5f0$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $84bca69d8f2fd5f0$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $f5kcw.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $84bca69d8f2fd5f0$var$darkModeMql = $84bca69d8f2fd5f0$var$isMatchMediaAvailable && window.matchMedia((0, $487074ac5b1ae9b1$export$bb1e815119d30f8b));
var $84bca69d8f2fd5f0$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$84bca69d8f2fd5f0$var$darkModeMql) return "light";
                return $84bca69d8f2fd5f0$var$darkModeMql !== null && $84bca69d8f2fd5f0$var$darkModeMql !== void 0 && $84bca69d8f2fd5f0$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($84bca69d8f2fd5f0$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $8fY35.bind)($84bca69d8f2fd5f0$var$darkModeMql, {
                    type: "change",
                    listener: $84bca69d8f2fd5f0$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $84bca69d8f2fd5f0$var$SingletonColorModeObserver = new $84bca69d8f2fd5f0$var$ColorModeObserver();
var $84bca69d8f2fd5f0$export$2e2bcd8739ae039 = $84bca69d8f2fd5f0$var$SingletonColorModeObserver;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $f5kcw = parcelRequire("f5kcw");

var $d5115bbc651f62ba$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $d5115bbc651f62ba$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $f5kcw.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $d5115bbc651f62ba$var$contrastModeMql = $d5115bbc651f62ba$var$isMatchMediaAvailable && window.matchMedia((0, $487074ac5b1ae9b1$export$8662df6937d86fcb));
var $d5115bbc651f62ba$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$d5115bbc651f62ba$var$contrastModeMql) return "no-preference";
                return $d5115bbc651f62ba$var$contrastModeMql !== null && $d5115bbc651f62ba$var$contrastModeMql !== void 0 && $d5115bbc651f62ba$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($d5115bbc651f62ba$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $8fY35.bind)($d5115bbc651f62ba$var$contrastModeMql, {
                    type: "change",
                    listener: $d5115bbc651f62ba$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $d5115bbc651f62ba$var$SingletonContrastModeObserver = new $d5115bbc651f62ba$var$ContrastModeObserver();
var $d5115bbc651f62ba$export$2e2bcd8739ae039 = $d5115bbc651f62ba$var$SingletonContrastModeObserver;


function $c20333c7d4bee289$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $84bca69d8f2fd5f0$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $84bca69d8f2fd5f0$export$2e2bcd8739ae039).bind();
    } else (0, $84bca69d8f2fd5f0$export$2e2bcd8739ae039).unbind();
    if ((0, $ltooA.fg)("platform_increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $d5115bbc651f62ba$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $d5115bbc651f62ba$export$2e2bcd8739ae039).bind();
        } else (0, $d5115bbc651f62ba$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $c8c3a099b7b5a9bc$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $84bca69d8f2fd5f0$export$2e2bcd8739ae039).unbind();
        if ((0, $ltooA.fg)("platform_increased-contrast-themes")) (0, $d5115bbc651f62ba$export$2e2bcd8739ae039).unbind();
    };
}



var $ludeB = parcelRequire("ludeB");

var $fUHKi = parcelRequire("fUHKi");

var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $ahbug = parcelRequire("ahbug");
function $6e838abd7bbb62a9$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $ahbug.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $05df02a4cc3d5a12$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $ltooA.fg)("platform_increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $6e838abd7bbb62a9$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $ltooA.fg)("platform_increased-contrast-themes")) {
            var increasedContrastTheme = (0, $6e838abd7bbb62a9$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themePreferences));
};
var $05df02a4cc3d5a12$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themeOverridePreferences));
};



function $4956cae4c69ecf85$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $4956cae4c69ecf85$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $4956cae4c69ecf85$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4956cae4c69ecf85$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4956cae4c69ecf85$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4956cae4c69ecf85$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4956cae4c69ecf85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4956cae4c69ecf85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4956cae4c69ecf85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4956cae4c69ecf85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $4956cae4c69ecf85$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === "function" ? nextThemeState($4956cae4c69ecf85$var$_objectSpread($4956cae4c69ecf85$var$_objectSpread({}, (0, $ahbug.themeStateDefaults)), {}, {
                        typography: (0, $ahbug.themeStateDefaults)["typography"],
                        shape: (0, $ahbug.themeStateDefaults)["shape"](),
                        motion: (0, $ahbug.themeStateDefaults)["motion"]()
                    }, (0, $eca55eb8615bcf3e$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $ahbug.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $ahbug.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $ahbug.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $ahbug.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $ahbug.themeStateDefaults)["shape"]() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $ahbug.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $ahbug.themeStateDefaults)["typography"] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $ahbug.themeStateDefaults)["motion"]() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $ahbug.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $ltooA.fg)("platform_increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $05df02a4cc3d5a12$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $487074ac5b1ae9b1$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $9W3Vk.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $ahbug.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $ludeB.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("14wq7"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $05df02a4cc3d5a12$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $4956cae4c69ecf85$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $c20333c7d4bee289$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $4956cae4c69ecf85$export$2e2bcd8739ae039 = $4956cae4c69ecf85$var$setGlobalTheme;


var $f5kcw = parcelRequire("f5kcw");

var $acw62 = parcelRequire("acw62");
var $ab8a4dd9fc0025c1$export$7981b2444296e410 = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $ab8a4dd9fc0025c1$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $acw62.useContext)($ab8a4dd9fc0025c1$export$7981b2444296e410);
};
var $ab8a4dd9fc0025c1$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $ab8a4dd9fc0025c1$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $acw62.useContext)($ab8a4dd9fc0025c1$export$d2def9838ca456c0);
};



var $acw62 = parcelRequire("acw62");
var $1b09ce32e61bdf7b$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $1b09ce32e61bdf7b$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");
var $04e01a85c9573af8$export$332347eeb335453c = /*#__PURE__*/ (0, $acw62.createContext)(false);



var $acw62 = parcelRequire("acw62");
var $8c3b4d345e425d50$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $8c3b4d345e425d50$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");

var $8f8d1e8f89b20394$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)((0, $04e01a85c9573af8$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
var $3ebbf47ed24d559f$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== "undefined") return document;
    return null;
};





var $f5kcw = parcelRequire("f5kcw");
function $634c9308e764747b$export$835a0dc855d02822(themeId) {
    var doc = (0, $3ebbf47ed24d559f$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $f5kcw.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
}


var $4ac912c4fb4fc220$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $634c9308e764747b$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $f6fae66094c18304$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $4ac912c4fb4fc220$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $3ebbf47ed24d559f$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement("style");
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $634c9308e764747b$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $4ac912c4fb4fc220$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $4ac912c4fb4fc220$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $4ac912c4fb4fc220$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $4ac912c4fb4fc220$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($4ac912c4fb4fc220$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $773a434794af739f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $773a434794af739f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $773a434794af739f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $773a434794af739f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $773a434794af739f$var$defaultThemeSettings = {
    dark: "dark",
    light: "light",
    spacing: "spacing",
    typography: "typography"
};
var $773a434794af739f$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
var $773a434794af739f$var$prefersDarkModeMql = $773a434794af739f$var$isMatchMediaAvailable ? window.matchMedia("(prefers-color-scheme: dark)") : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $773a434794af739f$var$getReconciledColorMode(colorMode) {
    if (colorMode === "auto") return $773a434794af739f$var$prefersDarkModeMql !== null && $773a434794af739f$var$prefersDarkModeMql !== void 0 && $773a434794af739f$var$prefersDarkModeMql.matches ? "dark" : "light";
    return colorMode;
}
var $773a434794af739f$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $773a434794af739f$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? "auto" : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $acw62.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $acw62.useState)($773a434794af739f$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return $773a434794af739f$var$_objectSpread($773a434794af739f$var$_objectSpread({}, $773a434794af739f$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $acw62.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($773a434794af739f$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $acw62.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $773a434794af739f$var$_objectSpread($773a434794af739f$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $acw62.useRef)(null);
    var isInsideAppProvider = (0, $ab8a4dd9fc0025c1$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $ab8a4dd9fc0025c1$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $8f8d1e8f89b20394$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $acw62.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $4956cae4c69ecf85$export$2e2bcd8739ae039)($773a434794af739f$var$_objectSpread($773a434794af739f$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $4ac912c4fb4fc220$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $acw62.useEffect)(function() {
        if (!$773a434794af739f$var$prefersDarkModeMql) return;
        var unbindListener = (0, $8fY35.bind)($773a434794af739f$var$prefersDarkModeMql, {
            type: "change",
            listener: function listener(event) {
                if (chosenColorMode === "auto") setReconciledColorMode(event.matches ? "dark" : "light");
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $773a434794af739f$var$_objectSpread($773a434794af739f$var$_objectSpread({}, (0, $c8c3a099b7b5a9bc$export$2e2bcd8739ae039)($773a434794af739f$var$_objectSpread($773a434794af739f$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $f5kcw.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04e01a85c9573af8$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b09ce32e61bdf7b$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b09ce32e61bdf7b$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c3b4d345e425d50$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c3b4d345e425d50$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, attrs, {
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            $773a434794af739f$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $773a434794af739f$export$2e2bcd8739ae039 = $773a434794af739f$var$ThemeProvider;


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $f5kcw = parcelRequire("f5kcw");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $aed60d4c66c42c77$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $eca55eb8615bcf3e$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $f5kcw.THEME_DATA_ATTRIBUTE),
                            (0, $f5kcw.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($aed60d4c66c42c77$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($aed60d4c66c42c77$export$2e2bcd8739ae039, "callbacks", new Set());



function $b6f9e7ce7c69ab08$export$20f3076712c8dfa() {
    var value = (0, $acw62.useContext)((0, $1b09ce32e61bdf7b$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $eca55eb8615bcf3e$export$2e2bcd8739ae039)();
    var _useState = (0, $acw62.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || "light"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $aed60d4c66c42c77$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || "light");
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}


var $535b5cb107a2e0cc$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $535b5cb107a2e0cc$export$72f415121273627e = "body > .atlaskit-portal-container";
var $535b5cb107a2e0cc$export$13f57c02915787b3 = "atlaskit-portal";


var $d03e7a0589b193d7$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $535b5cb107a2e0cc$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $d03e7a0589b193d7$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $d03e7a0589b193d7$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $535b5cb107a2e0cc$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $535b5cb107a2e0cc$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $d03e7a0589b193d7$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $d03e7a0589b193d7$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $d03e7a0589b193d7$var$getPortalParent().removeChild(container);
};
var $d03e7a0589b193d7$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $d03e7a0589b193d7$var$getPortalParent().appendChild(container);
};
var $d03e7a0589b193d7$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $d03e7a0589b193d7$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($d03e7a0589b193d7$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $535b5cb107a2e0cc$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $d03e7a0589b193d7$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($d03e7a0589b193d7$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $535b5cb107a2e0cc$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $535b5cb107a2e0cc$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $d03e7a0589b193d7$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $918a3cba96726463$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $d03e7a0589b193d7$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $b6f9e7ce7c69ab08$export$20f3076712c8dfa)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $d03e7a0589b193d7$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $d03e7a0589b193d7$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $773a434794af739f$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
var $a22efe054e59e9ed$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $00f5c09045502f6c$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $b6f9e7ce7c69ab08$export$20f3076712c8dfa)();
    (0, $a22efe054e59e9ed$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $d03e7a0589b193d7$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $d03e7a0589b193d7$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $773a434794af739f$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $325ceaea6ea1c9c2$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $a22efe054e59e9ed$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $325ceaea6ea1c9c2$export$2e2bcd8739ae039 = $325ceaea6ea1c9c2$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $c117b6461c5213d0$export$ed5835cc67e87f72 = "akPortalMount";
var $c117b6461c5213d0$export$80816bd900e5bd00 = "akPortalUnmount";


var $000bbda6b3174c51$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $000bbda6b3174c51$var$getLayerName = function getLayerName(zIndex) {
    return $000bbda6b3174c51$var$zIndexToName.hasOwnProperty(zIndex) ? $000bbda6b3174c51$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $000bbda6b3174c51$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $000bbda6b3174c51$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $000bbda6b3174c51$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $000bbda6b3174c51$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $d0d4ece4d7a28899$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $000bbda6b3174c51$export$2e2bcd8739ae039)((0, $c117b6461c5213d0$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $000bbda6b3174c51$export$2e2bcd8739ae039)((0, $c117b6461c5213d0$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $d0d4ece4d7a28899$export$2e2bcd8739ae039 = $d0d4ece4d7a28899$var$useFirePortalEvent;


function $1fdb36f29d565380$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $325ceaea6ea1c9c2$export$2e2bcd8739ae039)(mountStrategy);
    (0, $d0d4ece4d7a28899$export$2e2bcd8739ae039)(zIndex);
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $918a3cba96726463$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00f5c09045502f6c$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $f972352ac361f4c0$var$printed = {};
function $f972352ac361f4c0$export$2e2bcd8739ae039(message) {
    if ($f972352ac361f4c0$var$printed[message]) return;
    $f972352ac361f4c0$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $a489e7f1e55ed1ec$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $f972352ac361f4c0$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $a489e7f1e55ed1ec$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


// Reds
var $d630b5937429758a$export$4b84fd0e2c617bd = "#FFEBE6";
var $d630b5937429758a$export$b34b069eff244586 = "#FFBDAD";
var $d630b5937429758a$export$be802dd0d8b57f35 = "#FF8F73";
var $d630b5937429758a$export$60847d42f9da92a6 = "#FF7452";
var $d630b5937429758a$export$4a7404f376229999 = "#FF5630";
var $d630b5937429758a$export$2010d0fb4295b346 = "#DE350B";
var $d630b5937429758a$export$2837b5a1a71d5c02 = "#BF2600";
var $d630b5937429758a$export$8d9596b529bbb9cf = "#FFFAE6";
var $d630b5937429758a$export$41060a744ab0b7ae = "#FFF0B3";
var $d630b5937429758a$export$1cc05bbbf340e559 = "#FFE380";
var $d630b5937429758a$export$5aae31392d72caaa = "#FFC400";
var $d630b5937429758a$export$c6930421db9fa514 = "#FFAB00";
var $d630b5937429758a$export$59619663aa6500fb = "#FF991F";
var $d630b5937429758a$export$874739ea9e379ab6 = "#FF8B00";
var $d630b5937429758a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d630b5937429758a$export$69a3bf21b9686c2b = "#ABF5D1";
var $d630b5937429758a$export$afbce1382ec95f73 = "#79F2C0";
var $d630b5937429758a$export$747d86715d4175de = "#57D9A3";
var $d630b5937429758a$export$940e1f69e873f202 = "#36B37E";
var $d630b5937429758a$export$a49394138f7b8e85 = "#00875A";
var $d630b5937429758a$export$6fa04827ac68a4fb = "#006644";
var $d630b5937429758a$export$226de0355ed012f8 = "#DEEBFF";
var $d630b5937429758a$export$8c13c2ee36917869 = "#B3D4FF";
var $d630b5937429758a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d630b5937429758a$export$215b7063051591f1 = "#2684FF";
var $d630b5937429758a$export$e62e8919cca44969 = "#0065FF";
var $d630b5937429758a$export$b3de0ae08da2ce64 = "#0052CC";
var $d630b5937429758a$export$a6ee3d71bc067634 = "#0747A6";
var $d630b5937429758a$export$67f15409e87642a1 = "#669DF1";
var $d630b5937429758a$export$f0539dbc42dbb067 = "#8FB8F6";
var $d630b5937429758a$export$363e4475840015bb = "#EAE6FF";
var $d630b5937429758a$export$4b0a4417ed59760f = "#C0B6F2";
var $d630b5937429758a$export$6011520a64d9a187 = "#998DD9";
var $d630b5937429758a$export$a7175d4e9206bc80 = "#8777D9";
var $d630b5937429758a$export$b48405b95304b5a1 = "#6554C0";
var $d630b5937429758a$export$c71e4279dd54a18d = "#5243AA";
var $d630b5937429758a$export$147899de772240ec = "#403294";
var $d630b5937429758a$export$2cf711fe14c66f06 = "#E6FCFF";
var $d630b5937429758a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d630b5937429758a$export$776c9c497ef08533 = "#79E2F2";
var $d630b5937429758a$export$69cb3ca10c1e330e = "#00C7E6";
var $d630b5937429758a$export$9dc1ef0f3f48059b = "#00B8D9";
var $d630b5937429758a$export$7c835c78b6fcdef8 = "#00A3BF";
var $d630b5937429758a$export$6036577f95c3877e = "#008DA6";
var $d630b5937429758a$export$29a4f05edc054374 = "#FFFFFF";
var $d630b5937429758a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d630b5937429758a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d630b5937429758a$export$3e51e8f1440314ba = "#EBECF0";
var $d630b5937429758a$export$1ce2d1575d444ceb = "#DFE1E6";
var $d630b5937429758a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d630b5937429758a$export$c2e91cbeada39b8b = "#B3BAC5";
var $d630b5937429758a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d630b5937429758a$export$eaa8c8a70ac22806 = "#97A0AF";
var $d630b5937429758a$export$7c87d337fb91a97d = "#8993A4";
var $d630b5937429758a$export$d6447c357493214f = "#7A869A";
var $d630b5937429758a$export$f563ee71e9ee74cd = "#6B778C";
var $d630b5937429758a$export$e2ef2124cf4024b1 = "#5E6C84";
var $d630b5937429758a$export$eece5f492e429f08 = "#505F79";
var $d630b5937429758a$export$c39c0fe0f26207ae = "#42526E";
var $d630b5937429758a$export$7090862dc3038a9f = "#344563";
var $d630b5937429758a$export$ad0bacf983b7ddaa = "#253858";
var $d630b5937429758a$export$7d61b15e0da132af = "#172B4D";
var $d630b5937429758a$export$fbda843f0a27fe96 = "#091E42";
var $d630b5937429758a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d630b5937429758a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d630b5937429758a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d630b5937429758a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d630b5937429758a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d630b5937429758a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d630b5937429758a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d630b5937429758a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d630b5937429758a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d630b5937429758a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d630b5937429758a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d630b5937429758a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d630b5937429758a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d630b5937429758a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d630b5937429758a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d630b5937429758a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d630b5937429758a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $d630b5937429758a$export$2f6319cf7d736c2a = "#E6EDFA";
var $d630b5937429758a$export$95126bc8884d6634 = "#DCE5F5";
var $d630b5937429758a$export$8338d8c35d44ff1 = "#CED9EB";
var $d630b5937429758a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d630b5937429758a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d630b5937429758a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d630b5937429758a$export$97e81faa16a182c7 = "#8C9CB8";
var $d630b5937429758a$export$bfe21c59123ecf33 = "#7988A3";
var $d630b5937429758a$export$ee82aa2ea6a1558 = "#67758F";
var $d630b5937429758a$export$682927c6ed76be02 = "#56637A";
var $d630b5937429758a$export$91fd9994c5be9757 = "#455166";
var $d630b5937429758a$export$d281fbfe3cff2df6 = "#3B475C";
var $d630b5937429758a$export$3902c91d8b98a753 = "#313D52";
var $d630b5937429758a$export$8e8133c1ba5845b5 = "#283447";
var $d630b5937429758a$export$33ff357f6620b39 = "#202B3D";
var $d630b5937429758a$export$633847cf062b69e0 = "#1B2638";
var $d630b5937429758a$export$9776a6e503bdbf76 = "#121A29";
var $d630b5937429758a$export$6c813d5160dff5db = "#0E1624";
var $d630b5937429758a$export$3d4f271a500072a = "#0D1424";
var $d630b5937429758a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d630b5937429758a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d630b5937429758a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d630b5937429758a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d630b5937429758a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d630b5937429758a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d630b5937429758a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d630b5937429758a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d630b5937429758a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d630b5937429758a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d630b5937429758a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d630b5937429758a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d630b5937429758a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d630b5937429758a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d630b5937429758a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d630b5937429758a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d630b5937429758a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $d630b5937429758a$export$d2adc5dedf09fced = "#292A2E";
var $d630b5937429758a$export$f51762073d2bb381 = "#94C748";
var $d630b5937429758a$export$95e26d54def96891 = "#B3DF72";


var $1a1475fad72dfc33$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $1a1475fad72dfc33$export$c93026a968943f95 = "light";
var $1a1475fad72dfc33$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $1a1475fad72dfc33$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d630b5937429758a$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $a489e7f1e55ed1ec$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $1a1475fad72dfc33$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $1a1475fad72dfc33$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $1a1475fad72dfc33$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $a489e7f1e55ed1ec$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $1a1475fad72dfc33$export$ba1d834b86d72a09 = $1a1475fad72dfc33$export$a1b3edb637fb4f35;
var $1a1475fad72dfc33$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d630b5937429758a$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d630b5937429758a$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d630b5937429758a$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $8fY35 = parcelRequire("8fY35");
var $6526d5cb916b9db5$var$registrations = new Set();
var $6526d5cb916b9db5$var$cleanupEndEventListeners = null;
function $6526d5cb916b9db5$var$onDragStart() {
    if ($6526d5cb916b9db5$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6526d5cb916b9db5$var$cleanupEndEventListeners = (0, $8fY35.bindAll)(window, [
        {
            type: "dragend",
            listener: $6526d5cb916b9db5$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $6526d5cb916b9db5$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6526d5cb916b9db5$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($6526d5cb916b9db5$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $6526d5cb916b9db5$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $6526d5cb916b9db5$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $6526d5cb916b9db5$var$cleanupEndEventListeners = null;
    var clone = Array.from($6526d5cb916b9db5$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $6526d5cb916b9db5$var$bindStartEvents() {
    return (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: $6526d5cb916b9db5$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $6526d5cb916b9db5$var$onDragStart
        }
    ]);
}
var $6526d5cb916b9db5$var$cleanupStartEventListeners = null;
function $6526d5cb916b9db5$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6526d5cb916b9db5$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6526d5cb916b9db5$var$cleanupStartEventListeners = $6526d5cb916b9db5$var$bindStartEvents();
    $6526d5cb916b9db5$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $6526d5cb916b9db5$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6526d5cb916b9db5$var$registrations.delete(registration);
        if ($6526d5cb916b9db5$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $6526d5cb916b9db5$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $6526d5cb916b9db5$var$cleanupStartEventListeners = null;
        }
    };
}


function $3bdf20d291dcb534$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $8ad8ed0729bb29b2$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === "mouse") return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === "mouse-x") return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === "mouse-y") return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $ltooA = parcelRequire("ltooA");
var $b544c8af1ec85579$var$delayId = null;
function $b544c8af1ec85579$export$eaf678f6f93f5250() {
    if ($b544c8af1ec85579$var$delayId != null) {
        window.clearTimeout($b544c8af1ec85579$var$delayId);
        $b544c8af1ec85579$var$delayId = null;
    }
}
function $b544c8af1ec85579$export$5f4d6617421d489b(fn, delay) {
    $b544c8af1ec85579$export$eaf678f6f93f5250();
    $b544c8af1ec85579$var$delayId = window.setTimeout(function() {
        $b544c8af1ec85579$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $b8d6dc213acdb507$var$active = null;
function $b8d6dc213acdb507$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($b8d6dc213acdb507$var$active && $b8d6dc213acdb507$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $b544c8af1ec85579$export$eaf678f6f93f5250)();
            $b8d6dc213acdb507$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $b544c8af1ec85579$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $b544c8af1ec85579$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $b544c8af1ec85579$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($b8d6dc213acdb507$var$active && $b8d6dc213acdb507$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($b8d6dc213acdb507$var$active) {
            (0, $b544c8af1ec85579$export$eaf678f6f93f5250)();
            $b8d6dc213acdb507$var$active.entry.hide({
                isImmediate: true
            });
            $b8d6dc213acdb507$var$active.entry.done();
            $b8d6dc213acdb507$var$active = null;
        }
        // this tooltip is now the active tooltip
        $b8d6dc213acdb507$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $b544c8af1ec85579$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? undefined : getInitialMouse(),
        mousePos: entry.source.type === "mouse" && (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



function $09e191d996fc7263$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $d9f258fd1a7d4ed3$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $7ed52719c0b7f4ac$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $7ed52719c0b7f4ac$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            $7ed52719c0b7f4ac$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $acw62.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
                $7ed52719c0b7f4ac$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $368d51b4ce8b5cc4$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $368d51b4ce8b5cc4$var$TooltipPrimitive = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $acw62.createElement("div", {
        role: "tooltip",
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $acw62.createElement((0, $7ed52719c0b7f4ac$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$368d51b4ce8b5cc4$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $368d51b4ce8b5cc4$export$2e2bcd8739ae039 = $368d51b4ce8b5cc4$var$TooltipPrimitive;


var $c7218fc72d3b39d5$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $c7218fc72d3b39d5$var$TooltipContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $acw62.createElement((0, $368d51b4ce8b5cc4$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $d9f9c3011f2b7f78$export$2e2bcd8739ae039)([
            $c7218fc72d3b39d5$var$styles.base,
            truncate && $c7218fc72d3b39d5$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$c7218fc72d3b39d5$var$TooltipContainer.displayName = "TooltipContainer";
var $c7218fc72d3b39d5$export$2e2bcd8739ae039 = $c7218fc72d3b39d5$var$TooltipContainer;


function $961f959485f09718$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $961f959485f09718$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $961f959485f09718$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $961f959485f09718$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $961f959485f09718$var$tooltipZIndex = (0, $1a1475fad72dfc33$export$7be255094ccdc533).tooltip();
var $961f959485f09718$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.0.1"
};
// Inverts motion direction
var $961f959485f09718$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $961f959485f09718$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $961f959485f09718$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $c7218fc72d3b39d5$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === "mouse" || position === "mouse-y" || position === "mouse-x";
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $e2a6783643de8200$export$1a04351537078b55)($961f959485f09718$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $961f959485f09718$var$analyticsAttributes));
    var onHideHandler = (0, $e2a6783643de8200$export$1a04351537078b55)($961f959485f09718$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $961f959485f09718$var$analyticsAttributes));
    var apiRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $acw62.useRef)(null);
    var containerRef = (0, $acw62.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $acw62.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $18ac0aef6852b24e$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $18ac0aef6852b24e$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $18ac0aef6852b24e$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $18ac0aef6852b24e$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $18ac0aef6852b24e$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $acw62.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $18ac0aef6852b24e$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $acw62.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $acw62.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        return (0, $6526d5cb916b9db5$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $acw62.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? "fade-in" : "show-immediate");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done,
            shouldAlwaysFadeIn: (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $b8d6dc213acdb507$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $acw62.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $5f3446c461420775$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $acw62.useEffect)(function() {
        if (state === "hide") return 0, $232d11f435326a2b$export$2e2bcd8739ae039;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? undefined : (0, $3bdf20d291dcb534$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback")) apiRef.current.mousePosition = (0, $3bdf20d291dcb534$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $acw62.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $acw62.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(":focus-visible")) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $acw62.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $acw62.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $acw62.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1b77518667867a93$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback")) return (0, $8ad8ed0729bb29b2$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback")) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $09e191d996fc7263$export$2e2bcd8739ae039)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $acw62.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? (0, $acw62.Fragment) : $961f959485f09718$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children($961f959485f09718$var$_objectSpread($961f959485f09718$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31f4eab41b02ceca$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $961f959485f09718$var$invertedDirection[$961f959485f09718$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68f31dfe991398b4$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8eaeca19d2625b4$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $961f959485f09718$var$_objectSpread($961f959485f09718$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $961f959485f09718$export$2e2bcd8739ae039 = $961f959485f09718$var$Tooltip;
var $961f959485f09718$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fdb36f29d565380$export$2e2bcd8739ae039), {
        zIndex: $961f959485f09718$var$tooltipZIndex
    }, children);
};






var $cbba28d57dbc8c95$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $cbba28d57dbc8c95$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $cbba28d57dbc8c95$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $cbba28d57dbc8c95$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $cbba28d57dbc8c95$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26dbdd082a36bf03$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ec7edac2a9b0517$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $15983b3b4480e4e1$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d2c35c9b72bfde0$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $961f959485f09718$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26dbdd082a36bf03$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $3d94fa6e7ae720e2$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ec7edac2a9b0517$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $15983b3b4480e4e1$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d2c35c9b72bfde0$export$2e2bcd8739ae039), null, label)));
    });
}));
$cbba28d57dbc8c95$var$IconButton.displayName = "IconButton";
var $cbba28d57dbc8c95$export$2e2bcd8739ae039 = $cbba28d57dbc8c95$var$IconButton;


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $60a7508560ffe371$var$ATOMIC_GROUP_LENGTH = 5;
function $60a7508560ffe371$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $60a7508560ffe371$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");
var $f5fc977854502c0b$export$4ef52930e33717cd = "data-theme";
var $f5fc977854502c0b$export$cb374d25ded7f6ab = "data-subtree-theme";
var $f5fc977854502c0b$export$a00eac3f8684bcd0 = "data-color-mode";
var $f5fc977854502c0b$export$2112803007239c61 = "data-contrast-mode";
var $f5fc977854502c0b$export$352e418ed5b6193a = "data-custom-theme";
var $f5fc977854502c0b$export$6f0c6fb8c80fcc92 = "ds";
var $f5fc977854502c0b$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $f5fc977854502c0b$export$dddac1532e822863 = "--".concat($f5fc977854502c0b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $f5fc977854502c0b$export$9d7b58831ae93caa = "--".concat($f5fc977854502c0b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $ltooA = parcelRequire("ltooA");
var $da3a2507df08913e$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $da3a2507df08913e$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $da3a2507df08913e$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "spacing",
    "shape",
    "typography",
    "motion"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $da3a2507df08913e$var$themeOverrideIds = [];
var $da3a2507df08913e$export$92ba366331403db2 = [].concat($da3a2507df08913e$export$7d43e72a58e3283f, $da3a2507df08913e$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $da3a2507df08913e$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-motion": {
        id: "motion",
        displayName: "Motion",
        palette: "motionPalette",
        attributes: {
            type: "motion"
        }
    }
};
var $da3a2507df08913e$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: function shape() {
        if ((0, $ltooA.fg)("platform-dst-shape-theme-default")) return "shape";
        return undefined;
    },
    spacing: "spacing",
    typography: "typography",
    motion: function motion() {
        if ((0, $ltooA.fg)("platform-dst-motion-theme-default")) return "motion";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $da3a2507df08913e$export$2e2bcd8739ae039 = $da3a2507df08913e$var$themeConfig;



var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $971f6a7010094474$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape",
    "motion"
];
var $971f6a7010094474$var$customThemeOptions = "UNSAFE_themeOptions";
var $971f6a7010094474$var$isThemeKind = function isThemeKind(themeKind) {
    return $971f6a7010094474$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $971f6a7010094474$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $da3a2507df08913e$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $971f6a7010094474$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $971f6a7010094474$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ")// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $971f6a7010094474$var$isColorMode(id)) themeObject[kind] = id;
        if ($971f6a7010094474$var$isThemeKind(kind) && $971f6a7010094474$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $971f6a7010094474$var$customThemeOptions) try {
            themeObject[$971f6a7010094474$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $971f6a7010094474$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $971f6a7010094474$var$isColorMode(id) || // custom theme state
        kind === $971f6a7010094474$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $971f6a7010094474$var$isThemeKind(kind) && typeof id === "string" && $971f6a7010094474$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};


function $cae0300b6689d744$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cae0300b6689d744$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cae0300b6689d744$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cae0300b6689d744$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cae0300b6689d744$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $da3a2507df08913e$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $cae0300b6689d744$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $f5fc977854502c0b$export$a00eac3f8684bcd0)) || "";
    var theme = element.getAttribute((0, $f5fc977854502c0b$export$4ef52930e33717cd)) || "";
    return $cae0300b6689d744$var$_objectSpread($cae0300b6689d744$var$_objectSpread({}, (0, $971f6a7010094474$export$f19b488f7c0547ee)(theme)), $cae0300b6689d744$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $cae0300b6689d744$export$2e2bcd8739ae039 = $cae0300b6689d744$var$getGlobalTheme;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $dfea7845546de6fc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $cae0300b6689d744$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $f5fc977854502c0b$export$4ef52930e33717cd),
                            (0, $f5fc977854502c0b$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($dfea7845546de6fc$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($dfea7845546de6fc$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $a1da658d60a84779$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $acw62.useState)((0, $cae0300b6689d744$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $acw62.useEffect)(function() {
        var observer = new (0, $dfea7845546de6fc$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a1da658d60a84779$export$2e2bcd8739ae039 = $a1da658d60a84779$var$useThemeObserver;


var $21bfa8bb6fa9ceeb$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $21bfa8bb6fa9ceeb$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $21bfa8bb6fa9ceeb$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $21bfa8bb6fa9ceeb$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $21bfa8bb6fa9ceeb$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $21bfa8bb6fa9ceeb$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $21bfa8bb6fa9ceeb$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $21bfa8bb6fa9ceeb$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    "12": "_4t3i1crf",
    "16": "_4t3i7vkz",
    "20": "_4t3igktf",
    "24": "_4t3i1tcg",
    "32": "_4t3izwfg"
};
function $21bfa8bb6fa9ceeb$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "20" : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? "tile" : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            "--themed-icon-color": customIconColor || "initial"
        },
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        "aria-hidden": label === "" ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $60a7508560ffe371$export$2e2bcd8739ae039)([
            $21bfa8bb6fa9ceeb$var$styles.root,
            $21bfa8bb6fa9ceeb$var$sizeMap[size],
            colorMode === "dark" ? $21bfa8bb6fa9ceeb$var$dataCenterDarkAppearanceMap[appearance] : $21bfa8bb6fa9ceeb$var$dataCenterLightAppearanceMap[appearance],
            type === "rovo" ? colorMode === "dark" ? $21bfa8bb6fa9ceeb$var$rovoDarkAppearanceMap[appearance] : $21bfa8bb6fa9ceeb$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $21bfa8bb6fa9ceeb$var$cloudDarkAppearanceMap[appearance] : $21bfa8bb6fa9ceeb$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === "brand" && (0, $ltooA.fg)("assets-platform-branding") && $21bfa8bb6fa9ceeb$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $389b8b1b2800932a$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>\n</svg>\n';
function $389b8b1b2800932a$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Admin" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $389b8b1b2800932a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");

var $87082e906d6618bd$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $87082e906d6618bd$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $87082e906d6618bd$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $87082e906d6618bd$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $87082e906d6618bd$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $87082e906d6618bd$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $87082e906d6618bd$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $87082e906d6618bd$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $87082e906d6618bd$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $87082e906d6618bd$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $87082e906d6618bd$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $87082e906d6618bd$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? "small" : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? "tile" : _ref$type;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            "--themed-icon-color": customIconColor === "inherit" ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            "--themed-text-color": customTextColor || "inherit"
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        "aria-hidden": label === "" ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $60a7508560ffe371$export$2e2bcd8739ae039)([
            $87082e906d6618bd$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $87082e906d6618bd$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : "light"],
            $87082e906d6618bd$var$sizeMap[size],
            colorMode === "dark" ? $87082e906d6618bd$var$textDarkAppearanceMap[appearance] : $87082e906d6618bd$var$textLightAppearanceMap[appearance],
            colorMode === "dark" ? $87082e906d6618bd$var$dataCenterDarkAppearanceMap[appearance] : $87082e906d6618bd$var$dataCenterLightAppearanceMap[appearance],
            type === "rovo" ? colorMode === "dark" ? $87082e906d6618bd$var$rovoDarkAppearanceMap[appearance] : $87082e906d6618bd$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $87082e906d6618bd$var$cloudDarkAppearanceMap[appearance] : $87082e906d6618bd$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === "brand" && (0, $ltooA.fg)("assets-platform-branding") && $87082e906d6618bd$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $06bfb3ba32e0ee78$var$svg = '<svg height="100%" viewBox="0 0 126 32">\n    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>\n</svg>\n';
function $06bfb3ba32e0ee78$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Admin" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $06bfb3ba32e0ee78$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $8e86b560d8a10730$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>\n</svg>\n';
function $8e86b560d8a10730$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Align" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $8e86b560d8a10730$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c1ef7924ce69dfc1$var$svg = '<svg height="100%" viewBox="0 0 106 32">\n    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>\n</svg>\n';
function $c1ef7924ce69dfc1$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Align" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $c1ef7924ce69dfc1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $edff975b886b81b5$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>\n</svg>\n';
function $edff975b886b81b5$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Analytics" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $edff975b886b81b5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9cbcfd3cc0c40d2e$var$svg = '<svg height="100%" viewBox="0 0 161 32">\n    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>\n</svg>\n';
function $9cbcfd3cc0c40d2e$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Analytics" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $9cbcfd3cc0c40d2e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4bb96c0c43e732a3$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>\n</svg>\n';
var $4bb96c0c43e732a3$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>\n</svg>\n';
function $4bb96c0c43e732a3$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Assets" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $4bb96c0c43e732a3$var$svg,
        customThemeSvg: $4bb96c0c43e732a3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b4dde49fef9988c6$var$svg = '<svg height="100%" viewBox="0 0 126 32">\n    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>\n</svg>\n';
function $b4dde49fef9988c6$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Assets" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $b4dde49fef9988c6$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $bd2d84735fedebfe$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>\n</svg>\n';
function $bd2d84735fedebfe$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bamboo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $bd2d84735fedebfe$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a323cee89a9a05ab$var$svg = '<svg height="100%" viewBox="0 0 154 32">\n    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>\n</svg>\n';
function $a323cee89a9a05ab$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bamboo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $a323cee89a9a05ab$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d8287d0c54ed02e0$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>\n</svg>\n';
var $d8287d0c54ed02e0$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>\n</svg>\n';
function $d8287d0c54ed02e0$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $d8287d0c54ed02e0$var$svg,
        customThemeSvg: $d8287d0c54ed02e0$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a780c6309f692bcc$var$svg = '<svg height="100%" viewBox="0 0 166 32">\n    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>\n    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>\n</svg>\n';
function $a780c6309f692bcc$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $a780c6309f692bcc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $067b09dbd6819d21$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>\n</svg>\n';
function $067b09dbd6819d21$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $067b09dbd6819d21$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $490d5a0a0a56c1c0$var$svg = '<svg height="100%" viewBox="0 0 166 32">\n    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>\n</svg>\n';
function $490d5a0a0a56c1c0$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $490d5a0a0a56c1c0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ae7c6b8327e311a4$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75" clip-rule="evenodd"/>\n</svg>\n';
function $ae7c6b8327e311a4$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $ae7c6b8327e311a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c02b99fd709bbeed$var$svg = '<svg height="100%" viewBox="0 0 102 32">\n    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0" clip-rule="evenodd"/>\n</svg>\n';
function $c02b99fd709bbeed$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $c02b99fd709bbeed$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $eb54878dd50bf49e$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>\n</svg>\n';
function $eb54878dd50bf49e$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $eb54878dd50bf49e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $616fdd30929bdb4a$var$svg = '<svg height="100%" viewBox="0 0 102 32">\n    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>\n</svg>\n';
function $616fdd30929bdb4a$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $616fdd30929bdb4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b39cbac8decb2b6f$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>\n    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>\n</svg>\n';
function $b39cbac8decb2b6f$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Compass" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $b39cbac8decb2b6f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $143b10adeb1437c2$var$svg = '<svg height="100%" viewBox="0 0 162 32">\n    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>\n</svg>\n';
function $143b10adeb1437c2$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Compass" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $143b10adeb1437c2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d02eabbaeea5900b$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>\n</svg>\n';
var $d02eabbaeea5900b$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>\n</svg>\n';
function $d02eabbaeea5900b$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $d02eabbaeea5900b$var$svg,
        customThemeSvg: $d02eabbaeea5900b$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1e4ef953bb0b0ce8$var$svg = '<svg height="100%" viewBox="0 0 188 32">\n    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>\n</svg>\n';
function $1e4ef953bb0b0ce8$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $1e4ef953bb0b0ce8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a2f03718ae46777e$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>\n</svg>\n';
function $a2f03718ae46777e$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $a2f03718ae46777e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $137d601d1a535d1e$var$svg = '<svg height="100%" viewBox="0 0 188 32">\n    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>\n</svg>\n';
function $137d601d1a535d1e$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $137d601d1a535d1e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0eb05e56f724b643$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>\n</svg>\n';
function $0eb05e56f724b643$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Crowd" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $0eb05e56f724b643$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cec2c2045ffdb1e8$var$svg = '<svg height="100%" viewBox="0 0 126 32">\n    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>\n</svg>\n';
function $cec2c2045ffdb1e8$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Crowd" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $cec2c2045ffdb1e8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $de05fcd9142ded5a$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>\n</svg>\n';
var $de05fcd9142ded5a$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>\n</svg>\n';
function $de05fcd9142ded5a$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Customer Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $de05fcd9142ded5a$var$svg,
        customThemeSvg: $de05fcd9142ded5a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $263e6e007aaeb431$var$svg = '<svg height="100%" viewBox="0 0 456 32">\n    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>\n</svg>\n';
function $263e6e007aaeb431$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Customer Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $263e6e007aaeb431$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $bfe1584f17884468$var$svg = '<svg height="100%" viewBox="0 0 48 48">\n    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>\n    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>\n</svg>\n';
function $bfe1584f17884468$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Dx" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $bfe1584f17884468$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d72ce01a33d80f56$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>\n</svg>\n';
function $d72ce01a33d80f56$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Focus" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $d72ce01a33d80f56$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2d128798336b30d6$var$svg = '<svg height="100%" viewBox="0 0 117 32">\n    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>\n    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>\n</svg>\n';
function $2d128798336b30d6$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Focus" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $2d128798336b30d6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $275ae0200f102d48$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>\n</svg>\n';
function $275ae0200f102d48$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Goals" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $275ae0200f102d48$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fd69227292806c7a$var$svg = '<svg height="100%" viewBox="0 0 116 32">\n    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>\n</svg>\n';
function $fd69227292806c7a$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Goals" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $fd69227292806c7a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f11de1cd57a5781$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>\n</svg>\n';
function $4f11de1cd57a5781$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Guard" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $4f11de1cd57a5781$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $603ee49aea6e4f7d$var$svg = '<svg height="100%" viewBox="0 0 120 32">\n    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>\n</svg>\n';
function $603ee49aea6e4f7d$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Guard" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $603ee49aea6e4f7d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $47d1491f82040549$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>\n</svg>\n';
function $47d1491f82040549$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Home" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $47d1491f82040549$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2075c2bbce887c7d$var$svg = '<svg height="100%" viewBox="0 0 121 32">\n    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>\n</svg>\n';
function $2075c2bbce887c7d$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Home" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $2075c2bbce887c7d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $30ad8371e835a074$var$svg = '<svg height="100%" viewBox="0 0 32 32">\n    <g clip-path="url(#clip0_95164_16219)">\n        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n        <g clip-path="url(#clip1_95164_16219)">\n            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id="clip0_95164_16219">\n            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>\n        </clipPath>\n        <clipPath id="clip1_95164_16219">\n            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>\n        </clipPath>\n    </defs>\n</svg>\n';
function $30ad8371e835a074$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Hub" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $30ad8371e835a074$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9de88e29cd80743e$var$svg = '<svg height="100%" viewBox="0 0 95 32">\n    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>\n</svg>\n';
function $9de88e29cd80743e$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Hub" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $9de88e29cd80743e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $172adace76e64264$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>\n</svg>\n';
var $172adace76e64264$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>\n</svg>\n';
function $172adace76e64264$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $172adace76e64264$var$svg,
        customThemeSvg: $172adace76e64264$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $066a5c848b759317$var$svg = '<svg height="100%" viewBox="0 0 83 32">\n    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>\n</svg>\n';
function $066a5c848b759317$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $066a5c848b759317$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $22a7b1ca56e1e7e4$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>\n</svg>\n';
function $22a7b1ca56e1e7e4$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $22a7b1ca56e1e7e4$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6a8cc8e9ae9d3712$var$svg = '<svg height="100%" viewBox="0 0 83 32">\n    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>\n</svg>\n';
function $6a8cc8e9ae9d3712$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $6a8cc8e9ae9d3712$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $92f2476a81097332$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>\n</svg>\n';
var $92f2476a81097332$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>\n</svg>\n';
function $92f2476a81097332$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Product Discovery" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $92f2476a81097332$var$svg,
        customThemeSvg: $92f2476a81097332$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dcf243f0003cb84d$var$svg = '<svg height="100%" viewBox="0 0 327 32">\n    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>\n</svg>\n';
function $dcf243f0003cb84d$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Product Discovery" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $dcf243f0003cb84d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $1d972312520cf5b4$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>\n</svg>\n';
var $1d972312520cf5b4$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>\n</svg>\n';
function $1d972312520cf5b4$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $1d972312520cf5b4$var$svg,
        customThemeSvg: $1d972312520cf5b4$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $92f93af52daa0f2b$var$svg = '<svg height="100%" viewBox="0 0 372 32">\n    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>\n</svg>\n';
function $92f93af52daa0f2b$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $92f93af52daa0f2b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f8ed4acaa790938e$var$svg = '<svg height="100%" viewBox="0 0 25 24">\n    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>\n</svg>\n';
function $f8ed4acaa790938e$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $f8ed4acaa790938e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a45f9948f3045d50$var$svg = '<svg height="100%" viewBox="0 0 372 32">\n    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>\n</svg>\n';
function $a45f9948f3045d50$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $a45f9948f3045d50$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e29e92b5a98504c2$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>\n</svg>\n';
function $e29e92b5a98504c2$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $e29e92b5a98504c2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8719046addaa058e$var$svg = '<svg height="100%" viewBox="0 0 103 32">\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>\n    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>\n</svg>\n';
function $8719046addaa058e$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $8719046addaa058e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $00491de52be214f2$var$svg = '<svg height="100%" viewBox="0 0 100 32">\n    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>\n    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>\n</svg>\n';
function $00491de52be214f2$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom Attribution" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $00491de52be214f2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f8a9b027bd58ae6c$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>\n</svg>\n';
function $f8a9b027bd58ae6c$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $f8a9b027bd58ae6c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $992f074dc45a9024$var$svg = '<svg height="100%" viewBox="0 0 103 32">\n    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>\n    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>\n</svg>\n';
function $992f074dc45a9024$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $992f074dc45a9024$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9f44e5126ceeef9a$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>\n</svg>\n';
function $9f44e5126ceeef9a$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Opsgenie" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $9f44e5126ceeef9a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $915e8cdab12f40ca$var$svg = '<svg height="100%" viewBox="0 0 164 32">\n    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>\n</svg>\n';
function $915e8cdab12f40ca$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Opsgenie" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $915e8cdab12f40ca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6244876ee6467f08$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>\n</svg>\n';
function $6244876ee6467f08$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Projects" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $6244876ee6467f08$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e4698133c894240b$var$svg = '<svg height="100%" viewBox="0 0 145 32">\n    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>\n</svg>\n';
function $e4698133c894240b$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Projects" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $e4698133c894240b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4e67e66e4b0b1efe$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>\n    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>\n</svg>\n';
function $4e67e66e4b0b1efe$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $4e67e66e4b0b1efe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5c3b42793bddd50a$var$svg = '<svg height="100%" viewBox="0 0 106 32">\n    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>\n    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>\n</svg>\n';
function $5c3b42793bddd50a$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $5c3b42793bddd50a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $164df03114fbbcaa$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>\n    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>\n</svg>\n';
function $164df03114fbbcaa$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $164df03114fbbcaa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $99bdd9f1992e8f40$var$svg = '<svg height="100%" viewBox="0 0 165 32">\n    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>\n    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>\n</svg>\n';
function $99bdd9f1992e8f40$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $99bdd9f1992e8f40$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $80b190b2c6d1a3af$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>\n</svg>\n';
function $80b190b2c6d1a3af$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev Agent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $80b190b2c6d1a3af$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ff3d7785892415e9$var$svg = '<svg height="100%" viewBox="0 0 160 32">\n    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>\n</svg>\n';
function $ff3d7785892415e9$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev Agent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $ff3d7785892415e9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3f54e27315cfac6a$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>\n    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>\n</svg>\n';
function $3f54e27315cfac6a$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $3f54e27315cfac6a$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e79e6eeb85a8b7f7$var$svg = '<svg height="100%" viewBox="0 0 102 32">\n    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>\n    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>\n</svg>\n';
function $e79e6eeb85a8b7f7$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $e79e6eeb85a8b7f7$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $766fb46ef214d402$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5" clip-rule="evenodd"/>\n</svg>\n';
function $766fb46ef214d402$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $766fb46ef214d402$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fb006a7aa66b4da8$var$svg = '<svg height="100%" viewBox="0 0 130 32">\n    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0" clip-rule="evenodd"/>\n</svg>\n';
function $fb006a7aa66b4da8$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $fb006a7aa66b4da8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e3bdc25c2a27fd27$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>\n</svg>\n';
function $e3bdc25c2a27fd27$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $e3bdc25c2a27fd27$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ac7ed8c68efd9922$var$svg = '<svg height="100%" viewBox="0 0 130 32">\n    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>\n</svg>\n';
function $ac7ed8c68efd9922$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $ac7ed8c68efd9922$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $59858f423d37a0b2$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>\n</svg>\n';
function $59858f423d37a0b2$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Statuspage" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $59858f423d37a0b2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8b73fa1b409b7104$var$svg = '<svg height="100%" viewBox="0 0 192 32">\n    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>\n</svg>\n';
function $8b73fa1b409b7104$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Statuspage" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $8b73fa1b409b7104$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $29371ccec0b1ddf9$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M10.7 11.222V19h7.8v-7.778z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z"/>\n</svg>\n';
function $29371ccec0b1ddf9$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $29371ccec0b1ddf9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3a2fd83859f76fb5$var$svg = '<svg height="100%" viewBox="0 0 124 32">\n    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.125 14.125V24.75H24.75V14.125z"/>\n    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>\n</svg>\n';
function $3a2fd83859f76fb5$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $3a2fd83859f76fb5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f2ea1e70f1121577$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>\n</svg>\n';
function $f2ea1e70f1121577$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $f2ea1e70f1121577$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $22cb125270f1db64$var$svg = '<svg height="100%" viewBox="0 0 124 32">\n    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>\n</svg>\n';
function $22cb125270f1db64$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $22cb125270f1db64$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6bbe61ab629e7683$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>\n</svg>\n';
function $6bbe61ab629e7683$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Talent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $6bbe61ab629e7683$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7e731445474be878$var$svg = '<svg height="100%" viewBox="0 0 122 32">\n    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>\n    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>\n</svg>\n';
function $7e731445474be878$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Talent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $7e731445474be878$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $39ded4505b964a24$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>\n</svg>\n';
function $39ded4505b964a24$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Teams" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $39ded4505b964a24$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $448e5173ec3ee7e8$var$svg = '<svg height="100%" viewBox="0 0 127 32">\n    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>\n</svg>\n';
function $448e5173ec3ee7e8$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Teams" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $448e5173ec3ee7e8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $5ebd85c600ef3dd2$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>\n</svg>\n';
var $5ebd85c600ef3dd2$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>\n</svg>\n';
function $5ebd85c600ef3dd2$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Trello" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $21bfa8bb6fa9ceeb$export$be58b4326e23250f), {
        svg: $5ebd85c600ef3dd2$var$svg,
        customThemeSvg: $5ebd85c600ef3dd2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $acw62 = parcelRequire("acw62");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f8f7447a24ac65b3$var$svg = '<svg height="100%" viewBox="0 0 113 32">\n    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>\n    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>\n</svg>\n';
function $f8f7447a24ac65b3$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Trello" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87082e906d6618bd$export$f827d3c5a9c3f644), {
        svg: $f8f7447a24ac65b3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $acw62 = parcelRequire("acw62");

/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $5efdda03d2f7b098$export$438460117ae6b7ee = {
    iconColor: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $5efdda03d2f7b098$export$793fba32aed8942a = {
    iconGradientStart: "inherit",
    iconGradientStop: "inherit"
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $28b8fc8846d5f5cb$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $28b8fc8846d5f5cb$var$CSS_VAR_COLOR = "--logo-color";
var $28b8fc8846d5f5cb$var$CSS_VAR_FILL = "--logo-fill";
var $28b8fc8846d5f5cb$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $28b8fc8846d5f5cb$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $28b8fc8846d5f5cb$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $28b8fc8846d5f5cb$var$CSS_VAR_COLOR, iconColor), $28b8fc8846d5f5cb$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $60a7508560ffe371$export$2e2bcd8739ae039)([
            $28b8fc8846d5f5cb$var$styles.root,
            shouldApplyStopColor && $28b8fc8846d5f5cb$var$styles.stop,
            size && $28b8fc8846d5f5cb$var$styles[size]
        ])
    }));
};
var $28b8fc8846d5f5cb$export$2e2bcd8739ae039 = $28b8fc8846d5f5cb$var$Wrapper;


// Reds
var $fefa0493b314738c$export$4b84fd0e2c617bd = "#FFEBE6";
var $fefa0493b314738c$export$b34b069eff244586 = "#FFBDAD";
var $fefa0493b314738c$export$be802dd0d8b57f35 = "#FF8F73";
var $fefa0493b314738c$export$60847d42f9da92a6 = "#FF7452";
var $fefa0493b314738c$export$4a7404f376229999 = "#FF5630";
var $fefa0493b314738c$export$2010d0fb4295b346 = "#DE350B";
var $fefa0493b314738c$export$2837b5a1a71d5c02 = "#BF2600";
var $fefa0493b314738c$export$8d9596b529bbb9cf = "#FFFAE6";
var $fefa0493b314738c$export$41060a744ab0b7ae = "#FFF0B3";
var $fefa0493b314738c$export$1cc05bbbf340e559 = "#FFE380";
var $fefa0493b314738c$export$5aae31392d72caaa = "#FFC400";
var $fefa0493b314738c$export$c6930421db9fa514 = "#FFAB00";
var $fefa0493b314738c$export$59619663aa6500fb = "#FF991F";
var $fefa0493b314738c$export$874739ea9e379ab6 = "#FF8B00";
var $fefa0493b314738c$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $fefa0493b314738c$export$69a3bf21b9686c2b = "#ABF5D1";
var $fefa0493b314738c$export$afbce1382ec95f73 = "#79F2C0";
var $fefa0493b314738c$export$747d86715d4175de = "#57D9A3";
var $fefa0493b314738c$export$940e1f69e873f202 = "#36B37E";
var $fefa0493b314738c$export$a49394138f7b8e85 = "#00875A";
var $fefa0493b314738c$export$6fa04827ac68a4fb = "#006644";
var $fefa0493b314738c$export$226de0355ed012f8 = "#DEEBFF";
var $fefa0493b314738c$export$8c13c2ee36917869 = "#B3D4FF";
var $fefa0493b314738c$export$ecfc1dff386a3e7a = "#4C9AFF";
var $fefa0493b314738c$export$215b7063051591f1 = "#2684FF";
var $fefa0493b314738c$export$e62e8919cca44969 = "#0065FF";
var $fefa0493b314738c$export$b3de0ae08da2ce64 = "#0052CC";
var $fefa0493b314738c$export$a6ee3d71bc067634 = "#0747A6";
var $fefa0493b314738c$export$67f15409e87642a1 = "#669DF1";
var $fefa0493b314738c$export$f0539dbc42dbb067 = "#8FB8F6";
var $fefa0493b314738c$export$363e4475840015bb = "#EAE6FF";
var $fefa0493b314738c$export$4b0a4417ed59760f = "#C0B6F2";
var $fefa0493b314738c$export$6011520a64d9a187 = "#998DD9";
var $fefa0493b314738c$export$a7175d4e9206bc80 = "#8777D9";
var $fefa0493b314738c$export$b48405b95304b5a1 = "#6554C0";
var $fefa0493b314738c$export$c71e4279dd54a18d = "#5243AA";
var $fefa0493b314738c$export$147899de772240ec = "#403294";
var $fefa0493b314738c$export$2cf711fe14c66f06 = "#E6FCFF";
var $fefa0493b314738c$export$7a8f4d33f6f9772c = "#B3F5FF";
var $fefa0493b314738c$export$776c9c497ef08533 = "#79E2F2";
var $fefa0493b314738c$export$69cb3ca10c1e330e = "#00C7E6";
var $fefa0493b314738c$export$9dc1ef0f3f48059b = "#00B8D9";
var $fefa0493b314738c$export$7c835c78b6fcdef8 = "#00A3BF";
var $fefa0493b314738c$export$6036577f95c3877e = "#008DA6";
var $fefa0493b314738c$export$29a4f05edc054374 = "#FFFFFF";
var $fefa0493b314738c$export$e655ef011c4aa1a2 = "#FAFBFC";
var $fefa0493b314738c$export$9fdfb749e33cdf97 = "#F4F5F7";
var $fefa0493b314738c$export$3e51e8f1440314ba = "#EBECF0";
var $fefa0493b314738c$export$1ce2d1575d444ceb = "#DFE1E6";
var $fefa0493b314738c$export$8754fc7e6d8b3000 = "#C1C7D0";
var $fefa0493b314738c$export$c2e91cbeada39b8b = "#B3BAC5";
var $fefa0493b314738c$export$5f71e19f3a7ad9de = "#A5ADBA";
var $fefa0493b314738c$export$eaa8c8a70ac22806 = "#97A0AF";
var $fefa0493b314738c$export$7c87d337fb91a97d = "#8993A4";
var $fefa0493b314738c$export$d6447c357493214f = "#7A869A";
var $fefa0493b314738c$export$f563ee71e9ee74cd = "#6B778C";
var $fefa0493b314738c$export$e2ef2124cf4024b1 = "#5E6C84";
var $fefa0493b314738c$export$eece5f492e429f08 = "#505F79";
var $fefa0493b314738c$export$c39c0fe0f26207ae = "#42526E";
var $fefa0493b314738c$export$7090862dc3038a9f = "#344563";
var $fefa0493b314738c$export$ad0bacf983b7ddaa = "#253858";
var $fefa0493b314738c$export$7d61b15e0da132af = "#172B4D";
var $fefa0493b314738c$export$fbda843f0a27fe96 = "#091E42";
var $fefa0493b314738c$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $fefa0493b314738c$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $fefa0493b314738c$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $fefa0493b314738c$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $fefa0493b314738c$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $fefa0493b314738c$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $fefa0493b314738c$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $fefa0493b314738c$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $fefa0493b314738c$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $fefa0493b314738c$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $fefa0493b314738c$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $fefa0493b314738c$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $fefa0493b314738c$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $fefa0493b314738c$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $fefa0493b314738c$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $fefa0493b314738c$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $fefa0493b314738c$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $fefa0493b314738c$export$2f6319cf7d736c2a = "#E6EDFA";
var $fefa0493b314738c$export$95126bc8884d6634 = "#DCE5F5";
var $fefa0493b314738c$export$8338d8c35d44ff1 = "#CED9EB";
var $fefa0493b314738c$export$5368d76ae4fbbda7 = "#B8C7E0";
var $fefa0493b314738c$export$9f0a771d16ec8d36 = "#ABBBD6";
var $fefa0493b314738c$export$abcf8c38338b4aa5 = "#9FB0CC";
var $fefa0493b314738c$export$97e81faa16a182c7 = "#8C9CB8";
var $fefa0493b314738c$export$bfe21c59123ecf33 = "#7988A3";
var $fefa0493b314738c$export$ee82aa2ea6a1558 = "#67758F";
var $fefa0493b314738c$export$682927c6ed76be02 = "#56637A";
var $fefa0493b314738c$export$91fd9994c5be9757 = "#455166";
var $fefa0493b314738c$export$d281fbfe3cff2df6 = "#3B475C";
var $fefa0493b314738c$export$3902c91d8b98a753 = "#313D52";
var $fefa0493b314738c$export$8e8133c1ba5845b5 = "#283447";
var $fefa0493b314738c$export$33ff357f6620b39 = "#202B3D";
var $fefa0493b314738c$export$633847cf062b69e0 = "#1B2638";
var $fefa0493b314738c$export$9776a6e503bdbf76 = "#121A29";
var $fefa0493b314738c$export$6c813d5160dff5db = "#0E1624";
var $fefa0493b314738c$export$3d4f271a500072a = "#0D1424";
var $fefa0493b314738c$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $fefa0493b314738c$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $fefa0493b314738c$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $fefa0493b314738c$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $fefa0493b314738c$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $fefa0493b314738c$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $fefa0493b314738c$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $fefa0493b314738c$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $fefa0493b314738c$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $fefa0493b314738c$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $fefa0493b314738c$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $fefa0493b314738c$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $fefa0493b314738c$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $fefa0493b314738c$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $fefa0493b314738c$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $fefa0493b314738c$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $fefa0493b314738c$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $fefa0493b314738c$export$d2adc5dedf09fced = "#292A2E";
var $fefa0493b314738c$export$f51762073d2bb381 = "#94C748";
var $fefa0493b314738c$export$95e26d54def96891 = "#B3DF72";


var $fb1ac8fe32f55ec7$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $fefa0493b314738c$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $fefa0493b314738c$export$215b7063051591f1);
            iconColor = (0, $fefa0493b314738c$export$215b7063051591f1);
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $fefa0493b314738c$export$b3de0ae08da2ce64);
            break;
        case "neutral":
            iconGradientStart = (0, $fefa0493b314738c$export$7090862dc3038a9f);
            iconGradientStop = (0, $fefa0493b314738c$export$d6447c357493214f);
            iconColor = (0, $fefa0493b314738c$export$d6447c357493214f);
            textColor = (0, $fefa0493b314738c$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $fefa0493b314738c$export$eece5f492e429f08);
            break;
        case "inverse":
            iconGradientStart = "#FFFFFF66";
            iconGradientStop = "#FFFFFF";
            iconColor = "#FFFFFF";
            textColor = "#FFFFFF";
            atlassianLogoTextColor = "#FFFFFF";
            break;
    }
    if (colorMode === "dark" && appearance === "inverse") {
        iconGradientStart = "#161A1D66";
        iconGradientStop = "#161A1D";
        iconColor = "#161A1D";
        textColor = "#161A1D";
        atlassianLogoTextColor = "#161A1D";
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $fb1ac8fe32f55ec7$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $fefa0493b314738c$export$29a4f05edc054374);
            textColor = (0, $fefa0493b314738c$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $fefa0493b314738c$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $fb1ac8fe32f55ec7$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $fb1ac8fe32f55ec7$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $fb1ac8fe32f55ec7$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $7953dadd1fa5ec08$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $7953dadd1fa5ec08$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Admin" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $7953dadd1fa5ec08$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $21bae2dd818c4fe5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 295 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"\n        fill="'.concat(colors.textColor, '"\n      />\n      <path\n        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="').concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $21bae2dd818c4fe5$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Admin" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $21bae2dd818c4fe5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $c1e42edfaa646593$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $c1e42edfaa646593$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Administration" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $c1e42edfaa646593$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $e13fcc7a826553f8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 404 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"\n        fill="'.concat(colors.textColor, '"\n      />\n      <path\n        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="').concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $e13fcc7a826553f8$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Administration" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $e13fcc7a826553f8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");





var $22b42216c0fc3499$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$362a25f017e2bc8a)(appearance, colorMode);
    return '<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <linearGradient id="'.concat(id, '-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">\n      <stop offset="0" stop-color="').concat(colors.iconGradientStart, '"/>\n      <stop offset="1" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n    <linearGradient id="').concat(id, '-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">\n      <stop offset="0" stop-color="').concat(colors.iconGradientStart, '"/>\n      <stop offset="1" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n    <linearGradient xlink:href="#').concat(id, '-b" id="').concat(id, '-c" x1="20.595" x2="20.595" y2="22"/>\n    <linearGradient xlink:href="#').concat(id, '-b" id="').concat(id, '-d" x1="36.595" x2="36.595" y2="20"/>\n  </defs>\n  <path d="M10.595 30h4v10h-4z" fill="url(#').concat(id, '-a)"/>\n  <path d="M26.595 27h4v13h-4z" fill="url(#').concat(id, '-b)"/>\n  <path d="M18.595 22h4v18h-4z" fill="url(#').concat(id, '-c)"/>\n  <path d="M34.595 20h4v20h-4z" fill="url(#').concat(id, '-d)"/>\n  <path fill="').concat(colors.iconColor, '" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />\n</svg>');
};
var $22b42216c0fc3499$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Analytics" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $d9f258fd1a7d4ed3$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $22b42216c0fc3499$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $acw62 = parcelRequire("acw62");





var $caff720ecdec5c01$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$362a25f017e2bc8a)(appearance, colorMode);
    return '\n  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <linearGradient id="'.concat(id, '-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">\n      <stop offset="0" stop-color="').concat(colors.iconGradientStart, '"/>\n      <stop offset="1" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n    <linearGradient xlink:href="#').concat(id, '-a" id="').concat(id, '-b" x1="463.285" x2="463.285" y2="27"/>\n    <linearGradient xlink:href="#').concat(id, '-a" id="').concat(id, '-c" x1="455.285" x2="455.285" y2="22"/>\n    <linearGradient xlink:href="#').concat(id, '-a" id="').concat(id, '-d" x1="471.285" x2="471.285" y2="20"/>\n  </defs>\n  <g fill="').concat(colors.atlassianLogoTextColor, '">\n    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>\n  </g>\n  <g fill="').concat(colors.textColor, '">\n    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>\n  </g>\n  <path fill="url(#').concat(id, '-a)" d="M445.285 30h4v10h-4z"/>\n  <path fill="url(#').concat(id, '-b)" d="M461.285 27h4v13h-4z"/>\n  <path fill="url(#').concat(id, '-c)" d="M453.285 22h4v18h-4z"/>\n  <path fill="url(#').concat(id, '-d)" d="M469.285 20h4v20h-4z"/>\n  <path fill="').concat(colors.iconColor, '" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>\n</svg>');
};
var $caff720ecdec5c01$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Analytics" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $d9f258fd1a7d4ed3$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $caff720ecdec5c01$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $22759bd0382941e5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>\n    </svg>');
};
var $22759bd0382941e5$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $22759bd0382941e5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $cfb212a2eb3cbaf1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n        <path fill='.concat(colors.iconColor, ' d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>\n        <path fill=').concat(colors.textColor, ' d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>\n      </svg>');
};
var $cfb212a2eb3cbaf1$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $cfb212a2eb3cbaf1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $0bfbeac4f0501e86$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>\n      </svg>\n    ');
};
var $0bfbeac4f0501e86$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $0bfbeac4f0501e86$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $fef14db60cd2367d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n    <path fill='.concat(colors.iconColor, ' d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>\n    <path fill="').concat(colors.textColor, '" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n  </svg>');
};
var $fef14db60cd2367d$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $fef14db60cd2367d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $6e0d171db60f6745$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>\n    </svg>');
};
var $6e0d171db60f6745$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $6e0d171db60f6745$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $832d38befabddb99$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>\n      <path fill="').concat(colors.textColor, '" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n    </svg>\n    ');
};
var $832d38befabddb99$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $832d38befabddb99$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $d15a583ec2fe742c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n		<path fill="'.concat(colors.iconColor, '" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>\n		</svg>\n		');
};
var $d15a583ec2fe742c$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Focus" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $d15a583ec2fe742c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $cc635597221a5f4f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n		<path fill="'.concat(colors.iconColor, '" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>\n		<path fill="').concat(colors.textColor, '" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>\n		<path fill="').concat(colors.textColor, '" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>\n		<path fill="').concat(colors.textColor, '" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>\n		<path fill="').concat(colors.textColor, '" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>\n		<path fill="').concat(colors.textColor, '" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>\n		</svg>\n		');
};
var $cc635597221a5f4f$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Focus" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $cc635597221a5f4f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $86cd348e3a4f4de5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $86cd348e3a4f4de5$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $86cd348e3a4f4de5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $5d9c2123a4aa0914$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">\n      <path\n        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $5d9c2123a4aa0914$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $5d9c2123a4aa0914$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $0b246855f8e78ecb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n    </svg>');
};
var $0b246855f8e78ecb$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $0b246855f8e78ecb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $024895ee62750b10$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n      <path fill="').concat(colors.textColor, '" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>\n    </svg>');
};
var $024895ee62750b10$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $024895ee62750b10$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $7dc352c5db27de89$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path\n      fill="'.concat(colors.iconColor, '"\n      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"\n    />\n  </svg>');
};
var $7dc352c5db27de89$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Align" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $7dc352c5db27de89$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $e38e75a9bcb6de66$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="'.concat(colors.iconColor, '"/>\n      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="').concat(colors.textColor, '"/>\n    </svg>\n  ');
};
var $e38e75a9bcb6de66$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Align" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e38e75a9bcb6de66$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $571873bccae0faaf$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>\n    </svg>');
};
var $571873bccae0faaf$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Product Discovery" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $571873bccae0faaf$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $032273ebcd6c1065$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />\n      <path fill="').concat(colors.textColor, '" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />\n    </svg>');
};
var $032273ebcd6c1065$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Product Discovery" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $032273ebcd6c1065$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $9265230e104331d7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>\n    </svg>');
};
var $9265230e104331d7$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $9265230e104331d7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $5ea0248ba6f35c04$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />\n      <path fill=').concat(colors.textColor, ' d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />\n    </svg>');
};
var $5ea0248ba6f35c04$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5ea0248ba6f35c04$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $f1c4e2fa549ddc84$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$7818df200941dbbf)(appearance, colorMode);
    return '<svg\n    fill="none"\n    height="32"\n    viewBox="0 0 32 32"\n    xmlns="http://www.w3.org/2000/svg"\n    focusable="false"\n    aria-hidden="true"\n  >\n    <path\n      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"\n      fill="'.concat(colors.iconColor, '"\n    />\n  </svg>');
};
var $f1c4e2fa549ddc84$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f1c4e2fa549ddc84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $09328424a4e90528$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$7818df200941dbbf)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 98 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $09328424a4e90528$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $09328424a4e90528$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");


var $62413b384d9af73e$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom Attribution" : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1c4e2fa549ddc84$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $0715748348ae29e5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$7818df200941dbbf)(appearance, colorMode);
    return '<svg\n		fill="none"\n		height="32"\n		xmlns="http://www.w3.org/2000/svg"\n		focusable="false"\n		aria-hidden="true"\n		viewBox="0 0 88 32"\n	>\n		<path\n			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"\n			fill="'.concat(colors.iconColor, '"\n		/>\n		<path\n			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"\n			fill="').concat(colors.textColor, '"\n		/>\n	</svg>');
};
var $0715748348ae29e5$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom Attribution" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0715748348ae29e5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $2e47b0d9fc891d65$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>\n    </svg>');
};
var $2e47b0d9fc891d65$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Opsgenie" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $2e47b0d9fc891d65$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $037c3ad0bf96075c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>\n      <path fill="').concat(colors.textColor, '" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />\n    </svg>');
};
var $037c3ad0bf96075c$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Opsgenie" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $037c3ad0bf96075c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $abaa6ebb8622622b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n    <g fill="'.concat(colors.iconColor, '" fill-rule="evenodd">\n      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>\n      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>\n    </g>\n  </svg>');
};
var $abaa6ebb8622622b$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $abaa6ebb8622622b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $71d862e8a73f5b02$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path\n        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"\n        fill="'.concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"\n        fill="').concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $71d862e8a73f5b02$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $71d862e8a73f5b02$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $411fc7402fdd8b8a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>\n    </svg>');
};
var $411fc7402fdd8b8a$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Statuspage" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $411fc7402fdd8b8a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $2a6da775ab319aaf$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />\n      <path fill="').concat(colors.textColor, '" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />\n    </svg>');
};
var $2a6da775ab319aaf$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Statuspage" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2a6da775ab319aaf$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $a279742c1dc97112$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>\n    </svg>');
};
var $a279742c1dc97112$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Trello" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $a279742c1dc97112$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $acw62 = parcelRequire("acw62");




var $2ecd66503a51128d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>\n      <path fill="').concat(colors.textColor, '" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>\n    </svg>');
};
var $2ecd66503a51128d$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Trello" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2ecd66503a51128d$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};




var $acw62 = parcelRequire("acw62");




var $8456a8cbaccd3322$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n    <path fill="'.concat(colors.iconColor, '" d="M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>\n  </svg>\n  ');
};
var $8456a8cbaccd3322$export$94c87d39a54a1894 = function AtlassianMarketplaceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Marketplace" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $8456a8cbaccd3322$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $acw62 = parcelRequire("acw62");




var $ddd1928b087fe365$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 32 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $ddd1928b087fe365$export$a825993f361832f7 = function AtlassianAccessIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Access" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $ddd1928b087fe365$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $acw62 = parcelRequire("acw62");




var $842d1a7a26358f8d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>\n    </svg>');
};
var $842d1a7a26358f8d$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $842d1a7a26358f8d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $acw62 = parcelRequire("acw62");




var $6141941182815d45$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $fb1ac8fe32f55ec7$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">\n      <path fill='.concat(colors.iconColor, ' d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>\n      <path fill=').concat(colors.atlassianLogoTextColor, ' d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>\n    </svg>');
};
var $6141941182815d45$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $5efdda03d2f7b098$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1da658d60a84779$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b8fc8846d5f5cb$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $6141941182815d45$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
var $944275e252366807$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $944275e252366807$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $944275e252366807$var$_excluded3 = [
    "shouldUseHexLogo"
], $944275e252366807$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $944275e252366807$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $944275e252366807$var$_excluded);
        if ((0, $ltooA.fg)("platform-logo-rebrand") || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            size: size || "medium"
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            size: size
        }, props));
    };
};
var $944275e252366807$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $944275e252366807$var$_excluded2);
        if ((0, $ltooA.fg)("platform-logo-rebrand") || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            size: size || "medium"
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            size: size
        }, props));
    };
};
var $944275e252366807$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $944275e252366807$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $944275e252366807$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref3, $944275e252366807$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $ltooA.fg)("platform-logo-rebrand-rovo-hex") || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $944275e252366807$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref4, $944275e252366807$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            size: size || "medium"
        }, props));
    };
};
var $944275e252366807$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $ltooA.fg)("platform-logo-rebrand-team-eu") ? $944275e252366807$export$667425256e2e7296(NewComponent) : $944275e252366807$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Logo, props);
    };
};
var $944275e252366807$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: "atlassian",
        type: "legacy",
        category: "program"
    },
    {
        name: "atlassian-access",
        type: "legacy",
        category: "program"
    },
    {
        name: "atlassian-marketplace",
        type: "legacy",
        category: "program"
    },
    // Home collection
    {
        name: "home",
        type: "new",
        category: "app"
    },
    {
        name: "hub",
        type: "new",
        category: "app"
    },
    // Teamwork collection
    {
        name: "confluence",
        type: "migration",
        category: "app"
    },
    {
        name: "jira",
        type: "migration",
        category: "app"
    },
    {
        name: "loom",
        type: "migration",
        category: "app"
    },
    {
        name: "loom-blurple",
        type: "new",
        category: "app",
        skipExample: true
    },
    {
        name: "loom-attribution",
        type: "migration",
        category: "app"
    },
    {
        name: "rovo",
        type: "rovo-hex",
        category: "app"
    },
    // Strategy collection
    {
        name: "align",
        type: "new",
        category: "app"
    },
    {
        name: "focus",
        type: "migration",
        category: "app"
    },
    {
        name: "talent",
        type: "new",
        category: "app"
    },
    // App collection
    {
        name: "jira-product-discovery",
        type: "migration",
        category: "app"
    },
    // Dev collection
    {
        name: "bitbucket",
        type: "migration",
        category: "app"
    },
    {
        name: "compass",
        type: "migration",
        category: "app"
    },
    {
        name: "dx",
        type: "new",
        category: "app",
        skipLogo: true
    },
    {
        name: "rovo-dev",
        type: "new",
        category: "app"
    },
    {
        name: "rovo-dev-agent",
        type: "new",
        category: "agent"
    },
    // Customer collection
    {
        name: "jira-service-management",
        type: "migration",
        category: "app"
    },
    {
        name: "assets",
        type: "new",
        category: "app"
    },
    {
        name: "customer-service-management",
        type: "new",
        category: "app"
    },
    {
        name: "opsgenie",
        type: "migration",
        category: "app"
    },
    {
        name: "statuspage",
        type: "migration",
        category: "app"
    },
    {
        name: "trello",
        type: "migration",
        category: "app"
    },
    // Platform Collection
    {
        name: "admin",
        type: "new",
        category: "app"
    },
    {
        name: "analytics",
        type: "new",
        category: "app"
    },
    {
        name: "chat",
        type: "new",
        category: "app"
    },
    {
        name: "goals",
        type: "new",
        category: "app"
    },
    {
        name: "guard",
        type: "migration",
        category: "app"
    },
    {
        name: "projects",
        type: "new",
        category: "app"
    },
    {
        name: "search",
        type: "new",
        category: "app"
    },
    {
        name: "studio",
        type: "new",
        category: "app"
    },
    {
        name: "teams",
        type: "new",
        category: "app"
    },
    // Data Center
    {
        name: "jira-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "jira-service-management-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "confluence-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "bitbucket-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "bamboo",
        type: "new",
        category: "app"
    },
    {
        name: "crowd",
        type: "new",
        category: "app"
    },
    // Deprecated
    {
        name: "atlassian-administration",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "atlassian-admin",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "atlassian-analytics",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "atlas",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "jira-align",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "jira-software",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "jira-work-management",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    }
];
var $944275e252366807$export$62e1212796a86b1b = $944275e252366807$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === "program" && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $944275e252366807$export$e0dee4a765830f4d = $944275e252366807$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === "app" && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $944275e252366807$export$a13ce90e90d7bfc1 = $944275e252366807$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === "agent" && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $944275e252366807$export$516fce44c502c1d3 = $944275e252366807$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === "legacy";
});
var $944275e252366807$export$b805fae8e798ed39 = $944275e252366807$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === "migration";
});
var $944275e252366807$export$3f9abd26214cd85f = $944275e252366807$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === "new";
});


/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $45d19b87dc78f9cb$export$ef8e5f836dd989d3 = (0, $944275e252366807$export$667425256e2e7296)((0, $389b8b1b2800932a$export$ef8e5f836dd989d3));
var $45d19b87dc78f9cb$export$ebcd30672e67406 = (0, $944275e252366807$export$667425256e2e7296)((0, $06bfb3ba32e0ee78$export$61afcb38c001e19));
var $45d19b87dc78f9cb$export$af3460f51ce3602a = (0, $944275e252366807$export$667425256e2e7296)((0, $edff975b886b81b5$export$af3460f51ce3602a));
var $45d19b87dc78f9cb$export$c8415b6abe4a8587 = (0, $944275e252366807$export$667425256e2e7296)((0, $9cbcfd3cc0c40d2e$export$f0bac2b7ac3e3504));
var $45d19b87dc78f9cb$export$d89497e7f33ca6f5 = (0, $944275e252366807$export$667425256e2e7296)((0, $4bb96c0c43e732a3$export$d89497e7f33ca6f5));
var $45d19b87dc78f9cb$export$48ca930f3071e3e4 = (0, $944275e252366807$export$667425256e2e7296)((0, $b4dde49fef9988c6$export$81c47abe19675c4c));
var $45d19b87dc78f9cb$export$52cd484a7ef4f2b9 = (0, $944275e252366807$export$3fe521abfbbe6ab3)((0, $ae7c6b8327e311a4$export$52cd484a7ef4f2b9), (0, $eb54878dd50bf49e$export$402a257da320c93c));
var $45d19b87dc78f9cb$export$9ca9881809919df8 = (0, $944275e252366807$export$3fe521abfbbe6ab3)((0, $c02b99fd709bbeed$export$a529e78951cd6709), (0, $616fdd30929bdb4a$export$a3af32a9109d706d));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $45d19b87dc78f9cb$export$6da5aa77c402ba0f = (0, $944275e252366807$export$667425256e2e7296)((0, $de05fcd9142ded5a$export$6da5aa77c402ba0f));
var $45d19b87dc78f9cb$export$abc95e6180bb1d88 = (0, $944275e252366807$export$667425256e2e7296)((0, $263e6e007aaeb431$export$f597f0f7fadce0b9));
var $45d19b87dc78f9cb$export$9eb74917ea768ed4 = (0, $944275e252366807$export$667425256e2e7296)((0, $275ae0200f102d48$export$9eb74917ea768ed4));
var $45d19b87dc78f9cb$export$d2577aa28451395f = (0, $944275e252366807$export$667425256e2e7296)((0, $fd69227292806c7a$export$c527a545aa426db3));
var $45d19b87dc78f9cb$export$92c8767b874048d = (0, $944275e252366807$export$667425256e2e7296)((0, $47d1491f82040549$export$92c8767b874048d));
var $45d19b87dc78f9cb$export$d5648119d5b68e90 = (0, $944275e252366807$export$667425256e2e7296)((0, $2075c2bbce887c7d$export$8b6b7f1b1b2367d3));
var $45d19b87dc78f9cb$export$80b8b269d8b5014e = (0, $944275e252366807$export$667425256e2e7296)((0, $30ad8371e835a074$export$80b8b269d8b5014e));
var $45d19b87dc78f9cb$export$fc9bd6687b80fe3b = (0, $944275e252366807$export$667425256e2e7296)((0, $9de88e29cd80743e$export$7a38180641471460));
var $45d19b87dc78f9cb$export$5ed3e1bb3b04fc02 = (0, $944275e252366807$export$667425256e2e7296)((0, $6244876ee6467f08$export$5ed3e1bb3b04fc02));
var $45d19b87dc78f9cb$export$aeefab651bcf2338 = (0, $944275e252366807$export$667425256e2e7296)((0, $e4698133c894240b$export$e3d1678155aaab99));
var $45d19b87dc78f9cb$export$8b784b3227531b3e = (0, $944275e252366807$export$667425256e2e7296)((0, $164df03114fbbcaa$export$8b784b3227531b3e));
var $45d19b87dc78f9cb$export$f0750468d67c6902 = (0, $944275e252366807$export$667425256e2e7296)((0, $99bdd9f1992e8f40$export$4145bd793c9ed1d0));
var $45d19b87dc78f9cb$export$813cff80931d9dbf = (0, $944275e252366807$export$667425256e2e7296)((0, $80b190b2c6d1a3af$export$813cff80931d9dbf));
var $45d19b87dc78f9cb$export$409b7a5b7f180eba = (0, $944275e252366807$export$667425256e2e7296)((0, $ff3d7785892415e9$export$58747af448450872));
var $45d19b87dc78f9cb$export$82eafebb825fc23f = (0, $944275e252366807$export$3fe521abfbbe6ab3)((0, $766fb46ef214d402$export$82eafebb825fc23f), (0, $e3bdc25c2a27fd27$export$3599582ddc9fc5cf));
var $45d19b87dc78f9cb$export$e4c5487c9a8ae3b1 = (0, $944275e252366807$export$3fe521abfbbe6ab3)((0, $fb006a7aa66b4da8$export$fa08cbfe393f2a68), (0, $ac7ed8c68efd9922$export$d669f6cbbb67e061));
var $45d19b87dc78f9cb$export$290a0f24614cde9f = (0, $944275e252366807$export$3fe521abfbbe6ab3)((0, $29371ccec0b1ddf9$export$290a0f24614cde9f), (0, $f2ea1e70f1121577$export$8bb9894377e04e04));
var $45d19b87dc78f9cb$export$8aceb78c659789b6 = (0, $944275e252366807$export$3fe521abfbbe6ab3)((0, $3a2fd83859f76fb5$export$273fd56580e523ae), (0, $22cb125270f1db64$export$170353c338ac5f4a));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $45d19b87dc78f9cb$export$4b05688514531169 = (0, $944275e252366807$export$667425256e2e7296)((0, $6bbe61ab629e7683$export$4b05688514531169));
var $45d19b87dc78f9cb$export$4f6453e012279f89 = (0, $944275e252366807$export$667425256e2e7296)((0, $7e731445474be878$export$1b3979d995ebbc6e));
var $45d19b87dc78f9cb$export$1bcbc9c337da86da = (0, $944275e252366807$export$667425256e2e7296)((0, $39ded4505b964a24$export$1bcbc9c337da86da));
var $45d19b87dc78f9cb$export$9b1a0a0c574cec2a = (0, $944275e252366807$export$667425256e2e7296)((0, $448e5173ec3ee7e8$export$bfd8d1c4da84ce71));
var $45d19b87dc78f9cb$export$e812398311cab9a3 = (0, $944275e252366807$export$667425256e2e7296)((0, $bd2d84735fedebfe$export$e812398311cab9a3));
var $45d19b87dc78f9cb$export$765f5afcc1a5a7e3 = (0, $944275e252366807$export$667425256e2e7296)((0, $a323cee89a9a05ab$export$7c51958462d750e));
var $45d19b87dc78f9cb$export$d3ab16bbf4f954ee = (0, $944275e252366807$export$667425256e2e7296)((0, $067b09dbd6819d21$export$d3ab16bbf4f954ee));
var $45d19b87dc78f9cb$export$36044946916e84a0 = (0, $944275e252366807$export$667425256e2e7296)((0, $490d5a0a0a56c1c0$export$cc55e2a4c4b40552));
var $45d19b87dc78f9cb$export$53305f1f2855d3be = (0, $944275e252366807$export$667425256e2e7296)((0, $a2f03718ae46777e$export$53305f1f2855d3be));
var $45d19b87dc78f9cb$export$5e06396bce773a3 = (0, $944275e252366807$export$667425256e2e7296)((0, $137d601d1a535d1e$export$b3e508cb103e1f93));
var $45d19b87dc78f9cb$export$eaf73f391f7103bd = (0, $944275e252366807$export$667425256e2e7296)((0, $0eb05e56f724b643$export$eaf73f391f7103bd));
var $45d19b87dc78f9cb$export$6128b385660fd3c6 = (0, $944275e252366807$export$667425256e2e7296)((0, $cec2c2045ffdb1e8$export$3c371bdbcdfcdce));
var $45d19b87dc78f9cb$export$f8455b5667a3ee0c = (0, $944275e252366807$export$667425256e2e7296)((0, $22a7b1ca56e1e7e4$export$f8455b5667a3ee0c));
var $45d19b87dc78f9cb$export$eb152ab3801b2ae3 = (0, $944275e252366807$export$667425256e2e7296)((0, $6a8cc8e9ae9d3712$export$3224b07bc93ef23e));
var $45d19b87dc78f9cb$export$65fae0eaf343f2ca = (0, $944275e252366807$export$667425256e2e7296)((0, $f8ed4acaa790938e$export$65fae0eaf343f2ca));
var $45d19b87dc78f9cb$export$fffc0d480fb1ebf1 = (0, $944275e252366807$export$667425256e2e7296)((0, $a45f9948f3045d50$export$f64bc7a7f04428d0));
var $45d19b87dc78f9cb$export$74517ed253186308 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $c1e42edfaa646593$export$74517ed253186308), (0, $389b8b1b2800932a$export$ef8e5f836dd989d3));
var $45d19b87dc78f9cb$export$833abe6c2ce5ebfd = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $e13fcc7a826553f8$export$833abe6c2ce5ebfd), (0, $06bfb3ba32e0ee78$export$61afcb38c001e19));
var $45d19b87dc78f9cb$export$84109e099492cb5f = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $7953dadd1fa5ec08$export$84109e099492cb5f), (0, $389b8b1b2800932a$export$ef8e5f836dd989d3));
var $45d19b87dc78f9cb$export$f845d9b9254f0541 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $21bae2dd818c4fe5$export$f845d9b9254f0541), (0, $06bfb3ba32e0ee78$export$61afcb38c001e19));
var $45d19b87dc78f9cb$export$c42ad8a0b925c762 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $22b42216c0fc3499$export$c42ad8a0b925c762), (0, $edff975b886b81b5$export$af3460f51ce3602a));
var $45d19b87dc78f9cb$export$e6470bfc39010cc4 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $caff720ecdec5c01$export$e6470bfc39010cc4), (0, $9cbcfd3cc0c40d2e$export$f0bac2b7ac3e3504));
var $45d19b87dc78f9cb$export$5fc1066e677788d4 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $22759bd0382941e5$export$5fc1066e677788d4), (0, $d8287d0c54ed02e0$export$5fc1066e677788d4));
var $45d19b87dc78f9cb$export$bd40525f5333524b = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $cfb212a2eb3cbaf1$export$bd40525f5333524b), (0, $a780c6309f692bcc$export$f7ef5e5488e4b430));
var $45d19b87dc78f9cb$export$f7857fe64d7161d9 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $0bfbeac4f0501e86$export$f7857fe64d7161d9), (0, $b39cbac8decb2b6f$export$f7857fe64d7161d9));
var $45d19b87dc78f9cb$export$eb7d748e4f9c9676 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $fef14db60cd2367d$export$eb7d748e4f9c9676), (0, $143b10adeb1437c2$export$a16f50a81d183ce));
var $45d19b87dc78f9cb$export$9951d02c2d848122 = (0, $944275e252366807$export$667425256e2e7296)((0, $bfe1584f17884468$export$9951d02c2d848122));
var $45d19b87dc78f9cb$export$68f3db7f6af48bcb = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $6e0d171db60f6745$export$68f3db7f6af48bcb), (0, $d02eabbaeea5900b$export$68f3db7f6af48bcb));
var $45d19b87dc78f9cb$export$1b2e4fe6ef471556 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $832d38befabddb99$export$1b2e4fe6ef471556), (0, $1e4ef953bb0b0ce8$export$a88b0b0da9ef63ce));
var $45d19b87dc78f9cb$export$70a0c2f5862937b6 = (0, $944275e252366807$export$667425256e2e7296)((0, $8e86b560d8a10730$export$70a0c2f5862937b6));
var $45d19b87dc78f9cb$export$1b8596b4b0ef673b = (0, $944275e252366807$export$667425256e2e7296)((0, $c1ef7924ce69dfc1$export$8b5103382c06639c));
var $45d19b87dc78f9cb$export$407687b2dd89cc68 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $7dc352c5db27de89$export$407687b2dd89cc68), (0, $8e86b560d8a10730$export$70a0c2f5862937b6));
var $45d19b87dc78f9cb$export$ee11e928d3d045fd = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $e38e75a9bcb6de66$export$ee11e928d3d045fd), (0, $c1ef7924ce69dfc1$export$8b5103382c06639c));
var $45d19b87dc78f9cb$export$c4b5b1f965d8b3eb = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $0b246855f8e78ecb$export$c4b5b1f965d8b3eb), (0, $172adace76e64264$export$c4b5b1f965d8b3eb));
var $45d19b87dc78f9cb$export$17d3acb0b4379d02 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $024895ee62750b10$export$17d3acb0b4379d02), (0, $066a5c848b759317$export$bf4c5f97b468e8d6));
var $45d19b87dc78f9cb$export$21bfbeb62fdcce8d = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $571873bccae0faaf$export$21bfbeb62fdcce8d), (0, $92f2476a81097332$export$21bfbeb62fdcce8d));
var $45d19b87dc78f9cb$export$c49a2b642fe9eef4 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $032273ebcd6c1065$export$c49a2b642fe9eef4), (0, $dcf243f0003cb84d$export$602140a6a10b02bf));
var $45d19b87dc78f9cb$export$3c6158790f5e01c4 = (0, $944275e252366807$export$436fcf6e31fbacea)((0, $9265230e104331d7$export$3c6158790f5e01c4), (0, $1d972312520cf5b4$export$3c6158790f5e01c4));
var $45d19b87dc78f9cb$export$dabef2be6cd28c20 = (0, $944275e252366807$export$436fcf6e31fbacea)((0, $5ea0248ba6f35c04$export$dabef2be6cd28c20), (0, $92f93af52daa0f2b$export$de148263c75d2bc1));
var $45d19b87dc78f9cb$export$8d789f76fde3e05 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $f1c4e2fa549ddc84$export$8d789f76fde3e05), (0, $e29e92b5a98504c2$export$8d789f76fde3e05));
var $45d19b87dc78f9cb$export$94e206806e36c2ec = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $09328424a4e90528$export$94e206806e36c2ec), (0, $8719046addaa058e$export$78c0b4d8be34c9b2));
var $45d19b87dc78f9cb$export$1bf47cdade1a9fcb = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $62413b384d9af73e$export$1bf47cdade1a9fcb), (0, $e29e92b5a98504c2$export$8d789f76fde3e05));
var $45d19b87dc78f9cb$export$6e87ce8d41eda665 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $0715748348ae29e5$export$6e87ce8d41eda665), (0, $00491de52be214f2$export$68d7391318cdef11));
var $45d19b87dc78f9cb$export$e84e925618e0e5bc = (0, $944275e252366807$export$667425256e2e7296)((0, $992f074dc45a9024$export$71743a944cb62e48));
var $45d19b87dc78f9cb$export$1940ba72c868b663 = (0, $944275e252366807$export$667425256e2e7296)((0, $f8a9b027bd58ae6c$export$38c7b37a3e5e8d70));
var $45d19b87dc78f9cb$export$eeccc49dc7a12d9f = (0, $944275e252366807$export$436fcf6e31fbacea)((0, $2e47b0d9fc891d65$export$eeccc49dc7a12d9f), (0, $9f44e5126ceeef9a$export$eeccc49dc7a12d9f));
var $45d19b87dc78f9cb$export$a1c6484cdecc2c4b = (0, $944275e252366807$export$436fcf6e31fbacea)((0, $037c3ad0bf96075c$export$a1c6484cdecc2c4b), (0, $915e8cdab12f40ca$export$a5b9122e89b32ad3));
var $45d19b87dc78f9cb$export$f3f5aa321d88adf9 = (0, $944275e252366807$export$436fcf6e31fbacea)((0, $411fc7402fdd8b8a$export$f3f5aa321d88adf9), (0, $59858f423d37a0b2$export$f3f5aa321d88adf9));
var $45d19b87dc78f9cb$export$bb4ae5b41b43be04 = (0, $944275e252366807$export$436fcf6e31fbacea)((0, $2a6da775ab319aaf$export$bb4ae5b41b43be04), (0, $8b73fa1b409b7104$export$2bc88a281410ffa7));
var $45d19b87dc78f9cb$export$4384da9b8b140bf4 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $a279742c1dc97112$export$4384da9b8b140bf4), (0, $5ebd85c600ef3dd2$export$4384da9b8b140bf4));
var $45d19b87dc78f9cb$export$60e26212f3b61a28 = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $2ecd66503a51128d$export$60e26212f3b61a28), (0, $f8f7447a24ac65b3$export$1b13139dfc0336af));
var $45d19b87dc78f9cb$export$e23ae35269442b4f = (0, $944275e252366807$export$2469203854060337)((0, $abaa6ebb8622622b$export$e23ae35269442b4f), (0, $4e67e66e4b0b1efe$export$e23ae35269442b4f), (0, $3f54e27315cfac6a$export$9e62346a60cfb459));
var $45d19b87dc78f9cb$export$a0f6cb8061290bbb = (0, $944275e252366807$export$2469203854060337)((0, $71d862e8a73f5b02$export$a0f6cb8061290bbb), (0, $5c3b42793bddd50a$export$b0e15f0a1c9f4c55), (0, $e79e6eeb85a8b7f7$export$5e38d02efdb45577));
var $45d19b87dc78f9cb$export$3f95fcfdc25a741d = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $86cd348e3a4f4de5$export$3f95fcfdc25a741d), (0, $4f11de1cd57a5781$export$3f95fcfdc25a741d));
var $45d19b87dc78f9cb$export$a4a891d202775deb = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $5d9c2123a4aa0914$export$a4a891d202775deb), (0, $603ee49aea6e4f7d$export$2b896c4d595a4331));
var $45d19b87dc78f9cb$export$1e02e7298035a77c = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $d15a583ec2fe742c$export$1e02e7298035a77c), (0, $d72ce01a33d80f56$export$1e02e7298035a77c));
var $45d19b87dc78f9cb$export$33908560ea1b226d = (0, $944275e252366807$export$e30d2ddc605f6bb)((0, $cc635597221a5f4f$export$33908560ea1b226d), (0, $2d128798336b30d6$export$3a6e8b37e069a69d));



var $heRj3 = parcelRequire("heRj3");

var $hw8Qv = parcelRequire("hw8Qv");

var $g5Zhu = parcelRequire("g5Zhu");
var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;



var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $4e1d73e488a0f736$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e1d73e488a0f736$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e1d73e488a0f736$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e1d73e488a0f736$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4e1d73e488a0f736$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $4e1d73e488a0f736$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $4e1d73e488a0f736$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $4e1d73e488a0f736$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $4e1d73e488a0f736$var$_objectSpread($4e1d73e488a0f736$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $181b6956620c3a2a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $181b6956620c3a2a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $181b6956620c3a2a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($181b6956620c3a2a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $181b6956620c3a2a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $181b6956620c3a2a$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $181b6956620c3a2a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $181b6956620c3a2a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $181b6956620c3a2a$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $181b6956620c3a2a$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4e1d73e488a0f736$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $77be73ef68092118$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $96b1e5c5f6a491d2$export$5bf35293e545f20c() {
    var analyticsContext = (0, $77be73ef68092118$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $181b6956620c3a2a$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
var $076d3965bb632c3d$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $076d3965bb632c3d$var$react18UseId = ($076d3965bb632c3d$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $076d3965bb632c3d$var$_React$useId !== void 0 ? $076d3965bb632c3d$var$_React$useId : undefined;
function $076d3965bb632c3d$export$f680877a34711e37() {
    if ($076d3965bb632c3d$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $076d3965bb632c3d$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $e0ee72d35d886c5b$export$87d05f07e65211f1)());
}
var $076d3965bb632c3d$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($076d3965bb632c3d$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $076d3965bb632c3d$export$6ee17796e3d70de2() {
    if ($076d3965bb632c3d$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $076d3965bb632c3d$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $e0ee72d35d886c5b$export$bb5ca5fba6fb4f1f)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
var $671ea2626c6c4bdd$var$BORDER_WIDTH = 2;
var $671ea2626c6c4bdd$var$baseFocusOutsideStyles = (0, $gyDKM.css)({
    outline: "".concat($671ea2626c6c4bdd$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $671ea2626c6c4bdd$var$BORDER_WIDTH
});
var $671ea2626c6c4bdd$var$baseInsetStyles = (0, $gyDKM.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$671ea2626c6c4bdd$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $671ea2626c6c4bdd$var$focusRingStyles = (0, $gyDKM.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $671ea2626c6c4bdd$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $671ea2626c6c4bdd$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $671ea2626c6c4bdd$var$insetFocusRingStyles = (0, $gyDKM.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $671ea2626c6c4bdd$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $671ea2626c6c4bdd$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $671ea2626c6c4bdd$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $671ea2626c6c4bdd$var$baseInsetStyles : $671ea2626c6c4bdd$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $671ea2626c6c4bdd$var$insetFocusRingStyles : $671ea2626c6c4bdd$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $gyDKM.jsx)((0, $gyDKM.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$671ea2626c6c4bdd$var$FocusRing.displayName = "FocusRing";
var $671ea2626c6c4bdd$export$2e2bcd8739ae039 = $671ea2626c6c4bdd$var$FocusRing;



var $ltooA = parcelRequire("ltooA");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $18a5b0c0f47f6a46$export$4b84fd0e2c617bd = "#FFEBE6";
var $18a5b0c0f47f6a46$export$b34b069eff244586 = "#FFBDAD";
var $18a5b0c0f47f6a46$export$be802dd0d8b57f35 = "#FF8F73";
var $18a5b0c0f47f6a46$export$60847d42f9da92a6 = "#FF7452";
var $18a5b0c0f47f6a46$export$4a7404f376229999 = "#FF5630";
var $18a5b0c0f47f6a46$export$2010d0fb4295b346 = "#DE350B";
var $18a5b0c0f47f6a46$export$2837b5a1a71d5c02 = "#BF2600";
var $18a5b0c0f47f6a46$export$8d9596b529bbb9cf = "#FFFAE6";
var $18a5b0c0f47f6a46$export$41060a744ab0b7ae = "#FFF0B3";
var $18a5b0c0f47f6a46$export$1cc05bbbf340e559 = "#FFE380";
var $18a5b0c0f47f6a46$export$5aae31392d72caaa = "#FFC400";
var $18a5b0c0f47f6a46$export$c6930421db9fa514 = "#FFAB00";
var $18a5b0c0f47f6a46$export$59619663aa6500fb = "#FF991F";
var $18a5b0c0f47f6a46$export$874739ea9e379ab6 = "#FF8B00";
var $18a5b0c0f47f6a46$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $18a5b0c0f47f6a46$export$69a3bf21b9686c2b = "#ABF5D1";
var $18a5b0c0f47f6a46$export$afbce1382ec95f73 = "#79F2C0";
var $18a5b0c0f47f6a46$export$747d86715d4175de = "#57D9A3";
var $18a5b0c0f47f6a46$export$940e1f69e873f202 = "#36B37E";
var $18a5b0c0f47f6a46$export$a49394138f7b8e85 = "#00875A";
var $18a5b0c0f47f6a46$export$6fa04827ac68a4fb = "#006644";
var $18a5b0c0f47f6a46$export$226de0355ed012f8 = "#DEEBFF";
var $18a5b0c0f47f6a46$export$8c13c2ee36917869 = "#B3D4FF";
var $18a5b0c0f47f6a46$export$ecfc1dff386a3e7a = "#4C9AFF";
var $18a5b0c0f47f6a46$export$215b7063051591f1 = "#2684FF";
var $18a5b0c0f47f6a46$export$e62e8919cca44969 = "#0065FF";
var $18a5b0c0f47f6a46$export$b3de0ae08da2ce64 = "#0052CC";
var $18a5b0c0f47f6a46$export$a6ee3d71bc067634 = "#0747A6";
var $18a5b0c0f47f6a46$export$67f15409e87642a1 = "#669DF1";
var $18a5b0c0f47f6a46$export$f0539dbc42dbb067 = "#8FB8F6";
var $18a5b0c0f47f6a46$export$363e4475840015bb = "#EAE6FF";
var $18a5b0c0f47f6a46$export$4b0a4417ed59760f = "#C0B6F2";
var $18a5b0c0f47f6a46$export$6011520a64d9a187 = "#998DD9";
var $18a5b0c0f47f6a46$export$a7175d4e9206bc80 = "#8777D9";
var $18a5b0c0f47f6a46$export$b48405b95304b5a1 = "#6554C0";
var $18a5b0c0f47f6a46$export$c71e4279dd54a18d = "#5243AA";
var $18a5b0c0f47f6a46$export$147899de772240ec = "#403294";
var $18a5b0c0f47f6a46$export$2cf711fe14c66f06 = "#E6FCFF";
var $18a5b0c0f47f6a46$export$7a8f4d33f6f9772c = "#B3F5FF";
var $18a5b0c0f47f6a46$export$776c9c497ef08533 = "#79E2F2";
var $18a5b0c0f47f6a46$export$69cb3ca10c1e330e = "#00C7E6";
var $18a5b0c0f47f6a46$export$9dc1ef0f3f48059b = "#00B8D9";
var $18a5b0c0f47f6a46$export$7c835c78b6fcdef8 = "#00A3BF";
var $18a5b0c0f47f6a46$export$6036577f95c3877e = "#008DA6";
var $18a5b0c0f47f6a46$export$29a4f05edc054374 = "#FFFFFF";
var $18a5b0c0f47f6a46$export$e655ef011c4aa1a2 = "#FAFBFC";
var $18a5b0c0f47f6a46$export$9fdfb749e33cdf97 = "#F4F5F7";
var $18a5b0c0f47f6a46$export$3e51e8f1440314ba = "#EBECF0";
var $18a5b0c0f47f6a46$export$1ce2d1575d444ceb = "#DFE1E6";
var $18a5b0c0f47f6a46$export$8754fc7e6d8b3000 = "#C1C7D0";
var $18a5b0c0f47f6a46$export$c2e91cbeada39b8b = "#B3BAC5";
var $18a5b0c0f47f6a46$export$5f71e19f3a7ad9de = "#A5ADBA";
var $18a5b0c0f47f6a46$export$eaa8c8a70ac22806 = "#97A0AF";
var $18a5b0c0f47f6a46$export$7c87d337fb91a97d = "#8993A4";
var $18a5b0c0f47f6a46$export$d6447c357493214f = "#7A869A";
var $18a5b0c0f47f6a46$export$f563ee71e9ee74cd = "#6B778C";
var $18a5b0c0f47f6a46$export$e2ef2124cf4024b1 = "#5E6C84";
var $18a5b0c0f47f6a46$export$eece5f492e429f08 = "#505F79";
var $18a5b0c0f47f6a46$export$c39c0fe0f26207ae = "#42526E";
var $18a5b0c0f47f6a46$export$7090862dc3038a9f = "#344563";
var $18a5b0c0f47f6a46$export$ad0bacf983b7ddaa = "#253858";
var $18a5b0c0f47f6a46$export$7d61b15e0da132af = "#172B4D";
var $18a5b0c0f47f6a46$export$fbda843f0a27fe96 = "#091E42";
var $18a5b0c0f47f6a46$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $18a5b0c0f47f6a46$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $18a5b0c0f47f6a46$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $18a5b0c0f47f6a46$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $18a5b0c0f47f6a46$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $18a5b0c0f47f6a46$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $18a5b0c0f47f6a46$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $18a5b0c0f47f6a46$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $18a5b0c0f47f6a46$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $18a5b0c0f47f6a46$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $18a5b0c0f47f6a46$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $18a5b0c0f47f6a46$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $18a5b0c0f47f6a46$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $18a5b0c0f47f6a46$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $18a5b0c0f47f6a46$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $18a5b0c0f47f6a46$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $18a5b0c0f47f6a46$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $18a5b0c0f47f6a46$export$2f6319cf7d736c2a = "#E6EDFA";
var $18a5b0c0f47f6a46$export$95126bc8884d6634 = "#DCE5F5";
var $18a5b0c0f47f6a46$export$8338d8c35d44ff1 = "#CED9EB";
var $18a5b0c0f47f6a46$export$5368d76ae4fbbda7 = "#B8C7E0";
var $18a5b0c0f47f6a46$export$9f0a771d16ec8d36 = "#ABBBD6";
var $18a5b0c0f47f6a46$export$abcf8c38338b4aa5 = "#9FB0CC";
var $18a5b0c0f47f6a46$export$97e81faa16a182c7 = "#8C9CB8";
var $18a5b0c0f47f6a46$export$bfe21c59123ecf33 = "#7988A3";
var $18a5b0c0f47f6a46$export$ee82aa2ea6a1558 = "#67758F";
var $18a5b0c0f47f6a46$export$682927c6ed76be02 = "#56637A";
var $18a5b0c0f47f6a46$export$91fd9994c5be9757 = "#455166";
var $18a5b0c0f47f6a46$export$d281fbfe3cff2df6 = "#3B475C";
var $18a5b0c0f47f6a46$export$3902c91d8b98a753 = "#313D52";
var $18a5b0c0f47f6a46$export$8e8133c1ba5845b5 = "#283447";
var $18a5b0c0f47f6a46$export$33ff357f6620b39 = "#202B3D";
var $18a5b0c0f47f6a46$export$633847cf062b69e0 = "#1B2638";
var $18a5b0c0f47f6a46$export$9776a6e503bdbf76 = "#121A29";
var $18a5b0c0f47f6a46$export$6c813d5160dff5db = "#0E1624";
var $18a5b0c0f47f6a46$export$3d4f271a500072a = "#0D1424";
var $18a5b0c0f47f6a46$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $18a5b0c0f47f6a46$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $18a5b0c0f47f6a46$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $18a5b0c0f47f6a46$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $18a5b0c0f47f6a46$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $18a5b0c0f47f6a46$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $18a5b0c0f47f6a46$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $18a5b0c0f47f6a46$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $18a5b0c0f47f6a46$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $18a5b0c0f47f6a46$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $18a5b0c0f47f6a46$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $18a5b0c0f47f6a46$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $18a5b0c0f47f6a46$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $18a5b0c0f47f6a46$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $18a5b0c0f47f6a46$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $18a5b0c0f47f6a46$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $18a5b0c0f47f6a46$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $18a5b0c0f47f6a46$export$d2adc5dedf09fced = "#292A2E";
var $18a5b0c0f47f6a46$export$f51762073d2bb381 = "#94C748";
var $18a5b0c0f47f6a46$export$95e26d54def96891 = "#B3DF72";



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
var $bab1e653cfee6efc$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67744cfb74ed451c0181f18c132cbdd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($bab1e653cfee6efc$exports, "__esModule", {
    value: true
});
$bab1e653cfee6efc$exports.default = void 0;

var $bab1e653cfee6efc$var$_react = $bab1e653cfee6efc$var$_interopRequireDefault((parcelRequire("acw62")));

var $bab1e653cfee6efc$var$_person = $bab1e653cfee6efc$var$_interopRequireDefault((parcelRequire("9EzYg")));

var $bab1e653cfee6efc$var$_person2 = $bab1e653cfee6efc$var$_interopRequireDefault((parcelRequire("cjWe6")));
function $bab1e653cfee6efc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bab1e653cfee6efc$var$PersonIcon = (props)=>/*#__PURE__*/ $bab1e653cfee6efc$var$_react.default.createElement($bab1e653cfee6efc$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $bab1e653cfee6efc$var$_person2.default
    }, props));
$bab1e653cfee6efc$var$PersonIcon.Name = "PersonIconMigration";
var $bab1e653cfee6efc$var$_default = $bab1e653cfee6efc$exports.default = $bab1e653cfee6efc$var$PersonIcon;


var $aefc0178905eb079$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($aefc0178905eb079$exports, "__esModule", {
    value: true
});
$aefc0178905eb079$exports.default = void 0;

var $aefc0178905eb079$var$_react = $aefc0178905eb079$var$_interopRequireDefault((parcelRequire("acw62")));

var $aefc0178905eb079$var$_release = $aefc0178905eb079$var$_interopRequireDefault((parcelRequire("jx3Bs")));

var $aefc0178905eb079$var$_ship = $aefc0178905eb079$var$_interopRequireDefault((parcelRequire("fxKJj")));
function $aefc0178905eb079$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aefc0178905eb079$var$ReleaseIcon = (props)=>/*#__PURE__*/ $aefc0178905eb079$var$_react.default.createElement($aefc0178905eb079$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $aefc0178905eb079$var$_ship.default
    }, props));
$aefc0178905eb079$var$ReleaseIcon.Name = "ReleaseIconMigration";
var $aefc0178905eb079$var$_default = $aefc0178905eb079$exports.default = $aefc0178905eb079$var$ReleaseIcon;



var $9EzYg = parcelRequire("9EzYg");

var $jx3Bs = parcelRequire("jx3Bs");

var $ltooA = parcelRequire("ltooA");

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
/* eslint-disable no-console */ var $5c2437965df02b6b$var$printed = {};
function $5c2437965df02b6b$export$2e2bcd8739ae039(message) {
    if ($5c2437965df02b6b$var$printed[message]) return;
    $5c2437965df02b6b$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $029348dfd930b4ab$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $5c2437965df02b6b$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $029348dfd930b4ab$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $1c00ac34120f9784$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $1c00ac34120f9784$export$c93026a968943f95 = "light";
var $1c00ac34120f9784$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $1c00ac34120f9784$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $1c00ac34120f9784$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $1c00ac34120f9784$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $18a5b0c0f47f6a46$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1c00ac34120f9784$export$6d8204c2cb2e06b8() / 4;
    (0, $029348dfd930b4ab$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $1c00ac34120f9784$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $1c00ac34120f9784$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $1c00ac34120f9784$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $029348dfd930b4ab$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $1c00ac34120f9784$export$ba1d834b86d72a09 = $1c00ac34120f9784$export$a1b3edb637fb4f35;
var $1c00ac34120f9784$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $18a5b0c0f47f6a46$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $18a5b0c0f47f6a46$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $18a5b0c0f47f6a46$export$920c0d5c49070351), ")")
            }
        }
    };
};


var $17355254f832570a$export$9a270941bcff7e77 = {
    xsmall: (0, $1c00ac34120f9784$export$6d8204c2cb2e06b8)() * 2,
    small: (0, $1c00ac34120f9784$export$6d8204c2cb2e06b8)() * 3,
    medium: (0, $1c00ac34120f9784$export$6d8204c2cb2e06b8)() * 4,
    large: (0, $1c00ac34120f9784$export$6d8204c2cb2e06b8)() * 5,
    xlarge: (0, $1c00ac34120f9784$export$6d8204c2cb2e06b8)() * 12,
    xxlarge: (0, $1c00ac34120f9784$export$6d8204c2cb2e06b8)() * 16
};
var $17355254f832570a$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $17355254f832570a$export$e2bd4c1faded7921 = 2;
var $17355254f832570a$export$89a980dfdf90df51 = 0.9;
var $17355254f832570a$export$3c061e31594ebabe = "--avatar-background-color";
var $17355254f832570a$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $17355254f832570a$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};


function $7887bffaab575cbb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7887bffaab575cbb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7887bffaab575cbb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7887bffaab575cbb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7887bffaab575cbb$var$avatarDefaultIconStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $18a5b0c0f47f6a46$export$7c87d337fb91a97d), ")")
});
var $7887bffaab575cbb$var$avatarDefaultIconVisualRefreshStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $7887bffaab575cbb$var$nestedAvatarStyles = Object.entries((0, $17355254f832570a$export$9a270941bcff7e77)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $7887bffaab575cbb$var$_objectSpread($7887bffaab575cbb$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, key, (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& svg": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $7887bffaab575cbb$var$avatarImageStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $7887bffaab575cbb$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $17355254f832570a$export$e6da6efe4d1a5c9b)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $acw62.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $gyDKM.jsx)("span", {
        css: [
            (0, $ltooA.fg)("platform-component-visual-refresh") ? $7887bffaab575cbb$var$avatarDefaultIconVisualRefreshStyles : $7887bffaab575cbb$var$avatarDefaultIconStyles,
            $7887bffaab575cbb$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $ltooA.fg)("platform-component-visual-refresh") ? (0, $gyDKM.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9EzYg))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $gyDKM.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bab1e653cfee6efc$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $18a5b0c0f47f6a46$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $ltooA.fg)("platform-component-visual-refresh") ? (0, $gyDKM.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jx3Bs))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $gyDKM.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aefc0178905eb079$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $18a5b0c0f47f6a46$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return (0, $gyDKM.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $7887bffaab575cbb$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : "avatar-image",
        "data-ssr-placeholder-ignored": true
    });
};
var $7887bffaab575cbb$export$2e2bcd8739ae039 = $7887bffaab575cbb$var$AvatarImage;




var $acw62 = parcelRequire("acw62");
var $a36905fd7123b35d$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $a36905fd7123b35d$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $acw62.useContext)($a36905fd7123b35d$export$a20dad690e1279e2);
};



var $acw62 = parcelRequire("acw62");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gyDKM = parcelRequire("gyDKM");


var $d17e461bf5a9107b$var$iconWrapperStyles = (0, $gyDKM.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $d17e461bf5a9107b$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")") : _ref$bgColor, children = _ref.children;
    return (0, $gyDKM.jsx)("span", {
        css: $d17e461bf5a9107b$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $17355254f832570a$export$e2bd4c1faded7921), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $d17e461bf5a9107b$export$2e2bcd8739ae039 = $d17e461bf5a9107b$var$IconWrapper;


var $197e26d7c9cb80b0$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $18a5b0c0f47f6a46$export$4a7404f376229999), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $197e26d7c9cb80b0$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $18a5b0c0f47f6a46$export$b48405b95304b5a1), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $197e26d7c9cb80b0$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $18a5b0c0f47f6a46$export$f563ee71e9ee74cd), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$1ce2d1575d444ceb), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $197e26d7c9cb80b0$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $18a5b0c0f47f6a46$export$940e1f69e873f202), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $197e26d7c9cb80b0$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $197e26d7c9cb80b0$var$BusyIndicator;
        case "focus":
            return $197e26d7c9cb80b0$var$FocusIndicator;
        case "offline":
            return $197e26d7c9cb80b0$var$OfflineIndicator;
        case "online":
            return $197e26d7c9cb80b0$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $197e26d7c9cb80b0$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d17e461bf5a9107b$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $197e26d7c9cb80b0$var$getPresence(presence)) : children);
};
var $197e26d7c9cb80b0$export$2e2bcd8739ae039 = $197e26d7c9cb80b0$var$AvatarPresence;
var $197e26d7c9cb80b0$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $17355254f832570a$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: "none",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $17355254f832570a$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $17355254f832570a$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($197e26d7c9cb80b0$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};



var $acw62 = parcelRequire("acw62");



var $ca30fff773cac154$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $18a5b0c0f47f6a46$export$a49394138f7b8e85), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $ca30fff773cac154$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $18a5b0c0f47f6a46$export$2010d0fb4295b346), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $ca30fff773cac154$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $18a5b0c0f47f6a46$export$1ce2d1575d444ceb), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$c39c0fe0f26207ae), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $ca30fff773cac154$var$getStatus(status) {
    switch(status){
        case "approved":
            return $ca30fff773cac154$var$ApprovedIndicator;
        case "declined":
            return $ca30fff773cac154$var$DeclinedIndicator;
        case "locked":
            return $ca30fff773cac154$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $ca30fff773cac154$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d17e461bf5a9107b$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $ca30fff773cac154$var$getStatus(status)) : children);
};
var $ca30fff773cac154$export$2e2bcd8739ae039 = $ca30fff773cac154$var$AvatarStatus;
var $ca30fff773cac154$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $17355254f832570a$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $17355254f832570a$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $17355254f832570a$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca30fff773cac154$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $b3907fdf85e78486$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $b3907fdf85e78486$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $b3907fdf85e78486$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};


var $8ba2d884d9509fca$var$_templateObject;
function $8ba2d884d9509fca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ba2d884d9509fca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ba2d884d9509fca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ba2d884d9509fca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8ba2d884d9509fca$var$packageName = "@atlaskit/avatar";
var $8ba2d884d9509fca$var$packageVersion = "21.18.4";
var $8ba2d884d9509fca$var$getTestId = function getTestId(testId, children) {
    return !children ? {
        "data-testid": "".concat(testId, "--inner")
    } : {
        testId: "".concat(testId, "--inner")
    };
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $8ba2d884d9509fca$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $ltooA.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($8ba2d884d9509fca$var$_templateObject || ($8ba2d884d9509fca$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
        "\n		height: ",
        "px;\n		width: ",
        "px;\n		align-items: stretch;\n		background-color: ",
        ";\n		border-radius: ",
        ";\n		box-sizing: content-box;\n		cursor: inherit;\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		outline: none;\n		overflow: hidden;\n		position: static;\n		transform: translateZ(0);\n		transition:\n			transform 200ms,\n			opacity 200ms;\n		box-shadow: 0 0 0 ",
        "px ",
        ";\n		border: none;\n		margin: ",
        ";\n		padding: ",
        ";\n\n		&::-moz-focus-inner {\n			border: 0;\n			margin: ",
        ";\n			padding: ",
        ";\n		}\n\n		&::after {\n			background-color: transparent;\n			inset: 0px;\n\n			/* Added border-radius style to fix hover issue in safari */\n			border-radius: ",
        ";\n			content: ' ';\n			opacity: 0;\n			pointer-events: none;\n			position: absolute;\n			transition: opacity 200ms;\n			width: 100%;\n		}\n\n		:focus-visible {\n			box-shadow: none;\n		}\n\n		",
        "\n\n		",
        "\n\n    ",
        "\n	"
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $17355254f832570a$export$e2bd4c1faded7921), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :hover {\n        &::after {\n          background-color: ".concat("var(--ds-interaction-hovered, ".concat((0, $18a5b0c0f47f6a46$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $18a5b0c0f47f6a46$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(", (0, $17355254f832570a$export$89a980dfdf90df51), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $18a5b0c0f47f6a46$export$29a4f05edc054374), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $8ba2d884d9509fca$var$Avatar = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var _ref3;
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, sizeProp = _ref2.size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? "div" : _ref2$as;
    var _useAnalyticsEvents = (0, $96b1e5c5f6a491d2$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $a36905fd7123b35d$export$b50b87a1c4086b23)();
    var size = (_ref3 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : context === null || context === void 0 ? void 0 : context.size) !== null && _ref3 !== void 0 ? _ref3 : "medium";
    var customPresenceNode = /*#__PURE__*/ (0, $acw62.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $acw62.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $acw62.useRef)(analyticsContext);
    var labelId = (0, $076d3965bb632c3d$export$f680877a34711e37)();
    (0, $acw62.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $8ba2d884d9509fca$var$packageName,
                packageVersion: $8ba2d884d9509fca$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $8ba2d884d9509fca$var$_objectSpread({
            componentName: "avatar",
            packageName: $8ba2d884d9509fca$var$packageName,
            packageVersion: $8ba2d884d9509fca$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $8ba2d884d9509fca$var$_objectSpread($8ba2d884d9509fca$var$_objectSpread({}, href && (0, $b3907fdf85e78486$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $b3907fdf85e78486$export$cca6f1bef43616d3)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $gyDKM.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: "inline-block",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "relative",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $gyDKM.jsx)((0, $gyDKM.ClassNames), null, function(_ref4) {
        var css = _ref4.css;
        var props = $8ba2d884d9509fca$var$_objectSpread($8ba2d884d9509fca$var$_objectSpread($8ba2d884d9509fca$var$_objectSpread($8ba2d884d9509fca$var$_objectSpread({
            className: $8ba2d884d9509fca$var$getStyles(css, {
                size: (0, $17355254f832570a$export$9a270941bcff7e77)[size],
                radius: (0, $17355254f832570a$export$e6da6efe4d1a5c9b)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && $8ba2d884d9509fca$var$getTestId(testId, children)), (isInteractive || children) && {
            "aria-label": label || defaultLabel
        }), {}, {
            children: (0, $gyDKM.jsx)((0, $7887bffaab575cbb$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        if (children) return children(props);
        var element = (0, $b3907fdf85e78486$export$83ee468102cdf04c)(isDisabled, href, onClick);
        return element === "a" || element === "button" ? (0, $gyDKM.jsx)((0, $671ea2626c6c4bdd$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $acw62.createElement)(element, props)) : /*#__PURE__*/ (0, $acw62.createElement)(element, props);
    }), isPresence && (0, $gyDKM.jsx)((0, $197e26d7c9cb80b0$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $gyDKM.jsx)((0, $ca30fff773cac154$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $gyDKM.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined);
});
$8ba2d884d9509fca$var$Avatar.displayName = "Avatar";
var $8ba2d884d9509fca$export$2e2bcd8739ae039 = $8ba2d884d9509fca$var$Avatar;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $ltooA = parcelRequire("ltooA");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");
var $74a2289385f9e9a8$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $74a2289385f9e9a8$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($74a2289385f9e9a8$export$1ca2a26fecb070ae);
};
$74a2289385f9e9a8$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");
var $98eb855f55265b52$export$4ef52930e33717cd = "data-theme";
var $98eb855f55265b52$export$a00eac3f8684bcd0 = "data-color-mode";
var $98eb855f55265b52$export$2112803007239c61 = "data-contrast-mode";
var $98eb855f55265b52$export$352e418ed5b6193a = "data-custom-theme";
var $98eb855f55265b52$export$2faeed762aac6741 = "light";
var $98eb855f55265b52$export$6f0c6fb8c80fcc92 = "ds";
var $98eb855f55265b52$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $98eb855f55265b52$export$dddac1532e822863 = "--".concat($98eb855f55265b52$export$6f0c6fb8c80fcc92, "-token-not-found");
var $98eb855f55265b52$export$9d7b58831ae93caa = "--".concat($98eb855f55265b52$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $84a477e573f5250c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84a477e573f5250c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84a477e573f5250c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84a477e573f5250c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $84a477e573f5250c$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $84a477e573f5250c$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $84a477e573f5250c$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $84a477e573f5250c$export$632685d741f3dbbf = $84a477e573f5250c$var$_objectSpread($84a477e573f5250c$var$_objectSpread({}, $84a477e573f5250c$export$958d0ae7f2977ae4), $84a477e573f5250c$export$d2dc61f58390201c);
var $84a477e573f5250c$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $84a477e573f5250c$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $84a477e573f5250c$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $84a477e573f5250c$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $84a477e573f5250c$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $84a477e573f5250c$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $84a477e573f5250c$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $84a477e573f5250c$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $84a477e573f5250c$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $84a477e573f5250c$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $84a477e573f5250c$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $84a477e573f5250c$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $84a477e573f5250c$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $84a477e573f5250c$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $84a477e573f5250c$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $84a477e573f5250c$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $84a477e573f5250c$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $84a477e573f5250c$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $84a477e573f5250c$export$e615f061ca585a6c = $84a477e573f5250c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $84a477e573f5250c$export$ca0f9c2de39ffed7(spacingProperty, $84a477e573f5250c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $84a477e573f5250c$export$bf46c3f9eeafc71f = $84a477e573f5250c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $84a477e573f5250c$export$ca0f9c2de39ffed7(spacingProperty, $84a477e573f5250c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $84a477e573f5250c$export$e7af83bafe7f9e63 = $84a477e573f5250c$export$ca0f9c2de39ffed7("backgroundColor", $84a477e573f5250c$export$d1d79bf68ac056bd);
var $84a477e573f5250c$export$3a1bcba60b23d7f0 = $84a477e573f5250c$export$ca0f9c2de39ffed7("color", $84a477e573f5250c$export$8473307aa00d6ea1);
var $84a477e573f5250c$export$45f3f4fe16f9f7d5 = $84a477e573f5250c$export$ca0f9c2de39ffed7("fontWeight", $84a477e573f5250c$export$303e322c6b1ed114);
var $84a477e573f5250c$export$68cc305da27dbaa4 = $84a477e573f5250c$export$ca0f9c2de39ffed7("fontFamily", $84a477e573f5250c$export$3c7e9587132614b4);
var $84a477e573f5250c$export$128f10c238242f83 = $84a477e573f5250c$export$ca0f9c2de39ffed7("font", $84a477e573f5250c$export$6ffa317d5e70375);
var $84a477e573f5250c$export$219d364c0da35ae4 = $84a477e573f5250c$export$ca0f9c2de39ffed7("font", $84a477e573f5250c$export$236bfe3a33ef1292);
var $84a477e573f5250c$export$38845ca010b93505 = $84a477e573f5250c$export$ca0f9c2de39ffed7("fontWeight", $84a477e573f5250c$export$855cfd311192d666);
var $84a477e573f5250c$export$ff257d957d48c421 = $84a477e573f5250c$export$ca0f9c2de39ffed7((0, $98eb855f55265b52$export$9d7b58831ae93caa), $84a477e573f5250c$export$41a358c9c2356760);
var $84a477e573f5250c$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $84a477e573f5250c$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $gyDKM = parcelRequire("gyDKM");


var $hPtJY = parcelRequire("hPtJY");
function $723ed0c94788662e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $723ed0c94788662e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $723ed0c94788662e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $723ed0c94788662e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $723ed0c94788662e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $723ed0c94788662e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $723ed0c94788662e$export$9a199fbafee0014e = {
    backgroundColor: (0, $84a477e573f5250c$export$d1d79bf68ac056bd),
    blockSize: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderBottomColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderLeftColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $84a477e573f5250c$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    borderWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    bottom: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    boxShadow: (0, $84a477e573f5250c$export$7aff6e7ba39bb774),
    color: (0, $84a477e573f5250c$export$8473307aa00d6ea1),
    columnGap: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    font: (0, $84a477e573f5250c$export$6ffa317d5e70375),
    fontFamily: (0, $84a477e573f5250c$export$3c7e9587132614b4),
    fontWeight: (0, $84a477e573f5250c$export$303e322c6b1ed114),
    gap: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    height: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    inlineSize: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    inset: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    insetBlock: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    insetBlockEnd: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    insetBlockStart: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    insetInline: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    insetInlineEnd: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    insetInlineStart: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    left: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    margin: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginBlock: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginBlockEnd: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginBlockStart: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginBottom: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginInline: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginInlineEnd: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginInlineStart: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginLeft: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginRight: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    marginTop: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    maxBlockSize: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    maxHeight: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    maxWidth: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    minBlockSize: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    minHeight: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    minInlineSize: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    minWidth: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    opacity: (0, $84a477e573f5250c$export$daf94a976c798b4f),
    outlineColor: (0, $84a477e573f5250c$export$1531ad5bb3fbedac),
    outlineOffset: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    outlineWidth: (0, $84a477e573f5250c$export$e1b83c5210c471b8),
    padding: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingBlock: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingBottom: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingInline: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingLeft: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingRight: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    paddingTop: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    right: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    rowGap: (0, $84a477e573f5250c$export$958d0ae7f2977ae4),
    top: (0, $84a477e573f5250c$export$632685d741f3dbbf),
    width: (0, $84a477e573f5250c$export$6ccdbebca2ee545f),
    zIndex: (0, $84a477e573f5250c$export$b5f31a7e431d2eab)
};
var $723ed0c94788662e$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $723ed0c94788662e$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $723ed0c94788662e$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $723ed0c94788662e$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $723ed0c94788662e$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($723ed0c94788662e$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $723ed0c94788662e$var$safeSelectors.test(key)) {
            styleObj[key] = $723ed0c94788662e$var$_transformStyles(value);
            return;
        }
        if ($723ed0c94788662e$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($723ed0c94788662e$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $723ed0c94788662e$export$9a199fbafee0014e)) return;
        var tokenValue = $723ed0c94788662e$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $723ed0c94788662e$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $723ed0c94788662e$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $723ed0c94788662e$var$uniqueSymbol, (0, $gyDKM.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $723ed0c94788662e$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $723ed0c94788662e$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $723ed0c94788662e$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$723ed0c94788662e$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $723ed0c94788662e$export$f6c783d06584602c(style) {
    return $723ed0c94788662e$var$baseXcss(style);
}


var $91e9bb26aa188ba7$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $91e9bb26aa188ba7$var$_excluded2 = [
    "className"
];
var $91e9bb26aa188ba7$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $91e9bb26aa188ba7$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $91e9bb26aa188ba7$var$_excluded2);
    var resolvedStyles = (0, $723ed0c94788662e$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $91e9bb26aa188ba7$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $84a477e573f5250c$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $84a477e573f5250c$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $84a477e573f5250c$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $84a477e573f5250c$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $84a477e573f5250c$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $84a477e573f5250c$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $84a477e573f5250c$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $84a477e573f5250c$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $84a477e573f5250c$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $84a477e573f5250c$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $gyDKM.jsx)((0, $74a2289385f9e9a8$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $91e9bb26aa188ba7$export$2e2bcd8739ae039 = $91e9bb26aa188ba7$export$e71c4d32a2263218;
var $91e9bb26aa188ba7$var$baseStyles = (0, $gyDKM.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $c3f6c0a74f7df502$var$baseStylesOld = (0, $723ed0c94788662e$export$f6c783d06584602c)({
    display: "inline-flex",
    borderRadius: "border.radius",
    blockSize: "min-content",
    position: "static",
    overflow: "hidden"
});
var $c3f6c0a74f7df502$var$styles = {
    container: (0, $gyDKM.css)({
        display: "inline-flex",
        boxSizing: "border-box",
        position: "static",
        blockSize: "min-content",
        borderRadius: "3px",
        overflow: "hidden",
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $gyDKM.css)({
                backgroundColor: "#DDDEE1"
            }),
            inprogress: (0, $gyDKM.css)({
                backgroundColor: "#8FB8F6"
            }),
            moved: (0, $gyDKM.css)({
                backgroundColor: "#F9C84E"
            }),
            new: (0, $gyDKM.css)({
                backgroundColor: "#D8A0F7"
            }),
            removed: (0, $gyDKM.css)({
                backgroundColor: "#FD9891"
            }),
            success: (0, $gyDKM.css)({
                backgroundColor: "#B3DF72"
            })
        },
        subtle: {
            default: (0, $gyDKM.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $gyDKM.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $gyDKM.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $gyDKM.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $gyDKM.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $gyDKM.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $gyDKM.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $gyDKM.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $gyDKM.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $gyDKM.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $gyDKM.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $gyDKM.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $gyDKM.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $gyDKM.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $gyDKM.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $gyDKM.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $gyDKM.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $gyDKM.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $gyDKM.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $gyDKM.css)({
            color: "#292A2E"
        })
    }
};
var $c3f6c0a74f7df502$var$textStyles = (0, $gyDKM.css)({
    fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: "uppercase",
    whiteSpace: "nowrap"
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $c3f6c0a74f7df502$var$Lozenge = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $c3f6c0a74f7df502$var$styles.background[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $ltooA.fg)("platform-component-visual-refresh")) return (0, $gyDKM.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        css: [
            $c3f6c0a74f7df502$var$styles.container,
            $c3f6c0a74f7df502$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === "subtle" && !(0, $ltooA.fg)("visual-refresh_drop_5") && $c3f6c0a74f7df502$var$styles.border.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $c3f6c0a74f7df502$var$styles.outline.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $c3f6c0a74f7df502$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $gyDKM.jsx)("span", {
        css: [
            $c3f6c0a74f7df502$var$textStyles,
            $c3f6c0a74f7df502$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $c3f6c0a74f7df502$var$backgroundColorsOld[appearanceStyle] ? appearance : "default";
    return (0, $gyDKM.jsx)((0, $91e9bb26aa188ba7$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $c3f6c0a74f7df502$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $c3f6c0a74f7df502$var$baseStylesOld,
        testId: testId
    }, (0, $gyDKM.jsx)("span", {
        css: [
            $c3f6c0a74f7df502$var$textStyles,
            $c3f6c0a74f7df502$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$c3f6c0a74f7df502$var$Lozenge.displayName = "Lozenge";
var $c3f6c0a74f7df502$export$2e2bcd8739ae039 = $c3f6c0a74f7df502$var$Lozenge;
var $c3f6c0a74f7df502$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $c3f6c0a74f7df502$var$textColorsOld = {
    bold: {
        default: (0, $gyDKM.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $gyDKM.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $gyDKM.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $gyDKM.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $gyDKM.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $gyDKM.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $gyDKM.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $gyDKM.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $gyDKM.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $gyDKM.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $gyDKM.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $gyDKM.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $4xUU2 = parcelRequire("4xUU2");

var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $7494647bb54cb7f0$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $7fc40d59268d4cc9$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $cf001274ece650ec$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $cf001274ece650ec$var$currentValues = new WeakMap();
function $cf001274ece650ec$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $7fc40d59268d4cc9$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $7494647bb54cb7f0$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $cf001274ece650ec$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $cf001274ece650ec$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $7494647bb54cb7f0$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $7494647bb54cb7f0$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $cf001274ece650ec$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $acw62 = parcelRequire("acw62");

var $edc395c6c4f4f1b4$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $edc395c6c4f4f1b4$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $edc395c6c4f4f1b4$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $edc395c6c4f4f1b4$export$b8c7b07253306600
    }));
};
$edc395c6c4f4f1b4$var$InFocusGuard.propTypes = {};
var $edc395c6c4f4f1b4$export$2e2bcd8739ae039 = $edc395c6c4f4f1b4$var$InFocusGuard;



var $7WQrb = parcelRequire("7WQrb");
function $e2997686fcc4a8bc$var$ItoI(a) {
    return a;
}
function $e2997686fcc4a8bc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $e2997686fcc4a8bc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $e2997686fcc4a8bc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $e2997686fcc4a8bc$var$ItoI;
    return $e2997686fcc4a8bc$var$innerCreateMedium(defaults, middleware);
}
function $e2997686fcc4a8bc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $e2997686fcc4a8bc$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $6130f19b42b0d2c7$export$5733e022b1d538cb = (0, $e2997686fcc4a8bc$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $6130f19b42b0d2c7$export$b3e9a9312f73723c = (0, $e2997686fcc4a8bc$export$9ffbfcaf067b02c6)();
var $6130f19b42b0d2c7$export$3a1d52767cbc07b8 = (0, $e2997686fcc4a8bc$export$9ffbfcaf067b02c6)();
var $6130f19b42b0d2c7$export$892cbf28e5518020 = (0, $e2997686fcc4a8bc$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== "undefined"
});



var $acw62 = parcelRequire("acw62");
var $54f87edc0127e3e8$export$f5272e9b1168239c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


var $d4fcb6e3fc4c7a83$var$emptyArray = [];
var $d4fcb6e3fc4c7a83$var$FocusLock = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $acw62.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $acw62.useRef)();
    var isActive = (0, $acw62.useRef)(false);
    var originalFocusedElement = (0, $acw62.useRef)(null);
    var _useState2 = (0, $acw62.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $d4fcb6e3fc4c7a83$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $acw62.useState)({}), id = _useState3[0];
    var onActivation = (0, $acw62.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $acw62.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $acw62.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $acw62.useCallback)(function(event) {
        if (isActive.current) (0, $6130f19b42b0d2c7$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $6130f19b42b0d2c7$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = (0, $acw62.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $8nd05.default)((_extends2 = {}, _extends2[0, $4xUU2.FOCUS_DISABLED] = disabled && "disabled", _extends2[0, $4xUU2.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $cf001274ece650ec$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $acw62.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $edc395c6c4f4f1b4$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $edc395c6c4f4f1b4$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SideCar, {
        id: id,
        sideCar: (0, $6130f19b42b0d2c7$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, (0, $8nd05.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54f87edc0127e3e8$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $edc395c6c4f4f1b4$export$b8c7b07253306600)
    }));
});
$d4fcb6e3fc4c7a83$var$FocusLock.propTypes = {};
var $d4fcb6e3fc4c7a83$export$2e2bcd8739ae039 = $d4fcb6e3fc4c7a83$var$FocusLock;



var $acw62 = parcelRequire("acw62");


var $g7ajw = parcelRequire("g7ajw");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");
function $b77b99d839a92103$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $g7ajw.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $kSlfw.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $b77b99d839a92103$export$2e2bcd8739ae039 = $b77b99d839a92103$var$withSideEffect;



var $jW7tt = parcelRequire("jW7tt");
var $5rKE2 = parcelRequire("5rKE2");
var $fpTn0 = parcelRequire("fpTn0");
var $kuWmi = parcelRequire("kuWmi");
var $6nqmI = parcelRequire("6nqmI");
var $dltQK = parcelRequire("dltQK");parcelRequire("iQq8m");
var $abhGZ = parcelRequire("abhGZ");
function $93511d26b4a4f564$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $93511d26b4a4f564$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $93511d26b4a4f564$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};



var $35f6d88a5c82c9e2$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $35f6d88a5c82c9e2$var$isFreeFocus = function isFreeFocus() {
    return $35f6d88a5c82c9e2$var$focusOnBody() || (0, $6nqmI.focusIsHidden)();
};
var $35f6d88a5c82c9e2$var$lastActiveTrap = null;
var $35f6d88a5c82c9e2$var$lastActiveFocus = null;
var $35f6d88a5c82c9e2$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $35f6d88a5c82c9e2$var$lastPortaledElement = null;
var $35f6d88a5c82c9e2$var$focusWasOutsideWindow = false;
var $35f6d88a5c82c9e2$var$windowFocused = false;
var $35f6d88a5c82c9e2$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $35f6d88a5c82c9e2$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($35f6d88a5c82c9e2$var$lastActiveTrap.whiteList || $35f6d88a5c82c9e2$var$defaultWhitelist)(activeElement);
};
var $35f6d88a5c82c9e2$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $35f6d88a5c82c9e2$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $35f6d88a5c82c9e2$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $35f6d88a5c82c9e2$var$lastPortaledElement && $35f6d88a5c82c9e2$var$lastPortaledElement.portaledElement === element;
};
function $35f6d88a5c82c9e2$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $35f6d88a5c82c9e2$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($35f6d88a5c82c9e2$var$focusWasOutsideWindow);
    return $35f6d88a5c82c9e2$var$focusWasOutsideWindow === "meanwhile";
};
var $35f6d88a5c82c9e2$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $35f6d88a5c82c9e2$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $35f6d88a5c82c9e2$var$checkInHost(activeElement, area, area);
    });
};
var $35f6d88a5c82c9e2$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $dltQK.getFocusableNodes)(nodes, new Map());
};
var $35f6d88a5c82c9e2$var$isNotFocusable = function isNotFocusable(node) {
    return !$35f6d88a5c82c9e2$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $35f6d88a5c82c9e2$var$activateTrap = function activateTrap() {
    var result = false;
    if ($35f6d88a5c82c9e2$var$lastActiveTrap) {
        var _lastActiveTrap = $35f6d88a5c82c9e2$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $35f6d88a5c82c9e2$var$lastPortaledElement && $35f6d88a5c82c9e2$var$lastPortaledElement.portaledElement;
        if ($35f6d88a5c82c9e2$var$focusOnBody() && $35f6d88a5c82c9e2$var$lastActiveFocus && $35f6d88a5c82c9e2$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($35f6d88a5c82c9e2$var$lastActiveFocus) || $35f6d88a5c82c9e2$var$isNotFocusable($35f6d88a5c82c9e2$var$lastActiveFocus)) {
                var newTarget = $35f6d88a5c82c9e2$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $93511d26b4a4f564$export$c613fed06e332533)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$35f6d88a5c82c9e2$var$focusWasOutside(crossFrame) || !noFocusGuards || !$35f6d88a5c82c9e2$var$lastActiveFocus || $35f6d88a5c82c9e2$var$windowFocused) return false;
                var nodes = $35f6d88a5c82c9e2$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $35f6d88a5c82c9e2$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $35f6d88a5c82c9e2$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$35f6d88a5c82c9e2$var$isFreeFocus() || !$35f6d88a5c82c9e2$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $kuWmi.focusInside)(workingArea) || activeElement && $35f6d88a5c82c9e2$var$withinHost(activeElement, workingArea) || $35f6d88a5c82c9e2$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$35f6d88a5c82c9e2$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $abhGZ.moveFocusInside)(workingArea, $35f6d88a5c82c9e2$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $35f6d88a5c82c9e2$var$lastPortaledElement = {};
                        }
                    }
                    $35f6d88a5c82c9e2$var$lastActiveFocus = document && document.activeElement;
                    if ($35f6d88a5c82c9e2$var$lastActiveFocus !== document.body) $35f6d88a5c82c9e2$var$tryRestoreFocus = (0, $jW7tt.captureFocusRestore)($35f6d88a5c82c9e2$var$lastActiveFocus);
                    $35f6d88a5c82c9e2$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $5rKE2.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $35f6d88a5c82c9e2$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $35f6d88a5c82c9e2$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $35f6d88a5c82c9e2$var$onTrap = function onTrap(event) {
    if ($35f6d88a5c82c9e2$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $35f6d88a5c82c9e2$var$onBlur = function onBlur() {
    return (0, $93511d26b4a4f564$export$6523025722806278)($35f6d88a5c82c9e2$var$activateTrap);
};
var $35f6d88a5c82c9e2$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $35f6d88a5c82c9e2$var$recordPortal(currentNode, source);
};
var $35f6d88a5c82c9e2$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $35f6d88a5c82c9e2$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onBlur: $35f6d88a5c82c9e2$var$onBlur,
        onFocus: $35f6d88a5c82c9e2$var$onFocus
    }, children);
};
$35f6d88a5c82c9e2$var$FocusTrap.propTypes = {};
var $35f6d88a5c82c9e2$var$onWindowFocus = function onWindowFocus() {
    $35f6d88a5c82c9e2$var$windowFocused = true;
};
var $35f6d88a5c82c9e2$var$onWindowBlur = function onWindowBlur() {
    $35f6d88a5c82c9e2$var$windowFocused = false;
    $35f6d88a5c82c9e2$var$focusWasOutsideWindow = "just";
    (0, $93511d26b4a4f564$export$6523025722806278)(function() {
        $35f6d88a5c82c9e2$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $35f6d88a5c82c9e2$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $35f6d88a5c82c9e2$var$onTrap);
    document.addEventListener("focusout", $35f6d88a5c82c9e2$var$onBlur);
    window.addEventListener("focus", $35f6d88a5c82c9e2$var$onWindowFocus);
    window.addEventListener("blur", $35f6d88a5c82c9e2$var$onWindowBlur);
};
var $35f6d88a5c82c9e2$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $35f6d88a5c82c9e2$var$onTrap);
    document.removeEventListener("focusout", $35f6d88a5c82c9e2$var$onBlur);
    window.removeEventListener("focus", $35f6d88a5c82c9e2$var$onWindowFocus);
    window.removeEventListener("blur", $35f6d88a5c82c9e2$var$onWindowBlur);
};
function $35f6d88a5c82c9e2$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $35f6d88a5c82c9e2$var$focusLockAPI = {
    moveFocusInside: (0, $abhGZ.moveFocusInside),
    focusInside: (0, $kuWmi.focusInside),
    focusNextElement: (0, $fpTn0.focusNextElement),
    focusPrevElement: (0, $fpTn0.focusPrevElement),
    focusFirstElement: (0, $fpTn0.focusFirstElement),
    focusLastElement: (0, $fpTn0.focusLastElement),
    captureFocusRestore: (0, $jW7tt.captureFocusRestore)
};
function $35f6d88a5c82c9e2$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$35f6d88a5c82c9e2$var$lastActiveTrap) $35f6d88a5c82c9e2$var$attachHandler();
    var lastTrap = $35f6d88a5c82c9e2$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $35f6d88a5c82c9e2$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $35f6d88a5c82c9e2$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($35f6d88a5c82c9e2$var$focusLockAPI);
        $35f6d88a5c82c9e2$var$activateTrap(true);
        (0, $93511d26b4a4f564$export$6523025722806278)($35f6d88a5c82c9e2$var$activateTrap);
    } else {
        $35f6d88a5c82c9e2$var$detachHandler();
        $35f6d88a5c82c9e2$var$lastActiveFocus = null;
    }
}
(0, $6130f19b42b0d2c7$export$5733e022b1d538cb).assignSyncMedium($35f6d88a5c82c9e2$var$onFocus);
(0, $6130f19b42b0d2c7$export$b3e9a9312f73723c).assignMedium($35f6d88a5c82c9e2$var$onBlur);
(0, $6130f19b42b0d2c7$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($35f6d88a5c82c9e2$var$focusLockAPI);
});
var $35f6d88a5c82c9e2$export$2e2bcd8739ae039 = (0, $b77b99d839a92103$export$2e2bcd8739ae039)($35f6d88a5c82c9e2$var$reducePropsToState, $35f6d88a5c82c9e2$var$handleStateChangeOnClient)($35f6d88a5c82c9e2$var$FocusWatcher);


var $57654fc09455e2b4$var$FocusLockCombination = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4fcb6e3fc4c7a83$export$2e2bcd8739ae039), (0, $8nd05.default)({
        sideCar: (0, $35f6d88a5c82c9e2$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $57654fc09455e2b4$var$_ref = (0, $d4fcb6e3fc4c7a83$export$2e2bcd8739ae039).propTypes || {}, $57654fc09455e2b4$var$sideCar = $57654fc09455e2b4$var$_ref.sideCar, $57654fc09455e2b4$var$propTypes = (0, $1En50.default)($57654fc09455e2b4$var$_ref, [
    "sideCar"
]);
$57654fc09455e2b4$var$FocusLockCombination.propTypes = {};
var $57654fc09455e2b4$export$2e2bcd8739ae039 = $57654fc09455e2b4$var$FocusLockCombination;



var $32ba2b8b866d6e66$export$2e2bcd8739ae039 = (0, $57654fc09455e2b4$export$2e2bcd8739ae039);


var $ae3397446a14bfac$exports = {};
"use strict";
Object.defineProperty($ae3397446a14bfac$exports, "__esModule", {
    value: true
});
var $ac7e16ab1756b699$exports = {};
"use strict";
Object.defineProperty($ac7e16ab1756b699$exports, "__esModule", {
    value: true
});
var $ac7e16ab1756b699$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $ac7e16ab1756b699$var$_react2 = $ac7e16ab1756b699$var$_interopRequireDefault($acw62);

var $djCxr = parcelRequire("djCxr");
var $f245d236e066c4f9$exports = {};
"use strict";
Object.defineProperty($f245d236e066c4f9$exports, "__esModule", {
    value: true
});
$f245d236e066c4f9$exports.TouchScrollable = undefined;
var $f245d236e066c4f9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f245d236e066c4f9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $djCxr = parcelRequire("djCxr");
var $a04289da7886ea62$exports = {};
"use strict";
Object.defineProperty($a04289da7886ea62$exports, "__esModule", {
    value: true
});
$a04289da7886ea62$exports.pipe = $a04289da7886ea62$exports.listenerOptions = undefined;
$a04289da7886ea62$exports.preventTouchMove = $a04289da7886ea62$var$preventTouchMove;
$a04289da7886ea62$exports.allowTouchMove = $a04289da7886ea62$var$allowTouchMove;
$a04289da7886ea62$exports.preventInertiaScroll = $a04289da7886ea62$var$preventInertiaScroll;
$a04289da7886ea62$exports.isTouchDevice = $a04289da7886ea62$var$isTouchDevice;
$a04289da7886ea62$exports.camelToKebab = $a04289da7886ea62$var$camelToKebab;
$a04289da7886ea62$exports.parse = $a04289da7886ea62$var$parse;
$a04289da7886ea62$exports.getPadding = $a04289da7886ea62$var$getPadding;
$a04289da7886ea62$exports.getWindowHeight = $a04289da7886ea62$var$getWindowHeight;
$a04289da7886ea62$exports.getDocumentHeight = $a04289da7886ea62$var$getDocumentHeight;
$a04289da7886ea62$exports.makeStyleTag = $a04289da7886ea62$var$makeStyleTag;
$a04289da7886ea62$exports.injectStyles = $a04289da7886ea62$var$injectStyles;
$a04289da7886ea62$exports.insertStyleTag = $a04289da7886ea62$var$insertStyleTag;

var $djCxr = parcelRequire("djCxr");
var $a04289da7886ea62$var$listenerOptions = $a04289da7886ea62$exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $a04289da7886ea62$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $a04289da7886ea62$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $a04289da7886ea62$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $a04289da7886ea62$var$isTouchDevice() {
    if (!$djCxr.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $a04289da7886ea62$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $a04289da7886ea62$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $a04289da7886ea62$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $a04289da7886ea62$var$pipe = $a04289da7886ea62$exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($a04289da7886ea62$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $a04289da7886ea62$var$getPadding() {
    if (!$djCxr.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $a04289da7886ea62$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($djCxr.canUseDOM) return window.innerHeight * multiplier;
}
function $a04289da7886ea62$var$getDocumentHeight() {
    if ($djCxr.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $a04289da7886ea62$var$makeStyleTag() {
    if (!$djCxr.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $a04289da7886ea62$var$injectStyles(tag, css) {
    if (!$djCxr.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $a04289da7886ea62$var$insertStyleTag(tag) {
    if (!$djCxr.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}


function $f245d236e066c4f9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $f245d236e066c4f9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f245d236e066c4f9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f245d236e066c4f9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $f245d236e066c4f9$var$TouchScrollable = $f245d236e066c4f9$exports.TouchScrollable = function(_PureComponent) {
    $f245d236e066c4f9$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $f245d236e066c4f9$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $f245d236e066c4f9$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $f245d236e066c4f9$var$_possibleConstructorReturn(_this, _ret);
    }
    $f245d236e066c4f9$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$djCxr.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $a04289da7886ea62$exports.preventInertiaScroll, $a04289da7886ea62$exports.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $a04289da7886ea62$exports.allowTouchMove, $a04289da7886ea62$exports.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$djCxr.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $a04289da7886ea62$exports.preventInertiaScroll, $a04289da7886ea62$exports.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $a04289da7886ea62$exports.allowTouchMove, $a04289da7886ea62$exports.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $f245d236e066c4f9$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $acw62.cloneElement)(children, $f245d236e066c4f9$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($acw62.PureComponent);


var $43eb920883fe1f04$exports = {};
"use strict";
Object.defineProperty($43eb920883fe1f04$exports, "__esModule", {
    value: true
});
var $43eb920883fe1f04$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$43eb920883fe1f04$exports.default = $43eb920883fe1f04$var$withLockSheet;

var $acw62 = parcelRequire("acw62");
var $43eb920883fe1f04$var$_react2 = $43eb920883fe1f04$var$_interopRequireDefault($acw62);

function $43eb920883fe1f04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43eb920883fe1f04$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43eb920883fe1f04$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $43eb920883fe1f04$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $43eb920883fe1f04$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $43eb920883fe1f04$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $43eb920883fe1f04$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $43eb920883fe1f04$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $a04289da7886ea62$exports.makeStyleTag)();
                if (!sheet) return;
                (0, $a04289da7886ea62$exports.injectStyles)(sheet, styles);
                (0, $a04289da7886ea62$exports.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $a04289da7886ea62$exports.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $a04289da7886ea62$exports.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $43eb920883fe1f04$var$_possibleConstructorReturn(_this, _ret);
        }
        $43eb920883fe1f04$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $43eb920883fe1f04$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($acw62.PureComponent);
}


var $ac7e16ab1756b699$var$_withLockSheet2 = $ac7e16ab1756b699$var$_interopRequireDefault($43eb920883fe1f04$exports);
var $7b8537978ddb417d$exports = {};
"use strict";
Object.defineProperty($7b8537978ddb417d$exports, "__esModule", {
    value: true
});
var $7b8537978ddb417d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$7b8537978ddb417d$exports.default = $7b8537978ddb417d$var$withTouchListeners;

var $acw62 = parcelRequire("acw62");
var $7b8537978ddb417d$var$_react2 = $7b8537978ddb417d$var$_interopRequireDefault($acw62);

var $djCxr = parcelRequire("djCxr");

function $7b8537978ddb417d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7b8537978ddb417d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7b8537978ddb417d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7b8537978ddb417d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $7b8537978ddb417d$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $7b8537978ddb417d$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $7b8537978ddb417d$var$_classCallCheck(this, TouchProvider);
            return $7b8537978ddb417d$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $7b8537978ddb417d$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$djCxr.canUseDOM || !(0, $a04289da7886ea62$exports.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $a04289da7886ea62$exports.preventTouchMove, $a04289da7886ea62$exports.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$djCxr.canUseDOM || !(0, $a04289da7886ea62$exports.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $a04289da7886ea62$exports.preventTouchMove, $a04289da7886ea62$exports.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $7b8537978ddb417d$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($acw62.PureComponent);
}


var $ac7e16ab1756b699$var$_withTouchListeners2 = $ac7e16ab1756b699$var$_interopRequireDefault($7b8537978ddb417d$exports);

function $ac7e16ab1756b699$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ac7e16ab1756b699$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ac7e16ab1756b699$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ac7e16ab1756b699$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ac7e16ab1756b699$var$ScrollLock = function(_PureComponent) {
    $ac7e16ab1756b699$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $ac7e16ab1756b699$var$_classCallCheck(this, ScrollLock);
        return $ac7e16ab1756b699$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $ac7e16ab1756b699$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$djCxr.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $ac7e16ab1756b699$var$_react2.default.createElement($f245d236e066c4f9$exports.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($acw62.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $ac7e16ab1756b699$var$compose = (0, $a04289da7886ea62$exports.pipe)($ac7e16ab1756b699$var$_withTouchListeners2.default, $ac7e16ab1756b699$var$_withLockSheet2.default);
var $ac7e16ab1756b699$var$SheetLock = $ac7e16ab1756b699$var$compose($ac7e16ab1756b699$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $ac7e16ab1756b699$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $ac7e16ab1756b699$var$_react2.default.createElement($ac7e16ab1756b699$var$SheetLock, props) : props.children;
};
$ac7e16ab1756b699$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
$ac7e16ab1756b699$exports.default = $ac7e16ab1756b699$var$LockToggle;


Object.defineProperty($ae3397446a14bfac$exports, "default", {
    enumerable: true,
    get: function get() {
        return $ae3397446a14bfac$var$_interopRequireDefault($ac7e16ab1756b699$exports).default;
    }
});

Object.defineProperty($ae3397446a14bfac$exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $f245d236e066c4f9$exports.TouchScrollable;
    }
});
function $ae3397446a14bfac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $c90039d2737091d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c90039d2737091d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c90039d2737091d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c90039d2737091d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c90039d2737091d6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c90039d2737091d6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $c90039d2737091d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c90039d2737091d6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $c90039d2737091d6$var$_objectSpread($c90039d2737091d6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $71f1f821ac575715$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $71f1f821ac575715$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $71f1f821ac575715$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($71f1f821ac575715$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $71f1f821ac575715$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $71f1f821ac575715$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $71f1f821ac575715$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $71f1f821ac575715$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $71f1f821ac575715$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $71f1f821ac575715$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $c90039d2737091d6$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $5aac951b758aac8b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $2ef977ff580b5e2e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5aac951b758aac8b$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $71f1f821ac575715$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $5c94213f79186413$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $da4a71ad48bb2f49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da4a71ad48bb2f49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da4a71ad48bb2f49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da4a71ad48bb2f49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da4a71ad48bb2f49$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2ef977ff580b5e2e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $5c94213f79186413$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $5c94213f79186413$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $da4a71ad48bb2f49$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");

/**
 * An empty function which does nothing.
 */ function $a48626e6ce3de64c$export$2e2bcd8739ae039() {}


// Reds
var $f56d661167e7bbc2$export$4b84fd0e2c617bd = "#FFEBE6";
var $f56d661167e7bbc2$export$b34b069eff244586 = "#FFBDAD";
var $f56d661167e7bbc2$export$be802dd0d8b57f35 = "#FF8F73";
var $f56d661167e7bbc2$export$60847d42f9da92a6 = "#FF7452";
var $f56d661167e7bbc2$export$4a7404f376229999 = "#FF5630";
var $f56d661167e7bbc2$export$2010d0fb4295b346 = "#DE350B";
var $f56d661167e7bbc2$export$2837b5a1a71d5c02 = "#BF2600";
var $f56d661167e7bbc2$export$8d9596b529bbb9cf = "#FFFAE6";
var $f56d661167e7bbc2$export$41060a744ab0b7ae = "#FFF0B3";
var $f56d661167e7bbc2$export$1cc05bbbf340e559 = "#FFE380";
var $f56d661167e7bbc2$export$5aae31392d72caaa = "#FFC400";
var $f56d661167e7bbc2$export$c6930421db9fa514 = "#FFAB00";
var $f56d661167e7bbc2$export$59619663aa6500fb = "#FF991F";
var $f56d661167e7bbc2$export$874739ea9e379ab6 = "#FF8B00";
var $f56d661167e7bbc2$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f56d661167e7bbc2$export$69a3bf21b9686c2b = "#ABF5D1";
var $f56d661167e7bbc2$export$afbce1382ec95f73 = "#79F2C0";
var $f56d661167e7bbc2$export$747d86715d4175de = "#57D9A3";
var $f56d661167e7bbc2$export$940e1f69e873f202 = "#36B37E";
var $f56d661167e7bbc2$export$a49394138f7b8e85 = "#00875A";
var $f56d661167e7bbc2$export$6fa04827ac68a4fb = "#006644";
var $f56d661167e7bbc2$export$226de0355ed012f8 = "#DEEBFF";
var $f56d661167e7bbc2$export$8c13c2ee36917869 = "#B3D4FF";
var $f56d661167e7bbc2$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f56d661167e7bbc2$export$215b7063051591f1 = "#2684FF";
var $f56d661167e7bbc2$export$e62e8919cca44969 = "#0065FF";
var $f56d661167e7bbc2$export$b3de0ae08da2ce64 = "#0052CC";
var $f56d661167e7bbc2$export$a6ee3d71bc067634 = "#0747A6";
var $f56d661167e7bbc2$export$67f15409e87642a1 = "#669DF1";
var $f56d661167e7bbc2$export$f0539dbc42dbb067 = "#8FB8F6";
var $f56d661167e7bbc2$export$363e4475840015bb = "#EAE6FF";
var $f56d661167e7bbc2$export$4b0a4417ed59760f = "#C0B6F2";
var $f56d661167e7bbc2$export$6011520a64d9a187 = "#998DD9";
var $f56d661167e7bbc2$export$a7175d4e9206bc80 = "#8777D9";
var $f56d661167e7bbc2$export$b48405b95304b5a1 = "#6554C0";
var $f56d661167e7bbc2$export$c71e4279dd54a18d = "#5243AA";
var $f56d661167e7bbc2$export$147899de772240ec = "#403294";
var $f56d661167e7bbc2$export$2cf711fe14c66f06 = "#E6FCFF";
var $f56d661167e7bbc2$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f56d661167e7bbc2$export$776c9c497ef08533 = "#79E2F2";
var $f56d661167e7bbc2$export$69cb3ca10c1e330e = "#00C7E6";
var $f56d661167e7bbc2$export$9dc1ef0f3f48059b = "#00B8D9";
var $f56d661167e7bbc2$export$7c835c78b6fcdef8 = "#00A3BF";
var $f56d661167e7bbc2$export$6036577f95c3877e = "#008DA6";
var $f56d661167e7bbc2$export$29a4f05edc054374 = "#FFFFFF";
var $f56d661167e7bbc2$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f56d661167e7bbc2$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f56d661167e7bbc2$export$3e51e8f1440314ba = "#EBECF0";
var $f56d661167e7bbc2$export$1ce2d1575d444ceb = "#DFE1E6";
var $f56d661167e7bbc2$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f56d661167e7bbc2$export$c2e91cbeada39b8b = "#B3BAC5";
var $f56d661167e7bbc2$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f56d661167e7bbc2$export$eaa8c8a70ac22806 = "#97A0AF";
var $f56d661167e7bbc2$export$7c87d337fb91a97d = "#8993A4";
var $f56d661167e7bbc2$export$d6447c357493214f = "#7A869A";
var $f56d661167e7bbc2$export$f563ee71e9ee74cd = "#6B778C";
var $f56d661167e7bbc2$export$e2ef2124cf4024b1 = "#5E6C84";
var $f56d661167e7bbc2$export$eece5f492e429f08 = "#505F79";
var $f56d661167e7bbc2$export$c39c0fe0f26207ae = "#42526E";
var $f56d661167e7bbc2$export$7090862dc3038a9f = "#344563";
var $f56d661167e7bbc2$export$ad0bacf983b7ddaa = "#253858";
var $f56d661167e7bbc2$export$7d61b15e0da132af = "#172B4D";
var $f56d661167e7bbc2$export$fbda843f0a27fe96 = "#091E42";
var $f56d661167e7bbc2$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f56d661167e7bbc2$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f56d661167e7bbc2$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f56d661167e7bbc2$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f56d661167e7bbc2$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f56d661167e7bbc2$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f56d661167e7bbc2$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f56d661167e7bbc2$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f56d661167e7bbc2$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f56d661167e7bbc2$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f56d661167e7bbc2$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f56d661167e7bbc2$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f56d661167e7bbc2$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f56d661167e7bbc2$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f56d661167e7bbc2$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f56d661167e7bbc2$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f56d661167e7bbc2$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f56d661167e7bbc2$export$2f6319cf7d736c2a = "#E6EDFA";
var $f56d661167e7bbc2$export$95126bc8884d6634 = "#DCE5F5";
var $f56d661167e7bbc2$export$8338d8c35d44ff1 = "#CED9EB";
var $f56d661167e7bbc2$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f56d661167e7bbc2$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f56d661167e7bbc2$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f56d661167e7bbc2$export$97e81faa16a182c7 = "#8C9CB8";
var $f56d661167e7bbc2$export$bfe21c59123ecf33 = "#7988A3";
var $f56d661167e7bbc2$export$ee82aa2ea6a1558 = "#67758F";
var $f56d661167e7bbc2$export$682927c6ed76be02 = "#56637A";
var $f56d661167e7bbc2$export$91fd9994c5be9757 = "#455166";
var $f56d661167e7bbc2$export$d281fbfe3cff2df6 = "#3B475C";
var $f56d661167e7bbc2$export$3902c91d8b98a753 = "#313D52";
var $f56d661167e7bbc2$export$8e8133c1ba5845b5 = "#283447";
var $f56d661167e7bbc2$export$33ff357f6620b39 = "#202B3D";
var $f56d661167e7bbc2$export$633847cf062b69e0 = "#1B2638";
var $f56d661167e7bbc2$export$9776a6e503bdbf76 = "#121A29";
var $f56d661167e7bbc2$export$6c813d5160dff5db = "#0E1624";
var $f56d661167e7bbc2$export$3d4f271a500072a = "#0D1424";
var $f56d661167e7bbc2$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f56d661167e7bbc2$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f56d661167e7bbc2$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f56d661167e7bbc2$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f56d661167e7bbc2$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f56d661167e7bbc2$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f56d661167e7bbc2$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f56d661167e7bbc2$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f56d661167e7bbc2$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f56d661167e7bbc2$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f56d661167e7bbc2$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f56d661167e7bbc2$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f56d661167e7bbc2$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f56d661167e7bbc2$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f56d661167e7bbc2$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f56d661167e7bbc2$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f56d661167e7bbc2$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $f56d661167e7bbc2$export$d2adc5dedf09fced = "#292A2E";
var $f56d661167e7bbc2$export$f51762073d2bb381 = "#94C748";
var $f56d661167e7bbc2$export$95e26d54def96891 = "#B3DF72";



function $4b5f27ceb6232f9f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b5f27ceb6232f9f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b5f27ceb6232f9f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b5f27ceb6232f9f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4b5f27ceb6232f9f$var$packageName = "@atlaskit/blanket";
var $4b5f27ceb6232f9f$var$packageVersion = "15.0.8";
var $4b5f27ceb6232f9f$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $4b5f27ceb6232f9f$var$packageName,
    packageVersion: $4b5f27ceb6232f9f$var$packageVersion
};
var $4b5f27ceb6232f9f$var$baseStyles = null;
var $4b5f27ceb6232f9f$var$shouldAllowClickThroughStyles = null;
var $4b5f27ceb6232f9f$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $4b5f27ceb6232f9f$var$Blanket = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $a48626e6ce3de64c$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $acw62.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $da4a71ad48bb2f49$export$a4687b0234b40e28)($4b5f27ceb6232f9f$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $4b5f27ceb6232f9f$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $acw62.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $acw62.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $luEYg.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $593c55d1b5df349d$export$2e2bcd8739ae039)("var(--ds-blanket, ".concat((0, $f56d661167e7bbc2$export$486ab785e4bac3c6), ")"))
        }
    }, children);
}));
$4b5f27ceb6232f9f$var$Blanket.displayName = "Blanket";
var $4b5f27ceb6232f9f$export$2e2bcd8739ae039 = $4b5f27ceb6232f9f$var$Blanket;


/**
 * An empty function which does nothing.
 */ function $3a8eb9859f488de9$export$2e2bcd8739ae039() {}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
function $e5a122294cfc1b23$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5a122294cfc1b23$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5a122294cfc1b23$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5a122294cfc1b23$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e5a122294cfc1b23$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $e5a122294cfc1b23$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $3a8eb9859f488de9$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e5a122294cfc1b23$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($e5a122294cfc1b23$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $acw62.useRef)((0, $ltooA.fg)("layering-top-level-use-array") ? Math.random().toString(36) : "");
    if (!(0, $ltooA.fg)("layering-top-level-use-array")) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $ltooA.fg)("layering-top-level-use-array")) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $ltooA.fg)("layering-top-level-use-array")) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e5a122294cfc1b23$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e5a122294cfc1b23$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var layerList = (0, $acw62.useRef)([]);
    var value = (0, $acw62.useMemo)(function() {
        return $e5a122294cfc1b23$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $ltooA.fg)("layering-top-level-use-array") ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e5a122294cfc1b23$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e5a122294cfc1b23$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($e5a122294cfc1b23$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e5a122294cfc1b23$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e5a122294cfc1b23$var$LayeringProvider, null, content);
};



var $acw62 = parcelRequire("acw62");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $54b6bec240646028$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $54b6bec240646028$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$54b6bec240646028$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $54b6bec240646028$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($54b6bec240646028$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$54b6bec240646028$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $54b6bec240646028$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $54b6bec240646028$export$ff7706047246b98b = function prefersReducedMotion() {
    return $54b6bec240646028$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $194f2657a84cbf36$export$368bacef0dacbe05 = 25;
var $194f2657a84cbf36$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $194f2657a84cbf36$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $194f2657a84cbf36$export$30fa1a2e62ae150c = {
    none: $194f2657a84cbf36$export$38b928a7167ce124.none,
    small: $194f2657a84cbf36$export$38b928a7167ce124.small * $194f2657a84cbf36$var$EXITING_MOTION_MULTIPLIER,
    medium: $194f2657a84cbf36$export$38b928a7167ce124.medium * $194f2657a84cbf36$var$EXITING_MOTION_MULTIPLIER,
    large: $194f2657a84cbf36$export$38b928a7167ce124.large * $194f2657a84cbf36$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
var $bcedfea07d5697f5$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $bcedfea07d5697f5$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $bcedfea07d5697f5$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $bcedfea07d5697f5$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $bcedfea07d5697f5$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $409e1fba7c6209e5$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $409e1fba7c6209e5$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($409e1fba7c6209e5$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $409e1fba7c6209e5$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $409e1fba7c6209e5$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($409e1fba7c6209e5$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $409e1fba7c6209e5$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $409e1fba7c6209e5$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $409e1fba7c6209e5$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $409e1fba7c6209e5$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $409e1fba7c6209e5$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $409e1fba7c6209e5$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $409e1fba7c6209e5$var$childrenToArray(previousChildren);
    var current = $409e1fba7c6209e5$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $409e1fba7c6209e5$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $409e1fba7c6209e5$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $409e1fba7c6209e5$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $409e1fba7c6209e5$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $409e1fba7c6209e5$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($409e1fba7c6209e5$var$ExitingContext);
};
$409e1fba7c6209e5$var$ExitingPersistence.displayName = "ExitingPersistence";
var $409e1fba7c6209e5$export$2e2bcd8739ae039 = $409e1fba7c6209e5$var$ExitingPersistence;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
/**
 * An empty function which does nothing.
 */ function $703f8006cf89f64f$export$2e2bcd8739ae039() {}



var $acw62 = parcelRequire("acw62");
var $c5d95629cede4302$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $57968fce4c9dc208$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $1ab9d1c60fb775b5$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $703f8006cf89f64f$export$2e2bcd8739ae039)
    };
});
var $1ab9d1c60fb775b5$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $57968fce4c9dc208$export$c485849f2e393253)();
    var context = (0, $acw62.useContext)($1ab9d1c60fb775b5$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $1ab9d1c60fb775b5$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $c5d95629cede4302$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ab9d1c60fb775b5$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $1ab9d1c60fb775b5$export$2e2bcd8739ae039 = $1ab9d1c60fb775b5$var$StaggeredEntrance;


var $b15369c14637aff9$var$zoomIn = null;
var $b15369c14637aff9$var$zoomOut = null;
var $b15369c14637aff9$var$fadeIn = null;
var $b15369c14637aff9$var$fadeOut = null;
var $b15369c14637aff9$var$fadeInFromTop = null;
var $b15369c14637aff9$var$fadeOutFromTop = null;
var $b15369c14637aff9$var$fadeInFromLeft = null;
var $b15369c14637aff9$var$fadeOutFromLeft = null;
var $b15369c14637aff9$var$fadeInFromBottom = null;
var $b15369c14637aff9$var$fadeOutFromBottom = null;
var $b15369c14637aff9$var$fadeInFromRight = null;
var $b15369c14637aff9$var$fadeOutFromRight = null;
var $b15369c14637aff9$var$fadeInFromTopConstant = null;
var $b15369c14637aff9$var$fadeOutFromTopConstant = null;
var $b15369c14637aff9$var$fadeInFromLeftConstant = null;
var $b15369c14637aff9$var$fadeOutFromLeftConstant = null;
var $b15369c14637aff9$var$fadeInFromBottomConstant = null;
var $b15369c14637aff9$var$fadeOutFromBottomConstant = null;
var $b15369c14637aff9$var$fadeInFromRightConstant = null;
var $b15369c14637aff9$var$fadeOutFromRightConstant = null;
var $b15369c14637aff9$var$slideInFromTop = null;
var $b15369c14637aff9$var$slideOutFromTop = null;
var $b15369c14637aff9$var$slideInFromRight = null;
var $b15369c14637aff9$var$slideOutFromRight = null;
var $b15369c14637aff9$var$slideInFromBottom = null;
var $b15369c14637aff9$var$slideOutFromBottom = null;
var $b15369c14637aff9$var$slideInFromLeft = null;
var $b15369c14637aff9$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b15369c14637aff9$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $1ab9d1c60fb775b5$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $409e1fba7c6209e5$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $bcedfea07d5697f5$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $54b6bec240646028$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $194f2657a84cbf36$export$30fa1a2e62ae150c)[duration] : (0, $194f2657a84cbf36$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $luEYg.default)([
            (0, $luEYg.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $luEYg.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $luEYg.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $luEYg.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $luEYg.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $luEYg.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $luEYg.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $luEYg.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $luEYg.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $luEYg.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $luEYg.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $luEYg.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-40-out" && (0, $luEYg.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === "ease-in-60-out" && (0, $luEYg.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === "ease-in-80-out" && (0, $luEYg.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $luEYg.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $luEYg.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $luEYg.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $luEYg.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-40-out" && (0, $luEYg.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-60-out" && (0, $luEYg.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-80-out" && (0, $luEYg.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $luEYg.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $luEYg.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $luEYg.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $luEYg.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $luEYg.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $luEYg.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $luEYg.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $luEYg.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $luEYg.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $luEYg.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $luEYg.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $luEYg.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $luEYg.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $luEYg.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $luEYg.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $luEYg.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $luEYg.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $luEYg.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $luEYg.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $luEYg.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $luEYg.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $luEYg.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $luEYg.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $luEYg.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $luEYg.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $luEYg.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $luEYg.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $luEYg.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $luEYg.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $b15369c14637aff9$export$2e2bcd8739ae039 = $b15369c14637aff9$var$EnteringMotion;


var $ca2a51180c0616a0$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $ca2a51180c0616a0$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $ca2a51180c0616a0$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b15369c14637aff9$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $ca2a51180c0616a0$export$2e2bcd8739ae039 = $ca2a51180c0616a0$var$FadeIn;



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $ac2a885e4cd38a62$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $ac2a885e4cd38a62$export$72f415121273627e = "body > .atlaskit-portal-container";
var $ac2a885e4cd38a62$export$13f57c02915787b3 = "atlaskit-portal";


var $d1eb93353c28318c$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $ac2a885e4cd38a62$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $d1eb93353c28318c$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $d1eb93353c28318c$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $ac2a885e4cd38a62$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $ac2a885e4cd38a62$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $d1eb93353c28318c$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $d1eb93353c28318c$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $d1eb93353c28318c$var$getPortalParent().removeChild(container);
};
var $d1eb93353c28318c$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $d1eb93353c28318c$var$getPortalParent().appendChild(container);
};
var $d1eb93353c28318c$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $d1eb93353c28318c$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($d1eb93353c28318c$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $ac2a885e4cd38a62$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $d1eb93353c28318c$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($d1eb93353c28318c$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $ac2a885e4cd38a62$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $ac2a885e4cd38a62$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $d1eb93353c28318c$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $2953953ae0dfe471$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $d1eb93353c28318c$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $d1eb93353c28318c$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $d1eb93353c28318c$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
var $732426393e7b7d9d$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $067a8adc3d27508a$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $732426393e7b7d9d$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $d1eb93353c28318c$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $d1eb93353c28318c$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $2d57c4a039cc14ff$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $732426393e7b7d9d$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $2d57c4a039cc14ff$export$2e2bcd8739ae039 = $2d57c4a039cc14ff$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $2ac8a12bb819d1f9$export$ed5835cc67e87f72 = "akPortalMount";
var $2ac8a12bb819d1f9$export$80816bd900e5bd00 = "akPortalUnmount";


var $8f1d0bce80dd6f8b$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $8f1d0bce80dd6f8b$var$getLayerName = function getLayerName(zIndex) {
    return $8f1d0bce80dd6f8b$var$zIndexToName.hasOwnProperty(zIndex) ? $8f1d0bce80dd6f8b$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $8f1d0bce80dd6f8b$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $8f1d0bce80dd6f8b$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $8f1d0bce80dd6f8b$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $8f1d0bce80dd6f8b$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $e593453d146cebfd$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $8f1d0bce80dd6f8b$export$2e2bcd8739ae039)((0, $2ac8a12bb819d1f9$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $8f1d0bce80dd6f8b$export$2e2bcd8739ae039)((0, $2ac8a12bb819d1f9$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e593453d146cebfd$export$2e2bcd8739ae039 = $e593453d146cebfd$var$useFirePortalEvent;


function $c5a9f60c8d274816$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $2d57c4a039cc14ff$export$2e2bcd8739ae039)(mountStrategy);
    (0, $e593453d146cebfd$export$2e2bcd8739ae039)(zIndex);
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2953953ae0dfe471$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $067a8adc3d27508a$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $bf5141e249b21ad5$var$printed = {};
function $bf5141e249b21ad5$export$2e2bcd8739ae039(message) {
    if ($bf5141e249b21ad5$var$printed[message]) return;
    $bf5141e249b21ad5$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $318ae8412d64b8a8$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $bf5141e249b21ad5$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $318ae8412d64b8a8$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


// Reds
var $fc1f9c515b697fa4$export$4b84fd0e2c617bd = "#FFEBE6";
var $fc1f9c515b697fa4$export$b34b069eff244586 = "#FFBDAD";
var $fc1f9c515b697fa4$export$be802dd0d8b57f35 = "#FF8F73";
var $fc1f9c515b697fa4$export$60847d42f9da92a6 = "#FF7452";
var $fc1f9c515b697fa4$export$4a7404f376229999 = "#FF5630";
var $fc1f9c515b697fa4$export$2010d0fb4295b346 = "#DE350B";
var $fc1f9c515b697fa4$export$2837b5a1a71d5c02 = "#BF2600";
var $fc1f9c515b697fa4$export$8d9596b529bbb9cf = "#FFFAE6";
var $fc1f9c515b697fa4$export$41060a744ab0b7ae = "#FFF0B3";
var $fc1f9c515b697fa4$export$1cc05bbbf340e559 = "#FFE380";
var $fc1f9c515b697fa4$export$5aae31392d72caaa = "#FFC400";
var $fc1f9c515b697fa4$export$c6930421db9fa514 = "#FFAB00";
var $fc1f9c515b697fa4$export$59619663aa6500fb = "#FF991F";
var $fc1f9c515b697fa4$export$874739ea9e379ab6 = "#FF8B00";
var $fc1f9c515b697fa4$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $fc1f9c515b697fa4$export$69a3bf21b9686c2b = "#ABF5D1";
var $fc1f9c515b697fa4$export$afbce1382ec95f73 = "#79F2C0";
var $fc1f9c515b697fa4$export$747d86715d4175de = "#57D9A3";
var $fc1f9c515b697fa4$export$940e1f69e873f202 = "#36B37E";
var $fc1f9c515b697fa4$export$a49394138f7b8e85 = "#00875A";
var $fc1f9c515b697fa4$export$6fa04827ac68a4fb = "#006644";
var $fc1f9c515b697fa4$export$226de0355ed012f8 = "#DEEBFF";
var $fc1f9c515b697fa4$export$8c13c2ee36917869 = "#B3D4FF";
var $fc1f9c515b697fa4$export$ecfc1dff386a3e7a = "#4C9AFF";
var $fc1f9c515b697fa4$export$215b7063051591f1 = "#2684FF";
var $fc1f9c515b697fa4$export$e62e8919cca44969 = "#0065FF";
var $fc1f9c515b697fa4$export$b3de0ae08da2ce64 = "#0052CC";
var $fc1f9c515b697fa4$export$a6ee3d71bc067634 = "#0747A6";
var $fc1f9c515b697fa4$export$67f15409e87642a1 = "#669DF1";
var $fc1f9c515b697fa4$export$f0539dbc42dbb067 = "#8FB8F6";
var $fc1f9c515b697fa4$export$363e4475840015bb = "#EAE6FF";
var $fc1f9c515b697fa4$export$4b0a4417ed59760f = "#C0B6F2";
var $fc1f9c515b697fa4$export$6011520a64d9a187 = "#998DD9";
var $fc1f9c515b697fa4$export$a7175d4e9206bc80 = "#8777D9";
var $fc1f9c515b697fa4$export$b48405b95304b5a1 = "#6554C0";
var $fc1f9c515b697fa4$export$c71e4279dd54a18d = "#5243AA";
var $fc1f9c515b697fa4$export$147899de772240ec = "#403294";
var $fc1f9c515b697fa4$export$2cf711fe14c66f06 = "#E6FCFF";
var $fc1f9c515b697fa4$export$7a8f4d33f6f9772c = "#B3F5FF";
var $fc1f9c515b697fa4$export$776c9c497ef08533 = "#79E2F2";
var $fc1f9c515b697fa4$export$69cb3ca10c1e330e = "#00C7E6";
var $fc1f9c515b697fa4$export$9dc1ef0f3f48059b = "#00B8D9";
var $fc1f9c515b697fa4$export$7c835c78b6fcdef8 = "#00A3BF";
var $fc1f9c515b697fa4$export$6036577f95c3877e = "#008DA6";
var $fc1f9c515b697fa4$export$29a4f05edc054374 = "#FFFFFF";
var $fc1f9c515b697fa4$export$e655ef011c4aa1a2 = "#FAFBFC";
var $fc1f9c515b697fa4$export$9fdfb749e33cdf97 = "#F4F5F7";
var $fc1f9c515b697fa4$export$3e51e8f1440314ba = "#EBECF0";
var $fc1f9c515b697fa4$export$1ce2d1575d444ceb = "#DFE1E6";
var $fc1f9c515b697fa4$export$8754fc7e6d8b3000 = "#C1C7D0";
var $fc1f9c515b697fa4$export$c2e91cbeada39b8b = "#B3BAC5";
var $fc1f9c515b697fa4$export$5f71e19f3a7ad9de = "#A5ADBA";
var $fc1f9c515b697fa4$export$eaa8c8a70ac22806 = "#97A0AF";
var $fc1f9c515b697fa4$export$7c87d337fb91a97d = "#8993A4";
var $fc1f9c515b697fa4$export$d6447c357493214f = "#7A869A";
var $fc1f9c515b697fa4$export$f563ee71e9ee74cd = "#6B778C";
var $fc1f9c515b697fa4$export$e2ef2124cf4024b1 = "#5E6C84";
var $fc1f9c515b697fa4$export$eece5f492e429f08 = "#505F79";
var $fc1f9c515b697fa4$export$c39c0fe0f26207ae = "#42526E";
var $fc1f9c515b697fa4$export$7090862dc3038a9f = "#344563";
var $fc1f9c515b697fa4$export$ad0bacf983b7ddaa = "#253858";
var $fc1f9c515b697fa4$export$7d61b15e0da132af = "#172B4D";
var $fc1f9c515b697fa4$export$fbda843f0a27fe96 = "#091E42";
var $fc1f9c515b697fa4$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $fc1f9c515b697fa4$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $fc1f9c515b697fa4$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $fc1f9c515b697fa4$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $fc1f9c515b697fa4$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $fc1f9c515b697fa4$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $fc1f9c515b697fa4$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $fc1f9c515b697fa4$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $fc1f9c515b697fa4$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $fc1f9c515b697fa4$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $fc1f9c515b697fa4$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $fc1f9c515b697fa4$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $fc1f9c515b697fa4$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $fc1f9c515b697fa4$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $fc1f9c515b697fa4$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $fc1f9c515b697fa4$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $fc1f9c515b697fa4$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $fc1f9c515b697fa4$export$2f6319cf7d736c2a = "#E6EDFA";
var $fc1f9c515b697fa4$export$95126bc8884d6634 = "#DCE5F5";
var $fc1f9c515b697fa4$export$8338d8c35d44ff1 = "#CED9EB";
var $fc1f9c515b697fa4$export$5368d76ae4fbbda7 = "#B8C7E0";
var $fc1f9c515b697fa4$export$9f0a771d16ec8d36 = "#ABBBD6";
var $fc1f9c515b697fa4$export$abcf8c38338b4aa5 = "#9FB0CC";
var $fc1f9c515b697fa4$export$97e81faa16a182c7 = "#8C9CB8";
var $fc1f9c515b697fa4$export$bfe21c59123ecf33 = "#7988A3";
var $fc1f9c515b697fa4$export$ee82aa2ea6a1558 = "#67758F";
var $fc1f9c515b697fa4$export$682927c6ed76be02 = "#56637A";
var $fc1f9c515b697fa4$export$91fd9994c5be9757 = "#455166";
var $fc1f9c515b697fa4$export$d281fbfe3cff2df6 = "#3B475C";
var $fc1f9c515b697fa4$export$3902c91d8b98a753 = "#313D52";
var $fc1f9c515b697fa4$export$8e8133c1ba5845b5 = "#283447";
var $fc1f9c515b697fa4$export$33ff357f6620b39 = "#202B3D";
var $fc1f9c515b697fa4$export$633847cf062b69e0 = "#1B2638";
var $fc1f9c515b697fa4$export$9776a6e503bdbf76 = "#121A29";
var $fc1f9c515b697fa4$export$6c813d5160dff5db = "#0E1624";
var $fc1f9c515b697fa4$export$3d4f271a500072a = "#0D1424";
var $fc1f9c515b697fa4$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $fc1f9c515b697fa4$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $fc1f9c515b697fa4$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $fc1f9c515b697fa4$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $fc1f9c515b697fa4$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $fc1f9c515b697fa4$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $fc1f9c515b697fa4$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $fc1f9c515b697fa4$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $fc1f9c515b697fa4$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $fc1f9c515b697fa4$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $fc1f9c515b697fa4$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $fc1f9c515b697fa4$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $fc1f9c515b697fa4$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $fc1f9c515b697fa4$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $fc1f9c515b697fa4$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $fc1f9c515b697fa4$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $fc1f9c515b697fa4$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $fc1f9c515b697fa4$export$d2adc5dedf09fced = "#292A2E";
var $fc1f9c515b697fa4$export$f51762073d2bb381 = "#94C748";
var $fc1f9c515b697fa4$export$95e26d54def96891 = "#B3DF72";


var $7329851787b765fe$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $7329851787b765fe$export$c93026a968943f95 = "light";
var $7329851787b765fe$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $7329851787b765fe$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7329851787b765fe$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7329851787b765fe$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $fc1f9c515b697fa4$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7329851787b765fe$export$6d8204c2cb2e06b8() / 4;
    (0, $318ae8412d64b8a8$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7329851787b765fe$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7329851787b765fe$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7329851787b765fe$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $318ae8412d64b8a8$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $7329851787b765fe$export$ba1d834b86d72a09 = $7329851787b765fe$export$a1b3edb637fb4f35;
var $7329851787b765fe$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $fc1f9c515b697fa4$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $fc1f9c515b697fa4$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $fc1f9c515b697fa4$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $13d21e854fac3aac$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $acw62 = parcelRequire("acw62");
function $34dd0f03c2a5b74e$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
var $7fbf3af4ea7a3caf$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $7fbf3af4ea7a3caf$var$react18UseId = ($7fbf3af4ea7a3caf$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $7fbf3af4ea7a3caf$var$_React$useId !== void 0 ? $7fbf3af4ea7a3caf$var$_React$useId : undefined;
function $7fbf3af4ea7a3caf$export$f680877a34711e37() {
    if ($7fbf3af4ea7a3caf$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) return $7fbf3af4ea7a3caf$var$react18UseId();
    return "uid".concat((0, $e0ee72d35d886c5b$export$87d05f07e65211f1)());
}
var $7fbf3af4ea7a3caf$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($7fbf3af4ea7a3caf$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $7fbf3af4ea7a3caf$export$6ee17796e3d70de2() {
    if ($7fbf3af4ea7a3caf$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        var uid = $7fbf3af4ea7a3caf$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e0ee72d35d886c5b$export$bb5ca5fba6fb4f1f)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
var $581c8a8ce5c50b5f$var$BORDER_WIDTH = 2;
var $581c8a8ce5c50b5f$var$baseFocusOutsideStyles = (0, $gyDKM.css)({
    outline: "".concat($581c8a8ce5c50b5f$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $581c8a8ce5c50b5f$var$BORDER_WIDTH
});
var $581c8a8ce5c50b5f$var$baseInsetStyles = (0, $gyDKM.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$581c8a8ce5c50b5f$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $581c8a8ce5c50b5f$var$focusRingStyles = (0, $gyDKM.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $581c8a8ce5c50b5f$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $581c8a8ce5c50b5f$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $581c8a8ce5c50b5f$var$insetFocusRingStyles = (0, $gyDKM.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $581c8a8ce5c50b5f$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $581c8a8ce5c50b5f$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $581c8a8ce5c50b5f$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $581c8a8ce5c50b5f$var$baseInsetStyles : $581c8a8ce5c50b5f$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $581c8a8ce5c50b5f$var$insetFocusRingStyles : $581c8a8ce5c50b5f$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $gyDKM.jsx)((0, $gyDKM.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$581c8a8ce5c50b5f$var$FocusRing.displayName = "FocusRing";
var $581c8a8ce5c50b5f$export$2e2bcd8739ae039 = $581c8a8ce5c50b5f$var$FocusRing;



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $ltooA = parcelRequire("ltooA");

function $1bec74354e3bb851$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1bec74354e3bb851$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1bec74354e3bb851$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1bec74354e3bb851$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1bec74354e3bb851$var$ESCAPE = "Escape";
function $1bec74354e3bb851$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _useLayering = $1bec74354e3bb851$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $1bec74354e3bb851$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $1bec74354e3bb851$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $acw62.useContext)((0, $e5a122294cfc1b23$export$650d12d3c2ddb8fc));
    var _useContext = (0, $acw62.useContext)((0, $e5a122294cfc1b23$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        if ((0, $ltooA.fg)("layering-top-level-use-array")) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $1bec74354e3bb851$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $ltooA.fg)("layering-top-level-use-array") ? {
        layerList: layerList
    } : {});
}



parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $b027e119303a4bc8$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $b027e119303a4bc8$export$c881183ca713c214 = $b027e119303a4bc8$export$987d49ffe1b0900f;



var $842115f5d200f2e7$export$4ef52930e33717cd = "data-theme";
var $842115f5d200f2e7$export$a00eac3f8684bcd0 = "data-color-mode";
var $842115f5d200f2e7$export$2112803007239c61 = "data-contrast-mode";
var $842115f5d200f2e7$export$352e418ed5b6193a = "data-custom-theme";
var $842115f5d200f2e7$export$6f0c6fb8c80fcc92 = "ds";
var $842115f5d200f2e7$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $842115f5d200f2e7$export$dddac1532e822863 = "--".concat($842115f5d200f2e7$export$6f0c6fb8c80fcc92, "-token-not-found");
var $842115f5d200f2e7$export$9d7b58831ae93caa = "--".concat($842115f5d200f2e7$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $acw62 = parcelRequire("acw62");
var $e84436e5754afd9b$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $e84436e5754afd9b$export$dece24112a937f92 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
function $6526817bf212fbf1$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $acw62.useRef)(null);
    var onMotionFinish = (0, $acw62.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("lLUpG");
var $9eYWs = parcelRequire("9eYWs");

var $fUHKi = parcelRequire("fUHKi");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $78186563eb9c8075$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? "" : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $78186563eb9c8075$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $78186563eb9c8075$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith("data:")) return false;
    return !$78186563eb9c8075$var$hasSameOrigin(window.location.href, iframe.src);
}
var $78186563eb9c8075$var$registry = new Map();
function $78186563eb9c8075$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll("iframe")).filter($78186563eb9c8075$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $78186563eb9c8075$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $78186563eb9c8075$var$setStyle(iframe, {
                    property: "pointer-events",
                    rule: "none",
                    priority: "important"
                }),
                count: 1
            };
            $78186563eb9c8075$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $78186563eb9c8075$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $iedos.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $78186563eb9c8075$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $78186563eb9c8075$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $aab59772f6985da7$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: "pointerdown",
            listener: stop
        },
        {
            // The user did not start a drag
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: "dragstart",
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $9eYWs.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor);
}
function $aab59772f6985da7$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $aab59772f6985da7$var$api = (0, $78186563eb9c8075$export$a74bff2507e6126b)({
    watchForInteractionStart: $aab59772f6985da7$var$watchForInteractionStart,
    watchForInteractionEnd: $aab59772f6985da7$var$watchForInteractionEnd
});
function $aab59772f6985da7$export$ec28e97c7d8b1b35() {
    return $aab59772f6985da7$var$api.registerUsage();
}


parcelRequire("6oVK7");
var $2IBLj = parcelRequire("2IBLj");

function $5a6528731520c790$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $2IBLj.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $5a6528731520c790$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $2IBLj.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $5a6528731520c790$var$api = (0, $78186563eb9c8075$export$a74bff2507e6126b)({
    watchForInteractionStart: $5a6528731520c790$var$watchForInteractionStart,
    watchForInteractionEnd: $5a6528731520c790$var$watchForInteractionEnd
});
function $5a6528731520c790$export$27d79116d3a4e7d5() {
    return $5a6528731520c790$var$api.registerUsage();
}



var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("4Gj2B");
var $gzujt = parcelRequire("gzujt");

function $a886a31c38fd4c31$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // User is starting another interaction
            type: "pointerdown",
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            type: "dragstart",
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $gzujt.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $a886a31c38fd4c31$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $a886a31c38fd4c31$var$api = (0, $78186563eb9c8075$export$a74bff2507e6126b)({
    watchForInteractionStart: $a886a31c38fd4c31$var$watchForInteractionStart,
    watchForInteractionEnd: $a886a31c38fd4c31$var$watchForInteractionEnd
});
function $a886a31c38fd4c31$export$9c0606fcefb5d1e2() {
    return $a886a31c38fd4c31$var$api.registerUsage();
}


var $ad766c1accb12a7e$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $ad766c1accb12a7e$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = $ad766c1accb12a7e$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($ad766c1accb12a7e$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $ad766c1accb12a7e$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};



var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");
var $1219d3977ab14bb8$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $1219d3977ab14bb8$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $1219d3977ab14bb8$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";
var $1219d3977ab14bb8$export$fc825baa2ef870d0 = "cubic-bezier(0.4,0,0,1)";
var $1219d3977ab14bb8$export$816ee5d79b5bd9a5 = "cubic-bezier(0.6,0,0,1)";
var $1219d3977ab14bb8$export$53ce3390a1a8f2a2 = "cubic-bezier(0.8,0,0,1)";
var $1219d3977ab14bb8$export$45db2fc2f15997e7 = "cubic-bezier(0,0,1,1)";





var $51ce3a616635a3e4$var$gutter = 60;
var $51ce3a616635a3e4$var$maxWidthDimensions = "calc(100vw - ".concat($51ce3a616635a3e4$var$gutter * 2, "px)");
var $51ce3a616635a3e4$var$maxHeightDimensions = "calc(100vh - ".concat($51ce3a616635a3e4$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $51ce3a616635a3e4$var$positionerStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $7329851787b765fe$export$7be255094ccdc533).modal(),
    flexDirection: "column",
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $51ce3a616635a3e4$var$viewportScrollStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    height: "auto",
    position: "relative"
}, (0, $b027e119303a4bc8$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat($51ce3a616635a3e4$var$gutter, "px auto"),
    pointerEvents: "none"
}));
var $51ce3a616635a3e4$var$bodyScrollStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $b027e119303a4bc8$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $51ce3a616635a3e4$var$maxWidthDimensions,
    maxHeight: $51ce3a616635a3e4$var$maxHeightDimensions,
    position: "absolute",
    insetBlockStart: "".concat($51ce3a616635a3e4$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    pointerEvents: "none"
}));
var $51ce3a616635a3e4$var$stackTransitionStyles = (0, $gyDKM.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $194f2657a84cbf36$export$38b928a7167ce124).medium, "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $1219d3977ab14bb8$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $51ce3a616635a3e4$var$stackTransformStyles = (0, $gyDKM.css)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $51ce3a616635a3e4$var$stackIdleStyles = (0, $gyDKM.css)({
    transform: "none"
});
var $51ce3a616635a3e4$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $gyDKM.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--modal-dialog-translate-y": "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $51ce3a616635a3e4$var$positionerStyles,
            $51ce3a616635a3e4$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $51ce3a616635a3e4$var$stackTransformStyles : $51ce3a616635a3e4$var$stackIdleStyles,
            shouldScrollInViewport ? $51ce3a616635a3e4$var$viewportScrollStyles : $51ce3a616635a3e4$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$51ce3a616635a3e4$export$2e2bcd8739ae039 = $51ce3a616635a3e4$var$Positioner;


var $bf956acd0496239d$var$dialogStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $fc1f9c515b697fa4$export$29a4f05edc054374), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $fc1f9c515b697fa4$export$fbda843f0a27fe96), ")")
}, (0, $842115f5d200f2e7$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $fc1f9c515b697fa4$export$29a4f05edc054374), ")")), "pointerEvents", "auto"), (0, $b027e119303a4bc8$export$987d49ffe1b0900f).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $fc1f9c515b697fa4$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $fc1f9c515b697fa4$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $fc1f9c515b697fa4$export$d2d3bedfb276cac0)), ")"),
    marginInlineEnd: "inherit",
    marginInlineStart: "inherit"
}), "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}));
var $bf956acd0496239d$var$viewportScrollStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $b027e119303a4bc8$export$987d49ffe1b0900f).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $bf956acd0496239d$var$bodyScrollStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $b027e119303a4bc8$export$987d49ffe1b0900f).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $bf956acd0496239d$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $7fbf3af4ea7a3caf$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $acw62.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $iedos.combine)((0, $aab59772f6985da7$export$ec28e97c7d8b1b35)(), (0, $a886a31c38fd4c31$export$9c0606fcefb5d1e2)(), (0, $5a6528731520c790$export$27d79116d3a4e7d5)());
    }, []);
    (0, $34dd0f03c2a5b74e$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $6526817bf212fbf1$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $acw62.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $1bec74354e3bb851$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $1bec74354e3bb851$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return (0, $gyDKM.jsx)((0, $51ce3a616635a3e4$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $gyDKM.jsx)((0, $e84436e5754afd9b$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $gyDKM.jsx)((0, $e84436e5754afd9b$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $gyDKM.jsx)((0, $ca2a51180c0616a0$export$2e2bcd8739ae039), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $gyDKM.jsx)((0, $581c8a8ce5c50b5f$export$2e2bcd8739ae039), null, (0, $gyDKM.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $13d21e854fac3aac$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-width": (0, $ad766c1accb12a7e$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-height": (0, $ad766c1accb12a7e$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $bf956acd0496239d$var$dialogStyles,
                shouldScrollInViewport ? $bf956acd0496239d$var$viewportScrollStyles : $bf956acd0496239d$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bf956acd0496239d$export$2e2bcd8739ae039 = $bf956acd0496239d$var$ModalDialog;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $424a3e69aba92a32$var$uniqueReferencedValue = {};
function $424a3e69aba92a32$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $acw62.useRef)($424a3e69aba92a32$var$uniqueReferencedValue);
    if (ref.current === $424a3e69aba92a32$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $43421e821abb74cd$export$2e2bcd8739ae039(callback) {
    var ref = (0, $424a3e69aba92a32$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $5b90feeab0cf80f4$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $c099b19c3dd0cb65$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $acw62.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $0c2bc339094a93de$var$modalStackRegister = [];
function $0c2bc339094a93de$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $409e1fba7c6209e5$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $c099b19c3dd0cb65$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $5b90feeab0cf80f4$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $43421e821abb74cd$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $0c2bc339094a93de$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $acw62.useEffect)(function() {
        var currentStackIndex = $0c2bc339094a93de$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $0c2bc339094a93de$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $0c2bc339094a93de$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $0c2bc339094a93de$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $0c2bc339094a93de$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $0c2bc339094a93de$var$modalStackRegister.splice(currentStackIndex, 1);
                $0c2bc339094a93de$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $acw62.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $10a981246720e021$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $10a981246720e021$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $acw62.useLayoutEffect)(function() {
        setScrollTopOffset($10a981246720e021$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $acw62.useCallback)(function() {
        if ($10a981246720e021$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $2de636e70f18707f$var$fillScreenStyles = (0, $gyDKM.css)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $2de636e70f18707f$var$allowlistElements = function allowlistElements(element, callback) {
    var isAuiDialogAllowlisted = (0, $ltooA.fg)("platform_dst_allowlist-aui-dialog-for-ak-modal");
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (isAuiDialogAllowlisted && !!document.querySelector(".aui-blanket:not([hidden])")) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === "function") return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $2de636e70f18707f$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $3a8eb9859f488de9$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $3a8eb9859f488de9$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $0c2bc339094a93de$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $da4a71ad48bb2f49$export$a4687b0234b40e28)({
        fn: onClose,
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.1.1"
    });
    var onBlanketClicked = (0, $acw62.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $acw62.useCallback)(function(element) {
        return $2de636e70f18707f$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $10a981246720e021$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $gyDKM.jsx)((0, $4b5f27ceb6232f9f$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $gyDKM.jsx)((0, $bf956acd0496239d$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $gyDKM.jsx)((0, $e5a122294cfc1b23$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $gyDKM.jsx)((0, $c5a9f60c8d274816$export$2e2bcd8739ae039), {
        zIndex: (0, $7329851787b765fe$export$7be255094ccdc533).modal()
    }, (0, $gyDKM.jsx)((0, $ca2a51180c0616a0$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return (0, $gyDKM.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, fadeInProps, {
            css: $2de636e70f18707f$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $gyDKM.jsx)((0, $32ba2b8b866d6e66$export$2e2bcd8739ae039), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $gyDKM.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ae3397446a14bfac$exports))), null), shouldScrollInViewport ? (0, $gyDKM.jsx)((0, $ae3397446a14bfac$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $2de636e70f18707f$export$2e2bcd8739ae039 = $2de636e70f18707f$var$ModalWrapper;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $acw62 = parcelRequire("acw62");

var $01654f828baf5aac$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $acw62.useContext)((0, $e84436e5754afd9b$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $8fY35 = parcelRequire("8fY35");

var $ciU3d = parcelRequire("ciU3d");






var $cb049fb970a661aa$var$keylineColor = "var(--ds-border, ".concat((0, $fc1f9c515b697fa4$export$3e51e8f1440314ba), ")");
var $cb049fb970a661aa$var$baseStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $b027e119303a4bc8$export$987d49ffe1b0900f).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $cb049fb970a661aa$var$keylineHeight = 2;
var $cb049fb970a661aa$var$topKeylineStyles = (0, $gyDKM.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $cb049fb970a661aa$var$keylineColor)
});
var $cb049fb970a661aa$var$bottomKeylineStyles = (0, $gyDKM.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $cb049fb970a661aa$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $cb049fb970a661aa$var$ScrollContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $acw62.useEffect)(function() {
        var schedule = (0, $ciU3d.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $43421e821abb74cd$export$2e2bcd8739ae039)((0, $ciU3d.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $cb049fb970a661aa$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $cb049fb970a661aa$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $acw62.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $8fY35.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $8fY35.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $3a8eb9859f488de9$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $gyDKM.jsx)((0, $581c8a8ce5c50b5f$export$2e2bcd8739ae039), {
        isInset: true
    }, (0, $gyDKM.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $13d21e854fac3aac$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $cb049fb970a661aa$var$baseStyles,
            showTopKeyline && $cb049fb970a661aa$var$topKeylineStyles,
            showBottomKeyline && $cb049fb970a661aa$var$bottomKeylineStyles
        ]
    }, children));
});
$cb049fb970a661aa$var$ScrollContainer.displayName = "ScrollContainer";
var $cb049fb970a661aa$export$2e2bcd8739ae039 = $cb049fb970a661aa$var$ScrollContainer;



var $acw62 = parcelRequire("acw62");

function $ffa33f659eabb1db$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $acw62.useContext)((0, $e84436e5754afd9b$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $9e407589358cadb4$var$bodyStyles = (0, $gyDKM.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $9e407589358cadb4$var$bodyScrollStyles = (0, $gyDKM.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $9e407589358cadb4$var$viewportScrollStyles = (0, $gyDKM.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $9e407589358cadb4$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $01654f828baf5aac$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $ffa33f659eabb1db$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $gyDKM.jsx)("div", {
        css: [
            $9e407589358cadb4$var$bodyStyles,
            $9e407589358cadb4$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $gyDKM.jsx)((0, $ae3397446a14bfac$exports.TouchScrollable), null, (0, $gyDKM.jsx)((0, $cb049fb970a661aa$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $gyDKM.jsx)("div", {
        css: [
            $9e407589358cadb4$var$bodyStyles,
            $9e407589358cadb4$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $9e407589358cadb4$export$2e2bcd8739ae039 = $9e407589358cadb4$var$ModalBody;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gyDKM = parcelRequire("gyDKM");

var $51c3a3d13ce0e3d4$var$footerStyles = (0, $gyDKM.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $51c3a3d13ce0e3d4$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $01654f828baf5aac$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $gyDKM.jsx)("div", {
        css: $51c3a3d13ce0e3d4$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $51c3a3d13ce0e3d4$export$2e2bcd8739ae039 = $51c3a3d13ce0e3d4$var$ModalFooter;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $72c1af88d38e828a$var$headerStyles = (0, $gyDKM.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $72c1af88d38e828a$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $01654f828baf5aac$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $gyDKM.jsx)("div", {
        css: $72c1af88d38e828a$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $72c1af88d38e828a$export$2e2bcd8739ae039 = $72c1af88d38e828a$var$ModalHeader;


var $acw62 = parcelRequire("acw62");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $9e85ea5877acbb2a$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $409e1fba7c6209e5$export$2e2bcd8739ae039), {
        appear: true
    }, props.children);
};
var $9e85ea5877acbb2a$export$2e2bcd8739ae039 = $9e85ea5877acbb2a$var$ModalTransition;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $6aa2243ae498cdf7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6aa2243ae498cdf7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6aa2243ae498cdf7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6aa2243ae498cdf7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6aa2243ae498cdf7$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6aa2243ae498cdf7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $6aa2243ae498cdf7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6aa2243ae498cdf7$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $6aa2243ae498cdf7$var$_objectSpread($6aa2243ae498cdf7$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $aecf93129970955f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $aecf93129970955f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $aecf93129970955f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($aecf93129970955f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $aecf93129970955f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $aecf93129970955f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $aecf93129970955f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $aecf93129970955f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $aecf93129970955f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $aecf93129970955f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6aa2243ae498cdf7$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $8a7277657959c848$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $0b76d523d6ea8de9$export$5bf35293e545f20c() {
    var analyticsContext = (0, $8a7277657959c848$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $aecf93129970955f$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $509e6948e89e901c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $7bd463fa379dead6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bd463fa379dead6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bd463fa379dead6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bd463fa379dead6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7bd463fa379dead6$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $0b76d523d6ea8de9$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $509e6948e89e901c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $509e6948e89e901c$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7bd463fa379dead6$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $13866e744941118f$export$2e2bcd8739ae039() {}




var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");
var $119ca37061986fbc$export$4ef52930e33717cd = "data-theme";
var $119ca37061986fbc$export$a00eac3f8684bcd0 = "data-color-mode";
var $119ca37061986fbc$export$2112803007239c61 = "data-contrast-mode";
var $119ca37061986fbc$export$352e418ed5b6193a = "data-custom-theme";
var $119ca37061986fbc$export$2faeed762aac6741 = "light";
var $119ca37061986fbc$export$6f0c6fb8c80fcc92 = "ds";
var $119ca37061986fbc$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $119ca37061986fbc$export$dddac1532e822863 = "--".concat($119ca37061986fbc$export$6f0c6fb8c80fcc92, "-token-not-found");
var $119ca37061986fbc$export$9d7b58831ae93caa = "--".concat($119ca37061986fbc$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $083a998ee3f1192a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $083a998ee3f1192a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $083a998ee3f1192a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $083a998ee3f1192a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $083a998ee3f1192a$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $083a998ee3f1192a$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $083a998ee3f1192a$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $083a998ee3f1192a$export$632685d741f3dbbf = $083a998ee3f1192a$var$_objectSpread($083a998ee3f1192a$var$_objectSpread({}, $083a998ee3f1192a$export$958d0ae7f2977ae4), $083a998ee3f1192a$export$d2dc61f58390201c);
var $083a998ee3f1192a$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $083a998ee3f1192a$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $083a998ee3f1192a$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $083a998ee3f1192a$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $083a998ee3f1192a$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $083a998ee3f1192a$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $083a998ee3f1192a$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $083a998ee3f1192a$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $083a998ee3f1192a$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $083a998ee3f1192a$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $083a998ee3f1192a$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $083a998ee3f1192a$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $083a998ee3f1192a$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $083a998ee3f1192a$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $083a998ee3f1192a$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $083a998ee3f1192a$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $083a998ee3f1192a$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $083a998ee3f1192a$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $083a998ee3f1192a$export$e615f061ca585a6c = $083a998ee3f1192a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $083a998ee3f1192a$export$ca0f9c2de39ffed7(spacingProperty, $083a998ee3f1192a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $083a998ee3f1192a$export$bf46c3f9eeafc71f = $083a998ee3f1192a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $083a998ee3f1192a$export$ca0f9c2de39ffed7(spacingProperty, $083a998ee3f1192a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $083a998ee3f1192a$export$e7af83bafe7f9e63 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("backgroundColor", $083a998ee3f1192a$export$d1d79bf68ac056bd);
var $083a998ee3f1192a$export$3a1bcba60b23d7f0 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("color", $083a998ee3f1192a$export$8473307aa00d6ea1);
var $083a998ee3f1192a$export$45f3f4fe16f9f7d5 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("fontWeight", $083a998ee3f1192a$export$303e322c6b1ed114);
var $083a998ee3f1192a$export$68cc305da27dbaa4 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("fontFamily", $083a998ee3f1192a$export$3c7e9587132614b4);
var $083a998ee3f1192a$export$128f10c238242f83 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("font", $083a998ee3f1192a$export$6ffa317d5e70375);
var $083a998ee3f1192a$export$219d364c0da35ae4 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("font", $083a998ee3f1192a$export$236bfe3a33ef1292);
var $083a998ee3f1192a$export$38845ca010b93505 = $083a998ee3f1192a$export$ca0f9c2de39ffed7("fontWeight", $083a998ee3f1192a$export$855cfd311192d666);
var $083a998ee3f1192a$export$ff257d957d48c421 = $083a998ee3f1192a$export$ca0f9c2de39ffed7((0, $119ca37061986fbc$export$9d7b58831ae93caa), $083a998ee3f1192a$export$41a358c9c2356760);
var $083a998ee3f1192a$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $083a998ee3f1192a$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $gyDKM = parcelRequire("gyDKM");


var $hPtJY = parcelRequire("hPtJY");
function $bb4355498b94e8a3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bb4355498b94e8a3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bb4355498b94e8a3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bb4355498b94e8a3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bb4355498b94e8a3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bb4355498b94e8a3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $bb4355498b94e8a3$export$9a199fbafee0014e = {
    backgroundColor: (0, $083a998ee3f1192a$export$d1d79bf68ac056bd),
    blockSize: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderBottomColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderLeftColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $083a998ee3f1192a$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    borderWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    bottom: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    boxShadow: (0, $083a998ee3f1192a$export$7aff6e7ba39bb774),
    color: (0, $083a998ee3f1192a$export$8473307aa00d6ea1),
    columnGap: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    font: (0, $083a998ee3f1192a$export$6ffa317d5e70375),
    fontFamily: (0, $083a998ee3f1192a$export$3c7e9587132614b4),
    fontWeight: (0, $083a998ee3f1192a$export$303e322c6b1ed114),
    gap: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    height: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    inlineSize: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    inset: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    insetBlock: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    insetBlockEnd: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    insetBlockStart: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    insetInline: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    insetInlineEnd: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    insetInlineStart: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    left: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    margin: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginBlock: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginBlockEnd: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginBlockStart: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginBottom: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginInline: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginInlineEnd: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginInlineStart: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginLeft: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginRight: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    marginTop: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    maxBlockSize: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    maxHeight: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    maxWidth: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    minBlockSize: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    minHeight: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    minInlineSize: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    minWidth: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    opacity: (0, $083a998ee3f1192a$export$daf94a976c798b4f),
    outlineColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac),
    outlineOffset: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    outlineWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8),
    padding: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingBlock: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingBottom: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingInline: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingLeft: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingRight: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    paddingTop: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    right: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    rowGap: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4),
    top: (0, $083a998ee3f1192a$export$632685d741f3dbbf),
    width: (0, $083a998ee3f1192a$export$6ccdbebca2ee545f),
    zIndex: (0, $083a998ee3f1192a$export$b5f31a7e431d2eab)
};
var $bb4355498b94e8a3$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $bb4355498b94e8a3$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $bb4355498b94e8a3$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $bb4355498b94e8a3$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $bb4355498b94e8a3$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($bb4355498b94e8a3$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $bb4355498b94e8a3$var$safeSelectors.test(key)) {
            styleObj[key] = $bb4355498b94e8a3$var$_transformStyles(value);
            return;
        }
        if ($bb4355498b94e8a3$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($bb4355498b94e8a3$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $bb4355498b94e8a3$export$9a199fbafee0014e)) return;
        var tokenValue = $bb4355498b94e8a3$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $bb4355498b94e8a3$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $bb4355498b94e8a3$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $bb4355498b94e8a3$var$uniqueSymbol, (0, $gyDKM.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $bb4355498b94e8a3$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $bb4355498b94e8a3$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $bb4355498b94e8a3$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$bb4355498b94e8a3$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $bb4355498b94e8a3$export$f6c783d06584602c(style) {
    return $bb4355498b94e8a3$var$baseXcss(style);
}


var $5d945e0aed9c760e$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $5d945e0aed9c760e$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $5d945e0aed9c760e$var$focusRingStyles = (0, $gyDKM.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $083a998ee3f1192a$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $083a998ee3f1192a$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $083a998ee3f1192a$export$e1b83c5210c471b8)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $5d945e0aed9c760e$var$baseStyles = (0, $gyDKM.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $5d945e0aed9c760e$var$enabledStyles = (0, $gyDKM.css)({
    cursor: "pointer"
});
var $5d945e0aed9c760e$var$disabledStyles = (0, $gyDKM.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $5d945e0aed9c760e$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $13866e744941118f$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $5d945e0aed9c760e$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $807d5a51f7285bd1$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7bd463fa379dead6$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $5d945e0aed9c760e$var$_excluded2);
    var resolvedStyles = (0, $bb4355498b94e8a3$export$a9c84988c8f81f2d)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $gyDKM.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $5d945e0aed9c760e$var$baseStyles,
            $5d945e0aed9c760e$var$focusRingStyles,
            isDisabled ? $5d945e0aed9c760e$var$disabledStyles : $5d945e0aed9c760e$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $083a998ee3f1192a$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $083a998ee3f1192a$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $5d945e0aed9c760e$export$2e2bcd8739ae039 = $5d945e0aed9c760e$var$Pressable;



var $acw62 = parcelRequire("acw62");

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");
var $b471ebf44a602bb9$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $b471ebf44a602bb9$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($b471ebf44a602bb9$export$1ca2a26fecb070ae);
};
$b471ebf44a602bb9$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";




var $7442186ddc93bf33$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7442186ddc93bf33$var$_excluded2 = [
    "className"
];
var $7442186ddc93bf33$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $7442186ddc93bf33$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $7442186ddc93bf33$var$_excluded2);
    var resolvedStyles = (0, $bb4355498b94e8a3$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $7442186ddc93bf33$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $083a998ee3f1192a$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $083a998ee3f1192a$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $083a998ee3f1192a$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $083a998ee3f1192a$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $083a998ee3f1192a$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $gyDKM.jsx)((0, $b471ebf44a602bb9$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $7442186ddc93bf33$export$2e2bcd8739ae039 = $7442186ddc93bf33$export$e71c4d32a2263218;
var $7442186ddc93bf33$var$baseStyles = (0, $gyDKM.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $59997ef951923242$var$textStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $59997ef951923242$var$iconStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: "none"
});
var $59997ef951923242$var$commonStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    transition: "opacity 0.3s"
});
var $59997ef951923242$var$fadeStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $59997ef951923242$var$beforeIconStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $59997ef951923242$var$afterIconStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $59997ef951923242$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7442186ddc93bf33$export$2e2bcd8739ae039), {
        as: "span",
        xcss: [
            $59997ef951923242$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(type === "text" ? [
            $59997ef951923242$var$textStyles
        ] : [
            $59997ef951923242$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(isLoading ? [
            $59997ef951923242$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(position === "before" ? [
            $59997ef951923242$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(position === "after" ? [
            $59997ef951923242$var$afterIconStyles
        ] : []))
    }, children);
};
var $59997ef951923242$export$2e2bcd8739ae039 = $59997ef951923242$var$Content;



var $acw62 = parcelRequire("acw62");
function $6bafe83c74117cbe$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $6bafe83c74117cbe$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $6bafe83c74117cbe$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $6bafe83c74117cbe$export$2e2bcd8739ae039 = $6bafe83c74117cbe$var$IconRenderer;



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $4ce3066cf9760ddb$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $acw62 = parcelRequire("acw62");
function $63e7eca1b788d942$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
var $2962c61563225b3f$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $2962c61563225b3f$var$react18UseId = ($2962c61563225b3f$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $2962c61563225b3f$var$_React$useId !== void 0 ? $2962c61563225b3f$var$_React$useId : undefined;
function $2962c61563225b3f$export$f680877a34711e37() {
    if ($2962c61563225b3f$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $2962c61563225b3f$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $e0ee72d35d886c5b$export$87d05f07e65211f1)());
}
var $2962c61563225b3f$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($2962c61563225b3f$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $2962c61563225b3f$export$6ee17796e3d70de2() {
    if ($2962c61563225b3f$var$react18UseId && (0, $ltooA.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $2962c61563225b3f$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $e0ee72d35d886c5b$export$bb5ca5fba6fb4f1f)();
}



var $ltooA = parcelRequire("ltooA");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $d9e851d147a23683$export$4b84fd0e2c617bd = "#FFEBE6";
var $d9e851d147a23683$export$b34b069eff244586 = "#FFBDAD";
var $d9e851d147a23683$export$be802dd0d8b57f35 = "#FF8F73";
var $d9e851d147a23683$export$60847d42f9da92a6 = "#FF7452";
var $d9e851d147a23683$export$4a7404f376229999 = "#FF5630";
var $d9e851d147a23683$export$2010d0fb4295b346 = "#DE350B";
var $d9e851d147a23683$export$2837b5a1a71d5c02 = "#BF2600";
var $d9e851d147a23683$export$8d9596b529bbb9cf = "#FFFAE6";
var $d9e851d147a23683$export$41060a744ab0b7ae = "#FFF0B3";
var $d9e851d147a23683$export$1cc05bbbf340e559 = "#FFE380";
var $d9e851d147a23683$export$5aae31392d72caaa = "#FFC400";
var $d9e851d147a23683$export$c6930421db9fa514 = "#FFAB00";
var $d9e851d147a23683$export$59619663aa6500fb = "#FF991F";
var $d9e851d147a23683$export$874739ea9e379ab6 = "#FF8B00";
var $d9e851d147a23683$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d9e851d147a23683$export$69a3bf21b9686c2b = "#ABF5D1";
var $d9e851d147a23683$export$afbce1382ec95f73 = "#79F2C0";
var $d9e851d147a23683$export$747d86715d4175de = "#57D9A3";
var $d9e851d147a23683$export$940e1f69e873f202 = "#36B37E";
var $d9e851d147a23683$export$a49394138f7b8e85 = "#00875A";
var $d9e851d147a23683$export$6fa04827ac68a4fb = "#006644";
var $d9e851d147a23683$export$226de0355ed012f8 = "#DEEBFF";
var $d9e851d147a23683$export$8c13c2ee36917869 = "#B3D4FF";
var $d9e851d147a23683$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d9e851d147a23683$export$215b7063051591f1 = "#2684FF";
var $d9e851d147a23683$export$e62e8919cca44969 = "#0065FF";
var $d9e851d147a23683$export$b3de0ae08da2ce64 = "#0052CC";
var $d9e851d147a23683$export$a6ee3d71bc067634 = "#0747A6";
var $d9e851d147a23683$export$67f15409e87642a1 = "#669DF1";
var $d9e851d147a23683$export$f0539dbc42dbb067 = "#8FB8F6";
var $d9e851d147a23683$export$363e4475840015bb = "#EAE6FF";
var $d9e851d147a23683$export$4b0a4417ed59760f = "#C0B6F2";
var $d9e851d147a23683$export$6011520a64d9a187 = "#998DD9";
var $d9e851d147a23683$export$a7175d4e9206bc80 = "#8777D9";
var $d9e851d147a23683$export$b48405b95304b5a1 = "#6554C0";
var $d9e851d147a23683$export$c71e4279dd54a18d = "#5243AA";
var $d9e851d147a23683$export$147899de772240ec = "#403294";
var $d9e851d147a23683$export$2cf711fe14c66f06 = "#E6FCFF";
var $d9e851d147a23683$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d9e851d147a23683$export$776c9c497ef08533 = "#79E2F2";
var $d9e851d147a23683$export$69cb3ca10c1e330e = "#00C7E6";
var $d9e851d147a23683$export$9dc1ef0f3f48059b = "#00B8D9";
var $d9e851d147a23683$export$7c835c78b6fcdef8 = "#00A3BF";
var $d9e851d147a23683$export$6036577f95c3877e = "#008DA6";
var $d9e851d147a23683$export$29a4f05edc054374 = "#FFFFFF";
var $d9e851d147a23683$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d9e851d147a23683$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d9e851d147a23683$export$3e51e8f1440314ba = "#EBECF0";
var $d9e851d147a23683$export$1ce2d1575d444ceb = "#DFE1E6";
var $d9e851d147a23683$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d9e851d147a23683$export$c2e91cbeada39b8b = "#B3BAC5";
var $d9e851d147a23683$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d9e851d147a23683$export$eaa8c8a70ac22806 = "#97A0AF";
var $d9e851d147a23683$export$7c87d337fb91a97d = "#8993A4";
var $d9e851d147a23683$export$d6447c357493214f = "#7A869A";
var $d9e851d147a23683$export$f563ee71e9ee74cd = "#6B778C";
var $d9e851d147a23683$export$e2ef2124cf4024b1 = "#5E6C84";
var $d9e851d147a23683$export$eece5f492e429f08 = "#505F79";
var $d9e851d147a23683$export$c39c0fe0f26207ae = "#42526E";
var $d9e851d147a23683$export$7090862dc3038a9f = "#344563";
var $d9e851d147a23683$export$ad0bacf983b7ddaa = "#253858";
var $d9e851d147a23683$export$7d61b15e0da132af = "#172B4D";
var $d9e851d147a23683$export$fbda843f0a27fe96 = "#091E42";
var $d9e851d147a23683$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d9e851d147a23683$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d9e851d147a23683$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d9e851d147a23683$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d9e851d147a23683$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d9e851d147a23683$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d9e851d147a23683$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d9e851d147a23683$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d9e851d147a23683$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d9e851d147a23683$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d9e851d147a23683$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d9e851d147a23683$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d9e851d147a23683$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d9e851d147a23683$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d9e851d147a23683$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d9e851d147a23683$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d9e851d147a23683$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $d9e851d147a23683$export$2f6319cf7d736c2a = "#E6EDFA";
var $d9e851d147a23683$export$95126bc8884d6634 = "#DCE5F5";
var $d9e851d147a23683$export$8338d8c35d44ff1 = "#CED9EB";
var $d9e851d147a23683$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d9e851d147a23683$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d9e851d147a23683$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d9e851d147a23683$export$97e81faa16a182c7 = "#8C9CB8";
var $d9e851d147a23683$export$bfe21c59123ecf33 = "#7988A3";
var $d9e851d147a23683$export$ee82aa2ea6a1558 = "#67758F";
var $d9e851d147a23683$export$682927c6ed76be02 = "#56637A";
var $d9e851d147a23683$export$91fd9994c5be9757 = "#455166";
var $d9e851d147a23683$export$d281fbfe3cff2df6 = "#3B475C";
var $d9e851d147a23683$export$3902c91d8b98a753 = "#313D52";
var $d9e851d147a23683$export$8e8133c1ba5845b5 = "#283447";
var $d9e851d147a23683$export$33ff357f6620b39 = "#202B3D";
var $d9e851d147a23683$export$633847cf062b69e0 = "#1B2638";
var $d9e851d147a23683$export$9776a6e503bdbf76 = "#121A29";
var $d9e851d147a23683$export$6c813d5160dff5db = "#0E1624";
var $d9e851d147a23683$export$3d4f271a500072a = "#0D1424";
var $d9e851d147a23683$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d9e851d147a23683$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d9e851d147a23683$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d9e851d147a23683$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d9e851d147a23683$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d9e851d147a23683$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d9e851d147a23683$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d9e851d147a23683$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d9e851d147a23683$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d9e851d147a23683$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d9e851d147a23683$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d9e851d147a23683$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d9e851d147a23683$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d9e851d147a23683$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d9e851d147a23683$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d9e851d147a23683$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d9e851d147a23683$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $d9e851d147a23683$export$d2adc5dedf09fced = "#292A2E";
var $d9e851d147a23683$export$f51762073d2bb381 = "#94C748";
var $d9e851d147a23683$export$95e26d54def96891 = "#B3DF72";


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gyDKM = parcelRequire("gyDKM");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $51d57b457c5923ab$var$visuallyHiddenStyles = (0, $gyDKM.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $51d57b457c5923ab$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $gyDKM.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $51d57b457c5923ab$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $51d57b457c5923ab$export$2e2bcd8739ae039 = $51d57b457c5923ab$var$VisuallyHidden;



var $acw62 = parcelRequire("acw62");
var $000eb94e9a01b93e$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $000eb94e9a01b93e$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $acw62.useContext)($000eb94e9a01b93e$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $bdb0c2a4d450f389$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $bdb0c2a4d450f389$var$tabKeyCode = 9;
function $bdb0c2a4d450f389$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $bdb0c2a4d450f389$var$tabKeyCode) return;
    $bdb0c2a4d450f389$var$abort(event);
}
function $bdb0c2a4d450f389$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $bdb0c2a4d450f389$var$abort,
        onMouseUpCapture: $bdb0c2a4d450f389$var$abort,
        onKeyDownCapture: $bdb0c2a4d450f389$var$onKey,
        onKeyUpCapture: $bdb0c2a4d450f389$var$onKey,
        onTouchStartCapture: $bdb0c2a4d450f389$var$abort,
        onTouchEndCapture: $bdb0c2a4d450f389$var$abort,
        onPointerDownCapture: $bdb0c2a4d450f389$var$abort,
        onPointerUpCapture: $bdb0c2a4d450f389$var$abort,
        onClickCapture: $bdb0c2a4d450f389$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $bdb0c2a4d450f389$var$abort
    } : events;
}


var $9bd3f95d8cb0ef7b$export$d4c5499dc806c969 = ", Loading";



var $acw62 = parcelRequire("acw62");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $luEYg = parcelRequire("luEYg");

var $acw62 = parcelRequire("acw62");


var $8cc184934a26eece$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $c01371b6828f6eb8$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $d9e851d147a23683$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $d9e851d147a23683$export$29a4f05edc054374), ")");
}
var $c01371b6828f6eb8$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $c01371b6828f6eb8$var$loadIn = null;
var $c01371b6828f6eb8$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $c01371b6828f6eb8$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $c01371b6828f6eb8$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $8cc184934a26eece$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $c01371b6828f6eb8$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $807d5a51f7285bd1$export$2e2bcd8739ae039));
    $c01371b6828f6eb8$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $luEYg.default)([
            $c01371b6828f6eb8$var$styles.wrapperStyles,
            $c01371b6828f6eb8$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $luEYg.default)([
            $c01371b6828f6eb8$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $luEYg.default)([
            $c01371b6828f6eb8$var$styles.circleStyles
        ])
    })));
}));
var $c01371b6828f6eb8$export$2e2bcd8739ae039 = $c01371b6828f6eb8$var$Spinner;


function $6255d80113fc63da$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $6255d80113fc63da$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $6255d80113fc63da$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c01371b6828f6eb8$export$2e2bcd8739ae039), {
        size: $6255d80113fc63da$var$getIconSpacing(spacing),
        appearance: $6255d80113fc63da$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


function $2322e59e8714f935$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2322e59e8714f935$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2322e59e8714f935$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2322e59e8714f935$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// If updating `buttonStyles`, also update `buttonStylesWithRem`.
var $2322e59e8714f935$var$buttonStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: "font.body",
    fontWeight: "font.weight.medium",
    paddingBlock: "space.075",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $2322e59e8714f935$var$buttonStylesWithRem = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "2rem",
    font: "font.body",
    fontWeight: "font.weight.medium",
    paddingBlock: "space.075",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $2322e59e8714f935$var$defaultInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d9e851d147a23683$export$c39c0fe0f26207ae, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($d9e851d147a23683$export$8c13c2ee36917869, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d9e851d147a23683$export$b3de0ae08da2ce64, ")")
    }
});
var $2322e59e8714f935$var$defaultInteractiveRefreshedStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $2322e59e8714f935$var$defaultStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($d9e851d147a23683$export$8d43898f60b96a82, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($d9e851d147a23683$export$c39c0fe0f26207ae, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d9e851d147a23683$export$c39c0fe0f26207ae, ")")
    }
});
var $2322e59e8714f935$var$defaultRefreshedStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    }
});
var $2322e59e8714f935$var$primaryStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $2322e59e8714f935$var$primaryInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $2322e59e8714f935$var$warningStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $2322e59e8714f935$var$warningInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $2322e59e8714f935$var$dangerStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $2322e59e8714f935$var$dangerInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $2322e59e8714f935$var$discoveryStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $2322e59e8714f935$var$discoveryInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $2322e59e8714f935$var$subtleStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $2322e59e8714f935$var$subtleRefreshedStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    }
});
var $2322e59e8714f935$var$subtleInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $2322e59e8714f935$var$subtleInteractiveRefreshedStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $2322e59e8714f935$var$linkDecorationUnsetStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $2322e59e8714f935$var$disabledStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($d9e851d147a23683$export$8d43898f60b96a82, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d9e851d147a23683$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d9e851d147a23683$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    "::after": {
        content: "none"
    }
});
var $2322e59e8714f935$var$selectedStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$ad0bacf983b7ddaa, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")")
    }
});
var $2322e59e8714f935$var$selectedRefreshedStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    }
});
var $2322e59e8714f935$var$selectedInsideSplitButtonStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $2322e59e8714f935$var$selectedInteractiveStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($d9e851d147a23683$export$ad0bacf983b7ddaa, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($d9e851d147a23683$export$ad0bacf983b7ddaa, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $2322e59e8714f935$var$selectedWarningStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$59619663aa6500fb, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$7d61b15e0da132af, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$59619663aa6500fb, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$59619663aa6500fb, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $2322e59e8714f935$var$selectedDangerStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$2837b5a1a71d5c02, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$2837b5a1a71d5c02, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d9e851d147a23683$export$2837b5a1a71d5c02, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $2322e59e8714f935$var$selectedDiscoveryStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d9e851d147a23683$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
// If updating `spacingCompactStyles`, also update `spacingCompactStylesWithRem`.
var $2322e59e8714f935$var$spacingCompactStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    columnGap: "space.050",
    height: "".concat(24 / 14, "em"),
    paddingBlock: "space.025",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $2322e59e8714f935$var$spacingCompactStylesWithRem = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    columnGap: "space.050",
    height: "1.5rem",
    paddingBlock: "space.025",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $2322e59e8714f935$var$circleStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    borderRadius: "border.radius.circle"
});
var $2322e59e8714f935$var$fullWidthStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    width: "100%"
});
var $2322e59e8714f935$var$loadingStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    cursor: "progress"
});
// If updating `iconButtonStyles`, also update `iconButtonStylesWithRem`.
var $2322e59e8714f935$var$iconButtonStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $2322e59e8714f935$var$iconButtonStylesWithRem = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    height: "2rem",
    width: "2rem",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
// If updating `iconButtonCompactStyles`, also update `iconButtonCompactStylesWithRem`.
var $2322e59e8714f935$var$iconButtonCompactStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $2322e59e8714f935$var$iconButtonCompactStylesWithRem = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    width: "1.5rem",
    height: "1.5rem"
});
var $2322e59e8714f935$var$buttonIconBeforeStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    paddingInlineStart: "space.100"
});
var $2322e59e8714f935$var$buttonIconAfterStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    paddingInlineEnd: "space.100"
});
var $2322e59e8714f935$var$splitButtonStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $2322e59e8714f935$var$navigationSplitButtonStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $2322e59e8714f935$var$loadingOverlayStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $2322e59e8714f935$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $acw62.useRef)(null);
    var splitButtonContext = (0, $000eb94e9a01b93e$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $2962c61563225b3f$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $ltooA.fg)("platform-component-visual-refresh") ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $63e7eca1b788d942$export$2e2bcd8739ae039)(localRef, autoFocus);
    return $2322e59e8714f935$var$_objectSpread({
        ref: (0, $4ce3066cf9760ddb$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $2322e59e8714f935$var$buttonStylesWithRem : $2322e59e8714f935$var$buttonStyles,
            appearance === "default" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $2322e59e8714f935$var$defaultRefreshedStyles : $2322e59e8714f935$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $2322e59e8714f935$var$defaultInteractiveRefreshedStyles : $2322e59e8714f935$var$defaultInteractiveStyles),
            appearance === "primary" && $2322e59e8714f935$var$primaryStyles,
            appearance === "primary" && isInteractive && $2322e59e8714f935$var$primaryInteractiveStyles,
            appearance === "warning" && $2322e59e8714f935$var$warningStyles,
            appearance === "warning" && isInteractive && $2322e59e8714f935$var$warningInteractiveStyles,
            appearance === "danger" && $2322e59e8714f935$var$dangerStyles,
            appearance === "danger" && isInteractive && $2322e59e8714f935$var$dangerInteractiveStyles,
            appearance === "discovery" && $2322e59e8714f935$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $2322e59e8714f935$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $2322e59e8714f935$var$subtleRefreshedStyles : $2322e59e8714f935$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $2322e59e8714f935$var$subtleInteractiveRefreshedStyles : $2322e59e8714f935$var$subtleInteractiveStyles),
            $2322e59e8714f935$var$linkDecorationUnsetStyles,
            isSelected && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $2322e59e8714f935$var$selectedRefreshedStyles : $2322e59e8714f935$var$selectedStyles),
            isSelected && isSplitButton && $2322e59e8714f935$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $2322e59e8714f935$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $2322e59e8714f935$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $2322e59e8714f935$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $2322e59e8714f935$var$selectedDiscoveryStyles,
            isDisabled && $2322e59e8714f935$var$disabledStyles,
            isCircle && !isSplitButton && $2322e59e8714f935$var$circleStyles,
            spacing === "compact" && ((0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $2322e59e8714f935$var$spacingCompactStylesWithRem : $2322e59e8714f935$var$spacingCompactStyles),
            hasIconBefore && $2322e59e8714f935$var$buttonIconBeforeStyles,
            hasIconAfter && $2322e59e8714f935$var$buttonIconAfterStyles,
            isIconButton && ((0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $2322e59e8714f935$var$iconButtonStylesWithRem : $2322e59e8714f935$var$iconButtonStyles),
            isIconButton && spacing === "compact" && ((0, $ltooA.fg)("platform_dst_button_replace_em_with_rem") ? $2322e59e8714f935$var$iconButtonCompactStylesWithRem : $2322e59e8714f935$var$iconButtonCompactStyles),
            shouldFitContainer && $2322e59e8714f935$var$fullWidthStyles,
            isLoading && $2322e59e8714f935$var$loadingStyles,
            isSplitButton && $2322e59e8714f935$var$splitButtonStyles,
            isNavigationSplitButton && $2322e59e8714f935$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $000eb94e9a01b93e$export$4b86304b2c0d7e71).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7442186ddc93bf33$export$2e2bcd8739ae039), {
            as: "span",
            xcss: $2322e59e8714f935$var$loadingOverlayStyles
        }, (0, $6255d80113fc63da$export$2e2bcd8739ae039)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $51d57b457c5923ab$export$2e2bcd8739ae039), {
            id: loadingLabelId
        }, (0, $9bd3f95d8cb0ef7b$export$d4c5499dc806c969))),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $9bd3f95d8cb0ef7b$export$d4c5499dc806c969)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $bdb0c2a4d450f389$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $2322e59e8714f935$export$2e2bcd8739ae039 = $2322e59e8714f935$var$useButtonBase;


/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $a6c2ffbbe01ea470$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $2322e59e8714f935$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $59997ef951923242$export$2e2bcd8739ae039), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6bafe83c74117cbe$export$2e2bcd8739ae039), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $59997ef951923242$export$2e2bcd8739ae039), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $59997ef951923242$export$2e2bcd8739ae039), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6bafe83c74117cbe$export$2e2bcd8739ae039), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $a6c2ffbbe01ea470$export$2e2bcd8739ae039 = $a6c2ffbbe01ea470$var$useDefaultButton;


var $fcd5469ea5c6f261$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $fcd5469ea5c6f261$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $fcd5469ea5c6f261$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $fcd5469ea5c6f261$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $fcd5469ea5c6f261$var$_excluded2);
    var baseProps = (0, $a6c2ffbbe01ea470$export$2e2bcd8739ae039)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d945e0aed9c760e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$fcd5469ea5c6f261$var$Button.displayName = "Button";
var $fcd5469ea5c6f261$export$2e2bcd8739ae039 = $fcd5469ea5c6f261$var$Button;


/**
 * Character key codes which can be used in keyboard events.
 */ var $938d4698c2a2d161$export$390330c10ff2b9a1 = "ArrowUp";
var $938d4698c2a2d161$export$a80636c6f41931fe = "ArrowDown";
var $938d4698c2a2d161$export$4af703091671bc = "Home";
var $938d4698c2a2d161$export$e2bc30913faa5db7 = "End";
var $938d4698c2a2d161$export$10f6869ed0a7d75b = "Tab";
var $938d4698c2a2d161$export$8152f929a25a0ff4 = "Enter";
var $938d4698c2a2d161$export$e51a3576c045c8d5 = "Space";
var $938d4698c2a2d161$export$2bb790b9008907b4 = "Escape";





var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $026ef8766cce8297$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $acw62.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $acw62.useRef)(isControlled);
    (0, $acw62.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $acw62.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $a02acfeb36280694$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $acw62.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $acw62.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $f3a17832769845f6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f1feec303b173e7de0228adfc7e7782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($f3a17832769845f6$exports, "__esModule", {
    value: true
});
$f3a17832769845f6$exports.default = void 0;

var $f3a17832769845f6$var$_react = $f3a17832769845f6$var$_interopRequireDefault((parcelRequire("acw62")));

var $f3a17832769845f6$var$_chevronDown = $f3a17832769845f6$var$_interopRequireDefault((parcelRequire("l9kYV")));

var $f3a17832769845f6$var$_chevronDown2 = $f3a17832769845f6$var$_interopRequireDefault((parcelRequire("84K5U")));
function $f3a17832769845f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3a17832769845f6$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f3a17832769845f6$var$_react.default.createElement($f3a17832769845f6$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $f3a17832769845f6$var$_chevronDown2.default
    }, props));
$f3a17832769845f6$var$ChevronDownIcon.Name = "ChevronDownIconMigration";
var $f3a17832769845f6$var$_default = $f3a17832769845f6$exports.default = $f3a17832769845f6$var$ChevronDownIcon;



var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $acw62 = parcelRequire("acw62");

var $18f800778d25ddd2$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $18f800778d25ddd2$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $13866e744941118f$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $18f800778d25ddd2$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($18f800778d25ddd2$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $acw62.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18f800778d25ddd2$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $18f800778d25ddd2$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var value = (0, $acw62.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18f800778d25ddd2$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $18f800778d25ddd2$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($18f800778d25ddd2$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18f800778d25ddd2$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18f800778d25ddd2$var$LayeringProvider, null, content);
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1a6d0f6494675030$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $8a6218b28833b6e6$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $acw62.useContext)((0, $1a6d0f6494675030$export$5fbf4d7fae6cdc00));
    (0, $acw62.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;




function $af97a1c4b2e6d972$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $98419a3199f36288$export$cbabb21c2529b130));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $7db6b4218872c548$export$4bb192c7cacf928f)(innerRef, node);
        (0, $7db6b4218872c548$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        return function() {
            return (0, $7db6b4218872c548$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $7db6b4218872c548$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $8d893c865d408888$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $8d893c865d408888$export$72f415121273627e = "body > .atlaskit-portal-container";
var $8d893c865d408888$export$13f57c02915787b3 = "atlaskit-portal";


var $7c030ee432617853$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $8d893c865d408888$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $7c030ee432617853$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $7c030ee432617853$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $8d893c865d408888$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $8d893c865d408888$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $7c030ee432617853$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $7c030ee432617853$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $7c030ee432617853$var$getPortalParent().removeChild(container);
};
var $7c030ee432617853$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $7c030ee432617853$var$getPortalParent().appendChild(container);
};
var $7c030ee432617853$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $7c030ee432617853$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($7c030ee432617853$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $8d893c865d408888$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $7c030ee432617853$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($7c030ee432617853$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $8d893c865d408888$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $8d893c865d408888$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $7c030ee432617853$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $3f7528c0c4dac234$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $7c030ee432617853$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $7c030ee432617853$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $7c030ee432617853$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $573e85cac231bb10$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $c992661b5e0a6b9f$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $573e85cac231bb10$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $7c030ee432617853$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $7c030ee432617853$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $ltooA.fg)("platform_design_system_suspend_portal_children") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $bc10bd46da1f083f$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $573e85cac231bb10$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $bc10bd46da1f083f$export$2e2bcd8739ae039 = $bc10bd46da1f083f$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $00dc06cc89c53bef$export$ed5835cc67e87f72 = "akPortalMount";
var $00dc06cc89c53bef$export$80816bd900e5bd00 = "akPortalUnmount";


var $543b5edbd0214ef3$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $543b5edbd0214ef3$var$getLayerName = function getLayerName(zIndex) {
    return $543b5edbd0214ef3$var$zIndexToName.hasOwnProperty(zIndex) ? $543b5edbd0214ef3$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $543b5edbd0214ef3$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $543b5edbd0214ef3$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $543b5edbd0214ef3$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $543b5edbd0214ef3$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $7b2a9fb94748e910$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $543b5edbd0214ef3$export$2e2bcd8739ae039)((0, $00dc06cc89c53bef$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $543b5edbd0214ef3$export$2e2bcd8739ae039)((0, $00dc06cc89c53bef$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $7b2a9fb94748e910$export$2e2bcd8739ae039 = $7b2a9fb94748e910$var$useFirePortalEvent;


function $46ebd1317c97325a$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $bc10bd46da1f083f$export$2e2bcd8739ae039)(mountStrategy);
    (0, $7b2a9fb94748e910$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3f7528c0c4dac234$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c992661b5e0a6b9f$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



/* eslint-disable no-console */ var $28644e79bf4eead2$var$printed = {};
function $28644e79bf4eead2$export$2e2bcd8739ae039(message) {
    if ($28644e79bf4eead2$var$printed[message]) return;
    $28644e79bf4eead2$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $544b446323432e24$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $28644e79bf4eead2$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $544b446323432e24$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $8ab94fd19feed7e1$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $8ab94fd19feed7e1$export$c93026a968943f95 = "light";
var $8ab94fd19feed7e1$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $8ab94fd19feed7e1$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $8ab94fd19feed7e1$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $8ab94fd19feed7e1$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d9e851d147a23683$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8ab94fd19feed7e1$export$6d8204c2cb2e06b8() / 4;
    (0, $544b446323432e24$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $8ab94fd19feed7e1$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $8ab94fd19feed7e1$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $8ab94fd19feed7e1$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $544b446323432e24$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $8ab94fd19feed7e1$export$ba1d834b86d72a09 = $8ab94fd19feed7e1$export$a1b3edb637fb4f35;
var $8ab94fd19feed7e1$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d9e851d147a23683$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d9e851d147a23683$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d9e851d147a23683$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $4d48b2411759270d$var$ESCAPE = "Escape";
function $4d48b2411759270d$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _useLayering = $4d48b2411759270d$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $4d48b2411759270d$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $4d48b2411759270d$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $acw62.useContext)((0, $18f800778d25ddd2$export$650d12d3c2ddb8fc));
    var _useContext = (0, $acw62.useContext)((0, $18f800778d25ddd2$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $ltooA = parcelRequire("ltooA");

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $02Ztr = parcelRequire("02Ztr");
function $21e1d71617765e37$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $99345cce7d1ead6a$var$viewportPadding = 5;
var $99345cce7d1ead6a$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $99345cce7d1ead6a$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $99345cce7d1ead6a$var$defaultChildrenFn() {
    return null;
}
var $99345cce7d1ead6a$var$defaultOffset = [
    0,
    8
];
function $99345cce7d1ead6a$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $99345cce7d1ead6a$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $99345cce7d1ead6a$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $99345cce7d1ead6a$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $21e1d71617765e37$export$6d8c2b45c99d6e3f)({
            viewportPadding: $99345cce7d1ead6a$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($99345cce7d1ead6a$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4fec27400925987$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}






var $acw62 = parcelRequire("acw62");
var $9d25ff91f43eb18a$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $acw62.useRef)(true);
    (0, $acw62.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");



var $ltooA = parcelRequire("ltooA");
var $fdf25c4ccdc3e4a0$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $fdf25c4ccdc3e4a0$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($fdf25c4ccdc3e4a0$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};



var $acw62 = parcelRequire("acw62");
var $4376740dd4c167e1$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $acw62.useRef)([]);
    var requestFrame = (0, $acw62.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $acw62.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $acw62.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $fa88afc967f795ee$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $4d48b2411759270d$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $4376740dd4c167e1$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $acw62.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $13866e744941118f$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $ltooA.fg)("fix-dropdown-close-outside-iframe");
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $ltooA.fg)("sibling-dropdown-close-issue")) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute("data-ds--level");
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $ltooA.fg)("design-system-closed-all-when-click-outside")) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute("[data-ds--close--type]");
                            if (closeType === "single") // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute("data-ds--level");
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $fdf25c4ccdc3e4a0$export$3dee5e4542c672d9)(document.activeElement) && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $8fY35.bind)(window.parent.window, {
            type: "click",
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $8fY35.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $13866e744941118f$export$2e2bcd8739ae039);
        unbindBlur = (0, $8fY35.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $acw62 = parcelRequire("acw62");
var $539e1bc5b4077faf$exports = {};
var $234353d92c14c737$exports = {};
$234353d92c14c737$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $234353d92c14c737$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        "input",
        "select",
        "a[href]",
        "textarea",
        "button",
        "[tabindex]"
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(","));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute("tabindex"), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === "INPUT" && candidate.type === "hidden" || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $234353d92c14c737$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === "none") result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === "hidden";
    };
}


var $539e1bc5b4077faf$var$listeningFocusTrap = null;
function $539e1bc5b4077faf$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === "string" ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $539e1bc5b4077faf$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($539e1bc5b4077faf$var$listeningFocusTrap) $539e1bc5b4077faf$var$listeningFocusTrap.pause();
        $539e1bc5b4077faf$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $539e1bc5b4077faf$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener("focus", checkFocus, true);
        document.addEventListener("click", checkClick, true);
        document.addEventListener("mousedown", checkPointerDown, true);
        document.addEventListener("touchstart", checkPointerDown, true);
        document.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $539e1bc5b4077faf$var$listeningFocusTrap !== trap) return;
        document.removeEventListener("focus", checkFocus, true);
        document.removeEventListener("click", checkClick, true);
        document.removeEventListener("mousedown", checkPointerDown, true);
        document.removeEventListener("touchstart", checkPointerDown, true);
        document.removeEventListener("keydown", checkKey, true);
        $539e1bc5b4077faf$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = document.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === "function") e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === "Tab" || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $539e1bc5b4077faf$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute("tabindex") && Number(e.target.getAttribute("tabindex")) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $539e1bc5b4077faf$var$tryFocus(lastTabbableNode);
            return $539e1bc5b4077faf$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $539e1bc5b4077faf$var$tryFocus(firstTabbableNode);
        $539e1bc5b4077faf$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $234353d92c14c737$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $539e1bc5b4077faf$var$tryFocus(lastTabbableNode);
        $539e1bc5b4077faf$var$tryFocus(firstTabbableNode);
    }
}
function $539e1bc5b4077faf$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $539e1bc5b4077faf$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === "input") node.select();
}
$539e1bc5b4077faf$exports = $539e1bc5b4077faf$var$focusTrap;





var $ltooA = parcelRequire("ltooA");

var $713c78fd0b68925c$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $4376740dd4c167e1$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $4d48b2411759270d$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $acw62.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $13866e744941118f$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
            var isDropdown = popupRef.matches("[id^=ds--dropdown--]");
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                    if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $13866e744941118f$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($539e1bc5b4077faf$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $902fa2eb01c363c7$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $902fa2eb01c363c7$var$fullWidthStyles = (0, $gyDKM.css)({
    width: "100%"
});
var $902fa2eb01c363c7$var$rootStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $8ab94fd19feed7e1$export$7be255094ccdc533).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $d9e851d147a23683$export$29a4f05edc054374), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $d9e851d147a23683$export$7d3359664e8bb0e5), ", 0 0 1px ").concat((0, $d9e851d147a23683$export$d2d3bedfb276cac0)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $119ca37061986fbc$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $d9e851d147a23683$export$29a4f05edc054374), ")")), "&:focus", {
    outline: "none"
}));
var $902fa2eb01c363c7$var$scrollableStyles = (0, $gyDKM.css)({
    overflow: "auto"
});
var $902fa2eb01c363c7$var$blanketStyles = (0, $gyDKM.css)({
    position: "fixed",
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $902fa2eb01c363c7$var$modalStyles = (0, $gyDKM.css)({
    maxHeight: "50vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $902fa2eb01c363c7$var$DefaultPopupComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $902fa2eb01c363c7$var$_excluded);
    return (0, $gyDKM.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $902fa2eb01c363c7$var$rootStyles,
            appearance === "UNSAFE_modal-below-sm" && $902fa2eb01c363c7$var$modalStyles,
            !shouldRenderToParent && $902fa2eb01c363c7$var$scrollableStyles,
            shouldFitContainer && $902fa2eb01c363c7$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $902fa2eb01c363c7$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $902fa2eb01c363c7$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $713c78fd0b68925c$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $fa88afc967f795ee$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $4d48b2411759270d$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $gyDKM.jsx)((0, $99345cce7d1ead6a$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $gyDKM.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === "UNSAFE_modal-below-sm" ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $gyDKM.jsx)((0, $9d25ff91f43eb18a$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $ltooA.fg)("platform-design-system-apply-popup-wrapper-focus") ? (0, $gyDKM.jsx)((0, $acw62.Fragment), null, (0, $gyDKM.jsx)((0, $671ea2626c6c4bdd$export$2e2bcd8739ae039), null, popupContainer), appearance === "UNSAFE_modal-below-sm" && (0, $gyDKM.jsx)("div", {
            css: $902fa2eb01c363c7$var$blanketStyles
        })) : (0, $gyDKM.jsx)((0, $acw62.Fragment), null, popupContainer, appearance === "UNSAFE_modal-below-sm" && (0, $gyDKM.jsx)("div", {
            css: $902fa2eb01c363c7$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902fa2eb01c363c7$export$2e2bcd8739ae039 = $902fa2eb01c363c7$var$PopperWrapper;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $acw62 = parcelRequire("acw62");
var $a0c3bfbf36deae08$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $9a0b979eb3cc0c7e$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $9a0b979eb3cc0c7e$export$c881183ca713c214 = $9a0b979eb3cc0c7e$export$987d49ffe1b0900f;


var $65961207fa042d70$var$_window, $65961207fa042d70$var$_window$matchMedia, $65961207fa042d70$var$_window2, $65961207fa042d70$var$_window2$matchMedia, $65961207fa042d70$var$_window3, $65961207fa042d70$var$_window3$matchMedia, $65961207fa042d70$var$_window4, $65961207fa042d70$var$_window4$matchMedia, $65961207fa042d70$var$_window5, $65961207fa042d70$var$_window5$matchMedia, $65961207fa042d70$var$_window6, $65961207fa042d70$var$_window6$matchMedia, $65961207fa042d70$var$_window7, $65961207fa042d70$var$_window7$matchMedia, $65961207fa042d70$var$_window8, $65961207fa042d70$var$_window8$matchMedia, $65961207fa042d70$var$_window9, $65961207fa042d70$var$_window9$matchMedia, $65961207fa042d70$var$_window10, $65961207fa042d70$var$_window10$matchMedia, $65961207fa042d70$var$_window11, $65961207fa042d70$var$_window11$matchMedia;
var $65961207fa042d70$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window = window) === null || $65961207fa042d70$var$_window === void 0 || ($65961207fa042d70$var$_window$matchMedia = $65961207fa042d70$var$_window.matchMedia) === null || $65961207fa042d70$var$_window$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window$matchMedia.call($65961207fa042d70$var$_window, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window2 = window) === null || $65961207fa042d70$var$_window2 === void 0 || ($65961207fa042d70$var$_window2$matchMedia = $65961207fa042d70$var$_window2.matchMedia) === null || $65961207fa042d70$var$_window2$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window2$matchMedia.call($65961207fa042d70$var$_window2, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window3 = window) === null || $65961207fa042d70$var$_window3 === void 0 || ($65961207fa042d70$var$_window3$matchMedia = $65961207fa042d70$var$_window3.matchMedia) === null || $65961207fa042d70$var$_window3$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window3$matchMedia.call($65961207fa042d70$var$_window3, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window4 = window) === null || $65961207fa042d70$var$_window4 === void 0 || ($65961207fa042d70$var$_window4$matchMedia = $65961207fa042d70$var$_window4.matchMedia) === null || $65961207fa042d70$var$_window4$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window4$matchMedia.call($65961207fa042d70$var$_window4, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window5 = window) === null || $65961207fa042d70$var$_window5 === void 0 || ($65961207fa042d70$var$_window5$matchMedia = $65961207fa042d70$var$_window5.matchMedia) === null || $65961207fa042d70$var$_window5$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window5$matchMedia.call($65961207fa042d70$var$_window5, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window6 = window) === null || $65961207fa042d70$var$_window6 === void 0 || ($65961207fa042d70$var$_window6$matchMedia = $65961207fa042d70$var$_window6.matchMedia) === null || $65961207fa042d70$var$_window6$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window6$matchMedia.call($65961207fa042d70$var$_window6, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window7 = window) === null || $65961207fa042d70$var$_window7 === void 0 || ($65961207fa042d70$var$_window7$matchMedia = $65961207fa042d70$var$_window7.matchMedia) === null || $65961207fa042d70$var$_window7$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window7$matchMedia.call($65961207fa042d70$var$_window7, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window8 = window) === null || $65961207fa042d70$var$_window8 === void 0 || ($65961207fa042d70$var$_window8$matchMedia = $65961207fa042d70$var$_window8.matchMedia) === null || $65961207fa042d70$var$_window8$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window8$matchMedia.call($65961207fa042d70$var$_window8, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window9 = window) === null || $65961207fa042d70$var$_window9 === void 0 || ($65961207fa042d70$var$_window9$matchMedia = $65961207fa042d70$var$_window9.matchMedia) === null || $65961207fa042d70$var$_window9$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window9$matchMedia.call($65961207fa042d70$var$_window9, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window10 = window) === null || $65961207fa042d70$var$_window10 === void 0 || ($65961207fa042d70$var$_window10$matchMedia = $65961207fa042d70$var$_window10.matchMedia) === null || $65961207fa042d70$var$_window10$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window10$matchMedia.call($65961207fa042d70$var$_window10, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($65961207fa042d70$var$_window11 = window) === null || $65961207fa042d70$var$_window11 === void 0 || ($65961207fa042d70$var$_window11$matchMedia = $65961207fa042d70$var$_window11.matchMedia) === null || $65961207fa042d70$var$_window11$matchMedia === void 0 ? void 0 : $65961207fa042d70$var$_window11$matchMedia.call($65961207fa042d70$var$_window11, (0, $9a0b979eb3cc0c7e$export$c881183ca713c214).below.xl.replace("@media ", "").trim())
};
var $65961207fa042d70$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $acw62.useRef)(listener);
    (0, $acw62.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $65961207fa042d70$var$queries[queryString];
    (0, $a0c3bfbf36deae08$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $8fY35.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $6a644959b1ad9641$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $65961207fa042d70$export$49e55ae2c03d6045)("below.sm", function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $acw62.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === "UNSAFE_modal-below-sm" && isSmallViewport ? "UNSAFE_modal-below-sm" : "default";
    var shouldRenderToParent = _shouldRenderToParent && appearance === "default";
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");
var $94b3b68c03ed6e6d$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $acw62.useState)(function() {
        return (0, $jk22o.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");
var $e9e7a81c05870048$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $acw62.useState)(function() {
        return (0, $jk22o.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $26afce04e26fdc24$var$defaultLayer = (0, $8ab94fd19feed7e1$export$7be255094ccdc533).layer();
var $26afce04e26fdc24$var$wrapperStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    position: "relative"
});
var $26afce04e26fdc24$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $26afce04e26fdc24$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $94b3b68c03ed6e6d$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $e9e7a81c05870048$export$5d3a2de79e07b376)();
    var generatedId = (0, $2962c61563225b3f$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $6a644959b1ad9641$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $8a6218b28833b6e6$export$469bb693f11edc7f)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $gyDKM.jsx)((0, $18f800778d25ddd2$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $gyDKM.jsx)((0, $902fa2eb01c363c7$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $gyDKM.jsx)((0, $98419a3199f36288$export$d0d38e7dec7a1a61), null, (0, $gyDKM.jsx)((0, $af97a1c4b2e6d972$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $ltooA.fg)("platform-design-system-popup-ref") ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $gyDKM.jsx)((0, $46ebd1317c97325a$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $gyDKM.jsx)((0, $7442186ddc93bf33$export$2e2bcd8739ae039), {
        xcss: $26afce04e26fdc24$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $26afce04e26fdc24$export$2e2bcd8739ae039 = $26afce04e26fdc24$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8dbb5c8921bb103e$export$2e2bcd8739ae039 = (0, $26afce04e26fdc24$export$129a32eedafa97c5);




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");



var $g5Zhu = parcelRequire("g5Zhu");


var $ltooA = parcelRequire("ltooA");

var $1e875770839961ac$export$8a682ae47622dbb9 = "ds--dropdown--";
function $1e875770839961ac$export$2e2bcd8739ae039() {
    var id = (0, $2962c61563225b3f$export$f680877a34711e37)();
    return "".concat($1e875770839961ac$export$8a682ae47622dbb9).concat(id);
}


var $e89a3d4b09a67768$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $938d4698c2a2d161$export$a80636c6f41931fe), "next"), (0, $938d4698c2a2d161$export$390330c10ff2b9a1), "prev"), (0, $938d4698c2a2d161$export$4af703091671bc), "first"), (0, $938d4698c2a2d161$export$e2bc30913faa5db7), "last");
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $e89a3d4b09a67768$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var element = refs[++currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute("disabled");
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $e89a3d4b09a67768$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var element = refs[--currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute("disabled");
        if (isValid) return element;
    }
};
function $e89a3d4b09a67768$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $1e875770839961ac$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $938d4698c2a2d161$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $938d4698c2a2d161$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $e89a3d4b09a67768$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < currentRefs.length - 1) {
                    var _nextFocusableElement = $e89a3d4b09a67768$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $e89a3d4b09a67768$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $e89a3d4b09a67768$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $e89a3d4b09a67768$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $e89a3d4b09a67768$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $e89a3d4b09a67768$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $2a5ce9a7f1a7a115$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $acw62.createContext)({
    menuItemRefs: [],
    registerRef: (0, $13866e744941118f$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $2a5ce9a7f1a7a115$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $acw62.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $acw62.useRef)("ordered");
    registerMode.current = "ordered";
    var registerRef = (0, $acw62.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case "ordered":
                menuItemRefs.current.push(ref);
                break;
            case "unordered":
                // Reset and force a rerender
                registerMode.current = "regenerate";
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case "regenerate":
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $4d48b2411759270d$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $acw62.useEffect)(function() {
        if (registerMode.current === "ordered") // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = "unordered";
    });
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "keydown",
            listener: (0, $e89a3d4b09a67768$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2a5ce9a7f1a7a115$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $2a5ce9a7f1a7a115$export$2e2bcd8739ae039 = $2a5ce9a7f1a7a115$var$FocusManager;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");
var $10ceba9104050468$export$443076ec7ebce042 = /*#__PURE__*/ (0, $acw62.createContext)("cozy");
var $10ceba9104050468$export$9ca534b70725964d = /*#__PURE__*/ (0, $acw62.createContext)("border");


var $a68d372fdd326497$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $a68d372fdd326497$var$baseStyles = (0, $gyDKM.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a68d372fdd326497$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a68d372fdd326497$var$_excluded);
    return (0, $gyDKM.jsx)((0, $10ceba9104050468$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $gyDKM.jsx)((0, $10ceba9104050468$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $gyDKM.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $a68d372fdd326497$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $a68d372fdd326497$export$2e2bcd8739ae039 = $a68d372fdd326497$var$MenuGroup;




function $31d5d557cb3472e9$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "checkbox" || role === "menuitemcheckbox";
}


function $ab26c5fd873c58e5$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "radio" || role === "menuitemradio";
}



var $2461de2fa4d0c1f8$var$spinnerContainerStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    display: "flex",
    minWidth: "160px",
    padding: "space.250",
    justifyContent: "center"
});
var $2461de2fa4d0c1f8$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? "Loading" : _ref$statusLabel, testId = _ref.testId;
    return (0, $gyDKM.jsx)((0, $7442186ddc93bf33$export$2e2bcd8739ae039), {
        xcss: $2461de2fa4d0c1f8$var$spinnerContainerStyles
    }, (0, $gyDKM.jsx)((0, $c01371b6828f6eb8$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $2461de2fa4d0c1f8$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $acw62.useContext)((0, $2a5ce9a7f1a7a115$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $31d5d557cb3472e9$export$2e2bcd8739ae039)(menuItem) || (0, $ab26c5fd873c58e5$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $acw62.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $acw62.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute("disabled");
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $gyDKM.jsx)((0, $a68d372fdd326497$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $gyDKM.jsx)($2461de2fa4d0c1f8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $2461de2fa4d0c1f8$export$2e2bcd8739ae039 = $2461de2fa4d0c1f8$var$MenuWrapper;



var $acw62 = parcelRequire("acw62");

var $7545b1b49ea28cdd$export$756f795847463ebd = /*#__PURE__*/ (0, $acw62.createContext)({
    setItemState: (0, $13866e744941118f$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $13866e744941118f$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $7545b1b49ea28cdd$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $acw62.useRef)({});
    var context = (0, $acw62.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7545b1b49ea28cdd$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $7545b1b49ea28cdd$export$2e2bcd8739ae039 = $7545b1b49ea28cdd$var$SelectionStore;



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $45f2a567cf2728bc$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $acw62.useContext)((0, $2a5ce9a7f1a7a115$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (hasPopup && (0, $ltooA.fg)("select-avoid-duplicated-registered-ref")) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $45f2a567cf2728bc$export$2e2bcd8739ae039 = $45f2a567cf2728bc$var$useRegisterItemWithFocusManager;



var $f8fc2edc4a47080d$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $f8fc2edc4a47080d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8fc2edc4a47080d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8fc2edc4a47080d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8fc2edc4a47080d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f8fc2edc4a47080d$var$gridSize = (0, $8ab94fd19feed7e1$export$6d8204c2cb2e06b8)();
var $f8fc2edc4a47080d$var$MAX_HEIGHT = "calc(100vh - ".concat($f8fc2edc4a47080d$var$gridSize * 2, "px)");
var $f8fc2edc4a47080d$var$opposites = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    start: "end",
    auto: "auto",
    end: "start"
};
var $f8fc2edc4a47080d$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split("-");
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        "top",
        "bottom"
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        "start",
        "end"
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($f8fc2edc4a47080d$var$opposites[crossAxis]),
            "".concat($f8fc2edc4a47080d$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($f8fc2edc4a47080d$var$opposites[mainAxis]),
            "".concat($f8fc2edc4a47080d$var$opposites[mainAxis], "-").concat($f8fc2edc4a47080d$var$opposites[crossAxis]),
            "auto"
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($f8fc2edc4a47080d$var$opposites[mainAxis]),
        "".concat($f8fc2edc4a47080d$var$opposites[mainAxis], "-start"),
        "".concat($f8fc2edc4a47080d$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $f8fc2edc4a47080d$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $13866e744941118f$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $8ab94fd19feed7e1$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy;
    var _useControlledState = (0, $026ef8766cce8297$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $1e875770839961ac$export$2e2bcd8739ae039)();
    var itemRef = (0, $45f2a567cf2728bc$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $acw62.useMemo)(function() {
        return $f8fc2edc4a47080d$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $acw62.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === "keydown") setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $acw62.useCallback)(function(event, currentLevel) {
        var _event$target, _event$target$closest;
        if (event.key !== "Escape" && event.key !== "Tab" && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $1e875770839961ac$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset["ds-Level"];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if (event.key === "Tab" && event.shiftKey || event.key === "Escape") requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(function() {
            var _triggerRef$current;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $a02acfeb36280694$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $acw62.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $13866e744941118f$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $13866e744941118f$export$2e2bcd8739ae039;
        return (0, $8fY35.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $1e875770839961ac$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $938d4698c2a2d161$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $938d4698c2a2d161$export$e51a3576c045c8d5) || e.key === (0, $938d4698c2a2d161$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $938d4698c2a2d161$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== "fixed" ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7545b1b49ea28cdd$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8dbb5c8921bb103e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2["aria-controls"], ariaExpanded = _ref2["aria-expanded"], ariaHasPopup = _ref2["aria-haspopup"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $f8fc2edc4a47080d$var$_excluded);
            if (typeof _trigger === "function") return _trigger($f8fc2edc4a47080d$var$_objectSpread($f8fc2edc4a47080d$var$_objectSpread($f8fc2edc4a47080d$var$_objectSpread({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $4ce3066cf9760ddb$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fcd5469ea5c6f261$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bindFocus, {
                ref: (0, $4ce3066cf9760ddb$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($f3a17832769845f6$exports))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a5ce9a7f1a7a115$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2461de2fa4d0c1f8$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $f8fc2edc4a47080d$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $f8fc2edc4a47080d$export$2e2bcd8739ae039 = $f8fc2edc4a47080d$var$DropdownMenu;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");
/* eslint-disable no-console */ var $3345409bcb3b6293$var$printed = {};
function $3345409bcb3b6293$export$2e2bcd8739ae039(message) {
    if ($3345409bcb3b6293$var$printed[message]) return;
    $3345409bcb3b6293$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $62fcd341338481ac$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $3345409bcb3b6293$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $62fcd341338481ac$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $5efbbcf7aab5c136$export$2e2bcd8739ae039() {}




var $ltooA = parcelRequire("ltooA");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");



var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $gyDKM = parcelRequire("gyDKM");

var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");
var $076e4e51b3739dc5$export$4ef52930e33717cd = "data-theme";
var $076e4e51b3739dc5$export$a00eac3f8684bcd0 = "data-color-mode";
var $076e4e51b3739dc5$export$2112803007239c61 = "data-contrast-mode";
var $076e4e51b3739dc5$export$352e418ed5b6193a = "data-custom-theme";
var $076e4e51b3739dc5$export$2faeed762aac6741 = "light";
var $076e4e51b3739dc5$export$6f0c6fb8c80fcc92 = "ds";
var $076e4e51b3739dc5$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $076e4e51b3739dc5$export$dddac1532e822863 = "--".concat($076e4e51b3739dc5$export$6f0c6fb8c80fcc92, "-token-not-found");
var $076e4e51b3739dc5$export$9d7b58831ae93caa = "--".concat($076e4e51b3739dc5$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $8bdb494732f29498$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bdb494732f29498$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bdb494732f29498$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bdb494732f29498$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8bdb494732f29498$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $8bdb494732f29498$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $8bdb494732f29498$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $8bdb494732f29498$export$632685d741f3dbbf = $8bdb494732f29498$var$_objectSpread($8bdb494732f29498$var$_objectSpread({}, $8bdb494732f29498$export$958d0ae7f2977ae4), $8bdb494732f29498$export$d2dc61f58390201c);
var $8bdb494732f29498$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $8bdb494732f29498$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $8bdb494732f29498$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $8bdb494732f29498$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $8bdb494732f29498$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $8bdb494732f29498$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $8bdb494732f29498$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $8bdb494732f29498$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $8bdb494732f29498$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $8bdb494732f29498$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $8bdb494732f29498$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $8bdb494732f29498$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $8bdb494732f29498$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $8bdb494732f29498$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $8bdb494732f29498$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $8bdb494732f29498$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $8bdb494732f29498$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $8bdb494732f29498$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $8bdb494732f29498$export$e615f061ca585a6c = $8bdb494732f29498$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8bdb494732f29498$export$ca0f9c2de39ffed7(spacingProperty, $8bdb494732f29498$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8bdb494732f29498$export$bf46c3f9eeafc71f = $8bdb494732f29498$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8bdb494732f29498$export$ca0f9c2de39ffed7(spacingProperty, $8bdb494732f29498$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8bdb494732f29498$export$e7af83bafe7f9e63 = $8bdb494732f29498$export$ca0f9c2de39ffed7("backgroundColor", $8bdb494732f29498$export$d1d79bf68ac056bd);
var $8bdb494732f29498$export$3a1bcba60b23d7f0 = $8bdb494732f29498$export$ca0f9c2de39ffed7("color", $8bdb494732f29498$export$8473307aa00d6ea1);
var $8bdb494732f29498$export$45f3f4fe16f9f7d5 = $8bdb494732f29498$export$ca0f9c2de39ffed7("fontWeight", $8bdb494732f29498$export$303e322c6b1ed114);
var $8bdb494732f29498$export$68cc305da27dbaa4 = $8bdb494732f29498$export$ca0f9c2de39ffed7("fontFamily", $8bdb494732f29498$export$3c7e9587132614b4);
var $8bdb494732f29498$export$128f10c238242f83 = $8bdb494732f29498$export$ca0f9c2de39ffed7("font", $8bdb494732f29498$export$6ffa317d5e70375);
var $8bdb494732f29498$export$219d364c0da35ae4 = $8bdb494732f29498$export$ca0f9c2de39ffed7("font", $8bdb494732f29498$export$236bfe3a33ef1292);
var $8bdb494732f29498$export$38845ca010b93505 = $8bdb494732f29498$export$ca0f9c2de39ffed7("fontWeight", $8bdb494732f29498$export$855cfd311192d666);
var $8bdb494732f29498$export$ff257d957d48c421 = $8bdb494732f29498$export$ca0f9c2de39ffed7((0, $076e4e51b3739dc5$export$9d7b58831ae93caa), $8bdb494732f29498$export$41a358c9c2356760);
var $8bdb494732f29498$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $8bdb494732f29498$export$41a358c9c2356760[color] !== undefined;
};



var $hPtJY = parcelRequire("hPtJY");
function $723af74b676c2dda$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $723af74b676c2dda$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $723af74b676c2dda$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $723af74b676c2dda$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $723af74b676c2dda$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $723af74b676c2dda$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $723af74b676c2dda$export$9a199fbafee0014e = {
    backgroundColor: (0, $8bdb494732f29498$export$d1d79bf68ac056bd),
    blockSize: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderBottomColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderLeftColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $8bdb494732f29498$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    borderWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    bottom: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    boxShadow: (0, $8bdb494732f29498$export$7aff6e7ba39bb774),
    color: (0, $8bdb494732f29498$export$8473307aa00d6ea1),
    columnGap: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    font: (0, $8bdb494732f29498$export$6ffa317d5e70375),
    fontFamily: (0, $8bdb494732f29498$export$3c7e9587132614b4),
    fontWeight: (0, $8bdb494732f29498$export$303e322c6b1ed114),
    gap: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    height: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    inlineSize: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    inset: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    insetBlock: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    insetBlockEnd: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    insetBlockStart: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    insetInline: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    insetInlineEnd: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    insetInlineStart: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    left: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    margin: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginBlock: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginBlockEnd: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginBlockStart: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginBottom: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginInline: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginInlineEnd: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginInlineStart: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginLeft: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginRight: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    marginTop: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    maxBlockSize: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    maxHeight: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    maxWidth: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    minBlockSize: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    minHeight: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    minInlineSize: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    minWidth: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    opacity: (0, $8bdb494732f29498$export$daf94a976c798b4f),
    outlineColor: (0, $8bdb494732f29498$export$1531ad5bb3fbedac),
    outlineOffset: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    outlineWidth: (0, $8bdb494732f29498$export$e1b83c5210c471b8),
    padding: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingBlock: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingBottom: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingInline: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingLeft: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingRight: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    paddingTop: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    right: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    rowGap: (0, $8bdb494732f29498$export$958d0ae7f2977ae4),
    top: (0, $8bdb494732f29498$export$632685d741f3dbbf),
    width: (0, $8bdb494732f29498$export$6ccdbebca2ee545f),
    zIndex: (0, $8bdb494732f29498$export$b5f31a7e431d2eab)
};
var $723af74b676c2dda$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $723af74b676c2dda$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $723af74b676c2dda$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $723af74b676c2dda$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $723af74b676c2dda$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($723af74b676c2dda$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $723af74b676c2dda$var$safeSelectors.test(key)) {
            styleObj[key] = $723af74b676c2dda$var$_transformStyles(value);
            return;
        }
        if ($723af74b676c2dda$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($723af74b676c2dda$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $723af74b676c2dda$export$9a199fbafee0014e)) return;
        var tokenValue = $723af74b676c2dda$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $723af74b676c2dda$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $723af74b676c2dda$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $723af74b676c2dda$var$uniqueSymbol, (0, $gyDKM.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $723af74b676c2dda$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $723af74b676c2dda$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $723af74b676c2dda$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$723af74b676c2dda$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $723af74b676c2dda$export$f6c783d06584602c(style) {
    return $723af74b676c2dda$var$baseXcss(style);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $564f0b5b97e11f4c$var$justifyContentMap = {
    start: (0, $gyDKM.css)({
        justifyContent: "start"
    }),
    center: (0, $gyDKM.css)({
        justifyContent: "center"
    }),
    end: (0, $gyDKM.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $gyDKM.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $gyDKM.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $gyDKM.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $gyDKM.css)({
        justifyContent: "stretch"
    })
};
var $564f0b5b97e11f4c$var$flexDirectionMap = {
    column: (0, $gyDKM.css)({
        flexDirection: "column"
    }),
    row: (0, $gyDKM.css)({
        flexDirection: "row"
    })
};
var $564f0b5b97e11f4c$var$flexWrapMap = {
    wrap: (0, $gyDKM.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $gyDKM.css)({
        flexWrap: "nowrap"
    })
};
var $564f0b5b97e11f4c$var$alignItemsMap = {
    start: (0, $gyDKM.css)({
        alignItems: "start"
    }),
    center: (0, $gyDKM.css)({
        alignItems: "center"
    }),
    baseline: (0, $gyDKM.css)({
        alignItems: "baseline"
    }),
    end: (0, $gyDKM.css)({
        alignItems: "end"
    }),
    stretch: (0, $gyDKM.css)({
        alignItems: "stretch"
    })
};
var $564f0b5b97e11f4c$var$baseStyles = (0, $gyDKM.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $564f0b5b97e11f4c$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $723af74b676c2dda$export$a9c84988c8f81f2d)(xcss);
    return (0, $gyDKM.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $564f0b5b97e11f4c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $8bdb494732f29498$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $8bdb494732f29498$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $8bdb494732f29498$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $564f0b5b97e11f4c$var$alignItemsMap[alignItems],
            direction && $564f0b5b97e11f4c$var$flexDirectionMap[direction],
            justifyContent && $564f0b5b97e11f4c$var$justifyContentMap[justifyContent],
            wrap && $564f0b5b97e11f4c$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$564f0b5b97e11f4c$var$Flex.displayName = "Flex";
var $564f0b5b97e11f4c$export$2e2bcd8739ae039 = $564f0b5b97e11f4c$var$Flex;


var $360250dfd5a32698$var$flexGrowMap = {
    hug: (0, $723af74b676c2dda$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $723af74b676c2dda$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $360250dfd5a32698$var$separatorStyles = (0, $gyDKM.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $360250dfd5a32698$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $gyDKM.jsx)("span", {
        css: $360250dfd5a32698$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $360250dfd5a32698$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $gyDKM.jsx)($360250dfd5a32698$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $gyDKM.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $360250dfd5a32698$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $gyDKM.jsx)((0, $564f0b5b97e11f4c$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$360250dfd5a32698$var$Inline.displayName = "Inline";
var $360250dfd5a32698$export$2e2bcd8739ae039 = $360250dfd5a32698$var$Inline;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $22135e389daff500$var$flexGrowMap = {
    hug: (0, $723af74b676c2dda$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $723af74b676c2dda$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $22135e389daff500$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $22135e389daff500$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $gyDKM.jsx)((0, $564f0b5b97e11f4c$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$22135e389daff500$var$Stack.displayName = "Stack";
var $22135e389daff500$export$2e2bcd8739ae039 = $22135e389daff500$var$Stack;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $60da72fb59ecb244$export$4b84fd0e2c617bd = "#FFEBE6";
var $60da72fb59ecb244$export$b34b069eff244586 = "#FFBDAD";
var $60da72fb59ecb244$export$be802dd0d8b57f35 = "#FF8F73";
var $60da72fb59ecb244$export$60847d42f9da92a6 = "#FF7452";
var $60da72fb59ecb244$export$4a7404f376229999 = "#FF5630";
var $60da72fb59ecb244$export$2010d0fb4295b346 = "#DE350B";
var $60da72fb59ecb244$export$2837b5a1a71d5c02 = "#BF2600";
var $60da72fb59ecb244$export$8d9596b529bbb9cf = "#FFFAE6";
var $60da72fb59ecb244$export$41060a744ab0b7ae = "#FFF0B3";
var $60da72fb59ecb244$export$1cc05bbbf340e559 = "#FFE380";
var $60da72fb59ecb244$export$5aae31392d72caaa = "#FFC400";
var $60da72fb59ecb244$export$c6930421db9fa514 = "#FFAB00";
var $60da72fb59ecb244$export$59619663aa6500fb = "#FF991F";
var $60da72fb59ecb244$export$874739ea9e379ab6 = "#FF8B00";
var $60da72fb59ecb244$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $60da72fb59ecb244$export$69a3bf21b9686c2b = "#ABF5D1";
var $60da72fb59ecb244$export$afbce1382ec95f73 = "#79F2C0";
var $60da72fb59ecb244$export$747d86715d4175de = "#57D9A3";
var $60da72fb59ecb244$export$940e1f69e873f202 = "#36B37E";
var $60da72fb59ecb244$export$a49394138f7b8e85 = "#00875A";
var $60da72fb59ecb244$export$6fa04827ac68a4fb = "#006644";
var $60da72fb59ecb244$export$226de0355ed012f8 = "#DEEBFF";
var $60da72fb59ecb244$export$8c13c2ee36917869 = "#B3D4FF";
var $60da72fb59ecb244$export$ecfc1dff386a3e7a = "#4C9AFF";
var $60da72fb59ecb244$export$215b7063051591f1 = "#2684FF";
var $60da72fb59ecb244$export$e62e8919cca44969 = "#0065FF";
var $60da72fb59ecb244$export$b3de0ae08da2ce64 = "#0052CC";
var $60da72fb59ecb244$export$a6ee3d71bc067634 = "#0747A6";
var $60da72fb59ecb244$export$67f15409e87642a1 = "#669DF1";
var $60da72fb59ecb244$export$f0539dbc42dbb067 = "#8FB8F6";
var $60da72fb59ecb244$export$363e4475840015bb = "#EAE6FF";
var $60da72fb59ecb244$export$4b0a4417ed59760f = "#C0B6F2";
var $60da72fb59ecb244$export$6011520a64d9a187 = "#998DD9";
var $60da72fb59ecb244$export$a7175d4e9206bc80 = "#8777D9";
var $60da72fb59ecb244$export$b48405b95304b5a1 = "#6554C0";
var $60da72fb59ecb244$export$c71e4279dd54a18d = "#5243AA";
var $60da72fb59ecb244$export$147899de772240ec = "#403294";
var $60da72fb59ecb244$export$2cf711fe14c66f06 = "#E6FCFF";
var $60da72fb59ecb244$export$7a8f4d33f6f9772c = "#B3F5FF";
var $60da72fb59ecb244$export$776c9c497ef08533 = "#79E2F2";
var $60da72fb59ecb244$export$69cb3ca10c1e330e = "#00C7E6";
var $60da72fb59ecb244$export$9dc1ef0f3f48059b = "#00B8D9";
var $60da72fb59ecb244$export$7c835c78b6fcdef8 = "#00A3BF";
var $60da72fb59ecb244$export$6036577f95c3877e = "#008DA6";
var $60da72fb59ecb244$export$29a4f05edc054374 = "#FFFFFF";
var $60da72fb59ecb244$export$e655ef011c4aa1a2 = "#FAFBFC";
var $60da72fb59ecb244$export$9fdfb749e33cdf97 = "#F4F5F7";
var $60da72fb59ecb244$export$3e51e8f1440314ba = "#EBECF0";
var $60da72fb59ecb244$export$1ce2d1575d444ceb = "#DFE1E6";
var $60da72fb59ecb244$export$8754fc7e6d8b3000 = "#C1C7D0";
var $60da72fb59ecb244$export$c2e91cbeada39b8b = "#B3BAC5";
var $60da72fb59ecb244$export$5f71e19f3a7ad9de = "#A5ADBA";
var $60da72fb59ecb244$export$eaa8c8a70ac22806 = "#97A0AF";
var $60da72fb59ecb244$export$7c87d337fb91a97d = "#8993A4";
var $60da72fb59ecb244$export$d6447c357493214f = "#7A869A";
var $60da72fb59ecb244$export$f563ee71e9ee74cd = "#6B778C";
var $60da72fb59ecb244$export$e2ef2124cf4024b1 = "#5E6C84";
var $60da72fb59ecb244$export$eece5f492e429f08 = "#505F79";
var $60da72fb59ecb244$export$c39c0fe0f26207ae = "#42526E";
var $60da72fb59ecb244$export$7090862dc3038a9f = "#344563";
var $60da72fb59ecb244$export$ad0bacf983b7ddaa = "#253858";
var $60da72fb59ecb244$export$7d61b15e0da132af = "#172B4D";
var $60da72fb59ecb244$export$fbda843f0a27fe96 = "#091E42";
var $60da72fb59ecb244$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $60da72fb59ecb244$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $60da72fb59ecb244$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $60da72fb59ecb244$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $60da72fb59ecb244$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $60da72fb59ecb244$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $60da72fb59ecb244$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $60da72fb59ecb244$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $60da72fb59ecb244$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $60da72fb59ecb244$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $60da72fb59ecb244$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $60da72fb59ecb244$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $60da72fb59ecb244$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $60da72fb59ecb244$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $60da72fb59ecb244$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $60da72fb59ecb244$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $60da72fb59ecb244$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $60da72fb59ecb244$export$2f6319cf7d736c2a = "#E6EDFA";
var $60da72fb59ecb244$export$95126bc8884d6634 = "#DCE5F5";
var $60da72fb59ecb244$export$8338d8c35d44ff1 = "#CED9EB";
var $60da72fb59ecb244$export$5368d76ae4fbbda7 = "#B8C7E0";
var $60da72fb59ecb244$export$9f0a771d16ec8d36 = "#ABBBD6";
var $60da72fb59ecb244$export$abcf8c38338b4aa5 = "#9FB0CC";
var $60da72fb59ecb244$export$97e81faa16a182c7 = "#8C9CB8";
var $60da72fb59ecb244$export$bfe21c59123ecf33 = "#7988A3";
var $60da72fb59ecb244$export$ee82aa2ea6a1558 = "#67758F";
var $60da72fb59ecb244$export$682927c6ed76be02 = "#56637A";
var $60da72fb59ecb244$export$91fd9994c5be9757 = "#455166";
var $60da72fb59ecb244$export$d281fbfe3cff2df6 = "#3B475C";
var $60da72fb59ecb244$export$3902c91d8b98a753 = "#313D52";
var $60da72fb59ecb244$export$8e8133c1ba5845b5 = "#283447";
var $60da72fb59ecb244$export$33ff357f6620b39 = "#202B3D";
var $60da72fb59ecb244$export$633847cf062b69e0 = "#1B2638";
var $60da72fb59ecb244$export$9776a6e503bdbf76 = "#121A29";
var $60da72fb59ecb244$export$6c813d5160dff5db = "#0E1624";
var $60da72fb59ecb244$export$3d4f271a500072a = "#0D1424";
var $60da72fb59ecb244$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $60da72fb59ecb244$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $60da72fb59ecb244$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $60da72fb59ecb244$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $60da72fb59ecb244$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $60da72fb59ecb244$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $60da72fb59ecb244$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $60da72fb59ecb244$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $60da72fb59ecb244$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $60da72fb59ecb244$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $60da72fb59ecb244$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $60da72fb59ecb244$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $60da72fb59ecb244$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $60da72fb59ecb244$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $60da72fb59ecb244$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $60da72fb59ecb244$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $60da72fb59ecb244$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $60da72fb59ecb244$export$d2adc5dedf09fced = "#292A2E";
var $60da72fb59ecb244$export$f51762073d2bb381 = "#94C748";
var $60da72fb59ecb244$export$95e26d54def96891 = "#B3DF72";



var $d7051277e18cfb1e$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $gyDKM.jsx)(Component, props));
};
var $d7051277e18cfb1e$var$beforeAfterElementStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $d7051277e18cfb1e$var$contentStyles = (0, $723af74b676c2dda$export$f6c783d06584602c)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $d7051277e18cfb1e$var$truncateStyles = (0, $gyDKM.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $d7051277e18cfb1e$var$titleStyles = (0, $gyDKM.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $d7051277e18cfb1e$var$wordBreakStyles = (0, $gyDKM.css)({
    wordBreak: "break-word"
});
var $d7051277e18cfb1e$var$descriptionStyles = (0, $gyDKM.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $60da72fb59ecb244$export$f563ee71e9ee74cd), ")"),
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $d7051277e18cfb1e$var$disabledDescriptionStyles = (0, $gyDKM.css)({
    color: "var(--ds-text-disabled, ".concat((0, $60da72fb59ecb244$export$f563ee71e9ee74cd), ")")
});
var $d7051277e18cfb1e$var$positionRelativeStyles = (0, $gyDKM.css)({
    position: "relative"
});
var $d7051277e18cfb1e$var$primitiveStyles = (0, $gyDKM.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $d7051277e18cfb1e$var$spacingMapStyles = {
    cozy: (0, $gyDKM.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $gyDKM.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $d7051277e18cfb1e$var$interactiveStyles = (0, $gyDKM.css)({
    cursor: "pointer"
});
var $d7051277e18cfb1e$var$unselectedStyles = (0, $gyDKM.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $60da72fb59ecb244$export$9fdfb749e33cdf97), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $60da72fb59ecb244$export$3e51e8f1440314ba), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $d7051277e18cfb1e$var$disabledStyles = (0, $gyDKM.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $60da72fb59ecb244$export$f563ee71e9ee74cd), ")")
    }
});
var $d7051277e18cfb1e$var$selectedBorderStyles = (0, $gyDKM.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $d7051277e18cfb1e$var$selectedNotchStyles = (0, $gyDKM.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $d7051277e18cfb1e$var$selectedStyles = (0, $gyDKM.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $60da72fb59ecb244$export$9fdfb749e33cdf97), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $60da72fb59ecb244$export$9fdfb749e33cdf97), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $60da72fb59ecb244$export$3e51e8f1440314ba), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $d7051277e18cfb1e$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $d7051277e18cfb1e$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $62fcd341338481ac$export$eb1decd851a5ae56)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $acw62.useContext)((0, $10ceba9104050468$export$443076ec7ebce042));
    var selectionStyle = (0, $acw62.useContext)((0, $10ceba9104050468$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $d7051277e18cfb1e$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $gyDKM.jsx)((0, $gyDKM.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $gyDKM.jsx)((0, $671ea2626c6c4bdd$export$2e2bcd8739ae039), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $d7051277e18cfb1e$var$positionRelativeStyles,
                    $d7051277e18cfb1e$var$primitiveStyles,
                    $d7051277e18cfb1e$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $d7051277e18cfb1e$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $d7051277e18cfb1e$var$selectedStyles,
                        [
                            selectionStyle === "border" && $d7051277e18cfb1e$var$selectedBorderStyles,
                            selectionStyle === "notch" && $d7051277e18cfb1e$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $d7051277e18cfb1e$var$disabledStyles : $d7051277e18cfb1e$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $gyDKM.jsx)((0, $360250dfd5a32698$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $d7051277e18cfb1e$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $gyDKM.jsx)("span", {
                "data-item-elem-before": true,
                css: $d7051277e18cfb1e$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $gyDKM.jsx)((0, $22135e389daff500$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: $d7051277e18cfb1e$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn($d7051277e18cfb1e$var$titleStyles, shouldTitleWrap ? $d7051277e18cfb1e$var$wordBreakStyles : $d7051277e18cfb1e$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $gyDKM.jsx)("span", {
                "data-item-description": true,
                css: [
                    $d7051277e18cfb1e$var$descriptionStyles,
                    isDisabled && $d7051277e18cfb1e$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $d7051277e18cfb1e$var$wordBreakStyles : $d7051277e18cfb1e$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $gyDKM.jsx)("span", {
                "data-item-elem-after": true,
                css: $d7051277e18cfb1e$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $d7051277e18cfb1e$export$2e2bcd8739ae039 = $d7051277e18cfb1e$var$MenuItemPrimitive;


var $3b41921b362b1352$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3b41921b362b1352$var$ButtonItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $3b41921b362b1352$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $acw62.useContext)((0, $807d5a51f7285bd1$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $62fcd341338481ac$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $gyDKM.jsx)((0, $d7051277e18cfb1e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $gyDKM.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $3b41921b362b1352$export$2e2bcd8739ae039 = $3b41921b362b1352$var$ButtonItem;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");




var $ltooA = parcelRequire("ltooA");

var $a59e235c4e1ca920$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $a59e235c4e1ca920$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a59e235c4e1ca920$var$CustomItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a59e235c4e1ca920$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $acw62.useContext)((0, $807d5a51f7285bd1$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $62fcd341338481ac$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $gyDKM.jsx)((0, $d7051277e18cfb1e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $gyDKM.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $a59e235c4e1ca920$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $a59e235c4e1ca920$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $a59e235c4e1ca920$var$preventEvent : (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $a59e235c4e1ca920$export$2e2bcd8739ae039 = $a59e235c4e1ca920$var$CustomItem;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $3d6656aef41d25cc$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $acw62.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $3d6656aef41d25cc$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d6656aef41d25cc$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $3d6656aef41d25cc$export$2e2bcd8739ae039 = $3d6656aef41d25cc$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $2bfdc1bb38498637$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $acw62.useContext)((0, $3d6656aef41d25cc$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $2bfdc1bb38498637$export$2e2bcd8739ae039 = $2bfdc1bb38498637$var$useRouterLink;






var $ltooA = parcelRequire("ltooA");

var $62b3ff646a651a76$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $62b3ff646a651a76$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $62b3ff646a651a76$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $62b3ff646a651a76$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $62b3ff646a651a76$var$LinkItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $62b3ff646a651a76$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $2bfdc1bb38498637$export$2e2bcd8739ae039)();
    var interactionContext = (0, $acw62.useContext)((0, $807d5a51f7285bd1$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === "string" && $62b3ff646a651a76$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $62b3ff646a651a76$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : "a";
    (0, $62fcd341338481ac$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $gyDKM.jsx)((0, $d7051277e18cfb1e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $62b3ff646a651a76$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $62b3ff646a651a76$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $62b3ff646a651a76$var$preventEvent : (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $62b3ff646a651a76$export$2e2bcd8739ae039 = $62b3ff646a651a76$var$LinkItem;



var $ltooA = parcelRequire("ltooA");

var $0c583eef1017b111$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $0c583eef1017b111$var$DropdownMenuItem = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $0c583eef1017b111$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $45f2a567cf2728bc$export$2e2bcd8739ae039)(!!rest["aria-haspopup"]);
    var handleItemClick = (0, $acw62.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a59e235c4e1ca920$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $4ce3066cf9760ddb$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $62b3ff646a651a76$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $4ce3066cf9760ddb$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3b41921b362b1352$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $4ce3066cf9760ddb$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
});
var $0c583eef1017b111$export$2e2bcd8739ae039 = $0c583eef1017b111$var$DropdownMenuItem;


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");




var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $lAEgw = parcelRequire("lAEgw");

var $jyxdk = parcelRequire("jyxdk");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5fe530dcfdd72d73$var$svgStyles = (0, $gyDKM.css)((0, $jyxdk.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $5fe530dcfdd72d73$var$SVG = /*#__PURE__*/ (0, $acw62.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $gyDKM.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $lAEgw.getBackground)()
        },
        css: [
            $5fe530dcfdd72d73$var$svgStyles,
            (0, $jyxdk.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $5fe530dcfdd72d73$export$2e2bcd8739ae039 = $5fe530dcfdd72d73$var$SVG;



var $ltooA = parcelRequire("ltooA");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ var $6c1740f62a79b126$var$CheckboxIcon = function CheckboxIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe530dcfdd72d73$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d9e851d147a23683$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $d9e851d147a23683$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d9e851d147a23683$export$e655ef011c4aa1a2), ")") : "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons") && (0, $ltooA.fg)("platform-icon-control-migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d9e851d147a23683$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d9e851d147a23683$export$d6447c357493214f), ")"),
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d9e851d147a23683$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d9e851d147a23683$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    }))));
};
var $6c1740f62a79b126$export$2e2bcd8739ae039 = $6c1740f62a79b126$var$CheckboxIcon;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $c4d65fcf471c5c6c$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $acw62.createContext)("");



/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ var $d7f9b2ddea68ed49$var$useCheckboxState = function useCheckboxState(_ref) {
    var isSelected = _ref.isSelected, id = _ref.id, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $acw62.useContext)((0, $7545b1b49ea28cdd$export$756f795847463ebd)), setItemState = _useContext.setItemState, getItemState = _useContext.getItemState;
    var groupId = (0, $acw62.useContext)((0, $c4d65fcf471c5c6c$export$baf37c4be89255b8));
    var persistedIsSelected = getItemState(groupId, id);
    var _useState = (0, $acw62.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $acw62.useCallback)(function(newValue) {
        var nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === "boolean") return [
        isSelected,
        function() {
            return false;
        }
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $d7f9b2ddea68ed49$export$2e2bcd8739ae039 = $d7f9b2ddea68ed49$var$useCheckboxState;




var $hPtJY = parcelRequire("hPtJY");
var $76e82533643f974a$var$_excluded = [
    "children",
    "defaultSelected",
    "description",
    "id",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "testId",
    "interactionName"
];
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ var $76e82533643f974a$var$DropdownItemCheckbox = function DropdownItemCheckbox(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, description = _ref.description, id = _ref.id, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $13866e744941118f$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, testId = _ref.testId, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $76e82533643f974a$var$_excluded);
    typeof $hPtJY;
    var _useCheckboxState = (0, $d7f9b2ddea68ed49$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useCheckboxState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useCheckboxState, 2), selected = _useCheckboxState2[0], setSelected = _useCheckboxState2[1];
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $45f2a567cf2728bc$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $10ceba9104050468$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3b41921b362b1352$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6c1740f62a79b126$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children));
};
var $76e82533643f974a$export$2e2bcd8739ae039 = $76e82533643f974a$var$DropdownItemCheckbox;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");



var $2d76dfddba486551$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $2d76dfddba486551$var$headingStyles = (0, $gyDKM.css)({
    color: "var(--ds-text-subtle, ".concat((0, $60da72fb59ecb244$export$e2ef2124cf4024b1), ")"),
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2d76dfddba486551$var$HeadingItem = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $2d76dfddba486551$var$_excluded);
    (0, $62fcd341338481ac$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $5efbbcf7aab5c136$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $gyDKM.css)(cssFn(undefined));
    return (0, $gyDKM.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        css: [
            $2d76dfddba486551$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $2d76dfddba486551$export$2e2bcd8739ae039 = $2d76dfddba486551$var$HeadingItem;


var $3c1bdcdd1a04c4f1$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $3c1bdcdd1a04c4f1$var$gridSize = 8;
var $3c1bdcdd1a04c4f1$var$itemHeadingTopMargin = $3c1bdcdd1a04c4f1$var$gridSize * 2.5;
var $3c1bdcdd1a04c4f1$var$itemHeadingBottomMargin = $3c1bdcdd1a04c4f1$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $3c1bdcdd1a04c4f1$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $3c1bdcdd1a04c4f1$var$skeletonHeadingHeight = $3c1bdcdd1a04c4f1$var$gridSize;
var $3c1bdcdd1a04c4f1$var$skeletonHeadingMarginOffset = 3;
var $3c1bdcdd1a04c4f1$var$skeletonHeadingTopMargin = $3c1bdcdd1a04c4f1$var$itemHeadingTopMargin + ($3c1bdcdd1a04c4f1$var$itemHeadingContentHeight - $3c1bdcdd1a04c4f1$var$skeletonHeadingHeight) - $3c1bdcdd1a04c4f1$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $3c1bdcdd1a04c4f1$var$skeletonHeadingBottomMargin = $3c1bdcdd1a04c4f1$var$itemHeadingBottomMargin + $3c1bdcdd1a04c4f1$var$skeletonHeadingMarginOffset;
var $3c1bdcdd1a04c4f1$var$sectionPaddingTopBottom = $3c1bdcdd1a04c4f1$var$gridSize * 0.75;
var $3c1bdcdd1a04c4f1$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $3c1bdcdd1a04c4f1$var$sectionStyles = (0, $gyDKM.css)({
    "&::before, &::after": {
        display: "block",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $3c1bdcdd1a04c4f1$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $3c1bdcdd1a04c4f1$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $3c1bdcdd1a04c4f1$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $3c1bdcdd1a04c4f1$var$itemHeadingTopMargin - $3c1bdcdd1a04c4f1$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--skeleton-heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $3c1bdcdd1a04c4f1$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $3c1bdcdd1a04c4f1$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $3c1bdcdd1a04c4f1$var$skeletonHeadingTopMargin - $3c1bdcdd1a04c4f1$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $3c1bdcdd1a04c4f1$var$scrollableStyles = (0, $gyDKM.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $3c1bdcdd1a04c4f1$var$unscrollableStyles = (0, $gyDKM.css)({
    flexShrink: 0
});
var $3c1bdcdd1a04c4f1$var$thinSeparatorStyles = (0, $gyDKM.css)({
    borderBlockStart: "1px solid var(".concat($3c1bdcdd1a04c4f1$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $60da72fb59ecb244$export$920c0d5c49070351), ")"), ")")
});
var $3c1bdcdd1a04c4f1$var$noSeparatorStyles = (0, $gyDKM.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3c1bdcdd1a04c4f1$var$Section = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3c1bdcdd1a04c4f1$var$_excluded);
    (0, $62fcd341338481ac$export$eb1decd851a5ae56)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $gyDKM.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $acw62.Children).map((0, $acw62.Children).toArray(children), function(child, index) {
        return (0, $gyDKM.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $gyDKM.jsx)((0, $acw62.Fragment), null, (0, $gyDKM.jsx)((0, $2d76dfddba486551$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $gyDKM.jsx)((0, $acw62.Fragment), null, content);
    return (0, $gyDKM.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $3c1bdcdd1a04c4f1$var$sectionStyles,
            isScrollable ? $3c1bdcdd1a04c4f1$var$scrollableStyles : $3c1bdcdd1a04c4f1$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $3c1bdcdd1a04c4f1$var$thinSeparatorStyles : $3c1bdcdd1a04c4f1$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $3c1bdcdd1a04c4f1$export$2e2bcd8739ae039 = $3c1bdcdd1a04c4f1$var$Section;



var $acw62 = parcelRequire("acw62");

var $13c1cf7005bceba0$var$headingStyles = (0, $bb4355498b94e8a3$export$f6c783d06584602c)({
    color: "color.text.subtle",
    font: "font.heading.xxsmall",
    paddingBlock: "space.0",
    paddingInline: "space.200"
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $13c1cf7005bceba0$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7442186ddc93bf33$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $13c1cf7005bceba0$var$headingStyles
    }, title);
};
var $13c1cf7005bceba0$export$2e2bcd8739ae039 = $13c1cf7005bceba0$var$GroupTitle;



var $5b0027deb0fdc84f$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ var $5b0027deb0fdc84f$var$DropdownItemCheckboxGroup = function DropdownItemCheckboxGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $5b0027deb0fdc84f$var$_excluded);
    var uid = (0, $2962c61563225b3f$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-checkbox-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4d65fcf471c5c6c$export$baf37c4be89255b8).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c1bdcdd1a04c4f1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13c1cf7005bceba0$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $5b0027deb0fdc84f$export$2e2bcd8739ae039 = $5b0027deb0fdc84f$var$DropdownItemCheckboxGroup;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $b665697b0860b75b$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $b665697b0860b75b$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b665697b0860b75b$var$_excluded);
    var uid = (0, $2962c61563225b3f$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c1bdcdd1a04c4f1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13c1cf7005bceba0$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $b665697b0860b75b$export$2e2bcd8739ae039 = $b665697b0860b75b$var$DropdownMenuItemGroup;


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");




var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $f318bbf65595f29b$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe530dcfdd72d73$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d9e851d147a23683$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $d9e851d147a23683$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d9e851d147a23683$export$e655ef011c4aa1a2), ")") : "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons") && (0, $ltooA.fg)("platform-icon-control-migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d9e851d147a23683$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d9e851d147a23683$export$d6447c357493214f), ")"),
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d9e851d147a23683$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d9e851d147a23683$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    }))));
};
var $f318bbf65595f29b$export$2e2bcd8739ae039 = $f318bbf65595f29b$var$RadioIcon;



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");






var $g5Zhu = parcelRequire("g5Zhu");
function $ca10a6557ea97ea2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca10a6557ea97ea2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca10a6557ea97ea2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca10a6557ea97ea2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ca10a6557ea97ea2$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $ca10a6557ea97ea2$var$_objectSpread($ca10a6557ea97ea2$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, current, typeof group[current] === "undefined" ? undefined : false));
    }, {});
};
var $ca10a6557ea97ea2$export$2e2bcd8739ae039 = $ca10a6557ea97ea2$var$resetOptionsInGroup;


var $99f88b04cadef7b0$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $99f88b04cadef7b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99f88b04cadef7b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99f88b04cadef7b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99f88b04cadef7b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $99f88b04cadef7b0$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $acw62.createContext)({
    id: "",
    radioGroupState: {},
    selectRadioItem: (0, $13866e744941118f$export$2e2bcd8739ae039)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $99f88b04cadef7b0$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $99f88b04cadef7b0$var$_excluded);
    var _useContext = (0, $acw62.useContext)((0, $7545b1b49ea28cdd$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var uid = (0, $2962c61563225b3f$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-radio-group-title-".concat(uid);
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $acw62.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $99f88b04cadef7b0$var$_objectSpread($99f88b04cadef7b0$var$_objectSpread({}, (0, $ca10a6557ea97ea2$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99f88b04cadef7b0$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c1bdcdd1a04c4f1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13c1cf7005bceba0$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $99f88b04cadef7b0$export$2e2bcd8739ae039 = $99f88b04cadef7b0$var$DropdownItemRadioGroup;




function $f4ec425a83b0ce98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4ec425a83b0ce98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4ec425a83b0ce98$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4ec425a83b0ce98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f4ec425a83b0ce98$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $acw62.useContext)((0, $7545b1b49ea28cdd$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $acw62.useContext)((0, $99f88b04cadef7b0$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $acw62.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $acw62.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $acw62.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === "boolean") return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $f4ec425a83b0ce98$var$_objectSpread($f4ec425a83b0ce98$var$_objectSpread({}, (0, $ca10a6557ea97ea2$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $f4ec425a83b0ce98$export$2e2bcd8739ae039 = $f4ec425a83b0ce98$var$useRadioState;



var $d6e7a0389d96b181$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $d6e7a0389d96b181$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($d6e7a0389d96b181$var$canUseDOM() ? navigator.userAgent : "");
};
var $d6e7a0389d96b181$export$2e2bcd8739ae039 = $d6e7a0389d96b181$var$isVoiceOverSupported;



var $hPtJY = parcelRequire("hPtJY");
var $a1a9cbefdfbb6c8d$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "interactionName"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $a1a9cbefdfbb6c8d$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $13866e744941118f$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a1a9cbefdfbb6c8d$var$_excluded);
    typeof $hPtJY;
    var _useRadioState = (0, $f4ec425a83b0ce98$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $45f2a567cf2728bc$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $10ceba9104050468$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3b41921b362b1352$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f318bbf65595f29b$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $d6e7a0389d96b181$export$2e2bcd8739ae039)() ? "radio" : "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children));
};
var $a1a9cbefdfbb6c8d$export$2e2bcd8739ae039 = $a1a9cbefdfbb6c8d$var$DropdownItemRadio;




var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
//      
var $7f17f1906b9f3211$var$charCodeOfDot = ".".charCodeAt(0);
var $7f17f1906b9f3211$var$reEscapeChar = /\\(\\)?/g;
var $7f17f1906b9f3211$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7f17f1906b9f3211$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $7f17f1906b9f3211$var$charCodeOfDot) result.push("");
    string.replace($7f17f1906b9f3211$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($7f17f1906b9f3211$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $7f17f1906b9f3211$var$keysCache = {};
var $7f17f1906b9f3211$var$keysRegex = /[.[\]]+/;
var $7f17f1906b9f3211$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($7f17f1906b9f3211$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $7f17f1906b9f3211$var$keysCache[key] = key.split($7f17f1906b9f3211$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $7f17f1906b9f3211$var$keysCache[key] = $7f17f1906b9f3211$var$stringToPath(key);
    }
    return $7f17f1906b9f3211$var$keysCache[key];
};
//      
var $7f17f1906b9f3211$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $7f17f1906b9f3211$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $7f17f1906b9f3211$var$_toPropertyKey(arg) {
    var key = $7f17f1906b9f3211$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7f17f1906b9f3211$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7f17f1906b9f3211$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1En50.default)(current, [
                key
            ].map($7f17f1906b9f3211$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $8nd05.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $7f17f1906b9f3211$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $7f17f1906b9f3211$var$setInRecursor(state, 0, $7f17f1906b9f3211$var$toPath(key), value1, destroyArrays);
};
var $7f17f1906b9f3211$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $7f17f1906b9f3211$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $7f17f1906b9f3211$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(values, name);
    var error = $7f17f1906b9f3211$export$c52e5867d5879e24(errors, name);
    if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) error = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
    var submitError = submitErrors && $7f17f1906b9f3211$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $7f17f1906b9f3211$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $7f17f1906b9f3211$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $7f17f1906b9f3211$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $7f17f1906b9f3211$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$7f17f1906b9f3211$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $7f17f1906b9f3211$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $7f17f1906b9f3211$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$41e855cb628c1b55, $7f17f1906b9f3211$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $7f17f1906b9f3211$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $7f17f1906b9f3211$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3, $7f17f1906b9f3211$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $7f17f1906b9f3211$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$7f17f1906b9f3211$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $7f17f1906b9f3211$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $7f17f1906b9f3211$export$83d89fbfd8236492 = "4.20.10";
var $7f17f1906b9f3211$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $7f17f1906b9f3211$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $7f17f1906b9f3211$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $7f17f1906b9f3211$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $7f17f1906b9f3211$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $7f17f1906b9f3211$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $7f17f1906b9f3211$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $7f17f1906b9f3211$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $8nd05.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $8nd05.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $8nd05.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $8nd05.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $8nd05.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $7f17f1906b9f3211$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $7f17f1906b9f3211$export$e6bdf135a54e021b,
                    shallowEqual: $7f17f1906b9f3211$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $8nd05.default)({}, state.formState.values)); // clone to avoid writing
            if ($7f17f1906b9f3211$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $7f17f1906b9f3211$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $7f17f1906b9f3211$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $8nd05.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $8nd05.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $7f17f1906b9f3211$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) {
                    var existing = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$7f17f1906b9f3211$export$735bebc8ffabf28a] = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
                    merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$7f17f1906b9f3211$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $8nd05.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $7f17f1906b9f3211$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $7f17f1906b9f3211$var$notify(fieldSubscriber, fieldState, lastFieldState, $7f17f1906b9f3211$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $7f17f1906b9f3211$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $8nd05.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$7f17f1906b9f3211$var$hasAnyError(formState.errors) && !(formState.submitErrors && $7f17f1906b9f3211$var$hasAnyError(formState.submitErrors));
        var nextFormState = $7f17f1906b9f3211$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $7f17f1906b9f3211$var$notify(state.subscribers, nextFormState, lastFormState, $7f17f1906b9f3211$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $8nd05.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $8nd05.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $8nd05.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $7f17f1906b9f3211$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $7f17f1906b9f3211$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $8nd05.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $8nd05.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $8nd05.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $7f17f1906b9f3211$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $8nd05.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $7f17f1906b9f3211$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $7f17f1906b9f3211$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $7f17f1906b9f3211$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $7f17f1906b9f3211$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}



//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $485f8543f71f3f87$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === "function");
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $485f8543f71f3f87$var$getAllInputs = function getAllInputs() {
    if (typeof document === "undefined") return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($485f8543f71f3f87$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $485f8543f71f3f87$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(errors, input.name);
    });
};
//      
var $485f8543f71f3f87$var$noop = function noop() {};
var $485f8543f71f3f87$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $485f8543f71f3f87$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $485f8543f71f3f87$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === "function") // async
            result.then(afterSubmit, $485f8543f71f3f87$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $485f8543f71f3f87$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === "undefined") return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($485f8543f71f3f87$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$485f8543f71f3f87$export$2e2bcd8739ae039 = $485f8543f71f3f87$var$createDecorator;


var $616ab74e95c8680a$exports = {};
var $aba0e6d66e8d80dd$exports = {};
var $3da413f0b86c10df$exports = {};
var $96b401257ea00d24$exports = {};
var $31e24313ace94404$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};
var $180b2bc3c0deaf6c$exports = {};
var $f84e62f9db5b9ccd$exports = {};
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$f84e62f9db5b9ccd$exports = $f84e62f9db5b9ccd$var$freeGlobal;


/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $f84e62f9db5b9ccd$exports || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
$180b2bc3c0deaf6c$exports = $180b2bc3c0deaf6c$var$root;


/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $180b2bc3c0deaf6c$exports.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $180b2bc3c0deaf6c$exports["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;


var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $50557587dab070a0$exports(objValue, value)) || value === undefined && !(key in object)) $96b401257ea00d24$exports(object, key, value);
}
$3da413f0b86c10df$exports = $3da413f0b86c10df$var$assignValue;


var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};

var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};

/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, "create");
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($180b2bc3c0deaf6c$exports, "Map");
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8d50e526a9e9b7fa$exports,
        "map": new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        "string": new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype["delete"] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + "";
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;



var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $6b5a5095e0934938$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$f9ff2e983beb6b86$exports(object)) return object;
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $4d60aa8c33155976$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $f9ff2e983beb6b86$exports(objValue) ? objValue : $d83738e053b5eb08$exports(path[index + 1]) ? [] : {};
        }
        $3da413f0b86c10df$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$aba0e6d66e8d80dd$exports = $aba0e6d66e8d80dd$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $616ab74e95c8680a$var$set(object, path, value) {
    return object == null ? object : $aba0e6d66e8d80dd$exports(object, path, value);
}
$616ab74e95c8680a$exports = $616ab74e95c8680a$var$set;



var $ltooA = parcelRequire("ltooA");

var $06efbbb3bc2f8c6e$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === "hidden") return false;
        // If input ID matches the error, focus
        if (input.id && (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(errors, input.name);
    });
};


function $881b21ff70ac9ef2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $881b21ff70ac9ef2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $881b21ff70ac9ef2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $881b21ff70ac9ef2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $881b21ff70ac9ef2$export$c24727297075ec6a = /*#__PURE__*/ (0, $acw62.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $881b21ff70ac9ef2$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $881b21ff70ac9ef2$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit, testId = props.testId;
    var formRef = (0, $acw62.useRef)(null);
    var onSubmitRef = (0, $acw62.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $acw62.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $7f17f1906b9f3211$export$f681a8129d2e9d28)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === "function" ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($616ab74e95c8680a$exports)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($616ab74e95c8680a$exports)))(values, name, _value);
                    }
                }
            }
        });
        (0, $485f8543f71f3f87$export$2e2bcd8739ae039)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll("input")) : [];
        }, (0, $ltooA.fg)("platform-form-field-error-focus") ? (0, $06efbbb3bc2f8c6e$export$fc06342dc8588d3b) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $acw62.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $acw62.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $acw62.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $acw62.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $acw62.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = $881b21ff70ac9ef2$var$_objectSpread({
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    }, testId && {
        "data-testid": testId
    });
    var childrenContent = function() {
        if (typeof children === "function") {
            var result = children.length > 0 ? children($881b21ff70ac9ef2$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $ltooA.fg)("platform-form-reset-field-state") && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return (0, $ltooA.fg)("platform_design-system-team_form-upgrade") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($881b21ff70ac9ef2$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($881b21ff70ac9ef2$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $e0e4a99256e50750$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e0e4a99256e50750$exports, "__esModule", {
    value: true
});
$e0e4a99256e50750$exports.default = void 0;

var $e0e4a99256e50750$var$_react = $e0e4a99256e50750$var$_interopRequireDefault((parcelRequire("acw62")));

var $e0e4a99256e50750$var$_statusError = $e0e4a99256e50750$var$_interopRequireDefault((parcelRequire("609qU")));

var $e0e4a99256e50750$var$_error = $e0e4a99256e50750$var$_interopRequireDefault((parcelRequire("bDnoG")));
function $e0e4a99256e50750$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0e4a99256e50750$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $e0e4a99256e50750$var$_react.default.createElement($e0e4a99256e50750$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $e0e4a99256e50750$var$_error.default
    }, props));
$e0e4a99256e50750$var$StatusErrorIcon.displayName = "StatusErrorIconMigration";
var $e0e4a99256e50750$var$_default = $e0e4a99256e50750$exports.default = $e0e4a99256e50750$var$StatusErrorIcon;


var $eb1dc092b8ea7938$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($eb1dc092b8ea7938$exports, "__esModule", {
    value: true
});
$eb1dc092b8ea7938$exports.default = void 0;

var $eb1dc092b8ea7938$var$_react = $eb1dc092b8ea7938$var$_interopRequireDefault((parcelRequire("acw62")));

var $eb1dc092b8ea7938$var$_statusSuccess = $eb1dc092b8ea7938$var$_interopRequireDefault((parcelRequire("17TwJ")));

var $eb1dc092b8ea7938$var$_success = $eb1dc092b8ea7938$var$_interopRequireDefault((parcelRequire("y8qtd")));
function $eb1dc092b8ea7938$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb1dc092b8ea7938$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $eb1dc092b8ea7938$var$_react.default.createElement($eb1dc092b8ea7938$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $eb1dc092b8ea7938$var$_success.default
    }, props));
$eb1dc092b8ea7938$var$StatusSuccessIcon.displayName = "StatusSuccessIconMigration";
var $eb1dc092b8ea7938$var$_default = $eb1dc092b8ea7938$exports.default = $eb1dc092b8ea7938$var$StatusSuccessIcon;



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $2e2efe1d85cbfad3$export$3c4232819458a302 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $f1bd95993ada74a3$var$messageStyles = null;
var $f1bd95993ada74a3$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $f1bd95993ada74a3$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $f1bd95993ada74a3$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $luEYg.default)([
            $f1bd95993ada74a3$var$iconWrapperStyles.root
        ])
    }, children);
};
var $f1bd95993ada74a3$var$messageIcons = {
    error: /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0e4a99256e50750$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eb1dc092b8ea7938$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $f1bd95993ada74a3$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $f1bd95993ada74a3$var$messageIcons[appearance];
    var _useContext = (0, $acw62.useContext)($f1bd95993ada74a3$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $ltooA.fg)("platform_dst_form_screenreader_message_fix") && !isWrapper;
    (0, $acw62.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, icon && /*#__PURE__*/ $acw62.createElement($f1bd95993ada74a3$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? "polite" : undefined,
        className: (0, $luEYg.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $f1bd95993ada74a3$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $f1bd95993ada74a3$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $2e2efe1d85cbfad3$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($f1bd95993ada74a3$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $f1bd95993ada74a3$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $2e2efe1d85cbfad3$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($f1bd95993ada74a3$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $f1bd95993ada74a3$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $2e2efe1d85cbfad3$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($f1bd95993ada74a3$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $f1bd95993ada74a3$var$MessageWrapperContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isWrapper: false
});
var $f1bd95993ada74a3$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $acw62.createElement($f1bd95993ada74a3$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $luEYg = parcelRequire("luEYg");

var $acw62 = parcelRequire("acw62");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
var $1338c8e45cbdf834$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $1338c8e45cbdf834$var$react18UseId = ($1338c8e45cbdf834$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $1338c8e45cbdf834$var$_React$useId !== void 0 ? $1338c8e45cbdf834$var$_React$useId : undefined;
function $1338c8e45cbdf834$export$f680877a34711e37() {
    if ($1338c8e45cbdf834$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) return $1338c8e45cbdf834$var$react18UseId();
    return "uid".concat((0, $e0ee72d35d886c5b$export$87d05f07e65211f1)());
}
var $1338c8e45cbdf834$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($1338c8e45cbdf834$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $1338c8e45cbdf834$export$6ee17796e3d70de2() {
    if ($1338c8e45cbdf834$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        var uid = $1338c8e45cbdf834$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e0ee72d35d886c5b$export$bb5ca5fba6fb4f1f)();
}



var $ltooA = parcelRequire("ltooA");


/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $993d6aa380217926$var$fieldsetLabelStyles = null;
var $993d6aa380217926$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $luEYg.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $993d6aa380217926$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $acw62.createElement("legend", {
        className: (0, $luEYg.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};



/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $ff931ce3ccc143b8$var$requiredIndicatorStyles = null;
function $ff931ce3ccc143b8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $luEYg.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}


function $b25ca8e3392a46e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b25ca8e3392a46e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b25ca8e3392a46e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b25ca8e3392a46e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b25ca8e3392a46e5$var$fieldWrapperStyles = null;
function $b25ca8e3392a46e5$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $b25ca8e3392a46e5$var$isFunction(x) {
    return typeof x === "function";
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $b25ca8e3392a46e5$var$usePreviousRef(current) {
    var ref = (0, $acw62.useRef)(current);
    // will be updated on the next render
    (0, $acw62.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $b25ca8e3392a46e5$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === "function" && typeof currentValue === "function") return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(previousValue) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(currentValue) === "object") return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $b25ca8e3392a46e5$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $acw62.useContext)((0, $881b21ff70ac9ef2$export$c24727297075ec6a)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $acw62.useContext)((0, $881b21ff70ac9ef2$export$c17cf6b332a82dbc)) || props.isDisabled || false;
    var defaultValue = $b25ca8e3392a46e5$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $b25ca8e3392a46e5$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$b25ca8e3392a46e5$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $acw62.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $b25ca8e3392a46e5$var$usePreviousRef(state);
    (0, $acw62.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $b25ca8e3392a46e5$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($b25ca8e3392a46e5$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === "checkbox") {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $1338c8e45cbdf834$export$f680877a34711e37)();
    var fieldId = (0, $acw62.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = "";
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $b25ca8e3392a46e5$var$_objectSpread($b25ca8e3392a46e5$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        "aria-invalid": state.error ? "true" : "false",
        "aria-describedby": getDescribedBy(),
        "aria-labelledby": "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $luEYg.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $993d6aa380217926$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff931ce3ccc143b8$export$2e2bcd8739ae039), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2e2efe1d85cbfad3$export$3c4232819458a302).Provider, {
        value: fieldId
    }, component && (0, $ltooA.fg)("platform_design-system-team_field-upgrade") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, component && component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1bd95993ada74a3$export$ec445f12f63100a5), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1bd95993ada74a3$export$8fbe3c7d0ed2c683), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1bd95993ada74a3$export$915e9e7bd4f0f96d), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1bd95993ada74a3$export$5505afb209a532c8), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $55bd6b694f6c38bc$var$formFooterWrapperStyles = null;
var $55bd6b694f6c38bc$var$justifyContentStyles = null;
function $55bd6b694f6c38bc$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? "end" : _ref$align, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("footer", {
        className: (0, $luEYg.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === "start" && "_1bah1y6m"
        ])
    }, children);
}


var $268cd31570d63e05$exports = {};
"use strict";
Object.defineProperty($268cd31570d63e05$exports, "__esModule", {
    value: true
});
$268cd31570d63e05$exports.default = void 0;

var $268cd31570d63e05$var$_react = $268cd31570d63e05$var$_interopRequireDefault((parcelRequire("acw62")));


var $268cd31570d63e05$var$_showMoreHorizontal = $268cd31570d63e05$var$_interopRequireDefault((parcelRequire("b0drB")));
function $268cd31570d63e05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $268cd31570d63e05$var$MoreIcon = (props)=>/*#__PURE__*/ $268cd31570d63e05$var$_react.default.createElement($649746fe359eec05$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $268cd31570d63e05$var$_showMoreHorizontal.default
    }));
$268cd31570d63e05$var$MoreIcon.displayName = "MoreIcon";
var $268cd31570d63e05$var$_default = $268cd31570d63e05$exports.default = $268cd31570d63e05$var$MoreIcon;



var $acw62 = parcelRequire("acw62");
function $185ac4d2d2286c00$var$n() {
    return $185ac4d2d2286c00$var$n = Object.assign ? Object.assign.bind() : function(r) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
        }
        return r;
    }, $185ac4d2d2286c00$var$n.apply(this, arguments);
}
var $185ac4d2d2286c00$var$e = [
    "children",
    "options"
], $185ac4d2d2286c00$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $185ac4d2d2286c00$var$u = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(r, n) {
    return r[n.toLowerCase()] = n, r;
}, {
    class: "className",
    for: "htmlFor"
}), $185ac4d2d2286c00$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $185ac4d2d2286c00$var$i = [
    "style",
    "script",
    "pre"
], $185ac4d2d2286c00$var$o = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $185ac4d2d2286c00$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $185ac4d2d2286c00$var$f = /mailto:/i, $185ac4d2d2286c00$var$l = /\n{2,}$/, $185ac4d2d2286c00$var$_ = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $185ac4d2d2286c00$var$d = /^ *> ?/gm, $185ac4d2d2286c00$var$s = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $185ac4d2d2286c00$var$p = /^ {2,}\n/, $185ac4d2d2286c00$var$v = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $185ac4d2d2286c00$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $185ac4d2d2286c00$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $185ac4d2d2286c00$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $185ac4d2d2286c00$var$m = /^(?:\n *)*\n/, $185ac4d2d2286c00$var$k = /\r\n?/g, $185ac4d2d2286c00$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $185ac4d2d2286c00$var$q = /^\[\^([^\]]+)]/, $185ac4d2d2286c00$var$b = /\f/g, $185ac4d2d2286c00$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $185ac4d2d2286c00$var$$ = /^\s*?\[(x|\s)\]/, $185ac4d2d2286c00$var$z = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $185ac4d2d2286c00$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $185ac4d2d2286c00$var$R = /^([^\n]+)\n *(=|-){3,} *\n/, $185ac4d2d2286c00$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $185ac4d2d2286c00$var$B = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $185ac4d2d2286c00$var$L = /^<!--[\s\S]*?(?:-->)/, $185ac4d2d2286c00$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $185ac4d2d2286c00$var$j = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $185ac4d2d2286c00$var$C = /^\{.*\}$/, $185ac4d2d2286c00$var$I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $185ac4d2d2286c00$var$T = /^<([^ >]+@[^ >]+)>/, $185ac4d2d2286c00$var$M = /^<([^ >]+:\/[^ >]+)>/, $185ac4d2d2286c00$var$w = /-([a-z])?/gi, $185ac4d2d2286c00$var$D = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $185ac4d2d2286c00$var$F = /^[^\n]+(?:  \n|\n{2,})/, $185ac4d2d2286c00$var$P = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $185ac4d2d2286c00$var$N = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $185ac4d2d2286c00$var$Z = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $185ac4d2d2286c00$var$G = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $185ac4d2d2286c00$var$U = /\t/g, $185ac4d2d2286c00$var$V = /(^ *\||\| *$)/g, $185ac4d2d2286c00$var$H = /^ *:-+: *$/, $185ac4d2d2286c00$var$Q = /^ *:-+ *$/, $185ac4d2d2286c00$var$W = /^ *-+: *$/, $185ac4d2d2286c00$var$J = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $185ac4d2d2286c00$var$K = RegExp("^([*_])\\1" + $185ac4d2d2286c00$var$J + "\\1\\1(?!\\1)"), $185ac4d2d2286c00$var$X = RegExp("^([*_])" + $185ac4d2d2286c00$var$J + "\\1(?!\\1)"), $185ac4d2d2286c00$var$Y = RegExp("^(==)" + $185ac4d2d2286c00$var$J + "\\1"), $185ac4d2d2286c00$var$rr = RegExp("^(~~)" + $185ac4d2d2286c00$var$J + "\\1"), $185ac4d2d2286c00$var$nr = /^\\([^0-9A-Za-z\s])/, $185ac4d2d2286c00$var$er = /\\([^0-9A-Za-z\s])/g, $185ac4d2d2286c00$var$tr = /^[\s\S](?:(?!  |[0-9]\.|http)[^=*_~\-\n<`\\\[!])*/, $185ac4d2d2286c00$var$ur = /^\n+/, $185ac4d2d2286c00$var$ar = /^([ \t]*)/, $185ac4d2d2286c00$var$ir = /(?:^|\n)( *)$/, $185ac4d2d2286c00$var$or = "(?:\\d+\\.)", $185ac4d2d2286c00$var$cr = "(?:[*+-])";
function $185ac4d2d2286c00$var$fr(r) {
    return "( *)(" + (1 === r ? $185ac4d2d2286c00$var$or : $185ac4d2d2286c00$var$cr) + ") +";
}
var $185ac4d2d2286c00$var$lr = $185ac4d2d2286c00$var$fr(1), $185ac4d2d2286c00$var$_r = $185ac4d2d2286c00$var$fr(2);
function $185ac4d2d2286c00$var$dr(r) {
    return RegExp("^" + (1 === r ? $185ac4d2d2286c00$var$lr : $185ac4d2d2286c00$var$_r));
}
var $185ac4d2d2286c00$var$sr = $185ac4d2d2286c00$var$dr(1), $185ac4d2d2286c00$var$pr = $185ac4d2d2286c00$var$dr(2);
function $185ac4d2d2286c00$var$vr(r) {
    return RegExp("^" + (1 === r ? $185ac4d2d2286c00$var$lr : $185ac4d2d2286c00$var$_r) + "[^\\n]*(?:\\n(?!\\1" + (1 === r ? $185ac4d2d2286c00$var$or : $185ac4d2d2286c00$var$cr) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $185ac4d2d2286c00$var$yr = $185ac4d2d2286c00$var$vr(1), $185ac4d2d2286c00$var$hr = $185ac4d2d2286c00$var$vr(2);
function $185ac4d2d2286c00$var$gr(r) {
    var n = 1 === r ? $185ac4d2d2286c00$var$or : $185ac4d2d2286c00$var$cr;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $185ac4d2d2286c00$var$mr = $185ac4d2d2286c00$var$gr(1), $185ac4d2d2286c00$var$kr = $185ac4d2d2286c00$var$gr(2);
function $185ac4d2d2286c00$var$xr(r, n) {
    var e = 1 === n, t = e ? $185ac4d2d2286c00$var$mr : $185ac4d2d2286c00$var$kr, u = e ? $185ac4d2d2286c00$var$yr : $185ac4d2d2286c00$var$hr, a = e ? $185ac4d2d2286c00$var$sr : $185ac4d2d2286c00$var$pr;
    return {
        t: function(r) {
            return a.test(r);
        },
        u: $185ac4d2d2286c00$var$Or(function(r, n) {
            var e = $185ac4d2d2286c00$var$ir.exec(n.prevCapture);
            return e && (n.list || !n.inline && !n.simple) ? t.exec(r = e[1] + r) : null;
        }),
        i: 1,
        o: function(r, n, t) {
            var i = e ? +r[2] : void 0, o = r[0].replace($185ac4d2d2286c00$var$l, "\n").match(u), c = !1;
            return {
                items: o.map(function(r, e) {
                    var u = a.exec(r)[0].length, i = RegExp("^ {1," + u + "}", "gm"), f = r.replace(i, "").replace(a, ""), l = e === o.length - 1, _ = -1 !== f.indexOf("\n\n") || l && c;
                    c = _;
                    var d, s = t.inline, p = t.list;
                    t.list = !0, _ ? (t.inline = !1, d = $185ac4d2d2286c00$var$Sr(f) + "\n\n") : (t.inline = !0, d = $185ac4d2d2286c00$var$Sr(f));
                    var v = n(d, t);
                    return t.inline = s, t.list = p, v;
                }),
                ordered: e,
                start: i
            };
        },
        l: function(n, e, t) {
            return r(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, u) {
                return r("li", {
                    key: u
                }, e(n, t));
            }));
        }
    };
}
var $185ac4d2d2286c00$var$qr = RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $185ac4d2d2286c00$var$br = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $185ac4d2d2286c00$var$Sr(r) {
    for(var n = r.length; n > 0 && r[n - 1] <= " ";)n--;
    return r.slice(0, n);
}
function $185ac4d2d2286c00$var$$r(r, n) {
    return r.startsWith(n);
}
function $185ac4d2d2286c00$var$zr(r, n, e) {
    if (Array.isArray(e)) {
        for(var t = 0; t < e.length; t++)if ($185ac4d2d2286c00$var$$r(r, e[t])) return !0;
        return !1;
    }
    return e(r, n);
}
function $185ac4d2d2286c00$export$c383cdd2a518017a(r) {
    return r.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $185ac4d2d2286c00$var$Rr(r) {
    return $185ac4d2d2286c00$var$W.test(r) ? "right" : $185ac4d2d2286c00$var$H.test(r) ? "center" : $185ac4d2d2286c00$var$Q.test(r) ? "left" : null;
}
function $185ac4d2d2286c00$var$Ar(r, n, e, t) {
    var u = e.inTable;
    e.inTable = !0;
    var a = [
        []
    ], i = "";
    function o() {
        if (i) {
            var r = a[a.length - 1];
            r.push.apply(r, n(i, e)), i = "";
        }
    }
    return r.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach(function(r, n, e) {
        "|" === r.trim() && (o(), t) ? 0 !== n && n !== e.length - 1 && a.push([]) : i += r;
    }), o(), e.inTable = u, a;
}
function $185ac4d2d2286c00$var$Br(r, n, e) {
    e.inline = !0;
    var t = r[2] ? r[2].replace($185ac4d2d2286c00$var$V, "").split("|").map($185ac4d2d2286c00$var$Rr) : [], u = r[3] ? function(r, n, e) {
        return r.trim().split("\n").map(function(r) {
            return $185ac4d2d2286c00$var$Ar(r, n, e, !0);
        });
    }(r[3], n, e) : [], a = $185ac4d2d2286c00$var$Ar(r[1], n, e, !!u.length);
    return e.inline = !1, u.length ? {
        align: t,
        cells: u,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $185ac4d2d2286c00$var$Lr(r, n) {
    return null == r.align[n] ? {} : {
        textAlign: r.align[n]
    };
}
function $185ac4d2d2286c00$var$Or(r) {
    return r.inline = 1, r;
}
function $185ac4d2d2286c00$var$jr(r) {
    return $185ac4d2d2286c00$var$Or(function(n, e) {
        return e.inline ? r.exec(n) : null;
    });
}
function $185ac4d2d2286c00$var$Cr(r) {
    return $185ac4d2d2286c00$var$Or(function(n, e) {
        return e.inline || e.simple ? r.exec(n) : null;
    });
}
function $185ac4d2d2286c00$var$Ir(r) {
    return function(n, e) {
        return e.inline || e.simple ? null : r.exec(n);
    };
}
function $185ac4d2d2286c00$var$Tr(r) {
    return $185ac4d2d2286c00$var$Or(function(n) {
        return r.exec(n);
    });
}
var $185ac4d2d2286c00$var$Mr = /(javascript|vbscript|data(?!:image)):/i;
function $185ac4d2d2286c00$export$3e2338ea76b578c9(r) {
    try {
        var n = decodeURIComponent(r).replace(/[^A-Za-z0-9/:]/g, "");
        if ($185ac4d2d2286c00$var$Mr.test(n)) return null;
    } catch (r) {
        return null;
    }
    return r;
}
function $185ac4d2d2286c00$var$Dr(r) {
    return r ? r.replace($185ac4d2d2286c00$var$er, "$1") : r;
}
function $185ac4d2d2286c00$var$Fr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !0, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $185ac4d2d2286c00$var$Pr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !1, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $185ac4d2d2286c00$var$Nr(r, n, e) {
    var t = e.inline || !1;
    e.inline = !1;
    var u = r(n, e);
    return e.inline = t, u;
}
var $185ac4d2d2286c00$var$Zr = function(r, n, e) {
    return {
        children: $185ac4d2d2286c00$var$Fr(n, r[2], e)
    };
};
function $185ac4d2d2286c00$var$Gr() {
    return {};
}
function $185ac4d2d2286c00$var$Ur() {
    return null;
}
function $185ac4d2d2286c00$var$Vr() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $185ac4d2d2286c00$var$Hr(r, n, e) {
    for(var t = r, u = n.split("."); u.length && void 0 !== (t = t[u[0]]);)u.shift();
    return t || e;
}
function $185ac4d2d2286c00$var$Qr(r, n) {
    var e = $185ac4d2d2286c00$var$Hr(n, r);
    return e ? "function" == typeof e || "object" == typeof e && "render" in e ? e : $185ac4d2d2286c00$var$Hr(n, r + ".component", r) : r;
}
function $185ac4d2d2286c00$export$69f434acfbdb0b32(e, t) {
    var l;
    void 0 === e && (e = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $185ac4d2d2286c00$var$n({}, $185ac4d2d2286c00$var$a, t.namedCodesToUnicode) : $185ac4d2d2286c00$var$a;
    var V = t.slugify || $185ac4d2d2286c00$export$c383cdd2a518017a, H = t.sanitizer || $185ac4d2d2286c00$export$3e2338ea76b578c9, Q = t.createElement || $acw62.createElement, W = [
        $185ac4d2d2286c00$var$_,
        $185ac4d2d2286c00$var$y,
        $185ac4d2d2286c00$var$h,
        t.enforceAtxHeadings ? $185ac4d2d2286c00$var$E : $185ac4d2d2286c00$var$z,
        $185ac4d2d2286c00$var$R,
        $185ac4d2d2286c00$var$D,
        $185ac4d2d2286c00$var$mr,
        $185ac4d2d2286c00$var$kr
    ], J = [].concat(W, [
        $185ac4d2d2286c00$var$F,
        $185ac4d2d2286c00$var$A,
        $185ac4d2d2286c00$var$L,
        $185ac4d2d2286c00$var$j
    ]);
    function er(r, e) {
        var u = $185ac4d2d2286c00$var$Hr(t.overrides, r + ".props", {});
        return Q.apply(void 0, [
            $185ac4d2d2286c00$var$Qr(r, t.overrides),
            $185ac4d2d2286c00$var$n({}, e, u, {
                className: $185ac4d2d2286c00$var$Vr(null == e ? void 0 : e.className, u.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function ir(r) {
        r = r.replace($185ac4d2d2286c00$var$S, "");
        var n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $185ac4d2d2286c00$var$G.test(r));
        for(var e = sr(dr(n ? r : $185ac4d2d2286c00$var$Sr(r).replace($185ac4d2d2286c00$var$ur, "") + "\n\n", {
            inline: n
        })); "string" == typeof e[e.length - 1] && !e[e.length - 1].trim();)e.pop();
        if (null === t.wrapper) return e;
        var u, a = t.wrapper || (n ? "span" : "div");
        if (e.length > 1 || t.forceWrapper) u = e;
        else {
            if (1 === e.length) return "string" == typeof (u = e[0]) ? er("span", {
                key: "outer"
            }, u) : u;
            u = null;
        }
        return Q(a, {
            key: "outer"
        }, u);
    }
    function or(r, n) {
        if (!n || !n.trim()) return null;
        var e = n.match($185ac4d2d2286c00$var$c);
        return e ? e.reduce(function(n, e) {
            var t = e.indexOf("=");
            if (-1 !== t) {
                var a = (function(r) {
                    return -1 !== r.indexOf("-") && null === r.match($185ac4d2d2286c00$var$O) && (r = r.replace($185ac4d2d2286c00$var$w, function(r, n) {
                        return n.toUpperCase();
                    })), r;
                })(e.slice(0, t)).trim(), i = function(r) {
                    var n = r[0];
                    return ('"' === n || "'" === n) && r.length >= 2 && r[r.length - 1] === n ? r.slice(1, -1) : r;
                }(e.slice(t + 1).trim()), c = $185ac4d2d2286c00$var$u[a] || a;
                if ("ref" === c) return n;
                var f = n[c] = function(r, n, e, t) {
                    return "style" === n ? (function(r) {
                        var n = [], e = "", t = !1, u = !1, a = "";
                        if (!r) return n;
                        for(var i = 0; i < r.length; i++){
                            var o = r[i];
                            if ('"' !== o && "'" !== o || t || (u ? o === a && (u = !1, a = "") : (u = !0, a = o)), "(" === o && e.endsWith("url") ? t = !0 : ")" === o && t && (t = !1), ";" !== o || u || t) e += o;
                            else {
                                var c = e.trim();
                                if (c) {
                                    var f = c.indexOf(":");
                                    if (f > 0) {
                                        var l = c.slice(0, f).trim(), _ = c.slice(f + 1).trim();
                                        n.push([
                                            l,
                                            _
                                        ]);
                                    }
                                }
                                e = "";
                            }
                        }
                        var d = e.trim();
                        if (d) {
                            var s = d.indexOf(":");
                            if (s > 0) {
                                var p = d.slice(0, s).trim(), v = d.slice(s + 1).trim();
                                n.push([
                                    p,
                                    v
                                ]);
                            }
                        }
                        return n;
                    })(e).reduce(function(n, e) {
                        var u = e[0], a = e[1];
                        return n[u.replace(/(-[a-z])/g, function(r) {
                            return r[1].toUpperCase();
                        })] = t(a, r, u), n;
                    }, {}) : -1 !== $185ac4d2d2286c00$var$o.indexOf(n) ? t($185ac4d2d2286c00$var$Dr(e), r, n) : (e.match($185ac4d2d2286c00$var$C) && (e = $185ac4d2d2286c00$var$Dr(e.slice(1, e.length - 1))), "true" === e || "false" !== e && e);
                }(r, a, i, H);
                "string" == typeof f && ($185ac4d2d2286c00$var$A.test(f) || $185ac4d2d2286c00$var$j.test(f)) && (n[c] = ir(f.trim()));
            } else "style" !== e && (n[$185ac4d2d2286c00$var$u[e] || e] = !0);
            return n;
        }, {}) : null;
    }
    var cr = [], fr = {}, lr = ((l = {})[0] = {
        t: [
            ">"
        ],
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$_),
        i: 1,
        o: function(r, n, e) {
            var t = r[0].replace($185ac4d2d2286c00$var$d, "").match($185ac4d2d2286c00$var$s);
            return {
                alert: t[1],
                children: n(t[2], e)
            };
        },
        l: function(r, n, e) {
            var t = {
                key: e.key
            };
            return r.alert && (t.className = "markdown-alert-" + V(r.alert.toLowerCase(), $185ac4d2d2286c00$export$c383cdd2a518017a), r.children.unshift({
                attrs: {},
                children: [
                    {
                        type: "27",
                        text: r.alert
                    }
                ],
                noInnerParse: !0,
                type: "11",
                tag: "header"
            })), er("blockquote", t, n(r.children, e));
        }
    }, l[1] = {
        u: $185ac4d2d2286c00$var$Tr($185ac4d2d2286c00$var$p),
        i: 1,
        o: $185ac4d2d2286c00$var$Gr,
        l: function(r, n, e) {
            return er("br", {
                key: e.key
            });
        }
    }, l[2] = {
        t: function(r) {
            var n = r[0];
            return "-" === n || "*" === n || "_" === n;
        },
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$v),
        i: 1,
        o: $185ac4d2d2286c00$var$Gr,
        l: function(r, n, e) {
            return er("hr", {
                key: e.key
            });
        }
    }, l[3] = {
        t: [
            "    "
        ],
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$h),
        i: 0,
        o: function(r) {
            return {
                lang: void 0,
                text: $185ac4d2d2286c00$var$Dr($185ac4d2d2286c00$var$Sr(r[0].replace(/^ {4}/gm, "")))
            };
        },
        l: function(r, e, t) {
            return er("pre", {
                key: t.key
            }, er("code", $185ac4d2d2286c00$var$n({}, r.attrs, {
                className: r.lang ? "lang-" + r.lang : ""
            }), r.text));
        }
    }, l[4] = {
        t: [
            "```",
            "~~~"
        ],
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$y),
        i: 0,
        o: function(r) {
            return {
                attrs: or("code", r[3] || ""),
                lang: r[2] || void 0,
                text: r[4],
                type: "3"
            };
        }
    }, l[5] = {
        t: [
            "`"
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$g),
        i: 3,
        o: function(r) {
            return {
                text: $185ac4d2d2286c00$var$Dr(r[2])
            };
        },
        l: function(r, n, e) {
            return er("code", {
                key: e.key
            }, r.text);
        }
    }, l[6] = {
        t: [
            "[^"
        ],
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$x),
        i: 0,
        o: function(r) {
            return cr.push({
                footnote: r[2],
                identifier: r[1]
            }), {};
        },
        l: $185ac4d2d2286c00$var$Ur
    }, l[7] = {
        t: [
            "[^"
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$q),
        i: 1,
        o: function(r) {
            return {
                target: "#" + V(r[1], $185ac4d2d2286c00$export$c383cdd2a518017a),
                text: r[1]
            };
        },
        l: function(r, n, e) {
            return er("a", {
                key: e.key,
                href: H(r.target, "a", "href")
            }, er("sup", {
                key: e.key
            }, r.text));
        }
    }, l[8] = {
        t: [
            "[ ]",
            "[x]"
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$$),
        i: 1,
        o: function(r) {
            return {
                completed: "x" === r[1].toLowerCase()
            };
        },
        l: function(r, n, e) {
            return er("input", {
                checked: r.completed,
                key: e.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, l[9] = {
        t: [
            "#"
        ],
        u: $185ac4d2d2286c00$var$Ir(t.enforceAtxHeadings ? $185ac4d2d2286c00$var$E : $185ac4d2d2286c00$var$z),
        i: 1,
        o: function(r, n, e) {
            return {
                children: $185ac4d2d2286c00$var$Fr(n, r[2], e),
                id: V(r[2], $185ac4d2d2286c00$export$c383cdd2a518017a),
                level: r[1].length
            };
        },
        l: function(r, n, e) {
            return er("h" + r.level, {
                id: r.id,
                key: e.key
            }, n(r.children, e));
        }
    }, l[10] = {
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$R),
        i: 0,
        o: function(r, n, e) {
            return {
                children: $185ac4d2d2286c00$var$Fr(n, r[1], e),
                level: "=" === r[2] ? 1 : 2,
                type: "9"
            };
        }
    }, l[11] = {
        t: [
            "<"
        ],
        u: $185ac4d2d2286c00$var$Tr($185ac4d2d2286c00$var$A),
        i: 1,
        o: function(r, n, e) {
            var t, u = r[3].match($185ac4d2d2286c00$var$ar), a = RegExp("^" + u[1], "gm"), o = r[3].replace(a, ""), c = (t = o, J.some(function(r) {
                return r.test(t);
            }) ? $185ac4d2d2286c00$var$Nr : $185ac4d2d2286c00$var$Fr), f = r[1].toLowerCase(), l = -1 !== $185ac4d2d2286c00$var$i.indexOf(f), _ = (l ? f : r[1]).trim(), d = {
                attrs: or(_, r[2]),
                noInnerParse: l,
                tag: _
            };
            if (e.inAnchor = e.inAnchor || "a" === f, l) d.text = r[3];
            else {
                var s = e.inHTML;
                e.inHTML = !0, d.children = c(n, o, e), e.inHTML = s;
            }
            return e.inAnchor = !1, d;
        },
        l: function(r, e, t) {
            return er(r.tag, $185ac4d2d2286c00$var$n({
                key: t.key
            }, r.attrs), r.text || (r.children ? e(r.children, t) : ""));
        }
    }, l[13] = {
        t: [
            "<"
        ],
        u: $185ac4d2d2286c00$var$Tr($185ac4d2d2286c00$var$j),
        i: 1,
        o: function(r) {
            var n = r[1].trim();
            return {
                attrs: or(n, r[2] || ""),
                tag: n
            };
        },
        l: function(r, e, t) {
            return er(r.tag, $185ac4d2d2286c00$var$n({}, r.attrs, {
                key: t.key
            }));
        }
    }, l[12] = {
        t: [
            "<!--"
        ],
        u: $185ac4d2d2286c00$var$Tr($185ac4d2d2286c00$var$L),
        i: 1,
        o: function() {
            return {};
        },
        l: $185ac4d2d2286c00$var$Ur
    }, l[14] = {
        t: [
            "!["
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$br),
        i: 1,
        o: function(r) {
            return {
                alt: $185ac4d2d2286c00$var$Dr(r[1]),
                target: $185ac4d2d2286c00$var$Dr(r[2]),
                title: $185ac4d2d2286c00$var$Dr(r[3])
            };
        },
        l: function(r, n, e) {
            return er("img", {
                key: e.key,
                alt: r.alt || void 0,
                title: r.title || void 0,
                src: H(r.target, "img", "src")
            });
        }
    }, l[15] = {
        t: [
            "["
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$qr),
        i: 3,
        o: function(r, n, e) {
            return {
                children: $185ac4d2d2286c00$var$Pr(n, r[1], e),
                target: $185ac4d2d2286c00$var$Dr(r[2]),
                title: $185ac4d2d2286c00$var$Dr(r[3])
            };
        },
        l: function(r, n, e) {
            return er("a", {
                key: e.key,
                href: H(r.target, "a", "href"),
                title: r.title
            }, n(r.children, e));
        }
    }, l[16] = {
        t: [
            "<"
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$M),
        i: 0,
        o: function(r) {
            return {
                children: [
                    {
                        text: r[1],
                        type: "27"
                    }
                ],
                target: r[1],
                type: "15"
            };
        }
    }, l[17] = {
        t: function(r, n) {
            return !n.inAnchor && !t.disableAutoLink && ($185ac4d2d2286c00$var$$r(r, "http://") || $185ac4d2d2286c00$var$$r(r, "https://"));
        },
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$I),
        i: 0,
        o: function(r) {
            return {
                children: [
                    {
                        text: r[1],
                        type: "27"
                    }
                ],
                target: r[1],
                title: void 0,
                type: "15"
            };
        }
    }, l[18] = {
        t: [
            "<"
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$T),
        i: 0,
        o: function(r) {
            var n = r[1], e = r[1];
            return $185ac4d2d2286c00$var$f.test(e) || (e = "mailto:" + e), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: e,
                type: "15"
            };
        }
    }, l[20] = $185ac4d2d2286c00$var$xr(er, 1), l[33] = $185ac4d2d2286c00$var$xr(er, 2), l[19] = {
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$m),
        i: 3,
        o: $185ac4d2d2286c00$var$Gr,
        l: function() {
            return "\n";
        }
    }, l[21] = {
        u: $185ac4d2d2286c00$var$Or(function(r, n) {
            if (n.inline || n.simple || n.inHTML && -1 === r.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
            var e = "";
            r.split("\n").every(function(r) {
                return r += "\n", !W.some(function(n) {
                    return n.test(r);
                }) && (e += r, !!r.trim());
            });
            var t = $185ac4d2d2286c00$var$Sr(e);
            return "" === t ? null : [
                e,
                ,
                t
            ];
        }),
        i: 3,
        o: $185ac4d2d2286c00$var$Zr,
        l: function(r, n, e) {
            return er("p", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[22] = {
        t: [
            "["
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$P),
        i: 0,
        o: function(r) {
            return fr[r[1]] = {
                target: r[2],
                title: r[4]
            }, {};
        },
        l: $185ac4d2d2286c00$var$Ur
    }, l[23] = {
        t: [
            "!["
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$N),
        i: 0,
        o: function(r) {
            return {
                alt: r[1] ? $185ac4d2d2286c00$var$Dr(r[1]) : void 0,
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return fr[r.ref] ? er("img", {
                key: e.key,
                alt: r.alt,
                src: H(fr[r.ref].target, "img", "src"),
                title: fr[r.ref].title
            }) : null;
        }
    }, l[24] = {
        t: [
            "["
        ],
        u: $185ac4d2d2286c00$var$jr($185ac4d2d2286c00$var$Z),
        i: 0,
        o: function(r, n, e) {
            return {
                children: n(r[1], e),
                fallbackChildren: r[0],
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return fr[r.ref] ? er("a", {
                key: e.key,
                href: H(fr[r.ref].target, "a", "href"),
                title: fr[r.ref].title
            }, n(r.children, e)) : er("span", {
                key: e.key
            }, r.fallbackChildren);
        }
    }, l[25] = {
        t: [
            "|"
        ],
        u: $185ac4d2d2286c00$var$Ir($185ac4d2d2286c00$var$D),
        i: 1,
        o: $185ac4d2d2286c00$var$Br,
        l: function(r, n, e) {
            var t = r;
            return er("table", {
                key: e.key
            }, er("thead", null, er("tr", null, t.header.map(function(r, u) {
                return er("th", {
                    key: u,
                    style: $185ac4d2d2286c00$var$Lr(t, u)
                }, n(r, e));
            }))), er("tbody", null, t.cells.map(function(r, u) {
                return er("tr", {
                    key: u
                }, r.map(function(r, u) {
                    return er("td", {
                        key: u,
                        style: $185ac4d2d2286c00$var$Lr(t, u)
                    }, n(r, e));
                }));
            })));
        }
    }, l[27] = {
        u: $185ac4d2d2286c00$var$Tr($185ac4d2d2286c00$var$tr),
        i: 4,
        o: function(r) {
            var n = r[0];
            return {
                text: -1 === n.indexOf("&") ? n : n.replace($185ac4d2d2286c00$var$B, function(r, n) {
                    return t.namedCodesToUnicode[n] || r;
                })
            };
        },
        l: function(r) {
            return r.text;
        }
    }, l[28] = {
        t: [
            "**",
            "__"
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$K),
        i: 2,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return er("strong", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[29] = {
        t: function(r) {
            var n = r[0];
            return ("*" === n || "_" === n) && r[1] !== n;
        },
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$X),
        i: 3,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return er("em", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[30] = {
        t: [
            "\\"
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$nr),
        i: 1,
        o: function(r) {
            return {
                text: r[1],
                type: "27"
            };
        }
    }, l[31] = {
        t: [
            "=="
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$Y),
        i: 3,
        o: $185ac4d2d2286c00$var$Zr,
        l: function(r, n, e) {
            return er("mark", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[32] = {
        t: [
            "~~"
        ],
        u: $185ac4d2d2286c00$var$Cr($185ac4d2d2286c00$var$rr),
        i: 3,
        o: $185ac4d2d2286c00$var$Zr,
        l: function(r, n, e) {
            return er("del", {
                key: e.key
            }, n(r.children, e));
        }
    }, l);
    !0 === t.disableParsingRawHTML && (delete lr[11], delete lr[13]);
    var _r, dr = function(r) {
        var n = Object.keys(r);
        function e(t, u) {
            var a = [];
            if (u.prevCapture = u.prevCapture || "", t.trim()) for(; t;)for(var i = 0; i < n.length;){
                var o = n[i], c = r[o];
                if (!c.t || $185ac4d2d2286c00$var$zr(t, u, c.t)) {
                    var f = c.u(t, u);
                    if (f && f[0]) {
                        t = t.substring(f[0].length);
                        var l = c.o(f, e, u);
                        u.prevCapture += f[0], l.type || (l.type = o), a.push(l);
                        break;
                    }
                    i++;
                } else i++;
            }
            return u.prevCapture = "", a;
        }
        return n.sort(function(n, e) {
            return r[n].i - r[e].i || (n < e ? -1 : 1);
        }), function(r, n) {
            return e(function(r) {
                return r.replace($185ac4d2d2286c00$var$k, "\n").replace($185ac4d2d2286c00$var$b, "").replace($185ac4d2d2286c00$var$U, "    ");
            }(r), n);
        };
    }(lr), sr = (_r = function(r, n) {
        return function(e, t, u) {
            var a = r[e.type].l;
            return n ? n(function() {
                return a(e, t, u);
            }, e, t, u) : a(e, t, u);
        };
    }(lr, t.renderRule), function r(n, e) {
        if (void 0 === e && (e = {}), Array.isArray(n)) {
            for(var t = e.key, u = [], a = !1, i = 0; i < n.length; i++){
                e.key = i;
                var o = r(n[i], e), c = "string" == typeof o;
                c && a ? u[u.length - 1] += o : null !== o && u.push(o), a = c;
            }
            return e.key = t, u;
        }
        return _r(n, r, e);
    }), pr = ir(e);
    return cr.length ? er("div", null, pr, er("footer", {
        key: "footer"
    }, cr.map(function(r) {
        return er("div", {
            id: V(r.identifier, $185ac4d2d2286c00$export$c383cdd2a518017a),
            key: r.identifier
        }, r.identifier, sr(dr(r.footnote, {
            inline: !0
        })));
    }))) : pr;
}
function $185ac4d2d2286c00$export$2e2bcd8739ae039(n) {
    var t = n.children, u = void 0 === t ? "" : t, a = n.options, i = function(r, n) {
        if (null == r) return {};
        var e, t, u = {}, a = Object.keys(r);
        for(t = 0; t < a.length; t++)n.indexOf(e = a[t]) >= 0 || (u[e] = r[e]);
        return u;
    }(n, $185ac4d2d2286c00$var$e);
    return $acw62.cloneElement($185ac4d2d2286c00$export$69f434acfbdb0b32(u, a), i);
}


var $bccdbb9b5a9b9950$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b480e25e279369257bb77bb164319fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($bccdbb9b5a9b9950$exports, "__esModule", {
    value: true
});
$bccdbb9b5a9b9950$exports.default = void 0;

var $bccdbb9b5a9b9950$var$_react = $bccdbb9b5a9b9950$var$_interopRequireDefault((parcelRequire("acw62")));

var $bccdbb9b5a9b9950$var$_UNSAFE_baseNew = $bccdbb9b5a9b9950$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $bccdbb9b5a9b9950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bccdbb9b5a9b9950$var$CameraIcon = (props)=>/*#__PURE__*/ $bccdbb9b5a9b9950$var$_react.default.createElement($bccdbb9b5a9b9950$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14 13.25H2c-.69 0-1.25-.56-1.25-1.25V5.25a2 2 0 0 1 2-2H4.5l1.5-2h4l1.5 2h1.75a2 2 0 0 1 2 2V12c0 .69-.56 1.25-1.25 1.25Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 8.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/>`
    }, props));
$bccdbb9b5a9b9950$var$CameraIcon.displayName = "CameraIcon";
var $bccdbb9b5a9b9950$var$_default = $bccdbb9b5a9b9950$exports.default = $bccdbb9b5a9b9950$var$CameraIcon;


var $52477d57b9d8c8b9$exports = {};
typeof navigator === "object" && function(global1, factory) {
    $52477d57b9d8c8b9$exports = factory();
}($52477d57b9d8c8b9$exports, function() {
    "use strict";
    function _defineProperty$1(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
    }
    function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }
    function _defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function ownKeys(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function _objectSpread2(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ownKeys(Object(n), !0).forEach(function(t) {
                _defineProperty(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var defaults$1 = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    function matches$1(e, t) {
        return (function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function trigger(e, t) {
        if (e && t) {
            var n = new Event(t, {
                bubbles: !0
            });
            e.dispatchEvent(n);
        }
    }
    var getConstructor$1 = function(e) {
        return null != e ? e.constructor : null;
    }, instanceOf$1 = function(e, t) {
        return !!(e && t && e instanceof t);
    }, isNullOrUndefined$1 = function(e) {
        return null == e;
    }, isObject$1 = function(e) {
        return getConstructor$1(e) === Object;
    }, isNumber$1 = function(e) {
        return getConstructor$1(e) === Number && !Number.isNaN(e);
    }, isString$1 = function(e) {
        return getConstructor$1(e) === String;
    }, isBoolean$1 = function(e) {
        return getConstructor$1(e) === Boolean;
    }, isFunction$1 = function(e) {
        return getConstructor$1(e) === Function;
    }, isArray$1 = function(e) {
        return Array.isArray(e);
    }, isNodeList$1 = function(e) {
        return instanceOf$1(e, NodeList);
    }, isElement$1 = function(e) {
        return instanceOf$1(e, Element);
    }, isEvent$1 = function(e) {
        return instanceOf$1(e, Event);
    }, isEmpty$1 = function(e) {
        return isNullOrUndefined$1(e) || (isString$1(e) || isArray$1(e) || isNodeList$1(e)) && !e.length || isObject$1(e) && !Object.keys(e).length;
    }, is$1 = {
        nullOrUndefined: isNullOrUndefined$1,
        object: isObject$1,
        number: isNumber$1,
        string: isString$1,
        boolean: isBoolean$1,
        function: isFunction$1,
        array: isArray$1,
        nodeList: isNodeList$1,
        element: isElement$1,
        event: isEvent$1,
        empty: isEmpty$1
    };
    function getDecimalPlaces(e) {
        var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
    }
    function round(e, t) {
        if (1 > t) {
            var n = getDecimalPlaces(t);
            return parseFloat(e.toFixed(n));
        }
        return Math.round(e / t) * t;
    }
    var RangeTouch = function() {
        function e(t, n) {
            _classCallCheck(this, e), is$1.element(t) ? this.element = t : is$1.string(t) && (this.element = document.querySelector(t)), is$1.element(this.element) && is$1.empty(this.element.rangeTouch) && (this.config = _objectSpread2({}, defaults$1, {}, n), this.init());
        }
        return _createClass(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, n = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[n](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !is$1.event(t)) return null;
                    var n, r = t.target, i = t.changedTouches[0], o = parseFloat(r.getAttribute("min")) || 0, s = parseFloat(r.getAttribute("max")) || 100, u = parseFloat(r.getAttribute("step")) || 1, c = r.getBoundingClientRect(), a = 100 / c.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (n = 100 / c.width * (i.clientX - c.left)) ? n = 0 : 100 < n && (n = 100), 50 > n ? n -= (100 - 2 * n) * a : 50 < n && (n += 2 * (n - 50) * a), o + round(n / 100 * (s - o), u);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && is$1.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), trigger(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, r = null;
                    if (is$1.empty(t) || is$1.string(t) ? r = Array.from(document.querySelectorAll(is$1.string(t) ? t : 'input[type="range"]')) : is$1.element(t) ? r = [
                        t
                    ] : is$1.nodeList(t) ? r = Array.from(t) : is$1.array(t) && (r = t.filter(is$1.element)), is$1.empty(r)) return null;
                    var i = _objectSpread2({}, defaults$1, {}, n);
                    if (is$1.string(t) && i.watch) {
                        var o = new MutationObserver(function(n) {
                            Array.from(n).forEach(function(n) {
                                Array.from(n.addedNodes).forEach(function(n) {
                                    is$1.element(n) && matches$1(n, t) && new e(n, i);
                                });
                            });
                        });
                        o.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return r.map(function(t) {
                        return new e(t, n);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    // ==========================================================================
    // Type checking utils
    // ==========================================================================
    const getConstructor = (input)=>input !== null && typeof input !== "undefined" ? input.constructor : null;
    const instanceOf = (input, constructor)=>Boolean(input && constructor && input instanceof constructor);
    const isNullOrUndefined = (input)=>input === null || typeof input === "undefined";
    const isObject = (input)=>getConstructor(input) === Object;
    const isNumber = (input)=>getConstructor(input) === Number && !Number.isNaN(input);
    const isString = (input)=>getConstructor(input) === String;
    const isBoolean = (input)=>getConstructor(input) === Boolean;
    const isFunction = (input)=>typeof input === "function";
    const isArray = (input)=>Array.isArray(input);
    const isWeakMap = (input)=>instanceOf(input, WeakMap);
    const isNodeList = (input)=>instanceOf(input, NodeList);
    const isTextNode = (input)=>getConstructor(input) === Text;
    const isEvent = (input)=>instanceOf(input, Event);
    const isKeyboardEvent = (input)=>instanceOf(input, KeyboardEvent);
    const isCue = (input)=>instanceOf(input, window.TextTrackCue) || instanceOf(input, window.VTTCue);
    const isTrack = (input)=>instanceOf(input, TextTrack) || !isNullOrUndefined(input) && isString(input.kind);
    const isPromise = (input)=>instanceOf(input, Promise) && isFunction(input.then);
    const isElement = (input)=>input !== null && typeof input === "object" && input.nodeType === 1 && typeof input.style === "object" && typeof input.ownerDocument === "object";
    const isEmpty = (input)=>isNullOrUndefined(input) || (isString(input) || isArray(input) || isNodeList(input)) && !input.length || isObject(input) && !Object.keys(input).length;
    const isUrl = (input)=>{
        // Accept a URL object
        if (instanceOf(input, window.URL)) return true;
        // Must be string from here
        if (!isString(input)) return false;
        // Add the protocol if required
        let string = input;
        if (!input.startsWith("http://") || !input.startsWith("https://")) string = `http://${input}`;
        try {
            return !isEmpty(new URL(string).hostname);
        } catch (_) {
            return false;
        }
    };
    var is = {
        nullOrUndefined: isNullOrUndefined,
        object: isObject,
        number: isNumber,
        string: isString,
        boolean: isBoolean,
        function: isFunction,
        array: isArray,
        weakMap: isWeakMap,
        nodeList: isNodeList,
        element: isElement,
        textNode: isTextNode,
        event: isEvent,
        keyboardEvent: isKeyboardEvent,
        cue: isCue,
        track: isTrack,
        promise: isPromise,
        url: isUrl,
        empty: isEmpty
    };
    // ==========================================================================
    const transitionEndEvent = (()=>{
        const element = document.createElement("span");
        const events = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        };
        const type = Object.keys(events).find((event)=>element.style[event] !== undefined);
        return is.string(type) ? events[type] : false;
    })();
    // Force repaint of element
    function repaint(element, delay) {
        setTimeout(()=>{
            try {
                // eslint-disable-next-line no-param-reassign
                element.hidden = true;
                // eslint-disable-next-line no-unused-expressions
                element.offsetHeight;
                // eslint-disable-next-line no-param-reassign
                element.hidden = false;
            } catch (_) {
            // Do nothing
            }
        }, delay);
    }
    // ==========================================================================
    // Browser sniffing
    // Unfortunately, due to mixed support, UA sniffing is required
    // ==========================================================================
    const browser = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebkit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    // ==========================================================================
    // Clone nested objects
    function cloneDeep(object) {
        return JSON.parse(JSON.stringify(object));
    }
    // Get a nested value in an object
    function getDeep(object, path) {
        return path.split(".").reduce((obj, key)=>obj && obj[key], object);
    }
    // Deep extend destination object with N more objects
    function extend(target = {}, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();
        if (!is.object(source)) return target;
        Object.keys(source).forEach((key)=>{
            if (is.object(source[key])) {
                if (!Object.keys(target).includes(key)) Object.assign(target, {
                    [key]: {}
                });
                extend(target[key], source[key]);
            } else Object.assign(target, {
                [key]: source[key]
            });
        });
        return extend(target, ...sources);
    }
    // ==========================================================================
    // Wrap an element
    function wrap(elements, wrapper) {
        // Convert `elements` to an array, if necessary.
        const targets = elements.length ? elements : [
            elements
        ];
        // Loops backwards to prevent having to clone the wrapper on the
        // first element (see `child` below).
        Array.from(targets).reverse().forEach((element, index)=>{
            const child = index > 0 ? wrapper.cloneNode(true) : wrapper;
            // Cache the current parent and sibling.
            const parent = element.parentNode;
            const sibling = element.nextSibling;
            // Wrap the element (is automatically removed from its current
            // parent).
            child.appendChild(element);
            // If the element had a sibling, insert the wrapper before
            // the sibling to maintain the HTML structure; otherwise, just
            // append it to the parent.
            if (sibling) parent.insertBefore(child, sibling);
            else parent.appendChild(child);
        });
    }
    // Set attributes
    function setAttributes(element, attributes) {
        if (!is.element(element) || is.empty(attributes)) return;
        // Assume null and undefined attributes should be left out,
        // Setting them would otherwise convert them to "null" and "undefined"
        Object.entries(attributes).filter(([, value])=>!is.nullOrUndefined(value)).forEach(([key, value])=>element.setAttribute(key, value));
    }
    // Create a DocumentFragment
    function createElement(type, attributes, text) {
        // Create a new <element>
        const element = document.createElement(type);
        // Set all passed attributes
        if (is.object(attributes)) setAttributes(element, attributes);
        // Add text node
        if (is.string(text)) element.innerText = text;
        // Return built element
        return element;
    }
    // Inaert an element after another
    function insertAfter(element, target) {
        if (!is.element(element) || !is.element(target)) return;
        target.parentNode.insertBefore(element, target.nextSibling);
    }
    // Insert a DocumentFragment
    function insertElement(type, parent, attributes, text) {
        if (!is.element(parent)) return;
        parent.appendChild(createElement(type, attributes, text));
    }
    // Remove element(s)
    function removeElement(element) {
        if (is.nodeList(element) || is.array(element)) {
            Array.from(element).forEach(removeElement);
            return;
        }
        if (!is.element(element) || !is.element(element.parentNode)) return;
        element.parentNode.removeChild(element);
    }
    // Remove all child elements
    function emptyElement(element) {
        if (!is.element(element)) return;
        let { length: length } = element.childNodes;
        while(length > 0){
            element.removeChild(element.lastChild);
            length -= 1;
        }
    }
    // Replace element
    function replaceElement(newChild, oldChild) {
        if (!is.element(oldChild) || !is.element(oldChild.parentNode) || !is.element(newChild)) return null;
        oldChild.parentNode.replaceChild(newChild, oldChild);
        return newChild;
    }
    // Get an attribute object from a string selector
    function getAttributesFromSelector(sel, existingAttributes) {
        // For example:
        // '.test' to { class: 'test' }
        // '#test' to { id: 'test' }
        // '[data-test="test"]' to { 'data-test': 'test' }
        if (!is.string(sel) || is.empty(sel)) return {};
        const attributes = {};
        const existing = extend({}, existingAttributes);
        sel.split(",").forEach((s)=>{
            // Remove whitespace
            const selector = s.trim();
            const className = selector.replace(".", "");
            const stripped = selector.replace(/[[\]]/g, "");
            // Get the parts and value
            const parts = stripped.split("=");
            const [key] = parts;
            const value = parts.length > 1 ? parts[1].replace(/["']/g, "") : "";
            // Get the first character
            const start = selector.charAt(0);
            switch(start){
                case ".":
                    // Add to existing classname
                    if (is.string(existing.class)) attributes.class = `${existing.class} ${className}`;
                    else attributes.class = className;
                    break;
                case "#":
                    // ID selector
                    attributes.id = selector.replace("#", "");
                    break;
                case "[":
                    // Attribute selector
                    attributes[key] = value;
                    break;
            }
        });
        return extend(existing, attributes);
    }
    // Toggle hidden
    function toggleHidden(element, hidden) {
        if (!is.element(element)) return;
        let hide = hidden;
        if (!is.boolean(hide)) hide = !element.hidden;
        // eslint-disable-next-line no-param-reassign
        element.hidden = hide;
    }
    // Mirror Element.classList.toggle, with IE compatibility for "force" argument
    function toggleClass(element, className, force) {
        if (is.nodeList(element)) return Array.from(element).map((e)=>toggleClass(e, className, force));
        if (is.element(element)) {
            let method = "toggle";
            if (typeof force !== "undefined") method = force ? "add" : "remove";
            element.classList[method](className);
            return element.classList.contains(className);
        }
        return false;
    }
    // Has class name
    function hasClass(element, className) {
        return is.element(element) && element.classList.contains(className);
    }
    // Element matches selector
    function matches(element, selector) {
        const { prototype: prototype } = Element;
        function match() {
            return Array.from(document.querySelectorAll(selector)).includes(this);
        }
        const method = prototype.matches || prototype.webkitMatchesSelector || prototype.mozMatchesSelector || prototype.msMatchesSelector || match;
        return method.call(element, selector);
    }
    // Closest ancestor element matching selector (also tests element itself)
    function closest$1(element, selector) {
        const { prototype: prototype } = Element;
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
        function closestElement() {
            let el = this;
            do {
                if (matches.matches(el, selector)) return el;
                el = el.parentElement || el.parentNode;
            }while (el !== null && el.nodeType === 1);
            return null;
        }
        const method = prototype.closest || closestElement;
        return method.call(element, selector);
    }
    // Find all elements
    function getElements(selector) {
        return this.elements.container.querySelectorAll(selector);
    }
    // Find a single element
    function getElement(selector) {
        return this.elements.container.querySelector(selector);
    }
    // Set focus and tab focus class
    function setFocus(element = null, tabFocus = false) {
        if (!is.element(element)) return;
        // Set regular focus
        element.focus({
            preventScroll: true
        });
        // If we want to mimic keyboard focus via tab
        if (tabFocus) toggleClass(element, this.config.classNames.tabFocus);
    }
    // ==========================================================================
    // Default codecs for checking mimetype support
    const defaultCodecs = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    };
    // Check for feature support
    const support = {
        // Basic support
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        // Check for support
        // Basic functionality vs full UI
        check (type, provider, playsinline) {
            const canPlayInline = browser.isIPhone && playsinline && support.playsinline;
            const api = support[type] || provider !== "html5";
            const ui = api && support.rangeInput && (type !== "video" || !browser.isIPhone || canPlayInline);
            return {
                api: api,
                ui: ui
            };
        },
        // Picture-in-picture support
        // Safari & Chrome only currently
        pip: (()=>{
            // While iPhone's support picture-in-picture for some apps, seemingly Safari isn't one of them
            // It will throw the following error when trying to enter picture-in-picture
            // `NotSupportedError: The Picture-in-Picture mode is not supported.`
            if (browser.isIPhone) return false;
            // Safari
            // https://developer.apple.com/documentation/webkitjs/adding_picture_in_picture_to_your_safari_media_controls
            if (is.function(createElement("video").webkitSetPresentationMode)) return true;
            // Chrome
            // https://developers.google.com/web/updates/2018/10/watch-video-using-picture-in-picture
            if (document.pictureInPictureEnabled && !createElement("video").disablePictureInPicture) return true;
            return false;
        })(),
        // Airplay support
        // Safari only currently
        airplay: is.function(window.WebKitPlaybackTargetAvailabilityEvent),
        // Inline playback support
        // https://webkit.org/blog/6784/new-video-policies-for-ios/
        playsinline: "playsInline" in document.createElement("video"),
        // Check for mime type support against a player instance
        // Credits: http://diveintohtml5.info/everything.html
        // Related: http://www.leanbackplayer.com/test/h5mt.html
        mime (input) {
            if (is.empty(input)) return false;
            const [mediaType] = input.split("/");
            let type = input;
            // Verify we're using HTML5 and there's no media type mismatch
            if (!this.isHTML5 || mediaType !== this.type) return false;
            // Add codec if required
            if (Object.keys(defaultCodecs).includes(type)) type += `; codecs="${defaultCodecs[input]}"`;
            try {
                return Boolean(type && this.media.canPlayType(type).replace(/no/, ""));
            } catch (_) {
                return false;
            }
        },
        // Check for textTracks support
        textTracks: "textTracks" in document.createElement("video"),
        // <input type="range"> Sliders
        rangeInput: (()=>{
            const range = document.createElement("input");
            range.type = "range";
            return range.type === "range";
        })(),
        // Touch
        // NOTE: Remember a device can be mouse + touch enabled so we check on first touch event
        touch: "ontouchstart" in document.documentElement,
        // Detect transitions support
        transitions: transitionEndEvent !== false,
        // Reduced motion iOS & MacOS setting
        // https://webkit.org/blog/7551/responsive-design-for-motion/
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    };
    // ==========================================================================
    // Check for passive event listener support
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // https://www.youtube.com/watch?v=NPM6172J22g
    const supportsPassiveListeners = (()=>{
        // Test via a getter in the options object to see if the passive property is accessed
        let supported = false;
        try {
            const options = Object.defineProperty({}, "passive", {
                get () {
                    supported = true;
                    return null;
                }
            });
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        } catch (_) {
        // Do nothing
        }
        return supported;
    })();
    // Toggle event listener
    function toggleListener(element, event, callback, toggle = false, passive = true, capture = false) {
        // Bail if no element, event, or callback
        if (!element || !("addEventListener" in element) || is.empty(event) || !is.function(callback)) return;
        // Allow multiple events
        const events = event.split(" ");
        // Build options
        // Default to just the capture boolean for browsers with no passive listener support
        let options = capture;
        // If passive events listeners are supported
        if (supportsPassiveListeners) options = {
            passive: // Whether the listener can be passive (i.e. default never prevented)
            passive,
            capture: // Whether the listener is a capturing listener or not
            capture
        };
        // If a single node is passed, bind the event listener
        events.forEach((type)=>{
            if (this && this.eventListeners && toggle) // Cache event listener
            this.eventListeners.push({
                element: element,
                type: type,
                callback: callback,
                options: options
            });
            element[toggle ? "addEventListener" : "removeEventListener"](type, callback, options);
        });
    }
    // Bind event handler
    function on(element, events = "", callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, true, passive, capture);
    }
    // Unbind event handler
    function off(element, events = "", callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, false, passive, capture);
    }
    // Bind once-only event handler
    function once(element, events = "", callback, passive = true, capture = false) {
        const onceCallback = (...args)=>{
            off(element, events, onceCallback, passive, capture);
            callback.apply(this, args);
        };
        toggleListener.call(this, element, events, onceCallback, true, passive, capture);
    }
    // Trigger event
    function triggerEvent(element, type = "", bubbles = false, detail = {}) {
        // Bail if no element
        if (!is.element(element) || is.empty(type)) return;
        // Create and dispatch the event
        const event = new CustomEvent(type, {
            bubbles: bubbles,
            detail: {
                ...detail,
                plyr: this
            }
        });
        // Dispatch the event
        element.dispatchEvent(event);
    }
    // Unbind all cached event listeners
    function unbindListeners() {
        if (this && this.eventListeners) {
            this.eventListeners.forEach((item)=>{
                const { element: element, type: type, callback: callback, options: options } = item;
                element.removeEventListener(type, callback, options);
            });
            this.eventListeners = [];
        }
    }
    // Run method when / if player is ready
    function ready() {
        return new Promise((resolve)=>this.ready ? setTimeout(resolve, 0) : on.call(this, this.elements.container, "ready", resolve)).then(()=>{});
    }
    /**
   * Silence a Promise-like object.
   * This is useful for avoiding non-harmful, but potentially confusing "uncaught
   * play promise" rejection error messages.
   * @param  {Object} value An object that may or may not be `Promise`-like.
   */ function silencePromise(value) {
        if (is.promise(value)) value.then(null, ()=>{});
    }
    // ==========================================================================
    // Remove duplicates in an array
    function dedupe(array) {
        if (!is.array(array)) return array;
        return array.filter((item, index)=>array.indexOf(item) === index);
    }
    // Get the closest value in an array
    function closest(array, value) {
        if (!is.array(array) || !array.length) return null;
        return array.reduce((prev, curr)=>Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    }
    // ==========================================================================
    // Check support for a CSS declaration
    function supportsCSS(declaration) {
        if (!window || !window.CSS) return false;
        return window.CSS.supports(declaration);
    }
    // Standard/common aspect ratios
    const standardRatios = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((out, [x, y])=>({
            ...out,
            [x / y]: [
                x,
                y
            ]
        }), {});
    // Validate an aspect ratio
    function validateAspectRatio(input) {
        if (!is.array(input) && (!is.string(input) || !input.includes(":"))) return false;
        const ratio = is.array(input) ? input : input.split(":");
        return ratio.map(Number).every(is.number);
    }
    // Reduce an aspect ratio to it's lowest form
    function reduceAspectRatio(ratio) {
        if (!is.array(ratio) || !ratio.every(is.number)) return null;
        const [width, height] = ratio;
        const getDivider = (w, h)=>h === 0 ? w : getDivider(h, w % h);
        const divider = getDivider(width, height);
        return [
            width / divider,
            height / divider
        ];
    }
    // Calculate an aspect ratio
    function getAspectRatio(input) {
        const parse = (ratio)=>validateAspectRatio(ratio) ? ratio.split(":").map(Number) : null;
        // Try provided ratio
        let ratio = parse(input);
        // Get from config
        if (ratio === null) ratio = parse(this.config.ratio);
        // Get from embed
        if (ratio === null && !is.empty(this.embed) && is.array(this.embed.ratio)) ({ ratio: ratio } = this.embed);
        // Get from HTML5 video
        if (ratio === null && this.isHTML5) {
            const { videoWidth: videoWidth, videoHeight: videoHeight } = this.media;
            ratio = [
                videoWidth,
                videoHeight
            ];
        }
        return reduceAspectRatio(ratio);
    }
    // Set aspect ratio for responsive container
    function setAspectRatio(input) {
        if (!this.isVideo) return {};
        const { wrapper: wrapper } = this.elements;
        const ratio = getAspectRatio.call(this, input);
        if (!is.array(ratio)) return {};
        const [x, y] = reduceAspectRatio(ratio);
        const useNative = supportsCSS(`aspect-ratio: ${x}/${y}`);
        const padding = 100 / x * y;
        if (useNative) wrapper.style.aspectRatio = `${x}/${y}`;
        else wrapper.style.paddingBottom = `${padding}%`;
        // For Vimeo we have an extra <div> to hide the standard controls and UI
        if (this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const height = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10);
            const offset = (height - padding) / (height / 50);
            if (this.fullscreen.active) wrapper.style.paddingBottom = null;
            else this.media.style.transform = `translateY(-${offset}%)`;
        } else if (this.isHTML5) wrapper.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: padding,
            ratio: ratio
        };
    }
    // Round an aspect ratio to closest standard ratio
    function roundAspectRatio(x, y, tolerance = 0.05) {
        const ratio = x / y;
        const closestRatio = closest(Object.keys(standardRatios), ratio);
        // Check match is within tolerance
        if (Math.abs(closestRatio - ratio) <= tolerance) return standardRatios[closestRatio];
        // No match
        return [
            x,
            y
        ];
    }
    // Get the size of the viewport
    // https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
    function getViewportSize() {
        const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        return [
            width,
            height
        ];
    }
    // ==========================================================================
    const html5 = {
        getSources () {
            if (!this.isHTML5) return [];
            const sources = Array.from(this.media.querySelectorAll("source"));
            // Filter out unsupported sources (if type is specified)
            return sources.filter((source)=>{
                const type = source.getAttribute("type");
                if (is.empty(type)) return true;
                return support.mime.call(this, type);
            });
        },
        // Get quality levels
        getQualityOptions () {
            // Whether we're forcing all options (e.g. for streaming)
            if (this.config.quality.forced) return this.config.quality.options;
            // Get sizes from <source> elements
            return html5.getSources.call(this).map((source)=>Number(source.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const player = this;
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set aspect ratio if fixed
            if (!is.empty(this.config.ratio)) setAspectRatio.call(player);
            // Quality
            Object.defineProperty(player.media, "quality", {
                get () {
                    // Get sources
                    const sources = html5.getSources.call(player);
                    const source = sources.find((s)=>s.getAttribute("src") === player.source);
                    // Return size, if match is found
                    return source && Number(source.getAttribute("size"));
                },
                set (input) {
                    if (player.quality === input) return;
                    // If we're using an external handler...
                    if (player.config.quality.forced && is.function(player.config.quality.onChange)) player.config.quality.onChange(input);
                    else {
                        // Get sources
                        const sources = html5.getSources.call(player);
                        // Get first match for requested size
                        const source = sources.find((s)=>Number(s.getAttribute("size")) === input);
                        // No matching source found
                        if (!source) return;
                        // Get current state
                        const { currentTime: currentTime, paused: paused, preload: preload, readyState: readyState, playbackRate: playbackRate } = player.media;
                        // Set new source
                        player.media.src = source.getAttribute("src");
                        // Prevent loading if preload="none" and the current source isn't loaded (#1044)
                        if (preload !== "none" || readyState) {
                            // Restore time
                            player.once("loadedmetadata", ()=>{
                                player.speed = playbackRate;
                                player.currentTime = currentTime;
                                // Resume playing
                                if (!paused) silencePromise(player.play());
                            });
                            // Load new source
                            player.media.load();
                        }
                    }
                    // Trigger change event
                    triggerEvent.call(player, player.media, "qualitychange", false, {
                        quality: input
                    });
                }
            });
        },
        // Cancel current network requests
        // See https://github.com/sampotts/plyr/issues/174
        cancelRequests () {
            if (!this.isHTML5) return;
            // Remove child sources
            removeElement(html5.getSources.call(this));
            // Set blank video src attribute
            // This is to prevent a MEDIA_ERR_SRC_NOT_SUPPORTED error
            // Info: http://stackoverflow.com/questions/32231579/how-to-properly-dispose-of-an-html5-video-and-close-socket-or-connection
            this.media.setAttribute("src", this.config.blankVideo);
            // Load the new empty source
            // This will cancel existing requests
            // See https://github.com/sampotts/plyr/issues/174
            this.media.load();
            // Debugging
            this.debug.log("Cancelled network requests");
        }
    };
    // ==========================================================================
    // Generate a random ID
    function generateId(prefix) {
        return `${prefix}-${Math.floor(Math.random() * 10000)}`;
    }
    // Format string
    function format(input, ...args) {
        if (is.empty(input)) return input;
        return input.toString().replace(/{(\d+)}/g, (match, i)=>args[i].toString());
    }
    // Get percentage
    function getPercentage(current, max) {
        if (current === 0 || max === 0 || Number.isNaN(current) || Number.isNaN(max)) return 0;
        return (current / max * 100).toFixed(2);
    }
    // Replace all occurrences of a string in a string
    const replaceAll = (input = "", find = "", replace = "")=>input.replace(new RegExp(find.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), replace.toString());
    // Convert to title case
    const toTitleCase = (input = "")=>input.toString().replace(/\w\S*/g, (text)=>text.charAt(0).toUpperCase() + text.slice(1).toLowerCase());
    // Convert string to pascalCase
    function toPascalCase(input = "") {
        let string = input.toString();
        // Convert kebab case
        string = replaceAll(string, "-", " ");
        // Convert snake case
        string = replaceAll(string, "_", " ");
        // Convert to title case
        string = toTitleCase(string);
        // Convert to pascal case
        return replaceAll(string, " ", "");
    }
    // Convert string to pascalCase
    function toCamelCase(input = "") {
        let string = input.toString();
        // Convert to pascal case
        string = toPascalCase(string);
        // Convert first character to lowercase
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    // Remove HTML from a string
    function stripHTML(source) {
        const fragment = document.createDocumentFragment();
        const element = document.createElement("div");
        fragment.appendChild(element);
        element.innerHTML = source;
        return fragment.firstChild.innerText;
    }
    // Like outerHTML, but also works for DocumentFragment
    function getHTML(element) {
        const wrapper = document.createElement("div");
        wrapper.appendChild(element);
        return wrapper.innerHTML;
    }
    // ==========================================================================
    // Skip i18n for abbreviations and brand names
    const resources = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    };
    const i18n = {
        get (key = "", config = {}) {
            if (is.empty(key) || is.empty(config)) return "";
            let string = getDeep(config.i18n, key);
            if (is.empty(string)) {
                if (Object.keys(resources).includes(key)) return resources[key];
                return "";
            }
            const replace = {
                "{seektime}": config.seekTime,
                "{title}": config.title
            };
            Object.entries(replace).forEach(([k, v])=>{
                string = replaceAll(string, k, v);
            });
            return string;
        }
    };
    class Storage {
        constructor(player){
            _defineProperty$1(this, "get", (key)=>{
                if (!Storage.supported || !this.enabled) return null;
                const store = window.localStorage.getItem(this.key);
                if (is.empty(store)) return null;
                const json = JSON.parse(store);
                return is.string(key) && key.length ? json[key] : json;
            });
            _defineProperty$1(this, "set", (object)=>{
                // Bail if we don't have localStorage support or it's disabled
                if (!Storage.supported || !this.enabled) return;
                // Can only store objectst
                if (!is.object(object)) return;
                // Get current storage
                let storage = this.get();
                // Default to empty object
                if (is.empty(storage)) storage = {};
                // Update the working copy of the values
                extend(storage, object);
                // Update storage
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(storage));
                } catch (_) {
                // Do nothing
                }
            });
            this.enabled = player.config.storage.enabled;
            this.key = player.config.storage.key;
        }
        // Check for actual support (see if we can use it)
        static get supported() {
            try {
                if (!("localStorage" in window)) return false;
                const test = "___test";
                // Try to use it (it might be disabled, e.g. user is in private mode)
                // see: https://github.com/sampotts/plyr/issues/131
                window.localStorage.setItem(test, test);
                window.localStorage.removeItem(test);
                return true;
            } catch (_) {
                return false;
            }
        }
    }
    // ==========================================================================
    // Fetch wrapper
    // Using XHR to avoid issues with older browsers
    // ==========================================================================
    function fetch(url, responseType = "text") {
        return new Promise((resolve, reject)=>{
            try {
                const request = new XMLHttpRequest();
                // Check for CORS support
                if (!("withCredentials" in request)) return;
                request.addEventListener("load", ()=>{
                    if (responseType === "text") try {
                        resolve(JSON.parse(request.responseText));
                    } catch (_) {
                        resolve(request.responseText);
                    }
                    else resolve(request.response);
                });
                request.addEventListener("error", ()=>{
                    throw new Error(request.status);
                });
                request.open("GET", url, true);
                // Set the required response type
                request.responseType = responseType;
                request.send();
            } catch (error) {
                reject(error);
            }
        });
    }
    // ==========================================================================
    // Load an external SVG sprite
    function loadSprite(url, id) {
        if (!is.string(url)) return;
        const prefix = "cache";
        const hasId = is.string(id);
        let isCached = false;
        const exists = ()=>document.getElementById(id) !== null;
        const update = (container, data)=>{
            // eslint-disable-next-line no-param-reassign
            container.innerHTML = data;
            // Check again incase of race condition
            if (hasId && exists()) return;
            // Inject the SVG to the body
            document.body.insertAdjacentElement("afterbegin", container);
        };
        // Only load once if ID set
        if (!hasId || !exists()) {
            const useStorage = Storage.supported;
            // Create container
            const container = document.createElement("div");
            container.setAttribute("hidden", "");
            if (hasId) container.setAttribute("id", id);
            // Check in cache
            if (useStorage) {
                const cached = window.localStorage.getItem(`${prefix}-${id}`);
                isCached = cached !== null;
                if (isCached) {
                    const data = JSON.parse(cached);
                    update(container, data.content);
                }
            }
            // Get the sprite
            fetch(url).then((result)=>{
                if (is.empty(result)) return;
                if (useStorage) try {
                    window.localStorage.setItem(`${prefix}-${id}`, JSON.stringify({
                        content: result
                    }));
                } catch (_) {
                // Do nothing
                }
                update(container, result);
            }).catch(()=>{});
        }
    }
    // ==========================================================================
    // Time helpers
    const getHours = (value)=>Math.trunc(value / 60 / 60 % 60, 10);
    const getMinutes = (value)=>Math.trunc(value / 60 % 60, 10);
    const getSeconds = (value)=>Math.trunc(value % 60, 10);
    // Format time to UI friendly string
    function formatTime(time = 0, displayHours = false, inverted = false) {
        // Bail if the value isn't a number
        if (!is.number(time)) return formatTime(undefined, displayHours, inverted);
        // Format time component to add leading zero
        const format = (value)=>`0${value}`.slice(-2);
        // Breakdown to hours, mins, secs
        let hours = getHours(time);
        const mins = getMinutes(time);
        const secs = getSeconds(time);
        // Do we need to display hours?
        if (displayHours || hours > 0) hours = `${hours}:`;
        else hours = "";
        // Render
        return `${inverted && time > 0 ? "-" : ""}${hours}${format(mins)}:${format(secs)}`;
    }
    // ==========================================================================
    // TODO: Don't export a massive object - break down and create class
    const controls = {
        // Get icon URL
        getIconUrl () {
            const url = new URL(this.config.iconUrl, window.location);
            const host = window.location.host ? window.location.host : window.top.location.host;
            const cors = url.host !== host || browser.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: cors
            };
        },
        // Find the UI controls
        findElements () {
            try {
                this.elements.controls = getElement.call(this, this.config.selectors.controls.wrapper);
                // Buttons
                this.elements.buttons = {
                    play: getElements.call(this, this.config.selectors.buttons.play),
                    pause: getElement.call(this, this.config.selectors.buttons.pause),
                    restart: getElement.call(this, this.config.selectors.buttons.restart),
                    rewind: getElement.call(this, this.config.selectors.buttons.rewind),
                    fastForward: getElement.call(this, this.config.selectors.buttons.fastForward),
                    mute: getElement.call(this, this.config.selectors.buttons.mute),
                    pip: getElement.call(this, this.config.selectors.buttons.pip),
                    airplay: getElement.call(this, this.config.selectors.buttons.airplay),
                    settings: getElement.call(this, this.config.selectors.buttons.settings),
                    captions: getElement.call(this, this.config.selectors.buttons.captions),
                    fullscreen: getElement.call(this, this.config.selectors.buttons.fullscreen)
                };
                // Progress
                this.elements.progress = getElement.call(this, this.config.selectors.progress);
                // Inputs
                this.elements.inputs = {
                    seek: getElement.call(this, this.config.selectors.inputs.seek),
                    volume: getElement.call(this, this.config.selectors.inputs.volume)
                };
                // Display
                this.elements.display = {
                    buffer: getElement.call(this, this.config.selectors.display.buffer),
                    currentTime: getElement.call(this, this.config.selectors.display.currentTime),
                    duration: getElement.call(this, this.config.selectors.display.duration)
                };
                // Seek tooltip
                if (is.element(this.elements.progress)) this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`);
                return true;
            } catch (error) {
                // Log it
                this.debug.warn("It looks like there is a problem with your custom controls HTML", error);
                // Restore native video controls
                this.toggleNativeControls(true);
                return false;
            }
        },
        // Create <svg> icon
        createIcon (type, attributes) {
            const namespace = "http://www.w3.org/2000/svg";
            const iconUrl = controls.getIconUrl.call(this);
            const iconPath = `${!iconUrl.cors ? iconUrl.url : ""}#${this.config.iconPrefix}`;
            // Create <svg>
            const icon = document.createElementNS(namespace, "svg");
            setAttributes(icon, extend(attributes, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            // Create the <use> to reference sprite
            const use = document.createElementNS(namespace, "use");
            const path = `${iconPath}-${type}`;
            // Set `href` attributes
            // https://github.com/sampotts/plyr/issues/460
            // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
            if ("href" in use) use.setAttributeNS("http://www.w3.org/1999/xlink", "href", path);
            // Always set the older attribute even though it's "deprecated" (it'll be around for ages)
            use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", path);
            // Add <use> to <svg>
            icon.appendChild(use);
            return icon;
        },
        // Create hidden text label
        createLabel (key, attr = {}) {
            const text = i18n.get(key, this.config);
            const attributes = {
                ...attr,
                class: [
                    attr.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            };
            return createElement("span", attributes, text);
        },
        // Create a badge
        createBadge (text) {
            if (is.empty(text)) return null;
            const badge = createElement("span", {
                class: this.config.classNames.menu.value
            });
            badge.appendChild(createElement("span", {
                class: this.config.classNames.menu.badge
            }, text));
            return badge;
        },
        // Create a <button>
        createButton (buttonType, attr) {
            const attributes = extend({}, attr);
            let type = toCamelCase(buttonType);
            const props = {
                element: "button",
                toggle: false,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            [
                "element",
                "icon",
                "label"
            ].forEach((key)=>{
                if (Object.keys(attributes).includes(key)) {
                    props[key] = attributes[key];
                    delete attributes[key];
                }
            });
            // Default to 'button' type to prevent form submission
            if (props.element === "button" && !Object.keys(attributes).includes("type")) attributes.type = "button";
            // Set class name
            if (Object.keys(attributes).includes("class")) {
                if (!attributes.class.split(" ").some((c)=>c === this.config.classNames.control)) extend(attributes, {
                    class: `${attributes.class} ${this.config.classNames.control}`
                });
            } else attributes.class = this.config.classNames.control;
            // Large play button
            switch(buttonType){
                case "play":
                    props.toggle = true;
                    props.label = "play";
                    props.labelPressed = "pause";
                    props.icon = "play";
                    props.iconPressed = "pause";
                    break;
                case "mute":
                    props.toggle = true;
                    props.label = "mute";
                    props.labelPressed = "unmute";
                    props.icon = "volume";
                    props.iconPressed = "muted";
                    break;
                case "captions":
                    props.toggle = true;
                    props.label = "enableCaptions";
                    props.labelPressed = "disableCaptions";
                    props.icon = "captions-off";
                    props.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    props.toggle = true;
                    props.label = "enterFullscreen";
                    props.labelPressed = "exitFullscreen";
                    props.icon = "enter-fullscreen";
                    props.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    attributes.class += ` ${this.config.classNames.control}--overlaid`;
                    type = "play";
                    props.label = "play";
                    props.icon = "play";
                    break;
                default:
                    if (is.empty(props.label)) props.label = type;
                    if (is.empty(props.icon)) props.icon = buttonType;
            }
            const button = createElement(props.element);
            // Setup toggle icon and labels
            if (props.toggle) {
                // Icon
                button.appendChild(controls.createIcon.call(this, props.iconPressed, {
                    class: "icon--pressed"
                }));
                button.appendChild(controls.createIcon.call(this, props.icon, {
                    class: "icon--not-pressed"
                }));
                // Label/Tooltip
                button.appendChild(controls.createLabel.call(this, props.labelPressed, {
                    class: "label--pressed"
                }));
                button.appendChild(controls.createLabel.call(this, props.label, {
                    class: "label--not-pressed"
                }));
            } else {
                button.appendChild(controls.createIcon.call(this, props.icon));
                button.appendChild(controls.createLabel.call(this, props.label));
            }
            // Merge and set attributes
            extend(attributes, getAttributesFromSelector(this.config.selectors.buttons[type], attributes));
            setAttributes(button, attributes);
            // We have multiple play buttons
            if (type === "play") {
                if (!is.array(this.elements.buttons[type])) this.elements.buttons[type] = [];
                this.elements.buttons[type].push(button);
            } else this.elements.buttons[type] = button;
            return button;
        },
        // Create an <input type='range'>
        createRange (type, attributes) {
            // Seek input
            const input = createElement("input", extend(getAttributesFromSelector(this.config.selectors.inputs[type]), {
                type: "range",
                min: 0,
                max: 100,
                step: 0.01,
                value: 0,
                autocomplete: "off",
                // A11y fixes for https://github.com/sampotts/plyr/issues/905
                role: "slider",
                "aria-label": i18n.get(type, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, attributes));
            this.elements.inputs[type] = input;
            // Set the fill for webkit now
            controls.updateRangeFill.call(this, input);
            // Improve support on touch devices
            RangeTouch.setup(input);
            return input;
        },
        // Create a <progress>
        createProgress (type, attributes) {
            const progress = createElement("progress", extend(getAttributesFromSelector(this.config.selectors.display[type]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": true
            }, attributes));
            // Create the label inside
            if (type !== "volume") {
                progress.appendChild(createElement("span", null, "0"));
                const suffixKey = {
                    played: "played",
                    buffer: "buffered"
                }[type];
                const suffix = suffixKey ? i18n.get(suffixKey, this.config) : "";
                progress.innerText = `% ${suffix.toLowerCase()}`;
            }
            this.elements.display[type] = progress;
            return progress;
        },
        // Create time display
        createTime (type, attrs) {
            const attributes = getAttributesFromSelector(this.config.selectors.display[type], attrs);
            const container = createElement("div", extend(attributes, {
                class: `${attributes.class ? attributes.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": i18n.get(type, this.config)
            }), "00:00");
            // Reference for updates
            this.elements.display[type] = container;
            return container;
        },
        // Bind keyboard shortcuts for a menu item
        // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        bindMenuItemShortcuts (menuItem, type) {
            // Navigate through menus via arrow keys and space
            on.call(this, menuItem, "keydown keyup", (event)=>{
                // We only care about space and ⬆️ ⬇️️ ➡️
                if (![
                    "Space",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(event.key)) return;
                // Prevent play / seek
                event.preventDefault();
                event.stopPropagation();
                // We're just here to prevent the keydown bubbling
                if (event.type === "keydown") return;
                const isRadioButton = matches(menuItem, '[role="menuitemradio"]');
                // Show the respective menu
                if (!isRadioButton && [
                    "Space",
                    "ArrowRight"
                ].includes(event.key)) controls.showMenuPanel.call(this, type, true);
                else {
                    let target;
                    if (event.key !== "Space") {
                        if (event.key === "ArrowDown" || isRadioButton && event.key === "ArrowRight") {
                            target = menuItem.nextElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.firstElementChild;
                        } else {
                            target = menuItem.previousElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.lastElementChild;
                        }
                        setFocus.call(this, target, true);
                    }
                }
            }, false);
            // Enter will fire a `click` event but we still need to manage focus
            // So we bind to keyup which fires after and set focus here
            on.call(this, menuItem, "keyup", (event)=>{
                if (event.key !== "Return") return;
                controls.focusFirstMenuItem.call(this, null, true);
            });
        },
        // Create a settings menu item
        createMenuItem ({ value: value, list: list, type: type, title: title, badge: badge = null, checked: checked = false }) {
            const attributes = getAttributesFromSelector(this.config.selectors.inputs[type]);
            const menuItem = createElement("button", extend(attributes, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${attributes.class ? attributes.class : ""}`.trim(),
                "aria-checked": checked,
                value: value
            }));
            const flex = createElement("span");
            // We have to set as HTML incase of special characters
            flex.innerHTML = title;
            if (is.element(badge)) flex.appendChild(badge);
            menuItem.appendChild(flex);
            // Replicate radio button behavior
            Object.defineProperty(menuItem, "checked", {
                enumerable: true,
                get () {
                    return menuItem.getAttribute("aria-checked") === "true";
                },
                set (check) {
                    // Ensure exclusivity
                    if (check) Array.from(menuItem.parentNode.children).filter((node)=>matches(node, '[role="menuitemradio"]')).forEach((node)=>node.setAttribute("aria-checked", "false"));
                    menuItem.setAttribute("aria-checked", check ? "true" : "false");
                }
            });
            this.listeners.bind(menuItem, "click keyup", (event)=>{
                if (is.keyboardEvent(event) && event.key !== "Space") return;
                event.preventDefault();
                event.stopPropagation();
                menuItem.checked = true;
                switch(type){
                    case "language":
                        this.currentTrack = Number(value);
                        break;
                    case "quality":
                        this.quality = value;
                        break;
                    case "speed":
                        this.speed = parseFloat(value);
                        break;
                }
                controls.showMenuPanel.call(this, "home", is.keyboardEvent(event));
            }, type, false);
            controls.bindMenuItemShortcuts.call(this, menuItem, type);
            list.appendChild(menuItem);
        },
        // Format a time for display
        formatTime (time = 0, inverted = false) {
            // Bail if the value isn't a number
            if (!is.number(time)) return time;
            // Always display hours if duration is over an hour
            const forceHours = getHours(this.duration) > 0;
            return formatTime(time, forceHours, inverted);
        },
        // Update the displayed time
        updateTimeDisplay (target = null, time = 0, inverted = false) {
            // Bail if there's no element to display or the value isn't a number
            if (!is.element(target) || !is.number(time)) return;
            // eslint-disable-next-line no-param-reassign
            target.innerText = controls.formatTime(time, inverted);
        },
        // Update volume UI and storage
        updateVolume () {
            if (!this.supported.ui) return;
            // Update range
            if (is.element(this.elements.inputs.volume)) controls.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume);
            // Update mute state
            if (is.element(this.elements.buttons.mute)) this.elements.buttons.mute.pressed = this.muted || this.volume === 0;
        },
        // Update seek value and lower fill
        setRange (target, value = 0) {
            if (!is.element(target)) return;
            // eslint-disable-next-line
            target.value = value;
            // Webkit range fill
            controls.updateRangeFill.call(this, target);
        },
        // Update <progress> elements
        updateProgress (event) {
            if (!this.supported.ui || !is.event(event)) return;
            let value = 0;
            const setProgress = (target, input)=>{
                const val = is.number(input) ? input : 0;
                const progress = is.element(target) ? target : this.elements.display.buffer;
                // Update value and label
                if (is.element(progress)) {
                    progress.value = val;
                    // Update text label inside
                    const label = progress.getElementsByTagName("span")[0];
                    if (is.element(label)) label.childNodes[0].nodeValue = val;
                }
            };
            if (event) switch(event.type){
                // Video playing
                case "timeupdate":
                case "seeking":
                case "seeked":
                    value = getPercentage(this.currentTime, this.duration);
                    // Set seek range value only if it's a 'natural' time event
                    if (event.type === "timeupdate") controls.setRange.call(this, this.elements.inputs.seek, value);
                    break;
                // Check buffer status
                case "playing":
                case "progress":
                    setProgress(this.elements.display.buffer, this.buffered * 100);
                    break;
            }
        },
        // Webkit polyfill for lower fill range
        updateRangeFill (target) {
            // Get range from event if event passed
            const range = is.event(target) ? target.target : target;
            // Needs to be a valid <input type='range'>
            if (!is.element(range) || range.getAttribute("type") !== "range") return;
            // Set aria values for https://github.com/sampotts/plyr/issues/905
            if (matches(range, this.config.selectors.inputs.seek)) {
                range.setAttribute("aria-valuenow", this.currentTime);
                const currentTime = controls.formatTime(this.currentTime);
                const duration = controls.formatTime(this.duration);
                const format = i18n.get("seekLabel", this.config);
                range.setAttribute("aria-valuetext", format.replace("{currentTime}", currentTime).replace("{duration}", duration));
            } else if (matches(range, this.config.selectors.inputs.volume)) {
                const percent = range.value * 100;
                range.setAttribute("aria-valuenow", percent);
                range.setAttribute("aria-valuetext", `${percent.toFixed(1)}%`);
            } else range.setAttribute("aria-valuenow", range.value);
            // WebKit only
            if (!browser.isWebkit) return;
            // Set CSS custom property
            range.style.setProperty("--value", `${range.value / range.max * 100}%`);
        },
        // Update hover tooltip for seeking
        updateSeekTooltip (event) {
            var _this$config$markers, _this$config$markers$;
            // Bail if setting not true
            if (!this.config.tooltips.seek || !is.element(this.elements.inputs.seek) || !is.element(this.elements.display.seekTooltip) || this.duration === 0) return;
            const tipElement = this.elements.display.seekTooltip;
            const visible = `${this.config.classNames.tooltip}--visible`;
            const toggle = (show)=>toggleClass(tipElement, visible, show);
            // Hide on touch
            if (this.touch) {
                toggle(false);
                return;
            }
            // Determine percentage, if already visible
            let percent = 0;
            const clientRect = this.elements.progress.getBoundingClientRect();
            if (is.event(event)) percent = 100 / clientRect.width * (event.pageX - clientRect.left);
            else if (hasClass(tipElement, visible)) percent = parseFloat(tipElement.style.left, 10);
            else return;
            // Set bounds
            if (percent < 0) percent = 0;
            else if (percent > 100) percent = 100;
            const time = this.duration / 100 * percent;
            // Display the time a click would seek to
            tipElement.innerText = controls.formatTime(time);
            // Get marker point for time
            const point = (_this$config$markers = this.config.markers) === null || _this$config$markers === void 0 ? void 0 : (_this$config$markers$ = _this$config$markers.points) === null || _this$config$markers$ === void 0 ? void 0 : _this$config$markers$.find(({ time: t })=>t === Math.round(time));
            // Append the point label to the tooltip
            if (point) tipElement.insertAdjacentHTML("afterbegin", `${point.label}<br>`);
            // Set position
            tipElement.style.left = `${percent}%`;
            // Show/hide the tooltip
            // If the event is a moues in/out and percentage is inside bounds
            if (is.event(event) && [
                "mouseenter",
                "mouseleave"
            ].includes(event.type)) toggle(event.type === "mouseenter");
        },
        // Handle time change event
        timeUpdate (event) {
            // Only invert if only one time element is displayed and used for both duration and currentTime
            const invert = !is.element(this.elements.display.duration) && this.config.invertTime;
            // Duration
            controls.updateTimeDisplay.call(this, this.elements.display.currentTime, invert ? this.duration - this.currentTime : this.currentTime, invert);
            // Ignore updates while seeking
            if (event && event.type === "timeupdate" && this.media.seeking) return;
            // Playing progress
            controls.updateProgress.call(this, event);
        },
        // Show the duration on metadataloaded or durationchange events
        durationUpdate () {
            // Bail if no UI or durationchange event triggered after playing/seek when invertTime is false
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            // If duration is the 2**32 (shaka), Infinity (HLS), DASH-IF (Number.MAX_SAFE_INTEGER || Number.MAX_VALUE) indicating live we hide the currentTime and progressbar.
            // https://github.com/video-dev/hls.js/blob/5820d29d3c4c8a46e8b75f1e3afa3e68c1a9a2db/src/controller/buffer-controller.js#L415
            // https://github.com/google/shaka-player/blob/4d889054631f4e1cf0fbd80ddd2b71887c02e232/lib/media/streaming_engine.js#L1062
            // https://github.com/Dash-Industry-Forum/dash.js/blob/69859f51b969645b234666800d4cb596d89c602d/src/dash/models/DashManifestModel.js#L338
            if (this.duration >= 2 ** 32) {
                toggleHidden(this.elements.display.currentTime, true);
                toggleHidden(this.elements.progress, true);
                return;
            }
            // Update ARIA values
            if (is.element(this.elements.inputs.seek)) this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            // If there's a spot to display duration
            const hasDuration = is.element(this.elements.display.duration);
            // If there's only one time display, display duration there
            if (!hasDuration && this.config.displayDuration && this.paused) controls.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration);
            // If there's a duration element, update content
            if (hasDuration) controls.updateTimeDisplay.call(this, this.elements.display.duration, this.duration);
            if (this.config.markers.enabled) controls.setMarkers.call(this);
            // Update the tooltip (if visible)
            controls.updateSeekTooltip.call(this);
        },
        // Hide/show a tab
        toggleMenuButton (setting, toggle) {
            toggleHidden(this.elements.settings.buttons[setting], !toggle);
        },
        // Update the selected setting
        updateSetting (setting, container, input) {
            const pane = this.elements.settings.panels[setting];
            let value = null;
            let list = container;
            if (setting === "captions") value = this.currentTrack;
            else {
                value = !is.empty(input) ? input : this[setting];
                // Get default
                if (is.empty(value)) value = this.config[setting].default;
                // Unsupported value
                if (!is.empty(this.options[setting]) && !this.options[setting].includes(value)) {
                    this.debug.warn(`Unsupported value of '${value}' for ${setting}`);
                    return;
                }
                // Disabled value
                if (!this.config[setting].options.includes(value)) {
                    this.debug.warn(`Disabled value of '${value}' for ${setting}`);
                    return;
                }
            }
            // Get the list if we need to
            if (!is.element(list)) list = pane && pane.querySelector('[role="menu"]');
            // If there's no list it means it's not been rendered...
            if (!is.element(list)) return;
            // Update the label
            const label = this.elements.settings.buttons[setting].querySelector(`.${this.config.classNames.menu.value}`);
            label.innerHTML = controls.getLabel.call(this, setting, value);
            // Find the radio option and check it
            const target = list && list.querySelector(`[value="${value}"]`);
            if (is.element(target)) target.checked = true;
        },
        // Translate a value into a nice label
        getLabel (setting, value) {
            switch(setting){
                case "speed":
                    return value === 1 ? i18n.get("normal", this.config) : `${value}&times;`;
                case "quality":
                    if (is.number(value)) {
                        const label = i18n.get(`qualityLabel.${value}`, this.config);
                        if (!label.length) return `${value}p`;
                        return label;
                    }
                    return toTitleCase(value);
                case "captions":
                    return captions.getLabel.call(this);
                default:
                    return null;
            }
        },
        // Set the quality menu
        setQualityMenu (options) {
            // Menu required
            if (!is.element(this.elements.settings.panels.quality)) return;
            const type = "quality";
            const list = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            // Set options if passed and filter based on uniqueness and config
            if (is.array(options)) this.options.quality = dedupe(options).filter((quality)=>this.config.quality.options.includes(quality));
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.quality) && this.options.quality.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Get the badge HTML for HD, 4K etc
            const getBadge = (quality)=>{
                const label = i18n.get(`qualityBadge.${quality}`, this.config);
                if (!label.length) return null;
                return controls.createBadge.call(this, label);
            };
            // Sort options by the config and then render options
            this.options.quality.sort((a, b)=>{
                const sorting = this.config.quality.options;
                return sorting.indexOf(a) > sorting.indexOf(b) ? 1 : -1;
            }).forEach((quality)=>{
                controls.createMenuItem.call(this, {
                    value: quality,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, "quality", quality),
                    badge: getBadge(quality)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Set the looping options
        /* setLoopMenu() {
          // Menu required
          if (!is.element(this.elements.settings.panels.loop)) {
              return;
          }
           const options = ['start', 'end', 'all', 'reset'];
          const list = this.elements.settings.panels.loop.querySelector('[role="menu"]');
           // Show the pane and tab
          toggleHidden(this.elements.settings.buttons.loop, false);
          toggleHidden(this.elements.settings.panels.loop, false);
           // Toggle the pane and tab
          const toggle = !is.empty(this.loop.options);
          controls.toggleMenuButton.call(this, 'loop', toggle);
           // Empty the menu
          emptyElement(list);
           options.forEach(option => {
              const item = createElement('li');
               const button = createElement(
                  'button',
                  extend(getAttributesFromSelector(this.config.selectors.buttons.loop), {
                      type: 'button',
                      class: this.config.classNames.control,
                      'data-plyr-loop-action': option,
                  }),
                  i18n.get(option, this.config)
              );
               if (['start', 'end'].includes(option)) {
                  const badge = controls.createBadge.call(this, '00:00');
                  button.appendChild(badge);
              }
               item.appendChild(button);
              list.appendChild(item);
          });
      }, */ // Get current selected caption language
        // TODO: rework this to user the getter in the API?
        // Set a list of available captions languages
        setCaptionsMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.captions)) return;
            // TODO: Captions or language? Currently it's mixed
            const type = "captions";
            const list = this.elements.settings.panels.captions.querySelector('[role="menu"]');
            const tracks = captions.getTracks.call(this);
            const toggle = Boolean(tracks.length);
            // Toggle the pane and tab
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If there's no captions, bail
            if (!toggle) return;
            // Generate options data
            const options = tracks.map((track, value)=>({
                    value: value,
                    checked: this.captions.toggled && this.currentTrack === value,
                    title: captions.getLabel.call(this, track),
                    badge: track.language && controls.createBadge.call(this, track.language.toUpperCase()),
                    list: list,
                    type: "language"
                }));
            // Add the "Disabled" option to turn off captions
            options.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: i18n.get("disabled", this.config),
                list: list,
                type: "language"
            });
            // Generate options
            options.forEach(controls.createMenuItem.bind(this));
            controls.updateSetting.call(this, type, list);
        },
        // Set a list of available captions languages
        setSpeedMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.speed)) return;
            const type = "speed";
            const list = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            // Filter out invalid speeds
            this.options.speed = this.options.speed.filter((o)=>o >= this.minimumSpeed && o <= this.maximumSpeed);
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.speed) && this.options.speed.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Create items
            this.options.speed.forEach((speed)=>{
                controls.createMenuItem.call(this, {
                    value: speed,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, "speed", speed)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Check if we need to hide/show the settings menu
        checkMenu () {
            const { buttons: buttons } = this.elements.settings;
            const visible = !is.empty(buttons) && Object.values(buttons).some((button)=>!button.hidden);
            toggleHidden(this.elements.settings.menu, !visible);
        },
        // Focus the first menu item in a given (or visible) menu
        focusFirstMenuItem (pane, tabFocus = false) {
            if (this.elements.settings.popup.hidden) return;
            let target = pane;
            if (!is.element(target)) target = Object.values(this.elements.settings.panels).find((p)=>!p.hidden);
            const firstItem = target.querySelector('[role^="menuitem"]');
            setFocus.call(this, firstItem, tabFocus);
        },
        // Show/hide menu
        toggleMenu (input) {
            const { popup: popup } = this.elements.settings;
            const button = this.elements.buttons.settings;
            // Menu and button are required
            if (!is.element(popup) || !is.element(button)) return;
            // True toggle by default
            const { hidden: hidden } = popup;
            let show = hidden;
            if (is.boolean(input)) show = input;
            else if (is.keyboardEvent(input) && input.key === "Escape") show = false;
            else if (is.event(input)) {
                // If Plyr is in a shadowDOM, the event target is set to the component, instead of the
                // Element in the shadowDOM. The path, if available, is complete.
                const target = is.function(input.composedPath) ? input.composedPath()[0] : input.target;
                const isMenuItem = popup.contains(target);
                // If the click was inside the menu or if the click
                // wasn't the button or menu item and we're trying to
                // show the menu (a doc click shouldn't show the menu)
                if (isMenuItem || !isMenuItem && input.target !== button && show) return;
            }
            // Set button attributes
            button.setAttribute("aria-expanded", show);
            // Show the actual popup
            toggleHidden(popup, !show);
            // Add class hook
            toggleClass(this.elements.container, this.config.classNames.menu.open, show);
            // Focus the first item if key interaction
            if (show && is.keyboardEvent(input)) controls.focusFirstMenuItem.call(this, null, true);
            else if (!show && !hidden) // If closing, re-focus the button
            setFocus.call(this, button, is.keyboardEvent(input));
        },
        // Get the natural size of a menu panel
        getMenuSize (tab) {
            const clone = tab.cloneNode(true);
            clone.style.position = "absolute";
            clone.style.opacity = 0;
            clone.removeAttribute("hidden");
            // Append to parent so we get the "real" size
            tab.parentNode.appendChild(clone);
            // Get the sizes before we remove
            const width = clone.scrollWidth;
            const height = clone.scrollHeight;
            // Remove from the DOM
            removeElement(clone);
            return {
                width: width,
                height: height
            };
        },
        // Show a panel in the menu
        showMenuPanel (type = "", tabFocus = false) {
            const target = this.elements.container.querySelector(`#plyr-settings-${this.id}-${type}`);
            // Nothing to show, bail
            if (!is.element(target)) return;
            // Hide all other panels
            const container = target.parentNode;
            const current = Array.from(container.children).find((node)=>!node.hidden);
            // If we can do fancy animations, we'll animate the height/width
            if (support.transitions && !support.reducedMotion) {
                // Set the current width as a base
                container.style.width = `${current.scrollWidth}px`;
                container.style.height = `${current.scrollHeight}px`;
                // Get potential sizes
                const size = controls.getMenuSize.call(this, target);
                // Restore auto height/width
                const restore = (event)=>{
                    // We're only bothered about height and width on the container
                    if (event.target !== container || ![
                        "width",
                        "height"
                    ].includes(event.propertyName)) return;
                    // Revert back to auto
                    container.style.width = "";
                    container.style.height = "";
                    // Only listen once
                    off.call(this, container, transitionEndEvent, restore);
                };
                // Listen for the transition finishing and restore auto height/width
                on.call(this, container, transitionEndEvent, restore);
                // Set dimensions to target
                container.style.width = `${size.width}px`;
                container.style.height = `${size.height}px`;
            }
            // Set attributes on current tab
            toggleHidden(current, true);
            // Set attributes on target
            toggleHidden(target, false);
            // Focus the first item
            controls.focusFirstMenuItem.call(this, target, tabFocus);
        },
        // Set the download URL
        setDownloadUrl () {
            const button = this.elements.buttons.download;
            // Bail if no button
            if (!is.element(button)) return;
            // Set attribute
            button.setAttribute("href", this.download);
        },
        // Build the default HTML
        create (data) {
            const { bindMenuItemShortcuts: bindMenuItemShortcuts, createButton: createButton, createProgress: createProgress, createRange: createRange, createTime: createTime, setQualityMenu: setQualityMenu, setSpeedMenu: setSpeedMenu, showMenuPanel: showMenuPanel } = controls;
            this.elements.controls = null;
            // Larger overlaid play button
            if (is.array(this.config.controls) && this.config.controls.includes("play-large")) this.elements.container.appendChild(createButton.call(this, "play-large"));
            // Create the container
            const container = createElement("div", getAttributesFromSelector(this.config.selectors.controls.wrapper));
            this.elements.controls = container;
            // Default item attributes
            const defaultAttributes = {
                class: "plyr__controls__item"
            };
            // Loop through controls in order
            dedupe(is.array(this.config.controls) ? this.config.controls : []).forEach((control)=>{
                // Restart button
                if (control === "restart") container.appendChild(createButton.call(this, "restart", defaultAttributes));
                // Rewind button
                if (control === "rewind") container.appendChild(createButton.call(this, "rewind", defaultAttributes));
                // Play/Pause button
                if (control === "play") container.appendChild(createButton.call(this, "play", defaultAttributes));
                // Fast forward button
                if (control === "fast-forward") container.appendChild(createButton.call(this, "fast-forward", defaultAttributes));
                // Progress
                if (control === "progress") {
                    const progressContainer = createElement("div", {
                        class: `${defaultAttributes.class} plyr__progress__container`
                    });
                    const progress = createElement("div", getAttributesFromSelector(this.config.selectors.progress));
                    // Seek range slider
                    progress.appendChild(createRange.call(this, "seek", {
                        id: `plyr-seek-${data.id}`
                    }));
                    // Buffer progress
                    progress.appendChild(createProgress.call(this, "buffer"));
                    // TODO: Add loop display indicator
                    // Seek tooltip
                    if (this.config.tooltips.seek) {
                        const tooltip = createElement("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        progress.appendChild(tooltip);
                        this.elements.display.seekTooltip = tooltip;
                    }
                    this.elements.progress = progress;
                    progressContainer.appendChild(this.elements.progress);
                    container.appendChild(progressContainer);
                }
                // Media current time display
                if (control === "current-time") container.appendChild(createTime.call(this, "currentTime", defaultAttributes));
                // Media duration display
                if (control === "duration") container.appendChild(createTime.call(this, "duration", defaultAttributes));
                // Volume controls
                if (control === "mute" || control === "volume") {
                    let { volume: volume } = this.elements;
                    // Create the volume container if needed
                    if (!is.element(volume) || !container.contains(volume)) {
                        volume = createElement("div", extend({}, defaultAttributes, {
                            class: `${defaultAttributes.class} plyr__volume`.trim()
                        }));
                        this.elements.volume = volume;
                        container.appendChild(volume);
                    }
                    // Toggle mute button
                    if (control === "mute") volume.appendChild(createButton.call(this, "mute"));
                    // Volume range control
                    // Ignored on iOS as it's handled globally
                    // https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
                    if (control === "volume" && !browser.isIos) {
                        // Set the attributes
                        const attributes = {
                            max: 1,
                            step: 0.05,
                            value: this.config.volume
                        };
                        // Create the volume range slider
                        volume.appendChild(createRange.call(this, "volume", extend(attributes, {
                            id: `plyr-volume-${data.id}`
                        })));
                    }
                }
                // Toggle captions button
                if (control === "captions") container.appendChild(createButton.call(this, "captions", defaultAttributes));
                // Settings button / menu
                if (control === "settings" && !is.empty(this.config.settings)) {
                    const wrapper = createElement("div", extend({}, defaultAttributes, {
                        class: `${defaultAttributes.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    wrapper.appendChild(createButton.call(this, "settings", {
                        "aria-haspopup": true,
                        "aria-controls": `plyr-settings-${data.id}`,
                        "aria-expanded": false
                    }));
                    const popup = createElement("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${data.id}`,
                        hidden: ""
                    });
                    const inner = createElement("div");
                    const home = createElement("div", {
                        id: `plyr-settings-${data.id}-home`
                    });
                    // Create the menu
                    const menu = createElement("div", {
                        role: "menu"
                    });
                    home.appendChild(menu);
                    inner.appendChild(home);
                    this.elements.settings.panels.home = home;
                    // Build the menu items
                    this.config.settings.forEach((type)=>{
                        // TODO: bundle this with the createMenuItem helper and bindings
                        const menuItem = createElement("button", extend(getAttributesFromSelector(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": true,
                            hidden: ""
                        }));
                        // Bind menu shortcuts for keyboard users
                        bindMenuItemShortcuts.call(this, menuItem, type);
                        // Show menu on click
                        on.call(this, menuItem, "click", ()=>{
                            showMenuPanel.call(this, type, false);
                        });
                        const flex = createElement("span", null, i18n.get(type, this.config));
                        const value = createElement("span", {
                            class: this.config.classNames.menu.value
                        });
                        // Speed contains HTML entities
                        value.innerHTML = data[type];
                        flex.appendChild(value);
                        menuItem.appendChild(flex);
                        menu.appendChild(menuItem);
                        // Build the panes
                        const pane = createElement("div", {
                            id: `plyr-settings-${data.id}-${type}`,
                            hidden: ""
                        });
                        // Back button
                        const backButton = createElement("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        // Visible label
                        backButton.appendChild(createElement("span", {
                            "aria-hidden": true
                        }, i18n.get(type, this.config)));
                        // Screen reader label
                        backButton.appendChild(createElement("span", {
                            class: this.config.classNames.hidden
                        }, i18n.get("menuBack", this.config)));
                        // Go back via keyboard
                        on.call(this, pane, "keydown", (event)=>{
                            if (event.key !== "ArrowLeft") return;
                            // Prevent seek
                            event.preventDefault();
                            event.stopPropagation();
                            // Show the respective menu
                            showMenuPanel.call(this, "home", true);
                        }, false);
                        // Go back via button click
                        on.call(this, backButton, "click", ()=>{
                            showMenuPanel.call(this, "home", false);
                        });
                        // Add to pane
                        pane.appendChild(backButton);
                        // Menu
                        pane.appendChild(createElement("div", {
                            role: "menu"
                        }));
                        inner.appendChild(pane);
                        this.elements.settings.buttons[type] = menuItem;
                        this.elements.settings.panels[type] = pane;
                    });
                    popup.appendChild(inner);
                    wrapper.appendChild(popup);
                    container.appendChild(wrapper);
                    this.elements.settings.popup = popup;
                    this.elements.settings.menu = wrapper;
                }
                // Picture in picture button
                if (control === "pip" && support.pip) container.appendChild(createButton.call(this, "pip", defaultAttributes));
                // Airplay button
                if (control === "airplay" && support.airplay) container.appendChild(createButton.call(this, "airplay", defaultAttributes));
                // Download button
                if (control === "download") {
                    const attributes = extend({}, defaultAttributes, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    // Set download attribute for HTML5 only
                    if (this.isHTML5) attributes.download = "";
                    const { download: download } = this.config.urls;
                    if (!is.url(download) && this.isEmbed) extend(attributes, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    });
                    container.appendChild(createButton.call(this, "download", attributes));
                }
                // Toggle fullscreen button
                if (control === "fullscreen") container.appendChild(createButton.call(this, "fullscreen", defaultAttributes));
            });
            // Set available quality levels
            if (this.isHTML5) setQualityMenu.call(this, html5.getQualityOptions.call(this));
            setSpeedMenu.call(this);
            return container;
        },
        // Insert controls
        inject () {
            // Sprite
            if (this.config.loadSprite) {
                const icon = controls.getIconUrl.call(this);
                // Only load external sprite using AJAX
                if (icon.cors) loadSprite(icon.url, "sprite-plyr");
            }
            // Create a unique ID
            this.id = Math.floor(Math.random() * 10000);
            // Null by default
            let container = null;
            this.elements.controls = null;
            // Set template properties
            const props = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let update = true;
            // If function, run it and use output
            if (is.function(this.config.controls)) this.config.controls = this.config.controls.call(this, props);
            // Convert falsy controls to empty array (primarily for empty strings)
            if (!this.config.controls) this.config.controls = [];
            if (is.element(this.config.controls) || is.string(this.config.controls)) // HTMLElement or Non-empty string passed as the option
            container = this.config.controls;
            else {
                // Create controls
                container = controls.create.call(this, {
                    id: this.id,
                    seektime: this.config.seekTime,
                    speed: this.speed,
                    quality: this.quality,
                    captions: captions.getLabel.call(this)
                });
                update = false;
            }
            // Replace props with their value
            const replace = (input)=>{
                let result = input;
                Object.entries(props).forEach(([key, value])=>{
                    result = replaceAll(result, `{${key}}`, value);
                });
                return result;
            };
            // Update markup
            if (update) {
                if (is.string(this.config.controls)) container = replace(container);
            }
            // Controls container
            let target;
            // Inject to custom location
            if (is.string(this.config.selectors.controls.container)) target = document.querySelector(this.config.selectors.controls.container);
            // Inject into the container by default
            if (!is.element(target)) target = this.elements.container;
            // Inject controls HTML (needs to be before captions, hence "afterbegin")
            const insertMethod = is.element(container) ? "insertAdjacentElement" : "insertAdjacentHTML";
            target[insertMethod]("afterbegin", container);
            // Find the elements if need be
            if (!is.element(this.elements.controls)) controls.findElements.call(this);
            // Add pressed property to buttons
            if (!is.empty(this.elements.buttons)) {
                const addProperty = (button)=>{
                    const className = this.config.classNames.controlPressed;
                    button.setAttribute("aria-pressed", "false");
                    Object.defineProperty(button, "pressed", {
                        configurable: true,
                        enumerable: true,
                        get () {
                            return hasClass(button, className);
                        },
                        set (pressed = false) {
                            toggleClass(button, className, pressed);
                            button.setAttribute("aria-pressed", pressed ? "true" : "false");
                        }
                    });
                };
                // Toggle classname when pressed property is set
                Object.values(this.elements.buttons).filter(Boolean).forEach((button)=>{
                    if (is.array(button) || is.nodeList(button)) Array.from(button).filter(Boolean).forEach(addProperty);
                    else addProperty(button);
                });
            }
            // Edge sometimes doesn't finish the paint so force a repaint
            if (browser.isEdge) repaint(target);
            // Setup tooltips
            if (this.config.tooltips.controls) {
                const { classNames: classNames, selectors: selectors } = this.config;
                const selector = `${selectors.controls.wrapper} ${selectors.labels} .${classNames.hidden}`;
                const labels = getElements.call(this, selector);
                Array.from(labels).forEach((label)=>{
                    toggleClass(label, this.config.classNames.hidden, false);
                    toggleClass(label, this.config.classNames.tooltip, true);
                });
            }
        },
        // Set media metadata
        setMediaMetadata () {
            try {
                if ("mediaSession" in navigator) navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                });
            } catch (_) {
            // Do nothing
            }
        },
        // Add markers
        setMarkers () {
            var _this$config$markers2, _this$config$markers3;
            if (!this.duration || this.elements.markers) return;
            // Get valid points
            const points = (_this$config$markers2 = this.config.markers) === null || _this$config$markers2 === void 0 ? void 0 : (_this$config$markers3 = _this$config$markers2.points) === null || _this$config$markers3 === void 0 ? void 0 : _this$config$markers3.filter(({ time: time })=>time > 0 && time < this.duration);
            if (!(points !== null && points !== void 0 && points.length)) return;
            const containerFragment = document.createDocumentFragment();
            const pointsFragment = document.createDocumentFragment();
            let tipElement = null;
            const tipVisible = `${this.config.classNames.tooltip}--visible`;
            const toggleTip = (show)=>toggleClass(tipElement, tipVisible, show);
            // Inject markers to progress container
            points.forEach((point)=>{
                const markerElement = createElement("span", {
                    class: this.config.classNames.marker
                }, "");
                const left = `${point.time / this.duration * 100}%`;
                if (tipElement) {
                    // Show on hover
                    markerElement.addEventListener("mouseenter", ()=>{
                        if (point.label) return;
                        tipElement.style.left = left;
                        tipElement.innerHTML = point.label;
                        toggleTip(true);
                    });
                    // Hide on leave
                    markerElement.addEventListener("mouseleave", ()=>{
                        toggleTip(false);
                    });
                }
                markerElement.addEventListener("click", ()=>{
                    this.currentTime = point.time;
                });
                markerElement.style.left = left;
                pointsFragment.appendChild(markerElement);
            });
            containerFragment.appendChild(pointsFragment);
            // Inject a tooltip if needed
            if (!this.config.tooltips.seek) {
                tipElement = createElement("span", {
                    class: this.config.classNames.tooltip
                }, "");
                containerFragment.appendChild(tipElement);
            }
            this.elements.markers = {
                points: pointsFragment,
                tip: tipElement
            };
            this.elements.progress.appendChild(containerFragment);
        }
    };
    // ==========================================================================
    /**
   * Parse a string to a URL object
   * @param {String} input - the URL to be parsed
   * @param {Boolean} safe - failsafe parsing
   */ function parseUrl(input, safe = true) {
        let url = input;
        if (safe) {
            const parser = document.createElement("a");
            parser.href = url;
            url = parser.href;
        }
        try {
            return new URL(url);
        } catch (_) {
            return null;
        }
    }
    // Convert object to URLSearchParams
    function buildUrlParams(input) {
        const params = new URLSearchParams();
        if (is.object(input)) Object.entries(input).forEach(([key, value])=>{
            params.set(key, value);
        });
        return params;
    }
    // ==========================================================================
    const captions = {
        // Setup captions
        setup () {
            // Requires UI support
            if (!this.supported.ui) return;
            // Only Vimeo and HTML5 video supported at this point
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !support.textTracks) {
                // Clear menu and hide
                if (is.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions")) controls.setCaptionsMenu.call(this);
                return;
            }
            // Inject the container
            if (!is.element(this.elements.captions)) {
                this.elements.captions = createElement("div", getAttributesFromSelector(this.config.selectors.captions));
                this.elements.captions.setAttribute("dir", "auto");
                insertAfter(this.elements.captions, this.elements.wrapper);
            }
            // Fix IE captions if CORS is used
            // Fetch captions and inject as blobs instead (data URIs not supported!)
            if (browser.isIE && window.URL) {
                const elements = this.media.querySelectorAll("track");
                Array.from(elements).forEach((track)=>{
                    const src = track.getAttribute("src");
                    const url = parseUrl(src);
                    if (url !== null && url.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(url.protocol)) fetch(src, "blob").then((blob)=>{
                        track.setAttribute("src", window.URL.createObjectURL(blob));
                    }).catch(()=>{
                        removeElement(track);
                    });
                });
            }
            // Get and set initial data
            // The "preferred" options are not realized unless / until the wanted language has a match
            // * languages: Array of user's browser languages.
            // * language:  The language preferred by user settings or config
            // * active:    The state preferred by user settings or config
            // * toggled:   The real captions state
            const browserLanguages = navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ];
            const languages = dedupe(browserLanguages.map((language)=>language.split("-")[0]));
            let language = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            // Use first browser language when language is 'auto'
            if (language === "auto") [language] = languages;
            let active = this.storage.get("captions");
            if (!is.boolean(active)) ({ active: active } = this.config.captions);
            Object.assign(this.captions, {
                toggled: false,
                active: active,
                language: language,
                languages: languages
            });
            // Watch changes to textTracks and update captions menu
            if (this.isHTML5) {
                const trackEvents = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                on.call(this, this.media.textTracks, trackEvents, captions.update.bind(this));
            }
            // Update available languages in list next tick (the event must not be triggered before the listeners)
            setTimeout(captions.update.bind(this), 0);
        },
        // Update available language options in settings based on tracks
        update () {
            const tracks = captions.getTracks.call(this, true);
            // Get the wanted language
            const { active: active, language: language, meta: meta, currentTrackNode: currentTrackNode } = this.captions;
            const languageExists = Boolean(tracks.find((track)=>track.language === language));
            // Handle tracks (add event listener and "pseudo"-default)
            if (this.isHTML5 && this.isVideo) tracks.filter((track)=>!meta.get(track)).forEach((track)=>{
                this.debug.log("Track added", track);
                // Attempt to store if the original dom element was "default"
                meta.set(track, {
                    default: track.mode === "showing"
                });
                // Turn off native caption rendering to avoid double captions
                // Note: mode='hidden' forces a track to download. To ensure every track
                // isn't downloaded at once, only 'showing' tracks should be reassigned
                // eslint-disable-next-line no-param-reassign
                if (track.mode === "showing") // eslint-disable-next-line no-param-reassign
                track.mode = "hidden";
                // Add event listener for cue changes
                on.call(this, track, "cuechange", ()=>captions.updateCues.call(this));
            });
            // Update language first time it matches, or if the previous matching track was removed
            if (languageExists && this.language !== language || !tracks.includes(currentTrackNode)) {
                captions.setLanguage.call(this, language);
                captions.toggle.call(this, active && languageExists);
            }
            // Enable or disable captions based on track length
            if (this.elements) toggleClass(this.elements.container, this.config.classNames.captions.enabled, !is.empty(tracks));
            // Update available languages in list
            if (is.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions")) controls.setCaptionsMenu.call(this);
        },
        // Toggle captions display
        // Used internally for the toggleCaptions method, with the passive option forced to false
        toggle (input, passive = true) {
            // If there's no full support
            if (!this.supported.ui) return;
            const { toggled: toggled } = this.captions; // Current state
            const activeClass = this.config.classNames.captions.active;
            // Get the next state
            // If the method is called without parameter, toggle based on current value
            const active = is.nullOrUndefined(input) ? !toggled : input;
            // Update state and trigger event
            if (active !== toggled) {
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.active = active;
                    this.storage.set({
                        captions: active
                    });
                }
                // Force language if the call isn't passive and there is no matching language to toggle to
                if (!this.language && active && !passive) {
                    const tracks = captions.getTracks.call(this);
                    const track = captions.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], true);
                    // Override user preferences to avoid switching languages if a matching track is added
                    this.captions.language = track.language;
                    // Set caption, but don't store in localStorage as user preference
                    captions.set.call(this, tracks.indexOf(track));
                    return;
                }
                // Toggle button if it's enabled
                if (this.elements.buttons.captions) this.elements.buttons.captions.pressed = active;
                // Add class hook
                toggleClass(this.elements.container, activeClass, active);
                this.captions.toggled = active;
                // Update settings menu
                controls.updateSetting.call(this, "captions");
                // Trigger event (not used internally)
                triggerEvent.call(this, this.media, active ? "captionsenabled" : "captionsdisabled");
            }
            // Wait for the call stack to clear before setting mode='hidden'
            // on the active track - forcing the browser to download it
            setTimeout(()=>{
                if (active && this.captions.toggled) this.captions.currentTrackNode.mode = "hidden";
            });
        },
        // Set captions by track index
        // Used internally for the currentTrack setter with the passive option forced to false
        set (index, passive = true) {
            const tracks = captions.getTracks.call(this);
            // Disable captions if setting to -1
            if (index === -1) {
                captions.toggle.call(this, false, passive);
                return;
            }
            if (!is.number(index)) {
                this.debug.warn("Invalid caption argument", index);
                return;
            }
            if (!(index in tracks)) {
                this.debug.warn("Track not found", index);
                return;
            }
            if (this.captions.currentTrack !== index) {
                this.captions.currentTrack = index;
                const track = tracks[index];
                const { language: language } = track || {};
                // Store reference to node for invalidation on remove
                this.captions.currentTrackNode = track;
                // Update settings menu
                controls.updateSetting.call(this, "captions");
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.language = language;
                    this.storage.set({
                        language: language
                    });
                }
                // Handle Vimeo captions
                if (this.isVimeo) this.embed.enableTextTrack(language);
                // Trigger event
                triggerEvent.call(this, this.media, "languagechange");
            }
            // Show captions
            captions.toggle.call(this, true, passive);
            if (this.isHTML5 && this.isVideo) // If we change the active track while a cue is already displayed we need to update it
            captions.updateCues.call(this);
        },
        // Set captions by language
        // Used internally for the language setter with the passive option forced to false
        setLanguage (input, passive = true) {
            if (!is.string(input)) {
                this.debug.warn("Invalid language argument", input);
                return;
            }
            // Normalize
            const language = input.toLowerCase();
            this.captions.language = language;
            // Set currentTrack
            const tracks = captions.getTracks.call(this);
            const track = captions.findTrack.call(this, [
                language
            ]);
            captions.set.call(this, tracks.indexOf(track), passive);
        },
        // Get current valid caption tracks
        // If update is false it will also ignore tracks without metadata
        // This is used to "freeze" the language options when captions.update is false
        getTracks (update = false) {
            // Handle media or textTracks missing or null
            const tracks = Array.from((this.media || {}).textTracks || []);
            // For HTML5, use cache instead of current tracks when it exists (if captions.update is false)
            // Filter out removed tracks and tracks that aren't captions/subtitles (for example metadata)
            return tracks.filter((track)=>!this.isHTML5 || update || this.captions.meta.has(track)).filter((track)=>[
                    "captions",
                    "subtitles"
                ].includes(track.kind));
        },
        // Match tracks based on languages and get the first
        findTrack (languages, force = false) {
            const tracks = captions.getTracks.call(this);
            const sortIsDefault = (track)=>Number((this.captions.meta.get(track) || {}).default);
            const sorted = Array.from(tracks).sort((a, b)=>sortIsDefault(b) - sortIsDefault(a));
            let track;
            languages.every((language)=>{
                track = sorted.find((t)=>t.language === language);
                return !track; // Break iteration if there is a match
            });
            // If no match is found but is required, get first
            return track || (force ? sorted[0] : undefined);
        },
        // Get the current track
        getCurrentTrack () {
            return captions.getTracks.call(this)[this.currentTrack];
        },
        // Get UI label for track
        getLabel (track) {
            let currentTrack = track;
            if (!is.track(currentTrack) && support.textTracks && this.captions.toggled) currentTrack = captions.getCurrentTrack.call(this);
            if (is.track(currentTrack)) {
                if (!is.empty(currentTrack.label)) return currentTrack.label;
                if (!is.empty(currentTrack.language)) return track.language.toUpperCase();
                return i18n.get("enabled", this.config);
            }
            return i18n.get("disabled", this.config);
        },
        // Update captions using current track's active cues
        // Also optional array argument in case there isn't any track (ex: vimeo)
        updateCues (input) {
            // Requires UI
            if (!this.supported.ui) return;
            if (!is.element(this.elements.captions)) {
                this.debug.warn("No captions element to render to");
                return;
            }
            // Only accept array or empty input
            if (!is.nullOrUndefined(input) && !Array.isArray(input)) {
                this.debug.warn("updateCues: Invalid input", input);
                return;
            }
            let cues = input;
            // Get cues from track
            if (!cues) {
                const track = captions.getCurrentTrack.call(this);
                cues = Array.from((track || {}).activeCues || []).map((cue)=>cue.getCueAsHTML()).map(getHTML);
            }
            // Set new caption text
            const content = cues.map((cueText)=>cueText.trim()).join("\n");
            const changed = content !== this.elements.captions.innerHTML;
            if (changed) {
                // Empty the container and create a new child element
                emptyElement(this.elements.captions);
                const caption = createElement("span", getAttributesFromSelector(this.config.selectors.caption));
                caption.innerHTML = content;
                this.elements.captions.appendChild(caption);
                // Trigger event
                triggerEvent.call(this, this.media, "cuechange");
            }
        }
    };
    // ==========================================================================
    // Plyr default config
    // ==========================================================================
    const defaults = {
        // Disable
        enabled: true,
        // Custom media title
        title: "",
        // Logging to console
        debug: false,
        // Auto play (if supported)
        autoplay: false,
        // Only allow one media playing at once (vimeo only)
        autopause: true,
        // Allow inline playback on iOS (this effects YouTube/Vimeo - HTML5 requires the attribute present)
        // TODO: Remove iosNative fullscreen option in favour of this (logic needs work)
        playsinline: true,
        // Default time to skip when rewind/fast forward
        seekTime: 10,
        // Default volume
        volume: 1,
        muted: false,
        // Pass a custom duration
        duration: null,
        // Display the media duration on load in the current time position
        // If you have opted to display both duration and currentTime, this is ignored
        displayDuration: true,
        // Invert the current time to be a countdown
        invertTime: true,
        // Clicking the currentTime inverts it's value to show time left rather than elapsed
        toggleInvert: true,
        // Force an aspect ratio
        // The format must be `'w:h'` (e.g. `'16:9'`)
        ratio: null,
        // Click video container to play/pause
        clickToPlay: true,
        // Auto hide the controls
        hideControls: true,
        // Reset to start when playback ended
        resetOnEnd: false,
        // Disable the standard context menu
        disableContextMenu: true,
        // Sprite (for icons)
        loadSprite: true,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.3/plyr.svg",
        // Blank video (used to prevent errors on source change)
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        // Quality default
        quality: {
            default: 576,
            // The options to display in the UI, if available for the source media
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: false,
            onChange: null
        },
        // Set loops
        loop: {
            active: false
        },
        // Speed default and options to display
        speed: {
            selected: 1,
            // The options to display in the UI, if available for the source media (e.g. Vimeo and YouTube only support 0.5x-4x)
            options: [
                0.5,
                0.75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        // Keyboard shortcut settings
        keyboard: {
            focused: true,
            global: false
        },
        // Display tooltips
        tooltips: {
            controls: false,
            seek: true
        },
        // Captions settings
        captions: {
            active: false,
            language: "auto",
            // Listen to new tracks added after Plyr is initialized.
            // This is needed for streaming captions, but may result in unselectable options
            update: false
        },
        // Fullscreen settings
        fullscreen: {
            enabled: true,
            // Allow fullscreen?
            fallback: true,
            // Fallback using full viewport/window
            iosNative: false // Use the native fullscreen in iOS (disables custom controls)
        },
        // Local storage
        storage: {
            enabled: true,
            key: "plyr"
        },
        // Default controls
        controls: [
            "play-large",
            // 'restart',
            // 'rewind',
            "play",
            // 'fast-forward',
            "progress",
            "current-time",
            // 'duration',
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            // 'download',
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        // Localisation
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        // URLs
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        // Custom control listeners
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        // Events to watch and bubble
        events: [
            // Events to watch on HTML5 media elements and bubble
            // https://developer.mozilla.org/en/docs/Web/Guide/Events/Media_events
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            // Custom events
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            // YouTube
            "statechange",
            // Quality
            "qualitychange",
            // Ads
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        // Selectors
        // Change these to match your template if using custom HTML
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                // Used later
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        // Class hooks added to the player in different states
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isIos: "plyr--is-ios",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            tabFocus: "plyr__tab-focus",
            previewThumbnails: {
                // Tooltip thumbs
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                // Scrubbing
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        // Embed attributes
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        // Advertisements plugin
        // Register for an account here: http://vi.ai/publisher-video-monetization/?aid=plyrio
        ads: {
            enabled: false,
            publisherId: "",
            tagUrl: ""
        },
        // Preview Thumbnails plugin
        previewThumbnails: {
            enabled: false,
            src: ""
        },
        // Vimeo plugin
        vimeo: {
            byline: false,
            portrait: false,
            title: false,
            speed: true,
            transparent: false,
            // Custom settings from Plyr
            customControls: true,
            referrerPolicy: null,
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy
            // Whether the owner of the video has a Pro or Business account
            // (which allows us to properly hide controls without CSS hacks, etc)
            premium: false
        },
        // YouTube plugin
        youtube: {
            rel: 0,
            // No related vids
            showinfo: 0,
            // Hide info
            iv_load_policy: 3,
            // Hide annotations
            modestbranding: 1,
            // Hide logos as much as possible (they still show one in the corner when paused)
            // Custom settings from Plyr
            customControls: true,
            noCookie: false // Whether to use an alternative version of YouTube without cookies
        },
        // Media Metadata
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        // Markers
        markers: {
            enabled: false,
            points: []
        }
    };
    // ==========================================================================
    // Plyr states
    // ==========================================================================
    const pip = {
        active: "picture-in-picture",
        inactive: "inline"
    };
    // ==========================================================================
    // Plyr supported types and providers
    // ==========================================================================
    const providers = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    };
    const types = {
        audio: "audio",
        video: "video"
    };
    /**
   * Get provider by URL
   * @param {String} url
   */ function getProviderByUrl(url) {
        // YouTube
        if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(url)) return providers.youtube;
        // Vimeo
        if (/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(url)) return providers.vimeo;
        return null;
    }
    // ==========================================================================
    // Console wrapper
    // ==========================================================================
    const noop = ()=>{};
    class Console {
        constructor(enabled = false){
            this.enabled = window.console && enabled;
            if (this.enabled) this.log("Debugging enabled");
        }
        get log() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.log, console) : noop;
        }
        get warn() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : noop;
        }
        get error() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.error, console) : noop;
        }
    }
    class Fullscreen {
        constructor(player){
            _defineProperty$1(this, "onChange", ()=>{
                if (!this.enabled) return;
                // Update toggle button
                const button = this.player.elements.buttons.fullscreen;
                if (is.element(button)) button.pressed = this.active;
                // Always trigger events on the plyr / media element (not a fullscreen container) and let them bubble up
                const target = this.target === this.player.media ? this.target : this.player.elements.container;
                // Trigger an event
                triggerEvent.call(this.player, target, this.active ? "enterfullscreen" : "exitfullscreen", true);
            });
            _defineProperty$1(this, "toggleFallback", (toggle = false)=>{
                // Store or restore scroll position
                if (toggle) this.scrollPosition = {
                    x: window.scrollX || 0,
                    y: window.scrollY || 0
                };
                else window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
                // Toggle scroll
                document.body.style.overflow = toggle ? "hidden" : "";
                // Toggle class hook
                toggleClass(this.target, this.player.config.classNames.fullscreen.fallback, toggle);
                // Force full viewport on iPhone X+
                if (browser.isIos) {
                    let viewport = document.head.querySelector('meta[name="viewport"]');
                    const property = "viewport-fit=cover";
                    // Inject the viewport meta if required
                    if (!viewport) {
                        viewport = document.createElement("meta");
                        viewport.setAttribute("name", "viewport");
                    }
                    // Check if the property already exists
                    const hasProperty = is.string(viewport.content) && viewport.content.includes(property);
                    if (toggle) {
                        this.cleanupViewport = !hasProperty;
                        if (!hasProperty) viewport.content += `,${property}`;
                    } else if (this.cleanupViewport) viewport.content = viewport.content.split(",").filter((part)=>part.trim() !== property).join(",");
                }
                // Toggle button and fire events
                this.onChange();
            });
            _defineProperty$1(this, "trapFocus", (event)=>{
                // Bail if iOS, not active, not the tab key
                if (browser.isIos || !this.active || event.key !== "Tab") return;
                // Get the current focused element
                const focused = document.activeElement;
                const focusable = getElements.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]");
                const [first] = focusable;
                const last = focusable[focusable.length - 1];
                if (focused === last && !event.shiftKey) {
                    // Move focus to first element that can be tabbed if Shift isn't used
                    first.focus();
                    event.preventDefault();
                } else if (focused === first && event.shiftKey) {
                    // Move focus to last element that can be tabbed if Shift is used
                    last.focus();
                    event.preventDefault();
                }
            });
            _defineProperty$1(this, "update", ()=>{
                if (this.enabled) {
                    let mode;
                    if (this.forceFallback) mode = "Fallback (forced)";
                    else if (Fullscreen.native) mode = "Native";
                    else mode = "Fallback";
                    this.player.debug.log(`${mode} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                // Add styling hook to show button
                toggleClass(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
            });
            _defineProperty$1(this, "enter", ()=>{
                if (!this.enabled) return;
                // iOS native fullscreen doesn't need the request step
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    if (this.player.isVimeo) this.player.embed.requestFullscreen();
                    else this.target.webkitEnterFullscreen();
                } else if (!Fullscreen.native || this.forceFallback) this.toggleFallback(true);
                else if (!this.prefix) this.target.requestFullscreen({
                    navigationUI: "hide"
                });
                else if (!is.empty(this.prefix)) this.target[`${this.prefix}Request${this.property}`]();
            });
            _defineProperty$1(this, "exit", ()=>{
                if (!this.enabled) return;
                // iOS native fullscreen
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    this.target.webkitExitFullscreen();
                    silencePromise(this.player.play());
                } else if (!Fullscreen.native || this.forceFallback) this.toggleFallback(false);
                else if (!this.prefix) (document.cancelFullScreen || document.exitFullscreen).call(document);
                else if (!is.empty(this.prefix)) {
                    const action = this.prefix === "moz" ? "Cancel" : "Exit";
                    document[`${this.prefix}${action}${this.property}`]();
                }
            });
            _defineProperty$1(this, "toggle", ()=>{
                if (!this.active) this.enter();
                else this.exit();
            });
            // Keep reference to parent
            this.player = player;
            // Get prefix
            this.prefix = Fullscreen.prefix;
            this.property = Fullscreen.property;
            // Scroll position
            this.scrollPosition = {
                x: 0,
                y: 0
            };
            // Force the use of 'full window/browser' rather than fullscreen
            this.forceFallback = player.config.fullscreen.fallback === "force";
            // Get the fullscreen element
            // Checks container is an ancestor, defaults to null
            this.player.elements.fullscreen = player.config.fullscreen.container && closest$1(this.player.elements.container, player.config.fullscreen.container);
            // Register event listeners
            // Handle event (incase user presses escape etc)
            on.call(this.player, document, this.prefix === "ms" ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                // TODO: Filter for target??
                this.onChange();
            });
            // Fullscreen toggle on double click
            on.call(this.player, this.player.elements.container, "dblclick", (event)=>{
                // Ignore double click in controls
                if (is.element(this.player.elements.controls) && this.player.elements.controls.contains(event.target)) return;
                this.player.listeners.proxy(event, this.toggle, "fullscreen");
            });
            // Tap focus when in fullscreen
            on.call(this, this.player.elements.container, "keydown", (event)=>this.trapFocus(event));
            // Update the UI
            this.update();
        // this.toggle = this.toggle.bind(this);
        }
        // Determine if native supported
        static get native() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        // If we're actually using native
        get usingNative() {
            return Fullscreen.native && !this.forceFallback;
        }
        // Get the prefix for handlers
        static get prefix() {
            // No prefix
            if (is.function(document.exitFullscreen)) return "";
            // Check for fullscreen support by vendor prefix
            let value = "";
            const prefixes = [
                "webkit",
                "moz",
                "ms"
            ];
            prefixes.some((pre)=>{
                if (is.function(document[`${pre}ExitFullscreen`]) || is.function(document[`${pre}CancelFullScreen`])) {
                    value = pre;
                    return true;
                }
                return false;
            });
            return value;
        }
        static get property() {
            return this.prefix === "moz" ? "FullScreen" : "Fullscreen";
        }
        // Determine if fullscreen is enabled
        get enabled() {
            return (Fullscreen.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
        }
        // Get active state
        get active() {
            if (!this.enabled) return false;
            // Fallback using classname
            if (!Fullscreen.native || this.forceFallback) return hasClass(this.target, this.player.config.classNames.fullscreen.fallback);
            const element = !this.prefix ? this.target.getRootNode().fullscreenElement : this.target.getRootNode()[`${this.prefix}${this.property}Element`];
            return element && element.shadowRoot ? element === this.target.getRootNode().host : element === this.target;
        }
        // Get target element
        get target() {
            return browser.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
        }
    }
    // ==========================================================================
    // Load image avoiding xhr/fetch CORS issues
    // Server status can't be obtained this way unfortunately, so this uses "naturalWidth" to determine if the image has loaded
    // By default it checks if it is at least 1px, but you can add a second argument to change this
    // ==========================================================================
    function loadImage(src, minWidth = 1) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const handler = ()=>{
                delete image.onload;
                delete image.onerror;
                (image.naturalWidth >= minWidth ? resolve : reject)(image);
            };
            Object.assign(image, {
                onload: handler,
                onerror: handler,
                src: src
            });
        });
    }
    // ==========================================================================
    const ui = {
        addStyleHook () {
            toggleClass(this.elements.container, this.config.selectors.container.replace(".", ""), true);
            toggleClass(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        // Toggle native HTML5 media controls
        toggleNativeControls (toggle = false) {
            if (toggle && this.isHTML5) this.media.setAttribute("controls", "");
            else this.media.removeAttribute("controls");
        },
        // Setup the UI
        build () {
            // Re-attach media element listeners
            // TODO: Use event bubbling?
            this.listeners.media();
            // Don't setup interface if no support
            if (!this.supported.ui) {
                this.debug.warn(`Basic support only for ${this.provider} ${this.type}`);
                // Restore native controls
                ui.toggleNativeControls.call(this, true);
                // Bail
                return;
            }
            // Inject custom controls if not present
            if (!is.element(this.elements.controls)) {
                // Inject custom controls
                controls.inject.call(this);
                // Re-attach control listeners
                this.listeners.controls();
            }
            // Remove native controls
            ui.toggleNativeControls.call(this);
            // Setup captions for HTML5
            if (this.isHTML5) captions.setup.call(this);
            // Reset volume
            this.volume = null;
            // Reset mute state
            this.muted = null;
            // Reset loop state
            this.loop = null;
            // Reset quality setting
            this.quality = null;
            // Reset speed
            this.speed = null;
            // Reset volume display
            controls.updateVolume.call(this);
            // Reset time display
            controls.timeUpdate.call(this);
            // Reset duration display
            controls.durationUpdate.call(this);
            // Update the UI
            ui.checkPlaying.call(this);
            // Check for picture-in-picture support
            toggleClass(this.elements.container, this.config.classNames.pip.supported, support.pip && this.isHTML5 && this.isVideo);
            // Check for airplay support
            toggleClass(this.elements.container, this.config.classNames.airplay.supported, support.airplay && this.isHTML5);
            // Add iOS class
            toggleClass(this.elements.container, this.config.classNames.isIos, browser.isIos);
            // Add touch class
            toggleClass(this.elements.container, this.config.classNames.isTouch, this.touch);
            // Ready for API calls
            this.ready = true;
            // Ready event at end of execution stack
            setTimeout(()=>{
                triggerEvent.call(this, this.media, "ready");
            }, 0);
            // Set the title
            ui.setTitle.call(this);
            // Assure the poster image is set, if the property was added before the element was created
            if (this.poster) ui.setPoster.call(this, this.poster, false).catch(()=>{});
            // Manually set the duration if user has overridden it.
            // The event listeners for it doesn't get called if preload is disabled (#701)
            if (this.config.duration) controls.durationUpdate.call(this);
            // Media metadata
            if (this.config.mediaMetadata) controls.setMediaMetadata.call(this);
        },
        // Setup aria attribute for play and iframe title
        setTitle () {
            // Find the current text
            let label = i18n.get("play", this.config);
            // If there's a media title set, use that for the label
            if (is.string(this.config.title) && !is.empty(this.config.title)) label += `, ${this.config.title}`;
            // If there's a play button, set label
            Array.from(this.elements.buttons.play || []).forEach((button)=>{
                button.setAttribute("aria-label", label);
            });
            // Set iframe title
            // https://github.com/sampotts/plyr/issues/124
            if (this.isEmbed) {
                const iframe = getElement.call(this, "iframe");
                if (!is.element(iframe)) return;
                // Default to media type
                const title = !is.empty(this.config.title) ? this.config.title : "video";
                const format = i18n.get("frameTitle", this.config);
                iframe.setAttribute("title", format.replace("{title}", title));
            }
        },
        // Toggle poster
        togglePoster (enable) {
            toggleClass(this.elements.container, this.config.classNames.posterEnabled, enable);
        },
        // Set the poster image (async)
        // Used internally for the poster setter, with the passive option forced to false
        setPoster (poster, passive = true) {
            // Don't override if call is passive
            if (passive && this.poster) return Promise.reject(new Error("Poster already set"));
            // Set property synchronously to respect the call order
            this.media.setAttribute("data-poster", poster);
            // Show the poster
            this.elements.poster.removeAttribute("hidden");
            // Wait until ui is ready
            return ready.call(this)// Load image
            .then(()=>loadImage(poster)).catch((error)=>{
                // Hide poster on error unless it's been set by another call
                if (poster === this.poster) ui.togglePoster.call(this, false);
                // Rethrow
                throw error;
            }).then(()=>{
                // Prevent race conditions
                if (poster !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>{
                Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${poster}')`,
                    // Reset backgroundSize as well (since it can be set to "cover" for padded thumbnails for youtube)
                    backgroundSize: ""
                });
                ui.togglePoster.call(this, true);
                return poster;
            });
        },
        // Check playing state
        checkPlaying (event) {
            // Class hooks
            toggleClass(this.elements.container, this.config.classNames.playing, this.playing);
            toggleClass(this.elements.container, this.config.classNames.paused, this.paused);
            toggleClass(this.elements.container, this.config.classNames.stopped, this.stopped);
            // Set state
            Array.from(this.elements.buttons.play || []).forEach((target)=>{
                Object.assign(target, {
                    pressed: this.playing
                });
                target.setAttribute("aria-label", i18n.get(this.playing ? "pause" : "play", this.config));
            });
            // Only update controls on non timeupdate events
            if (is.event(event) && event.type === "timeupdate") return;
            // Toggle controls
            ui.toggleControls.call(this);
        },
        // Check if media is loading
        checkLoading (event) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(event.type);
            // Clear timer
            clearTimeout(this.timers.loading);
            // Timer to prevent flicker when seeking
            this.timers.loading = setTimeout(()=>{
                // Update progress bar loading class state
                toggleClass(this.elements.container, this.config.classNames.loading, this.loading);
                // Update controls visibility
                ui.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        // Toggle controls based on state and `force` argument
        toggleControls (force) {
            const { controls: controlsElement } = this.elements;
            if (controlsElement && this.config.hideControls) {
                // Don't hide controls if a touch-device user recently seeked. (Must be limited to touch devices, or it occasionally prevents desktop controls from hiding.)
                const recentTouchSeek = this.touch && this.lastSeekTime + 2000 > Date.now();
                // Show controls if force, loading, paused, button interaction, or recent seek, otherwise hide
                this.toggleControls(Boolean(force || this.loading || this.paused || controlsElement.pressed || controlsElement.hover || recentTouchSeek));
            }
        },
        // Migrate any custom properties from the media to the parent
        migrateStyles () {
            // Loop through values (as they are the keys when the object is spread 🤔)
            Object.values({
                ...this.media.style
            })// We're only fussed about Plyr specific properties
            .filter((key)=>!is.empty(key) && is.string(key) && key.startsWith("--plyr")).forEach((key)=>{
                // Set on the container
                this.elements.container.style.setProperty(key, this.media.style.getPropertyValue(key));
                // Clean up from media element
                this.media.style.removeProperty(key);
            });
            // Remove attribute if empty
            if (is.empty(this.media.style)) this.media.removeAttribute("style");
        }
    };
    class Listeners {
        constructor(_player){
            _defineProperty$1(this, "firstTouch", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                player.touch = true;
                // Add touch class
                toggleClass(elements.container, player.config.classNames.isTouch, true);
            });
            _defineProperty$1(this, "setTabFocus", (event)=>{
                const { player: player } = this;
                const { elements: elements } = player;
                const { key: key, type: type, timeStamp: timeStamp } = event;
                clearTimeout(this.focusTimer);
                // Ignore any key other than tab
                if (type === "keydown" && key !== "Tab") return;
                // Store reference to event timeStamp
                if (type === "keydown") this.lastKeyDown = timeStamp;
                // Remove current classes
                const removeCurrent = ()=>{
                    const className = player.config.classNames.tabFocus;
                    const current = getElements.call(player, `.${className}`);
                    toggleClass(current, className, false);
                };
                // Determine if a key was pressed to trigger this event
                const wasKeyDown = timeStamp - this.lastKeyDown <= 20;
                // Ignore focus events if a key was pressed prior
                if (type === "focus" && !wasKeyDown) return;
                // Remove all current
                removeCurrent();
                // Delay the adding of classname until the focus has changed
                // This event fires before the focusin event
                if (type !== "focusout") this.focusTimer = setTimeout(()=>{
                    const focused = document.activeElement;
                    // Ignore if current focus element isn't inside the player
                    if (!elements.container.contains(focused)) return;
                    toggleClass(document.activeElement, player.config.classNames.tabFocus, true);
                }, 10);
            });
            _defineProperty$1(this, "global", (toggle = true)=>{
                const { player: player } = this;
                // Keyboard shortcuts
                if (player.config.keyboard.global) toggleListener.call(player, window, "keydown keyup", this.handleKey, toggle, false);
                // Click anywhere closes menu
                toggleListener.call(player, document.body, "click", this.toggleMenu, toggle);
                // Detect touch by events
                once.call(player, document.body, "touchstart", this.firstTouch);
                // Tab focus detection
                toggleListener.call(player, document.body, "keydown focus blur focusout", this.setTabFocus, toggle, false, true);
            });
            _defineProperty$1(this, "container", ()=>{
                const { player: player } = this;
                const { config: config, elements: elements, timers: timers } = player;
                // Keyboard shortcuts
                if (!config.keyboard.global && config.keyboard.focused) on.call(player, elements.container, "keydown keyup", this.handleKey, false);
                // Toggle controls on mouse events and entering fullscreen
                on.call(player, elements.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (event)=>{
                    const { controls: controlsElement } = elements;
                    // Remove button states for fullscreen
                    if (controlsElement && event.type === "enterfullscreen") {
                        controlsElement.pressed = false;
                        controlsElement.hover = false;
                    }
                    // Show, then hide after a timeout unless another control event occurs
                    const show = [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(event.type);
                    let delay = 0;
                    if (show) {
                        ui.toggleControls.call(player, true);
                        // Use longer timeout for touch devices
                        delay = player.touch ? 3000 : 2000;
                    }
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Set new timer to prevent flicker when seeking
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Set a gutter for Vimeo
                const setGutter = ()=>{
                    if (!player.isVimeo || player.config.vimeo.premium) return;
                    const target = elements.wrapper;
                    const { active: active } = player.fullscreen;
                    const [videoWidth, videoHeight] = getAspectRatio.call(player);
                    const useNativeAspectRatio = supportsCSS(`aspect-ratio: ${videoWidth} / ${videoHeight}`);
                    // If not active, remove styles
                    if (!active) {
                        if (useNativeAspectRatio) {
                            target.style.width = null;
                            target.style.height = null;
                        } else {
                            target.style.maxWidth = null;
                            target.style.margin = null;
                        }
                        return;
                    }
                    // Determine which dimension will overflow and constrain view
                    const [viewportWidth, viewportHeight] = getViewportSize();
                    const overflow = viewportWidth / viewportHeight > videoWidth / videoHeight;
                    if (useNativeAspectRatio) {
                        target.style.width = overflow ? "auto" : "100%";
                        target.style.height = overflow ? "100%" : "auto";
                    } else {
                        target.style.maxWidth = overflow ? `${viewportHeight / videoHeight * videoWidth}px` : null;
                        target.style.margin = overflow ? "0 auto" : null;
                    }
                };
                // Handle resizing
                const resized = ()=>{
                    clearTimeout(timers.resized);
                    timers.resized = setTimeout(setGutter, 50);
                };
                on.call(player, elements.container, "enterfullscreen exitfullscreen", (event)=>{
                    const { target: target } = player.fullscreen;
                    // Ignore events not from target
                    if (target !== elements.container) return;
                    // If it's not an embed and no ratio specified
                    if (!player.isEmbed && is.empty(player.config.ratio)) return;
                    // Set Vimeo gutter
                    setGutter();
                    // Watch for resizes
                    const method = event.type === "enterfullscreen" ? on : off;
                    method.call(player, window, "resize", resized);
                });
            });
            _defineProperty$1(this, "media", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // Time change on media
                on.call(player, player.media, "timeupdate seeking seeked", (event)=>controls.timeUpdate.call(player, event));
                // Display duration
                on.call(player, player.media, "durationchange loadeddata loadedmetadata", (event)=>controls.durationUpdate.call(player, event));
                // Handle the media finishing
                on.call(player, player.media, "ended", ()=>{
                    // Show poster on end
                    if (player.isHTML5 && player.isVideo && player.config.resetOnEnd) {
                        // Restart
                        player.restart();
                        // Call pause otherwise IE11 will start playing the video again
                        player.pause();
                    }
                });
                // Check for buffer progress
                on.call(player, player.media, "progress playing seeking seeked", (event)=>controls.updateProgress.call(player, event));
                // Handle volume changes
                on.call(player, player.media, "volumechange", (event)=>controls.updateVolume.call(player, event));
                // Handle play/pause
                on.call(player, player.media, "playing play pause ended emptied timeupdate", (event)=>ui.checkPlaying.call(player, event));
                // Loading state
                on.call(player, player.media, "waiting canplay seeked playing", (event)=>ui.checkLoading.call(player, event));
                // Click video
                if (player.supported.ui && player.config.clickToPlay && !player.isAudio) {
                    // Re-fetch the wrapper
                    const wrapper = getElement.call(player, `.${player.config.classNames.video}`);
                    // Bail if there's no wrapper (this should never happen)
                    if (!is.element(wrapper)) return;
                    // On click play, pause or restart
                    on.call(player, elements.container, "click", (event)=>{
                        const targets = [
                            elements.container,
                            wrapper
                        ];
                        // Ignore if click if not container or in video wrapper
                        if (!targets.includes(event.target) && !wrapper.contains(event.target)) return;
                        // Touch devices will just show controls (if hidden)
                        if (player.touch && player.config.hideControls) return;
                        if (player.ended) {
                            this.proxy(event, player.restart, "restart");
                            this.proxy(event, ()=>{
                                silencePromise(player.play());
                            }, "play");
                        } else this.proxy(event, ()=>{
                            silencePromise(player.togglePlay());
                        }, "play");
                    });
                }
                // Disable right click
                if (player.supported.ui && player.config.disableContextMenu) on.call(player, elements.wrapper, "contextmenu", (event)=>{
                    event.preventDefault();
                }, false);
                // Volume change
                on.call(player, player.media, "volumechange", ()=>{
                    // Save to storage
                    player.storage.set({
                        volume: player.volume,
                        muted: player.muted
                    });
                });
                // Speed change
                on.call(player, player.media, "ratechange", ()=>{
                    // Update UI
                    controls.updateSetting.call(player, "speed");
                    // Save to storage
                    player.storage.set({
                        speed: player.speed
                    });
                });
                // Quality change
                on.call(player, player.media, "qualitychange", (event)=>{
                    // Update UI
                    controls.updateSetting.call(player, "quality", null, event.detail.quality);
                });
                // Update download link when ready and if quality changes
                on.call(player, player.media, "ready qualitychange", ()=>{
                    controls.setDownloadUrl.call(player);
                });
                // Proxy events to container
                // Bubble up key events for Edge
                const proxyEvents = player.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                on.call(player, player.media, proxyEvents, (event)=>{
                    let { detail: detail = {} } = event;
                    // Get error details from media
                    if (event.type === "error") detail = player.media.error;
                    triggerEvent.call(player, elements.container, event.type, true, detail);
                });
            });
            _defineProperty$1(this, "proxy", (event, defaultHandler, customHandlerKey)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                let returned = true;
                // Execute custom handler
                if (hasCustomHandler) returned = customHandler.call(player, event);
                // Only call default handler if not prevented in custom handler
                if (returned !== false && is.function(defaultHandler)) defaultHandler.call(player, event);
            });
            _defineProperty$1(this, "bind", (element, type, defaultHandler, customHandlerKey, passive = true)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                on.call(player, element, type, (event)=>this.proxy(event, defaultHandler, customHandlerKey), passive && !hasCustomHandler);
            });
            _defineProperty$1(this, "controls", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // IE doesn't support input event, so we fallback to change
                const inputEvent = browser.isIE ? "change" : "input";
                // Play/pause toggle
                if (elements.buttons.play) Array.from(elements.buttons.play).forEach((button)=>{
                    this.bind(button, "click", ()=>{
                        silencePromise(player.togglePlay());
                    }, "play");
                });
                // Pause
                this.bind(elements.buttons.restart, "click", player.restart, "restart");
                // Rewind
                this.bind(elements.buttons.rewind, "click", ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after rewind
                    player.lastSeekTime = Date.now();
                    player.rewind();
                }, "rewind");
                // Rewind
                this.bind(elements.buttons.fastForward, "click", ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after fast forward
                    player.lastSeekTime = Date.now();
                    player.forward();
                }, "fastForward");
                // Mute toggle
                this.bind(elements.buttons.mute, "click", ()=>{
                    player.muted = !player.muted;
                }, "mute");
                // Captions toggle
                this.bind(elements.buttons.captions, "click", ()=>player.toggleCaptions());
                // Download
                this.bind(elements.buttons.download, "click", ()=>{
                    triggerEvent.call(player, player.media, "download");
                }, "download");
                // Fullscreen toggle
                this.bind(elements.buttons.fullscreen, "click", ()=>{
                    player.fullscreen.toggle();
                }, "fullscreen");
                // Picture-in-Picture
                this.bind(elements.buttons.pip, "click", ()=>{
                    player.pip = "toggle";
                }, "pip");
                // Airplay
                this.bind(elements.buttons.airplay, "click", player.airplay, "airplay");
                // Settings menu - click toggle
                this.bind(elements.buttons.settings, "click", (event)=>{
                    // Prevent the document click listener closing the menu
                    event.stopPropagation();
                    event.preventDefault();
                    controls.toggleMenu.call(player, event);
                }, null, false); // Can't be passive as we're preventing default
                // Settings menu - keyboard toggle
                // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
                // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
                this.bind(elements.buttons.settings, "keyup", (event)=>{
                    if (![
                        "Space",
                        "Enter"
                    ].includes(event.key)) return;
                    // Because return triggers a click anyway, all we need to do is set focus
                    if (event.key === "Enter") {
                        controls.focusFirstMenuItem.call(player, null, true);
                        return;
                    }
                    // Prevent scroll
                    event.preventDefault();
                    // Prevent playing video (Firefox)
                    event.stopPropagation();
                    // Toggle menu
                    controls.toggleMenu.call(player, event);
                }, null, false // Can't be passive as we're preventing default
                );
                // Escape closes menu
                this.bind(elements.settings.menu, "keydown", (event)=>{
                    if (event.key === "Escape") controls.toggleMenu.call(player, event);
                });
                // Set range input alternative "value", which matches the tooltip time (#954)
                this.bind(elements.inputs.seek, "mousedown mousemove", (event)=>{
                    const rect = elements.progress.getBoundingClientRect();
                    const percent = 100 / rect.width * (event.pageX - rect.left);
                    event.currentTarget.setAttribute("seek-value", percent);
                });
                // Pause while seeking
                this.bind(elements.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (event)=>{
                    const seek = event.currentTarget;
                    const attribute = "play-on-seeked";
                    if (is.keyboardEvent(event) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(event.key)) return;
                    // Record seek time so we can prevent hiding controls for a few seconds after seek
                    player.lastSeekTime = Date.now();
                    // Was playing before?
                    const play = seek.hasAttribute(attribute);
                    // Done seeking
                    const done = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(event.type);
                    // If we're done seeking and it was playing, resume playback
                    if (play && done) {
                        seek.removeAttribute(attribute);
                        silencePromise(player.play());
                    } else if (!done && player.playing) {
                        seek.setAttribute(attribute, "");
                        player.pause();
                    }
                });
                // Fix range inputs on iOS
                // Super weird iOS bug where after you interact with an <input type="range">,
                // it takes over further interactions on the page. This is a hack
                if (browser.isIos) {
                    const inputs = getElements.call(player, 'input[type="range"]');
                    Array.from(inputs).forEach((input)=>this.bind(input, inputEvent, (event)=>repaint(event.target)));
                }
                // Seek
                this.bind(elements.inputs.seek, inputEvent, (event)=>{
                    const seek = event.currentTarget;
                    // If it exists, use seek-value instead of "value" for consistency with tooltip time (#954)
                    let seekTo = seek.getAttribute("seek-value");
                    if (is.empty(seekTo)) seekTo = seek.value;
                    seek.removeAttribute("seek-value");
                    player.currentTime = seekTo / seek.max * player.duration;
                }, "seek");
                // Seek tooltip
                this.bind(elements.progress, "mouseenter mouseleave mousemove", (event)=>controls.updateSeekTooltip.call(player, event));
                // Preview thumbnails plugin
                // TODO: Really need to work on some sort of plug-in wide event bus or pub-sub for this
                this.bind(elements.progress, "mousemove touchmove", (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startMove(event);
                });
                // Hide thumbnail preview - on mouse click, mouse leave, and video play/seek. All four are required, e.g., for buffering
                this.bind(elements.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endMove(false, true);
                });
                // Show scrubbing preview
                this.bind(elements.progress, "mousedown touchstart", (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startScrubbing(event);
                });
                this.bind(elements.progress, "mouseup touchend", (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endScrubbing(event);
                });
                // Polyfill for lower fill in <input type="range"> for webkit
                if (browser.isWebkit) Array.from(getElements.call(player, 'input[type="range"]')).forEach((element)=>{
                    this.bind(element, "input", (event)=>controls.updateRangeFill.call(player, event.target));
                });
                // Current time invert
                // Only if one time element is used for both currentTime and duration
                if (player.config.toggleInvert && !is.element(elements.display.duration)) this.bind(elements.display.currentTime, "click", ()=>{
                    // Do nothing if we're at the start
                    if (player.currentTime === 0) return;
                    player.config.invertTime = !player.config.invertTime;
                    controls.timeUpdate.call(player);
                });
                // Volume
                this.bind(elements.inputs.volume, inputEvent, (event)=>{
                    player.volume = event.target.value;
                }, "volume");
                // Update controls.hover state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, "mouseenter mouseleave", (event)=>{
                    elements.controls.hover = !player.touch && event.type === "mouseenter";
                });
                // Also update controls.hover state for any non-player children of fullscreen element (as above)
                if (elements.fullscreen) Array.from(elements.fullscreen.children).filter((c)=>!c.contains(elements.container)).forEach((child)=>{
                    this.bind(child, "mouseenter mouseleave", (event)=>{
                        if (elements.controls) elements.controls.hover = !player.touch && event.type === "mouseenter";
                    });
                });
                // Update controls.pressed state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, "mousedown mouseup touchstart touchend touchcancel", (event)=>{
                    elements.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(event.type);
                });
                // Show controls when they receive focus (e.g., when using keyboard tab key)
                this.bind(elements.controls, "focusin", ()=>{
                    const { config: config, timers: timers } = player;
                    // Skip transition to prevent focus from scrolling the parent element
                    toggleClass(elements.controls, config.classNames.noTransition, true);
                    // Toggle
                    ui.toggleControls.call(player, true);
                    // Restore transition
                    setTimeout(()=>{
                        toggleClass(elements.controls, config.classNames.noTransition, false);
                    }, 0);
                    // Delay a little more for mouse users
                    const delay = this.touch ? 3000 : 4000;
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Hide again after delay
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Mouse wheel for volume
                this.bind(elements.inputs.volume, "wheel", (event)=>{
                    // Detect "natural" scroll - supported on OS X Safari only
                    // Other browsers on OS X will be inverted until support improves
                    const inverted = event.webkitDirectionInvertedFromDevice;
                    // Get delta from event. Invert if `inverted` is true
                    const [x, y] = [
                        event.deltaX,
                        -event.deltaY
                    ].map((value)=>inverted ? -value : value);
                    // Using the biggest delta, normalize to 1 or -1 (or 0 if no delta)
                    const direction = Math.sign(Math.abs(x) > Math.abs(y) ? x : y);
                    // Change the volume by 2%
                    player.increaseVolume(direction / 50);
                    // Don't break page scrolling at max and min
                    const { volume: volume } = player.media;
                    if (direction === 1 && volume < 1 || direction === -1 && volume > 0) event.preventDefault();
                }, "volume", false);
            });
            this.player = _player;
            this.lastKey = null;
            this.focusTimer = null;
            this.lastKeyDown = null;
            this.handleKey = this.handleKey.bind(this);
            this.toggleMenu = this.toggleMenu.bind(this);
            this.setTabFocus = this.setTabFocus.bind(this);
            this.firstTouch = this.firstTouch.bind(this);
        }
        // Handle key presses
        handleKey(event) {
            const { player: player } = this;
            const { elements: elements } = player;
            const { key: key, type: type, altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
            const pressed = type === "keydown";
            const repeat = pressed && key === this.lastKey;
            // Bail if a modifier key is set
            if (altKey || ctrlKey || metaKey || shiftKey) return;
            // If the event is bubbled from the media element
            // Firefox doesn't get the key for whatever reason
            if (!key) return;
            // Seek by increment
            const seekByIncrement = (increment)=>{
                // Divide the max duration into 10th's and times by the number value
                player.currentTime = player.duration / 10 * increment;
            };
            // Handle the key on keydown
            // Reset on keyup
            if (pressed) {
                // Check focused element
                // and if the focused element is not editable (e.g. text input)
                // and any that accept key input http://webaim.org/techniques/keyboard/
                const focused = document.activeElement;
                if (is.element(focused)) {
                    const { editable: editable } = player.config.selectors;
                    const { seek: seek } = elements.inputs;
                    if (focused !== seek && matches(focused, editable)) return;
                    if (event.key === "Space" && matches(focused, 'button, [role^="menuitem"]')) return;
                }
                // Which keys should we prevent default
                const preventDefault = [
                    "Space",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ];
                // If the key is found prevent default (e.g. prevent scrolling for arrows)
                if (preventDefault.includes(key)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                switch(key){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        if (!repeat) seekByIncrement(parseInt(key, 10));
                        break;
                    case "Space":
                    case "k":
                        if (!repeat) silencePromise(player.togglePlay());
                        break;
                    case "ArrowUp":
                        player.increaseVolume(0.1);
                        break;
                    case "ArrowDown":
                        player.decreaseVolume(0.1);
                        break;
                    case "m":
                        if (!repeat) player.muted = !player.muted;
                        break;
                    case "ArrowRight":
                        player.forward();
                        break;
                    case "ArrowLeft":
                        player.rewind();
                        break;
                    case "f":
                        player.fullscreen.toggle();
                        break;
                    case "c":
                        if (!repeat) player.toggleCaptions();
                        break;
                    case "l":
                        player.loop = !player.loop;
                        break;
                }
                // Escape is handle natively when in full screen
                // So we only need to worry about non native
                if (key === "Escape" && !player.fullscreen.usingNative && player.fullscreen.active) player.fullscreen.toggle();
                // Store last key for next cycle
                this.lastKey = key;
            } else this.lastKey = null;
        }
        // Toggle menu
        toggleMenu(event) {
            controls.toggleMenu.call(this.player, event);
        }
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var loadjs_umd = createCommonjsModule(function(module1, exports) {
        (function(root, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            /**
       * Global dependencies.
       * @global {Object} document - DOM
       */ var devnull = function() {}, bundleIdCache = {}, bundleResultCache = {}, bundleCallbackQueue = {};
            /**
       * Subscribe to bundle load event.
       * @param {string[]} bundleIds - Bundle ids
       * @param {Function} callbackFn - The callback function
       */ function subscribe(bundleIds, callbackFn) {
                // listify
                bundleIds = bundleIds.push ? bundleIds : [
                    bundleIds
                ];
                var depsNotFound = [], i = bundleIds.length, numWaiting = i, fn, bundleId, r, q;
                // define callback function
                fn = function(bundleId, pathsNotFound) {
                    if (pathsNotFound.length) depsNotFound.push(bundleId);
                    numWaiting--;
                    if (!numWaiting) callbackFn(depsNotFound);
                };
                // register callback
                while(i--){
                    bundleId = bundleIds[i];
                    // execute callback if in result cache
                    r = bundleResultCache[bundleId];
                    if (r) {
                        fn(bundleId, r);
                        continue;
                    }
                    // add to callback queue
                    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
                    q.push(fn);
                }
            }
            /**
       * Publish bundle load event.
       * @param {string} bundleId - Bundle id
       * @param {string[]} pathsNotFound - List of files not found
       */ function publish(bundleId, pathsNotFound) {
                // exit if id isn't defined
                if (!bundleId) return;
                var q = bundleCallbackQueue[bundleId];
                // cache result
                bundleResultCache[bundleId] = pathsNotFound;
                // exit if queue is empty
                if (!q) return;
                // empty callback queue
                while(q.length){
                    q[0](bundleId, pathsNotFound);
                    q.splice(0, 1);
                }
            }
            /**
       * Execute callbacks.
       * @param {Object or Function} args - The callback args
       * @param {string[]} depsNotFound - List of dependencies not found
       */ function executeCallbacks(args, depsNotFound) {
                // accept function as argument
                if (args.call) args = {
                    success: args
                };
                // success and error callbacks
                if (depsNotFound.length) (args.error || devnull)(depsNotFound);
                else (args.success || devnull)(args);
            }
            /**
       * Load individual file.
       * @param {string} path - The file path
       * @param {Function} callbackFn - The callback function
       */ function loadFile(path, callbackFn, args, numTries) {
                var doc = document, async = args.async, maxTries = (args.numRetries || 0) + 1, beforeCallbackFn = args.before || devnull, pathname = path.replace(/[\?|#].*$/, ""), pathStripped = path.replace(/^(css|img)!/, ""), isLegacyIECss, e;
                numTries = numTries || 0;
                if (/(^css!|\.css$)/.test(pathname)) {
                    // css
                    e = doc.createElement("link");
                    e.rel = "stylesheet";
                    e.href = pathStripped;
                    // tag IE9+
                    isLegacyIECss = "hideFocus" in e;
                    // use preload in IE Edge (to detect load errors)
                    if (isLegacyIECss && e.relList) {
                        isLegacyIECss = 0;
                        e.rel = "preload";
                        e.as = "style";
                    }
                } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
                    // image
                    e = doc.createElement("img");
                    e.src = pathStripped;
                } else {
                    // javascript
                    e = doc.createElement("script");
                    e.src = path;
                    e.async = async === undefined ? true : async;
                }
                e.onload = e.onerror = e.onbeforeload = function(ev) {
                    var result = ev.type[0];
                    // treat empty stylesheets as failures to get around lack of onerror
                    // support in IE9-11
                    if (isLegacyIECss) try {
                        if (!e.sheet.cssText.length) result = "e";
                    } catch (x) {
                        // sheets objects created from load errors don't allow access to
                        // `cssText` (unless error is Code:18 SecurityError)
                        if (x.code != 18) result = "e";
                    }
                    // handle retries in case of load failure
                    if (result == "e") {
                        // increment counter
                        numTries += 1;
                        // exit function and try again
                        if (numTries < maxTries) return loadFile(path, callbackFn, args, numTries);
                    } else if (e.rel == "preload" && e.as == "style") // activate preloaded stylesheets
                    return e.rel = "stylesheet"; // jshint ignore:line
                    // execute callback
                    callbackFn(path, result, ev.defaultPrevented);
                };
                // add to document (unless callback returns `false`)
                if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
            }
            /**
       * Load multiple files.
       * @param {string[]} paths - The file paths
       * @param {Function} callbackFn - The callback function
       */ function loadFiles(paths, callbackFn, args) {
                // listify paths
                paths = paths.push ? paths : [
                    paths
                ];
                var numWaiting = paths.length, x = numWaiting, pathsNotFound = [], fn, i;
                // define callback function
                fn = function(path, result, defaultPrevented) {
                    // handle error
                    if (result == "e") pathsNotFound.push(path);
                    // handle beforeload event. If defaultPrevented then that means the load
                    // will be blocked (ex. Ghostery/ABP on Safari)
                    if (result == "b") {
                        if (defaultPrevented) pathsNotFound.push(path);
                        else return;
                    }
                    numWaiting--;
                    if (!numWaiting) callbackFn(pathsNotFound);
                };
                // load scripts
                for(i = 0; i < x; i++)loadFile(paths[i], fn, args);
            }
            /**
       * Initiate script load and register bundle.
       * @param {(string|string[])} paths - The file paths
       * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
       *   callback or (3) object literal with success/error arguments, numRetries,
       *   etc.
       * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
       *   literal with success/error arguments, numRetries, etc.
       */ function loadjs(paths, arg1, arg2) {
                var bundleId, args;
                // bundleId (if string)
                if (arg1 && arg1.trim) bundleId = arg1;
                // args (default is {})
                args = (bundleId ? arg2 : arg1) || {};
                // throw error if bundle is already defined
                if (bundleId) {
                    if (bundleId in bundleIdCache) throw "LoadJS";
                    else bundleIdCache[bundleId] = true;
                }
                function loadFn(resolve, reject) {
                    loadFiles(paths, function(pathsNotFound) {
                        // execute callbacks
                        executeCallbacks(args, pathsNotFound);
                        // resolve Promise
                        if (resolve) executeCallbacks({
                            success: resolve,
                            error: reject
                        }, pathsNotFound);
                        // publish bundle load event
                        publish(bundleId, pathsNotFound);
                    }, args);
                }
                if (args.returnPromise) return new Promise(loadFn);
                else loadFn();
            }
            /**
       * Execute callbacks when dependencies have been satisfied.
       * @param {(string|string[])} deps - List of bundle ids
       * @param {Object} args - success/error arguments
       */ loadjs.ready = function ready(deps, args) {
                // subscribe to bundle load event
                subscribe(deps, function(depsNotFound) {
                    // execute callbacks
                    executeCallbacks(args, depsNotFound);
                });
                return loadjs;
            };
            /**
       * Manually satisfy bundle dependencies.
       * @param {string} bundleId - The bundle id
       */ loadjs.done = function done(bundleId) {
                publish(bundleId, []);
            };
            /**
       * Reset loadjs dependencies statuses
       */ loadjs.reset = function reset() {
                bundleIdCache = {};
                bundleResultCache = {};
                bundleCallbackQueue = {};
            };
            /**
       * Determine if bundle has already been defined
       * @param String} bundleId - The bundle id
       */ loadjs.isDefined = function isDefined(bundleId) {
                return bundleId in bundleIdCache;
            };
            // export
            return loadjs;
        });
    });
    // ==========================================================================
    function loadScript(url) {
        return new Promise((resolve, reject)=>{
            loadjs_umd(url, {
                success: resolve,
                error: reject
            });
        });
    }
    // ==========================================================================
    // Parse Vimeo ID from URL
    function parseId$1(url) {
        if (is.empty(url)) return null;
        if (is.number(Number(url))) return url;
        const regex = /^.*(vimeo.com\/|video\/)(\d+).*/;
        return url.match(regex) ? RegExp.$2 : url;
    }
    // Try to extract a hash for private videos from the URL
    function parseHash(url) {
        /* This regex matches a hexadecimal hash if given in any of these forms:
     *  - [https://player.]vimeo.com/video/{id}/{hash}[?params]
     *  - [https://player.]vimeo.com/video/{id}?h={hash}[&params]
     *  - [https://player.]vimeo.com/video/{id}?[params]&h={hash}
     *  - video/{id}/{hash}
     * If matched, the hash is available in capture group 4
     */ const regex = /^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/;
        const found = url.match(regex);
        return found && found.length === 5 ? found[4] : null;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState$1(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? "play" : "pause");
        }
    }
    const vimeo = {
        setup () {
            const player = this;
            // Add embed class for responsive
            toggleClass(player.elements.wrapper, player.config.classNames.embed, true);
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set intial ratio
            setAspectRatio.call(player);
            // Load the SDK if not already
            if (!is.object(window.Vimeo)) loadScript(player.config.urls.vimeo.sdk).then(()=>{
                vimeo.ready.call(player);
            }).catch((error)=>{
                player.debug.warn("Vimeo SDK (player.js) failed to load", error);
            });
            else vimeo.ready.call(player);
        },
        // API Ready
        ready () {
            const player = this;
            const config = player.config.vimeo;
            const { premium: premium, referrerPolicy: referrerPolicy, ...frameParams } = config;
            // Get the source URL or ID
            let source = player.media.getAttribute("src");
            let hash = "";
            // Get from <div> if needed
            if (is.empty(source)) {
                source = player.media.getAttribute(player.config.attributes.embed.id);
                // hash can also be set as attribute on the <div>
                hash = player.media.getAttribute(player.config.attributes.embed.hash);
            } else hash = parseHash(source);
            const hashParam = hash ? {
                h: hash
            } : {};
            // If the owner has a pro or premium account then we can hide controls etc
            if (premium) Object.assign(frameParams, {
                controls: false,
                sidedock: false
            });
            // Get Vimeo params for the iframe
            const params = buildUrlParams({
                loop: player.config.loop.active,
                autoplay: player.autoplay,
                muted: player.muted,
                gesture: "media",
                playsinline: !this.config.fullscreen.iosNative,
                // hash has to be added to iframe-URL
                ...hashParam,
                ...frameParams
            });
            const id = parseId$1(source);
            // Build an iframe
            const iframe = createElement("iframe");
            const src = format(player.config.urls.vimeo.iframe, id, params);
            iframe.setAttribute("src", src);
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; "));
            // Set the referrer policy if required
            if (!is.empty(referrerPolicy)) iframe.setAttribute("referrerPolicy", referrerPolicy);
            // Inject the package
            if (premium || !config.customControls) {
                iframe.setAttribute("data-poster", player.poster);
                player.media = replaceElement(iframe, player.media);
            } else {
                const wrapper = createElement("div", {
                    class: player.config.classNames.embedContainer,
                    "data-poster": player.poster
                });
                wrapper.appendChild(iframe);
                player.media = replaceElement(wrapper, player.media);
            }
            // Get poster image
            if (!config.customControls) fetch(format(player.config.urls.vimeo.api, src)).then((response)=>{
                if (is.empty(response) || !response.thumbnail_url) return;
                // Set and show poster
                ui.setPoster.call(player, response.thumbnail_url).catch(()=>{});
            });
            // Setup instance
            // https://github.com/vimeo/player.js
            player.embed = new window.Vimeo.Player(iframe, {
                autopause: player.config.autopause,
                muted: player.muted
            });
            player.media.paused = true;
            player.media.currentTime = 0;
            // Disable native text track rendering
            if (player.supported.ui) player.embed.disableTextTrack();
            // Create a faux HTML5 API using the Vimeo API
            player.media.play = ()=>{
                assurePlaybackState$1.call(player, true);
                return player.embed.play();
            };
            player.media.pause = ()=>{
                assurePlaybackState$1.call(player, false);
                return player.embed.pause();
            };
            player.media.stop = ()=>{
                player.pause();
                player.currentTime = 0;
            };
            // Seeking
            let { currentTime: currentTime } = player.media;
            Object.defineProperty(player.media, "currentTime", {
                get () {
                    return currentTime;
                },
                set (time) {
                    // Vimeo will automatically play on seek if the video hasn't been played before
                    // Get current paused state and volume etc
                    const { embed: embed, media: media, paused: paused, volume: volume } = player;
                    const restorePause = paused && !embed.hasPlayed;
                    // Set seeking state and trigger event
                    media.seeking = true;
                    triggerEvent.call(player, media, "seeking");
                    // If paused, mute until seek is complete
                    Promise.resolve(restorePause && embed.setVolume(0))// Seek
                    .then(()=>embed.setCurrentTime(time))// Restore paused
                    .then(()=>restorePause && embed.pause())// Restore volume
                    .then(()=>restorePause && embed.setVolume(volume)).catch(()=>{
                    // Do nothing
                    });
                }
            });
            // Playback speed
            let speed = player.config.speed.selected;
            Object.defineProperty(player.media, "playbackRate", {
                get () {
                    return speed;
                },
                set (input) {
                    player.embed.setPlaybackRate(input).then(()=>{
                        speed = input;
                        triggerEvent.call(player, player.media, "ratechange");
                    }).catch(()=>{
                        // Cannot set Playback Rate, Video is probably not on Pro account
                        player.options.speed = [
                            1
                        ];
                    });
                }
            });
            // Volume
            let { volume: volume } = player.config;
            Object.defineProperty(player.media, "volume", {
                get () {
                    return volume;
                },
                set (input) {
                    player.embed.setVolume(input).then(()=>{
                        volume = input;
                        triggerEvent.call(player, player.media, "volumechange");
                    });
                }
            });
            // Muted
            let { muted: muted } = player.config;
            Object.defineProperty(player.media, "muted", {
                get () {
                    return muted;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : false;
                    player.embed.setVolume(toggle ? 0 : player.config.volume).then(()=>{
                        muted = toggle;
                        triggerEvent.call(player, player.media, "volumechange");
                    });
                }
            });
            // Loop
            let { loop: loop } = player.config;
            Object.defineProperty(player.media, "loop", {
                get () {
                    return loop;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : player.config.loop.active;
                    player.embed.setLoop(toggle).then(()=>{
                        loop = toggle;
                    });
                }
            });
            // Source
            let currentSrc;
            player.embed.getVideoUrl().then((value)=>{
                currentSrc = value;
                controls.setDownloadUrl.call(player);
            }).catch((error)=>{
                this.debug.warn(error);
            });
            Object.defineProperty(player.media, "currentSrc", {
                get () {
                    return currentSrc;
                }
            });
            // Ended
            Object.defineProperty(player.media, "ended", {
                get () {
                    return player.currentTime === player.duration;
                }
            });
            // Set aspect ratio based on video size
            Promise.all([
                player.embed.getVideoWidth(),
                player.embed.getVideoHeight()
            ]).then((dimensions)=>{
                const [width, height] = dimensions;
                player.embed.ratio = roundAspectRatio(width, height);
                setAspectRatio.call(this);
            });
            // Set autopause
            player.embed.setAutopause(player.config.autopause).then((state)=>{
                player.config.autopause = state;
            });
            // Get title
            player.embed.getVideoTitle().then((title)=>{
                player.config.title = title;
                ui.setTitle.call(this);
            });
            // Get current time
            player.embed.getCurrentTime().then((value)=>{
                currentTime = value;
                triggerEvent.call(player, player.media, "timeupdate");
            });
            // Get duration
            player.embed.getDuration().then((value)=>{
                player.media.duration = value;
                triggerEvent.call(player, player.media, "durationchange");
            });
            // Get captions
            player.embed.getTextTracks().then((tracks)=>{
                player.media.textTracks = tracks;
                captions.setup.call(player);
            });
            player.embed.on("cuechange", ({ cues: cues = [] })=>{
                const strippedCues = cues.map((cue)=>stripHTML(cue.text));
                captions.updateCues.call(player, strippedCues);
            });
            player.embed.on("loaded", ()=>{
                // Assure state and events are updated on autoplay
                player.embed.getPaused().then((paused)=>{
                    assurePlaybackState$1.call(player, !paused);
                    if (!paused) triggerEvent.call(player, player.media, "playing");
                });
                if (is.element(player.embed.element) && player.supported.ui) {
                    const frame = player.embed.element;
                    // Fix keyboard focus issues
                    // https://github.com/sampotts/plyr/issues/317
                    frame.setAttribute("tabindex", -1);
                }
            });
            player.embed.on("bufferstart", ()=>{
                triggerEvent.call(player, player.media, "waiting");
            });
            player.embed.on("bufferend", ()=>{
                triggerEvent.call(player, player.media, "playing");
            });
            player.embed.on("play", ()=>{
                assurePlaybackState$1.call(player, true);
                triggerEvent.call(player, player.media, "playing");
            });
            player.embed.on("pause", ()=>{
                assurePlaybackState$1.call(player, false);
            });
            player.embed.on("timeupdate", (data)=>{
                player.media.seeking = false;
                currentTime = data.seconds;
                triggerEvent.call(player, player.media, "timeupdate");
            });
            player.embed.on("progress", (data)=>{
                player.media.buffered = data.percent;
                triggerEvent.call(player, player.media, "progress");
                // Check all loaded
                if (parseInt(data.percent, 10) === 1) triggerEvent.call(player, player.media, "canplaythrough");
                // Get duration as if we do it before load, it gives an incorrect value
                // https://github.com/sampotts/plyr/issues/891
                player.embed.getDuration().then((value)=>{
                    if (value !== player.media.duration) {
                        player.media.duration = value;
                        triggerEvent.call(player, player.media, "durationchange");
                    }
                });
            });
            player.embed.on("seeked", ()=>{
                player.media.seeking = false;
                triggerEvent.call(player, player.media, "seeked");
            });
            player.embed.on("ended", ()=>{
                player.media.paused = true;
                triggerEvent.call(player, player.media, "ended");
            });
            player.embed.on("error", (detail)=>{
                player.media.error = detail;
                triggerEvent.call(player, player.media, "error");
            });
            // Rebuild UI
            if (config.customControls) setTimeout(()=>ui.build.call(player), 0);
        }
    };
    // ==========================================================================
    // Parse YouTube ID from URL
    function parseId(url) {
        if (is.empty(url)) return null;
        const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        return url.match(regex) ? RegExp.$2 : url;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? "play" : "pause");
        }
    }
    function getHost(config) {
        if (config.noCookie) return "https://www.youtube-nocookie.com";
        if (window.location.protocol === "http:") return "http://www.youtube.com";
        // Use YouTube's default
        return undefined;
    }
    const youtube = {
        setup () {
            // Add embed class for responsive
            toggleClass(this.elements.wrapper, this.config.classNames.embed, true);
            // Setup API
            if (is.object(window.YT) && is.function(window.YT.Player)) youtube.ready.call(this);
            else {
                // Reference current global callback
                const callback = window.onYouTubeIframeAPIReady;
                // Set callback to process queue
                window.onYouTubeIframeAPIReady = ()=>{
                    // Call global callback if set
                    if (is.function(callback)) callback();
                    youtube.ready.call(this);
                };
                // Load the SDK
                loadScript(this.config.urls.youtube.sdk).catch((error)=>{
                    this.debug.warn("YouTube API failed to load", error);
                });
            }
        },
        // Get the media title
        getTitle (videoId) {
            const url = format(this.config.urls.youtube.api, videoId);
            fetch(url).then((data)=>{
                if (is.object(data)) {
                    const { title: title, height: height, width: width } = data;
                    // Set title
                    this.config.title = title;
                    ui.setTitle.call(this);
                    // Set aspect ratio
                    this.embed.ratio = roundAspectRatio(width, height);
                }
                setAspectRatio.call(this);
            }).catch(()=>{
                // Set aspect ratio
                setAspectRatio.call(this);
            });
        },
        // API ready
        ready () {
            const player = this;
            const config = player.config.youtube;
            // Ignore already setup (race condition)
            const currentId = player.media && player.media.getAttribute("id");
            if (!is.empty(currentId) && currentId.startsWith("youtube-")) return;
            // Get the source URL or ID
            let source = player.media.getAttribute("src");
            // Get from <div> if needed
            if (is.empty(source)) source = player.media.getAttribute(this.config.attributes.embed.id);
            // Replace the <iframe> with a <div> due to YouTube API issues
            const videoId = parseId(source);
            const id = generateId(player.provider);
            // Replace media element
            const container = createElement("div", {
                id: id,
                "data-poster": config.customControls ? player.poster : undefined
            });
            player.media = replaceElement(container, player.media);
            // Only load the poster when using custom controls
            if (config.customControls) {
                const posterSrc = (s)=>`https://i.ytimg.com/vi/${videoId}/${s}default.jpg`;
                // Check thumbnail images in order of quality, but reject fallback thumbnails (120px wide)
                loadImage(posterSrc("maxres"), 121) // Higest quality and unpadded
                .catch(()=>loadImage(posterSrc("sd"), 121)) // 480p padded 4:3
                .catch(()=>loadImage(posterSrc("hq"))) // 360p padded 4:3. Always exists
                .then((image)=>ui.setPoster.call(player, image.src)).then((src)=>{
                    // If the image is padded, use background-size "cover" instead (like youtube does too with their posters)
                    if (!src.includes("maxres")) player.elements.poster.style.backgroundSize = "cover";
                }).catch(()=>{});
            }
            // Setup instance
            // https://developers.google.com/youtube/iframe_api_reference
            player.embed = new window.YT.Player(player.media, {
                videoId: videoId,
                host: getHost(config),
                playerVars: extend({}, {
                    // Autoplay
                    autoplay: player.config.autoplay ? 1 : 0,
                    // iframe interface language
                    hl: player.config.hl,
                    // Only show controls if not fully supported or opted out
                    controls: player.supported.ui && config.customControls ? 0 : 1,
                    // Disable keyboard as we handle it
                    disablekb: 1,
                    // Allow iOS inline playback
                    playsinline: !player.config.fullscreen.iosNative ? 1 : 0,
                    // Captions are flaky on YouTube
                    cc_load_policy: player.captions.active ? 1 : 0,
                    cc_lang_pref: player.config.captions.language,
                    // Tracking for stats
                    widget_referrer: window ? window.location.href : null
                }, config),
                events: {
                    onError (event) {
                        // YouTube may fire onError twice, so only handle it once
                        if (!player.media.error) {
                            const code = event.data;
                            // Messages copied from https://developers.google.com/youtube/iframe_api_reference#onError
                            const message = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[code] || "An unknown error occured";
                            player.media.error = {
                                code: code,
                                message: message
                            };
                            triggerEvent.call(player, player.media, "error");
                        }
                    },
                    onPlaybackRateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Get current speed
                        player.media.playbackRate = instance.getPlaybackRate();
                        triggerEvent.call(player, player.media, "ratechange");
                    },
                    onReady (event) {
                        // Bail if onReady has already been called. See issue #1108
                        if (is.function(player.media.play)) return;
                        // Get the instance
                        const instance = event.target;
                        // Get the title
                        youtube.getTitle.call(player, videoId);
                        // Create a faux HTML5 API using the YouTube API
                        player.media.play = ()=>{
                            assurePlaybackState.call(player, true);
                            instance.playVideo();
                        };
                        player.media.pause = ()=>{
                            assurePlaybackState.call(player, false);
                            instance.pauseVideo();
                        };
                        player.media.stop = ()=>{
                            instance.stopVideo();
                        };
                        player.media.duration = instance.getDuration();
                        player.media.paused = true;
                        // Seeking
                        player.media.currentTime = 0;
                        Object.defineProperty(player.media, "currentTime", {
                            get () {
                                return Number(instance.getCurrentTime());
                            },
                            set (time) {
                                // If paused and never played, mute audio preventively (YouTube starts playing on seek if the video hasn't been played yet).
                                if (player.paused && !player.embed.hasPlayed) player.embed.mute();
                                // Set seeking state and trigger event
                                player.media.seeking = true;
                                triggerEvent.call(player, player.media, "seeking");
                                // Seek after events sent
                                instance.seekTo(time);
                            }
                        });
                        // Playback speed
                        Object.defineProperty(player.media, "playbackRate", {
                            get () {
                                return instance.getPlaybackRate();
                            },
                            set (input) {
                                instance.setPlaybackRate(input);
                            }
                        });
                        // Volume
                        let { volume: volume } = player.config;
                        Object.defineProperty(player.media, "volume", {
                            get () {
                                return volume;
                            },
                            set (input) {
                                volume = input;
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, "volumechange");
                            }
                        });
                        // Muted
                        let { muted: muted } = player.config;
                        Object.defineProperty(player.media, "muted", {
                            get () {
                                return muted;
                            },
                            set (input) {
                                const toggle = is.boolean(input) ? input : muted;
                                muted = toggle;
                                instance[toggle ? "mute" : "unMute"]();
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, "volumechange");
                            }
                        });
                        // Source
                        Object.defineProperty(player.media, "currentSrc", {
                            get () {
                                return instance.getVideoUrl();
                            }
                        });
                        // Ended
                        Object.defineProperty(player.media, "ended", {
                            get () {
                                return player.currentTime === player.duration;
                            }
                        });
                        // Get available speeds
                        const speeds = instance.getAvailablePlaybackRates();
                        // Filter based on config
                        player.options.speed = speeds.filter((s)=>player.config.speed.options.includes(s));
                        // Set the tabindex to avoid focus entering iframe
                        if (player.supported.ui && config.customControls) player.media.setAttribute("tabindex", -1);
                        triggerEvent.call(player, player.media, "timeupdate");
                        triggerEvent.call(player, player.media, "durationchange");
                        // Reset timer
                        clearInterval(player.timers.buffering);
                        // Setup buffering
                        player.timers.buffering = setInterval(()=>{
                            // Get loaded % from YouTube
                            player.media.buffered = instance.getVideoLoadedFraction();
                            // Trigger progress only when we actually buffer something
                            if (player.media.lastBuffered === null || player.media.lastBuffered < player.media.buffered) triggerEvent.call(player, player.media, "progress");
                            // Set last buffer point
                            player.media.lastBuffered = player.media.buffered;
                            // Bail if we're at 100%
                            if (player.media.buffered === 1) {
                                clearInterval(player.timers.buffering);
                                // Trigger event
                                triggerEvent.call(player, player.media, "canplaythrough");
                            }
                        }, 200);
                        // Rebuild UI
                        if (config.customControls) setTimeout(()=>ui.build.call(player), 50);
                    },
                    onStateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Reset timer
                        clearInterval(player.timers.playing);
                        const seeked = player.media.seeking && [
                            1,
                            2
                        ].includes(event.data);
                        if (seeked) {
                            // Unset seeking and fire seeked event
                            player.media.seeking = false;
                            triggerEvent.call(player, player.media, "seeked");
                        }
                        // Handle events
                        // -1   Unstarted
                        // 0    Ended
                        // 1    Playing
                        // 2    Paused
                        // 3    Buffering
                        // 5    Video cued
                        switch(event.data){
                            case -1:
                                // Update scrubber
                                triggerEvent.call(player, player.media, "timeupdate");
                                // Get loaded % from YouTube
                                player.media.buffered = instance.getVideoLoadedFraction();
                                triggerEvent.call(player, player.media, "progress");
                                break;
                            case 0:
                                assurePlaybackState.call(player, false);
                                // YouTube doesn't support loop for a single video, so mimick it.
                                if (player.media.loop) {
                                    // YouTube needs a call to `stopVideo` before playing again
                                    instance.stopVideo();
                                    instance.playVideo();
                                } else triggerEvent.call(player, player.media, "ended");
                                break;
                            case 1:
                                // Restore paused state (YouTube starts playing on seek if the video hasn't been played yet)
                                if (config.customControls && !player.config.autoplay && player.media.paused && !player.embed.hasPlayed) player.media.pause();
                                else {
                                    assurePlaybackState.call(player, true);
                                    triggerEvent.call(player, player.media, "playing");
                                    // Poll to get playback progress
                                    player.timers.playing = setInterval(()=>{
                                        triggerEvent.call(player, player.media, "timeupdate");
                                    }, 50);
                                    // Check duration again due to YouTube bug
                                    // https://github.com/sampotts/plyr/issues/374
                                    // https://code.google.com/p/gdata-issues/issues/detail?id=8690
                                    if (player.media.duration !== instance.getDuration()) {
                                        player.media.duration = instance.getDuration();
                                        triggerEvent.call(player, player.media, "durationchange");
                                    }
                                }
                                break;
                            case 2:
                                // Restore audio (YouTube starts playing on seek if the video hasn't been played yet)
                                if (!player.muted) player.embed.unMute();
                                assurePlaybackState.call(player, false);
                                break;
                            case 3:
                                // Trigger waiting event to add loading classes to container as the video buffers.
                                triggerEvent.call(player, player.media, "waiting");
                                break;
                        }
                        triggerEvent.call(player, player.elements.container, "statechange", false, {
                            code: event.data
                        });
                    }
                }
            });
        }
    };
    // ==========================================================================
    const media = {
        // Setup media
        setup () {
            // If there's no media, bail
            if (!this.media) {
                this.debug.warn("No media element found!");
                return;
            }
            // Add type class
            toggleClass(this.elements.container, this.config.classNames.type.replace("{0}", this.type), true);
            // Add provider class
            toggleClass(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), true);
            // Add video class for embeds
            // This will require changes if audio embeds are added
            if (this.isEmbed) toggleClass(this.elements.container, this.config.classNames.type.replace("{0}", "video"), true);
            // Inject the player wrapper
            if (this.isVideo) {
                // Create the wrapper div
                this.elements.wrapper = createElement("div", {
                    class: this.config.classNames.video
                });
                // Wrap the video in a container
                wrap(this.media, this.elements.wrapper);
                // Poster image container
                this.elements.poster = createElement("div", {
                    class: this.config.classNames.poster
                });
                this.elements.wrapper.appendChild(this.elements.poster);
            }
            if (this.isHTML5) html5.setup.call(this);
            else if (this.isYouTube) youtube.setup.call(this);
            else if (this.isVimeo) vimeo.setup.call(this);
        }
    };
    const destroy = (instance)=>{
        // Destroy our adsManager
        if (instance.manager) instance.manager.destroy();
        // Destroy our adsManager
        if (instance.elements.displayContainer) instance.elements.displayContainer.destroy();
        instance.elements.container.remove();
    };
    class Ads {
        /**
     * Ads constructor.
     * @param {Object} player
     * @return {Ads}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                if (!this.enabled) return;
                // Check if the Google IMA3 SDK is loaded or load it ourselves
                if (!is.object(window.google) || !is.object(window.google.ima)) loadScript(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    // Script failed to load or is blocked
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                });
                else this.ready();
            });
            _defineProperty$1(this, "ready", ()=>{
                // Double check we're enabled
                if (!this.enabled) destroy(this);
                // Start ticking our safety timer. If the whole advertisement
                // thing doesn't resolve within our set time; we bail
                this.startSafetyTimer(12000, "ready()");
                // Clear the safety timer
                this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                });
                // Set listeners on the Plyr instance
                this.listeners();
                // Setup the IMA SDK
                this.setupIMA();
            });
            _defineProperty$1(this, "setupIMA", ()=>{
                // Create the container for our advertisements
                this.elements.container = createElement("div", {
                    class: this.player.config.classNames.ads
                });
                this.player.elements.container.appendChild(this.elements.container);
                // So we can run VPAID2
                google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED);
                // Set language
                google.ima.settings.setLocale(this.player.config.ads.language);
                // Set playback for iOS10+
                google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline);
                // We assume the adContainer is the video container of the plyr element that will house the ads
                this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media);
                // Create ads loader
                this.loader = new google.ima.AdsLoader(this.elements.displayContainer);
                // Listen and respond to ads loaded and error events
                this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (event)=>this.onAdsManagerLoaded(event), false);
                this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error), false);
                // Request video ads to be pre-loaded
                this.requestAds();
            });
            _defineProperty$1(this, "requestAds", ()=>{
                const { container: container } = this.player.elements;
                try {
                    // Request video ads
                    const request = new google.ima.AdsRequest();
                    request.adTagUrl = this.tagUrl;
                    // Specify the linear and nonlinear slot sizes. This helps the SDK
                    // to select the correct creative if multiple are returned
                    request.linearAdSlotWidth = container.offsetWidth;
                    request.linearAdSlotHeight = container.offsetHeight;
                    request.nonLinearAdSlotWidth = container.offsetWidth;
                    request.nonLinearAdSlotHeight = container.offsetHeight;
                    // We only overlay ads as we only support video.
                    request.forceNonLinearFullSlot = false;
                    // Mute based on current state
                    request.setAdWillPlayMuted(!this.player.muted);
                    this.loader.requestAds(request);
                } catch (error) {
                    this.onAdError(error);
                }
            });
            _defineProperty$1(this, "pollCountdown", (start = false)=>{
                if (!start) {
                    clearInterval(this.countdownTimer);
                    this.elements.container.removeAttribute("data-badge-text");
                    return;
                }
                const update = ()=>{
                    const time = formatTime(Math.max(this.manager.getRemainingTime(), 0));
                    const label = `${i18n.get("advertisement", this.player.config)} - ${time}`;
                    this.elements.container.setAttribute("data-badge-text", label);
                };
                this.countdownTimer = setInterval(update, 100);
            });
            _defineProperty$1(this, "onAdsManagerLoaded", (event)=>{
                // Load could occur after a source change (race condition)
                if (!this.enabled) return;
                // Get the ads manager
                const settings = new google.ima.AdsRenderingSettings();
                // Tell the SDK to save and restore content video state on our behalf
                settings.restoreCustomPlaybackStateOnAdBreakComplete = true;
                settings.enablePreloading = true;
                // The SDK is polling currentTime on the contentPlayback. And needs a duration
                // so it can determine when to start the mid- and post-roll
                this.manager = event.getAdsManager(this.player, settings);
                // Get the cue points for any mid-rolls by filtering out the pre- and post-roll
                this.cuePoints = this.manager.getCuePoints();
                // Add listeners to the required events
                // Advertisement error events
                this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error));
                // Advertisement regular events
                Object.keys(google.ima.AdEvent.Type).forEach((type)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[type], (e)=>this.onAdEvent(e));
                });
                // Resolve our adsManager
                this.trigger("loaded");
            });
            _defineProperty$1(this, "addCuePoints", ()=>{
                // Add advertisement cue's within the time line if available
                if (!is.empty(this.cuePoints)) this.cuePoints.forEach((cuePoint)=>{
                    if (cuePoint !== 0 && cuePoint !== -1 && cuePoint < this.player.duration) {
                        const seekElement = this.player.elements.progress;
                        if (is.element(seekElement)) {
                            const cuePercentage = 100 / this.player.duration * cuePoint;
                            const cue = createElement("span", {
                                class: this.player.config.classNames.cues
                            });
                            cue.style.left = `${cuePercentage.toString()}%`;
                            seekElement.appendChild(cue);
                        }
                    }
                });
            });
            _defineProperty$1(this, "onAdEvent", (event)=>{
                const { container: container } = this.player.elements;
                // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
                // don't have ad object associated
                const ad = event.getAd();
                const adData = event.getAdData();
                // Proxy event
                const dispatchEvent = (type)=>{
                    triggerEvent.call(this.player, this.player.media, `ads${type.replace(/_/g, "").toLowerCase()}`);
                };
                // Bubble the event
                dispatchEvent(event.type);
                switch(event.type){
                    case google.ima.AdEvent.Type.LOADED:
                        // This is the first event sent for an ad - it is possible to determine whether the
                        // ad is a video ad or an overlay
                        this.trigger("loaded");
                        // Start countdown
                        this.pollCountdown(true);
                        if (!ad.isLinear()) {
                            // Position AdDisplayContainer correctly for overlay
                            ad.width = container.offsetWidth;
                            ad.height = container.offsetHeight;
                        }
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        // Set volume to match player
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        // All ads for the current videos are done. We can now request new advertisements
                        // in case the video is re-played
                        // TODO: Example for what happens when a next video in a playlist would be loaded.
                        // So here we load a new video when all ads are done.
                        // Then we load new ads within a new adsManager. When the video
                        // Is started - after - the ads are loaded, then we get ads.
                        // You can also easily test cancelling and reloading by running
                        // player.ads.cancel() and player.ads.play from the console I guess.
                        // this.player.source = {
                        //     type: 'video',
                        //     title: 'View From A Blue Moon',
                        //     sources: [{
                        //         src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.mp4', type:
                        // 'video/mp4', }], poster:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg', tracks:
                        // [ { kind: 'captions', label: 'English', srclang: 'en', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.en.vtt',
                        // default: true, }, { kind: 'captions', label: 'French', srclang: 'fr', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.fr.vtt', }, ],
                        // };
                        // TODO: So there is still this thing where a video should only be allowed to start
                        // playing when the IMA SDK is ready or has failed
                        if (this.player.ended) this.loadAds();
                        else // The SDK won't allow new ads to be called without receiving a contentComplete()
                        this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        // This event indicates the ad has started - the video player can adjust the UI,
                        // for example display a pause button and remaining time. Fired when content should
                        // be paused. This usually happens right before an ad is about to cover the content
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        // This event indicates the ad has finished - the video player can perform
                        // appropriate UI actions, such as removing the timer for remaining time detection.
                        // Fired when content should be resumed. This usually happens when an ad finishes
                        // or collapses
                        this.pollCountdown();
                        this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        if (adData.adError) this.player.debug.warn(`Non-fatal ad error: ${adData.adError.getMessage()}`);
                        break;
                }
            });
            _defineProperty$1(this, "onAdError", (event)=>{
                this.cancel();
                this.player.debug.warn("Ads error", event);
            });
            _defineProperty$1(this, "listeners", ()=>{
                const { container: container } = this.player.elements;
                let time;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                });
                this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                });
                this.player.on("timeupdate", ()=>{
                    time = this.player.currentTime;
                });
                this.player.on("seeked", ()=>{
                    const seekedTime = this.player.currentTime;
                    if (is.empty(this.cuePoints)) return;
                    this.cuePoints.forEach((cuePoint, index)=>{
                        if (time < cuePoint && cuePoint < seekedTime) {
                            this.manager.discardAdBreak();
                            this.cuePoints.splice(index, 1);
                        }
                    });
                });
                // Listen to the resizing of the window. And resize ad accordingly
                // TODO: eventually implement ResizeObserver
                window.addEventListener("resize", ()=>{
                    if (this.manager) this.manager.resize(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            });
            _defineProperty$1(this, "play", ()=>{
                const { container: container } = this.player.elements;
                if (!this.managerPromise) this.resumeContent();
                // Play the requested advertisement whenever the adsManager is ready
                this.managerPromise.then(()=>{
                    // Set volume to match player
                    this.manager.setVolume(this.player.volume);
                    // Initialize the container. Must be done via a user action on mobile devices
                    this.elements.displayContainer.initialize();
                    try {
                        if (!this.initialized) {
                            // Initialize the ads manager. Ad rules playlist will start at this time
                            this.manager.init(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                            // Call play to start showing the ad. Single video and overlay ads will
                            // start at this time; the call will be ignored for ad rules
                            this.manager.start();
                        }
                        this.initialized = true;
                    } catch (adError) {
                        // An error may be thrown if there was a problem with the
                        // VAST response
                        this.onAdError(adError);
                    }
                }).catch(()=>{});
            });
            _defineProperty$1(this, "resumeContent", ()=>{
                // Hide the advertisement container
                this.elements.container.style.zIndex = "";
                // Ad is stopped
                this.playing = false;
                // Play video
                silencePromise(this.player.media.play());
            });
            _defineProperty$1(this, "pauseContent", ()=>{
                // Show the advertisement container
                this.elements.container.style.zIndex = 3;
                // Ad is playing
                this.playing = true;
                // Pause our video.
                this.player.media.pause();
            });
            _defineProperty$1(this, "cancel", ()=>{
                // Pause our video
                if (this.initialized) this.resumeContent();
                // Tell our instance that we're done for now
                this.trigger("error");
                // Re-create our adsManager
                this.loadAds();
            });
            _defineProperty$1(this, "loadAds", ()=>{
                // Tell our adsManager to go bye bye
                this.managerPromise.then(()=>{
                    // Destroy our adsManager
                    if (this.manager) this.manager.destroy();
                    // Re-set our adsManager promises
                    this.managerPromise = new Promise((resolve)=>{
                        this.on("loaded", resolve);
                        this.player.debug.log(this.manager);
                    });
                    // Now that the manager has been destroyed set it to also be un-initialized
                    this.initialized = false;
                    // Now request some new advertisements
                    this.requestAds();
                }).catch(()=>{});
            });
            _defineProperty$1(this, "trigger", (event, ...args)=>{
                const handlers = this.events[event];
                if (is.array(handlers)) handlers.forEach((handler)=>{
                    if (is.function(handler)) handler.apply(this, args);
                });
            });
            _defineProperty$1(this, "on", (event, callback)=>{
                if (!is.array(this.events[event])) this.events[event] = [];
                this.events[event].push(callback);
                return this;
            });
            _defineProperty$1(this, "startSafetyTimer", (time, from)=>{
                this.player.debug.log(`Safety timer invoked from: ${from}`);
                this.safetyTimer = setTimeout(()=>{
                    this.cancel();
                    this.clearSafetyTimer("startSafetyTimer()");
                }, time);
            });
            _defineProperty$1(this, "clearSafetyTimer", (from)=>{
                if (!is.nullOrUndefined(this.safetyTimer)) {
                    this.player.debug.log(`Safety timer cleared from: ${from}`);
                    clearTimeout(this.safetyTimer);
                    this.safetyTimer = null;
                }
            });
            this.player = player;
            this.config = player.config.ads;
            this.playing = false;
            this.initialized = false;
            this.elements = {
                container: null,
                displayContainer: null
            };
            this.manager = null;
            this.loader = null;
            this.cuePoints = null;
            this.events = {};
            this.safetyTimer = null;
            this.countdownTimer = null;
            // Setup a promise to resolve when the IMA manager is ready
            this.managerPromise = new Promise((resolve, reject)=>{
                // The ad is loaded and ready
                this.on("loaded", resolve);
                // Ads failed
                this.on("error", reject);
            });
            this.load();
        }
        get enabled() {
            const { config: config } = this;
            return this.player.isHTML5 && this.player.isVideo && config.enabled && (!is.empty(config.publisherId) || is.url(config.tagUrl));
        }
        /**
     * Load the IMA SDK
     */ // Build the tag URL
        get tagUrl() {
            const { config: config } = this;
            if (is.url(config.tagUrl)) return config.tagUrl;
            const params = {
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: config.publisherId
            };
            const base = "https://go.aniview.com/api/adserver6/vast/";
            return `${base}?${buildUrlParams(params)}`;
        }
    }
    /**
   * Returns a number whose value is limited to the given range.
   *
   * Example: limit the output of this computation to between 0 and 255
   * (x * 255).clamp(0, 255)
   *
   * @param {Number} input
   * @param {Number} min The lower boundary of the output range
   * @param {Number} max The upper boundary of the output range
   * @returns A number within the bounds of min and max
   * @type Number
   */ function clamp(input = 0, min = 0, max = 255) {
        return Math.min(Math.max(input, min), max);
    }
    // Arg: vttDataString example: "WEBVTT\n\n1\n00:00:05.000 --> 00:00:10.000\n1080p-00001.jpg"
    const parseVtt = (vttDataString)=>{
        const processedList = [];
        const frames = vttDataString.split(/\r\n\r\n|\n\n|\r\r/);
        frames.forEach((frame)=>{
            const result = {};
            const lines = frame.split(/\r\n|\n|\r/);
            lines.forEach((line)=>{
                if (!is.number(result.startTime)) {
                    // The line with start and end times on it is the first line of interest
                    const matchTimes = line.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/); // Note that this currently ignores caption formatting directives that are optionally on the end of this line - fine for non-captions VTT
                    if (matchTimes) {
                        result.startTime = Number(matchTimes[1] || 0) * 3600 + Number(matchTimes[2]) * 60 + Number(matchTimes[3]) + Number(`0.${matchTimes[4]}`);
                        result.endTime = Number(matchTimes[6] || 0) * 3600 + Number(matchTimes[7]) * 60 + Number(matchTimes[8]) + Number(`0.${matchTimes[9]}`);
                    }
                } else if (!is.empty(line.trim()) && is.empty(result.text)) {
                    // If we already have the startTime, then we're definitely up to the text line(s)
                    const lineSplit = line.trim().split("#xywh=");
                    [result.text] = lineSplit;
                    // If there's content in lineSplit[1], then we have sprites. If not, then it's just one frame per image
                    if (lineSplit[1]) [result.x, result.y, result.w, result.h] = lineSplit[1].split(",");
                }
            });
            if (result.text) processedList.push(result);
        });
        return processedList;
    };
    /**
   * Preview thumbnails for seek hover and scrubbing
   * Seeking: Hover over the seek bar (desktop only): shows a small preview container above the seek bar
   * Scrubbing: Click and drag the seek bar (desktop and mobile): shows the preview image over the entire video, as if the video is scrubbing at very high speed
   *
   * Notes:
   * - Thumbs are set via JS settings on Plyr init, not HTML5 'track' property. Using the track property would be a bit gross, because it doesn't support custom 'kinds'. kind=metadata might be used for something else, and we want to allow multiple thumbnails tracks. Tracks must have a unique combination of 'kind' and 'label'. We would have to do something like kind=metadata,label=thumbnails1 / kind=metadata,label=thumbnails2. Square peg, round hole
   * - VTT info: the image URL is relative to the VTT, not the current document. But if the url starts with a slash, it will naturally be relative to the current domain. https://support.jwplayer.com/articles/how-to-add-preview-thumbnails
   * - This implementation uses multiple separate img elements. Other implementations use background-image on one element. This would be nice and simple, but Firefox and Safari have flickering issues with replacing backgrounds of larger images. It seems that YouTube perhaps only avoids this because they don't have the option for high-res previews (even the fullscreen ones, when mousedown/seeking). Images appear over the top of each other, and previous ones are discarded once the new ones have been rendered
   */ const fitRatio = (ratio, outer)=>{
        const targetRatio = outer.width / outer.height;
        const result = {};
        if (ratio > targetRatio) {
            result.width = outer.width;
            result.height = 1 / ratio * outer.width;
        } else {
            result.height = outer.height;
            result.width = ratio * outer.height;
        }
        return result;
    };
    class PreviewThumbnails {
        /**
     * PreviewThumbnails constructor.
     * @param {Plyr} player
     * @return {PreviewThumbnails}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                // Toggle the regular seek tooltip
                if (this.player.elements.display.seekTooltip) this.player.elements.display.seekTooltip.hidden = this.enabled;
                if (!this.enabled) return;
                this.getThumbnails().then(()=>{
                    if (!this.enabled) return;
                    // Render DOM elements
                    this.render();
                    // Check to see if thumb container size was specified manually in CSS
                    this.determineContainerAutoSizing();
                    this.loaded = true;
                });
            });
            _defineProperty$1(this, "getThumbnails", ()=>{
                return new Promise((resolve)=>{
                    const { src: src } = this.player.config.previewThumbnails;
                    if (is.empty(src)) throw new Error("Missing previewThumbnails.src config attribute");
                    // Resolve promise
                    const sortAndResolve = ()=>{
                        // Sort smallest to biggest (e.g., [120p, 480p, 1080p])
                        this.thumbnails.sort((x, y)=>x.height - y.height);
                        this.player.debug.log("Preview thumbnails", this.thumbnails);
                        resolve();
                    };
                    // Via callback()
                    if (is.function(src)) src((thumbnails)=>{
                        this.thumbnails = thumbnails;
                        sortAndResolve();
                    });
                    else {
                        // If string, convert into single-element list
                        const urls = is.string(src) ? [
                            src
                        ] : src;
                        // Loop through each src URL. Download and process the VTT file, storing the resulting data in this.thumbnails
                        const promises = urls.map((u)=>this.getThumbnail(u));
                        // Resolve
                        Promise.all(promises).then(sortAndResolve);
                    }
                });
            });
            _defineProperty$1(this, "getThumbnail", (url)=>{
                return new Promise((resolve)=>{
                    fetch(url).then((response)=>{
                        const thumbnail = {
                            frames: parseVtt(response),
                            height: null,
                            urlPrefix: ""
                        };
                        // If the URLs don't start with '/', then we need to set their relative path to be the location of the VTT file
                        // If the URLs do start with '/', then they obviously don't need a prefix, so it will remain blank
                        // If the thumbnail URLs start with with none of '/', 'http://' or 'https://', then we need to set their relative path to be the location of the VTT file
                        if (!thumbnail.frames[0].text.startsWith("/") && !thumbnail.frames[0].text.startsWith("http://") && !thumbnail.frames[0].text.startsWith("https://")) thumbnail.urlPrefix = url.substring(0, url.lastIndexOf("/") + 1);
                        // Download the first frame, so that we can determine/set the height of this thumbnailsDef
                        const tempImage = new Image();
                        tempImage.onload = ()=>{
                            thumbnail.height = tempImage.naturalHeight;
                            thumbnail.width = tempImage.naturalWidth;
                            this.thumbnails.push(thumbnail);
                            resolve();
                        };
                        tempImage.src = thumbnail.urlPrefix + thumbnail.frames[0].text;
                    });
                });
            });
            _defineProperty$1(this, "startMove", (event)=>{
                if (!this.loaded) return;
                if (!is.event(event) || ![
                    "touchmove",
                    "mousemove"
                ].includes(event.type)) return;
                // Wait until media has a duration
                if (!this.player.media.duration) return;
                if (event.type === "touchmove") // Calculate seek hover position as approx video seconds
                this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                else {
                    var _this$player$config$m, _this$player$config$m2;
                    // Calculate seek hover position as approx video seconds
                    const clientRect = this.player.elements.progress.getBoundingClientRect();
                    const percentage = 100 / clientRect.width * (event.pageX - clientRect.left);
                    this.seekTime = this.player.media.duration * (percentage / 100);
                    if (this.seekTime < 0) // The mousemove fires for 10+px out to the left
                    this.seekTime = 0;
                    if (this.seekTime > this.player.media.duration - 1) // Took 1 second off the duration for safety, because different players can disagree on the real duration of a video
                    this.seekTime = this.player.media.duration - 1;
                    this.mousePosX = event.pageX;
                    // Set time text inside image container
                    this.elements.thumb.time.innerText = formatTime(this.seekTime);
                    // Get marker point for time
                    const point = (_this$player$config$m = this.player.config.markers) === null || _this$player$config$m === void 0 ? void 0 : (_this$player$config$m2 = _this$player$config$m.points) === null || _this$player$config$m2 === void 0 ? void 0 : _this$player$config$m2.find(({ time: t })=>t === Math.round(this.seekTime));
                    // Append the point label to the tooltip
                    if (point) // this.elements.thumb.time.innerText.concat('\n');
                    this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${point.label}<br>`);
                }
                // Download and show image
                this.showImageAtCurrentTime();
            });
            _defineProperty$1(this, "endMove", ()=>{
                this.toggleThumbContainer(false, true);
            });
            _defineProperty$1(this, "startScrubbing", (event)=>{
                // Only act on left mouse button (0), or touch device (event.button does not exist or is false)
                if (is.nullOrUndefined(event.button) || event.button === false || event.button === 0) {
                    this.mouseDown = true;
                    // Wait until media has a duration
                    if (this.player.media.duration) {
                        this.toggleScrubbingContainer(true);
                        this.toggleThumbContainer(false, true);
                        // Download and show image
                        this.showImageAtCurrentTime();
                    }
                }
            });
            _defineProperty$1(this, "endScrubbing", ()=>{
                this.mouseDown = false;
                // Hide scrubbing preview. But wait until the video has successfully seeked before hiding the scrubbing preview
                if (Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime)) // The video was already seeked/loaded at the chosen time - hide immediately
                this.toggleScrubbingContainer(false);
                else // The video hasn't seeked yet. Wait for that
                once.call(this.player, this.player.media, "timeupdate", ()=>{
                    // Re-check mousedown - we might have already started scrubbing again
                    if (!this.mouseDown) this.toggleScrubbingContainer(false);
                });
            });
            _defineProperty$1(this, "listeners", ()=>{
                // Hide thumbnail preview - on mouse click, mouse leave (in listeners.js for now), and video play/seek. All four are required, e.g., for buffering
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(false, true);
                });
                this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(false);
                });
                this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            });
            _defineProperty$1(this, "render", ()=>{
                // Create HTML element: plyr__preview-thumbnail-container
                this.elements.thumb.container = createElement("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                });
                // Wrapper for the image for styling
                this.elements.thumb.imageContainer = createElement("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                });
                this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                // Create HTML element, parent+span: time text (e.g., 01:32:00)
                const timeContainer = createElement("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = createElement("span", {}, "00:00");
                timeContainer.appendChild(this.elements.thumb.time);
                this.elements.thumb.imageContainer.appendChild(timeContainer);
                // Inject the whole thumb
                if (is.element(this.player.elements.progress)) this.player.elements.progress.appendChild(this.elements.thumb.container);
                // Create HTML element: plyr__preview-scrubbing-container
                this.elements.scrubbing.container = createElement("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                });
                this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            });
            _defineProperty$1(this, "destroy", ()=>{
                if (this.elements.thumb.container) this.elements.thumb.container.remove();
                if (this.elements.scrubbing.container) this.elements.scrubbing.container.remove();
            });
            _defineProperty$1(this, "showImageAtCurrentTime", ()=>{
                if (this.mouseDown) this.setScrubbingContainerSize();
                else this.setThumbContainerSizeAndPos();
                // Find the desired thumbnail index
                // TODO: Handle a video longer than the thumbs where thumbNum is null
                const thumbNum = this.thumbnails[0].frames.findIndex((frame)=>this.seekTime >= frame.startTime && this.seekTime <= frame.endTime);
                const hasThumb = thumbNum >= 0;
                let qualityIndex = 0;
                // Show the thumb container if we're not scrubbing
                if (!this.mouseDown) this.toggleThumbContainer(hasThumb);
                // No matching thumb found
                if (!hasThumb) return;
                // Check to see if we've already downloaded higher quality versions of this image
                this.thumbnails.forEach((thumbnail, index)=>{
                    if (this.loadedImages.includes(thumbnail.frames[thumbNum].text)) qualityIndex = index;
                });
                // Only proceed if either thumb num or thumbfilename has changed
                if (thumbNum !== this.showingThumb) {
                    this.showingThumb = thumbNum;
                    this.loadImage(qualityIndex);
                }
            });
            _defineProperty$1(this, "loadImage", (qualityIndex = 0)=>{
                const thumbNum = this.showingThumb;
                const thumbnail = this.thumbnails[qualityIndex];
                const { urlPrefix: urlPrefix } = thumbnail;
                const frame = thumbnail.frames[thumbNum];
                const thumbFilename = thumbnail.frames[thumbNum].text;
                const thumbUrl = urlPrefix + thumbFilename;
                if (!this.currentImageElement || this.currentImageElement.dataset.filename !== thumbFilename) {
                    // If we're already loading a previous image, remove its onload handler - we don't want it to load after this one
                    // Only do this if not using sprites. Without sprites we really want to show as many images as possible, as a best-effort
                    if (this.loadingImage && this.usingSprites) this.loadingImage.onload = null;
                    // We're building and adding a new image. In other implementations of similar functionality (YouTube), background image
                    // is instead used. But this causes issues with larger images in Firefox and Safari - switching between background
                    // images causes a flicker. Putting a new image over the top does not
                    const previewImage = new Image();
                    previewImage.src = thumbUrl;
                    previewImage.dataset.index = thumbNum;
                    previewImage.dataset.filename = thumbFilename;
                    this.showingThumbFilename = thumbFilename;
                    this.player.debug.log(`Loading image: ${thumbUrl}`);
                    // For some reason, passing the named function directly causes it to execute immediately. So I've wrapped it in an anonymous function...
                    previewImage.onload = ()=>this.showImage(previewImage, frame, qualityIndex, thumbNum, thumbFilename, true);
                    this.loadingImage = previewImage;
                    this.removeOldImages(previewImage);
                } else {
                    // Update the existing image
                    this.showImage(this.currentImageElement, frame, qualityIndex, thumbNum, thumbFilename, false);
                    this.currentImageElement.dataset.index = thumbNum;
                    this.removeOldImages(this.currentImageElement);
                }
            });
            _defineProperty$1(this, "showImage", (previewImage, frame, qualityIndex, thumbNum, thumbFilename, newImage = true)=>{
                this.player.debug.log(`Showing thumb: ${thumbFilename}. num: ${thumbNum}. qual: ${qualityIndex}. newimg: ${newImage}`);
                this.setImageSizeAndOffset(previewImage, frame);
                if (newImage) {
                    this.currentImageContainer.appendChild(previewImage);
                    this.currentImageElement = previewImage;
                    if (!this.loadedImages.includes(thumbFilename)) this.loadedImages.push(thumbFilename);
                }
                // Preload images before and after the current one
                // Show higher quality of the same frame
                // Each step here has a short time delay, and only continues if still hovering/seeking the same spot. This is to protect slow connections from overloading
                this.preloadNearby(thumbNum, true).then(this.preloadNearby(thumbNum, false)).then(this.getHigherQuality(qualityIndex, previewImage, frame, thumbFilename));
            });
            _defineProperty$1(this, "removeOldImages", (currentImage)=>{
                // Get a list of all images, convert it from a DOM list to an array
                Array.from(this.currentImageContainer.children).forEach((image)=>{
                    if (image.tagName.toLowerCase() !== "img") return;
                    const removeDelay = this.usingSprites ? 500 : 1000;
                    if (image.dataset.index !== currentImage.dataset.index && !image.dataset.deleting) {
                        // Wait 200ms, as the new image can take some time to show on certain browsers (even though it was downloaded before showing). This will prevent flicker, and show some generosity towards slower clients
                        // First set attribute 'deleting' to prevent multi-handling of this on repeat firing of this function
                        // eslint-disable-next-line no-param-reassign
                        image.dataset.deleting = true;
                        // This has to be set before the timeout - to prevent issues switching between hover and scrub
                        const { currentImageContainer: currentImageContainer } = this;
                        setTimeout(()=>{
                            currentImageContainer.removeChild(image);
                            this.player.debug.log(`Removing thumb: ${image.dataset.filename}`);
                        }, removeDelay);
                    }
                });
            });
            _defineProperty$1(this, "preloadNearby", (thumbNum, forward = true)=>{
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        const oldThumbFilename = this.thumbnails[0].frames[thumbNum].text;
                        if (this.showingThumbFilename === oldThumbFilename) {
                            // Find the nearest thumbs with different filenames. Sometimes it'll be the next index, but in the case of sprites, it might be 100+ away
                            let thumbnailsClone;
                            if (forward) thumbnailsClone = this.thumbnails[0].frames.slice(thumbNum);
                            else thumbnailsClone = this.thumbnails[0].frames.slice(0, thumbNum).reverse();
                            let foundOne = false;
                            thumbnailsClone.forEach((frame)=>{
                                const newThumbFilename = frame.text;
                                if (newThumbFilename !== oldThumbFilename) // Found one with a different filename. Make sure it hasn't already been loaded on this page visit
                                {
                                    if (!this.loadedImages.includes(newThumbFilename)) {
                                        foundOne = true;
                                        this.player.debug.log(`Preloading thumb filename: ${newThumbFilename}`);
                                        const { urlPrefix: urlPrefix } = this.thumbnails[0];
                                        const thumbURL = urlPrefix + newThumbFilename;
                                        const previewImage = new Image();
                                        previewImage.src = thumbURL;
                                        previewImage.onload = ()=>{
                                            this.player.debug.log(`Preloaded thumb filename: ${newThumbFilename}`);
                                            if (!this.loadedImages.includes(newThumbFilename)) this.loadedImages.push(newThumbFilename);
                                            // We don't resolve until the thumb is loaded
                                            resolve();
                                        };
                                    }
                                }
                            });
                            // If there are none to preload then we want to resolve immediately
                            if (!foundOne) resolve();
                        }
                    }, 300);
                });
            });
            _defineProperty$1(this, "getHigherQuality", (currentQualityIndex, previewImage, frame, thumbFilename)=>{
                if (currentQualityIndex < this.thumbnails.length - 1) {
                    // Only use the higher quality version if it's going to look any better - if the current thumb is of a lower pixel density than the thumbnail container
                    let previewImageHeight = previewImage.naturalHeight;
                    if (this.usingSprites) previewImageHeight = frame.h;
                    if (previewImageHeight < this.thumbContainerHeight) // Recurse back to the loadImage function - show a higher quality one, but only if the viewer is on this frame for a while
                    setTimeout(()=>{
                        // Make sure the mouse hasn't already moved on and started hovering at another image
                        if (this.showingThumbFilename === thumbFilename) {
                            this.player.debug.log(`Showing higher quality thumb for: ${thumbFilename}`);
                            this.loadImage(currentQualityIndex + 1);
                        }
                    }, 300);
                }
            });
            _defineProperty$1(this, "toggleThumbContainer", (toggle = false, clearShowing = false)=>{
                const className = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(className, toggle);
                if (!toggle && clearShowing) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "toggleScrubbingContainer", (toggle = false)=>{
                const className = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(className, toggle);
                if (!toggle) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "determineContainerAutoSizing", ()=>{
                if (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) // This will prevent auto sizing in this.setThumbContainerSizeAndPos()
                this.sizeSpecifiedInCSS = true;
            });
            _defineProperty$1(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: imageContainer } = this.elements.thumb;
                if (!this.sizeSpecifiedInCSS) {
                    const thumbWidth = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    imageContainer.style.height = `${this.thumbContainerHeight}px`;
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight > 20 && imageContainer.clientWidth < 20) {
                    const thumbWidth = Math.floor(imageContainer.clientHeight * this.thumbAspectRatio);
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight < 20 && imageContainer.clientWidth > 20) {
                    const thumbHeight = Math.floor(imageContainer.clientWidth / this.thumbAspectRatio);
                    imageContainer.style.height = `${thumbHeight}px`;
                }
                this.setThumbContainerPos();
            });
            _defineProperty$1(this, "setThumbContainerPos", ()=>{
                const scrubberRect = this.player.elements.progress.getBoundingClientRect();
                const containerRect = this.player.elements.container.getBoundingClientRect();
                const { container: container } = this.elements.thumb;
                // Find the lowest and highest desired left-position, so we don't slide out the side of the video container
                const min = containerRect.left - scrubberRect.left + 10;
                const max = containerRect.right - scrubberRect.left - container.clientWidth - 10;
                // Set preview container position to: mousepos, minus seekbar.left, minus half of previewContainer.clientWidth
                const position = this.mousePosX - scrubberRect.left - container.clientWidth / 2;
                const clamped = clamp(position, min, max);
                // Move the popover position
                container.style.left = `${clamped}px`;
                // The arrow can follow the cursor
                container.style.setProperty("--preview-arrow-offset", `${position - clamped}px`);
            });
            _defineProperty$1(this, "setScrubbingContainerSize", ()=>{
                const { width: width, height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${width}px`;
                this.elements.scrubbing.container.style.height = `${height}px`;
            });
            _defineProperty$1(this, "setImageSizeAndOffset", (previewImage, frame)=>{
                if (!this.usingSprites) return;
                // Find difference between height and preview container height
                const multiplier = this.thumbContainerHeight / frame.h;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.height = `${previewImage.naturalHeight * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.width = `${previewImage.naturalWidth * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.left = `-${frame.x * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.top = `-${frame.y * multiplier}px`;
            });
            this.player = player;
            this.thumbnails = [];
            this.loaded = false;
            this.lastMouseMoveTime = Date.now();
            this.mouseDown = false;
            this.loadedImages = [];
            this.elements = {
                thumb: {},
                scrubbing: {}
            };
            this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            if (this.usingSprites) return this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h;
            return this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return height;
            }
            // If css is used this needs to return the css height for sprites to work (see setImageSizeAndOffset)
            if (this.sizeSpecifiedInCSS) return this.elements.thumb.imageContainer.clientHeight;
            return Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(element) {
            if (this.mouseDown) this.currentScrubbingImageElement = element;
            else this.currentThumbnailImageElement = element;
        }
    }
    // ==========================================================================
    const source = {
        // Add elements to HTML5 media (source, tracks, etc)
        insertElements (type, attributes) {
            if (is.string(attributes)) insertElement(type, this.media, {
                src: attributes
            });
            else if (is.array(attributes)) attributes.forEach((attribute)=>{
                insertElement(type, this.media, attribute);
            });
        },
        // Update source
        // Sources are not checked for support so be careful
        change (input) {
            if (!getDeep(input, "sources.length")) {
                this.debug.warn("Invalid source format");
                return;
            }
            // Cancel current network requests
            html5.cancelRequests.call(this);
            // Destroy instance and re-setup
            this.destroy.call(this, ()=>{
                // Reset quality options
                this.options.quality = [];
                // Remove elements
                removeElement(this.media);
                this.media = null;
                // Reset class name
                if (is.element(this.elements.container)) this.elements.container.removeAttribute("class");
                // Set the type and provider
                const { sources: sources, type: type } = input;
                const [{ provider: provider = providers.html5, src: src }] = sources;
                const tagName = provider === "html5" ? type : "div";
                const attributes = provider === "html5" ? {} : {
                    src: src
                };
                Object.assign(this, {
                    provider: provider,
                    type: type,
                    // Check for support
                    supported: support.check(type, provider, this.config.playsinline),
                    // Create new element
                    media: createElement(tagName, attributes)
                });
                // Inject the new element
                this.elements.container.appendChild(this.media);
                // Autoplay the new source?
                if (is.boolean(input.autoplay)) this.config.autoplay = input.autoplay;
                // Set attributes for audio and video
                if (this.isHTML5) {
                    if (this.config.crossorigin) this.media.setAttribute("crossorigin", "");
                    if (this.config.autoplay) this.media.setAttribute("autoplay", "");
                    if (!is.empty(input.poster)) this.poster = input.poster;
                    if (this.config.loop.active) this.media.setAttribute("loop", "");
                    if (this.config.muted) this.media.setAttribute("muted", "");
                    if (this.config.playsinline) this.media.setAttribute("playsinline", "");
                }
                // Restore class hook
                ui.addStyleHook.call(this);
                // Set new sources for html5
                if (this.isHTML5) source.insertElements.call(this, "source", sources);
                // Set video title
                this.config.title = input.title;
                // Set up from scratch
                media.setup.call(this);
                // HTML5 stuff
                if (this.isHTML5) // Setup captions
                {
                    if (Object.keys(input).includes("tracks")) source.insertElements.call(this, "track", input.tracks);
                }
                // If HTML5 or embed but not fully supported, setupInterface and call ready now
                if (this.isHTML5 || this.isEmbed && !this.supported.ui) // Setup interface
                ui.build.call(this);
                // Load HTML5 sources
                if (this.isHTML5) this.media.load();
                // Update previewThumbnails config & reload plugin
                if (!is.empty(input.previewThumbnails)) {
                    Object.assign(this.config.previewThumbnails, input.previewThumbnails);
                    // Cleanup previewThumbnails plugin if it was loaded
                    if (this.previewThumbnails && this.previewThumbnails.loaded) {
                        this.previewThumbnails.destroy();
                        this.previewThumbnails = null;
                    }
                    // Create new instance if it is still enabled
                    if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
                }
                // Update the fullscreen support
                this.fullscreen.update();
            }, true);
        }
    };
    // Private properties
    // TODO: Use a WeakMap for private globals
    // const globals = new WeakMap();
    // Plyr instance
    class Plyr {
        constructor(target, options){
            _defineProperty$1(this, "play", ()=>{
                if (!is.function(this.media.play)) return null;
                // Intecept play with ads
                if (this.ads && this.ads.enabled) this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>silencePromise(this.media.play()));
                // Return the promise (for HTML5)
                return this.media.play();
            });
            _defineProperty$1(this, "pause", ()=>{
                if (!this.playing || !is.function(this.media.pause)) return null;
                return this.media.pause();
            });
            _defineProperty$1(this, "togglePlay", (input)=>{
                // Toggle based on current state if nothing passed
                const toggle = is.boolean(input) ? input : !this.playing;
                if (toggle) return this.play();
                return this.pause();
            });
            _defineProperty$1(this, "stop", ()=>{
                if (this.isHTML5) {
                    this.pause();
                    this.restart();
                } else if (is.function(this.media.stop)) this.media.stop();
            });
            _defineProperty$1(this, "restart", ()=>{
                this.currentTime = 0;
            });
            _defineProperty$1(this, "rewind", (seekTime)=>{
                this.currentTime -= is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            _defineProperty$1(this, "forward", (seekTime)=>{
                this.currentTime += is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            _defineProperty$1(this, "increaseVolume", (step)=>{
                const volume = this.media.muted ? 0 : this.volume;
                this.volume = volume + (is.number(step) ? step : 0);
            });
            _defineProperty$1(this, "decreaseVolume", (step)=>{
                this.increaseVolume(-step);
            });
            _defineProperty$1(this, "airplay", ()=>{
                // Show dialog if supported
                if (support.airplay) this.media.webkitShowPlaybackTargetPicker();
            });
            _defineProperty$1(this, "toggleControls", (toggle)=>{
                // Don't toggle if missing UI support or if it's audio
                if (this.supported.ui && !this.isAudio) {
                    // Get state before change
                    const isHidden = hasClass(this.elements.container, this.config.classNames.hideControls);
                    // Negate the argument if not undefined since adding the class to hides the controls
                    const force = typeof toggle === "undefined" ? undefined : !toggle;
                    // Apply and get updated state
                    const hiding = toggleClass(this.elements.container, this.config.classNames.hideControls, force);
                    // Close menu
                    if (hiding && is.array(this.config.controls) && this.config.controls.includes("settings") && !is.empty(this.config.settings)) controls.toggleMenu.call(this, false);
                    // Trigger event on change
                    if (hiding !== isHidden) {
                        const eventName = hiding ? "controlshidden" : "controlsshown";
                        triggerEvent.call(this, this.media, eventName);
                    }
                    return !hiding;
                }
                return false;
            });
            _defineProperty$1(this, "on", (event, callback)=>{
                on.call(this, this.elements.container, event, callback);
            });
            _defineProperty$1(this, "once", (event, callback)=>{
                once.call(this, this.elements.container, event, callback);
            });
            _defineProperty$1(this, "off", (event, callback)=>{
                off(this.elements.container, event, callback);
            });
            _defineProperty$1(this, "destroy", (callback, soft = false)=>{
                if (!this.ready) return;
                const done = ()=>{
                    // Reset overflow (incase destroyed while in fullscreen)
                    document.body.style.overflow = "";
                    // GC for embed
                    this.embed = null;
                    // If it's a soft destroy, make minimal changes
                    if (soft) {
                        if (Object.keys(this.elements).length) {
                            // Remove elements
                            removeElement(this.elements.buttons.play);
                            removeElement(this.elements.captions);
                            removeElement(this.elements.controls);
                            removeElement(this.elements.wrapper);
                            // Clear for GC
                            this.elements.buttons.play = null;
                            this.elements.captions = null;
                            this.elements.controls = null;
                            this.elements.wrapper = null;
                        }
                        // Callback
                        if (is.function(callback)) callback();
                    } else {
                        // Unbind listeners
                        unbindListeners.call(this);
                        // Cancel current network requests
                        html5.cancelRequests.call(this);
                        // Replace the container with the original element provided
                        replaceElement(this.elements.original, this.elements.container);
                        // Event
                        triggerEvent.call(this, this.elements.original, "destroyed", true);
                        // Callback
                        if (is.function(callback)) callback.call(this.elements.original);
                        // Reset state
                        this.ready = false;
                        // Clear for garbage collection
                        setTimeout(()=>{
                            this.elements = null;
                            this.media = null;
                        }, 200);
                    }
                };
                // Stop playback
                this.stop();
                // Clear timeouts
                clearTimeout(this.timers.loading);
                clearTimeout(this.timers.controls);
                clearTimeout(this.timers.resized);
                // Provider specific stuff
                if (this.isHTML5) {
                    // Restore native video controls
                    ui.toggleNativeControls.call(this, true);
                    // Clean up
                    done();
                } else if (this.isYouTube) {
                    // Clear timers
                    clearInterval(this.timers.buffering);
                    clearInterval(this.timers.playing);
                    // Destroy YouTube API
                    if (this.embed !== null && is.function(this.embed.destroy)) this.embed.destroy();
                    // Clean up
                    done();
                } else if (this.isVimeo) {
                    // Destroy Vimeo API
                    // then clean up (wait, to prevent postmessage errors)
                    if (this.embed !== null) this.embed.unload().then(done);
                    // Vimeo does not always return
                    setTimeout(done, 200);
                }
            });
            _defineProperty$1(this, "supports", (type)=>support.mime.call(this, type));
            this.timers = {};
            // State
            this.ready = false;
            this.loading = false;
            this.failed = false;
            // Touch device
            this.touch = support.touch;
            // Set the media element
            this.media = target;
            // String selector passed
            if (is.string(this.media)) this.media = document.querySelectorAll(this.media);
            // jQuery, NodeList or Array passed, use first element
            if (window.jQuery && this.media instanceof jQuery || is.nodeList(this.media) || is.array(this.media)) // eslint-disable-next-line
            this.media = this.media[0];
            // Set config
            this.config = extend({}, defaults, Plyr.defaults, options || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (_) {
                    return {};
                }
            })());
            // Elements cache
            this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            };
            // Captions
            this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap()
            };
            // Fullscreen
            this.fullscreen = {
                active: false
            };
            // Options
            this.options = {
                speed: [],
                quality: []
            };
            // Debugging
            // TODO: move to globals
            this.debug = new Console(this.config.debug);
            // Log config options and support
            this.debug.log("Config", this.config);
            this.debug.log("Support", support);
            // We need an element to setup
            if (is.nullOrUndefined(this.media) || !is.element(this.media)) {
                this.debug.error("Setup failed: no suitable element passed");
                return;
            }
            // Bail if the element is initialized
            if (this.media.plyr) {
                this.debug.warn("Target already setup");
                return;
            }
            // Bail if not enabled
            if (!this.config.enabled) {
                this.debug.error("Setup failed: disabled by config");
                return;
            }
            // Bail if disabled or no basic support
            // You may want to disable certain UAs etc
            if (!support.check().api) {
                this.debug.error("Setup failed: no support");
                return;
            }
            // Cache original element state for .destroy()
            const clone = this.media.cloneNode(true);
            clone.autoplay = false;
            this.elements.original = clone;
            // Set media type based on tag or data attribute
            // Supported: video, audio, vimeo, youtube
            const _type = this.media.tagName.toLowerCase();
            // Embed properties
            let iframe = null;
            let url = null;
            // Different setup based on type
            switch(_type){
                case "div":
                    // Find the frame
                    iframe = this.media.querySelector("iframe");
                    // <iframe> type
                    if (is.element(iframe)) {
                        // Detect provider
                        url = parseUrl(iframe.getAttribute("src"));
                        this.provider = getProviderByUrl(url.toString());
                        // Rework elements
                        this.elements.container = this.media;
                        this.media = iframe;
                        // Reset classname
                        this.elements.container.className = "";
                        // Get attributes from URL and set config
                        if (url.search.length) {
                            const truthy = [
                                "1",
                                "true"
                            ];
                            if (truthy.includes(url.searchParams.get("autoplay"))) this.config.autoplay = true;
                            if (truthy.includes(url.searchParams.get("loop"))) this.config.loop.active = true;
                            // TODO: replace fullscreen.iosNative with this playsinline config option
                            // YouTube requires the playsinline in the URL
                            if (this.isYouTube) {
                                this.config.playsinline = truthy.includes(url.searchParams.get("playsinline"));
                                this.config.youtube.hl = url.searchParams.get("hl"); // TODO: Should this be setting language?
                            } else this.config.playsinline = true;
                        }
                    } else {
                        // <div> with attributes
                        this.provider = this.media.getAttribute(this.config.attributes.embed.provider);
                        // Remove attribute
                        this.media.removeAttribute(this.config.attributes.embed.provider);
                    }
                    // Unsupported or missing provider
                    if (is.empty(this.provider) || !Object.values(providers).includes(this.provider)) {
                        this.debug.error("Setup failed: Invalid provider");
                        return;
                    }
                    // Audio will come later for external providers
                    this.type = types.video;
                    break;
                case "video":
                case "audio":
                    this.type = _type;
                    this.provider = providers.html5;
                    // Get config from attributes
                    if (this.media.hasAttribute("crossorigin")) this.config.crossorigin = true;
                    if (this.media.hasAttribute("autoplay")) this.config.autoplay = true;
                    if (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) this.config.playsinline = true;
                    if (this.media.hasAttribute("muted")) this.config.muted = true;
                    if (this.media.hasAttribute("loop")) this.config.loop.active = true;
                    break;
                default:
                    this.debug.error("Setup failed: unsupported type");
                    return;
            }
            // Check for support again but with type
            this.supported = support.check(this.type, this.provider, this.config.playsinline);
            // If no support for even API, bail
            if (!this.supported.api) {
                this.debug.error("Setup failed: no support");
                return;
            }
            this.eventListeners = [];
            // Create listeners
            this.listeners = new Listeners(this);
            // Setup local storage for user settings
            this.storage = new Storage(this);
            // Store reference
            this.media.plyr = this;
            // Wrap media
            if (!is.element(this.elements.container)) {
                this.elements.container = createElement("div", {
                    tabindex: 0
                });
                wrap(this.media, this.elements.container);
            }
            // Migrate custom properties from media to container (so they work 😉)
            ui.migrateStyles.call(this);
            // Add style hook
            ui.addStyleHook.call(this);
            // Setup media
            media.setup.call(this);
            // Listen for events if debugging
            if (this.config.debug) on.call(this, this.elements.container, this.config.events.join(" "), (event)=>{
                this.debug.log(`event: ${event.type}`);
            });
            // Setup fullscreen
            this.fullscreen = new Fullscreen(this);
            // Setup interface
            // If embed but not fully supported, build interface now to avoid flash of controls
            if (this.isHTML5 || this.isEmbed && !this.supported.ui) ui.build.call(this);
            // Container listeners
            this.listeners.container();
            // Global listeners
            this.listeners.global();
            // Setup ads if provided
            if (this.config.ads.enabled) this.ads = new Ads(this);
            // Autoplay if required
            if (this.isHTML5 && this.config.autoplay) this.once("canplay", ()=>silencePromise(this.play()));
            // Seek time will be recorded (in listeners.js) so we can prevent hiding controls for a few seconds after seek
            this.lastSeekTime = 0;
            // Setup preview thumbnails if enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        // ---------------------------------------
        // API
        // ---------------------------------------
        /**
     * Types and provider helpers
     */ get isHTML5() {
            return this.provider === providers.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === providers.youtube;
        }
        get isVimeo() {
            return this.provider === providers.vimeo;
        }
        get isVideo() {
            return this.type === types.video;
        }
        get isAudio() {
            return this.type === types.audio;
        }
        /**
     * Play the media, or play the advertisement (if they are not blocked)
     */ /**
     * Get playing state
     */ get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        /**
     * Get paused state
     */ get paused() {
            return Boolean(this.media.paused);
        }
        /**
     * Get stopped state
     */ get stopped() {
            return Boolean(this.paused && this.currentTime === 0);
        }
        /**
     * Get ended state
     */ get ended() {
            return Boolean(this.media.ended);
        }
        /**
     * Toggle playback based on current status
     * @param {Boolean} input
     */ /**
     * Seek to a time
     * @param {Number} input - where to seek to in seconds. Defaults to 0 (the start)
     */ set currentTime(input) {
            // Bail if media duration isn't available yet
            if (!this.duration) return;
            // Validate input
            const inputIsValid = is.number(input) && input > 0;
            // Set
            this.media.currentTime = inputIsValid ? Math.min(input, this.duration) : 0;
            // Logging
            this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        /**
     * Get current time
     */ get currentTime() {
            return Number(this.media.currentTime);
        }
        /**
     * Get buffered
     */ get buffered() {
            const { buffered: buffered } = this.media;
            // YouTube / Vimeo return a float between 0-1
            if (is.number(buffered)) return buffered;
            // HTML5
            // TODO: Handle buffered chunks of the media
            // (i.e. seek to another section buffers only that section)
            if (buffered && buffered.length && this.duration > 0) return buffered.end(0) / this.duration;
            return 0;
        }
        /**
     * Get seeking status
     */ get seeking() {
            return Boolean(this.media.seeking);
        }
        /**
     * Get the duration of the current media
     */ get duration() {
            // Faux duration set via config
            const fauxDuration = parseFloat(this.config.duration);
            // Media duration can be NaN or Infinity before the media has loaded
            const realDuration = (this.media || {}).duration;
            const duration = !is.number(realDuration) || realDuration === Infinity ? 0 : realDuration;
            // If config duration is funky, use regular duration
            return fauxDuration || duration;
        }
        /**
     * Set the player volume
     * @param {Number} value - must be between 0 and 1. Defaults to the value from local storage and config.volume if not set in storage
     */ set volume(value) {
            let volume = value;
            const max = 1;
            const min = 0;
            if (is.string(volume)) volume = Number(volume);
            // Load volume from storage if no value specified
            if (!is.number(volume)) volume = this.storage.get("volume");
            // Use config if all else fails
            if (!is.number(volume)) ({ volume: volume } = this.config);
            // Maximum is volumeMax
            if (volume > max) volume = max;
            // Minimum is volumeMin
            if (volume < min) volume = min;
            // Update config
            this.config.volume = volume;
            // Set the player volume
            this.media.volume = volume;
            // If muted, and we're increasing volume manually, reset muted state
            if (!is.empty(value) && this.muted && volume > 0) this.muted = false;
        }
        /**
     * Get the current player volume
     */ get volume() {
            return Number(this.media.volume);
        }
        /**
     * Increase volume
     * @param {Boolean} step - How much to decrease by (between 0 and 1)
     */ /**
     * Set muted state
     * @param {Boolean} mute
     */ set muted(mute) {
            let toggle = mute;
            // Load muted state from storage
            if (!is.boolean(toggle)) toggle = this.storage.get("muted");
            // Use config if all else fails
            if (!is.boolean(toggle)) toggle = this.config.muted;
            // Update config
            this.config.muted = toggle;
            // Set mute on the player
            this.media.muted = toggle;
        }
        /**
     * Get current muted state
     */ get muted() {
            return Boolean(this.media.muted);
        }
        /**
     * Check if the media has audio
     */ get hasAudio() {
            // Assume yes for all non HTML5 (as we can't tell...)
            if (!this.isHTML5) return true;
            if (this.isAudio) return true;
            // Get audio tracks
            return Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        /**
     * Set playback speed
     * @param {Number} input - the speed of playback (0.5-2.0)
     */ set speed(input) {
            let speed = null;
            if (is.number(input)) speed = input;
            if (!is.number(speed)) speed = this.storage.get("speed");
            if (!is.number(speed)) speed = this.config.speed.selected;
            // Clamp to min/max
            const { minimumSpeed: min, maximumSpeed: max } = this;
            speed = clamp(speed, min, max);
            // Update config
            this.config.speed.selected = speed;
            // Set media speed
            setTimeout(()=>{
                if (this.media) this.media.playbackRate = speed;
            }, 0);
        }
        /**
     * Get current playback speed
     */ get speed() {
            return Number(this.media.playbackRate);
        }
        /**
     * Get the minimum allowed speed
     */ get minimumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.min(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 0.5;
            // https://stackoverflow.com/a/32320020/1191319
            return 0.0625;
        }
        /**
     * Get the maximum allowed speed
     */ get maximumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.max(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 2;
            // https://stackoverflow.com/a/32320020/1191319
            return 16;
        }
        /**
     * Set playback quality
     * Currently HTML5 & YouTube only
     * @param {Number} input - Quality level
     */ set quality(input) {
            const config = this.config.quality;
            const options = this.options.quality;
            if (!options.length) return;
            let quality = [
                !is.empty(input) && Number(input),
                this.storage.get("quality"),
                config.selected,
                config.default
            ].find(is.number);
            let updateStorage = true;
            if (!options.includes(quality)) {
                const value = closest(options, quality);
                this.debug.warn(`Unsupported quality option: ${quality}, using ${value} instead`);
                quality = value;
                // Don't update storage if quality is not supported
                updateStorage = false;
            }
            // Update config
            config.selected = quality;
            // Set quality
            this.media.quality = quality;
            // Save to storage
            if (updateStorage) this.storage.set({
                quality: quality
            });
        }
        /**
     * Get current quality level
     */ get quality() {
            return this.media.quality;
        }
        /**
     * Toggle loop
     * TODO: Finish fancy new logic. Set the indicator on load as user may pass loop as config
     * @param {Boolean} input - Whether to loop or not
     */ set loop(input) {
            const toggle = is.boolean(input) ? input : this.config.loop.active;
            this.config.loop.active = toggle;
            this.media.loop = toggle;
        // Set default to be a true toggle
        /* const type = ['start', 'end', 'all', 'none', 'toggle'].includes(input) ? input : 'toggle';
           switch (type) {
              case 'start':
                  if (this.config.loop.end && this.config.loop.end <= this.currentTime) {
                      this.config.loop.end = null;
                  }
                  this.config.loop.start = this.currentTime;
                  // this.config.loop.indicator.start = this.elements.display.played.value;
                  break;
               case 'end':
                  if (this.config.loop.start >= this.currentTime) {
                      return this;
                  }
                  this.config.loop.end = this.currentTime;
                  // this.config.loop.indicator.end = this.elements.display.played.value;
                  break;
               case 'all':
                  this.config.loop.start = 0;
                  this.config.loop.end = this.duration - 2;
                  this.config.loop.indicator.start = 0;
                  this.config.loop.indicator.end = 100;
                  break;
               case 'toggle':
                  if (this.config.loop.active) {
                      this.config.loop.start = 0;
                      this.config.loop.end = null;
                  } else {
                      this.config.loop.start = 0;
                      this.config.loop.end = this.duration - 2;
                  }
                  break;
               default:
                  this.config.loop.start = 0;
                  this.config.loop.end = null;
                  break;
          } */ }
        /**
     * Get current loop state
     */ get loop() {
            return Boolean(this.media.loop);
        }
        /**
     * Set new media source
     * @param {Object} input - The new source object (see docs)
     */ set source(input) {
            source.change.call(this, input);
        }
        /**
     * Get current source
     */ get source() {
            return this.media.currentSrc;
        }
        /**
     * Get a download URL (either source or custom)
     */ get download() {
            const { download: download } = this.config.urls;
            return is.url(download) ? download : this.source;
        }
        /**
     * Set the download URL
     */ set download(input) {
            if (!is.url(input)) return;
            this.config.urls.download = input;
            controls.setDownloadUrl.call(this);
        }
        /**
     * Set the poster image for a video
     * @param {String} input - the URL for the new poster image
     */ set poster(input) {
            if (!this.isVideo) {
                this.debug.warn("Poster can only be set for video");
                return;
            }
            ui.setPoster.call(this, input, false).catch(()=>{});
        }
        /**
     * Get the current poster image
     */ get poster() {
            if (!this.isVideo) return null;
            return this.media.getAttribute("poster") || this.media.getAttribute("data-poster");
        }
        /**
     * Get the current aspect ratio in use
     */ get ratio() {
            if (!this.isVideo) return null;
            const ratio = reduceAspectRatio(getAspectRatio.call(this));
            return is.array(ratio) ? ratio.join(":") : ratio;
        }
        /**
     * Set video aspect ratio
     */ set ratio(input) {
            if (!this.isVideo) {
                this.debug.warn("Aspect ratio can only be set for video");
                return;
            }
            if (!is.string(input) || !validateAspectRatio(input)) {
                this.debug.error(`Invalid aspect ratio specified (${input})`);
                return;
            }
            this.config.ratio = reduceAspectRatio(input);
            setAspectRatio.call(this);
        }
        /**
     * Set the autoplay state
     * @param {Boolean} input - Whether to autoplay or not
     */ set autoplay(input) {
            this.config.autoplay = is.boolean(input) ? input : this.config.autoplay;
        }
        /**
     * Get the current autoplay state
     */ get autoplay() {
            return Boolean(this.config.autoplay);
        }
        /**
     * Toggle captions
     * @param {Boolean} input - Whether to enable captions
     */ toggleCaptions(input) {
            captions.toggle.call(this, input, false);
        }
        /**
     * Set the caption track by index
     * @param {Number} input - Caption index
     */ set currentTrack(input) {
            captions.set.call(this, input, false);
            captions.setup.call(this);
        }
        /**
     * Get the current caption track index (-1 if disabled)
     */ get currentTrack() {
            const { toggled: toggled, currentTrack: currentTrack } = this.captions;
            return toggled ? currentTrack : -1;
        }
        /**
     * Set the wanted language for captions
     * Since tracks can be added later it won't update the actual caption track until there is a matching track
     * @param {String} input - Two character ISO language code (e.g. EN, FR, PT, etc)
     */ set language(input) {
            captions.setLanguage.call(this, input, false);
        }
        /**
     * Get the current track's language
     */ get language() {
            return (captions.getCurrentTrack.call(this) || {}).language;
        }
        /**
     * Toggle picture-in-picture playback on WebKit/MacOS
     * TODO: update player with state, support, enabled
     * TODO: detect outside changes
     */ set pip(input) {
            // Bail if no support
            if (!support.pip) return;
            // Toggle based on current state if not passed
            const toggle = is.boolean(input) ? input : !this.pip;
            // Toggle based on current state
            // Safari
            if (is.function(this.media.webkitSetPresentationMode)) this.media.webkitSetPresentationMode(toggle ? pip.active : pip.inactive);
            // Chrome
            if (is.function(this.media.requestPictureInPicture)) {
                if (!this.pip && toggle) this.media.requestPictureInPicture();
                else if (this.pip && !toggle) document.exitPictureInPicture();
            }
        }
        /**
     * Get the current picture-in-picture state
     */ get pip() {
            if (!support.pip) return null;
            // Safari
            if (!is.empty(this.media.webkitPresentationMode)) return this.media.webkitPresentationMode === pip.active;
            // Chrome
            return this.media === document.pictureInPictureElement;
        }
        /**
     * Sets the preview thubmnails for the current source
     */ setPreviewThumbnails(thumbnailSource) {
            if (this.previewThumbnails && this.previewThumbnails.loaded) {
                this.previewThumbnails.destroy();
                this.previewThumbnails = null;
            }
            Object.assign(this.config.previewThumbnails, thumbnailSource);
            // Create new instance if it is still enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        /**
     * Trigger the airplay dialog
     * TODO: update player with state, support, enabled
     */ /**
     * Check for support
     * @param {String} type - Player type (audio/video)
     * @param {String} provider - Provider (html5/youtube/vimeo)
     * @param {Boolean} inline - Where player has `playsinline` sttribute
     */ static supported(type, provider, inline) {
            return support.check(type, provider, inline);
        }
        /**
     * Load an SVG sprite into the page
     * @param {String} url - URL for the SVG sprite
     * @param {String} [id] - Unique ID
     */ static loadSprite(url, id) {
            return loadSprite(url, id);
        }
        /**
     * Setup multiple instances
     * @param {*} selector
     * @param {Object} options
     */ static setup(selector, options = {}) {
            let targets = null;
            if (is.string(selector)) targets = Array.from(document.querySelectorAll(selector));
            else if (is.nodeList(selector)) targets = Array.from(selector);
            else if (is.array(selector)) targets = selector.filter(is.element);
            if (is.empty(targets)) return null;
            return targets.map((t)=>new Plyr(t, options));
        }
    }
    Plyr.defaults = cloneDeep(defaults);
    return Plyr;
}); //# sourceMappingURL=plyr.js.map



var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $59f888d7dcabf163$var$extendStatics = function(d, b) {
    $59f888d7dcabf163$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $59f888d7dcabf163$var$extendStatics(d, b);
};
function $59f888d7dcabf163$var$__extends(d, b) {
    $59f888d7dcabf163$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $59f888d7dcabf163$var$__assign = function() {
    $59f888d7dcabf163$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $59f888d7dcabf163$var$__assign.apply(this, arguments);
};
function $59f888d7dcabf163$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $59f888d7dcabf163$var$VIEWBOX_WIDTH = 100;
var $59f888d7dcabf163$var$VIEWBOX_HEIGHT = 100;
var $59f888d7dcabf163$var$VIEWBOX_HEIGHT_HALF = 50;
var $59f888d7dcabf163$var$VIEWBOX_CENTER_X = 50;
var $59f888d7dcabf163$var$VIEWBOX_CENTER_Y = 50;
function $59f888d7dcabf163$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $acw62.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $59f888d7dcabf163$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $59f888d7dcabf163$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $59f888d7dcabf163$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $59f888d7dcabf163$var$VIEWBOX_CENTER_X + "," + $59f888d7dcabf163$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $59f888d7dcabf163$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $59f888d7dcabf163$export$14082143029b37c8 = function(_super) {
    $59f888d7dcabf163$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $59f888d7dcabf163$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $acw62.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $59f888d7dcabf163$var$VIEWBOX_WIDTH + " " + $59f888d7dcabf163$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $acw62.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $59f888d7dcabf163$var$VIEWBOX_CENTER_X,
            cy: $59f888d7dcabf163$var$VIEWBOX_CENTER_Y,
            r: $59f888d7dcabf163$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $acw62.createElement)($59f888d7dcabf163$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $acw62.createElement)($59f888d7dcabf163$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $acw62.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $59f888d7dcabf163$var$VIEWBOX_CENTER_X,
            y: $59f888d7dcabf163$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: "CircularProgressbar",
            trail: "CircularProgressbar-trail",
            path: "CircularProgressbar-path",
            text: "CircularProgressbar-text",
            background: "CircularProgressbar-background"
        },
        counterClockwise: false,
        className: "",
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ""
    };
    return CircularProgressbar;
}((0, $acw62.Component));
function $59f888d7dcabf163$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $59f888d7dcabf163$var$__rest(props, [
        "children"
    ]);
    return (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $acw62.createElement)("div", {
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        }
    }, (0, $acw62.createElement)($59f888d7dcabf163$export$14082143029b37c8, $59f888d7dcabf163$var$__assign({}, circularProgressbarProps)), props.children ? (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "-100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    }, props.children) : null));
}
function $59f888d7dcabf163$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : "center center";
    return {
        root: {},
        path: $59f888d7dcabf163$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $59f888d7dcabf163$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $59f888d7dcabf163$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $59f888d7dcabf163$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $59f888d7dcabf163$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}



var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $692c898f1b866b38$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $692c898f1b866b38$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $692c898f1b866b38$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $692c898f1b866b38$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $692c898f1b866b38$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $692c898f1b866b38$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $692c898f1b866b38$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $692c898f1b866b38$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $692c898f1b866b38$var$_objectSpread($692c898f1b866b38$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $ac0cf9bebee0eacb$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $ac0cf9bebee0eacb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $ac0cf9bebee0eacb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ac0cf9bebee0eacb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ac0cf9bebee0eacb$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ac0cf9bebee0eacb$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ac0cf9bebee0eacb$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $ac0cf9bebee0eacb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $ac0cf9bebee0eacb$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $ac0cf9bebee0eacb$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $692c898f1b866b38$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $9c93b4a308143d8f$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $63c98f0db3cc2487$export$5bf35293e545f20c() {
    var analyticsContext = (0, $9c93b4a308143d8f$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $ac0cf9bebee0eacb$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $9199638cd2bfa705$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $f8a5355fce54a521$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8a5355fce54a521$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8a5355fce54a521$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8a5355fce54a521$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8a5355fce54a521$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $63c98f0db3cc2487$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $9199638cd2bfa705$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $9199638cd2bfa705$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f8a5355fce54a521$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");

var $ltooA = parcelRequire("ltooA");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $50942774ab114c9d$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $50942774ab114c9d$export$c881183ca713c214 = $50942774ab114c9d$export$987d49ffe1b0900f;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0e976ad0a059d2d1$export$4b84fd0e2c617bd = "#FFEBE6";
var $0e976ad0a059d2d1$export$b34b069eff244586 = "#FFBDAD";
var $0e976ad0a059d2d1$export$be802dd0d8b57f35 = "#FF8F73";
var $0e976ad0a059d2d1$export$60847d42f9da92a6 = "#FF7452";
var $0e976ad0a059d2d1$export$4a7404f376229999 = "#FF5630";
var $0e976ad0a059d2d1$export$2010d0fb4295b346 = "#DE350B";
var $0e976ad0a059d2d1$export$2837b5a1a71d5c02 = "#BF2600";
var $0e976ad0a059d2d1$export$8d9596b529bbb9cf = "#FFFAE6";
var $0e976ad0a059d2d1$export$41060a744ab0b7ae = "#FFF0B3";
var $0e976ad0a059d2d1$export$1cc05bbbf340e559 = "#FFE380";
var $0e976ad0a059d2d1$export$5aae31392d72caaa = "#FFC400";
var $0e976ad0a059d2d1$export$c6930421db9fa514 = "#FFAB00";
var $0e976ad0a059d2d1$export$59619663aa6500fb = "#FF991F";
var $0e976ad0a059d2d1$export$874739ea9e379ab6 = "#FF8B00";
var $0e976ad0a059d2d1$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0e976ad0a059d2d1$export$69a3bf21b9686c2b = "#ABF5D1";
var $0e976ad0a059d2d1$export$afbce1382ec95f73 = "#79F2C0";
var $0e976ad0a059d2d1$export$747d86715d4175de = "#57D9A3";
var $0e976ad0a059d2d1$export$940e1f69e873f202 = "#36B37E";
var $0e976ad0a059d2d1$export$a49394138f7b8e85 = "#00875A";
var $0e976ad0a059d2d1$export$6fa04827ac68a4fb = "#006644";
var $0e976ad0a059d2d1$export$226de0355ed012f8 = "#DEEBFF";
var $0e976ad0a059d2d1$export$8c13c2ee36917869 = "#B3D4FF";
var $0e976ad0a059d2d1$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0e976ad0a059d2d1$export$215b7063051591f1 = "#2684FF";
var $0e976ad0a059d2d1$export$e62e8919cca44969 = "#0065FF";
var $0e976ad0a059d2d1$export$b3de0ae08da2ce64 = "#0052CC";
var $0e976ad0a059d2d1$export$a6ee3d71bc067634 = "#0747A6";
var $0e976ad0a059d2d1$export$67f15409e87642a1 = "#669DF1";
var $0e976ad0a059d2d1$export$f0539dbc42dbb067 = "#8FB8F6";
var $0e976ad0a059d2d1$export$363e4475840015bb = "#EAE6FF";
var $0e976ad0a059d2d1$export$4b0a4417ed59760f = "#C0B6F2";
var $0e976ad0a059d2d1$export$6011520a64d9a187 = "#998DD9";
var $0e976ad0a059d2d1$export$a7175d4e9206bc80 = "#8777D9";
var $0e976ad0a059d2d1$export$b48405b95304b5a1 = "#6554C0";
var $0e976ad0a059d2d1$export$c71e4279dd54a18d = "#5243AA";
var $0e976ad0a059d2d1$export$147899de772240ec = "#403294";
var $0e976ad0a059d2d1$export$2cf711fe14c66f06 = "#E6FCFF";
var $0e976ad0a059d2d1$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0e976ad0a059d2d1$export$776c9c497ef08533 = "#79E2F2";
var $0e976ad0a059d2d1$export$69cb3ca10c1e330e = "#00C7E6";
var $0e976ad0a059d2d1$export$9dc1ef0f3f48059b = "#00B8D9";
var $0e976ad0a059d2d1$export$7c835c78b6fcdef8 = "#00A3BF";
var $0e976ad0a059d2d1$export$6036577f95c3877e = "#008DA6";
var $0e976ad0a059d2d1$export$29a4f05edc054374 = "#FFFFFF";
var $0e976ad0a059d2d1$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0e976ad0a059d2d1$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0e976ad0a059d2d1$export$3e51e8f1440314ba = "#EBECF0";
var $0e976ad0a059d2d1$export$1ce2d1575d444ceb = "#DFE1E6";
var $0e976ad0a059d2d1$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0e976ad0a059d2d1$export$c2e91cbeada39b8b = "#B3BAC5";
var $0e976ad0a059d2d1$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0e976ad0a059d2d1$export$eaa8c8a70ac22806 = "#97A0AF";
var $0e976ad0a059d2d1$export$7c87d337fb91a97d = "#8993A4";
var $0e976ad0a059d2d1$export$d6447c357493214f = "#7A869A";
var $0e976ad0a059d2d1$export$f563ee71e9ee74cd = "#6B778C";
var $0e976ad0a059d2d1$export$e2ef2124cf4024b1 = "#5E6C84";
var $0e976ad0a059d2d1$export$eece5f492e429f08 = "#505F79";
var $0e976ad0a059d2d1$export$c39c0fe0f26207ae = "#42526E";
var $0e976ad0a059d2d1$export$7090862dc3038a9f = "#344563";
var $0e976ad0a059d2d1$export$ad0bacf983b7ddaa = "#253858";
var $0e976ad0a059d2d1$export$7d61b15e0da132af = "#172B4D";
var $0e976ad0a059d2d1$export$fbda843f0a27fe96 = "#091E42";
var $0e976ad0a059d2d1$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0e976ad0a059d2d1$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0e976ad0a059d2d1$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0e976ad0a059d2d1$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0e976ad0a059d2d1$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0e976ad0a059d2d1$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0e976ad0a059d2d1$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0e976ad0a059d2d1$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0e976ad0a059d2d1$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0e976ad0a059d2d1$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0e976ad0a059d2d1$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0e976ad0a059d2d1$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0e976ad0a059d2d1$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0e976ad0a059d2d1$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0e976ad0a059d2d1$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0e976ad0a059d2d1$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0e976ad0a059d2d1$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0e976ad0a059d2d1$export$2f6319cf7d736c2a = "#E6EDFA";
var $0e976ad0a059d2d1$export$95126bc8884d6634 = "#DCE5F5";
var $0e976ad0a059d2d1$export$8338d8c35d44ff1 = "#CED9EB";
var $0e976ad0a059d2d1$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0e976ad0a059d2d1$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0e976ad0a059d2d1$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0e976ad0a059d2d1$export$97e81faa16a182c7 = "#8C9CB8";
var $0e976ad0a059d2d1$export$bfe21c59123ecf33 = "#7988A3";
var $0e976ad0a059d2d1$export$ee82aa2ea6a1558 = "#67758F";
var $0e976ad0a059d2d1$export$682927c6ed76be02 = "#56637A";
var $0e976ad0a059d2d1$export$91fd9994c5be9757 = "#455166";
var $0e976ad0a059d2d1$export$d281fbfe3cff2df6 = "#3B475C";
var $0e976ad0a059d2d1$export$3902c91d8b98a753 = "#313D52";
var $0e976ad0a059d2d1$export$8e8133c1ba5845b5 = "#283447";
var $0e976ad0a059d2d1$export$33ff357f6620b39 = "#202B3D";
var $0e976ad0a059d2d1$export$633847cf062b69e0 = "#1B2638";
var $0e976ad0a059d2d1$export$9776a6e503bdbf76 = "#121A29";
var $0e976ad0a059d2d1$export$6c813d5160dff5db = "#0E1624";
var $0e976ad0a059d2d1$export$3d4f271a500072a = "#0D1424";
var $0e976ad0a059d2d1$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0e976ad0a059d2d1$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0e976ad0a059d2d1$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0e976ad0a059d2d1$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0e976ad0a059d2d1$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0e976ad0a059d2d1$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0e976ad0a059d2d1$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0e976ad0a059d2d1$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0e976ad0a059d2d1$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0e976ad0a059d2d1$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0e976ad0a059d2d1$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0e976ad0a059d2d1$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0e976ad0a059d2d1$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0e976ad0a059d2d1$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0e976ad0a059d2d1$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0e976ad0a059d2d1$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0e976ad0a059d2d1$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $0e976ad0a059d2d1$export$d2adc5dedf09fced = "#292A2E";
var $0e976ad0a059d2d1$export$f51762073d2bb381 = "#94C748";
var $0e976ad0a059d2d1$export$95e26d54def96891 = "#B3DF72";


var $1f864dc64962f39c$export$ae3cba7672df0890 = "var(--ds-background-disabled, ".concat((0, $0e976ad0a059d2d1$export$9fdfb749e33cdf97), ")");
var $1f864dc64962f39c$export$fe505fe3c5edbdf6 = "var(--ds-border-disabled, ".concat((0, $0e976ad0a059d2d1$export$1ce2d1575d444ceb), ")");
var $1f864dc64962f39c$export$7f333bbf7ddab792 = "var(--ds-border-danger, ".concat((0, $0e976ad0a059d2d1$export$2010d0fb4295b346), ")");
var $1f864dc64962f39c$export$dafd83031c202ca8 = "var(--ds-border-input, ".concat((0, $0e976ad0a059d2d1$export$d6447c357493214f), ")");
var $1f864dc64962f39c$export$e8320c09dc1e4012 = "var(--ds-border-focused, ".concat((0, $0e976ad0a059d2d1$export$215b7063051591f1), ")");
var $1f864dc64962f39c$export$b13414ee9ac9cae6 = "var(--ds-background-input, ".concat((0, $0e976ad0a059d2d1$export$e655ef011c4aa1a2), ")");
var $1f864dc64962f39c$export$bca15982c103d57b = "var(--ds-background-input-hovered, ".concat((0, $0e976ad0a059d2d1$export$3e51e8f1440314ba), ")");
var $1f864dc64962f39c$export$21287e4b7f134f09 = "var(--ds-background-input-pressed, ".concat((0, $0e976ad0a059d2d1$export$29a4f05edc054374), ")");
var $1f864dc64962f39c$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
var $1f864dc64962f39c$export$5e076b2557ef7bbb = "var(--ds-text-subtlest, ".concat((0, $0e976ad0a059d2d1$export$f563ee71e9ee74cd), ")");
var $1f864dc64962f39c$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $0e976ad0a059d2d1$export$fbda843f0a27fe96), ")");
var $1f864dc64962f39c$export$eb4a7d363eec53c8 = "var(--ds-text-disabled, ".concat((0, $0e976ad0a059d2d1$export$5f71e19f3a7ad9de), ")");
var $1f864dc64962f39c$export$f4d082c200a4b4b8 = "transparent";


function $a4809c23d6fef6a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a4809c23d6fef6a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a4809c23d6fef6a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a4809c23d6fef6a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a4809c23d6fef6a2$var$disabledRules = {
    backgroundColor: $1f864dc64962f39c$export$ae3cba7672df0890,
    backgroundColorFocus: $1f864dc64962f39c$export$ae3cba7672df0890,
    backgroundColorHover: $1f864dc64962f39c$export$ae3cba7672df0890,
    borderColor: $1f864dc64962f39c$export$fe505fe3c5edbdf6,
    borderColorFocus: $1f864dc64962f39c$export$e8320c09dc1e4012,
    textColor: $1f864dc64962f39c$export$eb4a7d363eec53c8
};
var $a4809c23d6fef6a2$var$invalidRules = {
    borderColor: $1f864dc64962f39c$export$7f333bbf7ddab792,
    borderColorFocus: $1f864dc64962f39c$export$e8320c09dc1e4012,
    backgroundColor: $1f864dc64962f39c$export$b13414ee9ac9cae6,
    backgroundColorFocus: $1f864dc64962f39c$export$21287e4b7f134f09,
    backgroundColorHover: $1f864dc64962f39c$export$bca15982c103d57b
};
var $a4809c23d6fef6a2$var$backgroundColor = {
    standard: $1f864dc64962f39c$export$b13414ee9ac9cae6,
    subtle: $1f864dc64962f39c$export$f4d082c200a4b4b8,
    none: $1f864dc64962f39c$export$f4d082c200a4b4b8
};
var $a4809c23d6fef6a2$var$backgroundColorFocus = {
    standard: $1f864dc64962f39c$export$21287e4b7f134f09,
    subtle: $1f864dc64962f39c$export$21287e4b7f134f09,
    none: $1f864dc64962f39c$export$f4d082c200a4b4b8
};
var $a4809c23d6fef6a2$var$backgroundColorHover = {
    standard: $1f864dc64962f39c$export$bca15982c103d57b,
    subtle: $1f864dc64962f39c$export$bca15982c103d57b,
    none: $1f864dc64962f39c$export$f4d082c200a4b4b8
};
var $a4809c23d6fef6a2$var$borderColor = {
    standard: $1f864dc64962f39c$export$dafd83031c202ca8,
    subtle: $1f864dc64962f39c$export$f4d082c200a4b4b8,
    none: $1f864dc64962f39c$export$f4d082c200a4b4b8
};
var $a4809c23d6fef6a2$var$borderColorFocus = {
    standard: $1f864dc64962f39c$export$e8320c09dc1e4012,
    subtle: $1f864dc64962f39c$export$e8320c09dc1e4012,
    none: $1f864dc64962f39c$export$f4d082c200a4b4b8
};
var $a4809c23d6fef6a2$var$borderColorHover = {
    standard: $1f864dc64962f39c$export$dafd83031c202ca8,
    subtle: $1f864dc64962f39c$export$a87538d56ee366ec,
    none: $1f864dc64962f39c$export$f4d082c200a4b4b8
};
var $a4809c23d6fef6a2$var$lineHeightBase = 20;
var $a4809c23d6fef6a2$var$lineHeightCompact = 16;
var $a4809c23d6fef6a2$var$compactVerticalPadding = 2;
var $a4809c23d6fef6a2$var$verticalPadding = 6;
var $a4809c23d6fef6a2$var$horizontalPadding = 8;
var $a4809c23d6fef6a2$var$transitionDuration = "0.2s";
var $a4809c23d6fef6a2$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $a4809c23d6fef6a2$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: "unset",
    WebkitOpacity: "1"
};
var $a4809c23d6fef6a2$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $a4809c23d6fef6a2$var$lineHeightBase * minimumRows;
    return contentHeight + $a4809c23d6fef6a2$var$verticalPadding * 2 + borderHeight * 2;
};
var $a4809c23d6fef6a2$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $a4809c23d6fef6a2$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $a4809c23d6fef6a2$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $a4809c23d6fef6a2$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(appearance) {
    return appearance && (0, $gyDKM.css)($a4809c23d6fef6a2$var$_objectSpread({
        "&:focus": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a4809c23d6fef6a2$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a4809c23d6fef6a2$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a4809c23d6fef6a2$var$borderColorFocus[appearance])
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:not(:focus)": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a4809c23d6fef6a2$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a4809c23d6fef6a2$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-invalid]:focus": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a4809c23d6fef6a2$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a4809c23d6fef6a2$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a4809c23d6fef6a2$var$invalidRules.borderColorFocus)
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&[data-invalid]:not(:focus)": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a4809c23d6fef6a2$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a4809c23d6fef6a2$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a4809c23d6fef6a2$var$invalidRules.borderColor)
        }
    }, appearance === "standard" ? {
        "&:disabled:focus": {
            backgroundColor: $a4809c23d6fef6a2$var$disabledRules.backgroundColorFocus,
            borderColor: $a4809c23d6fef6a2$var$disabledRules.borderColorFocus
        },
        "&:disabled:not(:focus)": {
            backgroundColor: $a4809c23d6fef6a2$var$disabledRules.backgroundColor,
            borderColor: $a4809c23d6fef6a2$var$disabledRules.borderColor
        }
    } : {}));
};
var $a4809c23d6fef6a2$var$placeholderStyles = (0, $gyDKM.css)({
    "&::placeholder": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $1f864dc64962f39c$export$5e076b2557ef7bbb
    },
    "&:disabled::placeholder": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $a4809c23d6fef6a2$var$disabledRules.textColor
    }
});
var $a4809c23d6fef6a2$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(appearance) {
    return appearance && (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:hover:not(:read-only):not(:focus)": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a4809c23d6fef6a2$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a4809c23d6fef6a2$var$borderColorHover[appearance],
            "&:disabled": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $a4809c23d6fef6a2$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            "&[data-invalid]": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $a4809c23d6fef6a2$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $a4809c23d6fef6a2$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a4809c23d6fef6a2$var$invalidRules.borderColor)
            }
        }
    });
};
var $a4809c23d6fef6a2$var$resizeStyle = function resizeStyle(resize) {
    if (resize === "horizontal" || resize === "vertical") // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return (0, $gyDKM.css)({
        resize: resize
    });
    if (resize === "auto") return (0, $gyDKM.css)({
        resize: "both"
    });
    return (0, $gyDKM.css)({
        resize: "none"
    });
};
var $a4809c23d6fef6a2$var$borderStyle = function borderStyle(appearance) {
    return (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === "none" ? "none" : "solid"
    });
};
var $a4809c23d6fef6a2$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)' : 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    });
};
var $a4809c23d6fef6a2$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = appearance !== "none" ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $a4809c23d6fef6a2$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $gyDKM.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-compact]": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $a4809c23d6fef6a2$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($a4809c23d6fef6a2$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $a4809c23d6fef6a2$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:not([data-compact])": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $a4809c23d6fef6a2$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($a4809c23d6fef6a2$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $a4809c23d6fef6a2$var$lineHeightBase / 14
        }
    });
};
var $a4809c23d6fef6a2$var$staticStyles = (0, $gyDKM.css)({
    display: "block",
    boxSizing: "border-box",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    margin: 0,
    position: "relative",
    flex: "1 1 100%",
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    outline: "none",
    overflow: "auto",
    transition: "background-color ".concat($a4809c23d6fef6a2$var$transitionDuration, " ease-in-out,\n               border-color ").concat($a4809c23d6fef6a2$var$transitionDuration, " ease-in-out"),
    wordWrap: "break-word",
    "&:disabled": $a4809c23d6fef6a2$var$_objectSpread({
        cursor: "not-allowed"
    }, $a4809c23d6fef6a2$var$overrideSafariDisabledStyles),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-ms-clear": {
        display: "none"
    },
    "&:invalid": {
        boxShadow: "none"
    }
});
// suggestion: these two could be merged into cssMap during @compiled rewrite
var $a4809c23d6fef6a2$var$newFontStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    font: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
}, (0, $50942774ab114c9d$export$987d49ffe1b0900f).above.xs, {
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
}));
var $a4809c23d6fef6a2$var$monospacedFontFamilyStyles = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
}, (0, $50942774ab114c9d$export$987d49ffe1b0900f).above.xs, {
    // Reapply the monospaced font family as the font declaration used in the breakpoint in newFontStyles overrides it otherwise
    fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
}));
var $a4809c23d6fef6a2$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $gyDKM.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$borderStyle(appearance), // @todo: remove in `platform_design_system_team_safari_input_fix` cleanup
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") ? $a4809c23d6fef6a2$var$newFontStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    isMonospaced && (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") ? $a4809c23d6fef6a2$var$monospacedFontFamilyStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    }));
};
var $a4809c23d6fef6a2$export$98856a888ef36079 = function dynamicStyles(appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $gyDKM.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a4809c23d6fef6a2$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $1f864dc64962f39c$export$32f78bffcd82ff28,
        "&:disabled": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $a4809c23d6fef6a2$var$disabledRules.textColor
        }
    }));
};


var $ea673c41278c8551$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value"
];
function $ea673c41278c8551$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea673c41278c8551$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea673c41278c8551$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea673c41278c8551$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ea673c41278c8551$var$packageName = "@atlaskit/textarea";
var $ea673c41278c8551$var$packageVersion = "5.8.2";
var $ea673c41278c8551$var$analyticsParams = {
    componentName: "textArea",
    packageName: $ea673c41278c8551$var$packageName,
    packageVersion: $ea673c41278c8551$var$packageVersion
};
var $ea673c41278c8551$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = "auto";
    var borderHeight = (0, $a4809c23d6fef6a2$export$12879c7697ed953d);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $ea673c41278c8551$var$InnerTextArea = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var ourRef = (0, $acw62.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? "smart" : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? "50vh" : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $ea673c41278c8551$var$_excluded);
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (resize === "smart" && el) $ea673c41278c8551$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $f8a5355fce54a521$export$a4687b0234b40e28)($ea673c41278c8551$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $ea673c41278c8551$var$analyticsParams));
    var onFocusWithAnalytics = (0, $f8a5355fce54a521$export$a4687b0234b40e28)($ea673c41278c8551$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $ea673c41278c8551$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === "function") ref(elementRef);
    };
    var handleOnChange = (0, $acw62.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === "smart" && el) $ea673c41278c8551$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-testid": testId ? testId : undefined
    };
    var baseStyles = (0, $acw62.useMemo)(function() {
        return (0, $a4809c23d6fef6a2$export$bff8031d86bb089)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    var textAreaStyles = (0, $gyDKM.css)([
        baseStyles,
        (0, $a4809c23d6fef6a2$export$98856a888ef36079)(appearance)
    ]);
    return (0, $gyDKM.jsx)("textarea", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $ea673c41278c8551$var$TextArea = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function TextArea(props, ref) {
    return (0, $gyDKM.jsx)($ea673c41278c8551$var$InnerTextArea, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
}));
$ea673c41278c8551$var$TextArea.displayName = "TextArea";
var $ea673c41278c8551$export$2e2bcd8739ae039 = $ea673c41278c8551$var$TextArea;


var $71d76b5cdd325006$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $71d76b5cdd325006$var$INFINITY = 1 / 0, $71d76b5cdd325006$var$MAX_SAFE_INTEGER = 9007199254740991, $71d76b5cdd325006$var$MAX_INTEGER = 1.7976931348623157e+308, $71d76b5cdd325006$var$NAN = 0 / 0;
/** Used as references for the maximum length and index of an array. */ var $71d76b5cdd325006$var$MAX_ARRAY_LENGTH = 4294967295;
/** `Object#toString` result references. */ var $71d76b5cdd325006$var$argsTag = "[object Arguments]", $71d76b5cdd325006$var$funcTag = "[object Function]", $71d76b5cdd325006$var$genTag = "[object GeneratorFunction]", $71d76b5cdd325006$var$mapTag = "[object Map]", $71d76b5cdd325006$var$objectTag = "[object Object]", $71d76b5cdd325006$var$promiseTag = "[object Promise]", $71d76b5cdd325006$var$setTag = "[object Set]", $71d76b5cdd325006$var$stringTag = "[object String]", $71d76b5cdd325006$var$symbolTag = "[object Symbol]", $71d76b5cdd325006$var$weakMapTag = "[object WeakMap]";
var $71d76b5cdd325006$var$dataViewTag = "[object DataView]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $71d76b5cdd325006$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */ var $71d76b5cdd325006$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $71d76b5cdd325006$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $71d76b5cdd325006$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */ var $71d76b5cdd325006$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */ var $71d76b5cdd325006$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $71d76b5cdd325006$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to compose unicode character classes. */ var $71d76b5cdd325006$var$rsAstralRange = "\ud800-\udfff", $71d76b5cdd325006$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", $71d76b5cdd325006$var$rsComboSymbolsRange = "\\u20d0-\\u20f0", $71d76b5cdd325006$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $71d76b5cdd325006$var$rsAstral = "[" + $71d76b5cdd325006$var$rsAstralRange + "]", $71d76b5cdd325006$var$rsCombo = "[" + $71d76b5cdd325006$var$rsComboMarksRange + $71d76b5cdd325006$var$rsComboSymbolsRange + "]", $71d76b5cdd325006$var$rsFitz = "\ud83c[\udffb-\udfff]", $71d76b5cdd325006$var$rsModifier = "(?:" + $71d76b5cdd325006$var$rsCombo + "|" + $71d76b5cdd325006$var$rsFitz + ")", $71d76b5cdd325006$var$rsNonAstral = "[^" + $71d76b5cdd325006$var$rsAstralRange + "]", $71d76b5cdd325006$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $71d76b5cdd325006$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $71d76b5cdd325006$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $71d76b5cdd325006$var$reOptMod = $71d76b5cdd325006$var$rsModifier + "?", $71d76b5cdd325006$var$rsOptVar = "[" + $71d76b5cdd325006$var$rsVarRange + "]?", $71d76b5cdd325006$var$rsOptJoin = "(?:" + $71d76b5cdd325006$var$rsZWJ + "(?:" + [
    $71d76b5cdd325006$var$rsNonAstral,
    $71d76b5cdd325006$var$rsRegional,
    $71d76b5cdd325006$var$rsSurrPair
].join("|") + ")" + $71d76b5cdd325006$var$rsOptVar + $71d76b5cdd325006$var$reOptMod + ")*", $71d76b5cdd325006$var$rsSeq = $71d76b5cdd325006$var$rsOptVar + $71d76b5cdd325006$var$reOptMod + $71d76b5cdd325006$var$rsOptJoin, $71d76b5cdd325006$var$rsSymbol = "(?:" + [
    $71d76b5cdd325006$var$rsNonAstral + $71d76b5cdd325006$var$rsCombo + "?",
    $71d76b5cdd325006$var$rsCombo,
    $71d76b5cdd325006$var$rsRegional,
    $71d76b5cdd325006$var$rsSurrPair,
    $71d76b5cdd325006$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $71d76b5cdd325006$var$reUnicode = RegExp($71d76b5cdd325006$var$rsFitz + "(?=" + $71d76b5cdd325006$var$rsFitz + ")|" + $71d76b5cdd325006$var$rsSymbol + $71d76b5cdd325006$var$rsSeq, "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $71d76b5cdd325006$var$reHasUnicode = RegExp("[" + $71d76b5cdd325006$var$rsZWJ + $71d76b5cdd325006$var$rsAstralRange + $71d76b5cdd325006$var$rsComboMarksRange + $71d76b5cdd325006$var$rsComboSymbolsRange + $71d76b5cdd325006$var$rsVarRange + "]");
/** Built-in method references without a dependency on `root`. */ var $71d76b5cdd325006$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $71d76b5cdd325006$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $71d76b5cdd325006$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $71d76b5cdd325006$var$root = $71d76b5cdd325006$var$freeGlobal || $71d76b5cdd325006$var$freeSelf || Function("return this")();
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $71d76b5cdd325006$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $71d76b5cdd325006$var$asciiToArray(string) {
    return string.split("");
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $71d76b5cdd325006$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $71d76b5cdd325006$var$baseValues(object, props) {
    return $71d76b5cdd325006$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $71d76b5cdd325006$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $71d76b5cdd325006$var$hasUnicode(string) {
    return $71d76b5cdd325006$var$reHasUnicode.test(string);
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $71d76b5cdd325006$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $71d76b5cdd325006$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $71d76b5cdd325006$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $71d76b5cdd325006$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $71d76b5cdd325006$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $71d76b5cdd325006$var$stringToArray(string) {
    return $71d76b5cdd325006$var$hasUnicode(string) ? $71d76b5cdd325006$var$unicodeToArray(string) : $71d76b5cdd325006$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $71d76b5cdd325006$var$unicodeToArray(string) {
    return string.match($71d76b5cdd325006$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $71d76b5cdd325006$var$funcProto = Function.prototype, $71d76b5cdd325006$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $71d76b5cdd325006$var$coreJsData = $71d76b5cdd325006$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $71d76b5cdd325006$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($71d76b5cdd325006$var$coreJsData && $71d76b5cdd325006$var$coreJsData.keys && $71d76b5cdd325006$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $71d76b5cdd325006$var$funcToString = $71d76b5cdd325006$var$funcProto.toString;
/** Used to check objects for own properties. */ var $71d76b5cdd325006$var$hasOwnProperty = $71d76b5cdd325006$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $71d76b5cdd325006$var$objectToString = $71d76b5cdd325006$var$objectProto.toString;
/** Used to detect if a method is native. */ var $71d76b5cdd325006$var$reIsNative = RegExp("^" + $71d76b5cdd325006$var$funcToString.call($71d76b5cdd325006$var$hasOwnProperty).replace($71d76b5cdd325006$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $71d76b5cdd325006$var$Symbol = $71d76b5cdd325006$var$root.Symbol, $71d76b5cdd325006$var$iteratorSymbol = $71d76b5cdd325006$var$Symbol ? $71d76b5cdd325006$var$Symbol.iterator : undefined, $71d76b5cdd325006$var$propertyIsEnumerable = $71d76b5cdd325006$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $71d76b5cdd325006$var$nativeFloor = Math.floor, $71d76b5cdd325006$var$nativeKeys = $71d76b5cdd325006$var$overArg(Object.keys, Object), $71d76b5cdd325006$var$nativeRandom = Math.random;
/* Built-in method references that are verified to be native. */ var $71d76b5cdd325006$var$DataView = $71d76b5cdd325006$var$getNative($71d76b5cdd325006$var$root, "DataView"), $71d76b5cdd325006$var$Map = $71d76b5cdd325006$var$getNative($71d76b5cdd325006$var$root, "Map"), $71d76b5cdd325006$var$Promise = $71d76b5cdd325006$var$getNative($71d76b5cdd325006$var$root, "Promise"), $71d76b5cdd325006$var$Set = $71d76b5cdd325006$var$getNative($71d76b5cdd325006$var$root, "Set"), $71d76b5cdd325006$var$WeakMap = $71d76b5cdd325006$var$getNative($71d76b5cdd325006$var$root, "WeakMap");
/** Used to detect maps, sets, and weakmaps. */ var $71d76b5cdd325006$var$dataViewCtorString = $71d76b5cdd325006$var$toSource($71d76b5cdd325006$var$DataView), $71d76b5cdd325006$var$mapCtorString = $71d76b5cdd325006$var$toSource($71d76b5cdd325006$var$Map), $71d76b5cdd325006$var$promiseCtorString = $71d76b5cdd325006$var$toSource($71d76b5cdd325006$var$Promise), $71d76b5cdd325006$var$setCtorString = $71d76b5cdd325006$var$toSource($71d76b5cdd325006$var$Set), $71d76b5cdd325006$var$weakMapCtorString = $71d76b5cdd325006$var$toSource($71d76b5cdd325006$var$WeakMap);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $71d76b5cdd325006$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $71d76b5cdd325006$var$isArray(value) || $71d76b5cdd325006$var$isArguments(value) ? $71d76b5cdd325006$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $71d76b5cdd325006$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $71d76b5cdd325006$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $71d76b5cdd325006$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $71d76b5cdd325006$var$baseGetTag(value) {
    return $71d76b5cdd325006$var$objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $71d76b5cdd325006$var$baseIsNative(value) {
    if (!$71d76b5cdd325006$var$isObject(value) || $71d76b5cdd325006$var$isMasked(value)) return false;
    var pattern = $71d76b5cdd325006$var$isFunction(value) || $71d76b5cdd325006$var$isHostObject(value) ? $71d76b5cdd325006$var$reIsNative : $71d76b5cdd325006$var$reIsHostCtor;
    return pattern.test($71d76b5cdd325006$var$toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $71d76b5cdd325006$var$baseKeys(object) {
    if (!$71d76b5cdd325006$var$isPrototype(object)) return $71d76b5cdd325006$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($71d76b5cdd325006$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $71d76b5cdd325006$var$baseRandom(lower, upper) {
    return lower + $71d76b5cdd325006$var$nativeFloor($71d76b5cdd325006$var$nativeRandom() * (upper - lower + 1));
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $71d76b5cdd325006$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $71d76b5cdd325006$var$getNative(object, key) {
    var value = $71d76b5cdd325006$var$getValue(object, key);
    return $71d76b5cdd325006$var$baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $71d76b5cdd325006$var$getTag = $71d76b5cdd325006$var$baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ($71d76b5cdd325006$var$DataView && $71d76b5cdd325006$var$getTag(new $71d76b5cdd325006$var$DataView(new ArrayBuffer(1))) != $71d76b5cdd325006$var$dataViewTag || $71d76b5cdd325006$var$Map && $71d76b5cdd325006$var$getTag(new $71d76b5cdd325006$var$Map) != $71d76b5cdd325006$var$mapTag || $71d76b5cdd325006$var$Promise && $71d76b5cdd325006$var$getTag($71d76b5cdd325006$var$Promise.resolve()) != $71d76b5cdd325006$var$promiseTag || $71d76b5cdd325006$var$Set && $71d76b5cdd325006$var$getTag(new $71d76b5cdd325006$var$Set) != $71d76b5cdd325006$var$setTag || $71d76b5cdd325006$var$WeakMap && $71d76b5cdd325006$var$getTag(new $71d76b5cdd325006$var$WeakMap) != $71d76b5cdd325006$var$weakMapTag) $71d76b5cdd325006$var$getTag = function(value) {
    var result = $71d76b5cdd325006$var$objectToString.call(value), Ctor = result == $71d76b5cdd325006$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $71d76b5cdd325006$var$toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case $71d76b5cdd325006$var$dataViewCtorString:
            return $71d76b5cdd325006$var$dataViewTag;
        case $71d76b5cdd325006$var$mapCtorString:
            return $71d76b5cdd325006$var$mapTag;
        case $71d76b5cdd325006$var$promiseCtorString:
            return $71d76b5cdd325006$var$promiseTag;
        case $71d76b5cdd325006$var$setCtorString:
            return $71d76b5cdd325006$var$setTag;
        case $71d76b5cdd325006$var$weakMapCtorString:
            return $71d76b5cdd325006$var$weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $71d76b5cdd325006$var$isIndex(value, length) {
    length = length == null ? $71d76b5cdd325006$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $71d76b5cdd325006$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $71d76b5cdd325006$var$isIterateeCall(value, index, object) {
    if (!$71d76b5cdd325006$var$isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? $71d76b5cdd325006$var$isArrayLike(object) && $71d76b5cdd325006$var$isIndex(index, object.length) : type == "string" && index in object) return $71d76b5cdd325006$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $71d76b5cdd325006$var$isMasked(func) {
    return !!$71d76b5cdd325006$var$maskSrcKey && $71d76b5cdd325006$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $71d76b5cdd325006$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $71d76b5cdd325006$var$objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $71d76b5cdd325006$var$toSource(func) {
    if (func != null) {
        try {
            return $71d76b5cdd325006$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */ function $71d76b5cdd325006$var$sampleSize(collection, n, guard) {
    var index = -1, result = $71d76b5cdd325006$var$toArray(collection), length = result.length, lastIndex = length - 1;
    if (guard ? $71d76b5cdd325006$var$isIterateeCall(collection, n, guard) : n === undefined) n = 1;
    else n = $71d76b5cdd325006$var$baseClamp($71d76b5cdd325006$var$toInteger(n), 0, length);
    while(++index < n){
        var rand = $71d76b5cdd325006$var$baseRandom(index, lastIndex), value = result[rand];
        result[rand] = result[index];
        result[index] = value;
    }
    result.length = n;
    return result;
}
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $71d76b5cdd325006$var$shuffle(collection) {
    return $71d76b5cdd325006$var$sampleSize(collection, $71d76b5cdd325006$var$MAX_ARRAY_LENGTH);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $71d76b5cdd325006$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $71d76b5cdd325006$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $71d76b5cdd325006$var$isArrayLikeObject(value) && $71d76b5cdd325006$var$hasOwnProperty.call(value, "callee") && (!$71d76b5cdd325006$var$propertyIsEnumerable.call(value, "callee") || $71d76b5cdd325006$var$objectToString.call(value) == $71d76b5cdd325006$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $71d76b5cdd325006$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $71d76b5cdd325006$var$isArrayLike(value) {
    return value != null && $71d76b5cdd325006$var$isLength(value.length) && !$71d76b5cdd325006$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $71d76b5cdd325006$var$isArrayLikeObject(value) {
    return $71d76b5cdd325006$var$isObjectLike(value) && $71d76b5cdd325006$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $71d76b5cdd325006$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $71d76b5cdd325006$var$isObject(value) ? $71d76b5cdd325006$var$objectToString.call(value) : "";
    return tag == $71d76b5cdd325006$var$funcTag || tag == $71d76b5cdd325006$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $71d76b5cdd325006$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $71d76b5cdd325006$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $71d76b5cdd325006$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $71d76b5cdd325006$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $71d76b5cdd325006$var$isString(value) {
    return typeof value == "string" || !$71d76b5cdd325006$var$isArray(value) && $71d76b5cdd325006$var$isObjectLike(value) && $71d76b5cdd325006$var$objectToString.call(value) == $71d76b5cdd325006$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $71d76b5cdd325006$var$isSymbol(value) {
    return typeof value == "symbol" || $71d76b5cdd325006$var$isObjectLike(value) && $71d76b5cdd325006$var$objectToString.call(value) == $71d76b5cdd325006$var$symbolTag;
}
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $71d76b5cdd325006$var$toArray(value) {
    if (!value) return [];
    if ($71d76b5cdd325006$var$isArrayLike(value)) return $71d76b5cdd325006$var$isString(value) ? $71d76b5cdd325006$var$stringToArray(value) : $71d76b5cdd325006$var$copyArray(value);
    if ($71d76b5cdd325006$var$iteratorSymbol && value[$71d76b5cdd325006$var$iteratorSymbol]) return $71d76b5cdd325006$var$iteratorToArray(value[$71d76b5cdd325006$var$iteratorSymbol]());
    var tag = $71d76b5cdd325006$var$getTag(value), func = tag == $71d76b5cdd325006$var$mapTag ? $71d76b5cdd325006$var$mapToArray : tag == $71d76b5cdd325006$var$setTag ? $71d76b5cdd325006$var$setToArray : $71d76b5cdd325006$var$values;
    return func(value);
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $71d76b5cdd325006$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $71d76b5cdd325006$var$toNumber(value);
    if (value === $71d76b5cdd325006$var$INFINITY || value === -$71d76b5cdd325006$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $71d76b5cdd325006$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $71d76b5cdd325006$var$toInteger(value) {
    var result = $71d76b5cdd325006$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $71d76b5cdd325006$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($71d76b5cdd325006$var$isSymbol(value)) return $71d76b5cdd325006$var$NAN;
    if ($71d76b5cdd325006$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $71d76b5cdd325006$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($71d76b5cdd325006$var$reTrim, "");
    var isBinary = $71d76b5cdd325006$var$reIsBinary.test(value);
    return isBinary || $71d76b5cdd325006$var$reIsOctal.test(value) ? $71d76b5cdd325006$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $71d76b5cdd325006$var$reIsBadHex.test(value) ? $71d76b5cdd325006$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $71d76b5cdd325006$var$keys(object) {
    return $71d76b5cdd325006$var$isArrayLike(object) ? $71d76b5cdd325006$var$arrayLikeKeys(object) : $71d76b5cdd325006$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $71d76b5cdd325006$var$values(object) {
    return object ? $71d76b5cdd325006$var$baseValues(object, $71d76b5cdd325006$var$keys(object)) : [];
}
$71d76b5cdd325006$exports = $71d76b5cdd325006$var$shuffle;


/* eslint-disable @repo/internal/react/require-jsdoc */ var $06090553fb829f48$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $hPtJY = parcelRequire("hPtJY");
var $435dbeb6f3994f70$var$_process$env;
/// <reference types="node" />
var $435dbeb6f3994f70$var$_default_1 = typeof $hPtJY !== "undefined" && $hPtJY !== null && (($435dbeb6f3994f70$var$_process$env = {}, $435dbeb6f3994f70$var$_process$env === void 0) ? void 0 : $435dbeb6f3994f70$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);
var $435dbeb6f3994f70$export$2e2bcd8739ae039 = $435dbeb6f3994f70$var$_default_1;



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

function $df128ee7faff5945$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $df128ee7faff5945$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $df128ee7faff5945$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($df128ee7faff5945$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $df128ee7faff5945$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $df128ee7faff5945$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $df128ee7faff5945$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsContext);
        _this = $df128ee7faff5945$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $df128ee7faff5945$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $df128ee7faff5945$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab98e1efd591debd$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $acw62.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($df128ee7faff5945$var$AnalyticsContext, "contextTypes", $df128ee7faff5945$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($df128ee7faff5945$var$AnalyticsContext, "childContextTypes", $df128ee7faff5945$var$ContextTypes);
var $df128ee7faff5945$export$2e2bcd8739ae039 = $df128ee7faff5945$var$AnalyticsContext;



var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $23dfb362d41ad1f6$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};



var $acw62 = parcelRequire("acw62");
var $80f6721f94d0e6fe$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


var $fd9568354561533d$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $80f6721f94d0e6fe$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $23dfb362d41ad1f6$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $acw62.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $acw62.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab98e1efd591debd$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $fd9568354561533d$export$2e2bcd8739ae039 = $fd9568354561533d$var$AnalyticsContext;


var $dc3f627f04e213ed$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $435dbeb6f3994f70$export$2e2bcd8739ae039) || (0, $ltooA.fg)("analytics-next-use-legacy-context") === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fd9568354561533d$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df128ee7faff5945$export$2e2bcd8739ae039), props);
};
var $dc3f627f04e213ed$export$2e2bcd8739ae039 = $dc3f627f04e213ed$var$AnalyticsContext;


var $a81201919ffed32b$var$_excluded = [
    "analyticsContext"
];
function $a81201919ffed32b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a81201919ffed32b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a81201919ffed32b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a81201919ffed32b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a81201919ffed32b$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a81201919ffed32b$var$_excluded);
            var analyticsData = (0, $acw62.useMemo)(function() {
                return $a81201919ffed32b$var$_objectSpread($a81201919ffed32b$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc3f627f04e213ed$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $a81201919ffed32b$export$2e2bcd8739ae039 = $a81201919ffed32b$var$withAnalyticsContext;


var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $f1f955a7d7800268$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1f955a7d7800268$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1f955a7d7800268$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1f955a7d7800268$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f1f955a7d7800268$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f1f955a7d7800268$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $f1f955a7d7800268$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f1f955a7d7800268$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $f1f955a7d7800268$var$_objectSpread($f1f955a7d7800268$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $512028ccf877f337$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $512028ccf877f337$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $512028ccf877f337$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($512028ccf877f337$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $512028ccf877f337$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $512028ccf877f337$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $512028ccf877f337$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $512028ccf877f337$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $512028ccf877f337$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $512028ccf877f337$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $f1f955a7d7800268$export$2e2bcd8739ae039));



function $7d289a077a53c2e3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $23dfb362d41ad1f6$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $512028ccf877f337$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

function $d99e96c8a36a09fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d99e96c8a36a09fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d99e96c8a36a09fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d99e96c8a36a09fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d99e96c8a36a09fc$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $7d289a077a53c2e3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $acw62.useRef)({});
    var patchedProps = (0, $acw62.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $d99e96c8a36a09fc$var$_objectSpread($d99e96c8a36a09fc$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $d99e96c8a36a09fc$var$_objectSpread($d99e96c8a36a09fc$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $2fca11379f299e8e$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $d99e96c8a36a09fc$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $7d289a077a53c2e3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $2fca11379f299e8e$export$2e2bcd8739ae039 = $2fca11379f299e8e$var$withAnalyticsEvents;



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");
/* select.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");
var $84929694f9ad646d$exports = {};
function $84929694f9ad646d$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
$84929694f9ad646d$exports = $84929694f9ad646d$var$_readOnlyError, $84929694f9ad646d$exports.__esModule = true, $84929694f9ad646d$exports["default"] = $84929694f9ad646d$exports;



var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");

var $7lEDz = parcelRequire("7lEDz");

var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $785c9998908c36ff$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $785c9998908c36ff$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $785c9998908c36ff$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $785c9998908c36ff$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $g5Zhu = parcelRequire("g5Zhu");
/* indicators-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $7lEDz = parcelRequire("7lEDz");
const $5eaac7506ec1ff7b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $7lEDz.default)(actualStyles);
};


var $702bc6278a018d65$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $9ddb497f2638dee9$var$indicatorContainerStyles = null;
var $9ddb497f2638dee9$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "indicatorsContainer", {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-IndicatorsContainer")
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $9c6b1b215a2de1de$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk15s3 _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $9c6b1b215a2de1de$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $9c6b1b215a2de1de$var$multiValueStyles.root,
            isDisabled && $9c6b1b215a2de1de$var$multiValueStyles.disabled,
            isFocused && $9c6b1b215a2de1de$var$multiValueStyles.focused,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-multiValue")
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $5131fa8afa2d13f4$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $5131fa8afa2d13f4$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $5131fa8afa2d13f4$var$containerStyles.default,
            isRtl && $5131fa8afa2d13f4$var$containerStyles.rtl,
            isDisabled && $5131fa8afa2d13f4$var$containerStyles.disabled,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-container")
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $9804ec5e17a41770$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7",
    flex: "_1e0c1txw",
    compact: "_1q51ze3t _y4ti12x7 _85i5ze3t _bozg12x7"
};
var $9804ec5e17a41770$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $9804ec5e17a41770$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $9804ec5e17a41770$var$valueContainerStyles.flex,
            isCompact && $9804ec5e17a41770$var$valueContainerStyles.compact,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-ValueContainer")
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $ltooA = parcelRequire("ltooA");

var $b8d47299a469ed9f$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $b8d47299a469ed9f$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: innerRef,
        className: (0, $7lEDz.default)([
            $b8d47299a469ed9f$var$styles.default,
            (0, $ltooA.fg)("platform-dst-shape-theme-default") && $b8d47299a469ed9f$var$styles.defaultT26Shape,
            isDisabled && $b8d47299a469ed9f$var$styles.disabled,
            isInvalid && $b8d47299a469ed9f$var$styles.invalid,
            isCompact && $b8d47299a469ed9f$var$styles.compact,
            appearance === "subtle" && $b8d47299a469ed9f$var$styles.subtle,
            appearance === "subtle" && isFocused && $b8d47299a469ed9f$var$styles.subtleFocused,
            isFocused && $b8d47299a469ed9f$var$styles.focused,
            appearance === "none" && $b8d47299a469ed9f$var$styles.none,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-control")
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b8d47299a469ed9f$export$2e2bcd8739ae039 = $b8d47299a469ed9f$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $e60a7da7404ce3ea$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $e60a7da7404ce3ea$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "group", {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $e60a7da7404ce3ea$var$styles.root,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, "-Group")
        ])
    }), label && /*#__PURE__*/ $acw62.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $acw62.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e60a7da7404ce3ea$export$2e2bcd8739ae039 = $e60a7da7404ce3ea$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");



var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");
var $0952c65f3f364582$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $0952c65f3f364582$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0952c65f3f364582$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0952c65f3f364582$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0952c65f3f364582$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0952c65f3f364582$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $0952c65f3f364582$var$_excluded);
    return $0952c65f3f364582$var$_objectSpread({}, innerProps);
};


var $a30f927442de8d89$var$_excluded = [
    "data"
];
var $a30f927442de8d89$var$headingStyles = null;
var $a30f927442de8d89$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $0952c65f3f364582$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_cleanCommonProps, $a30f927442de8d89$var$_excluded);
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "groupHeading", {
        "group-heading": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-group")
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $6f8cb38ab8053f9c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6f8cb38ab8053f9c$exports, "__esModule", {
    value: true
});
$6f8cb38ab8053f9c$exports.default = void 0;

var $6f8cb38ab8053f9c$var$_react = $6f8cb38ab8053f9c$var$_interopRequireDefault((parcelRequire("acw62")));

var $6f8cb38ab8053f9c$var$_baseNew = $6f8cb38ab8053f9c$var$_interopRequireDefault((parcelRequire("5jvkr")));
function $6f8cb38ab8053f9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f8cb38ab8053f9c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $6f8cb38ab8053f9c$var$_react.default.createElement($6f8cb38ab8053f9c$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$6f8cb38ab8053f9c$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $6f8cb38ab8053f9c$var$_default = $6f8cb38ab8053f9c$exports.default = $6f8cb38ab8053f9c$var$CrossCircleIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $ab1f802aa0991e16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab1f802aa0991e16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab1f802aa0991e16$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab1f802aa0991e16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab1f802aa0991e16$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ab1f802aa0991e16$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ab1f802aa0991e16$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ab1f802aa0991e16$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $ab1f802aa0991e16$var$_objectSpread($ab1f802aa0991e16$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1614d4b5e6ef28c9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $1614d4b5e6ef28c9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $1614d4b5e6ef28c9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1614d4b5e6ef28c9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1614d4b5e6ef28c9$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1614d4b5e6ef28c9$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1614d4b5e6ef28c9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $1614d4b5e6ef28c9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $1614d4b5e6ef28c9$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1614d4b5e6ef28c9$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $ab1f802aa0991e16$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $0f816e84cca936b0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $d8b59e6c55018abf$export$5bf35293e545f20c() {
    var analyticsContext = (0, $0f816e84cca936b0$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $1614d4b5e6ef28c9$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $97ed421d130e262c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $d71553101c851cde$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d71553101c851cde$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d71553101c851cde$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d71553101c851cde$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d71553101c851cde$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d8b59e6c55018abf$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $97ed421d130e262c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $97ed421d130e262c$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d71553101c851cde$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}





var $acw62 = parcelRequire("acw62");
var $cbdb2814feb49f3f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");
var $569d4f34976b061d$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $569d4f34976b061d$var$_excluded2 = [
    "className"
];
var $569d4f34976b061d$var$focusRingStyles = null;
var $569d4f34976b061d$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $569d4f34976b061d$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $569d4f34976b061d$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $569d4f34976b061d$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $7lEDz.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $569d4f34976b061d$export$2e2bcd8739ae039 = $569d4f34976b061d$var$Focusable;


var $d850cae46f841614$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $d850cae46f841614$var$_excluded2 = [
    "className"
];
var $d850cae46f841614$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d850cae46f841614$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d850cae46f841614$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $cbdb2814feb49f3f$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $d71553101c851cde$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $d850cae46f841614$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $569d4f34976b061d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $0ef728659bef6f62$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)($d850cae46f841614$var$styles.root, isDisabled && $d850cae46f841614$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $d850cae46f841614$export$2e2bcd8739ae039 = $d850cae46f841614$var$Pressable;



var $28b9578d44916ffb$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $28b9578d44916ffb$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $28b9578d44916ffb$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? "clear" : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $28b9578d44916ffb$var$clearIndicatorStyles.default,
            isCompact && $28b9578d44916ffb$var$clearIndicatorStyles.compact,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-indicatorContainer")
        ])
    }, innerProps), /*#__PURE__*/ $acw62.createElement((0, $d850cae46f841614$export$2e2bcd8739ae039), {
        xcss: $28b9578d44916ffb$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6f8cb38ab8053f9c$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $3156e2a31b1a9771$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($3156e2a31b1a9771$exports, "__esModule", {
    value: true
});
$3156e2a31b1a9771$exports.default = void 0;

var $3156e2a31b1a9771$var$_react = $3156e2a31b1a9771$var$_interopRequireDefault((parcelRequire("acw62")));

var $3156e2a31b1a9771$var$_baseNew = $3156e2a31b1a9771$var$_interopRequireDefault((parcelRequire("5jvkr")));
function $3156e2a31b1a9771$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3156e2a31b1a9771$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3156e2a31b1a9771$var$_react.default.createElement($3156e2a31b1a9771$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$3156e2a31b1a9771$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $3156e2a31b1a9771$var$_default = $3156e2a31b1a9771$exports.default = $3156e2a31b1a9771$var$ChevronDownIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");
var $8718388c9790f1bc$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $8718388c9790f1bc$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $8718388c9790f1bc$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $8718388c9790f1bc$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $8718388c9790f1bc$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $8718388c9790f1bc$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $8718388c9790f1bc$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $8718388c9790f1bc$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $8718388c9790f1bc$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $8718388c9790f1bc$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, ariaAttributes, {
        role: role,
        className: (0, $7lEDz.default)([
            $8718388c9790f1bc$var$styles.root,
            gap && $8718388c9790f1bc$var$columnGapMap[gap],
            columnGap && $8718388c9790f1bc$var$columnGapMap[columnGap],
            gap && $8718388c9790f1bc$var$rowGapMap[gap],
            rowGap && $8718388c9790f1bc$var$rowGapMap[rowGap],
            alignItems && $8718388c9790f1bc$var$alignItemsMap[alignItems],
            direction && $8718388c9790f1bc$var$flexDirectionMap[direction],
            justifyContent && $8718388c9790f1bc$var$justifyContentMap[justifyContent],
            wrap && $8718388c9790f1bc$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$8718388c9790f1bc$var$Flex.displayName = "Flex";
var $8718388c9790f1bc$export$2e2bcd8739ae039 = $8718388c9790f1bc$var$Flex;


var $aea48fcec837ec21$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $aea48fcec837ec21$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $aea48fcec837ec21$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $7lEDz.default)([
            $aea48fcec837ec21$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $aea48fcec837ec21$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $aea48fcec837ec21$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $acw62.createElement($aea48fcec837ec21$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $acw62.createElement((0, $8718388c9790f1bc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $66d7dbe9bd15c487$export$a274e22fb40f762e)(grow === "hug" && $aea48fcec837ec21$var$styles.hug, grow === "fill" && $aea48fcec837ec21$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$aea48fcec837ec21$var$Inline.displayName = "Inline";
var $aea48fcec837ec21$export$2e2bcd8739ae039 = $aea48fcec837ec21$var$Inline;



var $2475fba3385d7619$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
var $2475fba3385d7619$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $2475fba3385d7619$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $2475fba3385d7619$var$dropdownStyles.default,
            isDisabled && $2475fba3385d7619$var$dropdownStyles.disabled,
            isCompact && $2475fba3385d7619$var$dropdownStyles.compact,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-indicatorContainer")
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $acw62.createElement((0, $aea48fcec837ec21$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $2475fba3385d7619$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3156e2a31b1a9771$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e29b896f7f0bda4f$var$ATOMIC_GROUP_LENGTH = 5;
function $e29b896f7f0bda4f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $e29b896f7f0bda4f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e46d18a7436b82ca$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


// Reds
var $ba973e425b8e449c$export$4b84fd0e2c617bd = "#FFEBE6";
var $ba973e425b8e449c$export$b34b069eff244586 = "#FFBDAD";
var $ba973e425b8e449c$export$be802dd0d8b57f35 = "#FF8F73";
var $ba973e425b8e449c$export$60847d42f9da92a6 = "#FF7452";
var $ba973e425b8e449c$export$4a7404f376229999 = "#FF5630";
var $ba973e425b8e449c$export$2010d0fb4295b346 = "#DE350B";
var $ba973e425b8e449c$export$2837b5a1a71d5c02 = "#BF2600";
var $ba973e425b8e449c$export$8d9596b529bbb9cf = "#FFFAE6";
var $ba973e425b8e449c$export$41060a744ab0b7ae = "#FFF0B3";
var $ba973e425b8e449c$export$1cc05bbbf340e559 = "#FFE380";
var $ba973e425b8e449c$export$5aae31392d72caaa = "#FFC400";
var $ba973e425b8e449c$export$c6930421db9fa514 = "#FFAB00";
var $ba973e425b8e449c$export$59619663aa6500fb = "#FF991F";
var $ba973e425b8e449c$export$874739ea9e379ab6 = "#FF8B00";
var $ba973e425b8e449c$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $ba973e425b8e449c$export$69a3bf21b9686c2b = "#ABF5D1";
var $ba973e425b8e449c$export$afbce1382ec95f73 = "#79F2C0";
var $ba973e425b8e449c$export$747d86715d4175de = "#57D9A3";
var $ba973e425b8e449c$export$940e1f69e873f202 = "#36B37E";
var $ba973e425b8e449c$export$a49394138f7b8e85 = "#00875A";
var $ba973e425b8e449c$export$6fa04827ac68a4fb = "#006644";
var $ba973e425b8e449c$export$226de0355ed012f8 = "#DEEBFF";
var $ba973e425b8e449c$export$8c13c2ee36917869 = "#B3D4FF";
var $ba973e425b8e449c$export$ecfc1dff386a3e7a = "#4C9AFF";
var $ba973e425b8e449c$export$215b7063051591f1 = "#2684FF";
var $ba973e425b8e449c$export$e62e8919cca44969 = "#0065FF";
var $ba973e425b8e449c$export$b3de0ae08da2ce64 = "#0052CC";
var $ba973e425b8e449c$export$a6ee3d71bc067634 = "#0747A6";
var $ba973e425b8e449c$export$67f15409e87642a1 = "#669DF1";
var $ba973e425b8e449c$export$f0539dbc42dbb067 = "#8FB8F6";
var $ba973e425b8e449c$export$363e4475840015bb = "#EAE6FF";
var $ba973e425b8e449c$export$4b0a4417ed59760f = "#C0B6F2";
var $ba973e425b8e449c$export$6011520a64d9a187 = "#998DD9";
var $ba973e425b8e449c$export$a7175d4e9206bc80 = "#8777D9";
var $ba973e425b8e449c$export$b48405b95304b5a1 = "#6554C0";
var $ba973e425b8e449c$export$c71e4279dd54a18d = "#5243AA";
var $ba973e425b8e449c$export$147899de772240ec = "#403294";
var $ba973e425b8e449c$export$2cf711fe14c66f06 = "#E6FCFF";
var $ba973e425b8e449c$export$7a8f4d33f6f9772c = "#B3F5FF";
var $ba973e425b8e449c$export$776c9c497ef08533 = "#79E2F2";
var $ba973e425b8e449c$export$69cb3ca10c1e330e = "#00C7E6";
var $ba973e425b8e449c$export$9dc1ef0f3f48059b = "#00B8D9";
var $ba973e425b8e449c$export$7c835c78b6fcdef8 = "#00A3BF";
var $ba973e425b8e449c$export$6036577f95c3877e = "#008DA6";
var $ba973e425b8e449c$export$29a4f05edc054374 = "#FFFFFF";
var $ba973e425b8e449c$export$e655ef011c4aa1a2 = "#FAFBFC";
var $ba973e425b8e449c$export$9fdfb749e33cdf97 = "#F4F5F7";
var $ba973e425b8e449c$export$3e51e8f1440314ba = "#EBECF0";
var $ba973e425b8e449c$export$1ce2d1575d444ceb = "#DFE1E6";
var $ba973e425b8e449c$export$8754fc7e6d8b3000 = "#C1C7D0";
var $ba973e425b8e449c$export$c2e91cbeada39b8b = "#B3BAC5";
var $ba973e425b8e449c$export$5f71e19f3a7ad9de = "#A5ADBA";
var $ba973e425b8e449c$export$eaa8c8a70ac22806 = "#97A0AF";
var $ba973e425b8e449c$export$7c87d337fb91a97d = "#8993A4";
var $ba973e425b8e449c$export$d6447c357493214f = "#7A869A";
var $ba973e425b8e449c$export$f563ee71e9ee74cd = "#6B778C";
var $ba973e425b8e449c$export$e2ef2124cf4024b1 = "#5E6C84";
var $ba973e425b8e449c$export$eece5f492e429f08 = "#505F79";
var $ba973e425b8e449c$export$c39c0fe0f26207ae = "#42526E";
var $ba973e425b8e449c$export$7090862dc3038a9f = "#344563";
var $ba973e425b8e449c$export$ad0bacf983b7ddaa = "#253858";
var $ba973e425b8e449c$export$7d61b15e0da132af = "#172B4D";
var $ba973e425b8e449c$export$fbda843f0a27fe96 = "#091E42";
var $ba973e425b8e449c$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $ba973e425b8e449c$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $ba973e425b8e449c$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $ba973e425b8e449c$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $ba973e425b8e449c$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $ba973e425b8e449c$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $ba973e425b8e449c$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $ba973e425b8e449c$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $ba973e425b8e449c$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $ba973e425b8e449c$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $ba973e425b8e449c$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $ba973e425b8e449c$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $ba973e425b8e449c$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $ba973e425b8e449c$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $ba973e425b8e449c$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $ba973e425b8e449c$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $ba973e425b8e449c$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $ba973e425b8e449c$export$2f6319cf7d736c2a = "#E6EDFA";
var $ba973e425b8e449c$export$95126bc8884d6634 = "#DCE5F5";
var $ba973e425b8e449c$export$8338d8c35d44ff1 = "#CED9EB";
var $ba973e425b8e449c$export$5368d76ae4fbbda7 = "#B8C7E0";
var $ba973e425b8e449c$export$9f0a771d16ec8d36 = "#ABBBD6";
var $ba973e425b8e449c$export$abcf8c38338b4aa5 = "#9FB0CC";
var $ba973e425b8e449c$export$97e81faa16a182c7 = "#8C9CB8";
var $ba973e425b8e449c$export$bfe21c59123ecf33 = "#7988A3";
var $ba973e425b8e449c$export$ee82aa2ea6a1558 = "#67758F";
var $ba973e425b8e449c$export$682927c6ed76be02 = "#56637A";
var $ba973e425b8e449c$export$91fd9994c5be9757 = "#455166";
var $ba973e425b8e449c$export$d281fbfe3cff2df6 = "#3B475C";
var $ba973e425b8e449c$export$3902c91d8b98a753 = "#313D52";
var $ba973e425b8e449c$export$8e8133c1ba5845b5 = "#283447";
var $ba973e425b8e449c$export$33ff357f6620b39 = "#202B3D";
var $ba973e425b8e449c$export$633847cf062b69e0 = "#1B2638";
var $ba973e425b8e449c$export$9776a6e503bdbf76 = "#121A29";
var $ba973e425b8e449c$export$6c813d5160dff5db = "#0E1624";
var $ba973e425b8e449c$export$3d4f271a500072a = "#0D1424";
var $ba973e425b8e449c$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $ba973e425b8e449c$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $ba973e425b8e449c$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $ba973e425b8e449c$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $ba973e425b8e449c$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $ba973e425b8e449c$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $ba973e425b8e449c$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $ba973e425b8e449c$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $ba973e425b8e449c$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $ba973e425b8e449c$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $ba973e425b8e449c$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $ba973e425b8e449c$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $ba973e425b8e449c$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $ba973e425b8e449c$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $ba973e425b8e449c$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $ba973e425b8e449c$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $ba973e425b8e449c$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $ba973e425b8e449c$export$d2adc5dedf09fced = "#292A2E";
var $ba973e425b8e449c$export$f51762073d2bb381 = "#94C748";
var $ba973e425b8e449c$export$95e26d54def96891 = "#B3DF72";


var $6ff53f1755ddd8ca$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $fed81066867e45e5$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $ba973e425b8e449c$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $ba973e425b8e449c$export$29a4f05edc054374), ")");
}
var $fed81066867e45e5$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $fed81066867e45e5$var$loadIn = null;
var $fed81066867e45e5$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $fed81066867e45e5$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $fed81066867e45e5$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $6ff53f1755ddd8ca$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $fed81066867e45e5$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $e46d18a7436b82ca$export$2e2bcd8739ae039));
    $fed81066867e45e5$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $e29b896f7f0bda4f$export$2e2bcd8739ae039)([
            $fed81066867e45e5$var$styles.wrapperStyles,
            $fed81066867e45e5$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $e29b896f7f0bda4f$export$2e2bcd8739ae039)([
            $fed81066867e45e5$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $e29b896f7f0bda4f$export$2e2bcd8739ae039)([
            $fed81066867e45e5$var$styles.circleStyles
        ])
    })));
}));
var $fed81066867e45e5$export$2e2bcd8739ae039 = $fed81066867e45e5$var$Spinner;



var $0530124230c4fedf$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $0530124230c4fedf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0530124230c4fedf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0530124230c4fedf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0530124230c4fedf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0530124230c4fedf$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $0530124230c4fedf$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $0530124230c4fedf$var$_excluded);
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)($0530124230c4fedf$var$_objectSpread($0530124230c4fedf$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $0530124230c4fedf$var$loadingIndicatorStyles.default,
            isCompact && $0530124230c4fedf$var$loadingIndicatorStyles.compact,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-loadingIndicator")
        ])
    }, innerProps), /*#__PURE__*/ $acw62.createElement((0, $fed81066867e45e5$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $ltooA = parcelRequire("ltooA");


var $deccdd3adfd208a3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $deccdd3adfd208a3$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $deccdd3adfd208a3$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $deccdd3adfd208a3$var$nativeInputStylesOld = null;
var $deccdd3adfd208a3$var$nativeInputStyles = null;
var $deccdd3adfd208a3$var$hidden = null;
var $deccdd3adfd208a3$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $0952c65f3f364582$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_cleanCommonProps, $deccdd3adfd208a3$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "input", {
        "input-container": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $ltooA.fg)("platform_do_not_clear_input_for_multiselect")) return /*#__PURE__*/ $acw62.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $deccdd3adfd208a3$var$inputStyles.root,
            isDisabled && $deccdd3adfd208a3$var$inputStyles.disabled,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-Input")
        ]),
        "data-value": value || "",
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7lEDz.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, "-input")
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $acw62.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $deccdd3adfd208a3$var$inputStylesOld.root,
            isDisabled && $deccdd3adfd208a3$var$inputStylesOld.disabled,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-Input")
        ]),
        "data-value": value || "",
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7lEDz.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, "-input")
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$deccdd3adfd208a3$export$2e2bcd8739ae039 = $deccdd3adfd208a3$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $ltooA = parcelRequire("ltooA");

var $54eed77df4687f6b$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $54eed77df4687f6b$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "menu", {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $54eed77df4687f6b$var$menuStyles.root,
            $54eed77df4687f6b$var$menuStyles[placement],
            (0, $ltooA.fg)("platform-dst-shape-theme-default") && $54eed77df4687f6b$var$menuStyles.rootT26Shape,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(xcss, className, "-menu")
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$54eed77df4687f6b$export$2e2bcd8739ae039 = $54eed77df4687f6b$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


function $3f898c83f71dd370$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f898c83f71dd370$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f898c83f71dd370$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f898c83f71dd370$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f898c83f71dd370$var$menuListStyles = null;
var $3f898c83f71dd370$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-MenuList")
        ]),
        style: $3f898c83f71dd370$var$_objectSpread($3f898c83f71dd370$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $bv4qN = parcelRequire("bv4qN");

var $acw62 = parcelRequire("acw62");
var $471b7090fdb2f5cc$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $471b7090fdb2f5cc$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($471b7090fdb2f5cc$var$HasTextAncestorContext);
};
var $471b7090fdb2f5cc$export$ae933c6cbe5643ad = $471b7090fdb2f5cc$var$HasTextAncestorContext.Provider;



var $acw62 = parcelRequire("acw62");
var $207fcfa714b5a6b0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $207fcfa714b5a6b0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($207fcfa714b5a6b0$export$1ca2a26fecb070ae);
};
$207fcfa714b5a6b0$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $a99ebb60ec9c2c5b$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $a99ebb60ec9c2c5b$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $207fcfa714b5a6b0$export$1aeb4f6b93c4540d)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($a99ebb60ec9c2c5b$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $a99ebb60ec9c2c5b$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $a99ebb60ec9c2c5b$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pwu06",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $a99ebb60ec9c2c5b$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $a99ebb60ec9c2c5b$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $a99ebb60ec9c2c5b$var$textColorMap = {
    "color.text": "_syazi7uo",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syazp1lv",
    "color.text.accent.orange.bolder": "_syaz7i1p",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syaz16jw",
    "color.text.accent.blue.bolder": "_syaz1kyx",
    "color.text.accent.purple": "_syazqmo9",
    "color.text.accent.purple.bolder": "_syaz1mn1",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1sqi",
    "color.text.accent.gray.bolder": "_syaz1tmo",
    "color.text.disabled": "_syaz1gmx",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syaz6x5g",
    "color.text.brand": "_syaz1oa5",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syaz1xn9",
    "color.text.warning.inverse": "_syaz1yd3",
    "color.text.success": "_syazgsak",
    "color.text.discovery": "_syazdv2p",
    "color.text.information": "_syazu3tg",
    "color.text.subtlest": "_syaz1rpy",
    "color.text.subtle": "_syazazsu",
    "color.link": "_syaz13af",
    "color.link.pressed": "_syaz12zz",
    "color.link.visited": "_syaz1ra0",
    "color.link.visited.pressed": "_syaz17z1"
};
var $a99ebb60ec9c2c5b$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $a99ebb60ec9c2c5b$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $bv4qN.default)($a99ebb60ec9c2c5b$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $471b7090fdb2f5cc$export$9322276ec105d055)();
    var color = $a99ebb60ec9c2c5b$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $acw62.createElement(Component, {
        id: id,
        className: (0, $7lEDz.default)([
            $a99ebb60ec9c2c5b$var$styles.root,
            size && $a99ebb60ec9c2c5b$var$fontSizeMap[size],
            color && $a99ebb60ec9c2c5b$var$textColorMap[color],
            maxLines && $a99ebb60ec9c2c5b$var$styles.truncation,
            maxLines === 1 && $a99ebb60ec9c2c5b$var$styles.breakAll,
            align && $a99ebb60ec9c2c5b$var$styles["textAlign.".concat(align)],
            weight && $a99ebb60ec9c2c5b$var$fontWeightMap[weight],
            Component === "em" && $a99ebb60ec9c2c5b$var$styles["as.em"],
            Component === "strong" && $a99ebb60ec9c2c5b$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $acw62.createElement((0, $471b7090fdb2f5cc$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $a99ebb60ec9c2c5b$export$2e2bcd8739ae039 = $a99ebb60ec9c2c5b$var$Text;



var $95c620cd2304db6f$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $95c620cd2304db6f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95c620cd2304db6f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95c620cd2304db6f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95c620cd2304db6f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $95c620cd2304db6f$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $95c620cd2304db6f$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? "Loading..." : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $95c620cd2304db6f$var$_excluded);
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)($95c620cd2304db6f$var$_objectSpread($95c620cd2304db6f$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-LoadingMessage")
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $acw62.createElement((0, $a99ebb60ec9c2c5b$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");



var $61a86ed26318476a$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $61a86ed26318476a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61a86ed26318476a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61a86ed26318476a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61a86ed26318476a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $61a86ed26318476a$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $61a86ed26318476a$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? "No options" : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $61a86ed26318476a$var$_excluded);
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)($61a86ed26318476a$var$_objectSpread($61a86ed26318476a$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-NoOptionsMessage")
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $acw62.createElement((0, $a99ebb60ec9c2c5b$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
const $10310cf078d13212$var$yAxisSides = /*#__PURE__*/ new Set([
    "top",
    "bottom"
]);
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return $10310cf078d13212$var$yAxisSides.has($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
const $10310cf078d13212$var$lrPlacement = [
    "left",
    "right"
];
const $10310cf078d13212$var$rlPlacement = [
    "right",
    "left"
];
const $10310cf078d13212$var$tbPlacement = [
    "top",
    "bottom"
];
const $10310cf078d13212$var$btPlacement = [
    "bottom",
    "top"
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case "left":
        case "right":
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== (0, $10310cf078d13212$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $10310cf078d13212$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    "left",
    "top"
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== "undefined";
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $238ac70369f38756$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    "inline",
    "contents"
]);
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$238ac70369f38756$var$invalidOverflowDisplayValues.has(display);
}
const $238ac70369f38756$var$tableElements = /*#__PURE__*/ new Set([
    "table",
    "td",
    "th"
]);
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return $238ac70369f38756$var$tableElements.has($238ac70369f38756$export$651544f548703224(element));
}
const $238ac70369f38756$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return $238ac70369f38756$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $238ac70369f38756$var$transformProperties = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective"
];
const $238ac70369f38756$var$willChangeValues = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective",
    "filter"
];
const $238ac70369f38756$var$containValues = [
    "paint",
    "layout",
    "strict",
    "content"
];
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$transformProperties.some((value)=>css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || $238ac70369f38756$var$willChangeValues.some((value)=>(css.willChange || "").includes(value)) || $238ac70369f38756$var$containValues.some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
const $238ac70369f38756$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    "html",
    "body",
    "#document"
]);
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return $238ac70369f38756$var$lastTraversableNodeNames.has($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, true) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === "rtl") x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    "absolute",
    "fixed"
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && $461947879dcdbcd4$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "static";
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
var $fc64aa6b92b8d28d$export$e001f626511a0ead = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $299fff5d1acd25c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $299fff5d1acd25c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $299fff5d1acd25c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $299fff5d1acd25c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $299fff5d1acd25c2$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $299fff5d1acd25c2$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $299fff5d1acd25c2$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $299fff5d1acd25c2$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)($299fff5d1acd25c2$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $299fff5d1acd25c2$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $acw62.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $acw62.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)($299fff5d1acd25c2$var$_objectSpread($299fff5d1acd25c2$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $299fff5d1acd25c2$var$menuPortalStyles.root,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-MenuPortal")
        ]),
        ref: setMenuPortalElement,
        style: $299fff5d1acd25c2$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            "--menu-left": "".concat(computedPosition.rect.left, "px"),
            "--menu-position": menuPosition,
            "--menu-top": "".concat(computedPosition.offset, "px"),
            "--menu-width": "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $acw62.createElement((0, $fc64aa6b92b8d28d$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $ltooA = parcelRequire("ltooA");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $edd3da46cf6ff850$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edd3da46cf6ff850$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edd3da46cf6ff850$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edd3da46cf6ff850$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $edd3da46cf6ff850$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $edd3da46cf6ff850$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $edd3da46cf6ff850$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $edd3da46cf6ff850$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $edd3da46cf6ff850$var$_objectSpread($edd3da46cf6ff850$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $cc0d9355903eaf90$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $cc0d9355903eaf90$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $cc0d9355903eaf90$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cc0d9355903eaf90$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cc0d9355903eaf90$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $cc0d9355903eaf90$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $cc0d9355903eaf90$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $cc0d9355903eaf90$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $cc0d9355903eaf90$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $cc0d9355903eaf90$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $edd3da46cf6ff850$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $a8fd43d4291cf156$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $c17dade04ba5e980$export$5bf35293e545f20c() {
    var analyticsContext = (0, $a8fd43d4291cf156$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $cc0d9355903eaf90$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $7d43ce78b0794ef1$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


var $506e0ab121f4cb51$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $c17dade04ba5e980$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $7d43ce78b0794ef1$export$1d27a74659855e44)(method);
    var payloadRef = (0, $7d43ce78b0794ef1$export$1d27a74659855e44)(payload);
    return (0, $acw62.useCallback)(function() {
        var pload = typeof payloadRef.current === "function" ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};




/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");

var $ltooA = parcelRequire("ltooA");
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");
/* badge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");

var $ltooA = parcelRequire("ltooA");
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f19c616e82747774$var$ATOMIC_GROUP_LENGTH = 5;
function $f19c616e82747774$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $f19c616e82747774$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $bv4qN = parcelRequire("bv4qN");

var $acw62 = parcelRequire("acw62");
var $5f6d6145ee98c62b$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $5f6d6145ee98c62b$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($5f6d6145ee98c62b$var$HasTextAncestorContext);
};
var $5f6d6145ee98c62b$export$ae933c6cbe5643ad = $5f6d6145ee98c62b$var$HasTextAncestorContext.Provider;



var $acw62 = parcelRequire("acw62");
var $ab5191109d3fd15a$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $ab5191109d3fd15a$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($ab5191109d3fd15a$export$1ca2a26fecb070ae);
};
$ab5191109d3fd15a$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $98d8dc07b23cb14c$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $98d8dc07b23cb14c$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $ab5191109d3fd15a$export$1aeb4f6b93c4540d)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($98d8dc07b23cb14c$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $98d8dc07b23cb14c$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $98d8dc07b23cb14c$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pwu06",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $98d8dc07b23cb14c$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $98d8dc07b23cb14c$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $98d8dc07b23cb14c$var$textColorMap = {
    "color.text": "_syazi7uo",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syazp1lv",
    "color.text.accent.orange.bolder": "_syaz7i1p",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syaz16jw",
    "color.text.accent.blue.bolder": "_syaz1kyx",
    "color.text.accent.purple": "_syazqmo9",
    "color.text.accent.purple.bolder": "_syaz1mn1",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1sqi",
    "color.text.accent.gray.bolder": "_syaz1tmo",
    "color.text.disabled": "_syaz1gmx",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syaz6x5g",
    "color.text.brand": "_syaz1oa5",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syaz1xn9",
    "color.text.warning.inverse": "_syaz1yd3",
    "color.text.success": "_syazgsak",
    "color.text.discovery": "_syazdv2p",
    "color.text.information": "_syazu3tg",
    "color.text.subtlest": "_syaz1rpy",
    "color.text.subtle": "_syazazsu",
    "color.link": "_syaz13af",
    "color.link.pressed": "_syaz12zz",
    "color.link.visited": "_syaz1ra0",
    "color.link.visited.pressed": "_syaz17z1"
};
var $98d8dc07b23cb14c$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $98d8dc07b23cb14c$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $bv4qN.default)($98d8dc07b23cb14c$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $5f6d6145ee98c62b$export$9322276ec105d055)();
    var color = $98d8dc07b23cb14c$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $acw62.createElement(Component, {
        id: id,
        className: (0, $f19c616e82747774$export$2e2bcd8739ae039)([
            $98d8dc07b23cb14c$var$styles.root,
            size && $98d8dc07b23cb14c$var$fontSizeMap[size],
            color && $98d8dc07b23cb14c$var$textColorMap[color],
            maxLines && $98d8dc07b23cb14c$var$styles.truncation,
            maxLines === 1 && $98d8dc07b23cb14c$var$styles.breakAll,
            align && $98d8dc07b23cb14c$var$styles["textAlign.".concat(align)],
            weight && $98d8dc07b23cb14c$var$fontWeightMap[weight],
            Component === "em" && $98d8dc07b23cb14c$var$styles["as.em"],
            Component === "strong" && $98d8dc07b23cb14c$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $acw62.createElement((0, $5f6d6145ee98c62b$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $98d8dc07b23cb14c$export$2e2bcd8739ae039 = $98d8dc07b23cb14c$var$Text;


/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");

function $e619ebbb3d685d69$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $e619ebbb3d685d69$export$4b844743568d5983(value, max) {
    var safeValue = $e619ebbb3d685d69$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $e619ebbb3d685d69$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $e619ebbb3d685d69$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $e619ebbb3d685d69$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $e619ebbb3d685d69$var$getSafeValue(value);
    var safeMax = $e619ebbb3d685d69$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


var $58949cc1c8fc8a19$export$d21bba0569254935 = {
    added: "success",
    removed: "danger",
    default: "neutral",
    primary: "information",
    primaryInverted: "inverse",
    important: "danger",
    warning: "warning",
    discovery: "discovery",
    danger: "danger",
    success: "success",
    information: "information",
    inverse: "inverse",
    neutral: "neutral"
};
var $58949cc1c8fc8a19$export$16f8cc7ac3541e83 = {
    added: "added",
    removed: "removed",
    default: "default",
    primary: "primary",
    primaryInverted: "primaryInverted",
    important: "important",
    danger: "removed",
    success: "added",
    information: "primary",
    inverse: "primaryInverted",
    neutral: "default",
    warning: "default",
    discovery: "default"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $58949cc1c8fc8a19$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $58949cc1c8fc8a19$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === "number" && max ? (0, $e619ebbb3d685d69$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $58949cc1c8fc8a19$var$BadgeNew = /*#__PURE__*/ (0, $acw62.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "neutral" : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $luEYg.default)([
            $58949cc1c8fc8a19$var$stylesNew.root,
            $58949cc1c8fc8a19$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $98d8dc07b23cb14c$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $58949cc1c8fc8a19$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $58949cc1c8fc8a19$export$2e2bcd8739ae039 = $58949cc1c8fc8a19$var$BadgeNew;



/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $e91698c4261e2b34$var$neutral300 = "#DDDEE1";
var $e91698c4261e2b34$var$red300 = "#FD9891";
var $e91698c4261e2b34$var$blue300 = "#8FB8F6";
var $e91698c4261e2b34$var$neutral1000 = "#292A2E";
var $e91698c4261e2b34$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $e91698c4261e2b34$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === "number" && typeof max === "number" ? (0, $e619ebbb3d685d69$export$4b844743568d5983)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $e91698c4261e2b34$var$Badge = /*#__PURE__*/ (0, $acw62.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        // Map old appearance names to new ones
        var newAppearance = (0, $58949cc1c8fc8a19$export$d21bba0569254935)[appearance];
        return /*#__PURE__*/ $acw62.createElement((0, $58949cc1c8fc8a19$export$2e2bcd8739ae039), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $58949cc1c8fc8a19$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $luEYg.default)([
            $e91698c4261e2b34$var$styles.root,
            $e91698c4261e2b34$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $98d8dc07b23cb14c$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $e91698c4261e2b34$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $e91698c4261e2b34$export$2e2bcd8739ae039 = $e91698c4261e2b34$var$Badge;



var $63374c601c699a95$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($63374c601c699a95$exports, "__esModule", {
    value: true
});
$63374c601c699a95$exports.default = void 0;

var $63374c601c699a95$var$_react = $63374c601c699a95$var$_interopRequireDefault((parcelRequire("acw62")));

var $63374c601c699a95$var$_baseNew = $63374c601c699a95$var$_interopRequireDefault((parcelRequire("eKnnT")));
function $63374c601c699a95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63374c601c699a95$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $63374c601c699a95$var$_react.default.createElement($63374c601c699a95$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$63374c601c699a95$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $63374c601c699a95$var$_default = $63374c601c699a95$exports.default = $63374c601c699a95$var$ChevronDownIcon;



var $3p9rK = parcelRequire("3p9rK");

var $fUHKi = parcelRequire("fUHKi");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


function $c2a6901a3a5e9162$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2a6901a3a5e9162$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2a6901a3a5e9162$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2a6901a3a5e9162$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2a6901a3a5e9162$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $c17dade04ba5e980$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $7d43ce78b0794ef1$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $7d43ce78b0794ef1$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c2a6901a3a5e9162$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $acw62 = parcelRequire("acw62");
var $8c1780c79962f4a3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");
var $bab351236df2c3da$export$4ef52930e33717cd = "data-theme";
var $bab351236df2c3da$export$cb374d25ded7f6ab = "data-subtree-theme";
var $bab351236df2c3da$export$a00eac3f8684bcd0 = "data-color-mode";
var $bab351236df2c3da$export$2112803007239c61 = "data-contrast-mode";
var $bab351236df2c3da$export$352e418ed5b6193a = "data-custom-theme";
var $bab351236df2c3da$export$6f0c6fb8c80fcc92 = "ds";
var $bab351236df2c3da$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $bab351236df2c3da$export$dddac1532e822863 = "--".concat($bab351236df2c3da$export$6f0c6fb8c80fcc92, "-token-not-found");
var $bab351236df2c3da$export$9d7b58831ae93caa = "--".concat($bab351236df2c3da$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $6ecfde409bf3a504$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ecfde409bf3a504$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ecfde409bf3a504$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ecfde409bf3a504$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6ecfde409bf3a504$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $6ecfde409bf3a504$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $6ecfde409bf3a504$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $6ecfde409bf3a504$export$632685d741f3dbbf = $6ecfde409bf3a504$var$_objectSpread($6ecfde409bf3a504$var$_objectSpread({}, $6ecfde409bf3a504$export$958d0ae7f2977ae4), $6ecfde409bf3a504$export$d2dc61f58390201c);
var $6ecfde409bf3a504$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $6ecfde409bf3a504$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $6ecfde409bf3a504$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #1E1F2129)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $6ecfde409bf3a504$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #F0F1F2)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #DDDEE1)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #F0F1F2)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #DDDEE1)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #F0F1F2)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #DDDEE1)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F8F8F8)"
};
var $6ecfde409bf3a504$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #0B120E24)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #E2483D)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #E06C00)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #B38600)",
    "color.border.accent.green": "var(--ds-border-accent-green, #22A06B)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #2898BD)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #357DE8)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #AF59E1)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #7D818A)",
    "color.border.disabled": "var(--ds-border-disabled, #0515240F)",
    "color.border.focused": "var(--ds-border-focused, #4688EC)",
    "color.border.input": "var(--ds-border-input, #8C8F97)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #1868DB)",
    "color.border.brand": "var(--ds-border-brand, #1868DB)",
    "color.border.danger": "var(--ds-border-danger, #E2483D)",
    "color.border.warning": "var(--ds-border-warning, #E06C00)",
    "color.border.success": "var(--ds-border-success, #6A9A23)",
    "color.border.discovery": "var(--ds-border-discovery, #AF59E1)",
    "color.border.information": "var(--ds-border-information, #357DE8)",
    "color.border.bold": "var(--ds-border-bold, #7D818A)"
};
var $6ecfde409bf3a504$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FFECEB)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FFD5D2)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #F87168)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #C9372C)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #872821)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #FCA700)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #BD5B00)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #F5E989)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #EED12B)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #946F00)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #BAF3DB)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #4BCE97)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #1F845A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #227D9B)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #669DF1)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #1868DB)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #EED7FC)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #C97CF4)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #964AC0)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #8C8F97)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #6B6E76)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    "color.background.disabled": "var(--ds-background-disabled, #17171708)",
    "color.background.input": "var(--ds-background-input, #FFFFFF)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #F8F8F8)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #0515240F)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #0B120E24)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #080F214A)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, #00000000)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #292A2E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #505258)",
    "color.background.selected": "var(--ds-background-selected, #E9F2FE)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #CFE1FD)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #8FB8F6)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #1868DB)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #1558BC)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #123263)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #E9F2FE)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #1868DB)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #1558BC)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #144794)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #1C2B42)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #123263)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #144794)",
    "color.background.danger": "var(--ds-background-danger, #FFECEB)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFD5D2)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FFB8B2)",
    "color.background.danger.subtler": "var(--ds-background-danger-subtler, #FFD5D2)",
    "color.background.danger.subtler.hovered": "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    "color.background.danger.subtler.pressed": "var(--ds-background-danger-subtler-pressed, #FD9891)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #C9372C)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #AE2E24)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #872821)",
    "color.background.warning": "var(--ds-background-warning, #FFF5DB)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FCE4A6)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FBD779)",
    "color.background.warning.subtler": "var(--ds-background-warning-subtler, #FCE4A6)",
    "color.background.warning.subtler.hovered": "var(--ds-background-warning-subtler-hovered, #FBD779)",
    "color.background.warning.subtler.pressed": "var(--ds-background-warning-subtler-pressed, #FBC828)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FBC828)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FCA700)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #F68909)",
    "color.background.success": "var(--ds-background-success, #EFFFD6)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #D3F1A7)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #BDE97C)",
    "color.background.success.subtler": "var(--ds-background-success-subtler, #D3F1A7)",
    "color.background.success.subtler.hovered": "var(--ds-background-success-subtler-hovered, #BDE97C)",
    "color.background.success.subtler.pressed": "var(--ds-background-success-subtler-pressed, #B3DF72)",
    "color.background.success.bold": "var(--ds-background-success-bold, #5B7F24)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #4C6B1F)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #3F5224)",
    "color.background.discovery": "var(--ds-background-discovery, #F8EEFE)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #EED7FC)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #E3BDFA)",
    "color.background.discovery.subtler": "var(--ds-background-discovery-subtler, #EED7FC)",
    "color.background.discovery.subtler.hovered": "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    "color.background.discovery.subtler.pressed": "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #964AC0)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #803FA5)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #673286)",
    "color.background.information": "var(--ds-background-information, #E9F2FE)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #CFE1FD)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #ADCBFB)",
    "color.background.information.subtler": "var(--ds-background-information-subtler, #CFE1FD)",
    "color.background.information.subtler.hovered": "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    "color.background.information.subtler.pressed": "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    "color.background.information.bold": "var(--ds-background-information-bold, #1868DB)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #1558BC)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #144794)",
    "color.blanket": "var(--ds-blanket, #050C1F75)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #0515240F)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #17171708)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #F0F1F2)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #DDDEE1)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #F0F1F2)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #DDDEE1)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #F0F1F2)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #DDDEE1)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F8F8F8)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $6ecfde409bf3a504$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #292A2E)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #AE2E24)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #5D1F1A)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #9E4C00)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #693200)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #7F5F01)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #533F04)",
    "color.text.accent.green": "var(--ds-text-accent-green, #216E4E)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #164B35)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #206A83)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #164555)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #1558BC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #123263)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #803FA5)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #48245D)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #943D73)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #50253F)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505258)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #1E1F21)",
    "color.text.disabled": "var(--ds-text-disabled, #080F214A)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #1868DB)",
    "color.text.brand": "var(--ds-text-brand, #1868DB)",
    "color.text.danger": "var(--ds-text-danger, #AE2E24)",
    "color.text.danger.bolder": "var(--ds-text-danger-bolder, #5D1F1A)",
    "color.text.warning": "var(--ds-text-warning, #9E4C00)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #292A2E)",
    "color.text.warning.bolder": "var(--ds-text-warning-bolder, #693200)",
    "color.text.success": "var(--ds-text-success, #4C6B1F)",
    "color.text.success.bolder": "var(--ds-text-success-bolder, #37471F)",
    "color.text.discovery": "var(--ds-text-discovery, #803FA5)",
    "color.text.discovery.bolder": "var(--ds-text-discovery-bolder, #48245D)",
    "color.text.information": "var(--ds-text-information, #1558BC)",
    "color.text.information.bolder": "var(--ds-text-information-bolder, #123263)",
    "color.text.subtlest": "var(--ds-text-subtlest, #6B6E76)",
    "color.text.subtle": "var(--ds-text-subtle, #505258)",
    "color.link": "var(--ds-link, #1868DB)",
    "color.link.pressed": "var(--ds-link-pressed, #1558BC)",
    "color.link.visited": "var(--ds-link-visited, #803FA5)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #48245D)"
};
var $6ecfde409bf3a504$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #292A2E)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #C9372C)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #E06C00)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #B38600)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #22A06B)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #2898BD)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #357DE8)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #AF59E1)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #7D818A)",
    "color.icon.disabled": "var(--ds-icon-disabled, #080F214A)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #1868DB)",
    "color.icon.brand": "var(--ds-icon-brand, #1868DB)",
    "color.icon.danger": "var(--ds-icon-danger, #C9372C)",
    "color.icon.warning": "var(--ds-icon-warning, #E06C00)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #292A2E)",
    "color.icon.success": "var(--ds-icon-success, #6A9A23)",
    "color.icon.discovery": "var(--ds-icon-discovery, #AF59E1)",
    "color.icon.information": "var(--ds-icon-information, #357DE8)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B6E76)",
    "color.icon.subtle": "var(--ds-icon-subtle, #505258)"
};
var $6ecfde409bf3a504$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $6ecfde409bf3a504$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.selected": "var(--ds-border-width-selected, 2px)",
    "border.width.focused": "var(--ds-border-width-focused, 2px)"
};
var $6ecfde409bf3a504$export$3c0a6c3e64bb180d = {
    "radius.xsmall": "var(--ds-radius-xsmall, 2px)",
    "radius.small": "var(--ds-radius-small, 3px)",
    "radius.medium": "var(--ds-radius-medium, 6px)",
    "radius.large": "var(--ds-radius-large, 8px)",
    "radius.xlarge": "var(--ds-radius-xlarge, 12px)",
    "radius.xxlarge": "var(--ds-radius-xxlarge, 16px)",
    "radius.full": "var(--ds-radius-full, 9999px)",
    "radius.tile": "var(--ds-radius-tile, 25%)"
};
var $6ecfde409bf3a504$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    // @deprecated
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 653 20px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 653 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 653 32px/36px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 653 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6ecfde409bf3a504$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 653)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $6ecfde409bf3a504$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6ecfde409bf3a504$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6ecfde409bf3a504$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $6ecfde409bf3a504$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $6ecfde409bf3a504$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $6ecfde409bf3a504$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $6ecfde409bf3a504$export$e615f061ca585a6c = $6ecfde409bf3a504$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6ecfde409bf3a504$export$ca0f9c2de39ffed7(spacingProperty, $6ecfde409bf3a504$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6ecfde409bf3a504$export$bf46c3f9eeafc71f = $6ecfde409bf3a504$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6ecfde409bf3a504$export$ca0f9c2de39ffed7(spacingProperty, $6ecfde409bf3a504$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6ecfde409bf3a504$export$e7af83bafe7f9e63 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("backgroundColor", $6ecfde409bf3a504$export$d1d79bf68ac056bd);
var $6ecfde409bf3a504$export$3a1bcba60b23d7f0 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("color", $6ecfde409bf3a504$export$8473307aa00d6ea1);
var $6ecfde409bf3a504$export$45f3f4fe16f9f7d5 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("fontWeight", $6ecfde409bf3a504$export$303e322c6b1ed114);
var $6ecfde409bf3a504$export$68cc305da27dbaa4 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("fontFamily", $6ecfde409bf3a504$export$3c7e9587132614b4);
var $6ecfde409bf3a504$export$128f10c238242f83 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("font", $6ecfde409bf3a504$export$6ffa317d5e70375);
var $6ecfde409bf3a504$export$219d364c0da35ae4 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("font", $6ecfde409bf3a504$export$236bfe3a33ef1292);
var $6ecfde409bf3a504$export$38845ca010b93505 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("fontWeight", $6ecfde409bf3a504$export$855cfd311192d666);
var $6ecfde409bf3a504$export$ff257d957d48c421 = $6ecfde409bf3a504$export$ca0f9c2de39ffed7((0, $bab351236df2c3da$export$9d7b58831ae93caa), $6ecfde409bf3a504$export$41a358c9c2356760);
var $6ecfde409bf3a504$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $6ecfde409bf3a504$export$41a358c9c2356760[color] !== undefined;
};
var $6ecfde409bf3a504$export$7001ce64d9ff7c7f = $6ecfde409bf3a504$export$ca0f9c2de39ffed7("font", $6ecfde409bf3a504$export$b805719bc8cb376);



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $gyDKM = parcelRequire("gyDKM");


var $hPtJY = parcelRequire("hPtJY");
function $77263fd95046b939$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $77263fd95046b939$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $77263fd95046b939$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $77263fd95046b939$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $77263fd95046b939$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $77263fd95046b939$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $77263fd95046b939$export$9a199fbafee0014e = {
    backgroundColor: (0, $6ecfde409bf3a504$export$d1d79bf68ac056bd),
    blockSize: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderBottomColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderLeftColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $6ecfde409bf3a504$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    borderWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    bottom: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    boxShadow: (0, $6ecfde409bf3a504$export$7aff6e7ba39bb774),
    color: (0, $6ecfde409bf3a504$export$8473307aa00d6ea1),
    columnGap: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    font: (0, $6ecfde409bf3a504$export$6ffa317d5e70375),
    fontFamily: (0, $6ecfde409bf3a504$export$3c7e9587132614b4),
    fontWeight: (0, $6ecfde409bf3a504$export$303e322c6b1ed114),
    gap: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    height: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    inlineSize: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    inset: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    insetBlock: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    insetBlockEnd: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    insetBlockStart: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    insetInline: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    insetInlineEnd: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    insetInlineStart: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    left: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    margin: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginBlock: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginBlockEnd: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginBlockStart: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginBottom: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginInline: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginInlineEnd: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginInlineStart: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginLeft: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginRight: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    marginTop: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    maxBlockSize: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    maxHeight: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    maxWidth: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    minBlockSize: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    minHeight: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    minInlineSize: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    minWidth: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    opacity: (0, $6ecfde409bf3a504$export$daf94a976c798b4f),
    outlineColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac),
    outlineOffset: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    outlineWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8),
    padding: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingBlock: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingBottom: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingInline: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingLeft: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingRight: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    paddingTop: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    right: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    rowGap: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4),
    top: (0, $6ecfde409bf3a504$export$632685d741f3dbbf),
    width: (0, $6ecfde409bf3a504$export$6ccdbebca2ee545f),
    zIndex: (0, $6ecfde409bf3a504$export$b5f31a7e431d2eab)
};
var $77263fd95046b939$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $77263fd95046b939$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $77263fd95046b939$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $77263fd95046b939$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $77263fd95046b939$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($77263fd95046b939$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $77263fd95046b939$var$safeSelectors.test(key)) {
            styleObj[key] = $77263fd95046b939$var$_transformStyles(value);
            return;
        }
        if ($77263fd95046b939$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($77263fd95046b939$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $77263fd95046b939$export$9a199fbafee0014e)) return;
        var tokenValue = $77263fd95046b939$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $77263fd95046b939$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $77263fd95046b939$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $77263fd95046b939$var$uniqueSymbol, (0, $gyDKM.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $77263fd95046b939$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $77263fd95046b939$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $77263fd95046b939$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$77263fd95046b939$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $77263fd95046b939$export$f6c783d06584602c(style) {
    return $77263fd95046b939$var$baseXcss(style);
}


var $09b6dc35fdb6c411$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $09b6dc35fdb6c411$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $09b6dc35fdb6c411$var$focusRingStyles = (0, $gyDKM.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $6ecfde409bf3a504$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $6ecfde409bf3a504$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $6ecfde409bf3a504$export$e1b83c5210c471b8)["border.width.focused"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $6ecfde409bf3a504$export$e1b83c5210c471b8)["border.width"], " solid")
        }
    }
});
var $09b6dc35fdb6c411$var$baseStyles = (0, $gyDKM.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $09b6dc35fdb6c411$var$enabledStyles = (0, $gyDKM.css)({
    cursor: "pointer"
});
var $09b6dc35fdb6c411$var$disabledStyles = (0, $gyDKM.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $09b6dc35fdb6c411$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $09b6dc35fdb6c411$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $8c1780c79962f4a3$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $c2a6901a3a5e9162$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $09b6dc35fdb6c411$var$_excluded2);
    var resolvedStyles = (0, $77263fd95046b939$export$a9c84988c8f81f2d)(xcss);
    return (0, $gyDKM.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $09b6dc35fdb6c411$var$baseStyles,
            $09b6dc35fdb6c411$var$focusRingStyles,
            isDisabled ? $09b6dc35fdb6c411$var$disabledStyles : $09b6dc35fdb6c411$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $6ecfde409bf3a504$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $6ecfde409bf3a504$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $09b6dc35fdb6c411$export$2e2bcd8739ae039 = $09b6dc35fdb6c411$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $df4654a34dfaeee1$var$ATOMIC_GROUP_LENGTH = 5;
function $df4654a34dfaeee1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $df4654a34dfaeee1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $499efeb4ba673346$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


// Reds
var $4ece0d95a6d4a56a$export$4b84fd0e2c617bd = "#FFEBE6";
var $4ece0d95a6d4a56a$export$b34b069eff244586 = "#FFBDAD";
var $4ece0d95a6d4a56a$export$be802dd0d8b57f35 = "#FF8F73";
var $4ece0d95a6d4a56a$export$60847d42f9da92a6 = "#FF7452";
var $4ece0d95a6d4a56a$export$4a7404f376229999 = "#FF5630";
var $4ece0d95a6d4a56a$export$2010d0fb4295b346 = "#DE350B";
var $4ece0d95a6d4a56a$export$2837b5a1a71d5c02 = "#BF2600";
var $4ece0d95a6d4a56a$export$8d9596b529bbb9cf = "#FFFAE6";
var $4ece0d95a6d4a56a$export$41060a744ab0b7ae = "#FFF0B3";
var $4ece0d95a6d4a56a$export$1cc05bbbf340e559 = "#FFE380";
var $4ece0d95a6d4a56a$export$5aae31392d72caaa = "#FFC400";
var $4ece0d95a6d4a56a$export$c6930421db9fa514 = "#FFAB00";
var $4ece0d95a6d4a56a$export$59619663aa6500fb = "#FF991F";
var $4ece0d95a6d4a56a$export$874739ea9e379ab6 = "#FF8B00";
var $4ece0d95a6d4a56a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4ece0d95a6d4a56a$export$69a3bf21b9686c2b = "#ABF5D1";
var $4ece0d95a6d4a56a$export$afbce1382ec95f73 = "#79F2C0";
var $4ece0d95a6d4a56a$export$747d86715d4175de = "#57D9A3";
var $4ece0d95a6d4a56a$export$940e1f69e873f202 = "#36B37E";
var $4ece0d95a6d4a56a$export$a49394138f7b8e85 = "#00875A";
var $4ece0d95a6d4a56a$export$6fa04827ac68a4fb = "#006644";
var $4ece0d95a6d4a56a$export$226de0355ed012f8 = "#DEEBFF";
var $4ece0d95a6d4a56a$export$8c13c2ee36917869 = "#B3D4FF";
var $4ece0d95a6d4a56a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4ece0d95a6d4a56a$export$215b7063051591f1 = "#2684FF";
var $4ece0d95a6d4a56a$export$e62e8919cca44969 = "#0065FF";
var $4ece0d95a6d4a56a$export$b3de0ae08da2ce64 = "#0052CC";
var $4ece0d95a6d4a56a$export$a6ee3d71bc067634 = "#0747A6";
var $4ece0d95a6d4a56a$export$67f15409e87642a1 = "#669DF1";
var $4ece0d95a6d4a56a$export$f0539dbc42dbb067 = "#8FB8F6";
var $4ece0d95a6d4a56a$export$363e4475840015bb = "#EAE6FF";
var $4ece0d95a6d4a56a$export$4b0a4417ed59760f = "#C0B6F2";
var $4ece0d95a6d4a56a$export$6011520a64d9a187 = "#998DD9";
var $4ece0d95a6d4a56a$export$a7175d4e9206bc80 = "#8777D9";
var $4ece0d95a6d4a56a$export$b48405b95304b5a1 = "#6554C0";
var $4ece0d95a6d4a56a$export$c71e4279dd54a18d = "#5243AA";
var $4ece0d95a6d4a56a$export$147899de772240ec = "#403294";
var $4ece0d95a6d4a56a$export$2cf711fe14c66f06 = "#E6FCFF";
var $4ece0d95a6d4a56a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4ece0d95a6d4a56a$export$776c9c497ef08533 = "#79E2F2";
var $4ece0d95a6d4a56a$export$69cb3ca10c1e330e = "#00C7E6";
var $4ece0d95a6d4a56a$export$9dc1ef0f3f48059b = "#00B8D9";
var $4ece0d95a6d4a56a$export$7c835c78b6fcdef8 = "#00A3BF";
var $4ece0d95a6d4a56a$export$6036577f95c3877e = "#008DA6";
var $4ece0d95a6d4a56a$export$29a4f05edc054374 = "#FFFFFF";
var $4ece0d95a6d4a56a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4ece0d95a6d4a56a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4ece0d95a6d4a56a$export$3e51e8f1440314ba = "#EBECF0";
var $4ece0d95a6d4a56a$export$1ce2d1575d444ceb = "#DFE1E6";
var $4ece0d95a6d4a56a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4ece0d95a6d4a56a$export$c2e91cbeada39b8b = "#B3BAC5";
var $4ece0d95a6d4a56a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4ece0d95a6d4a56a$export$eaa8c8a70ac22806 = "#97A0AF";
var $4ece0d95a6d4a56a$export$7c87d337fb91a97d = "#8993A4";
var $4ece0d95a6d4a56a$export$d6447c357493214f = "#7A869A";
var $4ece0d95a6d4a56a$export$f563ee71e9ee74cd = "#6B778C";
var $4ece0d95a6d4a56a$export$e2ef2124cf4024b1 = "#5E6C84";
var $4ece0d95a6d4a56a$export$eece5f492e429f08 = "#505F79";
var $4ece0d95a6d4a56a$export$c39c0fe0f26207ae = "#42526E";
var $4ece0d95a6d4a56a$export$7090862dc3038a9f = "#344563";
var $4ece0d95a6d4a56a$export$ad0bacf983b7ddaa = "#253858";
var $4ece0d95a6d4a56a$export$7d61b15e0da132af = "#172B4D";
var $4ece0d95a6d4a56a$export$fbda843f0a27fe96 = "#091E42";
var $4ece0d95a6d4a56a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4ece0d95a6d4a56a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4ece0d95a6d4a56a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4ece0d95a6d4a56a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4ece0d95a6d4a56a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4ece0d95a6d4a56a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4ece0d95a6d4a56a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4ece0d95a6d4a56a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4ece0d95a6d4a56a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4ece0d95a6d4a56a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4ece0d95a6d4a56a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4ece0d95a6d4a56a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4ece0d95a6d4a56a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4ece0d95a6d4a56a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4ece0d95a6d4a56a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4ece0d95a6d4a56a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4ece0d95a6d4a56a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4ece0d95a6d4a56a$export$2f6319cf7d736c2a = "#E6EDFA";
var $4ece0d95a6d4a56a$export$95126bc8884d6634 = "#DCE5F5";
var $4ece0d95a6d4a56a$export$8338d8c35d44ff1 = "#CED9EB";
var $4ece0d95a6d4a56a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4ece0d95a6d4a56a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4ece0d95a6d4a56a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4ece0d95a6d4a56a$export$97e81faa16a182c7 = "#8C9CB8";
var $4ece0d95a6d4a56a$export$bfe21c59123ecf33 = "#7988A3";
var $4ece0d95a6d4a56a$export$ee82aa2ea6a1558 = "#67758F";
var $4ece0d95a6d4a56a$export$682927c6ed76be02 = "#56637A";
var $4ece0d95a6d4a56a$export$91fd9994c5be9757 = "#455166";
var $4ece0d95a6d4a56a$export$d281fbfe3cff2df6 = "#3B475C";
var $4ece0d95a6d4a56a$export$3902c91d8b98a753 = "#313D52";
var $4ece0d95a6d4a56a$export$8e8133c1ba5845b5 = "#283447";
var $4ece0d95a6d4a56a$export$33ff357f6620b39 = "#202B3D";
var $4ece0d95a6d4a56a$export$633847cf062b69e0 = "#1B2638";
var $4ece0d95a6d4a56a$export$9776a6e503bdbf76 = "#121A29";
var $4ece0d95a6d4a56a$export$6c813d5160dff5db = "#0E1624";
var $4ece0d95a6d4a56a$export$3d4f271a500072a = "#0D1424";
var $4ece0d95a6d4a56a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4ece0d95a6d4a56a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4ece0d95a6d4a56a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4ece0d95a6d4a56a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4ece0d95a6d4a56a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4ece0d95a6d4a56a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4ece0d95a6d4a56a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4ece0d95a6d4a56a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4ece0d95a6d4a56a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4ece0d95a6d4a56a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4ece0d95a6d4a56a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4ece0d95a6d4a56a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4ece0d95a6d4a56a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4ece0d95a6d4a56a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4ece0d95a6d4a56a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4ece0d95a6d4a56a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4ece0d95a6d4a56a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4ece0d95a6d4a56a$export$d2adc5dedf09fced = "#292A2E";
var $4ece0d95a6d4a56a$export$f51762073d2bb381 = "#94C748";
var $4ece0d95a6d4a56a$export$95e26d54def96891 = "#B3DF72";


var $819d9a2f50b70857$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $e036465092931c4e$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $4ece0d95a6d4a56a$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $4ece0d95a6d4a56a$export$29a4f05edc054374), ")");
}
var $e036465092931c4e$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $e036465092931c4e$var$loadIn = null;
var $e036465092931c4e$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e036465092931c4e$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e036465092931c4e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $819d9a2f50b70857$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e036465092931c4e$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $499efeb4ba673346$export$2e2bcd8739ae039));
    $e036465092931c4e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $df4654a34dfaeee1$export$2e2bcd8739ae039)([
            $e036465092931c4e$var$styles.wrapperStyles,
            $e036465092931c4e$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $df4654a34dfaeee1$export$2e2bcd8739ae039)([
            $e036465092931c4e$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $df4654a34dfaeee1$export$2e2bcd8739ae039)([
            $e036465092931c4e$var$styles.circleStyles
        ])
    })));
}));
var $e036465092931c4e$export$2e2bcd8739ae039 = $e036465092931c4e$var$Spinner;



var $acw62 = parcelRequire("acw62");
// Map lozenge colors to appropriate icon colors
var $38cce238929dd914$var$getIconColor = function getIconColor(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case "success":
            return "var(--ds-icon-success, #6A9A23)";
        case "warning":
            return "var(--ds-icon-warning, #E06C00)";
        case "danger":
            return "var(--ds-icon-danger, #C9372C)";
        case "information":
            return "var(--ds-icon-information, #357DE8)";
        case "neutral":
            return "var(--ds-icon-subtlest, #6B6E76)";
        case "discovery":
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case "accent-red":
            return "var(--ds-icon-accent-red, #C9372C)";
        case "accent-orange":
            return "var(--ds-icon-accent-orange, #E06C00)";
        case "accent-yellow":
            return "var(--ds-icon-accent-yellow, #B38600)";
        case "accent-lime":
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case "accent-green":
            return "var(--ds-icon-accent-green, #22A06B)";
        case "accent-teal":
            return "var(--ds-icon-accent-teal, #2898BD)";
        case "accent-blue":
            return "var(--ds-icon-accent-blue, #357DE8)";
        case "accent-purple":
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case "accent-magenta":
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case "accent-gray":
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $38cce238929dd914$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $38cce238929dd914$var$getIconColor(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $38cce238929dd914$export$2e2bcd8739ae039 = $38cce238929dd914$export$32ff197eed95e568;


// Map legacy appearance to new color values
var $3957eda4e94cbe5f$var$legacyAppearanceMap = {
    default: "neutral",
    removed: "danger",
    inprogress: "information",
    new: "discovery",
    moved: "warning"
};
var $3957eda4e94cbe5f$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "neutral";
    if (appearance.startsWith("accent-")) return appearance;
    return (_legacyAppearanceMap$ = $3957eda4e94cbe5f$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};
var $3957eda4e94cbe5f$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith("accent-");
    var category = isAccent ? "accent" : "semantic";
    var key = isAccent ? resolvedColor.replace("accent-", "") : resolvedColor;
    return {
        category: category,
        key: key
    };
};


function $7d8f858af4b4c443$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d8f858af4b4c443$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d8f858af4b4c443$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d8f858af4b4c443$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $7d8f858af4b4c443$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    "accent-red": "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    "accent-orange": "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    "accent-yellow": "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    "accent-lime": "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    "accent-green": "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    "accent-teal": "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    "accent-blue": "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    "accent-purple": "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    "accent-magenta": "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    "accent-gray": "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $7d8f858af4b4c443$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    "metric.semantic.success": "_1bn8d6jc _4ayg1wl5",
    "metric.semantic.warning": "_1bn8bkku _4aygzr32",
    "metric.semantic.danger": "_1bn8jkmi _4ayg1r4b",
    "metric.semantic.information": "_1bn8ar1y _4ayg1c1j",
    "metric.semantic.neutral": "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    "metric.semantic.discovery": "_1bn85usi _4ayg18vq",
    "metric.inverse": "_1bn8vuon _4aygvuon",
    "semantic.success": "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    "semantic.warning": "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    "semantic.danger": "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    "semantic.information": "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    "semantic.neutral": "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    "semantic.discovery": "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    "accent.red": "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    "accent.orange": "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    "accent.yellow": "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    "accent.lime": "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    "accent.green": "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    "accent.teal": "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    "accent.blue": "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    "accent.purple": "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    "accent.magenta": "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    "accent.gray": "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    "interactive.semantic.success": "_irr31r82 _1di6d6jc",
    "interactive.semantic.warning": "_irr31yx4 _1di6bkku",
    "interactive.semantic.danger": "_irr370oi _1di6jkmi",
    "interactive.semantic.information": "_irr315aw _1di6ar1y",
    "interactive.semantic.neutral": "_irr3plhp _1di61gdz",
    "interactive.semantic.discovery": "_irr3rumk _1di65usi",
    "interactive.accent.red": "_irr3affd _1di61j5a",
    "interactive.accent.orange": "_irr31ei0 _1di6dpo3",
    "interactive.accent.yellow": "_irr31uw7 _1di61r9w",
    "interactive.accent.lime": "_irr31gf0 _1di62kxc",
    "interactive.accent.green": "_irr31e2h _1di6ybhx",
    "interactive.accent.teal": "_irr3kwwr _1di61jb0",
    "interactive.accent.blue": "_irr3815t _1di6rwxf",
    "interactive.accent.purple": "_irr3attl _1di63nfk",
    "interactive.accent.magenta": "_irr31axx _1di642ri",
    "interactive.accent.gray": "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $7d8f858af4b4c443$var$LozengeBase = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref["aria-controls"], ariaExpanded = _ref["aria-expanded"], ariaHaspopup = _ref["aria-haspopup"], ariaLabel = _ref["aria-label"];
    var isInteractive = typeof onClick === "function";
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $3957eda4e94cbe5f$export$acf5d2b7dc999bda)(appearance) || "neutral";
    var _getThemeStyles = (0, $3957eda4e94cbe5f$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === "inverse" ? "inverse" : (0, $3957eda4e94cbe5f$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === "inverse" ? "inverse" : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith("accent-") ? "neutral" : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : "neutral";
    var metricStyleKey = resolvedTrailingMetricAppearance === "inverse" ? "metric.inverse" : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith("accent-") ? "metric.semantic.".concat((0, $3957eda4e94cbe5f$export$a3fc04b8551e006a)(resolvedTrailingMetricAppearance).key) : "metric.semantic.neutral";
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : "100%"
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== "";
    var innerContent = /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? "100%" : undefined
        },
        className: (0, $iJ0kj.default)([
            $7d8f858af4b4c443$var$styles.content,
            spacing === "spacious" && $7d8f858af4b4c443$var$styles.contentSpacious,
            isLoading && $7d8f858af4b4c443$var$styles.loadingContent
        ])
    }, iconBefore && /*#__PURE__*/ $acw62.createElement((0, $38cce238929dd914$export$2e2bcd8739ae039), {
        size: spacing === "spacious" ? "medium" : "small",
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $iJ0kj.default)([
            $7d8f858af4b4c443$var$styles.text,
            spacing === "spacious" && $7d8f858af4b4c443$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith("accent-") && /*#__PURE__*/ $acw62.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $iJ0kj.default)([
            $7d8f858af4b4c443$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $e91698c4261e2b34$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($63374c601c699a95$exports))), {
        label: "",
        size: "small",
        color: "currentColor",
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $acw62.createElement((0, $09b6dc35fdb6c411$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref,
        xcss: (0, $66d7dbe9bd15c487$export$a274e22fb40f762e)($7d8f858af4b4c443$var$styles.container, spacing === "spacious" && $7d8f858af4b4c443$var$styles.containerSpacious, !isSelected && $7d8f858af4b4c443$var$styles.iconBorderFilter, !isLoading && $7d8f858af4b4c443$var$styles.iconBorderInteractiveFilter, $7d8f858af4b4c443$var$styles[colorStyleKey], !isLoading && $7d8f858af4b4c443$var$styles[interactiveStyleKey], isSelected && $7d8f858af4b4c443$var$styles.containerSelected, hasTrailingMetric && $7d8f858af4b4c443$var$styles.containerBadge, hasTrailingMetric && $7d8f858af4b4c443$var$styles.containerBadgeInteractive, hasTrailingMetric && $7d8f858af4b4c443$var$styles[metricStyleKey])
    }, isLoading && {
        "aria-busy": true,
        "aria-disabled": true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? "Loading" : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $7d8f858af4b4c443$var$_objectSpread($7d8f858af4b4c443$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? "oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important" : "transparent"),
            backgroundColor: isSelected ? $7d8f858af4b4c443$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? "progress" : "pointer"
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), innerContent, isLoading && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $iJ0kj.default)([
            $7d8f858af4b4c443$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $e036465092931c4e$export$2e2bcd8739ae039), {
        size: spacing === "spacious" ? "small" : "xsmall",
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $acw62.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $iJ0kj.default)([
            $7d8f858af4b4c443$var$styles.container,
            spacing === "spacious" && $7d8f858af4b4c443$var$styles.containerSpacious,
            spacing !== "spacious" && hasTrailingMetric && $7d8f858af4b4c443$var$styles.containerBadgePadding,
            $7d8f858af4b4c443$var$styles[colorStyleKey],
            hasTrailingMetric && $7d8f858af4b4c443$var$styles[metricStyleKey],
            $7d8f858af4b4c443$var$styles.iconBorderFilter,
            $7d8f858af4b4c443$var$styles.containerBadge
        ])
    }, innerContent);
}));
var $7d8f858af4b4c443$export$2e2bcd8739ae039 = $7d8f858af4b4c443$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $69866d7b19e2bd24$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "neutral" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $acw62.createElement((0, $7d8f858af4b4c443$export$2e2bcd8739ae039), baseProps, children);
};
$69866d7b19e2bd24$var$Lozenge.displayName = "Lozenge";
var $69866d7b19e2bd24$export$2e2bcd8739ae039 = $69866d7b19e2bd24$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $55e8287327009a1a$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    "bg.bold.default": "_bfhk1fkg",
    "bg.bold.inprogress": "_bfhk1ymo",
    "bg.bold.moved": "_bfhkxmjf",
    "bg.bold.new": "_bfhkshej",
    "bg.bold.removed": "_bfhk1366",
    "bg.bold.success": "_bfhk3uhp",
    "bg.subtle.default": "_bfhksm61",
    "bg.subtle.inprogress": "_bfhksm61",
    "bg.subtle.moved": "_bfhksm61",
    "bg.subtle.new": "_bfhksm61",
    "bg.subtle.removed": "_bfhksm61",
    "bg.subtle.success": "_bfhksm61",
    "outline.subtle.default": "_12ji14je _1qu2nqa1 _12y3t94y",
    "outline.subtle.inprogress": "_12jiuisw _1qu2nqa1 _12y3t94y",
    "outline.subtle.moved": "_12jih727 _1qu2nqa1 _12y3t94y",
    "outline.subtle.new": "_12ji157s _1qu2nqa1 _12y3t94y",
    "outline.subtle.removed": "_12jia2c0 _1qu2nqa1 _12y3t94y",
    "outline.subtle.success": "_12jin0nx _1qu2nqa1 _12y3t94y",
    "text.subtle": "_syazi7uo",
    "text.bold": "_syazwwip"
};
var $55e8287327009a1a$var$appearanceTypes = [
    "default",
    "inprogress",
    "moved",
    "new",
    "removed"
];
var $55e8287327009a1a$var$newSemanticColors = [
    "success",
    "discovery",
    "warning",
    "danger",
    "information",
    "neutral"
];
var $55e8287327009a1a$var$appearanceMapping = {
    neutral: "default",
    default: "default",
    information: "inprogress",
    inprogress: "inprogress",
    warning: "moved",
    moved: "moved",
    removed: "removed",
    danger: "removed",
    success: "success",
    discovery: "new",
    new: "new"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $55e8287327009a1a$var$LegacyLozenge = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = (0, $acw62.useMemo)(function() {
        return $55e8287327009a1a$var$appearanceTypes.includes(appearance) || $55e8287327009a1a$var$newSemanticColors.includes(appearance) ? $55e8287327009a1a$var$appearanceMapping[appearance] : "default";
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    return /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        "data-testid": testId,
        className: (0, $iJ0kj.default)([
            $55e8287327009a1a$var$styles.container,
            $55e8287327009a1a$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === "subtle" && $55e8287327009a1a$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && $55e8287327009a1a$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $iJ0kj.default)([
            $55e8287327009a1a$var$styles.text,
            (0, $ltooA.fg)("platform-lozenge-custom-letterspacing") && $55e8287327009a1a$var$styles.customLetterspacing,
            $55e8287327009a1a$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$55e8287327009a1a$var$LegacyLozenge.displayName = "Lozenge";
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $55e8287327009a1a$var$LozengeWrapper = /*#__PURE__*/ (0, $acw62.memo)(function(props) {
    if ((0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) return /*#__PURE__*/ $acw62.createElement((0, $69866d7b19e2bd24$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $acw62.createElement($55e8287327009a1a$var$LegacyLozenge, props);
});
$55e8287327009a1a$var$LozengeWrapper.displayName = "Lozenge";
var $55e8287327009a1a$export$2e2bcd8739ae039 = $55e8287327009a1a$var$LozengeWrapper;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $f76cd4ea2116adbb$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $f76cd4ea2116adbb$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($f76cd4ea2116adbb$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $f76cd4ea2116adbb$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f76cd4ea2116adbb$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f76cd4ea2116adbb$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $f76cd4ea2116adbb$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $f76cd4ea2116adbb$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $f76cd4ea2116adbb$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $f76cd4ea2116adbb$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $f76cd4ea2116adbb$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $f76cd4ea2116adbb$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $f76cd4ea2116adbb$var$childrenToArray(previousChildren);
    var current = $f76cd4ea2116adbb$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $f76cd4ea2116adbb$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $f76cd4ea2116adbb$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $ltooA.fg)("platform-dst-motion-uplift") ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $f76cd4ea2116adbb$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $f76cd4ea2116adbb$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $f76cd4ea2116adbb$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($f76cd4ea2116adbb$var$ExitingContext);
};
$f76cd4ea2116adbb$var$ExitingPersistence.displayName = "ExitingPersistence";
var $f76cd4ea2116adbb$export$2e2bcd8739ae039 = $f76cd4ea2116adbb$var$ExitingPersistence;


var $02Ztr = parcelRequire("02Ztr");
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $aa71385b865e1d08$export$368bacef0dacbe05 = 25;
var $aa71385b865e1d08$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $aa71385b865e1d08$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $aa71385b865e1d08$export$30fa1a2e62ae150c = {
    none: $aa71385b865e1d08$export$38b928a7167ce124.none,
    small: $aa71385b865e1d08$export$38b928a7167ce124.small * $aa71385b865e1d08$var$EXITING_MOTION_MULTIPLIER,
    medium: $aa71385b865e1d08$export$38b928a7167ce124.medium * $aa71385b865e1d08$var$EXITING_MOTION_MULTIPLIER,
    large: $aa71385b865e1d08$export$38b928a7167ce124.large * $aa71385b865e1d08$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
// Handle both browser and Node.js environments
var $97aed982f7ccfd3e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $97aed982f7ccfd3e$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $97aed982f7ccfd3e$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $97aed982f7ccfd3e$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $97aed982f7ccfd3e$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $acw62 = parcelRequire("acw62");
var $b9216c18e729155f$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $acw62.useRef)(null);
    var setRef = (0, $acw62.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};



var $acw62 = parcelRequire("acw62");
var $de1c35f886750e28$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);



/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $9896a8c662c5c06e$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "small" : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $b9216c18e729155f$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $f76cd4ea2116adbb$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $97aed982f7ccfd3e$export$1775f27e7c8051ca)();
    var setTimeout = (0, $97aed982f7ccfd3e$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? "exiting" : "entering";
    (0, $de1c35f886750e28$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: "border-box",
                willChange: "width,margin"
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: "0px",
                        margin: "0px",
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: "cubic-bezier(0.8,0,0,0.8)",
                        transitionDuration: (0, $aa71385b865e1d08$export$38b928a7167ce124)[duration] + "ms",
                        transitionProperty: "width,margin"
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish("exiting");
                    }, (0, $aa71385b865e1d08$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $9896a8c662c5c06e$export$2e2bcd8739ae039 = $9896a8c662c5c06e$var$ShrinkOut;



var $ltooA = parcelRequire("ltooA");
/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");
/* shared.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");


var $ltooA = parcelRequire("ltooA");
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $aea5132bc1cc641f$var$ATOMIC_GROUP_LENGTH = 5;
function $aea5132bc1cc641f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $aea5132bc1cc641f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $c12c2d7e0ec2286f$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $aea5132bc1cc641f$export$2e2bcd8739ae039)(actualStyles);
};



var $bv4qN = parcelRequire("bv4qN");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $a2c632eaa7fe2fac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a2c632eaa7fe2fac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a2c632eaa7fe2fac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a2c632eaa7fe2fac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a2c632eaa7fe2fac$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a2c632eaa7fe2fac$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $a2c632eaa7fe2fac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a2c632eaa7fe2fac$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $a2c632eaa7fe2fac$var$_objectSpread($a2c632eaa7fe2fac$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $2594331d061a808c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $2594331d061a808c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $2594331d061a808c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2594331d061a808c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2594331d061a808c$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $2594331d061a808c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2594331d061a808c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2594331d061a808c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $2594331d061a808c$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $2594331d061a808c$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $a2c632eaa7fe2fac$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $382f2535209452f3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $5fdb39d844d7390a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $382f2535209452f3$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $2594331d061a808c$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $57b60b4b1b1e91c7$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $522936d707e6a69d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $522936d707e6a69d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $522936d707e6a69d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $522936d707e6a69d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $522936d707e6a69d$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5fdb39d844d7390a$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $57b60b4b1b1e91c7$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $57b60b4b1b1e91c7$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $522936d707e6a69d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $40725b92c67dc33d$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $acw62.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $40725b92c67dc33d$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($40725b92c67dc33d$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $40725b92c67dc33d$export$2e2bcd8739ae039 = $40725b92c67dc33d$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $86b8107c06797381$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $acw62.useContext)((0, $40725b92c67dc33d$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $86b8107c06797381$export$2e2bcd8739ae039 = $86b8107c06797381$var$useRouterLink;





var $acw62 = parcelRequire("acw62");
var $c79500baad2351ea$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $4160c469caf63156$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $4160c469caf63156$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $luEYg.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $4160c469caf63156$export$2e2bcd8739ae039 = $4160c469caf63156$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ae45da12913c328f$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $ae45da12913c328f$var$_excluded2 = [
    "className"
];
var $ae45da12913c328f$var$focusRingStyles = null;
var $ae45da12913c328f$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $ae45da12913c328f$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $ae45da12913c328f$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $ae45da12913c328f$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $aea5132bc1cc641f$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $ae45da12913c328f$export$2e2bcd8739ae039 = $ae45da12913c328f$var$Focusable;


var $e084dcfa8ab7fd46$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $e084dcfa8ab7fd46$var$_excluded2 = [
    "className"
];
var $e084dcfa8ab7fd46$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $e084dcfa8ab7fd46$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $e084dcfa8ab7fd46$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $e084dcfa8ab7fd46$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $e084dcfa8ab7fd46$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $c79500baad2351ea$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $d9f258fd1a7d4ed3$export$f680877a34711e37)();
    var onClick = (0, $522936d707e6a69d$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $e084dcfa8ab7fd46$var$_excluded2);
    var RouterLink = (0, $86b8107c06797381$export$2e2bcd8739ae039)();
    var isExternal = typeof href === "string" && $e084dcfa8ab7fd46$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $e084dcfa8ab7fd46$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(href) === "object";
    (0, $bv4qN.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $acw62.createElement((0, $ae45da12913c328f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $c12c2d7e0ec2286f$export$a274e22fb40f762e)($e084dcfa8ab7fd46$var$styles.root, $e084dcfa8ab7fd46$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $acw62.createElement((0, $4160c469caf63156$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $e084dcfa8ab7fd46$var$Anchor = /*#__PURE__*/ (0, $acw62.forwardRef)($e084dcfa8ab7fd46$var$AnchorNoRef);
var $e084dcfa8ab7fd46$export$2e2bcd8739ae039 = $e084dcfa8ab7fd46$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $43281c6af3b88bd4$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $43281c6af3b88bd4$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($43281c6af3b88bd4$export$1ca2a26fecb070ae);
};
$43281c6af3b88bd4$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $173d97d76ec99053$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $173d97d76ec99053$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $173d97d76ec99053$var$baseStyles = null;
var $173d97d76ec99053$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhkkuup",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1gf0",
    "color.background.accent.lime.subtler.pressed": "_bfhk2kxc",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhk1jbd",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhkh0j0",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhknbir",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkaffd",
    "color.background.accent.red.subtler.pressed": "_bfhk1j5a",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1fnn",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhk1cl6",
    "color.background.accent.orange.subtlest": "_bfhkf5uh",
    "color.background.accent.orange.subtlest.hovered": "_bfhk19yr",
    "color.background.accent.orange.subtlest.pressed": "_bfhkf90x",
    "color.background.accent.orange.subtler": "_bfhk165s",
    "color.background.accent.orange.subtler.hovered": "_bfhk1ei0",
    "color.background.accent.orange.subtler.pressed": "_bfhkdpo3",
    "color.background.accent.orange.subtle": "_bfhk1kkj",
    "color.background.accent.orange.subtle.hovered": "_bfhk9mfs",
    "color.background.accent.orange.subtle.pressed": "_bfhkaxpp",
    "color.background.accent.orange.bolder": "_bfhk1qg1",
    "color.background.accent.orange.bolder.hovered": "_bfhk12qo",
    "color.background.accent.orange.bolder.pressed": "_bfhk1fyq",
    "color.background.accent.yellow.subtlest": "_bfhkibhp",
    "color.background.accent.yellow.subtlest.hovered": "_bfhkaetg",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk1o1l",
    "color.background.accent.yellow.subtler": "_bfhk1773",
    "color.background.accent.yellow.subtler.hovered": "_bfhk1uw7",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1r9w",
    "color.background.accent.yellow.subtle": "_bfhk8y3s",
    "color.background.accent.yellow.subtle.hovered": "_bfhk819w",
    "color.background.accent.yellow.subtle.pressed": "_bfhk1jx0",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk1okt",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkyfny",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhk1e2h",
    "color.background.accent.green.subtler.pressed": "_bfhkybhx",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk1g86",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1j68",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1cxp",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkkwwr",
    "color.background.accent.teal.subtler.pressed": "_bfhk1jb0",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk16zl",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhktor0",
    "color.background.accent.blue.subtlest": "_bfhk1s93",
    "color.background.accent.blue.subtlest.hovered": "_bfhkdaj9",
    "color.background.accent.blue.subtlest.pressed": "_bfhkxm0g",
    "color.background.accent.blue.subtler": "_bfhk1dy8",
    "color.background.accent.blue.subtler.hovered": "_bfhk815t",
    "color.background.accent.blue.subtler.pressed": "_bfhkrwxf",
    "color.background.accent.blue.subtle": "_bfhk115i",
    "color.background.accent.blue.subtle.hovered": "_bfhk9pr4",
    "color.background.accent.blue.subtle.pressed": "_bfhknpx7",
    "color.background.accent.blue.bolder": "_bfhk16e3",
    "color.background.accent.blue.bolder.hovered": "_bfhk1vbm",
    "color.background.accent.blue.bolder.pressed": "_bfhk1xwi",
    "color.background.accent.purple.subtlest": "_bfhkp2ly",
    "color.background.accent.purple.subtlest.hovered": "_bfhkkca2",
    "color.background.accent.purple.subtlest.pressed": "_bfhk1jbm",
    "color.background.accent.purple.subtler": "_bfhk1nm4",
    "color.background.accent.purple.subtler.hovered": "_bfhkattl",
    "color.background.accent.purple.subtler.pressed": "_bfhk3nfk",
    "color.background.accent.purple.subtle": "_bfhk18ah",
    "color.background.accent.purple.subtle.hovered": "_bfhk8bp1",
    "color.background.accent.purple.subtle.pressed": "_bfhk1cd2",
    "color.background.accent.purple.bolder": "_bfhkya33",
    "color.background.accent.purple.bolder.hovered": "_bfhk1af5",
    "color.background.accent.purple.bolder.pressed": "_bfhk6cze",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1ckf",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1axx",
    "color.background.accent.magenta.subtler.pressed": "_bfhk42ri",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk6c15",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkeawv",
    "color.background.accent.gray.subtlest": "_bfhkysee",
    "color.background.accent.gray.subtlest.hovered": "_bfhkwejn",
    "color.background.accent.gray.subtlest.pressed": "_bfhk18ut",
    "color.background.accent.gray.subtler": "_bfhk7qp0",
    "color.background.accent.gray.subtler.hovered": "_bfhk10ef",
    "color.background.accent.gray.subtler.pressed": "_bfhk1rk9",
    "color.background.accent.gray.subtle": "_bfhk18j9",
    "color.background.accent.gray.subtle.hovered": "_bfhk1nv3",
    "color.background.accent.gray.subtle.pressed": "_bfhkq9tj",
    "color.background.accent.gray.bolder": "_bfhk1i45",
    "color.background.accent.gray.bolder.hovered": "_bfhkbyip",
    "color.background.accent.gray.bolder.pressed": "_bfhk1van",
    "color.background.disabled": "_bfhkby5v",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhkl4ek",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhki8nm",
    "color.background.neutral.hovered": "_bfhkplhp",
    "color.background.neutral.pressed": "_bfhk1gdz",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk1dpa",
    "color.background.neutral.subtle.pressed": "_bfhkfcek",
    "color.background.neutral.bold": "_bfhk1aqn",
    "color.background.neutral.bold.hovered": "_bfhk1ibz",
    "color.background.neutral.bold.pressed": "_bfhkof27",
    "color.background.selected": "_bfhk15s3",
    "color.background.selected.hovered": "_bfhkufnl",
    "color.background.selected.pressed": "_bfhknozp",
    "color.background.selected.bold": "_bfhkjmqp",
    "color.background.selected.bold.hovered": "_bfhk1q28",
    "color.background.selected.bold.pressed": "_bfhk12kk",
    "color.background.brand.subtlest": "_bfhk1gmr",
    "color.background.brand.subtlest.hovered": "_bfhk3v15",
    "color.background.brand.subtlest.pressed": "_bfhku02c",
    "color.background.brand.bold": "_bfhk1856",
    "color.background.brand.bold.hovered": "_bfhkhf2y",
    "color.background.brand.bold.pressed": "_bfhkg6ey",
    "color.background.brand.boldest": "_bfhk1o4i",
    "color.background.brand.boldest.hovered": "_bfhklefx",
    "color.background.brand.boldest.pressed": "_bfhk16k6",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1r4b",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk13a9",
    "color.background.warning": "_bfhk1917",
    "color.background.warning.hovered": "_bfhk19zu",
    "color.background.warning.pressed": "_bfhkzr32",
    "color.background.warning.bold": "_bfhk1kmu",
    "color.background.warning.bold.hovered": "_bfhk1spp",
    "color.background.warning.bold.pressed": "_bfhk4m4m",
    "color.background.success": "_bfhk1y9u",
    "color.background.success.hovered": "_bfhk1vfx",
    "color.background.success.pressed": "_bfhk1wl5",
    "color.background.success.bold": "_bfhkkcmj",
    "color.background.success.bold.hovered": "_bfhky7x8",
    "color.background.success.bold.pressed": "_bfhkwcbh",
    "color.background.discovery": "_bfhk6vm6",
    "color.background.discovery.hovered": "_bfhk12eq",
    "color.background.discovery.pressed": "_bfhk18vq",
    "color.background.discovery.bold": "_bfhku5tj",
    "color.background.discovery.bold.hovered": "_bfhkfqeg",
    "color.background.discovery.bold.pressed": "_bfhk1f1m",
    "color.background.information": "_bfhk19ip",
    "color.background.information.hovered": "_bfhk86z5",
    "color.background.information.pressed": "_bfhk1c1j",
    "color.background.information.bold": "_bfhkx4w0",
    "color.background.information.bold.hovered": "_bfhkq2ii",
    "color.background.information.bold.pressed": "_bfhkf89v",
    "color.blanket": "_bfhk1i5c",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkizff",
    "color.skeleton.subtle": "_bfhkvkf5",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk19i6",
    "elevation.surface.pressed": "_bfhk13ro",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk6o2t",
    "elevation.surface.overlay.pressed": "_bfhkm8nx",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk116u",
    "elevation.surface.raised.pressed": "_bfhk14aj",
    "elevation.surface.sunken": "_bfhkhfxm",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $173d97d76ec99053$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $173d97d76ec99053$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l19i6",
    "elevation.surface.pressed": "_1q1l13ro",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l6o2t",
    "elevation.surface.overlay.pressed": "_1q1lm8nx",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l116u",
    "elevation.surface.raised.pressed": "_1q1l14aj",
    "elevation.surface.sunken": "_1q1lhfxm"
};
var $173d97d76ec99053$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $173d97d76ec99053$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $173d97d76ec99053$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $173d97d76ec99053$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $173d97d76ec99053$var$Box = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $173d97d76ec99053$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $173d97d76ec99053$var$_excluded2);
    var node = /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: (0, $aea5132bc1cc641f$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $173d97d76ec99053$var$backgroundColorMap[backgroundColor],
            backgroundColor && $173d97d76ec99053$var$isSurfaceToken(backgroundColor) && $173d97d76ec99053$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $173d97d76ec99053$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $173d97d76ec99053$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $173d97d76ec99053$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $173d97d76ec99053$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $acw62.createElement((0, $43281c6af3b88bd4$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $173d97d76ec99053$export$2e2bcd8739ae039 = $173d97d76ec99053$var$Box;
function $173d97d76ec99053$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $173d97d76ec99053$var$setSurfaceTokenMap;
}


var $b5ebf56dbdf13681$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $b5ebf56dbdf13681$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $b5ebf56dbdf13681$var$iconStyles = null;
var $b5ebf56dbdf13681$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b5ebf56dbdf13681$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $e084dcfa8ab7fd46$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $66d7dbe9bd15c487$export$a274e22fb40f762e)($b5ebf56dbdf13681$var$styles.base, (0, $ltooA.fg)("platform-dst-shape-theme-default") && $b5ebf56dbdf13681$var$styles.baseT26Shape, appearance === "default" && $b5ebf56dbdf13681$var$styles.defaultAppearance, appearance === "subtle" && $b5ebf56dbdf13681$var$styles.subtleAppearance, appearance === "inverse" && $b5ebf56dbdf13681$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== "inverse" && $b5ebf56dbdf13681$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === "_blank" && /*#__PURE__*/ $acw62.createElement((0, $173d97d76ec99053$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $b5ebf56dbdf13681$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $acw62.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $luEYg.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $b5ebf56dbdf13681$var$Link = /*#__PURE__*/ (0, $acw62.forwardRef)($b5ebf56dbdf13681$var$LinkWithoutRef);
var $b5ebf56dbdf13681$export$2e2bcd8739ae039 = $b5ebf56dbdf13681$var$Link;



/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");


var $b6151e808e208cc6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b6151e808e208cc6$exports, "__esModule", {
    value: true
});
$b6151e808e208cc6$exports.default = void 0;

var $b6151e808e208cc6$var$_react = $b6151e808e208cc6$var$_interopRequireDefault((parcelRequire("acw62")));

var $b6151e808e208cc6$var$_baseNew = $b6151e808e208cc6$var$_interopRequireDefault((parcelRequire("eKnnT")));
function $b6151e808e208cc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6151e808e208cc6$var$CrossIcon = (props)=>/*#__PURE__*/ $b6151e808e208cc6$var$_react.default.createElement($b6151e808e208cc6$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$b6151e808e208cc6$var$CrossIcon.displayName = "CrossIcon";
var $b6151e808e208cc6$var$_default = $b6151e808e208cc6$exports.default = $b6151e808e208cc6$var$CrossIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $iJ0kj = parcelRequire("iJ0kj");
const $35dd66c40a89b2fd$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $iJ0kj.default)(actualStyles);
};






/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");
var $465a72e027d02c4a$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $465a72e027d02c4a$var$_excluded2 = [
    "className"
];
var $465a72e027d02c4a$var$focusRingStyles = null;
var $465a72e027d02c4a$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $465a72e027d02c4a$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $465a72e027d02c4a$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $465a72e027d02c4a$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $iJ0kj.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $465a72e027d02c4a$export$2e2bcd8739ae039 = $465a72e027d02c4a$var$Focusable;


var $f49681d59158740f$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $f49681d59158740f$var$_excluded2 = [
    "className"
];
var $f49681d59158740f$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $f49681d59158740f$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $f49681d59158740f$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $8c1780c79962f4a3$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $c2a6901a3a5e9162$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $f49681d59158740f$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $465a72e027d02c4a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $0ef728659bef6f62$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $35dd66c40a89b2fd$export$a274e22fb40f762e)($f49681d59158740f$var$styles.root, isDisabled && $f49681d59158740f$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $f49681d59158740f$export$2e2bcd8739ae039 = $f49681d59158740f$var$Pressable;


var $1f4796ca2d110daa$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
var $1f4796ca2d110daa$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
var $1f4796ca2d110daa$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref["aria-label"], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "default" : _ref$shape;
    return /*#__PURE__*/ $acw62.createElement((0, $f49681d59158740f$export$2e2bcd8739ae039), {
        xcss: (0, $66d7dbe9bd15c487$export$a274e22fb40f762e)($1f4796ca2d110daa$var$removeButtonStyles.root, shape === "circle" && $1f4796ca2d110daa$var$removeButtonStyles.circle, $1f4796ca2d110daa$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b6151e808e208cc6$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1f4796ca2d110daa$export$2e2bcd8739ae039 = $1f4796ca2d110daa$var$RemoveButton;


var $694a8dfa83c0862e$export$203775b632e10448 = "--ds-tag-icon";
var $694a8dfa83c0862e$export$7d6deb4aa4b5840e = "--tag-border-token";
var $694a8dfa83c0862e$export$df7ff9c2f76bffcd = "--tag-icon-token";
var $694a8dfa83c0862e$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
var $694a8dfa83c0862e$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};
var $694a8dfa83c0862e$export$8793edee2d425525 = (0, $232d11f435326a2b$export$2e2bcd8739ae039);
function $694a8dfa83c0862e$export$f26019543e9f862f(text, onBeforeRemoveAction, onAfterRemoveAction) {
    var _useState = (0, $acw62.useState)($694a8dfa83c0862e$export$74452314b63acabc.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveComplete = (0, $acw62.useCallback)(function() {
        (onAfterRemoveAction !== null && onAfterRemoveAction !== void 0 ? onAfterRemoveAction : $694a8dfa83c0862e$export$8793edee2d425525)(text);
        setStatus($694a8dfa83c0862e$export$74452314b63acabc.Removed);
    }, [
        onAfterRemoveAction,
        text
    ]);
    var handleRemoveRequest = (0, $acw62.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : $694a8dfa83c0862e$export$279e7025ed114474;
        if (beforeAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $acw62.useCallback)(function(e) {
        var spacebarOrEnter = e.key === " " || e.key === "Enter";
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $acw62.useCallback)(function() {
        return setStatus($694a8dfa83c0862e$export$74452314b63acabc.Removing);
    }, []);
    var showingTag = (0, $acw62.useCallback)(function() {
        return setStatus($694a8dfa83c0862e$export$74452314b63acabc.Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}
function $694a8dfa83c0862e$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $b5ebf56dbdf13681$export$2e2bcd8739ae039);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
function $694a8dfa83c0862e$export$84acd183858d8235() {
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isLinkHovered = _useState4[0], setIsLinkHovered = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), isOverButton = _useState6[0], setIsOverButton = _useState6[1];
    var _useState7 = (0, $acw62.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState7, 2), isButtonFocused = _useState8[0], setIsButtonFocused = _useState8[1];
    var _useState9 = (0, $acw62.useState)(false), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState9, 2), isLinkFocused = _useState0[0], setIsLinkFocused = _useState0[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $acw62.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $acw62.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $acw62.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}
function $694a8dfa83c0862e$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "default" : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $acw62.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $acw62.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $acw62.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ $acw62.createElement((0, $1f4796ca2d110daa$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || "Remove", " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function $694a8dfa83c0862e$export$898a500849bb5cf4(_ref2) {
    var isRemovable = _ref2.isRemovable, status = _ref2.status, children = _ref2.children;
    if (isRemovable) return /*#__PURE__*/ $acw62.createElement((0, $f76cd4ea2116adbb$export$2e2bcd8739ae039), null, !(status === $694a8dfa83c0862e$export$74452314b63acabc.Removed) && /*#__PURE__*/ $acw62.createElement((0, $9896a8c662c5c06e$export$2e2bcd8739ae039), null, function(motion) {
        return /*#__PURE__*/ $acw62.createElement("span", {
            ref: motion.ref
        }, children);
    }));
    return children;
}
function $694a8dfa83c0862e$export$ce4b6a469c26f53f(_ref3) {
    var isLink = _ref3.isLink, href = _ref3.href, LinkComponent = _ref3.LinkComponent, testId = _ref3.testId, children = _ref3.children, onClick = _ref3.onClick, linkHandlers = _ref3.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ $acw62.createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, children);
}


var $8e7473c4297bb3f0$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "onClick"
];
// CSS variable name for icon color - must be used as literal string in cssMap due to Compiled CSS static analysis
var $8e7473c4297bb3f0$var$iconColorVar = "--ds-tag-icon";
var $8e7473c4297bb3f0$export$3351a8d90bcc13aa = {
    standard: "gray",
    grey: "gray",
    blue: "blue",
    green: "green",
    red: "red",
    yellow: "yellow",
    purple: "purple",
    lime: "lime",
    magenta: "magenta",
    orange: "orange",
    teal: "teal",
    // Light variants map to same as their non-light counterparts
    greyLight: "gray",
    blueLight: "blue",
    greenLight: "green",
    redLight: "red",
    yellowLight: "yellow",
    purpleLight: "purple",
    limeLight: "lime",
    magentaLight: "magenta",
    orangeLight: "orange",
    tealLight: "teal"
};
var $8e7473c4297bb3f0$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _1rjcv77o _18zr1mie _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// Border and icon color styles - each color sets CSS variables for its token values
var $8e7473c4297bb3f0$var$colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ // Border + icon filter styles - base state
var $8e7473c4297bb3f0$var$borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
};
// Border + icon filter styles - interactive states (hover/pressed)
var $8e7473c4297bb3f0$var$borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $8e7473c4297bb3f0$var$TagNewComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "gray" : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, onClick = _ref.onClick, other = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $8e7473c4297bb3f0$var$_excluded);
    var _useTagRemoval = (0, $694a8dfa83c0862e$export$f26019543e9f862f)(text, onBeforeRemoveAction, onAfterRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var _useLink = (0, $694a8dfa83c0862e$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $694a8dfa83c0862e$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $694a8dfa83c0862e$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, other, {
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $iJ0kj.default)([
            $8e7473c4297bb3f0$var$styles.baseStyles,
            $8e7473c4297bb3f0$var$colorStyles[color],
            $8e7473c4297bb3f0$var$borderIconFilterStyles.root,
            isLink && $8e7473c4297bb3f0$var$styles.interactiveBaseStyles,
            isLink && $8e7473c4297bb3f0$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $8e7473c4297bb3f0$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $8e7473c4297bb3f0$var$styles.interactiveHoverStyles,
            isRemovable && $8e7473c4297bb3f0$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $8e7473c4297bb3f0$var$styles.childFocusRingStyles
        ])
    }), /*#__PURE__*/ $acw62.createElement((0, $694a8dfa83c0862e$export$ce4b6a469c26f53f), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, elemBefore && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $iJ0kj.default)([
            $8e7473c4297bb3f0$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $acw62.createElement("span", {
        "data-tag-text": true,
        className: (0, $iJ0kj.default)([
            $8e7473c4297bb3f0$var$styles.textStyles
        ])
    }, text)), removeButton && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $iJ0kj.default)([
            $8e7473c4297bb3f0$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $acw62.createElement((0, $694a8dfa83c0862e$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status
    }, tagContent);
});
/**
 * __Tag new__
 */ var $8e7473c4297bb3f0$var$TagNew = /*#__PURE__*/ (0, $acw62.memo)($8e7473c4297bb3f0$var$TagNewComponent);
var $8e7473c4297bb3f0$export$2e2bcd8739ae039 = $8e7473c4297bb3f0$var$TagNew;


/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $iJ0kj = parcelRequire("iJ0kj");

var $acw62 = parcelRequire("acw62");
var $955ac849e4619c2e$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $955ac849e4619c2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $955ac849e4619c2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $955ac849e4619c2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $955ac849e4619c2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $955ac849e4619c2e$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $955ac849e4619c2e$var$baseStyles = null;
var $955ac849e4619c2e$var$interactiveStyles = null;
var $955ac849e4619c2e$var$focusRingStyles = null;
var $955ac849e4619c2e$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $955ac849e4619c2e$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === "gray") // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = "grey";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, other, {
        ref: ref,
        style: $955ac849e4619c2e$var$_objectSpread({}, style),
        className: (0, $iJ0kj.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $955ac849e4619c2e$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$955ac849e4619c2e$export$2e2bcd8739ae039 = $955ac849e4619c2e$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");
var $1cb26c4ac094268d$var$beforeElementStyles = null;
var $1cb26c4ac094268d$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $iJ0kj.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1cb26c4ac094268d$export$2e2bcd8739ae039 = $1cb26c4ac094268d$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $0004b8957b0008aa$var$colorToLozengeAppearanceMap = {
    gray: "default",
    grey: "default",
    lime: "success",
    green: "success",
    blue: "inprogress",
    red: "removed",
    purple: "new",
    yellow: "moved",
    orange: "moved",
    magenta: "new",
    teal: "inprogress",
    grayLight: "default",
    greyLight: "default",
    limeLight: "success",
    greenLight: "success",
    blueLight: "inprogress",
    redLight: "removed",
    purpleLight: "new",
    yellowLight: "moved",
    orangeLight: "moved",
    magentaLight: "new",
    tealLight: "inprogress"
};
function $0004b8957b0008aa$export$4d9e331cafeacb9d(color) {
    return $0004b8957b0008aa$var$colorToLozengeAppearanceMap[color || "gray"] || "default";
}


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $iJ0kj = parcelRequire("iJ0kj");
var $b19497fa32a65956$var$baseStyles = null;
var $b19497fa32a65956$var$linkStyles = null;
var $b19497fa32a65956$var$hasAfterStyles = null;
var $b19497fa32a65956$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : "a";
    if (href) return /*#__PURE__*/ $acw62.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $iJ0kj.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, text);
    else return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $iJ0kj.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b19497fa32a65956$export$2e2bcd8739ae039 = $b19497fa32a65956$var$Content;



var $b508d515dd2bdafb$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth"
];
var $b508d515dd2bdafb$var$textLinkCssVar = "--ds-ctl";
var $b508d515dd2bdafb$var$textDefaultCssVar = "--ds-ct";
var $b508d515dd2bdafb$var$textActiveCssVar = "--ds-ctp";
var $b508d515dd2bdafb$var$backgroundHoverCssVar = "--ds-cbh";
var $b508d515dd2bdafb$var$backgroundActiveCssVar = "--ds-cba";
var $b508d515dd2bdafb$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($b508d515dd2bdafb$var$TagStatus || {});
var $b508d515dd2bdafb$var$packageName = "@atlaskit/tag";
var $b508d515dd2bdafb$var$packageVersion = "0.0.0-development";
var $b508d515dd2bdafb$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $b508d515dd2bdafb$var$removingStyles = null;
var $b508d515dd2bdafb$var$RemovableTagComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $b508d515dd2bdafb$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $232d11f435326a2b$export$2e2bcd8739ae039) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b508d515dd2bdafb$var$_excluded);
    var _useState = (0, $acw62.useState)($b508d515dd2bdafb$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var onAfterRemoveActionWithAnalytics = (0, $506e0ab121f4cb51$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: "removed",
        actionSubject: "tag",
        attributes: {
            componentName: "tag",
            packageName: $b508d515dd2bdafb$var$packageName,
            packageVersion: $b508d515dd2bdafb$var$packageVersion
        }
    }, "atlaskit");
    var handleRemoveComplete = (0, $acw62.useCallback)(function() {
        onAfterRemoveActionWithAnalytics(text);
        setStatus($b508d515dd2bdafb$var$TagStatus.Removed);
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    var handleRemoveRequest = (0, $acw62.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $acw62.useCallback)(function(e) {
        var spacebarOrEnter = e.key === " " || e.key === "Enter";
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $acw62.useCallback)(function() {
        return setStatus($b508d515dd2bdafb$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $acw62.useCallback)(function() {
        return setStatus($b508d515dd2bdafb$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $acw62.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $acw62.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $acw62.createElement((0, $1f4796ca2d110daa$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || "Remove", " ").concat(text),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === "lozenge" && !(0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        var lozengeAppearance = (0, $0004b8957b0008aa$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $acw62.createElement((0, $55e8287327009a1a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), text);
    }
    // Use new TagNew component behind feature flag
    if ((0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        var newColor = (0, $8e7473c4297bb3f0$export$3351a8d90bcc13aa)[color || "standard"];
        return /*#__PURE__*/ $acw62.createElement((0, $8e7473c4297bb3f0$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveAction,
            maxWidth: maxWidth
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $acw62.createElement((0, $b19497fa32a65956$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $b508d515dd2bdafb$var$backgroundHoverCssVar, undefined), $b508d515dd2bdafb$var$backgroundActiveCssVar, undefined), $b508d515dd2bdafb$var$textDefaultCssVar, undefined), $b508d515dd2bdafb$var$textActiveCssVar, undefined), $b508d515dd2bdafb$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $acw62.createElement((0, $f76cd4ea2116adbb$export$2e2bcd8739ae039), null, !(status === $b508d515dd2bdafb$var$TagStatus.Removed) && /*#__PURE__*/ $acw62.createElement((0, $9896a8c662c5c06e$export$2e2bcd8739ae039), null, function(motion) {
        return /*#__PURE__*/ $acw62.createElement((0, $955ac849e4619c2e$export$2e2bcd8739ae039), {
            ref: (0, $3d94fa6e7ae720e2$export$2e2bcd8739ae039)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $b508d515dd2bdafb$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $acw62.createElement((0, $1cb26c4ac094268d$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $iJ0kj.default)([
                status === $b508d515dd2bdafb$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $b508d515dd2bdafb$var$RemovableTag = /*#__PURE__*/ (0, $acw62.memo)($b508d515dd2bdafb$var$RemovableTagComponent);
var $b508d515dd2bdafb$export$2e2bcd8739ae039 = $b508d515dd2bdafb$var$RemovableTag;



/* multi-value-label.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $635e6291a910f34a$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $635e6291a910f34a$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $635e6291a910f34a$var$multiValueLabelStyles.root,
            isDisabled && $635e6291a910f34a$var$multiValueLabelStyles.disabled,
            hasEllipsis && $635e6291a910f34a$var$multiValueLabelStyles.ellipsis,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-MultiValueLabel")
        ])
    }), children);
};


function $f872fa2431b7b1ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f872fa2431b7b1ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f872fa2431b7b1ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f872fa2431b7b1ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Tag wrapper: Tag has built-in margin; cancel the inline margin so we control spacing
var $f872fa2431b7b1ea$var$tagMarginToken = "var(--ds-space-050, 4px)";
var $f872fa2431b7b1ea$var$multiValueTagWrapperStyles = {
    root: "_1e0c1txw _1ul9ze3t _1pfhv77o _12l21b66 _6rthv77o _p12f1osq",
    inner: "_195g8ily"
};
// Tag-like color styles
var $f872fa2431b7b1ea$var$tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
var $f872fa2431b7b1ea$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $f872fa2431b7b1ea$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1mouv77o _195gv77o _1dqonqa1 _189ee4h9 _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1ul9idpf _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk1dpa _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $f872fa2431b7b1ea$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === "string") return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === "string" ? label : "";
};
var $f872fa2431b7b1ea$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $f872fa2431b7b1ea$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === "string";
    var ffTagUplifts = (0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts");
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "multiValue", {
        "multi-value": true,
        "multi-value--is-disabled": isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "multiValueLabel", {
        "multi-value__label": true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "multiValueRemove", {
        "multi-value__remove": true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $635e6291a910f34a$export$544aeea2a5ce08ee);
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $7lEDz.default)([
                $f872fa2431b7b1ea$var$multiValueTagWrapperStyles.root,
                (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, "-multiValue")
            ])
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $7lEDz.default)([
                $f872fa2431b7b1ea$var$multiValueTagWrapperStyles.inner
            ])
        }, /*#__PURE__*/ $acw62.createElement((0, $b508d515dd2bdafb$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : "gray",
            elemBefore: elemBefore
        })));
    }
    // FF on + custom content or custom Label/Remove → tag-like container styling with the provided
    // Label and Remove components so custom overrides continue to work.
    if (ffTagUplifts) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            className: (0, $7lEDz.default)([
                $f872fa2431b7b1ea$var$multiValueTagLikeStyles.root,
                $f872fa2431b7b1ea$var$tagLikeColorStyles.gray,
                colorKey === "blue" && $f872fa2431b7b1ea$var$tagLikeColorStyles.blue,
                colorKey === "green" && $f872fa2431b7b1ea$var$tagLikeColorStyles.green,
                colorKey === "red" && $f872fa2431b7b1ea$var$tagLikeColorStyles.red,
                colorKey === "yellow" && $f872fa2431b7b1ea$var$tagLikeColorStyles.yellow,
                colorKey === "purple" && $f872fa2431b7b1ea$var$tagLikeColorStyles.purple,
                colorKey === "lime" && $f872fa2431b7b1ea$var$tagLikeColorStyles.lime,
                colorKey === "magenta" && $f872fa2431b7b1ea$var$tagLikeColorStyles.magenta,
                colorKey === "orange" && $f872fa2431b7b1ea$var$tagLikeColorStyles.orange,
                colorKey === "teal" && $f872fa2431b7b1ea$var$tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && $f872fa2431b7b1ea$var$multiValueTagLikeStyles.disabled,
                isFocused && $f872fa2431b7b1ea$var$multiValueTagLikeStyles.focused,
                (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, "-multiValue")
            ])
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $7lEDz.default)([
                $f872fa2431b7b1ea$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $acw62.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $acw62.createElement(Remove, {
            data: data,
            innerProps: $f872fa2431b7b1ea$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: "button",
                tabIndex: -1,
                "aria-label": "".concat(labelText || "option", ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $acw62.createElement(Container, {
        data: data,
        innerProps: $f872fa2431b7b1ea$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $acw62.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $acw62.createElement(Remove, {
        data: data,
        innerProps: $f872fa2431b7b1ea$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: "button",
            tabIndex: -1,
            "aria-label": "".concat(labelText || "option", ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f872fa2431b7b1ea$export$2e2bcd8739ae039 = $f872fa2431b7b1ea$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $dfc66f78c669dad6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($dfc66f78c669dad6$exports, "__esModule", {
    value: true
});
$dfc66f78c669dad6$exports.default = void 0;

var $dfc66f78c669dad6$var$_react = $dfc66f78c669dad6$var$_interopRequireDefault((parcelRequire("acw62")));

var $dfc66f78c669dad6$var$_baseNew = $dfc66f78c669dad6$var$_interopRequireDefault((parcelRequire("5jvkr")));
function $dfc66f78c669dad6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dfc66f78c669dad6$var$CrossIcon = (props)=>/*#__PURE__*/ $dfc66f78c669dad6$var$_react.default.createElement($dfc66f78c669dad6$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$dfc66f78c669dad6$var$CrossIcon.displayName = "CrossIcon";
var $dfc66f78c669dad6$var$_default = $dfc66f78c669dad6$exports.default = $dfc66f78c669dad6$var$CrossIcon;


var $58fab6a134df6fd6$var$disabledStyles = null;
var $58fab6a134df6fd6$var$enabledStyles = null;
var $58fab6a134df6fd6$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1jjn _1di6fcek _i5f81jjn"
};
function $58fab6a134df6fd6$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7lEDz.default)([
            $58fab6a134df6fd6$var$multiValueRemoveStyles.root,
            isFocused && $58fab6a134df6fd6$var$multiValueRemoveStyles.focused,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-MultiValueRemove")
        ])
    }), /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": isDisabled ? "hide-clear-icon" : "show-clear-icon",
        className: (0, $7lEDz.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dfc66f78c669dad6$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $a11d9fbbf14d2c74$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $a11d9fbbf14d2c74$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $a11d9fbbf14d2c74$var$optionStyles.root,
            isFocused && $a11d9fbbf14d2c74$var$optionStyles.focused,
            isSelected && $a11d9fbbf14d2c74$var$optionStyles.selected,
            isFocused && isSelected && $a11d9fbbf14d2c74$var$optionStyles.focusedSelected,
            isDisabled && $a11d9fbbf14d2c74$var$optionStyles.disabled,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-option")
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a11d9fbbf14d2c74$export$2e2bcd8739ae039 = $a11d9fbbf14d2c74$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $0ca4dddb7159dd1c$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $0ca4dddb7159dd1c$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "placeholder", {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $0ca4dddb7159dd1c$var$placeholderStyles.root,
            isDisabled && $0ca4dddb7159dd1c$var$placeholderStyles.disabled,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-placeholder")
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0ca4dddb7159dd1c$export$2e2bcd8739ae039 = $0ca4dddb7159dd1c$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");


var $4feaee33de69d32a$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $4feaee33de69d32a$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $702bc6278a018d65$export$26417cabd806a658)(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $7lEDz.default)([
            $4feaee33de69d32a$var$styles.root,
            isDisabled && $4feaee33de69d32a$var$styles.disalbed,
            (0, $5eaac7506ec1ff7b$export$a274e22fb40f762e)(className, xcss, "-singleValue")
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4feaee33de69d32a$export$2e2bcd8739ae039 = $4feaee33de69d32a$var$SingleValue;


function $12c86ed757820ce3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12c86ed757820ce3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12c86ed757820ce3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12c86ed757820ce3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $12c86ed757820ce3$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $28b9578d44916ffb$export$ecf9cf59142dd54a),
    Control: (0, $b8d47299a469ed9f$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $2475fba3385d7619$export$ec98719d3db7f2e4),
    Group: (0, $e60a7da7404ce3ea$export$2e2bcd8739ae039),
    GroupHeading: (0, $a30f927442de8d89$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $9ddb497f2638dee9$export$d0ffd7e649cab6f),
    Input: (0, $deccdd3adfd208a3$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $0530124230c4fedf$export$7c20be4c1d342248),
    Menu: (0, $54eed77df4687f6b$export$2e2bcd8739ae039),
    MenuList: (0, $3f898c83f71dd370$export$d4c4e98c5044dc8),
    MenuPortal: (0, $299fff5d1acd25c2$export$793392f970497feb),
    LoadingMessage: (0, $95c620cd2304db6f$export$e928a71d039d3102),
    NoOptionsMessage: (0, $61a86ed26318476a$export$d58b72b7d3c4072c),
    MultiValue: (0, $f872fa2431b7b1ea$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $9c6b1b215a2de1de$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $635e6291a910f34a$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $58fab6a134df6fd6$export$8e1fd1a40e7a2f4a),
    Option: (0, $a11d9fbbf14d2c74$export$2e2bcd8739ae039),
    Placeholder: (0, $0ca4dddb7159dd1c$export$2e2bcd8739ae039),
    SelectContainer: (0, $5131fa8afa2d13f4$export$446eebadefe1123b),
    SingleValue: (0, $4feaee33de69d32a$export$2e2bcd8739ae039),
    ValueContainer: (0, $9804ec5e17a41770$export$4dc9f58ad9a1a000)
};
var $12c86ed757820ce3$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $12c86ed757820ce3$var$_objectSpread($12c86ed757820ce3$var$_objectSpread({}, $12c86ed757820ce3$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");
var $1c7e980b63bf8415$var$_excluded = [
    "innerRef"
];
var $1c7e980b63bf8415$var$removeProps = function removeProps(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)properties[_key - 1] = arguments[_key];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $1c7e980b63bf8415$var$dummyInputStyles = null;
function $1c7e980b63bf8415$export$2e2bcd8739ae039(_ref5) {
    var innerRef = _ref5.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref5, $1c7e980b63bf8415$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = $1c7e980b63bf8415$var$removeProps(props, "onExited", "in", "enter", "exit", "appear");
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: innerRef,
        className: (0, $7lEDz.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
var $ac53fa259ee98905$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return label.length ? "option ".concat(label, ", deselected") : "";
            case "clear":
                return "All selected options have been cleared.";
            case "select-option":
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : "";
            default:
                return "";
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : "";
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");
// Assistive text to describe visual elements. Hidden for sighted users.
var $99d617cc1f201097$var$styles = null;
var $99d617cc1f201097$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7lEDz.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $99d617cc1f201097$export$2e2bcd8739ae039 = $99d617cc1f201097$var$A11yText;


function $6560198ebe2f4515$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6560198ebe2f4515$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6560198ebe2f4515$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6560198ebe2f4515$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $6560198ebe2f4515$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return $6560198ebe2f4515$var$_objectSpread($6560198ebe2f4515$var$_objectSpread({}, (0, $ac53fa259ee98905$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return "";
            var onChangeProps = $6560198ebe2f4515$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (isLoading) resultsMsg = "Loading. ";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = "No options. ";
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99d617cc1f201097$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99d617cc1f201097$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6560198ebe2f4515$export$2e2bcd8739ae039 = $6560198ebe2f4515$var$LiveRegion;



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


function $c59fa8a23ca7387a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c59fa8a23ca7387a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c59fa8a23ca7387a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c59fa8a23ca7387a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c59fa8a23ca7387a$var$noop = (0, $232d11f435326a2b$export$2e2bcd8739ae039);
function $c59fa8a23ca7387a$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $c59fa8a23ca7387a$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $c59fa8a23ca7387a$var$normalizedHeight(el) {
    if ($c59fa8a23ca7387a$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $c59fa8a23ca7387a$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($c59fa8a23ca7387a$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $c59fa8a23ca7387a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $c59fa8a23ca7387a$var$getScrollTop(el) {
    if ($c59fa8a23ca7387a$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $c59fa8a23ca7387a$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c59fa8a23ca7387a$var$noop;
    var start = $c59fa8a23ca7387a$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $c59fa8a23ca7387a$var$easeOutCubic(currentTime, start, change, duration);
        $c59fa8a23ca7387a$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $c59fa8a23ca7387a$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $c59fa8a23ca7387a$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $c59fa8a23ca7387a$var$normalizedHeight(scrollParent);
    var scrollTop = $c59fa8a23ca7387a$var$getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $c59fa8a23ca7387a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $c59fa8a23ca7387a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $c59fa8a23ca7387a$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $c59fa8a23ca7387a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $c59fa8a23ca7387a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
var $c59fa8a23ca7387a$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var $c59fa8a23ca7387a$var$MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $acw62.useContext)((0, $fc64aa6b92b8d28d$export$e001f626511a0ead)) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $acw62.useLayoutEffect)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $c59fa8a23ca7387a$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $c59fa8a23ca7387a$var$_objectSpread($c59fa8a23ca7387a$var$_objectSpread({}, props), {}, {
            placement: placement || $c59fa8a23ca7387a$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $c59fa8a23ca7387a$export$2e2bcd8739ae039 = $c59fa8a23ca7387a$var$MenuPlacer;



var $g5Zhu = parcelRequire("g5Zhu");

var $jk22o = parcelRequire("jk22o");
var $a30bb61732033894$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $a30bb61732033894$var$anyDiacritic = new RegExp("[" + $a30bb61732033894$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $a30bb61732033894$var$diacriticToBase = {};
for(var $a30bb61732033894$var$i = 0; $a30bb61732033894$var$i < $a30bb61732033894$var$diacritics.length; $a30bb61732033894$var$i++){
    var $a30bb61732033894$var$diacritic = $a30bb61732033894$var$diacritics[$a30bb61732033894$var$i];
    for(var $a30bb61732033894$var$j = 0; $a30bb61732033894$var$j < $a30bb61732033894$var$diacritic.letters.length; $a30bb61732033894$var$j++)$a30bb61732033894$var$diacriticToBase[$a30bb61732033894$var$diacritic.letters[$a30bb61732033894$var$j]] = $a30bb61732033894$var$diacritic.base;
}
var $a30bb61732033894$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($a30bb61732033894$var$anyDiacritic, function(match) {
        return $a30bb61732033894$var$diacriticToBase[match];
    });
};


function $a2fc291a9a0429c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a2fc291a9a0429c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a2fc291a9a0429c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a2fc291a9a0429c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a2fc291a9a0429c3$var$memoizedStripDiacriticsForInput = (0, $jk22o.default)((0, $a30bb61732033894$export$b5bee4b27048330b));
var $a2fc291a9a0429c3$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $a2fc291a9a0429c3$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $a2fc291a9a0429c3$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $a2fc291a9a0429c3$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $a2fc291a9a0429c3$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $a2fc291a9a0429c3$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $a2fc291a9a0429c3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $a2fc291a9a0429c3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $a30bb61732033894$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};


/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $b4178fea5da33aed$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $b4178fea5da33aed$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($b4178fea5da33aed$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}



var $41YNz = parcelRequire("41YNz");
var $1cf65e5298eb3ddb$export$33f062f47f21a01 = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && value !== null) return [
        value
    ];
    return [];
};


function $02e5ea115c030570$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}


function $71f5145de4e5fa36$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}



function $b6cda712ff931d3e$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $1b77518667867a93$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* required-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $7lEDz = parcelRequire("7lEDz");

var $98fed3003f5d3296$var$styles = null;
var $98fed3003f5d3296$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $acw62.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $7lEDz.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $232d11f435326a2b$export$2e2bcd8739ae039)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98fed3003f5d3296$export$2e2bcd8739ae039 = $98fed3003f5d3296$var$RequiredInput;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// ==============================
// Passive Event Detector
// ==============================

var $7e4733be18128c9a$var$noop = (0, $232d11f435326a2b$export$2e2bcd8739ae039);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $7e4733be18128c9a$var$passiveOptionAccessed = false;
var $7e4733be18128c9a$var$options = {
    get passive () {
        return $7e4733be18128c9a$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $7e4733be18128c9a$var$w = typeof window !== "undefined" ? window : {};
if ($7e4733be18128c9a$var$w.addEventListener && $7e4733be18128c9a$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $7e4733be18128c9a$var$w.addEventListener("p", $7e4733be18128c9a$var$noop, $7e4733be18128c9a$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $7e4733be18128c9a$var$w.removeEventListener("p", $7e4733be18128c9a$var$noop, false);
}
var $7e4733be18128c9a$export$b0622a6911dbeaf5 = $7e4733be18128c9a$var$passiveOptionAccessed;


var $0792034e4bc12f14$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $0792034e4bc12f14$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $0792034e4bc12f14$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $7e4733be18128c9a$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("wheel", onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("touchstart", onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("wheel", onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("touchstart", onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $acw62 = parcelRequire("acw62");
var $04e4a927ce7e9554$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $04e4a927ce7e9554$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $04e4a927ce7e9554$var$preventTouchMove(e) {
    e.preventDefault();
}
function $04e4a927ce7e9554$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $04e4a927ce7e9554$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $04e4a927ce7e9554$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $04e4a927ce7e9554$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $04e4a927ce7e9554$var$activeScrollLocks = 0;
var $04e4a927ce7e9554$var$listenerOptions = {
    capture: false,
    passive: false
};
function $04e4a927ce7e9554$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$04e4a927ce7e9554$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $04e4a927ce7e9554$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $04e4a927ce7e9554$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($04e4a927ce7e9554$var$LOCK_STYLES).forEach(function(key) {
                var val = $04e4a927ce7e9554$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $04e4a927ce7e9554$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener("touchmove", $04e4a927ce7e9554$var$preventTouchMove, $04e4a927ce7e9554$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener("touchstart", $04e4a927ce7e9554$var$preventInertiaScroll, $04e4a927ce7e9554$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener("touchmove", $04e4a927ce7e9554$var$allowTouchMove, $04e4a927ce7e9554$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $04e4a927ce7e9554$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$04e4a927ce7e9554$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $04e4a927ce7e9554$var$activeScrollLocks = Math.max($04e4a927ce7e9554$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $04e4a927ce7e9554$var$activeScrollLocks < 1) $04e4a927ce7e9554$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $04e4a927ce7e9554$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener("touchmove", $04e4a927ce7e9554$var$preventTouchMove, $04e4a927ce7e9554$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener("touchstart", $04e4a927ce7e9554$var$preventInertiaScroll, $04e4a927ce7e9554$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener("touchmove", $04e4a927ce7e9554$var$allowTouchMove, $04e4a927ce7e9554$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $faf926a6d7c1837b$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $faf926a6d7c1837b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $0792034e4bc12f14$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $04e4a927ce7e9554$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: $faf926a6d7c1837b$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: "fixed",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



function $c27b1a9ab4e384ae$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $02e5ea115c030570$export$d8a62a489b442872)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}


function $f8042cebe65b2096$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}


function $0edee4b91306a919$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}


function $7a199f77e9432b63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a199f77e9432b63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a199f77e9432b63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a199f77e9432b63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7a199f77e9432b63$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $7a199f77e9432b63$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $7a199f77e9432b63$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7a199f77e9432b63$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7a199f77e9432b63$var$noop = (0, $232d11f435326a2b$export$2e2bcd8739ae039);
function $7a199f77e9432b63$var$notNullish(item) {
    return item != null;
}
function $7a199f77e9432b63$var$scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $c27b1a9ab4e384ae$export$3f99968195accfaf)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $c27b1a9ab4e384ae$export$3f99968195accfaf)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $7a199f77e9432b63$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused) {
        return false;
    }
}
function $7a199f77e9432b63$var$isTouchCapable() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (_unused2) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var $7a199f77e9432b63$var$filterUnsupportedSelectors = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ":",
        // pseudo-classes/elements
        "[",
        // attribute selectors
        ">",
        // child combinator
        "+",
        // adjacent sibling combinator
        "~",
        // general sibling combinator
        " ",
        // descendant combinator
        "*",
        // universal selector
        "#",
        // ID selector
        ".",
        // class selector
        "@",
        // at-rules
        "&",
        // parent selector
        "|",
        // namespace separator
        "^",
        // starts with
        "$",
        // ends with
        "=" // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var $7a199f77e9432b63$var$elemBeforeCSS = null;
var $7a199f77e9432b63$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $7a199f77e9432b63$var$isTouchCapable(),
    captureMenuScroll: !$7a199f77e9432b63$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $a2fc291a9a0429c3$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $785c9998908c36ff$export$f4da216a6ca54656),
    getOptionLabel: (0, $785c9998908c36ff$export$dac6ace3020563ca),
    getOptionValue: (0, $785c9998908c36ff$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $785c9998908c36ff$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$7a199f77e9432b63$var$isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $7a199f77e9432b63$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $7a199f77e9432b63$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $7a199f77e9432b63$var$_isOptionSelected(props, option, selectValue);
    var label = $7a199f77e9432b63$var$getOptionLabel(props, option);
    var value = $7a199f77e9432b63$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $7a199f77e9432b63$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $7a199f77e9432b63$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $7a199f77e9432b63$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $7a199f77e9432b63$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $7a199f77e9432b63$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($7a199f77e9432b63$var$notNullish);
}
function $7a199f77e9432b63$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $7a199f77e9432b63$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $7a199f77e9432b63$var$buildFocusableOptions(props, selectValue) {
    return $7a199f77e9432b63$var$buildFocusableOptionsFromCategorizedOptions($7a199f77e9432b63$var$buildCategorizedOptions(props, selectValue));
}
function $7a199f77e9432b63$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$7a199f77e9432b63$var$shouldHideSelectedOptions(props) || !isSelected) && $7a199f77e9432b63$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $7a199f77e9432b63$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $7a199f77e9432b63$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $7a199f77e9432b63$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $7a199f77e9432b63$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $7a199f77e9432b63$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $7a199f77e9432b63$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $7a199f77e9432b63$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $7a199f77e9432b63$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $7a199f77e9432b63$var$getOptionValue(props, i) === candidate;
    });
}
function $7a199f77e9432b63$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $7a199f77e9432b63$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $7a199f77e9432b63$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $7a199f77e9432b63$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Select);
        _this = $7a199f77e9432b63$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $ltooA.fg)("platform_do_not_clear_input_for_multiselect")) _this.onInputChange(inputValue, {
                action: "set-value",
                prevInputValue: inputValue
            });
            else _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $71f5145de4e5fa36$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $71f5145de4e5fa36$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $f8042cebe65b2096$export$dea4763e29237f4c)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $f8042cebe65b2096$export$dea4763e29237f4c)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $0edee4b91306a919$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $0edee4b91306a919$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $0edee4b91306a919$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $7a199f77e9432b63$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusableOptionsWithIds", function() {
            return $7a199f77e9432b63$var$buildFocusableOptionsWithIds($7a199f77e9432b63$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $b4178fea5da33aed$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getOptionLabel", function(data) {
            return $7a199f77e9432b63$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getOptionValue", function(data) {
            return $7a199f77e9432b63$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getStyles", function(key, props) {
            var base = {
                boxSizing: "border-box"
            };
            var custom = _this.props.styles[key];
            if (custom) return $7a199f77e9432b63$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getComponents", function() {
            return (0, $12c86ed757820ce3$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "buildCategorizedOptions", function() {
            return $7a199f77e9432b63$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "buildFocusableOptions", function() {
            return $7a199f77e9432b63$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $7a199f77e9432b63$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest("[data-rbd-draggable-context-id]"))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $02e5ea115c030570$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            if ((0, $ltooA.fg)("platform_dst_select_menu_close_on_blur")) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "shouldHideSelectedOptions", function() {
            return $7a199f77e9432b63$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$7a199f77e9432b63$var$instanceId);
        _this.state.selectValue = (0, $1cf65e5298eb3ddb$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $7a199f77e9432b63$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $7a199f77e9432b63$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    $7a199f77e9432b63$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $0ef728659bef6f62$export$95df08bae54cb4df)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute("aria-label", inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props["aria-label"] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute("aria-label", normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute("aria-label");
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "options" in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId("selected-value"), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $7a199f77e9432b63$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $7a199f77e9432b63$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $7a199f77e9432b63$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this$props$component;
                if (typeof this.props.formatOptionLabel === "function") {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === "menu" && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            className: (0, $7lEDz.default)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ])
                        }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label));
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props["aria-describedby"] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? "" : this.getElementId("single-value") : this.getElementId("placeholder");
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    "aria-describedby": baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId("multi-message");
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    "aria-describedby": describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchstart", this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchmove", this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({}, !this.props.isSearchable && (0, $ltooA.fg)("platform_fix_autocomplete_aria_for_select") ? {} : {
                    "aria-autocomplete": "both"
                }), {}, {
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-expanded": menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    "aria-haspopup": this.props["UNSAFE_is_experimental_generic"] ? "dialog" : "listbox",
                    "aria-invalid": this.props["aria-invalid"] || isInvalid,
                    "aria-label": this.props["aria-label"] || label,
                    "aria-labelledby": this.props["aria-labelledby"] || labelId,
                    "aria-required": required || isRequired,
                    role: "combobox",
                    "aria-activedescendant": this.props["UNSAFE_is_experimental_generic"] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && !(0, $ltooA.fg)("select_issearchable_aria-readonly_fix") && {
                    "aria-readonly": true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1c7e980b63bf8415$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: $7a199f77e9432b63$var$noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $7a199f77e9432b63$var$_objectSpread({
                        id: this.getElementId("placeholder")
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            "data-testid": "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId("selected-value"), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({}, testId && {
                            "data-testid": "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId("selected-value"), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId("single-value")
                    }
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $7a199f77e9432b63$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    "data-testid": "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === "compact";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === "compact";
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === "compact";
                var innerProps = $7a199f77e9432b63$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                }, testId && {
                    "data-testid": "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId("option"), "-").concat(id);
                    var innerProps = $7a199f77e9432b63$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props["UNSAFE_is_experimental_generic"] ? "listitem" : "option",
                        "aria-selected": _this6.props["UNSAFE_is_experimental_generic"] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        "aria-disabled": !isDisabled ? undefined : isDisabled,
                        "aria-describedby": headingId
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === "group") {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId("group"), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $7a199f77e9432b63$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    "data-testid": "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === "option") return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                        innerProps: $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({}, this.props["UNSAFE_is_experimental_generic"] && {
                            role: "listitem"
                        }), testId && {
                            "data-testid": "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c59fa8a23ca7387a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $7a199f77e9432b63$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId("listbox") : undefined
                        }, testId && {
                            "data-testid": "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $faf926a6d7c1837b$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({
                                role: _this6.props["UNSAFE_is_experimental_generic"] ? "dialog" : "listbox"
                            }, _this6.props["UNSAFE_is_experimental_generic"] && {
                                "aria-labelledby": ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId("input")
                            }), {}, {
                                "aria-multiselectable": !commonProps.isMulti || _this6.props["UNSAFE_is_experimental_generic"] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId("listbox")
                            }, testId && {
                                "data-testid": "".concat(testId, "-select--listbox")
                            }), (0, $0ef728659bef6f62$export$95df08bae54cb4df)() && !_this6.props["UNSAFE_is_experimental_generic"] && {
                                "aria-describedby": ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId("input")
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props["UNSAFE_is_experimental_generic"] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $98fed3003f5d3296$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6560198ebe2f4515$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? "Use left or right arrow keys to navigate selected items" : "");
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    id: this.getElementId("multi-message"),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? "default" : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? "default" : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === "compact";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $7a199f77e9432b63$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        "data-testid": testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $7a199f77e9432b63$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({}, testId && {
                        "data-testid": "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $0ef728659bef6f62$export$e1865c3bedcd822b)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: "application"
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $7a199f77e9432b63$var$_objectSpread({}, testId && {
                        "data-testid": "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b6cda712ff931d3e$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $1cf65e5298eb3ddb$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $7a199f77e9432b63$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $7a199f77e9432b63$var$buildFocusableOptionsWithIds($7a199f77e9432b63$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $7a199f77e9432b63$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $7a199f77e9432b63$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $7a199f77e9432b63$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $0edee4b91306a919$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return $7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread($7a199f77e9432b63$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $acw62.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($7a199f77e9432b63$export$2e2bcd8739ae039, "defaultProps", $7a199f77e9432b63$export$9c21a3269931e1e6);



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $15feef2fef8b1277$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $15feef2fef8b1277$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15feef2fef8b1277$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15feef2fef8b1277$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15feef2fef8b1277$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $15feef2fef8b1277$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === "string") return newValue;
    }
    return inputValue;
}
function $15feef2fef8b1277$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $15feef2fef8b1277$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $acw62.useRef)(undefined);
    var mounted = (0, $acw62.useRef)(false);
    var _useState = (0, $acw62.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $acw62.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $acw62.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $acw62.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $acw62.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $acw62.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $acw62.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $acw62.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $acw62.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $acw62.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $acw62.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $acw62.useCallback)(function(newValue, actionMeta) {
        var inputValue = $15feef2fef8b1277$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $15feef2fef8b1277$var$_objectSpread($15feef2fef8b1277$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $15feef2fef8b1277$var$_objectSpread($15feef2fef8b1277$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $380c4e557cfffd9a$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $380c4e557cfffd9a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $380c4e557cfffd9a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $380c4e557cfffd9a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $380c4e557cfffd9a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $380c4e557cfffd9a$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $380c4e557cfffd9a$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $380c4e557cfffd9a$var$_objectSpread($380c4e557cfffd9a$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $ef87bf2a6c8c135a$var$AsyncSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $15feef2fef8b1277$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $380c4e557cfffd9a$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a199f77e9432b63$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ef87bf2a6c8c135a$export$2e2bcd8739ae039 = $ef87bf2a6c8c135a$var$AsyncSelect;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $0294184334c47879$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $0294184334c47879$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? "default" : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $0294184334c47879$var$_excluded);
        var internalSelectRef = (0, $acw62.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $acw62.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === "error"
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = "AtlaskitSelect";
    return AtlaskitSelect;
}


var $6e237539ccf81b49$var$packageName = "@atlaskit/select";
var $6e237539ccf81b49$var$packageVersion = "0.0.0-development";
var $6e237539ccf81b49$export$d1de3b251ccaa8a3 = (0, $0294184334c47879$export$2e2bcd8739ae039)((0, $ef87bf2a6c8c135a$export$2e2bcd8739ae039));
var $6e237539ccf81b49$var$createAndFireEventOnAtlaskit = (0, $06090553fb829f48$export$2e2bcd8739ae039)("atlaskit");
var $6e237539ccf81b49$var$Select = (0, $a81201919ffed32b$export$2e2bcd8739ae039)({
    componentName: "select",
    packageName: $6e237539ccf81b49$var$packageName,
    packageVersion: $6e237539ccf81b49$var$packageVersion
})((0, $2fca11379f299e8e$export$2e2bcd8739ae039)({
    onChange: $6e237539ccf81b49$var$createAndFireEventOnAtlaskit({
        action: "changed",
        actionSubject: "option",
        attributes: {
            componentName: "select",
            packageName: $6e237539ccf81b49$var$packageName,
            packageVersion: $6e237539ccf81b49$var$packageVersion
        }
    })
})($6e237539ccf81b49$export$d1de3b251ccaa8a3));
var $6e237539ccf81b49$export$2e2bcd8739ae039 = $6e237539ccf81b49$var$Select;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $acw62 = parcelRequire("acw62");
var $e58c24303611723d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $e58c24303611723d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($e58c24303611723d$export$1ca2a26fecb070ae);
};
$e58c24303611723d$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $gyDKM = parcelRequire("gyDKM");
var $9eb3c88bed22478e$export$4ef52930e33717cd = "data-theme";
var $9eb3c88bed22478e$export$cb374d25ded7f6ab = "data-subtree-theme";
var $9eb3c88bed22478e$export$a00eac3f8684bcd0 = "data-color-mode";
var $9eb3c88bed22478e$export$2112803007239c61 = "data-contrast-mode";
var $9eb3c88bed22478e$export$352e418ed5b6193a = "data-custom-theme";
var $9eb3c88bed22478e$export$6f0c6fb8c80fcc92 = "ds";
var $9eb3c88bed22478e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $9eb3c88bed22478e$export$dddac1532e822863 = "--".concat($9eb3c88bed22478e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $9eb3c88bed22478e$export$9d7b58831ae93caa = "--".concat($9eb3c88bed22478e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $867c6858db3b2acc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $867c6858db3b2acc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $867c6858db3b2acc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $867c6858db3b2acc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $867c6858db3b2acc$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $867c6858db3b2acc$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $867c6858db3b2acc$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $867c6858db3b2acc$export$632685d741f3dbbf = $867c6858db3b2acc$var$_objectSpread($867c6858db3b2acc$var$_objectSpread({}, $867c6858db3b2acc$export$958d0ae7f2977ae4), $867c6858db3b2acc$export$d2dc61f58390201c);
var $867c6858db3b2acc$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $867c6858db3b2acc$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $867c6858db3b2acc$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $867c6858db3b2acc$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $867c6858db3b2acc$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $867c6858db3b2acc$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.subtler": "var(--ds-background-danger-subtler, #FFBDAD)",
    "color.background.danger.subtler.hovered": "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    "color.background.danger.subtler.pressed": "var(--ds-background-danger-subtler-pressed, #FF7452)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.subtler": "var(--ds-background-warning-subtler, #FFF0B3)",
    "color.background.warning.subtler.hovered": "var(--ds-background-warning-subtler-hovered, #FFE380)",
    "color.background.warning.subtler.pressed": "var(--ds-background-warning-subtler-pressed, #FFC400)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.subtler": "var(--ds-background-success-subtler, #ABF5D1)",
    "color.background.success.subtler.hovered": "var(--ds-background-success-subtler-hovered, #79F2C0)",
    "color.background.success.subtler.pressed": "var(--ds-background-success-subtler-pressed, #57D9A3)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.subtler": "var(--ds-background-discovery-subtler, #C0B6F2)",
    "color.background.discovery.subtler.hovered": "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    "color.background.discovery.subtler.pressed": "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.subtler": "var(--ds-background-information-subtler, #B3D4FF)",
    "color.background.information.subtler.hovered": "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    "color.background.information.subtler.pressed": "var(--ds-background-information-subtler-pressed, #2684FF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $867c6858db3b2acc$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.danger.bolder": "var(--ds-text-danger-bolder, #BF2600)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.warning.bolder": "var(--ds-text-warning-bolder, #974F0C)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.success.bolder": "var(--ds-text-success-bolder, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.discovery.bolder": "var(--ds-text-discovery-bolder, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.information.bolder": "var(--ds-text-information-bolder, #0747A6)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $867c6858db3b2acc$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $867c6858db3b2acc$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $867c6858db3b2acc$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.selected": "var(--ds-border-width-selected, 2px)",
    "border.width.focused": "var(--ds-border-width-focused, 2px)"
};
var $867c6858db3b2acc$export$3c0a6c3e64bb180d = {
    "radius.xsmall": "var(--ds-radius-xsmall, 2px)",
    "radius.small": "var(--ds-radius-small, 3px)",
    "radius.medium": "var(--ds-radius-medium, 6px)",
    "radius.large": "var(--ds-radius-large, 8px)",
    "radius.xlarge": "var(--ds-radius-xlarge, 12px)",
    "radius.xxlarge": "var(--ds-radius-xxlarge, 16px)",
    "radius.full": "var(--ds-radius-full, 9999px)",
    "radius.tile": "var(--ds-radius-tile, 25%)"
};
var $867c6858db3b2acc$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 653 20px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 653 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 653 32px/36px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 653 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $867c6858db3b2acc$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 653)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $867c6858db3b2acc$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $867c6858db3b2acc$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $867c6858db3b2acc$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $867c6858db3b2acc$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $867c6858db3b2acc$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $867c6858db3b2acc$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $gyDKM.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $867c6858db3b2acc$export$e615f061ca585a6c = $867c6858db3b2acc$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $867c6858db3b2acc$export$ca0f9c2de39ffed7(spacingProperty, $867c6858db3b2acc$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $867c6858db3b2acc$export$bf46c3f9eeafc71f = $867c6858db3b2acc$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $867c6858db3b2acc$export$ca0f9c2de39ffed7(spacingProperty, $867c6858db3b2acc$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $867c6858db3b2acc$export$e7af83bafe7f9e63 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("backgroundColor", $867c6858db3b2acc$export$d1d79bf68ac056bd);
var $867c6858db3b2acc$export$3a1bcba60b23d7f0 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("color", $867c6858db3b2acc$export$8473307aa00d6ea1);
var $867c6858db3b2acc$export$45f3f4fe16f9f7d5 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("fontWeight", $867c6858db3b2acc$export$303e322c6b1ed114);
var $867c6858db3b2acc$export$68cc305da27dbaa4 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("fontFamily", $867c6858db3b2acc$export$3c7e9587132614b4);
var $867c6858db3b2acc$export$128f10c238242f83 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("font", $867c6858db3b2acc$export$6ffa317d5e70375);
var $867c6858db3b2acc$export$219d364c0da35ae4 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("font", $867c6858db3b2acc$export$236bfe3a33ef1292);
var $867c6858db3b2acc$export$38845ca010b93505 = $867c6858db3b2acc$export$ca0f9c2de39ffed7("fontWeight", $867c6858db3b2acc$export$855cfd311192d666);
var $867c6858db3b2acc$export$ff257d957d48c421 = $867c6858db3b2acc$export$ca0f9c2de39ffed7((0, $9eb3c88bed22478e$export$9d7b58831ae93caa), $867c6858db3b2acc$export$41a358c9c2356760);
var $867c6858db3b2acc$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $867c6858db3b2acc$export$41a358c9c2356760[color] !== undefined;
};
var $867c6858db3b2acc$export$7001ce64d9ff7c7f = $867c6858db3b2acc$export$ca0f9c2de39ffed7("font", $867c6858db3b2acc$export$b805719bc8cb376);



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $gyDKM = parcelRequire("gyDKM");


var $hPtJY = parcelRequire("hPtJY");
function $2ab8ad6407bb0250$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2ab8ad6407bb0250$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2ab8ad6407bb0250$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2ab8ad6407bb0250$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2ab8ad6407bb0250$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2ab8ad6407bb0250$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $2ab8ad6407bb0250$export$9a199fbafee0014e = {
    backgroundColor: (0, $867c6858db3b2acc$export$d1d79bf68ac056bd),
    blockSize: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderBottomColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderLeftColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $867c6858db3b2acc$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    borderWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    bottom: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    boxShadow: (0, $867c6858db3b2acc$export$7aff6e7ba39bb774),
    color: (0, $867c6858db3b2acc$export$8473307aa00d6ea1),
    columnGap: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    font: (0, $867c6858db3b2acc$export$6ffa317d5e70375),
    fontFamily: (0, $867c6858db3b2acc$export$3c7e9587132614b4),
    fontWeight: (0, $867c6858db3b2acc$export$303e322c6b1ed114),
    gap: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    height: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    inlineSize: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    inset: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    insetBlock: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    insetBlockEnd: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    insetBlockStart: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    insetInline: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    insetInlineEnd: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    insetInlineStart: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    left: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    margin: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginBlock: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginBlockEnd: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginBlockStart: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginBottom: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginInline: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginInlineEnd: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginInlineStart: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginLeft: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginRight: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    marginTop: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    maxBlockSize: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    maxHeight: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    maxWidth: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    minBlockSize: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    minHeight: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    minInlineSize: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    minWidth: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    opacity: (0, $867c6858db3b2acc$export$daf94a976c798b4f),
    outlineColor: (0, $867c6858db3b2acc$export$1531ad5bb3fbedac),
    outlineOffset: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    outlineWidth: (0, $867c6858db3b2acc$export$e1b83c5210c471b8),
    padding: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingBlock: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingBottom: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingInline: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingLeft: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingRight: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    paddingTop: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    right: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    rowGap: (0, $867c6858db3b2acc$export$958d0ae7f2977ae4),
    top: (0, $867c6858db3b2acc$export$632685d741f3dbbf),
    width: (0, $867c6858db3b2acc$export$6ccdbebca2ee545f),
    zIndex: (0, $867c6858db3b2acc$export$b5f31a7e431d2eab)
};
var $2ab8ad6407bb0250$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $2ab8ad6407bb0250$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $2ab8ad6407bb0250$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $2ab8ad6407bb0250$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $2ab8ad6407bb0250$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($2ab8ad6407bb0250$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $2ab8ad6407bb0250$var$safeSelectors.test(key)) {
            styleObj[key] = $2ab8ad6407bb0250$var$_transformStyles(value);
            return;
        }
        if ($2ab8ad6407bb0250$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($2ab8ad6407bb0250$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $2ab8ad6407bb0250$export$9a199fbafee0014e)) return;
        var tokenValue = $2ab8ad6407bb0250$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $2ab8ad6407bb0250$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $2ab8ad6407bb0250$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $2ab8ad6407bb0250$var$uniqueSymbol, (0, $gyDKM.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $2ab8ad6407bb0250$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $2ab8ad6407bb0250$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $2ab8ad6407bb0250$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$2ab8ad6407bb0250$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $2ab8ad6407bb0250$export$f6c783d06584602c(style) {
    return $2ab8ad6407bb0250$var$baseXcss(style);
}


var $eecdcb0465c62051$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $eecdcb0465c62051$var$_excluded2 = [
    "className"
];
var $eecdcb0465c62051$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $eecdcb0465c62051$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $eecdcb0465c62051$var$_excluded2);
    var resolvedStyles = (0, $2ab8ad6407bb0250$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $gyDKM.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $eecdcb0465c62051$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $867c6858db3b2acc$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $867c6858db3b2acc$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $867c6858db3b2acc$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $867c6858db3b2acc$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $867c6858db3b2acc$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $867c6858db3b2acc$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $867c6858db3b2acc$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $867c6858db3b2acc$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $867c6858db3b2acc$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $867c6858db3b2acc$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $gyDKM.jsx)((0, $e58c24303611723d$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $eecdcb0465c62051$export$2e2bcd8739ae039 = $eecdcb0465c62051$export$e71c4d32a2263218;
var $eecdcb0465c62051$var$baseStyles = (0, $gyDKM.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-sort
 */ var $348c386a380b46b1$var$baseResetStyles = (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
    display: "table-cell",
    verticalAlign: "middle",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":first-of-type": {
        paddingInlineStart: "space.100"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":last-of-type": {
        paddingInlineEnd: "space.100"
    }
});
var $348c386a380b46b1$var$alignMapStyles = {
    text: (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
        textAlign: "left"
    }),
    icon: (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
        textAlign: "center"
    }),
    number: (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
        textAlign: "right"
    })
};
var $348c386a380b46b1$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, as = _ref.as, children = _ref.children, _ref$align = _ref.align, align = _ref$align === void 0 ? "text" : _ref$align, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? "space.100" : _ref$paddingBlock, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? "space.100" : _ref$paddingInline, backgroundColor = _ref.backgroundColor, scope = _ref.scope, width = _ref.width, xcss = _ref.xcss, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan, rowSpan = _ref.rowSpan;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = Array.isArray(xcss) ? xcss : [
        xcss
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eecdcb0465c62051$export$2e2bcd8739ae039), {
        xcss: [
            $348c386a380b46b1$var$baseResetStyles,
            $348c386a380b46b1$var$alignMapStyles[align]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(styles)),
        ref: ref,
        scope: scope,
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        testId: testId,
        style: width ? {
            width: width
        } : undefined,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        rowSpan: rowSpan
    }, children);
});


var $6ddc7161cee40b98$var$_excluded = [
    "testId"
];
var $6ddc7161cee40b98$export$9cf5b401f969f5e3 = function TD(_ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $6ddc7161cee40b98$var$_excluded);
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $348c386a380b46b1$export$41ad0bbfa4755cac), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "td",
        testId: testId
    }, props)));
};


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
var $3ab6f817b06011f9$export$2a909d4c080cb420 = {
    checked: [],
    allChecked: false,
    anyChecked: false,
    maxChecked: 0,
    selectionStart: -1,
    previousSelection: []
};
var $3ab6f817b06011f9$var$arrayFromRange = function arrayFromRange(from, to) {
    var startIdx = from;
    var stopIdx = to;
    var increment = 1;
    if (from > to) {
        startIdx = to;
        stopIdx = from;
        increment = 0;
    }
    // Create an array with values between `from` and `to` - either ascending or descending
    return Array.from({
        length: stopIdx - startIdx
    }, function(_, i) {
        return startIdx + i + increment;
    });
};
function $3ab6f817b06011f9$var$reducer(_ref, action) {
    var checked = _ref.checked, anyChecked = _ref.anyChecked, maxChecked = _ref.maxChecked, selectionStart = _ref.selectionStart, previousSelection = _ref.previousSelection;
    switch(action.type){
        case "toggle_selection":
            var _action$value = action.value, id = _action$value.id, shiftHeld = _action$value.shiftHeld;
            var updated = checked.slice();
            var newSelectionStart = selectionStart;
            var newPreviousSelection = previousSelection.slice();
            if (shiftHeld) {
                if (checked.length > 0) {
                    var newIds = $3ab6f817b06011f9$var$arrayFromRange(selectionStart, id); // create an array of the new ids
                    // Uncheck ids from the previous selection.
                    // This is done to maintain consistency with Shift-select behaviour elsewhere (e.g. macOS)
                    // TODO: Code could be improved to only remove ids that are not included in the new range, avoiding needing to re-add them below
                    updated = updated.filter(function(id) {
                        return !previousSelection.includes(id);
                    });
                    newIds.forEach(function(id) {
                        return updated.indexOf(id) === -1 && updated.push(id);
                    } // If the new id is not already checked, check it
                    );
                    newPreviousSelection = newIds; // Maintain an array of the previous selection to allow for consistent Shift-select behaviour
                }
            } else {
                var checkedIndex = checked.indexOf(id); // is index already checked
                if (checkedIndex !== -1) updated.splice(checkedIndex, 1); // if index is already checked, uncheck
                else updated.push(id); // if index is not checked, check
                newSelectionStart = id; // Reset selection start id to this non-shift-selected id
                newPreviousSelection = []; // Reset previous selection as it is no longer relevant once a new non-shift-selected id is added
            }
            var _anyChecked = updated.length > 0;
            return {
                checked: updated,
                allChecked: updated.length === maxChecked,
                anyChecked: _anyChecked || Boolean(updated[id]),
                maxChecked: maxChecked,
                selectionStart: newSelectionStart,
                previousSelection: newPreviousSelection
            };
        case "set_root":
            return {
                checked: action.value ? Array.from(Array(maxChecked).keys()) : [],
                allChecked: action.value,
                anyChecked: Boolean(action.value),
                maxChecked: maxChecked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        case "set_max":
            var max = action.value;
            return {
                maxChecked: max,
                allChecked: checked.length === max,
                anyChecked: anyChecked,
                checked: checked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        default:
            throw new Error();
    }
}
function $3ab6f817b06011f9$var$useSelectable() {
    var _useReducer = (0, $acw62.useReducer)($3ab6f817b06011f9$var$reducer, $3ab6f817b06011f9$export$2a909d4c080cb420), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var toggleSelection = (0, $acw62.useCallback)(function(id, shiftHeld) {
        dispatch({
            type: "toggle_selection",
            value: {
                id: id,
                shiftHeld: shiftHeld
            }
        });
    }, []);
    var setAll = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "set_root",
            value: true
        });
    }, []);
    var removeAll = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "set_root",
            value: false
        });
    }, []);
    var setMax = (0, $acw62.useCallback)(function(max) {
        dispatch({
            type: "set_max",
            value: max
        });
    }, []);
    return [
        state,
        {
            setAll: setAll,
            removeAll: removeAll,
            toggleSelection: toggleSelection,
            setMax: setMax
        }
    ];
}
var $3ab6f817b06011f9$export$2e2bcd8739ae039 = $3ab6f817b06011f9$var$useSelectable;


var $911884466be6b320$var$SelectionContext = /*#__PURE__*/ (0, $acw62.createContext)([
    (0, $3ab6f817b06011f9$export$2a909d4c080cb420),
    {}
]);
/**
 * __Selection provider__
 *
 * A selection provider injects selection specific state into the table.
 */ var $911884466be6b320$var$SelectionProvider = function SelectionProvider(_ref) {
    var children = _ref.children;
    var reducer = (0, $3ab6f817b06011f9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($911884466be6b320$var$SelectionContext.Provider, {
        value: reducer
    }, children);
};
var $911884466be6b320$export$a97c3cc4bf1da1ca = function useSelection() {
    return (0, $acw62.useContext)($911884466be6b320$var$SelectionContext);
};
var $911884466be6b320$export$2e2bcd8739ae039 = $911884466be6b320$var$SelectionProvider;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
var $40ff4dfdcb8275fc$export$21ebc1ba2b2bee67 = function useSorting(sortKey) {
    var _useState = (0, $acw62.useState)(sortKey), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), localSortKey = _useState2[0], setLocalSortKey = _useState2[1];
    var _useState3 = (0, $acw62.useState)(), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), localSortDirection = _useState4[0], setLocalSortDirection = _useState4[1];
    var toggleSortDirection = (0, $acw62.useCallback)(function() {
        setLocalSortDirection(function(oldLocalSortDirection) {
            switch(oldLocalSortDirection){
                case undefined:
                    return "ascending";
                case "ascending":
                    return "descending";
                case "descending":
                    return "ascending";
            }
        });
    }, []);
    var setSortState = (0, $acw62.useCallback)(function(key) {
        setLocalSortKey(function(localSortKey) {
            if (key !== localSortKey) {
                // sorting by different column
                setLocalSortDirection("ascending");
                return key;
            } else toggleSortDirection();
            return localSortKey;
        });
    }, [
        toggleSortDirection
    ]);
    var sortFn = (0, $acw62.useCallback)(function(rowA, rowB) {
        if (localSortKey === "unset") return 0;
        var ascendingComparator = rowA[localSortKey] < rowB[localSortKey] ? -1 : 1;
        return localSortDirection === "ascending" ? ascendingComparator : -ascendingComparator;
    }, [
        localSortDirection,
        localSortKey
    ]);
    return {
        sortKey: localSortKey,
        sortDirection: localSortDirection,
        setSortState: setSortState,
        sortFn: sortFn
    };
};



var $acw62 = parcelRequire("acw62");
/**
 * An empty function which does nothing.
 */ function $c8a80735269f0b5d$export$2e2bcd8739ae039() {}


function $c1b417307b620f74$var$generateContext() {
    return /*#__PURE__*/ (0, $acw62.createContext)({
        isSelectable: false,
        sortKey: "unset",
        setSortState: (0, $c8a80735269f0b5d$export$2e2bcd8739ae039),
        sortFn: function sortFn() {
            return 0;
        }
    });
}
var $c1b417307b620f74$var$TableContext = $c1b417307b620f74$var$generateContext();
function $c1b417307b620f74$export$d542ac353845c9cf(_ref) {
    var children = _ref.children, state = _ref.state;
    return(/*#__PURE__*/ // @ts-expect-error
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c1b417307b620f74$var$TableContext.Provider, {
        value: state
    }, children));
}
var $c1b417307b620f74$export$25bceaac3c7e4dc7 = function useTable() {
    return(// @ts-expect-error
    (0, $acw62.useContext)($c1b417307b620f74$var$TableContext));
};



var $acw62 = parcelRequire("acw62");
var $f5d450fa5a028806$export$54ec01a60f47d33d = function Table(_ref) {
    var children = _ref.children, testId = _ref.testId, summary = _ref.summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": testId
    }, summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", null, summary), children);
};


/**
 * __Table__
 *
 * A data table is used to display dynamic data.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ function $33b867bab2bb82ec$var$Table(_ref) {
    var children = _ref.children, isSelectable = _ref.isSelectable, _ref$sortKey = _ref.sortKey, sortKey = _ref$sortKey === void 0 ? "unset" : _ref$sortKey, testId = _ref.testId;
    var _useSorting = (0, $40ff4dfdcb8275fc$export$21ebc1ba2b2bee67)(sortKey), localSortKey = _useSorting.sortKey, sortDirection = _useSorting.sortDirection, setSortState = _useSorting.setSortState, sortFn = _useSorting.sortFn;
    var tableProviderState = (0, $acw62.useMemo)(function() {
        return {
            isSelectable: isSelectable,
            sortKey: localSortKey,
            sortDirection: sortDirection,
            setSortState: setSortState,
            sortFn: sortFn
        };
    }, [
        isSelectable,
        localSortKey,
        setSortState,
        sortDirection,
        sortFn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c1b417307b620f74$export$d542ac353845c9cf), {
        state: tableProviderState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5d450fa5a028806$export$54ec01a60f47d33d), {
        testId: testId
    }, isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $911884466be6b320$export$2e2bcd8739ae039), null, children) : children));
}
var $33b867bab2bb82ec$export$2e2bcd8739ae039 = $33b867bab2bb82ec$var$Table;


var $acw62 = parcelRequire("acw62");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");

var $bv4qN = parcelRequire("bv4qN");

var $acw62 = parcelRequire("acw62");
var $62b74ba96e8c9a7e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $62b74ba96e8c9a7e$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($62b74ba96e8c9a7e$var$HasTextAncestorContext);
};
var $62b74ba96e8c9a7e$export$ae933c6cbe5643ad = $62b74ba96e8c9a7e$var$HasTextAncestorContext.Provider;




var $8de685929e29da5d$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $8de685929e29da5d$var$resetStyles = (0, $gyDKM.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $8de685929e29da5d$var$strongStyles = (0, $gyDKM.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $8de685929e29da5d$var$emStyles = (0, $gyDKM.css)({
    fontStyle: "italic"
});
var $8de685929e29da5d$var$textAlignMap = {
    center: (0, $gyDKM.css)({
        textAlign: "center"
    }),
    end: (0, $gyDKM.css)({
        textAlign: "end"
    }),
    start: (0, $gyDKM.css)({
        textAlign: "start"
    })
};
var $8de685929e29da5d$var$truncationStyles = (0, $gyDKM.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $8de685929e29da5d$var$wordBreakMap = {
    breakAll: (0, $gyDKM.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8de685929e29da5d$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $e58c24303611723d$export$1aeb4f6b93c4540d)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $867c6858db3b2acc$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $867c6858db3b2acc$export$2185ce37f9bdd963)[surface];
    return "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8de685929e29da5d$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $bv4qN.default)($8de685929e29da5d$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $62b74ba96e8c9a7e$export$9322276ec105d055)();
    var color = $8de685929e29da5d$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $gyDKM.jsx)(Component, {
        ref: ref,
        css: [
            $8de685929e29da5d$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $867c6858db3b2acc$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $867c6858db3b2acc$export$3a1bcba60b23d7f0)[color],
            maxLines && $8de685929e29da5d$var$truncationStyles,
            maxLines === 1 && $8de685929e29da5d$var$wordBreakMap.breakAll,
            align && $8de685929e29da5d$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $867c6858db3b2acc$export$38845ca010b93505)[weight],
            Component === "em" && $8de685929e29da5d$var$emStyles,
            Component === "strong" && $8de685929e29da5d$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $gyDKM.jsx)((0, $62b74ba96e8c9a7e$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $8de685929e29da5d$export$2e2bcd8739ae039 = $8de685929e29da5d$var$Text;



var $acw62 = parcelRequire("acw62");

var $6fef4d18a2092121$export$2b39a3648955dd09 = function TH(_ref) {
    var children = _ref.children, testId = _ref.testId, align = _ref.align, scope = _ref.scope, backgroundColor = _ref.backgroundColor, width = _ref.width, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $348c386a380b46b1$export$41ad0bbfa4755cac), {
        as: "th",
        testId: testId,
        align: align,
        scope: scope,
        width: width,
        backgroundColor: backgroundColor,
        sortDirection: sortDirection,
        colSpan: colSpan
    }, children);
};


/**
 * __HeadCell__
 *
 * HeadCell element
 */ var $7feb6fad64afcd7f$var$HeadCell = function HeadCell(_ref) {
    var children = _ref.children, align = _ref.align, testId = _ref.testId, backgroundColor = _ref.backgroundColor, _ref$scope = _ref.scope, scope = _ref$scope === void 0 ? "col" : _ref$scope;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fef4d18a2092121$export$2b39a3648955dd09), {
        scope: scope,
        align: align,
        testId: testId,
        backgroundColor: backgroundColor
    }, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8de685929e29da5d$export$2e2bcd8739ae039), {
        weight: "medium"
    }, children));
};
var $7feb6fad64afcd7f$export$2e2bcd8739ae039 = $7feb6fad64afcd7f$var$HeadCell;


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ece78c01a797f37c$var$ExpandContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isExpanded: false,
    toggleExpanded: (0, $c8a80735269f0b5d$export$2e2bcd8739ae039)
});
var $ece78c01a797f37c$export$2994164b482c6fe4 = function ExpandContextProvider(_ref) {
    var children = _ref.children, isExpandedProp = _ref.isExpanded, _ref$isDefaultExpande = _ref.isDefaultExpanded, isDefaultExpanded = _ref$isDefaultExpande === void 0 ? false : _ref$isDefaultExpande;
    var _useState = (0, $acw62.useState)(isDefaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var toggleExpanded = (0, $acw62.useCallback)(function() {
        setIsExpanded(function(v) {
            return !v;
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ece78c01a797f37c$var$ExpandContext.Provider, {
        value: {
            isExpanded: isExpandedProp || isExpanded,
            toggleExpanded: toggleExpanded
        }
    }, children);
};
var $ece78c01a797f37c$var$useExpand = function useExpand() {
    return (0, $acw62.useContext)($ece78c01a797f37c$var$ExpandContext);
};
var $ece78c01a797f37c$export$2e2bcd8739ae039 = $ece78c01a797f37c$var$useExpand;



var $acw62 = parcelRequire("acw62");
var $c3044637001ce0e9$var$ExpandContentContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isExpandableContent: false
});
var $c3044637001ce0e9$export$bc52fac1a043e39f = function ExpandContentContextProvider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c3044637001ce0e9$var$ExpandContentContext.Provider, {
        value: {
            isExpandableContent: true
        }
    }, children);
};
var $c3044637001ce0e9$var$useExpandContent = function useExpandContent() {
    return (0, $acw62.useContext)($c3044637001ce0e9$var$ExpandContentContext);
};
var $c3044637001ce0e9$export$2e2bcd8739ae039 = $c3044637001ce0e9$var$useExpandContent;



var $acw62 = parcelRequire("acw62");
var $fc760b5921854565$var$RowContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $fc760b5921854565$export$81981d840a2ece5 = function useRowId() {
    return (0, $acw62.useContext)($fc760b5921854565$var$RowContext);
};
var $fc760b5921854565$export$329ef9142f16ee64 = $fc760b5921854565$var$RowContext.Provider;




var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");
var $d6b2c7cfff41cdb1$var$TableBodyContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $d6b2c7cfff41cdb1$export$c0d7aba0938441d = $d6b2c7cfff41cdb1$var$TableBodyContext.Provider;
var $d6b2c7cfff41cdb1$export$e4e48199ad91605c = function useTableBody() {
    var hasTableBody = (0, $acw62.useContext)($d6b2c7cfff41cdb1$var$TableBodyContext);
    (0, $bv4qN.default)(hasTableBody, "<Row /> must be nested inside a <TableBody>");
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
/* checkbox.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f7b4ce768337c96e$var$ATOMIC_GROUP_LENGTH = 5;
function $f7b4ce768337c96e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $f7b4ce768337c96e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $02289ff6d52a21d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02289ff6d52a21d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02289ff6d52a21d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02289ff6d52a21d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $02289ff6d52a21d5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $02289ff6d52a21d5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $02289ff6d52a21d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $02289ff6d52a21d5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $02289ff6d52a21d5$var$_objectSpread($02289ff6d52a21d5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $930e3bd674ca74bc$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $930e3bd674ca74bc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $930e3bd674ca74bc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($930e3bd674ca74bc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $930e3bd674ca74bc$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $930e3bd674ca74bc$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $930e3bd674ca74bc$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $930e3bd674ca74bc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $930e3bd674ca74bc$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $930e3bd674ca74bc$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $02289ff6d52a21d5$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $6d9548c7dbaf97c7$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $ab98e1efd591debd$export$2e2bcd8739ae039));
};


function $01a35b60286c6d4e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $6d9548c7dbaf97c7$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $43f123995fdafb2c$export$33752cf3ee811995)(function(payload) {
        return new (0, $930e3bd674ca74bc$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $0dce40b7523bff68$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $9bf4bc72c9d1c358$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bf4bc72c9d1c358$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bf4bc72c9d1c358$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bf4bc72c9d1c358$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9bf4bc72c9d1c358$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $01a35b60286c6d4e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $0dce40b7523bff68$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $0dce40b7523bff68$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9bf4bc72c9d1c358$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $cd3a3422e0585f06$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $cd3a3422e0585f06$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $cd3a3422e0585f06$var$CheckboxIcon = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $acw62.useMemo)(function() {
        return $cd3a3422e0585f06$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $f7b4ce768337c96e$export$2e2bcd8739ae039)([
            $cd3a3422e0585f06$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $acw62.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $f7b4ce768337c96e$export$2e2bcd8739ae039)([
            $cd3a3422e0585f06$var$svgStyles.rect
        ])
    }), icon));
});
var $cd3a3422e0585f06$export$2e2bcd8739ae039 = $cd3a3422e0585f06$var$CheckboxIcon;


/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $acw62 = parcelRequire("acw62");

var $b8bebd9f23416f95$var$baseStyles = null;
var $b8bebd9f23416f95$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $b8bebd9f23416f95$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $b8bebd9f23416f95$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $b8bebd9f23416f95$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $b8bebd9f23416f95$var$disabledCheckedStyles = null;
function $b8bebd9f23416f95$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("label", {
        className: (0, $f7b4ce768337c96e$export$2e2bcd8739ae039)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1tvo _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}


/* label-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $70854b3e02a7bef1$var$labelTextStyles = null;
function $70854b3e02a7bef1$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $f7b4ce768337c96e$export$2e2bcd8739ae039)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}


/* required-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $fb33a0a13bcd9f7d$var$requiredIndicatorStyles = null;
function $fb33a0a13bcd9f7d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": true,
        className: (0, $f7b4ce768337c96e$export$2e2bcd8739ae039)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}


var $7b8b5b6caf5c7f49$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $7b8b5b6caf5c7f49$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $7b8b5b6caf5c7f49$var$Checkbox = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $7b8b5b6caf5c7f49$var$_excluded);
    var _useState = (0, $acw62.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $9bf4bc72c9d1c358$export$a4687b0234b40e28)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "checkbox",
        packageName: "@atlaskit/checkbox",
        packageVersion: "0.0.0-development"
    });
    var internalRef = (0, $acw62.useRef)(null);
    var mergedRefs = (0, $3d94fa6e7ae720e2$export$2e2bcd8739ae039)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $acw62.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $b8bebd9f23416f95$export$2e2bcd8739ae039), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $f7b4ce768337c96e$export$2e2bcd8739ae039)([
            $7b8b5b6caf5c7f49$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? "true" : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? "true" : undefined
    })), /*#__PURE__*/ $acw62.createElement((0, $cd3a3422e0585f06$export$2e2bcd8739ae039), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $acw62.createElement((0, $70854b3e02a7bef1$export$2e2bcd8739ae039), null, label, isRequired && /*#__PURE__*/ $acw62.createElement((0, $fb33a0a13bcd9f7d$export$2e2bcd8739ae039), null)));
}));
$7b8b5b6caf5c7f49$var$Checkbox.displayName = "Checkbox";
var $7b8b5b6caf5c7f49$export$2e2bcd8739ae039 = $7b8b5b6caf5c7f49$var$Checkbox;


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $9d243a45b9f88846$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $9d243a45b9f88846$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $luEYg.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $9d243a45b9f88846$export$2e2bcd8739ae039 = $9d243a45b9f88846$var$VisuallyHidden;





var $acw62 = parcelRequire("acw62");


var $bc290d3166d48b2f$var$spacingStyles = (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
    width: "2rem",
    padding: "space.0"
});
var $bc290d3166d48b2f$export$1049d18762739f1d = function SelectableCell(_ref) {
    var children = _ref.children, as = _ref.as;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $348c386a380b46b1$export$41ad0bbfa4755cac), {
        as: as,
        xcss: $bc290d3166d48b2f$var$spacingStyles
    }, children);
};


var $934b4c380f6fa13a$var$SelectableCellComponent = function SelectableCellComponent() {
    var _useSelection = (0, $911884466be6b320$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 2), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked, toggleSelection = _useSelection2[1].toggleSelection;
    var idx = (0, $fc760b5921854565$export$81981d840a2ece5)();
    var isChecked = (0, $acw62.useMemo)(function() {
        return allChecked || checked.includes(idx);
    }, [
        allChecked,
        checked,
        idx
    ]);
    var onChange = (0, $acw62.useCallback)(function(e) {
        return toggleSelection === null || toggleSelection === void 0 ? void 0 : toggleSelection(idx, e.nativeEvent.shiftKey);
    }, [
        idx,
        toggleSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc290d3166d48b2f$export$1049d18762739f1d), {
        as: "td"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b8b5b6caf5c7f49$export$2e2bcd8739ae039), {
        isChecked: isChecked,
        onChange: onChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d243a45b9f88846$export$2e2bcd8739ae039), null, "Select row ", idx + 1)
    }));
};
var $934b4c380f6fa13a$var$SelectableCell = /*#__PURE__*/ (0, $acw62.memo)($934b4c380f6fa13a$var$SelectableCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$934b4c380f6fa13a$export$2e2bcd8739ae039 = $934b4c380f6fa13a$var$SelectableCell;



/* tr.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");


/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $03b2ef0ac6e18b4e$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $03b2ef0ac6e18b4e$var$_excluded2 = [
    "className"
];
var $03b2ef0ac6e18b4e$var$focusRingStyles = null;
var $03b2ef0ac6e18b4e$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $03b2ef0ac6e18b4e$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $03b2ef0ac6e18b4e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $03b2ef0ac6e18b4e$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $luEYg.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $03b2ef0ac6e18b4e$export$2e2bcd8739ae039 = $03b2ef0ac6e18b4e$var$Focusable;


var $b195b745b1a1b548$var$styles = {
    base: "_19itglyw _4t3i1wto _kqswh2mm _hpylidpf _btyzidpf",
    selected: "_bfhkcslv _irr3quvt",
    subitem: "_bfhkm7j4",
    bodyRow: "_1r62e4h9 _12ornqa1 _1ezz1tr0 _irr3134o"
};
var $b195b745b1a1b548$export$5582bd7183a5e873 = function TR(_ref) {
    var children = _ref.children, testId = _ref.testId, isSelected = _ref.isSelected, _ref$isBodyRow = _ref.isBodyRow, isBodyRow = _ref$isBodyRow === void 0 ? true : _ref$isBodyRow, isSubitem = _ref.isSubitem;
    return /*#__PURE__*/ $acw62.createElement((0, $03b2ef0ac6e18b4e$export$2e2bcd8739ae039), {
        as: "tr",
        isInset: true,
        tabIndex: -1,
        "aria-selected": isSelected,
        testId: testId,
        xcss: (0, $66d7dbe9bd15c487$export$a274e22fb40f762e)($b195b745b1a1b548$var$styles.base, isBodyRow && $b195b745b1a1b548$var$styles.bodyRow, isSelected && $b195b745b1a1b548$var$styles.selected, isSubitem && $b195b745b1a1b548$var$styles.subitem)
    }, children);
};


/**
 * __Row__
 *
 * A table row.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ var $f9fc543e7b74aa80$var$Row = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId;
    // To ensure valid nesting
    (0, $d6b2c7cfff41cdb1$export$e4e48199ad91605c)();
    // to access table state
    var _useTable = (0, $c1b417307b620f74$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $911884466be6b320$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 1), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked;
    var _useExpand = (0, $ece78c01a797f37c$export$2e2bcd8739ae039)(), isExpanded = _useExpand.isExpanded;
    var _useExpandContent = (0, $c3044637001ce0e9$export$2e2bcd8739ae039)(), isExpandableContent = _useExpandContent.isExpandableContent;
    var rowId = (0, $fc760b5921854565$export$81981d840a2ece5)();
    var isSelected = (0, $acw62.useMemo)(function() {
        if (!isSelectable || rowId === undefined) return undefined;
        return allChecked || checked.includes(rowId);
    }, [
        allChecked,
        checked,
        isSelectable,
        rowId
    ]);
    if (isExpanded === false && isExpandableContent) return null;
    var selectableCell = isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $934b4c380f6fa13a$export$2e2bcd8739ae039), null);
    if (isSelectable && isExpandableContent) selectableCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc290d3166d48b2f$export$1049d18762739f1d), {
        as: "td"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b195b745b1a1b548$export$5582bd7183a5e873), {
        isSelected: isSelected,
        testId: testId,
        isSubitem: isExpandableContent
    }, selectableCell, children);
});
var $f9fc543e7b74aa80$export$2e2bcd8739ae039 = $f9fc543e7b74aa80$var$Row;


var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");




/* tbody.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $01d145c7bf4e0ad9$var$bodyStyles = null;
var $01d145c7bf4e0ad9$export$7005b8a93a167348 = function TBody(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("tbody", {
        className: (0, $luEYg.default)([
            "_19itglyw _kqswh2mm _9v7aidpf _18postnw _8x3u8fd9 _aetrb3bt _11fnglyw"
        ])
    }, children);
};


var $f6f45c912d8223eb$var$_excluded = [
    "idx"
];
function $f6f45c912d8223eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6f45c912d8223eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6f45c912d8223eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6f45c912d8223eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * __Table body__
 */ function $f6f45c912d8223eb$var$TBody(_ref) {
    var rows = _ref.rows, children = _ref.children;
    var _useTable = (0, $c1b417307b620f74$export$25bceaac3c7e4dc7)(), sortFn = _useTable.sortFn;
    var _useSelection = (0, $911884466be6b320$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 2), _state = _useSelection2[0], _useSelection2$ = _useSelection2[1], removeAll = _useSelection2$.removeAll, setMax = _useSelection2$.setMax;
    // TODO: this seems like something the user should control or opt into.
    (0, $acw62.useEffect)(function() {
        removeAll === null || removeAll === void 0 || removeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- When the rows change, we [currently] want to call removeAll.
    }, [
        rows
    ]);
    var childrenCount = (0, $acw62.Children).count(children);
    var rowsLength = rows === null || rows === void 0 ? void 0 : rows.length;
    // Set data length (via setMax) whenever data changes
    (0, $acw62.useEffect)(function() {
        var numRows = rowsLength !== null && rowsLength !== void 0 ? rowsLength : childrenCount;
        setMax === null || setMax === void 0 || setMax(numRows);
    }, [
        rowsLength,
        childrenCount,
        setMax
    ]);
    var sortedRows = (0, $acw62.useMemo)(function() {
        return rows === null || rows === void 0 ? void 0 : rows.map(function(row, idx) {
            return $f6f45c912d8223eb$var$_objectSpread($f6f45c912d8223eb$var$_objectSpread({}, row), {}, {
                idx: idx
            });
        }).sort(sortFn);
    }, [
        rows,
        sortFn
    ]);
    var renderedChildren = function() {
        if (typeof children === "function") return sortedRows === null || sortedRows === void 0 ? void 0 : sortedRows.map(function(_ref2) {
            var idx = _ref2.idx, row = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $f6f45c912d8223eb$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc760b5921854565$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, // @ts-expect-error
            children(row));
        });
        var childrenArray = Array.isArray(children) ? children : [
            children
        ];
        return childrenArray.map(function(row, idx) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc760b5921854565$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, row);
        });
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6b2c7cfff41cdb1$export$c0d7aba0938441d), {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01d145c7bf4e0ad9$export$7005b8a93a167348), null, renderedChildren));
}
var $f6f45c912d8223eb$export$2e2bcd8739ae039 = $f6f45c912d8223eb$var$TBody;


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $gyDKM = parcelRequire("gyDKM");


var $674be286dd40d8f5$var$justifyContentMap = {
    start: (0, $gyDKM.css)({
        justifyContent: "start"
    }),
    center: (0, $gyDKM.css)({
        justifyContent: "center"
    }),
    end: (0, $gyDKM.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $gyDKM.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $gyDKM.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $gyDKM.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $gyDKM.css)({
        justifyContent: "stretch"
    })
};
var $674be286dd40d8f5$var$flexDirectionMap = {
    column: (0, $gyDKM.css)({
        flexDirection: "column"
    }),
    row: (0, $gyDKM.css)({
        flexDirection: "row"
    })
};
var $674be286dd40d8f5$var$flexWrapMap = {
    wrap: (0, $gyDKM.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $gyDKM.css)({
        flexWrap: "nowrap"
    })
};
var $674be286dd40d8f5$var$alignItemsMap = {
    start: (0, $gyDKM.css)({
        alignItems: "start"
    }),
    center: (0, $gyDKM.css)({
        alignItems: "center"
    }),
    baseline: (0, $gyDKM.css)({
        alignItems: "baseline"
    }),
    end: (0, $gyDKM.css)({
        alignItems: "end"
    }),
    stretch: (0, $gyDKM.css)({
        alignItems: "stretch"
    })
};
var $674be286dd40d8f5$var$baseStyles = (0, $gyDKM.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $674be286dd40d8f5$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $2ab8ad6407bb0250$export$a9c84988c8f81f2d)(xcss);
    return (0, $gyDKM.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $674be286dd40d8f5$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $867c6858db3b2acc$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $867c6858db3b2acc$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $867c6858db3b2acc$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $674be286dd40d8f5$var$alignItemsMap[alignItems],
            direction && $674be286dd40d8f5$var$flexDirectionMap[direction],
            justifyContent && $674be286dd40d8f5$var$justifyContentMap[justifyContent],
            wrap && $674be286dd40d8f5$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$674be286dd40d8f5$var$Flex.displayName = "Flex";
var $674be286dd40d8f5$export$2e2bcd8739ae039 = $674be286dd40d8f5$var$Flex;


var $a07083dc8dafb7b1$var$flexGrowMap = {
    hug: (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $a07083dc8dafb7b1$var$separatorStyles = (0, $gyDKM.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $a07083dc8dafb7b1$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $gyDKM.jsx)("span", {
        css: $a07083dc8dafb7b1$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $a07083dc8dafb7b1$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $gyDKM.jsx)($a07083dc8dafb7b1$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $gyDKM.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $a07083dc8dafb7b1$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $gyDKM.jsx)((0, $674be286dd40d8f5$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$a07083dc8dafb7b1$var$Inline.displayName = "Inline";
var $a07083dc8dafb7b1$export$2e2bcd8739ae039 = $a07083dc8dafb7b1$var$Inline;






var $acw62 = parcelRequire("acw62");

var $e789c5501f77d83b$var$overlayStyles = (0, $2ab8ad6407bb0250$export$f6c783d06584602c)({
    display: "flex",
    position: "absolute",
    inset: "space.0",
    insetInlineStart: "space.400"
});
var $e789c5501f77d83b$export$7e782ae264b7f61c = function BulkActionOverlay(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eecdcb0465c62051$export$2e2bcd8739ae039), {
        as: "th",
        paddingInline: "space.100",
        backgroundColor: "elevation.surface",
        xcss: $e789c5501f77d83b$var$overlayStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a07083dc8dafb7b1$export$2e2bcd8739ae039), {
        space: "space.300",
        alignBlock: "center"
    }, children));
};



/* thead.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $luEYg = parcelRequire("luEYg");
var $b841d434eeb71395$var$baseStyles = null;
var $b841d434eeb71395$export$c4c2bc57f2e82919 = function THead(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("thead", {
        className: (0, $luEYg.default)([
            "_1r04idpf _19itglyw _179rhf6m _mqm25u6v _kqsw1if8 _1pbykb7n _bfhkvuon"
        ])
    }, children);
};



var $e874157b269c4e90$var$THead = function THead(_ref) {
    var actions = _ref.actions, children = _ref.children;
    var _useTable = (0, $c1b417307b620f74$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $911884466be6b320$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 2), state = _useSelection2[0], _useSelection2$ = _useSelection2[1], setAll = _useSelection2$.setAll, removeAll = _useSelection2$.removeAll;
    var isChecked = state.allChecked || state.anyChecked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b841d434eeb71395$export$c4c2bc57f2e82919), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b195b745b1a1b548$export$5582bd7183a5e873), {
        isBodyRow: false
    }, isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc290d3166d48b2f$export$1049d18762739f1d), {
        as: "th"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b8b5b6caf5c7f49$export$2e2bcd8739ae039), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d243a45b9f88846$export$2e2bcd8739ae039), {
            id: "select-all"
        }, "Select all rows"),
        onChange: isChecked ? removeAll : setAll,
        isChecked: isChecked,
        isIndeterminate: state.anyChecked && !state.allChecked
    })), children, isSelectable && isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e789c5501f77d83b$export$7e782ae264b7f61c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #172B4D)",
            /* @ts-ignore migrate to Text */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)"
        }
    }, state.checked.length, " selected"), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a07083dc8dafb7b1$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100"
    }, actions(state.checked)))));
};
var $e874157b269c4e90$export$2e2bcd8739ae039 = $e874157b269c4e90$var$THead;


var $6050d4148ee1f561$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36758847330c30e3d31c155e38099f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6050d4148ee1f561$exports, "__esModule", {
    value: true
});
$6050d4148ee1f561$exports.default = void 0;

var $6050d4148ee1f561$var$_react = $6050d4148ee1f561$var$_interopRequireDefault((parcelRequire("acw62")));

var $6050d4148ee1f561$var$_UNSAFE_baseNew = $6050d4148ee1f561$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $6050d4148ee1f561$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6050d4148ee1f561$var$CommentIcon = (props)=>/*#__PURE__*/ $6050d4148ee1f561$var$_react.default.createElement($6050d4148ee1f561$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$6050d4148ee1f561$var$CommentIcon.displayName = "CommentIcon";
var $6050d4148ee1f561$var$_default = $6050d4148ee1f561$exports.default = $6050d4148ee1f561$var$CommentIcon;


var $fe10faeab8e06616$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e445612cfd22a19ca6ff947247db0ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fe10faeab8e06616$exports, "__esModule", {
    value: true
});
$fe10faeab8e06616$exports.default = void 0;

var $fe10faeab8e06616$var$_react = $fe10faeab8e06616$var$_interopRequireDefault((parcelRequire("acw62")));

var $fe10faeab8e06616$var$_UNSAFE_baseNew = $fe10faeab8e06616$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $fe10faeab8e06616$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe10faeab8e06616$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $fe10faeab8e06616$var$_react.default.createElement($fe10faeab8e06616$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 2.75c-3.255 0-6.086 2.039-7.13 4.888a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25s6.086-2.039 7.129-4.888a1.06 1.06 0 0 0 0-.724c-1.043-2.85-3.874-4.888-7.13-4.888Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$fe10faeab8e06616$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $fe10faeab8e06616$var$_default = $fe10faeab8e06616$exports.default = $fe10faeab8e06616$var$EyeOpenIcon;


var $87356966879965c8$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b7d311e04eceb9781b3930a729d8836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($87356966879965c8$exports, "__esModule", {
    value: true
});
$87356966879965c8$exports.default = void 0;

var $87356966879965c8$var$_react = $87356966879965c8$var$_interopRequireDefault((parcelRequire("acw62")));

var $87356966879965c8$var$_UNSAFE_baseNew = $87356966879965c8$var$_interopRequireDefault((parcelRequire("lwLxe")));
function $87356966879965c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87356966879965c8$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $87356966879965c8$var$_react.default.createElement($87356966879965c8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15m.25-7.278L11.346 9.5l4-4M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$87356966879965c8$var$PersonAddedIcon.displayName = "PersonAddedIcon";
var $87356966879965c8$var$_default = $87356966879965c8$exports.default = $87356966879965c8$var$PersonAddedIcon;


function $cb0e8fe57b0fd046$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $cb0e8fe57b0fd046$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $cb0e8fe57b0fd046$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, "__esModule", {
        value: true,
        configurable: true
    });
}
/// <reference types="./types/custom.d.ts" />
var $cb0e8fe57b0fd046$var$$a69491ea5a126553$exports = {};
var $cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports = {};
var $cb0e8fe57b0fd046$var$$660bd1c6cb41002a$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$660bd1c6cb41002a$exports, "Blockquote", ()=>$cb0e8fe57b0fd046$export$29a7a275fe11687);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$660bd1c6cb41002a$exports, "blockquoteStyles", ()=>$cb0e8fe57b0fd046$export$7a77f8e9665fa6b2);
const $cb0e8fe57b0fd046$export$29a7a275fe11687 = ({ children: children })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("blockquote", {
        css: (0, $gyDKM.css)($cb0e8fe57b0fd046$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $cb0e8fe57b0fd046$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    ...$cb0e8fe57b0fd046$var$$660bd1c6cb41002a$var$fontSizeStyles,
    span: $cb0e8fe57b0fd046$var$$660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};
var $cb0e8fe57b0fd046$var$$fec02fc26c7e145d$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fec02fc26c7e145d$exports, "ButtonSize", ()=>$cb0e8fe57b0fd046$export$5dd2748b7940a2a0);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fec02fc26c7e145d$exports, "ButtonAppearance", ()=>$cb0e8fe57b0fd046$export$261c9483fc4a455a);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fec02fc26c7e145d$exports, "Button", ()=>$cb0e8fe57b0fd046$export$353f5b6fc5456de1);
const $cb0e8fe57b0fd046$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf = ({ label: label, type: type, clickHandler: clickHandler, iconBefore: iconBefore, iconAfter: iconAfter, appearance: appearance, testId: testId, href: href, target: target, fullWidth: fullWidth = false, disabled: disabled = false, isLoading: isLoading = false, selected: selected = false })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $e33ac5fee2d2dbc4$export$2e2bcd8739ae039), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: testId,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && (0, $gyDKM.css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            fullWidth && (0, $gyDKM.css)({
                width: "100%",
                justifyContent: "center"
            })
        ],
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && label && (0, $gyDKM.css)({
                        marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $9b1489024cd32216$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$384448a6ffd0907f$export$5be053290bf6cd4c = (appearance, selected, disabled)=>{
    let testId = `button-${appearance}`;
    if (selected) testId += "-selected";
    if (disabled) testId += "-disabled";
    return testId;
};
const $cb0e8fe57b0fd046$var$$384448a6ffd0907f$export$99c79d2ae299b19a = (iconType)=>iconType ? iconType.replaceAll("-", " ") : "button icon";
const $cb0e8fe57b0fd046$var$$f0f55be381b0aa07$export$c25acd513dcc8062 = ({ clickHandler: clickHandler, testId: testId, disabled: disabled = false, selected: selected = false, isLoading: isLoading = false, tooltip: tooltip, iconType: iconType, showBeforeIcon: showBeforeIcon, href: href, target: target, iconColor: iconColor, size: size })=>{
    const commonProps = {
        tabIndex: 0,
        "aria-label": $cb0e8fe57b0fd046$var$$384448a6ffd0907f$export$99c79d2ae299b19a(iconType),
        "data-testid": testId,
        css: [
            $cb0e8fe57b0fd046$var$$f0f55be381b0aa07$var$learningButtonIconStyles["base"],
            size === $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM && $cb0e8fe57b0fd046$var$$f0f55be381b0aa07$var$learningButtonIconStyles["medium"],
            selected && $cb0e8fe57b0fd046$var$$f0f55be381b0aa07$var$learningButtonIconStyles["selected"],
            iconColor && (0, $gyDKM.css)({
                color: iconColor
            })
        ],
        onClick: clickHandler
    };
    const content = (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $9b1489024cd32216$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    let element;
    if (href && !disabled) element = (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    else element = (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
        id: "icon-button",
        ...commonProps,
        disabled: disabled,
        children: content
    });
    return tooltip ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $3bb76fb59b0ba000$export$2e2bcd8739ae039), {
        content: tooltip,
        testId: "tooltip",
        children: element
    }) : element;
};
const $cb0e8fe57b0fd046$var$$f0f55be381b0aa07$var$learningButtonIconStyles = {
    base: (0, $gyDKM.css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    medium: (0, $gyDKM.css)({
        width: "38px",
        height: "38px",
        minWidth: "38px",
        minHeight: "38px"
    }),
    selected: (0, $gyDKM.css)({
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.hovered"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.selected")
        }
    })
};
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$8f9833f38f34a075 = {
    basic: (0, $gyDKM.css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        textDecoration: "none",
        justifyContent: "center",
        maxWidth: "max-content",
        width: "100%",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        height: "40px",
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
            borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
            textDecoration: "none"
        },
        "&:active": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
            borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.brand.bold"),
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")}`
        }
    }),
    secondary: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
    }),
    danger: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.danger.bold"),
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    warning: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.warning.bold"),
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.warning"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.warning.inverse")
    }),
    subtle: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
    }),
    success: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.success.bold"),
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    selected: (0, $gyDKM.css)({
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
        }
    })
};
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463 = {
    medium: (0, $gyDKM.css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        height: "40px"
    }),
    large: (0, $gyDKM.css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600,
        height: "48px"
    })
};
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$84379743ac6ff850 = {
    medium: (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
    }),
    "medium-icon-before": (0, $gyDKM.css)({
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $gyDKM.css)({
        padding: `10px 10px 10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
    }),
    large: (0, $gyDKM.css)({
        maxWidth: "max-content",
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`
    }),
    "large-icon-before": (0, $gyDKM.css)({
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
    }),
    "large-icon-after": (0, $gyDKM.css)({
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`
    })
};
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$6398dd78520de6de = {
    large: (0, $gyDKM.css)({
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
        }
    }),
    "large-icon-before": (0, $gyDKM.css)({
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $gyDKM.css)({
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px 10px 10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
        }
    })
};
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$9d41b2b2e9b27135 = (0, $gyDKM.css)({
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$1870a7443335e00d = (0, $gyDKM.css)({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& > span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    "& svg": {
        maxWidth: "20px",
        maxHeight: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$46d009ded5eecf4e = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon"),
    cursor: "not-allowed"
});
const $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$d0e85600c25cfb6 = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
    borderColor: "transparent",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
        borderColor: "transparent",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
        cursor: "not-allowed"
    }
});
const $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$8c0322faba831be3 = (appearance, size)=>[
        $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$8f9833f38f34a075["basic"],
        $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$8f9833f38f34a075[appearance],
        $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463[size]
    ];
const $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$18739f551ab326b6 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon)=>{
    const styles = [];
    if (isButtonWithoutIcon) styles.push($cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$84379743ac6ff850[size]);
    if (showBeforeIcon) styles.push($cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-after`]);
    return styles;
};
const $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$10dac92f1edafe3b = (isResponsiveSpacing, size, showBeforeIcon, showAfterIcon)=>{
    const styles = [
        $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$6398dd78520de6de[size],
        $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$9d41b2b2e9b27135
    ];
    if (!isResponsiveSpacing) return [];
    if (showBeforeIcon) styles.push($cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-after`]);
    return styles;
};
const $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$1bff1bc920069ec8 = (appearance)=>{
    if (appearance === $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY) return (0, $gyDKM.css)({
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")
    });
    if (appearance === $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY) return (0, $gyDKM.css)({
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
    });
    return null;
};
const $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$3f4ba612f3306fd2 = (selected, isLoading, disabled, fullWidth)=>{
    const styles = [];
    if (selected) styles.push($cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$8f9833f38f34a075["selected"]);
    if (isLoading || disabled) styles.push((0, $gyDKM.css)({
        ...$cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$d0e85600c25cfb6,
        pointerEvents: "none",
        cursor: "not-allowed"
    }));
    if (fullWidth) styles.push((0, $gyDKM.css)({
        width: "100%",
        maxWidth: "none",
        justifyContent: "center"
    }));
    return styles;
};
const $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$a803e3773f881664 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding = true)=>{
    const linkButtonSpacingStyles = {
        medium: (0, $gyDKM.css)({
            padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
        }),
        "medium-icon-before": (0, $gyDKM.css)({
            padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }),
        "medium-icon-after": (0, $gyDKM.css)({
            padding: `10px 10px 10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
        }),
        large: (0, $gyDKM.css)({
            maxWidth: "max-content",
            padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`
        }),
        "large-icon-before": (0, $gyDKM.css)({
            padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
        }),
        "large-icon-after": (0, $gyDKM.css)({
            padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`
        })
    };
    const styles = [];
    if (isButtonWithoutIcon) styles.push(linkButtonSpacingStyles[size]);
    if (showBeforeIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-before`]);
    if (showAfterIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-after`]);
    if (!withPadding) styles.push((0, $gyDKM.css)({
        padding: 0
    }));
    return styles;
};
const $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$getLinkButtonStyles = (disabled)=>[
        $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["basic"],
        disabled && $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["disabled"]
    ];
const $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8 = ({ label: label, disabled: disabled = false, clickHandler: clickHandler, testId: testId, size: size = $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM, href: href, target: target, withPadding: withPadding = true, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$getLinkButtonStyles(disabled),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$a803e3773f881664(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding)
        ]
    };
    const content = (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            showBeforeIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $gyDKM.css)({
                        marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            showAfterIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $gyDKM.css)({
                        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$disabledIconStyles
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        onClick: clickHandler,
        children: content
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        disabled: disabled,
        onClick: clickHandler,
        children: content
    });
};
const $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$learningButtonLinkStyles = {
    basic: (0, $gyDKM.css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: (0, $gyDKM.css)({
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    })
};
const $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$buttonIconContainerStyles = (0, $gyDKM.css)({
    width: "24px",
    height: "24px"
});
const $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$var$disabledIconStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $cb0e8fe57b0fd046$var$$73286ba8e7c0bafe$export$9508e056e78f90ef = ({ label: label, appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, href: href, target: target, fullWidth: fullWidth = false, selected: selected = false, size: size = $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, as: as = "a", type: type })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        onClick: disabled || isLoading ? undefined : clickHandler,
        role: as === "button" ? undefined : href ? undefined : "button",
        tabIndex: disabled || isLoading ? -1 : 0,
        "data-testid": testId,
        css: [
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            $cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$1bff1bc920069ec8(appearance),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ]
    };
    const children = (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $9b1489024cd32216$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    label && (0, $gyDKM.css)({
                        marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
                        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
                            marginRight: 0
                        }
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: isLoading && (0, $gyDKM.css)({
                    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
                }),
                children: label
            }),
            showAfterIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $gyDKM.css)({
                        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$46d009ded5eecf4e
                ],
                children: showAfterIcon
            })
        ]
    });
    if (as === "button") return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: children
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: !disabled && !isLoading ? href : undefined,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$ea4b236bf0573f71$export$69c6dd121e96df9e = ({ label: label, type: type = "button", appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, fullWidth: fullWidth = false, selected: selected = false, size: size = $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, href: href, target: target })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            ...$cb0e8fe57b0fd046$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ],
        onClick: clickHandler
    };
    const content = (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $9b1489024cd32216$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $gyDKM.css)({
                        marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $gyDKM.css)({
                        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $gyDKM.css)({
                        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: content
    });
};
let $cb0e8fe57b0fd046$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($cb0e8fe57b0fd046$export$5dd2748b7940a2a0 || ($cb0e8fe57b0fd046$export$5dd2748b7940a2a0 = {}));
let $cb0e8fe57b0fd046$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($cb0e8fe57b0fd046$export$261c9483fc4a455a || ($cb0e8fe57b0fd046$export$261c9483fc4a455a = {}));
const $cb0e8fe57b0fd046$export$353f5b6fc5456de1 = (props)=>{
    const { appearance: appearance = $cb0e8fe57b0fd046$export$261c9483fc4a455a.DEFAULT, selected: selected = false, disabled: disabled = false, size: size = $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM, onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading = false, isResponsive: isResponsive = false } = props;
    const clickHandler = (0, $acw62.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore || false;
    const showAfterIcon = !isLoading && iconAfter || false;
    const isResponsiveSpacing = isResponsive && [
        $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
        $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.LARGE;
    const testId = $cb0e8fe57b0fd046$var$$384448a6ffd0907f$export$5be053290bf6cd4c(appearance, selected, disabled);
    const commonProps = {
        ...props,
        size: size,
        clickHandler: clickHandler,
        isButtonWithoutIcon: isButtonWithoutIcon,
        showBeforeIcon: showBeforeIcon,
        showAfterIcon: showAfterIcon,
        isResponsiveSpacing: isResponsiveSpacing,
        testId: testId
    };
    const componentMap = {
        [$cb0e8fe57b0fd046$export$261c9483fc4a455a.DEFAULT]: $cb0e8fe57b0fd046$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf,
        [$cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON]: $cb0e8fe57b0fd046$var$$f0f55be381b0aa07$export$c25acd513dcc8062,
        [$cb0e8fe57b0fd046$export$261c9483fc4a455a.LINK]: $cb0e8fe57b0fd046$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8,
        [$cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY]: $cb0e8fe57b0fd046$var$$73286ba8e7c0bafe$export$9508e056e78f90ef,
        [$cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY]: $cb0e8fe57b0fd046$var$$73286ba8e7c0bafe$export$9508e056e78f90ef
    };
    const Component = componentMap[appearance] ?? $cb0e8fe57b0fd046$var$$ea4b236bf0573f71$export$69c6dd121e96df9e;
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)(Component, {
        ...commonProps
    });
};
var $cb0e8fe57b0fd046$var$$d501466973a9f0a6$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$d501466973a9f0a6$exports, "CheckboxType", ()=>$cb0e8fe57b0fd046$export$138e17770a0a93a6);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$d501466973a9f0a6$exports, "CheckboxSize", ()=>$cb0e8fe57b0fd046$export$5e435bc8b081a399);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$d501466973a9f0a6$exports, "Checkbox", ()=>$cb0e8fe57b0fd046$export$48513f6b9f8ce62d);
var $cb0e8fe57b0fd046$var$$633811e9cd66d921$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$633811e9cd66d921$exports, "useKeyboardInteraction", ()=>$cb0e8fe57b0fd046$export$2a0b6757d41dacb2);
const $cb0e8fe57b0fd046$export$2a0b6757d41dacb2 = (handler)=>{
    return (0, $acw62.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    }, [
        handler
    ]);
};
let $cb0e8fe57b0fd046$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($cb0e8fe57b0fd046$export$138e17770a0a93a6 || ($cb0e8fe57b0fd046$export$138e17770a0a93a6 = {}));
let $cb0e8fe57b0fd046$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($cb0e8fe57b0fd046$export$5e435bc8b081a399 || ($cb0e8fe57b0fd046$export$5e435bc8b081a399 = {}));
const $cb0e8fe57b0fd046$export$48513f6b9f8ce62d = ({ label: label, isChecked: isChecked, onChange: onChange, type: type = $cb0e8fe57b0fd046$export$138e17770a0a93a6.DEFAULT, size: size = $cb0e8fe57b0fd046$export$5e435bc8b081a399.DEFAULT, isIndeterminate: isIndeterminate = false, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $acw62.useState)(false);
    const checkboxRef = (0, $acw62.useRef)(null);
    const handleChange = (0, $acw62.useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleChange);
    (0, $acw62.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$labelStyles,
            size === $cb0e8fe57b0fd046$export$5e435bc8b081a399.LARGE && $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$labelLargeStyles,
            type === $cb0e8fe57b0fd046$export$138e17770a0a93a6.DISABLED && $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $gyDKM.css)({
                fontWeight: 700
            }),
            !isBold && (0, $gyDKM.css)({
                fontWeight: 400
            })
        ],
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$inputCheckboxStyles
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e61786c4aee8d415, {
                children: label
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$variants.checkbox[type],
                    $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$checkmarkStyles,
                    size === $cb0e8fe57b0fd046$export$5e435bc8b081a399.LARGE && $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $cb0e8fe57b0fd046$export$138e17770a0a93a6.DANGER && (0, $gyDKM.css)({
                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger")
                    })
                ]
            }),
            isRequired && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$requiredMarkStyles,
                    size === $cb0e8fe57b0fd046$export$5e435bc8b081a399.LARGE && (0, $gyDKM.css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$requiredMarkStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "6px"
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$labelStyles = (0, $gyDKM.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$labelLargeStyles = (0, $gyDKM.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$inputCheckboxStyles = (0, $gyDKM.css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$checkmarkStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$checkmarkLargeStyles = (0, $gyDKM.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")}`
    }
});
const $cb0e8fe57b0fd046$var$$d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $gyDKM.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $gyDKM.css)({
            "&:hover": {
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $gyDKM.css)({
            "&, &:hover": {
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $gyDKM.css)({
            "&, &:hover": {
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $gyDKM.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $cb0e8fe57b0fd046$var$$c4979bfceee73878$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$c4979bfceee73878$exports, "CommonModal", ()=>$cb0e8fe57b0fd046$export$8577c1390d697bac);
const $cb0e8fe57b0fd046$export$8577c1390d697bac = ({ isOpen: isOpen, toggleModal: toggleModal, modalDescriptionLabel: modalDescription, children: children, styles: styles })=>{
    const closeModal = (0, $acw62.useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, [
        toggleModal
    ]);
    const modalRef = (0, $acw62.useRef)(null);
    const focusOnOpen = (0, $acw62.useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    // focusOnOpen and toggleModal intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $acw62.useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$modalStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                    type: "button",
                    css: $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($224bcf757434c5a8$exports))), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                    })
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$backdropStyles = (0, $gyDKM.css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$modalStyles = (0, $gyDKM.css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$closeButtonStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.hovered")
    }
});
const $cb0e8fe57b0fd046$var$$c4979bfceee73878$var$modalSlotStyles = (0, $gyDKM.css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});
var $cb0e8fe57b0fd046$var$$0903e93de01b205a$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$0903e93de01b205a$exports, "Divider", ()=>$cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ const $cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb = ({ color: color, height: height = 1 })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("hr", {
        "data-testid": "divider",
        style: styles
    });
};
var $cb0e8fe57b0fd046$var$$a950778dc3003c4a$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a950778dc3003c4a$exports, "Eyebrow", ()=>$cb0e8fe57b0fd046$export$71f050e2efa708bb);
const $cb0e8fe57b0fd046$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular", size: size = "small", color: color = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"), children: children })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("h4", {
        css: [
            $cb0e8fe57b0fd046$var$$a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $cb0e8fe57b0fd046$var$$a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $gyDKM.css)({
                fontWeight: 600
            }),
            color && (0, $gyDKM.css)({
                color: color
            })
        ],
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$a950778dc3003c4a$var$eyebrowSmallStyles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $cb0e8fe57b0fd046$var$$a950778dc3003c4a$var$eyebrowMediumStyles = (0, $gyDKM.css)({
    fontSize: "14px",
    lineHeight: "18px"
});
var $cb0e8fe57b0fd046$var$$582583ec420fce57$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$582583ec420fce57$exports, "Heading", ()=>$cb0e8fe57b0fd046$export$a8a3e93435678ff9);
var $cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "objectValuesToControls", ()=>$cb0e8fe57b0fd046$export$8a8918d045227e35);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "inspectorProps", ()=>$cb0e8fe57b0fd046$export$1784ac302bd8ebad);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "formatMinutes", ()=>$cb0e8fe57b0fd046$export$30c35cbf580cab77);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "getRedirectUrl", ()=>$cb0e8fe57b0fd046$export$93832c3affb240d3);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "calculateLearningProgress", ()=>$cb0e8fe57b0fd046$export$6e67b290ed5690f6);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "SEARCHBAR_HISTORY_STORAGE_KEY", ()=>$cb0e8fe57b0fd046$export$1059c3e9f228d9b);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "getLocalStorageHistory", ()=>$cb0e8fe57b0fd046$export$7765f5b61937bda1);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "setLocalStorageItems", ()=>$cb0e8fe57b0fd046$export$cec0922aa1b64670);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, "generateHashFromLabel", ()=>$cb0e8fe57b0fd046$export$1bdcd43c8c2377cf);
const $cb0e8fe57b0fd046$var$$3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email, redirectUrl: redirectUrl, prompt: prompt = "none", experience: experience = "entry-auth" })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $cb0e8fe57b0fd046$var$$3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $cb0e8fe57b0fd046$var$$3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};
let $cb0e8fe57b0fd046$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($cb0e8fe57b0fd046$export$7dc6752a22ab011a || ($cb0e8fe57b0fd046$export$7dc6752a22ab011a = {}));
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.LOCAL]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $cb0e8fe57b0fd046$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
    CommunityApp["APP_UPDATES"] = "release-notes";
})($cb0e8fe57b0fd046$export$93d048dc21eb282a || ($cb0e8fe57b0fd046$export$93d048dc21eb282a = {}));
const $cb0e8fe57b0fd046$export$67e61a6fa639f224 = (email)=>[
        {
            app: $cb0e8fe57b0fd046$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: $cb0e8fe57b0fd046$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $cb0e8fe57b0fd046$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $cb0e8fe57b0fd046$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $cb0e8fe57b0fd046$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        },
        {
            app: $cb0e8fe57b0fd046$export$93d048dc21eb282a.APP_UPDATES,
            label: "Release Notes",
            target: "_self",
            href: {
                loggedIn: "/release-notes",
                loggedOut: "/release-notes"
            }
        }
    ];
const $cb0e8fe57b0fd046$export$208c68d48dfc9a12 = $cb0e8fe57b0fd046$export$67e61a6fa639f224();
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$cb0e8fe57b0fd046$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$cb0e8fe57b0fd046$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$cb0e8fe57b0fd046$export$93d048dc21eb282a.EVENTS]: "/events",
    [$cb0e8fe57b0fd046$export$93d048dc21eb282a.PROFILE]: "/user",
    [$cb0e8fe57b0fd046$export$93d048dc21eb282a.CHAMPIONS]: "/champions",
    [$cb0e8fe57b0fd046$export$93d048dc21eb282a.APP_UPDATES]: "/release-notes"
};
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$132b2bf91782e62b = "/user";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$b9cc8022ec117e91 = "/user/settings";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    },
    SWITCH_ACCOUNT: {
        text: "Switch accounts",
        id: "switch-account"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    }
};
let $cb0e8fe57b0fd046$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($cb0e8fe57b0fd046$export$3d7865934588d77e || ($cb0e8fe57b0fd046$export$3d7865934588d77e = {}));
let $cb0e8fe57b0fd046$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($cb0e8fe57b0fd046$export$d778a884eb401313 || ($cb0e8fe57b0fd046$export$d778a884eb401313 = {}));
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/community-platform-terms-of-use";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$6aafbda8e90312f0 = "#";
const $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$10bc455dcefd3f1f = "https://www.atlassian.com/trust/data-protection";
var $cb0e8fe57b0fd046$var$$ff456f198febe2ae$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ff456f198febe2ae$exports, "formatUserTimestamp", ()=>$cb0e8fe57b0fd046$export$a547c17dcfa0a6bc);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ff456f198febe2ae$exports, "formatRelativeTimestamp", ()=>$cb0e8fe57b0fd046$export$880acc1b13aaa28b);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ff456f198febe2ae$exports, "formatFullDateTime", ()=>$cb0e8fe57b0fd046$export$a31e25c49c78e203);
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getOrdinalSuffix = (day)=>{
    if (day >= 11 && day <= 13) return "th";
    switch(day % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
const $cb0e8fe57b0fd046$export$a547c17dcfa0a6bc = (value, { locale: locale, timeZone: timeZone } = {})=>{
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const resolvedLocale = locale || (typeof navigator !== "undefined" ? navigator.language : "en-US");
    const resolvedTimeZone = timeZone || (typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "UTC");
    const parts = new Intl.DateTimeFormat(resolvedLocale, {
        timeZone: resolvedTimeZone,
        year: "numeric",
        month: "long",
        day: "numeric"
    }).formatToParts(date);
    const month = parts.find((p)=>p.type === "month")?.value;
    const dayString = parts.find((p)=>p.type === "day")?.value;
    const year = parts.find((p)=>p.type === "year")?.value;
    if (!month || !dayString || !year) return "";
    const day = Number(dayString);
    if (Number.isNaN(day)) return "";
    return `${month} ${day}${$cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getOrdinalSuffix(day)}, ${year}`;
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE = 60;
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$SECONDS_IN_HOUR = 3600;
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getUserTimeZone = ()=>{
    try {
        if (typeof Intl !== "undefined") return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return "UTC";
    }
    return "UTC";
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$generateDateString = (d)=>{
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getCalendarDate = (ms, timeZone)=>{
    const d = new Date(ms);
    try {
        const parts = new Intl.DateTimeFormat("en-CA", {
            timeZone: timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).formatToParts(new Date(ms));
        const year = parts.find((p)=>p.type === "year")?.value;
        const month = parts.find((p)=>p.type === "month")?.value;
        const day = parts.find((p)=>p.type === "day")?.value;
        if (year && month && day) return `${year}-${month}-${day}`;
    } catch  {
        return $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$generateDateString(d);
    }
    return $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$generateDateString(d);
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getCalendarDaysDiff = (nowMs, thenMs, timeZone)=>{
    const nowDate = $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getCalendarDate(nowMs, timeZone);
    const thenDate = $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getCalendarDate(thenMs, timeZone);
    const nowEpochDay = Math.floor(new Date(nowDate).getTime() / 86400000);
    const thenEpochDay = Math.floor(new Date(thenDate).getTime() / 86400000);
    return nowEpochDay - thenEpochDay;
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$formatTruncatedDate = (date, timeZone)=>{
    try {
        return new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            month: "short",
            day: "numeric"
        }).format(date);
    } catch  {
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        return `${months[date.getMonth()]} ${date.getDate()}`;
    }
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$formatTime = (date, timeZone)=>{
    try {
        return new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        }).format(date).toLowerCase().replace("am", "a.m.").replace("pm", "p.m.");
    } catch  {
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const period = hours >= 12 ? "p.m." : "a.m.";
        const displayHour = hours % 12 || 12;
        return `${displayHour}:${minutes} ${period}`;
    }
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getFullLabel = (date, timeZone, diff)=>{
    if (diff.seconds < 0) return $cb0e8fe57b0fd046$export$a547c17dcfa0a6bc(date, {
        timeZone: timeZone
    });
    if (diff.seconds < $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE) return "Just now";
    if (diff.minutes < 60) return diff.minutes === 1 ? "A minute ago" : `${diff.minutes} minutes ago`;
    if (diff.calendarDays === 1) return "Yesterday";
    if (diff.calendarDays === 0 && diff.hours < 24) return diff.hours === 1 ? "1 hour ago" : `${diff.hours} hours ago`;
    if (diff.calendarDays > 1 && diff.calendarDays < 7) return `${diff.calendarDays} days ago`;
    if (diff.calendarDays === 7) return "1 week ago";
    return $cb0e8fe57b0fd046$export$a547c17dcfa0a6bc(date, {
        timeZone: timeZone
    });
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getTruncatedLabel = (date, timeZone, diff)=>{
    if (diff.seconds < 0) return $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$formatTruncatedDate(date, timeZone);
    if (diff.seconds < $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE) return "now";
    if (diff.minutes < 60) return `${diff.minutes}m`;
    if (diff.calendarDays === 1) return "1d";
    if (diff.calendarDays === 0 && diff.hours < 24) return `${diff.hours}h`;
    return $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$formatTruncatedDate(date, timeZone);
};
const $cb0e8fe57b0fd046$export$880acc1b13aaa28b = (value, format = "full")=>{
    try {
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        const timeZone = $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getUserTimeZone();
        const nowMs = Date.now();
        const seconds = Math.floor((nowMs - date.getTime()) / 1000);
        const diff = {
            seconds: seconds,
            minutes: Math.floor(seconds / $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE),
            hours: Math.floor(seconds / $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$SECONDS_IN_HOUR),
            calendarDays: $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getCalendarDaysDiff(nowMs, date.getTime(), timeZone)
        };
        return format === "truncated" ? $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getTruncatedLabel(date, timeZone, diff) : $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getFullLabel(date, timeZone, diff);
    } catch  {
        return "";
    }
};
const $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getTimeZoneAbbreviation = (date, timeZone)=>{
    try {
        const shortParts = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            timeZoneName: "short"
        }).formatToParts(date);
        const shortResult = shortParts.find((p)=>p.type === "timeZoneName")?.value ?? "";
        if (shortResult && !shortResult.startsWith("GMT+") && !shortResult.startsWith("GMT-")) return shortResult;
        const longParts = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            timeZoneName: "long"
        }).formatToParts(date);
        const longName = longParts.find((p)=>p.type === "timeZoneName")?.value ?? "";
        if (longName) return longName.split(" ").map((word)=>word.charAt(0).toUpperCase()).join("");
        return shortResult || timeZone;
    } catch  {
        return timeZone;
    }
};
const $cb0e8fe57b0fd046$export$a31e25c49c78e203 = (value)=>{
    try {
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        const timeZone = $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getUserTimeZone();
        const dateString = $cb0e8fe57b0fd046$export$a547c17dcfa0a6bc(date, {
            timeZone: timeZone
        });
        const timeString = $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$formatTime(date, timeZone);
        const tzAbbr = $cb0e8fe57b0fd046$var$$ff456f198febe2ae$var$getTimeZoneAbbreviation(date, timeZone);
        return `${dateString} at ${timeString} ${tzAbbr}`;
    } catch  {
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        return date.toLocaleString();
    }
};
const $cb0e8fe57b0fd046$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $cb0e8fe57b0fd046$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId, fieldId: fieldId } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $cb0e8fe57b0fd046$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $cb0e8fe57b0fd046$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[environment] || $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[$cb0e8fe57b0fd046$export$7dc6752a22ab011a.STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $cb0e8fe57b0fd046$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};
const $cb0e8fe57b0fd046$export$1059c3e9f228d9b = "searchbar_history";
const $cb0e8fe57b0fd046$export$7765f5b61937bda1 = ()=>{
    if (typeof window === "undefined") return [];
    const storedHistory = localStorage.getItem($cb0e8fe57b0fd046$export$1059c3e9f228d9b);
    return storedHistory ? JSON.parse(storedHistory) : [];
};
const $cb0e8fe57b0fd046$export$cec0922aa1b64670 = (items)=>{
    if (typeof window === "undefined") return;
    localStorage.setItem($cb0e8fe57b0fd046$export$1059c3e9f228d9b, JSON.stringify(items));
};
const $cb0e8fe57b0fd046$export$1bdcd43c8c2377cf = (label)=>{
    return `#${label.toLowerCase().replace(/ /g, "-")}`;
};
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$fde9406d76ec24a9$exports, $cb0e8fe57b0fd046$var$$ff456f198febe2ae$exports);
const $cb0e8fe57b0fd046$export$a8a3e93435678ff9 = ({ children: children, level: level, inspectMode: inspectMode, id: id, color: color = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"), fontWeight: fontWeight })=>{
    const HeadingElement = $cb0e8fe57b0fd046$var$$582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $cb0e8fe57b0fd046$var$$582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? $cb0e8fe57b0fd046$export$1784ac302bd8ebad(Object.keys(inspectMode)[0], inspectMode) : {};
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $gyDKM.css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h0Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h1Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h2Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h3Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h4Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h5Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h6Styles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $cb0e8fe57b0fd046$var$$582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h0Styles,
    1: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h1Styles,
    2: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h2Styles,
    3: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h3Styles,
    4: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h4Styles,
    5: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h5Styles,
    6: $cb0e8fe57b0fd046$var$$582583ec420fce57$var$h6Styles
};
var $cb0e8fe57b0fd046$var$$a02a6f7de308273b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a02a6f7de308273b$exports, "icons", ()=>$cb0e8fe57b0fd046$export$df03f54e09e486fa);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a02a6f7de308273b$exports, "IconSize", ()=>$cb0e8fe57b0fd046$export$ff775019b5b6e7df);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a02a6f7de308273b$exports, "IconRotation", ()=>$cb0e8fe57b0fd046$export$b3241a99d3e47e02);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a02a6f7de308273b$exports, "Icon", ()=>$cb0e8fe57b0fd046$export$f04a61298a47a40f);
// Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
// Glyph icons use 'primaryColor' prop
const $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$CORE_ICONS = [
    "arrow-up-right",
    "atlassian-intelligence",
    "calendar",
    "compass",
    "download-core",
    "link-external",
    "location-outline",
    "megaphone",
    "people-group",
    "person",
    "project",
    "sidebar-collapse",
    "sidebar-expand",
    "thumb-down",
    "thumb-up",
    "roadmaps-plan",
    "generative-indicator"
];
const $cb0e8fe57b0fd046$export$df03f54e09e486fa = {
    filter: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a7dc2edd667ae2da$exports))), {
            ...props
        }),
    "chevron-down": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b37509fddb710d14$exports))), {
            ...props
        }),
    "chevron-up": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($912daf77e6b778ae$exports))), {
            ...props
        }),
    "chevron-left": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2ebcf1483de98f7e$exports))), {
            ...props
        }),
    "chevron-right": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3d31785cc3bc23ef$exports))), {
            ...props
        }),
    "chevron-down-circle": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9618c54ee2794487$exports))), {
            ...props
        }),
    "arrow-up-circle": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d2a37f70120ffbf2$exports))), {
            ...props
        }),
    "arrow-up": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f7f8c000d42a91ba$exports))), {
            ...props
        }),
    "arrow-up-right": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($krRSk))), {
            ...props
        }),
    "check-circle": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ad6b6c915170de16$exports))), {
            ...props
        }),
    "check-circle-outline": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f7ac7adc054f9d02$exports))), {
            ...props
        }),
    "arrow-right": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1a4d84fbcc800603$exports))), {
            ...props
        }),
    "arrow-left-circle": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($32cd67b0704c3d15$exports))), {
            ...props
        }),
    "arrow-right-circle": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7c984b1fac873075$exports))), {
            ...props
        }),
    "arrow-right-small": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.908 8L12.8283 9.2021L14.5785 11.1497H7.26318C6.84191 11.1497 6.5 11.5304 6.5 11.9994C6.5 12.4685 6.84191 12.8492 7.26318 12.8492H14.5785L12.8283 14.7979L13.908 16L17.5 11.9994L13.908 8Z",
                fill: props.primaryColor ?? "#1868DB"
            })
        }),
    "atlassian-intelligence": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($426c9189270b2d6d$exports))), {
            ...props
        }),
    "atlassian-logo": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f81dad094603fd5d$exports))), {
            ...props
        }),
    cross: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($224bcf757434c5a8$exports))), {
            ...props
        }),
    "dropdown-cross": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($08b1b9be7ef671a2$exports))), {
            ...props
        }),
    "menu-icon": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ffeb0366878e88f$exports))), {
            ...props
        }),
    "emoji-frequent": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a8b22758b6b909fb$exports))), {
            ...props
        }),
    "star-filled": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8ff1f8eb7d65cd94$exports))), {
            ...props
        }),
    star: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($593c413bca784438$exports))), {
            ...props
        }),
    "bitbucket-builds": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($de4dd7d1aab12c73$exports))), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e43d19eb9134f54b$exports))), {
            ...props
        }),
    "editor-table": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2fb596ac1dfd6a48$exports))), {
            ...props
        }),
    "editor-open": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d50eca750a629ef7$exports))), {
            ...props
        }),
    calendar: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($890220d08eb7ec6c$exports))), {
            ...props
        }),
    copy: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($142d03762c98d509$exports))), {
            ...props
        }),
    warning: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($136ca9fcf2043d4b$exports))), {
            ...props
        }),
    image: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($adba5dedbf5ee9c0$exports))), {
            ...props
        }),
    download: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0f35765cb16ef905$exports))), {
            ...props
        }),
    "download-core": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bZH1Z))), {
            ...props
        }),
    "zoom-in": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($84301abb52bcbf76$exports))), {
            ...props
        }),
    "zoom-out": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2ff04b2d6f0111c2$exports))), {
            ...props
        }),
    search: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9fe02b09e2c6116b$exports))), {
            ...props
        }),
    overview: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($834b5235e5fd92db$exports))), {
            ...props
        }),
    add: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f5fec3964c81954d$exports))), {
            ...props
        }),
    refresh: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e2cf0a338e6e7ec3$exports))), {
            ...props
        }),
    "add-circle": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($03edd2aa4dfebbd8$exports))), {
            ...props
        }),
    edit: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($22cd6fe70d8f03d8$exports))), {
            ...props
        }),
    "edit-filled": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($367dba6e2103b9b2$exports))), {
            ...props
        }),
    error: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b8de6cc86ff0ecdc$exports))), {
            ...props
        }),
    settings: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5fd3bacdb4e0d7cf$exports))), {
            ...props
        }),
    info: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4a9187e6958af736$exports))), {
            ...props
        }),
    question: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9be5747e7f75a217$exports))), {
            ...props
        }),
    check: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ca446314eb0c0eb9$exports))), {
            ...props
        }),
    "check-circle-filled": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ad6b6c915170de16$exports))), {
            ...props
        }),
    "emoji-symbols": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($022a88c88e22620b$exports))), {
            ...props
        }),
    compass: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($51fb804910f454f9$exports))), {
            ...props
        }),
    megaphone: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($513b793ef4407bd4$exports))), {
            ...props
        }),
    location: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($60aaa7a9a5689072$exports))), {
            ...props
        }),
    "location-outline": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9dzbE))), {
            ...props
        }),
    "chevron-left-large": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ed70aa6ac2ebc0b8$exports))), {
            ...props
        }),
    "chevron-right-large": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ed70aa6ac2ebc0b8$exports))), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4d6daabf365a3621$exports))), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f8c9b5db3aca009e$exports))), {
            ...props
        }),
    export: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d054a043c858c0ba$exports))), {
            ...props
        }),
    link: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($125c6682bbd13fdb$exports))), {
            ...props
        }),
    "roadmaps-plan": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($66996c4de10cf265$exports))), {
            ...props
        }),
    "generative-indicator": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3fbfec1d7cd78380$exports))), {
            ...props
        }),
    share: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9d0d5aadf571b450$exports))), {
            ...props
        }),
    "sidebar-collapse": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5ec528592db494f6$exports))), {
            ...props
        }),
    "sidebar-expand": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($28a5d0ad0984536c$exports))), {
            ...props
        }),
    "people-group": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e29d94b3c318ce90$exports))), {
            ...props
        }),
    project: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3dce87e94efb0a99$exports))), {
            ...props
        }),
    "link-external": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($63c1aeb1eeb3ba19$exports))), {
            ...props
        }),
    person: (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($81fcfa6180844492$exports))), {
            ...props
        }),
    "bookmark-narrow": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M16.5745 5.49575C16.5745 5.13673 16.2832 4.84567 15.9242 4.84554H8.07595C7.71685 4.84554 7.42574 5.13665 7.42574 5.49575V18.2473L12.0001 15.0318L12.5601 15.4268L16.5745 18.2473V5.49575ZM18.5251 20.0633C18.5248 20.8281 17.717 21.2956 17.0659 20.965L16.9377 20.8875L11.9988 17.4155L7.06253 20.8875C6.39483 21.3569 5.47538 20.8794 5.4751 20.0633V5.49575C5.4751 4.05934 6.63954 2.8949 8.07595 2.8949H15.9242C17.3605 2.89503 18.5251 4.05942 18.5251 5.49575V20.0633Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    "bookmark-narrow-filled": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M18.525 20.0632C18.5247 20.828 17.7168 21.2955 17.0658 20.9649L16.9375 20.8874L11.9987 17.4154L7.06241 20.8874C6.39471 21.3568 5.47525 20.8792 5.47498 20.0632V5.49563C5.47498 4.05922 6.63942 2.89478 8.07583 2.89478H15.9241C17.3604 2.8949 18.525 4.0593 18.525 5.49563V20.0632Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    bookmark: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "bookmark-filled": ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "gap-completed": ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bcaa313d5a1a98e5$exports))), {
            ...props
        }),
    "thumb-up": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($93c6bdb4ac81baf8$exports))), {
            ...props
        }),
    "dot-default": ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#091E42",
                strokeOpacity: "0.14"
            })
        }),
    "dot-selected": ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#0C66E4"
            })
        }),
    "dot-completed": ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                width: "8",
                height: "8",
                rx: "4",
                fill: "#22A06B"
            })
        }),
    "mosaic_map-pin": (props)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.8088 12.9426L19.8045 18.7363L23.8003 12.9426C23.8715 12.8394 23.938 12.735 24 12.6296C25.8712 9.44592 23.5904 5.33325 19.8045 5.33325C15.8931 5.33325 13.5882 9.72274 15.8088 12.9426ZM19.9234 12.494C21.1444 12.4321 22.1153 11.4225 22.1153 10.1861C22.1153 8.90983 21.0807 7.87521 19.8045 7.87521C18.5909 7.87521 17.5958 8.81071 17.501 9.99992C17.4961 10.0613 17.4938 10.1234 17.4938 10.1861C17.4938 11.4623 18.5284 12.4969 19.8046 12.497M19.8046 12.497C19.8444 12.497 19.8841 12.496 19.9234 12.494L19.8046 12.497Z",
                    fill: props.primaryColor ?? "#172b4d"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                    d: "M21.3333 22.6666V20.0426L24 16.1759V25.3333H8V9.99992H12.9424C12.9149 10.8857 13.0615 11.7906 13.4072 12.6666H10.6667V22.6666H21.3333Z",
                    fill: props.primaryColor ?? "#172b4d"
                })
            ]
        }),
    mosaic_compass: (props)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64467_13333",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64467_13333)",
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                            d: "M14.6665 16.0001C14.6665 15.2667 15.2665 14.6667 15.9998 14.6667C16.7332 14.6667 17.3332 15.2667 17.3332 16.0001C17.3332 16.7334 16.7332 17.3334 15.9998 17.3334C15.2665 17.3334 14.6665 16.7334 14.6665 16.0001Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M16.0002 26.6666C21.8935 26.6666 26.6668 21.8933 26.6668 15.9999C26.6668 10.1066 21.8935 5.33325 16.0002 5.33325C10.1068 5.33325 5.3335 10.1066 5.3335 15.9999C5.3335 21.8933 10.1068 26.6666 16.0002 26.6666ZM21.3335 10.6666L13.3335 13.3333L10.6668 21.3333L18.6668 18.6666L21.3335 10.6666Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    mosaic_megaphone: (props)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64493_847",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64493_847)",
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                            d: "M26 5.33325L16 9.33325V19.9999L26 23.9999V5.33325Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                            d: "M13.3335 10H5.3335V19.3333H9.3335V25.3333H13.3335V10Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    "more-vertical": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($cc33747d1cecda1d$exports))), {
            ...props
        }),
    "editor-panel": (props)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fca087c29e5c69a5$exports))), {
            ...props
        }),
    one: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
            css: $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $cb0e8fe57b0fd046$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($cb0e8fe57b0fd046$export$ff775019b5b6e7df || ($cb0e8fe57b0fd046$export$ff775019b5b6e7df = {}));
let $cb0e8fe57b0fd046$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($cb0e8fe57b0fd046$export$b3241a99d3e47e02 || ($cb0e8fe57b0fd046$export$b3241a99d3e47e02 = {}));
const $cb0e8fe57b0fd046$export$f04a61298a47a40f = ({ type: type, size: size = $cb0e8fe57b0fd046$export$ff775019b5b6e7df.MEDIUM, rotation: rotation = $cb0e8fe57b0fd046$export$b3241a99d3e47e02.ZERO, alt: alt = "", color: color, hoverColor: hoverColor, activeColor: activeColor })=>{
    const icon = (0, $acw62.useMemo)(()=>$cb0e8fe57b0fd046$export$df03f54e09e486fa[type], [
        type
    ]);
    const isCoreIcon = $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$CORE_ICONS.includes(type);
    // Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
    // Glyph icons use 'primaryColor' prop
    const iconProps = isCoreIcon ? {
        size: size,
        label: alt,
        color: color || "currentColor",
        testId: type
    } : {
        size: size,
        label: alt,
        primaryColor: color || undefined,
        testId: type
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
        css: [
            $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$baseStyles,
            $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon(iconProps) : null
    });
};
const $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$baseStyles = (0, $gyDKM.css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $gyDKM.css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $gyDKM.css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $gyDKM.css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $gyDKM.css)({
        transform: "rotate(270deg)"
    })
};
const $cb0e8fe57b0fd046$var$$a02a6f7de308273b$var$iconNumberStyles = (0, $gyDKM.css)({
    fontSize: "16px"
});
var $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$exports, "Image", ()=>$cb0e8fe57b0fd046$export$3e431a229df88919);
/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $cb0e8fe57b0fd046$export$3e431a229df88919 = ({ inspectMode: inspectMode, src: src, alt: alt, width: width, height: height, caption: caption = "", size: size, center: center = true, preventModal: preventModal = false, onClick: onClick, ...props })=>{
    const rightToolsRef = (0, $acw62.useRef)(null);
    const downloadButtonRef = (0, $acw62.useRef)(null);
    const modalImgRef = (0, $acw62.useRef)(null);
    const originalImgRef = (0, $acw62.useRef)(null);
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const [showControls, setShowControls] = (0, $acw62.useState)(false);
    const [totalZoom, setTotalZoom] = (0, $acw62.useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $acw62.useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $acw62.useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $acw62.useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer ?? undefined);
    }, [
        showControls
    ]);
    (0, $acw62.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $acw62.useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick,
        preventModal
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $acw62.useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            showModal && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: [
                                $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $gyDKM.css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $gyDKM.css)({
                                    opacity: 0
                                })
                            ],
                            children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $5e26c99fa43b3c99$export$c6930421db9fa514)
                                                })
                                            }),
                                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                                css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                                        css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                                                        css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        className: "right",
                                        ref: rightToolsRef,
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $gyDKM.css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$downloadImage(src, $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $77dbe26168790d25$export$2e2bcd8739ae039), {
                            css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $gyDKM.css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: [
                                $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $gyDKM.css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $gyDKM.css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        css: (0, $gyDKM.css)({
                                            color: (0, $5e26c99fa43b3c99$export$5368d76ae4fbbda7)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("image", inspectMode),
                css: (0, $gyDKM.css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("figure", {
                    css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $gyDKM.css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $gyDKM.css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $gyDKM.css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $gyDKM.css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`,
                                maxWidth: "100vw"
                            },
                            css: $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalStyles = (0, $gyDKM.css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalContentStyles = (0, $gyDKM.css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    overflow: "hidden",
    "& img": {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        width: "auto",
        height: "auto"
    }
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalControlsStyles = (0, $gyDKM.css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $5e26c99fa43b3c99$export$5368d76ae4fbbda7)} !important`
    }
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$textContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    color: (0, $5e26c99fa43b3c99$export$5368d76ae4fbbda7)
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$iconContainerStyles = (0, $gyDKM.css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$imageContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$badgeContentStyles = (0, $gyDKM.css)({
    margin: 0
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $gyDKM.css)({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    WebkitOverflowScrolling: "touch"
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$modalToolsStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $5e26c99fa43b3c99$export$5368d76ae4fbbda7)} !important`
    }
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $gyDKM.css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$figureStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$var$captionContainerStyles = (0, $gyDKM.css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest")
});
var $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$c0c01354ab9765ae$exports, "InvertedIconButton", ()=>$cb0e8fe57b0fd046$export$dd09d7da2da4d16f);
const $cb0e8fe57b0fd046$export$dd09d7da2da4d16f = ({ icon: icon, onClick: onClick, ariaLabel: ariaLabel, disabled: disabled = false, selected: selected = false, tooltip: tooltip, testId: testId = "inverted-icon-button" })=>{
    const button = (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
        css: [
            $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$var$baseStyles,
            selected && $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$var$selectedStyles,
            disabled && $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$var$disabledStyles
        ],
        onClick: onClick,
        "aria-label": ariaLabel,
        disabled: disabled,
        "data-testid": testId,
        type: "button",
        children: icon
    });
    return tooltip && !disabled ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $3bb76fb59b0ba000$export$2e2bcd8739ae039), {
        content: tooltip,
        testId: `${testId}-tooltip`,
        children: button
    }) : button;
};
const $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$var$baseStyles = (0, $gyDKM.css)({
    background: "transparent",
    border: "none",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
    width: "32px",
    height: "32px",
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    },
    // Ensure icon inherits the white color
    "& > span": {
        color: "inherit"
    }
});
const $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$var$selectedStyles = (0, $gyDKM.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.32)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.40)"
    }
});
const $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$var$disabledStyles = (0, $gyDKM.css)({
    cursor: "not-allowed",
    opacity: 0.4,
    "&:hover": {
        backgroundColor: "transparent"
    },
    "&:active": {
        backgroundColor: "transparent"
    }
});
var $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$exports, "LinkStyle", ()=>$cb0e8fe57b0fd046$export$2b77966d73aefa77);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$exports, "LinkSize", ()=>$cb0e8fe57b0fd046$export$be4c932f76c19adf);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$exports, "Link", ()=>$cb0e8fe57b0fd046$export$a6c7ac8248d6e38a);
let $cb0e8fe57b0fd046$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($cb0e8fe57b0fd046$export$2b77966d73aefa77 || ($cb0e8fe57b0fd046$export$2b77966d73aefa77 = {}));
let $cb0e8fe57b0fd046$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["EXTRA_LARGE"] = "extraLarge";
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($cb0e8fe57b0fd046$export$be4c932f76c19adf || ($cb0e8fe57b0fd046$export$be4c932f76c19adf = {}));
const $cb0e8fe57b0fd046$export$a6c7ac8248d6e38a = ({ label: label, fontColor: fontColor = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.blue"), target: target = "_self", link: link, style: style = $cb0e8fe57b0fd046$export$2b77966d73aefa77.REGULAR, icon: icon, onClick: onClick, size: size = $cb0e8fe57b0fd046$export$be4c932f76c19adf.MEDIUM, ...props })=>{
    const clickHandler = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$sizeStyles[size],
            $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$variantStyles[style].base,
            $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$baseStyles,
            $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $gyDKM.css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        /** @ts-expect-error - onKeyDown is not typed correctly */ onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            icon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$iconContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$baseStyles = (0, $gyDKM.css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    },
    extraLarge: {
        fontSize: "24px",
        lineHeight: "32px"
    }
};
const $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $gyDKM.css)({
            fontWeight: "normal"
        }),
        hover: (0, $gyDKM.css)({
            "&:hover": {
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $gyDKM.css)({
            fontWeight: 600
        }),
        hover: (0, $gyDKM.css)({
            "&:hover": {
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link")
            }
        })
    }
};
const $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};
var $cb0e8fe57b0fd046$var$$800df40a54823a3f$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$800df40a54823a3f$exports, "List", ()=>$cb0e8fe57b0fd046$export$54c2e3dc7acea9f5);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$800df40a54823a3f$exports, "variantsListStyles", ()=>$cb0e8fe57b0fd046$export$6427468642e6e9fe);
const $cb0e8fe57b0fd046$export$54c2e3dc7acea9f5 = ({ type: type = "unordered", textStyleType: textStyleType = "regular", children: children })=>{
    if (type === "ordered") return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ol", {
        "aria-label": "ordered",
        css: [
            $cb0e8fe57b0fd046$var$$800df40a54823a3f$var$listStyles,
            (0, $gyDKM.css)($cb0e8fe57b0fd046$export$6427468642e6e9fe.list[type]),
            $cb0e8fe57b0fd046$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
        "aria-label": "unordered",
        css: [
            $cb0e8fe57b0fd046$var$$800df40a54823a3f$var$listStyles,
            (0, $gyDKM.css)($cb0e8fe57b0fd046$export$6427468642e6e9fe.list[type]),
            $cb0e8fe57b0fd046$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $cb0e8fe57b0fd046$var$$800df40a54823a3f$var$listStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    ...$cb0e8fe57b0fd046$var$$800df40a54823a3f$var$fontSizeStyles,
    span: $cb0e8fe57b0fd046$var$$800df40a54823a3f$var$fontSizeStyles
});
const $cb0e8fe57b0fd046$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-of-type), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-of-type), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $gyDKM.css)({
            fontWeight: 400
        }),
        italic: (0, $gyDKM.css)({
            fontStyle: "italic"
        }),
        bold: (0, $gyDKM.css)({
            fontWeight: 700
        }),
        boldItalic: (0, $gyDKM.css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};
var $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "NavigationBar", ()=>$cb0e8fe57b0fd046$export$214ae410b202e65a);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "NavBarLinkItem", ()=>$cb0e8fe57b0fd046$export$e76239e22e3abad);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "NavBarProfileItem", ()=>$cb0e8fe57b0fd046$export$1cba3806e1f1b01d);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "AtlassianNavLogo", ()=>$cb0e8fe57b0fd046$export$6ce3be5638d8e2a);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "MenuItem", ()=>$cb0e8fe57b0fd046$export$2ce376c2cc3355c8);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "NavBarExpandableItem", ()=>$cb0e8fe57b0fd046$export$1229978ae51a03a8);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "NavbarSlideMenuItem", ()=>$cb0e8fe57b0fd046$export$c7fcbaf97c146aec);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports, "NavBarItemWithMenu", ()=>$cb0e8fe57b0fd046$export$2771c1f4a09ce668);
const $cb0e8fe57b0fd046$var$$6a34d18c8d59b475$var$CloseIcon = ()=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $cb0e8fe57b0fd046$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$6a34d18c8d59b475$var$CloseIcon;
const $cb0e8fe57b0fd046$var$$5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $cb0e8fe57b0fd046$var$$5ba5f450ff826a14$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$5ba5f450ff826a14$var$HamburgerMenuIcon;
const $cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767,
        MEDIA_QUERY: "@media (max-width: 767px)"
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279,
        MEDIA_QUERY: "@media (min-width: 768px) and (max-width: 1279px)"
    },
    DESKTOP: {
        MIN_WIDTH: 1280,
        MEDIA_QUERY: "@media (min-width: 1280px)"
    }
};
var $cb0e8fe57b0fd046$var$$965a3cfbe886b380$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$965a3cfbe886b380$exports, "useOutsideClickHandler", ()=>$cb0e8fe57b0fd046$export$aa79b0abe3dfeaba);
const $cb0e8fe57b0fd046$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $acw62.useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};
const $cb0e8fe57b0fd046$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref, label: label, logoSubtitle: logoSubtitle })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
        css: $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$containerStyles,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        css: $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $842d1a7a26358f8d$export$8a485e2e7ed91e8f), {
                            testId: "mobile"
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        css: $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6141941182815d45$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$dividerStyles
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                href: subtitleHref,
                css: $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $gyDKM.css)({
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $gyDKM.css)({
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.brand")
        }
    },
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$dividerStyles = (0, $gyDKM.css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $cb0e8fe57b0fd046$var$$90d3cbebafca1fdb$var$subtitleStyles = (0, $gyDKM.css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.brand"),
        textDecoration: "none"
    }
});
const $cb0e8fe57b0fd046$var$$ff532043ef39c56f$var$SlideMenuContext = (0, $acw62.createContext)(undefined);
const $cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$74d704c90f90362c = ()=>{
    const context = (0, $acw62.useContext)($cb0e8fe57b0fd046$var$$ff532043ef39c56f$var$SlideMenuContext);
    if (!context) throw new Error("useSlideMenuContext must be used within a SlideMenuContextProvider");
    return context;
};
const $cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd = ({ children: children })=>{
    const [slideMenuContent, setSlideMenuContent] = (0, $acw62.useState)(null);
    const [isSlideMenuOpen, setIsSlideMenuOpen] = (0, $acw62.useState)(false);
    const [containerHeight, setContainerHeight] = (0, $acw62.useState)("initial");
    const openSlideMenu = (content)=>{
        setSlideMenuContent(content);
        setIsSlideMenuOpen(true);
    };
    const closeSlideMenu = ()=>{
        setIsSlideMenuOpen(false);
    };
    const contextValue = (0, $acw62.useMemo)(()=>({
            slideMenuContent: slideMenuContent,
            isSlideMenuOpen: isSlideMenuOpen,
            openSlideMenu: openSlideMenu,
            closeSlideMenu: closeSlideMenu,
            containerHeight: containerHeight,
            setContainerHeight: setContainerHeight
        }), [
        slideMenuContent,
        isSlideMenuOpen,
        containerHeight
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$ff532043ef39c56f$var$SlideMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $cb0e8fe57b0fd046$export$2771c1f4a09ce668 = ({ headerContent: headerContent, bodyContent: bodyContent, isNested: isNested = false, isActive: isActive = false })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$containerStyles,
        role: "group",
        "data-testid": "navbar-menu-item",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$headerStyles,
                    isActive && $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$headerSelectedStyles,
                    isNested && $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$nestedHeaderStyles
                ],
                role: "treeitem",
                "aria-selected": isActive,
                children: headerContent
            }),
            isActive && bodyContent && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                css: [
                    $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$bodyContentContainerStyles,
                    isNested && $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles
                ],
                children: bodyContent
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$headerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`
});
const $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$headerSelectedStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
    "a, span": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$nestedHeaderStyles = (0, $gyDKM.css)({
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")}`
});
const $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$bodyContentContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: 0,
    margin: 0,
    marginTop: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} !important`,
    listStyle: "none"
});
const $cb0e8fe57b0fd046$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles = (0, $gyDKM.css)({
    li: {
        paddingLeft: "56px"
    }
});
var $cb0e8fe57b0fd046$var$$6e8a4d5d78071ed7$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$6e8a4d5d78071ed7$exports, "useMediaQuery", ()=>$cb0e8fe57b0fd046$export$32d5543ab307c01);
const $cb0e8fe57b0fd046$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $acw62.useState)(false);
    const updateTarget = (0, $acw62.useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    // mediaQuery and updateTarget intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return targetReached;
};
const $cb0e8fe57b0fd046$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link, shouldRedirect: shouldRedirect, isSelected: isSelected })=>{
    const { text: text, href: href, onClick: onClick, target: target } = link;
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        css: [
            $cb0e8fe57b0fd046$var$$3e3d20b49785004a$var$linkStyles.default,
            isSelected && $cb0e8fe57b0fd046$var$$3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $cb0e8fe57b0fd046$export$e76239e22e3abad = ({ isSelected: isSelected = false, link: link, expandableBodyContent: expandableBodyContent, isNested: isNested = false, showNewMenu: showNewMenu = false })=>{
    const isBreakpoint = $cb0e8fe57b0fd046$export$32d5543ab307c01(`(max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return showNewMenu ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2771c1f4a09ce668, {
        headerContent: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested,
        isActive: isSelected
    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$1229978ae51a03a8, {
        headerContent: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$3e3d20b49785004a$var$buttonDivStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $cb0e8fe57b0fd046$var$$3e3d20b49785004a$var$buttonDivStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $cb0e8fe57b0fd046$var$$3e3d20b49785004a$var$linkStyles = {
    default: (0, $gyDKM.css)({
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.information")
        },
        [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $gyDKM.css)({
        [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
        }
    })
};
const $cb0e8fe57b0fd046$export$1229978ae51a03a8 = ({ headerContent: headerContent, expandedHeaderContent: expandedHeaderContent, bodyContent: bodyContent, onExpandClick: onExpandClick, isNested: isNested = false })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
            children: [
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: [
                        $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    tabIndex: 0,
                    "aria-selected": isOpen,
                    onClick: onExpandClickHandler,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onExpandClickHandler();
                        }
                    },
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: isOpen && $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($hw8Qv))), {
                                label: "Collapse item"
                            }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($heRj3))), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                    css: [
                        $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            tabIndex: 0,
            "aria-selected": false,
            children: headerContent
        })
    });
};
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$headerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
    a: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    },
    span: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $gyDKM.css)({
    padding: "0 40px"
});
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $gyDKM.css)({
    li: {
        paddingLeft: "56px"
    }
});
const $cb0e8fe57b0fd046$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $gyDKM.css)({
    svg: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $cb0e8fe57b0fd046$export$c7fcbaf97c146aec = ({ title: title, menuHeader: menuHeader, menuContent: menuContent, type: type = "menuItem" })=>{
    const { openSlideMenu: openSlideMenu } = $cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleOpenMenu = (0, $acw62.useCallback)(()=>{
        openSlideMenu({
            header: menuHeader || title,
            content: menuContent
        });
    }, [
        openSlideMenu,
        menuHeader,
        title,
        menuContent
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleOpenMenu);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
        "data-testid": "navbar-slide-menu-item",
        css: [
            $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$listItemStyles,
            type === "subMenuItem" && $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$subMenuItemStyles
        ],
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            role: "button",
            tabIndex: 0,
            css: $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$interactiveContentStyles,
            onClick: handleOpenMenu,
            onKeyDown: onKeyDown,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$titleStyles,
                    children: title
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    size: "medium"
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$titleStyles = (0, $gyDKM.css)({
    fontSize: "16px",
    fontWeight: 400
});
const $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$listItemStyles = (0, $gyDKM.css)({});
const $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$interactiveContentStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`,
    paddingRight: "18px",
    height: "32px",
    "&:hover": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link")
    }
});
const $cb0e8fe57b0fd046$var$$67abd1c503eb8615$var$subMenuItemStyles = (0, $gyDKM.css)({
    "& > div": {
        padding: `0 18px 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")}`
    }
});
const $cb0e8fe57b0fd046$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$397a78fff494027c$var$headerContentStyles,
            isExpanded && $cb0e8fe57b0fd046$var$$397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $8ba2d884d9509fca$export$2e2bcd8739ae039), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $cb0e8fe57b0fd046$export$1cba3806e1f1b01d = ({ user: user, expandableMenuContent: expandableMenuContent, profileMenuContent: profileMenuContent, onProfileMenuClick: onProfileMenuClick, showNewMenu: showNewMenu = false })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    const isBreakpoint = $cb0e8fe57b0fd046$export$32d5543ab307c01(`(max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $acw62.useRef)(null);
    $cb0e8fe57b0fd046$export$aa79b0abe3dfeaba([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return showNewMenu ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c7fcbaf97c146aec, {
        title: $cb0e8fe57b0fd046$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        menuHeader: $cb0e8fe57b0fd046$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        menuContent: expandableMenuContent
    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$1229978ae51a03a8, {
        headerContent: $cb0e8fe57b0fd046$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $cb0e8fe57b0fd046$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
        ref: avatarMenuRef,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                css: [
                    $cb0e8fe57b0fd046$var$$397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $cb0e8fe57b0fd046$var$$397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $8ba2d884d9509fca$export$2e2bcd8739ae039), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                css: $cb0e8fe57b0fd046$var$$397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $cb0e8fe57b0fd046$var$$397a78fff494027c$var$headerContentStyles = (0, $gyDKM.css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem",
    lineHeight: "20px"
});
const $cb0e8fe57b0fd046$var$$397a78fff494027c$var$nameStyles = (0, $gyDKM.css)({
    alignSelf: "center"
});
const $cb0e8fe57b0fd046$var$$397a78fff494027c$var$avatarStyles = (0, $gyDKM.css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$397a78fff494027c$var$avatarUserSelectedStyles = (0, $gyDKM.css)({
    "& > * > span": {
        outline: `2px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")} solid`
    }
});
const $cb0e8fe57b0fd046$var$$397a78fff494027c$var$openMenuStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});
const $cb0e8fe57b0fd046$export$2ce376c2cc3355c8 = ({ link: link, type: type, contentBefore: contentBefore, contentAfter: contentAfter })=>{
    const { href: href, onClick: onClick, text: text, icon: icon } = link;
    const isActive = (0, $acw62.useMemo)(()=>href && globalThis ? globalThis.location.pathname === href : false, [
        href
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        css: $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("li", {
            css: [
                $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$menuItemContainerStyles[type],
                isActive && $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$activeStyles
            ],
            role: "treeitem",
            "aria-selected": isActive,
            children: [
                contentBefore,
                text,
                icon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$iconStyles,
                    children: icon
                }),
                contentAfter
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $gyDKM.css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $gyDKM.css)({
        height: "48px",
        padding: "0 24px"
    }),
    menuItem: (0, $gyDKM.css)({
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        height: "32px",
        padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
    })
};
const $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$menuLinkStyles = (0, $gyDKM.css)({
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        }
    }
});
const $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$activeStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
});
const $cb0e8fe57b0fd046$var$$3539883ac1727dfc$var$iconStyles = (0, $gyDKM.css)({
    display: "inline-flex",
    alignItems: "center",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$export$a24e9349d70a402 = ({ navRef: navRef })=>{
    const navWrapperTopPosition = (0, $acw62.useMemo)(()=>navRef.current?.getBoundingClientRect()?.y || 56, [
        navRef
    ]);
    const ref = (0, $acw62.useRef)(null);
    const { closeSlideMenu: closeSlideMenu, slideMenuContent: slideMenuContent, isSlideMenuOpen: isSlideMenuOpen, setContainerHeight: setContainerHeight } = $cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const { header: header, content: content } = slideMenuContent || {};
    const isTitleString = typeof header === "string";
    (0, $acw62.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const preventScroll = (e)=>{
            if (element.contains(e.target)) return;
            e.preventDefault();
        };
        element.addEventListener("wheel", preventScroll);
        element.addEventListener("touchmove", preventScroll);
        return ()=>{
            element.removeEventListener("wheel", preventScroll);
            element.removeEventListener("touchmove", preventScroll);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isSlideMenuOpen) setContainerHeight(ref.current?.getBoundingClientRect().height || "initial");
    // setContainerHeight intentionally excluded (stable setState function)
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        isSlideMenuOpen
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        ref: ref,
        "data-testid": "slide-menu",
        css: [
            $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$menuStyles,
            (0, $gyDKM.css)({
                maxHeight: `calc(100vh - ${navWrapperTopPosition}px)`
            })
        ],
        "aria-hidden": !isSlideMenuOpen,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$backButtonContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.LINK,
                    onClick: closeSlideMenu,
                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "chevron-left",
                        size: "medium"
                    }),
                    label: "Back"
                })
            }),
            header && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    !isTitleString && $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$headerStyles,
                    isTitleString && $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$titleStyles
                ],
                children: header
            }),
            content && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$contentStyles,
                children: content
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$menuStyles = (0, $gyDKM.css)({
    position: "fixed",
    width: "375px",
    overflow: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    zIndex: 1000,
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    top: 0,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        transition: "transform 0.3s cubic-bezier(.4,1,.5,1), opacity 0.3s",
        transform: "translateX(-100%)",
        left: 0,
        width: "100vw"
    }
});
const $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$backButtonContainerStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    "& button": {
        padding: 0,
        marginLeft: "-9px",
        fontWeight: 400
    }
});
const $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$headerStyles = (0, $gyDKM.css)({
    textTransform: "uppercase",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    "& > div": {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$titleStyles = (0, $gyDKM.css)({
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    fontFamily: "Charlie Text, sans-serif",
    textTransform: "uppercase",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")
});
const $cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$var$contentStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH = 375;
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen, toggleMenu: toggleMenu })=>{
    const { closeSlideMenu: closeSlideMenu } = $cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleToggle = ()=>{
        toggleMenu();
        if (isOpen) closeSlideMenu();
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $cbba28d57dbc8c95$export$2e2bcd8739ae039), {
        appearance: "subtle",
        onClick: handleToggle,
        icon: isOpen ? $cb0e8fe57b0fd046$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 : $cb0e8fe57b0fd046$var$$5ba5f450ff826a14$export$2e2bcd8739ae039,
        label: isOpen ? "Close menu" : "Open menu"
    });
};
const $cb0e8fe57b0fd046$export$214ae410b202e65a = ({ leftItems: leftItems, rightItems: rightItems, logoItem: logoItem, isSticky: isSticky = true, onMenuToggleClick: onMenuToggleClick, onMenuOutsideClick: onMenuOutsideClick })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $acw62.useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("nav", {
        css: [
            $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: (0, $115bf1020744eac3$export$25062201e9e25d76)($cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd, {
                        children: [
                            leftItems || rightItems ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                                ref: toggleRef,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$ToggleButton, {
                                    isOpen: isMenuOpen,
                                    toggleMenu: handleToggle
                                })
                            }) : null,
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$DesktopNavItems, {
                                leftItems: leftItems,
                                rightItems: rightItems
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$SmallNavItems, {
                                isMenuOpen: isMenuOpen,
                                setIsMenuOpen: setIsMenuOpen,
                                onMenuOutsideClick: onMenuOutsideClick,
                                leftItems: leftItems,
                                rightItems: rightItems,
                                toggleRef: toggleRef
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            leftItems?.map((item, index)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                    css: [
                        $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                    css: [
                        $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
        css: $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen, onMenuOutsideClick: onMenuOutsideClick, leftItems: leftItems, rightItems: rightItems, toggleRef: toggleRef })=>{
    const navRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const slideMenuWrapperRef = (0, $acw62.useRef)(null);
    const { isSlideMenuOpen: isSlideMenuOpen, containerHeight: containerHeight, closeSlideMenu: closeSlideMenu } = $cb0e8fe57b0fd046$var$$ff532043ef39c56f$export$74d704c90f90362c();
    $cb0e8fe57b0fd046$export$aa79b0abe3dfeaba([
        menuRef,
        slideMenuWrapperRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            closeSlideMenu();
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        ref: navRef,
        css: [
            $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles,
            isSlideMenuOpen && (0, $gyDKM.css)({
                height: containerHeight
            })
        ],
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                ref: slideMenuWrapperRef,
                css: [
                    $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$slideMenuStyles,
                    isSlideMenuOpen && $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles,
                    !isSlideMenuOpen && $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$e2bb601faa5fb56f$export$a24e9349d70a402, {
                    navRef: navRef
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles,
                    isSlideMenuOpen && $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                    css: $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavUlStyles,
                    ref: menuRef,
                    role: "menubar",
                    "aria-orientation": "vertical",
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$MenuItems, {
                        leftItems: leftItems,
                        rightItems: rightItems
                    })
                })
            })
        ]
    }) : null;
};
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $gyDKM.css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles = (0, $gyDKM.css)({
    position: "relative",
    transition: "transform 0.4s cubic-bezier(.5,1,.5,1)",
    zIndex: 1,
    borderRadius: "8px"
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles = (0, $gyDKM.css)({
    transform: "translateX(0)",
    opacity: 1,
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)",
        top: "56px"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles = (0, $gyDKM.css)({
    transform: "translateX(-100%)",
    opacity: 0,
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(-100vw)",
        top: "56px"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles = (0, $gyDKM.css)({
    transform: `translateX(${$cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px)`,
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$slideMenuStyles = (0, $gyDKM.css)({
    position: "absolute",
    left: 0,
    top: 0,
    width: `${$cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
    height: "100%",
    zIndex: 2,
    transition: "height 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(.5,1,.5,1), opacity 0.2s",
    transform: "translateX(-100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        width: "100vw",
        position: "fixed",
        borderRadius: 0,
        height: "100%"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$containerStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$stickyStyles = (0, $gyDKM.css)({
    position: "fixed"
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$innerContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $gyDKM.css)({
    flex: 1,
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $gyDKM.css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.brand")
        }
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    overflow: "hidden",
    transition: "height 0.4s cubic-bezier(.5,1,.5,1)",
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MIN_WIDTH}px) and (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: `${$cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $gyDKM.css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$leftItemStyles = (0, $gyDKM.css)({
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$var$rightItemStyles = (0, $gyDKM.css)({
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});
var $cb0e8fe57b0fd046$var$$9efbb38deb40219f$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$9efbb38deb40219f$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9efbb38deb40219f$exports, "NavigationBarWithProfile", ()=>$cb0e8fe57b0fd046$export$fddd19fbf4d591d8);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9efbb38deb40219f$exports, "default", ()=>$cb0e8fe57b0fd046$var$$9efbb38deb40219f$export$2e2bcd8739ae039);
/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ const $cb0e8fe57b0fd046$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e76239e22e3abad, {
        ...rest
    });
};
/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ const $cb0e8fe57b0fd046$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children, onClick: onClick })=>{
    const noOp = ()=>{};
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: onClick ? handleKeyDown : undefined,
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    return {
        ...payload,
        source: "communityNavigation",
        attributes: {
            ...payload.attributes || {},
            currentApp: analyticsInfo.currentApp,
            isLoggedIn: analyticsInfo.isLoggedIn,
            isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
        }
    };
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo, subtitleHref: subtitleHref, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: $cb0e8fe57b0fd046$export$93d048dc21eb282a.HOME
                }
            }, analyticsInfo), $cb0e8fe57b0fd046$export$d778a884eb401313.NAV_LOGO_CLICK);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$6ce3be5638d8e2a, {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo, destinationApp: destinationApp, link: link, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), $cb0e8fe57b0fd046$export$d778a884eb401313.NAV_ITEM_CLICK);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b, {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $gyDKM.css)({
        padding: "0 24px"
    }) : undefined;
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $gyDKM.css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
            borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $gyDKM.css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$signupButtonStyles = (isMobile)=>(0, $gyDKM.css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$c421b2a9819014e7 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $cb0e8fe57b0fd046$export$d778a884eb401313.LOG_IN_CLICK);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                css: $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$loginButtonStyles(isMobile),
                href: href,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
                    appearance: "subtle",
                    children: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$46dbfbdf99745111
                })
            })
        })
    });
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$5f193ccad31822c4 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $cb0e8fe57b0fd046$export$d778a884eb401313.SIGN_UP_CLICK);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                css: $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$var$signupButtonStyles(isMobile),
                href: href,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
                    appearance: "primary",
                    children: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$4fe37309c24221ae
                })
            })
        })
    });
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $cb0e8fe57b0fd046$export$d778a884eb401313.PROFILE_MENU_OPEN : $cb0e8fe57b0fd046$export$d778a884eb401313.PROFILE_MENU_CLOSE);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$1cba3806e1f1b01d, {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $cb0e8fe57b0fd046$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo, link: link, type: type, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), $cb0e8fe57b0fd046$export$d778a884eb401313.PROFILE_MENU_ITEM_CLICK);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2ce376c2cc3355c8, {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $cb0e8fe57b0fd046$export$d778a884eb401313.MOBILE_MENU_OPEN : $cb0e8fe57b0fd046$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($cb0e8fe57b0fd046$export$3d7865934588d77e.UI, $cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), $cb0e8fe57b0fd046$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$214ae410b202e65a, {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};
const $cb0e8fe57b0fd046$var$$9efbb38deb40219f$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, switchHref, analyticsInfo)=>{
    const subMenuItems = [];
    if (profileHref) subMenuItems.push({
        ...$cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$668d072b293d5f38.PROFILE,
        href: profileHref
    });
    if (settingsHref) subMenuItems.push({
        ...$cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$668d072b293d5f38.SETTINGS,
        href: settingsHref
    });
    if (switchHref) subMenuItems.push({
        ...$cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$668d072b293d5f38.SWITCH_ACCOUNT,
        href: switchHref
    });
    if (logoutHref) subMenuItems.push({
        ...$cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$668d072b293d5f38.LOG_OUT,
        href: logoutHref
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: subMenuItems.map((item, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$92905cc84b82619c, {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $cb0e8fe57b0fd046$export$fddd19fbf4d591d8 = ({ logoItem: logoItem, leftItems: leftItems, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, onAnalyticsSendEvent: onAnalyticsSendEvent, isSticky: isSticky = true, showNewMenu: showNewMenu = false, currentApp: currentApp = "unknown" })=>{
    const isMobileOrTablet = $cb0e8fe57b0fd046$export$32d5543ab307c01(`(max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    // Set up analytics info
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Render right items based on login state
    const rightItems = [];
    if (isLoggedIn && user) rightItems.push((0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$55b351f575b2f75b, {
        user: user,
        expandableMenuContent: $cb0e8fe57b0fd046$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, showNewMenu ? "menuItem" : "subMenu", profileHref, settingsHref, switchHref, analyticsInfo),
        profileMenuContent: $cb0e8fe57b0fd046$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, switchHref, analyticsInfo),
        analyticsInfo: analyticsInfo,
        showNewMenu: showNewMenu
    }));
    else if (isMobileOrTablet) rightItems.push((0, $115bf1020744eac3$export$25062201e9e25d76)((0, $0f650ff017b0ad3b$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            }),
            signupHref && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            })
        ]
    }));
    else rightItems.push((0, $115bf1020744eac3$export$25062201e9e25d76)((0, $608d3c177085052d$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo
            }),
            signupHref && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo
            })
        ]
    }));
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$86a131c9ca6f534a, {
        logoItem: logoItem,
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};
var $cb0e8fe57b0fd046$var$$9efbb38deb40219f$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$export$fddd19fbf4d591d8;
var $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3fbcb32390ca7008$exports, "RadioType", ()=>$cb0e8fe57b0fd046$export$f5eff9f4cffe1e46);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3fbcb32390ca7008$exports, "RadioSize", ()=>$cb0e8fe57b0fd046$export$4da24539a3bb7d98);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3fbcb32390ca7008$exports, "Radio", ()=>$cb0e8fe57b0fd046$export$d7b12c4107be0d61);
let $cb0e8fe57b0fd046$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($cb0e8fe57b0fd046$export$f5eff9f4cffe1e46 || ($cb0e8fe57b0fd046$export$f5eff9f4cffe1e46 = {}));
let $cb0e8fe57b0fd046$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($cb0e8fe57b0fd046$export$4da24539a3bb7d98 || ($cb0e8fe57b0fd046$export$4da24539a3bb7d98 = {}));
const $cb0e8fe57b0fd046$export$d7b12c4107be0d61 = ({ label: label = "", name: name, isChecked: isChecked, setIsChecked: setIsChecked, type: type = $cb0e8fe57b0fd046$export$f5eff9f4cffe1e46.DEFAULT, size: size = $cb0e8fe57b0fd046$export$4da24539a3bb7d98.DEFAULT, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const handleChange = (0, $acw62.useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleChange);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$radioContainerStyles,
            size === $cb0e8fe57b0fd046$export$4da24539a3bb7d98.LARGE && (0, $gyDKM.css)({
                columnGap: "8px"
            })
        ],
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$labelStyles,
                size === $cb0e8fe57b0fd046$export$4da24539a3bb7d98.LARGE && $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$labelLargeStyles,
                type === $cb0e8fe57b0fd046$export$f5eff9f4cffe1e46.DISABLED && $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $gyDKM.css)({
                    fontWeight: 700
                }),
                !isBold && (0, $gyDKM.css)({
                    fontWeight: 400
                })
            ],
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    css: $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e61786c4aee8d415, {
                    children: label
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$checkmarkStyles,
                        size === $cb0e8fe57b0fd046$export$4da24539a3bb7d98.LARGE && $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $cb0e8fe57b0fd046$export$f5eff9f4cffe1e46.DANGER && (0, $gyDKM.css)({
                            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger")
                        })
                    ]
                }),
                isRequired && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: [
                        $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $cb0e8fe57b0fd046$export$4da24539a3bb7d98.LARGE && (0, $gyDKM.css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$radioContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    columnGap: "6px"
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$requiredMarkStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "2px"
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$inputStyles = (0, $gyDKM.css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$checkmarkStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "4px"
    }
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $gyDKM.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input")
    }
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$labelStyles = (0, $gyDKM.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$labelLargeStyles = (0, $gyDKM.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $gyDKM.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $gyDKM.css)({
            ":hover": {
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $gyDKM.css)({
            ":hover": {
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $gyDKM.css)({
            "&, &:hover": {
                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $gyDKM.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $cb0e8fe57b0fd046$var$$731a4fd527bab680$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$731a4fd527bab680$exports, "TabsSize", ()=>$cb0e8fe57b0fd046$export$ddadc1228c8dcfa);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$731a4fd527bab680$exports, "Tab", ()=>$cb0e8fe57b0fd046$export$3e41faf802a29e71);
let $cb0e8fe57b0fd046$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["SMALL"] = "small";
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($cb0e8fe57b0fd046$export$ddadc1228c8dcfa || ($cb0e8fe57b0fd046$export$ddadc1228c8dcfa = {}));
const $cb0e8fe57b0fd046$export$3e41faf802a29e71 = ({ label: label, labelColor: labelColor = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"), labelColorSelected: labelColorSelected = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"), labelColorSelectedHover: labelColorSelectedHover = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"), onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, size: size = $cb0e8fe57b0fd046$export$ddadc1228c8dcfa.MEDIUM, selected: selected = false, selectedColor: selectedColor, selectedHoverColor: selectedHoverColor, isLoading: isLoading })=>{
    const clickHandler = (0, $acw62.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabStyles["basic"],
            selected && $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`],
            labelColor && !selected && (0, $gyDKM.css)({
                color: labelColor
            }),
            labelColorSelected && selected && (0, $gyDKM.css)({
                color: labelColorSelected
            }),
            labelColorSelectedHover && selected && (0, $gyDKM.css)({
                "&:hover": {
                    color: labelColorSelectedHover
                }
            }),
            selected && selectedColor && (0, $gyDKM.css)({
                backgroundColor: selectedColor,
                borderColor: selectedColor
            }),
            selected && selectedHoverColor && (0, $gyDKM.css)({
                "&:hover": {
                    backgroundColor: selectedHoverColor,
                    borderColor: selectedHoverColor
                }
            })
        ],
        children: [
            iconBefore && !isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $gyDKM.css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $gyDKM.css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $gyDKM.css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabStyles = {
    basic: (0, $gyDKM.css)({
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        border: `0.125rem solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
            borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
        }
    }),
    selected: (0, $gyDKM.css)({
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.bold.pressed"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.brand.boldest"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabSpacingStyles = {
    small: (0, $gyDKM.css)({
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`,
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
            padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`
        }
    }),
    "small-icon-before": (0, $gyDKM.css)({
        padding: "0.375rem 1rem 0.375rem 0.5rem"
    }),
    "small-icon-after": (0, $gyDKM.css)({
        padding: "0.375rem 0.5rem 0.375rem 1rem"
    }),
    medium: (0, $gyDKM.css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $gyDKM.css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $gyDKM.css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $gyDKM.css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $gyDKM.css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $gyDKM.css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $cb0e8fe57b0fd046$var$$731a4fd527bab680$var$tabIconContainerStyles = (0, $gyDKM.css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$exports, "Tag", ()=>$cb0e8fe57b0fd046$export$3288d34c523a1192);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$exports, "tagListStyles", ()=>$cb0e8fe57b0fd046$export$f40d73b6f7f951e9);
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$buildCustomStyles = (labelColor, borderColor, backgroundColor, textTransform, fontWeight, fontFamily, padding)=>(0, $gyDKM.css)({
        ...labelColor && {
            color: labelColor
        },
        ...borderColor && {
            borderColor: borderColor
        },
        ...backgroundColor && {
            backgroundColor: backgroundColor
        },
        ...textTransform && {
            textTransform: textTransform
        },
        ...fontWeight && {
            fontWeight: fontWeight
        },
        ...padding && {
            padding: padding
        },
        ...fontFamily && {
            fontFamily: fontFamily
        }
    });
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$buildCustomTextStyles = (labelColor, fontWeight, textTransform, fontFamily, maxSize)=>(0, $gyDKM.css)({
        ...labelColor && {
            color: labelColor
        },
        ...fontWeight && {
            fontWeight: fontWeight
        },
        ...textTransform && {
            textTransform: textTransform
        },
        ...fontFamily && {
            fontFamily: fontFamily
        },
        ...maxSize && {
            maxWidth: maxSize,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }
    });
const $cb0e8fe57b0fd046$export$3288d34c523a1192 = ({ inspectMode: inspectMode, label: label, onClick: onClick, selected: selected, iconAfter: iconAfter, iconBefore: iconBefore, isLarge: isLarge, isTall: isTall, labelColor: labelColor, borderColor: borderColor, backgroundColor: backgroundColor, textTransform: textTransform, fontWeight: fontWeight, fontFamily: fontFamily, maxSize: maxSize, padding: padding })=>{
    const customStyles = $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$buildCustomStyles(labelColor, borderColor, backgroundColor, textTransform, fontWeight, fontFamily, padding);
    const customTextStyles = $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$buildCustomTextStyles(labelColor, fontWeight, textTransform, fontFamily, maxSize);
    const noOp = ()=>{};
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("tag", inspectMode),
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : -1,
        css: [
            $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$tagStyles,
            selected && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$afterIconTagStyles,
            isLarge && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$largeTagStyles,
            isTall && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$tallTagStyles,
            customStyles
        ],
        onClick: onClick,
        onKeyDown: onClick ? onKeyDown : undefined,
        children: [
            iconBefore && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    isLarge && $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$largeTagTextStyles,
                    customTextStyles
                ],
                children: label
            }),
            iconAfter && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: [
                    $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
};
const $cb0e8fe57b0fd046$export$f40d73b6f7f951e9 = (0, $gyDKM.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$tagStyles = (0, $gyDKM.css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`,
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $gyDKM.css)({
    "&:hover": {
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$selectedTagStyles = (0, $gyDKM.css)({
    borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$iconStyles = (0, $gyDKM.css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$beforeIconStyles = (0, $gyDKM.css)({
    marginRight: "0.125rem"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$afterIconStyles = (0, $gyDKM.css)({
    marginLeft: "0.125rem"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $gyDKM.css)({
    paddingLeft: "0.375rem"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $gyDKM.css)({
    paddingRight: "0.375rem"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$largeTagStyles = (0, $gyDKM.css)({
    display: "flex",
    height: "32px",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    textTransform: "uppercase",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$largeTagTextStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'var(--Font-Family-Eyebrow, "Charlie Text")',
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase"
});
const $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$var$tallTagStyles = (0, $gyDKM.css)({
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "6px",
    paddingRight: "6px",
    height: "auto"
});
var $cb0e8fe57b0fd046$var$$8b54d37779d052e8$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$8b54d37779d052e8$exports, "Text", ()=>$cb0e8fe57b0fd046$export$5f1af8db9871e1d6);
const $cb0e8fe57b0fd046$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular", size: size = "regular", color: color = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.gray.bolder"), children: children, backgroundColor: backgroundColor })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
        css: [
            $cb0e8fe57b0fd046$var$$8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $gyDKM.css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $gyDKM.css)({
                color: color
            }),
            $cb0e8fe57b0fd046$var$$8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $cb0e8fe57b0fd046$var$$8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $cb0e8fe57b0fd046$var$$8b54d37779d052e8$var$textDefaultStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    blockquote: $cb0e8fe57b0fd046$export$7a77f8e9665fa6b2,
    ul: $cb0e8fe57b0fd046$export$6427468642e6e9fe.list.unordered,
    ol: $cb0e8fe57b0fd046$export$6427468642e6e9fe.list.ordered
});
const $cb0e8fe57b0fd046$var$$8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $gyDKM.css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $gyDKM.css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $gyDKM.css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $gyDKM.css)({
            fontWeight: 400
        }),
        semibold: (0, $gyDKM.css)({
            fontWeight: 600
        }),
        bold: (0, $gyDKM.css)({
            fontWeight: 700
        })
    }
};
var $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9cfa05d02afa3952$exports, "AccordionSize", ()=>$cb0e8fe57b0fd046$export$8f89d78db9c8c41f);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9cfa05d02afa3952$exports, "Accordion", ()=>$cb0e8fe57b0fd046$export$a766cd26d0d69044);
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title, index: index, children: children, isFirstTab: isFirstTab, isExpanded: isExpanded, shouldSingleTabBeOpen: shouldSingleTabBeOpen, setTabState: setTabState, setExpansionMap: setExpansionMap })=>{
    const tabRef = (0, $acw62.useRef)(null);
    const handleExpand = (0, $acw62.useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        index,
        setExpansionMap,
        setTabState,
        shouldSingleTabBeOpen
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    isExpanded && $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$contentContainer,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: disableClickEventBubbling,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        css: $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$accordionTabStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$firstTabStyles = (0, $gyDKM.css)({
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$expandedTabStyles = (0, $gyDKM.css)({
    borderLeft: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.accent.blue")}`
});
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$expandedTabContentStyles = (0, $gyDKM.css)({
    marginLeft: "-0.5rem"
});
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$contentContainer = (0, $gyDKM.css)({
    marginLeft: "0.75rem"
});
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$titleStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$51f57eef4d47f918$var$contentStyles = (0, $gyDKM.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});
let $cb0e8fe57b0fd046$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
    AccordionSize["FULL_WIDTH"] = "full-width";
})($cb0e8fe57b0fd046$export$8f89d78db9c8c41f || ($cb0e8fe57b0fd046$export$8f89d78db9c8c41f = {}));
const $cb0e8fe57b0fd046$export$a766cd26d0d69044 = ({ tabsContent: tabsContent, size: size, shouldSingleTabBeOpen: shouldSingleTabBeOpen, onChange: onChange })=>{
    const [expansionMap, setExpansionMap] = (0, $acw62.useState)([]);
    const [tabState, setTabState] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    // tabsContent intentionally excluded to avoid re-initializing on content changes
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $acw62.useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$var$baseAccordionStyles,
            $cb0e8fe57b0fd046$export$8f89d78db9c8c41f.DEFAULT === size && $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$var$accordionDefaultStyles,
            $cb0e8fe57b0fd046$export$8f89d78db9c8c41f.WIDE === size && $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title, children: children, isExpanded: isExpanded }, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$51f57eef4d47f918$export$10e5e64ea66c812f, {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$var$baseAccordionStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$var$accordionDefaultStyles = (0, $gyDKM.css)({
    maxWidth: "720px"
});
const $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$var$accordionWideStyles = (0, $gyDKM.css)({
    maxWidth: "1020px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px"
    }
});
var $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$exports, "InlineCode", ()=>$cb0e8fe57b0fd046$export$7f1bf47c7f50a6aa);
const $cb0e8fe57b0fd046$export$7f1bf47c7f50a6aa = ({ code: code = "" })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("code", {
        "data-testid": "code-block",
        css: $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                css: [
                    $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $gyDKM.css)({
                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $gyDKM.css)({
                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                onBlur: ()=>setIsCopied(false),
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        className: "tooltipText",
                        css: $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "copy",
                        color: isCopied ? (0, $5e26c99fa43b3c99$export$29a4f05edc054374) : (0, $5e26c99fa43b3c99$export$7d61b15e0da132af)
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                children: lines?.map((line, index)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                        css: $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $gyDKM.css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $gyDKM.css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$codeLinesStyles = (0, $gyDKM.css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$lineNumberStyles = (0, $gyDKM.css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtler")
});
const $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$var$lineTextStyles = (0, $gyDKM.css)({
    padding: "4px 8px 4px 0"
});
var $cb0e8fe57b0fd046$var$$a467abe0c2c1750b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a467abe0c2c1750b$exports, "Lozenge", ()=>$cb0e8fe57b0fd046$export$a31cbe1bf5463979);
const $cb0e8fe57b0fd046$export$a31cbe1bf5463979 = ({ appearance: appearance = "default", text: text, isBold: isBold })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c3f6c0a74f7df502$export$2e2bcd8739ae039), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });
var $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$52124b9ae1d78e04$exports, "SectionMessageAppearance", ()=>$cb0e8fe57b0fd046$export$710836885d72543c);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$52124b9ae1d78e04$exports, "SectionMessage", ()=>$cb0e8fe57b0fd046$export$a36903bd214cec06);
let $cb0e8fe57b0fd046$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($cb0e8fe57b0fd046$export$710836885d72543c || ($cb0e8fe57b0fd046$export$710836885d72543c = {}));
const $cb0e8fe57b0fd046$export$a36903bd214cec06 = ({ children: children, appearance: appearance, fullWidth: fullWidth = false, padding: padding, title: title })=>{
    const isInfoWhite = appearance === $cb0e8fe57b0fd046$export$710836885d72543c.INFORMATION_WHITE;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles({
                padding: padding
            }),
            isInfoWhite && $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $gyDKM.css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$iconContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "info",
                    alt: "info icon",
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.accent.blue")
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$descriptionStyles,
                children: [
                    title && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                        level: 5,
                        children: title
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        children: children
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles = ({ padding: padding = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200") })=>(0, $gyDKM.css)({
        display: "flex",
        width: "100%",
        borderRadius: "3px",
        padding: padding,
        columnGap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
    });
const $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$informationStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.information")
});
const $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$informationWhiteStyles = (0, $gyDKM.css)({
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface")
});
const $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$iconContainerStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$var$descriptionStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    "& *": {
        fontSize: "16px !important"
    }
});
var $cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "SharedFooter", ()=>$cb0e8fe57b0fd046$export$7a92b4adf6bd95bb);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "MinimalSharedFooter", ()=>$cb0e8fe57b0fd046$export$8dce6dbf8ef18fcb);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "default", ()=>$cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$export$2e2bcd8739ae039);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "columnStyle", ()=>$cb0e8fe57b0fd046$export$c5f2190049e47f52);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "columnsContainerStyle", ()=>$cb0e8fe57b0fd046$export$220191dc35b80c46);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "headerStyle", ()=>$cb0e8fe57b0fd046$export$5939e41228734fb7);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "linkStyle", ()=>$cb0e8fe57b0fd046$export$a4c1071d1005664f);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports, "FooterLink", ()=>$cb0e8fe57b0fd046$export$e0513c91be1318ca);
var $cb0e8fe57b0fd046$var$$a0eced43682c2d75$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a0eced43682c2d75$exports, "LicenseModal", ()=>$cb0e8fe57b0fd046$export$bd0c6e28f5d6b66e);
const $cb0e8fe57b0fd046$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle, bodyTitle: bodyTitle, bodyDescription: bodyDescription, closeModal: closeModal, licenses: licenses })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $2de636e70f18707f$export$2e2bcd8739ae039), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $72c1af88d38e828a$export$2e2bcd8739ae039), {
                children: modalTitle && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $9e407589358cadb4$export$2e2bcd8739ae039), {
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        css: (0, $gyDKM.css)({
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.brand")
                        }),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6141941182815d45$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                            children: bodyDescription
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: (0, $gyDKM.css)({
                                    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} 0`
                                }),
                                children: (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                            css: $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                            css: (0, $gyDKM.css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }, license.packageName + index))
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $51c3a3d13ce0e3d4$export$2e2bcd8739ae039), {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$spacingContainerStyles = (0, $gyDKM.css)({
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} 0`
});
const $cb0e8fe57b0fd046$var$$a0eced43682c2d75$var$licenseTitleStyles = (0, $gyDKM.css)({
    fontWeight: 600
});
var $cb0e8fe57b0fd046$var$$795b38850428b3a7$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $cb0e8fe57b0fd046$var$$795b38850428b3a7$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $cb0e8fe57b0fd046$var$$795b38850428b3a7$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$795b38850428b3a7$require$Buffer.from($cb0e8fe57b0fd046$var$$795b38850428b3a7$var$svgStringDesktopFooterWider).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$795b38850428b3a7$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $cb0e8fe57b0fd046$var$$795b38850428b3a7$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$795b38850428b3a7$require$Buffer.from($cb0e8fe57b0fd046$var$$795b38850428b3a7$var$svgStringDesktopFooterWide).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$795b38850428b3a7$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $cb0e8fe57b0fd046$var$$795b38850428b3a7$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$795b38850428b3a7$require$Buffer.from($cb0e8fe57b0fd046$var$$795b38850428b3a7$var$svgStringMobileFooter).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3 = "@media (min-width: 768px) and (max-width: 1279px)";
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8 = "@media (max-width: 767px)";
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$77261562b77476b8 = "@media (min-width: 1280px)";
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$9f513872ee8f6246 = (0, $gyDKM.css)({
    width: "100%",
    backgroundImage: `url(${$cb0e8fe57b0fd046$var$$795b38850428b3a7$export$f3cfc44c4eba4576})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    boxSizing: "border-box",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        backgroundImage: `url(${$cb0e8fe57b0fd046$var$$795b38850428b3a7$export$7d22dc8c5b0cc81c})`
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        backgroundImage: `url(${$cb0e8fe57b0fd046$var$$795b38850428b3a7$export$eca0cf64e1927e60})`
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$12bbd02e39f3a749 = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$77261562b77476b8]: {
        maxWidth: "1234px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        maxWidth: "720px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$b3dee97a51489da1 = (0, $gyDKM.css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        padding: "0 16px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $cb0e8fe57b0fd046$export$a4c1071d1005664f = (0, $gyDKM.css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        cursor: "pointer"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$76b9e543844e8a5 = (0, $gyDKM.css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$313ce10a9f9c4472 = (0, $gyDKM.css)({
    width: "420px",
    display: "flex",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$2bc3a170ad333299 = (0, $gyDKM.css)({
    svg: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $cb0e8fe57b0fd046$export$220191dc35b80c46 = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        gap: "16px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $cb0e8fe57b0fd046$export$c5f2190049e47f52 = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $cb0e8fe57b0fd046$export$5939e41228734fb7 = (0, $gyDKM.css)({
    marginBottom: "4px"
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$17633131d02ad451 = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        padding: "0 0px"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$140449594731c4c9 = (0, $gyDKM.css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle")
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$55e15b718251f123 = (0, $gyDKM.css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209 = (0, $gyDKM.css)({
    display: "inline",
    marginLeft: "32px",
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginLeft: "0"
    }
});
const $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$b814e32be8f9cc9e = (0, $gyDKM.css)({
    [$cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
const $cb0e8fe57b0fd046$var$$5a3292f3bef31812$var$YEAR = new Date().getFullYear();
const $cb0e8fe57b0fd046$var$$5a3292f3bef31812$var$COPYRIGHT = `Copyright \xa9 ${$cb0e8fe57b0fd046$var$$5a3292f3bef31812$var$YEAR} Atlassian`;
const $cb0e8fe57b0fd046$export$e0513c91be1318ca = ({ href: href, onClick: onClick, text: text, styles: styles = [] })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        href: href,
        onClick: onClick,
        css: [
            $cb0e8fe57b0fd046$export$a4c1071d1005664f,
            ...styles
        ],
        children: text
    });
const $cb0e8fe57b0fd046$var$$5a3292f3bef31812$export$f769621e3a03739f = ({ termsUrl: termsUrl, nav: nav, reportAProblemCallback: reportAProblemCallback, licenseData: licenseData, policyLinkText: policyLinkText = "Notice at Collection", policyLinkHref: policyLinkHref = $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$6aafbda8e90312f0 })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const openModal = (0, $acw62.useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $acw62.useCallback)(()=>setIsOpen(false), []);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$9f513872ee8f6246,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$12bbd02e39f3a749,
            children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$b3dee97a51489da1,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$76b9e543844e8a5,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$313ce10a9f9c4472,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$2bc3a170ad333299,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $842d1a7a26358f8d$export$8a485e2e7ed91e8f), {})
                                })
                            }),
                            nav
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$17633131d02ad451,
                        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$55e15b718251f123,
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$140449594731c4c9,
                                    children: $cb0e8fe57b0fd046$var$$5a3292f3bef31812$var$COPYRIGHT
                                }),
                                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$b814e32be8f9cc9e,
                                    children: [
                                        reportAProblemCallback && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                                            href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                            text: "Privacy Policy",
                                            styles: [
                                                $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                            href: policyLinkHref,
                                            className: "atl-policy-link",
                                            css: $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209,
                                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                                css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                                                className: "atl-policy-link-text",
                                                children: policyLinkText
                                            })
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                                            href: termsUrl,
                                            text: "Terms",
                                            styles: [
                                                $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                                            href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$10bc455dcefd3f1f,
                                            text: "Security",
                                            styles: [
                                                $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        licenseData && (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                                            children: [
                                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $cb0e8fe57b0fd046$var$$85f029238a1d2eb6$export$e635e766db488209
                                                    ]
                                                }),
                                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $9e85ea5877acbb2a$export$2e2bcd8739ae039), {
                                                    children: isOpen && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$bd0c6e28f5d6b66e, {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$FORUMS_URL = $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$cb0e8fe57b0fd046$export$93d048dc21eb282a.FORUMS];
const $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? $cb0e8fe57b0fd046$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
        email: email,
        redirectUrl: url
    }) : url;
const $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$ABOUT_LEARNING_URL = "https://community.atlassian.com/learning/hub/resources-and-support/about-atlassian-learning";
const $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$RESOURCES_LEARNING_URL = "https://community.atlassian.com/learning/hub/resources-and-support";
const $cb0e8fe57b0fd046$var$$224bc56423ffe231$export$2680595b358b488a = ({ isLoggedIn: isLoggedIn = false, email: email })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$export$220191dc35b80c46,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$export$c5f2190049e47f52,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$export$5939e41228734fb7,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                        href: "/",
                        css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Community"
                        })
                    })
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$export$c5f2190049e47f52,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$export$5939e41228734fb7,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                            href: $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$getForumsUrl($cb0e8fe57b0fd046$var$$224bc56423ffe231$var$FORUMS_URL, isLoggedIn, email),
                            css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                                size: "medium",
                                fontWeight: "semibold",
                                children: "Forums"
                            })
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                        href: $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$getForumsUrl(`${$cb0e8fe57b0fd046$var$$224bc56423ffe231$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                        text: "FAQs"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                        href: $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$getForumsUrl(`${$cb0e8fe57b0fd046$var$$224bc56423ffe231$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                        text: "Forums guidelines"
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$export$c5f2190049e47f52,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$export$5939e41228734fb7,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                            href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$cb0e8fe57b0fd046$export$93d048dc21eb282a.LEARNING],
                            css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                                size: "medium",
                                fontWeight: "semibold",
                                children: "Learning"
                            })
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                        href: $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$ABOUT_LEARNING_URL,
                        text: "About learning"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e0513c91be1318ca, {
                        href: $cb0e8fe57b0fd046$var$$224bc56423ffe231$var$RESOURCES_LEARNING_URL,
                        text: "Resources"
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$export$c5f2190049e47f52,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$export$5939e41228734fb7,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                        href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$cb0e8fe57b0fd046$export$93d048dc21eb282a.EVENTS],
                        css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Events"
                        })
                    })
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$export$c5f2190049e47f52,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$export$5939e41228734fb7,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                        href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$cb0e8fe57b0fd046$export$93d048dc21eb282a.CHAMPIONS],
                        css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Champions"
                        })
                    })
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$export$c5f2190049e47f52,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$export$5939e41228734fb7,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                        href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$cb0e8fe57b0fd046$export$93d048dc21eb282a.APP_UPDATES],
                        css: $cb0e8fe57b0fd046$export$a4c1071d1005664f,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Release Notes"
                        })
                    })
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback, isLoggedIn: isLoggedIn = false, email: email, licenseData: licenseData, policyLinkText: policyLinkText, policyLinkHref: policyLinkHref })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$5a3292f3bef31812$export$f769621e3a03739f, {
        termsUrl: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
        reportAProblemCallback: reportAProblemCallback,
        licenseData: licenseData,
        policyLinkText: policyLinkText,
        policyLinkHref: policyLinkHref,
        nav: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$224bc56423ffe231$export$2680595b358b488a, {
            isLoggedIn: isLoggedIn,
            email: email
        })
    });
const $cb0e8fe57b0fd046$export$8dce6dbf8ef18fcb = ({ termsUrl: termsUrl, nav: nav, reportAProblemCallback: reportAProblemCallback, licenseData: licenseData, policyLinkText: policyLinkText, policyLinkHref: policyLinkHref })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$5a3292f3bef31812$export$f769621e3a03739f, {
        termsUrl: termsUrl,
        nav: nav,
        reportAProblemCallback: reportAProblemCallback,
        licenseData: licenseData,
        policyLinkText: policyLinkText,
        policyLinkHref: policyLinkHref
    });
var $cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$export$7a92b4adf6bd95bb;
var $cb0e8fe57b0fd046$var$$77696804880d7cdc$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$77696804880d7cdc$exports, "DropdownMenu", ()=>$cb0e8fe57b0fd046$export$e44a253a59704894);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$77696804880d7cdc$exports, "DropdownMenuCheckbox", ()=>$cb0e8fe57b0fd046$export$2393c31da95977ae);
// Main DropdownMenu component (config-based with items object or custom items array)
const $cb0e8fe57b0fd046$var$$0199732cf5257721$export$e960b0f5cc4a2826 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5b0027deb0fdc84f$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $76e82533643f974a$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $cb0e8fe57b0fd046$var$$77e170ce1d4ab374$export$a6155c53cd00116c = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $99f88b04cadef7b0$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $a1a9cbefdfbb6c8d$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $cb0e8fe57b0fd046$var$$0633f0dbed99c656$var$selectedItemStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected.hovered"),
    fontWeight: 600
});
const $cb0e8fe57b0fd046$var$$0633f0dbed99c656$var$iconMenuStyles = (0, $gyDKM.css)({
    "& button > span": {
        gap: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} !important`
    },
    // Ensure icon and text are vertically aligned
    '& button [role="img"]': {
        display: "flex !important"
    }
});
const $cb0e8fe57b0fd046$var$$0633f0dbed99c656$export$efefb5b75235a614 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        id: "actions",
        css: $cb0e8fe57b0fd046$var$$0633f0dbed99c656$var$iconMenuStyles,
        children: Object.entries(items).map(([label, value])=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: value.isSelected && $cb0e8fe57b0fd046$var$$0633f0dbed99c656$var$selectedItemStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $0c583eef1017b111$export$2e2bcd8739ae039), {
                    testId: `dropdown-item-${label}`,
                    isDisabled: value.isDisabled,
                    onClick: ()=>onItemClick(label),
                    elemBefore: value.icon,
                    children: label
                })
            }, label))
    });
};
const $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee = (0, $gyDKM.css)({
    "& > button": {
        border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.brand")}`,
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected"),
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$a6df230d684a2658 = (0, $gyDKM.css)({
    "#actions": {
        "button[disabled]": {
            background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
            span: {
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.disabled"),
                ":hover": {
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    }
});
const $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$e42df41f371072da = (0, $gyDKM.css)({
    "& > button": {
        border: 0,
        background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected")
    }
});
const $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5 = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$export$e44a253a59704894 = ({ items: items, placement: placement, onItemClick: onItemClick, customItems: customItems, isCheckboxMenu: isCheckboxMenu = false, triggerText: triggerText, customTriggerStyles: customTriggerStyles, customTriggerActiveStyles: customTriggerActiveStyles, customTriggerComponent: customTriggerComponent, isOptionMenu: isOptionMenu = false })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $acw62.useState)(false);
    const [itemsList, setItemList] = (0, $acw62.useState)(items ?? {});
    const isControlled = (0, $acw62.useRef)(false);
    const prevItemsRef = (0, $acw62.useRef)(items);
    // Check if we're using custom items mode
    const isCustomItemsMode = customItems && customItems.length > 0;
    (0, $acw62.useEffect)(()=>{
        if (!isCustomItemsMode && prevItemsRef.current !== items && items) {
            isControlled.current = true;
            setItemList(items);
            prevItemsRef.current = items;
        }
    }, [
        items,
        isCustomItemsMode
    ]);
    const handleItemClick = (label)=>{
        // Only update internal state if not controlled
        if (!isControlled.current) setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            if (isCheckboxMenu) updatedState[label].isSelected = !updatedState[label].isSelected;
            else Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        if (onItemClick) onItemClick(label);
    };
    const getTriggerText = (itemsChecked)=>{
        const selectedItems = Object.keys(itemsChecked).filter((key)=>itemsChecked[key].isSelected);
        if (isCheckboxMenu) {
            if (triggerText) return triggerText;
            // For checkbox mode, show count of selected items or first item name
            if (selectedItems.length === 0) return Object.keys(itemsChecked)[0] || "Select items";
            else if (selectedItems.length === 1) return selectedItems[0];
            return `${selectedItems.length} selected`;
        }
        if (triggerText) return triggerText;
        // For radio mode, show the selected item or first item
        return selectedItems[0] || Object.keys(itemsChecked)[0];
    };
    const renderTrigger = ()=>{
        const selectedItems = Object.keys(itemsList).filter((key)=>itemsList[key]?.isSelected);
        // If custom trigger component is provided, use it
        if (customTriggerComponent) return customTriggerComponent;
        // For custom items mode, just use the triggerText
        if (isCustomItemsMode) return triggerText || "Menu";
        // If checkbox mode with custom trigger text and selections, render custom trigger with badge
        if (isCheckboxMenu && triggerText && selectedItems.length > 0) return ({ triggerRef: triggerRef, ...triggerButtonProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                ...triggerButtonProps,
                ref: triggerRef,
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                    css: $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5,
                    children: [
                        triggerText,
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c3f6c0a74f7df502$export$2e2bcd8739ae039), {
                            isBold: true,
                            appearance: "inprogress",
                            children: selectedItems.length
                        })
                    ]
                })
            });
        // Otherwise return the text trigger
        return getTriggerText(itemsList);
    };
    const hasAnyIcons = Object.values(itemsList).some((item)=>item?.icon);
    const isAnyItemSelected = isCustomItemsMode ? false : Object.values(itemsList).some(({ isSelected: isSelected })=>isSelected);
    const renderMenuContent = ()=>{
        // Custom items mode - render custom DropdownItems
        if (isCustomItemsMode && customItems) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
            children: customItems.map((item, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $0c583eef1017b111$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    description: item.description,
                    elemBefore: item.elemBefore,
                    elemAfter: item.elemAfter,
                    testId: item.testId,
                    children: item.children
                }, item.testId ?? index))
        });
        if (isCheckboxMenu) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0199732cf5257721$export$e960b0f5cc4a2826, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        if (isOptionMenu || hasAnyIcons) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0633f0dbed99c656$export$efefb5b75235a614, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$77e170ce1d4ab374$export$a6155c53cd00116c, {
            items: itemsList,
            onItemClick: handleItemClick
        });
    };
    // Combine base styles with actions styles for full DropdownMenu styling
    const combinedTriggerStyles = (0, $gyDKM.css)([
        $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee,
        $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$a6df230d684a2658
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            combinedTriggerStyles,
            customTriggerStyles,
            isAnyItemSelected && isDropdownOpen && $cb0e8fe57b0fd046$var$$69215f50d6c9f1e0$export$e42df41f371072da,
            isAnyItemSelected && isDropdownOpen && customTriggerActiveStyles
        ],
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f8fc2edc4a47080d$export$2e2bcd8739ae039), {
            onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
            trigger: renderTrigger(),
            shouldRenderToParent: true,
            placement: placement,
            children: renderMenuContent()
        })
    });
};
const $cb0e8fe57b0fd046$export$2393c31da95977ae = (props)=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e44a253a59704894, {
        ...props,
        isCheckboxMenu: false
    });
};
var $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$exports, "GreetingCard", ()=>$cb0e8fe57b0fd046$export$e52b3c28ffecde23);
const $cb0e8fe57b0fd046$var$$7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("defs", {
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip0_511_7308",
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip1_511_7308",
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$0467da094044eefe$export$590b8cc7d4f1d823 = ()=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                    id: "Clip path group",
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                                id: "clip0_10_2524",
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                                id: "Group",
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_2",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("defs", {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_608_7795",
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
const $cb0e8fe57b0fd046$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn, onClickContinue: onClickContinue })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$overlayStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$containerStyles,
            children: (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $0f650ff017b0ad3b$export$2e2bcd8739ae039), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$logoStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0467da094044eefe$export$590b8cc7d4f1d823, {})
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $0f650ff017b0ad3b$export$2e2bcd8739ae039), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$7a335ab395aac0f5$export$6b53fc34987132a8, {})
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                children: "We've logged you out. Log back in to see what's changed"
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $608d3c177085052d$export$2e2bcd8739ae039), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$overlayStyles = (0, $gyDKM.css)({
    position: "fixed",
    zIndex: (0, $95ad6dbea4f7d3b7$export$7be255094ccdc533).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$containerStackStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    height: "100%"
});
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$middleStackStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    marginBottom: "space.500"
});
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$containerStyles = (0, $gyDKM.css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$communityLogoStyles = (0, $gyDKM.css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$logoStyles = (0, $gyDKM.css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $gyDKM.css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});
var $cb0e8fe57b0fd046$var$$be203e745bcefb12$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$be203e745bcefb12$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$be203e745bcefb12$exports, "Error", ()=>$cb0e8fe57b0fd046$export$edf27be85e5f6da0);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$be203e745bcefb12$exports, "default", ()=>$cb0e8fe57b0fd046$var$$be203e745bcefb12$export$2e2bcd8739ae039);
const $cb0e8fe57b0fd046$var$$72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};
const $cb0e8fe57b0fd046$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout, errorMessage: errorMessage })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$pageStyles,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$containerStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$72560d06a87aac8e$export$87321d307719eaf2, {}),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("h1", {
                    css: $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                    css: $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    label: "Log out",
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $cb0e8fe57b0fd046$var$$be203e745bcefb12$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$export$edf27be85e5f6da0;
const $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$pageStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$containerStyles = (0, $gyDKM.css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.600")
});
const $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$headingStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    fontFamily: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $cb0e8fe57b0fd046$var$$be203e745bcefb12$var$descriptionStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});
var $cb0e8fe57b0fd046$var$$1db60c687807de63$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1db60c687807de63$exports, "SUCCESS_MESSAGE", ()=>$cb0e8fe57b0fd046$export$5620dbefc1cb6f80);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1db60c687807de63$exports, "ERROR_MESSAGE", ()=>$cb0e8fe57b0fd046$export$3f27bc10068ef877);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1db60c687807de63$exports, "NewsletterSignup", ()=>$cb0e8fe57b0fd046$export$21041608e6399292);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1db60c687807de63$exports, "Environment", ()=>$cb0e8fe57b0fd046$export$7dc6752a22ab011a);
var $cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports = {};
var $cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$exports, "DESKTOP_SCREEN_WIDTH", ()=>$cb0e8fe57b0fd046$export$27ed77542911fb0e);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$exports, "TABLET_SCREEN_WIDTH", ()=>$cb0e8fe57b0fd046$export$62d1d6124a8e4649);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$exports, "useDeviceSize", ()=>$cb0e8fe57b0fd046$export$4616d33c54ae5baf);
// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $cb0e8fe57b0fd046$export$27ed77542911fb0e = 1024;
const $cb0e8fe57b0fd046$export$62d1d6124a8e4649 = 900;
const $cb0e8fe57b0fd046$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $acw62.useState)(typeof window !== "undefined" ? window.innerWidth : $cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $acw62.useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    // width intentionally excluded (stable state setter)
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return width;
};
var $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$exports, "usePostNewsletterSignup", ()=>$cb0e8fe57b0fd046$export$ea96d97e8873ca7f);
const $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE = "community_learning_signup";
const $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF = "pointALead";
const $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$WAC_BASE_URL = {
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.LOCAL]: "/api/wac",
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.DEVELOPMENT]: "https://wac.stg.internal.atlassian.com",
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.STAGING]: "https://wac.stg.internal.atlassian.com",
    [$cb0e8fe57b0fd046$export$7dc6752a22ab011a.PRODUCTION]: "https://www.atlassian.com"
};
const $cb0e8fe57b0fd046$export$ea96d97e8873ca7f = ({ environment: environment = $cb0e8fe57b0fd046$export$7dc6752a22ab011a.DEVELOPMENT, onError: onError = ()=>null, onSuccess: onSuccess = ()=>null })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(false);
    const handleNewsletterSignup = async (formValues, formUrl)=>{
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const preferencesResponse = await $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$postPreferencesUpdate(formValues, environment, formUrl);
            if (!preferencesResponse.ok || preferencesResponse.status !== 202) throw new Error(`Error in postPreferencesUpdate with status: ${preferencesResponse.status}`);
            const wacResponse = await $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$postWacFormLead(formValues, environment);
            if (!wacResponse.ok || wacResponse.status !== 200) throw new Error(`Error in postWacFormLead with status: ${wacResponse.status}`);
            onSuccess();
            setSuccess(true);
        } catch (error) {
            if (error instanceof Error) setError(error.message);
            onError(error);
        } finally{
            setLoading(false);
        }
    };
    return {
        handleNewsletterSignup: handleNewsletterSignup,
        loading: loading,
        error: error,
        success: success
    };
};
const $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$postPreferencesUpdate = async (formValues, environment, formUrl)=>{
    const locale = navigator.language || Intl.DateTimeFormat().resolvedOptions().locale;
    const region = locale.split("-")[1];
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            consentCheckboxValue: true,
            consentLabelText: "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy.",
            email: formValues.email,
            formUrl: formUrl || "https://community.atlassian.com/",
            formId: "655e8a50-2d1f-4c1c-a782-fb5333e272a8",
            locale: region,
            paramsLocale: region,
            privacyPolicyText: '<p>By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy. <a href=\\"https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers\\">Atlassian Privacy Policy</a>.</p>\n',
            site: "atlassian"
        })
    };
    return fetch($cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/gateway/api/preferencesV2/update", requestOptions);
};
// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$postWacFormLead = async (formValues, environment)=>{
    const now = new Date();
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formValues,
            formType: $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE,
            formDef: $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF,
            created_at: now.toISOString(),
            submitted: now.toString()
        })
    };
    return fetch($cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/endpoint/streamhub/wacformlead", requestOptions);
};
var $cb0e8fe57b0fd046$var$$18cdd3872ade1318$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$18cdd3872ade1318$exports, "useScrollActiveSection", ()=>$cb0e8fe57b0fd046$export$c0e9cacf89df0750);
const $cb0e8fe57b0fd046$export$c0e9cacf89df0750 = ({ links: links, containerRef: containerRef, options: options = {} })=>{
    const [activeHref, setActiveHref] = (0, $acw62.useState)("");
    const { triggerPoint: triggerPoint = 0.3, topThreshold: topThreshold = 100 } = options;
    (0, $acw62.useEffect)(()=>{
        // Derive section IDs from links
        const linkHrefs = links.map((link)=>link.href ? link.href : $cb0e8fe57b0fd046$export$1bdcd43c8c2377cf(link.label));
        const sectionIds = linkHrefs.map((href)=>href.replace("#", ""));
        // Find sections by the IDs we derived from links
        const sections = sectionIds.map((id)=>document.getElementById(id)).filter(Boolean);
        if (sections.length === 0) return;
        const container = containerRef?.current;
        const isWindowScroll = !container;
        let ticking = false;
        const updateActiveSection = ()=>{
            // Get scroll position and dimensions
            const scrollY = isWindowScroll ? window.scrollY : container.scrollTop;
            const viewportHeight = isWindowScroll ? window.innerHeight : container.clientHeight;
            const triggerPointPx = viewportHeight * triggerPoint;
            // If we're at the very top, always select the first section
            if (scrollY < topThreshold) {
                setActiveHref(linkHrefs[0]);
                return;
            }
            // Find which section is currently at the trigger point
            let currentSectionIndex = 0;
            sections.forEach((section, index)=>{
                const rect = section.getBoundingClientRect();
                if (isWindowScroll) {
                    if (rect.top <= triggerPointPx) currentSectionIndex = index;
                } else {
                    // For container scroll, calculate relative position
                    const containerRect = container.getBoundingClientRect();
                    const relativeTop = rect.top - containerRect.top;
                    if (relativeTop <= triggerPointPx) currentSectionIndex = index;
                }
            });
            setActiveHref(linkHrefs[currentSectionIndex]);
        };
        const handleScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        };
        // Set initial active section
        updateActiveSection();
        // Attach scroll listener to container or window
        if (isWindowScroll) window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        else container.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            if (isWindowScroll) window.removeEventListener("scroll", handleScroll);
            else container.removeEventListener("scroll", handleScroll);
        };
    }, [
        links,
        containerRef,
        triggerPoint,
        topThreshold
    ]);
    return activeHref;
};
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports, $cb0e8fe57b0fd046$var$$3ced3ef7e9864bf1$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports, $cb0e8fe57b0fd046$var$$633811e9cd66d921$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports, $cb0e8fe57b0fd046$var$$6e8a4d5d78071ed7$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports, $cb0e8fe57b0fd046$var$$965a3cfbe886b380$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports, $cb0e8fe57b0fd046$var$$cbd57b1b072c1da3$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$ca43fe01b6155439$exports, $cb0e8fe57b0fd046$var$$18cdd3872ade1318$exports);
var $cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports = {};
var $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$exports, "TextField", ()=>$cb0e8fe57b0fd046$export$2c73285ae9390cec);
const $cb0e8fe57b0fd046$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false, onChange: onChange = ()=>{
    return null;
}, value: value, isDisabled: isDisabled = false, isRequired: isRequired = false, ...rest })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("input", {
        css: [
            $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest
    });
const $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$var$inputStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "1px solid #388BFF",
        outline: "1px solid #388BFF"
    }
});
const $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$var$invalidStyles = (0, $gyDKM.css)({
    border: "1px solid #C9372C",
    outline: "1px solid #C9372C"
});
const $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$var$disabledStyles = (0, $gyDKM.css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});
var $cb0e8fe57b0fd046$var$$60ab015507144a2b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$60ab015507144a2b$exports, "TextFieldMessage", ()=>$cb0e8fe57b0fd046$export$9144c5f9beecc4b7);
const $cb0e8fe57b0fd046$export$9144c5f9beecc4b7 = ({ message: message = "Example text here", type: type = "valid" })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f1bd95993ada74a3$export$8fbe3c7d0ed2c683), {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                    css: $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f1bd95993ada74a3$export$915e9e7bd4f0f96d), {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                    css: $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f1bd95993ada74a3$export$5505afb209a532c8), {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                    css: $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$spacing = (0, $gyDKM.css)({
    marginTop: "2px"
});
const $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$helperMessageStyle = (0, $gyDKM.css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$errorMessageStyle = (0, $gyDKM.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $cb0e8fe57b0fd046$var$$60ab015507144a2b$var$validMessageStyles = (0, $gyDKM.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
var $cb0e8fe57b0fd046$var$$57b1d5df6b5425d4$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$57b1d5df6b5425d4$exports, "TextFieldLabel", ()=>$cb0e8fe57b0fd046$export$76375b2580d1f8ac);
const $cb0e8fe57b0fd046$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label", isRequired: isRequired = true })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
        htmlFor: "basic-textfield",
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
            css: $cb0e8fe57b0fd046$var$$57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $ff931ce3ccc143b8$export$2e2bcd8739ae039), {})
            ]
        })
    });
const $cb0e8fe57b0fd046$var$$57b1d5df6b5425d4$var$labelStyles = (0, $gyDKM.css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
var $cb0e8fe57b0fd046$var$$4be7278e65b71184$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4be7278e65b71184$exports, "UnifiedAccountCardContent", ()=>$cb0e8fe57b0fd046$export$c031b829a2452999);
var $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$fc6addd2061b87dd$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fc6addd2061b87dd$exports, "default", ()=>$cb0e8fe57b0fd046$var$$fc6addd2061b87dd$export$2e2bcd8739ae039);
const $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions, isDisabled: isDisabled })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f8fc2edc4a47080d$export$2e2bcd8739ae039), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $cbba28d57dbc8c95$export$2e2bcd8739ae039), {
                    ...props,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($268cd31570d63e05$exports))),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b665697b0860b75b$export$2e2bcd8739ae039), {
            children: actions.map((action, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $0c583eef1017b111$export$2e2bcd8739ae039), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$var$buttonWrapperStyle = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});
const $cb0e8fe57b0fd046$export$c031b829a2452999 = ({ email: email, tags: tags, actions: actions, disableMenu: disableMenu })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$contentWrapperStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$dropdownWrapperStyles,
                children: disableMenu ? null : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$fc6addd2061b87dd$export$2e2bcd8739ae039, {
                    actions: actions,
                    isDisabled: disableMenu
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$coverImageWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$coverImageStyles,
                    children: (0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                                clipPath: "url(#clip0_985_48434)",
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("defs", {
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$textWrapperStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$contentWrapperStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$coverImageWrapperStyles = (0, $gyDKM.css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    borderTopRightRadius: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$coverImageStyles = (0, $gyDKM.css)({
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$textWrapperStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$emailStyles = (0, $gyDKM.css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$tagsWrapperStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$tagItemStyles = (0, $gyDKM.css)({
    display: "inline-block"
});
const $cb0e8fe57b0fd046$var$$4be7278e65b71184$var$dropdownWrapperStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    right: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
var $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", ()=>$cb0e8fe57b0fd046$export$c9d2f1697787ae74);
const $cb0e8fe57b0fd046$export$c9d2f1697787ae74 = ({ children: children, testId: testId, onClick: onClick, isAddAccount: isAddAccount = false })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
        "data-testid": testId,
        css: [
            $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$unstyledButtonStyles,
            $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$hoverEffectStyles : $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$unstyledButtonStyles = (0, $gyDKM.css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("font.family.brand.body")
});
const $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$cardContainerStyles = (0, $gyDKM.css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$hoverEffectStyles = (0, $gyDKM.css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$noPointerCursorStyles = (0, $gyDKM.css)({
    cursor: "default"
});
const $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$var$addAccountStyles = (0, $gyDKM.css)({
    border: `1px dashed ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: "none"
});
var $cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", ()=>$cb0e8fe57b0fd046$export$fc13faf098015d3a);
const $cb0e8fe57b0fd046$var$$5089616a215e9052$var$ellipseStyles = (0, $gyDKM.css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $cb0e8fe57b0fd046$var$$5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$5089616a215e9052$var$ellipseStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f5fec3964c81954d$exports))), {
            label: "Add",
            size: "large",
            primaryColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
        })
    });
};
const $cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$var$contentStyles = (0, $gyDKM.css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$var$textStyles = (0, $gyDKM.css)({
    marginTop: "16px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $cb0e8fe57b0fd046$export$fc13faf098015d3a = ()=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$var$contentStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$5089616a215e9052$export$f21ab0717a89c77f, {}),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};
var $cb0e8fe57b0fd046$var$$9c7edcd33b2e220b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", ()=>$cb0e8fe57b0fd046$export$b27c6704e245f018);
const $cb0e8fe57b0fd046$export$b27c6704e245f018 = ({ children: children })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$9c7edcd33b2e220b$var$containerStyles = (0, $gyDKM.css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});
var $cb0e8fe57b0fd046$var$$3ec1f71319ba0295$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", ()=>$cb0e8fe57b0fd046$export$8bee5cfdbbc2fc0c);
const $cb0e8fe57b0fd046$var$$3ec1f71319ba0295$var$loggedInContentStyles = (0, $gyDKM.css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $cb0e8fe57b0fd046$export$8bee5cfdbbc2fc0c = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$b27c6704e245f018, {
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: [
                $cb0e8fe57b0fd046$var$$3ec1f71319ba0295$var$loggedInContentStyles,
                $cb0e8fe57b0fd046$var$$3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $cb0e8fe57b0fd046$var$$3ec1f71319ba0295$var$baseContentStyles = (0, $gyDKM.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", ()=>$cb0e8fe57b0fd046$export$be7f7dedc3a0e1ad);
const $cb0e8fe57b0fd046$var$$5f6e50d159d7e8e1$var$StarFilledIcon = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $cb0e8fe57b0fd046$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$5f6e50d159d7e8e1$var$StarFilledIcon;
const $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $gyDKM.css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$export$be7f7dedc3a0e1ad = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$b27c6704e245f018, {
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: [
                $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$var$primaryContentStyles,
                $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039, {})
                }),
                "PRIMARY"
            ]
        })
    });
const $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$var$baseContentStyles = (0, $gyDKM.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $cb0e8fe57b0fd046$var$$01ef21c48d795edb$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$01ef21c48d795edb$exports, "UnifiedAccountTagLinked", ()=>$cb0e8fe57b0fd046$export$446c53c437a3d14a);
const $cb0e8fe57b0fd046$var$$01ef21c48d795edb$var$primaryContentStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $cb0e8fe57b0fd046$export$446c53c437a3d14a = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$b27c6704e245f018, {
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: [
                $cb0e8fe57b0fd046$var$$01ef21c48d795edb$var$primaryContentStyles,
                $cb0e8fe57b0fd046$var$$01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $cb0e8fe57b0fd046$var$$01ef21c48d795edb$var$baseContentStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $cb0e8fe57b0fd046$var$$fff41b96fcd62262$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fff41b96fcd62262$exports, "WelcomeModal", ()=>$cb0e8fe57b0fd046$export$9d12d42929c3fcf);
const $cb0e8fe57b0fd046$export$9d12d42929c3fcf = ({ onAccept: onAccept, onCancel: onCancel, coverImageSrc: coverImageSrc })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $2de636e70f18707f$export$2e2bcd8739ae039), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalContainerStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalImageContainerStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("h1", {
                            css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                            css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                            css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                    href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                    href: $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$buttonStyle = (0, $gyDKM.css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$coverImageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalContainerStyles = (0, $gyDKM.css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalImageContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    overflow: "hidden"
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalBodyStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $gyDKM.css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $cb0e8fe57b0fd046$var$$fff41b96fcd62262$var$modalButtonContainerStyles = (0, $gyDKM.css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$1ca64a7075ab6eae$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$60ab015507144a2b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$57b1d5df6b5425d4$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$4be7278e65b71184$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$db9d361cdef36cb6$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$e6da040d2ca2c72a$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$9c7edcd33b2e220b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$3ec1f71319ba0295$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$7cbc56ac0bc2e1de$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$fc6addd2061b87dd$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$01ef21c48d795edb$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports, $cb0e8fe57b0fd046$var$$fff41b96fcd62262$exports);
const $cb0e8fe57b0fd046$var$$2db63308c0b2527b$export$b56677d67e73c7be = ({ response: response, isLoading: isLoading })=>{
    const { message: message, isError: responseError } = response;
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$2db63308c0b2527b$var$inputStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
            name: "email",
            label: "Email address",
            defaultValue: "",
            children: ({ fieldProps: fieldProps, error: error, meta: meta })=>{
                const validationErrorMessage = meta.dirtySinceLastSubmit ? undefined : error;
                const displayMessage = validationErrorMessage || message;
                const displayType = error || responseError ? "error" : "valid";
                return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                    children: [
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$2db63308c0b2527b$var$inputButtonFlex,
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                    ...fieldProps,
                                    required: true,
                                    type: "email",
                                    autoComplete: "off",
                                    placeholder: "yourname@email.com"
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        as: "button",
                                        label: "Sign up",
                                        type: "submit",
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                        isLoading: isLoading
                                    })
                                })
                            ]
                        }),
                        displayMessage ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$9144c5f9beecc4b7, {
                            type: displayType,
                            message: displayMessage
                        }) : null
                    ]
                });
            }
        })
    });
};
const $cb0e8fe57b0fd046$var$$2db63308c0b2527b$var$inputStyles = (0, $gyDKM.css)({
    "& label": {
        fontWeight: 400
    }
});
const $cb0e8fe57b0fd046$var$$2db63308c0b2527b$var$inputButtonFlex = (0, $gyDKM.css)({
    display: "flex",
    alignContent: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd = ({ isMobile: isMobile })=>(0, $gyDKM.css)({
        minWidth: "fit-content",
        display: isMobile ? "none" : "block",
        marginTop: isMobile ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200") : 0,
        [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            minWidth: "100%",
            display: isMobile ? "block" : "none"
        }
    });
const $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$export$eefa3b352a86957 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$export$ecf6508459835aaf = "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the ";
const $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2 = ({ response: response, onSubmit: onSubmit, onPrivacyPolicyClick: onPrivacyPolicyClick })=>{
    const handleSubmit = async (data, form)=>{
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const errors = {
            email: !emailPattern.test(data.email) ? "Enter a valid email address." : undefined
        };
        if (!errors.email) {
            await onSubmit(data);
            form.reset();
        }
        return errors;
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $881b21ff70ac9ef2$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("form", {
                ...formProps,
                css: $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$var$formWrapperStyles,
                "data-testid": "signup-form",
                noValidate: true,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$var$formActionStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$2db63308c0b2527b$export$b56677d67e73c7be, {
                                response: response,
                                isLoading: submitting
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd({
                                    isMobile: true
                                }),
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    as: "button",
                                    label: "Sign up",
                                    type: "submit",
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                    isLoading: submitting,
                                    fullWidth: true
                                })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                        css: $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$var$acknowledgeStyle,
                        children: [
                            $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$export$ecf6508459835aaf,
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                href: $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$export$eefa3b352a86957,
                                target: "_blank",
                                onClick: onPrivacyPolicyClick,
                                rel: "noreferrer",
                                children: "Atlassian Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
    });
};
const $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$var$formWrapperStyles = (0, $gyDKM.css)({
    width: "100%",
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.800"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.800"),
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        padding: 0
    },
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
    },
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MEDIA_QUERY]: {
        marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")
    }
});
const $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$var$formActionStyles = (0, $gyDKM.css)({
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        flexDirection: "column",
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
    }
});
const $cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$var$acknowledgeStyle = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    maxWidth: "405px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontWeight: "400",
    fontSize: "12px",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    "& a": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    },
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        maxWidth: "unset"
    }
});
const $cb0e8fe57b0fd046$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0 = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
        "data-testid": "open-letter",
        width: "124",
        height: "118",
        viewBox: "0 0 124 118",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("g", {
            id: "Spot/Basics/Letter open",
            children: (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                id: "Vector",
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_2",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_3",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_4",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_5",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_6",
                        d: "M88.2168 41.562H36.7148V43.9475H88.2168V41.562Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_7",
                        d: "M88.2168 51.1689H36.7148V53.5544H88.2168V51.1689Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_8",
                        d: "M88.2168 60.7825H36.7148V63.1679H88.2168V60.7825Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_9",
                        d: "M88.2168 70.3901H36.7148V72.7756H88.2168V70.3901Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_10",
                        d: "M88.2168 80.0034H36.7148V82.3889H88.2168V80.0034Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_11",
                        d: "M88.2168 89.6106H36.7148V91.9961H88.2168V89.6106Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_12",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_13",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_14",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_15",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_16",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_17",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_18",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_19",
                        d: "M51.0637 80.5821L49.6444 80.767C49.6444 80.767 47.1873 80.5642 46.2033 80.9041L42.5059 80.7491C42.5059 80.7491 40.9613 80.8385 40.4961 81.0532C40.2039 81.1844 40.0191 81.3454 39.9773 81.4945C39.8938 81.7927 40.4127 82.0432 41.9036 81.9478C41.9215 81.9656 41.9811 81.9835 41.9871 82.0074C43.5615 81.7987 45.0762 82.1863 46.6804 82.1446C46.6626 82.0551 46.7162 81.9895 46.7639 82.0312L46.746 82.1386C47.8135 81.9239 48.4815 82.2817 49.4595 81.912C49.4595 81.912 49.3402 82.0551 49.3462 82.0551C52.6918 82.0014 57.2241 82.1744 60.85 82.0193L60.8321 82.0014V81.9835C60.5041 81.8702 58.8999 81.7032 58.8999 81.7032C60.1106 81.1784 61.4762 81.739 62.7584 81.7211L62.7465 81.8643C62.1919 81.8583 61.6969 81.9179 61.5001 81.9776C63.4919 82.1803 67.4876 82.234 69.3959 82.0253C69.3482 81.9179 68.7578 82.1505 68.6087 81.7987C69.0978 81.7987 69.5868 81.7509 70.046 81.7569C70.046 81.9835 69.7776 81.906 69.7239 81.9478C70.5171 82.1982 86.7322 82.5441 82.8618 81.5542L82.9632 81.4349C81.9613 81.3812 81.1324 81.3335 80.0947 81.1009C79.9456 81.1188 79.9277 81.1009 79.9277 81.2142C79.886 81.2321 79.8204 81.2679 79.8383 81.3156C79.8502 81.6019 79.5281 81.4886 79.385 81.4945C79.5639 80.6059 76.1527 81.3872 75.6995 81.3514C75.616 80.928 74.8109 81.3335 74.5366 81.1486C74.5545 81.1307 74.6797 81.0413 74.6916 81.0234C74.4471 80.7491 70.4217 81.4826 71.5727 80.9638C66.8196 80.0454 58.1962 81.0771 53.0615 80.272L53.0973 80.3256C53.0556 80.3078 52.9303 80.3316 52.9005 80.272C52.3936 80.439 51.0577 80.5582 51.0577 80.5582L51.0637 80.5821ZM62.8419 81.1486C62.8419 81.1486 62.8479 81.1248 62.8419 81.1188C62.8419 81.1606 63.5039 81.1367 63.5277 81.1486V81.2917C62.8538 81.5601 61.3212 80.588 62.7763 81.0174C62.824 80.9816 62.824 81.1009 62.8359 81.1486H62.8419ZM68.7101 81.1963C68.8234 81.2083 68.9487 81.2202 69.0858 81.2321C67.5651 81.6675 65.5136 81.1069 63.8438 81.3037C64.4163 80.6775 65.77 81.0174 66.4916 81.0592C67.2132 80.922 68.072 81.095 68.7101 81.1963ZM78.5143 81.3514V81.2798H78.574C78.574 81.2977 78.568 81.3216 78.5561 81.3335C78.5501 81.3454 78.5263 81.3633 78.5143 81.3573V81.3514ZM51.8688 80.922C51.9821 80.8087 52.4055 80.8743 52.1252 81.1009C52.0537 81.0651 51.8449 81.1665 51.8688 80.922ZM70.4276 81.3752C70.4276 81.1427 70.9882 81.1009 70.9882 81.417C70.7974 81.417 70.6125 81.3991 70.4276 81.3752ZM47.7121 81.1427C47.5631 81.3872 47.6048 81.1128 47.5571 80.9578C47.5929 80.9936 47.73 81.0055 47.7002 81.1188L47.7121 81.1427ZM45.1001 81.2739C45.0643 81.3931 44.9152 81.4707 44.8436 81.4766C44.6647 81.3812 45.0166 81.1665 45.1001 81.2739ZM40.8003 81.2739C40.7943 81.411 40.6929 81.4587 40.6631 81.3216C40.6751 81.2202 40.8003 81.1427 40.8182 81.2977C40.8182 81.2918 40.8182 81.2798 40.8003 81.2739ZM73.0039 81.8881C72.8489 82.2936 72.342 81.9597 72.0676 82.067C72.1332 81.6615 72.6223 81.9656 72.831 81.8941C72.9025 81.8941 72.9622 81.8941 73.0039 81.8881ZM56.0851 81.6973C56.0851 82.0551 55.5186 81.7688 55.3277 81.8464V81.7032C55.614 81.6675 55.7869 81.578 56.0732 81.6973H56.0851ZM67.7977 81.9776C67.6903 82.1207 67.5114 81.9835 67.3981 81.9835C67.3981 81.7808 67.8692 81.751 67.7977 81.9776ZM63.0447 81.8941C63.0208 81.6734 63.2534 81.7808 63.325 81.7629C63.2772 81.8106 63.1878 81.9478 63.1341 81.9418C63.0983 81.9418 63.0864 81.912 63.0447 81.8941ZM56.2938 81.5601C56.5145 81.5601 56.753 81.5601 56.9796 81.572V81.7152C56.7411 81.7152 56.5145 81.7092 56.2879 81.7032V81.5601H56.2938ZM58.5183 81.7927V81.9358C58.1962 82.067 58.1604 81.7032 58.5123 81.7927H58.5183ZM53.4193 81.7092C53.4551 81.7152 53.5028 81.7271 53.5386 81.7271C53.9978 81.7152 53.3478 82.228 53.4193 81.7092ZM51.01 81.8344C50.9623 81.8523 50.9027 81.8941 50.855 81.8941C50.533 81.8762 50.8908 81.5363 51.01 81.8344Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_20",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_21",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_22",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_23",
                        d: "M51.0637 44.3943L49.6444 44.5792C49.6444 44.5792 47.1873 44.3764 46.2033 44.7164L42.5059 44.5613C42.5059 44.5613 40.9613 44.6508 40.4961 44.8655C40.2039 45.0026 40.0191 45.1577 39.9773 45.3068C39.8938 45.605 40.4127 45.8554 41.9036 45.76C41.9215 45.7779 41.9811 45.7958 41.9871 45.8196C43.5615 45.6109 45.0762 45.9986 46.6804 45.9568C46.6626 45.8674 46.7162 45.8018 46.7639 45.8435L46.746 45.9508C47.8135 45.7362 48.4815 46.094 49.4595 45.7242C49.4595 45.7242 49.3402 45.8674 49.3462 45.8674C52.6918 45.8137 57.2241 45.9866 60.85 45.8316L60.8321 45.8137V45.7958C60.5041 45.6825 58.8999 45.5155 58.8999 45.5155C60.1106 44.9907 61.4762 45.5513 62.7584 45.5334L62.7465 45.6765C62.1919 45.6706 61.6969 45.7302 61.5001 45.7898C63.4919 45.9926 67.4876 46.0463 69.3959 45.8375C69.3482 45.7302 68.7578 45.9628 68.6087 45.6109C69.0978 45.6109 69.5868 45.5632 70.046 45.5692C70.046 45.7958 69.7776 45.7183 69.7239 45.76C70.5171 46.0105 86.7322 46.3564 82.8618 45.3664L82.9632 45.2471C81.9613 45.1935 81.1324 45.1458 80.0947 44.9132C79.9456 44.9311 79.9277 44.9132 79.9277 45.0265C79.886 45.0444 79.8204 45.0802 79.8383 45.1279C79.8502 45.4141 79.5281 45.3008 79.385 45.3068C79.5639 44.4182 76.1527 45.1994 75.6995 45.1636C75.616 44.7402 74.8109 45.1458 74.5366 44.9609C74.5545 44.943 74.6797 44.8535 74.6916 44.8356C74.4471 44.5613 70.4217 45.2948 71.5727 44.776C66.8196 43.8576 58.1962 44.8893 53.0615 44.0842L53.0973 44.1379C53.0556 44.12 52.9303 44.1439 52.9005 44.0842C52.3936 44.2512 51.0577 44.3705 51.0577 44.3705L51.0637 44.3943ZM62.8419 44.9549C62.8419 44.9549 62.8479 44.9311 62.8419 44.9251C62.8419 44.9668 63.5039 44.943 63.5277 44.9549V45.098C62.8538 45.3664 61.3212 44.4003 62.7763 44.8237C62.824 44.7879 62.824 44.9072 62.8359 44.9549H62.8419ZM68.7101 45.0026C68.8234 45.0146 68.9487 45.0265 69.0858 45.0384C67.5651 45.4738 65.5136 44.9132 63.8438 45.11C64.4163 44.4838 65.77 44.8237 66.4916 44.8655C67.2132 44.7283 68.072 44.9012 68.7101 45.0026ZM78.5143 45.1577V45.0861H78.574C78.574 45.104 78.568 45.1279 78.5561 45.1398C78.5501 45.1517 78.5263 45.1696 78.5143 45.1636V45.1577ZM51.8688 44.7283C51.9821 44.615 52.4055 44.6806 52.1252 44.9072C52.0537 44.8714 51.8449 44.9728 51.8688 44.7283ZM70.4276 45.1815C70.4276 44.949 70.9882 44.9012 70.9882 45.2233C70.7974 45.2233 70.6125 45.2054 70.4276 45.1815ZM47.7121 44.949C47.5631 45.1935 47.6048 44.9191 47.5571 44.7641C47.5929 44.7999 47.73 44.8118 47.7002 44.9251L47.7121 44.949ZM45.1001 45.0802C45.0643 45.1994 44.9152 45.277 44.8436 45.2829C44.6647 45.1875 45.0166 44.9728 45.1001 45.0802ZM40.8003 45.0802C40.7943 45.2173 40.6929 45.265 40.6631 45.1279C40.6751 45.0265 40.8003 44.949 40.8182 45.104C40.8182 45.098 40.8182 45.0861 40.8003 45.0802ZM73.0039 45.6944C72.8489 46.0999 72.342 45.766 72.0676 45.8733C72.1332 45.4678 72.6223 45.7719 72.831 45.7004C72.9025 45.7004 72.9622 45.7004 73.0039 45.6944ZM56.0851 45.5036C56.0851 45.8614 55.5186 45.5751 55.3277 45.6527V45.5095C55.614 45.4738 55.7869 45.3843 56.0732 45.5036H56.0851ZM67.7977 45.7839C67.6903 45.927 67.5114 45.7898 67.3981 45.7898C67.3981 45.5871 67.8692 45.5572 67.7977 45.7839ZM63.0447 45.7004C63.0208 45.4797 63.2534 45.5871 63.325 45.5692C63.2772 45.6169 63.1878 45.754 63.1341 45.7481C63.0983 45.7481 63.0864 45.7183 63.0447 45.7004ZM56.2938 45.3664C56.5145 45.3664 56.753 45.3664 56.9796 45.3783V45.5215C56.7411 45.5215 56.5145 45.5155 56.2879 45.5095V45.3664H56.2938ZM58.5183 45.599V45.7421C58.1962 45.8733 58.1604 45.5095 58.5123 45.599H58.5183ZM53.4193 45.5155C53.4551 45.5215 53.5028 45.5334 53.5386 45.5334C53.9978 45.5215 53.3478 46.0343 53.4193 45.5155ZM51.01 45.6407C50.9623 45.6586 50.9027 45.7004 50.855 45.6944C50.533 45.6765 50.8908 45.3366 51.01 45.6407Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_24",
                        d: "M51.0637 56.4532L49.6444 56.638C49.6444 56.638 47.1873 56.4353 46.2033 56.7752L42.5059 56.6202C42.5059 56.6202 40.9613 56.7096 40.4961 56.9243C40.2039 57.0615 40.0191 57.2165 39.9773 57.3656C39.8938 57.6638 40.4127 57.9143 41.9036 57.8188C41.9215 57.8367 41.9811 57.8546 41.9871 57.8785C43.5615 57.6698 45.0762 58.0574 46.6804 58.0156C46.6626 57.9262 46.7162 57.8606 46.7639 57.9023L46.746 58.0097C47.8135 57.795 48.4815 58.1528 49.4595 57.7831C49.4595 57.7831 49.3402 57.9262 49.3462 57.9262C52.6918 57.8725 57.2241 58.0455 60.85 57.8904L60.8321 57.8725V57.8546C60.5041 57.7413 58.8999 57.5743 58.8999 57.5743C60.1106 57.0495 61.4762 57.6101 62.7584 57.5922L62.7465 57.7354C62.1919 57.7294 61.6969 57.789 61.5001 57.8487C63.4919 58.0514 67.4876 58.1051 69.3959 57.8964C69.3482 57.789 68.7578 58.0216 68.6087 57.6698C69.0978 57.6698 69.5868 57.6221 70.046 57.628C70.046 57.8546 69.7776 57.7771 69.7239 57.8188C70.5171 58.0693 86.7322 58.4152 82.8618 57.4253L82.9632 57.306C81.9613 57.2523 81.1324 57.2046 80.0947 56.972C79.9456 56.9899 79.9277 56.972 79.9277 57.0853C79.886 57.1032 79.8204 57.139 79.8383 57.1867C79.8502 57.473 79.5281 57.3597 79.385 57.3656C79.5639 56.477 76.1527 57.2583 75.6995 57.2225C75.616 56.7991 74.8109 57.2046 74.5366 57.0197C74.5545 57.0018 74.6797 56.9124 74.6916 56.8945C74.4471 56.6202 70.4217 57.3537 71.5727 56.8349C66.8196 55.9165 58.1962 56.9482 53.0615 56.1431L53.0973 56.1967C53.0556 56.1789 52.9303 56.2027 52.9005 56.1431C52.3936 56.31 51.0577 56.4293 51.0577 56.4293L51.0637 56.4532ZM62.8419 57.0197C62.8419 57.0197 62.8479 56.9959 62.8419 56.9899C62.8419 57.0316 63.5039 57.0078 63.5277 57.0197V57.1629C62.8538 57.4312 61.3212 56.4591 62.7763 56.8885C62.824 56.8527 62.824 56.972 62.8359 57.0197H62.8419ZM68.7101 57.0674C68.8234 57.0794 68.9487 57.0913 69.0858 57.1032C67.5651 57.5386 65.5136 56.978 63.8438 57.1748C64.4163 56.5486 65.77 56.8885 66.4916 56.9303C67.2132 56.7931 68.072 56.9661 68.7101 57.0674ZM78.5143 57.2225V57.1509H78.574C78.574 57.1688 78.568 57.1927 78.5561 57.2046C78.5501 57.2225 78.5263 57.2344 78.5143 57.2285V57.2225ZM51.8688 56.7931C51.9821 56.6798 52.4055 56.7454 52.1252 56.972C52.0537 56.9362 51.8449 57.0376 51.8688 56.7931ZM70.4276 57.2463C70.4276 57.0138 70.9882 56.972 70.9882 57.2941C70.7974 57.2941 70.6125 57.2762 70.4276 57.2463ZM47.7121 57.0138C47.5631 57.2583 47.6048 56.9839 47.5571 56.8289C47.5929 56.8647 47.73 56.8766 47.7002 56.9899L47.7121 57.0138ZM45.1001 57.145C45.0643 57.2642 44.9152 57.3418 44.8436 57.3477C44.6647 57.2523 45.0166 57.0376 45.1001 57.145ZM40.8003 57.145C40.7943 57.2821 40.6929 57.3298 40.6631 57.1927C40.6751 57.0913 40.8003 57.0138 40.8182 57.1688C40.8182 57.1628 40.8182 57.1509 40.8003 57.145ZM73.0039 57.7592C72.8489 58.1647 72.342 57.8308 72.0676 57.9381C72.1332 57.5326 72.6223 57.8367 72.831 57.7652C72.9025 57.7652 72.9622 57.7652 73.0039 57.7592ZM56.0851 57.5684C56.0851 57.9262 55.5186 57.6399 55.3277 57.7175V57.5743C55.614 57.5386 55.7869 57.4491 56.0732 57.5684H56.0851ZM67.7977 57.8487C67.6903 57.9918 67.5114 57.8487 67.3981 57.8546C67.3981 57.6519 67.8692 57.622 67.7977 57.8487ZM63.0447 57.7652C63.0208 57.5445 63.2534 57.6519 63.325 57.634C63.2772 57.6817 63.1878 57.8189 63.1341 57.8129C63.0983 57.8129 63.0864 57.7831 63.0447 57.7652ZM56.2938 57.4312C56.5145 57.4312 56.753 57.4312 56.9796 57.4431V57.5863C56.7411 57.5863 56.5145 57.5803 56.2879 57.5743V57.4312H56.2938ZM58.5183 57.6638V57.8069C58.1962 57.9381 58.1604 57.5743 58.5123 57.6638H58.5183ZM53.4193 57.5803C53.4551 57.5863 53.5028 57.5982 53.5386 57.5982C53.9978 57.5863 53.3478 58.0991 53.4193 57.5803ZM51.01 57.7055C50.9623 57.7234 50.9027 57.7652 50.855 57.7592C50.533 57.7413 50.8908 57.4014 51.01 57.7055Z",
                        fill: "#101214"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                        id: "Vector_25",
                        d: "M51.0637 68.5174L49.6444 68.7022C49.6444 68.7022 47.1873 68.4995 46.2033 68.8394L42.5059 68.6844C42.5059 68.6844 40.9613 68.7738 40.4961 68.9885C40.2039 69.1257 40.0191 69.2807 39.9773 69.4298C39.8938 69.728 40.4127 69.9785 41.9036 69.8831C41.9215 69.9009 41.9811 69.9188 41.9871 69.9427C43.5615 69.734 45.0762 70.1216 46.6804 70.0799C46.6626 69.9904 46.7162 69.9248 46.7639 69.9665L46.746 70.0739C47.8135 69.8592 48.4815 70.217 49.4595 69.8473C49.4595 69.8473 49.3402 69.9904 49.3462 69.9904C52.6918 69.9367 57.2241 70.1097 60.85 69.9546L60.8321 69.9367V69.9188C60.5041 69.8055 58.8999 69.6385 58.8999 69.6385C60.1106 69.1137 61.4762 69.6743 62.7584 69.6564L62.7465 69.7996C62.1919 69.7936 61.6969 69.8532 61.5001 69.9129C63.4919 70.1156 67.4876 70.1693 69.3959 69.9606C69.3482 69.8532 68.7578 70.0858 68.6087 69.734C69.0978 69.734 69.5868 69.6863 70.046 69.6922C70.046 69.9188 69.7776 69.8413 69.7239 69.8831C70.5171 70.1335 86.7322 70.4794 82.8618 69.4895L82.9632 69.3702C81.9613 69.3165 81.1324 69.2688 80.0947 69.0362C79.9456 69.0541 79.9277 69.0362 79.9277 69.1495C79.886 69.1674 79.8204 69.2032 79.8383 69.2509C79.8502 69.5372 79.5281 69.4238 79.385 69.4298C79.5639 68.5412 76.1527 69.3225 75.6995 69.2867C75.616 68.8633 74.8109 69.2688 74.5366 69.0839C74.5545 69.066 74.6797 68.9766 74.6916 68.9587C74.4471 68.6844 70.4217 69.4179 71.5727 68.8991C66.8196 67.9807 58.1962 69.0124 53.0615 68.2073L53.0973 68.2609C53.0556 68.2431 52.9303 68.2669 52.9005 68.2073C52.3936 68.3743 51.0577 68.4935 51.0577 68.4935L51.0637 68.5174ZM62.8419 69.0839C62.8419 69.0839 62.8479 69.0601 62.8419 69.0541C62.8419 69.0959 63.5039 69.072 63.5277 69.0839V69.2271C62.8538 69.4954 61.3212 68.5233 62.7763 68.9527C62.824 68.9169 62.824 69.0362 62.8359 69.0839H62.8419ZM68.7101 69.1316C68.8234 69.1436 68.9487 69.1555 69.0858 69.1674C67.5651 69.6028 65.5136 69.0422 63.8438 69.239C64.4163 68.6128 65.77 68.9527 66.4916 68.9945C67.2132 68.8573 68.072 69.0302 68.7101 69.1316ZM78.5143 69.2867V69.2151H78.574C78.574 69.233 78.568 69.2569 78.5561 69.2688C78.5501 69.2807 78.5263 69.2986 78.5143 69.2927V69.2867ZM51.8688 68.8573C51.9821 68.744 52.4055 68.8096 52.1252 69.0362C52.0537 69.0004 51.8449 69.1018 51.8688 68.8573ZM70.4276 69.3105C70.4276 69.078 70.9882 69.0362 70.9882 69.3583C70.7974 69.3583 70.6125 69.3404 70.4276 69.3105ZM47.7121 69.078C47.5631 69.3225 47.6048 69.0481 47.5571 68.8931C47.5929 68.9289 47.73 68.9408 47.7002 69.0541L47.7121 69.078ZM45.1001 69.2092C45.0643 69.3284 44.9152 69.406 44.8436 69.4119C44.6647 69.3165 45.0166 69.1018 45.1001 69.2092ZM40.8003 69.2092C40.7943 69.3463 40.6929 69.394 40.6631 69.2569C40.6751 69.1555 40.8003 69.078 40.8182 69.233C40.8182 69.227 40.8182 69.2151 40.8003 69.2092ZM73.0039 69.8234C72.8489 70.2289 72.342 69.895 72.0676 70.0023C72.1332 69.5968 72.6223 69.9009 72.831 69.8294C72.9025 69.8294 72.9622 69.8294 73.0039 69.8234ZM56.0851 69.6326C56.0851 69.9904 55.5186 69.7041 55.3277 69.7817V69.6385C55.614 69.6028 55.7869 69.5133 56.0732 69.6326H56.0851ZM67.7977 69.9129C67.6903 70.056 67.5114 69.9129 67.3981 69.9188C67.3981 69.7161 67.8692 69.6863 67.7977 69.9129ZM63.0447 69.8294C63.0208 69.6087 63.2534 69.7161 63.325 69.6982C63.2772 69.7459 63.1878 69.883 63.1341 69.8771C63.0983 69.8771 63.0864 69.8473 63.0447 69.8294ZM56.2938 69.4954C56.5145 69.4954 56.753 69.4954 56.9796 69.5073V69.6505C56.7411 69.6505 56.5145 69.6445 56.2879 69.6385V69.4954H56.2938ZM58.5183 69.728V69.8711C58.1962 70.0023 58.1604 69.6385 58.5123 69.728H58.5183ZM53.4193 69.6445C53.4551 69.6505 53.5028 69.6624 53.5386 69.6624C53.9978 69.6505 53.3478 70.1633 53.4193 69.6445ZM51.01 69.7697C50.9623 69.7876 50.9027 69.8294 50.855 69.8234C50.533 69.8055 50.8908 69.4656 51.01 69.7697Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
const $cb0e8fe57b0fd046$export$5620dbefc1cb6f80 = "You\u2019re on the list! Thanks for signing up.";
const $cb0e8fe57b0fd046$export$3f27bc10068ef877 = "Something went wrong. Try again.";
const $cb0e8fe57b0fd046$export$21041608e6399292 = ({ environment: environment, formUrl: formUrl, atlassianId: atlassianId, anonymousId: anonymousId, eventHandlers: eventHandlers = {} })=>{
    const { handleNewsletterSignup: handleNewsletterSignup, error: error, success: success } = $cb0e8fe57b0fd046$export$ea96d97e8873ca7f({
        environment: environment,
        ...eventHandlers
    });
    const { onSubmit: onSubmit = ()=>null, onPrivacyPolicyClick: onPrivacyPolicyClick } = eventHandlers;
    const handleSubmit = async ({ email: email })=>{
        onSubmit();
        await handleNewsletterSignup({
            email: email,
            anonymousId: anonymousId,
            atlassianId: atlassianId
        }, formUrl);
    };
    const successMessage = success ? $cb0e8fe57b0fd046$export$5620dbefc1cb6f80 : undefined;
    const responseMessage = error ? $cb0e8fe57b0fd046$export$3f27bc10068ef877 : successMessage;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$1db60c687807de63$var$signUpWrapper,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$1db60c687807de63$var$stack,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0, {}),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("h2", {
                        css: $cb0e8fe57b0fd046$var$$1db60c687807de63$var$headingStyles,
                        children: [
                            "Sign up for the community ",
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                children: "newsletter"
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$1db60c687807de63$var$descriptionStyles,
                        children: "Get the latest resources, tips, and trends to help you grow."
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2, {
                response: {
                    message: responseMessage,
                    isError: Boolean(error)
                },
                onSubmit: handleSubmit,
                onPrivacyPolicyClick: onPrivacyPolicyClick
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$1db60c687807de63$var$signUpWrapper = (0, $gyDKM.css)({
    margin: "0 auto",
    maxWidth: "624px"
});
const $cb0e8fe57b0fd046$var$$1db60c687807de63$var$stack = (0, $gyDKM.css)({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$1db60c687807de63$var$headingStyles = (0, $gyDKM.css)({
    fontFamily: '"Charlie Display", sans-serif',
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    "& span": {
        display: "block",
        [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            display: "inline-block"
        }
    },
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "32px"
    },
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        width: "340px",
        fontSize: "32px"
    }
});
const $cb0e8fe57b0fd046$var$$1db60c687807de63$var$descriptionStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "32px",
    marginTop: 0,
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "20px"
    },
    [$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $cb0e8fe57b0fd046$var$$2f0c862779035c26$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$2f0c862779035c26$exports, "MarkdownWrapper", ()=>$cb0e8fe57b0fd046$export$e61786c4aee8d415);
const $cb0e8fe57b0fd046$export$e61786c4aee8d415 = ({ children: children, overrides: overrides })=>{
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) || typeof children !== "string" ? children : (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $185ac4d2d2286c00$export$2e2bcd8739ae039), {
        css: $cb0e8fe57b0fd046$var$$2f0c862779035c26$var$defaultStyles,
        options: {
            overrides: overrides
        },
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$2f0c862779035c26$var$defaultStyles = (0, $gyDKM.css)({
    "& > p:first-of-type": {
        margin: 0
    }
});
var $cb0e8fe57b0fd046$var$$6937e97bac512574$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$6937e97bac512574$exports, "TabbedAccordion", ()=>$cb0e8fe57b0fd046$export$187009fd9803261e);
const $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$ResourceCard = ({ description: description, link: link, type: type })=>{
    const handleClick = ()=>{
        window.open(link.link, link.target);
    };
    const hasType = type && type.length > 0;
    const hasDescription = description && description.length > 0;
    const accessibilityLabel = `${link.label}; ${hasType ? `type: ${type}; ` : ""}${hasDescription ? description : ""}`;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$containerStyles,
        onClick: handleClick,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        tabIndex: 0,
        role: "button",
        "aria-label": accessibilityLabel,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$contentStyles,
                children: [
                    hasType && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                        label: type
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
                        ...link,
                        style: $cb0e8fe57b0fd046$export$2b77966d73aefa77.SEMIBOLD,
                        onClick: handleClick,
                        tabIndex: -1
                    }),
                    hasDescription && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$descriptionStyles,
                        children: description
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "arrow-right",
                    alt: "Arrow right",
                    size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.MEDIUM
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")}`,
    alignItems: "center",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface"),
    justifyContent: "space-between",
    "& a": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link")
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        transition: "box-shadow 0.3s ease-in-out"
    },
    "&:hover svg": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link"),
        transform: "translateX(2px)"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
    }
});
const $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$contentStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    alignItems: "flex-start",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
    }
});
const $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$descriptionStyles = (0, $gyDKM.css)({
    margin: 0,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Atlassian Sans",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        fontSize: "12px",
        lineHeight: "16px"
    }
});
var $cb0e8fe57b0fd046$var$$76fc9668239269ce$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$76fc9668239269ce$var$ResourceCard;
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$Expander = ({ title: title, description: description, resources: resources, color: color, expandedByDefault: expandedByDefault = false, onExpandToggle: onExpandToggle, iconType: iconType, expandedContent: expandedContent })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(expandedByDefault);
    const iconProps = isExpanded ? {
        type: "chevron-down",
        alt: "Chevron down"
    } : {
        type: "chevron-right",
        alt: "Chevron right"
    };
    const toggleExpanded = (0, $acw62.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        onExpandToggle?.();
    }, [
        isExpanded,
        onExpandToggle
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                toggleExpanded();
            }
        }
    }, [
        toggleExpanded
    ]);
    const accessibilityLabel = `${title}; ${typeof description === "string" ? description : ""}`;
    const hasResources = resources.length > 0;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles,
        role: "button",
        "aria-label": accessibilityLabel,
        "aria-expanded": isExpanded,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        children: [
            iconType && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$outerIconStyles,
                    (0, $gyDKM.css)({
                        opacity: isExpanded ? 1 : 0.6,
                        "& svg": {
                            color: color
                        }
                    })
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: iconType,
                    color: color,
                    size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.LARGE
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$expanderCardStyles,
                style: {
                    borderLeft: `8px solid ${color && isExpanded ? color : "transparent"}`
                },
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$containerStyles,
                    children: [
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            role: "button",
                            tabIndex: 0,
                            css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$expanderHeaderStyles,
                            onClick: toggleExpanded,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    toggleExpanded();
                                }
                            },
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                    ...iconProps,
                                    size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.LARGE
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                    level: 5,
                                    children: title
                                })
                            ]
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$contentStyles,
                            children: [
                                typeof description === "string" ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                        children: description
                                    })
                                }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                    children: description
                                }),
                                isExpanded && expandedContent && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$expandedContentStyles,
                                    children: expandedContent
                                }),
                                isExpanded && hasResources && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$resourcesStyles,
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                                            fontWeight: "semibold",
                                            children: "Resources"
                                        }),
                                        resources.map((resource)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$76fc9668239269ce$export$2e2bcd8739ae039, {
                                                description: resource.description,
                                                link: resource.link,
                                                type: resource.type
                                            }, resource.link.link))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$expanderCardStyles = (0, $gyDKM.css)({
    display: "flex",
    flex: "auto",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    alignSelf: "stretch",
    alignItems: "stretch",
    borderRadius: "8px",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface"),
    boxShadow: "0 0 1px 0 rgba(9, 30, 66, 0.31), 0 1px 1px 0 rgba(9, 30, 66, 0.25)",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")}`
    }
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
    }
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$expanderHeaderStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    cursor: "pointer",
    userSelect: "none",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
    }
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$contentStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.600"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")
    }
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$resourcesStyles = (0, $gyDKM.css)({
    display: "flex",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    flexDirection: "column",
    alignItems: "stretch",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
    }
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$outerIconStyles = (0, $gyDKM.css)({
    "& svg": {
        width: "32px !important",
        height: "32px !important"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$descriptionStyles = (0, $gyDKM.css)({
    whiteSpace: "pre-wrap"
});
const $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$expandedContentStyles = (0, $gyDKM.css)({
    width: "100%"
});
var $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$var$Expander;
const $cb0e8fe57b0fd046$var$$737c57f1a347e52a$var$TabContent = ({ tabExpanders: tabExpanders, color: color, iconType: iconType })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$737c57f1a347e52a$var$tabContentContainerStyles,
        children: tabExpanders.map((tabItem, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039, {
                title: tabItem.title,
                description: tabItem.description,
                resources: tabItem.resources,
                color: color,
                expandedByDefault: index === 0,
                iconType: iconType,
                expandedContent: tabItem.expandedContent
            }, tabItem.title))
    });
};
const $cb0e8fe57b0fd046$var$$737c57f1a347e52a$var$tabContentContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
    }
});
var $cb0e8fe57b0fd046$var$$737c57f1a347e52a$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$737c57f1a347e52a$var$TabContent;
const $cb0e8fe57b0fd046$export$187009fd9803261e = ({ tabs: tabs, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange })=>{
    const [selectedTabIndex, setSelectedTabIndex] = (0, $acw62.useState)(defaultSelectedIndex);
    const tabRefs = (0, $acw62.useRef)([]);
    const contentRef = (0, $acw62.useRef)(null);
    const handleSelectTab = (0, $acw62.useCallback)((index)=>{
        setSelectedTabIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        let newIndex = selectedTabIndex;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                newIndex = selectedTabIndex > 0 ? selectedTabIndex - 1 : tabs.length - 1;
                break;
            case "ArrowRight":
                event.preventDefault();
                newIndex = selectedTabIndex < tabs.length - 1 ? selectedTabIndex + 1 : 0;
                break;
            case "Home":
                event.preventDefault();
                newIndex = 0;
                break;
            case "End":
                event.preventDefault();
                newIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        if (newIndex !== selectedTabIndex) {
            contentRef.current?.focus?.();
            handleSelectTab(newIndex);
        }
    }, [
        selectedTabIndex,
        tabs.length,
        handleSelectTab
    ]);
    const selectedTabContent = (0, $acw62.useMemo)(()=>{
        const selected = tabs[selectedTabIndex];
        if (!selected) return null;
        return selected;
    }, [
        tabs,
        selectedTabIndex
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$6937e97bac512574$var$defaultContainerStyles,
            containerStyles
        ],
        "data-testid": "tabbed-accordion",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$6937e97bac512574$var$tabsHeaderStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$6937e97bac512574$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed accordion tabs",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    children: tabs.map((tab, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$6937e97bac512574$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedTabIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": tabs.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e41faf802a29e71, {
                                label: tab.label,
                                labelColor: tab.labelColor || (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: tab.labelColorSelected || (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelectedHover: tab.labelColorSelectedHover || (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                selectedColor: tab.color,
                                selectedHoverColor: tab.color,
                                size: $cb0e8fe57b0fd046$export$ddadc1228c8dcfa.SMALL,
                                selected: index === selectedTabIndex
                            })
                        }, tab.label))
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("hr", {
                css: $cb0e8fe57b0fd046$var$$6937e97bac512574$var$dividerStyles
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$6937e97bac512574$var$accordionContainerStyles,
                ref: contentRef,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedTabIndex}`,
                "aria-labelledby": `tab-${selectedTabIndex}`,
                "aria-label": `${tabs[selectedTabIndex]?.label} content`,
                children: selectedTabContent && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$737c57f1a347e52a$export$2e2bcd8739ae039, {
                    tabExpanders: selectedTabContent.tabExpanders,
                    color: selectedTabContent.color,
                    iconType: selectedTabContent.iconType
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$6937e97bac512574$var$defaultContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.600"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
    }
});
const $cb0e8fe57b0fd046$var$$6937e97bac512574$var$tabsHeaderStyles = (0, $gyDKM.css)({
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$6937e97bac512574$var$tabsRowStyles = (0, $gyDKM.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$6937e97bac512574$var$dividerStyles = (0, $gyDKM.css)({
    border: `0.5px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    width: "100%",
    margin: 0,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$6937e97bac512574$var$tabWrapperStyles = (0, $gyDKM.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $cb0e8fe57b0fd046$var$$6937e97bac512574$var$accordionContainerStyles = (0, $gyDKM.css)({
    width: "100%"
});
var $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$8aff256b69bb18bd$exports, "TabbedCards", ()=>$cb0e8fe57b0fd046$export$f0f045459b5b92);
const $cb0e8fe57b0fd046$export$f0f045459b5b92 = ({ cards: cards, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange, ctaText: ctaText = "Learn more" })=>{
    const safeDefaultSelectedIndex = Math.min(Math.max(0, defaultSelectedIndex), Math.max(0, cards.length - 1));
    const [selectedCardIndex, setSelectedCardIndex] = (0, $acw62.useState)(safeDefaultSelectedIndex);
    const tabRefs = (0, $acw62.useRef)([]);
    const handleSelectTab = (0, $acw62.useCallback)((index)=>{
        setSelectedCardIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const selectedCard = (0, $acw62.useMemo)(()=>{
        const selected = cards[selectedCardIndex];
        return selected ?? null;
    }, [
        cards,
        selectedCardIndex
    ]);
    if (!cards.length) return null;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$containerBaseStyles,
            containerStyles
        ],
        "data-testid": "tabbed-cards",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$tabsHeaderStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed cards tabs",
                    children: cards.map((card, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedCardIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": cards.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e41faf802a29e71, {
                                label: card.title,
                                labelColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
                                labelColorSelectedHover: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
                                selectedColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.discovery"),
                                selectedHoverColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.discovery"),
                                size: $cb0e8fe57b0fd046$export$ddadc1228c8dcfa.MEDIUM,
                                selected: index === selectedCardIndex
                            })
                        }, card.title))
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$panelContainerStyles,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedCardIndex}`,
                "aria-labelledby": `tab-${selectedCardIndex}`,
                "aria-label": `${cards[selectedCardIndex]?.title} content`,
                children: selectedCard && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$cardContainerStyles,
                    children: [
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$cardLeftStyles,
                            children: [
                                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$textBlockStyles,
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                            level: 3,
                                            children: selectedCard.title
                                        }),
                                        selectedCard.subtitle && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            size: "regular",
                                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                            children: selectedCard.subtitle
                                        })
                                    ]
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$ctaContainerStyles,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.LINK,
                                        label: ctaText,
                                        href: selectedCard.href,
                                        target: selectedCard.target,
                                        iconAfter: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "arrow-right",
                                            alt: "Arrow right",
                                            size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                })
                            ]
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$imageWellStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                src: selectedCard.img.src,
                                alt: selectedCard.img.alt,
                                width: selectedCard.img.width,
                                height: selectedCard.img.height,
                                css: $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$cardImageStyles,
                                loading: selectedCard.img.loading,
                                decoding: selectedCard.img.decoding
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$containerBaseStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.600"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$tabsHeaderStyles = (0, $gyDKM.css)({
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$tabsRowStyles = (0, $gyDKM.css)({
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    overflowX: "auto",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        flexWrap: "wrap",
        justifyContent: "flex-start"
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$tabWrapperStyles = (0, $gyDKM.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab-selected"]:active': {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.discovery")
    },
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$panelContainerStyles = (0, $gyDKM.css)({
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$cardContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface"),
    borderRadius: "8px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "266px",
    gap: "80px",
    paddingLeft: "62px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$cardLeftStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    flex: "1 1 auto",
    minWidth: 0,
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        padding: 0
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$textBlockStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    minWidth: 0
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$ctaContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    // Align button label with heading/subtitle by removing left padding.
    '& [data-testid="button-link"]': {
        paddingLeft: 0
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$imageWellStyles = (0, $gyDKM.css)({
    width: "416px",
    height: "266px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        width: "100%",
        height: "200px",
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px"
    }
});
const $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$var$cardImageStyles = (0, $gyDKM.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
});
var $cb0e8fe57b0fd046$var$$271716b3dbf43c41$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$271716b3dbf43c41$exports, "MeatballMenu", ()=>$cb0e8fe57b0fd046$export$ef4a0fdddd7eccb7);
const $cb0e8fe57b0fd046$export$ef4a0fdddd7eccb7 = ({ items: items, placement: placement = "bottom-end", testId: testId = "meatball-menu", ariaLabel: ariaLabel = "More options", isInverted: isInverted = false })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$271716b3dbf43c41$var$menuContainerStyles,
        "data-testid": testId,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f8fc2edc4a47080d$export$2e2bcd8739ae039), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                    ...props,
                    ref: triggerRef,
                    css: [
                        $cb0e8fe57b0fd046$var$$271716b3dbf43c41$var$triggerButtonStyles,
                        isInverted && $cb0e8fe57b0fd046$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles
                    ],
                    "aria-label": ariaLabel,
                    "data-testid": `${testId}-trigger`,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "more-vertical",
                        rotation: $cb0e8fe57b0fd046$export$b3241a99d3e47e02.NINETY,
                        alt: ariaLabel,
                        color: isInverted ? "#FFFFFF" : undefined
                    })
                }),
            placement: placement,
            children: items.map((item, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $0c583eef1017b111$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    testId: item.testId || `${testId}-item-${index}`,
                    children: item.label
                }, `${item.label}-${index}`))
        })
    });
};
const $cb0e8fe57b0fd046$var$$271716b3dbf43c41$var$menuContainerStyles = (0, $gyDKM.css)({
    display: "inline-flex",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$271716b3dbf43c41$var$triggerButtonStyles = (0, $gyDKM.css)({
    background: "transparent",
    border: "none",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.hovered")
    },
    "&:active": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.pressed")
    },
    "&:focus": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")}`,
        outlineOffset: "2px"
    }
});
const $cb0e8fe57b0fd046$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles = (0, $gyDKM.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    }
});
var $cb0e8fe57b0fd046$var$$fd4e65895774e705$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fd4e65895774e705$exports, "ProfileAvatarSize", ()=>$cb0e8fe57b0fd046$export$902867f9afe4e0c1);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fd4e65895774e705$exports, "ProfileAvatar", ()=>$cb0e8fe57b0fd046$export$3778be82376b06d7);
let $cb0e8fe57b0fd046$export$902867f9afe4e0c1;
(function(ProfileAvatarSize) {
    ProfileAvatarSize["XS"] = "xs";
    ProfileAvatarSize["S"] = "s";
    ProfileAvatarSize["M"] = "m";
    ProfileAvatarSize["L"] = "l";
    ProfileAvatarSize["XL"] = "xl";
    ProfileAvatarSize["XXL"] = "xxl";
    ProfileAvatarSize["XXXL"] = "xxxl";
})($cb0e8fe57b0fd046$export$902867f9afe4e0c1 || ($cb0e8fe57b0fd046$export$902867f9afe4e0c1 = {}));
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$sizeMap = {
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XS]: 16,
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.S]: 24,
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.M]: 32,
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.L]: 40,
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XL]: 96,
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XXL]: 128,
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XXXL]: 248
};
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$atlaskitSizeMap = {
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XS]: "xsmall",
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.S]: "small",
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.M]: "medium",
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.L]: "large",
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XL]: "xlarge",
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XXL]: "xxlarge",
    [$cb0e8fe57b0fd046$export$902867f9afe4e0c1.XXXL]: "xxlarge"
};
// Pixel sizes used internally by @atlaskit/avatar for each `size` value.
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$atlaskitSizePx = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $cb0e8fe57b0fd046$export$3778be82376b06d7 = ({ size: size, label: label, src: src, showCameraIconOnXXXL: showCameraIconOnXXXL = false, onCameraClick: onCameraClick })=>{
    const avatarSize = $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$sizeMap[size] ?? $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$sizeMap[$cb0e8fe57b0fd046$export$902867f9afe4e0c1.M];
    const borderWidth = size === $cb0e8fe57b0fd046$export$902867f9afe4e0c1.XXXL ? 8 : 2;
    const scale = avatarSize / $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$atlaskitSizePx[$cb0e8fe57b0fd046$var$$fd4e65895774e705$var$atlaskitSizeMap[size]];
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
        xcss: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$wrapperBaseStyles,
        style: {
            width: avatarSize + 2 * borderWidth,
            height: avatarSize + 2 * borderWidth
        },
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                xcss: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$avatarFrameStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                        xcss: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$avatarBorderRingStyles,
                        style: {
                            border: `${borderWidth}px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.overlay")}`
                        }
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                        xcss: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$avatarScaleWrapperStyles,
                        style: {
                            transform: `scale(${scale})`
                        },
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $8ba2d884d9509fca$export$2e2bcd8739ae039), {
                            size: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$atlaskitSizeMap[size],
                            src: src,
                            name: label,
                            borderColor: "transparent"
                        })
                    })
                ]
            }),
            showCameraIconOnXXXL ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                as: "span",
                xcss: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$cameraWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                    as: "button",
                    type: "button",
                    xcss: $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$cameraButtonStyles,
                    "aria-label": "Change profile picture",
                    onClick: onCameraClick,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bccdbb9b5a9b9950$exports))), {
                        label: "Change profile picture",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.subtle")
                    })
                })
            }) : null
        ]
    });
};
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$wrapperBaseStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box"
});
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$avatarFrameStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    borderRadius: "border.radius.circle",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "color.background.neutral",
    boxSizing: "border-box",
    position: "relative"
});
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$avatarBorderRingStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    position: "absolute",
    inset: "space.0",
    borderRadius: "border.radius.circle",
    pointerEvents: "none",
    boxSizing: "border-box"
});
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$avatarScaleWrapperStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    transformOrigin: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$cameraWrapperStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    position: "absolute",
    width: "55px",
    height: "55px",
    borderRadius: "border.radius.circle",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: "16px",
    bottom: "14px",
    backgroundColor: "color.background.input",
    boxShadow: "elevation.shadow.overlay"
});
const $cb0e8fe57b0fd046$var$$fd4e65895774e705$var$cameraButtonStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    borderRadius: "border.radius.circle",
    borderWidth: "border.width.0",
    padding: "space.0",
    margin: "space.0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    cursor: "pointer"
});
var $cb0e8fe57b0fd046$var$$54253e316d7b853e$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$54253e316d7b853e$exports, "IconSizeWrapper", ()=>$cb0e8fe57b0fd046$export$a98b567077af326b);
const $cb0e8fe57b0fd046$var$$54253e316d7b853e$var$sizeMap = {
    xsmall: 12,
    small: 14,
    medium: 16,
    large: 24,
    xlarge: 32
};
function $cb0e8fe57b0fd046$var$$54253e316d7b853e$var$resolveSize(value) {
    return typeof value === "number" ? `${value}px` : value;
}
const $cb0e8fe57b0fd046$var$$54253e316d7b853e$var$wrapperStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
});
function $cb0e8fe57b0fd046$export$a98b567077af326b({ children: children, size: size, width: width, height: height }) {
    const resolvedWidth = width != null ? $cb0e8fe57b0fd046$var$$54253e316d7b853e$var$resolveSize(width) : `${$cb0e8fe57b0fd046$var$$54253e316d7b853e$var$sizeMap[size ?? "large"]}px`;
    const resolvedHeight = height != null ? $cb0e8fe57b0fd046$var$$54253e316d7b853e$var$resolveSize(height) : `${$cb0e8fe57b0fd046$var$$54253e316d7b853e$var$sizeMap[size ?? "large"]}px`;
    const refCallback = (0, $acw62.useCallback)((el)=>{
        if (el) {
            const svg = el.querySelector("svg");
            if (svg) {
                svg.style.width = resolvedWidth;
                svg.style.height = resolvedHeight;
            }
        }
    }, [
        resolvedWidth,
        resolvedHeight
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $608d3c177085052d$export$2e2bcd8739ae039), {
        xcss: $cb0e8fe57b0fd046$var$$54253e316d7b853e$var$wrapperStyles,
        ref: refCallback,
        children: children
    });
}
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$660bd1c6cb41002a$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$fec02fc26c7e145d$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$d501466973a9f0a6$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$c4979bfceee73878$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$0903e93de01b205a$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$a950778dc3003c4a$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$582583ec420fce57$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$a02a6f7de308273b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$1298c86a7e6a9fc7$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$c0c01354ab9765ae$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$4fce8dfc4ce8f546$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$800df40a54823a3f$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$25cbe9fdb2d8d071$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$9efbb38deb40219f$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$3fbcb32390ca7008$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$731a4fd527bab680$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$5cf70e33bfc6ce73$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$8b54d37779d052e8$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$9cfa05d02afa3952$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$7d458ed59bb9c6a8$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$a467abe0c2c1750b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$52124b9ae1d78e04$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$b5ebb29d1a23bfec$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$77696804880d7cdc$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$4366d2b05f9f8f6b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$be203e745bcefb12$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$a0eced43682c2d75$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$1db60c687807de63$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$2f0c862779035c26$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$6937e97bac512574$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$8aff256b69bb18bd$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$271716b3dbf43c41$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$fd4e65895774e705$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports, $cb0e8fe57b0fd046$var$$54253e316d7b853e$exports);
var $cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports = {};
var $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$83fc18f8199a12ff$exports, "AudioPlayer", ()=>$cb0e8fe57b0fd046$export$832cc5475f11d8b4);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $cb0e8fe57b0fd046$export$832cc5475f11d8b4 = ({ source: source, isOpened: isOpened, onClose: onClose, onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError })=>{
    const audioRef = (0, $acw62.useRef)(null);
    const focusRef = (0, $acw62.useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvent = (0, $acw62.useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, [
        onControlClick,
        onProgressUpdate
    ]);
    const addEvents = (0, $acw62.useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        addEvent,
        onError
    ]);
    (0, $acw62.useEffect)(()=>{
        const player = new (0, (/*@__PURE__*/$parcel$interopDefault($52477d57b9d8c8b9$exports)))(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": "Audio player",
        ref: focusRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        css: $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$var$audioPlayerStyles,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("figure", {
            "data-testid": "audio-player",
            css: $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$var$figureStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("audio", {
                    ref: audioRef
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "cross",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$var$audioPlayerStyles = (0, $gyDKM.css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $5e26c99fa43b3c99$export$e62e8919cca44969),
        "--plyr-audio-control-color": (0, $5e26c99fa43b3c99$export$29a4f05edc054374),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $5e26c99fa43b3c99$export$c2e91cbeada39b8b),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $5e26c99fa43b3c99$export$c39c0fe0f26207ae),
        "--plyr-tooltip-color": (0, $5e26c99fa43b3c99$export$29a4f05edc054374),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $5e26c99fa43b3c99$export$e62e8919cca44969)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$var$figureStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$var$closeIconStyles = (0, $gyDKM.css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});
var $cb0e8fe57b0fd046$var$$438c82700c218044$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$438c82700c218044$exports, "ArticleJumpLinks", ()=>$cb0e8fe57b0fd046$export$e11be3ad528d3c05);
const $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f = (0, $gyDKM.css)({
    display: "flex",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    // desktop
    "@media (min-width: 1000px)": {
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`,
        maxWidth: "290px"
    }
});
const $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$2dc6a66a41038997 = (0, $gyDKM.css)({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa = (0, $gyDKM.css)({
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    position: "relative",
    "&:hover": {
        borderRadius: "4px",
        backgroundColor: "rgba(220, 223, 228, 0.50)"
    },
    "& a": {
        // limit to 2 lines
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        wordBreak: "break-word",
        overflow: "hidden",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
        textOverflow: "ellipsis",
        textDecoration: "none",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce = (0, $gyDKM.css)({
    // desktop
    "@media (min-width: 1000px)": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest"),
        borderRadius: "4px",
        "& a": {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
        },
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        },
        ":before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "16px",
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
            position: "absolute",
            left: "0",
            top: "50%",
            transform: "translateY(-50%)"
        }
    }
});
const $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$405b853093cc10c7 = (0, $gyDKM.css)({
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    "& h6": {
        textOverflow: "ellipsis",
        fontSize: "16px !important",
        lineHeight: "24px !important"
    },
    // desktop
    "@media (min-width: 1000px)": {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$438c82700c218044$var$DEFAULT_TITLE = "On this page";
const $cb0e8fe57b0fd046$export$e11be3ad528d3c05 = ({ links: links, className: className, style: style, onClick: onClick, title: title = $cb0e8fe57b0fd046$var$$438c82700c218044$var$DEFAULT_TITLE, activeHref: activeHref })=>{
    const [internalActiveLink, setInternalActiveLink] = (0, $acw62.useState)(null);
    const handleScroll = (0, $acw62.useCallback)(()=>{
        internalActiveLink && setInternalActiveLink(null);
    }, [
        internalActiveLink
    ]);
    const handleClick = (0, $acw62.useCallback)((link)=>{
        requestAnimationFrame(()=>{
            setInternalActiveLink(link);
        });
        onClick?.(link);
    }, [
        onClick,
        setInternalActiveLink
    ]);
    (0, $acw62.useEffect)(()=>{
        // Only add scroll listener if activeHref is not provided (internal state mode)
        if (!activeHref) {
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        handleScroll,
        activeHref
    ]);
    const linksWithHref = (0, $acw62.useMemo)(()=>{
        return links.map((link)=>{
            const linkHref = link.href ? link.href : $cb0e8fe57b0fd046$export$1bdcd43c8c2377cf(link.label);
            // Use activeHref prop if provided, otherwise fall back to internal state
            const isActive = activeHref ? linkHref === activeHref : internalActiveLink?.label === link.label;
            const onLinkClick = ()=>handleClick?.(link);
            return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                css: [
                    $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa,
                    isActive && $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                    href: linkHref,
                    onClick: onLinkClick,
                    children: link.label
                })
            }, linkHref);
        });
    }, [
        links,
        internalActiveLink,
        activeHref,
        handleClick
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$405b853093cc10c7,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                    level: 6,
                    children: title
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                css: $cb0e8fe57b0fd046$var$$7af640a6c4cb35c7$export$2dc6a66a41038997,
                className: className,
                style: style,
                children: linksWithHref
            })
        ]
    });
};
var $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$389dbaf1c04dd698$exports, "BadgeCard", ()=>$cb0e8fe57b0fd046$export$22da447a4012011);
const $cb0e8fe57b0fd046$export$22da447a4012011 = ({ image: image, badgeTitle: badgeTitle, earnedDate: earnedDate, link: link, onClick: onClick })=>{
    const clickHandler = (0, $acw62.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(clickHandler);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        css: $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e431a229df88919, {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                        css: $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$containerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    border: `0 solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$contentContainerStyles = (0, $gyDKM.css)({
    marginLeft: "16px"
});
const $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$badgeTitleStyles = (0, $gyDKM.css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$var$earnedDateStyles = (0, $gyDKM.css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});
var $cb0e8fe57b0fd046$var$$c18917e553fd2737$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$c18917e553fd2737$exports, "CertificateCard", ()=>$cb0e8fe57b0fd046$export$c572aa3e2aa38d2);
const $cb0e8fe57b0fd046$export$c572aa3e2aa38d2 = ({ image: image, backgroundColor: backgroundColor, title: title, link: link, onClick: onClick })=>{
    const clickHandler = (0, $acw62.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(clickHandler);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$cardHeaderStyles,
                    (0, $gyDKM.css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$imageContainerStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e431a229df88919, {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$containerStyles = (0, $gyDKM.css)({
    maxWidth: "280px",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$cardHeaderStyles = (0, $gyDKM.css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$imageContainerStyles = (0, $gyDKM.css)({
    height: "112px",
    width: "112px"
});
const $cb0e8fe57b0fd046$var$$c18917e553fd2737$var$cardTitleStyles = (0, $gyDKM.css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});
var $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3ca3d702a74367ba$exports, "ContentOverviewCardState", ()=>$cb0e8fe57b0fd046$export$84c408eab3fc01b3);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3ca3d702a74367ba$exports, "ContentOverviewCard", ()=>$cb0e8fe57b0fd046$export$cb86f63bb5e77777);
var $cb0e8fe57b0fd046$var$$ed20910b93d89c3f$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ed20910b93d89c3f$exports, "ContentType", ()=>$cb0e8fe57b0fd046$export$e2e108cbe2e4f865);
let $cb0e8fe57b0fd046$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($cb0e8fe57b0fd046$export$e2e108cbe2e4f865 || ($cb0e8fe57b0fd046$export$e2e108cbe2e4f865 = {}));
let $cb0e8fe57b0fd046$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($cb0e8fe57b0fd046$export$84c408eab3fc01b3 || ($cb0e8fe57b0fd046$export$84c408eab3fc01b3 = {}));
const $cb0e8fe57b0fd046$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode, state: state = $cb0e8fe57b0fd046$export$84c408eab3fc01b3.DEFAULT, heading: heading, subheading: subheading, tags: tags = [], collapsedSectionItems: itemsSectionCollapsed = [], collapsedSectionContent: infoSectionCollapsed = "", collapsedSectionTitle: titleSectionCollapsed, contentType: contentType, onClickButton: onClickButton, href: href })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const handleClickButton = (0, $acw62.useCallback)((event)=>{
        if (onClickButton) {
            event?.preventDefault();
            onClickButton();
        }
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $acw62.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("article", {
        "aria-label": heading,
        css: [
            $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$articleContainerStyles,
            state === $cb0e8fe57b0fd046$export$84c408eab3fc01b3.FINISHED && (0, $gyDKM.css)({
                borderLeftColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success")
            })
        ],
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$containerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                type: "chevron-down"
                            })
                        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                type: "chevron-right"
                            })
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$tagStyles,
                                                children: /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$titleContainerStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                        ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("description", inspectMode),
                                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $cb0e8fe57b0fd046$export$84c408eab3fc01b3.LOADING && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $cb0e8fe57b0fd046$export$84c408eab3fc01b3.DEFAULT && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "Get started",
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $cb0e8fe57b0fd046$export$84c408eab3fc01b3.IN_PROGRESS && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "Continue",
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $cb0e8fe57b0fd046$export$84c408eab3fc01b3.FINISHED && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: (0, $gyDKM.css)({
                                                    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
                                                }),
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
                                                    link: href || "#",
                                                    label: `Review ${$cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: (event)=>handleClickButton(event),
                                                    target: "_blank"
                                                })
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                type: "check-circle",
                                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "section-expanded",
                css: [
                    $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $gyDKM.css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionContentStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb, {
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"),
                            height: 1
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("sectionList", inspectMode),
                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionTitleStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                                css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                                        css: $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$articleContainerStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `8px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$containerStyles = (0, $gyDKM.css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$buttonStyles = (0, $gyDKM.css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $gyDKM.css)({
    marginRight: "16px"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$gridContainerStyles = (0, $gyDKM.css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$gridItemStyles = (0, $gyDKM.css)({
    gridColumn: "span 12",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 9",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$tagContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexWrap: "wrap"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$tagStyles = (0, $gyDKM.css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$titleContainerStyles = (0, $gyDKM.css)({
    margin: "16px auto",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        marginRight: "1px"
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$descriptionStyles = (0, $gyDKM.css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$gridSideItemStyles = (0, $gyDKM.css)({
    gridColumn: "span 12",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    marginRight: "4px"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionExpandedStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionContentStyles = (0, $gyDKM.css)({
    margin: "8px 0"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionListStyles = (0, $gyDKM.css)({
    padding: "24px 0"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$sectionTitleStyles = (0, $gyDKM.css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$listStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    fontFamily: "Inter, sans-serif",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$var$itemStyles = (0, $gyDKM.css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});
var $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$exports, "EmptyState", ()=>$cb0e8fe57b0fd046$export$fddf379e22a74b00);
const $cb0e8fe57b0fd046$export$fddf379e22a74b00 = ({ image: image, description: description, redirectLink: redirectLink })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$imageContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e431a229df88919, {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$descriptionStyles,
                        tabIndex: 0,
                        children: description
                    }),
                    redirectLink && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: $cb0e8fe57b0fd046$export$2b77966d73aefa77.SEMIBOLD,
                        fontColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link"),
                        css: (0, $gyDKM.css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$containerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $5e26c99fa43b3c99$export$5f71e19f3a7ad9de),
    borderRadius: "4px",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$imageContainerStyles = (0, $gyDKM.css)({
    width: "64px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        width: "96px"
    }
});
const $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $gyDKM.css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$var$descriptionStyles = (0, $gyDKM.css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});
var $cb0e8fe57b0fd046$var$$81dd635d83decaee$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", ()=>$cb0e8fe57b0fd046$export$f9292ef28b7b429a);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$81dd635d83decaee$exports, "InlineFeedbackMessage", ()=>$cb0e8fe57b0fd046$export$f23c56ac9ab316f);
let $cb0e8fe57b0fd046$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($cb0e8fe57b0fd046$export$f9292ef28b7b429a || ($cb0e8fe57b0fd046$export$f9292ef28b7b429a = {}));
const $cb0e8fe57b0fd046$export$f23c56ac9ab316f = ({ title: title, description: description, appearance: appearance = $cb0e8fe57b0fd046$export$f9292ef28b7b429a.CORRECT })=>{
    const isIncorrectAppearance = appearance === $cb0e8fe57b0fd046$export$f9292ef28b7b429a.INCORRECT;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $gyDKM.css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success")}`
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "error",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.danger")
                    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "check-circle",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success")
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                css: $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                css: $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input")
});
const $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $gyDKM.css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageContentStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        marginLeft: "8px"
    }
});
const $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    margin: 0,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px"
    }
});
const $cb0e8fe57b0fd046$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $gyDKM.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$8d99d7c025746ac9$exports, "LearningContentCard", ()=>$cb0e8fe57b0fd046$export$c01be50dd5c433fe);
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title, description: description, isLearningProgress: isLearningProgress, inspectMode: inspectMode, disableDescriptionClamp: disableDescriptionClamp })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "card-content",
        css: $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("h4", {
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                css: $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("h5", {
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                css: $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                "data-testid": "description",
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("description", inspectMode),
                css: [
                    $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$descriptionStyles,
                    disableDescriptionClamp && $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$descriptionNoClampStyles
                ],
                children: description
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`,
    marginBottom: "-2px"
});
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$baseTitleStyles = (0, $gyDKM.css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $gyDKM.css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    height: "64px"
});
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$withProgressTitleStyles = (0, $gyDKM.css)([
    $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$catalogTitleStyles = (0, $gyDKM.css)([
    $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} !important`
    }
]);
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$descriptionStyles = (0, $gyDKM.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle")
});
const $cb0e8fe57b0fd046$var$$94fa590b0c9d9421$var$descriptionNoClampStyles = (0, $gyDKM.css)({
    display: "block",
    WebkitLineClamp: "none",
    overflow: "visible"
});
const $cb0e8fe57b0fd046$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl, backgroundColor: backgroundColor, productIcon: productIcon, isLearningProgress: isLearningProgress, imageHeight: imageHeight })=>{
    let height = isLearningProgress ? "96px" : "80px";
    if (imageHeight) height = `${imageHeight}px`;
    const backgroundSize = imageHeight ? "contain" : "cover";
    const backgroundPosition = imageHeight ? "center" : undefined; // if imageHeight is provided, the image will be displayed at the center of the container
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $cb0e8fe57b0fd046$var$$f73a4551a9d8a3b1$var$noImageStyles,
            (0, $gyDKM.css)({
                backgroundColor: backgroundColor,
                height: height,
                backgroundSize: backgroundSize,
                ...backgroundPosition && {
                    backgroundPosition: backgroundPosition
                }
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
            css: (0, $gyDKM.css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
};
const $cb0e8fe57b0fd046$var$$f73a4551a9d8a3b1$var$imageBaseStyles = (0, $gyDKM.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$f73a4551a9d8a3b1$var$noImageStyles = (0, $gyDKM.css)({
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $cb0e8fe57b0fd046$var$$70542fe329d53412$export$ce572121d239fe86 = 4;
const $cb0e8fe57b0fd046$var$$70542fe329d53412$export$3b38c99bd0870716 = 290;
const $cb0e8fe57b0fd046$var$$70542fe329d53412$export$bb4069a5b1582edc = 24;
const $cb0e8fe57b0fd046$var$$70542fe329d53412$export$9c6eb1f46b993412 = 3;
const $cb0e8fe57b0fd046$var$$fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags, lastLabelWidth: lastLabelWidth })=>tags.length > 0 && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, $cb0e8fe57b0fd046$var$$70542fe329d53412$export$9c6eb1f46b993412).map((tag, index, arr)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: index === arr.length - 1 && (0, $gyDKM.css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $cb0e8fe57b0fd046$var$$fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                    ...tag
                })
            }, tag.label + index))
    });
const $cb0e8fe57b0fd046$var$$fb345954107134f9$var$labelContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$cb0e8fe57b0fd046$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$cb0e8fe57b0fd046$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $cb0e8fe57b0fd046$var$$fb345954107134f9$var$truncatedLabelStyles = (0, $gyDKM.css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});
var $cb0e8fe57b0fd046$var$$d8ee29df49af8811$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$d8ee29df49af8811$exports, "LearningProgressBar", ()=>$cb0e8fe57b0fd046$export$184a993f673fc83f);
const $cb0e8fe57b0fd046$export$184a993f673fc83f = ({ wasPreviouslyCompleted: wasPreviouslyCompleted = false, completedResources: completedResources, resourceCount: resourceCount, completionDate: completionDate, contentType: contentType })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round($cb0e8fe57b0fd046$export$6e67b290ed5690f6(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount || wasPreviouslyCompleted) return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "gap-completed"
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                css: [
                    $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressTitleStyles,
                    (0, $gyDKM.css)({
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $59f888d7dcabf163$export$5ab97151efedb8c6), {
                    strokeWidth: 10,
                    value: $cb0e8fe57b0fd046$export$6e67b290ed5690f6(completedResources, resourceCount),
                    styles: (0, $59f888d7dcabf163$export$5115a192ad9bf57f)({
                        pathColor: completedResources === 0 ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.success")
                    })
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                css: $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressBarContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressBarStyles = (0, $gyDKM.css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$d8ee29df49af8811$var$progressTitleStyles = (0, $gyDKM.css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle")
});
let $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061;
(function(LearningProgressStatus) {
    LearningProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    LearningProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LearningProgressStatus["COMPLETED"] = "COMPLETED";
})($cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061 || ($cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061 = {}));
let $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["COMPLETED"] = "completed";
    CardStatus["DEFAULT"] = "default";
})($cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8 || ($cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8 = {}));
const $cb0e8fe57b0fd046$var$$035f8a623e403361$export$780035d9fe48eb32 = 420;
var $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$exports, "ShowMore", ()=>$cb0e8fe57b0fd046$export$ca7697601dcd7803);
const $cb0e8fe57b0fd046$export$ca7697601dcd7803 = ({ cardRef: cardRef, shareOnPdf: shareOnPdf, onGeneratePdf: onGeneratePdf, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, alignToRight: alignToRight })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleOnViewUpdates = (event)=>{
        if (onViewUpdates) {
            event.stopPropagation();
            event.preventDefault();
            onViewUpdates();
            setIsOpen(!isOpen);
        }
    };
    const handleGeneratePdf = (0, $acw62.useCallback)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }, [
        onGeneratePdf
    ]);
    const handleViewUpdates = (0, $acw62.useCallback)(()=>{
        if (onViewUpdates) onViewUpdates();
    }, [
        onViewUpdates
    ]);
    const onKeyDownGeneratePdf = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleGeneratePdf);
    const onKeyDownViewUpdates = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleViewUpdates);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: (0, $gyDKM.css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "show-more",
        ref: dropdownRef,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                label: "",
                appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "more-vertical"
                }),
                iconType: "more-vertical"
            }),
            isOpen && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "show-more-dropdown",
                css: [
                    $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles,
                    alignToRight && (0, $gyDKM.css)({
                        right: "unset",
                        textAlign: "left"
                    })
                ],
                children: [
                    shareOnPdf && onGeneratePdf && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "Export to PDF"
                        })
                    }),
                    areHistoricalNotifications && onViewUpdates && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnViewUpdates,
                        onKeyDown: onKeyDownViewUpdates,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "View updates"
                        })
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles = (0, $gyDKM.css)({
    position: "absolute",
    right: 0,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "7px 0",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    zIndex: 2,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$optionStyles = (0, $gyDKM.css)({
    width: "220px",
    padding: "7px 24px",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    ":hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$var$optionTextStyles = (0, $gyDKM.css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});
const $cb0e8fe57b0fd046$export$c01be50dd5c433fe = ({ inspectMode: inspectMode, title: title, description: description, onClick: onClick, target: target, link: link, tags: tags, disableDescriptionClamp: disableDescriptionClamp, minHeight: minHeight = 248, isLoading: isLoading = false, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, productIcon: productIcon, imageUrl: imageUrl, imageHeight: imageHeight, backgroundColor: backgroundColor })=>{
    const cardRef = (0, $acw62.useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $acw62.useState)("auto");
    const clickHandler = (0, $acw62.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(clickHandler);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const handleUpdatedButtonClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    (0, $acw62.useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || $cb0e8fe57b0fd046$var$$70542fe329d53412$export$3b38c99bd0870716) - $cb0e8fe57b0fd046$var$$70542fe329d53412$export$bb4069a5b1582edc * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, $cb0e8fe57b0fd046$var$$70542fe329d53412$export$9c6eb1f46b993412).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + $cb0e8fe57b0fd046$var$$70542fe329d53412$export$ce572121d239fe86;
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ($cb0e8fe57b0fd046$var$$70542fe329d53412$export$ce572121d239fe86 * tagsContainer.children.length - 1) + $cb0e8fe57b0fd046$var$$70542fe329d53412$export$bb4069a5b1582edc * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ if (isLoading) return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$imageBaseStyles,
                    $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$labelContainerStyles,
                        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$smallPillStyles
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $gyDKM.css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: (0, $gyDKM.css)({
                                marginTop: "12px"
                            }),
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $gyDKM.css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            ref: cardRef,
            role: "link",
            css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a, {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress,
                    imageHeight: imageHeight
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: [
                        $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$fb345954107134f9$export$331084b24da1eef5, {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$94fa590b0c9d9421$export$64ef9b8c11710c47, {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress,
                            disableDescriptionClamp: disableDescriptionClamp
                        }),
                        learningProgress && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$184a993f673fc83f, {
                                        wasPreviouslyCompleted: learningProgress.status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.LEARNING_PATH
                                    }),
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            isUpdated && learningProgress.status !== $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                "data-testid": "updated-icon",
                                                css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$updatedIconContainerStyles,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                                    label: "Updated",
                                                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                        type: "editor-panel"
                                                    }),
                                                    onClick: handleUpdatedButtonClick
                                                })
                                            }),
                                            shouldDisplayShowMoreButton && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$ca7697601dcd7803, {
                                                cardRef: cardRef,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf,
                                                areHistoricalNotifications: areHistoricalNotifications,
                                                onViewUpdates: onViewUpdates
                                            }),
                                            shouldDisplayBookmark && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "save-content",
                                                css: $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "bookmark-filled"
                                                }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$imageBaseStyles = (0, $gyDKM.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$noImageStyles = (0, $gyDKM.css)({
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$bodyContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${$cb0e8fe57b0fd046$var$$70542fe329d53412$export$bb4069a5b1582edc}px 0 0`
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $gyDKM.css)({
    padding: `21px 0 0`
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$labelContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$cb0e8fe57b0fd046$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$cb0e8fe57b0fd046$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$linkContainerStyles = (0, $gyDKM.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $gyDKM.css)({
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$updatedIconContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $gyDKM.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${$cb0e8fe57b0fd046$var$$70542fe329d53412$export$3b38c99bd0870716}px`,
    "&:hover": {
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")}`
    },
    '&:has([data-testid="show-more"]:active)': {
        outline: "none",
        border: "none"
    }
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $gyDKM.css)({
    boxShadow: "none",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled")}`
    }
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$smallPillStyles = (0, $gyDKM.css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    display: "inline-block"
});
const $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$var$bigPillStyles = (0, $gyDKM.css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
var $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$1f7c4876f10b107b$exports, "Modal", ()=>$cb0e8fe57b0fd046$export$2b77a92f1a5ad772);
let $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$DialogWidth || ($cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$DialogWidth = {}));
const $cb0e8fe57b0fd046$export$2b77a92f1a5ad772 = ({ closeModal: closeModal, width: width = $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$DialogWidth.LARGE, imageLink: imageLink, actionButton: actionButton, heading: heading, subheading: subheading, surveyText: surveyText })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $2de636e70f18707f$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        label: "close modal button",
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-subheading",
                            css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        actionButton && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                size: $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$imageStyles = (0, $gyDKM.css)({
    borderRadius: "50%"
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalContainerStyles = (0, $gyDKM.css)({
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")}`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: "16px"
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: "8px"
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalImageContainerStyles = (0, $gyDKM.css)({
    marginBottom: "24px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "16px"
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalBodyStyles = (0, $gyDKM.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$surveyTextStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        margin: 0
    }
});
var $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$c5616d3f1657fc84$exports, "LessonsTabContentSize", ()=>$cb0e8fe57b0fd046$export$415b2bdf1346d2d4);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$c5616d3f1657fc84$exports, "LessonsTabContent", ()=>$cb0e8fe57b0fd046$export$ce96f190f5d3ee14);
let $cb0e8fe57b0fd046$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($cb0e8fe57b0fd046$export$415b2bdf1346d2d4 || ($cb0e8fe57b0fd046$export$415b2bdf1346d2d4 = {}));
const $cb0e8fe57b0fd046$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks, activeTab: activeTab = 0, onClickTab: onClickTab, children: children, size: size = $cb0e8fe57b0fd046$export$415b2bdf1346d2d4.DEFAULT })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                css: $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e41faf802a29e71, {
                            size: $cb0e8fe57b0fd046$export$ddadc1228c8dcfa.LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $gyDKM.css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $gyDKM.css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $gyDKM.css)({
        maxWidth: "1020px"
    })
};
const $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $gyDKM.css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        padding: "12px"
    }
});
const $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $gyDKM.css)({
    margin: "6px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        margin: "4px"
    }
});
const $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $cb0e8fe57b0fd046$var$$eb6f767c51421421$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$eb6f767c51421421$exports, "Metadata", ()=>$cb0e8fe57b0fd046$export$e7adebdc1ebd2fed);
const $cb0e8fe57b0fd046$export$e7adebdc1ebd2fed = ({ fields: fields })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                            css: $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataListStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataItemsStyles = (0, $gyDKM.css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataTitleStyles = (0, $gyDKM.css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $cb0e8fe57b0fd046$var$$eb6f767c51421421$var$metadataValueStyles = (0, $gyDKM.css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
var $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$exports, "ArrowPosition", ()=>$cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$exports, "Popup", ()=>$cb0e8fe57b0fd046$export$129a32eedafa97c5);
let $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9 || ($cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9 = {}));
const $cb0e8fe57b0fd046$export$129a32eedafa97c5 = (0, $acw62.forwardRef)(({ popupHeight: popupHeight, title: title, children: children, step: step, totalSteps: totalSteps, arrowPosition: arrowPosition, onClose: onClose, onPrevious: onPrevious, onNext: onNext, popupStyle: popupStyle }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // handleClose and popoverRef intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        onClose
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": title,
        "data-testid": `popup-${arrowPosition}`,
        css: $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: [
                $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$popupContentStyles["base"],
                $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                            css: $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    disabled: step === 1,
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                                    label: "Previous",
                                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    disabled: step === totalSteps,
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                                    label: "Next",
                                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: (0, $gyDKM.css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        minHeight: "80px",
                        padding: "0 16px"
                    }),
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                            css: $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                            css: $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$popupContainerStyles = (0, $gyDKM.css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"),
        borderRadius: 0
    }
});
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $gyDKM.css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $gyDKM.css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $gyDKM.css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $gyDKM.css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $gyDKM.css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $gyDKM.css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $gyDKM.css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $gyDKM.css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $gyDKM.css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $gyDKM.css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $gyDKM.css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $gyDKM.css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $gyDKM.css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$contentHeaderStyles = (0, $gyDKM.css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$titleContainerStyles = (0, $gyDKM.css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$counterContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center"
});
var $cb0e8fe57b0fd046$var$$915f5687b3b07750$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$915f5687b3b07750$exports, "ProgressBar", ()=>$cb0e8fe57b0fd046$export$c17561cb55d4db30);
const $cb0e8fe57b0fd046$export$c17561cb55d4db30 = ({ progress: progress, color: color })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        "data-testid": "progress-bar",
        css: $cb0e8fe57b0fd046$var$$915f5687b3b07750$var$progressBarContainerStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $cb0e8fe57b0fd046$var$$915f5687b3b07750$var$progressBarContentStyles,
                color && (0, $gyDKM.css)({
                    backgroundColor: color
                }),
                (0, $gyDKM.css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $cb0e8fe57b0fd046$var$$915f5687b3b07750$var$progressBarContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $cb0e8fe57b0fd046$var$$915f5687b3b07750$var$progressBarContentStyles = (0, $gyDKM.css)({
    height: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.success"),
    borderRadius: "100px"
});
var $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$exports, "ProgressStatus", ()=>$cb0e8fe57b0fd046$export$fad76899145ca0c7);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$exports, "defineProgressStatus", ()=>$cb0e8fe57b0fd046$export$aa03ab7e1a208875);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$exports, "LearningHeader", ()=>$cb0e8fe57b0fd046$export$86f07cccb119409d);
var $cb0e8fe57b0fd046$var$$2cfa64583f556289$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$2cfa64583f556289$exports, "PopupShare", ()=>$cb0e8fe57b0fd046$export$477c64ffaba52edf);
const $cb0e8fe57b0fd046$export$477c64ffaba52edf = ({ cardRef: cardRef, buttonText: buttonText, showCopyLink: showCopyLink = true, shareOnFb: shareOnFb = true, shareOnLinkedin: shareOnLinkedin = true, backgroundColor: backgroundColor = "#FFFFFF", urlToShare: urlToShare, alignToLeft: alignToLeft = false, alignToTop: alignToTop = false, fullWidth: fullWidth = false, color: color = "default", fullHeight: fullHeight = false })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = (0, $acw62.useCallback)(()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    }, [
        urlToShare
    ]);
    const shareOnLinkedIn = (0, $acw62.useCallback)(()=>{
        const shareText = "Check out this training from Atlassian!";
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(shareText)}`;
        handleShare(linkedinUrl);
    }, [
        urlToShare
    ]);
    const copyToClipboard = (0, $acw62.useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(shareOnLinkedIn);
    const onKeyDownFacebook = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(shareOnFacebook);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    const primaryColor = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand");
    const primaryColorStyles = color === "primary" ? (0, $gyDKM.css)({
        color: primaryColor,
        "& span": {
            color: primaryColor
        },
        "& svg": {
            fill: primaryColor
        }
    }) : undefined;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$shareButtonStyles,
            fullHeight && $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fullHeightStyles,
            $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fitContentButtonStyles
        ],
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                label: buttonText ?? "Share",
                appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                size: $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM,
                iconBefore: buttonText ? (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: [
                        $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$buttonWithTextStyles,
                        primaryColorStyles
                    ],
                    "data-testid": "button-with-text",
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$buttonTextStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                children: buttonText
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "share"
                        })
                    ]
                }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: primaryColorStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "share"
                    })
                }),
                iconType: "share"
            }),
            isOpen && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$popupShareDropdownStyles,
                    alignToLeft && (0, $gyDKM.css)({
                        width: "176px",
                        right: 0
                    }),
                    alignToTop && (0, $gyDKM.css)({
                        bottom: "50px"
                    })
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                        onClick: copyToClipboard,
                        css: [
                            $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$copyToClipboardOptionStyles,
                            fullWidth && $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        "aria-label": "copy to clipboard",
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                type: "link",
                                size: "small"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: (0, $gyDKM.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
                                }),
                                children: "Copy link"
                            }),
                            isCopied && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                            fullWidth && $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                                    id: "g5891",
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                                            id: "shapes",
                                            children: [
                                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: (0, $gyDKM.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on LinkedIn"
                            })
                        ]
                    }),
                    shareOnFb && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles,
                            fullWidth && $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("g", {
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: (0, $gyDKM.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$buttonWithTextStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$buttonTextStyles = (0, $gyDKM.css)({
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$shareButtonStyles = (0, $gyDKM.css)({
    width: "fit-content",
    position: "relative",
    "& span": {
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fitContentButtonStyles = (0, $gyDKM.css)({
    '& button[id*="icon-button"]': {
        width: "fit-content !important",
        height: "fit-content !important"
    }
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fullHeightStyles = (0, $gyDKM.css)({
    height: "100%",
    '& button[id*="icon-button"]': {
        height: "100% !important"
    }
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$popupShareDropdownStyles = (0, $gyDKM.css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$fullWidthOptionsStyles = (0, $gyDKM.css)({
    whiteSpace: "nowrap"
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$isCopiedStyles = (0, $gyDKM.css)({
    position: "absolute",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.pressed"),
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $cb0e8fe57b0fd046$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
let $cb0e8fe57b0fd046$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($cb0e8fe57b0fd046$export$fad76899145ca0c7 || ($cb0e8fe57b0fd046$export$fad76899145ca0c7 = {}));
const $cb0e8fe57b0fd046$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $cb0e8fe57b0fd046$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $cb0e8fe57b0fd046$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $cb0e8fe57b0fd046$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $cb0e8fe57b0fd046$export$86f07cccb119409d = ({ inspectMode: inspectMode, heading: heading, anonymousView: anonymousView = true, urlToShare: urlToShare, onSignIn: onSignIn, onStartCourse: onStartCourse, isLoading: isLoading, contentType: contentType, progressStatus: progressStatus, tagLine: tagLine, isSaved: isSaved, onSave: onSave, shouldShowFeedback: shouldShowFeedback, onStartFeedback: onStartFeedback, href: href })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = (event)=>{
        if (onStartCourse) {
            event?.preventDefault();
            onStartCourse();
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE ? "course" : "learning path";
    const status = $cb0e8fe57b0fd046$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    const renderActionButtons = ()=>{
        if (isLoading) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
            label: "",
            isLoading: isLoading
        });
        if (anonymousView) return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: (0, $gyDKM.css)({
                display: "flex"
            }),
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    label: "Sign in",
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleSignIn,
                    isLoading: isLoading
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: (0, $gyDKM.css)({
                        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        label: status,
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY,
                        onClick: handleStartCourse,
                        isLoading: isLoading,
                        href: href,
                        target: "_blank"
                    })
                })
            ]
        });
        return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: (0, $gyDKM.css)({
                display: "flex"
            }),
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    label: status,
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleStartCourse,
                    isLoading: isLoading,
                    href: href,
                    target: "_blank"
                }),
                shouldShowFeedback && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: (0, $gyDKM.css)({
                        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        label: "Take survey",
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY,
                        onClick: onStartFeedback,
                        isLoading: isLoading
                    })
                })
            ]
        });
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("section", {
        "data-testid": "learning-header",
        css: $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$export$f40d73b6f7f951e9
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                    label: contentTypeLabel
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: (0, $gyDKM.css)({
                    margin: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} 0`
                }),
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                    css: $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: (0, $gyDKM.css)({
                    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
                    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")
                }),
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb, {
                    color: (0, $5e26c99fa43b3c99$export$8754fc7e6d8b3000)
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: (0, $gyDKM.css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    renderActionButtons(),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: (0, $gyDKM.css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                tabIndex: 0,
                                css: $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                    type: "bookmark-filled"
                                }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                    type: "bookmark"
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    paddingTop: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.600")}`,
    paddingBottom: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")}`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.lg]: {
        paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.1000"),
        paddingBottom: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")}`
    }
});
const $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$var$tagLineStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $gyDKM.css)({
    height: "24px",
    border: "none",
    padding: 0,
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`,
        borderRadius: "2px"
    }
});
var $cb0e8fe57b0fd046$var$$d559b1cc82536c49$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$d559b1cc82536c49$exports, "Footer", ()=>$cb0e8fe57b0fd046$export$a06f1c675e846f6f);
const $cb0e8fe57b0fd046$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal })=>{
    const noOp = ()=>{};
    const onKeyDownReport = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(onOpenReportProblemModal || noOp);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("footer", {
        "data-testid": "footer",
        css: $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$footerContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$paddingRightStyles,
                    $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$logoLinkStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6141941182815d45$export$765cacec8b0843f3), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("ul", {
                    css: $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                            css: [
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemStyles,
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                role: "button",
                                tabIndex: 0,
                                css: [
                                    $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $gyDKM.css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                onKeyDown: onKeyDownReport,
                                children: "Report problem"
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                            css: [
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemStyles,
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                css: $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                            css: [
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemStyles,
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                css: $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                            css: [
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemStyles,
                                $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                css: $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("li", {
                            css: $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$footerContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        padding: "48px 60px"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listStyles = (0, $gyDKM.css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    }
});
const $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        paddingTop: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$paddingRightStyles = (0, $gyDKM.css)({
    paddingRight: "24px"
});
const $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$logoLinkStyles = (0, $gyDKM.css)({
    lineHeight: "24px"
});
const $cb0e8fe57b0fd046$var$$d559b1cc82536c49$var$listItemLinkStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
        textDecoration: "none"
    }
});
var $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fa53e9c0a1746730$exports, "LabelledGraphic", ()=>$cb0e8fe57b0fd046$export$12b5e3eab33f219b);
const $cb0e8fe57b0fd046$export$12b5e3eab33f219b = ({ image: image, markers: markers, onClickMarker: onClickMarker, onClickNext: onClickNext, onClickPrevious: onClickPrevious, onClickDismiss: onClickDismiss, pulseAnimationColor: pulseAnimationColor = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input") })=>{
    const [activeId, setActiveId] = (0, $acw62.useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $acw62.useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $acw62.useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $acw62.useState)([]);
    const containerDivRef = (0, $acw62.useRef)(null);
    const popupRef = (0, $acw62.useRef)(null);
    const imageContainerRef = (0, $acw62.useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const normalizedPulseColor = pulseAnimationColor.replace(/\s/g, "").toUpperCase();
    const isWhitePulseVariant = normalizedPulseColor === "#FFFFFF" || normalizedPulseColor === "#FFF" || normalizedPulseColor.includes("#FFFFFF") || normalizedPulseColor === "VAR(--DS-BORDER-INVERSE)";
    const markerStrokeColor = isWhitePulseVariant ? "#FFFFFF" : "#BF63F3";
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $acw62.useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, [
        onClickDismiss
    ]);
    const handleClickMarker = (0, $acw62.useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, [
        onClickMarker
    ]);
    (0, $acw62.useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $cb0e8fe57b0fd046$export$2d4c84fdfce6f2a9.BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && isWhitePulseVariant && (0, $gyDKM.css)({
                            animation: `${$cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 1200ms linear infinite`
                        }),
                        !clickedMarkers.includes(idx) && !isWhitePulseVariant && (0, $gyDKM.css)({
                            animation: `${$cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 1200ms linear infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleClickMarker(idx);
                            }
                        },
                        draggable: true,
                        css: [
                            $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $gyDKM.css)({
                                border: `2px solid ${markerStrokeColor}`
                            })
                        ],
                        children: /*#__PURE__*/ (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        activeId === idx && (0, $gyDKM.css)({
                                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $gyDKM.css)({
                                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
                                        })
                                    ],
                                    children: /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: (0, $gyDKM.css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.inverse") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$129a32eedafa97c5, {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`,
                    minHeight: "fit-content"
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                ref: imageContainerRef,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e431a229df88919, {
                    ...image,
                    css: [
                        $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$imageStyles,
                        (0, $gyDKM.css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $gyDKM.css)({
    position: "relative",
    cursor: "default"
});
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$createPulseAnimationStyles = (pulseColor)=>(0, $gyDKM.keyframes)({
        "0%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 2px ${pulseColor}`
        },
        "35%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 8px ${pulseColor}99`
        },
        "65%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 14px ${pulseColor}00`
        },
        "100%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 14px ${pulseColor}00`
        }
    });
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles = $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$createPulseAnimationStyles("#FFFFFF");
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles = $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$createPulseAnimationStyles("#BF63F3");
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$markerPulseStyles = (0, $gyDKM.css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $gyDKM.css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: "#FFBA00",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: "#FCA700"
        },
        "&:active": {
            backgroundColor: "#FDCC09"
        }
    }),
    selected: (0, $gyDKM.css)({
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        "&:hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
        }
    })
};
const $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$var$imageStyles = (0, $gyDKM.css)({
    height: "auto",
    width: "100%"
});
var $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9225344cd5d1f99b$exports, "LessonHeader", ()=>$cb0e8fe57b0fd046$export$7bee7638d150bc04);
const $cb0e8fe57b0fd046$export$7bee7638d150bc04 = ({ heading: heading, tags: tags, description: description, urlToShare: urlToShare, onListenClick: onListenClick, showListenButton: showListenButton = true })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$headingWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$metadataStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$tagStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                    ...tag
                                })
                            }, index))
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            showListenButton && (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                                css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$lineWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb, {
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$metadataStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$flexContainerStyles = (0, $gyDKM.css)({
    display: "flex"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$listenButtonStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $gyDKM.css)({
    marginLeft: "0.25rem",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$tagStyles = (0, $gyDKM.css)({
    marginRight: "0.5rem"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$lineWrapperStyles = (0, $gyDKM.css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$headingWrapperStyles = (0, $gyDKM.css)({
    padding: "5rem 0 1.5rem 0"
});
const $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$var$descriptionStyles = (0, $gyDKM.css)({
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});
var $cb0e8fe57b0fd046$var$$3b9afd8fe4435353$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3b9afd8fe4435353$exports, "LessonList", ()=>$cb0e8fe57b0fd046$export$962a95c44e73eb25);
const $cb0e8fe57b0fd046$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted, size: size })=>isCompleted ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
        type: "check-circle-filled",
        size: size,
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.success")
    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
        type: "check-circle-outline",
        size: size,
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtler.pressed")
    });
const $cb0e8fe57b0fd046$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle, slug: slug, lessonSlug: lessonSlug, isCompleted: isCompleted, onNavigation: onNavigation })=>{
    const handleKeyDown = (0, $acw62.useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, []);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                isCompleted: isCompleted,
                size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.SMALL
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$7e5a668c3a5a9ea8$var$sectionStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $cb0e8fe57b0fd046$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $gyDKM.css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle, slug: slug, duration: duration, isCompleted: isCompleted, isCurrentLesson: isCurrentLesson, hasDivider: hasDivider, sections: sections, onNavigation: onNavigation })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $acw62.useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, []);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("section", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Section needs tabIndex for keyboard navigation
        tabIndex: 0,
        "aria-label": `Lesson overview for ${lessonTitle}`,
        css: [
            $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $gyDKM.css)({
                marginBottom: "16px"
            })
        ],
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        expandByCard(e);
                    }
                },
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $gyDKM.css)({
                                borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "chevron-down",
                            size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.selected") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.subtle")
                        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.selected") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.subtle")
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $gyDKM.css)({
                                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: (0, $gyDKM.css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                                            isCompleted: isCompleted,
                                            size: $cb0e8fe57b0fd046$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: (0, $gyDKM.css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>(0, $acw62.createElement)($cb0e8fe57b0fd046$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a, {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: (0, $gyDKM.css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb, {
                    height: 2,
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")
                })
            })
        ]
    }, slug);
};
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $gyDKM.css)({
    maxWidth: "25.25rem",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonCardStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$currentLessonStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected"),
    borderLeft: `4px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")}`
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$hoverLessonStyles = (0, $gyDKM.css)({
    ":hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
    }
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$expandButtonStyles = (0, $gyDKM.css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$durationStyles = (0, $gyDKM.css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonContainer = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$var$lessonTitleStyles = (0, $gyDKM.css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $cb0e8fe57b0fd046$export$962a95c44e73eb25 = ({ lessons: lessons })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>(0, $acw62.createElement)($cb0e8fe57b0fd046$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2, {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};
var $cb0e8fe57b0fd046$var$$050a30fc95775cfd$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$050a30fc95775cfd$exports, "LessonsList", ()=>$cb0e8fe57b0fd046$export$c3b0ae23c563b692);
const $cb0e8fe57b0fd046$export$c3b0ae23c563b692 = ({ lessons: lessons, onLessonClick: onLessonClick, isStandalone: isStandalone = false, isTablet: isTablet = false })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lessonsListStyles,
            isStandalone && $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles,
            isTablet && !isStandalone && (0, $gyDKM.css)({
                borderRadius: "0"
            })
        ],
        children: lessons?.map(({ slug: slug, isCompleted: isCompleted, title: title, duration: duration }, index)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                role: "button",
                "data-testid": `lesson-list-item-${index}`,
                tabIndex: 0,
                css: [
                    $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lessonItemStyles,
                    !isStandalone && !isTablet && index === lessons.length - 1 && $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lastLessonItemStyles,
                    isTablet && !isStandalone && index === 0 && $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles,
                    isTablet && !isStandalone && index === lessons.length - 1 && $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles
                ],
                onClick: ()=>onLessonClick(slug),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onLessonClick(slug);
                },
                children: [
                    /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$circleContainerStyles,
                        children: isCompleted ? /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            size: "small",
                            type: "check-circle",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success")
                        }) : /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$emptyCircleStyles
                        })
                    }),
                    /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        css: [
                            $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$textStyles,
                            isCompleted && {
                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.success")
                            }
                        ],
                        children: title
                    }),
                    /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$durationBadgeStyles,
                        children: duration
                    }),
                    isStandalone && /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$chevronContainerStyles,
                        children: /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            size: "medium",
                            type: "chevron-right",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
                        })
                    })
                ]
            }, slug))
    });
};
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lessonsListStyles = (0, $gyDKM.css)({
    backgroundColor: "#FFFFFF",
    maxWidth: "100%",
    borderRadius: "0 0 8px 8px",
    overflow: "hidden"
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles = (0, $gyDKM.css)({
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px"
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lessonItemStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:active": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    },
    ":first-of-type": {
        borderTop: "none"
    }
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$circleContainerStyles = (0, $gyDKM.css)({
    marginTop: "3px"
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$emptyCircleStyles = (0, $gyDKM.css)({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    border: `1.4px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075"),
    margin: "1px",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$textStyles = (0, $gyDKM.css)({
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    fontFamily: "Inter",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$durationBadgeStyles = (0, $gyDKM.css)({
    marginTop: "1px",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    marginLeft: "auto",
    whiteSpace: "nowrap",
    height: "fit-content"
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lastLessonItemStyles = (0, $gyDKM.css)({
    borderRadius: "0 0 8px 8px"
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles = (0, $gyDKM.css)({
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")} !important`
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles = (0, $gyDKM.css)({
    borderRadius: "0 !important"
});
const $cb0e8fe57b0fd046$var$$050a30fc95775cfd$var$chevronContainerStyles = (0, $gyDKM.css)({
    display: "none",
    "@media (max-width: 965px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
        marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.negative.100")
    }
});
var $cb0e8fe57b0fd046$var$$65703ff0bcd12648$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$65703ff0bcd12648$exports, "LessonSidebar", ()=>$cb0e8fe57b0fd046$export$c2bf8d11366d1eb0);
const $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress, pathColor: pathColor, trailColor: trailColor = (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"), image: image, title: title, onCourseNavigation: onCourseNavigation })=>{
    const handleClick = (0, $acw62.useCallback)(()=>{
        onCourseNavigation && onCourseNavigation();
    }, [
        onCourseNavigation
    ]);
    const handleKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleClick);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: (0, $gyDKM.css)({
                    maxWidth: "64px",
                    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $59f888d7dcabf163$export$5ab97151efedb8c6), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $59f888d7dcabf163$export$5115a192ad9bf57f)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                            css: $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: [
                                (0, $gyDKM.css)({
                                    backgroundColor: trailColor
                                }),
                                $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$imageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $gyDKM.css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$var$titleStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $cb0e8fe57b0fd046$export$c2bf8d11366d1eb0 = ({ lessons: lessons, progress: progress, pathColor: pathColor, title: title, image: image, isVisible: isVisible, onChangeMenuVisibility: onChangeMenuVisibility, onCourseNavigation: onCourseNavigation })=>(0, $115bf1020744eac3$export$25062201e9e25d76)($cb0e8fe57b0fd046$export$1ba59dacbcbf90fe, {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: (0, $gyDKM.css)({
                    marginLeft: "16px"
                }),
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: (0, $gyDKM.css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: [
                                $cb0e8fe57b0fd046$var$$65703ff0bcd12648$var$subheadingStyles,
                                (0, $gyDKM.css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75, {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: (0, $gyDKM.css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$962a95c44e73eb25, {
                lessons: lessons
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$65703ff0bcd12648$var$subheadingStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
var $cb0e8fe57b0fd046$var$$8340d81aba797956$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$8340d81aba797956$exports, "LearningOverviewCard", ()=>$cb0e8fe57b0fd046$export$60e8035fadc9b8fc);
var $cb0e8fe57b0fd046$var$$8f97e278a4a2a6b3$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $cb0e8fe57b0fd046$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground = `<svg width="1003" height="48" viewBox="0 0 1003 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3622_1083)">
      <g clip-path="url(#clip1_3622_1083)">
        <path
          d="M929.87 -106.601C934.923 -113.047 932.654 -115.022 927.128 -108.989C923.208 -104.711 919.232 -100.29 914.973 -95.4457C910.706 -90.547 906.173 -84.8713 902.441 -77.642C901.929 -76.6053 901.438 -75.6223 900.973 -74.6736C900.581 -73.6929 900.196 -72.7546 899.839 -71.8631C899.493 -70.958 899.113 -70.1306 898.849 -69.2729C898.586 -68.4274 898.343 -67.6109 898.101 -66.8314C897.872 -66.0506 897.619 -65.3092 897.435 -64.5795C897.275 -63.835 897.116 -63.1274 896.97 -62.4309C896.673 -61.0446 896.374 -59.7637 896.241 -58.4844C896.079 -57.2144 895.893 -55.9961 895.769 -54.7717C895.695 -53.5422 895.62 -52.3126 895.538 -51.053C895.481 -50.4216 895.48 -49.7785 895.49 -49.1218C895.494 -48.4596 895.492 -47.7918 895.495 -47.0926C895.45 -45.6992 895.57 -44.2212 895.672 -42.6212C895.734 -40.8087 896.046 -38.9029 896.305 -36.9035C896.407 -35.8974 896.663 -34.8941 896.85 -33.8669C897.074 -32.836 897.222 -31.7755 897.514 -30.7316C897.793 -29.6765 898.071 -28.6091 898.36 -27.5159C898.619 -26.4196 899.039 -25.3563 899.372 -24.2525C899.729 -23.1586 900.067 -22.0357 900.524 -20.944C901.095 -19.4758 901.672 -18.0008 902.248 -16.5135C903.686 -16.151 905.125 -15.7886 906.563 -15.4261L908.148 -15.024L909.749 -14.7069C910.816 -14.4996 911.884 -14.2923 912.945 -14.0795C914.015 -13.9338 915.072 -13.7893 916.13 -13.6449C916.659 -13.5788 917.181 -13.4949 917.698 -13.4424C918.222 -13.4077 918.74 -13.3676 919.258 -13.3274C920.294 -13.2594 921.317 -13.1803 922.328 -13.1147C923.342 -13.1108 924.331 -13.1094 925.302 -13.1037C925.79 -13.0974 926.272 -13.098 926.748 -13.093C927.225 -13.1003 927.69 -13.1458 928.161 -13.1722C930.021 -13.305 931.798 -13.3659 933.424 -13.6525C935.06 -13.8885 936.594 -14.073 937.944 -14.4185C939.298 -14.7325 940.538 -14.9593 941.583 -15.2676C942.622 -15.5827 943.499 -15.8526 944.2 -16.0659C944.814 -16.2634 945.445 -16.4282 946.042 -16.6706L947.817 -17.4307C948.868 -17.8993 950.401 -18.4983 952.174 -19.5183C953.072 -20.0086 954.081 -20.5123 955.126 -21.1299C956.149 -21.7869 957.247 -22.4858 958.427 -23.2319C963.03 -26.3399 968.353 -30.7603 973.46 -36.3963C976.055 -39.2319 978.501 -42.2247 981.093 -45.2956C983.684 -48.3664 986.348 -51.5351 989.05 -54.737C994.763 -61.4435 1000.62 -68.3333 1006.26 -74.9487L1008.09 -77.1133L970.879 -109.453C966.364 -113.375 962.194 -116.953 958.273 -120.283C953.7 -124.143 949.449 -127.723 945.42 -131.125C944.678 -130.223 943.943 -129.327 943.214 -128.436C942.856 -127.996 942.499 -127.568 942.141 -127.128C941.939 -126.87 941.731 -126.619 941.535 -126.367C940.74 -125.372 939.959 -124.387 939.189 -123.414C937.664 -121.465 936.17 -119.557 934.69 -117.66C932.576 -114.943 931.934 -113.128 932.4 -112.592L932.334 -112.332C932.406 -112.276 932.468 -112.282 932.515 -112.357L932.544 -112.466C933.134 -112.084 934.804 -113.003 937.144 -115.524C938.768 -117.296 940.405 -119.078 942.08 -120.893C942.908 -121.811 943.75 -122.74 944.611 -123.686C944.824 -123.918 945.032 -124.157 945.245 -124.389L945.523 -124.676C945.697 -124.85 945.871 -125.036 946.051 -125.216C946.212 -125.057 946.378 -124.892 946.551 -124.732L946.789 -124.498C946.872 -124.415 946.884 -124.389 947.164 -124.144C948.023 -123.364 948.906 -122.57 949.794 -121.768C951.584 -120.164 953.428 -118.511 955.343 -116.801C959.18 -113.387 963.311 -109.751 967.813 -105.818C970.585 -103.409 974.75 -99.5537 980.247 -94.53C983.002 -92.0237 986.097 -89.2169 989.489 -86.1324C991.196 -84.5985 992.985 -82.9942 994.853 -81.3264C996.512 -79.8591 998.231 -78.3239 1000.02 -76.7443C1000.02 -76.7443 1000.02 -76.7443 1000.03 -76.7375C1000.03 -76.7375 1000.03 -76.7375 1000.03 -76.7307L999.428 -75.9942C998.608 -74.9765 997.794 -73.9643 996.986 -72.9576C992.58 -67.3803 987.764 -61.4487 983.029 -55.6945C980.656 -52.8241 978.303 -49.9826 976.04 -47.2557C974.903 -45.8928 973.785 -44.5589 972.7 -43.2526C971.603 -41.9845 970.523 -40.8015 969.48 -39.627C968.467 -38.4309 967.35 -37.4185 966.338 -36.4017C965.308 -35.3929 964.34 -34.4148 963.33 -33.6019C962.344 -32.7618 961.416 -31.9716 960.551 -31.2367C959.658 -30.548 958.798 -29.9486 958.034 -29.383C957.263 -28.8364 956.598 -28.2977 955.964 -27.9044C955.336 -27.5166 954.797 -27.1817 954.347 -26.9119C953.472 -26.3698 952.996 -26.0778 952.996 -26.0778C952.138 -25.5031 951.199 -25.0603 950.283 -24.5781C949.361 -24.1149 948.469 -23.5932 947.518 -23.1762C945.607 -22.393 943.74 -21.4938 941.744 -20.9109C937.842 -19.5255 933.722 -18.7251 929.573 -18.2555L926.433 -17.9804L923.272 -17.9363C922.219 -17.8947 921.159 -17.9652 920.098 -18.0234C919.038 -18.1063 917.98 -18.0961 916.922 -18.2406L913.741 -18.6191C912.682 -18.7389 911.629 -18.9819 910.566 -19.1578C909.51 -19.3392 908.455 -19.5329 907.408 -19.8061L905.406 -20.2877L904.553 -22.4154C904.095 -23.4824 903.763 -24.5862 903.387 -25.6759C902.591 -27.8535 902.063 -30.0843 901.455 -32.3048C900.43 -36.7694 899.847 -41.2944 899.708 -45.799C899.617 -54.5172 901.176 -60.7732 902.66 -65.3605C902.844 -65.9356 903.027 -66.4861 903.204 -67.0187C903.288 -67.2822 903.373 -67.5458 903.458 -67.797C903.56 -68.0402 903.663 -68.2833 903.759 -68.521C904.156 -69.4703 904.519 -70.3427 904.855 -71.156C905.02 -71.5599 905.184 -71.9515 905.335 -72.3196C905.517 -72.6785 905.692 -73.0195 905.86 -73.355C906.196 -74.0137 906.505 -74.6256 906.787 -75.1907C907.6 -76.9267 908.616 -78.4937 909.532 -80.0583C910.413 -81.6513 911.478 -83.0586 912.439 -84.4951C912.938 -85.1991 913.381 -85.9272 913.903 -86.5918C914.425 -87.2563 914.927 -87.9166 915.436 -88.5701C916.442 -89.8783 917.421 -91.1521 918.467 -92.4005C922.553 -97.4041 926.266 -102.05 929.852 -106.622L929.87 -106.601Z"
          fill="#ffffff7d"
        />
        <path
          d="M485.107 17.5435C485.157 17.2393 485.206 16.9473 485.261 16.6622C485.278 16.3733 485.284 16.0955 485.3 15.8312C485.322 15.2892 485.33 14.7951 485.324 14.3368C485.343 13.4171 485.158 12.6498 485.022 12.0299C484.719 10.8054 484.323 10.2085 483.928 10.1932C483.526 10.1834 483.114 10.7415 482.773 11.8449C482.59 12.3954 482.499 13.0914 482.264 13.8777C482.161 14.2755 482.069 14.7115 481.982 15.179C481.941 15.4161 481.901 15.6532 481.853 15.9082C481.782 16.1483 481.716 16.3953 481.65 16.6545C480.974 19.6043 479.725 22.3352 477.739 24.515C475.77 26.7027 473.101 28.343 469.989 29.4622C466.875 30.606 463.32 31.2162 459.494 31.4897C458.544 31.5974 457.566 31.6219 456.576 31.6451C455.585 31.6806 454.581 31.7272 453.55 31.6906C452.518 31.6786 451.48 31.6599 450.417 31.6509C449.33 31.6149 448.225 31.5831 447.114 31.5445C442.635 31.4549 438.7 31.3709 437.402 31.3506C437.461 33.0947 437.517 34.758 437.575 36.3721C437.617 37.335 437.653 38.2665 437.691 39.1611C437.768 40.7708 437.837 42.2685 437.903 43.6732C438.049 46.4837 438.178 48.94 438.299 51.2842C438.542 55.9725 438.747 60.2179 438.871 65.9952C438.989 71.3019 439.109 77.3447 439.271 84.7774C442.605 84.9054 446.043 85.0502 449.524 85.1809C452.302 85.302 455.11 85.42 457.906 85.5368C463.561 85.752 469.165 85.7145 474.329 85.3789C479.492 85.0555 484.21 84.4395 488.08 83.7004C491.949 82.9612 494.97 82.1111 496.811 81.5433C498.187 81.1511 499.514 80.6115 500.851 80.0978C502.029 79.5802 503.702 78.8717 505.73 77.7972C506.747 77.2757 507.825 76.6181 509.009 75.928C510.159 75.1726 511.403 74.3834 512.642 73.4081C515.149 71.5039 517.788 69.0935 520.199 66.06C522.609 63.0388 524.767 59.3919 526.368 55.2742C528 51.1658 529.033 46.5883 529.51 41.8369C530 37.0745 529.928 32.156 529.432 27.1513C528.49 17.1591 524.835 6.82357 518.805 -1.52006C514.549 -7.40132 509.649 -11.8944 504.902 -15.2832C503.698 -16.0981 502.525 -16.8914 501.381 -17.6631C500.204 -18.3579 499.057 -19.0433 497.946 -19.7004C496.828 -20.3396 495.706 -20.8803 494.635 -21.4406C494.295 -21.6111 493.962 -21.7871 493.629 -21.9632C493.405 -22.0664 493.158 -22.2337 492.914 -22.3079L492.13 -22.3319C491.5 -22.3463 490.882 -22.3719 490.271 -22.3906C481.737 -22.6506 475.456 -22.8365 471.146 -22.9647C466.13 -23.0903 461.424 -23.2092 457.699 -23.3088L457.377 -18.1211C464.071 -16.6871 469.734 -13.9351 473.851 -9.95455C477.937 -5.97092 480.524 -1.00134 481.726 4.27301C482.155 6.19688 482.534 7.6642 482.859 8.65586C483.208 9.65003 483.595 10.1718 483.947 10.1889C484.305 10.2005 484.622 9.70074 484.85 8.64766C485.091 7.59583 485.137 5.9862 484.816 3.85057C483.934 -1.98513 481.344 -7.93852 476.726 -12.8297C472.089 -17.7166 465.53 -21.0977 458.111 -22.7969L457.845 -18.5252C461.574 -18.3941 466.279 -18.2259 471.299 -18.0566C475.257 -17.9332 481.351 -17.5745 489.372 -17.144C489.878 -17.1174 490.384 -17.0907 490.902 -17.0629L491.679 -17.0211C491.864 -17.0147 491.79 -17.0099 491.827 -17.0061L491.876 -17.0011C491.876 -17.0011 491.906 -16.9672 492.051 -16.8906C492.287 -16.7615 492.523 -16.6324 492.759 -16.5033C493.23 -16.2451 493.715 -15.9857 494.198 -15.7139C495.186 -15.2117 496.131 -14.5776 497.12 -13.97C497.614 -13.6601 498.115 -13.3556 498.622 -13.0444C499.109 -12.7043 499.602 -12.3574 500.095 -12.0104C504.076 -9.24363 508.128 -5.80154 511.761 -1.4742C512.991 -0.0999016 514.024 1.40902 515.133 2.87617L516.629 5.17427C517.149 5.92597 517.586 6.72498 518.024 7.52399C519.044 9.21093 519.835 11.0478 520.681 12.8965C521.038 13.8482 521.389 14.8054 521.745 15.7694C521.936 16.2465 522.095 16.7389 522.224 17.2344L522.652 18.7191C523.758 22.6971 524.486 26.8472 524.689 30.9872C525.268 39.2601 524.188 47.3027 521.595 53.596C520.323 56.7513 518.723 59.4651 517.055 61.7143C515.399 63.977 513.604 65.6937 512.1 67.0998C511.301 67.7547 510.62 68.3784 509.964 68.8499C509.314 69.3283 508.747 69.7347 508.295 70.066C507.343 70.6745 506.828 71.012 506.828 71.012C504.563 72.4459 502.168 73.7183 499.652 74.7619C498.417 75.3293 497.12 75.7605 495.839 76.249C494.529 76.6666 493.237 77.1292 491.9 77.476C486.584 78.9529 481.067 79.9146 475.469 80.435C469.87 80.9678 464.194 81.1277 458.498 81.0197C455.668 80.9799 452.748 80.8629 449.876 80.7879L443.466 80.595L443.003 62.5921L442.312 36.3457L447.253 36.4884C448.371 36.5214 449.476 36.5532 450.557 36.5825C451.664 36.5896 452.764 36.6023 453.845 36.607C454.926 36.6362 455.999 36.5657 457.058 36.5186C458.117 36.4714 459.157 36.4409 460.183 36.3038C464.297 35.9358 468.223 35.1838 471.806 33.7413C475.381 32.329 478.615 30.1893 480.927 27.3127C483.263 24.4509 484.572 20.9901 485.113 17.5626L485.107 17.5435Z"
          fill="#ffffff7d"
        />
        <path
          d="M628.636 -23.6993C627.184 -18.8428 627.285 -16.1605 628.042 -15.9228C628.842 -15.6623 630.281 -17.7738 631.962 -22.3165C632.638 -23.887 633.321 -25.4753 634.004 -27.076C634.766 -28.6378 635.601 -30.1674 636.401 -31.7501C636.774 -32.5596 637.297 -33.2735 637.749 -34.0441C638.219 -34.8067 638.689 -35.5693 639.159 -36.3442C640.136 -37.8656 641.277 -39.3024 642.347 -40.8329C646.985 -46.6464 652.943 -52.2209 660.978 -56.2732C662.164 -56.858 663.294 -57.4299 664.388 -57.8632C664.934 -58.086 665.445 -58.3372 665.959 -58.5077C666.505 -58.7059 667.026 -58.8943 667.522 -59.0729C671.346 -60.2248 674.355 -60.9339 676.118 -61.4106C673.934 -63.5064 671.794 -65.474 669.883 -67.2824C669.186 -67.9284 668.512 -68.5472 667.857 -69.158C667.344 -69.6307 666.85 -70.0829 666.361 -70.5284C664.423 -72.3023 662.67 -73.9028 660.971 -75.4546C657.579 -78.5637 654.391 -81.516 650.316 -85.4491C645.637 -89.9197 640.194 -95.1915 634.538 -100.708C631.719 -103.468 628.828 -106.285 625.968 -109.08C625.255 -109.784 624.535 -110.481 623.827 -111.178L622.162 -112.794L621.685 -113.251L621.448 -113.485L621.329 -113.596C621.329 -113.596 621.229 -113.582 621.179 -113.574L619.975 -113.307L618.771 -113.039L618.209 -112.911L617.847 -112.812L616.408 -112.413C615.469 -112.125 614.541 -111.799 613.625 -111.483C609.996 -110.12 606.696 -108.327 603.832 -106.317C603.47 -106.075 603.114 -105.827 602.751 -105.585C602.413 -105.316 602.075 -105.06 601.742 -104.797C601.078 -104.271 600.433 -103.761 599.794 -103.257C598.6 -102.165 597.433 -101.133 596.389 -100.089C592.2 -95.9121 589.715 -91.9583 588.256 -89.8302C587.419 -88.5482 586.726 -87.1773 585.979 -85.8305C585.374 -84.7971 584.726 -83.2857 583.896 -81.44C583.006 -79.6129 582.202 -77.3255 581.25 -74.7439C580.735 -73.4664 580.356 -72.0451 579.906 -70.5753C579.47 -69.1166 579.012 -67.5796 578.533 -65.9768C578.075 -64.4398 577.589 -62.8438 577.095 -61.1806C576.51 -59.5576 575.868 -57.8971 575.223 -56.175C572.497 -49.3508 568.288 -42.2319 562.402 -35.9698C559.408 -32.8965 555.985 -30.0708 552.167 -27.712C550.27 -26.5128 548.238 -25.4944 546.165 -24.5358L544.574 -23.8869L543.682 -23.5322L542.028 -22.9949C539.834 -22.265 537.606 -21.6005 535.378 -20.9482C537.479 -18.9228 542.769 -13.8396 547.946 -8.84843C558.695 1.42159 567.391 9.73274 574.278 16.3139C577.724 19.6017 580.706 22.4589 583.266 24.8959C584.545 26.1206 585.724 27.2423 586.789 28.2596C587.504 28.9383 588.182 29.5886 588.831 30.2049C589.29 30.6411 589.73 31.0693 590.165 31.4784C590.225 31.5092 590.263 31.6306 590.333 31.5821L590.528 31.5214L590.916 31.4C591.173 31.3209 591.423 31.2473 591.68 31.1682C592.268 30.9929 592.863 30.812 593.445 30.6299C593.795 30.5294 593.902 30.4845 594.078 30.4158L594.574 30.2373C595.233 29.9887 595.903 29.7784 596.534 29.4836C597.169 29.2079 597.793 28.931 598.422 28.6609C599.028 28.3513 599.628 28.0472 600.221 27.7487C600.826 27.4637 601.379 27.1053 601.948 26.7797C602.506 26.4404 603.075 26.1271 603.615 25.7675C604.143 25.4066 604.671 25.0458 605.193 24.6782C605.714 24.3228 606.23 23.9608 606.71 23.558C610.661 20.5014 613.893 17.0563 616.604 13.478C621.912 6.22945 625.281 -1.35211 627.641 -9.08543C629.982 -17.7176 627.486 -18.3668 624.653 -10.2731C621.847 -2.97477 618.23 4.03719 613.054 10.6126C610.418 13.8522 607.349 16.9427 603.702 19.6652C603.261 20.0225 602.791 20.3458 602.302 20.6612C601.825 20.9777 601.342 21.2998 600.853 21.6275C600.364 21.9428 599.84 22.2174 599.332 22.5247C598.814 22.8184 598.312 23.1325 597.77 23.3867C597.228 23.6533 596.691 23.9266 596.149 24.1932C595.582 24.4326 595.022 24.6789 594.456 24.9183C593.895 25.1768 593.294 25.3632 592.71 25.5823L591.926 25.8676L591.619 25.9541C591.538 25.9767 591.456 26.0117 591.375 26.0221C591.322 25.961 591.262 25.9055 591.197 25.8431C591.138 25.7753 591.072 25.713 591.001 25.6439C590.763 25.4095 590.525 25.175 590.269 24.9326C589.277 23.9473 588.177 22.8646 586.976 21.6788C584.593 19.3031 581.8 16.5207 578.639 13.367C572.304 7.05828 564.428 -0.749007 555.093 -9.75596C553.569 -11.2219 552.04 -12.6822 550.497 -14.1192C549.722 -14.8411 548.954 -15.5562 548.185 -16.2713L547.023 -17.3356L546.438 -17.865L546.152 -18.1291L546.093 -18.1969L546.08 -18.1858C545.995 -18.2192 545.856 -18.289 545.699 -18.4038C545.738 -18.4371 545.802 -18.4924 545.891 -18.5453L545.967 -18.587L545.999 -18.6147C546.055 -18.6276 545.923 -18.5853 546.124 -18.6638L547.66 -19.3245C549.706 -20.224 551.69 -21.272 553.622 -22.4058C557.474 -24.6993 561.024 -27.4687 564.189 -30.5123C570.569 -36.582 575.119 -43.8643 578.252 -50.5296C578.645 -51.368 579.024 -52.1831 579.397 -52.9927C579.782 -53.7886 580.044 -54.6218 580.367 -55.4117C580.671 -56.2096 580.968 -56.9774 581.259 -57.7396C581.549 -58.4895 581.839 -59.2271 582.048 -59.9666C582.944 -62.857 583.728 -65.4 584.382 -67.5108C584.702 -68.5361 584.98 -69.4542 585.229 -70.2516C585.472 -71.0558 585.691 -71.7325 585.911 -72.2669C586.326 -73.3505 586.553 -73.9274 586.553 -73.9274C586.553 -73.9274 586.913 -74.8805 587.564 -76.5958C587.883 -77.4541 588.4 -78.447 588.93 -79.6302C589.472 -80.7999 590.059 -82.1629 590.87 -83.5528C591.663 -84.9629 592.457 -86.5524 593.54 -88.094C594.06 -88.8762 594.582 -89.7077 595.141 -90.5355C595.755 -91.3268 596.369 -92.1428 597.015 -92.9741C599.646 -96.2451 602.871 -99.5547 606.768 -102.326C607.258 -102.666 607.748 -103.018 608.238 -103.358C608.746 -103.69 609.277 -103.983 609.791 -104.296C610.813 -104.953 611.929 -105.476 613.021 -106.04C613.565 -106.331 614.148 -106.538 614.715 -106.789C615.281 -107.041 615.854 -107.274 616.443 -107.474C617.032 -107.674 617.605 -107.919 618.211 -108.074L619.106 -108.335L619.556 -108.463L619.693 -108.499L619.768 -108.516L620.049 -108.58C620.049 -108.58 620.15 -108.619 620.186 -108.591L620.287 -108.5L621.186 -107.636C622.186 -106.681 623.185 -105.726 624.185 -104.771C626.179 -102.867 628.149 -100.979 630.09 -99.1241C637.845 -91.7125 645.023 -84.8481 650.362 -79.7354L660.058 -70.4692L664.909 -65.8388L666.201 -64.6006L666.528 -64.289L666.688 -64.1304L666.765 -64.0422C666.765 -64.0422 666.868 -63.9885 666.806 -63.9824C666.538 -63.9169 666.275 -63.8569 666.012 -63.7723C665.881 -63.73 665.75 -63.7 665.624 -63.6509L664.364 -63.2159C662.387 -62.495 660.461 -61.6636 658.599 -60.7207C649.837 -56.2783 643.471 -50.1019 638.705 -43.7384C637.605 -42.0749 636.447 -40.4915 635.471 -38.8401C634.998 -38.0036 634.537 -37.1659 634.071 -36.3472C633.629 -35.5137 633.115 -34.7247 632.758 -33.8579C631.991 -32.1606 631.199 -30.4904 630.488 -28.8183C629.869 -27.1061 629.256 -25.4116 628.649 -23.7227L628.636 -23.6993Z"
          fill="#ffffff7d"
        />
        <path
          d="M802.514 -15.3488C802.255 -15.1958 802.007 -15.0415 801.766 -14.8928C801.549 -14.7169 801.338 -14.5466 801.127 -14.3886C800.718 -14.059 800.353 -13.7435 800.025 -13.4366C799.347 -12.8622 798.925 -12.2246 798.577 -11.7341C797.906 -10.726 797.767 -10.0473 798.052 -9.74631C798.336 -9.44528 799.049 -9.50277 800.095 -9.96575C801.122 -10.4491 802.552 -11.2442 804.398 -12.2444C807.021 -13.6544 809.918 -14.5046 812.946 -14.4571C815.968 -14.4287 819.104 -13.5352 822.187 -11.9667C825.284 -10.4215 828.323 -8.208 831.307 -5.57939C832.074 -4.95732 832.799 -4.24042 833.549 -3.53337C834.3 -2.82631 835.056 -2.12481 835.791 -1.34509C836.533 -0.583212 837.281 0.197792 838.04 0.980018C838.811 1.80046 839.581 2.63321 840.369 3.474C843.542 6.79592 846.33 9.71378 847.249 10.6669C848.471 9.50436 849.642 8.37379 850.774 7.30107C851.45 6.64598 852.094 6.01856 852.712 5.41328C853.832 4.31467 854.857 3.29906 855.829 2.34008C857.762 0.420855 859.456 -1.25662 861.061 -2.85659C864.282 -6.05529 867.225 -8.94207 871.324 -12.7568C875.09 -16.259 879.375 -20.2465 884.651 -25.148C882.323 -27.679 879.919 -30.2858 877.485 -32.9266C875.549 -35.0343 873.595 -37.1748 871.641 -39.3029C867.678 -43.5833 863.565 -47.6625 859.562 -51.2419C855.558 -54.8213 851.676 -57.875 848.315 -60.2386C844.955 -62.6023 842.135 -64.2555 840.376 -65.2443C839.082 -65.9817 837.73 -66.6323 836.371 -67.2651C833.928 -68.3171 829.349 -70.353 822.893 -71.5648C819.678 -72.1633 815.995 -72.5248 812.042 -72.3075C808.089 -72.1025 803.883 -71.3108 799.735 -69.8205C795.57 -68.3505 791.529 -66.1318 787.746 -63.4108C783.945 -60.6977 780.444 -57.4717 777.195 -53.88C770.655 -46.7565 765.856 -37.4398 764.192 -27.6812C763.028 -20.7913 763.322 -14.3287 764.311 -8.68015C764.594 -7.27211 764.866 -5.90225 765.14 -4.56938C765.488 -3.25365 765.832 -1.98167 766.159 -0.742359C766.511 0.487134 766.934 1.65575 767.302 2.80025C767.423 3.15895 767.539 3.51087 767.654 3.87511C767.737 4.10009 767.806 4.38541 767.92 4.61967L768.477 5.20816C768.928 5.68685 769.367 6.15197 769.793 6.61584C775.826 13.0424 780.259 17.7725 783.306 21.0136C786.845 24.7562 790.171 28.2668 792.804 31.0452L796.812 27.9635C792.968 22.1179 790.866 16.1831 790.764 10.6122C790.693 5.05057 792.433 -0.0427144 795.383 -4.31432C796.459 -5.86269 797.251 -7.08128 797.725 -7.95475C798.188 -8.84177 798.288 -9.47491 798.039 -9.73523C797.797 -10.0134 797.199 -9.92557 796.276 -9.41314C795.334 -8.90874 794.131 -7.90512 792.817 -6.30657C789.226 -1.90838 786.78 3.80608 786.583 10.3363C786.404 16.8746 788.698 23.8804 792.878 30.4219L796.178 27.8806C793.571 25.0801 790.284 21.5362 786.776 17.7659C783.985 14.792 779.805 10.0814 774.28 3.91675C773.937 3.52322 773.582 3.14077 773.227 2.74599C773.05 2.54245 772.878 2.34568 772.695 2.14767L772.63 2.07304L772.618 2.05946L772.6 2.03911L772.571 1.99286C772.56 1.95465 772.567 1.94911 772.518 1.78949C772.441 1.53434 772.365 1.2792 772.289 1.02406C772.137 0.513761 771.972 -0.0101045 771.808 -0.533968C771.455 -1.5842 771.234 -2.67674 770.945 -3.79464C770.807 -4.35297 770.663 -4.91808 770.525 -5.48873C770.419 -6.06241 770.313 -6.64842 770.207 -7.23442C769.321 -11.9262 768.883 -17.1107 769.375 -22.5409C769.472 -24.3248 769.82 -26.0523 770.071 -27.802C770.242 -28.663 770.468 -29.5122 770.651 -30.3719C770.755 -30.7943 770.822 -31.2329 770.95 -31.6528L771.335 -32.9003C771.471 -33.3504 771.606 -33.8006 771.749 -34.2562L771.962 -34.9397L772.224 -35.6059C772.582 -36.4974 772.933 -37.3957 773.292 -38.2995C774.16 -40.036 774.986 -41.8201 776.062 -43.4861C778.128 -46.8639 780.613 -50.0569 783.448 -52.8742C789.006 -58.6378 795.609 -63.0458 802.047 -65.2314C805.252 -66.3473 808.392 -66.944 811.234 -67.1876C814.082 -67.4243 816.641 -67.2573 818.754 -67.0615C819.804 -66.8992 820.758 -66.7838 821.581 -66.6385C822.402 -66.4685 823.107 -66.3166 823.677 -66.203C824.816 -65.9266 825.433 -65.7464 825.433 -65.7464C828.131 -65.0335 830.795 -64.0889 833.388 -62.9289C835.995 -61.8046 838.531 -60.4647 841.007 -59.0135C845.958 -56.074 850.673 -52.6574 855.132 -48.8895C859.598 -45.1271 863.848 -41.0711 867.917 -36.8233C869.947 -34.7246 871.99 -32.507 874.023 -30.3522L878.557 -25.5191L865.83 -13.5742L847.266 3.86467L843.846 0.220832C840.742 -3.12502 837.56 -6.39212 834.303 -9.15357C831.04 -11.9341 827.625 -14.3342 823.966 -16.0355C820.332 -17.7465 816.415 -18.7378 812.637 -18.577C808.86 -18.4407 805.395 -17.1595 802.52 -15.342L802.514 -15.3488Z"
          fill="#ffffff7d"
        />
        <path
          d="M896.677 56.1783C892.472 50.562 890.102 52.1214 893.806 58.0641C895.803 61.2605 897.854 64.5057 900.088 67.9488C901.212 69.6648 902.371 71.4339 903.575 73.2819C904.187 74.2037 904.811 75.1392 905.446 76.1005C906.384 77.5009 907.347 78.9283 908.332 80.3953C911.16 80.1752 914.652 79.9049 918.331 79.6164C932.903 78.2748 936.445 77.3663 946.338 76.6075C950.283 76.2781 954.866 75.9453 959.665 75.6159C965.171 75.2469 970.917 74.8714 976.416 74.5079C976.371 72.4312 976.331 70.3736 976.289 68.3653C976.274 67.0586 976.264 65.7834 976.24 64.5439C976.211 62.0606 976.188 59.7265 976.168 57.6153C976.136 53.3874 976.104 50.0627 976.097 48.2497C976.089 47.2344 976.062 46.2112 976.011 45.1854C975.941 43.7247 975.824 41.2696 975.624 37.068C975.434 32.4407 975.156 25.8808 974.762 16.5443C973.11 15.8322 970.49 14.7066 967.178 13.2881C964.633 12.1823 961.564 10.8503 958.168 9.37371C951.382 6.40262 943.322 2.83217 935.648 -0.631174L920.59 -7.28702L908.681 15.5899C902.014 28.4344 897.278 38.1719 892.865 47.868C890.442 53.195 892.708 54.4827 895.67 49.4639C901.067 40.3317 906.334 30.8955 913.044 18.0739C914.017 16.1995 915.482 13.6143 917.4 10.2338C918.352 8.54299 919.419 6.64715 920.598 4.55866C921.185 3.50486 921.798 2.40427 922.445 1.25138C922.605 0.958381 922.771 0.672173 922.931 0.379174L923.158 -0.0307828L923.19 -0.0584499C923.229 -0.0916589 923.261 -0.119349 923.287 -0.141488C923.328 -0.0939942 923.37 -0.0588179 923.393 -0.031678C923.411 -0.011323 923.369 -0.0341659 923.447 0.00475372C923.636 0.0918888 923.83 0.185811 924.036 0.280978C924.431 0.463279 924.843 0.653604 925.268 0.857508C926.961 1.62938 928.843 2.48842 930.798 3.37956C933.366 4.53711 935.962 5.63551 938.548 6.65879C943.946 8.79622 949.698 11.1738 955.309 13.5432C960.426 15.7326 965.434 17.8738 969.858 19.7702C969.896 20.677 969.934 21.5592 969.968 22.3977C970.02 23.708 970.068 24.9623 970.113 26.1483C970.196 28.5133 970.271 30.6117 970.325 32.349C970.431 35.8235 970.496 37.8836 970.496 37.8836L971.644 70.2257L943.162 72.5864C928.788 73.781 921.87 74.3593 917.621 74.7136C916.076 74.8475 914.562 74.9783 913.141 75.1001C912.433 75.1644 911.745 75.2244 911.087 75.2813C910.882 75.3038 910.689 75.3275 910.509 75.3525C908 71.8258 905.724 68.6321 903.589 65.6259C901.183 62.2952 898.91 59.1945 896.652 56.1758L896.677 56.1783Z"
          fill="#ffffff7d"
        />
        <path
          d="M597.353 122.644C597.321 122.504 597.289 122.377 597.257 122.251C597.244 122.119 597.225 121.994 597.217 121.869C597.19 121.619 597.145 121.373 597.13 121.137C597.142 120.674 597.08 120.228 597.152 119.834C597.166 119.631 597.174 119.434 597.188 119.244C597.226 119.056 597.252 118.879 597.284 118.709C597.309 118.532 597.335 118.368 597.36 118.203C597.403 118.047 597.44 117.896 597.477 117.758C597.581 117.168 597.711 116.711 597.738 116.355C597.759 115.992 597.695 115.726 597.534 115.592C597.372 115.458 597.126 115.446 596.773 115.595C596.421 115.745 595.946 116.025 595.478 116.584C595.361 116.72 595.232 116.868 595.101 117.028C594.983 117.201 594.877 117.388 594.763 117.593C594.65 117.798 594.536 118.016 594.409 118.244C594.325 118.495 594.234 118.752 594.142 119.021C593.929 119.562 593.872 120.194 593.777 120.871C593.751 121.214 593.773 121.563 593.777 121.928C593.782 122.114 593.793 122.295 593.804 122.488C593.833 122.676 593.863 122.865 593.892 123.053C594.23 125.234 595.114 127.216 596.16 129.023C597.211 130.85 598.507 132.441 599.847 134.006C600.54 134.763 601.226 135.537 601.969 136.25C602.694 136.991 603.45 137.693 604.214 138.389C606.437 140.427 606.357 139.961 606.372 140.365L606.178 140.568L606.075 140.656L606.036 140.714L605.816 140.964C605.166 141.727 604.511 142.495 603.849 143.269C602.53 144.824 601.174 146.412 599.79 148.047C597.036 151.318 594.151 154.761 591.092 158.39C591.039 158.459 590.987 158.528 590.935 158.597C590.893 158.704 590.821 158.647 590.749 158.603L590.647 158.537L590.593 158.501L590.436 158.386C589.963 158.022 589.507 157.667 589.058 157.318C587.267 155.881 585.586 154.492 584.085 153.232C581.089 150.744 578.706 148.523 576.579 146.378C574.459 144.226 572.571 142.148 570.769 139.794C568.966 137.44 567.199 134.818 565.521 131.524C562.672 126.008 560.589 118.832 561.413 111.629C561.8 108.05 562.864 104.515 564.515 101.318C566.136 98.0866 568.312 95.2209 570.74 92.6593C573.15 90.1019 575.761 87.9422 578.437 86.2963C581.107 84.6437 583.83 83.5037 586.402 82.7565C591.556 81.2879 595.987 81.181 598.452 81.0971L600.716 81.0547C601.478 81.0269 602.303 80.9683 603.053 80.9146C604.356 80.8117 606.189 80.7257 608.761 80.4177C610.041 80.2631 611.534 80.0435 613.228 79.603C614.909 79.149 616.873 78.4514 618.766 77.0539C619.721 76.3715 620.591 75.5134 621.386 74.5055C622.193 73.4988 622.881 72.2388 623.361 70.7906C623.792 69.3127 623.914 67.6613 623.715 66.0144C623.472 64.3815 622.937 62.7994 622.218 61.3039C620.749 58.3528 618.641 55.7513 616.232 53.2677C615.021 52.0314 613.715 50.8289 612.342 49.6379C611.762 49.14 611.17 48.6408 610.573 48.1224L610.369 47.9657C610.369 47.9657 610.416 47.89 610.436 47.8487L610.482 47.773L610.521 47.7398C610.599 47.6241 610.684 47.5152 610.775 47.4007C611.634 46.3621 612.616 45.1567 613.715 43.8271C615.919 41.1622 618.572 37.9553 621.498 34.4174C622.727 32.9401 624.007 31.3938 625.333 29.8089C625.422 29.5891 625.576 29.7655 625.738 29.8748C626.158 30.2019 626.583 30.5357 627.002 30.8752C627.517 31.2985 628.032 31.7218 628.546 32.1452C629.586 33.0301 630.626 33.915 631.678 34.8134C632.686 35.726 633.732 36.5931 634.714 37.5401C636.729 39.3775 638.622 41.3325 640.459 43.3003C645.38 48.6552 649.092 54.0792 651.459 59.2862C653.851 64.4957 654.862 69.4353 654.88 73.7235C654.892 75.8649 654.675 77.847 654.323 79.6607C653.941 81.4651 653.442 83.0968 652.881 84.5677C651.724 87.4934 650.34 89.759 649.124 91.5222C647.674 93.5955 646.045 95.5022 644.343 97.1975C642.666 98.92 640.881 100.39 639.03 101.668C635.34 104.226 631.36 105.869 627.289 106.841C625.265 107.354 623.199 107.676 621.149 107.925C619.098 108.187 617.04 108.3 614.925 108.475C612.828 108.658 610.774 108.827 608.673 109.096C606.585 109.367 604.46 109.764 602.383 110.511C600.137 111.335 598.693 112.617 597.997 113.623C597.631 114.118 597.458 114.564 597.377 114.896C597.301 115.235 597.335 115.455 597.46 115.585L597.512 115.98C597.512 115.98 597.581 115.956 597.564 115.911L597.502 115.62L597.525 115.647C597.676 115.743 597.911 115.754 598.223 115.675C598.529 115.588 598.908 115.404 599.386 115.193C600.338 114.739 601.633 114.085 603.535 113.523C607.106 112.519 611.21 112.552 615.366 112.373C619.512 112.287 623.989 112.141 628.498 111.183C633.018 110.262 637.627 108.515 641.847 105.69C643.957 104.284 645.989 102.659 647.859 100.771C649.752 98.9093 651.542 96.8519 653.182 94.5195C654.443 92.7053 655.981 90.3192 657.364 87.1505C658.723 83.9916 659.911 80.0051 660.141 75.2657C660.376 70.5454 659.595 65.1096 657.494 59.5894C655.399 54.0636 652.045 48.509 647.728 43.203C644.913 39.7504 641.795 36.5825 638.53 33.709C637.82 33.0617 637.079 32.4421 636.337 31.8226C635.59 31.1962 634.849 30.5643 634.106 29.9694C632.622 28.7549 631.102 27.512 629.495 26.285L627.85 25.0666C627.117 24.5468 626.382 24.064 625.654 23.5757L624.552 22.8515L624.414 22.7571C624.414 22.7571 624.372 22.7096 624.347 22.7194L624.289 22.7692L624.088 23.0147L623.679 23.4866C623.134 24.1117 622.583 24.7423 622.055 25.4124C620.76 27.0067 619.471 28.6077 618.182 30.1965C615.865 33.054 613.555 35.8936 611.31 38.6533C608.565 41.9869 605.898 45.2419 603.342 48.3411C604.974 49.7252 606.582 51.0945 608.154 52.4355C609.17 53.2932 610.065 54.0892 610.977 54.9178C612.759 56.5646 614.335 58.2585 615.621 59.9415C616.907 61.6245 617.87 63.3243 618.363 64.8836C618.862 66.4497 618.875 67.8302 618.525 68.9884C618.181 70.1412 617.474 71.0962 616.739 71.8504C616.004 72.5923 615.273 73.0933 614.621 73.4539C614.292 73.6309 613.978 73.7598 613.725 73.895C613.449 74.003 613.21 74.0901 613.022 74.1576C612.639 74.2981 612.427 74.3508 612.427 74.3508C612.427 74.3508 611.579 74.6668 609.824 74.9587C608.074 75.2574 605.4 75.4871 601.98 75.6718C600.33 75.8013 598.451 75.7838 596.367 75.9311C594.302 76.0864 592.087 76.276 589.776 76.7156C587.47 77.1496 585.078 77.7542 582.68 78.6366C580.293 79.5449 577.933 80.7279 575.674 82.1563C573.397 83.5767 571.322 85.333 569.336 87.2035C568.858 87.687 568.369 88.1693 567.892 88.6528C567.408 89.1418 566.979 89.6673 566.519 90.1835C565.606 91.198 564.733 92.2847 563.915 93.4077C560.623 97.892 558.255 103.218 557.363 108.744C556.428 114.259 557.006 119.823 558.369 124.637C559.73 129.476 561.814 133.597 563.8 136.922C566.849 141.92 570.097 145.843 573.095 149.055C576.105 152.267 578.87 154.824 581.332 156.942C583.751 159.025 585.795 160.778 587.707 162.253C588.445 162.816 589.25 163.405 589.984 163.888C590.358 164.136 590.719 164.371 591.08 164.605C591.261 164.723 591.442 164.84 591.617 164.951L591.882 165.126C591.935 165.187 591.957 165.096 591.989 165.069L592.086 164.961C592.604 164.383 593.102 163.846 593.576 163.294C594.044 162.735 594.492 162.193 594.921 161.68C597.951 158.016 600.812 154.559 603.531 151.259C604.884 149.603 606.205 147.986 607.499 146.405C608.144 145.61 608.781 144.834 609.413 144.05C609.894 143.456 610.375 142.874 610.856 142.292C611.408 141.649 611.811 141.028 612.269 140.406L612.603 139.939L612.773 139.709L612.812 139.651C612.812 139.651 612.777 139.611 612.759 139.603L612.639 139.504L611.681 138.726C611.053 138.223 610.43 137.715 609.72 137.247C609.045 136.795 608.197 136.22 607.987 136.057C607.807 135.927 607.663 135.813 607.49 135.666L606.94 135.19C606.199 134.558 605.47 133.939 604.786 133.282C604.076 132.647 603.423 131.975 602.77 131.315C600.231 128.657 598.02 125.705 597.34 122.642L597.353 122.644Z"
          fill="#ffffff7d"
        />
        <path
          d="M905.025 104.617C908.268 104.859 910.596 104.322 912.04 103.776C913.485 103.218 914.096 102.63 913.988 102.248C913.875 101.834 913.048 101.633 911.568 101.532C910.088 101.432 907.949 101.437 905.199 101.09C901.301 100.546 897.6 98.8219 894.302 96.1306C890.979 93.4615 888.092 90.1067 886.444 86.0736C885.591 84.0759 885.092 81.9036 884.855 79.659C884.811 79.3762 884.81 79.0916 884.791 78.8113L884.765 78.3819C884.753 78.2137 884.742 78.1755 884.744 77.8293L884.721 76.1259L884.719 75.699L884.715 75.4883L884.714 75.383C884.714 75.383 884.66 75.3342 884.63 75.3126L883.93 74.7405C882.703 73.7315 881.458 72.7146 880.202 71.684C876.043 68.2867 871.686 64.7148 867.066 60.9429C856.534 52.4702 849.863 47.284 844.067 42.7681C841.173 40.5013 838.494 38.4047 835.636 36.1662C834.216 35.0387 832.755 33.8637 831.198 32.6293C829.498 31.2445 827.702 29.7881 825.745 28.1977C825.123 27.6892 824.488 27.1794 823.86 26.6641C823.543 26.4031 823.219 26.1476 822.902 25.8866L822.417 25.4971C822.26 25.3947 822.069 25.0968 822.006 25.4122C821.299 26.8311 820.573 28.2789 819.833 29.7502C819.557 30.3098 819.268 30.8681 818.986 31.4332C818.751 31.8856 818.534 32.3461 818.317 32.8189C817.877 33.7577 817.437 34.7089 816.996 35.6723C816.089 37.5967 815.284 39.6241 814.409 41.6632C813.632 43.7491 812.757 45.8252 812.043 48.0104C809.022 56.6477 806.809 66.0723 806.012 75.2136C805.771 77.4901 805.691 79.7582 805.607 81.9703C805.61 84.1911 805.553 86.3687 805.702 88.4868C805.864 92.7217 806.395 96.6971 807.016 100.273C808.309 107.431 810.225 112.92 811.332 115.958C812.064 117.727 812.733 119.527 813.615 121.25C815.072 124.354 818.013 130.052 823.031 136.821C827.985 143.621 835.198 151.311 844.23 158.5C848.74 162.081 853.705 165.603 859.117 168.75C864.529 171.885 870.381 174.712 876.587 176.734C882.775 178.759 889.26 180.148 895.734 180.582C902.208 181.041 908.645 180.711 914.787 179.757C923.446 178.304 930.974 175.938 937.461 173.318C943.967 170.694 949.526 167.937 954.295 165.291C959.059 162.639 963.103 160.191 966.488 157.981C968.177 156.878 969.745 155.88 971.126 154.913C972.385 154.051 973.587 153.227 974.726 152.446C975.311 152.047 975.883 151.648 976.443 151.272C976.723 151.077 976.99 150.894 977.263 150.705L977.365 150.641L977.41 150.603C977.41 150.603 977.386 150.576 977.374 150.562L977.177 150.4L976.782 150.075C970.586 145.073 964.791 140.39 959.289 135.941C954.569 132.184 950.114 128.627 945.831 125.217C937.241 118.42 929.312 112.24 921.415 106.175C917.23 102.954 914.707 101.746 914.2 102.195L913.841 102.66C913.927 102.669 913.953 102.634 913.926 102.551L914.115 102.304C913.794 102.902 915.515 105.137 919.53 108.588C927.094 115.083 934.763 121.583 943.177 128.603C947.401 132.1 951.791 135.737 956.439 139.592C960.436 142.868 964.655 146.321 969.155 150.006C969.179 150.033 969.252 150.065 969.232 150.094L969.118 150.169C969.041 150.223 968.959 150.271 968.882 150.325C968.724 150.426 968.559 150.533 968.375 150.644C967.752 151.051 967.091 151.492 966.405 151.941C965.67 152.399 964.908 152.878 964.109 153.378C963.31 153.879 962.473 154.388 961.61 154.931C960.73 155.442 959.817 155.98 958.867 156.539C956.991 157.672 954.913 158.766 952.724 159.979C948.308 162.308 943.298 164.781 937.627 167.1C931.95 169.413 925.605 171.565 918.574 173.109C913.99 174.085 909.349 174.789 904.705 175.128C899.688 175.491 894.42 175.333 889.129 174.53C883.844 173.734 878.535 172.305 873.465 170.324C863.295 166.354 854.154 160.317 846.718 154.33C843.019 151.319 839.715 148.337 836.93 145.512C836.209 144.826 835.584 144.095 834.931 143.422C834.297 142.733 833.655 142.099 833.101 141.437C831.986 140.105 830.883 138.942 830.009 137.783C828.172 135.531 826.851 133.64 825.932 132.353C825.464 131.712 825.157 131.192 824.924 130.846C824.703 130.502 824.58 130.323 824.58 130.323C824.58 130.323 824.406 130.058 824.074 129.548C823.736 129.043 823.247 128.301 822.669 127.302C822.097 126.31 821.329 125.131 820.59 123.677C820.205 122.964 819.797 122.199 819.366 121.382C818.973 120.556 818.557 119.679 818.113 118.756C816.414 115.064 814.643 110.554 813.269 105.417C811.882 100.291 810.891 94.537 810.529 88.5129C810.162 82.482 810.418 76.1866 811.288 69.9782C812.158 63.7699 813.624 57.653 815.434 51.9049C817.238 46.1501 819.429 40.7747 821.671 35.9489C821.95 35.34 822.221 34.749 822.492 34.158C822.755 33.6342 823.011 33.1159 823.267 32.5975C823.341 32.4504 823.415 32.3033 823.489 32.1562L823.597 31.9321L823.65 31.8262C823.65 31.8262 823.717 31.8639 823.741 31.8787C825.04 32.9321 826.255 33.9276 827.38 34.8335C848.06 51.6349 858.015 59.715 864.132 64.678C868.772 68.4209 873.16 71.9652 877.333 75.339C878.195 76.0327 879.058 76.714 879.896 77.3929L880.01 77.4849C880.039 77.5188 880.024 77.5914 880.028 77.6352L880.046 77.9648L880.114 78.8809C880.149 79.2186 880.154 79.5592 880.209 79.8926C880.539 82.5796 881.21 85.2332 882.305 87.6638C883.393 90.0999 884.804 92.34 886.476 94.2724C888.134 96.2159 889.983 97.8881 891.927 99.3472C893.878 100.801 895.972 102.059 898.199 102.953C900.419 103.852 902.739 104.416 905.025 104.617Z"
          fill="#ffffff7d"
        />
        <path
          d="M750.918 46.3522C758.573 45.1128 758.048 42.2019 750.288 42.8307C744.785 43.2804 739.151 43.7848 733.048 44.4087C730.025 44.6895 726.768 45.1259 723.389 45.6428C721.713 45.9736 719.993 46.3063 718.229 46.653C716.491 47.1076 714.704 47.5695 712.867 48.051C704.656 50.6382 699.911 53.2864 696.03 55.8305C695.542 56.1458 695.048 56.4297 694.589 56.7666C694.13 57.1036 693.684 57.4294 693.232 57.7608C692.779 58.0922 692.333 58.418 691.881 58.7494C691.422 59.074 690.976 59.4122 690.546 59.7953C689.669 60.529 688.754 61.2836 687.788 62.0824C686.875 62.9423 685.905 63.852 684.851 64.846C681.414 68.3136 677.817 72.8473 674.903 78.0873C674.182 79.3997 673.527 80.762 672.822 82.1193L671.901 84.2464L671.143 86.0189L670.767 86.9146L670.671 87.14C670.637 87.2169 670.752 87.2719 670.787 87.3373L671.117 87.7172C673.189 90.148 673.774 90.9743 674.941 92.2247C675.48 92.8052 676.025 93.3924 676.558 93.9661L677.364 94.8272L678.215 95.6373C682.663 100.01 687.456 103.478 691.623 105.93C693.74 107.085 695.626 108.154 697.297 108.862C698.123 109.243 698.869 109.585 699.537 109.887C700.213 110.148 700.803 110.375 701.296 110.567C702.473 110.989 703.633 111.485 704.839 111.786C705.916 112.056 707.431 112.507 709.355 112.95C711.288 113.301 713.602 113.869 716.25 114.138C721.545 114.843 728.159 115.205 735.372 114.644C738.976 114.348 742.752 113.939 746.495 113.441C750.273 112.971 754.175 112.489 758.128 111.999C766.026 111.025 774.134 110.061 781.929 109.176L790.783 108.101L783.832 68.3848C782.917 63.2076 782.054 58.4253 781.215 53.9548C780.206 48.6567 779.256 43.7234 778.358 39.0427C777.183 39.2018 776.013 39.3677 774.857 39.5225C774.285 39.6005 773.725 39.6798 773.16 39.7522L772.158 39.9042C770.883 40.1025 769.638 40.2979 768.4 40.4877C765.929 40.8864 763.533 41.2802 761.131 41.6673C757.912 42.2004 756.344 43.068 756.371 43.7574L756.162 43.8785C756.178 43.9604 756.232 43.9968 756.313 43.9865L756.401 43.9336C756.615 44.6048 758.421 45.054 761.689 44.8105C764.121 44.612 766.559 44.4202 769.065 44.2168C770.318 44.109 771.578 43.9956 772.862 43.8848L773.799 43.8005L774.196 43.7789C774.444 43.7669 774.692 43.755 774.946 43.7375C774.986 44.1188 775.032 44.507 775.072 44.9007C775.222 45.9118 775.385 46.9365 775.54 47.9791C775.876 50.079 776.214 52.2473 776.568 54.4852C777.295 58.9692 778.096 63.7575 778.999 68.9335C779.54 72.0563 780.214 76.7884 781.124 83.0166C781.591 86.1319 782.111 89.6175 782.684 93.4612C782.99 95.3849 783.297 97.4016 783.627 99.4947C783.8 100.545 783.967 101.614 784.139 102.714L784.174 102.921L784.194 103.022C784.194 103.022 784.194 103.022 784.2 103.029L784.188 103.04L784.175 103.051C784.156 103.043 784.138 103.035 784.145 103.03L781.976 103.286L779.639 103.593C778.085 103.806 776.53 104.032 774.993 104.278C768.347 105.323 761.182 106.353 754.181 107.312C747.181 108.247 740.314 109.257 734.418 109.667C732.925 109.732 731.488 109.796 730.119 109.861C728.746 109.883 727.424 109.835 726.182 109.827C725.558 109.819 724.952 109.807 724.371 109.798C723.792 109.751 723.225 109.706 722.683 109.663C721.598 109.578 720.593 109.507 719.687 109.434C717.878 109.225 716.441 108.98 715.451 108.849C714.467 108.724 713.94 108.597 713.94 108.597C713.94 108.597 713.149 108.436 711.726 108.143C711.016 107.972 710.136 107.864 709.147 107.566C708.156 107.292 707.019 106.979 705.772 106.63C704.533 106.238 703.205 105.732 701.766 105.24C700.341 104.699 698.861 104.005 697.293 103.338C696.53 102.939 695.755 102.539 694.955 102.124C694.562 101.917 694.156 101.709 693.75 101.5C693.345 101.28 692.966 101.025 692.561 100.792C691.765 100.303 690.956 99.8127 690.129 99.3144C689.342 98.7582 688.542 98.2008 687.731 97.6298C684.548 95.2904 681.374 92.6116 678.556 89.5299C677.819 88.7994 677.14 88.0068 676.468 87.2087L676.019 86.6931C675.99 86.6345 675.9 86.582 675.902 86.5204L675.984 86.3308C676.272 85.6425 676.553 84.9597 676.834 84.2769C677.253 83.404 677.677 82.5379 678.096 81.6773C681.496 74.8288 686.134 69.4791 689.985 66.0103C690.674 65.3195 691.439 64.7539 692.155 64.1709C692.877 63.607 693.538 63.0123 694.25 62.5279C694.956 62.0367 695.643 61.5744 696.305 61.1097C696.635 60.8835 696.96 60.6628 697.278 60.4353C697.602 60.2269 697.937 60.0445 698.266 59.8552C698.912 59.4754 699.539 59.1123 700.141 58.7589C700.736 58.3988 701.319 58.062 701.917 57.7949C703.091 57.2213 704.169 56.6937 705.173 56.1955C706.216 55.7695 707.166 55.3772 708.059 55.0101C708.945 54.6486 709.751 54.2974 710.546 54.0626C712.1 53.5523 713.403 53.1156 714.525 52.7408C716.263 52.2739 717.957 51.8211 719.607 51.3824C721.285 51.0269 722.919 50.6855 724.521 50.3472C727.753 49.7907 730.809 49.2906 733.861 48.889C739.924 48.0384 745.498 47.1939 750.919 46.3153L750.918 46.3522Z"
          fill="#ffffff7d"
        />
        <path
          d="M737.982 -30.5396C732.593 -21.759 735.084 -20.0835 740.952 -28.4568C749.352 -40.2903 758.232 -52.6566 770.032 -68.2584C772.641 -71.7481 774.923 -74.8132 775.687 -75.8304C774.881 -77.2978 774.104 -78.7065 773.355 -80.069C772.865 -80.9414 772.399 -81.7866 771.937 -82.6005C771.02 -84.2213 770.178 -85.7294 769.382 -87.1339C767.784 -89.9496 766.388 -92.417 765.049 -94.7672C762.377 -99.4733 759.978 -103.75 756.841 -109.622C754.559 -113.881 752.054 -118.576 748.766 -124.711C746.283 -121.568 743.683 -118.287 741.024 -114.933C739.035 -112.394 737 -109.793 734.96 -107.198C730.902 -101.981 726.88 -96.7112 723.186 -91.7852C715.782 -81.9413 709.725 -73.4883 707.149 -69.8716C706.263 -68.6192 705.384 -67.3601 704.534 -66.0671C701.497 -61.4703 693.327 -49.0876 683.61 -33.1569C673.857 -17.2423 662.64 2.27826 652.745 20.6217L648.111 29.3675L703.445 35.6948L705.577 31.7609C716.267 12.1249 724.631 -2.31629 732.934 -16.4668C737.533 -24.208 735.393 -25.7118 730.256 -18.2788C720.982 -4.71547 712.04 9.48774 701.254 29.2067C701.107 29.4763 700.947 29.7693 700.574 30.4365C696.645 29.8955 690.711 29.0892 683.012 28.0357C678.849 27.4833 674.212 26.8642 669.126 26.1934C666.586 25.8675 663.935 25.5304 661.173 25.182C659.899 25.0219 658.595 24.8647 657.266 24.6928C657.254 24.6792 657.249 24.6724 657.249 24.6601C657.249 24.6601 657.268 24.6435 657.281 24.6324C657.3 24.6158 657.307 24.598 657.314 24.5801L658.634 22.0606C659.587 20.2151 660.54 18.3697 661.48 16.5352C669.558 0.629919 679.733 -17.1593 688.132 -30.7743C692.323 -37.592 696.033 -43.3885 698.697 -47.4849C701.385 -51.5665 702.973 -53.9723 702.973 -53.9723C710.404 -65.23 718.082 -76.3204 725.964 -87.254C729.908 -92.7174 733.912 -98.1376 737.97 -103.509L744.095 -111.547L748.245 -116.89L755.104 -104.151L769.991 -76.5323L766.066 -71.3824C754.237 -55.6723 745.682 -42.9328 737.982 -30.5396Z"
          fill="#ffffff7d"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3622_1083">
        <rect width="1003" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_3622_1083">
        <rect
          width="3757.37"
          height="4501.65"
          fill="white"
          transform="matrix(0.17533 -0.151453 0.135277 0.155367 247.785 7.06543)"
        />
      </clipPath>
    </defs>
  </svg>`;
const $cb0e8fe57b0fd046$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$8f97e278a4a2a6b3$require$Buffer.from($cb0e8fe57b0fd046$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf = ({ ...props })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$0fd79bc510e2fa30$var$defaultButtonStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
            appearance: "default",
            ...props
        })
    });
};
const $cb0e8fe57b0fd046$var$$0fd79bc510e2fa30$var$defaultButtonStyles = (0, $gyDKM.css)({
    "& button": {
        borderRadius: "4px",
        border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
        backgroundColor: `transparent`
    }
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$export$2c3faa04d4773275 = ({ lessons: lessons, onLessonClick: onLessonClick, expandButtonText: expandButtonText = "Show lessons", collapseButtonText: collapseButtonText = "Hide lessons", containerStyles: customContainerStyles, buttonContainerStyles: customButtonContainerStyles })=>{
    const [isOpened, setIsOpened] = (0, $acw62.useState)(false);
    const deviceSize = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const isTablet = deviceSize <= $cb0e8fe57b0fd046$export$62d1d6124a8e4649;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$wrapperStyles,
            customContainerStyles
        ],
        children: [
            !isTablet && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    customButtonContainerStyles
                ],
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                    css: $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$lessonsContentWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerMobileStyles,
                    customButtonContainerStyles
                ],
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                    css: [
                        $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$toggleButtonStyles,
                        $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$toggleButtonMobileStyles
                    ],
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button-mobile",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$wrapperStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    maxWidth: "100%"
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`,
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$toggleButtonStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$toggleButtonMobileStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerOpenStyles = (0, $gyDKM.css)({
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$lessonsContentWrapperStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral")
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerClosedStyles = (0, $gyDKM.css)({
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$7586a58445419b5a$var$buttonContainerMobileStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
    }
});
const $cb0e8fe57b0fd046$var$$bde17c0708419ffe$var$CompletedIcon = ()=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M15.8203 7.04186L15.8028 7.03662L6.61914 16.5773L6.62525 16.5939L21.6161 21.8224L15.8203 7.04186Z",
                fill: "#1868DB"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.31618 3.19751L10.3213 7.04536L5.25684 6.23896L5.28564 4.75358L5.31618 3.19751Z",
                fill: "#FCA700"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M14.6344 9.49606H12.8924L11.1836 4.41504H12.9256L14.6344 9.49606Z",
                fill: "#BF63F3"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M9.40688 15.4488L9.37982 15.3764C9.22448 14.9662 8.95742 14.6153 8.60659 14.3631C8.24877 14.1057 7.82811 13.9695 7.39001 13.9695C6.9519 13.9695 6.53211 14.1057 6.17342 14.3631C5.82259 14.6153 5.55553 14.9662 5.40019 15.3764L5.37313 15.4488H3.82666L3.85808 15.3118C4.04397 14.5054 4.49255 13.774 5.12179 13.253C5.43684 12.9921 5.78855 12.7896 6.16644 12.6491C6.5583 12.5042 6.96935 12.4309 7.38913 12.4309C7.80891 12.4309 8.21997 12.5042 8.61182 12.6491C8.99059 12.7887 9.34142 12.9921 9.65648 13.253C10.2857 13.774 10.7352 14.5054 10.9202 15.3118L10.9516 15.4488H9.40513H9.40688Z",
                fill: "#1868DB"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M6.51602 10.2929C6.56926 10.2475 6.62075 10.1943 6.66962 10.1349C6.71849 10.0756 6.76126 10.0127 6.79617 9.94989C7.00126 9.58073 6.94017 9.19935 6.66787 8.89215C6.62162 8.83978 6.56926 8.78916 6.51078 8.74204C6.45231 8.69491 6.38773 8.64953 6.32402 8.61287C5.96707 8.40866 5.5822 8.42436 5.26278 8.69666C5.20867 8.74291 5.15631 8.79615 5.10657 8.85724C5.05769 8.91746 5.0158 8.97855 4.98177 9.03964C4.77755 9.40618 4.83951 9.78669 5.11093 10.0965C5.15893 10.1515 5.21304 10.2039 5.27413 10.2536C5.33522 10.3033 5.39195 10.3426 5.45304 10.3775C5.80911 10.5835 6.19486 10.5678 6.51515 10.2929H6.51602Z",
                fill: "#BF63F3"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M13.6186 12.9931C13.6718 12.9477 13.7233 12.8945 13.7722 12.8351C13.821 12.7758 13.8638 12.7129 13.8987 12.6501C14.1038 12.2809 14.0427 11.8995 13.7704 11.5923C13.7242 11.54 13.6718 11.4894 13.6133 11.4422C13.5548 11.3951 13.4903 11.3497 13.4266 11.3131C13.0696 11.1089 12.6847 11.1246 12.3653 11.3969C12.3112 11.4431 12.2589 11.4963 12.2091 11.5574C12.1594 11.6185 12.1183 11.6787 12.0843 11.7398C11.8801 12.1064 11.942 12.4869 12.2135 12.7967C12.2615 12.8517 12.3156 12.9041 12.3767 12.9538C12.4378 13.0035 12.4945 13.0428 12.5556 13.0777C12.9117 13.2837 13.2974 13.268 13.6177 12.9931H13.6186Z",
                fill: "#292A2E"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M9.3788 15.3765L9.40586 15.449H10.9523L10.9209 15.3119C10.7446 14.5439 10.3283 13.844 9.74535 13.3291L8.68848 14.4279C8.99829 14.674 9.23655 14.9995 9.3788 15.3765Z",
                fill: "#292A2E"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M14.6342 9.4961L14.3235 8.57275L13.4351 9.4961H14.6342Z",
                fill: "#292A2E"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M9.68084 8.91065L8.87305 10.5713L10.5337 11.3791L11.3415 9.71844L9.68084 8.91065Z",
                fill: "#FCA700"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M2.55684 10.4918C2.52717 10.4718 2.49924 10.4726 2.48004 10.4752C2.46084 10.4787 2.45037 10.4883 2.44601 10.5014C2.43728 10.5285 2.45561 10.5599 2.49051 10.5896C2.54113 10.6323 2.57255 10.6934 2.59786 10.7763C2.62491 10.8592 2.63888 10.9605 2.69648 11.0818C2.72964 11.1499 2.77764 11.2014 2.8239 11.2345C2.8719 11.2686 2.91641 11.2834 2.95742 11.2947C3.03946 11.3148 3.12062 11.3104 3.2175 11.2764C3.37982 11.2153 3.52557 11.0539 3.66346 11.0259C3.72804 11.0111 3.79001 11.0294 3.83277 11.0565C3.87291 11.0835 3.89648 11.1115 3.90608 11.1324C3.91306 11.1438 3.92004 11.1542 3.92702 11.1673C3.94011 11.1883 3.96106 11.2336 3.98462 11.3052C4.00993 11.3759 4.03088 11.4763 4.09982 11.5897C4.13473 11.6464 4.19059 11.6997 4.25691 11.7355C4.32324 11.7686 4.3983 11.787 4.47771 11.7843C4.55713 11.7782 4.62957 11.7486 4.68979 11.7136C4.75088 11.6787 4.80062 11.6395 4.8495 11.6046C4.9839 11.4998 5.07815 11.4675 5.15582 11.492C5.23611 11.512 5.27539 11.5548 5.29808 11.5897C5.35393 11.6744 5.3775 11.7878 5.41851 11.8908C5.45517 11.9938 5.52324 12.1029 5.6271 12.1552C5.6847 12.1823 5.72048 12.1666 5.72746 12.1456C5.73531 12.1221 5.71873 12.0924 5.68295 12.0662C5.61924 12.0147 5.58433 11.9406 5.55815 11.8437C5.52848 11.7494 5.51626 11.6307 5.43335 11.499C5.40281 11.4501 5.33561 11.3646 5.21255 11.3253C5.15321 11.3035 5.07466 11.2965 4.99524 11.3139C4.91495 11.3314 4.84426 11.3742 4.77968 11.4178C4.73691 11.4475 4.70026 11.478 4.66535 11.5077C4.62782 11.54 4.58942 11.567 4.55015 11.588C4.51088 11.6054 4.47161 11.6176 4.43146 11.6142C4.41139 11.6142 4.39044 11.608 4.37037 11.6037C4.35204 11.5941 4.33022 11.5915 4.31539 11.5784C4.28048 11.56 4.25779 11.5286 4.2351 11.4981C4.19495 11.4318 4.17575 11.355 4.15917 11.3017C4.14346 11.2467 4.13299 11.2127 4.13299 11.2127C4.13299 11.2127 4.12862 11.2005 4.12164 11.1778C4.11204 11.1542 4.1007 11.1211 4.07801 11.08C4.05706 11.039 4.02215 10.9902 3.97066 10.9491C3.9183 10.9072 3.85197 10.8802 3.77953 10.8671C3.70448 10.8566 3.62331 10.8697 3.55611 10.9003C3.48717 10.9299 3.43306 10.971 3.38157 11.0076C3.28208 11.0844 3.19655 11.1411 3.13197 11.156C3.03684 11.176 2.95917 11.1411 2.91902 11.1088C2.87801 11.0739 2.85706 11.0382 2.84222 11.0094C2.79859 10.9212 2.77677 10.8191 2.74011 10.7266C2.70433 10.6341 2.64499 10.5416 2.55684 10.4927V10.4918Z",
                fill: "#292A2E"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M8.03289 2.23406C8.01543 2.20352 7.99012 2.19043 7.97267 2.18432C7.95434 2.17908 7.9395 2.18257 7.93078 2.19217C7.9107 2.21224 7.91245 2.2489 7.93078 2.29079C7.95609 2.35188 7.95609 2.42083 7.94125 2.50635C7.92729 2.59275 7.89412 2.68875 7.88976 2.82315C7.88801 2.89821 7.90721 2.96715 7.93339 3.01777C7.96045 3.07014 7.99361 3.1033 8.02503 3.1321C8.08961 3.18708 8.16292 3.22112 8.26416 3.23421C8.43609 3.25341 8.63943 3.17574 8.77558 3.21414C8.84016 3.23072 8.88641 3.27523 8.9126 3.31886C8.93616 3.36163 8.94401 3.39654 8.94314 3.4201C8.94401 3.43319 8.94576 3.44628 8.94576 3.46024C8.94838 3.48468 8.94576 3.5353 8.93354 3.60948C8.92394 3.68454 8.89601 3.78315 8.90649 3.91494C8.91172 3.98126 8.9379 4.0537 8.97979 4.11566C9.0243 4.17588 9.0819 4.22563 9.15434 4.25966C9.22852 4.29021 9.3062 4.29719 9.37514 4.2937C9.44583 4.29021 9.5078 4.27799 9.56714 4.27014C9.73383 4.23872 9.83332 4.25268 9.89092 4.31028C9.95376 4.36439 9.9686 4.42024 9.97296 4.46214C9.9843 4.5625 9.95376 4.67421 9.94329 4.78504C9.92932 4.89326 9.9398 5.02155 10.0087 5.11581C10.0471 5.16555 10.0873 5.16904 10.1021 5.15246C10.1196 5.13501 10.1187 5.10097 10.0986 5.0617C10.0646 4.98664 10.0681 4.90461 10.089 4.80686C10.1056 4.70912 10.1493 4.59828 10.1353 4.44294C10.1309 4.38621 10.11 4.27886 10.0183 4.1881C9.97558 4.14184 9.90838 4.09995 9.82983 4.07901C9.75041 4.05806 9.66838 4.0633 9.58983 4.07377C9.53834 4.08075 9.49121 4.09123 9.4467 4.1017C9.3987 4.11304 9.35245 4.12003 9.30794 4.1209C9.26518 4.11828 9.22503 4.1113 9.19012 4.09035C9.17267 4.08075 9.15696 4.06592 9.14125 4.05283C9.1299 4.03624 9.1107 4.02315 9.10372 4.00483C9.08103 3.97254 9.07492 3.93414 9.06881 3.89661C9.06358 3.81894 9.08016 3.74214 9.09063 3.68715C9.10198 3.6313 9.10809 3.59552 9.10809 3.59552C9.10809 3.59552 9.10983 3.58243 9.11332 3.55886C9.11507 3.53355 9.12118 3.49952 9.11943 3.45239C9.11943 3.40614 9.1107 3.34679 9.08365 3.28657C9.0566 3.22548 9.00947 3.17137 8.951 3.12599C8.88903 3.08235 8.81049 3.05704 8.7363 3.05355C8.66125 3.04832 8.59405 3.06054 8.53209 3.07014C8.40816 3.09283 8.30692 3.10504 8.24234 3.08934C8.14896 3.06403 8.09572 2.9977 8.0739 2.9497C8.05296 2.89908 8.05034 2.85894 8.05121 2.82577C8.05209 2.72715 8.08001 2.62679 8.08874 2.5273C8.09921 2.42868 8.08874 2.31872 8.03201 2.23581L8.03289 2.23406Z",
                fill: "#292A2E"
            })
        ]
    });
};
var $cb0e8fe57b0fd046$var$$bde17c0708419ffe$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$bde17c0708419ffe$var$CompletedIcon;
const $cb0e8fe57b0fd046$var$$b16d92af3081158f$var$QuestionIcon = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.8284 7.15997C15.3505 7.67945 15.7181 8.3338 15.89 9.04999C16.1223 10.008 15.9918 11.0181 15.5235 11.8856C15.0552 12.7531 14.2824 13.4165 13.354 13.748C13.149 13.821 13.004 14.003 13.004 14.22V15.002C13.004 15.2677 12.8984 15.5226 12.7105 15.7105C12.5226 15.8984 12.2677 16.004 12.002 16.004C11.7363 16.004 11.4814 15.8984 11.2935 15.7105C11.1056 15.5226 11 15.2677 11 15.002V12.988C11.0034 12.725 11.1103 12.474 11.2975 12.2893C11.4846 12.1046 11.7369 12.001 11.9998 12.001H11.993C13.098 12.001 13.996 11.103 13.996 10.001C13.984 9.47739 13.7676 8.97927 13.3929 8.61327C13.0183 8.24727 12.5153 8.04248 11.9915 8.04275C11.4678 8.04301 10.9649 8.2483 10.5907 8.61467C10.2164 8.98104 10.0004 9.47937 9.989 10.003C9.987 10.554 9.539 11.001 8.987 11.001C8.74019 10.9995 8.50281 10.906 8.32123 10.7388C8.13964 10.5717 8.02689 10.3428 8.005 10.097L8 9.94999C8.017 7.44599 10.321 5.51399 12.933 6.10799C13.6501 6.27628 14.3063 6.64048 14.8284 7.15997ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
            fill: "#44546F"
        })
    });
var $cb0e8fe57b0fd046$var$$b16d92af3081158f$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$var$$b16d92af3081158f$var$QuestionIcon;
const $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$STATUS_LABELS = {
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]: "Not started",
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]: "Complete!"
};
const $cb0e8fe57b0fd046$var$$c68bccd399b510db$export$cee724c49a9ffe54 = ({ isRetired: isRetired, progress: progress, status: status })=>{
    if (isRetired) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
            css: $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    children: "Retired content"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$b16d92af3081158f$export$2e2bcd8739ae039, {})
            ]
        })
    });
    if (status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED) return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: (0, $gyDKM.css)({
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle")
                    }),
                    children: $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$STATUS_LABELS[$cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c17561cb55d4db30, {
                progress: 0
            })
        ]
    });
    if (status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
            css: $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    children: "Progress"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                    css: (0, $gyDKM.css)({
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.lime")
                    }),
                    children: $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$STATUS_LABELS[$cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$bde17c0708419ffe$export$2e2bcd8739ae039, {})
            ]
        })
    });
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                    css: $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$progressStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            children: "Progress"
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                            css: (0, $gyDKM.css)({
                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle")
                            }),
                            children: [
                                progress,
                                "%"
                            ]
                        })
                    ]
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c17561cb55d4db30, {
                progress: progress,
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.accent.lime")
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$c68bccd399b510db$var$progressStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$e9cd1e314d8acc99$export$aa140c19feb5d492 = ({ title: title, href: href, isRetired: isRetired = false, onTitleClick: onTitleClick })=>{
    const handleClick = (e)=>{
        if (onTitleClick) {
            e.preventDefault();
            onTitleClick();
        }
    };
    const handleKeyboardClick = (0, $acw62.useCallback)(()=>{
        if (onTitleClick) onTitleClick();
    }, [
        onTitleClick
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleKeyboardClick);
    if (isRetired) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $cb0e8fe57b0fd046$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
            level: 4,
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
            children: title
        })
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
            label: title,
            link: href || "#",
            size: $cb0e8fe57b0fd046$export$be4c932f76c19adf.EXTRA_LARGE,
            style: $cb0e8fe57b0fd046$export$2b77966d73aefa77.SEMIBOLD,
            icon: "arrow-right-small",
            onClick: handleClick
        })
    });
};
const $cb0e8fe57b0fd046$var$$e9cd1e314d8acc99$var$titleContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    "& *": {
        fontFamily: "Charlie Display, sans-serif"
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "& a span:last-of-type": {
        verticalAlign: "text-bottom"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        "& a span:last-of-type": {
            verticalAlign: "bottom"
        }
    }
});
const $cb0e8fe57b0fd046$export$60e8035fadc9b8fc = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, progress: progress, type: type, isSaved: isSaved, isRetired: isRetired, onSave: onSave, tags: tags, status: status, onDownloadPdf: onDownloadPdf, additionalActions: additionalActions, completionBadgeUrl: completionBadgeUrl, dropdownItems: dropdownItems, onTitleClick: onTitleClick, showSaveButton: showSaveButton = true })=>{
    const typeText = (0, $acw62.useMemo)(()=>{
        switch(type){
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE:
                return "Course";
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.LESSON:
                return "Lesson";
            default:
                return "Learning Path";
        }
    }, [
        type
    ]);
    const getBackgroundColor = (0, $acw62.useMemo)(()=>{
        if (isRetired) return "#8C8F97"; // neutral 500
        switch(type){
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE:
                return "#357DE8"; // blue 600
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.LESSON:
                return "#FCA700"; // yellow 400
            default:
                return "#6A9A23"; // lime 600
        }
    }, [
        isRetired,
        type
    ]);
    const expandableTextLabels = (0, $acw62.useMemo)(()=>{
        switch(type){
            case $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE:
                return {
                    expandButtonText: "Show lessons",
                    collapseButtonText: "Hide lessons"
                };
            default:
                return {
                    expandButtonText: "Show courses",
                    collapseButtonText: "Hide courses"
                };
        }
    }, [
        type
    ]);
    const handleSave = ()=>{
        onSave?.(!isSaved);
    };
    const showCourseList = !isRetired && lessons.length > 0;
    const isCompleted = progress === 100;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$containerStyles,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$topControlsStyles,
                style: {
                    backgroundColor: getBackgroundColor
                },
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: (0, $gyDKM.css)({
                            flexShrink: 0
                        }),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$71f050e2efa708bb, {
                            size: "medium",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
                            fontWeight: "semibold",
                            children: typeText
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$headerImageStyles,
                        style: {
                            backgroundImage: `url(${$cb0e8fe57b0fd046$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c})`
                        }
                    }),
                    isCompleted && completionBadgeUrl && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$badgeOuterContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$badgeInnerContainerStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e431a229df88919, {
                                src: completionBadgeUrl,
                                alt: "Completion Badge",
                                width: 48,
                                height: 48
                            })
                        })
                    }),
                    showSaveButton && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$dd09d7da2da4d16f, {
                        icon: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-narrow-filled" : "bookmark-narrow",
                            color: "#FFFFFF"
                        }),
                        ariaLabel: isSaved ? "Saved" : "Save",
                        onClick: handleSave,
                        selected: isSaved
                    }),
                    Boolean(dropdownItems?.length) && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$ef4a0fdddd7eccb7, {
                        items: dropdownItems,
                        isInverted: true
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$contentStyles,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$leftColumnStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$tagsContainerStyles,
                                children: tags.map((tag)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                        label: tag.label
                                    }, tag.label))
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$e9cd1e314d8acc99$export$aa140c19feb5d492, {
                                title: course.title,
                                href: course.href,
                                isRetired: isRetired,
                                onTitleClick: onTitleClick
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$rightColumnStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$c68bccd399b510db$export$cee724c49a9ffe54, {
                            isRetired: isRetired,
                            progress: progress,
                            status: status
                        })
                    })
                ]
            }),
            (onDownloadPdf || additionalActions) && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$completionActionsStyles,
                children: [
                    onDownloadPdf && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf, {
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.DEFAULT,
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bZH1Z))),
                        onClick: onDownloadPdf,
                        children: "Download completion pdf"
                    }),
                    additionalActions
                ]
            }),
            showCourseList && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$7586a58445419b5a$export$2c3faa04d4773275, {
                lessons: lessons,
                onLessonClick: onLessonClick,
                expandButtonText: expandableTextLabels.expandButtonText,
                collapseButtonText: expandableTextLabels.collapseButtonText,
                containerStyles: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$expandableLessonsListContainerStyles,
                buttonContainerStyles: $cb0e8fe57b0fd046$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden"
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$topControlsStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")}`
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$contentStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    flexWrap: "wrap",
    rowGap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$leftColumnStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$rightColumnStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    minWidth: "234px",
    alignSelf: "flex-end"
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$tagsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$expandableLessonsListContainerStyles = (0, $gyDKM.css)({
    border: "none",
    borderRadius: "0"
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles = (0, $gyDKM.css)({
    paddingLeft: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")} !important`
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$headerImageStyles = (0, $gyDKM.css)({
    display: "flex",
    flexGrow: 1,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    backgroundSize: "cover",
    minHeight: "48px",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$completionActionsStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")}`
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$badgeOuterContainerStyles = (0, $gyDKM.css)({
    position: "relative",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    width: "72px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$8340d81aba797956$var$badgeInnerContainerStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    transform: "translateY(-25%)"
});
var $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$dbb9d5792c296a49$exports, "SubmitFeedback", ()=>$cb0e8fe57b0fd046$export$f6dc54b55657f29f);
const $cb0e8fe57b0fd046$export$f6dc54b55657f29f = ({ onSubmit: onSubmit, onChange: onChange, isLoading: isLoading, isSubmitted: isSubmitted, hasError: hasError, opinion: opinion })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $acw62.useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $acw62.useState)(false);
    const handleChange = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $acw62.useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $acw62.useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $acw62.useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $cdd250fb0ff30a4f$export$2e2bcd8739ae039), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    type: "submit",
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $ea673c41278c8551$export$2e2bcd8739ae039), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $55bd6b694f6c38bc$export$2e2bcd8739ae039), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
            css: $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
            css: $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            !isSubmitted && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: (0, $gyDKM.css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                            css: $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: (0, $gyDKM.css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: (0, $gyDKM.css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$var$labelStyles = (0, $gyDKM.css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$var$feedbackStyles = (0, $gyDKM.css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});
var $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports, "QuestionType", ()=>$cb0e8fe57b0fd046$export$51940fbbacba35d4);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports, "QuizStatus", ()=>$cb0e8fe57b0fd046$export$bf1c1ed72daa392b);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports, "QuestionStatus", ()=>$cb0e8fe57b0fd046$export$602daccbd963b20);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports, "MatchingAnswerStatus", ()=>$cb0e8fe57b0fd046$export$85e3e62cc743c830);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports, "ActionDescription", ()=>$cb0e8fe57b0fd046$export$cb9c858407602327);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports, "Quiz", ()=>$cb0e8fe57b0fd046$export$76709845c4fea6cd);
let $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789 || ($cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789 = {}));
const $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode, text: text, elementId: elementId, inputStatus: inputStatus = $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT, onClick: onClick })=>{
    // Keep original Space-only handler for outer div (used by tests)
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    // Use keyboard interaction hook for inner div
    const handleClick = (0, $acw62.useCallback)(()=>onClick?.(), [
        onClick
    ]);
    const onKeyDownInner = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleClick);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsContainerStyles,
            $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsContentStyles,
                    $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                onKeyDown: onKeyDownInner,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsTextStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$e61786c4aee8d415, {
                        children: text
                    })
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsContainerStyles = (0, $gyDKM.css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsContentStyles = (0, $gyDKM.css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsTextStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $gyDKM.css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $5e26c99fa43b3c99$export$29a4f05edc054374),
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $gyDKM.css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $gyDKM.css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $gyDKM.css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $cb0e8fe57b0fd046$var$$b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $gyDKM.css)({
        color: "#000000",
        backgroundColor: (0, $5e26c99fa43b3c99$export$29a4f05edc054374),
        fontWeight: 400
    }),
    CORRECT: (0, $gyDKM.css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $gyDKM.css)({
        fontWeight: 700
    }),
    SELECTED: (0, $gyDKM.css)({
        fontWeight: 700
    }),
    DISABLED: (0, $gyDKM.css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};
let $cb0e8fe57b0fd046$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($cb0e8fe57b0fd046$export$51940fbbacba35d4 || ($cb0e8fe57b0fd046$export$51940fbbacba35d4 = {}));
let $cb0e8fe57b0fd046$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($cb0e8fe57b0fd046$export$bf1c1ed72daa392b || ($cb0e8fe57b0fd046$export$bf1c1ed72daa392b = {}));
let $cb0e8fe57b0fd046$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($cb0e8fe57b0fd046$export$602daccbd963b20 || ($cb0e8fe57b0fd046$export$602daccbd963b20 = {}));
let $cb0e8fe57b0fd046$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($cb0e8fe57b0fd046$export$85e3e62cc743c830 || ($cb0e8fe57b0fd046$export$85e3e62cc743c830 = {}));
let $cb0e8fe57b0fd046$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct responses.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($cb0e8fe57b0fd046$export$cb9c858407602327 || ($cb0e8fe57b0fd046$export$cb9c858407602327 = {}));
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$cb0e8fe57b0fd046$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT = 136;
const $cb0e8fe57b0fd046$export$76709845c4fea6cd = ({ inspectMode: inspectMode, title: title, questions: questions = [], onCompletion: onCompletion, step: step = 0, setStep: setStep, onInteraction: onInteraction, isCompleted: isCompleted = false, setIsCompleted: setIsCompleted, isLoggedInUser: isLoggedInUser, handleUserLogin: handleUserLogin, lessonId: lessonId, onAnswerSubmit: onAnswerSubmit })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $acw62.useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $acw62.useState)([]);
    const [status, setStatus] = (0, $acw62.useState)($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $acw62.useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $acw62.useState)($cb0e8fe57b0fd046$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $acw62.useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $acw62.useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $acw62.useState)({
        lessonId: "",
        step: 0
    });
    const width = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus === $cb0e8fe57b0fd046$export$85e3e62cc743c830.CORRECT && !isCompleted;
    (0, $acw62.useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    // lastSubmittedQuestion.lessonId, onSubmittedQuestionsRecheck, questions.length intentionally excluded
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        lessonId,
        isCompleted
    ]);
    (0, $acw62.useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $acw62.useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $acw62.useEffect)(()=>{
        const isLastCompletedQuestion = status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING, $cb0e8fe57b0fd046$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($cb0e8fe57b0fd046$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($cb0e8fe57b0fd046$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING, $cb0e8fe57b0fd046$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($cb0e8fe57b0fd046$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($cb0e8fe57b0fd046$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const currentQuestion = questions[step];
        if (!currentQuestion?.leftAnswers || !currentQuestion?.rightAnswers) return;
        const leftAnswers = currentQuestion.leftAnswers;
        const rightAnswers = currentQuestion.rightAnswers;
        if (correctAnswersArray.length === leftAnswers.length + rightAnswers.length) {
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $cb0e8fe57b0fd046$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $cb0e8fe57b0fd046$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $cb0e8fe57b0fd046$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS : $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, (/*@__PURE__*/$parcel$interopDefault($71d76b5cdd325006$exports)))(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS : $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789.CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789.INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS) return $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789.DISABLED;
        if (selectedAnswers.includes(answer)) return $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789.SELECTED;
        return $cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizContainerStyles,
        id: "quiz",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c17561cb55d4db30, {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c17561cb55d4db30, {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", questions[step]?.inspectMode),
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$questionImageStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3e431a229df88919, {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $cb0e8fe57b0fd046$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>{
                            const rightAnswer = questions[step]?.rightAnswers?.[index];
                            if (!rightAnswer) return null;
                            return /*#__PURE__*/ (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: rightAnswer.inspectMode,
                                        elementId: rightAnswer.title,
                                        text: rightAnswer.title,
                                        onClick: ()=>toggleAnswer(rightAnswer),
                                        inputStatus: getInputStatus(rightAnswer)
                                    })
                                ]
                            }, leftAnswer.title + rightAnswer.title);
                        })
                    }),
                    (questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>/*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$answerContainerStyles,
                            ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", answer?.inspectMode),
                            children: questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.SINGLE_SELECT ? /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$d7b12c4107be0d61, {
                                size: width >= $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $cb0e8fe57b0fd046$export$4da24539a3bb7d98.LARGE : $cb0e8fe57b0fd046$export$4da24539a3bb7d98.DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : /*#__PURE__*/ (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$48513f6b9f8ce62d, {
                                size: width >= $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $cb0e8fe57b0fd046$export$5e435bc8b081a399.LARGE : $cb0e8fe57b0fd046$export$5e435bc8b081a399.DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: [
                            $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $gyDKM.css)({
                                borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                            label: "Submit answer",
                            appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0
                        })
                    }),
                    (status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING) && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: [
                                $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS && (0, $gyDKM.css)({
                                    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
                                })
                            ],
                            children: [
                                status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f23c56ac9ab316f, {
                                    title: questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING ? "Correct" : "That\u2019s correct",
                                    appearance: $cb0e8fe57b0fd046$export$f9292ef28b7b429a.CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $cb0e8fe57b0fd046$export$51940fbbacba35d4.MATCHING && !isCompleted) && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: (0, $gyDKM.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        disabled: status !== $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.ERROR || status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.PARTLY_CORRECT) && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f23c56ac9ab316f, {
                                    title: status === $cb0e8fe57b0fd046$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That\u2019s partly correct" : "That\u2019s not correct",
                                    appearance: $cb0e8fe57b0fd046$export$f9292ef28b7b429a.INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: (0, $gyDKM.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "Try again",
                                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "refresh"
                                        }),
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f23c56ac9ab316f, {
                    title: "That\u2019s correct",
                    appearance: $cb0e8fe57b0fd046$export$f9292ef28b7b429a.CORRECT
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizContentContainerStyles = (0, $gyDKM.css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        padding: "24px 16px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $gyDKM.css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    flexDirection: "row",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizTitleStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$questionTitleStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$questionImageStyles = (0, $gyDKM.css)({
    padding: "24px 0"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $gyDKM.css)({
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$answerContainerStyles = (0, $gyDKM.css)({
    marginBottom: "24px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "20px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$buttonContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$feedbackContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$questionsStepStyles = (0, $gyDKM.css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$completionMessageStyles = (0, $gyDKM.css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $gyDKM.css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
var $cb0e8fe57b0fd046$var$$9c3f769544bb2079$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$9c3f769544bb2079$exports, "Sidebar", ()=>$cb0e8fe57b0fd046$export$1ba59dacbcbf90fe);
const $cb0e8fe57b0fd046$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility, isVisible: isVisible = true, children: children })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "chevron-left",
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "menu-icon",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        }),
                        isVisible ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: (0, $gyDKM.css)({
                                span: {
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                children: "Close"
                            })
                        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: (0, $gyDKM.css)({
                                span: {
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    isVisible && $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarClosedStyles,
                    $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $gyDKM.css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarStyles = (0, $gyDKM.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarClosedStyles = (0, $gyDKM.css)({
    width: "1.25rem",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$sidebarOpenStyles = (0, $gyDKM.css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.blanket")}`
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $gyDKM.css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        display: "flex"
    }
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $gyDKM.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $gyDKM.css)({
    marginLeft: "25.5rem"
});
const $cb0e8fe57b0fd046$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $gyDKM.css)({
    marginLeft: "0.5rem"
});
var $cb0e8fe57b0fd046$var$$3d76652bb6362040$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3d76652bb6362040$exports, "LearningSidebar", ()=>$cb0e8fe57b0fd046$export$4ff69a78d3a65d6f);
var $cb0e8fe57b0fd046$var$$ef44b01e6346ac17$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $cb0e8fe57b0fd046$var$$ef44b01e6346ac17$var$badge = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2407_668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#FCA700"/>
</mask>
<g mask="url(#mask0_2407_668)">
<path d="M59.9919 120.001C93.129 120.001 119.992 93.1381 119.992 60.001C119.992 26.8639 93.129 0.00100708 59.9919 0.00100708C26.8549 0.00100708 -0.00805664 26.8639 -0.00805664 60.001C-0.00805664 93.1381 26.8549 120.001 59.9919 120.001Z" fill="#F0F1F2"/>
<path d="M114.195 48.5778C139.041 82.736 131.616 130.479 97.5729 155.447L75.6838 125.554C93.1971 112.63 97.0229 88.0317 84.2648 70.3823L114.195 48.5778Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M61.381 -11.1668L61.381 -11.1667L61.3875 -11.1713C66.9496 -15.1726 72.2687 -18.6935 77.3965 -21.8258L116.987 15.9668C109.215 16.5818 99.355 21.2346 85.3825 30.54L85.3825 30.5399L85.3765 30.5441C79.0802 35.0076 73.098 38.8783 67.3602 42.2665L28.6585 5.32281C36.6192 3.90769 46.9288 -1.45355 61.381 -11.1668Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M-4.01227 93.1467L46.5982 80.1918L59.4265 130.835L8.81594 143.79L-4.01227 93.1467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M3.67239 23.827L3.68518 23.7211L3.66478 23.6962C4.43632 16.9412 1.0124 10.0403 -2.57376 4.84886C-4.3803 2.23367 -6.23694 0.0395466 -7.64175 -1.5007C-8.34432 -2.27099 -8.93428 -2.8782 -9.34902 -3.29322C-9.39083 -3.33506 -9.43086 -3.37495 -9.46905 -3.41285L13.9267 -0.587166C22.5213 4.49206 28.577 10.8772 32.2178 18.2212C35.8649 25.5781 37.096 33.9122 36.0121 42.8863C34.4107 56.146 27.9882 65.8687 18.1125 72.3709C8.28951 78.8384 -4.96514 82.1287 -20.3194 82.5128L-15.6409 43.7758C-9.8996 42.5993 -5.41093 40.3431 -2.18767 37.026C1.06994 33.6736 3.01663 29.2565 3.67239 23.827Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M98.1255 59.8467C98.1255 81.1403 81.101 98.3963 60.1074 98.3963C39.1139 98.3963 22.0894 81.1403 22.0894 59.8467C22.0894 38.5531 39.1139 21.2971 60.1074 21.2971C81.101 21.2971 98.1255 38.5531 98.1255 59.8467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M35.4794 65.1887C35.2675 65.5337 35.0269 65.9381 34.84 66.2562C34.66 66.5631 34.7569 66.9575 35.06 67.1444L39.3062 69.765C39.6175 69.9569 40.025 69.8581 40.2106 69.5431C40.3794 69.2575 40.5981 68.89 40.8369 68.495C42.52 65.7175 44.2125 66.0562 47.2619 67.5056L51.4731 69.5075C51.805 69.6656 52.2019 69.5181 52.3512 69.1819L54.3737 64.6156C54.5175 64.2906 54.3762 63.9112 54.055 63.76C53.1656 63.3419 51.3981 62.5075 49.8156 61.7412C44.0656 58.9569 39.2 59.1406 35.48 65.1887H35.4794Z" fill="url(#paint0_linear_2407_668)"/>
<path d="M54.5206 54.8113C54.7325 54.4663 54.9731 54.0619 55.16 53.7438C55.34 53.4369 55.2431 53.0425 54.94 52.8556L50.6938 50.235C50.3825 50.0431 49.975 50.1419 49.7894 50.4569C49.6206 50.7425 49.4019 51.11 49.1631 51.505C47.48 54.2825 45.7875 53.9438 42.7381 52.4944L38.5269 50.4925C38.195 50.3344 37.7981 50.4819 37.6488 50.8181L35.6263 55.3844C35.4825 55.7094 35.6238 56.0888 35.945 56.24C36.8344 56.6581 38.6019 57.4925 40.1844 58.2588C45.9344 61.0431 50.8 60.8594 54.52 54.8113H54.5206Z" fill="url(#paint1_linear_2407_668)"/>
<path d="M85.1263 49.5188H73.8275C73.8275 52.335 76.1106 54.6175 78.9263 54.6175H81.0069V56.6256C81.0069 59.4419 83.29 61.7244 86.1056 61.7244V50.4988C86.1056 49.9575 85.6669 49.5188 85.1256 49.5188H85.1263Z" fill="#1D7AFC"/>
<path d="M79.5345 55.1475H68.2357C68.2357 57.9638 70.5188 60.2463 73.3345 60.2463H75.4151V62.2544C75.4151 65.0706 77.6982 67.3531 80.5138 67.3531V56.1275C80.5138 55.5863 80.0751 55.1475 79.5338 55.1475H79.5345Z" fill="url(#paint2_linear_2407_668)"/>
<path d="M73.9425 60.7756H62.6438C62.6438 63.5919 64.9269 65.8744 67.7425 65.8744H69.8232V67.8825C69.8232 70.6988 72.1063 72.9813 74.9219 72.9813V61.7556C74.9219 61.2144 74.4832 60.7756 73.9419 60.7756H73.9425Z" fill="url(#paint3_linear_2407_668)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2407_668" x1="54.2475" y1="71.11" x2="41.3981" y2="63.7263" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint1_linear_2407_668" x1="35.7519" y1="48.89" x2="48.6019" y2="56.2738" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint2_linear_2407_668" x1="80.2745" y1="55.1663" x2="75.4682" y2="60.1225" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint3_linear_2407_668" x1="75.0019" y1="60.8281" x2="69.445" y2="66.2344" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
</defs>
</svg>`;
const $cb0e8fe57b0fd046$var$$ef44b01e6346ac17$export$44f5f766f3f98994 = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$ef44b01e6346ac17$require$Buffer.from($cb0e8fe57b0fd046$var$$ef44b01e6346ac17$var$badge).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$32c02b5652036d7a$var$SidebarContext = (0, $acw62.createContext)(undefined);
const $cb0e8fe57b0fd046$var$$32c02b5652036d7a$export$861cd542ff836f0d = ()=>{
    const context = (0, $acw62.useContext)($cb0e8fe57b0fd046$var$$32c02b5652036d7a$var$SidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarContextProvider");
    return context;
};
const $cb0e8fe57b0fd046$var$$32c02b5652036d7a$export$d8355e8edbcacbe8 = ({ children: children })=>{
    const [hoverInfo, setHoverInfo] = (0, $acw62.useState)(null);
    const popupRef = (0, $acw62.useRef)(null);
    const lastIdRef = (0, $acw62.useRef)(null);
    const timeoutRef = (0, $acw62.useRef)(null);
    const clear = (0, $acw62.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $acw62.useCallback)((data)=>{
        clear();
        if (lastIdRef.current !== data.courseId) setHoverInfo(null);
        lastIdRef.current = data.courseId;
        timeoutRef.current = setTimeout(()=>{
            if (lastIdRef.current === data.courseId) setHoverInfo(data);
        }, 1000);
    }, [
        clear
    ]);
    const handleMouseLeave = (0, $acw62.useCallback)((id)=>{
        clear();
        if (!id || lastIdRef.current === id) {
            lastIdRef.current = null;
            setHoverInfo(null);
        }
    }, [
        clear
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            hoverInfo: hoverInfo,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            popupRef: popupRef
        }), [
        hoverInfo,
        handleMouseEnter,
        handleMouseLeave
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$32c02b5652036d7a$var$SidebarContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$272e7ef3ea22070d = (status)=>{
    switch(status){
        case $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED:
            return $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED;
        case $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.IN_PROGRESS:
        case $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED:
        default:
            return $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT;
    }
};
const $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d = (courseSlug, lessonSlug, sectionSlug)=>{
    const currentPath = globalThis.location.pathname;
    const currentHash = globalThis.location.hash;
    if (courseSlug) return currentPath.includes(`/course/${courseSlug}`);
    if (sectionSlug === "quiz") return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === "#quiz";
    if (sectionSlug) return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
    if (lessonSlug) {
        const lessonPath = `/lesson/${lessonSlug}`;
        return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + "/");
    }
    return currentHash === `#${sectionSlug}`;
};
const $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$1308f255697e8777 = (lessonsCollection, progressForLessons)=>{
    const numberOfCompletedLessons = lessonsCollection.items.filter(({ sys: { id: id } })=>$cb0e8fe57b0fd046$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status) === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED).length;
    const numberOfTotalLessons = lessonsCollection.items.length;
    const progress = numberOfTotalLessons === 0 ? 0 : numberOfCompletedLessons / numberOfTotalLessons * 100;
    const isStatusCompleted = progress === 100;
    return {
        progress: progress,
        isStatusCompleted: isStatusCompleted
    };
};
const $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f = ({ lessonsCollection: lessonsCollection, progressForLessons: progressForLessons, reward: reward, title: title })=>{
    const { progress: progress, isStatusCompleted: isStatusCompleted } = (0, $acw62.useMemo)(()=>$cb0e8fe57b0fd046$var$$48630d5962798e4a$export$1308f255697e8777(lessonsCollection, progressForLessons), [
        lessonsCollection,
        progressForLessons
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$progressCircleContainerStyles,
        "data-testid": "course-progress-circle",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $59f888d7dcabf163$export$5ab97151efedb8c6), {
                strokeWidth: 8,
                value: progress,
                styles: (0, $59f888d7dcabf163$export$5115a192ad9bf57f)({
                    pathColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success"),
                    trailColor: "rgba(9, 30, 66, 0.14)"
                }),
                css: [
                    isStatusCompleted && $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: [
                        $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles,
                        isStatusCompleted && $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                    ],
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                        css: $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$imageStyles,
                        "data-testid": "course-badge-image",
                        src: reward?.badgeCdnUrl || $cb0e8fe57b0fd046$var$$ef44b01e6346ac17$export$44f5f766f3f98994,
                        alt: title
                    })
                })
            }),
            isStatusCompleted && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                type: "check",
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.success")
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$completedCourseProgressStyles = (0, $gyDKM.css)({
    opacity: "0.2"
});
const $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$progressCircleContainerStyles = (0, $gyDKM.css)({
    position: "relative",
    maxWidth: "32px",
    span: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
const $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$6cca9b298ff547cb$var$imageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
let $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["COURSE"] = "course";
    Appearance["LESSON"] = "lesson";
    Appearance["SECTION"] = "section";
})($cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf || ($cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf = {}));
/**
 * Props for the TextTooltip component
 * @param {string} text - Text to display in the tooltip
 * @param {CardStatus} status - Current status of the item (completed, or default)
 * @param {Appearance} appearance - Whether the item is a course card or lesson card
 * @param {boolean} isSelected - Whether the item is selected
 */ const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH = 650;
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a = ({ text: text, status: status, appearance: appearance, isSelected: isSelected })=>{
    const [isTruncated, setIsTruncated] = (0, $acw62.useState)(false);
    const textRef = (0, $acw62.useRef)(null);
    const deviceSize = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH;
    (0, $acw62.useEffect)(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>{
            window.removeEventListener("resize", checkTruncation);
        };
    }, [
        text
    ]);
    const isLesson = appearance === $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON;
    const isCourse = appearance === $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE;
    const isSection = appearance === $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION;
    const textElement = (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
        "data-testid": "sidebar-text-tooltip",
        ref: textRef,
        css: [
            isCourse && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$courseTitleStyles,
            isCourse && isSelected && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$titleSelectedStyles,
            isLesson && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$lessonTitleStyles,
            isMobile && isLesson && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$regularDecorationStyles,
            isLesson && isSelected && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$titleSelectedStyles,
            $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleStyles,
            isCourse && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$courseMaxWidth,
            isLesson && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$lessonMaxWidth,
            status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleCompletedStyles,
            status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleDefaultStyles,
            isSection && isSelected && $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleSelectedStyles
        ],
        children: text
    });
    return isTruncated ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $3bb76fb59b0ba000$export$2e2bcd8739ae039), {
        content: text,
        position: isMobile ? "bottom" : "right",
        children: textElement
    }) : textElement;
};
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    marginTop: 0,
    marginLeft: "10px",
    maxWidth: "330px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "290px"
    }
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleSelectedStyles = (0, $gyDKM.css)({
    fontWeight: 600,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleCompletedStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$sectionTitleDefaultStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle")
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$lessonTitleStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    marginTop: 0,
    marginRight: "auto",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        textDecoration: "underline"
    }
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$regularDecorationStyles = (0, $gyDKM.css)({
    "&:hover": {
        textDecoration: "none"
    }
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$titleSelectedStyles = (0, $gyDKM.css)({
    fontWeight: "500 !important",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$courseTitleStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    marginTop: 0
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$courseMaxWidth = (0, $gyDKM.css)({
    marginLeft: 0,
    maxWidth: "320px"
});
const $cb0e8fe57b0fd046$var$$47b694880a211b2b$var$lessonMaxWidth = (0, $gyDKM.css)({
    marginLeft: 0,
    marginRight: "auto",
    maxWidth: "290px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "270px"
    }
});
const $cb0e8fe57b0fd046$var$$0efd93166e145c77$export$a3b47b9708ebe4f0 = {
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $cb0e8fe57b0fd046$var$$0efd93166e145c77$export$411533295806dc51 = (sectionContentfulId, seenSectionObserver)=>{
    const element = document.getElementById(`${sectionContentfulId}`);
    if (element) seenSectionObserver.unobserve(element);
};
const $cb0e8fe57b0fd046$var$$0efd93166e145c77$export$a1fd357e7aacc4df = (0, $acw62.memo)(({ section: { title: title, id: id }, status: status, courseSlug: courseSlug, lessonSlug: lessonSlug, onSelect: onSelect, isSelected: isSelected })=>{
    const handleSectionClick = (e)=>{
        e.stopPropagation();
        onSelect(courseSlug || "", lessonSlug, id);
    };
    const handleKeyboardClick = (0, $acw62.useCallback)(()=>{
        onSelect(courseSlug || "", lessonSlug, id);
    }, [
        onSelect,
        courseSlug,
        lessonSlug,
        id
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleKeyboardClick);
    const getIconType = ()=>{
        if (isSelected && status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return $cb0e8fe57b0fd046$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
        if (isSelected) return "dot-selected";
        return $cb0e8fe57b0fd046$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
    };
    const type = getIconType();
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "sidebar-section-item",
        css: [
            $cb0e8fe57b0fd046$var$$0efd93166e145c77$var$sectionBarStyles,
            isSelected && $cb0e8fe57b0fd046$var$$0efd93166e145c77$var$sectionBarSelectedStyles
        ],
        onClick: handleSectionClick,
        onKeyDown: onKeyDown,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                type: type,
                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                text: title,
                status: status,
                isSelected: isSelected,
                appearance: $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION
            })
        ]
    });
});
const $cb0e8fe57b0fd046$var$$0efd93166e145c77$var$sectionBarStyles = (0, $gyDKM.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:active": {
        background: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")} !important`
    },
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $cb0e8fe57b0fd046$var$$0efd93166e145c77$var$sectionBarSelectedStyles = (0, $gyDKM.css)({
    "&::before": {
        content: '""',
        display: "block",
        width: "2px",
        height: "12px",
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        background: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")} !important`
    }
});
const $cb0e8fe57b0fd046$var$$4baed82dabfd5555$var$loadingFlash = (0, $gyDKM.keyframes)`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;
const $cb0e8fe57b0fd046$var$$4baed82dabfd5555$var$skeletonStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(241, 242, 244, 1)",
    borderRadius: "4px",
    position: "relative",
    "&::before": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,
        backgroundSize: "35%",
        backgroundPosition: 0,
        backgroundRepeat: "no-repeat",
        animation: `${$cb0e8fe57b0fd046$var$$4baed82dabfd5555$var$loadingFlash} 2.5s infinite linear`
    }
});
const $cb0e8fe57b0fd046$var$$4baed82dabfd5555$export$27a22c945b52f415 = ()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$4baed82dabfd5555$var$skeletonStyles,
        "data-testid": "skeleton-loader"
    });
const $cb0e8fe57b0fd046$var$$193bb26965d10640$export$9794789a1567361c = (0, $acw62.memo)(()=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$193bb26965d10640$var$loaderContainerStyles,
        children: [
            [
                ...Array(4)
            ].map((_, index)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$193bb26965d10640$var$sectionBarStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$193bb26965d10640$var$skeletonLoaderBarStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                        })
                    ]
                }, index)),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$193bb26965d10640$var$sectionBarStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: "Quiz",
                        status: $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT,
                        isSelected: false
                    })
                ]
            })
        ]
    }));
const $cb0e8fe57b0fd046$var$$193bb26965d10640$var$loaderContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$193bb26965d10640$var$skeletonLoaderBarStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "20px",
    marginLeft: "10px"
});
const $cb0e8fe57b0fd046$var$$193bb26965d10640$var$sectionBarStyles = (0, $gyDKM.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $cb0e8fe57b0fd046$var$$fd3fa057a77982d6$export$1f81c5947c983f13 = (0, $acw62.memo)((props)=>{
    const { lesson: { slug: slug, sectionListCollection: sectionListCollection }, progressForLesson: progressForLesson, isLoading: isLoading, courseSlug: courseSlug, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, isLessonCardExpanded: isLessonCardExpanded, isMobile: isMobile } = props;
    if (isLoading && isLessonCardExpanded) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$193bb26965d10640$export$9794789a1567361c, {});
    if (!isLessonCardExpanded || isMobile) return null;
    const status = $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$fd3fa057a77982d6$var$sectionContainerStyles,
        children: sectionListCollection.items.map((section)=>{
            const sectionStatus = section.id === "quiz" && status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED ? $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED : $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.section.find((sectionProgress)=>sectionProgress.sectionId === section.sys.id)?.status);
            return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0efd93166e145c77$export$a1fd357e7aacc4df, {
                section: section,
                status: sectionStatus,
                onSelect: onSelect,
                lessonSlug: slug,
                courseSlug: courseSlug,
                isSelected: currentLessonSlug === slug && section.sys.id === selectedSectionId
            }, section.id);
        })
    });
});
const $cb0e8fe57b0fd046$var$$fd3fa057a77982d6$var$sectionContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$d1d0f9af78cf2050$export$5496f515fa03c54e = (totalMinutes)=>{
    if (totalMinutes > 59) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) return `${hours} h`;
        return `${hours} h ${minutes} min`;
    }
    return `${totalMinutes} min`;
};
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$db6f237c151666ee = 480;
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0 = {
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$951debaed2d5c034 = (0, $acw62.memo)((props)=>{
    const { lesson: { sys: sys, slug: slug, title: title, duration: duration }, courseSlug: courseSlug, isLoading: isLoading, progressForLesson: progressForLesson, onSelect: onSelect, expandedLessonIds: expandedLessonIds, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, isCourse: isCourse } = props;
    const deviceSize = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$db6f237c151666ee;
    const isSelected = $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d("", slug);
    const status = $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    const [isLessonCardExpanded, setIsLessonCardExpanded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const isExpanded = expandedLessonIds?.includes(sys.id);
        setIsLessonCardExpanded(isExpanded || false);
    }, [
        expandedLessonIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleExpandClick = (e)=>{
        e.stopPropagation();
        setIsLessonCardExpanded(!isLessonCardExpanded);
    };
    const handleCardClick = (0, $acw62.useCallback)(()=>{
        setIsLessonCardExpanded(true);
        onSelect(courseSlug || "", slug);
    }, [
        courseSlug,
        slug,
        onSelect
    ]);
    const handleExpandKeyboard = (0, $acw62.useCallback)(()=>{
        setIsLessonCardExpanded(!isLessonCardExpanded);
    }, [
        isLessonCardExpanded
    ]);
    const onKeyDownCard = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleCardClick);
    const onKeyDownExpand = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleExpandKeyboard);
    const renderStatusIndicator = ()=>{
        if (status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
            type: "check-circle-outline",
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.success")
        });
        return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            css: [
                $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles,
                isSelected && $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles
            ],
            children: $cb0e8fe57b0fd046$var$$d1d0f9af78cf2050$export$5496f515fa03c54e(duration)
        });
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-lesson-card",
        css: [
            $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardStyles,
            isSelected && $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles
        ],
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles,
                    isMobile && $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles,
                    isCourse && isMobile && $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles
                ],
                onClick: handleCardClick,
                onKeyDown: onKeyDownCard,
                children: [
                    !isMobile && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles,
                        onClick: handleExpandClick,
                        onKeyDown: onKeyDownExpand,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: isLessonCardExpanded ? "chevron-down" : "chevron-right",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles,
                        children: renderStatusIndicator()
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$fd3fa057a77982d6$export$1f81c5947c983f13, {
                lesson: props.lesson,
                progressForLesson: progressForLesson,
                isLoading: isLoading,
                courseSlug: courseSlug,
                selectedSectionId: selectedSectionId,
                currentLessonSlug: currentLessonSlug,
                onSelect: onSelect,
                isLessonCardExpanded: isLessonCardExpanded,
                isMobile: isMobile
            })
        ]
    });
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    "&:active": {
        background: "#F1F2F4 !important"
    },
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles = (0, $gyDKM.css)({
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input.hovered"),
    "&:active": {
        background: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input.hovered")} !important`
    }
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles = (0, $gyDKM.css)({
    marginLeft: `calc(${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} + ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")})`
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles = (0, $gyDKM.css)({
    marginLeft: 0
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.pressed")
    }
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral"),
    marginLeft: "auto"
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.brand.subtlest")
});
const $cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles = (0, $gyDKM.css)({
    marginLeft: "auto"
});
const $cb0e8fe57b0fd046$var$$11732cc088354996$export$748c6b3a71d1e268 = (0, $acw62.memo)(()=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            ...Array(4)
        ].map((_, index)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$11732cc088354996$var$lessonCardHeaderStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$11732cc088354996$var$lessonExpanderStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$11732cc088354996$var$skeletonLoaderBarStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$4baed82dabfd5555$export$27a22c945b52f415, {}),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                            })
                        ]
                    })
                ]
            }, index))
    }));
const $cb0e8fe57b0fd046$var$$11732cc088354996$var$lessonCardHeaderStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$11732cc088354996$var$lessonExpanderStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px"
});
const $cb0e8fe57b0fd046$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles = (0, $gyDKM.css)({
    width: "50px",
    height: "20px",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$11732cc088354996$var$skeletonLoaderBarStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "20px",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE = {
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "Completed",
    [$cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "Course"
};
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$CourseCardHeaderContent = ({ isCourseExpanded: isCourseExpanded, isSelected: isSelected, status: status, title: title })=>(0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseExpanderStyles,
                    isCourseExpanded && $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: isCourseExpanded ? "chevron-down" : "chevron-right",
                    color: isCourseExpanded ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.selected") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseTitleContainerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                        css: [
                            $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleStyles,
                            status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles,
                            status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles,
                            isSelected && $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles
                        ],
                        children: isSelected ? "Current course".toUpperCase() : $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE[status].toUpperCase()
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $cb0e8fe57b0fd046$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE
                    })
                ]
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c = (props)=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, popupRef: popupRef } = $cb0e8fe57b0fd046$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const mouseLeaveHandler = (0, $acw62.useCallback)((e, id, courseCardRef)=>{
        const lessonPage = document.getElementById("lesson-page-body");
        const isMovedToSidebar = e.relatedTarget?.tagName === "ASIDE";
        if (!e.relatedTarget || !e.relatedTarget.nodeType || isMovedToSidebar || e.relatedTarget === props.scrollContainerRef.current || lessonPage?.contains(e.relatedTarget)) {
            handleMouseLeave();
            return;
        }
        if (e.currentTarget === courseCardRef.current || e.relatedTarget === popupRef.current) return;
        handleMouseLeave(id);
    }, [
        handleMouseLeave,
        popupRef,
        props.scrollContainerRef
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$aefb4e9d0a694068$export$7b8f328152f30a2c, {
        ...props,
        onHover: handleMouseEnter,
        onMouseLeave: mouseLeaveHandler,
        popupRef: popupRef
    });
};
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$export$7b8f328152f30a2c = (0, $acw62.memo)(({ course: { sys: sys, title: title, reward: reward, slug: slug, lessonsCollection: lessonsCollection }, status: status, isLoading: isLoading, selectedLessonRef: selectedLessonRef, progressForLessons: progressForLessons, onHover: onHover, onMouseLeave: onMouseLeave, onSelect: onSelect, expandedLessonIds: expandedLessonIds = [], expandedCourseIds: expandedCourseIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug })=>{
    const courseCardRef = (0, $acw62.useRef)(null);
    const isSelected = $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d(slug);
    const [isCourseExpanded, setIsCourseExpanded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const isExpanded = expandedCourseIds.includes(sys.id);
        setIsCourseExpanded(isExpanded || false);
    }, [
        expandedCourseIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleCourseCardExpand = (0, $acw62.useCallback)(()=>{
        setIsCourseExpanded(!isCourseExpanded);
        onSelect(slug);
    }, [
        isCourseExpanded,
        onSelect,
        slug
    ]);
    const showCoursePopup = (0, $acw62.useCallback)(()=>{
        if (courseCardRef.current) onHover({
            courseId: sys.id,
            courseCardPosition: courseCardRef.current.getBoundingClientRect()
        });
    }, [
        sys.id,
        onHover
    ]);
    const hideCoursePopup = (0, $acw62.useCallback)((e)=>{
        onMouseLeave(e, sys.id, courseCardRef);
    }, [
        onMouseLeave,
        sys.id,
        courseCardRef
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleCourseCardExpand);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-course-card",
        css: [
            $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardStyles,
            isCourseExpanded && $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardOpenedStyles
        ],
        ref: courseCardRef,
        onMouseEnter: showCoursePopup,
        onMouseLeave: hideCoursePopup,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardHeaderStyles,
                    isCourseExpanded && $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles
                ],
                onClick: handleCourseCardExpand,
                onKeyDown: onKeyDown,
                onMouseEnter: showCoursePopup,
                "data-testid": "course-card-header",
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$CourseCardHeaderContent, {
                        isCourseExpanded: isCourseExpanded,
                        isSelected: isSelected,
                        status: status,
                        title: title
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f, {
                        lessonsCollection: lessonsCollection,
                        progressForLessons: progressForLessons,
                        reward: reward,
                        title: title
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$lessonContainerStyles,
                onMouseEnter: hideCoursePopup,
                children: isLoading && isCourseExpanded ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$11732cc088354996$export$748c6b3a71d1e268, {}) : isCourseExpanded && lessonsCollection.items.map((lesson)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        ref: $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                            lesson: lesson,
                            courseSlug: slug,
                            progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                            onSelect: onSelect,
                            isLoading: isLoading,
                            expandedLessonIds: expandedLessonIds,
                            selectedSectionId: selectedSectionId,
                            currentLessonSlug: currentLessonSlug
                        })
                    }, lesson.sys.id))
            })
        ]
    });
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardOpenedStyles = (0, $gyDKM.css)({
    paddingBottom: 0,
    "&:hover": {
        background: "none"
    }
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardHeaderStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseExpanderStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")}`,
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles = (0, $gyDKM.css)({
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.blue.subtler")}`
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseTitleContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    marginRight: "auto"
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px"
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.success")
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $cb0e8fe57b0fd046$var$$aefb4e9d0a694068$var$lessonContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
var $cb0e8fe57b0fd046$var$$e48fba9cf5395297$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $cb0e8fe57b0fd046$var$$e48fba9cf5395297$var$courseBg = `<svg width="419" height="16" viewBox="0 0 419 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_550_14457)">
<rect width="419" height="16" fill="#CCE0FF"/>
<g clipPath="url(#clip1_550_14457)">
<path d="M419.987 -18.5349C419.996 -18.6007 420.003 -18.6684 420.014 -18.7323C420.032 -18.7947 420.048 -18.8548 420.064 -18.915C420.099 -19.0356 420.114 -19.1585 420.159 -19.2632C420.248 -19.4786 420.309 -19.6895 420.416 -19.8625C420.463 -19.9546 420.508 -20.0404 420.551 -20.1238C420.603 -20.2039 420.653 -20.2775 420.702 -20.3488C420.75 -20.4201 420.79 -20.4949 420.836 -20.5598C420.888 -20.6209 420.931 -20.6813 420.974 -20.7375C421.14 -20.9764 421.288 -21.1424 421.37 -21.2817C421.452 -21.421 421.479 -21.522 421.443 -21.5797C421.407 -21.6374 421.307 -21.6518 421.142 -21.6124C420.978 -21.5729 420.733 -21.4929 420.458 -21.2992C420.387 -21.251 420.313 -21.2006 420.234 -21.1476C420.159 -21.0907 420.086 -21.0172 420.006 -20.9452C419.928 -20.8714 419.847 -20.793 419.762 -20.7101C419.686 -20.6195 419.613 -20.5188 419.533 -20.4154C419.364 -20.214 419.244 -19.956 419.102 -19.6814C419.032 -19.5431 418.992 -19.3907 418.936 -19.2369C418.91 -19.159 418.885 -19.0793 418.86 -18.9995C418.838 -18.9178 418.826 -18.835 418.809 -18.7495C418.615 -17.7843 418.69 -16.8131 418.876 -15.8955C419.059 -14.9692 419.392 -14.1022 419.756 -13.244C419.947 -12.82 420.142 -12.3941 420.364 -11.9832C420.574 -11.563 420.81 -11.1596 421.049 -10.7501L421.231 -10.4386C421.302 -10.321 421.379 -10.2101 421.453 -10.1053C421.527 -10.0006 421.606 -9.89614 421.681 -9.80195L421.834 -9.60333C421.861 -9.56574 421.887 -9.52816 421.909 -9.49438C421.917 -9.47618 421.939 -9.45715 421.93 -9.44167L421.87 -9.4071L421.756 -9.34475C421.555 -9.2203 421.349 -9.09548 421.146 -8.96877C420.732 -8.71463 420.314 -8.45596 419.889 -8.19466C419.043 -7.67017 418.178 -7.13781 417.292 -6.58888C415.522 -5.48495 413.666 -4.32951 411.701 -3.10375C411.569 -3.02103 411.438 -2.9383 411.311 -2.85594L411.263 -2.82245C411.247 -2.81267 411.23 -2.79231 411.213 -2.79503L411.176 -2.83796L411.129 -2.89683C411.053 -2.99935 410.979 -3.09997 410.908 -3.19868C410.748 -3.42193 410.595 -3.64364 410.445 -3.8657C409.853 -4.75016 409.317 -5.59122 408.833 -6.35712C407.867 -7.87642 407.139 -9.19183 406.523 -10.4477C405.911 -11.704 405.395 -12.8909 404.961 -14.1983C404.532 -15.5018 404.156 -16.9191 403.941 -18.6294C403.764 -20.0724 403.734 -21.6582 403.948 -23.2902C404.067 -24.102 404.224 -24.9319 404.485 -25.7435C404.596 -26.156 404.761 -26.5543 404.909 -26.9594C405.08 -27.3562 405.245 -27.7586 405.453 -28.1438C405.847 -28.925 406.311 -29.6786 406.85 -30.3841C407.385 -31.0935 407.973 -31.7656 408.624 -32.3738C408.936 -32.6905 409.287 -32.9706 409.619 -33.2637C409.969 -33.5374 410.311 -33.821 410.678 -34.0689C411.033 -34.3347 411.41 -34.5667 411.777 -34.8021C412.152 -35.0318 412.539 -35.2437 412.914 -35.465C414.436 -36.3062 415.99 -36.9507 417.497 -37.3604C419.003 -37.7742 420.458 -37.9529 421.776 -37.9727C423.096 -37.9948 424.276 -37.8642 425.269 -37.709C426.262 -37.5579 427.07 -37.3657 427.646 -37.233L428.69 -36.9731C429.045 -36.8906 429.419 -36.816 429.771 -36.7438C430.378 -36.6242 431.227 -36.4356 432.428 -36.2523C433.028 -36.1615 433.721 -36.0769 434.532 -36.0632C435.339 -36.0534 436.29 -36.1149 437.298 -36.4729C437.804 -36.6385 438.302 -36.8957 438.794 -37.2048C439.033 -37.3787 439.288 -37.5351 439.516 -37.7605C439.63 -37.869 439.756 -37.968 439.863 -38.0906C439.969 -38.2173 440.076 -38.3441 440.183 -38.4708C440.585 -39.0093 440.922 -39.6533 441.087 -40.36C441.245 -41.0619 441.295 -41.8006 441.211 -42.5236C441.061 -43.9793 440.534 -45.3835 439.853 -46.7869C439.509 -47.4894 439.114 -48.1853 438.684 -48.8866C438.47 -49.2437 438.255 -49.5754 438.036 -49.9299C437.987 -50.0054 437.941 -50.0791 437.892 -50.1546L437.861 -50.2043C437.876 -50.2183 437.894 -50.2303 437.914 -50.2446C437.836 -50.198 438.202 -50.4311 438.461 -50.5962C439.016 -50.9486 439.658 -51.3547 440.372 -51.809C441.803 -52.7114 443.524 -53.7985 445.425 -54.9977C446.336 -55.5719 447.291 -56.1709 448.275 -56.789L448.326 -56.8229C448.342 -56.8285 448.363 -56.8575 448.374 -56.8291L448.412 -56.782L448.504 -56.6579C448.854 -56.1741 449.194 -55.6643 449.531 -55.1417C449.866 -54.6085 450.202 -54.0711 450.54 -53.5318C450.86 -52.9887 451.204 -52.4562 451.506 -51.9012C452.14 -50.8042 452.697 -49.6712 453.218 -48.5372C454.609 -45.4748 455.414 -42.5189 455.622 -39.8407C455.835 -37.1587 455.451 -34.7733 454.708 -32.833C453.969 -30.8848 452.931 -29.3702 451.906 -28.2006C450.869 -27.0365 449.854 -26.1974 448.994 -25.5647C448.74 -25.3769 448.489 -25.1936 448.225 -25.0259C447.964 -24.8543 447.711 -24.6813 447.441 -24.5299C447.177 -24.3728 446.912 -24.2175 446.652 -24.0608C446.391 -23.9059 446.118 -23.7795 445.858 -23.6394C445.335 -23.3486 444.792 -23.1336 444.267 -22.8909C444.001 -22.7819 443.73 -22.6891 443.467 -22.5865L443.07 -22.4368L442.67 -22.3139C441.607 -21.9637 440.54 -21.7558 439.49 -21.6187C438.439 -21.4751 437.397 -21.4582 436.377 -21.4936C435.354 -21.5266 434.349 -21.6452 433.361 -21.7966C432.866 -21.869 432.377 -21.9631 431.889 -22.0529C431.396 -22.1508 430.914 -22.258 430.418 -22.3472C429.434 -22.5326 428.468 -22.7237 427.477 -22.8686C426.491 -23.014 425.476 -23.1064 424.439 -23.0396C423.318 -22.955 422.489 -22.6083 422.02 -22.2885C421.775 -22.1351 421.62 -21.979 421.526 -21.8617C421.431 -21.7444 421.396 -21.6575 421.422 -21.6051L421.393 -21.4788C421.408 -21.4697 421.421 -21.4749 421.419 -21.4957L421.417 -21.6089L421.441 -21.5816C421.478 -21.5345 421.572 -21.5216 421.717 -21.5384C421.86 -21.5571 422.053 -21.6116 422.306 -21.665C422.804 -21.7878 423.52 -21.9506 424.501 -21.9791C426.333 -22.0036 428.217 -21.4933 430.151 -21.0651C432.069 -20.5956 434.122 -20.121 436.309 -19.9979C437.401 -19.9331 438.53 -19.9303 439.679 -20.0655C440.824 -20.1921 441.997 -20.4071 443.155 -20.7739L443.593 -20.9042L444.026 -21.0614C444.313 -21.168 444.608 -21.2671 444.896 -21.3844C445.464 -21.6371 446.054 -21.8709 446.616 -22.1755C446.899 -22.3238 447.191 -22.4604 447.471 -22.6231C447.751 -22.7858 448.03 -22.9527 448.316 -23.1181C448.602 -23.2793 448.877 -23.4647 449.157 -23.6505C449.44 -23.8303 449.714 -24.0282 449.988 -24.2304C450.841 -24.8582 451.905 -25.7016 453.021 -26.8957C453.309 -27.1871 453.571 -27.5225 453.863 -27.8605C454.004 -28.0321 454.137 -28.2178 454.276 -28.4019C454.418 -28.5841 454.554 -28.7744 454.686 -28.9767C455.233 -29.7648 455.74 -30.6669 456.174 -31.6739C457.054 -33.6806 457.614 -36.1379 457.566 -38.8279C457.534 -41.5171 456.936 -44.407 455.846 -47.313C455.131 -49.2086 454.232 -51.0191 453.22 -52.7275C453 -53.1092 452.768 -53.4857 452.531 -53.8595C452.294 -54.2398 452.058 -54.6159 451.817 -54.9852C451.333 -55.728 450.844 -56.4872 450.306 -57.24C450.171 -57.4276 450.035 -57.6151 449.893 -57.8043C449.653 -58.1255 449.383 -58.4567 449.123 -58.7678L448.927 -59.0067L448.828 -59.1241L448.779 -59.1849L448.713 -59.1435L448.187 -58.821L447.222 -58.2106C446.463 -57.721 445.702 -57.2332 444.944 -56.7458C443.425 -55.7748 441.918 -54.8133 440.448 -53.8739C438.753 -52.7996 437.104 -51.7523 435.527 -50.7531C435.991 -50.0108 436.451 -49.2806 436.903 -48.5602C437.066 -48.3037 437.217 -48.0566 437.362 -47.8111C437.505 -47.5633 437.664 -47.3253 437.793 -47.0784C438.349 -46.1047 438.792 -45.1297 439.105 -44.1938C439.417 -43.2556 439.58 -42.3464 439.535 -41.5453C439.493 -40.7422 439.25 -40.0623 438.851 -39.5598C438.46 -39.0496 437.954 -38.691 437.475 -38.4375C436.995 -38.1882 436.554 -38.0451 436.181 -37.9645C435.996 -37.9233 435.825 -37.9043 435.679 -37.8769C435.529 -37.8639 435.404 -37.8531 435.302 -37.8421C435.2 -37.8312 435.122 -37.8308 435.068 -37.8302C435.013 -37.8297 434.988 -37.8275 434.988 -37.8275C434.988 -37.8275 434.871 -37.8258 434.651 -37.8214C434.54 -37.8264 434.399 -37.8289 434.237 -37.8337C434.073 -37.8405 433.88 -37.8594 433.667 -37.8766C432.801 -37.959 431.531 -38.193 429.936 -38.5373C429.151 -38.6875 428.292 -38.9299 427.33 -39.1213C426.369 -39.3108 425.335 -39.5003 424.228 -39.5889C423.123 -39.684 421.952 -39.7105 420.741 -39.6161C419.533 -39.5114 418.291 -39.2883 417.058 -38.9422C415.82 -38.5999 414.613 -38.0966 413.43 -37.5304C412.848 -37.2281 412.256 -36.9335 411.697 -36.5849C411.125 -36.2584 410.565 -35.8951 410.019 -35.512C407.837 -33.9779 405.925 -31.9888 404.62 -29.7209C403.3 -27.462 402.621 -24.9776 402.422 -22.6921C402.327 -21.5467 402.342 -20.4485 402.416 -19.4205C402.469 -18.9089 402.508 -18.4129 402.588 -17.9394C402.625 -17.7034 402.656 -17.469 402.697 -17.2417C402.742 -17.0148 402.786 -16.792 402.83 -16.5776C403.106 -15.2754 403.444 -14.0752 403.836 -12.9845C404.024 -12.4364 404.237 -11.9177 404.431 -11.4142C404.65 -10.9212 404.839 -10.434 405.058 -9.98298C405.906 -8.16173 406.754 -6.6679 407.532 -5.40717C408.303 -4.16047 408.956 -3.11338 409.589 -2.21778C409.677 -2.09742 409.763 -1.97896 409.846 -1.8624C409.972 -1.69494 410.097 -1.53165 410.231 -1.36908C410.364 -1.21067 410.493 -1.0519 410.619 -0.899205C410.683 -0.822855 410.748 -0.748768 410.811 -0.672419C410.838 -0.607579 410.885 -0.664166 410.925 -0.684437L411.049 -0.758101C411.375 -0.947891 411.688 -1.14077 411.994 -1.33518C412.199 -1.46416 412.396 -1.58825 412.583 -1.70518C414.541 -2.94081 416.392 -4.10837 418.154 -5.22217C419.034 -5.78098 419.891 -6.32738 420.73 -6.86175C421.15 -7.13101 421.563 -7.39348 421.975 -7.65786C422.182 -7.7891 422.388 -7.9245 422.593 -8.05348L423.1 -8.37651L423.351 -8.53671L423.58 -8.69928L424.035 -9.02403L424.063 -9.04323L424.074 -9.05681C424.074 -9.05681 424.071 -9.06287 424.069 -9.06894L424.03 -9.12852L423.95 -9.24961L423.794 -9.48571C423.591 -9.79544 423.369 -10.1056 423.118 -10.405L422.846 -10.7381L422.646 -10.9914C422.584 -11.0742 422.525 -11.1592 422.472 -11.2385L422.296 -11.5213C422.062 -11.9038 421.823 -12.2818 421.616 -12.6688C421.392 -13.0502 421.203 -13.4408 421.015 -13.8274C420.658 -14.6063 420.324 -15.3894 420.137 -16.1874C419.943 -16.9804 419.861 -17.7833 419.977 -18.536L419.987 -18.5349Z" fill="#0055CC"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#0055CC"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#0055CC"/>
<path d="M384.78 4.00317C387.938 3.20902 387.727 2.24328 384.526 2.8355C382.254 3.25484 379.932 3.70159 377.414 4.2115C376.157 4.47157 374.85 4.74014 373.477 5.02282C372.791 5.16832 372.086 5.31754 371.367 5.47009L371.218 5.49975C371.197 5.50156 371.166 5.52111 371.163 5.48779C371.092 5.3198 371.022 5.14955 370.951 4.97739C369.623 1.76683 368.946 -0.312608 368.381 -2.12056C367.842 -3.9371 367.411 -5.50071 367.051 -7.83206C366.893 -8.815 366.773 -9.88939 366.688 -11.0193C366.622 -12.1487 366.576 -13.3344 366.64 -14.536C366.704 -15.7375 366.819 -16.9582 367.064 -18.1397C367.308 -19.3212 367.637 -20.4743 368.076 -21.5384C368.18 -21.8056 368.312 -22.0583 368.428 -22.3159C368.488 -22.4429 368.547 -22.5717 368.605 -22.6964C368.676 -22.8221 368.743 -22.9475 368.812 -23.071C369.086 -23.5669 369.355 -24.0518 369.614 -24.5212C369.889 -24.9814 370.184 -25.4057 370.452 -25.8255C370.59 -26.0304 370.716 -26.2407 370.855 -26.4332C371 -26.62 371.14 -26.8041 371.278 -26.9818C371.556 -27.3353 371.803 -27.6799 372.06 -27.9813C372.327 -28.2708 372.576 -28.5442 372.802 -28.7905C373.238 -29.3046 373.671 -29.64 373.952 -29.9099L374.459 -30.3798L375.001 -30.8128C375.161 -30.9442 375.356 -31.1016 375.579 -31.2847C375.688 -31.3822 375.817 -31.471 375.954 -31.5606C376.091 -31.6542 376.237 -31.7509 376.39 -31.8543C376.986 -32.2879 377.767 -32.7207 378.666 -33.1973C380.483 -34.1269 382.926 -34.9702 385.749 -35.687C386.452 -35.8718 387.182 -36.0463 387.929 -36.2181C388.673 -36.3959 389.442 -36.5611 390.222 -36.7357C390.745 -36.8524 391.276 -36.9698 391.811 -37.0875C391.827 -37.0973 391.829 -37.0806 391.834 -37.0685L391.843 -37.0295L391.877 -36.8813C391.965 -36.4755 392.052 -36.0698 392.138 -35.6618C392.826 -32.3978 393.535 -29.0517 394.215 -25.8333C394.699 -23.5608 395.138 -21.507 395.533 -19.657C395.709 -18.833 395.874 -18.0563 396.03 -17.3228L396.047 -17.2508C396.046 -17.2319 396.008 -17.237 395.99 -17.2291C395.759 -17.1839 395.532 -17.139 395.315 -17.0972C393.858 -16.8198 392.563 -16.5564 391.456 -16.2549C390.349 -15.9574 389.427 -15.6237 388.695 -15.2811C387.829 -14.8809 387.014 -14.3843 386.312 -13.7653C385.606 -13.1501 385.025 -12.4137 384.602 -11.6258C384.182 -10.8319 383.945 -10.0036 383.788 -9.19684C383.737 -8.79165 383.662 -8.39072 383.656 -7.99783C383.648 -7.79989 383.64 -7.60612 383.631 -7.41235C383.631 -7.2193 383.643 -7.02734 383.649 -6.83691C383.805 -3.79328 384.714 -1.22835 385.709 1.20748C386.262 2.50247 386.762 3.06972 386.983 3.0044L386.993 2.90906C386.995 2.92988 387.006 2.93939 387.029 2.93532L387.023 2.9883C387.233 2.86729 387.157 2.12695 386.709 0.831265C385.907 -1.60452 385.185 -4.13535 385.149 -6.8662C385.149 -7.03616 385.145 -7.20576 385.149 -7.37608C385.164 -7.54521 385.174 -7.71399 385.187 -7.88504C385.199 -8.2302 385.278 -8.56223 385.326 -8.90422C385.476 -9.57396 385.682 -10.2423 386.022 -10.8571C386.365 -11.4682 386.82 -12.0321 387.389 -12.52C387.957 -13.0078 388.635 -13.4232 389.39 -13.7698C389.972 -14.0448 390.76 -14.3208 391.748 -14.5722C392.735 -14.8236 393.919 -15.0374 395.292 -15.2697C395.66 -15.3352 396.039 -15.3995 396.429 -15.469C396.772 -15.5364 397.118 -15.6043 397.469 -15.6724C397.646 -15.7088 397.826 -15.7432 398.003 -15.7796L398.137 -15.8059L398.206 -15.8181C398.206 -15.8181 398.218 -15.8192 398.222 -15.8237L398.22 -15.8404L398.213 -15.8733L398.161 -16.1416C397.961 -17.1481 397.754 -18.2066 397.532 -19.3163C397.2 -21.0059 396.833 -22.8478 396.421 -24.8327C396.152 -26.1249 395.86 -27.4132 395.553 -28.6874C394.886 -31.4349 394.198 -34.3926 393.546 -37.2862L393.341 -38.2231L393.235 -38.7028L393.183 -38.9396L393.156 -39.0589C393.152 -39.0775 393.15 -39.1025 393.141 -39.1143L393.079 -39.1005C392.467 -38.9657 391.858 -38.8289 391.251 -38.6944C390.541 -38.5343 389.839 -38.3748 389.149 -38.2206C387.771 -37.9081 386.435 -37.6014 385.194 -37.2777C382.705 -36.6507 380.584 -35.9233 379.116 -35.303C378.753 -35.1373 378.426 -34.9872 378.141 -34.8597C377.997 -34.7948 377.866 -34.7352 377.745 -34.6785C377.627 -34.6158 377.521 -34.5583 377.422 -34.5058C377.038 -34.2962 376.829 -34.1816 376.829 -34.1816C376.829 -34.1816 376.751 -34.1391 376.605 -34.0572C376.459 -33.9712 376.233 -33.8676 375.972 -33.6855C375.704 -33.5091 375.379 -33.2921 374.999 -33.0431C374.904 -32.9803 374.807 -32.9152 374.705 -32.8498C374.611 -32.7744 374.511 -32.6965 374.413 -32.6167C374.213 -32.4566 373.998 -32.2891 373.775 -32.1102C373.313 -31.7722 372.875 -31.3252 372.39 -30.8677C371.887 -30.4254 371.447 -29.8606 370.947 -29.3074C370.689 -29.0333 370.468 -28.7245 370.238 -28.4087C370.006 -28.097 369.77 -27.7743 369.529 -27.4513C369.295 -27.1226 369.093 -26.7673 368.869 -26.4185C368.652 -26.0639 368.416 -25.714 368.211 -25.3458C368.012 -24.9719 367.81 -24.5935 367.61 -24.2131C367.412 -23.8267 367.19 -23.4612 367.018 -23.0414C366.838 -22.6334 366.644 -22.2242 366.501 -21.7963L366.27 -21.1595C366.194 -20.9452 366.142 -20.7266 366.076 -20.5111C365.569 -18.7781 365.306 -16.9907 365.209 -15.2722C365.017 -11.8291 365.44 -8.6765 365.857 -6.37103C366.505 -2.89797 367.285 -0.399449 367.899 1.48819C368.53 3.37439 369.032 4.64646 369.43 5.61072C369.519 5.81702 369.604 6.02368 369.693 6.2258C369.821 6.52311 369.954 6.82006 370.092 7.11438L370.193 7.33434L370.219 7.39085C370.227 7.40905 370.255 7.38986 370.274 7.39032L370.391 7.36545L370.861 7.27014C371.154 7.20702 371.444 7.142 371.732 7.07923C372.451 6.91835 373.155 6.76081 373.838 6.60923C375.206 6.2955 376.507 5.99813 377.757 5.70926C380.258 5.1232 382.558 4.56506 384.799 4.00364L384.78 4.00317Z" fill="#0055CC"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#0055CC"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#0055CC"/>
<path d="M334.463 4.55043C336.378 5.19855 337.423 5.25896 337.511 5.00382C337.601 4.73999 336.74 4.16631 334.878 3.42756C332.352 2.4169 329.793 1.33152 327.049 0.0860085C325.677 -0.537881 324.262 -1.20208 322.786 -1.9218C322.048 -2.27958 321.294 -2.65483 320.524 -3.0434C320.14 -3.23882 319.751 -3.43804 319.356 -3.63881C318.73 -3.96432 318.098 -4.29136 317.454 -4.62376C317.2 -4.26182 316.851 -3.76363 316.498 -3.26091C311.509 3.94463 310.444 5.82257 307.026 10.6636C306.168 11.8815 305.22 13.2247 304.201 14.6706C303.026 16.3251 301.771 18.0936 300.448 19.9519C301.609 20.5878 302.784 21.2287 303.958 21.8718C304.893 22.372 305.832 22.8676 306.756 23.3477C308.612 24.3052 310.431 25.205 312.103 26.0043C315.451 27.6025 318.222 28.8038 319.543 29.3586C320.099 29.5979 320.659 29.8221 321.228 30.0372C323.093 30.7483 327.879 32.5744 334.242 34.4547C337.42 35.4003 340.99 36.3582 344.761 37.2378C346.647 37.6765 348.582 38.0984 350.545 38.4927C351.525 38.691 352.513 38.8802 353.502 39.0631L354.99 39.3328L357.469 39.7599C357.512 39.07 357.618 37.3781 357.721 35.7073C358.398 24.2427 358.818 17.1478 359.038 13.4422C359.115 12.0821 359.191 10.7663 359.248 9.79823C358.525 9.66157 357.813 9.53027 357.113 9.39788C356.669 9.31047 356.23 9.22686 355.799 9.14253C354.934 8.97197 354.095 8.79926 353.278 8.62663C351.643 8.27947 350.096 7.92473 348.607 7.5691C345.63 6.85142 342.892 6.12149 340.191 5.33379C338.504 4.8422 337.595 4.76987 337.515 5.00346C337.437 5.2242 338.192 5.75466 339.861 6.35065C342.533 7.3025 345.259 8.16562 348.242 8.98554C349.733 9.39341 351.289 9.78944 352.935 10.1692C353.757 10.3623 354.602 10.5471 355.474 10.7317C356.136 10.8674 356.819 11.0054 357.52 11.1503C357.485 11.7346 357.434 12.53 357.383 13.3486C357.181 16.7484 356.524 23.8218 355.888 33.8225C355.843 34.6301 355.797 35.4335 355.753 36.2389L355.697 37.4438C355.695 37.5154 355.695 37.4881 355.696 37.4965L355.7 37.5003L355.703 37.5147L355.713 37.5495C355.713 37.5495 355.699 37.557 355.686 37.5581C355.653 37.5568 355.753 37.5796 355.443 37.531C355.007 37.4618 354.566 37.3929 354.124 37.3222C353.241 37.1784 352.344 37.0274 351.449 36.8616C349.654 36.5388 347.844 36.1754 346.062 35.7822C342.497 35.0064 339.05 34.105 336.046 33.2324C333.043 32.3575 330.487 31.5175 328.681 30.8914C327.778 30.573 327.064 30.3202 326.573 30.1467C326.083 29.9667 325.818 29.8679 325.818 29.8679C321.699 28.3744 317.646 26.7051 313.653 24.9006C311.657 23.9951 309.679 23.0545 307.719 22.0746C306.741 21.5844 305.762 21.086 304.793 20.5804L303.34 19.8146L302.638 19.4369L309.085 10.2354C314.014 3.19241 316.386 -0.198335 317.845 -2.28244C317.896 -2.35604 317.946 -2.42965 317.981 -2.48098C318.602 -2.1676 319.205 -1.86528 319.791 -1.56985C320.573 -1.18236 321.337 -0.814252 322.09 -0.459821C323.592 0.247136 325.035 0.892152 326.437 1.484C329.24 2.67411 331.869 3.66742 334.463 4.55459L334.463 4.55043Z" fill="#0055CC"/>
<path d="M266.148 11.4376C265.904 11.2409 261.607 11.6971 262.767 12.4216C263.152 12.7387 263.531 12.7338 263.685 12.3129C263.756 13.1539 264.635 12.0998 265.004 12.398C264.83 12.9693 266.069 11.8381 265.807 12.4269C270.358 13.3708 279.961 8.37317 268.469 10.984C269.573 11.3221 268.502 11.4792 268.006 11.3161C268.775 10.623 266.63 11.1225 266.225 11.3523C266.878 11.3825 265.768 11.8563 266.15 11.4397L266.148 11.4376Z" fill="#101214"/>
<path d="M272.605 3.22316C273.458 2.36056 274.245 3.76267 275.035 3.06913C276.28 1.68993 267.453 -0.414982 267.475 1.23096C267.685 2.6437 272.067 2.52666 272.605 3.22316Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_550_14457)">
<path d="M13.0459 7.94648C13.2244 7.80301 13.375 7.65148 13.5135 7.50519C13.6519 7.3589 13.7767 7.22429 13.8912 7.09266C14.1165 6.83394 14.2962 6.60644 14.4242 6.41279C14.6826 6.0274 14.7534 5.77787 14.657 5.68132C14.5605 5.58477 14.2987 5.63893 13.898 5.85831C13.6977 5.968 13.4612 6.12069 13.1927 6.31602C13.0586 6.41577 12.9146 6.52266 12.7657 6.64468C12.6168 6.7667 12.4583 6.90004 12.2783 7.02685C11.7797 7.3995 11.2791 7.7744 10.7705 8.1542C10.2398 8.49606 9.70493 8.83827 9.16244 9.18954C8.60947 9.51654 8.02636 9.81049 7.44957 10.1291C7.15404 10.2785 6.84575 10.4017 6.5389 10.5416C6.23133 10.6732 5.92782 10.8275 5.60858 10.9454C5.28898 11.0591 4.96332 11.1755 4.63765 11.2918C4.47464 11.3479 4.31044 11.4146 4.1448 11.4646C3.97464 11.5109 3.80449 11.5571 3.63433 11.6033C3.29175 11.6939 2.94835 11.7992 2.59636 11.8779C2.24139 11.9465 1.88225 12.0154 1.51931 12.0888C0.0606176 12.3264 -1.49813 12.4259 -3.12925 12.2945C-3.56103 12.2753 -3.97141 12.2123 -4.35537 12.1637C-4.54794 12.1447 -4.73171 12.1061 -4.90643 12.0751C-4.9938 12.0596 -5.08116 12.0441 -5.16436 12.0282C-5.22411 12.0166 -5.28576 12.0072 -5.34551 11.9956C-5.43287 11.9801 -5.5081 11.9594 -5.58713 11.9432C-6.21656 11.7732 -6.77491 11.6244 -7.25162 11.4978C-7.70977 11.3676 -8.08591 11.2638 -8.36563 11.1831C-8.05452 12.2599 -7.73595 13.2771 -7.45896 14.2015C-7.28585 14.7489 -7.12621 15.2617 -6.97515 15.748C-6.68674 16.6588 -6.42815 17.4673 -6.18005 18.2515C-5.68384 19.8199 -5.22994 21.2871 -4.66961 23.2339C-4.04204 25.3764 -3.32537 27.8951 -2.58721 30.5168C-2.22004 31.83 -1.84428 33.1696 -1.4715 34.4991C-1.25363 35.2733 -1.04029 36.0438 -0.825398 36.8078C-0.802628 36.8772 -0.789367 36.9578 -0.758627 37.0223L-0.551516 37.0883L-0.137285 37.2202L0.276945 37.3522L0.53893 37.4218C0.71283 37.4676 0.884474 37.5114 1.05837 37.5572C1.23346 37.5924 1.40628 37.6257 1.57946 37.6631C4.36235 38.2066 7.04848 37.8962 9.14027 37.3602C9.66062 37.2144 10.1485 37.0567 10.6086 36.9182C11.0609 36.7615 11.4697 36.5876 11.8496 36.4434C12.2341 36.3031 12.5622 36.1425 12.8562 35.9995C13.1502 35.8565 13.4062 35.7357 13.6198 35.6332C13.8785 35.5185 14.1157 35.3742 14.3552 35.2317L15.0752 34.7979C15.254 34.6817 15.4828 34.5611 15.7156 34.3899C15.9507 34.2205 16.2176 34.0316 16.5119 33.8194C16.8017 33.6033 17.1399 33.3894 17.4667 33.1155C17.7957 32.8436 18.1502 32.5506 18.5283 32.2388C18.716 32.0798 18.9169 31.9281 19.1073 31.7521C19.2955 31.5743 19.4897 31.3938 19.6897 31.2065C20.0835 30.8345 20.499 30.446 20.9358 30.0368C21.3513 29.6482 21.7823 29.2458 22.2305 28.8229C22.6881 28.4119 23.1922 28.0283 23.6952 27.6091C23.943 27.3925 24.219 27.2112 24.4958 27.0152C24.7708 26.8214 25.0517 26.625 25.3346 26.4263C25.4725 26.322 25.6221 26.2314 25.772 26.145C25.9215 26.0544 26.0733 25.9657 26.2248 25.8728C26.5303 25.6932 26.8325 25.4991 27.1493 25.329C28.4302 24.6598 29.8119 24.0406 31.3018 23.6052C32.7947 23.1799 34.3762 22.9064 36.0024 22.8599C36.8156 22.8251 37.6359 22.8736 38.4607 22.9489L39.0913 23.0348L39.4056 23.0789L40.0042 23.2075C40.8225 23.3779 41.6365 23.5717 42.4509 23.7697C42.1544 22.74 41.401 20.1363 40.667 17.5876C37.7264 7.53183 35.9053 1.30688 34.9535 -1.94261C34.9552 -2.23861 34.6651 -2.19668 34.4682 -2.26564C34.2584 -2.3146 34.0485 -2.36355 33.8387 -2.41251L33.6803 -2.44913C33.6311 -2.45956 33.6141 -2.46227 33.5778 -2.46961L33.3902 -2.50372L33.0173 -2.57001C32.7696 -2.61988 32.5206 -2.63607 32.2744 -2.66928L31.9055 -2.71284L31.5408 -2.73367C30.5668 -2.81081 29.6218 -2.74779 28.7074 -2.67062C26.8858 -2.45607 25.2051 -1.99564 23.6927 -1.35886C23.3041 -1.21817 22.9496 -1.02168 22.5817 -0.859698C22.4004 -0.772642 22.2187 -0.689742 22.0393 -0.604949C21.8648 -0.512183 21.6929 -0.413354 21.5206 -0.318686C21.1787 -0.123287 20.8406 0.0675779 20.5024 0.258452C20.1809 0.47097 19.8612 0.681234 19.5415 0.89149C19.3828 0.99757 19.226 1.10138 19.0692 1.20519C18.9128 1.31317 18.7677 1.43066 18.618 1.54435C18.321 1.77363 18.0236 1.99874 17.7304 2.22349C17.4281 2.44063 17.165 2.69844 16.8834 2.93687C16.6064 3.1791 16.3335 3.42097 16.0565 3.6632C14.9003 4.78106 14.4954 5.51069 14.6627 5.67453C14.8371 5.84825 15.5686 5.4743 16.7575 4.469C17.0367 4.25176 17.3182 4.03643 17.6015 3.81883C17.8853 3.60539 18.1547 3.37221 18.455 3.18042C18.7503 2.98066 19.0435 2.77901 19.3427 2.57472C19.4915 2.47579 19.6354 2.36889 19.7888 2.27377C19.9425 2.18281 20.0981 2.08959 20.256 1.99827C20.5672 1.81183 20.8807 1.62728 21.1938 1.43857C21.5194 1.27187 21.8468 1.10292 22.1765 0.935855C22.3434 0.852145 22.5062 0.768783 22.675 0.682808C22.8449 0.60933 23.0189 0.535501 23.193 0.461662C23.5419 0.322314 23.8814 0.148096 24.2446 0.0284898C25.6722 -0.5212 27.2231 -0.905332 28.8787 -1.07402C29.7068 -1.13111 30.5609 -1.17788 31.436 -1.10266L31.7652 -1.08084L32.0939 -1.04009C32.3148 -1.00888 32.5385 -0.994695 32.7585 -0.948727C32.959 -0.911546 33.1636 -0.874721 33.3663 -0.835639L33.4906 -0.804459C33.5296 -0.791045 33.5901 -0.794202 33.5831 -0.753728C33.7626 -0.108343 33.9886 0.711361 34.2604 1.69705C34.563 2.82065 34.9173 4.13071 35.3166 5.62151C36.1212 8.60049 37.1258 12.2923 38.3635 16.5934C38.7677 17.9957 39.1924 19.3919 39.6324 20.7701L39.7103 21.0172L39.7503 21.1397C39.7503 21.1397 39.7548 21.1435 39.757 21.1454C39.7661 21.153 39.7713 21.1651 39.7789 21.1792C39.7935 21.2031 39.816 21.2452 39.8321 21.2858C39.8094 21.2898 39.7776 21.2863 39.7337 21.288L39.7 21.2867L39.6811 21.2863L39.5858 21.2756L39.0005 21.2047C38.6159 21.1478 38.1999 21.1419 37.8004 21.1073C37.3951 21.0795 36.9912 21.0914 36.5855 21.0825C34.9651 21.0992 33.3478 21.3233 31.8071 21.7044C28.7091 22.4451 25.9889 23.9167 23.8329 25.4108C23.5617 25.6001 23.2986 25.7845 23.0374 25.9666C22.7852 26.1563 22.5484 26.3552 22.3129 26.5434C22.0774 26.7317 21.8479 26.9174 21.6222 27.0985C21.5105 27.19 21.3985 27.2773 21.2906 27.3643C21.1876 27.4593 21.0865 27.552 20.9873 27.6424C20.2001 28.3674 19.5102 29.0042 18.937 29.5344C18.6591 29.7914 18.4082 30.0209 18.1904 30.2202C18.0817 30.3219 17.9806 30.4146 17.8871 30.4983C17.7891 30.5781 17.6987 30.6489 17.6204 30.7144C17.3005 30.9709 17.13 31.1094 17.13 31.1094C17.13 31.1094 16.8416 31.3422 16.3261 31.7624C16.0647 31.9676 15.7272 32.1899 15.3418 32.4646C15.15 32.6009 14.9442 32.7446 14.7266 32.8977C14.509 33.0509 14.2624 33.1835 14.0092 33.3376C13.758 33.4895 13.4926 33.6489 13.2175 33.8154C12.9446 33.9838 12.637 34.1154 12.3319 34.2761C12.0216 34.4247 11.7142 34.6066 11.3733 34.7411C11.037 34.8794 10.6885 35.0229 10.3339 35.169C8.89465 35.705 7.25528 36.1346 5.51244 36.2647C4.64192 36.3402 3.74838 36.319 2.85551 36.2327L2.18746 36.1501L1.52224 36.0273C1.30062 35.9877 1.08518 35.9225 0.864745 35.8723L0.70406 35.8338L0.64585 35.8158L0.529429 35.7797C0.476824 35.778 0.495606 35.7281 0.478692 35.7023L0.439583 35.5651L0.23949 34.8753C0.105343 34.4149 -0.0284482 33.9585 -0.162235 33.5022C-0.429811 32.5896 -0.692493 31.685 -0.951844 30.7947C-1.99079 27.2401 -2.95224 23.9516 -3.66507 21.5018L-5.03013 16.8425L-5.71171 14.5117L-5.92228 13.7977L-5.96736 13.64L-5.99086 13.5623L-6.00278 13.5214C-6.00278 13.5214 -6.02077 13.4831 -6.00077 13.496C-5.91685 13.5202 -5.83258 13.5486 -5.74485 13.5683L-5.6163 13.5991L-5.29637 13.6595C-5.12807 13.689 -4.95906 13.7268 -4.78886 13.754L-4.27933 13.8231L-3.7698 13.8922L-3.25864 13.9319C-1.47352 14.073 0.223859 13.951 1.8069 13.6711C2.20054 13.5887 2.59002 13.5067 2.97117 13.4254C3.3535 13.3335 3.71855 13.2116 4.08731 13.1083C4.27151 13.0546 4.45344 12.999 4.63347 12.9456C4.81315 12.8881 4.98721 12.8142 5.162 12.7487C5.51122 12.6135 5.85438 12.481 6.19753 12.3484C6.53616 12.212 6.85488 12.0396 7.17958 11.8877C7.49939 11.7278 7.82481 11.5842 8.13331 11.4148C8.73565 11.052 9.34051 10.7184 9.90882 10.3502C10.4625 9.95811 11.0127 9.57471 11.5478 9.18631C12.0546 8.7626 12.5558 8.34566 13.0547 7.92683L13.0459 7.94648Z" fill="#0055CC"/>
<path d="M114.495 32.3233C112.222 31.5594 111.865 32.4842 114.065 33.4412C115.623 34.1181 117.228 34.7952 118.977 35.5123C119.855 35.8642 120.766 36.2322 121.724 36.617C122.269 36.8321 122.83 37.0521 123.405 37.2771C123.642 37.3719 123.882 37.4581 124.118 37.5446L124.298 37.6109L124.387 37.6431L124.432 37.658C124.448 37.6672 124.451 37.6354 124.461 37.6282L124.677 37.3074C124.82 37.0915 124.962 36.8714 125.107 36.6532C125.214 36.4803 125.323 36.3051 125.431 36.1299C126.78 33.8413 127.434 32.3201 127.986 30.9923C128.522 29.6576 128.956 28.5121 129.531 26.8088C130.002 25.3663 130.481 23.6442 130.752 21.7826C131.029 19.9289 131.072 17.9297 130.72 16.0614C130.685 15.8273 130.618 15.6003 130.566 15.3718L130.485 15.0327C130.452 14.9243 130.42 14.8201 130.388 14.7117C130.257 14.2887 130.129 13.8759 130.004 13.4734C129.871 13.0758 129.708 12.6954 129.569 12.3277C129.497 12.143 129.427 11.9644 129.357 11.79C129.273 11.619 129.194 11.4517 129.115 11.2886C128.956 10.9624 128.812 10.6518 128.666 10.3665C128.501 10.0891 128.349 9.82956 128.209 9.59201C127.945 9.10715 127.656 8.75656 127.474 8.4912L127.134 8.0276L126.744 7.59974C126.627 7.47357 126.483 7.32232 126.319 7.14562C126.159 6.96439 125.94 6.79237 125.717 6.58514C125.273 6.16197 124.688 5.71968 124.013 5.24104C122.649 4.29127 120.829 3.37894 118.787 2.5467C117.766 2.12111 116.69 1.71915 115.586 1.30078C115.27 1.18135 114.951 1.06003 114.628 0.93906C114.367 0.83993 114.105 0.738895 113.84 0.640126L113.446 0.4897L113.246 0.41467L113.146 0.37717L113.096 0.35841C113.096 0.35841 113.082 0.389005 113.075 0.406389C112.755 1.2378 112.429 2.08018 112.103 2.92671C111.218 5.21915 110.304 7.56446 109.412 9.8156C108.794 11.4093 108.234 12.851 107.732 14.1514C107.421 14.9526 107.128 15.7103 106.85 16.4268C106.745 16.6982 106.644 16.965 106.543 17.2276L106.506 17.3274C106.489 17.3478 106.52 17.3471 106.533 17.3544L106.583 17.3731L106.78 17.4463C106.91 17.4938 107.038 17.5435 107.168 17.591C107.634 17.7625 108.085 17.9291 108.525 18.0903C109.559 18.458 110.424 18.7754 111.129 19.0899C111.836 19.4021 112.382 19.7072 112.788 19.9826C113.763 20.6283 114.417 21.4256 114.721 22.3225C115.031 23.2209 115.01 24.211 114.85 25.1627C114.514 27.0782 113.723 28.8274 112.888 30.5008C112.427 31.3926 112.339 31.952 112.53 32.0971L112.524 32.1921C112.543 32.1967 112.555 32.1914 112.562 32.174L112.566 32.1192C112.77 32.2253 113.25 31.9025 113.813 31.0312C114.839 29.3874 115.819 27.6386 116.32 25.4445C116.554 24.3541 116.654 23.1054 116.251 21.8205C116.047 21.1856 115.719 20.5657 115.278 20.0207C114.838 19.4734 114.298 19.004 113.712 18.6079C113.257 18.2948 112.658 17.946 111.931 17.5894C111.201 17.2309 110.34 16.8775 109.378 16.5014C109.259 16.4551 109.137 16.4069 109.015 16.3587L108.972 16.3415L108.965 16.3358L108.952 16.3285L108.932 16.3114L108.894 16.2874C108.885 16.2798 108.864 16.2774 108.883 16.2548C108.905 16.2235 108.922 16.1989 108.937 16.1767C109.05 15.9046 109.164 15.6303 109.285 15.345C109.769 14.1721 110.29 12.891 110.842 11.5045C111.2 10.6006 111.535 9.68824 111.85 8.77542C112.189 7.78926 112.548 6.77404 112.917 5.74334C113.278 4.74895 113.644 3.73943 114.005 2.74504L114.061 2.56814C114.061 2.56814 114.066 2.54885 114.07 2.54849L114.092 2.555L114.135 2.56806L114.223 2.59607L114.268 2.61102L114.292 2.61945L114.381 2.65161L114.756 2.78908C115.003 2.88097 115.248 2.97094 115.491 3.06319C115.976 3.24351 116.451 3.42266 116.91 3.60324C117.372 3.77931 117.813 3.96134 118.238 4.13648C119.943 4.84051 121.328 5.56817 122.259 6.15047C122.71 6.45973 123.088 6.68503 123.314 6.87524C123.546 7.05866 123.675 7.15875 123.675 7.15875C123.675 7.15875 123.72 7.1968 123.812 7.26645C123.898 7.33873 124.044 7.43095 124.196 7.58148C124.355 7.72712 124.549 7.90546 124.772 8.1127C124.829 8.16442 124.886 8.21615 124.948 8.27167C125.001 8.33208 125.059 8.39212 125.117 8.45634C125.233 8.58477 125.355 8.7189 125.483 8.861C126.504 9.99784 127.669 11.8 128.462 14.0309C128.555 14.3103 128.651 14.5957 128.747 14.8812C128.839 15.167 128.95 15.4574 129.012 15.7415C129.087 16.0288 129.164 16.3138 129.211 16.6119L129.291 17.0539C129.312 17.2032 129.325 17.3531 129.347 17.5023C129.488 18.7029 129.464 19.9345 129.335 21.1165C129.074 23.485 128.427 25.6372 127.869 27.2046C127.024 29.5691 126.192 31.2486 125.546 32.5173C124.889 33.7808 124.393 34.6273 124.007 35.2609C123.939 35.3738 123.871 35.4825 123.805 35.589L123.775 35.6377C123.775 35.6377 123.741 35.6281 123.724 35.6254L123.618 35.5863C123.167 35.4156 122.729 35.2521 122.3 35.0921C121.329 34.7356 120.408 34.3979 119.52 34.072C117.742 33.4309 116.096 32.8581 114.486 32.3157L114.495 32.3233Z" fill="#0055CC"/>
<path d="M63.2213 -4.91981C64.3036 -4.55832 64.931 -4.50988 65.0627 -4.7584C65.1871 -4.9937 64.7809 -5.5439 63.6473 -6.03733C62.8457 -6.3791 62.0109 -6.66763 61.1289 -6.89542C60.2473 -7.11905 59.3135 -7.2899 58.3289 -7.34513C57.8413 -7.40358 57.3321 -7.37202 56.8151 -7.38176C56.558 -7.36997 56.296 -7.34306 56.0313 -7.32222C55.898 -7.31066 55.7647 -7.29911 55.6314 -7.28755C55.497 -7.2654 55.3648 -7.24136 55.2303 -7.21921C54.1508 -7.06059 53.0339 -6.72876 51.9327 -6.21366C51.7776 -6.13937 51.624 -6.0715 51.4775 -5.99376C51.3356 -5.91221 51.1978 -5.83104 51.0597 -5.75402C50.7857 -5.59808 50.528 -5.44774 50.2994 -5.27685C50.0662 -5.10976 49.8377 -4.96196 49.6378 -4.79776C49.4383 -4.6294 49.2487 -4.46819 49.0667 -4.31603C48.7053 -4.00564 48.4124 -3.68019 48.1181 -3.3945C47.8555 -3.08218 47.5991 -2.79557 47.3722 -2.50733C46.4759 -1.34485 45.8317 -0.275565 45.0325 1.33172C44.3767 2.70416 43.7657 4.37696 43.3437 6.17395C42.9124 7.95917 42.6876 9.9258 42.8109 11.7679C42.9178 13.6155 43.3565 15.3442 43.9484 16.684C44.5304 18.031 45.2423 18.9618 45.621 19.485C45.8706 19.776 46.1183 20.0692 46.3915 20.3414C46.8871 20.8083 47.8267 21.6795 49.2654 22.4989C49.6286 22.6962 50.0023 22.9177 50.4196 23.1102C50.8332 23.3072 51.2794 23.4931 51.7434 23.6669C52.6774 24.0119 53.698 24.3137 54.8094 24.5258C57.0183 24.9575 59.6288 24.962 62.1114 24.1404C63.3524 23.7391 64.5396 23.1263 65.6002 22.3608C66.6654 21.5991 67.6064 20.6867 68.4118 19.7104C69.54 18.318 70.3115 16.8999 70.9125 15.5972C71.4954 14.2794 71.8779 13.0712 72.1641 11.9868C72.4458 10.8986 72.6224 9.93065 72.7077 9.09447C72.8141 8.26064 72.8305 7.55211 72.8419 6.97831C72.8528 4.26015 72.1712 1.85591 71.051 -0.0633815C70.4777 -1.01665 69.8234 -1.86426 69.0796 -2.58242C68.3284 -3.28736 67.5418 -3.9179 66.6795 -4.40338C66.2508 -4.67885 65.8679 -4.78834 65.5987 -4.84473C65.3256 -4.8966 65.1518 -4.86894 65.0821 -4.77687L65.145 -4.63126C65.1232 -4.66504 65.0952 -4.67311 65.0588 -4.65736L65.0431 -4.69376C65.0108 -4.58185 65.0816 -4.41803 65.2604 -4.21742C65.4355 -4.01228 65.7286 -3.80058 66.0982 -3.50529C66.8482 -2.98281 67.5077 -2.34335 68.1348 -1.66543C68.7505 -0.973925 69.282 -0.187015 69.7486 0.672685C70.2113 1.53691 70.5551 2.50588 70.8114 3.55585C71.0594 4.60655 71.2063 5.74994 71.1886 6.97894C71.1966 7.21745 71.1654 7.48872 71.1497 7.79223C71.1381 8.09539 71.0911 8.42678 71.0364 8.79032C70.948 9.51559 70.767 10.3601 70.5057 11.2954C69.9645 13.1699 69.1073 15.4663 67.5012 17.7163L67.3088 17.9911L67.1005 18.2525L66.6908 18.7811C66.3873 19.1054 66.1203 19.4642 65.8002 19.7668C65.6299 19.9327 65.4716 20.1164 65.2858 20.273C65.1023 20.4316 64.9187 20.5902 64.7333 20.7511C64.3409 21.0432 63.9478 21.35 63.5114 21.5935C62.6552 22.102 61.7221 22.5228 60.7441 22.7629C58.7947 23.2718 56.7658 23.2231 55.0396 22.865C53.3077 22.5136 51.8735 21.9413 50.9288 21.4483C50.4595 21.1889 50.0869 20.9799 49.8427 20.8249C49.602 20.6611 49.4726 20.5716 49.4726 20.5716C49.4726 20.5716 49.4235 20.5381 49.3322 20.4768C49.2405 20.4113 49.0971 20.3293 48.9364 20.1942C48.772 20.0637 48.5714 19.9027 48.3372 19.7174C48.1201 19.5117 47.8736 19.2813 47.5996 19.0239C47.0988 18.4714 46.5061 17.8031 46.0168 16.9475C45.52 16.1009 45.0877 15.1039 44.7938 14.0068C44.1804 11.8107 44.2512 9.25102 44.7058 6.95602C45.1626 4.63984 45.9616 2.59194 46.736 1.18404C47.8904 -0.951311 49.1258 -2.26907 50.1581 -3.12021C51.1942 -3.97588 52.0123 -4.41609 52.6484 -4.70413C53.6061 -5.15434 54.5704 -5.45614 55.5178 -5.6138C55.6356 -5.6345 55.753 -5.65937 55.8686 -5.68198C55.9871 -5.69435 56.1034 -5.70862 56.2219 -5.72099C56.4548 -5.74538 56.6851 -5.77583 56.9142 -5.79569C57.3752 -5.80208 57.8243 -5.8494 58.2681 -5.81234C60.0484 -5.77572 61.691 -5.41453 63.2383 -4.91709L63.2213 -4.91981Z" fill="#0055CC"/>
<path d="M149.643 41.1462C149.707 41.1386 149.772 41.135 149.834 41.1296C149.897 41.1284 149.958 41.1335 150.017 41.1368C150.136 41.1434 150.255 41.1393 150.367 41.1485C150.584 41.1884 150.799 41.195 150.983 41.2609C151.077 41.2863 151.167 41.3078 151.257 41.3294C151.342 41.3619 151.422 41.3948 151.5 41.4216C151.58 41.4504 151.654 41.4776 151.725 41.5028C151.793 41.5368 151.859 41.5689 151.92 41.5972C152.179 41.7027 152.367 41.8102 152.516 41.8582C152.665 41.9103 152.768 41.9119 152.818 41.8655C152.869 41.8192 152.863 41.7211 152.795 41.5675C152.727 41.4139 152.604 41.2022 152.364 40.9733C152.304 40.9155 152.242 40.8517 152.176 40.7882C152.104 40.7315 152.021 40.6736 151.936 40.6138C151.851 40.554 151.758 40.4908 151.66 40.4279C151.555 40.3783 151.444 40.3271 151.328 40.2721C151.099 40.1534 150.826 40.0974 150.536 40.0197C150.391 39.9903 150.237 39.9806 150.078 39.9629C149.999 39.955 149.919 39.9452 149.837 39.9418C149.757 39.9445 149.674 39.9476 149.59 39.9506C148.636 39.9788 147.736 40.254 146.905 40.6177C146.068 40.9798 145.315 41.471 144.572 41.9823C144.209 42.2488 143.842 42.5115 143.498 42.8057C143.142 43.0862 142.801 43.3864 142.46 43.695L142.203 43.9229C142.117 43.9975 142.015 44.1008 141.928 44.1902C141.84 44.2818 141.755 44.373 141.675 44.4639L141.463 44.7068L141.37 44.8029C141.341 44.8285 141.308 44.8776 141.28 44.8192L141.196 44.7216L141.177 44.698L141.059 44.5718L140.819 44.3157C140.497 43.9722 140.173 43.6226 139.843 43.2714C139.187 42.5688 138.512 41.8509 137.823 41.1133C136.438 39.6471 134.985 38.105 133.447 36.4758C133.366 36.3925 133.286 36.3093 133.205 36.2261L133.16 36.188C133.113 36.1606 133.152 36.1278 133.173 36.0987L133.224 36.0376C133.316 35.9373 133.407 35.8393 133.497 35.7413C133.679 35.5471 133.86 35.3593 134.04 35.1738C134.763 34.4418 135.456 33.7649 136.09 33.1581C137.34 31.9418 138.448 30.9918 139.511 30.1548C140.576 29.3197 141.597 28.587 142.741 27.9067C143.884 27.2263 145.144 26.5737 146.712 25.9993C147.041 25.8701 147.387 25.775 147.733 25.6568C148.083 25.5489 148.444 25.4588 148.809 25.36C149.549 25.1973 150.314 25.0408 151.105 24.9722C152.687 24.8036 154.367 24.8909 156.008 25.2858C157.649 25.6806 159.244 26.388 160.67 27.3471C162.105 28.2991 163.355 29.4853 164.442 30.7697C165.532 32.0453 166.437 33.3937 167.101 34.744C167.769 36.094 168.2 37.4415 168.453 38.689C168.707 39.9385 168.791 41.0831 168.821 42.0542C168.854 43.0248 168.81 43.826 168.784 44.399L168.72 45.4389C168.704 45.7886 168.699 46.1626 168.693 46.5093C168.686 47.1141 168.656 47.9581 168.694 49.1446C168.711 49.7348 168.755 50.4171 168.886 51.1989C169.02 51.9762 169.253 52.8834 169.791 53.7915C170.053 54.2472 170.391 54.6816 170.799 55.0868C171.204 55.5007 171.727 55.8667 172.326 56.1546C172.941 56.4245 173.637 56.5655 174.345 56.5693C175.051 56.5605 175.743 56.4082 176.418 56.1881C177.747 55.7099 178.979 54.9338 180.172 53.9974C180.767 53.5283 181.354 53.0136 181.936 52.4638C182.23 52.1929 182.508 51.9211 182.801 51.6419C182.857 51.5887 182.911 51.5337 182.968 51.4805L183.01 51.4391C183.026 51.4524 183.042 51.4657 183.06 51.481L183.076 51.4943L183.085 51.5019L183.154 51.5756C183.256 51.6801 183.36 51.7907 183.472 51.9047C183.91 52.3619 184.42 52.8906 184.982 53.4797C186.108 54.6578 187.46 56.0766 188.952 57.6405C189.633 58.3557 190.346 59.1059 191.082 59.8793C191.101 59.907 191.162 59.9353 191.113 59.9669L191.075 60.0121L190.913 60.1856C190.524 60.6075 190.105 61.0278 189.673 61.445C189.235 61.8649 188.793 62.2851 188.349 62.7117C187.9 63.1179 187.462 63.5461 186.997 63.9389C186.087 64.7501 185.126 65.5027 184.164 66.2239C181.541 68.1593 178.922 69.5424 176.438 70.3284C173.956 71.1228 171.629 71.2992 169.639 71.0479C168.643 70.9245 167.728 70.7079 166.902 70.427C166.08 70.1373 165.338 69.8072 164.678 69.449C163.359 68.7303 162.368 67.9392 161.596 67.2591C160.691 66.4521 159.878 65.572 159.161 64.6753C158.43 63.7861 157.823 62.8547 157.303 61.9115C156.265 60.0228 155.669 58.0497 155.387 56.0934C155.235 55.1162 155.172 54.1397 155.141 53.1751C155.104 52.2089 155.139 51.2533 155.147 50.279C155.152 49.3092 155.16 48.358 155.127 47.3873C155.092 46.4231 155.005 45.4381 154.757 44.4609C154.485 43.4059 153.996 42.6741 153.603 42.2822C153.412 42.0785 153.232 41.9619 153.1 41.8936C152.968 41.8253 152.879 41.812 152.832 41.8497L152.701 41.8442C152.697 41.8635 152.703 41.8692 152.722 41.8655L152.829 41.8436L152.808 41.8685C152.77 41.9138 152.772 42.008 152.817 42.1426C152.86 42.2752 152.946 42.4482 153.042 42.6791C153.244 43.1316 153.527 43.7785 153.718 44.7041C153.889 45.5705 153.936 46.4792 153.926 47.4054C153.92 48.3312 153.872 49.2838 153.833 50.2398C153.722 52.1482 153.636 54.1889 153.902 56.2935C154.151 58.3995 154.77 60.593 155.881 62.6747C156.437 63.7134 157.093 64.7371 157.873 65.7018C158.641 66.6759 159.501 67.6149 160.49 68.5006C161.26 69.1829 162.28 70.0177 163.649 70.8244C165.02 71.6183 166.762 72.3758 168.863 72.7476C170.959 73.1156 173.393 73.0683 175.922 72.44C178.453 71.8219 181.043 70.6301 183.565 69.0036C185.208 67.94 186.742 66.7265 188.162 65.4284C188.478 65.1492 188.784 64.8541 189.092 64.5567C189.402 64.2613 189.714 63.9636 190.011 63.665C190.619 63.0668 191.235 62.4573 191.845 61.8107L192.299 61.316C192.345 61.2617 192.523 61.0679 192.639 60.9257L193.021 60.4708L193.391 60.0086L193.486 59.8955C193.48 59.8561 193.425 59.821 193.399 59.7834L193.195 59.566C192.933 59.2761 192.65 58.988 192.374 58.7014C191.761 58.0705 191.146 57.4377 190.534 56.8068C189.331 55.5598 188.135 54.3226 186.969 53.1144C185.625 51.7139 184.318 50.348 183.066 49.0444C182.442 49.6398 181.829 50.2259 181.227 50.8048C181.016 51.0098 180.808 51.2062 180.602 51.3919C180.393 51.5799 180.196 51.7733 179.987 51.9488C179.164 52.6706 178.326 53.2951 177.498 53.7927C176.67 54.2863 175.836 54.6439 175.066 54.7841C174.293 54.9266 173.6 54.8461 173.042 54.5966C172.477 54.3497 172.045 53.936 171.712 53.5326C171.383 53.1289 171.169 52.7362 171.022 52.3965C170.949 52.2266 170.901 52.067 170.85 51.9351C170.811 51.7937 170.778 51.677 170.753 51.5826C170.724 51.4886 170.713 51.4098 170.7 51.3606C170.689 51.309 170.683 51.2844 170.683 51.2844C170.683 51.2844 170.655 51.1757 170.62 50.9647C170.602 50.8571 170.582 50.7245 170.558 50.5692C170.542 50.409 170.522 50.2261 170.5 50.0182C170.428 49.181 170.429 47.9304 170.475 46.3506C170.48 45.578 170.559 44.7172 170.575 43.7653C170.586 42.816 170.584 41.7985 170.473 40.7275C170.366 39.6562 170.183 38.5328 169.879 37.3967C169.563 36.2616 169.12 35.1208 168.563 34.0109C168.013 32.8919 167.297 31.8419 166.532 30.8276C166.332 30.5785 166.135 30.3312 165.933 30.0802C165.729 29.8356 165.508 29.603 165.296 29.3632C165.082 29.1258 164.871 28.886 164.637 28.6587C164.41 28.4287 164.184 28.1965 163.941 27.9846C162.045 26.2207 159.744 24.834 157.312 24.1068C154.881 23.3649 152.383 23.3003 150.19 23.631C147.983 23.9545 146.071 24.6532 144.51 25.353C142.165 26.4333 140.292 27.6636 138.737 28.8286C137.183 29.9978 135.935 31.0964 134.891 32.0807C133.859 33.0556 132.992 33.8798 132.263 34.6501C132.173 34.7481 132.085 34.8439 131.996 34.9355C131.87 35.0807 131.724 35.2361 131.601 35.3915C131.474 35.5473 131.351 35.6986 131.228 35.8498C131.165 35.9245 131.108 36.0008 131.048 36.0732C131.006 36.1461 130.87 36.225 130.986 36.2883C131.232 36.5607 131.465 36.8217 131.709 37.0734C131.889 37.2634 132.062 37.4477 132.23 37.624C133.778 39.2461 135.238 40.775 136.632 42.2363C137.33 42.9626 138.015 43.6733 138.681 44.3688C139.015 44.7154 139.345 45.0583 139.674 45.3969C139.865 45.5964 140.056 45.7918 140.245 45.9894L140.649 46.4098C140.784 46.5428 140.916 46.6615 141.049 46.7885L141.247 46.9748L141.299 47.0185L141.32 47.044C141.325 47.0478 141.329 47.0516 141.332 47.0535L141.343 47.0399L141.444 46.943L141.83 46.5529C142.085 46.3 142.335 46.0077 142.564 45.7213C142.888 45.3177 143.089 45.0967 143.437 44.779C143.751 44.4791 144.068 44.1851 144.395 43.9113C144.712 43.6257 145.047 43.3701 145.374 43.1088C146.043 42.6165 146.72 42.1424 147.435 41.8013C148.146 41.4564 148.886 41.2055 149.62 41.1503L149.643 41.1462Z" fill="#0055CC"/>
<path d="M80.321 9.381C80.4416 7.10655 79.4571 7.02823 79.1312 9.25752C78.8942 10.8392 78.6434 12.4555 78.3341 14.1966C78.018 15.932 77.6635 17.8049 77.0533 19.8029C76.9621 20.1318 76.8558 20.4327 76.7629 20.7177C76.7418 20.7888 76.7161 20.8561 76.6904 20.9233C76.6579 21.008 76.6295 21.0923 76.5966 21.1728C76.5069 21.4218 76.4055 21.6573 76.3015 21.8866C75.8871 22.7744 75.5595 23.4763 75.3454 23.9376C76.5743 23.808 77.6597 23.6698 78.5962 23.5572C79.1374 23.483 79.6268 23.4154 80.1059 23.3508C81.0599 23.2219 81.9734 23.1092 83.1533 22.9964C85.9529 22.7118 89.7215 22.3998 93.0728 22.1386C93.9107 22.0744 94.7237 22.0123 95.4885 21.9523C95.6782 21.938 95.8679 21.9236 96.0534 21.9097C96.3908 21.8804 96.7199 21.8519 97.0447 21.8237C97.2132 21.807 97.3821 21.7945 97.5465 21.7781L97.6089 21.7727C97.6204 21.7591 97.6182 21.7341 97.6228 21.7148L97.6419 21.5957L97.6801 21.3574C97.73 21.0362 97.7788 20.7257 97.826 20.4215C97.9332 19.7429 98.0279 19.1388 98.1097 18.6281C98.1809 18.1394 98.241 17.7418 98.2835 17.4569C98.332 17.1191 98.3699 16.7801 98.4014 16.4396C98.4496 15.9045 98.5308 14.9722 98.6212 13.7348C98.6626 13.1206 98.7101 12.4304 98.7605 11.6769C98.8248 10.9391 98.9042 10.1327 98.9956 9.27083C99.1893 7.55237 99.4495 5.63093 99.8761 3.6447C100.088 2.65271 100.35 1.64389 100.688 0.657733C100.777 0.415087 100.869 0.172091 100.959 -0.0728197L101.111 -0.432169L101.185 -0.612789C101.19 -0.632072 101.226 -0.698169 101.255 -0.755205L101.343 -0.924419L101.695 -1.60959C101.746 -1.72103 101.822 -1.84298 101.901 -1.96529L102.126 -2.32887C102.421 -2.80344 102.713 -3.27991 103.01 -3.75675C102.93 -3.75822 102.807 -3.74549 102.664 -3.73095C102.522 -3.71867 102.364 -3.70079 102.189 -3.68563C101.84 -3.65113 101.434 -3.60967 100.989 -3.56688C100.271 -3.49835 99.4285 -3.41482 98.594 -3.33619C92.1629 -2.6822 88.1819 -2.27836 86.104 -2.06678C84.8775 -1.93528 83.7301 -1.81063 82.6387 -1.69294C81.9634 -1.61553 81.3068 -1.54182 80.6649 -1.4673L80.3138 -1.42637L80.1393 -1.40705L80.054 -1.39756C80.054 -1.39756 80.0158 -1.40264 80.0195 -1.38408L80.0129 -1.33944C79.9849 -1.10411 79.9566 -0.872952 79.9306 -0.639888C79.9042 -0.410991 79.8778 -0.182091 79.8514 0.046808C79.8379 0.182264 79.824 0.313557 79.8105 0.449013C79.6178 2.44645 79.5162 4.28491 79.4719 6.10582C79.4328 8.10883 80.2926 8.15179 80.5363 6.1856C80.7678 4.39463 81.0108 2.59008 81.2991 0.630513C81.3163 0.51362 81.3335 0.396721 81.3507 0.279829L81.3736 0.156149L81.3968 0.0366324C81.4245 0.0174448 81.4801 0.0294168 81.5173 0.0220026L81.6426 0.0153272C81.7592 0.00521753 81.8758 -0.00488413 81.9924 -0.0149939C82.259 -0.0381019 82.5275 -0.0634723 82.8005 -0.0850388C83.891 -0.187965 85.0441 -0.296311 86.2698 -0.413054C88.1772 -0.605671 92.1765 -0.77399 97.792 -1.29854C98.2499 -1.34242 98.7073 -1.39046 99.1621 -1.44458L99.459 -1.4808C99.459 -1.4808 99.4628 -1.48532 99.4666 -1.48985C99.4723 -1.49664 99.4841 -1.50606 99.5061 -1.51846C99.5282 -1.53086 99.5786 -1.55412 99.6074 -1.56081C99.6134 -1.54035 99.619 -1.52404 99.5928 -1.43784L99.5732 -1.37321L99.4323 -1.01267C99.3335 -0.771204 99.2457 -0.524399 99.1662 -0.278311C98.8317 0.707485 98.5712 1.70154 98.3498 2.68592C97.9192 4.64943 97.6406 6.5515 97.4316 8.21463C97.2283 9.87097 97.0684 11.3011 96.9964 12.3145C96.9101 13.3082 96.8578 13.8939 96.8578 13.8939C96.8578 13.8939 96.7819 14.8384 96.6206 16.3484C96.541 17.1044 96.4359 18.0011 96.3094 18.9919C96.2578 19.3657 96.2075 19.7561 96.1523 20.1616C96.1696 20.265 96.0622 20.2366 95.9922 20.2511C95.7737 20.2721 95.5533 20.2954 95.3287 20.3191C90.738 20.782 85.3487 21.3268 82.1496 21.6503L79.3959 21.931L78.3394 22.0393L78.1542 22.0575L78.0607 22.0677L78.0148 22.0717C78.0148 22.0717 77.9678 22.0862 77.9869 22.0636C78.0476 21.9408 78.1061 21.8162 78.1578 21.6858L78.2605 21.4167C78.3084 21.2909 78.3479 21.1657 78.3917 21.0402C78.4791 20.7893 78.5624 20.5387 78.637 20.2846C79.2812 18.1452 79.6012 16.2123 79.8478 14.4263C80.088 12.6388 80.2266 10.9859 80.3206 9.37683L80.321 9.381Z" fill="#0055CC"/>
</g>
</g>
<defs>
<clipPath id="clip0_550_14457">
<rect width="419" height="16" fill="white"/>
</clipPath>
<clipPath id="clip1_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 330) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $cb0e8fe57b0fd046$var$$e48fba9cf5395297$export$d3a66d29d3f047ac = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$e48fba9cf5395297$require$Buffer.from($cb0e8fe57b0fd046$var$$e48fba9cf5395297$var$courseBg).toString("base64")}`;
var $cb0e8fe57b0fd046$var$$ea8e736e4eb06883$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $cb0e8fe57b0fd046$var$$ea8e736e4eb06883$var$learningPathBg = `<svg width="420" height="32" viewBox="0 0 420 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_783_5660)">
<rect width="421" height="32" fill="#D3F1A7"/>
<g clipPath="url(#clip1_783_5660)">
<path d="M419.987 -18.535C419.996 -18.6008 420.003 -18.6685 420.014 -18.7325C420.032 -18.7948 420.048 -18.855 420.064 -18.9151C420.099 -19.0357 420.114 -19.1586 420.159 -19.2633C420.248 -19.4787 420.309 -19.6897 420.416 -19.8626C420.463 -19.9547 420.508 -20.0405 420.551 -20.1239C420.603 -20.204 420.653 -20.2776 420.702 -20.3489C420.75 -20.4203 420.79 -20.495 420.836 -20.56C420.888 -20.6211 420.931 -20.6814 420.974 -20.7377C421.14 -20.9766 421.288 -21.1425 421.37 -21.2818C421.452 -21.4212 421.479 -21.5221 421.443 -21.5798C421.407 -21.6375 421.307 -21.6519 421.142 -21.6125C420.978 -21.5731 420.733 -21.4931 420.458 -21.2993C420.387 -21.2511 420.313 -21.2007 420.234 -21.1477C420.159 -21.0908 420.086 -21.0173 420.006 -20.9454C419.928 -20.8715 419.847 -20.7931 419.762 -20.7102C419.686 -20.6197 419.613 -20.5189 419.533 -20.4155C419.364 -20.2141 419.244 -19.9561 419.102 -19.6815C419.032 -19.5432 418.992 -19.3908 418.936 -19.237C418.91 -19.1592 418.885 -19.0794 418.86 -18.9996C418.838 -18.918 418.826 -18.8351 418.809 -18.7496C418.615 -17.7845 418.69 -16.8132 418.876 -15.8956C419.059 -14.9694 419.392 -14.1023 419.756 -13.2441C419.947 -12.8201 420.142 -12.3942 420.364 -11.9834C420.574 -11.5631 420.81 -11.1597 421.049 -10.7503L421.231 -10.4387C421.302 -10.3211 421.379 -10.2102 421.453 -10.1055C421.527 -10.0007 421.606 -9.89626 421.681 -9.80207L421.834 -9.60345C421.861 -9.56587 421.887 -9.52828 421.909 -9.4945C421.917 -9.4763 421.939 -9.45727 421.93 -9.44179L421.87 -9.40722L421.756 -9.34487C421.555 -9.22042 421.349 -9.0956 421.146 -8.96889C420.732 -8.71475 420.314 -8.45608 419.889 -8.19478C419.043 -7.67029 418.178 -7.13793 417.292 -6.589C415.522 -5.48507 413.666 -4.32963 411.701 -3.10388C411.569 -3.02115 411.438 -2.93843 411.311 -2.85606L411.263 -2.82257C411.247 -2.8128 411.23 -2.79243 411.213 -2.79515L411.176 -2.83808L411.129 -2.89695C411.053 -2.99948 410.979 -3.10009 410.908 -3.19881C410.748 -3.42205 410.595 -3.64376 410.445 -3.86582C409.853 -4.75028 409.317 -5.59134 408.833 -6.35724C407.867 -7.87654 407.139 -9.19195 406.523 -10.4478C405.911 -11.7041 405.395 -12.8911 404.961 -14.1984C404.532 -15.502 404.156 -16.9192 403.941 -18.6296C403.764 -20.0725 403.734 -21.6583 403.948 -23.2903C404.067 -24.1022 404.224 -24.932 404.485 -25.7436C404.596 -26.1561 404.761 -26.5544 404.909 -26.9595C405.08 -27.3563 405.245 -27.7587 405.453 -28.1439C405.847 -28.9251 406.311 -29.6787 406.85 -30.3843C407.385 -31.0937 407.973 -31.7657 408.624 -32.3739C408.936 -32.6906 409.287 -32.9707 409.619 -33.2638C409.969 -33.5376 410.311 -33.8212 410.678 -34.0691C411.033 -34.3348 411.41 -34.5668 411.777 -34.8022C412.152 -35.0319 412.539 -35.2438 412.914 -35.4652C414.436 -36.3063 415.99 -36.9508 417.497 -37.3605C419.003 -37.7744 420.458 -37.953 421.776 -37.9728C423.096 -37.9949 424.276 -37.8643 425.269 -37.7091C426.262 -37.5581 427.07 -37.3658 427.646 -37.2332L428.69 -36.9733C429.045 -36.8908 429.419 -36.8161 429.771 -36.7439C430.378 -36.6244 431.227 -36.4357 432.428 -36.2524C433.028 -36.1617 433.721 -36.077 434.532 -36.0634C435.339 -36.0536 436.29 -36.115 437.298 -36.4731C437.804 -36.6386 438.302 -36.8958 438.794 -37.2049C439.033 -37.3788 439.288 -37.5352 439.516 -37.7606C439.63 -37.8691 439.756 -37.9682 439.863 -38.0907C439.969 -38.2175 440.076 -38.3442 440.183 -38.4709C440.585 -39.0094 440.922 -39.6534 441.087 -40.3602C441.245 -41.0621 441.295 -41.8007 441.211 -42.5237C441.061 -43.9794 440.534 -45.3837 439.853 -46.7871C439.509 -47.4895 439.114 -48.1854 438.684 -48.8867C438.47 -49.2438 438.255 -49.5756 438.036 -49.93C437.987 -50.0056 437.941 -50.0792 437.892 -50.1547L437.861 -50.2044C437.876 -50.2184 437.894 -50.2304 437.914 -50.2447C437.836 -50.1981 438.202 -50.4313 438.461 -50.5964C439.016 -50.9487 439.658 -51.3548 440.372 -51.8091C441.803 -52.7116 443.524 -53.7987 445.425 -54.9978C446.336 -55.572 447.291 -56.171 448.275 -56.7892L448.326 -56.823C448.342 -56.8286 448.363 -56.8577 448.374 -56.8292L448.412 -56.7821L448.504 -56.658C448.854 -56.1743 449.194 -55.6645 449.531 -55.1418C449.866 -54.6086 450.202 -54.0712 450.54 -53.5319C450.86 -52.9889 451.204 -52.4564 451.506 -51.9013C452.14 -50.8043 452.697 -49.6713 453.218 -48.5373C454.609 -45.4749 455.414 -42.519 455.622 -39.8408C455.835 -37.1588 455.451 -34.7734 454.708 -32.8332C453.969 -30.885 452.931 -29.3703 451.906 -28.2008C450.869 -27.0366 449.854 -26.1975 448.994 -25.5648C448.74 -25.377 448.489 -25.1937 448.225 -25.026C447.964 -24.8545 447.711 -24.6814 447.441 -24.53C447.177 -24.3729 446.912 -24.2176 446.652 -24.0609C446.391 -23.906 446.118 -23.7796 445.858 -23.6395C445.335 -23.3487 444.792 -23.1337 444.267 -22.891C444.001 -22.782 443.73 -22.6893 443.467 -22.5866L443.07 -22.4369L442.67 -22.314C441.607 -21.9638 440.54 -21.7559 439.49 -21.6188C438.439 -21.4752 437.397 -21.4584 436.377 -21.4937C435.354 -21.5267 434.349 -21.6453 433.361 -21.7967C432.866 -21.8692 432.377 -21.9632 431.889 -22.0531C431.396 -22.1509 430.914 -22.2581 430.418 -22.3473C429.434 -22.5327 428.468 -22.7238 427.477 -22.8687C426.491 -23.0141 425.476 -23.1065 424.439 -23.0397C423.318 -22.9551 422.489 -22.6084 422.02 -22.2886C421.775 -22.1352 421.62 -21.9792 421.526 -21.8618C421.431 -21.7445 421.396 -21.6576 421.422 -21.6053L421.393 -21.479C421.408 -21.4698 421.421 -21.475 421.419 -21.4959L421.417 -21.6091L421.441 -21.5817C421.478 -21.5346 421.572 -21.5217 421.717 -21.5385C421.86 -21.5572 422.053 -21.6117 422.306 -21.6651C422.804 -21.788 423.52 -21.9508 424.501 -21.9792C426.333 -22.0037 428.217 -21.4935 430.151 -21.0652C432.069 -20.5957 434.122 -20.1211 436.309 -19.998C437.401 -19.9333 438.53 -19.9304 439.679 -20.0657C440.824 -20.1922 441.997 -20.4072 443.155 -20.774L443.593 -20.9043L444.026 -21.0615C444.313 -21.1682 444.608 -21.2672 444.896 -21.3845C445.464 -21.6372 446.054 -21.871 446.616 -22.1756C446.899 -22.3239 447.191 -22.4605 447.471 -22.6232C447.751 -22.7859 448.03 -22.9528 448.316 -23.1182C448.602 -23.2794 448.877 -23.4648 449.157 -23.6507C449.44 -23.8304 449.714 -24.0284 449.988 -24.2305C450.841 -24.8583 451.905 -25.7017 453.021 -26.8958C453.309 -27.1872 453.571 -27.5226 453.863 -27.8606C454.004 -28.0322 454.137 -28.2179 454.276 -28.402C454.418 -28.5843 454.554 -28.7745 454.686 -28.9768C455.233 -29.7649 455.74 -30.6671 456.174 -31.674C457.054 -33.6807 457.614 -36.138 457.566 -38.828C457.534 -41.5172 456.936 -44.4071 455.846 -47.3131C455.131 -49.2087 454.232 -51.0192 453.22 -52.7276C453 -53.1093 452.768 -53.4858 452.531 -53.8597C452.294 -54.2399 452.058 -54.616 451.817 -54.9854C451.333 -55.7282 450.844 -56.4873 450.306 -57.2401C450.171 -57.4277 450.035 -57.6153 449.893 -57.8044C449.653 -58.1256 449.383 -58.4568 449.123 -58.7679L448.927 -59.0068L448.828 -59.1242L448.779 -59.185L448.713 -59.1436L448.187 -58.8211L447.222 -58.2108C446.463 -57.7211 445.702 -57.2334 444.944 -56.746C443.425 -55.775 441.918 -54.8134 440.448 -53.874C438.753 -52.7997 437.104 -51.7524 435.527 -50.7533C435.991 -50.0109 436.451 -49.2807 436.903 -48.5604C437.066 -48.3038 437.217 -48.0567 437.362 -47.8112C437.505 -47.5634 437.664 -47.3254 437.793 -47.0785C438.349 -46.1048 438.792 -45.1298 439.105 -44.1939C439.417 -43.2557 439.58 -42.3466 439.535 -41.5454C439.493 -40.7424 439.25 -40.0624 438.851 -39.5599C438.46 -39.0497 437.954 -38.6911 437.475 -38.4376C436.995 -38.1883 436.554 -38.0452 436.181 -37.9646C435.996 -37.9234 435.825 -37.9044 435.679 -37.877C435.529 -37.864 435.404 -37.8532 435.302 -37.8423C435.2 -37.8313 435.122 -37.8309 435.068 -37.8304C435.013 -37.8298 434.988 -37.8277 434.988 -37.8277C434.988 -37.8277 434.871 -37.8259 434.651 -37.8215C434.54 -37.8265 434.399 -37.829 434.237 -37.8338C434.073 -37.8406 433.88 -37.8596 433.667 -37.8767C432.801 -37.9591 431.531 -38.1931 429.936 -38.5374C429.151 -38.6876 428.292 -38.93 427.33 -39.1214C426.369 -39.3109 425.335 -39.5004 424.228 -39.5891C423.123 -39.6842 421.952 -39.7107 420.741 -39.6162C419.533 -39.5115 418.291 -39.2884 417.058 -38.9423C415.82 -38.6 414.613 -38.0967 413.43 -37.5305C412.848 -37.2282 412.256 -36.9336 411.697 -36.585C411.125 -36.2585 410.565 -35.8952 410.019 -35.5121C407.837 -33.978 405.925 -31.9889 404.62 -29.721C403.3 -27.4622 402.621 -24.9777 402.422 -22.6922C402.327 -21.5468 402.342 -20.4487 402.416 -19.4206C402.469 -18.909 402.508 -18.413 402.588 -17.9395C402.625 -17.7035 402.656 -17.4691 402.697 -17.2418C402.742 -17.0149 402.786 -16.7921 402.83 -16.5777C403.106 -15.2755 403.444 -14.0753 403.836 -12.9846C404.024 -12.4365 404.237 -11.9178 404.431 -11.4143C404.65 -10.9213 404.839 -10.4341 405.058 -9.9831C405.906 -8.16185 406.754 -6.66802 407.532 -5.40729C408.303 -4.16059 408.956 -3.11351 409.589 -2.2179C409.677 -2.09754 409.763 -1.97908 409.846 -1.86252C409.972 -1.69507 410.097 -1.53177 410.231 -1.3692C410.364 -1.2108 410.493 -1.05203 410.619 -0.899327C410.683 -0.822977 410.748 -0.74889 410.811 -0.672541C410.838 -0.607701 410.885 -0.664288 410.925 -0.684559L411.049 -0.758224C411.375 -0.948013 411.688 -1.14089 411.994 -1.3353C412.199 -1.46428 412.396 -1.58837 412.583 -1.70531C414.541 -2.94093 416.392 -4.10849 418.154 -5.2223C419.034 -5.7811 419.891 -6.3275 420.73 -6.86187C421.15 -7.13113 421.563 -7.39361 421.975 -7.65798C422.182 -7.78922 422.388 -7.92463 422.593 -8.0536L423.1 -8.37663L423.351 -8.53683L423.58 -8.6994L424.035 -9.02415L424.063 -9.04335L424.074 -9.05693C424.074 -9.05693 424.071 -9.06299 424.069 -9.06906L424.03 -9.12865L423.95 -9.24973L423.794 -9.48584C423.591 -9.79557 423.369 -10.1058 423.118 -10.4051L422.846 -10.7382L422.646 -10.9915C422.584 -11.0743 422.525 -11.1593 422.472 -11.2387L422.296 -11.5214C422.062 -11.9039 421.823 -12.282 421.616 -12.6689C421.392 -13.0503 421.203 -13.441 421.015 -13.8275C420.658 -14.6065 420.324 -15.3895 420.137 -16.1875C419.943 -16.9806 419.861 -17.7834 419.977 -18.5362L419.987 -18.535Z" fill="#6A9A23"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#6A9A23"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#6A9A23"/>
<path d="M384.78 4.00329C387.938 3.20915 387.727 2.24341 384.526 2.83562C382.254 3.25496 379.932 3.70171 377.414 4.21162C376.157 4.47169 374.85 4.74026 373.477 5.02294C372.791 5.16845 372.086 5.31766 371.367 5.47022L371.218 5.49987C371.197 5.50168 371.166 5.52123 371.163 5.48791C371.092 5.31992 371.022 5.14967 370.951 4.97752C369.623 1.76695 368.946 -0.312486 368.381 -2.12043C367.842 -3.93698 367.411 -5.50059 367.051 -7.83194C366.893 -8.81488 366.773 -9.88927 366.688 -11.0192C366.622 -12.1486 366.576 -13.3343 366.64 -14.5359C366.704 -15.7374 366.819 -16.9581 367.064 -18.1396C367.308 -19.3211 367.637 -20.4742 368.076 -21.5383C368.18 -21.8055 368.312 -22.0581 368.428 -22.3158C368.488 -22.4427 368.547 -22.5716 368.605 -22.6962C368.676 -22.822 368.743 -22.9474 368.812 -23.0709C369.086 -23.5667 369.355 -24.0516 369.614 -24.5211C369.889 -24.9813 370.184 -25.4056 370.452 -25.8254C370.59 -26.0303 370.716 -26.2406 370.855 -26.4331C371 -26.6199 371.14 -26.804 371.278 -26.9817C371.556 -27.3352 371.803 -27.6798 372.06 -27.9811C372.327 -28.2707 372.576 -28.5441 372.802 -28.7903C373.238 -29.3044 373.671 -29.6399 373.952 -29.9097L374.459 -30.3796L375.001 -30.8127C375.161 -30.9441 375.356 -31.1015 375.579 -31.2845C375.688 -31.3821 375.817 -31.4709 375.954 -31.5604C376.091 -31.6541 376.237 -31.7508 376.39 -31.8542C376.986 -32.2878 377.767 -32.7206 378.666 -33.1972C380.483 -34.1268 382.926 -34.9701 385.749 -35.6869C386.452 -35.8717 387.182 -36.0462 387.929 -36.2179C388.673 -36.3957 389.442 -36.561 390.222 -36.7356C390.745 -36.8523 391.276 -36.9696 391.811 -37.0874C391.827 -37.0972 391.829 -37.0805 391.834 -37.0684L391.843 -37.0293L391.877 -36.8812C391.965 -36.4754 392.052 -36.0697 392.138 -35.6616C392.826 -32.3977 393.535 -29.0516 394.215 -25.8332C394.699 -23.5607 395.138 -21.5069 395.533 -19.6569C395.709 -18.8328 395.874 -18.0562 396.03 -17.3227L396.047 -17.2507C396.046 -17.2318 396.008 -17.2368 395.99 -17.229C395.759 -17.1838 395.532 -17.1389 395.315 -17.097C393.858 -16.8196 392.563 -16.5563 391.456 -16.2547C390.349 -15.9573 389.427 -15.6235 388.695 -15.281C387.829 -14.8808 387.014 -14.3841 386.312 -13.7652C385.606 -13.15 385.025 -12.4135 384.602 -11.6257C384.182 -10.8318 383.945 -10.0035 383.788 -9.19671C383.737 -8.79153 383.662 -8.39059 383.656 -7.99771C383.648 -7.79977 383.64 -7.606 383.631 -7.41223C383.631 -7.21918 383.643 -7.02722 383.649 -6.83679C383.805 -3.79316 384.714 -1.22823 385.709 1.20761C386.262 2.50259 386.762 3.06984 386.983 3.00452L386.993 2.90918C386.995 2.93001 387.006 2.93951 387.029 2.93545L387.023 2.98842C387.233 2.86741 387.157 2.12707 386.709 0.831387C385.907 -1.6044 385.185 -4.13523 385.149 -6.86608C385.149 -7.03604 385.145 -7.20563 385.149 -7.37595C385.164 -7.54509 385.174 -7.71387 385.187 -7.88491C385.199 -8.23008 385.278 -8.56211 385.326 -8.9041C385.476 -9.57384 385.682 -10.2422 386.022 -10.857C386.365 -11.468 386.82 -12.032 387.389 -12.5198C387.957 -13.0076 388.635 -13.4231 389.39 -13.7697C389.972 -14.0447 390.76 -14.3207 391.748 -14.5721C392.735 -14.8234 393.919 -15.0373 395.292 -15.2696C395.66 -15.3351 396.039 -15.3993 396.429 -15.4689C396.772 -15.5363 397.118 -15.6041 397.469 -15.6723C397.646 -15.7087 397.826 -15.7431 398.003 -15.7795L398.137 -15.8058L398.206 -15.818C398.206 -15.818 398.218 -15.8191 398.222 -15.8236L398.22 -15.8403L398.213 -15.8732L398.161 -16.1414C397.961 -17.148 397.754 -18.2065 397.532 -19.3161C397.2 -21.0058 396.833 -22.8477 396.421 -24.8325C396.152 -26.1248 395.86 -27.413 395.553 -28.6873C394.886 -31.4348 394.198 -34.3925 393.546 -37.286L393.341 -38.223L393.235 -38.7027L393.183 -38.9395L393.156 -39.0588C393.152 -39.0774 393.15 -39.1024 393.141 -39.1141L393.079 -39.1004C392.467 -38.9655 391.858 -38.8288 391.251 -38.6943C390.541 -38.5342 389.839 -38.3747 389.149 -38.2205C387.771 -37.908 386.435 -37.6013 385.194 -37.2776C382.705 -36.6506 380.584 -35.9232 379.116 -35.3029C378.753 -35.1371 378.426 -34.9871 378.141 -34.8596C377.997 -34.7947 377.866 -34.7351 377.745 -34.6784C377.627 -34.6157 377.521 -34.5582 377.422 -34.5056C377.038 -34.296 376.829 -34.1815 376.829 -34.1815C376.829 -34.1815 376.751 -34.139 376.605 -34.0571C376.459 -33.971 376.233 -33.8675 375.972 -33.6854C375.704 -33.509 375.379 -33.292 374.999 -33.043C374.904 -32.9802 374.807 -32.9151 374.705 -32.8496C374.611 -32.7743 374.511 -32.6964 374.413 -32.6165C374.213 -32.4565 373.998 -32.289 373.775 -32.1101C373.313 -31.7721 372.875 -31.325 372.39 -30.8675C371.887 -30.4253 371.447 -29.8604 370.947 -29.3072C370.689 -29.0331 370.468 -28.7244 370.238 -28.4086C370.006 -28.0969 369.77 -27.7742 369.529 -27.4512C369.295 -27.1225 369.093 -26.7672 368.869 -26.4183C368.652 -26.0638 368.416 -25.7139 368.211 -25.3457C368.012 -24.9718 367.81 -24.5934 367.61 -24.213C367.412 -23.8266 367.19 -23.4611 367.018 -23.0413C366.838 -22.6332 366.644 -22.2241 366.501 -21.7962L366.27 -21.1594C366.194 -20.9451 366.142 -20.7265 366.076 -20.511C365.569 -18.778 365.306 -16.9905 365.209 -15.272C365.017 -11.829 365.44 -8.67637 365.857 -6.37091C366.505 -2.89785 367.285 -0.399327 367.899 1.48832C368.53 3.37452 369.032 4.64658 369.43 5.61085C369.519 5.81714 369.604 6.0238 369.693 6.22593C369.821 6.52323 369.954 6.82018 370.092 7.1145L370.193 7.33446L370.219 7.39097C370.227 7.40918 370.255 7.38998 370.274 7.39044L370.391 7.36557L370.861 7.27026C371.154 7.20714 371.444 7.14212 371.732 7.07936C372.451 6.91847 373.155 6.76093 373.838 6.60936C375.206 6.29562 376.507 5.99825 377.757 5.70939C380.258 5.12332 382.558 4.56518 384.799 4.00376L384.78 4.00329Z" fill="#6A9A23"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#6A9A23"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#6A9A23"/>
<path d="M334.463 4.5503C336.378 5.19843 337.423 5.25884 337.511 5.0037C337.601 4.73987 336.74 4.16619 334.878 3.42744C332.352 2.41678 329.793 1.3314 327.049 0.0858865C325.677 -0.538004 324.262 -1.20221 322.786 -1.92192C322.048 -2.2797 321.294 -2.65496 320.524 -3.04353C320.14 -3.23894 319.751 -3.43817 319.356 -3.63893C318.73 -3.96444 318.098 -4.29148 317.454 -4.62388C317.2 -4.26194 316.851 -3.76375 316.498 -3.26103C311.509 3.94451 310.444 5.82245 307.026 10.6635C306.168 11.8814 305.22 13.2246 304.201 14.6705C303.026 16.325 301.771 18.0935 300.448 19.9518C301.609 20.5877 302.784 21.2286 303.958 21.8717C304.893 22.3719 305.832 22.8675 306.756 23.3476C308.612 24.3051 310.431 25.2049 312.103 26.0042C315.451 27.6024 318.222 28.8037 319.543 29.3585C320.099 29.5978 320.659 29.8219 321.228 30.0371C323.093 30.7482 327.879 32.5742 334.242 34.4546C337.42 35.4002 340.99 36.3581 344.761 37.2377C346.647 37.6764 348.582 38.0983 350.545 38.4926C351.525 38.6909 352.513 38.8801 353.502 39.0629L354.99 39.3326L357.469 39.7598C357.512 39.0699 357.618 37.378 357.721 35.7072C358.398 24.2426 358.818 17.1477 359.038 13.4421C359.115 12.082 359.191 10.7661 359.248 9.7981C358.525 9.66145 357.813 9.53015 357.113 9.39776C356.669 9.31034 356.23 9.22673 355.799 9.14241C354.934 8.97185 354.095 8.79914 353.278 8.62651C351.643 8.27935 350.096 7.92461 348.607 7.56898C345.63 6.8513 342.892 6.12137 340.191 5.33367C338.504 4.84208 337.595 4.76975 337.515 5.00334C337.437 5.22408 338.192 5.75453 339.861 6.35052C342.533 7.30237 345.259 8.1655 348.242 8.98542C349.733 9.39329 351.289 9.78932 352.935 10.1691C353.757 10.3622 354.602 10.547 355.474 10.7316C356.136 10.8673 356.819 11.0053 357.52 11.1501C357.485 11.7344 357.434 12.5299 357.383 13.3484C357.181 16.7483 356.524 23.8217 355.888 33.8224C355.843 34.63 355.797 35.4334 355.753 36.2387L355.697 37.4437C355.695 37.5153 355.695 37.488 355.696 37.4963L355.7 37.5001L355.703 37.5145L355.713 37.5494C355.713 37.5494 355.699 37.5569 355.686 37.558C355.653 37.5567 355.753 37.5795 355.443 37.5309C355.007 37.4616 354.566 37.3928 354.124 37.3221C353.241 37.1783 352.344 37.0273 351.449 36.8615C349.654 36.5387 347.844 36.1753 346.062 35.7821C342.497 35.0063 339.05 34.1049 336.046 33.2323C333.043 32.3574 330.487 31.5173 328.681 30.8912C327.778 30.5729 327.064 30.3201 326.573 30.1465C326.083 29.9666 325.818 29.8678 325.818 29.8678C321.699 28.3743 317.646 26.705 313.653 24.9004C311.657 23.995 309.679 23.0544 307.719 22.0745C306.741 21.5843 305.762 21.0859 304.793 20.5802L303.34 19.8144L302.638 19.4367L309.085 10.2353C314.014 3.19229 316.386 -0.198457 317.845 -2.28256C317.896 -2.35617 317.946 -2.42977 317.981 -2.4811C318.602 -2.16773 319.205 -1.86541 319.791 -1.56997C320.573 -1.18248 321.337 -0.814374 322.09 -0.459944C323.592 0.247014 325.035 0.89203 326.437 1.48387C329.24 2.67399 331.869 3.6673 334.463 4.55447L334.463 4.5503Z" fill="#6A9A23"/>
<path d="M266.148 11.4377C265.904 11.241 261.607 11.6973 262.767 12.4218C263.152 12.7388 263.531 12.734 263.685 12.313C263.756 13.154 264.635 12.1 265.004 12.3981C264.83 12.9694 266.069 11.8383 265.807 12.4271C270.358 13.3709 279.961 8.3733 268.469 10.9842C269.573 11.3222 268.502 11.4793 268.006 11.3163C268.775 10.6232 266.63 11.1226 266.225 11.3524C266.878 11.3826 265.768 11.8565 266.15 11.4398L266.148 11.4377Z" fill="#101214"/>
<path d="M273.986 19.0467C273.385 19.0418 270.602 22.9468 270.26 23.3131C269.677 24.2322 271.049 24.4039 271.328 23.6053C271.45 23.4739 271.918 22.3416 272.164 22.8577C273.353 22.6833 273.656 20.6225 274.654 20.5627C274.514 20.2788 274.886 19.9778 274.819 19.7896C275.111 19.8418 275.301 19.4589 275.233 19.4186C276.559 18.4848 275.082 17.1701 274.308 18.5903C274.261 18.5239 273.902 18.7589 273.986 19.0428L273.986 19.0467Z" fill="#101214"/>
<path d="M288.709 27.7641C289.293 27.125 289.207 27.8367 288.919 28.1456C288.477 27.5052 288.381 28.9221 288.518 29.2965C288.558 29.1514 288.815 29.1459 288.75 29.4489C288.158 29.1232 287.385 32.9628 288.995 31.3767C289.003 31.3103 288.513 31.1909 288.68 31.1416C289.409 31.4079 288.987 30.7058 288.958 30.5243C289.347 30.5991 289.013 30.3704 289.181 30.3567C289.67 30.6613 288.959 29.5148 289.438 29.8463C290.383 29.1065 289.625 27.1642 290.464 26.62C289.666 25.994 291.452 23.4009 289.594 24.1887C289.01 25.3404 288.629 26.3014 288.709 27.7641Z" fill="#101214"/>
<path d="M278.52 33.4874C279.672 34.0122 279.857 31.3062 280.471 30.6733C281.323 29.9268 285.341 20.9746 282.563 22.9852C281.37 25.7048 279.916 27.7259 278.886 31.2063C278.677 31.7594 277.666 33.4114 278.52 33.4874Z" fill="#101214"/>
<path d="M272.605 3.22304C273.458 2.36044 274.245 3.76255 275.035 3.06901C276.28 1.6898 267.453 -0.415104 267.475 1.23084C267.685 2.64358 272.067 2.52653 272.605 3.22304Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_783_5660)">
<path d="M13.0459 23.9464C13.2244 23.8029 13.375 23.6514 13.5135 23.5051C13.6519 23.3588 13.7767 23.2242 13.8912 23.0925C14.1165 22.8338 14.2962 22.6063 14.4242 22.4127C14.6826 22.0273 14.7534 21.7777 14.657 21.6812C14.5605 21.5846 14.2987 21.6388 13.898 21.8582C13.6977 21.9679 13.4612 22.1206 13.1927 22.3159C13.0586 22.4156 12.9146 22.5225 12.7657 22.6446C12.6168 22.7666 12.4583 22.8999 12.2783 23.0267C11.7797 23.3994 11.2791 23.7743 10.7705 24.1541C10.2398 24.4959 9.70493 24.8382 9.16244 25.1894C8.60947 25.5164 8.02636 25.8104 7.44957 26.1289C7.15404 26.2784 6.84575 26.4016 6.5389 26.5415C6.23133 26.6731 5.92782 26.8274 5.60858 26.9453C5.28898 27.059 4.96332 27.1754 4.63765 27.2917C4.47464 27.3478 4.31044 27.4145 4.1448 27.4645C3.97464 27.5108 3.80449 27.557 3.63433 27.6032C3.29175 27.6937 2.94835 27.799 2.59636 27.8778C2.24139 27.9463 1.88225 28.0152 1.51931 28.0887C0.0606176 28.3263 -1.49813 28.4258 -3.12925 28.2944C-3.56103 28.2752 -3.97141 28.2121 -4.35537 28.1636C-4.54794 28.1446 -4.73171 28.106 -4.90643 28.075C-4.9938 28.0595 -5.08116 28.0439 -5.16436 28.0281C-5.22411 28.0165 -5.28576 28.0071 -5.34551 27.9955C-5.43287 27.98 -5.5081 27.9593 -5.58713 27.943C-6.21656 27.7731 -6.77491 27.6242 -7.25162 27.4977C-7.70977 27.3675 -8.08591 27.2637 -8.36563 27.183C-8.05452 28.2597 -7.73595 29.277 -7.45896 30.2014C-7.28585 30.7487 -7.12621 31.2616 -6.97515 31.7478C-6.68674 32.6587 -6.42815 33.4671 -6.18005 34.2514C-5.68384 35.8198 -5.22994 37.287 -4.66961 39.2338C-4.04204 41.3763 -3.32537 43.895 -2.58721 46.5167C-2.22004 47.8299 -1.84428 49.1695 -1.4715 50.499C-1.25363 51.2732 -1.04029 52.0436 -0.825398 52.8077C-0.802628 52.877 -0.789367 52.9577 -0.758627 53.0222L-0.551516 53.0882L-0.137285 53.2201L0.276945 53.3521L0.53893 53.4217C0.71283 53.4675 0.884474 53.5113 1.05837 53.5571C1.23346 53.5923 1.40628 53.6256 1.57946 53.663C4.36235 54.2065 7.04848 53.896 9.14027 53.3601C9.66062 53.2143 10.1485 53.0566 10.6086 52.9181C11.0609 52.7614 11.4697 52.5875 11.8496 52.4433C12.2341 52.303 12.5622 52.1424 12.8562 51.9994C13.1502 51.8564 13.4062 51.7356 13.6198 51.6331C13.8785 51.5184 14.1157 51.374 14.3552 51.2316L15.0752 50.7978C15.254 50.6816 15.4828 50.561 15.7156 50.3898C15.9507 50.2204 16.2176 50.0315 16.5119 49.8192C16.8017 49.6032 17.1399 49.3892 17.4667 49.1154C17.7957 48.8435 18.1502 48.5505 18.5283 48.2387C18.716 48.0797 18.9169 47.928 19.1073 47.752C19.2955 47.5741 19.4897 47.3936 19.6897 47.2064C20.0835 46.8344 20.499 46.4459 20.9358 46.0366C21.3513 45.6481 21.7823 45.2457 22.2305 44.8228C22.6881 44.4118 23.1922 44.0282 23.6952 43.609C23.943 43.3924 24.219 43.2111 24.4958 43.015C24.7708 42.8212 25.0517 42.6248 25.3346 42.4262C25.4725 42.3219 25.6221 42.2313 25.772 42.1449C25.9215 42.0543 26.0733 41.9656 26.2248 41.8727C26.5303 41.693 26.8325 41.499 27.1493 41.3288C28.4302 40.6597 29.8119 40.0405 31.3018 39.605C32.7947 39.1798 34.3762 38.9063 36.0024 38.8598C36.8156 38.8249 37.6359 38.8734 38.4607 38.9488L39.0913 39.0347L39.4056 39.0788L40.0042 39.2074C40.8225 39.3777 41.6365 39.5716 42.4509 39.7695C42.1544 38.7398 41.401 36.1362 40.667 33.5875C37.7264 23.5317 35.9053 17.3068 34.9535 14.0573C34.9552 13.7613 34.6651 13.8032 34.4682 13.7342C34.2584 13.6853 34.0485 13.6363 33.8387 13.5874L33.6803 13.5507C33.6311 13.5403 33.6141 13.5376 33.5778 13.5303L33.3902 13.4962L33.0173 13.4299C32.7696 13.38 32.5206 13.3638 32.2744 13.3306L31.9055 13.287L31.5408 13.2662C30.5668 13.1891 29.6218 13.2521 28.7074 13.3293C26.8858 13.5438 25.2051 14.0042 23.6927 14.641C23.3041 14.7817 22.9496 14.9782 22.5817 15.1402C22.4004 15.2272 22.2187 15.3101 22.0393 15.3949C21.8648 15.4877 21.6929 15.5865 21.5206 15.6812C21.1787 15.8766 20.8406 16.0675 20.5024 16.2583C20.1809 16.4708 19.8612 16.6811 19.5415 16.8914C19.3828 16.9974 19.226 17.1013 19.0692 17.2051C18.9128 17.3131 18.7677 17.4305 18.618 17.5442C18.321 17.7735 18.0236 17.9986 17.7304 18.2234C17.4281 18.4405 17.165 18.6983 16.8834 18.9367C16.6064 19.179 16.3335 19.4208 16.0565 19.6631C14.9003 20.7809 14.4954 21.5106 14.6627 21.6744C14.8371 21.8481 15.5686 21.4742 16.7575 20.4689C17.0367 20.2516 17.3182 20.0363 17.6015 19.8187C17.8853 19.6053 18.1547 19.3721 18.455 19.1803C18.7503 18.9805 19.0435 18.7789 19.3427 18.5746C19.4915 18.4757 19.6354 18.3688 19.7888 18.2736C19.9425 18.1827 20.0981 18.0895 20.256 17.9982C20.5672 17.8117 20.8807 17.6272 21.1938 17.4384C21.5194 17.2717 21.8468 17.1028 22.1765 16.9357C22.3434 16.852 22.5062 16.7687 22.675 16.6827C22.8449 16.6092 23.0189 16.5354 23.193 16.4615C23.5419 16.3222 23.8814 16.148 24.2446 16.0284C25.6722 15.4787 27.2231 15.0945 28.8787 14.9259C29.7068 14.8688 30.5609 14.822 31.436 14.8972L31.7652 14.919L32.0939 14.9598C32.3148 14.991 32.5385 15.0052 32.7585 15.0512C32.959 15.0883 33.1636 15.1252 33.3663 15.1642L33.4906 15.1954C33.5296 15.2088 33.5901 15.2057 33.5831 15.2462C33.7626 15.8915 33.9886 16.7112 34.2604 17.6969C34.563 18.8205 34.9173 20.1306 35.3166 21.6214C36.1212 24.6004 37.1258 28.2922 38.3635 32.5933C38.7677 33.9956 39.1924 35.3918 39.6324 36.77L39.7103 37.0171L39.7503 37.1396C39.7503 37.1396 39.7548 37.1434 39.757 37.1453C39.7661 37.1529 39.7713 37.165 39.7789 37.179C39.7935 37.203 39.816 37.2451 39.8321 37.2856C39.8094 37.2897 39.7776 37.2862 39.7337 37.2879L39.7 37.2866L39.6811 37.2861L39.5858 37.2755L39.0005 37.2045C38.6159 37.1477 38.1999 37.1418 37.8004 37.1071C37.3951 37.0793 36.9912 37.0913 36.5855 37.0824C34.9651 37.099 33.3478 37.3232 31.8071 37.7043C28.7091 38.445 25.9889 39.9166 23.8329 41.4107C23.5617 41.6 23.2986 41.7843 23.0374 41.9664C22.7852 42.1562 22.5484 42.355 22.3129 42.5433C22.0774 42.7316 21.8479 42.9172 21.6222 43.0984C21.5105 43.1899 21.3985 43.2772 21.2906 43.3642C21.1876 43.4592 21.0865 43.5519 20.9873 43.6423C20.2001 44.3673 19.5102 45.0041 18.937 45.5343C18.6591 45.7913 18.4082 46.0207 18.1904 46.2201C18.0817 46.3218 17.9806 46.4145 17.8871 46.4981C17.7891 46.578 17.6987 46.6488 17.6204 46.7143C17.3005 46.9707 17.13 47.1093 17.13 47.1093C17.13 47.1093 16.8416 47.342 16.3261 47.7623C16.0647 47.9675 15.7272 48.1898 15.3418 48.4645C15.15 48.6007 14.9442 48.7445 14.7266 48.8976C14.509 49.0508 14.2624 49.1833 14.0092 49.3375C13.758 49.4894 13.4926 49.6487 13.2175 49.8153C12.9446 49.9837 12.637 50.1153 12.3319 50.276C12.0216 50.4246 11.7142 50.6065 11.3733 50.741C11.037 50.8792 10.6885 51.0228 10.3339 51.1689C8.89465 51.7049 7.25528 52.1345 5.51244 52.2646C4.64192 52.34 3.74838 52.3189 2.85551 52.2326L2.18746 52.1499L1.52224 52.0271C1.30062 51.9876 1.08518 51.9223 0.864745 51.8722L0.70406 51.8337L0.64585 51.8157L0.529429 51.7796C0.476824 51.7779 0.495606 51.728 0.478692 51.7022L0.439583 51.565L0.23949 50.8752C0.105343 50.4147 -0.0284482 49.9584 -0.162235 49.5021C-0.429811 48.5895 -0.692493 47.6848 -0.951844 46.7946C-1.99079 43.24 -2.95224 39.9515 -3.66507 37.5017L-5.03013 32.8424L-5.71171 30.5116L-5.92228 29.7975L-5.96736 29.6399L-5.99086 29.5622L-6.00278 29.5213C-6.00278 29.5213 -6.02077 29.4829 -6.00077 29.4959C-5.91685 29.5201 -5.83258 29.5485 -5.74485 29.5681L-5.6163 29.599L-5.29637 29.6594C-5.12807 29.6888 -4.95906 29.7266 -4.78886 29.7539L-4.27933 29.823L-3.7698 29.8921L-3.25864 29.9317C-1.47352 30.0729 0.223859 29.9509 1.8069 29.671C2.20054 29.5886 2.59002 29.5066 2.97117 29.4253C3.3535 29.3334 3.71855 29.2115 4.08731 29.1082C4.27151 29.0545 4.45344 28.9988 4.63347 28.9455C4.81315 28.8879 4.98721 28.8141 5.162 28.7486C5.51122 28.6134 5.85438 28.4808 6.19753 28.3483C6.53616 28.2119 6.85488 28.0395 7.17958 27.8876C7.49939 27.7277 7.82481 27.584 8.13331 27.4146C8.73565 27.0519 9.34051 26.7183 9.90882 26.3501C10.4625 25.958 11.0127 25.5746 11.5478 25.1862C12.0546 24.7625 12.5558 24.3455 13.0547 23.9267L13.0459 23.9464Z" fill="#6A9A23"/>
<path d="M114.495 48.3233C112.222 47.5594 111.865 48.4842 114.065 49.4412C115.623 50.1181 117.228 50.7952 118.977 51.5123C119.855 51.8642 120.766 52.2322 121.724 52.617C122.269 52.8321 122.83 53.0521 123.405 53.2771C123.642 53.3719 123.882 53.4581 124.118 53.5446L124.298 53.6109L124.387 53.6431L124.432 53.658C124.448 53.6672 124.451 53.6354 124.461 53.6282L124.677 53.3074C124.82 53.0915 124.962 52.8714 125.107 52.6532C125.214 52.4803 125.323 52.3051 125.431 52.1299C126.78 49.8413 127.434 48.3201 127.986 46.9923C128.522 45.6576 128.956 44.5121 129.531 42.8088C130.002 41.3663 130.481 39.6442 130.752 37.7826C131.029 35.9289 131.072 33.9297 130.72 32.0614C130.685 31.8273 130.618 31.6003 130.566 31.3718L130.485 31.0327C130.452 30.9243 130.42 30.8201 130.388 30.7117C130.257 30.2887 130.129 29.8759 130.004 29.4734C129.871 29.0758 129.708 28.6954 129.569 28.3277C129.497 28.143 129.427 27.9644 129.357 27.79C129.273 27.619 129.194 27.4517 129.115 27.2886C128.956 26.9624 128.812 26.6518 128.666 26.3665C128.501 26.0891 128.349 25.8296 128.209 25.592C127.945 25.1071 127.656 24.7566 127.474 24.4912L127.134 24.0276L126.744 23.5997C126.627 23.4736 126.483 23.3223 126.319 23.1456C126.159 22.9644 125.94 22.7924 125.717 22.5851C125.273 22.162 124.688 21.7197 124.013 21.241C122.649 20.2913 120.829 19.3789 118.787 18.5467C117.766 18.1211 116.69 17.7191 115.586 17.3008C115.27 17.1814 114.951 17.06 114.628 16.9391C114.367 16.8399 114.105 16.7389 113.84 16.6401L113.446 16.4897L113.246 16.4147L113.146 16.3772L113.096 16.3584C113.096 16.3584 113.082 16.389 113.075 16.4064C112.755 17.2378 112.429 18.0802 112.103 18.9267C111.218 21.2191 110.304 23.5645 109.412 25.8156C108.794 27.4093 108.234 28.851 107.732 30.1514C107.421 30.9526 107.128 31.7103 106.85 32.4268C106.745 32.6982 106.644 32.965 106.543 33.2276L106.506 33.3274C106.489 33.3478 106.52 33.3471 106.533 33.3544L106.583 33.3731L106.78 33.4463C106.91 33.4938 107.038 33.5435 107.168 33.591C107.634 33.7625 108.085 33.9291 108.525 34.0903C109.559 34.458 110.424 34.7754 111.129 35.0899C111.836 35.4021 112.382 35.7072 112.788 35.9826C113.763 36.6283 114.417 37.4256 114.721 38.3225C115.031 39.2209 115.01 40.211 114.85 41.1627C114.514 43.0782 113.723 44.8274 112.888 46.5008C112.427 47.3926 112.339 47.952 112.53 48.0971L112.524 48.1921C112.543 48.1967 112.555 48.1914 112.562 48.174L112.566 48.1192C112.77 48.2253 113.25 47.9025 113.813 47.0312C114.839 45.3874 115.819 43.6386 116.32 41.4445C116.554 40.3541 116.654 39.1054 116.251 37.8205C116.047 37.1856 115.719 36.5657 115.278 36.0207C114.838 35.4734 114.298 35.004 113.712 34.6079C113.257 34.2948 112.658 33.946 111.931 33.5894C111.201 33.2309 110.34 32.8775 109.378 32.5014C109.259 32.4551 109.137 32.4069 109.015 32.3587L108.972 32.3415L108.965 32.3358L108.952 32.3285L108.932 32.3114L108.894 32.2874C108.885 32.2798 108.864 32.2774 108.883 32.2548C108.905 32.2235 108.922 32.1989 108.937 32.1767C109.05 31.9046 109.164 31.6303 109.285 31.345C109.769 30.1721 110.29 28.891 110.842 27.5045C111.2 26.6006 111.535 25.6882 111.85 24.7754C112.189 23.7893 112.548 22.774 112.917 21.7433C113.278 20.7489 113.644 19.7394 114.005 18.745L114.061 18.5681C114.061 18.5681 114.066 18.5489 114.07 18.5485L114.092 18.555L114.135 18.5681L114.223 18.5961L114.268 18.611L114.292 18.6194L114.381 18.6516L114.756 18.7891C115.003 18.881 115.248 18.9709 115.491 19.0632C115.976 19.2435 116.451 19.4227 116.91 19.6032C117.372 19.7793 117.813 19.9613 118.238 20.1365C119.943 20.8405 121.328 21.5682 122.259 22.1505C122.71 22.4597 123.088 22.685 123.314 22.8752C123.546 23.0587 123.675 23.1587 123.675 23.1587C123.675 23.1587 123.72 23.1968 123.812 23.2665C123.898 23.3387 124.044 23.4309 124.196 23.5815C124.355 23.7271 124.549 23.9055 124.772 24.1127C124.829 24.1644 124.886 24.2161 124.948 24.2717C125.001 24.3321 125.059 24.3921 125.117 24.4563C125.233 24.5848 125.355 24.7189 125.483 24.861C126.504 25.9978 127.669 27.8 128.462 30.0309C128.555 30.3103 128.651 30.5957 128.747 30.8812C128.839 31.167 128.95 31.4574 129.012 31.7415C129.087 32.0288 129.164 32.3138 129.211 32.6119L129.291 33.0539C129.312 33.2032 129.325 33.3531 129.347 33.5023C129.488 34.7029 129.464 35.9345 129.335 37.1165C129.074 39.485 128.427 41.6372 127.869 43.2046C127.024 45.5691 126.192 47.2486 125.546 48.5173C124.889 49.7808 124.393 50.6273 124.007 51.2609C123.939 51.3738 123.871 51.4825 123.805 51.589L123.775 51.6377C123.775 51.6377 123.741 51.6281 123.724 51.6254L123.618 51.5863C123.167 51.4156 122.729 51.2521 122.3 51.0921C121.329 50.7356 120.408 50.3979 119.52 50.072C117.742 49.4309 116.096 48.8581 114.486 48.3157L114.495 48.3233Z" fill="#6A9A23"/>
<path d="M63.2213 11.0802C64.3036 11.4417 64.931 11.4901 65.0627 11.2416C65.1871 11.0063 64.7809 10.4561 63.6473 9.96267C62.8457 9.6209 62.0109 9.33237 61.1289 9.10458C60.2473 8.88095 59.3135 8.7101 58.3289 8.65487C57.8413 8.59642 57.3321 8.62798 56.8151 8.61824C56.558 8.63003 56.296 8.65694 56.0313 8.67778C55.898 8.68934 55.7647 8.70089 55.6314 8.71245C55.497 8.7346 55.3648 8.75864 55.2303 8.78079C54.1508 8.93941 53.0339 9.27124 51.9327 9.78634C51.7776 9.86063 51.624 9.9285 51.4775 10.0062C51.3356 10.0878 51.1978 10.169 51.0597 10.246C50.7857 10.4019 50.528 10.5523 50.2994 10.7231C50.0662 10.8902 49.8377 11.038 49.6378 11.2022C49.4383 11.3706 49.2487 11.5318 49.0667 11.684C48.7053 11.9944 48.4124 12.3198 48.1181 12.6055C47.8555 12.9178 47.5991 13.2044 47.3722 13.4927C46.4759 14.6552 45.8317 15.7244 45.0325 17.3317C44.3767 18.7042 43.7657 20.377 43.3437 22.174C42.9124 23.9592 42.6876 25.9258 42.8109 27.7679C42.9178 29.6155 43.3565 31.3442 43.9484 32.684C44.5304 34.031 45.2423 34.9618 45.621 35.485C45.8706 35.776 46.1183 36.0692 46.3915 36.3414C46.8871 36.8083 47.8267 37.6795 49.2654 38.4989C49.6286 38.6962 50.0023 38.9177 50.4196 39.1102C50.8332 39.3072 51.2794 39.4931 51.7434 39.6669C52.6774 40.0119 53.698 40.3137 54.8094 40.5258C57.0183 40.9575 59.6288 40.962 62.1114 40.1404C63.3524 39.7391 64.5396 39.1263 65.6002 38.3608C66.6654 37.5991 67.6064 36.6867 68.4118 35.7104C69.54 34.318 70.3115 32.8999 70.9125 31.5972C71.4954 30.2794 71.8779 29.0712 72.1641 27.9868C72.4458 26.8986 72.6224 25.9307 72.7077 25.0945C72.8141 24.2606 72.8305 23.5521 72.8419 22.9783C72.8528 20.2602 72.1712 17.8559 71.051 15.9366C70.4777 14.9834 69.8234 14.1357 69.0796 13.4176C68.3284 12.7126 67.5418 12.0821 66.6795 11.5966C66.2508 11.3211 65.8679 11.2117 65.5987 11.1553C65.3256 11.1034 65.1518 11.1311 65.0821 11.2231L65.145 11.3687C65.1232 11.335 65.0952 11.3269 65.0588 11.3426L65.0431 11.3062C65.0108 11.4181 65.0816 11.582 65.2604 11.7826C65.4355 11.9877 65.7286 12.1994 66.0982 12.4947C66.8482 13.0172 67.5077 13.6566 68.1348 14.3346C68.7505 15.0261 69.282 15.813 69.7486 16.6727C70.2113 17.5369 70.5551 18.5059 70.8114 19.5559C71.0594 20.6065 71.2063 21.7499 71.1886 22.9789C71.1966 23.2174 71.1654 23.4887 71.1497 23.7922C71.1381 24.0954 71.0911 24.4268 71.0364 24.7903C70.948 25.5156 70.767 26.3601 70.5057 27.2954C69.9645 29.1699 69.1073 31.4663 67.5012 33.7163L67.3088 33.9911L67.1005 34.2525L66.6908 34.7811C66.3873 35.1054 66.1203 35.4642 65.8002 35.7668C65.6299 35.9327 65.4716 36.1164 65.2858 36.273C65.1023 36.4316 64.9187 36.5902 64.7333 36.7511C64.3409 37.0432 63.9478 37.35 63.5114 37.5935C62.6552 38.102 61.7221 38.5228 60.7441 38.7629C58.7947 39.2718 56.7658 39.2231 55.0396 38.865C53.3077 38.5136 51.8735 37.9413 50.9288 37.4483C50.4595 37.1889 50.0869 36.9799 49.8427 36.8249C49.602 36.6611 49.4726 36.5716 49.4726 36.5716C49.4726 36.5716 49.4235 36.5381 49.3322 36.4768C49.2405 36.4113 49.0971 36.3293 48.9364 36.1942C48.772 36.0637 48.5714 35.9027 48.3372 35.7174C48.1201 35.5117 47.8736 35.2813 47.5996 35.0239C47.0988 34.4714 46.5061 33.8031 46.0168 32.9475C45.52 32.1009 45.0877 31.1039 44.7938 30.0068C44.1804 27.8107 44.2512 25.251 44.7058 22.956C45.1626 20.6398 45.9616 18.5919 46.736 17.184C47.8904 15.0487 49.1258 13.7309 50.1581 12.8798C51.1942 12.0241 52.0123 11.5839 52.6484 11.2959C53.6061 10.8457 54.5704 10.5439 55.5178 10.3862C55.6356 10.3655 55.753 10.3406 55.8686 10.318C55.9871 10.3057 56.1034 10.2914 56.2219 10.279C56.4548 10.2546 56.6851 10.2242 56.9142 10.2043C57.3752 10.1979 57.8243 10.1506 58.2681 10.1877C60.0484 10.2243 61.691 10.5855 63.2383 11.0829L63.2213 11.0802Z" fill="#6A9A23"/>
<path d="M149.643 57.1462C149.707 57.1386 149.772 57.135 149.834 57.1296C149.897 57.1284 149.958 57.1335 150.017 57.1368C150.136 57.1434 150.255 57.1393 150.367 57.1485C150.584 57.1884 150.799 57.195 150.983 57.2609C151.077 57.2863 151.167 57.3078 151.257 57.3294C151.342 57.3619 151.422 57.3948 151.5 57.4216C151.58 57.4504 151.654 57.4776 151.725 57.5028C151.793 57.5368 151.859 57.5689 151.92 57.5972C152.179 57.7027 152.367 57.8102 152.516 57.8582C152.665 57.9103 152.768 57.9119 152.818 57.8655C152.869 57.8192 152.863 57.7211 152.795 57.5675C152.727 57.4139 152.604 57.2022 152.364 56.9733C152.304 56.9155 152.242 56.8517 152.176 56.7882C152.104 56.7315 152.021 56.6736 151.936 56.6138C151.851 56.554 151.758 56.4908 151.66 56.4279C151.555 56.3783 151.444 56.3271 151.328 56.2721C151.099 56.1534 150.826 56.0974 150.536 56.0197C150.391 55.9903 150.237 55.9806 150.078 55.9629C149.999 55.955 149.919 55.9452 149.837 55.9418C149.757 55.9445 149.674 55.9476 149.59 55.9506C148.636 55.9788 147.736 56.254 146.905 56.6177C146.068 56.9798 145.315 57.471 144.572 57.9823C144.209 58.2488 143.842 58.5115 143.498 58.8057C143.142 59.0862 142.801 59.3864 142.46 59.695L142.203 59.9229C142.117 59.9975 142.015 60.1008 141.928 60.1902C141.84 60.2818 141.755 60.373 141.675 60.4639L141.463 60.7068L141.37 60.8029C141.341 60.8285 141.308 60.8776 141.28 60.8192L141.196 60.7216L141.177 60.698L141.059 60.5718L140.819 60.3157C140.497 59.9722 140.173 59.6226 139.843 59.2714C139.187 58.5688 138.512 57.8509 137.823 57.1133C136.438 55.6471 134.985 54.105 133.447 52.4758C133.366 52.3925 133.286 52.3093 133.205 52.2261L133.16 52.188C133.113 52.1606 133.152 52.1278 133.173 52.0987L133.224 52.0376C133.316 51.9373 133.407 51.8393 133.497 51.7413C133.679 51.5471 133.86 51.3593 134.04 51.1738C134.763 50.4418 135.456 49.7649 136.09 49.1581C137.34 47.9418 138.448 46.9918 139.511 46.1548C140.576 45.3197 141.597 44.587 142.741 43.9067C143.884 43.2263 145.144 42.5737 146.712 41.9993C147.041 41.8701 147.387 41.775 147.733 41.6568C148.083 41.5489 148.444 41.4588 148.809 41.36C149.549 41.1973 150.314 41.0408 151.105 40.9722C152.687 40.8036 154.367 40.8909 156.008 41.2858C157.649 41.6806 159.244 42.388 160.67 43.3471C162.105 44.2991 163.355 45.4853 164.442 46.7697C165.532 48.0453 166.437 49.3937 167.101 50.744C167.769 52.094 168.2 53.4415 168.453 54.689C168.707 55.9385 168.791 57.0831 168.821 58.0542C168.854 59.0248 168.81 59.826 168.784 60.399L168.72 61.4389C168.704 61.7886 168.699 62.1626 168.693 62.5093C168.686 63.1141 168.656 63.9581 168.694 65.1446C168.711 65.7348 168.755 66.4171 168.886 67.1989C169.02 67.9762 169.253 68.8834 169.791 69.7915C170.053 70.2472 170.391 70.6816 170.799 71.0868C171.204 71.5007 171.727 71.8667 172.326 72.1546C172.941 72.4245 173.637 72.5655 174.345 72.5693C175.051 72.5605 175.743 72.4082 176.418 72.1881C177.747 71.7099 178.979 70.9338 180.172 69.9974C180.767 69.5283 181.354 69.0136 181.936 68.4638C182.23 68.1929 182.508 67.9211 182.801 67.6419C182.857 67.5887 182.911 67.5337 182.968 67.4805L183.01 67.4391C183.026 67.4524 183.042 67.4657 183.06 67.481L183.076 67.4943L183.085 67.5019L183.154 67.5756C183.256 67.6801 183.36 67.7907 183.472 67.9047C183.91 68.3619 184.42 68.8906 184.982 69.4797C186.108 70.6578 187.46 72.0766 188.952 73.6405C189.633 74.3557 190.346 75.1059 191.082 75.8793C191.101 75.907 191.162 75.9353 191.113 75.9669L191.075 76.0121L190.913 76.1856C190.524 76.6075 190.105 77.0278 189.673 77.445C189.235 77.8649 188.793 78.2851 188.349 78.7117C187.9 79.1179 187.462 79.5461 186.997 79.9389C186.087 80.7501 185.126 81.5027 184.164 82.2239C181.541 84.1593 178.922 85.5424 176.438 86.3284C173.956 87.1228 171.629 87.2992 169.639 87.0479C168.643 86.9245 167.728 86.7079 166.902 86.427C166.08 86.1373 165.338 85.8072 164.678 85.449C163.359 84.7303 162.368 83.9392 161.596 83.2591C160.691 82.4521 159.878 81.572 159.161 80.6753C158.43 79.7861 157.823 78.8547 157.303 77.9115C156.265 76.0228 155.669 74.0497 155.387 72.0934C155.235 71.1162 155.172 70.1397 155.141 69.1751C155.104 68.2089 155.139 67.2533 155.147 66.279C155.152 65.3092 155.16 64.358 155.127 63.3873C155.092 62.4231 155.005 61.4381 154.757 60.4609C154.485 59.4059 153.996 58.6741 153.603 58.2822C153.412 58.0785 153.232 57.9619 153.1 57.8936C152.968 57.8253 152.879 57.812 152.832 57.8497L152.701 57.8442C152.697 57.8635 152.703 57.8692 152.722 57.8655L152.829 57.8436L152.808 57.8685C152.77 57.9138 152.772 58.008 152.817 58.1426C152.86 58.2752 152.946 58.4482 153.042 58.6791C153.244 59.1316 153.527 59.7785 153.718 60.7041C153.889 61.5705 153.936 62.4792 153.926 63.4054C153.92 64.3312 153.872 65.2838 153.833 66.2398C153.722 68.1482 153.636 70.1889 153.902 72.2935C154.151 74.3995 154.77 76.593 155.881 78.6747C156.437 79.7134 157.093 80.7371 157.873 81.7018C158.641 82.6759 159.501 83.6149 160.49 84.5006C161.26 85.1829 162.28 86.0177 163.649 86.8244C165.02 87.6183 166.762 88.3758 168.863 88.7476C170.959 89.1156 173.393 89.0683 175.922 88.44C178.453 87.8219 181.043 86.6301 183.565 85.0036C185.208 83.94 186.742 82.7265 188.162 81.4284C188.478 81.1492 188.784 80.8541 189.092 80.5567C189.402 80.2613 189.714 79.9636 190.011 79.665C190.619 79.0668 191.235 78.4573 191.845 77.8107L192.299 77.316C192.345 77.2617 192.523 77.0679 192.639 76.9257L193.021 76.4708L193.391 76.0086L193.486 75.8955C193.48 75.8561 193.425 75.821 193.399 75.7834L193.195 75.566C192.933 75.2761 192.65 74.988 192.374 74.7014C191.761 74.0705 191.146 73.4377 190.534 72.8068C189.331 71.5598 188.135 70.3226 186.969 69.1144C185.625 67.7139 184.318 66.348 183.066 65.0444C182.442 65.6398 181.829 66.2259 181.227 66.8048C181.016 67.0098 180.808 67.2062 180.602 67.3919C180.393 67.5799 180.196 67.7733 179.987 67.9488C179.164 68.6706 178.326 69.2951 177.498 69.7927C176.67 70.2863 175.836 70.6439 175.066 70.7841C174.293 70.9266 173.6 70.8461 173.042 70.5966C172.477 70.3497 172.045 69.936 171.712 69.5326C171.383 69.1289 171.169 68.7362 171.022 68.3965C170.949 68.2266 170.901 68.067 170.85 67.9351C170.811 67.7937 170.778 67.677 170.753 67.5826C170.724 67.4886 170.713 67.4098 170.7 67.3606C170.689 67.309 170.683 67.2844 170.683 67.2844C170.683 67.2844 170.655 67.1757 170.62 66.9647C170.602 66.8571 170.582 66.7245 170.558 66.5692C170.542 66.409 170.522 66.2261 170.5 66.0182C170.428 65.181 170.429 63.9304 170.475 62.3506C170.48 61.578 170.559 60.7172 170.575 59.7653C170.586 58.816 170.584 57.7985 170.473 56.7275C170.366 55.6562 170.183 54.5328 169.879 53.3967C169.563 52.2616 169.12 51.1208 168.563 50.0109C168.013 48.8919 167.297 47.8419 166.532 46.8276C166.332 46.5785 166.135 46.3312 165.933 46.0802C165.729 45.8356 165.508 45.603 165.296 45.3632C165.082 45.1258 164.871 44.886 164.637 44.6587C164.41 44.4287 164.184 44.1965 163.941 43.9846C162.045 42.2207 159.744 40.834 157.312 40.1068C154.881 39.3649 152.383 39.3003 150.19 39.631C147.983 39.9545 146.071 40.6532 144.51 41.353C142.165 42.4333 140.292 43.6636 138.737 44.8286C137.183 45.9978 135.935 47.0964 134.891 48.0807C133.859 49.0556 132.992 49.8798 132.263 50.6501C132.173 50.7481 132.085 50.8439 131.996 50.9355C131.87 51.0807 131.724 51.2361 131.601 51.3915C131.474 51.5473 131.351 51.6986 131.228 51.8498C131.165 51.9245 131.108 52.0008 131.048 52.0732C131.006 52.1461 130.87 52.225 130.986 52.2883C131.232 52.5607 131.465 52.8217 131.709 53.0734C131.889 53.2634 132.062 53.4477 132.23 53.624C133.778 55.2461 135.238 56.775 136.632 58.2363C137.33 58.9626 138.015 59.6733 138.681 60.3688C139.015 60.7154 139.345 61.0583 139.674 61.3969C139.865 61.5964 140.056 61.7918 140.245 61.9894L140.649 62.4098C140.784 62.5428 140.916 62.6615 141.049 62.7885L141.247 62.9748L141.299 63.0185L141.32 63.044C141.325 63.0478 141.329 63.0516 141.332 63.0535L141.343 63.0399L141.444 62.943L141.83 62.5529C142.085 62.3 142.335 62.0077 142.564 61.7213C142.888 61.3177 143.089 61.0967 143.437 60.779C143.751 60.4791 144.068 60.1851 144.395 59.9113C144.712 59.6257 145.047 59.3701 145.374 59.1088C146.043 58.6165 146.72 58.1424 147.435 57.8013C148.146 57.4564 148.886 57.2055 149.62 57.1503L149.643 57.1462Z" fill="#6A9A23"/>
<path d="M80.321 25.3809C80.4416 23.1064 79.4571 23.0281 79.1312 25.2574C78.8942 26.839 78.6434 28.4554 78.3341 30.1965C78.018 31.9318 77.6635 33.8048 77.0533 35.8028C76.9621 36.1317 76.8558 36.4326 76.7629 36.7176C76.7418 36.7887 76.7161 36.8559 76.6904 36.9232C76.6579 37.0079 76.6295 37.0922 76.5966 37.1726C76.5069 37.4217 76.4055 37.6571 76.3015 37.8865C75.8871 38.7743 75.5595 39.4762 75.3454 39.9375C76.5743 39.8079 77.6597 39.6697 78.5962 39.5571C79.1374 39.4829 79.6268 39.4153 80.1059 39.3507C81.0599 39.2218 81.9734 39.109 83.1533 38.9963C85.9529 38.7116 89.7215 38.3996 93.0728 38.1385C93.9107 38.0743 94.7237 38.0122 95.4885 37.9522C95.6782 37.9379 95.8679 37.9235 96.0534 37.9095C96.3908 37.8803 96.7199 37.8518 97.0447 37.8236C97.2132 37.8069 97.3821 37.7943 97.5465 37.778L97.6089 37.7726C97.6204 37.759 97.6182 37.734 97.6228 37.7147L97.6419 37.5956L97.6801 37.3573C97.73 37.0361 97.7788 36.7255 97.826 36.4214C97.9332 35.7428 98.0279 35.1387 98.1097 34.628C98.1809 34.1392 98.241 33.7417 98.2835 33.4568C98.332 33.119 98.3699 32.78 98.4014 32.4394C98.4496 31.9044 98.5308 30.972 98.6212 29.7346C98.6626 29.1205 98.7101 28.4302 98.7605 27.6768C98.8248 26.9389 98.9042 26.1326 98.9956 25.2707C99.1893 23.5523 99.4495 21.6308 99.8761 19.6446C100.088 18.6526 100.35 17.6438 100.688 16.6576C100.777 16.415 100.869 16.172 100.959 15.9271L101.111 15.5677L101.185 15.3871C101.19 15.3678 101.226 15.3017 101.255 15.2447L101.343 15.0755L101.695 14.3903C101.746 14.2788 101.822 14.1569 101.901 14.0346L102.126 13.671C102.421 13.1964 102.713 12.72 103.01 12.2431C102.93 12.2417 102.807 12.2544 102.664 12.2689C102.522 12.2812 102.364 12.2991 102.189 12.3143C101.84 12.3487 101.434 12.3902 100.989 12.433C100.271 12.5015 99.4285 12.5851 98.594 12.6637C92.1629 13.3177 88.1819 13.7215 86.104 13.9331C84.8775 14.0646 83.7301 14.1892 82.6387 14.3069C81.9634 14.3843 81.3068 14.4581 80.6649 14.5326L80.3138 14.5735L80.1393 14.5928L80.054 14.6023C80.054 14.6023 80.0158 14.5972 80.0195 14.6158L80.0129 14.6604C79.9849 14.8958 79.9566 15.1269 79.9306 15.36C79.9042 15.5889 79.8778 15.8178 79.8514 16.0467C79.8379 16.1821 79.824 16.3134 79.8105 16.4489C79.6178 18.4463 79.5162 20.2848 79.4719 22.1057C79.4328 24.1087 80.2926 24.1517 80.5363 22.1855C80.7678 20.3945 81.0108 18.59 81.2991 16.6304C81.3163 16.5135 81.3335 16.3966 81.3507 16.2797L81.3736 16.156L81.3968 16.0365C81.4245 16.0173 81.4801 16.0293 81.5173 16.0219L81.6426 16.0152C81.7592 16.0051 81.8758 15.995 81.9924 15.9849C82.259 15.9618 82.5275 15.9364 82.8005 15.9148C83.891 15.8119 85.0441 15.7036 86.2698 15.5868C88.1772 15.3942 92.1765 15.2259 97.792 14.7013C98.2499 14.6575 98.7073 14.6094 99.1621 14.5553L99.459 14.5191C99.459 14.5191 99.4628 14.5146 99.4666 14.51C99.4723 14.5032 99.4841 14.4938 99.5061 14.4814C99.5282 14.469 99.5786 14.4458 99.6074 14.4391C99.6134 14.4595 99.619 14.4758 99.5928 14.562L99.5732 14.6267L99.4323 14.9872C99.3335 15.2287 99.2457 15.4755 99.1662 15.7216C98.8317 16.7074 98.5712 17.7014 98.3498 18.6858C97.9192 20.6493 97.6406 22.5514 97.4316 24.2145C97.2283 25.8708 97.0684 27.301 96.9964 28.3144C96.9101 29.3081 96.8578 29.8938 96.8578 29.8938C96.8578 29.8938 96.7819 30.8383 96.6206 32.3483C96.541 33.1043 96.4359 34.0009 96.3094 34.9918C96.2578 35.3655 96.2075 35.756 96.1523 36.1615C96.1696 36.2649 96.0622 36.2365 95.9922 36.2509C95.7737 36.272 95.5533 36.2953 95.3287 36.3189C90.738 36.7819 85.3487 37.3267 82.1496 37.6502L79.3959 37.9309L78.3394 38.0392L78.1542 38.0574L78.0607 38.0676L78.0148 38.0716C78.0148 38.0716 77.9678 38.0861 77.9869 38.0635C78.0476 37.9407 78.1061 37.8161 78.1578 37.6857L78.2605 37.4166C78.3084 37.2907 78.3479 37.1656 78.3917 37.0401C78.4791 36.7891 78.5624 36.5385 78.637 36.2845C79.2812 34.1451 79.6012 32.2122 79.8478 30.4262C80.088 28.6386 80.2266 26.9858 80.3206 25.3767L80.321 25.3809Z" fill="#6A9A23"/>
</g>
</g>
<defs>
<clipPath id="clip0_783_5660">
<rect width="421" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 346) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $cb0e8fe57b0fd046$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6 = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$ea8e736e4eb06883$require$Buffer.from($cb0e8fe57b0fd046$var$$ea8e736e4eb06883$var$learningPathBg).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$export$8b251419efc915eb = ({ isCourse: isCourse, courseImgUrl: courseImgUrl, title: title, completedItems: completedItems, progress: progress, learningPathSlug: learningPathSlug, courseSlug: courseSlug, navigate: navigate })=>{
    const handleNavigation = (0, $acw62.useCallback)(()=>{
        learningPathSlug ? navigate(`/path/${learningPathSlug}`) : navigate(`/course/${courseSlug}`);
    }, [
        learningPathSlug,
        courseSlug,
        navigate
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleNavigation);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-header",
        css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$headerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$headerImageStyles,
                src: isCourse ? $cb0e8fe57b0fd046$var$$e48fba9cf5395297$export$d3a66d29d3f047ac : $cb0e8fe57b0fd046$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6,
                alt: title
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$headerContentStyles,
                    isCourse && $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles
                ],
                children: [
                    isCourse && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$courseImageContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                            css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$courseImageStyles,
                            src: courseImgUrl,
                            alt: title,
                            "data-testid": "course-image"
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: [
                            $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$containerStyles,
                            isCourse && (0, $gyDKM.css)({
                                marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
                            })
                        ],
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$typeStyles,
                                children: isCourse ? "Course" : "Learning Path"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                role: "button",
                                tabIndex: 0,
                                css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$titleStyles,
                                "data-testid": "sidebar-title",
                                onClick: handleNavigation,
                                onKeyDown: onKeyDown,
                                children: title
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        "data-testid": "course-progress-circle",
                        css: $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $59f888d7dcabf163$export$5ab97151efedb8c6), {
                            strokeWidth: 8,
                            value: progress,
                            styles: (0, $59f888d7dcabf163$export$5115a192ad9bf57f)({
                                pathColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success"),
                                trailColor: "rgba(9, 30, 66, 0.14)"
                            }),
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$progressStyles,
                                    isCourse && (0, $gyDKM.css)({
                                        fontSize: "14px"
                                    })
                                ],
                                "data-testid": "progress-text",
                                children: completedItems
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$headerStyles = (0, $gyDKM.css)({
    width: "100%",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$headerImageStyles = (0, $gyDKM.css)({
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$headerContentStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles = (0, $gyDKM.css)({
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles = (0, $gyDKM.css)({
    maxWidth: "48px",
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$progressStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$courseImageContainerStyles = (0, $gyDKM.css)({
    width: "32px",
    minWidth: "32px",
    minHeight: "32px"
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$courseImageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto"
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$typeStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$var$titleStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    transition: "color 0.5s ease",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    "&:hover": {
        cursor: "pointer",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$792ece11a7230884 = 89;
const $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e = 8;
const $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$686a18f490557de2 = 16;
const $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 = 250;
const $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 = 68;
const $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8 = (positionData)=>{
    const height = positionData.height > $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$792ece11a7230884 ? $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$792ece11a7230884 : positionData.height;
    const subnavbarPosition = document.getElementById("subnavbar")?.getBoundingClientRect();
    const offset = subnavbarPosition && subnavbarPosition.y < $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 ? $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 - subnavbarPosition.y : 0;
    return {
        top: positionData.top - ($cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 / 2 - height / 2) + offset - $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$686a18f490557de2,
        left: $cb0e8fe57b0fd046$var$$035f8a623e403361$export$780035d9fe48eb32 - $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$686a18f490557de2
    };
};
const $cb0e8fe57b0fd046$var$$f50e6e435b887166$export$1671b398b5e36be4 = ({ courses: courses, renderPopup: renderPopup })=>{
    const { hoverInfo: hoverInfo, popupRef: popupRef, handleMouseLeave: handleMouseLeave } = $cb0e8fe57b0fd046$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const courseToShowInPopup = (0, $acw62.useMemo)(()=>courses.find(({ sys: sys })=>sys.id === hoverInfo?.courseId), [
        hoverInfo?.courseId,
        courses
    ]);
    const handlePopupLeave = (e)=>{
        const popupId = popupRef.current?.children[0].id;
        const isMovedToOutside = e.target.closest(`#${popupId}`);
        if (isMovedToOutside) handleMouseLeave();
    };
    if (!hoverInfo) return null;
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        "data-testid": "sidebar-hover-popup",
        ref: popupRef,
        onMouseLeave: handlePopupLeave,
        css: [
            $cb0e8fe57b0fd046$var$$f50e6e435b887166$var$popupStyles,
            (0, $gyDKM.css)($cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8(hoverInfo.courseCardPosition))
        ],
        children: renderPopup(courseToShowInPopup)
    });
};
const $cb0e8fe57b0fd046$var$$f50e6e435b887166$var$popupStyles = (0, $gyDKM.css)({
    position: "absolute",
    zIndex: 100,
    transform: "translateY(-50%)",
    paddingLeft: `${$cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$686a18f490557de2 + $cb0e8fe57b0fd046$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e}px`,
    marginLeft: "-1px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$export$4ff69a78d3a65d6f = ({ isVisible: isVisible = true, isLoading: isLoading, learningPath: learningPath, progressForLessons: progressForLessons, progressForCourses: progressForCourses, expandedCourseIds: expandedCourseIds = [], expandedLessonIds: expandedLessonIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, navigate: navigate = ()=>{}, renderPopup: renderPopup, onToggleVisibility: onToggleVisibility })=>{
    const [showCurrentLessonButton, setShowCurrentLessonButton] = (0, $acw62.useState)(false);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    const selectedLessonRef = (0, $acw62.useRef)(null);
    const courses = (0, $acw62.useMemo)(()=>learningPath?.coursesCollection.items || [], [
        learningPath?.coursesCollection.items
    ]);
    const lessons = (0, $acw62.useMemo)(()=>courses.flatMap((course)=>course.lessonsCollection.items), [
        courses
    ]);
    const numberOfCompletedLessons = lessons.filter(({ sys: { id: id } })=>progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const numberOfCompletedCourses = courses.filter(({ sys: { id: id } })=>progressForCourses?.courses.find((course)=>course.courseId === id)?.status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const selectedCourse = courses.find(({ slug: slug })=>$cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d(slug));
    const isCourse = !learningPath?.title;
    const courseImage = (courses[0]?.reward?.orangeLogicAsset?.imageUrl ?? courses[0]?.reward?.badgeCdnUrl) || $cb0e8fe57b0fd046$var$$ef44b01e6346ac17$export$44f5f766f3f98994;
    const calculateProgress = ()=>isCourse ? numberOfCompletedLessons / lessons.length * 100 : numberOfCompletedCourses / courses.length * 100;
    const completedEntities = isCourse ? numberOfCompletedLessons : numberOfCompletedCourses;
    const totalEntities = isCourse ? lessons.length : courses.length;
    // Find the selected lesson in either the main lessons array or inside course cards
    const selectedLessonId = (0, $acw62.useMemo)(()=>isCourse ? lessons.find(({ slug: slug })=>$cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d("", slug)) : courses.reduce((found, course)=>{
            if (found) return found;
            const selectedLesson = course.lessonsCollection.items.find(({ slug: slug })=>$cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d("", slug));
            return selectedLesson ? selectedLesson.sys.id : undefined;
        }, undefined), [
        isCourse,
        lessons,
        courses
    ]);
    // Handle scroll event to check if selected lesson is visible
    const handleScroll = (0, $acw62.useCallback)(()=>{
        if (!scrollContainerRef.current || !selectedLessonRef.current || !selectedLessonId) return;
        const container = scrollContainerRef.current;
        const selectedLessonElement = selectedLessonRef.current;
        const containerRect = container.getBoundingClientRect();
        const lessonRect = selectedLessonElement.getBoundingClientRect();
        // Check if the selected lesson is above the visible area
        const isLessonAboveViewport = lessonRect.top < containerRect.top;
        setShowCurrentLessonButton(isLessonAboveViewport);
    }, [
        selectedLessonId
    ]);
    const scrollToSelectedLesson = (0, $acw62.useCallback)(()=>{
        if (selectedLessonRef.current && scrollContainerRef.current) selectedLessonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
            handleScroll();
            return ()=>{
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        selectedLessonId
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $115bf1020744eac3$export$25062201e9e25d76)("aside", {
        "data-testid": "sidebar",
        css: [
            $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarStyles,
            !isVisible && $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarClosedStyles
        ],
        children: [
            isVisible && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$closeButtonContainerStyles,
                onClick: onToggleVisibility,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggleVisibility?.();
                    }
                },
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                    "data-testid": "sidebar-mobile-close-button",
                    css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$closeButtonStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                            css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$closeButtonTextStyles,
                            children: "Close"
                        })
                    ]
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                "data-testid": "sidebar-toggle-button",
                css: [
                    $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarButton,
                    isCourse && $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles
                ],
                onClick: onToggleVisibility,
                "aria-label": isVisible ? "Collapse sidebar" : "Expand sidebar",
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                    type: isVisible ? "sidebar-collapse" : "sidebar-expand"
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0dbf0b63949b5d22$export$8b251419efc915eb, {
                isCourse: isCourse,
                learningPathSlug: learningPath?.slug,
                courseSlug: courses[0]?.slug,
                title: isCourse ? selectedCourse?.title || "" : learningPath?.title || "",
                completedItems: `${completedEntities}/${totalEntities}`,
                progress: calculateProgress(),
                courseImgUrl: courseImage,
                navigate: navigate
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)($cb0e8fe57b0fd046$var$$32c02b5652036d7a$export$d8355e8edbcacbe8, {
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        "data-testid": "sidebar-cards-container",
                        css: [
                            $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$cardsContainerStyles,
                            isCourse && $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$cardsContainerForCourseStyles
                        ],
                        children: [
                            showCurrentLessonButton && selectedLessonId && (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                                css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$currentLessonStyles,
                                onClick: scrollToSelectedLesson,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        type: "arrow-up",
                                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$buttonTextStyles,
                                        children: "Current lesson"
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$cardsScrollableContainerStyles,
                                ref: scrollContainerRef,
                                children: isCourse ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    "data-testid": "sidebar-lesson-container",
                                    css: $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$lessonContainerStyles,
                                    children: lessons.map((lesson)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                            ref: $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                                                isCourse: isCourse,
                                                courseSlug: selectedCourse?.slug,
                                                lesson: lesson,
                                                progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                                                onSelect: onSelect,
                                                expandedLessonIds: expandedLessonIds,
                                                isLoading: isLoading,
                                                selectedSectionId: selectedSectionId,
                                                currentLessonSlug: currentLessonSlug
                                            })
                                        }, lesson.sys.id))
                                }) : courses.map((course)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c, {
                                        course: course,
                                        progressForLessons: progressForLessons,
                                        status: $cb0e8fe57b0fd046$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForCourses?.courses.find((courseProgress)=>courseProgress.courseId === course.sys.id)?.status),
                                        onSelect: onSelect,
                                        isLoading: isLoading,
                                        selectedLessonRef: selectedLessonRef,
                                        expandedLessonIds: expandedLessonIds,
                                        expandedCourseIds: expandedCourseIds,
                                        selectedSectionId: selectedSectionId,
                                        currentLessonSlug: currentLessonSlug,
                                        scrollContainerRef: scrollContainerRef
                                    }, course.sys.id))
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$f50e6e435b887166$export$1671b398b5e36be4, {
                        courses: courses,
                        renderPopup: renderPopup
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarStyles = (0, $gyDKM.css)({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    width: `${$cb0e8fe57b0fd046$var$$035f8a623e403361$export$780035d9fe48eb32}px`,
    borderRight: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    transition: "transform 0.3s ease",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarClosedStyles = (0, $gyDKM.css)({
    transform: "translateX(-412px)",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        transform: "translateX(-100%)"
    }
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$closeButtonContainerStyles = (0, $gyDKM.css)({
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.xs]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$closeButtonStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "none",
    cursor: "pointer"
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$closeButtonTextStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarButton = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "32px",
    height: "32px",
    top: "84px",
    right: "calc(-32px - 16px)",
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    padding: 0,
    border: "none",
    cursor: "pointer",
    zIndex: 100,
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.hovered")
    },
    "&:active": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.pressed")
    },
    svg: {
        width: "24px",
        height: "24px"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles = (0, $gyDKM.css)({
    top: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$cardsContainerStyles = (0, $gyDKM.css)({
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    minHeight: 0
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$cardsContainerForCourseStyles = (0, $gyDKM.css)({
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$currentLessonStyles = (0, $gyDKM.css)({
    position: "absolute",
    zIndex: 100,
    top: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    width: "fit-content",
    borderRadius: "100px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 0px 1px rgba(188, 214, 240, 0.00) inset"
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$buttonTextStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$lessonContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$3d76652bb6362040$var$cardsScrollableContainerStyles = (0, $gyDKM.css)({
    flex: 1,
    overflowY: "auto",
    minHeight: 0
});
var $cb0e8fe57b0fd046$var$$764442aba3de2fce$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$764442aba3de2fce$exports, "VIDEO_CONTROL_TYPES", ()=>$cb0e8fe57b0fd046$export$2ffae0f952561172);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$764442aba3de2fce$exports, "Video", ()=>$cb0e8fe57b0fd046$export$ae01dedf5c052bb);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $cb0e8fe57b0fd046$export$2ffae0f952561172 = [
    "play-small",
    "play",
    "progress",
    "current-time",
    "rewind",
    "fast-forward",
    "mute",
    "volume",
    "settings",
    "fullscreen",
    "seektime"
];
const $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH = 920;
const $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH = "/CDNLink/";
const $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl = (videoUrl)=>videoUrl?.includes($cb0e8fe57b0fd046$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH) ?? false;
const $cb0e8fe57b0fd046$export$ae01dedf5c052bb = ({ orangeUrl: orangeUrl, vimeoUrl: vimeoUrl, youtubeUrl: youtubeUrl, captions: captions, chapters: chapters, controls: controls, width: width, height: height, videoId: videoId, name: name, poster: poster = "", onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError, customControls: customControls, hasResponsiveControls: hasResponsiveControls, preload: preload = "metadata" })=>{
    const videoRef = (0, $acw62.useRef)(null);
    const playerRef = (0, $acw62.useRef)(null);
    const mobileControls = (0, $acw62.useMemo)(()=>customControls?.customMobileControls ?? [
            ...$cb0e8fe57b0fd046$export$2ffae0f952561172
        ], [
        customControls?.customMobileControls
    ]);
    const desktopControls = (0, $acw62.useMemo)(()=>customControls?.customDesktopControls ?? [
            ...$cb0e8fe57b0fd046$export$2ffae0f952561172
        ], [
        customControls?.customDesktopControls
    ]);
    const hasCustomDesktopControls = Boolean(customControls?.customDesktopControls?.length);
    const videoSrc = (0, $acw62.useMemo)(()=>orangeUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = (0, $acw62.useMemo)(()=>({
            type: "video",
            sources: [
                {
                    src: videoSrc
                }
            ],
            tracks: [
                {
                    kind: "captions",
                    label: "English",
                    srcLang: "en",
                    src: captions,
                    default: true
                }
            ]
        }), [
        videoSrc,
        captions
    ]);
    const playerOptions = (0, $acw62.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: true,
                seek: true
            },
            controls: desktopControls,
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        desktopControls,
        chapters,
        preload
    ]);
    const playerOptionsMobile = (0, $acw62.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: controls,
                seek: true
            },
            controls: controls ? mobileControls : [],
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        controls,
        mobileControls,
        chapters,
        preload
    ]);
    const addEvents = (0, $acw62.useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            const addEvent = (event)=>instance.on(event, ()=>onControlClick && onControlClick(event));
            addEvent("play");
            addEvent("pause");
            addEvent("captionsenabled");
            addEvent("captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onProgressUpdate,
        onError,
        name,
        videoId
    ]);
    (0, $acw62.useEffect)(()=>{
        // ✅ Destroy old player before creating new one
        const destroyPlayer = ()=>{
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
        const initializePlayer = ()=>{
            if (!videoRef.current) return;
            destroyPlayer(); // ✅ Clean up first
            const isMobileSize = hasResponsiveControls ? window.innerWidth >= $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH : window.innerWidth <= $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
            const player = new (0, (/*@__PURE__*/$parcel$interopDefault($52477d57b9d8c8b9$exports)))(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
            player.source = playerSource;
            player.poster = poster;
            addEvents(player);
            if ($cb0e8fe57b0fd046$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl(orangeUrl) && videoRef.current?.hasAttribute("crossorigin")) {
                // Orange Logic CDNLink URLs can fail CORS checks with crossorigin="anonymous".
                // Removing it restores playback for the original asset.
                videoRef.current.removeAttribute("crossorigin");
                videoRef.current.load();
            }
            playerRef.current = player; // ✅ Store reference
            const plyrVideoContainers = document.getElementsByClassName("plyr--video");
            if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
        };
        const handleResize = ()=>{
            initializePlayer();
        };
        window.addEventListener("resize", handleResize);
        initializePlayer();
        return ()=>{
            window.removeEventListener("resize", handleResize);
            destroyPlayer();
        };
    }, [
        hasResponsiveControls,
        playerOptions,
        playerOptionsMobile,
        playerSource,
        poster,
        orangeUrl,
        addEvents
    ]);
    if (videoSrc === vimeoUrl) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $gyDKM.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $gyDKM.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$videoPlayerStyles,
            hasCustomDesktopControls && $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$unsetVolumeWidthStyles
        ],
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            preload: preload,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$videoPlayerStyles = (0, $gyDKM.css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $5e26c99fa43b3c99$export$7d61b15e0da132af),
    "--plyr-audio-control-color": (0, $5e26c99fa43b3c99$export$7d61b15e0da132af),
    "--plyr-menu-color": (0, $5e26c99fa43b3c99$export$7d61b15e0da132af),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $5e26c99fa43b3c99$export$7d61b15e0da132af),
    ":focus-visible": {
        border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$764442aba3de2fce$var$unsetVolumeWidthStyles = (0, $gyDKM.css)({
    ".plyr__controls__item.plyr__volume": {
        minWidth: "unset !important",
        width: "unset !important"
    }
});
var $cb0e8fe57b0fd046$var$$77282b3961d82199$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$77282b3961d82199$exports, "Columns", ()=>$cb0e8fe57b0fd046$export$f02cc02ad0e0bba3);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$77282b3961d82199$exports, "LessonColumns", ()=>$cb0e8fe57b0fd046$export$2dde675552f76fc5);
let $cb0e8fe57b0fd046$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($cb0e8fe57b0fd046$export$f02cc02ad0e0bba3 || ($cb0e8fe57b0fd046$export$f02cc02ad0e0bba3 = {}));
const $cb0e8fe57b0fd046$export$2dde675552f76fc5 = ({ columns: columns = $cb0e8fe57b0fd046$export$f02cc02ad0e0bba3.TWO, children: children })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("section", {
        css: $cb0e8fe57b0fd046$var$$77282b3961d82199$var$sectionStyles,
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
            "data-testid": "lesson-columns",
            css: [
                $cb0e8fe57b0fd046$var$$77282b3961d82199$var$lessonColumnsStyles,
                $cb0e8fe57b0fd046$var$$77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $cb0e8fe57b0fd046$var$$77282b3961d82199$var$sectionStyles = (0, $gyDKM.css)({
    textOverflow: "ellipsis",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.lg]: {
        textOverflow: "clip"
    }
});
const $cb0e8fe57b0fd046$var$$77282b3961d82199$var$lessonColumnsStyles = (0, $gyDKM.css)({
    display: "grid",
    columnGap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $cb0e8fe57b0fd046$var$$77282b3961d82199$var$lessonColumnsMDStyles = {
    [$cb0e8fe57b0fd046$export$f02cc02ad0e0bba3.TWO]: (0, $gyDKM.css)({
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$cb0e8fe57b0fd046$export$f02cc02ad0e0bba3.THREE]: (0, $gyDKM.css)({
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$cb0e8fe57b0fd046$export$f02cc02ad0e0bba3.FOUR]: (0, $gyDKM.css)({
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};
var $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$exports, "LearningCourseCard", ()=>$cb0e8fe57b0fd046$export$5ae3342de8088f07);
const $cb0e8fe57b0fd046$export$5ae3342de8088f07 = ({ inspectMode: inspectMode, title: title, imageUrl: imageUrl, onClick: onClick, link: link, minHeight: minHeight = 153, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications })=>{
    const cardRef = (0, $acw62.useRef)(null);
    const onClickHandler = (0, $acw62.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleUpdatedButtonClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(onClickHandler);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
        href: link,
        css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            role: "button",
            ref: cardRef,
            css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                css: [
                                    $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                                "data-testid": "title",
                                ...$cb0e8fe57b0fd046$export$1784ac302bd8ebad("title", inspectMode),
                                css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$184a993f673fc83f, {
                                wasPreviouslyCompleted: learningProgress.status === $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    isUpdated && learningProgress.status !== $cb0e8fe57b0fd046$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        "data-testid": "updated-icon",
                                        css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                            label: "Updated",
                                            iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                                type: "editor-panel"
                                            }),
                                            onClick: handleUpdatedButtonClick
                                        })
                                    }),
                                    shouldDisplayShowMoreButton && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$ca7697601dcd7803, {
                                        cardRef: cardRef,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf,
                                        areHistoricalNotifications: areHistoricalNotifications,
                                        onViewUpdates: onViewUpdates
                                    }),
                                    shouldDisplayBookmark && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("button", {
                                        "data-testid": "save-content",
                                        css: $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "bookmark-filled"
                                        }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")}`
    }
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")}`,
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`
    }
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $gyDKM.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$imageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$noImageStyles = (0, $gyDKM.css)({
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.0")}`
    }
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $gyDKM.css)({
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $gyDKM.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$titleStyles = (0, $gyDKM.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
var $cb0e8fe57b0fd046$var$$27d686e47ff412fd$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$27d686e47ff412fd$exports, "FeedbackHeader", ()=>$cb0e8fe57b0fd046$export$41cd510048068b0c);
const $cb0e8fe57b0fd046$export$41cd510048068b0c = ({ heading: heading, duration: duration, description: description })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$headingWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("h1", {
                    css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$metadataStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$flexContainerStyles,
                    children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: (0, $gyDKM.css)({
                            display: "flex"
                        }),
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                    label: duration
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$lineWrapperStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb, {
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$metadataStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$flexContainerStyles = (0, $gyDKM.css)({
    display: "flex"
});
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$tagStyles = (0, $gyDKM.css)({
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$lineWrapperStyles = (0, $gyDKM.css)({
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")} 0`
});
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$headingWrapperStyles = (0, $gyDKM.css)({
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.1000")} 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} 0`
});
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$headingStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $cb0e8fe57b0fd046$var$$27d686e47ff412fd$var$descriptionStyles = (0, $gyDKM.css)({
    paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    }
});
var $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$exports, "ReportIssueModal", ()=>$cb0e8fe57b0fd046$export$448811829c5d1992);
let $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$DialogWidth || ($cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$DialogWidth = {}));
const $cb0e8fe57b0fd046$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch, consentToContact: consentToContact, selectValue: selectValue, textAreaValues: textAreaValues, heading: heading, width: width = $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$DialogWidth.LARGE, options: options, isDisabled: isDisabled, closeModal: closeModal, submit: submit, onSelectChange: onSelectChange, onTextChange: onTextChange, onParticipatingInResearch: onParticipatingInResearch, onConsentToContact: onConsentToContact })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $2de636e70f18707f$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("p", {
                            css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $gyDKM.css)({
                                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: (0, $gyDKM.css)({
                                marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                            }),
                            children: (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: (0, $gyDKM.css)({
                                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$selectContainerStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6e237539ccf81b49$export$2e2bcd8739ae039), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: (0, $gyDKM.css)({
                                        marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
                                    }),
                                    children: (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                                css: (0, $gyDKM.css)({
                                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$detailsStyles,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $ea673c41278c8551$export$2e2bcd8739ae039), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: (0, $gyDKM.css)({
                                        marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
                                    }),
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$48513f6b9f8ce62d, {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$48513f6b9f8ce62d, {
                                        label: (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("span", {
                    css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $d309f9e104674c66$export$2e2bcd8739ae039), {
                                appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                            label: "Submit",
                            appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalContainerStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
    }
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $gyDKM.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$selectContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$detailsStyles = (0, $gyDKM.css)({
    width: "100%",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
    }
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$modalBodyStyles = (0, $gyDKM.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $gyDKM.css)({
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    button: {
        height: "100%",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
        fontWeight: 600
    }
});
const $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$var$policyContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});
var $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$exports, "FlatContentCardStyle", ()=>$cb0e8fe57b0fd046$export$f2adaabc3a0295ef);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$exports, "FlatContentCardType", ()=>$cb0e8fe57b0fd046$export$8023ea0baf29b8db);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$exports, "FlatContentCard", ()=>$cb0e8fe57b0fd046$export$bc8a9d98c2eabbb7);
let $cb0e8fe57b0fd046$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($cb0e8fe57b0fd046$export$f2adaabc3a0295ef || ($cb0e8fe57b0fd046$export$f2adaabc3a0295ef = {}));
let $cb0e8fe57b0fd046$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
    FlatContentCardType["FLEXIBLE"] = "flexible";
})($cb0e8fe57b0fd046$export$8023ea0baf29b8db || ($cb0e8fe57b0fd046$export$8023ea0baf29b8db = {}));
const $cb0e8fe57b0fd046$export$bc8a9d98c2eabbb7 = ({ image: image, title: title, text: text, link: link, linkLabel: linkLabel = "Learn more", style: style = $cb0e8fe57b0fd046$export$f2adaabc3a0295ef.TALL, type: type = $cb0e8fe57b0fd046$export$8023ea0baf29b8db.ROUND, headingLevel: headingLevel, bgColor: bgColor = "initial", onClick: onClick, target: target = "_self", maxWidth: maxWidth, minHeight: minHeight, withElevationBorder: withElevationBorder = false })=>{
    const isSquareOrRectangle = type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.SQUARE || type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.RECTANGLE;
    const isFlexible = type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.FLEXIBLE;
    const roundStyles = image ? $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$squareTypeStyles.container : isFlexible ? $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$flexibleContainerStyles : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.RECTANGLE && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles[$cb0e8fe57b0fd046$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $gyDKM.css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $gyDKM.css)({
                maxWidth: maxWidth
            }),
            isFlexible && minHeight && (0, $gyDKM.css)({
                minHeight: minHeight
            }),
            withElevationBorder && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$elevationBorderStyles
        ],
        "data-testid": "learn-more-card",
        children: [
            image && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                src: image.src,
                alt: image.alt,
                width: isFlexible && image.width ? image.width : undefined,
                height: isFlexible && image.height ? image.height : undefined,
                css: [
                    $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$imageBaseStyles,
                    (isSquareOrRectangle || isFlexible) && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$imageSquareStyles,
                    isFlexible && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$imageFlexibleStyles,
                    isFlexible && image.width && image.height && (0, $gyDKM.css)({
                        width: `${image.width}px`,
                        height: `${image.height}px`
                    }),
                    style === $cb0e8fe57b0fd046$export$f2adaabc3a0295ef.FULL && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: (0, $gyDKM.css)([
                            $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$textStyles,
                            type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.ROUND && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$squareTypeStyles.heading,
                            isFlexible && $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles[style].heading
                        ]),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                            level: headingLevel || defaultHeadingLevel,
                            fontWeight: 600,
                            children: title
                        })
                    }),
                    (type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.ROUND || type === $cb0e8fe57b0fd046$export$8023ea0baf29b8db.RECTANGLE || isFlexible) && text && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: [
                            (0, $gyDKM.css)([
                                $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$textStyles,
                                $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles[style].text,
                                $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                            children: text
                        })
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
                        style: $cb0e8fe57b0fd046$export$2b77966d73aefa77.SEMIBOLD,
                        size: $cb0e8fe57b0fd046$export$be4c932f76c19adf.LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$containerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")} 0`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")} 0`
    }
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$elevationBorderStyles = (0, $gyDKM.css)({
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
        boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$textStyles = (0, $gyDKM.css)({
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$imageBaseStyles = (0, $gyDKM.css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    maxWidth: "100%"
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$imageSquareStyles = (0, $gyDKM.css)({
    borderRadius: 0,
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$imageFlexibleStyles = (0, $gyDKM.css)({
    maxWidth: "100%",
    objectFit: "contain"
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500"),
    borderRadius: "initial"
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$variantStyles = {
    [$cb0e8fe57b0fd046$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $gyDKM.css)({
                [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $gyDKM.css)({
                [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $gyDKM.css)({
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "2"
            }
        }),
        text: (0, $gyDKM.css)({
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "3"
            }
        })
    },
    [$cb0e8fe57b0fd046$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $gyDKM.css)({
                [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $gyDKM.css)({
                [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $gyDKM.css)({
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        }),
        text: (0, $gyDKM.css)({
            [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        })
    }
};
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $gyDKM.css)({
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
            minHeight: "264px",
            padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
        }
    }),
    heading: (0, $gyDKM.css)({
        marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
    })
};
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$flexibleContainerStyles = (0, $gyDKM.css)({
    height: "auto",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    borderRadius: "8px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
    }
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$contentContainerStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $gyDKM.css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$var$textContainerStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
    }
});
var $cb0e8fe57b0fd046$var$$205ed41b47d90e33$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$205ed41b47d90e33$exports, "RelatedResourcesPanel", ()=>$cb0e8fe57b0fd046$export$3775cdf183cb8274);
const $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$ResourceItem = ({ title: title, slug: slug, onResourceClick: onResourceClick })=>{
    const handleClick = (0, $acw62.useCallback)(()=>onResourceClick(slug), [
        slug,
        onResourceClick
    ]);
    const onKeyDown = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleClick);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$resourceStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: title
    });
};
const $cb0e8fe57b0fd046$export$3775cdf183cb8274 = ({ title: title, resources: resources, onResourceClick: onResourceClick, onButtonClick: onButtonClick })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const handleButtonClick = (0, $acw62.useCallback)(()=>{
        setIsOpen(!isOpen);
        onButtonClick && onButtonClick();
    }, [
        isOpen,
        onButtonClick
    ]);
    const onKeyDownPanel = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleButtonClick);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "related-resources-panel",
        css: $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles,
        onClick: handleButtonClick,
        onKeyDown: onKeyDownPanel,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "related-resources-header",
                css: $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$headerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                        level: 6,
                        children: title
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $cbba28d57dbc8c95$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($912daf77e6b778ae$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b37509fddb710d14$exports))),
                        label: isOpen ? "Collapse" : "Expand"
                    })
                ]
            }),
            isOpen && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("ul", {
                "data-testid": "related-resources-list",
                css: $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$resourcesListStyles,
                children: resources.map(({ title: title, slug: slug })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("li", {
                        "data-testid": `related-resource-item-${slug}`,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$ResourceItem, {
                            title: title,
                            slug: slug,
                            onResourceClick: onResourceClick
                        })
                    }, slug))
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    cursor: "pointer",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input.pressed")
});
const $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$headerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$resourcesListStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    paddingLeft: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250"),
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$205ed41b47d90e33$var$resourceStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.link"),
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    }
});
var $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports, "ThumbType", ()=>$cb0e8fe57b0fd046$export$e1c6e381de15460b);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports, "FeedbackButtonType", ()=>$cb0e8fe57b0fd046$export$8eec558e14651de4);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", ()=>$cb0e8fe57b0fd046$export$3e6d4d99e8c08756);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", ()=>$cb0e8fe57b0fd046$export$592a942fdddb4b1a);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports, "QuickFeedback", ()=>$cb0e8fe57b0fd046$export$c6f2bf448101d429);
let $cb0e8fe57b0fd046$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($cb0e8fe57b0fd046$export$e1c6e381de15460b || ($cb0e8fe57b0fd046$export$e1c6e381de15460b = {}));
let $cb0e8fe57b0fd046$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($cb0e8fe57b0fd046$export$8eec558e14651de4 || ($cb0e8fe57b0fd046$export$8eec558e14651de4 = {}));
const $cb0e8fe57b0fd046$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $cb0e8fe57b0fd046$export$592a942fdddb4b1a = [
    "It wasn\u2019t clear",
    "It wasn\u2019t accurate",
    "I didn\u2019t learn what I wanted to know",
    "Other"
];
const $cb0e8fe57b0fd046$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback, onChangeThoughts: onChangeThoughts, onChangeOption: onChangeOption, onThumbClick: onThumbClick, shouldShowDivider: shouldShowDivider = true, buttonText: buttonText = "How was this lesson?" })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [selectedThumb, setSelectedThumb] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const handleThumbClick = (thumbType)=>{
        if (selectedThumb !== thumbType) {
            setSelectedOption("");
            onChangeOption("");
            onChangeThoughts({
                target: {
                    value: ""
                }
            });
        }
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        setSelectedThumb(thumbType);
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($cb0e8fe57b0fd046$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($cb0e8fe57b0fd046$export$8eec558e14651de4.DISMISS);
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "quick-feedback-component",
        css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                "data-testid": "thumb-down-container",
                                css: [
                                    $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $cb0e8fe57b0fd046$export$e1c6e381de15460b.THUMB_DOWN && {
                                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        type: "thumb-down"
                                    }),
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($cb0e8fe57b0fd046$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: [
                                    $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $cb0e8fe57b0fd046$export$e1c6e381de15460b.THUMB_UP && {
                                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                "data-testid": "thumb-up-container",
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                        type: "thumb-up"
                                    }),
                                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($cb0e8fe57b0fd046$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        "data-testid": "quick-feedback-text",
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                            level: 6,
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
                            children: selectedThumb ? "Thanks for your feedback!" : buttonText
                        })
                    })
                ]
            }),
            shouldShowDivider && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$dividerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb, {
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "popup",
                css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$popupStyles,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $cb0e8fe57b0fd046$export$e1c6e381de15460b.THUMB_UP ? $cb0e8fe57b0fd046$export$3e6d4d99e8c08756.map((option)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $cb0e8fe57b0fd046$export$592a942fdddb4b1a.map((option)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                        id: "quick-feedback-input",
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    }, selectedThumb)
                                ]
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "Dismiss",
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                        label: "Submit",
                                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$quickFeedbackStyles = (0, $gyDKM.css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$feedbackContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    display: "flex",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$thumbsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $gyDKM.css)({
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.disabled"),
    borderRadius: "3px"
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$dividerStyles = (0, $gyDKM.css)({
    width: "100%",
    margin: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400")} 0`
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$popupStyles = (0, $gyDKM.css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    borderRadius: "8px",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$optionsContentStyles = (0, $gyDKM.css)({
    margin: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$radioContainerStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$feedbackFormStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$inputContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$var$buttonsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
var $cb0e8fe57b0fd046$var$$5f9280667c666470$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$5f9280667c666470$exports, "Searchbar", ()=>$cb0e8fe57b0fd046$export$b9f6e7a4c54af1f6);
const $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911 = ({ item: item, onRemove: onRemove, onSelect: onSelect })=>{
    const deviceSize = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const handleRemoveButton = (e)=>{
        e.stopPropagation();
        onRemove(item);
    };
    const handleItemClick = (0, $acw62.useCallback)(()=>{
        onSelect(item);
    }, [
        onSelect,
        item
    ]);
    const handleRemoveKeyboard = (0, $acw62.useCallback)(()=>{
        onRemove(item);
    }, [
        onRemove,
        item
    ]);
    const onKeyDownItem = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleItemClick);
    const onKeyDownRemove = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(handleRemoveKeyboard);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles,
        onClick: handleItemClick,
        onKeyDown: onKeyDownItem,
        "data-testid": "history-item",
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$historyItemStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "emoji-frequent",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.subtle")
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        css: $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$itemTextStyles,
                        children: item
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$removeContainerStyles,
                    deviceSize < $cb0e8fe57b0fd046$export$27ed77542911fb0e && (0, $gyDKM.css)({
                        opacity: 1
                    })
                ],
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        onClick: handleRemoveButton,
                        label: "",
                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    deviceSize < $cb0e8fe57b0fd046$export$27ed77542911fb0e && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                        role: "button",
                        tabIndex: 0,
                        css: $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$clearButtonStyles,
                        onClick: handleRemoveButton,
                        onKeyDown: onKeyDownRemove,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$removeContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    button: {
        span: {
            margin: "0px !important"
        }
    }
});
const $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    button: {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        outline: "none",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:hover > div:last-child": {
        opacity: 1
    }
});
const $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$historyItemStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: "4px"
});
const $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$itemTextStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")}`
});
const $cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$var$clearButtonStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px"
});
const $cb0e8fe57b0fd046$var$$2f046e897b352baf$export$ed4de3239e2fb964 = ({ items: items, onRemove: onRemove, onSelect: onSelect })=>{
    if (!items.length) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $115bf1020744eac3$export$ffb0004e005737fa), {});
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
        css: $cb0e8fe57b0fd046$var$$2f046e897b352baf$var$historyStyles,
        "data-testid": "history-container",
        children: items.slice(-5).reverse().map((item)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911, {
                item: item,
                onRemove: onRemove,
                onSelect: onSelect
            }, item))
    });
};
const $cb0e8fe57b0fd046$var$$2f046e897b352baf$var$historyStyles = (0, $gyDKM.css)({
    position: "absolute",
    display: "flex",
    width: "279px",
    borderRadius: "3px",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")}`,
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075"),
    flexDirection: "column",
    alignItems: "flex-start",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.surface.overlay"),
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    zIndex: 1,
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        width: "327px"
    }
});
const $cb0e8fe57b0fd046$export$b9f6e7a4c54af1f6 = ({ value: value, onChange: onChange, isLoading: isLoading, label: label, isTall: isTall = false })=>{
    const [isHistoryVisible, setIsHistoryVisible] = (0, $acw62.useState)(false);
    const [history, setHistory] = (0, $acw62.useState)($cb0e8fe57b0fd046$export$7765f5b61937bda1());
    const searchRef = (0, $acw62.useRef)(null);
    const deviceSize = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const isRemoveIconVisible = !!value.length && (deviceSize >= $cb0e8fe57b0fd046$export$27ed77542911fb0e || !isLoading);
    (0, $acw62.useEffect)(()=>{
        const searchElement = searchRef.current;
        if (!searchElement) return;
        const inputElement = searchElement.querySelector("input");
        if (!inputElement) return;
        const handleFocus = ()=>{
            setIsHistoryVisible(true);
        };
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setIsHistoryVisible(false);
        };
        inputElement.addEventListener("focus", handleFocus);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            inputElement.removeEventListener("focus", handleFocus);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleRemoveItem = (itemToRemove)=>{
        const newHistory = history.filter((item)=>item !== itemToRemove);
        setHistory(newHistory);
        $cb0e8fe57b0fd046$export$cec0922aa1b64670(newHistory);
    };
    const handleSelectItem = (selectedItem)=>{
        onChange(selectedItem);
        setIsHistoryVisible(false);
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter" && value.trim()) {
            if (!history.includes(value.trim()) && searchRef.current) {
                const newHistory = [
                    ...history,
                    value.trim()
                ];
                $cb0e8fe57b0fd046$export$cec0922aa1b64670(newHistory);
                const inputElement = searchRef.current.querySelector("input");
                if (inputElement) inputElement.blur();
                setIsHistoryVisible(false);
                setHistory(newHistory);
            }
        }
    };
    const filteredItems = history.filter((item)=>item.toLowerCase().includes(value.toLowerCase()));
    const handleOnChange = (event)=>{
        if (event.target instanceof HTMLInputElement) onChange(event.target.value);
    };
    const onClearSearchClick = ()=>{
        onChange("");
        setIsHistoryVisible(false);
    };
    const onKeyDownClear = $cb0e8fe57b0fd046$export$2a0b6757d41dacb2(onClearSearchClick);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        role: "search",
        css: $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchStyles,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        ref: searchRef,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                css: $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchBeforeIconStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9fe02b09e2c6116b$exports))), {
                    primaryColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                    size: "medium",
                    label: "search icon"
                })
            }),
            !!value.length && isLoading && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                "data-testid": "search-loader",
                css: [
                    $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchAfterIconStyles,
                    $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchLoaderIconStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $9b1489024cd32216$export$2e2bcd8739ae039), {
                    size: "small"
                })
            }),
            isRemoveIconVisible && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                role: "button",
                tabIndex: 0,
                css: $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchAfterIconStyles,
                onClick: onClearSearchClick,
                onKeyDown: onKeyDownClear,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    label: "",
                    size: $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.LARGE,
                    iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                        type: "cross",
                        alt: "cross icon"
                    }),
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON
                })
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("input", {
                placeholder: label ?? (deviceSize < $cb0e8fe57b0fd046$export$27ed77542911fb0e ? "Search" : "Search catalog"),
                value: value,
                onChange: handleOnChange,
                style: isTall ? {
                    paddingTop: "10px",
                    paddingBottom: "10px"
                } : {}
            }),
            isHistoryVisible && history.length > 0 && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$2f046e897b352baf$export$ed4de3239e2fb964, {
                items: filteredItems,
                onRemove: handleRemoveItem,
                onSelect: handleSelectItem
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchStyles = (0, $gyDKM.css)({
    position: "relative",
    width: "100%",
    maxWidth: "240px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "275px"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "100%"
    },
    input: {
        width: "100%",
        minHeight: "32px",
        border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.input")}`,
        borderRadius: "5px !important",
        padding: `0 30px 0 ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")}`,
        color: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")} !important`,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        outline: "none",
        "&::placeholder": {
            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
            fontFamily: "SF Pro, sans-serif"
        },
        "&:focus": {
            border: `2px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.focused")} !important`
        },
        [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
            height: "40px",
            padding: `10px 30px 10px ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500")}`
        }
    }
});
const $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchBeforeIconStyles = (0, $gyDKM.css)({
    position: "absolute",
    left: "10px",
    top: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    }
});
const $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchAfterIconStyles = (0, $gyDKM.css)({
    position: "absolute",
    right: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    top: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    },
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        top: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
    }
});
const $cb0e8fe57b0fd046$var$$5f9280667c666470$var$searchLoaderIconStyles = (0, $gyDKM.css)({
    cursor: "default",
    right: "-24px",
    [(0, $32b227fa3e7b874c$export$987d49ffe1b0900f).below.md]: {
        top: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
        right: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
    }
});
var $cb0e8fe57b0fd046$var$$ffad026de847a971$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ffad026de847a971$exports, "CourseStatus", ()=>$cb0e8fe57b0fd046$export$686d6bd87c227b43);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ffad026de847a971$exports, "CourseList", ()=>$cb0e8fe57b0fd046$export$96ebd64c4b8b0cf9);
var $cb0e8fe57b0fd046$var$$45c6e177b24a84f5$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $cb0e8fe57b0fd046$var$$45c6e177b24a84f5$var$completedGap = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.735 12.322C6.55446 12.13 6.30541 12.0171 6.04201 12.0077C5.77861 11.9983 5.52217 12.0933 5.32844 12.272C5.13471 12.4507 5.01937 12.6987 5.00749 12.962C4.99561 13.2253 5.08815 13.4826 5.265 13.678L8.877 17.597C9.414 18.123 10.214 18.123 10.711 17.627L11.075 17.268C12.3895 15.9753 13.7025 14.6809 15.014 13.385L15.054 13.345C16.2797 12.1371 17.499 10.9228 18.712 9.70205C18.8933 9.51225 18.9927 9.25878 18.9887 8.99634C18.9848 8.73391 18.8778 8.48354 18.6909 8.29926C18.504 8.11499 18.2522 8.01158 17.9897 8.01135C17.7273 8.01113 17.4752 8.1141 17.288 8.29805C16.0807 9.51239 14.8673 10.7207 13.648 11.923L13.608 11.963C12.3513 13.2053 11.0929 14.446 9.833 15.685L6.735 12.322Z" fill="#22A06B"/>
</svg>
`;
const $cb0e8fe57b0fd046$var$$45c6e177b24a84f5$export$29aa8664c658caa9 = `data:image/svg+xml;base64,${$cb0e8fe57b0fd046$var$$45c6e177b24a84f5$require$Buffer.from($cb0e8fe57b0fd046$var$$45c6e177b24a84f5$var$completedGap).toString("base64")}`;
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH = 900;
let $cb0e8fe57b0fd046$export$686d6bd87c227b43;
(function(CourseStatus) {
    CourseStatus[/** The course is not started */ "DEFAULT"] = "default";
    CourseStatus[/** The course is in progress */ "IN_PROGRESS"] = "in_progress";
    CourseStatus[/** The course is finished */ "FINISHED"] = "finished";
})($cb0e8fe57b0fd046$export$686d6bd87c227b43 || ($cb0e8fe57b0fd046$export$686d6bd87c227b43 = {}));
const $cb0e8fe57b0fd046$export$96ebd64c4b8b0cf9 = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, onCourseTitleClick: onCourseTitleClick, onCourseButtonClick: onCourseButtonClick })=>{
    const [isOpened, setIsOpened] = (0, $acw62.useState)(false);
    const deviceSize = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const numberOfCompletedLessons = lessons.filter((lesson)=>lesson.isCompleted).length;
    const calculateProgress = ()=>{
        if (course.courseStatus === $cb0e8fe57b0fd046$export$686d6bd87c227b43.FINISHED) return 100;
        return numberOfCompletedLessons / lessons.length * 100;
    };
    const isCompleted = calculateProgress() === 100;
    const isTablet = deviceSize <= $cb0e8fe57b0fd046$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    const getButtonText = (status)=>{
        switch(status){
            case $cb0e8fe57b0fd046$export$686d6bd87c227b43.DEFAULT:
                return "Get started";
            case $cb0e8fe57b0fd046$export$686d6bd87c227b43.IN_PROGRESS:
                return "Continue";
            case $cb0e8fe57b0fd046$export$686d6bd87c227b43.FINISHED:
                return "Review course";
            default:
                return "Get started";
        }
    };
    const handleTitleClick = (0, $acw62.useCallback)((event)=>{
        if (onCourseTitleClick) {
            event?.preventDefault();
            onCourseTitleClick();
        }
    }, [
        onCourseTitleClick
    ]);
    const handleButtonClick = (0, $acw62.useCallback)((event)=>{
        if (onCourseButtonClick) {
            event?.preventDefault();
            onCourseButtonClick();
        }
    }, [
        onCourseButtonClick
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: [
            $cb0e8fe57b0fd046$var$$ffad026de847a971$var$wrapperStyles,
            isOpened ? $cb0e8fe57b0fd046$var$$ffad026de847a971$var$wrapperOpenStyles : $cb0e8fe57b0fd046$var$$ffad026de847a971$var$wrapperClosedStyles,
            isCompleted && $cb0e8fe57b0fd046$var$$ffad026de847a971$var$completedCourseStyles
        ],
        "data-testid": "course-list-container",
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": `course-card-${course?.slug}`,
                css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$containerStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$progressBadgeContainerStyles,
                        "data-testid": "course-progress-badge",
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$customProgressBadgeStyles,
                            children: !isCompleted ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $59f888d7dcabf163$export$5ab97151efedb8c6), {
                                strokeWidth: 6,
                                value: calculateProgress(),
                                styles: (0, $59f888d7dcabf163$export$5115a192ad9bf57f)({
                                    pathColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success"),
                                    trailColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")
                                }),
                                "data-testid": "course-progress-circle",
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                    css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                        src: course.imageUrl,
                                        alt: "Course badge",
                                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$imageStyles,
                                        "data-testid": "course-badge-image"
                                    })
                                })
                            }) : (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$completedBadgeContainerStyles,
                                "data-testid": "course-completed-badge",
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                            src: course.imageUrl,
                                            alt: "Course badge",
                                            css: [
                                                $cb0e8fe57b0fd046$var$$ffad026de847a971$var$imageStyles,
                                                $cb0e8fe57b0fd046$var$$ffad026de847a971$var$completedImageStyles
                                            ],
                                            "data-testid": "course-completed-image"
                                        })
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$checkmarkOverlayStyles,
                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("img", {
                                            src: $cb0e8fe57b0fd046$var$$45c6e177b24a84f5$export$29aa8664c658caa9,
                                            alt: "Completed",
                                            css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$checkmarkIconStyles,
                                            "data-testid": "course-completed-checkmark"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$contentContainerStyles,
                        "data-testid": "course-content",
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$topContentStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$durationTextStyles,
                                                "data-testid": "course-duration",
                                                children: course.duration
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                                level: 5,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                                    css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$titleStyles,
                                                    href: course.href,
                                                    onClick: handleTitleClick,
                                                    "data-testid": "course-title-link",
                                                    children: course.title
                                                })
                                            })
                                        ]
                                    }),
                                    !isTablet && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$startCourseButtonStyles,
                                        href: course.href,
                                        onClick: handleButtonClick,
                                        "data-testid": "desktop-course-button",
                                        children: getButtonText(course.courseStatus)
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                    css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$subTitleStyles,
                                    "data-testid": "course-subtitle",
                                    children: course.subTitle
                                })
                            })
                        ]
                    })
                ]
            }),
            !isTablet && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerClosedStyles
                ],
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                    css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? "Hide lessons" : "Show lessons",
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            size: "small",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$ffad026de847a971$var$lessonsContentWrapperStyles,
                    isTablet && $cb0e8fe57b0fd046$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles
                ],
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerClosedStyles,
                    $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerMobileStyles
                ],
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("button", {
                        css: [
                            $cb0e8fe57b0fd046$var$$ffad026de847a971$var$toggleButtonStyles,
                            $cb0e8fe57b0fd046$var$$ffad026de847a971$var$toggleButtonMobileStyles
                        ],
                        onClick: toggleLessons,
                        "data-testid": "toggle-lessons-button-mobile",
                        children: [
                            isOpened ? "Hide lessons" : "Show lessons",
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                                size: "small",
                                type: isOpened ? "chevron-up" : "chevron-down",
                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("a", {
                        css: $cb0e8fe57b0fd046$var$$ffad026de847a971$var$continueButtonStyles,
                        href: course.href,
                        onClick: handleButtonClick,
                        "data-testid": "tablet-course-button",
                        children: getButtonText(course.courseStatus)
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    alignItems: "flex-start",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    minHeight: "120px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    "&:hover a": {
        opacity: 1
    },
    "@media (max-width: 343px)": {
        minHeight: "148px",
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`,
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$progressBadgeContainerStyles = (0, $gyDKM.css)({
    width: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500"),
    height: "41px",
    flexShrink: 0
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$customProgressBadgeStyles = (0, $gyDKM.css)({
    width: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.500"),
    height: "41px"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$imageBadgeContainerStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$imageStyles = (0, $gyDKM.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$completedBadgeContainerStyles = (0, $gyDKM.css)({
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$completedImageStyles = (0, $gyDKM.css)({
    opacity: 0.5,
    filter: "grayscale(100%)"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$checkmarkOverlayStyles = (0, $gyDKM.css)({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$checkmarkIconStyles = (0, $gyDKM.css)({
    width: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    height: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$contentContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$topContentStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    minWidth: 0,
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$durationTitleContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$titleStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display",
    fontSize: "20px",
    fontStyle: "normal",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textDecoration: "none",
    cursor: "pointer",
    lineHeight: "28px",
    fontWeight: 600,
    width: "100%",
    minWidth: 0,
    display: "block",
    maxHeight: "56px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "&:hover": {
        textDecoration: "underline",
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
    },
    "@media (max-width: 343px)": {
        fontSize: "16px",
        lineHeight: "24px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "48px"
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$startCourseButtonStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.2s ease",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
    },
    "&:visited": {
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand")
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$subTitleStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    width: "100%",
    minWidth: 0,
    maxHeight: "40px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "@media (max-width: 343px)": {
        lineHeight: "22px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "44px"
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$durationTextStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Charlie Text",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")}`,
    "@media (max-width: 343px)": {
        gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")}`
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$toggleButtonStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$toggleButtonMobileStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerOpenStyles = (0, $gyDKM.css)({
    borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$wrapperStyles = (0, $gyDKM.css)({
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    overflow: "hidden",
    maxWidth: "100%",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input")
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$wrapperClosedStyles = (0, $gyDKM.css)({
    borderRadius: "8px"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$wrapperOpenStyles = (0, $gyDKM.css)({
    borderRadius: "8px",
    "& > div:last-child": {
        borderRadius: "0 0 8px 8px"
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$lessonsContentWrapperStyles = (0, $gyDKM.css)({
    overflow: "hidden",
    borderRadius: "0 0 8px 8px !important",
    backgroundColor: "#FFFFFF",
    "& > div": {
        borderRadius: "0 0 8px 8px !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 0 8px 8px !important"
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles = (0, $gyDKM.css)({
    borderRadius: "0 !important",
    "& > div": {
        borderRadius: "0 !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 !important"
    }
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$completedCourseStyles = (0, $gyDKM.css)({
    borderLeft: `4px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success")}`
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerClosedStyles = (0, $gyDKM.css)({
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$buttonContainerMobileStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$ffad026de847a971$var$continueButtonStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.brand.bold"),
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    height: "32px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.brand.bold.hovered"),
        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.inverse"),
        textDecoration: "none"
    },
    "&:active": {
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.brand.bold.pressed")
    }
});
var $cb0e8fe57b0fd046$var$$0f989458047e435a$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$0f989458047e435a$exports, "InformationCardState", ()=>$cb0e8fe57b0fd046$export$cbadcd18ba5a3835);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$0f989458047e435a$exports, "InformationCard", ()=>$cb0e8fe57b0fd046$export$5a1fe75c0326c1f3);
var $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$exports, "LearningControlPanel", ()=>$cb0e8fe57b0fd046$export$b0db8dac2b423604);
const $cb0e8fe57b0fd046$export$b0db8dac2b423604 = ({ state: state = $cb0e8fe57b0fd046$export$cbadcd18ba5a3835.DEFAULT, isSaved: isSaved, onSave: onSave, urlToShare: urlToShare, contentType: contentType, onClick: onClick, ctaSlot: ctaSlot })=>{
    const isCourse = contentType === $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE;
    const buttonLabel = isCourse ? "course" : "learning path";
    const width = $cb0e8fe57b0fd046$export$4616d33c54ae5baf();
    const TABLET_WIDTH = 920;
    const handleOnClick = (event)=>{
        if (onClick) {
            event?.preventDefault();
            onClick();
        }
    };
    const ButtonStateProps = {
        [$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.LOADING]: {
            label: "",
            isLoading: true,
            fullWidth: true
        },
        [$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.DEFAULT]: {
            label: `Start ${buttonLabel}`,
            appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.IN_PROGRESS]: {
            label: `Continue ${buttonLabel}`,
            appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.FINISHED]: {
            label: `Review ${buttonLabel}`,
            appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.SECONDARY,
            fullWidth: true
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "control-panel-card",
        css: $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$var$learningControlPanelStyles,
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles,
                children: [
                    onSave && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        iconColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.subtle"),
                        label: "",
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                        size: $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.MEDIUM,
                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-filled" : "bookmark"
                        }),
                        onClick: handleOnSave
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$477c64ffaba52edf, {
                        urlToShare: urlToShare,
                        alignToTop: width <= TABLET_WIDTH,
                        fullWidth: true
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "control-panel-cta-button",
                css: $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles,
                children: [
                    state === $cb0e8fe57b0fd046$export$cbadcd18ba5a3835.LOADING && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        ...ButtonStateProps[$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.LOADING]
                    }),
                    state === $cb0e8fe57b0fd046$export$cbadcd18ba5a3835.DEFAULT && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.DEFAULT]
                    }),
                    state === $cb0e8fe57b0fd046$export$cbadcd18ba5a3835.IN_PROGRESS && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.IN_PROGRESS]
                    }),
                    state === $cb0e8fe57b0fd046$export$cbadcd18ba5a3835.FINISHED && (ctaSlot ?? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$cb0e8fe57b0fd046$export$cbadcd18ba5a3835.FINISHED]
                    }))
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$var$learningControlPanelStyles = (0, $gyDKM.css)({
    position: "relative",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 2,
    borderLeft: "none",
    borderRight: "none",
    "@media (max-width: 920px)": {
        borderBottom: "none"
    }
});
const $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    marginRight: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150"),
    '[id*="icon-button"]': {
        width: "38px",
        height: "38px",
        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral"),
        ":hover": {
            backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.neutral.hovered")
        }
    }
});
const $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles = (0, $gyDKM.css)({
    flex: 1,
    width: "100%",
    a: {
        padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")}`
    },
    button: {
        width: "100%",
        height: "38px"
    }
});
let $cb0e8fe57b0fd046$export$cbadcd18ba5a3835;
(function(InformationCardState) {
    InformationCardState["LOADING"] = "loading";
    InformationCardState["DEFAULT"] = "default";
    InformationCardState["IN_PROGRESS"] = "in_progress";
    InformationCardState["FINISHED"] = "finished";
})($cb0e8fe57b0fd046$export$cbadcd18ba5a3835 || ($cb0e8fe57b0fd046$export$cbadcd18ba5a3835 = {}));
const $cb0e8fe57b0fd046$export$5a1fe75c0326c1f3 = ({ contentType: contentType, video: video, badge: badge, progress: progress, duration: duration, description: description, title: title, urlToShare: urlToShare, cardState: cardState, isSaved: isSaved, onSave: onSave, onClick: onClick, ctaSlot: ctaSlot })=>{
    const isCourse = contentType === $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.COURSE;
    const defaultTitle = isCourse ? "After this course, you'll be able to:" : "This learning path is for:";
    const displayTitle = title ?? defaultTitle;
    const titleColor = isCourse ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.blue") : (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.lime");
    const isCompleted = progress === 100;
    const shouldShowBadge = isCourse && badge && !video;
    const shouldShowVideo = contentType === $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.LEARNING_PATH && video && !badge;
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        "data-testid": "information-card",
        css: [
            $cb0e8fe57b0fd046$var$$0f989458047e435a$var$informationCardStyles,
            isCourse ? $cb0e8fe57b0fd046$var$$0f989458047e435a$var$courseBorderStyles : $cb0e8fe57b0fd046$var$$0f989458047e435a$var$learningPathBorderStyles,
            shouldShowVideo && (0, $gyDKM.css)({
                borderTop: "none"
            })
        ],
        children: [
            shouldShowBadge && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$badgeContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$badgeStyles,
                    style: {
                        backgroundImage: `url(${badge})`
                    }
                })
            }),
            shouldShowVideo && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$videoContainerStyles,
                children: video
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "information-card-top",
                css: [
                    $cb0e8fe57b0fd046$var$$0f989458047e435a$var$informationCardContainerStyles,
                    (0, $gyDKM.css)({
                        marginTop: shouldShowBadge ? (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250") : "0px"
                    })
                ],
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                        level: 5,
                        color: titleColor,
                        children: displayTitle
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$descriptionStyles,
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                            size: "small",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                            children: description
                        })
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                "data-testid": "duration-progress-container",
                css: [
                    $cb0e8fe57b0fd046$var$$0f989458047e435a$var$informationCardContainerStyles,
                    $cb0e8fe57b0fd046$var$$0f989458047e435a$var$durationProgressContainerStyles
                ],
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        "data-testid": "duration-info",
                        css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$durationContainerStyles,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$spanStyles,
                                children: "Duration"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                label: duration
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        "data-testid": "progress-info",
                        css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$progressContainerStyles,
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$progressPercentageStyles,
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$spanStyles,
                                        children: "Progress "
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                        css: [
                                            $cb0e8fe57b0fd046$var$$0f989458047e435a$var$percentageStyles,
                                            isCompleted && (0, $gyDKM.css)({
                                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.success")
                                            })
                                        ],
                                        children: isCompleted ? "Completed" : `${progress}%`
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$c17561cb55d4db30, {
                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.success"),
                                progress: progress
                            })
                        ]
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$0f989458047e435a$var$controlPanelContainerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$b0db8dac2b423604, {
                    onClick: onClick,
                    isSaved: isSaved,
                    onSave: onSave,
                    state: cardState,
                    urlToShare: urlToShare,
                    contentType: contentType,
                    ctaSlot: ctaSlot
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$informationCardStyles = (0, $gyDKM.css)({
    position: "relative",
    width: "100%",
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderBottom: "unset",
    borderRadius: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    "@media (max-width: 965px)": {
        borderBottom: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
        boxShadow: "unset"
    }
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$courseBorderStyles = (0, $gyDKM.css)({
    borderTop: `8px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.blue")}`
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$learningPathBorderStyles = (0, $gyDKM.css)({
    borderTop: "8px solid #6A9A23"
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$badgeContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: `4px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.accent.blue")}`,
    left: "50%",
    top: "0%",
    transform: "translate(-50%, -60%)",
    background: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 1
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$videoContainerStyles = (0, $gyDKM.css)({
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    ".plyr": {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px"
    }
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$badgeStyles = (0, $gyDKM.css)({
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$informationCardContainerStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$descriptionStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    color: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")} !important`,
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    lineHeight: "22px !important",
    div: {
        paddingBottom: "0 !important",
        display: "flex !important",
        "@media (max-width: 920px)": {
            display: "flex !important"
        }
    },
    "span, p, li": {
        color: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")} !important`,
        fontFamily: "Inter !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        lineHeight: "22px !important"
    },
    li: {
        marginBottom: "6px !important"
    },
    "li:last-child": {
        marginBottom: "0 !important"
    }
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$durationProgressContainerStyles = (0, $gyDKM.css)({
    borderTop: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$durationContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$spanStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$percentageStyles = (0, $gyDKM.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text")
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$progressContainerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$progressPercentageStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$0f989458047e435a$var$controlPanelContainerStyles = (0, $gyDKM.css)({
    "@media (max-width: 965px)": {
        display: "none"
    }
});
var $cb0e8fe57b0fd046$var$$ffc638203e092686$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$ffc638203e092686$exports, "ContentVersioningDialog", ()=>$cb0e8fe57b0fd046$export$3a7bdc050aa55c54);
const $cb0e8fe57b0fd046$export$3a7bdc050aa55c54 = ({ resourceTitle: resourceTitle, subtitle: subtitle, notifications: notifications, onResourceLinkClick: onResourceLinkClick, closeModal: closeModal })=>{
    const handleDismiss = (e)=>{
        e.preventDefault();
        closeModal();
    };
    const handleResourceClick = (e, resourceLink)=>{
        e.preventDefault();
        onResourceLinkClick(resourceLink);
    };
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $2de636e70f18707f$export$2e2bcd8739ae039), {
        onClose: closeModal,
        children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
            "data-testid": "content-versioning-dialog",
            css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$containerStyles,
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$crossIconContainerStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        label: "",
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.ICON,
                        iconType: "cross",
                        iconBefore: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon")
                        }),
                        onClick: handleDismiss
                    })
                }),
                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    children: [
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            "data-testid": "dialog-title",
                            css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$dialogTitleStyles,
                            children: [
                                "Update to ",
                                resourceTitle
                            ]
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            "data-testid": "dialog-subtitle",
                            css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$dialogSubtitleStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                size: "small",
                                color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                children: subtitle
                            })
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
                                    children: "Summary of changes:"
                                }),
                                !!notifications.length && notifications.map((notification)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                        css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$notificationContainerStyles,
                                        children: [
                                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                                children: [
                                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                        "data-testid": "notification-title",
                                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                                            children: notification.title
                                                        })
                                                    }),
                                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("span", {
                                                        css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$notificationDateStyles,
                                                        children: notification.date
                                                    })
                                                ]
                                            }),
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$notificationDescriptionContainerStyles,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                                    size: "small",
                                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtle"),
                                                    children: notification.description
                                                })
                                            }),
                                            notification.contentType === $cb0e8fe57b0fd046$export$e2e108cbe2e4f865.LESSON && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$linkContainerStyles,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a6c7ac8248d6e38a, {
                                                    target: "_blank",
                                                    label: "View changes",
                                                    link: notification.resourceLink,
                                                    icon: "arrow-right",
                                                    onClick: (e)=>handleResourceClick(e, notification.resourceLink)
                                                })
                                            })
                                        ]
                                    }, notification.id))
                            ]
                        })
                    ]
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                    css: $cb0e8fe57b0fd046$var$$ffc638203e092686$var$buttonContainerStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                        label: "Dismiss",
                        appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                        onClick: handleDismiss
                    })
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$containerStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: "8px"
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$crossIconContainerStyles = (0, $gyDKM.css)({
    alignSelf: "flex-end",
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$dialogTitleStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    textAlign: "left"
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$dialogSubtitleStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$notificationContainerStyles = (0, $gyDKM.css)({
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")}`,
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "4px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `4px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$buttonContainerStyles = (0, $gyDKM.css)({
    alignSelf: "flex-end",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    a: {
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075"),
        paddingBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.075")
    }
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$notificationDateStyles = (0, $gyDKM.css)({
    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "18px"
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$notificationDescriptionContainerStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
});
const $cb0e8fe57b0fd046$var$$ffc638203e092686$var$linkContainerStyles = (0, $gyDKM.css)({
    a: {
        "&:hover": {
            textDecoration: "none"
        }
    }
});
var $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$4dfe37aba1865d88$exports, "CustomerInfoForm", ()=>$cb0e8fe57b0fd046$export$6415ce2f4ef17e20);
const $cb0e8fe57b0fd046$var$$292473fda2395210$export$1d1c4391ecac81e8 = async ()=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/all`);
    if (!result.ok) throw Error("Unable to fetch countries");
    return (await result.json()).countryList;
};
const $cb0e8fe57b0fd046$var$$292473fda2395210$export$2bc3cba6f94d7400 = async (isoCountryCode)=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/findByIso/${isoCountryCode}`);
    if (!result.ok) throw Error("Unable to fetch states");
    return result.json();
};
const $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$rowStyles = (0, $gyDKM.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$selectContainer = (0, $gyDKM.css)({
    maxWidth: "420px"
});
const $cb0e8fe57b0fd046$export$6415ce2f4ef17e20 = ({ onSubmit: onSubmit })=>{
    const [countries, setCountries] = (0, $acw62.useState)([]);
    const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)(null);
    const [states, setStates] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            try {
                const list = await $cb0e8fe57b0fd046$var$$292473fda2395210$export$1d1c4391ecac81e8();
                if (!mounted) return;
                setCountries(list);
                const us = list.find((c)=>c.isoCountryCode === "US" || c.countryIsoCode === "US" || c.displayName === "United States");
                if (us) setSelectedCountry(us);
            } catch  {
            // ignore network errors in Storybook/local environments
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            if (!selectedCountry) {
                setStates([]);
                return;
            }
            if (selectedCountry.states && selectedCountry.states.length) {
                setStates(selectedCountry.states);
                return;
            }
            try {
                const detailed = await $cb0e8fe57b0fd046$var$$292473fda2395210$export$2bc3cba6f94d7400(selectedCountry.isoCountryCode || selectedCountry.countryIsoCode);
                if (!mounted) return;
                setStates(detailed.states || []);
            } catch  {
                setStates([]);
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, [
        selectedCountry
    ]);
    const countryOptions = (0, $acw62.useMemo)(()=>countries.map((c)=>({
                label: c.displayName || c.countryIsoCode,
                value: c.isoCountryCode || c.countryIsoCode,
                data: c
            })), [
        countries
    ]);
    const stateOptions = (0, $acw62.useMemo)(()=>states.map((s)=>({
                label: s.name,
                value: s.code
            })), [
        states
    ]);
    const selectedCountryOption = (0, $acw62.useMemo)(()=>{
        if (!selectedCountry) return null;
        return {
            label: selectedCountry.displayName || selectedCountry.countryIsoCode,
            value: selectedCountry.isoCountryCode || selectedCountry.countryIsoCode,
            data: selectedCountry
        };
    }, [
        selectedCountry
    ]);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $881b21ff70ac9ef2$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: (0, $gyDKM.css)({
                            marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Customer Information"
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: [
                            $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$rowStyles,
                            $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "first-name",
                                        children: "First Name"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "first-name",
                                                placeholder: "First Name",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "last-name",
                                        children: "Last Name"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "last-name",
                                                placeholder: "Last Name",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "address1",
                                children: "Address"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                name: "address1",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address1",
                                        placeholder: "Address",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "address2",
                                children: "Address Line 2 (Optional)"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                name: "address2",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address2",
                                        placeholder: "Address Line 2"
                                    })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "city",
                                children: "City"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                name: "city",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "city",
                                        placeholder: "City",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: [
                            $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$rowStyles,
                            $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "country",
                                        children: "Country"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "country",
                                        defaultValue: selectedCountryOption,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6e237539ccf81b49$export$2e2bcd8739ae039), {
                                                    inputId: "country",
                                                    options: countryOptions,
                                                    value: value || selectedCountryOption,
                                                    placeholder: "Select country",
                                                    onChange: (opt)=>{
                                                        onChange(opt);
                                                        const countryData = opt?.data;
                                                        setSelectedCountry(countryData || null);
                                                    }
                                                })
                                            })
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "state",
                                        children: "State"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "state",
                                        defaultValue: null,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                css: $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6e237539ccf81b49$export$2e2bcd8739ae039), {
                                                    inputId: "state",
                                                    options: stateOptions,
                                                    value: value,
                                                    placeholder: "Select state",
                                                    isDisabled: !selectedCountry,
                                                    onChange: (opt)=>onChange(opt)
                                                })
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: [
                            $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$rowStyles,
                            $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "postcode",
                                        children: "Zip Code"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "postcode",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "postcode",
                                                placeholder: "Zip Code",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "phone",
                                        children: "Phone Number"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "phone",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "phone",
                                                placeholder: "Phone Number",
                                                type: "tel",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
};
var $cb0e8fe57b0fd046$var$$556680ce820612ab$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$556680ce820612ab$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$556680ce820612ab$exports, "PaymentInfoForm", ()=>$cb0e8fe57b0fd046$export$f950880927ff03db);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$556680ce820612ab$exports, "default", ()=>$cb0e8fe57b0fd046$var$$556680ce820612ab$export$2e2bcd8739ae039);
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$rowStyles = (0, $gyDKM.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$fieldBlock = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$selectContainer = (0, $gyDKM.css)({
    maxWidth: "220px"
});
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits = (s)=>s.replace(/\D+/g, "");
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$formatCardNumber = (value)=>{
    const digits = $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(value).slice(0, 19); // support up to 19 digits
    // group into 4s: 4-4-4-4-3
    const groups = [];
    for(let i = 0; i < digits.length; i += 4)groups.push(digits.slice(i, i + 4));
    return groups.join(" ").trim();
};
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$luhnCheck = (value)=>{
    const digits = $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(value);
    if (digits.length < 12) return false;
    // basic length gate
    let sum = 0;
    let shouldDouble = false;
    for(let i = digits.length - 1; i >= 0; i--){
        let digit = parseInt(digits.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
};
const $cb0e8fe57b0fd046$var$$556680ce820612ab$var$isExpiryInPast = (month, year)=>{
    if (!month || !year) return false;
    // incomplete fields handled elsewhere
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    if (year < currentYear) return true;
    if (year === currentYear && month < currentMonth) return true;
    return false;
};
const $cb0e8fe57b0fd046$export$f950880927ff03db = ({ onSubmit: onSubmit })=>{
    const monthOptions = (0, $acw62.useMemo)(()=>Array.from({
            length: 12
        }, (_, i)=>{
            const m = i + 1;
            const label = m < 10 ? `0${m}` : `${m}`;
            return {
                label: label,
                value: m
            };
        }), []);
    const yearOptions = (0, $acw62.useMemo)(()=>{
        const now = new Date();
        const start = now.getFullYear();
        const end = start + 20;
        const arr = [];
        for(let y = start; y <= end; y++)arr.push({
            label: `${y}`,
            value: y
        });
        return arr;
    }, []);
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $881b21ff70ac9ef2$export$2e2bcd8739ae039), {
        onSubmit: (values)=>{
            // normalize values before submit
            const normalized = {
                ...values,
                cardNumber: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(values.cardNumber || "")
            };
            return onSubmit(normalized);
        },
        children: ({ formProps: formProps })=>(0, $115bf1020744eac3$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                        css: (0, $gyDKM.css)({
                            marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Payment Information"
                        })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "cardholder-name",
                                children: "Name on card"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                name: "cardholderName",
                                defaultValue: "",
                                validate: (v)=>!v ? "Required" : undefined,
                                children: ({ fieldProps: fieldProps, error: error })=>(0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "cardholder-name",
                                                placeholder: "Name on card",
                                                required: true
                                            }),
                                            error && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "card-number",
                                children: "Card number"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                name: "cardNumber",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 12) return "Enter a valid card number";
                                    if (!$cb0e8fe57b0fd046$var$$556680ce820612ab$var$luhnCheck(v)) return "Enter a valid card number";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "card-number",
                                                placeholder: "1234 5678 9012 3456",
                                                inputMode: "numeric",
                                                autoComplete: "cc-number",
                                                value: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$formatCardNumber(String(value ?? "")),
                                                onChange: (e)=>onChange($cb0e8fe57b0fd046$var$$556680ce820612ab$var$formatCardNumber(e.target.value)),
                                                required: true
                                            }),
                                            error && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: [
                            $cb0e8fe57b0fd046$var$$556680ce820612ab$var$rowStyles,
                            $cb0e8fe57b0fd046$var$$556680ce820612ab$var$fieldBlock
                        ],
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-month",
                                        children: "Expiry month"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "expiryMonth",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            if (!v) return "Required";
                                            const monthVal = v?.value;
                                            const yearVal = values?.expiryYear?.value;
                                            if (monthVal && yearVal && $cb0e8fe57b0fd046$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                        css: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6e237539ccf81b49$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-month",
                                                            options: monthOptions,
                                                            value: value,
                                                            placeholder: "MM",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-year",
                                        children: "Expiry year"
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                        name: "expiryYear",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            // cross validate month/year when both exist
                                            const monthVal = values?.expiryMonth?.value;
                                            const yearVal = v?.value;
                                            if (!v) return "Required";
                                            if (monthVal && yearVal && $cb0e8fe57b0fd046$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                        css: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6e237539ccf81b49$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-year",
                                                            options: yearOptions,
                                                            value: value,
                                                            placeholder: "YYYY",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                        css: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $993d6aa380217926$export$b04be29aa201d4f5), {
                                htmlFor: "cvc",
                                children: "Security code (CVC)"
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $b25ca8e3392a46e5$export$2e2bcd8739ae039), {
                                name: "cvc",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 3 || digits.length > 4) return "Enter a valid CVC";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $115bf1020744eac3$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "cvc",
                                                placeholder: "CVC",
                                                type: "password",
                                                inputMode: "numeric",
                                                autoComplete: "cc-csc",
                                                value: $cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(String(value ?? "")).slice(0, 4),
                                                onChange: (e)=>onChange($cb0e8fe57b0fd046$var$$556680ce820612ab$var$onlyDigits(e.target.value).slice(0, 4)),
                                                required: true
                                            }),
                                            error && (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
    });
};
var $cb0e8fe57b0fd046$var$$556680ce820612ab$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$export$f950880927ff03db;
var $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$exports, "CheckoutSummary", ()=>$cb0e8fe57b0fd046$export$fde280adb8350d09);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$exports, "default", ()=>$cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039);
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency = (amountInCents, currency = "USD")=>{
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amountInCents / 100);
    } catch  {
        return `$${(amountInCents / 100).toFixed(2)}`;
    }
};
const $cb0e8fe57b0fd046$export$fde280adb8350d09 = ({ subtotal: subtotal, salesTax: salesTax, total: total, items: items, paymentMethod: paymentMethod, currency: currency = "USD" })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const itemCountText = (0, $acw62.useMemo)(()=>`${items.length} item${items.length === 1 ? "" : "s"}`, [
        items.length
    ]);
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$containerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                level: 4,
                children: "Summary"
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        children: "Subtotal"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        children: "Sales Tax"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$dividerStyles
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: [
                    $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$rowStyles,
                    (0, $gyDKM.css)({
                        marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
                    })
                ],
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                        level: 6,
                        children: "Total"
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                        level: 6,
                        children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: [
                            "Payment Method: ",
                            paymentMethod
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: itemCountText
                    })
                ]
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$buttonRowStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                    label: "Review Purchase",
                    appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                    fullWidth: true,
                    size: $cb0e8fe57b0fd046$export$5dd2748b7940a2a0.LARGE,
                    onClick: ()=>setIsOpen(true)
                })
            }),
            isOpen && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $2de636e70f18707f$export$2e2bcd8739ae039), {
                onClose: ()=>setIsOpen(false),
                children: (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                    css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalContainerStyles,
                    children: [
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalHeaderStyles,
                            children: [
                                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                    level: 3,
                                    children: "Review and Confirm"
                                }),
                                (0, $115bf1020744eac3$export$25062201e9e25d76)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: [
                                        currency,
                                        " \u2022 ",
                                        paymentMethod
                                    ]
                                })
                            ]
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalSectionStyles,
                            children: items.map((item, idx)=>(0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            children: item.name
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(item.price, currency)
                                        })
                                    ]
                                }, `${item.name}-${idx}`))
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$dividerStyles
                        }),
                        (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                            css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalTotalsStyles,
                            children: [
                                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            children: "Subtotal"
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                                        })
                                    ]
                                }),
                                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            children: "Sales Tax"
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                            children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                                        })
                                    ]
                                }),
                                (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
                                    css: [
                                        $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                        (0, $gyDKM.css)({
                                            marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.150")
                                        })
                                    ],
                                    children: [
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: "Total"
                                        }),
                                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                            css: $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalButtonRowStyles,
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$353f5b6fc5456de1, {
                                label: "Confirm Purchase",
                                appearance: $cb0e8fe57b0fd046$export$261c9483fc4a455a.PRIMARY,
                                onClick: ()=>setIsOpen(false)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$containerStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$rowStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$dividerStyles = (0, $gyDKM.css)({
    height: 1,
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border"),
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$buttonRowStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalContainerStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    minWidth: "560px"
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalHeaderStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalSectionStyles = (0, $gyDKM.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.100")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$itemRowStyles = (0, $gyDKM.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalTotalsStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.250")
});
const $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$var$modalButtonRowStyles = (0, $gyDKM.css)({
    marginTop: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.400"),
    display: "flex",
    justifyContent: "center"
});
var $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$export$fde280adb8350d09;
var $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$exports = {};
$cb0e8fe57b0fd046$var$$parcel$defineInteropFlag($cb0e8fe57b0fd046$var$$2397677ef2f4ee69$exports);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$2397677ef2f4ee69$exports, "Orders", ()=>$cb0e8fe57b0fd046$export$ed0df17bf864fd7b);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$2397677ef2f4ee69$exports, "default", ()=>$cb0e8fe57b0fd046$var$$2397677ef2f4ee69$export$2e2bcd8739ae039);
const $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$var$containerStyles = (0, $gyDKM.css)({
    padding: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input")
});
const $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$var$headerStyles = (0, $gyDKM.css)({
    marginBottom: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.200")
});
const $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$var$amountToUsd = (amount)=>{
    const dollars = (amount / 100).toFixed(2);
    return `USD $${dollars}`;
};
const $cb0e8fe57b0fd046$export$ed0df17bf864fd7b = ({ orders: orders })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)("div", {
        css: $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$var$containerStyles,
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("div", {
                css: $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$var$headerStyles,
                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$a8a3e93435678ff9, {
                    level: 4,
                    children: "Transactions"
                })
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $33b867bab2bb82ec$export$2e2bcd8739ae039), {
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $e874157b269c4e90$export$2e2bcd8739ae039), {
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $7feb6fad64afcd7f$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Date"
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $7feb6fad64afcd7f$export$2e2bcd8739ae039), {
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Purchase Info"
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $7feb6fad64afcd7f$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Payment Method"
                                })
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $7feb6fad64afcd7f$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Price"
                                })
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $f6f45c912d8223eb$export$2e2bcd8739ae039), {
                        children: orders.map((o)=>(0, $115bf1020744eac3$export$25062201e9e25d76)((0, $f9fc543e7b74aa80$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6ddc7161cee40b98$export$9cf5b401f969f5e3), {
                                        children: o.date
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6ddc7161cee40b98$export$9cf5b401f969f5e3), {
                                        children: o.summary
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6ddc7161cee40b98$export$9cf5b401f969f5e3), {
                                        children: o.paymentMethod
                                    }),
                                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $6ddc7161cee40b98$export$9cf5b401f969f5e3), {
                                        children: $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$var$amountToUsd(o.totalAmount)
                                    })
                                ]
                            }, o.id))
                    })
                ]
            })
        ]
    });
};
var $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$export$2e2bcd8739ae039 = $cb0e8fe57b0fd046$export$ed0df17bf864fd7b;
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$83fc18f8199a12ff$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$438c82700c218044$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$389dbaf1c04dd698$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$c18917e553fd2737$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$3ca3d702a74367ba$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$e018ab7ed2648ae8$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$81dd635d83decaee$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$8d99d7c025746ac9$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$1f7c4876f10b107b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$c5616d3f1657fc84$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$eb6f767c51421421$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$7fe7e19d380f3d34$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$915f5687b3b07750$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$579f9ef2424e0bd8$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$d559b1cc82536c49$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$fa53e9c0a1746730$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$9225344cd5d1f99b$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$3b9afd8fe4435353$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$050a30fc95775cfd$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$65703ff0bcd12648$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$8340d81aba797956$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$dbb9d5792c296a49$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$2cfa64583f556289$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$44303f6c3c81eeac$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$9c3f769544bb2079$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$3d76652bb6362040$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$764442aba3de2fce$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$77282b3961d82199$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$4c35f7fd4ad5f13f$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$d8ee29df49af8811$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$27d686e47ff412fd$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$a4deb03146bf3bfc$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$0ae392c3008c8a3e$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$205ed41b47d90e33$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$3c691af970e2b3d8$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$5f9280667c666470$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$ec9b8ebbd21bd316$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$ffad026de847a971$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$0f989458047e435a$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$a7b3e1c0391fddac$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$ffc638203e092686$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$ed20910b93d89c3f$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$4dfe37aba1865d88$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$556680ce820612ab$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$6a8b328ff2ec0580$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports, $cb0e8fe57b0fd046$var$$2397677ef2f4ee69$exports);
var $cb0e8fe57b0fd046$var$$0cf4554ad00467b5$exports = {};
var $cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "CommunityLogo", ()=>$cb0e8fe57b0fd046$export$311e5e9ca09eea69);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "CommunityNavigation", ()=>$cb0e8fe57b0fd046$export$901cb8c9de2be2aa);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "AnalyticsActivityType", ()=>$cb0e8fe57b0fd046$export$d778a884eb401313);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "EventType", ()=>$cb0e8fe57b0fd046$export$3d7865934588d77e);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "CommunityApp", ()=>$cb0e8fe57b0fd046$export$93d048dc21eb282a);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "MenuItemWithAnalytics", ()=>$cb0e8fe57b0fd046$export$92905cc84b82619c);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "APP_BUTTONS", ()=>$cb0e8fe57b0fd046$export$208c68d48dfc9a12);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports, "getAppButtons", ()=>$cb0e8fe57b0fd046$export$67e61a6fa639f224);
const $cb0e8fe57b0fd046$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref, analyticsInfo: analyticsInfo })=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00, {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $cb0e8fe57b0fd046$var$$a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu, appButtonHrefOverrides)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return $cb0e8fe57b0fd046$export$67e61a6fa639f224(email).map((button)=>{
        const defaultHref = button.app === $cb0e8fe57b0fd046$export$93d048dc21eb282a.FORUMS && isLoggedIn && forumsLoggedInRedirectHref ? `${button.href[loginState]}${forumsLoggedInRedirectHref}` : button.href[loginState];
        const overriddenHref = appButtonHrefOverrides?.[button.app]?.[loginState];
        return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$341f96d5922d8aaa$export$b18dbc162161ec9c, {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: overriddenHref ?? defaultHref,
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo,
            showNewMenu: showNewMenu
        }, button.app);
    });
};
const $cb0e8fe57b0fd046$export$901cb8c9de2be2aa = ({ currentApp: currentApp, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, subMenuContentByApp: subMenuContentByApp, onAnalyticsSendEvent: onAnalyticsSendEvent, forumsLoggedInRedirectHref: forumsLoggedInRedirectHref, appButtonHrefOverrides: appButtonHrefOverrides, isSticky: isSticky = true, email: email, showNewMenu: showNewMenu = false })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $acw62.useMemo)(()=>$cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$d349399b473d7299[loginState], [
        loginState
    ]);
    const isMobileOrTablet = $cb0e8fe57b0fd046$export$32d5543ab307c01(`(max-width: ${$cb0e8fe57b0fd046$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    const leftItems = [
        ...$cb0e8fe57b0fd046$var$$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu, appButtonHrefOverrides)
    ];
    // Create logo item
    const logoItem = (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$311e5e9ca09eea69, {
        subtitleHref: homeHref,
        analyticsInfo: analyticsInfo
    }, "community-logo");
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$fddd19fbf4d591d8, {
        logoItem: logoItem,
        leftItems: leftItems,
        isLoggedIn: isLoggedIn,
        user: user,
        loginHref: loginHref,
        signupHref: signupHref,
        logoutHref: logoutHref,
        switchHref: switchHref,
        profileHref: profileHref ?? $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$132b2bf91782e62b,
        settingsHref: settingsHref ?? $cb0e8fe57b0fd046$var$$1ff01338112cd7fe$export$b9cc8022ec117e91,
        onAnalyticsSendEvent: onAnalyticsSendEvent,
        isSticky: isSticky,
        showNewMenu: showNewMenu,
        currentApp: currentApp
    });
};
var $cb0e8fe57b0fd046$var$$976a3c76bc9fa9bc$exports = {};
var $cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$exports, "ForumFeedItem", ()=>$cb0e8fe57b0fd046$export$1074985837f1b2a5);
const $cb0e8fe57b0fd046$var$$c13069d48b7dab65$export$bbef7a8f2307e1f9 = ()=>{
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6668 8.00004C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00004C1.3335 4.31814 4.31826 1.33337 8.00016 1.33337C11.6821 1.33337 14.6668 4.31814 14.6668 8.00004ZM6.2551 7.37932C6.33643 7.41426 6.41 7.46505 6.47149 7.52872L7.33349 8.39072L9.52883 6.19539C9.59033 6.13171 9.66389 6.08093 9.74522 6.04599C9.82656 6.01105 9.91404 5.99266 10.0026 5.99189C10.0911 5.99112 10.1789 6.00799 10.2608 6.04151C10.3427 6.07503 10.4172 6.12453 10.4798 6.18712C10.5424 6.24972 10.5919 6.32415 10.6254 6.40608C10.6589 6.48802 10.6758 6.5758 10.675 6.66432C10.6742 6.75284 10.6558 6.84032 10.6209 6.92166C10.586 7.00299 10.5352 7.07656 10.4715 7.13805L7.80483 9.80472C7.67981 9.9297 7.51027 9.99991 7.33349 9.99991C7.15672 9.99991 6.98718 9.9297 6.86216 9.80472L5.52883 8.47139C5.46515 8.40989 5.41437 8.33633 5.37943 8.25499C5.34449 8.17365 5.3261 8.08617 5.32533 7.99765C5.32456 7.90913 5.34143 7.82135 5.37495 7.73942C5.40847 7.65749 5.45797 7.58305 5.52056 7.52046C5.58316 7.45786 5.65759 7.40836 5.73952 7.37484C5.82146 7.34132 5.90924 7.32445 5.99776 7.32522C6.08628 7.32599 6.17376 7.34438 6.2551 7.37932Z",
            fill: "#22A06B"
        })
    });
};
var $cb0e8fe57b0fd046$var$$fa9d4c58bb661680$exports = {};
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fa9d4c58bb661680$exports, "ForumFeedItemContentType", ()=>$cb0e8fe57b0fd046$export$96b2e747ae3de284);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fa9d4c58bb661680$exports, "ForumFeedItemCategoryType", ()=>$cb0e8fe57b0fd046$export$c6c284c40052569e);
$cb0e8fe57b0fd046$var$$parcel$export($cb0e8fe57b0fd046$var$$fa9d4c58bb661680$exports, "ForumFeedItemStatus", ()=>$cb0e8fe57b0fd046$export$88a22e3eec02cfbe);
let $cb0e8fe57b0fd046$export$96b2e747ae3de284;
(function(ForumFeedItemContentType) {
    ForumFeedItemContentType["Question"] = "Question";
    ForumFeedItemContentType["Discussion"] = "Discussion";
    ForumFeedItemContentType["Article"] = "Article";
})($cb0e8fe57b0fd046$export$96b2e747ae3de284 || ($cb0e8fe57b0fd046$export$96b2e747ae3de284 = {}));
let $cb0e8fe57b0fd046$export$c6c284c40052569e;
(function(ForumFeedItemCategoryType) {
    ForumFeedItemCategoryType["Subject"] = "subject";
    ForumFeedItemCategoryType["App"] = "app";
    ForumFeedItemCategoryType["Group"] = "group";
})($cb0e8fe57b0fd046$export$c6c284c40052569e || ($cb0e8fe57b0fd046$export$c6c284c40052569e = {}));
let $cb0e8fe57b0fd046$export$88a22e3eec02cfbe;
(function(ForumFeedItemStatus) {
    ForumFeedItemStatus["AnswerNotAccepted"] = "Answered Not Accepted";
    ForumFeedItemStatus["UnAnswered"] = "Unanswered";
    ForumFeedItemStatus["AnsweredAccepted"] = "Answered Accepted";
})($cb0e8fe57b0fd046$export$88a22e3eec02cfbe || ($cb0e8fe57b0fd046$export$88a22e3eec02cfbe = {}));
const $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$getMetricLabel = (value, singular, plural)=>value === 1 ? singular : plural;
const $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$export$9e55f86bc7a20cd4 = ({ likes: likes, responses: responses, views: views, status: status, contentType: contentType })=>{
    const showAnswerText = ()=>{
        switch(status){
            case $cb0e8fe57b0fd046$export$88a22e3eec02cfbe.AnsweredAccepted:
                return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                    xcss: $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$c13069d48b7dab65$export$bbef7a8f2307e1f9, {}),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                            size: "small",
                            weight: "semibold",
                            children: "ANSWER ACCEPTED"
                        })
                    ]
                });
            case $cb0e8fe57b0fd046$export$88a22e3eec02cfbe.AnswerNotAccepted:
                return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                    xcss: $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                        size: "small",
                        weight: "semibold",
                        children: "ANSWERED"
                    })
                });
            default:
                return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                    xcss: $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                        size: "small",
                        weight: "semibold",
                        children: "UNANSWERED"
                    })
                });
        }
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.200",
        wrap: "wrap",
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                alignItems: "center",
                gap: "space.150",
                wrap: "wrap",
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($93c6bdb4ac81baf8$exports))), {
                                label: "Likes"
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    likes,
                                    " ",
                                    $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$getMetricLabel(likes, "like", "likes")
                                ]
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6050d4148ee1f561$exports))), {
                                label: "Responses"
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    responses,
                                    " ",
                                    $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$getMetricLabel(responses, "response", "responses")
                                ]
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fe10faeab8e06616$exports))), {
                                label: "Views"
                            }),
                            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    views,
                                    " ",
                                    $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$getMetricLabel(views, "view", "views")
                                ]
                            })
                        ]
                    })
                ]
            }),
            contentType === $cb0e8fe57b0fd046$export$96b2e747ae3de284.Question ? showAnswerText() : null
        ]
    });
};
const $cb0e8fe57b0fd046$var$$2248ded33c1cc26f$var$answerContainerStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center",
    gap: "space.075"
});
const $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a = (appName)=>{
    return appName.trim().replace(/[-_]+/g, " ").replace(/\s+/g, " ").split(" ").filter(Boolean).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
const $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$normalizeProductKey = (product)=>{
    return product.trim().toLowerCase().replace(/[\s_]+/g, "-");
};
const $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$productLogoMap = {
    // Company
    atlassian: (0, $842d1a7a26358f8d$export$8a485e2e7ed91e8f),
    "atlassian-analytics": (0, $45d19b87dc78f9cb$export$c42ad8a0b925c762),
    analytics: (0, $45d19b87dc78f9cb$export$c42ad8a0b925c762),
    access: (0, $ddd1928b087fe365$export$a825993f361832f7),
    "atlassian-access": (0, $ddd1928b087fe365$export$a825993f361832f7),
    community: (0, $842d1a7a26358f8d$export$8a485e2e7ed91e8f),
    // Products
    atlas: (0, $45d19b87dc78f9cb$export$92c8767b874048d),
    focus: (0, $45d19b87dc78f9cb$export$1e02e7298035a77c),
    crowd: (0, $45d19b87dc78f9cb$export$eaf73f391f7103bd),
    bitbucket: (0, $45d19b87dc78f9cb$export$5fc1066e677788d4),
    compass: (0, $45d19b87dc78f9cb$export$f7857fe64d7161d9),
    confluence: (0, $45d19b87dc78f9cb$export$68f3db7f6af48bcb),
    guard: (0, $45d19b87dc78f9cb$export$3f95fcfdc25a741d),
    "atlassian-guard": (0, $45d19b87dc78f9cb$export$3f95fcfdc25a741d),
    jira: (0, $45d19b87dc78f9cb$export$c4b5b1f965d8b3eb),
    "jira-software": (0, $45d19b87dc78f9cb$export$c4b5b1f965d8b3eb),
    "jira-service-management": (0, $45d19b87dc78f9cb$export$3c6158790f5e01c4),
    "jira-service-desk": (0, $45d19b87dc78f9cb$export$3c6158790f5e01c4),
    jsm: (0, $45d19b87dc78f9cb$export$3c6158790f5e01c4),
    "jira-product-discovery": (0, $45d19b87dc78f9cb$export$21bfbeb62fdcce8d),
    jpd: (0, $45d19b87dc78f9cb$export$21bfbeb62fdcce8d),
    "jira-align": (0, $45d19b87dc78f9cb$export$407687b2dd89cc68),
    align: (0, $45d19b87dc78f9cb$export$407687b2dd89cc68),
    "jira-work-management": (0, $45d19b87dc78f9cb$export$c4b5b1f965d8b3eb),
    jwm: (0, $45d19b87dc78f9cb$export$c4b5b1f965d8b3eb),
    bamboo: (0, $45d19b87dc78f9cb$export$e812398311cab9a3),
    marketplace: (0, $8456a8cbaccd3322$export$94c87d39a54a1894),
    "atlassian-marketplace": (0, $8456a8cbaccd3322$export$94c87d39a54a1894),
    talent: (0, $45d19b87dc78f9cb$export$4b05688514531169),
    teams: (0, $45d19b87dc78f9cb$export$1bcbc9c337da86da),
    studio: (0, $45d19b87dc78f9cb$export$290a0f24614cde9f),
    projects: (0, $45d19b87dc78f9cb$export$5ed3e1bb3b04fc02),
    goals: (0, $45d19b87dc78f9cb$export$9eb74917ea768ed4),
    "atlassian-administration": (0, $45d19b87dc78f9cb$export$ef8e5f836dd989d3),
    "atlassian-admin": (0, $45d19b87dc78f9cb$export$ef8e5f836dd989d3),
    admin: (0, $45d19b87dc78f9cb$export$ef8e5f836dd989d3),
    assets: (0, $45d19b87dc78f9cb$export$d89497e7f33ca6f5),
    "rovo-dev": (0, $45d19b87dc78f9cb$export$8b784b3227531b3e),
    dx: (0, $45d19b87dc78f9cb$export$9951d02c2d848122),
    hub: (0, $45d19b87dc78f9cb$export$80b8b269d8b5014e),
    home: (0, $45d19b87dc78f9cb$export$92c8767b874048d),
    loom: (0, $45d19b87dc78f9cb$export$8d789f76fde3e05),
    opsgenie: (0, $45d19b87dc78f9cb$export$eeccc49dc7a12d9f),
    rovo: (0, $45d19b87dc78f9cb$export$e23ae35269442b4f),
    "rovo-atlassian-intelligence": (0, $45d19b87dc78f9cb$export$e23ae35269442b4f),
    statuspage: (0, $45d19b87dc78f9cb$export$f3f5aa321d88adf9),
    trello: (0, $45d19b87dc78f9cb$export$4384da9b8b140bf4),
    "customer-service-management": (0, $45d19b87dc78f9cb$export$6da5aa77c402ba0f)
};
const $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap = {
    "jira-service-management": (0, $45d19b87dc78f9cb$export$65fae0eaf343f2ca),
    jira: (0, $45d19b87dc78f9cb$export$f8455b5667a3ee0c),
    confluence: (0, $45d19b87dc78f9cb$export$53305f1f2855d3be),
    bitbucket: (0, $45d19b87dc78f9cb$export$d3ab16bbf4f954ee)
};
const $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$export$39846976078a8f0d = (product, props, hostingType)=>{
    const key = $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$normalizeProductKey(product);
    let Logo;
    if (hostingType === "data-center" && key in $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap) Logo = $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap[key];
    else Logo = $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$var$productLogoMap[key];
    if (!Logo) return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $842d1a7a26358f8d$export$8a485e2e7ed91e8f), {
        size: "xsmall",
        ...props,
        shouldUseNewLogoDesign: true,
        appearance: "brand"
    });
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)(Logo, {
        size: "xsmall",
        ...props,
        shouldUseNewLogoDesign: true,
        appearance: "brand"
    });
};
const $cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c = {
    color: "color.text",
    cursor: "pointer",
    position: "relative",
    textDecoration: "none",
    fontSize: "14px"
};
const $cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$37cc822878118153 = {
    textDecoration: "none",
    ":hover": {
        textDecoration: "none",
        color: "color.text"
    }
};
const $cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$ef0b806eff7008c6 = {
    textDecoration: "none",
    color: "color.text",
    ":hover": {
        color: "color.text",
        textDecoration: "none"
    },
    ":visited": {
        color: "color.text",
        textDecoration: "none"
    }
};
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$anchorResetStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)($cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$ef0b806eff7008c6);
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$anchorDetailStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)($cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c);
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$hoverUnderlineStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)($cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$37cc822878118153);
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$getContentTypeBackground = (contentType)=>{
    switch(contentType){
        case $cb0e8fe57b0fd046$export$96b2e747ae3de284.Question:
            return (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.warning.pressed");
        case $cb0e8fe57b0fd046$export$96b2e747ae3de284.Discussion:
            return (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.discovery.pressed");
        case $cb0e8fe57b0fd046$export$96b2e747ae3de284.Article:
            return (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.information.pressed");
    }
};
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$renderProductLogo = (name, hostingType)=>$cb0e8fe57b0fd046$var$$027dbfbbc85481a9$export$39846976078a8f0d(name, {
        size: "xsmall"
    }, hostingType);
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$export$7d7346e428084a7e = ({ contentType: contentType, isFeatured: isFeatured, categoryName: categoryName, categoryType: categoryType, categoryHref: categoryHref, menuComponent: menuComponent, hostingType: hostingType, isNew: isNew })=>{
    const categoryShown = ()=>{
        switch(categoryType){
            case $cb0e8fe57b0fd046$export$c6c284c40052569e.App:
                return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                    gap: "space.075",
                    alignItems: "center",
                    children: [
                        $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$renderProductLogo(categoryName, hostingType),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                            color: "color.text",
                            size: "medium",
                            children: $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                        })
                    ]
                });
            case $cb0e8fe57b0fd046$export$c6c284c40052569e.Group:
                return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                    gap: "space.075",
                    alignItems: "center",
                    children: [
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e29d94b3c318ce90$exports))), {
                            label: "group"
                        }),
                        (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                            color: "color.text",
                            size: "medium",
                            children: $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                        })
                    ]
                });
            case $cb0e8fe57b0fd046$export$c6c284c40052569e.Subject:
                return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                    color: "color.text",
                    size: "medium",
                    children: $cb0e8fe57b0fd046$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                });
        }
    };
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        alignItems: "stretch",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                label: contentType,
                isTall: true,
                backgroundColor: $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$getContentTypeBackground(contentType),
                borderColor: "transparent"
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                gap: "space.150",
                alignItems: "center",
                children: [
                    isNew && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                        label: "New",
                        isTall: true,
                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
                        borderColor: "#C97CF4"
                    }),
                    isFeatured && (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                        label: "Featured",
                        isTall: true,
                        backgroundColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.background.input"),
                        borderColor: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.border.accent.blue")
                    }),
                    categoryHref ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                        as: "a",
                        href: categoryHref,
                        xcss: [
                            $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$anchorDetailStyles,
                            $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$anchorResetStyles,
                            $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$hoverUnderlineStyles,
                            $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$categoryLinkStyles
                        ],
                        children: categoryShown()
                    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                        xcss: $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$categoryLinkStyles,
                        children: categoryShown()
                    }),
                    menuComponent
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$06e8096ff5ff1247$var$categoryLinkStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center"
});
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$anchorResetStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)($cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$ef0b806eff7008c6);
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$anchorDetailStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)($cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c);
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$hoverUnderlineStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)($cb0e8fe57b0fd046$var$$eb5a017dbcef9100$export$37cc822878118153);
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$noWrapText = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    whiteSpace: "nowrap"
});
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$export$1e30305c33fd8c57 = ({ tags: tags, timestamp: timestamp, authorDetails: authorDetails, authorHref: authorHref, authorHoverContent: authorHoverContent, rankComponent: rankComponent })=>{
    const [isAuthorHoverOpen, setIsAuthorHoverOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const authorHoverRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const tagsShown = tags.slice(0, 2);
    const extraTagCount = tags.length - tagsShown.length;
    const handleAuthorHoverOpen = ()=>setIsAuthorHoverOpen(true);
    const handleAuthorHoverClose = (event)=>{
        const relatedTarget = event?.relatedTarget;
        if (relatedTarget instanceof Node && authorHoverRef.current?.contains(relatedTarget)) return;
        setIsAuthorHoverOpen(false);
    };
    const authorContent = (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        alignItems: "center",
        gap: "space.025",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3778be82376b06d7, {
                size: $cb0e8fe57b0fd046$export$902867f9afe4e0c1.S,
                src: authorDetails.avatarUrl,
                label: authorDetails.name
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                size: "medium",
                children: authorDetails.name
            })
        ]
    });
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        wrap: "wrap",
        gap: "space.300",
        justifyContent: "space-between",
        children: [
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                wrap: "wrap",
                alignItems: "center",
                gap: "space.050",
                children: [
                    tagsShown.map((tag)=>{
                        return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                            as: "a",
                            href: tag.hyperlink,
                            xcss: [
                                $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$pillInteractiveStyles,
                                $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$anchorResetStyles
                            ],
                            children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                                label: `# ${tag.tag}`,
                                backgroundColor: "transparent",
                                borderColor: "color.border",
                                textTransform: "none",
                                fontWeight: "normal",
                                fontFamily: "Atlassian Sans, sans-serif",
                                maxSize: "250px",
                                padding: `${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.025")} ${(0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("space.050")}`
                            })
                        }, tag.tag);
                    }),
                    extraTagCount > 0 ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$export$3288d34c523a1192, {
                        label: `+${extraTagCount} more`,
                        textTransform: "none",
                        isTall: true,
                        borderColor: "transparent",
                        fontWeight: "400",
                        fontFamily: "Inter"
                    }) : null
                ]
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                wrap: "wrap",
                gap: "space.150",
                alignItems: "center",
                justifyContent: "end",
                xcss: (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
                    flex: "1"
                }),
                children: [
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $3bb76fb59b0ba000$export$2e2bcd8739ae039), {
                        content: $cb0e8fe57b0fd046$export$a31e25c49c78e203(timestamp),
                        children: (tooltipProps)=>(0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                                as: "span",
                                ...tooltipProps,
                                xcss: $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$noWrapText,
                                children: (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                                    size: "medium",
                                    children: $cb0e8fe57b0fd046$export$880acc1b13aaa28b(timestamp, "full")
                                })
                            })
                    }),
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                        columnGap: "space.100",
                        wrap: "wrap",
                        justifyContent: "end",
                        children: [
                            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                                xcss: $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$authorHoverTargetStyles,
                                onMouseEnter: handleAuthorHoverOpen,
                                onMouseLeave: handleAuthorHoverClose,
                                onFocusCapture: handleAuthorHoverOpen,
                                onBlurCapture: handleAuthorHoverClose,
                                ref: authorHoverRef,
                                children: [
                                    authorHref ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                                        as: "a",
                                        href: authorHref,
                                        xcss: [
                                            $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$anchorDetailStyles,
                                            $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$hoverUnderlineStyles,
                                            $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$noWrapText
                                        ],
                                        children: authorContent
                                    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                                        xcss: $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$anchorDetailStyles,
                                        children: authorContent
                                    }),
                                    authorHoverContent && isAuthorHoverOpen ? authorHoverContent : null
                                ]
                            }),
                            rankComponent
                        ]
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$pillInteractiveStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    cursor: "pointer",
    ":hover": {
        textTransform: "none",
        borderColor: "color.border",
        backgroundColor: "color.background.neutral.subtle.hovered"
    }
});
const $cb0e8fe57b0fd046$var$$65d6e13fe84e408e$var$authorHoverTargetStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    position: "relative"
});
const $cb0e8fe57b0fd046$var$$3ec02f67788713f1$export$f438dff3491d77ab = ({ title: title, titleHref: titleHref })=>{
    const content = (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                as: "span",
                style: {
                    fontSize: "24px",
                    fontFamily: "Charlie Display, sans-serif",
                    fontWeight: "600"
                },
                children: title
            }),
            titleHref && (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1a4d84fbcc800603$exports))), {
                label: "Navigate",
                size: "small"
            })
        ]
    });
    return titleHref ? (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
        as: "a",
        xcss: $cb0e8fe57b0fd046$var$$3ec02f67788713f1$var$titleLinkStyles,
        href: titleHref,
        children: content
    }) : (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
        xcss: $cb0e8fe57b0fd046$var$$3ec02f67788713f1$var$titleTextStyles,
        children: content
    });
};
const $cb0e8fe57b0fd046$var$$3ec02f67788713f1$var$titleLinkStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    color: "color.text",
    padding: "space.0",
    textAlign: "left",
    cursor: "pointer",
    textDecoration: "none",
    ":hover": {
        color: "color.link",
        textDecoration: "none"
    }
});
const $cb0e8fe57b0fd046$var$$3ec02f67788713f1$var$titleTextStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    color: "color.text",
    padding: "space.0",
    textAlign: "left"
});
const $cb0e8fe57b0fd046$var$$11271ea5e6da2c5e$export$c806476cb62098c9 = ()=>(0, $115bf1020744eac3$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M12.5 2C12.5 1.72386 12.2761 1.5 12 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V12C1.5 12.2761 1.72386 12.5 2 12.5H12C12.2761 12.5 12.5 12.2761 12.5 12V2ZM7.75 3V8H6.25V3H7.75ZM14 12C14 13.1046 13.1046 14 12 14H2C0.895431 14 1.00665e-08 13.1046 0 12V2C1.61066e-07 0.895431 0.89543 1.00665e-08 2 0H12C13.1046 1.61066e-07 14 0.89543 14 2V12Z",
                fill: "#6C6F77"
            }),
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)("path", {
                d: "M8 10.25C8 10.8023 7.55228 11.25 7 11.25C6.44772 11.25 6 10.8023 6 10.25C6 9.69771 6.44772 9.25 7 9.25C7.55228 9.25 8 9.69771 8 10.25Z",
                fill: "#6C6F77"
            })
        ]
    });
const $cb0e8fe57b0fd046$var$$ae14dd6ecf20d4c3$export$6d2e2d5b3f4f86b8 = ({ showModerationDetails: showModerationDetails, isModerationReviewed: isModerationReviewed })=>{
    if (!showModerationDetails) return null;
    return (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
        padding: "space.075",
        children: isModerationReviewed ? (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
            gap: "space.075",
            alignItems: "center",
            justifyContent: "end",
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($87356966879965c8$exports))), {
                    label: "Approved by admin",
                    color: (0, $bf65d4d6b5d64e28$export$2e2bcd8739ae039)("color.icon.success")
                }),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                    color: "color.text.success",
                    children: "Approved by admin"
                })
            ]
        }) : (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
            gap: "space.075",
            alignItems: "center",
            justifyContent: "end",
            children: [
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$11271ea5e6da2c5e$export$c806476cb62098c9, {}),
                (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                    color: "color.text.subtlest",
                    children: "Not yet reviewed"
                })
            ]
        })
    });
};
const $cb0e8fe57b0fd046$export$1074985837f1b2a5 = ({ contentType: contentType = $cb0e8fe57b0fd046$export$96b2e747ae3de284.Question, categoryType: categoryType, isFeatured: isFeatured = false, title: title, id: id, description: description, categoryName: categoryName, tags: tags = [], timestamp: timestamp, showModerationDetails: showModerationDetails = false, isModerationReviewed: isModerationReviewed = false, authorDetails: authorDetails, authorHoverContent: authorHoverContent, likes: likes, responses: responses, views: views, status: status, hostingType: hostingType = "data-center", titleHref: titleHref, authorHref: authorHref = "", categoryHref: categoryHref = "", menuComponent: menuComponent, isNew: isNew, rankComponent: rankComponent })=>{
    return (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
        direction: "column",
        gap: "space.100",
        children: [
            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$ae14dd6ecf20d4c3$export$6d2e2d5b3f4f86b8, {
                showModerationDetails: showModerationDetails,
                isModerationReviewed: isModerationReviewed
            }),
            (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                xcss: $cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$var$cardStyles,
                children: [
                    (0, $115bf1020744eac3$export$25062201e9e25d76)((0, $a9b577755822a7ff$export$2e2bcd8739ae039), {
                        gap: "space.200",
                        direction: "column",
                        children: [
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$06e8096ff5ff1247$export$7d7346e428084a7e, {
                                menuComponent: menuComponent,
                                categoryHref: categoryHref,
                                contentType: contentType,
                                categoryName: categoryName,
                                isFeatured: isFeatured,
                                categoryType: categoryType,
                                hostingType: hostingType,
                                isNew: isNew
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$3ec02f67788713f1$export$f438dff3491d77ab, {
                                title: title,
                                titleHref: titleHref
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $5a2aa3720e25ccad$export$2e2bcd8739ae039), {
                                size: "large",
                                maxLines: 2,
                                children: description
                            }),
                            (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$65d6e13fe84e408e$export$1e30305c33fd8c57, {
                                authorHref: authorHref,
                                tags: tags,
                                timestamp: timestamp,
                                authorDetails: authorDetails,
                                authorHoverContent: authorHoverContent,
                                id: id,
                                rankComponent: rankComponent
                            })
                        ]
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)((0, $c8593d66a3359792$export$2e2bcd8739ae039), {
                        xcss: $cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$var$dividerStyles
                    }),
                    (0, $115bf1020744eac3$export$34b9dba7ce09269b)($cb0e8fe57b0fd046$var$$2248ded33c1cc26f$export$9e55f86bc7a20cd4, {
                        contentType: contentType,
                        likes: likes,
                        responses: responses,
                        views: views,
                        status: status
                    })
                ]
            })
        ]
    });
};
const $cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$var$cardStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    display: "flex",
    flexDirection: "column",
    gap: "space.200",
    padding: "space.200",
    backgroundColor: "elevation.surface",
    borderRadius: "border.radius.200",
    boxShadow: "elevation.shadow.raised",
    width: "100%",
    boxSizing: "border-box"
});
const $cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$var$dividerStyles = (0, $d841ac2d6aa8bd23$export$f6c783d06584602c)({
    width: "100%",
    borderTopWidth: "border.width",
    borderTopStyle: "solid",
    borderTopColor: "color.border",
    borderRadius: "border.radius.circle"
});
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$976a3c76bc9fa9bc$exports, $cb0e8fe57b0fd046$var$$b0e23f9f192d2ea7$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$976a3c76bc9fa9bc$exports, $cb0e8fe57b0fd046$var$$fa9d4c58bb661680$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$0cf4554ad00467b5$exports, $cb0e8fe57b0fd046$var$$a3d28c94a229f94e$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$0cf4554ad00467b5$exports, $cb0e8fe57b0fd046$var$$976a3c76bc9fa9bc$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a69491ea5a126553$exports, $cb0e8fe57b0fd046$var$$5d4509b60606b6df$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a69491ea5a126553$exports, $cb0e8fe57b0fd046$var$$6e379ec2eca3d7d3$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a69491ea5a126553$exports, $cb0e8fe57b0fd046$var$$a6a41c835fd01d00$exports);
$cb0e8fe57b0fd046$var$$parcel$exportWildcard($cb0e8fe57b0fd046$var$$a69491ea5a126553$exports, $cb0e8fe57b0fd046$var$$0cf4554ad00467b5$exports);



var $acw62 = parcelRequire("acw62");

const $51c84bb9511e1e8b$export$122994dc05ba4308 = (0, $acw62.createContext)({
    profileAvatar: (0, (/*@__PURE__*/$parcel$interopDefault($80f43fae5f2a7696$exports)))
});



var $768c2bb36d671034$exports = {};
"use strict";
Object.defineProperty($768c2bb36d671034$exports, "__esModule", {
    value: true
});
var $9c2745e8f2aa72ed$exports = {};
"use strict";
Object.defineProperty($9c2745e8f2aa72ed$exports, "__esModule", {
    value: true
});
var $2f720e9b435080a3$exports = {};
"use strict";
Object.defineProperty($2f720e9b435080a3$exports, "__esModule", {
    value: true
});
$2f720e9b435080a3$exports.TestComponent = void 0;

var $2f720e9b435080a3$var$_react = $2f720e9b435080a3$var$_interopRequireDefault((parcelRequire("acw62")));
function $2f720e9b435080a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $2f720e9b435080a3$var$TestComponent = $2f720e9b435080a3$exports.TestComponent = function TestComponent(_ref) {
    var text = _ref.text, subtext = _ref.subtext;
    return /*#__PURE__*/ $2f720e9b435080a3$var$_react["default"].createElement("div", null, /*#__PURE__*/ $2f720e9b435080a3$var$_react["default"].createElement("h1", null, text), subtext ? /*#__PURE__*/ $2f720e9b435080a3$var$_react["default"].createElement("div", null, subtext) : null);
};


Object.keys($2f720e9b435080a3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $2f720e9b435080a3$exports[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $2f720e9b435080a3$exports[key];
        }
    });
});
var $f526f38f8e05b40d$exports = {};
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ "use strict";
Object.defineProperty($f526f38f8e05b40d$exports, "__esModule", {
    value: true
});
$f526f38f8e05b40d$exports.ConsentModal = void 0;

var $9dvtP = parcelRequire("9dvtP");

var $f526f38f8e05b40d$var$_react = $f526f38f8e05b40d$var$_interopRequireDefault((parcelRequire("acw62")));

var $f526f38f8e05b40d$var$_modalDialog = $f526f38f8e05b40d$var$_interopRequireDefault((parcelRequire("dyg5j")));

var $f526f38f8e05b40d$var$_new = $f526f38f8e05b40d$var$_interopRequireDefault((parcelRequire("fJTfv")));
function $f526f38f8e05b40d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// import './ConsentModal.module.css';
/**
 * Component that renders a inline code in topic body
 * @param {ConsentModalProps} ConsentModalProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <ConsentModal onClick={ () => setConsent() } />
 */ var $f526f38f8e05b40d$var$ConsentModal = $f526f38f8e05b40d$exports.ConsentModal = function ConsentModal(_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement($f526f38f8e05b40d$var$_modalDialog["default"], {
        shouldScrollInViewport: true
    }, /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement("div", {
        className: (0, $9dvtP.default)([
            "_1e0c1txw _4cvr1h6o _2lx21bp4 _19pk7vkz _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp"
        ])
    }, /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement("h1", {
        className: (0, $9dvtP.default)([
            "_ect46nat _1wybzwfg _k48pni7l _vwz41ylp _19pkidpf _otyr7vkz _y3gn1h6o"
        ])
    }, "Welcome to Early Access"), /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement("p", {
        className: (0, $9dvtP.default)([
            "_ect4oyw7 _1wybgktf _k48p1nn1 _vwz41tcg _y3gn1h6o _otyrzwfg"
        ])
    }, "By signing up for the Early Access Program (\u201CEAP\u201D), you acknowledge the", " ", /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement("a", {
        href: "http://atlassian.com/legal/privacy-policy",
        className: (0, $9dvtP.default)([
            "_syaz7g9i"
        ])
    }, "Atlassian Privacy Policy"), " ", "and that use of the EAP products is governed by the", " ", /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement("a", {
        href: "https://www.atlassian.com/legal/community-platform-terms-of-use",
        className: (0, $9dvtP.default)([
            "_syaz7g9i"
        ])
    }, "Online Community Platform Terms of Use"), "."), /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement("div", {
        className: (0, $9dvtP.default)([
            "_ect4zeyy"
        ])
    }, /*#__PURE__*/ $f526f38f8e05b40d$var$_react["default"].createElement($f526f38f8e05b40d$var$_new["default"], {
        appearance: "primary",
        onClick: onClick
    }, "Agree and sign up"))));
};
var $f526f38f8e05b40d$var$contentStyles = null;
var $f526f38f8e05b40d$var$headerStyles = null;
var $f526f38f8e05b40d$var$bodyStyles = null;
var $f526f38f8e05b40d$var$linkStyles = null;
var $f526f38f8e05b40d$var$buttonContainerStyles = null;


Object.keys($f526f38f8e05b40d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $f526f38f8e05b40d$exports[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $f526f38f8e05b40d$exports[key];
        }
    });
});
var $5afce0b42b1a9d68$exports = {};
"use strict";
function $5afce0b42b1a9d68$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5afce0b42b1a9d68$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5afce0b42b1a9d68$var$_typeof(o);
}
Object.defineProperty($5afce0b42b1a9d68$exports, "__esModule", {
    value: true
});
$5afce0b42b1a9d68$exports.ConsentValidator = void 0;

var $5afce0b42b1a9d68$var$_react = $5afce0b42b1a9d68$var$_interopRequireDefault((parcelRequire("acw62")));
var $8e221dc9235bf597$exports = {};
"use strict";
function $8e221dc9235bf597$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e221dc9235bf597$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e221dc9235bf597$var$_typeof(o);
}
Object.defineProperty($8e221dc9235bf597$exports, "__esModule", {
    value: true
});
$8e221dc9235bf597$exports.userConsentStatuses = $8e221dc9235bf597$exports.setUserConsent = $8e221dc9235bf597$exports.isUserConsented = void 0;
var $a31ec78ef2dbb035$exports = {};
"use strict";
Object.defineProperty($a31ec78ef2dbb035$exports, "__esModule", {
    value: true
});
$a31ec78ef2dbb035$exports.getUserIsConsentedQuery = $a31ec78ef2dbb035$exports.getUserIsAllowedQuery = $a31ec78ef2dbb035$exports.getUserAccountQuery = $a31ec78ef2dbb035$exports.USER_INFO_QUERY = void 0;
var $a31ec78ef2dbb035$var$getUserIsAllowedQuery = $a31ec78ef2dbb035$exports.getUserIsAllowedQuery = function getUserIsAllowedQuery(emailId) {
    return '\n  query USER_ALLOWED_QUERY {\n    unified {\n      gating {\n        isEmailIdAllowed(emailId: "'.concat(emailId, '") {\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n          ... on UnifiedAccessStatus {\n            id\n            status\n          }\n        }\n      }\n    }\n  }\n');
};
var $a31ec78ef2dbb035$var$USER_INFO_QUERY = $a31ec78ef2dbb035$exports.USER_INFO_QUERY = "query USER_INFO_QUERY {\n  me {\n    user {\n      ... on AtlassianAccountUser {\n        email\n        accountId\n        orgId\n        picture\n      }\n    }\n  }\n}";
var $a31ec78ef2dbb035$var$getUserIsConsentedQuery = $a31ec78ef2dbb035$exports.getUserIsConsentedQuery = function getUserIsConsentedQuery(aaid) {
    return '\n  query USER_CONSENTED_QUERY {\n    unified {\n      consent {\n      getConsent(value: "'.concat(aaid, '", type: "AAID") {\n        ... on UnifiedConsentStatus {\n          id\n          createdAt\n          type\n          updatedAt\n          value\n          consentObj {\n            consentKey\n            consentStatus\n            consenthubStatus\n            createdAt\n            updatedAt\n            uppConsentStatus\n          }\n        }\n        ... on UnifiedQueryError {\n          identifier\n          message\n          code\n        }\n      }\n    }\n  }\n}');
};
var $a31ec78ef2dbb035$var$getUserAccountQuery = $a31ec78ef2dbb035$exports.getUserAccountQuery = function getUserAccountQuery(aaid) {
    return '\n  query USER_ACCOUNT_QUERY {\n    unified {\n      account(aaid: "'.concat(aaid, '") {\n        ... on UnifiedAccount {\n          aaid\n          atlassianOneUserId\n          emailId\n          id\n          internalId\n          isLinked\n          isManaged\n          isPrimary\n          isProfileOwnerConsented\n          khorosUserId\n        }\n        ... on UnifiedQueryError {\n          code\n          identifier\n          message\n        }\n      }\n    }\n  }\n');
};


var $954418363634b5e4$exports = {};
"use strict";
Object.defineProperty($954418363634b5e4$exports, "__esModule", {
    value: true
});
$954418363634b5e4$exports.setUserIsConsentedMutation = $954418363634b5e4$exports.initializeCommunityMutationbyAaid = $954418363634b5e4$exports.initializeCommunityMutation = $954418363634b5e4$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION = void 0;
var $954418363634b5e4$var$setUserIsConsentedMutation = $954418363634b5e4$exports.setUserIsConsentedMutation = function setUserIsConsentedMutation(aaid, consentKey) {
    return '\n  mutation SET_USER_CONSENTED_MUTATION {\n    unified {\n      consent {\n        setConsent(\n          consentObj: {consentKey: "'.concat(consentKey, '", consentStatus: "true"}\n          type: "AAID"\n          value: "').concat(aaid, '"\n        ) {\n          errors {\n            message\n          }\n          message\n          success\n      }\n    }\n  }\n}');
};
var $954418363634b5e4$var$initializeCommunityMutation = $954418363634b5e4$exports.initializeCommunityMutation = function initializeCommunityMutation(emailId) {
    return '\nmutation INITIALIZE_COMMUNITY_MUTATION {\n  unified {\n    community {\n      initializeCommunity(emailId: "'.concat(emailId, '") {\n        success\n        errors {\n          code\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n        forumsProfile {\n          id\n          login\n        }\n        gamificationProfile {\n          firstName\n          userId\n        }\n        unifiedProfile {\n          accountInternalId\n        }\n        isNewForumsProfile\n        isNewGamificationProfile\n        isNewProfile\n      }\n    }\n  }\n}');
};
var $954418363634b5e4$var$initializeCommunityMutationbyAaid = $954418363634b5e4$exports.initializeCommunityMutationbyAaid = function initializeCommunityMutationbyAaid(aaid) {
    return '\nmutation INITIALIZE_COMMUNITY_MUTATION {\n  unified {\n    community {\n      initializeCommunity(aaid: "'.concat(aaid, '") {\n        success\n        errors {\n          code\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n        forumsProfile {\n          id\n          login\n        }\n        gamificationProfile {\n          firstName\n          userId\n        }\n        unifiedProfile {\n          accountInternalId\n        }\n        isNewForumsProfile\n        isNewGamificationProfile\n        isNewProfile\n      }\n    }\n  }\n}');
};
var $954418363634b5e4$var$SUBMIT_CHAMPION_SIGNUP_MUTATION = $954418363634b5e4$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION = "\n  mutation SUBMIT_CHAMPION_SIGNUP_MUTATION($input: UnifiedChampionSignupInput) {\n    champion {\n      championSignup {\n        submitChampionSignup(input: $input) {\n          success\n          message\n        }\n      }\n    }\n  }\n";


var $5827f444065c0e59$exports = {};
"use strict";
Object.defineProperty($5827f444065c0e59$exports, "__esModule", {
    value: true
});
$5827f444065c0e59$exports.shouldUseStargate = $5827f444065c0e59$exports.getXidEnvironment = $5827f444065c0e59$exports.getUppApiPathFromEnvironment = $5827f444065c0e59$exports.getGASv3Environment = $5827f444065c0e59$exports.getEnvironment = $5827f444065c0e59$exports.getAnalyticsWriteKey = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS = void 0;

var $3emEs = parcelRequire("3emEs");
var $e5a7ccf3ca9852d5$exports = {};
"use strict";
Object.defineProperty($e5a7ccf3ca9852d5$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("j22Yz")), $e5a7ccf3ca9852d5$exports);
var $c6d222d7d21f3819$exports = {};
"use strict";
Object.defineProperty($c6d222d7d21f3819$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

var $c6d222d7d21f3819$var$promise_polyfill_1 = $7WQrb.__importDefault((parcelRequire("cSbQH")));
var $8e853f0f8d13ba52$exports = {};
"use strict";
Object.defineProperty($8e853f0f8d13ba52$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");
var $bd573fbed78bb425$exports = {};
"use strict";
Object.defineProperty($bd573fbed78bb425$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");
var $bd573fbed78bb425$var$set = function(name, value, options) {
    var str = $bd573fbed78bb425$var$encode(name) + "=" + $bd573fbed78bb425$var$encode((value || "").toString());
    if (value == null) options.maxage = -1;
    var expiry;
    if (options.maxage) expiry = new Date(+new Date() + options.maxage);
    if (options.path) str += "; path=" + options.path;
    if (options.domain) str += "; domain=" + options.domain;
    if (expiry) str += "; expires=" + expiry.toUTCString();
    if (options.secure) str += "; secure";
    if (options.sameSite) str += "; samesite=" + options.sameSite;
    document.cookie = str;
    return str;
};
var $bd573fbed78bb425$var$all = function() {
    try {
        return $bd573fbed78bb425$var$parse(document.cookie);
    } catch (err) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(err.stack || err);
        return {};
    }
};
function $bd573fbed78bb425$var$get(name) {
    return $bd573fbed78bb425$var$all()[name];
}
function $bd573fbed78bb425$var$parse(str) {
    var obj = {};
    var pairs = str.split(/ *; */);
    if (pairs[0] === "") return obj;
    pairs.forEach(function(item) {
        var pair = item.split("=");
        var key = $bd573fbed78bb425$var$decode(pair[0]);
        var value = $bd573fbed78bb425$var$decode(pair[1]);
        if (key && value) obj[key] = value;
    });
    return obj;
}
function $bd573fbed78bb425$var$encode(value) {
    try {
        return encodeURIComponent(value);
    } catch (e) {
        console.log("error `encode(%o)` - %o", value, e);
        return "";
    }
}
function $bd573fbed78bb425$var$decode(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        console.log("error `decode(%o)` - %o", value, e);
        return "";
    }
}
function $bd573fbed78bb425$var$getCookie(name) {
    return $bd573fbed78bb425$var$get(name);
}
$bd573fbed78bb425$exports.getCookie = $bd573fbed78bb425$var$getCookie;
function $bd573fbed78bb425$var$getAllCookies() {
    return $bd573fbed78bb425$var$all();
}
$bd573fbed78bb425$exports.getAllCookies = $bd573fbed78bb425$var$getAllCookies;
function $bd573fbed78bb425$var$setCookie(name, value, options) {
    var finalOption = $7WQrb.__assign({
        maxage: 31536000000,
        secure: true,
        path: "/",
        expires: null,
        domain: null,
        sameSite: "lax"
    }, options);
    return $bd573fbed78bb425$var$set(name, value, finalOption);
}
$bd573fbed78bb425$exports.setCookie = $bd573fbed78bb425$var$setCookie;
function $bd573fbed78bb425$var$getCrossDomainCookieOption() {
    var domain = window.location.hostname.split(".").slice(-2).join(".");
    return {
        sameSite: "None",
        domain: domain
    };
}
$bd573fbed78bb425$exports.getCrossDomainCookieOption = $bd573fbed78bb425$var$getCrossDomainCookieOption;



var $j22Yz = parcelRequire("j22Yz");
var $9cd0f54ab738ea12$exports = {};
"use strict";
Object.defineProperty($9cd0f54ab738ea12$exports, "__esModule", {
    value: true
});

var $a876a9fa4a65a349$exports = {};
"use strict";
Object.defineProperty($a876a9fa4a65a349$exports, "__esModule", {
    value: true
});

var $j22Yz = parcelRequire("j22Yz");
$a876a9fa4a65a349$exports.checkXidValid = function(xid) {
    return (xid.type === $j22Yz.XIDItemType.UID || xid.type === $j22Yz.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};


var $9cd0f54ab738ea12$var$parseCachedXidItem = function(value) {
    try {
        var xid = JSON.parse(value);
        if (xid instanceof Array) {
            var valid = true;
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                valid = valid && $a876a9fa4a65a349$exports.checkXidValid(entry);
            }
            return valid ? xid : undefined;
        } else return $a876a9fa4a65a349$exports.checkXidValid(xid) ? xid : undefined;
    } catch (err) {
        return;
    }
};
function $9cd0f54ab738ea12$var$getFromLocalStorage(name) {
    try {
        return localStorage.getItem(name) || "";
    } catch (err) {}
}
function $9cd0f54ab738ea12$var$getXidFromCookie(name) {
    var cookieValue = $bd573fbed78bb425$exports.getCookie(name);
    return $9cd0f54ab738ea12$var$parseCachedXidItem(cookieValue);
}
$9cd0f54ab738ea12$exports.getXidFromCookie = $9cd0f54ab738ea12$var$getXidFromCookie;
function $9cd0f54ab738ea12$var$getXidFromLocalStorage(name) {
    var lsValue = "";
    try {
        lsValue = localStorage.getItem(name) || "";
    } catch (err) {}
    return $9cd0f54ab738ea12$var$parseCachedXidItem(lsValue);
}
$9cd0f54ab738ea12$exports.getXidFromLocalStorage = $9cd0f54ab738ea12$var$getXidFromLocalStorage;
function $9cd0f54ab738ea12$var$setLocalstorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (err) {}
}
$9cd0f54ab738ea12$exports.setLocalstorage = $9cd0f54ab738ea12$var$setLocalstorage;
function $9cd0f54ab738ea12$var$getCache(name) {
    return $bd573fbed78bb425$exports.getCookie(name) || $9cd0f54ab738ea12$var$getFromLocalStorage(name);
}
$9cd0f54ab738ea12$exports.getCache = $9cd0f54ab738ea12$var$getCache;
function $9cd0f54ab738ea12$var$getXidItemFromCache(name) {
    return $9cd0f54ab738ea12$var$getXidFromCookie(name) || $9cd0f54ab738ea12$var$getXidFromLocalStorage(name);
}
$9cd0f54ab738ea12$exports.getXidItemFromCache = $9cd0f54ab738ea12$var$getXidItemFromCache;


var $e2c023fb925e2611$exports = {};
"use strict";
Object.defineProperty($e2c023fb925e2611$exports, "__esModule", {
    value: true
});

var $0dac1e6593813108$exports = {};
"use strict";
Object.defineProperty($0dac1e6593813108$exports, "__esModule", {
    value: true
});
$0dac1e6593813108$exports.parse = function(url) {
    var a = document.createElement("a");
    a.href = url;
    return {
        href: a.href,
        host: a.host || location.host,
        port: "0" === a.port || "" === a.port ? $0dac1e6593813108$exports.port(a.protocol) : a.port,
        hash: a.hash,
        hostname: a.hostname || location.hostname,
        pathname: a.pathname.charAt(0) !== "/" ? "/" + a.pathname : a.pathname,
        protocol: !a.protocol || ":" === a.protocol ? location.protocol : a.protocol,
        search: a.search,
        query: a.search.slice(1)
    };
};
$0dac1e6593813108$exports.isAbsolute = function(url) {
    return 0 === url.indexOf("//") || !!~url.indexOf("://");
};
$0dac1e6593813108$exports.isRelative = function(url) {
    return !$0dac1e6593813108$exports.isAbsolute(url);
};
$0dac1e6593813108$exports.isCrossDomain = function(url) {
    var finalUrl = $0dac1e6593813108$exports.parse(url);
    var location1 = $0dac1e6593813108$exports.parse(window.location.href);
    return finalUrl.hostname !== location1.hostname || finalUrl.port !== location1.port || finalUrl.protocol !== location1.protocol;
};
$0dac1e6593813108$exports.port = function(protocol) {
    switch(protocol){
        case "http:":
            return 80;
        case "https:":
            return 443;
        default:
            return location.port;
    }
};
$0dac1e6593813108$exports.getParam = function(name) {
    var b = window.location.href.match("[?&]" + name + "=([^&#]+)");
    return b ? b.pop() : "";
};


var $e2c023fb925e2611$var$getLevels = function(url) {
    var host = $0dac1e6593813108$exports.parse(url).hostname;
    var parts = host.split(".");
    var last = parts[parts.length - 1];
    var levels = [];
    if (parts.length === 4 && !isNaN(parseInt(last, 10))) return levels;
    if (parts.length <= 1) return levels;
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join("."));
    return levels;
};
$e2c023fb925e2611$exports.domain = function(url) {
    var domainLevels = $e2c023fb925e2611$var$getLevels(url);
    for(var _i = 0, domainLevels_1 = domainLevels; _i < domainLevels_1.length; _i++){
        var domainLevel = domainLevels_1[_i];
        var cname = "__tld__";
        var opts = {
            domain: "." + domainLevel
        };
        $bd573fbed78bb425$exports.setCookie(cname, 1, opts);
        if ($bd573fbed78bb425$exports.getCookie(cname)) {
            $bd573fbed78bb425$exports.setCookie(cname, null, opts);
            return domainLevel;
        }
    }
    return "";
};
$e2c023fb925e2611$exports.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
$e2c023fb925e2611$exports.isAtlassianComDomain = function() {
    return /atlassian\.com$/.test(window.location.hostname);
};


var $efb6f17b15a35a23$exports = {};
"use strict";
Object.defineProperty($efb6f17b15a35a23$exports, "__esModule", {
    value: true
});
$efb6f17b15a35a23$exports.uuidv4 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === "x" ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
};


var $8e853f0f8d13ba52$var$UID_REFRESH_PERIOD = 604800000;
var $8e853f0f8d13ba52$var$XC_REFRESH_PERIOD = 2592000000;
$8e853f0f8d13ba52$exports.XC_CURRENT = "atl_xid.xc";
var $8e853f0f8d13ba52$var$XID_REFRESHED_AT = "atl_xid.ts";
var $8e853f0f8d13ba52$var$XID_CURRENT = "atl_xid.current";
var $8e853f0f8d13ba52$var$UIDS_ALL = "atl_xid.uid";
var $8e853f0f8d13ba52$var$UIDS_STORE_LIMIT = 20;
var $8e853f0f8d13ba52$var$Storage = function() {
    function Storage() {}
    Storage.getCachedXID = function() {
        try {
            var currentXID = $9cd0f54ab738ea12$exports.getXidItemFromCache($8e853f0f8d13ba52$var$XID_CURRENT);
            var refreshedAt = $9cd0f54ab738ea12$exports.getCache($8e853f0f8d13ba52$var$XID_REFRESHED_AT);
            var isFresh = false;
            if (currentXID.length > 0 && currentXID[0].type === $j22Yz.XIDItemType.UID) isFresh = parseInt(refreshedAt || "", 10) >= new Date().getTime() - $8e853f0f8d13ba52$var$UID_REFRESH_PERIOD;
            else if (currentXID.length > 0 && currentXID[0].type === $j22Yz.XIDItemType.XC) isFresh = parseInt(refreshedAt || "", 10) >= new Date().getTime() - $8e853f0f8d13ba52$var$XC_REFRESH_PERIOD;
            if (isFresh) {
                for(var _i = 0, currentXID_1 = currentXID; _i < currentXID_1.length; _i++){
                    var entry = currentXID_1[_i];
                    entry.state = $j22Yz.XIDState.EXISTING;
                }
                return currentXID;
            } else return [];
        } catch (err) {
            return [];
        }
    };
    Storage.saveXid = function(xid) {
        try {
            $bd573fbed78bb425$exports.setCookie($8e853f0f8d13ba52$var$XID_REFRESHED_AT, new Date().getTime());
            $9cd0f54ab738ea12$exports.setLocalstorage($8e853f0f8d13ba52$var$XID_REFRESHED_AT, new Date().getTime().toString());
            var xidCache = [];
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                if (entry.value && entry.createdAt) {
                    xidCache.push({
                        type: entry.type,
                        value: entry.value,
                        createdAt: entry.createdAt
                    });
                    break;
                }
            }
            $bd573fbed78bb425$exports.setCookie($8e853f0f8d13ba52$var$XID_CURRENT, JSON.stringify(xidCache));
            $9cd0f54ab738ea12$exports.setLocalstorage($8e853f0f8d13ba52$var$XID_CURRENT, JSON.stringify(xidCache));
        } catch (err) {
            console.error("Error setting xid cookie.");
        }
    };
    Storage.updateXc = function(env, xc) {
        try {
            if (env === $j22Yz.Environment.PROD && $e2c023fb925e2611$exports.isAtlassianComDomain()) return Storage.processAtlassianComDomainXc(xc);
            else Storage.saveXcLocalstorage(xc);
        } catch (err) {
            console.error("Error setting xc cookie.");
        }
        return xc;
    };
    Storage.getUids = function() {
        var uid = $9cd0f54ab738ea12$exports.getXidItemFromCache($8e853f0f8d13ba52$var$UIDS_ALL) || [];
        for(var _i = 0, uid_1 = uid; _i < uid_1.length; _i++){
            var entry = uid_1[_i];
            entry.state = $j22Yz.XIDState.EXISTING;
        }
        return uid;
    };
    Storage.saveUids = function(uid) {
        try {
            var uidCache = [];
            for(var _i = 0, uid_2 = uid; _i < uid_2.length; _i++){
                var entry = uid_2[_i];
                if (entry.value && entry.createdAt) uidCache.push({
                    type: entry.type,
                    value: entry.value,
                    createdAt: entry.createdAt
                });
            }
            uidCache.slice(0, $8e853f0f8d13ba52$var$UIDS_STORE_LIMIT);
            $9cd0f54ab738ea12$exports.setLocalstorage($8e853f0f8d13ba52$var$UIDS_ALL, JSON.stringify(uidCache));
        } catch (err) {
            console.error("Error setting uid cookie.");
        }
    };
    Storage.saveXcLocalstorage = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $9cd0f54ab738ea12$exports.getXidFromLocalStorage($8e853f0f8d13ba52$exports.XC_CURRENT);
            if (currentXcCache && currentXcCache.value === xc.value) return;
            else if (currentXcCache && currentXcCache.value !== xc.value) xc.state = $j22Yz.XIDState.CHANGED;
            var xidCache = {
                type: xc.type,
                value: xc.value,
                createdAt: xc.createdAt
            };
            $9cd0f54ab738ea12$exports.setLocalstorage($8e853f0f8d13ba52$exports.XC_CURRENT, JSON.stringify(xidCache));
        }
    };
    Storage.processAtlassianComDomainXc = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $9cd0f54ab738ea12$exports.getXidFromCookie($8e853f0f8d13ba52$exports.XC_CURRENT);
            if (currentXcCache) {
                $bd573fbed78bb425$exports.setCookie($8e853f0f8d13ba52$exports.XC_CURRENT, JSON.stringify(currentXcCache), $bd573fbed78bb425$exports.getCrossDomainCookieOption());
                var currentXc = $7WQrb.__assign({
                    state: $j22Yz.XIDState.EXISTING
                }, currentXcCache);
                Storage.saveXcLocalstorage(currentXc);
                return currentXc;
            } else {
                var newXcCache = {
                    value: $efb6f17b15a35a23$exports.uuidv4(),
                    createdAt: new Date().toISOString(),
                    type: $j22Yz.XIDItemType.XC
                };
                $bd573fbed78bb425$exports.setCookie($8e853f0f8d13ba52$exports.XC_CURRENT, JSON.stringify(newXcCache), $bd573fbed78bb425$exports.getCrossDomainCookieOption());
                var newXc = $7WQrb.__assign({
                    state: $j22Yz.XIDState.NEW
                }, newXcCache);
                Storage.saveXcLocalstorage(newXc);
                return newXc;
            }
        } else return xc;
    };
    return Storage;
}();
$8e853f0f8d13ba52$exports.Storage = $8e853f0f8d13ba52$var$Storage;


var $2f0865fb86813e48$exports = {};
"use strict";
Object.defineProperty($2f0865fb86813e48$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");
var $23e6e38469ffb129$exports = {};
"use strict";
Object.defineProperty($23e6e38469ffb129$exports, "__esModule", {
    value: true
});
var $4ce0c0d4526c4036$exports = {};
"use strict";
Object.defineProperty($4ce0c0d4526c4036$exports, "__esModule", {
    value: true
});
var $c14d1eb521069857$exports = {};
"use strict";
Object.defineProperty($c14d1eb521069857$exports, "__esModule", {
    value: true
});
$c14d1eb521069857$exports.UNAVAILABLE = "UNAVAILABLE";
$c14d1eb521069857$exports.ERROR = "ERROR";
$c14d1eb521069857$exports.YES = "YES";
$c14d1eb521069857$exports.NO = "NO";


function $4ce0c0d4526c4036$var$browserDefaultEvalLength() {
    try {
        return eval.toString().length || 0;
    } catch (err) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$4ce0c0d4526c4036$exports.browserDefaultEvalLength = $4ce0c0d4526c4036$var$browserDefaultEvalLength;


$23e6e38469ffb129$exports.browserDefaultEvalLength = $4ce0c0d4526c4036$exports.browserDefaultEvalLength;
var $8d2ee4f589cb47e7$exports = {};
"use strict";
Object.defineProperty($8d2ee4f589cb47e7$exports, "__esModule", {
    value: true
});

function $8d2ee4f589cb47e7$var$canWriteCookie() {
    try {
        document.cookie = "cookietest=1";
        if (document.cookie.indexOf("cookietest=") !== -1) {
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return $c14d1eb521069857$exports.YES;
        }
        return $c14d1eb521069857$exports.NO;
    } catch (t) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$8d2ee4f589cb47e7$exports.canWriteCookie = $8d2ee4f589cb47e7$var$canWriteCookie;


$23e6e38469ffb129$exports.canWriteCookie = $8d2ee4f589cb47e7$exports.canWriteCookie;
var $622ab20a9af5a2fb$exports = {};
"use strict";
Object.defineProperty($622ab20a9af5a2fb$exports, "__esModule", {
    value: true
});

function $622ab20a9af5a2fb$var$getBrowserVendor() {
    try {
        return navigator.vendor || $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$622ab20a9af5a2fb$exports.getBrowserVendor = $622ab20a9af5a2fb$var$getBrowserVendor;


$23e6e38469ffb129$exports.getBrowserVendor = $622ab20a9af5a2fb$exports.getBrowserVendor;
var $a56190052c4b9fa5$exports = {};
"use strict";
Object.defineProperty($a56190052c4b9fa5$exports, "__esModule", {
    value: true
});
function $a56190052c4b9fa5$var$getHardwareConcurrency() {
    try {
        var result = parseInt(navigator.hardwareConcurrency.toString(), 10);
        return isNaN(result) ? 1 : result;
    } catch (t) {
        return 1;
    }
}
$a56190052c4b9fa5$exports.getHardwareConcurrency = $a56190052c4b9fa5$var$getHardwareConcurrency;


$23e6e38469ffb129$exports.getHardwareConcurrency = $a56190052c4b9fa5$exports.getHardwareConcurrency;
var $22a8f7c9107ea0ff$exports = {};
"use strict";
Object.defineProperty($22a8f7c9107ea0ff$exports, "__esModule", {
    value: true
});

function $22a8f7c9107ea0ff$var$getLanguage() {
    try {
        return navigator.language || $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$22a8f7c9107ea0ff$exports.getLanguage = $22a8f7c9107ea0ff$var$getLanguage;


$23e6e38469ffb129$exports.getLanguage = $22a8f7c9107ea0ff$exports.getLanguage;
var $16f52fe5ce26720f$exports = {};
"use strict";
Object.defineProperty($16f52fe5ce26720f$exports, "__esModule", {
    value: true
});

function $16f52fe5ce26720f$var$getPlatform() {
    try {
        return navigator.platform || $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$16f52fe5ce26720f$exports.getPlatform = $16f52fe5ce26720f$var$getPlatform;


$23e6e38469ffb129$exports.getPlatform = $16f52fe5ce26720f$exports.getPlatform;
var $148e4ef715d2715d$exports = {};
"use strict";
Object.defineProperty($148e4ef715d2715d$exports, "__esModule", {
    value: true
});

function $148e4ef715d2715d$var$getPlugins() {
    try {
        var MSIE = "Microsoft Internet Explorer";
        var NETSCAPE = "Netscape";
        var isIE = navigator.appName === MSIE;
        var isNetscape = navigator.appName === NETSCAPE;
        var isTrident = /Trident/.test(navigator.userAgent);
        if (isIE || isNetscape && isTrident) return $c14d1eb521069857$exports.UNAVAILABLE;
        var navigatorPlugins = navigator.plugins;
        var s = "";
        for(var i = 0; i < navigatorPlugins.length; i++){
            var plugin = navigator.plugins[i];
            var name_1 = plugin.name;
            var fileName = plugin.filename;
            var pluginMimeTypes = plugin.length;
            for(var j = 0; j < pluginMimeTypes; j++){
                var o = plugin[j];
                if (o) s = s + name_1 + "," + fileName + "," + o.type + "|";
            }
        }
        return s;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$148e4ef715d2715d$exports.getPlugins = $148e4ef715d2715d$var$getPlugins;


$23e6e38469ffb129$exports.getPlugins = $148e4ef715d2715d$exports.getPlugins;
var $7a2ff8f8de17299c$exports = {};
"use strict";
Object.defineProperty($7a2ff8f8de17299c$exports, "__esModule", {
    value: true
});

function $7a2ff8f8de17299c$var$getProductSub() {
    try {
        return navigator.productSub || $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$7a2ff8f8de17299c$exports.getProductSub = $7a2ff8f8de17299c$var$getProductSub;


$23e6e38469ffb129$exports.getProductSub = $7a2ff8f8de17299c$exports.getProductSub;
var $56cb0ce4013ed92e$exports = {};
"use strict";
Object.defineProperty($56cb0ce4013ed92e$exports, "__esModule", {
    value: true
});

function $56cb0ce4013ed92e$var$getTimeZone() {
    try {
        if (window.Intl && window.Intl.DateTimeFormat) return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$56cb0ce4013ed92e$exports.getTimeZone = $56cb0ce4013ed92e$var$getTimeZone;


$23e6e38469ffb129$exports.getTimeZone = $56cb0ce4013ed92e$exports.getTimeZone;
var $e9d2904b703abaec$exports = {};
"use strict";
Object.defineProperty($e9d2904b703abaec$exports, "__esModule", {
    value: true
});

function $e9d2904b703abaec$var$getTimeZoneOffset() {
    try {
        return new Date().getTimezoneOffset() || $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$e9d2904b703abaec$exports.getTimeZoneOffset = $e9d2904b703abaec$var$getTimeZoneOffset;


$23e6e38469ffb129$exports.getTimeZoneOffset = $e9d2904b703abaec$exports.getTimeZoneOffset;
var $455fc4e3a25a06bc$exports = {};
"use strict";
Object.defineProperty($455fc4e3a25a06bc$exports, "__esModule", {
    value: true
});

function $455fc4e3a25a06bc$var$getUserAgent() {
    try {
        return navigator.userAgent || $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (d) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$455fc4e3a25a06bc$exports.getUserAgent = $455fc4e3a25a06bc$var$getUserAgent;


$23e6e38469ffb129$exports.getUserAgent = $455fc4e3a25a06bc$exports.getUserAgent;
var $c3ca05b63f0913c1$exports = {};
"use strict";
Object.defineProperty($c3ca05b63f0913c1$exports, "__esModule", {
    value: true
});

function $c3ca05b63f0913c1$var$isIndexedDBAvailable() {
    try {
        return window.indexedDB ? $c14d1eb521069857$exports.YES : $c14d1eb521069857$exports.NO;
    } catch (e) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$c3ca05b63f0913c1$exports.isIndexedDBAvailable = $c3ca05b63f0913c1$var$isIndexedDBAvailable;


$23e6e38469ffb129$exports.isIndexedDBAvailable = $c3ca05b63f0913c1$exports.isIndexedDBAvailable;
var $40072a50758ddff4$exports = {};
"use strict";
Object.defineProperty($40072a50758ddff4$exports, "__esModule", {
    value: true
});

function $40072a50758ddff4$var$isLocalStorageAvailable() {
    try {
        return window.localStorage ? $c14d1eb521069857$exports.YES : $c14d1eb521069857$exports.NO;
    } catch (e) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$40072a50758ddff4$exports.isLocalStorageAvailable = $40072a50758ddff4$var$isLocalStorageAvailable;


$23e6e38469ffb129$exports.isLocalStorageAvailable = $40072a50758ddff4$exports.isLocalStorageAvailable;
var $ff69613541142650$exports = {};
"use strict";
Object.defineProperty($ff69613541142650$exports, "__esModule", {
    value: true
});

function $ff69613541142650$var$isSessionStorageAvailable() {
    try {
        return window.sessionStorage ? $c14d1eb521069857$exports.YES : $c14d1eb521069857$exports.NO;
    } catch (e) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$ff69613541142650$exports.isSessionStorageAvailable = $ff69613541142650$var$isSessionStorageAvailable;


$23e6e38469ffb129$exports.isSessionStorageAvailable = $ff69613541142650$exports.isSessionStorageAvailable;
var $6b3c60635317d4c7$exports = {};
"use strict";
Object.defineProperty($6b3c60635317d4c7$exports, "__esModule", {
    value: true
});

function $6b3c60635317d4c7$var$isTestingBot() {
    try {
        var t = [
            "webdriver" in window,
            "_Selenium_IDE_Recorder" in window,
            "callSelenium" in window,
            "_selenium" in window,
            "__webdriver_script_fn" in document,
            "__driver_evaluate" in document,
            "__webdriver_evaluate" in document,
            "__selenium_evaluate" in document,
            "__fxdriver_evaluate" in document,
            "__driver_unwrapped" in document,
            "__webdriver_unwrapped" in document,
            "__selenium_unwrapped" in document,
            "__fxdriver_unwrapped" in document,
            "__webdriver_script_func" in document,
            null !== document.documentElement.getAttribute("selenium"),
            null !== document.documentElement.getAttribute("webdriver"),
            null !== document.documentElement.getAttribute("driver")
        ];
        return t.some(function(e) {
            return e === true;
        }) ? $c14d1eb521069857$exports.YES : $c14d1eb521069857$exports.NO;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$6b3c60635317d4c7$exports.isTestingBot = $6b3c60635317d4c7$var$isTestingBot;


$23e6e38469ffb129$exports.isTestingBot = $6b3c60635317d4c7$exports.isTestingBot;
var $f37fc32164d58076$exports = {};
"use strict";
Object.defineProperty($f37fc32164d58076$exports, "__esModule", {
    value: true
});

function $f37fc32164d58076$var$isWebDriver() {
    try {
        return navigator.webdriver ? $c14d1eb521069857$exports.YES : $c14d1eb521069857$exports.NO;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$f37fc32164d58076$exports.isWebDriver = $f37fc32164d58076$var$isWebDriver;


$23e6e38469ffb129$exports.isWebDriver = $f37fc32164d58076$exports.isWebDriver;


var $65e009d3e4105b7d$exports = {};
"use strict";
Object.defineProperty($65e009d3e4105b7d$exports, "__esModule", {
    value: true
});
var $ce6ce19b93626729$exports = {};
"use strict";
Object.defineProperty($ce6ce19b93626729$exports, "__esModule", {
    value: true
});

function $ce6ce19b93626729$var$studyPrint() {
    try {
        var canvasElement = document.createElement("canvas");
        canvasElement.width = 240;
        canvasElement.height = 140;
        canvasElement.style.display = "inline";
        var canvasContext = canvasElement.getContext("2d");
        if (canvasContext) {
            canvasContext.rect(0, 0, 10, 10);
            canvasContext.rect(2, 2, 6, 6);
            canvasContext.isPointInPath(5, 5, "evenodd");
            canvasContext.textBaseline = "alphabetic";
            canvasContext.fillStyle = "#f60";
            canvasContext.fillRect(125, 1, 62, 20);
            canvasContext.fillStyle = "#069";
            canvasContext.font = "11pt no-real-font-123";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 2, 15);
            canvasContext.fillStyle = "rgba(102, 204, 0, 0.2)";
            canvasContext.font = "18pt Arial";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 4, 45);
            canvasContext.globalCompositeOperation = "multiply";
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.beginPath();
            canvasContext.arc(50, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(0,255,255)";
            canvasContext.beginPath();
            canvasContext.arc(100, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,255,0)";
            canvasContext.beginPath();
            canvasContext.arc(75, 100, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.arc(75, 75, 75, 0, 2 * Math.PI, !0);
            canvasContext.arc(75, 75, 25, 0, 2 * Math.PI, !0);
            canvasContext.fill("evenodd");
            return canvasElement.toDataURL();
        }
        return $c14d1eb521069857$exports.UNAVAILABLE;
    } catch (error) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$ce6ce19b93626729$exports.studyPrint = $ce6ce19b93626729$var$studyPrint;


$65e009d3e4105b7d$exports.studyPrint = $ce6ce19b93626729$exports.studyPrint;



var $5470f79155b8c381$exports = {};
"use strict";
Object.defineProperty($5470f79155b8c381$exports, "__esModule", {
    value: true
});
var $ac0328260f04eb64$exports = {};
"use strict";
Object.defineProperty($ac0328260f04eb64$exports, "__esModule", {
    value: true
});

var $05c85398fae0b7ac$exports = {};
"use strict";
Object.defineProperty($05c85398fae0b7ac$exports, "__esModule", {
    value: true
});
$05c85398fae0b7ac$exports.fontsToCheck = [
    "Adobe Garamond",
    "Adobe Hebrew",
    "Agency FB",
    "Airstream",
    "Andale Mono",
    "Aparajita",
    "Arial",
    "BN Manson Nights",
    "Baskerville",
    "BlackChancery",
    "Book Antiqua",
    "Bookman Old Style",
    "CG Times",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chalkboard",
    "Comic Sans",
    "Comic Sans MS",
    "Consolas",
    "Cooper Black",
    "Corbel",
    "Courier",
    "Courier New",
    "Curlz MT",
    "DS Sans Serif",
    "Degrassi",
    "Didot",
    "Ebrima",
    "GOST Common",
    "Geneva",
    "Georgia",
    "Gulim",
    "Heiti TC",
    "Helvetica",
    "Helvetica Neue",
    "Hoefler Text",
    "Impact",
    "Kalinga",
    "Letter Gothic",
    "Lithos Pro",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MYRIAD",
    "Malgun Gothic",
    "Mangal",
    "MapInfo Miscellaneous",
    "Meiryo UI",
    "Monaco",
    "Monotype Corsiva",
    "NSimSun",
    "OSAKA",
    "Palatino",
    "Pickwick",
    "Playbill",
    "Pristina",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Shonar Bangla",
    "Snell Roundhand",
    "Styllo",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Wingdings"
];


var $ac0328260f04eb64$var$DetectFonts = function() {
    function DetectFonts() {
        var _this = this;
        this.baseFonts = [
            "monospace",
            "sans-serif",
            "serif"
        ];
        this.testString = "mmmmmmmmmmlli";
        this.testSize = "72px";
        this.defaultWidth = {};
        this.defaultHeight = {};
        this.createSpan = function() {
            var s = document.createElement("span");
            s.style.position = "absolute";
            s.style.left = "-9999px";
            s.style.fontSize = _this.testSize;
            s.style.fontStyle = "normal";
            s.style.fontWeight = "normal";
            s.style.letterSpacing = "normal";
            s.style.lineBreak = "auto";
            s.style.lineHeight = "normal";
            s.style.textTransform = "none";
            s.style.textAlign = "left";
            s.style.textDecoration = "none";
            s.style.textShadow = "none";
            s.style.whiteSpace = "normal";
            s.style.wordBreak = "normal";
            s.style.wordSpacing = "normal";
            s.innerHTML = _this.testString;
            return s;
        };
        this.createSpanWithFonts = function(fontToDetect, baseFont) {
            var s = _this.createSpan();
            s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
            return s;
        };
        this.initializeBaseFontsSpans = function() {
            var spans = [];
            for(var _i = 0, _a = _this.baseFonts; _i < _a.length; _i++){
                var font = _a[_i];
                var s = _this.createSpan();
                s.style.fontFamily = font;
                _this.baseFontsDiv.appendChild(s);
                spans.push(s);
            }
            return spans;
        };
        this.initializeFontsSpans = function() {
            var spans = {};
            for(var _i = 0, fontsToCheck_2 = $05c85398fae0b7ac$exports.fontsToCheck; _i < fontsToCheck_2.length; _i++){
                var fontToDetect = fontsToCheck_2[_i];
                var fontSpans = [];
                for(var _a = 0, _b = _this.baseFonts; _a < _b.length; _a++){
                    var baseFont = _b[_a];
                    var s = _this.createSpanWithFonts(fontToDetect, baseFont);
                    _this.fontsDiv.appendChild(s);
                    fontSpans.push(s);
                }
                var key = fontToDetect;
                spans[key] = fontSpans;
            }
            return spans;
        };
        this.isFontAvailable = function(fontSpans) {
            var detected = false;
            for(var i = 0; i < _this.baseFonts.length; i++){
                var fontWidth = fontSpans[i].offsetWidth;
                var fontDefaultWidth = _this.defaultWidth[_this.baseFonts[i]];
                var fontHeight = fontSpans[i].offsetHeight;
                var fontDefaultHeight = _this.defaultHeight[_this.baseFonts[i]];
                detected = fontWidth !== fontDefaultWidth || fontHeight !== fontDefaultHeight;
                if (detected) return detected;
            }
            return detected;
        };
        this.bodyElement = document.getElementsByTagName("body")[0];
        this.baseFontsDiv = document.createElement("div");
        this.fontsDiv = document.createElement("div");
    }
    DetectFonts.prototype.detect = function() {
        var baseFontsSpans = this.initializeBaseFontsSpans();
        this.bodyElement.appendChild(this.baseFontsDiv);
        for(var index = 0; index < this.baseFonts.length; index++){
            this.defaultWidth[this.baseFonts[index]] = baseFontsSpans[index].offsetWidth;
            this.defaultHeight[this.baseFonts[index]] = baseFontsSpans[index].offsetHeight;
        }
        var fontsSpans = this.initializeFontsSpans();
        this.bodyElement.appendChild(this.fontsDiv);
        var available = [];
        for(var _i = 0, fontsToCheck_3 = $05c85398fae0b7ac$exports.fontsToCheck; _i < fontsToCheck_3.length; _i++){
            var fontToCheck = fontsToCheck_3[_i];
            var result = 0;
            if (this.isFontAvailable(fontsSpans[fontToCheck])) result = 1;
            available.push(result);
        }
        this.bodyElement.removeChild(this.fontsDiv);
        this.bodyElement.removeChild(this.baseFontsDiv);
        return available.join("|");
    };
    DetectFonts.prototype.result = function() {
        try {
            return this.detect();
        } catch (error) {
            return $c14d1eb521069857$exports.ERROR;
        }
    };
    return DetectFonts;
}();
$ac0328260f04eb64$exports.DetectFonts = $ac0328260f04eb64$var$DetectFonts;


$5470f79155b8c381$exports.DetectFonts = $ac0328260f04eb64$exports.DetectFonts;


var $55e2fa6047af7988$exports = {};
"use strict";
Object.defineProperty($55e2fa6047af7988$exports, "__esModule", {
    value: true
});
var $6f60f920600ff468$exports = {};
"use strict";
Object.defineProperty($6f60f920600ff468$exports, "__esModule", {
    value: true
});

var $49d523f3a751739e$exports = {};
"use strict";
Object.defineProperty($49d523f3a751739e$exports, "__esModule", {
    value: true
});

function $49d523f3a751739e$var$getContext() {
    if (window.WebGLRenderingContext) {
        var canvasElement = document.createElement("canvas");
        var webGLcontexts = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        for(var _i = 0, webGLcontexts_1 = webGLcontexts; _i < webGLcontexts_1.length; _i++){
            var contextName = webGLcontexts_1[_i];
            try {
                var canvasRenderingContext = canvasElement.getContext(contextName);
                if (canvasRenderingContext && canvasRenderingContext instanceof WebGLRenderingContext && typeof canvasRenderingContext.getParameter === "function") return {
                    name: contextName,
                    context: canvasRenderingContext
                };
            } catch (p) {
                return $c14d1eb521069857$exports.ERROR;
            }
        }
    }
    return $c14d1eb521069857$exports.UNAVAILABLE;
}
$49d523f3a751739e$exports.getContext = $49d523f3a751739e$var$getContext;


function $6f60f920600ff468$var$getWebGL() {
    try {
        var gl = $49d523f3a751739e$exports.getContext();
        if (typeof gl === "undefined") return $c14d1eb521069857$exports.UNAVAILABLE;
        if (gl && typeof gl === "object" && gl.context) {
            var glContext = gl.context;
            var rendererInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo !== null) return [
                glContext.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL),
                glContext.getParameter(glContext.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                glContext.getParameter(glContext.MAX_CUBE_MAP_TEXTURE_SIZE)
            ].join("|");
            return $c14d1eb521069857$exports.UNAVAILABLE;
        }
    } catch (p) {
        return $c14d1eb521069857$exports.ERROR;
    }
}
$6f60f920600ff468$exports.getWebGL = $6f60f920600ff468$var$getWebGL;


$55e2fa6047af7988$exports.getWebGL = $6f60f920600ff468$exports.getWebGL;



var $efcb3b0af7aa4383$exports = {};
"use strict";
Object.defineProperty($efcb3b0af7aa4383$exports, "__esModule", {
    value: true
});
var $efcb3b0af7aa4383$var$x64Add = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $efcb3b0af7aa4383$var$x64Multiply = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $efcb3b0af7aa4383$var$x64Rotl = function(m, n) {
    n %= 64;
    if (n === 32) return [
        m[1],
        m[0]
    ];
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n | m[0] >>> 32 - n
    ];
    else {
        n -= 32;
        return [
            m[1] << n | m[0] >>> 32 - n,
            m[0] << n | m[1] >>> 32 - n
        ];
    }
};
var $efcb3b0af7aa4383$var$x64LeftShift = function(m, n) {
    n %= 64;
    if (n === 0) return m;
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n
    ];
    else return [
        m[1] << n - 32,
        0
    ];
};
var $efcb3b0af7aa4383$var$x64Xor = function(m, n) {
    return [
        m[0] ^ n[0],
        m[1] ^ n[1]
    ];
};
var $efcb3b0af7aa4383$var$x64Fmix = function(h) {
    h = $efcb3b0af7aa4383$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $efcb3b0af7aa4383$var$x64Multiply(h, [
        0xff51afd7,
        0xed558ccd
    ]);
    h = $efcb3b0af7aa4383$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $efcb3b0af7aa4383$var$x64Multiply(h, [
        0xc4ceb9fe,
        0x1a85ec53
    ]);
    h = $efcb3b0af7aa4383$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    return h;
};
$efcb3b0af7aa4383$exports.x64hash128 = function(key, seed) {
    key = key || "";
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var c1 = [
        0x87c37b91,
        0x114253d5
    ];
    var c2 = [
        0x4cf5ad43,
        0x2745937f
    ];
    for(var i = 0; i < bytes; i = i + 16){
        k1 = [
            key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
            key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
        ];
        k2 = [
            key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
            key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
        ];
        k1 = $efcb3b0af7aa4383$var$x64Multiply(k1, c1);
        k1 = $efcb3b0af7aa4383$var$x64Rotl(k1, 31);
        k1 = $efcb3b0af7aa4383$var$x64Multiply(k1, c2);
        h1 = $efcb3b0af7aa4383$var$x64Xor(h1, k1);
        h1 = $efcb3b0af7aa4383$var$x64Rotl(h1, 27);
        h1 = $efcb3b0af7aa4383$var$x64Add(h1, h2);
        h1 = $efcb3b0af7aa4383$var$x64Add($efcb3b0af7aa4383$var$x64Multiply(h1, [
            0,
            5
        ]), [
            0,
            0x52dce729
        ]);
        k2 = $efcb3b0af7aa4383$var$x64Multiply(k2, c2);
        k2 = $efcb3b0af7aa4383$var$x64Rotl(k2, 33);
        k2 = $efcb3b0af7aa4383$var$x64Multiply(k2, c1);
        h2 = $efcb3b0af7aa4383$var$x64Xor(h2, k2);
        h2 = $efcb3b0af7aa4383$var$x64Rotl(h2, 31);
        h2 = $efcb3b0af7aa4383$var$x64Add(h2, h1);
        h2 = $efcb3b0af7aa4383$var$x64Add($efcb3b0af7aa4383$var$x64Multiply(h2, [
            0,
            5
        ]), [
            0,
            0x38495ab5
        ]);
    }
    k1 = [
        0,
        0
    ];
    k2 = [
        0,
        0
    ];
    var iX = bytes;
    switch(remainder){
        case 15:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 14)
            ], 48));
        case 14:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 13)
            ], 40));
        case 13:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 12)
            ], 32));
        case 12:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 11)
            ], 24));
        case 11:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 10)
            ], 16));
        case 10:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 9)
            ], 8));
        case 9:
            k2 = $efcb3b0af7aa4383$var$x64Xor(k2, [
                0,
                key.charCodeAt(iX + 8)
            ]);
            k2 = $efcb3b0af7aa4383$var$x64Multiply(k2, c2);
            k2 = $efcb3b0af7aa4383$var$x64Rotl(k2, 33);
            k2 = $efcb3b0af7aa4383$var$x64Multiply(k2, c1);
            h2 = $efcb3b0af7aa4383$var$x64Xor(h2, k2);
        case 8:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 7)
            ], 56));
        case 7:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 6)
            ], 48));
        case 6:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 5)
            ], 40));
        case 5:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 4)
            ], 32));
        case 4:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 3)
            ], 24));
        case 3:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 2)
            ], 16));
        case 2:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, $efcb3b0af7aa4383$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 1)
            ], 8));
        case 1:
            k1 = $efcb3b0af7aa4383$var$x64Xor(k1, [
                0,
                key.charCodeAt(iX)
            ]);
            k1 = $efcb3b0af7aa4383$var$x64Multiply(k1, c1);
            k1 = $efcb3b0af7aa4383$var$x64Rotl(k1, 31);
            k1 = $efcb3b0af7aa4383$var$x64Multiply(k1, c2);
            h1 = $efcb3b0af7aa4383$var$x64Xor(h1, k1);
    }
    h1 = $efcb3b0af7aa4383$var$x64Xor(h1, [
        0,
        key.length
    ]);
    h2 = $efcb3b0af7aa4383$var$x64Xor(h2, [
        0,
        key.length
    ]);
    h1 = $efcb3b0af7aa4383$var$x64Add(h1, h2);
    h2 = $efcb3b0af7aa4383$var$x64Add(h2, h1);
    h1 = $efcb3b0af7aa4383$var$x64Fmix(h1);
    h2 = $efcb3b0af7aa4383$var$x64Fmix(h2);
    h1 = $efcb3b0af7aa4383$var$x64Add(h1, h2);
    h2 = $efcb3b0af7aa4383$var$x64Add(h2, h1);
    return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
};


var $2f0865fb86813e48$var$UIDGenerator = function() {
    function UIDGenerator() {}
    UIDGenerator.getDetails = function() {
        try {
            return {
                browser: {
                    browserDefaultEvalLength: $23e6e38469ffb129$exports.browserDefaultEvalLength(),
                    canWriteCookie: $23e6e38469ffb129$exports.canWriteCookie(),
                    getBrowserVendor: $23e6e38469ffb129$exports.getBrowserVendor(),
                    getHardwareConcurrency: $23e6e38469ffb129$exports.getHardwareConcurrency(),
                    getLanguage: $23e6e38469ffb129$exports.getLanguage(),
                    getPlatform: $23e6e38469ffb129$exports.getPlatform(),
                    getPlugins: $23e6e38469ffb129$exports.getPlugins(),
                    getProductSub: $23e6e38469ffb129$exports.getProductSub(),
                    getTimeZone: $23e6e38469ffb129$exports.getTimeZone(),
                    getTimeZoneOffset: $23e6e38469ffb129$exports.getTimeZoneOffset(),
                    getUserAgent: $23e6e38469ffb129$exports.getUserAgent(),
                    isIndexedDBAvailable: $23e6e38469ffb129$exports.isIndexedDBAvailable(),
                    isLocalStorageAvailable: $23e6e38469ffb129$exports.isLocalStorageAvailable(),
                    isSessionStorageAvailable: $23e6e38469ffb129$exports.isSessionStorageAvailable(),
                    isTestingBot: $23e6e38469ffb129$exports.isTestingBot(),
                    isWebDriver: $23e6e38469ffb129$exports.isWebDriver()
                },
                canvas: {
                    studyPrint: $65e009d3e4105b7d$exports.studyPrint()
                },
                font: {
                    jsFonts: new $5470f79155b8c381$exports.DetectFonts().detect()
                },
                webGL: {
                    getWebGL: $55e2fa6047af7988$exports.getWebGL()
                }
            };
        } catch (err) {
            return $c14d1eb521069857$exports.ERROR;
        }
    };
    UIDGenerator.getValue = function(cachedUids) {
        try {
            var values = [
                $23e6e38469ffb129$exports.browserDefaultEvalLength(),
                $23e6e38469ffb129$exports.canWriteCookie(),
                $23e6e38469ffb129$exports.getBrowserVendor(),
                $23e6e38469ffb129$exports.getHardwareConcurrency(),
                $23e6e38469ffb129$exports.getLanguage(),
                $23e6e38469ffb129$exports.getPlatform(),
                $23e6e38469ffb129$exports.getPlugins(),
                $23e6e38469ffb129$exports.getProductSub(),
                $23e6e38469ffb129$exports.getTimeZone(),
                $23e6e38469ffb129$exports.getTimeZoneOffset(),
                $23e6e38469ffb129$exports.getUserAgent(),
                $23e6e38469ffb129$exports.isIndexedDBAvailable(),
                $23e6e38469ffb129$exports.isLocalStorageAvailable(),
                $23e6e38469ffb129$exports.isSessionStorageAvailable(),
                $23e6e38469ffb129$exports.isTestingBot(),
                $23e6e38469ffb129$exports.isWebDriver(),
                $65e009d3e4105b7d$exports.studyPrint(),
                new $5470f79155b8c381$exports.DetectFonts().result(),
                $55e2fa6047af7988$exports.getWebGL()
            ];
            var value = $efcb3b0af7aa4383$exports.x64hash128(values.join("|"), 64);
            var state = void 0;
            if (!cachedUids.length) state = $e5a7ccf3ca9852d5$exports.XIDState.NEW;
            else if (cachedUids[0].value === value) state = $e5a7ccf3ca9852d5$exports.XIDState.EXISTING;
            else state = $e5a7ccf3ca9852d5$exports.XIDState.CHANGED;
            return state === $e5a7ccf3ca9852d5$exports.XIDState.EXISTING ? cachedUids : $7WQrb.__spreadArrays([
                {
                    type: $e5a7ccf3ca9852d5$exports.XIDItemType.UID,
                    createdAt: new Date().toISOString(),
                    state: state,
                    value: value
                }
            ], cachedUids);
        } catch (err) {
            return [
                {
                    type: $e5a7ccf3ca9852d5$exports.XIDItemType.UID,
                    state: $e5a7ccf3ca9852d5$exports.XIDState.ERROR
                }
            ];
        }
    };
    return UIDGenerator;
}();
$2f0865fb86813e48$exports.UIDGenerator = $2f0865fb86813e48$var$UIDGenerator;


var $362b9e30f609e57a$exports = {};
"use strict";
Object.defineProperty($362b9e30f609e57a$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

var $362b9e30f609e57a$var$promise_polyfill_1 = $7WQrb.__importDefault((parcelRequire("cSbQH")));



var $362b9e30f609e57a$var$TEST_HOST = "";
var $362b9e30f609e57a$var$DEV_HOST = "xxid.dev.atl-paas.net";
var $362b9e30f609e57a$var$STG_HOST = "xxid.staging.atl-paas.net";
var $362b9e30f609e57a$var$PROD_FALLBACK_HOST = "xxid.atl-paas.net";
var $362b9e30f609e57a$var$PROD_HOST = "xxid.atlassian.com";
var $362b9e30f609e57a$var$defaultTimeout = 3000;
var $362b9e30f609e57a$var$XCGenerator = function() {
    function XCGenerator() {}
    XCGenerator.getValue = function(env, timeout, isStorageEnabled) {
        if (timeout === void 0) timeout = $362b9e30f609e57a$var$defaultTimeout;
        if (isStorageEnabled === void 0) isStorageEnabled = true;
        var xxidHost = XCGenerator.getHost(env);
        var xxidOrigin = xxidHost ? "https://" + xxidHost : "";
        var iframeUrl = xxidOrigin ? xxidOrigin + "?t=" + new Date().getTime() : "";
        var frame = XCGenerator.addFrame(iframeUrl);
        return new $362b9e30f609e57a$var$promise_polyfill_1.default(function(resolve) {
            var listen = function(event) {
                if (event.data.type === "xcReady" && event.origin === xxidOrigin) {
                    var xc = XCGenerator.messageToXc(event);
                    if (isStorageEnabled) xc = $8e853f0f8d13ba52$exports.Storage.updateXc(env, xc);
                    resolve(xc);
                    XCGenerator.removeFrame(frame, listen);
                }
            };
            window.addEventListener("message", listen);
            setTimeout(function() {
                resolve({
                    type: $e5a7ccf3ca9852d5$exports.XIDItemType.XC,
                    state: $e5a7ccf3ca9852d5$exports.XIDState.TIMEOUT
                });
                XCGenerator.removeFrame(frame, listen);
            }, timeout);
        });
    };
    XCGenerator.messageToXc = function(event) {
        var _a = event.data, xc = _a.xc, ts = _a.ts, state = _a.state;
        if (xc && !!Date.parse(ts) && state) return {
            type: $e5a7ccf3ca9852d5$exports.XIDItemType.XC,
            value: xc,
            createdAt: ts,
            state: state
        };
        else return {
            type: $e5a7ccf3ca9852d5$exports.XIDItemType.XC,
            state: state ? state : $e5a7ccf3ca9852d5$exports.XIDState.MALFORMED
        };
    };
    XCGenerator.addFrame = function(url) {
        var frame = document.createElement("iframe");
        frame.id = "xc-" + new Date().getTime();
        frame.src = url;
        frame.style.display = "none";
        frame.style.position = "fixed";
        document.body.appendChild(frame);
        return frame;
    };
    XCGenerator.removeFrame = function(frame, listen) {
        if (document.body.contains(frame)) {
            document.body.removeChild(frame);
            window.removeEventListener("message", listen);
        }
    };
    XCGenerator.getHost = function(env) {
        switch(env){
            case $e5a7ccf3ca9852d5$exports.Environment.STAGE:
                return $362b9e30f609e57a$var$STG_HOST;
            case $e5a7ccf3ca9852d5$exports.Environment.PROD:
                return $e2c023fb925e2611$exports.isAtlassianComDomain() ? $362b9e30f609e57a$var$PROD_FALLBACK_HOST : $362b9e30f609e57a$var$PROD_HOST;
            case $e5a7ccf3ca9852d5$exports.Environment.TEST:
                return $362b9e30f609e57a$var$TEST_HOST;
            case $e5a7ccf3ca9852d5$exports.Environment.LOCAL:
            case $e5a7ccf3ca9852d5$exports.Environment.DEV:
            default:
                return $362b9e30f609e57a$var$DEV_HOST;
        }
    };
    return XCGenerator;
}();
$362b9e30f609e57a$exports.XCGenerator = $362b9e30f609e57a$var$XCGenerator;


var $0c737c92a679912b$exports = {};
"use strict";
Object.defineProperty($0c737c92a679912b$exports, "__esModule", {
    value: true
});

var $j22Yz = parcelRequire("j22Yz");
var $0c737c92a679912b$var$maptoNewXidCandidate = function(item, promiseStartTime) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && (state === $j22Yz.XIDState.NEW || state === $j22Yz.XIDState.CHANGED)) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt,
        timeTaken: $0c737c92a679912b$var$getCurrentTime() - promiseStartTime
    };
    return null;
};
var $0c737c92a679912b$var$maptoExistingXid = function(item) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && state === $j22Yz.XIDState.EXISTING) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt
    };
    return null;
};
var $0c737c92a679912b$var$mapToAmbiguousXid = function(item) {
    var state = item.state, type = item.type;
    if (item && state && type) switch(state){
        case $j22Yz.XIDState.TIMEOUT:
        case $j22Yz.XIDState.ERROR:
        case $j22Yz.XIDState.UNAVAILABLE:
        case $j22Yz.XIDState.UNKNOWN:
        case $j22Yz.XIDState.MALFORMED:
            return {
                type: type,
                state: state
            };
    }
    return null;
};
var $0c737c92a679912b$var$mapToMalformedXid = function(item) {
    var type = item.type;
    if (item && type) return {
        type: type,
        state: $j22Yz.XIDState.MALFORMED
    };
    return null;
};
function $0c737c92a679912b$var$promiseWithTimer(fn) {
    var addTimeTaken = function(item) {
        var fallbackXid = {
            type: $j22Yz.XIDItemType.UID,
            state: $j22Yz.XIDState.MALFORMED
        };
        return $0c737c92a679912b$var$maptoNewXidCandidate(item, start) || $0c737c92a679912b$var$maptoExistingXid(item) || $0c737c92a679912b$var$mapToAmbiguousXid(item) || $0c737c92a679912b$var$mapToMalformedXid(item) || fallbackXid;
    };
    var onPromiseDone = function(data) {
        return data.map(function(item) {
            return addTimeTaken(item);
        });
    };
    var start = $0c737c92a679912b$var$getCurrentTime();
    return fn().then(onPromiseDone);
}
$0c737c92a679912b$exports.promiseWithTimer = $0c737c92a679912b$var$promiseWithTimer;
var $0c737c92a679912b$var$getCurrentTime = function() {
    if (performance && performance.now) return performance.now();
    return new Date().getTime();
};



var $j22Yz = parcelRequire("j22Yz");
$c6d222d7d21f3819$exports.defaultTimeout = 5000;
var $c6d222d7d21f3819$var$delayUidGenerate = 1e3;
var $c6d222d7d21f3819$var$nonProdMaxTimeout = 30000;
var $c6d222d7d21f3819$var$prodMaxTimeout = 10000;
var $c6d222d7d21f3819$var$minTimeout = 2000;
var $c6d222d7d21f3819$var$XID = function() {
    function XID(env, timeout) {
        if (env === void 0) env = $j22Yz.Environment.LOCAL;
        if (timeout === void 0) timeout = $c6d222d7d21f3819$exports.defaultTimeout;
        this.storageEnabled = true;
        this.timeoutUid = {
            type: $j22Yz.XIDItemType.UID,
            state: $j22Yz.XIDState.TIMEOUT
        };
        if (!env) throw new Error("Missing env configuration");
        this.env = env;
        var maxTimeout = this.env === $j22Yz.Environment.PROD ? $c6d222d7d21f3819$var$prodMaxTimeout : $c6d222d7d21f3819$var$nonProdMaxTimeout;
        if (timeout >= $c6d222d7d21f3819$var$minTimeout && timeout <= maxTimeout) this.timeout = timeout;
        else {
            if (this.env !== $j22Yz.Environment.PROD) console.log("timeout configuration must be in the range of [" + $c6d222d7d21f3819$var$minTimeout + ", " + maxTimeout + "] seconds");
            this.timeout = $c6d222d7d21f3819$exports.defaultTimeout;
        }
    }
    XID.prototype.getTimeoutPromise = function(timeoutXid) {
        var _this = this;
        return new $c6d222d7d21f3819$var$promise_polyfill_1.default(function(resolve) {
            setTimeout(function() {
                resolve([
                    timeoutXid
                ]);
            }, (_this.timeout - $c6d222d7d21f3819$var$delayUidGenerate) / 2);
        });
    };
    XID.prototype.getXcPromiseAndSave = function() {
        var _this = this;
        return new $c6d222d7d21f3819$var$promise_polyfill_1.default(function(resolve) {
            _this.getXc().then(function(xc) {
                if (_this.storageEnabled) $8e853f0f8d13ba52$exports.Storage.saveXid([
                    xc
                ]);
                resolve([
                    xc
                ]);
            });
        });
    };
    XID.prototype.getUidPromiseAndSave = function() {
        var _this = this;
        return new $c6d222d7d21f3819$var$promise_polyfill_1.default(function(resolve) {
            var handleUid = function() {
                var cachedUids = [];
                if (_this.storageEnabled) cachedUids = $8e853f0f8d13ba52$exports.Storage.getUids();
                var uids = $2f0865fb86813e48$exports.UIDGenerator.getValue(cachedUids);
                if (_this.storageEnabled) {
                    $8e853f0f8d13ba52$exports.Storage.saveUids(uids);
                    $8e853f0f8d13ba52$exports.Storage.saveXid(uids);
                }
                resolve(uids);
            };
            var requestIdleCallback = window.requestIdleCallback;
            requestIdleCallback ? requestIdleCallback(handleUid) : setTimeout(handleUid, $c6d222d7d21f3819$var$delayUidGenerate);
        });
    };
    XID.prototype.getXidPromiseInXcUidOnly = function() {
        var _this = this;
        return this.getXcPromiseAndSave().then(function(xc) {
            if (xc && xc.length > 0 && xc[0].createdAt && xc[0].value) return xc;
            else return _this.getTimeoutPromise(_this.timeoutUid), _this.getUidPromiseAndSave().then(function(uid) {
                return $7WQrb.__spreadArrays(uid, xc);
            });
        });
    };
    XID.prototype.getXidCallbackForPromise = function(mode, storageEnabled) {
        if (mode === void 0) mode = $j22Yz.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        var transformedXids;
        var transform = function(xids) {
            if (transformedXids) return transformedXids;
            transformedXids = xids.map(function(xid) {
                if (xid.state === $j22Yz.XIDState.NEW || xid.state === $j22Yz.XIDState.CHANGED) return {
                    state: $j22Yz.XIDState.EXISTING,
                    type: xid.type,
                    createdAt: xid.createdAt,
                    value: xid.value
                };
                return xid;
            });
            return xids;
        };
        return this.getXidPromise(mode, storageEnabled).then(function(xid) {
            return function() {
                return transform(xid);
            };
        });
    };
    XID.prototype.getXidPromise = function(mode, storageEnabled) {
        var _this = this;
        if (mode === void 0) mode = $j22Yz.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        this.storageEnabled = storageEnabled;
        var cachedXidValue = mode === $j22Yz.XIDGenerateMode.CACHE_ONLY || mode === $j22Yz.XIDGenerateMode.CACHE_XC_UID ? $8e853f0f8d13ba52$exports.Storage.getCachedXID() : [];
        switch(mode){
            case $j22Yz.XIDGenerateMode.XC_ONLY:
                return $0c737c92a679912b$exports.promiseWithTimer(function() {
                    return _this.getXcPromiseAndSave();
                });
            case $j22Yz.XIDGenerateMode.UID_ONLY:
                return $0c737c92a679912b$exports.promiseWithTimer(function() {
                    return $c6d222d7d21f3819$var$promise_polyfill_1.default.race([
                        _this.getTimeoutPromise(_this.timeoutUid),
                        _this.getUidPromiseAndSave()
                    ]);
                });
            case $j22Yz.XIDGenerateMode.XC_UID:
                return $0c737c92a679912b$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
            case $j22Yz.XIDGenerateMode.CACHE_ONLY:
                return $c6d222d7d21f3819$var$promise_polyfill_1.default.resolve(cachedXidValue);
            case $j22Yz.XIDGenerateMode.CACHE_XC_UID:
            default:
                return cachedXidValue.length > 0 ? $c6d222d7d21f3819$var$promise_polyfill_1.default.resolve(cachedXidValue) : $0c737c92a679912b$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
        }
    };
    XID.prototype.getXc = function() {
        return $362b9e30f609e57a$exports.XCGenerator.getValue(this.env, (this.timeout - $c6d222d7d21f3819$var$delayUidGenerate) / 2, this.storageEnabled);
    };
    XID.prototype.getUidDetails = function() {
        return $2f0865fb86813e48$exports.UIDGenerator.getDetails();
    };
    return XID;
}();
$c6d222d7d21f3819$exports.XID = $c6d222d7d21f3819$var$XID;


$e5a7ccf3ca9852d5$exports.XID = $c6d222d7d21f3819$exports.XID;


var $fff776c95d28933e$exports = {};
"use strict";
Object.defineProperty($fff776c95d28933e$exports, "__esModule", {
    value: true
});
$fff776c95d28933e$exports.ENVIRONMENT = $fff776c95d28933e$exports.CONSENT_KEY = void 0;
var $fff776c95d28933e$var$ENVIRONMENT = $fff776c95d28933e$exports.ENVIRONMENT = /*#__PURE__*/ function(ENVIRONMENT) {
    ENVIRONMENT["LOCAL"] = "local";
    ENVIRONMENT["DEV"] = "development";
    ENVIRONMENT["STAGING"] = "staging";
    ENVIRONMENT["PROD"] = "production";
    return ENVIRONMENT;
}({});
var $fff776c95d28933e$var$CONSENT_KEY = $fff776c95d28933e$exports.CONSENT_KEY = {
    COMMUNITY: "communityTermsOfService",
    PRIVACY: "privacyPolicy"
};


function $5827f444065c0e59$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5827f444065c0e59$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5827f444065c0e59$var$_typeof(o);
}
function $5827f444065c0e59$var$_defineProperty(e, r, t) {
    return (r = $5827f444065c0e59$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5827f444065c0e59$var$_toPropertyKey(t) {
    var i = $5827f444065c0e59$var$_toPrimitive(t, "string");
    return "symbol" == $5827f444065c0e59$var$_typeof(i) ? i : i + "";
}
function $5827f444065c0e59$var$_toPrimitive(t, r) {
    if ("object" != $5827f444065c0e59$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5827f444065c0e59$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5827f444065c0e59$var$ENV_TO_ANALYTICS_ENV_TYPE = $5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty({}, $fff776c95d28933e$exports.ENVIRONMENT.LOCAL, $3emEs.envType.LOCAL), $fff776c95d28933e$exports.ENVIRONMENT.DEV, $3emEs.envType.DEV), $fff776c95d28933e$exports.ENVIRONMENT.STAGING, $3emEs.envType.STAGING), $fff776c95d28933e$exports.ENVIRONMENT.PROD, $3emEs.envType.PROD);
var $5827f444065c0e59$var$ENV_TO_XID_ENV = $5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty({}, $fff776c95d28933e$exports.ENVIRONMENT.LOCAL, $e5a7ccf3ca9852d5$exports.Environment.LOCAL), $fff776c95d28933e$exports.ENVIRONMENT.DEV, $e5a7ccf3ca9852d5$exports.Environment.DEV), $fff776c95d28933e$exports.ENVIRONMENT.STAGING, $e5a7ccf3ca9852d5$exports.Environment.STAGE), $fff776c95d28933e$exports.ENVIRONMENT.PROD, $e5a7ccf3ca9852d5$exports.Environment.PROD);
var $5827f444065c0e59$var$ENV_TO_ANALYTICS_WRITE_KEY = $5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty({}, $fff776c95d28933e$exports.ENVIRONMENT.LOCAL, "SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold"), $fff776c95d28933e$exports.ENVIRONMENT.DEV, "SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold"), $fff776c95d28933e$exports.ENVIRONMENT.STAGING, "4J6H7c3XTcpm1dbenkOILSyOachvf9It"), $fff776c95d28933e$exports.ENVIRONMENT.PROD, "TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw");
var $5827f444065c0e59$var$getEnvironment = $5827f444065c0e59$exports.getEnvironment = function getEnvironment(env) {
    var _process$env$CLIENT_L, _ref;
    if (env) return env;
    var processEnv = (_process$env$CLIENT_L = undefined, _process$env$CLIENT_L !== void 0) ? _process$env$CLIENT_L : "production";
    return (_ref = processEnv) !== null && _ref !== void 0 ? _ref : $fff776c95d28933e$exports.ENVIRONMENT.LOCAL;
};
var $5827f444065c0e59$var$getGASv3Environment = $5827f444065c0e59$exports.getGASv3Environment = function getGASv3Environment(environment) {
    return $5827f444065c0e59$var$ENV_TO_ANALYTICS_ENV_TYPE[environment !== null && environment !== void 0 ? environment : $5827f444065c0e59$var$getEnvironment()];
};
var $5827f444065c0e59$var$getXidEnvironment = $5827f444065c0e59$exports.getXidEnvironment = function getXidEnvironment(environment) {
    return $5827f444065c0e59$var$ENV_TO_XID_ENV[environment !== null && environment !== void 0 ? environment : $5827f444065c0e59$var$getEnvironment()];
};
var $5827f444065c0e59$var$getAnalyticsWriteKey = $5827f444065c0e59$exports.getAnalyticsWriteKey = function getAnalyticsWriteKey(environment) {
    return $5827f444065c0e59$var$ENV_TO_ANALYTICS_WRITE_KEY[environment !== null && environment !== void 0 ? environment : $5827f444065c0e59$var$getEnvironment()];
};
var $5827f444065c0e59$var$shouldUseStargate = $5827f444065c0e59$exports.shouldUseStargate = function shouldUseStargate(environment) {
    switch(environment !== null && environment !== void 0 ? environment : $5827f444065c0e59$var$getEnvironment()){
        case $fff776c95d28933e$exports.ENVIRONMENT.PROD:
        case $fff776c95d28933e$exports.ENVIRONMENT.STAGING:
            return true;
        case $fff776c95d28933e$exports.ENVIRONMENT.DEV:
        default:
            return false;
    }
};
var $5827f444065c0e59$var$getUppApiPathFromEnvironment = $5827f444065c0e59$exports.getUppApiPathFromEnvironment = function getUppApiPathFromEnvironment(env) {
    var environment = $5827f444065c0e59$var$getEnvironment(env);
    switch(environment){
        case $fff776c95d28933e$exports.ENVIRONMENT.DEV:
            return "/gateway/api/graphql?serviceOverride=upp_service_api=https://upp-service-api.ap-southeast-2.dev.atl-paas.net/api/graphql";
        default:
            return "/gateway/api/graphql";
    }
};
var $5827f444065c0e59$var$ENVIRONMENT_CONFIGS = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS = $5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty($5827f444065c0e59$var$_defineProperty({}, $fff776c95d28933e$exports.ENVIRONMENT.LOCAL, {
    HOME_BASE_URL: "https://community.dev.atlassian.com",
    KHOROS_ENDPOINT_PATH: "atlassiandev3",
    IDENTITY_BASE_URL: "https://id.stg.internal.atlassian.com"
}), $fff776c95d28933e$exports.ENVIRONMENT.DEV, {
    HOME_BASE_URL: "https://community.dev.atlassian.com",
    KHOROS_ENDPOINT_PATH: "atlassiandev3",
    IDENTITY_BASE_URL: "https://id.stg.internal.atlassian.com"
}), $fff776c95d28933e$exports.ENVIRONMENT.STAGING, {
    HOME_BASE_URL: "https://community.stg.atlassian.com",
    KHOROS_ENDPOINT_PATH: "atlassiandev",
    IDENTITY_BASE_URL: "https://id.stg.internal.atlassian.com"
}), $fff776c95d28933e$exports.ENVIRONMENT.PROD, {
    HOME_BASE_URL: "https://community.atlassian.com",
    KHOROS_ENDPOINT_PATH: "atlassian",
    IDENTITY_BASE_URL: "https://id.atlassian.com"
});


var $b9e43563e24aba1a$exports = {};
"use strict";
Object.defineProperty($b9e43563e24aba1a$exports, "__esModule", {
    value: true
});
$b9e43563e24aba1a$exports.hasConsentMutationError = $b9e43563e24aba1a$var$hasConsentMutationError;
$b9e43563e24aba1a$exports.isUnifiedAccountQueryError = $b9e43563e24aba1a$var$isUnifiedAccountQueryError;
$b9e43563e24aba1a$exports.isUnifiedQueryError = $b9e43563e24aba1a$var$isUnifiedQueryError;
function $b9e43563e24aba1a$var$isUnifiedQueryError(response) {
    return "identifier" in response;
}
function $b9e43563e24aba1a$var$hasConsentMutationError(response) {
    return response.errors != null && Array.isArray(response.errors) && response.errors.length > 0;
}
function $b9e43563e24aba1a$var$isUnifiedAccountQueryError(response) {
    return "identifier" in response;
}


function $8e221dc9235bf597$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $8e221dc9235bf597$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $8e221dc9235bf597$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($8e221dc9235bf597$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $8e221dc9235bf597$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e221dc9235bf597$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e221dc9235bf597$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e221dc9235bf597$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e221dc9235bf597$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e221dc9235bf597$var$_defineProperty(e, r, t) {
    return (r = $8e221dc9235bf597$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e221dc9235bf597$var$_toPropertyKey(t) {
    var i = $8e221dc9235bf597$var$_toPrimitive(t, "string");
    return "symbol" == $8e221dc9235bf597$var$_typeof(i) ? i : i + "";
}
function $8e221dc9235bf597$var$_toPrimitive(t, r) {
    if ("object" != $8e221dc9235bf597$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e221dc9235bf597$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e221dc9235bf597$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $8e221dc9235bf597$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $8e221dc9235bf597$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $8e221dc9235bf597$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $8e221dc9235bf597$var$userConsentStatuses = $8e221dc9235bf597$exports.userConsentStatuses = /*#__PURE__*/ function() {
    var _ref = $8e221dc9235bf597$var$_asyncToGenerator(/*#__PURE__*/ $8e221dc9235bf597$var$_regeneratorRuntime().mark(function _callee(aaid) {
        var baseUrl, Origin, env, apiPath, rawConsentResponse, consentResponse, _args = arguments;
        return $8e221dc9235bf597$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 6;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        headers: $8e221dc9235bf597$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $a31ec78ef2dbb035$exports.getUserIsConsentedQuery)(aaid),
                            operationName: "USER_CONSENTED_QUERY"
                        })
                    });
                case 6:
                    rawConsentResponse = _context.sent;
                    _context.next = 9;
                    return rawConsentResponse.json();
                case 9:
                    consentResponse = _context.sent;
                    return _context.abrupt("return", consentResponse);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function userConsentStatuses(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $8e221dc9235bf597$var$isUserConsented = $8e221dc9235bf597$exports.isUserConsented = /*#__PURE__*/ function() {
    var _ref2 = $8e221dc9235bf597$var$_asyncToGenerator(/*#__PURE__*/ $8e221dc9235bf597$var$_regeneratorRuntime().mark(function _callee2(consentKeys, aaid) {
        var baseUrl, Origin, _consentStatuses$data, consentStatuses, consentObj, _args2 = arguments;
        return $8e221dc9235bf597$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : "";
                    Origin = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 2;
                    _context2.next = 5;
                    return $8e221dc9235bf597$var$userConsentStatuses(aaid, baseUrl, Origin);
                case 5:
                    consentStatuses = _context2.sent;
                    if (!(0, $b9e43563e24aba1a$exports.isUnifiedQueryError)(consentStatuses.data.unified.consent.getConsent)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return", false);
                case 8:
                    consentObj = consentStatuses === null || consentStatuses === void 0 || (_consentStatuses$data = consentStatuses.data) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.unified) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.consent) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.getConsent) === null || _consentStatuses$data === void 0 ? void 0 : _consentStatuses$data.consentObj;
                    return _context2.abrupt("return", consentKeys.every(function(key) {
                        var consentStatus = consentObj === null || consentObj === void 0 ? void 0 : consentObj.find(function(consent) {
                            return consent.consentKey === key;
                        });
                        if ((consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.consentStatus) === "true") return true;
                    }));
                case 12:
                    _context2.prev = 12;
                    _context2.t0 = _context2["catch"](2);
                    console.error(_context2.t0);
                    return _context2.abrupt("return", false);
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return function isUserConsented(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
// Set consent on UPP
var $8e221dc9235bf597$var$setUserConsent = $8e221dc9235bf597$exports.setUserConsent = /*#__PURE__*/ function() {
    var _ref3 = $8e221dc9235bf597$var$_asyncToGenerator(/*#__PURE__*/ $8e221dc9235bf597$var$_regeneratorRuntime().mark(function _callee3(consentKeys, aaid, env) {
        var baseUrl, cookie, Origin, apiPath, consentPromises, consentResponses, consentValues, _args3 = arguments;
        return $8e221dc9235bf597$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    baseUrl = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : "";
                    cookie = _args3.length > 4 ? _args3[4] : undefined;
                    Origin = _args3.length > 5 ? _args3[5] : undefined;
                    _context3.prev = 3;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)(env);
                    consentPromises = [];
                    consentKeys.forEach(function(key) {
                        var consentPromise = fetch("".concat(baseUrl).concat(apiPath), {
                            method: "POST",
                            credentials: "include",
                            headers: $8e221dc9235bf597$var$_objectSpread($8e221dc9235bf597$var$_objectSpread({}, Origin ? {
                                Origin: Origin
                            } : {}), {}, {
                                "Content-Type": "application/json"
                            }, cookie ? {
                                cookie: cookie
                            } : {}),
                            body: JSON.stringify({
                                query: (0, $954418363634b5e4$exports.setUserIsConsentedMutation)(aaid, key),
                                operationName: "SET_USER_CONSENTED_MUTATION"
                            })
                        }).then(function(response) {
                            return response.json();
                        });
                        consentPromises.push(consentPromise);
                    });
                    _context3.next = 9;
                    return Promise.all(consentPromises);
                case 9:
                    consentResponses = _context3.sent;
                    consentValues = consentResponses.map(function(response) {
                        return response.data.unified.consent.setConsent;
                    });
                    consentValues.forEach(function(values) {
                        if ((0, $b9e43563e24aba1a$exports.hasConsentMutationError)(values)) {
                            if (values.errors && values.errors.length > 0) throw new Error("Error setting consent: ".concat(values.errors[0].message));
                        }
                    });
                    return _context3.abrupt("return", consentValues.every(function(value) {
                        return value.success;
                    }));
                case 15:
                    _context3.prev = 15;
                    _context3.t0 = _context3["catch"](3);
                    console.error("Error setting consent on UPP: ", _context3.t0);
                    return _context3.abrupt("return", false);
                case 19:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function setUserConsent(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();




var $8u8Lp = parcelRequire("8u8Lp");
parcelRequire("acw62");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
parcelRequire("8ajhZ");
parcelRequire("8rteH");
parcelRequire("Ivf4A");
var $05a45ec9b1af12be$export$ffb0004e005737fa = $7b02d682eb115277$exports.Fragment;
var $05a45ec9b1af12be$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $8u8Lp.h).call(props, "css")) return $7b02d682eb115277$exports.jsx(type, props, key);
    return $7b02d682eb115277$exports.jsx((0, $8u8Lp.E), (0, $8u8Lp.c)(type, props), key);
};
var $05a45ec9b1af12be$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $8u8Lp.h).call(props, "css")) return $7b02d682eb115277$exports.jsxs(type, props, key);
    return $7b02d682eb115277$exports.jsxs((0, $8u8Lp.E), (0, $8u8Lp.c)(type, props), key);
};




/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $aad4e6bead4773d5$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $aad4e6bead4773d5$export$2e2bcd8739ae039 = $aad4e6bead4773d5$var$tokens;


var $134730d15166ee5a$export$4ef52930e33717cd = "data-theme";
var $134730d15166ee5a$export$a00eac3f8684bcd0 = "data-color-mode";
var $134730d15166ee5a$export$2112803007239c61 = "data-contrast-mode";
var $134730d15166ee5a$export$352e418ed5b6193a = "data-custom-theme";
var $134730d15166ee5a$export$2faeed762aac6741 = "light";
var $134730d15166ee5a$export$6f0c6fb8c80fcc92 = "ds";
var $134730d15166ee5a$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $134730d15166ee5a$export$dddac1532e822863 = "--".concat($134730d15166ee5a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $134730d15166ee5a$export$9d7b58831ae93caa = "--".concat($134730d15166ee5a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $hPtJY = parcelRequire("hPtJY");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $c43cf29233629784$var$token(path, fallback) {
    var token = (0, $aad4e6bead4773d5$export$2e2bcd8739ae039)[path];
    typeof $hPtJY;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $134730d15166ee5a$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $c43cf29233629784$export$2e2bcd8739ae039 = $c43cf29233629784$var$token;



var $dnfL5 = parcelRequire("dnfL5");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/**
 * An empty function which does nothing.
 */ function $0893ab51d3631fdb$export$2e2bcd8739ae039() {}



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $6Bvm3 = parcelRequire("6Bvm3");

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $ad6731cd3cae09e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad6731cd3cae09e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad6731cd3cae09e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad6731cd3cae09e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad6731cd3cae09e5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ad6731cd3cae09e5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ad6731cd3cae09e5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ad6731cd3cae09e5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $ad6731cd3cae09e5$var$_objectSpread($ad6731cd3cae09e5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $a2421ea1fb26ac6a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a2421ea1fb26ac6a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a2421ea1fb26ac6a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a2421ea1fb26ac6a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a2421ea1fb26ac6a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a2421ea1fb26ac6a$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a2421ea1fb26ac6a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $a2421ea1fb26ac6a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $a2421ea1fb26ac6a$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a2421ea1fb26ac6a$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $ad6731cd3cae09e5$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $96e38b97f3903ede$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};


function $1e19285d55b23d2e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $96e38b97f3903ede$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $a2421ea1fb26ac6a$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $0bb45d4607a97797$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $f8784e9218a8d7c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8784e9218a8d7c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8784e9218a8d7c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8784e9218a8d7c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8784e9218a8d7c8$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1e19285d55b23d2e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $0bb45d4607a97797$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $0bb45d4607a97797$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f8784e9218a8d7c8$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $acw62 = parcelRequire("acw62");
function $a9944ef3517b621b$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
var $167851a124e2c118$var$BORDER_WIDTH = 2;
var $167851a124e2c118$var$baseFocusOutsideStyles = (0, $dnfL5.css)({
    outline: "".concat($167851a124e2c118$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $167851a124e2c118$var$BORDER_WIDTH
});
var $167851a124e2c118$var$baseInsetStyles = (0, $dnfL5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$167851a124e2c118$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $167851a124e2c118$var$focusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $167851a124e2c118$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $167851a124e2c118$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $167851a124e2c118$var$insetFocusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $167851a124e2c118$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $167851a124e2c118$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $167851a124e2c118$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $167851a124e2c118$var$baseInsetStyles : $167851a124e2c118$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $167851a124e2c118$var$insetFocusRingStyles : $167851a124e2c118$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $dnfL5.jsx)((0, $dnfL5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$167851a124e2c118$var$FocusRing.displayName = "FocusRing";
var $167851a124e2c118$export$2e2bcd8739ae039 = $167851a124e2c118$var$FocusRing;



var $acw62 = parcelRequire("acw62");
var $821ef75052fd65be$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $de95ffcf4639785f$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $de95ffcf4639785f$var$tabKeyCode = 9;
function $de95ffcf4639785f$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $de95ffcf4639785f$var$tabKeyCode) return;
    $de95ffcf4639785f$var$abort(event);
}
var $de95ffcf4639785f$var$block = {
    onMouseDownCapture: $de95ffcf4639785f$var$abort,
    onMouseUpCapture: $de95ffcf4639785f$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $de95ffcf4639785f$var$onKey,
    onKeyUpCapture: $de95ffcf4639785f$var$onKey,
    onTouchStartCapture: $de95ffcf4639785f$var$abort,
    onTouchEndCapture: $de95ffcf4639785f$var$abort,
    onPointerDownCapture: $de95ffcf4639785f$var$abort,
    onPointerUpCapture: $de95ffcf4639785f$var$abort,
    onClickCapture: $de95ffcf4639785f$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $de95ffcf4639785f$var$abort
};
var $de95ffcf4639785f$var$doNotBlock = {};
function $de95ffcf4639785f$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $de95ffcf4639785f$var$doNotBlock : $de95ffcf4639785f$var$block;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");
function $416dc049cf97caf5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $416dc049cf97caf5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $416dc049cf97caf5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $416dc049cf97caf5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $416dc049cf97caf5$var$gridSize = 8;
var $416dc049cf97caf5$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $416dc049cf97caf5$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $416dc049cf97caf5$var$lineHeights = {
    default: $416dc049cf97caf5$var$heights.default,
    compact: $416dc049cf97caf5$var$heights.compact,
    none: "inherit"
};
var $416dc049cf97caf5$var$padding = {
    // 10px gutter
    default: "0 ".concat($416dc049cf97caf5$var$gridSize + $416dc049cf97caf5$var$gridSize / 4, "px"),
    compact: "0 ".concat($416dc049cf97caf5$var$gridSize + $416dc049cf97caf5$var$gridSize / 4, "px"),
    none: "0"
};
var $416dc049cf97caf5$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($416dc049cf97caf5$var$gridSize / 4, "px"),
    default: "0 ".concat($416dc049cf97caf5$var$gridSize / 4, "px"),
    none: "0"
};
var $416dc049cf97caf5$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $416dc049cf97caf5$var$innerMargin = {
    content: "0 ".concat($416dc049cf97caf5$var$gridSize / 4, "px"),
    icon: "0 ".concat($416dc049cf97caf5$var$gridSize / 4, "px")
};
var $416dc049cf97caf5$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $416dc049cf97caf5$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    "&::after": $416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread({}, $416dc049cf97caf5$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:hover": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:active": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $416dc049cf97caf5$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $416dc049cf97caf5$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #1868DB)",
    "&:hover": {
        color: "var(--ds-link, #1868DB)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: "underline"
    }
};
var $416dc049cf97caf5$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #505258)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $416dc049cf97caf5$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #505258)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #292A2E)",
        textDecoration: "underline"
    }
};
var $416dc049cf97caf5$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $416dc049cf97caf5$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $416dc049cf97caf5$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    "&:not([disabled])::after": $416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread({}, $416dc049cf97caf5$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $416dc049cf97caf5$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $416dc049cf97caf5$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: (0, $ltooA.fg)("platform-dst-shape-theme-default") ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap",
        cursor: "pointer",
        height: $416dc049cf97caf5$var$heights[spacing],
        lineHeight: $416dc049cf97caf5$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $416dc049cf97caf5$var$singleIconPadding[spacing] : $416dc049cf97caf5$var$padding[spacing],
        verticalAlign: $416dc049cf97caf5$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, isSelected ? $416dc049cf97caf5$var$selectedStyles : $416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread($416dc049cf97caf5$var$_objectSpread({}, appearance === "default" && $416dc049cf97caf5$var$defaultStyles), appearance === "primary" && $416dc049cf97caf5$var$primaryStyles), appearance === "link" && $416dc049cf97caf5$var$linkStyles), appearance === "subtle" && $416dc049cf97caf5$var$subtleStyles), appearance === "subtle-link" && $416dc049cf97caf5$var$subtleLinkStyles), appearance === "warning" && $416dc049cf97caf5$var$warningStyles), appearance === "danger" && $416dc049cf97caf5$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $416dc049cf97caf5$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $416dc049cf97caf5$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : "transparent"
            },
            "&:active": {
                backgroundColor: $416dc049cf97caf5$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : "transparent"
            }
        }
    }, $416dc049cf97caf5$var$hasOverlayStyles)), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $416dc049cf97caf5$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $dnfL5.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $416dc049cf97caf5$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $416dc049cf97caf5$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $416dc049cf97caf5$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $416dc049cf97caf5$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $416dc049cf97caf5$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $acw62 = parcelRequire("acw62");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d930b4e2b907eef1$var$ATOMIC_GROUP_LENGTH = 5;
function $d930b4e2b907eef1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $d930b4e2b907eef1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $f26887e6ba26112a$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $f26887e6ba26112a$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $d930b4e2b907eef1$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $f26887e6ba26112a$export$2e2bcd8739ae039 = $f26887e6ba26112a$var$VisuallyHidden;


var $c5abf6a770e23349$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $acw62.isValidElement)(children) && children.type === (0, $f26887e6ba26112a$export$2e2bcd8739ae039);
};


var $c5d0e61271a52859$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $c5d0e61271a52859$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $c5d0e61271a52859$var$iconBeforeSpacingFixStyle = (0, $dnfL5.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $c5d0e61271a52859$var$iconAfterSpacingFixStyle = (0, $dnfL5.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $c5d0e61271a52859$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $c5abf6a770e23349$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $c5d0e61271a52859$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $c5abf6a770e23349$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $dnfL5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $c5d0e61271a52859$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $c5d0e61271a52859$var$_excluded);
    var ourRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $a9944ef3517b621b$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $acw62.useContext)((0, $821ef75052fd65be$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f8784e9218a8d7c8$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.10.6",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $dnfL5.css)((0, $416dc049cf97caf5$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $dnfL5.jsx)((0, $167851a124e2c118$export$2e2bcd8739ae039), null, (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $c5d0e61271a52859$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $de95ffcf4639785f$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $dnfL5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $416dc049cf97caf5$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $c5d0e61271a52859$var$getSpacingFix(children, $c5d0e61271a52859$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $c5d0e61271a52859$var$getChildren(children, [
        fadeStyles,
        (0, $416dc049cf97caf5$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $dnfL5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $416dc049cf97caf5$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $c5d0e61271a52859$var$getSpacingFix(children, $c5d0e61271a52859$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $dnfL5.jsx)("span", {
        css: [
            (0, $416dc049cf97caf5$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c5d0e61271a52859$export$2e2bcd8739ae039 = $c5d0e61271a52859$var$ButtonBase;




function $328fc88dbb557be5$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $c5abf6a770e23349$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $c071f8024d1b8ff7$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $c071f8024d1b8ff7$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $c071f8024d1b8ff7$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c071f8024d1b8ff7$var$_excluded);
    var isOnlySingleIcon = (0, $328fc88dbb557be5$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($c071f8024d1b8ff7$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $acw62.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($c071f8024d1b8ff7$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $acw62.useMemo)(function() {
        return (0, $416dc049cf97caf5$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5d0e61271a52859$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$c071f8024d1b8ff7$var$Button.displayName = "Button";
var $c071f8024d1b8ff7$export$2e2bcd8739ae039 = $c071f8024d1b8ff7$var$Button;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1fff79454cfa9cc4$var$ATOMIC_GROUP_LENGTH = 5;
function $1fff79454cfa9cc4$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $1fff79454cfa9cc4$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $8c48dc9e50d040df$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


// Reds
var $1139d3130285dbcb$export$4b84fd0e2c617bd = "#FFEBE6";
var $1139d3130285dbcb$export$b34b069eff244586 = "#FFBDAD";
var $1139d3130285dbcb$export$be802dd0d8b57f35 = "#FF8F73";
var $1139d3130285dbcb$export$60847d42f9da92a6 = "#FF7452";
var $1139d3130285dbcb$export$4a7404f376229999 = "#FF5630";
var $1139d3130285dbcb$export$2010d0fb4295b346 = "#DE350B";
var $1139d3130285dbcb$export$2837b5a1a71d5c02 = "#BF2600";
var $1139d3130285dbcb$export$8d9596b529bbb9cf = "#FFFAE6";
var $1139d3130285dbcb$export$41060a744ab0b7ae = "#FFF0B3";
var $1139d3130285dbcb$export$1cc05bbbf340e559 = "#FFE380";
var $1139d3130285dbcb$export$5aae31392d72caaa = "#FFC400";
var $1139d3130285dbcb$export$c6930421db9fa514 = "#FFAB00";
var $1139d3130285dbcb$export$59619663aa6500fb = "#FF991F";
var $1139d3130285dbcb$export$874739ea9e379ab6 = "#FF8B00";
var $1139d3130285dbcb$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $1139d3130285dbcb$export$69a3bf21b9686c2b = "#ABF5D1";
var $1139d3130285dbcb$export$afbce1382ec95f73 = "#79F2C0";
var $1139d3130285dbcb$export$747d86715d4175de = "#57D9A3";
var $1139d3130285dbcb$export$940e1f69e873f202 = "#36B37E";
var $1139d3130285dbcb$export$a49394138f7b8e85 = "#00875A";
var $1139d3130285dbcb$export$6fa04827ac68a4fb = "#006644";
var $1139d3130285dbcb$export$226de0355ed012f8 = "#DEEBFF";
var $1139d3130285dbcb$export$8c13c2ee36917869 = "#B3D4FF";
var $1139d3130285dbcb$export$ecfc1dff386a3e7a = "#4C9AFF";
var $1139d3130285dbcb$export$215b7063051591f1 = "#2684FF";
var $1139d3130285dbcb$export$e62e8919cca44969 = "#0065FF";
var $1139d3130285dbcb$export$b3de0ae08da2ce64 = "#0052CC";
var $1139d3130285dbcb$export$a6ee3d71bc067634 = "#0747A6";
var $1139d3130285dbcb$export$67f15409e87642a1 = "#669DF1";
var $1139d3130285dbcb$export$f0539dbc42dbb067 = "#8FB8F6";
var $1139d3130285dbcb$export$363e4475840015bb = "#EAE6FF";
var $1139d3130285dbcb$export$4b0a4417ed59760f = "#C0B6F2";
var $1139d3130285dbcb$export$6011520a64d9a187 = "#998DD9";
var $1139d3130285dbcb$export$a7175d4e9206bc80 = "#8777D9";
var $1139d3130285dbcb$export$b48405b95304b5a1 = "#6554C0";
var $1139d3130285dbcb$export$c71e4279dd54a18d = "#5243AA";
var $1139d3130285dbcb$export$147899de772240ec = "#403294";
var $1139d3130285dbcb$export$2cf711fe14c66f06 = "#E6FCFF";
var $1139d3130285dbcb$export$7a8f4d33f6f9772c = "#B3F5FF";
var $1139d3130285dbcb$export$776c9c497ef08533 = "#79E2F2";
var $1139d3130285dbcb$export$69cb3ca10c1e330e = "#00C7E6";
var $1139d3130285dbcb$export$9dc1ef0f3f48059b = "#00B8D9";
var $1139d3130285dbcb$export$7c835c78b6fcdef8 = "#00A3BF";
var $1139d3130285dbcb$export$6036577f95c3877e = "#008DA6";
var $1139d3130285dbcb$export$29a4f05edc054374 = "#FFFFFF";
var $1139d3130285dbcb$export$e655ef011c4aa1a2 = "#FAFBFC";
var $1139d3130285dbcb$export$9fdfb749e33cdf97 = "#F4F5F7";
var $1139d3130285dbcb$export$3e51e8f1440314ba = "#EBECF0";
var $1139d3130285dbcb$export$1ce2d1575d444ceb = "#DFE1E6";
var $1139d3130285dbcb$export$8754fc7e6d8b3000 = "#C1C7D0";
var $1139d3130285dbcb$export$c2e91cbeada39b8b = "#B3BAC5";
var $1139d3130285dbcb$export$5f71e19f3a7ad9de = "#A5ADBA";
var $1139d3130285dbcb$export$eaa8c8a70ac22806 = "#97A0AF";
var $1139d3130285dbcb$export$7c87d337fb91a97d = "#8993A4";
var $1139d3130285dbcb$export$d6447c357493214f = "#7A869A";
var $1139d3130285dbcb$export$f563ee71e9ee74cd = "#6B778C";
var $1139d3130285dbcb$export$e2ef2124cf4024b1 = "#5E6C84";
var $1139d3130285dbcb$export$eece5f492e429f08 = "#505F79";
var $1139d3130285dbcb$export$c39c0fe0f26207ae = "#42526E";
var $1139d3130285dbcb$export$7090862dc3038a9f = "#344563";
var $1139d3130285dbcb$export$ad0bacf983b7ddaa = "#253858";
var $1139d3130285dbcb$export$7d61b15e0da132af = "#172B4D";
var $1139d3130285dbcb$export$fbda843f0a27fe96 = "#091E42";
var $1139d3130285dbcb$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $1139d3130285dbcb$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $1139d3130285dbcb$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $1139d3130285dbcb$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $1139d3130285dbcb$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $1139d3130285dbcb$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $1139d3130285dbcb$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $1139d3130285dbcb$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $1139d3130285dbcb$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $1139d3130285dbcb$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $1139d3130285dbcb$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $1139d3130285dbcb$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $1139d3130285dbcb$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $1139d3130285dbcb$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $1139d3130285dbcb$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $1139d3130285dbcb$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $1139d3130285dbcb$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $1139d3130285dbcb$export$2f6319cf7d736c2a = "#E6EDFA";
var $1139d3130285dbcb$export$95126bc8884d6634 = "#DCE5F5";
var $1139d3130285dbcb$export$8338d8c35d44ff1 = "#CED9EB";
var $1139d3130285dbcb$export$5368d76ae4fbbda7 = "#B8C7E0";
var $1139d3130285dbcb$export$9f0a771d16ec8d36 = "#ABBBD6";
var $1139d3130285dbcb$export$abcf8c38338b4aa5 = "#9FB0CC";
var $1139d3130285dbcb$export$97e81faa16a182c7 = "#8C9CB8";
var $1139d3130285dbcb$export$bfe21c59123ecf33 = "#7988A3";
var $1139d3130285dbcb$export$ee82aa2ea6a1558 = "#67758F";
var $1139d3130285dbcb$export$682927c6ed76be02 = "#56637A";
var $1139d3130285dbcb$export$91fd9994c5be9757 = "#455166";
var $1139d3130285dbcb$export$d281fbfe3cff2df6 = "#3B475C";
var $1139d3130285dbcb$export$3902c91d8b98a753 = "#313D52";
var $1139d3130285dbcb$export$8e8133c1ba5845b5 = "#283447";
var $1139d3130285dbcb$export$33ff357f6620b39 = "#202B3D";
var $1139d3130285dbcb$export$633847cf062b69e0 = "#1B2638";
var $1139d3130285dbcb$export$9776a6e503bdbf76 = "#121A29";
var $1139d3130285dbcb$export$6c813d5160dff5db = "#0E1624";
var $1139d3130285dbcb$export$3d4f271a500072a = "#0D1424";
var $1139d3130285dbcb$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $1139d3130285dbcb$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $1139d3130285dbcb$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $1139d3130285dbcb$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $1139d3130285dbcb$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $1139d3130285dbcb$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $1139d3130285dbcb$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $1139d3130285dbcb$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $1139d3130285dbcb$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $1139d3130285dbcb$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $1139d3130285dbcb$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $1139d3130285dbcb$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $1139d3130285dbcb$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $1139d3130285dbcb$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $1139d3130285dbcb$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $1139d3130285dbcb$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $1139d3130285dbcb$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $1139d3130285dbcb$export$d2adc5dedf09fced = "#292A2E";
var $1139d3130285dbcb$export$f51762073d2bb381 = "#94C748";
var $1139d3130285dbcb$export$95e26d54def96891 = "#B3DF72";


var $5e762b5e0686f503$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $7979877583a72dd5$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $1139d3130285dbcb$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $1139d3130285dbcb$export$29a4f05edc054374), ")");
}
var $7979877583a72dd5$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $7979877583a72dd5$var$loadIn = null;
var $7979877583a72dd5$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $7979877583a72dd5$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $7979877583a72dd5$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $5e762b5e0686f503$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $7979877583a72dd5$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $8c48dc9e50d040df$export$2e2bcd8739ae039));
    $7979877583a72dd5$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $1fff79454cfa9cc4$export$2e2bcd8739ae039)([
            $7979877583a72dd5$var$styles.wrapperStyles,
            $7979877583a72dd5$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $1fff79454cfa9cc4$export$2e2bcd8739ae039)([
            $7979877583a72dd5$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $1fff79454cfa9cc4$export$2e2bcd8739ae039)([
            $7979877583a72dd5$var$styles.circleStyles
        ])
    })));
}));
var $7979877583a72dd5$export$2e2bcd8739ae039 = $7979877583a72dd5$var$Spinner;


function $342b3ab74c607b2a$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $342b3ab74c607b2a$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979877583a72dd5$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $342b3ab74c607b2a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


var $04e5d2708f9c98be$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $04e5d2708f9c98be$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $04e5d2708f9c98be$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c071f8024d1b8ff7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $342b3ab74c607b2a$export$2e2bcd8739ae039), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$04e5d2708f9c98be$var$LoadingButton.displayName = "LoadingButton";
var $04e5d2708f9c98be$export$2e2bcd8739ae039 = $04e5d2708f9c98be$var$LoadingButton;



var $8VyKT = parcelRequire("8VyKT");

var $6xdv4 = parcelRequire("6xdv4");

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

function $57ab94ea2d894ad6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57ab94ea2d894ad6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57ab94ea2d894ad6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57ab94ea2d894ad6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $57ab94ea2d894ad6$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $57ab94ea2d894ad6$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $57ab94ea2d894ad6$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $57ab94ea2d894ad6$export$632685d741f3dbbf = $57ab94ea2d894ad6$var$_objectSpread($57ab94ea2d894ad6$var$_objectSpread({}, $57ab94ea2d894ad6$export$958d0ae7f2977ae4), $57ab94ea2d894ad6$export$d2dc61f58390201c);
var $57ab94ea2d894ad6$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $57ab94ea2d894ad6$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $57ab94ea2d894ad6$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $57ab94ea2d894ad6$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $57ab94ea2d894ad6$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $57ab94ea2d894ad6$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $57ab94ea2d894ad6$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $57ab94ea2d894ad6$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $57ab94ea2d894ad6$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $57ab94ea2d894ad6$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $57ab94ea2d894ad6$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $57ab94ea2d894ad6$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $57ab94ea2d894ad6$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $57ab94ea2d894ad6$export$3c7e9587132614b4 = {
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $57ab94ea2d894ad6$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $57ab94ea2d894ad6$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $57ab94ea2d894ad6$export$e615f061ca585a6c = $57ab94ea2d894ad6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $57ab94ea2d894ad6$var$getSerializedStylesMap(spacingProperty, $57ab94ea2d894ad6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $57ab94ea2d894ad6$export$bf46c3f9eeafc71f = $57ab94ea2d894ad6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $57ab94ea2d894ad6$var$getSerializedStylesMap(spacingProperty, $57ab94ea2d894ad6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $57ab94ea2d894ad6$export$e7af83bafe7f9e63 = $57ab94ea2d894ad6$var$getSerializedStylesMap("backgroundColor", $57ab94ea2d894ad6$export$d1d79bf68ac056bd);
var $57ab94ea2d894ad6$export$3a1bcba60b23d7f0 = $57ab94ea2d894ad6$var$getSerializedStylesMap("color", $57ab94ea2d894ad6$export$8473307aa00d6ea1);
var $57ab94ea2d894ad6$export$45f3f4fe16f9f7d5 = $57ab94ea2d894ad6$var$getSerializedStylesMap("fontWeight", $57ab94ea2d894ad6$export$303e322c6b1ed114);
var $57ab94ea2d894ad6$export$68cc305da27dbaa4 = $57ab94ea2d894ad6$var$getSerializedStylesMap("fontFamily", $57ab94ea2d894ad6$export$3c7e9587132614b4);
var $57ab94ea2d894ad6$export$128f10c238242f83 = $57ab94ea2d894ad6$var$getSerializedStylesMap("font", $57ab94ea2d894ad6$export$6cc560b4dedf3816);
var $57ab94ea2d894ad6$export$ff257d957d48c421 = $57ab94ea2d894ad6$var$getSerializedStylesMap((0, $134730d15166ee5a$export$9d7b58831ae93caa), $57ab94ea2d894ad6$export$41a358c9c2356760);
var $57ab94ea2d894ad6$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $57ab94ea2d894ad6$export$41a358c9c2356760[color] !== undefined;
};



var $hPtJY = parcelRequire("hPtJY");
function $f2984a0b621e238a$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $f2984a0b621e238a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $f2984a0b621e238a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f2984a0b621e238a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f2984a0b621e238a$var$_arrayLikeToArray(o, minLen);
}
function $f2984a0b621e238a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f2984a0b621e238a$export$9a199fbafee0014e = {
    backgroundColor: (0, $57ab94ea2d894ad6$export$d1d79bf68ac056bd),
    blockSize: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderBottomColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderLeftColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $57ab94ea2d894ad6$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    borderWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    bottom: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    boxShadow: (0, $57ab94ea2d894ad6$export$7aff6e7ba39bb774),
    color: (0, $57ab94ea2d894ad6$export$8473307aa00d6ea1),
    columnGap: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    gap: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    height: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    inlineSize: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    inset: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    insetBlock: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    insetBlockEnd: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    insetBlockStart: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    insetInline: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    insetInlineEnd: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    insetInlineStart: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    left: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    margin: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginBlock: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginBlockEnd: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginBlockStart: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginBottom: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginInline: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginInlineEnd: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginInlineStart: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginLeft: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginRight: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    marginTop: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    maxBlockSize: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    maxHeight: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    maxWidth: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    minBlockSize: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    minHeight: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    minInlineSize: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    minWidth: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    opacity: (0, $57ab94ea2d894ad6$export$daf94a976c798b4f),
    outlineColor: (0, $57ab94ea2d894ad6$export$1531ad5bb3fbedac),
    outlineOffset: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    outlineWidth: (0, $57ab94ea2d894ad6$export$e1b83c5210c471b8),
    padding: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingBlock: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingBottom: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingInline: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingLeft: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingRight: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    paddingTop: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    right: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    rowGap: (0, $57ab94ea2d894ad6$export$958d0ae7f2977ae4),
    top: (0, $57ab94ea2d894ad6$export$632685d741f3dbbf),
    width: (0, $57ab94ea2d894ad6$export$6ccdbebca2ee545f),
    zIndex: (0, $57ab94ea2d894ad6$export$b5f31a7e431d2eab)
};
var $f2984a0b621e238a$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $f2984a0b621e238a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $f2984a0b621e238a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $f2984a0b621e238a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $f2984a0b621e238a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $f2984a0b621e238a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($f2984a0b621e238a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($f2984a0b621e238a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $f2984a0b621e238a$export$9a199fbafee0014e)) return;
        var tokenValue = $f2984a0b621e238a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $f2984a0b621e238a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $f2984a0b621e238a$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $f2984a0b621e238a$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
var $f2984a0b621e238a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $f2984a0b621e238a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$f2984a0b621e238a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $f2984a0b621e238a$export$f6c783d06584602c(style) {
    return $f2984a0b621e238a$var$baseXcss(style);
}


/** @jsx jsx */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $5d58ac69116010e9$var$justifyContentMap = {
    start: (0, $dnfL5.css)({
        justifyContent: "start"
    }),
    center: (0, $dnfL5.css)({
        justifyContent: "center"
    }),
    end: (0, $dnfL5.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $dnfL5.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $dnfL5.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $dnfL5.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $dnfL5.css)({
        justifyContent: "stretch"
    })
};
var $5d58ac69116010e9$var$flexDirectionMap = {
    column: (0, $dnfL5.css)({
        flexDirection: "column"
    }),
    row: (0, $dnfL5.css)({
        flexDirection: "row"
    })
};
var $5d58ac69116010e9$var$flexWrapMap = {
    wrap: (0, $dnfL5.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $dnfL5.css)({
        flexWrap: "nowrap"
    })
};
var $5d58ac69116010e9$var$alignItemsMap = {
    start: (0, $dnfL5.css)({
        alignItems: "start"
    }),
    center: (0, $dnfL5.css)({
        alignItems: "center"
    }),
    baseline: (0, $dnfL5.css)({
        alignItems: "baseline"
    }),
    end: (0, $dnfL5.css)({
        alignItems: "end"
    }),
    stretch: (0, $dnfL5.css)({
        alignItems: "stretch"
    })
};
var $5d58ac69116010e9$var$baseStyles = (0, $dnfL5.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $5d58ac69116010e9$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $f2984a0b621e238a$export$a9c84988c8f81f2d)(xcss);
    return (0, $dnfL5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $5d58ac69116010e9$var$baseStyles,
            gap && (0, $57ab94ea2d894ad6$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $57ab94ea2d894ad6$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $57ab94ea2d894ad6$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $5d58ac69116010e9$var$alignItemsMap[alignItems],
            direction && $5d58ac69116010e9$var$flexDirectionMap[direction],
            justifyContent && $5d58ac69116010e9$var$justifyContentMap[justifyContent],
            wrap && $5d58ac69116010e9$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$5d58ac69116010e9$var$Flex.displayName = "Flex";
var $5d58ac69116010e9$export$2e2bcd8739ae039 = $5d58ac69116010e9$var$Flex;


var $703a8c2f286efa80$var$flexGrowMap = {
    hug: (0, $f2984a0b621e238a$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $f2984a0b621e238a$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $703a8c2f286efa80$var$separatorStyles = (0, $dnfL5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $703a8c2f286efa80$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $dnfL5.jsx)("span", {
        css: $703a8c2f286efa80$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $703a8c2f286efa80$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $dnfL5.jsx)($703a8c2f286efa80$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $dnfL5.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $703a8c2f286efa80$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $dnfL5.jsx)((0, $5d58ac69116010e9$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$703a8c2f286efa80$var$Inline.displayName = "Inline";
var $703a8c2f286efa80$export$2e2bcd8739ae039 = $703a8c2f286efa80$var$Inline;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $a8737f70038867b1$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 109.99rem)",
        xl: "@media (min-width: 110rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110rem)"
    }
};
var $a8737f70038867b1$export$c881183ca713c214 = $a8737f70038867b1$export$987d49ffe1b0900f;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $f450fb6bcb502a17$var$flexGrowMap = {
    hug: (0, $f2984a0b621e238a$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $f2984a0b621e238a$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $f450fb6bcb502a17$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $f450fb6bcb502a17$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $dnfL5.jsx)((0, $5d58ac69116010e9$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f450fb6bcb502a17$var$Stack.displayName = "Stack";
var $f450fb6bcb502a17$export$2e2bcd8739ae039 = $f450fb6bcb502a17$var$Stack;

/** @jsx jsx */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $bv4qN = parcelRequire("bv4qN");


var $acw62 = parcelRequire("acw62");
var $616eaf632101f802$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $616eaf632101f802$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($616eaf632101f802$export$1ca2a26fecb070ae);
};
$616eaf632101f802$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $5f8657baeb303619$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $5f8657baeb303619$var$resetStyles = (0, $dnfL5.css)({
    margin: 0
});
var $5f8657baeb303619$var$strongStyles = (0, $dnfL5.css)({
    fontWeight: "bold"
});
var $5f8657baeb303619$var$emStyles = (0, $dnfL5.css)({
    fontStyle: "italic"
});
var $5f8657baeb303619$var$textAlignMap = {
    center: (0, $dnfL5.css)({
        textAlign: "center"
    }),
    end: (0, $dnfL5.css)({
        textAlign: "end"
    }),
    start: (0, $dnfL5.css)({
        textAlign: "start"
    })
};
var $5f8657baeb303619$var$truncationStyles = (0, $dnfL5.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $5f8657baeb303619$var$wordBreakMap = {
    breakAll: (0, $dnfL5.css)({
        wordBreak: "break-all"
    })
};
var $5f8657baeb303619$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $5f8657baeb303619$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $acw62.useContext)($5f8657baeb303619$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5f8657baeb303619$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $616eaf632101f802$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $57ab94ea2d894ad6$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $57ab94ea2d894ad6$export$2185ce37f9bdd963)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $5f8657baeb303619$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $bv4qN.default)($5f8657baeb303619$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $5f8657baeb303619$var$useHasTextAncestor();
    var color = $5f8657baeb303619$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $dnfL5.jsx)(Component, {
        ref: ref,
        css: [
            $5f8657baeb303619$var$resetStyles,
            (0, $57ab94ea2d894ad6$export$128f10c238242f83)[size],
            color && (0, $57ab94ea2d894ad6$export$3a1bcba60b23d7f0)[color],
            maxLines && $5f8657baeb303619$var$truncationStyles,
            maxLines === 1 && $5f8657baeb303619$var$wordBreakMap.breakAll,
            align && $5f8657baeb303619$var$textAlignMap[align],
            weight && (0, $57ab94ea2d894ad6$export$45f3f4fe16f9f7d5)[weight],
            Component === "em" && $5f8657baeb303619$var$emStyles,
            Component === "strong" && $5f8657baeb303619$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $dnfL5.jsx)($5f8657baeb303619$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $5f8657baeb303619$export$2e2bcd8739ae039 = $5f8657baeb303619$var$Text;


var $6e38e0bca95e9176$exports = {};
"use strict";
Object.defineProperty($6e38e0bca95e9176$exports, "__esModule", {
    value: true
});
$6e38e0bca95e9176$exports.default = void 0;

var $6e38e0bca95e9176$var$_react = $6e38e0bca95e9176$var$_interopRequireDefault((parcelRequire("acw62")));

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $8Z5xg = parcelRequire("8Z5xg");

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
var $1cc083ac5bc084f1$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $1cc083ac5bc084f1$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $1cc083ac5bc084f1$export$62ad7b0c781000e9 = {
    small: {
        width: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.small,
        height: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.medium,
        height: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.large,
        height: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.xlarge,
        height: $1cc083ac5bc084f1$export$c647cb0ee6e282fe.xlarge
    }
};



var $dnfL5 = parcelRequire("dnfL5");
var $fc267ce1839602b3$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fc267ce1839602b3$var$smallStyles = (0, $dnfL5.css)((0, $1cc083ac5bc084f1$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fc267ce1839602b3$var$mediumStyles = (0, $dnfL5.css)((0, $1cc083ac5bc084f1$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fc267ce1839602b3$var$largeStyles = (0, $dnfL5.css)((0, $1cc083ac5bc084f1$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fc267ce1839602b3$var$xlargeStyles = (0, $dnfL5.css)((0, $1cc083ac5bc084f1$export$62ad7b0c781000e9).xlarge);
var $fc267ce1839602b3$export$ef0ad74202575b64 = {
    small: $fc267ce1839602b3$var$smallStyles,
    medium: $fc267ce1839602b3$var$mediumStyles,
    large: $fc267ce1839602b3$var$largeStyles,
    xlarge: $fc267ce1839602b3$var$xlargeStyles
};
var $fc267ce1839602b3$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $1cc083ac5bc084f1$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $23c9b1cd22d0217f$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $ffaa9fd4a1fd151f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ffaa9fd4a1fd151f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ffaa9fd4a1fd151f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ffaa9fd4a1fd151f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ffaa9fd4a1fd151f$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $ffaa9fd4a1fd151f$var$_objectSpread($ffaa9fd4a1fd151f$var$_objectSpread({}, (0, $fc267ce1839602b3$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $ffaa9fd4a1fd151f$var$baseHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $ffaa9fd4a1fd151f$var$primaryEqualsSecondaryHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $ffaa9fd4a1fd151f$var$secondaryTransparentHcmStyles = (0, $dnfL5.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $ffaa9fd4a1fd151f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $dnfL5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $fc267ce1839602b3$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $dnfL5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $23c9b1cd22d0217f$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $ffaa9fd4a1fd151f$var$iconStyles,
            $ffaa9fd4a1fd151f$var$baseHcmStyles,
            primaryColor === secondaryColor && $ffaa9fd4a1fd151f$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $ffaa9fd4a1fd151f$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dnfL5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $ffaa9fd4a1fd151f$export$2e2bcd8739ae039 = $ffaa9fd4a1fd151f$export$f04a61298a47a40f;


var $6a95fc3941c3c881$var$_excluded = [
    "dangerouslySetGlyph"
];
var $6a95fc3941c3c881$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $6a95fc3941c3c881$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $6a95fc3941c3c881$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $8Z5xg.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $8Z5xg.fg)("platform-visual-refresh-icons-facade-button-fix") ? $6a95fc3941c3c881$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $6a95fc3941c3c881$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ffaa9fd4a1fd151f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $6a95fc3941c3c881$export$2e2bcd8739ae039 = $6a95fc3941c3c881$export$3cfb73f70dfca966;



var $6e38e0bca95e9176$var$_close = $6e38e0bca95e9176$var$_interopRequireDefault((parcelRequire("11P39")));
function $6e38e0bca95e9176$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6e38e0bca95e9176$var$CrossIcon = (props)=>/*#__PURE__*/ $6e38e0bca95e9176$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $6e38e0bca95e9176$var$_close.default
    }));
$6e38e0bca95e9176$var$CrossIcon.displayName = "CrossIcon";
var $6e38e0bca95e9176$var$_default = $6e38e0bca95e9176$exports.default = $6e38e0bca95e9176$var$CrossIcon;



var $gaDMh = parcelRequire("gaDMh");
var $dbf38fc8bfa334aa$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9e42f0bd2701e924d060f406b40f887>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($dbf38fc8bfa334aa$exports, "__esModule", {
    value: true
});
$dbf38fc8bfa334aa$exports.default = void 0;

var $dbf38fc8bfa334aa$var$_react = $dbf38fc8bfa334aa$var$_interopRequireDefault((parcelRequire("acw62")));

var $dbf38fc8bfa334aa$var$_UNSAFE_baseNew = $dbf38fc8bfa334aa$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $dbf38fc8bfa334aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbf38fc8bfa334aa$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $dbf38fc8bfa334aa$var$_react.default.createElement($dbf38fc8bfa334aa$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$dbf38fc8bfa334aa$var$AtlassianIntelligenceIcon.displayName = "AtlassianIntelligenceIcon";
var $dbf38fc8bfa334aa$var$_default = $dbf38fc8bfa334aa$exports.default = $dbf38fc8bfa334aa$var$AtlassianIntelligenceIcon;


var $765fb2c945546756$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($765fb2c945546756$exports, "__esModule", {
    value: true
});
$765fb2c945546756$exports.default = void 0;

var $765fb2c945546756$var$_react = $765fb2c945546756$var$_interopRequireDefault((parcelRequire("acw62")));

var $765fb2c945546756$var$_UNSAFE_baseNew = $765fb2c945546756$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $765fb2c945546756$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $765fb2c945546756$var$CalendarIcon = (props)=>/*#__PURE__*/ $765fb2c945546756$var$_react.default.createElement($765fb2c945546756$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$765fb2c945546756$var$CalendarIcon.displayName = "CalendarIcon";
var $765fb2c945546756$var$_default = $765fb2c945546756$exports.default = $765fb2c945546756$var$CalendarIcon;


var $5a7fe07e2432b2c0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5a7fe07e2432b2c0$exports, "__esModule", {
    value: true
});
$5a7fe07e2432b2c0$exports.default = void 0;

var $5a7fe07e2432b2c0$var$_react = $5a7fe07e2432b2c0$var$_interopRequireDefault((parcelRequire("acw62")));

var $5a7fe07e2432b2c0$var$_UNSAFE_baseNew = $5a7fe07e2432b2c0$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $5a7fe07e2432b2c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a7fe07e2432b2c0$var$CompassIcon = (props)=>/*#__PURE__*/ $5a7fe07e2432b2c0$var$_react.default.createElement($5a7fe07e2432b2c0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$5a7fe07e2432b2c0$var$CompassIcon.displayName = "CompassIcon";
var $5a7fe07e2432b2c0$var$_default = $5a7fe07e2432b2c0$exports.default = $5a7fe07e2432b2c0$var$CompassIcon;



var $aKcQU = parcelRequire("aKcQU");
var $541ff671b5d0d564$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79997d69990d173364910f60504b3516>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($541ff671b5d0d564$exports, "__esModule", {
    value: true
});
$541ff671b5d0d564$exports.default = void 0;

var $541ff671b5d0d564$var$_react = $541ff671b5d0d564$var$_interopRequireDefault((parcelRequire("acw62")));

var $541ff671b5d0d564$var$_UNSAFE_baseNew = $541ff671b5d0d564$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $541ff671b5d0d564$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $541ff671b5d0d564$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $541ff671b5d0d564$var$_react.default.createElement($541ff671b5d0d564$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
    }, props));
$541ff671b5d0d564$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $541ff671b5d0d564$var$_default = $541ff671b5d0d564$exports.default = $541ff671b5d0d564$var$LinkExternalIcon;



var $lrwzu = parcelRequire("lrwzu");
var $904ede548fb46240$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($904ede548fb46240$exports, "__esModule", {
    value: true
});
$904ede548fb46240$exports.default = void 0;

var $904ede548fb46240$var$_react = $904ede548fb46240$var$_interopRequireDefault((parcelRequire("acw62")));

var $904ede548fb46240$var$_UNSAFE_baseNew = $904ede548fb46240$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $904ede548fb46240$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $904ede548fb46240$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $904ede548fb46240$var$_react.default.createElement($904ede548fb46240$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$904ede548fb46240$var$MegaphoneIcon.displayName = "MegaphoneIcon";
var $904ede548fb46240$var$_default = $904ede548fb46240$exports.default = $904ede548fb46240$var$MegaphoneIcon;


var $176310dd99eb09fb$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c2c434ab24649808044e93163bd51c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($176310dd99eb09fb$exports, "__esModule", {
    value: true
});
$176310dd99eb09fb$exports.default = void 0;

var $176310dd99eb09fb$var$_react = $176310dd99eb09fb$var$_interopRequireDefault((parcelRequire("acw62")));

var $176310dd99eb09fb$var$_UNSAFE_baseNew = $176310dd99eb09fb$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $176310dd99eb09fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $176310dd99eb09fb$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $176310dd99eb09fb$var$_react.default.createElement($176310dd99eb09fb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$176310dd99eb09fb$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $176310dd99eb09fb$var$_default = $176310dd99eb09fb$exports.default = $176310dd99eb09fb$var$PeopleGroupIcon;


var $4a67238030457e9e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42f87835acc0152c23ae77c3bbeeba86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($4a67238030457e9e$exports, "__esModule", {
    value: true
});
$4a67238030457e9e$exports.default = void 0;

var $4a67238030457e9e$var$_react = $4a67238030457e9e$var$_interopRequireDefault((parcelRequire("acw62")));

var $4a67238030457e9e$var$_UNSAFE_baseNew = $4a67238030457e9e$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $4a67238030457e9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a67238030457e9e$var$PersonIcon = (props)=>/*#__PURE__*/ $4a67238030457e9e$var$_react.default.createElement($4a67238030457e9e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$4a67238030457e9e$var$PersonIcon.displayName = "PersonIcon";
var $4a67238030457e9e$var$_default = $4a67238030457e9e$exports.default = $4a67238030457e9e$var$PersonIcon;


var $69a553daba15aba1$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b1290bc5816db04bbec0542a218c285>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($69a553daba15aba1$exports, "__esModule", {
    value: true
});
$69a553daba15aba1$exports.default = void 0;

var $69a553daba15aba1$var$_react = $69a553daba15aba1$var$_interopRequireDefault((parcelRequire("acw62")));

var $69a553daba15aba1$var$_UNSAFE_baseNew = $69a553daba15aba1$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $69a553daba15aba1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69a553daba15aba1$var$ProjectIcon = (props)=>/*#__PURE__*/ $69a553daba15aba1$var$_react.default.createElement($69a553daba15aba1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
    }, props));
$69a553daba15aba1$var$ProjectIcon.displayName = "ProjectIcon";
var $69a553daba15aba1$var$_default = $69a553daba15aba1$exports.default = $69a553daba15aba1$var$ProjectIcon;


var $40a12891dd7bc9cd$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21cc5e8a48fa1ff0264c5abb7df80aa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($40a12891dd7bc9cd$exports, "__esModule", {
    value: true
});
$40a12891dd7bc9cd$exports.default = void 0;

var $40a12891dd7bc9cd$var$_react = $40a12891dd7bc9cd$var$_interopRequireDefault((parcelRequire("acw62")));

var $40a12891dd7bc9cd$var$_UNSAFE_baseNew = $40a12891dd7bc9cd$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $40a12891dd7bc9cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40a12891dd7bc9cd$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $40a12891dd7bc9cd$var$_react.default.createElement($40a12891dd7bc9cd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 1.75H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h2.75m0-12.5H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4.75m0-12.5v12.5M11 5.5 8.5 8l2.5 2.5"/>`
    }, props));
$40a12891dd7bc9cd$var$SidebarCollapseIcon.displayName = "SidebarCollapseIcon";
var $40a12891dd7bc9cd$var$_default = $40a12891dd7bc9cd$exports.default = $40a12891dd7bc9cd$var$SidebarCollapseIcon;


var $ad53fcc10ddf64e0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67bd8e50f260741b99439472e94111fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($ad53fcc10ddf64e0$exports, "__esModule", {
    value: true
});
$ad53fcc10ddf64e0$exports.default = void 0;

var $ad53fcc10ddf64e0$var$_react = $ad53fcc10ddf64e0$var$_interopRequireDefault((parcelRequire("acw62")));

var $ad53fcc10ddf64e0$var$_UNSAFE_baseNew = $ad53fcc10ddf64e0$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $ad53fcc10ddf64e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad53fcc10ddf64e0$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $ad53fcc10ddf64e0$var$_react.default.createElement($ad53fcc10ddf64e0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 1.75H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-2.75m0-12.5H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h9.25m0-12.5v12.5M5 5.5 7.5 8 5 10.5"/>`
    }, props));
$ad53fcc10ddf64e0$var$SidebarExpandIcon.displayName = "SidebarExpandIcon";
var $ad53fcc10ddf64e0$var$_default = $ad53fcc10ddf64e0$exports.default = $ad53fcc10ddf64e0$var$SidebarExpandIcon;


var $8ba342f149c37c37$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4906a52ca50c71ce3e4b4da49e7ade3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8ba342f149c37c37$exports, "__esModule", {
    value: true
});
$8ba342f149c37c37$exports.default = void 0;

var $8ba342f149c37c37$var$_react = $8ba342f149c37c37$var$_interopRequireDefault((parcelRequire("acw62")));

var $8ba342f149c37c37$var$_UNSAFE_baseNew = $8ba342f149c37c37$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $8ba342f149c37c37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ba342f149c37c37$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $8ba342f149c37c37$var$_react.default.createElement($8ba342f149c37c37$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.993 9.24c-1.586.69-3.176 2.118-3.176 4.234 0 1.057-4.202 1.586-2.086-3.702-1.058.475-4.98 1.747-4.98-.897 0-3.173-.25-6.346 3.98-6.346 2.453 0 4.06 0 6.036 1.267m0 0A1.25 1.25 0 0 1 12 2.75h2c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25V4q0-.105.017-.204Z"/>`
    }, props));
$8ba342f149c37c37$var$ThumbsDownIcon.displayName = "ThumbsDownIcon";
var $8ba342f149c37c37$var$_default = $8ba342f149c37c37$exports.default = $8ba342f149c37c37$var$ThumbsDownIcon;


var $66bb4267eaa8b347$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6198fed855ec7c0bf831f638e93e94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($66bb4267eaa8b347$exports, "__esModule", {
    value: true
});
$66bb4267eaa8b347$exports.default = void 0;

var $66bb4267eaa8b347$var$_react = $66bb4267eaa8b347$var$_interopRequireDefault((parcelRequire("acw62")));

var $66bb4267eaa8b347$var$_UNSAFE_baseNew = $66bb4267eaa8b347$var$_interopRequireDefault((parcelRequire("j9ueQ")));
function $66bb4267eaa8b347$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66bb4267eaa8b347$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $66bb4267eaa8b347$var$_react.default.createElement($66bb4267eaa8b347$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.007 6.76c1.586-.69 3.176-2.117 3.176-4.233 0-1.057 4.202-1.586 2.086 3.702 1.058-.475 4.981-1.747 4.981.897 0 3.173-.25 6.346-4.48 6.346-2.454 0-3.561 0-5.537-1.267m0 0A1.25 1.25 0 0 1 4 13.251H2c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v4.5q0 .105-.017.204Z"/>`
    }, props));
$66bb4267eaa8b347$var$ThumbsUpIcon.displayName = "ThumbsUpIcon";
var $66bb4267eaa8b347$var$_default = $66bb4267eaa8b347$exports.default = $66bb4267eaa8b347$var$ThumbsUpIcon;


var $b932394ef8ad724b$exports = {};
"use strict";
Object.defineProperty($b932394ef8ad724b$exports, "__esModule", {
    value: true
});
$b932394ef8ad724b$exports.default = void 0;

var $b932394ef8ad724b$var$_react = $b932394ef8ad724b$var$_interopRequireDefault((parcelRequire("acw62")));


var $b932394ef8ad724b$var$_add = $b932394ef8ad724b$var$_interopRequireDefault((parcelRequire("jnEWh")));
function $b932394ef8ad724b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b932394ef8ad724b$var$AddIcon = (props)=>/*#__PURE__*/ $b932394ef8ad724b$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $b932394ef8ad724b$var$_add.default
    }));
$b932394ef8ad724b$var$AddIcon.displayName = "AddIcon";
var $b932394ef8ad724b$var$_default = $b932394ef8ad724b$exports.default = $b932394ef8ad724b$var$AddIcon;


var $9ef8ab13acd96de1$exports = {};
"use strict";
Object.defineProperty($9ef8ab13acd96de1$exports, "__esModule", {
    value: true
});
$9ef8ab13acd96de1$exports.default = void 0;

var $9ef8ab13acd96de1$var$_react = $9ef8ab13acd96de1$var$_interopRequireDefault((parcelRequire("acw62")));


var $9ef8ab13acd96de1$var$_add = $9ef8ab13acd96de1$var$_interopRequireDefault((parcelRequire("jnEWh")));
function $9ef8ab13acd96de1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9ef8ab13acd96de1$var$AddCircleIcon = (props)=>/*#__PURE__*/ $9ef8ab13acd96de1$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $9ef8ab13acd96de1$var$_add.default
    }));
$9ef8ab13acd96de1$var$AddCircleIcon.displayName = "AddCircleIcon";
var $9ef8ab13acd96de1$var$_default = $9ef8ab13acd96de1$exports.default = $9ef8ab13acd96de1$var$AddCircleIcon;


var $dde75f56c579d288$exports = {};
"use strict";
Object.defineProperty($dde75f56c579d288$exports, "__esModule", {
    value: true
});
$dde75f56c579d288$exports.default = void 0;

var $dde75f56c579d288$var$_react = $dde75f56c579d288$var$_interopRequireDefault((parcelRequire("acw62")));


var $dde75f56c579d288$var$_arrowLeft = $dde75f56c579d288$var$_interopRequireDefault((parcelRequire("5kCbU")));
function $dde75f56c579d288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dde75f56c579d288$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $dde75f56c579d288$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $dde75f56c579d288$var$_arrowLeft.default
    }));
$dde75f56c579d288$var$ArrowLeftCircleIcon.displayName = "ArrowLeftCircleIcon";
var $dde75f56c579d288$var$_default = $dde75f56c579d288$exports.default = $dde75f56c579d288$var$ArrowLeftCircleIcon;


var $cfa4544cde9f0d6d$exports = {};
"use strict";
Object.defineProperty($cfa4544cde9f0d6d$exports, "__esModule", {
    value: true
});
$cfa4544cde9f0d6d$exports.default = void 0;

var $cfa4544cde9f0d6d$var$_react = $cfa4544cde9f0d6d$var$_interopRequireDefault((parcelRequire("acw62")));


var $cfa4544cde9f0d6d$var$_arrowRight = $cfa4544cde9f0d6d$var$_interopRequireDefault((parcelRequire("ePDXu")));
function $cfa4544cde9f0d6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cfa4544cde9f0d6d$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $cfa4544cde9f0d6d$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $cfa4544cde9f0d6d$var$_arrowRight.default
    }));
$cfa4544cde9f0d6d$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $cfa4544cde9f0d6d$var$_default = $cfa4544cde9f0d6d$exports.default = $cfa4544cde9f0d6d$var$ArrowRightIcon;


var $beffee6644bfbb75$exports = {};
"use strict";
Object.defineProperty($beffee6644bfbb75$exports, "__esModule", {
    value: true
});
$beffee6644bfbb75$exports.default = void 0;

var $beffee6644bfbb75$var$_react = $beffee6644bfbb75$var$_interopRequireDefault((parcelRequire("acw62")));


var $beffee6644bfbb75$var$_arrowRight = $beffee6644bfbb75$var$_interopRequireDefault((parcelRequire("ePDXu")));
function $beffee6644bfbb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $beffee6644bfbb75$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $beffee6644bfbb75$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $beffee6644bfbb75$var$_arrowRight.default
    }));
$beffee6644bfbb75$var$ArrowRightCircleIcon.displayName = "ArrowRightCircleIcon";
var $beffee6644bfbb75$var$_default = $beffee6644bfbb75$exports.default = $beffee6644bfbb75$var$ArrowRightCircleIcon;


var $b41eaaa0443252ca$exports = {};
"use strict";
Object.defineProperty($b41eaaa0443252ca$exports, "__esModule", {
    value: true
});
$b41eaaa0443252ca$exports.default = void 0;

var $b41eaaa0443252ca$var$_react = $b41eaaa0443252ca$var$_interopRequireDefault((parcelRequire("acw62")));


var $b41eaaa0443252ca$var$_arrowUp = $b41eaaa0443252ca$var$_interopRequireDefault((parcelRequire("3jPeh")));
function $b41eaaa0443252ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b41eaaa0443252ca$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $b41eaaa0443252ca$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $b41eaaa0443252ca$var$_arrowUp.default
    }));
$b41eaaa0443252ca$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $b41eaaa0443252ca$var$_default = $b41eaaa0443252ca$exports.default = $b41eaaa0443252ca$var$ArrowUpIcon;


var $1f40d9aadfb38c92$exports = {};
"use strict";
Object.defineProperty($1f40d9aadfb38c92$exports, "__esModule", {
    value: true
});
$1f40d9aadfb38c92$exports.default = void 0;

var $1f40d9aadfb38c92$var$_react = $1f40d9aadfb38c92$var$_interopRequireDefault((parcelRequire("acw62")));


var $1f40d9aadfb38c92$var$_arrowUp = $1f40d9aadfb38c92$var$_interopRequireDefault((parcelRequire("3jPeh")));
function $1f40d9aadfb38c92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f40d9aadfb38c92$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $1f40d9aadfb38c92$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
    }, props, {
        newIcon: $1f40d9aadfb38c92$var$_arrowUp.default
    }));
$1f40d9aadfb38c92$var$ArrowUpCircleIcon.displayName = "ArrowUpCircleIcon";
var $1f40d9aadfb38c92$var$_default = $1f40d9aadfb38c92$exports.default = $1f40d9aadfb38c92$var$ArrowUpCircleIcon;


var $9f6b1d4c229de4ab$exports = {};
"use strict";
Object.defineProperty($9f6b1d4c229de4ab$exports, "__esModule", {
    value: true
});
$9f6b1d4c229de4ab$exports.default = void 0;

var $9f6b1d4c229de4ab$var$_react = $9f6b1d4c229de4ab$var$_interopRequireDefault((parcelRequire("acw62")));

function $9f6b1d4c229de4ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f6b1d4c229de4ab$var$BitbucketBuildsIcon = (props)=>/*#__PURE__*/ $9f6b1d4c229de4ab$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 5a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1M8 5c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3"/><path d="M16.06 6h2.42c.81 0 1.47.66 1.47 1.47v1.95c0 .82-.65 1.47-1.47 1.47H16v2h2.47a3.47 3.47 0 0 0 3.48-3.47V7.47A3.47 3.47 0 0 0 18.48 4h-2.41zm-7.17 5H6.47A3.47 3.47 0 0 0 3 14.47v1.95c0 1.92 1.55 3.47 3.47 3.47h2.48v-2H6.47c-.82 0-1.47-.65-1.47-1.47v-1.95c0-.81.66-1.47 1.47-1.47h2.42z"/></g></svg>`
    }, props));
$9f6b1d4c229de4ab$var$BitbucketBuildsIcon.displayName = "BitbucketBuildsIcon";
var $9f6b1d4c229de4ab$var$_default = $9f6b1d4c229de4ab$exports.default = $9f6b1d4c229de4ab$var$BitbucketBuildsIcon;


var $72805e1b70ee4b7c$exports = {};
"use strict";
Object.defineProperty($72805e1b70ee4b7c$exports, "__esModule", {
    value: true
});
$72805e1b70ee4b7c$exports.default = void 0;

var $72805e1b70ee4b7c$var$_react = $72805e1b70ee4b7c$var$_interopRequireDefault((parcelRequire("acw62")));


var $72805e1b70ee4b7c$var$_checkMark = $72805e1b70ee4b7c$var$_interopRequireDefault((parcelRequire("eIST3")));
function $72805e1b70ee4b7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $72805e1b70ee4b7c$var$CheckIcon = (props)=>/*#__PURE__*/ $72805e1b70ee4b7c$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $72805e1b70ee4b7c$var$_checkMark.default
    }));
$72805e1b70ee4b7c$var$CheckIcon.displayName = "CheckIcon";
var $72805e1b70ee4b7c$var$_default = $72805e1b70ee4b7c$exports.default = $72805e1b70ee4b7c$var$CheckIcon;


var $eaf524c5b400049f$exports = {};
"use strict";
Object.defineProperty($eaf524c5b400049f$exports, "__esModule", {
    value: true
});
$eaf524c5b400049f$exports.default = void 0;

var $eaf524c5b400049f$var$_react = $eaf524c5b400049f$var$_interopRequireDefault((parcelRequire("acw62")));


var $eaf524c5b400049f$var$_success = $eaf524c5b400049f$var$_interopRequireDefault((parcelRequire("k08bI")));
function $eaf524c5b400049f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eaf524c5b400049f$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $eaf524c5b400049f$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $eaf524c5b400049f$var$_success.default
    }));
$eaf524c5b400049f$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $eaf524c5b400049f$var$_default = $eaf524c5b400049f$exports.default = $eaf524c5b400049f$var$CheckCircleIcon;


var $233df463ce9525bc$exports = {};
"use strict";
Object.defineProperty($233df463ce9525bc$exports, "__esModule", {
    value: true
});
$233df463ce9525bc$exports.default = void 0;

var $233df463ce9525bc$var$_react = $233df463ce9525bc$var$_interopRequireDefault((parcelRequire("acw62")));


var $233df463ce9525bc$var$_checkCircle = $233df463ce9525bc$var$_interopRequireDefault((parcelRequire("9H17v")));
function $233df463ce9525bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $233df463ce9525bc$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $233df463ce9525bc$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $233df463ce9525bc$var$_checkCircle.default
    }));
$233df463ce9525bc$var$CheckCircleOutlineIcon.displayName = "CheckCircleOutlineIcon";
var $233df463ce9525bc$var$_default = $233df463ce9525bc$exports.default = $233df463ce9525bc$var$CheckCircleOutlineIcon;


var $a3062bb40e0ac5b8$exports = {};
"use strict";
Object.defineProperty($a3062bb40e0ac5b8$exports, "__esModule", {
    value: true
});
$a3062bb40e0ac5b8$exports.default = void 0;

var $a3062bb40e0ac5b8$var$_react = $a3062bb40e0ac5b8$var$_interopRequireDefault((parcelRequire("acw62")));


var $a3062bb40e0ac5b8$var$_chevronDown = $a3062bb40e0ac5b8$var$_interopRequireDefault((parcelRequire("dSnoq")));
function $a3062bb40e0ac5b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a3062bb40e0ac5b8$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a3062bb40e0ac5b8$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $a3062bb40e0ac5b8$var$_chevronDown.default,
        iconType: "utility"
    }));
$a3062bb40e0ac5b8$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $a3062bb40e0ac5b8$var$_default = $a3062bb40e0ac5b8$exports.default = $a3062bb40e0ac5b8$var$ChevronDownIcon;


var $4e0d3392bc0b63e0$exports = {};
"use strict";
Object.defineProperty($4e0d3392bc0b63e0$exports, "__esModule", {
    value: true
});
$4e0d3392bc0b63e0$exports.default = void 0;

var $4e0d3392bc0b63e0$var$_react = $4e0d3392bc0b63e0$var$_interopRequireDefault((parcelRequire("acw62")));


var $4e0d3392bc0b63e0$var$_chevronDown = $4e0d3392bc0b63e0$var$_interopRequireDefault((parcelRequire("dSnoq")));
function $4e0d3392bc0b63e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4e0d3392bc0b63e0$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $4e0d3392bc0b63e0$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $4e0d3392bc0b63e0$var$_chevronDown.default,
        iconType: "utility"
    }));
$4e0d3392bc0b63e0$var$ChevronDownCircleIcon.displayName = "ChevronDownCircleIcon";
var $4e0d3392bc0b63e0$var$_default = $4e0d3392bc0b63e0$exports.default = $4e0d3392bc0b63e0$var$ChevronDownCircleIcon;


var $4a0a0d05cb5ada88$exports = {};
"use strict";
Object.defineProperty($4a0a0d05cb5ada88$exports, "__esModule", {
    value: true
});
$4a0a0d05cb5ada88$exports.default = void 0;

var $4a0a0d05cb5ada88$var$_react = $4a0a0d05cb5ada88$var$_interopRequireDefault((parcelRequire("acw62")));


var $4a0a0d05cb5ada88$var$_chevronLeft = $4a0a0d05cb5ada88$var$_interopRequireDefault((parcelRequire("3gck4")));
function $4a0a0d05cb5ada88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4a0a0d05cb5ada88$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $4a0a0d05cb5ada88$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $4a0a0d05cb5ada88$var$_chevronLeft.default,
        iconType: "utility"
    }));
$4a0a0d05cb5ada88$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $4a0a0d05cb5ada88$var$_default = $4a0a0d05cb5ada88$exports.default = $4a0a0d05cb5ada88$var$ChevronLeftIcon;


var $0866a766b9fa65fb$exports = {};
"use strict";
Object.defineProperty($0866a766b9fa65fb$exports, "__esModule", {
    value: true
});
$0866a766b9fa65fb$exports.default = void 0;

var $0866a766b9fa65fb$var$_react = $0866a766b9fa65fb$var$_interopRequireDefault((parcelRequire("acw62")));


var $0866a766b9fa65fb$var$_chevronLeft = $0866a766b9fa65fb$var$_interopRequireDefault((parcelRequire("3gck4")));
function $0866a766b9fa65fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0866a766b9fa65fb$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $0866a766b9fa65fb$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $0866a766b9fa65fb$var$_chevronLeft.default,
        iconType: "utility"
    }));
$0866a766b9fa65fb$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $0866a766b9fa65fb$var$_default = $0866a766b9fa65fb$exports.default = $0866a766b9fa65fb$var$ChevronLeftLargeIcon;


var $2a4facccadb10e11$exports = {};
"use strict";
Object.defineProperty($2a4facccadb10e11$exports, "__esModule", {
    value: true
});
$2a4facccadb10e11$exports.default = void 0;

var $2a4facccadb10e11$var$_react = $2a4facccadb10e11$var$_interopRequireDefault((parcelRequire("acw62")));


var $2a4facccadb10e11$var$_chevronRight = $2a4facccadb10e11$var$_interopRequireDefault((parcelRequire("cLpFk")));
function $2a4facccadb10e11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2a4facccadb10e11$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $2a4facccadb10e11$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $2a4facccadb10e11$var$_chevronRight.default,
        iconType: "utility"
    }));
$2a4facccadb10e11$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $2a4facccadb10e11$var$_default = $2a4facccadb10e11$exports.default = $2a4facccadb10e11$var$ChevronRightIcon;


var $e0881f5dbdc2ce2b$exports = {};
"use strict";
Object.defineProperty($e0881f5dbdc2ce2b$exports, "__esModule", {
    value: true
});
$e0881f5dbdc2ce2b$exports.default = void 0;

var $e0881f5dbdc2ce2b$var$_react = $e0881f5dbdc2ce2b$var$_interopRequireDefault((parcelRequire("acw62")));


var $e0881f5dbdc2ce2b$var$_chevronUp = $e0881f5dbdc2ce2b$var$_interopRequireDefault((parcelRequire("1ZV7N")));
function $e0881f5dbdc2ce2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e0881f5dbdc2ce2b$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $e0881f5dbdc2ce2b$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $e0881f5dbdc2ce2b$var$_chevronUp.default,
        iconType: "utility"
    }));
$e0881f5dbdc2ce2b$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $e0881f5dbdc2ce2b$var$_default = $e0881f5dbdc2ce2b$exports.default = $e0881f5dbdc2ce2b$var$ChevronUpIcon;


var $c39fd8ad171ba397$exports = {};
"use strict";
Object.defineProperty($c39fd8ad171ba397$exports, "__esModule", {
    value: true
});
$c39fd8ad171ba397$exports.default = void 0;

var $c39fd8ad171ba397$var$_react = $c39fd8ad171ba397$var$_interopRequireDefault((parcelRequire("acw62")));


var $c39fd8ad171ba397$var$_copy = $c39fd8ad171ba397$var$_interopRequireDefault((parcelRequire("foaze")));
function $c39fd8ad171ba397$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c39fd8ad171ba397$var$CopyIcon = (props)=>/*#__PURE__*/ $c39fd8ad171ba397$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $c39fd8ad171ba397$var$_copy.default
    }));
$c39fd8ad171ba397$var$CopyIcon.displayName = "CopyIcon";
var $c39fd8ad171ba397$var$_default = $c39fd8ad171ba397$exports.default = $c39fd8ad171ba397$var$CopyIcon;


var $a7f33bb0aed3b6ad$exports = {};
"use strict";
Object.defineProperty($a7f33bb0aed3b6ad$exports, "__esModule", {
    value: true
});
$a7f33bb0aed3b6ad$exports.default = void 0;

var $a7f33bb0aed3b6ad$var$_react = $a7f33bb0aed3b6ad$var$_interopRequireDefault((parcelRequire("acw62")));


var $a7f33bb0aed3b6ad$var$_download = $a7f33bb0aed3b6ad$var$_interopRequireDefault((parcelRequire("aKcQU")));
function $a7f33bb0aed3b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a7f33bb0aed3b6ad$var$DownloadIcon = (props)=>/*#__PURE__*/ $a7f33bb0aed3b6ad$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $a7f33bb0aed3b6ad$var$_download.default
    }));
$a7f33bb0aed3b6ad$var$DownloadIcon.displayName = "DownloadIcon";
var $a7f33bb0aed3b6ad$var$_default = $a7f33bb0aed3b6ad$exports.default = $a7f33bb0aed3b6ad$var$DownloadIcon;


var $be5e590a0b97263b$exports = {};
"use strict";
Object.defineProperty($be5e590a0b97263b$exports, "__esModule", {
    value: true
});
$be5e590a0b97263b$exports.default = void 0;

var $be5e590a0b97263b$var$_react = $be5e590a0b97263b$var$_interopRequireDefault((parcelRequire("acw62")));


var $be5e590a0b97263b$var$_edit = $be5e590a0b97263b$var$_interopRequireDefault((parcelRequire("kW30k")));
function $be5e590a0b97263b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be5e590a0b97263b$var$EditIcon = (props)=>/*#__PURE__*/ $be5e590a0b97263b$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $be5e590a0b97263b$var$_edit.default
    }));
$be5e590a0b97263b$var$EditIcon.displayName = "EditIcon";
var $be5e590a0b97263b$var$_default = $be5e590a0b97263b$exports.default = $be5e590a0b97263b$var$EditIcon;


var $6892adb592af984b$exports = {};
"use strict";
Object.defineProperty($6892adb592af984b$exports, "__esModule", {
    value: true
});
$6892adb592af984b$exports.default = void 0;

var $6892adb592af984b$var$_react = $6892adb592af984b$var$_interopRequireDefault((parcelRequire("acw62")));


var $6892adb592af984b$var$_edit = $6892adb592af984b$var$_interopRequireDefault((parcelRequire("kW30k")));
function $6892adb592af984b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6892adb592af984b$var$EditFilledIcon = (props)=>/*#__PURE__*/ $6892adb592af984b$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $6892adb592af984b$var$_edit.default
    }));
$6892adb592af984b$var$EditFilledIcon.displayName = "EditFilledIcon";
var $6892adb592af984b$var$_default = $6892adb592af984b$exports.default = $6892adb592af984b$var$EditFilledIcon;


var $d1bbaedeec8ea759$exports = {};
"use strict";
Object.defineProperty($d1bbaedeec8ea759$exports, "__esModule", {
    value: true
});
$d1bbaedeec8ea759$exports.default = void 0;

var $d1bbaedeec8ea759$var$_react = $d1bbaedeec8ea759$var$_interopRequireDefault((parcelRequire("acw62")));


var $d1bbaedeec8ea759$var$_close = $d1bbaedeec8ea759$var$_interopRequireDefault((parcelRequire("11P39")));
function $d1bbaedeec8ea759$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d1bbaedeec8ea759$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $d1bbaedeec8ea759$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $d1bbaedeec8ea759$var$_close.default
    }));
$d1bbaedeec8ea759$var$EditorCloseIcon.displayName = "EditorCloseIcon";
var $d1bbaedeec8ea759$var$_default = $d1bbaedeec8ea759$exports.default = $d1bbaedeec8ea759$var$EditorCloseIcon;


var $0fe96ae52df99a15$exports = {};
"use strict";
Object.defineProperty($0fe96ae52df99a15$exports, "__esModule", {
    value: true
});
$0fe96ae52df99a15$exports.default = void 0;

var $0fe96ae52df99a15$var$_react = $0fe96ae52df99a15$var$_interopRequireDefault((parcelRequire("acw62")));


var $0fe96ae52df99a15$var$_contentWrapRight = $0fe96ae52df99a15$var$_interopRequireDefault((parcelRequire("1LQ8Q")));
function $0fe96ae52df99a15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0fe96ae52df99a15$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $0fe96ae52df99a15$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $0fe96ae52df99a15$var$_contentWrapRight.default
    }));
$0fe96ae52df99a15$var$EditorMediaWrapRightIcon.displayName = "EditorMediaWrapRightIcon";
var $0fe96ae52df99a15$var$_default = $0fe96ae52df99a15$exports.default = $0fe96ae52df99a15$var$EditorMediaWrapRightIcon;


var $210b73e2393383f6$exports = {};
"use strict";
Object.defineProperty($210b73e2393383f6$exports, "__esModule", {
    value: true
});
$210b73e2393383f6$exports.default = void 0;

var $210b73e2393383f6$var$_react = $210b73e2393383f6$var$_interopRequireDefault((parcelRequire("acw62")));


var $210b73e2393383f6$var$_arrowUpRight = $210b73e2393383f6$var$_interopRequireDefault((parcelRequire("gaDMh")));
function $210b73e2393383f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $210b73e2393383f6$var$EditorOpenIcon = (props)=>/*#__PURE__*/ $210b73e2393383f6$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.873 7.63c-.28 0-.344.159-.147.357l2.436 2.436-4.386 4.386a.51.51 0 0 0 0 .713l.7.7a.495.495 0 0 0 .713.001l4.387-4.386 2.436 2.436c.197.197.357.124.357-.147V8.133a.507.507 0 0 0-.503-.503z"/></svg>`
    }, props, {
        newIcon: $210b73e2393383f6$var$_arrowUpRight.default
    }));
$210b73e2393383f6$var$EditorOpenIcon.displayName = "EditorOpenIcon";
var $210b73e2393383f6$var$_default = $210b73e2393383f6$exports.default = $210b73e2393383f6$var$EditorOpenIcon;


var $72d0253bb5975c99$exports = {};
"use strict";
Object.defineProperty($72d0253bb5975c99$exports, "__esModule", {
    value: true
});
$72d0253bb5975c99$exports.default = void 0;

var $72d0253bb5975c99$var$_react = $72d0253bb5975c99$var$_interopRequireDefault((parcelRequire("acw62")));


var $72d0253bb5975c99$var$_information = $72d0253bb5975c99$var$_interopRequireDefault((parcelRequire("kjbKN")));
function $72d0253bb5975c99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $72d0253bb5975c99$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $72d0253bb5975c99$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $72d0253bb5975c99$var$_information.default
    }));
$72d0253bb5975c99$var$EditorPanelIcon.displayName = "EditorPanelIcon";
var $72d0253bb5975c99$var$_default = $72d0253bb5975c99$exports.default = $72d0253bb5975c99$var$EditorPanelIcon;


var $6719c1cdf1c67024$exports = {};
"use strict";
Object.defineProperty($6719c1cdf1c67024$exports, "__esModule", {
    value: true
});
$6719c1cdf1c67024$exports.default = void 0;

var $6719c1cdf1c67024$var$_react = $6719c1cdf1c67024$var$_interopRequireDefault((parcelRequire("acw62")));


var $6719c1cdf1c67024$var$_grid = $6719c1cdf1c67024$var$_interopRequireDefault((parcelRequire("9ttUk")));
function $6719c1cdf1c67024$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6719c1cdf1c67024$var$EditorTableIcon = (props)=>/*#__PURE__*/ $6719c1cdf1c67024$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $6719c1cdf1c67024$var$_grid.default
    }));
$6719c1cdf1c67024$var$EditorTableIcon.displayName = "EditorTableIcon";
var $6719c1cdf1c67024$var$_default = $6719c1cdf1c67024$exports.default = $6719c1cdf1c67024$var$EditorTableIcon;


var $c2fc273fd8eb0796$exports = {};
"use strict";
Object.defineProperty($c2fc273fd8eb0796$exports, "__esModule", {
    value: true
});
$c2fc273fd8eb0796$exports.default = void 0;

var $c2fc273fd8eb0796$var$_react = $c2fc273fd8eb0796$var$_interopRequireDefault((parcelRequire("acw62")));

function $c2fc273fd8eb0796$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c2fc273fd8eb0796$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $c2fc273fd8eb0796$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$c2fc273fd8eb0796$var$EmojiAtlassianIcon.displayName = "EmojiAtlassianIcon";
var $c2fc273fd8eb0796$var$_default = $c2fc273fd8eb0796$exports.default = $c2fc273fd8eb0796$var$EmojiAtlassianIcon;


var $2f3e0a57a89e363c$exports = {};
"use strict";
Object.defineProperty($2f3e0a57a89e363c$exports, "__esModule", {
    value: true
});
$2f3e0a57a89e363c$exports.default = void 0;

var $2f3e0a57a89e363c$var$_react = $2f3e0a57a89e363c$var$_interopRequireDefault((parcelRequire("acw62")));


var $2f3e0a57a89e363c$var$_clock = $2f3e0a57a89e363c$var$_interopRequireDefault((parcelRequire("ddr8b")));
function $2f3e0a57a89e363c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f3e0a57a89e363c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $2f3e0a57a89e363c$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $2f3e0a57a89e363c$var$_clock.default
    }));
$2f3e0a57a89e363c$var$EmojiFrequentIcon.displayName = "EmojiFrequentIcon";
var $2f3e0a57a89e363c$var$_default = $2f3e0a57a89e363c$exports.default = $2f3e0a57a89e363c$var$EmojiFrequentIcon;


var $fb0ec5a882684bce$exports = {};
"use strict";
Object.defineProperty($fb0ec5a882684bce$exports, "__esModule", {
    value: true
});
$fb0ec5a882684bce$exports.default = void 0;

var $fb0ec5a882684bce$var$_react = $fb0ec5a882684bce$var$_interopRequireDefault((parcelRequire("acw62")));


var $fb0ec5a882684bce$var$_heart = $fb0ec5a882684bce$var$_interopRequireDefault((parcelRequire("4OiYq")));
function $fb0ec5a882684bce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb0ec5a882684bce$var$EmojiSymbolsIcon = (props)=>/*#__PURE__*/ $fb0ec5a882684bce$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12 9.44 1.76-1.744a2.505 2.505 0 0 1 3.52 0 2.45 2.45 0 0 1 0 3.488L12 16.417l-5.28-5.232a2.45 2.45 0 0 1 0-3.49 2.505 2.505 0 0 1 3.52 0v.001zm-6.684 3.143.003.004 6.322 6.266a.51.51 0 0 0 .718 0l6.322-6.266.003-.004.004-.003a4.41 4.41 0 0 0 0-6.28 4.51 4.51 0 0 0-6.336 0l-.003.004-.004.003L12 6.65l-.345-.342-.004-.003-.003-.003a4.51 4.51 0 0 0-6.336 0 4.41 4.41 0 0 0 0 6.279z"/></svg>`
    }, props, {
        newIcon: $fb0ec5a882684bce$var$_heart.default
    }));
$fb0ec5a882684bce$var$EmojiSymbolsIcon.displayName = "EmojiSymbolsIcon";
var $fb0ec5a882684bce$var$_default = $fb0ec5a882684bce$exports.default = $fb0ec5a882684bce$var$EmojiSymbolsIcon;


var $acfd7a32d0c9dc49$exports = {};
"use strict";
Object.defineProperty($acfd7a32d0c9dc49$exports, "__esModule", {
    value: true
});
$acfd7a32d0c9dc49$exports.default = void 0;

var $acfd7a32d0c9dc49$var$_react = $acfd7a32d0c9dc49$var$_interopRequireDefault((parcelRequire("acw62")));


var $acfd7a32d0c9dc49$var$_error = $acfd7a32d0c9dc49$var$_interopRequireDefault((parcelRequire("au6Na")));
function $acfd7a32d0c9dc49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acfd7a32d0c9dc49$var$ErrorIcon = (props)=>/*#__PURE__*/ $acfd7a32d0c9dc49$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $acfd7a32d0c9dc49$var$_error.default
    }));
$acfd7a32d0c9dc49$var$ErrorIcon.displayName = "ErrorIcon";
var $acfd7a32d0c9dc49$var$_default = $acfd7a32d0c9dc49$exports.default = $acfd7a32d0c9dc49$var$ErrorIcon;


var $fa6c001ff71fe7d5$exports = {};
"use strict";
Object.defineProperty($fa6c001ff71fe7d5$exports, "__esModule", {
    value: true
});
$fa6c001ff71fe7d5$exports.default = void 0;

var $fa6c001ff71fe7d5$var$_react = $fa6c001ff71fe7d5$var$_interopRequireDefault((parcelRequire("acw62")));


var $fa6c001ff71fe7d5$var$_upload = $fa6c001ff71fe7d5$var$_interopRequireDefault((parcelRequire("8ubK2")));
function $fa6c001ff71fe7d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa6c001ff71fe7d5$var$ExportIcon = (props)=>/*#__PURE__*/ $fa6c001ff71fe7d5$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $fa6c001ff71fe7d5$var$_upload.default
    }));
$fa6c001ff71fe7d5$var$ExportIcon.displayName = "ExportIcon";
var $fa6c001ff71fe7d5$var$_default = $fa6c001ff71fe7d5$exports.default = $fa6c001ff71fe7d5$var$ExportIcon;


var $7a7616abae5178e5$exports = {};
"use strict";
Object.defineProperty($7a7616abae5178e5$exports, "__esModule", {
    value: true
});
$7a7616abae5178e5$exports.default = void 0;

var $7a7616abae5178e5$var$_react = $7a7616abae5178e5$var$_interopRequireDefault((parcelRequire("acw62")));


var $7a7616abae5178e5$var$_filter = $7a7616abae5178e5$var$_interopRequireDefault((parcelRequire("7IcEl")));
function $7a7616abae5178e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a7616abae5178e5$var$FilterIcon = (props)=>/*#__PURE__*/ $7a7616abae5178e5$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $7a7616abae5178e5$var$_filter.default
    }));
$7a7616abae5178e5$var$FilterIcon.displayName = "FilterIcon";
var $7a7616abae5178e5$var$_default = $7a7616abae5178e5$exports.default = $7a7616abae5178e5$var$FilterIcon;


var $fecfafd3ba8ed3dd$exports = {};
"use strict";
Object.defineProperty($fecfafd3ba8ed3dd$exports, "__esModule", {
    value: true
});
$fecfafd3ba8ed3dd$exports.default = void 0;

var $fecfafd3ba8ed3dd$var$_react = $fecfafd3ba8ed3dd$var$_interopRequireDefault((parcelRequire("acw62")));


var $fecfafd3ba8ed3dd$var$_chevronDown = $fecfafd3ba8ed3dd$var$_interopRequireDefault((parcelRequire("dSnoq")));
function $fecfafd3ba8ed3dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fecfafd3ba8ed3dd$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $fecfafd3ba8ed3dd$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $fecfafd3ba8ed3dd$var$_chevronDown.default,
        iconType: "utility"
    }));
$fecfafd3ba8ed3dd$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $fecfafd3ba8ed3dd$var$_default = $fecfafd3ba8ed3dd$exports.default = $fecfafd3ba8ed3dd$var$HipchatChevronDownIcon;


var $ae62f6b7dd7088cc$exports = {};
"use strict";
Object.defineProperty($ae62f6b7dd7088cc$exports, "__esModule", {
    value: true
});
$ae62f6b7dd7088cc$exports.default = void 0;

var $ae62f6b7dd7088cc$var$_react = $ae62f6b7dd7088cc$var$_interopRequireDefault((parcelRequire("acw62")));


var $ae62f6b7dd7088cc$var$_chevronUp = $ae62f6b7dd7088cc$var$_interopRequireDefault((parcelRequire("1ZV7N")));
function $ae62f6b7dd7088cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae62f6b7dd7088cc$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $ae62f6b7dd7088cc$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $ae62f6b7dd7088cc$var$_chevronUp.default,
        iconType: "utility"
    }));
$ae62f6b7dd7088cc$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $ae62f6b7dd7088cc$var$_default = $ae62f6b7dd7088cc$exports.default = $ae62f6b7dd7088cc$var$HipchatChevronUpIcon;


var $a20790a8c33090f5$exports = {};
"use strict";
Object.defineProperty($a20790a8c33090f5$exports, "__esModule", {
    value: true
});
$a20790a8c33090f5$exports.default = void 0;

var $a20790a8c33090f5$var$_react = $a20790a8c33090f5$var$_interopRequireDefault((parcelRequire("acw62")));


var $a20790a8c33090f5$var$_image = $a20790a8c33090f5$var$_interopRequireDefault((parcelRequire("1iipD")));
function $a20790a8c33090f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a20790a8c33090f5$var$ImageIcon = (props)=>/*#__PURE__*/ $a20790a8c33090f5$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $a20790a8c33090f5$var$_image.default
    }));
$a20790a8c33090f5$var$ImageIcon.displayName = "ImageIcon";
var $a20790a8c33090f5$var$_default = $a20790a8c33090f5$exports.default = $a20790a8c33090f5$var$ImageIcon;


var $bd769250eb2245bc$exports = {};
"use strict";
Object.defineProperty($bd769250eb2245bc$exports, "__esModule", {
    value: true
});
$bd769250eb2245bc$exports.default = void 0;

var $bd769250eb2245bc$var$_react = $bd769250eb2245bc$var$_interopRequireDefault((parcelRequire("acw62")));


var $bd769250eb2245bc$var$_information = $bd769250eb2245bc$var$_interopRequireDefault((parcelRequire("kjbKN")));
function $bd769250eb2245bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bd769250eb2245bc$var$InfoIcon = (props)=>/*#__PURE__*/ $bd769250eb2245bc$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $bd769250eb2245bc$var$_information.default
    }));
$bd769250eb2245bc$var$InfoIcon.displayName = "InfoIcon";
var $bd769250eb2245bc$var$_default = $bd769250eb2245bc$exports.default = $bd769250eb2245bc$var$InfoIcon;


var $511535d0df671f93$exports = {};
"use strict";
Object.defineProperty($511535d0df671f93$exports, "__esModule", {
    value: true
});
$511535d0df671f93$exports.default = void 0;

var $511535d0df671f93$var$_react = $511535d0df671f93$var$_interopRequireDefault((parcelRequire("acw62")));


var $511535d0df671f93$var$_link = $511535d0df671f93$var$_interopRequireDefault((parcelRequire("9si9u")));
function $511535d0df671f93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $511535d0df671f93$var$LinkIcon = (props)=>/*#__PURE__*/ $511535d0df671f93$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $511535d0df671f93$var$_link.default
    }));
$511535d0df671f93$var$LinkIcon.displayName = "LinkIcon";
var $511535d0df671f93$var$_default = $511535d0df671f93$exports.default = $511535d0df671f93$var$LinkIcon;


var $dad88ef40fe77ddb$exports = {};
"use strict";
Object.defineProperty($dad88ef40fe77ddb$exports, "__esModule", {
    value: true
});
$dad88ef40fe77ddb$exports.default = void 0;

var $dad88ef40fe77ddb$var$_react = $dad88ef40fe77ddb$var$_interopRequireDefault((parcelRequire("acw62")));


var $dad88ef40fe77ddb$var$_location = $dad88ef40fe77ddb$var$_interopRequireDefault((parcelRequire("lrwzu")));
function $dad88ef40fe77ddb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dad88ef40fe77ddb$var$LocationIcon = (props)=>/*#__PURE__*/ $dad88ef40fe77ddb$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $dad88ef40fe77ddb$var$_location.default
    }));
$dad88ef40fe77ddb$var$LocationIcon.displayName = "LocationIcon";
var $dad88ef40fe77ddb$var$_default = $dad88ef40fe77ddb$exports.default = $dad88ef40fe77ddb$var$LocationIcon;


var $ad9d696347fa2144$exports = {};
"use strict";
Object.defineProperty($ad9d696347fa2144$exports, "__esModule", {
    value: true
});
$ad9d696347fa2144$exports.default = void 0;

var $ad9d696347fa2144$var$_react = $ad9d696347fa2144$var$_interopRequireDefault((parcelRequire("acw62")));


var $ad9d696347fa2144$var$_zoomIn = $ad9d696347fa2144$var$_interopRequireDefault((parcelRequire("g8M0Q")));
function $ad9d696347fa2144$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ad9d696347fa2144$var$MediaServicesZoomInIcon = (props)=>/*#__PURE__*/ $ad9d696347fa2144$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2z"/></svg>`
    }, props, {
        newIcon: $ad9d696347fa2144$var$_zoomIn.default
    }));
$ad9d696347fa2144$var$MediaServicesZoomInIcon.displayName = "MediaServicesZoomInIcon";
var $ad9d696347fa2144$var$_default = $ad9d696347fa2144$exports.default = $ad9d696347fa2144$var$MediaServicesZoomInIcon;


var $e3ac338e8e8e25ef$exports = {};
"use strict";
Object.defineProperty($e3ac338e8e8e25ef$exports, "__esModule", {
    value: true
});
$e3ac338e8e8e25ef$exports.default = void 0;

var $e3ac338e8e8e25ef$var$_react = $e3ac338e8e8e25ef$var$_interopRequireDefault((parcelRequire("acw62")));


var $e3ac338e8e8e25ef$var$_zoomOut = $e3ac338e8e8e25ef$var$_interopRequireDefault((parcelRequire("8FjZq")));
function $e3ac338e8e8e25ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e3ac338e8e8e25ef$var$MediaServicesZoomOutIcon = (props)=>/*#__PURE__*/ $e3ac338e8e8e25ef$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $e3ac338e8e8e25ef$var$_zoomOut.default
    }));
$e3ac338e8e8e25ef$var$MediaServicesZoomOutIcon.displayName = "MediaServicesZoomOutIcon";
var $e3ac338e8e8e25ef$var$_default = $e3ac338e8e8e25ef$exports.default = $e3ac338e8e8e25ef$var$MediaServicesZoomOutIcon;


var $6ad5f2e289b76b76$exports = {};
"use strict";
Object.defineProperty($6ad5f2e289b76b76$exports, "__esModule", {
    value: true
});
$6ad5f2e289b76b76$exports.default = void 0;

var $6ad5f2e289b76b76$var$_react = $6ad5f2e289b76b76$var$_interopRequireDefault((parcelRequire("acw62")));


var $6ad5f2e289b76b76$var$_menu = $6ad5f2e289b76b76$var$_interopRequireDefault((parcelRequire("3RUVz")));
function $6ad5f2e289b76b76$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ad5f2e289b76b76$var$MenuIcon = (props)=>/*#__PURE__*/ $6ad5f2e289b76b76$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z"/></svg>`
    }, props, {
        newIcon: $6ad5f2e289b76b76$var$_menu.default
    }));
$6ad5f2e289b76b76$var$MenuIcon.displayName = "MenuIcon";
var $6ad5f2e289b76b76$var$_default = $6ad5f2e289b76b76$exports.default = $6ad5f2e289b76b76$var$MenuIcon;


var $d8410616b501ba4d$exports = {};
"use strict";
Object.defineProperty($d8410616b501ba4d$exports, "__esModule", {
    value: true
});
$d8410616b501ba4d$exports.default = void 0;

var $d8410616b501ba4d$var$_react = $d8410616b501ba4d$var$_interopRequireDefault((parcelRequire("acw62")));


var $d8410616b501ba4d$var$_showMoreVertical = $d8410616b501ba4d$var$_interopRequireDefault((parcelRequire("58lkt")));
function $d8410616b501ba4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8410616b501ba4d$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $d8410616b501ba4d$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $d8410616b501ba4d$var$_showMoreVertical.default
    }));
$d8410616b501ba4d$var$MoreVerticalIcon.displayName = "MoreVerticalIcon";
var $d8410616b501ba4d$var$_default = $d8410616b501ba4d$exports.default = $d8410616b501ba4d$var$MoreVerticalIcon;


var $7c7b494736d4cc5b$exports = {};
"use strict";
Object.defineProperty($7c7b494736d4cc5b$exports, "__esModule", {
    value: true
});
$7c7b494736d4cc5b$exports.default = void 0;

var $7c7b494736d4cc5b$var$_react = $7c7b494736d4cc5b$var$_interopRequireDefault((parcelRequire("acw62")));


var $7c7b494736d4cc5b$var$_alignLeft = $7c7b494736d4cc5b$var$_interopRequireDefault((parcelRequire("8TOG6")));
function $7c7b494736d4cc5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7c7b494736d4cc5b$var$OverviewIcon = (props)=>/*#__PURE__*/ $7c7b494736d4cc5b$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $7c7b494736d4cc5b$var$_alignLeft.default
    }));
$7c7b494736d4cc5b$var$OverviewIcon.displayName = "OverviewIcon";
var $7c7b494736d4cc5b$var$_default = $7c7b494736d4cc5b$exports.default = $7c7b494736d4cc5b$var$OverviewIcon;


var $4994ef50c21a890a$exports = {};
"use strict";
Object.defineProperty($4994ef50c21a890a$exports, "__esModule", {
    value: true
});
$4994ef50c21a890a$exports.default = void 0;

var $4994ef50c21a890a$var$_react = $4994ef50c21a890a$var$_interopRequireDefault((parcelRequire("acw62")));


var $4994ef50c21a890a$var$_questionCircle = $4994ef50c21a890a$var$_interopRequireDefault((parcelRequire("aS8XK")));
function $4994ef50c21a890a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4994ef50c21a890a$var$QuestionIcon = (props)=>/*#__PURE__*/ $4994ef50c21a890a$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $4994ef50c21a890a$var$_questionCircle.default
    }));
$4994ef50c21a890a$var$QuestionIcon.displayName = "QuestionIcon";
var $4994ef50c21a890a$var$_default = $4994ef50c21a890a$exports.default = $4994ef50c21a890a$var$QuestionIcon;


var $a95050abcaff2f05$exports = {};
"use strict";
Object.defineProperty($a95050abcaff2f05$exports, "__esModule", {
    value: true
});
$a95050abcaff2f05$exports.default = void 0;

var $a95050abcaff2f05$var$_react = $a95050abcaff2f05$var$_interopRequireDefault((parcelRequire("acw62")));


var $a95050abcaff2f05$var$_refresh = $a95050abcaff2f05$var$_interopRequireDefault((parcelRequire("eDEui")));
function $a95050abcaff2f05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a95050abcaff2f05$var$RefreshIcon = (props)=>/*#__PURE__*/ $a95050abcaff2f05$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $a95050abcaff2f05$var$_refresh.default
    }));
$a95050abcaff2f05$var$RefreshIcon.displayName = "RefreshIcon";
var $a95050abcaff2f05$var$_default = $a95050abcaff2f05$exports.default = $a95050abcaff2f05$var$RefreshIcon;


var $84d260297a222b6a$exports = {};
"use strict";
Object.defineProperty($84d260297a222b6a$exports, "__esModule", {
    value: true
});
$84d260297a222b6a$exports.default = void 0;

var $84d260297a222b6a$var$_react = $84d260297a222b6a$var$_interopRequireDefault((parcelRequire("acw62")));


var $84d260297a222b6a$var$_search = $84d260297a222b6a$var$_interopRequireDefault((parcelRequire("kI7jx")));
function $84d260297a222b6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $84d260297a222b6a$var$SearchIcon = (props)=>/*#__PURE__*/ $84d260297a222b6a$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $84d260297a222b6a$var$_search.default
    }));
$84d260297a222b6a$var$SearchIcon.displayName = "SearchIcon";
var $84d260297a222b6a$var$_default = $84d260297a222b6a$exports.default = $84d260297a222b6a$var$SearchIcon;


var $5a5c08e14f64cdf6$exports = {};
"use strict";
Object.defineProperty($5a5c08e14f64cdf6$exports, "__esModule", {
    value: true
});
$5a5c08e14f64cdf6$exports.default = void 0;

var $5a5c08e14f64cdf6$var$_react = $5a5c08e14f64cdf6$var$_interopRequireDefault((parcelRequire("acw62")));


var $5a5c08e14f64cdf6$var$_settings = $5a5c08e14f64cdf6$var$_interopRequireDefault((parcelRequire("dwwhx")));
function $5a5c08e14f64cdf6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a5c08e14f64cdf6$var$SettingsIcon = (props)=>/*#__PURE__*/ $5a5c08e14f64cdf6$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $5a5c08e14f64cdf6$var$_settings.default
    }));
$5a5c08e14f64cdf6$var$SettingsIcon.displayName = "SettingsIcon";
var $5a5c08e14f64cdf6$var$_default = $5a5c08e14f64cdf6$exports.default = $5a5c08e14f64cdf6$var$SettingsIcon;


var $8f22ce6266498d8f$exports = {};
"use strict";
Object.defineProperty($8f22ce6266498d8f$exports, "__esModule", {
    value: true
});
$8f22ce6266498d8f$exports.default = void 0;

var $8f22ce6266498d8f$var$_react = $8f22ce6266498d8f$var$_interopRequireDefault((parcelRequire("acw62")));


var $8f22ce6266498d8f$var$_share = $8f22ce6266498d8f$var$_interopRequireDefault((parcelRequire("6QGpd")));
function $8f22ce6266498d8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8f22ce6266498d8f$var$ShareIcon = (props)=>/*#__PURE__*/ $8f22ce6266498d8f$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $8f22ce6266498d8f$var$_share.default
    }));
$8f22ce6266498d8f$var$ShareIcon.displayName = "ShareIcon";
var $8f22ce6266498d8f$var$_default = $8f22ce6266498d8f$exports.default = $8f22ce6266498d8f$var$ShareIcon;


var $fa7fc39340ede4b5$exports = {};
"use strict";
Object.defineProperty($fa7fc39340ede4b5$exports, "__esModule", {
    value: true
});
$fa7fc39340ede4b5$exports.default = void 0;

var $fa7fc39340ede4b5$var$_react = $fa7fc39340ede4b5$var$_interopRequireDefault((parcelRequire("acw62")));


var $fa7fc39340ede4b5$var$_starUnstarred = $fa7fc39340ede4b5$var$_interopRequireDefault((parcelRequire("eIfnO")));
function $fa7fc39340ede4b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa7fc39340ede4b5$var$StarIcon = (props)=>/*#__PURE__*/ $fa7fc39340ede4b5$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $fa7fc39340ede4b5$var$_starUnstarred.default
    }));
$fa7fc39340ede4b5$var$StarIcon.displayName = "StarIcon";
var $fa7fc39340ede4b5$var$_default = $fa7fc39340ede4b5$exports.default = $fa7fc39340ede4b5$var$StarIcon;


var $6e70cf83e1cfcb36$exports = {};
"use strict";
Object.defineProperty($6e70cf83e1cfcb36$exports, "__esModule", {
    value: true
});
$6e70cf83e1cfcb36$exports.default = void 0;

var $6e70cf83e1cfcb36$var$_react = $6e70cf83e1cfcb36$var$_interopRequireDefault((parcelRequire("acw62")));


var $6e70cf83e1cfcb36$var$_starStarred = $6e70cf83e1cfcb36$var$_interopRequireDefault((parcelRequire("fqs5t")));
function $6e70cf83e1cfcb36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6e70cf83e1cfcb36$var$StarFilledIcon = (props)=>/*#__PURE__*/ $6e70cf83e1cfcb36$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $6e70cf83e1cfcb36$var$_starStarred.default
    }));
$6e70cf83e1cfcb36$var$StarFilledIcon.displayName = "StarFilledIcon";
var $6e70cf83e1cfcb36$var$_default = $6e70cf83e1cfcb36$exports.default = $6e70cf83e1cfcb36$var$StarFilledIcon;


var $82bb617b0c11ad15$exports = {};
"use strict";
Object.defineProperty($82bb617b0c11ad15$exports, "__esModule", {
    value: true
});
$82bb617b0c11ad15$exports.default = void 0;

var $82bb617b0c11ad15$var$_react = $82bb617b0c11ad15$var$_interopRequireDefault((parcelRequire("acw62")));


var $82bb617b0c11ad15$var$_warning = $82bb617b0c11ad15$var$_interopRequireDefault((parcelRequire("51kdZ")));
function $82bb617b0c11ad15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $82bb617b0c11ad15$var$WarningIcon = (props)=>/*#__PURE__*/ $82bb617b0c11ad15$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $82bb617b0c11ad15$var$_warning.default
    }));
$82bb617b0c11ad15$var$WarningIcon.displayName = "WarningIcon";
var $82bb617b0c11ad15$var$_default = $82bb617b0c11ad15$exports.default = $82bb617b0c11ad15$var$WarningIcon;


var $b5560414905dc7f5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b5560414905dc7f5$exports, "__esModule", {
    value: true
});
$b5560414905dc7f5$exports.default = void 0;

var $b5560414905dc7f5$var$_react = $b5560414905dc7f5$var$_interopRequireDefault((parcelRequire("acw62")));

var $b5560414905dc7f5$var$_baseNew = $b5560414905dc7f5$var$_interopRequireDefault((parcelRequire("6Zqnk")));
function $b5560414905dc7f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5560414905dc7f5$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $b5560414905dc7f5$var$_react.default.createElement($b5560414905dc7f5$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$b5560414905dc7f5$var$RoadmapsPlanIcon.displayName = "RoadmapsPlanIcon";
var $b5560414905dc7f5$var$_default = $b5560414905dc7f5$exports.default = $b5560414905dc7f5$var$RoadmapsPlanIcon;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $70196eb977b951dd$var$printed = {};
function $70196eb977b951dd$export$2e2bcd8739ae039(message) {
    if ($70196eb977b951dd$var$printed[message]) return;
    $70196eb977b951dd$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $70ea3c5730b9fd5f$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $70196eb977b951dd$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $70ea3c5730b9fd5f$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $3624036857e6cb2b$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $3624036857e6cb2b$export$c93026a968943f95 = "light";
var $3624036857e6cb2b$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $3624036857e6cb2b$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $3624036857e6cb2b$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $3624036857e6cb2b$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $3624036857e6cb2b$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $3624036857e6cb2b$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $3624036857e6cb2b$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $3624036857e6cb2b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $2b750d3a8789dea3$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3624036857e6cb2b$export$6d8204c2cb2e06b8() / 4;
    (0, $70ea3c5730b9fd5f$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $3624036857e6cb2b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $3624036857e6cb2b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $3624036857e6cb2b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $70ea3c5730b9fd5f$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $3624036857e6cb2b$export$ba1d834b86d72a09 = $3624036857e6cb2b$export$a1b3edb637fb4f35;
var $3624036857e6cb2b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $2b750d3a8789dea3$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $2b750d3a8789dea3$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $2b750d3a8789dea3$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $629376b081034ab2$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $3624036857e6cb2b$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $3624036857e6cb2b$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $3624036857e6cb2b$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $3624036857e6cb2b$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $127e0d6eab5209f1$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $629376b081034ab2$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $127e0d6eab5209f1$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $127e0d6eab5209f1$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $629376b081034ab2$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $2b750d3a8789dea3$export$4b84fd0e2c617bd = "#FFEBE6";
var $2b750d3a8789dea3$export$b34b069eff244586 = "#FFBDAD";
var $2b750d3a8789dea3$export$be802dd0d8b57f35 = "#FF8F73";
var $2b750d3a8789dea3$export$60847d42f9da92a6 = "#FF7452";
var $2b750d3a8789dea3$export$4a7404f376229999 = "#FF5630";
var $2b750d3a8789dea3$export$2010d0fb4295b346 = "#DE350B";
var $2b750d3a8789dea3$export$2837b5a1a71d5c02 = "#BF2600";
var $2b750d3a8789dea3$export$8d9596b529bbb9cf = "#FFFAE6";
var $2b750d3a8789dea3$export$41060a744ab0b7ae = "#FFF0B3";
var $2b750d3a8789dea3$export$1cc05bbbf340e559 = "#FFE380";
var $2b750d3a8789dea3$export$5aae31392d72caaa = "#FFC400";
var $2b750d3a8789dea3$export$c6930421db9fa514 = "#FFAB00";
var $2b750d3a8789dea3$export$59619663aa6500fb = "#FF991F";
var $2b750d3a8789dea3$export$874739ea9e379ab6 = "#FF8B00";
var $2b750d3a8789dea3$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $2b750d3a8789dea3$export$69a3bf21b9686c2b = "#ABF5D1";
var $2b750d3a8789dea3$export$afbce1382ec95f73 = "#79F2C0";
var $2b750d3a8789dea3$export$747d86715d4175de = "#57D9A3";
var $2b750d3a8789dea3$export$940e1f69e873f202 = "#36B37E";
var $2b750d3a8789dea3$export$a49394138f7b8e85 = "#00875A";
var $2b750d3a8789dea3$export$6fa04827ac68a4fb = "#006644";
var $2b750d3a8789dea3$export$226de0355ed012f8 = "#DEEBFF";
var $2b750d3a8789dea3$export$8c13c2ee36917869 = "#B3D4FF";
var $2b750d3a8789dea3$export$ecfc1dff386a3e7a = "#4C9AFF";
var $2b750d3a8789dea3$export$215b7063051591f1 = "#2684FF";
var $2b750d3a8789dea3$export$e62e8919cca44969 = "#0065FF";
var $2b750d3a8789dea3$export$b3de0ae08da2ce64 = "#0052CC";
var $2b750d3a8789dea3$export$a6ee3d71bc067634 = "#0747A6";
var $2b750d3a8789dea3$export$363e4475840015bb = "#EAE6FF";
var $2b750d3a8789dea3$export$4b0a4417ed59760f = "#C0B6F2";
var $2b750d3a8789dea3$export$6011520a64d9a187 = "#998DD9";
var $2b750d3a8789dea3$export$a7175d4e9206bc80 = "#8777D9";
var $2b750d3a8789dea3$export$b48405b95304b5a1 = "#6554C0";
var $2b750d3a8789dea3$export$c71e4279dd54a18d = "#5243AA";
var $2b750d3a8789dea3$export$147899de772240ec = "#403294";
var $2b750d3a8789dea3$export$2cf711fe14c66f06 = "#E6FCFF";
var $2b750d3a8789dea3$export$7a8f4d33f6f9772c = "#B3F5FF";
var $2b750d3a8789dea3$export$776c9c497ef08533 = "#79E2F2";
var $2b750d3a8789dea3$export$69cb3ca10c1e330e = "#00C7E6";
var $2b750d3a8789dea3$export$9dc1ef0f3f48059b = "#00B8D9";
var $2b750d3a8789dea3$export$7c835c78b6fcdef8 = "#00A3BF";
var $2b750d3a8789dea3$export$6036577f95c3877e = "#008DA6";
var $2b750d3a8789dea3$export$29a4f05edc054374 = "#FFFFFF";
var $2b750d3a8789dea3$export$e655ef011c4aa1a2 = "#FAFBFC";
var $2b750d3a8789dea3$export$9fdfb749e33cdf97 = "#F4F5F7";
var $2b750d3a8789dea3$export$3e51e8f1440314ba = "#EBECF0";
var $2b750d3a8789dea3$export$1ce2d1575d444ceb = "#DFE1E6";
var $2b750d3a8789dea3$export$8754fc7e6d8b3000 = "#C1C7D0";
var $2b750d3a8789dea3$export$c2e91cbeada39b8b = "#B3BAC5";
var $2b750d3a8789dea3$export$5f71e19f3a7ad9de = "#A5ADBA";
var $2b750d3a8789dea3$export$eaa8c8a70ac22806 = "#97A0AF";
var $2b750d3a8789dea3$export$7c87d337fb91a97d = "#8993A4";
var $2b750d3a8789dea3$export$d6447c357493214f = "#7A869A";
var $2b750d3a8789dea3$export$f563ee71e9ee74cd = "#6B778C";
var $2b750d3a8789dea3$export$e2ef2124cf4024b1 = "#5E6C84";
var $2b750d3a8789dea3$export$eece5f492e429f08 = "#505F79";
var $2b750d3a8789dea3$export$c39c0fe0f26207ae = "#42526E";
var $2b750d3a8789dea3$export$7090862dc3038a9f = "#344563";
var $2b750d3a8789dea3$export$ad0bacf983b7ddaa = "#253858";
var $2b750d3a8789dea3$export$7d61b15e0da132af = "#172B4D";
var $2b750d3a8789dea3$export$fbda843f0a27fe96 = "#091E42";
var $2b750d3a8789dea3$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $2b750d3a8789dea3$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $2b750d3a8789dea3$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $2b750d3a8789dea3$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $2b750d3a8789dea3$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $2b750d3a8789dea3$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $2b750d3a8789dea3$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $2b750d3a8789dea3$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $2b750d3a8789dea3$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $2b750d3a8789dea3$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $2b750d3a8789dea3$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $2b750d3a8789dea3$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $2b750d3a8789dea3$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $2b750d3a8789dea3$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $2b750d3a8789dea3$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $2b750d3a8789dea3$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $2b750d3a8789dea3$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $2b750d3a8789dea3$export$2f6319cf7d736c2a = "#E6EDFA";
var $2b750d3a8789dea3$export$95126bc8884d6634 = "#DCE5F5";
var $2b750d3a8789dea3$export$8338d8c35d44ff1 = "#CED9EB";
var $2b750d3a8789dea3$export$5368d76ae4fbbda7 = "#B8C7E0";
var $2b750d3a8789dea3$export$9f0a771d16ec8d36 = "#ABBBD6";
var $2b750d3a8789dea3$export$abcf8c38338b4aa5 = "#9FB0CC";
var $2b750d3a8789dea3$export$97e81faa16a182c7 = "#8C9CB8";
var $2b750d3a8789dea3$export$bfe21c59123ecf33 = "#7988A3";
var $2b750d3a8789dea3$export$ee82aa2ea6a1558 = "#67758F";
var $2b750d3a8789dea3$export$682927c6ed76be02 = "#56637A";
var $2b750d3a8789dea3$export$91fd9994c5be9757 = "#455166";
var $2b750d3a8789dea3$export$d281fbfe3cff2df6 = "#3B475C";
var $2b750d3a8789dea3$export$3902c91d8b98a753 = "#313D52";
var $2b750d3a8789dea3$export$8e8133c1ba5845b5 = "#283447";
var $2b750d3a8789dea3$export$33ff357f6620b39 = "#202B3D";
var $2b750d3a8789dea3$export$633847cf062b69e0 = "#1B2638";
var $2b750d3a8789dea3$export$9776a6e503bdbf76 = "#121A29";
var $2b750d3a8789dea3$export$6c813d5160dff5db = "#0E1624";
var $2b750d3a8789dea3$export$3d4f271a500072a = "#0D1424";
var $2b750d3a8789dea3$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $2b750d3a8789dea3$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $2b750d3a8789dea3$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $2b750d3a8789dea3$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $2b750d3a8789dea3$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $2b750d3a8789dea3$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $2b750d3a8789dea3$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $2b750d3a8789dea3$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $2b750d3a8789dea3$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $2b750d3a8789dea3$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $2b750d3a8789dea3$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $2b750d3a8789dea3$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $2b750d3a8789dea3$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $2b750d3a8789dea3$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $2b750d3a8789dea3$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $2b750d3a8789dea3$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $2b750d3a8789dea3$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $2b750d3a8789dea3$export$8ce1fd94bee2f412 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($2b750d3a8789dea3$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($2b750d3a8789dea3$export$633847cf062b69e0, ")")
});
var $2b750d3a8789dea3$export$b861914ea877b580 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($2b750d3a8789dea3$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($2b750d3a8789dea3$export$8c13c2ee36917869, ")")
});
var $2b750d3a8789dea3$export$3f1b020df94387af = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($2b750d3a8789dea3$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($2b750d3a8789dea3$export$d281fbfe3cff2df6, ")")
});
var $2b750d3a8789dea3$export$c0183dbab98ca63e = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($2b750d3a8789dea3$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($2b750d3a8789dea3$export$8e8133c1ba5845b5, ")")
});
var $2b750d3a8789dea3$export$6f093cfa640b7166 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($2b750d3a8789dea3$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($2b750d3a8789dea3$export$5368d76ae4fbbda7, ")")
});
var $2b750d3a8789dea3$export$42f8e9c698766e7a = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($2b750d3a8789dea3$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($2b750d3a8789dea3$export$5368d76ae4fbbda7, ")")
});
var $2b750d3a8789dea3$export$c2d157ca1c34b6e3 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($2b750d3a8789dea3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($2b750d3a8789dea3$export$b3de0ae08da2ce64, ")")
});
var $2b750d3a8789dea3$export$1905ba28d7cf066f = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($2b750d3a8789dea3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($2b750d3a8789dea3$export$97e81faa16a182c7, ")")
});
var $2b750d3a8789dea3$export$bd9002130d306d39 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($2b750d3a8789dea3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($2b750d3a8789dea3$export$bfe21c59123ecf33, ")")
});
var $2b750d3a8789dea3$export$46e4a324ac90507f = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($2b750d3a8789dea3$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($2b750d3a8789dea3$export$5368d76ae4fbbda7, ")")
});
var $2b750d3a8789dea3$export$79f3f2b82beb0d36 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($2b750d3a8789dea3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($2b750d3a8789dea3$export$97e81faa16a182c7, ")")
});
var $2b750d3a8789dea3$export$7bb0d5c671655cc4 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$9fdfb749e33cdf97,
    dark: $2b750d3a8789dea3$export$8e8133c1ba5845b5
});
var $2b750d3a8789dea3$export$9c30223ca0a664fb = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($2b750d3a8789dea3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($2b750d3a8789dea3$export$ecfc1dff386a3e7a, ")")
});
var $2b750d3a8789dea3$export$7ed258b0728b004b = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($2b750d3a8789dea3$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($2b750d3a8789dea3$export$215b7063051591f1, ")")
});
var $2b750d3a8789dea3$export$dfa920d8decc8a59 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($2b750d3a8789dea3$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($2b750d3a8789dea3$export$ecfc1dff386a3e7a, ")")
});
var $2b750d3a8789dea3$export$6069e6ad5c78f632 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($2b750d3a8789dea3$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($2b750d3a8789dea3$export$215b7063051591f1, ")")
});
var $2b750d3a8789dea3$export$9ad721cf3b3debe0 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($2b750d3a8789dea3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($2b750d3a8789dea3$export$ecfc1dff386a3e7a, ")")
});
var $2b750d3a8789dea3$export$2aa0182783e7e9de = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$b3de0ae08da2ce64,
    dark: $2b750d3a8789dea3$export$ecfc1dff386a3e7a
});
var $2b750d3a8789dea3$export$8bf7dff220b82b4a = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$9dc1ef0f3f48059b,
    dark: $2b750d3a8789dea3$export$69cb3ca10c1e330e
});
var $2b750d3a8789dea3$export$e13cce2a2d16a9d4 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$b48405b95304b5a1,
    dark: $2b750d3a8789dea3$export$6011520a64d9a187
});
var $2b750d3a8789dea3$export$a90204d1394caf30 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$4a7404f376229999,
    dark: $2b750d3a8789dea3$export$4a7404f376229999
});
var $2b750d3a8789dea3$export$594c5a8758200c32 = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$c6930421db9fa514,
    dark: $2b750d3a8789dea3$export$c6930421db9fa514
});
var $2b750d3a8789dea3$export$955a2ebd2fb142ae = (0, $127e0d6eab5209f1$export$2e2bcd8739ae039)({
    light: $2b750d3a8789dea3$export$940e1f69e873f202,
    dark: $2b750d3a8789dea3$export$940e1f69e873f202
});
var $2b750d3a8789dea3$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($2b750d3a8789dea3$export$8d43898f60b96a82, ")");
};



var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ecc69a910d65988c$var$n = function(t, e) {
    return ($ecc69a910d65988c$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    })(t, e);
};
var $ecc69a910d65988c$var$o, $ecc69a910d65988c$var$r, $ecc69a910d65988c$var$i = (function(t) {
    /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
        var e = {}.hasOwnProperty;
        function n() {
            for(var t = [], o = 0; o < arguments.length; o++){
                var r = arguments[o];
                if (r) {
                    var i = typeof r;
                    if ("string" === i || "number" === i) t.push(r);
                    else if (Array.isArray(r) && r.length) {
                        var s = n.apply(null, r);
                        s && t.push(s);
                    } else if ("object" === i) for(var l in r)e.call(r, l) && r[l] && t.push(l);
                }
            }
            return t.join(" ");
        }
        t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    }();
}($ecc69a910d65988c$var$r = {
    path: $ecc69a910d65988c$var$o,
    exports: {},
    require: function(t, e) {
        return function() {
            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == e && $ecc69a910d65988c$var$r.path);
    }
}, $ecc69a910d65988c$var$r.exports), $ecc69a910d65988c$var$r.exports);
function $ecc69a910d65988c$var$s(t, e, n) {
    var o, r, i, s, l;
    function a() {
        var c = Date.now() - s;
        c < e && c >= 0 ? o = setTimeout(a, e - c) : (o = null, n || (l = t.apply(i, r), i = r = null));
    }
    null == e && (e = 100);
    var c = function() {
        i = this, r = arguments, s = Date.now();
        var c = n && !o;
        return o || (o = setTimeout(a, e)), c && (l = t.apply(i, r), i = r = null), l;
    };
    return c.clear = function() {
        o && (clearTimeout(o), o = null);
    }, c.flush = function() {
        o && (l = t.apply(i, r), i = r = null, clearTimeout(o), o = null);
    }, c;
}
$ecc69a910d65988c$var$s.debounce = $ecc69a910d65988c$var$s;
var $ecc69a910d65988c$var$l = $ecc69a910d65988c$var$s;
!function(t, e) {
    void 0 === e && (e = {});
    var n = e.insertAt;
    if (t && "undefined" != typeof document) {
        var o = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
        r.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
}(".indiana-scroll-container {\n  overflow: auto;\n}\n.indiana-scroll-container--dragging {\n  scroll-behavior: auto !important;\n}\n.indiana-scroll-container--dragging > * {\n  pointer-events: none;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.indiana-scroll-container--hide-scrollbars {\n  overflow: hidden;\n  overflow: -moz-scrollbars-none;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n  display: none !important;\n  height: 0 !important;\n  width: 0 !important;\n  background: transparent !important;\n  -webkit-appearance: none !important;\n}\n.indiana-scroll-container--native-scroll {\n  overflow: auto;\n}\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab;\n}");
var $ecc69a910d65988c$var$a, $ecc69a910d65988c$var$c = ($ecc69a910d65988c$var$a = "indiana-scroll-container", function(t, e) {
    if (!t) return $ecc69a910d65988c$var$a;
    var n;
    "string" == typeof t ? n = t : e = t;
    var o = $ecc69a910d65988c$var$a;
    return n && (o += "__" + n), o + (e ? Object.keys(e).reduce(function(t, n) {
        var r = e[n];
        return r && (t += " " + ("boolean" == typeof r ? o + "--" + n : o + "--" + n + "_" + r)), t;
    }, "") : "");
}), $ecc69a910d65988c$var$p = function(e) {
    function o(n) {
        var o = e.call(this, n) || this;
        return o.onEndScroll = function() {
            o.scrolling = !1, !o.pressed && o.started && o.processEnd();
        }, o.onScroll = function(t) {
            var e = o.container.current;
            e.scrollLeft === o.scrollLeft && e.scrollTop === o.scrollTop || (o.scrolling = !0, o.processScroll(t), o.onEndScroll());
        }, o.onTouchStart = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.isDraggable(t.target)) {
                if (o.internal = !0, e && o.scrolling) o.pressed = !0;
                else {
                    var n = t.touches[0];
                    o.processClick(t, n.clientX, n.clientY), !e && o.props.stopPropagation && t.stopPropagation();
                }
            }
        }, o.onTouchEnd = function(t) {
            var e = o.props.nativeMobileScroll;
            o.pressed && (!o.started || o.scrolling && e ? o.pressed = !1 : o.processEnd(), o.forceUpdate());
        }, o.onTouchMove = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.pressed && (!e || !o.isMobile)) {
                var n = t.touches[0];
                n && o.processMove(t, n.clientX, n.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation();
            }
        }, o.onMouseDown = function(t) {
            o.isDraggable(t.target) && o.isScrollable() && (o.internal = !0, -1 !== o.props.buttons.indexOf(t.button) && (o.processClick(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation()));
        }, o.onMouseMove = function(t) {
            o.pressed && (o.processMove(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.onMouseUp = function(t) {
            o.pressed && (o.started ? o.processEnd() : (o.internal = !1, o.pressed = !1, o.forceUpdate(), o.props.onClick && o.props.onClick(t)), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.container = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(), o.onEndScroll = $ecc69a910d65988c$var$l(o.onEndScroll, 300), o.scrolling = !1, o.started = !1, o.pressed = !1, o.internal = !1, o.getRef = o.getRef.bind(o), o;
    }
    return function(t, e) {
        function o() {
            this.constructor = t;
        }
        $ecc69a910d65988c$var$n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o);
    }(o, e), o.prototype.componentDidMount = function() {
        var t = this.props.nativeMobileScroll, e = this.container.current;
        window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), window.addEventListener("touchend", this.onTouchEnd), e.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), e.addEventListener("mousedown", this.onMouseDown, {
            passive: !1
        }), t && (this.isMobile = this.isMobileDevice(), this.isMobile && this.forceUpdate());
    }, o.prototype.componentWillUnmount = function() {
        window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
    }, o.prototype.getElement = function() {
        return this.container.current;
    }, o.prototype.isMobileDevice = function() {
        return void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile");
    }, o.prototype.isDraggable = function(t) {
        var e = this.props.ignoreElements;
        if (e) {
            var n = t.closest(e);
            return null === n || n.contains(this.getElement());
        }
        return !0;
    }, o.prototype.isScrollable = function() {
        var t = this.container.current;
        return t && (t.scrollWidth > t.clientWidth || t.scrollHeight > t.clientHeight);
    }, o.prototype.processClick = function(t, e, n) {
        var o = this.container.current;
        this.scrollLeft = o.scrollLeft, this.scrollTop = o.scrollTop, this.clientX = e, this.clientY = n, this.pressed = !0;
    }, o.prototype.processStart = function(t) {
        void 0 === t && (t = !0);
        var e = this.props.onStartScroll;
        this.started = !0, t && document.body.classList.add("indiana-dragging"), e && e({
            external: !this.internal
        }), this.forceUpdate();
    }, o.prototype.processScroll = function(t) {
        if (this.started) {
            var e = this.props.onScroll;
            e && e({
                external: !this.internal
            });
        } else this.processStart(!1);
    }, o.prototype.processMove = function(t, e, n) {
        var o = this.props, r = o.horizontal, i = o.vertical, s = o.activationDistance, l = o.onScroll, a = this.container.current;
        this.started ? (r && (a.scrollLeft -= e - this.clientX), i && (a.scrollTop -= n - this.clientY), l && l({
            external: !this.internal
        }), this.clientX = e, this.clientY = n, this.scrollLeft = a.scrollLeft, this.scrollTop = a.scrollTop) : (r && Math.abs(e - this.clientX) > s || i && Math.abs(n - this.clientY) > s) && (this.clientX = e, this.clientY = n, this.processStart());
    }, o.prototype.processEnd = function() {
        var t = this.props.onEndScroll;
        this.container.current && t && t({
            external: !this.internal
        }), this.pressed = !1, this.started = !1, this.scrolling = !1, this.internal = !1, document.body.classList.remove("indiana-dragging"), this.forceUpdate();
    }, o.prototype.getRef = function(t) {
        [
            this.container,
            this.props.innerRef
        ].forEach(function(e) {
            e && ("function" == typeof e ? e(t) : e.current = t);
        });
    }, o.prototype.render = function() {
        var e = this.props, n = e.children, o = e.draggingClassName, r = e.className, s = e.style, l = e.hideScrollbars, a = e.component;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(a, {
            className: $ecc69a910d65988c$var$i(r, this.pressed && o, $ecc69a910d65988c$var$c({
                dragging: this.pressed,
                "hide-scrollbars": l,
                "native-scroll": this.isMobile
            })),
            style: s,
            ref: this.getRef,
            onScroll: this.onScroll
        }, n);
    }, o.defaultProps = {
        nativeMobileScroll: !0,
        hideScrollbars: !0,
        activationDistance: 10,
        vertical: !0,
        horizontal: !0,
        stopPropagation: !1,
        style: {},
        component: "div",
        buttons: [
            0
        ]
    }, o;
}((0, $acw62.PureComponent));
var $ecc69a910d65988c$export$2e2bcd8739ae039 = $ecc69a910d65988c$var$p;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $0f64162dd28c6e9a$var$ATOMIC_GROUP_LENGTH = 5;
function $0f64162dd28c6e9a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $0f64162dd28c6e9a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("acw62");


var $3U1FJ = parcelRequire("3U1FJ");
var $1b267db47313e17e$var$strictApi = (0, $3U1FJ.createStrictAPI)();
var $1b267db47313e17e$export$dbf350e5966cf602 = $1b267db47313e17e$var$strictApi.css;
var $1b267db47313e17e$export$eb1ecd84a24ee424 = $1b267db47313e17e$var$strictApi.cssMap;
$1b267db47313e17e$var$strictApi.cssMap;
var $1b267db47313e17e$export$a274e22fb40f762e = $1b267db47313e17e$var$strictApi.cx;
var $1b267db47313e17e$var$XCSSProp = $1b267db47313e17e$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 



var $41YNz = parcelRequire("41YNz");
function $4ecf0ab45c3aacd5$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") ref.current = value;
        });
    };
}




var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");
function $b0c138cae604a466$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId().replace(/[:«»]/g, "_");
}
var $b0c138cae604a466$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($b0c138cae604a466$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $b0c138cae604a466$export$6ee17796e3d70de2() {
    var uid = $b0c138cae604a466$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}



var $ltooA = parcelRequire("ltooA");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


const $b4ea748dabc9686d$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)(actualStyles);
};



function $c3757936ec4d05cc$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_userAgentData = window.navigator["userAgentData"]) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $c3757936ec4d05cc$var$isIPhone() {
    return $c3757936ec4d05cc$var$testPlatform(/^iPhone/i);
}
function $c3757936ec4d05cc$var$isMac() {
    return $c3757936ec4d05cc$var$testPlatform(/^Mac/i);
}
function $c3757936ec4d05cc$var$isIPad() {
    return $c3757936ec4d05cc$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c3757936ec4d05cc$var$isMac() && navigator.maxTouchPoints > 1;
}
function $c3757936ec4d05cc$var$isIOS() {
    return $c3757936ec4d05cc$var$isIPhone() || $c3757936ec4d05cc$var$isIPad();
}
function $c3757936ec4d05cc$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $c3757936ec4d05cc$export$e1865c3bedcd822b() {
    return $c3757936ec4d05cc$var$isMac() || $c3757936ec4d05cc$var$isIOS();
}




/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $0c10100aa6d830f3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $0c10100aa6d830f3$var$_excluded2 = [
    "className"
];
var $0c10100aa6d830f3$var$focusRingStyles = null;
var $0c10100aa6d830f3$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $0c10100aa6d830f3$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $0c10100aa6d830f3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $0c10100aa6d830f3$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $0c10100aa6d830f3$export$2e2bcd8739ae039 = $0c10100aa6d830f3$var$Focusable;


var $f6448228a9089723$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $f6448228a9089723$var$_excluded2 = [
    "className"
];
var $f6448228a9089723$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $f6448228a9089723$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $f6448228a9089723$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $821ef75052fd65be$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f8784e9218a8d7c8$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $f6448228a9089723$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $0c10100aa6d830f3$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $c3757936ec4d05cc$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $b4ea748dabc9686d$export$a274e22fb40f762e)($f6448228a9089723$var$styles.root, isDisabled && $f6448228a9089723$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $f6448228a9089723$export$2e2bcd8739ae039 = $f6448228a9089723$var$Pressable;




var $acw62 = parcelRequire("acw62");
var $6ac036be189c2909$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $6ac036be189c2909$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $acw62.useContext)($6ac036be189c2909$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $05d184075405b1fa$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $05d184075405b1fa$var$tabKeyCode = 9;
function $05d184075405b1fa$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $05d184075405b1fa$var$tabKeyCode) return;
    $05d184075405b1fa$var$abort(event);
}
function $05d184075405b1fa$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $05d184075405b1fa$var$abort,
        onMouseUpCapture: $05d184075405b1fa$var$abort,
        onKeyDownCapture: $05d184075405b1fa$var$onKey,
        onKeyUpCapture: $05d184075405b1fa$var$onKey,
        onTouchStartCapture: $05d184075405b1fa$var$abort,
        onTouchEndCapture: $05d184075405b1fa$var$abort,
        onPointerDownCapture: $05d184075405b1fa$var$abort,
        onPointerUpCapture: $05d184075405b1fa$var$abort,
        onClickCapture: $05d184075405b1fa$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $05d184075405b1fa$var$abort
    } : events;
}



var $acw62 = parcelRequire("acw62");

function $d25112fad2805101$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $d25112fad2805101$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $d25112fad2805101$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979877583a72dd5$export$2e2bcd8739ae039), {
        size: $d25112fad2805101$var$getIconSpacing(spacing),
        appearance: $d25112fad2805101$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $45be0b1e9cb22013$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $45be0b1e9cb22013$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $45be0b1e9cb22013$var$LOADING_LABEL = ", Loading";
var $45be0b1e9cb22013$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $45be0b1e9cb22013$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $45be0b1e9cb22013$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $45be0b1e9cb22013$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $45be0b1e9cb22013$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $45be0b1e9cb22013$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $45be0b1e9cb22013$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $45be0b1e9cb22013$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $45be0b1e9cb22013$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $45be0b1e9cb22013$var$_excluded);
    var localRef = (0, $acw62.useRef)(null);
    var splitButtonContext = (0, $6ac036be189c2909$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $b0c138cae604a466$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $a9944ef3517b621b$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $45be0b1e9cb22013$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f6448228a9089723$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $4ecf0ab45c3aacd5$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $1b267db47313e17e$export$a274e22fb40f762e)($45be0b1e9cb22013$var$styles.base, (0, $ltooA.fg)("platform-dst-shape-theme-default") && $45be0b1e9cb22013$var$styles.baseT26Shape, appearance === "default" && $45be0b1e9cb22013$var$defaultStyles.root, appearance === "default" && isInteractive && $45be0b1e9cb22013$var$defaultStyles.interactive, appearance === "primary" && $45be0b1e9cb22013$var$primaryStyles.root, appearance === "primary" && isInteractive && $45be0b1e9cb22013$var$primaryStyles.interactive, appearance === "warning" && $45be0b1e9cb22013$var$warningStyles.root, appearance === "warning" && isInteractive && $45be0b1e9cb22013$var$warningStyles.interactive, appearance === "danger" && $45be0b1e9cb22013$var$dangerStyles.root, appearance === "danger" && isInteractive && $45be0b1e9cb22013$var$dangerStyles.interactive, appearance === "discovery" && $45be0b1e9cb22013$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $45be0b1e9cb22013$var$discoveryStyles.interactive, appearance === "subtle" && $45be0b1e9cb22013$var$subtleStyles.root, appearance === "subtle" && isInteractive && $45be0b1e9cb22013$var$subtleStyles.interactive, $45be0b1e9cb22013$var$styles.linkDecorationUnset, isSelected && $45be0b1e9cb22013$var$selectedStyles.root, isSelected && isSplitButton && $45be0b1e9cb22013$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $45be0b1e9cb22013$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $45be0b1e9cb22013$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $45be0b1e9cb22013$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $45be0b1e9cb22013$var$selectedStyles.discovery, isDisabled && $45be0b1e9cb22013$var$styles.disabled, isDisabled && appearance !== "default" && appearance !== "subtle" && $45be0b1e9cb22013$var$styles.sharedDisabled, isDisabled && appearance === "default" && $45be0b1e9cb22013$var$defaultStyles.disabled, isCircle && !isSplitButton && $45be0b1e9cb22013$var$styles.circle, spacing === "compact" && $45be0b1e9cb22013$var$styles.spacingCompact, spacing === "compact" && (0, $ltooA.fg)("platform-dst-shape-theme-default") && $45be0b1e9cb22013$var$styles.spacingCompactT26Shape, shouldFitContainer && $45be0b1e9cb22013$var$styles.fullWidth, hasIconBefore && $45be0b1e9cb22013$var$styles.buttonIconBefore, hasIconAfter && $45be0b1e9cb22013$var$styles.buttonIconAfter, isIconButton && $45be0b1e9cb22013$var$styles.iconButton, isIconButton && spacing === "compact" && $45be0b1e9cb22013$var$styles.iconButtonCompact, isLoading && $45be0b1e9cb22013$var$styles.loading, isSplitButton && $45be0b1e9cb22013$var$styles.splitButton, isNavigationSplitButton && $45be0b1e9cb22013$var$styles.navigationSplitButton),
        isDisabled: (0, $ltooA.fg)("platform-dst_fix_not_focusable_loading_button") ? isDisabled : isEffectivelyDisabled
    }, (0, $ltooA.fg)("platform-dst_fix_not_focusable_loading_button") && {
        "aria-live": "polite"
    }, isLoading && (0, $ltooA.fg)("platform-dst_fix_not_focusable_loading_button") && {
        "aria-disabled": true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($45be0b1e9cb22013$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $05d184075405b1fa$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ac036be189c2909$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            $45be0b1e9cb22013$var$styles.loadingOverlay
        ])
    }, (0, $d25112fad2805101$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f26887e6ba26112a$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $45be0b1e9cb22013$var$LOADING_LABEL)));
});
var $45be0b1e9cb22013$export$2e2bcd8739ae039 = $45be0b1e9cb22013$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $acw62 = parcelRequire("acw62");
var $57e8f8a209e3fa2e$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $57e8f8a209e3fa2e$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            $57e8f8a209e3fa2e$var$styles.common,
            type === "text" && $57e8f8a209e3fa2e$var$styles.text,
            type === "icon" && $57e8f8a209e3fa2e$var$styles.icon,
            isLoading && $57e8f8a209e3fa2e$var$styles.fade
        ])
    }, children);
};
var $57e8f8a209e3fa2e$export$2e2bcd8739ae039 = $57e8f8a209e3fa2e$var$Content;



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
function $ad17a330ea897dec$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $ad17a330ea897dec$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $ad17a330ea897dec$var$isIconRenderProp(Icon);
    var iconProps = {
        label: "",
        color: "currentColor",
        size: (0, $ltooA.fg)("platform_dst_button_chevron_sizing") ? function(iconName) {
            return iconName.startsWith("Chevron") ? "small" : "medium";
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, iconProps));
};
var $ad17a330ea897dec$export$2e2bcd8739ae039 = $ad17a330ea897dec$var$IconRenderer;


var $64c424bfb08ced14$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $64c424bfb08ced14$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $64c424bfb08ced14$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $64c424bfb08ced14$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $64c424bfb08ced14$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45be0b1e9cb22013$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57e8f8a209e3fa2e$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad17a330ea897dec$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57e8f8a209e3fa2e$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57e8f8a209e3fa2e$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad17a330ea897dec$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$64c424bfb08ced14$var$Button.displayName = "Button";
var $64c424bfb08ced14$export$2e2bcd8739ae039 = $64c424bfb08ced14$var$Button;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


function $8b1dadd64a05a59e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b1dadd64a05a59e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b1dadd64a05a59e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b1dadd64a05a59e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8b1dadd64a05a59e$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1e19285d55b23d2e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $0bb45d4607a97797$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $0bb45d4607a97797$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8b1dadd64a05a59e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Character key codes which can be used in keyboard events.
 */ var $d1876d23b57d7dbe$export$390330c10ff2b9a1 = "ArrowUp";
var $d1876d23b57d7dbe$export$a80636c6f41931fe = "ArrowDown";
var $d1876d23b57d7dbe$export$fc4577f2a2af0ae3 = "ArrowLeft";
var $d1876d23b57d7dbe$export$c40f9845adc73fb5 = "ArrowRight";
var $d1876d23b57d7dbe$export$4af703091671bc = "Home";
var $d1876d23b57d7dbe$export$e2bc30913faa5db7 = "End";
var $d1876d23b57d7dbe$export$10f6869ed0a7d75b = "Tab";
var $d1876d23b57d7dbe$export$8152f929a25a0ff4 = "Enter";
var $d1876d23b57d7dbe$export$e51a3576c045c8d5 = "Space";
var $d1876d23b57d7dbe$export$2bb790b9008907b4 = "Escape";


function $5e96ead42d7f056f$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $d1876d23b57d7dbe$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $8fY35.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $acw62 = parcelRequire("acw62");
function $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $b5dbb4b5b06c5ee5$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c917b6c7007a4c8$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $3b196c42c336330f$export$1d57e79091cc3046() {
    var namespace = (0, $acw62.useContext)((0, $4c917b6c7007a4c8$export$644a49f3b8c50fcd));
    return namespace;
}


function $8501596c6516e42a$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $acw62.useContext)((0, $b5dbb4b5b06c5ee5$export$5fbf4d7fae6cdc00));
    var namespace = (0, $3b196c42c336330f$export$1d57e79091cc3046)();
    (0, $acw62.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $d4d78fe6c9b19203$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $d4d78fe6c9b19203$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($d4d78fe6c9b19203$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $d4d78fe6c9b19203$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d4d78fe6c9b19203$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d4d78fe6c9b19203$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $d4d78fe6c9b19203$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $d4d78fe6c9b19203$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $d4d78fe6c9b19203$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $d4d78fe6c9b19203$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $d4d78fe6c9b19203$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $d4d78fe6c9b19203$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $d4d78fe6c9b19203$var$childrenToArray(previousChildren);
    var current = $d4d78fe6c9b19203$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $d4d78fe6c9b19203$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $d4d78fe6c9b19203$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $ltooA.fg)("platform-dst-motion-uplift") ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $d4d78fe6c9b19203$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $d4d78fe6c9b19203$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $d4d78fe6c9b19203$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($d4d78fe6c9b19203$var$ExitingContext);
};
$d4d78fe6c9b19203$var$ExitingPersistence.displayName = "ExitingPersistence";
var $d4d78fe6c9b19203$export$2e2bcd8739ae039 = $d4d78fe6c9b19203$var$ExitingPersistence;


var $acw62 = parcelRequire("acw62");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $eb221847c1dd7bbf$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $eb221847c1dd7bbf$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$eb221847c1dd7bbf$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $eb221847c1dd7bbf$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($eb221847c1dd7bbf$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$eb221847c1dd7bbf$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $eb221847c1dd7bbf$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $eb221847c1dd7bbf$export$ff7706047246b98b = function prefersReducedMotion() {
    return $eb221847c1dd7bbf$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $70e78348cd8c44d9$export$368bacef0dacbe05 = 25;
var $70e78348cd8c44d9$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $70e78348cd8c44d9$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $70e78348cd8c44d9$export$30fa1a2e62ae150c = {
    none: $70e78348cd8c44d9$export$38b928a7167ce124.none,
    small: $70e78348cd8c44d9$export$38b928a7167ce124.small * $70e78348cd8c44d9$var$EXITING_MOTION_MULTIPLIER,
    medium: $70e78348cd8c44d9$export$38b928a7167ce124.medium * $70e78348cd8c44d9$var$EXITING_MOTION_MULTIPLIER,
    large: $70e78348cd8c44d9$export$38b928a7167ce124.large * $70e78348cd8c44d9$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
// Handle both browser and Node.js environments
var $5ecd6d8e1090f4cd$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $5ecd6d8e1090f4cd$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $5ecd6d8e1090f4cd$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $5ecd6d8e1090f4cd$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $5ecd6d8e1090f4cd$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $a7741df3fb805904$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $e2ee0a296606657a$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $a8924548ac33c590$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $0893ab51d3631fdb$export$2e2bcd8739ae039)
    };
});
var $a8924548ac33c590$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $e2ee0a296606657a$export$c485849f2e393253)();
    var context = (0, $acw62.useContext)($a8924548ac33c590$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $a8924548ac33c590$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $a7741df3fb805904$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a8924548ac33c590$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $a8924548ac33c590$export$2e2bcd8739ae039 = $a8924548ac33c590$var$StaggeredEntrance;


var $b0ee5ca0bfcb577d$var$zoomIn = null;
var $b0ee5ca0bfcb577d$var$zoomOut = null;
var $b0ee5ca0bfcb577d$var$fadeIn = null;
var $b0ee5ca0bfcb577d$var$fadeOut = null;
var $b0ee5ca0bfcb577d$var$fadeInFromTop = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromTop = null;
var $b0ee5ca0bfcb577d$var$fadeInFromLeft = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromLeft = null;
var $b0ee5ca0bfcb577d$var$fadeInFromBottom = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromBottom = null;
var $b0ee5ca0bfcb577d$var$fadeInFromRight = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromRight = null;
var $b0ee5ca0bfcb577d$var$fadeInFromTopConstant = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromTopConstant = null;
var $b0ee5ca0bfcb577d$var$fadeInFromLeftConstant = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromLeftConstant = null;
var $b0ee5ca0bfcb577d$var$fadeInFromBottomConstant = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromBottomConstant = null;
var $b0ee5ca0bfcb577d$var$fadeInFromRightConstant = null;
var $b0ee5ca0bfcb577d$var$fadeOutFromRightConstant = null;
var $b0ee5ca0bfcb577d$var$slideInFromTop = null;
var $b0ee5ca0bfcb577d$var$slideOutFromTop = null;
var $b0ee5ca0bfcb577d$var$slideInFromRight = null;
var $b0ee5ca0bfcb577d$var$slideOutFromRight = null;
var $b0ee5ca0bfcb577d$var$slideInFromBottom = null;
var $b0ee5ca0bfcb577d$var$slideOutFromBottom = null;
var $b0ee5ca0bfcb577d$var$slideInFromLeft = null;
var $b0ee5ca0bfcb577d$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b0ee5ca0bfcb577d$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $a8924548ac33c590$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $d4d78fe6c9b19203$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $5ecd6d8e1090f4cd$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $eb221847c1dd7bbf$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $70e78348cd8c44d9$export$30fa1a2e62ae150c)[duration] : (0, $70e78348cd8c44d9$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-40-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === "ease-in-60-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === "ease-in-80-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-40-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-60-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-80-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $b0ee5ca0bfcb577d$export$2e2bcd8739ae039 = $b0ee5ca0bfcb577d$var$EnteringMotion;


var $0783a0a34bcaaa29$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $0783a0a34bcaaa29$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $0783a0a34bcaaa29$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0ee5ca0bfcb577d$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $0783a0a34bcaaa29$export$2e2bcd8739ae039 = $0783a0a34bcaaa29$var$FadeIn;



var $ltooA = parcelRequire("ltooA");

var $cMeaX = parcelRequire("cMeaX");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $fOd0O = parcelRequire("fOd0O");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");


var $h1Oiy = parcelRequire("h1Oiy");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $g5Zhu = parcelRequire("g5Zhu");

var $ltooA = parcelRequire("ltooA");

var $A96et = parcelRequire("A96et");

var $d5ByG = parcelRequire("d5ByG");

var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $d5ByG = parcelRequire("d5ByG");
var $7f6f8ee962659794$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape",
    "motion"
];
var $7f6f8ee962659794$var$customThemeOptions = "UNSAFE_themeOptions";
var $7f6f8ee962659794$var$isThemeKind = function isThemeKind(themeKind) {
    return $7f6f8ee962659794$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $7f6f8ee962659794$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $d5ByG.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $7f6f8ee962659794$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $7f6f8ee962659794$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ")// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $7f6f8ee962659794$var$isColorMode(id)) themeObject[kind] = id;
        if ($7f6f8ee962659794$var$isThemeKind(kind) && $7f6f8ee962659794$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $7f6f8ee962659794$var$customThemeOptions) try {
            themeObject[$7f6f8ee962659794$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $7f6f8ee962659794$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $7f6f8ee962659794$var$isColorMode(id) || // custom theme state
        kind === $7f6f8ee962659794$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $7f6f8ee962659794$var$isThemeKind(kind) && typeof id === "string" && $7f6f8ee962659794$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};



var $2ddH8 = parcelRequire("2ddH8");

var $jbywj = parcelRequire("jbywj");
function $f487e9e2b26ab247$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f487e9e2b26ab247$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f487e9e2b26ab247$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f487e9e2b26ab247$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f487e9e2b26ab247$var$defaultColorMode = "light";
var $f487e9e2b26ab247$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $f487e9e2b26ab247$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $d5ByG.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $d5ByG.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $d5ByG.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $d5ByG.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $d5ByG.themeStateDefaults)["motion"]() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $d5ByG.themeStateDefaults)["shape"]() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $d5ByG.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $d5ByG.themeStateDefaults)["typography"] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $d5ByG.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $7f6f8ee962659794$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $A96et.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $A96et.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $f487e9e2b26ab247$var$defaultColorMode : colorMode);
    if ((0, $ltooA.fg)("platform_increased-contrast-themes")) result = $f487e9e2b26ab247$var$_objectSpread($f487e9e2b26ab247$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $A96et.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $f487e9e2b26ab247$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $2ddH8.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $jbywj.hash)(optionString);
        result[0, $A96et.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $f487e9e2b26ab247$export$2e2bcd8739ae039 = $f487e9e2b26ab247$var$getThemeHtmlAttrs;


var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");

var $g5Zhu = parcelRequire("g5Zhu");

var $A96et = parcelRequire("A96et");

var $d5ByG = parcelRequire("d5ByG");

function $16600c9e822da5a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16600c9e822da5a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16600c9e822da5a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16600c9e822da5a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $16600c9e822da5a0$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $d5ByG.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $16600c9e822da5a0$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $A96et.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $A96et.THEME_DATA_ATTRIBUTE)) || "";
    return $16600c9e822da5a0$var$_objectSpread($16600c9e822da5a0$var$_objectSpread({}, (0, $7f6f8ee962659794$export$f19b488f7c0547ee)(theme)), $16600c9e822da5a0$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $16600c9e822da5a0$export$2e2bcd8739ae039 = $16600c9e822da5a0$var$getGlobalTheme;



var $d5ByG = parcelRequire("d5ByG");

var $2ddH8 = parcelRequire("2ddH8");

var $02Ztr = parcelRequire("02Ztr");

var $ltooA = parcelRequire("ltooA");


var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $A96et = parcelRequire("A96et");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $49ff22dfb2dd925d$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("lKBXP"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("1LwJp"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("fJtit"));
    },
    "dark": function dark() {
        return (parcelRequire("dBEO0"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("2drUC"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("i8T9x"));
    },
    "spacing": function spacing() {
        return (parcelRequire("lN5ZJ"));
    },
    "typography": function typography() {
        return (parcelRequire("f6LYk"));
    },
    "shape": function shape() {
        return (parcelRequire("fPTwb"));
    },
    "motion": function motion() {
        return (parcelRequire("3ImuY"));
    }
};
var $49ff22dfb2dd925d$export$2e2bcd8739ae039 = $49ff22dfb2dd925d$var$themeImportsMap;



var $A96et = parcelRequire("A96et");
var $32e1becc7b51e788$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $A96et.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $A96et.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $32e1becc7b51e788$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $32e1becc7b51e788$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $49ff22dfb2dd925d$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $32e1becc7b51e788$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $32e1becc7b51e788$export$8662df6937d86fcb = "(prefers-contrast: more)";


var $09815703cb17f9b0$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $09815703cb17f9b0$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $A96et.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $09815703cb17f9b0$var$darkModeMql = $09815703cb17f9b0$var$isMatchMediaAvailable && window.matchMedia((0, $32e1becc7b51e788$export$bb1e815119d30f8b));
var $09815703cb17f9b0$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$09815703cb17f9b0$var$darkModeMql) return "light";
                return $09815703cb17f9b0$var$darkModeMql !== null && $09815703cb17f9b0$var$darkModeMql !== void 0 && $09815703cb17f9b0$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($09815703cb17f9b0$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $8fY35.bind)($09815703cb17f9b0$var$darkModeMql, {
                    type: "change",
                    listener: $09815703cb17f9b0$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $09815703cb17f9b0$var$SingletonColorModeObserver = new $09815703cb17f9b0$var$ColorModeObserver();
var $09815703cb17f9b0$export$2e2bcd8739ae039 = $09815703cb17f9b0$var$SingletonColorModeObserver;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $A96et = parcelRequire("A96et");

var $97fa155da39dd03d$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $97fa155da39dd03d$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $A96et.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $97fa155da39dd03d$var$contrastModeMql = $97fa155da39dd03d$var$isMatchMediaAvailable && window.matchMedia((0, $32e1becc7b51e788$export$8662df6937d86fcb));
var $97fa155da39dd03d$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$97fa155da39dd03d$var$contrastModeMql) return "no-preference";
                return $97fa155da39dd03d$var$contrastModeMql !== null && $97fa155da39dd03d$var$contrastModeMql !== void 0 && $97fa155da39dd03d$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($97fa155da39dd03d$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $8fY35.bind)($97fa155da39dd03d$var$contrastModeMql, {
                    type: "change",
                    listener: $97fa155da39dd03d$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $97fa155da39dd03d$var$SingletonContrastModeObserver = new $97fa155da39dd03d$var$ContrastModeObserver();
var $97fa155da39dd03d$export$2e2bcd8739ae039 = $97fa155da39dd03d$var$SingletonContrastModeObserver;


function $469aca69809a32c5$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $09815703cb17f9b0$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $09815703cb17f9b0$export$2e2bcd8739ae039).bind();
    } else (0, $09815703cb17f9b0$export$2e2bcd8739ae039).unbind();
    if ((0, $ltooA.fg)("platform_increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $97fa155da39dd03d$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $97fa155da39dd03d$export$2e2bcd8739ae039).bind();
        } else (0, $97fa155da39dd03d$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $f487e9e2b26ab247$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $09815703cb17f9b0$export$2e2bcd8739ae039).unbind();
        if ((0, $ltooA.fg)("platform_increased-contrast-themes")) (0, $97fa155da39dd03d$export$2e2bcd8739ae039).unbind();
    };
}



var $375e4 = parcelRequire("375e4");

var $fUHKi = parcelRequire("fUHKi");

var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $d5ByG = parcelRequire("d5ByG");
function $66a3b1bd3d1fa0e7$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $d5ByG.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $d2fe351a6a1d8bff$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $ltooA.fg)("platform_increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $66a3b1bd3d1fa0e7$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $ltooA.fg)("platform_increased-contrast-themes")) {
            var increasedContrastTheme = (0, $66a3b1bd3d1fa0e7$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themePreferences));
};
var $d2fe351a6a1d8bff$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themeOverridePreferences));
};



function $254d36839a439820$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $254d36839a439820$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $254d36839a439820$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $254d36839a439820$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $254d36839a439820$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $254d36839a439820$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $254d36839a439820$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $254d36839a439820$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $254d36839a439820$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $254d36839a439820$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $254d36839a439820$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === "function" ? nextThemeState($254d36839a439820$var$_objectSpread($254d36839a439820$var$_objectSpread({}, (0, $d5ByG.themeStateDefaults)), {}, {
                        typography: (0, $d5ByG.themeStateDefaults)["typography"],
                        shape: (0, $d5ByG.themeStateDefaults)["shape"](),
                        motion: (0, $d5ByG.themeStateDefaults)["motion"]()
                    }, (0, $16600c9e822da5a0$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $d5ByG.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $d5ByG.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $d5ByG.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $d5ByG.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $d5ByG.themeStateDefaults)["shape"]() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $d5ByG.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $d5ByG.themeStateDefaults)["typography"] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $d5ByG.themeStateDefaults)["motion"]() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $d5ByG.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $ltooA.fg)("platform_increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $d2fe351a6a1d8bff$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $32e1becc7b51e788$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $2ddH8.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $d5ByG.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $375e4.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("lQLK6"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $d2fe351a6a1d8bff$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $254d36839a439820$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $469aca69809a32c5$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $254d36839a439820$export$2e2bcd8739ae039 = $254d36839a439820$var$setGlobalTheme;


var $A96et = parcelRequire("A96et");

var $acw62 = parcelRequire("acw62");
var $8ee5685daa21224d$export$7981b2444296e410 = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $8ee5685daa21224d$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $acw62.useContext)($8ee5685daa21224d$export$7981b2444296e410);
};
var $8ee5685daa21224d$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $8ee5685daa21224d$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $acw62.useContext)($8ee5685daa21224d$export$d2def9838ca456c0);
};



var $acw62 = parcelRequire("acw62");
var $b53c990299c70b91$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $b53c990299c70b91$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");
var $0062e37175f1deb4$export$332347eeb335453c = /*#__PURE__*/ (0, $acw62.createContext)(false);



var $acw62 = parcelRequire("acw62");
var $a3b6658998fdb629$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $a3b6658998fdb629$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");

var $28a5680485ac5d88$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)((0, $0062e37175f1deb4$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
var $8df4118f2b1be45c$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== "undefined") return document;
    return null;
};





var $A96et = parcelRequire("A96et");
function $a8571f70a1328ac6$export$835a0dc855d02822(themeId) {
    var doc = (0, $8df4118f2b1be45c$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $A96et.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
}


var $487830e0bed1a20e$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $a8571f70a1328ac6$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $49ff22dfb2dd925d$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $487830e0bed1a20e$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $8df4118f2b1be45c$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement("style");
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $a8571f70a1328ac6$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $487830e0bed1a20e$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $487830e0bed1a20e$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $487830e0bed1a20e$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $487830e0bed1a20e$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($487830e0bed1a20e$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $91ec136ed340d382$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91ec136ed340d382$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91ec136ed340d382$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91ec136ed340d382$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $91ec136ed340d382$var$defaultThemeSettings = {
    dark: "dark",
    light: "light",
    spacing: "spacing",
    typography: "typography"
};
var $91ec136ed340d382$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
var $91ec136ed340d382$var$prefersDarkModeMql = $91ec136ed340d382$var$isMatchMediaAvailable ? window.matchMedia("(prefers-color-scheme: dark)") : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $91ec136ed340d382$var$getReconciledColorMode(colorMode) {
    if (colorMode === "auto") return $91ec136ed340d382$var$prefersDarkModeMql !== null && $91ec136ed340d382$var$prefersDarkModeMql !== void 0 && $91ec136ed340d382$var$prefersDarkModeMql.matches ? "dark" : "light";
    return colorMode;
}
var $91ec136ed340d382$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $91ec136ed340d382$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? "auto" : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $acw62.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $acw62.useState)($91ec136ed340d382$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return $91ec136ed340d382$var$_objectSpread($91ec136ed340d382$var$_objectSpread({}, $91ec136ed340d382$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $acw62.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($91ec136ed340d382$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $acw62.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $91ec136ed340d382$var$_objectSpread($91ec136ed340d382$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $acw62.useRef)(null);
    var isInsideAppProvider = (0, $8ee5685daa21224d$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $8ee5685daa21224d$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $28a5680485ac5d88$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $acw62.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $254d36839a439820$export$2e2bcd8739ae039)($91ec136ed340d382$var$_objectSpread($91ec136ed340d382$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $487830e0bed1a20e$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $acw62.useEffect)(function() {
        if (!$91ec136ed340d382$var$prefersDarkModeMql) return;
        var unbindListener = (0, $8fY35.bind)($91ec136ed340d382$var$prefersDarkModeMql, {
            type: "change",
            listener: function listener(event) {
                if (chosenColorMode === "auto") setReconciledColorMode(event.matches ? "dark" : "light");
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $91ec136ed340d382$var$_objectSpread($91ec136ed340d382$var$_objectSpread({}, (0, $f487e9e2b26ab247$export$2e2bcd8739ae039)($91ec136ed340d382$var$_objectSpread($91ec136ed340d382$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $A96et.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0062e37175f1deb4$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b53c990299c70b91$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b53c990299c70b91$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a3b6658998fdb629$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a3b6658998fdb629$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, attrs, {
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            $91ec136ed340d382$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $91ec136ed340d382$export$2e2bcd8739ae039 = $91ec136ed340d382$var$ThemeProvider;


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $A96et = parcelRequire("A96et");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $fbe246988ec09d71$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $16600c9e822da5a0$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $A96et.THEME_DATA_ATTRIBUTE),
                            (0, $A96et.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($fbe246988ec09d71$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($fbe246988ec09d71$export$2e2bcd8739ae039, "callbacks", new Set());



function $2f582f6852375789$export$20f3076712c8dfa() {
    var value = (0, $acw62.useContext)((0, $b53c990299c70b91$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $16600c9e822da5a0$export$2e2bcd8739ae039)();
    var _useState = (0, $acw62.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || "light"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $fbe246988ec09d71$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || "light");
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}


var $a54113a028562f98$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $a54113a028562f98$export$72f415121273627e = "body > .atlaskit-portal-container";
var $a54113a028562f98$export$13f57c02915787b3 = "atlaskit-portal";


var $1a353c2f2ba3bebb$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $a54113a028562f98$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $1a353c2f2ba3bebb$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $1a353c2f2ba3bebb$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $a54113a028562f98$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $a54113a028562f98$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $1a353c2f2ba3bebb$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $1a353c2f2ba3bebb$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $1a353c2f2ba3bebb$var$getPortalParent().removeChild(container);
};
var $1a353c2f2ba3bebb$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $1a353c2f2ba3bebb$var$getPortalParent().appendChild(container);
};
var $1a353c2f2ba3bebb$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $1a353c2f2ba3bebb$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($1a353c2f2ba3bebb$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $a54113a028562f98$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $1a353c2f2ba3bebb$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($1a353c2f2ba3bebb$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $a54113a028562f98$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $a54113a028562f98$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $1a353c2f2ba3bebb$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $8019377ab309d99d$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $1a353c2f2ba3bebb$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $2f582f6852375789$export$20f3076712c8dfa)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $1a353c2f2ba3bebb$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $1a353c2f2ba3bebb$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $91ec136ed340d382$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
var $c9aca49190328c37$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $166831d93597259b$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $2f582f6852375789$export$20f3076712c8dfa)();
    (0, $c9aca49190328c37$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $1a353c2f2ba3bebb$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $1a353c2f2ba3bebb$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $91ec136ed340d382$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $800b008fcdbd5f13$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $c9aca49190328c37$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $800b008fcdbd5f13$export$2e2bcd8739ae039 = $800b008fcdbd5f13$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $54304884fd82aa6d$export$ed5835cc67e87f72 = "akPortalMount";
var $54304884fd82aa6d$export$80816bd900e5bd00 = "akPortalUnmount";


var $fa93860de5f95f63$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $fa93860de5f95f63$var$getLayerName = function getLayerName(zIndex) {
    return $fa93860de5f95f63$var$zIndexToName.hasOwnProperty(zIndex) ? $fa93860de5f95f63$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $fa93860de5f95f63$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $fa93860de5f95f63$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $fa93860de5f95f63$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $fa93860de5f95f63$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $be799f03653d4e3b$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $fa93860de5f95f63$export$2e2bcd8739ae039)((0, $54304884fd82aa6d$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $fa93860de5f95f63$export$2e2bcd8739ae039)((0, $54304884fd82aa6d$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $be799f03653d4e3b$export$2e2bcd8739ae039 = $be799f03653d4e3b$var$useFirePortalEvent;


function $9168ef770719cc96$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $800b008fcdbd5f13$export$2e2bcd8739ae039)(mountStrategy);
    (0, $be799f03653d4e3b$export$2e2bcd8739ae039)(zIndex);
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8019377ab309d99d$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $166831d93597259b$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $be34e3de4de8a331$var$printed = {};
function $be34e3de4de8a331$export$2e2bcd8739ae039(message) {
    if ($be34e3de4de8a331$var$printed[message]) return;
    $be34e3de4de8a331$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $ce6bd5a0ee81205d$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $be34e3de4de8a331$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ce6bd5a0ee81205d$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


// Reds
var $84f5d982e4ad85d8$export$4b84fd0e2c617bd = "#FFEBE6";
var $84f5d982e4ad85d8$export$b34b069eff244586 = "#FFBDAD";
var $84f5d982e4ad85d8$export$be802dd0d8b57f35 = "#FF8F73";
var $84f5d982e4ad85d8$export$60847d42f9da92a6 = "#FF7452";
var $84f5d982e4ad85d8$export$4a7404f376229999 = "#FF5630";
var $84f5d982e4ad85d8$export$2010d0fb4295b346 = "#DE350B";
var $84f5d982e4ad85d8$export$2837b5a1a71d5c02 = "#BF2600";
var $84f5d982e4ad85d8$export$8d9596b529bbb9cf = "#FFFAE6";
var $84f5d982e4ad85d8$export$41060a744ab0b7ae = "#FFF0B3";
var $84f5d982e4ad85d8$export$1cc05bbbf340e559 = "#FFE380";
var $84f5d982e4ad85d8$export$5aae31392d72caaa = "#FFC400";
var $84f5d982e4ad85d8$export$c6930421db9fa514 = "#FFAB00";
var $84f5d982e4ad85d8$export$59619663aa6500fb = "#FF991F";
var $84f5d982e4ad85d8$export$874739ea9e379ab6 = "#FF8B00";
var $84f5d982e4ad85d8$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $84f5d982e4ad85d8$export$69a3bf21b9686c2b = "#ABF5D1";
var $84f5d982e4ad85d8$export$afbce1382ec95f73 = "#79F2C0";
var $84f5d982e4ad85d8$export$747d86715d4175de = "#57D9A3";
var $84f5d982e4ad85d8$export$940e1f69e873f202 = "#36B37E";
var $84f5d982e4ad85d8$export$a49394138f7b8e85 = "#00875A";
var $84f5d982e4ad85d8$export$6fa04827ac68a4fb = "#006644";
var $84f5d982e4ad85d8$export$226de0355ed012f8 = "#DEEBFF";
var $84f5d982e4ad85d8$export$8c13c2ee36917869 = "#B3D4FF";
var $84f5d982e4ad85d8$export$ecfc1dff386a3e7a = "#4C9AFF";
var $84f5d982e4ad85d8$export$215b7063051591f1 = "#2684FF";
var $84f5d982e4ad85d8$export$e62e8919cca44969 = "#0065FF";
var $84f5d982e4ad85d8$export$b3de0ae08da2ce64 = "#0052CC";
var $84f5d982e4ad85d8$export$a6ee3d71bc067634 = "#0747A6";
var $84f5d982e4ad85d8$export$67f15409e87642a1 = "#669DF1";
var $84f5d982e4ad85d8$export$f0539dbc42dbb067 = "#8FB8F6";
var $84f5d982e4ad85d8$export$363e4475840015bb = "#EAE6FF";
var $84f5d982e4ad85d8$export$4b0a4417ed59760f = "#C0B6F2";
var $84f5d982e4ad85d8$export$6011520a64d9a187 = "#998DD9";
var $84f5d982e4ad85d8$export$a7175d4e9206bc80 = "#8777D9";
var $84f5d982e4ad85d8$export$b48405b95304b5a1 = "#6554C0";
var $84f5d982e4ad85d8$export$c71e4279dd54a18d = "#5243AA";
var $84f5d982e4ad85d8$export$147899de772240ec = "#403294";
var $84f5d982e4ad85d8$export$2cf711fe14c66f06 = "#E6FCFF";
var $84f5d982e4ad85d8$export$7a8f4d33f6f9772c = "#B3F5FF";
var $84f5d982e4ad85d8$export$776c9c497ef08533 = "#79E2F2";
var $84f5d982e4ad85d8$export$69cb3ca10c1e330e = "#00C7E6";
var $84f5d982e4ad85d8$export$9dc1ef0f3f48059b = "#00B8D9";
var $84f5d982e4ad85d8$export$7c835c78b6fcdef8 = "#00A3BF";
var $84f5d982e4ad85d8$export$6036577f95c3877e = "#008DA6";
var $84f5d982e4ad85d8$export$29a4f05edc054374 = "#FFFFFF";
var $84f5d982e4ad85d8$export$e655ef011c4aa1a2 = "#FAFBFC";
var $84f5d982e4ad85d8$export$9fdfb749e33cdf97 = "#F4F5F7";
var $84f5d982e4ad85d8$export$3e51e8f1440314ba = "#EBECF0";
var $84f5d982e4ad85d8$export$1ce2d1575d444ceb = "#DFE1E6";
var $84f5d982e4ad85d8$export$8754fc7e6d8b3000 = "#C1C7D0";
var $84f5d982e4ad85d8$export$c2e91cbeada39b8b = "#B3BAC5";
var $84f5d982e4ad85d8$export$5f71e19f3a7ad9de = "#A5ADBA";
var $84f5d982e4ad85d8$export$eaa8c8a70ac22806 = "#97A0AF";
var $84f5d982e4ad85d8$export$7c87d337fb91a97d = "#8993A4";
var $84f5d982e4ad85d8$export$d6447c357493214f = "#7A869A";
var $84f5d982e4ad85d8$export$f563ee71e9ee74cd = "#6B778C";
var $84f5d982e4ad85d8$export$e2ef2124cf4024b1 = "#5E6C84";
var $84f5d982e4ad85d8$export$eece5f492e429f08 = "#505F79";
var $84f5d982e4ad85d8$export$c39c0fe0f26207ae = "#42526E";
var $84f5d982e4ad85d8$export$7090862dc3038a9f = "#344563";
var $84f5d982e4ad85d8$export$ad0bacf983b7ddaa = "#253858";
var $84f5d982e4ad85d8$export$7d61b15e0da132af = "#172B4D";
var $84f5d982e4ad85d8$export$fbda843f0a27fe96 = "#091E42";
var $84f5d982e4ad85d8$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $84f5d982e4ad85d8$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $84f5d982e4ad85d8$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $84f5d982e4ad85d8$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $84f5d982e4ad85d8$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $84f5d982e4ad85d8$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $84f5d982e4ad85d8$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $84f5d982e4ad85d8$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $84f5d982e4ad85d8$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $84f5d982e4ad85d8$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $84f5d982e4ad85d8$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $84f5d982e4ad85d8$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $84f5d982e4ad85d8$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $84f5d982e4ad85d8$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $84f5d982e4ad85d8$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $84f5d982e4ad85d8$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $84f5d982e4ad85d8$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $84f5d982e4ad85d8$export$2f6319cf7d736c2a = "#E6EDFA";
var $84f5d982e4ad85d8$export$95126bc8884d6634 = "#DCE5F5";
var $84f5d982e4ad85d8$export$8338d8c35d44ff1 = "#CED9EB";
var $84f5d982e4ad85d8$export$5368d76ae4fbbda7 = "#B8C7E0";
var $84f5d982e4ad85d8$export$9f0a771d16ec8d36 = "#ABBBD6";
var $84f5d982e4ad85d8$export$abcf8c38338b4aa5 = "#9FB0CC";
var $84f5d982e4ad85d8$export$97e81faa16a182c7 = "#8C9CB8";
var $84f5d982e4ad85d8$export$bfe21c59123ecf33 = "#7988A3";
var $84f5d982e4ad85d8$export$ee82aa2ea6a1558 = "#67758F";
var $84f5d982e4ad85d8$export$682927c6ed76be02 = "#56637A";
var $84f5d982e4ad85d8$export$91fd9994c5be9757 = "#455166";
var $84f5d982e4ad85d8$export$d281fbfe3cff2df6 = "#3B475C";
var $84f5d982e4ad85d8$export$3902c91d8b98a753 = "#313D52";
var $84f5d982e4ad85d8$export$8e8133c1ba5845b5 = "#283447";
var $84f5d982e4ad85d8$export$33ff357f6620b39 = "#202B3D";
var $84f5d982e4ad85d8$export$633847cf062b69e0 = "#1B2638";
var $84f5d982e4ad85d8$export$9776a6e503bdbf76 = "#121A29";
var $84f5d982e4ad85d8$export$6c813d5160dff5db = "#0E1624";
var $84f5d982e4ad85d8$export$3d4f271a500072a = "#0D1424";
var $84f5d982e4ad85d8$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $84f5d982e4ad85d8$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $84f5d982e4ad85d8$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $84f5d982e4ad85d8$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $84f5d982e4ad85d8$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $84f5d982e4ad85d8$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $84f5d982e4ad85d8$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $84f5d982e4ad85d8$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $84f5d982e4ad85d8$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $84f5d982e4ad85d8$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $84f5d982e4ad85d8$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $84f5d982e4ad85d8$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $84f5d982e4ad85d8$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $84f5d982e4ad85d8$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $84f5d982e4ad85d8$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $84f5d982e4ad85d8$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $84f5d982e4ad85d8$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $84f5d982e4ad85d8$export$d2adc5dedf09fced = "#292A2E";
var $84f5d982e4ad85d8$export$f51762073d2bb381 = "#94C748";
var $84f5d982e4ad85d8$export$95e26d54def96891 = "#B3DF72";


var $11065d9fefd0f175$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $11065d9fefd0f175$export$c93026a968943f95 = "light";
var $11065d9fefd0f175$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $11065d9fefd0f175$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $84f5d982e4ad85d8$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $ce6bd5a0ee81205d$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $11065d9fefd0f175$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $11065d9fefd0f175$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $11065d9fefd0f175$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $ce6bd5a0ee81205d$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $11065d9fefd0f175$export$ba1d834b86d72a09 = $11065d9fefd0f175$export$a1b3edb637fb4f35;
var $11065d9fefd0f175$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $84f5d982e4ad85d8$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $84f5d982e4ad85d8$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $84f5d982e4ad85d8$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $8fY35 = parcelRequire("8fY35");
var $844fad606937166e$var$registrations = new Set();
var $844fad606937166e$var$cleanupEndEventListeners = null;
function $844fad606937166e$var$onDragStart() {
    if ($844fad606937166e$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $844fad606937166e$var$cleanupEndEventListeners = (0, $8fY35.bindAll)(window, [
        {
            type: "dragend",
            listener: $844fad606937166e$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $844fad606937166e$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $844fad606937166e$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($844fad606937166e$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $844fad606937166e$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $844fad606937166e$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $844fad606937166e$var$cleanupEndEventListeners = null;
    var clone = Array.from($844fad606937166e$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $844fad606937166e$var$bindStartEvents() {
    return (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: $844fad606937166e$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $844fad606937166e$var$onDragStart
        }
    ]);
}
var $844fad606937166e$var$cleanupStartEventListeners = null;
function $844fad606937166e$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$844fad606937166e$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $844fad606937166e$var$cleanupStartEventListeners = $844fad606937166e$var$bindStartEvents();
    $844fad606937166e$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $844fad606937166e$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $844fad606937166e$var$registrations.delete(registration);
        if ($844fad606937166e$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $844fad606937166e$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $844fad606937166e$var$cleanupStartEventListeners = null;
        }
    };
}


function $0759fb068d7c9616$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $6c0918569cf31c74$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === "mouse") return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === "mouse-x") return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === "mouse-y") return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $ltooA = parcelRequire("ltooA");
var $ff1f8895cbab091f$var$delayId = null;
function $ff1f8895cbab091f$export$eaf678f6f93f5250() {
    if ($ff1f8895cbab091f$var$delayId != null) {
        window.clearTimeout($ff1f8895cbab091f$var$delayId);
        $ff1f8895cbab091f$var$delayId = null;
    }
}
function $ff1f8895cbab091f$export$5f4d6617421d489b(fn, delay) {
    $ff1f8895cbab091f$export$eaf678f6f93f5250();
    $ff1f8895cbab091f$var$delayId = window.setTimeout(function() {
        $ff1f8895cbab091f$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $9c9623b5513e4bc4$var$active = null;
function $9c9623b5513e4bc4$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($9c9623b5513e4bc4$var$active && $9c9623b5513e4bc4$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $ff1f8895cbab091f$export$eaf678f6f93f5250)();
            $9c9623b5513e4bc4$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $ff1f8895cbab091f$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $ff1f8895cbab091f$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $ff1f8895cbab091f$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($9c9623b5513e4bc4$var$active && $9c9623b5513e4bc4$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($9c9623b5513e4bc4$var$active) {
            (0, $ff1f8895cbab091f$export$eaf678f6f93f5250)();
            $9c9623b5513e4bc4$var$active.entry.hide({
                isImmediate: true
            });
            $9c9623b5513e4bc4$var$active.entry.done();
            $9c9623b5513e4bc4$var$active = null;
        }
        // this tooltip is now the active tooltip
        $9c9623b5513e4bc4$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $ff1f8895cbab091f$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? undefined : getInitialMouse(),
        mousePos: entry.source.type === "mouse" && (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



function $b4b6c907e9ce5d3a$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $b0c138cae604a466$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $adea6d8dd82c01b9$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $adea6d8dd82c01b9$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            $adea6d8dd82c01b9$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $acw62.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
                $adea6d8dd82c01b9$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $e9713a812f27adaa$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $e9713a812f27adaa$var$TooltipPrimitive = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $acw62.createElement("div", {
        role: "tooltip",
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $acw62.createElement((0, $adea6d8dd82c01b9$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$e9713a812f27adaa$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $e9713a812f27adaa$export$2e2bcd8739ae039 = $e9713a812f27adaa$var$TooltipPrimitive;


var $ff54962aeb462d93$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $ff54962aeb462d93$var$TooltipContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $acw62.createElement((0, $e9713a812f27adaa$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $0f64162dd28c6e9a$export$2e2bcd8739ae039)([
            $ff54962aeb462d93$var$styles.base,
            truncate && $ff54962aeb462d93$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$ff54962aeb462d93$var$TooltipContainer.displayName = "TooltipContainer";
var $ff54962aeb462d93$export$2e2bcd8739ae039 = $ff54962aeb462d93$var$TooltipContainer;


function $89c11d010b5ee036$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89c11d010b5ee036$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89c11d010b5ee036$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89c11d010b5ee036$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89c11d010b5ee036$var$tooltipZIndex = (0, $11065d9fefd0f175$export$7be255094ccdc533).tooltip();
var $89c11d010b5ee036$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.0.1"
};
// Inverts motion direction
var $89c11d010b5ee036$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $89c11d010b5ee036$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $89c11d010b5ee036$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $ff54962aeb462d93$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $0893ab51d3631fdb$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === "mouse" || position === "mouse-y" || position === "mouse-x";
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $8b1dadd64a05a59e$export$1a04351537078b55)($89c11d010b5ee036$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $89c11d010b5ee036$var$analyticsAttributes));
    var onHideHandler = (0, $8b1dadd64a05a59e$export$1a04351537078b55)($89c11d010b5ee036$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $89c11d010b5ee036$var$analyticsAttributes));
    var apiRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $acw62.useRef)(null);
    var containerRef = (0, $acw62.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $acw62.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $acw62.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $fb4c1b8ea1a0e77e$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $acw62.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $acw62.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        return (0, $844fad606937166e$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $acw62.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? "fade-in" : "show-immediate");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done,
            shouldAlwaysFadeIn: (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $9c9623b5513e4bc4$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $acw62.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $5e96ead42d7f056f$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $acw62.useEffect)(function() {
        if (state === "hide") return 0, $0893ab51d3631fdb$export$2e2bcd8739ae039;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? undefined : (0, $0759fb068d7c9616$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback")) apiRef.current.mousePosition = (0, $0759fb068d7c9616$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $acw62.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $acw62.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(":focus-visible")) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $acw62.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $acw62.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $acw62.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $8501596c6516e42a$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback")) return (0, $6c0918569cf31c74$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback")) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $b4b6c907e9ce5d3a$export$2e2bcd8739ae039)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $acw62.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $ltooA.fg)("platform_dst_nav4_side_nav_resize_tooltip_feedback") ? (0, $acw62.Fragment) : $89c11d010b5ee036$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children($89c11d010b5ee036$var$_objectSpread($89c11d010b5ee036$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cMeaX.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $89c11d010b5ee036$var$invertedDirection[$89c11d010b5ee036$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4d78fe6c9b19203$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0783a0a34bcaaa29$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $89c11d010b5ee036$var$_objectSpread($89c11d010b5ee036$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $89c11d010b5ee036$export$2e2bcd8739ae039 = $89c11d010b5ee036$var$Tooltip;
var $89c11d010b5ee036$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9168ef770719cc96$export$2e2bcd8739ae039), {
        zIndex: $89c11d010b5ee036$var$tooltipZIndex
    }, children);
};






var $361fce14cc02175c$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $361fce14cc02175c$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $361fce14cc02175c$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $361fce14cc02175c$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $361fce14cc02175c$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45be0b1e9cb22013$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57e8f8a209e3fa2e$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad17a330ea897dec$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f26887e6ba26112a$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89c11d010b5ee036$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45be0b1e9cb22013$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $4ecf0ab45c3aacd5$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57e8f8a209e3fa2e$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad17a330ea897dec$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f26887e6ba26112a$export$2e2bcd8739ae039), null, label)));
    });
}));
$361fce14cc02175c$var$IconButton.displayName = "IconButton";
var $361fce14cc02175c$export$2e2bcd8739ae039 = $361fce14cc02175c$var$IconButton;


/* eslint-disable max-len */ 
var $acw62 = parcelRequire("acw62");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");
var $aa4891c2a990e3cf$export$4ef52930e33717cd = "data-theme";
var $aa4891c2a990e3cf$export$a00eac3f8684bcd0 = "data-color-mode";
var $aa4891c2a990e3cf$export$2112803007239c61 = "data-contrast-mode";
var $aa4891c2a990e3cf$export$352e418ed5b6193a = "data-custom-theme";
var $aa4891c2a990e3cf$export$2faeed762aac6741 = "light";
var $aa4891c2a990e3cf$export$6f0c6fb8c80fcc92 = "ds";
var $aa4891c2a990e3cf$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $aa4891c2a990e3cf$export$dddac1532e822863 = "--".concat($aa4891c2a990e3cf$export$6f0c6fb8c80fcc92, "-token-not-found");
var $aa4891c2a990e3cf$export$9d7b58831ae93caa = "--".concat($aa4891c2a990e3cf$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


var $a197b4a6d0653a69$var$_ref, $a197b4a6d0653a69$var$_process, $a197b4a6d0653a69$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a197b4a6d0653a69$var$TESTS_MODE = ($a197b4a6d0653a69$var$_ref = (globalThis === null || globalThis === void 0 || ($a197b4a6d0653a69$var$_process = globalThis.process) === null || $a197b4a6d0653a69$var$_process === void 0 || ($a197b4a6d0653a69$var$_process = $a197b4a6d0653a69$var$_process.env) === null || $a197b4a6d0653a69$var$_process === void 0 ? void 0 : $a197b4a6d0653a69$var$_process.JEST_WORKER_ID) !== undefined, $a197b4a6d0653a69$var$_ref !== void 0) ? $a197b4a6d0653a69$var$_ref : false;
var $a197b4a6d0653a69$var$DEBUG_MODE = !$a197b4a6d0653a69$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a197b4a6d0653a69$var$_process2 = globalThis.process) === null || $a197b4a6d0653a69$var$_process2 === void 0 || ($a197b4a6d0653a69$var$_process2 = $a197b4a6d0653a69$var$_process2.env) === null || $a197b4a6d0653a69$var$_process2 === void 0 ? void 0 : $a197b4a6d0653a69$var$_process2.NODE_ENV) !== "production";
var $a197b4a6d0653a69$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a197b4a6d0653a69$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $hPtJY = parcelRequire("hPtJY");
var $f83051c5db9b74e4$var$pkgName = "@atlaskit/platform-feature-flags";
var $f83051c5db9b74e4$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $f83051c5db9b74e4$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $f83051c5db9b74e4$var$ENV_ENABLE_PLATFORM_FF = $f83051c5db9b74e4$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $f83051c5db9b74e4$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $f83051c5db9b74e4$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $f83051c5db9b74e4$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $f83051c5db9b74e4$var$ENV_ENABLE_PLATFORM_FF || $f83051c5db9b74e4$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $f83051c5db9b74e4$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $f83051c5db9b74e4$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$f83051c5db9b74e4$var$globalVar[$f83051c5db9b74e4$export$7e41b1b2bdee3f98] = $f83051c5db9b74e4$var$globalVar[$f83051c5db9b74e4$export$7e41b1b2bdee3f98] || $f83051c5db9b74e4$var$DEFAULT_PFF_GLOBAL;
function $f83051c5db9b74e4$export$f2b591175b3e424c(resolver) {
    $f83051c5db9b74e4$var$globalVar[$f83051c5db9b74e4$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $f83051c5db9b74e4$export$6333b6aff9fc6275(flagKey) {
    if ($f83051c5db9b74e4$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $a197b4a6d0653a69$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $f83051c5db9b74e4$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $f83051c5db9b74e4$var$globalVar[$f83051c5db9b74e4$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $a5265e14bc11a3d2$export$ba05d765b8392e5e(flagResolver) {
    (0, $f83051c5db9b74e4$export$f2b591175b3e424c)(flagResolver);
}
function $a5265e14bc11a3d2$export$470e5c2be1411c89(name) {
    return (0, $f83051c5db9b74e4$export$6333b6aff9fc6275)(name);
}
function $a5265e14bc11a3d2$export$b40ec24ac8275656(name) {
    return (0, $f83051c5db9b74e4$export$6333b6aff9fc6275)(name);
}


var $28b2540be6969c9d$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $28b2540be6969c9d$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $28b2540be6969c9d$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $28b2540be6969c9d$export$ba8a43b83ecc69f8 = [];
var $28b2540be6969c9d$export$92ba366331403db2 = [].concat($28b2540be6969c9d$export$7d43e72a58e3283f, $28b2540be6969c9d$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $28b2540be6969c9d$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $28b2540be6969c9d$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $a5265e14bc11a3d2$export$b40ec24ac8275656)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $28b2540be6969c9d$export$2e2bcd8739ae039 = $28b2540be6969c9d$var$themeConfig;



var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $0e82e725690228a5$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $0e82e725690228a5$var$customThemeOptions = "UNSAFE_themeOptions";
var $0e82e725690228a5$var$isThemeKind = function isThemeKind(themeKind) {
    return $0e82e725690228a5$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $0e82e725690228a5$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $28b2540be6969c9d$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $0e82e725690228a5$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $0e82e725690228a5$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $0e82e725690228a5$var$isColorMode(id)) themeObject[kind] = id;
        if ($0e82e725690228a5$var$isThemeKind(kind) && $0e82e725690228a5$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $0e82e725690228a5$var$customThemeOptions) try {
            themeObject[$0e82e725690228a5$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $0e82e725690228a5$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $0e82e725690228a5$var$isColorMode(id) || // custom theme state
        kind === $0e82e725690228a5$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $0e82e725690228a5$var$isThemeKind(kind) && typeof id === "string" && $0e82e725690228a5$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};


function $8f648654cbcd18db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f648654cbcd18db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f648654cbcd18db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f648654cbcd18db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8f648654cbcd18db$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $28b2540be6969c9d$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $8f648654cbcd18db$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $aa4891c2a990e3cf$export$a00eac3f8684bcd0)) || "";
    var theme = element.getAttribute((0, $aa4891c2a990e3cf$export$4ef52930e33717cd)) || "";
    return $8f648654cbcd18db$var$_objectSpread($8f648654cbcd18db$var$_objectSpread({}, (0, $0e82e725690228a5$export$f19b488f7c0547ee)(theme)), $8f648654cbcd18db$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $8f648654cbcd18db$export$2e2bcd8739ae039 = $8f648654cbcd18db$var$getGlobalTheme;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $aa0291323b0fb3c1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $8f648654cbcd18db$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $aa4891c2a990e3cf$export$4ef52930e33717cd),
                            (0, $aa4891c2a990e3cf$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($aa0291323b0fb3c1$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($aa0291323b0fb3c1$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $1757394a691c65fe$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $acw62.useState)((0, $8f648654cbcd18db$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $acw62.useEffect)(function() {
        var observer = new (0, $aa0291323b0fb3c1$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $1757394a691c65fe$export$2e2bcd8739ae039 = $1757394a691c65fe$var$useThemeObserver;


/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $d9eaf70640f32b21$export$438460117ae6b7ee = {
    iconColor: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $d9eaf70640f32b21$export$793fba32aed8942a = {
    iconGradientStart: "inherit",
    iconGradientStop: "inherit"
};
var $d9eaf70640f32b21$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $d9eaf70640f32b21$export$31d7044b7540a6d8 = $d9eaf70640f32b21$export$438460117ae6b7ee;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $105a4049f7064954$export$4b84fd0e2c617bd = "#FFEBE6";
var $105a4049f7064954$export$b34b069eff244586 = "#FFBDAD";
var $105a4049f7064954$export$be802dd0d8b57f35 = "#FF8F73";
var $105a4049f7064954$export$60847d42f9da92a6 = "#FF7452";
var $105a4049f7064954$export$4a7404f376229999 = "#FF5630";
var $105a4049f7064954$export$2010d0fb4295b346 = "#DE350B";
var $105a4049f7064954$export$2837b5a1a71d5c02 = "#BF2600";
var $105a4049f7064954$export$8d9596b529bbb9cf = "#FFFAE6";
var $105a4049f7064954$export$41060a744ab0b7ae = "#FFF0B3";
var $105a4049f7064954$export$1cc05bbbf340e559 = "#FFE380";
var $105a4049f7064954$export$5aae31392d72caaa = "#FFC400";
var $105a4049f7064954$export$c6930421db9fa514 = "#FFAB00";
var $105a4049f7064954$export$59619663aa6500fb = "#FF991F";
var $105a4049f7064954$export$874739ea9e379ab6 = "#FF8B00";
var $105a4049f7064954$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $105a4049f7064954$export$69a3bf21b9686c2b = "#ABF5D1";
var $105a4049f7064954$export$afbce1382ec95f73 = "#79F2C0";
var $105a4049f7064954$export$747d86715d4175de = "#57D9A3";
var $105a4049f7064954$export$940e1f69e873f202 = "#36B37E";
var $105a4049f7064954$export$a49394138f7b8e85 = "#00875A";
var $105a4049f7064954$export$6fa04827ac68a4fb = "#006644";
var $105a4049f7064954$export$226de0355ed012f8 = "#DEEBFF";
var $105a4049f7064954$export$8c13c2ee36917869 = "#B3D4FF";
var $105a4049f7064954$export$ecfc1dff386a3e7a = "#4C9AFF";
var $105a4049f7064954$export$215b7063051591f1 = "#2684FF";
var $105a4049f7064954$export$e62e8919cca44969 = "#0065FF";
var $105a4049f7064954$export$b3de0ae08da2ce64 = "#0052CC";
var $105a4049f7064954$export$a6ee3d71bc067634 = "#0747A6";
var $105a4049f7064954$export$67f15409e87642a1 = "#669DF1";
var $105a4049f7064954$export$f0539dbc42dbb067 = "#8FB8F6";
var $105a4049f7064954$export$363e4475840015bb = "#EAE6FF";
var $105a4049f7064954$export$4b0a4417ed59760f = "#C0B6F2";
var $105a4049f7064954$export$6011520a64d9a187 = "#998DD9";
var $105a4049f7064954$export$a7175d4e9206bc80 = "#8777D9";
var $105a4049f7064954$export$b48405b95304b5a1 = "#6554C0";
var $105a4049f7064954$export$c71e4279dd54a18d = "#5243AA";
var $105a4049f7064954$export$147899de772240ec = "#403294";
var $105a4049f7064954$export$2cf711fe14c66f06 = "#E6FCFF";
var $105a4049f7064954$export$7a8f4d33f6f9772c = "#B3F5FF";
var $105a4049f7064954$export$776c9c497ef08533 = "#79E2F2";
var $105a4049f7064954$export$69cb3ca10c1e330e = "#00C7E6";
var $105a4049f7064954$export$9dc1ef0f3f48059b = "#00B8D9";
var $105a4049f7064954$export$7c835c78b6fcdef8 = "#00A3BF";
var $105a4049f7064954$export$6036577f95c3877e = "#008DA6";
var $105a4049f7064954$export$29a4f05edc054374 = "#FFFFFF";
var $105a4049f7064954$export$e655ef011c4aa1a2 = "#FAFBFC";
var $105a4049f7064954$export$9fdfb749e33cdf97 = "#F4F5F7";
var $105a4049f7064954$export$3e51e8f1440314ba = "#EBECF0";
var $105a4049f7064954$export$1ce2d1575d444ceb = "#DFE1E6";
var $105a4049f7064954$export$8754fc7e6d8b3000 = "#C1C7D0";
var $105a4049f7064954$export$c2e91cbeada39b8b = "#B3BAC5";
var $105a4049f7064954$export$5f71e19f3a7ad9de = "#A5ADBA";
var $105a4049f7064954$export$eaa8c8a70ac22806 = "#97A0AF";
var $105a4049f7064954$export$7c87d337fb91a97d = "#8993A4";
var $105a4049f7064954$export$d6447c357493214f = "#7A869A";
var $105a4049f7064954$export$f563ee71e9ee74cd = "#6B778C";
var $105a4049f7064954$export$e2ef2124cf4024b1 = "#5E6C84";
var $105a4049f7064954$export$eece5f492e429f08 = "#505F79";
var $105a4049f7064954$export$c39c0fe0f26207ae = "#42526E";
var $105a4049f7064954$export$7090862dc3038a9f = "#344563";
var $105a4049f7064954$export$ad0bacf983b7ddaa = "#253858";
var $105a4049f7064954$export$7d61b15e0da132af = "#172B4D";
var $105a4049f7064954$export$fbda843f0a27fe96 = "#091E42";
var $105a4049f7064954$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $105a4049f7064954$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $105a4049f7064954$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $105a4049f7064954$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $105a4049f7064954$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $105a4049f7064954$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $105a4049f7064954$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $105a4049f7064954$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $105a4049f7064954$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $105a4049f7064954$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $105a4049f7064954$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $105a4049f7064954$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $105a4049f7064954$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $105a4049f7064954$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $105a4049f7064954$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $105a4049f7064954$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $105a4049f7064954$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $105a4049f7064954$export$2f6319cf7d736c2a = "#E6EDFA";
var $105a4049f7064954$export$95126bc8884d6634 = "#DCE5F5";
var $105a4049f7064954$export$8338d8c35d44ff1 = "#CED9EB";
var $105a4049f7064954$export$5368d76ae4fbbda7 = "#B8C7E0";
var $105a4049f7064954$export$9f0a771d16ec8d36 = "#ABBBD6";
var $105a4049f7064954$export$abcf8c38338b4aa5 = "#9FB0CC";
var $105a4049f7064954$export$97e81faa16a182c7 = "#8C9CB8";
var $105a4049f7064954$export$bfe21c59123ecf33 = "#7988A3";
var $105a4049f7064954$export$ee82aa2ea6a1558 = "#67758F";
var $105a4049f7064954$export$682927c6ed76be02 = "#56637A";
var $105a4049f7064954$export$91fd9994c5be9757 = "#455166";
var $105a4049f7064954$export$d281fbfe3cff2df6 = "#3B475C";
var $105a4049f7064954$export$3902c91d8b98a753 = "#313D52";
var $105a4049f7064954$export$8e8133c1ba5845b5 = "#283447";
var $105a4049f7064954$export$33ff357f6620b39 = "#202B3D";
var $105a4049f7064954$export$633847cf062b69e0 = "#1B2638";
var $105a4049f7064954$export$9776a6e503bdbf76 = "#121A29";
var $105a4049f7064954$export$6c813d5160dff5db = "#0E1624";
var $105a4049f7064954$export$3d4f271a500072a = "#0D1424";
var $105a4049f7064954$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $105a4049f7064954$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $105a4049f7064954$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $105a4049f7064954$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $105a4049f7064954$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $105a4049f7064954$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $105a4049f7064954$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $105a4049f7064954$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $105a4049f7064954$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $105a4049f7064954$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $105a4049f7064954$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $105a4049f7064954$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $105a4049f7064954$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $105a4049f7064954$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $105a4049f7064954$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $105a4049f7064954$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $105a4049f7064954$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $105a4049f7064954$export$d2adc5dedf09fced = "#292A2E";
var $105a4049f7064954$export$f51762073d2bb381 = "#94C748";
var $105a4049f7064954$export$95e26d54def96891 = "#B3DF72";


var $5dd8358678e5592c$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $105a4049f7064954$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $105a4049f7064954$export$215b7063051591f1);
            iconColor = (0, $105a4049f7064954$export$215b7063051591f1);
            textColor = "var(--ds-text, ".concat((0, $105a4049f7064954$export$7d61b15e0da132af), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $105a4049f7064954$export$b3de0ae08da2ce64);
            break;
        case "neutral":
            iconGradientStart = (0, $105a4049f7064954$export$7090862dc3038a9f);
            iconGradientStop = (0, $105a4049f7064954$export$d6447c357493214f);
            iconColor = (0, $105a4049f7064954$export$d6447c357493214f);
            textColor = (0, $105a4049f7064954$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $105a4049f7064954$export$eece5f492e429f08);
            break;
        case "inverse":
            iconGradientStart = "#FFFFFF66";
            iconGradientStop = "#FFFFFF";
            iconColor = "#FFFFFF";
            textColor = "#FFFFFF";
            atlassianLogoTextColor = "#FFFFFF";
            break;
    }
    if (colorMode === "dark" && appearance === "inverse") {
        iconGradientStart = "#161A1D66";
        iconGradientStop = "#161A1D";
        iconColor = "#161A1D";
        textColor = "#161A1D";
        atlassianLogoTextColor = "#161A1D";
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $5dd8358678e5592c$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $105a4049f7064954$export$29a4f05edc054374);
            textColor = (0, $105a4049f7064954$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $105a4049f7064954$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $5dd8358678e5592c$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $5dd8358678e5592c$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $5dd8358678e5592c$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $dnfL5 = parcelRequire("dnfL5");

var $45b5713085286aaa$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $45b5713085286aaa$var$CSS_VAR_COLOR = "--logo-color";
var $45b5713085286aaa$var$CSS_VAR_FILL = "--logo-fill";
var $45b5713085286aaa$var$baseWrapperStyles = (0, $dnfL5.css)({
    display: "inline-block",
    position: "relative",
    color: "var(".concat($45b5713085286aaa$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($45b5713085286aaa$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: "none",
    whiteSpace: "normal",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": {
        height: "100%",
        fill: "inherit"
    }
});
var $45b5713085286aaa$var$stopColorStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $45b5713085286aaa$var$sizeStyles = Object.entries((0, $d9eaf70640f32b21$export$c647cb0ee6e282fe)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $45b5713085286aaa$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref3, $45b5713085286aaa$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $dnfL5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        css: [
            $45b5713085286aaa$var$baseWrapperStyles,
            shouldApplyStopColor && $45b5713085286aaa$var$stopColorStyles,
            size && $45b5713085286aaa$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref4, $45b5713085286aaa$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref4, $45b5713085286aaa$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $45b5713085286aaa$export$2e2bcd8739ae039 = $45b5713085286aaa$var$Wrapper;


var $f53d1d0ce4a6d984$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $5dd8358678e5592c$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>\n    </svg>');
};
var $f53d1d0ce4a6d984$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $d9eaf70640f32b21$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $d9eaf70640f32b21$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $d9eaf70640f32b21$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $1757394a691c65fe$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45b5713085286aaa$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f53d1d0ce4a6d984$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

/* eslint-disable max-len */ 
var $acw62 = parcelRequire("acw62");




var $ea269827cfabf855$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $5dd8358678e5592c$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">\n      <path fill='.concat(colors.iconColor, ' d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>\n      <path fill=').concat(colors.atlassianLogoTextColor, ' d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>\n    </svg>');
};
var $ea269827cfabf855$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $d9eaf70640f32b21$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $d9eaf70640f32b21$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $d9eaf70640f32b21$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $1757394a691c65fe$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45b5713085286aaa$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $ea269827cfabf855$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $dSnoq = parcelRequire("dSnoq");

var $1ZV7N = parcelRequire("1ZV7N");

var $g5Zhu = parcelRequire("g5Zhu");


var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $8xLFK = parcelRequire("8xLFK");

var $lNWR1 = parcelRequire("lNWR1");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
var $39648264581c94c1$var$BORDER_WIDTH = 2;
var $39648264581c94c1$var$baseFocusOutsideStyles = (0, $dnfL5.css)({
    outline: "".concat($39648264581c94c1$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $39648264581c94c1$var$BORDER_WIDTH
});
var $39648264581c94c1$var$baseInsetStyles = (0, $dnfL5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$39648264581c94c1$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $39648264581c94c1$var$focusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $39648264581c94c1$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $39648264581c94c1$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $39648264581c94c1$var$insetFocusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $39648264581c94c1$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $39648264581c94c1$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $39648264581c94c1$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $39648264581c94c1$var$baseInsetStyles : $39648264581c94c1$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $39648264581c94c1$var$insetFocusRingStyles : $39648264581c94c1$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $dnfL5.jsx)((0, $dnfL5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$39648264581c94c1$var$FocusRing.displayName = "FocusRing";
var $39648264581c94c1$export$2e2bcd8739ae039 = $39648264581c94c1$var$FocusRing;



var $ltooA = parcelRequire("ltooA");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $73d67e94bef23f4f$export$4b84fd0e2c617bd = "#FFEBE6";
var $73d67e94bef23f4f$export$b34b069eff244586 = "#FFBDAD";
var $73d67e94bef23f4f$export$be802dd0d8b57f35 = "#FF8F73";
var $73d67e94bef23f4f$export$60847d42f9da92a6 = "#FF7452";
var $73d67e94bef23f4f$export$4a7404f376229999 = "#FF5630";
var $73d67e94bef23f4f$export$2010d0fb4295b346 = "#DE350B";
var $73d67e94bef23f4f$export$2837b5a1a71d5c02 = "#BF2600";
var $73d67e94bef23f4f$export$8d9596b529bbb9cf = "#FFFAE6";
var $73d67e94bef23f4f$export$41060a744ab0b7ae = "#FFF0B3";
var $73d67e94bef23f4f$export$1cc05bbbf340e559 = "#FFE380";
var $73d67e94bef23f4f$export$5aae31392d72caaa = "#FFC400";
var $73d67e94bef23f4f$export$c6930421db9fa514 = "#FFAB00";
var $73d67e94bef23f4f$export$59619663aa6500fb = "#FF991F";
var $73d67e94bef23f4f$export$874739ea9e379ab6 = "#FF8B00";
var $73d67e94bef23f4f$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $73d67e94bef23f4f$export$69a3bf21b9686c2b = "#ABF5D1";
var $73d67e94bef23f4f$export$afbce1382ec95f73 = "#79F2C0";
var $73d67e94bef23f4f$export$747d86715d4175de = "#57D9A3";
var $73d67e94bef23f4f$export$940e1f69e873f202 = "#36B37E";
var $73d67e94bef23f4f$export$a49394138f7b8e85 = "#00875A";
var $73d67e94bef23f4f$export$6fa04827ac68a4fb = "#006644";
var $73d67e94bef23f4f$export$226de0355ed012f8 = "#DEEBFF";
var $73d67e94bef23f4f$export$8c13c2ee36917869 = "#B3D4FF";
var $73d67e94bef23f4f$export$ecfc1dff386a3e7a = "#4C9AFF";
var $73d67e94bef23f4f$export$215b7063051591f1 = "#2684FF";
var $73d67e94bef23f4f$export$e62e8919cca44969 = "#0065FF";
var $73d67e94bef23f4f$export$b3de0ae08da2ce64 = "#0052CC";
var $73d67e94bef23f4f$export$a6ee3d71bc067634 = "#0747A6";
var $73d67e94bef23f4f$export$67f15409e87642a1 = "#669DF1";
var $73d67e94bef23f4f$export$f0539dbc42dbb067 = "#8FB8F6";
var $73d67e94bef23f4f$export$363e4475840015bb = "#EAE6FF";
var $73d67e94bef23f4f$export$4b0a4417ed59760f = "#C0B6F2";
var $73d67e94bef23f4f$export$6011520a64d9a187 = "#998DD9";
var $73d67e94bef23f4f$export$a7175d4e9206bc80 = "#8777D9";
var $73d67e94bef23f4f$export$b48405b95304b5a1 = "#6554C0";
var $73d67e94bef23f4f$export$c71e4279dd54a18d = "#5243AA";
var $73d67e94bef23f4f$export$147899de772240ec = "#403294";
var $73d67e94bef23f4f$export$2cf711fe14c66f06 = "#E6FCFF";
var $73d67e94bef23f4f$export$7a8f4d33f6f9772c = "#B3F5FF";
var $73d67e94bef23f4f$export$776c9c497ef08533 = "#79E2F2";
var $73d67e94bef23f4f$export$69cb3ca10c1e330e = "#00C7E6";
var $73d67e94bef23f4f$export$9dc1ef0f3f48059b = "#00B8D9";
var $73d67e94bef23f4f$export$7c835c78b6fcdef8 = "#00A3BF";
var $73d67e94bef23f4f$export$6036577f95c3877e = "#008DA6";
var $73d67e94bef23f4f$export$29a4f05edc054374 = "#FFFFFF";
var $73d67e94bef23f4f$export$e655ef011c4aa1a2 = "#FAFBFC";
var $73d67e94bef23f4f$export$9fdfb749e33cdf97 = "#F4F5F7";
var $73d67e94bef23f4f$export$3e51e8f1440314ba = "#EBECF0";
var $73d67e94bef23f4f$export$1ce2d1575d444ceb = "#DFE1E6";
var $73d67e94bef23f4f$export$8754fc7e6d8b3000 = "#C1C7D0";
var $73d67e94bef23f4f$export$c2e91cbeada39b8b = "#B3BAC5";
var $73d67e94bef23f4f$export$5f71e19f3a7ad9de = "#A5ADBA";
var $73d67e94bef23f4f$export$eaa8c8a70ac22806 = "#97A0AF";
var $73d67e94bef23f4f$export$7c87d337fb91a97d = "#8993A4";
var $73d67e94bef23f4f$export$d6447c357493214f = "#7A869A";
var $73d67e94bef23f4f$export$f563ee71e9ee74cd = "#6B778C";
var $73d67e94bef23f4f$export$e2ef2124cf4024b1 = "#5E6C84";
var $73d67e94bef23f4f$export$eece5f492e429f08 = "#505F79";
var $73d67e94bef23f4f$export$c39c0fe0f26207ae = "#42526E";
var $73d67e94bef23f4f$export$7090862dc3038a9f = "#344563";
var $73d67e94bef23f4f$export$ad0bacf983b7ddaa = "#253858";
var $73d67e94bef23f4f$export$7d61b15e0da132af = "#172B4D";
var $73d67e94bef23f4f$export$fbda843f0a27fe96 = "#091E42";
var $73d67e94bef23f4f$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $73d67e94bef23f4f$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $73d67e94bef23f4f$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $73d67e94bef23f4f$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $73d67e94bef23f4f$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $73d67e94bef23f4f$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $73d67e94bef23f4f$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $73d67e94bef23f4f$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $73d67e94bef23f4f$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $73d67e94bef23f4f$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $73d67e94bef23f4f$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $73d67e94bef23f4f$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $73d67e94bef23f4f$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $73d67e94bef23f4f$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $73d67e94bef23f4f$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $73d67e94bef23f4f$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $73d67e94bef23f4f$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $73d67e94bef23f4f$export$2f6319cf7d736c2a = "#E6EDFA";
var $73d67e94bef23f4f$export$95126bc8884d6634 = "#DCE5F5";
var $73d67e94bef23f4f$export$8338d8c35d44ff1 = "#CED9EB";
var $73d67e94bef23f4f$export$5368d76ae4fbbda7 = "#B8C7E0";
var $73d67e94bef23f4f$export$9f0a771d16ec8d36 = "#ABBBD6";
var $73d67e94bef23f4f$export$abcf8c38338b4aa5 = "#9FB0CC";
var $73d67e94bef23f4f$export$97e81faa16a182c7 = "#8C9CB8";
var $73d67e94bef23f4f$export$bfe21c59123ecf33 = "#7988A3";
var $73d67e94bef23f4f$export$ee82aa2ea6a1558 = "#67758F";
var $73d67e94bef23f4f$export$682927c6ed76be02 = "#56637A";
var $73d67e94bef23f4f$export$91fd9994c5be9757 = "#455166";
var $73d67e94bef23f4f$export$d281fbfe3cff2df6 = "#3B475C";
var $73d67e94bef23f4f$export$3902c91d8b98a753 = "#313D52";
var $73d67e94bef23f4f$export$8e8133c1ba5845b5 = "#283447";
var $73d67e94bef23f4f$export$33ff357f6620b39 = "#202B3D";
var $73d67e94bef23f4f$export$633847cf062b69e0 = "#1B2638";
var $73d67e94bef23f4f$export$9776a6e503bdbf76 = "#121A29";
var $73d67e94bef23f4f$export$6c813d5160dff5db = "#0E1624";
var $73d67e94bef23f4f$export$3d4f271a500072a = "#0D1424";
var $73d67e94bef23f4f$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $73d67e94bef23f4f$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $73d67e94bef23f4f$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $73d67e94bef23f4f$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $73d67e94bef23f4f$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $73d67e94bef23f4f$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $73d67e94bef23f4f$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $73d67e94bef23f4f$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $73d67e94bef23f4f$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $73d67e94bef23f4f$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $73d67e94bef23f4f$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $73d67e94bef23f4f$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $73d67e94bef23f4f$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $73d67e94bef23f4f$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $73d67e94bef23f4f$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $73d67e94bef23f4f$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $73d67e94bef23f4f$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $73d67e94bef23f4f$export$d2adc5dedf09fced = "#292A2E";
var $73d67e94bef23f4f$export$f51762073d2bb381 = "#94C748";
var $73d67e94bef23f4f$export$95e26d54def96891 = "#B3DF72";



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
var $ed00fb37da899b82$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67744cfb74ed451c0181f18c132cbdd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($ed00fb37da899b82$exports, "__esModule", {
    value: true
});
$ed00fb37da899b82$exports.default = void 0;

var $ed00fb37da899b82$var$_react = $ed00fb37da899b82$var$_interopRequireDefault((parcelRequire("acw62")));

var $ed00fb37da899b82$var$_person = $ed00fb37da899b82$var$_interopRequireDefault((parcelRequire("9kTCw")));

var $ed00fb37da899b82$var$_person2 = $ed00fb37da899b82$var$_interopRequireDefault((parcelRequire("epzNS")));
function $ed00fb37da899b82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed00fb37da899b82$var$PersonIcon = (props)=>/*#__PURE__*/ $ed00fb37da899b82$var$_react.default.createElement($ed00fb37da899b82$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $ed00fb37da899b82$var$_person2.default
    }, props));
$ed00fb37da899b82$var$PersonIcon.Name = "PersonIconMigration";
var $ed00fb37da899b82$var$_default = $ed00fb37da899b82$exports.default = $ed00fb37da899b82$var$PersonIcon;


var $77f6423e99e0967b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($77f6423e99e0967b$exports, "__esModule", {
    value: true
});
$77f6423e99e0967b$exports.default = void 0;

var $77f6423e99e0967b$var$_react = $77f6423e99e0967b$var$_interopRequireDefault((parcelRequire("acw62")));

var $77f6423e99e0967b$var$_release = $77f6423e99e0967b$var$_interopRequireDefault((parcelRequire("gBEIc")));

var $77f6423e99e0967b$var$_ship = $77f6423e99e0967b$var$_interopRequireDefault((parcelRequire("b9unQ")));
function $77f6423e99e0967b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77f6423e99e0967b$var$ReleaseIcon = (props)=>/*#__PURE__*/ $77f6423e99e0967b$var$_react.default.createElement($77f6423e99e0967b$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $77f6423e99e0967b$var$_ship.default
    }, props));
$77f6423e99e0967b$var$ReleaseIcon.Name = "ReleaseIconMigration";
var $77f6423e99e0967b$var$_default = $77f6423e99e0967b$exports.default = $77f6423e99e0967b$var$ReleaseIcon;



var $9kTCw = parcelRequire("9kTCw");

var $gBEIc = parcelRequire("gBEIc");

var $ltooA = parcelRequire("ltooA");

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $gbB1D = parcelRequire("gbB1D");

var $305339d639acb94f$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $305339d639acb94f$export$c93026a968943f95 = "light";
var $305339d639acb94f$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $305339d639acb94f$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $305339d639acb94f$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $305339d639acb94f$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $73d67e94bef23f4f$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $305339d639acb94f$export$6d8204c2cb2e06b8() / 4;
    (0, $gbB1D.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $305339d639acb94f$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $305339d639acb94f$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $305339d639acb94f$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $gbB1D.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $305339d639acb94f$export$ba1d834b86d72a09 = $305339d639acb94f$export$a1b3edb637fb4f35;
var $305339d639acb94f$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $73d67e94bef23f4f$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $73d67e94bef23f4f$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $73d67e94bef23f4f$export$920c0d5c49070351), ")")
            }
        }
    };
};


var $14a6a993e82a40d3$export$9a270941bcff7e77 = {
    xsmall: (0, $305339d639acb94f$export$6d8204c2cb2e06b8)() * 2,
    small: (0, $305339d639acb94f$export$6d8204c2cb2e06b8)() * 3,
    medium: (0, $305339d639acb94f$export$6d8204c2cb2e06b8)() * 4,
    large: (0, $305339d639acb94f$export$6d8204c2cb2e06b8)() * 5,
    xlarge: (0, $305339d639acb94f$export$6d8204c2cb2e06b8)() * 12,
    xxlarge: (0, $305339d639acb94f$export$6d8204c2cb2e06b8)() * 16
};
var $14a6a993e82a40d3$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $14a6a993e82a40d3$export$e2bd4c1faded7921 = 2;
var $14a6a993e82a40d3$export$89a980dfdf90df51 = 0.9;
var $14a6a993e82a40d3$export$3c061e31594ebabe = "--avatar-background-color";
var $14a6a993e82a40d3$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $14a6a993e82a40d3$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};


function $eca2381c9bc08af0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eca2381c9bc08af0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eca2381c9bc08af0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eca2381c9bc08af0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eca2381c9bc08af0$var$avatarDefaultIconStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $73d67e94bef23f4f$export$7c87d337fb91a97d), ")")
});
var $eca2381c9bc08af0$var$avatarDefaultIconVisualRefreshStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $eca2381c9bc08af0$var$nestedAvatarStyles = Object.entries((0, $14a6a993e82a40d3$export$9a270941bcff7e77)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $eca2381c9bc08af0$var$_objectSpread($eca2381c9bc08af0$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, key, (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& svg": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $eca2381c9bc08af0$var$avatarImageStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $eca2381c9bc08af0$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $14a6a993e82a40d3$export$e6da6efe4d1a5c9b)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $acw62.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $dnfL5.jsx)("span", {
        css: [
            (0, $ltooA.fg)("platform-component-visual-refresh") ? $eca2381c9bc08af0$var$avatarDefaultIconVisualRefreshStyles : $eca2381c9bc08af0$var$avatarDefaultIconStyles,
            $eca2381c9bc08af0$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $ltooA.fg)("platform-component-visual-refresh") ? (0, $dnfL5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9kTCw))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $dnfL5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ed00fb37da899b82$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $73d67e94bef23f4f$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $ltooA.fg)("platform-component-visual-refresh") ? (0, $dnfL5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gBEIc))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $dnfL5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77f6423e99e0967b$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $73d67e94bef23f4f$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return (0, $dnfL5.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $eca2381c9bc08af0$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : "avatar-image",
        "data-ssr-placeholder-ignored": true
    });
};
var $eca2381c9bc08af0$export$2e2bcd8739ae039 = $eca2381c9bc08af0$var$AvatarImage;




var $acw62 = parcelRequire("acw62");
var $db76737188e0d1f6$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $db76737188e0d1f6$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $acw62.useContext)($db76737188e0d1f6$export$a20dad690e1279e2);
};



var $acw62 = parcelRequire("acw62");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dnfL5 = parcelRequire("dnfL5");


var $4e1ea06c8cafe541$var$iconWrapperStyles = (0, $dnfL5.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $4e1ea06c8cafe541$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")") : _ref$bgColor, children = _ref.children;
    return (0, $dnfL5.jsx)("span", {
        css: $4e1ea06c8cafe541$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $14a6a993e82a40d3$export$e2bd4c1faded7921), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $4e1ea06c8cafe541$export$2e2bcd8739ae039 = $4e1ea06c8cafe541$var$IconWrapper;


var $619abc04afca8ffd$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $73d67e94bef23f4f$export$4a7404f376229999), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $619abc04afca8ffd$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $73d67e94bef23f4f$export$b48405b95304b5a1), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $619abc04afca8ffd$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $73d67e94bef23f4f$export$f563ee71e9ee74cd), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$1ce2d1575d444ceb), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $619abc04afca8ffd$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $73d67e94bef23f4f$export$940e1f69e873f202), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $619abc04afca8ffd$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $619abc04afca8ffd$var$BusyIndicator;
        case "focus":
            return $619abc04afca8ffd$var$FocusIndicator;
        case "offline":
            return $619abc04afca8ffd$var$OfflineIndicator;
        case "online":
            return $619abc04afca8ffd$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $619abc04afca8ffd$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e1ea06c8cafe541$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $619abc04afca8ffd$var$getPresence(presence)) : children);
};
var $619abc04afca8ffd$export$2e2bcd8739ae039 = $619abc04afca8ffd$var$AvatarPresence;
var $619abc04afca8ffd$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $14a6a993e82a40d3$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: "none",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $14a6a993e82a40d3$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $14a6a993e82a40d3$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($619abc04afca8ffd$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};



var $acw62 = parcelRequire("acw62");



var $b76e0fb4f24d7962$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $73d67e94bef23f4f$export$a49394138f7b8e85), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $b76e0fb4f24d7962$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $73d67e94bef23f4f$export$2010d0fb4295b346), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $b76e0fb4f24d7962$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $73d67e94bef23f4f$export$1ce2d1575d444ceb), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$c39c0fe0f26207ae), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $b76e0fb4f24d7962$var$getStatus(status) {
    switch(status){
        case "approved":
            return $b76e0fb4f24d7962$var$ApprovedIndicator;
        case "declined":
            return $b76e0fb4f24d7962$var$DeclinedIndicator;
        case "locked":
            return $b76e0fb4f24d7962$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $b76e0fb4f24d7962$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e1ea06c8cafe541$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $b76e0fb4f24d7962$var$getStatus(status)) : children);
};
var $b76e0fb4f24d7962$export$2e2bcd8739ae039 = $b76e0fb4f24d7962$var$AvatarStatus;
var $b76e0fb4f24d7962$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $14a6a993e82a40d3$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $14a6a993e82a40d3$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $14a6a993e82a40d3$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b76e0fb4f24d7962$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $7dd0184c416d550a$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $7dd0184c416d550a$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $7dd0184c416d550a$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};


var $b2487e6c908f2748$var$_templateObject;
function $b2487e6c908f2748$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2487e6c908f2748$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2487e6c908f2748$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2487e6c908f2748$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b2487e6c908f2748$var$packageName = "@atlaskit/avatar";
var $b2487e6c908f2748$var$packageVersion = "21.18.4";
var $b2487e6c908f2748$var$getTestId = function getTestId(testId, children) {
    return !children ? {
        "data-testid": "".concat(testId, "--inner")
    } : {
        testId: "".concat(testId, "--inner")
    };
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $b2487e6c908f2748$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $ltooA.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($b2487e6c908f2748$var$_templateObject || ($b2487e6c908f2748$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
        "\n		height: ",
        "px;\n		width: ",
        "px;\n		align-items: stretch;\n		background-color: ",
        ";\n		border-radius: ",
        ";\n		box-sizing: content-box;\n		cursor: inherit;\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		outline: none;\n		overflow: hidden;\n		position: static;\n		transform: translateZ(0);\n		transition:\n			transform 200ms,\n			opacity 200ms;\n		box-shadow: 0 0 0 ",
        "px ",
        ";\n		border: none;\n		margin: ",
        ";\n		padding: ",
        ";\n\n		&::-moz-focus-inner {\n			border: 0;\n			margin: ",
        ";\n			padding: ",
        ";\n		}\n\n		&::after {\n			background-color: transparent;\n			inset: 0px;\n\n			/* Added border-radius style to fix hover issue in safari */\n			border-radius: ",
        ";\n			content: ' ';\n			opacity: 0;\n			pointer-events: none;\n			position: absolute;\n			transition: opacity 200ms;\n			width: 100%;\n		}\n\n		:focus-visible {\n			box-shadow: none;\n		}\n\n		",
        "\n\n		",
        "\n\n    ",
        "\n	"
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $14a6a993e82a40d3$export$e2bd4c1faded7921), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :hover {\n        &::after {\n          background-color: ".concat("var(--ds-interaction-hovered, ".concat((0, $73d67e94bef23f4f$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $73d67e94bef23f4f$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(", (0, $14a6a993e82a40d3$export$89a980dfdf90df51), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $73d67e94bef23f4f$export$29a4f05edc054374), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $b2487e6c908f2748$var$Avatar = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var _ref3;
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, sizeProp = _ref2.size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? "div" : _ref2$as;
    var _useAnalyticsEvents = (0, $8xLFK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $db76737188e0d1f6$export$b50b87a1c4086b23)();
    var size = (_ref3 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : context === null || context === void 0 ? void 0 : context.size) !== null && _ref3 !== void 0 ? _ref3 : "medium";
    var customPresenceNode = /*#__PURE__*/ (0, $acw62.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $acw62.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $acw62.useRef)(analyticsContext);
    var labelId = (0, $lNWR1.useId)();
    (0, $acw62.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $b2487e6c908f2748$var$packageName,
                packageVersion: $b2487e6c908f2748$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $b2487e6c908f2748$var$_objectSpread({
            componentName: "avatar",
            packageName: $b2487e6c908f2748$var$packageName,
            packageVersion: $b2487e6c908f2748$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $b2487e6c908f2748$var$_objectSpread($b2487e6c908f2748$var$_objectSpread({}, href && (0, $7dd0184c416d550a$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $7dd0184c416d550a$export$cca6f1bef43616d3)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $dnfL5.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: "inline-block",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "relative",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $dnfL5.jsx)((0, $dnfL5.ClassNames), null, function(_ref4) {
        var css = _ref4.css;
        var props = $b2487e6c908f2748$var$_objectSpread($b2487e6c908f2748$var$_objectSpread($b2487e6c908f2748$var$_objectSpread($b2487e6c908f2748$var$_objectSpread({
            className: $b2487e6c908f2748$var$getStyles(css, {
                size: (0, $14a6a993e82a40d3$export$9a270941bcff7e77)[size],
                radius: (0, $14a6a993e82a40d3$export$e6da6efe4d1a5c9b)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && $b2487e6c908f2748$var$getTestId(testId, children)), (isInteractive || children) && {
            "aria-label": label || defaultLabel
        }), {}, {
            children: (0, $dnfL5.jsx)((0, $eca2381c9bc08af0$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        if (children) return children(props);
        var element = (0, $7dd0184c416d550a$export$83ee468102cdf04c)(isDisabled, href, onClick);
        return element === "a" || element === "button" ? (0, $dnfL5.jsx)((0, $39648264581c94c1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $acw62.createElement)(element, props)) : /*#__PURE__*/ (0, $acw62.createElement)(element, props);
    }), isPresence && (0, $dnfL5.jsx)((0, $619abc04afca8ffd$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $dnfL5.jsx)((0, $b76e0fb4f24d7962$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $dnfL5.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined);
});
$b2487e6c908f2748$var$Avatar.displayName = "Avatar";
var $b2487e6c908f2748$export$2e2bcd8739ae039 = $b2487e6c908f2748$var$Avatar;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $acw62 = parcelRequire("acw62");
var $2b38344f2e1b2b1c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $2b38344f2e1b2b1c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($2b38344f2e1b2b1c$export$1ca2a26fecb070ae);
};
$2b38344f2e1b2b1c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");
var $70688a4268d07052$export$4ef52930e33717cd = "data-theme";
var $70688a4268d07052$export$a00eac3f8684bcd0 = "data-color-mode";
var $70688a4268d07052$export$2112803007239c61 = "data-contrast-mode";
var $70688a4268d07052$export$352e418ed5b6193a = "data-custom-theme";
var $70688a4268d07052$export$2faeed762aac6741 = "light";
var $70688a4268d07052$export$6f0c6fb8c80fcc92 = "ds";
var $70688a4268d07052$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $70688a4268d07052$export$dddac1532e822863 = "--".concat($70688a4268d07052$export$6f0c6fb8c80fcc92, "-token-not-found");
var $70688a4268d07052$export$9d7b58831ae93caa = "--".concat($70688a4268d07052$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $9da2d5ad09311bea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9da2d5ad09311bea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9da2d5ad09311bea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9da2d5ad09311bea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9da2d5ad09311bea$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $9da2d5ad09311bea$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $9da2d5ad09311bea$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $9da2d5ad09311bea$export$632685d741f3dbbf = $9da2d5ad09311bea$var$_objectSpread($9da2d5ad09311bea$var$_objectSpread({}, $9da2d5ad09311bea$export$958d0ae7f2977ae4), $9da2d5ad09311bea$export$d2dc61f58390201c);
var $9da2d5ad09311bea$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $9da2d5ad09311bea$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $9da2d5ad09311bea$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $9da2d5ad09311bea$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $9da2d5ad09311bea$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $9da2d5ad09311bea$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $9da2d5ad09311bea$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $9da2d5ad09311bea$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $9da2d5ad09311bea$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $9da2d5ad09311bea$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $9da2d5ad09311bea$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $9da2d5ad09311bea$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $9da2d5ad09311bea$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $9da2d5ad09311bea$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $9da2d5ad09311bea$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $9da2d5ad09311bea$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $9da2d5ad09311bea$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $9da2d5ad09311bea$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $9da2d5ad09311bea$export$e615f061ca585a6c = $9da2d5ad09311bea$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9da2d5ad09311bea$export$ca0f9c2de39ffed7(spacingProperty, $9da2d5ad09311bea$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9da2d5ad09311bea$export$bf46c3f9eeafc71f = $9da2d5ad09311bea$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9da2d5ad09311bea$export$ca0f9c2de39ffed7(spacingProperty, $9da2d5ad09311bea$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9da2d5ad09311bea$export$e7af83bafe7f9e63 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("backgroundColor", $9da2d5ad09311bea$export$d1d79bf68ac056bd);
var $9da2d5ad09311bea$export$3a1bcba60b23d7f0 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("color", $9da2d5ad09311bea$export$8473307aa00d6ea1);
var $9da2d5ad09311bea$export$45f3f4fe16f9f7d5 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("fontWeight", $9da2d5ad09311bea$export$303e322c6b1ed114);
var $9da2d5ad09311bea$export$68cc305da27dbaa4 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("fontFamily", $9da2d5ad09311bea$export$3c7e9587132614b4);
var $9da2d5ad09311bea$export$128f10c238242f83 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("font", $9da2d5ad09311bea$export$6ffa317d5e70375);
var $9da2d5ad09311bea$export$219d364c0da35ae4 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("font", $9da2d5ad09311bea$export$236bfe3a33ef1292);
var $9da2d5ad09311bea$export$38845ca010b93505 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7("fontWeight", $9da2d5ad09311bea$export$855cfd311192d666);
var $9da2d5ad09311bea$export$ff257d957d48c421 = $9da2d5ad09311bea$export$ca0f9c2de39ffed7((0, $70688a4268d07052$export$9d7b58831ae93caa), $9da2d5ad09311bea$export$41a358c9c2356760);
var $9da2d5ad09311bea$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $9da2d5ad09311bea$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");


var $hPtJY = parcelRequire("hPtJY");
function $dc7b576405bdfafb$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dc7b576405bdfafb$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $dc7b576405bdfafb$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dc7b576405bdfafb$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dc7b576405bdfafb$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dc7b576405bdfafb$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $dc7b576405bdfafb$export$9a199fbafee0014e = {
    backgroundColor: (0, $9da2d5ad09311bea$export$d1d79bf68ac056bd),
    blockSize: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderBottomColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderLeftColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $9da2d5ad09311bea$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    borderWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    bottom: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    boxShadow: (0, $9da2d5ad09311bea$export$7aff6e7ba39bb774),
    color: (0, $9da2d5ad09311bea$export$8473307aa00d6ea1),
    columnGap: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    font: (0, $9da2d5ad09311bea$export$6ffa317d5e70375),
    fontFamily: (0, $9da2d5ad09311bea$export$3c7e9587132614b4),
    fontWeight: (0, $9da2d5ad09311bea$export$303e322c6b1ed114),
    gap: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    height: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    inlineSize: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    inset: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    insetBlock: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    insetBlockEnd: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    insetBlockStart: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    insetInline: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    insetInlineEnd: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    insetInlineStart: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    left: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    margin: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginBlock: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginBlockEnd: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginBlockStart: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginBottom: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginInline: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginInlineEnd: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginInlineStart: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginLeft: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginRight: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    marginTop: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    maxBlockSize: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    maxHeight: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    maxWidth: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    minBlockSize: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    minHeight: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    minInlineSize: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    minWidth: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    opacity: (0, $9da2d5ad09311bea$export$daf94a976c798b4f),
    outlineColor: (0, $9da2d5ad09311bea$export$1531ad5bb3fbedac),
    outlineOffset: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    outlineWidth: (0, $9da2d5ad09311bea$export$e1b83c5210c471b8),
    padding: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingBlock: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingBottom: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingInline: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingLeft: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingRight: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    paddingTop: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    right: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    rowGap: (0, $9da2d5ad09311bea$export$958d0ae7f2977ae4),
    top: (0, $9da2d5ad09311bea$export$632685d741f3dbbf),
    width: (0, $9da2d5ad09311bea$export$6ccdbebca2ee545f),
    zIndex: (0, $9da2d5ad09311bea$export$b5f31a7e431d2eab)
};
var $dc7b576405bdfafb$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $dc7b576405bdfafb$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $dc7b576405bdfafb$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $dc7b576405bdfafb$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $dc7b576405bdfafb$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($dc7b576405bdfafb$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $dc7b576405bdfafb$var$safeSelectors.test(key)) {
            styleObj[key] = $dc7b576405bdfafb$var$_transformStyles(value);
            return;
        }
        if ($dc7b576405bdfafb$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($dc7b576405bdfafb$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $dc7b576405bdfafb$export$9a199fbafee0014e)) return;
        var tokenValue = $dc7b576405bdfafb$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $dc7b576405bdfafb$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $dc7b576405bdfafb$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $dc7b576405bdfafb$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $dc7b576405bdfafb$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $dc7b576405bdfafb$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $dc7b576405bdfafb$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$dc7b576405bdfafb$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $dc7b576405bdfafb$export$f6c783d06584602c(style) {
    return $dc7b576405bdfafb$var$baseXcss(style);
}


var $fb428571510d2bac$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $fb428571510d2bac$var$_excluded2 = [
    "className"
];
var $fb428571510d2bac$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $fb428571510d2bac$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $fb428571510d2bac$var$_excluded2);
    var resolvedStyles = (0, $dc7b576405bdfafb$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $fb428571510d2bac$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $9da2d5ad09311bea$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9da2d5ad09311bea$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $9da2d5ad09311bea$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $9da2d5ad09311bea$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $dnfL5.jsx)((0, $2b38344f2e1b2b1c$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $fb428571510d2bac$export$2e2bcd8739ae039 = $fb428571510d2bac$export$e71c4d32a2263218;
var $fb428571510d2bac$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $e1ce2b1d3d70c4a6$var$baseStylesOld = (0, $dc7b576405bdfafb$export$f6c783d06584602c)({
    display: "inline-flex",
    borderRadius: "border.radius",
    blockSize: "min-content",
    position: "static",
    overflow: "hidden"
});
var $e1ce2b1d3d70c4a6$var$styles = {
    container: (0, $dnfL5.css)({
        display: "inline-flex",
        boxSizing: "border-box",
        position: "static",
        blockSize: "min-content",
        borderRadius: "3px",
        overflow: "hidden",
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $dnfL5.css)({
                backgroundColor: "#DDDEE1"
            }),
            inprogress: (0, $dnfL5.css)({
                backgroundColor: "#8FB8F6"
            }),
            moved: (0, $dnfL5.css)({
                backgroundColor: "#F9C84E"
            }),
            new: (0, $dnfL5.css)({
                backgroundColor: "#D8A0F7"
            }),
            removed: (0, $dnfL5.css)({
                backgroundColor: "#FD9891"
            }),
            success: (0, $dnfL5.css)({
                backgroundColor: "#B3DF72"
            })
        },
        subtle: {
            default: (0, $dnfL5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $dnfL5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $dnfL5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $dnfL5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $dnfL5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $dnfL5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $dnfL5.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $dnfL5.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $dnfL5.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $dnfL5.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $dnfL5.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $dnfL5.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $dnfL5.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $dnfL5.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $dnfL5.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $dnfL5.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $dnfL5.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $dnfL5.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $dnfL5.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $dnfL5.css)({
            color: "#292A2E"
        })
    }
};
var $e1ce2b1d3d70c4a6$var$textStyles = (0, $dnfL5.css)({
    fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: "uppercase",
    whiteSpace: "nowrap"
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $e1ce2b1d3d70c4a6$var$Lozenge = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $e1ce2b1d3d70c4a6$var$styles.background[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $ltooA.fg)("platform-component-visual-refresh")) return (0, $dnfL5.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        css: [
            $e1ce2b1d3d70c4a6$var$styles.container,
            $e1ce2b1d3d70c4a6$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === "subtle" && !(0, $ltooA.fg)("visual-refresh_drop_5") && $e1ce2b1d3d70c4a6$var$styles.border.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $e1ce2b1d3d70c4a6$var$styles.outline.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $e1ce2b1d3d70c4a6$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $dnfL5.jsx)("span", {
        css: [
            $e1ce2b1d3d70c4a6$var$textStyles,
            $e1ce2b1d3d70c4a6$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $e1ce2b1d3d70c4a6$var$backgroundColorsOld[appearanceStyle] ? appearance : "default";
    return (0, $dnfL5.jsx)((0, $fb428571510d2bac$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $e1ce2b1d3d70c4a6$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $e1ce2b1d3d70c4a6$var$baseStylesOld,
        testId: testId
    }, (0, $dnfL5.jsx)("span", {
        css: [
            $e1ce2b1d3d70c4a6$var$textStyles,
            $e1ce2b1d3d70c4a6$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$e1ce2b1d3d70c4a6$var$Lozenge.displayName = "Lozenge";
var $e1ce2b1d3d70c4a6$export$2e2bcd8739ae039 = $e1ce2b1d3d70c4a6$var$Lozenge;
var $e1ce2b1d3d70c4a6$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $e1ce2b1d3d70c4a6$var$textColorsOld = {
    bold: {
        default: (0, $dnfL5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $dnfL5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $dnfL5.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $dnfL5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $dnfL5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $dnfL5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $dnfL5.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $dnfL5.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $dnfL5.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $dnfL5.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $dnfL5.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $dnfL5.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $5auEi = parcelRequire("5auEi");

var $dXy8E = parcelRequire("dXy8E");

var $ktKrw = parcelRequire("ktKrw");

var $8Fp8I = parcelRequire("8Fp8I");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $982af3473eee44c3$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $acw62.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $acw62.useRef)(isControlled);
    (0, $acw62.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $acw62.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $31442ad359bb1bbf$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $acw62.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $acw62.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $a2777c4e957814e4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f1feec303b173e7de0228adfc7e7782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a2777c4e957814e4$exports, "__esModule", {
    value: true
});
$a2777c4e957814e4$exports.default = void 0;

var $a2777c4e957814e4$var$_react = $a2777c4e957814e4$var$_interopRequireDefault((parcelRequire("acw62")));

var $a2777c4e957814e4$var$_chevronDown = $a2777c4e957814e4$var$_interopRequireDefault((parcelRequire("cSZPM")));

var $a2777c4e957814e4$var$_chevronDown2 = $a2777c4e957814e4$var$_interopRequireDefault((parcelRequire("gw5Wo")));
function $a2777c4e957814e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2777c4e957814e4$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a2777c4e957814e4$var$_react.default.createElement($a2777c4e957814e4$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $a2777c4e957814e4$var$_chevronDown2.default
    }, props));
$a2777c4e957814e4$var$ChevronDownIcon.Name = "ChevronDownIconMigration";
var $a2777c4e957814e4$var$_default = $a2777c4e957814e4$exports.default = $a2777c4e957814e4$var$ChevronDownIcon;



var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $lNWR1 = parcelRequire("lNWR1");

var $acw62 = parcelRequire("acw62");

var $8Fp8I = parcelRequire("8Fp8I");
var $31390fc59b838143$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $31390fc59b838143$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $8Fp8I.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $31390fc59b838143$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($31390fc59b838143$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $acw62.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31390fc59b838143$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $31390fc59b838143$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var value = (0, $acw62.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31390fc59b838143$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $31390fc59b838143$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($31390fc59b838143$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31390fc59b838143$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31390fc59b838143$var$LayeringProvider, null, content);
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e577608a5d0079e0$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $ebe38ff99337ff76$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $acw62.useContext)((0, $e577608a5d0079e0$export$5fbf4d7fae6cdc00));
    (0, $acw62.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $ltooA = parcelRequire("ltooA");

var $6Hh1R = parcelRequire("6Hh1R");
var $acw62 = parcelRequire("acw62");


var $6Hh1R = parcelRequire("6Hh1R");

var $evS7p = parcelRequire("evS7p");
function $947a156bfc8423f9$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $6Hh1R.ManagerReferenceNodeSetterContext));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $evS7p.setRef)(innerRef, node);
        (0, $evS7p.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        return function() {
            return (0, $evS7p.setRef)(innerRef, null);
        };
    }, []);
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $evS7p.unwrapArray)(children)({
        ref: refHandler
    });
}



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $2f65ce9bc50a0a9f$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $2f65ce9bc50a0a9f$export$72f415121273627e = "body > .atlaskit-portal-container";
var $2f65ce9bc50a0a9f$export$13f57c02915787b3 = "atlaskit-portal";


var $df9faab40460014a$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $2f65ce9bc50a0a9f$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $df9faab40460014a$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $df9faab40460014a$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $2f65ce9bc50a0a9f$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $2f65ce9bc50a0a9f$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $df9faab40460014a$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $df9faab40460014a$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $df9faab40460014a$var$getPortalParent().removeChild(container);
};
var $df9faab40460014a$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $df9faab40460014a$var$getPortalParent().appendChild(container);
};
var $df9faab40460014a$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $df9faab40460014a$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($df9faab40460014a$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $2f65ce9bc50a0a9f$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $df9faab40460014a$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($df9faab40460014a$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $2f65ce9bc50a0a9f$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $2f65ce9bc50a0a9f$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $df9faab40460014a$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $125b62692e2d3b66$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $df9faab40460014a$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $df9faab40460014a$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $df9faab40460014a$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $7f2c0afdaa97de01$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $dfbaebaa34e12098$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $7f2c0afdaa97de01$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $df9faab40460014a$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $df9faab40460014a$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $ltooA.fg)("platform_design_system_suspend_portal_children") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $c7138743fa161e71$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $7f2c0afdaa97de01$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $c7138743fa161e71$export$2e2bcd8739ae039 = $c7138743fa161e71$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $81abd23e003950c1$export$ed5835cc67e87f72 = "akPortalMount";
var $81abd23e003950c1$export$80816bd900e5bd00 = "akPortalUnmount";


var $89d83c8e5cc020cf$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $89d83c8e5cc020cf$var$getLayerName = function getLayerName(zIndex) {
    return $89d83c8e5cc020cf$var$zIndexToName.hasOwnProperty(zIndex) ? $89d83c8e5cc020cf$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $89d83c8e5cc020cf$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $89d83c8e5cc020cf$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $89d83c8e5cc020cf$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $89d83c8e5cc020cf$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $c8cd6eb92d4d092e$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $89d83c8e5cc020cf$export$2e2bcd8739ae039)((0, $81abd23e003950c1$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $89d83c8e5cc020cf$export$2e2bcd8739ae039)((0, $81abd23e003950c1$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $c8cd6eb92d4d092e$export$2e2bcd8739ae039 = $c8cd6eb92d4d092e$var$useFirePortalEvent;


function $f7a2bf4376bacc46$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $c7138743fa161e71$export$2e2bcd8739ae039)(mountStrategy);
    (0, $c8cd6eb92d4d092e$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $125b62692e2d3b66$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfbaebaa34e12098$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $acw62 = parcelRequire("acw62");
var $1878cc26564473ab$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $1878cc26564473ab$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($1878cc26564473ab$export$1ca2a26fecb070ae);
};
$1878cc26564473ab$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");
var $c1c5fe1d9888b461$export$4ef52930e33717cd = "data-theme";
var $c1c5fe1d9888b461$export$a00eac3f8684bcd0 = "data-color-mode";
var $c1c5fe1d9888b461$export$2112803007239c61 = "data-contrast-mode";
var $c1c5fe1d9888b461$export$352e418ed5b6193a = "data-custom-theme";
var $c1c5fe1d9888b461$export$2faeed762aac6741 = "light";
var $c1c5fe1d9888b461$export$6f0c6fb8c80fcc92 = "ds";
var $c1c5fe1d9888b461$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $c1c5fe1d9888b461$export$dddac1532e822863 = "--".concat($c1c5fe1d9888b461$export$6f0c6fb8c80fcc92, "-token-not-found");
var $c1c5fe1d9888b461$export$9d7b58831ae93caa = "--".concat($c1c5fe1d9888b461$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $b23f8be8cd57a058$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b23f8be8cd57a058$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b23f8be8cd57a058$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b23f8be8cd57a058$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b23f8be8cd57a058$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $b23f8be8cd57a058$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $b23f8be8cd57a058$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $b23f8be8cd57a058$export$632685d741f3dbbf = $b23f8be8cd57a058$var$_objectSpread($b23f8be8cd57a058$var$_objectSpread({}, $b23f8be8cd57a058$export$958d0ae7f2977ae4), $b23f8be8cd57a058$export$d2dc61f58390201c);
var $b23f8be8cd57a058$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $b23f8be8cd57a058$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $b23f8be8cd57a058$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $b23f8be8cd57a058$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $b23f8be8cd57a058$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $b23f8be8cd57a058$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $b23f8be8cd57a058$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $b23f8be8cd57a058$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $b23f8be8cd57a058$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $b23f8be8cd57a058$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $b23f8be8cd57a058$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $b23f8be8cd57a058$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $b23f8be8cd57a058$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $b23f8be8cd57a058$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $b23f8be8cd57a058$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $b23f8be8cd57a058$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $b23f8be8cd57a058$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $b23f8be8cd57a058$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $b23f8be8cd57a058$export$e615f061ca585a6c = $b23f8be8cd57a058$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $b23f8be8cd57a058$export$ca0f9c2de39ffed7(spacingProperty, $b23f8be8cd57a058$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $b23f8be8cd57a058$export$bf46c3f9eeafc71f = $b23f8be8cd57a058$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $b23f8be8cd57a058$export$ca0f9c2de39ffed7(spacingProperty, $b23f8be8cd57a058$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $b23f8be8cd57a058$export$e7af83bafe7f9e63 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("backgroundColor", $b23f8be8cd57a058$export$d1d79bf68ac056bd);
var $b23f8be8cd57a058$export$3a1bcba60b23d7f0 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("color", $b23f8be8cd57a058$export$8473307aa00d6ea1);
var $b23f8be8cd57a058$export$45f3f4fe16f9f7d5 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("fontWeight", $b23f8be8cd57a058$export$303e322c6b1ed114);
var $b23f8be8cd57a058$export$68cc305da27dbaa4 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("fontFamily", $b23f8be8cd57a058$export$3c7e9587132614b4);
var $b23f8be8cd57a058$export$128f10c238242f83 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("font", $b23f8be8cd57a058$export$6ffa317d5e70375);
var $b23f8be8cd57a058$export$219d364c0da35ae4 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("font", $b23f8be8cd57a058$export$236bfe3a33ef1292);
var $b23f8be8cd57a058$export$38845ca010b93505 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7("fontWeight", $b23f8be8cd57a058$export$855cfd311192d666);
var $b23f8be8cd57a058$export$ff257d957d48c421 = $b23f8be8cd57a058$export$ca0f9c2de39ffed7((0, $c1c5fe1d9888b461$export$9d7b58831ae93caa), $b23f8be8cd57a058$export$41a358c9c2356760);
var $b23f8be8cd57a058$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $b23f8be8cd57a058$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");


var $hPtJY = parcelRequire("hPtJY");
function $b73c0fec4c496922$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b73c0fec4c496922$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b73c0fec4c496922$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b73c0fec4c496922$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b73c0fec4c496922$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b73c0fec4c496922$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b73c0fec4c496922$export$9a199fbafee0014e = {
    backgroundColor: (0, $b23f8be8cd57a058$export$d1d79bf68ac056bd),
    blockSize: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderBottomColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderLeftColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $b23f8be8cd57a058$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    borderWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    bottom: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    boxShadow: (0, $b23f8be8cd57a058$export$7aff6e7ba39bb774),
    color: (0, $b23f8be8cd57a058$export$8473307aa00d6ea1),
    columnGap: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    font: (0, $b23f8be8cd57a058$export$6ffa317d5e70375),
    fontFamily: (0, $b23f8be8cd57a058$export$3c7e9587132614b4),
    fontWeight: (0, $b23f8be8cd57a058$export$303e322c6b1ed114),
    gap: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    height: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    inlineSize: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    inset: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    insetBlock: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    insetBlockEnd: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    insetBlockStart: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    insetInline: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    insetInlineEnd: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    insetInlineStart: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    left: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    margin: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginBlock: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginBlockEnd: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginBlockStart: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginBottom: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginInline: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginInlineEnd: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginInlineStart: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginLeft: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginRight: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    marginTop: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    maxBlockSize: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    maxHeight: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    maxWidth: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    minBlockSize: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    minHeight: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    minInlineSize: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    minWidth: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    opacity: (0, $b23f8be8cd57a058$export$daf94a976c798b4f),
    outlineColor: (0, $b23f8be8cd57a058$export$1531ad5bb3fbedac),
    outlineOffset: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    outlineWidth: (0, $b23f8be8cd57a058$export$e1b83c5210c471b8),
    padding: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingBlock: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingBottom: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingInline: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingLeft: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingRight: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    paddingTop: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    right: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    rowGap: (0, $b23f8be8cd57a058$export$958d0ae7f2977ae4),
    top: (0, $b23f8be8cd57a058$export$632685d741f3dbbf),
    width: (0, $b23f8be8cd57a058$export$6ccdbebca2ee545f),
    zIndex: (0, $b23f8be8cd57a058$export$b5f31a7e431d2eab)
};
var $b73c0fec4c496922$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $b73c0fec4c496922$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $b73c0fec4c496922$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $b73c0fec4c496922$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $b73c0fec4c496922$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b73c0fec4c496922$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $b73c0fec4c496922$var$safeSelectors.test(key)) {
            styleObj[key] = $b73c0fec4c496922$var$_transformStyles(value);
            return;
        }
        if ($b73c0fec4c496922$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b73c0fec4c496922$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b73c0fec4c496922$export$9a199fbafee0014e)) return;
        var tokenValue = $b73c0fec4c496922$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $b73c0fec4c496922$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $b73c0fec4c496922$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $b73c0fec4c496922$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $b73c0fec4c496922$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $b73c0fec4c496922$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $b73c0fec4c496922$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$b73c0fec4c496922$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b73c0fec4c496922$export$f6c783d06584602c(style) {
    return $b73c0fec4c496922$var$baseXcss(style);
}


var $c6e5ce6df13b0da0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $c6e5ce6df13b0da0$var$_excluded2 = [
    "className"
];
var $c6e5ce6df13b0da0$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c6e5ce6df13b0da0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $c6e5ce6df13b0da0$var$_excluded2);
    var resolvedStyles = (0, $b73c0fec4c496922$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $c6e5ce6df13b0da0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $b23f8be8cd57a058$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $b23f8be8cd57a058$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $b23f8be8cd57a058$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $b23f8be8cd57a058$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $dnfL5.jsx)((0, $1878cc26564473ab$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $c6e5ce6df13b0da0$export$2e2bcd8739ae039 = $c6e5ce6df13b0da0$export$e71c4d32a2263218;
var $c6e5ce6df13b0da0$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});



var $cFKGy = parcelRequire("cFKGy");

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $e3059f3b699dc189$var$ESCAPE = "Escape";
function $e3059f3b699dc189$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _useLayering = $e3059f3b699dc189$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $e3059f3b699dc189$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $e3059f3b699dc189$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $acw62.useContext)((0, $31390fc59b838143$export$650d12d3c2ddb8fc));
    var _useContext = (0, $acw62.useContext)((0, $31390fc59b838143$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $ltooA = parcelRequire("ltooA");

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $bqx5F = parcelRequire("bqx5F");

var $02Ztr = parcelRequire("02Ztr");
function $150ef57e68e332ef$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $4c51652d4d644b73$var$viewportPadding = 5;
var $4c51652d4d644b73$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $4c51652d4d644b73$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $4c51652d4d644b73$var$defaultChildrenFn() {
    return null;
}
var $4c51652d4d644b73$var$defaultOffset = [
    0,
    8
];
function $4c51652d4d644b73$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $4c51652d4d644b73$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $4c51652d4d644b73$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $4c51652d4d644b73$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $150ef57e68e332ef$export$6d8c2b45c99d6e3f)({
            viewportPadding: $4c51652d4d644b73$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($4c51652d4d644b73$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bqx5F.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $5XtxN = parcelRequire("5XtxN");

var $cFKGy = parcelRequire("cFKGy");


var $acw62 = parcelRequire("acw62");
var $f91101f449b8ac54$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $acw62.useRef)(true);
    (0, $acw62.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $8Fp8I = parcelRequire("8Fp8I");


var $ltooA = parcelRequire("ltooA");
var $8700500be2b7cf3b$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $8700500be2b7cf3b$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($8700500be2b7cf3b$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};



var $acw62 = parcelRequire("acw62");
var $49042bde9cb5550c$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $acw62.useRef)([]);
    var requestFrame = (0, $acw62.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $acw62.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $acw62.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $b564c226eb4c8531$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $e3059f3b699dc189$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $49042bde9cb5550c$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $acw62.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $8Fp8I.default;
        var inIframe = window && window.self !== window.top && (0, $ltooA.fg)("fix-dropdown-close-outside-iframe");
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $ltooA.fg)("sibling-dropdown-close-issue")) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute("data-ds--level");
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $ltooA.fg)("design-system-closed-all-when-click-outside")) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute("[data-ds--close--type]");
                            if (closeType === "single") // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute("data-ds--level");
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $8700500be2b7cf3b$export$3dee5e4542c672d9)(document.activeElement) && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $8fY35.bind)(window.parent.window, {
            type: "click",
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $8fY35.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $8Fp8I.default);
        unbindBlur = (0, $8fY35.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $acw62 = parcelRequire("acw62");


var $8Fp8I = parcelRequire("8Fp8I");


var $ltooA = parcelRequire("ltooA");

var $6f449669bd6f3e67$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $49042bde9cb5550c$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $e3059f3b699dc189$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $acw62.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $8Fp8I.default;
        if (shouldDisableFocusTrap && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
            var isDropdown = popupRef.matches("[id^=ds--dropdown--]");
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                    if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $8Fp8I.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($539e1bc5b4077faf$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $4c9fc4b0ff589bb7$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $4c9fc4b0ff589bb7$var$fullWidthStyles = (0, $dnfL5.css)({
    width: "100%"
});
var $4c9fc4b0ff589bb7$var$rootStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $cFKGy.layers).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $5XtxN.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $5XtxN.N50A), ", 0 0 1px ").concat((0, $5XtxN.N60A)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $c1c5fe1d9888b461$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $5XtxN.N0), ")")), "&:focus", {
    outline: "none"
}));
var $4c9fc4b0ff589bb7$var$scrollableStyles = (0, $dnfL5.css)({
    overflow: "auto"
});
var $4c9fc4b0ff589bb7$var$blanketStyles = (0, $dnfL5.css)({
    position: "fixed",
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $4c9fc4b0ff589bb7$var$modalStyles = (0, $dnfL5.css)({
    maxHeight: "50vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $4c9fc4b0ff589bb7$var$DefaultPopupComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $4c9fc4b0ff589bb7$var$_excluded);
    return (0, $dnfL5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $4c9fc4b0ff589bb7$var$rootStyles,
            appearance === "UNSAFE_modal-below-sm" && $4c9fc4b0ff589bb7$var$modalStyles,
            !shouldRenderToParent && $4c9fc4b0ff589bb7$var$scrollableStyles,
            shouldFitContainer && $4c9fc4b0ff589bb7$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $4c9fc4b0ff589bb7$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $4c9fc4b0ff589bb7$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $6f449669bd6f3e67$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $b564c226eb4c8531$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $e3059f3b699dc189$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $dnfL5.jsx)((0, $4c51652d4d644b73$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $dnfL5.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === "UNSAFE_modal-below-sm" ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $dnfL5.jsx)((0, $f91101f449b8ac54$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $ltooA.fg)("platform-design-system-apply-popup-wrapper-focus") ? (0, $dnfL5.jsx)((0, $acw62.Fragment), null, (0, $dnfL5.jsx)((0, $39648264581c94c1$export$2e2bcd8739ae039), null, popupContainer), appearance === "UNSAFE_modal-below-sm" && (0, $dnfL5.jsx)("div", {
            css: $4c9fc4b0ff589bb7$var$blanketStyles
        })) : (0, $dnfL5.jsx)((0, $acw62.Fragment), null, popupContainer, appearance === "UNSAFE_modal-below-sm" && (0, $dnfL5.jsx)("div", {
            css: $4c9fc4b0ff589bb7$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4c9fc4b0ff589bb7$export$2e2bcd8739ae039 = $4c9fc4b0ff589bb7$var$PopperWrapper;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $acw62 = parcelRequire("acw62");
var $d6218787c165cb1f$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $e47e3ad97dccc62a$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $e47e3ad97dccc62a$export$c881183ca713c214 = $e47e3ad97dccc62a$export$987d49ffe1b0900f;


var $13779b62205b788b$var$_window, $13779b62205b788b$var$_window$matchMedia, $13779b62205b788b$var$_window2, $13779b62205b788b$var$_window2$matchMedia, $13779b62205b788b$var$_window3, $13779b62205b788b$var$_window3$matchMedia, $13779b62205b788b$var$_window4, $13779b62205b788b$var$_window4$matchMedia, $13779b62205b788b$var$_window5, $13779b62205b788b$var$_window5$matchMedia, $13779b62205b788b$var$_window6, $13779b62205b788b$var$_window6$matchMedia, $13779b62205b788b$var$_window7, $13779b62205b788b$var$_window7$matchMedia, $13779b62205b788b$var$_window8, $13779b62205b788b$var$_window8$matchMedia, $13779b62205b788b$var$_window9, $13779b62205b788b$var$_window9$matchMedia, $13779b62205b788b$var$_window10, $13779b62205b788b$var$_window10$matchMedia, $13779b62205b788b$var$_window11, $13779b62205b788b$var$_window11$matchMedia;
var $13779b62205b788b$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window = window) === null || $13779b62205b788b$var$_window === void 0 || ($13779b62205b788b$var$_window$matchMedia = $13779b62205b788b$var$_window.matchMedia) === null || $13779b62205b788b$var$_window$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window$matchMedia.call($13779b62205b788b$var$_window, (0, $e47e3ad97dccc62a$export$c881183ca713c214).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window2 = window) === null || $13779b62205b788b$var$_window2 === void 0 || ($13779b62205b788b$var$_window2$matchMedia = $13779b62205b788b$var$_window2.matchMedia) === null || $13779b62205b788b$var$_window2$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window2$matchMedia.call($13779b62205b788b$var$_window2, (0, $e47e3ad97dccc62a$export$c881183ca713c214).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window3 = window) === null || $13779b62205b788b$var$_window3 === void 0 || ($13779b62205b788b$var$_window3$matchMedia = $13779b62205b788b$var$_window3.matchMedia) === null || $13779b62205b788b$var$_window3$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window3$matchMedia.call($13779b62205b788b$var$_window3, (0, $e47e3ad97dccc62a$export$c881183ca713c214).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window4 = window) === null || $13779b62205b788b$var$_window4 === void 0 || ($13779b62205b788b$var$_window4$matchMedia = $13779b62205b788b$var$_window4.matchMedia) === null || $13779b62205b788b$var$_window4$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window4$matchMedia.call($13779b62205b788b$var$_window4, (0, $e47e3ad97dccc62a$export$c881183ca713c214).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window5 = window) === null || $13779b62205b788b$var$_window5 === void 0 || ($13779b62205b788b$var$_window5$matchMedia = $13779b62205b788b$var$_window5.matchMedia) === null || $13779b62205b788b$var$_window5$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window5$matchMedia.call($13779b62205b788b$var$_window5, (0, $e47e3ad97dccc62a$export$c881183ca713c214).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window6 = window) === null || $13779b62205b788b$var$_window6 === void 0 || ($13779b62205b788b$var$_window6$matchMedia = $13779b62205b788b$var$_window6.matchMedia) === null || $13779b62205b788b$var$_window6$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window6$matchMedia.call($13779b62205b788b$var$_window6, (0, $e47e3ad97dccc62a$export$c881183ca713c214).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window7 = window) === null || $13779b62205b788b$var$_window7 === void 0 || ($13779b62205b788b$var$_window7$matchMedia = $13779b62205b788b$var$_window7.matchMedia) === null || $13779b62205b788b$var$_window7$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window7$matchMedia.call($13779b62205b788b$var$_window7, (0, $e47e3ad97dccc62a$export$c881183ca713c214).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window8 = window) === null || $13779b62205b788b$var$_window8 === void 0 || ($13779b62205b788b$var$_window8$matchMedia = $13779b62205b788b$var$_window8.matchMedia) === null || $13779b62205b788b$var$_window8$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window8$matchMedia.call($13779b62205b788b$var$_window8, (0, $e47e3ad97dccc62a$export$c881183ca713c214).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window9 = window) === null || $13779b62205b788b$var$_window9 === void 0 || ($13779b62205b788b$var$_window9$matchMedia = $13779b62205b788b$var$_window9.matchMedia) === null || $13779b62205b788b$var$_window9$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window9$matchMedia.call($13779b62205b788b$var$_window9, (0, $e47e3ad97dccc62a$export$c881183ca713c214).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window10 = window) === null || $13779b62205b788b$var$_window10 === void 0 || ($13779b62205b788b$var$_window10$matchMedia = $13779b62205b788b$var$_window10.matchMedia) === null || $13779b62205b788b$var$_window10$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window10$matchMedia.call($13779b62205b788b$var$_window10, (0, $e47e3ad97dccc62a$export$c881183ca713c214).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($13779b62205b788b$var$_window11 = window) === null || $13779b62205b788b$var$_window11 === void 0 || ($13779b62205b788b$var$_window11$matchMedia = $13779b62205b788b$var$_window11.matchMedia) === null || $13779b62205b788b$var$_window11$matchMedia === void 0 ? void 0 : $13779b62205b788b$var$_window11$matchMedia.call($13779b62205b788b$var$_window11, (0, $e47e3ad97dccc62a$export$c881183ca713c214).below.xl.replace("@media ", "").trim())
};
var $13779b62205b788b$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $acw62.useRef)(listener);
    (0, $acw62.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $13779b62205b788b$var$queries[queryString];
    (0, $d6218787c165cb1f$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $8fY35.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $a0b66de5ab92cfdf$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $13779b62205b788b$export$49e55ae2c03d6045)("below.sm", function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $acw62.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === "UNSAFE_modal-below-sm" && isSmallViewport ? "UNSAFE_modal-below-sm" : "default";
    var shouldRenderToParent = _shouldRenderToParent && appearance === "default";
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");
var $f0ebef19cbcdfd96$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $acw62.useState)(function() {
        return (0, $jk22o.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");
var $1d78d48a320ef74b$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $acw62.useState)(function() {
        return (0, $jk22o.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $f6c6585f0b64ab7f$var$defaultLayer = (0, $cFKGy.layers).layer();
var $f6c6585f0b64ab7f$var$wrapperStyles = (0, $b73c0fec4c496922$export$f6c783d06584602c)({
    position: "relative"
});
var $f6c6585f0b64ab7f$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $f6c6585f0b64ab7f$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $f0ebef19cbcdfd96$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $1d78d48a320ef74b$export$5d3a2de79e07b376)();
    var generatedId = (0, $lNWR1.useId)();
    var _usePopupAppearance = (0, $a0b66de5ab92cfdf$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $ebe38ff99337ff76$export$469bb693f11edc7f)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $dnfL5.jsx)((0, $31390fc59b838143$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $dnfL5.jsx)((0, $4c9fc4b0ff589bb7$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $dnfL5.jsx)((0, $6Hh1R.Manager), null, (0, $dnfL5.jsx)((0, $947a156bfc8423f9$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $ltooA.fg)("platform-design-system-popup-ref") ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $dnfL5.jsx)((0, $f7a2bf4376bacc46$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $dnfL5.jsx)((0, $c6e5ce6df13b0da0$export$2e2bcd8739ae039), {
        xcss: $f6c6585f0b64ab7f$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $f6c6585f0b64ab7f$export$2e2bcd8739ae039 = $f6c6585f0b64ab7f$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b92ca51b974ad76$export$2e2bcd8739ae039 = (0, $f6c6585f0b64ab7f$export$129a32eedafa97c5);



var $cFKGy = parcelRequire("cFKGy");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $8Fp8I = parcelRequire("8Fp8I");


var $g5Zhu = parcelRequire("g5Zhu");

var $dXy8E = parcelRequire("dXy8E");

var $ltooA = parcelRequire("ltooA");

var $lNWR1 = parcelRequire("lNWR1");
var $01b7f00011a347b6$export$8a682ae47622dbb9 = "ds--dropdown--";
function $01b7f00011a347b6$export$2e2bcd8739ae039() {
    var id = (0, $lNWR1.useId)();
    return "".concat($01b7f00011a347b6$export$8a682ae47622dbb9).concat(id);
}


var $7ed9866a9cd09228$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $dXy8E.KEY_DOWN), "next"), (0, $dXy8E.KEY_UP), "prev"), (0, $dXy8E.KEY_HOME), "first"), (0, $dXy8E.KEY_END), "last");
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $7ed9866a9cd09228$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var element = refs[++currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute("disabled");
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $7ed9866a9cd09228$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var element = refs[--currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute("disabled");
        if (isValid) return element;
    }
};
function $7ed9866a9cd09228$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $01b7f00011a347b6$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $dXy8E.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $dXy8E.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $7ed9866a9cd09228$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < currentRefs.length - 1) {
                    var _nextFocusableElement = $7ed9866a9cd09228$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $7ed9866a9cd09228$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $7ed9866a9cd09228$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $7ed9866a9cd09228$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $7ed9866a9cd09228$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $7ed9866a9cd09228$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $978040dd98293eac$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $acw62.createContext)({
    menuItemRefs: [],
    registerRef: (0, $8Fp8I.default)
});
/**
 * Focus manager logic.
 */ var $978040dd98293eac$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $acw62.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $acw62.useRef)("ordered");
    registerMode.current = "ordered";
    var registerRef = (0, $acw62.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case "ordered":
                menuItemRefs.current.push(ref);
                break;
            case "unordered":
                // Reset and force a rerender
                registerMode.current = "regenerate";
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case "regenerate":
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $e3059f3b699dc189$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $acw62.useEffect)(function() {
        if (registerMode.current === "ordered") // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = "unordered";
    });
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "keydown",
            listener: (0, $7ed9866a9cd09228$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($978040dd98293eac$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $978040dd98293eac$export$2e2bcd8739ae039 = $978040dd98293eac$var$FocusManager;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $dnfL5 = parcelRequire("dnfL5");

var $acw62 = parcelRequire("acw62");
var $761f855927d3d42b$export$443076ec7ebce042 = /*#__PURE__*/ (0, $acw62.createContext)("cozy");
var $761f855927d3d42b$export$9ca534b70725964d = /*#__PURE__*/ (0, $acw62.createContext)("border");


var $1ad1f8702b89e3ec$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $1ad1f8702b89e3ec$var$baseStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $1ad1f8702b89e3ec$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $1ad1f8702b89e3ec$var$_excluded);
    return (0, $dnfL5.jsx)((0, $761f855927d3d42b$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $dnfL5.jsx)((0, $761f855927d3d42b$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $dnfL5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $1ad1f8702b89e3ec$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $1ad1f8702b89e3ec$export$2e2bcd8739ae039 = $1ad1f8702b89e3ec$var$MenuGroup;



/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9dvtP = parcelRequire("9dvtP");

var $acw62 = parcelRequire("acw62");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $5XtxN = parcelRequire("5XtxN");
var $ca55993ecf0c2ad8$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $e9cb1d6d63d84fa7$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $5XtxN.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $5XtxN.N0), ")");
}
var $e9cb1d6d63d84fa7$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $e9cb1d6d63d84fa7$var$loadIn = null;
var $e9cb1d6d63d84fa7$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e9cb1d6d63d84fa7$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e9cb1d6d63d84fa7$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $ca55993ecf0c2ad8$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e9cb1d6d63d84fa7$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $5ZZ0M.default));
    $e9cb1d6d63d84fa7$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9dvtP.default)([
            $e9cb1d6d63d84fa7$var$styles.wrapperStyles,
            $e9cb1d6d63d84fa7$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $9dvtP.default)([
            $e9cb1d6d63d84fa7$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $9dvtP.default)([
            $e9cb1d6d63d84fa7$var$styles.circleStyles
        ])
    })));
}));
var $e9cb1d6d63d84fa7$export$2e2bcd8739ae039 = $e9cb1d6d63d84fa7$var$Spinner;


function $3ed29e022ffdebdc$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "checkbox" || role === "menuitemcheckbox";
}


function $29e979d08fa9681d$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "radio" || role === "menuitemradio";
}



var $5e2a1ab804b9a578$var$spinnerContainerStyles = (0, $b73c0fec4c496922$export$f6c783d06584602c)({
    display: "flex",
    minWidth: "160px",
    padding: "space.250",
    justifyContent: "center"
});
var $5e2a1ab804b9a578$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? "Loading" : _ref$statusLabel, testId = _ref.testId;
    return (0, $dnfL5.jsx)((0, $c6e5ce6df13b0da0$export$2e2bcd8739ae039), {
        xcss: $5e2a1ab804b9a578$var$spinnerContainerStyles
    }, (0, $dnfL5.jsx)((0, $e9cb1d6d63d84fa7$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $5e2a1ab804b9a578$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $acw62.useContext)((0, $978040dd98293eac$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $3ed29e022ffdebdc$export$2e2bcd8739ae039)(menuItem) || (0, $29e979d08fa9681d$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $acw62.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $acw62.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute("disabled");
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $dnfL5.jsx)((0, $1ad1f8702b89e3ec$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $dnfL5.jsx)($5e2a1ab804b9a578$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $5e2a1ab804b9a578$export$2e2bcd8739ae039 = $5e2a1ab804b9a578$var$MenuWrapper;



var $acw62 = parcelRequire("acw62");

var $8Fp8I = parcelRequire("8Fp8I");
var $06fbe7b38794f351$export$756f795847463ebd = /*#__PURE__*/ (0, $acw62.createContext)({
    setItemState: (0, $8Fp8I.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $8Fp8I.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $06fbe7b38794f351$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $acw62.useRef)({});
    var context = (0, $acw62.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($06fbe7b38794f351$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $06fbe7b38794f351$export$2e2bcd8739ae039 = $06fbe7b38794f351$var$SelectionStore;



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $3edcc84d52ebfb82$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $acw62.useContext)((0, $978040dd98293eac$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (hasPopup && (0, $ltooA.fg)("select-avoid-duplicated-registered-ref")) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $3edcc84d52ebfb82$export$2e2bcd8739ae039 = $3edcc84d52ebfb82$var$useRegisterItemWithFocusManager;



var $1263a8525c372af9$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $1263a8525c372af9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1263a8525c372af9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1263a8525c372af9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1263a8525c372af9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1263a8525c372af9$var$gridSize = (0, $cFKGy.gridSize)();
var $1263a8525c372af9$var$MAX_HEIGHT = "calc(100vh - ".concat($1263a8525c372af9$var$gridSize * 2, "px)");
var $1263a8525c372af9$var$opposites = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    start: "end",
    auto: "auto",
    end: "start"
};
var $1263a8525c372af9$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split("-");
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        "top",
        "bottom"
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        "start",
        "end"
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($1263a8525c372af9$var$opposites[crossAxis]),
            "".concat($1263a8525c372af9$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($1263a8525c372af9$var$opposites[mainAxis]),
            "".concat($1263a8525c372af9$var$opposites[mainAxis], "-").concat($1263a8525c372af9$var$opposites[crossAxis]),
            "auto"
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($1263a8525c372af9$var$opposites[mainAxis]),
        "".concat($1263a8525c372af9$var$opposites[mainAxis], "-start"),
        "".concat($1263a8525c372af9$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $1263a8525c372af9$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $8Fp8I.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $cFKGy.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy;
    var _useControlledState = (0, $982af3473eee44c3$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $01b7f00011a347b6$export$2e2bcd8739ae039)();
    var itemRef = (0, $3edcc84d52ebfb82$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $acw62.useMemo)(function() {
        return $1263a8525c372af9$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $acw62.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === "keydown") setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $acw62.useCallback)(function(event, currentLevel) {
        var _event$target, _event$target$closest;
        if (event.key !== "Escape" && event.key !== "Tab" && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $01b7f00011a347b6$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset["ds-Level"];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if (event.key === "Tab" && event.shiftKey || event.key === "Escape") requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(function() {
            var _triggerRef$current;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $31442ad359bb1bbf$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $acw62.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $8Fp8I.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $8Fp8I.default;
        return (0, $8fY35.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $01b7f00011a347b6$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $dXy8E.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $dXy8E.KEY_SPACE) || e.key === (0, $dXy8E.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $dXy8E.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== "fixed" ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06fbe7b38794f351$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b92ca51b974ad76$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2["aria-controls"], ariaExpanded = _ref2["aria-expanded"], ariaHasPopup = _ref2["aria-haspopup"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $1263a8525c372af9$var$_excluded);
            if (typeof _trigger === "function") return _trigger($1263a8525c372af9$var$_objectSpread($1263a8525c372af9$var$_objectSpread($1263a8525c372af9$var$_objectSpread({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $ktKrw.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5auEi.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bindFocus, {
                ref: (0, $ktKrw.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($a2777c4e957814e4$exports))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $978040dd98293eac$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e2a1ab804b9a578$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $1263a8525c372af9$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $1263a8525c372af9$export$2e2bcd8739ae039 = $1263a8525c372af9$var$DropdownMenu;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ktKrw = parcelRequire("ktKrw");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $gbB1D = parcelRequire("gbB1D");

var $8Fp8I = parcelRequire("8Fp8I");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $ltooA = parcelRequire("ltooA");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $gbB1D = parcelRequire("gbB1D");


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");
var $3421a668b099315b$export$4ef52930e33717cd = "data-theme";
var $3421a668b099315b$export$a00eac3f8684bcd0 = "data-color-mode";
var $3421a668b099315b$export$2112803007239c61 = "data-contrast-mode";
var $3421a668b099315b$export$352e418ed5b6193a = "data-custom-theme";
var $3421a668b099315b$export$2faeed762aac6741 = "light";
var $3421a668b099315b$export$6f0c6fb8c80fcc92 = "ds";
var $3421a668b099315b$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $3421a668b099315b$export$dddac1532e822863 = "--".concat($3421a668b099315b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $3421a668b099315b$export$9d7b58831ae93caa = "--".concat($3421a668b099315b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $74a17725458386f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74a17725458386f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74a17725458386f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74a17725458386f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74a17725458386f4$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $74a17725458386f4$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $74a17725458386f4$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $74a17725458386f4$export$632685d741f3dbbf = $74a17725458386f4$var$_objectSpread($74a17725458386f4$var$_objectSpread({}, $74a17725458386f4$export$958d0ae7f2977ae4), $74a17725458386f4$export$d2dc61f58390201c);
var $74a17725458386f4$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $74a17725458386f4$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $74a17725458386f4$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $74a17725458386f4$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $74a17725458386f4$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $74a17725458386f4$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $74a17725458386f4$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $74a17725458386f4$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $74a17725458386f4$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $74a17725458386f4$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $74a17725458386f4$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $74a17725458386f4$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $74a17725458386f4$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $74a17725458386f4$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $74a17725458386f4$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $74a17725458386f4$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $74a17725458386f4$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $74a17725458386f4$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $74a17725458386f4$export$e615f061ca585a6c = $74a17725458386f4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $74a17725458386f4$export$ca0f9c2de39ffed7(spacingProperty, $74a17725458386f4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $74a17725458386f4$export$bf46c3f9eeafc71f = $74a17725458386f4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $74a17725458386f4$export$ca0f9c2de39ffed7(spacingProperty, $74a17725458386f4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $74a17725458386f4$export$e7af83bafe7f9e63 = $74a17725458386f4$export$ca0f9c2de39ffed7("backgroundColor", $74a17725458386f4$export$d1d79bf68ac056bd);
var $74a17725458386f4$export$3a1bcba60b23d7f0 = $74a17725458386f4$export$ca0f9c2de39ffed7("color", $74a17725458386f4$export$8473307aa00d6ea1);
var $74a17725458386f4$export$45f3f4fe16f9f7d5 = $74a17725458386f4$export$ca0f9c2de39ffed7("fontWeight", $74a17725458386f4$export$303e322c6b1ed114);
var $74a17725458386f4$export$68cc305da27dbaa4 = $74a17725458386f4$export$ca0f9c2de39ffed7("fontFamily", $74a17725458386f4$export$3c7e9587132614b4);
var $74a17725458386f4$export$128f10c238242f83 = $74a17725458386f4$export$ca0f9c2de39ffed7("font", $74a17725458386f4$export$6ffa317d5e70375);
var $74a17725458386f4$export$219d364c0da35ae4 = $74a17725458386f4$export$ca0f9c2de39ffed7("font", $74a17725458386f4$export$236bfe3a33ef1292);
var $74a17725458386f4$export$38845ca010b93505 = $74a17725458386f4$export$ca0f9c2de39ffed7("fontWeight", $74a17725458386f4$export$855cfd311192d666);
var $74a17725458386f4$export$ff257d957d48c421 = $74a17725458386f4$export$ca0f9c2de39ffed7((0, $3421a668b099315b$export$9d7b58831ae93caa), $74a17725458386f4$export$41a358c9c2356760);
var $74a17725458386f4$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $74a17725458386f4$export$41a358c9c2356760[color] !== undefined;
};



var $hPtJY = parcelRequire("hPtJY");
function $3f6b0708a56db47d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3f6b0708a56db47d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3f6b0708a56db47d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3f6b0708a56db47d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3f6b0708a56db47d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3f6b0708a56db47d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $3f6b0708a56db47d$export$9a199fbafee0014e = {
    backgroundColor: (0, $74a17725458386f4$export$d1d79bf68ac056bd),
    blockSize: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderBottomColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderLeftColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $74a17725458386f4$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    borderWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    bottom: (0, $74a17725458386f4$export$632685d741f3dbbf),
    boxShadow: (0, $74a17725458386f4$export$7aff6e7ba39bb774),
    color: (0, $74a17725458386f4$export$8473307aa00d6ea1),
    columnGap: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    font: (0, $74a17725458386f4$export$6ffa317d5e70375),
    fontFamily: (0, $74a17725458386f4$export$3c7e9587132614b4),
    fontWeight: (0, $74a17725458386f4$export$303e322c6b1ed114),
    gap: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    height: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    inlineSize: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    inset: (0, $74a17725458386f4$export$632685d741f3dbbf),
    insetBlock: (0, $74a17725458386f4$export$632685d741f3dbbf),
    insetBlockEnd: (0, $74a17725458386f4$export$632685d741f3dbbf),
    insetBlockStart: (0, $74a17725458386f4$export$632685d741f3dbbf),
    insetInline: (0, $74a17725458386f4$export$632685d741f3dbbf),
    insetInlineEnd: (0, $74a17725458386f4$export$632685d741f3dbbf),
    insetInlineStart: (0, $74a17725458386f4$export$632685d741f3dbbf),
    left: (0, $74a17725458386f4$export$632685d741f3dbbf),
    margin: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginBlock: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginBlockEnd: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginBlockStart: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginBottom: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginInline: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginInlineEnd: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginInlineStart: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginLeft: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginRight: (0, $74a17725458386f4$export$632685d741f3dbbf),
    marginTop: (0, $74a17725458386f4$export$632685d741f3dbbf),
    maxBlockSize: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    maxHeight: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    maxWidth: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    minBlockSize: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    minHeight: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    minInlineSize: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    minWidth: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    opacity: (0, $74a17725458386f4$export$daf94a976c798b4f),
    outlineColor: (0, $74a17725458386f4$export$1531ad5bb3fbedac),
    outlineOffset: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    outlineWidth: (0, $74a17725458386f4$export$e1b83c5210c471b8),
    padding: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingBlock: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingBottom: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingInline: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingLeft: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingRight: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    paddingTop: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    right: (0, $74a17725458386f4$export$632685d741f3dbbf),
    rowGap: (0, $74a17725458386f4$export$958d0ae7f2977ae4),
    top: (0, $74a17725458386f4$export$632685d741f3dbbf),
    width: (0, $74a17725458386f4$export$6ccdbebca2ee545f),
    zIndex: (0, $74a17725458386f4$export$b5f31a7e431d2eab)
};
var $3f6b0708a56db47d$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $3f6b0708a56db47d$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $3f6b0708a56db47d$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3f6b0708a56db47d$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3f6b0708a56db47d$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($3f6b0708a56db47d$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $3f6b0708a56db47d$var$safeSelectors.test(key)) {
            styleObj[key] = $3f6b0708a56db47d$var$_transformStyles(value);
            return;
        }
        if ($3f6b0708a56db47d$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3f6b0708a56db47d$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3f6b0708a56db47d$export$9a199fbafee0014e)) return;
        var tokenValue = $3f6b0708a56db47d$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3f6b0708a56db47d$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3f6b0708a56db47d$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $3f6b0708a56db47d$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $3f6b0708a56db47d$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3f6b0708a56db47d$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $3f6b0708a56db47d$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3f6b0708a56db47d$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3f6b0708a56db47d$export$f6c783d06584602c(style) {
    return $3f6b0708a56db47d$var$baseXcss(style);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $b06a372e57678c19$var$justifyContentMap = {
    start: (0, $dnfL5.css)({
        justifyContent: "start"
    }),
    center: (0, $dnfL5.css)({
        justifyContent: "center"
    }),
    end: (0, $dnfL5.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $dnfL5.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $dnfL5.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $dnfL5.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $dnfL5.css)({
        justifyContent: "stretch"
    })
};
var $b06a372e57678c19$var$flexDirectionMap = {
    column: (0, $dnfL5.css)({
        flexDirection: "column"
    }),
    row: (0, $dnfL5.css)({
        flexDirection: "row"
    })
};
var $b06a372e57678c19$var$flexWrapMap = {
    wrap: (0, $dnfL5.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $dnfL5.css)({
        flexWrap: "nowrap"
    })
};
var $b06a372e57678c19$var$alignItemsMap = {
    start: (0, $dnfL5.css)({
        alignItems: "start"
    }),
    center: (0, $dnfL5.css)({
        alignItems: "center"
    }),
    baseline: (0, $dnfL5.css)({
        alignItems: "baseline"
    }),
    end: (0, $dnfL5.css)({
        alignItems: "end"
    }),
    stretch: (0, $dnfL5.css)({
        alignItems: "stretch"
    })
};
var $b06a372e57678c19$var$baseStyles = (0, $dnfL5.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $b06a372e57678c19$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $3f6b0708a56db47d$export$a9c84988c8f81f2d)(xcss);
    return (0, $dnfL5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $b06a372e57678c19$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $74a17725458386f4$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $74a17725458386f4$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $74a17725458386f4$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $b06a372e57678c19$var$alignItemsMap[alignItems],
            direction && $b06a372e57678c19$var$flexDirectionMap[direction],
            justifyContent && $b06a372e57678c19$var$justifyContentMap[justifyContent],
            wrap && $b06a372e57678c19$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$b06a372e57678c19$var$Flex.displayName = "Flex";
var $b06a372e57678c19$export$2e2bcd8739ae039 = $b06a372e57678c19$var$Flex;


var $79a33ba47c98bd7c$var$flexGrowMap = {
    hug: (0, $3f6b0708a56db47d$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $3f6b0708a56db47d$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $79a33ba47c98bd7c$var$separatorStyles = (0, $dnfL5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $79a33ba47c98bd7c$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $dnfL5.jsx)("span", {
        css: $79a33ba47c98bd7c$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $79a33ba47c98bd7c$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $dnfL5.jsx)($79a33ba47c98bd7c$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $dnfL5.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $79a33ba47c98bd7c$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $dnfL5.jsx)((0, $b06a372e57678c19$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$79a33ba47c98bd7c$var$Inline.displayName = "Inline";
var $79a33ba47c98bd7c$export$2e2bcd8739ae039 = $79a33ba47c98bd7c$var$Inline;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $0407305aab5660b1$var$flexGrowMap = {
    hug: (0, $3f6b0708a56db47d$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $3f6b0708a56db47d$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $0407305aab5660b1$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $0407305aab5660b1$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $dnfL5.jsx)((0, $b06a372e57678c19$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0407305aab5660b1$var$Stack.displayName = "Stack";
var $0407305aab5660b1$export$2e2bcd8739ae039 = $0407305aab5660b1$var$Stack;



var $5XtxN = parcelRequire("5XtxN");

var $4586de5a692015ce$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $dnfL5.jsx)(Component, props));
};
var $4586de5a692015ce$var$beforeAfterElementStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $4586de5a692015ce$var$contentStyles = (0, $3f6b0708a56db47d$export$f6c783d06584602c)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $4586de5a692015ce$var$truncateStyles = (0, $dnfL5.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $4586de5a692015ce$var$titleStyles = (0, $dnfL5.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $4586de5a692015ce$var$wordBreakStyles = (0, $dnfL5.css)({
    wordBreak: "break-word"
});
var $4586de5a692015ce$var$descriptionStyles = (0, $dnfL5.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $5XtxN.N200), ")"),
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $4586de5a692015ce$var$disabledDescriptionStyles = (0, $dnfL5.css)({
    color: "var(--ds-text-disabled, ".concat((0, $5XtxN.N200), ")")
});
var $4586de5a692015ce$var$positionRelativeStyles = (0, $dnfL5.css)({
    position: "relative"
});
var $4586de5a692015ce$var$primitiveStyles = (0, $dnfL5.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $4586de5a692015ce$var$spacingMapStyles = {
    cozy: (0, $dnfL5.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $dnfL5.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $4586de5a692015ce$var$interactiveStyles = (0, $dnfL5.css)({
    cursor: "pointer"
});
var $4586de5a692015ce$var$unselectedStyles = (0, $dnfL5.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $5XtxN.N20), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $5XtxN.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $4586de5a692015ce$var$disabledStyles = (0, $dnfL5.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $5XtxN.N200), ")")
    }
});
var $4586de5a692015ce$var$selectedBorderStyles = (0, $dnfL5.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $4586de5a692015ce$var$selectedNotchStyles = (0, $dnfL5.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $4586de5a692015ce$var$selectedStyles = (0, $dnfL5.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $5XtxN.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $5XtxN.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $5XtxN.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $4586de5a692015ce$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $4586de5a692015ce$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $gbB1D.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $acw62.useContext)((0, $761f855927d3d42b$export$443076ec7ebce042));
    var selectionStyle = (0, $acw62.useContext)((0, $761f855927d3d42b$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $4586de5a692015ce$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $dnfL5.jsx)((0, $dnfL5.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $dnfL5.jsx)((0, $39648264581c94c1$export$2e2bcd8739ae039), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $4586de5a692015ce$var$positionRelativeStyles,
                    $4586de5a692015ce$var$primitiveStyles,
                    $4586de5a692015ce$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $4586de5a692015ce$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $4586de5a692015ce$var$selectedStyles,
                        [
                            selectionStyle === "border" && $4586de5a692015ce$var$selectedBorderStyles,
                            selectionStyle === "notch" && $4586de5a692015ce$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $4586de5a692015ce$var$disabledStyles : $4586de5a692015ce$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $dnfL5.jsx)((0, $79a33ba47c98bd7c$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $4586de5a692015ce$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $dnfL5.jsx)("span", {
                "data-item-elem-before": true,
                css: $4586de5a692015ce$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $dnfL5.jsx)((0, $0407305aab5660b1$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: $4586de5a692015ce$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn($4586de5a692015ce$var$titleStyles, shouldTitleWrap ? $4586de5a692015ce$var$wordBreakStyles : $4586de5a692015ce$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $dnfL5.jsx)("span", {
                "data-item-description": true,
                css: [
                    $4586de5a692015ce$var$descriptionStyles,
                    isDisabled && $4586de5a692015ce$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $4586de5a692015ce$var$wordBreakStyles : $4586de5a692015ce$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $dnfL5.jsx)("span", {
                "data-item-elem-after": true,
                css: $4586de5a692015ce$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $4586de5a692015ce$export$2e2bcd8739ae039 = $4586de5a692015ce$var$MenuItemPrimitive;


var $02087188e6a3b46f$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $02087188e6a3b46f$var$ButtonItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $8Fp8I.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $02087188e6a3b46f$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $acw62.useContext)((0, $5ZZ0M.default));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $gbB1D.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8Fp8I.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $dnfL5.jsx)((0, $4586de5a692015ce$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $dnfL5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $02087188e6a3b46f$export$2e2bcd8739ae039 = $02087188e6a3b46f$var$ButtonItem;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $gbB1D = parcelRequire("gbB1D");

var $8Fp8I = parcelRequire("8Fp8I");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $ltooA = parcelRequire("ltooA");

var $23ca5baa42dc7f7a$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $23ca5baa42dc7f7a$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $23ca5baa42dc7f7a$var$CustomItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $8Fp8I.default) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $23ca5baa42dc7f7a$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $acw62.useContext)((0, $5ZZ0M.default));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $gbB1D.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8Fp8I.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $dnfL5.jsx)((0, $4586de5a692015ce$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $dnfL5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $23ca5baa42dc7f7a$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $23ca5baa42dc7f7a$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $23ca5baa42dc7f7a$var$preventEvent : (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $23ca5baa42dc7f7a$export$2e2bcd8739ae039 = $23ca5baa42dc7f7a$var$CustomItem;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $gBTNE = parcelRequire("gBTNE");

var $gbB1D = parcelRequire("gbB1D");

var $8Fp8I = parcelRequire("8Fp8I");

var $5ZZ0M = parcelRequire("5ZZ0M");

var $ltooA = parcelRequire("ltooA");

var $c31bc2dc109999b2$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $c31bc2dc109999b2$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $c31bc2dc109999b2$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $c31bc2dc109999b2$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $c31bc2dc109999b2$var$LinkItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $8Fp8I.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $c31bc2dc109999b2$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $gBTNE.default)();
    var interactionContext = (0, $acw62.useContext)((0, $5ZZ0M.default));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === "string" && $c31bc2dc109999b2$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $c31bc2dc109999b2$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : "a";
    (0, $gbB1D.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8Fp8I.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $dnfL5.jsx)((0, $4586de5a692015ce$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $c31bc2dc109999b2$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $c31bc2dc109999b2$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $c31bc2dc109999b2$var$preventEvent : (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $c31bc2dc109999b2$export$2e2bcd8739ae039 = $c31bc2dc109999b2$var$LinkItem;



var $ltooA = parcelRequire("ltooA");

var $b946ff9b63436f4b$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $b946ff9b63436f4b$var$DropdownMenuItem = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b946ff9b63436f4b$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $3edcc84d52ebfb82$export$2e2bcd8739ae039)(!!rest["aria-haspopup"]);
    var handleItemClick = (0, $acw62.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $23ca5baa42dc7f7a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $ktKrw.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c31bc2dc109999b2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $ktKrw.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02087188e6a3b46f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $ktKrw.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
});
var $b946ff9b63436f4b$export$2e2bcd8739ae039 = $b946ff9b63436f4b$var$DropdownMenuItem;


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $8Fp8I = parcelRequire("8Fp8I");



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $dsTof = parcelRequire("dsTof");

var $iPMlH = parcelRequire("iPMlH");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $803a77902aa5d3f3$var$svgStyles = (0, $dnfL5.css)((0, $iPMlH.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $803a77902aa5d3f3$var$SVG = /*#__PURE__*/ (0, $acw62.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $dnfL5.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $dsTof.getBackground)()
        },
        css: [
            $803a77902aa5d3f3$var$svgStyles,
            (0, $iPMlH.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $803a77902aa5d3f3$export$2e2bcd8739ae039 = $803a77902aa5d3f3$var$SVG;



var $ltooA = parcelRequire("ltooA");

var $5XtxN = parcelRequire("5XtxN");
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ var $b9d60df9293a315c$var$CheckboxIcon = function CheckboxIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $803a77902aa5d3f3$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $5XtxN.B400), ")") : "var(--ds-background-input, ".concat((0, $5XtxN.N10), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $5XtxN.N10), ")") : "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons") && (0, $ltooA.fg)("platform-icon-control-migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $5XtxN.B400), ")") : "var(--ds-border-input, ".concat((0, $5XtxN.N100), ")"),
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $5XtxN.B400), ")") : "var(--ds-border-input, ".concat((0, $5XtxN.N100), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    }))));
};
var $b9d60df9293a315c$export$2e2bcd8739ae039 = $b9d60df9293a315c$var$CheckboxIcon;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $0a875a4e60a01286$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $acw62.createContext)("");



/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ var $d30edff9df6093f8$var$useCheckboxState = function useCheckboxState(_ref) {
    var isSelected = _ref.isSelected, id = _ref.id, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $acw62.useContext)((0, $06fbe7b38794f351$export$756f795847463ebd)), setItemState = _useContext.setItemState, getItemState = _useContext.getItemState;
    var groupId = (0, $acw62.useContext)((0, $0a875a4e60a01286$export$baf37c4be89255b8));
    var persistedIsSelected = getItemState(groupId, id);
    var _useState = (0, $acw62.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $acw62.useCallback)(function(newValue) {
        var nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === "boolean") return [
        isSelected,
        function() {
            return false;
        }
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $d30edff9df6093f8$export$2e2bcd8739ae039 = $d30edff9df6093f8$var$useCheckboxState;




var $hPtJY = parcelRequire("hPtJY");
var $266d196313c1f14d$var$_excluded = [
    "children",
    "defaultSelected",
    "description",
    "id",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "testId",
    "interactionName"
];
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ var $266d196313c1f14d$var$DropdownItemCheckbox = function DropdownItemCheckbox(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, description = _ref.description, id = _ref.id, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8Fp8I.default) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, testId = _ref.testId, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $266d196313c1f14d$var$_excluded);
    typeof $hPtJY;
    var _useCheckboxState = (0, $d30edff9df6093f8$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useCheckboxState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useCheckboxState, 2), selected = _useCheckboxState2[0], setSelected = _useCheckboxState2[1];
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $3edcc84d52ebfb82$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $761f855927d3d42b$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02087188e6a3b46f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9d60df9293a315c$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children));
};
var $266d196313c1f14d$export$2e2bcd8739ae039 = $266d196313c1f14d$var$DropdownItemCheckbox;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $lNWR1 = parcelRequire("lNWR1");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $gbB1D = parcelRequire("gbB1D");

var $5XtxN = parcelRequire("5XtxN");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $gbB1D = parcelRequire("gbB1D");

var $8Fp8I = parcelRequire("8Fp8I");

var $5XtxN = parcelRequire("5XtxN");
var $bd4830e742be2e67$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $bd4830e742be2e67$var$headingStyles = (0, $dnfL5.css)({
    color: "var(--ds-text-subtle, ".concat((0, $5XtxN.N300), ")"),
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $bd4830e742be2e67$var$HeadingItem = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $8Fp8I.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $bd4830e742be2e67$var$_excluded);
    (0, $gbB1D.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8Fp8I.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $dnfL5.css)(cssFn(undefined));
    return (0, $dnfL5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        css: [
            $bd4830e742be2e67$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $bd4830e742be2e67$export$2e2bcd8739ae039 = $bd4830e742be2e67$var$HeadingItem;


var $8f4f1dc114f36b21$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $8f4f1dc114f36b21$var$gridSize = 8;
var $8f4f1dc114f36b21$var$itemHeadingTopMargin = $8f4f1dc114f36b21$var$gridSize * 2.5;
var $8f4f1dc114f36b21$var$itemHeadingBottomMargin = $8f4f1dc114f36b21$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $8f4f1dc114f36b21$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $8f4f1dc114f36b21$var$skeletonHeadingHeight = $8f4f1dc114f36b21$var$gridSize;
var $8f4f1dc114f36b21$var$skeletonHeadingMarginOffset = 3;
var $8f4f1dc114f36b21$var$skeletonHeadingTopMargin = $8f4f1dc114f36b21$var$itemHeadingTopMargin + ($8f4f1dc114f36b21$var$itemHeadingContentHeight - $8f4f1dc114f36b21$var$skeletonHeadingHeight) - $8f4f1dc114f36b21$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $8f4f1dc114f36b21$var$skeletonHeadingBottomMargin = $8f4f1dc114f36b21$var$itemHeadingBottomMargin + $8f4f1dc114f36b21$var$skeletonHeadingMarginOffset;
var $8f4f1dc114f36b21$var$sectionPaddingTopBottom = $8f4f1dc114f36b21$var$gridSize * 0.75;
var $8f4f1dc114f36b21$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $8f4f1dc114f36b21$var$sectionStyles = (0, $dnfL5.css)({
    "&::before, &::after": {
        display: "block",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $8f4f1dc114f36b21$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $8f4f1dc114f36b21$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $8f4f1dc114f36b21$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $8f4f1dc114f36b21$var$itemHeadingTopMargin - $8f4f1dc114f36b21$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--skeleton-heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $8f4f1dc114f36b21$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $8f4f1dc114f36b21$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $8f4f1dc114f36b21$var$skeletonHeadingTopMargin - $8f4f1dc114f36b21$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $8f4f1dc114f36b21$var$scrollableStyles = (0, $dnfL5.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $8f4f1dc114f36b21$var$unscrollableStyles = (0, $dnfL5.css)({
    flexShrink: 0
});
var $8f4f1dc114f36b21$var$thinSeparatorStyles = (0, $dnfL5.css)({
    borderBlockStart: "1px solid var(".concat($8f4f1dc114f36b21$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $5XtxN.N30A), ")"), ")")
});
var $8f4f1dc114f36b21$var$noSeparatorStyles = (0, $dnfL5.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $8f4f1dc114f36b21$var$Section = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $8f4f1dc114f36b21$var$_excluded);
    (0, $gbB1D.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $dnfL5.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $acw62.Children).map((0, $acw62.Children).toArray(children), function(child, index) {
        return (0, $dnfL5.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $dnfL5.jsx)((0, $acw62.Fragment), null, (0, $dnfL5.jsx)((0, $bd4830e742be2e67$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $dnfL5.jsx)((0, $acw62.Fragment), null, content);
    return (0, $dnfL5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $8f4f1dc114f36b21$var$sectionStyles,
            isScrollable ? $8f4f1dc114f36b21$var$scrollableStyles : $8f4f1dc114f36b21$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $8f4f1dc114f36b21$var$thinSeparatorStyles : $8f4f1dc114f36b21$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $8f4f1dc114f36b21$export$2e2bcd8739ae039 = $8f4f1dc114f36b21$var$Section;



var $acw62 = parcelRequire("acw62");

var $92d1951c55d8e636$var$headingStyles = (0, $b73c0fec4c496922$export$f6c783d06584602c)({
    color: "color.text.subtle",
    font: "font.heading.xxsmall",
    paddingBlock: "space.0",
    paddingInline: "space.200"
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $92d1951c55d8e636$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6e5ce6df13b0da0$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $92d1951c55d8e636$var$headingStyles
    }, title);
};
var $92d1951c55d8e636$export$2e2bcd8739ae039 = $92d1951c55d8e636$var$GroupTitle;



var $16cda2aabaf6bb3c$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ var $16cda2aabaf6bb3c$var$DropdownItemCheckboxGroup = function DropdownItemCheckboxGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $16cda2aabaf6bb3c$var$_excluded);
    var uid = (0, $lNWR1.useId)();
    var titleId = "dropdown-menu-item-checkbox-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a875a4e60a01286$export$baf37c4be89255b8).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f4f1dc114f36b21$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $92d1951c55d8e636$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $16cda2aabaf6bb3c$export$2e2bcd8739ae039 = $16cda2aabaf6bb3c$var$DropdownItemCheckboxGroup;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $lNWR1 = parcelRequire("lNWR1");


var $e6fa7af9dd0097ab$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $e6fa7af9dd0097ab$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $e6fa7af9dd0097ab$var$_excluded);
    var uid = (0, $lNWR1.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f4f1dc114f36b21$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $92d1951c55d8e636$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $e6fa7af9dd0097ab$export$2e2bcd8739ae039 = $e6fa7af9dd0097ab$var$DropdownMenuItemGroup;


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $8Fp8I = parcelRequire("8Fp8I");



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");

var $5XtxN = parcelRequire("5XtxN");
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $35f4ff7cefe86066$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $803a77902aa5d3f3$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $5XtxN.B400), ")") : "var(--ds-background-input, ".concat((0, $5XtxN.N10), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $5XtxN.N10), ")") : "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons") && (0, $ltooA.fg)("platform-icon-control-migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $5XtxN.B400), ")") : "var(--ds-border-input, ".concat((0, $5XtxN.N100), ")"),
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $5XtxN.B400), ")") : "var(--ds-border-input, ".concat((0, $5XtxN.N100), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    }))));
};
var $35f4ff7cefe86066$export$2e2bcd8739ae039 = $35f4ff7cefe86066$var$RadioIcon;



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $8Fp8I = parcelRequire("8Fp8I");

var $lNWR1 = parcelRequire("lNWR1");




var $g5Zhu = parcelRequire("g5Zhu");
function $4ac343fc5ddf54e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ac343fc5ddf54e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ac343fc5ddf54e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ac343fc5ddf54e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4ac343fc5ddf54e6$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $4ac343fc5ddf54e6$var$_objectSpread($4ac343fc5ddf54e6$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, current, typeof group[current] === "undefined" ? undefined : false));
    }, {});
};
var $4ac343fc5ddf54e6$export$2e2bcd8739ae039 = $4ac343fc5ddf54e6$var$resetOptionsInGroup;


var $c6a273f238e36c27$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $c6a273f238e36c27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6a273f238e36c27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6a273f238e36c27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6a273f238e36c27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c6a273f238e36c27$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $acw62.createContext)({
    id: "",
    radioGroupState: {},
    selectRadioItem: (0, $8Fp8I.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $c6a273f238e36c27$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c6a273f238e36c27$var$_excluded);
    var _useContext = (0, $acw62.useContext)((0, $06fbe7b38794f351$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var uid = (0, $lNWR1.useId)();
    var titleId = "dropdown-menu-item-radio-group-title-".concat(uid);
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $acw62.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $c6a273f238e36c27$var$_objectSpread($c6a273f238e36c27$var$_objectSpread({}, (0, $4ac343fc5ddf54e6$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c6a273f238e36c27$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f4f1dc114f36b21$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $92d1951c55d8e636$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $c6a273f238e36c27$export$2e2bcd8739ae039 = $c6a273f238e36c27$var$DropdownItemRadioGroup;




function $6f20f3556678788b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f20f3556678788b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f20f3556678788b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f20f3556678788b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f20f3556678788b$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $acw62.useContext)((0, $06fbe7b38794f351$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $acw62.useContext)((0, $c6a273f238e36c27$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $acw62.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $acw62.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $acw62.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === "boolean") return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $6f20f3556678788b$var$_objectSpread($6f20f3556678788b$var$_objectSpread({}, (0, $4ac343fc5ddf54e6$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $6f20f3556678788b$export$2e2bcd8739ae039 = $6f20f3556678788b$var$useRadioState;



var $93271e8de2a9de9c$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $93271e8de2a9de9c$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($93271e8de2a9de9c$var$canUseDOM() ? navigator.userAgent : "");
};
var $93271e8de2a9de9c$export$2e2bcd8739ae039 = $93271e8de2a9de9c$var$isVoiceOverSupported;



var $hPtJY = parcelRequire("hPtJY");
var $83e385c72b6ff66a$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "interactionName"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $83e385c72b6ff66a$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8Fp8I.default) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $83e385c72b6ff66a$var$_excluded);
    typeof $hPtJY;
    var _useRadioState = (0, $6f20f3556678788b$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $3edcc84d52ebfb82$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $761f855927d3d42b$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02087188e6a3b46f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35f4ff7cefe86066$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $93271e8de2a9de9c$export$2e2bcd8739ae039)() ? "radio" : "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children));
};
var $83e385c72b6ff66a$export$2e2bcd8739ae039 = $83e385c72b6ff66a$var$DropdownItemRadio;




var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $hsD2P = parcelRequire("hsD2P");

var $rZzKT = parcelRequire("rZzKT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $6Bvm3 = parcelRequire("6Bvm3");

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $fef0fc9e16514591$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fef0fc9e16514591$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fef0fc9e16514591$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fef0fc9e16514591$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fef0fc9e16514591$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fef0fc9e16514591$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $fef0fc9e16514591$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $fef0fc9e16514591$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $fef0fc9e16514591$var$_objectSpread($fef0fc9e16514591$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $2797381328a7dc0d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $2797381328a7dc0d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $2797381328a7dc0d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2797381328a7dc0d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2797381328a7dc0d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $2797381328a7dc0d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2797381328a7dc0d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2797381328a7dc0d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $2797381328a7dc0d$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $2797381328a7dc0d$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $fef0fc9e16514591$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $a9c63b3be78f71f5$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};


function $724ba8e2ed957081$export$5bf35293e545f20c() {
    var analyticsContext = (0, $a9c63b3be78f71f5$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $2797381328a7dc0d$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $07aa77c15c206ad5$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $9fe6d82cda9d5e60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fe6d82cda9d5e60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fe6d82cda9d5e60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fe6d82cda9d5e60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fe6d82cda9d5e60$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $724ba8e2ed957081$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $07aa77c15c206ad5$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $07aa77c15c206ad5$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9fe6d82cda9d5e60$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $cBc12 = parcelRequire("cBc12");
/**
 * An empty function which does nothing.
 */ function $359c3f2288c42472$export$2e2bcd8739ae039() {}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
function $f16b91217a2ff4ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f16b91217a2ff4ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f16b91217a2ff4ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f16b91217a2ff4ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f16b91217a2ff4ea$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $f16b91217a2ff4ea$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $359c3f2288c42472$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $f16b91217a2ff4ea$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($f16b91217a2ff4ea$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $acw62.useRef)((0, $ltooA.fg)("layering-top-level-use-array") ? Math.random().toString(36) : "");
    if (!(0, $ltooA.fg)("layering-top-level-use-array")) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $ltooA.fg)("layering-top-level-use-array")) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $ltooA.fg)("layering-top-level-use-array")) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f16b91217a2ff4ea$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $f16b91217a2ff4ea$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var layerList = (0, $acw62.useRef)([]);
    var value = (0, $acw62.useMemo)(function() {
        return $f16b91217a2ff4ea$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $ltooA.fg)("layering-top-level-use-array") ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f16b91217a2ff4ea$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $f16b91217a2ff4ea$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($f16b91217a2ff4ea$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f16b91217a2ff4ea$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f16b91217a2ff4ea$var$LayeringProvider, null, content);
};



var $1NLnE = parcelRequire("1NLnE");

var $ltooA = parcelRequire("ltooA");

var $izA8S = parcelRequire("izA8S");
/* eslint-disable no-console */ var $a786cf765e4abc62$var$printed = {};
function $a786cf765e4abc62$export$2e2bcd8739ae039(message) {
    if ($a786cf765e4abc62$var$printed[message]) return;
    $a786cf765e4abc62$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $2b6eacac2bc83518$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $a786cf765e4abc62$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $2b6eacac2bc83518$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


// Reds
var $27185b4044ac25f3$export$4b84fd0e2c617bd = "#FFEBE6";
var $27185b4044ac25f3$export$b34b069eff244586 = "#FFBDAD";
var $27185b4044ac25f3$export$be802dd0d8b57f35 = "#FF8F73";
var $27185b4044ac25f3$export$60847d42f9da92a6 = "#FF7452";
var $27185b4044ac25f3$export$4a7404f376229999 = "#FF5630";
var $27185b4044ac25f3$export$2010d0fb4295b346 = "#DE350B";
var $27185b4044ac25f3$export$2837b5a1a71d5c02 = "#BF2600";
var $27185b4044ac25f3$export$8d9596b529bbb9cf = "#FFFAE6";
var $27185b4044ac25f3$export$41060a744ab0b7ae = "#FFF0B3";
var $27185b4044ac25f3$export$1cc05bbbf340e559 = "#FFE380";
var $27185b4044ac25f3$export$5aae31392d72caaa = "#FFC400";
var $27185b4044ac25f3$export$c6930421db9fa514 = "#FFAB00";
var $27185b4044ac25f3$export$59619663aa6500fb = "#FF991F";
var $27185b4044ac25f3$export$874739ea9e379ab6 = "#FF8B00";
var $27185b4044ac25f3$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $27185b4044ac25f3$export$69a3bf21b9686c2b = "#ABF5D1";
var $27185b4044ac25f3$export$afbce1382ec95f73 = "#79F2C0";
var $27185b4044ac25f3$export$747d86715d4175de = "#57D9A3";
var $27185b4044ac25f3$export$940e1f69e873f202 = "#36B37E";
var $27185b4044ac25f3$export$a49394138f7b8e85 = "#00875A";
var $27185b4044ac25f3$export$6fa04827ac68a4fb = "#006644";
var $27185b4044ac25f3$export$226de0355ed012f8 = "#DEEBFF";
var $27185b4044ac25f3$export$8c13c2ee36917869 = "#B3D4FF";
var $27185b4044ac25f3$export$ecfc1dff386a3e7a = "#4C9AFF";
var $27185b4044ac25f3$export$215b7063051591f1 = "#2684FF";
var $27185b4044ac25f3$export$e62e8919cca44969 = "#0065FF";
var $27185b4044ac25f3$export$b3de0ae08da2ce64 = "#0052CC";
var $27185b4044ac25f3$export$a6ee3d71bc067634 = "#0747A6";
var $27185b4044ac25f3$export$67f15409e87642a1 = "#669DF1";
var $27185b4044ac25f3$export$f0539dbc42dbb067 = "#8FB8F6";
var $27185b4044ac25f3$export$363e4475840015bb = "#EAE6FF";
var $27185b4044ac25f3$export$4b0a4417ed59760f = "#C0B6F2";
var $27185b4044ac25f3$export$6011520a64d9a187 = "#998DD9";
var $27185b4044ac25f3$export$a7175d4e9206bc80 = "#8777D9";
var $27185b4044ac25f3$export$b48405b95304b5a1 = "#6554C0";
var $27185b4044ac25f3$export$c71e4279dd54a18d = "#5243AA";
var $27185b4044ac25f3$export$147899de772240ec = "#403294";
var $27185b4044ac25f3$export$2cf711fe14c66f06 = "#E6FCFF";
var $27185b4044ac25f3$export$7a8f4d33f6f9772c = "#B3F5FF";
var $27185b4044ac25f3$export$776c9c497ef08533 = "#79E2F2";
var $27185b4044ac25f3$export$69cb3ca10c1e330e = "#00C7E6";
var $27185b4044ac25f3$export$9dc1ef0f3f48059b = "#00B8D9";
var $27185b4044ac25f3$export$7c835c78b6fcdef8 = "#00A3BF";
var $27185b4044ac25f3$export$6036577f95c3877e = "#008DA6";
var $27185b4044ac25f3$export$29a4f05edc054374 = "#FFFFFF";
var $27185b4044ac25f3$export$e655ef011c4aa1a2 = "#FAFBFC";
var $27185b4044ac25f3$export$9fdfb749e33cdf97 = "#F4F5F7";
var $27185b4044ac25f3$export$3e51e8f1440314ba = "#EBECF0";
var $27185b4044ac25f3$export$1ce2d1575d444ceb = "#DFE1E6";
var $27185b4044ac25f3$export$8754fc7e6d8b3000 = "#C1C7D0";
var $27185b4044ac25f3$export$c2e91cbeada39b8b = "#B3BAC5";
var $27185b4044ac25f3$export$5f71e19f3a7ad9de = "#A5ADBA";
var $27185b4044ac25f3$export$eaa8c8a70ac22806 = "#97A0AF";
var $27185b4044ac25f3$export$7c87d337fb91a97d = "#8993A4";
var $27185b4044ac25f3$export$d6447c357493214f = "#7A869A";
var $27185b4044ac25f3$export$f563ee71e9ee74cd = "#6B778C";
var $27185b4044ac25f3$export$e2ef2124cf4024b1 = "#5E6C84";
var $27185b4044ac25f3$export$eece5f492e429f08 = "#505F79";
var $27185b4044ac25f3$export$c39c0fe0f26207ae = "#42526E";
var $27185b4044ac25f3$export$7090862dc3038a9f = "#344563";
var $27185b4044ac25f3$export$ad0bacf983b7ddaa = "#253858";
var $27185b4044ac25f3$export$7d61b15e0da132af = "#172B4D";
var $27185b4044ac25f3$export$fbda843f0a27fe96 = "#091E42";
var $27185b4044ac25f3$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $27185b4044ac25f3$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $27185b4044ac25f3$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $27185b4044ac25f3$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $27185b4044ac25f3$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $27185b4044ac25f3$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $27185b4044ac25f3$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $27185b4044ac25f3$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $27185b4044ac25f3$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $27185b4044ac25f3$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $27185b4044ac25f3$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $27185b4044ac25f3$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $27185b4044ac25f3$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $27185b4044ac25f3$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $27185b4044ac25f3$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $27185b4044ac25f3$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $27185b4044ac25f3$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $27185b4044ac25f3$export$2f6319cf7d736c2a = "#E6EDFA";
var $27185b4044ac25f3$export$95126bc8884d6634 = "#DCE5F5";
var $27185b4044ac25f3$export$8338d8c35d44ff1 = "#CED9EB";
var $27185b4044ac25f3$export$5368d76ae4fbbda7 = "#B8C7E0";
var $27185b4044ac25f3$export$9f0a771d16ec8d36 = "#ABBBD6";
var $27185b4044ac25f3$export$abcf8c38338b4aa5 = "#9FB0CC";
var $27185b4044ac25f3$export$97e81faa16a182c7 = "#8C9CB8";
var $27185b4044ac25f3$export$bfe21c59123ecf33 = "#7988A3";
var $27185b4044ac25f3$export$ee82aa2ea6a1558 = "#67758F";
var $27185b4044ac25f3$export$682927c6ed76be02 = "#56637A";
var $27185b4044ac25f3$export$91fd9994c5be9757 = "#455166";
var $27185b4044ac25f3$export$d281fbfe3cff2df6 = "#3B475C";
var $27185b4044ac25f3$export$3902c91d8b98a753 = "#313D52";
var $27185b4044ac25f3$export$8e8133c1ba5845b5 = "#283447";
var $27185b4044ac25f3$export$33ff357f6620b39 = "#202B3D";
var $27185b4044ac25f3$export$633847cf062b69e0 = "#1B2638";
var $27185b4044ac25f3$export$9776a6e503bdbf76 = "#121A29";
var $27185b4044ac25f3$export$6c813d5160dff5db = "#0E1624";
var $27185b4044ac25f3$export$3d4f271a500072a = "#0D1424";
var $27185b4044ac25f3$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $27185b4044ac25f3$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $27185b4044ac25f3$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $27185b4044ac25f3$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $27185b4044ac25f3$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $27185b4044ac25f3$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $27185b4044ac25f3$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $27185b4044ac25f3$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $27185b4044ac25f3$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $27185b4044ac25f3$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $27185b4044ac25f3$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $27185b4044ac25f3$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $27185b4044ac25f3$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $27185b4044ac25f3$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $27185b4044ac25f3$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $27185b4044ac25f3$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $27185b4044ac25f3$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $27185b4044ac25f3$export$d2adc5dedf09fced = "#292A2E";
var $27185b4044ac25f3$export$f51762073d2bb381 = "#94C748";
var $27185b4044ac25f3$export$95e26d54def96891 = "#B3DF72";


var $c1cf5f95793e2497$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $c1cf5f95793e2497$export$c93026a968943f95 = "light";
var $c1cf5f95793e2497$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $c1cf5f95793e2497$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $c1cf5f95793e2497$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $c1cf5f95793e2497$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $27185b4044ac25f3$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c1cf5f95793e2497$export$6d8204c2cb2e06b8() / 4;
    (0, $2b6eacac2bc83518$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c1cf5f95793e2497$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c1cf5f95793e2497$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c1cf5f95793e2497$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2b6eacac2bc83518$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $c1cf5f95793e2497$export$ba1d834b86d72a09 = $c1cf5f95793e2497$export$a1b3edb637fb4f35;
var $c1cf5f95793e2497$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $27185b4044ac25f3$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $27185b4044ac25f3$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $27185b4044ac25f3$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $6336b02f0af33ac6$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $acw62 = parcelRequire("acw62");
function $d13e593e3529dc19$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $98BOi = parcelRequire("98BOi");

var $ltooA = parcelRequire("ltooA");
var $1e2d6e339a91cfd1$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $1e2d6e339a91cfd1$var$react18UseId = ($1e2d6e339a91cfd1$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $1e2d6e339a91cfd1$var$_React$useId !== void 0 ? $1e2d6e339a91cfd1$var$_React$useId : undefined;
function $1e2d6e339a91cfd1$export$f680877a34711e37() {
    if ($1e2d6e339a91cfd1$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) return $1e2d6e339a91cfd1$var$react18UseId();
    return "uid".concat((0, $98BOi.useUID)());
}
var $1e2d6e339a91cfd1$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($1e2d6e339a91cfd1$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $1e2d6e339a91cfd1$export$6ee17796e3d70de2() {
    if ($1e2d6e339a91cfd1$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        var uid = $1e2d6e339a91cfd1$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $98BOi.useUIDSeed)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");
var $34d0a838a679453b$var$BORDER_WIDTH = 2;
var $34d0a838a679453b$var$baseFocusOutsideStyles = (0, $dnfL5.css)({
    outline: "".concat($34d0a838a679453b$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $34d0a838a679453b$var$BORDER_WIDTH
});
var $34d0a838a679453b$var$baseInsetStyles = (0, $dnfL5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$34d0a838a679453b$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $34d0a838a679453b$var$focusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $34d0a838a679453b$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $34d0a838a679453b$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $34d0a838a679453b$var$insetFocusRingStyles = (0, $dnfL5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $34d0a838a679453b$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $34d0a838a679453b$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $34d0a838a679453b$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $34d0a838a679453b$var$baseInsetStyles : $34d0a838a679453b$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $34d0a838a679453b$var$insetFocusRingStyles : $34d0a838a679453b$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $dnfL5.jsx)((0, $dnfL5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$34d0a838a679453b$var$FocusRing.displayName = "FocusRing";
var $34d0a838a679453b$export$2e2bcd8739ae039 = $34d0a838a679453b$var$FocusRing;



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $ltooA = parcelRequire("ltooA");

function $332452f03c0f94e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $332452f03c0f94e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $332452f03c0f94e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $332452f03c0f94e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $332452f03c0f94e3$var$ESCAPE = "Escape";
function $332452f03c0f94e3$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _useLayering = $332452f03c0f94e3$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $332452f03c0f94e3$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $332452f03c0f94e3$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $acw62.useContext)((0, $f16b91217a2ff4ea$export$650d12d3c2ddb8fc));
    var _useContext = (0, $acw62.useContext)((0, $f16b91217a2ff4ea$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        if ((0, $ltooA.fg)("layering-top-level-use-array")) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $332452f03c0f94e3$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $ltooA.fg)("layering-top-level-use-array") ? {
        layerList: layerList
    } : {});
}



var $1NLnE = parcelRequire("1NLnE");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $91be92a61fc958b7$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $91be92a61fc958b7$export$c881183ca713c214 = $91be92a61fc958b7$export$987d49ffe1b0900f;



var $fe82708d7c957358$export$4ef52930e33717cd = "data-theme";
var $fe82708d7c957358$export$a00eac3f8684bcd0 = "data-color-mode";
var $fe82708d7c957358$export$2112803007239c61 = "data-contrast-mode";
var $fe82708d7c957358$export$352e418ed5b6193a = "data-custom-theme";
var $fe82708d7c957358$export$6f0c6fb8c80fcc92 = "ds";
var $fe82708d7c957358$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $fe82708d7c957358$export$dddac1532e822863 = "--".concat($fe82708d7c957358$export$6f0c6fb8c80fcc92, "-token-not-found");
var $fe82708d7c957358$export$9d7b58831ae93caa = "--".concat($fe82708d7c957358$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $acw62 = parcelRequire("acw62");
var $c6370763a5fec4d3$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $c6370763a5fec4d3$export$dece24112a937f92 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
function $368969cc89834b44$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $acw62.useRef)(null);
    var onMotionFinish = (0, $acw62.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("lLUpG");
var $9eYWs = parcelRequire("9eYWs");

var $fUHKi = parcelRequire("fUHKi");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $f5135afb533d0145$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? "" : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $f5135afb533d0145$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $f5135afb533d0145$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith("data:")) return false;
    return !$f5135afb533d0145$var$hasSameOrigin(window.location.href, iframe.src);
}
var $f5135afb533d0145$var$registry = new Map();
function $f5135afb533d0145$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll("iframe")).filter($f5135afb533d0145$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $f5135afb533d0145$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $f5135afb533d0145$var$setStyle(iframe, {
                    property: "pointer-events",
                    rule: "none",
                    priority: "important"
                }),
                count: 1
            };
            $f5135afb533d0145$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $f5135afb533d0145$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $iedos.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $f5135afb533d0145$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $f5135afb533d0145$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $e3cac3ca6dd83897$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: "pointerdown",
            listener: stop
        },
        {
            // The user did not start a drag
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: "dragstart",
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $9eYWs.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor);
}
function $e3cac3ca6dd83897$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $e3cac3ca6dd83897$var$api = (0, $f5135afb533d0145$export$a74bff2507e6126b)({
    watchForInteractionStart: $e3cac3ca6dd83897$var$watchForInteractionStart,
    watchForInteractionEnd: $e3cac3ca6dd83897$var$watchForInteractionEnd
});
function $e3cac3ca6dd83897$export$ec28e97c7d8b1b35() {
    return $e3cac3ca6dd83897$var$api.registerUsage();
}


parcelRequire("6oVK7");
var $2IBLj = parcelRequire("2IBLj");

function $7cae041b6711372c$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $2IBLj.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $7cae041b6711372c$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $2IBLj.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $7cae041b6711372c$var$api = (0, $f5135afb533d0145$export$a74bff2507e6126b)({
    watchForInteractionStart: $7cae041b6711372c$var$watchForInteractionStart,
    watchForInteractionEnd: $7cae041b6711372c$var$watchForInteractionEnd
});
function $7cae041b6711372c$export$27d79116d3a4e7d5() {
    return $7cae041b6711372c$var$api.registerUsage();
}



var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("4Gj2B");
var $gzujt = parcelRequire("gzujt");

function $ca56b37ef28c6876$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // User is starting another interaction
            type: "pointerdown",
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            type: "dragstart",
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $gzujt.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $ca56b37ef28c6876$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $ca56b37ef28c6876$var$api = (0, $f5135afb533d0145$export$a74bff2507e6126b)({
    watchForInteractionStart: $ca56b37ef28c6876$var$watchForInteractionStart,
    watchForInteractionEnd: $ca56b37ef28c6876$var$watchForInteractionEnd
});
function $ca56b37ef28c6876$export$9c0606fcefb5d1e2() {
    return $ca56b37ef28c6876$var$api.registerUsage();
}


var $fed560410be3880b$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $fed560410be3880b$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = $fed560410be3880b$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($fed560410be3880b$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $fed560410be3880b$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};



var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $7hYes = parcelRequire("7hYes");

var $fZQEc = parcelRequire("fZQEc");


var $2b1f2d36855f04eb$var$gutter = 60;
var $2b1f2d36855f04eb$var$maxWidthDimensions = "calc(100vw - ".concat($2b1f2d36855f04eb$var$gutter * 2, "px)");
var $2b1f2d36855f04eb$var$maxHeightDimensions = "calc(100vh - ".concat($2b1f2d36855f04eb$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $2b1f2d36855f04eb$var$positionerStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $c1cf5f95793e2497$export$7be255094ccdc533).modal(),
    flexDirection: "column",
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $2b1f2d36855f04eb$var$viewportScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    height: "auto",
    position: "relative"
}, (0, $91be92a61fc958b7$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat($2b1f2d36855f04eb$var$gutter, "px auto"),
    pointerEvents: "none"
}));
var $2b1f2d36855f04eb$var$bodyScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $91be92a61fc958b7$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $2b1f2d36855f04eb$var$maxWidthDimensions,
    maxHeight: $2b1f2d36855f04eb$var$maxHeightDimensions,
    position: "absolute",
    insetBlockStart: "".concat($2b1f2d36855f04eb$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    pointerEvents: "none"
}));
var $2b1f2d36855f04eb$var$stackTransitionStyles = (0, $dnfL5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $fZQEc.durations).medium, "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $7hYes.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $2b1f2d36855f04eb$var$stackTransformStyles = (0, $dnfL5.css)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $2b1f2d36855f04eb$var$stackIdleStyles = (0, $dnfL5.css)({
    transform: "none"
});
var $2b1f2d36855f04eb$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $dnfL5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--modal-dialog-translate-y": "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $2b1f2d36855f04eb$var$positionerStyles,
            $2b1f2d36855f04eb$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $2b1f2d36855f04eb$var$stackTransformStyles : $2b1f2d36855f04eb$var$stackIdleStyles,
            shouldScrollInViewport ? $2b1f2d36855f04eb$var$viewportScrollStyles : $2b1f2d36855f04eb$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2b1f2d36855f04eb$export$2e2bcd8739ae039 = $2b1f2d36855f04eb$var$Positioner;


var $11bbc345fd2927bf$var$dialogStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $27185b4044ac25f3$export$29a4f05edc054374), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $27185b4044ac25f3$export$fbda843f0a27fe96), ")")
}, (0, $fe82708d7c957358$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $27185b4044ac25f3$export$29a4f05edc054374), ")")), "pointerEvents", "auto"), (0, $91be92a61fc958b7$export$987d49ffe1b0900f).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $27185b4044ac25f3$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $27185b4044ac25f3$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $27185b4044ac25f3$export$d2d3bedfb276cac0)), ")"),
    marginInlineEnd: "inherit",
    marginInlineStart: "inherit"
}), "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}));
var $11bbc345fd2927bf$var$viewportScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $91be92a61fc958b7$export$987d49ffe1b0900f).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $11bbc345fd2927bf$var$bodyScrollStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $91be92a61fc958b7$export$987d49ffe1b0900f).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $11bbc345fd2927bf$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $1e2d6e339a91cfd1$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $acw62.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $iedos.combine)((0, $e3cac3ca6dd83897$export$ec28e97c7d8b1b35)(), (0, $ca56b37ef28c6876$export$9c0606fcefb5d1e2)(), (0, $7cae041b6711372c$export$27d79116d3a4e7d5)());
    }, []);
    (0, $d13e593e3529dc19$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $368969cc89834b44$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $acw62.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $332452f03c0f94e3$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $332452f03c0f94e3$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return (0, $dnfL5.jsx)((0, $2b1f2d36855f04eb$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $dnfL5.jsx)((0, $c6370763a5fec4d3$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $dnfL5.jsx)((0, $c6370763a5fec4d3$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $dnfL5.jsx)((0, $1NLnE.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $dnfL5.jsx)((0, $34d0a838a679453b$export$2e2bcd8739ae039), null, (0, $dnfL5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $6336b02f0af33ac6$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-width": (0, $fed560410be3880b$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-height": (0, $fed560410be3880b$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $11bbc345fd2927bf$var$dialogStyles,
                shouldScrollInViewport ? $11bbc345fd2927bf$var$viewportScrollStyles : $11bbc345fd2927bf$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11bbc345fd2927bf$export$2e2bcd8739ae039 = $11bbc345fd2927bf$var$ModalDialog;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $8fb1fbc183fa6641$var$uniqueReferencedValue = {};
function $8fb1fbc183fa6641$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $acw62.useRef)($8fb1fbc183fa6641$var$uniqueReferencedValue);
    if (ref.current === $8fb1fbc183fa6641$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $3e164669cf9e7714$export$2e2bcd8739ae039(callback) {
    var ref = (0, $8fb1fbc183fa6641$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $c4ecb80520e47fc3$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $2ccb9a82b8371a48$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $acw62.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



var $ocesl = parcelRequire("ocesl");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $24447792384bcd55$var$modalStackRegister = [];
function $24447792384bcd55$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $ocesl.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $2ccb9a82b8371a48$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $c4ecb80520e47fc3$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $3e164669cf9e7714$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $24447792384bcd55$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $acw62.useEffect)(function() {
        var currentStackIndex = $24447792384bcd55$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $24447792384bcd55$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $24447792384bcd55$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $24447792384bcd55$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $24447792384bcd55$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $24447792384bcd55$var$modalStackRegister.splice(currentStackIndex, 1);
                $24447792384bcd55$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $acw62.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $ced846d40e71e7a4$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $ced846d40e71e7a4$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $acw62.useLayoutEffect)(function() {
        setScrollTopOffset($ced846d40e71e7a4$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $acw62.useCallback)(function() {
        if ($ced846d40e71e7a4$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $7ea5684aaa353f60$var$fillScreenStyles = (0, $dnfL5.css)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $7ea5684aaa353f60$var$allowlistElements = function allowlistElements(element, callback) {
    var isAuiDialogAllowlisted = (0, $ltooA.fg)("platform_dst_allowlist-aui-dialog-for-ak-modal");
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (isAuiDialogAllowlisted && !!document.querySelector(".aui-blanket:not([hidden])")) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === "function") return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $7ea5684aaa353f60$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $359c3f2288c42472$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $359c3f2288c42472$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $24447792384bcd55$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $9fe6d82cda9d5e60$export$a4687b0234b40e28)({
        fn: onClose,
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.1.1"
    });
    var onBlanketClicked = (0, $acw62.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $acw62.useCallback)(function(element) {
        return $7ea5684aaa353f60$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $ced846d40e71e7a4$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $dnfL5.jsx)((0, $cBc12.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $dnfL5.jsx)((0, $11bbc345fd2927bf$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $dnfL5.jsx)((0, $f16b91217a2ff4ea$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $dnfL5.jsx)((0, $izA8S.default), {
        zIndex: (0, $c1cf5f95793e2497$export$7be255094ccdc533).modal()
    }, (0, $dnfL5.jsx)((0, $1NLnE.default), null, function(fadeInProps) {
        return (0, $dnfL5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, fadeInProps, {
            css: $7ea5684aaa353f60$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $dnfL5.jsx)((0, $hsD2P.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $dnfL5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($rZzKT))), null), shouldScrollInViewport ? (0, $dnfL5.jsx)((0, $rZzKT.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $7ea5684aaa353f60$export$2e2bcd8739ae039 = $7ea5684aaa353f60$var$ModalWrapper;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $rZzKT = parcelRequire("rZzKT");

var $acw62 = parcelRequire("acw62");

var $4f34542a87d860ff$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $acw62.useContext)((0, $c6370763a5fec4d3$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $8fY35 = parcelRequire("8fY35");

var $ciU3d = parcelRequire("ciU3d");






var $55850cb569fb9987$var$keylineColor = "var(--ds-border, ".concat((0, $27185b4044ac25f3$export$3e51e8f1440314ba), ")");
var $55850cb569fb9987$var$baseStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $91be92a61fc958b7$export$987d49ffe1b0900f).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $55850cb569fb9987$var$keylineHeight = 2;
var $55850cb569fb9987$var$topKeylineStyles = (0, $dnfL5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $55850cb569fb9987$var$keylineColor)
});
var $55850cb569fb9987$var$bottomKeylineStyles = (0, $dnfL5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $55850cb569fb9987$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $55850cb569fb9987$var$ScrollContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $acw62.useEffect)(function() {
        var schedule = (0, $ciU3d.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $3e164669cf9e7714$export$2e2bcd8739ae039)((0, $ciU3d.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $55850cb569fb9987$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $55850cb569fb9987$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $acw62.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $8fY35.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $8fY35.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $359c3f2288c42472$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $dnfL5.jsx)((0, $34d0a838a679453b$export$2e2bcd8739ae039), {
        isInset: true
    }, (0, $dnfL5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $6336b02f0af33ac6$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $55850cb569fb9987$var$baseStyles,
            showTopKeyline && $55850cb569fb9987$var$topKeylineStyles,
            showBottomKeyline && $55850cb569fb9987$var$bottomKeylineStyles
        ]
    }, children));
});
$55850cb569fb9987$var$ScrollContainer.displayName = "ScrollContainer";
var $55850cb569fb9987$export$2e2bcd8739ae039 = $55850cb569fb9987$var$ScrollContainer;



var $acw62 = parcelRequire("acw62");

function $778442a00742201a$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $acw62.useContext)((0, $c6370763a5fec4d3$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $580232987e0040bf$var$bodyStyles = (0, $dnfL5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $580232987e0040bf$var$bodyScrollStyles = (0, $dnfL5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $580232987e0040bf$var$viewportScrollStyles = (0, $dnfL5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $580232987e0040bf$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $4f34542a87d860ff$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $778442a00742201a$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $dnfL5.jsx)("div", {
        css: [
            $580232987e0040bf$var$bodyStyles,
            $580232987e0040bf$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $dnfL5.jsx)((0, $rZzKT.TouchScrollable), null, (0, $dnfL5.jsx)((0, $55850cb569fb9987$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $dnfL5.jsx)("div", {
        css: [
            $580232987e0040bf$var$bodyStyles,
            $580232987e0040bf$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $580232987e0040bf$export$2e2bcd8739ae039 = $580232987e0040bf$var$ModalBody;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dnfL5 = parcelRequire("dnfL5");

var $910e75271bd879af$var$footerStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $910e75271bd879af$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $4f34542a87d860ff$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $dnfL5.jsx)("div", {
        css: $910e75271bd879af$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $910e75271bd879af$export$2e2bcd8739ae039 = $910e75271bd879af$var$ModalFooter;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $c6373468b09630cb$var$headerStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $c6373468b09630cb$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $4f34542a87d860ff$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $dnfL5.jsx)("div", {
        css: $c6373468b09630cb$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $c6373468b09630cb$export$2e2bcd8739ae039 = $c6373468b09630cb$var$ModalHeader;


var $acw62 = parcelRequire("acw62");

var $ocesl = parcelRequire("ocesl");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $9d66509194a07e3f$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ocesl.default), {
        appear: true
    }, props.children);
};
var $9d66509194a07e3f$export$2e2bcd8739ae039 = $9d66509194a07e3f$var$ModalTransition;



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");




var $ltooA = parcelRequire("ltooA");

var $04f890be6b989bed$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === "hidden") return false;
        // If input ID matches the error, focus
        if (input.id && (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(errors, input.name);
    });
};


function $cda506121b783a25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cda506121b783a25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cda506121b783a25$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cda506121b783a25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cda506121b783a25$export$c24727297075ec6a = /*#__PURE__*/ (0, $acw62.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $cda506121b783a25$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $cda506121b783a25$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit, testId = props.testId;
    var formRef = (0, $acw62.useRef)(null);
    var onSubmitRef = (0, $acw62.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $acw62.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $7f17f1906b9f3211$export$f681a8129d2e9d28)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === "function" ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($616ab74e95c8680a$exports)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($616ab74e95c8680a$exports)))(values, name, _value);
                    }
                }
            }
        });
        (0, $485f8543f71f3f87$export$2e2bcd8739ae039)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll("input")) : [];
        }, (0, $ltooA.fg)("platform-form-field-error-focus") ? (0, $04f890be6b989bed$export$fc06342dc8588d3b) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $acw62.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $acw62.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $acw62.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $acw62.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $acw62.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = $cda506121b783a25$var$_objectSpread({
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    }, testId && {
        "data-testid": testId
    });
    var childrenContent = function() {
        if (typeof children === "function") {
            var result = children.length > 0 ? children($cda506121b783a25$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $ltooA.fg)("platform-form-reset-field-state") && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return (0, $ltooA.fg)("platform_design-system-team_form-upgrade") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cda506121b783a25$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cda506121b783a25$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $9e9e3f3e39de7795$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9e9e3f3e39de7795$exports, "__esModule", {
    value: true
});
$9e9e3f3e39de7795$exports.default = void 0;

var $9e9e3f3e39de7795$var$_react = $9e9e3f3e39de7795$var$_interopRequireDefault((parcelRequire("acw62")));

var $9e9e3f3e39de7795$var$_statusError = $9e9e3f3e39de7795$var$_interopRequireDefault((parcelRequire("hkroK")));

var $9e9e3f3e39de7795$var$_error = $9e9e3f3e39de7795$var$_interopRequireDefault((parcelRequire("fj2nS")));
function $9e9e3f3e39de7795$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e9e3f3e39de7795$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9e9e3f3e39de7795$var$_react.default.createElement($9e9e3f3e39de7795$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $9e9e3f3e39de7795$var$_error.default
    }, props));
$9e9e3f3e39de7795$var$StatusErrorIcon.displayName = "StatusErrorIconMigration";
var $9e9e3f3e39de7795$var$_default = $9e9e3f3e39de7795$exports.default = $9e9e3f3e39de7795$var$StatusErrorIcon;


var $e0c016134b7ecbd2$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e0c016134b7ecbd2$exports, "__esModule", {
    value: true
});
$e0c016134b7ecbd2$exports.default = void 0;

var $e0c016134b7ecbd2$var$_react = $e0c016134b7ecbd2$var$_interopRequireDefault((parcelRequire("acw62")));

var $e0c016134b7ecbd2$var$_statusSuccess = $e0c016134b7ecbd2$var$_interopRequireDefault((parcelRequire("8GMJF")));

var $e0c016134b7ecbd2$var$_success = $e0c016134b7ecbd2$var$_interopRequireDefault((parcelRequire("cKFez")));
function $e0c016134b7ecbd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0c016134b7ecbd2$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $e0c016134b7ecbd2$var$_react.default.createElement($e0c016134b7ecbd2$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $e0c016134b7ecbd2$var$_success.default
    }, props));
$e0c016134b7ecbd2$var$StatusSuccessIcon.displayName = "StatusSuccessIconMigration";
var $e0c016134b7ecbd2$var$_default = $e0c016134b7ecbd2$exports.default = $e0c016134b7ecbd2$var$StatusSuccessIcon;



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $05d9f5b515934cdf$export$3c4232819458a302 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $aa4d7172759f512c$var$messageStyles = null;
var $aa4d7172759f512c$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $aa4d7172759f512c$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $aa4d7172759f512c$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $9dvtP.default)([
            $aa4d7172759f512c$var$iconWrapperStyles.root
        ])
    }, children);
};
var $aa4d7172759f512c$var$messageIcons = {
    error: /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9e9e3f3e39de7795$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0c016134b7ecbd2$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $aa4d7172759f512c$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $aa4d7172759f512c$var$messageIcons[appearance];
    var _useContext = (0, $acw62.useContext)($aa4d7172759f512c$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $ltooA.fg)("platform_dst_form_screenreader_message_fix") && !isWrapper;
    (0, $acw62.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, icon && /*#__PURE__*/ $acw62.createElement($aa4d7172759f512c$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? "polite" : undefined,
        className: (0, $9dvtP.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $aa4d7172759f512c$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $aa4d7172759f512c$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $05d9f5b515934cdf$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($aa4d7172759f512c$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $aa4d7172759f512c$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $05d9f5b515934cdf$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($aa4d7172759f512c$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $aa4d7172759f512c$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $05d9f5b515934cdf$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($aa4d7172759f512c$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $aa4d7172759f512c$var$MessageWrapperContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isWrapper: false
});
var $aa4d7172759f512c$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $acw62.createElement($aa4d7172759f512c$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $9dvtP = parcelRequire("9dvtP");

var $acw62 = parcelRequire("acw62");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $98BOi = parcelRequire("98BOi");

var $ltooA = parcelRequire("ltooA");
var $3cc83182377c8e3a$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $3cc83182377c8e3a$var$react18UseId = ($3cc83182377c8e3a$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $3cc83182377c8e3a$var$_React$useId !== void 0 ? $3cc83182377c8e3a$var$_React$useId : undefined;
function $3cc83182377c8e3a$export$f680877a34711e37() {
    if ($3cc83182377c8e3a$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) return $3cc83182377c8e3a$var$react18UseId();
    return "uid".concat((0, $98BOi.useUID)());
}
var $3cc83182377c8e3a$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($3cc83182377c8e3a$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $3cc83182377c8e3a$export$6ee17796e3d70de2() {
    if ($3cc83182377c8e3a$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        var uid = $3cc83182377c8e3a$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $98BOi.useUIDSeed)();
}



var $ltooA = parcelRequire("ltooA");


/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $2e72a8d621f47959$var$fieldsetLabelStyles = null;
var $2e72a8d621f47959$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $9dvtP.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $2e72a8d621f47959$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $acw62.createElement("legend", {
        className: (0, $9dvtP.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};



/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $d947b0e94e999790$var$requiredIndicatorStyles = null;
function $d947b0e94e999790$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $9dvtP.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}


function $18a4c3e80e579556$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $18a4c3e80e579556$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $18a4c3e80e579556$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $18a4c3e80e579556$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $18a4c3e80e579556$var$fieldWrapperStyles = null;
function $18a4c3e80e579556$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $18a4c3e80e579556$var$isFunction(x) {
    return typeof x === "function";
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $18a4c3e80e579556$var$usePreviousRef(current) {
    var ref = (0, $acw62.useRef)(current);
    // will be updated on the next render
    (0, $acw62.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $18a4c3e80e579556$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === "function" && typeof currentValue === "function") return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(previousValue) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(currentValue) === "object") return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $18a4c3e80e579556$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $acw62.useContext)((0, $cda506121b783a25$export$c24727297075ec6a)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $acw62.useContext)((0, $cda506121b783a25$export$c17cf6b332a82dbc)) || props.isDisabled || false;
    var defaultValue = $18a4c3e80e579556$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $18a4c3e80e579556$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$18a4c3e80e579556$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $acw62.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $18a4c3e80e579556$var$usePreviousRef(state);
    (0, $acw62.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $18a4c3e80e579556$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($18a4c3e80e579556$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === "checkbox") {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $3cc83182377c8e3a$export$f680877a34711e37)();
    var fieldId = (0, $acw62.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = "";
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $18a4c3e80e579556$var$_objectSpread($18a4c3e80e579556$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        "aria-invalid": state.error ? "true" : "false",
        "aria-describedby": getDescribedBy(),
        "aria-labelledby": "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $9dvtP.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d947b0e94e999790$export$2e2bcd8739ae039), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $05d9f5b515934cdf$export$3c4232819458a302).Provider, {
        value: fieldId
    }, component && (0, $ltooA.fg)("platform_design-system-team_field-upgrade") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, component && component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aa4d7172759f512c$export$ec445f12f63100a5), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aa4d7172759f512c$export$8fbe3c7d0ed2c683), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aa4d7172759f512c$export$915e9e7bd4f0f96d), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aa4d7172759f512c$export$5505afb209a532c8), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $fb1f1eb3befa3ccc$var$formFooterWrapperStyles = null;
var $fb1f1eb3befa3ccc$var$justifyContentStyles = null;
function $fb1f1eb3befa3ccc$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? "end" : _ref$align, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("footer", {
        className: (0, $9dvtP.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === "start" && "_1bah1y6m"
        ])
    }, children);
}


var $d54c3c01d7096ae7$exports = {};
"use strict";
Object.defineProperty($d54c3c01d7096ae7$exports, "__esModule", {
    value: true
});
$d54c3c01d7096ae7$exports.default = void 0;

var $d54c3c01d7096ae7$var$_react = $d54c3c01d7096ae7$var$_interopRequireDefault((parcelRequire("acw62")));


var $d54c3c01d7096ae7$var$_showMoreHorizontal = $d54c3c01d7096ae7$var$_interopRequireDefault((parcelRequire("lNKMg")));
function $d54c3c01d7096ae7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d54c3c01d7096ae7$var$MoreIcon = (props)=>/*#__PURE__*/ $d54c3c01d7096ae7$var$_react.default.createElement($6a95fc3941c3c881$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $d54c3c01d7096ae7$var$_showMoreHorizontal.default
    }));
$d54c3c01d7096ae7$var$MoreIcon.displayName = "MoreIcon";
var $d54c3c01d7096ae7$var$_default = $d54c3c01d7096ae7$exports.default = $d54c3c01d7096ae7$var$MoreIcon;






var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $1a77571422b9634a$var$extendStatics = function(d, b) {
    $1a77571422b9634a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1a77571422b9634a$var$extendStatics(d, b);
};
function $1a77571422b9634a$var$__extends(d, b) {
    $1a77571422b9634a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1a77571422b9634a$var$__assign = function() {
    $1a77571422b9634a$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a77571422b9634a$var$__assign.apply(this, arguments);
};
function $1a77571422b9634a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $1a77571422b9634a$var$VIEWBOX_WIDTH = 100;
var $1a77571422b9634a$var$VIEWBOX_HEIGHT = 100;
var $1a77571422b9634a$var$VIEWBOX_HEIGHT_HALF = 50;
var $1a77571422b9634a$var$VIEWBOX_CENTER_X = 50;
var $1a77571422b9634a$var$VIEWBOX_CENTER_Y = 50;
function $1a77571422b9634a$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $acw62.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $1a77571422b9634a$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $1a77571422b9634a$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $1a77571422b9634a$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $1a77571422b9634a$var$VIEWBOX_CENTER_X + "," + $1a77571422b9634a$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $1a77571422b9634a$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $1a77571422b9634a$export$14082143029b37c8 = function(_super) {
    $1a77571422b9634a$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $1a77571422b9634a$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $acw62.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $1a77571422b9634a$var$VIEWBOX_WIDTH + " " + $1a77571422b9634a$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $acw62.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $1a77571422b9634a$var$VIEWBOX_CENTER_X,
            cy: $1a77571422b9634a$var$VIEWBOX_CENTER_Y,
            r: $1a77571422b9634a$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $acw62.createElement)($1a77571422b9634a$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $acw62.createElement)($1a77571422b9634a$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $acw62.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $1a77571422b9634a$var$VIEWBOX_CENTER_X,
            y: $1a77571422b9634a$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: "CircularProgressbar",
            trail: "CircularProgressbar-trail",
            path: "CircularProgressbar-path",
            text: "CircularProgressbar-text",
            background: "CircularProgressbar-background"
        },
        counterClockwise: false,
        className: "",
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ""
    };
    return CircularProgressbar;
}((0, $acw62.Component));
function $1a77571422b9634a$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $1a77571422b9634a$var$__rest(props, [
        "children"
    ]);
    return (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $acw62.createElement)("div", {
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        }
    }, (0, $acw62.createElement)($1a77571422b9634a$export$14082143029b37c8, $1a77571422b9634a$var$__assign({}, circularProgressbarProps)), props.children ? (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "-100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    }, props.children) : null));
}
function $1a77571422b9634a$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : "center center";
    return {
        root: {},
        path: $1a77571422b9634a$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $1a77571422b9634a$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $1a77571422b9634a$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $1a77571422b9634a$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $1a77571422b9634a$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}



var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $jmqGD = parcelRequire("jmqGD");

var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");

var $ltooA = parcelRequire("ltooA");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $d95e72aa45a79136$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $d95e72aa45a79136$export$c881183ca713c214 = $d95e72aa45a79136$export$987d49ffe1b0900f;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0ed3e85fb4a45304$export$4b84fd0e2c617bd = "#FFEBE6";
var $0ed3e85fb4a45304$export$b34b069eff244586 = "#FFBDAD";
var $0ed3e85fb4a45304$export$be802dd0d8b57f35 = "#FF8F73";
var $0ed3e85fb4a45304$export$60847d42f9da92a6 = "#FF7452";
var $0ed3e85fb4a45304$export$4a7404f376229999 = "#FF5630";
var $0ed3e85fb4a45304$export$2010d0fb4295b346 = "#DE350B";
var $0ed3e85fb4a45304$export$2837b5a1a71d5c02 = "#BF2600";
var $0ed3e85fb4a45304$export$8d9596b529bbb9cf = "#FFFAE6";
var $0ed3e85fb4a45304$export$41060a744ab0b7ae = "#FFF0B3";
var $0ed3e85fb4a45304$export$1cc05bbbf340e559 = "#FFE380";
var $0ed3e85fb4a45304$export$5aae31392d72caaa = "#FFC400";
var $0ed3e85fb4a45304$export$c6930421db9fa514 = "#FFAB00";
var $0ed3e85fb4a45304$export$59619663aa6500fb = "#FF991F";
var $0ed3e85fb4a45304$export$874739ea9e379ab6 = "#FF8B00";
var $0ed3e85fb4a45304$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0ed3e85fb4a45304$export$69a3bf21b9686c2b = "#ABF5D1";
var $0ed3e85fb4a45304$export$afbce1382ec95f73 = "#79F2C0";
var $0ed3e85fb4a45304$export$747d86715d4175de = "#57D9A3";
var $0ed3e85fb4a45304$export$940e1f69e873f202 = "#36B37E";
var $0ed3e85fb4a45304$export$a49394138f7b8e85 = "#00875A";
var $0ed3e85fb4a45304$export$6fa04827ac68a4fb = "#006644";
var $0ed3e85fb4a45304$export$226de0355ed012f8 = "#DEEBFF";
var $0ed3e85fb4a45304$export$8c13c2ee36917869 = "#B3D4FF";
var $0ed3e85fb4a45304$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0ed3e85fb4a45304$export$215b7063051591f1 = "#2684FF";
var $0ed3e85fb4a45304$export$e62e8919cca44969 = "#0065FF";
var $0ed3e85fb4a45304$export$b3de0ae08da2ce64 = "#0052CC";
var $0ed3e85fb4a45304$export$a6ee3d71bc067634 = "#0747A6";
var $0ed3e85fb4a45304$export$67f15409e87642a1 = "#669DF1";
var $0ed3e85fb4a45304$export$f0539dbc42dbb067 = "#8FB8F6";
var $0ed3e85fb4a45304$export$363e4475840015bb = "#EAE6FF";
var $0ed3e85fb4a45304$export$4b0a4417ed59760f = "#C0B6F2";
var $0ed3e85fb4a45304$export$6011520a64d9a187 = "#998DD9";
var $0ed3e85fb4a45304$export$a7175d4e9206bc80 = "#8777D9";
var $0ed3e85fb4a45304$export$b48405b95304b5a1 = "#6554C0";
var $0ed3e85fb4a45304$export$c71e4279dd54a18d = "#5243AA";
var $0ed3e85fb4a45304$export$147899de772240ec = "#403294";
var $0ed3e85fb4a45304$export$2cf711fe14c66f06 = "#E6FCFF";
var $0ed3e85fb4a45304$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0ed3e85fb4a45304$export$776c9c497ef08533 = "#79E2F2";
var $0ed3e85fb4a45304$export$69cb3ca10c1e330e = "#00C7E6";
var $0ed3e85fb4a45304$export$9dc1ef0f3f48059b = "#00B8D9";
var $0ed3e85fb4a45304$export$7c835c78b6fcdef8 = "#00A3BF";
var $0ed3e85fb4a45304$export$6036577f95c3877e = "#008DA6";
var $0ed3e85fb4a45304$export$29a4f05edc054374 = "#FFFFFF";
var $0ed3e85fb4a45304$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0ed3e85fb4a45304$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0ed3e85fb4a45304$export$3e51e8f1440314ba = "#EBECF0";
var $0ed3e85fb4a45304$export$1ce2d1575d444ceb = "#DFE1E6";
var $0ed3e85fb4a45304$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0ed3e85fb4a45304$export$c2e91cbeada39b8b = "#B3BAC5";
var $0ed3e85fb4a45304$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0ed3e85fb4a45304$export$eaa8c8a70ac22806 = "#97A0AF";
var $0ed3e85fb4a45304$export$7c87d337fb91a97d = "#8993A4";
var $0ed3e85fb4a45304$export$d6447c357493214f = "#7A869A";
var $0ed3e85fb4a45304$export$f563ee71e9ee74cd = "#6B778C";
var $0ed3e85fb4a45304$export$e2ef2124cf4024b1 = "#5E6C84";
var $0ed3e85fb4a45304$export$eece5f492e429f08 = "#505F79";
var $0ed3e85fb4a45304$export$c39c0fe0f26207ae = "#42526E";
var $0ed3e85fb4a45304$export$7090862dc3038a9f = "#344563";
var $0ed3e85fb4a45304$export$ad0bacf983b7ddaa = "#253858";
var $0ed3e85fb4a45304$export$7d61b15e0da132af = "#172B4D";
var $0ed3e85fb4a45304$export$fbda843f0a27fe96 = "#091E42";
var $0ed3e85fb4a45304$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0ed3e85fb4a45304$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0ed3e85fb4a45304$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0ed3e85fb4a45304$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0ed3e85fb4a45304$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0ed3e85fb4a45304$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0ed3e85fb4a45304$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0ed3e85fb4a45304$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0ed3e85fb4a45304$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0ed3e85fb4a45304$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0ed3e85fb4a45304$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0ed3e85fb4a45304$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0ed3e85fb4a45304$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0ed3e85fb4a45304$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0ed3e85fb4a45304$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0ed3e85fb4a45304$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0ed3e85fb4a45304$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0ed3e85fb4a45304$export$2f6319cf7d736c2a = "#E6EDFA";
var $0ed3e85fb4a45304$export$95126bc8884d6634 = "#DCE5F5";
var $0ed3e85fb4a45304$export$8338d8c35d44ff1 = "#CED9EB";
var $0ed3e85fb4a45304$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0ed3e85fb4a45304$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0ed3e85fb4a45304$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0ed3e85fb4a45304$export$97e81faa16a182c7 = "#8C9CB8";
var $0ed3e85fb4a45304$export$bfe21c59123ecf33 = "#7988A3";
var $0ed3e85fb4a45304$export$ee82aa2ea6a1558 = "#67758F";
var $0ed3e85fb4a45304$export$682927c6ed76be02 = "#56637A";
var $0ed3e85fb4a45304$export$91fd9994c5be9757 = "#455166";
var $0ed3e85fb4a45304$export$d281fbfe3cff2df6 = "#3B475C";
var $0ed3e85fb4a45304$export$3902c91d8b98a753 = "#313D52";
var $0ed3e85fb4a45304$export$8e8133c1ba5845b5 = "#283447";
var $0ed3e85fb4a45304$export$33ff357f6620b39 = "#202B3D";
var $0ed3e85fb4a45304$export$633847cf062b69e0 = "#1B2638";
var $0ed3e85fb4a45304$export$9776a6e503bdbf76 = "#121A29";
var $0ed3e85fb4a45304$export$6c813d5160dff5db = "#0E1624";
var $0ed3e85fb4a45304$export$3d4f271a500072a = "#0D1424";
var $0ed3e85fb4a45304$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0ed3e85fb4a45304$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0ed3e85fb4a45304$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0ed3e85fb4a45304$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0ed3e85fb4a45304$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0ed3e85fb4a45304$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0ed3e85fb4a45304$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0ed3e85fb4a45304$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0ed3e85fb4a45304$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0ed3e85fb4a45304$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0ed3e85fb4a45304$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0ed3e85fb4a45304$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0ed3e85fb4a45304$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0ed3e85fb4a45304$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0ed3e85fb4a45304$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0ed3e85fb4a45304$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0ed3e85fb4a45304$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $0ed3e85fb4a45304$export$d2adc5dedf09fced = "#292A2E";
var $0ed3e85fb4a45304$export$f51762073d2bb381 = "#94C748";
var $0ed3e85fb4a45304$export$95e26d54def96891 = "#B3DF72";


var $501649f8e44249ee$export$ae3cba7672df0890 = "var(--ds-background-disabled, ".concat((0, $0ed3e85fb4a45304$export$9fdfb749e33cdf97), ")");
var $501649f8e44249ee$export$fe505fe3c5edbdf6 = "var(--ds-border-disabled, ".concat((0, $0ed3e85fb4a45304$export$1ce2d1575d444ceb), ")");
var $501649f8e44249ee$export$7f333bbf7ddab792 = "var(--ds-border-danger, ".concat((0, $0ed3e85fb4a45304$export$2010d0fb4295b346), ")");
var $501649f8e44249ee$export$dafd83031c202ca8 = "var(--ds-border-input, ".concat((0, $0ed3e85fb4a45304$export$d6447c357493214f), ")");
var $501649f8e44249ee$export$e8320c09dc1e4012 = "var(--ds-border-focused, ".concat((0, $0ed3e85fb4a45304$export$215b7063051591f1), ")");
var $501649f8e44249ee$export$b13414ee9ac9cae6 = "var(--ds-background-input, ".concat((0, $0ed3e85fb4a45304$export$e655ef011c4aa1a2), ")");
var $501649f8e44249ee$export$bca15982c103d57b = "var(--ds-background-input-hovered, ".concat((0, $0ed3e85fb4a45304$export$3e51e8f1440314ba), ")");
var $501649f8e44249ee$export$21287e4b7f134f09 = "var(--ds-background-input-pressed, ".concat((0, $0ed3e85fb4a45304$export$29a4f05edc054374), ")");
var $501649f8e44249ee$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
var $501649f8e44249ee$export$5e076b2557ef7bbb = "var(--ds-text-subtlest, ".concat((0, $0ed3e85fb4a45304$export$f563ee71e9ee74cd), ")");
var $501649f8e44249ee$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $0ed3e85fb4a45304$export$fbda843f0a27fe96), ")");
var $501649f8e44249ee$export$eb4a7d363eec53c8 = "var(--ds-text-disabled, ".concat((0, $0ed3e85fb4a45304$export$5f71e19f3a7ad9de), ")");
var $501649f8e44249ee$export$f4d082c200a4b4b8 = "transparent";


function $40936c729c837ee9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40936c729c837ee9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40936c729c837ee9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40936c729c837ee9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $40936c729c837ee9$var$disabledRules = {
    backgroundColor: $501649f8e44249ee$export$ae3cba7672df0890,
    backgroundColorFocus: $501649f8e44249ee$export$ae3cba7672df0890,
    backgroundColorHover: $501649f8e44249ee$export$ae3cba7672df0890,
    borderColor: $501649f8e44249ee$export$fe505fe3c5edbdf6,
    borderColorFocus: $501649f8e44249ee$export$e8320c09dc1e4012,
    textColor: $501649f8e44249ee$export$eb4a7d363eec53c8
};
var $40936c729c837ee9$var$invalidRules = {
    borderColor: $501649f8e44249ee$export$7f333bbf7ddab792,
    borderColorFocus: $501649f8e44249ee$export$e8320c09dc1e4012,
    backgroundColor: $501649f8e44249ee$export$b13414ee9ac9cae6,
    backgroundColorFocus: $501649f8e44249ee$export$21287e4b7f134f09,
    backgroundColorHover: $501649f8e44249ee$export$bca15982c103d57b
};
var $40936c729c837ee9$var$backgroundColor = {
    standard: $501649f8e44249ee$export$b13414ee9ac9cae6,
    subtle: $501649f8e44249ee$export$f4d082c200a4b4b8,
    none: $501649f8e44249ee$export$f4d082c200a4b4b8
};
var $40936c729c837ee9$var$backgroundColorFocus = {
    standard: $501649f8e44249ee$export$21287e4b7f134f09,
    subtle: $501649f8e44249ee$export$21287e4b7f134f09,
    none: $501649f8e44249ee$export$f4d082c200a4b4b8
};
var $40936c729c837ee9$var$backgroundColorHover = {
    standard: $501649f8e44249ee$export$bca15982c103d57b,
    subtle: $501649f8e44249ee$export$bca15982c103d57b,
    none: $501649f8e44249ee$export$f4d082c200a4b4b8
};
var $40936c729c837ee9$var$borderColor = {
    standard: $501649f8e44249ee$export$dafd83031c202ca8,
    subtle: $501649f8e44249ee$export$f4d082c200a4b4b8,
    none: $501649f8e44249ee$export$f4d082c200a4b4b8
};
var $40936c729c837ee9$var$borderColorFocus = {
    standard: $501649f8e44249ee$export$e8320c09dc1e4012,
    subtle: $501649f8e44249ee$export$e8320c09dc1e4012,
    none: $501649f8e44249ee$export$f4d082c200a4b4b8
};
var $40936c729c837ee9$var$borderColorHover = {
    standard: $501649f8e44249ee$export$dafd83031c202ca8,
    subtle: $501649f8e44249ee$export$a87538d56ee366ec,
    none: $501649f8e44249ee$export$f4d082c200a4b4b8
};
var $40936c729c837ee9$var$lineHeightBase = 20;
var $40936c729c837ee9$var$lineHeightCompact = 16;
var $40936c729c837ee9$var$compactVerticalPadding = 2;
var $40936c729c837ee9$var$verticalPadding = 6;
var $40936c729c837ee9$var$horizontalPadding = 8;
var $40936c729c837ee9$var$transitionDuration = "0.2s";
var $40936c729c837ee9$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $40936c729c837ee9$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: "unset",
    WebkitOpacity: "1"
};
var $40936c729c837ee9$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $40936c729c837ee9$var$lineHeightBase * minimumRows;
    return contentHeight + $40936c729c837ee9$var$verticalPadding * 2 + borderHeight * 2;
};
var $40936c729c837ee9$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $40936c729c837ee9$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $40936c729c837ee9$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $40936c729c837ee9$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(appearance) {
    return appearance && (0, $dnfL5.css)($40936c729c837ee9$var$_objectSpread({
        "&:focus": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $40936c729c837ee9$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $40936c729c837ee9$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $40936c729c837ee9$var$borderColorFocus[appearance])
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:not(:focus)": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $40936c729c837ee9$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $40936c729c837ee9$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-invalid]:focus": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $40936c729c837ee9$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $40936c729c837ee9$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $40936c729c837ee9$var$invalidRules.borderColorFocus)
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&[data-invalid]:not(:focus)": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $40936c729c837ee9$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $40936c729c837ee9$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $40936c729c837ee9$var$invalidRules.borderColor)
        }
    }, appearance === "standard" ? {
        "&:disabled:focus": {
            backgroundColor: $40936c729c837ee9$var$disabledRules.backgroundColorFocus,
            borderColor: $40936c729c837ee9$var$disabledRules.borderColorFocus
        },
        "&:disabled:not(:focus)": {
            backgroundColor: $40936c729c837ee9$var$disabledRules.backgroundColor,
            borderColor: $40936c729c837ee9$var$disabledRules.borderColor
        }
    } : {}));
};
var $40936c729c837ee9$var$placeholderStyles = (0, $dnfL5.css)({
    "&::placeholder": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $501649f8e44249ee$export$5e076b2557ef7bbb
    },
    "&:disabled::placeholder": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $40936c729c837ee9$var$disabledRules.textColor
    }
});
var $40936c729c837ee9$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(appearance) {
    return appearance && (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:hover:not(:read-only):not(:focus)": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $40936c729c837ee9$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $40936c729c837ee9$var$borderColorHover[appearance],
            "&:disabled": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $40936c729c837ee9$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            "&[data-invalid]": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $40936c729c837ee9$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $40936c729c837ee9$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $40936c729c837ee9$var$invalidRules.borderColor)
            }
        }
    });
};
var $40936c729c837ee9$var$resizeStyle = function resizeStyle(resize) {
    if (resize === "horizontal" || resize === "vertical") // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return (0, $dnfL5.css)({
        resize: resize
    });
    if (resize === "auto") return (0, $dnfL5.css)({
        resize: "both"
    });
    return (0, $dnfL5.css)({
        resize: "none"
    });
};
var $40936c729c837ee9$var$borderStyle = function borderStyle(appearance) {
    return (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === "none" ? "none" : "solid"
    });
};
var $40936c729c837ee9$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)' : 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    });
};
var $40936c729c837ee9$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = appearance !== "none" ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $40936c729c837ee9$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $dnfL5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-compact]": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $40936c729c837ee9$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($40936c729c837ee9$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $40936c729c837ee9$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:not([data-compact])": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $40936c729c837ee9$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($40936c729c837ee9$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $40936c729c837ee9$var$lineHeightBase / 14
        }
    });
};
var $40936c729c837ee9$var$staticStyles = (0, $dnfL5.css)({
    display: "block",
    boxSizing: "border-box",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    margin: 0,
    position: "relative",
    flex: "1 1 100%",
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    outline: "none",
    overflow: "auto",
    transition: "background-color ".concat($40936c729c837ee9$var$transitionDuration, " ease-in-out,\n               border-color ").concat($40936c729c837ee9$var$transitionDuration, " ease-in-out"),
    wordWrap: "break-word",
    "&:disabled": $40936c729c837ee9$var$_objectSpread({
        cursor: "not-allowed"
    }, $40936c729c837ee9$var$overrideSafariDisabledStyles),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-ms-clear": {
        display: "none"
    },
    "&:invalid": {
        boxShadow: "none"
    }
});
// suggestion: these two could be merged into cssMap during @compiled rewrite
var $40936c729c837ee9$var$newFontStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    font: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
}, (0, $d95e72aa45a79136$export$987d49ffe1b0900f).above.xs, {
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
}));
var $40936c729c837ee9$var$monospacedFontFamilyStyles = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
}, (0, $d95e72aa45a79136$export$987d49ffe1b0900f).above.xs, {
    // Reapply the monospaced font family as the font declaration used in the breakpoint in newFontStyles overrides it otherwise
    fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
}));
var $40936c729c837ee9$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $dnfL5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$borderStyle(appearance), // @todo: remove in `platform_design_system_team_safari_input_fix` cleanup
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") ? $40936c729c837ee9$var$newFontStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    isMonospaced && (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") ? $40936c729c837ee9$var$monospacedFontFamilyStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    }));
};
var $40936c729c837ee9$export$98856a888ef36079 = function dynamicStyles(appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $dnfL5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $40936c729c837ee9$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $501649f8e44249ee$export$32f78bffcd82ff28,
        "&:disabled": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $40936c729c837ee9$var$disabledRules.textColor
        }
    }));
};


var $152edff8f3d35f34$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value"
];
function $152edff8f3d35f34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $152edff8f3d35f34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $152edff8f3d35f34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $152edff8f3d35f34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $152edff8f3d35f34$var$packageName = "@atlaskit/textarea";
var $152edff8f3d35f34$var$packageVersion = "5.8.2";
var $152edff8f3d35f34$var$analyticsParams = {
    componentName: "textArea",
    packageName: $152edff8f3d35f34$var$packageName,
    packageVersion: $152edff8f3d35f34$var$packageVersion
};
var $152edff8f3d35f34$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = "auto";
    var borderHeight = (0, $40936c729c837ee9$export$12879c7697ed953d);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $152edff8f3d35f34$var$InnerTextArea = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var ourRef = (0, $acw62.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? "smart" : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? "50vh" : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $152edff8f3d35f34$var$_excluded);
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (resize === "smart" && el) $152edff8f3d35f34$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $jmqGD.usePlatformLeafEventHandler)($152edff8f3d35f34$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $152edff8f3d35f34$var$analyticsParams));
    var onFocusWithAnalytics = (0, $jmqGD.usePlatformLeafEventHandler)($152edff8f3d35f34$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $152edff8f3d35f34$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === "function") ref(elementRef);
    };
    var handleOnChange = (0, $acw62.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === "smart" && el) $152edff8f3d35f34$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-testid": testId ? testId : undefined
    };
    var baseStyles = (0, $acw62.useMemo)(function() {
        return (0, $40936c729c837ee9$export$bff8031d86bb089)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    var textAreaStyles = (0, $dnfL5.css)([
        baseStyles,
        (0, $40936c729c837ee9$export$98856a888ef36079)(appearance)
    ]);
    return (0, $dnfL5.jsx)("textarea", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $152edff8f3d35f34$var$TextArea = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function TextArea(props, ref) {
    return (0, $dnfL5.jsx)($152edff8f3d35f34$var$InnerTextArea, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
}));
$152edff8f3d35f34$var$TextArea.displayName = "TextArea";
var $152edff8f3d35f34$export$2e2bcd8739ae039 = $152edff8f3d35f34$var$TextArea;



/* eslint-disable @repo/internal/react/require-jsdoc */ var $dc87d2aaa4908eb7$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $hPtJY = parcelRequire("hPtJY");
var $1a6d5e032bf3d79c$var$_process$env;
/// <reference types="node" />
var $1a6d5e032bf3d79c$var$_default_1 = typeof $hPtJY !== "undefined" && $hPtJY !== null && (($1a6d5e032bf3d79c$var$_process$env = {}, $1a6d5e032bf3d79c$var$_process$env === void 0) ? void 0 : $1a6d5e032bf3d79c$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);
var $1a6d5e032bf3d79c$export$2e2bcd8739ae039 = $1a6d5e032bf3d79c$var$_default_1;



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9ZLvy = parcelRequire("9ZLvy");
function $0301fa190b7d202e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $0301fa190b7d202e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $0301fa190b7d202e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0301fa190b7d202e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0301fa190b7d202e$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $0301fa190b7d202e$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $0301fa190b7d202e$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsContext);
        _this = $0301fa190b7d202e$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $0301fa190b7d202e$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $0301fa190b7d202e$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ZLvy.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $acw62.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($0301fa190b7d202e$var$AnalyticsContext, "contextTypes", $0301fa190b7d202e$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($0301fa190b7d202e$var$AnalyticsContext, "childContextTypes", $0301fa190b7d202e$var$ContextTypes);
var $0301fa190b7d202e$export$2e2bcd8739ae039 = $0301fa190b7d202e$var$AnalyticsContext;



var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");

var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $5e914b3e6b10e220$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};



var $acw62 = parcelRequire("acw62");
var $85a7be382a104213$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


var $4bfa746aa899ffde$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $85a7be382a104213$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $5e914b3e6b10e220$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $acw62.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $acw62.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ZLvy.default).Provider, {
        value: value
    }, children);
};
var $4bfa746aa899ffde$export$2e2bcd8739ae039 = $4bfa746aa899ffde$var$AnalyticsContext;


var $16d7721e00d20c60$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $1a6d5e032bf3d79c$export$2e2bcd8739ae039) || (0, $ltooA.fg)("analytics-next-use-legacy-context") === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bfa746aa899ffde$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0301fa190b7d202e$export$2e2bcd8739ae039), props);
};
var $16d7721e00d20c60$export$2e2bcd8739ae039 = $16d7721e00d20c60$var$AnalyticsContext;


var $fdddc63a0d63cbeb$var$_excluded = [
    "analyticsContext"
];
function $fdddc63a0d63cbeb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdddc63a0d63cbeb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdddc63a0d63cbeb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdddc63a0d63cbeb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdddc63a0d63cbeb$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $fdddc63a0d63cbeb$var$_excluded);
            var analyticsData = (0, $acw62.useMemo)(function() {
                return $fdddc63a0d63cbeb$var$_objectSpread($fdddc63a0d63cbeb$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16d7721e00d20c60$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $fdddc63a0d63cbeb$export$2e2bcd8739ae039 = $fdddc63a0d63cbeb$var$withAnalyticsContext;


var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $6Bvm3 = parcelRequire("6Bvm3");

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $29bb6981e2db5572$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29bb6981e2db5572$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29bb6981e2db5572$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29bb6981e2db5572$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $29bb6981e2db5572$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $29bb6981e2db5572$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $29bb6981e2db5572$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $29bb6981e2db5572$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $29bb6981e2db5572$var$_objectSpread($29bb6981e2db5572$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $162e9dfbb7896e82$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $162e9dfbb7896e82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $162e9dfbb7896e82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($162e9dfbb7896e82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $162e9dfbb7896e82$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $162e9dfbb7896e82$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $162e9dfbb7896e82$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $162e9dfbb7896e82$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $162e9dfbb7896e82$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $162e9dfbb7896e82$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $29bb6981e2db5572$export$2e2bcd8739ae039));



function $adb011f97b8029a7$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5e914b3e6b10e220$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $162e9dfbb7896e82$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

function $1b7011e3511db35f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b7011e3511db35f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b7011e3511db35f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b7011e3511db35f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b7011e3511db35f$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $adb011f97b8029a7$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $acw62.useRef)({});
    var patchedProps = (0, $acw62.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $1b7011e3511db35f$var$_objectSpread($1b7011e3511db35f$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $1b7011e3511db35f$var$_objectSpread($1b7011e3511db35f$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $988e6509b1c31583$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $1b7011e3511db35f$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $adb011f97b8029a7$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $988e6509b1c31583$export$2e2bcd8739ae039 = $988e6509b1c31583$var$withAnalyticsEvents;



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");
/* select.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");


var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9100017bc3df9b38$var$ATOMIC_GROUP_LENGTH = 5;
function $9100017bc3df9b38$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $9100017bc3df9b38$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");
function $b77544e2caa431c1$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_userAgentData = window.navigator["userAgentData"]) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $b77544e2caa431c1$var$isIPhone() {
    return $b77544e2caa431c1$var$testPlatform(/^iPhone/i);
}
function $b77544e2caa431c1$var$isMac() {
    return $b77544e2caa431c1$var$testPlatform(/^Mac/i);
}
function $b77544e2caa431c1$var$isIPad() {
    return $b77544e2caa431c1$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b77544e2caa431c1$var$isMac() && navigator.maxTouchPoints > 1;
}
function $b77544e2caa431c1$var$isIOS() {
    return $b77544e2caa431c1$var$isIPhone() || $b77544e2caa431c1$var$isIPad();
}
function $b77544e2caa431c1$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $b77544e2caa431c1$export$e1865c3bedcd822b() {
    return $b77544e2caa431c1$var$isMac() || $b77544e2caa431c1$var$isIOS();
}


/**
 * An empty function which does nothing.
 */ function $f7203335dc3f20fa$export$2e2bcd8739ae039() {}



var $ltooA = parcelRequire("ltooA");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $2beec76e165774c3$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $2beec76e165774c3$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $2beec76e165774c3$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $2beec76e165774c3$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $g5Zhu = parcelRequire("g5Zhu");
/* indicators-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


const $5c865fb94edc765b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9100017bc3df9b38$export$2e2bcd8739ae039)(actualStyles);
};


var $58276eeb2339959d$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $2a42a786aeb6254c$var$indicatorContainerStyles = null;
var $2a42a786aeb6254c$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "indicatorsContainer", {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-IndicatorsContainer")
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $8fdc72518ab21c02$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk15s3 _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $8fdc72518ab21c02$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $8fdc72518ab21c02$var$multiValueStyles.root,
            isDisabled && $8fdc72518ab21c02$var$multiValueStyles.disabled,
            isFocused && $8fdc72518ab21c02$var$multiValueStyles.focused,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-multiValue")
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $6cf18d1d15e45369$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $6cf18d1d15e45369$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $6cf18d1d15e45369$var$containerStyles.default,
            isRtl && $6cf18d1d15e45369$var$containerStyles.rtl,
            isDisabled && $6cf18d1d15e45369$var$containerStyles.disabled,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-container")
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $189382aa22da7d77$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7",
    flex: "_1e0c1txw",
    compact: "_1q51ze3t _y4ti12x7 _85i5ze3t _bozg12x7"
};
var $189382aa22da7d77$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $189382aa22da7d77$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $189382aa22da7d77$var$valueContainerStyles.flex,
            isCompact && $189382aa22da7d77$var$valueContainerStyles.compact,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-ValueContainer")
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");

var $ae002a8f3831176c$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $ae002a8f3831176c$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: innerRef,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $ae002a8f3831176c$var$styles.default,
            (0, $ltooA.fg)("platform-dst-shape-theme-default") && $ae002a8f3831176c$var$styles.defaultT26Shape,
            isDisabled && $ae002a8f3831176c$var$styles.disabled,
            isInvalid && $ae002a8f3831176c$var$styles.invalid,
            isCompact && $ae002a8f3831176c$var$styles.compact,
            appearance === "subtle" && $ae002a8f3831176c$var$styles.subtle,
            appearance === "subtle" && isFocused && $ae002a8f3831176c$var$styles.subtleFocused,
            isFocused && $ae002a8f3831176c$var$styles.focused,
            appearance === "none" && $ae002a8f3831176c$var$styles.none,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-control")
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ae002a8f3831176c$export$2e2bcd8739ae039 = $ae002a8f3831176c$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $67bb65600f07f267$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $67bb65600f07f267$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "group", {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $67bb65600f07f267$var$styles.root,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, "-Group")
        ])
    }), label && /*#__PURE__*/ $acw62.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $acw62.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$67bb65600f07f267$export$2e2bcd8739ae039 = $67bb65600f07f267$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");




var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");
var $8edaab242ebda000$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $8edaab242ebda000$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8edaab242ebda000$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8edaab242ebda000$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8edaab242ebda000$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8edaab242ebda000$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $8edaab242ebda000$var$_excluded);
    return $8edaab242ebda000$var$_objectSpread({}, innerProps);
};


var $ea548ea687b10989$var$_excluded = [
    "data"
];
var $ea548ea687b10989$var$headingStyles = null;
var $ea548ea687b10989$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $8edaab242ebda000$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_cleanCommonProps, $ea548ea687b10989$var$_excluded);
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "groupHeading", {
        "group-heading": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-group")
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $d9b8918d00dd39a8$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d9b8918d00dd39a8$exports, "__esModule", {
    value: true
});
$d9b8918d00dd39a8$exports.default = void 0;

var $d9b8918d00dd39a8$var$_react = $d9b8918d00dd39a8$var$_interopRequireDefault((parcelRequire("acw62")));

var $d9b8918d00dd39a8$var$_baseNew = $d9b8918d00dd39a8$var$_interopRequireDefault((parcelRequire("4WWnO")));
function $d9b8918d00dd39a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9b8918d00dd39a8$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d9b8918d00dd39a8$var$_react.default.createElement($d9b8918d00dd39a8$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$d9b8918d00dd39a8$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $d9b8918d00dd39a8$var$_default = $d9b8918d00dd39a8$exports.default = $d9b8918d00dd39a8$var$CrossCircleIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $0f2bf88a36aa71fe$var$ATOMIC_GROUP_LENGTH = 5;
function $0f2bf88a36aa71fe$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $0f2bf88a36aa71fe$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $d65521e6d957d20d$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $0f2bf88a36aa71fe$export$2e2bcd8739ae039)(actualStyles);
};



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $6Bvm3 = parcelRequire("6Bvm3");

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $b4bda8056a754b44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4bda8056a754b44$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4bda8056a754b44$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4bda8056a754b44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b4bda8056a754b44$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b4bda8056a754b44$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $b4bda8056a754b44$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b4bda8056a754b44$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $b4bda8056a754b44$var$_objectSpread($b4bda8056a754b44$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $bd691812603930ec$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $bd691812603930ec$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $bd691812603930ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bd691812603930ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bd691812603930ec$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $bd691812603930ec$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $bd691812603930ec$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $bd691812603930ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $bd691812603930ec$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $bd691812603930ec$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b4bda8056a754b44$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $249a51fe2e140070$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};


function $fa7aeab677c9dacd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $249a51fe2e140070$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $bd691812603930ec$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $ef76cce6964d5897$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $969273620ec8fe3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $969273620ec8fe3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $969273620ec8fe3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $969273620ec8fe3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $969273620ec8fe3b$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $fa7aeab677c9dacd$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $ef76cce6964d5897$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $ef76cce6964d5897$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $969273620ec8fe3b$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


function $e8f347b91a2537bc$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_userAgentData = window.navigator["userAgentData"]) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $e8f347b91a2537bc$var$isIPhone() {
    return $e8f347b91a2537bc$var$testPlatform(/^iPhone/i);
}
function $e8f347b91a2537bc$var$isMac() {
    return $e8f347b91a2537bc$var$testPlatform(/^Mac/i);
}
function $e8f347b91a2537bc$var$isIPad() {
    return $e8f347b91a2537bc$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $e8f347b91a2537bc$var$isMac() && navigator.maxTouchPoints > 1;
}
function $e8f347b91a2537bc$var$isIOS() {
    return $e8f347b91a2537bc$var$isIPhone() || $e8f347b91a2537bc$var$isIPad();
}
function $e8f347b91a2537bc$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $e8f347b91a2537bc$export$e1865c3bedcd822b() {
    return $e8f347b91a2537bc$var$isMac() || $e8f347b91a2537bc$var$isIOS();
}


/**
 * An empty function which does nothing.
 */ function $5bd1c65285ffb8ce$export$2e2bcd8739ae039() {}



var $acw62 = parcelRequire("acw62");
var $2601e54ec301158e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ec20d9ac266f0065$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $ec20d9ac266f0065$var$_excluded2 = [
    "className"
];
var $ec20d9ac266f0065$var$focusRingStyles = null;
var $ec20d9ac266f0065$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $ec20d9ac266f0065$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $ec20d9ac266f0065$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $ec20d9ac266f0065$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $0f2bf88a36aa71fe$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $ec20d9ac266f0065$export$2e2bcd8739ae039 = $ec20d9ac266f0065$var$Focusable;


var $484954471eb7443a$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $484954471eb7443a$var$_excluded2 = [
    "className"
];
var $484954471eb7443a$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $484954471eb7443a$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5bd1c65285ffb8ce$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $484954471eb7443a$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $2601e54ec301158e$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $969273620ec8fe3b$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $484954471eb7443a$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $ec20d9ac266f0065$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $e8f347b91a2537bc$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $d65521e6d957d20d$export$a274e22fb40f762e)($484954471eb7443a$var$styles.root, isDisabled && $484954471eb7443a$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $484954471eb7443a$export$2e2bcd8739ae039 = $484954471eb7443a$var$Pressable;



var $04b4231e01c47bcf$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $04b4231e01c47bcf$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $04b4231e01c47bcf$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? "clear" : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $04b4231e01c47bcf$var$clearIndicatorStyles.default,
            isCompact && $04b4231e01c47bcf$var$clearIndicatorStyles.compact,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-indicatorContainer")
        ])
    }, innerProps), /*#__PURE__*/ $acw62.createElement((0, $484954471eb7443a$export$2e2bcd8739ae039), {
        xcss: $04b4231e01c47bcf$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d9b8918d00dd39a8$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $f1e708aebba3cda2$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($f1e708aebba3cda2$exports, "__esModule", {
    value: true
});
$f1e708aebba3cda2$exports.default = void 0;

var $f1e708aebba3cda2$var$_react = $f1e708aebba3cda2$var$_interopRequireDefault((parcelRequire("acw62")));

var $f1e708aebba3cda2$var$_baseNew = $f1e708aebba3cda2$var$_interopRequireDefault((parcelRequire("4WWnO")));
function $f1e708aebba3cda2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1e708aebba3cda2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f1e708aebba3cda2$var$_react.default.createElement($f1e708aebba3cda2$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f1e708aebba3cda2$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $f1e708aebba3cda2$var$_default = $f1e708aebba3cda2$exports.default = $f1e708aebba3cda2$var$ChevronDownIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $86b6e0c5c17f702c$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $86b6e0c5c17f702c$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $86b6e0c5c17f702c$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $86b6e0c5c17f702c$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $86b6e0c5c17f702c$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $86b6e0c5c17f702c$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $86b6e0c5c17f702c$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $86b6e0c5c17f702c$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $86b6e0c5c17f702c$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $86b6e0c5c17f702c$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, ariaAttributes, {
        role: role,
        className: (0, $0f2bf88a36aa71fe$export$2e2bcd8739ae039)([
            $86b6e0c5c17f702c$var$styles.root,
            gap && $86b6e0c5c17f702c$var$columnGapMap[gap],
            columnGap && $86b6e0c5c17f702c$var$columnGapMap[columnGap],
            gap && $86b6e0c5c17f702c$var$rowGapMap[gap],
            rowGap && $86b6e0c5c17f702c$var$rowGapMap[rowGap],
            alignItems && $86b6e0c5c17f702c$var$alignItemsMap[alignItems],
            direction && $86b6e0c5c17f702c$var$flexDirectionMap[direction],
            justifyContent && $86b6e0c5c17f702c$var$justifyContentMap[justifyContent],
            wrap && $86b6e0c5c17f702c$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$86b6e0c5c17f702c$var$Flex.displayName = "Flex";
var $86b6e0c5c17f702c$export$2e2bcd8739ae039 = $86b6e0c5c17f702c$var$Flex;


var $189ca24ef4b625ea$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $189ca24ef4b625ea$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $189ca24ef4b625ea$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $0f2bf88a36aa71fe$export$2e2bcd8739ae039)([
            $189ca24ef4b625ea$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $189ca24ef4b625ea$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $189ca24ef4b625ea$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $acw62.createElement($189ca24ef4b625ea$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $acw62.createElement((0, $86b6e0c5c17f702c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $1b267db47313e17e$export$a274e22fb40f762e)(grow === "hug" && $189ca24ef4b625ea$var$styles.hug, grow === "fill" && $189ca24ef4b625ea$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$189ca24ef4b625ea$var$Inline.displayName = "Inline";
var $189ca24ef4b625ea$export$2e2bcd8739ae039 = $189ca24ef4b625ea$var$Inline;



var $2e5dde9de66158b5$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
var $2e5dde9de66158b5$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $2e5dde9de66158b5$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $2e5dde9de66158b5$var$dropdownStyles.default,
            isDisabled && $2e5dde9de66158b5$var$dropdownStyles.disabled,
            isCompact && $2e5dde9de66158b5$var$dropdownStyles.compact,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-indicatorContainer")
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $acw62.createElement((0, $189ca24ef4b625ea$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $2e5dde9de66158b5$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1e708aebba3cda2$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d40b3282faf14385$var$ATOMIC_GROUP_LENGTH = 5;
function $d40b3282faf14385$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $d40b3282faf14385$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $de54d250d5d60de6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


// Reds
var $b8a8169e77d1e088$export$4b84fd0e2c617bd = "#FFEBE6";
var $b8a8169e77d1e088$export$b34b069eff244586 = "#FFBDAD";
var $b8a8169e77d1e088$export$be802dd0d8b57f35 = "#FF8F73";
var $b8a8169e77d1e088$export$60847d42f9da92a6 = "#FF7452";
var $b8a8169e77d1e088$export$4a7404f376229999 = "#FF5630";
var $b8a8169e77d1e088$export$2010d0fb4295b346 = "#DE350B";
var $b8a8169e77d1e088$export$2837b5a1a71d5c02 = "#BF2600";
var $b8a8169e77d1e088$export$8d9596b529bbb9cf = "#FFFAE6";
var $b8a8169e77d1e088$export$41060a744ab0b7ae = "#FFF0B3";
var $b8a8169e77d1e088$export$1cc05bbbf340e559 = "#FFE380";
var $b8a8169e77d1e088$export$5aae31392d72caaa = "#FFC400";
var $b8a8169e77d1e088$export$c6930421db9fa514 = "#FFAB00";
var $b8a8169e77d1e088$export$59619663aa6500fb = "#FF991F";
var $b8a8169e77d1e088$export$874739ea9e379ab6 = "#FF8B00";
var $b8a8169e77d1e088$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $b8a8169e77d1e088$export$69a3bf21b9686c2b = "#ABF5D1";
var $b8a8169e77d1e088$export$afbce1382ec95f73 = "#79F2C0";
var $b8a8169e77d1e088$export$747d86715d4175de = "#57D9A3";
var $b8a8169e77d1e088$export$940e1f69e873f202 = "#36B37E";
var $b8a8169e77d1e088$export$a49394138f7b8e85 = "#00875A";
var $b8a8169e77d1e088$export$6fa04827ac68a4fb = "#006644";
var $b8a8169e77d1e088$export$226de0355ed012f8 = "#DEEBFF";
var $b8a8169e77d1e088$export$8c13c2ee36917869 = "#B3D4FF";
var $b8a8169e77d1e088$export$ecfc1dff386a3e7a = "#4C9AFF";
var $b8a8169e77d1e088$export$215b7063051591f1 = "#2684FF";
var $b8a8169e77d1e088$export$e62e8919cca44969 = "#0065FF";
var $b8a8169e77d1e088$export$b3de0ae08da2ce64 = "#0052CC";
var $b8a8169e77d1e088$export$a6ee3d71bc067634 = "#0747A6";
var $b8a8169e77d1e088$export$67f15409e87642a1 = "#669DF1";
var $b8a8169e77d1e088$export$f0539dbc42dbb067 = "#8FB8F6";
var $b8a8169e77d1e088$export$363e4475840015bb = "#EAE6FF";
var $b8a8169e77d1e088$export$4b0a4417ed59760f = "#C0B6F2";
var $b8a8169e77d1e088$export$6011520a64d9a187 = "#998DD9";
var $b8a8169e77d1e088$export$a7175d4e9206bc80 = "#8777D9";
var $b8a8169e77d1e088$export$b48405b95304b5a1 = "#6554C0";
var $b8a8169e77d1e088$export$c71e4279dd54a18d = "#5243AA";
var $b8a8169e77d1e088$export$147899de772240ec = "#403294";
var $b8a8169e77d1e088$export$2cf711fe14c66f06 = "#E6FCFF";
var $b8a8169e77d1e088$export$7a8f4d33f6f9772c = "#B3F5FF";
var $b8a8169e77d1e088$export$776c9c497ef08533 = "#79E2F2";
var $b8a8169e77d1e088$export$69cb3ca10c1e330e = "#00C7E6";
var $b8a8169e77d1e088$export$9dc1ef0f3f48059b = "#00B8D9";
var $b8a8169e77d1e088$export$7c835c78b6fcdef8 = "#00A3BF";
var $b8a8169e77d1e088$export$6036577f95c3877e = "#008DA6";
var $b8a8169e77d1e088$export$29a4f05edc054374 = "#FFFFFF";
var $b8a8169e77d1e088$export$e655ef011c4aa1a2 = "#FAFBFC";
var $b8a8169e77d1e088$export$9fdfb749e33cdf97 = "#F4F5F7";
var $b8a8169e77d1e088$export$3e51e8f1440314ba = "#EBECF0";
var $b8a8169e77d1e088$export$1ce2d1575d444ceb = "#DFE1E6";
var $b8a8169e77d1e088$export$8754fc7e6d8b3000 = "#C1C7D0";
var $b8a8169e77d1e088$export$c2e91cbeada39b8b = "#B3BAC5";
var $b8a8169e77d1e088$export$5f71e19f3a7ad9de = "#A5ADBA";
var $b8a8169e77d1e088$export$eaa8c8a70ac22806 = "#97A0AF";
var $b8a8169e77d1e088$export$7c87d337fb91a97d = "#8993A4";
var $b8a8169e77d1e088$export$d6447c357493214f = "#7A869A";
var $b8a8169e77d1e088$export$f563ee71e9ee74cd = "#6B778C";
var $b8a8169e77d1e088$export$e2ef2124cf4024b1 = "#5E6C84";
var $b8a8169e77d1e088$export$eece5f492e429f08 = "#505F79";
var $b8a8169e77d1e088$export$c39c0fe0f26207ae = "#42526E";
var $b8a8169e77d1e088$export$7090862dc3038a9f = "#344563";
var $b8a8169e77d1e088$export$ad0bacf983b7ddaa = "#253858";
var $b8a8169e77d1e088$export$7d61b15e0da132af = "#172B4D";
var $b8a8169e77d1e088$export$fbda843f0a27fe96 = "#091E42";
var $b8a8169e77d1e088$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $b8a8169e77d1e088$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $b8a8169e77d1e088$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $b8a8169e77d1e088$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $b8a8169e77d1e088$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $b8a8169e77d1e088$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $b8a8169e77d1e088$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $b8a8169e77d1e088$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $b8a8169e77d1e088$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $b8a8169e77d1e088$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $b8a8169e77d1e088$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $b8a8169e77d1e088$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $b8a8169e77d1e088$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $b8a8169e77d1e088$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $b8a8169e77d1e088$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $b8a8169e77d1e088$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $b8a8169e77d1e088$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $b8a8169e77d1e088$export$2f6319cf7d736c2a = "#E6EDFA";
var $b8a8169e77d1e088$export$95126bc8884d6634 = "#DCE5F5";
var $b8a8169e77d1e088$export$8338d8c35d44ff1 = "#CED9EB";
var $b8a8169e77d1e088$export$5368d76ae4fbbda7 = "#B8C7E0";
var $b8a8169e77d1e088$export$9f0a771d16ec8d36 = "#ABBBD6";
var $b8a8169e77d1e088$export$abcf8c38338b4aa5 = "#9FB0CC";
var $b8a8169e77d1e088$export$97e81faa16a182c7 = "#8C9CB8";
var $b8a8169e77d1e088$export$bfe21c59123ecf33 = "#7988A3";
var $b8a8169e77d1e088$export$ee82aa2ea6a1558 = "#67758F";
var $b8a8169e77d1e088$export$682927c6ed76be02 = "#56637A";
var $b8a8169e77d1e088$export$91fd9994c5be9757 = "#455166";
var $b8a8169e77d1e088$export$d281fbfe3cff2df6 = "#3B475C";
var $b8a8169e77d1e088$export$3902c91d8b98a753 = "#313D52";
var $b8a8169e77d1e088$export$8e8133c1ba5845b5 = "#283447";
var $b8a8169e77d1e088$export$33ff357f6620b39 = "#202B3D";
var $b8a8169e77d1e088$export$633847cf062b69e0 = "#1B2638";
var $b8a8169e77d1e088$export$9776a6e503bdbf76 = "#121A29";
var $b8a8169e77d1e088$export$6c813d5160dff5db = "#0E1624";
var $b8a8169e77d1e088$export$3d4f271a500072a = "#0D1424";
var $b8a8169e77d1e088$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $b8a8169e77d1e088$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $b8a8169e77d1e088$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $b8a8169e77d1e088$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $b8a8169e77d1e088$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $b8a8169e77d1e088$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $b8a8169e77d1e088$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $b8a8169e77d1e088$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $b8a8169e77d1e088$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $b8a8169e77d1e088$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $b8a8169e77d1e088$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $b8a8169e77d1e088$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $b8a8169e77d1e088$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $b8a8169e77d1e088$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $b8a8169e77d1e088$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $b8a8169e77d1e088$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $b8a8169e77d1e088$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $b8a8169e77d1e088$export$d2adc5dedf09fced = "#292A2E";
var $b8a8169e77d1e088$export$f51762073d2bb381 = "#94C748";
var $b8a8169e77d1e088$export$95e26d54def96891 = "#B3DF72";


var $c43aa17d6080512f$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $acf318aad4ee2501$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $b8a8169e77d1e088$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $b8a8169e77d1e088$export$29a4f05edc054374), ")");
}
var $acf318aad4ee2501$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $acf318aad4ee2501$var$loadIn = null;
var $acf318aad4ee2501$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $acf318aad4ee2501$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $acf318aad4ee2501$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $c43aa17d6080512f$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $acf318aad4ee2501$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $de54d250d5d60de6$export$2e2bcd8739ae039));
    $acf318aad4ee2501$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $d40b3282faf14385$export$2e2bcd8739ae039)([
            $acf318aad4ee2501$var$styles.wrapperStyles,
            $acf318aad4ee2501$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $d40b3282faf14385$export$2e2bcd8739ae039)([
            $acf318aad4ee2501$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $d40b3282faf14385$export$2e2bcd8739ae039)([
            $acf318aad4ee2501$var$styles.circleStyles
        ])
    })));
}));
var $acf318aad4ee2501$export$2e2bcd8739ae039 = $acf318aad4ee2501$var$Spinner;



var $0c4986918392b922$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $0c4986918392b922$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c4986918392b922$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c4986918392b922$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c4986918392b922$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c4986918392b922$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $0c4986918392b922$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $0c4986918392b922$var$_excluded);
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)($0c4986918392b922$var$_objectSpread($0c4986918392b922$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $0c4986918392b922$var$loadingIndicatorStyles.default,
            isCompact && $0c4986918392b922$var$loadingIndicatorStyles.compact,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-loadingIndicator")
        ])
    }, innerProps), /*#__PURE__*/ $acw62.createElement((0, $acf318aad4ee2501$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");


var $02a6758cb621c1f3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $02a6758cb621c1f3$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $02a6758cb621c1f3$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $02a6758cb621c1f3$var$nativeInputStylesOld = null;
var $02a6758cb621c1f3$var$nativeInputStyles = null;
var $02a6758cb621c1f3$var$hidden = null;
var $02a6758cb621c1f3$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $8edaab242ebda000$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_cleanCommonProps, $02a6758cb621c1f3$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "input", {
        "input-container": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $ltooA.fg)("platform_do_not_clear_input_for_multiselect")) return /*#__PURE__*/ $acw62.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $02a6758cb621c1f3$var$inputStyles.root,
            isDisabled && $02a6758cb621c1f3$var$inputStyles.disabled,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-Input")
        ]),
        "data-value": value || "",
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, "-input")
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $acw62.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $02a6758cb621c1f3$var$inputStylesOld.root,
            isDisabled && $02a6758cb621c1f3$var$inputStylesOld.disabled,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-Input")
        ]),
        "data-value": value || "",
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, "-input")
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$02a6758cb621c1f3$export$2e2bcd8739ae039 = $02a6758cb621c1f3$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");

var $c320044182bcf49b$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $c320044182bcf49b$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "menu", {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $c320044182bcf49b$var$menuStyles.root,
            $c320044182bcf49b$var$menuStyles[placement],
            (0, $ltooA.fg)("platform-dst-shape-theme-default") && $c320044182bcf49b$var$menuStyles.rootT26Shape,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(xcss, className, "-menu")
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c320044182bcf49b$export$2e2bcd8739ae039 = $c320044182bcf49b$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");



function $373cab6d65000c13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $373cab6d65000c13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $373cab6d65000c13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $373cab6d65000c13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $373cab6d65000c13$var$menuListStyles = null;
var $373cab6d65000c13$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-MenuList")
        ]),
        style: $373cab6d65000c13$var$_objectSpread($373cab6d65000c13$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");


var $bv4qN = parcelRequire("bv4qN");

var $acw62 = parcelRequire("acw62");
var $82c9335403e11973$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $82c9335403e11973$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($82c9335403e11973$var$HasTextAncestorContext);
};
var $82c9335403e11973$export$ae933c6cbe5643ad = $82c9335403e11973$var$HasTextAncestorContext.Provider;



var $acw62 = parcelRequire("acw62");
var $9f5859118b4bbb24$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $9f5859118b4bbb24$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($9f5859118b4bbb24$export$1ca2a26fecb070ae);
};
$9f5859118b4bbb24$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $d36d131233eddfd5$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $d36d131233eddfd5$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $9f5859118b4bbb24$export$1aeb4f6b93c4540d)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($d36d131233eddfd5$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $d36d131233eddfd5$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $d36d131233eddfd5$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pwu06",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $d36d131233eddfd5$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $d36d131233eddfd5$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $d36d131233eddfd5$var$textColorMap = {
    "color.text": "_syazi7uo",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syazp1lv",
    "color.text.accent.orange.bolder": "_syaz7i1p",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syaz16jw",
    "color.text.accent.blue.bolder": "_syaz1kyx",
    "color.text.accent.purple": "_syazqmo9",
    "color.text.accent.purple.bolder": "_syaz1mn1",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1sqi",
    "color.text.accent.gray.bolder": "_syaz1tmo",
    "color.text.disabled": "_syaz1gmx",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syaz6x5g",
    "color.text.brand": "_syaz1oa5",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syaz1xn9",
    "color.text.warning.inverse": "_syaz1yd3",
    "color.text.success": "_syazgsak",
    "color.text.discovery": "_syazdv2p",
    "color.text.information": "_syazu3tg",
    "color.text.subtlest": "_syaz1rpy",
    "color.text.subtle": "_syazazsu",
    "color.link": "_syaz13af",
    "color.link.pressed": "_syaz12zz",
    "color.link.visited": "_syaz1ra0",
    "color.link.visited.pressed": "_syaz17z1"
};
var $d36d131233eddfd5$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $d36d131233eddfd5$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $bv4qN.default)($d36d131233eddfd5$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $82c9335403e11973$export$9322276ec105d055)();
    var color = $d36d131233eddfd5$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $acw62.createElement(Component, {
        id: id,
        className: (0, $0f2bf88a36aa71fe$export$2e2bcd8739ae039)([
            $d36d131233eddfd5$var$styles.root,
            size && $d36d131233eddfd5$var$fontSizeMap[size],
            color && $d36d131233eddfd5$var$textColorMap[color],
            maxLines && $d36d131233eddfd5$var$styles.truncation,
            maxLines === 1 && $d36d131233eddfd5$var$styles.breakAll,
            align && $d36d131233eddfd5$var$styles["textAlign.".concat(align)],
            weight && $d36d131233eddfd5$var$fontWeightMap[weight],
            Component === "em" && $d36d131233eddfd5$var$styles["as.em"],
            Component === "strong" && $d36d131233eddfd5$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $acw62.createElement((0, $82c9335403e11973$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $d36d131233eddfd5$export$2e2bcd8739ae039 = $d36d131233eddfd5$var$Text;



var $917d6738db7047d1$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $917d6738db7047d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $917d6738db7047d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $917d6738db7047d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $917d6738db7047d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $917d6738db7047d1$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $917d6738db7047d1$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? "Loading..." : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $917d6738db7047d1$var$_excluded);
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)($917d6738db7047d1$var$_objectSpread($917d6738db7047d1$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-LoadingMessage")
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $acw62.createElement((0, $d36d131233eddfd5$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");




var $e34f6bee63610cdd$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $e34f6bee63610cdd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e34f6bee63610cdd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e34f6bee63610cdd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e34f6bee63610cdd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e34f6bee63610cdd$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $e34f6bee63610cdd$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? "No options" : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $e34f6bee63610cdd$var$_excluded);
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)($e34f6bee63610cdd$var$_objectSpread($e34f6bee63610cdd$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-NoOptionsMessage")
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $acw62.createElement((0, $d36d131233eddfd5$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");




var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
var $f424f34066fe5ad6$export$e001f626511a0ead = /*#__PURE__*/ (0, $acw62.createContext)(null);


function $76d5f6a880a3febe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76d5f6a880a3febe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76d5f6a880a3febe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76d5f6a880a3febe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $76d5f6a880a3febe$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $76d5f6a880a3febe$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $76d5f6a880a3febe$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $76d5f6a880a3febe$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)($76d5f6a880a3febe$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $76d5f6a880a3febe$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $acw62.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $acw62.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)($76d5f6a880a3febe$var$_objectSpread($76d5f6a880a3febe$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $76d5f6a880a3febe$var$menuPortalStyles.root,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-MenuPortal")
        ]),
        ref: setMenuPortalElement,
        style: $76d5f6a880a3febe$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            "--menu-left": "".concat(computedPosition.rect.left, "px"),
            "--menu-position": menuPosition,
            "--menu-top": "".concat(computedPosition.offset, "px"),
            "--menu-width": "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $acw62.createElement((0, $f424f34066fe5ad6$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $2f438cde82521d36$var$ATOMIC_GROUP_LENGTH = 5;
function $2f438cde82521d36$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $2f438cde82521d36$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $6Bvm3 = parcelRequire("6Bvm3");

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $f5f067dbcb3ed598$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5f067dbcb3ed598$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5f067dbcb3ed598$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5f067dbcb3ed598$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f5f067dbcb3ed598$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f5f067dbcb3ed598$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $f5f067dbcb3ed598$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f5f067dbcb3ed598$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $f5f067dbcb3ed598$var$_objectSpread($f5f067dbcb3ed598$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $86c4fe3b90be0be2$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $86c4fe3b90be0be2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $86c4fe3b90be0be2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($86c4fe3b90be0be2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $86c4fe3b90be0be2$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $86c4fe3b90be0be2$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $86c4fe3b90be0be2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $86c4fe3b90be0be2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $86c4fe3b90be0be2$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $86c4fe3b90be0be2$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $f5f067dbcb3ed598$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $ab0ffb22dccf9e78$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};


function $90b57e6ed9866528$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ab0ffb22dccf9e78$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $86c4fe3b90be0be2$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $624b3091c5b645e0$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


var $9db4b9d521157359$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $90b57e6ed9866528$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $624b3091c5b645e0$export$1d27a74659855e44)(method);
    var payloadRef = (0, $624b3091c5b645e0$export$1d27a74659855e44)(payload);
    return (0, $acw62.useCallback)(function() {
        var pload = typeof payloadRef.current === "function" ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};



var $41YNz = parcelRequire("41YNz");
function $9c27926e5513487f$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") ref.current = value;
        });
    };
}


/**
 * An empty function which does nothing.
 */ function $e9638e34f36c5e23$export$2e2bcd8739ae039() {}


/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

/* badge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");

var $ltooA = parcelRequire("ltooA");

/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");

function $118855c3cbcb7085$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $118855c3cbcb7085$export$4b844743568d5983(value, max) {
    var safeValue = $118855c3cbcb7085$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $118855c3cbcb7085$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $118855c3cbcb7085$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $118855c3cbcb7085$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $118855c3cbcb7085$var$getSafeValue(value);
    var safeMax = $118855c3cbcb7085$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


var $5d412ca2edbf06a1$export$d21bba0569254935 = {
    added: "success",
    removed: "danger",
    default: "neutral",
    primary: "information",
    primaryInverted: "inverse",
    important: "danger",
    warning: "warning",
    discovery: "discovery",
    danger: "danger",
    success: "success",
    information: "information",
    inverse: "inverse",
    neutral: "neutral"
};
var $5d412ca2edbf06a1$export$16f8cc7ac3541e83 = {
    added: "added",
    removed: "removed",
    default: "default",
    primary: "primary",
    primaryInverted: "primaryInverted",
    important: "important",
    danger: "removed",
    success: "added",
    information: "primary",
    inverse: "primaryInverted",
    neutral: "default",
    warning: "default",
    discovery: "default"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $5d412ca2edbf06a1$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $5d412ca2edbf06a1$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === "number" && max ? (0, $118855c3cbcb7085$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $5d412ca2edbf06a1$var$BadgeNew = /*#__PURE__*/ (0, $acw62.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "neutral" : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $9dvtP.default)([
            $5d412ca2edbf06a1$var$stylesNew.root,
            $5d412ca2edbf06a1$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $d36d131233eddfd5$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $5d412ca2edbf06a1$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $5d412ca2edbf06a1$export$2e2bcd8739ae039 = $5d412ca2edbf06a1$var$BadgeNew;



/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $c13f1f6e21bef1c2$var$neutral300 = "#DDDEE1";
var $c13f1f6e21bef1c2$var$red300 = "#FD9891";
var $c13f1f6e21bef1c2$var$blue300 = "#8FB8F6";
var $c13f1f6e21bef1c2$var$neutral1000 = "#292A2E";
var $c13f1f6e21bef1c2$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $c13f1f6e21bef1c2$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === "number" && typeof max === "number" ? (0, $118855c3cbcb7085$export$4b844743568d5983)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $c13f1f6e21bef1c2$var$Badge = /*#__PURE__*/ (0, $acw62.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        // Map old appearance names to new ones
        var newAppearance = (0, $5d412ca2edbf06a1$export$d21bba0569254935)[appearance];
        return /*#__PURE__*/ $acw62.createElement((0, $5d412ca2edbf06a1$export$2e2bcd8739ae039), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $5d412ca2edbf06a1$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $9dvtP.default)([
            $c13f1f6e21bef1c2$var$styles.root,
            $c13f1f6e21bef1c2$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $d36d131233eddfd5$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $c13f1f6e21bef1c2$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $c13f1f6e21bef1c2$export$2e2bcd8739ae039 = $c13f1f6e21bef1c2$var$Badge;





var $3p9rK = parcelRequire("3p9rK");

var $fUHKi = parcelRequire("fUHKi");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");




var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");
var $da2889b2c144c6d5$export$4ef52930e33717cd = "data-theme";
var $da2889b2c144c6d5$export$cb374d25ded7f6ab = "data-subtree-theme";
var $da2889b2c144c6d5$export$a00eac3f8684bcd0 = "data-color-mode";
var $da2889b2c144c6d5$export$2112803007239c61 = "data-contrast-mode";
var $da2889b2c144c6d5$export$352e418ed5b6193a = "data-custom-theme";
var $da2889b2c144c6d5$export$6f0c6fb8c80fcc92 = "ds";
var $da2889b2c144c6d5$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $da2889b2c144c6d5$export$dddac1532e822863 = "--".concat($da2889b2c144c6d5$export$6f0c6fb8c80fcc92, "-token-not-found");
var $da2889b2c144c6d5$export$9d7b58831ae93caa = "--".concat($da2889b2c144c6d5$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $693d21b965c29ca0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $693d21b965c29ca0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $693d21b965c29ca0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $693d21b965c29ca0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $693d21b965c29ca0$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $693d21b965c29ca0$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $693d21b965c29ca0$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $693d21b965c29ca0$export$632685d741f3dbbf = $693d21b965c29ca0$var$_objectSpread($693d21b965c29ca0$var$_objectSpread({}, $693d21b965c29ca0$export$958d0ae7f2977ae4), $693d21b965c29ca0$export$d2dc61f58390201c);
var $693d21b965c29ca0$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $693d21b965c29ca0$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $693d21b965c29ca0$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #1E1F2129)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $693d21b965c29ca0$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #F0F1F2)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #DDDEE1)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #F0F1F2)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #DDDEE1)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #F0F1F2)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #DDDEE1)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F8F8F8)"
};
var $693d21b965c29ca0$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #0B120E24)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #E2483D)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #E06C00)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #B38600)",
    "color.border.accent.green": "var(--ds-border-accent-green, #22A06B)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #2898BD)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #357DE8)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #AF59E1)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #7D818A)",
    "color.border.disabled": "var(--ds-border-disabled, #0515240F)",
    "color.border.focused": "var(--ds-border-focused, #4688EC)",
    "color.border.input": "var(--ds-border-input, #8C8F97)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #1868DB)",
    "color.border.brand": "var(--ds-border-brand, #1868DB)",
    "color.border.danger": "var(--ds-border-danger, #E2483D)",
    "color.border.warning": "var(--ds-border-warning, #E06C00)",
    "color.border.success": "var(--ds-border-success, #6A9A23)",
    "color.border.discovery": "var(--ds-border-discovery, #AF59E1)",
    "color.border.information": "var(--ds-border-information, #357DE8)",
    "color.border.bold": "var(--ds-border-bold, #7D818A)"
};
var $693d21b965c29ca0$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FFECEB)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FFD5D2)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #F87168)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #C9372C)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #872821)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #FCA700)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #BD5B00)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #F5E989)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #EED12B)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #946F00)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #BAF3DB)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #4BCE97)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #1F845A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #227D9B)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #669DF1)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #1868DB)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #EED7FC)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #C97CF4)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #964AC0)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #8C8F97)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #6B6E76)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    "color.background.disabled": "var(--ds-background-disabled, #17171708)",
    "color.background.input": "var(--ds-background-input, #FFFFFF)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #F8F8F8)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #0515240F)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #0B120E24)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #080F214A)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, #00000000)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #292A2E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #505258)",
    "color.background.selected": "var(--ds-background-selected, #E9F2FE)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #CFE1FD)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #8FB8F6)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #1868DB)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #1558BC)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #123263)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #E9F2FE)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #1868DB)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #1558BC)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #144794)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #1C2B42)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #123263)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #144794)",
    "color.background.danger": "var(--ds-background-danger, #FFECEB)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFD5D2)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FFB8B2)",
    "color.background.danger.subtler": "var(--ds-background-danger-subtler, #FFD5D2)",
    "color.background.danger.subtler.hovered": "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    "color.background.danger.subtler.pressed": "var(--ds-background-danger-subtler-pressed, #FD9891)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #C9372C)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #AE2E24)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #872821)",
    "color.background.warning": "var(--ds-background-warning, #FFF5DB)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FCE4A6)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FBD779)",
    "color.background.warning.subtler": "var(--ds-background-warning-subtler, #FCE4A6)",
    "color.background.warning.subtler.hovered": "var(--ds-background-warning-subtler-hovered, #FBD779)",
    "color.background.warning.subtler.pressed": "var(--ds-background-warning-subtler-pressed, #FBC828)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FBC828)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FCA700)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #F68909)",
    "color.background.success": "var(--ds-background-success, #EFFFD6)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #D3F1A7)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #BDE97C)",
    "color.background.success.subtler": "var(--ds-background-success-subtler, #D3F1A7)",
    "color.background.success.subtler.hovered": "var(--ds-background-success-subtler-hovered, #BDE97C)",
    "color.background.success.subtler.pressed": "var(--ds-background-success-subtler-pressed, #B3DF72)",
    "color.background.success.bold": "var(--ds-background-success-bold, #5B7F24)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #4C6B1F)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #3F5224)",
    "color.background.discovery": "var(--ds-background-discovery, #F8EEFE)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #EED7FC)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #E3BDFA)",
    "color.background.discovery.subtler": "var(--ds-background-discovery-subtler, #EED7FC)",
    "color.background.discovery.subtler.hovered": "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    "color.background.discovery.subtler.pressed": "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #964AC0)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #803FA5)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #673286)",
    "color.background.information": "var(--ds-background-information, #E9F2FE)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #CFE1FD)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #ADCBFB)",
    "color.background.information.subtler": "var(--ds-background-information-subtler, #CFE1FD)",
    "color.background.information.subtler.hovered": "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    "color.background.information.subtler.pressed": "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    "color.background.information.bold": "var(--ds-background-information-bold, #1868DB)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #1558BC)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #144794)",
    "color.blanket": "var(--ds-blanket, #050C1F75)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #0515240F)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #17171708)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #F0F1F2)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #DDDEE1)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #F0F1F2)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #DDDEE1)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #F0F1F2)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #DDDEE1)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F8F8F8)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $693d21b965c29ca0$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #292A2E)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #AE2E24)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #5D1F1A)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #9E4C00)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #693200)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #7F5F01)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #533F04)",
    "color.text.accent.green": "var(--ds-text-accent-green, #216E4E)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #164B35)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #206A83)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #164555)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #1558BC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #123263)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #803FA5)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #48245D)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #943D73)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #50253F)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505258)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #1E1F21)",
    "color.text.disabled": "var(--ds-text-disabled, #080F214A)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #1868DB)",
    "color.text.brand": "var(--ds-text-brand, #1868DB)",
    "color.text.danger": "var(--ds-text-danger, #AE2E24)",
    "color.text.danger.bolder": "var(--ds-text-danger-bolder, #5D1F1A)",
    "color.text.warning": "var(--ds-text-warning, #9E4C00)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #292A2E)",
    "color.text.warning.bolder": "var(--ds-text-warning-bolder, #693200)",
    "color.text.success": "var(--ds-text-success, #4C6B1F)",
    "color.text.success.bolder": "var(--ds-text-success-bolder, #37471F)",
    "color.text.discovery": "var(--ds-text-discovery, #803FA5)",
    "color.text.discovery.bolder": "var(--ds-text-discovery-bolder, #48245D)",
    "color.text.information": "var(--ds-text-information, #1558BC)",
    "color.text.information.bolder": "var(--ds-text-information-bolder, #123263)",
    "color.text.subtlest": "var(--ds-text-subtlest, #6B6E76)",
    "color.text.subtle": "var(--ds-text-subtle, #505258)",
    "color.link": "var(--ds-link, #1868DB)",
    "color.link.pressed": "var(--ds-link-pressed, #1558BC)",
    "color.link.visited": "var(--ds-link-visited, #803FA5)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #48245D)"
};
var $693d21b965c29ca0$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #292A2E)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #C9372C)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #E06C00)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #B38600)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #22A06B)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #2898BD)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #357DE8)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #AF59E1)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #7D818A)",
    "color.icon.disabled": "var(--ds-icon-disabled, #080F214A)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #1868DB)",
    "color.icon.brand": "var(--ds-icon-brand, #1868DB)",
    "color.icon.danger": "var(--ds-icon-danger, #C9372C)",
    "color.icon.warning": "var(--ds-icon-warning, #E06C00)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #292A2E)",
    "color.icon.success": "var(--ds-icon-success, #6A9A23)",
    "color.icon.discovery": "var(--ds-icon-discovery, #AF59E1)",
    "color.icon.information": "var(--ds-icon-information, #357DE8)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B6E76)",
    "color.icon.subtle": "var(--ds-icon-subtle, #505258)"
};
var $693d21b965c29ca0$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $693d21b965c29ca0$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.selected": "var(--ds-border-width-selected, 2px)",
    "border.width.focused": "var(--ds-border-width-focused, 2px)"
};
var $693d21b965c29ca0$export$3c0a6c3e64bb180d = {
    "radius.xsmall": "var(--ds-radius-xsmall, 2px)",
    "radius.small": "var(--ds-radius-small, 3px)",
    "radius.medium": "var(--ds-radius-medium, 6px)",
    "radius.large": "var(--ds-radius-large, 8px)",
    "radius.xlarge": "var(--ds-radius-xlarge, 12px)",
    "radius.xxlarge": "var(--ds-radius-xxlarge, 16px)",
    "radius.full": "var(--ds-radius-full, 9999px)",
    "radius.tile": "var(--ds-radius-tile, 25%)"
};
var $693d21b965c29ca0$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    // @deprecated
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 653 20px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 653 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 653 32px/36px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 653 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $693d21b965c29ca0$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 653)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $693d21b965c29ca0$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $693d21b965c29ca0$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $693d21b965c29ca0$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $693d21b965c29ca0$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $693d21b965c29ca0$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $693d21b965c29ca0$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $693d21b965c29ca0$export$e615f061ca585a6c = $693d21b965c29ca0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $693d21b965c29ca0$export$ca0f9c2de39ffed7(spacingProperty, $693d21b965c29ca0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $693d21b965c29ca0$export$bf46c3f9eeafc71f = $693d21b965c29ca0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $693d21b965c29ca0$export$ca0f9c2de39ffed7(spacingProperty, $693d21b965c29ca0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $693d21b965c29ca0$export$e7af83bafe7f9e63 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("backgroundColor", $693d21b965c29ca0$export$d1d79bf68ac056bd);
var $693d21b965c29ca0$export$3a1bcba60b23d7f0 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("color", $693d21b965c29ca0$export$8473307aa00d6ea1);
var $693d21b965c29ca0$export$45f3f4fe16f9f7d5 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("fontWeight", $693d21b965c29ca0$export$303e322c6b1ed114);
var $693d21b965c29ca0$export$68cc305da27dbaa4 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("fontFamily", $693d21b965c29ca0$export$3c7e9587132614b4);
var $693d21b965c29ca0$export$128f10c238242f83 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("font", $693d21b965c29ca0$export$6ffa317d5e70375);
var $693d21b965c29ca0$export$219d364c0da35ae4 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("font", $693d21b965c29ca0$export$236bfe3a33ef1292);
var $693d21b965c29ca0$export$38845ca010b93505 = $693d21b965c29ca0$export$ca0f9c2de39ffed7("fontWeight", $693d21b965c29ca0$export$855cfd311192d666);
var $693d21b965c29ca0$export$ff257d957d48c421 = $693d21b965c29ca0$export$ca0f9c2de39ffed7((0, $da2889b2c144c6d5$export$9d7b58831ae93caa), $693d21b965c29ca0$export$41a358c9c2356760);
var $693d21b965c29ca0$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $693d21b965c29ca0$export$41a358c9c2356760[color] !== undefined;
};
var $693d21b965c29ca0$export$7001ce64d9ff7c7f = $693d21b965c29ca0$export$ca0f9c2de39ffed7("font", $693d21b965c29ca0$export$b805719bc8cb376);



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");


var $hPtJY = parcelRequire("hPtJY");
function $0e6465d031f7df66$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0e6465d031f7df66$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0e6465d031f7df66$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0e6465d031f7df66$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0e6465d031f7df66$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0e6465d031f7df66$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0e6465d031f7df66$export$9a199fbafee0014e = {
    backgroundColor: (0, $693d21b965c29ca0$export$d1d79bf68ac056bd),
    blockSize: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderBottomColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderLeftColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $693d21b965c29ca0$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    borderWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    bottom: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    boxShadow: (0, $693d21b965c29ca0$export$7aff6e7ba39bb774),
    color: (0, $693d21b965c29ca0$export$8473307aa00d6ea1),
    columnGap: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    font: (0, $693d21b965c29ca0$export$6ffa317d5e70375),
    fontFamily: (0, $693d21b965c29ca0$export$3c7e9587132614b4),
    fontWeight: (0, $693d21b965c29ca0$export$303e322c6b1ed114),
    gap: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    height: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    inlineSize: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    inset: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    insetBlock: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    insetBlockEnd: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    insetBlockStart: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    insetInline: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    insetInlineEnd: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    insetInlineStart: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    left: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    margin: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginBlock: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginBlockEnd: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginBlockStart: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginBottom: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginInline: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginInlineEnd: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginInlineStart: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginLeft: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginRight: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    marginTop: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    maxBlockSize: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    maxHeight: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    maxWidth: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    minBlockSize: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    minHeight: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    minInlineSize: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    minWidth: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    opacity: (0, $693d21b965c29ca0$export$daf94a976c798b4f),
    outlineColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac),
    outlineOffset: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    outlineWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8),
    padding: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingBlock: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingBottom: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingInline: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingLeft: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingRight: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    paddingTop: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    right: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    rowGap: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4),
    top: (0, $693d21b965c29ca0$export$632685d741f3dbbf),
    width: (0, $693d21b965c29ca0$export$6ccdbebca2ee545f),
    zIndex: (0, $693d21b965c29ca0$export$b5f31a7e431d2eab)
};
var $0e6465d031f7df66$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $0e6465d031f7df66$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $0e6465d031f7df66$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $0e6465d031f7df66$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $0e6465d031f7df66$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($0e6465d031f7df66$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $0e6465d031f7df66$var$safeSelectors.test(key)) {
            styleObj[key] = $0e6465d031f7df66$var$_transformStyles(value);
            return;
        }
        if ($0e6465d031f7df66$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($0e6465d031f7df66$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $0e6465d031f7df66$export$9a199fbafee0014e)) return;
        var tokenValue = $0e6465d031f7df66$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $0e6465d031f7df66$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $0e6465d031f7df66$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $0e6465d031f7df66$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $0e6465d031f7df66$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $0e6465d031f7df66$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $0e6465d031f7df66$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$0e6465d031f7df66$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $0e6465d031f7df66$export$f6c783d06584602c(style) {
    return $0e6465d031f7df66$var$baseXcss(style);
}


var $d8692590f6ecbc96$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d8692590f6ecbc96$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d8692590f6ecbc96$var$focusRingStyles = (0, $dnfL5.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $693d21b965c29ca0$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $693d21b965c29ca0$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $693d21b965c29ca0$export$e1b83c5210c471b8)["border.width.focused"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $693d21b965c29ca0$export$e1b83c5210c471b8)["border.width"], " solid")
        }
    }
});
var $d8692590f6ecbc96$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $d8692590f6ecbc96$var$enabledStyles = (0, $dnfL5.css)({
    cursor: "pointer"
});
var $d8692590f6ecbc96$var$disabledStyles = (0, $dnfL5.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d8692590f6ecbc96$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5bd1c65285ffb8ce$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d8692590f6ecbc96$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $2601e54ec301158e$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $969273620ec8fe3b$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $d8692590f6ecbc96$var$_excluded2);
    var resolvedStyles = (0, $0e6465d031f7df66$export$a9c84988c8f81f2d)(xcss);
    return (0, $dnfL5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d8692590f6ecbc96$var$baseStyles,
            $d8692590f6ecbc96$var$focusRingStyles,
            isDisabled ? $d8692590f6ecbc96$var$disabledStyles : $d8692590f6ecbc96$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $693d21b965c29ca0$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $693d21b965c29ca0$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $693d21b965c29ca0$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $693d21b965c29ca0$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $693d21b965c29ca0$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $693d21b965c29ca0$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $693d21b965c29ca0$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $693d21b965c29ca0$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $d8692590f6ecbc96$export$2e2bcd8739ae039 = $d8692590f6ecbc96$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $63e5d15b650ac9c1$var$ATOMIC_GROUP_LENGTH = 5;
function $63e5d15b650ac9c1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $63e5d15b650ac9c1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $64ba798d41ff26ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


// Reds
var $77661fe540f01d52$export$4b84fd0e2c617bd = "#FFEBE6";
var $77661fe540f01d52$export$b34b069eff244586 = "#FFBDAD";
var $77661fe540f01d52$export$be802dd0d8b57f35 = "#FF8F73";
var $77661fe540f01d52$export$60847d42f9da92a6 = "#FF7452";
var $77661fe540f01d52$export$4a7404f376229999 = "#FF5630";
var $77661fe540f01d52$export$2010d0fb4295b346 = "#DE350B";
var $77661fe540f01d52$export$2837b5a1a71d5c02 = "#BF2600";
var $77661fe540f01d52$export$8d9596b529bbb9cf = "#FFFAE6";
var $77661fe540f01d52$export$41060a744ab0b7ae = "#FFF0B3";
var $77661fe540f01d52$export$1cc05bbbf340e559 = "#FFE380";
var $77661fe540f01d52$export$5aae31392d72caaa = "#FFC400";
var $77661fe540f01d52$export$c6930421db9fa514 = "#FFAB00";
var $77661fe540f01d52$export$59619663aa6500fb = "#FF991F";
var $77661fe540f01d52$export$874739ea9e379ab6 = "#FF8B00";
var $77661fe540f01d52$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $77661fe540f01d52$export$69a3bf21b9686c2b = "#ABF5D1";
var $77661fe540f01d52$export$afbce1382ec95f73 = "#79F2C0";
var $77661fe540f01d52$export$747d86715d4175de = "#57D9A3";
var $77661fe540f01d52$export$940e1f69e873f202 = "#36B37E";
var $77661fe540f01d52$export$a49394138f7b8e85 = "#00875A";
var $77661fe540f01d52$export$6fa04827ac68a4fb = "#006644";
var $77661fe540f01d52$export$226de0355ed012f8 = "#DEEBFF";
var $77661fe540f01d52$export$8c13c2ee36917869 = "#B3D4FF";
var $77661fe540f01d52$export$ecfc1dff386a3e7a = "#4C9AFF";
var $77661fe540f01d52$export$215b7063051591f1 = "#2684FF";
var $77661fe540f01d52$export$e62e8919cca44969 = "#0065FF";
var $77661fe540f01d52$export$b3de0ae08da2ce64 = "#0052CC";
var $77661fe540f01d52$export$a6ee3d71bc067634 = "#0747A6";
var $77661fe540f01d52$export$67f15409e87642a1 = "#669DF1";
var $77661fe540f01d52$export$f0539dbc42dbb067 = "#8FB8F6";
var $77661fe540f01d52$export$363e4475840015bb = "#EAE6FF";
var $77661fe540f01d52$export$4b0a4417ed59760f = "#C0B6F2";
var $77661fe540f01d52$export$6011520a64d9a187 = "#998DD9";
var $77661fe540f01d52$export$a7175d4e9206bc80 = "#8777D9";
var $77661fe540f01d52$export$b48405b95304b5a1 = "#6554C0";
var $77661fe540f01d52$export$c71e4279dd54a18d = "#5243AA";
var $77661fe540f01d52$export$147899de772240ec = "#403294";
var $77661fe540f01d52$export$2cf711fe14c66f06 = "#E6FCFF";
var $77661fe540f01d52$export$7a8f4d33f6f9772c = "#B3F5FF";
var $77661fe540f01d52$export$776c9c497ef08533 = "#79E2F2";
var $77661fe540f01d52$export$69cb3ca10c1e330e = "#00C7E6";
var $77661fe540f01d52$export$9dc1ef0f3f48059b = "#00B8D9";
var $77661fe540f01d52$export$7c835c78b6fcdef8 = "#00A3BF";
var $77661fe540f01d52$export$6036577f95c3877e = "#008DA6";
var $77661fe540f01d52$export$29a4f05edc054374 = "#FFFFFF";
var $77661fe540f01d52$export$e655ef011c4aa1a2 = "#FAFBFC";
var $77661fe540f01d52$export$9fdfb749e33cdf97 = "#F4F5F7";
var $77661fe540f01d52$export$3e51e8f1440314ba = "#EBECF0";
var $77661fe540f01d52$export$1ce2d1575d444ceb = "#DFE1E6";
var $77661fe540f01d52$export$8754fc7e6d8b3000 = "#C1C7D0";
var $77661fe540f01d52$export$c2e91cbeada39b8b = "#B3BAC5";
var $77661fe540f01d52$export$5f71e19f3a7ad9de = "#A5ADBA";
var $77661fe540f01d52$export$eaa8c8a70ac22806 = "#97A0AF";
var $77661fe540f01d52$export$7c87d337fb91a97d = "#8993A4";
var $77661fe540f01d52$export$d6447c357493214f = "#7A869A";
var $77661fe540f01d52$export$f563ee71e9ee74cd = "#6B778C";
var $77661fe540f01d52$export$e2ef2124cf4024b1 = "#5E6C84";
var $77661fe540f01d52$export$eece5f492e429f08 = "#505F79";
var $77661fe540f01d52$export$c39c0fe0f26207ae = "#42526E";
var $77661fe540f01d52$export$7090862dc3038a9f = "#344563";
var $77661fe540f01d52$export$ad0bacf983b7ddaa = "#253858";
var $77661fe540f01d52$export$7d61b15e0da132af = "#172B4D";
var $77661fe540f01d52$export$fbda843f0a27fe96 = "#091E42";
var $77661fe540f01d52$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $77661fe540f01d52$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $77661fe540f01d52$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $77661fe540f01d52$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $77661fe540f01d52$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $77661fe540f01d52$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $77661fe540f01d52$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $77661fe540f01d52$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $77661fe540f01d52$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $77661fe540f01d52$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $77661fe540f01d52$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $77661fe540f01d52$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $77661fe540f01d52$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $77661fe540f01d52$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $77661fe540f01d52$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $77661fe540f01d52$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $77661fe540f01d52$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $77661fe540f01d52$export$2f6319cf7d736c2a = "#E6EDFA";
var $77661fe540f01d52$export$95126bc8884d6634 = "#DCE5F5";
var $77661fe540f01d52$export$8338d8c35d44ff1 = "#CED9EB";
var $77661fe540f01d52$export$5368d76ae4fbbda7 = "#B8C7E0";
var $77661fe540f01d52$export$9f0a771d16ec8d36 = "#ABBBD6";
var $77661fe540f01d52$export$abcf8c38338b4aa5 = "#9FB0CC";
var $77661fe540f01d52$export$97e81faa16a182c7 = "#8C9CB8";
var $77661fe540f01d52$export$bfe21c59123ecf33 = "#7988A3";
var $77661fe540f01d52$export$ee82aa2ea6a1558 = "#67758F";
var $77661fe540f01d52$export$682927c6ed76be02 = "#56637A";
var $77661fe540f01d52$export$91fd9994c5be9757 = "#455166";
var $77661fe540f01d52$export$d281fbfe3cff2df6 = "#3B475C";
var $77661fe540f01d52$export$3902c91d8b98a753 = "#313D52";
var $77661fe540f01d52$export$8e8133c1ba5845b5 = "#283447";
var $77661fe540f01d52$export$33ff357f6620b39 = "#202B3D";
var $77661fe540f01d52$export$633847cf062b69e0 = "#1B2638";
var $77661fe540f01d52$export$9776a6e503bdbf76 = "#121A29";
var $77661fe540f01d52$export$6c813d5160dff5db = "#0E1624";
var $77661fe540f01d52$export$3d4f271a500072a = "#0D1424";
var $77661fe540f01d52$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $77661fe540f01d52$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $77661fe540f01d52$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $77661fe540f01d52$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $77661fe540f01d52$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $77661fe540f01d52$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $77661fe540f01d52$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $77661fe540f01d52$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $77661fe540f01d52$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $77661fe540f01d52$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $77661fe540f01d52$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $77661fe540f01d52$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $77661fe540f01d52$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $77661fe540f01d52$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $77661fe540f01d52$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $77661fe540f01d52$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $77661fe540f01d52$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $77661fe540f01d52$export$d2adc5dedf09fced = "#292A2E";
var $77661fe540f01d52$export$f51762073d2bb381 = "#94C748";
var $77661fe540f01d52$export$95e26d54def96891 = "#B3DF72";


var $9746bf031f459403$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $afb39bdef66bde81$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $77661fe540f01d52$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $77661fe540f01d52$export$29a4f05edc054374), ")");
}
var $afb39bdef66bde81$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $afb39bdef66bde81$var$loadIn = null;
var $afb39bdef66bde81$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $afb39bdef66bde81$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $afb39bdef66bde81$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $9746bf031f459403$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $afb39bdef66bde81$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $64ba798d41ff26ae$export$2e2bcd8739ae039));
    $afb39bdef66bde81$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $63e5d15b650ac9c1$export$2e2bcd8739ae039)([
            $afb39bdef66bde81$var$styles.wrapperStyles,
            $afb39bdef66bde81$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $63e5d15b650ac9c1$export$2e2bcd8739ae039)([
            $afb39bdef66bde81$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $63e5d15b650ac9c1$export$2e2bcd8739ae039)([
            $afb39bdef66bde81$var$styles.circleStyles
        ])
    })));
}));
var $afb39bdef66bde81$export$2e2bcd8739ae039 = $afb39bdef66bde81$var$Spinner;



var $acw62 = parcelRequire("acw62");
// Map lozenge colors to appropriate icon colors
var $d283a3666e1caf07$var$getIconColor = function getIconColor(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case "success":
            return "var(--ds-icon-success, #6A9A23)";
        case "warning":
            return "var(--ds-icon-warning, #E06C00)";
        case "danger":
            return "var(--ds-icon-danger, #C9372C)";
        case "information":
            return "var(--ds-icon-information, #357DE8)";
        case "neutral":
            return "var(--ds-icon-subtlest, #6B6E76)";
        case "discovery":
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case "accent-red":
            return "var(--ds-icon-accent-red, #C9372C)";
        case "accent-orange":
            return "var(--ds-icon-accent-orange, #E06C00)";
        case "accent-yellow":
            return "var(--ds-icon-accent-yellow, #B38600)";
        case "accent-lime":
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case "accent-green":
            return "var(--ds-icon-accent-green, #22A06B)";
        case "accent-teal":
            return "var(--ds-icon-accent-teal, #2898BD)";
        case "accent-blue":
            return "var(--ds-icon-accent-blue, #357DE8)";
        case "accent-purple":
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case "accent-magenta":
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case "accent-gray":
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $d283a3666e1caf07$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $d283a3666e1caf07$var$getIconColor(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $d283a3666e1caf07$export$2e2bcd8739ae039 = $d283a3666e1caf07$export$32ff197eed95e568;


// Map legacy appearance to new color values
var $606fedb7fd465305$var$legacyAppearanceMap = {
    default: "neutral",
    removed: "danger",
    inprogress: "information",
    new: "discovery",
    moved: "warning"
};
var $606fedb7fd465305$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "neutral";
    if (appearance.startsWith("accent-")) return appearance;
    return (_legacyAppearanceMap$ = $606fedb7fd465305$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};
var $606fedb7fd465305$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith("accent-");
    var category = isAccent ? "accent" : "semantic";
    var key = isAccent ? resolvedColor.replace("accent-", "") : resolvedColor;
    return {
        category: category,
        key: key
    };
};


function $f9031c181d477203$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f9031c181d477203$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f9031c181d477203$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f9031c181d477203$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $f9031c181d477203$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    "accent-red": "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    "accent-orange": "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    "accent-yellow": "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    "accent-lime": "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    "accent-green": "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    "accent-teal": "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    "accent-blue": "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    "accent-purple": "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    "accent-magenta": "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    "accent-gray": "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $f9031c181d477203$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    "metric.semantic.success": "_1bn8d6jc _4ayg1wl5",
    "metric.semantic.warning": "_1bn8bkku _4aygzr32",
    "metric.semantic.danger": "_1bn8jkmi _4ayg1r4b",
    "metric.semantic.information": "_1bn8ar1y _4ayg1c1j",
    "metric.semantic.neutral": "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    "metric.semantic.discovery": "_1bn85usi _4ayg18vq",
    "metric.inverse": "_1bn8vuon _4aygvuon",
    "semantic.success": "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    "semantic.warning": "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    "semantic.danger": "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    "semantic.information": "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    "semantic.neutral": "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    "semantic.discovery": "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    "accent.red": "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    "accent.orange": "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    "accent.yellow": "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    "accent.lime": "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    "accent.green": "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    "accent.teal": "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    "accent.blue": "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    "accent.purple": "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    "accent.magenta": "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    "accent.gray": "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    "interactive.semantic.success": "_irr31r82 _1di6d6jc",
    "interactive.semantic.warning": "_irr31yx4 _1di6bkku",
    "interactive.semantic.danger": "_irr370oi _1di6jkmi",
    "interactive.semantic.information": "_irr315aw _1di6ar1y",
    "interactive.semantic.neutral": "_irr3plhp _1di61gdz",
    "interactive.semantic.discovery": "_irr3rumk _1di65usi",
    "interactive.accent.red": "_irr3affd _1di61j5a",
    "interactive.accent.orange": "_irr31ei0 _1di6dpo3",
    "interactive.accent.yellow": "_irr31uw7 _1di61r9w",
    "interactive.accent.lime": "_irr31gf0 _1di62kxc",
    "interactive.accent.green": "_irr31e2h _1di6ybhx",
    "interactive.accent.teal": "_irr3kwwr _1di61jb0",
    "interactive.accent.blue": "_irr3815t _1di6rwxf",
    "interactive.accent.purple": "_irr3attl _1di63nfk",
    "interactive.accent.magenta": "_irr31axx _1di642ri",
    "interactive.accent.gray": "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $f9031c181d477203$var$LozengeBase = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref["aria-controls"], ariaExpanded = _ref["aria-expanded"], ariaHaspopup = _ref["aria-haspopup"], ariaLabel = _ref["aria-label"];
    var isInteractive = typeof onClick === "function";
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $606fedb7fd465305$export$acf5d2b7dc999bda)(appearance) || "neutral";
    var _getThemeStyles = (0, $606fedb7fd465305$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === "inverse" ? "inverse" : (0, $606fedb7fd465305$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === "inverse" ? "inverse" : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith("accent-") ? "neutral" : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : "neutral";
    var metricStyleKey = resolvedTrailingMetricAppearance === "inverse" ? "metric.inverse" : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith("accent-") ? "metric.semantic.".concat((0, $606fedb7fd465305$export$a3fc04b8551e006a)(resolvedTrailingMetricAppearance).key) : "metric.semantic.neutral";
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : "100%"
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== "";
    var innerContent = /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? "100%" : undefined
        },
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $f9031c181d477203$var$styles.content,
            spacing === "spacious" && $f9031c181d477203$var$styles.contentSpacious,
            isLoading && $f9031c181d477203$var$styles.loadingContent
        ])
    }, iconBefore && /*#__PURE__*/ $acw62.createElement((0, $d283a3666e1caf07$export$2e2bcd8739ae039), {
        size: spacing === "spacious" ? "medium" : "small",
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $f9031c181d477203$var$styles.text,
            spacing === "spacious" && $f9031c181d477203$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith("accent-") && /*#__PURE__*/ $acw62.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $f9031c181d477203$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $c13f1f6e21bef1c2$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1e708aebba3cda2$exports))), {
        label: "",
        size: "small",
        color: "currentColor",
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $acw62.createElement((0, $d8692590f6ecbc96$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref,
        xcss: (0, $1b267db47313e17e$export$a274e22fb40f762e)($f9031c181d477203$var$styles.container, spacing === "spacious" && $f9031c181d477203$var$styles.containerSpacious, !isSelected && $f9031c181d477203$var$styles.iconBorderFilter, !isLoading && $f9031c181d477203$var$styles.iconBorderInteractiveFilter, $f9031c181d477203$var$styles[colorStyleKey], !isLoading && $f9031c181d477203$var$styles[interactiveStyleKey], isSelected && $f9031c181d477203$var$styles.containerSelected, hasTrailingMetric && $f9031c181d477203$var$styles.containerBadge, hasTrailingMetric && $f9031c181d477203$var$styles.containerBadgeInteractive, hasTrailingMetric && $f9031c181d477203$var$styles[metricStyleKey])
    }, isLoading && {
        "aria-busy": true,
        "aria-disabled": true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? "Loading" : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $f9031c181d477203$var$_objectSpread($f9031c181d477203$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? "oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important" : "transparent"),
            backgroundColor: isSelected ? $f9031c181d477203$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? "progress" : "pointer"
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), innerContent, isLoading && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $f9031c181d477203$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $afb39bdef66bde81$export$2e2bcd8739ae039), {
        size: spacing === "spacious" ? "small" : "xsmall",
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $acw62.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $f9031c181d477203$var$styles.container,
            spacing === "spacious" && $f9031c181d477203$var$styles.containerSpacious,
            spacing !== "spacious" && hasTrailingMetric && $f9031c181d477203$var$styles.containerBadgePadding,
            $f9031c181d477203$var$styles[colorStyleKey],
            hasTrailingMetric && $f9031c181d477203$var$styles[metricStyleKey],
            $f9031c181d477203$var$styles.iconBorderFilter,
            $f9031c181d477203$var$styles.containerBadge
        ])
    }, innerContent);
}));
var $f9031c181d477203$export$2e2bcd8739ae039 = $f9031c181d477203$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $0c67fa6d9bee0d66$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "neutral" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $acw62.createElement((0, $f9031c181d477203$export$2e2bcd8739ae039), baseProps, children);
};
$0c67fa6d9bee0d66$var$Lozenge.displayName = "Lozenge";
var $0c67fa6d9bee0d66$export$2e2bcd8739ae039 = $0c67fa6d9bee0d66$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $50c1f06236c7842c$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    "bg.bold.default": "_bfhk1fkg",
    "bg.bold.inprogress": "_bfhk1ymo",
    "bg.bold.moved": "_bfhkxmjf",
    "bg.bold.new": "_bfhkshej",
    "bg.bold.removed": "_bfhk1366",
    "bg.bold.success": "_bfhk3uhp",
    "bg.subtle.default": "_bfhksm61",
    "bg.subtle.inprogress": "_bfhksm61",
    "bg.subtle.moved": "_bfhksm61",
    "bg.subtle.new": "_bfhksm61",
    "bg.subtle.removed": "_bfhksm61",
    "bg.subtle.success": "_bfhksm61",
    "outline.subtle.default": "_12ji14je _1qu2nqa1 _12y3t94y",
    "outline.subtle.inprogress": "_12jiuisw _1qu2nqa1 _12y3t94y",
    "outline.subtle.moved": "_12jih727 _1qu2nqa1 _12y3t94y",
    "outline.subtle.new": "_12ji157s _1qu2nqa1 _12y3t94y",
    "outline.subtle.removed": "_12jia2c0 _1qu2nqa1 _12y3t94y",
    "outline.subtle.success": "_12jin0nx _1qu2nqa1 _12y3t94y",
    "text.subtle": "_syazi7uo",
    "text.bold": "_syazwwip"
};
var $50c1f06236c7842c$var$appearanceTypes = [
    "default",
    "inprogress",
    "moved",
    "new",
    "removed"
];
var $50c1f06236c7842c$var$newSemanticColors = [
    "success",
    "discovery",
    "warning",
    "danger",
    "information",
    "neutral"
];
var $50c1f06236c7842c$var$appearanceMapping = {
    neutral: "default",
    default: "default",
    information: "inprogress",
    inprogress: "inprogress",
    warning: "moved",
    moved: "moved",
    removed: "removed",
    danger: "removed",
    success: "success",
    discovery: "new",
    new: "new"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $50c1f06236c7842c$var$LegacyLozenge = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = (0, $acw62.useMemo)(function() {
        return $50c1f06236c7842c$var$appearanceTypes.includes(appearance) || $50c1f06236c7842c$var$newSemanticColors.includes(appearance) ? $50c1f06236c7842c$var$appearanceMapping[appearance] : "default";
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    return /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        "data-testid": testId,
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $50c1f06236c7842c$var$styles.container,
            $50c1f06236c7842c$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === "subtle" && $50c1f06236c7842c$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && $50c1f06236c7842c$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $50c1f06236c7842c$var$styles.text,
            (0, $ltooA.fg)("platform-lozenge-custom-letterspacing") && $50c1f06236c7842c$var$styles.customLetterspacing,
            $50c1f06236c7842c$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$50c1f06236c7842c$var$LegacyLozenge.displayName = "Lozenge";
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $50c1f06236c7842c$var$LozengeWrapper = /*#__PURE__*/ (0, $acw62.memo)(function(props) {
    if ((0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) return /*#__PURE__*/ $acw62.createElement((0, $0c67fa6d9bee0d66$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $acw62.createElement($50c1f06236c7842c$var$LegacyLozenge, props);
});
$50c1f06236c7842c$var$LozengeWrapper.displayName = "Lozenge";
var $50c1f06236c7842c$export$2e2bcd8739ae039 = $50c1f06236c7842c$var$LozengeWrapper;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $59612df65049ab16$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $59612df65049ab16$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($59612df65049ab16$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $59612df65049ab16$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $59612df65049ab16$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($59612df65049ab16$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $59612df65049ab16$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $59612df65049ab16$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $59612df65049ab16$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $59612df65049ab16$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $59612df65049ab16$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $59612df65049ab16$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $59612df65049ab16$var$childrenToArray(previousChildren);
    var current = $59612df65049ab16$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $59612df65049ab16$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $59612df65049ab16$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $ltooA.fg)("platform-dst-motion-uplift") ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $59612df65049ab16$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $59612df65049ab16$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $59612df65049ab16$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($59612df65049ab16$var$ExitingContext);
};
$59612df65049ab16$var$ExitingPersistence.displayName = "ExitingPersistence";
var $59612df65049ab16$export$2e2bcd8739ae039 = $59612df65049ab16$var$ExitingPersistence;


var $02Ztr = parcelRequire("02Ztr");
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $ad2ee7808b91ee42$export$368bacef0dacbe05 = 25;
var $ad2ee7808b91ee42$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $ad2ee7808b91ee42$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $ad2ee7808b91ee42$export$30fa1a2e62ae150c = {
    none: $ad2ee7808b91ee42$export$38b928a7167ce124.none,
    small: $ad2ee7808b91ee42$export$38b928a7167ce124.small * $ad2ee7808b91ee42$var$EXITING_MOTION_MULTIPLIER,
    medium: $ad2ee7808b91ee42$export$38b928a7167ce124.medium * $ad2ee7808b91ee42$var$EXITING_MOTION_MULTIPLIER,
    large: $ad2ee7808b91ee42$export$38b928a7167ce124.large * $ad2ee7808b91ee42$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
// Handle both browser and Node.js environments
var $051c736604f95f09$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $051c736604f95f09$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $051c736604f95f09$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $051c736604f95f09$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $051c736604f95f09$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $acw62 = parcelRequire("acw62");
var $c89cf143b55b120b$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $acw62.useRef)(null);
    var setRef = (0, $acw62.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};



var $acw62 = parcelRequire("acw62");
var $6dfdaa076e5bb4f0$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);



/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a571726c29fb0aa5$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "small" : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $c89cf143b55b120b$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $59612df65049ab16$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $051c736604f95f09$export$1775f27e7c8051ca)();
    var setTimeout = (0, $051c736604f95f09$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? "exiting" : "entering";
    (0, $6dfdaa076e5bb4f0$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: "border-box",
                willChange: "width,margin"
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: "0px",
                        margin: "0px",
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: "cubic-bezier(0.8,0,0,0.8)",
                        transitionDuration: (0, $ad2ee7808b91ee42$export$38b928a7167ce124)[duration] + "ms",
                        transitionProperty: "width,margin"
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish("exiting");
                    }, (0, $ad2ee7808b91ee42$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $a571726c29fb0aa5$export$2e2bcd8739ae039 = $a571726c29fb0aa5$var$ShrinkOut;



var $ltooA = parcelRequire("ltooA");
/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

/* shared.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");


var $ltooA = parcelRequire("ltooA");
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $bv4qN = parcelRequire("bv4qN");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $269a9492350588de$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $acw62.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $269a9492350588de$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($269a9492350588de$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $269a9492350588de$export$2e2bcd8739ae039 = $269a9492350588de$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $61f7fdf13a4108f3$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $acw62.useContext)((0, $269a9492350588de$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $61f7fdf13a4108f3$export$2e2bcd8739ae039 = $61f7fdf13a4108f3$var$useRouterLink;




var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");
function $5ce5a364148f32a0$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId().replace(/[:«»]/g, "_");
}
var $5ce5a364148f32a0$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($5ce5a364148f32a0$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $5ce5a364148f32a0$export$6ee17796e3d70de2() {
    var uid = $5ce5a364148f32a0$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}



/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $79d5c31dba16affa$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $79d5c31dba16affa$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9dvtP.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $79d5c31dba16affa$export$2e2bcd8739ae039 = $79d5c31dba16affa$var$VisuallyHidden;



var $d95af54e24914fdb$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $d95af54e24914fdb$var$_excluded2 = [
    "className"
];
var $d95af54e24914fdb$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $d95af54e24914fdb$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $d95af54e24914fdb$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d95af54e24914fdb$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5bd1c65285ffb8ce$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d95af54e24914fdb$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $2601e54ec301158e$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $5ce5a364148f32a0$export$f680877a34711e37)();
    var onClick = (0, $969273620ec8fe3b$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $d95af54e24914fdb$var$_excluded2);
    var RouterLink = (0, $61f7fdf13a4108f3$export$2e2bcd8739ae039)();
    var isExternal = typeof href === "string" && $d95af54e24914fdb$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $d95af54e24914fdb$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(href) === "object";
    (0, $bv4qN.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $acw62.createElement((0, $ec20d9ac266f0065$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $d65521e6d957d20d$export$a274e22fb40f762e)($d95af54e24914fdb$var$styles.root, $d95af54e24914fdb$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $acw62.createElement((0, $79d5c31dba16affa$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d95af54e24914fdb$var$Anchor = /*#__PURE__*/ (0, $acw62.forwardRef)($d95af54e24914fdb$var$AnchorNoRef);
var $d95af54e24914fdb$export$2e2bcd8739ae039 = $d95af54e24914fdb$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $80aeea492a73f6fa$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $80aeea492a73f6fa$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $80aeea492a73f6fa$var$baseStyles = null;
var $80aeea492a73f6fa$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhkkuup",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1gf0",
    "color.background.accent.lime.subtler.pressed": "_bfhk2kxc",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhk1jbd",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhkh0j0",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhknbir",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkaffd",
    "color.background.accent.red.subtler.pressed": "_bfhk1j5a",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1fnn",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhk1cl6",
    "color.background.accent.orange.subtlest": "_bfhkf5uh",
    "color.background.accent.orange.subtlest.hovered": "_bfhk19yr",
    "color.background.accent.orange.subtlest.pressed": "_bfhkf90x",
    "color.background.accent.orange.subtler": "_bfhk165s",
    "color.background.accent.orange.subtler.hovered": "_bfhk1ei0",
    "color.background.accent.orange.subtler.pressed": "_bfhkdpo3",
    "color.background.accent.orange.subtle": "_bfhk1kkj",
    "color.background.accent.orange.subtle.hovered": "_bfhk9mfs",
    "color.background.accent.orange.subtle.pressed": "_bfhkaxpp",
    "color.background.accent.orange.bolder": "_bfhk1qg1",
    "color.background.accent.orange.bolder.hovered": "_bfhk12qo",
    "color.background.accent.orange.bolder.pressed": "_bfhk1fyq",
    "color.background.accent.yellow.subtlest": "_bfhkibhp",
    "color.background.accent.yellow.subtlest.hovered": "_bfhkaetg",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk1o1l",
    "color.background.accent.yellow.subtler": "_bfhk1773",
    "color.background.accent.yellow.subtler.hovered": "_bfhk1uw7",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1r9w",
    "color.background.accent.yellow.subtle": "_bfhk8y3s",
    "color.background.accent.yellow.subtle.hovered": "_bfhk819w",
    "color.background.accent.yellow.subtle.pressed": "_bfhk1jx0",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk1okt",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkyfny",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhk1e2h",
    "color.background.accent.green.subtler.pressed": "_bfhkybhx",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk1g86",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1j68",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1cxp",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkkwwr",
    "color.background.accent.teal.subtler.pressed": "_bfhk1jb0",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk16zl",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhktor0",
    "color.background.accent.blue.subtlest": "_bfhk1s93",
    "color.background.accent.blue.subtlest.hovered": "_bfhkdaj9",
    "color.background.accent.blue.subtlest.pressed": "_bfhkxm0g",
    "color.background.accent.blue.subtler": "_bfhk1dy8",
    "color.background.accent.blue.subtler.hovered": "_bfhk815t",
    "color.background.accent.blue.subtler.pressed": "_bfhkrwxf",
    "color.background.accent.blue.subtle": "_bfhk115i",
    "color.background.accent.blue.subtle.hovered": "_bfhk9pr4",
    "color.background.accent.blue.subtle.pressed": "_bfhknpx7",
    "color.background.accent.blue.bolder": "_bfhk16e3",
    "color.background.accent.blue.bolder.hovered": "_bfhk1vbm",
    "color.background.accent.blue.bolder.pressed": "_bfhk1xwi",
    "color.background.accent.purple.subtlest": "_bfhkp2ly",
    "color.background.accent.purple.subtlest.hovered": "_bfhkkca2",
    "color.background.accent.purple.subtlest.pressed": "_bfhk1jbm",
    "color.background.accent.purple.subtler": "_bfhk1nm4",
    "color.background.accent.purple.subtler.hovered": "_bfhkattl",
    "color.background.accent.purple.subtler.pressed": "_bfhk3nfk",
    "color.background.accent.purple.subtle": "_bfhk18ah",
    "color.background.accent.purple.subtle.hovered": "_bfhk8bp1",
    "color.background.accent.purple.subtle.pressed": "_bfhk1cd2",
    "color.background.accent.purple.bolder": "_bfhkya33",
    "color.background.accent.purple.bolder.hovered": "_bfhk1af5",
    "color.background.accent.purple.bolder.pressed": "_bfhk6cze",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1ckf",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1axx",
    "color.background.accent.magenta.subtler.pressed": "_bfhk42ri",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk6c15",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkeawv",
    "color.background.accent.gray.subtlest": "_bfhkysee",
    "color.background.accent.gray.subtlest.hovered": "_bfhkwejn",
    "color.background.accent.gray.subtlest.pressed": "_bfhk18ut",
    "color.background.accent.gray.subtler": "_bfhk7qp0",
    "color.background.accent.gray.subtler.hovered": "_bfhk10ef",
    "color.background.accent.gray.subtler.pressed": "_bfhk1rk9",
    "color.background.accent.gray.subtle": "_bfhk18j9",
    "color.background.accent.gray.subtle.hovered": "_bfhk1nv3",
    "color.background.accent.gray.subtle.pressed": "_bfhkq9tj",
    "color.background.accent.gray.bolder": "_bfhk1i45",
    "color.background.accent.gray.bolder.hovered": "_bfhkbyip",
    "color.background.accent.gray.bolder.pressed": "_bfhk1van",
    "color.background.disabled": "_bfhkby5v",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhkl4ek",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhki8nm",
    "color.background.neutral.hovered": "_bfhkplhp",
    "color.background.neutral.pressed": "_bfhk1gdz",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk1dpa",
    "color.background.neutral.subtle.pressed": "_bfhkfcek",
    "color.background.neutral.bold": "_bfhk1aqn",
    "color.background.neutral.bold.hovered": "_bfhk1ibz",
    "color.background.neutral.bold.pressed": "_bfhkof27",
    "color.background.selected": "_bfhk15s3",
    "color.background.selected.hovered": "_bfhkufnl",
    "color.background.selected.pressed": "_bfhknozp",
    "color.background.selected.bold": "_bfhkjmqp",
    "color.background.selected.bold.hovered": "_bfhk1q28",
    "color.background.selected.bold.pressed": "_bfhk12kk",
    "color.background.brand.subtlest": "_bfhk1gmr",
    "color.background.brand.subtlest.hovered": "_bfhk3v15",
    "color.background.brand.subtlest.pressed": "_bfhku02c",
    "color.background.brand.bold": "_bfhk1856",
    "color.background.brand.bold.hovered": "_bfhkhf2y",
    "color.background.brand.bold.pressed": "_bfhkg6ey",
    "color.background.brand.boldest": "_bfhk1o4i",
    "color.background.brand.boldest.hovered": "_bfhklefx",
    "color.background.brand.boldest.pressed": "_bfhk16k6",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1r4b",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk13a9",
    "color.background.warning": "_bfhk1917",
    "color.background.warning.hovered": "_bfhk19zu",
    "color.background.warning.pressed": "_bfhkzr32",
    "color.background.warning.bold": "_bfhk1kmu",
    "color.background.warning.bold.hovered": "_bfhk1spp",
    "color.background.warning.bold.pressed": "_bfhk4m4m",
    "color.background.success": "_bfhk1y9u",
    "color.background.success.hovered": "_bfhk1vfx",
    "color.background.success.pressed": "_bfhk1wl5",
    "color.background.success.bold": "_bfhkkcmj",
    "color.background.success.bold.hovered": "_bfhky7x8",
    "color.background.success.bold.pressed": "_bfhkwcbh",
    "color.background.discovery": "_bfhk6vm6",
    "color.background.discovery.hovered": "_bfhk12eq",
    "color.background.discovery.pressed": "_bfhk18vq",
    "color.background.discovery.bold": "_bfhku5tj",
    "color.background.discovery.bold.hovered": "_bfhkfqeg",
    "color.background.discovery.bold.pressed": "_bfhk1f1m",
    "color.background.information": "_bfhk19ip",
    "color.background.information.hovered": "_bfhk86z5",
    "color.background.information.pressed": "_bfhk1c1j",
    "color.background.information.bold": "_bfhkx4w0",
    "color.background.information.bold.hovered": "_bfhkq2ii",
    "color.background.information.bold.pressed": "_bfhkf89v",
    "color.blanket": "_bfhk1i5c",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkizff",
    "color.skeleton.subtle": "_bfhkvkf5",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk19i6",
    "elevation.surface.pressed": "_bfhk13ro",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk6o2t",
    "elevation.surface.overlay.pressed": "_bfhkm8nx",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk116u",
    "elevation.surface.raised.pressed": "_bfhk14aj",
    "elevation.surface.sunken": "_bfhkhfxm",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $80aeea492a73f6fa$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $80aeea492a73f6fa$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l19i6",
    "elevation.surface.pressed": "_1q1l13ro",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l6o2t",
    "elevation.surface.overlay.pressed": "_1q1lm8nx",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l116u",
    "elevation.surface.raised.pressed": "_1q1l14aj",
    "elevation.surface.sunken": "_1q1lhfxm"
};
var $80aeea492a73f6fa$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $80aeea492a73f6fa$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $80aeea492a73f6fa$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $80aeea492a73f6fa$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $80aeea492a73f6fa$var$Box = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $80aeea492a73f6fa$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $80aeea492a73f6fa$var$_excluded2);
    var node = /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: (0, $0f2bf88a36aa71fe$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $80aeea492a73f6fa$var$backgroundColorMap[backgroundColor],
            backgroundColor && $80aeea492a73f6fa$var$isSurfaceToken(backgroundColor) && $80aeea492a73f6fa$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $80aeea492a73f6fa$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $80aeea492a73f6fa$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $80aeea492a73f6fa$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $80aeea492a73f6fa$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $acw62.createElement((0, $9f5859118b4bbb24$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $80aeea492a73f6fa$export$2e2bcd8739ae039 = $80aeea492a73f6fa$var$Box;
function $80aeea492a73f6fa$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $80aeea492a73f6fa$var$setSurfaceTokenMap;
}


var $be5518ac7bc8e564$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $be5518ac7bc8e564$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $be5518ac7bc8e564$var$iconStyles = null;
var $be5518ac7bc8e564$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $be5518ac7bc8e564$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $d95af54e24914fdb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $1b267db47313e17e$export$a274e22fb40f762e)($be5518ac7bc8e564$var$styles.base, (0, $ltooA.fg)("platform-dst-shape-theme-default") && $be5518ac7bc8e564$var$styles.baseT26Shape, appearance === "default" && $be5518ac7bc8e564$var$styles.defaultAppearance, appearance === "subtle" && $be5518ac7bc8e564$var$styles.subtleAppearance, appearance === "inverse" && $be5518ac7bc8e564$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== "inverse" && $be5518ac7bc8e564$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === "_blank" && /*#__PURE__*/ $acw62.createElement((0, $80aeea492a73f6fa$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $be5518ac7bc8e564$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $acw62.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $9dvtP.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $be5518ac7bc8e564$var$Link = /*#__PURE__*/ (0, $acw62.forwardRef)($be5518ac7bc8e564$var$LinkWithoutRef);
var $be5518ac7bc8e564$export$2e2bcd8739ae039 = $be5518ac7bc8e564$var$Link;



/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");


var $27a22153ee2c23d4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($27a22153ee2c23d4$exports, "__esModule", {
    value: true
});
$27a22153ee2c23d4$exports.default = void 0;

var $27a22153ee2c23d4$var$_react = $27a22153ee2c23d4$var$_interopRequireDefault((parcelRequire("acw62")));

var $27a22153ee2c23d4$var$_baseNew = $27a22153ee2c23d4$var$_interopRequireDefault((parcelRequire("4WWnO")));
function $27a22153ee2c23d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27a22153ee2c23d4$var$CrossIcon = (props)=>/*#__PURE__*/ $27a22153ee2c23d4$var$_react.default.createElement($27a22153ee2c23d4$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$27a22153ee2c23d4$var$CrossIcon.displayName = "CrossIcon";
var $27a22153ee2c23d4$var$_default = $27a22153ee2c23d4$exports.default = $27a22153ee2c23d4$var$CrossIcon;



var $f14aa40c1ef6f263$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
var $f14aa40c1ef6f263$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
var $f14aa40c1ef6f263$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref["aria-label"], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "default" : _ref$shape;
    return /*#__PURE__*/ $acw62.createElement((0, $484954471eb7443a$export$2e2bcd8739ae039), {
        xcss: (0, $1b267db47313e17e$export$a274e22fb40f762e)($f14aa40c1ef6f263$var$removeButtonStyles.root, shape === "circle" && $f14aa40c1ef6f263$var$removeButtonStyles.circle, $f14aa40c1ef6f263$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($27a22153ee2c23d4$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f14aa40c1ef6f263$export$2e2bcd8739ae039 = $f14aa40c1ef6f263$var$RemoveButton;


var $a91f30afc29fdcef$export$203775b632e10448 = "--ds-tag-icon";
var $a91f30afc29fdcef$export$7d6deb4aa4b5840e = "--tag-border-token";
var $a91f30afc29fdcef$export$df7ff9c2f76bffcd = "--tag-icon-token";
var $a91f30afc29fdcef$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
var $a91f30afc29fdcef$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};
var $a91f30afc29fdcef$export$8793edee2d425525 = (0, $e9638e34f36c5e23$export$2e2bcd8739ae039);
function $a91f30afc29fdcef$export$f26019543e9f862f(text, onBeforeRemoveAction, onAfterRemoveAction) {
    var _useState = (0, $acw62.useState)($a91f30afc29fdcef$export$74452314b63acabc.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveComplete = (0, $acw62.useCallback)(function() {
        (onAfterRemoveAction !== null && onAfterRemoveAction !== void 0 ? onAfterRemoveAction : $a91f30afc29fdcef$export$8793edee2d425525)(text);
        setStatus($a91f30afc29fdcef$export$74452314b63acabc.Removed);
    }, [
        onAfterRemoveAction,
        text
    ]);
    var handleRemoveRequest = (0, $acw62.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : $a91f30afc29fdcef$export$279e7025ed114474;
        if (beforeAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $acw62.useCallback)(function(e) {
        var spacebarOrEnter = e.key === " " || e.key === "Enter";
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $acw62.useCallback)(function() {
        return setStatus($a91f30afc29fdcef$export$74452314b63acabc.Removing);
    }, []);
    var showingTag = (0, $acw62.useCallback)(function() {
        return setStatus($a91f30afc29fdcef$export$74452314b63acabc.Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}
function $a91f30afc29fdcef$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $be5518ac7bc8e564$export$2e2bcd8739ae039);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
function $a91f30afc29fdcef$export$84acd183858d8235() {
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isLinkHovered = _useState4[0], setIsLinkHovered = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), isOverButton = _useState6[0], setIsOverButton = _useState6[1];
    var _useState7 = (0, $acw62.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState7, 2), isButtonFocused = _useState8[0], setIsButtonFocused = _useState8[1];
    var _useState9 = (0, $acw62.useState)(false), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState9, 2), isLinkFocused = _useState0[0], setIsLinkFocused = _useState0[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $acw62.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $acw62.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $acw62.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}
function $a91f30afc29fdcef$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "default" : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $acw62.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $acw62.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $acw62.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ $acw62.createElement((0, $f14aa40c1ef6f263$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || "Remove", " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function $a91f30afc29fdcef$export$898a500849bb5cf4(_ref2) {
    var isRemovable = _ref2.isRemovable, status = _ref2.status, children = _ref2.children;
    if (isRemovable) return /*#__PURE__*/ $acw62.createElement((0, $59612df65049ab16$export$2e2bcd8739ae039), null, !(status === $a91f30afc29fdcef$export$74452314b63acabc.Removed) && /*#__PURE__*/ $acw62.createElement((0, $a571726c29fb0aa5$export$2e2bcd8739ae039), null, function(motion) {
        return /*#__PURE__*/ $acw62.createElement("span", {
            ref: motion.ref
        }, children);
    }));
    return children;
}
function $a91f30afc29fdcef$export$ce4b6a469c26f53f(_ref3) {
    var isLink = _ref3.isLink, href = _ref3.href, LinkComponent = _ref3.LinkComponent, testId = _ref3.testId, children = _ref3.children, onClick = _ref3.onClick, linkHandlers = _ref3.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ $acw62.createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, children);
}


var $3652526e953fcf4e$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "onClick"
];
// CSS variable name for icon color - must be used as literal string in cssMap due to Compiled CSS static analysis
var $3652526e953fcf4e$var$iconColorVar = "--ds-tag-icon";
var $3652526e953fcf4e$export$3351a8d90bcc13aa = {
    standard: "gray",
    grey: "gray",
    blue: "blue",
    green: "green",
    red: "red",
    yellow: "yellow",
    purple: "purple",
    lime: "lime",
    magenta: "magenta",
    orange: "orange",
    teal: "teal",
    // Light variants map to same as their non-light counterparts
    greyLight: "gray",
    blueLight: "blue",
    greenLight: "green",
    redLight: "red",
    yellowLight: "yellow",
    purpleLight: "purple",
    limeLight: "lime",
    magentaLight: "magenta",
    orangeLight: "orange",
    tealLight: "teal"
};
var $3652526e953fcf4e$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _1rjcv77o _18zr1mie _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// Border and icon color styles - each color sets CSS variables for its token values
var $3652526e953fcf4e$var$colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ // Border + icon filter styles - base state
var $3652526e953fcf4e$var$borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
};
// Border + icon filter styles - interactive states (hover/pressed)
var $3652526e953fcf4e$var$borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $3652526e953fcf4e$var$TagNewComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "gray" : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, onClick = _ref.onClick, other = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3652526e953fcf4e$var$_excluded);
    var _useTagRemoval = (0, $a91f30afc29fdcef$export$f26019543e9f862f)(text, onBeforeRemoveAction, onAfterRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var _useLink = (0, $a91f30afc29fdcef$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $a91f30afc29fdcef$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $a91f30afc29fdcef$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, other, {
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $3652526e953fcf4e$var$styles.baseStyles,
            $3652526e953fcf4e$var$colorStyles[color],
            $3652526e953fcf4e$var$borderIconFilterStyles.root,
            isLink && $3652526e953fcf4e$var$styles.interactiveBaseStyles,
            isLink && $3652526e953fcf4e$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $3652526e953fcf4e$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $3652526e953fcf4e$var$styles.interactiveHoverStyles,
            isRemovable && $3652526e953fcf4e$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $3652526e953fcf4e$var$styles.childFocusRingStyles
        ])
    }), /*#__PURE__*/ $acw62.createElement((0, $a91f30afc29fdcef$export$ce4b6a469c26f53f), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, elemBefore && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $3652526e953fcf4e$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $acw62.createElement("span", {
        "data-tag-text": true,
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $3652526e953fcf4e$var$styles.textStyles
        ])
    }, text)), removeButton && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            $3652526e953fcf4e$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $acw62.createElement((0, $a91f30afc29fdcef$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status
    }, tagContent);
});
/**
 * __Tag new__
 */ var $3652526e953fcf4e$var$TagNew = /*#__PURE__*/ (0, $acw62.memo)($3652526e953fcf4e$var$TagNewComponent);
var $3652526e953fcf4e$export$2e2bcd8739ae039 = $3652526e953fcf4e$var$TagNew;


/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");


var $acw62 = parcelRequire("acw62");
var $16b8ccc4154f663d$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $16b8ccc4154f663d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16b8ccc4154f663d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16b8ccc4154f663d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16b8ccc4154f663d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $16b8ccc4154f663d$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $16b8ccc4154f663d$var$baseStyles = null;
var $16b8ccc4154f663d$var$interactiveStyles = null;
var $16b8ccc4154f663d$var$focusRingStyles = null;
var $16b8ccc4154f663d$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $16b8ccc4154f663d$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === "gray") // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = "grey";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, other, {
        ref: ref,
        style: $16b8ccc4154f663d$var$_objectSpread({}, style),
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $16b8ccc4154f663d$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$16b8ccc4154f663d$export$2e2bcd8739ae039 = $16b8ccc4154f663d$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $8c4160371740e235$var$beforeElementStyles = null;
var $8c4160371740e235$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8c4160371740e235$export$2e2bcd8739ae039 = $8c4160371740e235$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $07e79c16474a04e6$var$colorToLozengeAppearanceMap = {
    gray: "default",
    grey: "default",
    lime: "success",
    green: "success",
    blue: "inprogress",
    red: "removed",
    purple: "new",
    yellow: "moved",
    orange: "moved",
    magenta: "new",
    teal: "inprogress",
    grayLight: "default",
    greyLight: "default",
    limeLight: "success",
    greenLight: "success",
    blueLight: "inprogress",
    redLight: "removed",
    purpleLight: "new",
    yellowLight: "moved",
    orangeLight: "moved",
    magentaLight: "new",
    tealLight: "inprogress"
};
function $07e79c16474a04e6$export$4d9e331cafeacb9d(color) {
    return $07e79c16474a04e6$var$colorToLozengeAppearanceMap[color || "gray"] || "default";
}


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $18e297918900efb7$var$baseStyles = null;
var $18e297918900efb7$var$linkStyles = null;
var $18e297918900efb7$var$hasAfterStyles = null;
var $18e297918900efb7$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : "a";
    if (href) return /*#__PURE__*/ $acw62.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, text);
    else return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18e297918900efb7$export$2e2bcd8739ae039 = $18e297918900efb7$var$Content;



var $273fe9a3bd7afaef$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth"
];
var $273fe9a3bd7afaef$var$textLinkCssVar = "--ds-ctl";
var $273fe9a3bd7afaef$var$textDefaultCssVar = "--ds-ct";
var $273fe9a3bd7afaef$var$textActiveCssVar = "--ds-ctp";
var $273fe9a3bd7afaef$var$backgroundHoverCssVar = "--ds-cbh";
var $273fe9a3bd7afaef$var$backgroundActiveCssVar = "--ds-cba";
var $273fe9a3bd7afaef$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($273fe9a3bd7afaef$var$TagStatus || {});
var $273fe9a3bd7afaef$var$packageName = "@atlaskit/tag";
var $273fe9a3bd7afaef$var$packageVersion = "0.0.0-development";
var $273fe9a3bd7afaef$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $273fe9a3bd7afaef$var$removingStyles = null;
var $273fe9a3bd7afaef$var$RemovableTagComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $273fe9a3bd7afaef$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $e9638e34f36c5e23$export$2e2bcd8739ae039) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $273fe9a3bd7afaef$var$_excluded);
    var _useState = (0, $acw62.useState)($273fe9a3bd7afaef$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var onAfterRemoveActionWithAnalytics = (0, $9db4b9d521157359$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: "removed",
        actionSubject: "tag",
        attributes: {
            componentName: "tag",
            packageName: $273fe9a3bd7afaef$var$packageName,
            packageVersion: $273fe9a3bd7afaef$var$packageVersion
        }
    }, "atlaskit");
    var handleRemoveComplete = (0, $acw62.useCallback)(function() {
        onAfterRemoveActionWithAnalytics(text);
        setStatus($273fe9a3bd7afaef$var$TagStatus.Removed);
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    var handleRemoveRequest = (0, $acw62.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $acw62.useCallback)(function(e) {
        var spacebarOrEnter = e.key === " " || e.key === "Enter";
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $acw62.useCallback)(function() {
        return setStatus($273fe9a3bd7afaef$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $acw62.useCallback)(function() {
        return setStatus($273fe9a3bd7afaef$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $acw62.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $acw62.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $acw62.createElement((0, $f14aa40c1ef6f263$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || "Remove", " ").concat(text),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === "lozenge" && !(0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        var lozengeAppearance = (0, $07e79c16474a04e6$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $acw62.createElement((0, $50c1f06236c7842c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), text);
    }
    // Use new TagNew component behind feature flag
    if ((0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        var newColor = (0, $3652526e953fcf4e$export$3351a8d90bcc13aa)[color || "standard"];
        return /*#__PURE__*/ $acw62.createElement((0, $3652526e953fcf4e$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveAction,
            maxWidth: maxWidth
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $acw62.createElement((0, $18e297918900efb7$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $273fe9a3bd7afaef$var$backgroundHoverCssVar, undefined), $273fe9a3bd7afaef$var$backgroundActiveCssVar, undefined), $273fe9a3bd7afaef$var$textDefaultCssVar, undefined), $273fe9a3bd7afaef$var$textActiveCssVar, undefined), $273fe9a3bd7afaef$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $acw62.createElement((0, $59612df65049ab16$export$2e2bcd8739ae039), null, !(status === $273fe9a3bd7afaef$var$TagStatus.Removed) && /*#__PURE__*/ $acw62.createElement((0, $a571726c29fb0aa5$export$2e2bcd8739ae039), null, function(motion) {
        return /*#__PURE__*/ $acw62.createElement((0, $16b8ccc4154f663d$export$2e2bcd8739ae039), {
            ref: (0, $9c27926e5513487f$export$2e2bcd8739ae039)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $273fe9a3bd7afaef$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $acw62.createElement((0, $8c4160371740e235$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $2f438cde82521d36$export$2e2bcd8739ae039)([
                status === $273fe9a3bd7afaef$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $273fe9a3bd7afaef$var$RemovableTag = /*#__PURE__*/ (0, $acw62.memo)($273fe9a3bd7afaef$var$RemovableTagComponent);
var $273fe9a3bd7afaef$export$2e2bcd8739ae039 = $273fe9a3bd7afaef$var$RemovableTag;



/* multi-value-label.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $ce3f20e2a324a73d$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $ce3f20e2a324a73d$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $ce3f20e2a324a73d$var$multiValueLabelStyles.root,
            isDisabled && $ce3f20e2a324a73d$var$multiValueLabelStyles.disabled,
            hasEllipsis && $ce3f20e2a324a73d$var$multiValueLabelStyles.ellipsis,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-MultiValueLabel")
        ])
    }), children);
};


function $6d50487ad34429a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d50487ad34429a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d50487ad34429a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d50487ad34429a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Tag wrapper: Tag has built-in margin; cancel the inline margin so we control spacing
var $6d50487ad34429a4$var$tagMarginToken = "var(--ds-space-050, 4px)";
var $6d50487ad34429a4$var$multiValueTagWrapperStyles = {
    root: "_1e0c1txw _1ul9ze3t _1pfhv77o _12l21b66 _6rthv77o _p12f1osq",
    inner: "_195g8ily"
};
// Tag-like color styles
var $6d50487ad34429a4$var$tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
var $6d50487ad34429a4$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $6d50487ad34429a4$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1mouv77o _195gv77o _1dqonqa1 _189ee4h9 _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1ul9idpf _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk1dpa _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $6d50487ad34429a4$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === "string") return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === "string" ? label : "";
};
var $6d50487ad34429a4$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $6d50487ad34429a4$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === "string";
    var ffTagUplifts = (0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts");
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "multiValue", {
        "multi-value": true,
        "multi-value--is-disabled": isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "multiValueLabel", {
        "multi-value__label": true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "multiValueRemove", {
        "multi-value__remove": true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $ce3f20e2a324a73d$export$544aeea2a5ce08ee);
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
                $6d50487ad34429a4$var$multiValueTagWrapperStyles.root,
                (0, $5c865fb94edc765b$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, "-multiValue")
            ])
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
                $6d50487ad34429a4$var$multiValueTagWrapperStyles.inner
            ])
        }, /*#__PURE__*/ $acw62.createElement((0, $273fe9a3bd7afaef$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : "gray",
            elemBefore: elemBefore
        })));
    }
    // FF on + custom content or custom Label/Remove → tag-like container styling with the provided
    // Label and Remove components so custom overrides continue to work.
    if (ffTagUplifts) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
                $6d50487ad34429a4$var$multiValueTagLikeStyles.root,
                $6d50487ad34429a4$var$tagLikeColorStyles.gray,
                colorKey === "blue" && $6d50487ad34429a4$var$tagLikeColorStyles.blue,
                colorKey === "green" && $6d50487ad34429a4$var$tagLikeColorStyles.green,
                colorKey === "red" && $6d50487ad34429a4$var$tagLikeColorStyles.red,
                colorKey === "yellow" && $6d50487ad34429a4$var$tagLikeColorStyles.yellow,
                colorKey === "purple" && $6d50487ad34429a4$var$tagLikeColorStyles.purple,
                colorKey === "lime" && $6d50487ad34429a4$var$tagLikeColorStyles.lime,
                colorKey === "magenta" && $6d50487ad34429a4$var$tagLikeColorStyles.magenta,
                colorKey === "orange" && $6d50487ad34429a4$var$tagLikeColorStyles.orange,
                colorKey === "teal" && $6d50487ad34429a4$var$tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && $6d50487ad34429a4$var$multiValueTagLikeStyles.disabled,
                isFocused && $6d50487ad34429a4$var$multiValueTagLikeStyles.focused,
                (0, $5c865fb94edc765b$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, "-multiValue")
            ])
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
                $6d50487ad34429a4$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $acw62.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $acw62.createElement(Remove, {
            data: data,
            innerProps: $6d50487ad34429a4$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: "button",
                tabIndex: -1,
                "aria-label": "".concat(labelText || "option", ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $acw62.createElement(Container, {
        data: data,
        innerProps: $6d50487ad34429a4$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $acw62.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $acw62.createElement(Remove, {
        data: data,
        innerProps: $6d50487ad34429a4$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: "button",
            tabIndex: -1,
            "aria-label": "".concat(labelText || "option", ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d50487ad34429a4$export$2e2bcd8739ae039 = $6d50487ad34429a4$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $c468e3ca32148be1$var$disabledStyles = null;
var $c468e3ca32148be1$var$enabledStyles = null;
var $c468e3ca32148be1$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1jjn _1di6fcek _i5f81jjn"
};
function $c468e3ca32148be1$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $c468e3ca32148be1$var$multiValueRemoveStyles.root,
            isFocused && $c468e3ca32148be1$var$multiValueRemoveStyles.focused,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-MultiValueRemove")
        ])
    }), /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": isDisabled ? "hide-clear-icon" : "show-clear-icon",
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($27a22153ee2c23d4$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $9490bd089180f527$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $9490bd089180f527$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $9490bd089180f527$var$optionStyles.root,
            isFocused && $9490bd089180f527$var$optionStyles.focused,
            isSelected && $9490bd089180f527$var$optionStyles.selected,
            isFocused && isSelected && $9490bd089180f527$var$optionStyles.focusedSelected,
            isDisabled && $9490bd089180f527$var$optionStyles.disabled,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-option")
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9490bd089180f527$export$2e2bcd8739ae039 = $9490bd089180f527$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $4f6cbf9b7a1018ee$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $4f6cbf9b7a1018ee$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "placeholder", {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $4f6cbf9b7a1018ee$var$placeholderStyles.root,
            isDisabled && $4f6cbf9b7a1018ee$var$placeholderStyles.disabled,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-placeholder")
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4f6cbf9b7a1018ee$export$2e2bcd8739ae039 = $4f6cbf9b7a1018ee$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



var $b3a00994e03cedb2$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $b3a00994e03cedb2$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $58276eeb2339959d$export$26417cabd806a658)(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            $b3a00994e03cedb2$var$styles.root,
            isDisabled && $b3a00994e03cedb2$var$styles.disalbed,
            (0, $5c865fb94edc765b$export$a274e22fb40f762e)(className, xcss, "-singleValue")
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b3a00994e03cedb2$export$2e2bcd8739ae039 = $b3a00994e03cedb2$var$SingleValue;


function $8441c7fe21ac6115$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8441c7fe21ac6115$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8441c7fe21ac6115$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8441c7fe21ac6115$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8441c7fe21ac6115$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $04b4231e01c47bcf$export$ecf9cf59142dd54a),
    Control: (0, $ae002a8f3831176c$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $2e5dde9de66158b5$export$ec98719d3db7f2e4),
    Group: (0, $67bb65600f07f267$export$2e2bcd8739ae039),
    GroupHeading: (0, $ea548ea687b10989$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $2a42a786aeb6254c$export$d0ffd7e649cab6f),
    Input: (0, $02a6758cb621c1f3$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $0c4986918392b922$export$7c20be4c1d342248),
    Menu: (0, $c320044182bcf49b$export$2e2bcd8739ae039),
    MenuList: (0, $373cab6d65000c13$export$d4c4e98c5044dc8),
    MenuPortal: (0, $76d5f6a880a3febe$export$793392f970497feb),
    LoadingMessage: (0, $917d6738db7047d1$export$e928a71d039d3102),
    NoOptionsMessage: (0, $e34f6bee63610cdd$export$d58b72b7d3c4072c),
    MultiValue: (0, $6d50487ad34429a4$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $8fdc72518ab21c02$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $ce3f20e2a324a73d$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $c468e3ca32148be1$export$8e1fd1a40e7a2f4a),
    Option: (0, $9490bd089180f527$export$2e2bcd8739ae039),
    Placeholder: (0, $4f6cbf9b7a1018ee$export$2e2bcd8739ae039),
    SelectContainer: (0, $6cf18d1d15e45369$export$446eebadefe1123b),
    SingleValue: (0, $b3a00994e03cedb2$export$2e2bcd8739ae039),
    ValueContainer: (0, $189382aa22da7d77$export$4dc9f58ad9a1a000)
};
var $8441c7fe21ac6115$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $8441c7fe21ac6115$var$_objectSpread($8441c7fe21ac6115$var$_objectSpread({}, $8441c7fe21ac6115$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $63f19105f88f5f9b$var$_excluded = [
    "innerRef"
];
var $63f19105f88f5f9b$var$removeProps = function removeProps(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)properties[_key - 1] = arguments[_key];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $63f19105f88f5f9b$var$dummyInputStyles = null;
function $63f19105f88f5f9b$export$2e2bcd8739ae039(_ref5) {
    var innerRef = _ref5.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref5, $63f19105f88f5f9b$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = $63f19105f88f5f9b$var$removeProps(props, "onExited", "in", "enter", "exit", "appear");
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: innerRef,
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
var $289f411b8d6dbd0f$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return label.length ? "option ".concat(label, ", deselected") : "";
            case "clear":
                return "All selected options have been cleared.";
            case "select-option":
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : "";
            default:
                return "";
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : "";
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

// Assistive text to describe visual elements. Hidden for sighted users.
var $f999765815d7e22d$var$styles = null;
var $f999765815d7e22d$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $f999765815d7e22d$export$2e2bcd8739ae039 = $f999765815d7e22d$var$A11yText;


function $49aa623bab7ace43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $49aa623bab7ace43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $49aa623bab7ace43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $49aa623bab7ace43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $49aa623bab7ace43$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return $49aa623bab7ace43$var$_objectSpread($49aa623bab7ace43$var$_objectSpread({}, (0, $289f411b8d6dbd0f$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return "";
            var onChangeProps = $49aa623bab7ace43$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (isLoading) resultsMsg = "Loading. ";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = "No options. ";
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f999765815d7e22d$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f999765815d7e22d$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49aa623bab7ace43$export$2e2bcd8739ae039 = $49aa623bab7ace43$var$LiveRegion;



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


function $9b4b50cd55522043$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b4b50cd55522043$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b4b50cd55522043$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b4b50cd55522043$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9b4b50cd55522043$var$noop = (0, $f7203335dc3f20fa$export$2e2bcd8739ae039);
function $9b4b50cd55522043$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $9b4b50cd55522043$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $9b4b50cd55522043$var$normalizedHeight(el) {
    if ($9b4b50cd55522043$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $9b4b50cd55522043$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($9b4b50cd55522043$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $9b4b50cd55522043$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $9b4b50cd55522043$var$getScrollTop(el) {
    if ($9b4b50cd55522043$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $9b4b50cd55522043$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $9b4b50cd55522043$var$noop;
    var start = $9b4b50cd55522043$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $9b4b50cd55522043$var$easeOutCubic(currentTime, start, change, duration);
        $9b4b50cd55522043$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $9b4b50cd55522043$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $9b4b50cd55522043$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $9b4b50cd55522043$var$normalizedHeight(scrollParent);
    var scrollTop = $9b4b50cd55522043$var$getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $9b4b50cd55522043$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $9b4b50cd55522043$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $9b4b50cd55522043$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $9b4b50cd55522043$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $9b4b50cd55522043$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
var $9b4b50cd55522043$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var $9b4b50cd55522043$var$MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $acw62.useContext)((0, $f424f34066fe5ad6$export$e001f626511a0ead)) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $acw62.useLayoutEffect)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $9b4b50cd55522043$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $9b4b50cd55522043$var$_objectSpread($9b4b50cd55522043$var$_objectSpread({}, props), {}, {
            placement: placement || $9b4b50cd55522043$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $9b4b50cd55522043$export$2e2bcd8739ae039 = $9b4b50cd55522043$var$MenuPlacer;



var $g5Zhu = parcelRequire("g5Zhu");

var $jk22o = parcelRequire("jk22o");
var $3a1c71d9784e2274$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $3a1c71d9784e2274$var$anyDiacritic = new RegExp("[" + $3a1c71d9784e2274$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $3a1c71d9784e2274$var$diacriticToBase = {};
for(var $3a1c71d9784e2274$var$i = 0; $3a1c71d9784e2274$var$i < $3a1c71d9784e2274$var$diacritics.length; $3a1c71d9784e2274$var$i++){
    var $3a1c71d9784e2274$var$diacritic = $3a1c71d9784e2274$var$diacritics[$3a1c71d9784e2274$var$i];
    for(var $3a1c71d9784e2274$var$j = 0; $3a1c71d9784e2274$var$j < $3a1c71d9784e2274$var$diacritic.letters.length; $3a1c71d9784e2274$var$j++)$3a1c71d9784e2274$var$diacriticToBase[$3a1c71d9784e2274$var$diacritic.letters[$3a1c71d9784e2274$var$j]] = $3a1c71d9784e2274$var$diacritic.base;
}
var $3a1c71d9784e2274$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($3a1c71d9784e2274$var$anyDiacritic, function(match) {
        return $3a1c71d9784e2274$var$diacriticToBase[match];
    });
};


function $1efb8aae41dd6cc2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1efb8aae41dd6cc2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1efb8aae41dd6cc2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1efb8aae41dd6cc2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1efb8aae41dd6cc2$var$memoizedStripDiacriticsForInput = (0, $jk22o.default)((0, $3a1c71d9784e2274$export$b5bee4b27048330b));
var $1efb8aae41dd6cc2$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $1efb8aae41dd6cc2$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $1efb8aae41dd6cc2$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $1efb8aae41dd6cc2$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $1efb8aae41dd6cc2$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $1efb8aae41dd6cc2$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $1efb8aae41dd6cc2$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $1efb8aae41dd6cc2$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $3a1c71d9784e2274$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};


/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $4b53ebc5c440d759$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $4b53ebc5c440d759$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($4b53ebc5c440d759$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}



var $41YNz = parcelRequire("41YNz");
var $3df4215612165e43$export$33f062f47f21a01 = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && value !== null) return [
        value
    ];
    return [];
};


function $456c78651819c88f$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}


function $de310f8593e573d2$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}



function $731e0fe1f502c446$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $8501596c6516e42a$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* required-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");


var $d9b56159f40b93e0$var$styles = null;
var $d9b56159f40b93e0$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $acw62.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $f7203335dc3f20fa$export$2e2bcd8739ae039)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9b56159f40b93e0$export$2e2bcd8739ae039 = $d9b56159f40b93e0$var$RequiredInput;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// ==============================
// Passive Event Detector
// ==============================

var $957d7dc70888c6e7$var$noop = (0, $f7203335dc3f20fa$export$2e2bcd8739ae039);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $957d7dc70888c6e7$var$passiveOptionAccessed = false;
var $957d7dc70888c6e7$var$options = {
    get passive () {
        return $957d7dc70888c6e7$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $957d7dc70888c6e7$var$w = typeof window !== "undefined" ? window : {};
if ($957d7dc70888c6e7$var$w.addEventListener && $957d7dc70888c6e7$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $957d7dc70888c6e7$var$w.addEventListener("p", $957d7dc70888c6e7$var$noop, $957d7dc70888c6e7$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $957d7dc70888c6e7$var$w.removeEventListener("p", $957d7dc70888c6e7$var$noop, false);
}
var $957d7dc70888c6e7$export$b0622a6911dbeaf5 = $957d7dc70888c6e7$var$passiveOptionAccessed;


var $00c09357fde9f58c$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $00c09357fde9f58c$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $00c09357fde9f58c$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $957d7dc70888c6e7$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("wheel", onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("touchstart", onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("wheel", onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("touchstart", onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $acw62 = parcelRequire("acw62");
var $e0ca81ffa7b0d569$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $e0ca81ffa7b0d569$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $e0ca81ffa7b0d569$var$preventTouchMove(e) {
    e.preventDefault();
}
function $e0ca81ffa7b0d569$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $e0ca81ffa7b0d569$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $e0ca81ffa7b0d569$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $e0ca81ffa7b0d569$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $e0ca81ffa7b0d569$var$activeScrollLocks = 0;
var $e0ca81ffa7b0d569$var$listenerOptions = {
    capture: false,
    passive: false
};
function $e0ca81ffa7b0d569$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$e0ca81ffa7b0d569$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $e0ca81ffa7b0d569$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $e0ca81ffa7b0d569$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($e0ca81ffa7b0d569$var$LOCK_STYLES).forEach(function(key) {
                var val = $e0ca81ffa7b0d569$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $e0ca81ffa7b0d569$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener("touchmove", $e0ca81ffa7b0d569$var$preventTouchMove, $e0ca81ffa7b0d569$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener("touchstart", $e0ca81ffa7b0d569$var$preventInertiaScroll, $e0ca81ffa7b0d569$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener("touchmove", $e0ca81ffa7b0d569$var$allowTouchMove, $e0ca81ffa7b0d569$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $e0ca81ffa7b0d569$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$e0ca81ffa7b0d569$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $e0ca81ffa7b0d569$var$activeScrollLocks = Math.max($e0ca81ffa7b0d569$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $e0ca81ffa7b0d569$var$activeScrollLocks < 1) $e0ca81ffa7b0d569$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $e0ca81ffa7b0d569$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener("touchmove", $e0ca81ffa7b0d569$var$preventTouchMove, $e0ca81ffa7b0d569$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener("touchstart", $e0ca81ffa7b0d569$var$preventInertiaScroll, $e0ca81ffa7b0d569$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener("touchmove", $e0ca81ffa7b0d569$var$allowTouchMove, $e0ca81ffa7b0d569$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $31a01131ac5f43b6$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $31a01131ac5f43b6$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $00c09357fde9f58c$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $e0ca81ffa7b0d569$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: $31a01131ac5f43b6$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: "fixed",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



function $64f1aa428ee07f49$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $456c78651819c88f$export$d8a62a489b442872)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}


function $fd81dc82b980d2ad$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}


function $8ff7b8d5d6ce0316$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}


function $3c177990d2adb1d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c177990d2adb1d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c177990d2adb1d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c177990d2adb1d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c177990d2adb1d0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $3c177990d2adb1d0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $3c177990d2adb1d0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3c177990d2adb1d0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3c177990d2adb1d0$var$noop = (0, $f7203335dc3f20fa$export$2e2bcd8739ae039);
function $3c177990d2adb1d0$var$notNullish(item) {
    return item != null;
}
function $3c177990d2adb1d0$var$scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $64f1aa428ee07f49$export$3f99968195accfaf)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $64f1aa428ee07f49$export$3f99968195accfaf)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $3c177990d2adb1d0$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused) {
        return false;
    }
}
function $3c177990d2adb1d0$var$isTouchCapable() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (_unused2) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var $3c177990d2adb1d0$var$filterUnsupportedSelectors = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ":",
        // pseudo-classes/elements
        "[",
        // attribute selectors
        ">",
        // child combinator
        "+",
        // adjacent sibling combinator
        "~",
        // general sibling combinator
        " ",
        // descendant combinator
        "*",
        // universal selector
        "#",
        // ID selector
        ".",
        // class selector
        "@",
        // at-rules
        "&",
        // parent selector
        "|",
        // namespace separator
        "^",
        // starts with
        "$",
        // ends with
        "=" // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var $3c177990d2adb1d0$var$elemBeforeCSS = null;
var $3c177990d2adb1d0$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $3c177990d2adb1d0$var$isTouchCapable(),
    captureMenuScroll: !$3c177990d2adb1d0$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $1efb8aae41dd6cc2$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $2beec76e165774c3$export$f4da216a6ca54656),
    getOptionLabel: (0, $2beec76e165774c3$export$dac6ace3020563ca),
    getOptionValue: (0, $2beec76e165774c3$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $2beec76e165774c3$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$3c177990d2adb1d0$var$isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $3c177990d2adb1d0$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $3c177990d2adb1d0$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $3c177990d2adb1d0$var$_isOptionSelected(props, option, selectValue);
    var label = $3c177990d2adb1d0$var$getOptionLabel(props, option);
    var value = $3c177990d2adb1d0$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $3c177990d2adb1d0$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $3c177990d2adb1d0$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $3c177990d2adb1d0$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $3c177990d2adb1d0$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $3c177990d2adb1d0$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($3c177990d2adb1d0$var$notNullish);
}
function $3c177990d2adb1d0$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $3c177990d2adb1d0$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $3c177990d2adb1d0$var$buildFocusableOptions(props, selectValue) {
    return $3c177990d2adb1d0$var$buildFocusableOptionsFromCategorizedOptions($3c177990d2adb1d0$var$buildCategorizedOptions(props, selectValue));
}
function $3c177990d2adb1d0$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$3c177990d2adb1d0$var$shouldHideSelectedOptions(props) || !isSelected) && $3c177990d2adb1d0$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $3c177990d2adb1d0$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $3c177990d2adb1d0$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $3c177990d2adb1d0$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $3c177990d2adb1d0$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $3c177990d2adb1d0$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $3c177990d2adb1d0$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $3c177990d2adb1d0$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $3c177990d2adb1d0$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $3c177990d2adb1d0$var$getOptionValue(props, i) === candidate;
    });
}
function $3c177990d2adb1d0$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $3c177990d2adb1d0$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $3c177990d2adb1d0$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $3c177990d2adb1d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Select);
        _this = $3c177990d2adb1d0$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $ltooA.fg)("platform_do_not_clear_input_for_multiselect")) _this.onInputChange(inputValue, {
                action: "set-value",
                prevInputValue: inputValue
            });
            else _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $de310f8593e573d2$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $de310f8593e573d2$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $fd81dc82b980d2ad$export$dea4763e29237f4c)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $fd81dc82b980d2ad$export$dea4763e29237f4c)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $8ff7b8d5d6ce0316$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $8ff7b8d5d6ce0316$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $8ff7b8d5d6ce0316$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $3c177990d2adb1d0$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusableOptionsWithIds", function() {
            return $3c177990d2adb1d0$var$buildFocusableOptionsWithIds($3c177990d2adb1d0$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $4b53ebc5c440d759$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getOptionLabel", function(data) {
            return $3c177990d2adb1d0$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getOptionValue", function(data) {
            return $3c177990d2adb1d0$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getStyles", function(key, props) {
            var base = {
                boxSizing: "border-box"
            };
            var custom = _this.props.styles[key];
            if (custom) return $3c177990d2adb1d0$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getComponents", function() {
            return (0, $8441c7fe21ac6115$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "buildCategorizedOptions", function() {
            return $3c177990d2adb1d0$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "buildFocusableOptions", function() {
            return $3c177990d2adb1d0$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $3c177990d2adb1d0$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest("[data-rbd-draggable-context-id]"))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $456c78651819c88f$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            if ((0, $ltooA.fg)("platform_dst_select_menu_close_on_blur")) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "shouldHideSelectedOptions", function() {
            return $3c177990d2adb1d0$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$3c177990d2adb1d0$var$instanceId);
        _this.state.selectValue = (0, $3df4215612165e43$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $3c177990d2adb1d0$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $3c177990d2adb1d0$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    $3c177990d2adb1d0$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $b77544e2caa431c1$export$95df08bae54cb4df)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute("aria-label", inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props["aria-label"] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute("aria-label", normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute("aria-label");
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "options" in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId("selected-value"), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $3c177990d2adb1d0$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $3c177990d2adb1d0$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $3c177990d2adb1d0$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this$props$component;
                if (typeof this.props.formatOptionLabel === "function") {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === "menu" && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $ltooA.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            className: (0, $9100017bc3df9b38$export$2e2bcd8739ae039)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ])
                        }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label));
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props["aria-describedby"] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? "" : this.getElementId("single-value") : this.getElementId("placeholder");
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    "aria-describedby": baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId("multi-message");
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    "aria-describedby": describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchstart", this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchmove", this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({}, !this.props.isSearchable && (0, $ltooA.fg)("platform_fix_autocomplete_aria_for_select") ? {} : {
                    "aria-autocomplete": "both"
                }), {}, {
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-expanded": menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    "aria-haspopup": this.props["UNSAFE_is_experimental_generic"] ? "dialog" : "listbox",
                    "aria-invalid": this.props["aria-invalid"] || isInvalid,
                    "aria-label": this.props["aria-label"] || label,
                    "aria-labelledby": this.props["aria-labelledby"] || labelId,
                    "aria-required": required || isRequired,
                    role: "combobox",
                    "aria-activedescendant": this.props["UNSAFE_is_experimental_generic"] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && !(0, $ltooA.fg)("select_issearchable_aria-readonly_fix") && {
                    "aria-readonly": true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $63f19105f88f5f9b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: $3c177990d2adb1d0$var$noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $3c177990d2adb1d0$var$_objectSpread({
                        id: this.getElementId("placeholder")
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            "data-testid": "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId("selected-value"), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({}, testId && {
                            "data-testid": "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId("selected-value"), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId("single-value")
                    }
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $3c177990d2adb1d0$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    "data-testid": "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === "compact";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === "compact";
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === "compact";
                var innerProps = $3c177990d2adb1d0$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                }, testId && {
                    "data-testid": "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId("option"), "-").concat(id);
                    var innerProps = $3c177990d2adb1d0$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props["UNSAFE_is_experimental_generic"] ? "listitem" : "option",
                        "aria-selected": _this6.props["UNSAFE_is_experimental_generic"] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        "aria-disabled": !isDisabled ? undefined : isDisabled,
                        "aria-describedby": headingId
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === "group") {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId("group"), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $3c177990d2adb1d0$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    "data-testid": "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === "option") return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                        innerProps: $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({}, this.props["UNSAFE_is_experimental_generic"] && {
                            role: "listitem"
                        }), testId && {
                            "data-testid": "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b4b50cd55522043$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $3c177990d2adb1d0$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId("listbox") : undefined
                        }, testId && {
                            "data-testid": "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31a01131ac5f43b6$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({
                                role: _this6.props["UNSAFE_is_experimental_generic"] ? "dialog" : "listbox"
                            }, _this6.props["UNSAFE_is_experimental_generic"] && {
                                "aria-labelledby": ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId("input")
                            }), {}, {
                                "aria-multiselectable": !commonProps.isMulti || _this6.props["UNSAFE_is_experimental_generic"] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId("listbox")
                            }, testId && {
                                "data-testid": "".concat(testId, "-select--listbox")
                            }), (0, $b77544e2caa431c1$export$95df08bae54cb4df)() && !_this6.props["UNSAFE_is_experimental_generic"] && {
                                "aria-describedby": ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId("input")
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props["UNSAFE_is_experimental_generic"] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9b56159f40b93e0$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $49aa623bab7ace43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? "Use left or right arrow keys to navigate selected items" : "");
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    id: this.getElementId("multi-message"),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? "default" : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? "default" : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === "compact";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $3c177990d2adb1d0$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        "data-testid": testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $3c177990d2adb1d0$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({}, testId && {
                        "data-testid": "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $b77544e2caa431c1$export$e1865c3bedcd822b)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: "application"
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $3c177990d2adb1d0$var$_objectSpread({}, testId && {
                        "data-testid": "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $731e0fe1f502c446$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $3df4215612165e43$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $3c177990d2adb1d0$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $3c177990d2adb1d0$var$buildFocusableOptionsWithIds($3c177990d2adb1d0$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $3c177990d2adb1d0$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $3c177990d2adb1d0$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $3c177990d2adb1d0$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $8ff7b8d5d6ce0316$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return $3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread($3c177990d2adb1d0$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $acw62.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($3c177990d2adb1d0$export$2e2bcd8739ae039, "defaultProps", $3c177990d2adb1d0$export$9c21a3269931e1e6);



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $55b06999d7b0b93d$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $55b06999d7b0b93d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55b06999d7b0b93d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55b06999d7b0b93d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55b06999d7b0b93d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $55b06999d7b0b93d$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === "string") return newValue;
    }
    return inputValue;
}
function $55b06999d7b0b93d$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $55b06999d7b0b93d$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $acw62.useRef)(undefined);
    var mounted = (0, $acw62.useRef)(false);
    var _useState = (0, $acw62.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $acw62.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $acw62.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $acw62.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $acw62.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $acw62.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $acw62.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $acw62.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $acw62.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $acw62.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $acw62.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $acw62.useCallback)(function(newValue, actionMeta) {
        var inputValue = $55b06999d7b0b93d$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $55b06999d7b0b93d$var$_objectSpread($55b06999d7b0b93d$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $55b06999d7b0b93d$var$_objectSpread($55b06999d7b0b93d$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $6b03d73da06ef6c8$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $6b03d73da06ef6c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b03d73da06ef6c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b03d73da06ef6c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b03d73da06ef6c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6b03d73da06ef6c8$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $6b03d73da06ef6c8$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $6b03d73da06ef6c8$var$_objectSpread($6b03d73da06ef6c8$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $dae1686afbbd3b8e$var$AsyncSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $55b06999d7b0b93d$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $6b03d73da06ef6c8$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c177990d2adb1d0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dae1686afbbd3b8e$export$2e2bcd8739ae039 = $dae1686afbbd3b8e$var$AsyncSelect;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $107c043ae0f217cc$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $107c043ae0f217cc$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? "default" : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $107c043ae0f217cc$var$_excluded);
        var internalSelectRef = (0, $acw62.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $acw62.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === "error"
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = "AtlaskitSelect";
    return AtlaskitSelect;
}


var $6a65a164d1aeffc0$var$packageName = "@atlaskit/select";
var $6a65a164d1aeffc0$var$packageVersion = "0.0.0-development";
var $6a65a164d1aeffc0$export$d1de3b251ccaa8a3 = (0, $107c043ae0f217cc$export$2e2bcd8739ae039)((0, $dae1686afbbd3b8e$export$2e2bcd8739ae039));
var $6a65a164d1aeffc0$var$createAndFireEventOnAtlaskit = (0, $dc87d2aaa4908eb7$export$2e2bcd8739ae039)("atlaskit");
var $6a65a164d1aeffc0$var$Select = (0, $fdddc63a0d63cbeb$export$2e2bcd8739ae039)({
    componentName: "select",
    packageName: $6a65a164d1aeffc0$var$packageName,
    packageVersion: $6a65a164d1aeffc0$var$packageVersion
})((0, $988e6509b1c31583$export$2e2bcd8739ae039)({
    onChange: $6a65a164d1aeffc0$var$createAndFireEventOnAtlaskit({
        action: "changed",
        actionSubject: "option",
        attributes: {
            componentName: "select",
            packageName: $6a65a164d1aeffc0$var$packageName,
            packageVersion: $6a65a164d1aeffc0$var$packageVersion
        }
    })
})($6a65a164d1aeffc0$export$d1de3b251ccaa8a3));
var $6a65a164d1aeffc0$export$2e2bcd8739ae039 = $6a65a164d1aeffc0$var$Select;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $acw62 = parcelRequire("acw62");
var $393c8d6844b3eb51$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $393c8d6844b3eb51$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($393c8d6844b3eb51$export$1ca2a26fecb070ae);
};
$393c8d6844b3eb51$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $dnfL5 = parcelRequire("dnfL5");
var $3a8b285751820f4e$export$4ef52930e33717cd = "data-theme";
var $3a8b285751820f4e$export$cb374d25ded7f6ab = "data-subtree-theme";
var $3a8b285751820f4e$export$a00eac3f8684bcd0 = "data-color-mode";
var $3a8b285751820f4e$export$2112803007239c61 = "data-contrast-mode";
var $3a8b285751820f4e$export$352e418ed5b6193a = "data-custom-theme";
var $3a8b285751820f4e$export$6f0c6fb8c80fcc92 = "ds";
var $3a8b285751820f4e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $3a8b285751820f4e$export$dddac1532e822863 = "--".concat($3a8b285751820f4e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $3a8b285751820f4e$export$9d7b58831ae93caa = "--".concat($3a8b285751820f4e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $fd1f3bd4499375fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd1f3bd4499375fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd1f3bd4499375fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd1f3bd4499375fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd1f3bd4499375fc$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $fd1f3bd4499375fc$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $fd1f3bd4499375fc$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $fd1f3bd4499375fc$export$632685d741f3dbbf = $fd1f3bd4499375fc$var$_objectSpread($fd1f3bd4499375fc$var$_objectSpread({}, $fd1f3bd4499375fc$export$958d0ae7f2977ae4), $fd1f3bd4499375fc$export$d2dc61f58390201c);
var $fd1f3bd4499375fc$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $fd1f3bd4499375fc$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $fd1f3bd4499375fc$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $fd1f3bd4499375fc$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $fd1f3bd4499375fc$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $fd1f3bd4499375fc$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.subtler": "var(--ds-background-danger-subtler, #FFBDAD)",
    "color.background.danger.subtler.hovered": "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    "color.background.danger.subtler.pressed": "var(--ds-background-danger-subtler-pressed, #FF7452)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.subtler": "var(--ds-background-warning-subtler, #FFF0B3)",
    "color.background.warning.subtler.hovered": "var(--ds-background-warning-subtler-hovered, #FFE380)",
    "color.background.warning.subtler.pressed": "var(--ds-background-warning-subtler-pressed, #FFC400)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.subtler": "var(--ds-background-success-subtler, #ABF5D1)",
    "color.background.success.subtler.hovered": "var(--ds-background-success-subtler-hovered, #79F2C0)",
    "color.background.success.subtler.pressed": "var(--ds-background-success-subtler-pressed, #57D9A3)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.subtler": "var(--ds-background-discovery-subtler, #C0B6F2)",
    "color.background.discovery.subtler.hovered": "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    "color.background.discovery.subtler.pressed": "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.subtler": "var(--ds-background-information-subtler, #B3D4FF)",
    "color.background.information.subtler.hovered": "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    "color.background.information.subtler.pressed": "var(--ds-background-information-subtler-pressed, #2684FF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $fd1f3bd4499375fc$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.danger.bolder": "var(--ds-text-danger-bolder, #BF2600)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.warning.bolder": "var(--ds-text-warning-bolder, #974F0C)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.success.bolder": "var(--ds-text-success-bolder, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.discovery.bolder": "var(--ds-text-discovery-bolder, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.information.bolder": "var(--ds-text-information-bolder, #0747A6)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $fd1f3bd4499375fc$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $fd1f3bd4499375fc$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $fd1f3bd4499375fc$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.selected": "var(--ds-border-width-selected, 2px)",
    "border.width.focused": "var(--ds-border-width-focused, 2px)"
};
var $fd1f3bd4499375fc$export$3c0a6c3e64bb180d = {
    "radius.xsmall": "var(--ds-radius-xsmall, 2px)",
    "radius.small": "var(--ds-radius-small, 3px)",
    "radius.medium": "var(--ds-radius-medium, 6px)",
    "radius.large": "var(--ds-radius-large, 8px)",
    "radius.xlarge": "var(--ds-radius-xlarge, 12px)",
    "radius.xxlarge": "var(--ds-radius-xxlarge, 16px)",
    "radius.full": "var(--ds-radius-full, 9999px)",
    "radius.tile": "var(--ds-radius-tile, 25%)"
};
var $fd1f3bd4499375fc$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 653 20px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 653 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 653 32px/36px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 653 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $fd1f3bd4499375fc$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 653)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $fd1f3bd4499375fc$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $fd1f3bd4499375fc$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $fd1f3bd4499375fc$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $fd1f3bd4499375fc$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $fd1f3bd4499375fc$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $fd1f3bd4499375fc$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $dnfL5.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $fd1f3bd4499375fc$export$e615f061ca585a6c = $fd1f3bd4499375fc$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7(spacingProperty, $fd1f3bd4499375fc$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fd1f3bd4499375fc$export$bf46c3f9eeafc71f = $fd1f3bd4499375fc$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7(spacingProperty, $fd1f3bd4499375fc$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fd1f3bd4499375fc$export$e7af83bafe7f9e63 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("backgroundColor", $fd1f3bd4499375fc$export$d1d79bf68ac056bd);
var $fd1f3bd4499375fc$export$3a1bcba60b23d7f0 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("color", $fd1f3bd4499375fc$export$8473307aa00d6ea1);
var $fd1f3bd4499375fc$export$45f3f4fe16f9f7d5 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("fontWeight", $fd1f3bd4499375fc$export$303e322c6b1ed114);
var $fd1f3bd4499375fc$export$68cc305da27dbaa4 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("fontFamily", $fd1f3bd4499375fc$export$3c7e9587132614b4);
var $fd1f3bd4499375fc$export$128f10c238242f83 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("font", $fd1f3bd4499375fc$export$6ffa317d5e70375);
var $fd1f3bd4499375fc$export$219d364c0da35ae4 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("font", $fd1f3bd4499375fc$export$236bfe3a33ef1292);
var $fd1f3bd4499375fc$export$38845ca010b93505 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("fontWeight", $fd1f3bd4499375fc$export$855cfd311192d666);
var $fd1f3bd4499375fc$export$ff257d957d48c421 = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7((0, $3a8b285751820f4e$export$9d7b58831ae93caa), $fd1f3bd4499375fc$export$41a358c9c2356760);
var $fd1f3bd4499375fc$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $fd1f3bd4499375fc$export$41a358c9c2356760[color] !== undefined;
};
var $fd1f3bd4499375fc$export$7001ce64d9ff7c7f = $fd1f3bd4499375fc$export$ca0f9c2de39ffed7("font", $fd1f3bd4499375fc$export$b805719bc8cb376);



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $dnfL5 = parcelRequire("dnfL5");


var $hPtJY = parcelRequire("hPtJY");
function $cd218cf1334f0efa$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cd218cf1334f0efa$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cd218cf1334f0efa$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cd218cf1334f0efa$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cd218cf1334f0efa$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cd218cf1334f0efa$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $cd218cf1334f0efa$export$9a199fbafee0014e = {
    backgroundColor: (0, $fd1f3bd4499375fc$export$d1d79bf68ac056bd),
    blockSize: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderBottomColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderLeftColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $fd1f3bd4499375fc$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    borderWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    bottom: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    boxShadow: (0, $fd1f3bd4499375fc$export$7aff6e7ba39bb774),
    color: (0, $fd1f3bd4499375fc$export$8473307aa00d6ea1),
    columnGap: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    font: (0, $fd1f3bd4499375fc$export$6ffa317d5e70375),
    fontFamily: (0, $fd1f3bd4499375fc$export$3c7e9587132614b4),
    fontWeight: (0, $fd1f3bd4499375fc$export$303e322c6b1ed114),
    gap: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    height: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    inlineSize: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    inset: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    insetBlock: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    insetBlockEnd: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    insetBlockStart: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    insetInline: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    insetInlineEnd: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    insetInlineStart: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    left: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    margin: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginBlock: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginBlockEnd: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginBlockStart: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginBottom: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginInline: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginInlineEnd: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginInlineStart: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginLeft: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginRight: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    marginTop: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    maxBlockSize: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    maxHeight: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    maxWidth: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    minBlockSize: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    minHeight: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    minInlineSize: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    minWidth: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    opacity: (0, $fd1f3bd4499375fc$export$daf94a976c798b4f),
    outlineColor: (0, $fd1f3bd4499375fc$export$1531ad5bb3fbedac),
    outlineOffset: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    outlineWidth: (0, $fd1f3bd4499375fc$export$e1b83c5210c471b8),
    padding: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingBlock: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingBottom: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingInline: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingLeft: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingRight: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    paddingTop: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    right: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    rowGap: (0, $fd1f3bd4499375fc$export$958d0ae7f2977ae4),
    top: (0, $fd1f3bd4499375fc$export$632685d741f3dbbf),
    width: (0, $fd1f3bd4499375fc$export$6ccdbebca2ee545f),
    zIndex: (0, $fd1f3bd4499375fc$export$b5f31a7e431d2eab)
};
var $cd218cf1334f0efa$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $cd218cf1334f0efa$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $cd218cf1334f0efa$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $cd218cf1334f0efa$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $cd218cf1334f0efa$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($cd218cf1334f0efa$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $cd218cf1334f0efa$var$safeSelectors.test(key)) {
            styleObj[key] = $cd218cf1334f0efa$var$_transformStyles(value);
            return;
        }
        if ($cd218cf1334f0efa$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($cd218cf1334f0efa$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $cd218cf1334f0efa$export$9a199fbafee0014e)) return;
        var tokenValue = $cd218cf1334f0efa$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $cd218cf1334f0efa$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $cd218cf1334f0efa$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $cd218cf1334f0efa$var$uniqueSymbol, (0, $dnfL5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $cd218cf1334f0efa$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $cd218cf1334f0efa$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $cd218cf1334f0efa$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$cd218cf1334f0efa$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $cd218cf1334f0efa$export$f6c783d06584602c(style) {
    return $cd218cf1334f0efa$var$baseXcss(style);
}


var $d5c9481cef10e92d$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d5c9481cef10e92d$var$_excluded2 = [
    "className"
];
var $d5c9481cef10e92d$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d5c9481cef10e92d$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $d5c9481cef10e92d$var$_excluded2);
    var resolvedStyles = (0, $cd218cf1334f0efa$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $dnfL5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d5c9481cef10e92d$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fd1f3bd4499375fc$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fd1f3bd4499375fc$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $fd1f3bd4499375fc$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fd1f3bd4499375fc$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $dnfL5.jsx)((0, $393c8d6844b3eb51$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d5c9481cef10e92d$export$2e2bcd8739ae039 = $d5c9481cef10e92d$export$e71c4d32a2263218;
var $d5c9481cef10e92d$var$baseStyles = (0, $dnfL5.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-sort
 */ var $e3d8e0ef68442bb6$var$baseResetStyles = (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
    display: "table-cell",
    verticalAlign: "middle",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":first-of-type": {
        paddingInlineStart: "space.100"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":last-of-type": {
        paddingInlineEnd: "space.100"
    }
});
var $e3d8e0ef68442bb6$var$alignMapStyles = {
    text: (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
        textAlign: "left"
    }),
    icon: (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
        textAlign: "center"
    }),
    number: (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
        textAlign: "right"
    })
};
var $e3d8e0ef68442bb6$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, as = _ref.as, children = _ref.children, _ref$align = _ref.align, align = _ref$align === void 0 ? "text" : _ref$align, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? "space.100" : _ref$paddingBlock, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? "space.100" : _ref$paddingInline, backgroundColor = _ref.backgroundColor, scope = _ref.scope, width = _ref.width, xcss = _ref.xcss, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan, rowSpan = _ref.rowSpan;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = Array.isArray(xcss) ? xcss : [
        xcss
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5c9481cef10e92d$export$2e2bcd8739ae039), {
        xcss: [
            $e3d8e0ef68442bb6$var$baseResetStyles,
            $e3d8e0ef68442bb6$var$alignMapStyles[align]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(styles)),
        ref: ref,
        scope: scope,
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        testId: testId,
        style: width ? {
            width: width
        } : undefined,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        rowSpan: rowSpan
    }, children);
});


var $2fa521c4fe830903$var$_excluded = [
    "testId"
];
var $2fa521c4fe830903$export$9cf5b401f969f5e3 = function TD(_ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $2fa521c4fe830903$var$_excluded);
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e3d8e0ef68442bb6$export$41ad0bbfa4755cac), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "td",
        testId: testId
    }, props)));
};


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
var $4f19ca4d0a8ccd1b$export$2a909d4c080cb420 = {
    checked: [],
    allChecked: false,
    anyChecked: false,
    maxChecked: 0,
    selectionStart: -1,
    previousSelection: []
};
var $4f19ca4d0a8ccd1b$var$arrayFromRange = function arrayFromRange(from, to) {
    var startIdx = from;
    var stopIdx = to;
    var increment = 1;
    if (from > to) {
        startIdx = to;
        stopIdx = from;
        increment = 0;
    }
    // Create an array with values between `from` and `to` - either ascending or descending
    return Array.from({
        length: stopIdx - startIdx
    }, function(_, i) {
        return startIdx + i + increment;
    });
};
function $4f19ca4d0a8ccd1b$var$reducer(_ref, action) {
    var checked = _ref.checked, anyChecked = _ref.anyChecked, maxChecked = _ref.maxChecked, selectionStart = _ref.selectionStart, previousSelection = _ref.previousSelection;
    switch(action.type){
        case "toggle_selection":
            var _action$value = action.value, id = _action$value.id, shiftHeld = _action$value.shiftHeld;
            var updated = checked.slice();
            var newSelectionStart = selectionStart;
            var newPreviousSelection = previousSelection.slice();
            if (shiftHeld) {
                if (checked.length > 0) {
                    var newIds = $4f19ca4d0a8ccd1b$var$arrayFromRange(selectionStart, id); // create an array of the new ids
                    // Uncheck ids from the previous selection.
                    // This is done to maintain consistency with Shift-select behaviour elsewhere (e.g. macOS)
                    // TODO: Code could be improved to only remove ids that are not included in the new range, avoiding needing to re-add them below
                    updated = updated.filter(function(id) {
                        return !previousSelection.includes(id);
                    });
                    newIds.forEach(function(id) {
                        return updated.indexOf(id) === -1 && updated.push(id);
                    } // If the new id is not already checked, check it
                    );
                    newPreviousSelection = newIds; // Maintain an array of the previous selection to allow for consistent Shift-select behaviour
                }
            } else {
                var checkedIndex = checked.indexOf(id); // is index already checked
                if (checkedIndex !== -1) updated.splice(checkedIndex, 1); // if index is already checked, uncheck
                else updated.push(id); // if index is not checked, check
                newSelectionStart = id; // Reset selection start id to this non-shift-selected id
                newPreviousSelection = []; // Reset previous selection as it is no longer relevant once a new non-shift-selected id is added
            }
            var _anyChecked = updated.length > 0;
            return {
                checked: updated,
                allChecked: updated.length === maxChecked,
                anyChecked: _anyChecked || Boolean(updated[id]),
                maxChecked: maxChecked,
                selectionStart: newSelectionStart,
                previousSelection: newPreviousSelection
            };
        case "set_root":
            return {
                checked: action.value ? Array.from(Array(maxChecked).keys()) : [],
                allChecked: action.value,
                anyChecked: Boolean(action.value),
                maxChecked: maxChecked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        case "set_max":
            var max = action.value;
            return {
                maxChecked: max,
                allChecked: checked.length === max,
                anyChecked: anyChecked,
                checked: checked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        default:
            throw new Error();
    }
}
function $4f19ca4d0a8ccd1b$var$useSelectable() {
    var _useReducer = (0, $acw62.useReducer)($4f19ca4d0a8ccd1b$var$reducer, $4f19ca4d0a8ccd1b$export$2a909d4c080cb420), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var toggleSelection = (0, $acw62.useCallback)(function(id, shiftHeld) {
        dispatch({
            type: "toggle_selection",
            value: {
                id: id,
                shiftHeld: shiftHeld
            }
        });
    }, []);
    var setAll = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "set_root",
            value: true
        });
    }, []);
    var removeAll = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "set_root",
            value: false
        });
    }, []);
    var setMax = (0, $acw62.useCallback)(function(max) {
        dispatch({
            type: "set_max",
            value: max
        });
    }, []);
    return [
        state,
        {
            setAll: setAll,
            removeAll: removeAll,
            toggleSelection: toggleSelection,
            setMax: setMax
        }
    ];
}
var $4f19ca4d0a8ccd1b$export$2e2bcd8739ae039 = $4f19ca4d0a8ccd1b$var$useSelectable;


var $c024f2fe71d9b05b$var$SelectionContext = /*#__PURE__*/ (0, $acw62.createContext)([
    (0, $4f19ca4d0a8ccd1b$export$2a909d4c080cb420),
    {}
]);
/**
 * __Selection provider__
 *
 * A selection provider injects selection specific state into the table.
 */ var $c024f2fe71d9b05b$var$SelectionProvider = function SelectionProvider(_ref) {
    var children = _ref.children;
    var reducer = (0, $4f19ca4d0a8ccd1b$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c024f2fe71d9b05b$var$SelectionContext.Provider, {
        value: reducer
    }, children);
};
var $c024f2fe71d9b05b$export$a97c3cc4bf1da1ca = function useSelection() {
    return (0, $acw62.useContext)($c024f2fe71d9b05b$var$SelectionContext);
};
var $c024f2fe71d9b05b$export$2e2bcd8739ae039 = $c024f2fe71d9b05b$var$SelectionProvider;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
var $40b776a5213c5ac6$export$21ebc1ba2b2bee67 = function useSorting(sortKey) {
    var _useState = (0, $acw62.useState)(sortKey), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), localSortKey = _useState2[0], setLocalSortKey = _useState2[1];
    var _useState3 = (0, $acw62.useState)(), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), localSortDirection = _useState4[0], setLocalSortDirection = _useState4[1];
    var toggleSortDirection = (0, $acw62.useCallback)(function() {
        setLocalSortDirection(function(oldLocalSortDirection) {
            switch(oldLocalSortDirection){
                case undefined:
                    return "ascending";
                case "ascending":
                    return "descending";
                case "descending":
                    return "ascending";
            }
        });
    }, []);
    var setSortState = (0, $acw62.useCallback)(function(key) {
        setLocalSortKey(function(localSortKey) {
            if (key !== localSortKey) {
                // sorting by different column
                setLocalSortDirection("ascending");
                return key;
            } else toggleSortDirection();
            return localSortKey;
        });
    }, [
        toggleSortDirection
    ]);
    var sortFn = (0, $acw62.useCallback)(function(rowA, rowB) {
        if (localSortKey === "unset") return 0;
        var ascendingComparator = rowA[localSortKey] < rowB[localSortKey] ? -1 : 1;
        return localSortDirection === "ascending" ? ascendingComparator : -ascendingComparator;
    }, [
        localSortDirection,
        localSortKey
    ]);
    return {
        sortKey: localSortKey,
        sortDirection: localSortDirection,
        setSortState: setSortState,
        sortFn: sortFn
    };
};



var $acw62 = parcelRequire("acw62");
/**
 * An empty function which does nothing.
 */ function $ba70261a691f9601$export$2e2bcd8739ae039() {}


function $049bd5eb1bba73a3$var$generateContext() {
    return /*#__PURE__*/ (0, $acw62.createContext)({
        isSelectable: false,
        sortKey: "unset",
        setSortState: (0, $ba70261a691f9601$export$2e2bcd8739ae039),
        sortFn: function sortFn() {
            return 0;
        }
    });
}
var $049bd5eb1bba73a3$var$TableContext = $049bd5eb1bba73a3$var$generateContext();
function $049bd5eb1bba73a3$export$d542ac353845c9cf(_ref) {
    var children = _ref.children, state = _ref.state;
    return(/*#__PURE__*/ // @ts-expect-error
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($049bd5eb1bba73a3$var$TableContext.Provider, {
        value: state
    }, children));
}
var $049bd5eb1bba73a3$export$25bceaac3c7e4dc7 = function useTable() {
    return(// @ts-expect-error
    (0, $acw62.useContext)($049bd5eb1bba73a3$var$TableContext));
};



var $acw62 = parcelRequire("acw62");
var $2d5ca0b28ebd4a32$export$54ec01a60f47d33d = function Table(_ref) {
    var children = _ref.children, testId = _ref.testId, summary = _ref.summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": testId
    }, summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", null, summary), children);
};


/**
 * __Table__
 *
 * A data table is used to display dynamic data.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ function $5b66b205d90a8beb$var$Table(_ref) {
    var children = _ref.children, isSelectable = _ref.isSelectable, _ref$sortKey = _ref.sortKey, sortKey = _ref$sortKey === void 0 ? "unset" : _ref$sortKey, testId = _ref.testId;
    var _useSorting = (0, $40b776a5213c5ac6$export$21ebc1ba2b2bee67)(sortKey), localSortKey = _useSorting.sortKey, sortDirection = _useSorting.sortDirection, setSortState = _useSorting.setSortState, sortFn = _useSorting.sortFn;
    var tableProviderState = (0, $acw62.useMemo)(function() {
        return {
            isSelectable: isSelectable,
            sortKey: localSortKey,
            sortDirection: sortDirection,
            setSortState: setSortState,
            sortFn: sortFn
        };
    }, [
        isSelectable,
        localSortKey,
        setSortState,
        sortDirection,
        sortFn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $049bd5eb1bba73a3$export$d542ac353845c9cf), {
        state: tableProviderState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2d5ca0b28ebd4a32$export$54ec01a60f47d33d), {
        testId: testId
    }, isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c024f2fe71d9b05b$export$2e2bcd8739ae039), null, children) : children));
}
var $5b66b205d90a8beb$export$2e2bcd8739ae039 = $5b66b205d90a8beb$var$Table;


var $acw62 = parcelRequire("acw62");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");

var $bv4qN = parcelRequire("bv4qN");

var $acw62 = parcelRequire("acw62");
var $d60ceef540399d30$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $d60ceef540399d30$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($d60ceef540399d30$var$HasTextAncestorContext);
};
var $d60ceef540399d30$export$ae933c6cbe5643ad = $d60ceef540399d30$var$HasTextAncestorContext.Provider;




var $84366bdccba0e8c3$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $84366bdccba0e8c3$var$resetStyles = (0, $dnfL5.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $84366bdccba0e8c3$var$strongStyles = (0, $dnfL5.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $84366bdccba0e8c3$var$emStyles = (0, $dnfL5.css)({
    fontStyle: "italic"
});
var $84366bdccba0e8c3$var$textAlignMap = {
    center: (0, $dnfL5.css)({
        textAlign: "center"
    }),
    end: (0, $dnfL5.css)({
        textAlign: "end"
    }),
    start: (0, $dnfL5.css)({
        textAlign: "start"
    })
};
var $84366bdccba0e8c3$var$truncationStyles = (0, $dnfL5.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $84366bdccba0e8c3$var$wordBreakMap = {
    breakAll: (0, $dnfL5.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $84366bdccba0e8c3$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $393c8d6844b3eb51$export$1aeb4f6b93c4540d)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $fd1f3bd4499375fc$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $fd1f3bd4499375fc$export$2185ce37f9bdd963)[surface];
    return "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $84366bdccba0e8c3$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $bv4qN.default)($84366bdccba0e8c3$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $d60ceef540399d30$export$9322276ec105d055)();
    var color = $84366bdccba0e8c3$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $dnfL5.jsx)(Component, {
        ref: ref,
        css: [
            $84366bdccba0e8c3$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $fd1f3bd4499375fc$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $fd1f3bd4499375fc$export$3a1bcba60b23d7f0)[color],
            maxLines && $84366bdccba0e8c3$var$truncationStyles,
            maxLines === 1 && $84366bdccba0e8c3$var$wordBreakMap.breakAll,
            align && $84366bdccba0e8c3$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $fd1f3bd4499375fc$export$38845ca010b93505)[weight],
            Component === "em" && $84366bdccba0e8c3$var$emStyles,
            Component === "strong" && $84366bdccba0e8c3$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $dnfL5.jsx)((0, $d60ceef540399d30$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $84366bdccba0e8c3$export$2e2bcd8739ae039 = $84366bdccba0e8c3$var$Text;



var $acw62 = parcelRequire("acw62");

var $efbc3f7554e2e652$export$2b39a3648955dd09 = function TH(_ref) {
    var children = _ref.children, testId = _ref.testId, align = _ref.align, scope = _ref.scope, backgroundColor = _ref.backgroundColor, width = _ref.width, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e3d8e0ef68442bb6$export$41ad0bbfa4755cac), {
        as: "th",
        testId: testId,
        align: align,
        scope: scope,
        width: width,
        backgroundColor: backgroundColor,
        sortDirection: sortDirection,
        colSpan: colSpan
    }, children);
};


/**
 * __HeadCell__
 *
 * HeadCell element
 */ var $6bfd699cf662c59e$var$HeadCell = function HeadCell(_ref) {
    var children = _ref.children, align = _ref.align, testId = _ref.testId, backgroundColor = _ref.backgroundColor, _ref$scope = _ref.scope, scope = _ref$scope === void 0 ? "col" : _ref$scope;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $efbc3f7554e2e652$export$2b39a3648955dd09), {
        scope: scope,
        align: align,
        testId: testId,
        backgroundColor: backgroundColor
    }, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84366bdccba0e8c3$export$2e2bcd8739ae039), {
        weight: "medium"
    }, children));
};
var $6bfd699cf662c59e$export$2e2bcd8739ae039 = $6bfd699cf662c59e$var$HeadCell;


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1a5d670c554b6284$var$ExpandContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isExpanded: false,
    toggleExpanded: (0, $ba70261a691f9601$export$2e2bcd8739ae039)
});
var $1a5d670c554b6284$export$2994164b482c6fe4 = function ExpandContextProvider(_ref) {
    var children = _ref.children, isExpandedProp = _ref.isExpanded, _ref$isDefaultExpande = _ref.isDefaultExpanded, isDefaultExpanded = _ref$isDefaultExpande === void 0 ? false : _ref$isDefaultExpande;
    var _useState = (0, $acw62.useState)(isDefaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var toggleExpanded = (0, $acw62.useCallback)(function() {
        setIsExpanded(function(v) {
            return !v;
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1a5d670c554b6284$var$ExpandContext.Provider, {
        value: {
            isExpanded: isExpandedProp || isExpanded,
            toggleExpanded: toggleExpanded
        }
    }, children);
};
var $1a5d670c554b6284$var$useExpand = function useExpand() {
    return (0, $acw62.useContext)($1a5d670c554b6284$var$ExpandContext);
};
var $1a5d670c554b6284$export$2e2bcd8739ae039 = $1a5d670c554b6284$var$useExpand;



var $acw62 = parcelRequire("acw62");
var $f298fb830cd9c4bd$var$ExpandContentContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isExpandableContent: false
});
var $f298fb830cd9c4bd$export$bc52fac1a043e39f = function ExpandContentContextProvider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f298fb830cd9c4bd$var$ExpandContentContext.Provider, {
        value: {
            isExpandableContent: true
        }
    }, children);
};
var $f298fb830cd9c4bd$var$useExpandContent = function useExpandContent() {
    return (0, $acw62.useContext)($f298fb830cd9c4bd$var$ExpandContentContext);
};
var $f298fb830cd9c4bd$export$2e2bcd8739ae039 = $f298fb830cd9c4bd$var$useExpandContent;



var $acw62 = parcelRequire("acw62");
var $dc39d2ad6e7f44b5$var$RowContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $dc39d2ad6e7f44b5$export$81981d840a2ece5 = function useRowId() {
    return (0, $acw62.useContext)($dc39d2ad6e7f44b5$var$RowContext);
};
var $dc39d2ad6e7f44b5$export$329ef9142f16ee64 = $dc39d2ad6e7f44b5$var$RowContext.Provider;




var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");
var $9996c6835537bd19$var$TableBodyContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $9996c6835537bd19$export$c0d7aba0938441d = $9996c6835537bd19$var$TableBodyContext.Provider;
var $9996c6835537bd19$export$e4e48199ad91605c = function useTableBody() {
    var hasTableBody = (0, $acw62.useContext)($9996c6835537bd19$var$TableBodyContext);
    (0, $bv4qN.default)(hasTableBody, "<Row /> must be nested inside a <TableBody>");
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
/* checkbox.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $aafdd1c97efaa03f$var$ATOMIC_GROUP_LENGTH = 5;
function $aafdd1c97efaa03f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $aafdd1c97efaa03f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $6Bvm3 = parcelRequire("6Bvm3");

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $7c16a8132ce44b77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c16a8132ce44b77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c16a8132ce44b77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c16a8132ce44b77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7c16a8132ce44b77$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7c16a8132ce44b77$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $7c16a8132ce44b77$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $7c16a8132ce44b77$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $7c16a8132ce44b77$var$_objectSpread($7c16a8132ce44b77$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $a3a398f01d0bc4c2$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a3a398f01d0bc4c2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a3a398f01d0bc4c2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a3a398f01d0bc4c2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a3a398f01d0bc4c2$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a3a398f01d0bc4c2$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a3a398f01d0bc4c2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $a3a398f01d0bc4c2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $a3a398f01d0bc4c2$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a3a398f01d0bc4c2$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $7c16a8132ce44b77$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");
var $8e9ac6e3afbb3325$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $9ZLvy.default));
};


function $e388ce8a1343fa50$export$5bf35293e545f20c() {
    var analyticsContext = (0, $8e9ac6e3afbb3325$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6Bvm3.useCallbackOne)(function(payload) {
        return new (0, $a3a398f01d0bc4c2$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $505c184f94be30a2$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $724cf882b52903cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $724cf882b52903cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $724cf882b52903cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $724cf882b52903cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $724cf882b52903cd$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $e388ce8a1343fa50$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $505c184f94be30a2$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $505c184f94be30a2$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $724cf882b52903cd$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $41YNz = parcelRequire("41YNz");
function $463a23ad31479961$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") ref.current = value;
        });
    };
}


/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $e016f68edd4206ae$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $e016f68edd4206ae$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $e016f68edd4206ae$var$CheckboxIcon = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $acw62.useMemo)(function() {
        return $e016f68edd4206ae$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $aafdd1c97efaa03f$export$2e2bcd8739ae039)([
            $e016f68edd4206ae$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $acw62.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $aafdd1c97efaa03f$export$2e2bcd8739ae039)([
            $e016f68edd4206ae$var$svgStyles.rect
        ])
    }), icon));
});
var $e016f68edd4206ae$export$2e2bcd8739ae039 = $e016f68edd4206ae$var$CheckboxIcon;


/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $acw62 = parcelRequire("acw62");

var $01605f002e11c02e$var$baseStyles = null;
var $01605f002e11c02e$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $01605f002e11c02e$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $01605f002e11c02e$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $01605f002e11c02e$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $01605f002e11c02e$var$disabledCheckedStyles = null;
function $01605f002e11c02e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("label", {
        className: (0, $aafdd1c97efaa03f$export$2e2bcd8739ae039)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1tvo _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}


/* label-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $88c353e6551a7863$var$labelTextStyles = null;
function $88c353e6551a7863$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $aafdd1c97efaa03f$export$2e2bcd8739ae039)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}


/* required-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $acw62 = parcelRequire("acw62");

var $a621d73e0f85bb19$var$requiredIndicatorStyles = null;
function $a621d73e0f85bb19$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": true,
        className: (0, $aafdd1c97efaa03f$export$2e2bcd8739ae039)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}


var $a5d0e37b02b19a63$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $a5d0e37b02b19a63$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $a5d0e37b02b19a63$var$Checkbox = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a5d0e37b02b19a63$var$_excluded);
    var _useState = (0, $acw62.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $724cf882b52903cd$export$a4687b0234b40e28)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "checkbox",
        packageName: "@atlaskit/checkbox",
        packageVersion: "0.0.0-development"
    });
    var internalRef = (0, $acw62.useRef)(null);
    var mergedRefs = (0, $463a23ad31479961$export$2e2bcd8739ae039)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $acw62.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $01605f002e11c02e$export$2e2bcd8739ae039), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $aafdd1c97efaa03f$export$2e2bcd8739ae039)([
            $a5d0e37b02b19a63$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? "true" : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? "true" : undefined
    })), /*#__PURE__*/ $acw62.createElement((0, $e016f68edd4206ae$export$2e2bcd8739ae039), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $acw62.createElement((0, $88c353e6551a7863$export$2e2bcd8739ae039), null, label, isRequired && /*#__PURE__*/ $acw62.createElement((0, $a621d73e0f85bb19$export$2e2bcd8739ae039), null)));
}));
$a5d0e37b02b19a63$var$Checkbox.displayName = "Checkbox";
var $a5d0e37b02b19a63$export$2e2bcd8739ae039 = $a5d0e37b02b19a63$var$Checkbox;






var $acw62 = parcelRequire("acw62");


var $7512fc73e55de485$var$spacingStyles = (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
    width: "2rem",
    padding: "space.0"
});
var $7512fc73e55de485$export$1049d18762739f1d = function SelectableCell(_ref) {
    var children = _ref.children, as = _ref.as;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e3d8e0ef68442bb6$export$41ad0bbfa4755cac), {
        as: as,
        xcss: $7512fc73e55de485$var$spacingStyles
    }, children);
};


var $57a151df9bbc7c01$var$SelectableCellComponent = function SelectableCellComponent() {
    var _useSelection = (0, $c024f2fe71d9b05b$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 2), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked, toggleSelection = _useSelection2[1].toggleSelection;
    var idx = (0, $dc39d2ad6e7f44b5$export$81981d840a2ece5)();
    var isChecked = (0, $acw62.useMemo)(function() {
        return allChecked || checked.includes(idx);
    }, [
        allChecked,
        checked,
        idx
    ]);
    var onChange = (0, $acw62.useCallback)(function(e) {
        return toggleSelection === null || toggleSelection === void 0 ? void 0 : toggleSelection(idx, e.nativeEvent.shiftKey);
    }, [
        idx,
        toggleSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7512fc73e55de485$export$1049d18762739f1d), {
        as: "td"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a5d0e37b02b19a63$export$2e2bcd8739ae039), {
        isChecked: isChecked,
        onChange: onChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $79d5c31dba16affa$export$2e2bcd8739ae039), null, "Select row ", idx + 1)
    }));
};
var $57a151df9bbc7c01$var$SelectableCell = /*#__PURE__*/ (0, $acw62.memo)($57a151df9bbc7c01$var$SelectableCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$57a151df9bbc7c01$export$2e2bcd8739ae039 = $57a151df9bbc7c01$var$SelectableCell;



/* tr.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");


/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $62f56889b3a58c38$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $62f56889b3a58c38$var$_excluded2 = [
    "className"
];
var $62f56889b3a58c38$var$focusRingStyles = null;
var $62f56889b3a58c38$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $62f56889b3a58c38$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $62f56889b3a58c38$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $62f56889b3a58c38$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9dvtP.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $62f56889b3a58c38$export$2e2bcd8739ae039 = $62f56889b3a58c38$var$Focusable;


var $df4b7c649bb550a3$var$styles = {
    base: "_19itglyw _4t3i1wto _kqswh2mm _hpylidpf _btyzidpf",
    selected: "_bfhkcslv _irr3quvt",
    subitem: "_bfhkm7j4",
    bodyRow: "_1r62e4h9 _12ornqa1 _1ezz1tr0 _irr3134o"
};
var $df4b7c649bb550a3$export$5582bd7183a5e873 = function TR(_ref) {
    var children = _ref.children, testId = _ref.testId, isSelected = _ref.isSelected, _ref$isBodyRow = _ref.isBodyRow, isBodyRow = _ref$isBodyRow === void 0 ? true : _ref$isBodyRow, isSubitem = _ref.isSubitem;
    return /*#__PURE__*/ $acw62.createElement((0, $62f56889b3a58c38$export$2e2bcd8739ae039), {
        as: "tr",
        isInset: true,
        tabIndex: -1,
        "aria-selected": isSelected,
        testId: testId,
        xcss: (0, $1b267db47313e17e$export$a274e22fb40f762e)($df4b7c649bb550a3$var$styles.base, isBodyRow && $df4b7c649bb550a3$var$styles.bodyRow, isSelected && $df4b7c649bb550a3$var$styles.selected, isSubitem && $df4b7c649bb550a3$var$styles.subitem)
    }, children);
};


/**
 * __Row__
 *
 * A table row.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ var $94dcad7497a0e822$var$Row = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId;
    // To ensure valid nesting
    (0, $9996c6835537bd19$export$e4e48199ad91605c)();
    // to access table state
    var _useTable = (0, $049bd5eb1bba73a3$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $c024f2fe71d9b05b$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 1), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked;
    var _useExpand = (0, $1a5d670c554b6284$export$2e2bcd8739ae039)(), isExpanded = _useExpand.isExpanded;
    var _useExpandContent = (0, $f298fb830cd9c4bd$export$2e2bcd8739ae039)(), isExpandableContent = _useExpandContent.isExpandableContent;
    var rowId = (0, $dc39d2ad6e7f44b5$export$81981d840a2ece5)();
    var isSelected = (0, $acw62.useMemo)(function() {
        if (!isSelectable || rowId === undefined) return undefined;
        return allChecked || checked.includes(rowId);
    }, [
        allChecked,
        checked,
        isSelectable,
        rowId
    ]);
    if (isExpanded === false && isExpandableContent) return null;
    var selectableCell = isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57a151df9bbc7c01$export$2e2bcd8739ae039), null);
    if (isSelectable && isExpandableContent) selectableCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7512fc73e55de485$export$1049d18762739f1d), {
        as: "td"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df4b7c649bb550a3$export$5582bd7183a5e873), {
        isSelected: isSelected,
        testId: testId,
        isSubitem: isExpandableContent
    }, selectableCell, children);
});
var $94dcad7497a0e822$export$2e2bcd8739ae039 = $94dcad7497a0e822$var$Row;


var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");




/* tbody.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $28b5ed7cd0817c3a$var$bodyStyles = null;
var $28b5ed7cd0817c3a$export$7005b8a93a167348 = function TBody(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("tbody", {
        className: (0, $9dvtP.default)([
            "_19itglyw _kqswh2mm _9v7aidpf _18postnw _8x3u8fd9 _aetrb3bt _11fnglyw"
        ])
    }, children);
};


var $05e8f78d78363646$var$_excluded = [
    "idx"
];
function $05e8f78d78363646$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05e8f78d78363646$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05e8f78d78363646$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05e8f78d78363646$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * __Table body__
 */ function $05e8f78d78363646$var$TBody(_ref) {
    var rows = _ref.rows, children = _ref.children;
    var _useTable = (0, $049bd5eb1bba73a3$export$25bceaac3c7e4dc7)(), sortFn = _useTable.sortFn;
    var _useSelection = (0, $c024f2fe71d9b05b$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 2), _state = _useSelection2[0], _useSelection2$ = _useSelection2[1], removeAll = _useSelection2$.removeAll, setMax = _useSelection2$.setMax;
    // TODO: this seems like something the user should control or opt into.
    (0, $acw62.useEffect)(function() {
        removeAll === null || removeAll === void 0 || removeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- When the rows change, we [currently] want to call removeAll.
    }, [
        rows
    ]);
    var childrenCount = (0, $acw62.Children).count(children);
    var rowsLength = rows === null || rows === void 0 ? void 0 : rows.length;
    // Set data length (via setMax) whenever data changes
    (0, $acw62.useEffect)(function() {
        var numRows = rowsLength !== null && rowsLength !== void 0 ? rowsLength : childrenCount;
        setMax === null || setMax === void 0 || setMax(numRows);
    }, [
        rowsLength,
        childrenCount,
        setMax
    ]);
    var sortedRows = (0, $acw62.useMemo)(function() {
        return rows === null || rows === void 0 ? void 0 : rows.map(function(row, idx) {
            return $05e8f78d78363646$var$_objectSpread($05e8f78d78363646$var$_objectSpread({}, row), {}, {
                idx: idx
            });
        }).sort(sortFn);
    }, [
        rows,
        sortFn
    ]);
    var renderedChildren = function() {
        if (typeof children === "function") return sortedRows === null || sortedRows === void 0 ? void 0 : sortedRows.map(function(_ref2) {
            var idx = _ref2.idx, row = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $05e8f78d78363646$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc39d2ad6e7f44b5$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, // @ts-expect-error
            children(row));
        });
        var childrenArray = Array.isArray(children) ? children : [
            children
        ];
        return childrenArray.map(function(row, idx) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc39d2ad6e7f44b5$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, row);
        });
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9996c6835537bd19$export$c0d7aba0938441d), {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28b5ed7cd0817c3a$export$7005b8a93a167348), null, renderedChildren));
}
var $05e8f78d78363646$export$2e2bcd8739ae039 = $05e8f78d78363646$var$TBody;


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dnfL5 = parcelRequire("dnfL5");


var $c9b23a4f6d3f4077$var$justifyContentMap = {
    start: (0, $dnfL5.css)({
        justifyContent: "start"
    }),
    center: (0, $dnfL5.css)({
        justifyContent: "center"
    }),
    end: (0, $dnfL5.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $dnfL5.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $dnfL5.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $dnfL5.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $dnfL5.css)({
        justifyContent: "stretch"
    })
};
var $c9b23a4f6d3f4077$var$flexDirectionMap = {
    column: (0, $dnfL5.css)({
        flexDirection: "column"
    }),
    row: (0, $dnfL5.css)({
        flexDirection: "row"
    })
};
var $c9b23a4f6d3f4077$var$flexWrapMap = {
    wrap: (0, $dnfL5.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $dnfL5.css)({
        flexWrap: "nowrap"
    })
};
var $c9b23a4f6d3f4077$var$alignItemsMap = {
    start: (0, $dnfL5.css)({
        alignItems: "start"
    }),
    center: (0, $dnfL5.css)({
        alignItems: "center"
    }),
    baseline: (0, $dnfL5.css)({
        alignItems: "baseline"
    }),
    end: (0, $dnfL5.css)({
        alignItems: "end"
    }),
    stretch: (0, $dnfL5.css)({
        alignItems: "stretch"
    })
};
var $c9b23a4f6d3f4077$var$baseStyles = (0, $dnfL5.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $c9b23a4f6d3f4077$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $cd218cf1334f0efa$export$a9c84988c8f81f2d)(xcss);
    return (0, $dnfL5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $c9b23a4f6d3f4077$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $fd1f3bd4499375fc$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $fd1f3bd4499375fc$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $fd1f3bd4499375fc$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $c9b23a4f6d3f4077$var$alignItemsMap[alignItems],
            direction && $c9b23a4f6d3f4077$var$flexDirectionMap[direction],
            justifyContent && $c9b23a4f6d3f4077$var$justifyContentMap[justifyContent],
            wrap && $c9b23a4f6d3f4077$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$c9b23a4f6d3f4077$var$Flex.displayName = "Flex";
var $c9b23a4f6d3f4077$export$2e2bcd8739ae039 = $c9b23a4f6d3f4077$var$Flex;


var $2bc65535524ee205$var$flexGrowMap = {
    hug: (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $2bc65535524ee205$var$separatorStyles = (0, $dnfL5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $2bc65535524ee205$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $dnfL5.jsx)("span", {
        css: $2bc65535524ee205$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $2bc65535524ee205$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $dnfL5.jsx)($2bc65535524ee205$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $dnfL5.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $2bc65535524ee205$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $dnfL5.jsx)((0, $c9b23a4f6d3f4077$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$2bc65535524ee205$var$Inline.displayName = "Inline";
var $2bc65535524ee205$export$2e2bcd8739ae039 = $2bc65535524ee205$var$Inline;






var $acw62 = parcelRequire("acw62");

var $358a317fd8889ab2$var$overlayStyles = (0, $cd218cf1334f0efa$export$f6c783d06584602c)({
    display: "flex",
    position: "absolute",
    inset: "space.0",
    insetInlineStart: "space.400"
});
var $358a317fd8889ab2$export$7e782ae264b7f61c = function BulkActionOverlay(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5c9481cef10e92d$export$2e2bcd8739ae039), {
        as: "th",
        paddingInline: "space.100",
        backgroundColor: "elevation.surface",
        xcss: $358a317fd8889ab2$var$overlayStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2bc65535524ee205$export$2e2bcd8739ae039), {
        space: "space.300",
        alignBlock: "center"
    }, children));
};



/* thead.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $acw62 = parcelRequire("acw62");

var $9dvtP = parcelRequire("9dvtP");
var $383387eafbb57e81$var$baseStyles = null;
var $383387eafbb57e81$export$c4c2bc57f2e82919 = function THead(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("thead", {
        className: (0, $9dvtP.default)([
            "_1r04idpf _19itglyw _179rhf6m _mqm25u6v _kqsw1if8 _1pbykb7n _bfhkvuon"
        ])
    }, children);
};



var $4fd48a36e666961f$var$THead = function THead(_ref) {
    var actions = _ref.actions, children = _ref.children;
    var _useTable = (0, $049bd5eb1bba73a3$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $c024f2fe71d9b05b$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useSelection, 2), state = _useSelection2[0], _useSelection2$ = _useSelection2[1], setAll = _useSelection2$.setAll, removeAll = _useSelection2$.removeAll;
    var isChecked = state.allChecked || state.anyChecked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $383387eafbb57e81$export$c4c2bc57f2e82919), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df4b7c649bb550a3$export$5582bd7183a5e873), {
        isBodyRow: false
    }, isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7512fc73e55de485$export$1049d18762739f1d), {
        as: "th"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a5d0e37b02b19a63$export$2e2bcd8739ae039), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $79d5c31dba16affa$export$2e2bcd8739ae039), {
            id: "select-all"
        }, "Select all rows"),
        onChange: isChecked ? removeAll : setAll,
        isChecked: isChecked,
        isIndeterminate: state.anyChecked && !state.allChecked
    })), children, isSelectable && isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $358a317fd8889ab2$export$7e782ae264b7f61c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #172B4D)",
            /* @ts-ignore migrate to Text */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)"
        }
    }, state.checked.length, " selected"), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2bc65535524ee205$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100"
    }, actions(state.checked)))));
};
var $4fd48a36e666961f$export$2e2bcd8739ae039 = $4fd48a36e666961f$var$THead;


function $f2f805f49af46a8b$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $f2f805f49af46a8b$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $f2f805f49af46a8b$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, "__esModule", {
        value: true,
        configurable: true
    });
}
/// <reference types="./types/custom.d.ts" />
var $f2f805f49af46a8b$var$$a69491ea5a126553$exports = {};
var $f2f805f49af46a8b$var$$5d4509b60606b6df$exports = {};
var $f2f805f49af46a8b$var$$660bd1c6cb41002a$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$660bd1c6cb41002a$exports, "Blockquote", ()=>$f2f805f49af46a8b$export$29a7a275fe11687);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$660bd1c6cb41002a$exports, "blockquoteStyles", ()=>$f2f805f49af46a8b$export$7a77f8e9665fa6b2);
const $f2f805f49af46a8b$export$29a7a275fe11687 = ({ children: children })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("blockquote", {
        css: (0, $dnfL5.css)($f2f805f49af46a8b$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $f2f805f49af46a8b$var$$660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $f2f805f49af46a8b$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    ...$f2f805f49af46a8b$var$$660bd1c6cb41002a$var$fontSizeStyles,
    span: $f2f805f49af46a8b$var$$660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};
var $f2f805f49af46a8b$var$$fec02fc26c7e145d$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fec02fc26c7e145d$exports, "ButtonSize", ()=>$f2f805f49af46a8b$export$5dd2748b7940a2a0);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fec02fc26c7e145d$exports, "ButtonAppearance", ()=>$f2f805f49af46a8b$export$261c9483fc4a455a);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fec02fc26c7e145d$exports, "Button", ()=>$f2f805f49af46a8b$export$353f5b6fc5456de1);
const $f2f805f49af46a8b$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf = ({ label: label, type: type, clickHandler: clickHandler, iconBefore: iconBefore, iconAfter: iconAfter, appearance: appearance, testId: testId, href: href, target: target, fullWidth: fullWidth = false, disabled: disabled = false, isLoading: isLoading = false, selected: selected = false })=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $c071f8024d1b8ff7$export$2e2bcd8739ae039), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: testId,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && (0, $dnfL5.css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            fullWidth && (0, $dnfL5.css)({
                width: "100%",
                justifyContent: "center"
            })
        ],
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && label && (0, $dnfL5.css)({
                        marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $8VyKT.default), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$384448a6ffd0907f$export$5be053290bf6cd4c = (appearance, selected, disabled)=>{
    let testId = `button-${appearance}`;
    if (selected) testId += "-selected";
    if (disabled) testId += "-disabled";
    return testId;
};
const $f2f805f49af46a8b$var$$384448a6ffd0907f$export$99c79d2ae299b19a = (iconType)=>iconType ? iconType.replaceAll("-", " ") : "button icon";
const $f2f805f49af46a8b$var$$f0f55be381b0aa07$export$c25acd513dcc8062 = ({ clickHandler: clickHandler, testId: testId, disabled: disabled = false, selected: selected = false, isLoading: isLoading = false, tooltip: tooltip, iconType: iconType, showBeforeIcon: showBeforeIcon, href: href, target: target, iconColor: iconColor })=>{
    const commonProps = {
        tabIndex: 0,
        "aria-label": $f2f805f49af46a8b$var$$384448a6ffd0907f$export$99c79d2ae299b19a(iconType),
        "data-testid": testId,
        css: [
            $f2f805f49af46a8b$var$$f0f55be381b0aa07$var$learningButtonIconStyles["base"],
            selected && $f2f805f49af46a8b$var$$f0f55be381b0aa07$var$learningButtonIconStyles["selected"],
            iconColor && (0, $dnfL5.css)({
                color: iconColor
            })
        ],
        onClick: clickHandler
    };
    const content = (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $8VyKT.default), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    let element;
    if (href && !disabled) element = (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    else element = (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
        id: "icon-button",
        ...commonProps,
        disabled: disabled,
        children: content
    });
    return tooltip ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6xdv4.default), {
        content: tooltip,
        testId: "tooltip",
        children: element
    }) : element;
};
const $f2f805f49af46a8b$var$$f0f55be381b0aa07$var$learningButtonIconStyles = {
    base: (0, $dnfL5.css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    selected: (0, $dnfL5.css)({
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.hovered"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.selected")
        }
    })
};
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$8f9833f38f34a075 = {
    basic: (0, $dnfL5.css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        textDecoration: "none",
        justifyContent: "center",
        maxWidth: "max-content",
        width: "100%",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        height: "40px",
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
            borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
            textDecoration: "none"
        },
        "&:active": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
            borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.brand.bold"),
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")}`
        }
    }),
    secondary: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
    }),
    danger: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.danger.bold"),
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    warning: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.warning.bold"),
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.warning"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.warning.inverse")
    }),
    subtle: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
    }),
    success: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.success.bold"),
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    selected: (0, $dnfL5.css)({
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
        }
    })
};
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463 = {
    medium: (0, $dnfL5.css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        height: "40px"
    }),
    large: (0, $dnfL5.css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600,
        height: "48px"
    })
};
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$84379743ac6ff850 = {
    medium: (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
    }),
    "medium-icon-before": (0, $dnfL5.css)({
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $dnfL5.css)({
        padding: `10px 10px 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
    }),
    large: (0, $dnfL5.css)({
        maxWidth: "max-content",
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`
    }),
    "large-icon-before": (0, $dnfL5.css)({
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
    }),
    "large-icon-after": (0, $dnfL5.css)({
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`
    })
};
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$6398dd78520de6de = {
    large: (0, $dnfL5.css)({
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
        }
    }),
    "large-icon-before": (0, $dnfL5.css)({
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $dnfL5.css)({
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px 10px 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
        }
    })
};
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$9d41b2b2e9b27135 = (0, $dnfL5.css)({
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$1870a7443335e00d = (0, $dnfL5.css)({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& > span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    "& svg": {
        maxWidth: "20px",
        maxHeight: "20px"
    }
});
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$46d009ded5eecf4e = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon"),
    cursor: "not-allowed"
});
const $f2f805f49af46a8b$var$$426d900cf47bc59f$export$d0e85600c25cfb6 = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
    borderColor: "transparent",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
        borderColor: "transparent",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
        cursor: "not-allowed"
    }
});
const $f2f805f49af46a8b$var$$6fde84a571ed6267$export$8c0322faba831be3 = (appearance, size)=>[
        $f2f805f49af46a8b$var$$426d900cf47bc59f$export$8f9833f38f34a075["basic"],
        $f2f805f49af46a8b$var$$426d900cf47bc59f$export$8f9833f38f34a075[appearance],
        $f2f805f49af46a8b$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463[size]
    ];
const $f2f805f49af46a8b$var$$6fde84a571ed6267$export$18739f551ab326b6 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon)=>{
    const styles = [];
    if (isButtonWithoutIcon) styles.push($f2f805f49af46a8b$var$$426d900cf47bc59f$export$84379743ac6ff850[size]);
    if (showBeforeIcon) styles.push($f2f805f49af46a8b$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($f2f805f49af46a8b$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-after`]);
    return styles;
};
const $f2f805f49af46a8b$var$$6fde84a571ed6267$export$10dac92f1edafe3b = (isResponsiveSpacing, size, showBeforeIcon, showAfterIcon)=>{
    const styles = [
        $f2f805f49af46a8b$var$$426d900cf47bc59f$export$6398dd78520de6de[size],
        $f2f805f49af46a8b$var$$426d900cf47bc59f$export$9d41b2b2e9b27135
    ];
    if (!isResponsiveSpacing) return [];
    if (showBeforeIcon) styles.push($f2f805f49af46a8b$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($f2f805f49af46a8b$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-after`]);
    return styles;
};
const $f2f805f49af46a8b$var$$6fde84a571ed6267$export$1bff1bc920069ec8 = (appearance)=>{
    if (appearance === $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY) return (0, $dnfL5.css)({
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")
    });
    if (appearance === $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY) return (0, $dnfL5.css)({
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
    });
    return null;
};
const $f2f805f49af46a8b$var$$6fde84a571ed6267$export$3f4ba612f3306fd2 = (selected, isLoading, disabled, fullWidth)=>{
    const styles = [];
    if (selected) styles.push($f2f805f49af46a8b$var$$426d900cf47bc59f$export$8f9833f38f34a075["selected"]);
    if (isLoading || disabled) styles.push((0, $dnfL5.css)({
        ...$f2f805f49af46a8b$var$$426d900cf47bc59f$export$d0e85600c25cfb6,
        pointerEvents: "none",
        cursor: "not-allowed"
    }));
    if (fullWidth) styles.push((0, $dnfL5.css)({
        width: "100%",
        maxWidth: "none",
        justifyContent: "center"
    }));
    return styles;
};
const $f2f805f49af46a8b$var$$6fde84a571ed6267$export$a803e3773f881664 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding = true)=>{
    const linkButtonSpacingStyles = {
        medium: (0, $dnfL5.css)({
            padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
        }),
        "medium-icon-before": (0, $dnfL5.css)({
            padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }),
        "medium-icon-after": (0, $dnfL5.css)({
            padding: `10px 10px 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
        }),
        large: (0, $dnfL5.css)({
            maxWidth: "max-content",
            padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`
        }),
        "large-icon-before": (0, $dnfL5.css)({
            padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
        }),
        "large-icon-after": (0, $dnfL5.css)({
            padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`
        })
    };
    const styles = [];
    if (isButtonWithoutIcon) styles.push(linkButtonSpacingStyles[size]);
    if (showBeforeIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-before`]);
    if (showAfterIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-after`]);
    if (!withPadding) styles.push((0, $dnfL5.css)({
        padding: 0
    }));
    return styles;
};
const $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$getLinkButtonStyles = (disabled)=>[
        $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["basic"],
        disabled && $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["disabled"]
    ];
const $f2f805f49af46a8b$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8 = ({ label: label, disabled: disabled = false, clickHandler: clickHandler, testId: testId, size: size = $f2f805f49af46a8b$export$5dd2748b7940a2a0.MEDIUM, href: href, target: target, withPadding: withPadding = true, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$f2f805f49af46a8b$var$$9a690c81e99c8d02$var$getLinkButtonStyles(disabled),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$a803e3773f881664(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding)
        ]
    };
    const content = (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            showBeforeIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $dnfL5.css)({
                        marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            showAfterIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $dnfL5.css)({
                        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$disabledIconStyles
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        onClick: clickHandler,
        children: content
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        disabled: disabled,
        onClick: clickHandler,
        children: content
    });
};
const $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$learningButtonLinkStyles = {
    basic: (0, $dnfL5.css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: (0, $dnfL5.css)({
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    })
};
const $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$buttonIconContainerStyles = (0, $dnfL5.css)({
    width: "24px",
    height: "24px"
});
const $f2f805f49af46a8b$var$$9a690c81e99c8d02$var$disabledIconStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $f2f805f49af46a8b$var$$73286ba8e7c0bafe$export$9508e056e78f90ef = ({ label: label, appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, href: href, target: target, fullWidth: fullWidth = false, selected: selected = false, size: size = $f2f805f49af46a8b$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, as: as = "a", type: type })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        onClick: disabled || isLoading ? undefined : clickHandler,
        role: as === "button" ? undefined : href ? undefined : "button",
        tabIndex: disabled || isLoading ? -1 : 0,
        "data-testid": testId,
        css: [
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            $f2f805f49af46a8b$var$$6fde84a571ed6267$export$1bff1bc920069ec8(appearance),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ]
    };
    const children = (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $8VyKT.default), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    label && (0, $dnfL5.css)({
                        marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
                        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
                            marginRight: 0
                        }
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: isLoading && (0, $dnfL5.css)({
                    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
                }),
                children: label
            }),
            showAfterIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $dnfL5.css)({
                        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $f2f805f49af46a8b$var$$426d900cf47bc59f$export$46d009ded5eecf4e
                ],
                children: showAfterIcon
            })
        ]
    });
    if (as === "button") return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: children
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: !disabled && !isLoading ? href : undefined,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: children
    });
};
const $f2f805f49af46a8b$var$$ea4b236bf0573f71$export$69c6dd121e96df9e = ({ label: label, type: type = "button", appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, fullWidth: fullWidth = false, selected: selected = false, size: size = $f2f805f49af46a8b$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, href: href, target: target })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            ...$f2f805f49af46a8b$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ],
        onClick: clickHandler
    };
    const content = (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $8VyKT.default), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $dnfL5.css)({
                        marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $dnfL5.css)({
                        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $dnfL5.css)({
                        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: content
    });
};
let $f2f805f49af46a8b$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($f2f805f49af46a8b$export$5dd2748b7940a2a0 || ($f2f805f49af46a8b$export$5dd2748b7940a2a0 = {}));
let $f2f805f49af46a8b$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($f2f805f49af46a8b$export$261c9483fc4a455a || ($f2f805f49af46a8b$export$261c9483fc4a455a = {}));
const $f2f805f49af46a8b$export$353f5b6fc5456de1 = (props)=>{
    const { appearance: appearance = $f2f805f49af46a8b$export$261c9483fc4a455a.DEFAULT, selected: selected = false, disabled: disabled = false, size: size = $f2f805f49af46a8b$export$5dd2748b7940a2a0.MEDIUM, onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading = false, isResponsive: isResponsive = false } = props;
    const clickHandler = (0, $acw62.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore || false;
    const showAfterIcon = !isLoading && iconAfter || false;
    const isResponsiveSpacing = isResponsive && [
        $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
        $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $f2f805f49af46a8b$export$5dd2748b7940a2a0.LARGE;
    const testId = $f2f805f49af46a8b$var$$384448a6ffd0907f$export$5be053290bf6cd4c(appearance, selected, disabled);
    const commonProps = {
        ...props,
        clickHandler: clickHandler,
        isButtonWithoutIcon: isButtonWithoutIcon,
        showBeforeIcon: showBeforeIcon,
        showAfterIcon: showAfterIcon,
        isResponsiveSpacing: isResponsiveSpacing,
        testId: testId
    };
    const componentMap = {
        [$f2f805f49af46a8b$export$261c9483fc4a455a.DEFAULT]: $f2f805f49af46a8b$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf,
        [$f2f805f49af46a8b$export$261c9483fc4a455a.ICON]: $f2f805f49af46a8b$var$$f0f55be381b0aa07$export$c25acd513dcc8062,
        [$f2f805f49af46a8b$export$261c9483fc4a455a.LINK]: $f2f805f49af46a8b$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8,
        [$f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY]: $f2f805f49af46a8b$var$$73286ba8e7c0bafe$export$9508e056e78f90ef,
        [$f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY]: $f2f805f49af46a8b$var$$73286ba8e7c0bafe$export$9508e056e78f90ef
    };
    const Component = componentMap[appearance] ?? $f2f805f49af46a8b$var$$ea4b236bf0573f71$export$69c6dd121e96df9e;
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)(Component, {
        ...commonProps
    });
};
var $f2f805f49af46a8b$var$$d501466973a9f0a6$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$d501466973a9f0a6$exports, "CheckboxType", ()=>$f2f805f49af46a8b$export$138e17770a0a93a6);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$d501466973a9f0a6$exports, "CheckboxSize", ()=>$f2f805f49af46a8b$export$5e435bc8b081a399);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$d501466973a9f0a6$exports, "Checkbox", ()=>$f2f805f49af46a8b$export$48513f6b9f8ce62d);
var $f2f805f49af46a8b$var$$633811e9cd66d921$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$633811e9cd66d921$exports, "useKeyboardInteraction", ()=>$f2f805f49af46a8b$export$2a0b6757d41dacb2);
const $f2f805f49af46a8b$export$2a0b6757d41dacb2 = (handler)=>{
    return (0, $acw62.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    }, [
        handler
    ]);
};
let $f2f805f49af46a8b$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($f2f805f49af46a8b$export$138e17770a0a93a6 || ($f2f805f49af46a8b$export$138e17770a0a93a6 = {}));
let $f2f805f49af46a8b$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($f2f805f49af46a8b$export$5e435bc8b081a399 || ($f2f805f49af46a8b$export$5e435bc8b081a399 = {}));
const $f2f805f49af46a8b$export$48513f6b9f8ce62d = ({ label: label, isChecked: isChecked, onChange: onChange, type: type = $f2f805f49af46a8b$export$138e17770a0a93a6.DEFAULT, size: size = $f2f805f49af46a8b$export$5e435bc8b081a399.DEFAULT, isIndeterminate: isIndeterminate = false, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $acw62.useState)(false);
    const checkboxRef = (0, $acw62.useRef)(null);
    const handleChange = (0, $acw62.useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleChange);
    (0, $acw62.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $f2f805f49af46a8b$var$$d501466973a9f0a6$var$labelStyles,
            size === $f2f805f49af46a8b$export$5e435bc8b081a399.LARGE && $f2f805f49af46a8b$var$$d501466973a9f0a6$var$labelLargeStyles,
            type === $f2f805f49af46a8b$export$138e17770a0a93a6.DISABLED && $f2f805f49af46a8b$var$$d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $dnfL5.css)({
                fontWeight: 700
            }),
            !isBold && (0, $dnfL5.css)({
                fontWeight: 400
            })
        ],
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $f2f805f49af46a8b$var$$d501466973a9f0a6$var$inputCheckboxStyles
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$e61786c4aee8d415, {
                children: label
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $f2f805f49af46a8b$var$$d501466973a9f0a6$var$variants.checkbox[type],
                    $f2f805f49af46a8b$var$$d501466973a9f0a6$var$checkmarkStyles,
                    size === $f2f805f49af46a8b$export$5e435bc8b081a399.LARGE && $f2f805f49af46a8b$var$$d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $f2f805f49af46a8b$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $f2f805f49af46a8b$var$$d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $f2f805f49af46a8b$export$138e17770a0a93a6.DANGER && (0, $dnfL5.css)({
                        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger")
                    })
                ]
            }),
            isRequired && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$d501466973a9f0a6$var$requiredMarkStyles,
                    size === $f2f805f49af46a8b$export$5e435bc8b081a399.LARGE && (0, $dnfL5.css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$requiredMarkStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "6px"
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$labelStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$labelLargeStyles = (0, $dnfL5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$inputCheckboxStyles = (0, $dnfL5.css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$checkmarkStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$checkmarkLargeStyles = (0, $dnfL5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")}`
    }
});
const $f2f805f49af46a8b$var$$d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $dnfL5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $dnfL5.css)({
            "&:hover": {
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $dnfL5.css)({
            "&, &:hover": {
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $dnfL5.css)({
            "&, &:hover": {
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $dnfL5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $f2f805f49af46a8b$var$$c4979bfceee73878$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$c4979bfceee73878$exports, "CommonModal", ()=>$f2f805f49af46a8b$export$8577c1390d697bac);
const $f2f805f49af46a8b$export$8577c1390d697bac = ({ isOpen: isOpen, toggleModal: toggleModal, modalDescriptionLabel: modalDescription, children: children, styles: styles })=>{
    const closeModal = (0, $acw62.useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, [
        toggleModal
    ]);
    const modalRef = (0, $acw62.useRef)(null);
    const focusOnOpen = (0, $acw62.useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    // focusOnOpen and toggleModal intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $acw62.useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            $f2f805f49af46a8b$var$$c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $f2f805f49af46a8b$var$$c4979bfceee73878$var$modalStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                    type: "button",
                    css: $f2f805f49af46a8b$var$$c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6e38e0bca95e9176$exports))), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                    })
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$c4979bfceee73878$var$backdropStyles = (0, $dnfL5.css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $f2f805f49af46a8b$var$$c4979bfceee73878$var$modalStyles = (0, $dnfL5.css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $f2f805f49af46a8b$var$$c4979bfceee73878$var$closeButtonStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.hovered")
    }
});
const $f2f805f49af46a8b$var$$c4979bfceee73878$var$modalSlotStyles = (0, $dnfL5.css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});
var $f2f805f49af46a8b$var$$0903e93de01b205a$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$0903e93de01b205a$exports, "Divider", ()=>$f2f805f49af46a8b$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ const $f2f805f49af46a8b$export$2e0a83ec2e27ecbb = ({ color: color, height: height = 1 })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("hr", {
        "data-testid": "divider",
        style: styles
    });
};
var $f2f805f49af46a8b$var$$a950778dc3003c4a$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a950778dc3003c4a$exports, "Eyebrow", ()=>$f2f805f49af46a8b$export$71f050e2efa708bb);
const $f2f805f49af46a8b$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular", size: size = "small", color: color = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"), children: children })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("h4", {
        css: [
            $f2f805f49af46a8b$var$$a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $f2f805f49af46a8b$var$$a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $dnfL5.css)({
                fontWeight: 600
            }),
            color && (0, $dnfL5.css)({
                color: color
            })
        ],
        children: children
    });
};
const $f2f805f49af46a8b$var$$a950778dc3003c4a$var$eyebrowSmallStyles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $f2f805f49af46a8b$var$$a950778dc3003c4a$var$eyebrowMediumStyles = (0, $dnfL5.css)({
    fontSize: "14px",
    lineHeight: "18px"
});
var $f2f805f49af46a8b$var$$582583ec420fce57$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$582583ec420fce57$exports, "Heading", ()=>$f2f805f49af46a8b$export$a8a3e93435678ff9);
var $f2f805f49af46a8b$var$$fde9406d76ec24a9$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "objectValuesToControls", ()=>$f2f805f49af46a8b$export$8a8918d045227e35);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "inspectorProps", ()=>$f2f805f49af46a8b$export$1784ac302bd8ebad);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "formatMinutes", ()=>$f2f805f49af46a8b$export$30c35cbf580cab77);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "getRedirectUrl", ()=>$f2f805f49af46a8b$export$93832c3affb240d3);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "calculateLearningProgress", ()=>$f2f805f49af46a8b$export$6e67b290ed5690f6);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "SEARCHBAR_HISTORY_STORAGE_KEY", ()=>$f2f805f49af46a8b$export$1059c3e9f228d9b);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "getLocalStorageHistory", ()=>$f2f805f49af46a8b$export$7765f5b61937bda1);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "setLocalStorageItems", ()=>$f2f805f49af46a8b$export$cec0922aa1b64670);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fde9406d76ec24a9$exports, "generateHashFromLabel", ()=>$f2f805f49af46a8b$export$1bdcd43c8c2377cf);
const $f2f805f49af46a8b$var$$3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email, redirectUrl: redirectUrl, prompt: prompt = "none", experience: experience = "entry-auth" })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $f2f805f49af46a8b$var$$3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $f2f805f49af46a8b$var$$3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};
let $f2f805f49af46a8b$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($f2f805f49af46a8b$export$7dc6752a22ab011a || ($f2f805f49af46a8b$export$7dc6752a22ab011a = {}));
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.LOCAL]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $f2f805f49af46a8b$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
})($f2f805f49af46a8b$export$93d048dc21eb282a || ($f2f805f49af46a8b$export$93d048dc21eb282a = {}));
const $f2f805f49af46a8b$export$67e61a6fa639f224 = (email)=>[
        {
            app: $f2f805f49af46a8b$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: $f2f805f49af46a8b$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $f2f805f49af46a8b$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $f2f805f49af46a8b$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $f2f805f49af46a8b$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        }
    ];
const $f2f805f49af46a8b$export$208c68d48dfc9a12 = $f2f805f49af46a8b$export$67e61a6fa639f224();
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$f2f805f49af46a8b$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$f2f805f49af46a8b$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$f2f805f49af46a8b$export$93d048dc21eb282a.EVENTS]: "/events",
    [$f2f805f49af46a8b$export$93d048dc21eb282a.PROFILE]: "/user",
    [$f2f805f49af46a8b$export$93d048dc21eb282a.CHAMPIONS]: "/champions"
};
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$132b2bf91782e62b = "/user";
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$b9cc8022ec117e91 = "/user/settings";
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    },
    SWITCH_ACCOUNT: {
        text: "Switch accounts",
        id: "switch-account"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    }
};
let $f2f805f49af46a8b$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($f2f805f49af46a8b$export$3d7865934588d77e || ($f2f805f49af46a8b$export$3d7865934588d77e = {}));
let $f2f805f49af46a8b$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($f2f805f49af46a8b$export$d778a884eb401313 || ($f2f805f49af46a8b$export$d778a884eb401313 = {}));
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/community-platform-terms-of-use";
const $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $f2f805f49af46a8b$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $f2f805f49af46a8b$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId, fieldId: fieldId } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $f2f805f49af46a8b$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $f2f805f49af46a8b$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[environment] || $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[$f2f805f49af46a8b$export$7dc6752a22ab011a.STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $f2f805f49af46a8b$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};
const $f2f805f49af46a8b$export$1059c3e9f228d9b = "searchbar_history";
const $f2f805f49af46a8b$export$7765f5b61937bda1 = ()=>{
    if (typeof window === "undefined") return [];
    const storedHistory = localStorage.getItem($f2f805f49af46a8b$export$1059c3e9f228d9b);
    return storedHistory ? JSON.parse(storedHistory) : [];
};
const $f2f805f49af46a8b$export$cec0922aa1b64670 = (items)=>{
    if (typeof window === "undefined") return;
    localStorage.setItem($f2f805f49af46a8b$export$1059c3e9f228d9b, JSON.stringify(items));
};
const $f2f805f49af46a8b$export$1bdcd43c8c2377cf = (label)=>{
    return `#${label.toLowerCase().replace(/ /g, "-")}`;
};
const $f2f805f49af46a8b$export$a8a3e93435678ff9 = ({ children: children, level: level, inspectMode: inspectMode, id: id, color: color = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"), fontWeight: fontWeight })=>{
    const HeadingElement = $f2f805f49af46a8b$var$$582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $f2f805f49af46a8b$var$$582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? $f2f805f49af46a8b$export$1784ac302bd8ebad(Object.keys(inspectMode)[0], inspectMode) : {};
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $dnfL5.css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h0Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h1Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h2Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h3Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h4Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h5Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$h6Styles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $f2f805f49af46a8b$var$$582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $f2f805f49af46a8b$var$$582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $f2f805f49af46a8b$var$$582583ec420fce57$var$h0Styles,
    1: $f2f805f49af46a8b$var$$582583ec420fce57$var$h1Styles,
    2: $f2f805f49af46a8b$var$$582583ec420fce57$var$h2Styles,
    3: $f2f805f49af46a8b$var$$582583ec420fce57$var$h3Styles,
    4: $f2f805f49af46a8b$var$$582583ec420fce57$var$h4Styles,
    5: $f2f805f49af46a8b$var$$582583ec420fce57$var$h5Styles,
    6: $f2f805f49af46a8b$var$$582583ec420fce57$var$h6Styles
};
var $f2f805f49af46a8b$var$$a02a6f7de308273b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a02a6f7de308273b$exports, "icons", ()=>$f2f805f49af46a8b$export$df03f54e09e486fa);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a02a6f7de308273b$exports, "IconSize", ()=>$f2f805f49af46a8b$export$ff775019b5b6e7df);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a02a6f7de308273b$exports, "IconRotation", ()=>$f2f805f49af46a8b$export$b3241a99d3e47e02);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a02a6f7de308273b$exports, "Icon", ()=>$f2f805f49af46a8b$export$f04a61298a47a40f);
// Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
// Glyph icons use 'primaryColor' prop
const $f2f805f49af46a8b$var$$a02a6f7de308273b$var$CORE_ICONS = [
    "arrow-up-right",
    "atlassian-intelligence",
    "calendar",
    "compass",
    "download-core",
    "link-external",
    "location-outline",
    "megaphone",
    "people-group",
    "person",
    "project",
    "sidebar-collapse",
    "sidebar-expand",
    "thumb-down",
    "thumb-up",
    "roadmaps-plan"
];
const $f2f805f49af46a8b$export$df03f54e09e486fa = {
    filter: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7a7616abae5178e5$exports))), {
            ...props
        }),
    "chevron-down": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a3062bb40e0ac5b8$exports))), {
            ...props
        }),
    "chevron-up": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e0881f5dbdc2ce2b$exports))), {
            ...props
        }),
    "chevron-left": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4a0a0d05cb5ada88$exports))), {
            ...props
        }),
    "chevron-right": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2a4facccadb10e11$exports))), {
            ...props
        }),
    "chevron-down-circle": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4e0d3392bc0b63e0$exports))), {
            ...props
        }),
    "arrow-up-circle": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1f40d9aadfb38c92$exports))), {
            ...props
        }),
    "arrow-up": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b41eaaa0443252ca$exports))), {
            ...props
        }),
    "arrow-up-right": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($gaDMh))), {
            ...props
        }),
    "check-circle": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($eaf524c5b400049f$exports))), {
            ...props
        }),
    "check-circle-outline": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($233df463ce9525bc$exports))), {
            ...props
        }),
    "arrow-right": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($cfa4544cde9f0d6d$exports))), {
            ...props
        }),
    "arrow-left-circle": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dde75f56c579d288$exports))), {
            ...props
        }),
    "arrow-right-circle": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($beffee6644bfbb75$exports))), {
            ...props
        }),
    "arrow-right-small": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.908 8L12.8283 9.2021L14.5785 11.1497H7.26318C6.84191 11.1497 6.5 11.5304 6.5 11.9994C6.5 12.4685 6.84191 12.8492 7.26318 12.8492H14.5785L12.8283 14.7979L13.908 16L17.5 11.9994L13.908 8Z",
                fill: props.primaryColor ?? "#1868DB"
            })
        }),
    "atlassian-intelligence": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dbf38fc8bfa334aa$exports))), {
            ...props
        }),
    "atlassian-logo": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c2fc273fd8eb0796$exports))), {
            ...props
        }),
    cross: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6e38e0bca95e9176$exports))), {
            ...props
        }),
    "dropdown-cross": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d1bbaedeec8ea759$exports))), {
            ...props
        }),
    "menu-icon": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6ad5f2e289b76b76$exports))), {
            ...props
        }),
    "emoji-frequent": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2f3e0a57a89e363c$exports))), {
            ...props
        }),
    "star-filled": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6e70cf83e1cfcb36$exports))), {
            ...props
        }),
    star: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fa7fc39340ede4b5$exports))), {
            ...props
        }),
    "bitbucket-builds": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9f6b1d4c229de4ab$exports))), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0fe96ae52df99a15$exports))), {
            ...props
        }),
    "editor-table": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6719c1cdf1c67024$exports))), {
            ...props
        }),
    "editor-open": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($210b73e2393383f6$exports))), {
            ...props
        }),
    calendar: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($765fb2c945546756$exports))), {
            ...props
        }),
    copy: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c39fd8ad171ba397$exports))), {
            ...props
        }),
    warning: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($82bb617b0c11ad15$exports))), {
            ...props
        }),
    image: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a20790a8c33090f5$exports))), {
            ...props
        }),
    download: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a7f33bb0aed3b6ad$exports))), {
            ...props
        }),
    "download-core": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($aKcQU))), {
            ...props
        }),
    "zoom-in": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ad9d696347fa2144$exports))), {
            ...props
        }),
    "zoom-out": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e3ac338e8e8e25ef$exports))), {
            ...props
        }),
    search: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($84d260297a222b6a$exports))), {
            ...props
        }),
    overview: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7c7b494736d4cc5b$exports))), {
            ...props
        }),
    add: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b932394ef8ad724b$exports))), {
            ...props
        }),
    refresh: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a95050abcaff2f05$exports))), {
            ...props
        }),
    "add-circle": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9ef8ab13acd96de1$exports))), {
            ...props
        }),
    edit: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be5e590a0b97263b$exports))), {
            ...props
        }),
    "edit-filled": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6892adb592af984b$exports))), {
            ...props
        }),
    error: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($acfd7a32d0c9dc49$exports))), {
            ...props
        }),
    settings: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5a5c08e14f64cdf6$exports))), {
            ...props
        }),
    info: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bd769250eb2245bc$exports))), {
            ...props
        }),
    question: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4994ef50c21a890a$exports))), {
            ...props
        }),
    check: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($72805e1b70ee4b7c$exports))), {
            ...props
        }),
    "check-circle-filled": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($eaf524c5b400049f$exports))), {
            ...props
        }),
    "emoji-symbols": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fb0ec5a882684bce$exports))), {
            ...props
        }),
    compass: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5a7fe07e2432b2c0$exports))), {
            ...props
        }),
    megaphone: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($904ede548fb46240$exports))), {
            ...props
        }),
    location: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dad88ef40fe77ddb$exports))), {
            ...props
        }),
    "location-outline": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($lrwzu))), {
            ...props
        }),
    "chevron-left-large": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0866a766b9fa65fb$exports))), {
            ...props
        }),
    "chevron-right-large": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0866a766b9fa65fb$exports))), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ae62f6b7dd7088cc$exports))), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fecfafd3ba8ed3dd$exports))), {
            ...props
        }),
    export: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fa6c001ff71fe7d5$exports))), {
            ...props
        }),
    link: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($511535d0df671f93$exports))), {
            ...props
        }),
    "roadmaps-plan": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b5560414905dc7f5$exports))), {
            ...props
        }),
    share: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8f22ce6266498d8f$exports))), {
            ...props
        }),
    "sidebar-collapse": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($40a12891dd7bc9cd$exports))), {
            ...props
        }),
    "sidebar-expand": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ad53fcc10ddf64e0$exports))), {
            ...props
        }),
    "people-group": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($176310dd99eb09fb$exports))), {
            ...props
        }),
    project: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($69a553daba15aba1$exports))), {
            ...props
        }),
    "link-external": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($541ff671b5d0d564$exports))), {
            ...props
        }),
    person: (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4a67238030457e9e$exports))), {
            ...props
        }),
    "bookmark-narrow": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M16.5745 5.49575C16.5745 5.13673 16.2832 4.84567 15.9242 4.84554H8.07595C7.71685 4.84554 7.42574 5.13665 7.42574 5.49575V18.2473L12.0001 15.0318L12.5601 15.4268L16.5745 18.2473V5.49575ZM18.5251 20.0633C18.5248 20.8281 17.717 21.2956 17.0659 20.965L16.9377 20.8875L11.9988 17.4155L7.06253 20.8875C6.39483 21.3569 5.47538 20.8794 5.4751 20.0633V5.49575C5.4751 4.05934 6.63954 2.8949 8.07595 2.8949H15.9242C17.3605 2.89503 18.5251 4.05942 18.5251 5.49575V20.0633Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    "bookmark-narrow-filled": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M18.525 20.0632C18.5247 20.828 17.7168 21.2955 17.0658 20.9649L16.9375 20.8874L11.9987 17.4154L7.06241 20.8874C6.39471 21.3568 5.47525 20.8792 5.47498 20.0632V5.49563C5.47498 4.05922 6.63942 2.89478 8.07583 2.89478H15.9241C17.3604 2.8949 18.525 4.0593 18.525 5.49563V20.0632Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    bookmark: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "bookmark-filled": ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "gap-completed": ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8ba342f149c37c37$exports))), {
            ...props
        }),
    "thumb-up": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($66bb4267eaa8b347$exports))), {
            ...props
        }),
    "dot-default": ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#091E42",
                strokeOpacity: "0.14"
            })
        }),
    "dot-selected": ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#0C66E4"
            })
        }),
    "dot-completed": ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                width: "8",
                height: "8",
                rx: "4",
                fill: "#22A06B"
            })
        }),
    "mosaic_map-pin": (props)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.8088 12.9426L19.8045 18.7363L23.8003 12.9426C23.8715 12.8394 23.938 12.735 24 12.6296C25.8712 9.44592 23.5904 5.33325 19.8045 5.33325C15.8931 5.33325 13.5882 9.72274 15.8088 12.9426ZM19.9234 12.494C21.1444 12.4321 22.1153 11.4225 22.1153 10.1861C22.1153 8.90983 21.0807 7.87521 19.8045 7.87521C18.5909 7.87521 17.5958 8.81071 17.501 9.99992C17.4961 10.0613 17.4938 10.1234 17.4938 10.1861C17.4938 11.4623 18.5284 12.4969 19.8046 12.497M19.8046 12.497C19.8444 12.497 19.8841 12.496 19.9234 12.494L19.8046 12.497Z",
                    fill: props.primaryColor ?? "#172b4d"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                    d: "M21.3333 22.6666V20.0426L24 16.1759V25.3333H8V9.99992H12.9424C12.9149 10.8857 13.0615 11.7906 13.4072 12.6666H10.6667V22.6666H21.3333Z",
                    fill: props.primaryColor ?? "#172b4d"
                })
            ]
        }),
    mosaic_compass: (props)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64467_13333",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64467_13333)",
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                            d: "M14.6665 16.0001C14.6665 15.2667 15.2665 14.6667 15.9998 14.6667C16.7332 14.6667 17.3332 15.2667 17.3332 16.0001C17.3332 16.7334 16.7332 17.3334 15.9998 17.3334C15.2665 17.3334 14.6665 16.7334 14.6665 16.0001Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M16.0002 26.6666C21.8935 26.6666 26.6668 21.8933 26.6668 15.9999C26.6668 10.1066 21.8935 5.33325 16.0002 5.33325C10.1068 5.33325 5.3335 10.1066 5.3335 15.9999C5.3335 21.8933 10.1068 26.6666 16.0002 26.6666ZM21.3335 10.6666L13.3335 13.3333L10.6668 21.3333L18.6668 18.6666L21.3335 10.6666Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    mosaic_megaphone: (props)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64493_847",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64493_847)",
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                            d: "M26 5.33325L16 9.33325V19.9999L26 23.9999V5.33325Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                            d: "M13.3335 10H5.3335V19.3333H9.3335V25.3333H13.3335V10Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    "more-vertical": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d8410616b501ba4d$exports))), {
            ...props
        }),
    "editor-panel": (props)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($72d0253bb5975c99$exports))), {
            ...props
        }),
    one: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
            css: $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $f2f805f49af46a8b$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($f2f805f49af46a8b$export$ff775019b5b6e7df || ($f2f805f49af46a8b$export$ff775019b5b6e7df = {}));
let $f2f805f49af46a8b$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($f2f805f49af46a8b$export$b3241a99d3e47e02 || ($f2f805f49af46a8b$export$b3241a99d3e47e02 = {}));
const $f2f805f49af46a8b$export$f04a61298a47a40f = ({ type: type, size: size = $f2f805f49af46a8b$export$ff775019b5b6e7df.MEDIUM, rotation: rotation = $f2f805f49af46a8b$export$b3241a99d3e47e02.ZERO, alt: alt = "", color: color, hoverColor: hoverColor, activeColor: activeColor })=>{
    const icon = (0, $acw62.useMemo)(()=>$f2f805f49af46a8b$export$df03f54e09e486fa[type], [
        type
    ]);
    const isCoreIcon = $f2f805f49af46a8b$var$$a02a6f7de308273b$var$CORE_ICONS.includes(type);
    // Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
    // Glyph icons use 'primaryColor' prop
    const iconProps = isCoreIcon ? {
        size: size,
        label: alt,
        color: color || "currentColor",
        testId: type
    } : {
        size: size,
        label: alt,
        primaryColor: color || undefined,
        testId: type
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
        css: [
            $f2f805f49af46a8b$var$$a02a6f7de308273b$var$baseStyles,
            $f2f805f49af46a8b$var$$a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon(iconProps) : null
    });
};
const $f2f805f49af46a8b$var$$a02a6f7de308273b$var$baseStyles = (0, $dnfL5.css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $f2f805f49af46a8b$var$$a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $dnfL5.css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $dnfL5.css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $dnfL5.css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $dnfL5.css)({
        transform: "rotate(270deg)"
    })
};
const $f2f805f49af46a8b$var$$a02a6f7de308273b$var$iconNumberStyles = (0, $dnfL5.css)({
    fontSize: "16px"
});
var $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1298c86a7e6a9fc7$exports, "Image", ()=>$f2f805f49af46a8b$export$3e431a229df88919);
/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $f2f805f49af46a8b$export$3e431a229df88919 = ({ inspectMode: inspectMode, src: src, alt: alt, width: width, height: height, caption: caption = "", size: size, center: center = true, preventModal: preventModal = false, onClick: onClick, ...props })=>{
    const rightToolsRef = (0, $acw62.useRef)(null);
    const downloadButtonRef = (0, $acw62.useRef)(null);
    const modalImgRef = (0, $acw62.useRef)(null);
    const originalImgRef = (0, $acw62.useRef)(null);
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const [showControls, setShowControls] = (0, $acw62.useState)(false);
    const [totalZoom, setTotalZoom] = (0, $acw62.useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $acw62.useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $acw62.useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $acw62.useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer ?? undefined);
    }, [
        showControls
    ]);
    (0, $acw62.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $acw62.useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick,
        preventModal
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $acw62.useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            showModal && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: [
                                $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $dnfL5.css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $dnfL5.css)({
                                    opacity: 0
                                })
                            ],
                            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $2b750d3a8789dea3$export$c6930421db9fa514)
                                                })
                                            }),
                                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                                css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                                        css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                                                        css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        className: "right",
                                        ref: rightToolsRef,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $dnfL5.css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$downloadImage(src, $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $ecc69a910d65988c$export$2e2bcd8739ae039), {
                            css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $dnfL5.css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: [
                                $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $dnfL5.css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $dnfL5.css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: (0, $dnfL5.css)({
                                            color: (0, $2b750d3a8789dea3$export$5368d76ae4fbbda7)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("image", inspectMode),
                css: (0, $dnfL5.css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("figure", {
                    css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $dnfL5.css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $dnfL5.css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $dnfL5.css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $dnfL5.css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`,
                                maxWidth: "100vw"
                            },
                            css: $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalStyles = (0, $dnfL5.css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalContentStyles = (0, $dnfL5.css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    overflow: "hidden",
    "& img": {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        width: "auto",
        height: "auto"
    }
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalControlsStyles = (0, $dnfL5.css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $2b750d3a8789dea3$export$5368d76ae4fbbda7)} !important`
    }
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$textContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    color: (0, $2b750d3a8789dea3$export$5368d76ae4fbbda7)
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$iconContainerStyles = (0, $dnfL5.css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$imageContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$badgeContentStyles = (0, $dnfL5.css)({
    margin: 0
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $dnfL5.css)({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    WebkitOverflowScrolling: "touch"
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$modalToolsStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $2b750d3a8789dea3$export$5368d76ae4fbbda7)} !important`
    }
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $dnfL5.css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$figureStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$var$captionContainerStyles = (0, $dnfL5.css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest")
});
var $f2f805f49af46a8b$var$$c0c01354ab9765ae$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$c0c01354ab9765ae$exports, "InvertedIconButton", ()=>$f2f805f49af46a8b$export$dd09d7da2da4d16f);
const $f2f805f49af46a8b$export$dd09d7da2da4d16f = ({ icon: icon, onClick: onClick, ariaLabel: ariaLabel, disabled: disabled = false, selected: selected = false, tooltip: tooltip, testId: testId = "inverted-icon-button" })=>{
    const button = (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
        css: [
            $f2f805f49af46a8b$var$$c0c01354ab9765ae$var$baseStyles,
            selected && $f2f805f49af46a8b$var$$c0c01354ab9765ae$var$selectedStyles,
            disabled && $f2f805f49af46a8b$var$$c0c01354ab9765ae$var$disabledStyles
        ],
        onClick: onClick,
        "aria-label": ariaLabel,
        disabled: disabled,
        "data-testid": testId,
        type: "button",
        children: icon
    });
    return tooltip && !disabled ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6xdv4.default), {
        content: tooltip,
        testId: `${testId}-tooltip`,
        children: button
    }) : button;
};
const $f2f805f49af46a8b$var$$c0c01354ab9765ae$var$baseStyles = (0, $dnfL5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
    width: "32px",
    height: "32px",
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    },
    // Ensure icon inherits the white color
    "& > span": {
        color: "inherit"
    }
});
const $f2f805f49af46a8b$var$$c0c01354ab9765ae$var$selectedStyles = (0, $dnfL5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.32)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.40)"
    }
});
const $f2f805f49af46a8b$var$$c0c01354ab9765ae$var$disabledStyles = (0, $dnfL5.css)({
    cursor: "not-allowed",
    opacity: 0.4,
    "&:hover": {
        backgroundColor: "transparent"
    },
    "&:active": {
        backgroundColor: "transparent"
    }
});
var $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4fce8dfc4ce8f546$exports, "LinkStyle", ()=>$f2f805f49af46a8b$export$2b77966d73aefa77);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4fce8dfc4ce8f546$exports, "LinkSize", ()=>$f2f805f49af46a8b$export$be4c932f76c19adf);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4fce8dfc4ce8f546$exports, "Link", ()=>$f2f805f49af46a8b$export$a6c7ac8248d6e38a);
let $f2f805f49af46a8b$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($f2f805f49af46a8b$export$2b77966d73aefa77 || ($f2f805f49af46a8b$export$2b77966d73aefa77 = {}));
let $f2f805f49af46a8b$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["EXTRA_LARGE"] = "extraLarge";
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($f2f805f49af46a8b$export$be4c932f76c19adf || ($f2f805f49af46a8b$export$be4c932f76c19adf = {}));
const $f2f805f49af46a8b$export$a6c7ac8248d6e38a = ({ label: label, fontColor: fontColor = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.blue"), target: target = "_self", link: link, style: style = $f2f805f49af46a8b$export$2b77966d73aefa77.REGULAR, icon: icon, onClick: onClick, size: size = $f2f805f49af46a8b$export$be4c932f76c19adf.MEDIUM, ...props })=>{
    const clickHandler = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$sizeStyles[size],
            $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$variantStyles[style].base,
            $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$baseStyles,
            $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $dnfL5.css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        /** @ts-expect-error - onKeyDown is not typed correctly */ onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            icon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$iconContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$baseStyles = (0, $dnfL5.css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    },
    extraLarge: {
        fontSize: "24px",
        lineHeight: "32px"
    }
};
const $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $dnfL5.css)({
            fontWeight: "normal"
        }),
        hover: (0, $dnfL5.css)({
            "&:hover": {
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $dnfL5.css)({
            fontWeight: 600
        }),
        hover: (0, $dnfL5.css)({
            "&:hover": {
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link")
            }
        })
    }
};
const $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};
var $f2f805f49af46a8b$var$$800df40a54823a3f$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$800df40a54823a3f$exports, "List", ()=>$f2f805f49af46a8b$export$54c2e3dc7acea9f5);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$800df40a54823a3f$exports, "variantsListStyles", ()=>$f2f805f49af46a8b$export$6427468642e6e9fe);
const $f2f805f49af46a8b$export$54c2e3dc7acea9f5 = ({ type: type = "unordered", textStyleType: textStyleType = "regular", children: children })=>{
    if (type === "ordered") return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ol", {
        "aria-label": "ordered",
        css: [
            $f2f805f49af46a8b$var$$800df40a54823a3f$var$listStyles,
            (0, $dnfL5.css)($f2f805f49af46a8b$export$6427468642e6e9fe.list[type]),
            $f2f805f49af46a8b$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
        "aria-label": "unordered",
        css: [
            $f2f805f49af46a8b$var$$800df40a54823a3f$var$listStyles,
            (0, $dnfL5.css)($f2f805f49af46a8b$export$6427468642e6e9fe.list[type]),
            $f2f805f49af46a8b$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $f2f805f49af46a8b$var$$800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $f2f805f49af46a8b$var$$800df40a54823a3f$var$listStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    ...$f2f805f49af46a8b$var$$800df40a54823a3f$var$fontSizeStyles,
    span: $f2f805f49af46a8b$var$$800df40a54823a3f$var$fontSizeStyles
});
const $f2f805f49af46a8b$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-of-type), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-of-type), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $dnfL5.css)({
            fontWeight: 400
        }),
        italic: (0, $dnfL5.css)({
            fontStyle: "italic"
        }),
        bold: (0, $dnfL5.css)({
            fontWeight: 700
        }),
        boldItalic: (0, $dnfL5.css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};
var $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "NavigationBar", ()=>$f2f805f49af46a8b$export$214ae410b202e65a);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "NavBarLinkItem", ()=>$f2f805f49af46a8b$export$e76239e22e3abad);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "NavBarProfileItem", ()=>$f2f805f49af46a8b$export$1cba3806e1f1b01d);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "AtlassianNavLogo", ()=>$f2f805f49af46a8b$export$6ce3be5638d8e2a);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "MenuItem", ()=>$f2f805f49af46a8b$export$2ce376c2cc3355c8);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "NavBarExpandableItem", ()=>$f2f805f49af46a8b$export$1229978ae51a03a8);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "NavbarSlideMenuItem", ()=>$f2f805f49af46a8b$export$c7fcbaf97c146aec);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports, "NavBarItemWithMenu", ()=>$f2f805f49af46a8b$export$2771c1f4a09ce668);
const $f2f805f49af46a8b$var$$6a34d18c8d59b475$var$CloseIcon = ()=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $f2f805f49af46a8b$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$6a34d18c8d59b475$var$CloseIcon;
const $f2f805f49af46a8b$var$$5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $f2f805f49af46a8b$var$$5ba5f450ff826a14$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$5ba5f450ff826a14$var$HamburgerMenuIcon;
const $f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767,
        MEDIA_QUERY: "@media (max-width: 767px)"
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279,
        MEDIA_QUERY: "@media (min-width: 768px) and (max-width: 1279px)"
    },
    DESKTOP: {
        MIN_WIDTH: 1280,
        MEDIA_QUERY: "@media (min-width: 1280px)"
    }
};
var $f2f805f49af46a8b$var$$965a3cfbe886b380$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$965a3cfbe886b380$exports, "useOutsideClickHandler", ()=>$f2f805f49af46a8b$export$aa79b0abe3dfeaba);
const $f2f805f49af46a8b$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $acw62.useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};
const $f2f805f49af46a8b$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref, label: label, logoSubtitle: logoSubtitle })=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
        css: $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$containerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        css: $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $f53d1d0ce4a6d984$export$8a485e2e7ed91e8f), {
                            testId: "mobile"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        css: $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $ea269827cfabf855$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$dividerStyles
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                href: subtitleHref,
                css: $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $dnfL5.css)({
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $dnfL5.css)({
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.brand")
        }
    },
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$dividerStyles = (0, $dnfL5.css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $f2f805f49af46a8b$var$$90d3cbebafca1fdb$var$subtitleStyles = (0, $dnfL5.css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.brand"),
        textDecoration: "none"
    }
});
const $f2f805f49af46a8b$var$$ff532043ef39c56f$var$SlideMenuContext = (0, $acw62.createContext)(undefined);
const $f2f805f49af46a8b$var$$ff532043ef39c56f$export$74d704c90f90362c = ()=>{
    const context = (0, $acw62.useContext)($f2f805f49af46a8b$var$$ff532043ef39c56f$var$SlideMenuContext);
    if (!context) throw new Error("useSlideMenuContext must be used within a SlideMenuContextProvider");
    return context;
};
const $f2f805f49af46a8b$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd = ({ children: children })=>{
    const [slideMenuContent, setSlideMenuContent] = (0, $acw62.useState)(null);
    const [isSlideMenuOpen, setIsSlideMenuOpen] = (0, $acw62.useState)(false);
    const [containerHeight, setContainerHeight] = (0, $acw62.useState)("initial");
    const openSlideMenu = (content)=>{
        setSlideMenuContent(content);
        setIsSlideMenuOpen(true);
    };
    const closeSlideMenu = ()=>{
        setIsSlideMenuOpen(false);
    };
    const contextValue = (0, $acw62.useMemo)(()=>({
            slideMenuContent: slideMenuContent,
            isSlideMenuOpen: isSlideMenuOpen,
            openSlideMenu: openSlideMenu,
            closeSlideMenu: closeSlideMenu,
            containerHeight: containerHeight,
            setContainerHeight: setContainerHeight
        }), [
        slideMenuContent,
        isSlideMenuOpen,
        containerHeight
    ]);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$ff532043ef39c56f$var$SlideMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $f2f805f49af46a8b$export$2771c1f4a09ce668 = ({ headerContent: headerContent, bodyContent: bodyContent, isNested: isNested = false, isActive: isActive = false })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$containerStyles,
        role: "group",
        "data-testid": "navbar-menu-item",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$headerStyles,
                    isActive && $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$headerSelectedStyles,
                    isNested && $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$nestedHeaderStyles
                ],
                role: "treeitem",
                "aria-selected": isActive,
                children: headerContent
            }),
            isActive && bodyContent && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                css: [
                    $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$bodyContentContainerStyles,
                    isNested && $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles
                ],
                children: bodyContent
            })
        ]
    });
const $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$headerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`
});
const $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$headerSelectedStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
    "a, span": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$nestedHeaderStyles = (0, $dnfL5.css)({
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")}`
});
const $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$bodyContentContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: 0,
    margin: 0,
    marginTop: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} !important`,
    listStyle: "none"
});
const $f2f805f49af46a8b$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles = (0, $dnfL5.css)({
    li: {
        paddingLeft: "56px"
    }
});
var $f2f805f49af46a8b$var$$6e8a4d5d78071ed7$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$6e8a4d5d78071ed7$exports, "useMediaQuery", ()=>$f2f805f49af46a8b$export$32d5543ab307c01);
const $f2f805f49af46a8b$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $acw62.useState)(false);
    const updateTarget = (0, $acw62.useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    // mediaQuery and updateTarget intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return targetReached;
};
const $f2f805f49af46a8b$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link, shouldRedirect: shouldRedirect, isSelected: isSelected })=>{
    const { text: text, href: href, onClick: onClick, target: target } = link;
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        css: [
            $f2f805f49af46a8b$var$$3e3d20b49785004a$var$linkStyles.default,
            isSelected && $f2f805f49af46a8b$var$$3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $f2f805f49af46a8b$export$e76239e22e3abad = ({ isSelected: isSelected = false, link: link, expandableBodyContent: expandableBodyContent, isNested: isNested = false, showNewMenu: showNewMenu = false })=>{
    const isBreakpoint = $f2f805f49af46a8b$export$32d5543ab307c01(`(max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return showNewMenu ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2771c1f4a09ce668, {
        headerContent: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested,
        isActive: isSelected
    }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$1229978ae51a03a8, {
        headerContent: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$3e3d20b49785004a$var$buttonDivStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $f2f805f49af46a8b$var$$3e3d20b49785004a$var$buttonDivStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $f2f805f49af46a8b$var$$3e3d20b49785004a$var$linkStyles = {
    default: (0, $dnfL5.css)({
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.information")
        },
        [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $dnfL5.css)({
        [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
        }
    })
};
const $f2f805f49af46a8b$export$1229978ae51a03a8 = ({ headerContent: headerContent, expandedHeaderContent: expandedHeaderContent, bodyContent: bodyContent, onExpandClick: onExpandClick, isNested: isNested = false })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
            children: [
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: [
                        $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    tabIndex: 0,
                    "aria-selected": isOpen,
                    onClick: onExpandClickHandler,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onExpandClickHandler();
                        }
                    },
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: isOpen && $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1ZV7N))), {
                                label: "Collapse item"
                            }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dSnoq))), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                    css: [
                        $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            tabIndex: 0,
            "aria-selected": false,
            children: headerContent
        })
    });
};
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$headerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
    a: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    },
    span: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $dnfL5.css)({
    padding: "0 40px"
});
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $dnfL5.css)({
    li: {
        paddingLeft: "56px"
    }
});
const $f2f805f49af46a8b$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $dnfL5.css)({
    svg: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $f2f805f49af46a8b$export$c7fcbaf97c146aec = ({ title: title, menuHeader: menuHeader, menuContent: menuContent, type: type = "menuItem" })=>{
    const { openSlideMenu: openSlideMenu } = $f2f805f49af46a8b$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleOpenMenu = (0, $acw62.useCallback)(()=>{
        openSlideMenu({
            header: menuHeader || title,
            content: menuContent
        });
    }, [
        openSlideMenu,
        menuHeader,
        title,
        menuContent
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleOpenMenu);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
        "data-testid": "navbar-slide-menu-item",
        css: [
            $f2f805f49af46a8b$var$$67abd1c503eb8615$var$listItemStyles,
            type === "subMenuItem" && $f2f805f49af46a8b$var$$67abd1c503eb8615$var$subMenuItemStyles
        ],
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            role: "button",
            tabIndex: 0,
            css: $f2f805f49af46a8b$var$$67abd1c503eb8615$var$interactiveContentStyles,
            onClick: handleOpenMenu,
            onKeyDown: onKeyDown,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: $f2f805f49af46a8b$var$$67abd1c503eb8615$var$titleStyles,
                    children: title
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    size: "medium"
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$67abd1c503eb8615$var$titleStyles = (0, $dnfL5.css)({
    fontSize: "16px",
    fontWeight: 400
});
const $f2f805f49af46a8b$var$$67abd1c503eb8615$var$listItemStyles = (0, $dnfL5.css)({});
const $f2f805f49af46a8b$var$$67abd1c503eb8615$var$interactiveContentStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`,
    paddingRight: "18px",
    height: "32px",
    "&:hover": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link")
    }
});
const $f2f805f49af46a8b$var$$67abd1c503eb8615$var$subMenuItemStyles = (0, $dnfL5.css)({
    "& > div": {
        padding: `0 18px 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")}`
    }
});
const $f2f805f49af46a8b$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$397a78fff494027c$var$headerContentStyles,
            isExpanded && $f2f805f49af46a8b$var$$397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $b2487e6c908f2748$export$2e2bcd8739ae039), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $f2f805f49af46a8b$export$1cba3806e1f1b01d = ({ user: user, expandableMenuContent: expandableMenuContent, profileMenuContent: profileMenuContent, onProfileMenuClick: onProfileMenuClick, showNewMenu: showNewMenu = false })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    const isBreakpoint = $f2f805f49af46a8b$export$32d5543ab307c01(`(max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $acw62.useRef)(null);
    $f2f805f49af46a8b$export$aa79b0abe3dfeaba([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return showNewMenu ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c7fcbaf97c146aec, {
        title: $f2f805f49af46a8b$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        menuHeader: $f2f805f49af46a8b$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        menuContent: expandableMenuContent
    }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$1229978ae51a03a8, {
        headerContent: $f2f805f49af46a8b$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $f2f805f49af46a8b$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
        ref: avatarMenuRef,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                css: [
                    $f2f805f49af46a8b$var$$397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $f2f805f49af46a8b$var$$397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $b2487e6c908f2748$export$2e2bcd8739ae039), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                css: $f2f805f49af46a8b$var$$397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $f2f805f49af46a8b$var$$397a78fff494027c$var$headerContentStyles = (0, $dnfL5.css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem",
    lineHeight: "20px"
});
const $f2f805f49af46a8b$var$$397a78fff494027c$var$nameStyles = (0, $dnfL5.css)({
    alignSelf: "center"
});
const $f2f805f49af46a8b$var$$397a78fff494027c$var$avatarStyles = (0, $dnfL5.css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$397a78fff494027c$var$avatarUserSelectedStyles = (0, $dnfL5.css)({
    "& > * > span": {
        outline: `2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")} solid`
    }
});
const $f2f805f49af46a8b$var$$397a78fff494027c$var$openMenuStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});
const $f2f805f49af46a8b$export$2ce376c2cc3355c8 = ({ link: link, type: type, contentBefore: contentBefore, contentAfter: contentAfter })=>{
    const { href: href, onClick: onClick, text: text, icon: icon } = link;
    const isActive = (0, $acw62.useMemo)(()=>href && globalThis ? globalThis.location.pathname === href : false, [
        href
    ]);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        css: $f2f805f49af46a8b$var$$3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("li", {
            css: [
                $f2f805f49af46a8b$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $f2f805f49af46a8b$var$$3539883ac1727dfc$var$menuItemContainerStyles[type],
                isActive && $f2f805f49af46a8b$var$$3539883ac1727dfc$var$activeStyles
            ],
            role: "treeitem",
            "aria-selected": isActive,
            children: [
                contentBefore,
                text,
                icon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: $f2f805f49af46a8b$var$$3539883ac1727dfc$var$iconStyles,
                    children: icon
                }),
                contentAfter
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $f2f805f49af46a8b$var$$3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $dnfL5.css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $dnfL5.css)({
        height: "48px",
        padding: "0 24px"
    }),
    menuItem: (0, $dnfL5.css)({
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        height: "32px",
        padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
    })
};
const $f2f805f49af46a8b$var$$3539883ac1727dfc$var$menuLinkStyles = (0, $dnfL5.css)({
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        }
    }
});
const $f2f805f49af46a8b$var$$3539883ac1727dfc$var$activeStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
});
const $f2f805f49af46a8b$var$$3539883ac1727dfc$var$iconStyles = (0, $dnfL5.css)({
    display: "inline-flex",
    alignItems: "center",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$e2bb601faa5fb56f$export$a24e9349d70a402 = ({ navRef: navRef })=>{
    const navWrapperTopPosition = (0, $acw62.useMemo)(()=>navRef.current?.getBoundingClientRect()?.y || 56, [
        navRef
    ]);
    const ref = (0, $acw62.useRef)(null);
    const { closeSlideMenu: closeSlideMenu, slideMenuContent: slideMenuContent, isSlideMenuOpen: isSlideMenuOpen, setContainerHeight: setContainerHeight } = $f2f805f49af46a8b$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const { header: header, content: content } = slideMenuContent || {};
    const isTitleString = typeof header === "string";
    (0, $acw62.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const preventScroll = (e)=>{
            if (element.contains(e.target)) return;
            e.preventDefault();
        };
        element.addEventListener("wheel", preventScroll);
        element.addEventListener("touchmove", preventScroll);
        return ()=>{
            element.removeEventListener("wheel", preventScroll);
            element.removeEventListener("touchmove", preventScroll);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isSlideMenuOpen) setContainerHeight(ref.current?.getBoundingClientRect().height || "initial");
    // setContainerHeight intentionally excluded (stable setState function)
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        isSlideMenuOpen
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        ref: ref,
        "data-testid": "slide-menu",
        css: [
            $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$menuStyles,
            (0, $dnfL5.css)({
                maxHeight: `calc(100vh - ${navWrapperTopPosition}px)`
            })
        ],
        "aria-hidden": !isSlideMenuOpen,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$backButtonContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.LINK,
                    onClick: closeSlideMenu,
                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "chevron-left",
                        size: "medium"
                    }),
                    label: "Back"
                })
            }),
            header && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    !isTitleString && $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$headerStyles,
                    isTitleString && $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$titleStyles
                ],
                children: header
            }),
            content && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$contentStyles,
                children: content
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$menuStyles = (0, $dnfL5.css)({
    position: "fixed",
    width: "375px",
    overflow: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    zIndex: 1000,
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    top: 0,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        transition: "transform 0.3s cubic-bezier(.4,1,.5,1), opacity 0.3s",
        transform: "translateX(-100%)",
        left: 0,
        width: "100vw"
    }
});
const $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$backButtonContainerStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    "& button": {
        padding: 0,
        marginLeft: "-9px",
        fontWeight: 400
    }
});
const $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$headerStyles = (0, $dnfL5.css)({
    textTransform: "uppercase",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    "& > div": {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$titleStyles = (0, $dnfL5.css)({
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    fontFamily: "Charlie Text, sans-serif",
    textTransform: "uppercase",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")
});
const $f2f805f49af46a8b$var$$e2bb601faa5fb56f$var$contentStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH = 375;
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen, toggleMenu: toggleMenu })=>{
    const { closeSlideMenu: closeSlideMenu } = $f2f805f49af46a8b$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleToggle = ()=>{
        toggleMenu();
        if (isOpen) closeSlideMenu();
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $361fce14cc02175c$export$2e2bcd8739ae039), {
        appearance: "subtle",
        onClick: handleToggle,
        icon: isOpen ? $f2f805f49af46a8b$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 : $f2f805f49af46a8b$var$$5ba5f450ff826a14$export$2e2bcd8739ae039,
        label: isOpen ? "Close menu" : "Open menu"
    });
};
const $f2f805f49af46a8b$export$214ae410b202e65a = ({ leftItems: leftItems, rightItems: rightItems, logoItem: logoItem, isSticky: isSticky = true, onMenuToggleClick: onMenuToggleClick, onMenuOutsideClick: onMenuOutsideClick })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $acw62.useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("nav", {
        css: [
            $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)($f2f805f49af46a8b$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd, {
                        children: [
                            leftItems || rightItems ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                                ref: toggleRef,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$ToggleButton, {
                                    isOpen: isMenuOpen,
                                    toggleMenu: handleToggle
                                })
                            }) : null,
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$DesktopNavItems, {
                                leftItems: leftItems,
                                rightItems: rightItems
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$SmallNavItems, {
                                isMenuOpen: isMenuOpen,
                                setIsMenuOpen: setIsMenuOpen,
                                onMenuOutsideClick: onMenuOutsideClick,
                                leftItems: leftItems,
                                rightItems: rightItems,
                                toggleRef: toggleRef
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            leftItems?.map((item, index)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                    css: [
                        $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                    css: [
                        $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
        css: $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen, onMenuOutsideClick: onMenuOutsideClick, leftItems: leftItems, rightItems: rightItems, toggleRef: toggleRef })=>{
    const navRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const slideMenuWrapperRef = (0, $acw62.useRef)(null);
    const { isSlideMenuOpen: isSlideMenuOpen, containerHeight: containerHeight, closeSlideMenu: closeSlideMenu } = $f2f805f49af46a8b$var$$ff532043ef39c56f$export$74d704c90f90362c();
    $f2f805f49af46a8b$export$aa79b0abe3dfeaba([
        menuRef,
        slideMenuWrapperRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            closeSlideMenu();
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        ref: navRef,
        css: [
            $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles,
            isSlideMenuOpen && (0, $dnfL5.css)({
                height: containerHeight
            })
        ],
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                ref: slideMenuWrapperRef,
                css: [
                    $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$slideMenuStyles,
                    isSlideMenuOpen && $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles,
                    !isSlideMenuOpen && $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$e2bb601faa5fb56f$export$a24e9349d70a402, {
                    navRef: navRef
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles,
                    isSlideMenuOpen && $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                    css: $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavUlStyles,
                    ref: menuRef,
                    role: "menubar",
                    "aria-orientation": "vertical",
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$MenuItems, {
                        leftItems: leftItems,
                        rightItems: rightItems
                    })
                })
            })
        ]
    }) : null;
};
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $dnfL5.css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles = (0, $dnfL5.css)({
    position: "relative",
    transition: "transform 0.4s cubic-bezier(.5,1,.5,1)",
    zIndex: 1,
    borderRadius: "8px"
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles = (0, $dnfL5.css)({
    transform: "translateX(0)",
    opacity: 1,
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)",
        top: "56px"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles = (0, $dnfL5.css)({
    transform: "translateX(-100%)",
    opacity: 0,
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(-100vw)",
        top: "56px"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles = (0, $dnfL5.css)({
    transform: `translateX(${$f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px)`,
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$slideMenuStyles = (0, $dnfL5.css)({
    position: "absolute",
    left: 0,
    top: 0,
    width: `${$f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
    height: "100%",
    zIndex: 2,
    transition: "height 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(.5,1,.5,1), opacity 0.2s",
    transform: "translateX(-100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        width: "100vw",
        position: "fixed",
        borderRadius: 0,
        height: "100%"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$containerStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$stickyStyles = (0, $dnfL5.css)({
    position: "fixed"
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$innerContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $dnfL5.css)({
    flex: 1,
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $dnfL5.css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.brand")
        }
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    overflow: "hidden",
    transition: "height 0.4s cubic-bezier(.5,1,.5,1)",
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MIN_WIDTH}px) and (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: `${$f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $dnfL5.css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$leftItemStyles = (0, $dnfL5.css)({
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$var$rightItemStyles = (0, $dnfL5.css)({
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});
var $f2f805f49af46a8b$var$$9efbb38deb40219f$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$9efbb38deb40219f$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9efbb38deb40219f$exports, "NavigationBarWithProfile", ()=>$f2f805f49af46a8b$export$fddd19fbf4d591d8);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9efbb38deb40219f$exports, "default", ()=>$f2f805f49af46a8b$var$$9efbb38deb40219f$export$2e2bcd8739ae039);
/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ const $f2f805f49af46a8b$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$e76239e22e3abad, {
        ...rest
    });
};
/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ const $f2f805f49af46a8b$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children, onClick: onClick })=>{
    const noOp = ()=>{};
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: onClick ? handleKeyDown : undefined,
        children: children
    });
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    return {
        ...payload,
        source: "communityNavigation",
        attributes: {
            ...payload.attributes || {},
            currentApp: analyticsInfo.currentApp,
            isLoggedIn: analyticsInfo.isLoggedIn,
            isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
        }
    };
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo, subtitleHref: subtitleHref, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: $f2f805f49af46a8b$export$93d048dc21eb282a.HOME
                }
            }, analyticsInfo), $f2f805f49af46a8b$export$d778a884eb401313.NAV_LOGO_CLICK);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$6ce3be5638d8e2a, {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo, destinationApp: destinationApp, link: link, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), $f2f805f49af46a8b$export$d778a884eb401313.NAV_ITEM_CLICK);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b, {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $dnfL5.css)({
        padding: "0 24px"
    }) : undefined;
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $dnfL5.css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
            borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $dnfL5.css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$signupButtonStyles = (isMobile)=>(0, $dnfL5.css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$c421b2a9819014e7 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $f2f805f49af46a8b$export$d778a884eb401313.LOG_IN_CLICK);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                css: $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$loginButtonStyles(isMobile),
                href: href,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
                    appearance: "subtle",
                    children: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$46dbfbdf99745111
                })
            })
        })
    });
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$5f193ccad31822c4 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $f2f805f49af46a8b$export$d778a884eb401313.SIGN_UP_CLICK);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                css: $f2f805f49af46a8b$var$$341f96d5922d8aaa$var$signupButtonStyles(isMobile),
                href: href,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
                    appearance: "primary",
                    children: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$4fe37309c24221ae
                })
            })
        })
    });
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $f2f805f49af46a8b$export$d778a884eb401313.PROFILE_MENU_OPEN : $f2f805f49af46a8b$export$d778a884eb401313.PROFILE_MENU_CLOSE);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$1cba3806e1f1b01d, {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $f2f805f49af46a8b$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo, link: link, type: type, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), $f2f805f49af46a8b$export$d778a884eb401313.PROFILE_MENU_ITEM_CLICK);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2ce376c2cc3355c8, {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $f2f805f49af46a8b$export$d778a884eb401313.MOBILE_MENU_OPEN : $f2f805f49af46a8b$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($f2f805f49af46a8b$export$3d7865934588d77e.UI, $f2f805f49af46a8b$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), $f2f805f49af46a8b$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$214ae410b202e65a, {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};
const $f2f805f49af46a8b$var$$9efbb38deb40219f$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, switchHref, analyticsInfo)=>{
    const subMenuItems = [];
    if (profileHref) subMenuItems.push({
        ...$f2f805f49af46a8b$var$$1ff01338112cd7fe$export$668d072b293d5f38.PROFILE,
        href: profileHref
    });
    if (settingsHref) subMenuItems.push({
        ...$f2f805f49af46a8b$var$$1ff01338112cd7fe$export$668d072b293d5f38.SETTINGS,
        href: settingsHref
    });
    if (switchHref) subMenuItems.push({
        ...$f2f805f49af46a8b$var$$1ff01338112cd7fe$export$668d072b293d5f38.SWITCH_ACCOUNT,
        href: switchHref
    });
    if (logoutHref) subMenuItems.push({
        ...$f2f805f49af46a8b$var$$1ff01338112cd7fe$export$668d072b293d5f38.LOG_OUT,
        href: logoutHref
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: subMenuItems.map((item, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$92905cc84b82619c, {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $f2f805f49af46a8b$export$fddd19fbf4d591d8 = ({ logoItem: logoItem, leftItems: leftItems, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, onAnalyticsSendEvent: onAnalyticsSendEvent, isSticky: isSticky = true, showNewMenu: showNewMenu = false, currentApp: currentApp = "unknown" })=>{
    const isMobileOrTablet = $f2f805f49af46a8b$export$32d5543ab307c01(`(max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    // Set up analytics info
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Render right items based on login state
    const rightItems = [];
    if (isLoggedIn && user) rightItems.push((0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$55b351f575b2f75b, {
        user: user,
        expandableMenuContent: $f2f805f49af46a8b$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, showNewMenu ? "menuItem" : "subMenu", profileHref, settingsHref, switchHref, analyticsInfo),
        profileMenuContent: $f2f805f49af46a8b$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, switchHref, analyticsInfo),
        analyticsInfo: analyticsInfo,
        showNewMenu: showNewMenu
    }));
    else if (isMobileOrTablet) rightItems.push((0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $f450fb6bcb502a17$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            }),
            signupHref && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            })
        ]
    }));
    else rightItems.push((0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $703a8c2f286efa80$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo
            }),
            signupHref && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo
            })
        ]
    }));
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$86a131c9ca6f534a, {
        logoItem: logoItem,
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};
var $f2f805f49af46a8b$var$$9efbb38deb40219f$export$2e2bcd8739ae039 = $f2f805f49af46a8b$export$fddd19fbf4d591d8;
var $f2f805f49af46a8b$var$$3fbcb32390ca7008$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3fbcb32390ca7008$exports, "RadioType", ()=>$f2f805f49af46a8b$export$f5eff9f4cffe1e46);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3fbcb32390ca7008$exports, "RadioSize", ()=>$f2f805f49af46a8b$export$4da24539a3bb7d98);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3fbcb32390ca7008$exports, "Radio", ()=>$f2f805f49af46a8b$export$d7b12c4107be0d61);
let $f2f805f49af46a8b$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($f2f805f49af46a8b$export$f5eff9f4cffe1e46 || ($f2f805f49af46a8b$export$f5eff9f4cffe1e46 = {}));
let $f2f805f49af46a8b$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($f2f805f49af46a8b$export$4da24539a3bb7d98 || ($f2f805f49af46a8b$export$4da24539a3bb7d98 = {}));
const $f2f805f49af46a8b$export$d7b12c4107be0d61 = ({ label: label = "", name: name, isChecked: isChecked, setIsChecked: setIsChecked, type: type = $f2f805f49af46a8b$export$f5eff9f4cffe1e46.DEFAULT, size: size = $f2f805f49af46a8b$export$4da24539a3bb7d98.DEFAULT, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const handleChange = (0, $acw62.useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleChange);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$radioContainerStyles,
            size === $f2f805f49af46a8b$export$4da24539a3bb7d98.LARGE && (0, $dnfL5.css)({
                columnGap: "8px"
            })
        ],
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$labelStyles,
                size === $f2f805f49af46a8b$export$4da24539a3bb7d98.LARGE && $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$labelLargeStyles,
                type === $f2f805f49af46a8b$export$f5eff9f4cffe1e46.DISABLED && $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $dnfL5.css)({
                    fontWeight: 700
                }),
                !isBold && (0, $dnfL5.css)({
                    fontWeight: 400
                })
            ],
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    css: $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$e61786c4aee8d415, {
                    children: label
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$checkmarkStyles,
                        size === $f2f805f49af46a8b$export$4da24539a3bb7d98.LARGE && $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $f2f805f49af46a8b$export$f5eff9f4cffe1e46.DANGER && (0, $dnfL5.css)({
                            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger")
                        })
                    ]
                }),
                isRequired && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: [
                        $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $f2f805f49af46a8b$export$4da24539a3bb7d98.LARGE && (0, $dnfL5.css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$radioContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    columnGap: "6px"
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$requiredMarkStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "2px"
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$inputStyles = (0, $dnfL5.css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$checkmarkStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "4px"
    }
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $dnfL5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input")
    }
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$labelStyles = (0, $dnfL5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$labelLargeStyles = (0, $dnfL5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $f2f805f49af46a8b$var$$3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $dnfL5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $dnfL5.css)({
            ":hover": {
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $dnfL5.css)({
            ":hover": {
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $dnfL5.css)({
            "&, &:hover": {
                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $dnfL5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $f2f805f49af46a8b$var$$731a4fd527bab680$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$731a4fd527bab680$exports, "TabsSize", ()=>$f2f805f49af46a8b$export$ddadc1228c8dcfa);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$731a4fd527bab680$exports, "Tab", ()=>$f2f805f49af46a8b$export$3e41faf802a29e71);
let $f2f805f49af46a8b$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["SMALL"] = "small";
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($f2f805f49af46a8b$export$ddadc1228c8dcfa || ($f2f805f49af46a8b$export$ddadc1228c8dcfa = {}));
const $f2f805f49af46a8b$export$3e41faf802a29e71 = ({ label: label, labelColor: labelColor = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"), labelColorSelected: labelColorSelected = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"), labelColorSelectedHover: labelColorSelectedHover = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"), onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, size: size = $f2f805f49af46a8b$export$ddadc1228c8dcfa.MEDIUM, selected: selected = false, selectedColor: selectedColor, selectedHoverColor: selectedHoverColor, isLoading: isLoading })=>{
    const clickHandler = (0, $acw62.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabStyles["basic"],
            selected && $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`],
            labelColor && !selected && (0, $dnfL5.css)({
                color: labelColor
            }),
            labelColorSelected && selected && (0, $dnfL5.css)({
                color: labelColorSelected
            }),
            labelColorSelectedHover && selected && (0, $dnfL5.css)({
                "&:hover": {
                    color: labelColorSelectedHover
                }
            }),
            selected && selectedColor && (0, $dnfL5.css)({
                backgroundColor: selectedColor,
                borderColor: selectedColor
            }),
            selected && selectedHoverColor && (0, $dnfL5.css)({
                "&:hover": {
                    backgroundColor: selectedHoverColor,
                    borderColor: selectedHoverColor
                }
            })
        ],
        children: [
            iconBefore && !isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $dnfL5.css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $dnfL5.css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $dnfL5.css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabStyles = {
    basic: (0, $dnfL5.css)({
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        border: `0.125rem solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
            borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
        }
    }),
    selected: (0, $dnfL5.css)({
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.bold.pressed"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.brand.boldest"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabSpacingStyles = {
    small: (0, $dnfL5.css)({
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`,
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
            padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`
        }
    }),
    "small-icon-before": (0, $dnfL5.css)({
        padding: "0.375rem 1rem 0.375rem 0.5rem"
    }),
    "small-icon-after": (0, $dnfL5.css)({
        padding: "0.375rem 0.5rem 0.375rem 1rem"
    }),
    medium: (0, $dnfL5.css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $dnfL5.css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $dnfL5.css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $dnfL5.css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $dnfL5.css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $dnfL5.css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $f2f805f49af46a8b$var$$731a4fd527bab680$var$tabIconContainerStyles = (0, $dnfL5.css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$5cf70e33bfc6ce73$exports, "Tag", ()=>$f2f805f49af46a8b$export$3288d34c523a1192);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$5cf70e33bfc6ce73$exports, "tagListStyles", ()=>$f2f805f49af46a8b$export$f40d73b6f7f951e9);
const $f2f805f49af46a8b$export$3288d34c523a1192 = ({ inspectMode: inspectMode, label: label, onClick: onClick, selected: selected, iconAfter: iconAfter, iconBefore: iconBefore, isLarge: isLarge, isTall: isTall, labelColor: labelColor, borderColor: borderColor, backgroundColor: backgroundColor })=>{
    const customStyles = (0, $dnfL5.css)({
        ...labelColor && {
            color: labelColor
        },
        ...borderColor && {
            borderColor: borderColor
        },
        ...backgroundColor && {
            backgroundColor: backgroundColor
        }
    });
    const noOp = ()=>{};
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        ...$f2f805f49af46a8b$export$1784ac302bd8ebad("tag", inspectMode),
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : -1,
        css: [
            $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$tagStyles,
            selected && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$afterIconTagStyles,
            isLarge && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$largeTagStyles,
            isTall && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$tallTagStyles,
            customStyles
        ],
        onClick: onClick,
        onKeyDown: onClick ? onKeyDown : undefined,
        children: [
            iconBefore && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    isLarge && $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$largeTagTextStyles,
                    labelColor && (0, $dnfL5.css)({
                        color: labelColor
                    })
                ],
                children: label
            }),
            iconAfter && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: [
                    $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
};
const $f2f805f49af46a8b$export$f40d73b6f7f951e9 = (0, $dnfL5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$tagStyles = (0, $dnfL5.css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`,
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $dnfL5.css)({
    "&:hover": {
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$selectedTagStyles = (0, $dnfL5.css)({
    borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$iconStyles = (0, $dnfL5.css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$beforeIconStyles = (0, $dnfL5.css)({
    marginRight: "0.125rem"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$afterIconStyles = (0, $dnfL5.css)({
    marginLeft: "0.125rem"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $dnfL5.css)({
    paddingLeft: "0.375rem"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $dnfL5.css)({
    paddingRight: "0.375rem"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$largeTagStyles = (0, $dnfL5.css)({
    display: "flex",
    height: "32px",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    textTransform: "uppercase",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$largeTagTextStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'var(--Font-Family-Eyebrow, "Charlie Text")',
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase"
});
const $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$var$tallTagStyles = (0, $dnfL5.css)({
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "6px",
    paddingRight: "6px",
    height: "auto"
});
var $f2f805f49af46a8b$var$$8b54d37779d052e8$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$8b54d37779d052e8$exports, "Text", ()=>$f2f805f49af46a8b$export$5f1af8db9871e1d6);
const $f2f805f49af46a8b$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular", size: size = "regular", color: color = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.gray.bolder"), children: children, backgroundColor: backgroundColor })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
        css: [
            $f2f805f49af46a8b$var$$8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $dnfL5.css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $dnfL5.css)({
                color: color
            }),
            $f2f805f49af46a8b$var$$8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $f2f805f49af46a8b$var$$8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $f2f805f49af46a8b$var$$8b54d37779d052e8$var$textDefaultStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    blockquote: $f2f805f49af46a8b$export$7a77f8e9665fa6b2,
    ul: $f2f805f49af46a8b$export$6427468642e6e9fe.list.unordered,
    ol: $f2f805f49af46a8b$export$6427468642e6e9fe.list.ordered
});
const $f2f805f49af46a8b$var$$8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $dnfL5.css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $dnfL5.css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $dnfL5.css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $dnfL5.css)({
            fontWeight: 400
        }),
        semibold: (0, $dnfL5.css)({
            fontWeight: 600
        }),
        bold: (0, $dnfL5.css)({
            fontWeight: 700
        })
    }
};
var $f2f805f49af46a8b$var$$9cfa05d02afa3952$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9cfa05d02afa3952$exports, "AccordionSize", ()=>$f2f805f49af46a8b$export$8f89d78db9c8c41f);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9cfa05d02afa3952$exports, "Accordion", ()=>$f2f805f49af46a8b$export$a766cd26d0d69044);
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $f2f805f49af46a8b$var$$51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title, index: index, children: children, isFirstTab: isFirstTab, isExpanded: isExpanded, shouldSingleTabBeOpen: shouldSingleTabBeOpen, setTabState: setTabState, setExpansionMap: setExpansionMap })=>{
    const tabRef = (0, $acw62.useRef)(null);
    const handleExpand = (0, $acw62.useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        index,
        setExpansionMap,
        setTabState,
        shouldSingleTabBeOpen
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $f2f805f49af46a8b$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $f2f805f49af46a8b$var$$51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $f2f805f49af46a8b$var$$51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $f2f805f49af46a8b$var$$51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    isExpanded && $f2f805f49af46a8b$var$$51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$51f57eef4d47f918$var$contentContainer,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: disableClickEventBubbling,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        css: $f2f805f49af46a8b$var$$51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$accordionTabStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$firstTabStyles = (0, $dnfL5.css)({
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$expandedTabStyles = (0, $dnfL5.css)({
    borderLeft: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.accent.blue")}`
});
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$expandedTabContentStyles = (0, $dnfL5.css)({
    marginLeft: "-0.5rem"
});
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$contentContainer = (0, $dnfL5.css)({
    marginLeft: "0.75rem"
});
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$titleStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$51f57eef4d47f918$var$contentStyles = (0, $dnfL5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});
let $f2f805f49af46a8b$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
    AccordionSize["FULL_WIDTH"] = "full-width";
})($f2f805f49af46a8b$export$8f89d78db9c8c41f || ($f2f805f49af46a8b$export$8f89d78db9c8c41f = {}));
const $f2f805f49af46a8b$export$a766cd26d0d69044 = ({ tabsContent: tabsContent, size: size, shouldSingleTabBeOpen: shouldSingleTabBeOpen, onChange: onChange })=>{
    const [expansionMap, setExpansionMap] = (0, $acw62.useState)([]);
    const [tabState, setTabState] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    // tabsContent intentionally excluded to avoid re-initializing on content changes
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $acw62.useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            $f2f805f49af46a8b$var$$9cfa05d02afa3952$var$baseAccordionStyles,
            $f2f805f49af46a8b$export$8f89d78db9c8c41f.DEFAULT === size && $f2f805f49af46a8b$var$$9cfa05d02afa3952$var$accordionDefaultStyles,
            $f2f805f49af46a8b$export$8f89d78db9c8c41f.WIDE === size && $f2f805f49af46a8b$var$$9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title, children: children, isExpanded: isExpanded }, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$51f57eef4d47f918$export$10e5e64ea66c812f, {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $f2f805f49af46a8b$var$$9cfa05d02afa3952$var$baseAccordionStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $f2f805f49af46a8b$var$$9cfa05d02afa3952$var$accordionDefaultStyles = (0, $dnfL5.css)({
    maxWidth: "720px"
});
const $f2f805f49af46a8b$var$$9cfa05d02afa3952$var$accordionWideStyles = (0, $dnfL5.css)({
    maxWidth: "1020px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px"
    }
});
var $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$7d458ed59bb9c6a8$exports, "InlineCode", ()=>$f2f805f49af46a8b$export$7f1bf47c7f50a6aa);
const $f2f805f49af46a8b$export$7f1bf47c7f50a6aa = ({ code: code = "" })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("code", {
        "data-testid": "code-block",
        css: $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                css: [
                    $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $dnfL5.css)({
                        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $dnfL5.css)({
                        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                onBlur: ()=>setIsCopied(false),
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        className: "tooltipText",
                        css: $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "copy",
                        color: isCopied ? (0, $2b750d3a8789dea3$export$29a4f05edc054374) : (0, $2b750d3a8789dea3$export$7d61b15e0da132af)
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                children: lines?.map((line, index)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                        css: $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $dnfL5.css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $dnfL5.css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$codeLinesStyles = (0, $dnfL5.css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$lineNumberStyles = (0, $dnfL5.css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtler")
});
const $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$var$lineTextStyles = (0, $dnfL5.css)({
    padding: "4px 8px 4px 0"
});
var $f2f805f49af46a8b$var$$a467abe0c2c1750b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a467abe0c2c1750b$exports, "Lozenge", ()=>$f2f805f49af46a8b$export$a31cbe1bf5463979);
const $f2f805f49af46a8b$export$a31cbe1bf5463979 = ({ appearance: appearance = "default", text: text, isBold: isBold })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $e1ce2b1d3d70c4a6$export$2e2bcd8739ae039), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });
var $f2f805f49af46a8b$var$$52124b9ae1d78e04$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$52124b9ae1d78e04$exports, "SectionMessageAppearance", ()=>$f2f805f49af46a8b$export$710836885d72543c);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$52124b9ae1d78e04$exports, "SectionMessage", ()=>$f2f805f49af46a8b$export$a36903bd214cec06);
let $f2f805f49af46a8b$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($f2f805f49af46a8b$export$710836885d72543c || ($f2f805f49af46a8b$export$710836885d72543c = {}));
const $f2f805f49af46a8b$export$a36903bd214cec06 = ({ children: children, appearance: appearance, fullWidth: fullWidth = false, padding: padding, title: title })=>{
    const isInfoWhite = appearance === $f2f805f49af46a8b$export$710836885d72543c.INFORMATION_WHITE;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles({
                padding: padding
            }),
            isInfoWhite && $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $dnfL5.css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$iconContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "info",
                    alt: "info icon",
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.accent.blue")
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$descriptionStyles,
                children: [
                    title && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                        level: 5,
                        children: title
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        children: children
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles = ({ padding: padding = (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200") })=>(0, $dnfL5.css)({
        display: "flex",
        width: "100%",
        borderRadius: "3px",
        padding: padding,
        columnGap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
    });
const $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$informationStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.information")
});
const $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$informationWhiteStyles = (0, $dnfL5.css)({
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface")
});
const $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$iconContainerStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$52124b9ae1d78e04$var$descriptionStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    "& *": {
        fontSize: "16px !important"
    }
});
var $f2f805f49af46a8b$var$$77696804880d7cdc$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$77696804880d7cdc$exports, "DropdownMenu", ()=>$f2f805f49af46a8b$export$e44a253a59704894);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$77696804880d7cdc$exports, "DropdownMenuCheckbox", ()=>$f2f805f49af46a8b$export$2393c31da95977ae);
// Main DropdownMenu component (config-based with items object or custom items array)
const $f2f805f49af46a8b$var$$0199732cf5257721$export$e960b0f5cc4a2826 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $16cda2aabaf6bb3c$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $266d196313c1f14d$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $f2f805f49af46a8b$var$$77e170ce1d4ab374$export$a6155c53cd00116c = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $c6a273f238e36c27$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $83e385c72b6ff66a$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $f2f805f49af46a8b$var$$0633f0dbed99c656$var$selectedItemStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected.hovered"),
    fontWeight: 600
});
const $f2f805f49af46a8b$var$$0633f0dbed99c656$var$iconMenuStyles = (0, $dnfL5.css)({
    "& button > span": {
        gap: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} !important`
    },
    // Ensure icon and text are vertically aligned
    '& button [role="img"]': {
        display: "flex !important"
    }
});
const $f2f805f49af46a8b$var$$0633f0dbed99c656$export$efefb5b75235a614 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        id: "actions",
        css: $f2f805f49af46a8b$var$$0633f0dbed99c656$var$iconMenuStyles,
        children: Object.entries(items).map(([label, value])=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: value.isSelected && $f2f805f49af46a8b$var$$0633f0dbed99c656$var$selectedItemStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $b946ff9b63436f4b$export$2e2bcd8739ae039), {
                    testId: `dropdown-item-${label}`,
                    isDisabled: value.isDisabled,
                    onClick: ()=>onItemClick(label),
                    elemBefore: value.icon,
                    children: label
                })
            }, label))
    });
};
const $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee = (0, $dnfL5.css)({
    "& > button": {
        border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.brand")}`,
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected"),
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$a6df230d684a2658 = (0, $dnfL5.css)({
    "#actions": {
        "button[disabled]": {
            background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
            span: {
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.disabled"),
                ":hover": {
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    }
});
const $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$e42df41f371072da = (0, $dnfL5.css)({
    "& > button": {
        border: 0,
        background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected")
    }
});
const $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5 = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$export$e44a253a59704894 = ({ items: items, placement: placement, onItemClick: onItemClick, customItems: customItems, isCheckboxMenu: isCheckboxMenu = false, triggerText: triggerText, customTriggerStyles: customTriggerStyles, customTriggerActiveStyles: customTriggerActiveStyles, customTriggerComponent: customTriggerComponent, isOptionMenu: isOptionMenu = false })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $acw62.useState)(false);
    const [itemsList, setItemList] = (0, $acw62.useState)(items ?? {});
    const isControlled = (0, $acw62.useRef)(false);
    const prevItemsRef = (0, $acw62.useRef)(items);
    // Check if we're using custom items mode
    const isCustomItemsMode = customItems && customItems.length > 0;
    (0, $acw62.useEffect)(()=>{
        if (!isCustomItemsMode && prevItemsRef.current !== items && items) {
            isControlled.current = true;
            setItemList(items);
            prevItemsRef.current = items;
        }
    }, [
        items,
        isCustomItemsMode
    ]);
    const handleItemClick = (label)=>{
        // Only update internal state if not controlled
        if (!isControlled.current) setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            if (isCheckboxMenu) updatedState[label].isSelected = !updatedState[label].isSelected;
            else Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        if (onItemClick) onItemClick(label);
    };
    const getTriggerText = (itemsChecked)=>{
        const selectedItems = Object.keys(itemsChecked).filter((key)=>itemsChecked[key].isSelected);
        if (isCheckboxMenu) {
            if (triggerText) return triggerText;
            // For checkbox mode, show count of selected items or first item name
            if (selectedItems.length === 0) return Object.keys(itemsChecked)[0] || "Select items";
            else if (selectedItems.length === 1) return selectedItems[0];
            return `${selectedItems.length} selected`;
        }
        if (triggerText) return triggerText;
        // For radio mode, show the selected item or first item
        return selectedItems[0] || Object.keys(itemsChecked)[0];
    };
    const renderTrigger = ()=>{
        const selectedItems = Object.keys(itemsList).filter((key)=>itemsList[key]?.isSelected);
        // If custom trigger component is provided, use it
        if (customTriggerComponent) return customTriggerComponent;
        // For custom items mode, just use the triggerText
        if (isCustomItemsMode) return triggerText || "Menu";
        // If checkbox mode with custom trigger text and selections, render custom trigger with badge
        if (isCheckboxMenu && triggerText && selectedItems.length > 0) return ({ triggerRef: triggerRef, ...triggerButtonProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                ...triggerButtonProps,
                ref: triggerRef,
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                    css: $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5,
                    children: [
                        triggerText,
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $e1ce2b1d3d70c4a6$export$2e2bcd8739ae039), {
                            isBold: true,
                            appearance: "inprogress",
                            children: selectedItems.length
                        })
                    ]
                })
            });
        // Otherwise return the text trigger
        return getTriggerText(itemsList);
    };
    const hasAnyIcons = Object.values(itemsList).some((item)=>item?.icon);
    const isAnyItemSelected = isCustomItemsMode ? false : Object.values(itemsList).some(({ isSelected: isSelected })=>isSelected);
    const renderMenuContent = ()=>{
        // Custom items mode - render custom DropdownItems
        if (isCustomItemsMode && customItems) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
            children: customItems.map((item, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $b946ff9b63436f4b$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    description: item.description,
                    elemBefore: item.elemBefore,
                    elemAfter: item.elemAfter,
                    testId: item.testId,
                    children: item.children
                }, item.testId ?? index))
        });
        if (isCheckboxMenu) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0199732cf5257721$export$e960b0f5cc4a2826, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        if (isOptionMenu || hasAnyIcons) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0633f0dbed99c656$export$efefb5b75235a614, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$77e170ce1d4ab374$export$a6155c53cd00116c, {
            items: itemsList,
            onItemClick: handleItemClick
        });
    };
    // Combine base styles with actions styles for full DropdownMenu styling
    const combinedTriggerStyles = (0, $dnfL5.css)([
        $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee,
        $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$a6df230d684a2658
    ]);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            combinedTriggerStyles,
            customTriggerStyles,
            isAnyItemSelected && isDropdownOpen && $f2f805f49af46a8b$var$$69215f50d6c9f1e0$export$e42df41f371072da,
            isAnyItemSelected && isDropdownOpen && customTriggerActiveStyles
        ],
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1263a8525c372af9$export$2e2bcd8739ae039), {
            onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
            trigger: renderTrigger(),
            shouldRenderToParent: true,
            placement: placement,
            children: renderMenuContent()
        })
    });
};
const $f2f805f49af46a8b$export$2393c31da95977ae = (props)=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$e44a253a59704894, {
        ...props,
        isCheckboxMenu: false
    });
};
var $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4366d2b05f9f8f6b$exports, "GreetingCard", ()=>$f2f805f49af46a8b$export$e52b3c28ffecde23);
const $f2f805f49af46a8b$var$$7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("defs", {
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip0_511_7308",
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip1_511_7308",
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });
const $f2f805f49af46a8b$var$$0467da094044eefe$export$590b8cc7d4f1d823 = ()=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                    id: "Clip path group",
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                                id: "clip0_10_2524",
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                                id: "Group",
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_2",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("defs", {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_608_7795",
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
const $f2f805f49af46a8b$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn, onClickContinue: onClickContinue })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$overlayStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$containerStyles,
            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $f450fb6bcb502a17$export$2e2bcd8739ae039), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$logoStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0467da094044eefe$export$590b8cc7d4f1d823, {})
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $f450fb6bcb502a17$export$2e2bcd8739ae039), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$7a335ab395aac0f5$export$6b53fc34987132a8, {})
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                children: "We've logged you out. Log back in to see what's changed"
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $703a8c2f286efa80$export$2e2bcd8739ae039), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$overlayStyles = (0, $dnfL5.css)({
    position: "fixed",
    zIndex: (0, $3624036857e6cb2b$export$7be255094ccdc533).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$containerStackStyles = (0, $f2984a0b621e238a$export$f6c783d06584602c)({
    height: "100%"
});
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$middleStackStyles = (0, $f2984a0b621e238a$export$f6c783d06584602c)({
    marginBottom: "space.500"
});
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$containerStyles = (0, $dnfL5.css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$communityLogoStyles = (0, $dnfL5.css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$logoStyles = (0, $dnfL5.css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $dnfL5.css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});
var $f2f805f49af46a8b$var$$be203e745bcefb12$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$be203e745bcefb12$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$be203e745bcefb12$exports, "Error", ()=>$f2f805f49af46a8b$export$edf27be85e5f6da0);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$be203e745bcefb12$exports, "default", ()=>$f2f805f49af46a8b$var$$be203e745bcefb12$export$2e2bcd8739ae039);
const $f2f805f49af46a8b$var$$72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};
const $f2f805f49af46a8b$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout, errorMessage: errorMessage })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$be203e745bcefb12$var$pageStyles,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: $f2f805f49af46a8b$var$$be203e745bcefb12$var$containerStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$72560d06a87aac8e$export$87321d307719eaf2, {}),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("h1", {
                    css: $f2f805f49af46a8b$var$$be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                    css: $f2f805f49af46a8b$var$$be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    label: "Log out",
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $f2f805f49af46a8b$var$$be203e745bcefb12$export$2e2bcd8739ae039 = $f2f805f49af46a8b$export$edf27be85e5f6da0;
const $f2f805f49af46a8b$var$$be203e745bcefb12$var$pageStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$be203e745bcefb12$var$containerStyles = (0, $dnfL5.css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.600")
});
const $f2f805f49af46a8b$var$$be203e745bcefb12$var$headingStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    fontFamily: (0, $c43cf29233629784$export$2e2bcd8739ae039)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $f2f805f49af46a8b$var$$be203e745bcefb12$var$descriptionStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});
var $f2f805f49af46a8b$var$$a0eced43682c2d75$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a0eced43682c2d75$exports, "LicenseModal", ()=>$f2f805f49af46a8b$export$bd0c6e28f5d6b66e);
const $f2f805f49af46a8b$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle, bodyTitle: bodyTitle, bodyDescription: bodyDescription, closeModal: closeModal, licenses: licenses })=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $7ea5684aaa353f60$export$2e2bcd8739ae039), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $c6373468b09630cb$export$2e2bcd8739ae039), {
                children: modalTitle && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $580232987e0040bf$export$2e2bcd8739ae039), {
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        css: (0, $dnfL5.css)({
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.brand")
                        }),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $ea269827cfabf855$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $5f8657baeb303619$export$2e2bcd8739ae039), {
                            children: bodyDescription
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: (0, $dnfL5.css)({
                                    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} 0`
                                }),
                                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $5f8657baeb303619$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                            css: $f2f805f49af46a8b$var$$a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                            css: (0, $dnfL5.css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }, license.packageName + index))
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $910e75271bd879af$export$2e2bcd8739ae039), {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$a0eced43682c2d75$var$spacingContainerStyles = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} 0`
});
const $f2f805f49af46a8b$var$$a0eced43682c2d75$var$licenseTitleStyles = (0, $dnfL5.css)({
    fontWeight: 600
});
var $f2f805f49af46a8b$var$$1db60c687807de63$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1db60c687807de63$exports, "SUCCESS_MESSAGE", ()=>$f2f805f49af46a8b$export$5620dbefc1cb6f80);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1db60c687807de63$exports, "ERROR_MESSAGE", ()=>$f2f805f49af46a8b$export$3f27bc10068ef877);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1db60c687807de63$exports, "NewsletterSignup", ()=>$f2f805f49af46a8b$export$21041608e6399292);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1db60c687807de63$exports, "Environment", ()=>$f2f805f49af46a8b$export$7dc6752a22ab011a);
var $f2f805f49af46a8b$var$$ca43fe01b6155439$exports = {};
var $f2f805f49af46a8b$var$$3ced3ef7e9864bf1$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3ced3ef7e9864bf1$exports, "DESKTOP_SCREEN_WIDTH", ()=>$f2f805f49af46a8b$export$27ed77542911fb0e);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3ced3ef7e9864bf1$exports, "TABLET_SCREEN_WIDTH", ()=>$f2f805f49af46a8b$export$62d1d6124a8e4649);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3ced3ef7e9864bf1$exports, "useDeviceSize", ()=>$f2f805f49af46a8b$export$4616d33c54ae5baf);
// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $f2f805f49af46a8b$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $f2f805f49af46a8b$export$27ed77542911fb0e = 1024;
const $f2f805f49af46a8b$export$62d1d6124a8e4649 = 900;
const $f2f805f49af46a8b$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $acw62.useState)(typeof window !== "undefined" ? window.innerWidth : $f2f805f49af46a8b$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $acw62.useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $f2f805f49af46a8b$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    // width intentionally excluded (stable state setter)
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return width;
};
var $f2f805f49af46a8b$var$$cbd57b1b072c1da3$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$cbd57b1b072c1da3$exports, "usePostNewsletterSignup", ()=>$f2f805f49af46a8b$export$ea96d97e8873ca7f);
const $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE = "community_learning_signup";
const $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF = "pointALead";
const $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$WAC_BASE_URL = {
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.LOCAL]: "/api/wac",
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.DEVELOPMENT]: "https://wac.stg.internal.atlassian.com",
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.STAGING]: "https://wac.stg.internal.atlassian.com",
    [$f2f805f49af46a8b$export$7dc6752a22ab011a.PRODUCTION]: "https://www.atlassian.com"
};
const $f2f805f49af46a8b$export$ea96d97e8873ca7f = ({ environment: environment = $f2f805f49af46a8b$export$7dc6752a22ab011a.DEVELOPMENT, onError: onError = ()=>null, onSuccess: onSuccess = ()=>null })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(false);
    const handleNewsletterSignup = async (formValues, formUrl)=>{
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const preferencesResponse = await $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$postPreferencesUpdate(formValues, environment, formUrl);
            if (!preferencesResponse.ok || preferencesResponse.status !== 202) throw new Error(`Error in postPreferencesUpdate with status: ${preferencesResponse.status}`);
            const wacResponse = await $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$postWacFormLead(formValues, environment);
            if (!wacResponse.ok || wacResponse.status !== 200) throw new Error(`Error in postWacFormLead with status: ${wacResponse.status}`);
            onSuccess();
            setSuccess(true);
        } catch (error) {
            if (error instanceof Error) setError(error.message);
            onError(error);
        } finally{
            setLoading(false);
        }
    };
    return {
        handleNewsletterSignup: handleNewsletterSignup,
        loading: loading,
        error: error,
        success: success
    };
};
const $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$postPreferencesUpdate = async (formValues, environment, formUrl)=>{
    const locale = navigator.language || Intl.DateTimeFormat().resolvedOptions().locale;
    const region = locale.split("-")[1];
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            consentCheckboxValue: true,
            consentLabelText: "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy.",
            email: formValues.email,
            formUrl: formUrl || "https://community.atlassian.com/",
            formId: "655e8a50-2d1f-4c1c-a782-fb5333e272a8",
            locale: region,
            paramsLocale: region,
            privacyPolicyText: '<p>By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy. <a href=\\"https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers\\">Atlassian Privacy Policy</a>.</p>\n',
            site: "atlassian"
        })
    };
    return fetch($f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/gateway/api/preferencesV2/update", requestOptions);
};
// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$postWacFormLead = async (formValues, environment)=>{
    const now = new Date();
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formValues,
            formType: $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE,
            formDef: $f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF,
            created_at: now.toISOString(),
            submitted: now.toString()
        })
    };
    return fetch($f2f805f49af46a8b$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/endpoint/streamhub/wacformlead", requestOptions);
};
var $f2f805f49af46a8b$var$$18cdd3872ade1318$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$18cdd3872ade1318$exports, "useScrollActiveSection", ()=>$f2f805f49af46a8b$export$c0e9cacf89df0750);
const $f2f805f49af46a8b$export$c0e9cacf89df0750 = ({ links: links, containerRef: containerRef, options: options = {} })=>{
    const [activeHref, setActiveHref] = (0, $acw62.useState)("");
    const { triggerPoint: triggerPoint = 0.3, topThreshold: topThreshold = 100 } = options;
    (0, $acw62.useEffect)(()=>{
        // Derive section IDs from links
        const linkHrefs = links.map((link)=>link.href ? link.href : $f2f805f49af46a8b$export$1bdcd43c8c2377cf(link.label));
        const sectionIds = linkHrefs.map((href)=>href.replace("#", ""));
        // Find sections by the IDs we derived from links
        const sections = sectionIds.map((id)=>document.getElementById(id)).filter(Boolean);
        if (sections.length === 0) return;
        const container = containerRef?.current;
        const isWindowScroll = !container;
        let ticking = false;
        const updateActiveSection = ()=>{
            // Get scroll position and dimensions
            const scrollY = isWindowScroll ? window.scrollY : container.scrollTop;
            const viewportHeight = isWindowScroll ? window.innerHeight : container.clientHeight;
            const triggerPointPx = viewportHeight * triggerPoint;
            // If we're at the very top, always select the first section
            if (scrollY < topThreshold) {
                setActiveHref(linkHrefs[0]);
                return;
            }
            // Find which section is currently at the trigger point
            let currentSectionIndex = 0;
            sections.forEach((section, index)=>{
                const rect = section.getBoundingClientRect();
                if (isWindowScroll) {
                    if (rect.top <= triggerPointPx) currentSectionIndex = index;
                } else {
                    // For container scroll, calculate relative position
                    const containerRect = container.getBoundingClientRect();
                    const relativeTop = rect.top - containerRect.top;
                    if (relativeTop <= triggerPointPx) currentSectionIndex = index;
                }
            });
            setActiveHref(linkHrefs[currentSectionIndex]);
        };
        const handleScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        };
        // Set initial active section
        updateActiveSection();
        // Attach scroll listener to container or window
        if (isWindowScroll) window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        else container.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            if (isWindowScroll) window.removeEventListener("scroll", handleScroll);
            else container.removeEventListener("scroll", handleScroll);
        };
    }, [
        links,
        containerRef,
        triggerPoint,
        topThreshold
    ]);
    return activeHref;
};
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$ca43fe01b6155439$exports, $f2f805f49af46a8b$var$$3ced3ef7e9864bf1$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$ca43fe01b6155439$exports, $f2f805f49af46a8b$var$$633811e9cd66d921$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$ca43fe01b6155439$exports, $f2f805f49af46a8b$var$$6e8a4d5d78071ed7$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$ca43fe01b6155439$exports, $f2f805f49af46a8b$var$$965a3cfbe886b380$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$ca43fe01b6155439$exports, $f2f805f49af46a8b$var$$cbd57b1b072c1da3$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$ca43fe01b6155439$exports, $f2f805f49af46a8b$var$$18cdd3872ade1318$exports);
var $f2f805f49af46a8b$var$$a6a41c835fd01d00$exports = {};
var $f2f805f49af46a8b$var$$1ca64a7075ab6eae$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1ca64a7075ab6eae$exports, "TextField", ()=>$f2f805f49af46a8b$export$2c73285ae9390cec);
const $f2f805f49af46a8b$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false, onChange: onChange = ()=>{
    return null;
}, value: value, isDisabled: isDisabled = false, isRequired: isRequired = false, ...rest })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("input", {
        css: [
            $f2f805f49af46a8b$var$$1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $f2f805f49af46a8b$var$$1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $f2f805f49af46a8b$var$$1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest
    });
const $f2f805f49af46a8b$var$$1ca64a7075ab6eae$var$inputStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "1px solid #388BFF",
        outline: "1px solid #388BFF"
    }
});
const $f2f805f49af46a8b$var$$1ca64a7075ab6eae$var$invalidStyles = (0, $dnfL5.css)({
    border: "1px solid #C9372C",
    outline: "1px solid #C9372C"
});
const $f2f805f49af46a8b$var$$1ca64a7075ab6eae$var$disabledStyles = (0, $dnfL5.css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});
var $f2f805f49af46a8b$var$$60ab015507144a2b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$60ab015507144a2b$exports, "TextFieldMessage", ()=>$f2f805f49af46a8b$export$9144c5f9beecc4b7);
const $f2f805f49af46a8b$export$9144c5f9beecc4b7 = ({ message: message = "Example text here", type: type = "valid" })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $aa4d7172759f512c$export$8fbe3c7d0ed2c683), {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                    css: $f2f805f49af46a8b$var$$60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $aa4d7172759f512c$export$915e9e7bd4f0f96d), {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                    css: $f2f805f49af46a8b$var$$60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $aa4d7172759f512c$export$5505afb209a532c8), {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                    css: $f2f805f49af46a8b$var$$60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $f2f805f49af46a8b$var$$60ab015507144a2b$var$spacing = (0, $dnfL5.css)({
    marginTop: "2px"
});
const $f2f805f49af46a8b$var$$60ab015507144a2b$var$helperMessageStyle = (0, $dnfL5.css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $f2f805f49af46a8b$var$$60ab015507144a2b$var$errorMessageStyle = (0, $dnfL5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $f2f805f49af46a8b$var$$60ab015507144a2b$var$validMessageStyles = (0, $dnfL5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
var $f2f805f49af46a8b$var$$57b1d5df6b5425d4$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$57b1d5df6b5425d4$exports, "TextFieldLabel", ()=>$f2f805f49af46a8b$export$76375b2580d1f8ac);
const $f2f805f49af46a8b$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label", isRequired: isRequired = true })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
        htmlFor: "basic-textfield",
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
            css: $f2f805f49af46a8b$var$$57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $d947b0e94e999790$export$2e2bcd8739ae039), {})
            ]
        })
    });
const $f2f805f49af46a8b$var$$57b1d5df6b5425d4$var$labelStyles = (0, $dnfL5.css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
var $f2f805f49af46a8b$var$$4be7278e65b71184$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4be7278e65b71184$exports, "UnifiedAccountCardContent", ()=>$f2f805f49af46a8b$export$c031b829a2452999);
var $f2f805f49af46a8b$var$$fc6addd2061b87dd$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$fc6addd2061b87dd$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fc6addd2061b87dd$exports, "default", ()=>$f2f805f49af46a8b$var$$fc6addd2061b87dd$export$2e2bcd8739ae039);
const $f2f805f49af46a8b$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions, isDisabled: isDisabled })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1263a8525c372af9$export$2e2bcd8739ae039), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $361fce14cc02175c$export$2e2bcd8739ae039), {
                    ...props,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($d54c3c01d7096ae7$exports))),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $e6fa7af9dd0097ab$export$2e2bcd8739ae039), {
            children: actions.map((action, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $b946ff9b63436f4b$export$2e2bcd8739ae039), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $f2f805f49af46a8b$var$$fc6addd2061b87dd$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $f2f805f49af46a8b$var$$fc6addd2061b87dd$var$buttonWrapperStyle = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});
const $f2f805f49af46a8b$export$c031b829a2452999 = ({ email: email, tags: tags, actions: actions, disableMenu: disableMenu })=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$contentWrapperStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$dropdownWrapperStyles,
                children: disableMenu ? null : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$fc6addd2061b87dd$export$2e2bcd8739ae039, {
                    actions: actions,
                    isDisabled: disableMenu
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$coverImageWrapperStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$coverImageStyles,
                    children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                                clipPath: "url(#clip0_985_48434)",
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("defs", {
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$textWrapperStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$contentWrapperStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$coverImageWrapperStyles = (0, $dnfL5.css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    borderTopRightRadius: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$coverImageStyles = (0, $dnfL5.css)({
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$textWrapperStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$emailStyles = (0, $dnfL5.css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$tagsWrapperStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$tagItemStyles = (0, $dnfL5.css)({
    display: "inline-block"
});
const $f2f805f49af46a8b$var$$4be7278e65b71184$var$dropdownWrapperStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    right: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
var $f2f805f49af46a8b$var$$db9d361cdef36cb6$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", ()=>$f2f805f49af46a8b$export$c9d2f1697787ae74);
const $f2f805f49af46a8b$export$c9d2f1697787ae74 = ({ children: children, testId: testId, onClick: onClick, isAddAccount: isAddAccount = false })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
        "data-testid": testId,
        css: [
            $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$unstyledButtonStyles,
            $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$hoverEffectStyles : $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$unstyledButtonStyles = (0, $dnfL5.css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $c43cf29233629784$export$2e2bcd8739ae039)("font.family.brand.body")
});
const $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$cardContainerStyles = (0, $dnfL5.css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$hoverEffectStyles = (0, $dnfL5.css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$noPointerCursorStyles = (0, $dnfL5.css)({
    cursor: "default"
});
const $f2f805f49af46a8b$var$$db9d361cdef36cb6$var$addAccountStyles = (0, $dnfL5.css)({
    border: `1px dashed ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: "none"
});
var $f2f805f49af46a8b$var$$e6da040d2ca2c72a$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", ()=>$f2f805f49af46a8b$export$fc13faf098015d3a);
const $f2f805f49af46a8b$var$$5089616a215e9052$var$ellipseStyles = (0, $dnfL5.css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $f2f805f49af46a8b$var$$5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$5089616a215e9052$var$ellipseStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b932394ef8ad724b$exports))), {
            label: "Add",
            size: "large",
            primaryColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
        })
    });
};
const $f2f805f49af46a8b$var$$e6da040d2ca2c72a$var$contentStyles = (0, $dnfL5.css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $f2f805f49af46a8b$var$$e6da040d2ca2c72a$var$textStyles = (0, $dnfL5.css)({
    marginTop: "16px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $f2f805f49af46a8b$export$fc13faf098015d3a = ()=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$e6da040d2ca2c72a$var$contentStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$5089616a215e9052$export$f21ab0717a89c77f, {}),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};
var $f2f805f49af46a8b$var$$9c7edcd33b2e220b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", ()=>$f2f805f49af46a8b$export$b27c6704e245f018);
const $f2f805f49af46a8b$export$b27c6704e245f018 = ({ children: children })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $f2f805f49af46a8b$var$$9c7edcd33b2e220b$var$containerStyles = (0, $dnfL5.css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});
var $f2f805f49af46a8b$var$$3ec1f71319ba0295$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", ()=>$f2f805f49af46a8b$export$8bee5cfdbbc2fc0c);
const $f2f805f49af46a8b$var$$3ec1f71319ba0295$var$loggedInContentStyles = (0, $dnfL5.css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $f2f805f49af46a8b$export$8bee5cfdbbc2fc0c = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$b27c6704e245f018, {
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: [
                $f2f805f49af46a8b$var$$3ec1f71319ba0295$var$loggedInContentStyles,
                $f2f805f49af46a8b$var$$3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $f2f805f49af46a8b$var$$3ec1f71319ba0295$var$baseContentStyles = (0, $dnfL5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", ()=>$f2f805f49af46a8b$export$be7f7dedc3a0e1ad);
const $f2f805f49af46a8b$var$$5f6e50d159d7e8e1$var$StarFilledIcon = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $f2f805f49af46a8b$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$5f6e50d159d7e8e1$var$StarFilledIcon;
const $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $dnfL5.css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $f2f805f49af46a8b$export$be7f7dedc3a0e1ad = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$b27c6704e245f018, {
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: [
                $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$var$primaryContentStyles,
                $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039, {})
                }),
                "PRIMARY"
            ]
        })
    });
const $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$var$baseContentStyles = (0, $dnfL5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $f2f805f49af46a8b$var$$01ef21c48d795edb$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$01ef21c48d795edb$exports, "UnifiedAccountTagLinked", ()=>$f2f805f49af46a8b$export$446c53c437a3d14a);
const $f2f805f49af46a8b$var$$01ef21c48d795edb$var$primaryContentStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $f2f805f49af46a8b$export$446c53c437a3d14a = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$b27c6704e245f018, {
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: [
                $f2f805f49af46a8b$var$$01ef21c48d795edb$var$primaryContentStyles,
                $f2f805f49af46a8b$var$$01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $f2f805f49af46a8b$var$$01ef21c48d795edb$var$baseContentStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $f2f805f49af46a8b$var$$80cd39a44f20f361$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$80cd39a44f20f361$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$80cd39a44f20f361$exports, "SharedFooter", ()=>$f2f805f49af46a8b$export$7a92b4adf6bd95bb);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$80cd39a44f20f361$exports, "default", ()=>$f2f805f49af46a8b$var$$80cd39a44f20f361$export$2e2bcd8739ae039);
var $f2f805f49af46a8b$var$$85d9a99cb49b730f$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $f2f805f49af46a8b$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $f2f805f49af46a8b$var$$85d9a99cb49b730f$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$85d9a99cb49b730f$require$Buffer.from($f2f805f49af46a8b$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWider).toString("base64")}`;
const $f2f805f49af46a8b$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $f2f805f49af46a8b$var$$85d9a99cb49b730f$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$85d9a99cb49b730f$require$Buffer.from($f2f805f49af46a8b$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWide).toString("base64")}`;
const $f2f805f49af46a8b$var$$85d9a99cb49b730f$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $f2f805f49af46a8b$var$$85d9a99cb49b730f$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$85d9a99cb49b730f$require$Buffer.from($f2f805f49af46a8b$var$$85d9a99cb49b730f$var$svgStringMobileFooter).toString("base64")}`;
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY = "@media (min-width: 768px) and (max-width: 1279px)";
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY = "@media (max-width: 767px)";
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY = "@media (min-width: 1280px)";
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$YEAR = new Date().getFullYear();
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$COPYRIGHT = `Copyright \xa9 ${$f2f805f49af46a8b$var$$80cd39a44f20f361$var$YEAR} Atlassian`;
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink = ({ href: href, onClick: onClick, text: text, styles: styles = [] })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        href: href,
        onClick: onClick,
        css: [
            $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
            ...styles
        ],
        children: text
    });
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$FORUMS_URL = $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$f2f805f49af46a8b$export$93d048dc21eb282a.FORUMS];
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? $f2f805f49af46a8b$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
        email: email,
        redirectUrl: url
    }) : url;
const $f2f805f49af46a8b$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback, isLoggedIn: isLoggedIn = false, showChampions: showChampions = false, showNewLearningLinks: showNewLearningLinks = false, email: email, licenseData: licenseData })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const openModal = (0, $acw62.useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $acw62.useCallback)(()=>setIsOpen(false), []);
    const ABOUT_LEARNING_URL = showNewLearningLinks ? "https://community.atlassian.com/learning/hub/resources-and-support/about-atlassian-learning" : "https://university.atlassian.com/student/activity/836764-about-us";
    const RESOURCES_LEARNING_URL = showNewLearningLinks ? "https://community.atlassian.com/learning/hub/resources-and-support" : "https://university.atlassian.com/student/activity/1938006-resources-and-support";
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$footerBackgroundStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$footerWrapperStyles,
            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$footerStyle,
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$innerDivStyle,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$logoContainerStyle,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$logoStyle,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $f53d1d0ce4a6d984$export$8a485e2e7ed91e8f), {})
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnsContainerStyle,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnStyle,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                            css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$headerStyle,
                                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                                href: "/",
                                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Community"
                                                })
                                            })
                                        })
                                    }),
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$headerStyle,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                                    href: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$getForumsUrl($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FORUMS_URL, isLoggedIn, email),
                                                    css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
                                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Forums"
                                                    })
                                                })
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$getForumsUrl(`${$f2f805f49af46a8b$var$$80cd39a44f20f361$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                                                text: "FAQs"
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$getForumsUrl(`${$f2f805f49af46a8b$var$$80cd39a44f20f361$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                                                text: "Forums guidelines"
                                            })
                                        ]
                                    }),
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$headerStyle,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                                    href: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$f2f805f49af46a8b$export$93d048dc21eb282a.LEARNING],
                                                    css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
                                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Learning"
                                                    })
                                                })
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: ABOUT_LEARNING_URL,
                                                text: "About learning"
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: RESOURCES_LEARNING_URL,
                                                text: "Resources"
                                            })
                                        ]
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnStyle,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                            css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$headerStyle,
                                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                                href: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$f2f805f49af46a8b$export$93d048dc21eb282a.EVENTS],
                                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Events"
                                                })
                                            })
                                        })
                                    }),
                                    showChampions && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnStyle,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                            css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$headerStyle,
                                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                                href: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$f2f805f49af46a8b$export$93d048dc21eb282a.CHAMPIONS],
                                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Champions"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomDivStyle,
                        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomContentStyle,
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$copyrightText,
                                    children: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$COPYRIGHT
                                }),
                                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinksContainerStyle,
                                    children: [
                                        reportAProblemCallback && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                            text: "Privacy Policy",
                                            styles: [
                                                $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            className: "atl-policy-link",
                                            css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle,
                                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                                css: $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle,
                                                className: "atl-policy-link-text",
                                                children: "Notice at Collection"
                                            })
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/community-platform-terms-of-use",
                                            text: "Terms",
                                            styles: [
                                                $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/trust/data-protection",
                                            text: "Security",
                                            styles: [
                                                $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        licenseData && (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                                            children: [
                                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$80cd39a44f20f361$var$FooterLink, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle
                                                    ]
                                                }),
                                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $9d66509194a07e3f$export$2e2bcd8739ae039), {
                                                    children: isOpen && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$bd0c6e28f5d6b66e, {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$footerBackgroundStyles = (0, $dnfL5.css)({
    width: "100%",
    backgroundImage: `url(${$f2f805f49af46a8b$var$$85d9a99cb49b730f$export$f3cfc44c4eba4576})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    boxSizing: "border-box",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        backgroundImage: `url(${$f2f805f49af46a8b$var$$85d9a99cb49b730f$export$7d22dc8c5b0cc81c})`
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        backgroundImage: `url(${$f2f805f49af46a8b$var$$85d9a99cb49b730f$export$eca0cf64e1927e60})`
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$footerWrapperStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY]: {
        maxWidth: "1234px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        maxWidth: "720px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$footerStyle = (0, $dnfL5.css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 16px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$linkStyle = (0, $dnfL5.css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        cursor: "pointer"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$innerDivStyle = (0, $dnfL5.css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$logoContainerStyle = (0, $dnfL5.css)({
    width: "420px",
    display: "flex",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$logoStyle = (0, $dnfL5.css)({
    svg: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnsContainerStyle = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        gap: "16px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$columnStyle = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$headerStyle = (0, $dnfL5.css)({
    marginBottom: "4px"
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomDivStyle = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 0px"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$copyrightText = (0, $dnfL5.css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle")
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomContentStyle = (0, $dnfL5.css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinkStyle = (0, $dnfL5.css)({
    display: "inline",
    marginLeft: "32px",
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0"
    }
});
const $f2f805f49af46a8b$var$$80cd39a44f20f361$var$bottomLinksContainerStyle = (0, $dnfL5.css)({
    [$f2f805f49af46a8b$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        // match columnStyle
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
var $f2f805f49af46a8b$var$$80cd39a44f20f361$export$2e2bcd8739ae039 = $f2f805f49af46a8b$export$7a92b4adf6bd95bb;
var $f2f805f49af46a8b$var$$fff41b96fcd62262$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fff41b96fcd62262$exports, "WelcomeModal", ()=>$f2f805f49af46a8b$export$9d12d42929c3fcf);
const $f2f805f49af46a8b$export$9d12d42929c3fcf = ({ onAccept: onAccept, onCancel: onCancel, coverImageSrc: coverImageSrc })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $7ea5684aaa353f60$export$2e2bcd8739ae039), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalContainerStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalImageContainerStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("h1", {
                            css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                            css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                            css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                    href: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                    href: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$buttonStyle = (0, $dnfL5.css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$coverImageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalContainerStyles = (0, $dnfL5.css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalImageContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    overflow: "hidden"
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalBodyStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $dnfL5.css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $f2f805f49af46a8b$var$$fff41b96fcd62262$var$modalButtonContainerStyles = (0, $dnfL5.css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$1ca64a7075ab6eae$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$60ab015507144a2b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$57b1d5df6b5425d4$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$4be7278e65b71184$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$db9d361cdef36cb6$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$e6da040d2ca2c72a$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$9c7edcd33b2e220b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$3ec1f71319ba0295$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$7cbc56ac0bc2e1de$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$fc6addd2061b87dd$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$01ef21c48d795edb$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$80cd39a44f20f361$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a6a41c835fd01d00$exports, $f2f805f49af46a8b$var$$fff41b96fcd62262$exports);
const $f2f805f49af46a8b$var$$2db63308c0b2527b$export$b56677d67e73c7be = ({ response: response, isLoading: isLoading })=>{
    const { message: message, isError: responseError } = response;
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$2db63308c0b2527b$var$inputStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
            name: "email",
            label: "Email address",
            defaultValue: "",
            children: ({ fieldProps: fieldProps, error: error, meta: meta })=>{
                const validationErrorMessage = meta.dirtySinceLastSubmit ? undefined : error;
                const displayMessage = validationErrorMessage || message;
                const displayType = error || responseError ? "error" : "valid";
                return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                    children: [
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$2db63308c0b2527b$var$inputButtonFlex,
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                    ...fieldProps,
                                    required: true,
                                    type: "email",
                                    autoComplete: "off",
                                    placeholder: "yourname@email.com"
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        as: "button",
                                        label: "Sign up",
                                        type: "submit",
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                        isLoading: isLoading
                                    })
                                })
                            ]
                        }),
                        displayMessage ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$9144c5f9beecc4b7, {
                            type: displayType,
                            message: displayMessage
                        }) : null
                    ]
                });
            }
        })
    });
};
const $f2f805f49af46a8b$var$$2db63308c0b2527b$var$inputStyles = (0, $dnfL5.css)({
    "& label": {
        fontWeight: 400
    }
});
const $f2f805f49af46a8b$var$$2db63308c0b2527b$var$inputButtonFlex = (0, $dnfL5.css)({
    display: "flex",
    alignContent: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd = ({ isMobile: isMobile })=>(0, $dnfL5.css)({
        minWidth: "fit-content",
        display: isMobile ? "none" : "block",
        marginTop: isMobile ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200") : 0,
        [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            minWidth: "100%",
            display: isMobile ? "block" : "none"
        }
    });
const $f2f805f49af46a8b$var$$d51a9a1c56c91a16$export$eefa3b352a86957 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $f2f805f49af46a8b$var$$d51a9a1c56c91a16$export$ecf6508459835aaf = "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the ";
const $f2f805f49af46a8b$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2 = ({ response: response, onSubmit: onSubmit, onPrivacyPolicyClick: onPrivacyPolicyClick })=>{
    const handleSubmit = async (data, form)=>{
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const errors = {
            email: !emailPattern.test(data.email) ? "Enter a valid email address." : undefined
        };
        if (!errors.email) {
            await onSubmit(data);
            form.reset();
        }
        return errors;
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $cda506121b783a25$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("form", {
                ...formProps,
                css: $f2f805f49af46a8b$var$$d51a9a1c56c91a16$var$formWrapperStyles,
                "data-testid": "signup-form",
                noValidate: true,
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$d51a9a1c56c91a16$var$formActionStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$2db63308c0b2527b$export$b56677d67e73c7be, {
                                response: response,
                                isLoading: submitting
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd({
                                    isMobile: true
                                }),
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    as: "button",
                                    label: "Sign up",
                                    type: "submit",
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                    isLoading: submitting,
                                    fullWidth: true
                                })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                        css: $f2f805f49af46a8b$var$$d51a9a1c56c91a16$var$acknowledgeStyle,
                        children: [
                            $f2f805f49af46a8b$var$$d51a9a1c56c91a16$export$ecf6508459835aaf,
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                href: $f2f805f49af46a8b$var$$d51a9a1c56c91a16$export$eefa3b352a86957,
                                target: "_blank",
                                onClick: onPrivacyPolicyClick,
                                rel: "noreferrer",
                                children: "Atlassian Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
    });
};
const $f2f805f49af46a8b$var$$d51a9a1c56c91a16$var$formWrapperStyles = (0, $dnfL5.css)({
    width: "100%",
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.800"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.800"),
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        padding: 0
    },
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
    },
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MEDIA_QUERY]: {
        marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")
    }
});
const $f2f805f49af46a8b$var$$d51a9a1c56c91a16$var$formActionStyles = (0, $dnfL5.css)({
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        flexDirection: "column",
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
    }
});
const $f2f805f49af46a8b$var$$d51a9a1c56c91a16$var$acknowledgeStyle = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    maxWidth: "405px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontWeight: "400",
    fontSize: "12px",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    "& a": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    },
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        maxWidth: "unset"
    }
});
const $f2f805f49af46a8b$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0 = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
        "data-testid": "open-letter",
        width: "124",
        height: "118",
        viewBox: "0 0 124 118",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("g", {
            id: "Spot/Basics/Letter open",
            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                id: "Vector",
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_2",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_3",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_4",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_5",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_6",
                        d: "M88.2168 41.562H36.7148V43.9475H88.2168V41.562Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_7",
                        d: "M88.2168 51.1689H36.7148V53.5544H88.2168V51.1689Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_8",
                        d: "M88.2168 60.7825H36.7148V63.1679H88.2168V60.7825Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_9",
                        d: "M88.2168 70.3901H36.7148V72.7756H88.2168V70.3901Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_10",
                        d: "M88.2168 80.0034H36.7148V82.3889H88.2168V80.0034Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_11",
                        d: "M88.2168 89.6106H36.7148V91.9961H88.2168V89.6106Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_12",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_13",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_14",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_15",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_16",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_17",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_18",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_19",
                        d: "M51.0637 80.5821L49.6444 80.767C49.6444 80.767 47.1873 80.5642 46.2033 80.9041L42.5059 80.7491C42.5059 80.7491 40.9613 80.8385 40.4961 81.0532C40.2039 81.1844 40.0191 81.3454 39.9773 81.4945C39.8938 81.7927 40.4127 82.0432 41.9036 81.9478C41.9215 81.9656 41.9811 81.9835 41.9871 82.0074C43.5615 81.7987 45.0762 82.1863 46.6804 82.1446C46.6626 82.0551 46.7162 81.9895 46.7639 82.0312L46.746 82.1386C47.8135 81.9239 48.4815 82.2817 49.4595 81.912C49.4595 81.912 49.3402 82.0551 49.3462 82.0551C52.6918 82.0014 57.2241 82.1744 60.85 82.0193L60.8321 82.0014V81.9835C60.5041 81.8702 58.8999 81.7032 58.8999 81.7032C60.1106 81.1784 61.4762 81.739 62.7584 81.7211L62.7465 81.8643C62.1919 81.8583 61.6969 81.9179 61.5001 81.9776C63.4919 82.1803 67.4876 82.234 69.3959 82.0253C69.3482 81.9179 68.7578 82.1505 68.6087 81.7987C69.0978 81.7987 69.5868 81.7509 70.046 81.7569C70.046 81.9835 69.7776 81.906 69.7239 81.9478C70.5171 82.1982 86.7322 82.5441 82.8618 81.5542L82.9632 81.4349C81.9613 81.3812 81.1324 81.3335 80.0947 81.1009C79.9456 81.1188 79.9277 81.1009 79.9277 81.2142C79.886 81.2321 79.8204 81.2679 79.8383 81.3156C79.8502 81.6019 79.5281 81.4886 79.385 81.4945C79.5639 80.6059 76.1527 81.3872 75.6995 81.3514C75.616 80.928 74.8109 81.3335 74.5366 81.1486C74.5545 81.1307 74.6797 81.0413 74.6916 81.0234C74.4471 80.7491 70.4217 81.4826 71.5727 80.9638C66.8196 80.0454 58.1962 81.0771 53.0615 80.272L53.0973 80.3256C53.0556 80.3078 52.9303 80.3316 52.9005 80.272C52.3936 80.439 51.0577 80.5582 51.0577 80.5582L51.0637 80.5821ZM62.8419 81.1486C62.8419 81.1486 62.8479 81.1248 62.8419 81.1188C62.8419 81.1606 63.5039 81.1367 63.5277 81.1486V81.2917C62.8538 81.5601 61.3212 80.588 62.7763 81.0174C62.824 80.9816 62.824 81.1009 62.8359 81.1486H62.8419ZM68.7101 81.1963C68.8234 81.2083 68.9487 81.2202 69.0858 81.2321C67.5651 81.6675 65.5136 81.1069 63.8438 81.3037C64.4163 80.6775 65.77 81.0174 66.4916 81.0592C67.2132 80.922 68.072 81.095 68.7101 81.1963ZM78.5143 81.3514V81.2798H78.574C78.574 81.2977 78.568 81.3216 78.5561 81.3335C78.5501 81.3454 78.5263 81.3633 78.5143 81.3573V81.3514ZM51.8688 80.922C51.9821 80.8087 52.4055 80.8743 52.1252 81.1009C52.0537 81.0651 51.8449 81.1665 51.8688 80.922ZM70.4276 81.3752C70.4276 81.1427 70.9882 81.1009 70.9882 81.417C70.7974 81.417 70.6125 81.3991 70.4276 81.3752ZM47.7121 81.1427C47.5631 81.3872 47.6048 81.1128 47.5571 80.9578C47.5929 80.9936 47.73 81.0055 47.7002 81.1188L47.7121 81.1427ZM45.1001 81.2739C45.0643 81.3931 44.9152 81.4707 44.8436 81.4766C44.6647 81.3812 45.0166 81.1665 45.1001 81.2739ZM40.8003 81.2739C40.7943 81.411 40.6929 81.4587 40.6631 81.3216C40.6751 81.2202 40.8003 81.1427 40.8182 81.2977C40.8182 81.2918 40.8182 81.2798 40.8003 81.2739ZM73.0039 81.8881C72.8489 82.2936 72.342 81.9597 72.0676 82.067C72.1332 81.6615 72.6223 81.9656 72.831 81.8941C72.9025 81.8941 72.9622 81.8941 73.0039 81.8881ZM56.0851 81.6973C56.0851 82.0551 55.5186 81.7688 55.3277 81.8464V81.7032C55.614 81.6675 55.7869 81.578 56.0732 81.6973H56.0851ZM67.7977 81.9776C67.6903 82.1207 67.5114 81.9835 67.3981 81.9835C67.3981 81.7808 67.8692 81.751 67.7977 81.9776ZM63.0447 81.8941C63.0208 81.6734 63.2534 81.7808 63.325 81.7629C63.2772 81.8106 63.1878 81.9478 63.1341 81.9418C63.0983 81.9418 63.0864 81.912 63.0447 81.8941ZM56.2938 81.5601C56.5145 81.5601 56.753 81.5601 56.9796 81.572V81.7152C56.7411 81.7152 56.5145 81.7092 56.2879 81.7032V81.5601H56.2938ZM58.5183 81.7927V81.9358C58.1962 82.067 58.1604 81.7032 58.5123 81.7927H58.5183ZM53.4193 81.7092C53.4551 81.7152 53.5028 81.7271 53.5386 81.7271C53.9978 81.7152 53.3478 82.228 53.4193 81.7092ZM51.01 81.8344C50.9623 81.8523 50.9027 81.8941 50.855 81.8941C50.533 81.8762 50.8908 81.5363 51.01 81.8344Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_20",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_21",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_22",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_23",
                        d: "M51.0637 44.3943L49.6444 44.5792C49.6444 44.5792 47.1873 44.3764 46.2033 44.7164L42.5059 44.5613C42.5059 44.5613 40.9613 44.6508 40.4961 44.8655C40.2039 45.0026 40.0191 45.1577 39.9773 45.3068C39.8938 45.605 40.4127 45.8554 41.9036 45.76C41.9215 45.7779 41.9811 45.7958 41.9871 45.8196C43.5615 45.6109 45.0762 45.9986 46.6804 45.9568C46.6626 45.8674 46.7162 45.8018 46.7639 45.8435L46.746 45.9508C47.8135 45.7362 48.4815 46.094 49.4595 45.7242C49.4595 45.7242 49.3402 45.8674 49.3462 45.8674C52.6918 45.8137 57.2241 45.9866 60.85 45.8316L60.8321 45.8137V45.7958C60.5041 45.6825 58.8999 45.5155 58.8999 45.5155C60.1106 44.9907 61.4762 45.5513 62.7584 45.5334L62.7465 45.6765C62.1919 45.6706 61.6969 45.7302 61.5001 45.7898C63.4919 45.9926 67.4876 46.0463 69.3959 45.8375C69.3482 45.7302 68.7578 45.9628 68.6087 45.6109C69.0978 45.6109 69.5868 45.5632 70.046 45.5692C70.046 45.7958 69.7776 45.7183 69.7239 45.76C70.5171 46.0105 86.7322 46.3564 82.8618 45.3664L82.9632 45.2471C81.9613 45.1935 81.1324 45.1458 80.0947 44.9132C79.9456 44.9311 79.9277 44.9132 79.9277 45.0265C79.886 45.0444 79.8204 45.0802 79.8383 45.1279C79.8502 45.4141 79.5281 45.3008 79.385 45.3068C79.5639 44.4182 76.1527 45.1994 75.6995 45.1636C75.616 44.7402 74.8109 45.1458 74.5366 44.9609C74.5545 44.943 74.6797 44.8535 74.6916 44.8356C74.4471 44.5613 70.4217 45.2948 71.5727 44.776C66.8196 43.8576 58.1962 44.8893 53.0615 44.0842L53.0973 44.1379C53.0556 44.12 52.9303 44.1439 52.9005 44.0842C52.3936 44.2512 51.0577 44.3705 51.0577 44.3705L51.0637 44.3943ZM62.8419 44.9549C62.8419 44.9549 62.8479 44.9311 62.8419 44.9251C62.8419 44.9668 63.5039 44.943 63.5277 44.9549V45.098C62.8538 45.3664 61.3212 44.4003 62.7763 44.8237C62.824 44.7879 62.824 44.9072 62.8359 44.9549H62.8419ZM68.7101 45.0026C68.8234 45.0146 68.9487 45.0265 69.0858 45.0384C67.5651 45.4738 65.5136 44.9132 63.8438 45.11C64.4163 44.4838 65.77 44.8237 66.4916 44.8655C67.2132 44.7283 68.072 44.9012 68.7101 45.0026ZM78.5143 45.1577V45.0861H78.574C78.574 45.104 78.568 45.1279 78.5561 45.1398C78.5501 45.1517 78.5263 45.1696 78.5143 45.1636V45.1577ZM51.8688 44.7283C51.9821 44.615 52.4055 44.6806 52.1252 44.9072C52.0537 44.8714 51.8449 44.9728 51.8688 44.7283ZM70.4276 45.1815C70.4276 44.949 70.9882 44.9012 70.9882 45.2233C70.7974 45.2233 70.6125 45.2054 70.4276 45.1815ZM47.7121 44.949C47.5631 45.1935 47.6048 44.9191 47.5571 44.7641C47.5929 44.7999 47.73 44.8118 47.7002 44.9251L47.7121 44.949ZM45.1001 45.0802C45.0643 45.1994 44.9152 45.277 44.8436 45.2829C44.6647 45.1875 45.0166 44.9728 45.1001 45.0802ZM40.8003 45.0802C40.7943 45.2173 40.6929 45.265 40.6631 45.1279C40.6751 45.0265 40.8003 44.949 40.8182 45.104C40.8182 45.098 40.8182 45.0861 40.8003 45.0802ZM73.0039 45.6944C72.8489 46.0999 72.342 45.766 72.0676 45.8733C72.1332 45.4678 72.6223 45.7719 72.831 45.7004C72.9025 45.7004 72.9622 45.7004 73.0039 45.6944ZM56.0851 45.5036C56.0851 45.8614 55.5186 45.5751 55.3277 45.6527V45.5095C55.614 45.4738 55.7869 45.3843 56.0732 45.5036H56.0851ZM67.7977 45.7839C67.6903 45.927 67.5114 45.7898 67.3981 45.7898C67.3981 45.5871 67.8692 45.5572 67.7977 45.7839ZM63.0447 45.7004C63.0208 45.4797 63.2534 45.5871 63.325 45.5692C63.2772 45.6169 63.1878 45.754 63.1341 45.7481C63.0983 45.7481 63.0864 45.7183 63.0447 45.7004ZM56.2938 45.3664C56.5145 45.3664 56.753 45.3664 56.9796 45.3783V45.5215C56.7411 45.5215 56.5145 45.5155 56.2879 45.5095V45.3664H56.2938ZM58.5183 45.599V45.7421C58.1962 45.8733 58.1604 45.5095 58.5123 45.599H58.5183ZM53.4193 45.5155C53.4551 45.5215 53.5028 45.5334 53.5386 45.5334C53.9978 45.5215 53.3478 46.0343 53.4193 45.5155ZM51.01 45.6407C50.9623 45.6586 50.9027 45.7004 50.855 45.6944C50.533 45.6765 50.8908 45.3366 51.01 45.6407Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_24",
                        d: "M51.0637 56.4532L49.6444 56.638C49.6444 56.638 47.1873 56.4353 46.2033 56.7752L42.5059 56.6202C42.5059 56.6202 40.9613 56.7096 40.4961 56.9243C40.2039 57.0615 40.0191 57.2165 39.9773 57.3656C39.8938 57.6638 40.4127 57.9143 41.9036 57.8188C41.9215 57.8367 41.9811 57.8546 41.9871 57.8785C43.5615 57.6698 45.0762 58.0574 46.6804 58.0156C46.6626 57.9262 46.7162 57.8606 46.7639 57.9023L46.746 58.0097C47.8135 57.795 48.4815 58.1528 49.4595 57.7831C49.4595 57.7831 49.3402 57.9262 49.3462 57.9262C52.6918 57.8725 57.2241 58.0455 60.85 57.8904L60.8321 57.8725V57.8546C60.5041 57.7413 58.8999 57.5743 58.8999 57.5743C60.1106 57.0495 61.4762 57.6101 62.7584 57.5922L62.7465 57.7354C62.1919 57.7294 61.6969 57.789 61.5001 57.8487C63.4919 58.0514 67.4876 58.1051 69.3959 57.8964C69.3482 57.789 68.7578 58.0216 68.6087 57.6698C69.0978 57.6698 69.5868 57.6221 70.046 57.628C70.046 57.8546 69.7776 57.7771 69.7239 57.8188C70.5171 58.0693 86.7322 58.4152 82.8618 57.4253L82.9632 57.306C81.9613 57.2523 81.1324 57.2046 80.0947 56.972C79.9456 56.9899 79.9277 56.972 79.9277 57.0853C79.886 57.1032 79.8204 57.139 79.8383 57.1867C79.8502 57.473 79.5281 57.3597 79.385 57.3656C79.5639 56.477 76.1527 57.2583 75.6995 57.2225C75.616 56.7991 74.8109 57.2046 74.5366 57.0197C74.5545 57.0018 74.6797 56.9124 74.6916 56.8945C74.4471 56.6202 70.4217 57.3537 71.5727 56.8349C66.8196 55.9165 58.1962 56.9482 53.0615 56.1431L53.0973 56.1967C53.0556 56.1789 52.9303 56.2027 52.9005 56.1431C52.3936 56.31 51.0577 56.4293 51.0577 56.4293L51.0637 56.4532ZM62.8419 57.0197C62.8419 57.0197 62.8479 56.9959 62.8419 56.9899C62.8419 57.0316 63.5039 57.0078 63.5277 57.0197V57.1629C62.8538 57.4312 61.3212 56.4591 62.7763 56.8885C62.824 56.8527 62.824 56.972 62.8359 57.0197H62.8419ZM68.7101 57.0674C68.8234 57.0794 68.9487 57.0913 69.0858 57.1032C67.5651 57.5386 65.5136 56.978 63.8438 57.1748C64.4163 56.5486 65.77 56.8885 66.4916 56.9303C67.2132 56.7931 68.072 56.9661 68.7101 57.0674ZM78.5143 57.2225V57.1509H78.574C78.574 57.1688 78.568 57.1927 78.5561 57.2046C78.5501 57.2225 78.5263 57.2344 78.5143 57.2285V57.2225ZM51.8688 56.7931C51.9821 56.6798 52.4055 56.7454 52.1252 56.972C52.0537 56.9362 51.8449 57.0376 51.8688 56.7931ZM70.4276 57.2463C70.4276 57.0138 70.9882 56.972 70.9882 57.2941C70.7974 57.2941 70.6125 57.2762 70.4276 57.2463ZM47.7121 57.0138C47.5631 57.2583 47.6048 56.9839 47.5571 56.8289C47.5929 56.8647 47.73 56.8766 47.7002 56.9899L47.7121 57.0138ZM45.1001 57.145C45.0643 57.2642 44.9152 57.3418 44.8436 57.3477C44.6647 57.2523 45.0166 57.0376 45.1001 57.145ZM40.8003 57.145C40.7943 57.2821 40.6929 57.3298 40.6631 57.1927C40.6751 57.0913 40.8003 57.0138 40.8182 57.1688C40.8182 57.1628 40.8182 57.1509 40.8003 57.145ZM73.0039 57.7592C72.8489 58.1647 72.342 57.8308 72.0676 57.9381C72.1332 57.5326 72.6223 57.8367 72.831 57.7652C72.9025 57.7652 72.9622 57.7652 73.0039 57.7592ZM56.0851 57.5684C56.0851 57.9262 55.5186 57.6399 55.3277 57.7175V57.5743C55.614 57.5386 55.7869 57.4491 56.0732 57.5684H56.0851ZM67.7977 57.8487C67.6903 57.9918 67.5114 57.8487 67.3981 57.8546C67.3981 57.6519 67.8692 57.622 67.7977 57.8487ZM63.0447 57.7652C63.0208 57.5445 63.2534 57.6519 63.325 57.634C63.2772 57.6817 63.1878 57.8189 63.1341 57.8129C63.0983 57.8129 63.0864 57.7831 63.0447 57.7652ZM56.2938 57.4312C56.5145 57.4312 56.753 57.4312 56.9796 57.4431V57.5863C56.7411 57.5863 56.5145 57.5803 56.2879 57.5743V57.4312H56.2938ZM58.5183 57.6638V57.8069C58.1962 57.9381 58.1604 57.5743 58.5123 57.6638H58.5183ZM53.4193 57.5803C53.4551 57.5863 53.5028 57.5982 53.5386 57.5982C53.9978 57.5863 53.3478 58.0991 53.4193 57.5803ZM51.01 57.7055C50.9623 57.7234 50.9027 57.7652 50.855 57.7592C50.533 57.7413 50.8908 57.4014 51.01 57.7055Z",
                        fill: "#101214"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                        id: "Vector_25",
                        d: "M51.0637 68.5174L49.6444 68.7022C49.6444 68.7022 47.1873 68.4995 46.2033 68.8394L42.5059 68.6844C42.5059 68.6844 40.9613 68.7738 40.4961 68.9885C40.2039 69.1257 40.0191 69.2807 39.9773 69.4298C39.8938 69.728 40.4127 69.9785 41.9036 69.8831C41.9215 69.9009 41.9811 69.9188 41.9871 69.9427C43.5615 69.734 45.0762 70.1216 46.6804 70.0799C46.6626 69.9904 46.7162 69.9248 46.7639 69.9665L46.746 70.0739C47.8135 69.8592 48.4815 70.217 49.4595 69.8473C49.4595 69.8473 49.3402 69.9904 49.3462 69.9904C52.6918 69.9367 57.2241 70.1097 60.85 69.9546L60.8321 69.9367V69.9188C60.5041 69.8055 58.8999 69.6385 58.8999 69.6385C60.1106 69.1137 61.4762 69.6743 62.7584 69.6564L62.7465 69.7996C62.1919 69.7936 61.6969 69.8532 61.5001 69.9129C63.4919 70.1156 67.4876 70.1693 69.3959 69.9606C69.3482 69.8532 68.7578 70.0858 68.6087 69.734C69.0978 69.734 69.5868 69.6863 70.046 69.6922C70.046 69.9188 69.7776 69.8413 69.7239 69.8831C70.5171 70.1335 86.7322 70.4794 82.8618 69.4895L82.9632 69.3702C81.9613 69.3165 81.1324 69.2688 80.0947 69.0362C79.9456 69.0541 79.9277 69.0362 79.9277 69.1495C79.886 69.1674 79.8204 69.2032 79.8383 69.2509C79.8502 69.5372 79.5281 69.4238 79.385 69.4298C79.5639 68.5412 76.1527 69.3225 75.6995 69.2867C75.616 68.8633 74.8109 69.2688 74.5366 69.0839C74.5545 69.066 74.6797 68.9766 74.6916 68.9587C74.4471 68.6844 70.4217 69.4179 71.5727 68.8991C66.8196 67.9807 58.1962 69.0124 53.0615 68.2073L53.0973 68.2609C53.0556 68.2431 52.9303 68.2669 52.9005 68.2073C52.3936 68.3743 51.0577 68.4935 51.0577 68.4935L51.0637 68.5174ZM62.8419 69.0839C62.8419 69.0839 62.8479 69.0601 62.8419 69.0541C62.8419 69.0959 63.5039 69.072 63.5277 69.0839V69.2271C62.8538 69.4954 61.3212 68.5233 62.7763 68.9527C62.824 68.9169 62.824 69.0362 62.8359 69.0839H62.8419ZM68.7101 69.1316C68.8234 69.1436 68.9487 69.1555 69.0858 69.1674C67.5651 69.6028 65.5136 69.0422 63.8438 69.239C64.4163 68.6128 65.77 68.9527 66.4916 68.9945C67.2132 68.8573 68.072 69.0302 68.7101 69.1316ZM78.5143 69.2867V69.2151H78.574C78.574 69.233 78.568 69.2569 78.5561 69.2688C78.5501 69.2807 78.5263 69.2986 78.5143 69.2927V69.2867ZM51.8688 68.8573C51.9821 68.744 52.4055 68.8096 52.1252 69.0362C52.0537 69.0004 51.8449 69.1018 51.8688 68.8573ZM70.4276 69.3105C70.4276 69.078 70.9882 69.0362 70.9882 69.3583C70.7974 69.3583 70.6125 69.3404 70.4276 69.3105ZM47.7121 69.078C47.5631 69.3225 47.6048 69.0481 47.5571 68.8931C47.5929 68.9289 47.73 68.9408 47.7002 69.0541L47.7121 69.078ZM45.1001 69.2092C45.0643 69.3284 44.9152 69.406 44.8436 69.4119C44.6647 69.3165 45.0166 69.1018 45.1001 69.2092ZM40.8003 69.2092C40.7943 69.3463 40.6929 69.394 40.6631 69.2569C40.6751 69.1555 40.8003 69.078 40.8182 69.233C40.8182 69.227 40.8182 69.2151 40.8003 69.2092ZM73.0039 69.8234C72.8489 70.2289 72.342 69.895 72.0676 70.0023C72.1332 69.5968 72.6223 69.9009 72.831 69.8294C72.9025 69.8294 72.9622 69.8294 73.0039 69.8234ZM56.0851 69.6326C56.0851 69.9904 55.5186 69.7041 55.3277 69.7817V69.6385C55.614 69.6028 55.7869 69.5133 56.0732 69.6326H56.0851ZM67.7977 69.9129C67.6903 70.056 67.5114 69.9129 67.3981 69.9188C67.3981 69.7161 67.8692 69.6863 67.7977 69.9129ZM63.0447 69.8294C63.0208 69.6087 63.2534 69.7161 63.325 69.6982C63.2772 69.7459 63.1878 69.883 63.1341 69.8771C63.0983 69.8771 63.0864 69.8473 63.0447 69.8294ZM56.2938 69.4954C56.5145 69.4954 56.753 69.4954 56.9796 69.5073V69.6505C56.7411 69.6505 56.5145 69.6445 56.2879 69.6385V69.4954H56.2938ZM58.5183 69.728V69.8711C58.1962 70.0023 58.1604 69.6385 58.5123 69.728H58.5183ZM53.4193 69.6445C53.4551 69.6505 53.5028 69.6624 53.5386 69.6624C53.9978 69.6505 53.3478 70.1633 53.4193 69.6445ZM51.01 69.7697C50.9623 69.7876 50.9027 69.8294 50.855 69.8234C50.533 69.8055 50.8908 69.4656 51.01 69.7697Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
const $f2f805f49af46a8b$export$5620dbefc1cb6f80 = "You\u2019re on the list! Thanks for signing up.";
const $f2f805f49af46a8b$export$3f27bc10068ef877 = "Something went wrong. Try again.";
const $f2f805f49af46a8b$export$21041608e6399292 = ({ environment: environment, formUrl: formUrl, atlassianId: atlassianId, anonymousId: anonymousId, eventHandlers: eventHandlers = {} })=>{
    const { handleNewsletterSignup: handleNewsletterSignup, error: error, success: success } = $f2f805f49af46a8b$export$ea96d97e8873ca7f({
        environment: environment,
        ...eventHandlers
    });
    const { onSubmit: onSubmit = ()=>null, onPrivacyPolicyClick: onPrivacyPolicyClick } = eventHandlers;
    const handleSubmit = async ({ email: email })=>{
        onSubmit();
        await handleNewsletterSignup({
            email: email,
            anonymousId: anonymousId,
            atlassianId: atlassianId
        }, formUrl);
    };
    const successMessage = success ? $f2f805f49af46a8b$export$5620dbefc1cb6f80 : undefined;
    const responseMessage = error ? $f2f805f49af46a8b$export$3f27bc10068ef877 : successMessage;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$1db60c687807de63$var$signUpWrapper,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$1db60c687807de63$var$stack,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0, {}),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("h2", {
                        css: $f2f805f49af46a8b$var$$1db60c687807de63$var$headingStyles,
                        children: [
                            "Sign up for the community ",
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                children: "newsletter"
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$1db60c687807de63$var$descriptionStyles,
                        children: "Get the latest resources, tips, and trends to help you grow."
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2, {
                response: {
                    message: responseMessage,
                    isError: Boolean(error)
                },
                onSubmit: handleSubmit,
                onPrivacyPolicyClick: onPrivacyPolicyClick
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$1db60c687807de63$var$signUpWrapper = (0, $dnfL5.css)({
    margin: "0 auto",
    maxWidth: "624px"
});
const $f2f805f49af46a8b$var$$1db60c687807de63$var$stack = (0, $dnfL5.css)({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$1db60c687807de63$var$headingStyles = (0, $dnfL5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    "& span": {
        display: "block",
        [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            display: "inline-block"
        }
    },
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "32px"
    },
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        width: "340px",
        fontSize: "32px"
    }
});
const $f2f805f49af46a8b$var$$1db60c687807de63$var$descriptionStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "32px",
    marginTop: 0,
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "20px"
    },
    [$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $f2f805f49af46a8b$var$$2f0c862779035c26$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$2f0c862779035c26$exports, "MarkdownWrapper", ()=>$f2f805f49af46a8b$export$e61786c4aee8d415);
const $f2f805f49af46a8b$export$e61786c4aee8d415 = ({ children: children, overrides: overrides })=>{
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) || typeof children !== "string" ? children : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $185ac4d2d2286c00$export$2e2bcd8739ae039), {
        css: $f2f805f49af46a8b$var$$2f0c862779035c26$var$defaultStyles,
        options: {
            overrides: overrides
        },
        children: children
    });
};
const $f2f805f49af46a8b$var$$2f0c862779035c26$var$defaultStyles = (0, $dnfL5.css)({
    "& > p:first-of-type": {
        margin: 0
    }
});
var $f2f805f49af46a8b$var$$6937e97bac512574$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$6937e97bac512574$exports, "TabbedAccordion", ()=>$f2f805f49af46a8b$export$187009fd9803261e);
const $f2f805f49af46a8b$var$$76fc9668239269ce$var$ResourceCard = ({ description: description, link: link, type: type })=>{
    const handleClick = ()=>{
        window.open(link.link, link.target);
    };
    const hasType = type && type.length > 0;
    const hasDescription = description && description.length > 0;
    const accessibilityLabel = `${link.label}; ${hasType ? `type: ${type}; ` : ""}${hasDescription ? description : ""}`;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$76fc9668239269ce$var$containerStyles,
        onClick: handleClick,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        tabIndex: 0,
        role: "button",
        "aria-label": accessibilityLabel,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$76fc9668239269ce$var$contentStyles,
                children: [
                    hasType && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                        label: type
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
                        ...link,
                        style: $f2f805f49af46a8b$export$2b77966d73aefa77.SEMIBOLD,
                        onClick: handleClick,
                        tabIndex: -1
                    }),
                    hasDescription && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$76fc9668239269ce$var$descriptionStyles,
                        children: description
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "arrow-right",
                    alt: "Arrow right",
                    size: $f2f805f49af46a8b$export$ff775019b5b6e7df.MEDIUM
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$76fc9668239269ce$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")}`,
    alignItems: "center",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface"),
    justifyContent: "space-between",
    "& a": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link")
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        transition: "box-shadow 0.3s ease-in-out"
    },
    "&:hover svg": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link"),
        transform: "translateX(2px)"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
    }
});
const $f2f805f49af46a8b$var$$76fc9668239269ce$var$contentStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    alignItems: "flex-start",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
    }
});
const $f2f805f49af46a8b$var$$76fc9668239269ce$var$descriptionStyles = (0, $dnfL5.css)({
    margin: 0,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Atlassian Sans",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        fontSize: "12px",
        lineHeight: "16px"
    }
});
var $f2f805f49af46a8b$var$$76fc9668239269ce$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$76fc9668239269ce$var$ResourceCard;
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$Expander = ({ title: title, description: description, resources: resources, color: color, expandedByDefault: expandedByDefault = false, onExpandToggle: onExpandToggle, iconType: iconType, expandedContent: expandedContent })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(expandedByDefault);
    const iconProps = isExpanded ? {
        type: "chevron-down",
        alt: "Chevron down"
    } : {
        type: "chevron-right",
        alt: "Chevron right"
    };
    const toggleExpanded = (0, $acw62.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        onExpandToggle?.();
    }, [
        isExpanded,
        onExpandToggle
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                toggleExpanded();
            }
        }
    }, [
        toggleExpanded
    ]);
    const accessibilityLabel = `${title}; ${typeof description === "string" ? description : ""}`;
    const hasResources = resources.length > 0;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles,
        role: "button",
        "aria-label": accessibilityLabel,
        "aria-expanded": isExpanded,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        children: [
            iconType && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$outerIconStyles,
                    (0, $dnfL5.css)({
                        opacity: isExpanded ? 1 : 0.6,
                        "& svg": {
                            color: color
                        }
                    })
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: iconType,
                    color: color,
                    size: $f2f805f49af46a8b$export$ff775019b5b6e7df.LARGE
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$expanderCardStyles,
                style: {
                    borderLeft: `8px solid ${color && isExpanded ? color : "transparent"}`
                },
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$containerStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            role: "button",
                            tabIndex: 0,
                            css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$expanderHeaderStyles,
                            onClick: toggleExpanded,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    toggleExpanded();
                                }
                            },
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                    ...iconProps,
                                    size: $f2f805f49af46a8b$export$ff775019b5b6e7df.LARGE
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                    level: 5,
                                    children: title
                                })
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$contentStyles,
                            children: [
                                typeof description === "string" ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                        children: description
                                    })
                                }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                    children: description
                                }),
                                isExpanded && expandedContent && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$expandedContentStyles,
                                    children: expandedContent
                                }),
                                isExpanded && hasResources && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$resourcesStyles,
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                                            fontWeight: "semibold",
                                            children: "Resources"
                                        }),
                                        resources.map((resource)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$76fc9668239269ce$export$2e2bcd8739ae039, {
                                                description: resource.description,
                                                link: resource.link,
                                                type: resource.type
                                            }, resource.link.link))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$expanderCardStyles = (0, $dnfL5.css)({
    display: "flex",
    flex: "auto",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    alignSelf: "stretch",
    alignItems: "stretch",
    borderRadius: "8px",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface"),
    boxShadow: "0 0 1px 0 rgba(9, 30, 66, 0.31), 0 1px 1px 0 rgba(9, 30, 66, 0.25)",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")}`
    }
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
    }
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$expanderHeaderStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    cursor: "pointer",
    userSelect: "none",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
    }
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$contentStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.600"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")
    }
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$resourcesStyles = (0, $dnfL5.css)({
    display: "flex",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    flexDirection: "column",
    alignItems: "stretch",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
    }
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$outerIconStyles = (0, $dnfL5.css)({
    "& svg": {
        width: "32px !important",
        height: "32px !important"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$descriptionStyles = (0, $dnfL5.css)({
    whiteSpace: "pre-wrap"
});
const $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$expandedContentStyles = (0, $dnfL5.css)({
    width: "100%"
});
var $f2f805f49af46a8b$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$f3815ecfa3837fcc$var$Expander;
const $f2f805f49af46a8b$var$$737c57f1a347e52a$var$TabContent = ({ tabExpanders: tabExpanders, color: color, iconType: iconType })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$737c57f1a347e52a$var$tabContentContainerStyles,
        children: tabExpanders.map((tabItem, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039, {
                title: tabItem.title,
                description: tabItem.description,
                resources: tabItem.resources,
                color: color,
                expandedByDefault: index === 0,
                iconType: iconType,
                expandedContent: tabItem.expandedContent
            }, tabItem.title))
    });
};
const $f2f805f49af46a8b$var$$737c57f1a347e52a$var$tabContentContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
    }
});
var $f2f805f49af46a8b$var$$737c57f1a347e52a$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$737c57f1a347e52a$var$TabContent;
const $f2f805f49af46a8b$export$187009fd9803261e = ({ tabs: tabs, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange })=>{
    const [selectedTabIndex, setSelectedTabIndex] = (0, $acw62.useState)(defaultSelectedIndex);
    const tabRefs = (0, $acw62.useRef)([]);
    const contentRef = (0, $acw62.useRef)(null);
    const handleSelectTab = (0, $acw62.useCallback)((index)=>{
        setSelectedTabIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        let newIndex = selectedTabIndex;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                newIndex = selectedTabIndex > 0 ? selectedTabIndex - 1 : tabs.length - 1;
                break;
            case "ArrowRight":
                event.preventDefault();
                newIndex = selectedTabIndex < tabs.length - 1 ? selectedTabIndex + 1 : 0;
                break;
            case "Home":
                event.preventDefault();
                newIndex = 0;
                break;
            case "End":
                event.preventDefault();
                newIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        if (newIndex !== selectedTabIndex) {
            contentRef.current?.focus?.();
            handleSelectTab(newIndex);
        }
    }, [
        selectedTabIndex,
        tabs.length,
        handleSelectTab
    ]);
    const selectedTabContent = (0, $acw62.useMemo)(()=>{
        const selected = tabs[selectedTabIndex];
        if (!selected) return null;
        return selected;
    }, [
        tabs,
        selectedTabIndex
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$6937e97bac512574$var$defaultContainerStyles,
            containerStyles
        ],
        "data-testid": "tabbed-accordion",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$6937e97bac512574$var$tabsHeaderStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$6937e97bac512574$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed accordion tabs",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    children: tabs.map((tab, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$6937e97bac512574$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedTabIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": tabs.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e41faf802a29e71, {
                                label: tab.label,
                                labelColor: tab.labelColor || (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: tab.labelColorSelected || (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelectedHover: tab.labelColorSelectedHover || (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                selectedColor: tab.color,
                                selectedHoverColor: tab.color,
                                size: $f2f805f49af46a8b$export$ddadc1228c8dcfa.SMALL,
                                selected: index === selectedTabIndex
                            })
                        }, tab.label))
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("hr", {
                css: $f2f805f49af46a8b$var$$6937e97bac512574$var$dividerStyles
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$6937e97bac512574$var$accordionContainerStyles,
                ref: contentRef,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedTabIndex}`,
                "aria-labelledby": `tab-${selectedTabIndex}`,
                "aria-label": `${tabs[selectedTabIndex]?.label} content`,
                children: selectedTabContent && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$737c57f1a347e52a$export$2e2bcd8739ae039, {
                    tabExpanders: selectedTabContent.tabExpanders,
                    color: selectedTabContent.color,
                    iconType: selectedTabContent.iconType
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$6937e97bac512574$var$defaultContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.600"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
    }
});
const $f2f805f49af46a8b$var$$6937e97bac512574$var$tabsHeaderStyles = (0, $dnfL5.css)({
    width: "100%"
});
const $f2f805f49af46a8b$var$$6937e97bac512574$var$tabsRowStyles = (0, $dnfL5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$6937e97bac512574$var$dividerStyles = (0, $dnfL5.css)({
    border: `0.5px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    width: "100%",
    margin: 0,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$6937e97bac512574$var$tabWrapperStyles = (0, $dnfL5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $f2f805f49af46a8b$var$$6937e97bac512574$var$accordionContainerStyles = (0, $dnfL5.css)({
    width: "100%"
});
var $f2f805f49af46a8b$var$$8aff256b69bb18bd$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$8aff256b69bb18bd$exports, "TabbedCards", ()=>$f2f805f49af46a8b$export$f0f045459b5b92);
const $f2f805f49af46a8b$export$f0f045459b5b92 = ({ cards: cards, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange, ctaText: ctaText = "Learn more" })=>{
    const safeDefaultSelectedIndex = Math.min(Math.max(0, defaultSelectedIndex), Math.max(0, cards.length - 1));
    const [selectedCardIndex, setSelectedCardIndex] = (0, $acw62.useState)(safeDefaultSelectedIndex);
    const tabRefs = (0, $acw62.useRef)([]);
    const handleSelectTab = (0, $acw62.useCallback)((index)=>{
        setSelectedCardIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const selectedCard = (0, $acw62.useMemo)(()=>{
        const selected = cards[selectedCardIndex];
        return selected ?? null;
    }, [
        cards,
        selectedCardIndex
    ]);
    if (!cards.length) return null;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$containerBaseStyles,
            containerStyles
        ],
        "data-testid": "tabbed-cards",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$tabsHeaderStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed cards tabs",
                    children: cards.map((card, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedCardIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": cards.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e41faf802a29e71, {
                                label: card.title,
                                labelColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
                                labelColorSelectedHover: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
                                selectedColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.discovery"),
                                selectedHoverColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.discovery"),
                                size: $f2f805f49af46a8b$export$ddadc1228c8dcfa.MEDIUM,
                                selected: index === selectedCardIndex
                            })
                        }, card.title))
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$panelContainerStyles,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedCardIndex}`,
                "aria-labelledby": `tab-${selectedCardIndex}`,
                "aria-label": `${cards[selectedCardIndex]?.title} content`,
                children: selectedCard && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$cardContainerStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$cardLeftStyles,
                            children: [
                                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$textBlockStyles,
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                            level: 3,
                                            children: selectedCard.title
                                        }),
                                        selectedCard.subtitle && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            size: "regular",
                                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                            children: selectedCard.subtitle
                                        })
                                    ]
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$ctaContainerStyles,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.LINK,
                                        label: ctaText,
                                        href: selectedCard.href,
                                        target: selectedCard.target,
                                        iconAfter: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "arrow-right",
                                            alt: "Arrow right",
                                            size: $f2f805f49af46a8b$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                })
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$imageWellStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                src: selectedCard.img.src,
                                alt: selectedCard.img.alt,
                                width: selectedCard.img.width,
                                height: selectedCard.img.height,
                                css: $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$cardImageStyles,
                                loading: selectedCard.img.loading,
                                decoding: selectedCard.img.decoding
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$containerBaseStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.600"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$tabsHeaderStyles = (0, $dnfL5.css)({
    width: "100%"
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$tabsRowStyles = (0, $dnfL5.css)({
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    overflowX: "auto",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        flexWrap: "wrap",
        justifyContent: "flex-start"
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$tabWrapperStyles = (0, $dnfL5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab-selected"]:active': {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.discovery")
    },
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$panelContainerStyles = (0, $dnfL5.css)({
    width: "100%"
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$cardContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface"),
    borderRadius: "8px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "266px",
    gap: "80px",
    paddingLeft: "62px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$cardLeftStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    flex: "1 1 auto",
    minWidth: 0,
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        padding: 0
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$textBlockStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    minWidth: 0
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$ctaContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    // Align button label with heading/subtitle by removing left padding.
    '& [data-testid="button-link"]': {
        paddingLeft: 0
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$imageWellStyles = (0, $dnfL5.css)({
    width: "416px",
    height: "266px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        width: "100%",
        height: "200px",
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px"
    }
});
const $f2f805f49af46a8b$var$$8aff256b69bb18bd$var$cardImageStyles = (0, $dnfL5.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
});
var $f2f805f49af46a8b$var$$271716b3dbf43c41$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$271716b3dbf43c41$exports, "MeatballMenu", ()=>$f2f805f49af46a8b$export$ef4a0fdddd7eccb7);
const $f2f805f49af46a8b$export$ef4a0fdddd7eccb7 = ({ items: items, placement: placement = "bottom-end", testId: testId = "meatball-menu", ariaLabel: ariaLabel = "More options", isInverted: isInverted = false })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$271716b3dbf43c41$var$menuContainerStyles,
        "data-testid": testId,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1263a8525c372af9$export$2e2bcd8739ae039), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                    ...props,
                    ref: triggerRef,
                    css: [
                        $f2f805f49af46a8b$var$$271716b3dbf43c41$var$triggerButtonStyles,
                        isInverted && $f2f805f49af46a8b$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles
                    ],
                    "aria-label": ariaLabel,
                    "data-testid": `${testId}-trigger`,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "more-vertical",
                        rotation: $f2f805f49af46a8b$export$b3241a99d3e47e02.NINETY,
                        alt: ariaLabel,
                        color: isInverted ? "#FFFFFF" : undefined
                    })
                }),
            placement: placement,
            children: items.map((item, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $b946ff9b63436f4b$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    testId: item.testId || `${testId}-item-${index}`,
                    children: item.label
                }, `${item.label}-${index}`))
        })
    });
};
const $f2f805f49af46a8b$var$$271716b3dbf43c41$var$menuContainerStyles = (0, $dnfL5.css)({
    display: "inline-flex",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$271716b3dbf43c41$var$triggerButtonStyles = (0, $dnfL5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.hovered")
    },
    "&:active": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.pressed")
    },
    "&:focus": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")}`,
        outlineOffset: "2px"
    }
});
const $f2f805f49af46a8b$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles = (0, $dnfL5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    }
});
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$660bd1c6cb41002a$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$fec02fc26c7e145d$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$d501466973a9f0a6$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$c4979bfceee73878$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$0903e93de01b205a$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$a950778dc3003c4a$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$582583ec420fce57$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$a02a6f7de308273b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$1298c86a7e6a9fc7$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$c0c01354ab9765ae$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$4fce8dfc4ce8f546$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$800df40a54823a3f$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$25cbe9fdb2d8d071$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$9efbb38deb40219f$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$3fbcb32390ca7008$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$731a4fd527bab680$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$5cf70e33bfc6ce73$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$8b54d37779d052e8$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$9cfa05d02afa3952$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$7d458ed59bb9c6a8$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$a467abe0c2c1750b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$52124b9ae1d78e04$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$77696804880d7cdc$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$4366d2b05f9f8f6b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$be203e745bcefb12$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$a0eced43682c2d75$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$1db60c687807de63$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$2f0c862779035c26$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$6937e97bac512574$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$8aff256b69bb18bd$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$5d4509b60606b6df$exports, $f2f805f49af46a8b$var$$271716b3dbf43c41$exports);
var $f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports = {};
var $f2f805f49af46a8b$var$$83fc18f8199a12ff$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$83fc18f8199a12ff$exports, "AudioPlayer", ()=>$f2f805f49af46a8b$export$832cc5475f11d8b4);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $f2f805f49af46a8b$export$832cc5475f11d8b4 = ({ source: source, isOpened: isOpened, onClose: onClose, onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError })=>{
    const audioRef = (0, $acw62.useRef)(null);
    const focusRef = (0, $acw62.useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvent = (0, $acw62.useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, [
        onControlClick,
        onProgressUpdate
    ]);
    const addEvents = (0, $acw62.useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        addEvent,
        onError
    ]);
    (0, $acw62.useEffect)(()=>{
        const player = new (0, (/*@__PURE__*/$parcel$interopDefault($52477d57b9d8c8b9$exports)))(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": "Audio player",
        ref: focusRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        css: $f2f805f49af46a8b$var$$83fc18f8199a12ff$var$audioPlayerStyles,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("figure", {
            "data-testid": "audio-player",
            css: $f2f805f49af46a8b$var$$83fc18f8199a12ff$var$figureStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("audio", {
                    ref: audioRef
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $f2f805f49af46a8b$var$$83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "cross",
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$83fc18f8199a12ff$var$audioPlayerStyles = (0, $dnfL5.css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $2b750d3a8789dea3$export$e62e8919cca44969),
        "--plyr-audio-control-color": (0, $2b750d3a8789dea3$export$29a4f05edc054374),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $2b750d3a8789dea3$export$c2e91cbeada39b8b),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $2b750d3a8789dea3$export$c39c0fe0f26207ae),
        "--plyr-tooltip-color": (0, $2b750d3a8789dea3$export$29a4f05edc054374),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $2b750d3a8789dea3$export$e62e8919cca44969)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$83fc18f8199a12ff$var$figureStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $f2f805f49af46a8b$var$$83fc18f8199a12ff$var$closeIconStyles = (0, $dnfL5.css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});
var $f2f805f49af46a8b$var$$438c82700c218044$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$438c82700c218044$exports, "ArticleJumpLinks", ()=>$f2f805f49af46a8b$export$e11be3ad528d3c05);
const $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f = (0, $dnfL5.css)({
    display: "flex",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    // desktop
    "@media (min-width: 1000px)": {
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`,
        maxWidth: "290px"
    }
});
const $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$2dc6a66a41038997 = (0, $dnfL5.css)({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    position: "relative",
    "&:hover": {
        borderRadius: "4px",
        backgroundColor: "rgba(220, 223, 228, 0.50)"
    },
    "& a": {
        // limit to 2 lines
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        wordBreak: "break-word",
        overflow: "hidden",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
        textOverflow: "ellipsis",
        textDecoration: "none",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px"
    }
});
const $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce = (0, $dnfL5.css)({
    // desktop
    "@media (min-width: 1000px)": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest"),
        borderRadius: "4px",
        "& a": {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
        },
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        },
        ":before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "16px",
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
            position: "absolute",
            left: "0",
            top: "50%",
            transform: "translateY(-50%)"
        }
    }
});
const $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$405b853093cc10c7 = (0, $dnfL5.css)({
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    "& h6": {
        textOverflow: "ellipsis",
        fontSize: "16px !important",
        lineHeight: "24px !important"
    },
    // desktop
    "@media (min-width: 1000px)": {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$438c82700c218044$var$DEFAULT_TITLE = "On this page";
const $f2f805f49af46a8b$export$e11be3ad528d3c05 = ({ links: links, className: className, style: style, onClick: onClick, title: title = $f2f805f49af46a8b$var$$438c82700c218044$var$DEFAULT_TITLE, activeHref: activeHref })=>{
    const [internalActiveLink, setInternalActiveLink] = (0, $acw62.useState)(null);
    const handleScroll = (0, $acw62.useCallback)(()=>{
        internalActiveLink && setInternalActiveLink(null);
    }, [
        internalActiveLink
    ]);
    const handleClick = (0, $acw62.useCallback)((link)=>{
        requestAnimationFrame(()=>{
            setInternalActiveLink(link);
        });
        onClick?.(link);
    }, [
        onClick,
        setInternalActiveLink
    ]);
    (0, $acw62.useEffect)(()=>{
        // Only add scroll listener if activeHref is not provided (internal state mode)
        if (!activeHref) {
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        handleScroll,
        activeHref
    ]);
    const linksWithHref = (0, $acw62.useMemo)(()=>{
        return links.map((link)=>{
            const linkHref = link.href ? link.href : $f2f805f49af46a8b$export$1bdcd43c8c2377cf(link.label);
            // Use activeHref prop if provided, otherwise fall back to internal state
            const isActive = activeHref ? linkHref === activeHref : internalActiveLink?.label === link.label;
            const onLinkClick = ()=>handleClick?.(link);
            return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                css: [
                    $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa,
                    isActive && $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                    href: linkHref,
                    onClick: onLinkClick,
                    children: link.label
                })
            }, linkHref);
        });
    }, [
        links,
        internalActiveLink,
        activeHref,
        handleClick
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$405b853093cc10c7,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                    level: 6,
                    children: title
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                css: $f2f805f49af46a8b$var$$7af640a6c4cb35c7$export$2dc6a66a41038997,
                className: className,
                style: style,
                children: linksWithHref
            })
        ]
    });
};
var $f2f805f49af46a8b$var$$389dbaf1c04dd698$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$389dbaf1c04dd698$exports, "BadgeCard", ()=>$f2f805f49af46a8b$export$22da447a4012011);
const $f2f805f49af46a8b$export$22da447a4012011 = ({ image: image, badgeTitle: badgeTitle, earnedDate: earnedDate, link: link, onClick: onClick })=>{
    const clickHandler = (0, $acw62.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(clickHandler);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        css: $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e431a229df88919, {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                        css: $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$containerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    border: `0 solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$contentContainerStyles = (0, $dnfL5.css)({
    marginLeft: "16px"
});
const $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$badgeTitleStyles = (0, $dnfL5.css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $f2f805f49af46a8b$var$$389dbaf1c04dd698$var$earnedDateStyles = (0, $dnfL5.css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});
var $f2f805f49af46a8b$var$$c18917e553fd2737$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$c18917e553fd2737$exports, "CertificateCard", ()=>$f2f805f49af46a8b$export$c572aa3e2aa38d2);
const $f2f805f49af46a8b$export$c572aa3e2aa38d2 = ({ image: image, backgroundColor: backgroundColor, title: title, link: link, onClick: onClick })=>{
    const clickHandler = (0, $acw62.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(clickHandler);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $f2f805f49af46a8b$var$$c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$c18917e553fd2737$var$cardHeaderStyles,
                    (0, $dnfL5.css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$c18917e553fd2737$var$imageContainerStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e431a229df88919, {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$c18917e553fd2737$var$containerStyles = (0, $dnfL5.css)({
    maxWidth: "280px",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $f2f805f49af46a8b$var$$c18917e553fd2737$var$cardHeaderStyles = (0, $dnfL5.css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $f2f805f49af46a8b$var$$c18917e553fd2737$var$imageContainerStyles = (0, $dnfL5.css)({
    height: "112px",
    width: "112px"
});
const $f2f805f49af46a8b$var$$c18917e553fd2737$var$cardTitleStyles = (0, $dnfL5.css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});
var $f2f805f49af46a8b$var$$3ca3d702a74367ba$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3ca3d702a74367ba$exports, "ContentOverviewCardState", ()=>$f2f805f49af46a8b$export$84c408eab3fc01b3);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3ca3d702a74367ba$exports, "ContentOverviewCard", ()=>$f2f805f49af46a8b$export$cb86f63bb5e77777);
var $f2f805f49af46a8b$var$$ed20910b93d89c3f$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$ed20910b93d89c3f$exports, "ContentType", ()=>$f2f805f49af46a8b$export$e2e108cbe2e4f865);
let $f2f805f49af46a8b$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($f2f805f49af46a8b$export$e2e108cbe2e4f865 || ($f2f805f49af46a8b$export$e2e108cbe2e4f865 = {}));
let $f2f805f49af46a8b$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($f2f805f49af46a8b$export$84c408eab3fc01b3 || ($f2f805f49af46a8b$export$84c408eab3fc01b3 = {}));
const $f2f805f49af46a8b$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode, state: state = $f2f805f49af46a8b$export$84c408eab3fc01b3.DEFAULT, heading: heading, subheading: subheading, tags: tags = [], collapsedSectionItems: itemsSectionCollapsed = [], collapsedSectionContent: infoSectionCollapsed = "", collapsedSectionTitle: titleSectionCollapsed, contentType: contentType, onClickButton: onClickButton, href: href })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const handleClickButton = (0, $acw62.useCallback)((event)=>{
        if (onClickButton) {
            event?.preventDefault();
            onClickButton();
        }
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $acw62.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("article", {
        "aria-label": heading,
        css: [
            $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$articleContainerStyles,
            state === $f2f805f49af46a8b$export$84c408eab3fc01b3.FINISHED && (0, $dnfL5.css)({
                borderLeftColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success")
            })
        ],
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$containerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                type: "chevron-down"
                            })
                        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                type: "chevron-right"
                            })
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$tagStyles,
                                                children: /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$titleContainerStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                        ...$f2f805f49af46a8b$export$1784ac302bd8ebad("description", inspectMode),
                                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $f2f805f49af46a8b$export$84c408eab3fc01b3.LOADING && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $f2f805f49af46a8b$export$84c408eab3fc01b3.DEFAULT && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "Get started",
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $f2f805f49af46a8b$export$84c408eab3fc01b3.IN_PROGRESS && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "Continue",
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $f2f805f49af46a8b$export$84c408eab3fc01b3.FINISHED && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: (0, $dnfL5.css)({
                                                    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
                                                }),
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
                                                    link: href || "#",
                                                    label: `Review ${$f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: (event)=>handleClickButton(event),
                                                    target: "_blank"
                                                })
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                type: "check-circle",
                                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "section-expanded",
                css: [
                    $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $dnfL5.css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionContentStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2e0a83ec2e27ecbb, {
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"),
                            height: 1
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        ...$f2f805f49af46a8b$export$1784ac302bd8ebad("sectionList", inspectMode),
                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionTitleStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                                css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                                        css: $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$articleContainerStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `8px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$containerStyles = (0, $dnfL5.css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$buttonStyles = (0, $dnfL5.css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $dnfL5.css)({
    marginRight: "16px"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$gridContainerStyles = (0, $dnfL5.css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$gridItemStyles = (0, $dnfL5.css)({
    gridColumn: "span 12",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 9",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$tagContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexWrap: "wrap"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$tagStyles = (0, $dnfL5.css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$titleContainerStyles = (0, $dnfL5.css)({
    margin: "16px auto",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        marginRight: "1px"
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$descriptionStyles = (0, $dnfL5.css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$gridSideItemStyles = (0, $dnfL5.css)({
    gridColumn: "span 12",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    marginRight: "4px"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionExpandedStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionContentStyles = (0, $dnfL5.css)({
    margin: "8px 0"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionListStyles = (0, $dnfL5.css)({
    padding: "24px 0"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$sectionTitleStyles = (0, $dnfL5.css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$listStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    fontFamily: "Inter, sans-serif",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $f2f805f49af46a8b$var$$3ca3d702a74367ba$var$itemStyles = (0, $dnfL5.css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});
var $f2f805f49af46a8b$var$$e018ab7ed2648ae8$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$e018ab7ed2648ae8$exports, "EmptyState", ()=>$f2f805f49af46a8b$export$fddf379e22a74b00);
const $f2f805f49af46a8b$export$fddf379e22a74b00 = ({ image: image, description: description, redirectLink: redirectLink })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$imageContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e431a229df88919, {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$descriptionStyles,
                        tabIndex: 0,
                        children: description
                    }),
                    redirectLink && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: $f2f805f49af46a8b$export$2b77966d73aefa77.SEMIBOLD,
                        fontColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link"),
                        css: (0, $dnfL5.css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$containerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $2b750d3a8789dea3$export$5f71e19f3a7ad9de),
    borderRadius: "4px",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$imageContainerStyles = (0, $dnfL5.css)({
    width: "64px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        width: "96px"
    }
});
const $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $dnfL5.css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $f2f805f49af46a8b$var$$e018ab7ed2648ae8$var$descriptionStyles = (0, $dnfL5.css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});
var $f2f805f49af46a8b$var$$81dd635d83decaee$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", ()=>$f2f805f49af46a8b$export$f9292ef28b7b429a);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$81dd635d83decaee$exports, "InlineFeedbackMessage", ()=>$f2f805f49af46a8b$export$f23c56ac9ab316f);
let $f2f805f49af46a8b$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($f2f805f49af46a8b$export$f9292ef28b7b429a || ($f2f805f49af46a8b$export$f9292ef28b7b429a = {}));
const $f2f805f49af46a8b$export$f23c56ac9ab316f = ({ title: title, description: description, appearance: appearance = $f2f805f49af46a8b$export$f9292ef28b7b429a.CORRECT })=>{
    const isIncorrectAppearance = appearance === $f2f805f49af46a8b$export$f9292ef28b7b429a.INCORRECT;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $dnfL5.css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success")}`
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "error",
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.danger")
                    }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "check-circle",
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success")
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                css: $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                css: $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input")
});
const $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $dnfL5.css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageContentStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        marginLeft: "8px"
    }
});
const $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    margin: 0,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px"
    }
});
const $f2f805f49af46a8b$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $dnfL5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $f2f805f49af46a8b$var$$8d99d7c025746ac9$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$8d99d7c025746ac9$exports, "LearningContentCard", ()=>$f2f805f49af46a8b$export$c01be50dd5c433fe);
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title, description: description, isLearningProgress: isLearningProgress, inspectMode: inspectMode, disableDescriptionClamp: disableDescriptionClamp })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "card-content",
        css: $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("h4", {
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                css: $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("h5", {
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                css: $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                "data-testid": "description",
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("description", inspectMode),
                css: [
                    $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$descriptionStyles,
                    disableDescriptionClamp && $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$descriptionNoClampStyles
                ],
                children: description
            })
        ]
    });
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`,
    marginBottom: "-2px"
});
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$baseTitleStyles = (0, $dnfL5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $dnfL5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    height: "64px"
});
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$withProgressTitleStyles = (0, $dnfL5.css)([
    $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$catalogTitleStyles = (0, $dnfL5.css)([
    $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} !important`
    }
]);
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$descriptionStyles = (0, $dnfL5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle")
});
const $f2f805f49af46a8b$var$$94fa590b0c9d9421$var$descriptionNoClampStyles = (0, $dnfL5.css)({
    display: "block",
    WebkitLineClamp: "none",
    overflow: "visible"
});
const $f2f805f49af46a8b$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl, backgroundColor: backgroundColor, productIcon: productIcon, isLearningProgress: isLearningProgress, imageHeight: imageHeight })=>{
    let height = isLearningProgress ? "96px" : "80px";
    if (imageHeight) height = `${imageHeight}px`;
    const backgroundSize = imageHeight ? "contain" : "cover";
    const backgroundPosition = imageHeight ? "center" : undefined; // if imageHeight is provided, the image will be displayed at the center of the container
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            $f2f805f49af46a8b$var$$f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $f2f805f49af46a8b$var$$f73a4551a9d8a3b1$var$noImageStyles,
            (0, $dnfL5.css)({
                backgroundColor: backgroundColor,
                height: height,
                backgroundSize: backgroundSize,
                ...backgroundPosition && {
                    backgroundPosition: backgroundPosition
                }
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
            css: (0, $dnfL5.css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
};
const $f2f805f49af46a8b$var$$f73a4551a9d8a3b1$var$imageBaseStyles = (0, $dnfL5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$f73a4551a9d8a3b1$var$noImageStyles = (0, $dnfL5.css)({
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $f2f805f49af46a8b$var$$70542fe329d53412$export$ce572121d239fe86 = 4;
const $f2f805f49af46a8b$var$$70542fe329d53412$export$3b38c99bd0870716 = 290;
const $f2f805f49af46a8b$var$$70542fe329d53412$export$bb4069a5b1582edc = 24;
const $f2f805f49af46a8b$var$$70542fe329d53412$export$9c6eb1f46b993412 = 3;
const $f2f805f49af46a8b$var$$fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags, lastLabelWidth: lastLabelWidth })=>tags.length > 0 && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, $f2f805f49af46a8b$var$$70542fe329d53412$export$9c6eb1f46b993412).map((tag, index, arr)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: index === arr.length - 1 && (0, $dnfL5.css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $f2f805f49af46a8b$var$$fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                    ...tag
                })
            }, tag.label + index))
    });
const $f2f805f49af46a8b$var$$fb345954107134f9$var$labelContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$f2f805f49af46a8b$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$f2f805f49af46a8b$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $f2f805f49af46a8b$var$$fb345954107134f9$var$truncatedLabelStyles = (0, $dnfL5.css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});
var $f2f805f49af46a8b$var$$d8ee29df49af8811$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$d8ee29df49af8811$exports, "LearningProgressBar", ()=>$f2f805f49af46a8b$export$184a993f673fc83f);
const $f2f805f49af46a8b$export$184a993f673fc83f = ({ wasPreviouslyCompleted: wasPreviouslyCompleted = false, completedResources: completedResources, resourceCount: resourceCount, completionDate: completionDate, contentType: contentType })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round($f2f805f49af46a8b$export$6e67b290ed5690f6(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount || wasPreviouslyCompleted) return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "gap-completed"
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                css: [
                    $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressTitleStyles,
                    (0, $dnfL5.css)({
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1a77571422b9634a$export$5ab97151efedb8c6), {
                    strokeWidth: 10,
                    value: $f2f805f49af46a8b$export$6e67b290ed5690f6(completedResources, resourceCount),
                    styles: (0, $1a77571422b9634a$export$5115a192ad9bf57f)({
                        pathColor: completedResources === 0 ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.success")
                    })
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                css: $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressBarContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressBarStyles = (0, $dnfL5.css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $f2f805f49af46a8b$var$$d8ee29df49af8811$var$progressTitleStyles = (0, $dnfL5.css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle")
});
let $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061;
(function(LearningProgressStatus) {
    LearningProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    LearningProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LearningProgressStatus["COMPLETED"] = "COMPLETED";
})($f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061 || ($f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061 = {}));
let $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["COMPLETED"] = "completed";
    CardStatus["DEFAULT"] = "default";
})($f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8 || ($f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8 = {}));
const $f2f805f49af46a8b$var$$035f8a623e403361$export$780035d9fe48eb32 = 420;
var $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$ec9b8ebbd21bd316$exports, "ShowMore", ()=>$f2f805f49af46a8b$export$ca7697601dcd7803);
const $f2f805f49af46a8b$export$ca7697601dcd7803 = ({ cardRef: cardRef, shareOnPdf: shareOnPdf, onGeneratePdf: onGeneratePdf, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, alignToRight: alignToRight })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleOnViewUpdates = (event)=>{
        if (onViewUpdates) {
            event.stopPropagation();
            event.preventDefault();
            onViewUpdates();
            setIsOpen(!isOpen);
        }
    };
    const handleGeneratePdf = (0, $acw62.useCallback)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }, [
        onGeneratePdf
    ]);
    const handleViewUpdates = (0, $acw62.useCallback)(()=>{
        if (onViewUpdates) onViewUpdates();
    }, [
        onViewUpdates
    ]);
    const onKeyDownGeneratePdf = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleGeneratePdf);
    const onKeyDownViewUpdates = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleViewUpdates);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: (0, $dnfL5.css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "show-more",
        ref: dropdownRef,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                label: "",
                appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "more-vertical"
                }),
                iconType: "more-vertical"
            }),
            isOpen && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "show-more-dropdown",
                css: [
                    $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles,
                    alignToRight && (0, $dnfL5.css)({
                        right: "unset",
                        textAlign: "left"
                    })
                ],
                children: [
                    shareOnPdf && onGeneratePdf && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "Export to PDF"
                        })
                    }),
                    areHistoricalNotifications && onViewUpdates && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnViewUpdates,
                        onKeyDown: onKeyDownViewUpdates,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "View updates"
                        })
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles = (0, $dnfL5.css)({
    position: "absolute",
    right: 0,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "7px 0",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    zIndex: 2,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$optionStyles = (0, $dnfL5.css)({
    width: "220px",
    padding: "7px 24px",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    ":hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$var$optionTextStyles = (0, $dnfL5.css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});
const $f2f805f49af46a8b$export$c01be50dd5c433fe = ({ inspectMode: inspectMode, title: title, description: description, onClick: onClick, target: target, link: link, tags: tags, disableDescriptionClamp: disableDescriptionClamp, minHeight: minHeight = 248, isLoading: isLoading = false, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, productIcon: productIcon, imageUrl: imageUrl, imageHeight: imageHeight, backgroundColor: backgroundColor })=>{
    const cardRef = (0, $acw62.useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $acw62.useState)("auto");
    const clickHandler = (0, $acw62.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(clickHandler);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const handleUpdatedButtonClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    (0, $acw62.useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || $f2f805f49af46a8b$var$$70542fe329d53412$export$3b38c99bd0870716) - $f2f805f49af46a8b$var$$70542fe329d53412$export$bb4069a5b1582edc * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, $f2f805f49af46a8b$var$$70542fe329d53412$export$9c6eb1f46b993412).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + $f2f805f49af46a8b$var$$70542fe329d53412$export$ce572121d239fe86;
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ($f2f805f49af46a8b$var$$70542fe329d53412$export$ce572121d239fe86 * tagsContainer.children.length - 1) + $f2f805f49af46a8b$var$$70542fe329d53412$export$bb4069a5b1582edc * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ if (isLoading) return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$imageBaseStyles,
                    $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$labelContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$smallPillStyles
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $dnfL5.css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: (0, $dnfL5.css)({
                                marginTop: "12px"
                            }),
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $dnfL5.css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            ref: cardRef,
            role: "link",
            css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a, {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress,
                    imageHeight: imageHeight
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: [
                        $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$fb345954107134f9$export$331084b24da1eef5, {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$94fa590b0c9d9421$export$64ef9b8c11710c47, {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress,
                            disableDescriptionClamp: disableDescriptionClamp
                        }),
                        learningProgress && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$184a993f673fc83f, {
                                        wasPreviouslyCompleted: learningProgress.status === $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: $f2f805f49af46a8b$export$e2e108cbe2e4f865.LEARNING_PATH
                                    }),
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            isUpdated && learningProgress.status !== $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                "data-testid": "updated-icon",
                                                css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$updatedIconContainerStyles,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                                    label: "Updated",
                                                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                        type: "editor-panel"
                                                    }),
                                                    onClick: handleUpdatedButtonClick
                                                })
                                            }),
                                            shouldDisplayShowMoreButton && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$ca7697601dcd7803, {
                                                cardRef: cardRef,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf,
                                                areHistoricalNotifications: areHistoricalNotifications,
                                                onViewUpdates: onViewUpdates
                                            }),
                                            shouldDisplayBookmark && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "save-content",
                                                css: $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "bookmark-filled"
                                                }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$imageBaseStyles = (0, $dnfL5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$noImageStyles = (0, $dnfL5.css)({
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$bodyContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${$f2f805f49af46a8b$var$$70542fe329d53412$export$bb4069a5b1582edc}px 0 0`
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $dnfL5.css)({
    padding: `21px 0 0`
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$labelContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$f2f805f49af46a8b$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$f2f805f49af46a8b$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$linkContainerStyles = (0, $dnfL5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $dnfL5.css)({
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$updatedIconContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $dnfL5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${$f2f805f49af46a8b$var$$70542fe329d53412$export$3b38c99bd0870716}px`,
    "&:hover": {
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")}`
    },
    '&:has([data-testid="show-more"]:active)': {
        outline: "none",
        border: "none"
    }
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $dnfL5.css)({
    boxShadow: "none",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled")}`
    }
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$smallPillStyles = (0, $dnfL5.css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    display: "inline-block"
});
const $f2f805f49af46a8b$var$$8d99d7c025746ac9$var$bigPillStyles = (0, $dnfL5.css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
var $f2f805f49af46a8b$var$$1f7c4876f10b107b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$1f7c4876f10b107b$exports, "Modal", ()=>$f2f805f49af46a8b$export$2b77a92f1a5ad772);
let $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($f2f805f49af46a8b$var$$1f7c4876f10b107b$var$DialogWidth || ($f2f805f49af46a8b$var$$1f7c4876f10b107b$var$DialogWidth = {}));
const $f2f805f49af46a8b$export$2b77a92f1a5ad772 = ({ closeModal: closeModal, width: width = $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$DialogWidth.LARGE, imageLink: imageLink, actionButton: actionButton, heading: heading, subheading: subheading, surveyText: surveyText })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $7ea5684aaa353f60$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        label: "close modal button",
                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-subheading",
                            css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        actionButton && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                size: $f2f805f49af46a8b$export$5dd2748b7940a2a0.LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$imageStyles = (0, $dnfL5.css)({
    borderRadius: "50%"
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalContainerStyles = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")}`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: "16px"
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: "8px"
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalImageContainerStyles = (0, $dnfL5.css)({
    marginBottom: "24px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "16px"
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalBodyStyles = (0, $dnfL5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$surveyTextStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $f2f805f49af46a8b$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        margin: 0
    }
});
var $f2f805f49af46a8b$var$$c5616d3f1657fc84$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$c5616d3f1657fc84$exports, "LessonsTabContentSize", ()=>$f2f805f49af46a8b$export$415b2bdf1346d2d4);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$c5616d3f1657fc84$exports, "LessonsTabContent", ()=>$f2f805f49af46a8b$export$ce96f190f5d3ee14);
let $f2f805f49af46a8b$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($f2f805f49af46a8b$export$415b2bdf1346d2d4 || ($f2f805f49af46a8b$export$415b2bdf1346d2d4 = {}));
const $f2f805f49af46a8b$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks, activeTab: activeTab = 0, onClickTab: onClickTab, children: children, size: size = $f2f805f49af46a8b$export$415b2bdf1346d2d4.DEFAULT })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                css: $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e41faf802a29e71, {
                            size: $f2f805f49af46a8b$export$ddadc1228c8dcfa.LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $dnfL5.css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $dnfL5.css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $dnfL5.css)({
        maxWidth: "1020px"
    })
};
const $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $dnfL5.css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        padding: "12px"
    }
});
const $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $dnfL5.css)({
    margin: "6px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        margin: "4px"
    }
});
const $f2f805f49af46a8b$var$$c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $f2f805f49af46a8b$var$$eb6f767c51421421$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$eb6f767c51421421$exports, "Metadata", ()=>$f2f805f49af46a8b$export$e7adebdc1ebd2fed);
const $f2f805f49af46a8b$export$e7adebdc1ebd2fed = ({ fields: fields })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                            css: $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataListStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataItemsStyles = (0, $dnfL5.css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataTitleStyles = (0, $dnfL5.css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $f2f805f49af46a8b$var$$eb6f767c51421421$var$metadataValueStyles = (0, $dnfL5.css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
var $f2f805f49af46a8b$var$$7fe7e19d380f3d34$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$7fe7e19d380f3d34$exports, "ArrowPosition", ()=>$f2f805f49af46a8b$export$2d4c84fdfce6f2a9);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$7fe7e19d380f3d34$exports, "Popup", ()=>$f2f805f49af46a8b$export$129a32eedafa97c5);
let $f2f805f49af46a8b$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($f2f805f49af46a8b$export$2d4c84fdfce6f2a9 || ($f2f805f49af46a8b$export$2d4c84fdfce6f2a9 = {}));
const $f2f805f49af46a8b$export$129a32eedafa97c5 = (0, $acw62.forwardRef)(({ popupHeight: popupHeight, title: title, children: children, step: step, totalSteps: totalSteps, arrowPosition: arrowPosition, onClose: onClose, onPrevious: onPrevious, onNext: onNext, popupStyle: popupStyle }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // handleClose and popoverRef intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        onClose
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": title,
        "data-testid": `popup-${arrowPosition}`,
        css: $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: [
                $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$popupContentStyles["base"],
                $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                            css: $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    disabled: step === 1,
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                                    label: "Previous",
                                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    disabled: step === totalSteps,
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                                    label: "Next",
                                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: (0, $dnfL5.css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        padding: "0 16px"
                    }),
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                            css: $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                            css: $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$popupContainerStyles = (0, $dnfL5.css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"),
        borderRadius: 0
    }
});
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $dnfL5.css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $dnfL5.css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $dnfL5.css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $dnfL5.css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $dnfL5.css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $dnfL5.css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $dnfL5.css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $dnfL5.css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $dnfL5.css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $dnfL5.css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $dnfL5.css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $dnfL5.css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $dnfL5.css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$contentHeaderStyles = (0, $dnfL5.css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$titleContainerStyles = (0, $dnfL5.css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$counterContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $f2f805f49af46a8b$var$$7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center"
});
var $f2f805f49af46a8b$var$$915f5687b3b07750$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$915f5687b3b07750$exports, "ProgressBar", ()=>$f2f805f49af46a8b$export$c17561cb55d4db30);
const $f2f805f49af46a8b$export$c17561cb55d4db30 = ({ progress: progress, color: color })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        "data-testid": "progress-bar",
        css: $f2f805f49af46a8b$var$$915f5687b3b07750$var$progressBarContainerStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $f2f805f49af46a8b$var$$915f5687b3b07750$var$progressBarContentStyles,
                color && (0, $dnfL5.css)({
                    backgroundColor: color
                }),
                (0, $dnfL5.css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $f2f805f49af46a8b$var$$915f5687b3b07750$var$progressBarContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $f2f805f49af46a8b$var$$915f5687b3b07750$var$progressBarContentStyles = (0, $dnfL5.css)({
    height: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.success"),
    borderRadius: "100px"
});
var $f2f805f49af46a8b$var$$579f9ef2424e0bd8$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$579f9ef2424e0bd8$exports, "ProgressStatus", ()=>$f2f805f49af46a8b$export$fad76899145ca0c7);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$579f9ef2424e0bd8$exports, "defineProgressStatus", ()=>$f2f805f49af46a8b$export$aa03ab7e1a208875);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$579f9ef2424e0bd8$exports, "LearningHeader", ()=>$f2f805f49af46a8b$export$86f07cccb119409d);
var $f2f805f49af46a8b$var$$2cfa64583f556289$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$2cfa64583f556289$exports, "PopupShare", ()=>$f2f805f49af46a8b$export$477c64ffaba52edf);
const $f2f805f49af46a8b$export$477c64ffaba52edf = ({ cardRef: cardRef, buttonText: buttonText, showCopyLink: showCopyLink = true, shareOnFb: shareOnFb = true, shareOnLinkedin: shareOnLinkedin = true, backgroundColor: backgroundColor = "#FFFFFF", urlToShare: urlToShare, alignToLeft: alignToLeft = false, alignToTop: alignToTop = false, fullWidth: fullWidth = false, color: color = "default", fullHeight: fullHeight = false })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = (0, $acw62.useCallback)(()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    }, [
        urlToShare
    ]);
    const shareOnLinkedIn = (0, $acw62.useCallback)(()=>{
        const shareText = "Check out this training from Atlassian!";
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(shareText)}`;
        handleShare(linkedinUrl);
    }, [
        urlToShare
    ]);
    const copyToClipboard = (0, $acw62.useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = $f2f805f49af46a8b$export$2a0b6757d41dacb2(shareOnLinkedIn);
    const onKeyDownFacebook = $f2f805f49af46a8b$export$2a0b6757d41dacb2(shareOnFacebook);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    const primaryColor = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand");
    const primaryColorStyles = color === "primary" ? (0, $dnfL5.css)({
        color: primaryColor,
        "& span": {
            color: primaryColor
        },
        "& svg": {
            fill: primaryColor
        }
    }) : undefined;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$2cfa64583f556289$var$shareButtonStyles,
            fullHeight && $f2f805f49af46a8b$var$$2cfa64583f556289$var$fullHeightStyles
        ],
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                label: buttonText ?? "Share",
                appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: buttonText ? (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: [
                        $f2f805f49af46a8b$var$$2cfa64583f556289$var$buttonWithTextStyles,
                        primaryColorStyles
                    ],
                    "data-testid": "button-with-text",
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$2cfa64583f556289$var$buttonTextStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                children: buttonText
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "share"
                        })
                    ]
                }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: primaryColorStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "share"
                    })
                }),
                iconType: "share"
            }),
            isOpen && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $f2f805f49af46a8b$var$$2cfa64583f556289$var$popupShareDropdownStyles,
                    alignToLeft && (0, $dnfL5.css)({
                        width: "176px",
                        right: 0
                    }),
                    alignToTop && (0, $dnfL5.css)({
                        bottom: "50px"
                    })
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                        onClick: copyToClipboard,
                        css: [
                            $f2f805f49af46a8b$var$$2cfa64583f556289$var$copyToClipboardOptionStyles,
                            fullWidth && $f2f805f49af46a8b$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        "aria-label": "copy to clipboard",
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                type: "link",
                                size: "small"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: (0, $dnfL5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
                                }),
                                children: "Copy link"
                            }),
                            isCopied && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: $f2f805f49af46a8b$var$$2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $f2f805f49af46a8b$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                            fullWidth && $f2f805f49af46a8b$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                                    id: "g5891",
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                                            id: "shapes",
                                            children: [
                                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: (0, $dnfL5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on LinkedIn"
                            })
                        ]
                    }),
                    shareOnFb && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $f2f805f49af46a8b$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles,
                            fullWidth && $f2f805f49af46a8b$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("g", {
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: (0, $dnfL5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$buttonWithTextStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$buttonTextStyles = (0, $dnfL5.css)({
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$shareButtonStyles = (0, $dnfL5.css)({
    width: "fit-content",
    position: "relative",
    "& span": {
        fontFamily: "Charlie Text, sans-serif"
    },
    // override fixed sizing when text is included
    '& button[id*="icon-button"]': {
        width: "fit-content !important",
        height: "fit-content !important"
    }
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$fullHeightStyles = (0, $dnfL5.css)({
    height: "100%",
    '& button[id*="icon-button"]': {
        height: "100% !important"
    }
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$popupShareDropdownStyles = (0, $dnfL5.css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$fullWidthOptionsStyles = (0, $dnfL5.css)({
    whiteSpace: "nowrap"
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$isCopiedStyles = (0, $dnfL5.css)({
    position: "absolute",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.pressed"),
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $f2f805f49af46a8b$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
let $f2f805f49af46a8b$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($f2f805f49af46a8b$export$fad76899145ca0c7 || ($f2f805f49af46a8b$export$fad76899145ca0c7 = {}));
const $f2f805f49af46a8b$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $f2f805f49af46a8b$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $f2f805f49af46a8b$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $f2f805f49af46a8b$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $f2f805f49af46a8b$export$86f07cccb119409d = ({ inspectMode: inspectMode, heading: heading, anonymousView: anonymousView = true, urlToShare: urlToShare, onSignIn: onSignIn, onStartCourse: onStartCourse, isLoading: isLoading, contentType: contentType, progressStatus: progressStatus, tagLine: tagLine, isSaved: isSaved, onSave: onSave, shouldShowFeedback: shouldShowFeedback, onStartFeedback: onStartFeedback, href: href })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = (event)=>{
        if (onStartCourse) {
            event?.preventDefault();
            onStartCourse();
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE ? "course" : "learning path";
    const status = $f2f805f49af46a8b$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    const renderActionButtons = ()=>{
        if (isLoading) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
            label: "",
            isLoading: isLoading
        });
        if (anonymousView) return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: (0, $dnfL5.css)({
                display: "flex"
            }),
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    label: "Sign in",
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleSignIn,
                    isLoading: isLoading
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: (0, $dnfL5.css)({
                        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        label: status,
                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY,
                        onClick: handleStartCourse,
                        isLoading: isLoading,
                        href: href,
                        target: "_blank"
                    })
                })
            ]
        });
        return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: (0, $dnfL5.css)({
                display: "flex"
            }),
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    label: status,
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleStartCourse,
                    isLoading: isLoading,
                    href: href,
                    target: "_blank"
                }),
                shouldShowFeedback && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: (0, $dnfL5.css)({
                        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        label: "Take survey",
                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY,
                        onClick: onStartFeedback,
                        isLoading: isLoading
                    })
                })
            ]
        });
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("section", {
        "data-testid": "learning-header",
        css: $f2f805f49af46a8b$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$export$f40d73b6f7f951e9
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                    label: contentTypeLabel
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: (0, $dnfL5.css)({
                    margin: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} 0`
                }),
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                    css: $f2f805f49af46a8b$var$$579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: (0, $dnfL5.css)({
                    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
                    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")
                }),
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2e0a83ec2e27ecbb, {
                    color: (0, $2b750d3a8789dea3$export$8754fc7e6d8b3000)
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: (0, $dnfL5.css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    renderActionButtons(),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: (0, $dnfL5.css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                tabIndex: 0,
                                css: $f2f805f49af46a8b$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                    type: "bookmark-filled"
                                }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                    type: "bookmark"
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    paddingTop: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.600")}`,
    paddingBottom: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")}`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.lg]: {
        paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.1000"),
        paddingBottom: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")}`
    }
});
const $f2f805f49af46a8b$var$$579f9ef2424e0bd8$var$tagLineStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $f2f805f49af46a8b$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $dnfL5.css)({
    height: "24px",
    border: "none",
    padding: 0,
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`,
        borderRadius: "2px"
    }
});
var $f2f805f49af46a8b$var$$d559b1cc82536c49$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$d559b1cc82536c49$exports, "Footer", ()=>$f2f805f49af46a8b$export$a06f1c675e846f6f);
const $f2f805f49af46a8b$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal })=>{
    const noOp = ()=>{};
    const onKeyDownReport = $f2f805f49af46a8b$export$2a0b6757d41dacb2(onOpenReportProblemModal || noOp);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("footer", {
        "data-testid": "footer",
        css: $f2f805f49af46a8b$var$$d559b1cc82536c49$var$footerContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $f2f805f49af46a8b$var$$d559b1cc82536c49$var$paddingRightStyles,
                    $f2f805f49af46a8b$var$$d559b1cc82536c49$var$logoLinkStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $ea269827cfabf855$export$765cacec8b0843f3), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("ul", {
                    css: $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                            css: [
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemStyles,
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                role: "button",
                                tabIndex: 0,
                                css: [
                                    $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $dnfL5.css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                onKeyDown: onKeyDownReport,
                                children: "Report problem"
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                            css: [
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemStyles,
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                css: $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                            css: [
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemStyles,
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                css: $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                            css: [
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemStyles,
                                $f2f805f49af46a8b$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                css: $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("li", {
                            css: $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$d559b1cc82536c49$var$footerContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        padding: "48px 60px"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listStyles = (0, $dnfL5.css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    }
});
const $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        paddingTop: "24px"
    }
});
const $f2f805f49af46a8b$var$$d559b1cc82536c49$var$paddingRightStyles = (0, $dnfL5.css)({
    paddingRight: "24px"
});
const $f2f805f49af46a8b$var$$d559b1cc82536c49$var$logoLinkStyles = (0, $dnfL5.css)({
    lineHeight: "24px"
});
const $f2f805f49af46a8b$var$$d559b1cc82536c49$var$listItemLinkStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
        textDecoration: "none"
    }
});
var $f2f805f49af46a8b$var$$fa53e9c0a1746730$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$fa53e9c0a1746730$exports, "LabelledGraphic", ()=>$f2f805f49af46a8b$export$12b5e3eab33f219b);
const $f2f805f49af46a8b$export$12b5e3eab33f219b = ({ image: image, markers: markers, onClickMarker: onClickMarker, onClickNext: onClickNext, onClickPrevious: onClickPrevious, onClickDismiss: onClickDismiss, pulseAnimationColor: pulseAnimationColor = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input") })=>{
    const [activeId, setActiveId] = (0, $acw62.useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $acw62.useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $acw62.useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $acw62.useState)([]);
    const containerDivRef = (0, $acw62.useRef)(null);
    const popupRef = (0, $acw62.useRef)(null);
    const imageContainerRef = (0, $acw62.useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $acw62.useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, [
        onClickDismiss
    ]);
    const handleClickMarker = (0, $acw62.useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, [
        onClickMarker
    ]);
    (0, $acw62.useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $f2f805f49af46a8b$export$2d4c84fdfce6f2a9.BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && pulseAnimationColor === "#FFFFFF" && (0, $dnfL5.css)({
                            animation: `${$f2f805f49af46a8b$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        }),
                        !clickedMarkers.includes(idx) && pulseAnimationColor !== "#FFFFFF" && (0, $dnfL5.css)({
                            animation: `${$f2f805f49af46a8b$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleClickMarker(idx);
                            }
                        },
                        draggable: true,
                        css: [
                            $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $dnfL5.css)({
                                border: `2px solid ${pulseAnimationColor}`
                            })
                        ],
                        children: /*#__PURE__*/ (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        activeId === idx && (0, $dnfL5.css)({
                                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $dnfL5.css)({
                                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
                                        })
                                    ],
                                    children: /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: (0, $dnfL5.css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.inverse") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$129a32eedafa97c5, {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                ref: imageContainerRef,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e431a229df88919, {
                    ...image,
                    css: [
                        $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$imageStyles,
                        (0, $dnfL5.css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $dnfL5.css)({
    position: "relative",
    cursor: "default"
});
const $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles = (0, $dnfL5.keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.inverse")}`
    }
});
const $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles = (0, $dnfL5.keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.discovery")}`
    }
});
const $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$markerPulseStyles = (0, $dnfL5.css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $dnfL5.css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle"),
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle.hovered")
        },
        "&:active": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle.pressed")
        }
    }),
    selected: (0, $dnfL5.css)({
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        "&:hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
        }
    })
};
const $f2f805f49af46a8b$var$$fa53e9c0a1746730$var$imageStyles = (0, $dnfL5.css)({
    height: "auto",
    width: "100%"
});
var $f2f805f49af46a8b$var$$9225344cd5d1f99b$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9225344cd5d1f99b$exports, "LessonHeader", ()=>$f2f805f49af46a8b$export$7bee7638d150bc04);
const $f2f805f49af46a8b$export$7bee7638d150bc04 = ({ heading: heading, tags: tags, description: description, urlToShare: urlToShare, onListenClick: onListenClick, showListenButton: showListenButton = true })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$headingWrapperStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$metadataStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$tagStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                                    ...tag
                                })
                            }, index))
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            showListenButton && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                                css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$lineWrapperStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2e0a83ec2e27ecbb, {
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$metadataStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$flexContainerStyles = (0, $dnfL5.css)({
    display: "flex"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$listenButtonStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $dnfL5.css)({
    marginLeft: "0.25rem",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$tagStyles = (0, $dnfL5.css)({
    marginRight: "0.5rem"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$lineWrapperStyles = (0, $dnfL5.css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$headingWrapperStyles = (0, $dnfL5.css)({
    padding: "5rem 0 1.5rem 0"
});
const $f2f805f49af46a8b$var$$9225344cd5d1f99b$var$descriptionStyles = (0, $dnfL5.css)({
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});
var $f2f805f49af46a8b$var$$3b9afd8fe4435353$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3b9afd8fe4435353$exports, "LessonList", ()=>$f2f805f49af46a8b$export$962a95c44e73eb25);
const $f2f805f49af46a8b$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted, size: size })=>isCompleted ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
        type: "check-circle-filled",
        size: size,
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.success")
    }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
        type: "check-circle-outline",
        size: size,
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtler.pressed")
    });
const $f2f805f49af46a8b$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle, slug: slug, lessonSlug: lessonSlug, isCompleted: isCompleted, onNavigation: onNavigation })=>{
    const handleKeyDown = (0, $acw62.useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, []);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                isCompleted: isCompleted,
                size: $f2f805f49af46a8b$export$ff775019b5b6e7df.SMALL
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$7e5a668c3a5a9ea8$var$sectionStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $f2f805f49af46a8b$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $dnfL5.css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle, slug: slug, duration: duration, isCompleted: isCompleted, isCurrentLesson: isCurrentLesson, hasDivider: hasDivider, sections: sections, onNavigation: onNavigation })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $acw62.useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, []);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("section", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Section needs tabIndex for keyboard navigation
        tabIndex: 0,
        "aria-label": `Lesson overview for ${lessonTitle}`,
        css: [
            $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $dnfL5.css)({
                marginBottom: "16px"
            })
        ],
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        expandByCard(e);
                    }
                },
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $dnfL5.css)({
                                borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "chevron-down",
                            size: $f2f805f49af46a8b$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.selected") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.subtle")
                        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            size: $f2f805f49af46a8b$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.selected") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.subtle")
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $dnfL5.css)({
                                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: (0, $dnfL5.css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                                            isCompleted: isCompleted,
                                            size: $f2f805f49af46a8b$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: (0, $dnfL5.css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>(0, $acw62.createElement)($f2f805f49af46a8b$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a, {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: (0, $dnfL5.css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2e0a83ec2e27ecbb, {
                    height: 2,
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")
                })
            })
        ]
    }, slug);
};
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $dnfL5.css)({
    maxWidth: "25.25rem",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonCardStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$currentLessonStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected"),
    borderLeft: `4px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")}`
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$hoverLessonStyles = (0, $dnfL5.css)({
    ":hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
    }
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$expandButtonStyles = (0, $dnfL5.css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$durationStyles = (0, $dnfL5.css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonContainer = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$fc302bf0bdbf0587$var$lessonTitleStyles = (0, $dnfL5.css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $f2f805f49af46a8b$export$962a95c44e73eb25 = ({ lessons: lessons })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>(0, $acw62.createElement)($f2f805f49af46a8b$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2, {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};
var $f2f805f49af46a8b$var$$050a30fc95775cfd$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$050a30fc95775cfd$exports, "LessonsList", ()=>$f2f805f49af46a8b$export$c3b0ae23c563b692);
const $f2f805f49af46a8b$export$c3b0ae23c563b692 = ({ lessons: lessons, onLessonClick: onLessonClick, isStandalone: isStandalone = false, isTablet: isTablet = false })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lessonsListStyles,
            isStandalone && $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles,
            isTablet && !isStandalone && (0, $dnfL5.css)({
                borderRadius: "0"
            })
        ],
        children: lessons?.map(({ slug: slug, isCompleted: isCompleted, title: title, duration: duration }, index)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                role: "button",
                "data-testid": `lesson-list-item-${index}`,
                tabIndex: 0,
                css: [
                    $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lessonItemStyles,
                    !isStandalone && !isTablet && index === lessons.length - 1 && $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lastLessonItemStyles,
                    isTablet && !isStandalone && index === 0 && $f2f805f49af46a8b$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles,
                    isTablet && !isStandalone && index === lessons.length - 1 && $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles
                ],
                onClick: ()=>onLessonClick(slug),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onLessonClick(slug);
                },
                children: [
                    /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$050a30fc95775cfd$var$circleContainerStyles,
                        children: isCompleted ? /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            size: "small",
                            type: "check-circle",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success")
                        }) : /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$050a30fc95775cfd$var$emptyCircleStyles
                        })
                    }),
                    /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        css: [
                            $f2f805f49af46a8b$var$$050a30fc95775cfd$var$textStyles,
                            isCompleted && {
                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.success")
                            }
                        ],
                        children: title
                    }),
                    /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$050a30fc95775cfd$var$durationBadgeStyles,
                        children: duration
                    }),
                    isStandalone && /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$050a30fc95775cfd$var$chevronContainerStyles,
                        children: /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            size: "medium",
                            type: "chevron-right",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
                        })
                    })
                ]
            }, slug))
    });
};
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lessonsListStyles = (0, $dnfL5.css)({
    backgroundColor: "#FFFFFF",
    maxWidth: "100%",
    borderRadius: "0 0 8px 8px",
    overflow: "hidden"
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles = (0, $dnfL5.css)({
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px"
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lessonItemStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:active": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    },
    ":first-of-type": {
        borderTop: "none"
    }
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$circleContainerStyles = (0, $dnfL5.css)({
    marginTop: "3px"
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$emptyCircleStyles = (0, $dnfL5.css)({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    border: `1.4px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075"),
    margin: "1px",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025")
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$textStyles = (0, $dnfL5.css)({
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    fontFamily: "Inter",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$durationBadgeStyles = (0, $dnfL5.css)({
    marginTop: "1px",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    marginLeft: "auto",
    whiteSpace: "nowrap",
    height: "fit-content"
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lastLessonItemStyles = (0, $dnfL5.css)({
    borderRadius: "0 0 8px 8px"
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles = (0, $dnfL5.css)({
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")} !important`
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles = (0, $dnfL5.css)({
    borderRadius: "0 !important"
});
const $f2f805f49af46a8b$var$$050a30fc95775cfd$var$chevronContainerStyles = (0, $dnfL5.css)({
    display: "none",
    "@media (max-width: 965px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
        marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.negative.100")
    }
});
var $f2f805f49af46a8b$var$$65703ff0bcd12648$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$65703ff0bcd12648$exports, "LessonSidebar", ()=>$f2f805f49af46a8b$export$c2bf8d11366d1eb0);
const $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress, pathColor: pathColor, trailColor: trailColor = (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"), image: image, title: title, onCourseNavigation: onCourseNavigation })=>{
    const handleClick = (0, $acw62.useCallback)(()=>{
        onCourseNavigation && onCourseNavigation();
    }, [
        onCourseNavigation
    ]);
    const handleKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleClick);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: (0, $dnfL5.css)({
                    maxWidth: "64px",
                    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1a77571422b9634a$export$5ab97151efedb8c6), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $1a77571422b9634a$export$5115a192ad9bf57f)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                            css: $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: [
                                (0, $dnfL5.css)({
                                    backgroundColor: trailColor
                                }),
                                $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$imageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $dnfL5.css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$var$titleStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $f2f805f49af46a8b$export$c2bf8d11366d1eb0 = ({ lessons: lessons, progress: progress, pathColor: pathColor, title: title, image: image, isVisible: isVisible, onChangeMenuVisibility: onChangeMenuVisibility, onCourseNavigation: onCourseNavigation })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)($f2f805f49af46a8b$export$1ba59dacbcbf90fe, {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: (0, $dnfL5.css)({
                    marginLeft: "16px"
                }),
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: (0, $dnfL5.css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: [
                                $f2f805f49af46a8b$var$$65703ff0bcd12648$var$subheadingStyles,
                                (0, $dnfL5.css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75, {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: (0, $dnfL5.css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$962a95c44e73eb25, {
                lessons: lessons
            })
        ]
    });
const $f2f805f49af46a8b$var$$65703ff0bcd12648$var$subheadingStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
var $f2f805f49af46a8b$var$$8340d81aba797956$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$8340d81aba797956$exports, "LearningOverviewCard", ()=>$f2f805f49af46a8b$export$60e8035fadc9b8fc);
var $f2f805f49af46a8b$var$$8f97e278a4a2a6b3$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $f2f805f49af46a8b$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground = `<svg width="1003" height="48" viewBox="0 0 1003 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3622_1083)">
      <g clip-path="url(#clip1_3622_1083)">
        <path
          d="M929.87 -106.601C934.923 -113.047 932.654 -115.022 927.128 -108.989C923.208 -104.711 919.232 -100.29 914.973 -95.4457C910.706 -90.547 906.173 -84.8713 902.441 -77.642C901.929 -76.6053 901.438 -75.6223 900.973 -74.6736C900.581 -73.6929 900.196 -72.7546 899.839 -71.8631C899.493 -70.958 899.113 -70.1306 898.849 -69.2729C898.586 -68.4274 898.343 -67.6109 898.101 -66.8314C897.872 -66.0506 897.619 -65.3092 897.435 -64.5795C897.275 -63.835 897.116 -63.1274 896.97 -62.4309C896.673 -61.0446 896.374 -59.7637 896.241 -58.4844C896.079 -57.2144 895.893 -55.9961 895.769 -54.7717C895.695 -53.5422 895.62 -52.3126 895.538 -51.053C895.481 -50.4216 895.48 -49.7785 895.49 -49.1218C895.494 -48.4596 895.492 -47.7918 895.495 -47.0926C895.45 -45.6992 895.57 -44.2212 895.672 -42.6212C895.734 -40.8087 896.046 -38.9029 896.305 -36.9035C896.407 -35.8974 896.663 -34.8941 896.85 -33.8669C897.074 -32.836 897.222 -31.7755 897.514 -30.7316C897.793 -29.6765 898.071 -28.6091 898.36 -27.5159C898.619 -26.4196 899.039 -25.3563 899.372 -24.2525C899.729 -23.1586 900.067 -22.0357 900.524 -20.944C901.095 -19.4758 901.672 -18.0008 902.248 -16.5135C903.686 -16.151 905.125 -15.7886 906.563 -15.4261L908.148 -15.024L909.749 -14.7069C910.816 -14.4996 911.884 -14.2923 912.945 -14.0795C914.015 -13.9338 915.072 -13.7893 916.13 -13.6449C916.659 -13.5788 917.181 -13.4949 917.698 -13.4424C918.222 -13.4077 918.74 -13.3676 919.258 -13.3274C920.294 -13.2594 921.317 -13.1803 922.328 -13.1147C923.342 -13.1108 924.331 -13.1094 925.302 -13.1037C925.79 -13.0974 926.272 -13.098 926.748 -13.093C927.225 -13.1003 927.69 -13.1458 928.161 -13.1722C930.021 -13.305 931.798 -13.3659 933.424 -13.6525C935.06 -13.8885 936.594 -14.073 937.944 -14.4185C939.298 -14.7325 940.538 -14.9593 941.583 -15.2676C942.622 -15.5827 943.499 -15.8526 944.2 -16.0659C944.814 -16.2634 945.445 -16.4282 946.042 -16.6706L947.817 -17.4307C948.868 -17.8993 950.401 -18.4983 952.174 -19.5183C953.072 -20.0086 954.081 -20.5123 955.126 -21.1299C956.149 -21.7869 957.247 -22.4858 958.427 -23.2319C963.03 -26.3399 968.353 -30.7603 973.46 -36.3963C976.055 -39.2319 978.501 -42.2247 981.093 -45.2956C983.684 -48.3664 986.348 -51.5351 989.05 -54.737C994.763 -61.4435 1000.62 -68.3333 1006.26 -74.9487L1008.09 -77.1133L970.879 -109.453C966.364 -113.375 962.194 -116.953 958.273 -120.283C953.7 -124.143 949.449 -127.723 945.42 -131.125C944.678 -130.223 943.943 -129.327 943.214 -128.436C942.856 -127.996 942.499 -127.568 942.141 -127.128C941.939 -126.87 941.731 -126.619 941.535 -126.367C940.74 -125.372 939.959 -124.387 939.189 -123.414C937.664 -121.465 936.17 -119.557 934.69 -117.66C932.576 -114.943 931.934 -113.128 932.4 -112.592L932.334 -112.332C932.406 -112.276 932.468 -112.282 932.515 -112.357L932.544 -112.466C933.134 -112.084 934.804 -113.003 937.144 -115.524C938.768 -117.296 940.405 -119.078 942.08 -120.893C942.908 -121.811 943.75 -122.74 944.611 -123.686C944.824 -123.918 945.032 -124.157 945.245 -124.389L945.523 -124.676C945.697 -124.85 945.871 -125.036 946.051 -125.216C946.212 -125.057 946.378 -124.892 946.551 -124.732L946.789 -124.498C946.872 -124.415 946.884 -124.389 947.164 -124.144C948.023 -123.364 948.906 -122.57 949.794 -121.768C951.584 -120.164 953.428 -118.511 955.343 -116.801C959.18 -113.387 963.311 -109.751 967.813 -105.818C970.585 -103.409 974.75 -99.5537 980.247 -94.53C983.002 -92.0237 986.097 -89.2169 989.489 -86.1324C991.196 -84.5985 992.985 -82.9942 994.853 -81.3264C996.512 -79.8591 998.231 -78.3239 1000.02 -76.7443C1000.02 -76.7443 1000.02 -76.7443 1000.03 -76.7375C1000.03 -76.7375 1000.03 -76.7375 1000.03 -76.7307L999.428 -75.9942C998.608 -74.9765 997.794 -73.9643 996.986 -72.9576C992.58 -67.3803 987.764 -61.4487 983.029 -55.6945C980.656 -52.8241 978.303 -49.9826 976.04 -47.2557C974.903 -45.8928 973.785 -44.5589 972.7 -43.2526C971.603 -41.9845 970.523 -40.8015 969.48 -39.627C968.467 -38.4309 967.35 -37.4185 966.338 -36.4017C965.308 -35.3929 964.34 -34.4148 963.33 -33.6019C962.344 -32.7618 961.416 -31.9716 960.551 -31.2367C959.658 -30.548 958.798 -29.9486 958.034 -29.383C957.263 -28.8364 956.598 -28.2977 955.964 -27.9044C955.336 -27.5166 954.797 -27.1817 954.347 -26.9119C953.472 -26.3698 952.996 -26.0778 952.996 -26.0778C952.138 -25.5031 951.199 -25.0603 950.283 -24.5781C949.361 -24.1149 948.469 -23.5932 947.518 -23.1762C945.607 -22.393 943.74 -21.4938 941.744 -20.9109C937.842 -19.5255 933.722 -18.7251 929.573 -18.2555L926.433 -17.9804L923.272 -17.9363C922.219 -17.8947 921.159 -17.9652 920.098 -18.0234C919.038 -18.1063 917.98 -18.0961 916.922 -18.2406L913.741 -18.6191C912.682 -18.7389 911.629 -18.9819 910.566 -19.1578C909.51 -19.3392 908.455 -19.5329 907.408 -19.8061L905.406 -20.2877L904.553 -22.4154C904.095 -23.4824 903.763 -24.5862 903.387 -25.6759C902.591 -27.8535 902.063 -30.0843 901.455 -32.3048C900.43 -36.7694 899.847 -41.2944 899.708 -45.799C899.617 -54.5172 901.176 -60.7732 902.66 -65.3605C902.844 -65.9356 903.027 -66.4861 903.204 -67.0187C903.288 -67.2822 903.373 -67.5458 903.458 -67.797C903.56 -68.0402 903.663 -68.2833 903.759 -68.521C904.156 -69.4703 904.519 -70.3427 904.855 -71.156C905.02 -71.5599 905.184 -71.9515 905.335 -72.3196C905.517 -72.6785 905.692 -73.0195 905.86 -73.355C906.196 -74.0137 906.505 -74.6256 906.787 -75.1907C907.6 -76.9267 908.616 -78.4937 909.532 -80.0583C910.413 -81.6513 911.478 -83.0586 912.439 -84.4951C912.938 -85.1991 913.381 -85.9272 913.903 -86.5918C914.425 -87.2563 914.927 -87.9166 915.436 -88.5701C916.442 -89.8783 917.421 -91.1521 918.467 -92.4005C922.553 -97.4041 926.266 -102.05 929.852 -106.622L929.87 -106.601Z"
          fill="#ffffff7d"
        />
        <path
          d="M485.107 17.5435C485.157 17.2393 485.206 16.9473 485.261 16.6622C485.278 16.3733 485.284 16.0955 485.3 15.8312C485.322 15.2892 485.33 14.7951 485.324 14.3368C485.343 13.4171 485.158 12.6498 485.022 12.0299C484.719 10.8054 484.323 10.2085 483.928 10.1932C483.526 10.1834 483.114 10.7415 482.773 11.8449C482.59 12.3954 482.499 13.0914 482.264 13.8777C482.161 14.2755 482.069 14.7115 481.982 15.179C481.941 15.4161 481.901 15.6532 481.853 15.9082C481.782 16.1483 481.716 16.3953 481.65 16.6545C480.974 19.6043 479.725 22.3352 477.739 24.515C475.77 26.7027 473.101 28.343 469.989 29.4622C466.875 30.606 463.32 31.2162 459.494 31.4897C458.544 31.5974 457.566 31.6219 456.576 31.6451C455.585 31.6806 454.581 31.7272 453.55 31.6906C452.518 31.6786 451.48 31.6599 450.417 31.6509C449.33 31.6149 448.225 31.5831 447.114 31.5445C442.635 31.4549 438.7 31.3709 437.402 31.3506C437.461 33.0947 437.517 34.758 437.575 36.3721C437.617 37.335 437.653 38.2665 437.691 39.1611C437.768 40.7708 437.837 42.2685 437.903 43.6732C438.049 46.4837 438.178 48.94 438.299 51.2842C438.542 55.9725 438.747 60.2179 438.871 65.9952C438.989 71.3019 439.109 77.3447 439.271 84.7774C442.605 84.9054 446.043 85.0502 449.524 85.1809C452.302 85.302 455.11 85.42 457.906 85.5368C463.561 85.752 469.165 85.7145 474.329 85.3789C479.492 85.0555 484.21 84.4395 488.08 83.7004C491.949 82.9612 494.97 82.1111 496.811 81.5433C498.187 81.1511 499.514 80.6115 500.851 80.0978C502.029 79.5802 503.702 78.8717 505.73 77.7972C506.747 77.2757 507.825 76.6181 509.009 75.928C510.159 75.1726 511.403 74.3834 512.642 73.4081C515.149 71.5039 517.788 69.0935 520.199 66.06C522.609 63.0388 524.767 59.3919 526.368 55.2742C528 51.1658 529.033 46.5883 529.51 41.8369C530 37.0745 529.928 32.156 529.432 27.1513C528.49 17.1591 524.835 6.82357 518.805 -1.52006C514.549 -7.40132 509.649 -11.8944 504.902 -15.2832C503.698 -16.0981 502.525 -16.8914 501.381 -17.6631C500.204 -18.3579 499.057 -19.0433 497.946 -19.7004C496.828 -20.3396 495.706 -20.8803 494.635 -21.4406C494.295 -21.6111 493.962 -21.7871 493.629 -21.9632C493.405 -22.0664 493.158 -22.2337 492.914 -22.3079L492.13 -22.3319C491.5 -22.3463 490.882 -22.3719 490.271 -22.3906C481.737 -22.6506 475.456 -22.8365 471.146 -22.9647C466.13 -23.0903 461.424 -23.2092 457.699 -23.3088L457.377 -18.1211C464.071 -16.6871 469.734 -13.9351 473.851 -9.95455C477.937 -5.97092 480.524 -1.00134 481.726 4.27301C482.155 6.19688 482.534 7.6642 482.859 8.65586C483.208 9.65003 483.595 10.1718 483.947 10.1889C484.305 10.2005 484.622 9.70074 484.85 8.64766C485.091 7.59583 485.137 5.9862 484.816 3.85057C483.934 -1.98513 481.344 -7.93852 476.726 -12.8297C472.089 -17.7166 465.53 -21.0977 458.111 -22.7969L457.845 -18.5252C461.574 -18.3941 466.279 -18.2259 471.299 -18.0566C475.257 -17.9332 481.351 -17.5745 489.372 -17.144C489.878 -17.1174 490.384 -17.0907 490.902 -17.0629L491.679 -17.0211C491.864 -17.0147 491.79 -17.0099 491.827 -17.0061L491.876 -17.0011C491.876 -17.0011 491.906 -16.9672 492.051 -16.8906C492.287 -16.7615 492.523 -16.6324 492.759 -16.5033C493.23 -16.2451 493.715 -15.9857 494.198 -15.7139C495.186 -15.2117 496.131 -14.5776 497.12 -13.97C497.614 -13.6601 498.115 -13.3556 498.622 -13.0444C499.109 -12.7043 499.602 -12.3574 500.095 -12.0104C504.076 -9.24363 508.128 -5.80154 511.761 -1.4742C512.991 -0.0999016 514.024 1.40902 515.133 2.87617L516.629 5.17427C517.149 5.92597 517.586 6.72498 518.024 7.52399C519.044 9.21093 519.835 11.0478 520.681 12.8965C521.038 13.8482 521.389 14.8054 521.745 15.7694C521.936 16.2465 522.095 16.7389 522.224 17.2344L522.652 18.7191C523.758 22.6971 524.486 26.8472 524.689 30.9872C525.268 39.2601 524.188 47.3027 521.595 53.596C520.323 56.7513 518.723 59.4651 517.055 61.7143C515.399 63.977 513.604 65.6937 512.1 67.0998C511.301 67.7547 510.62 68.3784 509.964 68.8499C509.314 69.3283 508.747 69.7347 508.295 70.066C507.343 70.6745 506.828 71.012 506.828 71.012C504.563 72.4459 502.168 73.7183 499.652 74.7619C498.417 75.3293 497.12 75.7605 495.839 76.249C494.529 76.6666 493.237 77.1292 491.9 77.476C486.584 78.9529 481.067 79.9146 475.469 80.435C469.87 80.9678 464.194 81.1277 458.498 81.0197C455.668 80.9799 452.748 80.8629 449.876 80.7879L443.466 80.595L443.003 62.5921L442.312 36.3457L447.253 36.4884C448.371 36.5214 449.476 36.5532 450.557 36.5825C451.664 36.5896 452.764 36.6023 453.845 36.607C454.926 36.6362 455.999 36.5657 457.058 36.5186C458.117 36.4714 459.157 36.4409 460.183 36.3038C464.297 35.9358 468.223 35.1838 471.806 33.7413C475.381 32.329 478.615 30.1893 480.927 27.3127C483.263 24.4509 484.572 20.9901 485.113 17.5626L485.107 17.5435Z"
          fill="#ffffff7d"
        />
        <path
          d="M628.636 -23.6993C627.184 -18.8428 627.285 -16.1605 628.042 -15.9228C628.842 -15.6623 630.281 -17.7738 631.962 -22.3165C632.638 -23.887 633.321 -25.4753 634.004 -27.076C634.766 -28.6378 635.601 -30.1674 636.401 -31.7501C636.774 -32.5596 637.297 -33.2735 637.749 -34.0441C638.219 -34.8067 638.689 -35.5693 639.159 -36.3442C640.136 -37.8656 641.277 -39.3024 642.347 -40.8329C646.985 -46.6464 652.943 -52.2209 660.978 -56.2732C662.164 -56.858 663.294 -57.4299 664.388 -57.8632C664.934 -58.086 665.445 -58.3372 665.959 -58.5077C666.505 -58.7059 667.026 -58.8943 667.522 -59.0729C671.346 -60.2248 674.355 -60.9339 676.118 -61.4106C673.934 -63.5064 671.794 -65.474 669.883 -67.2824C669.186 -67.9284 668.512 -68.5472 667.857 -69.158C667.344 -69.6307 666.85 -70.0829 666.361 -70.5284C664.423 -72.3023 662.67 -73.9028 660.971 -75.4546C657.579 -78.5637 654.391 -81.516 650.316 -85.4491C645.637 -89.9197 640.194 -95.1915 634.538 -100.708C631.719 -103.468 628.828 -106.285 625.968 -109.08C625.255 -109.784 624.535 -110.481 623.827 -111.178L622.162 -112.794L621.685 -113.251L621.448 -113.485L621.329 -113.596C621.329 -113.596 621.229 -113.582 621.179 -113.574L619.975 -113.307L618.771 -113.039L618.209 -112.911L617.847 -112.812L616.408 -112.413C615.469 -112.125 614.541 -111.799 613.625 -111.483C609.996 -110.12 606.696 -108.327 603.832 -106.317C603.47 -106.075 603.114 -105.827 602.751 -105.585C602.413 -105.316 602.075 -105.06 601.742 -104.797C601.078 -104.271 600.433 -103.761 599.794 -103.257C598.6 -102.165 597.433 -101.133 596.389 -100.089C592.2 -95.9121 589.715 -91.9583 588.256 -89.8302C587.419 -88.5482 586.726 -87.1773 585.979 -85.8305C585.374 -84.7971 584.726 -83.2857 583.896 -81.44C583.006 -79.6129 582.202 -77.3255 581.25 -74.7439C580.735 -73.4664 580.356 -72.0451 579.906 -70.5753C579.47 -69.1166 579.012 -67.5796 578.533 -65.9768C578.075 -64.4398 577.589 -62.8438 577.095 -61.1806C576.51 -59.5576 575.868 -57.8971 575.223 -56.175C572.497 -49.3508 568.288 -42.2319 562.402 -35.9698C559.408 -32.8965 555.985 -30.0708 552.167 -27.712C550.27 -26.5128 548.238 -25.4944 546.165 -24.5358L544.574 -23.8869L543.682 -23.5322L542.028 -22.9949C539.834 -22.265 537.606 -21.6005 535.378 -20.9482C537.479 -18.9228 542.769 -13.8396 547.946 -8.84843C558.695 1.42159 567.391 9.73274 574.278 16.3139C577.724 19.6017 580.706 22.4589 583.266 24.8959C584.545 26.1206 585.724 27.2423 586.789 28.2596C587.504 28.9383 588.182 29.5886 588.831 30.2049C589.29 30.6411 589.73 31.0693 590.165 31.4784C590.225 31.5092 590.263 31.6306 590.333 31.5821L590.528 31.5214L590.916 31.4C591.173 31.3209 591.423 31.2473 591.68 31.1682C592.268 30.9929 592.863 30.812 593.445 30.6299C593.795 30.5294 593.902 30.4845 594.078 30.4158L594.574 30.2373C595.233 29.9887 595.903 29.7784 596.534 29.4836C597.169 29.2079 597.793 28.931 598.422 28.6609C599.028 28.3513 599.628 28.0472 600.221 27.7487C600.826 27.4637 601.379 27.1053 601.948 26.7797C602.506 26.4404 603.075 26.1271 603.615 25.7675C604.143 25.4066 604.671 25.0458 605.193 24.6782C605.714 24.3228 606.23 23.9608 606.71 23.558C610.661 20.5014 613.893 17.0563 616.604 13.478C621.912 6.22945 625.281 -1.35211 627.641 -9.08543C629.982 -17.7176 627.486 -18.3668 624.653 -10.2731C621.847 -2.97477 618.23 4.03719 613.054 10.6126C610.418 13.8522 607.349 16.9427 603.702 19.6652C603.261 20.0225 602.791 20.3458 602.302 20.6612C601.825 20.9777 601.342 21.2998 600.853 21.6275C600.364 21.9428 599.84 22.2174 599.332 22.5247C598.814 22.8184 598.312 23.1325 597.77 23.3867C597.228 23.6533 596.691 23.9266 596.149 24.1932C595.582 24.4326 595.022 24.6789 594.456 24.9183C593.895 25.1768 593.294 25.3632 592.71 25.5823L591.926 25.8676L591.619 25.9541C591.538 25.9767 591.456 26.0117 591.375 26.0221C591.322 25.961 591.262 25.9055 591.197 25.8431C591.138 25.7753 591.072 25.713 591.001 25.6439C590.763 25.4095 590.525 25.175 590.269 24.9326C589.277 23.9473 588.177 22.8646 586.976 21.6788C584.593 19.3031 581.8 16.5207 578.639 13.367C572.304 7.05828 564.428 -0.749007 555.093 -9.75596C553.569 -11.2219 552.04 -12.6822 550.497 -14.1192C549.722 -14.8411 548.954 -15.5562 548.185 -16.2713L547.023 -17.3356L546.438 -17.865L546.152 -18.1291L546.093 -18.1969L546.08 -18.1858C545.995 -18.2192 545.856 -18.289 545.699 -18.4038C545.738 -18.4371 545.802 -18.4924 545.891 -18.5453L545.967 -18.587L545.999 -18.6147C546.055 -18.6276 545.923 -18.5853 546.124 -18.6638L547.66 -19.3245C549.706 -20.224 551.69 -21.272 553.622 -22.4058C557.474 -24.6993 561.024 -27.4687 564.189 -30.5123C570.569 -36.582 575.119 -43.8643 578.252 -50.5296C578.645 -51.368 579.024 -52.1831 579.397 -52.9927C579.782 -53.7886 580.044 -54.6218 580.367 -55.4117C580.671 -56.2096 580.968 -56.9774 581.259 -57.7396C581.549 -58.4895 581.839 -59.2271 582.048 -59.9666C582.944 -62.857 583.728 -65.4 584.382 -67.5108C584.702 -68.5361 584.98 -69.4542 585.229 -70.2516C585.472 -71.0558 585.691 -71.7325 585.911 -72.2669C586.326 -73.3505 586.553 -73.9274 586.553 -73.9274C586.553 -73.9274 586.913 -74.8805 587.564 -76.5958C587.883 -77.4541 588.4 -78.447 588.93 -79.6302C589.472 -80.7999 590.059 -82.1629 590.87 -83.5528C591.663 -84.9629 592.457 -86.5524 593.54 -88.094C594.06 -88.8762 594.582 -89.7077 595.141 -90.5355C595.755 -91.3268 596.369 -92.1428 597.015 -92.9741C599.646 -96.2451 602.871 -99.5547 606.768 -102.326C607.258 -102.666 607.748 -103.018 608.238 -103.358C608.746 -103.69 609.277 -103.983 609.791 -104.296C610.813 -104.953 611.929 -105.476 613.021 -106.04C613.565 -106.331 614.148 -106.538 614.715 -106.789C615.281 -107.041 615.854 -107.274 616.443 -107.474C617.032 -107.674 617.605 -107.919 618.211 -108.074L619.106 -108.335L619.556 -108.463L619.693 -108.499L619.768 -108.516L620.049 -108.58C620.049 -108.58 620.15 -108.619 620.186 -108.591L620.287 -108.5L621.186 -107.636C622.186 -106.681 623.185 -105.726 624.185 -104.771C626.179 -102.867 628.149 -100.979 630.09 -99.1241C637.845 -91.7125 645.023 -84.8481 650.362 -79.7354L660.058 -70.4692L664.909 -65.8388L666.201 -64.6006L666.528 -64.289L666.688 -64.1304L666.765 -64.0422C666.765 -64.0422 666.868 -63.9885 666.806 -63.9824C666.538 -63.9169 666.275 -63.8569 666.012 -63.7723C665.881 -63.73 665.75 -63.7 665.624 -63.6509L664.364 -63.2159C662.387 -62.495 660.461 -61.6636 658.599 -60.7207C649.837 -56.2783 643.471 -50.1019 638.705 -43.7384C637.605 -42.0749 636.447 -40.4915 635.471 -38.8401C634.998 -38.0036 634.537 -37.1659 634.071 -36.3472C633.629 -35.5137 633.115 -34.7247 632.758 -33.8579C631.991 -32.1606 631.199 -30.4904 630.488 -28.8183C629.869 -27.1061 629.256 -25.4116 628.649 -23.7227L628.636 -23.6993Z"
          fill="#ffffff7d"
        />
        <path
          d="M802.514 -15.3488C802.255 -15.1958 802.007 -15.0415 801.766 -14.8928C801.549 -14.7169 801.338 -14.5466 801.127 -14.3886C800.718 -14.059 800.353 -13.7435 800.025 -13.4366C799.347 -12.8622 798.925 -12.2246 798.577 -11.7341C797.906 -10.726 797.767 -10.0473 798.052 -9.74631C798.336 -9.44528 799.049 -9.50277 800.095 -9.96575C801.122 -10.4491 802.552 -11.2442 804.398 -12.2444C807.021 -13.6544 809.918 -14.5046 812.946 -14.4571C815.968 -14.4287 819.104 -13.5352 822.187 -11.9667C825.284 -10.4215 828.323 -8.208 831.307 -5.57939C832.074 -4.95732 832.799 -4.24042 833.549 -3.53337C834.3 -2.82631 835.056 -2.12481 835.791 -1.34509C836.533 -0.583212 837.281 0.197792 838.04 0.980018C838.811 1.80046 839.581 2.63321 840.369 3.474C843.542 6.79592 846.33 9.71378 847.249 10.6669C848.471 9.50436 849.642 8.37379 850.774 7.30107C851.45 6.64598 852.094 6.01856 852.712 5.41328C853.832 4.31467 854.857 3.29906 855.829 2.34008C857.762 0.420855 859.456 -1.25662 861.061 -2.85659C864.282 -6.05529 867.225 -8.94207 871.324 -12.7568C875.09 -16.259 879.375 -20.2465 884.651 -25.148C882.323 -27.679 879.919 -30.2858 877.485 -32.9266C875.549 -35.0343 873.595 -37.1748 871.641 -39.3029C867.678 -43.5833 863.565 -47.6625 859.562 -51.2419C855.558 -54.8213 851.676 -57.875 848.315 -60.2386C844.955 -62.6023 842.135 -64.2555 840.376 -65.2443C839.082 -65.9817 837.73 -66.6323 836.371 -67.2651C833.928 -68.3171 829.349 -70.353 822.893 -71.5648C819.678 -72.1633 815.995 -72.5248 812.042 -72.3075C808.089 -72.1025 803.883 -71.3108 799.735 -69.8205C795.57 -68.3505 791.529 -66.1318 787.746 -63.4108C783.945 -60.6977 780.444 -57.4717 777.195 -53.88C770.655 -46.7565 765.856 -37.4398 764.192 -27.6812C763.028 -20.7913 763.322 -14.3287 764.311 -8.68015C764.594 -7.27211 764.866 -5.90225 765.14 -4.56938C765.488 -3.25365 765.832 -1.98167 766.159 -0.742359C766.511 0.487134 766.934 1.65575 767.302 2.80025C767.423 3.15895 767.539 3.51087 767.654 3.87511C767.737 4.10009 767.806 4.38541 767.92 4.61967L768.477 5.20816C768.928 5.68685 769.367 6.15197 769.793 6.61584C775.826 13.0424 780.259 17.7725 783.306 21.0136C786.845 24.7562 790.171 28.2668 792.804 31.0452L796.812 27.9635C792.968 22.1179 790.866 16.1831 790.764 10.6122C790.693 5.05057 792.433 -0.0427144 795.383 -4.31432C796.459 -5.86269 797.251 -7.08128 797.725 -7.95475C798.188 -8.84177 798.288 -9.47491 798.039 -9.73523C797.797 -10.0134 797.199 -9.92557 796.276 -9.41314C795.334 -8.90874 794.131 -7.90512 792.817 -6.30657C789.226 -1.90838 786.78 3.80608 786.583 10.3363C786.404 16.8746 788.698 23.8804 792.878 30.4219L796.178 27.8806C793.571 25.0801 790.284 21.5362 786.776 17.7659C783.985 14.792 779.805 10.0814 774.28 3.91675C773.937 3.52322 773.582 3.14077 773.227 2.74599C773.05 2.54245 772.878 2.34568 772.695 2.14767L772.63 2.07304L772.618 2.05946L772.6 2.03911L772.571 1.99286C772.56 1.95465 772.567 1.94911 772.518 1.78949C772.441 1.53434 772.365 1.2792 772.289 1.02406C772.137 0.513761 771.972 -0.0101045 771.808 -0.533968C771.455 -1.5842 771.234 -2.67674 770.945 -3.79464C770.807 -4.35297 770.663 -4.91808 770.525 -5.48873C770.419 -6.06241 770.313 -6.64842 770.207 -7.23442C769.321 -11.9262 768.883 -17.1107 769.375 -22.5409C769.472 -24.3248 769.82 -26.0523 770.071 -27.802C770.242 -28.663 770.468 -29.5122 770.651 -30.3719C770.755 -30.7943 770.822 -31.2329 770.95 -31.6528L771.335 -32.9003C771.471 -33.3504 771.606 -33.8006 771.749 -34.2562L771.962 -34.9397L772.224 -35.6059C772.582 -36.4974 772.933 -37.3957 773.292 -38.2995C774.16 -40.036 774.986 -41.8201 776.062 -43.4861C778.128 -46.8639 780.613 -50.0569 783.448 -52.8742C789.006 -58.6378 795.609 -63.0458 802.047 -65.2314C805.252 -66.3473 808.392 -66.944 811.234 -67.1876C814.082 -67.4243 816.641 -67.2573 818.754 -67.0615C819.804 -66.8992 820.758 -66.7838 821.581 -66.6385C822.402 -66.4685 823.107 -66.3166 823.677 -66.203C824.816 -65.9266 825.433 -65.7464 825.433 -65.7464C828.131 -65.0335 830.795 -64.0889 833.388 -62.9289C835.995 -61.8046 838.531 -60.4647 841.007 -59.0135C845.958 -56.074 850.673 -52.6574 855.132 -48.8895C859.598 -45.1271 863.848 -41.0711 867.917 -36.8233C869.947 -34.7246 871.99 -32.507 874.023 -30.3522L878.557 -25.5191L865.83 -13.5742L847.266 3.86467L843.846 0.220832C840.742 -3.12502 837.56 -6.39212 834.303 -9.15357C831.04 -11.9341 827.625 -14.3342 823.966 -16.0355C820.332 -17.7465 816.415 -18.7378 812.637 -18.577C808.86 -18.4407 805.395 -17.1595 802.52 -15.342L802.514 -15.3488Z"
          fill="#ffffff7d"
        />
        <path
          d="M896.677 56.1783C892.472 50.562 890.102 52.1214 893.806 58.0641C895.803 61.2605 897.854 64.5057 900.088 67.9488C901.212 69.6648 902.371 71.4339 903.575 73.2819C904.187 74.2037 904.811 75.1392 905.446 76.1005C906.384 77.5009 907.347 78.9283 908.332 80.3953C911.16 80.1752 914.652 79.9049 918.331 79.6164C932.903 78.2748 936.445 77.3663 946.338 76.6075C950.283 76.2781 954.866 75.9453 959.665 75.6159C965.171 75.2469 970.917 74.8714 976.416 74.5079C976.371 72.4312 976.331 70.3736 976.289 68.3653C976.274 67.0586 976.264 65.7834 976.24 64.5439C976.211 62.0606 976.188 59.7265 976.168 57.6153C976.136 53.3874 976.104 50.0627 976.097 48.2497C976.089 47.2344 976.062 46.2112 976.011 45.1854C975.941 43.7247 975.824 41.2696 975.624 37.068C975.434 32.4407 975.156 25.8808 974.762 16.5443C973.11 15.8322 970.49 14.7066 967.178 13.2881C964.633 12.1823 961.564 10.8503 958.168 9.37371C951.382 6.40262 943.322 2.83217 935.648 -0.631174L920.59 -7.28702L908.681 15.5899C902.014 28.4344 897.278 38.1719 892.865 47.868C890.442 53.195 892.708 54.4827 895.67 49.4639C901.067 40.3317 906.334 30.8955 913.044 18.0739C914.017 16.1995 915.482 13.6143 917.4 10.2338C918.352 8.54299 919.419 6.64715 920.598 4.55866C921.185 3.50486 921.798 2.40427 922.445 1.25138C922.605 0.958381 922.771 0.672173 922.931 0.379174L923.158 -0.0307828L923.19 -0.0584499C923.229 -0.0916589 923.261 -0.119349 923.287 -0.141488C923.328 -0.0939942 923.37 -0.0588179 923.393 -0.031678C923.411 -0.011323 923.369 -0.0341659 923.447 0.00475372C923.636 0.0918888 923.83 0.185811 924.036 0.280978C924.431 0.463279 924.843 0.653604 925.268 0.857508C926.961 1.62938 928.843 2.48842 930.798 3.37956C933.366 4.53711 935.962 5.63551 938.548 6.65879C943.946 8.79622 949.698 11.1738 955.309 13.5432C960.426 15.7326 965.434 17.8738 969.858 19.7702C969.896 20.677 969.934 21.5592 969.968 22.3977C970.02 23.708 970.068 24.9623 970.113 26.1483C970.196 28.5133 970.271 30.6117 970.325 32.349C970.431 35.8235 970.496 37.8836 970.496 37.8836L971.644 70.2257L943.162 72.5864C928.788 73.781 921.87 74.3593 917.621 74.7136C916.076 74.8475 914.562 74.9783 913.141 75.1001C912.433 75.1644 911.745 75.2244 911.087 75.2813C910.882 75.3038 910.689 75.3275 910.509 75.3525C908 71.8258 905.724 68.6321 903.589 65.6259C901.183 62.2952 898.91 59.1945 896.652 56.1758L896.677 56.1783Z"
          fill="#ffffff7d"
        />
        <path
          d="M597.353 122.644C597.321 122.504 597.289 122.377 597.257 122.251C597.244 122.119 597.225 121.994 597.217 121.869C597.19 121.619 597.145 121.373 597.13 121.137C597.142 120.674 597.08 120.228 597.152 119.834C597.166 119.631 597.174 119.434 597.188 119.244C597.226 119.056 597.252 118.879 597.284 118.709C597.309 118.532 597.335 118.368 597.36 118.203C597.403 118.047 597.44 117.896 597.477 117.758C597.581 117.168 597.711 116.711 597.738 116.355C597.759 115.992 597.695 115.726 597.534 115.592C597.372 115.458 597.126 115.446 596.773 115.595C596.421 115.745 595.946 116.025 595.478 116.584C595.361 116.72 595.232 116.868 595.101 117.028C594.983 117.201 594.877 117.388 594.763 117.593C594.65 117.798 594.536 118.016 594.409 118.244C594.325 118.495 594.234 118.752 594.142 119.021C593.929 119.562 593.872 120.194 593.777 120.871C593.751 121.214 593.773 121.563 593.777 121.928C593.782 122.114 593.793 122.295 593.804 122.488C593.833 122.676 593.863 122.865 593.892 123.053C594.23 125.234 595.114 127.216 596.16 129.023C597.211 130.85 598.507 132.441 599.847 134.006C600.54 134.763 601.226 135.537 601.969 136.25C602.694 136.991 603.45 137.693 604.214 138.389C606.437 140.427 606.357 139.961 606.372 140.365L606.178 140.568L606.075 140.656L606.036 140.714L605.816 140.964C605.166 141.727 604.511 142.495 603.849 143.269C602.53 144.824 601.174 146.412 599.79 148.047C597.036 151.318 594.151 154.761 591.092 158.39C591.039 158.459 590.987 158.528 590.935 158.597C590.893 158.704 590.821 158.647 590.749 158.603L590.647 158.537L590.593 158.501L590.436 158.386C589.963 158.022 589.507 157.667 589.058 157.318C587.267 155.881 585.586 154.492 584.085 153.232C581.089 150.744 578.706 148.523 576.579 146.378C574.459 144.226 572.571 142.148 570.769 139.794C568.966 137.44 567.199 134.818 565.521 131.524C562.672 126.008 560.589 118.832 561.413 111.629C561.8 108.05 562.864 104.515 564.515 101.318C566.136 98.0866 568.312 95.2209 570.74 92.6593C573.15 90.1019 575.761 87.9422 578.437 86.2963C581.107 84.6437 583.83 83.5037 586.402 82.7565C591.556 81.2879 595.987 81.181 598.452 81.0971L600.716 81.0547C601.478 81.0269 602.303 80.9683 603.053 80.9146C604.356 80.8117 606.189 80.7257 608.761 80.4177C610.041 80.2631 611.534 80.0435 613.228 79.603C614.909 79.149 616.873 78.4514 618.766 77.0539C619.721 76.3715 620.591 75.5134 621.386 74.5055C622.193 73.4988 622.881 72.2388 623.361 70.7906C623.792 69.3127 623.914 67.6613 623.715 66.0144C623.472 64.3815 622.937 62.7994 622.218 61.3039C620.749 58.3528 618.641 55.7513 616.232 53.2677C615.021 52.0314 613.715 50.8289 612.342 49.6379C611.762 49.14 611.17 48.6408 610.573 48.1224L610.369 47.9657C610.369 47.9657 610.416 47.89 610.436 47.8487L610.482 47.773L610.521 47.7398C610.599 47.6241 610.684 47.5152 610.775 47.4007C611.634 46.3621 612.616 45.1567 613.715 43.8271C615.919 41.1622 618.572 37.9553 621.498 34.4174C622.727 32.9401 624.007 31.3938 625.333 29.8089C625.422 29.5891 625.576 29.7655 625.738 29.8748C626.158 30.2019 626.583 30.5357 627.002 30.8752C627.517 31.2985 628.032 31.7218 628.546 32.1452C629.586 33.0301 630.626 33.915 631.678 34.8134C632.686 35.726 633.732 36.5931 634.714 37.5401C636.729 39.3775 638.622 41.3325 640.459 43.3003C645.38 48.6552 649.092 54.0792 651.459 59.2862C653.851 64.4957 654.862 69.4353 654.88 73.7235C654.892 75.8649 654.675 77.847 654.323 79.6607C653.941 81.4651 653.442 83.0968 652.881 84.5677C651.724 87.4934 650.34 89.759 649.124 91.5222C647.674 93.5955 646.045 95.5022 644.343 97.1975C642.666 98.92 640.881 100.39 639.03 101.668C635.34 104.226 631.36 105.869 627.289 106.841C625.265 107.354 623.199 107.676 621.149 107.925C619.098 108.187 617.04 108.3 614.925 108.475C612.828 108.658 610.774 108.827 608.673 109.096C606.585 109.367 604.46 109.764 602.383 110.511C600.137 111.335 598.693 112.617 597.997 113.623C597.631 114.118 597.458 114.564 597.377 114.896C597.301 115.235 597.335 115.455 597.46 115.585L597.512 115.98C597.512 115.98 597.581 115.956 597.564 115.911L597.502 115.62L597.525 115.647C597.676 115.743 597.911 115.754 598.223 115.675C598.529 115.588 598.908 115.404 599.386 115.193C600.338 114.739 601.633 114.085 603.535 113.523C607.106 112.519 611.21 112.552 615.366 112.373C619.512 112.287 623.989 112.141 628.498 111.183C633.018 110.262 637.627 108.515 641.847 105.69C643.957 104.284 645.989 102.659 647.859 100.771C649.752 98.9093 651.542 96.8519 653.182 94.5195C654.443 92.7053 655.981 90.3192 657.364 87.1505C658.723 83.9916 659.911 80.0051 660.141 75.2657C660.376 70.5454 659.595 65.1096 657.494 59.5894C655.399 54.0636 652.045 48.509 647.728 43.203C644.913 39.7504 641.795 36.5825 638.53 33.709C637.82 33.0617 637.079 32.4421 636.337 31.8226C635.59 31.1962 634.849 30.5643 634.106 29.9694C632.622 28.7549 631.102 27.512 629.495 26.285L627.85 25.0666C627.117 24.5468 626.382 24.064 625.654 23.5757L624.552 22.8515L624.414 22.7571C624.414 22.7571 624.372 22.7096 624.347 22.7194L624.289 22.7692L624.088 23.0147L623.679 23.4866C623.134 24.1117 622.583 24.7423 622.055 25.4124C620.76 27.0067 619.471 28.6077 618.182 30.1965C615.865 33.054 613.555 35.8936 611.31 38.6533C608.565 41.9869 605.898 45.2419 603.342 48.3411C604.974 49.7252 606.582 51.0945 608.154 52.4355C609.17 53.2932 610.065 54.0892 610.977 54.9178C612.759 56.5646 614.335 58.2585 615.621 59.9415C616.907 61.6245 617.87 63.3243 618.363 64.8836C618.862 66.4497 618.875 67.8302 618.525 68.9884C618.181 70.1412 617.474 71.0962 616.739 71.8504C616.004 72.5923 615.273 73.0933 614.621 73.4539C614.292 73.6309 613.978 73.7598 613.725 73.895C613.449 74.003 613.21 74.0901 613.022 74.1576C612.639 74.2981 612.427 74.3508 612.427 74.3508C612.427 74.3508 611.579 74.6668 609.824 74.9587C608.074 75.2574 605.4 75.4871 601.98 75.6718C600.33 75.8013 598.451 75.7838 596.367 75.9311C594.302 76.0864 592.087 76.276 589.776 76.7156C587.47 77.1496 585.078 77.7542 582.68 78.6366C580.293 79.5449 577.933 80.7279 575.674 82.1563C573.397 83.5767 571.322 85.333 569.336 87.2035C568.858 87.687 568.369 88.1693 567.892 88.6528C567.408 89.1418 566.979 89.6673 566.519 90.1835C565.606 91.198 564.733 92.2847 563.915 93.4077C560.623 97.892 558.255 103.218 557.363 108.744C556.428 114.259 557.006 119.823 558.369 124.637C559.73 129.476 561.814 133.597 563.8 136.922C566.849 141.92 570.097 145.843 573.095 149.055C576.105 152.267 578.87 154.824 581.332 156.942C583.751 159.025 585.795 160.778 587.707 162.253C588.445 162.816 589.25 163.405 589.984 163.888C590.358 164.136 590.719 164.371 591.08 164.605C591.261 164.723 591.442 164.84 591.617 164.951L591.882 165.126C591.935 165.187 591.957 165.096 591.989 165.069L592.086 164.961C592.604 164.383 593.102 163.846 593.576 163.294C594.044 162.735 594.492 162.193 594.921 161.68C597.951 158.016 600.812 154.559 603.531 151.259C604.884 149.603 606.205 147.986 607.499 146.405C608.144 145.61 608.781 144.834 609.413 144.05C609.894 143.456 610.375 142.874 610.856 142.292C611.408 141.649 611.811 141.028 612.269 140.406L612.603 139.939L612.773 139.709L612.812 139.651C612.812 139.651 612.777 139.611 612.759 139.603L612.639 139.504L611.681 138.726C611.053 138.223 610.43 137.715 609.72 137.247C609.045 136.795 608.197 136.22 607.987 136.057C607.807 135.927 607.663 135.813 607.49 135.666L606.94 135.19C606.199 134.558 605.47 133.939 604.786 133.282C604.076 132.647 603.423 131.975 602.77 131.315C600.231 128.657 598.02 125.705 597.34 122.642L597.353 122.644Z"
          fill="#ffffff7d"
        />
        <path
          d="M905.025 104.617C908.268 104.859 910.596 104.322 912.04 103.776C913.485 103.218 914.096 102.63 913.988 102.248C913.875 101.834 913.048 101.633 911.568 101.532C910.088 101.432 907.949 101.437 905.199 101.09C901.301 100.546 897.6 98.8219 894.302 96.1306C890.979 93.4615 888.092 90.1067 886.444 86.0736C885.591 84.0759 885.092 81.9036 884.855 79.659C884.811 79.3762 884.81 79.0916 884.791 78.8113L884.765 78.3819C884.753 78.2137 884.742 78.1755 884.744 77.8293L884.721 76.1259L884.719 75.699L884.715 75.4883L884.714 75.383C884.714 75.383 884.66 75.3342 884.63 75.3126L883.93 74.7405C882.703 73.7315 881.458 72.7146 880.202 71.684C876.043 68.2867 871.686 64.7148 867.066 60.9429C856.534 52.4702 849.863 47.284 844.067 42.7681C841.173 40.5013 838.494 38.4047 835.636 36.1662C834.216 35.0387 832.755 33.8637 831.198 32.6293C829.498 31.2445 827.702 29.7881 825.745 28.1977C825.123 27.6892 824.488 27.1794 823.86 26.6641C823.543 26.4031 823.219 26.1476 822.902 25.8866L822.417 25.4971C822.26 25.3947 822.069 25.0968 822.006 25.4122C821.299 26.8311 820.573 28.2789 819.833 29.7502C819.557 30.3098 819.268 30.8681 818.986 31.4332C818.751 31.8856 818.534 32.3461 818.317 32.8189C817.877 33.7577 817.437 34.7089 816.996 35.6723C816.089 37.5967 815.284 39.6241 814.409 41.6632C813.632 43.7491 812.757 45.8252 812.043 48.0104C809.022 56.6477 806.809 66.0723 806.012 75.2136C805.771 77.4901 805.691 79.7582 805.607 81.9703C805.61 84.1911 805.553 86.3687 805.702 88.4868C805.864 92.7217 806.395 96.6971 807.016 100.273C808.309 107.431 810.225 112.92 811.332 115.958C812.064 117.727 812.733 119.527 813.615 121.25C815.072 124.354 818.013 130.052 823.031 136.821C827.985 143.621 835.198 151.311 844.23 158.5C848.74 162.081 853.705 165.603 859.117 168.75C864.529 171.885 870.381 174.712 876.587 176.734C882.775 178.759 889.26 180.148 895.734 180.582C902.208 181.041 908.645 180.711 914.787 179.757C923.446 178.304 930.974 175.938 937.461 173.318C943.967 170.694 949.526 167.937 954.295 165.291C959.059 162.639 963.103 160.191 966.488 157.981C968.177 156.878 969.745 155.88 971.126 154.913C972.385 154.051 973.587 153.227 974.726 152.446C975.311 152.047 975.883 151.648 976.443 151.272C976.723 151.077 976.99 150.894 977.263 150.705L977.365 150.641L977.41 150.603C977.41 150.603 977.386 150.576 977.374 150.562L977.177 150.4L976.782 150.075C970.586 145.073 964.791 140.39 959.289 135.941C954.569 132.184 950.114 128.627 945.831 125.217C937.241 118.42 929.312 112.24 921.415 106.175C917.23 102.954 914.707 101.746 914.2 102.195L913.841 102.66C913.927 102.669 913.953 102.634 913.926 102.551L914.115 102.304C913.794 102.902 915.515 105.137 919.53 108.588C927.094 115.083 934.763 121.583 943.177 128.603C947.401 132.1 951.791 135.737 956.439 139.592C960.436 142.868 964.655 146.321 969.155 150.006C969.179 150.033 969.252 150.065 969.232 150.094L969.118 150.169C969.041 150.223 968.959 150.271 968.882 150.325C968.724 150.426 968.559 150.533 968.375 150.644C967.752 151.051 967.091 151.492 966.405 151.941C965.67 152.399 964.908 152.878 964.109 153.378C963.31 153.879 962.473 154.388 961.61 154.931C960.73 155.442 959.817 155.98 958.867 156.539C956.991 157.672 954.913 158.766 952.724 159.979C948.308 162.308 943.298 164.781 937.627 167.1C931.95 169.413 925.605 171.565 918.574 173.109C913.99 174.085 909.349 174.789 904.705 175.128C899.688 175.491 894.42 175.333 889.129 174.53C883.844 173.734 878.535 172.305 873.465 170.324C863.295 166.354 854.154 160.317 846.718 154.33C843.019 151.319 839.715 148.337 836.93 145.512C836.209 144.826 835.584 144.095 834.931 143.422C834.297 142.733 833.655 142.099 833.101 141.437C831.986 140.105 830.883 138.942 830.009 137.783C828.172 135.531 826.851 133.64 825.932 132.353C825.464 131.712 825.157 131.192 824.924 130.846C824.703 130.502 824.58 130.323 824.58 130.323C824.58 130.323 824.406 130.058 824.074 129.548C823.736 129.043 823.247 128.301 822.669 127.302C822.097 126.31 821.329 125.131 820.59 123.677C820.205 122.964 819.797 122.199 819.366 121.382C818.973 120.556 818.557 119.679 818.113 118.756C816.414 115.064 814.643 110.554 813.269 105.417C811.882 100.291 810.891 94.537 810.529 88.5129C810.162 82.482 810.418 76.1866 811.288 69.9782C812.158 63.7699 813.624 57.653 815.434 51.9049C817.238 46.1501 819.429 40.7747 821.671 35.9489C821.95 35.34 822.221 34.749 822.492 34.158C822.755 33.6342 823.011 33.1159 823.267 32.5975C823.341 32.4504 823.415 32.3033 823.489 32.1562L823.597 31.9321L823.65 31.8262C823.65 31.8262 823.717 31.8639 823.741 31.8787C825.04 32.9321 826.255 33.9276 827.38 34.8335C848.06 51.6349 858.015 59.715 864.132 64.678C868.772 68.4209 873.16 71.9652 877.333 75.339C878.195 76.0327 879.058 76.714 879.896 77.3929L880.01 77.4849C880.039 77.5188 880.024 77.5914 880.028 77.6352L880.046 77.9648L880.114 78.8809C880.149 79.2186 880.154 79.5592 880.209 79.8926C880.539 82.5796 881.21 85.2332 882.305 87.6638C883.393 90.0999 884.804 92.34 886.476 94.2724C888.134 96.2159 889.983 97.8881 891.927 99.3472C893.878 100.801 895.972 102.059 898.199 102.953C900.419 103.852 902.739 104.416 905.025 104.617Z"
          fill="#ffffff7d"
        />
        <path
          d="M750.918 46.3522C758.573 45.1128 758.048 42.2019 750.288 42.8307C744.785 43.2804 739.151 43.7848 733.048 44.4087C730.025 44.6895 726.768 45.1259 723.389 45.6428C721.713 45.9736 719.993 46.3063 718.229 46.653C716.491 47.1076 714.704 47.5695 712.867 48.051C704.656 50.6382 699.911 53.2864 696.03 55.8305C695.542 56.1458 695.048 56.4297 694.589 56.7666C694.13 57.1036 693.684 57.4294 693.232 57.7608C692.779 58.0922 692.333 58.418 691.881 58.7494C691.422 59.074 690.976 59.4122 690.546 59.7953C689.669 60.529 688.754 61.2836 687.788 62.0824C686.875 62.9423 685.905 63.852 684.851 64.846C681.414 68.3136 677.817 72.8473 674.903 78.0873C674.182 79.3997 673.527 80.762 672.822 82.1193L671.901 84.2464L671.143 86.0189L670.767 86.9146L670.671 87.14C670.637 87.2169 670.752 87.2719 670.787 87.3373L671.117 87.7172C673.189 90.148 673.774 90.9743 674.941 92.2247C675.48 92.8052 676.025 93.3924 676.558 93.9661L677.364 94.8272L678.215 95.6373C682.663 100.01 687.456 103.478 691.623 105.93C693.74 107.085 695.626 108.154 697.297 108.862C698.123 109.243 698.869 109.585 699.537 109.887C700.213 110.148 700.803 110.375 701.296 110.567C702.473 110.989 703.633 111.485 704.839 111.786C705.916 112.056 707.431 112.507 709.355 112.95C711.288 113.301 713.602 113.869 716.25 114.138C721.545 114.843 728.159 115.205 735.372 114.644C738.976 114.348 742.752 113.939 746.495 113.441C750.273 112.971 754.175 112.489 758.128 111.999C766.026 111.025 774.134 110.061 781.929 109.176L790.783 108.101L783.832 68.3848C782.917 63.2076 782.054 58.4253 781.215 53.9548C780.206 48.6567 779.256 43.7234 778.358 39.0427C777.183 39.2018 776.013 39.3677 774.857 39.5225C774.285 39.6005 773.725 39.6798 773.16 39.7522L772.158 39.9042C770.883 40.1025 769.638 40.2979 768.4 40.4877C765.929 40.8864 763.533 41.2802 761.131 41.6673C757.912 42.2004 756.344 43.068 756.371 43.7574L756.162 43.8785C756.178 43.9604 756.232 43.9968 756.313 43.9865L756.401 43.9336C756.615 44.6048 758.421 45.054 761.689 44.8105C764.121 44.612 766.559 44.4202 769.065 44.2168C770.318 44.109 771.578 43.9956 772.862 43.8848L773.799 43.8005L774.196 43.7789C774.444 43.7669 774.692 43.755 774.946 43.7375C774.986 44.1188 775.032 44.507 775.072 44.9007C775.222 45.9118 775.385 46.9365 775.54 47.9791C775.876 50.079 776.214 52.2473 776.568 54.4852C777.295 58.9692 778.096 63.7575 778.999 68.9335C779.54 72.0563 780.214 76.7884 781.124 83.0166C781.591 86.1319 782.111 89.6175 782.684 93.4612C782.99 95.3849 783.297 97.4016 783.627 99.4947C783.8 100.545 783.967 101.614 784.139 102.714L784.174 102.921L784.194 103.022C784.194 103.022 784.194 103.022 784.2 103.029L784.188 103.04L784.175 103.051C784.156 103.043 784.138 103.035 784.145 103.03L781.976 103.286L779.639 103.593C778.085 103.806 776.53 104.032 774.993 104.278C768.347 105.323 761.182 106.353 754.181 107.312C747.181 108.247 740.314 109.257 734.418 109.667C732.925 109.732 731.488 109.796 730.119 109.861C728.746 109.883 727.424 109.835 726.182 109.827C725.558 109.819 724.952 109.807 724.371 109.798C723.792 109.751 723.225 109.706 722.683 109.663C721.598 109.578 720.593 109.507 719.687 109.434C717.878 109.225 716.441 108.98 715.451 108.849C714.467 108.724 713.94 108.597 713.94 108.597C713.94 108.597 713.149 108.436 711.726 108.143C711.016 107.972 710.136 107.864 709.147 107.566C708.156 107.292 707.019 106.979 705.772 106.63C704.533 106.238 703.205 105.732 701.766 105.24C700.341 104.699 698.861 104.005 697.293 103.338C696.53 102.939 695.755 102.539 694.955 102.124C694.562 101.917 694.156 101.709 693.75 101.5C693.345 101.28 692.966 101.025 692.561 100.792C691.765 100.303 690.956 99.8127 690.129 99.3144C689.342 98.7582 688.542 98.2008 687.731 97.6298C684.548 95.2904 681.374 92.6116 678.556 89.5299C677.819 88.7994 677.14 88.0068 676.468 87.2087L676.019 86.6931C675.99 86.6345 675.9 86.582 675.902 86.5204L675.984 86.3308C676.272 85.6425 676.553 84.9597 676.834 84.2769C677.253 83.404 677.677 82.5379 678.096 81.6773C681.496 74.8288 686.134 69.4791 689.985 66.0103C690.674 65.3195 691.439 64.7539 692.155 64.1709C692.877 63.607 693.538 63.0123 694.25 62.5279C694.956 62.0367 695.643 61.5744 696.305 61.1097C696.635 60.8835 696.96 60.6628 697.278 60.4353C697.602 60.2269 697.937 60.0445 698.266 59.8552C698.912 59.4754 699.539 59.1123 700.141 58.7589C700.736 58.3988 701.319 58.062 701.917 57.7949C703.091 57.2213 704.169 56.6937 705.173 56.1955C706.216 55.7695 707.166 55.3772 708.059 55.0101C708.945 54.6486 709.751 54.2974 710.546 54.0626C712.1 53.5523 713.403 53.1156 714.525 52.7408C716.263 52.2739 717.957 51.8211 719.607 51.3824C721.285 51.0269 722.919 50.6855 724.521 50.3472C727.753 49.7907 730.809 49.2906 733.861 48.889C739.924 48.0384 745.498 47.1939 750.919 46.3153L750.918 46.3522Z"
          fill="#ffffff7d"
        />
        <path
          d="M737.982 -30.5396C732.593 -21.759 735.084 -20.0835 740.952 -28.4568C749.352 -40.2903 758.232 -52.6566 770.032 -68.2584C772.641 -71.7481 774.923 -74.8132 775.687 -75.8304C774.881 -77.2978 774.104 -78.7065 773.355 -80.069C772.865 -80.9414 772.399 -81.7866 771.937 -82.6005C771.02 -84.2213 770.178 -85.7294 769.382 -87.1339C767.784 -89.9496 766.388 -92.417 765.049 -94.7672C762.377 -99.4733 759.978 -103.75 756.841 -109.622C754.559 -113.881 752.054 -118.576 748.766 -124.711C746.283 -121.568 743.683 -118.287 741.024 -114.933C739.035 -112.394 737 -109.793 734.96 -107.198C730.902 -101.981 726.88 -96.7112 723.186 -91.7852C715.782 -81.9413 709.725 -73.4883 707.149 -69.8716C706.263 -68.6192 705.384 -67.3601 704.534 -66.0671C701.497 -61.4703 693.327 -49.0876 683.61 -33.1569C673.857 -17.2423 662.64 2.27826 652.745 20.6217L648.111 29.3675L703.445 35.6948L705.577 31.7609C716.267 12.1249 724.631 -2.31629 732.934 -16.4668C737.533 -24.208 735.393 -25.7118 730.256 -18.2788C720.982 -4.71547 712.04 9.48774 701.254 29.2067C701.107 29.4763 700.947 29.7693 700.574 30.4365C696.645 29.8955 690.711 29.0892 683.012 28.0357C678.849 27.4833 674.212 26.8642 669.126 26.1934C666.586 25.8675 663.935 25.5304 661.173 25.182C659.899 25.0219 658.595 24.8647 657.266 24.6928C657.254 24.6792 657.249 24.6724 657.249 24.6601C657.249 24.6601 657.268 24.6435 657.281 24.6324C657.3 24.6158 657.307 24.598 657.314 24.5801L658.634 22.0606C659.587 20.2151 660.54 18.3697 661.48 16.5352C669.558 0.629919 679.733 -17.1593 688.132 -30.7743C692.323 -37.592 696.033 -43.3885 698.697 -47.4849C701.385 -51.5665 702.973 -53.9723 702.973 -53.9723C710.404 -65.23 718.082 -76.3204 725.964 -87.254C729.908 -92.7174 733.912 -98.1376 737.97 -103.509L744.095 -111.547L748.245 -116.89L755.104 -104.151L769.991 -76.5323L766.066 -71.3824C754.237 -55.6723 745.682 -42.9328 737.982 -30.5396Z"
          fill="#ffffff7d"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3622_1083">
        <rect width="1003" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_3622_1083">
        <rect
          width="3757.37"
          height="4501.65"
          fill="white"
          transform="matrix(0.17533 -0.151453 0.135277 0.155367 247.785 7.06543)"
        />
      </clipPath>
    </defs>
  </svg>`;
const $f2f805f49af46a8b$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$8f97e278a4a2a6b3$require$Buffer.from($f2f805f49af46a8b$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground).toString("base64")}`;
const $f2f805f49af46a8b$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf = ({ ...props })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$0fd79bc510e2fa30$var$defaultButtonStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
            appearance: "default",
            ...props
        })
    });
};
const $f2f805f49af46a8b$var$$0fd79bc510e2fa30$var$defaultButtonStyles = (0, $dnfL5.css)({
    "& button": {
        borderRadius: "4px",
        border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
        backgroundColor: `transparent`
    }
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$export$2c3faa04d4773275 = ({ lessons: lessons, onLessonClick: onLessonClick, expandButtonText: expandButtonText = "Show lessons", collapseButtonText: collapseButtonText = "Hide lessons", containerStyles: customContainerStyles, buttonContainerStyles: customButtonContainerStyles })=>{
    const [isOpened, setIsOpened] = (0, $acw62.useState)(false);
    const deviceSize = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const isTablet = deviceSize <= $f2f805f49af46a8b$export$62d1d6124a8e4649;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$7586a58445419b5a$var$wrapperStyles,
            customContainerStyles
        ],
        children: [
            !isTablet && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    customButtonContainerStyles
                ],
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                    css: $f2f805f49af46a8b$var$$7586a58445419b5a$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$7586a58445419b5a$var$lessonsContentWrapperStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerMobileStyles,
                    customButtonContainerStyles
                ],
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                    css: [
                        $f2f805f49af46a8b$var$$7586a58445419b5a$var$toggleButtonStyles,
                        $f2f805f49af46a8b$var$$7586a58445419b5a$var$toggleButtonMobileStyles
                    ],
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button-mobile",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$wrapperStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    maxWidth: "100%"
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`,
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$toggleButtonStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$toggleButtonMobileStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerOpenStyles = (0, $dnfL5.css)({
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$lessonsContentWrapperStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral")
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerClosedStyles = (0, $dnfL5.css)({
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$7586a58445419b5a$var$buttonContainerMobileStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
    }
});
const $f2f805f49af46a8b$var$$bde17c0708419ffe$var$CompletedIcon = ()=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M15.8203 7.04186L15.8028 7.03662L6.61914 16.5773L6.62525 16.5939L21.6161 21.8224L15.8203 7.04186Z",
                fill: "#1868DB"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.31618 3.19751L10.3213 7.04536L5.25684 6.23896L5.28564 4.75358L5.31618 3.19751Z",
                fill: "#FCA700"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M14.6344 9.49606H12.8924L11.1836 4.41504H12.9256L14.6344 9.49606Z",
                fill: "#BF63F3"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M9.40688 15.4488L9.37982 15.3764C9.22448 14.9662 8.95742 14.6153 8.60659 14.3631C8.24877 14.1057 7.82811 13.9695 7.39001 13.9695C6.9519 13.9695 6.53211 14.1057 6.17342 14.3631C5.82259 14.6153 5.55553 14.9662 5.40019 15.3764L5.37313 15.4488H3.82666L3.85808 15.3118C4.04397 14.5054 4.49255 13.774 5.12179 13.253C5.43684 12.9921 5.78855 12.7896 6.16644 12.6491C6.5583 12.5042 6.96935 12.4309 7.38913 12.4309C7.80891 12.4309 8.21997 12.5042 8.61182 12.6491C8.99059 12.7887 9.34142 12.9921 9.65648 13.253C10.2857 13.774 10.7352 14.5054 10.9202 15.3118L10.9516 15.4488H9.40513H9.40688Z",
                fill: "#1868DB"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M6.51602 10.2929C6.56926 10.2475 6.62075 10.1943 6.66962 10.1349C6.71849 10.0756 6.76126 10.0127 6.79617 9.94989C7.00126 9.58073 6.94017 9.19935 6.66787 8.89215C6.62162 8.83978 6.56926 8.78916 6.51078 8.74204C6.45231 8.69491 6.38773 8.64953 6.32402 8.61287C5.96707 8.40866 5.5822 8.42436 5.26278 8.69666C5.20867 8.74291 5.15631 8.79615 5.10657 8.85724C5.05769 8.91746 5.0158 8.97855 4.98177 9.03964C4.77755 9.40618 4.83951 9.78669 5.11093 10.0965C5.15893 10.1515 5.21304 10.2039 5.27413 10.2536C5.33522 10.3033 5.39195 10.3426 5.45304 10.3775C5.80911 10.5835 6.19486 10.5678 6.51515 10.2929H6.51602Z",
                fill: "#BF63F3"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M13.6186 12.9931C13.6718 12.9477 13.7233 12.8945 13.7722 12.8351C13.821 12.7758 13.8638 12.7129 13.8987 12.6501C14.1038 12.2809 14.0427 11.8995 13.7704 11.5923C13.7242 11.54 13.6718 11.4894 13.6133 11.4422C13.5548 11.3951 13.4903 11.3497 13.4266 11.3131C13.0696 11.1089 12.6847 11.1246 12.3653 11.3969C12.3112 11.4431 12.2589 11.4963 12.2091 11.5574C12.1594 11.6185 12.1183 11.6787 12.0843 11.7398C11.8801 12.1064 11.942 12.4869 12.2135 12.7967C12.2615 12.8517 12.3156 12.9041 12.3767 12.9538C12.4378 13.0035 12.4945 13.0428 12.5556 13.0777C12.9117 13.2837 13.2974 13.268 13.6177 12.9931H13.6186Z",
                fill: "#292A2E"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M9.3788 15.3765L9.40586 15.449H10.9523L10.9209 15.3119C10.7446 14.5439 10.3283 13.844 9.74535 13.3291L8.68848 14.4279C8.99829 14.674 9.23655 14.9995 9.3788 15.3765Z",
                fill: "#292A2E"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M14.6342 9.4961L14.3235 8.57275L13.4351 9.4961H14.6342Z",
                fill: "#292A2E"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M9.68084 8.91065L8.87305 10.5713L10.5337 11.3791L11.3415 9.71844L9.68084 8.91065Z",
                fill: "#FCA700"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M2.55684 10.4918C2.52717 10.4718 2.49924 10.4726 2.48004 10.4752C2.46084 10.4787 2.45037 10.4883 2.44601 10.5014C2.43728 10.5285 2.45561 10.5599 2.49051 10.5896C2.54113 10.6323 2.57255 10.6934 2.59786 10.7763C2.62491 10.8592 2.63888 10.9605 2.69648 11.0818C2.72964 11.1499 2.77764 11.2014 2.8239 11.2345C2.8719 11.2686 2.91641 11.2834 2.95742 11.2947C3.03946 11.3148 3.12062 11.3104 3.2175 11.2764C3.37982 11.2153 3.52557 11.0539 3.66346 11.0259C3.72804 11.0111 3.79001 11.0294 3.83277 11.0565C3.87291 11.0835 3.89648 11.1115 3.90608 11.1324C3.91306 11.1438 3.92004 11.1542 3.92702 11.1673C3.94011 11.1883 3.96106 11.2336 3.98462 11.3052C4.00993 11.3759 4.03088 11.4763 4.09982 11.5897C4.13473 11.6464 4.19059 11.6997 4.25691 11.7355C4.32324 11.7686 4.3983 11.787 4.47771 11.7843C4.55713 11.7782 4.62957 11.7486 4.68979 11.7136C4.75088 11.6787 4.80062 11.6395 4.8495 11.6046C4.9839 11.4998 5.07815 11.4675 5.15582 11.492C5.23611 11.512 5.27539 11.5548 5.29808 11.5897C5.35393 11.6744 5.3775 11.7878 5.41851 11.8908C5.45517 11.9938 5.52324 12.1029 5.6271 12.1552C5.6847 12.1823 5.72048 12.1666 5.72746 12.1456C5.73531 12.1221 5.71873 12.0924 5.68295 12.0662C5.61924 12.0147 5.58433 11.9406 5.55815 11.8437C5.52848 11.7494 5.51626 11.6307 5.43335 11.499C5.40281 11.4501 5.33561 11.3646 5.21255 11.3253C5.15321 11.3035 5.07466 11.2965 4.99524 11.3139C4.91495 11.3314 4.84426 11.3742 4.77968 11.4178C4.73691 11.4475 4.70026 11.478 4.66535 11.5077C4.62782 11.54 4.58942 11.567 4.55015 11.588C4.51088 11.6054 4.47161 11.6176 4.43146 11.6142C4.41139 11.6142 4.39044 11.608 4.37037 11.6037C4.35204 11.5941 4.33022 11.5915 4.31539 11.5784C4.28048 11.56 4.25779 11.5286 4.2351 11.4981C4.19495 11.4318 4.17575 11.355 4.15917 11.3017C4.14346 11.2467 4.13299 11.2127 4.13299 11.2127C4.13299 11.2127 4.12862 11.2005 4.12164 11.1778C4.11204 11.1542 4.1007 11.1211 4.07801 11.08C4.05706 11.039 4.02215 10.9902 3.97066 10.9491C3.9183 10.9072 3.85197 10.8802 3.77953 10.8671C3.70448 10.8566 3.62331 10.8697 3.55611 10.9003C3.48717 10.9299 3.43306 10.971 3.38157 11.0076C3.28208 11.0844 3.19655 11.1411 3.13197 11.156C3.03684 11.176 2.95917 11.1411 2.91902 11.1088C2.87801 11.0739 2.85706 11.0382 2.84222 11.0094C2.79859 10.9212 2.77677 10.8191 2.74011 10.7266C2.70433 10.6341 2.64499 10.5416 2.55684 10.4927V10.4918Z",
                fill: "#292A2E"
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
                d: "M8.03289 2.23406C8.01543 2.20352 7.99012 2.19043 7.97267 2.18432C7.95434 2.17908 7.9395 2.18257 7.93078 2.19217C7.9107 2.21224 7.91245 2.2489 7.93078 2.29079C7.95609 2.35188 7.95609 2.42083 7.94125 2.50635C7.92729 2.59275 7.89412 2.68875 7.88976 2.82315C7.88801 2.89821 7.90721 2.96715 7.93339 3.01777C7.96045 3.07014 7.99361 3.1033 8.02503 3.1321C8.08961 3.18708 8.16292 3.22112 8.26416 3.23421C8.43609 3.25341 8.63943 3.17574 8.77558 3.21414C8.84016 3.23072 8.88641 3.27523 8.9126 3.31886C8.93616 3.36163 8.94401 3.39654 8.94314 3.4201C8.94401 3.43319 8.94576 3.44628 8.94576 3.46024C8.94838 3.48468 8.94576 3.5353 8.93354 3.60948C8.92394 3.68454 8.89601 3.78315 8.90649 3.91494C8.91172 3.98126 8.9379 4.0537 8.97979 4.11566C9.0243 4.17588 9.0819 4.22563 9.15434 4.25966C9.22852 4.29021 9.3062 4.29719 9.37514 4.2937C9.44583 4.29021 9.5078 4.27799 9.56714 4.27014C9.73383 4.23872 9.83332 4.25268 9.89092 4.31028C9.95376 4.36439 9.9686 4.42024 9.97296 4.46214C9.9843 4.5625 9.95376 4.67421 9.94329 4.78504C9.92932 4.89326 9.9398 5.02155 10.0087 5.11581C10.0471 5.16555 10.0873 5.16904 10.1021 5.15246C10.1196 5.13501 10.1187 5.10097 10.0986 5.0617C10.0646 4.98664 10.0681 4.90461 10.089 4.80686C10.1056 4.70912 10.1493 4.59828 10.1353 4.44294C10.1309 4.38621 10.11 4.27886 10.0183 4.1881C9.97558 4.14184 9.90838 4.09995 9.82983 4.07901C9.75041 4.05806 9.66838 4.0633 9.58983 4.07377C9.53834 4.08075 9.49121 4.09123 9.4467 4.1017C9.3987 4.11304 9.35245 4.12003 9.30794 4.1209C9.26518 4.11828 9.22503 4.1113 9.19012 4.09035C9.17267 4.08075 9.15696 4.06592 9.14125 4.05283C9.1299 4.03624 9.1107 4.02315 9.10372 4.00483C9.08103 3.97254 9.07492 3.93414 9.06881 3.89661C9.06358 3.81894 9.08016 3.74214 9.09063 3.68715C9.10198 3.6313 9.10809 3.59552 9.10809 3.59552C9.10809 3.59552 9.10983 3.58243 9.11332 3.55886C9.11507 3.53355 9.12118 3.49952 9.11943 3.45239C9.11943 3.40614 9.1107 3.34679 9.08365 3.28657C9.0566 3.22548 9.00947 3.17137 8.951 3.12599C8.88903 3.08235 8.81049 3.05704 8.7363 3.05355C8.66125 3.04832 8.59405 3.06054 8.53209 3.07014C8.40816 3.09283 8.30692 3.10504 8.24234 3.08934C8.14896 3.06403 8.09572 2.9977 8.0739 2.9497C8.05296 2.89908 8.05034 2.85894 8.05121 2.82577C8.05209 2.72715 8.08001 2.62679 8.08874 2.5273C8.09921 2.42868 8.08874 2.31872 8.03201 2.23581L8.03289 2.23406Z",
                fill: "#292A2E"
            })
        ]
    });
};
var $f2f805f49af46a8b$var$$bde17c0708419ffe$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$bde17c0708419ffe$var$CompletedIcon;
const $f2f805f49af46a8b$var$$b16d92af3081158f$var$QuestionIcon = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.8284 7.15997C15.3505 7.67945 15.7181 8.3338 15.89 9.04999C16.1223 10.008 15.9918 11.0181 15.5235 11.8856C15.0552 12.7531 14.2824 13.4165 13.354 13.748C13.149 13.821 13.004 14.003 13.004 14.22V15.002C13.004 15.2677 12.8984 15.5226 12.7105 15.7105C12.5226 15.8984 12.2677 16.004 12.002 16.004C11.7363 16.004 11.4814 15.8984 11.2935 15.7105C11.1056 15.5226 11 15.2677 11 15.002V12.988C11.0034 12.725 11.1103 12.474 11.2975 12.2893C11.4846 12.1046 11.7369 12.001 11.9998 12.001H11.993C13.098 12.001 13.996 11.103 13.996 10.001C13.984 9.47739 13.7676 8.97927 13.3929 8.61327C13.0183 8.24727 12.5153 8.04248 11.9915 8.04275C11.4678 8.04301 10.9649 8.2483 10.5907 8.61467C10.2164 8.98104 10.0004 9.47937 9.989 10.003C9.987 10.554 9.539 11.001 8.987 11.001C8.74019 10.9995 8.50281 10.906 8.32123 10.7388C8.13964 10.5717 8.02689 10.3428 8.005 10.097L8 9.94999C8.017 7.44599 10.321 5.51399 12.933 6.10799C13.6501 6.27628 14.3063 6.64048 14.8284 7.15997ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
            fill: "#44546F"
        })
    });
var $f2f805f49af46a8b$var$$b16d92af3081158f$export$2e2bcd8739ae039 = $f2f805f49af46a8b$var$$b16d92af3081158f$var$QuestionIcon;
const $f2f805f49af46a8b$var$$c68bccd399b510db$var$STATUS_LABELS = {
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]: "Not started",
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]: "Complete!"
};
const $f2f805f49af46a8b$var$$c68bccd399b510db$export$cee724c49a9ffe54 = ({ isRetired: isRetired, progress: progress, status: status })=>{
    if (isRetired) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
            css: $f2f805f49af46a8b$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    children: "Retired content"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$b16d92af3081158f$export$2e2bcd8739ae039, {})
            ]
        })
    });
    if (status === $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED) return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: (0, $dnfL5.css)({
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle")
                    }),
                    children: $f2f805f49af46a8b$var$$c68bccd399b510db$var$STATUS_LABELS[$f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c17561cb55d4db30, {
                progress: 0
            })
        ]
    });
    if (status === $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
            css: $f2f805f49af46a8b$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    children: "Progress"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                    css: (0, $dnfL5.css)({
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.lime")
                    }),
                    children: $f2f805f49af46a8b$var$$c68bccd399b510db$var$STATUS_LABELS[$f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$bde17c0708419ffe$export$2e2bcd8739ae039, {})
            ]
        })
    });
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                    css: $f2f805f49af46a8b$var$$c68bccd399b510db$var$progressStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            children: "Progress"
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                            css: (0, $dnfL5.css)({
                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle")
                            }),
                            children: [
                                progress,
                                "%"
                            ]
                        })
                    ]
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c17561cb55d4db30, {
                progress: progress,
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.accent.lime")
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$c68bccd399b510db$var$progressStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$e9cd1e314d8acc99$export$aa140c19feb5d492 = ({ title: title, href: href, isRetired: isRetired = false, onTitleClick: onTitleClick })=>{
    const handleClick = (e)=>{
        if (onTitleClick) {
            e.preventDefault();
            onTitleClick();
        }
    };
    const handleKeyboardClick = (0, $acw62.useCallback)(()=>{
        if (onTitleClick) onTitleClick();
    }, [
        onTitleClick
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleKeyboardClick);
    if (isRetired) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $f2f805f49af46a8b$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
            level: 4,
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
            children: title
        })
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
            label: title,
            link: href || "#",
            size: $f2f805f49af46a8b$export$be4c932f76c19adf.EXTRA_LARGE,
            style: $f2f805f49af46a8b$export$2b77966d73aefa77.SEMIBOLD,
            icon: "arrow-right-small",
            onClick: handleClick
        })
    });
};
const $f2f805f49af46a8b$var$$e9cd1e314d8acc99$var$titleContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    "& *": {
        fontFamily: "Charlie Display, sans-serif"
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "& a span:last-of-type": {
        verticalAlign: "text-bottom"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        "& a span:last-of-type": {
            verticalAlign: "bottom"
        }
    }
});
const $f2f805f49af46a8b$export$60e8035fadc9b8fc = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, progress: progress, type: type, isSaved: isSaved, isRetired: isRetired, onSave: onSave, tags: tags, status: status, onDownloadPdf: onDownloadPdf, completionBadgeUrl: completionBadgeUrl, dropdownItems: dropdownItems, onTitleClick: onTitleClick, showSaveButton: showSaveButton = true })=>{
    const typeText = (0, $acw62.useMemo)(()=>{
        switch(type){
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE:
                return "Course";
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.LESSON:
                return "Lesson";
            default:
                return "Learning Path";
        }
    }, [
        type
    ]);
    const getBackgroundColor = (0, $acw62.useMemo)(()=>{
        if (isRetired) return "#8C8F97"; // neutral 500
        switch(type){
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE:
                return "#357DE8"; // blue 600
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.LESSON:
                return "#FCA700"; // yellow 400
            default:
                return "#6A9A23"; // lime 600
        }
    }, [
        isRetired,
        type
    ]);
    const expandableTextLabels = (0, $acw62.useMemo)(()=>{
        switch(type){
            case $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE:
                return {
                    expandButtonText: "Show lessons",
                    collapseButtonText: "Hide lessons"
                };
            default:
                return {
                    expandButtonText: "Show courses",
                    collapseButtonText: "Hide courses"
                };
        }
    }, [
        type
    ]);
    const handleSave = ()=>{
        onSave?.(!isSaved);
    };
    const showCourseList = !isRetired && lessons.length > 0;
    const isCompleted = progress === 100;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$8340d81aba797956$var$containerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$8340d81aba797956$var$topControlsStyles,
                style: {
                    backgroundColor: getBackgroundColor
                },
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: (0, $dnfL5.css)({
                            flexShrink: 0
                        }),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$71f050e2efa708bb, {
                            size: "medium",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
                            fontWeight: "semibold",
                            children: typeText
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$8340d81aba797956$var$headerImageStyles,
                        style: {
                            backgroundImage: `url(${$f2f805f49af46a8b$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c})`
                        }
                    }),
                    isCompleted && completionBadgeUrl && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$8340d81aba797956$var$badgeOuterContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$8340d81aba797956$var$badgeInnerContainerStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e431a229df88919, {
                                src: completionBadgeUrl,
                                alt: "Completion Badge",
                                width: 48,
                                height: 48
                            })
                        })
                    }),
                    showSaveButton && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$dd09d7da2da4d16f, {
                        icon: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-narrow-filled" : "bookmark-narrow",
                            color: "#FFFFFF"
                        }),
                        ariaLabel: isSaved ? "Saved" : "Save",
                        onClick: handleSave,
                        selected: isSaved
                    }),
                    Boolean(dropdownItems?.length) && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$ef4a0fdddd7eccb7, {
                        items: dropdownItems,
                        isInverted: true
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$8340d81aba797956$var$contentStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$8340d81aba797956$var$leftColumnStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$8340d81aba797956$var$tagsContainerStyles,
                                children: tags.map((tag)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                                        label: tag.label
                                    }, tag.label))
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$e9cd1e314d8acc99$export$aa140c19feb5d492, {
                                title: course.title,
                                href: course.href,
                                isRetired: isRetired,
                                onTitleClick: onTitleClick
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$8340d81aba797956$var$rightColumnStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$c68bccd399b510db$export$cee724c49a9ffe54, {
                            isRetired: isRetired,
                            progress: progress,
                            status: status
                        })
                    })
                ]
            }),
            onDownloadPdf && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$8340d81aba797956$var$downloadPdfLinkStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf, {
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.DEFAULT,
                    iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($aKcQU))),
                    onClick: onDownloadPdf,
                    children: "Download completion pdf"
                })
            }),
            showCourseList && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$7586a58445419b5a$export$2c3faa04d4773275, {
                lessons: lessons,
                onLessonClick: onLessonClick,
                expandButtonText: expandableTextLabels.expandButtonText,
                collapseButtonText: expandableTextLabels.collapseButtonText,
                containerStyles: $f2f805f49af46a8b$var$$8340d81aba797956$var$expandableLessonsListContainerStyles,
                buttonContainerStyles: $f2f805f49af46a8b$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$8340d81aba797956$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden"
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$topControlsStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")}`
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$contentStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    flexWrap: "wrap",
    rowGap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$leftColumnStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$rightColumnStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    minWidth: "234px",
    alignSelf: "flex-end"
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$tagsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$expandableLessonsListContainerStyles = (0, $dnfL5.css)({
    border: "none",
    borderRadius: "0"
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles = (0, $dnfL5.css)({
    paddingLeft: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")} !important`
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$headerImageStyles = (0, $dnfL5.css)({
    display: "flex",
    flexGrow: 1,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    backgroundSize: "cover",
    minHeight: "48px",
    width: "100%"
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$downloadPdfLinkStyles = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")}`
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$badgeOuterContainerStyles = (0, $dnfL5.css)({
    position: "relative",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    width: "72px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$8340d81aba797956$var$badgeInnerContainerStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    transform: "translateY(-25%)"
});
var $f2f805f49af46a8b$var$$dbb9d5792c296a49$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$dbb9d5792c296a49$exports, "SubmitFeedback", ()=>$f2f805f49af46a8b$export$f6dc54b55657f29f);
const $f2f805f49af46a8b$export$f6dc54b55657f29f = ({ onSubmit: onSubmit, onChange: onChange, isLoading: isLoading, isSubmitted: isSubmitted, hasError: hasError, opinion: opinion })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $acw62.useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $acw62.useState)(false);
    const handleChange = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $acw62.useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $acw62.useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $acw62.useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $04e5d2708f9c98be$export$2e2bcd8739ae039), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    type: "submit",
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $152edff8f3d35f34$export$2e2bcd8739ae039), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $fb1f1eb3befa3ccc$export$2e2bcd8739ae039), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
            css: $f2f805f49af46a8b$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
            css: $f2f805f49af46a8b$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            !isSubmitted && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: (0, $dnfL5.css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                            css: $f2f805f49af46a8b$var$$dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: (0, $dnfL5.css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: (0, $dnfL5.css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $f2f805f49af46a8b$var$$dbb9d5792c296a49$var$labelStyles = (0, $dnfL5.css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$dbb9d5792c296a49$var$feedbackStyles = (0, $dnfL5.css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});
var $f2f805f49af46a8b$var$$44303f6c3c81eeac$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$44303f6c3c81eeac$exports, "QuestionType", ()=>$f2f805f49af46a8b$export$51940fbbacba35d4);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$44303f6c3c81eeac$exports, "QuizStatus", ()=>$f2f805f49af46a8b$export$bf1c1ed72daa392b);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$44303f6c3c81eeac$exports, "QuestionStatus", ()=>$f2f805f49af46a8b$export$602daccbd963b20);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$44303f6c3c81eeac$exports, "MatchingAnswerStatus", ()=>$f2f805f49af46a8b$export$85e3e62cc743c830);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$44303f6c3c81eeac$exports, "ActionDescription", ()=>$f2f805f49af46a8b$export$cb9c858407602327);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$44303f6c3c81eeac$exports, "Quiz", ()=>$f2f805f49af46a8b$export$76709845c4fea6cd);
let $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789 || ($f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789 = {}));
const $f2f805f49af46a8b$var$$b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode, text: text, elementId: elementId, inputStatus: inputStatus = $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT, onClick: onClick })=>{
    // Keep original Space-only handler for outer div (used by tests)
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    // Use keyboard interaction hook for inner div
    const handleClick = (0, $acw62.useCallback)(()=>onClick?.(), [
        onClick
    ]);
    const onKeyDownInner = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleClick);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsContainerStyles,
            $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsContentStyles,
                    $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                onKeyDown: onKeyDownInner,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsTextStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$e61786c4aee8d415, {
                        children: text
                    })
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsContainerStyles = (0, $dnfL5.css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsContentStyles = (0, $dnfL5.css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsTextStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $dnfL5.css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $2b750d3a8789dea3$export$29a4f05edc054374),
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $dnfL5.css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $dnfL5.css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $dnfL5.css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $f2f805f49af46a8b$var$$b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $dnfL5.css)({
        color: "#000000",
        backgroundColor: (0, $2b750d3a8789dea3$export$29a4f05edc054374),
        fontWeight: 400
    }),
    CORRECT: (0, $dnfL5.css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $dnfL5.css)({
        fontWeight: 700
    }),
    SELECTED: (0, $dnfL5.css)({
        fontWeight: 700
    }),
    DISABLED: (0, $dnfL5.css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};
let $f2f805f49af46a8b$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($f2f805f49af46a8b$export$51940fbbacba35d4 || ($f2f805f49af46a8b$export$51940fbbacba35d4 = {}));
let $f2f805f49af46a8b$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($f2f805f49af46a8b$export$bf1c1ed72daa392b || ($f2f805f49af46a8b$export$bf1c1ed72daa392b = {}));
let $f2f805f49af46a8b$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($f2f805f49af46a8b$export$602daccbd963b20 || ($f2f805f49af46a8b$export$602daccbd963b20 = {}));
let $f2f805f49af46a8b$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($f2f805f49af46a8b$export$85e3e62cc743c830 || ($f2f805f49af46a8b$export$85e3e62cc743c830 = {}));
let $f2f805f49af46a8b$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct responses.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($f2f805f49af46a8b$export$cb9c858407602327 || ($f2f805f49af46a8b$export$cb9c858407602327 = {}));
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$f2f805f49af46a8b$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT = 136;
const $f2f805f49af46a8b$export$76709845c4fea6cd = ({ inspectMode: inspectMode, title: title, questions: questions = [], onCompletion: onCompletion, step: step = 0, setStep: setStep, onInteraction: onInteraction, isCompleted: isCompleted = false, setIsCompleted: setIsCompleted, isLoggedInUser: isLoggedInUser, handleUserLogin: handleUserLogin, lessonId: lessonId, onAnswerSubmit: onAnswerSubmit })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $acw62.useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $acw62.useState)([]);
    const [status, setStatus] = (0, $acw62.useState)($f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $acw62.useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $acw62.useState)($f2f805f49af46a8b$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $acw62.useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $acw62.useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $acw62.useState)({
        lessonId: "",
        step: 0
    });
    const width = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus === $f2f805f49af46a8b$export$85e3e62cc743c830.CORRECT && !isCompleted;
    (0, $acw62.useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    // lastSubmittedQuestion.lessonId, onSubmittedQuestionsRecheck, questions.length intentionally excluded
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        lessonId,
        isCompleted
    ]);
    (0, $acw62.useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $acw62.useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $acw62.useEffect)(()=>{
        const isLastCompletedQuestion = status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING, $f2f805f49af46a8b$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($f2f805f49af46a8b$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($f2f805f49af46a8b$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING, $f2f805f49af46a8b$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($f2f805f49af46a8b$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($f2f805f49af46a8b$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const currentQuestion = questions[step];
        if (!currentQuestion?.leftAnswers || !currentQuestion?.rightAnswers) return;
        const leftAnswers = currentQuestion.leftAnswers;
        const rightAnswers = currentQuestion.rightAnswers;
        if (correctAnswersArray.length === leftAnswers.length + rightAnswers.length) {
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $f2f805f49af46a8b$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $f2f805f49af46a8b$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $f2f805f49af46a8b$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS : $f2f805f49af46a8b$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, (/*@__PURE__*/$parcel$interopDefault($71d76b5cdd325006$exports)))(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS : $f2f805f49af46a8b$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789.CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789.INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS) return $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789.DISABLED;
        if (selectedAnswers.includes(answer)) return $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789.SELECTED;
        return $f2f805f49af46a8b$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizContainerStyles,
        id: "quiz",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c17561cb55d4db30, {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c17561cb55d4db30, {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", questions[step]?.inspectMode),
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$questionImageStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3e431a229df88919, {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $f2f805f49af46a8b$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>{
                            const rightAnswer = questions[step]?.rightAnswers?.[index];
                            if (!rightAnswer) return null;
                            return /*#__PURE__*/ (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: rightAnswer.inspectMode,
                                        elementId: rightAnswer.title,
                                        text: rightAnswer.title,
                                        onClick: ()=>toggleAnswer(rightAnswer),
                                        inputStatus: getInputStatus(rightAnswer)
                                    })
                                ]
                            }, leftAnswer.title + rightAnswer.title);
                        })
                    }),
                    (questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>/*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$answerContainerStyles,
                            ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", answer?.inspectMode),
                            children: questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.SINGLE_SELECT ? /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$d7b12c4107be0d61, {
                                size: width >= $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $f2f805f49af46a8b$export$4da24539a3bb7d98.LARGE : $f2f805f49af46a8b$export$4da24539a3bb7d98.DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : /*#__PURE__*/ (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$48513f6b9f8ce62d, {
                                size: width >= $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $f2f805f49af46a8b$export$5e435bc8b081a399.LARGE : $f2f805f49af46a8b$export$5e435bc8b081a399.DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: [
                            $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $dnfL5.css)({
                                borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                            label: "Submit answer",
                            appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0
                        })
                    }),
                    (status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING) && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: [
                                $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS && (0, $dnfL5.css)({
                                    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
                                })
                            ],
                            children: [
                                status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f23c56ac9ab316f, {
                                    title: questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING ? "Correct" : "That\u2019s correct",
                                    appearance: $f2f805f49af46a8b$export$f9292ef28b7b429a.CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $f2f805f49af46a8b$export$51940fbbacba35d4.MATCHING && !isCompleted) && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: (0, $dnfL5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        disabled: status !== $f2f805f49af46a8b$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.ERROR || status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.PARTLY_CORRECT) && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f23c56ac9ab316f, {
                                    title: status === $f2f805f49af46a8b$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That\u2019s partly correct" : "That\u2019s not correct",
                                    appearance: $f2f805f49af46a8b$export$f9292ef28b7b429a.INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: (0, $dnfL5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "Try again",
                                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "refresh"
                                        }),
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f23c56ac9ab316f, {
                    title: "That\u2019s correct",
                    appearance: $f2f805f49af46a8b$export$f9292ef28b7b429a.CORRECT
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizContentContainerStyles = (0, $dnfL5.css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        padding: "24px 16px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $dnfL5.css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    flexDirection: "row",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizTitleStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$questionTitleStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$questionImageStyles = (0, $dnfL5.css)({
    padding: "24px 0"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $dnfL5.css)({
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$answerContainerStyles = (0, $dnfL5.css)({
    marginBottom: "24px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "20px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$buttonContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "24px"
    }
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$feedbackContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$questionsStepStyles = (0, $dnfL5.css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$completionMessageStyles = (0, $dnfL5.css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $f2f805f49af46a8b$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $dnfL5.css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
var $f2f805f49af46a8b$var$$9c3f769544bb2079$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$9c3f769544bb2079$exports, "Sidebar", ()=>$f2f805f49af46a8b$export$1ba59dacbcbf90fe);
const $f2f805f49af46a8b$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility, isVisible: isVisible = true, children: children })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $f2f805f49af46a8b$var$$9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $f2f805f49af46a8b$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $f2f805f49af46a8b$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "chevron-left",
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $f2f805f49af46a8b$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "menu-icon",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        }),
                        isVisible ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: (0, $dnfL5.css)({
                                span: {
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                children: "Close"
                            })
                        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: (0, $dnfL5.css)({
                                span: {
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    isVisible && $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarClosedStyles,
                    $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $dnfL5.css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarStyles = (0, $dnfL5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarClosedStyles = (0, $dnfL5.css)({
    width: "1.25rem",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$sidebarOpenStyles = (0, $dnfL5.css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.blanket")}`
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $dnfL5.css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        display: "flex"
    }
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $dnfL5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $dnfL5.css)({
    marginLeft: "25.5rem"
});
const $f2f805f49af46a8b$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $dnfL5.css)({
    marginLeft: "0.5rem"
});
var $f2f805f49af46a8b$var$$3d76652bb6362040$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3d76652bb6362040$exports, "LearningSidebar", ()=>$f2f805f49af46a8b$export$4ff69a78d3a65d6f);
var $f2f805f49af46a8b$var$$ef44b01e6346ac17$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $f2f805f49af46a8b$var$$ef44b01e6346ac17$var$badge = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2407_668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#FCA700"/>
</mask>
<g mask="url(#mask0_2407_668)">
<path d="M59.9919 120.001C93.129 120.001 119.992 93.1381 119.992 60.001C119.992 26.8639 93.129 0.00100708 59.9919 0.00100708C26.8549 0.00100708 -0.00805664 26.8639 -0.00805664 60.001C-0.00805664 93.1381 26.8549 120.001 59.9919 120.001Z" fill="#F0F1F2"/>
<path d="M114.195 48.5778C139.041 82.736 131.616 130.479 97.5729 155.447L75.6838 125.554C93.1971 112.63 97.0229 88.0317 84.2648 70.3823L114.195 48.5778Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M61.381 -11.1668L61.381 -11.1667L61.3875 -11.1713C66.9496 -15.1726 72.2687 -18.6935 77.3965 -21.8258L116.987 15.9668C109.215 16.5818 99.355 21.2346 85.3825 30.54L85.3825 30.5399L85.3765 30.5441C79.0802 35.0076 73.098 38.8783 67.3602 42.2665L28.6585 5.32281C36.6192 3.90769 46.9288 -1.45355 61.381 -11.1668Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M-4.01227 93.1467L46.5982 80.1918L59.4265 130.835L8.81594 143.79L-4.01227 93.1467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M3.67239 23.827L3.68518 23.7211L3.66478 23.6962C4.43632 16.9412 1.0124 10.0403 -2.57376 4.84886C-4.3803 2.23367 -6.23694 0.0395466 -7.64175 -1.5007C-8.34432 -2.27099 -8.93428 -2.8782 -9.34902 -3.29322C-9.39083 -3.33506 -9.43086 -3.37495 -9.46905 -3.41285L13.9267 -0.587166C22.5213 4.49206 28.577 10.8772 32.2178 18.2212C35.8649 25.5781 37.096 33.9122 36.0121 42.8863C34.4107 56.146 27.9882 65.8687 18.1125 72.3709C8.28951 78.8384 -4.96514 82.1287 -20.3194 82.5128L-15.6409 43.7758C-9.8996 42.5993 -5.41093 40.3431 -2.18767 37.026C1.06994 33.6736 3.01663 29.2565 3.67239 23.827Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M98.1255 59.8467C98.1255 81.1403 81.101 98.3963 60.1074 98.3963C39.1139 98.3963 22.0894 81.1403 22.0894 59.8467C22.0894 38.5531 39.1139 21.2971 60.1074 21.2971C81.101 21.2971 98.1255 38.5531 98.1255 59.8467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M35.4794 65.1887C35.2675 65.5337 35.0269 65.9381 34.84 66.2562C34.66 66.5631 34.7569 66.9575 35.06 67.1444L39.3062 69.765C39.6175 69.9569 40.025 69.8581 40.2106 69.5431C40.3794 69.2575 40.5981 68.89 40.8369 68.495C42.52 65.7175 44.2125 66.0562 47.2619 67.5056L51.4731 69.5075C51.805 69.6656 52.2019 69.5181 52.3512 69.1819L54.3737 64.6156C54.5175 64.2906 54.3762 63.9112 54.055 63.76C53.1656 63.3419 51.3981 62.5075 49.8156 61.7412C44.0656 58.9569 39.2 59.1406 35.48 65.1887H35.4794Z" fill="url(#paint0_linear_2407_668)"/>
<path d="M54.5206 54.8113C54.7325 54.4663 54.9731 54.0619 55.16 53.7438C55.34 53.4369 55.2431 53.0425 54.94 52.8556L50.6938 50.235C50.3825 50.0431 49.975 50.1419 49.7894 50.4569C49.6206 50.7425 49.4019 51.11 49.1631 51.505C47.48 54.2825 45.7875 53.9438 42.7381 52.4944L38.5269 50.4925C38.195 50.3344 37.7981 50.4819 37.6488 50.8181L35.6263 55.3844C35.4825 55.7094 35.6238 56.0888 35.945 56.24C36.8344 56.6581 38.6019 57.4925 40.1844 58.2588C45.9344 61.0431 50.8 60.8594 54.52 54.8113H54.5206Z" fill="url(#paint1_linear_2407_668)"/>
<path d="M85.1263 49.5188H73.8275C73.8275 52.335 76.1106 54.6175 78.9263 54.6175H81.0069V56.6256C81.0069 59.4419 83.29 61.7244 86.1056 61.7244V50.4988C86.1056 49.9575 85.6669 49.5188 85.1256 49.5188H85.1263Z" fill="#1D7AFC"/>
<path d="M79.5345 55.1475H68.2357C68.2357 57.9638 70.5188 60.2463 73.3345 60.2463H75.4151V62.2544C75.4151 65.0706 77.6982 67.3531 80.5138 67.3531V56.1275C80.5138 55.5863 80.0751 55.1475 79.5338 55.1475H79.5345Z" fill="url(#paint2_linear_2407_668)"/>
<path d="M73.9425 60.7756H62.6438C62.6438 63.5919 64.9269 65.8744 67.7425 65.8744H69.8232V67.8825C69.8232 70.6988 72.1063 72.9813 74.9219 72.9813V61.7556C74.9219 61.2144 74.4832 60.7756 73.9419 60.7756H73.9425Z" fill="url(#paint3_linear_2407_668)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2407_668" x1="54.2475" y1="71.11" x2="41.3981" y2="63.7263" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint1_linear_2407_668" x1="35.7519" y1="48.89" x2="48.6019" y2="56.2738" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint2_linear_2407_668" x1="80.2745" y1="55.1663" x2="75.4682" y2="60.1225" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint3_linear_2407_668" x1="75.0019" y1="60.8281" x2="69.445" y2="66.2344" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
</defs>
</svg>`;
const $f2f805f49af46a8b$var$$ef44b01e6346ac17$export$44f5f766f3f98994 = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$ef44b01e6346ac17$require$Buffer.from($f2f805f49af46a8b$var$$ef44b01e6346ac17$var$badge).toString("base64")}`;
const $f2f805f49af46a8b$var$$32c02b5652036d7a$var$SidebarContext = (0, $acw62.createContext)(undefined);
const $f2f805f49af46a8b$var$$32c02b5652036d7a$export$861cd542ff836f0d = ()=>{
    const context = (0, $acw62.useContext)($f2f805f49af46a8b$var$$32c02b5652036d7a$var$SidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarContextProvider");
    return context;
};
const $f2f805f49af46a8b$var$$32c02b5652036d7a$export$d8355e8edbcacbe8 = ({ children: children })=>{
    const [hoverInfo, setHoverInfo] = (0, $acw62.useState)(null);
    const popupRef = (0, $acw62.useRef)(null);
    const lastIdRef = (0, $acw62.useRef)(null);
    const timeoutRef = (0, $acw62.useRef)(null);
    const clear = (0, $acw62.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $acw62.useCallback)((data)=>{
        clear();
        if (lastIdRef.current !== data.courseId) setHoverInfo(null);
        lastIdRef.current = data.courseId;
        timeoutRef.current = setTimeout(()=>{
            if (lastIdRef.current === data.courseId) setHoverInfo(data);
        }, 1000);
    }, [
        clear
    ]);
    const handleMouseLeave = (0, $acw62.useCallback)((id)=>{
        clear();
        if (!id || lastIdRef.current === id) {
            lastIdRef.current = null;
            setHoverInfo(null);
        }
    }, [
        clear
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            hoverInfo: hoverInfo,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            popupRef: popupRef
        }), [
        hoverInfo,
        handleMouseEnter,
        handleMouseLeave
    ]);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$32c02b5652036d7a$var$SidebarContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $f2f805f49af46a8b$var$$48630d5962798e4a$export$272e7ef3ea22070d = (status)=>{
    switch(status){
        case $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED:
            return $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED;
        case $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.IN_PROGRESS:
        case $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED:
        default:
            return $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT;
    }
};
const $f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d = (courseSlug, lessonSlug, sectionSlug)=>{
    const currentPath = globalThis.location.pathname;
    const currentHash = globalThis.location.hash;
    if (courseSlug) return currentPath.includes(`/course/${courseSlug}`);
    if (sectionSlug === "quiz") return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === "#quiz";
    if (sectionSlug) return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
    if (lessonSlug) {
        const lessonPath = `/lesson/${lessonSlug}`;
        return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + "/");
    }
    return currentHash === `#${sectionSlug}`;
};
const $f2f805f49af46a8b$var$$48630d5962798e4a$export$1308f255697e8777 = (lessonsCollection, progressForLessons)=>{
    const numberOfCompletedLessons = lessonsCollection.items.filter(({ sys: { id: id } })=>$f2f805f49af46a8b$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status) === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED).length;
    const numberOfTotalLessons = lessonsCollection.items.length;
    const progress = numberOfTotalLessons === 0 ? 0 : numberOfCompletedLessons / numberOfTotalLessons * 100;
    const isStatusCompleted = progress === 100;
    return {
        progress: progress,
        isStatusCompleted: isStatusCompleted
    };
};
const $f2f805f49af46a8b$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f = ({ lessonsCollection: lessonsCollection, progressForLessons: progressForLessons, reward: reward, title: title })=>{
    const { progress: progress, isStatusCompleted: isStatusCompleted } = (0, $acw62.useMemo)(()=>$f2f805f49af46a8b$var$$48630d5962798e4a$export$1308f255697e8777(lessonsCollection, progressForLessons), [
        lessonsCollection,
        progressForLessons
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$progressCircleContainerStyles,
        "data-testid": "course-progress-circle",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1a77571422b9634a$export$5ab97151efedb8c6), {
                strokeWidth: 8,
                value: progress,
                styles: (0, $1a77571422b9634a$export$5115a192ad9bf57f)({
                    pathColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success"),
                    trailColor: "rgba(9, 30, 66, 0.14)"
                }),
                css: [
                    isStatusCompleted && $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: [
                        $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles,
                        isStatusCompleted && $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                    ],
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                        css: $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$imageStyles,
                        "data-testid": "course-badge-image",
                        src: reward?.badgeCdnUrl || $f2f805f49af46a8b$var$$ef44b01e6346ac17$export$44f5f766f3f98994,
                        alt: title
                    })
                })
            }),
            isStatusCompleted && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                type: "check",
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.success")
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$completedCourseProgressStyles = (0, $dnfL5.css)({
    opacity: "0.2"
});
const $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$progressCircleContainerStyles = (0, $dnfL5.css)({
    position: "relative",
    maxWidth: "32px",
    span: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
const $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$6cca9b298ff547cb$var$imageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
let $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["COURSE"] = "course";
    Appearance["LESSON"] = "lesson";
    Appearance["SECTION"] = "section";
})($f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf || ($f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf = {}));
/**
 * Props for the TextTooltip component
 * @param {string} text - Text to display in the tooltip
 * @param {CardStatus} status - Current status of the item (completed, or default)
 * @param {Appearance} appearance - Whether the item is a course card or lesson card
 * @param {boolean} isSelected - Whether the item is selected
 */ const $f2f805f49af46a8b$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH = 650;
const $f2f805f49af46a8b$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a = ({ text: text, status: status, appearance: appearance, isSelected: isSelected })=>{
    const [isTruncated, setIsTruncated] = (0, $acw62.useState)(false);
    const textRef = (0, $acw62.useRef)(null);
    const deviceSize = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $f2f805f49af46a8b$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH;
    (0, $acw62.useEffect)(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>{
            window.removeEventListener("resize", checkTruncation);
        };
    }, [
        text
    ]);
    const isLesson = appearance === $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON;
    const isCourse = appearance === $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE;
    const isSection = appearance === $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION;
    const textElement = (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
        "data-testid": "sidebar-text-tooltip",
        ref: textRef,
        css: [
            isCourse && $f2f805f49af46a8b$var$$47b694880a211b2b$var$courseTitleStyles,
            isCourse && isSelected && $f2f805f49af46a8b$var$$47b694880a211b2b$var$titleSelectedStyles,
            isLesson && $f2f805f49af46a8b$var$$47b694880a211b2b$var$lessonTitleStyles,
            isMobile && isLesson && $f2f805f49af46a8b$var$$47b694880a211b2b$var$regularDecorationStyles,
            isLesson && isSelected && $f2f805f49af46a8b$var$$47b694880a211b2b$var$titleSelectedStyles,
            $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleStyles,
            isCourse && $f2f805f49af46a8b$var$$47b694880a211b2b$var$courseMaxWidth,
            isLesson && $f2f805f49af46a8b$var$$47b694880a211b2b$var$lessonMaxWidth,
            status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleCompletedStyles,
            status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleDefaultStyles,
            isSection && isSelected && $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleSelectedStyles
        ],
        children: text
    });
    return isTruncated ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6xdv4.default), {
        content: text,
        position: isMobile ? "bottom" : "right",
        children: textElement
    }) : textElement;
};
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    marginTop: 0,
    marginLeft: "10px",
    maxWidth: "330px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "290px"
    }
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleSelectedStyles = (0, $dnfL5.css)({
    fontWeight: 600,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleCompletedStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$sectionTitleDefaultStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle")
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$lessonTitleStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    marginTop: 0,
    marginRight: "auto",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        textDecoration: "underline"
    }
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$regularDecorationStyles = (0, $dnfL5.css)({
    "&:hover": {
        textDecoration: "none"
    }
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$titleSelectedStyles = (0, $dnfL5.css)({
    fontWeight: "500 !important",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$courseTitleStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    marginTop: 0
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$courseMaxWidth = (0, $dnfL5.css)({
    marginLeft: 0,
    maxWidth: "320px"
});
const $f2f805f49af46a8b$var$$47b694880a211b2b$var$lessonMaxWidth = (0, $dnfL5.css)({
    marginLeft: 0,
    marginRight: "auto",
    maxWidth: "290px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "270px"
    }
});
const $f2f805f49af46a8b$var$$0efd93166e145c77$export$a3b47b9708ebe4f0 = {
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $f2f805f49af46a8b$var$$0efd93166e145c77$export$411533295806dc51 = (sectionContentfulId, seenSectionObserver)=>{
    const element = document.getElementById(`${sectionContentfulId}`);
    if (element) seenSectionObserver.unobserve(element);
};
const $f2f805f49af46a8b$var$$0efd93166e145c77$export$a1fd357e7aacc4df = (0, $acw62.memo)(({ section: { title: title, id: id }, status: status, courseSlug: courseSlug, lessonSlug: lessonSlug, onSelect: onSelect, isSelected: isSelected })=>{
    const handleSectionClick = (e)=>{
        e.stopPropagation();
        onSelect(courseSlug || "", lessonSlug, id);
    };
    const handleKeyboardClick = (0, $acw62.useCallback)(()=>{
        onSelect(courseSlug || "", lessonSlug, id);
    }, [
        onSelect,
        courseSlug,
        lessonSlug,
        id
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleKeyboardClick);
    const getIconType = ()=>{
        if (isSelected && status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return $f2f805f49af46a8b$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
        if (isSelected) return "dot-selected";
        return $f2f805f49af46a8b$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
    };
    const type = getIconType();
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "sidebar-section-item",
        css: [
            $f2f805f49af46a8b$var$$0efd93166e145c77$var$sectionBarStyles,
            isSelected && $f2f805f49af46a8b$var$$0efd93166e145c77$var$sectionBarSelectedStyles
        ],
        onClick: handleSectionClick,
        onKeyDown: onKeyDown,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                type: type,
                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                text: title,
                status: status,
                isSelected: isSelected,
                appearance: $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION
            })
        ]
    });
});
const $f2f805f49af46a8b$var$$0efd93166e145c77$var$sectionBarStyles = (0, $dnfL5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:active": {
        background: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")} !important`
    },
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $f2f805f49af46a8b$var$$0efd93166e145c77$var$sectionBarSelectedStyles = (0, $dnfL5.css)({
    "&::before": {
        content: '""',
        display: "block",
        width: "2px",
        height: "12px",
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        background: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")} !important`
    }
});
const $f2f805f49af46a8b$var$$4baed82dabfd5555$var$loadingFlash = (0, $dnfL5.keyframes)`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;
const $f2f805f49af46a8b$var$$4baed82dabfd5555$var$skeletonStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(241, 242, 244, 1)",
    borderRadius: "4px",
    position: "relative",
    "&::before": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,
        backgroundSize: "35%",
        backgroundPosition: 0,
        backgroundRepeat: "no-repeat",
        animation: `${$f2f805f49af46a8b$var$$4baed82dabfd5555$var$loadingFlash} 2.5s infinite linear`
    }
});
const $f2f805f49af46a8b$var$$4baed82dabfd5555$export$27a22c945b52f415 = ()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$4baed82dabfd5555$var$skeletonStyles,
        "data-testid": "skeleton-loader"
    });
const $f2f805f49af46a8b$var$$193bb26965d10640$export$9794789a1567361c = (0, $acw62.memo)(()=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$193bb26965d10640$var$loaderContainerStyles,
        children: [
            [
                ...Array(4)
            ].map((_, index)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$193bb26965d10640$var$sectionBarStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$193bb26965d10640$var$skeletonLoaderBarStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                        })
                    ]
                }, index)),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$193bb26965d10640$var$sectionBarStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: "Quiz",
                        status: $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT,
                        isSelected: false
                    })
                ]
            })
        ]
    }));
const $f2f805f49af46a8b$var$$193bb26965d10640$var$loaderContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$193bb26965d10640$var$skeletonLoaderBarStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "20px",
    marginLeft: "10px"
});
const $f2f805f49af46a8b$var$$193bb26965d10640$var$sectionBarStyles = (0, $dnfL5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $f2f805f49af46a8b$var$$fd3fa057a77982d6$export$1f81c5947c983f13 = (0, $acw62.memo)((props)=>{
    const { lesson: { slug: slug, sectionListCollection: sectionListCollection }, progressForLesson: progressForLesson, isLoading: isLoading, courseSlug: courseSlug, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, isLessonCardExpanded: isLessonCardExpanded, isMobile: isMobile } = props;
    if (isLoading && isLessonCardExpanded) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$193bb26965d10640$export$9794789a1567361c, {});
    if (!isLessonCardExpanded || isMobile) return null;
    const status = $f2f805f49af46a8b$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$fd3fa057a77982d6$var$sectionContainerStyles,
        children: sectionListCollection.items.map((section)=>{
            const sectionStatus = section.id === "quiz" && status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED ? $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED : $f2f805f49af46a8b$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.section.find((sectionProgress)=>sectionProgress.sectionId === section.sys.id)?.status);
            return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0efd93166e145c77$export$a1fd357e7aacc4df, {
                section: section,
                status: sectionStatus,
                onSelect: onSelect,
                lessonSlug: slug,
                courseSlug: courseSlug,
                isSelected: currentLessonSlug === slug && section.sys.id === selectedSectionId
            }, section.id);
        })
    });
});
const $f2f805f49af46a8b$var$$fd3fa057a77982d6$var$sectionContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$d1d0f9af78cf2050$export$5496f515fa03c54e = (totalMinutes)=>{
    if (totalMinutes > 59) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) return `${hours} h`;
        return `${hours} h ${minutes} min`;
    }
    return `${totalMinutes} min`;
};
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$db6f237c151666ee = 480;
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0 = {
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$951debaed2d5c034 = (0, $acw62.memo)((props)=>{
    const { lesson: { sys: sys, slug: slug, title: title, duration: duration }, courseSlug: courseSlug, isLoading: isLoading, progressForLesson: progressForLesson, onSelect: onSelect, expandedLessonIds: expandedLessonIds, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, isCourse: isCourse } = props;
    const deviceSize = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$db6f237c151666ee;
    const isSelected = $f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d("", slug);
    const status = $f2f805f49af46a8b$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    const [isLessonCardExpanded, setIsLessonCardExpanded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const isExpanded = expandedLessonIds?.includes(sys.id);
        setIsLessonCardExpanded(isExpanded || false);
    }, [
        expandedLessonIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleExpandClick = (e)=>{
        e.stopPropagation();
        setIsLessonCardExpanded(!isLessonCardExpanded);
    };
    const handleCardClick = (0, $acw62.useCallback)(()=>{
        setIsLessonCardExpanded(true);
        onSelect(courseSlug || "", slug);
    }, [
        courseSlug,
        slug,
        onSelect
    ]);
    const handleExpandKeyboard = (0, $acw62.useCallback)(()=>{
        setIsLessonCardExpanded(!isLessonCardExpanded);
    }, [
        isLessonCardExpanded
    ]);
    const onKeyDownCard = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleCardClick);
    const onKeyDownExpand = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleExpandKeyboard);
    const renderStatusIndicator = ()=>{
        if (status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
            type: "check-circle-outline",
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.success")
        });
        return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            css: [
                $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles,
                isSelected && $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles
            ],
            children: $f2f805f49af46a8b$var$$d1d0f9af78cf2050$export$5496f515fa03c54e(duration)
        });
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-lesson-card",
        css: [
            $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardStyles,
            isSelected && $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles
        ],
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles,
                    isMobile && $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles,
                    isCourse && isMobile && $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles
                ],
                onClick: handleCardClick,
                onKeyDown: onKeyDownCard,
                children: [
                    !isMobile && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles,
                        onClick: handleExpandClick,
                        onKeyDown: onKeyDownExpand,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: isLessonCardExpanded ? "chevron-down" : "chevron-right",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles,
                        children: renderStatusIndicator()
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$fd3fa057a77982d6$export$1f81c5947c983f13, {
                lesson: props.lesson,
                progressForLesson: progressForLesson,
                isLoading: isLoading,
                courseSlug: courseSlug,
                selectedSectionId: selectedSectionId,
                currentLessonSlug: currentLessonSlug,
                onSelect: onSelect,
                isLessonCardExpanded: isLessonCardExpanded,
                isMobile: isMobile
            })
        ]
    });
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    "&:active": {
        background: "#F1F2F4 !important"
    },
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles = (0, $dnfL5.css)({
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input.hovered"),
    "&:active": {
        background: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input.hovered")} !important`
    }
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles = (0, $dnfL5.css)({
    marginLeft: `calc(${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} + ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025")})`
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles = (0, $dnfL5.css)({
    marginLeft: 0
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.pressed")
    }
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral"),
    marginLeft: "auto"
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.brand.subtlest")
});
const $f2f805f49af46a8b$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles = (0, $dnfL5.css)({
    marginLeft: "auto"
});
const $f2f805f49af46a8b$var$$11732cc088354996$export$748c6b3a71d1e268 = (0, $acw62.memo)(()=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            ...Array(4)
        ].map((_, index)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$11732cc088354996$var$lessonCardHeaderStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$11732cc088354996$var$lessonExpanderStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$11732cc088354996$var$skeletonLoaderBarStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$4baed82dabfd5555$export$27a22c945b52f415, {}),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                            })
                        ]
                    })
                ]
            }, index))
    }));
const $f2f805f49af46a8b$var$$11732cc088354996$var$lessonCardHeaderStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$11732cc088354996$var$lessonExpanderStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px"
});
const $f2f805f49af46a8b$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles = (0, $dnfL5.css)({
    width: "50px",
    height: "20px",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$11732cc088354996$var$skeletonLoaderBarStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "20px",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025")
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE = {
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "Completed",
    [$f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "Course"
};
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$CourseCardHeaderContent = ({ isCourseExpanded: isCourseExpanded, isSelected: isSelected, status: status, title: title })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseExpanderStyles,
                    isCourseExpanded && $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: isCourseExpanded ? "chevron-down" : "chevron-right",
                    color: isCourseExpanded ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.selected") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseTitleContainerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                        css: [
                            $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleStyles,
                            status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles,
                            status === $f2f805f49af46a8b$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles,
                            isSelected && $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles
                        ],
                        children: isSelected ? "Current course".toUpperCase() : $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE[status].toUpperCase()
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $f2f805f49af46a8b$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE
                    })
                ]
            })
        ]
    });
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c = (props)=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, popupRef: popupRef } = $f2f805f49af46a8b$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const mouseLeaveHandler = (0, $acw62.useCallback)((e, id, courseCardRef)=>{
        const lessonPage = document.getElementById("lesson-page-body");
        const isMovedToSidebar = e.relatedTarget?.tagName === "ASIDE";
        if (!e.relatedTarget || !e.relatedTarget.nodeType || isMovedToSidebar || e.relatedTarget === props.scrollContainerRef.current || lessonPage?.contains(e.relatedTarget)) {
            handleMouseLeave();
            return;
        }
        if (e.currentTarget === courseCardRef.current || e.relatedTarget === popupRef.current) return;
        handleMouseLeave(id);
    }, [
        handleMouseLeave,
        popupRef,
        props.scrollContainerRef
    ]);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$aefb4e9d0a694068$export$7b8f328152f30a2c, {
        ...props,
        onHover: handleMouseEnter,
        onMouseLeave: mouseLeaveHandler,
        popupRef: popupRef
    });
};
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$export$7b8f328152f30a2c = (0, $acw62.memo)(({ course: { sys: sys, title: title, reward: reward, slug: slug, lessonsCollection: lessonsCollection }, status: status, isLoading: isLoading, selectedLessonRef: selectedLessonRef, progressForLessons: progressForLessons, onHover: onHover, onMouseLeave: onMouseLeave, onSelect: onSelect, expandedLessonIds: expandedLessonIds = [], expandedCourseIds: expandedCourseIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug })=>{
    const courseCardRef = (0, $acw62.useRef)(null);
    const isSelected = $f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d(slug);
    const [isCourseExpanded, setIsCourseExpanded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const isExpanded = expandedCourseIds.includes(sys.id);
        setIsCourseExpanded(isExpanded || false);
    }, [
        expandedCourseIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleCourseCardExpand = (0, $acw62.useCallback)(()=>{
        setIsCourseExpanded(!isCourseExpanded);
        onSelect(slug);
    }, [
        isCourseExpanded,
        onSelect,
        slug
    ]);
    const showCoursePopup = (0, $acw62.useCallback)(()=>{
        if (courseCardRef.current) onHover({
            courseId: sys.id,
            courseCardPosition: courseCardRef.current.getBoundingClientRect()
        });
    }, [
        sys.id,
        onHover
    ]);
    const hideCoursePopup = (0, $acw62.useCallback)((e)=>{
        onMouseLeave(e, sys.id, courseCardRef);
    }, [
        onMouseLeave,
        sys.id,
        courseCardRef
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleCourseCardExpand);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-course-card",
        css: [
            $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardStyles,
            isCourseExpanded && $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardOpenedStyles
        ],
        ref: courseCardRef,
        onMouseEnter: showCoursePopup,
        onMouseLeave: hideCoursePopup,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardHeaderStyles,
                    isCourseExpanded && $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles
                ],
                onClick: handleCourseCardExpand,
                onKeyDown: onKeyDown,
                onMouseEnter: showCoursePopup,
                "data-testid": "course-card-header",
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$aefb4e9d0a694068$var$CourseCardHeaderContent, {
                        isCourseExpanded: isCourseExpanded,
                        isSelected: isSelected,
                        status: status,
                        title: title
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f, {
                        lessonsCollection: lessonsCollection,
                        progressForLessons: progressForLessons,
                        reward: reward,
                        title: title
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$lessonContainerStyles,
                onMouseEnter: hideCoursePopup,
                children: isLoading && isCourseExpanded ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$11732cc088354996$export$748c6b3a71d1e268, {}) : isCourseExpanded && lessonsCollection.items.map((lesson)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        ref: $f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                            lesson: lesson,
                            courseSlug: slug,
                            progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                            onSelect: onSelect,
                            isLoading: isLoading,
                            expandedLessonIds: expandedLessonIds,
                            selectedSectionId: selectedSectionId,
                            currentLessonSlug: currentLessonSlug
                        })
                    }, lesson.sys.id))
            })
        ]
    });
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardOpenedStyles = (0, $dnfL5.css)({
    paddingBottom: 0,
    "&:hover": {
        background: "none"
    }
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardHeaderStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseExpanderStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")}`,
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles = (0, $dnfL5.css)({
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.blue.subtler")}`
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseTitleContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    marginRight: "auto"
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px"
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.success")
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $f2f805f49af46a8b$var$$aefb4e9d0a694068$var$lessonContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
var $f2f805f49af46a8b$var$$e48fba9cf5395297$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $f2f805f49af46a8b$var$$e48fba9cf5395297$var$courseBg = `<svg width="419" height="16" viewBox="0 0 419 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_550_14457)">
<rect width="419" height="16" fill="#CCE0FF"/>
<g clipPath="url(#clip1_550_14457)">
<path d="M419.987 -18.5349C419.996 -18.6007 420.003 -18.6684 420.014 -18.7323C420.032 -18.7947 420.048 -18.8548 420.064 -18.915C420.099 -19.0356 420.114 -19.1585 420.159 -19.2632C420.248 -19.4786 420.309 -19.6895 420.416 -19.8625C420.463 -19.9546 420.508 -20.0404 420.551 -20.1238C420.603 -20.2039 420.653 -20.2775 420.702 -20.3488C420.75 -20.4201 420.79 -20.4949 420.836 -20.5598C420.888 -20.6209 420.931 -20.6813 420.974 -20.7375C421.14 -20.9764 421.288 -21.1424 421.37 -21.2817C421.452 -21.421 421.479 -21.522 421.443 -21.5797C421.407 -21.6374 421.307 -21.6518 421.142 -21.6124C420.978 -21.5729 420.733 -21.4929 420.458 -21.2992C420.387 -21.251 420.313 -21.2006 420.234 -21.1476C420.159 -21.0907 420.086 -21.0172 420.006 -20.9452C419.928 -20.8714 419.847 -20.793 419.762 -20.7101C419.686 -20.6195 419.613 -20.5188 419.533 -20.4154C419.364 -20.214 419.244 -19.956 419.102 -19.6814C419.032 -19.5431 418.992 -19.3907 418.936 -19.2369C418.91 -19.159 418.885 -19.0793 418.86 -18.9995C418.838 -18.9178 418.826 -18.835 418.809 -18.7495C418.615 -17.7843 418.69 -16.8131 418.876 -15.8955C419.059 -14.9692 419.392 -14.1022 419.756 -13.244C419.947 -12.82 420.142 -12.3941 420.364 -11.9832C420.574 -11.563 420.81 -11.1596 421.049 -10.7501L421.231 -10.4386C421.302 -10.321 421.379 -10.2101 421.453 -10.1053C421.527 -10.0006 421.606 -9.89614 421.681 -9.80195L421.834 -9.60333C421.861 -9.56574 421.887 -9.52816 421.909 -9.49438C421.917 -9.47618 421.939 -9.45715 421.93 -9.44167L421.87 -9.4071L421.756 -9.34475C421.555 -9.2203 421.349 -9.09548 421.146 -8.96877C420.732 -8.71463 420.314 -8.45596 419.889 -8.19466C419.043 -7.67017 418.178 -7.13781 417.292 -6.58888C415.522 -5.48495 413.666 -4.32951 411.701 -3.10375C411.569 -3.02103 411.438 -2.9383 411.311 -2.85594L411.263 -2.82245C411.247 -2.81267 411.23 -2.79231 411.213 -2.79503L411.176 -2.83796L411.129 -2.89683C411.053 -2.99935 410.979 -3.09997 410.908 -3.19868C410.748 -3.42193 410.595 -3.64364 410.445 -3.8657C409.853 -4.75016 409.317 -5.59122 408.833 -6.35712C407.867 -7.87642 407.139 -9.19183 406.523 -10.4477C405.911 -11.704 405.395 -12.8909 404.961 -14.1983C404.532 -15.5018 404.156 -16.9191 403.941 -18.6294C403.764 -20.0724 403.734 -21.6582 403.948 -23.2902C404.067 -24.102 404.224 -24.9319 404.485 -25.7435C404.596 -26.156 404.761 -26.5543 404.909 -26.9594C405.08 -27.3562 405.245 -27.7586 405.453 -28.1438C405.847 -28.925 406.311 -29.6786 406.85 -30.3841C407.385 -31.0935 407.973 -31.7656 408.624 -32.3738C408.936 -32.6905 409.287 -32.9706 409.619 -33.2637C409.969 -33.5374 410.311 -33.821 410.678 -34.0689C411.033 -34.3347 411.41 -34.5667 411.777 -34.8021C412.152 -35.0318 412.539 -35.2437 412.914 -35.465C414.436 -36.3062 415.99 -36.9507 417.497 -37.3604C419.003 -37.7742 420.458 -37.9529 421.776 -37.9727C423.096 -37.9948 424.276 -37.8642 425.269 -37.709C426.262 -37.5579 427.07 -37.3657 427.646 -37.233L428.69 -36.9731C429.045 -36.8906 429.419 -36.816 429.771 -36.7438C430.378 -36.6242 431.227 -36.4356 432.428 -36.2523C433.028 -36.1615 433.721 -36.0769 434.532 -36.0632C435.339 -36.0534 436.29 -36.1149 437.298 -36.4729C437.804 -36.6385 438.302 -36.8957 438.794 -37.2048C439.033 -37.3787 439.288 -37.5351 439.516 -37.7605C439.63 -37.869 439.756 -37.968 439.863 -38.0906C439.969 -38.2173 440.076 -38.3441 440.183 -38.4708C440.585 -39.0093 440.922 -39.6533 441.087 -40.36C441.245 -41.0619 441.295 -41.8006 441.211 -42.5236C441.061 -43.9793 440.534 -45.3835 439.853 -46.7869C439.509 -47.4894 439.114 -48.1853 438.684 -48.8866C438.47 -49.2437 438.255 -49.5754 438.036 -49.9299C437.987 -50.0054 437.941 -50.0791 437.892 -50.1546L437.861 -50.2043C437.876 -50.2183 437.894 -50.2303 437.914 -50.2446C437.836 -50.198 438.202 -50.4311 438.461 -50.5962C439.016 -50.9486 439.658 -51.3547 440.372 -51.809C441.803 -52.7114 443.524 -53.7985 445.425 -54.9977C446.336 -55.5719 447.291 -56.1709 448.275 -56.789L448.326 -56.8229C448.342 -56.8285 448.363 -56.8575 448.374 -56.8291L448.412 -56.782L448.504 -56.6579C448.854 -56.1741 449.194 -55.6643 449.531 -55.1417C449.866 -54.6085 450.202 -54.0711 450.54 -53.5318C450.86 -52.9887 451.204 -52.4562 451.506 -51.9012C452.14 -50.8042 452.697 -49.6712 453.218 -48.5372C454.609 -45.4748 455.414 -42.5189 455.622 -39.8407C455.835 -37.1587 455.451 -34.7733 454.708 -32.833C453.969 -30.8848 452.931 -29.3702 451.906 -28.2006C450.869 -27.0365 449.854 -26.1974 448.994 -25.5647C448.74 -25.3769 448.489 -25.1936 448.225 -25.0259C447.964 -24.8543 447.711 -24.6813 447.441 -24.5299C447.177 -24.3728 446.912 -24.2175 446.652 -24.0608C446.391 -23.9059 446.118 -23.7795 445.858 -23.6394C445.335 -23.3486 444.792 -23.1336 444.267 -22.8909C444.001 -22.7819 443.73 -22.6891 443.467 -22.5865L443.07 -22.4368L442.67 -22.3139C441.607 -21.9637 440.54 -21.7558 439.49 -21.6187C438.439 -21.4751 437.397 -21.4582 436.377 -21.4936C435.354 -21.5266 434.349 -21.6452 433.361 -21.7966C432.866 -21.869 432.377 -21.9631 431.889 -22.0529C431.396 -22.1508 430.914 -22.258 430.418 -22.3472C429.434 -22.5326 428.468 -22.7237 427.477 -22.8686C426.491 -23.014 425.476 -23.1064 424.439 -23.0396C423.318 -22.955 422.489 -22.6083 422.02 -22.2885C421.775 -22.1351 421.62 -21.979 421.526 -21.8617C421.431 -21.7444 421.396 -21.6575 421.422 -21.6051L421.393 -21.4788C421.408 -21.4697 421.421 -21.4749 421.419 -21.4957L421.417 -21.6089L421.441 -21.5816C421.478 -21.5345 421.572 -21.5216 421.717 -21.5384C421.86 -21.5571 422.053 -21.6116 422.306 -21.665C422.804 -21.7878 423.52 -21.9506 424.501 -21.9791C426.333 -22.0036 428.217 -21.4933 430.151 -21.0651C432.069 -20.5956 434.122 -20.121 436.309 -19.9979C437.401 -19.9331 438.53 -19.9303 439.679 -20.0655C440.824 -20.1921 441.997 -20.4071 443.155 -20.7739L443.593 -20.9042L444.026 -21.0614C444.313 -21.168 444.608 -21.2671 444.896 -21.3844C445.464 -21.6371 446.054 -21.8709 446.616 -22.1755C446.899 -22.3238 447.191 -22.4604 447.471 -22.6231C447.751 -22.7858 448.03 -22.9527 448.316 -23.1181C448.602 -23.2793 448.877 -23.4647 449.157 -23.6505C449.44 -23.8303 449.714 -24.0282 449.988 -24.2304C450.841 -24.8582 451.905 -25.7016 453.021 -26.8957C453.309 -27.1871 453.571 -27.5225 453.863 -27.8605C454.004 -28.0321 454.137 -28.2178 454.276 -28.4019C454.418 -28.5841 454.554 -28.7744 454.686 -28.9767C455.233 -29.7648 455.74 -30.6669 456.174 -31.6739C457.054 -33.6806 457.614 -36.1379 457.566 -38.8279C457.534 -41.5171 456.936 -44.407 455.846 -47.313C455.131 -49.2086 454.232 -51.0191 453.22 -52.7275C453 -53.1092 452.768 -53.4857 452.531 -53.8595C452.294 -54.2398 452.058 -54.6159 451.817 -54.9852C451.333 -55.728 450.844 -56.4872 450.306 -57.24C450.171 -57.4276 450.035 -57.6151 449.893 -57.8043C449.653 -58.1255 449.383 -58.4567 449.123 -58.7678L448.927 -59.0067L448.828 -59.1241L448.779 -59.1849L448.713 -59.1435L448.187 -58.821L447.222 -58.2106C446.463 -57.721 445.702 -57.2332 444.944 -56.7458C443.425 -55.7748 441.918 -54.8133 440.448 -53.8739C438.753 -52.7996 437.104 -51.7523 435.527 -50.7531C435.991 -50.0108 436.451 -49.2806 436.903 -48.5602C437.066 -48.3037 437.217 -48.0566 437.362 -47.8111C437.505 -47.5633 437.664 -47.3253 437.793 -47.0784C438.349 -46.1047 438.792 -45.1297 439.105 -44.1938C439.417 -43.2556 439.58 -42.3464 439.535 -41.5453C439.493 -40.7422 439.25 -40.0623 438.851 -39.5598C438.46 -39.0496 437.954 -38.691 437.475 -38.4375C436.995 -38.1882 436.554 -38.0451 436.181 -37.9645C435.996 -37.9233 435.825 -37.9043 435.679 -37.8769C435.529 -37.8639 435.404 -37.8531 435.302 -37.8421C435.2 -37.8312 435.122 -37.8308 435.068 -37.8302C435.013 -37.8297 434.988 -37.8275 434.988 -37.8275C434.988 -37.8275 434.871 -37.8258 434.651 -37.8214C434.54 -37.8264 434.399 -37.8289 434.237 -37.8337C434.073 -37.8405 433.88 -37.8594 433.667 -37.8766C432.801 -37.959 431.531 -38.193 429.936 -38.5373C429.151 -38.6875 428.292 -38.9299 427.33 -39.1213C426.369 -39.3108 425.335 -39.5003 424.228 -39.5889C423.123 -39.684 421.952 -39.7105 420.741 -39.6161C419.533 -39.5114 418.291 -39.2883 417.058 -38.9422C415.82 -38.5999 414.613 -38.0966 413.43 -37.5304C412.848 -37.2281 412.256 -36.9335 411.697 -36.5849C411.125 -36.2584 410.565 -35.8951 410.019 -35.512C407.837 -33.9779 405.925 -31.9888 404.62 -29.7209C403.3 -27.462 402.621 -24.9776 402.422 -22.6921C402.327 -21.5467 402.342 -20.4485 402.416 -19.4205C402.469 -18.9089 402.508 -18.4129 402.588 -17.9394C402.625 -17.7034 402.656 -17.469 402.697 -17.2417C402.742 -17.0148 402.786 -16.792 402.83 -16.5776C403.106 -15.2754 403.444 -14.0752 403.836 -12.9845C404.024 -12.4364 404.237 -11.9177 404.431 -11.4142C404.65 -10.9212 404.839 -10.434 405.058 -9.98298C405.906 -8.16173 406.754 -6.6679 407.532 -5.40717C408.303 -4.16047 408.956 -3.11338 409.589 -2.21778C409.677 -2.09742 409.763 -1.97896 409.846 -1.8624C409.972 -1.69494 410.097 -1.53165 410.231 -1.36908C410.364 -1.21067 410.493 -1.0519 410.619 -0.899205C410.683 -0.822855 410.748 -0.748768 410.811 -0.672419C410.838 -0.607579 410.885 -0.664166 410.925 -0.684437L411.049 -0.758101C411.375 -0.947891 411.688 -1.14077 411.994 -1.33518C412.199 -1.46416 412.396 -1.58825 412.583 -1.70518C414.541 -2.94081 416.392 -4.10837 418.154 -5.22217C419.034 -5.78098 419.891 -6.32738 420.73 -6.86175C421.15 -7.13101 421.563 -7.39348 421.975 -7.65786C422.182 -7.7891 422.388 -7.9245 422.593 -8.05348L423.1 -8.37651L423.351 -8.53671L423.58 -8.69928L424.035 -9.02403L424.063 -9.04323L424.074 -9.05681C424.074 -9.05681 424.071 -9.06287 424.069 -9.06894L424.03 -9.12852L423.95 -9.24961L423.794 -9.48571C423.591 -9.79544 423.369 -10.1056 423.118 -10.405L422.846 -10.7381L422.646 -10.9914C422.584 -11.0742 422.525 -11.1592 422.472 -11.2385L422.296 -11.5213C422.062 -11.9038 421.823 -12.2818 421.616 -12.6688C421.392 -13.0502 421.203 -13.4408 421.015 -13.8274C420.658 -14.6063 420.324 -15.3894 420.137 -16.1874C419.943 -16.9804 419.861 -17.7833 419.977 -18.536L419.987 -18.5349Z" fill="#0055CC"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#0055CC"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#0055CC"/>
<path d="M384.78 4.00317C387.938 3.20902 387.727 2.24328 384.526 2.8355C382.254 3.25484 379.932 3.70159 377.414 4.2115C376.157 4.47157 374.85 4.74014 373.477 5.02282C372.791 5.16832 372.086 5.31754 371.367 5.47009L371.218 5.49975C371.197 5.50156 371.166 5.52111 371.163 5.48779C371.092 5.3198 371.022 5.14955 370.951 4.97739C369.623 1.76683 368.946 -0.312608 368.381 -2.12056C367.842 -3.9371 367.411 -5.50071 367.051 -7.83206C366.893 -8.815 366.773 -9.88939 366.688 -11.0193C366.622 -12.1487 366.576 -13.3344 366.64 -14.536C366.704 -15.7375 366.819 -16.9582 367.064 -18.1397C367.308 -19.3212 367.637 -20.4743 368.076 -21.5384C368.18 -21.8056 368.312 -22.0583 368.428 -22.3159C368.488 -22.4429 368.547 -22.5717 368.605 -22.6964C368.676 -22.8221 368.743 -22.9475 368.812 -23.071C369.086 -23.5669 369.355 -24.0518 369.614 -24.5212C369.889 -24.9814 370.184 -25.4057 370.452 -25.8255C370.59 -26.0304 370.716 -26.2407 370.855 -26.4332C371 -26.62 371.14 -26.8041 371.278 -26.9818C371.556 -27.3353 371.803 -27.6799 372.06 -27.9813C372.327 -28.2708 372.576 -28.5442 372.802 -28.7905C373.238 -29.3046 373.671 -29.64 373.952 -29.9099L374.459 -30.3798L375.001 -30.8128C375.161 -30.9442 375.356 -31.1016 375.579 -31.2847C375.688 -31.3822 375.817 -31.471 375.954 -31.5606C376.091 -31.6542 376.237 -31.7509 376.39 -31.8543C376.986 -32.2879 377.767 -32.7207 378.666 -33.1973C380.483 -34.1269 382.926 -34.9702 385.749 -35.687C386.452 -35.8718 387.182 -36.0463 387.929 -36.2181C388.673 -36.3959 389.442 -36.5611 390.222 -36.7357C390.745 -36.8524 391.276 -36.9698 391.811 -37.0875C391.827 -37.0973 391.829 -37.0806 391.834 -37.0685L391.843 -37.0295L391.877 -36.8813C391.965 -36.4755 392.052 -36.0698 392.138 -35.6618C392.826 -32.3978 393.535 -29.0517 394.215 -25.8333C394.699 -23.5608 395.138 -21.507 395.533 -19.657C395.709 -18.833 395.874 -18.0563 396.03 -17.3228L396.047 -17.2508C396.046 -17.2319 396.008 -17.237 395.99 -17.2291C395.759 -17.1839 395.532 -17.139 395.315 -17.0972C393.858 -16.8198 392.563 -16.5564 391.456 -16.2549C390.349 -15.9574 389.427 -15.6237 388.695 -15.2811C387.829 -14.8809 387.014 -14.3843 386.312 -13.7653C385.606 -13.1501 385.025 -12.4137 384.602 -11.6258C384.182 -10.8319 383.945 -10.0036 383.788 -9.19684C383.737 -8.79165 383.662 -8.39072 383.656 -7.99783C383.648 -7.79989 383.64 -7.60612 383.631 -7.41235C383.631 -7.2193 383.643 -7.02734 383.649 -6.83691C383.805 -3.79328 384.714 -1.22835 385.709 1.20748C386.262 2.50247 386.762 3.06972 386.983 3.0044L386.993 2.90906C386.995 2.92988 387.006 2.93939 387.029 2.93532L387.023 2.9883C387.233 2.86729 387.157 2.12695 386.709 0.831265C385.907 -1.60452 385.185 -4.13535 385.149 -6.8662C385.149 -7.03616 385.145 -7.20576 385.149 -7.37608C385.164 -7.54521 385.174 -7.71399 385.187 -7.88504C385.199 -8.2302 385.278 -8.56223 385.326 -8.90422C385.476 -9.57396 385.682 -10.2423 386.022 -10.8571C386.365 -11.4682 386.82 -12.0321 387.389 -12.52C387.957 -13.0078 388.635 -13.4232 389.39 -13.7698C389.972 -14.0448 390.76 -14.3208 391.748 -14.5722C392.735 -14.8236 393.919 -15.0374 395.292 -15.2697C395.66 -15.3352 396.039 -15.3995 396.429 -15.469C396.772 -15.5364 397.118 -15.6043 397.469 -15.6724C397.646 -15.7088 397.826 -15.7432 398.003 -15.7796L398.137 -15.8059L398.206 -15.8181C398.206 -15.8181 398.218 -15.8192 398.222 -15.8237L398.22 -15.8404L398.213 -15.8733L398.161 -16.1416C397.961 -17.1481 397.754 -18.2066 397.532 -19.3163C397.2 -21.0059 396.833 -22.8478 396.421 -24.8327C396.152 -26.1249 395.86 -27.4132 395.553 -28.6874C394.886 -31.4349 394.198 -34.3926 393.546 -37.2862L393.341 -38.2231L393.235 -38.7028L393.183 -38.9396L393.156 -39.0589C393.152 -39.0775 393.15 -39.1025 393.141 -39.1143L393.079 -39.1005C392.467 -38.9657 391.858 -38.8289 391.251 -38.6944C390.541 -38.5343 389.839 -38.3748 389.149 -38.2206C387.771 -37.9081 386.435 -37.6014 385.194 -37.2777C382.705 -36.6507 380.584 -35.9233 379.116 -35.303C378.753 -35.1373 378.426 -34.9872 378.141 -34.8597C377.997 -34.7948 377.866 -34.7352 377.745 -34.6785C377.627 -34.6158 377.521 -34.5583 377.422 -34.5058C377.038 -34.2962 376.829 -34.1816 376.829 -34.1816C376.829 -34.1816 376.751 -34.1391 376.605 -34.0572C376.459 -33.9712 376.233 -33.8676 375.972 -33.6855C375.704 -33.5091 375.379 -33.2921 374.999 -33.0431C374.904 -32.9803 374.807 -32.9152 374.705 -32.8498C374.611 -32.7744 374.511 -32.6965 374.413 -32.6167C374.213 -32.4566 373.998 -32.2891 373.775 -32.1102C373.313 -31.7722 372.875 -31.3252 372.39 -30.8677C371.887 -30.4254 371.447 -29.8606 370.947 -29.3074C370.689 -29.0333 370.468 -28.7245 370.238 -28.4087C370.006 -28.097 369.77 -27.7743 369.529 -27.4513C369.295 -27.1226 369.093 -26.7673 368.869 -26.4185C368.652 -26.0639 368.416 -25.714 368.211 -25.3458C368.012 -24.9719 367.81 -24.5935 367.61 -24.2131C367.412 -23.8267 367.19 -23.4612 367.018 -23.0414C366.838 -22.6334 366.644 -22.2242 366.501 -21.7963L366.27 -21.1595C366.194 -20.9452 366.142 -20.7266 366.076 -20.5111C365.569 -18.7781 365.306 -16.9907 365.209 -15.2722C365.017 -11.8291 365.44 -8.6765 365.857 -6.37103C366.505 -2.89797 367.285 -0.399449 367.899 1.48819C368.53 3.37439 369.032 4.64646 369.43 5.61072C369.519 5.81702 369.604 6.02368 369.693 6.2258C369.821 6.52311 369.954 6.82006 370.092 7.11438L370.193 7.33434L370.219 7.39085C370.227 7.40905 370.255 7.38986 370.274 7.39032L370.391 7.36545L370.861 7.27014C371.154 7.20702 371.444 7.142 371.732 7.07923C372.451 6.91835 373.155 6.76081 373.838 6.60923C375.206 6.2955 376.507 5.99813 377.757 5.70926C380.258 5.1232 382.558 4.56506 384.799 4.00364L384.78 4.00317Z" fill="#0055CC"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#0055CC"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#0055CC"/>
<path d="M334.463 4.55043C336.378 5.19855 337.423 5.25896 337.511 5.00382C337.601 4.73999 336.74 4.16631 334.878 3.42756C332.352 2.4169 329.793 1.33152 327.049 0.0860085C325.677 -0.537881 324.262 -1.20208 322.786 -1.9218C322.048 -2.27958 321.294 -2.65483 320.524 -3.0434C320.14 -3.23882 319.751 -3.43804 319.356 -3.63881C318.73 -3.96432 318.098 -4.29136 317.454 -4.62376C317.2 -4.26182 316.851 -3.76363 316.498 -3.26091C311.509 3.94463 310.444 5.82257 307.026 10.6636C306.168 11.8815 305.22 13.2247 304.201 14.6706C303.026 16.3251 301.771 18.0936 300.448 19.9519C301.609 20.5878 302.784 21.2287 303.958 21.8718C304.893 22.372 305.832 22.8676 306.756 23.3477C308.612 24.3052 310.431 25.205 312.103 26.0043C315.451 27.6025 318.222 28.8038 319.543 29.3586C320.099 29.5979 320.659 29.8221 321.228 30.0372C323.093 30.7483 327.879 32.5744 334.242 34.4547C337.42 35.4003 340.99 36.3582 344.761 37.2378C346.647 37.6765 348.582 38.0984 350.545 38.4927C351.525 38.691 352.513 38.8802 353.502 39.0631L354.99 39.3328L357.469 39.7599C357.512 39.07 357.618 37.3781 357.721 35.7073C358.398 24.2427 358.818 17.1478 359.038 13.4422C359.115 12.0821 359.191 10.7663 359.248 9.79823C358.525 9.66157 357.813 9.53027 357.113 9.39788C356.669 9.31047 356.23 9.22686 355.799 9.14253C354.934 8.97197 354.095 8.79926 353.278 8.62663C351.643 8.27947 350.096 7.92473 348.607 7.5691C345.63 6.85142 342.892 6.12149 340.191 5.33379C338.504 4.8422 337.595 4.76987 337.515 5.00346C337.437 5.2242 338.192 5.75466 339.861 6.35065C342.533 7.3025 345.259 8.16562 348.242 8.98554C349.733 9.39341 351.289 9.78944 352.935 10.1692C353.757 10.3623 354.602 10.5471 355.474 10.7317C356.136 10.8674 356.819 11.0054 357.52 11.1503C357.485 11.7346 357.434 12.53 357.383 13.3486C357.181 16.7484 356.524 23.8218 355.888 33.8225C355.843 34.6301 355.797 35.4335 355.753 36.2389L355.697 37.4438C355.695 37.5154 355.695 37.4881 355.696 37.4965L355.7 37.5003L355.703 37.5147L355.713 37.5495C355.713 37.5495 355.699 37.557 355.686 37.5581C355.653 37.5568 355.753 37.5796 355.443 37.531C355.007 37.4618 354.566 37.3929 354.124 37.3222C353.241 37.1784 352.344 37.0274 351.449 36.8616C349.654 36.5388 347.844 36.1754 346.062 35.7822C342.497 35.0064 339.05 34.105 336.046 33.2324C333.043 32.3575 330.487 31.5175 328.681 30.8914C327.778 30.573 327.064 30.3202 326.573 30.1467C326.083 29.9667 325.818 29.8679 325.818 29.8679C321.699 28.3744 317.646 26.7051 313.653 24.9006C311.657 23.9951 309.679 23.0545 307.719 22.0746C306.741 21.5844 305.762 21.086 304.793 20.5804L303.34 19.8146L302.638 19.4369L309.085 10.2354C314.014 3.19241 316.386 -0.198335 317.845 -2.28244C317.896 -2.35604 317.946 -2.42965 317.981 -2.48098C318.602 -2.1676 319.205 -1.86528 319.791 -1.56985C320.573 -1.18236 321.337 -0.814252 322.09 -0.459821C323.592 0.247136 325.035 0.892152 326.437 1.484C329.24 2.67411 331.869 3.66742 334.463 4.55459L334.463 4.55043Z" fill="#0055CC"/>
<path d="M266.148 11.4376C265.904 11.2409 261.607 11.6971 262.767 12.4216C263.152 12.7387 263.531 12.7338 263.685 12.3129C263.756 13.1539 264.635 12.0998 265.004 12.398C264.83 12.9693 266.069 11.8381 265.807 12.4269C270.358 13.3708 279.961 8.37317 268.469 10.984C269.573 11.3221 268.502 11.4792 268.006 11.3161C268.775 10.623 266.63 11.1225 266.225 11.3523C266.878 11.3825 265.768 11.8563 266.15 11.4397L266.148 11.4376Z" fill="#101214"/>
<path d="M272.605 3.22316C273.458 2.36056 274.245 3.76267 275.035 3.06913C276.28 1.68993 267.453 -0.414982 267.475 1.23096C267.685 2.6437 272.067 2.52666 272.605 3.22316Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_550_14457)">
<path d="M13.0459 7.94648C13.2244 7.80301 13.375 7.65148 13.5135 7.50519C13.6519 7.3589 13.7767 7.22429 13.8912 7.09266C14.1165 6.83394 14.2962 6.60644 14.4242 6.41279C14.6826 6.0274 14.7534 5.77787 14.657 5.68132C14.5605 5.58477 14.2987 5.63893 13.898 5.85831C13.6977 5.968 13.4612 6.12069 13.1927 6.31602C13.0586 6.41577 12.9146 6.52266 12.7657 6.64468C12.6168 6.7667 12.4583 6.90004 12.2783 7.02685C11.7797 7.3995 11.2791 7.7744 10.7705 8.1542C10.2398 8.49606 9.70493 8.83827 9.16244 9.18954C8.60947 9.51654 8.02636 9.81049 7.44957 10.1291C7.15404 10.2785 6.84575 10.4017 6.5389 10.5416C6.23133 10.6732 5.92782 10.8275 5.60858 10.9454C5.28898 11.0591 4.96332 11.1755 4.63765 11.2918C4.47464 11.3479 4.31044 11.4146 4.1448 11.4646C3.97464 11.5109 3.80449 11.5571 3.63433 11.6033C3.29175 11.6939 2.94835 11.7992 2.59636 11.8779C2.24139 11.9465 1.88225 12.0154 1.51931 12.0888C0.0606176 12.3264 -1.49813 12.4259 -3.12925 12.2945C-3.56103 12.2753 -3.97141 12.2123 -4.35537 12.1637C-4.54794 12.1447 -4.73171 12.1061 -4.90643 12.0751C-4.9938 12.0596 -5.08116 12.0441 -5.16436 12.0282C-5.22411 12.0166 -5.28576 12.0072 -5.34551 11.9956C-5.43287 11.9801 -5.5081 11.9594 -5.58713 11.9432C-6.21656 11.7732 -6.77491 11.6244 -7.25162 11.4978C-7.70977 11.3676 -8.08591 11.2638 -8.36563 11.1831C-8.05452 12.2599 -7.73595 13.2771 -7.45896 14.2015C-7.28585 14.7489 -7.12621 15.2617 -6.97515 15.748C-6.68674 16.6588 -6.42815 17.4673 -6.18005 18.2515C-5.68384 19.8199 -5.22994 21.2871 -4.66961 23.2339C-4.04204 25.3764 -3.32537 27.8951 -2.58721 30.5168C-2.22004 31.83 -1.84428 33.1696 -1.4715 34.4991C-1.25363 35.2733 -1.04029 36.0438 -0.825398 36.8078C-0.802628 36.8772 -0.789367 36.9578 -0.758627 37.0223L-0.551516 37.0883L-0.137285 37.2202L0.276945 37.3522L0.53893 37.4218C0.71283 37.4676 0.884474 37.5114 1.05837 37.5572C1.23346 37.5924 1.40628 37.6257 1.57946 37.6631C4.36235 38.2066 7.04848 37.8962 9.14027 37.3602C9.66062 37.2144 10.1485 37.0567 10.6086 36.9182C11.0609 36.7615 11.4697 36.5876 11.8496 36.4434C12.2341 36.3031 12.5622 36.1425 12.8562 35.9995C13.1502 35.8565 13.4062 35.7357 13.6198 35.6332C13.8785 35.5185 14.1157 35.3742 14.3552 35.2317L15.0752 34.7979C15.254 34.6817 15.4828 34.5611 15.7156 34.3899C15.9507 34.2205 16.2176 34.0316 16.5119 33.8194C16.8017 33.6033 17.1399 33.3894 17.4667 33.1155C17.7957 32.8436 18.1502 32.5506 18.5283 32.2388C18.716 32.0798 18.9169 31.9281 19.1073 31.7521C19.2955 31.5743 19.4897 31.3938 19.6897 31.2065C20.0835 30.8345 20.499 30.446 20.9358 30.0368C21.3513 29.6482 21.7823 29.2458 22.2305 28.8229C22.6881 28.4119 23.1922 28.0283 23.6952 27.6091C23.943 27.3925 24.219 27.2112 24.4958 27.0152C24.7708 26.8214 25.0517 26.625 25.3346 26.4263C25.4725 26.322 25.6221 26.2314 25.772 26.145C25.9215 26.0544 26.0733 25.9657 26.2248 25.8728C26.5303 25.6932 26.8325 25.4991 27.1493 25.329C28.4302 24.6598 29.8119 24.0406 31.3018 23.6052C32.7947 23.1799 34.3762 22.9064 36.0024 22.8599C36.8156 22.8251 37.6359 22.8736 38.4607 22.9489L39.0913 23.0348L39.4056 23.0789L40.0042 23.2075C40.8225 23.3779 41.6365 23.5717 42.4509 23.7697C42.1544 22.74 41.401 20.1363 40.667 17.5876C37.7264 7.53183 35.9053 1.30688 34.9535 -1.94261C34.9552 -2.23861 34.6651 -2.19668 34.4682 -2.26564C34.2584 -2.3146 34.0485 -2.36355 33.8387 -2.41251L33.6803 -2.44913C33.6311 -2.45956 33.6141 -2.46227 33.5778 -2.46961L33.3902 -2.50372L33.0173 -2.57001C32.7696 -2.61988 32.5206 -2.63607 32.2744 -2.66928L31.9055 -2.71284L31.5408 -2.73367C30.5668 -2.81081 29.6218 -2.74779 28.7074 -2.67062C26.8858 -2.45607 25.2051 -1.99564 23.6927 -1.35886C23.3041 -1.21817 22.9496 -1.02168 22.5817 -0.859698C22.4004 -0.772642 22.2187 -0.689742 22.0393 -0.604949C21.8648 -0.512183 21.6929 -0.413354 21.5206 -0.318686C21.1787 -0.123287 20.8406 0.0675779 20.5024 0.258452C20.1809 0.47097 19.8612 0.681234 19.5415 0.89149C19.3828 0.99757 19.226 1.10138 19.0692 1.20519C18.9128 1.31317 18.7677 1.43066 18.618 1.54435C18.321 1.77363 18.0236 1.99874 17.7304 2.22349C17.4281 2.44063 17.165 2.69844 16.8834 2.93687C16.6064 3.1791 16.3335 3.42097 16.0565 3.6632C14.9003 4.78106 14.4954 5.51069 14.6627 5.67453C14.8371 5.84825 15.5686 5.4743 16.7575 4.469C17.0367 4.25176 17.3182 4.03643 17.6015 3.81883C17.8853 3.60539 18.1547 3.37221 18.455 3.18042C18.7503 2.98066 19.0435 2.77901 19.3427 2.57472C19.4915 2.47579 19.6354 2.36889 19.7888 2.27377C19.9425 2.18281 20.0981 2.08959 20.256 1.99827C20.5672 1.81183 20.8807 1.62728 21.1938 1.43857C21.5194 1.27187 21.8468 1.10292 22.1765 0.935855C22.3434 0.852145 22.5062 0.768783 22.675 0.682808C22.8449 0.60933 23.0189 0.535501 23.193 0.461662C23.5419 0.322314 23.8814 0.148096 24.2446 0.0284898C25.6722 -0.5212 27.2231 -0.905332 28.8787 -1.07402C29.7068 -1.13111 30.5609 -1.17788 31.436 -1.10266L31.7652 -1.08084L32.0939 -1.04009C32.3148 -1.00888 32.5385 -0.994695 32.7585 -0.948727C32.959 -0.911546 33.1636 -0.874721 33.3663 -0.835639L33.4906 -0.804459C33.5296 -0.791045 33.5901 -0.794202 33.5831 -0.753728C33.7626 -0.108343 33.9886 0.711361 34.2604 1.69705C34.563 2.82065 34.9173 4.13071 35.3166 5.62151C36.1212 8.60049 37.1258 12.2923 38.3635 16.5934C38.7677 17.9957 39.1924 19.3919 39.6324 20.7701L39.7103 21.0172L39.7503 21.1397C39.7503 21.1397 39.7548 21.1435 39.757 21.1454C39.7661 21.153 39.7713 21.1651 39.7789 21.1792C39.7935 21.2031 39.816 21.2452 39.8321 21.2858C39.8094 21.2898 39.7776 21.2863 39.7337 21.288L39.7 21.2867L39.6811 21.2863L39.5858 21.2756L39.0005 21.2047C38.6159 21.1478 38.1999 21.1419 37.8004 21.1073C37.3951 21.0795 36.9912 21.0914 36.5855 21.0825C34.9651 21.0992 33.3478 21.3233 31.8071 21.7044C28.7091 22.4451 25.9889 23.9167 23.8329 25.4108C23.5617 25.6001 23.2986 25.7845 23.0374 25.9666C22.7852 26.1563 22.5484 26.3552 22.3129 26.5434C22.0774 26.7317 21.8479 26.9174 21.6222 27.0985C21.5105 27.19 21.3985 27.2773 21.2906 27.3643C21.1876 27.4593 21.0865 27.552 20.9873 27.6424C20.2001 28.3674 19.5102 29.0042 18.937 29.5344C18.6591 29.7914 18.4082 30.0209 18.1904 30.2202C18.0817 30.3219 17.9806 30.4146 17.8871 30.4983C17.7891 30.5781 17.6987 30.6489 17.6204 30.7144C17.3005 30.9709 17.13 31.1094 17.13 31.1094C17.13 31.1094 16.8416 31.3422 16.3261 31.7624C16.0647 31.9676 15.7272 32.1899 15.3418 32.4646C15.15 32.6009 14.9442 32.7446 14.7266 32.8977C14.509 33.0509 14.2624 33.1835 14.0092 33.3376C13.758 33.4895 13.4926 33.6489 13.2175 33.8154C12.9446 33.9838 12.637 34.1154 12.3319 34.2761C12.0216 34.4247 11.7142 34.6066 11.3733 34.7411C11.037 34.8794 10.6885 35.0229 10.3339 35.169C8.89465 35.705 7.25528 36.1346 5.51244 36.2647C4.64192 36.3402 3.74838 36.319 2.85551 36.2327L2.18746 36.1501L1.52224 36.0273C1.30062 35.9877 1.08518 35.9225 0.864745 35.8723L0.70406 35.8338L0.64585 35.8158L0.529429 35.7797C0.476824 35.778 0.495606 35.7281 0.478692 35.7023L0.439583 35.5651L0.23949 34.8753C0.105343 34.4149 -0.0284482 33.9585 -0.162235 33.5022C-0.429811 32.5896 -0.692493 31.685 -0.951844 30.7947C-1.99079 27.2401 -2.95224 23.9516 -3.66507 21.5018L-5.03013 16.8425L-5.71171 14.5117L-5.92228 13.7977L-5.96736 13.64L-5.99086 13.5623L-6.00278 13.5214C-6.00278 13.5214 -6.02077 13.4831 -6.00077 13.496C-5.91685 13.5202 -5.83258 13.5486 -5.74485 13.5683L-5.6163 13.5991L-5.29637 13.6595C-5.12807 13.689 -4.95906 13.7268 -4.78886 13.754L-4.27933 13.8231L-3.7698 13.8922L-3.25864 13.9319C-1.47352 14.073 0.223859 13.951 1.8069 13.6711C2.20054 13.5887 2.59002 13.5067 2.97117 13.4254C3.3535 13.3335 3.71855 13.2116 4.08731 13.1083C4.27151 13.0546 4.45344 12.999 4.63347 12.9456C4.81315 12.8881 4.98721 12.8142 5.162 12.7487C5.51122 12.6135 5.85438 12.481 6.19753 12.3484C6.53616 12.212 6.85488 12.0396 7.17958 11.8877C7.49939 11.7278 7.82481 11.5842 8.13331 11.4148C8.73565 11.052 9.34051 10.7184 9.90882 10.3502C10.4625 9.95811 11.0127 9.57471 11.5478 9.18631C12.0546 8.7626 12.5558 8.34566 13.0547 7.92683L13.0459 7.94648Z" fill="#0055CC"/>
<path d="M114.495 32.3233C112.222 31.5594 111.865 32.4842 114.065 33.4412C115.623 34.1181 117.228 34.7952 118.977 35.5123C119.855 35.8642 120.766 36.2322 121.724 36.617C122.269 36.8321 122.83 37.0521 123.405 37.2771C123.642 37.3719 123.882 37.4581 124.118 37.5446L124.298 37.6109L124.387 37.6431L124.432 37.658C124.448 37.6672 124.451 37.6354 124.461 37.6282L124.677 37.3074C124.82 37.0915 124.962 36.8714 125.107 36.6532C125.214 36.4803 125.323 36.3051 125.431 36.1299C126.78 33.8413 127.434 32.3201 127.986 30.9923C128.522 29.6576 128.956 28.5121 129.531 26.8088C130.002 25.3663 130.481 23.6442 130.752 21.7826C131.029 19.9289 131.072 17.9297 130.72 16.0614C130.685 15.8273 130.618 15.6003 130.566 15.3718L130.485 15.0327C130.452 14.9243 130.42 14.8201 130.388 14.7117C130.257 14.2887 130.129 13.8759 130.004 13.4734C129.871 13.0758 129.708 12.6954 129.569 12.3277C129.497 12.143 129.427 11.9644 129.357 11.79C129.273 11.619 129.194 11.4517 129.115 11.2886C128.956 10.9624 128.812 10.6518 128.666 10.3665C128.501 10.0891 128.349 9.82956 128.209 9.59201C127.945 9.10715 127.656 8.75656 127.474 8.4912L127.134 8.0276L126.744 7.59974C126.627 7.47357 126.483 7.32232 126.319 7.14562C126.159 6.96439 125.94 6.79237 125.717 6.58514C125.273 6.16197 124.688 5.71968 124.013 5.24104C122.649 4.29127 120.829 3.37894 118.787 2.5467C117.766 2.12111 116.69 1.71915 115.586 1.30078C115.27 1.18135 114.951 1.06003 114.628 0.93906C114.367 0.83993 114.105 0.738895 113.84 0.640126L113.446 0.4897L113.246 0.41467L113.146 0.37717L113.096 0.35841C113.096 0.35841 113.082 0.389005 113.075 0.406389C112.755 1.2378 112.429 2.08018 112.103 2.92671C111.218 5.21915 110.304 7.56446 109.412 9.8156C108.794 11.4093 108.234 12.851 107.732 14.1514C107.421 14.9526 107.128 15.7103 106.85 16.4268C106.745 16.6982 106.644 16.965 106.543 17.2276L106.506 17.3274C106.489 17.3478 106.52 17.3471 106.533 17.3544L106.583 17.3731L106.78 17.4463C106.91 17.4938 107.038 17.5435 107.168 17.591C107.634 17.7625 108.085 17.9291 108.525 18.0903C109.559 18.458 110.424 18.7754 111.129 19.0899C111.836 19.4021 112.382 19.7072 112.788 19.9826C113.763 20.6283 114.417 21.4256 114.721 22.3225C115.031 23.2209 115.01 24.211 114.85 25.1627C114.514 27.0782 113.723 28.8274 112.888 30.5008C112.427 31.3926 112.339 31.952 112.53 32.0971L112.524 32.1921C112.543 32.1967 112.555 32.1914 112.562 32.174L112.566 32.1192C112.77 32.2253 113.25 31.9025 113.813 31.0312C114.839 29.3874 115.819 27.6386 116.32 25.4445C116.554 24.3541 116.654 23.1054 116.251 21.8205C116.047 21.1856 115.719 20.5657 115.278 20.0207C114.838 19.4734 114.298 19.004 113.712 18.6079C113.257 18.2948 112.658 17.946 111.931 17.5894C111.201 17.2309 110.34 16.8775 109.378 16.5014C109.259 16.4551 109.137 16.4069 109.015 16.3587L108.972 16.3415L108.965 16.3358L108.952 16.3285L108.932 16.3114L108.894 16.2874C108.885 16.2798 108.864 16.2774 108.883 16.2548C108.905 16.2235 108.922 16.1989 108.937 16.1767C109.05 15.9046 109.164 15.6303 109.285 15.345C109.769 14.1721 110.29 12.891 110.842 11.5045C111.2 10.6006 111.535 9.68824 111.85 8.77542C112.189 7.78926 112.548 6.77404 112.917 5.74334C113.278 4.74895 113.644 3.73943 114.005 2.74504L114.061 2.56814C114.061 2.56814 114.066 2.54885 114.07 2.54849L114.092 2.555L114.135 2.56806L114.223 2.59607L114.268 2.61102L114.292 2.61945L114.381 2.65161L114.756 2.78908C115.003 2.88097 115.248 2.97094 115.491 3.06319C115.976 3.24351 116.451 3.42266 116.91 3.60324C117.372 3.77931 117.813 3.96134 118.238 4.13648C119.943 4.84051 121.328 5.56817 122.259 6.15047C122.71 6.45973 123.088 6.68503 123.314 6.87524C123.546 7.05866 123.675 7.15875 123.675 7.15875C123.675 7.15875 123.72 7.1968 123.812 7.26645C123.898 7.33873 124.044 7.43095 124.196 7.58148C124.355 7.72712 124.549 7.90546 124.772 8.1127C124.829 8.16442 124.886 8.21615 124.948 8.27167C125.001 8.33208 125.059 8.39212 125.117 8.45634C125.233 8.58477 125.355 8.7189 125.483 8.861C126.504 9.99784 127.669 11.8 128.462 14.0309C128.555 14.3103 128.651 14.5957 128.747 14.8812C128.839 15.167 128.95 15.4574 129.012 15.7415C129.087 16.0288 129.164 16.3138 129.211 16.6119L129.291 17.0539C129.312 17.2032 129.325 17.3531 129.347 17.5023C129.488 18.7029 129.464 19.9345 129.335 21.1165C129.074 23.485 128.427 25.6372 127.869 27.2046C127.024 29.5691 126.192 31.2486 125.546 32.5173C124.889 33.7808 124.393 34.6273 124.007 35.2609C123.939 35.3738 123.871 35.4825 123.805 35.589L123.775 35.6377C123.775 35.6377 123.741 35.6281 123.724 35.6254L123.618 35.5863C123.167 35.4156 122.729 35.2521 122.3 35.0921C121.329 34.7356 120.408 34.3979 119.52 34.072C117.742 33.4309 116.096 32.8581 114.486 32.3157L114.495 32.3233Z" fill="#0055CC"/>
<path d="M63.2213 -4.91981C64.3036 -4.55832 64.931 -4.50988 65.0627 -4.7584C65.1871 -4.9937 64.7809 -5.5439 63.6473 -6.03733C62.8457 -6.3791 62.0109 -6.66763 61.1289 -6.89542C60.2473 -7.11905 59.3135 -7.2899 58.3289 -7.34513C57.8413 -7.40358 57.3321 -7.37202 56.8151 -7.38176C56.558 -7.36997 56.296 -7.34306 56.0313 -7.32222C55.898 -7.31066 55.7647 -7.29911 55.6314 -7.28755C55.497 -7.2654 55.3648 -7.24136 55.2303 -7.21921C54.1508 -7.06059 53.0339 -6.72876 51.9327 -6.21366C51.7776 -6.13937 51.624 -6.0715 51.4775 -5.99376C51.3356 -5.91221 51.1978 -5.83104 51.0597 -5.75402C50.7857 -5.59808 50.528 -5.44774 50.2994 -5.27685C50.0662 -5.10976 49.8377 -4.96196 49.6378 -4.79776C49.4383 -4.6294 49.2487 -4.46819 49.0667 -4.31603C48.7053 -4.00564 48.4124 -3.68019 48.1181 -3.3945C47.8555 -3.08218 47.5991 -2.79557 47.3722 -2.50733C46.4759 -1.34485 45.8317 -0.275565 45.0325 1.33172C44.3767 2.70416 43.7657 4.37696 43.3437 6.17395C42.9124 7.95917 42.6876 9.9258 42.8109 11.7679C42.9178 13.6155 43.3565 15.3442 43.9484 16.684C44.5304 18.031 45.2423 18.9618 45.621 19.485C45.8706 19.776 46.1183 20.0692 46.3915 20.3414C46.8871 20.8083 47.8267 21.6795 49.2654 22.4989C49.6286 22.6962 50.0023 22.9177 50.4196 23.1102C50.8332 23.3072 51.2794 23.4931 51.7434 23.6669C52.6774 24.0119 53.698 24.3137 54.8094 24.5258C57.0183 24.9575 59.6288 24.962 62.1114 24.1404C63.3524 23.7391 64.5396 23.1263 65.6002 22.3608C66.6654 21.5991 67.6064 20.6867 68.4118 19.7104C69.54 18.318 70.3115 16.8999 70.9125 15.5972C71.4954 14.2794 71.8779 13.0712 72.1641 11.9868C72.4458 10.8986 72.6224 9.93065 72.7077 9.09447C72.8141 8.26064 72.8305 7.55211 72.8419 6.97831C72.8528 4.26015 72.1712 1.85591 71.051 -0.0633815C70.4777 -1.01665 69.8234 -1.86426 69.0796 -2.58242C68.3284 -3.28736 67.5418 -3.9179 66.6795 -4.40338C66.2508 -4.67885 65.8679 -4.78834 65.5987 -4.84473C65.3256 -4.8966 65.1518 -4.86894 65.0821 -4.77687L65.145 -4.63126C65.1232 -4.66504 65.0952 -4.67311 65.0588 -4.65736L65.0431 -4.69376C65.0108 -4.58185 65.0816 -4.41803 65.2604 -4.21742C65.4355 -4.01228 65.7286 -3.80058 66.0982 -3.50529C66.8482 -2.98281 67.5077 -2.34335 68.1348 -1.66543C68.7505 -0.973925 69.282 -0.187015 69.7486 0.672685C70.2113 1.53691 70.5551 2.50588 70.8114 3.55585C71.0594 4.60655 71.2063 5.74994 71.1886 6.97894C71.1966 7.21745 71.1654 7.48872 71.1497 7.79223C71.1381 8.09539 71.0911 8.42678 71.0364 8.79032C70.948 9.51559 70.767 10.3601 70.5057 11.2954C69.9645 13.1699 69.1073 15.4663 67.5012 17.7163L67.3088 17.9911L67.1005 18.2525L66.6908 18.7811C66.3873 19.1054 66.1203 19.4642 65.8002 19.7668C65.6299 19.9327 65.4716 20.1164 65.2858 20.273C65.1023 20.4316 64.9187 20.5902 64.7333 20.7511C64.3409 21.0432 63.9478 21.35 63.5114 21.5935C62.6552 22.102 61.7221 22.5228 60.7441 22.7629C58.7947 23.2718 56.7658 23.2231 55.0396 22.865C53.3077 22.5136 51.8735 21.9413 50.9288 21.4483C50.4595 21.1889 50.0869 20.9799 49.8427 20.8249C49.602 20.6611 49.4726 20.5716 49.4726 20.5716C49.4726 20.5716 49.4235 20.5381 49.3322 20.4768C49.2405 20.4113 49.0971 20.3293 48.9364 20.1942C48.772 20.0637 48.5714 19.9027 48.3372 19.7174C48.1201 19.5117 47.8736 19.2813 47.5996 19.0239C47.0988 18.4714 46.5061 17.8031 46.0168 16.9475C45.52 16.1009 45.0877 15.1039 44.7938 14.0068C44.1804 11.8107 44.2512 9.25102 44.7058 6.95602C45.1626 4.63984 45.9616 2.59194 46.736 1.18404C47.8904 -0.951311 49.1258 -2.26907 50.1581 -3.12021C51.1942 -3.97588 52.0123 -4.41609 52.6484 -4.70413C53.6061 -5.15434 54.5704 -5.45614 55.5178 -5.6138C55.6356 -5.6345 55.753 -5.65937 55.8686 -5.68198C55.9871 -5.69435 56.1034 -5.70862 56.2219 -5.72099C56.4548 -5.74538 56.6851 -5.77583 56.9142 -5.79569C57.3752 -5.80208 57.8243 -5.8494 58.2681 -5.81234C60.0484 -5.77572 61.691 -5.41453 63.2383 -4.91709L63.2213 -4.91981Z" fill="#0055CC"/>
<path d="M149.643 41.1462C149.707 41.1386 149.772 41.135 149.834 41.1296C149.897 41.1284 149.958 41.1335 150.017 41.1368C150.136 41.1434 150.255 41.1393 150.367 41.1485C150.584 41.1884 150.799 41.195 150.983 41.2609C151.077 41.2863 151.167 41.3078 151.257 41.3294C151.342 41.3619 151.422 41.3948 151.5 41.4216C151.58 41.4504 151.654 41.4776 151.725 41.5028C151.793 41.5368 151.859 41.5689 151.92 41.5972C152.179 41.7027 152.367 41.8102 152.516 41.8582C152.665 41.9103 152.768 41.9119 152.818 41.8655C152.869 41.8192 152.863 41.7211 152.795 41.5675C152.727 41.4139 152.604 41.2022 152.364 40.9733C152.304 40.9155 152.242 40.8517 152.176 40.7882C152.104 40.7315 152.021 40.6736 151.936 40.6138C151.851 40.554 151.758 40.4908 151.66 40.4279C151.555 40.3783 151.444 40.3271 151.328 40.2721C151.099 40.1534 150.826 40.0974 150.536 40.0197C150.391 39.9903 150.237 39.9806 150.078 39.9629C149.999 39.955 149.919 39.9452 149.837 39.9418C149.757 39.9445 149.674 39.9476 149.59 39.9506C148.636 39.9788 147.736 40.254 146.905 40.6177C146.068 40.9798 145.315 41.471 144.572 41.9823C144.209 42.2488 143.842 42.5115 143.498 42.8057C143.142 43.0862 142.801 43.3864 142.46 43.695L142.203 43.9229C142.117 43.9975 142.015 44.1008 141.928 44.1902C141.84 44.2818 141.755 44.373 141.675 44.4639L141.463 44.7068L141.37 44.8029C141.341 44.8285 141.308 44.8776 141.28 44.8192L141.196 44.7216L141.177 44.698L141.059 44.5718L140.819 44.3157C140.497 43.9722 140.173 43.6226 139.843 43.2714C139.187 42.5688 138.512 41.8509 137.823 41.1133C136.438 39.6471 134.985 38.105 133.447 36.4758C133.366 36.3925 133.286 36.3093 133.205 36.2261L133.16 36.188C133.113 36.1606 133.152 36.1278 133.173 36.0987L133.224 36.0376C133.316 35.9373 133.407 35.8393 133.497 35.7413C133.679 35.5471 133.86 35.3593 134.04 35.1738C134.763 34.4418 135.456 33.7649 136.09 33.1581C137.34 31.9418 138.448 30.9918 139.511 30.1548C140.576 29.3197 141.597 28.587 142.741 27.9067C143.884 27.2263 145.144 26.5737 146.712 25.9993C147.041 25.8701 147.387 25.775 147.733 25.6568C148.083 25.5489 148.444 25.4588 148.809 25.36C149.549 25.1973 150.314 25.0408 151.105 24.9722C152.687 24.8036 154.367 24.8909 156.008 25.2858C157.649 25.6806 159.244 26.388 160.67 27.3471C162.105 28.2991 163.355 29.4853 164.442 30.7697C165.532 32.0453 166.437 33.3937 167.101 34.744C167.769 36.094 168.2 37.4415 168.453 38.689C168.707 39.9385 168.791 41.0831 168.821 42.0542C168.854 43.0248 168.81 43.826 168.784 44.399L168.72 45.4389C168.704 45.7886 168.699 46.1626 168.693 46.5093C168.686 47.1141 168.656 47.9581 168.694 49.1446C168.711 49.7348 168.755 50.4171 168.886 51.1989C169.02 51.9762 169.253 52.8834 169.791 53.7915C170.053 54.2472 170.391 54.6816 170.799 55.0868C171.204 55.5007 171.727 55.8667 172.326 56.1546C172.941 56.4245 173.637 56.5655 174.345 56.5693C175.051 56.5605 175.743 56.4082 176.418 56.1881C177.747 55.7099 178.979 54.9338 180.172 53.9974C180.767 53.5283 181.354 53.0136 181.936 52.4638C182.23 52.1929 182.508 51.9211 182.801 51.6419C182.857 51.5887 182.911 51.5337 182.968 51.4805L183.01 51.4391C183.026 51.4524 183.042 51.4657 183.06 51.481L183.076 51.4943L183.085 51.5019L183.154 51.5756C183.256 51.6801 183.36 51.7907 183.472 51.9047C183.91 52.3619 184.42 52.8906 184.982 53.4797C186.108 54.6578 187.46 56.0766 188.952 57.6405C189.633 58.3557 190.346 59.1059 191.082 59.8793C191.101 59.907 191.162 59.9353 191.113 59.9669L191.075 60.0121L190.913 60.1856C190.524 60.6075 190.105 61.0278 189.673 61.445C189.235 61.8649 188.793 62.2851 188.349 62.7117C187.9 63.1179 187.462 63.5461 186.997 63.9389C186.087 64.7501 185.126 65.5027 184.164 66.2239C181.541 68.1593 178.922 69.5424 176.438 70.3284C173.956 71.1228 171.629 71.2992 169.639 71.0479C168.643 70.9245 167.728 70.7079 166.902 70.427C166.08 70.1373 165.338 69.8072 164.678 69.449C163.359 68.7303 162.368 67.9392 161.596 67.2591C160.691 66.4521 159.878 65.572 159.161 64.6753C158.43 63.7861 157.823 62.8547 157.303 61.9115C156.265 60.0228 155.669 58.0497 155.387 56.0934C155.235 55.1162 155.172 54.1397 155.141 53.1751C155.104 52.2089 155.139 51.2533 155.147 50.279C155.152 49.3092 155.16 48.358 155.127 47.3873C155.092 46.4231 155.005 45.4381 154.757 44.4609C154.485 43.4059 153.996 42.6741 153.603 42.2822C153.412 42.0785 153.232 41.9619 153.1 41.8936C152.968 41.8253 152.879 41.812 152.832 41.8497L152.701 41.8442C152.697 41.8635 152.703 41.8692 152.722 41.8655L152.829 41.8436L152.808 41.8685C152.77 41.9138 152.772 42.008 152.817 42.1426C152.86 42.2752 152.946 42.4482 153.042 42.6791C153.244 43.1316 153.527 43.7785 153.718 44.7041C153.889 45.5705 153.936 46.4792 153.926 47.4054C153.92 48.3312 153.872 49.2838 153.833 50.2398C153.722 52.1482 153.636 54.1889 153.902 56.2935C154.151 58.3995 154.77 60.593 155.881 62.6747C156.437 63.7134 157.093 64.7371 157.873 65.7018C158.641 66.6759 159.501 67.6149 160.49 68.5006C161.26 69.1829 162.28 70.0177 163.649 70.8244C165.02 71.6183 166.762 72.3758 168.863 72.7476C170.959 73.1156 173.393 73.0683 175.922 72.44C178.453 71.8219 181.043 70.6301 183.565 69.0036C185.208 67.94 186.742 66.7265 188.162 65.4284C188.478 65.1492 188.784 64.8541 189.092 64.5567C189.402 64.2613 189.714 63.9636 190.011 63.665C190.619 63.0668 191.235 62.4573 191.845 61.8107L192.299 61.316C192.345 61.2617 192.523 61.0679 192.639 60.9257L193.021 60.4708L193.391 60.0086L193.486 59.8955C193.48 59.8561 193.425 59.821 193.399 59.7834L193.195 59.566C192.933 59.2761 192.65 58.988 192.374 58.7014C191.761 58.0705 191.146 57.4377 190.534 56.8068C189.331 55.5598 188.135 54.3226 186.969 53.1144C185.625 51.7139 184.318 50.348 183.066 49.0444C182.442 49.6398 181.829 50.2259 181.227 50.8048C181.016 51.0098 180.808 51.2062 180.602 51.3919C180.393 51.5799 180.196 51.7733 179.987 51.9488C179.164 52.6706 178.326 53.2951 177.498 53.7927C176.67 54.2863 175.836 54.6439 175.066 54.7841C174.293 54.9266 173.6 54.8461 173.042 54.5966C172.477 54.3497 172.045 53.936 171.712 53.5326C171.383 53.1289 171.169 52.7362 171.022 52.3965C170.949 52.2266 170.901 52.067 170.85 51.9351C170.811 51.7937 170.778 51.677 170.753 51.5826C170.724 51.4886 170.713 51.4098 170.7 51.3606C170.689 51.309 170.683 51.2844 170.683 51.2844C170.683 51.2844 170.655 51.1757 170.62 50.9647C170.602 50.8571 170.582 50.7245 170.558 50.5692C170.542 50.409 170.522 50.2261 170.5 50.0182C170.428 49.181 170.429 47.9304 170.475 46.3506C170.48 45.578 170.559 44.7172 170.575 43.7653C170.586 42.816 170.584 41.7985 170.473 40.7275C170.366 39.6562 170.183 38.5328 169.879 37.3967C169.563 36.2616 169.12 35.1208 168.563 34.0109C168.013 32.8919 167.297 31.8419 166.532 30.8276C166.332 30.5785 166.135 30.3312 165.933 30.0802C165.729 29.8356 165.508 29.603 165.296 29.3632C165.082 29.1258 164.871 28.886 164.637 28.6587C164.41 28.4287 164.184 28.1965 163.941 27.9846C162.045 26.2207 159.744 24.834 157.312 24.1068C154.881 23.3649 152.383 23.3003 150.19 23.631C147.983 23.9545 146.071 24.6532 144.51 25.353C142.165 26.4333 140.292 27.6636 138.737 28.8286C137.183 29.9978 135.935 31.0964 134.891 32.0807C133.859 33.0556 132.992 33.8798 132.263 34.6501C132.173 34.7481 132.085 34.8439 131.996 34.9355C131.87 35.0807 131.724 35.2361 131.601 35.3915C131.474 35.5473 131.351 35.6986 131.228 35.8498C131.165 35.9245 131.108 36.0008 131.048 36.0732C131.006 36.1461 130.87 36.225 130.986 36.2883C131.232 36.5607 131.465 36.8217 131.709 37.0734C131.889 37.2634 132.062 37.4477 132.23 37.624C133.778 39.2461 135.238 40.775 136.632 42.2363C137.33 42.9626 138.015 43.6733 138.681 44.3688C139.015 44.7154 139.345 45.0583 139.674 45.3969C139.865 45.5964 140.056 45.7918 140.245 45.9894L140.649 46.4098C140.784 46.5428 140.916 46.6615 141.049 46.7885L141.247 46.9748L141.299 47.0185L141.32 47.044C141.325 47.0478 141.329 47.0516 141.332 47.0535L141.343 47.0399L141.444 46.943L141.83 46.5529C142.085 46.3 142.335 46.0077 142.564 45.7213C142.888 45.3177 143.089 45.0967 143.437 44.779C143.751 44.4791 144.068 44.1851 144.395 43.9113C144.712 43.6257 145.047 43.3701 145.374 43.1088C146.043 42.6165 146.72 42.1424 147.435 41.8013C148.146 41.4564 148.886 41.2055 149.62 41.1503L149.643 41.1462Z" fill="#0055CC"/>
<path d="M80.321 9.381C80.4416 7.10655 79.4571 7.02823 79.1312 9.25752C78.8942 10.8392 78.6434 12.4555 78.3341 14.1966C78.018 15.932 77.6635 17.8049 77.0533 19.8029C76.9621 20.1318 76.8558 20.4327 76.7629 20.7177C76.7418 20.7888 76.7161 20.8561 76.6904 20.9233C76.6579 21.008 76.6295 21.0923 76.5966 21.1728C76.5069 21.4218 76.4055 21.6573 76.3015 21.8866C75.8871 22.7744 75.5595 23.4763 75.3454 23.9376C76.5743 23.808 77.6597 23.6698 78.5962 23.5572C79.1374 23.483 79.6268 23.4154 80.1059 23.3508C81.0599 23.2219 81.9734 23.1092 83.1533 22.9964C85.9529 22.7118 89.7215 22.3998 93.0728 22.1386C93.9107 22.0744 94.7237 22.0123 95.4885 21.9523C95.6782 21.938 95.8679 21.9236 96.0534 21.9097C96.3908 21.8804 96.7199 21.8519 97.0447 21.8237C97.2132 21.807 97.3821 21.7945 97.5465 21.7781L97.6089 21.7727C97.6204 21.7591 97.6182 21.7341 97.6228 21.7148L97.6419 21.5957L97.6801 21.3574C97.73 21.0362 97.7788 20.7257 97.826 20.4215C97.9332 19.7429 98.0279 19.1388 98.1097 18.6281C98.1809 18.1394 98.241 17.7418 98.2835 17.4569C98.332 17.1191 98.3699 16.7801 98.4014 16.4396C98.4496 15.9045 98.5308 14.9722 98.6212 13.7348C98.6626 13.1206 98.7101 12.4304 98.7605 11.6769C98.8248 10.9391 98.9042 10.1327 98.9956 9.27083C99.1893 7.55237 99.4495 5.63093 99.8761 3.6447C100.088 2.65271 100.35 1.64389 100.688 0.657733C100.777 0.415087 100.869 0.172091 100.959 -0.0728197L101.111 -0.432169L101.185 -0.612789C101.19 -0.632072 101.226 -0.698169 101.255 -0.755205L101.343 -0.924419L101.695 -1.60959C101.746 -1.72103 101.822 -1.84298 101.901 -1.96529L102.126 -2.32887C102.421 -2.80344 102.713 -3.27991 103.01 -3.75675C102.93 -3.75822 102.807 -3.74549 102.664 -3.73095C102.522 -3.71867 102.364 -3.70079 102.189 -3.68563C101.84 -3.65113 101.434 -3.60967 100.989 -3.56688C100.271 -3.49835 99.4285 -3.41482 98.594 -3.33619C92.1629 -2.6822 88.1819 -2.27836 86.104 -2.06678C84.8775 -1.93528 83.7301 -1.81063 82.6387 -1.69294C81.9634 -1.61553 81.3068 -1.54182 80.6649 -1.4673L80.3138 -1.42637L80.1393 -1.40705L80.054 -1.39756C80.054 -1.39756 80.0158 -1.40264 80.0195 -1.38408L80.0129 -1.33944C79.9849 -1.10411 79.9566 -0.872952 79.9306 -0.639888C79.9042 -0.410991 79.8778 -0.182091 79.8514 0.046808C79.8379 0.182264 79.824 0.313557 79.8105 0.449013C79.6178 2.44645 79.5162 4.28491 79.4719 6.10582C79.4328 8.10883 80.2926 8.15179 80.5363 6.1856C80.7678 4.39463 81.0108 2.59008 81.2991 0.630513C81.3163 0.51362 81.3335 0.396721 81.3507 0.279829L81.3736 0.156149L81.3968 0.0366324C81.4245 0.0174448 81.4801 0.0294168 81.5173 0.0220026L81.6426 0.0153272C81.7592 0.00521753 81.8758 -0.00488413 81.9924 -0.0149939C82.259 -0.0381019 82.5275 -0.0634723 82.8005 -0.0850388C83.891 -0.187965 85.0441 -0.296311 86.2698 -0.413054C88.1772 -0.605671 92.1765 -0.77399 97.792 -1.29854C98.2499 -1.34242 98.7073 -1.39046 99.1621 -1.44458L99.459 -1.4808C99.459 -1.4808 99.4628 -1.48532 99.4666 -1.48985C99.4723 -1.49664 99.4841 -1.50606 99.5061 -1.51846C99.5282 -1.53086 99.5786 -1.55412 99.6074 -1.56081C99.6134 -1.54035 99.619 -1.52404 99.5928 -1.43784L99.5732 -1.37321L99.4323 -1.01267C99.3335 -0.771204 99.2457 -0.524399 99.1662 -0.278311C98.8317 0.707485 98.5712 1.70154 98.3498 2.68592C97.9192 4.64943 97.6406 6.5515 97.4316 8.21463C97.2283 9.87097 97.0684 11.3011 96.9964 12.3145C96.9101 13.3082 96.8578 13.8939 96.8578 13.8939C96.8578 13.8939 96.7819 14.8384 96.6206 16.3484C96.541 17.1044 96.4359 18.0011 96.3094 18.9919C96.2578 19.3657 96.2075 19.7561 96.1523 20.1616C96.1696 20.265 96.0622 20.2366 95.9922 20.2511C95.7737 20.2721 95.5533 20.2954 95.3287 20.3191C90.738 20.782 85.3487 21.3268 82.1496 21.6503L79.3959 21.931L78.3394 22.0393L78.1542 22.0575L78.0607 22.0677L78.0148 22.0717C78.0148 22.0717 77.9678 22.0862 77.9869 22.0636C78.0476 21.9408 78.1061 21.8162 78.1578 21.6858L78.2605 21.4167C78.3084 21.2909 78.3479 21.1657 78.3917 21.0402C78.4791 20.7893 78.5624 20.5387 78.637 20.2846C79.2812 18.1452 79.6012 16.2123 79.8478 14.4263C80.088 12.6388 80.2266 10.9859 80.3206 9.37683L80.321 9.381Z" fill="#0055CC"/>
</g>
</g>
<defs>
<clipPath id="clip0_550_14457">
<rect width="419" height="16" fill="white"/>
</clipPath>
<clipPath id="clip1_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 330) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $f2f805f49af46a8b$var$$e48fba9cf5395297$export$d3a66d29d3f047ac = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$e48fba9cf5395297$require$Buffer.from($f2f805f49af46a8b$var$$e48fba9cf5395297$var$courseBg).toString("base64")}`;
var $f2f805f49af46a8b$var$$ea8e736e4eb06883$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $f2f805f49af46a8b$var$$ea8e736e4eb06883$var$learningPathBg = `<svg width="420" height="32" viewBox="0 0 420 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_783_5660)">
<rect width="421" height="32" fill="#D3F1A7"/>
<g clipPath="url(#clip1_783_5660)">
<path d="M419.987 -18.535C419.996 -18.6008 420.003 -18.6685 420.014 -18.7325C420.032 -18.7948 420.048 -18.855 420.064 -18.9151C420.099 -19.0357 420.114 -19.1586 420.159 -19.2633C420.248 -19.4787 420.309 -19.6897 420.416 -19.8626C420.463 -19.9547 420.508 -20.0405 420.551 -20.1239C420.603 -20.204 420.653 -20.2776 420.702 -20.3489C420.75 -20.4203 420.79 -20.495 420.836 -20.56C420.888 -20.6211 420.931 -20.6814 420.974 -20.7377C421.14 -20.9766 421.288 -21.1425 421.37 -21.2818C421.452 -21.4212 421.479 -21.5221 421.443 -21.5798C421.407 -21.6375 421.307 -21.6519 421.142 -21.6125C420.978 -21.5731 420.733 -21.4931 420.458 -21.2993C420.387 -21.2511 420.313 -21.2007 420.234 -21.1477C420.159 -21.0908 420.086 -21.0173 420.006 -20.9454C419.928 -20.8715 419.847 -20.7931 419.762 -20.7102C419.686 -20.6197 419.613 -20.5189 419.533 -20.4155C419.364 -20.2141 419.244 -19.9561 419.102 -19.6815C419.032 -19.5432 418.992 -19.3908 418.936 -19.237C418.91 -19.1592 418.885 -19.0794 418.86 -18.9996C418.838 -18.918 418.826 -18.8351 418.809 -18.7496C418.615 -17.7845 418.69 -16.8132 418.876 -15.8956C419.059 -14.9694 419.392 -14.1023 419.756 -13.2441C419.947 -12.8201 420.142 -12.3942 420.364 -11.9834C420.574 -11.5631 420.81 -11.1597 421.049 -10.7503L421.231 -10.4387C421.302 -10.3211 421.379 -10.2102 421.453 -10.1055C421.527 -10.0007 421.606 -9.89626 421.681 -9.80207L421.834 -9.60345C421.861 -9.56587 421.887 -9.52828 421.909 -9.4945C421.917 -9.4763 421.939 -9.45727 421.93 -9.44179L421.87 -9.40722L421.756 -9.34487C421.555 -9.22042 421.349 -9.0956 421.146 -8.96889C420.732 -8.71475 420.314 -8.45608 419.889 -8.19478C419.043 -7.67029 418.178 -7.13793 417.292 -6.589C415.522 -5.48507 413.666 -4.32963 411.701 -3.10388C411.569 -3.02115 411.438 -2.93843 411.311 -2.85606L411.263 -2.82257C411.247 -2.8128 411.23 -2.79243 411.213 -2.79515L411.176 -2.83808L411.129 -2.89695C411.053 -2.99948 410.979 -3.10009 410.908 -3.19881C410.748 -3.42205 410.595 -3.64376 410.445 -3.86582C409.853 -4.75028 409.317 -5.59134 408.833 -6.35724C407.867 -7.87654 407.139 -9.19195 406.523 -10.4478C405.911 -11.7041 405.395 -12.8911 404.961 -14.1984C404.532 -15.502 404.156 -16.9192 403.941 -18.6296C403.764 -20.0725 403.734 -21.6583 403.948 -23.2903C404.067 -24.1022 404.224 -24.932 404.485 -25.7436C404.596 -26.1561 404.761 -26.5544 404.909 -26.9595C405.08 -27.3563 405.245 -27.7587 405.453 -28.1439C405.847 -28.9251 406.311 -29.6787 406.85 -30.3843C407.385 -31.0937 407.973 -31.7657 408.624 -32.3739C408.936 -32.6906 409.287 -32.9707 409.619 -33.2638C409.969 -33.5376 410.311 -33.8212 410.678 -34.0691C411.033 -34.3348 411.41 -34.5668 411.777 -34.8022C412.152 -35.0319 412.539 -35.2438 412.914 -35.4652C414.436 -36.3063 415.99 -36.9508 417.497 -37.3605C419.003 -37.7744 420.458 -37.953 421.776 -37.9728C423.096 -37.9949 424.276 -37.8643 425.269 -37.7091C426.262 -37.5581 427.07 -37.3658 427.646 -37.2332L428.69 -36.9733C429.045 -36.8908 429.419 -36.8161 429.771 -36.7439C430.378 -36.6244 431.227 -36.4357 432.428 -36.2524C433.028 -36.1617 433.721 -36.077 434.532 -36.0634C435.339 -36.0536 436.29 -36.115 437.298 -36.4731C437.804 -36.6386 438.302 -36.8958 438.794 -37.2049C439.033 -37.3788 439.288 -37.5352 439.516 -37.7606C439.63 -37.8691 439.756 -37.9682 439.863 -38.0907C439.969 -38.2175 440.076 -38.3442 440.183 -38.4709C440.585 -39.0094 440.922 -39.6534 441.087 -40.3602C441.245 -41.0621 441.295 -41.8007 441.211 -42.5237C441.061 -43.9794 440.534 -45.3837 439.853 -46.7871C439.509 -47.4895 439.114 -48.1854 438.684 -48.8867C438.47 -49.2438 438.255 -49.5756 438.036 -49.93C437.987 -50.0056 437.941 -50.0792 437.892 -50.1547L437.861 -50.2044C437.876 -50.2184 437.894 -50.2304 437.914 -50.2447C437.836 -50.1981 438.202 -50.4313 438.461 -50.5964C439.016 -50.9487 439.658 -51.3548 440.372 -51.8091C441.803 -52.7116 443.524 -53.7987 445.425 -54.9978C446.336 -55.572 447.291 -56.171 448.275 -56.7892L448.326 -56.823C448.342 -56.8286 448.363 -56.8577 448.374 -56.8292L448.412 -56.7821L448.504 -56.658C448.854 -56.1743 449.194 -55.6645 449.531 -55.1418C449.866 -54.6086 450.202 -54.0712 450.54 -53.5319C450.86 -52.9889 451.204 -52.4564 451.506 -51.9013C452.14 -50.8043 452.697 -49.6713 453.218 -48.5373C454.609 -45.4749 455.414 -42.519 455.622 -39.8408C455.835 -37.1588 455.451 -34.7734 454.708 -32.8332C453.969 -30.885 452.931 -29.3703 451.906 -28.2008C450.869 -27.0366 449.854 -26.1975 448.994 -25.5648C448.74 -25.377 448.489 -25.1937 448.225 -25.026C447.964 -24.8545 447.711 -24.6814 447.441 -24.53C447.177 -24.3729 446.912 -24.2176 446.652 -24.0609C446.391 -23.906 446.118 -23.7796 445.858 -23.6395C445.335 -23.3487 444.792 -23.1337 444.267 -22.891C444.001 -22.782 443.73 -22.6893 443.467 -22.5866L443.07 -22.4369L442.67 -22.314C441.607 -21.9638 440.54 -21.7559 439.49 -21.6188C438.439 -21.4752 437.397 -21.4584 436.377 -21.4937C435.354 -21.5267 434.349 -21.6453 433.361 -21.7967C432.866 -21.8692 432.377 -21.9632 431.889 -22.0531C431.396 -22.1509 430.914 -22.2581 430.418 -22.3473C429.434 -22.5327 428.468 -22.7238 427.477 -22.8687C426.491 -23.0141 425.476 -23.1065 424.439 -23.0397C423.318 -22.9551 422.489 -22.6084 422.02 -22.2886C421.775 -22.1352 421.62 -21.9792 421.526 -21.8618C421.431 -21.7445 421.396 -21.6576 421.422 -21.6053L421.393 -21.479C421.408 -21.4698 421.421 -21.475 421.419 -21.4959L421.417 -21.6091L421.441 -21.5817C421.478 -21.5346 421.572 -21.5217 421.717 -21.5385C421.86 -21.5572 422.053 -21.6117 422.306 -21.6651C422.804 -21.788 423.52 -21.9508 424.501 -21.9792C426.333 -22.0037 428.217 -21.4935 430.151 -21.0652C432.069 -20.5957 434.122 -20.1211 436.309 -19.998C437.401 -19.9333 438.53 -19.9304 439.679 -20.0657C440.824 -20.1922 441.997 -20.4072 443.155 -20.774L443.593 -20.9043L444.026 -21.0615C444.313 -21.1682 444.608 -21.2672 444.896 -21.3845C445.464 -21.6372 446.054 -21.871 446.616 -22.1756C446.899 -22.3239 447.191 -22.4605 447.471 -22.6232C447.751 -22.7859 448.03 -22.9528 448.316 -23.1182C448.602 -23.2794 448.877 -23.4648 449.157 -23.6507C449.44 -23.8304 449.714 -24.0284 449.988 -24.2305C450.841 -24.8583 451.905 -25.7017 453.021 -26.8958C453.309 -27.1872 453.571 -27.5226 453.863 -27.8606C454.004 -28.0322 454.137 -28.2179 454.276 -28.402C454.418 -28.5843 454.554 -28.7745 454.686 -28.9768C455.233 -29.7649 455.74 -30.6671 456.174 -31.674C457.054 -33.6807 457.614 -36.138 457.566 -38.828C457.534 -41.5172 456.936 -44.4071 455.846 -47.3131C455.131 -49.2087 454.232 -51.0192 453.22 -52.7276C453 -53.1093 452.768 -53.4858 452.531 -53.8597C452.294 -54.2399 452.058 -54.616 451.817 -54.9854C451.333 -55.7282 450.844 -56.4873 450.306 -57.2401C450.171 -57.4277 450.035 -57.6153 449.893 -57.8044C449.653 -58.1256 449.383 -58.4568 449.123 -58.7679L448.927 -59.0068L448.828 -59.1242L448.779 -59.185L448.713 -59.1436L448.187 -58.8211L447.222 -58.2108C446.463 -57.7211 445.702 -57.2334 444.944 -56.746C443.425 -55.775 441.918 -54.8134 440.448 -53.874C438.753 -52.7997 437.104 -51.7524 435.527 -50.7533C435.991 -50.0109 436.451 -49.2807 436.903 -48.5604C437.066 -48.3038 437.217 -48.0567 437.362 -47.8112C437.505 -47.5634 437.664 -47.3254 437.793 -47.0785C438.349 -46.1048 438.792 -45.1298 439.105 -44.1939C439.417 -43.2557 439.58 -42.3466 439.535 -41.5454C439.493 -40.7424 439.25 -40.0624 438.851 -39.5599C438.46 -39.0497 437.954 -38.6911 437.475 -38.4376C436.995 -38.1883 436.554 -38.0452 436.181 -37.9646C435.996 -37.9234 435.825 -37.9044 435.679 -37.877C435.529 -37.864 435.404 -37.8532 435.302 -37.8423C435.2 -37.8313 435.122 -37.8309 435.068 -37.8304C435.013 -37.8298 434.988 -37.8277 434.988 -37.8277C434.988 -37.8277 434.871 -37.8259 434.651 -37.8215C434.54 -37.8265 434.399 -37.829 434.237 -37.8338C434.073 -37.8406 433.88 -37.8596 433.667 -37.8767C432.801 -37.9591 431.531 -38.1931 429.936 -38.5374C429.151 -38.6876 428.292 -38.93 427.33 -39.1214C426.369 -39.3109 425.335 -39.5004 424.228 -39.5891C423.123 -39.6842 421.952 -39.7107 420.741 -39.6162C419.533 -39.5115 418.291 -39.2884 417.058 -38.9423C415.82 -38.6 414.613 -38.0967 413.43 -37.5305C412.848 -37.2282 412.256 -36.9336 411.697 -36.585C411.125 -36.2585 410.565 -35.8952 410.019 -35.5121C407.837 -33.978 405.925 -31.9889 404.62 -29.721C403.3 -27.4622 402.621 -24.9777 402.422 -22.6922C402.327 -21.5468 402.342 -20.4487 402.416 -19.4206C402.469 -18.909 402.508 -18.413 402.588 -17.9395C402.625 -17.7035 402.656 -17.4691 402.697 -17.2418C402.742 -17.0149 402.786 -16.7921 402.83 -16.5777C403.106 -15.2755 403.444 -14.0753 403.836 -12.9846C404.024 -12.4365 404.237 -11.9178 404.431 -11.4143C404.65 -10.9213 404.839 -10.4341 405.058 -9.9831C405.906 -8.16185 406.754 -6.66802 407.532 -5.40729C408.303 -4.16059 408.956 -3.11351 409.589 -2.2179C409.677 -2.09754 409.763 -1.97908 409.846 -1.86252C409.972 -1.69507 410.097 -1.53177 410.231 -1.3692C410.364 -1.2108 410.493 -1.05203 410.619 -0.899327C410.683 -0.822977 410.748 -0.74889 410.811 -0.672541C410.838 -0.607701 410.885 -0.664288 410.925 -0.684559L411.049 -0.758224C411.375 -0.948013 411.688 -1.14089 411.994 -1.3353C412.199 -1.46428 412.396 -1.58837 412.583 -1.70531C414.541 -2.94093 416.392 -4.10849 418.154 -5.2223C419.034 -5.7811 419.891 -6.3275 420.73 -6.86187C421.15 -7.13113 421.563 -7.39361 421.975 -7.65798C422.182 -7.78922 422.388 -7.92463 422.593 -8.0536L423.1 -8.37663L423.351 -8.53683L423.58 -8.6994L424.035 -9.02415L424.063 -9.04335L424.074 -9.05693C424.074 -9.05693 424.071 -9.06299 424.069 -9.06906L424.03 -9.12865L423.95 -9.24973L423.794 -9.48584C423.591 -9.79557 423.369 -10.1058 423.118 -10.4051L422.846 -10.7382L422.646 -10.9915C422.584 -11.0743 422.525 -11.1593 422.472 -11.2387L422.296 -11.5214C422.062 -11.9039 421.823 -12.282 421.616 -12.6689C421.392 -13.0503 421.203 -13.441 421.015 -13.8275C420.658 -14.6065 420.324 -15.3895 420.137 -16.1875C419.943 -16.9806 419.861 -17.7834 419.977 -18.5362L419.987 -18.535Z" fill="#6A9A23"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#6A9A23"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#6A9A23"/>
<path d="M384.78 4.00329C387.938 3.20915 387.727 2.24341 384.526 2.83562C382.254 3.25496 379.932 3.70171 377.414 4.21162C376.157 4.47169 374.85 4.74026 373.477 5.02294C372.791 5.16845 372.086 5.31766 371.367 5.47022L371.218 5.49987C371.197 5.50168 371.166 5.52123 371.163 5.48791C371.092 5.31992 371.022 5.14967 370.951 4.97752C369.623 1.76695 368.946 -0.312486 368.381 -2.12043C367.842 -3.93698 367.411 -5.50059 367.051 -7.83194C366.893 -8.81488 366.773 -9.88927 366.688 -11.0192C366.622 -12.1486 366.576 -13.3343 366.64 -14.5359C366.704 -15.7374 366.819 -16.9581 367.064 -18.1396C367.308 -19.3211 367.637 -20.4742 368.076 -21.5383C368.18 -21.8055 368.312 -22.0581 368.428 -22.3158C368.488 -22.4427 368.547 -22.5716 368.605 -22.6962C368.676 -22.822 368.743 -22.9474 368.812 -23.0709C369.086 -23.5667 369.355 -24.0516 369.614 -24.5211C369.889 -24.9813 370.184 -25.4056 370.452 -25.8254C370.59 -26.0303 370.716 -26.2406 370.855 -26.4331C371 -26.6199 371.14 -26.804 371.278 -26.9817C371.556 -27.3352 371.803 -27.6798 372.06 -27.9811C372.327 -28.2707 372.576 -28.5441 372.802 -28.7903C373.238 -29.3044 373.671 -29.6399 373.952 -29.9097L374.459 -30.3796L375.001 -30.8127C375.161 -30.9441 375.356 -31.1015 375.579 -31.2845C375.688 -31.3821 375.817 -31.4709 375.954 -31.5604C376.091 -31.6541 376.237 -31.7508 376.39 -31.8542C376.986 -32.2878 377.767 -32.7206 378.666 -33.1972C380.483 -34.1268 382.926 -34.9701 385.749 -35.6869C386.452 -35.8717 387.182 -36.0462 387.929 -36.2179C388.673 -36.3957 389.442 -36.561 390.222 -36.7356C390.745 -36.8523 391.276 -36.9696 391.811 -37.0874C391.827 -37.0972 391.829 -37.0805 391.834 -37.0684L391.843 -37.0293L391.877 -36.8812C391.965 -36.4754 392.052 -36.0697 392.138 -35.6616C392.826 -32.3977 393.535 -29.0516 394.215 -25.8332C394.699 -23.5607 395.138 -21.5069 395.533 -19.6569C395.709 -18.8328 395.874 -18.0562 396.03 -17.3227L396.047 -17.2507C396.046 -17.2318 396.008 -17.2368 395.99 -17.229C395.759 -17.1838 395.532 -17.1389 395.315 -17.097C393.858 -16.8196 392.563 -16.5563 391.456 -16.2547C390.349 -15.9573 389.427 -15.6235 388.695 -15.281C387.829 -14.8808 387.014 -14.3841 386.312 -13.7652C385.606 -13.15 385.025 -12.4135 384.602 -11.6257C384.182 -10.8318 383.945 -10.0035 383.788 -9.19671C383.737 -8.79153 383.662 -8.39059 383.656 -7.99771C383.648 -7.79977 383.64 -7.606 383.631 -7.41223C383.631 -7.21918 383.643 -7.02722 383.649 -6.83679C383.805 -3.79316 384.714 -1.22823 385.709 1.20761C386.262 2.50259 386.762 3.06984 386.983 3.00452L386.993 2.90918C386.995 2.93001 387.006 2.93951 387.029 2.93545L387.023 2.98842C387.233 2.86741 387.157 2.12707 386.709 0.831387C385.907 -1.6044 385.185 -4.13523 385.149 -6.86608C385.149 -7.03604 385.145 -7.20563 385.149 -7.37595C385.164 -7.54509 385.174 -7.71387 385.187 -7.88491C385.199 -8.23008 385.278 -8.56211 385.326 -8.9041C385.476 -9.57384 385.682 -10.2422 386.022 -10.857C386.365 -11.468 386.82 -12.032 387.389 -12.5198C387.957 -13.0076 388.635 -13.4231 389.39 -13.7697C389.972 -14.0447 390.76 -14.3207 391.748 -14.5721C392.735 -14.8234 393.919 -15.0373 395.292 -15.2696C395.66 -15.3351 396.039 -15.3993 396.429 -15.4689C396.772 -15.5363 397.118 -15.6041 397.469 -15.6723C397.646 -15.7087 397.826 -15.7431 398.003 -15.7795L398.137 -15.8058L398.206 -15.818C398.206 -15.818 398.218 -15.8191 398.222 -15.8236L398.22 -15.8403L398.213 -15.8732L398.161 -16.1414C397.961 -17.148 397.754 -18.2065 397.532 -19.3161C397.2 -21.0058 396.833 -22.8477 396.421 -24.8325C396.152 -26.1248 395.86 -27.413 395.553 -28.6873C394.886 -31.4348 394.198 -34.3925 393.546 -37.286L393.341 -38.223L393.235 -38.7027L393.183 -38.9395L393.156 -39.0588C393.152 -39.0774 393.15 -39.1024 393.141 -39.1141L393.079 -39.1004C392.467 -38.9655 391.858 -38.8288 391.251 -38.6943C390.541 -38.5342 389.839 -38.3747 389.149 -38.2205C387.771 -37.908 386.435 -37.6013 385.194 -37.2776C382.705 -36.6506 380.584 -35.9232 379.116 -35.3029C378.753 -35.1371 378.426 -34.9871 378.141 -34.8596C377.997 -34.7947 377.866 -34.7351 377.745 -34.6784C377.627 -34.6157 377.521 -34.5582 377.422 -34.5056C377.038 -34.296 376.829 -34.1815 376.829 -34.1815C376.829 -34.1815 376.751 -34.139 376.605 -34.0571C376.459 -33.971 376.233 -33.8675 375.972 -33.6854C375.704 -33.509 375.379 -33.292 374.999 -33.043C374.904 -32.9802 374.807 -32.9151 374.705 -32.8496C374.611 -32.7743 374.511 -32.6964 374.413 -32.6165C374.213 -32.4565 373.998 -32.289 373.775 -32.1101C373.313 -31.7721 372.875 -31.325 372.39 -30.8675C371.887 -30.4253 371.447 -29.8604 370.947 -29.3072C370.689 -29.0331 370.468 -28.7244 370.238 -28.4086C370.006 -28.0969 369.77 -27.7742 369.529 -27.4512C369.295 -27.1225 369.093 -26.7672 368.869 -26.4183C368.652 -26.0638 368.416 -25.7139 368.211 -25.3457C368.012 -24.9718 367.81 -24.5934 367.61 -24.213C367.412 -23.8266 367.19 -23.4611 367.018 -23.0413C366.838 -22.6332 366.644 -22.2241 366.501 -21.7962L366.27 -21.1594C366.194 -20.9451 366.142 -20.7265 366.076 -20.511C365.569 -18.778 365.306 -16.9905 365.209 -15.272C365.017 -11.829 365.44 -8.67637 365.857 -6.37091C366.505 -2.89785 367.285 -0.399327 367.899 1.48832C368.53 3.37452 369.032 4.64658 369.43 5.61085C369.519 5.81714 369.604 6.0238 369.693 6.22593C369.821 6.52323 369.954 6.82018 370.092 7.1145L370.193 7.33446L370.219 7.39097C370.227 7.40918 370.255 7.38998 370.274 7.39044L370.391 7.36557L370.861 7.27026C371.154 7.20714 371.444 7.14212 371.732 7.07936C372.451 6.91847 373.155 6.76093 373.838 6.60936C375.206 6.29562 376.507 5.99825 377.757 5.70939C380.258 5.12332 382.558 4.56518 384.799 4.00376L384.78 4.00329Z" fill="#6A9A23"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#6A9A23"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#6A9A23"/>
<path d="M334.463 4.5503C336.378 5.19843 337.423 5.25884 337.511 5.0037C337.601 4.73987 336.74 4.16619 334.878 3.42744C332.352 2.41678 329.793 1.3314 327.049 0.0858865C325.677 -0.538004 324.262 -1.20221 322.786 -1.92192C322.048 -2.2797 321.294 -2.65496 320.524 -3.04353C320.14 -3.23894 319.751 -3.43817 319.356 -3.63893C318.73 -3.96444 318.098 -4.29148 317.454 -4.62388C317.2 -4.26194 316.851 -3.76375 316.498 -3.26103C311.509 3.94451 310.444 5.82245 307.026 10.6635C306.168 11.8814 305.22 13.2246 304.201 14.6705C303.026 16.325 301.771 18.0935 300.448 19.9518C301.609 20.5877 302.784 21.2286 303.958 21.8717C304.893 22.3719 305.832 22.8675 306.756 23.3476C308.612 24.3051 310.431 25.2049 312.103 26.0042C315.451 27.6024 318.222 28.8037 319.543 29.3585C320.099 29.5978 320.659 29.8219 321.228 30.0371C323.093 30.7482 327.879 32.5742 334.242 34.4546C337.42 35.4002 340.99 36.3581 344.761 37.2377C346.647 37.6764 348.582 38.0983 350.545 38.4926C351.525 38.6909 352.513 38.8801 353.502 39.0629L354.99 39.3326L357.469 39.7598C357.512 39.0699 357.618 37.378 357.721 35.7072C358.398 24.2426 358.818 17.1477 359.038 13.4421C359.115 12.082 359.191 10.7661 359.248 9.7981C358.525 9.66145 357.813 9.53015 357.113 9.39776C356.669 9.31034 356.23 9.22673 355.799 9.14241C354.934 8.97185 354.095 8.79914 353.278 8.62651C351.643 8.27935 350.096 7.92461 348.607 7.56898C345.63 6.8513 342.892 6.12137 340.191 5.33367C338.504 4.84208 337.595 4.76975 337.515 5.00334C337.437 5.22408 338.192 5.75453 339.861 6.35052C342.533 7.30237 345.259 8.1655 348.242 8.98542C349.733 9.39329 351.289 9.78932 352.935 10.1691C353.757 10.3622 354.602 10.547 355.474 10.7316C356.136 10.8673 356.819 11.0053 357.52 11.1501C357.485 11.7344 357.434 12.5299 357.383 13.3484C357.181 16.7483 356.524 23.8217 355.888 33.8224C355.843 34.63 355.797 35.4334 355.753 36.2387L355.697 37.4437C355.695 37.5153 355.695 37.488 355.696 37.4963L355.7 37.5001L355.703 37.5145L355.713 37.5494C355.713 37.5494 355.699 37.5569 355.686 37.558C355.653 37.5567 355.753 37.5795 355.443 37.5309C355.007 37.4616 354.566 37.3928 354.124 37.3221C353.241 37.1783 352.344 37.0273 351.449 36.8615C349.654 36.5387 347.844 36.1753 346.062 35.7821C342.497 35.0063 339.05 34.1049 336.046 33.2323C333.043 32.3574 330.487 31.5173 328.681 30.8912C327.778 30.5729 327.064 30.3201 326.573 30.1465C326.083 29.9666 325.818 29.8678 325.818 29.8678C321.699 28.3743 317.646 26.705 313.653 24.9004C311.657 23.995 309.679 23.0544 307.719 22.0745C306.741 21.5843 305.762 21.0859 304.793 20.5802L303.34 19.8144L302.638 19.4367L309.085 10.2353C314.014 3.19229 316.386 -0.198457 317.845 -2.28256C317.896 -2.35617 317.946 -2.42977 317.981 -2.4811C318.602 -2.16773 319.205 -1.86541 319.791 -1.56997C320.573 -1.18248 321.337 -0.814374 322.09 -0.459944C323.592 0.247014 325.035 0.89203 326.437 1.48387C329.24 2.67399 331.869 3.6673 334.463 4.55447L334.463 4.5503Z" fill="#6A9A23"/>
<path d="M266.148 11.4377C265.904 11.241 261.607 11.6973 262.767 12.4218C263.152 12.7388 263.531 12.734 263.685 12.313C263.756 13.154 264.635 12.1 265.004 12.3981C264.83 12.9694 266.069 11.8383 265.807 12.4271C270.358 13.3709 279.961 8.3733 268.469 10.9842C269.573 11.3222 268.502 11.4793 268.006 11.3163C268.775 10.6232 266.63 11.1226 266.225 11.3524C266.878 11.3826 265.768 11.8565 266.15 11.4398L266.148 11.4377Z" fill="#101214"/>
<path d="M273.986 19.0467C273.385 19.0418 270.602 22.9468 270.26 23.3131C269.677 24.2322 271.049 24.4039 271.328 23.6053C271.45 23.4739 271.918 22.3416 272.164 22.8577C273.353 22.6833 273.656 20.6225 274.654 20.5627C274.514 20.2788 274.886 19.9778 274.819 19.7896C275.111 19.8418 275.301 19.4589 275.233 19.4186C276.559 18.4848 275.082 17.1701 274.308 18.5903C274.261 18.5239 273.902 18.7589 273.986 19.0428L273.986 19.0467Z" fill="#101214"/>
<path d="M288.709 27.7641C289.293 27.125 289.207 27.8367 288.919 28.1456C288.477 27.5052 288.381 28.9221 288.518 29.2965C288.558 29.1514 288.815 29.1459 288.75 29.4489C288.158 29.1232 287.385 32.9628 288.995 31.3767C289.003 31.3103 288.513 31.1909 288.68 31.1416C289.409 31.4079 288.987 30.7058 288.958 30.5243C289.347 30.5991 289.013 30.3704 289.181 30.3567C289.67 30.6613 288.959 29.5148 289.438 29.8463C290.383 29.1065 289.625 27.1642 290.464 26.62C289.666 25.994 291.452 23.4009 289.594 24.1887C289.01 25.3404 288.629 26.3014 288.709 27.7641Z" fill="#101214"/>
<path d="M278.52 33.4874C279.672 34.0122 279.857 31.3062 280.471 30.6733C281.323 29.9268 285.341 20.9746 282.563 22.9852C281.37 25.7048 279.916 27.7259 278.886 31.2063C278.677 31.7594 277.666 33.4114 278.52 33.4874Z" fill="#101214"/>
<path d="M272.605 3.22304C273.458 2.36044 274.245 3.76255 275.035 3.06901C276.28 1.6898 267.453 -0.415104 267.475 1.23084C267.685 2.64358 272.067 2.52653 272.605 3.22304Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_783_5660)">
<path d="M13.0459 23.9464C13.2244 23.8029 13.375 23.6514 13.5135 23.5051C13.6519 23.3588 13.7767 23.2242 13.8912 23.0925C14.1165 22.8338 14.2962 22.6063 14.4242 22.4127C14.6826 22.0273 14.7534 21.7777 14.657 21.6812C14.5605 21.5846 14.2987 21.6388 13.898 21.8582C13.6977 21.9679 13.4612 22.1206 13.1927 22.3159C13.0586 22.4156 12.9146 22.5225 12.7657 22.6446C12.6168 22.7666 12.4583 22.8999 12.2783 23.0267C11.7797 23.3994 11.2791 23.7743 10.7705 24.1541C10.2398 24.4959 9.70493 24.8382 9.16244 25.1894C8.60947 25.5164 8.02636 25.8104 7.44957 26.1289C7.15404 26.2784 6.84575 26.4016 6.5389 26.5415C6.23133 26.6731 5.92782 26.8274 5.60858 26.9453C5.28898 27.059 4.96332 27.1754 4.63765 27.2917C4.47464 27.3478 4.31044 27.4145 4.1448 27.4645C3.97464 27.5108 3.80449 27.557 3.63433 27.6032C3.29175 27.6937 2.94835 27.799 2.59636 27.8778C2.24139 27.9463 1.88225 28.0152 1.51931 28.0887C0.0606176 28.3263 -1.49813 28.4258 -3.12925 28.2944C-3.56103 28.2752 -3.97141 28.2121 -4.35537 28.1636C-4.54794 28.1446 -4.73171 28.106 -4.90643 28.075C-4.9938 28.0595 -5.08116 28.0439 -5.16436 28.0281C-5.22411 28.0165 -5.28576 28.0071 -5.34551 27.9955C-5.43287 27.98 -5.5081 27.9593 -5.58713 27.943C-6.21656 27.7731 -6.77491 27.6242 -7.25162 27.4977C-7.70977 27.3675 -8.08591 27.2637 -8.36563 27.183C-8.05452 28.2597 -7.73595 29.277 -7.45896 30.2014C-7.28585 30.7487 -7.12621 31.2616 -6.97515 31.7478C-6.68674 32.6587 -6.42815 33.4671 -6.18005 34.2514C-5.68384 35.8198 -5.22994 37.287 -4.66961 39.2338C-4.04204 41.3763 -3.32537 43.895 -2.58721 46.5167C-2.22004 47.8299 -1.84428 49.1695 -1.4715 50.499C-1.25363 51.2732 -1.04029 52.0436 -0.825398 52.8077C-0.802628 52.877 -0.789367 52.9577 -0.758627 53.0222L-0.551516 53.0882L-0.137285 53.2201L0.276945 53.3521L0.53893 53.4217C0.71283 53.4675 0.884474 53.5113 1.05837 53.5571C1.23346 53.5923 1.40628 53.6256 1.57946 53.663C4.36235 54.2065 7.04848 53.896 9.14027 53.3601C9.66062 53.2143 10.1485 53.0566 10.6086 52.9181C11.0609 52.7614 11.4697 52.5875 11.8496 52.4433C12.2341 52.303 12.5622 52.1424 12.8562 51.9994C13.1502 51.8564 13.4062 51.7356 13.6198 51.6331C13.8785 51.5184 14.1157 51.374 14.3552 51.2316L15.0752 50.7978C15.254 50.6816 15.4828 50.561 15.7156 50.3898C15.9507 50.2204 16.2176 50.0315 16.5119 49.8192C16.8017 49.6032 17.1399 49.3892 17.4667 49.1154C17.7957 48.8435 18.1502 48.5505 18.5283 48.2387C18.716 48.0797 18.9169 47.928 19.1073 47.752C19.2955 47.5741 19.4897 47.3936 19.6897 47.2064C20.0835 46.8344 20.499 46.4459 20.9358 46.0366C21.3513 45.6481 21.7823 45.2457 22.2305 44.8228C22.6881 44.4118 23.1922 44.0282 23.6952 43.609C23.943 43.3924 24.219 43.2111 24.4958 43.015C24.7708 42.8212 25.0517 42.6248 25.3346 42.4262C25.4725 42.3219 25.6221 42.2313 25.772 42.1449C25.9215 42.0543 26.0733 41.9656 26.2248 41.8727C26.5303 41.693 26.8325 41.499 27.1493 41.3288C28.4302 40.6597 29.8119 40.0405 31.3018 39.605C32.7947 39.1798 34.3762 38.9063 36.0024 38.8598C36.8156 38.8249 37.6359 38.8734 38.4607 38.9488L39.0913 39.0347L39.4056 39.0788L40.0042 39.2074C40.8225 39.3777 41.6365 39.5716 42.4509 39.7695C42.1544 38.7398 41.401 36.1362 40.667 33.5875C37.7264 23.5317 35.9053 17.3068 34.9535 14.0573C34.9552 13.7613 34.6651 13.8032 34.4682 13.7342C34.2584 13.6853 34.0485 13.6363 33.8387 13.5874L33.6803 13.5507C33.6311 13.5403 33.6141 13.5376 33.5778 13.5303L33.3902 13.4962L33.0173 13.4299C32.7696 13.38 32.5206 13.3638 32.2744 13.3306L31.9055 13.287L31.5408 13.2662C30.5668 13.1891 29.6218 13.2521 28.7074 13.3293C26.8858 13.5438 25.2051 14.0042 23.6927 14.641C23.3041 14.7817 22.9496 14.9782 22.5817 15.1402C22.4004 15.2272 22.2187 15.3101 22.0393 15.3949C21.8648 15.4877 21.6929 15.5865 21.5206 15.6812C21.1787 15.8766 20.8406 16.0675 20.5024 16.2583C20.1809 16.4708 19.8612 16.6811 19.5415 16.8914C19.3828 16.9974 19.226 17.1013 19.0692 17.2051C18.9128 17.3131 18.7677 17.4305 18.618 17.5442C18.321 17.7735 18.0236 17.9986 17.7304 18.2234C17.4281 18.4405 17.165 18.6983 16.8834 18.9367C16.6064 19.179 16.3335 19.4208 16.0565 19.6631C14.9003 20.7809 14.4954 21.5106 14.6627 21.6744C14.8371 21.8481 15.5686 21.4742 16.7575 20.4689C17.0367 20.2516 17.3182 20.0363 17.6015 19.8187C17.8853 19.6053 18.1547 19.3721 18.455 19.1803C18.7503 18.9805 19.0435 18.7789 19.3427 18.5746C19.4915 18.4757 19.6354 18.3688 19.7888 18.2736C19.9425 18.1827 20.0981 18.0895 20.256 17.9982C20.5672 17.8117 20.8807 17.6272 21.1938 17.4384C21.5194 17.2717 21.8468 17.1028 22.1765 16.9357C22.3434 16.852 22.5062 16.7687 22.675 16.6827C22.8449 16.6092 23.0189 16.5354 23.193 16.4615C23.5419 16.3222 23.8814 16.148 24.2446 16.0284C25.6722 15.4787 27.2231 15.0945 28.8787 14.9259C29.7068 14.8688 30.5609 14.822 31.436 14.8972L31.7652 14.919L32.0939 14.9598C32.3148 14.991 32.5385 15.0052 32.7585 15.0512C32.959 15.0883 33.1636 15.1252 33.3663 15.1642L33.4906 15.1954C33.5296 15.2088 33.5901 15.2057 33.5831 15.2462C33.7626 15.8915 33.9886 16.7112 34.2604 17.6969C34.563 18.8205 34.9173 20.1306 35.3166 21.6214C36.1212 24.6004 37.1258 28.2922 38.3635 32.5933C38.7677 33.9956 39.1924 35.3918 39.6324 36.77L39.7103 37.0171L39.7503 37.1396C39.7503 37.1396 39.7548 37.1434 39.757 37.1453C39.7661 37.1529 39.7713 37.165 39.7789 37.179C39.7935 37.203 39.816 37.2451 39.8321 37.2856C39.8094 37.2897 39.7776 37.2862 39.7337 37.2879L39.7 37.2866L39.6811 37.2861L39.5858 37.2755L39.0005 37.2045C38.6159 37.1477 38.1999 37.1418 37.8004 37.1071C37.3951 37.0793 36.9912 37.0913 36.5855 37.0824C34.9651 37.099 33.3478 37.3232 31.8071 37.7043C28.7091 38.445 25.9889 39.9166 23.8329 41.4107C23.5617 41.6 23.2986 41.7843 23.0374 41.9664C22.7852 42.1562 22.5484 42.355 22.3129 42.5433C22.0774 42.7316 21.8479 42.9172 21.6222 43.0984C21.5105 43.1899 21.3985 43.2772 21.2906 43.3642C21.1876 43.4592 21.0865 43.5519 20.9873 43.6423C20.2001 44.3673 19.5102 45.0041 18.937 45.5343C18.6591 45.7913 18.4082 46.0207 18.1904 46.2201C18.0817 46.3218 17.9806 46.4145 17.8871 46.4981C17.7891 46.578 17.6987 46.6488 17.6204 46.7143C17.3005 46.9707 17.13 47.1093 17.13 47.1093C17.13 47.1093 16.8416 47.342 16.3261 47.7623C16.0647 47.9675 15.7272 48.1898 15.3418 48.4645C15.15 48.6007 14.9442 48.7445 14.7266 48.8976C14.509 49.0508 14.2624 49.1833 14.0092 49.3375C13.758 49.4894 13.4926 49.6487 13.2175 49.8153C12.9446 49.9837 12.637 50.1153 12.3319 50.276C12.0216 50.4246 11.7142 50.6065 11.3733 50.741C11.037 50.8792 10.6885 51.0228 10.3339 51.1689C8.89465 51.7049 7.25528 52.1345 5.51244 52.2646C4.64192 52.34 3.74838 52.3189 2.85551 52.2326L2.18746 52.1499L1.52224 52.0271C1.30062 51.9876 1.08518 51.9223 0.864745 51.8722L0.70406 51.8337L0.64585 51.8157L0.529429 51.7796C0.476824 51.7779 0.495606 51.728 0.478692 51.7022L0.439583 51.565L0.23949 50.8752C0.105343 50.4147 -0.0284482 49.9584 -0.162235 49.5021C-0.429811 48.5895 -0.692493 47.6848 -0.951844 46.7946C-1.99079 43.24 -2.95224 39.9515 -3.66507 37.5017L-5.03013 32.8424L-5.71171 30.5116L-5.92228 29.7975L-5.96736 29.6399L-5.99086 29.5622L-6.00278 29.5213C-6.00278 29.5213 -6.02077 29.4829 -6.00077 29.4959C-5.91685 29.5201 -5.83258 29.5485 -5.74485 29.5681L-5.6163 29.599L-5.29637 29.6594C-5.12807 29.6888 -4.95906 29.7266 -4.78886 29.7539L-4.27933 29.823L-3.7698 29.8921L-3.25864 29.9317C-1.47352 30.0729 0.223859 29.9509 1.8069 29.671C2.20054 29.5886 2.59002 29.5066 2.97117 29.4253C3.3535 29.3334 3.71855 29.2115 4.08731 29.1082C4.27151 29.0545 4.45344 28.9988 4.63347 28.9455C4.81315 28.8879 4.98721 28.8141 5.162 28.7486C5.51122 28.6134 5.85438 28.4808 6.19753 28.3483C6.53616 28.2119 6.85488 28.0395 7.17958 27.8876C7.49939 27.7277 7.82481 27.584 8.13331 27.4146C8.73565 27.0519 9.34051 26.7183 9.90882 26.3501C10.4625 25.958 11.0127 25.5746 11.5478 25.1862C12.0546 24.7625 12.5558 24.3455 13.0547 23.9267L13.0459 23.9464Z" fill="#6A9A23"/>
<path d="M114.495 48.3233C112.222 47.5594 111.865 48.4842 114.065 49.4412C115.623 50.1181 117.228 50.7952 118.977 51.5123C119.855 51.8642 120.766 52.2322 121.724 52.617C122.269 52.8321 122.83 53.0521 123.405 53.2771C123.642 53.3719 123.882 53.4581 124.118 53.5446L124.298 53.6109L124.387 53.6431L124.432 53.658C124.448 53.6672 124.451 53.6354 124.461 53.6282L124.677 53.3074C124.82 53.0915 124.962 52.8714 125.107 52.6532C125.214 52.4803 125.323 52.3051 125.431 52.1299C126.78 49.8413 127.434 48.3201 127.986 46.9923C128.522 45.6576 128.956 44.5121 129.531 42.8088C130.002 41.3663 130.481 39.6442 130.752 37.7826C131.029 35.9289 131.072 33.9297 130.72 32.0614C130.685 31.8273 130.618 31.6003 130.566 31.3718L130.485 31.0327C130.452 30.9243 130.42 30.8201 130.388 30.7117C130.257 30.2887 130.129 29.8759 130.004 29.4734C129.871 29.0758 129.708 28.6954 129.569 28.3277C129.497 28.143 129.427 27.9644 129.357 27.79C129.273 27.619 129.194 27.4517 129.115 27.2886C128.956 26.9624 128.812 26.6518 128.666 26.3665C128.501 26.0891 128.349 25.8296 128.209 25.592C127.945 25.1071 127.656 24.7566 127.474 24.4912L127.134 24.0276L126.744 23.5997C126.627 23.4736 126.483 23.3223 126.319 23.1456C126.159 22.9644 125.94 22.7924 125.717 22.5851C125.273 22.162 124.688 21.7197 124.013 21.241C122.649 20.2913 120.829 19.3789 118.787 18.5467C117.766 18.1211 116.69 17.7191 115.586 17.3008C115.27 17.1814 114.951 17.06 114.628 16.9391C114.367 16.8399 114.105 16.7389 113.84 16.6401L113.446 16.4897L113.246 16.4147L113.146 16.3772L113.096 16.3584C113.096 16.3584 113.082 16.389 113.075 16.4064C112.755 17.2378 112.429 18.0802 112.103 18.9267C111.218 21.2191 110.304 23.5645 109.412 25.8156C108.794 27.4093 108.234 28.851 107.732 30.1514C107.421 30.9526 107.128 31.7103 106.85 32.4268C106.745 32.6982 106.644 32.965 106.543 33.2276L106.506 33.3274C106.489 33.3478 106.52 33.3471 106.533 33.3544L106.583 33.3731L106.78 33.4463C106.91 33.4938 107.038 33.5435 107.168 33.591C107.634 33.7625 108.085 33.9291 108.525 34.0903C109.559 34.458 110.424 34.7754 111.129 35.0899C111.836 35.4021 112.382 35.7072 112.788 35.9826C113.763 36.6283 114.417 37.4256 114.721 38.3225C115.031 39.2209 115.01 40.211 114.85 41.1627C114.514 43.0782 113.723 44.8274 112.888 46.5008C112.427 47.3926 112.339 47.952 112.53 48.0971L112.524 48.1921C112.543 48.1967 112.555 48.1914 112.562 48.174L112.566 48.1192C112.77 48.2253 113.25 47.9025 113.813 47.0312C114.839 45.3874 115.819 43.6386 116.32 41.4445C116.554 40.3541 116.654 39.1054 116.251 37.8205C116.047 37.1856 115.719 36.5657 115.278 36.0207C114.838 35.4734 114.298 35.004 113.712 34.6079C113.257 34.2948 112.658 33.946 111.931 33.5894C111.201 33.2309 110.34 32.8775 109.378 32.5014C109.259 32.4551 109.137 32.4069 109.015 32.3587L108.972 32.3415L108.965 32.3358L108.952 32.3285L108.932 32.3114L108.894 32.2874C108.885 32.2798 108.864 32.2774 108.883 32.2548C108.905 32.2235 108.922 32.1989 108.937 32.1767C109.05 31.9046 109.164 31.6303 109.285 31.345C109.769 30.1721 110.29 28.891 110.842 27.5045C111.2 26.6006 111.535 25.6882 111.85 24.7754C112.189 23.7893 112.548 22.774 112.917 21.7433C113.278 20.7489 113.644 19.7394 114.005 18.745L114.061 18.5681C114.061 18.5681 114.066 18.5489 114.07 18.5485L114.092 18.555L114.135 18.5681L114.223 18.5961L114.268 18.611L114.292 18.6194L114.381 18.6516L114.756 18.7891C115.003 18.881 115.248 18.9709 115.491 19.0632C115.976 19.2435 116.451 19.4227 116.91 19.6032C117.372 19.7793 117.813 19.9613 118.238 20.1365C119.943 20.8405 121.328 21.5682 122.259 22.1505C122.71 22.4597 123.088 22.685 123.314 22.8752C123.546 23.0587 123.675 23.1587 123.675 23.1587C123.675 23.1587 123.72 23.1968 123.812 23.2665C123.898 23.3387 124.044 23.4309 124.196 23.5815C124.355 23.7271 124.549 23.9055 124.772 24.1127C124.829 24.1644 124.886 24.2161 124.948 24.2717C125.001 24.3321 125.059 24.3921 125.117 24.4563C125.233 24.5848 125.355 24.7189 125.483 24.861C126.504 25.9978 127.669 27.8 128.462 30.0309C128.555 30.3103 128.651 30.5957 128.747 30.8812C128.839 31.167 128.95 31.4574 129.012 31.7415C129.087 32.0288 129.164 32.3138 129.211 32.6119L129.291 33.0539C129.312 33.2032 129.325 33.3531 129.347 33.5023C129.488 34.7029 129.464 35.9345 129.335 37.1165C129.074 39.485 128.427 41.6372 127.869 43.2046C127.024 45.5691 126.192 47.2486 125.546 48.5173C124.889 49.7808 124.393 50.6273 124.007 51.2609C123.939 51.3738 123.871 51.4825 123.805 51.589L123.775 51.6377C123.775 51.6377 123.741 51.6281 123.724 51.6254L123.618 51.5863C123.167 51.4156 122.729 51.2521 122.3 51.0921C121.329 50.7356 120.408 50.3979 119.52 50.072C117.742 49.4309 116.096 48.8581 114.486 48.3157L114.495 48.3233Z" fill="#6A9A23"/>
<path d="M63.2213 11.0802C64.3036 11.4417 64.931 11.4901 65.0627 11.2416C65.1871 11.0063 64.7809 10.4561 63.6473 9.96267C62.8457 9.6209 62.0109 9.33237 61.1289 9.10458C60.2473 8.88095 59.3135 8.7101 58.3289 8.65487C57.8413 8.59642 57.3321 8.62798 56.8151 8.61824C56.558 8.63003 56.296 8.65694 56.0313 8.67778C55.898 8.68934 55.7647 8.70089 55.6314 8.71245C55.497 8.7346 55.3648 8.75864 55.2303 8.78079C54.1508 8.93941 53.0339 9.27124 51.9327 9.78634C51.7776 9.86063 51.624 9.9285 51.4775 10.0062C51.3356 10.0878 51.1978 10.169 51.0597 10.246C50.7857 10.4019 50.528 10.5523 50.2994 10.7231C50.0662 10.8902 49.8377 11.038 49.6378 11.2022C49.4383 11.3706 49.2487 11.5318 49.0667 11.684C48.7053 11.9944 48.4124 12.3198 48.1181 12.6055C47.8555 12.9178 47.5991 13.2044 47.3722 13.4927C46.4759 14.6552 45.8317 15.7244 45.0325 17.3317C44.3767 18.7042 43.7657 20.377 43.3437 22.174C42.9124 23.9592 42.6876 25.9258 42.8109 27.7679C42.9178 29.6155 43.3565 31.3442 43.9484 32.684C44.5304 34.031 45.2423 34.9618 45.621 35.485C45.8706 35.776 46.1183 36.0692 46.3915 36.3414C46.8871 36.8083 47.8267 37.6795 49.2654 38.4989C49.6286 38.6962 50.0023 38.9177 50.4196 39.1102C50.8332 39.3072 51.2794 39.4931 51.7434 39.6669C52.6774 40.0119 53.698 40.3137 54.8094 40.5258C57.0183 40.9575 59.6288 40.962 62.1114 40.1404C63.3524 39.7391 64.5396 39.1263 65.6002 38.3608C66.6654 37.5991 67.6064 36.6867 68.4118 35.7104C69.54 34.318 70.3115 32.8999 70.9125 31.5972C71.4954 30.2794 71.8779 29.0712 72.1641 27.9868C72.4458 26.8986 72.6224 25.9307 72.7077 25.0945C72.8141 24.2606 72.8305 23.5521 72.8419 22.9783C72.8528 20.2602 72.1712 17.8559 71.051 15.9366C70.4777 14.9834 69.8234 14.1357 69.0796 13.4176C68.3284 12.7126 67.5418 12.0821 66.6795 11.5966C66.2508 11.3211 65.8679 11.2117 65.5987 11.1553C65.3256 11.1034 65.1518 11.1311 65.0821 11.2231L65.145 11.3687C65.1232 11.335 65.0952 11.3269 65.0588 11.3426L65.0431 11.3062C65.0108 11.4181 65.0816 11.582 65.2604 11.7826C65.4355 11.9877 65.7286 12.1994 66.0982 12.4947C66.8482 13.0172 67.5077 13.6566 68.1348 14.3346C68.7505 15.0261 69.282 15.813 69.7486 16.6727C70.2113 17.5369 70.5551 18.5059 70.8114 19.5559C71.0594 20.6065 71.2063 21.7499 71.1886 22.9789C71.1966 23.2174 71.1654 23.4887 71.1497 23.7922C71.1381 24.0954 71.0911 24.4268 71.0364 24.7903C70.948 25.5156 70.767 26.3601 70.5057 27.2954C69.9645 29.1699 69.1073 31.4663 67.5012 33.7163L67.3088 33.9911L67.1005 34.2525L66.6908 34.7811C66.3873 35.1054 66.1203 35.4642 65.8002 35.7668C65.6299 35.9327 65.4716 36.1164 65.2858 36.273C65.1023 36.4316 64.9187 36.5902 64.7333 36.7511C64.3409 37.0432 63.9478 37.35 63.5114 37.5935C62.6552 38.102 61.7221 38.5228 60.7441 38.7629C58.7947 39.2718 56.7658 39.2231 55.0396 38.865C53.3077 38.5136 51.8735 37.9413 50.9288 37.4483C50.4595 37.1889 50.0869 36.9799 49.8427 36.8249C49.602 36.6611 49.4726 36.5716 49.4726 36.5716C49.4726 36.5716 49.4235 36.5381 49.3322 36.4768C49.2405 36.4113 49.0971 36.3293 48.9364 36.1942C48.772 36.0637 48.5714 35.9027 48.3372 35.7174C48.1201 35.5117 47.8736 35.2813 47.5996 35.0239C47.0988 34.4714 46.5061 33.8031 46.0168 32.9475C45.52 32.1009 45.0877 31.1039 44.7938 30.0068C44.1804 27.8107 44.2512 25.251 44.7058 22.956C45.1626 20.6398 45.9616 18.5919 46.736 17.184C47.8904 15.0487 49.1258 13.7309 50.1581 12.8798C51.1942 12.0241 52.0123 11.5839 52.6484 11.2959C53.6061 10.8457 54.5704 10.5439 55.5178 10.3862C55.6356 10.3655 55.753 10.3406 55.8686 10.318C55.9871 10.3057 56.1034 10.2914 56.2219 10.279C56.4548 10.2546 56.6851 10.2242 56.9142 10.2043C57.3752 10.1979 57.8243 10.1506 58.2681 10.1877C60.0484 10.2243 61.691 10.5855 63.2383 11.0829L63.2213 11.0802Z" fill="#6A9A23"/>
<path d="M149.643 57.1462C149.707 57.1386 149.772 57.135 149.834 57.1296C149.897 57.1284 149.958 57.1335 150.017 57.1368C150.136 57.1434 150.255 57.1393 150.367 57.1485C150.584 57.1884 150.799 57.195 150.983 57.2609C151.077 57.2863 151.167 57.3078 151.257 57.3294C151.342 57.3619 151.422 57.3948 151.5 57.4216C151.58 57.4504 151.654 57.4776 151.725 57.5028C151.793 57.5368 151.859 57.5689 151.92 57.5972C152.179 57.7027 152.367 57.8102 152.516 57.8582C152.665 57.9103 152.768 57.9119 152.818 57.8655C152.869 57.8192 152.863 57.7211 152.795 57.5675C152.727 57.4139 152.604 57.2022 152.364 56.9733C152.304 56.9155 152.242 56.8517 152.176 56.7882C152.104 56.7315 152.021 56.6736 151.936 56.6138C151.851 56.554 151.758 56.4908 151.66 56.4279C151.555 56.3783 151.444 56.3271 151.328 56.2721C151.099 56.1534 150.826 56.0974 150.536 56.0197C150.391 55.9903 150.237 55.9806 150.078 55.9629C149.999 55.955 149.919 55.9452 149.837 55.9418C149.757 55.9445 149.674 55.9476 149.59 55.9506C148.636 55.9788 147.736 56.254 146.905 56.6177C146.068 56.9798 145.315 57.471 144.572 57.9823C144.209 58.2488 143.842 58.5115 143.498 58.8057C143.142 59.0862 142.801 59.3864 142.46 59.695L142.203 59.9229C142.117 59.9975 142.015 60.1008 141.928 60.1902C141.84 60.2818 141.755 60.373 141.675 60.4639L141.463 60.7068L141.37 60.8029C141.341 60.8285 141.308 60.8776 141.28 60.8192L141.196 60.7216L141.177 60.698L141.059 60.5718L140.819 60.3157C140.497 59.9722 140.173 59.6226 139.843 59.2714C139.187 58.5688 138.512 57.8509 137.823 57.1133C136.438 55.6471 134.985 54.105 133.447 52.4758C133.366 52.3925 133.286 52.3093 133.205 52.2261L133.16 52.188C133.113 52.1606 133.152 52.1278 133.173 52.0987L133.224 52.0376C133.316 51.9373 133.407 51.8393 133.497 51.7413C133.679 51.5471 133.86 51.3593 134.04 51.1738C134.763 50.4418 135.456 49.7649 136.09 49.1581C137.34 47.9418 138.448 46.9918 139.511 46.1548C140.576 45.3197 141.597 44.587 142.741 43.9067C143.884 43.2263 145.144 42.5737 146.712 41.9993C147.041 41.8701 147.387 41.775 147.733 41.6568C148.083 41.5489 148.444 41.4588 148.809 41.36C149.549 41.1973 150.314 41.0408 151.105 40.9722C152.687 40.8036 154.367 40.8909 156.008 41.2858C157.649 41.6806 159.244 42.388 160.67 43.3471C162.105 44.2991 163.355 45.4853 164.442 46.7697C165.532 48.0453 166.437 49.3937 167.101 50.744C167.769 52.094 168.2 53.4415 168.453 54.689C168.707 55.9385 168.791 57.0831 168.821 58.0542C168.854 59.0248 168.81 59.826 168.784 60.399L168.72 61.4389C168.704 61.7886 168.699 62.1626 168.693 62.5093C168.686 63.1141 168.656 63.9581 168.694 65.1446C168.711 65.7348 168.755 66.4171 168.886 67.1989C169.02 67.9762 169.253 68.8834 169.791 69.7915C170.053 70.2472 170.391 70.6816 170.799 71.0868C171.204 71.5007 171.727 71.8667 172.326 72.1546C172.941 72.4245 173.637 72.5655 174.345 72.5693C175.051 72.5605 175.743 72.4082 176.418 72.1881C177.747 71.7099 178.979 70.9338 180.172 69.9974C180.767 69.5283 181.354 69.0136 181.936 68.4638C182.23 68.1929 182.508 67.9211 182.801 67.6419C182.857 67.5887 182.911 67.5337 182.968 67.4805L183.01 67.4391C183.026 67.4524 183.042 67.4657 183.06 67.481L183.076 67.4943L183.085 67.5019L183.154 67.5756C183.256 67.6801 183.36 67.7907 183.472 67.9047C183.91 68.3619 184.42 68.8906 184.982 69.4797C186.108 70.6578 187.46 72.0766 188.952 73.6405C189.633 74.3557 190.346 75.1059 191.082 75.8793C191.101 75.907 191.162 75.9353 191.113 75.9669L191.075 76.0121L190.913 76.1856C190.524 76.6075 190.105 77.0278 189.673 77.445C189.235 77.8649 188.793 78.2851 188.349 78.7117C187.9 79.1179 187.462 79.5461 186.997 79.9389C186.087 80.7501 185.126 81.5027 184.164 82.2239C181.541 84.1593 178.922 85.5424 176.438 86.3284C173.956 87.1228 171.629 87.2992 169.639 87.0479C168.643 86.9245 167.728 86.7079 166.902 86.427C166.08 86.1373 165.338 85.8072 164.678 85.449C163.359 84.7303 162.368 83.9392 161.596 83.2591C160.691 82.4521 159.878 81.572 159.161 80.6753C158.43 79.7861 157.823 78.8547 157.303 77.9115C156.265 76.0228 155.669 74.0497 155.387 72.0934C155.235 71.1162 155.172 70.1397 155.141 69.1751C155.104 68.2089 155.139 67.2533 155.147 66.279C155.152 65.3092 155.16 64.358 155.127 63.3873C155.092 62.4231 155.005 61.4381 154.757 60.4609C154.485 59.4059 153.996 58.6741 153.603 58.2822C153.412 58.0785 153.232 57.9619 153.1 57.8936C152.968 57.8253 152.879 57.812 152.832 57.8497L152.701 57.8442C152.697 57.8635 152.703 57.8692 152.722 57.8655L152.829 57.8436L152.808 57.8685C152.77 57.9138 152.772 58.008 152.817 58.1426C152.86 58.2752 152.946 58.4482 153.042 58.6791C153.244 59.1316 153.527 59.7785 153.718 60.7041C153.889 61.5705 153.936 62.4792 153.926 63.4054C153.92 64.3312 153.872 65.2838 153.833 66.2398C153.722 68.1482 153.636 70.1889 153.902 72.2935C154.151 74.3995 154.77 76.593 155.881 78.6747C156.437 79.7134 157.093 80.7371 157.873 81.7018C158.641 82.6759 159.501 83.6149 160.49 84.5006C161.26 85.1829 162.28 86.0177 163.649 86.8244C165.02 87.6183 166.762 88.3758 168.863 88.7476C170.959 89.1156 173.393 89.0683 175.922 88.44C178.453 87.8219 181.043 86.6301 183.565 85.0036C185.208 83.94 186.742 82.7265 188.162 81.4284C188.478 81.1492 188.784 80.8541 189.092 80.5567C189.402 80.2613 189.714 79.9636 190.011 79.665C190.619 79.0668 191.235 78.4573 191.845 77.8107L192.299 77.316C192.345 77.2617 192.523 77.0679 192.639 76.9257L193.021 76.4708L193.391 76.0086L193.486 75.8955C193.48 75.8561 193.425 75.821 193.399 75.7834L193.195 75.566C192.933 75.2761 192.65 74.988 192.374 74.7014C191.761 74.0705 191.146 73.4377 190.534 72.8068C189.331 71.5598 188.135 70.3226 186.969 69.1144C185.625 67.7139 184.318 66.348 183.066 65.0444C182.442 65.6398 181.829 66.2259 181.227 66.8048C181.016 67.0098 180.808 67.2062 180.602 67.3919C180.393 67.5799 180.196 67.7733 179.987 67.9488C179.164 68.6706 178.326 69.2951 177.498 69.7927C176.67 70.2863 175.836 70.6439 175.066 70.7841C174.293 70.9266 173.6 70.8461 173.042 70.5966C172.477 70.3497 172.045 69.936 171.712 69.5326C171.383 69.1289 171.169 68.7362 171.022 68.3965C170.949 68.2266 170.901 68.067 170.85 67.9351C170.811 67.7937 170.778 67.677 170.753 67.5826C170.724 67.4886 170.713 67.4098 170.7 67.3606C170.689 67.309 170.683 67.2844 170.683 67.2844C170.683 67.2844 170.655 67.1757 170.62 66.9647C170.602 66.8571 170.582 66.7245 170.558 66.5692C170.542 66.409 170.522 66.2261 170.5 66.0182C170.428 65.181 170.429 63.9304 170.475 62.3506C170.48 61.578 170.559 60.7172 170.575 59.7653C170.586 58.816 170.584 57.7985 170.473 56.7275C170.366 55.6562 170.183 54.5328 169.879 53.3967C169.563 52.2616 169.12 51.1208 168.563 50.0109C168.013 48.8919 167.297 47.8419 166.532 46.8276C166.332 46.5785 166.135 46.3312 165.933 46.0802C165.729 45.8356 165.508 45.603 165.296 45.3632C165.082 45.1258 164.871 44.886 164.637 44.6587C164.41 44.4287 164.184 44.1965 163.941 43.9846C162.045 42.2207 159.744 40.834 157.312 40.1068C154.881 39.3649 152.383 39.3003 150.19 39.631C147.983 39.9545 146.071 40.6532 144.51 41.353C142.165 42.4333 140.292 43.6636 138.737 44.8286C137.183 45.9978 135.935 47.0964 134.891 48.0807C133.859 49.0556 132.992 49.8798 132.263 50.6501C132.173 50.7481 132.085 50.8439 131.996 50.9355C131.87 51.0807 131.724 51.2361 131.601 51.3915C131.474 51.5473 131.351 51.6986 131.228 51.8498C131.165 51.9245 131.108 52.0008 131.048 52.0732C131.006 52.1461 130.87 52.225 130.986 52.2883C131.232 52.5607 131.465 52.8217 131.709 53.0734C131.889 53.2634 132.062 53.4477 132.23 53.624C133.778 55.2461 135.238 56.775 136.632 58.2363C137.33 58.9626 138.015 59.6733 138.681 60.3688C139.015 60.7154 139.345 61.0583 139.674 61.3969C139.865 61.5964 140.056 61.7918 140.245 61.9894L140.649 62.4098C140.784 62.5428 140.916 62.6615 141.049 62.7885L141.247 62.9748L141.299 63.0185L141.32 63.044C141.325 63.0478 141.329 63.0516 141.332 63.0535L141.343 63.0399L141.444 62.943L141.83 62.5529C142.085 62.3 142.335 62.0077 142.564 61.7213C142.888 61.3177 143.089 61.0967 143.437 60.779C143.751 60.4791 144.068 60.1851 144.395 59.9113C144.712 59.6257 145.047 59.3701 145.374 59.1088C146.043 58.6165 146.72 58.1424 147.435 57.8013C148.146 57.4564 148.886 57.2055 149.62 57.1503L149.643 57.1462Z" fill="#6A9A23"/>
<path d="M80.321 25.3809C80.4416 23.1064 79.4571 23.0281 79.1312 25.2574C78.8942 26.839 78.6434 28.4554 78.3341 30.1965C78.018 31.9318 77.6635 33.8048 77.0533 35.8028C76.9621 36.1317 76.8558 36.4326 76.7629 36.7176C76.7418 36.7887 76.7161 36.8559 76.6904 36.9232C76.6579 37.0079 76.6295 37.0922 76.5966 37.1726C76.5069 37.4217 76.4055 37.6571 76.3015 37.8865C75.8871 38.7743 75.5595 39.4762 75.3454 39.9375C76.5743 39.8079 77.6597 39.6697 78.5962 39.5571C79.1374 39.4829 79.6268 39.4153 80.1059 39.3507C81.0599 39.2218 81.9734 39.109 83.1533 38.9963C85.9529 38.7116 89.7215 38.3996 93.0728 38.1385C93.9107 38.0743 94.7237 38.0122 95.4885 37.9522C95.6782 37.9379 95.8679 37.9235 96.0534 37.9095C96.3908 37.8803 96.7199 37.8518 97.0447 37.8236C97.2132 37.8069 97.3821 37.7943 97.5465 37.778L97.6089 37.7726C97.6204 37.759 97.6182 37.734 97.6228 37.7147L97.6419 37.5956L97.6801 37.3573C97.73 37.0361 97.7788 36.7255 97.826 36.4214C97.9332 35.7428 98.0279 35.1387 98.1097 34.628C98.1809 34.1392 98.241 33.7417 98.2835 33.4568C98.332 33.119 98.3699 32.78 98.4014 32.4394C98.4496 31.9044 98.5308 30.972 98.6212 29.7346C98.6626 29.1205 98.7101 28.4302 98.7605 27.6768C98.8248 26.9389 98.9042 26.1326 98.9956 25.2707C99.1893 23.5523 99.4495 21.6308 99.8761 19.6446C100.088 18.6526 100.35 17.6438 100.688 16.6576C100.777 16.415 100.869 16.172 100.959 15.9271L101.111 15.5677L101.185 15.3871C101.19 15.3678 101.226 15.3017 101.255 15.2447L101.343 15.0755L101.695 14.3903C101.746 14.2788 101.822 14.1569 101.901 14.0346L102.126 13.671C102.421 13.1964 102.713 12.72 103.01 12.2431C102.93 12.2417 102.807 12.2544 102.664 12.2689C102.522 12.2812 102.364 12.2991 102.189 12.3143C101.84 12.3487 101.434 12.3902 100.989 12.433C100.271 12.5015 99.4285 12.5851 98.594 12.6637C92.1629 13.3177 88.1819 13.7215 86.104 13.9331C84.8775 14.0646 83.7301 14.1892 82.6387 14.3069C81.9634 14.3843 81.3068 14.4581 80.6649 14.5326L80.3138 14.5735L80.1393 14.5928L80.054 14.6023C80.054 14.6023 80.0158 14.5972 80.0195 14.6158L80.0129 14.6604C79.9849 14.8958 79.9566 15.1269 79.9306 15.36C79.9042 15.5889 79.8778 15.8178 79.8514 16.0467C79.8379 16.1821 79.824 16.3134 79.8105 16.4489C79.6178 18.4463 79.5162 20.2848 79.4719 22.1057C79.4328 24.1087 80.2926 24.1517 80.5363 22.1855C80.7678 20.3945 81.0108 18.59 81.2991 16.6304C81.3163 16.5135 81.3335 16.3966 81.3507 16.2797L81.3736 16.156L81.3968 16.0365C81.4245 16.0173 81.4801 16.0293 81.5173 16.0219L81.6426 16.0152C81.7592 16.0051 81.8758 15.995 81.9924 15.9849C82.259 15.9618 82.5275 15.9364 82.8005 15.9148C83.891 15.8119 85.0441 15.7036 86.2698 15.5868C88.1772 15.3942 92.1765 15.2259 97.792 14.7013C98.2499 14.6575 98.7073 14.6094 99.1621 14.5553L99.459 14.5191C99.459 14.5191 99.4628 14.5146 99.4666 14.51C99.4723 14.5032 99.4841 14.4938 99.5061 14.4814C99.5282 14.469 99.5786 14.4458 99.6074 14.4391C99.6134 14.4595 99.619 14.4758 99.5928 14.562L99.5732 14.6267L99.4323 14.9872C99.3335 15.2287 99.2457 15.4755 99.1662 15.7216C98.8317 16.7074 98.5712 17.7014 98.3498 18.6858C97.9192 20.6493 97.6406 22.5514 97.4316 24.2145C97.2283 25.8708 97.0684 27.301 96.9964 28.3144C96.9101 29.3081 96.8578 29.8938 96.8578 29.8938C96.8578 29.8938 96.7819 30.8383 96.6206 32.3483C96.541 33.1043 96.4359 34.0009 96.3094 34.9918C96.2578 35.3655 96.2075 35.756 96.1523 36.1615C96.1696 36.2649 96.0622 36.2365 95.9922 36.2509C95.7737 36.272 95.5533 36.2953 95.3287 36.3189C90.738 36.7819 85.3487 37.3267 82.1496 37.6502L79.3959 37.9309L78.3394 38.0392L78.1542 38.0574L78.0607 38.0676L78.0148 38.0716C78.0148 38.0716 77.9678 38.0861 77.9869 38.0635C78.0476 37.9407 78.1061 37.8161 78.1578 37.6857L78.2605 37.4166C78.3084 37.2907 78.3479 37.1656 78.3917 37.0401C78.4791 36.7891 78.5624 36.5385 78.637 36.2845C79.2812 34.1451 79.6012 32.2122 79.8478 30.4262C80.088 28.6386 80.2266 26.9858 80.3206 25.3767L80.321 25.3809Z" fill="#6A9A23"/>
</g>
</g>
<defs>
<clipPath id="clip0_783_5660">
<rect width="421" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 346) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $f2f805f49af46a8b$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6 = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$ea8e736e4eb06883$require$Buffer.from($f2f805f49af46a8b$var$$ea8e736e4eb06883$var$learningPathBg).toString("base64")}`;
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$export$8b251419efc915eb = ({ isCourse: isCourse, courseImgUrl: courseImgUrl, title: title, completedItems: completedItems, progress: progress, learningPathSlug: learningPathSlug, courseSlug: courseSlug, navigate: navigate })=>{
    const handleNavigation = (0, $acw62.useCallback)(()=>{
        learningPathSlug ? navigate(`/path/${learningPathSlug}`) : navigate(`/course/${courseSlug}`);
    }, [
        learningPathSlug,
        courseSlug,
        navigate
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleNavigation);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-header",
        css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$headerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$headerImageStyles,
                src: isCourse ? $f2f805f49af46a8b$var$$e48fba9cf5395297$export$d3a66d29d3f047ac : $f2f805f49af46a8b$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6,
                alt: title
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: [
                    $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$headerContentStyles,
                    isCourse && $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles
                ],
                children: [
                    isCourse && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$courseImageContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                            css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$courseImageStyles,
                            src: courseImgUrl,
                            alt: title,
                            "data-testid": "course-image"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: [
                            $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$containerStyles,
                            isCourse && (0, $dnfL5.css)({
                                marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
                            })
                        ],
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$typeStyles,
                                children: isCourse ? "Course" : "Learning Path"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                role: "button",
                                tabIndex: 0,
                                css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$titleStyles,
                                "data-testid": "sidebar-title",
                                onClick: handleNavigation,
                                onKeyDown: onKeyDown,
                                children: title
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        "data-testid": "course-progress-circle",
                        css: $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1a77571422b9634a$export$5ab97151efedb8c6), {
                            strokeWidth: 8,
                            value: progress,
                            styles: (0, $1a77571422b9634a$export$5115a192ad9bf57f)({
                                pathColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success"),
                                trailColor: "rgba(9, 30, 66, 0.14)"
                            }),
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$progressStyles,
                                    isCourse && (0, $dnfL5.css)({
                                        fontSize: "14px"
                                    })
                                ],
                                "data-testid": "progress-text",
                                children: completedItems
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$headerStyles = (0, $dnfL5.css)({
    width: "100%",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$headerImageStyles = (0, $dnfL5.css)({
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$headerContentStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles = (0, $dnfL5.css)({
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles = (0, $dnfL5.css)({
    maxWidth: "48px",
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$progressStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$courseImageContainerStyles = (0, $dnfL5.css)({
    width: "32px",
    minWidth: "32px",
    minHeight: "32px"
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$courseImageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto"
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$typeStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$0dbf0b63949b5d22$var$titleStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    transition: "color 0.5s ease",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    "&:hover": {
        cursor: "pointer",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$792ece11a7230884 = 89;
const $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e = 8;
const $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$686a18f490557de2 = 16;
const $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 = 250;
const $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 = 68;
const $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8 = (positionData)=>{
    const height = positionData.height > $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$792ece11a7230884 ? $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$792ece11a7230884 : positionData.height;
    const subnavbarPosition = document.getElementById("subnavbar")?.getBoundingClientRect();
    const offset = subnavbarPosition && subnavbarPosition.y < $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 ? $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 - subnavbarPosition.y : 0;
    return {
        top: positionData.top - ($f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 / 2 - height / 2) + offset - $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$686a18f490557de2,
        left: $f2f805f49af46a8b$var$$035f8a623e403361$export$780035d9fe48eb32 - $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$686a18f490557de2
    };
};
const $f2f805f49af46a8b$var$$f50e6e435b887166$export$1671b398b5e36be4 = ({ courses: courses, renderPopup: renderPopup })=>{
    const { hoverInfo: hoverInfo, popupRef: popupRef, handleMouseLeave: handleMouseLeave } = $f2f805f49af46a8b$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const courseToShowInPopup = (0, $acw62.useMemo)(()=>courses.find(({ sys: sys })=>sys.id === hoverInfo?.courseId), [
        hoverInfo?.courseId,
        courses
    ]);
    const handlePopupLeave = (e)=>{
        const popupId = popupRef.current?.children[0].id;
        const isMovedToOutside = e.target.closest(`#${popupId}`);
        if (isMovedToOutside) handleMouseLeave();
    };
    if (!hoverInfo) return null;
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        "data-testid": "sidebar-hover-popup",
        ref: popupRef,
        onMouseLeave: handlePopupLeave,
        css: [
            $f2f805f49af46a8b$var$$f50e6e435b887166$var$popupStyles,
            (0, $dnfL5.css)($f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8(hoverInfo.courseCardPosition))
        ],
        children: renderPopup(courseToShowInPopup)
    });
};
const $f2f805f49af46a8b$var$$f50e6e435b887166$var$popupStyles = (0, $dnfL5.css)({
    position: "absolute",
    zIndex: 100,
    transform: "translateY(-50%)",
    paddingLeft: `${$f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$686a18f490557de2 + $f2f805f49af46a8b$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e}px`,
    marginLeft: "-1px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$export$4ff69a78d3a65d6f = ({ isVisible: isVisible = true, isLoading: isLoading, learningPath: learningPath, progressForLessons: progressForLessons, progressForCourses: progressForCourses, expandedCourseIds: expandedCourseIds = [], expandedLessonIds: expandedLessonIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, navigate: navigate = ()=>{}, renderPopup: renderPopup, onToggleVisibility: onToggleVisibility })=>{
    const [showCurrentLessonButton, setShowCurrentLessonButton] = (0, $acw62.useState)(false);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    const selectedLessonRef = (0, $acw62.useRef)(null);
    const courses = (0, $acw62.useMemo)(()=>learningPath?.coursesCollection.items || [], [
        learningPath?.coursesCollection.items
    ]);
    const lessons = (0, $acw62.useMemo)(()=>courses.flatMap((course)=>course.lessonsCollection.items), [
        courses
    ]);
    const numberOfCompletedLessons = lessons.filter(({ sys: { id: id } })=>progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status === $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const numberOfCompletedCourses = courses.filter(({ sys: { id: id } })=>progressForCourses?.courses.find((course)=>course.courseId === id)?.status === $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const selectedCourse = courses.find(({ slug: slug })=>$f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d(slug));
    const isCourse = !learningPath?.title;
    const courseImage = (courses[0]?.reward?.orangeLogicAsset?.imageUrl ?? courses[0]?.reward?.badgeCdnUrl) || $f2f805f49af46a8b$var$$ef44b01e6346ac17$export$44f5f766f3f98994;
    const calculateProgress = ()=>isCourse ? numberOfCompletedLessons / lessons.length * 100 : numberOfCompletedCourses / courses.length * 100;
    const completedEntities = isCourse ? numberOfCompletedLessons : numberOfCompletedCourses;
    const totalEntities = isCourse ? lessons.length : courses.length;
    // Find the selected lesson in either the main lessons array or inside course cards
    const selectedLessonId = (0, $acw62.useMemo)(()=>isCourse ? lessons.find(({ slug: slug })=>$f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d("", slug)) : courses.reduce((found, course)=>{
            if (found) return found;
            const selectedLesson = course.lessonsCollection.items.find(({ slug: slug })=>$f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d("", slug));
            return selectedLesson ? selectedLesson.sys.id : undefined;
        }, undefined), [
        isCourse,
        lessons,
        courses
    ]);
    // Handle scroll event to check if selected lesson is visible
    const handleScroll = (0, $acw62.useCallback)(()=>{
        if (!scrollContainerRef.current || !selectedLessonRef.current || !selectedLessonId) return;
        const container = scrollContainerRef.current;
        const selectedLessonElement = selectedLessonRef.current;
        const containerRect = container.getBoundingClientRect();
        const lessonRect = selectedLessonElement.getBoundingClientRect();
        // Check if the selected lesson is above the visible area
        const isLessonAboveViewport = lessonRect.top < containerRect.top;
        setShowCurrentLessonButton(isLessonAboveViewport);
    }, [
        selectedLessonId
    ]);
    const scrollToSelectedLesson = (0, $acw62.useCallback)(()=>{
        if (selectedLessonRef.current && scrollContainerRef.current) selectedLessonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
            handleScroll();
            return ()=>{
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        selectedLessonId
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("aside", {
        "data-testid": "sidebar",
        css: [
            $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarStyles,
            !isVisible && $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarClosedStyles
        ],
        children: [
            isVisible && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$closeButtonContainerStyles,
                onClick: onToggleVisibility,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggleVisibility?.();
                    }
                },
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                    "data-testid": "sidebar-mobile-close-button",
                    css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$closeButtonStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                            css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$closeButtonTextStyles,
                            children: "Close"
                        })
                    ]
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                "data-testid": "sidebar-toggle-button",
                css: [
                    $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarButton,
                    isCourse && $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles
                ],
                onClick: onToggleVisibility,
                "aria-label": isVisible ? "Collapse sidebar" : "Expand sidebar",
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                    type: isVisible ? "sidebar-collapse" : "sidebar-expand"
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0dbf0b63949b5d22$export$8b251419efc915eb, {
                isCourse: isCourse,
                learningPathSlug: learningPath?.slug,
                courseSlug: courses[0]?.slug,
                title: isCourse ? selectedCourse?.title || "" : learningPath?.title || "",
                completedItems: `${completedEntities}/${totalEntities}`,
                progress: calculateProgress(),
                courseImgUrl: courseImage,
                navigate: navigate
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)($f2f805f49af46a8b$var$$32c02b5652036d7a$export$d8355e8edbcacbe8, {
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        "data-testid": "sidebar-cards-container",
                        css: [
                            $f2f805f49af46a8b$var$$3d76652bb6362040$var$cardsContainerStyles,
                            isCourse && $f2f805f49af46a8b$var$$3d76652bb6362040$var$cardsContainerForCourseStyles
                        ],
                        children: [
                            showCurrentLessonButton && selectedLessonId && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                                css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$currentLessonStyles,
                                onClick: scrollToSelectedLesson,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        type: "arrow-up",
                                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$buttonTextStyles,
                                        children: "Current lesson"
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$cardsScrollableContainerStyles,
                                ref: scrollContainerRef,
                                children: isCourse ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    "data-testid": "sidebar-lesson-container",
                                    css: $f2f805f49af46a8b$var$$3d76652bb6362040$var$lessonContainerStyles,
                                    children: lessons.map((lesson)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                            ref: $f2f805f49af46a8b$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                                                isCourse: isCourse,
                                                courseSlug: selectedCourse?.slug,
                                                lesson: lesson,
                                                progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                                                onSelect: onSelect,
                                                expandedLessonIds: expandedLessonIds,
                                                isLoading: isLoading,
                                                selectedSectionId: selectedSectionId,
                                                currentLessonSlug: currentLessonSlug
                                            })
                                        }, lesson.sys.id))
                                }) : courses.map((course)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c, {
                                        course: course,
                                        progressForLessons: progressForLessons,
                                        status: $f2f805f49af46a8b$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForCourses?.courses.find((courseProgress)=>courseProgress.courseId === course.sys.id)?.status),
                                        onSelect: onSelect,
                                        isLoading: isLoading,
                                        selectedLessonRef: selectedLessonRef,
                                        expandedLessonIds: expandedLessonIds,
                                        expandedCourseIds: expandedCourseIds,
                                        selectedSectionId: selectedSectionId,
                                        currentLessonSlug: currentLessonSlug,
                                        scrollContainerRef: scrollContainerRef
                                    }, course.sys.id))
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$f50e6e435b887166$export$1671b398b5e36be4, {
                        courses: courses,
                        renderPopup: renderPopup
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarStyles = (0, $dnfL5.css)({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    width: `${$f2f805f49af46a8b$var$$035f8a623e403361$export$780035d9fe48eb32}px`,
    borderRight: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    transition: "transform 0.3s ease",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarClosedStyles = (0, $dnfL5.css)({
    transform: "translateX(-412px)",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        transform: "translateX(-100%)"
    }
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$closeButtonContainerStyles = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.xs]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$closeButtonStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "none",
    cursor: "pointer"
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$closeButtonTextStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarButton = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "32px",
    height: "32px",
    top: "84px",
    right: "calc(-32px - 16px)",
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    padding: 0,
    border: "none",
    cursor: "pointer",
    zIndex: 100,
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.hovered")
    },
    "&:active": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.pressed")
    },
    svg: {
        width: "24px",
        height: "24px"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles = (0, $dnfL5.css)({
    top: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$cardsContainerStyles = (0, $dnfL5.css)({
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    minHeight: 0
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$cardsContainerForCourseStyles = (0, $dnfL5.css)({
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$currentLessonStyles = (0, $dnfL5.css)({
    position: "absolute",
    zIndex: 100,
    top: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    width: "fit-content",
    borderRadius: "100px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 0px 1px rgba(188, 214, 240, 0.00) inset"
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$buttonTextStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$lessonContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$3d76652bb6362040$var$cardsScrollableContainerStyles = (0, $dnfL5.css)({
    flex: 1,
    overflowY: "auto",
    minHeight: 0
});
var $f2f805f49af46a8b$var$$764442aba3de2fce$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$764442aba3de2fce$exports, "VIDEO_CONTROL_TYPES", ()=>$f2f805f49af46a8b$export$2ffae0f952561172);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$764442aba3de2fce$exports, "Video", ()=>$f2f805f49af46a8b$export$ae01dedf5c052bb);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $f2f805f49af46a8b$export$2ffae0f952561172 = [
    "play-small",
    "play",
    "progress",
    "current-time",
    "rewind",
    "fast-forward",
    "mute",
    "volume",
    "settings",
    "fullscreen",
    "seektime"
];
const $f2f805f49af46a8b$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $f2f805f49af46a8b$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH = 920;
const $f2f805f49af46a8b$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH = "/CDNLink/";
const $f2f805f49af46a8b$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl = (videoUrl)=>videoUrl?.includes($f2f805f49af46a8b$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH) ?? false;
const $f2f805f49af46a8b$export$ae01dedf5c052bb = ({ orangeUrl: orangeUrl, vimeoUrl: vimeoUrl, youtubeUrl: youtubeUrl, captions: captions, chapters: chapters, controls: controls, width: width, height: height, videoId: videoId, name: name, poster: poster = "", onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError, customControls: customControls, hasResponsiveControls: hasResponsiveControls, preload: preload = "metadata" })=>{
    const videoRef = (0, $acw62.useRef)(null);
    const playerRef = (0, $acw62.useRef)(null);
    const mobileControls = (0, $acw62.useMemo)(()=>customControls?.customMobileControls ?? [
            ...$f2f805f49af46a8b$export$2ffae0f952561172
        ], [
        customControls?.customMobileControls
    ]);
    const desktopControls = (0, $acw62.useMemo)(()=>customControls?.customDesktopControls ?? [
            ...$f2f805f49af46a8b$export$2ffae0f952561172
        ], [
        customControls?.customDesktopControls
    ]);
    const hasCustomDesktopControls = Boolean(customControls?.customDesktopControls?.length);
    const videoSrc = (0, $acw62.useMemo)(()=>orangeUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = (0, $acw62.useMemo)(()=>({
            type: "video",
            sources: [
                {
                    src: videoSrc
                }
            ],
            tracks: [
                {
                    kind: "captions",
                    label: "English",
                    srcLang: "en",
                    src: captions,
                    default: true
                }
            ]
        }), [
        videoSrc,
        captions
    ]);
    const playerOptions = (0, $acw62.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: true,
                seek: true
            },
            controls: desktopControls,
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        desktopControls,
        chapters,
        preload
    ]);
    const playerOptionsMobile = (0, $acw62.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: controls,
                seek: true
            },
            controls: controls ? mobileControls : [],
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        controls,
        mobileControls,
        chapters,
        preload
    ]);
    const addEvents = (0, $acw62.useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            const addEvent = (event)=>instance.on(event, ()=>onControlClick && onControlClick(event));
            addEvent("play");
            addEvent("pause");
            addEvent("captionsenabled");
            addEvent("captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onProgressUpdate,
        onError,
        name,
        videoId
    ]);
    (0, $acw62.useEffect)(()=>{
        // ✅ Destroy old player before creating new one
        const destroyPlayer = ()=>{
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
        const initializePlayer = ()=>{
            if (!videoRef.current) return;
            destroyPlayer(); // ✅ Clean up first
            const isMobileSize = hasResponsiveControls ? window.innerWidth >= $f2f805f49af46a8b$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH : window.innerWidth <= $f2f805f49af46a8b$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
            const player = new (0, (/*@__PURE__*/$parcel$interopDefault($52477d57b9d8c8b9$exports)))(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
            player.source = playerSource;
            player.poster = poster;
            addEvents(player);
            if ($f2f805f49af46a8b$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl(orangeUrl) && videoRef.current?.hasAttribute("crossorigin")) {
                // Orange Logic CDNLink URLs can fail CORS checks with crossorigin="anonymous".
                // Removing it restores playback for the original asset.
                videoRef.current.removeAttribute("crossorigin");
                videoRef.current.load();
            }
            playerRef.current = player; // ✅ Store reference
            const plyrVideoContainers = document.getElementsByClassName("plyr--video");
            if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
        };
        const handleResize = ()=>{
            initializePlayer();
        };
        window.addEventListener("resize", handleResize);
        initializePlayer();
        return ()=>{
            window.removeEventListener("resize", handleResize);
            destroyPlayer();
        };
    }, [
        hasResponsiveControls,
        playerOptions,
        playerOptionsMobile,
        playerSource,
        poster,
        orangeUrl,
        addEvents
    ]);
    if (videoSrc === vimeoUrl) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $dnfL5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $dnfL5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: [
            $f2f805f49af46a8b$var$$764442aba3de2fce$var$videoPlayerStyles,
            hasCustomDesktopControls && $f2f805f49af46a8b$var$$764442aba3de2fce$var$unsetVolumeWidthStyles
        ],
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            preload: preload,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$764442aba3de2fce$var$videoPlayerStyles = (0, $dnfL5.css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $2b750d3a8789dea3$export$7d61b15e0da132af),
    "--plyr-audio-control-color": (0, $2b750d3a8789dea3$export$7d61b15e0da132af),
    "--plyr-menu-color": (0, $2b750d3a8789dea3$export$7d61b15e0da132af),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $2b750d3a8789dea3$export$7d61b15e0da132af),
    ":focus-visible": {
        border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$764442aba3de2fce$var$unsetVolumeWidthStyles = (0, $dnfL5.css)({
    ".plyr__controls__item.plyr__volume": {
        minWidth: "unset !important",
        width: "unset !important"
    }
});
var $f2f805f49af46a8b$var$$77282b3961d82199$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$77282b3961d82199$exports, "Columns", ()=>$f2f805f49af46a8b$export$f02cc02ad0e0bba3);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$77282b3961d82199$exports, "LessonColumns", ()=>$f2f805f49af46a8b$export$2dde675552f76fc5);
let $f2f805f49af46a8b$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($f2f805f49af46a8b$export$f02cc02ad0e0bba3 || ($f2f805f49af46a8b$export$f02cc02ad0e0bba3 = {}));
const $f2f805f49af46a8b$export$2dde675552f76fc5 = ({ columns: columns = $f2f805f49af46a8b$export$f02cc02ad0e0bba3.TWO, children: children })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("section", {
        css: $f2f805f49af46a8b$var$$77282b3961d82199$var$sectionStyles,
        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
            "data-testid": "lesson-columns",
            css: [
                $f2f805f49af46a8b$var$$77282b3961d82199$var$lessonColumnsStyles,
                $f2f805f49af46a8b$var$$77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $f2f805f49af46a8b$var$$77282b3961d82199$var$sectionStyles = (0, $dnfL5.css)({
    textOverflow: "ellipsis",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.lg]: {
        textOverflow: "clip"
    }
});
const $f2f805f49af46a8b$var$$77282b3961d82199$var$lessonColumnsStyles = (0, $dnfL5.css)({
    display: "grid",
    columnGap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $f2f805f49af46a8b$var$$77282b3961d82199$var$lessonColumnsMDStyles = {
    [$f2f805f49af46a8b$export$f02cc02ad0e0bba3.TWO]: (0, $dnfL5.css)({
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$f2f805f49af46a8b$export$f02cc02ad0e0bba3.THREE]: (0, $dnfL5.css)({
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$f2f805f49af46a8b$export$f02cc02ad0e0bba3.FOUR]: (0, $dnfL5.css)({
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};
var $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$exports, "LearningCourseCard", ()=>$f2f805f49af46a8b$export$5ae3342de8088f07);
const $f2f805f49af46a8b$export$5ae3342de8088f07 = ({ inspectMode: inspectMode, title: title, imageUrl: imageUrl, onClick: onClick, link: link, minHeight: minHeight = 153, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications })=>{
    const cardRef = (0, $acw62.useRef)(null);
    const onClickHandler = (0, $acw62.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleUpdatedButtonClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(onClickHandler);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
        href: link,
        css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            role: "button",
            ref: cardRef,
            css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                css: [
                                    $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                                "data-testid": "title",
                                ...$f2f805f49af46a8b$export$1784ac302bd8ebad("title", inspectMode),
                                css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$184a993f673fc83f, {
                                wasPreviouslyCompleted: learningProgress.status === $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    isUpdated && learningProgress.status !== $f2f805f49af46a8b$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        "data-testid": "updated-icon",
                                        css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                            label: "Updated",
                                            iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                                type: "editor-panel"
                                            }),
                                            onClick: handleUpdatedButtonClick
                                        })
                                    }),
                                    shouldDisplayShowMoreButton && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$ca7697601dcd7803, {
                                        cardRef: cardRef,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf,
                                        areHistoricalNotifications: areHistoricalNotifications,
                                        onViewUpdates: onViewUpdates
                                    }),
                                    shouldDisplayBookmark && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("button", {
                                        "data-testid": "save-content",
                                        css: $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "bookmark-filled"
                                        }) : (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")}`
    }
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")}`,
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`
    }
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $dnfL5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$imageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$noImageStyles = (0, $dnfL5.css)({
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.0")}`
    }
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $dnfL5.css)({
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $dnfL5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$titleStyles = (0, $dnfL5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
var $f2f805f49af46a8b$var$$27d686e47ff412fd$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$27d686e47ff412fd$exports, "FeedbackHeader", ()=>$f2f805f49af46a8b$export$41cd510048068b0c);
const $f2f805f49af46a8b$export$41cd510048068b0c = ({ heading: heading, duration: duration, description: description })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$headingWrapperStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("h1", {
                    css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$metadataStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$flexContainerStyles,
                    children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: (0, $dnfL5.css)({
                            display: "flex"
                        }),
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                                    label: duration
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$lineWrapperStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2e0a83ec2e27ecbb, {
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$metadataStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$flexContainerStyles = (0, $dnfL5.css)({
    display: "flex"
});
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$tagStyles = (0, $dnfL5.css)({
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$lineWrapperStyles = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")} 0`
});
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$headingWrapperStyles = (0, $dnfL5.css)({
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.1000")} 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} 0`
});
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$headingStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $f2f805f49af46a8b$var$$27d686e47ff412fd$var$descriptionStyles = (0, $dnfL5.css)({
    paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    }
});
var $f2f805f49af46a8b$var$$a4deb03146bf3bfc$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a4deb03146bf3bfc$exports, "ReportIssueModal", ()=>$f2f805f49af46a8b$export$448811829c5d1992);
let $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$DialogWidth || ($f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$DialogWidth = {}));
const $f2f805f49af46a8b$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch, consentToContact: consentToContact, selectValue: selectValue, textAreaValues: textAreaValues, heading: heading, width: width = $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$DialogWidth.LARGE, options: options, isDisabled: isDisabled, closeModal: closeModal, submit: submit, onSelectChange: onSelectChange, onTextChange: onTextChange, onParticipatingInResearch: onParticipatingInResearch, onConsentToContact: onConsentToContact })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $7ea5684aaa353f60$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("p", {
                            css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $dnfL5.css)({
                                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: (0, $dnfL5.css)({
                                marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                            }),
                            children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: (0, $dnfL5.css)({
                                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$selectContainerStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6a65a164d1aeffc0$export$2e2bcd8739ae039), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: (0, $dnfL5.css)({
                                        marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
                                    }),
                                    children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                                css: (0, $dnfL5.css)({
                                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$detailsStyles,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $152edff8f3d35f34$export$2e2bcd8739ae039), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: (0, $dnfL5.css)({
                                        marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
                                    }),
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$48513f6b9f8ce62d, {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$48513f6b9f8ce62d, {
                                        label: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("span", {
                    css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $64c424bfb08ced14$export$2e2bcd8739ae039), {
                                appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                            label: "Submit",
                            appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalContainerStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
    }
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $dnfL5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$selectContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$detailsStyles = (0, $dnfL5.css)({
    width: "100%",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
    }
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$modalBodyStyles = (0, $dnfL5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $dnfL5.css)({
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    button: {
        height: "100%",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
        fontWeight: 600
    }
});
const $f2f805f49af46a8b$var$$a4deb03146bf3bfc$var$policyContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});
var $f2f805f49af46a8b$var$$0ae392c3008c8a3e$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$0ae392c3008c8a3e$exports, "FlatContentCardStyle", ()=>$f2f805f49af46a8b$export$f2adaabc3a0295ef);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$0ae392c3008c8a3e$exports, "FlatContentCardType", ()=>$f2f805f49af46a8b$export$8023ea0baf29b8db);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$0ae392c3008c8a3e$exports, "FlatContentCard", ()=>$f2f805f49af46a8b$export$bc8a9d98c2eabbb7);
let $f2f805f49af46a8b$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($f2f805f49af46a8b$export$f2adaabc3a0295ef || ($f2f805f49af46a8b$export$f2adaabc3a0295ef = {}));
let $f2f805f49af46a8b$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
    FlatContentCardType["FLEXIBLE"] = "flexible";
})($f2f805f49af46a8b$export$8023ea0baf29b8db || ($f2f805f49af46a8b$export$8023ea0baf29b8db = {}));
const $f2f805f49af46a8b$export$bc8a9d98c2eabbb7 = ({ image: image, title: title, text: text, link: link, linkLabel: linkLabel = "Learn more", style: style = $f2f805f49af46a8b$export$f2adaabc3a0295ef.TALL, type: type = $f2f805f49af46a8b$export$8023ea0baf29b8db.ROUND, headingLevel: headingLevel, bgColor: bgColor = "initial", onClick: onClick, target: target = "_self", maxWidth: maxWidth, minHeight: minHeight, withElevationBorder: withElevationBorder = false })=>{
    const isSquareOrRectangle = type === $f2f805f49af46a8b$export$8023ea0baf29b8db.SQUARE || type === $f2f805f49af46a8b$export$8023ea0baf29b8db.RECTANGLE;
    const isFlexible = type === $f2f805f49af46a8b$export$8023ea0baf29b8db.FLEXIBLE;
    const roundStyles = image ? $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$squareTypeStyles.container : isFlexible ? $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$flexibleContainerStyles : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $f2f805f49af46a8b$export$8023ea0baf29b8db.RECTANGLE && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles[$f2f805f49af46a8b$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $dnfL5.css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $dnfL5.css)({
                maxWidth: maxWidth
            }),
            isFlexible && minHeight && (0, $dnfL5.css)({
                minHeight: minHeight
            }),
            withElevationBorder && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$elevationBorderStyles
        ],
        "data-testid": "learn-more-card",
        children: [
            image && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                src: image.src,
                alt: image.alt,
                width: isFlexible && image.width ? image.width : undefined,
                height: isFlexible && image.height ? image.height : undefined,
                css: [
                    $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$imageBaseStyles,
                    (isSquareOrRectangle || isFlexible) && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$imageSquareStyles,
                    isFlexible && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$imageFlexibleStyles,
                    isFlexible && image.width && image.height && (0, $dnfL5.css)({
                        width: `${image.width}px`,
                        height: `${image.height}px`
                    }),
                    style === $f2f805f49af46a8b$export$f2adaabc3a0295ef.FULL && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: [
                    $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: (0, $dnfL5.css)([
                            $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$textStyles,
                            type === $f2f805f49af46a8b$export$8023ea0baf29b8db.ROUND && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$squareTypeStyles.heading,
                            isFlexible && $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles[style].heading
                        ]),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                            level: headingLevel || defaultHeadingLevel,
                            fontWeight: 600,
                            children: title
                        })
                    }),
                    (type === $f2f805f49af46a8b$export$8023ea0baf29b8db.ROUND || type === $f2f805f49af46a8b$export$8023ea0baf29b8db.RECTANGLE || isFlexible) && text && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: [
                            (0, $dnfL5.css)([
                                $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$textStyles,
                                $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles[style].text,
                                $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                            children: text
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
                        style: $f2f805f49af46a8b$export$2b77966d73aefa77.SEMIBOLD,
                        size: $f2f805f49af46a8b$export$be4c932f76c19adf.LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$containerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")} 0`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")} 0`
    }
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$elevationBorderStyles = (0, $dnfL5.css)({
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
        boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$textStyles = (0, $dnfL5.css)({
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$imageBaseStyles = (0, $dnfL5.css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    maxWidth: "100%"
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$imageSquareStyles = (0, $dnfL5.css)({
    borderRadius: 0,
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$imageFlexibleStyles = (0, $dnfL5.css)({
    maxWidth: "100%",
    objectFit: "contain"
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500"),
    borderRadius: "initial"
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$variantStyles = {
    [$f2f805f49af46a8b$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $dnfL5.css)({
                [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $dnfL5.css)({
                [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $dnfL5.css)({
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "2"
            }
        }),
        text: (0, $dnfL5.css)({
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "3"
            }
        })
    },
    [$f2f805f49af46a8b$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $dnfL5.css)({
                [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $dnfL5.css)({
                [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $dnfL5.css)({
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        }),
        text: (0, $dnfL5.css)({
            [(0, $a8737f70038867b1$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        })
    }
};
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $dnfL5.css)({
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
            minHeight: "264px",
            padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
        }
    }),
    heading: (0, $dnfL5.css)({
        marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
    })
};
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$flexibleContainerStyles = (0, $dnfL5.css)({
    height: "auto",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    borderRadius: "8px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
    }
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$contentContainerStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $dnfL5.css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $f2f805f49af46a8b$var$$0ae392c3008c8a3e$var$textContainerStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
    }
});
var $f2f805f49af46a8b$var$$205ed41b47d90e33$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$205ed41b47d90e33$exports, "RelatedResourcesPanel", ()=>$f2f805f49af46a8b$export$3775cdf183cb8274);
const $f2f805f49af46a8b$var$$205ed41b47d90e33$var$ResourceItem = ({ title: title, slug: slug, onResourceClick: onResourceClick })=>{
    const handleClick = (0, $acw62.useCallback)(()=>onResourceClick(slug), [
        slug,
        onResourceClick
    ]);
    const onKeyDown = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleClick);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $f2f805f49af46a8b$var$$205ed41b47d90e33$var$resourceStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: title
    });
};
const $f2f805f49af46a8b$export$3775cdf183cb8274 = ({ title: title, resources: resources, onResourceClick: onResourceClick, onButtonClick: onButtonClick })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const handleButtonClick = (0, $acw62.useCallback)(()=>{
        setIsOpen(!isOpen);
        onButtonClick && onButtonClick();
    }, [
        isOpen,
        onButtonClick
    ]);
    const onKeyDownPanel = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleButtonClick);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "related-resources-panel",
        css: $f2f805f49af46a8b$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles,
        onClick: handleButtonClick,
        onKeyDown: onKeyDownPanel,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "related-resources-header",
                css: $f2f805f49af46a8b$var$$205ed41b47d90e33$var$headerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                        level: 6,
                        children: title
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $361fce14cc02175c$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($e0881f5dbdc2ce2b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a3062bb40e0ac5b8$exports))),
                        label: isOpen ? "Collapse" : "Expand"
                    })
                ]
            }),
            isOpen && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("ul", {
                "data-testid": "related-resources-list",
                css: $f2f805f49af46a8b$var$$205ed41b47d90e33$var$resourcesListStyles,
                children: resources.map(({ title: title, slug: slug })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("li", {
                        "data-testid": `related-resource-item-${slug}`,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$205ed41b47d90e33$var$ResourceItem, {
                            title: title,
                            slug: slug,
                            onResourceClick: onResourceClick
                        })
                    }, slug))
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    cursor: "pointer",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input.pressed")
});
const $f2f805f49af46a8b$var$$205ed41b47d90e33$var$headerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$205ed41b47d90e33$var$resourcesListStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    paddingLeft: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250"),
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$205ed41b47d90e33$var$resourceStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.link"),
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    }
});
var $f2f805f49af46a8b$var$$3c691af970e2b3d8$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3c691af970e2b3d8$exports, "ThumbType", ()=>$f2f805f49af46a8b$export$e1c6e381de15460b);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3c691af970e2b3d8$exports, "FeedbackButtonType", ()=>$f2f805f49af46a8b$export$8eec558e14651de4);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", ()=>$f2f805f49af46a8b$export$3e6d4d99e8c08756);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", ()=>$f2f805f49af46a8b$export$592a942fdddb4b1a);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$3c691af970e2b3d8$exports, "QuickFeedback", ()=>$f2f805f49af46a8b$export$c6f2bf448101d429);
let $f2f805f49af46a8b$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($f2f805f49af46a8b$export$e1c6e381de15460b || ($f2f805f49af46a8b$export$e1c6e381de15460b = {}));
let $f2f805f49af46a8b$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($f2f805f49af46a8b$export$8eec558e14651de4 || ($f2f805f49af46a8b$export$8eec558e14651de4 = {}));
const $f2f805f49af46a8b$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $f2f805f49af46a8b$export$592a942fdddb4b1a = [
    "It wasn\u2019t clear",
    "It wasn\u2019t accurate",
    "I didn\u2019t learn what I wanted to know",
    "Other"
];
const $f2f805f49af46a8b$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback, onChangeThoughts: onChangeThoughts, onChangeOption: onChangeOption, onThumbClick: onThumbClick, shouldShowDivider: shouldShowDivider = true, buttonText: buttonText = "How was this lesson?" })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [selectedThumb, setSelectedThumb] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const handleThumbClick = (thumbType)=>{
        if (selectedThumb !== thumbType) {
            setSelectedOption("");
            onChangeOption("");
            onChangeThoughts({
                target: {
                    value: ""
                }
            });
        }
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        setSelectedThumb(thumbType);
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($f2f805f49af46a8b$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($f2f805f49af46a8b$export$8eec558e14651de4.DISMISS);
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "quick-feedback-component",
        css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                "data-testid": "thumb-down-container",
                                css: [
                                    $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $f2f805f49af46a8b$export$e1c6e381de15460b.THUMB_DOWN && {
                                        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        type: "thumb-down"
                                    }),
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($f2f805f49af46a8b$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: [
                                    $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $f2f805f49af46a8b$export$e1c6e381de15460b.THUMB_UP && {
                                        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                "data-testid": "thumb-up-container",
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                        type: "thumb-up"
                                    }),
                                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($f2f805f49af46a8b$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        "data-testid": "quick-feedback-text",
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                            level: 6,
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
                            children: selectedThumb ? "Thanks for your feedback!" : buttonText
                        })
                    })
                ]
            }),
            shouldShowDivider && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$dividerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2e0a83ec2e27ecbb, {
                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "popup",
                css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$popupStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $f2f805f49af46a8b$export$e1c6e381de15460b.THUMB_UP ? $f2f805f49af46a8b$export$3e6d4d99e8c08756.map((option)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $f2f805f49af46a8b$export$592a942fdddb4b1a.map((option)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                        id: "quick-feedback-input",
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    }, selectedThumb)
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "Dismiss",
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                        label: "Submit",
                                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$quickFeedbackStyles = (0, $dnfL5.css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$feedbackContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    display: "flex",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    alignItems: "center"
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$thumbsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $dnfL5.css)({
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.disabled"),
    borderRadius: "3px"
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$dividerStyles = (0, $dnfL5.css)({
    width: "100%",
    margin: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400")} 0`
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$popupStyles = (0, $dnfL5.css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    borderRadius: "8px",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$optionsContentStyles = (0, $dnfL5.css)({
    margin: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$radioContainerStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$feedbackFormStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$inputContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$3c691af970e2b3d8$var$buttonsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
var $f2f805f49af46a8b$var$$5f9280667c666470$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$5f9280667c666470$exports, "Searchbar", ()=>$f2f805f49af46a8b$export$b9f6e7a4c54af1f6);
const $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911 = ({ item: item, onRemove: onRemove, onSelect: onSelect })=>{
    const deviceSize = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const handleRemoveButton = (e)=>{
        e.stopPropagation();
        onRemove(item);
    };
    const handleItemClick = (0, $acw62.useCallback)(()=>{
        onSelect(item);
    }, [
        onSelect,
        item
    ]);
    const handleRemoveKeyboard = (0, $acw62.useCallback)(()=>{
        onRemove(item);
    }, [
        onRemove,
        item
    ]);
    const onKeyDownItem = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleItemClick);
    const onKeyDownRemove = $f2f805f49af46a8b$export$2a0b6757d41dacb2(handleRemoveKeyboard);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles,
        onClick: handleItemClick,
        onKeyDown: onKeyDownItem,
        "data-testid": "history-item",
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$historyItemStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "emoji-frequent",
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.subtle")
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        css: $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$itemTextStyles,
                        children: item
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: [
                    $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$removeContainerStyles,
                    deviceSize < $f2f805f49af46a8b$export$27ed77542911fb0e && (0, $dnfL5.css)({
                        opacity: 1
                    })
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        onClick: handleRemoveButton,
                        label: "",
                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    deviceSize < $f2f805f49af46a8b$export$27ed77542911fb0e && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                        role: "button",
                        tabIndex: 0,
                        css: $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$clearButtonStyles,
                        onClick: handleRemoveButton,
                        onKeyDown: onKeyDownRemove,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$removeContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    button: {
        span: {
            margin: "0px !important"
        }
    }
});
const $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    button: {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        outline: "none",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:hover > div:last-child": {
        opacity: 1
    }
});
const $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$historyItemStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: "4px"
});
const $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$itemTextStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")}`
});
const $f2f805f49af46a8b$var$$9c9ed7a3b666cf11$var$clearButtonStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px"
});
const $f2f805f49af46a8b$var$$2f046e897b352baf$export$ed4de3239e2fb964 = ({ items: items, onRemove: onRemove, onSelect: onSelect })=>{
    if (!items.length) return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {});
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
        css: $f2f805f49af46a8b$var$$2f046e897b352baf$var$historyStyles,
        "data-testid": "history-container",
        children: items.slice(-5).reverse().map((item)=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911, {
                item: item,
                onRemove: onRemove,
                onSelect: onSelect
            }, item))
    });
};
const $f2f805f49af46a8b$var$$2f046e897b352baf$var$historyStyles = (0, $dnfL5.css)({
    position: "absolute",
    display: "flex",
    width: "279px",
    borderRadius: "3px",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")}`,
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075"),
    flexDirection: "column",
    alignItems: "flex-start",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.surface.overlay"),
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    zIndex: 1,
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        width: "327px"
    }
});
const $f2f805f49af46a8b$export$b9f6e7a4c54af1f6 = ({ value: value, onChange: onChange, isLoading: isLoading, label: label, isTall: isTall = false })=>{
    const [isHistoryVisible, setIsHistoryVisible] = (0, $acw62.useState)(false);
    const [history, setHistory] = (0, $acw62.useState)($f2f805f49af46a8b$export$7765f5b61937bda1());
    const searchRef = (0, $acw62.useRef)(null);
    const deviceSize = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const isRemoveIconVisible = !!value.length && (deviceSize >= $f2f805f49af46a8b$export$27ed77542911fb0e || !isLoading);
    (0, $acw62.useEffect)(()=>{
        const searchElement = searchRef.current;
        if (!searchElement) return;
        const inputElement = searchElement.querySelector("input");
        if (!inputElement) return;
        const handleFocus = ()=>{
            setIsHistoryVisible(true);
        };
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setIsHistoryVisible(false);
        };
        inputElement.addEventListener("focus", handleFocus);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            inputElement.removeEventListener("focus", handleFocus);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleRemoveItem = (itemToRemove)=>{
        const newHistory = history.filter((item)=>item !== itemToRemove);
        setHistory(newHistory);
        $f2f805f49af46a8b$export$cec0922aa1b64670(newHistory);
    };
    const handleSelectItem = (selectedItem)=>{
        onChange(selectedItem);
        setIsHistoryVisible(false);
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter" && value.trim()) {
            if (!history.includes(value.trim()) && searchRef.current) {
                const newHistory = [
                    ...history,
                    value.trim()
                ];
                $f2f805f49af46a8b$export$cec0922aa1b64670(newHistory);
                const inputElement = searchRef.current.querySelector("input");
                if (inputElement) inputElement.blur();
                setIsHistoryVisible(false);
                setHistory(newHistory);
            }
        }
    };
    const filteredItems = history.filter((item)=>item.toLowerCase().includes(value.toLowerCase()));
    const handleOnChange = (event)=>{
        if (event.target instanceof HTMLInputElement) onChange(event.target.value);
    };
    const onClearSearchClick = ()=>{
        onChange("");
        setIsHistoryVisible(false);
    };
    const onKeyDownClear = $f2f805f49af46a8b$export$2a0b6757d41dacb2(onClearSearchClick);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        role: "search",
        css: $f2f805f49af46a8b$var$$5f9280667c666470$var$searchStyles,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        ref: searchRef,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                css: $f2f805f49af46a8b$var$$5f9280667c666470$var$searchBeforeIconStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($84d260297a222b6a$exports))), {
                    primaryColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                    size: "medium",
                    label: "search icon"
                })
            }),
            !!value.length && isLoading && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                "data-testid": "search-loader",
                css: [
                    $f2f805f49af46a8b$var$$5f9280667c666470$var$searchAfterIconStyles,
                    $f2f805f49af46a8b$var$$5f9280667c666470$var$searchLoaderIconStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $8VyKT.default), {
                    size: "small"
                })
            }),
            isRemoveIconVisible && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                role: "button",
                tabIndex: 0,
                css: $f2f805f49af46a8b$var$$5f9280667c666470$var$searchAfterIconStyles,
                onClick: onClearSearchClick,
                onKeyDown: onKeyDownClear,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    label: "",
                    size: $f2f805f49af46a8b$export$5dd2748b7940a2a0.LARGE,
                    iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                        type: "cross",
                        alt: "cross icon"
                    }),
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON
                })
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("input", {
                placeholder: label ?? (deviceSize < $f2f805f49af46a8b$export$27ed77542911fb0e ? "Search" : "Search catalog"),
                value: value,
                onChange: handleOnChange,
                style: isTall ? {
                    paddingTop: "10px",
                    paddingBottom: "10px"
                } : {}
            }),
            isHistoryVisible && history.length > 0 && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$2f046e897b352baf$export$ed4de3239e2fb964, {
                items: filteredItems,
                onRemove: handleRemoveItem,
                onSelect: handleSelectItem
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$5f9280667c666470$var$searchStyles = (0, $dnfL5.css)({
    position: "relative",
    width: "100%",
    maxWidth: "240px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "275px"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "100%"
    },
    input: {
        width: "100%",
        minHeight: "32px",
        border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.input")}`,
        borderRadius: "5px !important",
        padding: `0 30px 0 ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")}`,
        color: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")} !important`,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        outline: "none",
        "&::placeholder": {
            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
            fontFamily: "SF Pro, sans-serif"
        },
        "&:focus": {
            border: `2px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.focused")} !important`
        },
        [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
            height: "40px",
            padding: `10px 30px 10px ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500")}`
        }
    }
});
const $f2f805f49af46a8b$var$$5f9280667c666470$var$searchBeforeIconStyles = (0, $dnfL5.css)({
    position: "absolute",
    left: "10px",
    top: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    }
});
const $f2f805f49af46a8b$var$$5f9280667c666470$var$searchAfterIconStyles = (0, $dnfL5.css)({
    position: "absolute",
    right: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    top: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    },
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        top: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
    }
});
const $f2f805f49af46a8b$var$$5f9280667c666470$var$searchLoaderIconStyles = (0, $dnfL5.css)({
    cursor: "default",
    right: "-24px",
    [(0, $a8737f70038867b1$export$987d49ffe1b0900f).below.md]: {
        top: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
        right: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
    }
});
var $f2f805f49af46a8b$var$$ffad026de847a971$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$ffad026de847a971$exports, "CourseStatus", ()=>$f2f805f49af46a8b$export$686d6bd87c227b43);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$ffad026de847a971$exports, "CourseList", ()=>$f2f805f49af46a8b$export$96ebd64c4b8b0cf9);
var $f2f805f49af46a8b$var$$45c6e177b24a84f5$require$Buffer = (0, $51861dfc7ca9d588$export$a143d493d941bafc);
const $f2f805f49af46a8b$var$$45c6e177b24a84f5$var$completedGap = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.735 12.322C6.55446 12.13 6.30541 12.0171 6.04201 12.0077C5.77861 11.9983 5.52217 12.0933 5.32844 12.272C5.13471 12.4507 5.01937 12.6987 5.00749 12.962C4.99561 13.2253 5.08815 13.4826 5.265 13.678L8.877 17.597C9.414 18.123 10.214 18.123 10.711 17.627L11.075 17.268C12.3895 15.9753 13.7025 14.6809 15.014 13.385L15.054 13.345C16.2797 12.1371 17.499 10.9228 18.712 9.70205C18.8933 9.51225 18.9927 9.25878 18.9887 8.99634C18.9848 8.73391 18.8778 8.48354 18.6909 8.29926C18.504 8.11499 18.2522 8.01158 17.9897 8.01135C17.7273 8.01113 17.4752 8.1141 17.288 8.29805C16.0807 9.51239 14.8673 10.7207 13.648 11.923L13.608 11.963C12.3513 13.2053 11.0929 14.446 9.833 15.685L6.735 12.322Z" fill="#22A06B"/>
</svg>
`;
const $f2f805f49af46a8b$var$$45c6e177b24a84f5$export$29aa8664c658caa9 = `data:image/svg+xml;base64,${$f2f805f49af46a8b$var$$45c6e177b24a84f5$require$Buffer.from($f2f805f49af46a8b$var$$45c6e177b24a84f5$var$completedGap).toString("base64")}`;
const $f2f805f49af46a8b$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH = 900;
let $f2f805f49af46a8b$export$686d6bd87c227b43;
(function(CourseStatus) {
    CourseStatus[/** The course is not started */ "DEFAULT"] = "default";
    CourseStatus[/** The course is in progress */ "IN_PROGRESS"] = "in_progress";
    CourseStatus[/** The course is finished */ "FINISHED"] = "finished";
})($f2f805f49af46a8b$export$686d6bd87c227b43 || ($f2f805f49af46a8b$export$686d6bd87c227b43 = {}));
const $f2f805f49af46a8b$export$96ebd64c4b8b0cf9 = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, onCourseTitleClick: onCourseTitleClick, onCourseButtonClick: onCourseButtonClick })=>{
    const [isOpened, setIsOpened] = (0, $acw62.useState)(false);
    const deviceSize = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const numberOfCompletedLessons = lessons.filter((lesson)=>lesson.isCompleted).length;
    const calculateProgress = ()=>{
        if (course.courseStatus === $f2f805f49af46a8b$export$686d6bd87c227b43.FINISHED) return 100;
        return numberOfCompletedLessons / lessons.length * 100;
    };
    const isCompleted = calculateProgress() === 100;
    const isTablet = deviceSize <= $f2f805f49af46a8b$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    const getButtonText = (status)=>{
        switch(status){
            case $f2f805f49af46a8b$export$686d6bd87c227b43.DEFAULT:
                return "Get started";
            case $f2f805f49af46a8b$export$686d6bd87c227b43.IN_PROGRESS:
                return "Continue";
            case $f2f805f49af46a8b$export$686d6bd87c227b43.FINISHED:
                return "Review course";
            default:
                return "Get started";
        }
    };
    const handleTitleClick = (0, $acw62.useCallback)((event)=>{
        if (onCourseTitleClick) {
            event?.preventDefault();
            onCourseTitleClick();
        }
    }, [
        onCourseTitleClick
    ]);
    const handleButtonClick = (0, $acw62.useCallback)((event)=>{
        if (onCourseButtonClick) {
            event?.preventDefault();
            onCourseButtonClick();
        }
    }, [
        onCourseButtonClick
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: [
            $f2f805f49af46a8b$var$$ffad026de847a971$var$wrapperStyles,
            isOpened ? $f2f805f49af46a8b$var$$ffad026de847a971$var$wrapperOpenStyles : $f2f805f49af46a8b$var$$ffad026de847a971$var$wrapperClosedStyles,
            isCompleted && $f2f805f49af46a8b$var$$ffad026de847a971$var$completedCourseStyles
        ],
        "data-testid": "course-list-container",
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": `course-card-${course?.slug}`,
                css: $f2f805f49af46a8b$var$$ffad026de847a971$var$containerStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$progressBadgeContainerStyles,
                        "data-testid": "course-progress-badge",
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$ffad026de847a971$var$customProgressBadgeStyles,
                            children: !isCompleted ? (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $1a77571422b9634a$export$5ab97151efedb8c6), {
                                strokeWidth: 6,
                                value: calculateProgress(),
                                styles: (0, $1a77571422b9634a$export$5115a192ad9bf57f)({
                                    pathColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success"),
                                    trailColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")
                                }),
                                "data-testid": "course-progress-circle",
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                    css: $f2f805f49af46a8b$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                        src: course.imageUrl,
                                        alt: "Course badge",
                                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$imageStyles,
                                        "data-testid": "course-badge-image"
                                    })
                                })
                            }) : (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$ffad026de847a971$var$completedBadgeContainerStyles,
                                "data-testid": "course-completed-badge",
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                            src: course.imageUrl,
                                            alt: "Course badge",
                                            css: [
                                                $f2f805f49af46a8b$var$$ffad026de847a971$var$imageStyles,
                                                $f2f805f49af46a8b$var$$ffad026de847a971$var$completedImageStyles
                                            ],
                                            "data-testid": "course-completed-image"
                                        })
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$checkmarkOverlayStyles,
                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("img", {
                                            src: $f2f805f49af46a8b$var$$45c6e177b24a84f5$export$29aa8664c658caa9,
                                            alt: "Completed",
                                            css: $f2f805f49af46a8b$var$$ffad026de847a971$var$checkmarkIconStyles,
                                            "data-testid": "course-completed-checkmark"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$contentContainerStyles,
                        "data-testid": "course-content",
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$ffad026de847a971$var$topContentStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$ffad026de847a971$var$durationTextStyles,
                                                "data-testid": "course-duration",
                                                children: course.duration
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                                level: 5,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                                    css: $f2f805f49af46a8b$var$$ffad026de847a971$var$titleStyles,
                                                    href: course.href,
                                                    onClick: handleTitleClick,
                                                    "data-testid": "course-title-link",
                                                    children: course.title
                                                })
                                            })
                                        ]
                                    }),
                                    !isTablet && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$startCourseButtonStyles,
                                        href: course.href,
                                        onClick: handleButtonClick,
                                        "data-testid": "desktop-course-button",
                                        children: getButtonText(course.courseStatus)
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                css: $f2f805f49af46a8b$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                    css: $f2f805f49af46a8b$var$$ffad026de847a971$var$subTitleStyles,
                                    "data-testid": "course-subtitle",
                                    children: course.subTitle
                                })
                            })
                        ]
                    })
                ]
            }),
            !isTablet && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerClosedStyles
                ],
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                    css: $f2f805f49af46a8b$var$$ffad026de847a971$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? "Hide lessons" : "Show lessons",
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            size: "small",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: [
                    $f2f805f49af46a8b$var$$ffad026de847a971$var$lessonsContentWrapperStyles,
                    isTablet && $f2f805f49af46a8b$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles
                ],
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: [
                    $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerClosedStyles,
                    $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerMobileStyles
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("button", {
                        css: [
                            $f2f805f49af46a8b$var$$ffad026de847a971$var$toggleButtonStyles,
                            $f2f805f49af46a8b$var$$ffad026de847a971$var$toggleButtonMobileStyles
                        ],
                        onClick: toggleLessons,
                        "data-testid": "toggle-lessons-button-mobile",
                        children: [
                            isOpened ? "Hide lessons" : "Show lessons",
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                                size: "small",
                                type: isOpened ? "chevron-up" : "chevron-down",
                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("a", {
                        css: $f2f805f49af46a8b$var$$ffad026de847a971$var$continueButtonStyles,
                        href: course.href,
                        onClick: handleButtonClick,
                        "data-testid": "tablet-course-button",
                        children: getButtonText(course.courseStatus)
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$ffad026de847a971$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    alignItems: "flex-start",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    minHeight: "120px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    "&:hover a": {
        opacity: 1
    },
    "@media (max-width: 343px)": {
        minHeight: "148px",
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`,
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$progressBadgeContainerStyles = (0, $dnfL5.css)({
    width: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500"),
    height: "41px",
    flexShrink: 0
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$customProgressBadgeStyles = (0, $dnfL5.css)({
    width: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.500"),
    height: "41px"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$imageBadgeContainerStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$imageStyles = (0, $dnfL5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$completedBadgeContainerStyles = (0, $dnfL5.css)({
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$completedImageStyles = (0, $dnfL5.css)({
    opacity: 0.5,
    filter: "grayscale(100%)"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$checkmarkOverlayStyles = (0, $dnfL5.css)({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$checkmarkIconStyles = (0, $dnfL5.css)({
    width: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    height: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$contentContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$topContentStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    minWidth: 0,
    width: "100%"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$durationTitleContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$titleStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display",
    fontSize: "20px",
    fontStyle: "normal",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textDecoration: "none",
    cursor: "pointer",
    lineHeight: "28px",
    fontWeight: 600,
    width: "100%",
    minWidth: 0,
    display: "block",
    maxHeight: "56px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "&:hover": {
        textDecoration: "underline",
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
    },
    "@media (max-width: 343px)": {
        fontSize: "16px",
        lineHeight: "24px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "48px"
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$startCourseButtonStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.2s ease",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
    },
    "&:visited": {
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand")
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$subTitleStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    width: "100%",
    minWidth: 0,
    maxHeight: "40px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "@media (max-width: 343px)": {
        lineHeight: "22px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "44px"
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$durationTextStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Charlie Text",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050")
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")}`,
    "@media (max-width: 343px)": {
        gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")}`
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$toggleButtonStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$toggleButtonMobileStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerOpenStyles = (0, $dnfL5.css)({
    borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$wrapperStyles = (0, $dnfL5.css)({
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    overflow: "hidden",
    maxWidth: "100%",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input")
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$wrapperClosedStyles = (0, $dnfL5.css)({
    borderRadius: "8px"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$wrapperOpenStyles = (0, $dnfL5.css)({
    borderRadius: "8px",
    "& > div:last-child": {
        borderRadius: "0 0 8px 8px"
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$lessonsContentWrapperStyles = (0, $dnfL5.css)({
    overflow: "hidden",
    borderRadius: "0 0 8px 8px !important",
    backgroundColor: "#FFFFFF",
    "& > div": {
        borderRadius: "0 0 8px 8px !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 0 8px 8px !important"
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles = (0, $dnfL5.css)({
    borderRadius: "0 !important",
    "& > div": {
        borderRadius: "0 !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 !important"
    }
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$completedCourseStyles = (0, $dnfL5.css)({
    borderLeft: `4px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success")}`
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerClosedStyles = (0, $dnfL5.css)({
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$buttonContainerMobileStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$ffad026de847a971$var$continueButtonStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.brand.bold"),
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    height: "32px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.brand.bold.hovered"),
        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.inverse"),
        textDecoration: "none"
    },
    "&:active": {
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.brand.bold.pressed")
    }
});
var $f2f805f49af46a8b$var$$0f989458047e435a$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$0f989458047e435a$exports, "InformationCardState", ()=>$f2f805f49af46a8b$export$cbadcd18ba5a3835);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$0f989458047e435a$exports, "InformationCard", ()=>$f2f805f49af46a8b$export$5a1fe75c0326c1f3);
var $f2f805f49af46a8b$var$$a7b3e1c0391fddac$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a7b3e1c0391fddac$exports, "LearningControlPanel", ()=>$f2f805f49af46a8b$export$b0db8dac2b423604);
const $f2f805f49af46a8b$export$b0db8dac2b423604 = ({ state: state = $f2f805f49af46a8b$export$cbadcd18ba5a3835.DEFAULT, isSaved: isSaved, onSave: onSave, urlToShare: urlToShare, contentType: contentType, onClick: onClick })=>{
    const isCourse = contentType === $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE;
    const buttonLabel = isCourse ? "course" : "learning path";
    const width = $f2f805f49af46a8b$export$4616d33c54ae5baf();
    const TABLET_WIDTH = 920;
    const handleOnClick = (event)=>{
        if (onClick) {
            event?.preventDefault();
            onClick();
        }
    };
    const ButtonStateProps = {
        [$f2f805f49af46a8b$export$cbadcd18ba5a3835.LOADING]: {
            label: "",
            isLoading: true,
            fullWidth: true
        },
        [$f2f805f49af46a8b$export$cbadcd18ba5a3835.DEFAULT]: {
            label: `Start ${buttonLabel}`,
            appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$f2f805f49af46a8b$export$cbadcd18ba5a3835.IN_PROGRESS]: {
            label: `Continue ${buttonLabel}`,
            appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$f2f805f49af46a8b$export$cbadcd18ba5a3835.FINISHED]: {
            label: `Review ${buttonLabel}`,
            appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.SECONDARY,
            fullWidth: true
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "control-panel-card",
        css: $f2f805f49af46a8b$var$$a7b3e1c0391fddac$var$learningControlPanelStyles,
        children: [
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles,
                children: [
                    onSave && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        iconColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon.subtle"),
                        label: "",
                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-filled" : "bookmark"
                        }),
                        onClick: handleOnSave
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$477c64ffaba52edf, {
                        urlToShare: urlToShare,
                        alignToTop: width <= TABLET_WIDTH,
                        fullWidth: true
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "control-panel-cta-button",
                css: $f2f805f49af46a8b$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles,
                children: [
                    state === $f2f805f49af46a8b$export$cbadcd18ba5a3835.LOADING && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        ...ButtonStateProps[$f2f805f49af46a8b$export$cbadcd18ba5a3835.LOADING]
                    }),
                    state === $f2f805f49af46a8b$export$cbadcd18ba5a3835.DEFAULT && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$f2f805f49af46a8b$export$cbadcd18ba5a3835.DEFAULT]
                    }),
                    state === $f2f805f49af46a8b$export$cbadcd18ba5a3835.IN_PROGRESS && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$f2f805f49af46a8b$export$cbadcd18ba5a3835.IN_PROGRESS]
                    }),
                    state === $f2f805f49af46a8b$export$cbadcd18ba5a3835.FINISHED && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$f2f805f49af46a8b$export$cbadcd18ba5a3835.FINISHED]
                    })
                ]
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$a7b3e1c0391fddac$var$learningControlPanelStyles = (0, $dnfL5.css)({
    position: "relative",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 2,
    borderLeft: "none",
    borderRight: "none",
    "@media (max-width: 920px)": {
        borderBottom: "none"
    }
});
const $f2f805f49af46a8b$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    marginRight: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150"),
    '[id*="icon-button"]': {
        width: "38px",
        height: "38px",
        backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral"),
        ":hover": {
            backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.neutral.hovered")
        }
    }
});
const $f2f805f49af46a8b$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles = (0, $dnfL5.css)({
    flex: 1,
    width: "100%",
    a: {
        padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")}`
    },
    button: {
        width: "100%",
        height: "38px"
    }
});
let $f2f805f49af46a8b$export$cbadcd18ba5a3835;
(function(InformationCardState) {
    InformationCardState["LOADING"] = "loading";
    InformationCardState["DEFAULT"] = "default";
    InformationCardState["IN_PROGRESS"] = "in_progress";
    InformationCardState["FINISHED"] = "finished";
})($f2f805f49af46a8b$export$cbadcd18ba5a3835 || ($f2f805f49af46a8b$export$cbadcd18ba5a3835 = {}));
const $f2f805f49af46a8b$export$5a1fe75c0326c1f3 = ({ contentType: contentType, video: video, badge: badge, progress: progress, duration: duration, description: description, title: title, urlToShare: urlToShare, cardState: cardState, isSaved: isSaved, onSave: onSave, onClick: onClick })=>{
    const isCourse = contentType === $f2f805f49af46a8b$export$e2e108cbe2e4f865.COURSE;
    const defaultTitle = isCourse ? "After this course, you'll be able to:" : "This learning path is for:";
    const displayTitle = title ?? defaultTitle;
    const titleColor = isCourse ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.blue") : (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.lime");
    const isCompleted = progress === 100;
    const shouldShowBadge = isCourse && badge && !video;
    const shouldShowVideo = contentType === $f2f805f49af46a8b$export$e2e108cbe2e4f865.LEARNING_PATH && video && !badge;
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        "data-testid": "information-card",
        css: [
            $f2f805f49af46a8b$var$$0f989458047e435a$var$informationCardStyles,
            isCourse ? $f2f805f49af46a8b$var$$0f989458047e435a$var$courseBorderStyles : $f2f805f49af46a8b$var$$0f989458047e435a$var$learningPathBorderStyles,
            shouldShowVideo && (0, $dnfL5.css)({
                borderTop: "none"
            })
        ],
        children: [
            shouldShowBadge && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$0f989458047e435a$var$badgeContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$0f989458047e435a$var$badgeStyles,
                    style: {
                        backgroundImage: `url(${badge})`
                    }
                })
            }),
            shouldShowVideo && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$0f989458047e435a$var$videoContainerStyles,
                children: video
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "information-card-top",
                css: [
                    $f2f805f49af46a8b$var$$0f989458047e435a$var$informationCardContainerStyles,
                    (0, $dnfL5.css)({
                        marginTop: shouldShowBadge ? (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250") : "0px"
                    })
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                        level: 5,
                        color: titleColor,
                        children: displayTitle
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: $f2f805f49af46a8b$var$$0f989458047e435a$var$descriptionStyles,
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                            size: "small",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                            children: description
                        })
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                "data-testid": "duration-progress-container",
                css: [
                    $f2f805f49af46a8b$var$$0f989458047e435a$var$informationCardContainerStyles,
                    $f2f805f49af46a8b$var$$0f989458047e435a$var$durationProgressContainerStyles
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        "data-testid": "duration-info",
                        css: $f2f805f49af46a8b$var$$0f989458047e435a$var$durationContainerStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                css: $f2f805f49af46a8b$var$$0f989458047e435a$var$spanStyles,
                                children: "Duration"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$3288d34c523a1192, {
                                label: duration
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        "data-testid": "progress-info",
                        css: $f2f805f49af46a8b$var$$0f989458047e435a$var$progressContainerStyles,
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                css: $f2f805f49af46a8b$var$$0f989458047e435a$var$progressPercentageStyles,
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: $f2f805f49af46a8b$var$$0f989458047e435a$var$spanStyles,
                                        children: "Progress "
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                        css: [
                                            $f2f805f49af46a8b$var$$0f989458047e435a$var$percentageStyles,
                                            isCompleted && (0, $dnfL5.css)({
                                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.success")
                                            })
                                        ],
                                        children: isCompleted ? "Completed" : `${progress}%`
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$c17561cb55d4db30, {
                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border.success"),
                                progress: progress
                            })
                        ]
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$0f989458047e435a$var$controlPanelContainerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$b0db8dac2b423604, {
                    onClick: onClick,
                    isSaved: isSaved,
                    onSave: onSave,
                    state: cardState,
                    urlToShare: urlToShare,
                    contentType: contentType
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$0f989458047e435a$var$informationCardStyles = (0, $dnfL5.css)({
    position: "relative",
    width: "100%",
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderBottom: "unset",
    borderRadius: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    "@media (max-width: 965px)": {
        borderBottom: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
        boxShadow: "unset"
    }
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$courseBorderStyles = (0, $dnfL5.css)({
    borderTop: `8px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.blue")}`
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$learningPathBorderStyles = (0, $dnfL5.css)({
    borderTop: "8px solid #6A9A23"
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$badgeContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: `4px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.accent.blue")}`,
    left: "50%",
    top: "0%",
    transform: "translate(-50%, -60%)",
    background: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 1
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$videoContainerStyles = (0, $dnfL5.css)({
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    ".plyr": {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px"
    }
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$badgeStyles = (0, $dnfL5.css)({
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$informationCardContainerStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$descriptionStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    color: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")} !important`,
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    lineHeight: "22px !important",
    div: {
        paddingBottom: "0 !important",
        display: "flex !important",
        "@media (max-width: 920px)": {
            display: "flex !important"
        }
    },
    "span, p, li": {
        color: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")} !important`,
        fontFamily: "Inter !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        lineHeight: "22px !important"
    },
    li: {
        marginBottom: "6px !important"
    },
    "li:last-child": {
        marginBottom: "0 !important"
    }
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$durationProgressContainerStyles = (0, $dnfL5.css)({
    borderTop: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$durationContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$spanStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$percentageStyles = (0, $dnfL5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text")
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$progressContainerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$progressPercentageStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$0f989458047e435a$var$controlPanelContainerStyles = (0, $dnfL5.css)({
    "@media (max-width: 965px)": {
        display: "none"
    }
});
var $f2f805f49af46a8b$var$$ffc638203e092686$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$ffc638203e092686$exports, "ContentVersioningDialog", ()=>$f2f805f49af46a8b$export$3a7bdc050aa55c54);
const $f2f805f49af46a8b$export$3a7bdc050aa55c54 = ({ resourceTitle: resourceTitle, subtitle: subtitle, notifications: notifications, onResourceLinkClick: onResourceLinkClick, closeModal: closeModal })=>{
    const handleDismiss = (e)=>{
        e.preventDefault();
        closeModal();
    };
    const handleResourceClick = (e, resourceLink)=>{
        e.preventDefault();
        onResourceLinkClick(resourceLink);
    };
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $7ea5684aaa353f60$export$2e2bcd8739ae039), {
        onClose: closeModal,
        children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
            "data-testid": "content-versioning-dialog",
            css: $f2f805f49af46a8b$var$$ffc638203e092686$var$containerStyles,
            children: [
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$ffc638203e092686$var$crossIconContainerStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        label: "",
                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.ICON,
                        iconType: "cross",
                        iconBefore: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.icon")
                        }),
                        onClick: handleDismiss
                    })
                }),
                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    children: [
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            "data-testid": "dialog-title",
                            css: $f2f805f49af46a8b$var$$ffc638203e092686$var$dialogTitleStyles,
                            children: [
                                "Update to ",
                                resourceTitle
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            "data-testid": "dialog-subtitle",
                            css: $f2f805f49af46a8b$var$$ffc638203e092686$var$dialogSubtitleStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                size: "small",
                                color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                children: subtitle
                            })
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
                                    children: "Summary of changes:"
                                }),
                                !!notifications.length && notifications.map((notification)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                        css: $f2f805f49af46a8b$var$$ffc638203e092686$var$notificationContainerStyles,
                                        children: [
                                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                                children: [
                                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                        "data-testid": "notification-title",
                                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                                            children: notification.title
                                                        })
                                                    }),
                                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("span", {
                                                        css: $f2f805f49af46a8b$var$$ffc638203e092686$var$notificationDateStyles,
                                                        children: notification.date
                                                    })
                                                ]
                                            }),
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$ffc638203e092686$var$notificationDescriptionContainerStyles,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                                    size: "small",
                                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtle"),
                                                    children: notification.description
                                                })
                                            }),
                                            notification.contentType === $f2f805f49af46a8b$export$e2e108cbe2e4f865.LESSON && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$ffc638203e092686$var$linkContainerStyles,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a6c7ac8248d6e38a, {
                                                    target: "_blank",
                                                    label: "View changes",
                                                    link: notification.resourceLink,
                                                    icon: "arrow-right",
                                                    onClick: (e)=>handleResourceClick(e, notification.resourceLink)
                                                })
                                            })
                                        ]
                                    }, notification.id))
                            ]
                        })
                    ]
                }),
                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                    css: $f2f805f49af46a8b$var$$ffc638203e092686$var$buttonContainerStyles,
                    children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                        label: "Dismiss",
                        appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                        onClick: handleDismiss
                    })
                })
            ]
        })
    });
};
const $f2f805f49af46a8b$var$$ffc638203e092686$var$containerStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $c43cf29233629784$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: "8px"
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$crossIconContainerStyles = (0, $dnfL5.css)({
    alignSelf: "flex-end",
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$dialogTitleStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    textAlign: "left"
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$dialogSubtitleStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$notificationContainerStyles = (0, $dnfL5.css)({
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")} ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")}`,
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "4px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `4px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$buttonContainerStyles = (0, $dnfL5.css)({
    alignSelf: "flex-end",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    a: {
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075"),
        paddingBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.075")
    }
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$notificationDateStyles = (0, $dnfL5.css)({
    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "18px"
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$notificationDescriptionContainerStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
});
const $f2f805f49af46a8b$var$$ffc638203e092686$var$linkContainerStyles = (0, $dnfL5.css)({
    a: {
        "&:hover": {
            textDecoration: "none"
        }
    }
});
var $f2f805f49af46a8b$var$$4dfe37aba1865d88$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$4dfe37aba1865d88$exports, "CustomerInfoForm", ()=>$f2f805f49af46a8b$export$6415ce2f4ef17e20);
const $f2f805f49af46a8b$var$$292473fda2395210$export$1d1c4391ecac81e8 = async ()=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/all`);
    if (!result.ok) throw Error("Unable to fetch countries");
    return (await result.json()).countryList;
};
const $f2f805f49af46a8b$var$$292473fda2395210$export$2bc3cba6f94d7400 = async (isoCountryCode)=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/findByIso/${isoCountryCode}`);
    if (!result.ok) throw Error("Unable to fetch states");
    return result.json();
};
const $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$rowStyles = (0, $dnfL5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$selectContainer = (0, $dnfL5.css)({
    maxWidth: "420px"
});
const $f2f805f49af46a8b$export$6415ce2f4ef17e20 = ({ onSubmit: onSubmit })=>{
    const [countries, setCountries] = (0, $acw62.useState)([]);
    const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)(null);
    const [states, setStates] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            try {
                const list = await $f2f805f49af46a8b$var$$292473fda2395210$export$1d1c4391ecac81e8();
                if (!mounted) return;
                setCountries(list);
                const us = list.find((c)=>c.isoCountryCode === "US" || c.countryIsoCode === "US" || c.displayName === "United States");
                if (us) setSelectedCountry(us);
            } catch  {
            // ignore network errors in Storybook/local environments
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            if (!selectedCountry) {
                setStates([]);
                return;
            }
            if (selectedCountry.states && selectedCountry.states.length) {
                setStates(selectedCountry.states);
                return;
            }
            try {
                const detailed = await $f2f805f49af46a8b$var$$292473fda2395210$export$2bc3cba6f94d7400(selectedCountry.isoCountryCode || selectedCountry.countryIsoCode);
                if (!mounted) return;
                setStates(detailed.states || []);
            } catch  {
                setStates([]);
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, [
        selectedCountry
    ]);
    const countryOptions = (0, $acw62.useMemo)(()=>countries.map((c)=>({
                label: c.displayName || c.countryIsoCode,
                value: c.isoCountryCode || c.countryIsoCode,
                data: c
            })), [
        countries
    ]);
    const stateOptions = (0, $acw62.useMemo)(()=>states.map((s)=>({
                label: s.name,
                value: s.code
            })), [
        states
    ]);
    const selectedCountryOption = (0, $acw62.useMemo)(()=>{
        if (!selectedCountry) return null;
        return {
            label: selectedCountry.displayName || selectedCountry.countryIsoCode,
            value: selectedCountry.isoCountryCode || selectedCountry.countryIsoCode,
            data: selectedCountry
        };
    }, [
        selectedCountry
    ]);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $cda506121b783a25$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: (0, $dnfL5.css)({
                            marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Customer Information"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: [
                            $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$rowStyles,
                            $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "first-name",
                                        children: "First Name"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "first-name",
                                                placeholder: "First Name",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "last-name",
                                        children: "Last Name"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "last-name",
                                                placeholder: "Last Name",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "address1",
                                children: "Address"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                name: "address1",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address1",
                                        placeholder: "Address",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "address2",
                                children: "Address Line 2 (Optional)"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                name: "address2",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address2",
                                        placeholder: "Address Line 2"
                                    })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "city",
                                children: "City"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                name: "city",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "city",
                                        placeholder: "City",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: [
                            $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$rowStyles,
                            $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "country",
                                        children: "Country"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "country",
                                        defaultValue: selectedCountryOption,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6a65a164d1aeffc0$export$2e2bcd8739ae039), {
                                                    inputId: "country",
                                                    options: countryOptions,
                                                    value: value || selectedCountryOption,
                                                    placeholder: "Select country",
                                                    onChange: (opt)=>{
                                                        onChange(opt);
                                                        const countryData = opt?.data;
                                                        setSelectedCountry(countryData || null);
                                                    }
                                                })
                                            })
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "state",
                                        children: "State"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "state",
                                        defaultValue: null,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                css: $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6a65a164d1aeffc0$export$2e2bcd8739ae039), {
                                                    inputId: "state",
                                                    options: stateOptions,
                                                    value: value,
                                                    placeholder: "Select state",
                                                    isDisabled: !selectedCountry,
                                                    onChange: (opt)=>onChange(opt)
                                                })
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: [
                            $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$rowStyles,
                            $f2f805f49af46a8b$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "postcode",
                                        children: "Zip Code"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "postcode",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "postcode",
                                                placeholder: "Zip Code",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "phone",
                                        children: "Phone Number"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "phone",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "phone",
                                                placeholder: "Phone Number",
                                                type: "tel",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
};
var $f2f805f49af46a8b$var$$556680ce820612ab$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$556680ce820612ab$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$556680ce820612ab$exports, "PaymentInfoForm", ()=>$f2f805f49af46a8b$export$f950880927ff03db);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$556680ce820612ab$exports, "default", ()=>$f2f805f49af46a8b$var$$556680ce820612ab$export$2e2bcd8739ae039);
const $f2f805f49af46a8b$var$$556680ce820612ab$var$rowStyles = (0, $dnfL5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$556680ce820612ab$var$fieldBlock = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$556680ce820612ab$var$selectContainer = (0, $dnfL5.css)({
    maxWidth: "220px"
});
const $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits = (s)=>s.replace(/\D+/g, "");
const $f2f805f49af46a8b$var$$556680ce820612ab$var$formatCardNumber = (value)=>{
    const digits = $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(value).slice(0, 19); // support up to 19 digits
    // group into 4s: 4-4-4-4-3
    const groups = [];
    for(let i = 0; i < digits.length; i += 4)groups.push(digits.slice(i, i + 4));
    return groups.join(" ").trim();
};
const $f2f805f49af46a8b$var$$556680ce820612ab$var$luhnCheck = (value)=>{
    const digits = $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(value);
    if (digits.length < 12) return false;
    // basic length gate
    let sum = 0;
    let shouldDouble = false;
    for(let i = digits.length - 1; i >= 0; i--){
        let digit = parseInt(digits.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
};
const $f2f805f49af46a8b$var$$556680ce820612ab$var$isExpiryInPast = (month, year)=>{
    if (!month || !year) return false;
    // incomplete fields handled elsewhere
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    if (year < currentYear) return true;
    if (year === currentYear && month < currentMonth) return true;
    return false;
};
const $f2f805f49af46a8b$export$f950880927ff03db = ({ onSubmit: onSubmit })=>{
    const monthOptions = (0, $acw62.useMemo)(()=>Array.from({
            length: 12
        }, (_, i)=>{
            const m = i + 1;
            const label = m < 10 ? `0${m}` : `${m}`;
            return {
                label: label,
                value: m
            };
        }), []);
    const yearOptions = (0, $acw62.useMemo)(()=>{
        const now = new Date();
        const start = now.getFullYear();
        const end = start + 20;
        const arr = [];
        for(let y = start; y <= end; y++)arr.push({
            label: `${y}`,
            value: y
        });
        return arr;
    }, []);
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $cda506121b783a25$export$2e2bcd8739ae039), {
        onSubmit: (values)=>{
            // normalize values before submit
            const normalized = {
                ...values,
                cardNumber: $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(values.cardNumber || "")
            };
            return onSubmit(normalized);
        },
        children: ({ formProps: formProps })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                        css: (0, $dnfL5.css)({
                            marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Payment Information"
                        })
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "cardholder-name",
                                children: "Name on card"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                name: "cardholderName",
                                defaultValue: "",
                                validate: (v)=>!v ? "Required" : undefined,
                                children: ({ fieldProps: fieldProps, error: error })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "cardholder-name",
                                                placeholder: "Name on card",
                                                required: true
                                            }),
                                            error && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "card-number",
                                children: "Card number"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                name: "cardNumber",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 12) return "Enter a valid card number";
                                    if (!$f2f805f49af46a8b$var$$556680ce820612ab$var$luhnCheck(v)) return "Enter a valid card number";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "card-number",
                                                placeholder: "1234 5678 9012 3456",
                                                inputMode: "numeric",
                                                autoComplete: "cc-number",
                                                value: $f2f805f49af46a8b$var$$556680ce820612ab$var$formatCardNumber(String(value ?? "")),
                                                onChange: (e)=>onChange($f2f805f49af46a8b$var$$556680ce820612ab$var$formatCardNumber(e.target.value)),
                                                required: true
                                            }),
                                            error && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: [
                            $f2f805f49af46a8b$var$$556680ce820612ab$var$rowStyles,
                            $f2f805f49af46a8b$var$$556680ce820612ab$var$fieldBlock
                        ],
                        children: [
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-month",
                                        children: "Expiry month"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "expiryMonth",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            if (!v) return "Required";
                                            const monthVal = v?.value;
                                            const yearVal = values?.expiryYear?.value;
                                            if (monthVal && yearVal && $f2f805f49af46a8b$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                        css: $f2f805f49af46a8b$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6a65a164d1aeffc0$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-month",
                                                            options: monthOptions,
                                                            value: value,
                                                            placeholder: "MM",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            }),
                            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-year",
                                        children: "Expiry year"
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                        name: "expiryYear",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            // cross validate month/year when both exist
                                            const monthVal = values?.expiryMonth?.value;
                                            const yearVal = v?.value;
                                            if (!v) return "Required";
                                            if (monthVal && yearVal && $f2f805f49af46a8b$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                        css: $f2f805f49af46a8b$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6a65a164d1aeffc0$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-year",
                                                            options: yearOptions,
                                                            value: value,
                                                            placeholder: "YYYY",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                        css: $f2f805f49af46a8b$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2e72a8d621f47959$export$b04be29aa201d4f5), {
                                htmlFor: "cvc",
                                children: "Security code (CVC)"
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $18a4c3e80e579556$export$2e2bcd8739ae039), {
                                name: "cvc",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 3 || digits.length > 4) return "Enter a valid CVC";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $05a45ec9b1af12be$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "cvc",
                                                placeholder: "CVC",
                                                type: "password",
                                                inputMode: "numeric",
                                                autoComplete: "cc-csc",
                                                value: $f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(String(value ?? "")).slice(0, 4),
                                                onChange: (e)=>onChange($f2f805f49af46a8b$var$$556680ce820612ab$var$onlyDigits(e.target.value).slice(0, 4)),
                                                required: true
                                            }),
                                            error && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
    });
};
var $f2f805f49af46a8b$var$$556680ce820612ab$export$2e2bcd8739ae039 = $f2f805f49af46a8b$export$f950880927ff03db;
var $f2f805f49af46a8b$var$$6a8b328ff2ec0580$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$6a8b328ff2ec0580$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$6a8b328ff2ec0580$exports, "CheckoutSummary", ()=>$f2f805f49af46a8b$export$fde280adb8350d09);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$6a8b328ff2ec0580$exports, "default", ()=>$f2f805f49af46a8b$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039);
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency = (amountInCents, currency = "USD")=>{
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amountInCents / 100);
    } catch  {
        return `$${(amountInCents / 100).toFixed(2)}`;
    }
};
const $f2f805f49af46a8b$export$fde280adb8350d09 = ({ subtotal: subtotal, salesTax: salesTax, total: total, items: items, paymentMethod: paymentMethod, currency: currency = "USD" })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const itemCountText = (0, $acw62.useMemo)(()=>`${items.length} item${items.length === 1 ? "" : "s"}`, [
        items.length
    ]);
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$containerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                level: 4,
                children: "Summary"
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        children: "Subtotal"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        children: "Sales Tax"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$dividerStyles
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: [
                    $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$rowStyles,
                    (0, $dnfL5.css)({
                        marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
                    })
                ],
                children: [
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                        level: 6,
                        children: "Total"
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                        level: 6,
                        children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles,
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: [
                            "Payment Method: ",
                            paymentMethod
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: itemCountText
                    })
                ]
            }),
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$buttonRowStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                    label: "Review Purchase",
                    appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                    fullWidth: true,
                    size: $f2f805f49af46a8b$export$5dd2748b7940a2a0.LARGE,
                    onClick: ()=>setIsOpen(true)
                })
            }),
            isOpen && (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $7ea5684aaa353f60$export$2e2bcd8739ae039), {
                onClose: ()=>setIsOpen(false),
                children: (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                    css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalContainerStyles,
                    children: [
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalHeaderStyles,
                            children: [
                                (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                    level: 3,
                                    children: "Review and Confirm"
                                }),
                                (0, $05a45ec9b1af12be$export$25062201e9e25d76)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: [
                                        currency,
                                        " \u2022 ",
                                        paymentMethod
                                    ]
                                })
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalSectionStyles,
                            children: items.map((item, idx)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            children: item.name
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(item.price, currency)
                                        })
                                    ]
                                }, `${item.name}-${idx}`))
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$dividerStyles
                        }),
                        (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                            css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalTotalsStyles,
                            children: [
                                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            children: "Subtotal"
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                                        })
                                    ]
                                }),
                                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            children: "Sales Tax"
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                            children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                                        })
                                    ]
                                }),
                                (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
                                    css: [
                                        $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                        (0, $dnfL5.css)({
                                            marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.150")
                                        })
                                    ],
                                    children: [
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: "Total"
                                        }),
                                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                            css: $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalButtonRowStyles,
                            children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$353f5b6fc5456de1, {
                                label: "Confirm Purchase",
                                appearance: $f2f805f49af46a8b$export$261c9483fc4a455a.PRIMARY,
                                onClick: ()=>setIsOpen(false)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$containerStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$rowStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$dividerStyles = (0, $dnfL5.css)({
    height: 1,
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border"),
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$buttonRowStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalContainerStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    minWidth: "560px"
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalHeaderStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalSectionStyles = (0, $dnfL5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.100")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$itemRowStyles = (0, $dnfL5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalTotalsStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.250")
});
const $f2f805f49af46a8b$var$$6a8b328ff2ec0580$var$modalButtonRowStyles = (0, $dnfL5.css)({
    marginTop: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.400"),
    display: "flex",
    justifyContent: "center"
});
var $f2f805f49af46a8b$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039 = $f2f805f49af46a8b$export$fde280adb8350d09;
var $f2f805f49af46a8b$var$$2397677ef2f4ee69$exports = {};
$f2f805f49af46a8b$var$$parcel$defineInteropFlag($f2f805f49af46a8b$var$$2397677ef2f4ee69$exports);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$2397677ef2f4ee69$exports, "Orders", ()=>$f2f805f49af46a8b$export$ed0df17bf864fd7b);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$2397677ef2f4ee69$exports, "default", ()=>$f2f805f49af46a8b$var$$2397677ef2f4ee69$export$2e2bcd8739ae039);
const $f2f805f49af46a8b$var$$2397677ef2f4ee69$var$containerStyles = (0, $dnfL5.css)({
    padding: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $c43cf29233629784$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.background.input")
});
const $f2f805f49af46a8b$var$$2397677ef2f4ee69$var$headerStyles = (0, $dnfL5.css)({
    marginBottom: (0, $c43cf29233629784$export$2e2bcd8739ae039)("space.200")
});
const $f2f805f49af46a8b$var$$2397677ef2f4ee69$var$amountToUsd = (amount)=>{
    const dollars = (amount / 100).toFixed(2);
    return `USD $${dollars}`;
};
const $f2f805f49af46a8b$export$ed0df17bf864fd7b = ({ orders: orders })=>{
    return (0, $05a45ec9b1af12be$export$25062201e9e25d76)("div", {
        css: $f2f805f49af46a8b$var$$2397677ef2f4ee69$var$containerStyles,
        children: [
            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)("div", {
                css: $f2f805f49af46a8b$var$$2397677ef2f4ee69$var$headerStyles,
                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$a8a3e93435678ff9, {
                    level: 4,
                    children: "Transactions"
                })
            }),
            (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $5b66b205d90a8beb$export$2e2bcd8739ae039), {
                children: [
                    (0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $4fd48a36e666961f$export$2e2bcd8739ae039), {
                        children: [
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6bfd699cf662c59e$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Date"
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6bfd699cf662c59e$export$2e2bcd8739ae039), {
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Purchase Info"
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6bfd699cf662c59e$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Payment Method"
                                })
                            }),
                            (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $6bfd699cf662c59e$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $c43cf29233629784$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Price"
                                })
                            })
                        ]
                    }),
                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $05e8f78d78363646$export$2e2bcd8739ae039), {
                        children: orders.map((o)=>(0, $05a45ec9b1af12be$export$25062201e9e25d76)((0, $94dcad7497a0e822$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2fa521c4fe830903$export$9cf5b401f969f5e3), {
                                        children: o.date
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2fa521c4fe830903$export$9cf5b401f969f5e3), {
                                        children: o.summary
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2fa521c4fe830903$export$9cf5b401f969f5e3), {
                                        children: o.paymentMethod
                                    }),
                                    (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)((0, $2fa521c4fe830903$export$9cf5b401f969f5e3), {
                                        children: $f2f805f49af46a8b$var$$2397677ef2f4ee69$var$amountToUsd(o.totalAmount)
                                    })
                                ]
                            }, o.id))
                    })
                ]
            })
        ]
    });
};
var $f2f805f49af46a8b$var$$2397677ef2f4ee69$export$2e2bcd8739ae039 = $f2f805f49af46a8b$export$ed0df17bf864fd7b;
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$83fc18f8199a12ff$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$438c82700c218044$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$389dbaf1c04dd698$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$c18917e553fd2737$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$3ca3d702a74367ba$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$e018ab7ed2648ae8$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$81dd635d83decaee$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$8d99d7c025746ac9$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$1f7c4876f10b107b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$c5616d3f1657fc84$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$eb6f767c51421421$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$7fe7e19d380f3d34$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$915f5687b3b07750$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$579f9ef2424e0bd8$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$d559b1cc82536c49$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$fa53e9c0a1746730$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$9225344cd5d1f99b$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$3b9afd8fe4435353$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$050a30fc95775cfd$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$65703ff0bcd12648$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$8340d81aba797956$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$dbb9d5792c296a49$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$2cfa64583f556289$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$44303f6c3c81eeac$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$9c3f769544bb2079$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$3d76652bb6362040$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$764442aba3de2fce$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$77282b3961d82199$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$4c35f7fd4ad5f13f$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$d8ee29df49af8811$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$27d686e47ff412fd$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$a4deb03146bf3bfc$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$0ae392c3008c8a3e$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$205ed41b47d90e33$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$3c691af970e2b3d8$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$5f9280667c666470$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$ec9b8ebbd21bd316$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$ffad026de847a971$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$0f989458047e435a$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$a7b3e1c0391fddac$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$ffc638203e092686$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$ed20910b93d89c3f$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$4dfe37aba1865d88$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$556680ce820612ab$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$6a8b328ff2ec0580$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports, $f2f805f49af46a8b$var$$2397677ef2f4ee69$exports);
var $f2f805f49af46a8b$var$$0cf4554ad00467b5$exports = {};
var $f2f805f49af46a8b$var$$a3d28c94a229f94e$exports = {};
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "CommunityLogo", ()=>$f2f805f49af46a8b$export$311e5e9ca09eea69);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "CommunityNavigation", ()=>$f2f805f49af46a8b$export$901cb8c9de2be2aa);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "AnalyticsActivityType", ()=>$f2f805f49af46a8b$export$d778a884eb401313);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "EventType", ()=>$f2f805f49af46a8b$export$3d7865934588d77e);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "CommunityApp", ()=>$f2f805f49af46a8b$export$93d048dc21eb282a);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "MenuItemWithAnalytics", ()=>$f2f805f49af46a8b$export$92905cc84b82619c);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "APP_BUTTONS", ()=>$f2f805f49af46a8b$export$208c68d48dfc9a12);
$f2f805f49af46a8b$var$$parcel$export($f2f805f49af46a8b$var$$a3d28c94a229f94e$exports, "getAppButtons", ()=>$f2f805f49af46a8b$export$67e61a6fa639f224);
const $f2f805f49af46a8b$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref, analyticsInfo: analyticsInfo })=>{
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00, {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $f2f805f49af46a8b$var$$a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return $f2f805f49af46a8b$export$67e61a6fa639f224(email).map((button)=>{
        if (button.app === $f2f805f49af46a8b$export$93d048dc21eb282a.FORUMS && isLoggedIn && forumsLoggedInRedirectHref) button.href[loginState] += forumsLoggedInRedirectHref;
        return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$var$$341f96d5922d8aaa$export$b18dbc162161ec9c, {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: button.href[loginState],
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo,
            showNewMenu: showNewMenu
        }, button.app);
    });
};
const $f2f805f49af46a8b$export$901cb8c9de2be2aa = ({ currentApp: currentApp, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, subMenuContentByApp: subMenuContentByApp, onAnalyticsSendEvent: onAnalyticsSendEvent, forumsLoggedInRedirectHref: forumsLoggedInRedirectHref, isSticky: isSticky = true, showChampions: showChampions = false, email: email, showNewMenu: showNewMenu = false })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $acw62.useMemo)(()=>$f2f805f49af46a8b$var$$1ff01338112cd7fe$export$d349399b473d7299[loginState], [
        loginState
    ]);
    const isMobileOrTablet = $f2f805f49af46a8b$export$32d5543ab307c01(`(max-width: ${$f2f805f49af46a8b$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Build left items
    let leftItems = [
        ...$f2f805f49af46a8b$var$$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu)
    ];
    if (!showChampions) leftItems = leftItems.filter((item)=>item.key !== $f2f805f49af46a8b$export$93d048dc21eb282a.CHAMPIONS);
    // Create logo item
    const logoItem = (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$311e5e9ca09eea69, {
        subtitleHref: homeHref,
        analyticsInfo: analyticsInfo
    }, "community-logo");
    return (0, $05a45ec9b1af12be$export$34b9dba7ce09269b)($f2f805f49af46a8b$export$fddd19fbf4d591d8, {
        logoItem: logoItem,
        leftItems: leftItems,
        isLoggedIn: isLoggedIn,
        user: user,
        loginHref: loginHref,
        signupHref: signupHref,
        logoutHref: logoutHref,
        switchHref: switchHref,
        profileHref: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$132b2bf91782e62b,
        settingsHref: $f2f805f49af46a8b$var$$1ff01338112cd7fe$export$b9cc8022ec117e91,
        onAnalyticsSendEvent: onAnalyticsSendEvent,
        isSticky: isSticky,
        showNewMenu: showNewMenu,
        currentApp: currentApp
    });
};
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$0cf4554ad00467b5$exports, $f2f805f49af46a8b$var$$a3d28c94a229f94e$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a69491ea5a126553$exports, $f2f805f49af46a8b$var$$5d4509b60606b6df$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a69491ea5a126553$exports, $f2f805f49af46a8b$var$$6e379ec2eca3d7d3$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a69491ea5a126553$exports, $f2f805f49af46a8b$var$$a6a41c835fd01d00$exports);
$f2f805f49af46a8b$var$$parcel$exportWildcard($f2f805f49af46a8b$var$$a69491ea5a126553$exports, $f2f805f49af46a8b$var$$0cf4554ad00467b5$exports);




var $5afce0b42b1a9d68$var$_loadingSpinner = $5afce0b42b1a9d68$var$_interopRequireDefault((parcelRequire("gQkqH")));
function $5afce0b42b1a9d68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $5afce0b42b1a9d68$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $5afce0b42b1a9d68$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $5afce0b42b1a9d68$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($5afce0b42b1a9d68$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $5afce0b42b1a9d68$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $5afce0b42b1a9d68$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $5afce0b42b1a9d68$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $5afce0b42b1a9d68$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $5afce0b42b1a9d68$var$_slicedToArray(r, e) {
    return $5afce0b42b1a9d68$var$_arrayWithHoles(r) || $5afce0b42b1a9d68$var$_iterableToArrayLimit(r, e) || $5afce0b42b1a9d68$var$_unsupportedIterableToArray(r, e) || $5afce0b42b1a9d68$var$_nonIterableRest();
}
function $5afce0b42b1a9d68$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5afce0b42b1a9d68$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5afce0b42b1a9d68$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5afce0b42b1a9d68$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5afce0b42b1a9d68$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5afce0b42b1a9d68$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5afce0b42b1a9d68$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $5afce0b42b1a9d68$var$ConsentValidator = $5afce0b42b1a9d68$exports.ConsentValidator = function ConsentValidator(_ref) {
    var coverImageSrc = _ref.coverImageSrc, children = _ref.children, onLogout = _ref.onLogout, aaid = _ref.aaid, isUserConsented = _ref.isUserConsented, onConsentError = _ref.onConsentError, onConsentSuccess = _ref.onConsentSuccess, env = _ref.env;
    var _React$useState = $5afce0b42b1a9d68$var$_react["default"].useState(false), _React$useState2 = $5afce0b42b1a9d68$var$_slicedToArray(_React$useState, 2), handledConsent = _React$useState2[0], setHandledConsent = _React$useState2[1];
    var _React$useState3 = $5afce0b42b1a9d68$var$_react["default"].useState(false), _React$useState4 = $5afce0b42b1a9d68$var$_slicedToArray(_React$useState3, 2), isLoading = _React$useState4[0], setIsLoading = _React$useState4[1];
    var _React$useState5 = $5afce0b42b1a9d68$var$_react["default"].useState(false), _React$useState6 = $5afce0b42b1a9d68$var$_slicedToArray(_React$useState5, 2), consentError = _React$useState6[0], setConsentError = _React$useState6[1];
    var handleConsentError = function handleConsentError() {
        onConsentError();
        setConsentError(true);
    };
    var handleUserConsent = function handleUserConsent() {
        $5afce0b42b1a9d68$var$_asyncToGenerator(/*#__PURE__*/ $5afce0b42b1a9d68$var$_regeneratorRuntime().mark(function _callee() {
            var consentResponse;
            return $5afce0b42b1a9d68$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        if (!(aaid && !consentError)) {
                            _context.next = 7;
                            break;
                        }
                        setIsLoading(true);
                        _context.next = 5;
                        return (0, $8e221dc9235bf597$exports.setUserConsent)([
                            $fff776c95d28933e$exports.CONSENT_KEY.COMMUNITY,
                            $fff776c95d28933e$exports.CONSENT_KEY.PRIVACY
                        ], aaid, env);
                    case 5:
                        consentResponse = _context.sent;
                        // Tried to set consent but still false
                        if (!consentResponse) handleConsentError();
                        else if (onConsentSuccess) onConsentSuccess();
                    case 7:
                        _context.next = 12;
                        break;
                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](0);
                        handleConsentError();
                    case 12:
                        _context.prev = 12;
                        setIsLoading(false);
                        // We have either handled the error or succesfully consented
                        setHandledConsent(true);
                        return _context.finish(12);
                    case 16:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    12,
                    16
                ]
            ]);
        }))();
    };
    if (isLoading) return /*#__PURE__*/ $5afce0b42b1a9d68$var$_react["default"].createElement($5afce0b42b1a9d68$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return !aaid || isUserConsented || handledConsent ? children : /*#__PURE__*/ $5afce0b42b1a9d68$var$_react["default"].createElement($f2f805f49af46a8b$export$9d12d42929c3fcf, {
        coverImageSrc: coverImageSrc,
        onAccept: handleUserConsent,
        onCancel: onLogout
    });
};


Object.keys($5afce0b42b1a9d68$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $5afce0b42b1a9d68$exports[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $5afce0b42b1a9d68$exports[key];
        }
    });
});
var $edea63791bd7bce4$exports = {};
"use strict";
function $edea63791bd7bce4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $edea63791bd7bce4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $edea63791bd7bce4$var$_typeof(o);
}
Object.defineProperty($edea63791bd7bce4$exports, "__esModule", {
    value: true
});
$edea63791bd7bce4$exports.ConsentValidator2 = void 0;

var $edea63791bd7bce4$var$_react = $edea63791bd7bce4$var$_interopRequireDefault((parcelRequire("acw62")));




var $edea63791bd7bce4$var$_loadingSpinner = $edea63791bd7bce4$var$_interopRequireDefault((parcelRequire("gQkqH")));
function $edea63791bd7bce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $edea63791bd7bce4$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $edea63791bd7bce4$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $edea63791bd7bce4$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($edea63791bd7bce4$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $edea63791bd7bce4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $edea63791bd7bce4$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $edea63791bd7bce4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $edea63791bd7bce4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $edea63791bd7bce4$var$_slicedToArray(r, e) {
    return $edea63791bd7bce4$var$_arrayWithHoles(r) || $edea63791bd7bce4$var$_iterableToArrayLimit(r, e) || $edea63791bd7bce4$var$_unsupportedIterableToArray(r, e) || $edea63791bd7bce4$var$_nonIterableRest();
}
function $edea63791bd7bce4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $edea63791bd7bce4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $edea63791bd7bce4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $edea63791bd7bce4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $edea63791bd7bce4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $edea63791bd7bce4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $edea63791bd7bce4$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $edea63791bd7bce4$var$ConsentValidator2 = $edea63791bd7bce4$exports.ConsentValidator2 = function ConsentValidator2(_ref) {
    var coverImageSrc = _ref.coverImageSrc, children = _ref.children, onLogout = _ref.onLogout, aaid = _ref.aaid, isUserConsented = _ref.isUserConsented, onConsentError = _ref.onConsentError, onConsentSuccess = _ref.onConsentSuccess, onConsentComplete = _ref.onConsentComplete, env = _ref.env;
    var _React$useState = $edea63791bd7bce4$var$_react["default"].useState(false), _React$useState2 = $edea63791bd7bce4$var$_slicedToArray(_React$useState, 2), isLoading = _React$useState2[0], setIsLoading = _React$useState2[1];
    var handleUserConsent = function handleUserConsent() {
        $edea63791bd7bce4$var$_asyncToGenerator(/*#__PURE__*/ $edea63791bd7bce4$var$_regeneratorRuntime().mark(function _callee() {
            var consentResponse;
            return $edea63791bd7bce4$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        if (aaid) {
                            _context.next = 5;
                            break;
                        }
                        onConsentError("missing_aaid", "AAID is required");
                        _context.next = 10;
                        break;
                    case 5:
                        setIsLoading(true);
                        _context.next = 8;
                        return (0, $8e221dc9235bf597$exports.setUserConsent)([
                            $fff776c95d28933e$exports.CONSENT_KEY.COMMUNITY,
                            $fff776c95d28933e$exports.CONSENT_KEY.PRIVACY
                        ], aaid, env);
                    case 8:
                        consentResponse = _context.sent;
                        // Tried to set consent but still false
                        if (!consentResponse) onConsentError("consent_failed", "Failed to set consent");
                        else onConsentSuccess();
                    case 10:
                        _context.next = 15;
                        break;
                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](0);
                        onConsentError("consent_failed", "Failed to set consent" + _context.t0.message);
                    case 15:
                        _context.prev = 15;
                        setIsLoading(false);
                        if (onConsentComplete) onConsentComplete();
                        return _context.finish(15);
                    case 19:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12,
                    15,
                    19
                ]
            ]);
        }))();
    };
    if (isLoading) return /*#__PURE__*/ $edea63791bd7bce4$var$_react["default"].createElement($edea63791bd7bce4$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return isUserConsented ? children : /*#__PURE__*/ $edea63791bd7bce4$var$_react["default"].createElement($f2f805f49af46a8b$export$9d12d42929c3fcf, {
        coverImageSrc: coverImageSrc,
        onAccept: handleUserConsent,
        onCancel: onLogout
    });
};


Object.keys($edea63791bd7bce4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $edea63791bd7bce4$exports[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $edea63791bd7bce4$exports[key];
        }
    });
});
var $f884b612740a06ae$exports = {};
"use strict";
function $f884b612740a06ae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f884b612740a06ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f884b612740a06ae$var$_typeof(o);
}
Object.defineProperty($f884b612740a06ae$exports, "__esModule", {
    value: true
});
$f884b612740a06ae$exports.SuspenseExtender = void 0;

var $f884b612740a06ae$var$_react = $f884b612740a06ae$var$_interopRequireWildcard((parcelRequire("acw62")));
function $f884b612740a06ae$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f884b612740a06ae$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f884b612740a06ae$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $f884b612740a06ae$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $f884b612740a06ae$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var $f884b612740a06ae$var$SuspenseExtender = $f884b612740a06ae$exports.SuspenseExtender = function SuspenseExtender(_ref) {
    var children = _ref.children, fallback = _ref.fallback, isReady = _ref.isReady;
    return /*#__PURE__*/ $f884b612740a06ae$var$_react["default"].createElement($f884b612740a06ae$var$_react.Suspense, {
        fallback: fallback
    }, isReady === null || isReady === undefined || isReady ? children : fallback);
};


Object.keys($f884b612740a06ae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $f884b612740a06ae$exports[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $f884b612740a06ae$exports[key];
        }
    });
});

var $gQkqH = parcelRequire("gQkqH");
Object.keys($gQkqH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $gQkqH[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $gQkqH[key];
        }
    });
});
var $6eab54e19a516415$exports = {};
"use strict";
function $6eab54e19a516415$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6eab54e19a516415$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6eab54e19a516415$var$_typeof(o);
}
Object.defineProperty($6eab54e19a516415$exports, "__esModule", {
    value: true
});
$6eab54e19a516415$exports.Initializer = void 0;

var $6eab54e19a516415$var$_react = $6eab54e19a516415$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6eab54e19a516415$var$_loadingSpinner = $6eab54e19a516415$var$_interopRequireDefault((parcelRequire("gQkqH")));
var $11903467dd03ded7$exports = {};
"use strict";
Object.defineProperty($11903467dd03ded7$exports, "__esModule", {
    value: true
});
var $4921f5a45b3590cd$exports = {};
"use strict";
Object.defineProperty($4921f5a45b3590cd$exports, "__esModule", {
    value: true
});
var $2b01a2a8b07d1ffb$exports = {};
"use strict";
Object.defineProperty($2b01a2a8b07d1ffb$exports, "__esModule", {
    value: true
});
Object.defineProperty($2b01a2a8b07d1ffb$exports, "CookieCompliance", {
    enumerable: true,
    get: function get() {
        return $2ac1d0168768b0b1$exports.CookieCompliance;
    }
});
Object.defineProperty($2b01a2a8b07d1ffb$exports, "InitializeAutoAtlAnalytics", {
    enumerable: true,
    get: function get() {
        return $9bd63f1974e4bdb4$exports.InitializeAutoAtlAnalytics;
    }
});
var $9bd63f1974e4bdb4$exports = {};
"use strict";
Object.defineProperty($9bd63f1974e4bdb4$exports, "__esModule", {
    value: true
});
$9bd63f1974e4bdb4$exports.InitializeAutoAtlAnalytics = void 0;

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $8xLFK = parcelRequire("8xLFK");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $8xLFK = parcelRequire("8xLFK");
function $4b1b4163f4170ab5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b1b4163f4170ab5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b1b4163f4170ab5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b1b4163f4170ab5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4b1b4163f4170ab5$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $8xLFK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $acw62.useRef)({});
    var patchedProps = (0, $acw62.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $4b1b4163f4170ab5$var$_objectSpread($4b1b4163f4170ab5$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $4b1b4163f4170ab5$var$_objectSpread($4b1b4163f4170ab5$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $3294956374cdc905$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $4b1b4163f4170ab5$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $8xLFK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $3294956374cdc905$export$2e2bcd8739ae039 = $3294956374cdc905$var$withAnalyticsEvents;


var $f3d3ce17110e3c39$exports = {};
"use strict";
Object.defineProperty($f3d3ce17110e3c39$exports, "__esModule", {
    value: true
});
$f3d3ce17110e3c39$exports.useAnalyticsClient = $f3d3ce17110e3c39$exports.CommunityAnalyticsListener = $f3d3ce17110e3c39$exports.CommunityAnalyticsClientProvider = $f3d3ce17110e3c39$exports.AnalyticsWebClientContext = void 0;

var $f3d3ce17110e3c39$var$_react = $f3d3ce17110e3c39$var$_interopRequireWildcard((parcelRequire("acw62")));

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $hPtJY = parcelRequire("hPtJY");
var $8ce47ba8dd552818$var$_process$env;
var /// <reference types="node" />
$8ce47ba8dd552818$export$2e2bcd8739ae039 = typeof $hPtJY !== "undefined" && $hPtJY !== null && (($8ce47ba8dd552818$var$_process$env = {}, $8ce47ba8dd552818$var$_process$env === void 0) ? void 0 : $8ce47ba8dd552818$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9ZLvy = parcelRequire("9ZLvy");
function $165cb41a2d280428$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $165cb41a2d280428$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $165cb41a2d280428$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($165cb41a2d280428$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $165cb41a2d280428$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $165cb41a2d280428$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $165cb41a2d280428$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsListener);
        _this = $165cb41a2d280428$var$_callSuper(this, AnalyticsListener, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $165cb41a2d280428$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === "*" || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $165cb41a2d280428$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(AnalyticsListener, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ZLvy.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $acw62.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($165cb41a2d280428$var$AnalyticsListener, "contextTypes", $165cb41a2d280428$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($165cb41a2d280428$var$AnalyticsListener, "childContextTypes", $165cb41a2d280428$var$ContextTypes);
var $165cb41a2d280428$export$2e2bcd8739ae039 = $165cb41a2d280428$var$AnalyticsListener;



var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $9ZLvy = parcelRequire("9ZLvy");

var $i6h2G = parcelRequire("i6h2G");

var $5i9fe = parcelRequire("5i9fe");
var $b476ca3d820c5f7c$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var _useAnalyticsContext = (0, $i6h2G.useAnalyticsContext)(), _useAnalyticsContext$ = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext$ === void 0 ? function() {
        return [];
    } : _useAnalyticsContext$, getAtlaskitAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var onEventRef = (0, $5i9fe.useTrackedRef)(onEvent);
    var channelRef = (0, $5i9fe.useTrackedRef)(channel);
    var getAnalyticsEventHandlers = (0, $acw62.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === "*" || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getAtlaskitAnalyticsEventHandlers()));
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    var value = (0, $acw62.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ZLvy.default).Provider, {
        value: value
    }, children);
};
var $b476ca3d820c5f7c$export$2e2bcd8739ae039 = $b476ca3d820c5f7c$var$AnalyticsListener;


var $f95e6fab44df17ad$var$ExportedAnalyticsListener = function ExportedAnalyticsListener(props) {
    var isModernContext = (0, $8ce47ba8dd552818$export$2e2bcd8739ae039) || (0, $ltooA.fg)("analytics-next-use-modern-context_jira");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b476ca3d820c5f7c$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $165cb41a2d280428$export$2e2bcd8739ae039), props);
};
var $f95e6fab44df17ad$export$2e2bcd8739ae039 = $f95e6fab44df17ad$var$ExportedAnalyticsListener;



var $3emEs = parcelRequire("3emEs");
var $9d08699771426032$exports = {};
"use strict";
Object.defineProperty($9d08699771426032$exports, "__esModule", {
    value: true
});
$9d08699771426032$exports.Identity = void 0;
var $f3ce5ca773e60031$exports = {};
"use strict";
Object.defineProperty($f3ce5ca773e60031$exports, "__esModule", {
    value: true
});
$f3ce5ca773e60031$exports.Cookie = void 0;
function $f3ce5ca773e60031$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f3ce5ca773e60031$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f3ce5ca773e60031$var$_typeof(o);
}
function $f3ce5ca773e60031$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f3ce5ca773e60031$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f3ce5ca773e60031$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f3ce5ca773e60031$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f3ce5ca773e60031$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f3ce5ca773e60031$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f3ce5ca773e60031$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $f3ce5ca773e60031$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f3ce5ca773e60031$var$_toPropertyKey(o.key), o);
    }
}
function $f3ce5ca773e60031$var$_createClass(e, r, t) {
    return r && $f3ce5ca773e60031$var$_defineProperties(e.prototype, r), t && $f3ce5ca773e60031$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $f3ce5ca773e60031$var$_toPropertyKey(t) {
    var i = $f3ce5ca773e60031$var$_toPrimitive(t, "string");
    return "symbol" == $f3ce5ca773e60031$var$_typeof(i) ? i : i + "";
}
function $f3ce5ca773e60031$var$_toPrimitive(t, r) {
    if ("object" != $f3ce5ca773e60031$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f3ce5ca773e60031$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f3ce5ca773e60031$var$Cookie = $f3ce5ca773e60031$exports.Cookie = /*#__PURE__*/ function() {
    function Cookie() {
        $f3ce5ca773e60031$var$_classCallCheck(this, Cookie);
    }
    return $f3ce5ca773e60031$var$_createClass(Cookie, null, [
        {
            key: "getCookieUrl",
            value: function getCookieUrl(cookieName, defaultUrl) {
                var cookieUrl = Cookie.readCookie(cookieName);
                if (cookieUrl !== null) return cookieUrl;
                return defaultUrl;
            }
        },
        {
            key: "readCookie",
            value: function readCookie(name) {
                try {
                    var nameEQ = name + "=";
                    var ca = document.cookie.split(";");
                    var _iterator = $f3ce5ca773e60031$var$_createForOfIteratorHelper(ca), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var c = _step.value;
                            while(c.startsWith(" "))c = c.substring(1, c.length);
                            if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                } catch (e) {
                    // Helpers.sendWrapperLoadError uses this method to get some context
                    // for the reported error, so we don't want to call that here, otherwise
                    // we would get stuck in an infinite loop
                    // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
                    if (name !== "login_user_detected") console.warn("Error reading cookie - ".concat(name), e);
                }
                return null;
            }
        },
        {
            key: "writeCookie",
            value: function writeCookie(name, value, days, topLevelDomain) {
                var seconds = days ? days * 86400 : null;
                Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
            }
        },
        {
            key: "writeCookieInSeconds",
            value: function writeCookieInSeconds(name, value, seconds, topLevelDomain) {
                try {
                    var expires = "";
                    if (seconds) {
                        var date = new Date();
                        date.setTime(date.getTime() + seconds * 1000);
                        expires = "; expires=" + date.toUTCString();
                    }
                    var cookie = name + "=" + value + expires + "; path=/;";
                    var domain = window.location.hostname;
                    if (domain !== "localhost" && topLevelDomain) {
                        var domainTokens = domain.split(".");
                        if (domainTokens.length > 1) {
                            var lastToken = domainTokens[domainTokens.length - 1];
                            var secondLastToken = domainTokens[domainTokens.length - 2];
                            if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = "." + secondLastToken + "." + lastToken;
                        }
                        cookie += " domain=" + domain + ";";
                    }
                    document.cookie = cookie;
                } catch (e) {
                    console.warn("Error writing cookie - ".concat(name), e);
                }
            }
        }
    ]);
}();


var $686dafd5f57e3409$exports = {};
"use strict";
Object.defineProperty($686dafd5f57e3409$exports, "__esModule", {
    value: true
});
$686dafd5f57e3409$exports.AnalyticsState = void 0;
function $686dafd5f57e3409$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $686dafd5f57e3409$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $686dafd5f57e3409$var$_typeof(o);
}
function $686dafd5f57e3409$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $686dafd5f57e3409$var$_toPropertyKey(o.key), o);
    }
}
function $686dafd5f57e3409$var$_createClass(e, r, t) {
    return r && $686dafd5f57e3409$var$_defineProperties(e.prototype, r), t && $686dafd5f57e3409$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $686dafd5f57e3409$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $686dafd5f57e3409$var$_defineProperty(e, r, t) {
    return (r = $686dafd5f57e3409$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $686dafd5f57e3409$var$_toPropertyKey(t) {
    var i = $686dafd5f57e3409$var$_toPrimitive(t, "string");
    return "symbol" == $686dafd5f57e3409$var$_typeof(i) ? i : i + "";
}
function $686dafd5f57e3409$var$_toPrimitive(t, r) {
    if ("object" != $686dafd5f57e3409$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $686dafd5f57e3409$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $686dafd5f57e3409$var$AnalyticsState = $686dafd5f57e3409$exports.AnalyticsState = /*#__PURE__*/ $686dafd5f57e3409$var$_createClass(function AnalyticsState() {
    $686dafd5f57e3409$var$_classCallCheck(this, AnalyticsState);
});
$686dafd5f57e3409$var$_defineProperty($686dafd5f57e3409$var$AnalyticsState, "pageViewOptions", {});


var $9789bdfe9c957a15$exports = {};
"use strict";
Object.defineProperty($9789bdfe9c957a15$exports, "__esModule", {
    value: true
});
$9789bdfe9c957a15$exports.requiredBucketAttributeKeys = $9789bdfe9c957a15$exports.Cohort = $9789bdfe9c957a15$exports.COHORT_VERSION = $9789bdfe9c957a15$exports.ATL_COHORT = void 0;

var $dd4d4cd8f6ef082a$exports = {};
"use strict";
Object.defineProperty($dd4d4cd8f6ef082a$exports, "__esModule", {
    value: true
});
$dd4d4cd8f6ef082a$exports.Guid = void 0;
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $568f4ee4022ba00e$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


var $7ed41b2ce96d3996$exports = {};
"use strict";
Object.defineProperty($7ed41b2ce96d3996$exports, "__esModule", {
    value: true
});
$7ed41b2ce96d3996$exports.Helpers = void 0;

var $7ed41b2ce96d3996$var$_queryString = $7ed41b2ce96d3996$var$_interopRequireDefault((parcelRequire("8R0Eu")));
function $7ed41b2ce96d3996$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $7ed41b2ce96d3996$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7ed41b2ce96d3996$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7ed41b2ce96d3996$var$_typeof(o);
}
function $7ed41b2ce96d3996$var$_slicedToArray(r, e) {
    return $7ed41b2ce96d3996$var$_arrayWithHoles(r) || $7ed41b2ce96d3996$var$_iterableToArrayLimit(r, e) || $7ed41b2ce96d3996$var$_unsupportedIterableToArray(r, e) || $7ed41b2ce96d3996$var$_nonIterableRest();
}
function $7ed41b2ce96d3996$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7ed41b2ce96d3996$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7ed41b2ce96d3996$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7ed41b2ce96d3996$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7ed41b2ce96d3996$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7ed41b2ce96d3996$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7ed41b2ce96d3996$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $7ed41b2ce96d3996$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $7ed41b2ce96d3996$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7ed41b2ce96d3996$var$_toPropertyKey(o.key), o);
    }
}
function $7ed41b2ce96d3996$var$_createClass(e, r, t) {
    return r && $7ed41b2ce96d3996$var$_defineProperties(e.prototype, r), t && $7ed41b2ce96d3996$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $7ed41b2ce96d3996$var$_defineProperty(e, r, t) {
    return (r = $7ed41b2ce96d3996$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7ed41b2ce96d3996$var$_toPropertyKey(t) {
    var i = $7ed41b2ce96d3996$var$_toPrimitive(t, "string");
    return "symbol" == $7ed41b2ce96d3996$var$_typeof(i) ? i : i + "";
}
function $7ed41b2ce96d3996$var$_toPrimitive(t, r) {
    if ("object" != $7ed41b2ce96d3996$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7ed41b2ce96d3996$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html
var $7ed41b2ce96d3996$var$EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
var $7ed41b2ce96d3996$var$PATH_OVERRIDE = "/path-contained-email-address";
// Cap on identical wrapper-load error reports per page lifecycle, so a
// recurring failure can't flood downstream telemetry.
var $7ed41b2ce96d3996$var$MAX_REPORTS_PER_KEY = 3;
var $7ed41b2ce96d3996$var$Helpers = $7ed41b2ce96d3996$exports.Helpers = /*#__PURE__*/ function() {
    function Helpers() {
        $7ed41b2ce96d3996$var$_classCallCheck(this, Helpers);
    }
    return $7ed41b2ce96d3996$var$_createClass(Helpers, null, [
        {
            key: "sendWrapperLoadError",
            value: /** Report a wrapper-load failure. Throttled per `message` key. */ function sendWrapperLoadError(message, data) {
                var _Helpers$wrapperLoadE;
                var count = (_Helpers$wrapperLoadE = Helpers.wrapperLoadErrorCounts.get(message)) !== null && _Helpers$wrapperLoadE !== void 0 ? _Helpers$wrapperLoadE : 0;
                if (count >= $7ed41b2ce96d3996$var$MAX_REPORTS_PER_KEY) return;
                Helpers.wrapperLoadErrorCounts.set(message, count + 1);
                // TODO: Handle sending error somewhere, reference atl-analytics if needed
                console.warn("Error loading wrapper: ".concat(message), data);
            }
        },
        {
            key: "_resetWrapperLoadErrorThrottle",
            value: function _resetWrapperLoadErrorThrottle() {
                Helpers.wrapperLoadErrorCounts.clear();
            }
        },
        {
            key: "getParameterByName",
            value: function getParameterByName(name) {
                //eslint-disable-next-line
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
                var results = regex.exec(window.location.search);
                var value = results && results.length >= 2 ? results[1] : null;
                return !value ? "" : decodeURIComponent(value.replace(/\+/g, " "));
            }
        },
        {
            key: "getUtms",
            value: function getUtms(utms) {
                if (window.location.search.includes("utm_")) {
                    for(var utmKey in utms)//eslint-disable-next-line
                    if (utms.hasOwnProperty(utmKey)) utms[utmKey] = Helpers.getParameterByName(utmKey);
                    return utms;
                }
                return null;
            }
        },
        {
            key: "canonical",
            value: function canonical() {
                var tags = Array.from(document.getElementsByTagName("link"));
                for(var _i = 0, _tags = tags; _i < _tags.length; _i++){
                    var tag = _tags[_i];
                    if (tag && tag.getAttribute("rel") === "canonical") return tag.getAttribute("href");
                }
                return null;
            }
        },
        {
            key: "getCanonicalUrl",
            value: function getCanonicalUrl() {
                var canon = Helpers.canonical();
                if (canon) return canon;
                var url = window.location.href;
                var i = url.indexOf("#");
                return i === -1 ? url : url.slice(0, i);
            }
        },
        {
            key: "getUrlFragment",
            value: function getUrlFragment() {
                var url = window.location.href;
                var i = url.indexOf("#");
                if (i === -1) return "";
                var fragment = url.slice(i + 1); // fragment after '#'
                var _fragment$split = fragment.split("?"), _fragment$split2 = $7ed41b2ce96d3996$var$_slicedToArray(_fragment$split, 1), path = _fragment$split2[0]; // discard query string
                return "#".concat(path);
            }
        },
        {
            key: "addActualUrl",
            value: function addActualUrl(obj) {
                if (window.location.href !== Helpers.getCanonicalUrl()) {
                    // respect cleaned url
                    if (obj["url"]) obj["actualUrl"] = obj["url"];
                    else obj["actualUrl"] = Helpers.maskURL(window.location.href);
                }
            }
        },
        {
            key: "isObject",
            value: function isObject(o) {
                return o !== null && $7ed41b2ce96d3996$var$_typeof(o) === "object" && Array.isArray(o) === false;
            }
        },
        {
            key: "urlContainsEmail",
            value: function urlContainsEmail(url) {
                return Boolean($7ed41b2ce96d3996$var$EMAIL_REGEX.exec(decodeURIComponent(url)));
            }
        },
        {
            key: "dropEmailQueryParams",
            value: function dropEmailQueryParams(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(_ref) {
                    var _ref2 = $7ed41b2ce96d3996$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    if (!Helpers.urlContainsEmail(value)) sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "maskSearchTerms",
            value: function maskSearchTerms(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(_ref3) {
                    var _ref4 = $7ed41b2ce96d3996$var$_slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
                    if (key === "term" || key === "q") sanitizedObj[key] = "[REDACTED]";
                    else sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "dropEmailFromPath",
            value: function dropEmailFromPath(path) {
                var newPath = "";
                if (Helpers.urlContainsEmail(path)) {
                    var pathArray = path.split("/");
                    pathArray.forEach(function(value) {
                        if (value !== "" && !Helpers.urlContainsEmail(value)) newPath = newPath + "/" + value;
                    });
                }
                return newPath === "" ? path : newPath;
            }
        },
        {
            key: "convertQueryObjToString",
            value: function convertQueryObjToString(obj) {
                var queryString = new URLSearchParams(obj).toString();
                if (queryString !== "") queryString = "?" + queryString;
                return queryString;
            }
        },
        {
            key: "emailAddressIsDetected",
            value: function emailAddressIsDetected() {
                return Helpers.urlContainsEmail(window.location.href) || Helpers.urlContainsEmail(document.referrer);
            }
        },
        {
            key: "hostnameFromUrl",
            value: function hostnameFromUrl(url) {
                return url.replace(/http(s|):\/\//g, "").split(/(\/|:)/g)[0];
            }
        },
        {
            key: "addCleanedUrlAndPaths",
            value: function addCleanedUrlAndPaths(obj) {
                obj["url"] = window.location.origin + $7ed41b2ce96d3996$var$PATH_OVERRIDE;
                obj["path"] = $7ed41b2ce96d3996$var$PATH_OVERRIDE;
                obj["search"] = "";
                return obj;
            }
        },
        {
            key: "addCleanedReferrer",
            value: function addCleanedReferrer(obj) {
                obj["referrer"] = Helpers.urlWithoutPath(document.referrer) + $7ed41b2ce96d3996$var$PATH_OVERRIDE;
                return obj;
            }
        },
        {
            key: "urlWithoutPath",
            value: function urlWithoutPath(url) {
                var fakeTag = document.createElement("a");
                fakeTag.href = url;
                return fakeTag.protocol + "//" + fakeTag.host;
            }
        },
        {
            key: "maskURL",
            value: function maskURL(input) {
                if (input === "" || input === undefined) return input;
                var url = new URL(input);
                var obj = $7ed41b2ce96d3996$var$_queryString["default"].parse(url.search);
                obj = Helpers.dropEmailQueryParams(obj);
                if (url.pathname.includes("/search")) obj = Helpers.maskSearchTerms(obj);
                return url.origin + Helpers.dropEmailFromPath(url.pathname) + Helpers.convertQueryObjToString(obj);
            }
        }
    ]);
}();
$7ed41b2ce96d3996$var$_defineProperty($7ed41b2ce96d3996$var$Helpers, "wrapperLoadErrorCounts", new Map());


var $953d02a8da05f5df$exports = {};
"use strict";
Object.defineProperty($953d02a8da05f5df$exports, "__esModule", {
    value: true
});
$953d02a8da05f5df$exports.mathGuid = void 0;
function $953d02a8da05f5df$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $953d02a8da05f5df$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $953d02a8da05f5df$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $953d02a8da05f5df$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $953d02a8da05f5df$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $953d02a8da05f5df$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * See:
 *  - http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/24891600#24891600
 * for more context around the issue of psuedo-randomness used by browsers and the solution used below.
 *
 * and:
 *  - http://web.archive.org/web/20120503063359/http://baagoe.com/en/RandomMusings/javascript/
 * for info regarding the Alea code used below.
 */ var $953d02a8da05f5df$var$trueRandom = function() {
    function Mash() {
        var n = 0xefc8249d;
        var mash = function mash(data) {
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    function Alea() {
        return function(args) {
            // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
            var s0 = 0;
            var s1 = 0;
            var s2 = 0;
            var c = 1;
            if (args.length == 0) args = [
                +new Date()
            ];
            var mash = Mash();
            s0 = mash(" ");
            s1 = mash(" ");
            s2 = mash(" ");
            var _iterator = $953d02a8da05f5df$var$_createForOfIteratorHelper(args), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var item = _step.value;
                    s0 -= mash(item);
                    if (s0 < 0) s0 += 1;
                    s1 -= mash(item);
                    if (s1 < 0) s1 += 1;
                    s2 -= mash(item);
                    if (s2 < 0) s2 += 1;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            var random = function random() {
                var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = "Alea 0.9";
            random.args = args;
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    return Alea();
}();
var $953d02a8da05f5df$var$mathGuid = $953d02a8da05f5df$exports.mathGuid = function mathGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = $953d02a8da05f5df$var$trueRandom() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};


function $dd4d4cd8f6ef082a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd4d4cd8f6ef082a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd4d4cd8f6ef082a$var$_typeof(o);
}
function $dd4d4cd8f6ef082a$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $dd4d4cd8f6ef082a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $dd4d4cd8f6ef082a$var$_toPropertyKey(o.key), o);
    }
}
function $dd4d4cd8f6ef082a$var$_createClass(e, r, t) {
    return r && $dd4d4cd8f6ef082a$var$_defineProperties(e.prototype, r), t && $dd4d4cd8f6ef082a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $dd4d4cd8f6ef082a$var$_toPropertyKey(t) {
    var i = $dd4d4cd8f6ef082a$var$_toPrimitive(t, "string");
    return "symbol" == $dd4d4cd8f6ef082a$var$_typeof(i) ? i : i + "";
}
function $dd4d4cd8f6ef082a$var$_toPrimitive(t, r) {
    if ("object" != $dd4d4cd8f6ef082a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dd4d4cd8f6ef082a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dd4d4cd8f6ef082a$var$Guid = $dd4d4cd8f6ef082a$exports.Guid = /*#__PURE__*/ function() {
    function Guid() {
        $dd4d4cd8f6ef082a$var$_classCallCheck(this, Guid);
    }
    return $dd4d4cd8f6ef082a$var$_createClass(Guid, null, [
        {
            key: "guid",
            value: function guid() {
                try {
                    return (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error getting uuidV4");
                    return (0, $953d02a8da05f5df$exports.mathGuid)();
                }
            }
        },
        {
            key: "guidNoDashes",
            value: function guidNoDashes() {
                return (0, $3fa3ae484854b431$export$2e2bcd8739ae039)().replace(/-/g, "");
            }
        },
        {
            key: "addNumberToGUID",
            value: function addNumberToGUID(guid, number) {
                // take the last 4 digits and convert to a hex string representation
                var hex = guid.slice(-4);
                var value = parseInt(hex, 16);
                if (isNaN(value)) return guid;
                var valLength = value.toString(16).length;
                value += number;
                // clamp to 2 bytes
                if (value > 65535) value -= 65536;
                else if (value < 0) value += 65536;
                // convert back to hex and make sure its as long as many digits as the initial value
                // This is needed for subtraction
                hex = value.toString(16);
                if (hex.length < valLength) hex = ("00000" + hex).slice(-valLength);
                // replace the last 4 digits of the guid with the last 4 digits of the converted value
                return guid.slice(0, guid.length - hex.length) + hex;
            }
        },
        {
            key: "guidHashCode",
            value: function guidHashCode(guid) {
                var hash = 0;
                for(var i = 0; i < guid.length; i++){
                    hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
                    hash = hash & hash; // Convert to 32bit integer
                }
                return Math.abs(hash);
            }
        }
    ]);
}();



function $9789bdfe9c957a15$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9789bdfe9c957a15$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9789bdfe9c957a15$var$_typeof(o);
}
function $9789bdfe9c957a15$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $9789bdfe9c957a15$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9789bdfe9c957a15$var$_toPropertyKey(o.key), o);
    }
}
function $9789bdfe9c957a15$var$_createClass(e, r, t) {
    return r && $9789bdfe9c957a15$var$_defineProperties(e.prototype, r), t && $9789bdfe9c957a15$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9789bdfe9c957a15$var$_toPropertyKey(t) {
    var i = $9789bdfe9c957a15$var$_toPrimitive(t, "string");
    return "symbol" == $9789bdfe9c957a15$var$_typeof(i) ? i : i + "";
}
function $9789bdfe9c957a15$var$_toPrimitive(t, r) {
    if ("object" != $9789bdfe9c957a15$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9789bdfe9c957a15$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */ 
var $9789bdfe9c957a15$var$ATL_COHORT = $9789bdfe9c957a15$exports.ATL_COHORT = "atlCohort";
var $9789bdfe9c957a15$var$COHORT_VERSION = $9789bdfe9c957a15$exports.COHORT_VERSION = "2";
var $9789bdfe9c957a15$var$requiredBucketAttributeKeys = $9789bdfe9c957a15$exports.requiredBucketAttributeKeys = [
    "index",
    "bucketedAtUTC",
    "version",
    "bucketId"
];
var $9789bdfe9c957a15$var$cohortBuckets = {
    bucketAll: {
        bucketId: 0
    }
};
/**
 * Provides public access to cohort cookie name and methods for reading and writing that cookie
 * @module Cohort
 */ var $9789bdfe9c957a15$var$Cohort = $9789bdfe9c957a15$exports.Cohort = /*#__PURE__*/ function() {
    function Cohort() {
        $9789bdfe9c957a15$var$_classCallCheck(this, Cohort);
    }
    return $9789bdfe9c957a15$var$_createClass(Cohort, null, [
        {
            key: "readAtlCohort",
            value: /*
       Hypothetical way to add other buckets (adding their name to the types above):
           if (isMobileDevice()) {
              cohortBuckets.bucket_mobile = {
                  bucketId: 1
              };
          }
           if (isEnglishSpeaking()) {
              cohortBuckets.bucket_english = {};
          }
           function isMobileDevice() {
              // some logic here...
              return true;
          }
           function isEnglishSpeaking() {
              // some logic here...
              return false;
          }
      */ /**
     * Tries to read the ATL_COHORT cookie and return it
     * @function readAtlCohort
     * @return {object | null} the cohort object or null
     */ function readAtlCohort() {
                var atlCohort;
                var atlCohortCookie = $f3ce5ca773e60031$exports.Cookie.readCookie($9789bdfe9c957a15$var$ATL_COHORT);
                try {
                    atlCohort = atlCohortCookie ? JSON.parse(atlCohortCookie) : null;
                    return $7ed41b2ce96d3996$exports.Helpers.isObject(atlCohort) ? atlCohort : null;
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error reading ALT_COHORT Cookie");
                    return null;
                }
            }
        },
        {
            key: "writeAtlCohort",
            value: function writeAtlCohort(atlCohort) {
                if ($7ed41b2ce96d3996$exports.Helpers.isObject(atlCohort)) $f3ce5ca773e60031$exports.Cookie.writeCookie($9789bdfe9c957a15$var$ATL_COHORT, JSON.stringify(atlCohort), 3650, true);
            }
        },
        {
            key: "bucketExists",
            value: function bucketExists(key, atlCohort) {
                if ($7ed41b2ce96d3996$exports.Helpers.isObject(atlCohort)) {
                    var bucket = atlCohort[key];
                    if (bucket && $7ed41b2ce96d3996$exports.Helpers.isObject(bucket)) return $9789bdfe9c957a15$var$requiredBucketAttributeKeys.every(function(bucketAttribute) {
                        return typeof bucket[bucketAttribute] !== "undefined";
                    });
                }
                return false;
            }
        },
        {
            key: "createBucket",
            value: function createBucket(bucketKey) {
                var bucketAttributes = $9789bdfe9c957a15$var$cohortBuckets[bucketKey];
                var anonymousId = $f3ce5ca773e60031$exports.Cookie.readCookie("ajs_anonymous_id");
                var bucket = {
                    bucketedAtUTC: new Date().toISOString(),
                    version: $9789bdfe9c957a15$var$COHORT_VERSION,
                    index: anonymousId ? $dd4d4cd8f6ef082a$exports.Guid.guidHashCode($dd4d4cd8f6ef082a$exports.Guid.addNumberToGUID(anonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
                    bucketId: bucketAttributes.bucketId
                };
                return bucket;
            }
        },
        {
            key: "readWriteAtlCohort",
            value: function readWriteAtlCohort(writeOverride) {
                // if overriding the cohort, do not read the existing cohort; set to empty to force a write
                var atlCohort = writeOverride ? {} : Cohort.readAtlCohort() || {};
                var missingBuckets = Object.keys($9789bdfe9c957a15$var$cohortBuckets)// Find missing buckets
                .filter(function(bucket) {
                    return !Cohort.bucketExists(bucket, atlCohort);
                });
                if (missingBuckets.length) {
                    missingBuckets.forEach(function(missingBucket) {
                        return atlCohort[missingBucket] = Cohort.createBucket(missingBucket);
                    });
                    Cohort.writeAtlCohort(atlCohort);
                }
                return atlCohort;
            }
        }
    ]);
}();



var $51d4ec156e612ca7$exports = {};
"use strict";
Object.defineProperty($51d4ec156e612ca7$exports, "__esModule", {
    value: true
});
$51d4ec156e612ca7$exports.Tracking = void 0;


var $2ac1d0168768b0b1$exports = {};
"use strict";
Object.defineProperty($2ac1d0168768b0b1$exports, "__esModule", {
    value: true
});
$2ac1d0168768b0b1$exports.CookieCompliance = void 0;



function $2ac1d0168768b0b1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ac1d0168768b0b1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ac1d0168768b0b1$var$_typeof(o);
}
function $2ac1d0168768b0b1$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $2ac1d0168768b0b1$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $2ac1d0168768b0b1$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($2ac1d0168768b0b1$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $2ac1d0168768b0b1$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $2ac1d0168768b0b1$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $2ac1d0168768b0b1$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $2ac1d0168768b0b1$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $2ac1d0168768b0b1$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $2ac1d0168768b0b1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $2ac1d0168768b0b1$var$_toPropertyKey(o.key), o);
    }
}
function $2ac1d0168768b0b1$var$_createClass(e, r, t) {
    return r && $2ac1d0168768b0b1$var$_defineProperties(e.prototype, r), t && $2ac1d0168768b0b1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $2ac1d0168768b0b1$var$_defineProperty(e, r, t) {
    return (r = $2ac1d0168768b0b1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2ac1d0168768b0b1$var$_toPropertyKey(t) {
    var i = $2ac1d0168768b0b1$var$_toPrimitive(t, "string");
    return "symbol" == $2ac1d0168768b0b1$var$_typeof(i) ? i : i + "";
}
function $2ac1d0168768b0b1$var$_toPrimitive(t, r) {
    if ("object" != $2ac1d0168768b0b1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2ac1d0168768b0b1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Cookie compliance module.
 *
 * Two-tier consent model:
 *   - operational events  -> always fire (error/perf/page-load telemetry)
 *   - non-operational     -> fire only if the user consented to OneTrust C0002 (Performance) cookies
 *
 * Suppression is purely a function of OneTrust consent state — must not depend on
 * FeatureGates / async init.
 *
 * @module CookieCompliance
 */ 
// 24h, mirrors upstream PR #256
var $2ac1d0168768b0b1$var$SN_ID_COOKIE_DAYS = 1;
var $2ac1d0168768b0b1$var$ATL_FIRST_VISIT_TTL_MS = 86400000;
var $2ac1d0168768b0b1$var$SN_ID_COOKIE_NAME = "sn_id";
var $2ac1d0168768b0b1$var$ATL_FIRST_VISIT_KEY = "atl_first_visit";
var $2ac1d0168768b0b1$var$CookieCompliance = $2ac1d0168768b0b1$exports.CookieCompliance = /*#__PURE__*/ function() {
    function CookieCompliance() {
        $2ac1d0168768b0b1$var$_classCallCheck(this, CookieCompliance);
    }
    return $2ac1d0168768b0b1$var$_createClass(CookieCompliance, null, [
        {
            key: "optOutPerfTracking",
            value: /**
     * @returns true when the user has NOT consented to OneTrust C0002 (Performance) cookies.
     *          When true, the wrapper suppresses all non-operational events and only fires the
     *          strictly-necessary `requested_page` operational event. Side-effect: refreshes
     *          the `optedOut` cache used by `GASv3.sendOperationalEvent` to strip identifiers.
     */ function optOutPerfTracking() {
                var result = CookieCompliance._noPerformanceCookieConsent();
                CookieCompliance.optedOut = result;
                return result;
            }
        },
        {
            key: "_noPerformanceCookieConsent",
            value: function _noPerformanceCookieConsent() {
                if (typeof window === "undefined") return false;
                if (typeof window.OnetrustActiveGroups === "string" && window.OnetrustActiveGroups.length > 0) return !window.OnetrustActiveGroups.includes("2");
                // OptanonConsent cookie fallback — value contains "groups=...,C0002:1,..."
                var optanon = $f3ce5ca773e60031$exports.Cookie.readCookie("OptanonConsent");
                if (optanon) try {
                    var decoded = decodeURIComponent(optanon);
                    var groupsMatch = /groups=([^&]+)/.exec(decoded);
                    if (groupsMatch && groupsMatch[1]) return !/C0002:1|,2:1|,2,/.test(groupsMatch[1]);
                } catch (_unused) {
                // ignore — fall through to default
                }
                // No signal at all → treat as opted out so we don't accidentally over-collect
                return true;
            }
        },
        {
            key: "_isLocalStorageAvailable",
            value: function _isLocalStorageAvailable() {
                if (CookieCompliance.localStorageAvailable !== undefined) return CookieCompliance.localStorageAvailable;
                if (typeof window === "undefined") {
                    CookieCompliance.localStorageAvailable = false;
                    return false;
                }
                try {
                    var probeKey = "__atl_storage_probe__";
                    window.localStorage.setItem(probeKey, "1");
                    window.localStorage.removeItem(probeKey);
                    CookieCompliance.localStorageAvailable = true;
                } catch (_unused2) {
                    CookieCompliance.localStorageAvailable = false;
                }
                return CookieCompliance.localStorageAvailable;
            }
        },
        {
            key: "_resetMemoisedState",
            value: function _resetMemoisedState() {
                CookieCompliance.localStorageAvailable = undefined;
                CookieCompliance.atlFirstVisitCache = undefined;
                CookieCompliance.activeGroupsListenerInstalled = false;
            }
        },
        {
            key: "setSnIdAndAtlFirstVisit",
            value: function setSnIdAndAtlFirstVisit(pageViewProperties) {
                var snId = $f3ce5ca773e60031$exports.Cookie.readCookie($2ac1d0168768b0b1$var$SN_ID_COOKIE_NAME);
                if (!snId) {
                    snId = $dd4d4cd8f6ef082a$exports.Guid.guid();
                    $f3ce5ca773e60031$exports.Cookie.writeCookie($2ac1d0168768b0b1$var$SN_ID_COOKIE_NAME, encodeURIComponent('"' + snId + '"'), $2ac1d0168768b0b1$var$SN_ID_COOKIE_DAYS, true);
                    // Invalidate cache before seeding so the post-seed read sees the new payload.
                    CookieCompliance.atlFirstVisitCache = undefined;
                    CookieCompliance._setAtlFirstVisit(pageViewProperties);
                }
                CookieCompliance.snId = decodeURIComponent(snId).replace(/['"]+/g, "");
                // Fast path: serve from memoised cache to skip storage on SPA route changes.
                if (CookieCompliance.atlFirstVisitCache !== undefined) {
                    CookieCompliance.atlFirstVisit = CookieCompliance.atlFirstVisitCache;
                    return;
                }
                if (!CookieCompliance._isLocalStorageAvailable()) {
                    CookieCompliance.atlFirstVisit = {};
                    CookieCompliance.atlFirstVisitCache = {};
                    return;
                }
                try {
                    var stored = window.localStorage.getItem($2ac1d0168768b0b1$var$ATL_FIRST_VISIT_KEY);
                    var parsed = stored ? JSON.parse(stored) : {};
                    CookieCompliance.atlFirstVisit = parsed;
                    CookieCompliance.atlFirstVisitCache = parsed;
                } catch (_unused3) {
                    CookieCompliance.atlFirstVisit = {};
                    CookieCompliance.atlFirstVisitCache = {};
                }
            }
        },
        {
            key: "_listenForActiveGroupsChange",
            value: function _listenForActiveGroupsChange() {
                if (typeof window === "undefined") return;
                // Idempotent: only install the accessor once per page lifecycle.
                if (CookieCompliance.activeGroupsListenerInstalled) return;
                var activeGroups = window.OnetrustActiveGroups;
                try {
                    Object.defineProperty(window, "OnetrustActiveGroups", {
                        get: function get() {
                            return activeGroups;
                        },
                        set: function set(newGroups) {
                            if (newGroups !== activeGroups) {
                                activeGroups = newGroups;
                                // Prefer the in-memory cache so we don't trigger an extra
                                // storage read on every group change. Only fall back to
                                // `localStorage.getItem` if the cache hasn't been populated
                                // yet AND storage is available.
                                var payload = CookieCompliance.atlFirstVisitCache;
                                if (payload === undefined && CookieCompliance._isLocalStorageAvailable()) try {
                                    var data = window.localStorage.getItem($2ac1d0168768b0b1$var$ATL_FIRST_VISIT_KEY);
                                    payload = data ? JSON.parse(data) : undefined;
                                } catch (_unused4) {
                                    // swallow — the property setter must not throw
                                    return;
                                }
                                if (!payload || Object.keys(payload).length === 0) return;
                                payload.activeGroups = newGroups;
                                // Keep the cache + public field in sync.
                                CookieCompliance.atlFirstVisitCache = payload;
                                CookieCompliance.atlFirstVisit = payload;
                                // Persist to storage when available; skip silently otherwise.
                                if (CookieCompliance._isLocalStorageAvailable()) try {
                                    window.localStorage.setItem($2ac1d0168768b0b1$var$ATL_FIRST_VISIT_KEY, JSON.stringify(payload));
                                } catch (_unused5) {
                                // swallow — the property setter must not throw
                                }
                            }
                        },
                        configurable: true
                    });
                    CookieCompliance.activeGroupsListenerInstalled = true;
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("atl_first_visit activeGroups listener install failed", e instanceof Error ? e.message : String(e));
                }
            }
        },
        {
            key: "_setAtlFirstVisit",
            value: function _setAtlFirstVisit(pageViewProperties) {
                var refUrl = null;
                try {
                    refUrl = document.referrer ? new URL(document.referrer) : null;
                } catch (_unused6) {
                    refUrl = null;
                }
                var data = {
                    originProduct: CookieCompliance._try(function() {
                        return pageViewProperties === null || pageViewProperties === void 0 ? void 0 : pageViewProperties["originProduct"];
                    }),
                    campaign: CookieCompliance._try(function() {
                        return $7ed41b2ce96d3996$exports.Helpers.getUtms({
                            utm_campaign: "",
                            utm_medium: "",
                            utm_source: "",
                            utm_content: "",
                            utm_term: ""
                        });
                    }),
                    page_url_params_json: CookieCompliance._try(function() {
                        return JSON.stringify(CookieCompliance._parseQuery(window.location.search));
                    }),
                    page_url: CookieCompliance._try(function() {
                        return window.location.href;
                    }),
                    page_path: CookieCompliance._try(function() {
                        return window.location.pathname;
                    }),
                    page_domain: CookieCompliance._try(function() {
                        return window.location.hostname;
                    }),
                    page_subdomain: CookieCompliance._try(function() {
                        return window.location.hostname;
                    }),
                    page_referrer_url: CookieCompliance._try(function() {
                        return document.referrer;
                    }),
                    page_referrer_domain: CookieCompliance._try(function() {
                        var _refUrl;
                        return (_refUrl = refUrl) === null || _refUrl === void 0 ? void 0 : _refUrl.hostname;
                    }),
                    page_referrer_subdomain: CookieCompliance._try(function() {
                        var _refUrl2;
                        return (_refUrl2 = refUrl) === null || _refUrl2 === void 0 ? void 0 : _refUrl2.hostname;
                    }),
                    page_url_parameters: CookieCompliance._try(function() {
                        return window.location.search;
                    }),
                    page_referrer_url_parameters: CookieCompliance._try(function() {
                        var _refUrl3;
                        return (_refUrl3 = refUrl) === null || _refUrl3 === void 0 ? void 0 : _refUrl3.search;
                    }),
                    cookiesEnabled: CookieCompliance._try(function() {
                        var _window$navigator;
                        return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.cookieEnabled;
                    }, "unknown"),
                    activeGroups: CookieCompliance._try(function() {
                        return window.OnetrustActiveGroups;
                    }),
                    "bxp-gateway-id": CookieCompliance._try(function() {
                        return $f3ce5ca773e60031$exports.Cookie.readCookie("bxp_gateway_request_id");
                    }),
                    "user-agent": CookieCompliance._try(function() {
                        var _window$navigator2;
                        return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.userAgent;
                    }),
                    expiresAt: Date.now() + $2ac1d0168768b0b1$var$ATL_FIRST_VISIT_TTL_MS
                };
                // Skip the write when storage is known-broken; cache the payload in memory.
                if (!CookieCompliance._isLocalStorageAvailable()) {
                    CookieCompliance.atlFirstVisitCache = data;
                    return;
                }
                try {
                    window.localStorage.setItem($2ac1d0168768b0b1$var$ATL_FIRST_VISIT_KEY, JSON.stringify(data));
                    CookieCompliance.atlFirstVisitCache = data;
                } catch (e) {
                    // Mark storage unavailable so subsequent ops short-circuit.
                    CookieCompliance.localStorageAvailable = false;
                    CookieCompliance.atlFirstVisitCache = data;
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("atl_first_visit localStorage update failed", e instanceof Error ? e.message : String(e));
                }
            }
        },
        {
            key: "_try",
            value: function _try(fn) {
                var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                try {
                    var value = fn();
                    return value === null || value === undefined ? fallback : value;
                } catch (_unused7) {
                    return fallback;
                }
            }
        },
        {
            key: "_parseQuery",
            value: function _parseQuery(search) {
                var out = {};
                if (!search) return out;
                var params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
                params.forEach(function(value, key) {
                    out[key] = value;
                });
                return out;
            }
        },
        {
            key: "waitForOneTrustToInit",
            value: function() {
                var _waitForOneTrustToInit = $2ac1d0168768b0b1$var$_asyncToGenerator(/*#__PURE__*/ $2ac1d0168768b0b1$var$_regeneratorRuntime().mark(function _callee() {
                    var maxWaitMs, _args = arguments;
                    return $2ac1d0168768b0b1$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                maxWaitMs = _args.length > 0 && _args[0] !== undefined ? _args[0] : 3000;
                                if (!(typeof window === "undefined")) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 3:
                                if (!(typeof window.OnetrustActiveGroups === "string")) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 5:
                                return _context.abrupt("return", new Promise(function(resolve) {
                                    var POLL_MS = 250;
                                    var timers = {};
                                    timers.interval = setInterval(function() {
                                        if (typeof window.OnetrustActiveGroups === "string") {
                                            if (timers.interval) clearInterval(timers.interval);
                                            if (timers.timeout) clearTimeout(timers.timeout);
                                            resolve();
                                        }
                                    }, POLL_MS);
                                    timers.timeout = setTimeout(function() {
                                        if (timers.interval) clearInterval(timers.interval);
                                        resolve();
                                    }, maxWaitMs);
                                }));
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function waitForOneTrustToInit() {
                    return _waitForOneTrustToInit.apply(this, arguments);
                }
                return waitForOneTrustToInit;
            }()
        }
    ]);
}();
/**
 * Resolved sn_id (after `setSnIdAndAtlFirstVisit` runs). Attached to the `requested_page`
 * operational event in `Tracking.pageView` (mirrors upstream PR #269).
 */ $2ac1d0168768b0b1$var$_defineProperty($2ac1d0168768b0b1$var$CookieCompliance, "snId", "");
/**
 * Resolved atl_first_visit payload (after `setSnIdAndAtlFirstVisit` runs). Attached to the
 * `requested_page` operational event.
 */ $2ac1d0168768b0b1$var$_defineProperty($2ac1d0168768b0b1$var$CookieCompliance, "atlFirstVisit", {});
/**
 * Memoised result of the most recent `optOutPerfTracking()` call. Used so the rest of the
 * wrapper can branch off a stable boolean within a single init pass without re-reading the
 * gate / cookie on every event. Refreshed on each `optOutPerfTracking()` call.
 */ $2ac1d0168768b0b1$var$_defineProperty($2ac1d0168768b0b1$var$CookieCompliance, "optedOut", false);
/**
 * Idempotency flag for `_listenForActiveGroupsChange()`. The
 * `Object.defineProperty` accessor on `window.OnetrustActiveGroups` can only
 * be installed once per page lifecycle (re-installing throws), so callers
 * can safely invoke from every SPA route change.
 */ $2ac1d0168768b0b1$var$_defineProperty($2ac1d0168768b0b1$var$CookieCompliance, "activeGroupsListenerInstalled", false);
/**
 * Memoised feature-detect for `window.localStorage`. Tri-state: `undefined`
 * = not probed, `true` = available, `false` = unavailable (Safari private
 * mode, sandboxed iframe, ITP, disabled). Once `false`, callers MUST skip
 * storage ops — repeating them on every event amplifies upstream operational
 * error volume.
 */ $2ac1d0168768b0b1$var$_defineProperty($2ac1d0168768b0b1$var$CookieCompliance, "localStorageAvailable", undefined);
/**
 * Memoised parsed `atl_first_visit` payload for this page lifecycle. Set on
 * first read so SPA route changes don't re-hit storage.
 */ $2ac1d0168768b0b1$var$_defineProperty($2ac1d0168768b0b1$var$CookieCompliance, "atlFirstVisitCache", undefined);



var $17b2e0e0478a2ce8$exports = {};
"use strict";
Object.defineProperty($17b2e0e0478a2ce8$exports, "__esModule", {
    value: true
});
$17b2e0e0478a2ce8$exports.GASv3 = void 0;
var $421bc9561fa21e57$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};



var $3emEs = parcelRequire("3emEs");







var $32d4b1bfd92b4113$exports = {};
"use strict";
Object.defineProperty($32d4b1bfd92b4113$exports, "__esModule", {
    value: true
});
$32d4b1bfd92b4113$exports.TrelloUrlScrubber = void 0;
function $32d4b1bfd92b4113$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $32d4b1bfd92b4113$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $32d4b1bfd92b4113$var$_typeof(o);
}
function $32d4b1bfd92b4113$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $32d4b1bfd92b4113$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $32d4b1bfd92b4113$var$_toPropertyKey(o.key), o);
    }
}
function $32d4b1bfd92b4113$var$_createClass(e, r, t) {
    return r && $32d4b1bfd92b4113$var$_defineProperties(e.prototype, r), t && $32d4b1bfd92b4113$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $32d4b1bfd92b4113$var$_toPropertyKey(t) {
    var i = $32d4b1bfd92b4113$var$_toPrimitive(t, "string");
    return "symbol" == $32d4b1bfd92b4113$var$_typeof(i) ? i : i + "";
}
function $32d4b1bfd92b4113$var$_toPrimitive(t, r) {
    if ("object" != $32d4b1bfd92b4113$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $32d4b1bfd92b4113$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $32d4b1bfd92b4113$var$routeTypes = {
    BOARD: "board",
    BOARD_BUTLER: "board-butler",
    BOARD_BUTLER_PAGE: "board-butler-page",
    BOARD_RECOMMEND: "board-recommend",
    CARD: "card",
    ENTERPRISE_ADMIN: "enterprise-admin",
    ENTERPRISE_ADMIN_TAB: "enterprise-admin-tab",
    ENTERPRISE_ADMIN_TAB_SUBSECTION: "enterprise-admin-tab-subsection",
    HOME: "home",
    TEMPLATES: "templates",
    TEMPLATES_CATEGORIES: "templates-categories",
    TEMPLATES_STORY: "templates-story",
    TEMPLATES_RECOMMEND: "templates-recommend",
    TEMPLATES_SUBMIT: "templates-submit",
    TEMPLATE: "template",
    USER: "user",
    USER_TABS: "user-tabs",
    USER_CARDS_WORKSPACE: "user-cards-workspace",
    VIEW: "view",
    WORKSPACE: "workspace",
    WORKSPACE_SECTION: "workspace-section",
    WORKSPACE_MEMBERS_SUBSECTION: "workspace-members-subsection",
    WORKSPACE_VIEWS_SUBSECTION: "workspace-views-subsection",
    POWER_UPS_HOME: "power-ups-home",
    POWER_UPS_ALL: "power-ups-all",
    POWER_UPS_TRELLO: "power-ups-trello",
    POWER_UPS_CATEGORIES: "power-ups-categories",
    UPGRADE_TEAM: "select-team-to-upgrade",
    SHORTCUTS: "shortcuts"
};
// Trello indices of non UGC/PII in the pathname depending on their route type
var $32d4b1bfd92b4113$var$ALLOWLIST_INDICES = {
    ROUTE_IDENTIFIER: 0,
    ROUTE_SHORTLINK: 1,
    B_ROUTE_BUTLER: 3,
    B_ROUTE_BUTLER_PAGE: 4,
    B_ROUTE_RECOMMEND: 4,
    E_ROUTE_ADMIN: 2,
    E_ROUTE_ADMIN_TAB_NAME: 3,
    E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
    POWER_UPS_ROUTE_PAGE: 1,
    POWER_UPS_ROUTE_CATEGORY: 1,
    POWER_UPS_ROUTE_CATEGORY_NAME: 2,
    TEMPLATES_ROUTE_PAGE: 1,
    TEMPLATES_ROUTE_CATEGORY: 1,
    TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
    TEMPLATES_ROUTE_RECOMMEND: 4,
    U_ROUTE_TAB_NAME: 2,
    W_ROUTE_PAGE: 2,
    W_ROUTE_PAGE_SUBSECTION: 3
};
var $32d4b1bfd92b4113$var$routePatternMap = new Map([
    [
        $32d4b1bfd92b4113$var$routeTypes.BOARD_RECOMMEND,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.BOARD_RECOMMEND,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/([^/]+)/recommend$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.B_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.BOARD_BUTLER_PAGE,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.BOARD_BUTLER_PAGE,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.BOARD_BUTLER,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.BOARD_BUTLER,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/butler/$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.BOARD,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.BOARD,
            regExp: new RegExp("^/b/([^/]+)(?:/(.*?))?$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.CARD,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.CARD,
            regExp: new RegExp("^/c/"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
            regExp: new RegExp("^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.ENTERPRISE_ADMIN_TAB,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.ENTERPRISE_ADMIN_TAB,
            regExp: new RegExp("^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.ENTERPRISE_ADMIN,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.ENTERPRISE_ADMIN,
            regExp: new RegExp("^/e/([^/]+)/admin$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_HOME,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_HOME,
            regExp: new RegExp("^/power-ups$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_ALL,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_ALL,
            regExp: new RegExp("^/power-ups/all$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_TRELLO,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_TRELLO,
            regExp: new RegExp("^/power-ups/made-by-trello$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_CATEGORIES,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.POWER_UPS_CATEGORIES,
            regExp: new RegExp("^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.HOME,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.HOME,
            regExp: new RegExp("^/$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.UPGRADE_TEAM,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.UPGRADE_TEAM,
            regExp: new RegExp("^/select-team-to-upgrade$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.SHORTCUTS,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.SHORTCUTS,
            regExp: new RegExp("^/shortcuts$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_SUBMIT,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_SUBMIT,
            regExp: new RegExp("^/templates/submit$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_RECOMMEND,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_RECOMMEND,
            regExp: new RegExp("^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_CATEGORIES,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_CATEGORIES,
            regExp: new RegExp("^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_STORY,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.TEMPLATES_STORY,
            regExp: new RegExp("^/templates/([^/]+)/([^/]+)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.TEMPLATES,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.TEMPLATES,
            regExp: new RegExp("^/templates$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.USER_CARDS_WORKSPACE,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.USER_CARDS_WORKSPACE,
            regExp: new RegExp("^/u/([^/]+)/cards/([^/]+)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.USER_TABS,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.USER_TABS,
            regExp: new RegExp("^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.USER,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.USER,
            regExp: new RegExp("^/u/"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.VIEW,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.VIEW,
            regExp: new RegExp("^/v/"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.WORKSPACE_SECTION,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.WORKSPACE_SECTION,
            regExp: new RegExp("^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.W_ROUTE_PAGE
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
            regExp: new RegExp("^/w/([^/]+)/members/(guests|requests)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
            regExp: new RegExp("^/w/([^/]+)/views/(table|calendar|)$"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $32d4b1bfd92b4113$var$routeTypes.WORKSPACE,
        {
            id: $32d4b1bfd92b4113$var$routeTypes.WORKSPACE,
            regExp: new RegExp("^/w/"),
            allowlist: [
                $32d4b1bfd92b4113$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ]
]);
var $32d4b1bfd92b4113$var$TrelloUrlScrubber = $32d4b1bfd92b4113$exports.TrelloUrlScrubber = /*#__PURE__*/ function() {
    function TrelloUrlScrubber() {
        $32d4b1bfd92b4113$var$_classCallCheck(this, TrelloUrlScrubber);
    }
    return $32d4b1bfd92b4113$var$_createClass(TrelloUrlScrubber, null, [
        {
            key: "_determineRoute",
            value: function _determineRoute(urlPathname) {
                var routePatternArray = Array.from($32d4b1bfd92b4113$var$routePatternMap.values());
                for(var _i = 0, _routePatternArray = routePatternArray; _i < _routePatternArray.length; _i++){
                    var routeDefinition = _routePatternArray[_i];
                    if (routeDefinition.regExp.exec(urlPathname)) return routeDefinition;
                }
                return null;
            }
        },
        {
            key: "_reconstructPathname",
            value: function _reconstructPathname(pathnameSections, sectionsToKeep) {
                var reconstructedUrl = "";
                for(var i = 0; i < pathnameSections.length; i++)if (sectionsToKeep.includes(i)) reconstructedUrl += "/" + pathnameSections[i];
                return reconstructedUrl;
            }
        },
        {
            key: "scrubUrl",
            value: function scrubUrl(urlPathname, defaultPathname) {
                var matchingRoute = TrelloUrlScrubber._determineRoute(urlPathname);
                // remove starting slash to allow matchers to use ^ properly
                var partialUrl = urlPathname.substring(1, urlPathname.length);
                var pathnameSections = partialUrl.split("/");
                // to avoid UGC/PII related HOTs, we should be extra cautious & return a
                // generic path for URLs that don't follow a known pattern
                return matchingRoute ? TrelloUrlScrubber._reconstructPathname(pathnameSections, matchingRoute.allowlist) : defaultPathname;
            }
        }
    ]);
}();


function $17b2e0e0478a2ce8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $17b2e0e0478a2ce8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17b2e0e0478a2ce8$var$_typeof(o);
}
function $17b2e0e0478a2ce8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17b2e0e0478a2ce8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17b2e0e0478a2ce8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17b2e0e0478a2ce8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17b2e0e0478a2ce8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $17b2e0e0478a2ce8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $17b2e0e0478a2ce8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $17b2e0e0478a2ce8$var$_toPropertyKey(o.key), o);
    }
}
function $17b2e0e0478a2ce8$var$_createClass(e, r, t) {
    return r && $17b2e0e0478a2ce8$var$_defineProperties(e.prototype, r), t && $17b2e0e0478a2ce8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $17b2e0e0478a2ce8$var$_defineProperty(e, r, t) {
    return (r = $17b2e0e0478a2ce8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $17b2e0e0478a2ce8$var$_toPropertyKey(t) {
    var i = $17b2e0e0478a2ce8$var$_toPrimitive(t, "string");
    return "symbol" == $17b2e0e0478a2ce8$var$_typeof(i) ? i : i + "";
}
function $17b2e0e0478a2ce8$var$_toPrimitive(t, r) {
    if ("object" != $17b2e0e0478a2ce8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17b2e0e0478a2ce8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $8R0Eu = parcelRequire("8R0Eu");
var $17b2e0e0478a2ce8$var$attributeWhiteList = [
    "atlCohort",
    "featureFlags"
];
var $17b2e0e0478a2ce8$var$ATL_USER_HASH = "atlUserHash";
/**
 * Module for GASv3 tracking events.
 * @module GASv3
 */ var $17b2e0e0478a2ce8$var$GASv3 = $17b2e0e0478a2ce8$exports.GASv3 = /*#__PURE__*/ function() {
    function GASv3() {
        $17b2e0e0478a2ce8$var$_classCallCheck(this, GASv3);
    }
    return $17b2e0e0478a2ce8$var$_createClass(GASv3, null, [
        {
            key: "sendUIEvent",
            value: /**
     * Sends a UI event to GASv3
     * @function sendUIEvent
     * @param {string} name
     * @param {object} data
     * @param {object} skipEnrichment - whether to add additional data
     */ function sendUIEvent(name, data, skipEnrichment) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes["trackEventName"] = name;
                var source = GASv3.setSource(data);
                var uiEvent = {
                    action: data.action || "clicked",
                    actionSubject: data.actionSubject || "component",
                    actionSubjectId: data.actionSubjectId || undefined,
                    source: source,
                    attributes: attributes
                };
                this._createAndFireEvent($3emEs.eventType.UI, uiEvent);
            }
        },
        {
            key: "sendScreenEvent",
            value: function sendScreenEvent(name, data, skipEnrichment) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes["name"] = name || data["name"];
                var screenName = data["name"] || attributes["screenNameOverride"] || "page";
                delete attributes["screenNameOverride"];
                this._createAndFireEvent($3emEs.eventType.SCREEN, {
                    name: screenName,
                    attributes: attributes
                });
                GASv3.sendIdentityEvent();
            }
        },
        {
            key: "sendTrackEvent",
            value: function sendTrackEvent(name, data, skipEnrichment) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes["trackEventName"] = name;
                data.source = GASv3.setSource(data);
                data.attributes = attributes;
                this._createAndFireEvent($3emEs.eventType.TRACK, data);
            }
        },
        {
            key: "sendOperationalEvent",
            value: function sendOperationalEvent(name, data, skipEnrichment) {
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes["trackEventName"] = name;
                data.source = GASv3.setSource(data);
                data.attributes = attributes;
                // When opted out of performance cookies, exclude cross-product
                // identifiers from operational events so the strictly-necessary sn_id is the only
                // session linker. Uses the analytics-web-client native `excludedProperties` option
                // (requires @atlassiansox/analytics-web-client >= 5.24.0) per upstream atl-analytics.
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optedOut) data.excludedProperties = {
                    anonymousId: true,
                    authenticatedUserId: true,
                    userId: true,
                    xid: true
                };
                this._createAndFireEvent($3emEs.eventType.OPERATIONAL, data);
            }
        },
        {
            key: "sendIdentityEvent",
            value: function sendIdentityEvent() {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                // load the identity hash cookie
                var atlUserHash = $f3ce5ca773e60031$exports.Cookie.readCookie($17b2e0e0478a2ce8$var$ATL_USER_HASH);
                // get the user identifiers
                var identifiers = GASv3.getUserIdentifiers();
                // calculate the data hash of the known identifiers
                var calculatedHash = $dd4d4cd8f6ef082a$exports.Guid.guidHashCode(JSON.stringify(identifiers)).toString();
                if (!atlUserHash || atlUserHash !== calculatedHash) {
                    // save new hash and send UI event
                    $f3ce5ca773e60031$exports.Cookie.writeCookie($17b2e0e0478a2ce8$var$ATL_USER_HASH, calculatedHash, 3650, true);
                    var data = {
                        action: "identified",
                        actionSubject: "user",
                        identifiers: identifiers,
                        writeKey: $686dafd5f57e3409$exports.AnalyticsState.writeKey
                    };
                    GASv3.sendUIEvent("", data, true);
                }
            }
        },
        {
            key: "getUserIdentifiers",
            value: function getUserIdentifiers() {
                return {
                    anonymousId: $686dafd5f57e3409$exports.AnalyticsState.anonymousId,
                    atlassianAccountId: $9d08699771426032$exports.Identity.getAtlassianUserId(),
                    crossDomainId: $51d4ec156e612ca7$exports.Tracking.xid,
                    optimizelyEndUserId: null,
                    trelloUserId: $9d08699771426032$exports.Identity.getTrelloUserId()
                };
            }
        },
        {
            key: "setSource",
            value: function setSource(data) {
                var set = false;
                var source = data.source || "";
                if (source) set = true;
                if (data["eventContainer"]) {
                    source += data["eventContainer"].split(" ")[0];
                    set = true;
                }
                if (data["eventColumn"]) {
                    source += data["eventColumn"].split(" ")[0];
                    set = true;
                }
                if (!set) source = "none";
                return source;
            }
        },
        {
            key: "getReferrerURL",
            value: function getReferrerURL(ref) {
                if ($9d08699771426032$exports.Identity.isReferrerTrello()) {
                    var referrer = new URL(ref);
                    return referrer.hostname + $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(referrer.pathname, "");
                }
                return ref;
            }
        },
        {
            key: "_createAndFireEvent",
            value: function _createAndFireEvent(eventType, payload) {
                // using analytics-next createAndFireEvent to send event
                if ($686dafd5f57e3409$exports.AnalyticsState.createAnalyticsEvent) (0, $421bc9561fa21e57$export$2e2bcd8739ae039)("atl-global")($17b2e0e0478a2ce8$var$_objectSpread($17b2e0e0478a2ce8$var$_objectSpread({}, payload), {}, {
                    eventType: eventType
                }))($686dafd5f57e3409$exports.AnalyticsState.createAnalyticsEvent);
                // using analytics-web-client to send event
                if (GASv3.client) switch(eventType){
                    case "ui":
                        GASv3.client.sendUIEvent(payload, null);
                        break;
                    case "screen":
                        GASv3.client.sendScreenEvent(payload, null);
                        break;
                    case "operational":
                        GASv3.client.sendOperationalEvent(payload, null);
                        break;
                    case "track":
                        GASv3.client.sendTrackEvent(payload, null);
                        break;
                }
            }
        },
        {
            key: "enrichEventData",
            value: function enrichEventData(inputData) {
                var data = {};
                if ($17b2e0e0478a2ce8$var$_typeof(inputData) !== "object" || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== "undefined") data.data = dataValue;
                } else data = inputData;
                var newData = JSON.parse(JSON.stringify(data));
                newData.writeKey = $686dafd5f57e3409$exports.AnalyticsState.writeKey;
                newData.isMarketingEvent = GASv3.isMarketingEvent;
                var page;
                var ref;
                var page_canonical_url;
                try {
                    var _page;
                    // convert all passed in values to string if they are currently objects
                    Object.keys(newData).forEach(function(inputKey) {
                        var key = inputKey;
                        if (newData[key] && $17b2e0e0478a2ce8$var$_typeof(newData[key]) === "object" && !Array.isArray(newData[key]) && !$17b2e0e0478a2ce8$var$attributeWhiteList.includes(key)) // @ts-ignore
                        newData[key] = JSON.stringify(newData[key]);
                    });
                    var href = GASv3.getLocation();
                    page = href ? new URL($7ed41b2ce96d3996$exports.Helpers.maskURL(href)) : null;
                    var referredByJiraDotCom = ((_page = page) === null || _page === void 0 ? void 0 : _page.searchParams.get("referer")) === "jira.com";
                    ref = referredByJiraDotCom ? new URL("https://www.jira.com") : document.referrer ? new URL($7ed41b2ce96d3996$exports.Helpers.maskURL(document.referrer)) : null;
                    var canonical_url = $7ed41b2ce96d3996$exports.Helpers.getCanonicalUrl();
                    page_canonical_url = canonical_url ? $7ed41b2ce96d3996$exports.Helpers.maskURL($7ed41b2ce96d3996$exports.Helpers.getCanonicalUrl()) : undefined;
                    newData.page_title = newData.page_title || document.title || "";
                    newData.page_domain = page ? page.hostname || "" : "";
                    newData.page_subdomain = page ? page.hostname || "" : "";
                    // referrer attributes
                    newData.page_referrer_domain = ref ? ref.hostname || "" : "";
                    newData.page_referrer_subdomain = ref ? ref.hostname || "" : "";
                    if ($9d08699771426032$exports.Identity.isReferrerTrello()) {
                        // fix for hot-99118
                        newData.page_canonical_url = page ? $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || "" : "";
                        newData.page_url = page ? $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || "" : "";
                        newData.page_path = page ? $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(page.pathname, new URL(page.href).pathname) || "" : "";
                        newData.page_url_parameters = page ? $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(page.search, "") : "";
                        newData.page_url_params_json = page ? JSON.stringify($8R0Eu.parse($32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(page.search, new URL(page.origin).pathname))) : "";
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($8R0Eu.parse($32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(ref.search, new URL(ref.origin).pathname))) : "";
                        newData.page_referrer_path = ref ? $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || "" : "";
                        newData.page_referrer_url = ref ? ref.origin + $32d4b1bfd92b4113$exports.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || "" : "";
                    } else {
                        newData.page_canonical_url = page_canonical_url;
                        newData.page_url = page ? page.href || "" : "";
                        newData.page_path = page ? page.pathname || "" : "";
                        newData.page_url_parameters = page ? page.search || "" : "";
                        newData.page_url_params_json = page ? JSON.stringify($8R0Eu.parse(page.search)) : "";
                        newData.page_url_fragment = page ? $7ed41b2ce96d3996$exports.Helpers.getUrlFragment() : ""; // added for community client
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($8R0Eu.parse(ref.search)) : "";
                        newData.page_referrer_path = ref ? ref.pathname || "" : "";
                        newData.page_referrer_url = ref ? ref.href || "" : "";
                    }
                    newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : "unknown";
                    newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : "";
                    // add additionalEventData
                    for(var _key in GASv3.additionalEventData)// eslint-disable-next-line no-prototype-builtins
                    if (GASv3.additionalEventData.hasOwnProperty(_key)) newData[_key] = GASv3.additionalEventData[_key];
                } catch (e) {
                    // fix for hot-99118
                    var additionalData = {
                        error: e instanceof Error ? e.message : JSON.stringify(e),
                        href: location ? location.href : "no location",
                        referrer: document ? document.referrer ? GASv3.getReferrerURL(document.referrer) : "no referrer" : "no document"
                    };
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("GASv3 enrichEventData error", JSON.stringify(additionalData));
                }
                return newData;
            }
        },
        {
            key: "getLocation",
            value: function getLocation() {
                return location.href;
            }
        }
    ]);
}();
// set this value with attributes that should be sent on every event, set during event enrichment
$17b2e0e0478a2ce8$var$_defineProperty($17b2e0e0478a2ce8$var$GASv3, "additionalEventData", {});


var $89d199d6317f68be$exports = {};
"use strict";
Object.defineProperty($89d199d6317f68be$exports, "__esModule", {
    value: true
});
$89d199d6317f68be$exports.Gtm = void 0;


function $89d199d6317f68be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $89d199d6317f68be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $89d199d6317f68be$var$_typeof(o);
}
function $89d199d6317f68be$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $89d199d6317f68be$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $89d199d6317f68be$var$_toPropertyKey(o.key), o);
    }
}
function $89d199d6317f68be$var$_createClass(e, r, t) {
    return r && $89d199d6317f68be$var$_defineProperties(e.prototype, r), t && $89d199d6317f68be$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $89d199d6317f68be$var$_toPropertyKey(t) {
    var i = $89d199d6317f68be$var$_toPrimitive(t, "string");
    return "symbol" == $89d199d6317f68be$var$_typeof(i) ? i : i + "";
}
function $89d199d6317f68be$var$_toPrimitive(t, r) {
    if ("object" != $89d199d6317f68be$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $89d199d6317f68be$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */ 
var $89d199d6317f68be$var$Gtm = $89d199d6317f68be$exports.Gtm = /*#__PURE__*/ function() {
    function Gtm() {
        $89d199d6317f68be$var$_classCallCheck(this, Gtm);
    }
    return $89d199d6317f68be$var$_createClass(Gtm, null, [
        {
            key: "initialize",
            value: /**
     * Initializes Google Tag Manager
     * @function initialize
     */ function initialize(writeKey) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var containerId = Gtm.getContainerId(writeKey);
                if (containerId) {
                    var _firstScript$parentNo;
                    window["dataLayer"] = window["dataLayer"] || [];
                    window["dataLayer"].push({
                        "gtm.start": new Date().getTime(),
                        event: "gtm.js"
                    });
                    var firstScript = document.getElementsByTagName("script")[0];
                    var gtmScript = document.createElement("script");
                    gtmScript.defer = true;
                    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + containerId;
                    firstScript === null || firstScript === void 0 || (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.appendChild(gtmScript);
                }
            }
        },
        {
            key: "page",
            value: function page(name, category, data) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var event = "Loaded a Page";
                Gtm.track(data, event);
                if (category) {
                    event = "Viewed " + name + " " + category + " Page";
                    Gtm.track(data, event);
                }
                if (name) {
                    event = "Viewed " + name + " Page";
                    Gtm.track(data, event);
                }
            }
        },
        {
            key: "track",
            value: function track(data, event) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var props = typeof data !== "undefined" ? JSON.parse(JSON.stringify(data)) : {};
                var anonId = $686dafd5f57e3409$exports.AnalyticsState.anonymousId;
                if (anonId) props.gasv3AnonymousId = anonId;
                if (event) props.event = event;
                var dataLayer = "dataLayer";
                window[dataLayer] = window[dataLayer] || [];
                window[dataLayer].push(props);
            }
        },
        {
            key: "getContainerId",
            value: function getContainerId(writeKey) {
                var containerIds = Gtm.getContainerIdMapping();
                return containerIds[writeKey];
            }
        },
        {
            key: "getContainerIdMapping",
            value: function getContainerIdMapping() {
                return {
                    // Production
                    ycih1ygfsk: "GTM-MR6PJQR",
                    // support.atlassian.com
                    "9nfqb81km3": "GTM-TSGXFNC",
                    // confluence.atlassian.com
                    kFTUHPhH9Q: "GTM-TRS3MV",
                    // bitbucket
                    u7y09b0olq: "GTM-5VS67RK",
                    // developer.atlassian.com
                    eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr: "GTM-KZLJPX4",
                    // opsgenie
                    bvsetm1g1y: "GTM-5RJSBR",
                    // atlassian.com-cart
                    kiv6wyh2nw: "GTM-5RJSBR",
                    // atlassian.com
                    r4n974s99s: "GTM-5RJSBR",
                    // blogs.atlassian.com
                    swoogo: "GTM-5RJSBR",
                    // events.atlassian.com
                    "8oi64no": "GTM-K7MDT22",
                    // statuspage.io
                    xjtlog1hqa: "GTM-KQ6R2C3",
                    // marketplace.atlassian.com
                    bNSPpYAL9OiAkamBRvfRJoRu9YANW14I: "GTM-MGV77B",
                    // docs.atlassian.com-aui
                    TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw: "GTM-TQZMFCL",
                    // community.atlassian.com
                    trello: "GTM-PJ8M5SK",
                    // trello
                    // Test
                    "4J6H7c3XTcpm1dbenkOILSyOachvf9It": "GTM-TQZMFCL",
                    // community.stg.atlassian.com
                    SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold: "GTM-TQZMFCL",
                    // community.dev1.dev.atlassian.com
                    QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M: "GTM-TQZMFCL",
                    // community.dev2.dev.atlassian.com
                    QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE: "GTM-TQZMFCL",
                    // community.dev3.dev.atlassian.com
                    hWTszOAQMuItRdv8J30A3mNpCWd891bx: "GTM-TQZMFCL",
                    // community.dev4.dev.atlassian.com
                    EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I: "GTM-5RJSBR",
                    // qa-wac.internal.atlassian.com
                    Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs: "GTM-5RJSBR" // CXP Local Dev
                };
            }
        }
    ]);
}();





var $02dcaeca70bf20a9$exports = {};
"use strict";
Object.defineProperty($02dcaeca70bf20a9$exports, "__esModule", {
    value: true
});
$02dcaeca70bf20a9$exports.eventType = void 0;
// this is a 'const enum' copy of eventType from '@atlassiansox/analytics-web-client'
// exporting it here allows importing the enum directly from this package - it cannot be directly exported, as
// enums have issues being accessed during runtime from *.d.ts files
// https://stackoverflow.com/a/50511773
// https://stackoverflow.com/a/66939542
var $02dcaeca70bf20a9$var$eventType = $02dcaeca70bf20a9$exports.eventType = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});


function $51d4ec156e612ca7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $51d4ec156e612ca7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $51d4ec156e612ca7$var$_typeof(o);
}
function $51d4ec156e612ca7$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $51d4ec156e612ca7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $51d4ec156e612ca7$var$_toPropertyKey(o.key), o);
    }
}
function $51d4ec156e612ca7$var$_createClass(e, r, t) {
    return r && $51d4ec156e612ca7$var$_defineProperties(e.prototype, r), t && $51d4ec156e612ca7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $51d4ec156e612ca7$var$_toPropertyKey(t) {
    var i = $51d4ec156e612ca7$var$_toPrimitive(t, "string");
    return "symbol" == $51d4ec156e612ca7$var$_typeof(i) ? i : i + "";
}
function $51d4ec156e612ca7$var$_toPrimitive(t, r) {
    if ("object" != $51d4ec156e612ca7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $51d4ec156e612ca7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $51d4ec156e612ca7$var$Tracking = $51d4ec156e612ca7$exports.Tracking = /*#__PURE__*/ function() {
    function Tracking() {
        $51d4ec156e612ca7$var$_classCallCheck(this, Tracking);
    }
    return $51d4ec156e612ca7$var$_createClass(Tracking, null, [
        {
            key: "_getEventDomain",
            value: function _getEventDomain() {
                return location && location.href ? new URL(location.href).hostname : "";
            }
        },
        {
            key: "trackEvent",
            value: function trackEvent(event, data) {
                var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $02dcaeca70bf20a9$exports.eventType.UI;
                // Drop non-operational events when the user is opted out of performance cookies.
                // Operational events still fire so we can observe page lifecycle compliantly.
                if (type !== $02dcaeca70bf20a9$exports.eventType.OPERATIONAL && $2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                // Upstream-aligned: prefer the async enrichment path when available.
                if (Tracking._shouldUsePromise()) {
                    Tracking.enrichEventDataPromise(data).then(function(enriched) {
                        try {
                            Tracking._trackEvent(event, enriched, type);
                        } catch (e) {
                            console.warn("enrich Event + tracking._trackEvent invocation failed", e);
                        }
                    }, function(e) {
                        console.warn("enrich Event + tracking._trackEvent invocation failed", e);
                    });
                    return;
                }
                try {
                    data = Tracking.enrichEventData(data);
                    Tracking._trackEvent(event, data, type);
                } catch (e) {
                    console.warn("enrich Event + tracking._trackEvent invocation failed", e);
                }
            }
        },
        {
            key: "_trackEvent",
            value: function _trackEvent(event, enrichedData, type) {
                switch(type){
                    case $02dcaeca70bf20a9$exports.eventType.SCREEN:
                        $17b2e0e0478a2ce8$exports.GASv3.sendScreenEvent(event, enrichedData);
                        break;
                    case $02dcaeca70bf20a9$exports.eventType.TRACK:
                        $17b2e0e0478a2ce8$exports.GASv3.sendTrackEvent(event, enrichedData);
                        break;
                    case $02dcaeca70bf20a9$exports.eventType.OPERATIONAL:
                        $17b2e0e0478a2ce8$exports.GASv3.sendOperationalEvent(event, enrichedData);
                        break;
                    case $02dcaeca70bf20a9$exports.eventType.UI:
                    default:
                        $17b2e0e0478a2ce8$exports.GASv3.sendUIEvent(event, enrichedData);
                        break;
                }
            }
        },
        {
            key: "_shouldUsePromise",
            value: function _shouldUsePromise() {
                return Tracking._browserSupportsPromises() && Tracking._userOptedOutOfTrackingCookies();
            }
        },
        {
            key: "_browserSupportsPromises",
            value: function _browserSupportsPromises() {
                return typeof Promise !== "undefined";
            }
        },
        {
            key: "_userOptedOutOfTrackingCookies",
            value: function _userOptedOutOfTrackingCookies() {
                return false;
            }
        },
        {
            key: "enrichEventDataPromise",
            value: function enrichEventDataPromise(data) {
                return Promise.resolve(Tracking.enrichEventData(data));
            }
        },
        {
            key: "pageView",
            value: function pageView(pageViewProperties) {
                // Upstream-aligned: prefer the async enrichment path when available so we
                // can wait on identity hydration (marketo id) before firing. Falls back to
                // the synchronous path. Both paths converge on `_pageView()` for the
                // cookie-compliance / requested_page logic. Mirrors atl-analytics
                // _pageView at:
                // https://bitbucket.org/atlassian/atl-analytics/src/master/src/analytics/js/atl-events.js#lines-158
                if (Tracking._shouldUsePromise()) {
                    Tracking.enrichEventDataPromise(pageViewProperties).then(function(enriched) {
                        try {
                            Tracking._pageView(enriched);
                        } catch (e) {
                            console.warn("enrich Event + tracking._pageView invocation failed", e);
                        }
                    }, function(e) {
                        console.warn("enrich Event + tracking._pageView invocation failed", e);
                    });
                    return;
                }
                try {
                    pageViewProperties = Tracking.enrichEventData(pageViewProperties);
                    Tracking._pageView(pageViewProperties);
                } catch (e) {
                    console.warn("enrich Event + tracking._pageView invocation failed", e);
                }
            }
        },
        {
            key: "_pageView",
            value: function _pageView(enrichedPageViewProperties) {
                enrichedPageViewProperties.wrapperName = "atl-global";
                enrichedPageViewProperties.destinationFlag = "gasv3";
                if (window.cmsPageVariant) enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
                // ALWAYS fire the `requested_page` operational event regardless of consent
                // state. Operational events are strictly-necessary for page-lifecycle
                // observability and are exempt from C0002 (Performance) consent. The event
                // carries `sn_id` (24h cookie) and `atl_first_visit` (localStorage) as
                // strictly-necessary identifiers. Mirrors upstream atl-analytics _pageView():
                // https://bitbucket.org/atlassian/atl-analytics/src/master/src/analytics/js/atl-events.js#lines-169
                //
                // Note: `gasv3.sendOperationalEvent()` automatically sets
                // `data.excludedProperties` (anonymousId, authenticatedUserId, userId, xid)
                // when `CookieCompliance.optedOut === true` so the operational event does
                // not leak cross-product identifiers when the user has not consented.
                enrichedPageViewProperties.sn_id = $2ac1d0168768b0b1$exports.CookieCompliance.snId;
                enrichedPageViewProperties.atl_first_visit = $2ac1d0168768b0b1$exports.CookieCompliance.atlFirstVisit;
                // analytics-web-client requires `action` + `actionSubject` on operational
                // events (it throws "Missing event.actionSubject" otherwise). The page-view
                // operational event describes "a page was requested", so use the standard
                // page/requested subject+action pair.
                enrichedPageViewProperties.actionSubject = "page";
                enrichedPageViewProperties.action = "requested";
                $17b2e0e0478a2ce8$exports.GASv3.sendOperationalEvent("requested_page", enrichedPageViewProperties, true);
                // When the user HAS consented to performance cookies, also fire the
                // non-operational screen + GTM page events on top of the operational one.
                // When opted out, these are suppressed (gasv3.sendScreenEvent has its own
                // optOutPerfTracking gate, but we short-circuit explicitly here for clarity).
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                $89d199d6317f68be$exports.Gtm.page(null, null, enrichedPageViewProperties);
                $17b2e0e0478a2ce8$exports.GASv3.sendScreenEvent(null, enrichedPageViewProperties);
            }
        },
        {
            key: "getPageViewId",
            value: function getPageViewId() {
                if (!Tracking.pageViewId) Tracking.pageViewId = $dd4d4cd8f6ef082a$exports.Guid.guid();
                return Tracking.pageViewId;
            }
        },
        {
            key: "enrichEventData",
            value: function enrichEventData(data) {
                return Tracking._enrichEventData(data, $9d08699771426032$exports.Identity.getMarketoId());
            }
        },
        {
            key: "_enrichEventData",
            value: function _enrichEventData(inputData, marketoId) {
                var data = {};
                if ($51d4ec156e612ca7$var$_typeof(inputData) !== "object" || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== "undefined") data["data"] = dataValue;
                } else data = inputData;
                // if not already done, read the request Id cookie set by bxp-gateway
                if (!Tracking.bxpGatewayRequestId) Tracking.bxpGatewayRequestId = $f3ce5ca773e60031$exports.Cookie.readCookie("bxp_gateway_request_id");
                // Only set the property if the cookie was there and readCookie didn't return null
                if (Tracking.bxpGatewayRequestId) data["bxpGatewayRequestId"] = Tracking.bxpGatewayRequestId;
                data["pageViewId"] = Tracking.getPageViewId();
                // add identity data, if not present
                data["atlEventId"] = $dd4d4cd8f6ef082a$exports.Guid.guid();
                data["atlJSVersion"] = $686dafd5f57e3409$exports.AnalyticsState.version || "1.0.0";
                data["browserLanguages"] = navigator.languages;
                // add category, if not present
                data["category"] = data["category"] || (document.title !== "undefined" ? document.title.trim().replace(/\W+/g, "_") : "");
                // add the cohort to the object
                data[$9789bdfe9c957a15$exports.ATL_COHORT] = $9789bdfe9c957a15$exports.Cohort.readWriteAtlCohort();
                var utms = $686dafd5f57e3409$exports.AnalyticsState.utms;
                if (utms) data["campaign"] = {
                    name: utms["utm_campaign"],
                    medium: utms["utm_medium"],
                    source: utms["utm_source"],
                    content: utms["utm_content"],
                    term: utms["utm_term"]
                };
                data["clientSessionId"] = Tracking.readWriteSessionCookie();
                if (Tracking.xid) data["atlXid"] = Tracking.xid;
                data["marketoId"] = marketoId ? marketoId : "";
                return data;
            }
        },
        {
            key: "buildTrackEventProperties",
            value: function buildTrackEventProperties(el, dataset, label, href) {
                if (!dataset) return;
                var trackEventProperties = {
                    label: label,
                    href: href
                };
                if (el && el.nodeName === "BUTTON") {
                    var form = el.getAttribute("form");
                    if (form) trackEventProperties.form = form;
                }
                var expectedProperties = [
                    "actionSubjectId",
                    "eventContainer",
                    "eventColumn",
                    "eventComponent",
                    "uuid",
                    "event",
                    "inputValue",
                    "parentLabel",
                    "label",
                    "labelEnglish",
                    "productKey",
                    "productVersion",
                    "productEdition",
                    "productPlatform",
                    "schemaVersion",
                    "name"
                ];
                var isExpectedProperty = function isExpectedProperty(value) {
                    return expectedProperties.includes(value);
                };
                var dataSetEntries = [];
                for(var dataProperty in dataset)// eslint-disable-next-line no-prototype-builtins
                if (dataProperty !== "track-event" && dataset.hasOwnProperty(dataProperty)) {
                    var dataPropertyValue = dataset[dataProperty];
                    if (dataPropertyValue) {
                        if (isExpectedProperty(dataProperty)) trackEventProperties[dataProperty] = dataPropertyValue;
                        else {
                            var dataEntry = {};
                            dataEntry[dataProperty] = dataPropertyValue;
                            dataSetEntries.push(dataEntry);
                        }
                    }
                }
                trackEventProperties.dataSet = dataSetEntries;
                return trackEventProperties;
            }
        },
        {
            key: "_autoTrackClickEvent",
            value: function _autoTrackClickEvent(event) {
                try {
                    var currentTargetElem = event.currentTarget;
                    var targetElem = event.target;
                    var rawText = targetElem.textContent;
                    var isInput = function isInput(elem) {
                        return elem.tagName === "INPUT";
                    };
                    var isAnchor = function isAnchor(elem) {
                        return elem.hasAttribute("href");
                    };
                    var isSelect = function isSelect(elem) {
                        return elem.tagName === "SELECT";
                    };
                    // handle form buttons differently
                    if (isInput(targetElem)) // targetElem.value of an input text field is considered UGC and should not be tracked
                    rawText = targetElem.type === "text" ? "[REDACTED]" : targetElem.value !== "" ? targetElem.value : targetElem.textContent;
                    else if (isSelect(targetElem)) {
                        targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
                        rawText = targetElem.getAttribute("data-label") || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
                    } else if (rawText === "") {
                        var _targetElem$parentNod;
                        rawText = ((_targetElem$parentNod = targetElem.parentNode) === null || _targetElem$parentNod === void 0 ? void 0 : _targetElem$parentNod.textContent) || targetElem.title || targetElem.ariaLabel || targetElem.className;
                    }
                    var href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : "";
                    var trackEventName = targetElem.getAttribute("data-track-event") || currentTargetElem.getAttribute("data-track-event") || "Clicked-Auto-CTA";
                    var eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, "-") : "";
                    var trackEventProperties = Tracking.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
                    //@ts-ignore
                    Tracking.trackEvent(trackEventName, trackEventProperties);
                } catch (err) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking click event");
                }
            }
        },
        {
            key: "autoTrackSelects",
            value: function autoTrackSelects() {
                try {
                    var selects = Array.from(document.querySelectorAll("select"));
                    for(var _i = 0, _selects = selects; _i < _selects.length; _i++){
                        var select = _selects[_i];
                        if (!Tracking.isAutoTrackingDisabled(select)) {
                            select.removeEventListener("change", Tracking._autoTrackClickEvent);
                            select.addEventListener("change", Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking select event");
                }
            }
        },
        {
            key: "autoTrackButtons",
            value: function autoTrackButtons(trackAll) {
                try {
                    var selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
                    var btns = Array.from(document.querySelectorAll(selector));
                    for(var _i2 = 0, _btns = btns; _i2 < _btns.length; _i2++){
                        var btn = _btns[_i2];
                        if (!Tracking.isAutoTrackingDisabled(btn)) {
                            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                            btn.removeEventListener("click", Tracking._autoTrackClickEvent);
                            // add an event listener
                            btn.addEventListener("click", Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking button event");
                }
            }
        },
        {
            key: "autoTrackLinks",
            value: function autoTrackLinks(trackAll) {
                try {
                    var links = [], selector = trackAll ? "a, .external-link" : "a[class*='button'], a[class*='btn'], .external-link", btnyLinks = Array.from(document.querySelectorAll(selector));
                    for(var _i3 = 0, _btnyLinks = btnyLinks; _i3 < _btnyLinks.length; _i3++){
                        var el = _btnyLinks[_i3];
                        var htmlEl = el;
                        if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes("cta") || el.className.includes("external-link")) links.push(el);
                    }
                    for(var _i4 = 0, _links = links; _i4 < _links.length; _i4++){
                        var link = _links[_i4];
                        if (!Tracking.isAutoTrackingDisabled(link)) {
                            link.removeEventListener("click", Tracking._autoTrackClickEvent);
                            link.addEventListener("click", Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking link event");
                }
            }
        },
        {
            key: "_autoTrackVideoEvent",
            value: function _autoTrackVideoEvent(element, eventName) {
                try {
                    var _element$parentElemen;
                    var className = typeof element.className !== "undefined" ? element.className : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : _element$parentElemen.className, eventLabel = typeof element.textContent !== "undefined" ? element.textContent : "", eventCategory = typeof document.title !== "undefined" ? document.title.replace(/\W+/g, "_").trim() : "";
                    Tracking.trackEvent(eventName, {
                        className: className,
                        category: eventCategory,
                        label: eventLabel,
                        _sio: $f3ce5ca773e60031$exports.Cookie.readCookie("_sio") || "",
                        _atl_path: $f3ce5ca773e60031$exports.Cookie.readCookie("__atl_path") || ""
                    });
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking video event");
                }
            }
        },
        {
            key: "autoTrackVideos",
            value: function autoTrackVideos() {
                try {
                    var videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
                    var videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
                    var trackVideoOpenEvent = function trackVideoOpenEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, "Opened Video");
                    };
                    var trackVideoCloseEvent = function trackVideoCloseEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, "Closed Video");
                    };
                    for(var _i5 = 0, _videoOpenLinks = videoOpenLinks; _i5 < _videoOpenLinks.length; _i5++){
                        var videoOpenLink = _videoOpenLinks[_i5];
                        videoOpenLink.removeEventListener("click", trackVideoOpenEvent);
                        videoOpenLink.addEventListener("click", trackVideoOpenEvent);
                    }
                    for(var _i6 = 0, _videoCloseLinks = videoCloseLinks; _i6 < _videoCloseLinks.length; _i6++){
                        var videoCloseLink = _videoCloseLinks[_i6];
                        videoCloseLink.removeEventListener("click", trackVideoCloseEvent);
                        videoCloseLink.addEventListener("click", trackVideoCloseEvent);
                    }
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking video event");
                }
            }
        },
        {
            key: "autoTrackTabs",
            value: function autoTrackTabs() {
                try {
                    var selector = "[role='tab']";
                    var tabs = Array.from(document.querySelectorAll(selector));
                    for(var _i7 = 0, _tabs = tabs; _i7 < _tabs.length; _i7++){
                        var tab = _tabs[_i7];
                        if (!Tracking.isAutoTrackingDisabled(tab)) {
                            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                            tab.removeEventListener("select", Tracking._autoTrackClickEvent);
                            // add an event listener
                            tab.addEventListener("select", Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error auto-tracking tab event");
                }
            }
        },
        {
            key: "isAutoTrackingDisabled",
            value: function isAutoTrackingDisabled(element) {
                return element.classList.contains("doNotAutoTrack");
            }
        },
        {
            key: "readWriteSessionCookie",
            value: function readWriteSessionCookie() {
                var cookie = $f3ce5ca773e60031$exports.Cookie.readCookie("atl_session");
                var name = "atl_session";
                var value = cookie || $dd4d4cd8f6ef082a$exports.Guid.guid();
                var seconds = 1800;
                if ($f3ce5ca773e60031$exports.Cookie.writeCookieInSeconds) $f3ce5ca773e60031$exports.Cookie.writeCookieInSeconds(name, value, seconds);
                return value;
            }
        }
    ]);
}();


function $9d08699771426032$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9d08699771426032$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9d08699771426032$var$_typeof(o);
}
function $9d08699771426032$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $9d08699771426032$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9d08699771426032$var$_toPropertyKey(o.key), o);
    }
}
function $9d08699771426032$var$_createClass(e, r, t) {
    return r && $9d08699771426032$var$_defineProperties(e.prototype, r), t && $9d08699771426032$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9d08699771426032$var$_toPropertyKey(t) {
    var i = $9d08699771426032$var$_toPrimitive(t, "string");
    return "symbol" == $9d08699771426032$var$_typeof(i) ? i : i + "";
}
function $9d08699771426032$var$_toPrimitive(t, r) {
    if ("object" != $9d08699771426032$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9d08699771426032$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9d08699771426032$var$TRELLO_USER_ID = "token";
var $9d08699771426032$var$XID = "seg_xid";
var $9d08699771426032$var$pageViewProperties = {};
// cookie used by Marketo to track interactions, allows a website to link visitor behavior across sites and campaigns
var $9d08699771426032$var$MARKETO_ID = "_mkto_trk";
var $9d08699771426032$var$REFERRER_TRELLO_DOMAINS = [
    "trello.com",
    "trellis.coffee"
];
var $9d08699771426032$var$Identity = $9d08699771426032$exports.Identity = /*#__PURE__*/ function() {
    function Identity() {
        $9d08699771426032$var$_classCallCheck(this, Identity);
    }
    return $9d08699771426032$var$_createClass(Identity, null, [
        {
            key: "identify",
            value: /**
     * Sends a track event with known identifiers
     * @function identify
     * @param {string} userId - required
     * @param {object} traits - optional, dictionary of custom traits to send
     */ function identify(userId, traits) {
                traits = !!traits && $9d08699771426032$var$_typeof(traits) === "object" ? traits : {};
                var data = traits;
                data["atlassian_id"] = userId;
                data["atlJSVersion"] = $686dafd5f57e3409$exports.AnalyticsState.version || "1.0.0";
                try {
                    data["ga_clientid"] = $f3ce5ca773e60031$exports.Cookie.readCookie("_ga");
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error reading _ga cookie");
                }
                $51d4ec156e612ca7$exports.Tracking.trackEvent("known_identifiers", data);
            }
        },
        {
            key: "autoIdentify",
            value: function autoIdentify() {
                var emailDetected = $7ed41b2ce96d3996$exports.Helpers.emailAddressIsDetected();
                var userId = Identity.getAtlassianUserId();
                var xid = $f3ce5ca773e60031$exports.Cookie.readCookie($9d08699771426032$var$XID);
                if (emailDetected) {
                    var integrations = {
                        All: false,
                        "Google Analytics": true
                    };
                    if (!$686dafd5f57e3409$exports.AnalyticsState.pageViewOptions) $686dafd5f57e3409$exports.AnalyticsState.pageViewOptions = {
                        integrations: integrations
                    };
                    else $686dafd5f57e3409$exports.AnalyticsState.pageViewOptions["integrations"] = integrations;
                    if ($7ed41b2ce96d3996$exports.Helpers.urlContainsEmail(window.location.href)) $7ed41b2ce96d3996$exports.Helpers.addCleanedUrlAndPaths($9d08699771426032$var$pageViewProperties);
                    if ($7ed41b2ce96d3996$exports.Helpers.urlContainsEmail(document.referrer)) $7ed41b2ce96d3996$exports.Helpers.addCleanedReferrer($9d08699771426032$var$pageViewProperties);
                }
                try {
                    $9d08699771426032$var$pageViewProperties["anonymous_id"] = $686dafd5f57e3409$exports.AnalyticsState.anonymousId;
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error reading segment anonymousId");
                }
                try {
                    $9d08699771426032$var$pageViewProperties[$9789bdfe9c957a15$exports.ATL_COHORT] = $9789bdfe9c957a15$exports.Cohort.readWriteAtlCohort();
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error read / writing atlCohort cookie");
                }
                if (userId || xid) Identity.identify(userId, $9d08699771426032$var$pageViewProperties);
            }
        },
        {
            key: "getAtlassianUserId",
            value: function getAtlassianUserId() {
                var userId = $f3ce5ca773e60031$exports.Cookie.readCookie("__aid_user_id");
                if (userId) return decodeURIComponent(userId);
                return null;
            }
        },
        {
            key: "getTrelloUserId",
            value: function getTrelloUserId() {
                try {
                    var page = location.href ? new URL(location.href) : null;
                    // since the trello cookie is such a common name. check to make sure we're actually on a trello page
                    if (page && (page.hostname.includes("trello.com") || page.hostname.includes("trellis.coffee"))) {
                        var token = $f3ce5ca773e60031$exports.Cookie.readCookie($9d08699771426032$var$TRELLO_USER_ID);
                        if (token) return decodeURIComponent(token).split("/")[0];
                    }
                } catch (e) {
                    $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("Error reading Trello userId");
                }
                return null;
            }
        },
        {
            key: "getMarketoId",
            value: function getMarketoId() {
                var marketoId = $f3ce5ca773e60031$exports.Cookie.readCookie($9d08699771426032$var$MARKETO_ID);
                if (marketoId) return decodeURIComponent(marketoId);
                return null;
            }
        },
        {
            key: "getMarketoIdPromise",
            value: function getMarketoIdPromise() {
                var enableRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var waitCount = 0;
                var maxWait = enableRetry ? 5000 : 0;
                return new Promise(function(resolve) {
                    Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                });
            }
        },
        {
            key: "_internalMarketoPromise",
            value: function _internalMarketoPromise(waitCount, maxWait, resolve) {
                var delay = 500;
                var marketoId = $f3ce5ca773e60031$exports.Cookie.readCookie($9d08699771426032$var$MARKETO_ID);
                // wait for up to 5 seconds for the marketo cookie to show up
                if (marketoId) resolve(decodeURIComponent(marketoId));
                else {
                    waitCount += delay;
                    if (waitCount >= maxWait) {
                        $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("getMarketoIdPromise error");
                        resolve("");
                    } else if (typeof setTimeout === "function") setTimeout(function() {
                        Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                    }, delay);
                    else {
                        // handle the case where setTimeout is not a function
                        $7ed41b2ce96d3996$exports.Helpers.sendWrapperLoadError("getMarketoIdPromise error - setTimeout is not a function");
                        resolve("");
                    }
                }
            }
        },
        {
            key: "isReferrerTrello",
            value: function isReferrerTrello() {
                if (!document.referrer) return false;
                var ref = new URL(document.referrer);
                return $9d08699771426032$var$REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
            }
        }
    ]);
}();



var $4599fe60e8c57108$exports = {};
"use strict";
Object.defineProperty($4599fe60e8c57108$exports, "__esModule", {
    value: true
});
Object.defineProperty($4599fe60e8c57108$exports, "AnalyticsWebClient", {
    enumerable: true,
    get: function get() {
        return $4599fe60e8c57108$var$_analyticsWebClient["default"];
    }
});
$4599fe60e8c57108$exports.CommunityAnalyticsClient = void 0;

var $4599fe60e8c57108$var$_analyticsWebClient = $4599fe60e8c57108$var$_interopRequireWildcard((parcelRequire("jj25f")));


var $8fdc6f047d3223fd$exports = {};
"use strict";
Object.defineProperty($8fdc6f047d3223fd$exports, "__esModule", {
    value: true
});
$8fdc6f047d3223fd$exports.Initializer = void 0;





var $5232ad6c80b6caf6$exports = {};
"use strict";
Object.defineProperty($5232ad6c80b6caf6$exports, "__esModule", {
    value: true
});
$5232ad6c80b6caf6$exports.Metrics = $5232ad6c80b6caf6$exports.MetricKey = void 0;





function $5232ad6c80b6caf6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5232ad6c80b6caf6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5232ad6c80b6caf6$var$_typeof(o);
}
function $5232ad6c80b6caf6$var$_slicedToArray(r, e) {
    return $5232ad6c80b6caf6$var$_arrayWithHoles(r) || $5232ad6c80b6caf6$var$_iterableToArrayLimit(r, e) || $5232ad6c80b6caf6$var$_unsupportedIterableToArray(r, e) || $5232ad6c80b6caf6$var$_nonIterableRest();
}
function $5232ad6c80b6caf6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5232ad6c80b6caf6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5232ad6c80b6caf6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5232ad6c80b6caf6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5232ad6c80b6caf6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5232ad6c80b6caf6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5232ad6c80b6caf6$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $5232ad6c80b6caf6$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $5232ad6c80b6caf6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5232ad6c80b6caf6$var$_toPropertyKey(o.key), o);
    }
}
function $5232ad6c80b6caf6$var$_createClass(e, r, t) {
    return r && $5232ad6c80b6caf6$var$_defineProperties(e.prototype, r), t && $5232ad6c80b6caf6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $5232ad6c80b6caf6$var$_defineProperty(e, r, t) {
    return (r = $5232ad6c80b6caf6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5232ad6c80b6caf6$var$_toPropertyKey(t) {
    var i = $5232ad6c80b6caf6$var$_toPrimitive(t, "string");
    return "symbol" == $5232ad6c80b6caf6$var$_typeof(i) ? i : i + "";
}
function $5232ad6c80b6caf6$var$_toPrimitive(t, r) {
    if ("object" != $5232ad6c80b6caf6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5232ad6c80b6caf6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Module for segment metrics tracking events.
 * @module Metrics
 */ 
var $5232ad6c80b6caf6$var$MetricKey = $5232ad6c80b6caf6$exports.MetricKey = /*#__PURE__*/ function(MetricKey) {
    MetricKey["TIME_TO_LOAD"] = "timeToLoad";
    MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
    MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
    MetricKey["TIME_TO_READY"] = "timeToReady";
    MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
    MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
    MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
    return MetricKey;
}({});
var $5232ad6c80b6caf6$var$Metrics = $5232ad6c80b6caf6$exports.Metrics = /*#__PURE__*/ function() {
    function Metrics() {
        $5232ad6c80b6caf6$var$_classCallCheck(this, Metrics);
    }
    return $5232ad6c80b6caf6$var$_createClass(Metrics, null, [
        {
            key: "logMetric",
            value: /**
     * Store the value of a single performance metric
     * @function logMetrics
     * @param {MetricKey} metricKey - the metric to log
     * @param {number} mockDate - a mock timestamp
     */ function logMetric(metricKey, mockDate) {
                Metrics.metricsData[metricKey] = mockDate || Date.now();
            }
        },
        {
            key: "setLoadTimestamp",
            value: function setLoadTimestamp(loadTimestamp) {
                Metrics.loadTimestamp = loadTimestamp;
            }
        },
        {
            key: "sendMetrics",
            value: function sendMetrics(mockReq) {
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
                var loadTimestamp = Metrics.loadTimestamp;
                if (!loadTimestamp) return;
                // calculate all of the times
                Object.entries(Metrics.metricsData).forEach(function(_ref) {
                    var _ref2 = $5232ad6c80b6caf6$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    if (value > 0) // Todo .. should this be > loadTimestamp ??
                    Metrics.metricsData[key] = value - loadTimestamp;
                });
                var cohort = $9789bdfe9c957a15$exports.Cohort.readAtlCohort();
                var properties = {
                    action: "metrics",
                    actionSubject: "atlGlobal",
                    metrics: Metrics.metricsData,
                    atlJSVersion: $686dafd5f57e3409$exports.AnalyticsState.version,
                    cohort: cohort ? cohort.bucketAll.index : null,
                    host: mockReq ? mockReq.hostFake : window.location.host,
                    path: mockReq ? mockReq.pathFake : window.location.pathname,
                    pageViewId: $51d4ec156e612ca7$exports.Tracking.getPageViewId() // used to tie to other events
                };
                $17b2e0e0478a2ce8$exports.GASv3.sendUIEvent("", properties, true);
                Metrics.resetMetrics();
            }
        },
        {
            key: "resetMetrics",
            value: function resetMetrics() {
                Metrics.metricsData = {};
            }
        }
    ]);
}();
$5232ad6c80b6caf6$var$_defineProperty($5232ad6c80b6caf6$var$Metrics, "metricsData", {});



function $8fdc6f047d3223fd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fdc6f047d3223fd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fdc6f047d3223fd$var$_typeof(o);
}
function $8fdc6f047d3223fd$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $8fdc6f047d3223fd$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $8fdc6f047d3223fd$var$_toPropertyKey(o.key), o);
    }
}
function $8fdc6f047d3223fd$var$_createClass(e, r, t) {
    return r && $8fdc6f047d3223fd$var$_defineProperties(e.prototype, r), t && $8fdc6f047d3223fd$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $8fdc6f047d3223fd$var$_toPropertyKey(t) {
    var i = $8fdc6f047d3223fd$var$_toPrimitive(t, "string");
    return "symbol" == $8fdc6f047d3223fd$var$_typeof(i) ? i : i + "";
}
function $8fdc6f047d3223fd$var$_toPrimitive(t, r) {
    if ("object" != $8fdc6f047d3223fd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8fdc6f047d3223fd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Module for initializing the wrapper.
 * @module Initializer
 */ var $8fdc6f047d3223fd$var$Initializer = $8fdc6f047d3223fd$exports.Initializer = /*#__PURE__*/ function() {
    function Initializer() {
        $8fdc6f047d3223fd$var$_classCallCheck(this, Initializer);
    }
    return $8fdc6f047d3223fd$var$_createClass(Initializer, null, [
        {
            key: "initWithPageAnalytics",
            value: /**
     * Initializes auto-tracking and page view tracking.
     * @function initWithPageAnalytics
     * @param {string} writeKey - required, historically used as Segment.io key, now just sent as a property (not sure if used, but keep sending it)
     * @param {object} pageViewProperties - optional, dictionary of properties of the page
     * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
     * @param {string} anonymousId - GASv3 analytics client anonymous id
     * @param {function} createAnalyticsEvent - analytics-next CreateUIAnalyticsEvent
     */ function initWithPageAnalytics(writeKey) {
                var pageViewProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var loadTimestamp = arguments.length > 2 ? arguments[2] : undefined;
                var anonymousId = arguments.length > 3 ? arguments[3] : undefined;
                var createAnalyticsEvent = arguments.length > 4 ? arguments[4] : undefined;
                $686dafd5f57e3409$exports.AnalyticsState.anonymousId = anonymousId;
                $686dafd5f57e3409$exports.AnalyticsState.createAnalyticsEvent = createAnalyticsEvent;
                // set load timestamp for calculating metrics
                $5232ad6c80b6caf6$exports.Metrics.setLoadTimestamp(loadTimestamp);
                Initializer.captureUTMs();
                // adding marketing boolean if current product comes under marketing domain
                Initializer.setIsMarketingEvent(pageViewProperties);
                // store params for later reporting if necessary.
                $686dafd5f57e3409$exports.AnalyticsState.writeKey = writeKey;
                $7ed41b2ce96d3996$exports.Helpers.addActualUrl(pageViewProperties);
                // When the user has not consented to performance cookies and
                // the kill-switch FeatureGate is on, fire only the strictly-necessary operational path.
                // Skips GTM, Segment (already absent in this fork), Snowplow (idem), auto-tracking, and
                // GA integration. The library still fires the `requested_page` operational event with
                // the strictly-necessary `sn_id` + `atl_first_visit` payload via Tracking.pageView.
                if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) {
                    $2ac1d0168768b0b1$exports.CookieCompliance.setSnIdAndAtlFirstVisit(pageViewProperties);
                    $2ac1d0168768b0b1$exports.CookieCompliance._listenForActiveGroupsChange();
                    $51d4ec156e612ca7$exports.Tracking.pageView(pageViewProperties);
                    Initializer.globalCallReady();
                    return;
                }
                // Full (consented) init path — load GTM, fire normal page view, set up auto-tracking.
                // TODO: Switch these params to dynamically config based on writeKey
                $89d199d6317f68be$exports.Gtm.initialize(writeKey);
                $51d4ec156e612ca7$exports.Tracking.pageView(pageViewProperties);
                Initializer.autoTrack();
                Initializer.gaIntegration();
                Initializer.globalCallReady();
            }
        },
        {
            key: "globalCallReady",
            value: function globalCallReady() {
                if (typeof window.analyticsPageReady === "function") window.analyticsPageReady();
                $5232ad6c80b6caf6$exports.Metrics.logMetric($5232ad6c80b6caf6$exports.MetricKey.TIME_TO_READY);
                $5232ad6c80b6caf6$exports.Metrics.sendMetrics();
            }
        },
        {
            key: "captureUTMs",
            value: function captureUTMs() {
                var utmKeys = {
                    utm_campaign: "",
                    utm_medium: "",
                    utm_source: "",
                    utm_content: "",
                    utm_term: ""
                };
                $686dafd5f57e3409$exports.AnalyticsState.utms = $7ed41b2ce96d3996$exports.Helpers.getUtms(utmKeys);
            }
        },
        {
            key: "autoTrack",
            value: function autoTrack() {
                $51d4ec156e612ca7$exports.Tracking.autoTrackButtons(true);
                $51d4ec156e612ca7$exports.Tracking.autoTrackLinks(true);
                $51d4ec156e612ca7$exports.Tracking.autoTrackVideos();
                $51d4ec156e612ca7$exports.Tracking.autoTrackSelects();
                $51d4ec156e612ca7$exports.Tracking.autoTrackTabs();
            }
        },
        {
            key: "gaIntegration",
            value: function gaIntegration() {
                var emailDetected = $7ed41b2ce96d3996$exports.Helpers.emailAddressIsDetected();
                var pathOverride = "/path-contained-email-address";
                if (typeof window.ga !== "undefined") {
                    window.ga("require", "linker");
                    window.ga("linker:autoLink", [
                        "atlassian.com",
                        "bitbucket.org",
                        "hipchat.com",
                        "attendease.com",
                        "get.atlassian.com",
                        "eegeventsite.secure.force.com",
                        "atlassian.swoogo.com"
                    ]);
                    if (emailDetected) {
                        // only override what is needed
                        if ($7ed41b2ce96d3996$exports.Helpers.urlContainsEmail(window.location.href)) {
                            window.ga("set", "location", window.location.origin + pathOverride);
                            window.ga("set", "path", pathOverride);
                        }
                        if ($7ed41b2ce96d3996$exports.Helpers.urlContainsEmail(document.referrer)) window.ga("set", "referrer", $7ed41b2ce96d3996$exports.Helpers.hostnameFromUrl(document.referrer) + pathOverride);
                    }
                }
            }
        },
        {
            key: "setIsMarketingEvent",
            value: function setIsMarketingEvent(pageViewProperties) {
                if (typeof pageViewProperties["isMarketingEvent"] !== "boolean") $17b2e0e0478a2ce8$exports.GASv3.isMarketingEvent = true;
                else $17b2e0e0478a2ce8$exports.GASv3.isMarketingEvent = pageViewProperties["isMarketingEvent"];
            }
        },
        {
            key: "setXID",
            value: function setXID(xid) {
                $51d4ec156e612ca7$exports.Tracking.xid = xid;
            }
        }
    ]);
}();






function $4599fe60e8c57108$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4599fe60e8c57108$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4599fe60e8c57108$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $4599fe60e8c57108$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4599fe60e8c57108$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4599fe60e8c57108$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4599fe60e8c57108$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4599fe60e8c57108$var$_typeof(o);
}
function $4599fe60e8c57108$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4599fe60e8c57108$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4599fe60e8c57108$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4599fe60e8c57108$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4599fe60e8c57108$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4599fe60e8c57108$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $4599fe60e8c57108$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $4599fe60e8c57108$var$_toPropertyKey(o.key), o);
    }
}
function $4599fe60e8c57108$var$_createClass(e, r, t) {
    return r && $4599fe60e8c57108$var$_defineProperties(e.prototype, r), t && $4599fe60e8c57108$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $4599fe60e8c57108$var$_defineProperty(e, r, t) {
    return (r = $4599fe60e8c57108$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4599fe60e8c57108$var$_toPropertyKey(t) {
    var i = $4599fe60e8c57108$var$_toPrimitive(t, "string");
    return "symbol" == $4599fe60e8c57108$var$_typeof(i) ? i : i + "";
}
function $4599fe60e8c57108$var$_toPrimitive(t, r) {
    if ("object" != $4599fe60e8c57108$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4599fe60e8c57108$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Service to interact with analytics client, send GASv3 events
 */ 
var $4599fe60e8c57108$var$CommunityAnalyticsClient = $4599fe60e8c57108$exports.CommunityAnalyticsClient = /*#__PURE__*/ function() {
    function CommunityAnalyticsClient() {
        $4599fe60e8c57108$var$_classCallCheck(this, CommunityAnalyticsClient);
    }
    return $4599fe60e8c57108$var$_createClass(CommunityAnalyticsClient, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (typeof window !== "undefined") {
                    var settings = $4599fe60e8c57108$var$_objectSpread({
                        useStargate: (0, $5827f444065c0e59$exports.shouldUseStargate)(this.clientEnvironment),
                        xidConsent: true,
                        xidPromiseFn: function xidPromiseFn() {
                            return new $e5a7ccf3ca9852d5$exports.XID((0, $5827f444065c0e59$exports.getXidEnvironment)(_this.clientEnvironment)).getXidCallbackForPromise();
                        }
                    }, this.clientSettings);
                    return new $4599fe60e8c57108$var$_analyticsWebClient["default"]({
                        env: (0, $5827f444065c0e59$exports.getGASv3Environment)(this.clientEnvironment),
                        product: this.PRODUCT,
                        version: "1.0.0",
                        locale: "en-us"
                    }, settings);
                }
                throw new Error("window is not defined");
            }
        },
        {
            key: "initializeClient",
            value: function initializeClient(communitySubApp, settings, environment) {
                var userId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var writeKey = (0, $5827f444065c0e59$exports.getAnalyticsWriteKey)(this.clientEnvironment);
                this.writeKey = writeKey;
                this.clientSettings = settings;
                this.clientEnvironment = environment;
                this.analyticsClient = this.init();
                // set static analytics client instance on GASv3 class
                $17b2e0e0478a2ce8$exports.GASv3.client = this.analyticsClient;
                // If the consumer explicitly passes `null`, treat the session as anonymous and
                // skip the legacy identity-cookie hydration so a stale AAID can't leak into events.
                // Only fall back to Identity.getAtlassianUserId() when `userId` is omitted entirely.
                var clientUserId = userId === null ? null : userId !== null && userId !== void 0 ? userId : $9d08699771426032$exports.Identity.getAtlassianUserId();
                if (clientUserId) this.setAnalyticsUserInfo(clientUserId);
                else if (this.analyticsClient.clearUserInfo) // Defensive: ensure no stale userId persists on the underlying analytics-web-client instance.
                this.analyticsClient.clearUserInfo();
                // set global community attributes to be sent on each event
                $17b2e0e0478a2ce8$exports.GASv3.additionalEventData = this.getGlobalAttributes(communitySubApp);
                return this.analyticsClient;
            }
        },
        {
            key: "initWithPageAnalytics",
            value: function initWithPageAnalytics(communitySubApp, settings, environment) {
                var pageViewProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var userId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                if (!this.analyticsClient) this.analyticsClient = this.initializeClient(communitySubApp, settings, environment, userId);
                this.setUpPageAnalytics(pageViewProperties);
                return this.analyticsClient;
            }
        },
        {
            key: "setUpPageAnalytics",
            value: function setUpPageAnalytics() {
                var pageViewProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.analyticsClient) throw new Error("Initialize the analytics client before calling setUpPageAnalytics()");
                // set up auto-tracking for page views and other activity
                $8fdc6f047d3223fd$exports.Initializer.initWithPageAnalytics((0, $5827f444065c0e59$exports.getAnalyticsWriteKey)(this.clientEnvironment), $4599fe60e8c57108$var$deepClone(pageViewProperties), Date.now(), this.analyticsClient.getAnonymousId(), null // createAnalyticsEvent only needed for analytics-next
                );
            }
        },
        {
            key: "sendPageView",
            value: function sendPageView() {
                var pageViewProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.analyticsClient) // No client yet (init in flight / SSR) — nothing to fire. Callers fire the
                // entry page view via init; route-change calls before init are no-ops.
                return;
                $51d4ec156e612ca7$exports.Tracking.pageView(pageViewProperties);
            }
        },
        {
            key: "hasAnalyticsClient",
            value: function hasAnalyticsClient() {
                return !!this.analyticsClient;
            }
        },
        {
            key: "getAnalyticsClient",
            value: function getAnalyticsClient() {
                return this.analyticsClient;
            }
        },
        {
            key: "setAnalyticsUserInfo",
            value: function setAnalyticsUserInfo(userId) {
                if (userId && this.hasAnalyticsClient()) this.getAnalyticsClient().setUserInfo($4599fe60e8c57108$var$_analyticsWebClient.userType.ATLASSIAN_ACCOUNT, userId);
            }
        },
        {
            key: "sendEvent",
            value: function sendEvent() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $02dcaeca70bf20a9$exports.eventType.UI;
                var payload = arguments.length > 1 ? arguments[1] : undefined;
                if (this.isAnalyticsEnabled()) $51d4ec156e612ca7$exports.Tracking.trackEvent("", payload, type);
            }
        },
        {
            key: "getGlobalAttributes",
            value: function getGlobalAttributes(subApp) {
                return {
                    app: this.APP,
                    subApp: subApp
                };
            }
        }
    ]);
}();
/** Payload for eventType.UI and TRACK events
 * @property {string} action - action being performed
 * @property {string} actionSubject - subject of the action
 * @property {string} [actionSubjectId] - (optional) action subject id
 * @property {Record<string, string>} [attributes] - (optional) additional attributes
 * @property {string} [source] - source of the event, where (e.g. a screen) in the product
 */ $4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "PRODUCT", "marketing");
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "APP", "community");
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "SUB_APP", {
    HOME: "home",
    FORUMS: "forums",
    LEARNING: "learning",
    EVENTS: "events",
    UNIFIED_PORTABLE_PROFILE: "unified-portable-profile"
});
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "writeKey", null);
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "analyticsClient", null);
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "clientSettings", null);
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "clientEnvironment", null);
$4599fe60e8c57108$var$_defineProperty($4599fe60e8c57108$var$CommunityAnalyticsClient, "isAnalyticsEnabled", function() {
    return true;
});
/**
 * Payload for eventType.SCREEN events
 * @property {string} name - name of the screen being viewed
 * @property {Record<string, string>} [attributes] - additional attributes
 */ // type constrained to community sub-app string values (as defined by CommunityAnalyticsClient.SUB_APP)
var $4599fe60e8c57108$var$deepClone = function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};


function $f3d3ce17110e3c39$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f3d3ce17110e3c39$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f3d3ce17110e3c39$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $f3d3ce17110e3c39$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $f3d3ce17110e3c39$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f3d3ce17110e3c39$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f3d3ce17110e3c39$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f3d3ce17110e3c39$var$_typeof(o);
}
function $f3d3ce17110e3c39$var$_slicedToArray(r, e) {
    return $f3d3ce17110e3c39$var$_arrayWithHoles(r) || $f3d3ce17110e3c39$var$_iterableToArrayLimit(r, e) || $f3d3ce17110e3c39$var$_unsupportedIterableToArray(r, e) || $f3d3ce17110e3c39$var$_nonIterableRest();
}
function $f3d3ce17110e3c39$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f3d3ce17110e3c39$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f3d3ce17110e3c39$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f3d3ce17110e3c39$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f3d3ce17110e3c39$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f3d3ce17110e3c39$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f3d3ce17110e3c39$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $f3d3ce17110e3c39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3d3ce17110e3c39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3d3ce17110e3c39$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f3d3ce17110e3c39$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3d3ce17110e3c39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f3d3ce17110e3c39$var$_defineProperty(e, r, t) {
    return (r = $f3d3ce17110e3c39$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f3d3ce17110e3c39$var$_toPropertyKey(t) {
    var i = $f3d3ce17110e3c39$var$_toPrimitive(t, "string");
    return "symbol" == $f3d3ce17110e3c39$var$_typeof(i) ? i : i + "";
}
function $f3d3ce17110e3c39$var$_toPrimitive(t, r) {
    if ("object" != $f3d3ce17110e3c39$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f3d3ce17110e3c39$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * WARNING: Not yet ready for use, do not use - use the CommunityAnalyticsClient in analytics-client instead.
 *
 * This file contains the context and provider for the analytics client (@atlaskit/analytics-next pattern) - these React
 * components can be wrapped around the app to provide the analytics client to the rest of the application.
 */ 
var $f3d3ce17110e3c39$var$AnalyticsWebClientContext = $f3d3ce17110e3c39$exports.AnalyticsWebClientContext = /*#__PURE__*/ (0, $f3d3ce17110e3c39$var$_react.createContext)({
    analyticsWebClientInstance: null
});
/**
 * This listener component listens for analytics events and sends them to the analytics client (analytics-next pattern).
 */ var $f3d3ce17110e3c39$var$CommunityAnalyticsListener = $f3d3ce17110e3c39$exports.CommunityAnalyticsListener = function CommunityAnalyticsListener(_ref) {
    var children = _ref.children;
    var analyticsClient = $f3d3ce17110e3c39$var$useAnalyticsClient();
    var onEvent = (0, $f3d3ce17110e3c39$var$_react.useCallback)(function(event) {
        if (!analyticsClient) return;
        // Gate: suppress non-operational (UI/screen) events when the user has not
        // consented to OneTrust C0002 (Performance) cookies. Only operational events
        // are strictly-necessary and exempt from consent.
        if ($2ac1d0168768b0b1$exports.CookieCompliance.optOutPerfTracking()) return;
        // TODO: modify this?
        var processedEventPayload = $f3d3ce17110e3c39$var$_objectSpread($f3d3ce17110e3c39$var$_objectSpread({
            actionSubject: "component",
            eventType: "ui",
            source: "default"
        }, event.payload), {}, {
            attributes: $f3d3ce17110e3c39$var$_objectSpread({}, event.payload["attributes"] || {})
        });
        var ANALYTICS_TYPE = "console";
        if (ANALYTICS_TYPE === "console") {
            // eslint-disable-next-line
            console.log({
                event: processedEventPayload
            });
            analyticsClient.onEvent(null, processedEventPayload);
        } else analyticsClient.onEvent(null, processedEventPayload);
    }, [
        analyticsClient
    ]);
    return /*#__PURE__*/ $f3d3ce17110e3c39$var$_react["default"].createElement($f95e6fab44df17ad$export$2e2bcd8739ae039, {
        channel: "*",
        onEvent: onEvent
    }, children);
};
/**
 * This provider component initializes the analytics client and provides it to the rest of the application (analytics-next
 * pattern).
 * @param settings
 * @param environment
 * @param children
 * @constructor
 */ var $f3d3ce17110e3c39$var$CommunityAnalyticsClientProvider = $f3d3ce17110e3c39$exports.CommunityAnalyticsClientProvider = function CommunityAnalyticsClientProvider(_ref2) {
    var settings = _ref2.settings, environment = _ref2.environment, children = _ref2.children;
    var _useState = (0, $f3d3ce17110e3c39$var$_react.useState)(null), _useState2 = $f3d3ce17110e3c39$var$_slicedToArray(_useState, 2), analyticsWebClientInstance = _useState2[0], setAnalyticsWebClientInstance = _useState2[1];
    (0, $f3d3ce17110e3c39$var$_react.useEffect)(function() {
        if (typeof window !== "undefined") {
            // eslint-disable-next-line
            console.log("Initializing analytics client");
            $4599fe60e8c57108$exports.CommunityAnalyticsClient.clientSettings = settings;
            $4599fe60e8c57108$exports.CommunityAnalyticsClient.clientEnvironment = environment;
            var client = $4599fe60e8c57108$exports.CommunityAnalyticsClient.init();
            var aaid = $9d08699771426032$exports.Identity.getAtlassianUserId();
            if (aaid) client.setUserInfo($3emEs.userType.ATLASSIAN_ACCOUNT, aaid);
            setAnalyticsWebClientInstance(client);
        }
    }, []);
    return /*#__PURE__*/ $f3d3ce17110e3c39$var$_react["default"].createElement($f3d3ce17110e3c39$var$AnalyticsWebClientContext.Provider, {
        value: {
            analyticsWebClientInstance: analyticsWebClientInstance
        }
    }, children);
};
var $f3d3ce17110e3c39$var$useAnalyticsClient = $f3d3ce17110e3c39$exports.useAnalyticsClient = function useAnalyticsClient() {
    var context = (0, $f3d3ce17110e3c39$var$_react.useContext)($f3d3ce17110e3c39$var$AnalyticsWebClientContext);
    if (!context) throw new Error("calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!");
    return context.analyticsWebClientInstance;
};



var $9bd63f1974e4bdb4$var$deepClone = function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};
var $9bd63f1974e4bdb4$var$InitializeAutoAtlAnalyticsImpl = function InitializeAutoAtlAnalyticsImpl(_ref) {
    var _ref$pageViewProperti = _ref.pageViewProperties, pageViewProperties = _ref$pageViewProperti === void 0 ? {} : _ref$pageViewProperti, createAnalyticsEvent = _ref.createAnalyticsEvent;
    var analyticsClient = (0, $f3d3ce17110e3c39$exports.useAnalyticsClient)();
    var ANALYTICS_WRITE_KEY = "";
    (0, $acw62.useEffect)(function() {
        if (!analyticsClient) return;
        $8fdc6f047d3223fd$exports.Initializer.initWithPageAnalytics(ANALYTICS_WRITE_KEY, $9bd63f1974e4bdb4$var$deepClone(pageViewProperties), Date.now(), analyticsClient.getAnonymousId(), createAnalyticsEvent || null);
    }, [
        analyticsClient,
        ANALYTICS_WRITE_KEY,
        createAnalyticsEvent,
        pageViewProperties
    ]);
    return null;
};
var $9bd63f1974e4bdb4$var$InitializeAutoAtlAnalytics = $9bd63f1974e4bdb4$exports.InitializeAutoAtlAnalytics = (0, $3294956374cdc905$export$2e2bcd8739ae039)()($9bd63f1974e4bdb4$var$InitializeAutoAtlAnalyticsImpl);





Object.keys($2b01a2a8b07d1ffb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4921f5a45b3590cd$exports && $4921f5a45b3590cd$exports[key] === $2b01a2a8b07d1ffb$exports[key]) return;
    Object.defineProperty($4921f5a45b3590cd$exports, key, {
        enumerable: true,
        get: function get() {
            return $2b01a2a8b07d1ffb$exports[key];
        }
    });
});
var $5cc60536ca8d39ed$exports = {};
"use strict";
Object.defineProperty($5cc60536ca8d39ed$exports, "__esModule", {
    value: true
});

Object.keys($f3d3ce17110e3c39$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5cc60536ca8d39ed$exports && $5cc60536ca8d39ed$exports[key] === $f3d3ce17110e3c39$exports[key]) return;
    Object.defineProperty($5cc60536ca8d39ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $f3d3ce17110e3c39$exports[key];
        }
    });
});

Object.keys($4599fe60e8c57108$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5cc60536ca8d39ed$exports && $5cc60536ca8d39ed$exports[key] === $4599fe60e8c57108$exports[key]) return;
    Object.defineProperty($5cc60536ca8d39ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $4599fe60e8c57108$exports[key];
        }
    });
});

Object.keys($02dcaeca70bf20a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5cc60536ca8d39ed$exports && $5cc60536ca8d39ed$exports[key] === $02dcaeca70bf20a9$exports[key]) return;
    Object.defineProperty($5cc60536ca8d39ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $02dcaeca70bf20a9$exports[key];
        }
    });
});


Object.keys($5cc60536ca8d39ed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4921f5a45b3590cd$exports && $4921f5a45b3590cd$exports[key] === $5cc60536ca8d39ed$exports[key]) return;
    Object.defineProperty($4921f5a45b3590cd$exports, key, {
        enumerable: true,
        get: function get() {
            return $5cc60536ca8d39ed$exports[key];
        }
    });
});


Object.keys($4921f5a45b3590cd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $11903467dd03ded7$exports && $11903467dd03ded7$exports[key] === $4921f5a45b3590cd$exports[key]) return;
    Object.defineProperty($11903467dd03ded7$exports, key, {
        enumerable: true,
        get: function get() {
            return $4921f5a45b3590cd$exports[key];
        }
    });
});
var $73e66904c023c428$exports = {};
"use strict";
function $73e66904c023c428$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73e66904c023c428$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73e66904c023c428$var$_typeof(o);
}
Object.defineProperty($73e66904c023c428$exports, "__esModule", {
    value: true
});
$73e66904c023c428$exports.isUserInAllowList = $73e66904c023c428$exports.isUserAllowedForEaExperience = $73e66904c023c428$exports.getUserInfo = void 0;


function $73e66904c023c428$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $73e66904c023c428$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $73e66904c023c428$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($73e66904c023c428$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $73e66904c023c428$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $73e66904c023c428$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $73e66904c023c428$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $73e66904c023c428$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $73e66904c023c428$var$getUserInfo = $73e66904c023c428$exports.getUserInfo = /*#__PURE__*/ function() {
    var _ref = $73e66904c023c428$var$_asyncToGenerator(/*#__PURE__*/ $73e66904c023c428$var$_regeneratorRuntime().mark(function _callee() {
        var baseUrl, _responseBody$data, apiPath, response, responseBody, _args = arguments;
        return $73e66904c023c428$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
                    _context.prev = 1;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)();
                    _context.next = 5;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: $a31ec78ef2dbb035$exports.USER_INFO_QUERY,
                            operationName: "USER_INFO_QUERY"
                        })
                    });
                case 5:
                    response = _context.sent;
                    _context.next = 8;
                    return response.json();
                case 8:
                    responseBody = _context.sent;
                    return _context.abrupt("return", ((_responseBody$data = responseBody.data) === null || _responseBody$data === void 0 || (_responseBody$data = _responseBody$data.me) === null || _responseBody$data === void 0 ? void 0 : _responseBody$data.user) || null);
                case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](1);
                    return _context.abrupt("return", null);
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return function getUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var $73e66904c023c428$var$isUserInAllowList = $73e66904c023c428$exports.isUserInAllowList = /*#__PURE__*/ function() {
    var _ref2 = $73e66904c023c428$var$_asyncToGenerator(/*#__PURE__*/ $73e66904c023c428$var$_regeneratorRuntime().mark(function _callee2(emailId) {
        var baseUrl, _responseBody$data2, apiPath, response, responseBody, _args2 = arguments;
        return $73e66904c023c428$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";
                    if (emailId) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return", false);
                case 3:
                    _context2.prev = 3;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)();
                    _context2.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: (0, $a31ec78ef2dbb035$exports.getUserIsAllowedQuery)(emailId),
                            operationName: "USER_ALLOWED_QUERY"
                        })
                    });
                case 7:
                    response = _context2.sent;
                    _context2.next = 10;
                    return response.json();
                case 10:
                    responseBody = _context2.sent;
                    return _context2.abrupt("return", !!((_responseBody$data2 = responseBody.data) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.unified) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.gating) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.isEmailIdAllowed) !== null && _responseBody$data2 !== void 0 && _responseBody$data2.status));
                case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](3);
                    return _context2.abrupt("return", false);
                case 17:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function isUserInAllowList(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var $73e66904c023c428$var$isUserAllowedForEaExperience = $73e66904c023c428$exports.isUserAllowedForEaExperience = /*#__PURE__*/ function() {
    var _ref3 = $73e66904c023c428$var$_asyncToGenerator(/*#__PURE__*/ $73e66904c023c428$var$_regeneratorRuntime().mark(function _callee3() {
        var baseUrl, userInfo, _args3 = arguments;
        return $73e66904c023c428$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    baseUrl = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : "";
                    _context3.next = 3;
                    return $73e66904c023c428$var$getUserInfo(baseUrl);
                case 3:
                    userInfo = _context3.sent;
                    if (userInfo) {
                        _context3.next = 6;
                        break;
                    }
                    return _context3.abrupt("return", false);
                case 6:
                    _context3.next = 8;
                    return $73e66904c023c428$var$isUserInAllowList(userInfo.email);
                case 8:
                    return _context3.abrupt("return", _context3.sent);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function isUserAllowedForEaExperience() {
        return _ref3.apply(this, arguments);
    };
}();


Object.keys($73e66904c023c428$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $11903467dd03ded7$exports && $11903467dd03ded7$exports[key] === $73e66904c023c428$exports[key]) return;
    Object.defineProperty($11903467dd03ded7$exports, key, {
        enumerable: true,
        get: function get() {
            return $73e66904c023c428$exports[key];
        }
    });
});

Object.keys($8e221dc9235bf597$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $11903467dd03ded7$exports && $11903467dd03ded7$exports[key] === $8e221dc9235bf597$exports[key]) return;
    Object.defineProperty($11903467dd03ded7$exports, key, {
        enumerable: true,
        get: function get() {
            return $8e221dc9235bf597$exports[key];
        }
    });
});
var $ec4089d934924496$exports = {};
"use strict";
function $ec4089d934924496$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec4089d934924496$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec4089d934924496$var$_typeof(o);
}
Object.defineProperty($ec4089d934924496$exports, "__esModule", {
    value: true
});
$ec4089d934924496$exports.initializeCommunitybyAaid = $ec4089d934924496$exports.initializeCommunity = $ec4089d934924496$exports.getHlvCommunityForumsSignOutUrl = $ec4089d934924496$exports.getHlvCommunityForumsSignInUrl = $ec4089d934924496$exports.getCommunityLogoutUrl = $ec4089d934924496$exports.getCommunityLoginUrl = $ec4089d934924496$exports.getCommunityIdentityLogoutUrl = $ec4089d934924496$exports.getCommunityIdentityLoginUrl = void 0;


var $8883d5ac37340af9$exports = {};
"use strict";
Object.defineProperty($8883d5ac37340af9$exports, "__esModule", {
    value: true
});
$8883d5ac37340af9$exports.getLogoutUrl = $8883d5ac37340af9$exports.getLoginUrl = $8883d5ac37340af9$exports.getIdentityLogoutUrl = $8883d5ac37340af9$exports.getIdentityLoginUrl = $8883d5ac37340af9$exports.getHlvVanillaForumsSignOutUrl = $8883d5ac37340af9$exports.getHlvVanillaForumsSignInUrl = $8883d5ac37340af9$exports.getForumsSignOutUrl = $8883d5ac37340af9$exports.getForumsSignInUrl = $8883d5ac37340af9$exports.getAuthUrl = void 0;

function $8883d5ac37340af9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8883d5ac37340af9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8883d5ac37340af9$var$_typeof(o);
}
function $8883d5ac37340af9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8883d5ac37340af9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8883d5ac37340af9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8883d5ac37340af9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8883d5ac37340af9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8883d5ac37340af9$var$_defineProperty(e, r, t) {
    return (r = $8883d5ac37340af9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8883d5ac37340af9$var$_toPropertyKey(t) {
    var i = $8883d5ac37340af9$var$_toPrimitive(t, "string");
    return "symbol" == $8883d5ac37340af9$var$_typeof(i) ? i : i + "";
}
function $8883d5ac37340af9$var$_toPrimitive(t, r) {
    if ("object" != $8883d5ac37340af9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8883d5ac37340af9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8883d5ac37340af9$var$buildAuthQueryParams = function buildAuthQueryParams(urlType, _ref) {
    var email = _ref.email, redirectUrl = _ref.redirectUrl, prompt = _ref.prompt, _ref$experience = _ref.experience, experience = _ref$experience === void 0 ? "entry-auth" : _ref$experience;
    var queryParams = [];
    if (email) queryParams.push("login_hint=".concat(email));
    if (experience) queryParams.push("application=community--".concat(experience));
    if (redirectUrl) {
        // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
        var encodedRedirectUrl = encodeURIComponent(redirectUrl);
        queryParams.push(urlType === "identity" ? "continue=".concat(encodedRedirectUrl) : "referer=".concat(encodedRedirectUrl));
    }
    if (prompt) queryParams.push("prompt=".concat(prompt));
    return queryParams;
};
var $8883d5ac37340af9$var$getAuthUrl = $8883d5ac37340af9$exports.getAuthUrl = function getAuthUrl(type, queryParamValues, env) {
    var environment = (0, $5827f444065c0e59$exports.getEnvironment)(env);
    var config = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS[environment];
    var queryParams = $8883d5ac37340af9$var$buildAuthQueryParams("identity", queryParamValues);
    return "".concat(config.IDENTITY_BASE_URL, "/").concat(type, "?").concat(queryParams.join("&"));
};
var $8883d5ac37340af9$var$getForumsSignInUrl = $8883d5ac37340af9$exports.getForumsSignInUrl = function getForumsSignInUrl(queryParamValues, env) {
    var environment = (0, $5827f444065c0e59$exports.getEnvironment)(env);
    var config = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS[environment];
    // Only include referer parameter for OAuth2 SSO redirect
    var queryParams = [];
    if (queryParamValues.redirectUrl) // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
    queryParams.push("referer=".concat(encodeURIComponent(queryParamValues.redirectUrl)));
    var queryString = queryParams.length > 0 ? "?".concat(queryParams.join("&")) : "";
    return "".concat(config.HOME_BASE_URL, "/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect").concat(queryString);
};
var $8883d5ac37340af9$var$getForumsSignOutUrl = $8883d5ac37340af9$exports.getForumsSignOutUrl = function getForumsSignOutUrl(redirectUrl, env) {
    var environment = (0, $5827f444065c0e59$exports.getEnvironment)(env);
    var config = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS[environment];
    // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
    var encodedRedirectUrl = redirectUrl ? encodeURIComponent(redirectUrl) : "";
    return "".concat(config.HOME_BASE_URL, "/forums/s/plugins/custom/atlassian/").concat(config.KHOROS_ENDPOINT_PATH, "/khoros_logout?referer=").concat(encodedRedirectUrl);
};
var $8883d5ac37340af9$var$getHlvVanillaForumsSignInUrl = $8883d5ac37340af9$exports.getHlvVanillaForumsSignInUrl = function getHlvVanillaForumsSignInUrl(queryParamValues, env) {
    var environment = (0, $5827f444065c0e59$exports.getEnvironment)(env);
    var config = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS[environment];
    var target = queryParamValues.redirectUrl ? "?Target=".concat(encodeURIComponent(queryParamValues.redirectUrl)) : "";
    return "".concat(config.HOME_BASE_URL, "/forums/entry/signin").concat(target);
};
var $8883d5ac37340af9$var$getHlvVanillaForumsSignOutUrl = $8883d5ac37340af9$exports.getHlvVanillaForumsSignOutUrl = function getHlvVanillaForumsSignOutUrl(env) {
    var environment = (0, $5827f444065c0e59$exports.getEnvironment)(env);
    var config = $5827f444065c0e59$exports.ENVIRONMENT_CONFIGS[environment];
    return "".concat(config.HOME_BASE_URL, "/forums/entry/signout");
};
var $8883d5ac37340af9$var$getIdentityLoginUrl = $8883d5ac37340af9$exports.getIdentityLoginUrl = function getIdentityLoginUrl(queryParamValues, env) {
    return $8883d5ac37340af9$var$getAuthUrl("login", queryParamValues, env);
};
var $8883d5ac37340af9$var$getIdentityLogoutUrl = $8883d5ac37340af9$exports.getIdentityLogoutUrl = function getIdentityLogoutUrl(queryParamValues, env) {
    return $8883d5ac37340af9$var$getAuthUrl("logout", queryParamValues, env);
};
var $8883d5ac37340af9$var$getLoginUrl = $8883d5ac37340af9$exports.getLoginUrl = function getLoginUrl(queryParamValues, env) {
    // Build the forums signin URL with the redirect URL
    var forumsSignInUrl = $8883d5ac37340af9$var$getForumsSignInUrl(queryParamValues, env);
    // redirect the identity login to the forums signin url
    var identityLoginUrl = $8883d5ac37340af9$var$getAuthUrl("login", $8883d5ac37340af9$var$_objectSpread($8883d5ac37340af9$var$_objectSpread({}, queryParamValues), {}, {
        redirectUrl: "".concat(forumsSignInUrl)
    }), env);
    return identityLoginUrl;
};
var $8883d5ac37340af9$var$getLogoutUrl = $8883d5ac37340af9$exports.getLogoutUrl = function getLogoutUrl(queryParamValues, env) {
    // Build the forums signout URL with the redirect URL
    var forumsSignOutUrl = $8883d5ac37340af9$var$getForumsSignOutUrl(queryParamValues.redirectUrl, env);
    // redirect the identity logout to the forums signout url
    var identityLogoutUrl = $8883d5ac37340af9$var$getAuthUrl("logout", $8883d5ac37340af9$var$_objectSpread($8883d5ac37340af9$var$_objectSpread({}, queryParamValues), {}, {
        redirectUrl: "".concat(forumsSignOutUrl)
    }), env);
    return identityLogoutUrl;
};


function $ec4089d934924496$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $ec4089d934924496$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $ec4089d934924496$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($ec4089d934924496$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $ec4089d934924496$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec4089d934924496$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec4089d934924496$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec4089d934924496$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec4089d934924496$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec4089d934924496$var$_defineProperty(e, r, t) {
    return (r = $ec4089d934924496$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ec4089d934924496$var$_toPropertyKey(t) {
    var i = $ec4089d934924496$var$_toPrimitive(t, "string");
    return "symbol" == $ec4089d934924496$var$_typeof(i) ? i : i + "";
}
function $ec4089d934924496$var$_toPrimitive(t, r) {
    if ("object" != $ec4089d934924496$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ec4089d934924496$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec4089d934924496$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $ec4089d934924496$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $ec4089d934924496$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $ec4089d934924496$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $ec4089d934924496$var$getCommunityLoginUrl = $ec4089d934924496$exports.getCommunityLoginUrl = function getCommunityLoginUrl(queryParamValues, env) {
    return (0, $8883d5ac37340af9$exports.getLoginUrl)(queryParamValues, env);
};
var $ec4089d934924496$var$getCommunityLogoutUrl = $ec4089d934924496$exports.getCommunityLogoutUrl = function getCommunityLogoutUrl(queryParamValues, env) {
    return (0, $8883d5ac37340af9$exports.getLogoutUrl)(queryParamValues, env);
};
var $ec4089d934924496$var$getCommunityIdentityLoginUrl = $ec4089d934924496$exports.getCommunityIdentityLoginUrl = function getCommunityIdentityLoginUrl(queryParamValues, env) {
    return (0, $8883d5ac37340af9$exports.getIdentityLoginUrl)(queryParamValues, env);
};
var $ec4089d934924496$var$getCommunityIdentityLogoutUrl = $ec4089d934924496$exports.getCommunityIdentityLogoutUrl = function getCommunityIdentityLogoutUrl(queryParamValues, env) {
    return (0, $8883d5ac37340af9$exports.getIdentityLogoutUrl)(queryParamValues, env);
};
var $ec4089d934924496$var$getHlvCommunityForumsSignInUrl = $ec4089d934924496$exports.getHlvCommunityForumsSignInUrl = function getHlvCommunityForumsSignInUrl(queryParamValues, env) {
    return (0, $8883d5ac37340af9$exports.getHlvVanillaForumsSignInUrl)(queryParamValues, env);
};
var $ec4089d934924496$var$getHlvCommunityForumsSignOutUrl = $ec4089d934924496$exports.getHlvCommunityForumsSignOutUrl = function getHlvCommunityForumsSignOutUrl(env) {
    return (0, $8883d5ac37340af9$exports.getHlvVanillaForumsSignOutUrl)(env);
};
// Initialize Community on UPP
var $ec4089d934924496$var$initializeCommunity = $ec4089d934924496$exports.initializeCommunity = /*#__PURE__*/ function() {
    var _ref = $ec4089d934924496$var$_asyncToGenerator(/*#__PURE__*/ $ec4089d934924496$var$_regeneratorRuntime().mark(function _callee(emailId) {
        var baseUrl, Origin, env, _graphqlResponseBody$, apiPath, graphqlResponse, graphqlResponseBody, _args = arguments;
        return $ec4089d934924496$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    _context.prev = 3;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        headers: $ec4089d934924496$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $954418363634b5e4$exports.initializeCommunityMutation)(emailId),
                            operationName: "INITIALIZE_COMMUNITY_MUTATION"
                        })
                    });
                case 7:
                    graphqlResponse = _context.sent;
                    _context.next = 10;
                    return graphqlResponse.json();
                case 10:
                    graphqlResponseBody = _context.sent;
                    return _context.abrupt("return", graphqlResponseBody === null || graphqlResponseBody === void 0 || (_graphqlResponseBody$ = graphqlResponseBody.data) === null || _graphqlResponseBody$ === void 0 || (_graphqlResponseBody$ = _graphqlResponseBody$.unified) === null || _graphqlResponseBody$ === void 0 || (_graphqlResponseBody$ = _graphqlResponseBody$.community) === null || _graphqlResponseBody$ === void 0 ? void 0 : _graphqlResponseBody$.initializeCommunity);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    console.error("Error setting consent on UPP: ", _context.t0);
                    return _context.abrupt("return", false);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function initializeCommunity(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $ec4089d934924496$var$initializeCommunitybyAaid = $ec4089d934924496$exports.initializeCommunitybyAaid = /*#__PURE__*/ function() {
    var _ref2 = $ec4089d934924496$var$_asyncToGenerator(/*#__PURE__*/ $ec4089d934924496$var$_regeneratorRuntime().mark(function _callee2(aaid) {
        var baseUrl, Origin, env, _graphqlResponseBody$2, apiPath, graphqlResponse, graphqlResponseBody, _args2 = arguments;
        return $ec4089d934924496$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";
                    Origin = _args2.length > 2 ? _args2[2] : undefined;
                    env = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 3;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)(env);
                    _context2.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        headers: $ec4089d934924496$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $954418363634b5e4$exports.initializeCommunityMutationbyAaid)(aaid),
                            operationName: "INITIALIZE_COMMUNITY_MUTATION"
                        })
                    });
                case 7:
                    graphqlResponse = _context2.sent;
                    _context2.next = 10;
                    return graphqlResponse.json();
                case 10:
                    graphqlResponseBody = _context2.sent;
                    return _context2.abrupt("return", graphqlResponseBody === null || graphqlResponseBody === void 0 || (_graphqlResponseBody$2 = graphqlResponseBody.data) === null || _graphqlResponseBody$2 === void 0 || (_graphqlResponseBody$2 = _graphqlResponseBody$2.unified) === null || _graphqlResponseBody$2 === void 0 || (_graphqlResponseBody$2 = _graphqlResponseBody$2.community) === null || _graphqlResponseBody$2 === void 0 ? void 0 : _graphqlResponseBody$2.initializeCommunity);
                case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](3);
                    console.error("Error setting consent on UPP: ", _context2.t0);
                    return _context2.abrupt("return", false);
                case 18:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function initializeCommunitybyAaid(_x2) {
        return _ref2.apply(this, arguments);
    };
}();


Object.keys($ec4089d934924496$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $11903467dd03ded7$exports && $11903467dd03ded7$exports[key] === $ec4089d934924496$exports[key]) return;
    Object.defineProperty($11903467dd03ded7$exports, key, {
        enumerable: true,
        get: function get() {
            return $ec4089d934924496$exports[key];
        }
    });
});
var $e10a0530111a5bb5$exports = {};
"use strict";
function $e10a0530111a5bb5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e10a0530111a5bb5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e10a0530111a5bb5$var$_typeof(o);
}
Object.defineProperty($e10a0530111a5bb5$exports, "__esModule", {
    value: true
});
$e10a0530111a5bb5$exports.isUserManaged = $e10a0530111a5bb5$exports.getUserAccountStatuses = void 0;



function $e10a0530111a5bb5$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $e10a0530111a5bb5$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $e10a0530111a5bb5$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($e10a0530111a5bb5$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $e10a0530111a5bb5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e10a0530111a5bb5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e10a0530111a5bb5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e10a0530111a5bb5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e10a0530111a5bb5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e10a0530111a5bb5$var$_defineProperty(e, r, t) {
    return (r = $e10a0530111a5bb5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e10a0530111a5bb5$var$_toPropertyKey(t) {
    var i = $e10a0530111a5bb5$var$_toPrimitive(t, "string");
    return "symbol" == $e10a0530111a5bb5$var$_typeof(i) ? i : i + "";
}
function $e10a0530111a5bb5$var$_toPrimitive(t, r) {
    if ("object" != $e10a0530111a5bb5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e10a0530111a5bb5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e10a0530111a5bb5$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $e10a0530111a5bb5$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $e10a0530111a5bb5$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $e10a0530111a5bb5$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $e10a0530111a5bb5$var$getUserAccountStatuses = $e10a0530111a5bb5$exports.getUserAccountStatuses = /*#__PURE__*/ function() {
    var _ref = $e10a0530111a5bb5$var$_asyncToGenerator(/*#__PURE__*/ $e10a0530111a5bb5$var$_regeneratorRuntime().mark(function _callee(aaid) {
        var baseUrl, Origin, env, apiPath, rawResponse, json, _args = arguments;
        return $e10a0530111a5bb5$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 6;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        headers: $e10a0530111a5bb5$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $a31ec78ef2dbb035$exports.getUserAccountQuery)(aaid),
                            operationName: "USER_ACCOUNT_QUERY"
                        })
                    });
                case 6:
                    rawResponse = _context.sent;
                    _context.next = 9;
                    return rawResponse.json();
                case 9:
                    json = _context.sent;
                    return _context.abrupt("return", json);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getUserAccountStatuses(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $e10a0530111a5bb5$var$isUserManaged = $e10a0530111a5bb5$exports.isUserManaged = /*#__PURE__*/ function() {
    var _ref2 = $e10a0530111a5bb5$var$_asyncToGenerator(/*#__PURE__*/ $e10a0530111a5bb5$var$_regeneratorRuntime().mark(function _callee2(aaid) {
        var baseUrl, Origin, env, _response$data, response, account, _args2 = arguments;
        return $e10a0530111a5bb5$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";
                    Origin = _args2.length > 2 ? _args2[2] : undefined;
                    env = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 3;
                    _context2.next = 6;
                    return $e10a0530111a5bb5$var$getUserAccountStatuses(aaid, baseUrl, Origin, env);
                case 6:
                    response = _context2.sent;
                    account = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.unified) === null || _response$data === void 0 ? void 0 : _response$data.account;
                    if (!(!account || (0, $b9e43563e24aba1a$exports.isUnifiedAccountQueryError)(account))) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 10:
                    if (!(typeof account.isManaged !== "boolean")) {
                        _context2.next = 12;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 12:
                    return _context2.abrupt("return", account.isManaged);
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](3);
                    console.error("[isUserManaged] Error fetching unified account:", _context2.t0);
                    return _context2.abrupt("return", null);
                case 19:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function isUserManaged(_x2) {
        return _ref2.apply(this, arguments);
    };
}();


Object.keys($e10a0530111a5bb5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $11903467dd03ded7$exports && $11903467dd03ded7$exports[key] === $e10a0530111a5bb5$exports[key]) return;
    Object.defineProperty($11903467dd03ded7$exports, key, {
        enumerable: true,
        get: function get() {
            return $e10a0530111a5bb5$exports[key];
        }
    });
});
var $a20f4660174db1d4$exports = {};
"use strict";
function $a20f4660174db1d4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a20f4660174db1d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a20f4660174db1d4$var$_typeof(o);
}
Object.defineProperty($a20f4660174db1d4$exports, "__esModule", {
    value: true
});
$a20f4660174db1d4$exports.submitChampionSignup = void 0;


function $a20f4660174db1d4$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $a20f4660174db1d4$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $a20f4660174db1d4$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($a20f4660174db1d4$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $a20f4660174db1d4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a20f4660174db1d4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a20f4660174db1d4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a20f4660174db1d4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a20f4660174db1d4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a20f4660174db1d4$var$_defineProperty(e, r, t) {
    return (r = $a20f4660174db1d4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a20f4660174db1d4$var$_toPropertyKey(t) {
    var i = $a20f4660174db1d4$var$_toPrimitive(t, "string");
    return "symbol" == $a20f4660174db1d4$var$_typeof(i) ? i : i + "";
}
function $a20f4660174db1d4$var$_toPrimitive(t, r) {
    if ("object" != $a20f4660174db1d4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a20f4660174db1d4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a20f4660174db1d4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a20f4660174db1d4$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a20f4660174db1d4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a20f4660174db1d4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $a20f4660174db1d4$var$submitChampionSignup = $a20f4660174db1d4$exports.submitChampionSignup = /*#__PURE__*/ function() {
    var _ref = $a20f4660174db1d4$var$_asyncToGenerator(/*#__PURE__*/ $a20f4660174db1d4$var$_regeneratorRuntime().mark(function _callee(input) {
        var baseUrl, Origin, env, _json$data$champion$c, _json$data, apiPath, rawResponse, json, _args = arguments;
        return $a20f4660174db1d4$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    _context.prev = 3;
                    apiPath = (0, $5827f444065c0e59$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: "POST",
                        credentials: "include",
                        headers: $a20f4660174db1d4$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: $954418363634b5e4$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION,
                            operationName: "SUBMIT_CHAMPION_SIGNUP_MUTATION",
                            variables: {
                                input: input
                            }
                        })
                    });
                case 7:
                    rawResponse = _context.sent;
                    _context.next = 10;
                    return rawResponse.json();
                case 10:
                    json = _context.sent;
                    return _context.abrupt("return", (_json$data$champion$c = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 || (_json$data = _json$data.champion) === null || _json$data === void 0 || (_json$data = _json$data.championSignup) === null || _json$data === void 0 ? void 0 : _json$data.submitChampionSignup) !== null && _json$data$champion$c !== void 0 ? _json$data$champion$c : null);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    console.error("Error submitting champion signup: ", _context.t0);
                    return _context.abrupt("return", null);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function submitChampionSignup(_x) {
        return _ref.apply(this, arguments);
    };
}();


Object.keys($a20f4660174db1d4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $11903467dd03ded7$exports && $11903467dd03ded7$exports[key] === $a20f4660174db1d4$exports[key]) return;
    Object.defineProperty($11903467dd03ded7$exports, key, {
        enumerable: true,
        get: function get() {
            return $a20f4660174db1d4$exports[key];
        }
    });
});


function $6eab54e19a516415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $6eab54e19a516415$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6eab54e19a516415$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6eab54e19a516415$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $6eab54e19a516415$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $6eab54e19a516415$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6eab54e19a516415$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $6eab54e19a516415$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $6eab54e19a516415$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($6eab54e19a516415$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $6eab54e19a516415$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $6eab54e19a516415$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $6eab54e19a516415$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $6eab54e19a516415$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $6eab54e19a516415$var$_slicedToArray(r, e) {
    return $6eab54e19a516415$var$_arrayWithHoles(r) || $6eab54e19a516415$var$_iterableToArrayLimit(r, e) || $6eab54e19a516415$var$_unsupportedIterableToArray(r, e) || $6eab54e19a516415$var$_nonIterableRest();
}
function $6eab54e19a516415$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6eab54e19a516415$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6eab54e19a516415$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6eab54e19a516415$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6eab54e19a516415$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6eab54e19a516415$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6eab54e19a516415$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $6eab54e19a516415$var$Initializer = $6eab54e19a516415$exports.Initializer = function Initializer(_ref) {
    var emailId = _ref.emailId, aaid = _ref.aaid, onError = _ref.onError, onSuccess = _ref.onSuccess, onComplete = _ref.onComplete, isInitialized = _ref.isInitialized, children = _ref.children;
    var _React$useState = $6eab54e19a516415$var$_react["default"].useState(false), _React$useState2 = $6eab54e19a516415$var$_slicedToArray(_React$useState, 2), isLoading = _React$useState2[0], setIsLoading = _React$useState2[1];
    var initializeCommunityAccounts = /*#__PURE__*/ function() {
        var _ref2 = $6eab54e19a516415$var$_asyncToGenerator(/*#__PURE__*/ $6eab54e19a516415$var$_regeneratorRuntime().mark(function _callee() {
            var response;
            return $6eab54e19a516415$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        setIsLoading(true);
                        if (!aaid) {
                            _context.next = 8;
                            break;
                        }
                        _context.next = 5;
                        return (0, $11903467dd03ded7$exports.initializeCommunitybyAaid)(aaid);
                    case 5:
                        response = _context.sent;
                        _context.next = 15;
                        break;
                    case 8:
                        if (!emailId) {
                            _context.next = 14;
                            break;
                        }
                        _context.next = 11;
                        return (0, $11903467dd03ded7$exports.initializeCommunity)(emailId);
                    case 11:
                        response = _context.sent;
                        _context.next = 15;
                        break;
                    case 14:
                        onError("missing_aaid_emailid", "AAID or emailId is required");
                    case 15:
                        if (!response) onError("consent_failed", "Failed to initialize");
                        else onSuccess();
                        _context.next = 21;
                        break;
                    case 18:
                        _context.prev = 18;
                        _context.t0 = _context["catch"](0);
                        onError("initialization_failed", "Failed to initialize" + _context.t0.message);
                    case 21:
                        _context.prev = 21;
                        setIsLoading(false);
                        if (onComplete) onComplete();
                        return _context.finish(21);
                    case 25:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18,
                    21,
                    25
                ]
            ]);
        }));
        return function initializeCommunityAccounts() {
            return _ref2.apply(this, arguments);
        };
    }();
    (0, $6eab54e19a516415$var$_react.useEffect)(function() {
        $6eab54e19a516415$var$_asyncToGenerator(/*#__PURE__*/ $6eab54e19a516415$var$_regeneratorRuntime().mark(function _callee2() {
            return $6eab54e19a516415$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return initializeCommunityAccounts();
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }))();
    }, [
        aaid,
        emailId
    ]);
    if (isLoading) return /*#__PURE__*/ $6eab54e19a516415$var$_react["default"].createElement($6eab54e19a516415$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return isInitialized ? children : null;
};


Object.keys($6eab54e19a516415$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9c2745e8f2aa72ed$exports && $9c2745e8f2aa72ed$exports[key] === $6eab54e19a516415$exports[key]) return;
    Object.defineProperty($9c2745e8f2aa72ed$exports, key, {
        enumerable: true,
        get: function get() {
            return $6eab54e19a516415$exports[key];
        }
    });
});


Object.keys($9c2745e8f2aa72ed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $768c2bb36d671034$exports && $768c2bb36d671034$exports[key] === $9c2745e8f2aa72ed$exports[key]) return;
    Object.defineProperty($768c2bb36d671034$exports, key, {
        enumerable: true,
        get: function get() {
            return $9c2745e8f2aa72ed$exports[key];
        }
    });
});

Object.keys($11903467dd03ded7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $768c2bb36d671034$exports && $768c2bb36d671034$exports[key] === $11903467dd03ded7$exports[key]) return;
    Object.defineProperty($768c2bb36d671034$exports, key, {
        enumerable: true,
        get: function get() {
            return $11903467dd03ded7$exports[key];
        }
    });
});


const $9ad628f7523b39c7$export$61fc7d43ac8f84b0 = (callback, delay)=>{
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            callback();
        }, delay);
    };
};




var $26Mrv = parcelRequire("26Mrv");
const $4fca6bd638ae6930$export$2ca6851c09d9209a = ()=>(0, $26Mrv.default).checkGate("upp-ui-feature-gate-test") ?? false;
const $4fca6bd638ae6930$export$d380572c97739ad9 = ()=>{
    const REACT_APP_USE_MOCK_NETWORK_HANDLER = "false";
    if (REACT_APP_USE_MOCK_NETWORK_HANDLER === "true") return true;
    return (0, $26Mrv.default).checkGate("product-id-to-node-id-change") ?? false;
};
const $4fca6bd638ae6930$export$bc1863240190ff9 = ()=>(0, $26Mrv.default).checkGate("upp-ui-feature-unified-account") ?? false;
const $4fca6bd638ae6930$export$c70e28e0bbfc9705 = ()=>(0, $26Mrv.default).checkGate("community-account-switcher") ?? false;
const $4fca6bd638ae6930$export$5301ad2d5b2b49a4 = ()=>(0, $26Mrv.default).checkGate("community-give-recognition-upp") ?? false;
const $4fca6bd638ae6930$export$ded3174c200d604a = ()=>(0, $26Mrv.default).checkGate("community_new_top_navigation") ?? false;
const $4fca6bd638ae6930$export$73f46a93e1216cfe = ()=>(0, $26Mrv.default).checkGate("community-forums-hlv-vanilla") ?? false;


const $7ef8d8aa49ecf9c6$var$IDENTITY_BASE_URL = "https://id.atlassian.com";
const $7ef8d8aa49ecf9c6$var$VANILLA_HLV_BASE_URL = "https://atlassian.vanillacommunities.com";
// Temporary pre-release override: prod testers use the direct Vanilla host until /forums is switched to HLV.
const $7ef8d8aa49ecf9c6$var$getVanillaHlvPath = (path)=>$7ef8d8aa49ecf9c6$var$VANILLA_HLV_BASE_URL ? `${$7ef8d8aa49ecf9c6$var$VANILLA_HLV_BASE_URL}${path}` : `/forums${path}`;
const $7ef8d8aa49ecf9c6$var$buildAuthQueryParams = (urlType, { email: email, redirectUrl: redirectUrl, prompt: prompt, experience: experience = "entry-auth" })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(urlType === "identity" ? `continue=${redirectUrl}` : `referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $7ef8d8aa49ecf9c6$export$1ecea9365b9c733c = (type, queryParamValues)=>{
    const queryParams = $7ef8d8aa49ecf9c6$var$buildAuthQueryParams("identity", queryParamValues);
    return `${$7ef8d8aa49ecf9c6$var$IDENTITY_BASE_URL}/${type}?${queryParams.join("&")}`;
};
const $7ef8d8aa49ecf9c6$export$1db7da00354b15ed = (queryParamValues)=>{
    if ((0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) {
        const queryParams = [];
        // Only include Target parameter for OAuth2 SSO redirect
        if (queryParamValues.redirectUrl) queryParams.push(`Target=${encodeURIComponent(queryParamValues.redirectUrl)}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        return $7ef8d8aa49ecf9c6$var$getVanillaHlvPath(`/entry/signin${queryString}`);
    }
    queryParamValues.prompt = "none";
    const queryParams = $7ef8d8aa49ecf9c6$var$buildAuthQueryParams("forums", queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};
const $7ef8d8aa49ecf9c6$export$f6a03fcc87267edf = (redirectUrl)=>{
    if ((0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) {
        const queryParams = [];
        // Only include Target parameter for OAuth2 SSO redirect
        if (redirectUrl?.length) queryParams.push(`Target=${encodeURIComponent(redirectUrl)}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        return $7ef8d8aa49ecf9c6$var$getVanillaHlvPath(`/entry/signout${queryString}`);
    }
    return `forums/community/page.logoutpage?t:cp=authentication/contributions/unticketedauthenticationactions&referer=${encodeURIComponent(redirectUrl ?? "")}&lia-action-token=vqbaOmbKji5FT8GhRqcJgN-gWIFDCKe-W-WZBph1FU0k_rYZvSl2UDf6uiPc8XUx&lia-action-token-id=logoff`;
};
const $7ef8d8aa49ecf9c6$export$c6601b379265eb67 = (forumsUserId, path, legacyShow = "activity")=>{
    if ((0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) return `${window.location.origin}/forums/profile/${path}/${forumsUserId}`;
    return `${window.location.origin}/forums/user/viewprofilepage/user-id/${forumsUserId}?show=${legacyShow}#details`;
};



var $acw62 = parcelRequire("acw62");

function $5db42e3dfedca408$export$9e8a0eb132335404(ref) {
    const [isWrapped, setIsWrapped] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const checkWrap = ()=>{
            if (ref.current) {
                const lineHeight = parseInt(window.getComputedStyle(ref.current).lineHeight, 10);
                const actualHeight = ref.current.offsetHeight;
                if (actualHeight > lineHeight) setIsWrapped(true);
                else setIsWrapped(false);
            }
        };
        const debouncedCheckWrap = (0, $9ad628f7523b39c7$export$61fc7d43ac8f84b0)(checkWrap, 300);
        window.addEventListener("resize", debouncedCheckWrap);
        checkWrap();
        return ()=>window.removeEventListener("resize", debouncedCheckWrap);
    }, [
        ref
    ]);
    return isWrapped;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $1bd54bdf397d06fd$export$d07517a676ce386f = {
    mobile: 768,
    tablet: 1280
};
const $1bd54bdf397d06fd$export$51e389dae84ec233 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $1bd54bdf397d06fd$export$cdecc1356a028a96 = ({ children: children })=>{
    const [screenType, setScreenType] = (0, $acw62.useState)();
    const calculateScreenType = (0, $acw62.useCallback)(()=>{
        const width = window.innerWidth;
        if (width < $1bd54bdf397d06fd$export$d07517a676ce386f.mobile) return "mobile";
        else if (width >= $1bd54bdf397d06fd$export$d07517a676ce386f.mobile && width < $1bd54bdf397d06fd$export$d07517a676ce386f.tablet) return "tablet";
        else return "desktop";
    }, []);
    const handleResize = (0, $acw62.useCallback)(()=>{
        const newScreenType = calculateScreenType();
        if (newScreenType !== screenType) setScreenType(newScreenType);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const debouncedResizeHandler = (0, $9ad628f7523b39c7$export$61fc7d43ac8f84b0)(handleResize, 300);
        window.addEventListener("resize", debouncedResizeHandler);
        handleResize();
        return ()=>{
            window.removeEventListener("resize", debouncedResizeHandler);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1bd54bdf397d06fd$export$51e389dae84ec233.Provider, {
        value: screenType || "desktop",
        children: children
    });
};


const $c46d6ad15b094b20$export$73fc99e2307f4d2e = ()=>{
    const screenType = (0, $acw62.useContext)((0, $1bd54bdf397d06fd$export$51e389dae84ec233));
    if (screenType === undefined) throw new Error("useScreenType must be used within a ResponsiveProvider");
    return screenType;
};


function $11b44da27d1a9b8a$export$bef94a5618bf18bf(url) {
    const pattern = new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*(\\?[;&a-z\\d%_.~+=@-]*)?(\\#[-a-z\\d_@]*)?$", "i"); // fragment locator
    return url && !!pattern.test(url);
}
const $11b44da27d1a9b8a$var$characterLimit = (limit, value)=>{
    if (value && value.length > limit) return `TOO_LONG`;
    return undefined;
};
const $11b44da27d1a9b8a$var$validateUrl = (value)=>{
    if (value && !$11b44da27d1a9b8a$export$bef94a5618bf18bf(value)) return `INVALID_URL`;
    return undefined;
};
const $11b44da27d1a9b8a$export$d78505ea49a0d35b = {
    characterLimit: $11b44da27d1a9b8a$var$characterLimit,
    validateUrl: $11b44da27d1a9b8a$var$validateUrl
};


const $5950fde19a0508c0$export$2bc9488aaaa78231 = (inputNumber)=>{
    const number = inputNumber - 3;
    // If below 1099, return the number
    if (number <= 1099) return `+${number}`;
    else if (number > 1099 && number <= 999900) {
        // Round down to the nearest hundred, then divide by 1000
        const roundedDown = Math.floor(number / 100) * 100;
        const dividedNumber = roundedDown / 1000;
        if (dividedNumber % 1 === 0) // This is so we don't end up with '.0k'
        return `+${dividedNumber}k`;
        else // If it's not a whole number keep one decimal place
        return `+${dividedNumber.toFixed(1)}k`;
    } else return "+999.9k";
};
const $5950fde19a0508c0$export$2942cf5daa9fcc1 = (inputNumber)=>{
    if (inputNumber <= 1099) return `${inputNumber}`;
    else if (inputNumber > 1099 && inputNumber <= 999900) {
        const roundedDown = Math.floor(inputNumber / 100) * 100;
        const dividedNumber = roundedDown / 1000;
        if (dividedNumber % 1 === 0) return `${dividedNumber}k`;
        else return `${dividedNumber.toFixed(1)}k`;
    } else return "999.9k";
};



var $acw62 = parcelRequire("acw62");

const $ffa1c9c6a8a97c90$var$getNormalizedProducts = (allProducts, isProductIdToNodeIdChangeEnabled)=>{
    const edges = allProducts.edges ?? [];
    return edges.reduce((normalizedProducts, currentEdge)=>{
        if (currentEdge?.node) {
            const normalizedProduct = {
                title: currentEdge.node.title,
                type: currentEdge.node.type,
                viewHref: currentEdge.node.viewHref,
                id: isProductIdToNodeIdChangeEnabled ? currentEdge.node.productId : currentEdge.node.id
            };
            normalizedProducts.push(normalizedProduct);
        }
        return normalizedProducts;
    }, []);
};
const $ffa1c9c6a8a97c90$export$3e0a9d9c71b68dbb = (allProducts)=>{
    const isProductIdToNodeIdChangeEnabled = (0, $4fca6bd638ae6930$export$d380572c97739ad9)();
    return (0, $acw62.useMemo)(()=>allProducts ? $ffa1c9c6a8a97c90$var$getNormalizedProducts(allProducts, isProductIdToNodeIdChangeEnabled) : [], [
        allProducts,
        isProductIdToNodeIdChangeEnabled
    ]);
};
const $ffa1c9c6a8a97c90$export$df8cfbb1033cc959 = (selectedProducts, allProducts)=>{
    const selectedProductsArray = selectedProducts.split(",");
    return allProducts.filter((product)=>{
        if (product && product.id) {
            if (selectedProductsArray.includes(product.id)) return product;
        }
    });
};


const $79e6cb5b828d5745$export$4dac87d8635f2155 = (inputUrl)=>{
    return !/^https?:\/\//i.test(inputUrl) ? "https://" + inputUrl : inputUrl;
};


var $b4f35ae695e9f7f6$export$be46596bc6608f3b;
(function(ENVIRONMENT) {
    ENVIRONMENT["LOCAL"] = "local";
    ENVIRONMENT["DEV"] = "development";
    ENVIRONMENT["STAGING"] = "staging";
    ENVIRONMENT["PROD"] = "production";
})($b4f35ae695e9f7f6$export$be46596bc6608f3b || ($b4f35ae695e9f7f6$export$be46596bc6608f3b = {}));
const $b4f35ae695e9f7f6$export$57570b1603cf6adb = ()=>{
    return "production";
};


const $0ee606ad15f500d3$export$df86adc920cb0162 = (consents)=>{
    // Return false if the array is undefined or empty
    if (!consents || consents.length === 0) return false;
    const requiredConsents = [
        "communityTermsOfService",
        "privacyPolicy"
    ];
    return requiredConsents.every((requiredKey)=>{
        const consent = consents.find((c)=>c.consentKey === requiredKey);
        return consent?.consentStatus === "true";
    });
};
const $0ee606ad15f500d3$export$7a0549bb2cff767b = (isProfileOwnerConsented)=>{
    return isProfileOwnerConsented ?? false;
};




let $0ee39200de55b7f1$var$eagerInitDone = false;
/**
 * Eagerly initialises the analytics client WITHOUT waiting for OneTrust.
 * Used exclusively for operational events which are strictly-necessary and
 * exempt from C0002 (Performance) consent. The library's Tracking.trackEvent()
 * allows operational events through regardless of consent state, and
 * GASv3.sendOperationalEvent() strips cross-product identifiers when opted out.
 *
 * This eager initialisation intentionally does not provide a userId because
 * operational events may need to be emitted before user context is available.
 * In that case, early operational events can be sent without user context.
 * Callers should call setUserInfo() before sendOperationalEvent() where
 * possible so subsequent analytics events include user context.
 * */ const $0ee39200de55b7f1$var$ensureEagerInit = ()=>{
    if ($0ee39200de55b7f1$var$eagerInitDone || (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).hasAnalyticsClient()) return;
    (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).initializeClient((0, $768c2bb36d671034$exports.CommunityAnalyticsClient).SUB_APP.UNIFIED_PORTABLE_PROFILE, null, (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)(), null);
    $0ee39200de55b7f1$var$eagerInitDone = true;
};
const $0ee39200de55b7f1$export$ec05d93a265a7799 = (aaid)=>{
    (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).setAnalyticsUserInfo(aaid);
};
const $0ee39200de55b7f1$export$22a3b1671f38a193 = ({ screenName: screenName, attributes: attributes, isPersonalView: isPersonalView })=>{
    (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).sendEvent((0, $768c2bb36d671034$exports.eventType).SCREEN, {
        name: screenName,
        attributes: {
            isPersonalView: isPersonalView,
            ...attributes
        }
    });
};
const $0ee39200de55b7f1$export$1ba525b8a711eaac = ({ source: source, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, isPersonalView: isPersonalView })=>{
    (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).sendEvent((0, $768c2bb36d671034$exports.eventType).TRACK, {
        action: action,
        actionSubject: actionSubject,
        attributes: {
            isPersonalView: isPersonalView,
            ...attributes
        },
        source: source,
        actionSubjectId: actionSubjectId
    });
};
const $0ee39200de55b7f1$export$1aecf263098db667 = ({ source: source, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, isPersonalView: isPersonalView })=>{
    (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).sendEvent((0, $768c2bb36d671034$exports.eventType).UI, {
        action: action,
        actionSubject: actionSubject,
        attributes: {
            isPersonalView: isPersonalView,
            ...attributes
        },
        source: source,
        actionSubjectId: actionSubjectId
    });
};
const $0ee39200de55b7f1$export$e5f89b51c6d4e36b = ({ source: source, action: action, actionSubject: actionSubject, attributes: attributes })=>{
    $0ee39200de55b7f1$var$ensureEagerInit();
    (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).sendEvent((0, $768c2bb36d671034$exports.eventType).OPERATIONAL, {
        source: source,
        action: action,
        actionSubject: actionSubject,
        attributes: attributes
    });
};


// https://data-portal.internal.atlassian.com/analytics/registry/71740
const $b0f0e0cabc9e8981$export$3e5cc68ecf7f615e = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "headerCameraButton",
        isPersonalView: isPersonalView,
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71751
const $b0f0e0cabc9e8981$export$c63bfb07c3429619 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "editProfileButton",
        isPersonalView: isPersonalView,
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE
    });
};


var $be0e9f0d021963cb$var$_StatsSnapshotQuery;

const $be0e9f0d021963cb$export$6083b409658e4d09 = $be0e9f0d021963cb$var$_StatsSnapshotQuery !== void 0 ? $be0e9f0d021963cb$var$_StatsSnapshotQuery : $be0e9f0d021963cb$var$_StatsSnapshotQuery = (parcelRequire("fEgMm"));


/* RankLozenge.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

const $b9bfd99c9a9103f0$var$borderColorMap = {
    "COMMUNITY LEADER": "var(--ds-background-accent-purple-subtle)",
    "I'M NEW HERE": "var(--ds-background-accent-lime-subtle)",
    "RISING STAR": "var(--ds-background-accent-teal-subtle)",
    "MARKETPLACE PARTNER": "var(--ds-background-accent-orange-subtle)",
    "SOLUTION PARTNER": "var(--ds-background-accent-green-subtle)",
    "COMMUNITY MANAGER": "var(--ds-background-accent-yellow-subtle)",
    "ATLASSIAN TEAM": "var(--ds-background-accent-blue-subtle)",
    BANNED: "var(--ds-background-accent-gray-bolder)",
    VISITOR: "var(--ds-background-accent-blue-subtle)"
};
const $b9bfd99c9a9103f0$var$defaultBorderColor = "var(--ds-background-accent-blue-subtle)";
const $b9bfd99c9a9103f0$var$getBorderColor = (rank)=>({
        borderColor: $b9bfd99c9a9103f0$var$borderColorMap[rank] || $b9bfd99c9a9103f0$var$defaultBorderColor
    });
const $b9bfd99c9a9103f0$export$7028bce10fa4e287 = ({ rank: rank, nicknameLength: nicknameLength })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        role: "status",
        "aria-label": `Community rank: ${rank}`,
        style: $b9bfd99c9a9103f0$var$getBorderColor(rank),
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1yt41fhj _19it1axk _2rko8vuz _1wyboxav _ect41q02 _k48pzul8 _syaz1blv _1p1dangw _vwz47vkz _4t3ildb6 _19pk14y2 _xg5u1mrw _f5tlqfx8",
            nicknameLength > 32 && "_1jcoidpf _bj5y1bs0",
            nicknameLength > 18 && "_fsb2idpf _rs1m1bs0"
        ]),
        children: rank
    });
};
const $b9bfd99c9a9103f0$var$badgeStyles = null;
// 32 chars, on the 33rd lozenge appears above name. Reduce gap to 8px on wrapped lozenge.
const $b9bfd99c9a9103f0$var$wrappedLozengeDesktopStyles = null;
// 18 chars, on the 19th lozenge appears above name. Reduce gap to 8px on wrapped lozenge.
const $b9bfd99c9a9103f0$var$wrappedLozengeTabletStyles = null;






const $7f1303b450ad1698$var$useIsProfileBanned = (internalId)=>{
    const unifiedProfile = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    })?.unified?.unifiedProfile;
    let profileFragmentData;
    if (unifiedProfile && "__fragments" in unifiedProfile) profileFragmentData = (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile);
    return profileFragmentData?.isProfileBanned || false;
};
var $7f1303b450ad1698$export$2e2bcd8739ae039 = $7f1303b450ad1698$var$useIsProfileBanned;






const $fdc4eea726aa2036$var$useIsForumsModerator = (aaid)=>{
    if (!aaid) throw new Error("useIsForumsModerator: aaid is required");
    const account = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $69f7bb7bdecca370$export$d483224631a5893c), {
        aaid: aaid
    }, {
        fetchPolicy: "store-or-network"
    })?.unified;
    const isForumsModerator = account?.account?.isForumsModerator || false;
    return isForumsModerator;
};
var $fdc4eea726aa2036$export$2e2bcd8739ae039 = $fdc4eea726aa2036$var$useIsForumsModerator;


const $09c953719a360ef8$var$useIsLoggedInUserAForumsModerator = ()=>{
    const loggedInUser = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5b4d113e3efb8585$export$75493bef044c2fa0), {}, {
        fetchPolicy: "store-or-network"
    })?.me?.user;
    return loggedInUser?.accountId ? (0, $fdc4eea726aa2036$export$2e2bcd8739ae039)(loggedInUser.accountId) : false;
};
var $09c953719a360ef8$export$2e2bcd8739ae039 = $09c953719a360ef8$var$useIsLoggedInUserAForumsModerator;




const $f26dd37926a562a3$var$useLoggedInUser = ()=>{
    const atlassianUserData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5b4d113e3efb8585$export$75493bef044c2fa0), {}, {
        fetchPolicy: "store-or-network"
    });
    return atlassianUserData?.me?.user || null;
};
var $f26dd37926a562a3$export$2e2bcd8739ae039 = $f26dd37926a562a3$var$useLoggedInUser;


const $e68713997378eddf$var$useIsLoggedIn = ()=>{
    const loggedInUser = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)();
    return !!loggedInUser?.accountId;
};
var $e68713997378eddf$export$2e2bcd8739ae039 = $e68713997378eddf$var$useIsLoggedIn;



var $ec6ff1b76abaa9b1$var$_AtlassianAccountAnyUserQuery;

const $ec6ff1b76abaa9b1$export$91596656064cbe02 = $ec6ff1b76abaa9b1$var$_AtlassianAccountAnyUserQuery !== void 0 ? $ec6ff1b76abaa9b1$var$_AtlassianAccountAnyUserQuery : $ec6ff1b76abaa9b1$var$_AtlassianAccountAnyUserQuery = (parcelRequire("6Zmxz"));



const $8c6ebd5d5a7aecba$var$ProfileHeaderContent = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(pathProfileId);
    // const isPersonalView = true;
    const { push: push } = (0, $9a1d980dc90c7cfe$export$402e82ff1b20594b)();
    const profileResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $fe73a947836bf836$export$9d9de7756b13ecf), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const statsSnapshotResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $be0e9f0d021963cb$export$6083b409658e4d09), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const isProfileBanned = (0, $7f1303b450ad1698$export$2e2bcd8739ae039)(pathProfileId);
    const profileData = profileResponseData?.unified?.unifiedProfile;
    if (!profileData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch profile data"
    });
    const rawRank = statsSnapshotResponse?.unified?.unifiedProfile?.forums?.snapshot?.rank;
    const rank = rawRank?.toUpperCase() === "NOT APPLICABLE" ? "VISITOR" : rawRank;
    const userResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: profileData.aaid
    }, {
        fetchPolicy: "store-or-network"
    });
    const userData = userResponseData.user;
    if (!userData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch user data"
    });
    // data of current logged-in user (not profile user)
    const { email: email } = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)() || {};
    const isLoggedIn = (0, $e68713997378eddf$export$2e2bcd8739ae039)();
    const isLoggedUserAForumsModerator = (0, $09c953719a360ef8$export$2e2bcd8739ae039)();
    const handleCameraButtonClick = ()=>{
        (0, $b0f0e0cabc9e8981$export$3e5cc68ecf7f615e)(isPersonalView);
        handleEditProfile();
    };
    const handleEditProfileButtonClick = ()=>{
        (0, $b0f0e0cabc9e8981$export$c63bfb07c3429619)(isPersonalView);
        handleEditProfile();
    };
    const handleEditProfile = (0, $acw62.useCallback)(()=>{
        push(`/profile/${pathProfileId}/edit`);
    }, [
        pathProfileId
    ]);
    // temp fix for forums user id
    const forumsNodeId = statsSnapshotResponse?.unified?.unifiedProfile?.forums?.id;
    const forumsUserIdParts = (forumsNodeId ?? "").split("::forums/");
    const forumsUserId = forumsUserIdParts?.[1] ?? "";
    const handleModeratorControlsClick = (0, $acw62.useCallback)(()=>{
        if (!forumsUserId) return;
        const moderatorUrl = (0, $7ef8d8aa49ecf9c6$export$c6601b379265eb67)(forumsUserId, "notes", "admin");
        const effectiveModeratorUrl = isLoggedIn ? (0, $7ef8d8aa49ecf9c6$export$1db7da00354b15ed)({
            redirectUrl: moderatorUrl,
            email: email || ""
        }) : moderatorUrl;
        window.location.href = effectiveModeratorUrl;
    }, [
        email,
        forumsUserId,
        isLoggedIn
    ]);
    const { nickname: nickname, picture: picture } = userData;
    const nicknameLength = nickname ? nickname.length : 0;
    const { role: role, company: company, location: location } = profileData;
    const userPosition = [];
    if (role) userPosition.push(role);
    if (company) userPosition.push(company);
    let highResolutionPicture = "";
    try {
        const { profileAvatar: profileAvatar } = (0, $acw62.useContext)((0, $51c84bb9511e1e8b$export$122994dc05ba4308));
        highResolutionPicture = (0, $29b4de728b246ef8$export$1b8f63ded5de1d1e)(picture, (0, $77d0522707ddb581$export$a7e851dd01b7bece).LARGE, profileAvatar);
    } catch (e) {
        console.error("Error in changing to high resolution picture", e);
    }
    const nameOnly = !location && !userPosition?.length;
    // const screenType = useScreenType();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1bsb1nb2 _4t3i1nb2 _16jlidpf _1o9zidpf _kqswh2mm _ej7d55gi _19dqpd6w _1ao3pd6w _1jco1hqk _yuwchaca _1b5yhaca _uwwn1ule _17fr1ixi _1fuy1wug _fipvftgi _1kfj1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: highResolutionPicture,
                        alt: "Profile Photo",
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1bsb1osq _2rko1osq _4t3i1osq _19itknlt _dgfplmt6 _1czo6xln"
                        ])
                    }),
                    isPersonalView && (!isProfileBanned || isLoggedUserAForumsModerator) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: handleCameraButtonClick,
                        "data-testid": "camera-edit-button",
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_80omtlke _1bsb3okq _4t3i3okq _2rko1osq _bfhk1xnl _kdamz34t _kqswstnw _94n5idpf _1xi2idpf _19itglyw _v8sr4bvh _1hvy4bvh _1foe14y2 _174t14y2 _1lh6ftgi _1szsftgi _uwwnglyw",
                            isProfileBanned && !isLoggedUserAForumsModerator && "_1e0cglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4abbfa76f1e2bd65$exports))), {
                            primaryColor: "var(--ds-icon-subtle)",
                            // size={screenType === 'tablet' ? 'large' : 'xlarge'}
                            size: "large",
                            label: "Edit profile"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2lx21sbv _1n261g80 _1bahesu3 _16jlkb7n _1o9zkb7n _rk7t1tcg _16goftgi _6q2i1lbu _1upz1bp4 _17951h6o _1ns5ftgi",
                    nameOnly && "_1xjh1z0f _1f2ea5zd",
                    !nameOnly && "_1q2w1z0f _15hl5mqy _188845bk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_ect4kwxw _slp31hna",
                            "_1wybhiv4 _k48pbogh _vwz41ylp _1dyz1ljo _syaz1blv _2hwxftgi _1nmz1hna _i0dl1ns9 _1gw81ylp _1paha5zd _bnvs1osq _ly8r1h6o _1mybidpf"
                        ]),
                        children: nickname
                    }),
                    isProfileBanned && !isLoggedUserAForumsModerator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9bfd99c9a9103f0$export$7028bce10fa4e287), {
                        rank: "BANNED",
                        nicknameLength: nicknameLength
                    }),
                    rank && (!isProfileBanned || isLoggedUserAForumsModerator) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9bfd99c9a9103f0$export$7028bce10fa4e287), {
                        rank: rank === "VISITOR" ? "VISITOR" : rank.toUpperCase(),
                        nicknameLength: nicknameLength
                    }),
                    userPosition?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_ect4kwxw _slp31hna",
                            "_1wybxjmg _vwz4l6l0 _k48pzul8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _i0dl1osq _syaz1blv _1gw8gktf _1rea1bs0 _1pah1f4h"
                        ]),
                        children: userPosition.join(" at ")
                    }) : null,
                    location ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_ect4kwxw _slp31hna",
                            "_1wybxjmg _vwz4l6l0 _k48pzul8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _i0dl1osq _syaz1k3w _1gw8gktf _1pah1f4h"
                        ]),
                        children: location
                    }) : null
                ]
            }),
            isPersonalView ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_16jlidpf _1o9zidpf _1wpz1y6m _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _v8sr1osq _1ypb1h6o _be4bidpf _uwwn1txw _iyz51bp4 _wv5q1h6o _i27a1h6o _oe5x1tcg",
                    nameOnly && "_ca0qckbl _u5f3idpf _n3tdckbl _19bvidpf _1q4w1tcg _1jrpidpf _esur1tcg _1icxidpf _1sup1tcg _uyo4idpf _be4b1tcg _1pzxidpf"
                ]),
                children: [
                    isLoggedUserAForumsModerator && Boolean(forumsUserId) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_16jlidpf _1o9zidpf _1wpz1y6m _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _v8sr1osq _1ypb1h6o _be4bidpf _uwwn1txw _iyz51bp4 _wv5q1h6o _i27a1h6o _oe5x1tcg",
                            "_ca0qidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                            appearance: (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).PRIMARY,
                            onClick: handleModeratorControlsClick,
                            label: "Moderator controls"
                        })
                    }) : null,
                    !isProfileBanned || isLoggedUserAForumsModerator ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                        appearance: isLoggedUserAForumsModerator ? (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).SECONDARY : (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).PRIMARY,
                        onClick: handleEditProfileButtonClick,
                        label: "Edit profile"
                    }) : null
                ]
            }) : null
        ]
    });
};
const $8c6ebd5d5a7aecba$var$LoadingProfileHeader = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1bsb1nb2 _4t3i1nb2 _16jlidpf _1o9zidpf _kqswh2mm _ej7d55gi _19dqpd6w _1ao3pd6w _1jco1hqk _yuwchaca _1b5yhaca _uwwn1ule _17fr1ixi _1fuy1wug _fipvftgi _1kfj1wug"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1bsb1osq _2rko1osq _4t3i1osq _19itknlt _dgfplmt6 _1czo6xln",
                        "_11q718r8"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2lx21sbv _1n261g80 _1bahesu3 _16jlkb7n _1o9zkb7n _rk7t1tcg _16goftgi _6q2i1lbu _1upz1bp4 _17951h6o _1ns5ftgi",
                    "_1q2w1z0f _15hl5mqy _188845bk",
                    "_2hwx19wn _4t3ickbl _2rkoftgi _19pkftgi _11q718r8 _1kfjka7h _1fuyka7h"
                ])
            })
        ]
    });
};
const $8c6ebd5d5a7aecba$var$ProfileHeader = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1ule _kqswh2mm _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _1wyb1tcg _1bsb1osq _1bah1yb4 _1t0j1g80 _10qu10bg _1d1skb7n _8ayzkb7n _gji2f1ug _1supidpf _uyo47vkz _be4bidpf _1pzx7vkz _iyz51bp4"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c6ebd5d5a7aecba$var$LoadingProfileHeader, {}),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c6ebd5d5a7aecba$var$ProfileHeaderContent, {})
            })
        })
    });
};
var $8c6ebd5d5a7aecba$export$2e2bcd8739ae039 = $8c6ebd5d5a7aecba$var$ProfileHeader;
// DESKTOP_PHOTO_SIZE  renders to (accounting for margin) 245px x 245px
const $8c6ebd5d5a7aecba$var$DESKTOP_PHOTO_SIZE = 261;
// TABLET_PHOTO_SIZE renders to (accounting for margin) 185px x 185px
const $8c6ebd5d5a7aecba$var$TABLET_PHOTO_SIZE = 195;
// MOBILE_PHOTO_SIZE renders to (accounting for margin) 105px x 105px
const $8c6ebd5d5a7aecba$var$MOBILE_PHOTO_SIZE = 111;
const $8c6ebd5d5a7aecba$var$DESKTOP_PHOTO_BORDER_SIZE = 8;
const $8c6ebd5d5a7aecba$var$TABLET_PHOTO_BORDER_SIZE = 5;
const $8c6ebd5d5a7aecba$var$MOBILE_PHOTO_BORDER_SIZE = 3;
const $8c6ebd5d5a7aecba$var$headerStyles = null;
const $8c6ebd5d5a7aecba$var$hideCameraButtonStyles = null;
const $8c6ebd5d5a7aecba$var$containerStyles = null;
const $8c6ebd5d5a7aecba$var$profilePhotoStyles = null;
const $8c6ebd5d5a7aecba$var$moderatorControlsButton = null;
const $8c6ebd5d5a7aecba$var$profilePhotoContainerStyles = null;
const $8c6ebd5d5a7aecba$var$mainContentStyles = null;
const $8c6ebd5d5a7aecba$var$mainContentPadding = {
    default: null,
    nameOnly: null
};
const $8c6ebd5d5a7aecba$var$nameStyles = null;
const $8c6ebd5d5a7aecba$var$headingStyles = null;
const $8c6ebd5d5a7aecba$var$positionStyles = null;
const $8c6ebd5d5a7aecba$var$locationStyles = null;
const $8c6ebd5d5a7aecba$var$editButtonWrapperStyles = null;
const $8c6ebd5d5a7aecba$var$nameOnlyEditButtonStyles = null;
const $8c6ebd5d5a7aecba$var$cameraIconEditButtonStyles = null;
const $8c6ebd5d5a7aecba$var$loadingProfilePhotoStyles = null;
const $8c6ebd5d5a7aecba$var$loadingProfileInfoStyles = null;



var $acw62 = parcelRequire("acw62");
"use client";
const $f52e2ccccb0d538f$export$b16d9fb1a22de840 = (0, $acw62.createContext)(null);
const $f52e2ccccb0d538f$var$initialState = {
    didCatch: false,
    error: null
};
class $f52e2ccccb0d538f$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $f52e2ccccb0d538f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $f52e2ccccb0d538f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $acw62.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $acw62.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $acw62.createElement)($f52e2ccccb0d538f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $f52e2ccccb0d538f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $f52e2ccccb0d538f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $f52e2ccccb0d538f$export$c052f6604b7d51fe() {
    const context = (0, $acw62.useContext)($f52e2ccccb0d538f$export$b16d9fb1a22de840);
    $f52e2ccccb0d538f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $acw62.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $acw62.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $f52e2ccccb0d538f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $acw62.forwardRef)((props, ref)=>(0, $acw62.createElement)($f52e2ccccb0d538f$export$e926676385687eaf, errorBoundaryProps, (0, $acw62.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}


/* Fallback.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");
const $449db7dc91aabb25$var$styles = null;
const $449db7dc91aabb25$var$REACT_APP_IS_ERROR_SHOWN = false;
const $449db7dc91aabb25$var$Fallback = ({ error: error })=>{
    return $449db7dc91aabb25$var$REACT_APP_IS_ERROR_SHOWN ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Something went wrong:"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz5scu"
                ]),
                children: error.message
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
};
var $449db7dc91aabb25$export$2e2bcd8739ae039 = $449db7dc91aabb25$var$Fallback;


/* eslint-disable */ 
/* eslint-disable */ const $73d0a2cdf35f1275$var$defaultOptions = {
    headers: {
        "content-type": "application/json;charset=UTF-8"
    }
};
const $73d0a2cdf35f1275$export$3988ae62b71be9a3 = async (url, options)=>$73d0a2cdf35f1275$var$request(url, undefined, {
        ...options,
        method: "GET"
    });
const $73d0a2cdf35f1275$export$299ba2dee77727e9 = async (url, data, options)=>$73d0a2cdf35f1275$var$request(url, data, {
        ...options,
        method: "POST"
    });
const $73d0a2cdf35f1275$export$327f7b26ebf455db = async (url, data, options)=>$73d0a2cdf35f1275$var$request(url, data, {
        ...options,
        method: "PUT"
    });
const $73d0a2cdf35f1275$export$1d2f21e549771e67 = async (url, data, options)=>$73d0a2cdf35f1275$var$request(url, data, {
        ...options,
        method: "DELETE"
    });
const $73d0a2cdf35f1275$var$request = async (url, data, options)=>{
    let response;
    try {
        const body = options?.method === "GET" ? undefined : JSON.stringify(data);
        response = await fetch(url, {
            ...$73d0a2cdf35f1275$var$defaultOptions,
            ...options,
            body: body
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    } catch (e) {
        console.log("Request failed", e);
        throw e;
    }
};


const $ff917de846b535b7$var$uppAPI = "/gateway/api/upp-service-api";
const $ff917de846b535b7$var$log = async (type, code, description, error)=>{
    try {
        await (0, $73d0a2cdf35f1275$export$299ba2dee77727e9)(`${$ff917de846b535b7$var$uppAPI}${(0, $ea571afc9b14fbb2$export$807b1b70df68fbc6).LOG_PATH}`, {
            type: type,
            code: code,
            description: description,
            error: error
        });
    } catch (e) {
        console.log("Failed to log error", e);
    }
};
const $ff917de846b535b7$export$1c9f709888824e05 = async (type, code, description, error)=>{
    await $ff917de846b535b7$var$log(type, code, description, error);
};
const $ff917de846b535b7$export$c106dd0671a0fc2d = async (type, code, description, error)=>{
    await $ff917de846b535b7$var$log(type, code, description, error);
};
const $ff917de846b535b7$export$a3bc9b8ed74fc = async (type, code, description, error)=>{
    await $ff917de846b535b7$var$log(type, code, description, error);
};
const $ff917de846b535b7$export$a80b3bd66acc52ff = async (type, code, description, error)=>{
    await $ff917de846b535b7$var$log(type, code, description, error);
};
const $ff917de846b535b7$export$e11d707ed8ea628b = (error, info)=>{
    console.log("logBoundaryError error: ", error);
    console.log("logBoundaryError componentStack: ", info?.componentStack);
};


const $703c47fb157a7467$var$TopPanel = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_19itokh7 _otyrzwfg _1rea1tcg"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_19itglyw _otyr19bv _1bah1yb4 _kqswh2mm _p12f94vn _19pk68cl _2hwx1wug _otyridpf _18u01wug _fii91mug _ebtg1wug _1reaidpf _rk7t1wug _1jco1wdt _n3j91wug _bj5yidpf _k2i01wug"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c6ebd5d5a7aecba$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $703c47fb157a7467$export$2e2bcd8739ae039 = $703c47fb157a7467$var$TopPanel;
const $703c47fb157a7467$export$6a6b19ad7f0440cf = 55;
const $703c47fb157a7467$export$2be3f11171664f06 = 175;
const $703c47fb157a7467$export$255c584be29e1f6d = 194;
const $703c47fb157a7467$export$4ad54acafc203c36 = 275;
const $703c47fb157a7467$var$topPanelStyles = null;
const $703c47fb157a7467$var$contentStyles = null;


/* MainPanel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");


/* StatsSnapshot.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");



var $5c5c0f6b82e5b280$var$_ProfileBadgesQuery;

const $5c5c0f6b82e5b280$export$15a2e43f9400c215 = $5c5c0f6b82e5b280$var$_ProfileBadgesQuery !== void 0 ? $5c5c0f6b82e5b280$var$_ProfileBadgesQuery : $5c5c0f6b82e5b280$var$_ProfileBadgesQuery = (parcelRequire("9CU7A"));



/* ElevatedContainer.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");
const $e11946d314b99a3d$var$ElevatedContainer = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1yt41m6l _mw8n5k6p",
            "_2rkoftgi _1bsb1osq _16qsj9yf _bfhk6ota"
        ]),
        children: children
    });
var $e11946d314b99a3d$export$2e2bcd8739ae039 = $e11946d314b99a3d$var$ElevatedContainer;
const $e11946d314b99a3d$var$sectionContainerStyles = null;
const $e11946d314b99a3d$var$elevatedContainerStyles = null;





/* SectionSummaryContainer.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

const $6a44cdd096bb28cc$var$SectionSummaryContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1y6m _zulpl6l0 _oe5xxjmg"
        ]),
        children: children
    });
};
var $6a44cdd096bb28cc$export$2e2bcd8739ae039 = $6a44cdd096bb28cc$var$SectionSummaryContainer;
const $6a44cdd096bb28cc$var$sectionContainerStyles = null;


/* LoadingMainPanelSection.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

const $bc406a32200a03b6$export$6cbf77c1b1e30396 = ({ hasHeader: hasHeader })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            hasHeader ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_4t3ildb6 _1bsbmko7 _11q718r8 _2rkoftgi"
                ])
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_4t3ikz1e _1bsb1osq _11q718r8 _2rkoftgi"
                ])
            })
        ]
    });
};
const $bc406a32200a03b6$var$loadingHeaderStyles = null;
const $bc406a32200a03b6$var$loadingSectionStyles = null;








// https://data-portal.internal.atlassian.com/analytics/registry/87311
const $573e508d22f84a01$export$55e70457a816bd63 = (snapshotKey, snapshotValue, isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "unifiedProfileStatsSnapshot",
        attributes: {
            snapshotKey: snapshotKey,
            snapshotValue: snapshotValue
        },
        isPersonalView: isPersonalView
    });
};



const $55ef8b350847a858$export$c7495bd2aea2b6bc = ({ internalId: internalId, learnId: learnId, profileHasConsented: profileHasConsented })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc406a32200a03b6$export$6cbf77c1b1e30396), {
                hasHeader: false
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($55ef8b350847a858$var$StatsSnapshot, {
                internalId: internalId,
                learnId: learnId,
                profileHasConsented: profileHasConsented
            })
        })
    });
const $55ef8b350847a858$var$StatsSnapshot = ({ internalId: internalId, learnId: learnId, profileHasConsented: profileHasConsented })=>{
    const stats = new Map([
        [
            "learningAchievements",
            {
                label: "Learning achievements",
                value: 0
            }
        ],
        [
            "answersCreated",
            {
                label: "Answers",
                value: 0
            }
        ],
        [
            "acceptedAnswersCreated",
            {
                label: "Accepted solutions",
                value: 0
            }
        ],
        [
            "articlesCreated",
            {
                label: "Articles",
                value: 0
            }
        ],
        [
            "kudosReceived",
            {
                label: "Likes received",
                value: 0
            }
        ],
        [
            "totalPosts",
            {
                label: "Total posts",
                value: 0
            }
        ]
    ]);
    const { email: email } = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)() || {};
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    const isLoggedIn = (0, $e68713997378eddf$export$2e2bcd8739ae039)();
    const statsSnapshotResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $be0e9f0d021963cb$export$6083b409658e4d09), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    });
    let totalLearningAchievements = 0;
    if (learnId) {
        const badgesResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5c5c0f6b82e5b280$export$15a2e43f9400c215), {
            internalId: internalId
        }).unified?.unifiedProfile;
        totalLearningAchievements = badgesResponse?.learning?.recentLearningAchievementBadges?.totalCount ?? 0;
    }
    const forumsData = statsSnapshotResponse?.unified?.unifiedProfile?.forums?.snapshot;
    // temp fix for forums user id
    const forumsNodeId = statsSnapshotResponse?.unified?.unifiedProfile?.forums?.id;
    const forumsUserIdParts = (forumsNodeId ?? "").split("::forums/");
    const forumsUserId = forumsUserIdParts?.[1] ?? "";
    let forumsPostActivityUrl;
    if (forumsData?.id && forumsUserId) {
        const postsActivityUrl = (0, $7ef8d8aa49ecf9c6$export$c6601b379265eb67)(forumsUserId, "discussions", "activity");
        forumsPostActivityUrl = isLoggedIn ? (0, $7ef8d8aa49ecf9c6$export$1db7da00354b15ed)({
            redirectUrl: postsActivityUrl,
            email: email || ""
        }) : postsActivityUrl;
    }
    const hideArticleStats = (0, $4fca6bd638ae6930$export$73f46a93e1216cfe)();
    if (hideArticleStats) stats.delete("articlesCreated");
    let isAllStatsZero = true;
    if (forumsData) Object.entries(forumsData).forEach(([key, value])=>{
        const matchingStat = stats.get(key);
        if (matchingStat && typeof value === "number") {
            if (value > 0) isAllStatsZero = false;
            matchingStat.value = value;
            stats.set(key, matchingStat);
        }
    });
    const learningAchievementsStat = stats.get("learningAchievements");
    if (learningAchievementsStat) {
        if (totalLearningAchievements > 0) isAllStatsZero = false;
        learningAchievementsStat.value = totalLearningAchievements;
        stats.set("learningAchievements", learningAchievementsStat);
    }
    if (!profileHasConsented) stats.delete("learningAchievements");
    if (!isPersonalView && isAllStatsZero) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a44cdd096bb28cc$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e11946d314b99a3d$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "snapshot-container",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c11p5 _yv0e1g7m _1v5716hb",
                    hideArticleStats && "_yv0e1rzm _1v571g7m _km5ag31l _1ntsuojk"
                ]),
                children: Array.from(stats.entries()).sort(([keyA, { value: valueA }], [keyB, { value: valueB }])=>{
                    // Move zero values to the end
                    if (valueA === 0 && valueB !== 0) return 1;
                    if (valueA !== 0 && valueB === 0) return -1;
                    // Maintain original order if both are zero or both are non-zero
                    return 0;
                }).map(([key, { label: label, value: value }])=>!isPersonalView && value === 0 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_y3gn1h6o _1j3tgktf"
                        ]),
                        children: key === "totalPosts" && forumsPostActivityUrl ? value > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: forumsPostActivityUrl,
                            onClick: ()=>(0, $573e508d22f84a01$export$55e70457a816bd63)(key, value, isPersonalView),
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_syaz1kw7 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1ule _30l31kw7 _9oik1r31 _1bnxglyw _jf4cnqa1"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "stat-value-container",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1jwt _vwz4kb7n _ect4kwxw _1wybckbl _zg8l4jg8 _k48pzul8 _1dyz81m1",
                                        isAllStatsZero && "_syaz1k3w",
                                        value === 0 && "_syaz1k3w"
                                    ]),
                                    children: (0, $5950fde19a0508c0$export$2942cf5daa9fcc1)(value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "stat-label-container",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1blv _y3gn1h6o _ect4kwxw _1wyb7vkz _zg8l4jg8 _k48pzul8 _1bsbo7ol _19pkidpf _2hwx1wug _otyridpf _18u01wug _vwz4gktf _1dyzidpf"
                                    ]),
                                    children: label
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_y3gn1h6o _1j3tgktf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "stat-value-container",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1jwt _vwz4kb7n _ect4kwxw _1wybckbl _zg8l4jg8 _k48pzul8 _1dyz81m1",
                                        isAllStatsZero && "_syaz1k3w",
                                        value === 0 && "_syaz1k3w"
                                    ]),
                                    children: (0, $5950fde19a0508c0$export$2942cf5daa9fcc1)(value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "stat-label-container",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1blv _y3gn1h6o _ect4kwxw _1wyb7vkz _zg8l4jg8 _k48pzul8 _1bsbo7ol _19pkidpf _2hwx1wug _otyridpf _18u01wug _vwz4gktf _1dyzidpf"
                                    ]),
                                    children: label
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "stat-value-container",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1blv _vwz4kb7n _ect4kwxw _1wybckbl _zg8l4jg8 _k48pzul8 _1dyz81m1",
                                        isAllStatsZero && "_syaz1k3w",
                                        value === 0 && "_syaz1k3w"
                                    ]),
                                    children: (0, $5950fde19a0508c0$export$2942cf5daa9fcc1)(value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "stat-label-container",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1blv _y3gn1h6o _ect4kwxw _1wyb7vkz _zg8l4jg8 _k48pzul8 _1bsbo7ol _19pkidpf _2hwx1wug _otyridpf _18u01wug _vwz4gktf _1dyzidpf"
                                    ]),
                                    children: label
                                })
                            ]
                        })
                    }, key))
            })
        })
    });
};
var $55ef8b350847a858$export$2e2bcd8739ae039 = $55ef8b350847a858$var$StatsSnapshot;
const $55ef8b350847a858$var$scoreStyle = null;
const $55ef8b350847a858$var$zeroScoreStyle = null;
const $55ef8b350847a858$var$numberStyleTotalPosts = null;
const $55ef8b350847a858$var$numberStyle = null;
const $55ef8b350847a858$var$numberStyleAllZero = null;
const $55ef8b350847a858$var$labelStyle = null;
const $55ef8b350847a858$var$statsContainerStyles = null;
const $55ef8b350847a858$var$statsContainerStylesWithoutArticles = null;
const $55ef8b350847a858$var$plainLinkStyle = null;


/* KudosSummary.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");


var $10f21b5b6953fc2d$var$_KudosSummaryQuery;

const $10f21b5b6953fc2d$export$68ef570fcece8188 = $10f21b5b6953fc2d$var$_KudosSummaryQuery !== void 0 ? $10f21b5b6953fc2d$var$_KudosSummaryQuery : $10f21b5b6953fc2d$var$_KudosSummaryQuery = (parcelRequire("eOkFe"));



/* MainPanelSectionHeader.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");




const $60827b78b26318bf$export$98de7844f3808310 = (sectionName, isPersonalView, source = (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: source,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "sectionHeader",
        attributes: {
            sectionName: sectionName
        },
        isPersonalView: isPersonalView
    });
};


const $8b09ec013b267e49$var$MainPanelSectionHeader = ({ title: title, subtitle: subtitle, link: link, linkText: linkText, viewAllAnalyticsName: viewAllAnalyticsName, testId: testId })=>{
    const onClickViewAll = ()=>{
        // TODO find implementation of this component and add the proper registry data portal link with the correct actionSubjectId
        (0, $60827b78b26318bf$export$98de7844f3808310)(viewAllAnalyticsName ?? "sectionHeader", true);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _1bsb1osq _2lx2vrvc _1bah1yb4 _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1wybhiv4 _k48pzul8 _ect4kwxw _vwz4gosd _1mqw1tcg _1cf8zwfg"
                        ]),
                        children: title
                    }),
                    link && linkText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _4t3igosd _1yt41dzv _1bah1h6o _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_syaz1jwt _y3gn1h6o _ect41q02 _1wyb7vkz _k48pzul8 _vwz4gktf"
                            ]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_80omtlke"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                                    to: link,
                                    onClick: onClickViewAll,
                                    children: `View all`
                                })
                            })
                        })
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _1bsb1osq _2lx2vrvc _1bah1yb4 _4cvr1h6o",
                    "_syaz1blv _ect41v9d _1wybxjmg _zg8l4jg8 _k48pc13d _vwz4l6l0"
                ]),
                children: subtitle
            })
        ]
    });
};
const $8b09ec013b267e49$var$headerContainerStyles = null;
const $8b09ec013b267e49$var$cursorStyles = null;
const $8b09ec013b267e49$var$titleStyles = null;
const $8b09ec013b267e49$var$linkContainerStyles = null;
const $8b09ec013b267e49$var$linkStyles = null;
const $8b09ec013b267e49$var$rowStyles = null;
const $8b09ec013b267e49$var$subtitleStyles = null;
var $8b09ec013b267e49$export$2e2bcd8739ae039 = $8b09ec013b267e49$var$MainPanelSectionHeader;



/* SubSection.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");
const $78ff1af2299d0634$var$SubSection = ({ title: title, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_kqswh2mm _1e0c1txw _zulpxjmg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2lx21bp4 _4cvr1y6m _1ypb1fhb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz1blv _1iqs1cme _ect41q02 _1wyboxav _zg8l4jg8 _k48pzul8 _vwz4xjmg _1p1dangw"
                ]),
                children: title
            }),
            children
        ]
    });
var $78ff1af2299d0634$export$2e2bcd8739ae039 = $78ff1af2299d0634$var$SubSection;
const $78ff1af2299d0634$var$containerStyles = null;
const $78ff1af2299d0634$var$subSectionTitleStyles = null;


/* EmptyStateMessageBody.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");

const $92160255da0d8a25$var$EmptyStateMessageBody = ({ message: message, linkType: linkType, linkTo: linkTo, linkText: linkText, sendAnalyticsEvent: sendAnalyticsEvent = ()=>null, isButton: isButton = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz1blv _ect41v9d _1wybxjmg _zg8l4jg8 _k48p1nn1 _vwz4l6l0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: message
            }),
            linkType === "internal" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                href: linkTo,
                onClick: sendAnalyticsEvent,
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz1jwt _ect41q02 _1wybxjmg _zg8l4jg8 _k48pzul8 _vwz4gktf _80omtlke",
                    isButton && "_2rko1y44 _19it1f3p _1e0c1txw _4t3i1ylp _1yt41dzv _1bah1h6o _4cvr1h6o _1bsb1ns9"
                ]),
                children: linkText
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                role: "link",
                onClick: sendAnalyticsEvent,
                href: linkTo,
                target: "_blank",
                rel: "noreferrer",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz1jwt _ect41q02 _1wybxjmg _zg8l4jg8 _k48pzul8 _vwz4gktf _80omtlke",
                    isButton && "_2rko1y44 _19it1f3p _1e0c1txw _4t3i1ylp _1yt41dzv _1bah1h6o _4cvr1h6o _1bsb1ns9"
                ]),
                children: linkText
            })
        ]
    });
var $92160255da0d8a25$export$2e2bcd8739ae039 = $92160255da0d8a25$var$EmptyStateMessageBody;
const $92160255da0d8a25$var$emptyStateMessageStyles = null;
const $92160255da0d8a25$var$emptyStateLinkStyles = null;
const $92160255da0d8a25$var$secondaryButtonStyles = null;








// https://data-portal.internal.atlassian.com/analytics/registry/71739
const $9a59db8343324c6b$export$f6e4b24df4a21ebd = ()=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "link",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        actionSubjectId: "learnMoreAboutKudos",
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/85850
const $9a59db8343324c6b$export$e9e47999dc0f4f3d = ({ senderAaid: senderAaid, receiverAaid: receiverAaid, profileInternalId: profileInternalId })=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "button",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        actionSubjectId: "openRecognitionModal",
        isPersonalView: false,
        attributes: {
            senderAaid: senderAaid ?? "",
            receiverAaid: receiverAaid ?? "",
            profileInternalId: profileInternalId ?? ""
        }
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/85851
const $9a59db8343324c6b$export$af0144b723aef4e9 = ({ recognitionReason: recognitionReason, senderAaid: senderAaid, receiverAaid: receiverAaid, profileInternalId: profileInternalId })=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "button",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        actionSubjectId: "giveRecognitionButton",
        isPersonalView: false,
        attributes: {
            recognitionReason: recognitionReason ?? "",
            senderAaid: senderAaid ?? "",
            receiverAaid: receiverAaid ?? "",
            profileInternalId: profileInternalId ?? ""
        }
    });
};





/* KudosModal.tsx generated by @compiled/babel-plugin v0.29.1 */ 


var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $4xUU2 = parcelRequire("4xUU2");

var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $acw62 = parcelRequire("acw62");

var $119d56c93ccd46db$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $119d56c93ccd46db$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }));
};
$119d56c93ccd46db$var$InFocusGuard.propTypes = {};
var $119d56c93ccd46db$export$2e2bcd8739ae039 = $119d56c93ccd46db$var$InFocusGuard;



var $7WQrb = parcelRequire("7WQrb");
function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $292937b69072d1e6$export$5733e022b1d538cb = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $292937b69072d1e6$export$b3e9a9312f73723c = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$3a1d52767cbc07b8 = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$892cbf28e5518020 = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== "undefined"
});



var $acw62 = parcelRequire("acw62");
var $8e648ed3a7dabece$export$f5272e9b1168239c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


var $e86725766b4cde33$var$emptyArray = [];
var $e86725766b4cde33$var$FocusLock = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $acw62.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $acw62.useRef)();
    var isActive = (0, $acw62.useRef)(false);
    var originalFocusedElement = (0, $acw62.useRef)(null);
    var _useState2 = (0, $acw62.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e86725766b4cde33$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $acw62.useState)({}), id = _useState3[0];
    var onActivation = (0, $acw62.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $acw62.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $acw62.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $acw62.useCallback)(function(event) {
        if (isActive.current) (0, $292937b69072d1e6$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $292937b69072d1e6$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = (0, $acw62.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $8nd05.default)((_extends2 = {}, _extends2[0, $4xUU2.FOCUS_DISABLED] = disabled && "disabled", _extends2[0, $4xUU2.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $acw62.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SideCar, {
        id: id,
        sideCar: (0, $292937b69072d1e6$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, (0, $8nd05.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8e648ed3a7dabece$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
    }));
});
$e86725766b4cde33$var$FocusLock.propTypes = {};
var $e86725766b4cde33$export$2e2bcd8739ae039 = $e86725766b4cde33$var$FocusLock;



var $acw62 = parcelRequire("acw62");


var $g7ajw = parcelRequire("g7ajw");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");
function $bec73a156e960f78$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $g7ajw.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $kSlfw.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $bec73a156e960f78$export$2e2bcd8739ae039 = $bec73a156e960f78$var$withSideEffect;



var $jW7tt = parcelRequire("jW7tt");
var $5rKE2 = parcelRequire("5rKE2");
var $fpTn0 = parcelRequire("fpTn0");
var $kuWmi = parcelRequire("kuWmi");
var $6nqmI = parcelRequire("6nqmI");
var $dltQK = parcelRequire("dltQK");parcelRequire("iQq8m");
var $abhGZ = parcelRequire("abhGZ");
function $de7ba2c6b170eb4f$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $de7ba2c6b170eb4f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $de7ba2c6b170eb4f$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};



var $00df5dbe84bcea91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $00df5dbe84bcea91$var$isFreeFocus = function isFreeFocus() {
    return $00df5dbe84bcea91$var$focusOnBody() || (0, $6nqmI.focusIsHidden)();
};
var $00df5dbe84bcea91$var$lastActiveTrap = null;
var $00df5dbe84bcea91$var$lastActiveFocus = null;
var $00df5dbe84bcea91$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $00df5dbe84bcea91$var$lastPortaledElement = null;
var $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
var $00df5dbe84bcea91$var$windowFocused = false;
var $00df5dbe84bcea91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $00df5dbe84bcea91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($00df5dbe84bcea91$var$lastActiveTrap.whiteList || $00df5dbe84bcea91$var$defaultWhitelist)(activeElement);
};
var $00df5dbe84bcea91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $00df5dbe84bcea91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $00df5dbe84bcea91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement === element;
};
function $00df5dbe84bcea91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $00df5dbe84bcea91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($00df5dbe84bcea91$var$focusWasOutsideWindow);
    return $00df5dbe84bcea91$var$focusWasOutsideWindow === "meanwhile";
};
var $00df5dbe84bcea91$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $00df5dbe84bcea91$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $00df5dbe84bcea91$var$checkInHost(activeElement, area, area);
    });
};
var $00df5dbe84bcea91$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $dltQK.getFocusableNodes)(nodes, new Map());
};
var $00df5dbe84bcea91$var$isNotFocusable = function isNotFocusable(node) {
    return !$00df5dbe84bcea91$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $00df5dbe84bcea91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($00df5dbe84bcea91$var$lastActiveTrap) {
        var _lastActiveTrap = $00df5dbe84bcea91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement;
        if ($00df5dbe84bcea91$var$focusOnBody() && $00df5dbe84bcea91$var$lastActiveFocus && $00df5dbe84bcea91$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($00df5dbe84bcea91$var$lastActiveFocus) || $00df5dbe84bcea91$var$isNotFocusable($00df5dbe84bcea91$var$lastActiveFocus)) {
                var newTarget = $00df5dbe84bcea91$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $de7ba2c6b170eb4f$export$c613fed06e332533)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$00df5dbe84bcea91$var$focusWasOutside(crossFrame) || !noFocusGuards || !$00df5dbe84bcea91$var$lastActiveFocus || $00df5dbe84bcea91$var$windowFocused) return false;
                var nodes = $00df5dbe84bcea91$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $00df5dbe84bcea91$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $00df5dbe84bcea91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$00df5dbe84bcea91$var$isFreeFocus() || !$00df5dbe84bcea91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $kuWmi.focusInside)(workingArea) || activeElement && $00df5dbe84bcea91$var$withinHost(activeElement, workingArea) || $00df5dbe84bcea91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$00df5dbe84bcea91$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $abhGZ.moveFocusInside)(workingArea, $00df5dbe84bcea91$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $00df5dbe84bcea91$var$lastPortaledElement = {};
                        }
                    }
                    $00df5dbe84bcea91$var$lastActiveFocus = document && document.activeElement;
                    if ($00df5dbe84bcea91$var$lastActiveFocus !== document.body) $00df5dbe84bcea91$var$tryRestoreFocus = (0, $jW7tt.captureFocusRestore)($00df5dbe84bcea91$var$lastActiveFocus);
                    $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $5rKE2.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $00df5dbe84bcea91$var$onTrap = function onTrap(event) {
    if ($00df5dbe84bcea91$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $00df5dbe84bcea91$var$onBlur = function onBlur() {
    return (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
};
var $00df5dbe84bcea91$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $00df5dbe84bcea91$var$recordPortal(currentNode, source);
};
var $00df5dbe84bcea91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $00df5dbe84bcea91$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onBlur: $00df5dbe84bcea91$var$onBlur,
        onFocus: $00df5dbe84bcea91$var$onFocus
    }, children);
};
$00df5dbe84bcea91$var$FocusTrap.propTypes = {};
var $00df5dbe84bcea91$var$onWindowFocus = function onWindowFocus() {
    $00df5dbe84bcea91$var$windowFocused = true;
};
var $00df5dbe84bcea91$var$onWindowBlur = function onWindowBlur() {
    $00df5dbe84bcea91$var$windowFocused = false;
    $00df5dbe84bcea91$var$focusWasOutsideWindow = "just";
    (0, $de7ba2c6b170eb4f$export$6523025722806278)(function() {
        $00df5dbe84bcea91$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $00df5dbe84bcea91$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.addEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.addEventListener("focus", $00df5dbe84bcea91$var$onWindowFocus);
    window.addEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
var $00df5dbe84bcea91$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.removeEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.removeEventListener("focus", $00df5dbe84bcea91$var$onWindowFocus);
    window.removeEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
function $00df5dbe84bcea91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $00df5dbe84bcea91$var$focusLockAPI = {
    moveFocusInside: (0, $abhGZ.moveFocusInside),
    focusInside: (0, $kuWmi.focusInside),
    focusNextElement: (0, $fpTn0.focusNextElement),
    focusPrevElement: (0, $fpTn0.focusPrevElement),
    focusFirstElement: (0, $fpTn0.focusFirstElement),
    focusLastElement: (0, $fpTn0.focusLastElement),
    captureFocusRestore: (0, $jW7tt.captureFocusRestore)
};
function $00df5dbe84bcea91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$00df5dbe84bcea91$var$lastActiveTrap) $00df5dbe84bcea91$var$attachHandler();
    var lastTrap = $00df5dbe84bcea91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $00df5dbe84bcea91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $00df5dbe84bcea91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($00df5dbe84bcea91$var$focusLockAPI);
        $00df5dbe84bcea91$var$activateTrap(true);
        (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
    } else {
        $00df5dbe84bcea91$var$detachHandler();
        $00df5dbe84bcea91$var$lastActiveFocus = null;
    }
}
(0, $292937b69072d1e6$export$5733e022b1d538cb).assignSyncMedium($00df5dbe84bcea91$var$onFocus);
(0, $292937b69072d1e6$export$b3e9a9312f73723c).assignMedium($00df5dbe84bcea91$var$onBlur);
(0, $292937b69072d1e6$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($00df5dbe84bcea91$var$focusLockAPI);
});
var $00df5dbe84bcea91$export$2e2bcd8739ae039 = (0, $bec73a156e960f78$export$2e2bcd8739ae039)($00df5dbe84bcea91$var$reducePropsToState, $00df5dbe84bcea91$var$handleStateChangeOnClient)($00df5dbe84bcea91$var$FocusWatcher);


var $afd3cd9c4d0274d7$var$FocusLockCombination = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e86725766b4cde33$export$2e2bcd8739ae039), (0, $8nd05.default)({
        sideCar: (0, $00df5dbe84bcea91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $afd3cd9c4d0274d7$var$_ref = (0, $e86725766b4cde33$export$2e2bcd8739ae039).propTypes || {}, $afd3cd9c4d0274d7$var$sideCar = $afd3cd9c4d0274d7$var$_ref.sideCar, $afd3cd9c4d0274d7$var$propTypes = (0, $1En50.default)($afd3cd9c4d0274d7$var$_ref, [
    "sideCar"
]);
$afd3cd9c4d0274d7$var$FocusLockCombination.propTypes = {};
var $afd3cd9c4d0274d7$export$2e2bcd8739ae039 = $afd3cd9c4d0274d7$var$FocusLockCombination;



var $9962412629625ccb$export$2e2bcd8739ae039 = (0, $afd3cd9c4d0274d7$export$2e2bcd8739ae039);


var $cf2505162f62ed75$exports = {};
"use strict";
Object.defineProperty($cf2505162f62ed75$exports, "__esModule", {
    value: true
});
var $9ce482b93321ce99$exports = {};
"use strict";
Object.defineProperty($9ce482b93321ce99$exports, "__esModule", {
    value: true
});
var $9ce482b93321ce99$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $9ce482b93321ce99$var$_react2 = $9ce482b93321ce99$var$_interopRequireDefault($acw62);

var $djCxr = parcelRequire("djCxr");
var $1129dd3c6936dec9$exports = {};
"use strict";
Object.defineProperty($1129dd3c6936dec9$exports, "__esModule", {
    value: true
});
$1129dd3c6936dec9$exports.TouchScrollable = undefined;
var $1129dd3c6936dec9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1129dd3c6936dec9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $djCxr = parcelRequire("djCxr");
var $76f11057e191f2b2$exports = {};
"use strict";
Object.defineProperty($76f11057e191f2b2$exports, "__esModule", {
    value: true
});
$76f11057e191f2b2$exports.pipe = $76f11057e191f2b2$exports.listenerOptions = undefined;
$76f11057e191f2b2$exports.preventTouchMove = $76f11057e191f2b2$var$preventTouchMove;
$76f11057e191f2b2$exports.allowTouchMove = $76f11057e191f2b2$var$allowTouchMove;
$76f11057e191f2b2$exports.preventInertiaScroll = $76f11057e191f2b2$var$preventInertiaScroll;
$76f11057e191f2b2$exports.isTouchDevice = $76f11057e191f2b2$var$isTouchDevice;
$76f11057e191f2b2$exports.camelToKebab = $76f11057e191f2b2$var$camelToKebab;
$76f11057e191f2b2$exports.parse = $76f11057e191f2b2$var$parse;
$76f11057e191f2b2$exports.getPadding = $76f11057e191f2b2$var$getPadding;
$76f11057e191f2b2$exports.getWindowHeight = $76f11057e191f2b2$var$getWindowHeight;
$76f11057e191f2b2$exports.getDocumentHeight = $76f11057e191f2b2$var$getDocumentHeight;
$76f11057e191f2b2$exports.makeStyleTag = $76f11057e191f2b2$var$makeStyleTag;
$76f11057e191f2b2$exports.injectStyles = $76f11057e191f2b2$var$injectStyles;
$76f11057e191f2b2$exports.insertStyleTag = $76f11057e191f2b2$var$insertStyleTag;

var $djCxr = parcelRequire("djCxr");
var $76f11057e191f2b2$var$listenerOptions = $76f11057e191f2b2$exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $76f11057e191f2b2$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $76f11057e191f2b2$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $76f11057e191f2b2$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $76f11057e191f2b2$var$isTouchDevice() {
    if (!$djCxr.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $76f11057e191f2b2$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $76f11057e191f2b2$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $76f11057e191f2b2$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $76f11057e191f2b2$var$pipe = $76f11057e191f2b2$exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($76f11057e191f2b2$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $76f11057e191f2b2$var$getPadding() {
    if (!$djCxr.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $76f11057e191f2b2$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($djCxr.canUseDOM) return window.innerHeight * multiplier;
}
function $76f11057e191f2b2$var$getDocumentHeight() {
    if ($djCxr.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $76f11057e191f2b2$var$makeStyleTag() {
    if (!$djCxr.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $76f11057e191f2b2$var$injectStyles(tag, css) {
    if (!$djCxr.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $76f11057e191f2b2$var$insertStyleTag(tag) {
    if (!$djCxr.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}


function $1129dd3c6936dec9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $1129dd3c6936dec9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1129dd3c6936dec9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1129dd3c6936dec9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1129dd3c6936dec9$var$TouchScrollable = $1129dd3c6936dec9$exports.TouchScrollable = function(_PureComponent) {
    $1129dd3c6936dec9$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $1129dd3c6936dec9$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1129dd3c6936dec9$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $1129dd3c6936dec9$var$_possibleConstructorReturn(_this, _ret);
    }
    $1129dd3c6936dec9$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$djCxr.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $76f11057e191f2b2$exports.preventInertiaScroll, $76f11057e191f2b2$exports.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $76f11057e191f2b2$exports.allowTouchMove, $76f11057e191f2b2$exports.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$djCxr.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $76f11057e191f2b2$exports.preventInertiaScroll, $76f11057e191f2b2$exports.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $76f11057e191f2b2$exports.allowTouchMove, $76f11057e191f2b2$exports.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $1129dd3c6936dec9$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $acw62.cloneElement)(children, $1129dd3c6936dec9$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($acw62.PureComponent);


var $43807214af823376$exports = {};
"use strict";
Object.defineProperty($43807214af823376$exports, "__esModule", {
    value: true
});
var $43807214af823376$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$43807214af823376$exports.default = $43807214af823376$var$withLockSheet;

var $acw62 = parcelRequire("acw62");
var $43807214af823376$var$_react2 = $43807214af823376$var$_interopRequireDefault($acw62);

function $43807214af823376$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43807214af823376$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43807214af823376$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $43807214af823376$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $43807214af823376$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $43807214af823376$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $43807214af823376$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $43807214af823376$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $76f11057e191f2b2$exports.makeStyleTag)();
                if (!sheet) return;
                (0, $76f11057e191f2b2$exports.injectStyles)(sheet, styles);
                (0, $76f11057e191f2b2$exports.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $76f11057e191f2b2$exports.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $76f11057e191f2b2$exports.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $43807214af823376$var$_possibleConstructorReturn(_this, _ret);
        }
        $43807214af823376$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $43807214af823376$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($acw62.PureComponent);
}


var $9ce482b93321ce99$var$_withLockSheet2 = $9ce482b93321ce99$var$_interopRequireDefault($43807214af823376$exports);
var $b2bceace3becf4c9$exports = {};
"use strict";
Object.defineProperty($b2bceace3becf4c9$exports, "__esModule", {
    value: true
});
var $b2bceace3becf4c9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$b2bceace3becf4c9$exports.default = $b2bceace3becf4c9$var$withTouchListeners;

var $acw62 = parcelRequire("acw62");
var $b2bceace3becf4c9$var$_react2 = $b2bceace3becf4c9$var$_interopRequireDefault($acw62);

var $djCxr = parcelRequire("djCxr");

function $b2bceace3becf4c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2bceace3becf4c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b2bceace3becf4c9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b2bceace3becf4c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $b2bceace3becf4c9$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $b2bceace3becf4c9$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $b2bceace3becf4c9$var$_classCallCheck(this, TouchProvider);
            return $b2bceace3becf4c9$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $b2bceace3becf4c9$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$djCxr.canUseDOM || !(0, $76f11057e191f2b2$exports.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $76f11057e191f2b2$exports.preventTouchMove, $76f11057e191f2b2$exports.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$djCxr.canUseDOM || !(0, $76f11057e191f2b2$exports.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $76f11057e191f2b2$exports.preventTouchMove, $76f11057e191f2b2$exports.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $b2bceace3becf4c9$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($acw62.PureComponent);
}


var $9ce482b93321ce99$var$_withTouchListeners2 = $9ce482b93321ce99$var$_interopRequireDefault($b2bceace3becf4c9$exports);

function $9ce482b93321ce99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ce482b93321ce99$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ce482b93321ce99$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9ce482b93321ce99$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9ce482b93321ce99$var$ScrollLock = function(_PureComponent) {
    $9ce482b93321ce99$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $9ce482b93321ce99$var$_classCallCheck(this, ScrollLock);
        return $9ce482b93321ce99$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $9ce482b93321ce99$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$djCxr.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $9ce482b93321ce99$var$_react2.default.createElement($1129dd3c6936dec9$exports.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($acw62.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $9ce482b93321ce99$var$compose = (0, $76f11057e191f2b2$exports.pipe)($9ce482b93321ce99$var$_withTouchListeners2.default, $9ce482b93321ce99$var$_withLockSheet2.default);
var $9ce482b93321ce99$var$SheetLock = $9ce482b93321ce99$var$compose($9ce482b93321ce99$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $9ce482b93321ce99$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $9ce482b93321ce99$var$_react2.default.createElement($9ce482b93321ce99$var$SheetLock, props) : props.children;
};
$9ce482b93321ce99$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
$9ce482b93321ce99$exports.default = $9ce482b93321ce99$var$LockToggle;


Object.defineProperty($cf2505162f62ed75$exports, "default", {
    enumerable: true,
    get: function get() {
        return $cf2505162f62ed75$var$_interopRequireDefault($9ce482b93321ce99$exports).default;
    }
});

Object.defineProperty($cf2505162f62ed75$exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $1129dd3c6936dec9$exports.TouchScrollable;
    }
});
function $cf2505162f62ed75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $d29f5b3d0d51225a$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $d29f5b3d0d51225a$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $acw62.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $acw62.useRef)(true);
    var committed = (0, $acw62.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $d29f5b3d0d51225a$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $acw62.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $d29f5b3d0d51225a$export$33752cf3ee811995(callback, inputs) {
    return $d29f5b3d0d51225a$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $d29f5b3d0d51225a$export$1538c33de8887b59 = $d29f5b3d0d51225a$export$b6feb8998cd9b342;
var $d29f5b3d0d51225a$export$35808ee640e87ca7 = $d29f5b3d0d51225a$export$33752cf3ee811995;



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $fe9adb20c41a65ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe9adb20c41a65ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe9adb20c41a65ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe9adb20c41a65ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fe9adb20c41a65ad$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fe9adb20c41a65ad$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $fe9adb20c41a65ad$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $fe9adb20c41a65ad$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $fe9adb20c41a65ad$var$_objectSpread($fe9adb20c41a65ad$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $94aff9b9173eee4d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $94aff9b9173eee4d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $94aff9b9173eee4d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94aff9b9173eee4d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $94aff9b9173eee4d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $94aff9b9173eee4d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $94aff9b9173eee4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $94aff9b9173eee4d$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $fe9adb20c41a65ad$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $a43742e34dd4eabd$var$AnalyticsNextContext = (0, $acw62.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $a43742e34dd4eabd$export$2e2bcd8739ae039 = $a43742e34dd4eabd$var$AnalyticsNextContext;


var $025517dbaab8c128$export$2e2bcd8739ae039 = (0, $a43742e34dd4eabd$export$2e2bcd8739ae039);


var $d0165f47f9d720fb$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $025517dbaab8c128$export$2e2bcd8739ae039));
};


function $644f5cd0da7c3c67$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d0165f47f9d720fb$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $d29f5b3d0d51225a$export$33752cf3ee811995)(function(payload) {
        return new (0, $94aff9b9173eee4d$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $a25ba612a14d7f71$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $ee8f8175665f2347$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee8f8175665f2347$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee8f8175665f2347$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee8f8175665f2347$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ee8f8175665f2347$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $644f5cd0da7c3c67$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $a25ba612a14d7f71$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $a25ba612a14d7f71$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ee8f8175665f2347$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $532567ef34010e3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $532567ef34010e3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $532567ef34010e3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $532567ef34010e3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $532567ef34010e3c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $532567ef34010e3c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $532567ef34010e3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $532567ef34010e3c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $532567ef34010e3c$var$_objectSpread($532567ef34010e3c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $795c1150128619c9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $795c1150128619c9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $795c1150128619c9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($795c1150128619c9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $795c1150128619c9$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $795c1150128619c9$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $795c1150128619c9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $795c1150128619c9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $795c1150128619c9$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $795c1150128619c9$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $532567ef34010e3c$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $b99dcc30739da40b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $025517dbaab8c128$export$2e2bcd8739ae039));
};


function $d84aa386e0d9c56a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $b99dcc30739da40b$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $d29f5b3d0d51225a$export$33752cf3ee811995)(function(payload) {
        return new (0, $795c1150128619c9$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $68e7254cca862cf6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $d3b4823309526471$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3b4823309526471$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3b4823309526471$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3b4823309526471$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3b4823309526471$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d84aa386e0d9c56a$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $68e7254cca862cf6$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $68e7254cca862cf6$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d3b4823309526471$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $662598f897e92de9$export$2e2bcd8739ae039() {}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $6caa0d9fe444653d$export$4b84fd0e2c617bd = "#FFEBE6";
var $6caa0d9fe444653d$export$b34b069eff244586 = "#FFBDAD";
var $6caa0d9fe444653d$export$be802dd0d8b57f35 = "#FF8F73";
var $6caa0d9fe444653d$export$60847d42f9da92a6 = "#FF7452";
var $6caa0d9fe444653d$export$4a7404f376229999 = "#FF5630";
var $6caa0d9fe444653d$export$2010d0fb4295b346 = "#DE350B";
var $6caa0d9fe444653d$export$2837b5a1a71d5c02 = "#BF2600";
var $6caa0d9fe444653d$export$8d9596b529bbb9cf = "#FFFAE6";
var $6caa0d9fe444653d$export$41060a744ab0b7ae = "#FFF0B3";
var $6caa0d9fe444653d$export$1cc05bbbf340e559 = "#FFE380";
var $6caa0d9fe444653d$export$5aae31392d72caaa = "#FFC400";
var $6caa0d9fe444653d$export$c6930421db9fa514 = "#FFAB00";
var $6caa0d9fe444653d$export$59619663aa6500fb = "#FF991F";
var $6caa0d9fe444653d$export$874739ea9e379ab6 = "#FF8B00";
var $6caa0d9fe444653d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $6caa0d9fe444653d$export$69a3bf21b9686c2b = "#ABF5D1";
var $6caa0d9fe444653d$export$afbce1382ec95f73 = "#79F2C0";
var $6caa0d9fe444653d$export$747d86715d4175de = "#57D9A3";
var $6caa0d9fe444653d$export$940e1f69e873f202 = "#36B37E";
var $6caa0d9fe444653d$export$a49394138f7b8e85 = "#00875A";
var $6caa0d9fe444653d$export$6fa04827ac68a4fb = "#006644";
var $6caa0d9fe444653d$export$226de0355ed012f8 = "#DEEBFF";
var $6caa0d9fe444653d$export$8c13c2ee36917869 = "#B3D4FF";
var $6caa0d9fe444653d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $6caa0d9fe444653d$export$215b7063051591f1 = "#2684FF";
var $6caa0d9fe444653d$export$e62e8919cca44969 = "#0065FF";
var $6caa0d9fe444653d$export$b3de0ae08da2ce64 = "#0052CC";
var $6caa0d9fe444653d$export$a6ee3d71bc067634 = "#0747A6";
var $6caa0d9fe444653d$export$67f15409e87642a1 = "#669DF1";
var $6caa0d9fe444653d$export$f0539dbc42dbb067 = "#8FB8F6";
var $6caa0d9fe444653d$export$363e4475840015bb = "#EAE6FF";
var $6caa0d9fe444653d$export$4b0a4417ed59760f = "#C0B6F2";
var $6caa0d9fe444653d$export$6011520a64d9a187 = "#998DD9";
var $6caa0d9fe444653d$export$a7175d4e9206bc80 = "#8777D9";
var $6caa0d9fe444653d$export$b48405b95304b5a1 = "#6554C0";
var $6caa0d9fe444653d$export$c71e4279dd54a18d = "#5243AA";
var $6caa0d9fe444653d$export$147899de772240ec = "#403294";
var $6caa0d9fe444653d$export$2cf711fe14c66f06 = "#E6FCFF";
var $6caa0d9fe444653d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $6caa0d9fe444653d$export$776c9c497ef08533 = "#79E2F2";
var $6caa0d9fe444653d$export$69cb3ca10c1e330e = "#00C7E6";
var $6caa0d9fe444653d$export$9dc1ef0f3f48059b = "#00B8D9";
var $6caa0d9fe444653d$export$7c835c78b6fcdef8 = "#00A3BF";
var $6caa0d9fe444653d$export$6036577f95c3877e = "#008DA6";
var $6caa0d9fe444653d$export$29a4f05edc054374 = "#FFFFFF";
var $6caa0d9fe444653d$export$e655ef011c4aa1a2 = "#FAFBFC";
var $6caa0d9fe444653d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $6caa0d9fe444653d$export$3e51e8f1440314ba = "#EBECF0";
var $6caa0d9fe444653d$export$1ce2d1575d444ceb = "#DFE1E6";
var $6caa0d9fe444653d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $6caa0d9fe444653d$export$c2e91cbeada39b8b = "#B3BAC5";
var $6caa0d9fe444653d$export$5f71e19f3a7ad9de = "#A5ADBA";
var $6caa0d9fe444653d$export$eaa8c8a70ac22806 = "#97A0AF";
var $6caa0d9fe444653d$export$7c87d337fb91a97d = "#8993A4";
var $6caa0d9fe444653d$export$d6447c357493214f = "#7A869A";
var $6caa0d9fe444653d$export$f563ee71e9ee74cd = "#6B778C";
var $6caa0d9fe444653d$export$e2ef2124cf4024b1 = "#5E6C84";
var $6caa0d9fe444653d$export$eece5f492e429f08 = "#505F79";
var $6caa0d9fe444653d$export$c39c0fe0f26207ae = "#42526E";
var $6caa0d9fe444653d$export$7090862dc3038a9f = "#344563";
var $6caa0d9fe444653d$export$ad0bacf983b7ddaa = "#253858";
var $6caa0d9fe444653d$export$7d61b15e0da132af = "#172B4D";
var $6caa0d9fe444653d$export$fbda843f0a27fe96 = "#091E42";
var $6caa0d9fe444653d$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $6caa0d9fe444653d$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $6caa0d9fe444653d$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $6caa0d9fe444653d$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $6caa0d9fe444653d$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $6caa0d9fe444653d$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $6caa0d9fe444653d$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $6caa0d9fe444653d$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $6caa0d9fe444653d$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $6caa0d9fe444653d$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $6caa0d9fe444653d$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $6caa0d9fe444653d$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $6caa0d9fe444653d$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $6caa0d9fe444653d$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $6caa0d9fe444653d$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $6caa0d9fe444653d$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $6caa0d9fe444653d$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $6caa0d9fe444653d$export$2f6319cf7d736c2a = "#E6EDFA";
var $6caa0d9fe444653d$export$95126bc8884d6634 = "#DCE5F5";
var $6caa0d9fe444653d$export$8338d8c35d44ff1 = "#CED9EB";
var $6caa0d9fe444653d$export$5368d76ae4fbbda7 = "#B8C7E0";
var $6caa0d9fe444653d$export$9f0a771d16ec8d36 = "#ABBBD6";
var $6caa0d9fe444653d$export$abcf8c38338b4aa5 = "#9FB0CC";
var $6caa0d9fe444653d$export$97e81faa16a182c7 = "#8C9CB8";
var $6caa0d9fe444653d$export$bfe21c59123ecf33 = "#7988A3";
var $6caa0d9fe444653d$export$ee82aa2ea6a1558 = "#67758F";
var $6caa0d9fe444653d$export$682927c6ed76be02 = "#56637A";
var $6caa0d9fe444653d$export$91fd9994c5be9757 = "#455166";
var $6caa0d9fe444653d$export$d281fbfe3cff2df6 = "#3B475C";
var $6caa0d9fe444653d$export$3902c91d8b98a753 = "#313D52";
var $6caa0d9fe444653d$export$8e8133c1ba5845b5 = "#283447";
var $6caa0d9fe444653d$export$33ff357f6620b39 = "#202B3D";
var $6caa0d9fe444653d$export$633847cf062b69e0 = "#1B2638";
var $6caa0d9fe444653d$export$9776a6e503bdbf76 = "#121A29";
var $6caa0d9fe444653d$export$6c813d5160dff5db = "#0E1624";
var $6caa0d9fe444653d$export$3d4f271a500072a = "#0D1424";
var $6caa0d9fe444653d$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $6caa0d9fe444653d$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $6caa0d9fe444653d$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $6caa0d9fe444653d$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $6caa0d9fe444653d$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $6caa0d9fe444653d$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $6caa0d9fe444653d$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $6caa0d9fe444653d$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $6caa0d9fe444653d$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $6caa0d9fe444653d$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $6caa0d9fe444653d$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $6caa0d9fe444653d$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $6caa0d9fe444653d$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $6caa0d9fe444653d$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $6caa0d9fe444653d$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $6caa0d9fe444653d$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $6caa0d9fe444653d$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $6caa0d9fe444653d$export$d2adc5dedf09fced = "#292A2E";
var $6caa0d9fe444653d$export$f51762073d2bb381 = "#94C748";
var $6caa0d9fe444653d$export$95e26d54def96891 = "#B3DF72";


/* eslint-disable no-console */ var $749b72ace1112d40$var$printed = {};
function $749b72ace1112d40$export$2e2bcd8739ae039(message) {
    if ($749b72ace1112d40$var$printed[message]) return;
    $749b72ace1112d40$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $423a0fb8286e3660$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $749b72ace1112d40$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $423a0fb8286e3660$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $f728f4d4061c9d59$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $f728f4d4061c9d59$export$c93026a968943f95 = "light";
var $f728f4d4061c9d59$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $f728f4d4061c9d59$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f728f4d4061c9d59$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f728f4d4061c9d59$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $f728f4d4061c9d59$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $f728f4d4061c9d59$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $f728f4d4061c9d59$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $f728f4d4061c9d59$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $6caa0d9fe444653d$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f728f4d4061c9d59$export$6d8204c2cb2e06b8() / 4;
    (0, $423a0fb8286e3660$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f728f4d4061c9d59$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f728f4d4061c9d59$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f728f4d4061c9d59$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $423a0fb8286e3660$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $f728f4d4061c9d59$export$ba1d834b86d72a09 = $f728f4d4061c9d59$export$a1b3edb637fb4f35;
var $f728f4d4061c9d59$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $6caa0d9fe444653d$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $6caa0d9fe444653d$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $6caa0d9fe444653d$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $aac7c3d609a8c84e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aac7c3d609a8c84e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aac7c3d609a8c84e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aac7c3d609a8c84e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aac7c3d609a8c84e$var$packageName = "@atlaskit/blanket";
var $aac7c3d609a8c84e$var$packageVersion = "13.3.5";
var $aac7c3d609a8c84e$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $aac7c3d609a8c84e$var$packageName,
    packageVersion: $aac7c3d609a8c84e$var$packageVersion
};
var $aac7c3d609a8c84e$var$baseStyles = (0, $jjlaj.css)({
    position: "fixed",
    zIndex: (0, $f728f4d4061c9d59$export$7be255094ccdc533).blanket(),
    inset: 0,
    backgroundColor: "var(--ds-blanket, ".concat((0, $6caa0d9fe444653d$export$486ab785e4bac3c6), ")"),
    overflowY: "auto",
    pointerEvents: "initial"
});
var $aac7c3d609a8c84e$var$shouldAllowClickThroughStyles = (0, $jjlaj.css)({
    pointerEvents: "none"
});
var $aac7c3d609a8c84e$var$invisibleStyles = (0, $jjlaj.css)({
    backgroundColor: "transparent"
});
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $aac7c3d609a8c84e$var$Blanket = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $662598f897e92de9$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $acw62.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $d3b4823309526471$export$a4687b0234b40e28)($aac7c3d609a8c84e$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $aac7c3d609a8c84e$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $acw62.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $acw62.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ (0, $jjlaj.jsx)("div", {
        role: "presentation",
        css: [
            $aac7c3d609a8c84e$var$baseStyles,
            shouldAllowClickThrough && $aac7c3d609a8c84e$var$shouldAllowClickThroughStyles,
            !isTinted && $aac7c3d609a8c84e$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$aac7c3d609a8c84e$var$Blanket.displayName = "Blanket";
var $aac7c3d609a8c84e$export$2e2bcd8739ae039 = $aac7c3d609a8c84e$var$Blanket;


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $d3997b4aab843580$export$2e2bcd8739ae039() {}



var $acw62 = parcelRequire("acw62");

var $b3f08d7ea81e76d6$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $b3f08d7ea81e76d6$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $d3997b4aab843580$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $b3f08d7ea81e76d6$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($b3f08d7ea81e76d6$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $acw62.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b3f08d7ea81e76d6$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $b3f08d7ea81e76d6$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var value = (0, $acw62.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b3f08d7ea81e76d6$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $b3f08d7ea81e76d6$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($b3f08d7ea81e76d6$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b3f08d7ea81e76d6$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b3f08d7ea81e76d6$var$LayeringProvider, null, content);
};



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
var $e9ca40ca2325ac8e$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $e9ca40ca2325ac8e$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $e9ca40ca2325ac8e$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $d145bd79772829f1$export$368bacef0dacbe05 = 25;
var $d145bd79772829f1$export$2023a81c8547415f = $d145bd79772829f1$export$368bacef0dacbe05 * 4;
var $d145bd79772829f1$export$6fa259be09e118a7 = $d145bd79772829f1$export$368bacef0dacbe05 * 14;
var $d145bd79772829f1$export$9424640c29bc466d = $d145bd79772829f1$export$368bacef0dacbe05 * 28;



var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $465494c09bea9747$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $465494c09bea9747$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$465494c09bea9747$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $465494c09bea9747$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($465494c09bea9747$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$465494c09bea9747$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $465494c09bea9747$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $465494c09bea9747$export$ff7706047246b98b = function prefersReducedMotion() {
    return $465494c09bea9747$export$f0f789643ba5a83c;
};




var $acw62 = parcelRequire("acw62");
var $33b808b0547937cc$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $33b808b0547937cc$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $33b808b0547937cc$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $33b808b0547937cc$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $33b808b0547937cc$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $183a833228617892$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $183a833228617892$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $acw62.createContext)($183a833228617892$export$d1e013d71d2e2121);
var $183a833228617892$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $183a833228617892$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($183a833228617892$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $183a833228617892$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $183a833228617892$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $183a833228617892$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $183a833228617892$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $183a833228617892$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $183a833228617892$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $465494c09bea9747$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $183a833228617892$export$7032ae6d9d98bedd(previousChildren);
    var current = $183a833228617892$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $183a833228617892$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $183a833228617892$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $183a833228617892$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $183a833228617892$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $183a833228617892$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($183a833228617892$export$b9c4904d7a6929e6);
};
$183a833228617892$var$ExitingPersistence.displayName = "ExitingPersistence";
var $183a833228617892$export$2e2bcd8739ae039 = $183a833228617892$var$ExitingPersistence;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $2e4a70dc4f7a83ef$export$2e2bcd8739ae039() {}



var $acw62 = parcelRequire("acw62");
var $e8e989d9395983cb$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $a0a7320c3aacf366$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $cbd330df05180142$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $2e4a70dc4f7a83ef$export$2e2bcd8739ae039)
    };
});
var $cbd330df05180142$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $a0a7320c3aacf366$export$c485849f2e393253)();
    var context = (0, $acw62.useContext)($cbd330df05180142$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $cbd330df05180142$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $e8e989d9395983cb$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cbd330df05180142$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $cbd330df05180142$export$2e2bcd8739ae039 = $cbd330df05180142$var$StaggeredEntrance;


function $290b44577c627b97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $290b44577c627b97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $290b44577c627b97$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $290b44577c627b97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $290b44577c627b97$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $290b44577c627b97$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $d145bd79772829f1$export$9424640c29bc466d) : _ref$duration;
    var staggered = (0, $cbd330df05180142$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $183a833228617892$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $33b808b0547937cc$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $290b44577c627b97$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jjlaj.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($290b44577c627b97$var$_objectSpread($290b44577c627b97$var$_objectSpread({}, (0, $465494c09bea9747$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $290b44577c627b97$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jjlaj.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $290b44577c627b97$export$2e2bcd8739ae039 = $290b44577c627b97$var$EnteringMotion;


function $c1a7c75e4c42bc2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1a7c75e4c42bc2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1a7c75e4c42bc2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1a7c75e4c42bc2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c1a7c75e4c42bc2c$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $c1a7c75e4c42bc2c$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $c1a7c75e4c42bc2c$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $c1a7c75e4c42bc2c$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c1a7c75e4c42bc2c$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $c1a7c75e4c42bc2c$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $c1a7c75e4c42bc2c$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c1a7c75e4c42bc2c$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c1a7c75e4c42bc2c$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $d145bd79772829f1$export$9424640c29bc466d) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $c1a7c75e4c42bc2c$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $290b44577c627b97$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $c1a7c75e4c42bc2c$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $c1a7c75e4c42bc2c$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $e9ca40ca2325ac8e$export$c07234257a03d5e9;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c1a7c75e4c42bc2c$export$2e2bcd8739ae039 = $c1a7c75e4c42bc2c$var$FadeIn;


var $c1ad1fc6548657e1$var$_ref, $c1ad1fc6548657e1$var$_process, $c1ad1fc6548657e1$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c1ad1fc6548657e1$var$TESTS_MODE = ($c1ad1fc6548657e1$var$_ref = (globalThis === null || globalThis === void 0 || ($c1ad1fc6548657e1$var$_process = globalThis.process) === null || $c1ad1fc6548657e1$var$_process === void 0 || ($c1ad1fc6548657e1$var$_process = $c1ad1fc6548657e1$var$_process.env) === null || $c1ad1fc6548657e1$var$_process === void 0 ? void 0 : $c1ad1fc6548657e1$var$_process.JEST_WORKER_ID) !== undefined, $c1ad1fc6548657e1$var$_ref !== void 0) ? $c1ad1fc6548657e1$var$_ref : false;
var $c1ad1fc6548657e1$var$DEBUG_MODE = !$c1ad1fc6548657e1$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c1ad1fc6548657e1$var$_process2 = globalThis.process) === null || $c1ad1fc6548657e1$var$_process2 === void 0 || ($c1ad1fc6548657e1$var$_process2 = $c1ad1fc6548657e1$var$_process2.env) === null || $c1ad1fc6548657e1$var$_process2 === void 0 ? void 0 : $c1ad1fc6548657e1$var$_process2.NODE_ENV) !== "production";
var $c1ad1fc6548657e1$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c1ad1fc6548657e1$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $hPtJY = parcelRequire("hPtJY");
var $44e0815e249f339e$var$pkgName = "@atlaskit/platform-feature-flags";
var $44e0815e249f339e$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $44e0815e249f339e$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $44e0815e249f339e$var$ENV_ENABLE_PLATFORM_FF = $44e0815e249f339e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $44e0815e249f339e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $44e0815e249f339e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $44e0815e249f339e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $44e0815e249f339e$var$ENV_ENABLE_PLATFORM_FF || $44e0815e249f339e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $44e0815e249f339e$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $44e0815e249f339e$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$44e0815e249f339e$var$globalVar[$44e0815e249f339e$export$7e41b1b2bdee3f98] = $44e0815e249f339e$var$globalVar[$44e0815e249f339e$export$7e41b1b2bdee3f98] || $44e0815e249f339e$var$DEFAULT_PFF_GLOBAL;
function $44e0815e249f339e$export$f2b591175b3e424c(resolver) {
    $44e0815e249f339e$var$globalVar[$44e0815e249f339e$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $44e0815e249f339e$export$6333b6aff9fc6275(flagKey) {
    if ($44e0815e249f339e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $c1ad1fc6548657e1$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $44e0815e249f339e$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $44e0815e249f339e$var$globalVar[$44e0815e249f339e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $cc6aff01a90d8d94$export$ba05d765b8392e5e(flagResolver) {
    (0, $44e0815e249f339e$export$f2b591175b3e424c)(flagResolver);
}
function $cc6aff01a90d8d94$export$470e5c2be1411c89(name) {
    return (0, $44e0815e249f339e$export$6333b6aff9fc6275)(name);
}
function $cc6aff01a90d8d94$export$b40ec24ac8275656(name) {
    return (0, $44e0815e249f339e$export$6333b6aff9fc6275)(name);
}



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $048a9a7f2cfa709c$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $048a9a7f2cfa709c$export$72f415121273627e = "body > .atlaskit-portal-container";
var $048a9a7f2cfa709c$export$13f57c02915787b3 = "atlaskit-portal";


var $3dcce44f23fef19f$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $048a9a7f2cfa709c$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $3dcce44f23fef19f$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $3dcce44f23fef19f$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $048a9a7f2cfa709c$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $048a9a7f2cfa709c$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $3dcce44f23fef19f$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $3dcce44f23fef19f$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $3dcce44f23fef19f$var$getPortalParent().removeChild(container);
};
var $3dcce44f23fef19f$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $3dcce44f23fef19f$var$getPortalParent().appendChild(container);
};
var $3dcce44f23fef19f$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $3dcce44f23fef19f$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($3dcce44f23fef19f$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $048a9a7f2cfa709c$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $3dcce44f23fef19f$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($3dcce44f23fef19f$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $048a9a7f2cfa709c$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $048a9a7f2cfa709c$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $3dcce44f23fef19f$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $45a07dae92ce14fd$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $3dcce44f23fef19f$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $3dcce44f23fef19f$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $3dcce44f23fef19f$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $958efa86467d55bc$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $e816b1eb28955d95$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $958efa86467d55bc$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $3dcce44f23fef19f$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $3dcce44f23fef19f$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $ltooA.fg)("platform_design_system_suspend_portal_children") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $1u0KT.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $d890abd04375baa4$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $958efa86467d55bc$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $d890abd04375baa4$export$2e2bcd8739ae039 = $d890abd04375baa4$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $e9560e07bb6dad2c$export$ed5835cc67e87f72 = "akPortalMount";
var $e9560e07bb6dad2c$export$80816bd900e5bd00 = "akPortalUnmount";


var $704714955971ec93$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $704714955971ec93$var$getLayerName = function getLayerName(zIndex) {
    return $704714955971ec93$var$zIndexToName.hasOwnProperty(zIndex) ? $704714955971ec93$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $704714955971ec93$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $704714955971ec93$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $704714955971ec93$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $704714955971ec93$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $80f682bbfec0ea79$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $704714955971ec93$export$2e2bcd8739ae039)((0, $e9560e07bb6dad2c$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $704714955971ec93$export$2e2bcd8739ae039)((0, $e9560e07bb6dad2c$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $80f682bbfec0ea79$export$2e2bcd8739ae039 = $80f682bbfec0ea79$var$useFirePortalEvent;


function $2167cf9ee39b2459$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $d890abd04375baa4$export$2e2bcd8739ae039)(mountStrategy);
    (0, $80f682bbfec0ea79$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45a07dae92ce14fd$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e816b1eb28955d95$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $a0f5ef3b0d821339$var$printed = {};
function $a0f5ef3b0d821339$export$2e2bcd8739ae039(message) {
    if ($a0f5ef3b0d821339$var$printed[message]) return;
    $a0f5ef3b0d821339$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $f44ba4bc0607081e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $a0f5ef3b0d821339$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $f44ba4bc0607081e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 
function $ef9efea84017c196$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $2bb8b27d8f7435bc$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $2bb8b27d8f7435bc$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $2bb8b27d8f7435bc$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $2bb8b27d8f7435bc$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $509304e4f9453846$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $ef9efea84017c196$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $509304e4f9453846$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $509304e4f9453846$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $ef9efea84017c196$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $4226027c05fa0528$export$4b84fd0e2c617bd = "#FFEBE6";
var $4226027c05fa0528$export$b34b069eff244586 = "#FFBDAD";
var $4226027c05fa0528$export$be802dd0d8b57f35 = "#FF8F73";
var $4226027c05fa0528$export$60847d42f9da92a6 = "#FF7452";
var $4226027c05fa0528$export$4a7404f376229999 = "#FF5630";
var $4226027c05fa0528$export$2010d0fb4295b346 = "#DE350B";
var $4226027c05fa0528$export$2837b5a1a71d5c02 = "#BF2600";
var $4226027c05fa0528$export$8d9596b529bbb9cf = "#FFFAE6";
var $4226027c05fa0528$export$41060a744ab0b7ae = "#FFF0B3";
var $4226027c05fa0528$export$1cc05bbbf340e559 = "#FFE380";
var $4226027c05fa0528$export$5aae31392d72caaa = "#FFC400";
var $4226027c05fa0528$export$c6930421db9fa514 = "#FFAB00";
var $4226027c05fa0528$export$59619663aa6500fb = "#FF991F";
var $4226027c05fa0528$export$874739ea9e379ab6 = "#FF8B00";
var $4226027c05fa0528$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4226027c05fa0528$export$69a3bf21b9686c2b = "#ABF5D1";
var $4226027c05fa0528$export$afbce1382ec95f73 = "#79F2C0";
var $4226027c05fa0528$export$747d86715d4175de = "#57D9A3";
var $4226027c05fa0528$export$940e1f69e873f202 = "#36B37E";
var $4226027c05fa0528$export$a49394138f7b8e85 = "#00875A";
var $4226027c05fa0528$export$6fa04827ac68a4fb = "#006644";
var $4226027c05fa0528$export$226de0355ed012f8 = "#DEEBFF";
var $4226027c05fa0528$export$8c13c2ee36917869 = "#B3D4FF";
var $4226027c05fa0528$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4226027c05fa0528$export$215b7063051591f1 = "#2684FF";
var $4226027c05fa0528$export$e62e8919cca44969 = "#0065FF";
var $4226027c05fa0528$export$b3de0ae08da2ce64 = "#0052CC";
var $4226027c05fa0528$export$a6ee3d71bc067634 = "#0747A6";
var $4226027c05fa0528$export$363e4475840015bb = "#EAE6FF";
var $4226027c05fa0528$export$4b0a4417ed59760f = "#C0B6F2";
var $4226027c05fa0528$export$6011520a64d9a187 = "#998DD9";
var $4226027c05fa0528$export$a7175d4e9206bc80 = "#8777D9";
var $4226027c05fa0528$export$b48405b95304b5a1 = "#6554C0";
var $4226027c05fa0528$export$c71e4279dd54a18d = "#5243AA";
var $4226027c05fa0528$export$147899de772240ec = "#403294";
var $4226027c05fa0528$export$2cf711fe14c66f06 = "#E6FCFF";
var $4226027c05fa0528$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4226027c05fa0528$export$776c9c497ef08533 = "#79E2F2";
var $4226027c05fa0528$export$69cb3ca10c1e330e = "#00C7E6";
var $4226027c05fa0528$export$9dc1ef0f3f48059b = "#00B8D9";
var $4226027c05fa0528$export$7c835c78b6fcdef8 = "#00A3BF";
var $4226027c05fa0528$export$6036577f95c3877e = "#008DA6";
var $4226027c05fa0528$export$29a4f05edc054374 = "#FFFFFF";
var $4226027c05fa0528$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4226027c05fa0528$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4226027c05fa0528$export$3e51e8f1440314ba = "#EBECF0";
var $4226027c05fa0528$export$1ce2d1575d444ceb = "#DFE1E6";
var $4226027c05fa0528$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4226027c05fa0528$export$c2e91cbeada39b8b = "#B3BAC5";
var $4226027c05fa0528$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4226027c05fa0528$export$eaa8c8a70ac22806 = "#97A0AF";
var $4226027c05fa0528$export$7c87d337fb91a97d = "#8993A4";
var $4226027c05fa0528$export$d6447c357493214f = "#7A869A";
var $4226027c05fa0528$export$f563ee71e9ee74cd = "#6B778C";
var $4226027c05fa0528$export$e2ef2124cf4024b1 = "#5E6C84";
var $4226027c05fa0528$export$eece5f492e429f08 = "#505F79";
var $4226027c05fa0528$export$c39c0fe0f26207ae = "#42526E";
var $4226027c05fa0528$export$7090862dc3038a9f = "#344563";
var $4226027c05fa0528$export$ad0bacf983b7ddaa = "#253858";
var $4226027c05fa0528$export$7d61b15e0da132af = "#172B4D";
var $4226027c05fa0528$export$fbda843f0a27fe96 = "#091E42";
var $4226027c05fa0528$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4226027c05fa0528$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4226027c05fa0528$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4226027c05fa0528$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4226027c05fa0528$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4226027c05fa0528$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4226027c05fa0528$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4226027c05fa0528$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4226027c05fa0528$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4226027c05fa0528$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4226027c05fa0528$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4226027c05fa0528$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4226027c05fa0528$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4226027c05fa0528$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4226027c05fa0528$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4226027c05fa0528$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4226027c05fa0528$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4226027c05fa0528$export$2f6319cf7d736c2a = "#E6EDFA";
var $4226027c05fa0528$export$95126bc8884d6634 = "#DCE5F5";
var $4226027c05fa0528$export$8338d8c35d44ff1 = "#CED9EB";
var $4226027c05fa0528$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4226027c05fa0528$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4226027c05fa0528$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4226027c05fa0528$export$97e81faa16a182c7 = "#8C9CB8";
var $4226027c05fa0528$export$bfe21c59123ecf33 = "#7988A3";
var $4226027c05fa0528$export$ee82aa2ea6a1558 = "#67758F";
var $4226027c05fa0528$export$682927c6ed76be02 = "#56637A";
var $4226027c05fa0528$export$91fd9994c5be9757 = "#455166";
var $4226027c05fa0528$export$d281fbfe3cff2df6 = "#3B475C";
var $4226027c05fa0528$export$3902c91d8b98a753 = "#313D52";
var $4226027c05fa0528$export$8e8133c1ba5845b5 = "#283447";
var $4226027c05fa0528$export$33ff357f6620b39 = "#202B3D";
var $4226027c05fa0528$export$633847cf062b69e0 = "#1B2638";
var $4226027c05fa0528$export$9776a6e503bdbf76 = "#121A29";
var $4226027c05fa0528$export$6c813d5160dff5db = "#0E1624";
var $4226027c05fa0528$export$3d4f271a500072a = "#0D1424";
var $4226027c05fa0528$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4226027c05fa0528$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4226027c05fa0528$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4226027c05fa0528$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4226027c05fa0528$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4226027c05fa0528$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4226027c05fa0528$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4226027c05fa0528$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4226027c05fa0528$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4226027c05fa0528$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4226027c05fa0528$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4226027c05fa0528$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4226027c05fa0528$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4226027c05fa0528$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4226027c05fa0528$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4226027c05fa0528$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4226027c05fa0528$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4226027c05fa0528$export$8ce1fd94bee2f412 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($4226027c05fa0528$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($4226027c05fa0528$export$633847cf062b69e0, ")")
});
var $4226027c05fa0528$export$b861914ea877b580 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($4226027c05fa0528$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($4226027c05fa0528$export$8c13c2ee36917869, ")")
});
var $4226027c05fa0528$export$3f1b020df94387af = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($4226027c05fa0528$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($4226027c05fa0528$export$d281fbfe3cff2df6, ")")
});
var $4226027c05fa0528$export$c0183dbab98ca63e = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($4226027c05fa0528$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($4226027c05fa0528$export$8e8133c1ba5845b5, ")")
});
var $4226027c05fa0528$export$6f093cfa640b7166 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($4226027c05fa0528$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($4226027c05fa0528$export$5368d76ae4fbbda7, ")")
});
var $4226027c05fa0528$export$42f8e9c698766e7a = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($4226027c05fa0528$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($4226027c05fa0528$export$5368d76ae4fbbda7, ")")
});
var $4226027c05fa0528$export$c2d157ca1c34b6e3 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($4226027c05fa0528$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($4226027c05fa0528$export$b3de0ae08da2ce64, ")")
});
var $4226027c05fa0528$export$1905ba28d7cf066f = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($4226027c05fa0528$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($4226027c05fa0528$export$97e81faa16a182c7, ")")
});
var $4226027c05fa0528$export$bd9002130d306d39 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($4226027c05fa0528$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($4226027c05fa0528$export$bfe21c59123ecf33, ")")
});
var $4226027c05fa0528$export$46e4a324ac90507f = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($4226027c05fa0528$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($4226027c05fa0528$export$5368d76ae4fbbda7, ")")
});
var $4226027c05fa0528$export$79f3f2b82beb0d36 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($4226027c05fa0528$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($4226027c05fa0528$export$97e81faa16a182c7, ")")
});
var $4226027c05fa0528$export$7bb0d5c671655cc4 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$9fdfb749e33cdf97,
    dark: $4226027c05fa0528$export$8e8133c1ba5845b5
});
var $4226027c05fa0528$export$9c30223ca0a664fb = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($4226027c05fa0528$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($4226027c05fa0528$export$ecfc1dff386a3e7a, ")")
});
var $4226027c05fa0528$export$7ed258b0728b004b = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($4226027c05fa0528$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($4226027c05fa0528$export$215b7063051591f1, ")")
});
var $4226027c05fa0528$export$dfa920d8decc8a59 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($4226027c05fa0528$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($4226027c05fa0528$export$ecfc1dff386a3e7a, ")")
});
var $4226027c05fa0528$export$6069e6ad5c78f632 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($4226027c05fa0528$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($4226027c05fa0528$export$215b7063051591f1, ")")
});
var $4226027c05fa0528$export$9ad721cf3b3debe0 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($4226027c05fa0528$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($4226027c05fa0528$export$ecfc1dff386a3e7a, ")")
});
var $4226027c05fa0528$export$2aa0182783e7e9de = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$b3de0ae08da2ce64,
    dark: $4226027c05fa0528$export$ecfc1dff386a3e7a
});
var $4226027c05fa0528$export$8bf7dff220b82b4a = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$9dc1ef0f3f48059b,
    dark: $4226027c05fa0528$export$69cb3ca10c1e330e
});
var $4226027c05fa0528$export$e13cce2a2d16a9d4 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$b48405b95304b5a1,
    dark: $4226027c05fa0528$export$6011520a64d9a187
});
var $4226027c05fa0528$export$a90204d1394caf30 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$4a7404f376229999,
    dark: $4226027c05fa0528$export$4a7404f376229999
});
var $4226027c05fa0528$export$594c5a8758200c32 = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$c6930421db9fa514,
    dark: $4226027c05fa0528$export$c6930421db9fa514
});
var $4226027c05fa0528$export$955a2ebd2fb142ae = (0, $509304e4f9453846$export$2e2bcd8739ae039)({
    light: $4226027c05fa0528$export$940e1f69e873f202,
    dark: $4226027c05fa0528$export$940e1f69e873f202
});
var $4226027c05fa0528$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($4226027c05fa0528$export$8d43898f60b96a82, ")");
};


var $2bb8b27d8f7435bc$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $2bb8b27d8f7435bc$export$c93026a968943f95 = "light";
var $2bb8b27d8f7435bc$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $2bb8b27d8f7435bc$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $2bb8b27d8f7435bc$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $2bb8b27d8f7435bc$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $2bb8b27d8f7435bc$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $2bb8b27d8f7435bc$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $2bb8b27d8f7435bc$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $2bb8b27d8f7435bc$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $4226027c05fa0528$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $2bb8b27d8f7435bc$export$6d8204c2cb2e06b8() / 4;
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $2bb8b27d8f7435bc$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $2bb8b27d8f7435bc$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $2bb8b27d8f7435bc$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $2bb8b27d8f7435bc$export$ba1d834b86d72a09 = $2bb8b27d8f7435bc$export$a1b3edb637fb4f35;
var $2bb8b27d8f7435bc$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $4226027c05fa0528$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $4226027c05fa0528$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $4226027c05fa0528$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $fd05be839c660684$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $fd05be839c660684$export$e2a22331486dcca0 = $fd05be839c660684$export$bdbb4cbb3078e58d();


var $4d266bc9c8f3d314$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $fd05be839c660684$export$bdbb4cbb3078e58d)()
    };
};
var $4d266bc9c8f3d314$export$e575061ef2a070eb = $4d266bc9c8f3d314$export$1921362e86c73c88();
var $4d266bc9c8f3d314$export$b4d5da5f34fb77ad = $acw62.createContext($4d266bc9c8f3d314$export$1921362e86c73c88());
var $4d266bc9c8f3d314$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $4d266bc9c8f3d314$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};


var $82d9d5049c8c7ec2$var$generateUID = function(context) {
    var quartz = context || (0, $4d266bc9c8f3d314$export$e575061ef2a070eb);
    var prefix = (0, $4d266bc9c8f3d314$export$36e24695f02d4503)(quartz);
    var id = (0, $4d266bc9c8f3d314$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $82d9d5049c8c7ec2$var$useUIDState = function() {
    var context = (0, $acw62.useContext)((0, $4d266bc9c8f3d314$export$b4d5da5f34fb77ad));
    var uid = (0, $acw62.useState)(function() {
        return $82d9d5049c8c7ec2$var$generateUID(context);
    })[0];
    return uid;
};
var $82d9d5049c8c7ec2$export$87d05f07e65211f1 = function() {
    var uid = $82d9d5049c8c7ec2$var$useUIDState().uid;
    return uid;
};
var $82d9d5049c8c7ec2$export$bb5ca5fba6fb4f1f = function() {
    var gen = $82d9d5049c8c7ec2$var$useUIDState().gen;
    return gen;
};


/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $270747da43296caf$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $acw62 = parcelRequire("acw62");
function $3f80dbe144e57bfc$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $6f72ff8788d34fb2$var$BORDER_WIDTH = 2;
var $6f72ff8788d34fb2$var$baseFocusOutsideStyles = (0, $jjlaj.css)({
    outline: "".concat($6f72ff8788d34fb2$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $6f72ff8788d34fb2$var$BORDER_WIDTH
});
var $6f72ff8788d34fb2$var$baseInsetStyles = (0, $jjlaj.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$6f72ff8788d34fb2$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $6f72ff8788d34fb2$var$focusRingStyles = (0, $jjlaj.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $6f72ff8788d34fb2$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $6f72ff8788d34fb2$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $6f72ff8788d34fb2$var$insetFocusRingStyles = (0, $jjlaj.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $6f72ff8788d34fb2$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $6f72ff8788d34fb2$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $6f72ff8788d34fb2$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $6f72ff8788d34fb2$var$baseInsetStyles : $6f72ff8788d34fb2$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $6f72ff8788d34fb2$var$insetFocusRingStyles : $6f72ff8788d34fb2$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $jjlaj.jsx)((0, $jjlaj.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$6f72ff8788d34fb2$var$FocusRing.displayName = "FocusRing";
var $6f72ff8788d34fb2$export$2e2bcd8739ae039 = $6f72ff8788d34fb2$var$FocusRing;



var $acw62 = parcelRequire("acw62");
var $289ca172bce9e9d7$exports = {};
"use strict";
Object.defineProperty($289ca172bce9e9d7$exports, "__esModule", {
    value: true
});
$289ca172bce9e9d7$exports.bindAll = $289ca172bce9e9d7$exports.bind = void 0;
var $102710b0c7c20790$exports = {};
"use strict";
Object.defineProperty($102710b0c7c20790$exports, "__esModule", {
    value: true
});
$102710b0c7c20790$exports.bind = void 0;
function $102710b0c7c20790$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$102710b0c7c20790$exports.bind = $102710b0c7c20790$var$bind;


Object.defineProperty($289ca172bce9e9d7$exports, "bind", {
    enumerable: true,
    get: function() {
        return $102710b0c7c20790$exports.bind;
    }
});
var $e0a0a0b052115335$exports = {};
"use strict";
var $e0a0a0b052115335$var$__assign = $e0a0a0b052115335$exports && $e0a0a0b052115335$exports.__assign || function() {
    $e0a0a0b052115335$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e0a0a0b052115335$var$__assign.apply(this, arguments);
};
Object.defineProperty($e0a0a0b052115335$exports, "__esModule", {
    value: true
});
$e0a0a0b052115335$exports.bindAll = void 0;

function $e0a0a0b052115335$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $e0a0a0b052115335$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $e0a0a0b052115335$var$__assign($e0a0a0b052115335$var$__assign({}, original), {
        options: $e0a0a0b052115335$var$__assign($e0a0a0b052115335$var$__assign({}, $e0a0a0b052115335$var$toOptions(sharedOptions)), $e0a0a0b052115335$var$toOptions(original.options))
    });
    return binding;
}
function $e0a0a0b052115335$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $e0a0a0b052115335$var$getBinding(original, sharedOptions);
        return (0, $102710b0c7c20790$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$e0a0a0b052115335$exports.bindAll = $e0a0a0b052115335$var$bindAll;


Object.defineProperty($289ca172bce9e9d7$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $e0a0a0b052115335$exports.bindAll;
    }
});



var $60d8ecd98027d18d$var$ESCAPE = "Escape";
function $60d8ecd98027d18d$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _UNSAFE_useLayering = $60d8ecd98027d18d$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $60d8ecd98027d18d$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $289ca172bce9e9d7$exports.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $60d8ecd98027d18d$export$cec37b93989366d4() {
    var currentLevel = (0, $acw62.useContext)((0, $b3f08d7ea81e76d6$export$650d12d3c2ddb8fc));
    var _useContext = (0, $acw62.useContext)((0, $b3f08d7ea81e76d6$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see https://compiledcssinjs.com/docs/atomic-css#selector-specificity
 */ var $967d549f036d06b7$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 109.99rem)",
        xl: "@media (min-width: 110rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110rem)"
    }
};
var $967d549f036d06b7$export$c881183ca713c214 = $967d549f036d06b7$export$987d49ffe1b0900f;



var $03ee2cbf8300ce78$export$4ef52930e33717cd = "data-theme";
var $03ee2cbf8300ce78$export$a00eac3f8684bcd0 = "data-color-mode";
var $03ee2cbf8300ce78$export$2112803007239c61 = "data-contrast-mode";
var $03ee2cbf8300ce78$export$352e418ed5b6193a = "data-custom-theme";
var $03ee2cbf8300ce78$export$2faeed762aac6741 = "light";
var $03ee2cbf8300ce78$export$6f0c6fb8c80fcc92 = "ds";
var $03ee2cbf8300ce78$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $03ee2cbf8300ce78$export$dddac1532e822863 = "--".concat($03ee2cbf8300ce78$export$6f0c6fb8c80fcc92, "-token-not-found");
var $03ee2cbf8300ce78$export$9d7b58831ae93caa = "--".concat($03ee2cbf8300ce78$export$6f0c6fb8c80fcc92, "-elevation-surface-current");




var $b77b51d464e4238b$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $b77b51d464e4238b$export$f2b922cb4a245974 = 60;
var $b77b51d464e4238b$var$gridSize = (0, $2bb8b27d8f7435bc$export$6d8204c2cb2e06b8)();
var $b77b51d464e4238b$export$7a57f79000377ca2 = (0, $2bb8b27d8f7435bc$export$7a57f79000377ca2)();
var $b77b51d464e4238b$export$9212741279b5f103 = $b77b51d464e4238b$var$gridSize * 2;
var $b77b51d464e4238b$export$6f98e8eaf0be1996 = $b77b51d464e4238b$var$gridSize * 3;
var $b77b51d464e4238b$export$5e63d1b3b2849330 = $b77b51d464e4238b$var$gridSize;
var $b77b51d464e4238b$export$4c317248f944c2a9 = 2;
var $b77b51d464e4238b$export$d901150a4cc83165 = "var(--ds-border, ".concat((0, $4226027c05fa0528$export$3e51e8f1440314ba), ")");
var $b77b51d464e4238b$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $4226027c05fa0528$export$fbda843f0a27fe96), ")");
var $b77b51d464e4238b$export$3797a580396e3639 = {
    danger: "var(--ds-icon-danger, ".concat((0, $4226027c05fa0528$export$2010d0fb4295b346), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};



var $acw62 = parcelRequire("acw62");
var $c409c6850144d199$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $c409c6850144d199$export$dece24112a937f92 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
function $c2c5fe2a4523ebc1$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $acw62.useRef)(null);
    var onMotionFinish = (0, $acw62.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $8e0a7c9e1635d9ed$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = (0, $b77b51d464e4238b$export$7e3df82ee760448c).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, $b77b51d464e4238b$export$7e3df82ee760448c).widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $8e0a7c9e1635d9ed$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");





var $7e8436e9e798d30d$var$maxWidthDimensions = "calc(100vw - ".concat((0, $b77b51d464e4238b$export$f2b922cb4a245974) * 2, "px)");
var $7e8436e9e798d30d$var$maxHeightDimensions = "calc(100vh - ".concat((0, $b77b51d464e4238b$export$f2b922cb4a245974) * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $7e8436e9e798d30d$var$positionerStyles = (0, $jjlaj.css)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $2bb8b27d8f7435bc$export$7be255094ccdc533).modal(),
    top: 0,
    left: 0,
    flexDirection: "column"
});
var $7e8436e9e798d30d$var$viewportScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    height: "auto",
    position: "relative"
}, (0, $967d549f036d06b7$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat((0, $b77b51d464e4238b$export$f2b922cb4a245974), "px auto"),
    pointerEvents: "none"
}));
var $7e8436e9e798d30d$var$bodyScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $967d549f036d06b7$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $7e8436e9e798d30d$var$maxWidthDimensions,
    maxHeight: $7e8436e9e798d30d$var$maxHeightDimensions,
    marginRight: "auto",
    marginLeft: "auto",
    position: "absolute",
    top: "".concat((0, $b77b51d464e4238b$export$f2b922cb4a245974), "px"),
    right: 0,
    left: 0,
    pointerEvents: "none"
}));
var $7e8436e9e798d30d$var$stackTransitionStyles = (0, $jjlaj.css)({
    transitionDuration: "".concat((0, $d145bd79772829f1$export$6fa259be09e118a7), "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $e9ca40ca2325ac8e$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $7e8436e9e798d30d$var$stackTransformStyles = (0, $jjlaj.css)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $7e8436e9e798d30d$var$stackIdleStyles = (0, $jjlaj.css)({
    transform: "none"
});
var $7e8436e9e798d30d$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $jjlaj.jsx)("div", {
        style: {
            "--modal-dialog-translate-y": "".concat(stackIndex * ((0, $b77b51d464e4238b$export$9212741279b5f103) / 2), "px")
        },
        css: [
            $7e8436e9e798d30d$var$positionerStyles,
            $7e8436e9e798d30d$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $7e8436e9e798d30d$var$stackTransformStyles : $7e8436e9e798d30d$var$stackIdleStyles,
            shouldScrollInViewport ? $7e8436e9e798d30d$var$viewportScrollStyles : $7e8436e9e798d30d$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e8436e9e798d30d$export$2e2bcd8739ae039 = $7e8436e9e798d30d$var$Positioner;


var $173f315784d5fdf0$var$_css;
var $173f315784d5fdf0$var$dialogStyles = (0, $jjlaj.css)(($173f315784d5fdf0$var$_css = {
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $4226027c05fa0528$export$29a4f05edc054374), ")"),
    color: (0, $b77b51d464e4238b$export$32f78bffcd82ff28)
}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($173f315784d5fdf0$var$_css, (0, $03ee2cbf8300ce78$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $4226027c05fa0528$export$29a4f05edc054374), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($173f315784d5fdf0$var$_css, "pointerEvents", "auto"), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($173f315784d5fdf0$var$_css, (0, $967d549f036d06b7$export$987d49ffe1b0900f).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    borderRadius: (0, $b77b51d464e4238b$export$7a57f79000377ca2),
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $4226027c05fa0528$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $4226027c05fa0528$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $4226027c05fa0528$export$d2d3bedfb276cac0)), ")"),
    marginInlineEnd: "inherit",
    marginInlineStart: "inherit"
}), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($173f315784d5fdf0$var$_css, "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}), $173f315784d5fdf0$var$_css));
var $173f315784d5fdf0$var$viewportScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $967d549f036d06b7$export$987d49ffe1b0900f).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $173f315784d5fdf0$var$bodyScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $967d549f036d06b7$export$987d49ffe1b0900f).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $173f315784d5fdf0$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $82d9d5049c8c7ec2$export$87d05f07e65211f1)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $3f80dbe144e57bfc$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $c2c5fe2a4523ebc1$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $acw62.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $60d8ecd98027d18d$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    return (0, $jjlaj.jsx)((0, $7e8436e9e798d30d$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $jjlaj.jsx)((0, $c409c6850144d199$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $jjlaj.jsx)((0, $c409c6850144d199$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $jjlaj.jsx)((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                "--modal-dialog-width": (0, $8e0a7c9e1635d9ed$export$a3da89b899389ed8)(width),
                "--modal-dialog-height": (0, $8e0a7c9e1635d9ed$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $173f315784d5fdf0$var$dialogStyles,
                shouldScrollInViewport ? $173f315784d5fdf0$var$viewportScrollStyles : $173f315784d5fdf0$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$173f315784d5fdf0$export$2e2bcd8739ae039 = $173f315784d5fdf0$var$ModalDialog;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $32da3ab8d78b92fd$var$uniqueReferencedValue = {};
function $32da3ab8d78b92fd$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $acw62.useRef)($32da3ab8d78b92fd$var$uniqueReferencedValue);
    if (ref.current === $32da3ab8d78b92fd$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $94e127bdad6c95fb$export$2e2bcd8739ae039(callback) {
    var ref = (0, $32da3ab8d78b92fd$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $8b1ca3977f5313f5$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $ae6659c5d7ef547e$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $acw62.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $266f54f749ed0c14$var$modalStackRegister = [];
function $266f54f749ed0c14$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $183a833228617892$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $ae6659c5d7ef547e$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $8b1ca3977f5313f5$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $94e127bdad6c95fb$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $266f54f749ed0c14$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $acw62.useEffect)(function() {
        var currentStackIndex = $266f54f749ed0c14$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $266f54f749ed0c14$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $266f54f749ed0c14$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $266f54f749ed0c14$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $266f54f749ed0c14$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $266f54f749ed0c14$var$modalStackRegister.splice(currentStackIndex, 1);
                $266f54f749ed0c14$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $acw62.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
var $6adf76077f9a8214$exports = {};
"use strict";
Object.defineProperty($6adf76077f9a8214$exports, "__esModule", {
    value: true
});
$6adf76077f9a8214$exports.bindAll = $6adf76077f9a8214$exports.bind = void 0;
var $3944c931ca910cb6$exports = {};
"use strict";
Object.defineProperty($3944c931ca910cb6$exports, "__esModule", {
    value: true
});
$3944c931ca910cb6$exports.bind = void 0;
function $3944c931ca910cb6$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$3944c931ca910cb6$exports.bind = $3944c931ca910cb6$var$bind;


Object.defineProperty($6adf76077f9a8214$exports, "bind", {
    enumerable: true,
    get: function() {
        return $3944c931ca910cb6$exports.bind;
    }
});
var $c6d7a4a5ac271467$exports = {};
"use strict";
var $c6d7a4a5ac271467$var$__assign = $c6d7a4a5ac271467$exports && $c6d7a4a5ac271467$exports.__assign || function() {
    $c6d7a4a5ac271467$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6d7a4a5ac271467$var$__assign.apply(this, arguments);
};
Object.defineProperty($c6d7a4a5ac271467$exports, "__esModule", {
    value: true
});
$c6d7a4a5ac271467$exports.bindAll = void 0;

function $c6d7a4a5ac271467$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $c6d7a4a5ac271467$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c6d7a4a5ac271467$var$__assign($c6d7a4a5ac271467$var$__assign({}, original), {
        options: $c6d7a4a5ac271467$var$__assign($c6d7a4a5ac271467$var$__assign({}, $c6d7a4a5ac271467$var$toOptions(sharedOptions)), $c6d7a4a5ac271467$var$toOptions(original.options))
    });
    return binding;
}
function $c6d7a4a5ac271467$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c6d7a4a5ac271467$var$getBinding(original, sharedOptions);
        return (0, $3944c931ca910cb6$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$c6d7a4a5ac271467$exports.bindAll = $c6d7a4a5ac271467$var$bindAll;


Object.defineProperty($6adf76077f9a8214$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $c6d7a4a5ac271467$exports.bindAll;
    }
});


/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $f1146797d708fab8$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $f1146797d708fab8$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $acw62.useLayoutEffect)(function() {
        setScrollTopOffset($f1146797d708fab8$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $acw62.useCallback)(function() {
        if ($f1146797d708fab8$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $acw62.useEffect)(function() {
        return (0, $6adf76077f9a8214$exports.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $49f7c216070fc3db$var$fillScreenStyles = (0, $jjlaj.css)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $49f7c216070fc3db$var$whiteListElements = function whiteListElements(element) {
    // allows focus to reach elements outside the modal if they contain the data-atlas-extension attribute
    return !element.hasAttribute("data-atlas-extension");
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $49f7c216070fc3db$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $266f54f749ed0c14$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: onClose,
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "12.10.3"
    });
    var onBlanketClicked = (0, $acw62.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    (0, $f1146797d708fab8$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $jjlaj.jsx)((0, $aac7c3d609a8c84e$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $jjlaj.jsx)((0, $173f315784d5fdf0$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $jjlaj.jsx)((0, $b3f08d7ea81e76d6$export$a183686c3f6f4ea8), {
        isDisabled: (0, $cc6aff01a90d8d94$export$470e5c2be1411c89)("platform.design-system-team.layering_qmiw3") ? false : true
    }, (0, $jjlaj.jsx)((0, $2167cf9ee39b2459$export$2e2bcd8739ae039), {
        zIndex: (0, $2bb8b27d8f7435bc$export$7be255094ccdc533).modal()
    }, (0, $jjlaj.jsx)((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, fadeInProps, {
            css: $49f7c216070fc3db$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $jjlaj.jsx)((0, $9962412629625ccb$export$2e2bcd8739ae039), {
            autoFocus: autoFocusLock,
            disabled: (0, $cc6aff01a90d8d94$export$470e5c2be1411c89)("platform.design-system-team.multiple-modal-inappropriate-focus_z5u4j") ? undefined : !isForeground,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: $49f7c216070fc3db$var$whiteListElements
        }, (0, $jjlaj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf2505162f62ed75$exports))), null), shouldScrollInViewport ? (0, $jjlaj.jsx)((0, $cf2505162f62ed75$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $49f7c216070fc3db$export$2e2bcd8739ae039 = $49f7c216070fc3db$var$ModalWrapper;



var $acw62 = parcelRequire("acw62");

/* KudosModalBody.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");

/* KudosReason.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

const $eda5826232273e1e$var$KudosReason = ({ image: image, description: description, onClick: onClick, selected: selected = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _1bsb1osq _vchhusvi _ca0q1crf _u5f3ftgi _n3tddlk8 _19bvftgi _4cvr1h6o _zulp1crf _80omtlke _2rkoftgi _19it3e1a _bfhk1xnl _syaz1blv _1bto1l2s _ect41q02 _1wyb1y1z _k48pzul8 _vwz41hdq _4t3i1wug",
            !selected && "_8vu4ftgi _bfw73e1a _19lc4puc",
            selected && "_19itffjr _11q712qo"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _1bsb1a70 _4t3i1a70 _1bah1h6o _4cvr1h6o _1o9zidpf"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: image
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1reo15vq _18m915vq _syaz1c40 _1bto1l2s _y3gn1e5h _ect48ub1 _1wyb1j7v _zg8l4jg8 _k48p1nn1 _vwz41hdq _1bsb1osq _4t3i1wug _1e0c1o8l"
                ]),
                children: description
            })
        ]
    });
const $eda5826232273e1e$var$baseButtonStyle = null;
const $eda5826232273e1e$var$hoverButtonStyle = null;
const $eda5826232273e1e$var$selectedButtonStyle = null;
const $eda5826232273e1e$var$selectedImageStyle = null;
const $eda5826232273e1e$var$descriptionStyle = null;
var $eda5826232273e1e$export$2e2bcd8739ae039 = $eda5826232273e1e$var$KudosReason;










const $fdb3528b429eeb1b$var$KUDOS_COMMENTS = {
    GOING_ABOVE_BEYOND: {
        value: "for going above and beyond",
        label: "Going above & beyond"
    },
    WRITING_GREAT_CONTENT: {
        value: "for writing great content",
        label: "Writing great content"
    },
    BEING_AWESOME_AT_ACE: {
        value: "for being awesome at an ace",
        label: "Being awesome at an ACE"
    },
    JUST_BECAUSE: {
        value: "just because",
        label: "Just because"
    }
};
const $fdb3528b429eeb1b$var$KUDOS_IMAGES = {
    [$fdb3528b429eeb1b$var$KUDOS_COMMENTS.GOING_ABOVE_BEYOND.value]: (0, (/*@__PURE__*/$parcel$interopDefault($d4d6420dfd160f51$exports))),
    [$fdb3528b429eeb1b$var$KUDOS_COMMENTS.WRITING_GREAT_CONTENT.value]: (0, (/*@__PURE__*/$parcel$interopDefault($954bfc0b92c489fd$exports))),
    [$fdb3528b429eeb1b$var$KUDOS_COMMENTS.BEING_AWESOME_AT_ACE.value]: (0, (/*@__PURE__*/$parcel$interopDefault($fd39177d1a9e2c77$exports))),
    [$fdb3528b429eeb1b$var$KUDOS_COMMENTS.JUST_BECAUSE.value]: (0, (/*@__PURE__*/$parcel$interopDefault($915a40f482384f94$exports)))
};
const $fdb3528b429eeb1b$var$KudosModalBody = ({ onReasonSelect: onReasonSelect })=>{
    const [selectedReason, setSelectedReason] = (0, $acw62.useState)(null);
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const profileResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $fe73a947836bf836$export$9d9de7756b13ecf), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const profileData = profileResponseData?.unified?.unifiedProfile;
    if (!profileData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch profile data"
    });
    const userResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: profileData.aaid
    }, {
        fetchPolicy: "store-or-network"
    });
    const userData = userResponseData.user;
    if (!userData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch user data"
    });
    const { picture: picture } = userData;
    let highResolutionPicture = "";
    const { profileAvatar: profileAvatar } = (0, $acw62.useContext)((0, $51c84bb9511e1e8b$export$122994dc05ba4308));
    highResolutionPicture = (0, $29b4de728b246ef8$export$1b8f63ded5de1d1e)(picture, (0, $77d0522707ddb581$export$a7e851dd01b7bece).SMALL, profileAvatar);
    const handleReasonClick = (0, $acw62.useCallback)((reason)=>{
        setSelectedReason(reason);
        onReasonSelect(reason); // Pass the reason up
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpxjmg _1wpz1fhb _vchhusvi _1rquusvi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _2lx21bp4 _4cvr1y6m _zulpzwfg _1wpz1fhb"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _ca0q1crf _u5f3ftgi _n3tddlk8 _19bvftgi _4cvr1h6o _zulp1crf _1wpz1fhb _2rkoftgi _19itffjr"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: highResolutionPicture,
                            alt: "Profile Photo",
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1bsbzwfg _4t3izwfg _2rko1ssb"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_ect41v9d",
                                !profileData?.role && "_1e0c1txw _4cvr1h6o _1bah1h6o"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_1wyb7vkz _k48p1nn1 _syazwwip _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: `${userData?.nickname}`
                                }),
                                profileData?.role && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_1wyb1crf _syaz1e01 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: profileData.role
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _2lx21bp4 _4cvr1y6m _zulpi2wt _1bsb1osq _fsb2idpf _bo3bidpf _rs1midpf _1817idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_syaz1c40 _1iqs14wa _ect4i8h4 _1wyb1crf _zg8l4jg8 _k48pni7l _vwz47vkz _1p1dangw"
                        ]),
                        children: "Recognition reason"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c11p5 _1bsb1osq _yv0ewxkt _zulpftgi _4cvr1h6o _ca0qidpf _u5f369x6 _n3tdidpf _19bv69x6 _uwwn1txw _iyz51bp4"
                        ]),
                        children: Object.values($fdb3528b429eeb1b$var$KUDOS_COMMENTS).map((reason)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eda5826232273e1e$export$2e2bcd8739ae039), {
                                image: $fdb3528b429eeb1b$var$KUDOS_IMAGES[reason.value],
                                description: reason.label,
                                onClick: ()=>handleReasonClick(reason.value),
                                selected: selectedReason === reason.value
                            }, reason.value))
                    })
                ]
            })
        ]
    });
};
const $fdb3528b429eeb1b$var$subHeadReason = null;
const $fdb3528b429eeb1b$var$kudosReasonGrid = null;
const $fdb3528b429eeb1b$var$profilePhotoStyles = null;
const $fdb3528b429eeb1b$var$profileSectionStyle = null;
const $fdb3528b429eeb1b$var$profileSectionText = null;
const $fdb3528b429eeb1b$var$profileSectionTextCentered = null;
const $fdb3528b429eeb1b$var$profileSectionName = null;
const $fdb3528b429eeb1b$var$profileSectionRole = null;
const $fdb3528b429eeb1b$var$kudosModal = null;
const $fdb3528b429eeb1b$var$recognitionReasonStyles = null;
const $fdb3528b429eeb1b$var$profileSectionContainer = null;
var $fdb3528b429eeb1b$export$2e2bcd8739ae039 = $fdb3528b429eeb1b$var$KudosModalBody;





var $e97ebc79e04e432b$var$_RecognitionScheduleQuery;

const $e97ebc79e04e432b$export$e0169f671b3e59f6 = $e97ebc79e04e432b$var$_RecognitionScheduleQuery !== void 0 ? $e97ebc79e04e432b$var$_RecognitionScheduleQuery : $e97ebc79e04e432b$var$_RecognitionScheduleQuery = (parcelRequire("7z092"));



const $3c60c4da24201aa6$export$ec9951569f53766a = ({ currentProfileAaid: currentProfileAaid })=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const loggedInUser = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)();
    const loggedInUserAaid = loggedInUser?.accountId ?? "";
    // Fetch user data only if we have profile data
    const userResponseData = currentProfileAaid ? (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: currentProfileAaid
    }, {
        fetchPolicy: "store-or-network"
    }) : null;
    // Fetch recognition schedule data
    const recognitionScheduleData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $e97ebc79e04e432b$export$e0169f671b3e59f6), {
        aaid: loggedInUserAaid
    }, {
        fetchPolicy: "store-or-network"
    });
    const userData = userResponseData?.user;
    const recognitionSchedule = recognitionScheduleData?.unified?.unifiedProfile?.gamification?.recognitionSchedule;
    return {
        userData: userData || null,
        recognitionSchedule: recognitionSchedule,
        loggedInUserAaid: loggedInUserAaid,
        pathProfileId: pathProfileId || ""
    };
};



var $acw62 = parcelRequire("acw62");

var $d1b4ef742bdc9ff0$var$_UnifiedGamificationMutation;

const $d1b4ef742bdc9ff0$export$b5ac8b460e255cd6 = $d1b4ef742bdc9ff0$var$_UnifiedGamificationMutation !== void 0 ? $d1b4ef742bdc9ff0$var$_UnifiedGamificationMutation : $d1b4ef742bdc9ff0$var$_UnifiedGamificationMutation = (parcelRequire("hKsNu"));





var $eJz0f = parcelRequire("eJz0f");

// mockNetworkHandler.ts
const $8d12ec8ae626d4da$export$517722f989ec2162 = {
    UnifiedSystemMutation: (variables)=>({
            data: {
                unified: {
                    createUnifiedSystem: {
                        errors: [],
                        success: true,
                        unifiedProfile: {
                            bio: "",
                            company: "",
                            aaid: "62587f99fdb60b0069294184",
                            id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                            linkedinUrl: "",
                            location: "",
                            accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                            products: null,
                            role: "",
                            internalId: "c34de571-576f-45e6-8c02-0917609af889",
                            username: "emptyloggedin",
                            websiteUrl: "",
                            xUrl: null,
                            youtubeUrl: null,
                            isPrivate: false,
                            isPersonalView: true,
                            isLinkedView: false
                        }
                    }
                }
            }
        }),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: "",
                        company: "",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "",
                        products: null,
                        role: "",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "emptyloggedin",
                        websiteUrl: "",
                        xUrl: "",
                        youtubeUrl: "",
                        isPrivate: false,
                        isPersonalView: true,
                        isLinkedView: false
                    }
                }
            }
        }),
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {
                    user: {
                        __typename: "AtlassianAccountUser",
                        accountId: "62587f99fdb60b0069294184",
                        accountStatus: "active",
                        name: "Empty User",
                        email: "cstauss@atlassian.com",
                        nickname: "Empty User",
                        picture: "",
                        id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                    }
                }
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Empty User",
                    picture: "http://www.google.com/initials",
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 0
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 0
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 0,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        }),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 0,
                                answersCreated: 0,
                                articlesCreated: 0,
                                kudosReceived: 0,
                                totalPosts: 0
                            }
                        }
                    }
                }
            }
        }),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [],
                                totalCount: 0
                            }
                        }
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCourses: {
                                __typename: "UnifiedRecentCourseConnection",
                                edges: [],
                                pageInfo: {
                                    endCursor: "0",
                                    hasNextPage: false,
                                    hasPreviousPage: false,
                                    startCursor: "0"
                                },
                                totalCount: 0
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [],
                            pageInfo: {
                                endCursor: "0",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 0
                        }
                    }
                }
            }
        }),
    UnifiedLearningCertificationQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        learning: {
                            __typename: "UnifiedLearning",
                            certifications: {
                                __typename: "UnifiedLearningCertificationConnection",
                                edges: [],
                                totalCount: 0
                            }
                        }
                    }
                }
            }
        })
};



const $40181de4ac92c9ea$var$getCertificateName = (id, isEmeritus, isLongName)=>{
    if (isEmeritus) return "Atlassian Certified Expert Emeritus";
    if (isLongName) return new Array(50).fill("Certificate").join(" ");
    return `Certificate ${id}`;
};
const $40181de4ac92c9ea$var$getMockedCertmetricsCertificatesEdge = (id, isEmeritus, isLongName)=>({
        __typename: "UnifiedLearningCertificationEdge",
        cursor: `${id}`,
        node: {
            __typename: "UnifiedLearningCertification",
            name: $40181de4ac92c9ea$var$getCertificateName(id, isEmeritus, isLongName),
            activeDate: "2024-02-02",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($80f43fae5f2a7696$exports))),
            publicUrl: "https://example.com",
            nameAbbr: isEmeritus ? "ACP-EE" : `TEST-${id}`,
            status: "ACTIVE"
        }
    });
const $40181de4ac92c9ea$export$777fa732f79e69c6 = ({ count: count, withEmeritus: withEmeritus })=>{
    if (count === 0) return [];
    return new Array(count).fill(null).map((_, index)=>{
        const isEmeritus = withEmeritus && index === 0;
        const isLongName = index === 1;
        return $40181de4ac92c9ea$var$getMockedCertmetricsCertificatesEdge(index, isEmeritus, isLongName);
    });
};




const $a2524e20d5294bc9$export$2d5e5d48d26f9268 = {
    UnifiedSystemMutation: (variables)=>({
            data: {
                unified: {
                    createUnifiedSystem: {
                        errors: [],
                        success: true,
                        unifiedProfile: {
                            bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                            company: "Nike",
                            aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                            id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                            linkedinUrl: "linkedin.com/colbystauss",
                            location: "Utah, USA",
                            accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                            products: null,
                            role: "CEO",
                            internalId: "c34de571-576f-45e6-8c02-0917609af889",
                            username: "fullloggedin",
                            websiteUrl: "colbystauss.net",
                            xUrl: null,
                            youtubeUrl: null,
                            isPrivate: false,
                            isPersonalView: true,
                            isLinkedView: false
                        }
                    }
                }
            }
        }),
    EditProfileFormMutation: (variables)=>({
            data: {
                unified: {
                    updateUnifiedProfile: {
                        errors: [],
                        success: true
                    }
                }
            }
        }),
    UnifiedAccountQuery: (variables)=>({
            data: {
                unified: {
                    account: {
                        __typename: "UnifiedAccount",
                        id: "ari:cloud:unified-portable-profile::unified-account/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        emailId: "loggedin@atlassian.com",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        isLinked: true,
                        isManaged: false,
                        isPrimary: true,
                        isForumsModerator: false,
                        picture: "https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/712020:0189aab4-6460-4699-a05b-939927f7ebea/06206e96-73a9-4d35-84c0-fcd1614b9918/128",
                        nickname: "Colby Stauss",
                        linkedAccounts: {
                            __typename: "UnifiedLinkedAccountConnection",
                            edges: [
                                {
                                    node: {
                                        id: "ari:cloud:unified-portable-profile::unified-account/c3094a2b-1833-483e-8d06-3ecf04fa1227",
                                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebeb",
                                        emailId: "loggedin-1@atlassian.com",
                                        internalId: "c34de571-576f-45e6-8c02-0917609af882",
                                        isLinked: true,
                                        isManaged: true,
                                        isPrimary: false,
                                        nickname: "Colby",
                                        picture: "https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/712020:0189aab4-6460-4699-a05b-939927f7ebea/06206e96-73a9-4d35-84c0-fcd1614b9918/128"
                                    },
                                    cursor: "0"
                                },
                                {
                                    node: {
                                        id: "ari:cloud:unified-portable-profile::unified-account/113783a6-b6c9-485a-accc-d1457aae8911",
                                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebec",
                                        emailId: "loggedin-2@atlassian.com",
                                        internalId: "c34de571-576f-45e6-8c02-0917609af883",
                                        isLinked: true,
                                        isManaged: false,
                                        isPrimary: false,
                                        nickname: "Stauss",
                                        picture: "https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/712020:0189aab4-6460-4699-a05b-939927f7ebea/06206e96-73a9-4d35-84c0-fcd1614b9918/128"
                                    },
                                    cursor: "1"
                                }
                            ],
                            totalCount: 2,
                            pageInfo: {
                                endCursor: "2",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            }
                        }
                    }
                }
            }
        }),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                        company: "Nike",
                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "analytics,halp,hipchat",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "fullloggedin",
                        websiteUrl: "colbystauss.net",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: true,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [
                            {
                                cursor: "0",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/analytics",
                                    productId: "analytics",
                                    title: "Analytics Visualization Platform",
                                    type: "category",
                                    viewHref: "/forums/Analytics-Visualization-Platform/ct-p/analytics"
                                }
                            },
                            {
                                cursor: "1",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/atlas",
                                    productId: "atlas",
                                    title: "Atlas",
                                    type: "category",
                                    viewHref: "/forums/Atlas/ct-p/atlas"
                                }
                            },
                            {
                                cursor: "2",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/identity-manager",
                                    productId: "identity-manager",
                                    title: "Atlassian Access",
                                    type: "category",
                                    viewHref: "/forums/Atlassian-Access/ct-p/identity-manager"
                                }
                            },
                            {
                                cursor: "3",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/bamboo",
                                    productId: "bamboo",
                                    title: "Bamboo",
                                    type: "category",
                                    viewHref: "/forums/Bamboo/ct-p/bamboo"
                                }
                            },
                            {
                                cursor: "4",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/bitbucket",
                                    productId: "bitbucket",
                                    title: "Bitbucket",
                                    type: "category",
                                    viewHref: "/forums/Bitbucket/ct-p/bitbucket"
                                }
                            },
                            {
                                cursor: "5",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/clover",
                                    productId: "clover",
                                    title: "Clover",
                                    type: "category",
                                    viewHref: "/forums/Clover/ct-p/clover"
                                }
                            },
                            {
                                cursor: "6",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/announcements",
                                    productId: "announcements",
                                    title: "Community Announcements",
                                    type: "category",
                                    viewHref: "/forums/Community-Announcements/ct-p/announcements"
                                }
                            },
                            {
                                cursor: "7",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/confluence",
                                    productId: "confluence",
                                    title: "Confluence",
                                    type: "category",
                                    viewHref: "/forums/Confluence/ct-p/confluence"
                                }
                            },
                            {
                                cursor: "8",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/confluence-collection",
                                    productId: "confluence-collection",
                                    title: "Confluence Collection",
                                    type: "category",
                                    viewHref: "/forums/Confluence-Collection/ct-p/confluence-collection"
                                }
                            },
                            {
                                cursor: "9",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/crowd",
                                    productId: "crowd",
                                    title: "Crowd",
                                    type: "category",
                                    viewHref: "/forums/Crowd/ct-p/crowd"
                                }
                            },
                            {
                                cursor: "10",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/data-center",
                                    productId: "data-center",
                                    title: "Data Center",
                                    type: "category",
                                    viewHref: "/forums/Data-Center/ct-p/data-center"
                                }
                            },
                            {
                                cursor: "11",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/fisheye-crucible",
                                    productId: "fisheye-crucible",
                                    title: "FishEye/Crucible",
                                    type: "category",
                                    viewHref: "/forums/FishEye-Crucible/ct-p/fisheye-crucible"
                                }
                            },
                            {
                                cursor: "12",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/halp",
                                    productId: "halp",
                                    title: "Halp",
                                    type: "category",
                                    viewHref: "/forums/Halp/ct-p/halp"
                                }
                            },
                            {
                                cursor: "13",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/hipchat",
                                    productId: "hipchat",
                                    title: "HipChat",
                                    type: "category",
                                    viewHref: "/forums/HipChat/ct-p/hipchat"
                                }
                            },
                            {
                                cursor: "14",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/jira",
                                    productId: "jira",
                                    title: "Jira",
                                    type: "category",
                                    viewHref: "/forums/Jira/ct-p/jira"
                                }
                            },
                            {
                                cursor: "15",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/MarketplaceApps",
                                    productId: "MarketplaceApps",
                                    title: "Marketplace Apps",
                                    type: "category",
                                    viewHref: "/forums/Marketplace-Apps/ct-p/MarketplaceApps"
                                }
                            },
                            {
                                cursor: "16",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/my-new-collection",
                                    productId: "my-new-collection",
                                    title: "My New Collection",
                                    type: "category",
                                    viewHref: "/forums/My-New-Collection/ct-p/my-new-collection"
                                }
                            },
                            {
                                cursor: "17",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/atlassian-marketplace",
                                    productId: "atlassian-marketplace",
                                    title: "Product Add-ons",
                                    type: "category",
                                    viewHref: "/forums/Product-Add-ons/ct-p/atlassian-marketplace"
                                }
                            },
                            {
                                cursor: "18",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/products-qa-category",
                                    productId: "products-qa-category",
                                    title: "Products QA Category",
                                    type: "category",
                                    viewHref: "/forums/Products-QA-Category/ct-p/products-qa-category"
                                }
                            },
                            {
                                cursor: "19",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/sourcetree",
                                    productId: "sourcetree",
                                    title: "SourceTree",
                                    type: "category",
                                    viewHref: "/forums/SourceTree/ct-p/sourcetree"
                                }
                            },
                            {
                                cursor: "20",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/statuspage",
                                    productId: "statuspage",
                                    title: "StatusPage",
                                    type: "category",
                                    viewHref: "/forums/StatusPage/ct-p/statuspage"
                                }
                            },
                            {
                                cursor: "21",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/stride",
                                    productId: "stride",
                                    title: "Stride",
                                    type: "category",
                                    viewHref: "/forums/Stride/ct-p/stride"
                                }
                            },
                            {
                                cursor: "22",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/trello",
                                    productId: "trello",
                                    title: "Trello",
                                    type: "category",
                                    viewHref: "/forums/Trello/ct-p/trello"
                                }
                            },
                            {
                                cursor: "23",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/xyz",
                                    productId: "xyz",
                                    title: "XYZ",
                                    type: "category",
                                    viewHref: "/forums/XYZ/ct-p/xyz"
                                }
                            }
                        ],
                        totalCount: 24
                    }
                }
            }
        }),
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {
                    user: {
                        __typename: "AtlassianAccountUser",
                        accountId: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        accountStatus: "active",
                        name: "Logged In",
                        email: "loggedin@atlassian.com",
                        nickname: "Logged In",
                        picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128",
                        id: "ari:cloud:identity::user/712020:0189aab4-6460-4699-a05b-939927f7ebea"
                    }
                }
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Logged In",
                    picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128",
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 1
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 6
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 0,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        }),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 4,
                                answersCreated: 5,
                                articlesCreated: 6,
                                kudosReceived: 7,
                                totalPosts: 13,
                                rank: "MARKETPLACE PARTNER"
                            }
                        }
                    }
                }
            }
        }),
    UnifiedLearningCertificationQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        learning: {
                            __typename: "UnifiedLearning",
                            certifications: {
                                __typename: "UnifiedLearningCertificationConnection",
                                edges: (0, $40181de4ac92c9ea$export$777fa732f79e69c6)({
                                    count: variables.first ?? 10,
                                    withEmeritus: true
                                }),
                                totalCount: 10
                            }
                        }
                    }
                }
            }
        }),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            viewHref: "/forums/Welcome-Center/gh-p/WelcomeCenter",
                                            title: "Welcome Center",
                                            groupMemberCount: 11,
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T16:50:44Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            viewHref: "/forums/Toronto-AUG/gh-p/TorontoAUG",
                                            title: "Toronto AUG",
                                            groupMemberCount: 2,
                                            topicsCount: 1,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:03:20Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:TorontoAUG"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            viewHref: "/forums/San-Diego-AUG/gh-p/SanDiegoAUG",
                                            title: "San Diego AUG",
                                            groupMemberCount: 6,
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:02:31Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SanDiegoAUG"
                                        }
                                    },
                                    {
                                        cursor: "3",
                                        node: {
                                            viewHref: "/forums/Secret-AUG/gh-p/SecretAUG",
                                            title: "Secret AUG",
                                            groupMemberCount: 4,
                                            topicsCount: 0,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:02:15Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SecretAUG"
                                        }
                                    },
                                    {
                                        cursor: "4",
                                        node: {
                                            viewHref: "/forums/Austin-AUG/gh-p/aug-atx",
                                            title: "Austin AUG",
                                            groupMemberCount: 16,
                                            topicsCount: 32,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-09-28T15:44:23Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: "/forums/image/serverpage/image-id/292i59680227343233C1/image-size/medium?v=v2&px=400"
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:aug-atx"
                                        }
                                    },
                                    {
                                        cursor: "5",
                                        node: {
                                            viewHref: "/forums/Rooting-for-Raisins/gh-p/RootingforRaisins",
                                            title: "Rooting for Raisins",
                                            groupMemberCount: 4,
                                            topicsCount: 4,
                                            hasHiddenAncestor: false,
                                            joinDate: "2024-01-23T21:43:48Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: "/forums/image/serverpage/image-id/263iDC6C8847513F900E/image-size/medium?v=v2&px=400"
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:RootingforRaisins"
                                        }
                                    }
                                ],
                                totalCount: 6
                            }
                        }
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            imageUrl: "https://randomuser.me/api/portraits/men/6.jpg",
                                            name: "Test Course Four",
                                            actionUrl: "https://www.atlassian.com",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            imageUrl: "https://randomuser.me/api/portraits/men/4.jpg",
                                            name: "Test Course Two",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/2"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            name: "Test Course Three",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/3",
                                            imageUrl: "https://randomuser.me/api/portraits/women/1.jpg"
                                        }
                                    },
                                    {
                                        cursor: "3",
                                        node: {
                                            name: "Test Course One",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/4",
                                            imageUrl: "https://randomuser.me/api/portraits/women/2.jpg"
                                        }
                                    },
                                    {
                                        cursor: "4",
                                        node: {
                                            name: "Test Course Five",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/5",
                                            imageUrl: "https://randomuser.me/api/portraits/women/3.jpg"
                                        }
                                    }
                                ],
                                totalCount: 5
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        type: "kms"
                                    }
                                },
                                {
                                    node: {
                                        description: "Answers accepted",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7",
                                        imageUrl: "",
                                        name: "First Accepted Solution",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37",
                                        imageUrl: "",
                                        name: "Level 0",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Likes received",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15",
                                        imageUrl: "",
                                        name: "First Like Received",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31",
                                        imageUrl: "",
                                        name: "Test Peter",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12",
                                        imageUrl: "",
                                        name: "5 Topics Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11",
                                        imageUrl: "",
                                        name: "First Topic Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Role badges",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20",
                                        imageUrl: "",
                                        name: "Atlassian Team",
                                        type: "khoros"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "8",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 8
                        }
                    }
                }
            }
        }),
    UnifiedConsentQuery: (variables)=>({
            data: {
                unified: {
                    consent: {
                        getConsent: {
                            __typename: "UnifiedConsentStatus",
                            id: "ch-712020:0189aab4-6460-4699-a05b-939927f7ebea",
                            consentObj: [
                                {
                                    consentKey: "privacyPolicy",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "termsOfService",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "targetingCookies",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "allowPartnerShare",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "allowSponsorShare",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "eapTermsOfService",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "functionalCookies",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "performanceCookies",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "generalMarketingOptIn",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "communityTermsOfService",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "strictlyNecessaryCookies",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "eapCommunityTermsOfService",
                                    consentStatus: "true",
                                    consenthubStatus: true,
                                    uppConsentStatus: false
                                },
                                {
                                    consentKey: "doNotSellOrSharePersonalData",
                                    consentStatus: "false",
                                    consenthubStatus: false,
                                    uppConsentStatus: false
                                }
                            ],
                            updatedAt: "2025-06-24T04:18:52.632Z",
                            value: "712020:0189aab4-6460-4699-a05b-939927f7ebea"
                        }
                    }
                }
            }
        }),
    CommunityInitializeMutation: (variables)=>({
            data: {
                unified: {
                    community: {
                        initializeCommunity: {
                            errors: [],
                            forumsProfile: {
                                id: "723"
                            },
                            success: true,
                            gamificationProfile: {
                                userId: "712020:0189aab4-6460-4699-a05b-939927f7ebea"
                            },
                            unifiedProfile: {
                                aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                                accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                                internalId: "c34de571-576f-45e6-8c02-0917609af889",
                                id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889"
                            }
                        }
                    }
                }
            }
        })
};



const $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f = {
    UnifiedSystemMutation: (variables)=>({
            data: {
                unified: {
                    createUnifiedSystem: {
                        errors: [],
                        success: true,
                        unifiedProfile: {
                            bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                            company: "Nike",
                            aaid: "62587f99fdb60b0069294184",
                            id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                            linkedinUrl: "linkedin.com/colbystauss",
                            location: "Utah, USA",
                            accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                            products: null,
                            role: "CEO",
                            internalId: "c34de571-576f-45e6-8c02-0917609af889",
                            username: "fullloggedout",
                            websiteUrl: "colbystauss.net",
                            xUrl: null,
                            youtubeUrl: null,
                            isPrivate: false,
                            isPersonalView: false,
                            isLinkedView: false
                        }
                    }
                }
            }
        }),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="https://www.atlassian.com">Atlassian</a>.</p>',
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "analytics,halp,hipchat",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "fullloggedout",
                        websiteUrl: "https://www.atlassian.com",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [
                            {
                                cursor: "0",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/analytics",
                                    productId: "analytics",
                                    title: "Analytics Visualization Platform",
                                    type: "category",
                                    viewHref: "/t5/Analytics-Visualization-Platform/ct-p/analytics"
                                }
                            },
                            {
                                cursor: "1",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/atlas",
                                    productId: "atlas",
                                    title: "Atlas",
                                    type: "category",
                                    viewHref: "/t5/Atlas/ct-p/atlas"
                                }
                            },
                            {
                                cursor: "2",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/identity-manager",
                                    productId: "identity-manager",
                                    title: "Atlassian Access",
                                    type: "category",
                                    viewHref: "/t5/Atlassian-Access/ct-p/identity-manager"
                                }
                            },
                            {
                                cursor: "3",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/bamboo",
                                    productId: "bamboo",
                                    title: "Bamboo",
                                    type: "category",
                                    viewHref: "/t5/Bamboo/ct-p/bamboo"
                                }
                            },
                            {
                                cursor: "4",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/bitbucket",
                                    productId: "bitbucket",
                                    title: "Bitbucket",
                                    type: "category",
                                    viewHref: "/t5/Bitbucket/ct-p/bitbucket"
                                }
                            },
                            {
                                cursor: "5",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/clover",
                                    productId: "clover",
                                    title: "Clover",
                                    type: "category",
                                    viewHref: "/t5/Clover/ct-p/clover"
                                }
                            },
                            {
                                cursor: "6",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/announcements",
                                    productId: "announcements",
                                    title: "Community Announcements",
                                    type: "category",
                                    viewHref: "/t5/Community-Announcements/ct-p/announcements"
                                }
                            },
                            {
                                cursor: "7",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/confluence",
                                    productId: "confluence",
                                    title: "Confluence",
                                    type: "category",
                                    viewHref: "/t5/Confluence/ct-p/confluence"
                                }
                            },
                            {
                                cursor: "8",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/confluence-collection",
                                    productId: "confluence-collection",
                                    title: "Confluence Collection",
                                    type: "category",
                                    viewHref: "/t5/Confluence-Collection/ct-p/confluence-collection"
                                }
                            },
                            {
                                cursor: "9",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/crowd",
                                    productId: "crowd",
                                    title: "Crowd",
                                    type: "category",
                                    viewHref: "/t5/Crowd/ct-p/crowd"
                                }
                            },
                            {
                                cursor: "10",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/data-center",
                                    productId: "data-center",
                                    title: "Data Center",
                                    type: "category",
                                    viewHref: "/t5/Data-Center/ct-p/data-center"
                                }
                            },
                            {
                                cursor: "11",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/fisheye-crucible",
                                    productId: "fisheye-crucible",
                                    title: "FishEye/Crucible",
                                    type: "category",
                                    viewHref: "/t5/FishEye-Crucible/ct-p/fisheye-crucible"
                                }
                            },
                            {
                                cursor: "12",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/halp",
                                    productId: "halp",
                                    title: "Halp",
                                    type: "category",
                                    viewHref: "/t5/Halp/ct-p/halp"
                                }
                            },
                            {
                                cursor: "13",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/hipchat",
                                    productId: "hipchat",
                                    title: "HipChat",
                                    type: "category",
                                    viewHref: "/t5/HipChat/ct-p/hipchat"
                                }
                            },
                            {
                                cursor: "14",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/jira",
                                    productId: "jira",
                                    title: "Jira",
                                    type: "category",
                                    viewHref: "/t5/Jira/ct-p/jira"
                                }
                            },
                            {
                                cursor: "15",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/MarketplaceApps",
                                    productId: "MarketplaceApps",
                                    title: "Marketplace Apps",
                                    type: "category",
                                    viewHref: "/t5/Marketplace-Apps/ct-p/MarketplaceApps"
                                }
                            },
                            {
                                cursor: "16",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/my-new-collection",
                                    productId: "my-new-collection",
                                    title: "My New Collection",
                                    type: "category",
                                    viewHref: "/t5/My-New-Collection/ct-p/my-new-collection"
                                }
                            },
                            {
                                cursor: "17",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/atlassian-marketplace",
                                    productId: "atlassian-marketplace",
                                    title: "Product Add-ons",
                                    type: "category",
                                    viewHref: "/t5/Product-Add-ons/ct-p/atlassian-marketplace"
                                }
                            },
                            {
                                cursor: "18",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/products-qa-category",
                                    productId: "products-qa-category",
                                    title: "Products QA Category",
                                    type: "category",
                                    viewHref: "/t5/Products-QA-Category/ct-p/products-qa-category"
                                }
                            },
                            {
                                cursor: "19",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/sourcetree",
                                    productId: "sourcetree",
                                    title: "SourceTree",
                                    type: "category",
                                    viewHref: "/t5/SourceTree/ct-p/sourcetree"
                                }
                            },
                            {
                                cursor: "20",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/statuspage",
                                    productId: "statuspage",
                                    title: "StatusPage",
                                    type: "category",
                                    viewHref: "/t5/StatusPage/ct-p/statuspage"
                                }
                            },
                            {
                                cursor: "21",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/stride",
                                    productId: "stride",
                                    title: "Stride",
                                    type: "category",
                                    viewHref: "/t5/Stride/ct-p/stride"
                                }
                            },
                            {
                                cursor: "22",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/trello",
                                    productId: "trello",
                                    title: "Trello",
                                    type: "category",
                                    viewHref: "/t5/Trello/ct-p/trello"
                                }
                            },
                            {
                                cursor: "23",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/xyz",
                                    productId: "xyz",
                                    title: "XYZ",
                                    type: "category",
                                    viewHref: "/t5/XYZ/ct-p/xyz"
                                }
                            }
                        ],
                        totalCount: 24
                    }
                }
            }
        }),
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {}
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Logged Out",
                    picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128",
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 1
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 0
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 23,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        }),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 12,
                                answersCreated: 11,
                                articlesCreated: 93,
                                kudosReceived: 1,
                                totalPosts: 1,
                                rank: "RISING STAR"
                            }
                        }
                    }
                }
            }
        }),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            viewHref: "/t5/Welcome-Center/gh-p/WelcomeCenter",
                                            title: "Welcome Center",
                                            groupMemberCount: 11,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T16:50:44Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            viewHref: "/t5/Toronto-AUG/gh-p/TorontoAUG",
                                            title: "Toronto AUG",
                                            groupMemberCount: 2,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 1,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:03:20Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:TorontoAUG"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            viewHref: "/t5/San-Diego-AUG/gh-p/SanDiegoAUG",
                                            title: "San Diego AUG",
                                            groupMemberCount: 6,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:02:31Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SanDiegoAUG"
                                        }
                                    },
                                    {
                                        cursor: "3",
                                        node: {
                                            viewHref: "/t5/Secret-AUG/gh-p/SecretAUG",
                                            title: "Secret AUG",
                                            groupMemberCount: 4,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 0,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:02:15Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SecretAUG"
                                        }
                                    },
                                    {
                                        cursor: "4",
                                        node: {
                                            viewHref: "/t5/Austin-AUG/gh-p/aug-atx",
                                            title: "Austin AUG",
                                            groupMemberCount: 16,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 32,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-09-28T15:44:23Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: "/t5/image/serverpage/image-id/292i59680227343233C1/image-size/medium?v=v2&px=400"
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:aug-atx"
                                        }
                                    },
                                    {
                                        cursor: "5",
                                        node: {
                                            viewHref: "/t5/Rooting-for-Raisins/gh-p/RootingforRaisins",
                                            title: "Rooting for Raisins",
                                            groupMemberCount: 4,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 4,
                                            hasHiddenAncestor: false,
                                            joinDate: "2024-01-23T21:43:48Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: "/t5/image/serverpage/image-id/263iDC6C8847513F900E/image-size/medium?v=v2&px=400"
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:RootingforRaisins"
                                        }
                                    }
                                ],
                                totalCount: 6
                            }
                        }
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            actionUrl: "https://www.atlassian.com",
                                            imageUrl: "https://randomuser.me/api/portraits/men/6.jpg",
                                            name: "Test Course Four",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            imageUrl: "https://randomuser.me/api/portraits/men/4.jpg",
                                            name: "Test Course Two",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/2"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            name: "Test Course Three",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/3",
                                            imageUrl: "https://randomuser.me/api/portraits/women/1.jpg"
                                        }
                                    },
                                    {
                                        cursor: "3",
                                        node: {
                                            name: "Test Course One",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/4",
                                            imageUrl: "https://randomuser.me/api/portraits/women/2.jpg"
                                        }
                                    },
                                    {
                                        cursor: "4",
                                        node: {
                                            name: "Test Course Five",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/5",
                                            imageUrl: "https://randomuser.me/api/portraits/women/3.jpg"
                                        }
                                    }
                                ],
                                totalCount: 5
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        type: "kms"
                                    }
                                },
                                {
                                    node: {
                                        description: "Answers accepted",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7",
                                        imageUrl: "",
                                        name: "First Accepted Solution",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37",
                                        imageUrl: "",
                                        name: "Level 0",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Likes received",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15",
                                        imageUrl: "",
                                        name: "First Like Received",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31",
                                        imageUrl: "",
                                        name: "Test Peter",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12",
                                        imageUrl: "",
                                        name: "5 Topics Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11",
                                        imageUrl: "",
                                        name: "First Topic Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Role badges",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20",
                                        imageUrl: "",
                                        name: "Atlassian Team",
                                        type: "khoros"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "8",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 8
                        }
                    }
                }
            }
        }),
    UnifiedLearningCertificationQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            certifications: {
                                __typename: "UnifiedLearningCertificationConnection",
                                id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/certifications",
                                edges: (0, $40181de4ac92c9ea$export$777fa732f79e69c6)({
                                    count: variables.first ?? 10,
                                    withEmeritus: true
                                }),
                                totalCount: 10
                            }
                        }
                    }
                }
            }
        }),
    ProfileHeaderQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        location: "Kansas, USA",
                        role: "CEO",
                        username: "fullloggedout"
                    }
                }
            }
        })
};


const $2ab838cd658f759f$export$2ecd21ff5fd0c8df = {
    UnifiedSystemMutation: (variables)=>({
            data: {
                unified: {
                    createUnifiedSystem: {
                        errors: [],
                        success: true,
                        unifiedProfile: {
                            bio: "",
                            company: "",
                            aaid: "62587f99fdb60b0069294184",
                            id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                            linkedinUrl: "",
                            location: "",
                            accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                            products: null,
                            role: "",
                            internalId: "c34de571-576f-45e6-8c02-0917609af889",
                            username: "emptyloggedout",
                            websiteUrl: "",
                            xUrl: null,
                            youtubeUrl: null,
                            isPrivate: false,
                            isPersonalView: false,
                            isLinkedView: false
                        }
                    }
                }
            }
        }),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: "",
                        company: "",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "",
                        products: null,
                        role: "",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "emptyloggedout",
                        websiteUrl: "",
                        xUrl: "",
                        youtubeUrl: "",
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    }
                }
            }
        }),
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {}
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Empty User",
                    picture: "http://www.google.com/initials",
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 0
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 0
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 0,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        }),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 0,
                                answersCreated: 0,
                                articlesCreated: 0,
                                kudosReceived: 0,
                                totalPosts: 0
                            }
                        }
                    }
                }
            }
        }),
    UnifiedLearningCertificationQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        learning: {
                            __typename: "UnifiedLearning",
                            certifications: {
                                __typename: "UnifiedLearningCertificationConnection",
                                edges: [],
                                totalCount: 0
                            }
                        }
                    }
                }
            }
        }),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [],
                                totalCount: 0
                            }
                        }
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [],
                                totalCount: 0
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [],
                            pageInfo: {
                                endCursor: "0",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 0
                        }
                    }
                }
            }
        })
};


const $7b587f4ee19b4d9c$export$f26e5c1f057d036a = {
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedQueryError",
                        identifier: "nonexistent",
                        message: "ACCOUNTS_FETCH_BY_UNIFIED_PROFILE_USERNAME_FAILED, Unable to fetch profile",
                        extensions: [
                            {
                                errorType: "INTERNAL_SERVER_ERROR",
                                statusCode: 500
                            }
                        ]
                    }
                }
            }
        })
};



const $cc6ea6d92182c6c1$export$7bdb4660628ea86d = {
    UnifiedSystemMutation: (variables)=>({
            data: {
                unified: {
                    createUnifiedSystem: {
                        errors: [],
                        success: true,
                        unifiedProfile: {
                            bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                            company: "Nike",
                            aaid: "62587f99fdb60b0069294184",
                            id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                            linkedinUrl: "linkedin.com/colbystauss",
                            location: "Utah, USA",
                            accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                            products: null,
                            role: "CEO",
                            internalId: "c34de571-576f-45e6-8c02-0917609af889",
                            username: "loggedoutsinglecertificate",
                            websiteUrl: "colbystauss.net",
                            xUrl: null,
                            youtubeUrl: null,
                            isPrivate: false,
                            isPersonalView: false,
                            isLinkedView: false
                        }
                    }
                }
            }
        }),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "analytics,halp,hipchat",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedoutsinglecertificate",
                        websiteUrl: "colbystauss.net",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [
                            {
                                cursor: "0",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/analytics",
                                    productId: "analytics",
                                    title: "Analytics Visualization Platform",
                                    type: "category",
                                    viewHref: "/t5/Analytics-Visualization-Platform/ct-p/analytics"
                                }
                            },
                            {
                                cursor: "1",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/atlas",
                                    productId: "atlas",
                                    title: "Atlas",
                                    type: "category",
                                    viewHref: "/t5/Atlas/ct-p/atlas"
                                }
                            },
                            {
                                cursor: "2",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/identity-manager",
                                    productId: "identity-manager",
                                    title: "Atlassian Access",
                                    type: "category",
                                    viewHref: "/t5/Atlassian-Access/ct-p/identity-manager"
                                }
                            },
                            {
                                cursor: "3",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/bamboo",
                                    productId: "bamboo",
                                    title: "Bamboo",
                                    type: "category",
                                    viewHref: "/t5/Bamboo/ct-p/bamboo"
                                }
                            },
                            {
                                cursor: "4",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/bitbucket",
                                    productId: "bitbucket",
                                    title: "Bitbucket",
                                    type: "category",
                                    viewHref: "/t5/Bitbucket/ct-p/bitbucket"
                                }
                            },
                            {
                                cursor: "5",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/clover",
                                    productId: "clover",
                                    title: "Clover",
                                    type: "category",
                                    viewHref: "/t5/Clover/ct-p/clover"
                                }
                            },
                            {
                                cursor: "6",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/announcements",
                                    productId: "announcements",
                                    title: "Community Announcements",
                                    type: "category",
                                    viewHref: "/t5/Community-Announcements/ct-p/announcements"
                                }
                            },
                            {
                                cursor: "7",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/confluence",
                                    productId: "confluence",
                                    title: "Confluence",
                                    type: "category",
                                    viewHref: "/t5/Confluence/ct-p/confluence"
                                }
                            },
                            {
                                cursor: "8",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/confluence-collection",
                                    productId: "confluence-collection",
                                    title: "Confluence Collection",
                                    type: "category",
                                    viewHref: "/t5/Confluence-Collection/ct-p/confluence-collection"
                                }
                            },
                            {
                                cursor: "9",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/crowd",
                                    productId: "crowd",
                                    title: "Crowd",
                                    type: "category",
                                    viewHref: "/t5/Crowd/ct-p/crowd"
                                }
                            },
                            {
                                cursor: "10",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/data-center",
                                    productId: "data-center",
                                    title: "Data Center",
                                    type: "category",
                                    viewHref: "/t5/Data-Center/ct-p/data-center"
                                }
                            },
                            {
                                cursor: "11",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/fisheye-crucible",
                                    productId: "fisheye-crucible",
                                    title: "FishEye/Crucible",
                                    type: "category",
                                    viewHref: "/t5/FishEye-Crucible/ct-p/fisheye-crucible"
                                }
                            },
                            {
                                cursor: "12",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/halp",
                                    productId: "halp",
                                    title: "Halp",
                                    type: "category",
                                    viewHref: "/t5/Halp/ct-p/halp"
                                }
                            },
                            {
                                cursor: "13",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/hipchat",
                                    productId: "hipchat",
                                    title: "HipChat",
                                    type: "category",
                                    viewHref: "/t5/HipChat/ct-p/hipchat"
                                }
                            },
                            {
                                cursor: "14",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/jira",
                                    productId: "jira",
                                    title: "Jira",
                                    type: "category",
                                    viewHref: "/t5/Jira/ct-p/jira"
                                }
                            },
                            {
                                cursor: "15",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/MarketplaceApps",
                                    productId: "MarketplaceApps",
                                    title: "Marketplace Apps",
                                    type: "category",
                                    viewHref: "/t5/Marketplace-Apps/ct-p/MarketplaceApps"
                                }
                            },
                            {
                                cursor: "16",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/my-new-collection",
                                    productId: "my-new-collection",
                                    title: "My New Collection",
                                    type: "category",
                                    viewHref: "/t5/My-New-Collection/ct-p/my-new-collection"
                                }
                            },
                            {
                                cursor: "17",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/atlassian-marketplace",
                                    productId: "atlassian-marketplace",
                                    title: "Product Add-ons",
                                    type: "category",
                                    viewHref: "/t5/Product-Add-ons/ct-p/atlassian-marketplace"
                                }
                            },
                            {
                                cursor: "18",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/products-qa-category",
                                    productId: "products-qa-category",
                                    title: "Products QA Category",
                                    type: "category",
                                    viewHref: "/t5/Products-QA-Category/ct-p/products-qa-category"
                                }
                            },
                            {
                                cursor: "19",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/sourcetree",
                                    productId: "sourcetree",
                                    title: "SourceTree",
                                    type: "category",
                                    viewHref: "/t5/SourceTree/ct-p/sourcetree"
                                }
                            },
                            {
                                cursor: "20",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/statuspage",
                                    productId: "statuspage",
                                    title: "StatusPage",
                                    type: "category",
                                    viewHref: "/t5/StatusPage/ct-p/statuspage"
                                }
                            },
                            {
                                cursor: "21",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/stride",
                                    productId: "stride",
                                    title: "Stride",
                                    type: "category",
                                    viewHref: "/t5/Stride/ct-p/stride"
                                }
                            },
                            {
                                cursor: "22",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/trello",
                                    productId: "trello",
                                    title: "Trello",
                                    type: "category",
                                    viewHref: "/t5/Trello/ct-p/trello"
                                }
                            },
                            {
                                cursor: "23",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/xyz",
                                    productId: "xyz",
                                    title: "XYZ",
                                    type: "category",
                                    viewHref: "/t5/XYZ/ct-p/xyz"
                                }
                            }
                        ],
                        totalCount: 24
                    }
                }
            }
        }),
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {}
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Logged Out",
                    picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128",
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 1
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 0
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 0,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        }),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 12,
                                answersCreated: 11,
                                articlesCreated: 93,
                                kudosReceived: 0,
                                totalPosts: 0
                            }
                        }
                    }
                }
            }
        }),
    CertificationsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            certifications: {
                                __typename: "UnifiedLearningCertificationConnection",
                                totalCount: 3,
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            activeDate: "2024-05-09",
                                            expireDate: "2024-05-09",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/cloudFoundations",
                                            imageUrl: "www.image.com",
                                            inactiveDate: "2024-05-09",
                                            name: "Atlassian Cloud Foundations",
                                            nameAbbr: "Cloud-1",
                                            status: "COMPLETED"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            activeDate: "2024-05-10",
                                            expireDate: "2024-05-09",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/itsm",
                                            imageUrl: "www.image.com",
                                            inactiveDate: "2024-05-09",
                                            name: "ITSM with Jira Service Management Foundations Certification",
                                            nameAbbr: "ITSM-1",
                                            status: "COMPLETED"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            activeDate: "2024-05-11",
                                            expireDate: "2024-05-09",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/certifications/managing",
                                            imageUrl: "www.image.com",
                                            inactiveDate: "2024-05-09",
                                            name: "Managing Jira Projects for Cloud Certification",
                                            nameAbbr: "managing-1",
                                            status: "COMPLETED"
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        }),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            viewHref: "/t5/Welcome-Center/gh-p/WelcomeCenter",
                                            title: "Welcome Center",
                                            groupMemberCount: 11,
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T16:50:44Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            viewHref: "/t5/Toronto-AUG/gh-p/TorontoAUG",
                                            title: "Toronto AUG",
                                            groupMemberCount: 2,
                                            topicsCount: 1,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:03:20Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:TorontoAUG"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            viewHref: "/t5/San-Diego-AUG/gh-p/SanDiegoAUG",
                                            title: "San Diego AUG",
                                            groupMemberCount: 6,
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:02:31Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SanDiegoAUG"
                                        }
                                    },
                                    {
                                        cursor: "3",
                                        node: {
                                            viewHref: "/t5/Secret-AUG/gh-p/SecretAUG",
                                            title: "Secret AUG",
                                            groupMemberCount: 4,
                                            topicsCount: 0,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:02:15Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:SecretAUG"
                                        }
                                    },
                                    {
                                        cursor: "4",
                                        node: {
                                            viewHref: "/t5/Austin-AUG/gh-p/aug-atx",
                                            title: "Austin AUG",
                                            groupMemberCount: 16,
                                            topicsCount: 32,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-09-28T15:44:23Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: "/t5/image/serverpage/image-id/292i59680227343233C1/image-size/medium?v=v2&px=400"
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:aug-atx"
                                        }
                                    },
                                    {
                                        cursor: "5",
                                        node: {
                                            viewHref: "/t5/Rooting-for-Raisins/gh-p/RootingforRaisins",
                                            title: "Rooting for Raisins",
                                            groupMemberCount: 4,
                                            topicsCount: 4,
                                            hasHiddenAncestor: false,
                                            joinDate: "2024-01-23T21:43:48Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: "/t5/image/serverpage/image-id/263iDC6C8847513F900E/image-size/medium?v=v2&px=400"
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:RootingforRaisins"
                                        }
                                    }
                                ],
                                totalCount: 6
                            }
                        }
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCourses: {
                                __typename: "UnifiedRecentCourseConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            activeDate: "2022-01-01",
                                            courseName: "Test Course Four",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1",
                                            src: "https://randomuser.me/api/portraits/men/6.jpg"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            activeDate: "2020-01-01",
                                            courseName: "Test Course Two",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/2",
                                            src: "https://randomuser.me/api/portraits/men/4.jpg"
                                        }
                                    },
                                    {
                                        cursor: "2",
                                        node: {
                                            activeDate: "2021-01-01",
                                            courseName: "Test Course Three",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/3",
                                            src: "https://randomuser.me/api/portraits/women/1.jpg"
                                        }
                                    },
                                    {
                                        cursor: "3",
                                        node: {
                                            activeDate: "2019-01-01",
                                            courseName: "Test Course One",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/4",
                                            src: "https://randomuser.me/api/portraits/women/2.jpg"
                                        }
                                    },
                                    {
                                        cursor: "4",
                                        node: {
                                            activeDate: "2023-01-01",
                                            courseName: "Test Course Five",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/5",
                                            src: "https://randomuser.me/api/portraits/women/3.jpg"
                                        }
                                    }
                                ],
                                pageInfo: {
                                    endCursor: "5",
                                    hasNextPage: false,
                                    hasPreviousPage: false,
                                    startCursor: "0"
                                },
                                totalCount: 5
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        type: "kms"
                                    }
                                },
                                {
                                    node: {
                                        description: "Answers accepted",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7",
                                        imageUrl: "",
                                        name: "First Accepted Solution",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37",
                                        imageUrl: "",
                                        name: "Level 0",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Likes received",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15",
                                        imageUrl: "",
                                        name: "First Like Received",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31",
                                        imageUrl: "",
                                        name: "Test Peter",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12",
                                        imageUrl: "",
                                        name: "5 Topics Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11",
                                        imageUrl: "",
                                        name: "First Topic Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Role badges",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20",
                                        imageUrl: "",
                                        name: "Atlassian Team",
                                        type: "khoros"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "8",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 8
                        }
                    }
                }
            }
        }),
    UnifiedLearningCertificationQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        learning: {
                            __typename: "UnifiedLearning",
                            certifications: {
                                __typename: "UnifiedLearningCertificationConnection",
                                edges: (0, $40181de4ac92c9ea$export$777fa732f79e69c6)({
                                    count: 1,
                                    withEmeritus: false
                                }),
                                totalCount: 1
                            }
                        }
                    }
                }
            }
        }),
    ProfileHeaderQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        location: "Kansas, USA",
                        role: "CEO",
                        username: "loggedoutsinglecertificate"
                    }
                }
            }
        })
};



const $a89189ea6cc5a4c1$export$89bbb2431d737acb = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                        company: null,
                        // Main change
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "analytics,halp,hipchat",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedoutnoprofilecompany",
                        websiteUrl: "colbystauss.net",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [],
                        totalCount: 0
                    }
                }
            }
        })
};



const $1e6011280b2e4a24$export$178cd3e009024616 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "analytics,halp,hipchat",
                        role: null,
                        // Main change
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedoutnoprofileposition",
                        websiteUrl: "colbystauss.net",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [],
                        totalCount: 0
                    }
                }
            }
        })
};



const $35fd9cf069c9894d$export$bea5c6bf3b47b5ec = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutuserinitialsprofilepicture"
                    }
                }
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Logged Out",
                    picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/initials/CS-4.png",
                    // Main change
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        })
};


const $9148aa08bab58f6f$export$1b6fef8f8a44276 = {
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {
                    user: null
                }
            }
        })
};


const $715d7b3f0ebbbbb0$export$2f59fa3fef6c4040 = {
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {
                    user: {
                        __typename: "AtlassianAccountUser",
                        accountId: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        accountStatus: "active",
                        name: "Logged In",
                        email: "loggedin@atlassian.com",
                        nickname: "Logged In",
                        picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128",
                        id: "ari:cloud:identity::user/712020:0189aab4-6460-4699-a05b-939927f7ebea"
                    }
                }
            }
        }),
    UnifiedSystemMutation: (variables)=>({
            data: {
                unified: {
                    createUnifiedSystem: {
                        errors: [],
                        success: true,
                        unifiedProfile: {
                            bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
                            company: "Nike",
                            aaid: "62587f99fdb60b0069294184",
                            id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                            linkedinUrl: "linkedin.com/colbystauss",
                            location: "Utah, USA",
                            accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                            products: null,
                            role: "CEO",
                            internalId: "c34de571-576f-45e6-8c02-0917609af889",
                            username: "fullloggedin",
                            websiteUrl: "colbystauss.net",
                            xUrl: null,
                            youtubeUrl: null,
                            isPrivate: false,
                            isPersonalView: true,
                            isLinkedView: false
                        }
                    }
                }
            }
        })
};



const $886d06ab937da4fd$export$bd6857437a295342 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutmanybadges"
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [],
                                totalCount: 0
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                ...new Array(1103).fill(null).map((_, index)=>({
                                        node: {
                                            description: "Answer 1 question tagged \u201Ccloud\u201D",
                                            id: `ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589`,
                                            imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                            name: "Cloudie",
                                            type: "kms"
                                        }
                                    }))
                            ],
                            pageInfo: {
                                endCursor: "1103",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 1103
                        }
                    }
                }
            }
        })
};



const $66f2c4fb4f370e2f$export$f615cee095b52782 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutnorecentcourses"
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [],
                                totalCount: 0
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        type: "kms"
                                    }
                                },
                                {
                                    node: {
                                        description: "Answers accepted",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7",
                                        imageUrl: "",
                                        name: "First Accepted Solution",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37",
                                        imageUrl: "",
                                        name: "Level 0",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Likes received",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15",
                                        imageUrl: "",
                                        name: "First Like Received",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31",
                                        imageUrl: "",
                                        name: "Test Peter",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12",
                                        imageUrl: "",
                                        name: "5 Topics Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11",
                                        imageUrl: "",
                                        name: "First Topic Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Role badges",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20",
                                        imageUrl: "",
                                        name: "Atlassian Team",
                                        type: "khoros"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "1103",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 1103
                        }
                    }
                }
            }
        })
};



const $21b5f777c24d30c6$export$281002907661f265 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedinnorecentcourses"
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [],
                                totalCount: 0
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        type: "kms"
                                    }
                                },
                                {
                                    node: {
                                        description: "Answers accepted",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7",
                                        imageUrl: "",
                                        name: "First Accepted Solution",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37",
                                        imageUrl: "",
                                        name: "Level 0",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Likes received",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15",
                                        imageUrl: "",
                                        name: "First Like Received",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: null,
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31",
                                        imageUrl: "",
                                        name: "Test Peter",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12",
                                        imageUrl: "",
                                        name: "5 Topics Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Topics discussed",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11",
                                        imageUrl: "",
                                        name: "First Topic Discussed",
                                        type: "khoros"
                                    }
                                },
                                {
                                    node: {
                                        description: "Role badges",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20",
                                        imageUrl: "",
                                        name: "Atlassian Team",
                                        type: "khoros"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "8",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 8
                        }
                    }
                }
            }
        })
};



const $8e190c4049561839$export$3c58ab94cf3f9a65 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            actionUrl: "https://www.atlassian.com",
                                            imageUrl: "https://randomuser.me/api/portraits/men/6.jpg",
                                            name: "Test Course Four",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1"
                                        }
                                    }
                                ],
                                totalCount: 1
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        actionUrl: "https://www.atlassian.com",
                                        type: "kms"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "1",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 1
                        }
                    }
                }
            }
        })
};



const $54a21a58bfea3221$export$5f7213acf7a64eaf = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            actionUrl: "https://www.atlassian.com",
                                            imageUrl: "https://randomuser.me/api/portraits/men/6.jpg",
                                            name: "Test Course Four",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1"
                                        }
                                    }
                                ],
                                totalCount: 1
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [
                                {
                                    node: {
                                        description: "Answer 1 question tagged \u201Ccloud\u201D",
                                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589",
                                        imageUrl: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530",
                                        name: "Cloudie",
                                        actionUrl: "https://www.atlassian.com",
                                        type: "kms"
                                    }
                                }
                            ],
                            pageInfo: {
                                endCursor: "1",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 1
                        }
                    }
                }
            }
        })
};



const $eeca7ae34c480208$export$121382178bfd74e7 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: "<p>Hi I'm an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer an engineer.</p>",
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "analytics,halp,hipchat",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedoutlongbio",
                        websiteUrl: "colbystauss.net",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [],
                        totalCount: 0
                    }
                }
            }
        })
};



const $9507866cd9e316c9$export$9175c39b76f79cdf = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: "<p>Hi I'm an engineer.</p>",
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: null,
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "halp",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedoutnocontactlinks",
                        websiteUrl: null,
                        xUrl: null,
                        youtubeUrl: null,
                        isPrivate: false,
                        isPersonalView: false,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [
                            {
                                cursor: "12",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/halp",
                                    productId: "halp",
                                    title: "Halp",
                                    type: "category",
                                    viewHref: "/t5/Halp/ct-p/halp"
                                }
                            }
                        ],
                        totalCount: 1
                    }
                }
            }
        })
};



const $b8c17c7df1cd3e4e$export$d514bff8f804606b = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: null,
                        company: "Nike",
                        aaid: "712020:0189aab4-6460-4699-a05b-939927f7ebea",
                        linkedinUrl: "linkedin.com/colbystauss",
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "halp",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedinnobio",
                        websiteUrl: "colbystauss.net",
                        xUrl: "x.com/colby",
                        youtubeUrl: "youtube.com/colby",
                        isPrivate: false,
                        isPersonalView: true,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [
                            {
                                cursor: "1",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/halp",
                                    productId: "halp",
                                    title: "Halp",
                                    type: "category",
                                    viewHref: "/t5/Halp/ct-p/halp"
                                }
                            }
                        ],
                        totalCount: 1
                    }
                }
            }
        })
};



const $855d0a613d39911d$export$a993971fd4a62228 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "privateprofile",
                        isPrivate: true,
                        isPersonalView: false,
                        isLinkedView: false
                    }
                }
            }
        }),
    AtlassianAccountUserQuery: (variables)=>({
            data: {
                me: {
                    user: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).AtlassianAccountUserQuery(variables).data.me.user,
                        accountId: null
                    }
                }
            }
        })
};



const $b1d870d57dcf1c96$export$7e11038ba81d11f1 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        bio: "<p>Hi I'm an engineer.</p>",
                        company: "Nike",
                        aaid: "62587f99fdb60b0069294184",
                        linkedinUrl: null,
                        accountInternalId: "541b9286-8563-4825-aae8-43e7e90fb493",
                        location: "Kansas, USA",
                        products: "halp",
                        role: "CEO",
                        internalId: "c34de571-576f-45e6-8c02-0917609af889",
                        username: "loggedinnocontactlinks",
                        websiteUrl: null,
                        xUrl: null,
                        youtubeUrl: null,
                        isPrivate: false,
                        isPersonalView: true,
                        isLinkedView: false
                    },
                    atlassianProducts: {
                        __typename: "UnifiedAtlassianProductConnection",
                        edges: [
                            {
                                cursor: "12",
                                node: {
                                    id: "ari:cloud:unified-portable-profile::unified-atlassian-product/halp",
                                    productId: "halp",
                                    title: "Halp",
                                    type: "category",
                                    viewHref: "/t5/Halp/ct-p/halp"
                                }
                            }
                        ],
                        totalCount: 1
                    }
                }
            }
        })
};



const $7582af1129bbb007$export$4d24479133275ec9 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutwithoutsomestats"
                    }
                }
            }
        }),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 12,
                                answersCreated: 11,
                                articlesCreated: 93,
                                kudosReceived: 0,
                                totalPosts: 0,
                                rank: "RISING STAR"
                            }
                        }
                    }
                }
            }
        })
};



const $9b4b0f89dba6fb5f$export$5b2486770874960 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    StatsSnapshotQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            snapshot: {
                                __typename: "UnifiedForumsSnapshot",
                                id: "ari:cloud:unified-portable-profile::forums/723/snapshot",
                                acceptedAnswersCreated: 12,
                                answersCreated: 11,
                                articlesCreated: 93,
                                kudosReceived: 0,
                                totalPosts: 0,
                                rank: "RISING STAR"
                            }
                        }
                    }
                }
            }
        })
};



const $7123ba9d0fd9d89f$export$242a83832dbcba7a = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutonegroup"
                    }
                }
            }
        }),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            viewHref: "/t5/Welcome-Center/gh-p/WelcomeCenter",
                                            title: "Welcome Center",
                                            groupMemberCount: 11,
                                            aaid: "62587f99fdb60b0069294184",
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T16:50:44Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter"
                                        }
                                    }
                                ],
                                totalCount: 1
                            }
                        }
                    }
                }
            }
        })
};



const $8235fa7c36b62329$export$a4eb959f311afb3 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedForumsGroupsQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        forums: {
                            __typename: "UnifiedForums",
                            id: "ari:cloud:unified-portable-profile::forums/723",
                            groups: {
                                __typename: "UnifiedForumsGroupsConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            viewHref: "/t5/Welcome-Center/gh-p/WelcomeCenter",
                                            title: "Welcome Center",
                                            groupMemberCount: 11,
                                            topicsCount: 6,
                                            hasHiddenAncestor: false,
                                            aaid: "62587f99fdb60b0069294184",
                                            joinDate: "2022-06-23T16:50:44Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter"
                                        }
                                    },
                                    {
                                        cursor: "1",
                                        node: {
                                            viewHref: "/t5/Toronto-AUG/gh-p/TorontoAUG",
                                            title: "Toronto AUG",
                                            groupMemberCount: 2,
                                            topicsCount: 1,
                                            aaid: "62587f99fdb60b0069294184",
                                            hasHiddenAncestor: false,
                                            joinDate: "2022-06-23T17:03:20Z",
                                            membershipType: "open",
                                            avatar: {
                                                mediumHref: ""
                                            },
                                            id: "ari:cloud:unified-portable-profile::forums/723/groups/grouphub:TorontoAUG"
                                        }
                                    }
                                ],
                                totalCount: 2
                            }
                        }
                    }
                }
            }
        })
};



const $85687a8c62c0006d$export$8b2b86f1f79cc3e8 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutwithoutpeerkudos"
                    }
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 0
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 0
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 0,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        })
};



const $d63ded9ff5880e75$export$fac8ea4c7d1d4df1 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedinwithoutpeerkudos"
                    }
                }
            }
        }),
    KudosSummaryQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        gamification: {
                            __typename: "UnifiedGamification",
                            id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184",
                            recognitionsSummary: {
                                __typename: "UnifiedGamificationRecognitionsSummary",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/recognition-summary",
                                totals: [
                                    {
                                        comment: "for writing great content",
                                        count: 0
                                    },
                                    {
                                        comment: "just because",
                                        count: 0
                                    },
                                    {
                                        comment: "for going above and beyond",
                                        count: 0
                                    },
                                    {
                                        comment: "for being awesome at an ace",
                                        count: 0
                                    }
                                ]
                            },
                            levels: {
                                __typename: "UnifiedGamificationLevel",
                                id: "ari:cloud:unified-portable-profile::gamification/62587f99fdb60b0069294184/level",
                                currentLevelArt: "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/level_icon-752347?1602275472120",
                                currentLevelDescription: "Level 1",
                                currentLevelName: "Seed",
                                currentPoints: 0,
                                maxPoints: 150,
                                nextLevelName: "Root"
                            }
                        }
                    }
                }
            }
        })
};



const $f7d289896e452c8c$export$a4e366e379af8e06 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutlongname"
                    }
                }
            }
        }),
    AtlassianAccountAnyUserQuery: (variables)=>({
            data: {
                user: {
                    __typename: "AtlassianAccountUser",
                    nickname: "Logged Out Logged Out Logged Out Logged Out",
                    picture: "https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128",
                    id: "ari:cloud:identity::user/62587f99fdb60b0069294184"
                }
            }
        })
};



const $a96fe971fbc96335$export$7be8b1022a72f03 = (count, baseId, baseName, baseDescription, baseImageUrl, baseType)=>{
    return Array.from({
        length: count
    }, (_, index)=>({
            node: {
                id: `${baseId}-${index + 1}`,
                name: `${baseName} ${index + 1}`,
                description: `${baseDescription} ${index + 1}`,
                imageUrl: `${baseImageUrl}`,
                actionUrl: "https://www.atlassian.com",
                type: baseType
            }
        }));
};


const $04107ba38d3786b2$export$c9fd4cb0b7f0c5cf = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedinusermanybadgesandcoursescaseone"
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: (0, $a96fe971fbc96335$export$7be8b1022a72f03)(1102, "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses", "Test Course", "Course Badge", "https://randomuser.me/api/portraits/men/6.jpg", "course"),
                                totalCount: 1102
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: (0, $a96fe971fbc96335$export$7be8b1022a72f03)(1102, "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge", "Cloudie", "Answer 1 question tagged \u201Ccloud\u201D", "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530", "kms"),
                            pageInfo: {
                                endCursor: "1102",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 1102
                        }
                    }
                }
            }
        })
};




const $7778e4d42defdc03$export$481ca81f3aac6967 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedinusermanybadgesandcoursescasetwo"
                    }
                }
            }
        }),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: (0, $a96fe971fbc96335$export$7be8b1022a72f03)(1105, "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses", "Test Course", "Course Badge", "https://randomuser.me/api/portraits/men/6.jpg", "course"),
                                totalCount: 1105
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: (0, $a96fe971fbc96335$export$7be8b1022a72f03)(1105, "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge", "Cloudie", "Answer 1 question tagged \u201Ccloud\u201D", "https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530", "kms"),
                            pageInfo: {
                                endCursor: "1105",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 1105
                        }
                    }
                }
            }
        })
};



const $2d1e49d770ec06f6$export$7f84b8ad236d1fb3 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    ProfileBadgesQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        __typename: "UnifiedProfile",
                        id: "ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889",
                        aaid: "62587f99fdb60b0069294184",
                        learning: {
                            __typename: "UnifiedLearning",
                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184",
                            recentCoursesBadges: {
                                __typename: "UnifiedProfileBadgesConnection",
                                edges: [
                                    {
                                        cursor: "0",
                                        node: {
                                            actionUrl: "https://www.atlassian.com",
                                            imageUrl: "https://randomuser.me/api/portraits/men/6.jpg",
                                            name: "Test Course Four",
                                            id: "ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1"
                                        }
                                    }
                                ],
                                totalCount: 1
                            }
                        },
                        badges: {
                            __typename: "UnifiedProfileBadgesConnection",
                            edges: [],
                            pageInfo: {
                                endCursor: "0",
                                hasNextPage: false,
                                hasPreviousPage: false,
                                startCursor: "0"
                            },
                            totalCount: 0
                        }
                    }
                }
            }
        })
};



const $f86933cdbb36e1ac$export$8300b363dabd1238 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedinnoconsent",
                        isProfileOwnerConsented: false
                    }
                }
            }
        })
};



const $f9b0f953482781fb$export$a221b8b1f618ca61 = {
    ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f),
    UnifiedProfileQuery: (variables)=>({
            data: {
                unified: {
                    unifiedProfile: {
                        ...(0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f).UnifiedProfileQuery(variables).data.unified.unifiedProfile,
                        username: "loggedoutnoconsent",
                        isProfileOwnerConsented: false
                    }
                }
            }
        })
};



const $6babd2e8cf0fe674$export$643d95cf1122a8a8 = {
    ...(0, $a2524e20d5294bc9$export$2d5e5d48d26f9268),
    UnifiedAccountQuery: (variables)=>{
        const response = (0, $a2524e20d5294bc9$export$2d5e5d48d26f9268).UnifiedAccountQuery(variables);
        return {
            data: {
                unified: {
                    ...response.data.unified,
                    account: {
                        ...response.data.unified.account,
                        isForumsModerator: true
                    }
                }
            }
        };
    }
};


const $48499f09ec551876$var$handleBaseUrl = (href)=>{
    const url = new URL(href);
    const params = new URLSearchParams(url.search);
    const isloggedIn = params.has("baseLoggedIn");
    return isloggedIn ? (0, $715d7b3f0ebbbbb0$export$2f59fa3fef6c4040) : (0, $9148aa08bab58f6f$export$1b6fef8f8a44276);
};
const $48499f09ec551876$var$isBaseUrl = (href)=>{
    const baseUrlWithPossibleQuery = /\/(\?.*)?$/;
    return baseUrlWithPossibleQuery.test(href);
};
const $48499f09ec551876$var$getMockDataObject = ()=>{
    if (window.location.href.includes("forumsmoderator")) return 0, $6babd2e8cf0fe674$export$643d95cf1122a8a8;
    if (window.location.href.includes("fullloggedin")) return 0, $a2524e20d5294bc9$export$2d5e5d48d26f9268;
    if (window.location.href.includes("emptyloggedin")) return 0, $8d12ec8ae626d4da$export$517722f989ec2162;
    if (window.location.href.includes("fullloggedout")) return 0, $e1fba2e2af20d2b2$export$1a4431f8fbf13d8f;
    if (window.location.href.includes("privateprofile")) return 0, $855d0a613d39911d$export$a993971fd4a62228;
    if (window.location.href.includes("emptyloggedout")) return 0, $2ab838cd658f759f$export$2ecd21ff5fd0c8df;
    if (window.location.href.includes("nonexistent")) return 0, $7b587f4ee19b4d9c$export$f26e5c1f057d036a;
    if (window.location.href.includes("loggedoutsinglecertificate")) return 0, $cc6ea6d92182c6c1$export$7bdb4660628ea86d;
    if (window.location.href.includes("loggedoutmanybadges")) return 0, $886d06ab937da4fd$export$bd6857437a295342;
    if (window.location.href.includes("loggedoutnorecentcourses")) return 0, $66f2c4fb4f370e2f$export$f615cee095b52782;
    if (window.location.href.includes("loggedinnorecentcourses")) return 0, $21b5f777c24d30c6$export$281002907661f265;
    if (window.location.href.includes("loggedinnobadgesonecourse")) return 0, $2d1e49d770ec06f6$export$7f84b8ad236d1fb3;
    if (window.location.href.includes("loggedoutonebadgeandcourse")) return 0, $8e190c4049561839$export$3c58ab94cf3f9a65;
    if (window.location.href.includes("loggedinonebadgeandcourse")) return 0, $54a21a58bfea3221$export$5f7213acf7a64eaf;
    if (window.location.href.includes("loggedinusermanybadgesandcoursescaseone")) return 0, $04107ba38d3786b2$export$c9fd4cb0b7f0c5cf;
    if (window.location.href.includes("loggedinusermanybadgesandcoursescasetwo")) return 0, $7778e4d42defdc03$export$481ca81f3aac6967;
    if (window.location.href.includes("loggedoutlongbio")) return 0, $eeca7ae34c480208$export$121382178bfd74e7;
    if (window.location.href.includes("loggedoutnocontactlinks")) return 0, $9507866cd9e316c9$export$9175c39b76f79cdf;
    if (window.location.href.includes("loggedinnocontactlinks")) return 0, $b1d870d57dcf1c96$export$7e11038ba81d11f1;
    if (window.location.href.includes("loggedinnobio")) return 0, $b8c17c7df1cd3e4e$export$d514bff8f804606b;
    if (window.location.href.includes("loggedoutwithoutsomestats")) return 0, $7582af1129bbb007$export$4d24479133275ec9;
    if (window.location.href.includes("loggedinwithoutsomestats")) return 0, $9b4b0f89dba6fb5f$export$5b2486770874960;
    if (window.location.href.includes("loggedoutnoprofilecompany")) return 0, $a89189ea6cc5a4c1$export$89bbb2431d737acb;
    if (window.location.href.includes("loggedoutnoprofileposition")) return 0, $1e6011280b2e4a24$export$178cd3e009024616;
    if (window.location.href.includes("loggedoutuserinitialsprofilepicture")) return 0, $35fd9cf069c9894d$export$bea5c6bf3b47b5ec;
    if (window.location.href.includes("loggedoutonegroup")) return 0, $7123ba9d0fd9d89f$export$242a83832dbcba7a;
    if (window.location.href.includes("loggedouttwogroups")) return 0, $8235fa7c36b62329$export$a4eb959f311afb3;
    if (window.location.href.includes("loggedoutwithoutpeerkudos")) return 0, $85687a8c62c0006d$export$8b2b86f1f79cc3e8;
    if (window.location.href.includes("loggedinwithoutpeerkudos")) return 0, $d63ded9ff5880e75$export$fac8ea4c7d1d4df1;
    if (window.location.href.includes("loggedoutlongname")) return 0, $f7d289896e452c8c$export$a4e366e379af8e06;
    if (window.location.href.includes("loggedinnoconsent")) return 0, $f86933cdbb36e1ac$export$8300b363dabd1238;
    if (window.location.href.includes("loggedoutnoconsent")) return 0, $f9b0f953482781fb$export$a221b8b1f618ca61;
    if ($48499f09ec551876$var$isBaseUrl(window.location.href)) return $48499f09ec551876$var$handleBaseUrl(window.location.href);
    return 0, $a2524e20d5294bc9$export$2d5e5d48d26f9268;
};
const $48499f09ec551876$export$53506f850103c397 = (operationName, variables)=>{
    const mockResponses = $48499f09ec551876$var$getMockDataObject();
    if (mockResponses[operationName]) {
        const response = mockResponses[operationName](variables);
        console.log(`Mock response for operation: "${operationName}":`, response);
        return response;
    }
    console.warn(`No mock defined for operation "${operationName}"`);
    return {
        data: {}
    }; // Return empty data if no mock is defined for the operation
};


const $d12f5e126d966d57$export$d69aa84e7b32f36c = (params, variables)=>{
    console.log(`Mock request for ${params.name} with`, variables);
    return Promise.resolve((0, $48499f09ec551876$export$53506f850103c397)(params.name, variables));
};


const $b0a24095f82369bb$var$REACT_APP_UPP_GRAPHQL_URL = "/gateway/api/graphql", $b0a24095f82369bb$var$REACT_APP_USE_MOCK_NETWORK_HANDLER = "false";
const $b0a24095f82369bb$var$callGraphql = async (params, variables)=>{
    try {
        const response = await (0, $73d0a2cdf35f1275$export$299ba2dee77727e9)($b0a24095f82369bb$var$REACT_APP_UPP_GRAPHQL_URL, {
            query: params.text,
            variables: variables
        }, {
            credentials: "include"
        });
        // GraphQL returns exceptions (for example, a missing required variable) in the "errors"
        // property of the response. If any exceptions occurred when processing the request,
        // throw an error to indicate to the developer what went wrong.
        if (Array.isArray(response.errors)) {
            console.error(`Error fetching GraphQL query '${params.name}' with variables '${JSON.stringify(variables)}'`);
            const errorMessages = response.errors.map((error, index)=>`Error ${index}: ${error.message}`).join("\n");
            console.error(`All error messages: \n${errorMessages}`);
            console.error(`All error details: ${JSON.stringify(response.errors)}`);
            throw new Error(errorMessages);
        }
        return response;
    } catch (e) {
        console.log("Error fetching graphql request", e);
        //throw e;
        return {
            errors: [
                e
            ]
        };
    }
};
// Conditionally use the mock network handler based on the environment variable
const $b0a24095f82369bb$var$network = (0, $eJz0f.Network).create($b0a24095f82369bb$var$REACT_APP_USE_MOCK_NETWORK_HANDLER === "true" ? (0, $d12f5e126d966d57$export$d69aa84e7b32f36c) : $b0a24095f82369bb$var$callGraphql);
const $b0a24095f82369bb$export$6bc7b24d4e862158 = new (0, $eJz0f.Environment)({
    network: $b0a24095f82369bb$var$network,
    store: new (0, $eJz0f.Store)(new (0, $eJz0f.RecordSource)(), {
        // This property tells Relay to not immediately clear its cache when the user
        // navigates around the app. Relay will hold onto the specified number of
        // query results, allowing the user to return to recently visited pages
        // and reusing cached data if its available/fresh.
        gcReleaseBufferSize: 10
    })
});



const $e5408a4b42209aa8$export$ca9e1394dc02d224 = ({ onSuccess: onSuccess, onComplete: onComplete, profileInternalId: profileInternalId })=>{
    const [commitRecognition, isInFlight] = (0, $2d93712440e0508b$exports.useMutation)((0, $d1b4ef742bdc9ff0$export$b5ac8b460e255cd6));
    const refetchRecognitionSchedule = (0, $acw62.useCallback)((loggedInUserAaid)=>{
        (0, $2d93712440e0508b$exports.fetchQuery)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), (0, $e97ebc79e04e432b$export$e0169f671b3e59f6), {
            aaid: loggedInUserAaid
        }).subscribe({
            next: ()=>{
            // Data will be automatically updated in the component
            },
            error: (error)=>{
                console.error("Failed to refetch recognition schedule", error);
            }
        });
    }, []);
    const refetchKudosSummary = (0, $acw62.useCallback)(()=>{
        (0, $2d93712440e0508b$exports.fetchQuery)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), (0, $10f21b5b6953fc2d$export$68ef570fcece8188), {
            internalId: profileInternalId
        }).subscribe({
            next: ()=>{
            // Data will be automatically updated in the component
            },
            error: (error)=>{
                console.error("Failed to refetch kudos summary", error);
            }
        });
    }, [
        profileInternalId
    ]);
    const giveRecognition = (0, $acw62.useCallback)((params)=>{
        commitRecognition({
            variables: {
                aaid: params.currentProfileAaid,
                comment: params.comment,
                value: 100
            },
            onCompleted: (response, errors)=>{
                const authenticateRecognitionVal = response?.unified?.gamification?.sendRecognition;
                if (!authenticateRecognitionVal?.success || errors) {
                    if (errors) console.error("Giving recognition failed", errors);
                } else {
                    refetchRecognitionSchedule(params.loggedInUserAaid);
                    refetchKudosSummary();
                    (0, $9a59db8343324c6b$export$af0144b723aef4e9)({
                        recognitionReason: params.comment,
                        senderAaid: params.loggedInUserAaid,
                        receiverAaid: params.currentProfileAaid,
                        profileInternalId: params.pathProfileId
                    });
                    onSuccess();
                }
                onComplete();
            },
            onError: (error)=>{
                console.error("Giving recognition failed", error);
                onComplete?.();
            }
        });
    }, [
        commitRecognition,
        refetchRecognitionSchedule,
        refetchKudosSummary,
        onSuccess,
        onComplete
    ]);
    return {
        giveRecognition: giveRecognition,
        isSubmitting: isInFlight
    };
};


/* KudosModalFooter.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

/** @jsx jsx */ 
var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");

var $ede1f1939e49e4d2$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $acw62.useContext)((0, $c409c6850144d199$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $246b20cce3342d64$var$footerStyles = (0, $jjlaj.css)({
    display: "flex",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: (0, $b77b51d464e4238b$export$6f98e8eaf0be1996),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingTop: "".concat((0, $b77b51d464e4238b$export$6f98e8eaf0be1996) - (0, $b77b51d464e4238b$export$4c317248f944c2a9), "px"),
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $246b20cce3342d64$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ede1f1939e49e4d2$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $jjlaj.jsx)("div", {
        css: $246b20cce3342d64$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $246b20cce3342d64$export$2e2bcd8739ae039 = $246b20cce3342d64$var$ModalFooter;


/** @jsx jsx */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");
var $0c27aa7a20d367fb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 

var $9cbaa315e36eaba7$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $9cbaa315e36eaba7$export$c93026a968943f95 = "light";
var $9cbaa315e36eaba7$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $9cbaa315e36eaba7$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $9cbaa315e36eaba7$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $9cbaa315e36eaba7$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $9cbaa315e36eaba7$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $9cbaa315e36eaba7$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $9cbaa315e36eaba7$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $9cbaa315e36eaba7$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d2815711d11bdbaf$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9cbaa315e36eaba7$export$6d8204c2cb2e06b8() / 4;
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $9cbaa315e36eaba7$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $9cbaa315e36eaba7$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $9cbaa315e36eaba7$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $9cbaa315e36eaba7$export$ba1d834b86d72a09 = $9cbaa315e36eaba7$export$a1b3edb637fb4f35;
var $9cbaa315e36eaba7$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d2815711d11bdbaf$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d2815711d11bdbaf$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d2815711d11bdbaf$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $4eebd70660458527$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $9cbaa315e36eaba7$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $9cbaa315e36eaba7$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $9cbaa315e36eaba7$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $9cbaa315e36eaba7$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $5cedd6d123772aee$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $4eebd70660458527$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $5cedd6d123772aee$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $5cedd6d123772aee$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $4eebd70660458527$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $d2815711d11bdbaf$export$4b84fd0e2c617bd = "#FFEBE6";
var $d2815711d11bdbaf$export$b34b069eff244586 = "#FFBDAD";
var $d2815711d11bdbaf$export$be802dd0d8b57f35 = "#FF8F73";
var $d2815711d11bdbaf$export$60847d42f9da92a6 = "#FF7452";
var $d2815711d11bdbaf$export$4a7404f376229999 = "#FF5630";
var $d2815711d11bdbaf$export$2010d0fb4295b346 = "#DE350B";
var $d2815711d11bdbaf$export$2837b5a1a71d5c02 = "#BF2600";
var $d2815711d11bdbaf$export$8d9596b529bbb9cf = "#FFFAE6";
var $d2815711d11bdbaf$export$41060a744ab0b7ae = "#FFF0B3";
var $d2815711d11bdbaf$export$1cc05bbbf340e559 = "#FFE380";
var $d2815711d11bdbaf$export$5aae31392d72caaa = "#FFC400";
var $d2815711d11bdbaf$export$c6930421db9fa514 = "#FFAB00";
var $d2815711d11bdbaf$export$59619663aa6500fb = "#FF991F";
var $d2815711d11bdbaf$export$874739ea9e379ab6 = "#FF8B00";
var $d2815711d11bdbaf$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d2815711d11bdbaf$export$69a3bf21b9686c2b = "#ABF5D1";
var $d2815711d11bdbaf$export$afbce1382ec95f73 = "#79F2C0";
var $d2815711d11bdbaf$export$747d86715d4175de = "#57D9A3";
var $d2815711d11bdbaf$export$940e1f69e873f202 = "#36B37E";
var $d2815711d11bdbaf$export$a49394138f7b8e85 = "#00875A";
var $d2815711d11bdbaf$export$6fa04827ac68a4fb = "#006644";
var $d2815711d11bdbaf$export$226de0355ed012f8 = "#DEEBFF";
var $d2815711d11bdbaf$export$8c13c2ee36917869 = "#B3D4FF";
var $d2815711d11bdbaf$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d2815711d11bdbaf$export$215b7063051591f1 = "#2684FF";
var $d2815711d11bdbaf$export$e62e8919cca44969 = "#0065FF";
var $d2815711d11bdbaf$export$b3de0ae08da2ce64 = "#0052CC";
var $d2815711d11bdbaf$export$a6ee3d71bc067634 = "#0747A6";
var $d2815711d11bdbaf$export$363e4475840015bb = "#EAE6FF";
var $d2815711d11bdbaf$export$4b0a4417ed59760f = "#C0B6F2";
var $d2815711d11bdbaf$export$6011520a64d9a187 = "#998DD9";
var $d2815711d11bdbaf$export$a7175d4e9206bc80 = "#8777D9";
var $d2815711d11bdbaf$export$b48405b95304b5a1 = "#6554C0";
var $d2815711d11bdbaf$export$c71e4279dd54a18d = "#5243AA";
var $d2815711d11bdbaf$export$147899de772240ec = "#403294";
var $d2815711d11bdbaf$export$2cf711fe14c66f06 = "#E6FCFF";
var $d2815711d11bdbaf$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d2815711d11bdbaf$export$776c9c497ef08533 = "#79E2F2";
var $d2815711d11bdbaf$export$69cb3ca10c1e330e = "#00C7E6";
var $d2815711d11bdbaf$export$9dc1ef0f3f48059b = "#00B8D9";
var $d2815711d11bdbaf$export$7c835c78b6fcdef8 = "#00A3BF";
var $d2815711d11bdbaf$export$6036577f95c3877e = "#008DA6";
var $d2815711d11bdbaf$export$29a4f05edc054374 = "#FFFFFF";
var $d2815711d11bdbaf$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d2815711d11bdbaf$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d2815711d11bdbaf$export$3e51e8f1440314ba = "#EBECF0";
var $d2815711d11bdbaf$export$1ce2d1575d444ceb = "#DFE1E6";
var $d2815711d11bdbaf$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d2815711d11bdbaf$export$c2e91cbeada39b8b = "#B3BAC5";
var $d2815711d11bdbaf$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d2815711d11bdbaf$export$eaa8c8a70ac22806 = "#97A0AF";
var $d2815711d11bdbaf$export$7c87d337fb91a97d = "#8993A4";
var $d2815711d11bdbaf$export$d6447c357493214f = "#7A869A";
var $d2815711d11bdbaf$export$f563ee71e9ee74cd = "#6B778C";
var $d2815711d11bdbaf$export$e2ef2124cf4024b1 = "#5E6C84";
var $d2815711d11bdbaf$export$eece5f492e429f08 = "#505F79";
var $d2815711d11bdbaf$export$c39c0fe0f26207ae = "#42526E";
var $d2815711d11bdbaf$export$7090862dc3038a9f = "#344563";
var $d2815711d11bdbaf$export$ad0bacf983b7ddaa = "#253858";
var $d2815711d11bdbaf$export$7d61b15e0da132af = "#172B4D";
var $d2815711d11bdbaf$export$fbda843f0a27fe96 = "#091E42";
var $d2815711d11bdbaf$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d2815711d11bdbaf$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d2815711d11bdbaf$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d2815711d11bdbaf$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d2815711d11bdbaf$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d2815711d11bdbaf$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d2815711d11bdbaf$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d2815711d11bdbaf$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d2815711d11bdbaf$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d2815711d11bdbaf$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d2815711d11bdbaf$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d2815711d11bdbaf$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d2815711d11bdbaf$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d2815711d11bdbaf$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d2815711d11bdbaf$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d2815711d11bdbaf$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d2815711d11bdbaf$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $d2815711d11bdbaf$export$2f6319cf7d736c2a = "#E6EDFA";
var $d2815711d11bdbaf$export$95126bc8884d6634 = "#DCE5F5";
var $d2815711d11bdbaf$export$8338d8c35d44ff1 = "#CED9EB";
var $d2815711d11bdbaf$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d2815711d11bdbaf$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d2815711d11bdbaf$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d2815711d11bdbaf$export$97e81faa16a182c7 = "#8C9CB8";
var $d2815711d11bdbaf$export$bfe21c59123ecf33 = "#7988A3";
var $d2815711d11bdbaf$export$ee82aa2ea6a1558 = "#67758F";
var $d2815711d11bdbaf$export$682927c6ed76be02 = "#56637A";
var $d2815711d11bdbaf$export$91fd9994c5be9757 = "#455166";
var $d2815711d11bdbaf$export$d281fbfe3cff2df6 = "#3B475C";
var $d2815711d11bdbaf$export$3902c91d8b98a753 = "#313D52";
var $d2815711d11bdbaf$export$8e8133c1ba5845b5 = "#283447";
var $d2815711d11bdbaf$export$33ff357f6620b39 = "#202B3D";
var $d2815711d11bdbaf$export$633847cf062b69e0 = "#1B2638";
var $d2815711d11bdbaf$export$9776a6e503bdbf76 = "#121A29";
var $d2815711d11bdbaf$export$6c813d5160dff5db = "#0E1624";
var $d2815711d11bdbaf$export$3d4f271a500072a = "#0D1424";
var $d2815711d11bdbaf$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d2815711d11bdbaf$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d2815711d11bdbaf$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d2815711d11bdbaf$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d2815711d11bdbaf$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d2815711d11bdbaf$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d2815711d11bdbaf$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d2815711d11bdbaf$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d2815711d11bdbaf$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d2815711d11bdbaf$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d2815711d11bdbaf$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d2815711d11bdbaf$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d2815711d11bdbaf$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d2815711d11bdbaf$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d2815711d11bdbaf$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d2815711d11bdbaf$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d2815711d11bdbaf$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $d2815711d11bdbaf$export$8ce1fd94bee2f412 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($d2815711d11bdbaf$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($d2815711d11bdbaf$export$633847cf062b69e0, ")")
});
var $d2815711d11bdbaf$export$b861914ea877b580 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($d2815711d11bdbaf$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($d2815711d11bdbaf$export$8c13c2ee36917869, ")")
});
var $d2815711d11bdbaf$export$3f1b020df94387af = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($d2815711d11bdbaf$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($d2815711d11bdbaf$export$d281fbfe3cff2df6, ")")
});
var $d2815711d11bdbaf$export$c0183dbab98ca63e = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($d2815711d11bdbaf$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($d2815711d11bdbaf$export$8e8133c1ba5845b5, ")")
});
var $d2815711d11bdbaf$export$6f093cfa640b7166 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($d2815711d11bdbaf$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($d2815711d11bdbaf$export$5368d76ae4fbbda7, ")")
});
var $d2815711d11bdbaf$export$42f8e9c698766e7a = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($d2815711d11bdbaf$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d2815711d11bdbaf$export$5368d76ae4fbbda7, ")")
});
var $d2815711d11bdbaf$export$c2d157ca1c34b6e3 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($d2815711d11bdbaf$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($d2815711d11bdbaf$export$b3de0ae08da2ce64, ")")
});
var $d2815711d11bdbaf$export$1905ba28d7cf066f = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($d2815711d11bdbaf$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d2815711d11bdbaf$export$97e81faa16a182c7, ")")
});
var $d2815711d11bdbaf$export$bd9002130d306d39 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($d2815711d11bdbaf$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d2815711d11bdbaf$export$bfe21c59123ecf33, ")")
});
var $d2815711d11bdbaf$export$46e4a324ac90507f = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($d2815711d11bdbaf$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d2815711d11bdbaf$export$5368d76ae4fbbda7, ")")
});
var $d2815711d11bdbaf$export$79f3f2b82beb0d36 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($d2815711d11bdbaf$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d2815711d11bdbaf$export$97e81faa16a182c7, ")")
});
var $d2815711d11bdbaf$export$7bb0d5c671655cc4 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$9fdfb749e33cdf97,
    dark: $d2815711d11bdbaf$export$8e8133c1ba5845b5
});
var $d2815711d11bdbaf$export$9c30223ca0a664fb = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($d2815711d11bdbaf$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($d2815711d11bdbaf$export$ecfc1dff386a3e7a, ")")
});
var $d2815711d11bdbaf$export$7ed258b0728b004b = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($d2815711d11bdbaf$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($d2815711d11bdbaf$export$215b7063051591f1, ")")
});
var $d2815711d11bdbaf$export$dfa920d8decc8a59 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($d2815711d11bdbaf$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($d2815711d11bdbaf$export$ecfc1dff386a3e7a, ")")
});
var $d2815711d11bdbaf$export$6069e6ad5c78f632 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($d2815711d11bdbaf$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($d2815711d11bdbaf$export$215b7063051591f1, ")")
});
var $d2815711d11bdbaf$export$9ad721cf3b3debe0 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($d2815711d11bdbaf$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($d2815711d11bdbaf$export$ecfc1dff386a3e7a, ")")
});
var $d2815711d11bdbaf$export$2aa0182783e7e9de = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$b3de0ae08da2ce64,
    dark: $d2815711d11bdbaf$export$ecfc1dff386a3e7a
});
var $d2815711d11bdbaf$export$8bf7dff220b82b4a = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$9dc1ef0f3f48059b,
    dark: $d2815711d11bdbaf$export$69cb3ca10c1e330e
});
var $d2815711d11bdbaf$export$e13cce2a2d16a9d4 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$b48405b95304b5a1,
    dark: $d2815711d11bdbaf$export$6011520a64d9a187
});
var $d2815711d11bdbaf$export$a90204d1394caf30 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$4a7404f376229999,
    dark: $d2815711d11bdbaf$export$4a7404f376229999
});
var $d2815711d11bdbaf$export$594c5a8758200c32 = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$c6930421db9fa514,
    dark: $d2815711d11bdbaf$export$c6930421db9fa514
});
var $d2815711d11bdbaf$export$955a2ebd2fb142ae = (0, $5cedd6d123772aee$export$2e2bcd8739ae039)({
    light: $d2815711d11bdbaf$export$940e1f69e873f202,
    dark: $d2815711d11bdbaf$export$940e1f69e873f202
});
var $d2815711d11bdbaf$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($d2815711d11bdbaf$export$8d43898f60b96a82, ")");
};


var $3ab5ab3d43a68898$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $d847f661580efa86$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $d2815711d11bdbaf$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $d2815711d11bdbaf$export$29a4f05edc054374), ")");
}
var $d847f661580efa86$var$rotate = (0, $jjlaj.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $d847f661580efa86$var$rotateStyles = (0, $jjlaj.css)({
    animation: "".concat($d847f661580efa86$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $d847f661580efa86$var$loadIn = (0, $jjlaj.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $d847f661580efa86$var$loadInStyles = (0, $jjlaj.css)({
    animation: "".concat($d847f661580efa86$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $d847f661580efa86$var$wrapperStyles = (0, $jjlaj.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $d847f661580efa86$var$circleStyles = (0, $jjlaj.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d847f661580efa86$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
var $d847f661580efa86$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3ab5ab3d43a68898$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d847f661580efa86$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $0c27aa7a20d367fb$export$2e2bcd8739ae039));
    $d847f661580efa86$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jjlaj.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $d847f661580efa86$var$wrapperStyles,
            $d847f661580efa86$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jjlaj.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $d847f661580efa86$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $jjlaj.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $d847f661580efa86$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));


const $441f86547dd59805$export$994a453e91e6cab5 = ({ isReasonSelected: isReasonSelected, isSubmitting: isSubmitting, onSendRecognition: onSendRecognition })=>{
    const isButtonDisabled = !isReasonSelected || isSubmitting;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $246b20cce3342d64$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _2lx21bp4 _4cvr1y6m _1wpz1fhb"
            ]),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _4t3i1ylp _1yt41dzv _1bahesu3 _4cvresu3 _kqswstnw _1ltv7vkz _94n57vkz _syazjqlt _y3gn1h6o _ect41q02 _1wyb7vkz _k48pni7l _vwz4gktf"
                    ]),
                    children: "+100 PTS"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: onSendRecognition,
                        type: "submit",
                        disabled: isButtonDisabled,
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_kqswstnw _1xi27vkz _94n57vkz _1e0c1txw _4t3i1ylp _1yt41dzv _1bahesu3 _4cvresu3 _syazdqsh _1wyb7vkz _zg8l4jg8 _k48pni7l _vwz4gktf _bfhk15v2 _2rko1y44 _1dqoglyw _80omtlke",
                            isReasonSelected && !isSubmitting && "_bfhk16j5 _syaz3etr _80omtlke"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _zulp1oug"
                            ]),
                            children: [
                                isSubmitting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_kqswstnw _1ltv1ssb _154i1ssb _t9ec1ooe"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d847f661580efa86$export$2e2bcd8739ae039), {
                                        size: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        isSubmitting && "_3um015vq"
                                    ]),
                                    children: "Give recognition"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const $441f86547dd59805$var$giveRecognitionButton = null;
const $441f86547dd59805$var$giveRecognitionButtonActive = null;
const $441f86547dd59805$var$recognitionAmountStyles = null;
const $441f86547dd59805$var$giveRecognitionFooterStyles = null;
const $441f86547dd59805$var$buttonContentStyles = null;
const $441f86547dd59805$var$hiddenTextStyles = null;
const $441f86547dd59805$var$centeredSpinnerStyles = null;


/* KudosModalHeader.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

var $79ef2cf25005c825$exports = {};
"use strict";
Object.defineProperty($79ef2cf25005c825$exports, "__esModule", {
    value: true
});
$79ef2cf25005c825$exports.default = void 0;

var $79ef2cf25005c825$var$_react = $79ef2cf25005c825$var$_interopRequireDefault((parcelRequire("acw62")));

function $79ef2cf25005c825$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $79ef2cf25005c825$var$CrossIcon = (props)=>/*#__PURE__*/ $79ef2cf25005c825$var$_react.default.createElement($909afc01458e2b41$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$79ef2cf25005c825$var$CrossIcon.displayName = "CrossIcon";
var $79ef2cf25005c825$var$_default = $79ef2cf25005c825$var$CrossIcon;
$79ef2cf25005c825$exports.default = $79ef2cf25005c825$var$_default;


/** @jsx jsx */ parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $185e137d176d1262$var$headerStyles = (0, $jjlaj.css)({
    display: "flex",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: (0, $b77b51d464e4238b$export$6f98e8eaf0be1996),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingBottom: "".concat((0, $b77b51d464e4238b$export$6f98e8eaf0be1996) - (0, $b77b51d464e4238b$export$4c317248f944c2a9), "px"),
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $185e137d176d1262$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ede1f1939e49e4d2$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $jjlaj.jsx)("div", {
        css: $185e137d176d1262$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $185e137d176d1262$export$2e2bcd8739ae039 = $185e137d176d1262$var$ModalHeader;


const $f90d700a3e79fe6a$export$30ede47bad3eb2e6 = ({ recognitionSchedule: recognitionSchedule, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $185e137d176d1262$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _2lx21bp4 _zulp1eps"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_syazr3uz _ect4kwxw _k48pzul8 _vwz4gosd _1wybhiv4"
                            ]),
                            children: "Give recognition"
                        }),
                        recognitionSchedule?.availablePoints !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1e0c1txw _2lx21bp4 _zulph461"
                            ]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_k48pc13d _1wybxjmg _vwz4l6l0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1k3w"
                                ]),
                                children: `${recognitionSchedule.availablePoints} left this week`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onClose,
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_kqswstnw _1xi27vkz _154i1tcg _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _2rko1y44"
                    ]),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79ef2cf25005c825$exports))), {
                        label: "Close Modal",
                        size: "large",
                        primaryColor: "var(--ds-text)"
                    })
                })
            ]
        })
    });
};
const $f90d700a3e79fe6a$var$closeButtonStyles = null;
const $f90d700a3e79fe6a$var$giveRecognitionHeaderStyle = null;
const $f90d700a3e79fe6a$var$giveRecognitionHeaderContainer = null;
const $f90d700a3e79fe6a$var$giveRecognitionHeaderSubtitle = null;
const $f90d700a3e79fe6a$var$recognitionInfoContainer = null;




var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $89521677a55c2272$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89521677a55c2272$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89521677a55c2272$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89521677a55c2272$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89521677a55c2272$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $89521677a55c2272$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $89521677a55c2272$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $89521677a55c2272$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $89521677a55c2272$var$_objectSpread($89521677a55c2272$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $e244bc916caaef66$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $e244bc916caaef66$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $e244bc916caaef66$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e244bc916caaef66$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e244bc916caaef66$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $e244bc916caaef66$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e244bc916caaef66$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $e244bc916caaef66$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $e244bc916caaef66$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $e244bc916caaef66$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $89521677a55c2272$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $cf8590d0a45a9dfc$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $025517dbaab8c128$export$2e2bcd8739ae039));
};


function $384ecea4e7973d42$export$5bf35293e545f20c() {
    var analyticsContext = (0, $cf8590d0a45a9dfc$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $d29f5b3d0d51225a$export$33752cf3ee811995)(function(payload) {
        return new (0, $e244bc916caaef66$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $bbc15e91ddf20cb5$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $f2645c9c716c7cdf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2645c9c716c7cdf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2645c9c716c7cdf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2645c9c716c7cdf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f2645c9c716c7cdf$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $384ecea4e7973d42$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $bbc15e91ddf20cb5$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $bbc15e91ddf20cb5$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f2645c9c716c7cdf$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $45f4b35fa627590b$export$2e2bcd8739ae039() {}



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");
// Allows support for heading levels 1-9 via aria-level
var $4166e07202f48cb9$var$HeadingLevelContext = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $4166e07202f48cb9$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $acw62.useContext)($4166e07202f48cb9$var$HeadingLevelContext);
};
var $4166e07202f48cb9$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $4166e07202f48cb9$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $4166e07202f48cb9$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $4166e07202f48cb9$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4166e07202f48cb9$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $4166e07202f48cb9$export$2e2bcd8739ae039 = $4166e07202f48cb9$var$HeadingLevelContextProvider;



var $02Ztr = parcelRequire("02Ztr");

var $jjlaj = parcelRequire("jjlaj");

var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");
var $6895126650a7f820$export$4ef52930e33717cd = "data-theme";
var $6895126650a7f820$export$a00eac3f8684bcd0 = "data-color-mode";
var $6895126650a7f820$export$2112803007239c61 = "data-contrast-mode";
var $6895126650a7f820$export$352e418ed5b6193a = "data-custom-theme";
var $6895126650a7f820$export$2faeed762aac6741 = "light";
var $6895126650a7f820$export$6f0c6fb8c80fcc92 = "ds";
var $6895126650a7f820$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $6895126650a7f820$export$dddac1532e822863 = "--".concat($6895126650a7f820$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6895126650a7f820$export$9d7b58831ae93caa = "--".concat($6895126650a7f820$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $ad8f02e30ed95df2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad8f02e30ed95df2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad8f02e30ed95df2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad8f02e30ed95df2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad8f02e30ed95df2$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $ad8f02e30ed95df2$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $ad8f02e30ed95df2$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $ad8f02e30ed95df2$export$632685d741f3dbbf = $ad8f02e30ed95df2$var$_objectSpread($ad8f02e30ed95df2$var$_objectSpread({}, $ad8f02e30ed95df2$export$958d0ae7f2977ae4), $ad8f02e30ed95df2$export$d2dc61f58390201c);
var $ad8f02e30ed95df2$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $ad8f02e30ed95df2$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $ad8f02e30ed95df2$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ad8f02e30ed95df2$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $ad8f02e30ed95df2$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $ad8f02e30ed95df2$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ad8f02e30ed95df2$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $ad8f02e30ed95df2$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $ad8f02e30ed95df2$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ad8f02e30ed95df2$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $ad8f02e30ed95df2$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $ad8f02e30ed95df2$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $ad8f02e30ed95df2$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $ad8f02e30ed95df2$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $ad8f02e30ed95df2$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $ad8f02e30ed95df2$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $ad8f02e30ed95df2$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $ad8f02e30ed95df2$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ad8f02e30ed95df2$export$e615f061ca585a6c = $ad8f02e30ed95df2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7(spacingProperty, $ad8f02e30ed95df2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ad8f02e30ed95df2$export$bf46c3f9eeafc71f = $ad8f02e30ed95df2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7(spacingProperty, $ad8f02e30ed95df2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ad8f02e30ed95df2$export$e7af83bafe7f9e63 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("backgroundColor", $ad8f02e30ed95df2$export$d1d79bf68ac056bd);
var $ad8f02e30ed95df2$export$3a1bcba60b23d7f0 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("color", $ad8f02e30ed95df2$export$8473307aa00d6ea1);
var $ad8f02e30ed95df2$export$45f3f4fe16f9f7d5 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("fontWeight", $ad8f02e30ed95df2$export$303e322c6b1ed114);
var $ad8f02e30ed95df2$export$68cc305da27dbaa4 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("fontFamily", $ad8f02e30ed95df2$export$3c7e9587132614b4);
var $ad8f02e30ed95df2$export$128f10c238242f83 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("font", $ad8f02e30ed95df2$export$6ffa317d5e70375);
var $ad8f02e30ed95df2$export$219d364c0da35ae4 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("font", $ad8f02e30ed95df2$export$236bfe3a33ef1292);
var $ad8f02e30ed95df2$export$38845ca010b93505 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7("fontWeight", $ad8f02e30ed95df2$export$855cfd311192d666);
var $ad8f02e30ed95df2$export$ff257d957d48c421 = $ad8f02e30ed95df2$export$ca0f9c2de39ffed7((0, $6895126650a7f820$export$9d7b58831ae93caa), $ad8f02e30ed95df2$export$41a358c9c2356760);
var $ad8f02e30ed95df2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ad8f02e30ed95df2$export$41a358c9c2356760[color] !== undefined;
};


var $acw62 = parcelRequire("acw62");
var $1d44a74b978dbb87$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $1d44a74b978dbb87$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($1d44a74b978dbb87$export$1ca2a26fecb070ae);
};
$1d44a74b978dbb87$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";




var $hPtJY = parcelRequire("hPtJY");
var $6dade6aab478882f$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $6dade6aab478882f$var$headingResetStyles = (0, $jjlaj.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $6dade6aab478882f$var$useColor = function useColor(colorProp) {
    var surface = (0, $1d44a74b978dbb87$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $ad8f02e30ed95df2$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $ad8f02e30ed95df2$export$2185ce37f9bdd963)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $6dade6aab478882f$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $hPtJY;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $4166e07202f48cb9$export$97a37b1befbbf9b1)($6dade6aab478882f$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $6dade6aab478882f$var$useColor(colorProp);
    return (0, $jjlaj.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $6dade6aab478882f$var$headingResetStyles,
            size && $6dade6aab478882f$var$headingSizeStylesMap[size],
            $6dade6aab478882f$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $6dade6aab478882f$export$93e8ddd840a408f9 = {
    "color.text": (0, $jjlaj.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $jjlaj.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $jjlaj.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $6dade6aab478882f$var$headingSizeStylesMap = {
    xxlarge: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $jjlaj.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $6dade6aab478882f$export$2e2bcd8739ae039 = $6dade6aab478882f$var$Heading;



var $hPtJY = parcelRequire("hPtJY");
var $7d9e81ef639116d5$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $7d9e81ef639116d5$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $7d9e81ef639116d5$var$headingResetStyles = (0, $jjlaj.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $7d9e81ef639116d5$var$h900Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $7d9e81ef639116d5$var$h800Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $7d9e81ef639116d5$var$h700Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $7d9e81ef639116d5$var$h600Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $7d9e81ef639116d5$var$h500Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $7d9e81ef639116d5$var$h400Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $7d9e81ef639116d5$var$h300Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $7d9e81ef639116d5$var$h200Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $7d9e81ef639116d5$var$h100Styles = (0, $jjlaj.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $7d9e81ef639116d5$var$inverseStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $7d9e81ef639116d5$var$subtlestStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $7d9e81ef639116d5$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $hPtJY;
    var _useHeading = (0, $4166e07202f48cb9$export$97a37b1befbbf9b1)($7d9e81ef639116d5$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $jjlaj.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $7d9e81ef639116d5$var$headingResetStyles,
            level === "h100" && $7d9e81ef639116d5$var$h100Styles,
            level === "h200" && $7d9e81ef639116d5$var$h200Styles,
            level === "h300" && $7d9e81ef639116d5$var$h300Styles,
            level === "h400" && $7d9e81ef639116d5$var$h400Styles,
            level === "h500" && $7d9e81ef639116d5$var$h500Styles,
            level === "h600" && $7d9e81ef639116d5$var$h600Styles,
            level === "h700" && $7d9e81ef639116d5$var$h700Styles,
            level === "h800" && $7d9e81ef639116d5$var$h800Styles,
            level === "h900" && $7d9e81ef639116d5$var$h900Styles,
            color === "inverse" && $7d9e81ef639116d5$var$inverseStyles,
            color === "default" && isSubtleHeading && $7d9e81ef639116d5$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $7d9e81ef639116d5$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $7d9e81ef639116d5$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $jjlaj.jsx)($7d9e81ef639116d5$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $jjlaj.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), props);
};
var $7d9e81ef639116d5$export$2e2bcd8739ae039 = $7d9e81ef639116d5$var$Heading;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");
var $e8bac04dbce2804c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $e8bac04dbce2804c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($e8bac04dbce2804c$export$1ca2a26fecb070ae);
};
$e8bac04dbce2804c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");
var $84088d4b8a6e13ea$export$4ef52930e33717cd = "data-theme";
var $84088d4b8a6e13ea$export$a00eac3f8684bcd0 = "data-color-mode";
var $84088d4b8a6e13ea$export$2112803007239c61 = "data-contrast-mode";
var $84088d4b8a6e13ea$export$352e418ed5b6193a = "data-custom-theme";
var $84088d4b8a6e13ea$export$2faeed762aac6741 = "light";
var $84088d4b8a6e13ea$export$6f0c6fb8c80fcc92 = "ds";
var $84088d4b8a6e13ea$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $84088d4b8a6e13ea$export$dddac1532e822863 = "--".concat($84088d4b8a6e13ea$export$6f0c6fb8c80fcc92, "-token-not-found");
var $84088d4b8a6e13ea$export$9d7b58831ae93caa = "--".concat($84088d4b8a6e13ea$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $b33f29a531e0ea11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b33f29a531e0ea11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b33f29a531e0ea11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b33f29a531e0ea11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b33f29a531e0ea11$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $b33f29a531e0ea11$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $b33f29a531e0ea11$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $b33f29a531e0ea11$export$632685d741f3dbbf = $b33f29a531e0ea11$var$_objectSpread($b33f29a531e0ea11$var$_objectSpread({}, $b33f29a531e0ea11$export$958d0ae7f2977ae4), $b33f29a531e0ea11$export$d2dc61f58390201c);
var $b33f29a531e0ea11$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $b33f29a531e0ea11$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $b33f29a531e0ea11$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $b33f29a531e0ea11$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $b33f29a531e0ea11$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $b33f29a531e0ea11$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $b33f29a531e0ea11$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $b33f29a531e0ea11$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $b33f29a531e0ea11$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $b33f29a531e0ea11$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $b33f29a531e0ea11$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $b33f29a531e0ea11$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $b33f29a531e0ea11$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $b33f29a531e0ea11$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $b33f29a531e0ea11$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $b33f29a531e0ea11$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $b33f29a531e0ea11$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $b33f29a531e0ea11$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $b33f29a531e0ea11$export$e615f061ca585a6c = $b33f29a531e0ea11$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $b33f29a531e0ea11$export$ca0f9c2de39ffed7(spacingProperty, $b33f29a531e0ea11$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $b33f29a531e0ea11$export$bf46c3f9eeafc71f = $b33f29a531e0ea11$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $b33f29a531e0ea11$export$ca0f9c2de39ffed7(spacingProperty, $b33f29a531e0ea11$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $b33f29a531e0ea11$export$e7af83bafe7f9e63 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("backgroundColor", $b33f29a531e0ea11$export$d1d79bf68ac056bd);
var $b33f29a531e0ea11$export$3a1bcba60b23d7f0 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("color", $b33f29a531e0ea11$export$8473307aa00d6ea1);
var $b33f29a531e0ea11$export$45f3f4fe16f9f7d5 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("fontWeight", $b33f29a531e0ea11$export$303e322c6b1ed114);
var $b33f29a531e0ea11$export$68cc305da27dbaa4 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("fontFamily", $b33f29a531e0ea11$export$3c7e9587132614b4);
var $b33f29a531e0ea11$export$128f10c238242f83 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("font", $b33f29a531e0ea11$export$6ffa317d5e70375);
var $b33f29a531e0ea11$export$219d364c0da35ae4 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("font", $b33f29a531e0ea11$export$236bfe3a33ef1292);
var $b33f29a531e0ea11$export$38845ca010b93505 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7("fontWeight", $b33f29a531e0ea11$export$855cfd311192d666);
var $b33f29a531e0ea11$export$ff257d957d48c421 = $b33f29a531e0ea11$export$ca0f9c2de39ffed7((0, $84088d4b8a6e13ea$export$9d7b58831ae93caa), $b33f29a531e0ea11$export$41a358c9c2356760);
var $b33f29a531e0ea11$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $b33f29a531e0ea11$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $jjlaj = parcelRequire("jjlaj");


var $hPtJY = parcelRequire("hPtJY");
function $e6d0345947ee0cfe$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e6d0345947ee0cfe$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e6d0345947ee0cfe$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e6d0345947ee0cfe$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e6d0345947ee0cfe$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e6d0345947ee0cfe$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e6d0345947ee0cfe$export$9a199fbafee0014e = {
    backgroundColor: (0, $b33f29a531e0ea11$export$d1d79bf68ac056bd),
    blockSize: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderBottomColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderLeftColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $b33f29a531e0ea11$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    borderWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    bottom: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    boxShadow: (0, $b33f29a531e0ea11$export$7aff6e7ba39bb774),
    color: (0, $b33f29a531e0ea11$export$8473307aa00d6ea1),
    columnGap: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    font: (0, $b33f29a531e0ea11$export$6ffa317d5e70375),
    fontFamily: (0, $b33f29a531e0ea11$export$3c7e9587132614b4),
    fontWeight: (0, $b33f29a531e0ea11$export$303e322c6b1ed114),
    gap: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    height: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    inlineSize: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    inset: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    insetBlock: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    insetBlockEnd: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    insetBlockStart: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    insetInline: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    insetInlineEnd: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    insetInlineStart: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    left: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    margin: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginBlock: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginBlockEnd: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginBlockStart: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginBottom: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginInline: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginInlineEnd: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginInlineStart: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginLeft: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginRight: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    marginTop: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    maxBlockSize: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    maxHeight: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    maxWidth: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    minBlockSize: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    minHeight: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    minInlineSize: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    minWidth: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    opacity: (0, $b33f29a531e0ea11$export$daf94a976c798b4f),
    outlineColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac),
    outlineOffset: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    outlineWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8),
    padding: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingBlock: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingBottom: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingInline: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingLeft: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingRight: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    paddingTop: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    right: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    rowGap: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4),
    top: (0, $b33f29a531e0ea11$export$632685d741f3dbbf),
    width: (0, $b33f29a531e0ea11$export$6ccdbebca2ee545f),
    zIndex: (0, $b33f29a531e0ea11$export$b5f31a7e431d2eab)
};
var $e6d0345947ee0cfe$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $e6d0345947ee0cfe$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $e6d0345947ee0cfe$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e6d0345947ee0cfe$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e6d0345947ee0cfe$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e6d0345947ee0cfe$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $e6d0345947ee0cfe$var$safeSelectors.test(key)) {
            styleObj[key] = $e6d0345947ee0cfe$var$_transformStyles(value);
            return;
        }
        if ($e6d0345947ee0cfe$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e6d0345947ee0cfe$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e6d0345947ee0cfe$export$9a199fbafee0014e)) return;
        var tokenValue = $e6d0345947ee0cfe$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e6d0345947ee0cfe$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e6d0345947ee0cfe$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $e6d0345947ee0cfe$var$uniqueSymbol, (0, $jjlaj.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $e6d0345947ee0cfe$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e6d0345947ee0cfe$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e6d0345947ee0cfe$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e6d0345947ee0cfe$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e6d0345947ee0cfe$export$f6c783d06584602c(style) {
    return $e6d0345947ee0cfe$var$baseXcss(style);
}


var $8a31190586db0eb8$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $8a31190586db0eb8$var$_excluded2 = [
    "className"
];
var $8a31190586db0eb8$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $8a31190586db0eb8$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $8a31190586db0eb8$var$_excluded2);
    var resolvedStyles = (0, $e6d0345947ee0cfe$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $8a31190586db0eb8$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $b33f29a531e0ea11$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $b33f29a531e0ea11$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $b33f29a531e0ea11$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jjlaj.jsx)((0, $e8bac04dbce2804c$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $8a31190586db0eb8$export$2e2bcd8739ae039 = $8a31190586db0eb8$export$e71c4d32a2263218;
var $8a31190586db0eb8$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $71ac53a2d478e3f7$var$justifyContentMap = {
    start: (0, $jjlaj.css)({
        justifyContent: "start"
    }),
    center: (0, $jjlaj.css)({
        justifyContent: "center"
    }),
    end: (0, $jjlaj.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jjlaj.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jjlaj.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jjlaj.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jjlaj.css)({
        justifyContent: "stretch"
    })
};
var $71ac53a2d478e3f7$var$flexDirectionMap = {
    column: (0, $jjlaj.css)({
        flexDirection: "column"
    }),
    row: (0, $jjlaj.css)({
        flexDirection: "row"
    })
};
var $71ac53a2d478e3f7$var$flexWrapMap = {
    wrap: (0, $jjlaj.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jjlaj.css)({
        flexWrap: "nowrap"
    })
};
var $71ac53a2d478e3f7$var$alignItemsMap = {
    start: (0, $jjlaj.css)({
        alignItems: "start"
    }),
    center: (0, $jjlaj.css)({
        alignItems: "center"
    }),
    baseline: (0, $jjlaj.css)({
        alignItems: "baseline"
    }),
    end: (0, $jjlaj.css)({
        alignItems: "end"
    }),
    stretch: (0, $jjlaj.css)({
        alignItems: "stretch"
    })
};
var $71ac53a2d478e3f7$var$baseStyles = (0, $jjlaj.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $71ac53a2d478e3f7$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $e6d0345947ee0cfe$export$a9c84988c8f81f2d)(xcss);
    return (0, $jjlaj.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $71ac53a2d478e3f7$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $b33f29a531e0ea11$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $b33f29a531e0ea11$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $b33f29a531e0ea11$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $71ac53a2d478e3f7$var$alignItemsMap[alignItems],
            direction && $71ac53a2d478e3f7$var$flexDirectionMap[direction],
            justifyContent && $71ac53a2d478e3f7$var$justifyContentMap[justifyContent],
            wrap && $71ac53a2d478e3f7$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$71ac53a2d478e3f7$var$Flex.displayName = "Flex";
var $71ac53a2d478e3f7$export$2e2bcd8739ae039 = $71ac53a2d478e3f7$var$Flex;


var $1f12c6db18b953b0$var$flexGrowMap = {
    hug: (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $1f12c6db18b953b0$var$separatorStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $1f12c6db18b953b0$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jjlaj.jsx)("span", {
        css: $1f12c6db18b953b0$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $1f12c6db18b953b0$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jjlaj.jsx)($1f12c6db18b953b0$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jjlaj.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $1f12c6db18b953b0$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jjlaj.jsx)((0, $71ac53a2d478e3f7$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$1f12c6db18b953b0$var$Inline.displayName = "Inline";
var $1f12c6db18b953b0$export$2e2bcd8739ae039 = $1f12c6db18b953b0$var$Inline;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $bb2d4144016fdeac$var$flexGrowMap = {
    hug: (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $bb2d4144016fdeac$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $bb2d4144016fdeac$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jjlaj.jsx)((0, $71ac53a2d478e3f7$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$bb2d4144016fdeac$var$Stack.displayName = "Stack";
var $bb2d4144016fdeac$export$2e2bcd8739ae039 = $bb2d4144016fdeac$var$Stack;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jjlaj = parcelRequire("jjlaj");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $8568069ac023c6f7$var$visuallyHiddenStyles = (0, $jjlaj.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8568069ac023c6f7$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $jjlaj.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $8568069ac023c6f7$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $8568069ac023c6f7$export$2e2bcd8739ae039 = $8568069ac023c6f7$var$VisuallyHidden;


var $a8cf11ad922cb067$export$d6830277b06edd6 = "normal";
var $a8cf11ad922cb067$export$4f8f13a66ae77bdd = "--color";
var $a8cf11ad922cb067$export$e9244ec13bd422b5 = "--bg-color";
var $a8cf11ad922cb067$export$97e78d9745006c11 = "--bg-color-hover";
var $a8cf11ad922cb067$export$291d63757828f290 = "--bg-color-active";



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $1302912422da4370$var$_excluded = [
    "children"
];
function $1302912422da4370$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $acw62.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $1302912422da4370$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $acw62.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $acw62.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $fdb39e5d87c0db59$var$_createTheme = (0, $1302912422da4370$export$25d302a5b900a763)(function() {
    return {
        mode: "light"
    };
}), $fdb39e5d87c0db59$var$Provider = $fdb39e5d87c0db59$var$_createTheme.Provider, $fdb39e5d87c0db59$var$Consumer = $fdb39e5d87c0db59$var$_createTheme.Consumer, $fdb39e5d87c0db59$export$7692396083754928 = $fdb39e5d87c0db59$var$_createTheme.useTheme;
var $fdb39e5d87c0db59$var$Theme = {
    Provider: $fdb39e5d87c0db59$var$Provider,
    Consumer: $fdb39e5d87c0db59$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fdb39e5d87c0db59$export$2e2bcd8739ae039 = $fdb39e5d87c0db59$var$Theme;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $acw62 = parcelRequire("acw62");
function $c7fc49da903314f5$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $e9954464659b19b4$var$BORDER_WIDTH = 2;
var $e9954464659b19b4$var$baseFocusOutsideStyles = (0, $jjlaj.css)({
    outline: "".concat($e9954464659b19b4$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $e9954464659b19b4$var$BORDER_WIDTH
});
var $e9954464659b19b4$var$baseInsetStyles = (0, $jjlaj.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$e9954464659b19b4$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $e9954464659b19b4$var$focusRingStyles = (0, $jjlaj.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $e9954464659b19b4$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $e9954464659b19b4$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $e9954464659b19b4$var$insetFocusRingStyles = (0, $jjlaj.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $e9954464659b19b4$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $e9954464659b19b4$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $e9954464659b19b4$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $e9954464659b19b4$var$baseInsetStyles : $e9954464659b19b4$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $e9954464659b19b4$var$insetFocusRingStyles : $e9954464659b19b4$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $jjlaj.jsx)((0, $jjlaj.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$e9954464659b19b4$var$FocusRing.displayName = "FocusRing";
var $e9954464659b19b4$export$2e2bcd8739ae039 = $e9954464659b19b4$var$FocusRing;



/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $3360c9f5dc4c66ec$export$4b84fd0e2c617bd = "#FFEBE6";
var $3360c9f5dc4c66ec$export$b34b069eff244586 = "#FFBDAD";
var $3360c9f5dc4c66ec$export$be802dd0d8b57f35 = "#FF8F73";
var $3360c9f5dc4c66ec$export$60847d42f9da92a6 = "#FF7452";
var $3360c9f5dc4c66ec$export$4a7404f376229999 = "#FF5630";
var $3360c9f5dc4c66ec$export$2010d0fb4295b346 = "#DE350B";
var $3360c9f5dc4c66ec$export$2837b5a1a71d5c02 = "#BF2600";
var $3360c9f5dc4c66ec$export$8d9596b529bbb9cf = "#FFFAE6";
var $3360c9f5dc4c66ec$export$41060a744ab0b7ae = "#FFF0B3";
var $3360c9f5dc4c66ec$export$1cc05bbbf340e559 = "#FFE380";
var $3360c9f5dc4c66ec$export$5aae31392d72caaa = "#FFC400";
var $3360c9f5dc4c66ec$export$c6930421db9fa514 = "#FFAB00";
var $3360c9f5dc4c66ec$export$59619663aa6500fb = "#FF991F";
var $3360c9f5dc4c66ec$export$874739ea9e379ab6 = "#FF8B00";
var $3360c9f5dc4c66ec$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $3360c9f5dc4c66ec$export$69a3bf21b9686c2b = "#ABF5D1";
var $3360c9f5dc4c66ec$export$afbce1382ec95f73 = "#79F2C0";
var $3360c9f5dc4c66ec$export$747d86715d4175de = "#57D9A3";
var $3360c9f5dc4c66ec$export$940e1f69e873f202 = "#36B37E";
var $3360c9f5dc4c66ec$export$a49394138f7b8e85 = "#00875A";
var $3360c9f5dc4c66ec$export$6fa04827ac68a4fb = "#006644";
var $3360c9f5dc4c66ec$export$226de0355ed012f8 = "#DEEBFF";
var $3360c9f5dc4c66ec$export$8c13c2ee36917869 = "#B3D4FF";
var $3360c9f5dc4c66ec$export$ecfc1dff386a3e7a = "#4C9AFF";
var $3360c9f5dc4c66ec$export$215b7063051591f1 = "#2684FF";
var $3360c9f5dc4c66ec$export$e62e8919cca44969 = "#0065FF";
var $3360c9f5dc4c66ec$export$b3de0ae08da2ce64 = "#0052CC";
var $3360c9f5dc4c66ec$export$a6ee3d71bc067634 = "#0747A6";
var $3360c9f5dc4c66ec$export$67f15409e87642a1 = "#669DF1";
var $3360c9f5dc4c66ec$export$f0539dbc42dbb067 = "#8FB8F6";
var $3360c9f5dc4c66ec$export$363e4475840015bb = "#EAE6FF";
var $3360c9f5dc4c66ec$export$4b0a4417ed59760f = "#C0B6F2";
var $3360c9f5dc4c66ec$export$6011520a64d9a187 = "#998DD9";
var $3360c9f5dc4c66ec$export$a7175d4e9206bc80 = "#8777D9";
var $3360c9f5dc4c66ec$export$b48405b95304b5a1 = "#6554C0";
var $3360c9f5dc4c66ec$export$c71e4279dd54a18d = "#5243AA";
var $3360c9f5dc4c66ec$export$147899de772240ec = "#403294";
var $3360c9f5dc4c66ec$export$2cf711fe14c66f06 = "#E6FCFF";
var $3360c9f5dc4c66ec$export$7a8f4d33f6f9772c = "#B3F5FF";
var $3360c9f5dc4c66ec$export$776c9c497ef08533 = "#79E2F2";
var $3360c9f5dc4c66ec$export$69cb3ca10c1e330e = "#00C7E6";
var $3360c9f5dc4c66ec$export$9dc1ef0f3f48059b = "#00B8D9";
var $3360c9f5dc4c66ec$export$7c835c78b6fcdef8 = "#00A3BF";
var $3360c9f5dc4c66ec$export$6036577f95c3877e = "#008DA6";
var $3360c9f5dc4c66ec$export$29a4f05edc054374 = "#FFFFFF";
var $3360c9f5dc4c66ec$export$e655ef011c4aa1a2 = "#FAFBFC";
var $3360c9f5dc4c66ec$export$9fdfb749e33cdf97 = "#F4F5F7";
var $3360c9f5dc4c66ec$export$3e51e8f1440314ba = "#EBECF0";
var $3360c9f5dc4c66ec$export$1ce2d1575d444ceb = "#DFE1E6";
var $3360c9f5dc4c66ec$export$8754fc7e6d8b3000 = "#C1C7D0";
var $3360c9f5dc4c66ec$export$c2e91cbeada39b8b = "#B3BAC5";
var $3360c9f5dc4c66ec$export$5f71e19f3a7ad9de = "#A5ADBA";
var $3360c9f5dc4c66ec$export$eaa8c8a70ac22806 = "#97A0AF";
var $3360c9f5dc4c66ec$export$7c87d337fb91a97d = "#8993A4";
var $3360c9f5dc4c66ec$export$d6447c357493214f = "#7A869A";
var $3360c9f5dc4c66ec$export$f563ee71e9ee74cd = "#6B778C";
var $3360c9f5dc4c66ec$export$e2ef2124cf4024b1 = "#5E6C84";
var $3360c9f5dc4c66ec$export$eece5f492e429f08 = "#505F79";
var $3360c9f5dc4c66ec$export$c39c0fe0f26207ae = "#42526E";
var $3360c9f5dc4c66ec$export$7090862dc3038a9f = "#344563";
var $3360c9f5dc4c66ec$export$ad0bacf983b7ddaa = "#253858";
var $3360c9f5dc4c66ec$export$7d61b15e0da132af = "#172B4D";
var $3360c9f5dc4c66ec$export$fbda843f0a27fe96 = "#091E42";
var $3360c9f5dc4c66ec$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $3360c9f5dc4c66ec$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $3360c9f5dc4c66ec$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $3360c9f5dc4c66ec$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $3360c9f5dc4c66ec$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $3360c9f5dc4c66ec$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $3360c9f5dc4c66ec$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $3360c9f5dc4c66ec$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $3360c9f5dc4c66ec$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $3360c9f5dc4c66ec$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $3360c9f5dc4c66ec$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $3360c9f5dc4c66ec$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $3360c9f5dc4c66ec$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $3360c9f5dc4c66ec$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $3360c9f5dc4c66ec$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $3360c9f5dc4c66ec$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $3360c9f5dc4c66ec$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $3360c9f5dc4c66ec$export$2f6319cf7d736c2a = "#E6EDFA";
var $3360c9f5dc4c66ec$export$95126bc8884d6634 = "#DCE5F5";
var $3360c9f5dc4c66ec$export$8338d8c35d44ff1 = "#CED9EB";
var $3360c9f5dc4c66ec$export$5368d76ae4fbbda7 = "#B8C7E0";
var $3360c9f5dc4c66ec$export$9f0a771d16ec8d36 = "#ABBBD6";
var $3360c9f5dc4c66ec$export$abcf8c38338b4aa5 = "#9FB0CC";
var $3360c9f5dc4c66ec$export$97e81faa16a182c7 = "#8C9CB8";
var $3360c9f5dc4c66ec$export$bfe21c59123ecf33 = "#7988A3";
var $3360c9f5dc4c66ec$export$ee82aa2ea6a1558 = "#67758F";
var $3360c9f5dc4c66ec$export$682927c6ed76be02 = "#56637A";
var $3360c9f5dc4c66ec$export$91fd9994c5be9757 = "#455166";
var $3360c9f5dc4c66ec$export$d281fbfe3cff2df6 = "#3B475C";
var $3360c9f5dc4c66ec$export$3902c91d8b98a753 = "#313D52";
var $3360c9f5dc4c66ec$export$8e8133c1ba5845b5 = "#283447";
var $3360c9f5dc4c66ec$export$33ff357f6620b39 = "#202B3D";
var $3360c9f5dc4c66ec$export$633847cf062b69e0 = "#1B2638";
var $3360c9f5dc4c66ec$export$9776a6e503bdbf76 = "#121A29";
var $3360c9f5dc4c66ec$export$6c813d5160dff5db = "#0E1624";
var $3360c9f5dc4c66ec$export$3d4f271a500072a = "#0D1424";
var $3360c9f5dc4c66ec$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $3360c9f5dc4c66ec$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $3360c9f5dc4c66ec$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $3360c9f5dc4c66ec$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $3360c9f5dc4c66ec$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $3360c9f5dc4c66ec$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $3360c9f5dc4c66ec$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $3360c9f5dc4c66ec$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $3360c9f5dc4c66ec$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $3360c9f5dc4c66ec$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $3360c9f5dc4c66ec$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $3360c9f5dc4c66ec$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $3360c9f5dc4c66ec$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $3360c9f5dc4c66ec$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $3360c9f5dc4c66ec$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $3360c9f5dc4c66ec$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $3360c9f5dc4c66ec$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $3360c9f5dc4c66ec$export$d2adc5dedf09fced = "#292A2E";
var $3360c9f5dc4c66ec$export$f51762073d2bb381 = "#94C748";
var $3360c9f5dc4c66ec$export$95e26d54def96891 = "#B3DF72";


function $5e302c3b7a82c90a$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5e302c3b7a82c90a$var$tabKeyCode = 9;
function $5e302c3b7a82c90a$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5e302c3b7a82c90a$var$tabKeyCode) return;
    $5e302c3b7a82c90a$var$abort(event);
}
var $5e302c3b7a82c90a$var$block = {
    onMouseDownCapture: $5e302c3b7a82c90a$var$abort,
    onMouseUpCapture: $5e302c3b7a82c90a$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $5e302c3b7a82c90a$var$onKey,
    onKeyUpCapture: $5e302c3b7a82c90a$var$onKey,
    onTouchStartCapture: $5e302c3b7a82c90a$var$abort,
    onTouchEndCapture: $5e302c3b7a82c90a$var$abort,
    onPointerDownCapture: $5e302c3b7a82c90a$var$abort,
    onPointerUpCapture: $5e302c3b7a82c90a$var$abort,
    onClickCapture: $5e302c3b7a82c90a$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $5e302c3b7a82c90a$var$abort
};
var $5e302c3b7a82c90a$var$doNotBlock = {};
function $5e302c3b7a82c90a$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $5e302c3b7a82c90a$var$doNotBlock : $5e302c3b7a82c90a$var$block;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");

var $ltooA = parcelRequire("ltooA");
/* eslint-disable no-console */ var $f849ebb53c65f7cc$var$printed = {};
function $f849ebb53c65f7cc$export$2e2bcd8739ae039(message) {
    if ($f849ebb53c65f7cc$var$printed[message]) return;
    $f849ebb53c65f7cc$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $db7f5fb56eaf9aa1$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $f849ebb53c65f7cc$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $db7f5fb56eaf9aa1$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $49ec67b26854962f$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $49ec67b26854962f$export$c93026a968943f95 = "light";
var $49ec67b26854962f$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $49ec67b26854962f$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $49ec67b26854962f$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $49ec67b26854962f$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $3360c9f5dc4c66ec$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $49ec67b26854962f$export$6d8204c2cb2e06b8() / 4;
    (0, $db7f5fb56eaf9aa1$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $49ec67b26854962f$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $49ec67b26854962f$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $49ec67b26854962f$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $db7f5fb56eaf9aa1$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $49ec67b26854962f$export$ba1d834b86d72a09 = $49ec67b26854962f$export$a1b3edb637fb4f35;
var $49ec67b26854962f$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $3360c9f5dc4c66ec$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $3360c9f5dc4c66ec$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $3360c9f5dc4c66ec$export$920c0d5c49070351), ")")
            }
        }
    };
};



// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $233d68a3e8882097$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $233d68a3e8882097$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($3360c9f5dc4c66ec$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($3360c9f5dc4c66ec$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($3360c9f5dc4c66ec$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($3360c9f5dc4c66ec$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($233d68a3e8882097$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($3360c9f5dc4c66ec$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($3360c9f5dc4c66ec$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($3360c9f5dc4c66ec$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($3360c9f5dc4c66ec$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($3360c9f5dc4c66ec$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($3360c9f5dc4c66ec$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($3360c9f5dc4c66ec$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($3360c9f5dc4c66ec$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($3360c9f5dc4c66ec$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($3360c9f5dc4c66ec$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($3360c9f5dc4c66ec$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($3360c9f5dc4c66ec$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($3360c9f5dc4c66ec$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($3360c9f5dc4c66ec$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($3360c9f5dc4c66ec$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($3360c9f5dc4c66ec$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($3360c9f5dc4c66ec$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($3360c9f5dc4c66ec$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($3360c9f5dc4c66ec$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($3360c9f5dc4c66ec$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($3360c9f5dc4c66ec$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($3360c9f5dc4c66ec$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($233d68a3e8882097$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($3360c9f5dc4c66ec$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$3d4f271a500072a, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($3360c9f5dc4c66ec$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($3360c9f5dc4c66ec$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($3360c9f5dc4c66ec$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($3360c9f5dc4c66ec$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($3360c9f5dc4c66ec$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($3360c9f5dc4c66ec$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($3360c9f5dc4c66ec$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($3360c9f5dc4c66ec$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($3360c9f5dc4c66ec$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($3360c9f5dc4c66ec$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($3360c9f5dc4c66ec$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($3360c9f5dc4c66ec$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($3360c9f5dc4c66ec$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($3360c9f5dc4c66ec$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($3360c9f5dc4c66ec$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $233d68a3e8882097$export$2e2bcd8739ae039 = $233d68a3e8882097$var$values;


function $124693bd0740e550$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $124693bd0740e550$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $124693bd0740e550$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $124693bd0740e550$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $124693bd0740e550$var$gridSize = (0, $49ec67b26854962f$export$6d8204c2cb2e06b8)();
var $124693bd0740e550$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $124693bd0740e550$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $124693bd0740e550$var$lineHeights = {
    default: $124693bd0740e550$var$heights.default,
    compact: $124693bd0740e550$var$heights.compact,
    none: "inherit"
};
var $124693bd0740e550$var$padding = {
    // 10px gutter
    default: "0 ".concat($124693bd0740e550$var$gridSize + $124693bd0740e550$var$gridSize / 4, "px"),
    compact: "0 ".concat($124693bd0740e550$var$gridSize + $124693bd0740e550$var$gridSize / 4, "px"),
    none: "0"
};
var $124693bd0740e550$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px"),
    default: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px"),
    none: "0"
};
var $124693bd0740e550$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $124693bd0740e550$var$innerMargin = {
    content: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px"),
    icon: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px")
};
var $124693bd0740e550$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $124693bd0740e550$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $124693bd0740e550$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $124693bd0740e550$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $124693bd0740e550$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $124693bd0740e550$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $124693bd0740e550$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $124693bd0740e550$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $124693bd0740e550$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $124693bd0740e550$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $124693bd0740e550$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $124693bd0740e550$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $124693bd0740e550$var$getColor({
            group: (0, $233d68a3e8882097$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($124693bd0740e550$var$getColor({
            group: (0, $233d68a3e8882097$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $124693bd0740e550$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $124693bd0740e550$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $ltooA.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $124693bd0740e550$var$heights[spacing],
        lineHeight: $124693bd0740e550$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $124693bd0740e550$var$singleIconPadding[spacing] : $124693bd0740e550$var$padding[spacing],
        verticalAlign: $124693bd0740e550$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $ltooA.fg)("platform-component-visual-refresh") && $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $124693bd0740e550$var$_objectSpread({}, baseColors),
        "&:hover": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $124693bd0740e550$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $ltooA.fg)("platform-component-visual-refresh") && (isSelected ? $124693bd0740e550$var$selectedStyles : $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, appearance === "default" && $124693bd0740e550$var$defaultStyles), appearance === "primary" && $124693bd0740e550$var$primaryStyles), appearance === "link" && $124693bd0740e550$var$linkStyles), appearance === "subtle" && $124693bd0740e550$var$subtleStyles), appearance === "subtle-link" && $124693bd0740e550$var$subtleLinkStyles), appearance === "warning" && $124693bd0740e550$var$warningStyles), appearance === "danger" && $124693bd0740e550$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $124693bd0740e550$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $124693bd0740e550$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $124693bd0740e550$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $124693bd0740e550$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $124693bd0740e550$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jjlaj.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $124693bd0740e550$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $124693bd0740e550$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $124693bd0740e550$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $124693bd0740e550$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $124693bd0740e550$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $acw62 = parcelRequire("acw62");

var $c3573038e77d8f9e$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $acw62.isValidElement)(children) && children.type === (0, $8568069ac023c6f7$export$2e2bcd8739ae039);
};


var $d701453916ab4688$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d701453916ab4688$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $d701453916ab4688$var$iconBeforeSpacingFixStyle = (0, $jjlaj.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d701453916ab4688$var$iconAfterSpacingFixStyle = (0, $jjlaj.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d701453916ab4688$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $c3573038e77d8f9e$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $d701453916ab4688$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $c3573038e77d8f9e$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $jjlaj.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d701453916ab4688$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $d701453916ab4688$var$_excluded);
    var ourRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $c7fc49da903314f5$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $acw62.useContext)((0, $0c27aa7a20d367fb$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f2645c9c716c7cdf$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "20.5.3",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $jjlaj.css)((0, $124693bd0740e550$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $3360c9f5dc4c66ec$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $3360c9f5dc4c66ec$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $jjlaj.jsx)((0, $e9954464659b19b4$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d701453916ab4688$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $5e302c3b7a82c90a$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $124693bd0740e550$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $d701453916ab4688$var$getSpacingFix(children, $d701453916ab4688$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d701453916ab4688$var$getChildren(children, [
        fadeStyles,
        (0, $124693bd0740e550$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $124693bd0740e550$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $d701453916ab4688$var$getSpacingFix(children, $d701453916ab4688$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jjlaj.jsx)("span", {
        css: [
            (0, $124693bd0740e550$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d701453916ab4688$export$2e2bcd8739ae039 = $d701453916ab4688$var$ButtonBase;



function $37ca384b6aa4d0c1$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $c3573038e77d8f9e$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $97d7a407d1f58bcb$var$ATOMIC_GROUP_LENGTH = 5;
function $97d7a407d1f58bcb$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $97d7a407d1f58bcb$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $acw62 = parcelRequire("acw62");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $2cc8599b45970337$export$4b84fd0e2c617bd = "#FFEBE6";
var $2cc8599b45970337$export$b34b069eff244586 = "#FFBDAD";
var $2cc8599b45970337$export$be802dd0d8b57f35 = "#FF8F73";
var $2cc8599b45970337$export$60847d42f9da92a6 = "#FF7452";
var $2cc8599b45970337$export$4a7404f376229999 = "#FF5630";
var $2cc8599b45970337$export$2010d0fb4295b346 = "#DE350B";
var $2cc8599b45970337$export$2837b5a1a71d5c02 = "#BF2600";
var $2cc8599b45970337$export$8d9596b529bbb9cf = "#FFFAE6";
var $2cc8599b45970337$export$41060a744ab0b7ae = "#FFF0B3";
var $2cc8599b45970337$export$1cc05bbbf340e559 = "#FFE380";
var $2cc8599b45970337$export$5aae31392d72caaa = "#FFC400";
var $2cc8599b45970337$export$c6930421db9fa514 = "#FFAB00";
var $2cc8599b45970337$export$59619663aa6500fb = "#FF991F";
var $2cc8599b45970337$export$874739ea9e379ab6 = "#FF8B00";
var $2cc8599b45970337$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $2cc8599b45970337$export$69a3bf21b9686c2b = "#ABF5D1";
var $2cc8599b45970337$export$afbce1382ec95f73 = "#79F2C0";
var $2cc8599b45970337$export$747d86715d4175de = "#57D9A3";
var $2cc8599b45970337$export$940e1f69e873f202 = "#36B37E";
var $2cc8599b45970337$export$a49394138f7b8e85 = "#00875A";
var $2cc8599b45970337$export$6fa04827ac68a4fb = "#006644";
var $2cc8599b45970337$export$226de0355ed012f8 = "#DEEBFF";
var $2cc8599b45970337$export$8c13c2ee36917869 = "#B3D4FF";
var $2cc8599b45970337$export$ecfc1dff386a3e7a = "#4C9AFF";
var $2cc8599b45970337$export$215b7063051591f1 = "#2684FF";
var $2cc8599b45970337$export$e62e8919cca44969 = "#0065FF";
var $2cc8599b45970337$export$b3de0ae08da2ce64 = "#0052CC";
var $2cc8599b45970337$export$a6ee3d71bc067634 = "#0747A6";
var $2cc8599b45970337$export$67f15409e87642a1 = "#669DF1";
var $2cc8599b45970337$export$f0539dbc42dbb067 = "#8FB8F6";
var $2cc8599b45970337$export$363e4475840015bb = "#EAE6FF";
var $2cc8599b45970337$export$4b0a4417ed59760f = "#C0B6F2";
var $2cc8599b45970337$export$6011520a64d9a187 = "#998DD9";
var $2cc8599b45970337$export$a7175d4e9206bc80 = "#8777D9";
var $2cc8599b45970337$export$b48405b95304b5a1 = "#6554C0";
var $2cc8599b45970337$export$c71e4279dd54a18d = "#5243AA";
var $2cc8599b45970337$export$147899de772240ec = "#403294";
var $2cc8599b45970337$export$2cf711fe14c66f06 = "#E6FCFF";
var $2cc8599b45970337$export$7a8f4d33f6f9772c = "#B3F5FF";
var $2cc8599b45970337$export$776c9c497ef08533 = "#79E2F2";
var $2cc8599b45970337$export$69cb3ca10c1e330e = "#00C7E6";
var $2cc8599b45970337$export$9dc1ef0f3f48059b = "#00B8D9";
var $2cc8599b45970337$export$7c835c78b6fcdef8 = "#00A3BF";
var $2cc8599b45970337$export$6036577f95c3877e = "#008DA6";
var $2cc8599b45970337$export$29a4f05edc054374 = "#FFFFFF";
var $2cc8599b45970337$export$e655ef011c4aa1a2 = "#FAFBFC";
var $2cc8599b45970337$export$9fdfb749e33cdf97 = "#F4F5F7";
var $2cc8599b45970337$export$3e51e8f1440314ba = "#EBECF0";
var $2cc8599b45970337$export$1ce2d1575d444ceb = "#DFE1E6";
var $2cc8599b45970337$export$8754fc7e6d8b3000 = "#C1C7D0";
var $2cc8599b45970337$export$c2e91cbeada39b8b = "#B3BAC5";
var $2cc8599b45970337$export$5f71e19f3a7ad9de = "#A5ADBA";
var $2cc8599b45970337$export$eaa8c8a70ac22806 = "#97A0AF";
var $2cc8599b45970337$export$7c87d337fb91a97d = "#8993A4";
var $2cc8599b45970337$export$d6447c357493214f = "#7A869A";
var $2cc8599b45970337$export$f563ee71e9ee74cd = "#6B778C";
var $2cc8599b45970337$export$e2ef2124cf4024b1 = "#5E6C84";
var $2cc8599b45970337$export$eece5f492e429f08 = "#505F79";
var $2cc8599b45970337$export$c39c0fe0f26207ae = "#42526E";
var $2cc8599b45970337$export$7090862dc3038a9f = "#344563";
var $2cc8599b45970337$export$ad0bacf983b7ddaa = "#253858";
var $2cc8599b45970337$export$7d61b15e0da132af = "#172B4D";
var $2cc8599b45970337$export$fbda843f0a27fe96 = "#091E42";
var $2cc8599b45970337$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $2cc8599b45970337$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $2cc8599b45970337$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $2cc8599b45970337$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $2cc8599b45970337$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $2cc8599b45970337$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $2cc8599b45970337$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $2cc8599b45970337$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $2cc8599b45970337$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $2cc8599b45970337$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $2cc8599b45970337$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $2cc8599b45970337$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $2cc8599b45970337$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $2cc8599b45970337$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $2cc8599b45970337$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $2cc8599b45970337$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $2cc8599b45970337$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $2cc8599b45970337$export$2f6319cf7d736c2a = "#E6EDFA";
var $2cc8599b45970337$export$95126bc8884d6634 = "#DCE5F5";
var $2cc8599b45970337$export$8338d8c35d44ff1 = "#CED9EB";
var $2cc8599b45970337$export$5368d76ae4fbbda7 = "#B8C7E0";
var $2cc8599b45970337$export$9f0a771d16ec8d36 = "#ABBBD6";
var $2cc8599b45970337$export$abcf8c38338b4aa5 = "#9FB0CC";
var $2cc8599b45970337$export$97e81faa16a182c7 = "#8C9CB8";
var $2cc8599b45970337$export$bfe21c59123ecf33 = "#7988A3";
var $2cc8599b45970337$export$ee82aa2ea6a1558 = "#67758F";
var $2cc8599b45970337$export$682927c6ed76be02 = "#56637A";
var $2cc8599b45970337$export$91fd9994c5be9757 = "#455166";
var $2cc8599b45970337$export$d281fbfe3cff2df6 = "#3B475C";
var $2cc8599b45970337$export$3902c91d8b98a753 = "#313D52";
var $2cc8599b45970337$export$8e8133c1ba5845b5 = "#283447";
var $2cc8599b45970337$export$33ff357f6620b39 = "#202B3D";
var $2cc8599b45970337$export$633847cf062b69e0 = "#1B2638";
var $2cc8599b45970337$export$9776a6e503bdbf76 = "#121A29";
var $2cc8599b45970337$export$6c813d5160dff5db = "#0E1624";
var $2cc8599b45970337$export$3d4f271a500072a = "#0D1424";
var $2cc8599b45970337$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $2cc8599b45970337$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $2cc8599b45970337$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $2cc8599b45970337$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $2cc8599b45970337$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $2cc8599b45970337$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $2cc8599b45970337$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $2cc8599b45970337$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $2cc8599b45970337$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $2cc8599b45970337$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $2cc8599b45970337$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $2cc8599b45970337$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $2cc8599b45970337$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $2cc8599b45970337$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $2cc8599b45970337$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $2cc8599b45970337$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $2cc8599b45970337$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $2cc8599b45970337$export$d2adc5dedf09fced = "#292A2E";
var $2cc8599b45970337$export$f51762073d2bb381 = "#94C748";
var $2cc8599b45970337$export$95e26d54def96891 = "#B3DF72";


var $8990a010dc56dc45$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $eae3a537d5762af5$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $2cc8599b45970337$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $2cc8599b45970337$export$29a4f05edc054374), ")");
}
var $eae3a537d5762af5$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $eae3a537d5762af5$var$loadIn = null;
var $eae3a537d5762af5$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $eae3a537d5762af5$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $eae3a537d5762af5$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $8990a010dc56dc45$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $eae3a537d5762af5$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $0c27aa7a20d367fb$export$2e2bcd8739ae039));
    $eae3a537d5762af5$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $97d7a407d1f58bcb$export$2e2bcd8739ae039)([
            $eae3a537d5762af5$var$styles.wrapperStyles,
            $eae3a537d5762af5$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $97d7a407d1f58bcb$export$2e2bcd8739ae039)([
            $eae3a537d5762af5$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $97d7a407d1f58bcb$export$2e2bcd8739ae039)([
            $eae3a537d5762af5$var$styles.circleStyles
        ])
    })));
}));
var $eae3a537d5762af5$export$2e2bcd8739ae039 = $eae3a537d5762af5$var$Spinner;


function $fa4f28c9a3efa92e$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $fa4f28c9a3efa92e$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eae3a537d5762af5$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $fa4f28c9a3efa92e$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}



var $g5Zhu = parcelRequire("g5Zhu");


function $7b0d721e607ac8a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b0d721e607ac8a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b0d721e607ac8a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b0d721e607ac8a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b0d721e607ac8a2$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $7b0d721e607ac8a2$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $124693bd0740e550$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $7b0d721e607ac8a2$var$stateToSelectorMap[state];
    if (selector) result = $7b0d721e607ac8a2$var$_objectSpread($7b0d721e607ac8a2$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $7b0d721e607ac8a2$var$_objectSpread($7b0d721e607ac8a2$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $7b0d721e607ac8a2$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $7b0d721e607ac8a2$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $7b0d721e607ac8a2$var$Theme = (0, $1302912422da4370$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $7b0d721e607ac8a2$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7b0d721e607ac8a2$export$2e2bcd8739ae039 = $7b0d721e607ac8a2$var$Theme;


var $0ac08233ee80a5c4$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $0ac08233ee80a5c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ac08233ee80a5c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ac08233ee80a5c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ac08233ee80a5c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ac08233ee80a5c4$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $0ac08233ee80a5c4$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $0ac08233ee80a5c4$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $7b0d721e607ac8a2$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $0ac08233ee80a5c4$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $0ac08233ee80a5c4$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $acw62.useState)($0ac08233ee80a5c4$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b0d721e607ac8a2$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fdb39e5d87c0db59$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b0d721e607ac8a2$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            mode: mode,
            state: $0ac08233ee80a5c4$var$getInteractionState($0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $37ca384b6aa4d0c1$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d701453916ab4688$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fa4f28c9a3efa92e$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $7b0d721e607ac8a2$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$0ac08233ee80a5c4$var$CustomThemeButton.displayName = "CustomThemeButton";
var $0ac08233ee80a5c4$export$2e2bcd8739ae039 = $0ac08233ee80a5c4$var$CustomThemeButton;




/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $16136f4ac150d4da$export$4b84fd0e2c617bd = "#FFEBE6";
var $16136f4ac150d4da$export$b34b069eff244586 = "#FFBDAD";
var $16136f4ac150d4da$export$be802dd0d8b57f35 = "#FF8F73";
var $16136f4ac150d4da$export$60847d42f9da92a6 = "#FF7452";
var $16136f4ac150d4da$export$4a7404f376229999 = "#FF5630";
var $16136f4ac150d4da$export$2010d0fb4295b346 = "#DE350B";
var $16136f4ac150d4da$export$2837b5a1a71d5c02 = "#BF2600";
var $16136f4ac150d4da$export$8d9596b529bbb9cf = "#FFFAE6";
var $16136f4ac150d4da$export$41060a744ab0b7ae = "#FFF0B3";
var $16136f4ac150d4da$export$1cc05bbbf340e559 = "#FFE380";
var $16136f4ac150d4da$export$5aae31392d72caaa = "#FFC400";
var $16136f4ac150d4da$export$c6930421db9fa514 = "#FFAB00";
var $16136f4ac150d4da$export$59619663aa6500fb = "#FF991F";
var $16136f4ac150d4da$export$874739ea9e379ab6 = "#FF8B00";
var $16136f4ac150d4da$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $16136f4ac150d4da$export$69a3bf21b9686c2b = "#ABF5D1";
var $16136f4ac150d4da$export$afbce1382ec95f73 = "#79F2C0";
var $16136f4ac150d4da$export$747d86715d4175de = "#57D9A3";
var $16136f4ac150d4da$export$940e1f69e873f202 = "#36B37E";
var $16136f4ac150d4da$export$a49394138f7b8e85 = "#00875A";
var $16136f4ac150d4da$export$6fa04827ac68a4fb = "#006644";
var $16136f4ac150d4da$export$226de0355ed012f8 = "#DEEBFF";
var $16136f4ac150d4da$export$8c13c2ee36917869 = "#B3D4FF";
var $16136f4ac150d4da$export$ecfc1dff386a3e7a = "#4C9AFF";
var $16136f4ac150d4da$export$215b7063051591f1 = "#2684FF";
var $16136f4ac150d4da$export$e62e8919cca44969 = "#0065FF";
var $16136f4ac150d4da$export$b3de0ae08da2ce64 = "#0052CC";
var $16136f4ac150d4da$export$a6ee3d71bc067634 = "#0747A6";
var $16136f4ac150d4da$export$67f15409e87642a1 = "#669DF1";
var $16136f4ac150d4da$export$f0539dbc42dbb067 = "#8FB8F6";
var $16136f4ac150d4da$export$363e4475840015bb = "#EAE6FF";
var $16136f4ac150d4da$export$4b0a4417ed59760f = "#C0B6F2";
var $16136f4ac150d4da$export$6011520a64d9a187 = "#998DD9";
var $16136f4ac150d4da$export$a7175d4e9206bc80 = "#8777D9";
var $16136f4ac150d4da$export$b48405b95304b5a1 = "#6554C0";
var $16136f4ac150d4da$export$c71e4279dd54a18d = "#5243AA";
var $16136f4ac150d4da$export$147899de772240ec = "#403294";
var $16136f4ac150d4da$export$2cf711fe14c66f06 = "#E6FCFF";
var $16136f4ac150d4da$export$7a8f4d33f6f9772c = "#B3F5FF";
var $16136f4ac150d4da$export$776c9c497ef08533 = "#79E2F2";
var $16136f4ac150d4da$export$69cb3ca10c1e330e = "#00C7E6";
var $16136f4ac150d4da$export$9dc1ef0f3f48059b = "#00B8D9";
var $16136f4ac150d4da$export$7c835c78b6fcdef8 = "#00A3BF";
var $16136f4ac150d4da$export$6036577f95c3877e = "#008DA6";
var $16136f4ac150d4da$export$29a4f05edc054374 = "#FFFFFF";
var $16136f4ac150d4da$export$e655ef011c4aa1a2 = "#FAFBFC";
var $16136f4ac150d4da$export$9fdfb749e33cdf97 = "#F4F5F7";
var $16136f4ac150d4da$export$3e51e8f1440314ba = "#EBECF0";
var $16136f4ac150d4da$export$1ce2d1575d444ceb = "#DFE1E6";
var $16136f4ac150d4da$export$8754fc7e6d8b3000 = "#C1C7D0";
var $16136f4ac150d4da$export$c2e91cbeada39b8b = "#B3BAC5";
var $16136f4ac150d4da$export$5f71e19f3a7ad9de = "#A5ADBA";
var $16136f4ac150d4da$export$eaa8c8a70ac22806 = "#97A0AF";
var $16136f4ac150d4da$export$7c87d337fb91a97d = "#8993A4";
var $16136f4ac150d4da$export$d6447c357493214f = "#7A869A";
var $16136f4ac150d4da$export$f563ee71e9ee74cd = "#6B778C";
var $16136f4ac150d4da$export$e2ef2124cf4024b1 = "#5E6C84";
var $16136f4ac150d4da$export$eece5f492e429f08 = "#505F79";
var $16136f4ac150d4da$export$c39c0fe0f26207ae = "#42526E";
var $16136f4ac150d4da$export$7090862dc3038a9f = "#344563";
var $16136f4ac150d4da$export$ad0bacf983b7ddaa = "#253858";
var $16136f4ac150d4da$export$7d61b15e0da132af = "#172B4D";
var $16136f4ac150d4da$export$fbda843f0a27fe96 = "#091E42";
var $16136f4ac150d4da$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $16136f4ac150d4da$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $16136f4ac150d4da$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $16136f4ac150d4da$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $16136f4ac150d4da$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $16136f4ac150d4da$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $16136f4ac150d4da$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $16136f4ac150d4da$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $16136f4ac150d4da$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $16136f4ac150d4da$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $16136f4ac150d4da$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $16136f4ac150d4da$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $16136f4ac150d4da$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $16136f4ac150d4da$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $16136f4ac150d4da$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $16136f4ac150d4da$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $16136f4ac150d4da$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $16136f4ac150d4da$export$2f6319cf7d736c2a = "#E6EDFA";
var $16136f4ac150d4da$export$95126bc8884d6634 = "#DCE5F5";
var $16136f4ac150d4da$export$8338d8c35d44ff1 = "#CED9EB";
var $16136f4ac150d4da$export$5368d76ae4fbbda7 = "#B8C7E0";
var $16136f4ac150d4da$export$9f0a771d16ec8d36 = "#ABBBD6";
var $16136f4ac150d4da$export$abcf8c38338b4aa5 = "#9FB0CC";
var $16136f4ac150d4da$export$97e81faa16a182c7 = "#8C9CB8";
var $16136f4ac150d4da$export$bfe21c59123ecf33 = "#7988A3";
var $16136f4ac150d4da$export$ee82aa2ea6a1558 = "#67758F";
var $16136f4ac150d4da$export$682927c6ed76be02 = "#56637A";
var $16136f4ac150d4da$export$91fd9994c5be9757 = "#455166";
var $16136f4ac150d4da$export$d281fbfe3cff2df6 = "#3B475C";
var $16136f4ac150d4da$export$3902c91d8b98a753 = "#313D52";
var $16136f4ac150d4da$export$8e8133c1ba5845b5 = "#283447";
var $16136f4ac150d4da$export$33ff357f6620b39 = "#202B3D";
var $16136f4ac150d4da$export$633847cf062b69e0 = "#1B2638";
var $16136f4ac150d4da$export$9776a6e503bdbf76 = "#121A29";
var $16136f4ac150d4da$export$6c813d5160dff5db = "#0E1624";
var $16136f4ac150d4da$export$3d4f271a500072a = "#0D1424";
var $16136f4ac150d4da$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $16136f4ac150d4da$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $16136f4ac150d4da$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $16136f4ac150d4da$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $16136f4ac150d4da$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $16136f4ac150d4da$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $16136f4ac150d4da$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $16136f4ac150d4da$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $16136f4ac150d4da$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $16136f4ac150d4da$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $16136f4ac150d4da$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $16136f4ac150d4da$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $16136f4ac150d4da$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $16136f4ac150d4da$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $16136f4ac150d4da$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $16136f4ac150d4da$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $16136f4ac150d4da$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $16136f4ac150d4da$export$d2adc5dedf09fced = "#292A2E";
var $16136f4ac150d4da$export$f51762073d2bb381 = "#94C748";
var $16136f4ac150d4da$export$95e26d54def96891 = "#B3DF72";


var $82786787318b191b$export$59e42969c95d314 = {
    error: "color.background.danger.bold",
    info: "color.background.neutral.bold",
    normal: "elevation.surface.overlay",
    success: "color.background.success.bold",
    warning: "color.background.warning.bold"
};
var $82786787318b191b$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    info: "var(--ds-icon-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    normal: "var(--ds-icon-subtle, ".concat((0, $16136f4ac150d4da$export$c39c0fe0f26207ae), ")"),
    success: "var(--ds-icon-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    warning: "var(--ds-icon-warning-inverse, ".concat((0, $16136f4ac150d4da$export$ad0bacf983b7ddaa), ")")
};
var $82786787318b191b$export$f50075b2584087f = {
    error: "color.text.inverse",
    info: "color.text.inverse",
    normal: "color.text",
    success: "color.text.inverse",
    warning: "color.text.warning.inverse"
};
var $82786787318b191b$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    normal: "var(--ds-text, ".concat((0, $16136f4ac150d4da$export$7d61b15e0da132af), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $16136f4ac150d4da$export$ad0bacf983b7ddaa), ")")
};
var $82786787318b191b$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")")
    },
    normal: {
        default: "none",
        active: "none",
        pressed: "none"
    }
};
var $82786787318b191b$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $16136f4ac150d4da$export$29a4f05edc054374), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $16136f4ac150d4da$export$ad0bacf983b7ddaa), ")"),
    normal: "var(--ds-link, ".concat((0, $16136f4ac150d4da$export$b3de0ae08da2ce64), ")")
};


var $346810cc4b2b017b$var$buttonStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: "0 ".concat("var(--ds-space-100, 8px)", " !important"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: "var(".concat((0, $a8cf11ad922cb067$export$e9244ec13bd422b5), ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: "var(".concat((0, $a8cf11ad922cb067$export$4f8f13a66ae77bdd), ") !important"),
        fontWeight: "var(--ds-font-weight-medium, 500)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:hover, &&:active, a&&:hover, a&&:active": {
        textDecoration: "underline"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $a8cf11ad922cb067$export$97e78d9745006c11), ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $a8cf11ad922cb067$export$291d63757828f290), ")")
    }
});
var $346810cc4b2b017b$var$appearanceNormalButtonStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: "0 !important"
    }
});
var $346810cc4b2b017b$var$appearanceNormalActionsContainerStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        transform: "translateX(-2px)"
    }
});
var $346810cc4b2b017b$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $a8cf11ad922cb067$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $a8cf11ad922cb067$export$d6830277b06edd6);
    return (0, $jjlaj.jsx)("span", {
        css: !isBold && $346810cc4b2b017b$var$appearanceNormalActionsContainerStyles
    }, (0, $jjlaj.jsx)((0, $1f12c6db18b953b0$export$2e2bcd8739ae039), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        var _ref;
        return (0, $jjlaj.jsx)((0, $0ac08233ee80a5c4$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? "default" : "link",
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref, (0, $a8cf11ad922cb067$export$4f8f13a66ae77bdd), (0, $82786787318b191b$export$7bcfe3cca4dd78b6)[appearance]), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref, (0, $a8cf11ad922cb067$export$e9244ec13bd422b5), (0, $82786787318b191b$export$81ba6b63eedb299f)[appearance].default), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref, (0, $a8cf11ad922cb067$export$97e78d9745006c11), (0, $82786787318b191b$export$81ba6b63eedb299f)[appearance].pressed), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref, (0, $a8cf11ad922cb067$export$291d63757828f290), (0, $82786787318b191b$export$81ba6b63eedb299f)[appearance].active), _ref),
            css: [
                $346810cc4b2b017b$var$buttonStyles,
                appearance === (0, $a8cf11ad922cb067$export$d6830277b06edd6) && $346810cc4b2b017b$var$appearanceNormalButtonStyles
            ]
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$346810cc4b2b017b$export$2e2bcd8739ae039 = $346810cc4b2b017b$var$FlagActions;



var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");



var $20529c9476e6df43$export$97192c8fa0d5e26b = function slideInAnimation(from, state, fade) {
    var initial = state === "entering" ? "0%" : "100%";
    var end = state === "entering" ? "100%" : "0%";
    var fromMap = {
        top: "translate3d(0, -100%, 0)",
        right: "translate3d(100%, 0, 0)",
        bottom: "translate3d(0, 100%, 0)",
        left: "translate3d(-100%, 0, 0)"
    };
    var animateOpacity = fade === "inout" || fade === "in" && state === "entering" || fade === "out" && state === "exiting";
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, initial, {
        transform: fromMap[from],
        opacity: animateOpacity ? 0 : 1
    }), end, {
        transform: "none",
        opacity: 1
    });
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $20529c9476e6df43$var$SlideIn = function SlideIn(_ref2) {
    var children = _ref2.children, enterFrom = _ref2.enterFrom, exitTo = _ref2.exitTo, _ref2$fade = _ref2.fade, fade = _ref2$fade === void 0 ? "none" : _ref2$fade, _ref2$duration = _ref2.duration, duration = _ref2$duration === void 0 ? (0, $d145bd79772829f1$export$6fa259be09e118a7) : _ref2$duration, isPaused = _ref2.isPaused, onFinish = _ref2.onFinish, _ref2$animationTiming = _ref2.animationTimingFunction, animationTimingFunction = _ref2$animationTiming === void 0 ? function(state) {
        return state === "entering" ? (0, $e9ca40ca2325ac8e$export$57636bb43b1ccbb0) : (0, $e9ca40ca2325ac8e$export$929e5a82286172a6);
    } : _ref2$animationTiming;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $290b44577c627b97$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $20529c9476e6df43$export$97192c8fa0d5e26b(enterFrom, "entering", fade),
        exitingAnimation: $20529c9476e6df43$export$97192c8fa0d5e26b(exitTo || enterFrom, "exiting", fade),
        animationTimingFunction: animationTimingFunction,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $20529c9476e6df43$export$2e2bcd8739ae039 = $20529c9476e6df43$var$SlideIn;







var $be469768ab19a67e$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $be469768ab19a67e$export$c93026a968943f95 = "light";
var $be469768ab19a67e$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $be469768ab19a67e$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $be469768ab19a67e$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $be469768ab19a67e$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $be469768ab19a67e$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $be469768ab19a67e$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $be469768ab19a67e$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $be469768ab19a67e$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $16136f4ac150d4da$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $be469768ab19a67e$export$6d8204c2cb2e06b8() / 4;
    (0, $db7f5fb56eaf9aa1$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $be469768ab19a67e$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $be469768ab19a67e$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $be469768ab19a67e$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $db7f5fb56eaf9aa1$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $be469768ab19a67e$export$ba1d834b86d72a09 = $be469768ab19a67e$export$a1b3edb637fb4f35;
var $be469768ab19a67e$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $16136f4ac150d4da$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $16136f4ac150d4da$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $16136f4ac150d4da$export$920c0d5c49070351), ")")
            }
        }
    };
};


var $38132a618d93e205$var$gridSize = (0, $be469768ab19a67e$export$6d8204c2cb2e06b8)();
var $38132a618d93e205$export$1eee5ddc4f6d41c5 = $38132a618d93e205$var$gridSize * 50;
var $38132a618d93e205$export$a56455a41666bb2a = 400;
var $38132a618d93e205$var$defaultFlagGroupContext = {
    onDismissed: (0, $45f4b35fa627590b$export$2e2bcd8739ae039),
    isDismissAllowed: false
};
var $38132a618d93e205$export$c57ba665aaa722be = /*#__PURE__*/ (0, $acw62.createContext)($38132a618d93e205$var$defaultFlagGroupContext);
function $38132a618d93e205$export$e91ea202abb66350() {
    return (0, $acw62.useContext)($38132a618d93e205$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $38132a618d93e205$var$baseStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $38132a618d93e205$export$1eee5ddc4f6d41c5,
    position: "absolute",
    insetBlockEnd: 0,
    transition: "transform ".concat($38132a618d93e205$export$a56455a41666bb2a, "ms ease-in-out"),
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        width: "100vw"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":first-of-type": {
        transform: "translate(0,0)",
        transition: "none"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(n + 2)": {
        animationDuration: "0ms",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: "translateX(0) translateY(100%) translateY(".concat(2 * $38132a618d93e205$var$gridSize, "px)")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(1)": {
        zIndex: 5
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(2)": {
        zIndex: 4
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:nth-of-type(n + 4)": {
        visibility: "hidden"
    }
});
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $38132a618d93e205$var$dismissAllowedStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&& + *": {
        transform: "translate(0, 0)",
        transitionDuration: "".concat($38132a618d93e205$export$a56455a41666bb2a / 2, "ms")
    }
});
var $38132a618d93e205$var$flagGroupContainerStyles = (0, $jjlaj.css)({
    position: "fixed",
    zIndex: "flag",
    insetBlockEnd: "var(--ds-space-600, 48px)",
    insetInlineStart: "var(--ds-space-1000, 80px)",
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        insetBlockEnd: 0,
        insetInlineStart: 0
    }
});
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $38132a618d93e205$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $acw62.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(children) === "object" ? (0, $acw62.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $jjlaj.jsx)((0, $20529c9476e6df43$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: $38132a618d93e205$export$a56455a41666bb2a,
                animationTimingFunction: function animationTimingFunction() {
                    return 0, $e9ca40ca2325ac8e$export$929e5a82286172a6;
                }
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return (0, $jjlaj.jsx)("div", {
                    css: [
                        $38132a618d93e205$var$baseStyles,
                        isDismissAllowed && $38132a618d93e205$var$dismissAllowedStyles
                    ],
                    className: className,
                    ref: ref
                }, (0, $jjlaj.jsx)($38132a618d93e205$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $38132a618d93e205$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = (0, $jjlaj.jsx)("div", {
        id: id,
        css: $38132a618d93e205$var$flagGroupContainerStyles
    }, hasFlags ? (0, $jjlaj.jsx)((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)(LabelTag, null, label)) : null, (0, $jjlaj.jsx)((0, $183a833228617892$export$2e2bcd8739ae039), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : (0, $jjlaj.jsx)((0, $2167cf9ee39b2459$export$2e2bcd8739ae039), {
        zIndex: (0, $be469768ab19a67e$export$7be255094ccdc533).flag()
    }, flags);
};
var $38132a618d93e205$export$2e2bcd8739ae039 = $38132a618d93e205$var$FlagGroup;



var $acw62 = parcelRequire("acw62");
var $d09ac97c4d5c96c6$exports = {};
"use strict";
Object.defineProperty($d09ac97c4d5c96c6$exports, "__esModule", {
    value: true
});
$d09ac97c4d5c96c6$exports.default = void 0;

var $d09ac97c4d5c96c6$var$_react = $d09ac97c4d5c96c6$var$_interopRequireDefault((parcelRequire("acw62")));

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $7rZ3m = parcelRequire("7rZ3m");

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $bd01ec5af3136cb1$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $bd01ec5af3136cb1$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $bd01ec5af3136cb1$export$62ad7b0c781000e9 = {
    small: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.small,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.medium,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.large,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.xlarge,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.xlarge
    }
};



var $jjlaj = parcelRequire("jjlaj");
var $a3294a82b6521b72$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$smallStyles = (0, $jjlaj.css)((0, $bd01ec5af3136cb1$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$mediumStyles = (0, $jjlaj.css)((0, $bd01ec5af3136cb1$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$largeStyles = (0, $jjlaj.css)((0, $bd01ec5af3136cb1$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$xlargeStyles = (0, $jjlaj.css)((0, $bd01ec5af3136cb1$export$62ad7b0c781000e9).xlarge);
var $a3294a82b6521b72$export$ef0ad74202575b64 = {
    small: $a3294a82b6521b72$var$smallStyles,
    medium: $a3294a82b6521b72$var$mediumStyles,
    large: $a3294a82b6521b72$var$largeStyles,
    xlarge: $a3294a82b6521b72$var$xlargeStyles
};
var $a3294a82b6521b72$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $bd01ec5af3136cb1$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $dacce6ae6934d567$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $5beb262371f1cc5e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5beb262371f1cc5e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5beb262371f1cc5e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5beb262371f1cc5e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $5beb262371f1cc5e$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $5beb262371f1cc5e$var$_objectSpread($5beb262371f1cc5e$var$_objectSpread({}, (0, $a3294a82b6521b72$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $5beb262371f1cc5e$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $5beb262371f1cc5e$var$primaryEqualsSecondaryHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $5beb262371f1cc5e$var$secondaryTransparentHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $5beb262371f1cc5e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jjlaj.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $a3294a82b6521b72$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jjlaj.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $dacce6ae6934d567$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $5beb262371f1cc5e$var$iconStyles,
            $5beb262371f1cc5e$var$baseHcmStyles,
            primaryColor === secondaryColor && $5beb262371f1cc5e$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $5beb262371f1cc5e$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jjlaj.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $5beb262371f1cc5e$export$2e2bcd8739ae039 = $5beb262371f1cc5e$export$f04a61298a47a40f;


var $3bd332d0d860848f$var$_excluded = [
    "dangerouslySetGlyph"
];
var $3bd332d0d860848f$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $3bd332d0d860848f$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3bd332d0d860848f$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $7rZ3m.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $7rZ3m.fg)("platform-visual-refresh-icons-facade-button-fix") ? $3bd332d0d860848f$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $3bd332d0d860848f$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5beb262371f1cc5e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $3bd332d0d860848f$export$2e2bcd8739ae039 = $3bd332d0d860848f$export$3cfb73f70dfca966;



var $d09ac97c4d5c96c6$var$_chevronDown = $d09ac97c4d5c96c6$var$_interopRequireDefault((parcelRequire("sg1HA")));
function $d09ac97c4d5c96c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d09ac97c4d5c96c6$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $d09ac97c4d5c96c6$var$_react.default.createElement($3bd332d0d860848f$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $d09ac97c4d5c96c6$var$_chevronDown.default,
        iconType: "utility"
    }));
$d09ac97c4d5c96c6$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $d09ac97c4d5c96c6$var$_default = $d09ac97c4d5c96c6$exports.default = $d09ac97c4d5c96c6$var$HipchatChevronDownIcon;


var $d4ed22ceb5c8d966$exports = {};
"use strict";
Object.defineProperty($d4ed22ceb5c8d966$exports, "__esModule", {
    value: true
});
$d4ed22ceb5c8d966$exports.default = void 0;

var $d4ed22ceb5c8d966$var$_react = $d4ed22ceb5c8d966$var$_interopRequireDefault((parcelRequire("acw62")));


var $d4ed22ceb5c8d966$var$_chevronUp = $d4ed22ceb5c8d966$var$_interopRequireDefault((parcelRequire("fqvUX")));
function $d4ed22ceb5c8d966$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d4ed22ceb5c8d966$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $d4ed22ceb5c8d966$var$_react.default.createElement($3bd332d0d860848f$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $d4ed22ceb5c8d966$var$_chevronUp.default,
        iconType: "utility"
    }));
$d4ed22ceb5c8d966$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $d4ed22ceb5c8d966$var$_default = $d4ed22ceb5c8d966$exports.default = $d4ed22ceb5c8d966$var$HipchatChevronUpIcon;


var $856f7aedef48a228$exports = {};
"use strict";
Object.defineProperty($856f7aedef48a228$exports, "__esModule", {
    value: true
});
$856f7aedef48a228$exports.default = void 0;

var $856f7aedef48a228$var$_react = $856f7aedef48a228$var$_interopRequireDefault((parcelRequire("acw62")));


var $856f7aedef48a228$var$_close = $856f7aedef48a228$var$_interopRequireDefault((parcelRequire("eVxRg")));
function $856f7aedef48a228$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $856f7aedef48a228$var$CrossIcon = (props)=>/*#__PURE__*/ $856f7aedef48a228$var$_react.default.createElement($3bd332d0d860848f$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $856f7aedef48a228$var$_close.default
    }));
$856f7aedef48a228$var$CrossIcon.displayName = "CrossIcon";
var $856f7aedef48a228$var$_default = $856f7aedef48a228$exports.default = $856f7aedef48a228$var$CrossIcon;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");





var $2f20f1fba022f462$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $2f20f1fba022f462$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $2f20f1fba022f462$var$focusRingStyles = (0, $jjlaj.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $b33f29a531e0ea11$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $b33f29a531e0ea11$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $b33f29a531e0ea11$export$e1b83c5210c471b8)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $2f20f1fba022f462$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $2f20f1fba022f462$var$enabledStyles = (0, $jjlaj.css)({
    cursor: "pointer"
});
var $2f20f1fba022f462$var$disabledStyles = (0, $jjlaj.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $2f20f1fba022f462$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $2f20f1fba022f462$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $0c27aa7a20d367fb$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f2645c9c716c7cdf$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $2f20f1fba022f462$var$_excluded2);
    var resolvedStyles = (0, $e6d0345947ee0cfe$export$a9c84988c8f81f2d)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $jjlaj.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $2f20f1fba022f462$var$baseStyles,
            $2f20f1fba022f462$var$focusRingStyles,
            isDisabled ? $2f20f1fba022f462$var$disabledStyles : $2f20f1fba022f462$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $b33f29a531e0ea11$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $b33f29a531e0ea11$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $2f20f1fba022f462$export$2e2bcd8739ae039 = $2f20f1fba022f462$var$Pressable;



var $2ca5792a09d1f5f6$var$buttonStyles = (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
    display: "flex",
    width: "24px",
    height: "24px",
    padding: "space.0",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    background: "none",
    borderStyle: "none",
    cursor: "pointer",
    whiteSpace: "nowrap"
});
var $2ca5792a09d1f5f6$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($856f7aedef48a228$exports)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($d4ed22ceb5c8d966$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d09ac97c4d5c96c6$exports)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "medium";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f20f1fba022f462$export$2e2bcd8739ae039), {
        xcss: $2ca5792a09d1f5f6$var$buttonStyles,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ButtonIcon, {
        label: buttonLabel,
        size: size,
        primaryColor: (0, $82786787318b191b$export$13b42cd9d596bfe0)[appearance]
    }));
};
var $2ca5792a09d1f5f6$var$DismissButton = /*#__PURE__*/ (0, $acw62.memo)($2ca5792a09d1f5f6$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ca5792a09d1f5f6$export$2e2bcd8739ae039 = $2ca5792a09d1f5f6$var$DismissButton;


var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $9444eed9bcadd173$var$expanderStyles = (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
    width: "100%"
});
var $9444eed9bcadd173$var$containerStyles = (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
    transition: "max-height 0.3s"
});
var $9444eed9bcadd173$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8a31190586db0eb8$export$2e2bcd8739ae039), {
        xcss: $9444eed9bcadd173$var$containerStyles,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: "1 1 100%",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $183a833228617892$export$2e2bcd8739ae039), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), null, function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8a31190586db0eb8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            xcss: $9444eed9bcadd173$var$expanderStyles
        }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bb2d4144016fdeac$export$2e2bcd8739ae039), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9444eed9bcadd173$export$2e2bcd8739ae039 = $9444eed9bcadd173$var$Expander;



function $2d77e1c2d32ffd41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d77e1c2d32ffd41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d77e1c2d32ffd41$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d77e1c2d32ffd41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d77e1c2d32ffd41$var$CSS_VAR_ICON_COLOR = "--flag-icon-color";
// For cases where a single word is longer than the container (e.g. filenames)
var $2d77e1c2d32ffd41$var$overflowWrapStyles = (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
    overflowWrap: "anywhere"
});
var $2d77e1c2d32ffd41$var$descriptionStyles = (0, $jjlaj.css)({
    maxHeight: 100,
    // height is defined as 5 lines maximum by design
    overflow: "auto",
    overflowWrap: "anywhere" // For cases where a single word is longer than the container (e.g. filenames)
});
var $2d77e1c2d32ffd41$var$iconWrapperStyles = (0, $jjlaj.css)({
    display: "flex",
    alignItems: "start",
    flexShrink: 0,
    color: "var(".concat($2d77e1c2d32ffd41$var$CSS_VAR_ICON_COLOR, ")")
});
var $2d77e1c2d32ffd41$var$flagStyles = (0, $e6d0345947ee0cfe$export$f6c783d06584602c)({
    boxShadow: "elevation.shadow.overlay",
    borderRadius: "border.radius.100",
    overflow: "hidden",
    zIndex: "flag",
    width: "100%",
    transition: "background-color 200ms"
});
var $2d77e1c2d32ffd41$var$flagWrapperStyles = (0, $jjlaj.css)({
    width: "100%"
});
var $2d77e1c2d32ffd41$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "15.8.7"
};
var $2d77e1c2d32ffd41$var$transitionStyles = (0, $jjlaj.css)({
    flexGrow: 1,
    transition: "gap 0.3s"
});
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $2d77e1c2d32ffd41$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $a8cf11ad922cb067$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $38132a618d93e205$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $acw62.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $f2645c9c716c7cdf$export$a4687b0234b40e28)($2d77e1c2d32ffd41$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $2d77e1c2d32ffd41$var$analyticsAttributes));
    var isBold = appearance !== (0, $a8cf11ad922cb067$export$d6830277b06edd6);
    var toggleExpand = (0, $acw62.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $acw62.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $acw62.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $acw62.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $f2645c9c716c7cdf$export$a4687b0234b40e28)($2d77e1c2d32ffd41$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $2d77e1c2d32ffd41$var$analyticsAttributes));
    var onBlurAnalytics = (0, $f2645c9c716c7cdf$export$a4687b0234b40e28)($2d77e1c2d32ffd41$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $2d77e1c2d32ffd41$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $82786787318b191b$export$f50075b2584087f)[appearance];
    var iconColor = (0, $82786787318b191b$export$7f70afe2167f8235)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? (0, $jjlaj.jsx)((0, $8568069ac023c6f7$export$2e2bcd8739ae039), {
        role: "alert"
    }, title, description) : undefined;
    return (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        role: delayAnnouncement ? undefined : "alert",
        css: $2d77e1c2d32ffd41$var$flagWrapperStyles,
        "data-testid": testId
    }, autoDismissProps), (0, $jjlaj.jsx)((0, $8a31190586db0eb8$export$2e2bcd8739ae039), {
        backgroundColor: (0, $82786787318b191b$export$59e42969c95d314)[appearance],
        padding: "space.200",
        xcss: $2d77e1c2d32ffd41$var$flagStyles
    }, (0, $jjlaj.jsx)((0, $1f12c6db18b953b0$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.200"
    }, (0, $jjlaj.jsx)("div", {
        css: $2d77e1c2d32ffd41$var$iconWrapperStyles,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $2d77e1c2d32ffd41$var$CSS_VAR_ICON_COLOR, iconColor)
    }, icon), (0, $jjlaj.jsx)("span", {
        css: $2d77e1c2d32ffd41$var$transitionStyles
    }, (0, $jjlaj.jsx)((0, $bb2d4144016fdeac$export$2e2bcd8739ae039), {
        space: shouldRenderGap ? "space.100" : "space.0" // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, (0, $jjlaj.jsx)((0, $1f12c6db18b953b0$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, (0, $jjlaj.jsx)((0, $8a31190586db0eb8$export$2e2bcd8739ae039), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $2d77e1c2d32ffd41$var$overflowWrapStyles
    }, (0, $jjlaj.jsx)((0, $7d9e81ef639116d5$export$2e2bcd8739ae039), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, title)), isDismissable ? !(isBold && !description && !actions.length) && (0, $jjlaj.jsx)((0, $2ca5792a09d1f5f6$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), (0, $jjlaj.jsx)((0, $9444eed9bcadd173$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && (0, $jjlaj.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $82786787318b191b$export$13b42cd9d596bfe0)[appearance]
        },
        css: $2d77e1c2d32ffd41$var$descriptionStyles,
        "data-testid": testId && "".concat(testId, "-description")
    }, description), (0, $jjlaj.jsx)((0, $346810cc4b2b017b$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $2d77e1c2d32ffd41$export$2e2bcd8739ae039 = $2d77e1c2d32ffd41$var$Flag;



var $9f175d156b67ed04$var$packageName = "@atlaskit/flag";
var $9f175d156b67ed04$var$packageVersion = "15.8.7";
var $9f175d156b67ed04$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $9f175d156b67ed04$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $45f4b35fa627590b$export$2e2bcd8739ae039) : _props$onDismissed;
    var autoDismissTimer = (0, $acw62.useRef)(null);
    var _useFlagGroup = (0, $38132a618d93e205$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $acw62.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $f2645c9c716c7cdf$export$a4687b0234b40e28)({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext,
        componentName: "flag",
        packageName: $9f175d156b67ed04$var$packageName,
        packageVersion: $9f175d156b67ed04$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $acw62.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $acw62.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $acw62.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $9f175d156b67ed04$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $acw62.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $9f175d156b67ed04$export$2e2bcd8739ae039 = $9f175d156b67ed04$var$AutoDismissFlag;


var $33b93c4ae7cd1380$exports = {};
"use strict";
Object.defineProperty($33b93c4ae7cd1380$exports, "__esModule", {
    value: true
});
$33b93c4ae7cd1380$exports.default = void 0;

var $33b93c4ae7cd1380$var$_react = $33b93c4ae7cd1380$var$_interopRequireDefault((parcelRequire("acw62")));

function $33b93c4ae7cd1380$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $33b93c4ae7cd1380$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $33b93c4ae7cd1380$var$_react.default.createElement($909afc01458e2b41$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$33b93c4ae7cd1380$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $33b93c4ae7cd1380$var$_default = $33b93c4ae7cd1380$var$CheckCircleIcon;
$33b93c4ae7cd1380$exports.default = $33b93c4ae7cd1380$var$_default;


const $841392e8ea024d6d$export$5966a7397891b74f = ({ flags: flags, handleDismiss: handleDismiss, userName: userName })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38132a618d93e205$export$2e2bcd8739ae039), {
        onDismissed: handleDismiss,
        children: flags.map((flagId)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f175d156b67ed04$export$2e2bcd8739ae039), {
                id: flagId,
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33b93c4ae7cd1380$exports))), {
                    label: "Success",
                    primaryColor: "var(--ds-icon-success)",
                    size: "medium"
                }),
                title: `Peer recognition sent`,
                description: `Great job! ${userName} received 100 bonus points from your recognition.`
            }, flagId);
        })
    });
};


/* LimitReachedModal.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");


var $ef858c181cbf85a8$exports = {};
"use strict";
Object.defineProperty($ef858c181cbf85a8$exports, "__esModule", {
    value: true
});
$ef858c181cbf85a8$exports.default = void 0;

var $ef858c181cbf85a8$var$_react = $ef858c181cbf85a8$var$_interopRequireDefault((parcelRequire("acw62")));

function $ef858c181cbf85a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ef858c181cbf85a8$var$InfoIcon = (props)=>/*#__PURE__*/ $ef858c181cbf85a8$var$_react.default.createElement($909afc01458e2b41$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$ef858c181cbf85a8$var$InfoIcon.displayName = "InfoIcon";
var $ef858c181cbf85a8$var$_default = $ef858c181cbf85a8$var$InfoIcon;
$ef858c181cbf85a8$exports.default = $ef858c181cbf85a8$var$_default;



const $67a919cc37a66295$var$styles = null;
const $67a919cc37a66295$var$formatRefreshDate = (nextRefreshTimestamp)=>{
    if (!nextRefreshTimestamp) return "soon";
    const date = new Date(nextRefreshTimestamp);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        timeZone: "UTC"
    });
};
const $67a919cc37a66295$export$3ea4a047fa51d81d = ({ recognitionSchedule: recognitionSchedule, onClose: onClose })=>{
    const refreshDate = $67a919cc37a66295$var$formatRefreshDate(recognitionSchedule?.nextRefresh);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49f7c216070fc3db$export$2e2bcd8739ae039), {
        onClose: onClose,
        width: "45rem",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $185e137d176d1262$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_kqswstnw _1xi27vkz _154i7vkz _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79ef2cf25005c825$exports))), {
                            label: "Close Modal",
                            primaryColor: "var(--ds-text)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _zulpxjmg _4cvr1y6m _ca0qa5zd _n3tda5zd _19bvl6l0 _u5f3l6l0"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_1e0c1txw _4cvr1h6o _zulpxjmg"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ef858c181cbf85a8$exports))), {
                                            label: "Information",
                                            size: "large",
                                            primaryColor: "var(--ds-icon-information)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_syaz1blv _1iqs1jhh _ect41mof _1wyb1joh _zg8l4jg8 _k48p1cnh _vwz4uxip _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            children: "You\u2019ve reached your limit for this week."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1blv _ect48ub1 _1wybj6jx _zg8l4jg8 _k48p1md6 _vwz410wf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _18u0a5zd"
                                    ]),
                                    children: [
                                        "Thanks for sharing the love! Come back on ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: refreshDate
                                        }),
                                        " to give more recognition."
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $67a919cc37a66295$var$modalContainer = null;
const $67a919cc37a66295$var$headerContainer = null;
const $67a919cc37a66295$var$closeButtonStyles = null;
const $67a919cc37a66295$var$titleStyles = null;
const $67a919cc37a66295$var$bodyStyles = null;


const $07b434b9e9e0636a$var$KudosModal = ({ currentProfileAaid: currentProfileAaid })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [flags, setFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [isReasonSelected, setIsReasonSelected] = (0, $acw62.useState)(false);
    const [selectedReason, setSelectedReason] = (0, $acw62.useState)();
    const { userData: userData, recognitionSchedule: recognitionSchedule, loggedInUserAaid: loggedInUserAaid, pathProfileId: pathProfileId } = (0, $3c60c4da24201aa6$export$ec9951569f53766a)({
        currentProfileAaid: currentProfileAaid
    });
    const closeModal = ()=>setIsOpen(false);
    const openModal = ()=>{
        (0, $9a59db8343324c6b$export$e9e47999dc0f4f3d)({
            senderAaid: loggedInUserAaid ?? "",
            receiverAaid: currentProfileAaid,
            profileInternalId: pathProfileId ?? ""
        });
        setIsOpen(true);
    };
    const { giveRecognition: giveRecognition, isSubmitting: isSubmitting } = (0, $e5408a4b42209aa8$export$ca9e1394dc02d224)({
        onSuccess: ()=>{
            setFlags([
                flags.length + 1,
                ...flags
            ]);
            setIsReasonSelected(false);
            setSelectedReason(undefined);
        },
        onComplete: closeModal,
        profileInternalId: pathProfileId ?? ""
    });
    const sendRecognitionButton = ()=>{
        giveRecognition({
            currentProfileAaid: currentProfileAaid,
            comment: selectedReason ?? "",
            loggedInUserAaid: loggedInUserAaid ?? "",
            pathProfileId: pathProfileId ?? ""
        });
    };
    const handleDismiss = ()=>{
        setFlags(flags.slice(1));
    };
    const userName = userData?.nickname;
    const firstName = userName ? userName.split(" ")[0] : null;
    const shouldShowLimitModal = ()=>isOpen && recognitionSchedule?.availablePoints === 0;
    const shouldShowRegularModal = ()=>isOpen && (recognitionSchedule?.availablePoints ?? 0) > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: openModal,
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_80omtlke _syaz1jwt _y3gn1h6o _ect41q02 _1wyb7vkz _k48pzul8 _vwz4gktf _o5721q9c _19itglyw _bfhku67f _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _9oik1r31 _1bnx8stv _jf4cnqa1"
                ]),
                children: `Give ${firstName} recognition`
            }),
            shouldShowLimitModal() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67a919cc37a66295$export$3ea4a047fa51d81d), {
                recognitionSchedule: recognitionSchedule,
                onClose: closeModal
            }),
            shouldShowRegularModal() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49f7c216070fc3db$export$2e2bcd8739ae039), {
                onClose: closeModal,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_vchhusvi _1bsb1osq _bfhku67f _19pkidpf _2hwx1wug _otyridpf _18u01wug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f90d700a3e79fe6a$export$30ede47bad3eb2e6), {
                            recognitionSchedule: recognitionSchedule,
                            onClose: closeModal
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdb3528b429eeb1b$export$2e2bcd8739ae039), {
                            onReasonSelect: (reason)=>{
                                setIsReasonSelected(true);
                                setSelectedReason(reason);
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $441f86547dd59805$export$994a453e91e6cab5), {
                            onSendRecognition: sendRecognitionButton,
                            isReasonSelected: isReasonSelected,
                            isSubmitting: isSubmitting
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $841392e8ea024d6d$export$5966a7397891b74f), {
                flags: flags,
                handleDismiss: handleDismiss,
                userName: userData?.nickname ?? ""
            })
        ]
    });
};
const $07b434b9e9e0636a$var$GiveRecognitionModalStyles = null;
const $07b434b9e9e0636a$var$cursorStyles = null;
var $07b434b9e9e0636a$export$2e2bcd8739ae039 = $07b434b9e9e0636a$var$KudosModal;





const $3c73a8cc647b45fa$var$useIsProfileLinkedView = (internalId)=>{
    const unifiedProfile = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    })?.unified?.unifiedProfile;
    let profileFragmentData;
    if (unifiedProfile && "__fragments" in unifiedProfile) profileFragmentData = (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile);
    return profileFragmentData?.isLinkedView ?? false;
};
var $3c73a8cc647b45fa$export$2e2bcd8739ae039 = $3c73a8cc647b45fa$var$useIsProfileLinkedView;





const $718f65897de78705$var$useIsProfilePersonalView = (internalId)=>{
    const unifiedProfile = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    })?.unified?.unifiedProfile;
    let profileFragmentData;
    if (unifiedProfile && "__fragments" in unifiedProfile) profileFragmentData = (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile);
    return profileFragmentData?.isPersonalView ?? false;
};
var $718f65897de78705$export$2e2bcd8739ae039 = $718f65897de78705$var$useIsProfilePersonalView;



const $e5bc73569692f822$export$98371ac105153257 = ({ internalId: internalId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc406a32200a03b6$export$6cbf77c1b1e30396), {
                hasHeader: true
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5bc73569692f822$var$KudosSummary, {
                internalId: internalId
            })
        })
    });
const $e5bc73569692f822$var$KudosSummary = ({ internalId: internalId })=>{
    const kudosSummaryQuery = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $10f21b5b6953fc2d$export$68ef570fcece8188), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    }).unified?.unifiedProfile?.gamification;
    // Fetch profile data user visits
    const profileResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $fe73a947836bf836$export$9d9de7756b13ecf), {
        internalId: internalId
    }, {
        fetchPolicy: "store-or-network"
    });
    const profileData = profileResponseData?.unified?.unifiedProfile;
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    const isProfilePersonalView = (0, $718f65897de78705$export$2e2bcd8739ae039)(internalId);
    const isLinkedView = (0, $3c73a8cc647b45fa$export$2e2bcd8739ae039)(internalId);
    const recognitionSummaryTotals = kudosSummaryQuery?.recognitionsSummary;
    const allTotalsZero = recognitionSummaryTotals?.totals ? recognitionSummaryTotals.totals.every((total)=>total.count === 0) : true;
    const levels = kudosSummaryQuery?.levels;
    const FallbackComponent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "Something went wrong"
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a44cdd096bb28cc$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _1bsb1osq _2lx21bp4 _4cvr1y6m _zulpl6l0 _oe5xxjmg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _1bsb1osq _2lx2vrvc _1bah1yb4 _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b09ec013b267e49$export$2e2bcd8739ae039), {
                            testId: "kudos-summary-title",
                            title: "Kudos",
                            subtitle: isPersonalView ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Get rewards for your activity and progress, from beginner to expert. "
                            }) : undefined
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                            FallbackComponent: FallbackComponent,
                            onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                            children: (0, $4fca6bd638ae6930$export$5301ad2d5b2b49a4)() && !(isProfilePersonalView || isLinkedView) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1e0c1txw _4t3igosd _1yt41dzv _1bah1h6o _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1jwt _y3gn1h6o _ect41q02 _1wyb7vkz _k48pzul8 _vwz4gktf _o5721q9c"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07b434b9e9e0636a$export$2e2bcd8739ae039), {
                                        currentProfileAaid: profileData?.aaid ?? ""
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    "data-testid": "kudos-parent-container",
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _4cvr1y6m _zulpa5zd _1wpz1fhb _2rko1eps _11q71xnl _16qsj9yf _1yt41m6l _mw8n5k6p _iyz51bp4 _oe5xhiv4 _8ayzidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5bc73569692f822$var$KudosProgressSection, {
                            data: {
                                currentLevelArt: levels?.currentLevelArt,
                                currentLevelDescription: levels?.currentLevelDescription,
                                currentLevelName: levels?.currentLevelName,
                                currentPoints: levels?.currentPoints,
                                maxPoints: levels?.maxPoints,
                                nextLevelName: levels?.nextLevelName
                            }
                        }),
                        !isPersonalView && allTotalsZero ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5bc73569692f822$var$PeerKudosReceivedSection, {
                            data: recognitionSummaryTotals,
                            isEmptyMessageShown: isPersonalView && allTotalsZero
                        })
                    ]
                })
            ]
        })
    });
};
const $e5bc73569692f822$var$PeerKudosReceivedSection = ({ data: data, isEmptyMessageShown: isEmptyMessageShown })=>{
    const sendLearnMoreAnalytics = ()=>{
        (0, $9a59db8343324c6b$export$f6e4b24df4a21ebd)();
    };
    function formatAce(inputString) {
        return inputString.replace(/\b(ace)\b/gi, "ACE");
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "peer-kudos-received-container",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1ssb _ffv71osq",
            "_181716fl"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
            title: "Peer Recognition Received",
            children: isEmptyMessageShown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
                message: "Earn and give kudos for helping others. Kudos you receive will appear here.",
                linkTo: (0, $77d0522707ddb581$export$2e0ebf9d5f4bd3e9),
                linkType: "external",
                sendAnalyticsEvent: sendLearnMoreAnalytics,
                linkText: "Learn more about kudos"
            }) : data?.totals?.map((total, index)=>total.count !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _zulpxjmg _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a805a8f660383d18$exports))),
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1bsb1pa9 _4t3i1pa9"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_4t3iqslr _syaz1blv _ect41v9d _1wybxjmg _zg8l4jg8 _k48pc13d _vwz4l6l0"
                            ]),
                            children: `${total.count} kudos ${formatAce(total.comment)}`
                        })
                    ]
                }, index))
        })
    });
};
const $e5bc73569692f822$var$KudosProgressSection = ({ data: data })=>{
    const currentPoints = data.currentPoints ?? 0;
    const maxPoints = data.maxPoints ?? 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1ssb _ffv71osq"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
            title: "Progress",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o"
                    ]),
                    children: [
                        data.currentLevelArt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: data.currentLevelArt,
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1bsbap9k _4t3iap9k _1o9zidpf _1wpz1y6m"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1bsbn8ye _1o9zidpf _18u0xjmg"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_2lx2vrvc _1e0c1txw _4cvr1y6m _zulph461 _1bsb1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                            "_syaz1blv _ect4kwxw _zg8l4jg8 _1p1dglyw _k48pzul8 _1wybxjmg _vwz4hiv4"
                                        ]),
                                        children: `${data.currentLevelDescription}: ${data.currentLevelName}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5bc73569692f822$var$ProgressBar, {
                                    completed: currentPoints / maxPoints * 100
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_1e0c1txw _1bsbn8ye _4cvr1y6m _zulpxjmg _ovu8m0mk"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_syaz1k3w _y3gn1e5h _ect41v9d _zg8l4jg8 _1p1dglyw _k48pc13d _1wybdlk8 _vwz41bcc _1cf8qslr"
                                            ]),
                                            children: `Next: ${data.nextLevelName}`
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_syaz1k3w _y3gnusic _ect41v9d _zg8l4jg8 _1p1dglyw _k48pc13d _1wybdlk8 _vwz41bcc _16jlkb7n _1o9zidpf _i0dlf1ug _1cf8qslr"
                                            ]),
                                            children: `${currentPoints.toLocaleString("en-US")} / ${maxPoints.toLocaleString("en-US")} points`
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $e5bc73569692f822$var$ProgressBar = ({ completed: completed })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_4t3i1eps _1bsb1osq _bfhk18r8 _2rkoh461 _1reo15vq _18m915vq _ovu8m0mk"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                width: `${completed}%`
            },
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_4t3i1osq _bfhk16j5 _y3gnusic"
            ])
        })
    });
};
const $e5bc73569692f822$var$progressBarStyles = null;
const $e5bc73569692f822$var$kudosCardStyle = null;
const $e5bc73569692f822$var$kudosLinkCardTitleStyle = null;
const $e5bc73569692f822$var$kudosIconStyle = null;
const $e5bc73569692f822$var$progressFrameLevelTextStyle = null;
const $e5bc73569692f822$var$progressLowerNextTextStyle = null;
const $e5bc73569692f822$var$progressLowerPointsTextStyle = null;
const $e5bc73569692f822$var$progressLevelTitleStyle = null;
const $e5bc73569692f822$var$progressLevelIconStyle = null;
const $e5bc73569692f822$var$progressFrameStyle = null;
const $e5bc73569692f822$var$progressFrameLowerStyle = null;
const $e5bc73569692f822$var$progressLevelStyle = null;
//could use elsewhere for progress bar styles
const $e5bc73569692f822$var$progressBarContainerStyle = null;
//should be the same for all border boxes on main column of profile
const $e5bc73569692f822$var$contentStyle = null;
const $e5bc73569692f822$var$sectionStyle = null;
const $e5bc73569692f822$var$peerKudosReceivedTabletStyle = null;
//should be the same for all containers on the main column of profile
const $e5bc73569692f822$var$mainContainerStyle = null;
const $e5bc73569692f822$var$sectionSummaryStyles = null;
const $e5bc73569692f822$var$linkContainerStyles = null;
const $e5bc73569692f822$var$linkStyles = null;
var $e5bc73569692f822$export$2e2bcd8739ae039 = $e5bc73569692f822$var$KudosSummary;


/* CertificationsSummary.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");

/* CertificationCard.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $975c22efe0f749c9$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}





// https://data-portal.internal.atlassian.com/analytics/registry/71742
const $5b5d3839c457cab4$export$6302f668947d948f = (certificationName, isMainPanel, isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: isMainPanel ? (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE : (0, $77d0522707ddb581$export$d2cea8e85c08e64c).CERTIFICATIONS,
        action: "clicked",
        actionSubject: "card",
        actionSubjectId: "certificationCard",
        attributes: {
            certificationName: certificationName ?? "not-named"
        },
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71733
const $5b5d3839c457cab4$export$9a1f20343cd61c4d = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).CERTIFICATIONS,
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71746
const $5b5d3839c457cab4$export$ee8d96c9d7080a5 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).CERTIFICATIONS,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "backToProfile",
        isPersonalView: isPersonalView
    });
};
const $5b5d3839c457cab4$export$5c298709690674bc = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "viewAllCertifications",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71738
const $5b5d3839c457cab4$export$dfe5cd97f8f560b0 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "certsGetStarted",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        isPersonalView: isPersonalView
    });
};




const $a849b9ec5f55f3e6$var$Certification = ({ data: data, isPersonalView: isPersonalView, isMainPanel: isMainPanel, testId: testId })=>{
    if (!data.name) return null;
    // add data.publicUrl back in when we have the data
    // const certificationUrl = data.publicUrl || CERTIFICATE_DEFAULT_URL;
    const certificationUrl = (0, $77d0522707ddb581$export$5fa6e6390aee07dd);
    const onClickCertification = ()=>{
        (0, $5b5d3839c457cab4$export$6302f668947d948f)(data.name ?? "not-named", isMainPanel ?? false, isPersonalView);
        window.open(certificationUrl);
    };
    const generateTagText = (nameAbbr, name)=>{
        if (name.toLowerCase().includes("fundamentals")) return "certificate";
        if (typeof nameAbbr !== "string") return null;
        if (nameAbbr.startsWith("ACP")) return "professional";
        else if (nameAbbr.startsWith("ACA")) return "associate";
        else return null;
    };
    const tagText = generateTagText(data.nameAbbr, data.name);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        "data-testid": testId,
        role: "button",
        onClick: onClickCertification,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _y3gn1kw7 _4bfu1r31 _1hmsglyw _ajmmnqa1 _11q7glyw _syaz1kw7 _19itglyw _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ect41q02",
            "_kqswh2mm _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _2lx21bp4 _vchhusvi _16qsj9yf _2rko1eps _11q76ota _1pbykb7n _4t3ipcwi _16jlkb7n _1o9zkb7n _i0dl1osq _v564wzwm _1dbz17er _1jhm1egq _8pe7163w _b8e6kb7n _aoqkkb7n _110dzag3 _yuwc122r",
            isMainPanel && "_6q2ix4fp _12d1idpf _aekxidpf _1pgkpcwi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_kqswstnw _1itkd9cz _1lrw1dfr _ouxl1ssb _2rko1ddd _154iidpf _1ltvidpf _4t3i88uy _1bsb1osq _1pbycs5v"
                ]),
                style: {
                    "--_vno4dg": (0, $975c22efe0f749c9$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($ff6469b987c1ec9f$exports))), ")", "url(")
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2lx21bp4 _1yt4l6l0 _1pbyegat"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_2rko1ssb _4t3il1r9 _1bsbl1r9 _1reo15vq _18m915vq"
                        ]),
                        children: data.imageUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: data.imageUrl,
                            alt: data.name,
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1bsb1osq _4t3i1osq"
                            ])
                        })
                    }),
                    tagText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_19pkftgi _otyryjp0 _1e0c116y"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$3288d34c523a1192), {
                            label: tagText
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_syaz1blv _19pkdlk8 _ect4kwxw _1wybgktf _k48pzul8 _vwz41f4h _1e0ccj1k _sudp1e54 _1yyj11wp _1reo15vq _18m915vq"
                        ]),
                        children: data.name
                    })
                ]
            })
        ]
    });
};
const $a849b9ec5f55f3e6$var$mainPanelCardStyle = null;
const $a849b9ec5f55f3e6$var$unstyledButtonStyles = null;
const $a849b9ec5f55f3e6$var$tagWrapper = null;
const $a849b9ec5f55f3e6$var$cardContainerStyles = null;
const $a849b9ec5f55f3e6$var$topBackgroundStyles = null;
const $a849b9ec5f55f3e6$var$cardContentStyles = null;
const $a849b9ec5f55f3e6$var$courseNameStyles = null;
const $a849b9ec5f55f3e6$var$certificationImageContainerStyles = null;
const $a849b9ec5f55f3e6$var$certificationImageStyles = null;
var $a849b9ec5f55f3e6$export$2e2bcd8739ae039 = $a849b9ec5f55f3e6$var$Certification;







var $acw62 = parcelRequire("acw62");

const $1ff86c684b2eea3c$export$df64e748287156f4 = (data)=>{
    const edges = data.unified?.unifiedProfile?.learning?.certifications?.edges;
    if (!edges) return;
    return edges.reduce((normalizedCertmetricsCertificates, currentEdge)=>{
        if (currentEdge?.node) normalizedCertmetricsCertificates.push(currentEdge.node);
        return normalizedCertmetricsCertificates;
    }, []);
};



var $5f1a5bf778e73f5b$var$_UnifiedLearningCertificationQuery;

const $5f1a5bf778e73f5b$export$e467401ccf0c4eff = $5f1a5bf778e73f5b$var$_UnifiedLearningCertificationQuery !== void 0 ? $5f1a5bf778e73f5b$var$_UnifiedLearningCertificationQuery : $5f1a5bf778e73f5b$var$_UnifiedLearningCertificationQuery = (parcelRequire("ksg6x"));


const $235eb8ab1660c314$var$splitCertificatesByActiveDatePresence = (certificates)=>{
    return certificates.reduce((result, currentCertificate)=>{
        if (currentCertificate?.activeDate) result.certificatesWithDate.push(currentCertificate);
        else result.certificatesWithoutDate.push(currentCertificate);
        return result;
    }, {
        certificatesWithDate: [],
        certificatesWithoutDate: []
    });
};
const $235eb8ab1660c314$var$sortCertificatesByActiveDate = (certificates)=>{
    const { certificatesWithDate: certificatesWithDate, certificatesWithoutDate: certificatesWithoutDate } = $235eb8ab1660c314$var$splitCertificatesByActiveDatePresence(certificates);
    const sortedCertificates = certificatesWithDate.sort((a, b)=>{
        const aActiveDate = a?.activeDate || "";
        const bActiveDate = b?.activeDate || "";
        return new Date(bActiveDate).getTime() - new Date(aActiveDate).getTime();
    });
    return sortedCertificates.concat(certificatesWithoutDate);
};
const $235eb8ab1660c314$var$sortEmeritusCertificateFirst = (certificates)=>{
    const emeritusCertificateIndex = certificates.findIndex((certificate)=>certificate?.nameAbbr === (0, $77d0522707ddb581$export$8410e492fb32a9b).EXPERT_EMERITUS);
    if (emeritusCertificateIndex && emeritusCertificateIndex !== -1) {
        const emeritusCertificte = certificates.splice(emeritusCertificateIndex, 1);
        certificates.unshift(emeritusCertificte[0]);
    }
    return certificates;
};
const $235eb8ab1660c314$var$retrieveCertmetricsCertificates = (data)=>{
    const normalizedCertificates = (0, $1ff86c684b2eea3c$export$df64e748287156f4)(data);
    if (!normalizedCertificates) return undefined;
    const dateSorted = $235eb8ab1660c314$var$sortCertificatesByActiveDate(normalizedCertificates);
    return $235eb8ab1660c314$var$sortEmeritusCertificateFirst(dateSorted);
};
const $235eb8ab1660c314$var$useCertmetricsCertificates = (variables)=>{
    const data = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5f1a5bf778e73f5b$export$e467401ccf0c4eff), variables, {
        fetchPolicy: "store-or-network"
    });
    const certificates = (0, $acw62.useMemo)(()=>{
        return $235eb8ab1660c314$var$retrieveCertmetricsCertificates(data);
    }, [
        data
    ]);
    const totalCount = data.unified?.unifiedProfile?.learning?.certifications?.totalCount ?? undefined;
    return {
        certificates: certificates,
        totalCount: totalCount
    };
};
var $235eb8ab1660c314$export$2e2bcd8739ae039 = $235eb8ab1660c314$var$useCertmetricsCertificates;









function $2291a83d8de96232$export$44a1b87e52fd4ed5(certifications, removeEmeritus) {
    const currentDate = new Date();
    // Filter out null values
    const nonNullCertifications = certifications.filter((cert)=>cert !== null);
    // Filter out expired certifications
    const filteredCertifications = nonNullCertifications.filter((certification)=>{
        if (certification.expireDate) {
            const expireDate = new Date(certification.expireDate);
            return expireDate >= currentDate;
        }
        return true;
    });
    // Remove 'Emeritus' from the name if removeEmeritus is true
    const updatedCertifications = filteredCertifications.map((certification)=>{
        if (removeEmeritus && certification.name && certification.name.includes("Emeritus")) return {
            ...certification,
            name: certification.name.replace("Emeritus", "").trim()
        };
        return certification;
    });
    // Sort certifications
    updatedCertifications.sort((a, b)=>{
        const isExpertA = a.name?.startsWith("Atlassian Certified Expert") || false;
        const isExpertB = b.name?.startsWith("Atlassian Certified Expert") || false;
        if (isExpertA && !isExpertB) return -1;
        if (!isExpertA && isExpertB) return 1;
        return new Date(b.activeDate ?? 0).getTime() - new Date(a.activeDate ?? 0).getTime();
    });
    return updatedCertifications;
}


const $1f585a3def3b9b54$export$cb8a57f28f16d7a9 = ({ internalId: internalId, accountId: accountId })=>accountId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc406a32200a03b6$export$6cbf77c1b1e30396), {
                hasHeader: true
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1f585a3def3b9b54$var$CertificationsSummary, {
                internalId: internalId,
                accountId: accountId
            })
        })
    }) : null;
const $1f585a3def3b9b54$var$CertificationsSummary = ({ internalId: internalId })=>{
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    const { certificates: certificates, totalCount: totalCount } = (0, $235eb8ab1660c314$export$2e2bcd8739ae039)({
        internalId: internalId,
        status: (0, $77d0522707ddb581$export$6e66959687be02fe).ACTIVE,
        type: [
            "CERTIFICATION"
        ],
        sortField: "ACTIVE_DATE",
        sortDirection: "DESC"
    });
    const filteredCertificates = (0, $2291a83d8de96232$export$44a1b87e52fd4ed5)((certificates ?? []).slice(0, 3), false);
    const totalCertifications = totalCount ?? 0;
    if (!isPersonalView && !totalCertifications) return null;
    let titleText;
    if (isPersonalView && !totalCertifications) titleText = "Credentials";
    else titleText = `${totalCertifications} Credential${totalCertifications > 1 ? "s" : ""}`;
    const sendGetStartedAnalytics = ()=>{
        (0, $5b5d3839c457cab4$export$dfe5cd97f8f560b0)(isPersonalView);
    };
    if (!isPersonalView && !filteredCertificates) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a44cdd096bb28cc$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b09ec013b267e49$export$2e2bcd8739ae039), {
                testId: "certifications-summary-title",
                title: titleText,
                link: totalCertifications < 4 ? undefined : `/profile/${internalId}/certifications`,
                linkText: totalCertifications < 4 ? undefined : "View all",
                viewAllAnalyticsName: "viewAllCertifications"
            }),
            isPersonalView && totalCertifications === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e11946d314b99a3d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "certifications-cta-container",
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _2lx21bp4 _zulpxjmg"
                    ]),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
                        message: "Get Atlassian-certified to boost your career and earn global recognition for your expertise.",
                        linkTo: (0, $77d0522707ddb581$export$5fa6e6390aee07dd),
                        linkText: "Get started",
                        linkType: "external",
                        sendAnalyticsEvent: sendGetStartedAnalytics,
                        isButton: true
                    })
                })
            }) : null,
            filteredCertificates && totalCertifications > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "certifications-summary-list",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1bsb1osq _1e0c1txw _2lx2vrvc _zulp1tcg _g1ns1g80 _oe5x7vkz"
                ]),
                children: filteredCertificates.map((cert, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a849b9ec5f55f3e6$export$2e2bcd8739ae039), {
                        testId: `certification-card-${i}`,
                        isMainPanel: true,
                        isPersonalView: isPersonalView,
                        data: {
                            name: cert?.name ?? null,
                            imageUrl: cert?.imageUrl ?? null,
                            publicUrl: cert?.imageUrl ?? null,
                            nameAbbr: cert?.nameAbbr ?? null
                        }
                    }, i))
            }) : null
        ]
    });
};
const $1f585a3def3b9b54$var$certificationsCardsStyles = null;
const $1f585a3def3b9b54$var$emptyMessageContainerStyles = null;
var $1f585a3def3b9b54$export$2e2bcd8739ae039 = $1f585a3def3b9b54$var$CertificationsSummary;



/* GroupsSummary.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");

var $0b2fc169eb37e823$var$_UnifiedForumsGroupsQuery;

const $0b2fc169eb37e823$export$32494925c577d61b = $0b2fc169eb37e823$var$_UnifiedForumsGroupsQuery !== void 0 ? $0b2fc169eb37e823$var$_UnifiedForumsGroupsQuery : $0b2fc169eb37e823$var$_UnifiedForumsGroupsQuery = (parcelRequire("jE992"));














// https://data-portal.internal.atlassian.com/analytics/registry/70935
const $5ac37411c5201f22$export$c91eb30a2badd38b = (groupName, isPersonalView, source = (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: source,
        action: "clicked",
        actionSubject: "card",
        actionSubjectId: "groupCard",
        attributes: {
            groupName: groupName ?? "not-named"
        },
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71737
const $5ac37411c5201f22$export$ce87930de26dac97 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "findAGroup",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71746
const $5ac37411c5201f22$export$247741b7e547d5b0 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).GROUPS,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "backToProfile",
        isPersonalView: isPersonalView
    });
};




/* LoadingSidePanelSection.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

const $dbb75c5d43001c98$export$65eada320cc2f47c = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_4t3imgvx _1bsb1osq _11q718r8 _2rkoftgi"
        ])
    });
};
const $dbb75c5d43001c98$var$loadingSectionStyles = null;




const $28b1e818e05d15e3$var$COMMUNITY_BASE_URL = "https://community.atlassian.com";
const $28b1e818e05d15e3$export$d3b1722b41d3ee98 = ()=>(0, $4fca6bd638ae6930$export$73f46a93e1216cfe)() ? `${$28b1e818e05d15e3$var$COMMUNITY_BASE_URL}/forums/groups` : `${$28b1e818e05d15e3$var$COMMUNITY_BASE_URL}/t5/Groups/ct-p/groups`;
const $28b1e818e05d15e3$export$5eec9c5057ec9561 = (viewHref)=>(0, $4fca6bd638ae6930$export$73f46a93e1216cfe)() ? viewHref ?? $28b1e818e05d15e3$export$d3b1722b41d3ee98() : `${$28b1e818e05d15e3$var$COMMUNITY_BASE_URL}${viewHref || "#"}`;
const $28b1e818e05d15e3$export$4e1c4af5d80537e4 = (imageUrl)=>{
    const resolvedImageUrl = imageUrl || (0, $77d0522707ddb581$export$525244e58866b0c7);
    return (0, $4fca6bd638ae6930$export$73f46a93e1216cfe)() ? imageUrl || `${$28b1e818e05d15e3$var$COMMUNITY_BASE_URL}${0, $77d0522707ddb581$export$525244e58866b0c7}` : `${$28b1e818e05d15e3$var$COMMUNITY_BASE_URL}${resolvedImageUrl}`;
};


const $6aeee297ca0427ed$export$9d29d4e8402ec840 = ({ internalId: internalId, isMainPanel: isMainPanel })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: isMainPanel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc406a32200a03b6$export$6cbf77c1b1e30396), {
                hasHeader: true
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb75c5d43001c98$export$65eada320cc2f47c), {}),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6aeee297ca0427ed$var$GroupsSummary, {
                internalId: internalId
            })
        })
    });
const $6aeee297ca0427ed$var$GroupsSummary = ({ internalId: internalId })=>{
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    const unifiedGroupsResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $0b2fc169eb37e823$export$32494925c577d61b), {
        internalId: internalId
    });
    const unifiedGroupsData = unifiedGroupsResponse?.unified?.unifiedProfile?.forums?.groups?.edges?.map((item)=>item?.node);
    const totalCount = unifiedGroupsResponse?.unified?.unifiedProfile?.forums?.groups?.totalCount ?? 0;
    if (!isPersonalView && (!unifiedGroupsData || !totalCount)) return null;
    const onClickGroup = (groupLink, groupName)=>{
        (0, $5ac37411c5201f22$export$c91eb30a2badd38b)(groupName ?? "not-named", isPersonalView);
        window.open(groupLink);
    };
    const sendJoinGroupAnalytics = ()=>{
        (0, $5ac37411c5201f22$export$ce87930de26dac97)(isPersonalView);
    };
    const displayedGroups = unifiedGroupsData ? unifiedGroupsData.slice(0, 4) : [];
    const sectionTitle = totalCount === 0 ? "GROUPS" : totalCount === 1 ? `${totalCount} GROUP` : `${totalCount} GROUPS`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a44cdd096bb28cc$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e11946d314b99a3d$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
                title: sectionTitle,
                children: !unifiedGroupsData || !totalCount ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
                    message: "Ask questions, join discussions, and find your people.",
                    linkTo: (0, $28b1e818e05d15e3$export$d3b1722b41d3ee98)(),
                    linkType: "external",
                    sendAnalyticsEvent: sendJoinGroupAnalytics,
                    linkText: "Join a group"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_syaz1jwt _1wybxjmg _vwz4gktf _k48pni7l _zg8l4jg8 _18u01wug _kqswstnw _ect41q02 _154iidpf _1xi2idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                                to: `profile/${internalId}/groups`,
                                children: `View all`
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "summary-groups-list",
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1e0c1txw _2lx21bp4 _zulphiv4 _1bsb1osq"
                            ]),
                            children: displayedGroups.map((group, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    onClick: ()=>onClickGroup((0, $28b1e818e05d15e3$export$5eec9c5057ec9561)(group?.viewHref), group?.title),
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1qtk _kqswh2mm _1kt9b3bt _1cs8stnw _1auk14id _qnecd439 _oound439 _19wo14id _rfx3h461 _1g0vidpf _1xqc18r8 _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1or91bs0 _pmkj1bs0"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                            "_1e0c1txw _4cvrjp4b _1bsb1osq _kqswh2mm"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb18e8 _4t3ia5zd _bfhk18r8 _2rko14y2 _2hwxoxav _1o9zidpf"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($54a8512f4af9f62a$exports))),
                                                    alt: "Groups Icon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                    "_1e0c1txw _2lx21bp4 _zulph461 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                            "_1wybxjmg _k48pzul8 _1bsbb54c _vwz4l6l0 _syazrfnr _ect4kwxw"
                                                        ]),
                                                        children: group?.title
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                            "_ect41v9d _syaz1jij _1wybdlk8 _vwz41bcc _k48p1kdj"
                                                        ]),
                                                        children: [
                                                            group?.groupMemberCount?.toLocaleString("en-US"),
                                                            " ",
                                                            "members"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index))
                        })
                    ]
                })
            })
        })
    });
};
var $6aeee297ca0427ed$export$2e2bcd8739ae039 = $6aeee297ca0427ed$var$GroupsSummary;
const $6aeee297ca0427ed$var$groupsStyles = {
    container: null,
    header: null,
    groupsList: null,
    title: null,
    viewAllLink: null,
    groupLink: null,
    groupItem: null,
    groupImageContainer: null,
    groupInfo: null,
    groupName: null,
    groupMembers: null,
    emptyState: null
};



var $eJz0f = parcelRequire("eJz0f");

/* Events.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");






// https://data-portal.internal.atlassian.com/analytics/registry/71750
const $54c3da6cbab5f73d$export$e3ca08d12c0376d3 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "bioLink",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71736
const $54c3da6cbab5f73d$export$3d544e2ec22d45ce = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "aboutMeEditProfile",
        isPersonalView: isPersonalView,
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71745
const $54c3da6cbab5f73d$export$1e6f0ad6ac50506f = (linkType, isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "socialLink",
        attributes: {
            linkType: linkType
        },
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84848
const $54c3da6cbab5f73d$export$189cf78b7d99f3d1 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "eventsLinkProfile",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71749
const $54c3da6cbab5f73d$export$a809453cb4b83dfe = (productId, isPersonalView, source)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: source,
        action: "clicked",
        actionSubject: "pill",
        actionSubjectId: "productPill",
        attributes: {
            productId: productId
        },
        isPersonalView: isPersonalView
    });
};




const $4681896e22cc2dc9$var$Events = ()=>{
    const [unifiedProfileUsername] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(unifiedProfileUsername);
    const sendEventsAnalytics = ()=>{
        (0, $54c3da6cbab5f73d$export$189cf78b7d99f3d1)(isPersonalView);
    };
    if (!isPersonalView) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e11946d314b99a3d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": "events-container",
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _2lx21bp4 _zulpa5zd _oe5xhiv4"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
                title: "Community Events",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
                    message: "Join an upcoming community event to learn, connect, and swap tips with other Atlassian users.",
                    linkTo: `https://ace.atlassian.com/`,
                    linkType: "external",
                    sendAnalyticsEvent: sendEventsAnalytics,
                    linkText: "Explore events"
                })
            })
        })
    });
};
var $4681896e22cc2dc9$export$2e2bcd8739ae039 = $4681896e22cc2dc9$var$Events;
const $4681896e22cc2dc9$var$eventsContainerStyles = null;




var $acw62 = parcelRequire("acw62");




/* BadgesSummary.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");







/* MostRecentBadges.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

/* MostRecentAvatars.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

/* Avatar.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");
const $5bfc06667fe121b2$var$remainderAvatarStyle = null;
const $5bfc06667fe121b2$var$imageAvatarStyle = null;
const $5bfc06667fe121b2$var$commonStyle = null;
const $5bfc06667fe121b2$var$Avatar = ({ src: src, name: name, isRemainder: isRemainder, displayText: displayText })=>{
    const avatarStyle = {
        backgroundImage: `url(${src})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
    };
    // Different styling for 'remainder avatar' and avatar with no src
    if (isRemainder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": `avatar-${displayText ? "remainder" : name}`,
        style: avatarStyle,
        title: name,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_18u01vh9 _1bsbl1r9 _4t3il1r9 _2rko1ssb _19it1gqe _4cvr1h6o _1bah1h6o _1e0c1txw _1wyb1y1z _18171d0t _1pgc14id _damwpm4n",
            "_bfhk18r8 _ect4kwxw _k48pzul8 _vwz4l1r9"
        ]),
        children: displayText
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": `avatar-${name}`,
        style: avatarStyle,
        title: name,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_18u01vh9 _1bsbl1r9 _4t3il1r9 _2rko1ssb _19it1gqe _4cvr1h6o _1bah1h6o _1e0c1txw _1wyb1y1z _18171d0t _1pgc14id _damwpm4n",
            "_bfhku67f"
        ])
    });
};
var $5bfc06667fe121b2$export$2e2bcd8739ae039 = $5bfc06667fe121b2$var$Avatar;



const $2334c837e4f7a704$export$6a861a37616558d7 = ({ data: data })=>{
    const avatars = data.slice(0, 3).map((avatar, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bfc06667fe121b2$export$2e2bcd8739ae039), {
            src: avatar.src ?? undefined,
            name: avatar.name || "",
            isRemainder: !avatar.src
        }, index));
    let remainderText = "";
    if (data.length > 3) {
        remainderText = (0, $5950fde19a0508c0$export$2bc9488aaaa78231)(data.length);
        avatars.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bfc06667fe121b2$export$2e2bcd8739ae039), {
            name: "remainder",
            isRemainder: true,
            displayText: remainderText
        }, "remainder"));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _18u0oxav _16nzoxav"
        ]),
        children: avatars
    });
};
const $2334c837e4f7a704$var$avatarContainer = null;






const $f1acffce3b3355bb$export$2afb7dd8601f73b2 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "viewAllBadges",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71746
const $f1acffce3b3355bb$export$42caad678751a45d = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).BADGES,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "backToProfile",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71732
const $f1acffce3b3355bb$export$d3077750ed35a580 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).BADGES,
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71855
const $f1acffce3b3355bb$export$d2e1534e63f08fe5 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "coursesStartLearning",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/85447
const $f1acffce3b3355bb$export$2b47182b94bc885c = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "unifiedProfileBadgesVisitForums",
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        isPersonalView: isPersonalView
    });
};



const $82301b01c60b3e85$var$MostRecentBadges = ({ isPersonalView: isPersonalView, recentBadges: recentBadges })=>{
    const isRecentBadgesZero = recentBadges.length === 0;
    //error state
    if (!isPersonalView && isRecentBadgesZero) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "most-recent-badges-container",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1ssb _2rko1vwy _189e1lkn _pg9o1osq",
            "_1f49cs5v"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
            title: "MOST RECENT BADGES",
            children: isRecentBadgesZero ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
                message: "Log in to Atlassian Community Forums to earn your first badge.",
                linkTo: (0, $77d0522707ddb581$export$9b60d67f4e046ae5),
                linkType: "external",
                sendAnalyticsEvent: ()=>(0, $f1acffce3b3355bb$export$2b47182b94bc885c)(isPersonalView),
                linkText: "Visit forums"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2334c837e4f7a704$export$6a861a37616558d7), {
                data: recentBadges
            })
        })
    });
};
const $82301b01c60b3e85$var$boxStyles = null;
const $82301b01c60b3e85$var$badgesStyle = null;
var $82301b01c60b3e85$export$2e2bcd8739ae039 = $82301b01c60b3e85$var$MostRecentBadges;


/* MostRecentLearningAchievements.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");






const $db6f4c15372022ff$var$MostRecentLearningAchievements = ({ isPersonalView: isPersonalView, recentLearningAchievementBadges: recentLearningAchievementBadges, profileHasConsented: profileHasConsented })=>{
    const isRecentLearningAchievementsZero = recentLearningAchievementBadges.length === 0 || !profileHasConsented;
    if (!isPersonalView && isRecentLearningAchievementsZero) return null;
    // https://learning.atlassian.com/catalog does not exist yet
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "most-recent-learning-achievements-container",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1ssb _2rko1vwy _189e1lkn _pg9o1osq",
            "_1f49kb7n",
            isRecentLearningAchievementsZero && "_1f4911wp"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
            title: "RECENT LEARNING ACHIEVEMENTS",
            children: isRecentLearningAchievementsZero ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
                message: "Complete a course to earn your first learning badge.",
                linkTo: (0, $77d0522707ddb581$export$9e4b135057b3ea75),
                linkType: "external",
                sendAnalyticsEvent: ()=>(0, $f1acffce3b3355bb$export$d2e1534e63f08fe5)(isPersonalView),
                linkText: "Start learning"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2334c837e4f7a704$export$6a861a37616558d7), {
                data: recentLearningAchievementBadges
            })
        })
    });
};
const $db6f4c15372022ff$var$boxStyles = null;
const $db6f4c15372022ff$var$recentLearningAchievementsStyle = null;
const $db6f4c15372022ff$var$emptyLearningAchievementsStyles = null;
var $db6f4c15372022ff$export$2e2bcd8739ae039 = $db6f4c15372022ff$var$MostRecentLearningAchievements;


const $2c6e1ee3a983034b$var$BadgesSummary = ({ internalId: internalId, profileHasConsented: profileHasConsented })=>{
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    const badgesResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5c5c0f6b82e5b280$export$15a2e43f9400c215), {
        internalId: internalId
    }).unified?.unifiedProfile;
    const forumsBadgesEdges = badgesResponse?.badges?.edges || [];
    const recentLearningAchievementBadgesEdges = badgesResponse?.learning?.recentLearningAchievementBadges?.edges || [];
    const forumsBadges = forumsBadgesEdges.map((edge)=>({
            ...edge?.node ?? {},
            src: edge?.node?.imageUrl
        }));
    const recentLearningAchievementBadges = recentLearningAchievementBadgesEdges.map((edge)=>({
            ...edge?.node ?? {},
            src: edge?.node?.imageUrl
        }));
    const totalForumsBadges = badgesResponse?.badges?.totalCount ?? 0;
    const totalLearningBadges = badgesResponse?.learning?.recentLearningAchievementBadges?.totalCount ?? 0;
    const totalNumberOfBadges = totalForumsBadges + totalLearningBadges;
    const titleParts = [
        totalNumberOfBadges || ""
    ];
    titleParts.push(totalNumberOfBadges === 1 ? "Badge" : "Badges");
    // ideally this scenario should never happen since one badge always exist, but this behavior has been seen due to bunchball connection issue
    if (!isPersonalView && !totalNumberOfBadges) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a44cdd096bb28cc$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b09ec013b267e49$export$2e2bcd8739ae039), {
                testId: "badges-summary-title",
                title: titleParts.join(" "),
                link: `/profile/${internalId}/badges`,
                linkText: totalNumberOfBadges ? "View all" : undefined,
                subtitle: isPersonalView ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Earn badges for your activity and learning achievements."
                }) : undefined,
                viewAllAnalyticsName: "viewAllBadges"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e11946d314b99a3d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _1bah1yb4 _1bsb1osq _zulpa5zd _iyz51bp4 _oe5xl6l0"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db6f4c15372022ff$export$2e2bcd8739ae039), {
                            isPersonalView: isPersonalView,
                            recentLearningAchievementBadges: recentLearningAchievementBadges,
                            profileHasConsented: profileHasConsented
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82301b01c60b3e85$export$2e2bcd8739ae039), {
                            isPersonalView: isPersonalView,
                            recentBadges: forumsBadges
                        })
                    ]
                })
            })
        ]
    });
};
var $2c6e1ee3a983034b$export$2e2bcd8739ae039 = $2c6e1ee3a983034b$var$BadgesSummary;
const $2c6e1ee3a983034b$var$avatarContainerStyles = null;


const $ae4baa668923fe79$export$38c827fac2a4f35c = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc406a32200a03b6$export$6cbf77c1b1e30396), {
                hasHeader: true
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c6e1ee3a983034b$export$2e2bcd8739ae039), {
                ...props
            })
        })
    });


const $f6626375f8a1be53$var$MainPanel = ({ data: data })=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const screenType = (0, $c46d6ad15b094b20$export$73fc99e2307f4d2e)();
    const unifiedProfile = data?.unified?.unifiedProfile;
    const profileData = unifiedProfile && `__fragments` in unifiedProfile ? (0, $eJz0f.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), data?.unified?.unifiedProfile) : null;
    const hasProfileOwnerConsent = (0, $0ee606ad15f500d3$export$7a0549bb2cff767b)(profileData?.isProfileOwnerConsented ?? undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _4cvr1y6m _zulpa5zd _oe5xhiv4"
        ]),
        children: [
            profileData?.aaid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55ef8b350847a858$export$c7495bd2aea2b6bc), {
                internalId: pathProfileId,
                learnId: profileData?.aaid,
                profileHasConsented: hasProfileOwnerConsent
            }) : null,
            hasProfileOwnerConsent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f585a3def3b9b54$export$cb8a57f28f16d7a9), {
                internalId: pathProfileId,
                accountId: profileData?.aaid
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae4baa668923fe79$export$38c827fac2a4f35c), {
                internalId: pathProfileId,
                profileHasConsented: hasProfileOwnerConsent
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5bc73569692f822$export$98371ac105153257), {
                internalId: pathProfileId
            }),
            screenType !== "desktop" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aeee297ca0427ed$export$9d29d4e8402ec840), {
                        internalId: pathProfileId,
                        isMainPanel: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4681896e22cc2dc9$export$2e2bcd8739ae039), {})
                ]
            }) : null
        ]
    });
};
var $f6626375f8a1be53$export$2e2bcd8739ae039 = $f6626375f8a1be53$var$MainPanel;
const $f6626375f8a1be53$var$containerStyles = null;


/* SidePanel.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");




/* AboutMe.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

/* Bio.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");

// state/index.ts
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $a0c8adad6df9bd62$var$OrderedMap(content) {
    this.content = content;
}
$a0c8adad6df9bd62$var$OrderedMap.prototype = {
    constructor: $a0c8adad6df9bd62$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $a0c8adad6df9bd62$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $a0c8adad6df9bd62$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $a0c8adad6df9bd62$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $a0c8adad6df9bd62$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $a0c8adad6df9bd62$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $a0c8adad6df9bd62$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $a0c8adad6df9bd62$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $a0c8adad6df9bd62$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $a0c8adad6df9bd62$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $a0c8adad6df9bd62$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$a0c8adad6df9bd62$var$OrderedMap.from = function(value) {
    if (value instanceof $a0c8adad6df9bd62$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $a0c8adad6df9bd62$var$OrderedMap(content);
};
var $a0c8adad6df9bd62$export$2e2bcd8739ae039 = $a0c8adad6df9bd62$var$OrderedMap;


function $d7ba288a9be229df$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $d7ba288a9be229df$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $d7ba288a9be229df$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $d7ba288a9be229df$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $d7ba288a9be229df$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $d7ba288a9be229df$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $d7ba288a9be229df$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $d7ba288a9be229df$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $d7ba288a9be229df$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $d7ba288a9be229df$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $d7ba288a9be229df$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $d7ba288a9be229df$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $d7ba288a9be229df$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $d7ba288a9be229df$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $d7ba288a9be229df$var$retIndex(0, pos);
        if (pos == this.size) return $d7ba288a9be229df$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $d7ba288a9be229df$var$retIndex(i + 1, end);
                return $d7ba288a9be229df$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $d7ba288a9be229df$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $d7ba288a9be229df$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $d7ba288a9be229df$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $d7ba288a9be229df$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $d7ba288a9be229df$export$ffb0004e005737fa.empty;
        if (nodes instanceof $d7ba288a9be229df$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $d7ba288a9be229df$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $d7ba288a9be229df$export$ffb0004e005737fa.empty = new $d7ba288a9be229df$export$ffb0004e005737fa([], 0);
const $d7ba288a9be229df$var$found = {
    index: 0,
    offset: 0
};
function $d7ba288a9be229df$var$retIndex(index, offset) {
    $d7ba288a9be229df$var$found.index = index;
    $d7ba288a9be229df$var$found.offset = offset;
    return $d7ba288a9be229df$var$found;
}
function $d7ba288a9be229df$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$d7ba288a9be229df$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$d7ba288a9be229df$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $d7ba288a9be229df$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $d7ba288a9be229df$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
        if (marks instanceof $d7ba288a9be229df$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $d7ba288a9be229df$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $d7ba288a9be229df$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $d7ba288a9be229df$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $d7ba288a9be229df$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $d7ba288a9be229df$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $d7ba288a9be229df$export$b3f2e2de3a8baa1e($d7ba288a9be229df$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $d7ba288a9be229df$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $d7ba288a9be229df$export$b3f2e2de3a8baa1e($d7ba288a9be229df$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $d7ba288a9be229df$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $d7ba288a9be229df$export$b3f2e2de3a8baa1e.empty = new $d7ba288a9be229df$export$b3f2e2de3a8baa1e($d7ba288a9be229df$export$ffb0004e005737fa.empty, 0, 0);
function $d7ba288a9be229df$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($d7ba288a9be229df$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $d7ba288a9be229df$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $d7ba288a9be229df$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $d7ba288a9be229df$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $d7ba288a9be229df$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $d7ba288a9be229df$export$6de0e778727af3f2("Inconsistent open depths");
    return $d7ba288a9be229df$var$replaceOuter($from, $to, slice, 0);
}
function $d7ba288a9be229df$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $d7ba288a9be229df$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $d7ba288a9be229df$var$close(node, $d7ba288a9be229df$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $d7ba288a9be229df$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $d7ba288a9be229df$var$prepareSliceForReplace(slice, $from);
        return $d7ba288a9be229df$var$close(node, $d7ba288a9be229df$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $d7ba288a9be229df$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $d7ba288a9be229df$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $d7ba288a9be229df$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $d7ba288a9be229df$var$checkJoin(node, $after.node(depth));
    return node;
}
function $d7ba288a9be229df$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $d7ba288a9be229df$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $d7ba288a9be229df$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$d7ba288a9be229df$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $d7ba288a9be229df$var$addNode($end.nodeBefore, target);
}
function $d7ba288a9be229df$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $d7ba288a9be229df$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $d7ba288a9be229df$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $d7ba288a9be229df$var$joinable($end, $to, depth + 1);
    let content = [];
    $d7ba288a9be229df$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $d7ba288a9be229df$var$checkJoin(openStart, openEnd);
        $d7ba288a9be229df$var$addNode($d7ba288a9be229df$var$close(openStart, $d7ba288a9be229df$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $d7ba288a9be229df$var$addNode($d7ba288a9be229df$var$close(openStart, $d7ba288a9be229df$var$replaceTwoWay($from, $start, depth + 1)), content);
        $d7ba288a9be229df$var$addRange($start, $end, depth, content);
        if (openEnd) $d7ba288a9be229df$var$addNode($d7ba288a9be229df$var$close(openEnd, $d7ba288a9be229df$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $d7ba288a9be229df$var$addRange($to, null, depth, content);
    return new $d7ba288a9be229df$export$ffb0004e005737fa(content);
}
function $d7ba288a9be229df$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $d7ba288a9be229df$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $d7ba288a9be229df$var$joinable($from, $to, depth + 1);
        $d7ba288a9be229df$var$addNode($d7ba288a9be229df$var$close(type, $d7ba288a9be229df$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $d7ba288a9be229df$var$addRange($to, null, depth, content);
    return new $d7ba288a9be229df$export$ffb0004e005737fa(content);
}
function $d7ba288a9be229df$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($d7ba288a9be229df$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $d7ba288a9be229df$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $d7ba288a9be229df$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $d7ba288a9be229df$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $d7ba288a9be229df$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $d7ba288a9be229df$var$resolveCache.set(doc, cache = new $d7ba288a9be229df$var$ResolveCache);
        let result = cache.elts[cache.i] = $d7ba288a9be229df$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $d7ba288a9be229df$var$resolveCacheSize;
        return result;
    }
}
class $d7ba288a9be229df$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $d7ba288a9be229df$var$resolveCacheSize = 12, $d7ba288a9be229df$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $d7ba288a9be229df$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $d7ba288a9be229df$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $d7ba288a9be229df$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $d7ba288a9be229df$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $d7ba288a9be229df$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $d7ba288a9be229df$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $d7ba288a9be229df$var$emptyAttrs) && $d7ba288a9be229df$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $d7ba288a9be229df$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $d7ba288a9be229df$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $d7ba288a9be229df$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $d7ba288a9be229df$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $d7ba288a9be229df$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $d7ba288a9be229df$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $d7ba288a9be229df$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $d7ba288a9be229df$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $d7ba288a9be229df$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $d7ba288a9be229df$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$d7ba288a9be229df$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $d7ba288a9be229df$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$d7ba288a9be229df$export$85c928794f8d04d4.prototype.text = undefined;
class $d7ba288a9be229df$var$TextNode extends $d7ba288a9be229df$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $d7ba288a9be229df$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $d7ba288a9be229df$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $d7ba288a9be229df$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $d7ba288a9be229df$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $d7ba288a9be229df$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $d7ba288a9be229df$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $d7ba288a9be229df$export$364ed450558d7ec4.empty;
        let expr = $d7ba288a9be229df$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $d7ba288a9be229df$var$dfa($d7ba288a9be229df$var$nfa(expr));
        $d7ba288a9be229df$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $d7ba288a9be229df$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $d7ba288a9be229df$export$364ed450558d7ec4.empty = new $d7ba288a9be229df$export$364ed450558d7ec4(true);
class $d7ba288a9be229df$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $d7ba288a9be229df$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($d7ba288a9be229df$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $d7ba288a9be229df$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($d7ba288a9be229df$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $d7ba288a9be229df$var$parseExprSubscript(stream) {
    let expr = $d7ba288a9be229df$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $d7ba288a9be229df$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $d7ba288a9be229df$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $d7ba288a9be229df$var$parseExprRange(stream, expr) {
    let min = $d7ba288a9be229df$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $d7ba288a9be229df$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $d7ba288a9be229df$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $d7ba288a9be229df$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $d7ba288a9be229df$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $d7ba288a9be229df$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $d7ba288a9be229df$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $d7ba288a9be229df$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $d7ba288a9be229df$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($d7ba288a9be229df$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $d7ba288a9be229df$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($d7ba288a9be229df$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $d7ba288a9be229df$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $d7ba288a9be229df$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($d7ba288a9be229df$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $d7ba288a9be229df$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $d7ba288a9be229df$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $d7ba288a9be229df$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $d7ba288a9be229df$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $d7ba288a9be229df$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $d7ba288a9be229df$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $d7ba288a9be229df$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $d7ba288a9be229df$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $d7ba288a9be229df$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $d7ba288a9be229df$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $d7ba288a9be229df$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $d7ba288a9be229df$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $d7ba288a9be229df$export$ffb0004e005737fa.from(content), $d7ba288a9be229df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $d7ba288a9be229df$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $d7ba288a9be229df$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $d7ba288a9be229df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $d7ba288a9be229df$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($d7ba288a9be229df$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $d7ba288a9be229df$export$85c928794f8d04d4(this, attrs, content.append(after), $d7ba288a9be229df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $d7ba288a9be229df$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $d7ba288a9be229df$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $d7ba288a9be229df$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $d7ba288a9be229df$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $d7ba288a9be229df$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $d7ba288a9be229df$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $d7ba288a9be229df$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $d7ba288a9be229df$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $d7ba288a9be229df$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $d7ba288a9be229df$export$c9d15bcfc6d42044(this, $d7ba288a9be229df$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $d7ba288a9be229df$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $d7ba288a9be229df$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $d7ba288a9be229df$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $a0c8adad6df9bd62$export$2e2bcd8739ae039).from(spec.nodes), instanceSpec.marks = (0, $a0c8adad6df9bd62$export$2e2bcd8739ae039).from(spec.marks || {}), this.nodes = $d7ba288a9be229df$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $d7ba288a9be229df$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $d7ba288a9be229df$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $d7ba288a9be229df$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $d7ba288a9be229df$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$d7ba288a9be229df$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$d7ba288a9be229df$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $d7ba288a9be229df$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $d7ba288a9be229df$var$TextNode(type, type.defaultAttrs, text, $d7ba288a9be229df$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $d7ba288a9be229df$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $d7ba288a9be229df$var$isTagRule(rule) {
    return rule.tag != null;
}
function $d7ba288a9be229df$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $d7ba288a9be229df$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($d7ba288a9be229df$var$isTagRule(rule)) this.tags.push(rule);
            else if ($d7ba288a9be229df$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $d7ba288a9be229df$var$ParseContext(this, options, false);
        context.addAll(dom, $d7ba288a9be229df$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $d7ba288a9be229df$var$ParseContext(this, options, true);
        context.addAll(dom, $d7ba288a9be229df$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $d7ba288a9be229df$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($d7ba288a9be229df$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $d7ba288a9be229df$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $d7ba288a9be229df$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $d7ba288a9be229df$export$1059c6e7d2ce5669(schema, $d7ba288a9be229df$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $d7ba288a9be229df$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $d7ba288a9be229df$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $d7ba288a9be229df$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $d7ba288a9be229df$var$OPT_PRESERVE_WS = 1, $d7ba288a9be229df$var$OPT_PRESERVE_WS_FULL = 2, $d7ba288a9be229df$var$OPT_OPEN_LEFT = 4;
function $d7ba288a9be229df$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $d7ba288a9be229df$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $d7ba288a9be229df$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $d7ba288a9be229df$var$OPT_PRESERVE_WS | $d7ba288a9be229df$var$OPT_PRESERVE_WS_FULL : base & ~$d7ba288a9be229df$var$OPT_OPEN_LEFT;
}
class $d7ba288a9be229df$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $d7ba288a9be229df$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($d7ba288a9be229df$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $d7ba288a9be229df$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $d7ba288a9be229df$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($d7ba288a9be229df$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$d7ba288a9be229df$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $d7ba288a9be229df$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $d7ba288a9be229df$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $d7ba288a9be229df$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $d7ba288a9be229df$var$NodeContext(topNode.type, topNode.attrs, $d7ba288a9be229df$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $d7ba288a9be229df$var$NodeContext(null, null, $d7ba288a9be229df$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $d7ba288a9be229df$var$NodeContext(parser.schema.topNodeType, null, $d7ba288a9be229df$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $d7ba288a9be229df$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $d7ba288a9be229df$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($d7ba288a9be229df$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $d7ba288a9be229df$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $d7ba288a9be229df$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($d7ba288a9be229df$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $d7ba288a9be229df$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $d7ba288a9be229df$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $d7ba288a9be229df$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $d7ba288a9be229df$var$OPT_OPEN_LEFT;
        let applyMarks = $d7ba288a9be229df$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $d7ba288a9be229df$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $d7ba288a9be229df$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $d7ba288a9be229df$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $d7ba288a9be229df$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $d7ba288a9be229df$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $d7ba288a9be229df$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $d7ba288a9be229df$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $d7ba288a9be229df$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $d7ba288a9be229df$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $d7ba288a9be229df$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $d7ba288a9be229df$var$renderSpec($d7ba288a9be229df$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $d7ba288a9be229df$var$renderSpec($d7ba288a9be229df$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $d7ba288a9be229df$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $d7ba288a9be229df$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $d7ba288a9be229df$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $d7ba288a9be229df$var$gatherToDOM(schema.marks);
    }
}
function $d7ba288a9be229df$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $d7ba288a9be229df$var$doc(options) {
    return options.document || window.document;
}
const $d7ba288a9be229df$var$suspiciousAttributeCache = new WeakMap();
function $d7ba288a9be229df$var$suspiciousAttributes(attrs) {
    let value = $d7ba288a9be229df$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $d7ba288a9be229df$var$suspiciousAttributeCache.set(attrs, value = $d7ba288a9be229df$var$suspiciousAttributesInner(attrs));
    return value;
}
function $d7ba288a9be229df$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $d7ba288a9be229df$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $d7ba288a9be229df$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $d7ba288a9be229df$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}



// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $62ded6a368f04ea2$var$lower16 = 0xffff;
const $62ded6a368f04ea2$var$factor16 = Math.pow(2, 16);
function $62ded6a368f04ea2$var$makeRecover(index, offset) {
    return index + offset * $62ded6a368f04ea2$var$factor16;
}
function $62ded6a368f04ea2$var$recoverIndex(value) {
    return value & $62ded6a368f04ea2$var$lower16;
}
function $62ded6a368f04ea2$var$recoverOffset(value) {
    return (value - (value & $62ded6a368f04ea2$var$lower16)) / $62ded6a368f04ea2$var$factor16;
}
const $62ded6a368f04ea2$var$DEL_BEFORE = 1, $62ded6a368f04ea2$var$DEL_AFTER = 2, $62ded6a368f04ea2$var$DEL_ACROSS = 4, $62ded6a368f04ea2$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $62ded6a368f04ea2$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $62ded6a368f04ea2$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($62ded6a368f04ea2$var$DEL_BEFORE | $62ded6a368f04ea2$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($62ded6a368f04ea2$var$DEL_AFTER | $62ded6a368f04ea2$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $62ded6a368f04ea2$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $62ded6a368f04ea2$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty) return $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $62ded6a368f04ea2$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $62ded6a368f04ea2$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $62ded6a368f04ea2$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $62ded6a368f04ea2$var$DEL_AFTER : pos == end ? $62ded6a368f04ea2$var$DEL_BEFORE : $62ded6a368f04ea2$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $62ded6a368f04ea2$var$DEL_SIDE;
                return new $62ded6a368f04ea2$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $62ded6a368f04ea2$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $62ded6a368f04ea2$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $62ded6a368f04ea2$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty : new $62ded6a368f04ea2$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty = new $62ded6a368f04ea2$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](https://prosemirror.net/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $62ded6a368f04ea2$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(maps, /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps ? maps.length : 0){
        this.mirror = mirror;
        this.from = from;
        this.to = to;
        this._maps = maps || [];
        this.ownData = !(maps || mirror);
    }
    /**
    The step maps in this mapping.
    */ get maps() {
        return this._maps;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $62ded6a368f04ea2$export$f5f785078011b62(this._maps, this.mirror, from, to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        if (!this.ownData) {
            this._maps = this._maps.slice();
            this.mirror = this.mirror && this.mirror.slice();
            this.ownData = true;
        }
        this.to = this._maps.push(map);
        if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $62ded6a368f04ea2$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this._maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this._maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this._maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $62ded6a368f04ea2$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $62ded6a368f04ea2$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $62ded6a368f04ea2$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $62ded6a368f04ea2$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $62ded6a368f04ea2$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $62ded6a368f04ea2$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $62ded6a368f04ea2$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $62ded6a368f04ea2$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $62ded6a368f04ea2$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $d7ba288a9be229df$export$6de0e778727af3f2)) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $62ded6a368f04ea2$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($62ded6a368f04ea2$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $d7ba288a9be229df$export$ffb0004e005737fa).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $62ded6a368f04ea2$export$d24ba56b0e3464a9 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $62ded6a368f04ea2$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $62ded6a368f04ea2$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $62ded6a368f04ea2$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $62ded6a368f04ea2$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $62ded6a368f04ea2$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("addMark", $62ded6a368f04ea2$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $62ded6a368f04ea2$export$94150db1311f67a9 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $62ded6a368f04ea2$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $62ded6a368f04ea2$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $62ded6a368f04ea2$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $62ded6a368f04ea2$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $62ded6a368f04ea2$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("removeMark", $62ded6a368f04ea2$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $62ded6a368f04ea2$export$adefd16c402fee4e extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $62ded6a368f04ea2$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $62ded6a368f04ea2$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $62ded6a368f04ea2$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $62ded6a368f04ea2$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $62ded6a368f04ea2$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("addNodeMark", $62ded6a368f04ea2$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $62ded6a368f04ea2$export$fdf7d1dc10724da2 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $62ded6a368f04ea2$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $62ded6a368f04ea2$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $62ded6a368f04ea2$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("removeNodeMark", $62ded6a368f04ea2$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $62ded6a368f04ea2$export$5c860b2e74034756 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $62ded6a368f04ea2$var$contentBetween(doc, this.from, this.to)) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $62ded6a368f04ea2$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $62ded6a368f04ea2$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $62ded6a368f04ea2$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
    }
    merge(other) {
        if (!(other instanceof $62ded6a368f04ea2$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty : new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $62ded6a368f04ea2$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty : new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $62ded6a368f04ea2$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $62ded6a368f04ea2$export$5c860b2e74034756(json.from, json.to, (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).fromJSON(schema, json.slice), !!json.structure);
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("replace", $62ded6a368f04ea2$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $62ded6a368f04ea2$export$444ba800d6024a98 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($62ded6a368f04ea2$var$contentBetween(doc, this.from, this.gapFrom) || $62ded6a368f04ea2$var$contentBetween(doc, this.gapTo, this.to))) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $62ded6a368f04ea2$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $62ded6a368f04ea2$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $62ded6a368f04ea2$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $62ded6a368f04ea2$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("replaceAround", $62ded6a368f04ea2$export$444ba800d6024a98);
function $62ded6a368f04ea2$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $62ded6a368f04ea2$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $62ded6a368f04ea2$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $62ded6a368f04ea2$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $62ded6a368f04ea2$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $d7ba288a9be229df$export$b6a78689043c6521)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $62ded6a368f04ea2$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $62ded6a368f04ea2$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $62ded6a368f04ea2$export$5c860b2e74034756(cur, end, (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $62ded6a368f04ea2$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $62ded6a368f04ea2$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, true);
        tr.replace(cur, cur, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $62ded6a368f04ea2$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $62ded6a368f04ea2$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$62ded6a368f04ea2$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $62ded6a368f04ea2$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $62ded6a368f04ea2$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $62ded6a368f04ea2$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $62ded6a368f04ea2$var$findWrappingOutside(range, nodeType);
    let inner = around && $62ded6a368f04ea2$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($62ded6a368f04ea2$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($62ded6a368f04ea2$var$withAttrs));
}
function $62ded6a368f04ea2$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $62ded6a368f04ea2$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $62ded6a368f04ea2$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $62ded6a368f04ea2$var$wrap(tr, range, wrappers) {
    let content = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $62ded6a368f04ea2$export$444ba800d6024a98(start, end, start, end, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(content, 0, 0), wrappers.length, true));
}
function $62ded6a368f04ea2$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $62ded6a368f04ea2$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $62ded6a368f04ea2$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $62ded6a368f04ea2$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $62ded6a368f04ea2$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $62ded6a368f04ea2$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $62ded6a368f04ea2$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $62ded6a368f04ea2$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $62ded6a368f04ea2$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $62ded6a368f04ea2$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $62ded6a368f04ea2$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $62ded6a368f04ea2$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $62ded6a368f04ea2$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, after = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $62ded6a368f04ea2$export$5c860b2e74034756(pos, pos, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $62ded6a368f04ea2$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $62ded6a368f04ea2$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $62ded6a368f04ea2$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $62ded6a368f04ea2$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $62ded6a368f04ea2$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $62ded6a368f04ea2$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $62ded6a368f04ea2$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $62ded6a368f04ea2$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $62ded6a368f04ea2$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $62ded6a368f04ea2$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $62ded6a368f04ea2$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $62ded6a368f04ea2$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $62ded6a368f04ea2$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $62ded6a368f04ea2$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $62ded6a368f04ea2$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($62ded6a368f04ea2$var$fitsTrivially($from, $to, slice)) return new $62ded6a368f04ea2$export$5c860b2e74034756(from, to, slice);
    return new $62ded6a368f04ea2$var$Fitter($from, $to, slice).fit();
}
function $62ded6a368f04ea2$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $62ded6a368f04ea2$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(content, openStart, openEnd);
        if (moveInline > -1) return new $62ded6a368f04ea2$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $62ded6a368f04ea2$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $62ded6a368f04ea2$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $62ded6a368f04ea2$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $62ded6a368f04ea2$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($62ded6a368f04ea2$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $62ded6a368f04ea2$var$addToFragment(this.placed, frontierDepth, (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty : new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$62ded6a368f04ea2$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $62ded6a368f04ea2$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $62ded6a368f04ea2$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $62ded6a368f04ea2$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $62ded6a368f04ea2$var$addToFragment(this.placed, this.depth, (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, true);
        if (add.childCount) this.placed = $62ded6a368f04ea2$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $62ded6a368f04ea2$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($62ded6a368f04ea2$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $62ded6a368f04ea2$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($62ded6a368f04ea2$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $62ded6a368f04ea2$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $62ded6a368f04ea2$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $62ded6a368f04ea2$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, true));
    }
    return node.copy(frag);
}
function $62ded6a368f04ea2$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$62ded6a368f04ea2$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $62ded6a368f04ea2$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $62ded6a368f04ea2$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $62ded6a368f04ea2$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($62ded6a368f04ea2$var$fitsTrivially($from, $to, slice)) return tr.step(new $62ded6a368f04ea2$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $62ded6a368f04ea2$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $62ded6a368f04ea2$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($62ded6a368f04ea2$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $62ded6a368f04ea2$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($62ded6a368f04ea2$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, true));
    }
    return fragment;
}
function $62ded6a368f04ea2$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $62ded6a368f04ea2$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(node), 0, 0));
}
function $62ded6a368f04ea2$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $62ded6a368f04ea2$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $62ded6a368f04ea2$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $62ded6a368f04ea2$export$626399c38172f669 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $62ded6a368f04ea2$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $62ded6a368f04ea2$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $62ded6a368f04ea2$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $62ded6a368f04ea2$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("attr", $62ded6a368f04ea2$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $62ded6a368f04ea2$export$f50707b396300ac9 extends $62ded6a368f04ea2$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $62ded6a368f04ea2$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $62ded6a368f04ea2$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $62ded6a368f04ea2$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $62ded6a368f04ea2$export$f50707b396300ac9(json.attr, json.value);
    }
}
$62ded6a368f04ea2$export$fd55ce593607084a.jsonID("docAttr", $62ded6a368f04ea2$export$f50707b396300ac9);
/**
@internal
*/ let $62ded6a368f04ea2$export$88cc3a1dfce48dd3 = class extends Error {
};
$62ded6a368f04ea2$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$62ded6a368f04ea2$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$62ded6a368f04ea2$export$88cc3a1dfce48dd3.prototype.constructor = $62ded6a368f04ea2$export$88cc3a1dfce48dd3;
$62ded6a368f04ea2$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $62ded6a368f04ea2$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $62ded6a368f04ea2$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $62ded6a368f04ea2$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
        let step = $62ded6a368f04ea2$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $62ded6a368f04ea2$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $62ded6a368f04ea2$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $62ded6a368f04ea2$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $62ded6a368f04ea2$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $62ded6a368f04ea2$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $62ded6a368f04ea2$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $62ded6a368f04ea2$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $62ded6a368f04ea2$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $62ded6a368f04ea2$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $62ded6a368f04ea2$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $62ded6a368f04ea2$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or all marks of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        let node = this.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at position " + pos);
        if (mark instanceof (0, $d7ba288a9be229df$export$c9d15bcfc6d42044)) {
            if (mark.isInSet(node.marks)) this.step(new $62ded6a368f04ea2$export$fdf7d1dc10724da2(pos, mark));
        } else {
            let set = node.marks, found, steps = [];
            while(found = mark.isInSet(set)){
                steps.push(new $62ded6a368f04ea2$export$fdf7d1dc10724da2(pos, found));
                set = found.removeFromSet(set);
            }
            for(let i = steps.length - 1; i >= 0; i--)this.step(steps[i]);
        }
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split (with the outermost nodes coming first).
    */ split(pos, depth = 1, typesAfter) {
        $62ded6a368f04ea2$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $62ded6a368f04ea2$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $62ded6a368f04ea2$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $62ded6a368f04ea2$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}


const $c286ea535d926598$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $c286ea535d926598$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $c286ea535d926598$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty : content);
            if (i == 0) $c286ea535d926598$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $c286ea535d926598$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $c286ea535d926598$export$c2b25f346d19bcbb($pos) : $c286ea535d926598$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $c286ea535d926598$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c286ea535d926598$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c286ea535d926598$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $c286ea535d926598$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c286ea535d926598$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $c286ea535d926598$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c286ea535d926598$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $c286ea535d926598$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $c286ea535d926598$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $c286ea535d926598$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $c286ea535d926598$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$c286ea535d926598$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $c286ea535d926598$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $c286ea535d926598$var$warnedAboutTextSelection = false;
function $c286ea535d926598$var$checkTextSelection($pos) {
    if (!$c286ea535d926598$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $c286ea535d926598$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $c286ea535d926598$export$c2b25f346d19bcbb extends $c286ea535d926598$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $c286ea535d926598$var$checkTextSelection($anchor);
        $c286ea535d926598$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $c286ea535d926598$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $c286ea535d926598$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
        super.replace(tr, content);
        if (content == (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $c286ea535d926598$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $c286ea535d926598$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $c286ea535d926598$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $c286ea535d926598$export$52baac22726c72bf.findFrom($head, bias, true) || $c286ea535d926598$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $c286ea535d926598$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($c286ea535d926598$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c286ea535d926598$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $c286ea535d926598$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$c286ea535d926598$export$52baac22726c72bf.jsonID("text", $c286ea535d926598$export$c2b25f346d19bcbb);
class $c286ea535d926598$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $c286ea535d926598$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $c286ea535d926598$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $c286ea535d926598$export$e2940151ac854c0b extends $c286ea535d926598$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $c286ea535d926598$export$52baac22726c72bf.near($pos);
        return new $c286ea535d926598$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $c286ea535d926598$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $c286ea535d926598$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $c286ea535d926598$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $c286ea535d926598$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$c286ea535d926598$export$e2940151ac854c0b.prototype.visible = false;
$c286ea535d926598$export$52baac22726c72bf.jsonID("node", $c286ea535d926598$export$e2940151ac854c0b);
class $c286ea535d926598$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $c286ea535d926598$var$TextBookmark(pos, pos) : new $c286ea535d926598$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $c286ea535d926598$export$e2940151ac854c0b.isSelectable(node)) return new $c286ea535d926598$export$e2940151ac854c0b($pos);
        return $c286ea535d926598$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $c286ea535d926598$export$c15d9ba76bdbcd95 extends $c286ea535d926598$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
        if (content == (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $c286ea535d926598$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $c286ea535d926598$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $c286ea535d926598$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $c286ea535d926598$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $c286ea535d926598$var$AllBookmark;
    }
}
$c286ea535d926598$export$52baac22726c72bf.jsonID("all", $c286ea535d926598$export$c15d9ba76bdbcd95);
const $c286ea535d926598$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $c286ea535d926598$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $c286ea535d926598$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $c286ea535d926598$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $c286ea535d926598$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $c286ea535d926598$export$e2940151ac854c0b.isSelectable(child)) return $c286ea535d926598$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $c286ea535d926598$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $62ded6a368f04ea2$export$5c860b2e74034756) || step instanceof (0, $62ded6a368f04ea2$export$444ba800d6024a98))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($c286ea535d926598$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $c286ea535d926598$var$UPDATED_SEL = 1, $c286ea535d926598$var$UPDATED_MARKS = 2, $c286ea535d926598$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $c286ea535d926598$export$febc5573c75cefb0 extends (0, $62ded6a368f04ea2$export$563a914cafbdc389) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $c286ea535d926598$var$UPDATED_SEL) & ~$c286ea535d926598$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $c286ea535d926598$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $c286ea535d926598$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $d7ba288a9be229df$export$c9d15bcfc6d42044).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $c286ea535d926598$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$c286ea535d926598$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $d7ba288a9be229df$export$c9d15bcfc6d42044).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($c286ea535d926598$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $c286ea535d926598$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $c286ea535d926598$var$UPDATED_SCROLL) > 0;
    }
}
function $c286ea535d926598$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $c286ea535d926598$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $c286ea535d926598$var$bind(desc.init, self);
        this.apply = $c286ea535d926598$var$bind(desc.apply, self);
    }
}
const $c286ea535d926598$var$baseFields = [
    new $c286ea535d926598$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $c286ea535d926598$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $c286ea535d926598$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $c286ea535d926598$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $c286ea535d926598$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $c286ea535d926598$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $c286ea535d926598$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $c286ea535d926598$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $c286ea535d926598$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $c286ea535d926598$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $c286ea535d926598$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $c286ea535d926598$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $c286ea535d926598$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $c286ea535d926598$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $c286ea535d926598$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == "object") for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $c286ea535d926598$var$Configuration(config.schema, config.plugins);
        let instance = new $c286ea535d926598$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $d7ba288a9be229df$export$85c928794f8d04d4).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $c286ea535d926598$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $c286ea535d926598$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $c286ea535d926598$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $c286ea535d926598$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $c286ea535d926598$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $c286ea535d926598$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $c286ea535d926598$var$keys = Object.create(null);
function $c286ea535d926598$var$createKey(name) {
    if (name in $c286ea535d926598$var$keys) return name + "$" + ++$c286ea535d926598$var$keys[name];
    $c286ea535d926598$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $c286ea535d926598$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $c286ea535d926598$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}




// view/index.ts



const $0e46bf1b6d57978f$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $0e46bf1b6d57978f$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $0e46bf1b6d57978f$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $0e46bf1b6d57978f$var$textRange = function(node, from, to) {
    let range = $0e46bf1b6d57978f$var$reusedRange || ($0e46bf1b6d57978f$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $0e46bf1b6d57978f$var$clearReusedRange = function() {
    $0e46bf1b6d57978f$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $0e46bf1b6d57978f$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($0e46bf1b6d57978f$var$scanFor(node, off, targetNode, targetOff, -1) || $0e46bf1b6d57978f$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $0e46bf1b6d57978f$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $0e46bf1b6d57978f$var$scanFor(node, off, targetNode, targetOff, dir) {
    var _a;
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $0e46bf1b6d57978f$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $0e46bf1b6d57978f$var$hasBlockDesc(node) || $0e46bf1b6d57978f$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $0e46bf1b6d57978f$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (child.nodeType == 1 && child.contentEditable == "false") {
                if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;
                else return false;
            } else {
                node = child;
                off = dir < 0 ? $0e46bf1b6d57978f$var$nodeSize(node) : 0;
            }
        } else return false;
    }
}
function $0e46bf1b6d57978f$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $0e46bf1b6d57978f$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $0e46bf1b6d57978f$var$nodeSize(node);
        } else if (node.parentNode && !$0e46bf1b6d57978f$var$hasBlockDesc(node)) {
            offset = $0e46bf1b6d57978f$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $0e46bf1b6d57978f$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$0e46bf1b6d57978f$var$hasBlockDesc(node)) {
            offset = $0e46bf1b6d57978f$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $0e46bf1b6d57978f$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $0e46bf1b6d57978f$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $0e46bf1b6d57978f$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $0e46bf1b6d57978f$var$nodeSize(node);
    }
}
function $0e46bf1b6d57978f$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $0e46bf1b6d57978f$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $0e46bf1b6d57978f$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $0e46bf1b6d57978f$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $0e46bf1b6d57978f$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $0e46bf1b6d57978f$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($0e46bf1b6d57978f$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($0e46bf1b6d57978f$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $0e46bf1b6d57978f$var$nav = typeof navigator != "undefined" ? navigator : null;
const $0e46bf1b6d57978f$var$doc = typeof document != "undefined" ? document : null;
const $0e46bf1b6d57978f$var$agent = $0e46bf1b6d57978f$var$nav && $0e46bf1b6d57978f$var$nav.userAgent || "";
const $0e46bf1b6d57978f$var$ie_edge = /Edge\/(\d+)/.exec($0e46bf1b6d57978f$var$agent);
const $0e46bf1b6d57978f$var$ie_upto10 = /MSIE \d/.exec($0e46bf1b6d57978f$var$agent);
const $0e46bf1b6d57978f$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($0e46bf1b6d57978f$var$agent);
const $0e46bf1b6d57978f$var$ie = !!($0e46bf1b6d57978f$var$ie_upto10 || $0e46bf1b6d57978f$var$ie_11up || $0e46bf1b6d57978f$var$ie_edge);
const $0e46bf1b6d57978f$var$ie_version = $0e46bf1b6d57978f$var$ie_upto10 ? document.documentMode : $0e46bf1b6d57978f$var$ie_11up ? +$0e46bf1b6d57978f$var$ie_11up[1] : $0e46bf1b6d57978f$var$ie_edge ? +$0e46bf1b6d57978f$var$ie_edge[1] : 0;
const $0e46bf1b6d57978f$var$gecko = !$0e46bf1b6d57978f$var$ie && /gecko\/(\d+)/i.test($0e46bf1b6d57978f$var$agent);
$0e46bf1b6d57978f$var$gecko && (/Firefox\/(\d+)/.exec($0e46bf1b6d57978f$var$agent) || [
    0,
    0
])[1];
const $0e46bf1b6d57978f$var$_chrome = !$0e46bf1b6d57978f$var$ie && /Chrome\/(\d+)/.exec($0e46bf1b6d57978f$var$agent);
const $0e46bf1b6d57978f$var$chrome = !!$0e46bf1b6d57978f$var$_chrome;
const $0e46bf1b6d57978f$var$chrome_version = $0e46bf1b6d57978f$var$_chrome ? +$0e46bf1b6d57978f$var$_chrome[1] : 0;
const $0e46bf1b6d57978f$var$safari = !$0e46bf1b6d57978f$var$ie && !!$0e46bf1b6d57978f$var$nav && /Apple Computer/.test($0e46bf1b6d57978f$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $0e46bf1b6d57978f$var$ios = $0e46bf1b6d57978f$var$safari && (/Mobile\/\w+/.test($0e46bf1b6d57978f$var$agent) || !!$0e46bf1b6d57978f$var$nav && $0e46bf1b6d57978f$var$nav.maxTouchPoints > 2);
const $0e46bf1b6d57978f$var$mac = $0e46bf1b6d57978f$var$ios || ($0e46bf1b6d57978f$var$nav ? /Mac/.test($0e46bf1b6d57978f$var$nav.platform) : false);
const $0e46bf1b6d57978f$var$windows = $0e46bf1b6d57978f$var$nav ? /Win/.test($0e46bf1b6d57978f$var$nav.platform) : false;
const $0e46bf1b6d57978f$var$android = /Android \d/.test($0e46bf1b6d57978f$var$agent);
const $0e46bf1b6d57978f$var$webkit = !!$0e46bf1b6d57978f$var$doc && "webkitFontSmoothing" in $0e46bf1b6d57978f$var$doc.documentElement.style;
const $0e46bf1b6d57978f$var$webkit_version = $0e46bf1b6d57978f$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $0e46bf1b6d57978f$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $0e46bf1b6d57978f$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $0e46bf1b6d57978f$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $0e46bf1b6d57978f$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;;){
        if (!parent) break;
        if (parent.nodeType != 1) {
            parent = $0e46bf1b6d57978f$var$parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $0e46bf1b6d57978f$var$windowRect(doc) : $0e46bf1b6d57978f$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $0e46bf1b6d57978f$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $0e46bf1b6d57978f$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $0e46bf1b6d57978f$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $0e46bf1b6d57978f$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $0e46bf1b6d57978f$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $0e46bf1b6d57978f$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $0e46bf1b6d57978f$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $0e46bf1b6d57978f$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $0e46bf1b6d57978f$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos)) break;
        parent = pos == "absolute" ? parent.offsetParent : $0e46bf1b6d57978f$var$parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $0e46bf1b6d57978f$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $0e46bf1b6d57978f$var$scrollStack(view.dom)
    };
}
function $0e46bf1b6d57978f$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $0e46bf1b6d57978f$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $0e46bf1b6d57978f$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $0e46bf1b6d57978f$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $0e46bf1b6d57978f$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $0e46bf1b6d57978f$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $0e46bf1b6d57978f$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($0e46bf1b6d57978f$var$preventScrollSupported) return dom.focus($0e46bf1b6d57978f$var$preventScrollSupported);
    let stored = $0e46bf1b6d57978f$var$scrollStack(dom);
    dom.focus($0e46bf1b6d57978f$var$preventScrollSupported == null ? {
        get preventScroll () {
            $0e46bf1b6d57978f$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$0e46bf1b6d57978f$var$preventScrollSupported) {
        $0e46bf1b6d57978f$var$preventScrollSupported = false;
        $0e46bf1b6d57978f$var$restoreScrollStack(stored, 0);
    }
}
function $0e46bf1b6d57978f$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $0e46bf1b6d57978f$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $0e46bf1b6d57978f$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $0e46bf1b6d57978f$var$findOffsetInNode(closest, coordsClosest);
}
function $0e46bf1b6d57978f$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $0e46bf1b6d57978f$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($0e46bf1b6d57978f$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $0e46bf1b6d57978f$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $0e46bf1b6d57978f$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $0e46bf1b6d57978f$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $0e46bf1b6d57978f$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $0e46bf1b6d57978f$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $0e46bf1b6d57978f$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($0e46bf1b6d57978f$var$inRect(coords, rect)) return $0e46bf1b6d57978f$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $0e46bf1b6d57978f$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $0e46bf1b6d57978f$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$0e46bf1b6d57978f$var$inRect(coords, box)) return null;
        elt = $0e46bf1b6d57978f$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($0e46bf1b6d57978f$var$safari) {
        for(let p = elt; node && p; p = $0e46bf1b6d57978f$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $0e46bf1b6d57978f$var$targetKludge(elt, coords);
    if (node) {
        if ($0e46bf1b6d57978f$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($0e46bf1b6d57978f$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $0e46bf1b6d57978f$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $0e46bf1b6d57978f$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $0e46bf1b6d57978f$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $0e46bf1b6d57978f$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($0e46bf1b6d57978f$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $0e46bf1b6d57978f$var$nonZero) || target.getBoundingClientRect();
}
const $0e46bf1b6d57978f$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $0e46bf1b6d57978f$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $0e46bf1b6d57978f$var$webkit || $0e46bf1b6d57978f$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($0e46bf1b6d57978f$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $0e46bf1b6d57978f$var$singleRect($0e46bf1b6d57978f$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($0e46bf1b6d57978f$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $0e46bf1b6d57978f$var$singleRect($0e46bf1b6d57978f$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $0e46bf1b6d57978f$var$singleRect($0e46bf1b6d57978f$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $0e46bf1b6d57978f$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $0e46bf1b6d57978f$var$flattenV($0e46bf1b6d57978f$var$singleRect($0e46bf1b6d57978f$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $0e46bf1b6d57978f$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $0e46bf1b6d57978f$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $0e46bf1b6d57978f$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $0e46bf1b6d57978f$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $0e46bf1b6d57978f$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $0e46bf1b6d57978f$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $0e46bf1b6d57978f$var$textRange(before, $0e46bf1b6d57978f$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $0e46bf1b6d57978f$var$flattenV($0e46bf1b6d57978f$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $0e46bf1b6d57978f$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $0e46bf1b6d57978f$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $0e46bf1b6d57978f$var$flattenV($0e46bf1b6d57978f$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $0e46bf1b6d57978f$var$flattenV($0e46bf1b6d57978f$var$singleRect(node.nodeType == 3 ? $0e46bf1b6d57978f$var$textRange(node) : node, -side), side >= 0);
}
function $0e46bf1b6d57978f$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $0e46bf1b6d57978f$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $0e46bf1b6d57978f$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $0e46bf1b6d57978f$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $0e46bf1b6d57978f$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $0e46bf1b6d57978f$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $0e46bf1b6d57978f$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $0e46bf1b6d57978f$var$maybeRTL = /[\u0590-\u08ac]/;
function $0e46bf1b6d57978f$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$0e46bf1b6d57978f$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $0e46bf1b6d57978f$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $0e46bf1b6d57978f$var$cachedState = null;
let $0e46bf1b6d57978f$var$cachedDir = null;
let $0e46bf1b6d57978f$var$cachedResult = false;
function $0e46bf1b6d57978f$var$endOfTextblock(view, state, dir) {
    if ($0e46bf1b6d57978f$var$cachedState == state && $0e46bf1b6d57978f$var$cachedDir == dir) return $0e46bf1b6d57978f$var$cachedResult;
    $0e46bf1b6d57978f$var$cachedState = state;
    $0e46bf1b6d57978f$var$cachedDir = dir;
    return $0e46bf1b6d57978f$var$cachedResult = dir == "up" || dir == "down" ? $0e46bf1b6d57978f$var$endOfTextblockVertical(view, state, dir) : $0e46bf1b6d57978f$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $0e46bf1b6d57978f$var$NOT_DIRTY = 0, $0e46bf1b6d57978f$var$CHILD_DIRTY = 1, $0e46bf1b6d57978f$var$CONTENT_DIRTY = 2, $0e46bf1b6d57978f$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $0e46bf1b6d57978f$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $0e46bf1b6d57978f$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $0e46bf1b6d57978f$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $0e46bf1b6d57978f$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $0e46bf1b6d57978f$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $0e46bf1b6d57978f$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $0e46bf1b6d57978f$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $0e46bf1b6d57978f$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $0e46bf1b6d57978f$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($0e46bf1b6d57978f$var$gecko || $0e46bf1b6d57978f$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $0e46bf1b6d57978f$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($0e46bf1b6d57978f$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $0e46bf1b6d57978f$var$safari) && $0e46bf1b6d57978f$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $0e46bf1b6d57978f$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $0e46bf1b6d57978f$var$CONTENT_DIRTY : $0e46bf1b6d57978f$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $0e46bf1b6d57978f$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $0e46bf1b6d57978f$var$CONTENT_DIRTY : $0e46bf1b6d57978f$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $0e46bf1b6d57978f$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $0e46bf1b6d57978f$var$CONTENT_DIRTY : $0e46bf1b6d57978f$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    get ignoreForSelection() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $0e46bf1b6d57978f$var$WidgetViewDesc extends $0e46bf1b6d57978f$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $0e46bf1b6d57978f$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get ignoreForSelection() {
        return !!this.widget.type.spec.relaxedSide;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $0e46bf1b6d57978f$var$CompositionViewDesc extends $0e46bf1b6d57978f$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $0e46bf1b6d57978f$var$MarkViewDesc extends $0e46bf1b6d57978f$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $d7ba288a9be229df$export$3476b78f8f5a8b72).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $0e46bf1b6d57978f$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $0e46bf1b6d57978f$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $0e46bf1b6d57978f$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $0e46bf1b6d57978f$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $0e46bf1b6d57978f$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $0e46bf1b6d57978f$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $0e46bf1b6d57978f$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $0e46bf1b6d57978f$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $0e46bf1b6d57978f$var$NodeViewDesc extends $0e46bf1b6d57978f$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $d7ba288a9be229df$export$3476b78f8f5a8b72).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $0e46bf1b6d57978f$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $0e46bf1b6d57978f$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $0e46bf1b6d57978f$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $0e46bf1b6d57978f$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $0e46bf1b6d57978f$var$NOT_DIRTY && node.eq(this.node) && $0e46bf1b6d57978f$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $0e46bf1b6d57978f$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $0e46bf1b6d57978f$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $d7ba288a9be229df$export$c9d15bcfc6d42044).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $0e46bf1b6d57978f$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $0e46bf1b6d57978f$var$renderDescs(this.contentDOM, this.children, view);
            if ($0e46bf1b6d57978f$var$ios) $0e46bf1b6d57978f$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $0e46bf1b6d57978f$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $0e46bf1b6d57978f$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $0e46bf1b6d57978f$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $0e46bf1b6d57978f$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $0e46bf1b6d57978f$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($0e46bf1b6d57978f$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $0e46bf1b6d57978f$var$patchOuterDeco(this.dom, this.nodeDOM, $0e46bf1b6d57978f$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $0e46bf1b6d57978f$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $0e46bf1b6d57978f$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $0e46bf1b6d57978f$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $0e46bf1b6d57978f$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $0e46bf1b6d57978f$var$TextViewDesc extends $0e46bf1b6d57978f$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $0e46bf1b6d57978f$var$NODE_DIRTY || this.dirty != $0e46bf1b6d57978f$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $0e46bf1b6d57978f$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $0e46bf1b6d57978f$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $0e46bf1b6d57978f$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $0e46bf1b6d57978f$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $0e46bf1b6d57978f$var$TrailingHackViewDesc extends $0e46bf1b6d57978f$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $0e46bf1b6d57978f$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $0e46bf1b6d57978f$var$CustomNodeViewDesc extends $0e46bf1b6d57978f$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $0e46bf1b6d57978f$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $0e46bf1b6d57978f$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $0e46bf1b6d57978f$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $0e46bf1b6d57978f$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $0e46bf1b6d57978f$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $0e46bf1b6d57978f$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $0e46bf1b6d57978f$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$0e46bf1b6d57978f$var$OuterDecoLevel.prototype = Object.create(null);
const $0e46bf1b6d57978f$var$noDeco = [
    new $0e46bf1b6d57978f$var$OuterDecoLevel
];
function $0e46bf1b6d57978f$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $0e46bf1b6d57978f$var$noDeco;
    let top = needsWrap ? $0e46bf1b6d57978f$var$noDeco[0] : new $0e46bf1b6d57978f$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $0e46bf1b6d57978f$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $0e46bf1b6d57978f$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $0e46bf1b6d57978f$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $0e46bf1b6d57978f$var$noDeco && curComputed == $0e46bf1b6d57978f$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $0e46bf1b6d57978f$var$noDeco[0];
                curDOM = parent;
            }
        }
        $0e46bf1b6d57978f$var$patchAttributes(curDOM, prev || $0e46bf1b6d57978f$var$noDeco[0], deco);
    }
    return curDOM;
}
function $0e46bf1b6d57978f$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $0e46bf1b6d57978f$var$applyOuterDeco(dom, deco, node) {
    return $0e46bf1b6d57978f$var$patchOuterDeco(dom, dom, $0e46bf1b6d57978f$var$noDeco, $0e46bf1b6d57978f$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $0e46bf1b6d57978f$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $0e46bf1b6d57978f$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $0e46bf1b6d57978f$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $0e46bf1b6d57978f$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $0e46bf1b6d57978f$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $0e46bf1b6d57978f$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $0e46bf1b6d57978f$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $0e46bf1b6d57978f$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $0e46bf1b6d57978f$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $0e46bf1b6d57978f$var$NODE_DIRTY && $0e46bf1b6d57978f$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $0e46bf1b6d57978f$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $0e46bf1b6d57978f$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$0e46bf1b6d57978f$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $0e46bf1b6d57978f$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $0e46bf1b6d57978f$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $0e46bf1b6d57978f$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $0e46bf1b6d57978f$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $0e46bf1b6d57978f$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($0e46bf1b6d57978f$var$safari || $0e46bf1b6d57978f$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $0e46bf1b6d57978f$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $0e46bf1b6d57978f$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $0e46bf1b6d57978f$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $0e46bf1b6d57978f$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $0e46bf1b6d57978f$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($0e46bf1b6d57978f$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $0e46bf1b6d57978f$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $0e46bf1b6d57978f$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $0e46bf1b6d57978f$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $0e46bf1b6d57978f$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($0e46bf1b6d57978f$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $0e46bf1b6d57978f$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $c286ea535d926598$export$e2940151ac854c0b)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $0e46bf1b6d57978f$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $0e46bf1b6d57978f$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $0e46bf1b6d57978f$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $0e46bf1b6d57978f$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $0e46bf1b6d57978f$var$syncNodeSelection(view, sel);
    if (!$0e46bf1b6d57978f$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $0e46bf1b6d57978f$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $0e46bf1b6d57978f$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $0e46bf1b6d57978f$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($0e46bf1b6d57978f$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $0e46bf1b6d57978f$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $0e46bf1b6d57978f$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($0e46bf1b6d57978f$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $0e46bf1b6d57978f$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $0e46bf1b6d57978f$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $0e46bf1b6d57978f$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $0e46bf1b6d57978f$var$brokenSelectBetweenUneditable = $0e46bf1b6d57978f$var$safari || $0e46bf1b6d57978f$var$chrome && $0e46bf1b6d57978f$var$chrome_version < 63;
function $0e46bf1b6d57978f$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($0e46bf1b6d57978f$var$safari && after && after.contentEditable == "false") return $0e46bf1b6d57978f$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $0e46bf1b6d57978f$var$setEditable(after);
        else if (before) return $0e46bf1b6d57978f$var$setEditable(before);
    }
}
function $0e46bf1b6d57978f$var$setEditable(element) {
    element.contentEditable = "true";
    if ($0e46bf1b6d57978f$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $0e46bf1b6d57978f$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $0e46bf1b6d57978f$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$0e46bf1b6d57978f$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $0e46bf1b6d57978f$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $0e46bf1b6d57978f$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $0e46bf1b6d57978f$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $c286ea535d926598$export$e2940151ac854c0b)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $0e46bf1b6d57978f$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $0e46bf1b6d57978f$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $0e46bf1b6d57978f$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $0e46bf1b6d57978f$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $c286ea535d926598$export$c2b25f346d19bcbb).between($anchor, $head, bias);
}
function $0e46bf1b6d57978f$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $0e46bf1b6d57978f$var$hasSelection(view);
}
function $0e46bf1b6d57978f$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $0e46bf1b6d57978f$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $0e46bf1b6d57978f$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $0e46bf1b6d57978f$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $c286ea535d926598$export$52baac22726c72bf).findFrom($start, dir);
}
function $0e46bf1b6d57978f$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $0e46bf1b6d57978f$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $0e46bf1b6d57978f$var$apply(view, new (0, $c286ea535d926598$export$c2b25f346d19bcbb)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $0e46bf1b6d57978f$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $c286ea535d926598$export$e2940151ac854c0b)) return $0e46bf1b6d57978f$var$apply(view, next);
            return false;
        } else if (!($0e46bf1b6d57978f$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(node)) return $0e46bf1b6d57978f$var$apply(view, new (0, $c286ea535d926598$export$e2940151ac854c0b)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($0e46bf1b6d57978f$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $0e46bf1b6d57978f$var$apply(view, new (0, $c286ea535d926598$export$c2b25f346d19bcbb)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $c286ea535d926598$export$e2940151ac854c0b) && sel.node.isInline) return $0e46bf1b6d57978f$var$apply(view, new (0, $c286ea535d926598$export$c2b25f346d19bcbb)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $0e46bf1b6d57978f$var$moveSelectionBlock(view.state, dir);
        if (next) return $0e46bf1b6d57978f$var$apply(view, next);
        return false;
    }
}
function $0e46bf1b6d57978f$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $0e46bf1b6d57978f$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $0e46bf1b6d57978f$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $0e46bf1b6d57978f$var$skipIgnoredNodesBefore(view) : $0e46bf1b6d57978f$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $0e46bf1b6d57978f$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($0e46bf1b6d57978f$var$gecko && node.nodeType == 1 && offset < $0e46bf1b6d57978f$var$nodeLen(node) && $0e46bf1b6d57978f$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($0e46bf1b6d57978f$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($0e46bf1b6d57978f$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $0e46bf1b6d57978f$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $0e46bf1b6d57978f$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $0e46bf1b6d57978f$var$nodeLen(node);
            }
        }
    }
    if (force) $0e46bf1b6d57978f$var$setSelFocus(view, node, offset);
    else if (moveNode) $0e46bf1b6d57978f$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $0e46bf1b6d57978f$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $0e46bf1b6d57978f$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($0e46bf1b6d57978f$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($0e46bf1b6d57978f$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $0e46bf1b6d57978f$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $0e46bf1b6d57978f$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $0e46bf1b6d57978f$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $0e46bf1b6d57978f$var$setSelFocus(view, moveNode, moveOffset);
}
function $0e46bf1b6d57978f$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $0e46bf1b6d57978f$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$0e46bf1b6d57978f$var$hasBlockDesc(node)){
        offset = $0e46bf1b6d57978f$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $0e46bf1b6d57978f$var$textNodeBefore(node, offset) {
    while(node && !offset && !$0e46bf1b6d57978f$var$hasBlockDesc(node)){
        offset = $0e46bf1b6d57978f$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $0e46bf1b6d57978f$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $0e46bf1b6d57978f$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $0e46bf1b6d57978f$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($0e46bf1b6d57978f$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $0e46bf1b6d57978f$var$selectionToDOM(view);
    }, 50);
}
function $0e46bf1b6d57978f$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($0e46bf1b6d57978f$var$chrome || $0e46bf1b6d57978f$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $0e46bf1b6d57978f$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($0e46bf1b6d57978f$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $0e46bf1b6d57978f$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $c286ea535d926598$export$e2940151ac854c0b)) return $0e46bf1b6d57978f$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $c286ea535d926598$export$c15d9ba76bdbcd95) ? (0, $c286ea535d926598$export$52baac22726c72bf).near(side, dir) : (0, $c286ea535d926598$export$52baac22726c72bf).findFrom(side, dir);
        return beyond ? $0e46bf1b6d57978f$var$apply(view, beyond) : false;
    }
    return false;
}
function $0e46bf1b6d57978f$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $0e46bf1b6d57978f$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $0e46bf1b6d57978f$var$safariDownArrowBug(view) {
    if (!$0e46bf1b6d57978f$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $0e46bf1b6d57978f$var$switchEditable(view, child, "true");
        setTimeout(()=>$0e46bf1b6d57978f$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $0e46bf1b6d57978f$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $0e46bf1b6d57978f$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $0e46bf1b6d57978f$var$getMods(event);
    if (code == 8 || $0e46bf1b6d57978f$var$mac && code == 72 && mods == "c") return $0e46bf1b6d57978f$var$stopNativeHorizontalDelete(view, -1) || $0e46bf1b6d57978f$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $0e46bf1b6d57978f$var$mac && code == 68 && mods == "c") return $0e46bf1b6d57978f$var$stopNativeHorizontalDelete(view, 1) || $0e46bf1b6d57978f$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $0e46bf1b6d57978f$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $0e46bf1b6d57978f$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $0e46bf1b6d57978f$var$selectHorizontally(view, dir, mods) || $0e46bf1b6d57978f$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $0e46bf1b6d57978f$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $0e46bf1b6d57978f$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $0e46bf1b6d57978f$var$selectHorizontally(view, dir, mods) || $0e46bf1b6d57978f$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $0e46bf1b6d57978f$var$mac && code == 80 && mods == "c") return $0e46bf1b6d57978f$var$selectVertically(view, -1, mods) || $0e46bf1b6d57978f$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $0e46bf1b6d57978f$var$mac && code == 78 && mods == "c") return $0e46bf1b6d57978f$var$safariDownArrowBug(view) || $0e46bf1b6d57978f$var$selectVertically(view, 1, mods) || $0e46bf1b6d57978f$var$skipIgnoredNodes(view, 1);
    else if (mods == ($0e46bf1b6d57978f$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $0e46bf1b6d57978f$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $d7ba288a9be229df$export$3476b78f8f5a8b72).fromSchema(view.state.schema);
    let doc = $0e46bf1b6d57978f$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $0e46bf1b6d57978f$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $0e46bf1b6d57978f$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $d7ba288a9be229df$export$3476b78f8f5a8b72).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $0e46bf1b6d57978f$var$readHTML(html);
        if ($0e46bf1b6d57978f$var$webkit) $0e46bf1b6d57978f$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $d7ba288a9be229df$export$1059c6e7d2ce5669).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$0e46bf1b6d57978f$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $0e46bf1b6d57978f$var$addContext($0e46bf1b6d57978f$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).maxOpen($0e46bf1b6d57978f$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $0e46bf1b6d57978f$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $0e46bf1b6d57978f$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $0e46bf1b6d57978f$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $0e46bf1b6d57978f$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $0e46bf1b6d57978f$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $0e46bf1b6d57978f$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(result);
    }
    return fragment;
}
function $0e46bf1b6d57978f$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $0e46bf1b6d57978f$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $0e46bf1b6d57978f$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $d7ba288a9be229df$export$ffb0004e005737fa).from($0e46bf1b6d57978f$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $0e46bf1b6d57978f$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $0e46bf1b6d57978f$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, true);
    return node.copy(fragment.append(fill));
}
function $0e46bf1b6d57978f$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $0e46bf1b6d57978f$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $0e46bf1b6d57978f$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($0e46bf1b6d57978f$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)($0e46bf1b6d57978f$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $0e46bf1b6d57978f$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $0e46bf1b6d57978f$var$_detachedDoc = null;
function $0e46bf1b6d57978f$var$detachedDoc() {
    return $0e46bf1b6d57978f$var$_detachedDoc || ($0e46bf1b6d57978f$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $0e46bf1b6d57978f$var$_policy = null;
function $0e46bf1b6d57978f$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$0e46bf1b6d57978f$var$_policy) $0e46bf1b6d57978f$var$_policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $0e46bf1b6d57978f$var$_policy.createHTML(html);
}
function $0e46bf1b6d57978f$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $0e46bf1b6d57978f$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $0e46bf1b6d57978f$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $0e46bf1b6d57978f$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $0e46bf1b6d57978f$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($0e46bf1b6d57978f$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\xa0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $0e46bf1b6d57978f$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $0e46bf1b6d57978f$var$handlers = {};
const $0e46bf1b6d57978f$var$editHandlers = {};
const $0e46bf1b6d57978f$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $0e46bf1b6d57978f$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: "",
            button: 0
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $0e46bf1b6d57978f$var$initInput(view) {
    for(let event in $0e46bf1b6d57978f$var$handlers){
        let handler = $0e46bf1b6d57978f$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($0e46bf1b6d57978f$var$eventBelongsToView(view, event) && !$0e46bf1b6d57978f$var$runCustomHandler(view, event) && (view.editable || !(event.type in $0e46bf1b6d57978f$var$editHandlers))) handler(view, event);
        }, $0e46bf1b6d57978f$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($0e46bf1b6d57978f$var$safari) view.dom.addEventListener("input", ()=>null);
    $0e46bf1b6d57978f$var$ensureListeners(view);
}
function $0e46bf1b6d57978f$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $0e46bf1b6d57978f$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $0e46bf1b6d57978f$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$0e46bf1b6d57978f$var$runCustomHandler(view, event));
    });
}
function $0e46bf1b6d57978f$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $0e46bf1b6d57978f$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $0e46bf1b6d57978f$var$dispatchEvent(view, event) {
    if (!$0e46bf1b6d57978f$var$runCustomHandler(view, event) && $0e46bf1b6d57978f$var$handlers[event.type] && (view.editable || !(event.type in $0e46bf1b6d57978f$var$editHandlers))) $0e46bf1b6d57978f$var$handlers[event.type](view, event);
}
$0e46bf1b6d57978f$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($0e46bf1b6d57978f$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($0e46bf1b6d57978f$var$android && $0e46bf1b6d57978f$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($0e46bf1b6d57978f$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $0e46bf1b6d57978f$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $0e46bf1b6d57978f$var$captureKeyDown(view, event)) event.preventDefault();
    else $0e46bf1b6d57978f$var$setSelectionOrigin(view, "key");
};
$0e46bf1b6d57978f$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$0e46bf1b6d57978f$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($0e46bf1b6d57978f$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $0e46bf1b6d57978f$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        let deflt = ()=>view.state.tr.insertText(text).scrollIntoView();
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text, deflt))) view.dispatch(deflt());
        event.preventDefault();
    }
};
function $0e46bf1b6d57978f$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $0e46bf1b6d57978f$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $0e46bf1b6d57978f$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $0e46bf1b6d57978f$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $0e46bf1b6d57978f$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(node)) {
        $0e46bf1b6d57978f$var$updateSelection(view, new (0, $c286ea535d926598$export$e2940151ac854c0b)($pos), "pointer");
        return true;
    }
    return false;
}
function $0e46bf1b6d57978f$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $c286ea535d926598$export$e2940151ac854c0b)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $0e46bf1b6d57978f$var$updateSelection(view, (0, $c286ea535d926598$export$e2940151ac854c0b).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $0e46bf1b6d57978f$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $0e46bf1b6d57978f$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $0e46bf1b6d57978f$var$selectClickedNode(view, inside) : $0e46bf1b6d57978f$var$selectClickedLeaf(view, inside));
}
function $0e46bf1b6d57978f$var$handleDoubleClick(view, pos, inside, event) {
    return $0e46bf1b6d57978f$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $0e46bf1b6d57978f$var$handleTripleClick(view, pos, inside, event) {
    return $0e46bf1b6d57978f$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $0e46bf1b6d57978f$var$defaultTripleClick(view, inside, event);
}
function $0e46bf1b6d57978f$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $0e46bf1b6d57978f$var$updateSelection(view, (0, $c286ea535d926598$export$c2b25f346d19bcbb).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $0e46bf1b6d57978f$var$updateSelection(view, (0, $c286ea535d926598$export$c2b25f346d19bcbb).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(node)) $0e46bf1b6d57978f$var$updateSelection(view, (0, $c286ea535d926598$export$e2940151ac854c0b).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $0e46bf1b6d57978f$var$forceDOMFlush(view) {
    return $0e46bf1b6d57978f$var$endComposition(view);
}
const $0e46bf1b6d57978f$var$selectNodeModifier = $0e46bf1b6d57978f$var$mac ? "metaKey" : "ctrlKey";
$0e46bf1b6d57978f$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $0e46bf1b6d57978f$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $0e46bf1b6d57978f$var$isNear(event, view.input.lastClick) && !event[$0e46bf1b6d57978f$var$selectNodeModifier] && view.input.lastClick.button == event.button) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type,
        button: event.button
    };
    let pos = view.posAtCoords($0e46bf1b6d57978f$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $0e46bf1b6d57978f$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $0e46bf1b6d57978f$var$handleDoubleClick : $0e46bf1b6d57978f$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $0e46bf1b6d57978f$var$setSelectionOrigin(view, "pointer");
};
class $0e46bf1b6d57978f$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$0e46bf1b6d57978f$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $c286ea535d926598$export$e2940151ac854c0b) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $0e46bf1b6d57978f$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $0e46bf1b6d57978f$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$0e46bf1b6d57978f$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($0e46bf1b6d57978f$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $0e46bf1b6d57978f$var$setSelectionOrigin(this.view, "pointer");
        else if ($0e46bf1b6d57978f$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $0e46bf1b6d57978f$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $0e46bf1b6d57978f$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $0e46bf1b6d57978f$var$updateSelection(this.view, (0, $c286ea535d926598$export$52baac22726c72bf).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $0e46bf1b6d57978f$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $0e46bf1b6d57978f$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$0e46bf1b6d57978f$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $0e46bf1b6d57978f$var$forceDOMFlush(view);
    $0e46bf1b6d57978f$var$setSelectionOrigin(view, "pointer");
};
$0e46bf1b6d57978f$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $0e46bf1b6d57978f$var$setSelectionOrigin(view, "pointer");
};
$0e46bf1b6d57978f$var$handlers.contextmenu = (view)=>$0e46bf1b6d57978f$var$forceDOMFlush(view);
function $0e46bf1b6d57978f$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($0e46bf1b6d57978f$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $0e46bf1b6d57978f$var$timeoutComposition = $0e46bf1b6d57978f$var$android ? 5000 : -1;
$0e46bf1b6d57978f$var$editHandlers.compositionstart = $0e46bf1b6d57978f$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $0e46bf1b6d57978f$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $0e46bf1b6d57978f$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($0e46bf1b6d57978f$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $0e46bf1b6d57978f$var$scheduleComposeEnd(view, $0e46bf1b6d57978f$var$timeoutComposition);
};
$0e46bf1b6d57978f$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $0e46bf1b6d57978f$var$scheduleComposeEnd(view, 20);
    }
};
function $0e46bf1b6d57978f$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$0e46bf1b6d57978f$var$endComposition(view), delay);
}
function $0e46bf1b6d57978f$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $0e46bf1b6d57978f$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $0e46bf1b6d57978f$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $0e46bf1b6d57978f$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $0e46bf1b6d57978f$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $0e46bf1b6d57978f$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $0e46bf1b6d57978f$var$endComposition(view, restarting = false) {
    if ($0e46bf1b6d57978f$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $0e46bf1b6d57978f$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $0e46bf1b6d57978f$var$selectionFromDOM(view), cur = view.state.selection;
        if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $0e46bf1b6d57978f$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $0e46bf1b6d57978f$var$brokenClipboardAPI = $0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version < 15 || $0e46bf1b6d57978f$var$ios && $0e46bf1b6d57978f$var$webkit_version < 604;
$0e46bf1b6d57978f$var$handlers.copy = $0e46bf1b6d57978f$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $0e46bf1b6d57978f$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $0e46bf1b6d57978f$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $0e46bf1b6d57978f$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $0e46bf1b6d57978f$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $0e46bf1b6d57978f$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $0e46bf1b6d57978f$var$doPaste(view, target.value, null, plain, event);
        else $0e46bf1b6d57978f$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $0e46bf1b6d57978f$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $0e46bf1b6d57978f$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty))) return true;
    if (!slice) return false;
    let singleNode = $0e46bf1b6d57978f$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $0e46bf1b6d57978f$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$0e46bf1b6d57978f$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$0e46bf1b6d57978f$var$android) return;
    let data = $0e46bf1b6d57978f$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $0e46bf1b6d57978f$var$doPaste(view, $0e46bf1b6d57978f$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $0e46bf1b6d57978f$var$capturePaste(view, event);
};
class $0e46bf1b6d57978f$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $0e46bf1b6d57978f$var$dragCopyModifier = $0e46bf1b6d57978f$var$mac ? "altKey" : "ctrlKey";
function $0e46bf1b6d57978f$var$dragMoves(view, event) {
    let moves = view.someProp("dragCopies", (test)=>!test(event));
    return moves != null ? moves : !event[$0e46bf1b6d57978f$var$dragCopyModifier];
}
$0e46bf1b6d57978f$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($0e46bf1b6d57978f$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $c286ea535d926598$export$e2940151ac854c0b) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $c286ea535d926598$export$e2940151ac854c0b).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $c286ea535d926598$export$e2940151ac854c0b).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $0e46bf1b6d57978f$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$0e46bf1b6d57978f$var$chrome || $0e46bf1b6d57978f$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($0e46bf1b6d57978f$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$0e46bf1b6d57978f$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $0e46bf1b6d57978f$var$Dragging(slice, $0e46bf1b6d57978f$var$dragMoves(view, event), node);
};
$0e46bf1b6d57978f$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$0e46bf1b6d57978f$var$editHandlers.dragover = $0e46bf1b6d57978f$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$0e46bf1b6d57978f$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($0e46bf1b6d57978f$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $0e46bf1b6d57978f$var$parseFromClipboard(view, $0e46bf1b6d57978f$var$getText(event.dataTransfer), $0e46bf1b6d57978f$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && $0e46bf1b6d57978f$var$dragMoves(view, event));
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $62ded6a368f04ea2$export$2819d598d048fc9c)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $c286ea535d926598$export$e2940151ac854c0b)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($0e46bf1b6d57978f$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$0e46bf1b6d57978f$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $0e46bf1b6d57978f$var$selectionToDOM(view);
        }, 20);
    }
};
$0e46bf1b6d57978f$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$0e46bf1b6d57978f$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($0e46bf1b6d57978f$var$chrome && $0e46bf1b6d57978f$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $0e46bf1b6d57978f$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $0e46bf1b6d57978f$var$editHandlers)$0e46bf1b6d57978f$var$handlers[prop] = $0e46bf1b6d57978f$var$editHandlers[prop];
function $0e46bf1b6d57978f$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $0e46bf1b6d57978f$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $0e46bf1b6d57978f$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $0e46bf1b6d57978f$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $0e46bf1b6d57978f$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $0e46bf1b6d57978f$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $0e46bf1b6d57978f$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $0e46bf1b6d57978f$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $0e46bf1b6d57978f$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $0e46bf1b6d57978f$var$InlineType && $0e46bf1b6d57978f$var$compareObjs(this.attrs, other.attrs) && $0e46bf1b6d57978f$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $0e46bf1b6d57978f$var$InlineType;
    }
    destroy() {}
}
class $0e46bf1b6d57978f$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $0e46bf1b6d57978f$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $0e46bf1b6d57978f$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $0e46bf1b6d57978f$var$NodeType && $0e46bf1b6d57978f$var$compareObjs(this.attrs, other.attrs) && $0e46bf1b6d57978f$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $0e46bf1b6d57978f$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $0e46bf1b6d57978f$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $0e46bf1b6d57978f$export$10e30b733df217ea(pos, pos, new $0e46bf1b6d57978f$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $0e46bf1b6d57978f$export$10e30b733df217ea(from, to, new $0e46bf1b6d57978f$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $0e46bf1b6d57978f$export$10e30b733df217ea(from, to, new $0e46bf1b6d57978f$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $0e46bf1b6d57978f$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $0e46bf1b6d57978f$var$WidgetType;
    }
}
const $0e46bf1b6d57978f$var$none = [], $0e46bf1b6d57978f$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $0e46bf1b6d57978f$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $0e46bf1b6d57978f$var$none;
        this.children = children.length ? children : $0e46bf1b6d57978f$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $0e46bf1b6d57978f$var$buildTree(decorations, doc, 0, $0e46bf1b6d57978f$var$noSpec) : $0e46bf1b6d57978f$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $0e46bf1b6d57978f$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $0e46bf1b6d57978f$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $0e46bf1b6d57978f$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $0e46bf1b6d57978f$export$93bf62eb445cec98(newLocal.sort($0e46bf1b6d57978f$var$byPos), $0e46bf1b6d57978f$var$none) : $0e46bf1b6d57978f$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $0e46bf1b6d57978f$var$empty) return $0e46bf1b6d57978f$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $0e46bf1b6d57978f$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $0e46bf1b6d57978f$var$buildTree(found, childNode, baseOffset + 1, $0e46bf1b6d57978f$var$noSpec));
            childIndex += 3;
        });
        let local = $0e46bf1b6d57978f$var$moveSpans(childIndex ? $0e46bf1b6d57978f$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $0e46bf1b6d57978f$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($0e46bf1b6d57978f$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $0e46bf1b6d57978f$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $0e46bf1b6d57978f$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $0e46bf1b6d57978f$export$93bf62eb445cec98(local, children) : $0e46bf1b6d57978f$var$empty;
    }
    forChild(offset, node) {
        if (this == $0e46bf1b6d57978f$var$empty) return this;
        if (node.isLeaf) return $0e46bf1b6d57978f$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $0e46bf1b6d57978f$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $0e46bf1b6d57978f$export$93bf62eb445cec98(local.sort($0e46bf1b6d57978f$var$byPos), $0e46bf1b6d57978f$var$none);
            return child ? new $0e46bf1b6d57978f$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $0e46bf1b6d57978f$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $0e46bf1b6d57978f$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $0e46bf1b6d57978f$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $0e46bf1b6d57978f$var$empty) return $0e46bf1b6d57978f$var$none;
        if (node.inlineContent || !this.local.some($0e46bf1b6d57978f$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $0e46bf1b6d57978f$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $0e46bf1b6d57978f$export$93bf62eb445cec98.empty = new $0e46bf1b6d57978f$export$93bf62eb445cec98([], []);
/**
@internal
*/ $0e46bf1b6d57978f$export$93bf62eb445cec98.removeOverlap = $0e46bf1b6d57978f$var$removeOverlap;
const $0e46bf1b6d57978f$var$empty = $0e46bf1b6d57978f$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $0e46bf1b6d57978f$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $0e46bf1b6d57978f$var$noSpec));
        return $0e46bf1b6d57978f$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $0e46bf1b6d57978f$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $0e46bf1b6d57978f$var$empty) continue;
            if (result instanceof $0e46bf1b6d57978f$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $0e46bf1b6d57978f$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $0e46bf1b6d57978f$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $0e46bf1b6d57978f$var$removeOverlap(sorted ? result : result.sort($0e46bf1b6d57978f$var$byPos)) : $0e46bf1b6d57978f$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $0e46bf1b6d57978f$var$empty;
            case 1:
                return members[0];
            default:
                return new $0e46bf1b6d57978f$var$DecorationGroup(members.every((m)=>m instanceof $0e46bf1b6d57978f$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $0e46bf1b6d57978f$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $0e46bf1b6d57978f$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $0e46bf1b6d57978f$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $0e46bf1b6d57978f$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $0e46bf1b6d57978f$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $0e46bf1b6d57978f$export$93bf62eb445cec98(newLocal.sort($0e46bf1b6d57978f$var$byPos), children);
}
function $0e46bf1b6d57978f$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $0e46bf1b6d57978f$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $0e46bf1b6d57978f$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $0e46bf1b6d57978f$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $0e46bf1b6d57978f$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $0e46bf1b6d57978f$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $0e46bf1b6d57978f$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $0e46bf1b6d57978f$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $0e46bf1b6d57978f$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $0e46bf1b6d57978f$var$moveSpans(hasNulls ? $0e46bf1b6d57978f$var$withoutNulls(spans) : spans, -offset).sort($0e46bf1b6d57978f$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $0e46bf1b6d57978f$export$93bf62eb445cec98(locals, children) : $0e46bf1b6d57978f$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $0e46bf1b6d57978f$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $0e46bf1b6d57978f$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $0e46bf1b6d57978f$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $0e46bf1b6d57978f$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $0e46bf1b6d57978f$var$insertAhead(array, i, deco) {
    while(i < array.length && $0e46bf1b6d57978f$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $0e46bf1b6d57978f$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $0e46bf1b6d57978f$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($0e46bf1b6d57978f$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $0e46bf1b6d57978f$var$DecorationGroup.from(found);
}
const $0e46bf1b6d57978f$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $0e46bf1b6d57978f$var$useCharData = $0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11;
class $0e46bf1b6d57978f$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $0e46bf1b6d57978f$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $0e46bf1b6d57978f$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($0e46bf1b6d57978f$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $0e46bf1b6d57978f$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$0e46bf1b6d57978f$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $0e46bf1b6d57978f$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $0e46bf1b6d57978f$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $0e46bf1b6d57978f$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $0e46bf1b6d57978f$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $0e46bf1b6d57978f$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($0e46bf1b6d57978f$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $0e46bf1b6d57978f$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $0e46bf1b6d57978f$var$selectionCollapsed(sel) && (readSel = $0e46bf1b6d57978f$var$selectionFromDOM(view)) && readSel.eq((0, $c286ea535d926598$export$52baac22726c72bf).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $0e46bf1b6d57978f$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $0e46bf1b6d57978f$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $0e46bf1b6d57978f$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $0e46bf1b6d57978f$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $0e46bf1b6d57978f$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $0e46bf1b6d57978f$var$cssChecked = new WeakMap();
let $0e46bf1b6d57978f$var$cssCheckWarned = false;
function $0e46bf1b6d57978f$var$checkCSS(view) {
    if ($0e46bf1b6d57978f$var$cssChecked.has(view)) return;
    $0e46bf1b6d57978f$var$cssChecked.set(view, null);
    if ([
        "normal",
        "nowrap",
        "pre-line"
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $0e46bf1b6d57978f$var$gecko;
        if ($0e46bf1b6d57978f$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $0e46bf1b6d57978f$var$cssCheckWarned = true;
    }
}
function $0e46bf1b6d57978f$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($0e46bf1b6d57978f$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $0e46bf1b6d57978f$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $0e46bf1b6d57978f$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $0e46bf1b6d57978f$var$rangeToSelectionRange(view, found) : null;
}
function $0e46bf1b6d57978f$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $0e46bf1b6d57978f$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$0e46bf1b6d57978f$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($0e46bf1b6d57978f$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $d7ba288a9be229df$export$1059c6e7d2ce5669).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $0e46bf1b6d57978f$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $0e46bf1b6d57978f$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($0e46bf1b6d57978f$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $0e46bf1b6d57978f$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $0e46bf1b6d57978f$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $0e46bf1b6d57978f$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $0e46bf1b6d57978f$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($0e46bf1b6d57978f$var$chrome && $0e46bf1b6d57978f$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $0e46bf1b6d57978f$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $0e46bf1b6d57978f$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $0e46bf1b6d57978f$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($0e46bf1b6d57978f$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $0e46bf1b6d57978f$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$0e46bf1b6d57978f$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $0e46bf1b6d57978f$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $0e46bf1b6d57978f$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \xa0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($0e46bf1b6d57978f$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", "")) && (nextSel = (0, $c286ea535d926598$export$52baac22726c72bf).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head > $from.pos) && view.someProp("handleKeyDown", (f)=>f(view, $0e46bf1b6d57978f$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $0e46bf1b6d57978f$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $0e46bf1b6d57978f$var$keyEvent(8, "Backspace")))) {
        if ($0e46bf1b6d57978f$var$android && $0e46bf1b6d57978f$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($0e46bf1b6d57978f$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($0e46bf1b6d57978f$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $0e46bf1b6d57978f$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let mkTr = (base)=>{
        let tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = $0e46bf1b6d57978f$var$resolveSelection(view, tr.doc, parse.sel);
            // Chrome will sometimes, during composition, report the
            // selection in the wrong place. If it looks like that is
            // happening, don't update the selection.
            // Edge just doesn't move the cursor forward when you start typing
            // in an empty block or between br nodes.
            if (sel && !($0e46bf1b6d57978f$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $0e46bf1b6d57978f$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
        }
        if (compositionID) tr.setMeta("composition", compositionID);
        return tr.scrollIntoView();
    };
    let markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($0e46bf1b6d57978f$var$ie && $0e46bf1b6d57978f$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$0e46bf1b6d57978f$var$selectionToDOM(view), 20);
            }
            let tr = mkTr(view.state.tr.delete(chFrom, chTo));
            let marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            if (marks) tr.ensureMarks(marks);
            view.dispatch(tr);
        } else if (change.endA == change.endB && (markChange = $0e46bf1b6d57978f$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            let tr = mkTr(view.state.tr);
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
            view.dispatch(tr);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            let deflt = ()=>mkTr(view.state.tr.insertText(text, chFrom, chTo));
            if (!view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text, deflt))) view.dispatch(deflt());
        }
    } else view.dispatch(mkTr());
}
function $0e46bf1b6d57978f$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $0e46bf1b6d57978f$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $0e46bf1b6d57978f$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $0e46bf1b6d57978f$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $0e46bf1b6d57978f$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($0e46bf1b6d57978f$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $0e46bf1b6d57978f$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $0e46bf1b6d57978f$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $0e46bf1b6d57978f$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $0e46bf1b6d57978f$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $0e46bf1b6d57978f$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $0e46bf1b6d57978f$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $0e46bf1b6d57978f$export$5d42ca91c11c9e4d = $0e46bf1b6d57978f$var$parseFromClipboard;
/**
@internal
*/ const $0e46bf1b6d57978f$export$76b14d3c719c32fc = $0e46bf1b6d57978f$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $0e46bf1b6d57978f$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $0e46bf1b6d57978f$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($0e46bf1b6d57978f$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $0e46bf1b6d57978f$var$getEditable(this);
        $0e46bf1b6d57978f$var$updateCursorWrapper(this);
        this.nodeViews = $0e46bf1b6d57978f$var$buildNodeViews(this);
        this.docView = $0e46bf1b6d57978f$var$docViewDesc(this.state.doc, $0e46bf1b6d57978f$var$computeDocDeco(this), $0e46bf1b6d57978f$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $0e46bf1b6d57978f$var$DOMObserver(this, (from, to, typeOver, added)=>$0e46bf1b6d57978f$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $0e46bf1b6d57978f$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $0e46bf1b6d57978f$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($0e46bf1b6d57978f$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $0e46bf1b6d57978f$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $0e46bf1b6d57978f$var$buildNodeViews(this);
            if ($0e46bf1b6d57978f$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $0e46bf1b6d57978f$var$ensureListeners(this);
        this.editable = $0e46bf1b6d57978f$var$getEditable(this);
        $0e46bf1b6d57978f$var$updateCursorWrapper(this);
        let innerDeco = $0e46bf1b6d57978f$var$viewDecorations(this), outerDeco = $0e46bf1b6d57978f$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $0e46bf1b6d57978f$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($0e46bf1b6d57978f$var$ie || $0e46bf1b6d57978f$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $0e46bf1b6d57978f$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $0e46bf1b6d57978f$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $0e46bf1b6d57978f$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $0e46bf1b6d57978f$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $0e46bf1b6d57978f$var$anchorInRightPlace(this))) $0e46bf1b6d57978f$var$selectionToDOM(this, forceSelUpdate);
            else {
                $0e46bf1b6d57978f$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $0e46bf1b6d57978f$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $c286ea535d926598$export$e2940151ac854c0b)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $0e46bf1b6d57978f$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $0e46bf1b6d57978f$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $0e46bf1b6d57978f$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $c286ea535d926598$export$e2940151ac854c0b).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($0e46bf1b6d57978f$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == "false") return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $0e46bf1b6d57978f$var$focusPreventScroll(this.dom);
        $0e46bf1b6d57978f$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $0e46bf1b6d57978f$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $0e46bf1b6d57978f$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $0e46bf1b6d57978f$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $0e46bf1b6d57978f$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $0e46bf1b6d57978f$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */ serializeForClipboard(slice) {
        return $0e46bf1b6d57978f$var$serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $0e46bf1b6d57978f$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $0e46bf1b6d57978f$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $0e46bf1b6d57978f$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $0e46bf1b6d57978f$var$dispatchEvent(this, event);
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $0e46bf1b6d57978f$var$safari && this.root.nodeType === 11 && $0e46bf1b6d57978f$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $0e46bf1b6d57978f$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
$0e46bf1b6d57978f$export$eece2fccabbb77c5.prototype.dispatch = function(tr) {
    let dispatchTransaction = this._props.dispatchTransaction;
    if (dispatchTransaction) dispatchTransaction.call(this, tr);
    else this.updateState(this.state.apply(tr));
};
function $0e46bf1b6d57978f$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $0e46bf1b6d57978f$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $0e46bf1b6d57978f$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $0e46bf1b6d57978f$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $0e46bf1b6d57978f$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $0e46bf1b6d57978f$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $0e46bf1b6d57978f$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $0e46bf1b6d57978f$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $0e46bf1b6d57978f$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}




// keymap/index.ts
var $68b9e7c405929963$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $68b9e7c405929963$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $68b9e7c405929963$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $68b9e7c405929963$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $68b9e7c405929963$var$i = 0; $68b9e7c405929963$var$i < 10; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[48 + $68b9e7c405929963$var$i] = $68b9e7c405929963$export$e2253033e6e1df16[96 + $68b9e7c405929963$var$i] = String($68b9e7c405929963$var$i);
// The function keys
for(var $68b9e7c405929963$var$i = 1; $68b9e7c405929963$var$i <= 24; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i + 111] = "F" + $68b9e7c405929963$var$i;
// And the alphabetic keys
for(var $68b9e7c405929963$var$i = 65; $68b9e7c405929963$var$i <= 90; $68b9e7c405929963$var$i++){
    $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i + 32);
    $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $68b9e7c405929963$var$code in $68b9e7c405929963$export$e2253033e6e1df16)if (!$68b9e7c405929963$export$fba63a578e423eb.hasOwnProperty($68b9e7c405929963$var$code)) $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$code] = $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$code];
function $68b9e7c405929963$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $68b9e7c405929963$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $68b9e7c405929963$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $68b9e7c405929963$export$fba63a578e423eb : $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}



const $aeeb4b3d0077ce94$var$mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
const $aeeb4b3d0077ce94$var$windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function $aeeb4b3d0077ce94$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($aeeb4b3d0077ce94$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $aeeb4b3d0077ce94$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$aeeb4b3d0077ce94$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $aeeb4b3d0077ce94$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $aeeb4b3d0077ce94$export$5043418e2ef368d5(bindings) {
    return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        props: {
            handleKeyDown: $aeeb4b3d0077ce94$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $aeeb4b3d0077ce94$export$53f558754f8b9fd1(bindings) {
    let map = $aeeb4b3d0077ce94$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $68b9e7c405929963$export$fb33aafd75404f4c)(event), baseName, direct = map[$aeeb4b3d0077ce94$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$aeeb4b3d0077ce94$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
            !($aeeb4b3d0077ce94$var$windows && event.ctrlKey && event.altKey) && (baseName = (0, $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060, #1529.
                let fromCode = map[$aeeb4b3d0077ce94$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}




// model/index.ts



// transform/index.ts



// commands/index.ts



/**
Delete the selection, if there is one.
*/ const $bd35583558ee295f$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $bd35583558ee295f$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $bd35583558ee295f$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $bd35583558ee295f$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $bd35583558ee295f$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $62ded6a368f04ea2$export$f1508b72cc76a09e)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($bd35583558ee295f$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($bd35583558ee295f$var$textblockAt(before, "end") || (0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $62ded6a368f04ea2$export$ed6ac67359824afd)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($bd35583558ee295f$var$textblockAt(before, "end") ? (0, $c286ea535d926598$export$52baac22726c72bf).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $c286ea535d926598$export$e2940151ac854c0b).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $bd35583558ee295f$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $bd35583558ee295f$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $bd35583558ee295f$var$findCutBefore($cursor);
    return $cut ? $bd35583558ee295f$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $bd35583558ee295f$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $bd35583558ee295f$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $bd35583558ee295f$var$findCutAfter($cursor);
    return $cut ? $bd35583558ee295f$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $bd35583558ee295f$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $62ded6a368f04ea2$export$ed6ac67359824afd)(state.doc, beforePos, afterPos, (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty);
    if (!step || step.from != beforePos || step instanceof (0, $62ded6a368f04ea2$export$5c860b2e74034756) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $c286ea535d926598$export$c2b25f346d19bcbb).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $bd35583558ee295f$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $bd35583558ee295f$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $bd35583558ee295f$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $c286ea535d926598$export$e2940151ac854c0b).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $bd35583558ee295f$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $bd35583558ee295f$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $bd35583558ee295f$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $bd35583558ee295f$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $bd35583558ee295f$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($bd35583558ee295f$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($bd35583558ee295f$var$textblockAt(after, "start") || (0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(after))) {
        let delStep = (0, $62ded6a368f04ea2$export$ed6ac67359824afd)(state.doc, $cursor.before(), $cursor.after(), (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($bd35583558ee295f$var$textblockAt(after, "start") ? (0, $c286ea535d926598$export$52baac22726c72bf).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $c286ea535d926598$export$e2940151ac854c0b).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $bd35583558ee295f$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $bd35583558ee295f$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $c286ea535d926598$export$e2940151ac854c0b).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $bd35583558ee295f$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $bd35583558ee295f$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $c286ea535d926598$export$e2940151ac854c0b), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $62ded6a368f04ea2$export$41b1d4cb5ceb3147)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $c286ea535d926598$export$e2940151ac854c0b).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $bd35583558ee295f$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $c286ea535d926598$export$e2940151ac854c0b)) {
        if (sel.node.isTextblock || !(0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $62ded6a368f04ea2$export$41b1d4cb5ceb3147)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $bd35583558ee295f$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $62ded6a368f04ea2$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $bd35583558ee295f$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $bd35583558ee295f$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $bd35583558ee295f$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $bd35583558ee295f$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $c286ea535d926598$export$52baac22726c72bf).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $bd35583558ee295f$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $c286ea535d926598$export$c15d9ba76bdbcd95) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $bd35583558ee295f$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $c286ea535d926598$export$c2b25f346d19bcbb).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $bd35583558ee295f$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $62ded6a368f04ea2$export$5aaf008897aef029)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $62ded6a368f04ea2$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $bd35583558ee295f$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $c286ea535d926598$export$e2940151ac854c0b) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $62ded6a368f04ea2$export$5aaf008897aef029)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $bd35583558ee295f$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb) || state.selection instanceof (0, $c286ea535d926598$export$c15d9ba76bdbcd95)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, splitPos, types.length, types);
        }
        if (!can) return false;
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $bd35583558ee295f$export$e99155638ff4dff0 = $bd35583558ee295f$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $bd35583558ee295f$export$eeb429476568b72b = (state, dispatch)=>{
    return $bd35583558ee295f$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $bd35583558ee295f$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $c286ea535d926598$export$e2940151ac854c0b).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $bd35583558ee295f$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $c286ea535d926598$export$c15d9ba76bdbcd95)(state.doc)));
    return true;
};
function $bd35583558ee295f$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $bd35583558ee295f$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $bd35583558ee295f$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(conn[i].create(null, wrap));
            wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $62ded6a368f04ea2$export$444ba800d6024a98)($cut.pos - 1, end, $cut.pos, end, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $c286ea535d926598$export$52baac22726c72bf).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $62ded6a368f04ea2$export$f1508b72cc76a09e)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $bd35583558ee295f$var$textblockAt(after, "start", true) && $bd35583558ee295f$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $62ded6a368f04ea2$export$444ba800d6024a98)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $bd35583558ee295f$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $c286ea535d926598$export$c2b25f346d19bcbb).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $bd35583558ee295f$export$c3a64f3c9604a1b1 = $bd35583558ee295f$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $bd35583558ee295f$export$a66c1876556415e5 = $bd35583558ee295f$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $bd35583558ee295f$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $62ded6a368f04ea2$export$118cb9a83e81ba37)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $bd35583558ee295f$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $bd35583558ee295f$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $bd35583558ee295f$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $c286ea535d926598$export$7bd1839c3c5d5bd4)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $c286ea535d926598$export$7bd1839c3c5d5bd4)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $bd35583558ee295f$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    let dropSpace = !(options && options.includeWhitespace);
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$bd35583558ee295f$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $bd35583558ee295f$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $bd35583558ee295f$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $bd35583558ee295f$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $bd35583558ee295f$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $bd35583558ee295f$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $bd35583558ee295f$var$backspace = $bd35583558ee295f$export$146a774cdef7663a($bd35583558ee295f$export$e9a518a637d1e641, $bd35583558ee295f$export$979097b097459299, $bd35583558ee295f$export$52b8a4af68d19794);
let $bd35583558ee295f$var$del = $bd35583558ee295f$export$146a774cdef7663a($bd35583558ee295f$export$e9a518a637d1e641, $bd35583558ee295f$export$bf432e340007f9ef, $bd35583558ee295f$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $bd35583558ee295f$export$eb36e8971b04df36 = {
    "Enter": $bd35583558ee295f$export$146a774cdef7663a($bd35583558ee295f$export$a5d02b4b65e94f91, $bd35583558ee295f$export$d0f80ac1b4510888, $bd35583558ee295f$export$a3574cc681852c08, $bd35583558ee295f$export$e99155638ff4dff0),
    "Mod-Enter": $bd35583558ee295f$export$634b78845598ff5b,
    "Backspace": $bd35583558ee295f$var$backspace,
    "Mod-Backspace": $bd35583558ee295f$var$backspace,
    "Shift-Backspace": $bd35583558ee295f$var$backspace,
    "Delete": $bd35583558ee295f$var$del,
    "Mod-Delete": $bd35583558ee295f$var$del,
    "Mod-a": $bd35583558ee295f$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $bd35583558ee295f$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $bd35583558ee295f$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $bd35583558ee295f$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $bd35583558ee295f$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $bd35583558ee295f$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $bd35583558ee295f$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $bd35583558ee295f$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $bd35583558ee295f$export$c3a64f3c9604a1b1,
    "Ctrl-e": $bd35583558ee295f$export$a66c1876556415e5
};
for(let key in $bd35583558ee295f$export$eb36e8971b04df36)$bd35583558ee295f$export$f292ad8dbd5063c8[key] = $bd35583558ee295f$export$eb36e8971b04df36[key];
const $bd35583558ee295f$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $bd35583558ee295f$export$4a0c2b85b1f0a889 = $bd35583558ee295f$var$mac ? $bd35583558ee295f$export$f292ad8dbd5063c8 : $bd35583558ee295f$export$eb36e8971b04df36;




// schema-list/index.ts



const $88fd855d7280fcf4$var$olDOM = [
    "ol",
    0
], $88fd855d7280fcf4$var$ulDOM = [
    "ul",
    0
], $88fd855d7280fcf4$var$liDOM = [
    "li",
    0
];
/**
An ordered list [node spec](https://prosemirror.net/docs/ref/#model.NodeSpec). Has a single
attribute, `order`, which determines the number at which the list
starts counting, and defaults to 1. Represented as an `<ol>`
element.
*/ const $88fd855d7280fcf4$export$a5dc81035676e7a = {
    attrs: {
        order: {
            default: 1,
            validate: "number"
        }
    },
    parseDOM: [
        {
            tag: "ol",
            getAttrs (dom) {
                return {
                    order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
                };
            }
        }
    ],
    toDOM (node) {
        return node.attrs.order == 1 ? $88fd855d7280fcf4$var$olDOM : [
            "ol",
            {
                start: node.attrs.order
            },
            0
        ];
    }
};
/**
A bullet list node spec, represented in the DOM as `<ul>`.
*/ const $88fd855d7280fcf4$export$a140c94e5ea26bee = {
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM () {
        return $88fd855d7280fcf4$var$ulDOM;
    }
};
/**
A list item (`<li>`) spec.
*/ const $88fd855d7280fcf4$export$76c7e83ecc9cdf05 = {
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM () {
        return $88fd855d7280fcf4$var$liDOM;
    },
    defining: true
};
function $88fd855d7280fcf4$var$add(obj, props) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    for(let prop in props)copy[prop] = props[prop];
    return copy;
}
/**
Convenience function for adding list-related node types to a map
specifying the nodes for a schema. Adds
[`orderedList`](https://prosemirror.net/docs/ref/#schema-list.orderedList) as `"ordered_list"`,
[`bulletList`](https://prosemirror.net/docs/ref/#schema-list.bulletList) as `"bullet_list"`, and
[`listItem`](https://prosemirror.net/docs/ref/#schema-list.listItem) as `"list_item"`.

`itemContent` determines the content expression for the list items.
If you want the commands defined in this module to apply to your
list structure, it should have a shape like `"paragraph block*"` or
`"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
given to assign a group name to the list node types, for example
`"block"`.
*/ function $88fd855d7280fcf4$export$fa2e7d3d1550c2ea(nodes, itemContent, listGroup) {
    return nodes.append({
        ordered_list: $88fd855d7280fcf4$var$add($88fd855d7280fcf4$export$a5dc81035676e7a, {
            content: "list_item+",
            group: listGroup
        }),
        bullet_list: $88fd855d7280fcf4$var$add($88fd855d7280fcf4$export$a140c94e5ea26bee, {
            content: "list_item+",
            group: listGroup
        }),
        list_item: $88fd855d7280fcf4$var$add($88fd855d7280fcf4$export$76c7e83ecc9cdf05, {
            content: itemContent
        })
    });
}
/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/ function $88fd855d7280fcf4$export$a8aef45c6262afee(listType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to);
        if (!range) return false;
        let tr = dispatch ? state.tr : null;
        if (!$88fd855d7280fcf4$export$e4d3cb74b660c6e9(tr, range, listType, attrs)) return false;
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Try to wrap the given node range in a list of the given type.
Return `true` when this is possible, `false` otherwise. When `tr`
is non-null, the wrapping is added to that transaction. When it is
`null`, the function only queries whether the wrapping is
possible.
*/ function $88fd855d7280fcf4$export$e4d3cb74b660c6e9(tr, range, listType, attrs = null) {
    let doJoin = false, outerRange = range, doc = range.$from.doc;
    // This is at the top of an existing list item
    if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
        // Don't do anything if this is the top of the list
        if (range.$from.index(range.depth - 1) == 0) return false;
        let $insert = doc.resolve(range.start - 2);
        outerRange = new (0, $d7ba288a9be229df$export$7bc461ceb770fb16)($insert, $insert, range.depth);
        if (range.endIndex < range.parent.childCount) range = new (0, $d7ba288a9be229df$export$7bc461ceb770fb16)(range.$from, doc.resolve(range.$to.end(range.depth)), range.depth);
        doJoin = true;
    }
    let wrap = (0, $62ded6a368f04ea2$export$118cb9a83e81ba37)(outerRange, listType, attrs, range);
    if (!wrap) return false;
    if (tr) $88fd855d7280fcf4$var$doWrapInList(tr, range, wrap, doJoin, listType);
    return true;
}
function $88fd855d7280fcf4$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $62ded6a368f04ea2$export$444ba800d6024a98)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type == listType) found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Build a command that splits a non-empty textblock at the top level
of a list item by also splitting that list item.
*/ function $88fd855d7280fcf4$export$e920ee2eb756d384(itemType, itemAttrs) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to, node: node } = state.selection;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        let grandParent = $from.node(-1);
        if (grandParent.type != itemType) return false;
        if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth == 3 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
                let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from($from.node(d).copy(wrap));
                let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                wrap = wrap.append((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(itemType.createAndFill()));
                let start = $from.before($from.depth - (depthBefore - 1));
                let tr = state.tr.replace(start, $from.after(-depthAfter), new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (node, pos)=>{
                    if (sel > -1) return false;
                    if (node.isTextblock && node.content.size == 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $c286ea535d926598$export$52baac22726c72bf).near(tr.doc.resolve(sel)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        let tr = state.tr.delete($from.pos, $to.pos);
        let types = nextType ? [
            itemAttrs ? {
                type: itemType,
                attrs: itemAttrs
            } : null,
            {
                type: nextType
            }
        ] : undefined;
        if (!(0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, $from.pos, 2, types)) return false;
        if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        return true;
    };
}
/**
Acts like [`splitListItem`](https://prosemirror.net/docs/ref/#schema-list.splitListItem), but
without resetting the set of active marks at the cursor.
*/ function $88fd855d7280fcf4$export$265ad35055c66d75(itemType, itemAttrs) {
    let split = $88fd855d7280fcf4$export$e920ee2eb756d384(itemType, itemAttrs);
    return (state, dispatch)=>{
        return split(state, dispatch && ((tr)=>{
            let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/ function $88fd855d7280fcf4$export$e74cd5adb935a538(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        if (!dispatch) return true;
        if ($from.node(range.depth - 1).type == itemType) return $88fd855d7280fcf4$var$liftToOuterList(state, dispatch, itemType, range);
        else return $88fd855d7280fcf4$var$liftOutOfList(state, dispatch, range);
    };
}
function $88fd855d7280fcf4$var$liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new (0, $62ded6a368f04ea2$export$444ba800d6024a98)(end - 1, endOfList, end, endOfList, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $d7ba288a9be229df$export$7bc461ceb770fb16)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $62ded6a368f04ea2$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    tr.lift(range, target);
    let $after = tr.doc.resolve(tr.mapping.map(end, -1) - 1);
    if ((0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(tr.doc, $after.pos) && $after.nodeBefore.type == $after.nodeAfter.type) tr.join($after.pos);
    dispatch(tr.scrollIntoView());
    return true;
}
function $88fd855d7280fcf4$var$liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for(let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty : (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(list)))) return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new (0, $62ded6a368f04ea2$export$444ba800d6024a98)(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((atStart ? (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty : (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(list.copy((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty))).append(atEnd ? (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty : (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(list.copy((0, $d7ba288a9be229df$export$ffb0004e005737fa).empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/ function $88fd855d7280fcf4$export$dd505f850a3798a4(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        let startIndex = range.startIndex;
        if (startIndex == 0) return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType) return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(nestedBefore ? itemType.create() : null);
            let slice = new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(itemType.create(null, (0, $d7ba288a9be229df$export$ffb0004e005737fa).from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new (0, $62ded6a368f04ea2$export$444ba800d6024a98)(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)).scrollIntoView());
        }
        return true;
    };
}




/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */ function $aceda74b73705131$export$83e24c5933427696(config) {
    const { state: state, transaction: transaction } = config;
    let { selection: selection } = transaction;
    let { doc: doc } = transaction;
    let { storedMarks: storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks () {
            return storedMarks;
        },
        get selection () {
            return selection;
        },
        get doc () {
            return doc;
        },
        get tr () {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        }
    };
}
class $aceda74b73705131$export$475014de15a4c342 {
    constructor(props){
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const { tr: tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            const method = (...args)=>{
                const callback = command(...args)(props);
                if (!tr.getMeta("preventDispatch") && !this.hasCustomState) view.dispatch(tr);
                return callback;
            };
            return [
                name,
                method
            ];
        }));
    }
    get chain() {
        return ()=>this.createChain();
    }
    get can() {
        return ()=>this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = ()=>{
            if (!hasStartTransaction && shouldDispatch && !tr.getMeta("preventDispatch") && !this.hasCustomState) view.dispatch(tr);
            return callbacks.every((callback)=>callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                const chainedCommand = (...args)=>{
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [
                    name,
                    chainedCommand
                ];
            })),
            run: run
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands: rawCommands, state: state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            return [
                name,
                (...args)=>command(...args)({
                        ...props,
                        dispatch: undefined
                    })
            ];
        }));
        return {
            ...formattedCommands,
            chain: ()=>this.createChain(tr, dispatch)
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const props = {
            tr: tr,
            editor: editor,
            view: view,
            state: $aceda74b73705131$export$83e24c5933427696({
                state: state,
                transaction: tr
            }),
            dispatch: shouldDispatch ? ()=>undefined : undefined,
            chain: ()=>this.createChain(tr, shouldDispatch),
            can: ()=>this.createCan(tr),
            get commands () {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                    return [
                        name,
                        (...args)=>command(...args)(props)
                    ];
                }));
            }
        };
        return props;
    }
}
class $aceda74b73705131$var$EventEmitter {
    constructor(){
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) this.callbacks[event] = [];
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) callbacks.forEach((callback)=>callback.apply(this, args));
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) this.callbacks[event] = callbacks.filter((callback)=>callback !== fn);
            else delete this.callbacks[event];
        }
        return this;
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}
/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */ function $aceda74b73705131$export$f73578b718a57eaa(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) return $aceda74b73705131$export$f73578b718a57eaa(extension.parent, field, context);
    if (typeof extension.config[field] === "function") {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent ? $aceda74b73705131$export$f73578b718a57eaa(extension.parent, field, context) : null
        });
        return value;
    }
    return extension.config[field];
}
function $aceda74b73705131$export$36e8c2990da8266f(extensions) {
    const baseExtensions = extensions.filter((extension)=>extension.type === "extension");
    const nodeExtensions = extensions.filter((extension)=>extension.type === "node");
    const markExtensions = extensions.filter((extension)=>extension.type === "mark");
    return {
        baseExtensions: baseExtensions,
        nodeExtensions: nodeExtensions,
        markExtensions: markExtensions
    };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */ function $aceda74b73705131$export$6e54e3e69d60df3d(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $aceda74b73705131$export$36e8c2990da8266f(extensions);
    const nodeAndMarkExtensions = [
        ...nodeExtensions,
        ...markExtensions
    ];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false
    };
    extensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions
        };
        const addGlobalAttributes = $aceda74b73705131$export$f73578b718a57eaa(extension, "addGlobalAttributes", context);
        if (!addGlobalAttributes) return;
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach((globalAttribute)=>{
            globalAttribute.types.forEach((type)=>{
                Object.entries(globalAttribute.attributes).forEach(([name, attribute])=>{
                    extensionAttributes.push({
                        type: type,
                        name: name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute
                        }
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        const addAttributes = $aceda74b73705131$export$f73578b718a57eaa(extension, "addAttributes", context);
        if (!addAttributes) return;
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object.entries(attributes).forEach(([name, attribute])=>{
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === "function") mergedAttr.default = mergedAttr.default();
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) delete mergedAttr.default;
            extensionAttributes.push({
                type: extension.name,
                name: name,
                attribute: mergedAttr
            });
        });
    });
    return extensionAttributes;
}
function $aceda74b73705131$export$d168cba70360dd3d(nameOrType, schema) {
    if (typeof nameOrType === "string") {
        if (!schema.nodes[nameOrType]) throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}
function $aceda74b73705131$export$9f98db6234c4bd78(...objects) {
    return objects.filter((item)=>!!item).reduce((items, item)=>{
        const mergedAttributes = {
            ...items
        };
        Object.entries(item).forEach(([key, value])=>{
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === "class") {
                const valueClasses = value ? value.split(" ") : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(" ") : [];
                const insertClasses = valueClasses.filter((valueClass)=>!existingClasses.includes(valueClass));
                mergedAttributes[key] = [
                    ...existingClasses,
                    ...insertClasses
                ].join(" ");
            } else if (key === "style") {
                const newStyles = value ? value.split(";").map((style)=>style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(";").map((style)=>style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach((style)=>{
                    const [property, val] = style.split(":").map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach((style)=>{
                    const [property, val] = style.split(":").map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val])=>`${property}: ${val}`).join("; ");
            } else mergedAttributes[key] = value;
        });
        return mergedAttributes;
    }, {});
}
function $aceda74b73705131$export$bc79d84a417d7b02(nodeOrMark, extensionAttributes) {
    return extensionAttributes.filter((attribute)=>attribute.type === nodeOrMark.type.name).filter((item)=>item.attribute.rendered).map((item)=>{
        if (!item.attribute.renderHTML) return {
            [item.name]: nodeOrMark.attrs[item.name]
        };
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    }).reduce((attributes, attribute)=>$aceda74b73705131$export$9f98db6234c4bd78(attributes, attribute), {});
}
function $aceda74b73705131$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */ function $aceda74b73705131$export$592682234826c0bd(value, context, ...props) {
    if ($aceda74b73705131$export$f6e2535fb5126e54(value)) {
        if (context) return value.bind(context)(...props);
        return value(...props);
    }
    return value;
}
function $aceda74b73705131$export$83b788b1a3698c03(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}
function $aceda74b73705131$export$3004f64547af360e(value) {
    if (typeof value !== "string") return value;
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) return Number(value);
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */ function $aceda74b73705131$export$7ce6b571718439ec(parseRule, extensionAttributes) {
    if ("style" in parseRule) return parseRule;
    return {
        ...parseRule,
        getAttrs: (node)=>{
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) return false;
            const newAttributes = extensionAttributes.reduce((items, item)=>{
                const value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : $aceda74b73705131$export$3004f64547af360e(node.getAttribute(item.name));
                if (value === null || value === undefined) return items;
                return {
                    ...items,
                    [item.name]: value
                };
            }, {});
            return {
                ...oldAttributes,
                ...newAttributes
            };
        }
    };
}
function $aceda74b73705131$var$cleanUpSchemaItem(data) {
    return Object.fromEntries(// @ts-ignore
    Object.entries(data).filter(([key, value])=>{
        if (key === "attrs" && $aceda74b73705131$export$83b788b1a3698c03(value)) return false;
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */ function $aceda74b73705131$export$71bc12a97b59a858(extensions, editor) {
    var _a;
    const allAttributes = $aceda74b73705131$export$6e54e3e69d60df3d(extensions);
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $aceda74b73705131$export$36e8c2990da8266f(extensions);
    const topNode = (_a = nodeExtensions.find((extension)=>$aceda74b73705131$export$f73578b718a57eaa(extension, "topNode"))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraNodeFields = extensions.reduce((fields, e)=>{
            const extendNodeSchema = $aceda74b73705131$export$f73578b718a57eaa(e, "extendNodeSchema", context);
            return {
                ...fields,
                ...extendNodeSchema ? extendNodeSchema(extension) : {}
            };
        }, {});
        const schema = $aceda74b73705131$var$cleanUpSchemaItem({
            ...extraNodeFields,
            content: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "content", context)),
            marks: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "marks", context)),
            group: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "group", context)),
            inline: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "inline", context)),
            atom: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "atom", context)),
            selectable: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "selectable", context)),
            draggable: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "draggable", context)),
            code: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "code", context)),
            whitespace: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "whitespace", context)),
            defining: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "defining", context)),
            isolating: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "isolating", context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "parseHTML", context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$aceda74b73705131$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $aceda74b73705131$export$f73578b718a57eaa(extension, "renderHTML", context);
        if (renderHTML) schema.toDOM = (node)=>renderHTML({
                node: node,
                HTMLAttributes: $aceda74b73705131$export$bc79d84a417d7b02(node, extensionAttributes)
            });
        const renderText = $aceda74b73705131$export$f73578b718a57eaa(extension, "renderText", context);
        if (renderText) schema.toText = renderText;
        return [
            extension.name,
            schema
        ];
    }));
    const marks = Object.fromEntries(markExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraMarkFields = extensions.reduce((fields, e)=>{
            const extendMarkSchema = $aceda74b73705131$export$f73578b718a57eaa(e, "extendMarkSchema", context);
            return {
                ...fields,
                ...extendMarkSchema ? extendMarkSchema(extension) : {}
            };
        }, {});
        const schema = $aceda74b73705131$var$cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "inclusive", context)),
            excludes: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "excludes", context)),
            group: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "group", context)),
            spanning: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "spanning", context)),
            code: $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "code", context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "parseHTML", context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$aceda74b73705131$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $aceda74b73705131$export$f73578b718a57eaa(extension, "renderHTML", context);
        if (renderHTML) schema.toDOM = (mark)=>renderHTML({
                mark: mark,
                HTMLAttributes: $aceda74b73705131$export$bc79d84a417d7b02(mark, extensionAttributes)
            });
        return [
            extension.name,
            schema
        ];
    }));
    return new (0, $d7ba288a9be229df$export$19342e026b58ebb7)({
        topNode: topNode,
        nodes: nodes,
        marks: marks
    });
}
/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */ function $aceda74b73705131$export$ea18268b31f54e5(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}
function $aceda74b73705131$export$79b791167b05aada(extension, enabled) {
    if (Array.isArray(enabled)) return enabled.some((enabledExtension)=>{
        const name = typeof enabledExtension === "string" ? enabledExtension : enabledExtension.name;
        return name === extension.name;
    });
    return enabled;
}
/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */ const $aceda74b73705131$export$a3e238086d556fa9 = ($from, maxMatch = 500)=>{
    let textBefore = "";
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index)=>{
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node: node,
            pos: pos,
            parent: parent,
            index: index
        })) || node.textContent || "%leaf%";
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};
function $aceda74b73705131$export$49841c62b9eff15(value) {
    return Object.prototype.toString.call(value) === "[object RegExp]";
}
class $aceda74b73705131$export$9b55e2b000ad65f2 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $aceda74b73705131$var$inputRuleMatcherHandler = (text, find)=>{
    if ($aceda74b73705131$export$49841c62b9eff15(find)) return find.exec(text);
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) return null;
    const result = [
        inputRuleMatch.text
    ];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function $aceda74b73705131$var$run$1(config) {
    var _a;
    const { editor: editor, from: from, to: to, text: text, rules: rules, plugin: plugin } = config;
    const { view: view } = editor;
    if (view.composing) return false;
    const $from = view.state.doc.resolve(from);
    if (// check for code node
    $from.parent.type.spec.code || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find((mark)=>mark.type.spec.code))) return false;
    let matched = false;
    const textBefore = $aceda74b73705131$export$a3e238086d556fa9($from) + text;
    rules.forEach((rule)=>{
        if (matched) return;
        const match = $aceda74b73705131$var$inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) return;
        const tr = view.state.tr;
        const state = $aceda74b73705131$export$83e24c5933427696({
            state: view.state,
            transaction: tr
        });
        const range = {
            from: from - (match[0].length - text.length),
            to: to
        };
        const { commands: commands, chain: chain, can: can } = new $aceda74b73705131$export$475014de15a4c342({
            editor: editor,
            state: state
        });
        const handler = rule.handler({
            state: state,
            range: range,
            match: match,
            commands: commands,
            chain: chain,
            can: can
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) return;
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from: from,
            to: to,
            text: text
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */ function $aceda74b73705131$export$f2a821f78e918151(props) {
    const { editor: editor, rules: rules } = props;
    const plugin = new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(plugin);
                if (stored) return stored;
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta("applyInputRules");
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) setTimeout(()=>{
                    const { from: from, text: text } = simulatedInputMeta;
                    const to = from + text.length;
                    $aceda74b73705131$var$run$1({
                        editor: editor,
                        from: from,
                        to: to,
                        text: text,
                        rules: rules,
                        plugin: plugin
                    });
                });
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                return $aceda74b73705131$var$run$1({
                    editor: editor,
                    from: from,
                    to: to,
                    text: text,
                    rules: rules,
                    plugin: plugin
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const { $cursor: $cursor } = view.state.selection;
                        if ($cursor) $aceda74b73705131$var$run$1({
                            editor: editor,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: "",
                            rules: rules,
                            plugin: plugin
                        });
                    });
                    return false;
                }
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown (view, event) {
                if (event.key !== "Enter") return false;
                const { $cursor: $cursor } = view.state.selection;
                if ($cursor) return $aceda74b73705131$var$run$1({
                    editor: editor,
                    from: $cursor.pos,
                    to: $cursor.pos,
                    text: "\n",
                    rules: rules,
                    plugin: plugin
                });
                return false;
            }
        },
        // @ts-ignore
        isInputRules: true
    });
    return plugin;
}
// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function $aceda74b73705131$var$getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $aceda74b73705131$export$53b83ca8eaab0383(value) {
    if ($aceda74b73705131$var$getType(value) !== "Object") return false;
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function $aceda74b73705131$export$dd702b3c8240390c(target, source) {
    const output = {
        ...target
    };
    if ($aceda74b73705131$export$53b83ca8eaab0383(target) && $aceda74b73705131$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($aceda74b73705131$export$53b83ca8eaab0383(source[key]) && $aceda74b73705131$export$53b83ca8eaab0383(target[key])) output[key] = $aceda74b73705131$export$dd702b3c8240390c(target[key], source[key]);
        else output[key] = source[key];
    });
    return output;
}
/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $aceda74b73705131$export$c9d15bcfc6d42044 {
    constructor(config = {}){
        this.type = "mark";
        this.name = "mark";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $aceda74b73705131$export$c9d15bcfc6d42044(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $aceda74b73705131$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $aceda74b73705131$export$c9d15bcfc6d42044(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    static handleExit({ editor: editor, mark: mark }) {
        const { tr: tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) return false;
            const removeMark = currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) tr.removeStoredMark(removeMark);
            tr.insertText(" ", currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}
function $aceda74b73705131$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ class $aceda74b73705131$export$e75df4392d073e98 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $aceda74b73705131$var$pasteRuleMatcherHandler = (text, find, event)=>{
    if ($aceda74b73705131$export$49841c62b9eff15(find)) return [
        ...text.matchAll(find)
    ];
    const matches = find(text, event);
    if (!matches) return [];
    return matches.map((pasteRuleMatch)=>{
        const result = [
            pasteRuleMatch.text
        ];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function $aceda74b73705131$var$run(config) {
    const { editor: editor, state: state, from: from, to: to, rule: rule, pasteEvent: pasteEvent, dropEvent: dropEvent } = config;
    const { commands: commands, chain: chain, can: can } = new $aceda74b73705131$export$475014de15a4c342({
        editor: editor,
        state: state
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isTextblock || node.type.spec.code) return;
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, "\uFFFC");
        const matches = $aceda74b73705131$var$pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach((match)=>{
            if (match.index === undefined) return;
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end)
            };
            const handler = rule.handler({
                state: state,
                range: range,
                match: match,
                commands: commands,
                chain: chain,
                can: can,
                pasteEvent: pasteEvent,
                dropEvent: dropEvent
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every((handler)=>handler !== null);
    return success;
}
const $aceda74b73705131$var$createClipboardPasteEvent = (text)=>{
    var _a;
    const event = new ClipboardEvent("paste", {
        clipboardData: new DataTransfer()
    });
    (_a = event.clipboardData) === null || _a === void 0 || _a.setData("text/html", text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */ function $aceda74b73705131$export$458282b0dddaaaa4(props) {
    const { editor: editor, rules: rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
    let dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
    const processEvent = ({ state: state, from: from, to: to, rule: rule, pasteEvt: pasteEvt })=>{
        const tr = state.tr;
        const chainableState = $aceda74b73705131$export$83e24c5933427696({
            state: state,
            transaction: tr
        });
        const handler = $aceda74b73705131$var$run({
            editor: editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule: rule,
            pasteEvent: pasteEvt,
            dropEvent: dropEvent
        });
        if (!handler || !tr.steps.length) return;
        dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
        pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
        return tr;
    };
    const plugins = rules.map((rule)=>{
        return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
            // we register a global drag handler to track the current drag source element
            view (view) {
                const handleDragstart = (event)=>{
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? view.dom.parentElement : null;
                };
                window.addEventListener("dragstart", handleDragstart);
                return {
                    destroy () {
                        window.removeEventListener("dragstart", handleDragstart);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event)=>{
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        return false;
                    },
                    paste: (_view, event)=>{
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData("text/html");
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes("data-pm-slice"));
                        return false;
                    }
                }
            },
            appendTransaction: (transactions, oldState, state)=>{
                const transaction = transactions[0];
                const isPaste = transaction.getMeta("uiEvent") === "paste" && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta("uiEvent") === "drop" && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta("applyPasteRules");
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) return;
                // Handle simulated paste
                if (isSimulatedPaste) {
                    const { from: from, text: text } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = $aceda74b73705131$var$createClipboardPasteEvent(text);
                    return processEvent({
                        rule: rule,
                        state: state,
                        from: from,
                        to: {
                            b: to
                        },
                        pasteEvt: pasteEvt
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!$aceda74b73705131$export$7e4aa119212bc614(from) || !to || from === to.b) return;
                return processEvent({
                    rule: rule,
                    state: state,
                    from: from,
                    to: to,
                    pasteEvt: pasteEvent
                });
            }
        });
    });
    return plugins;
}
function $aceda74b73705131$export$15704658c784aef1(items) {
    const filtered = items.filter((el, index)=>items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}
class $aceda74b73705131$var$ExtensionManager {
    constructor(extensions, editor){
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = $aceda74b73705131$var$ExtensionManager.resolve(extensions);
        this.schema = $aceda74b73705131$export$71bc12a97b59a858(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */ static resolve(extensions) {
        const resolvedExtensions = $aceda74b73705131$var$ExtensionManager.sort($aceda74b73705131$var$ExtensionManager.flatten(extensions));
        const duplicatedNames = $aceda74b73705131$export$15704658c784aef1(resolvedExtensions.map((extension)=>extension.name));
        if (duplicatedNames.length) console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item)=>`'${item}'`).join(", ")}]. This can lead to issues.`);
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */ static flatten(extensions) {
        return extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage
            };
            const addExtensions = $aceda74b73705131$export$f73578b718a57eaa(extension, "addExtensions", context);
            if (addExtensions) return [
                extension,
                ...this.flatten(addExtensions())
            ];
            return extension;
        })// `Infinity` will break TypeScript so we set a number that is probably high enough
        .flat(10);
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */ static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b)=>{
            const priorityA = $aceda74b73705131$export$f73578b718a57eaa(a, "priority") || defaultPriority;
            const priorityB = $aceda74b73705131$export$f73578b718a57eaa(b, "priority") || defaultPriority;
            if (priorityA > priorityB) return -1;
            if (priorityA < priorityB) return 1;
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */ get commands() {
        return this.extensions.reduce((commands, extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $aceda74b73705131$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const addCommands = $aceda74b73705131$export$f73578b718a57eaa(extension, "addCommands", context);
            if (!addCommands) return commands;
            return {
                ...commands,
                ...addCommands()
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */ get plugins() {
        const { editor: editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = $aceda74b73705131$var$ExtensionManager.sort([
            ...this.extensions
        ].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $aceda74b73705131$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const plugins = [];
            const addKeyboardShortcuts = $aceda74b73705131$export$f73578b718a57eaa(extension, "addKeyboardShortcuts", context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === "mark" && $aceda74b73705131$export$f73578b718a57eaa(extension, "exitable", context)) defaultBindings.ArrowRight = ()=>$aceda74b73705131$export$c9d15bcfc6d42044.handleExit({
                    editor: editor,
                    mark: extension
                });
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method])=>{
                    return [
                        shortcut,
                        ()=>method({
                                editor: editor
                            })
                    ];
                }));
                defaultBindings = {
                    ...defaultBindings,
                    ...bindings
                };
            }
            const keyMapPlugin = (0, $aeeb4b3d0077ce94$export$5043418e2ef368d5)(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = $aceda74b73705131$export$f73578b718a57eaa(extension, "addInputRules", context);
            if ($aceda74b73705131$export$79b791167b05aada(extension, editor.options.enableInputRules) && addInputRules) inputRules.push(...addInputRules());
            const addPasteRules = $aceda74b73705131$export$f73578b718a57eaa(extension, "addPasteRules", context);
            if ($aceda74b73705131$export$79b791167b05aada(extension, editor.options.enablePasteRules) && addPasteRules) pasteRules.push(...addPasteRules());
            const addProseMirrorPlugins = $aceda74b73705131$export$f73578b718a57eaa(extension, "addProseMirrorPlugins", context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        }).flat();
        return [
            $aceda74b73705131$export$f2a821f78e918151({
                editor: editor,
                rules: inputRules
            }),
            ...$aceda74b73705131$export$458282b0dddaaaa4({
                editor: editor,
                rules: pasteRules
            }),
            ...allPlugins
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */ get attributes() {
        return $aceda74b73705131$export$6e54e3e69d60df3d(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */ get nodeViews() {
        const { editor: editor } = this;
        const { nodeExtensions: nodeExtensions } = $aceda74b73705131$export$36e8c2990da8266f(this.extensions);
        return Object.fromEntries(nodeExtensions.filter((extension)=>!!$aceda74b73705131$export$f73578b718a57eaa(extension, "addNodeView")).map((extension)=>{
            const extensionAttributes = this.attributes.filter((attribute)=>attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $aceda74b73705131$export$d168cba70360dd3d(extension.name, this.schema)
            };
            const addNodeView = $aceda74b73705131$export$f73578b718a57eaa(extension, "addNodeView", context);
            if (!addNodeView) return [];
            const nodeview = (node, view, getPos, decorations, innerDecorations)=>{
                const HTMLAttributes = $aceda74b73705131$export$bc79d84a417d7b02(node, extensionAttributes);
                return addNodeView()({
                    node: // pass-through
                    node,
                    view: view,
                    getPos: getPos,
                    decorations: decorations,
                    innerDecorations: innerDecorations,
                    editor: // tiptap-specific
                    editor,
                    extension: extension,
                    HTMLAttributes: HTMLAttributes
                });
            };
            return [
                extension.name,
                nodeview
            ];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */ setupExtensions() {
        this.extensions.forEach((extension)=>{
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $aceda74b73705131$export$ea18268b31f54e5(extension.name, this.schema)
            };
            if (extension.type === "mark") {
                const keepOnSplit = (_a = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "keepOnSplit", context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) this.splittableMarks.push(extension.name);
            }
            const onBeforeCreate = $aceda74b73705131$export$f73578b718a57eaa(extension, "onBeforeCreate", context);
            const onCreate = $aceda74b73705131$export$f73578b718a57eaa(extension, "onCreate", context);
            const onUpdate = $aceda74b73705131$export$f73578b718a57eaa(extension, "onUpdate", context);
            const onSelectionUpdate = $aceda74b73705131$export$f73578b718a57eaa(extension, "onSelectionUpdate", context);
            const onTransaction = $aceda74b73705131$export$f73578b718a57eaa(extension, "onTransaction", context);
            const onFocus = $aceda74b73705131$export$f73578b718a57eaa(extension, "onFocus", context);
            const onBlur = $aceda74b73705131$export$f73578b718a57eaa(extension, "onBlur", context);
            const onDestroy = $aceda74b73705131$export$f73578b718a57eaa(extension, "onDestroy", context);
            if (onBeforeCreate) this.editor.on("beforeCreate", onBeforeCreate);
            if (onCreate) this.editor.on("create", onCreate);
            if (onUpdate) this.editor.on("update", onUpdate);
            if (onSelectionUpdate) this.editor.on("selectionUpdate", onSelectionUpdate);
            if (onTransaction) this.editor.on("transaction", onTransaction);
            if (onFocus) this.editor.on("focus", onFocus);
            if (onBlur) this.editor.on("blur", onBlur);
            if (onDestroy) this.editor.on("destroy", onDestroy);
        });
    }
}
/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $aceda74b73705131$export$eeddbf09bb970356 {
    constructor(config = {}){
        this.type = "extension";
        this.name = "extension";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $aceda74b73705131$export$eeddbf09bb970356(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $aceda74b73705131$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $aceda74b73705131$export$eeddbf09bb970356({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */ function $aceda74b73705131$export$6e5992a7455d9ef6(startNode, range, options) {
    const { from: from, to: to } = range;
    const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
    let text = "";
    startNode.nodesBetween(from, to, (node, pos, parent, index)=>{
        var _a;
        if (node.isBlock && pos > from) text += blockSeparator;
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) text += textSerializer({
                node: node,
                pos: pos,
                parent: parent,
                index: index,
                range: range
            });
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
    });
    return text;
}
/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */ function $aceda74b73705131$export$fdd92b7d22ac071c(schema) {
    return Object.fromEntries(Object.entries(schema.nodes).filter(([, node])=>node.spec.toText).map(([name, node])=>[
            name,
            node.spec.toText
        ]));
}
const $aceda74b73705131$var$ClipboardTextSerializer = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "clipboardTextSerializer",
    addOptions () {
        return {
            blockSeparator: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("clipboardTextSerializer"),
                props: {
                    clipboardTextSerializer: ()=>{
                        const { editor: editor } = this;
                        const { state: state, schema: schema } = editor;
                        const { doc: doc, selection: selection } = state;
                        const { ranges: ranges } = selection;
                        const from = Math.min(...ranges.map((range)=>range.$from.pos));
                        const to = Math.max(...ranges.map((range)=>range.$to.pos));
                        const textSerializers = $aceda74b73705131$export$fdd92b7d22ac071c(schema);
                        const range = {
                            from: from,
                            to: to
                        };
                        return $aceda74b73705131$export$6e5992a7455d9ef6(doc, range, {
                            ...this.options.blockSeparator !== undefined ? {
                                blockSeparator: this.options.blockSeparator
                            } : {},
                            textSerializers: textSerializers
                        });
                    }
                }
            })
        ];
    }
});
const $aceda74b73705131$var$blur = ()=>({ editor: editor, view: view })=>{
        requestAnimationFrame(()=>{
            var _a;
            if (!editor.isDestroyed) {
                view.dom.blur();
                // Browsers should remove the caret on blur but safari does not.
                // See: https://github.com/ueberdosis/tiptap/issues/2405
                (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 || _a.removeAllRanges();
            }
        });
        return true;
    };
const $aceda74b73705131$var$clearContent = (emitUpdate = false)=>({ commands: commands })=>{
        return commands.setContent("", emitUpdate);
    };
const $aceda74b73705131$var$clearNodes = ()=>({ state: state, tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { ranges: ranges } = selection;
        if (!dispatch) return true;
        ranges.forEach(({ $from: $from, $to: $to })=>{
            state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (node.type.isText) return;
                const { doc: doc, mapping: mapping } = tr;
                const $mappedFrom = doc.resolve(mapping.map(pos));
                const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
                const nodeRange = $mappedFrom.blockRange($mappedTo);
                if (!nodeRange) return;
                const targetLiftDepth = (0, $62ded6a368f04ea2$export$f1508b72cc76a09e)(nodeRange);
                if (node.type.isTextblock) {
                    const { defaultType: defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                    tr.setNodeMarkup(nodeRange.start, defaultType);
                }
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(nodeRange, targetLiftDepth);
            });
        });
        return true;
    };
const $aceda74b73705131$var$command = (fn)=>(props)=>{
        return fn(props);
    };
const $aceda74b73705131$var$createParagraphNear = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$d0f80ac1b4510888)(state, dispatch);
    };
const $aceda74b73705131$var$cut = (originRange, targetPos)=>({ editor: editor, tr: tr })=>{
        const { state: state } = editor;
        const contentSlice = state.doc.slice(originRange.from, originRange.to);
        tr.deleteRange(originRange.from, originRange.to);
        const newPos = tr.mapping.map(targetPos);
        tr.insert(newPos, contentSlice.content);
        tr.setSelection(new (0, $c286ea535d926598$export$c2b25f346d19bcbb)(tr.doc.resolve(newPos - 1)));
        return true;
    };
const $aceda74b73705131$var$deleteCurrentNode = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const currentNode = selection.$anchor.node();
        // if there is content inside the current node, break out of this command
        if (currentNode.content.size > 0) return false;
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === currentNode.type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $aceda74b73705131$var$deleteNode = (typeOrName)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $aceda74b73705131$var$deleteRange = (range)=>({ tr: tr, dispatch: dispatch })=>{
        const { from: from, to: to } = range;
        if (dispatch) tr.delete(from, to);
        return true;
    };
const $aceda74b73705131$var$deleteSelection = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$e9a518a637d1e641)(state, dispatch);
    };
const $aceda74b73705131$var$enter = ()=>({ commands: commands })=>{
        return commands.keyboardShortcut("Enter");
    };
const $aceda74b73705131$var$exitCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$634b78845598ff5b)(state, dispatch);
    };
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */ function $aceda74b73705131$export$7aeb68f71172641d(object1, object2, options = {
    strict: true
}) {
    const keys = Object.keys(object2);
    if (!keys.length) return true;
    return keys.every((key)=>{
        if (options.strict) return object2[key] === object1[key];
        if ($aceda74b73705131$export$49841c62b9eff15(object2[key])) return object2[key].test(object1[key]);
        return object2[key] === object1[key];
    });
}
function $aceda74b73705131$var$findMarkInSet(marks, type, attributes = {}) {
    return marks.find((item)=>{
        return item.type === type && $aceda74b73705131$export$7aeb68f71172641d(item.attrs, attributes);
    });
}
function $aceda74b73705131$var$isMarkInSet(marks, type, attributes = {}) {
    return !!$aceda74b73705131$var$findMarkInSet(marks, type, attributes);
}
function $aceda74b73705131$export$8ceae6d06f5c4df5($pos, type, attributes = {}) {
    if (!$pos || !type) return;
    let start = $pos.parent.childAfter($pos.parentOffset);
    if ($pos.parentOffset === start.offset && start.offset !== 0) start = $pos.parent.childBefore($pos.parentOffset);
    if (!start.node) return;
    const mark = $aceda74b73705131$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    if (!mark) return;
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    $aceda74b73705131$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    while(startIndex > 0 && mark.isInSet($pos.parent.child(startIndex - 1).marks)){
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while(endIndex < $pos.parent.childCount && $aceda74b73705131$var$isMarkInSet([
        ...$pos.parent.child(endIndex).marks
    ], type, attributes)){
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos
    };
}
function $aceda74b73705131$export$b1269d6bf6e491ec(nameOrType, schema) {
    if (typeof nameOrType === "string") {
        if (!schema.marks[nameOrType]) throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.marks[nameOrType];
    }
    return nameOrType;
}
const $aceda74b73705131$var$extendMarkRange = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { doc: doc, selection: selection } = tr;
        const { $from: $from, from: from, to: to } = selection;
        if (dispatch) {
            const range = $aceda74b73705131$export$8ceae6d06f5c4df5($from, type, attributes);
            if (range && range.from <= from && range.to >= to) {
                const newSelection = (0, $c286ea535d926598$export$c2b25f346d19bcbb).create(doc, range.from, range.to);
                tr.setSelection(newSelection);
            }
        }
        return true;
    };
const $aceda74b73705131$var$first = (commands)=>(props)=>{
        const items = typeof commands === "function" ? commands(props) : commands;
        for(let i = 0; i < items.length; i += 1){
            if (items[i](props)) return true;
        }
        return false;
    };
function $aceda74b73705131$export$38b50bf35e79aaf3(value) {
    return value instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb);
}
function $aceda74b73705131$export$6fb785c609d82593(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}
function $aceda74b73705131$export$225b0233b78e0d61(doc, position = null) {
    if (!position) return null;
    const selectionAtStart = (0, $c286ea535d926598$export$52baac22726c72bf).atStart(doc);
    const selectionAtEnd = (0, $c286ea535d926598$export$52baac22726c72bf).atEnd(doc);
    if (position === "start" || position === true) return selectionAtStart;
    if (position === "end") return selectionAtEnd;
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === "all") return (0, $c286ea535d926598$export$c2b25f346d19bcbb).create(doc, $aceda74b73705131$export$6fb785c609d82593(0, minPos, maxPos), $aceda74b73705131$export$6fb785c609d82593(doc.content.size, minPos, maxPos));
    return (0, $c286ea535d926598$export$c2b25f346d19bcbb).create(doc, $aceda74b73705131$export$6fb785c609d82593(position, minPos, maxPos), $aceda74b73705131$export$6fb785c609d82593(position, minPos, maxPos));
}
function $aceda74b73705131$export$86c1a3f9ab33da5c() {
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const $aceda74b73705131$var$focus = (position = null, options = {})=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        options = {
            scrollIntoView: true,
            ...options
        };
        const delayedFocus = ()=>{
            // focus within `requestAnimationFrame` breaks focus on iOS
            // so we have to call this
            if ($aceda74b73705131$export$86c1a3f9ab33da5c()) view.dom.focus();
            // For React we have to focus asynchronously. Otherwise wild things happen.
            // see: https://github.com/ueberdosis/tiptap/issues/1520
            requestAnimationFrame(()=>{
                if (!editor.isDestroyed) {
                    view.focus();
                    if (options === null || options === void 0 ? void 0 : options.scrollIntoView) editor.commands.scrollIntoView();
                }
            });
        };
        if (view.hasFocus() && position === null || position === false) return true;
        // we don’t try to resolve a NodeSelection or CellSelection
        if (dispatch && position === null && !$aceda74b73705131$export$38b50bf35e79aaf3(editor.state.selection)) {
            delayedFocus();
            return true;
        }
        // pass through tr.doc instead of editor.state.doc
        // since transactions could change the editors state before this command has been run
        const selection = $aceda74b73705131$export$225b0233b78e0d61(tr.doc, position) || editor.state.selection;
        const isSameSelection = editor.state.selection.eq(selection);
        if (dispatch) {
            if (!isSameSelection) tr.setSelection(selection);
            // `tr.setSelection` resets the stored marks
            // so we’ll restore them if the selection is the same as before
            if (isSameSelection && tr.storedMarks) tr.setStoredMarks(tr.storedMarks);
            delayedFocus();
        }
        return true;
    };
const $aceda74b73705131$var$forEach = (items, fn)=>(props)=>{
        return items.every((item, index)=>fn(item, {
                ...props,
                index: index
            }));
    };
const $aceda74b73705131$var$insertContent = (value, options)=>({ tr: tr, commands: commands })=>{
        return commands.insertContentAt({
            from: tr.selection.from,
            to: tr.selection.to
        }, value, options);
    };
const $aceda74b73705131$var$removeWhitespaces = (node)=>{
    const children = node.childNodes;
    for(let i = children.length - 1; i >= 0; i -= 1){
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
        else if (child.nodeType === 1) $aceda74b73705131$var$removeWhitespaces(child);
    }
    return node;
};
function $aceda74b73705131$export$1b93bf03550cde01(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
    return $aceda74b73705131$var$removeWhitespaces(html);
}
/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */ function $aceda74b73705131$export$12c64e96dddaee61(content, schema, options) {
    options = {
        slice: true,
        parseOptions: {},
        ...options
    };
    const isJSONContent = typeof content === "object" && content !== null;
    const isTextContent = typeof content === "string";
    if (isJSONContent) try {
        const isArrayContent = Array.isArray(content) && content.length > 0;
        // if the JSON Content is an array of nodes, create a fragment for each node
        if (isArrayContent) return (0, $d7ba288a9be229df$export$ffb0004e005737fa).fromArray(content.map((item)=>schema.nodeFromJSON(item)));
        const node = schema.nodeFromJSON(content);
        if (options.errorOnInvalidContent) node.check();
        return node;
    } catch (error) {
        if (options.errorOnInvalidContent) throw new Error("[tiptap error]: Invalid JSON content", {
            cause: error
        });
        console.warn("[tiptap warn]: Invalid content.", "Passed value:", content, "Error:", error);
        return $aceda74b73705131$export$12c64e96dddaee61("", schema, options);
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = "";
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new (0, $d7ba288a9be229df$export$19342e026b58ebb7)({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: "inline*",
                        group: "block",
                        parseDOM: [
                            {
                                tag: "*",
                                getAttrs: (e)=>{
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === "string" ? e : e.outerHTML;
                                    return null;
                                }
                            }
                        ]
                    }
                })
            });
            if (options.slice) (0, $d7ba288a9be229df$export$1059c6e7d2ce5669).fromSchema(contentCheckSchema).parseSlice($aceda74b73705131$export$1b93bf03550cde01(content), options.parseOptions);
            else (0, $d7ba288a9be229df$export$1059c6e7d2ce5669).fromSchema(contentCheckSchema).parse($aceda74b73705131$export$1b93bf03550cde01(content), options.parseOptions);
            if (options.errorOnInvalidContent && hasInvalidContent) throw new Error("[tiptap error]: Invalid HTML content", {
                cause: new Error(`Invalid element found: ${invalidContent}`)
            });
        }
        const parser = (0, $d7ba288a9be229df$export$1059c6e7d2ce5669).fromSchema(schema);
        if (options.slice) return parser.parseSlice($aceda74b73705131$export$1b93bf03550cde01(content), options.parseOptions).content;
        return parser.parse($aceda74b73705131$export$1b93bf03550cde01(content), options.parseOptions);
    }
    return $aceda74b73705131$export$12c64e96dddaee61("", schema, options);
}
// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function $aceda74b73705131$export$bf93acd215057ab0(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) return;
    const step = tr.steps[last];
    if (!(step instanceof (0, $62ded6a368f04ea2$export$5c860b2e74034756) || step instanceof (0, $62ded6a368f04ea2$export$444ba800d6024a98))) return;
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end === 0) end = newTo;
    });
    tr.setSelection((0, $c286ea535d926598$export$52baac22726c72bf).near(tr.doc.resolve(end), bias));
}
const $aceda74b73705131$var$isFragment = (nodeOrFragment)=>{
    return !("type" in nodeOrFragment);
};
const $aceda74b73705131$var$insertContentAt = (position, value, options)=>({ tr: tr, dispatch: dispatch, editor: editor })=>{
        var _a;
        if (dispatch) {
            options = {
                parseOptions: {},
                updateSelection: true,
                applyInputRules: false,
                applyPasteRules: false,
                ...options
            };
            let content;
            try {
                content = $aceda74b73705131$export$12c64e96dddaee61(value, editor.schema, {
                    parseOptions: {
                        preserveWhitespace: "full",
                        ...options.parseOptions
                    },
                    errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
                });
            } catch (e) {
                editor.emit("contentError", {
                    editor: editor,
                    error: e,
                    disableCollaboration: ()=>{
                        console.error("[tiptap error]: Unable to disable collaboration at this point in time");
                    }
                });
                return false;
            }
            let { from: from, to: to } = typeof position === "number" ? {
                from: position,
                to: position
            } : {
                from: position.from,
                to: position.to
            };
            let isOnlyTextContent = true;
            let isOnlyBlockContent = true;
            const nodes = $aceda74b73705131$var$isFragment(content) ? content : [
                content
            ];
            nodes.forEach((node)=>{
                // check if added node is valid
                node.check();
                isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
                isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
            });
            // check if we can replace the wrapping node by
            // the newly inserted content
            // example:
            // replace an empty paragraph by an inserted image
            // instead of inserting the image below the paragraph
            if (from === to && isOnlyBlockContent) {
                const { parent: parent } = tr.doc.resolve(from);
                const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
                if (isEmptyTextBlock) {
                    from -= 1;
                    to += 1;
                }
            }
            let newContent;
            // if there is only plain text we have to use `insertText`
            // because this will keep the current marks
            if (isOnlyTextContent) {
                // if value is string, we can use it directly
                // otherwise if it is an array, we have to join it
                if (Array.isArray(value)) newContent = value.map((v)=>v.text || "").join("");
                else if (typeof value === "object" && !!value && !!value.text) newContent = value.text;
                else newContent = value;
                tr.insertText(newContent, from, to);
            } else {
                newContent = content;
                tr.replaceWith(from, to, newContent);
            }
            // set cursor at end of inserted content
            if (options.updateSelection) $aceda74b73705131$export$bf93acd215057ab0(tr, tr.steps.length - 1, -1);
            if (options.applyInputRules) tr.setMeta("applyInputRules", {
                from: from,
                text: newContent
            });
            if (options.applyPasteRules) tr.setMeta("applyPasteRules", {
                from: from,
                text: newContent
            });
        }
        return true;
    };
const $aceda74b73705131$var$joinUp = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$4bb15e6d4372b393)(state, dispatch);
    };
const $aceda74b73705131$var$joinDown = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$8dd967a262b064bb)(state, dispatch);
    };
const $aceda74b73705131$var$joinBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$979097b097459299)(state, dispatch);
    };
const $aceda74b73705131$var$joinForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$bf432e340007f9ef)(state, dispatch);
    };
const $aceda74b73705131$var$joinItemBackward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $62ded6a368f04ea2$export$41b1d4cb5ceb3147)(state.doc, state.selection.$from.pos, -1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch (e) {
            return false;
        }
    };
const $aceda74b73705131$var$joinItemForward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $62ded6a368f04ea2$export$41b1d4cb5ceb3147)(state.doc, state.selection.$from.pos, 1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch (e) {
            return false;
        }
    };
const $aceda74b73705131$var$joinTextblockBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$1dce4f5c74f5f90f)(state, dispatch);
    };
const $aceda74b73705131$var$joinTextblockForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$e796bb96d22be2cd)(state, dispatch);
    };
function $aceda74b73705131$export$6159e43e50a41987() {
    return typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
}
function $aceda74b73705131$var$normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === "Space") result = " ";
    let alt;
    let ctrl;
    let shift;
    let meta;
    for(let i = 0; i < parts.length - 1; i += 1){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($aceda74b73705131$export$86c1a3f9ab33da5c() || $aceda74b73705131$export$6159e43e50a41987()) meta = true;
            else ctrl = true;
        } else throw new Error(`Unrecognized modifier name: ${mod}`);
    }
    if (alt) result = `Alt-${result}`;
    if (ctrl) result = `Ctrl-${result}`;
    if (meta) result = `Meta-${result}`;
    if (shift) result = `Shift-${result}`;
    return result;
}
const $aceda74b73705131$var$keyboardShortcut = (name)=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        const keys = $aceda74b73705131$var$normalizeKeyName(name).split(/-(?!$)/);
        const key = keys.find((item)=>![
                "Alt",
                "Ctrl",
                "Meta",
                "Shift"
            ].includes(item));
        const event = new KeyboardEvent("keydown", {
            key: key === "Space" ? " " : key,
            altKey: keys.includes("Alt"),
            ctrlKey: keys.includes("Ctrl"),
            metaKey: keys.includes("Meta"),
            shiftKey: keys.includes("Shift"),
            bubbles: true,
            cancelable: true
        });
        const capturedTransaction = editor.captureTransaction(()=>{
            view.someProp("handleKeyDown", (f)=>f(view, event));
        });
        capturedTransaction === null || capturedTransaction === void 0 || capturedTransaction.steps.forEach((step)=>{
            const newStep = step.map(tr.mapping);
            if (newStep && dispatch) tr.maybeStep(newStep);
        });
        return true;
    };
function $aceda74b73705131$export$7a24a642b0c7ad29(state, typeOrName, attributes = {}) {
    const { from: from, to: to, empty: empty } = state.selection;
    const type = typeOrName ? $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isText) return;
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node: node,
            from: relativeFrom,
            to: relativeTo
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges.filter((nodeRange)=>{
        if (!type) return true;
        return type.name === nodeRange.node.type.name;
    }).filter((nodeRange)=>$aceda74b73705131$export$7aeb68f71172641d(nodeRange.node.attrs, attributes, {
            strict: false
        }));
    if (empty) return !!matchedNodeRanges.length;
    const range = matchedNodeRanges.reduce((sum, nodeRange)=>sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}
const $aceda74b73705131$var$lift = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $aceda74b73705131$export$7a24a642b0c7ad29(state, type, attributes);
        if (!isActive) return false;
        return (0, $bd35583558ee295f$export$590e8b2c435046d9)(state, dispatch);
    };
const $aceda74b73705131$var$liftEmptyBlock = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$a3574cc681852c08)(state, dispatch);
    };
const $aceda74b73705131$var$liftListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $88fd855d7280fcf4$export$e74cd5adb935a538)(type)(state, dispatch);
    };
const $aceda74b73705131$var$newlineInCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$a5d02b4b65e94f91)(state, dispatch);
    };
/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */ function $aceda74b73705131$export$e501dfcf737a48e0(name, schema) {
    if (schema.nodes[name]) return "node";
    if (schema.marks[name]) return "mark";
    return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */ function $aceda74b73705131$export$8694e5c03a4df8e6(obj, propOrProps) {
    const props = typeof propOrProps === "string" ? [
        propOrProps
    ] : propOrProps;
    return Object.keys(obj).reduce((newObj, prop)=>{
        if (!props.includes(prop)) newObj[prop] = obj[prop];
        return newObj;
    }, {});
}
const $aceda74b73705131$var$resetAttributes = (typeOrName, attributes)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $aceda74b73705131$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === "node") nodeType = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === "mark") markType = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, $aceda74b73705131$export$8694e5c03a4df8e6(node.attrs, attributes));
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(pos, pos + node.nodeSize, markType.create($aceda74b73705131$export$8694e5c03a4df8e6(mark.attrs, attributes)));
                });
            });
        });
        return true;
    };
const $aceda74b73705131$var$scrollIntoView = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) tr.scrollIntoView();
        return true;
    };
const $aceda74b73705131$var$selectAll = ()=>({ tr: tr, commands: commands })=>{
        return commands.setTextSelection({
            from: 0,
            to: tr.doc.content.size
        });
    };
const $aceda74b73705131$var$selectNodeBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$52b8a4af68d19794)(state, dispatch);
    };
const $aceda74b73705131$var$selectNodeForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$5835b52680b80cfd)(state, dispatch);
    };
const $aceda74b73705131$var$selectParentNode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$a37f6aaa9169911d)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $aceda74b73705131$var$selectTextblockEnd = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$a66c1876556415e5)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $aceda74b73705131$var$selectTextblockStart = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $bd35583558ee295f$export$c3a64f3c9604a1b1)(state, dispatch);
    };
/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */ function $aceda74b73705131$export$37330def6e48b4c9(content, schema, parseOptions = {}, options = {}) {
    return $aceda74b73705131$export$12c64e96dddaee61(content, schema, {
        slice: false,
        parseOptions: parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent
    });
}
const $aceda74b73705131$var$setContent = (content, emitUpdate = false, parseOptions = {}, options = {})=>({ editor: editor, tr: tr, dispatch: dispatch, commands: commands })=>{
        var _a, _b;
        const { doc: doc } = tr;
        // This is to keep backward compatibility with the previous behavior
        // TODO remove this in the next major version
        if (parseOptions.preserveWhitespace !== "full") {
            const document1 = $aceda74b73705131$export$37330def6e48b4c9(content, editor.schema, parseOptions, {
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
            });
            if (dispatch) tr.replaceWith(0, doc.content.size, document1).setMeta("preventUpdate", !emitUpdate);
            return true;
        }
        if (dispatch) tr.setMeta("preventUpdate", !emitUpdate);
        return commands.insertContentAt({
            from: 0,
            to: doc.content.size
        }, content, {
            parseOptions: parseOptions,
            errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck
        });
    };
function $aceda74b73705131$export$2cd1d0e1f861bae0(state, typeOrName) {
    const type = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
    const { from: from, to: to, empty: empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) marks.push(...state.storedMarks);
        marks.push(...state.selection.$head.marks());
    } else state.doc.nodesBetween(from, to, (node)=>{
        marks.push(...node.marks);
    });
    const mark = marks.find((markItem)=>markItem.type.name === type.name);
    if (!mark) return {};
    return {
        ...mark.attrs
    };
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */ function $aceda74b73705131$export$f945f1716a5df33d(oldDoc, transactions) {
    const transform = new (0, $62ded6a368f04ea2$export$563a914cafbdc389)(oldDoc);
    transactions.forEach((transaction)=>{
        transaction.steps.forEach((step)=>{
            transform.step(step);
        });
    });
    return transform;
}
/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */ function $aceda74b73705131$export$6133a2de0e8ac885(match) {
    for(let i = 0; i < match.edgeCount; i += 1){
        const { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $aceda74b73705131$export$f94ca194e830789c(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $aceda74b73705131$export$6a2a251dde98a23(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */ function $aceda74b73705131$export$fe09644e3bc6166b($pos, predicate) {
    for(let i = $pos.depth; i > 0; i -= 1){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
}
/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */ function $aceda74b73705131$export$dc159056ffdb4c76(predicate) {
    return (selection)=>$aceda74b73705131$export$fe09644e3bc6166b(selection.$from, predicate);
}
function $aceda74b73705131$export$d1b60002472b2c81(fragment, schema) {
    const documentFragment = (0, $d7ba288a9be229df$export$3476b78f8f5a8b72).fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement("div");
    container.appendChild(documentFragment);
    return container.innerHTML;
}
function $aceda74b73705131$export$19a621270f26273c(extensions, editor) {
    const resolvedExtensions = $aceda74b73705131$var$ExtensionManager.resolve(extensions);
    return $aceda74b73705131$export$71bc12a97b59a858(resolvedExtensions, editor);
}
/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */ function $aceda74b73705131$export$4f413073eb19378c(doc, extensions) {
    const schema = $aceda74b73705131$export$19a621270f26273c(extensions);
    const contentNode = (0, $d7ba288a9be229df$export$85c928794f8d04d4).fromJSON(schema, doc);
    return $aceda74b73705131$export$d1b60002472b2c81(contentNode.content, schema);
}
/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */ function $aceda74b73705131$export$d23738d50f257f47(html, extensions) {
    const schema = $aceda74b73705131$export$19a621270f26273c(extensions);
    const dom = $aceda74b73705131$export$1b93bf03550cde01(html);
    return (0, $d7ba288a9be229df$export$1059c6e7d2ce5669).fromSchema(schema).parse(dom).toJSON();
}
/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */ function $aceda74b73705131$export$c72d34660a162238(node, options) {
    const range = {
        from: 0,
        to: node.content.size
    };
    return $aceda74b73705131$export$6e5992a7455d9ef6(node, range, options);
}
/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */ function $aceda74b73705131$export$43625cf01e0b7b62(doc, extensions, options) {
    const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
    const schema = $aceda74b73705131$export$19a621270f26273c(extensions);
    const contentNode = (0, $d7ba288a9be229df$export$85c928794f8d04d4).fromJSON(schema, doc);
    return $aceda74b73705131$export$c72d34660a162238(contentNode, {
        blockSeparator: blockSeparator,
        textSerializers: {
            ...$aceda74b73705131$export$fdd92b7d22ac071c(schema),
            ...textSerializers
        }
    });
}
function $aceda74b73705131$export$e8c6736926dcac42(state, typeOrName) {
    const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
    const { from: from, to: to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, (node)=>{
        nodes.push(node);
    });
    const node = nodes.reverse().find((nodeItem)=>nodeItem.type.name === type.name);
    if (!node) return {};
    return {
        ...node.attrs
    };
}
/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */ function $aceda74b73705131$export$fe94072fee8a6976(state, typeOrName) {
    const schemaType = $aceda74b73705131$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === "node") return $aceda74b73705131$export$e8c6736926dcac42(state, typeOrName);
    if (schemaType === "mark") return $aceda74b73705131$export$2cd1d0e1f861bae0(state, typeOrName);
    return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */ function $aceda74b73705131$export$2e2262a44ac61957(array, by = JSON.stringify) {
    const seen = {};
    return array.filter((item)=>{
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
    });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */ function $aceda74b73705131$var$simplifyChangedRanges(changes) {
    const uniqueChanges = $aceda74b73705131$export$2e2262a44ac61957(changes);
    return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index)=>{
        const rest = uniqueChanges.filter((_, i)=>i !== index);
        return !rest.some((otherChange)=>{
            return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
        });
    });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */ function $aceda74b73705131$export$ba396fc65ff2f439(transform) {
    const { mapping: mapping, steps: steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index)=>{
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from: from, to: to } = steps[index];
            if (from === undefined || to === undefined) return;
            ranges.push({
                from: from,
                to: to
            });
        } else stepMap.forEach((from, to)=>{
            ranges.push({
                from: from,
                to: to
            });
        });
        ranges.forEach(({ from: from, to: to })=>{
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd
                },
                newRange: {
                    from: newStart,
                    to: newEnd
                }
            });
        });
    });
    return $aceda74b73705131$var$simplifyChangedRanges(changes);
}
function $aceda74b73705131$export$d661e0733145fb37(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map((mark)=>{
        const output = {
            type: mark.type.name
        };
        if (Object.keys(mark.attrs).length) output.attrs = {
            ...mark.attrs
        };
        return output;
    });
    const attrs = {
        ...node.attrs
    };
    const output = {
        type: node.type.name,
        from: from,
        to: to
    };
    if (Object.keys(attrs).length) output.attrs = attrs;
    if (marks.length) output.marks = marks;
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset)=>{
            var _a;
            (_a = output.content) === null || _a === void 0 || _a.push($aceda74b73705131$export$d661e0733145fb37(child, startOffset + offset + increment));
        });
    }
    if (node.text) output.text = node.text;
    return output;
}
function $aceda74b73705131$export$c5fd7af7c5c1efa(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) doc.resolve(from).marks().forEach((mark)=>{
        const $pos = doc.resolve(from);
        const range = $aceda74b73705131$export$8ceae6d06f5c4df5($pos, mark.type);
        if (!range) return;
        marks.push({
            mark: mark,
            ...range
        });
    });
    else doc.nodesBetween(from, to, (node, pos)=>{
        if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) return;
        marks.push(...node.marks.map((mark)=>({
                from: pos,
                to: pos + node.nodeSize,
                mark: mark
            })));
    });
    return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */ const $aceda74b73705131$export$ee90757e11fae7cd = (state, typeOrName, pos, maxDepth = 20)=>{
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while(currentDepth > 0 && node === null){
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) node = currentNode;
        else currentDepth -= 1;
    }
    return [
        node,
        currentDepth
    ];
};
/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */ function $aceda74b73705131$export$49b565bbca5fba3a(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object.entries(attributes).filter(([name])=>{
        const extensionAttribute = extensionAttributes.find((item)=>{
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) return false;
        return extensionAttribute.attribute.keepOnSplit;
    }));
}
function $aceda74b73705131$export$72001287e2a5b413(state, typeOrName, attributes = {}) {
    const { empty: empty, ranges: ranges } = state.selection;
    const type = typeOrName ? $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema) : null;
    if (empty) return !!(state.storedMarks || state.selection.$from.marks()).filter((mark)=>{
        if (!type) return true;
        return type.name === mark.type.name;
    }).find((mark)=>$aceda74b73705131$export$7aeb68f71172641d(mark.attrs, attributes, {
            strict: false
        }));
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from: $from, $to: $to })=>{
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isText && !node.marks.length) return;
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map((mark)=>({
                    mark: mark,
                    from: relativeFrom,
                    to: relativeTo
                })));
        });
    });
    if (selectionRange === 0) return false;
    // calculate range of matched mark
    const matchedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return type.name === markRange.mark.type.name;
    }).filter((markRange)=>$aceda74b73705131$export$7aeb68f71172641d(markRange.mark.attrs, attributes, {
            strict: false
        })).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    }).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}
function $aceda74b73705131$export$39e04e72f972b885(state, name, attributes = {}) {
    if (!name) return $aceda74b73705131$export$7a24a642b0c7ad29(state, null, attributes) || $aceda74b73705131$export$72001287e2a5b413(state, null, attributes);
    const schemaType = $aceda74b73705131$export$e501dfcf737a48e0(name, state.schema);
    if (schemaType === "node") return $aceda74b73705131$export$7a24a642b0c7ad29(state, name, attributes);
    if (schemaType === "mark") return $aceda74b73705131$export$72001287e2a5b413(state, name, attributes);
    return false;
}
const $aceda74b73705131$export$6a042f9d56fb39ec = (state, nodeType)=>{
    const { $from: $from, $to: $to, $anchor: $anchor } = state.selection;
    if (nodeType) {
        const parentNode = $aceda74b73705131$export$dc159056ffdb4c76((node)=>node.type.name === nodeType)(state.selection);
        if (!parentNode) return false;
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) return true;
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) return false;
    return true;
};
const $aceda74b73705131$export$d0aa6c7595396956 = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) return false;
    return true;
};
function $aceda74b73705131$export$ead95ff48ba53ffd(name, extensions) {
    const { nodeExtensions: nodeExtensions } = $aceda74b73705131$export$36e8c2990da8266f(extensions);
    const extension = nodeExtensions.find((item)=>item.name === name);
    if (!extension) return false;
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage
    };
    const group = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "group", context));
    if (typeof group !== "string") return false;
    return group.split(" ").includes("list");
}
/**
 * Returns true if the given prosemirror node is empty.
 */ function $aceda74b73705131$export$cd58ff1081f6abe9(node, { checkChildren: checkChildren = true, ignoreWhitespace: ignoreWhitespace = false } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === "hardBreak") // Hard breaks are considered empty
        return true;
        if (node.isText) return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : "");
    }
    if (node.isText) return !node.text;
    if (node.isAtom || node.isLeaf) return false;
    if (node.content.childCount === 0) return true;
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach((childNode)=>{
            if (isContentEmpty === false) // Exit early for perf
            return;
            if (!$aceda74b73705131$export$cd58ff1081f6abe9(childNode, {
                ignoreWhitespace: ignoreWhitespace,
                checkChildren: checkChildren
            })) isContentEmpty = false;
        });
        return isContentEmpty;
    }
    return false;
}
function $aceda74b73705131$export$a8c1d2c13abf8822(value) {
    return value instanceof (0, $c286ea535d926598$export$e2940151ac854c0b);
}
function $aceda74b73705131$export$660ecae6cde71645(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = $aceda74b73705131$export$6fb785c609d82593(from, minPos, maxPos);
    const resolvedEnd = $aceda74b73705131$export$6fb785c609d82593(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        x: x,
        y: y
    };
    return {
        ...data,
        toJSON: ()=>data
    };
}
function $aceda74b73705131$var$canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection: selection } = tr;
    let cursor = null;
    if ($aceda74b73705131$export$38b50bf35e79aaf3(selection)) cursor = selection.$cursor;
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark)=>mark.type.excludes(newMarkType));
    }
    const { ranges: ranges } = selection;
    return ranges.some(({ $from: $from, $to: $to })=>{
        let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent)=>{
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) return false;
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark)=>otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const $aceda74b73705131$var$setMark = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        const type = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) {
            if (empty) {
                const oldAttributes = $aceda74b73705131$export$2cd1d0e1f861bae0(state, type);
                tr.addStoredMark(type.create({
                    ...oldAttributes,
                    ...attributes
                }));
            } else ranges.forEach((range)=>{
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find((mark)=>mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) node.marks.forEach((mark)=>{
                        if (type === mark.type) tr.addMark(trimmedFrom, trimmedTo, type.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    });
                    else tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                });
            });
        }
        return $aceda74b73705131$var$canSetMark(state, tr, type);
    };
const $aceda74b73705131$var$setMeta = (key, value)=>({ tr: tr })=>{
        tr.setMeta(key, value);
        return true;
    };
const $aceda74b73705131$var$setNode = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch, chain: chain })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        // TODO: use a fallback like insertContent?
        if (!type.isTextblock) {
            console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
            return false;
        }
        return chain()// try to convert node to default node if needed
        .command(({ commands: commands })=>{
            const canSetBlock = (0, $bd35583558ee295f$export$36987f561c736aad)(type, attributes)(state);
            if (canSetBlock) return true;
            return commands.clearNodes();
        }).command(({ state: updatedState })=>{
            return (0, $bd35583558ee295f$export$36987f561c736aad)(type, attributes)(updatedState, dispatch);
        }).run();
    };
const $aceda74b73705131$var$setNodeSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const from = $aceda74b73705131$export$6fb785c609d82593(position, 0, doc.content.size);
            const selection = (0, $c286ea535d926598$export$e2940151ac854c0b).create(doc, from);
            tr.setSelection(selection);
        }
        return true;
    };
const $aceda74b73705131$var$setTextSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const { from: from, to: to } = typeof position === "number" ? {
                from: position,
                to: position
            } : position;
            const minPos = (0, $c286ea535d926598$export$c2b25f346d19bcbb).atStart(doc).from;
            const maxPos = (0, $c286ea535d926598$export$c2b25f346d19bcbb).atEnd(doc).to;
            const resolvedFrom = $aceda74b73705131$export$6fb785c609d82593(from, minPos, maxPos);
            const resolvedEnd = $aceda74b73705131$export$6fb785c609d82593(to, minPos, maxPos);
            const selection = (0, $c286ea535d926598$export$c2b25f346d19bcbb).create(doc, resolvedFrom, resolvedEnd);
            tr.setSelection(selection);
        }
        return true;
    };
const $aceda74b73705131$var$sinkListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $88fd855d7280fcf4$export$dd505f850a3798a4)(type)(state, dispatch);
    };
function $aceda74b73705131$var$ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) {
        const filteredMarks = marks.filter((mark)=>splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const $aceda74b73705131$var$splitBlock = ({ keepMarks: keepMarks = true } = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        const { selection: selection, doc: doc } = tr;
        const { $from: $from, $to: $to } = selection;
        const extensionAttributes = editor.extensionManager.attributes;
        const newAttributes = $aceda74b73705131$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
        if (selection instanceof (0, $c286ea535d926598$export$e2940151ac854c0b) && selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $62ded6a368f04ea2$export$5aaf008897aef029)(doc, $from.pos)) return false;
            if (dispatch) {
                if (keepMarks) $aceda74b73705131$var$ensureMarks(state, editor.extensionManager.splittableMarks);
                tr.split($from.pos).scrollIntoView();
            }
            return true;
        }
        if (!$from.parent.isBlock) return false;
        const atEnd = $to.parentOffset === $to.parent.content.size;
        const deflt = $from.depth === 0 ? undefined : $aceda74b73705131$export$6133a2de0e8ac885($from.node(-1).contentMatchAt($from.indexAfter(-1)));
        let types = atEnd && deflt ? [
            {
                type: deflt,
                attrs: newAttributes
            }
        ] : undefined;
        let can = (0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, types);
        if (!types && !can && (0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
            {
                type: deflt
            }
        ] : undefined)) {
            can = true;
            types = deflt ? [
                {
                    type: deflt,
                    attrs: newAttributes
                }
            ] : undefined;
        }
        if (dispatch) {
            if (can) {
                if (selection instanceof (0, $c286ea535d926598$export$c2b25f346d19bcbb)) tr.deleteSelection();
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                    const first = tr.mapping.map($from.before());
                    const $first = tr.doc.resolve(first);
                    if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            if (keepMarks) $aceda74b73705131$var$ensureMarks(state, editor.extensionManager.splittableMarks);
            tr.scrollIntoView();
        }
        return can;
    };
const $aceda74b73705131$var$splitListItem = (typeOrName, overrideAttrs = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        var _a;
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        const { $from: $from, $to: $to } = state.selection;
        // @ts-ignore
        // eslint-disable-next-line
        const node = state.selection.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        const grandParent = $from.node(-1);
        if (grandParent.type !== type) return false;
        const extensionAttributes = editor.extensionManager.attributes;
        if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).empty;
                // eslint-disable-next-line
                const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1)wrap = (0, $d7ba288a9be229df$export$ffb0004e005737fa).from($from.node(d).copy(wrap));
                // eslint-disable-next-line
                const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                const newNextTypeAttributes = {
                    ...$aceda74b73705131$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
                    ...overrideAttrs
                };
                const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
                wrap = wrap.append((0, $d7ba288a9be229df$export$ffb0004e005737fa).from(type.createAndFill(null, nextType) || undefined));
                const start = $from.before($from.depth - (depthBefore - 1));
                tr.replace(start, $from.after(-depthAfter), new (0, $d7ba288a9be229df$export$b3f2e2de3a8baa1e)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos)=>{
                    if (sel > -1) return false;
                    if (n.isTextblock && n.content.size === 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $c286ea535d926598$export$c2b25f346d19bcbb).near(tr.doc.resolve(sel)));
                tr.scrollIntoView();
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const newTypeAttributes = {
            ...$aceda74b73705131$export$49b565bbca5fba3a(extensionAttributes, grandParent.type.name, grandParent.attrs),
            ...overrideAttrs
        };
        const newNextTypeAttributes = {
            ...$aceda74b73705131$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
            ...overrideAttrs
        };
        tr.delete($from.pos, $to.pos);
        const types = nextType ? [
            {
                type: type,
                attrs: newTypeAttributes
            },
            {
                type: nextType,
                attrs: newNextTypeAttributes
            }
        ] : [
            {
                type: type,
                attrs: newTypeAttributes
            }
        ];
        if (!(0, $62ded6a368f04ea2$export$5aaf008897aef029)(tr.doc, $from.pos, 2)) return false;
        if (dispatch) {
            const { selection: selection, storedMarks: storedMarks } = state;
            const { splittableMarks: splittableMarks } = editor.extensionManager;
            const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
            tr.split($from.pos, 2, types).scrollIntoView();
            if (!marks || !dispatch) return true;
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
        }
        return true;
    };
const $aceda74b73705131$var$joinListBackwards = (tr, listType)=>{
    const list = $aceda74b73705131$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) return true;
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && (0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(tr.doc, list.pos);
    if (!canJoinBackwards) return true;
    tr.join(list.pos);
    return true;
};
const $aceda74b73705131$var$joinListForwards = (tr, listType)=>{
    const list = $aceda74b73705131$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) return true;
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && (0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(tr.doc, after);
    if (!canJoinForwards) return true;
    tr.join(after);
    return true;
};
const $aceda74b73705131$var$toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {})=>({ editor: editor, tr: tr, state: state, dispatch: dispatch, chain: chain, commands: commands, can: can })=>{
        const { extensions: extensions, splittableMarks: splittableMarks } = editor.extensionManager;
        const listType = $aceda74b73705131$export$d168cba70360dd3d(listTypeOrName, state.schema);
        const itemType = $aceda74b73705131$export$d168cba70360dd3d(itemTypeOrName, state.schema);
        const { selection: selection, storedMarks: storedMarks } = state;
        const { $from: $from, $to: $to } = selection;
        const range = $from.blockRange($to);
        const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
        if (!range) return false;
        const parentList = $aceda74b73705131$export$dc159056ffdb4c76((node)=>$aceda74b73705131$export$ead95ff48ba53ffd(node.type.name, extensions))(selection);
        if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
            // remove list
            if (parentList.node.type === listType) return commands.liftListItem(itemType);
            // change list type
            if ($aceda74b73705131$export$ead95ff48ba53ffd(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) return chain().command(()=>{
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            }).command(()=>$aceda74b73705131$var$joinListBackwards(tr, listType)).command(()=>$aceda74b73705131$var$joinListForwards(tr, listType)).run();
        }
        if (!keepMarks || !marks || !dispatch) return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$aceda74b73705131$var$joinListBackwards(tr, listType)).command(()=>$aceda74b73705131$var$joinListForwards(tr, listType)).run();
        return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$aceda74b73705131$var$joinListBackwards(tr, listType)).command(()=>$aceda74b73705131$var$joinListForwards(tr, listType)).run();
    };
const $aceda74b73705131$var$toggleMark = (typeOrName, attributes = {}, options = {})=>({ state: state, commands: commands })=>{
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const type = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const isActive = $aceda74b73705131$export$72001287e2a5b413(state, type, attributes);
        if (isActive) return commands.unsetMark(type, {
            extendEmptyMarkRange: extendEmptyMarkRange
        });
        return commands.setMark(type, attributes);
    };
const $aceda74b73705131$var$toggleNode = (typeOrName, toggleTypeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        const toggleType = $aceda74b73705131$export$d168cba70360dd3d(toggleTypeOrName, state.schema);
        const isActive = $aceda74b73705131$export$7a24a642b0c7ad29(state, type, attributes);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        if (isActive) return commands.setNode(toggleType, attributesToCopy);
        // If the node is not active, we want to set the new node type with the given attributes
        // Copying over the attributes from the current node if the selection is pointing to a node of the same type
        return commands.setNode(type, {
            ...attributesToCopy,
            ...attributes
        });
    };
const $aceda74b73705131$var$toggleWrap = (typeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $aceda74b73705131$export$7a24a642b0c7ad29(state, type, attributes);
        if (isActive) return commands.lift(type);
        return commands.wrapIn(type, attributes);
    };
const $aceda74b73705131$var$undoInputRule = ()=>({ state: state, dispatch: dispatch })=>{
        const plugins = state.plugins;
        for(let i = 0; i < plugins.length; i += 1){
            const plugin = plugins[i];
            let undoable;
            // @ts-ignore
            // eslint-disable-next-line
            if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
                if (dispatch) {
                    const tr = state.tr;
                    const toUndo = undoable.transform;
                    for(let j = toUndo.steps.length - 1; j >= 0; j -= 1)tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                    if (undoable.text) {
                        const marks = tr.doc.resolve(undoable.from).marks();
                        tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                    } else tr.delete(undoable.from, undoable.to);
                }
                return true;
            }
        }
        return false;
    };
const $aceda74b73705131$var$unsetAllMarks = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        if (empty) return true;
        if (dispatch) ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
        return true;
    };
const $aceda74b73705131$var$unsetMark = (typeOrName, options = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        var _a;
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const { selection: selection } = tr;
        const type = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { $from: $from, empty: empty, ranges: ranges } = selection;
        if (!dispatch) return true;
        if (empty && extendEmptyMarkRange) {
            let { from: from, to: to } = selection;
            const attrs = (_a = $from.marks().find((mark)=>mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
            const range = $aceda74b73705131$export$8ceae6d06f5c4df5($from, type, attrs);
            if (range) {
                from = range.from;
                to = range.to;
            }
            tr.removeMark(from, to, type);
        } else ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
        tr.removeStoredMark(type);
        return true;
    };
const $aceda74b73705131$var$updateAttributes = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $aceda74b73705131$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === "node") nodeType = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === "mark") markType = $aceda74b73705131$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            const from = range.$from.pos;
            const to = range.$to.pos;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    ...attributes
                });
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) {
                        const trimmedFrom = Math.max(pos, from);
                        const trimmedTo = Math.min(pos + node.nodeSize, to);
                        tr.addMark(trimmedFrom, trimmedTo, markType.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    }
                });
            });
        });
        return true;
    };
const $aceda74b73705131$var$wrapIn = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $bd35583558ee295f$export$6e5e3c49755affd0)(type, attributes)(state, dispatch);
    };
const $aceda74b73705131$var$wrapInList = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $aceda74b73705131$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $88fd855d7280fcf4$export$a8aef45c6262afee)(type, attributes)(state, dispatch);
    };
var $aceda74b73705131$var$commands = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blur: $aceda74b73705131$var$blur,
    clearContent: $aceda74b73705131$var$clearContent,
    clearNodes: $aceda74b73705131$var$clearNodes,
    command: $aceda74b73705131$var$command,
    createParagraphNear: $aceda74b73705131$var$createParagraphNear,
    cut: $aceda74b73705131$var$cut,
    deleteCurrentNode: $aceda74b73705131$var$deleteCurrentNode,
    deleteNode: $aceda74b73705131$var$deleteNode,
    deleteRange: $aceda74b73705131$var$deleteRange,
    deleteSelection: $aceda74b73705131$var$deleteSelection,
    enter: $aceda74b73705131$var$enter,
    exitCode: $aceda74b73705131$var$exitCode,
    extendMarkRange: $aceda74b73705131$var$extendMarkRange,
    first: $aceda74b73705131$var$first,
    focus: $aceda74b73705131$var$focus,
    forEach: $aceda74b73705131$var$forEach,
    insertContent: $aceda74b73705131$var$insertContent,
    insertContentAt: $aceda74b73705131$var$insertContentAt,
    joinBackward: $aceda74b73705131$var$joinBackward,
    joinDown: $aceda74b73705131$var$joinDown,
    joinForward: $aceda74b73705131$var$joinForward,
    joinItemBackward: $aceda74b73705131$var$joinItemBackward,
    joinItemForward: $aceda74b73705131$var$joinItemForward,
    joinTextblockBackward: $aceda74b73705131$var$joinTextblockBackward,
    joinTextblockForward: $aceda74b73705131$var$joinTextblockForward,
    joinUp: $aceda74b73705131$var$joinUp,
    keyboardShortcut: $aceda74b73705131$var$keyboardShortcut,
    lift: $aceda74b73705131$var$lift,
    liftEmptyBlock: $aceda74b73705131$var$liftEmptyBlock,
    liftListItem: $aceda74b73705131$var$liftListItem,
    newlineInCode: $aceda74b73705131$var$newlineInCode,
    resetAttributes: $aceda74b73705131$var$resetAttributes,
    scrollIntoView: $aceda74b73705131$var$scrollIntoView,
    selectAll: $aceda74b73705131$var$selectAll,
    selectNodeBackward: $aceda74b73705131$var$selectNodeBackward,
    selectNodeForward: $aceda74b73705131$var$selectNodeForward,
    selectParentNode: $aceda74b73705131$var$selectParentNode,
    selectTextblockEnd: $aceda74b73705131$var$selectTextblockEnd,
    selectTextblockStart: $aceda74b73705131$var$selectTextblockStart,
    setContent: $aceda74b73705131$var$setContent,
    setMark: $aceda74b73705131$var$setMark,
    setMeta: $aceda74b73705131$var$setMeta,
    setNode: $aceda74b73705131$var$setNode,
    setNodeSelection: $aceda74b73705131$var$setNodeSelection,
    setTextSelection: $aceda74b73705131$var$setTextSelection,
    sinkListItem: $aceda74b73705131$var$sinkListItem,
    splitBlock: $aceda74b73705131$var$splitBlock,
    splitListItem: $aceda74b73705131$var$splitListItem,
    toggleList: $aceda74b73705131$var$toggleList,
    toggleMark: $aceda74b73705131$var$toggleMark,
    toggleNode: $aceda74b73705131$var$toggleNode,
    toggleWrap: $aceda74b73705131$var$toggleWrap,
    undoInputRule: $aceda74b73705131$var$undoInputRule,
    unsetAllMarks: $aceda74b73705131$var$unsetAllMarks,
    unsetMark: $aceda74b73705131$var$unsetMark,
    updateAttributes: $aceda74b73705131$var$updateAttributes,
    wrapIn: $aceda74b73705131$var$wrapIn,
    wrapInList: $aceda74b73705131$var$wrapInList
});
const $aceda74b73705131$var$Commands = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "commands",
    addCommands () {
        return {
            ...$aceda74b73705131$var$commands
        };
    }
});
const $aceda74b73705131$var$Drop = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "drop",
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("tiptapDrop"),
                props: {
                    handleDrop: (_, e, slice, moved)=>{
                        this.editor.emit("drop", {
                            editor: this.editor,
                            event: e,
                            slice: slice,
                            moved: moved
                        });
                    }
                }
            })
        ];
    }
});
const $aceda74b73705131$var$Editable = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "editable",
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("editable"),
                props: {
                    editable: ()=>this.editor.options.editable
                }
            })
        ];
    }
});
const $aceda74b73705131$var$FocusEvents = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "focusEvents",
    addProseMirrorPlugins () {
        const { editor: editor } = this;
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("focusEvents"),
                props: {
                    handleDOMEvents: {
                        focus: (view, event)=>{
                            editor.isFocused = true;
                            const transaction = editor.state.tr.setMeta("focus", {
                                event: event
                            }).setMeta("addToHistory", false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event)=>{
                            editor.isFocused = false;
                            const transaction = editor.state.tr.setMeta("blur", {
                                event: event
                            }).setMeta("addToHistory", false);
                            view.dispatch(transaction);
                            return false;
                        }
                    }
                }
            })
        ];
    }
});
const $aceda74b73705131$var$Keymap = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "keymap",
    addKeyboardShortcuts () {
        const handleBackspace = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.undoInputRule(),
                    // maybe convert first text block node to default node
                    ()=>commands.command(({ tr: tr })=>{
                            const { selection: selection, doc: doc } = tr;
                            const { empty: empty, $anchor: $anchor } = selection;
                            const { pos: pos, parent: parent } = $anchor;
                            const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                            const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                            const parentPos = $anchor.pos - $anchor.parentOffset;
                            const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : (0, $c286ea535d926598$export$52baac22726c72bf).atStart(doc).from === pos;
                            if (!empty || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === "paragraph" // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                            ) return false;
                            return commands.clearNodes();
                        }),
                    ()=>commands.deleteSelection(),
                    ()=>commands.joinBackward(),
                    ()=>commands.selectNodeBackward()
                ]);
        const handleDelete = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.deleteSelection(),
                    ()=>commands.deleteCurrentNode(),
                    ()=>commands.joinForward(),
                    ()=>commands.selectNodeForward()
                ]);
        const handleEnter = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.newlineInCode(),
                    ()=>commands.createParagraphNear(),
                    ()=>commands.liftEmptyBlock(),
                    ()=>commands.splitBlock()
                ]);
        const baseKeymap = {
            Enter: handleEnter,
            "Mod-Enter": ()=>this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            "Mod-Backspace": handleBackspace,
            "Shift-Backspace": handleBackspace,
            Delete: handleDelete,
            "Mod-Delete": handleDelete,
            "Mod-a": ()=>this.editor.commands.selectAll()
        };
        const pcKeymap = {
            ...baseKeymap
        };
        const macKeymap = {
            ...baseKeymap,
            "Ctrl-h": handleBackspace,
            "Alt-Backspace": handleBackspace,
            "Ctrl-d": handleDelete,
            "Ctrl-Alt-Backspace": handleDelete,
            "Alt-Delete": handleDelete,
            "Alt-d": handleDelete,
            "Ctrl-a": ()=>this.editor.commands.selectTextblockStart(),
            "Ctrl-e": ()=>this.editor.commands.selectTextblockEnd()
        };
        if ($aceda74b73705131$export$86c1a3f9ab33da5c() || $aceda74b73705131$export$6159e43e50a41987()) return macKeymap;
        return pcKeymap;
    },
    addProseMirrorPlugins () {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("clearDocument"),
                appendTransaction: (transactions, oldState, newState)=>{
                    const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some((transaction)=>transaction.getMeta("preventClearDocument"));
                    if (!docChanges || ignoreTr) return;
                    const { empty: empty, from: from, to: to } = oldState.selection;
                    const allFrom = (0, $c286ea535d926598$export$52baac22726c72bf).atStart(oldState.doc).from;
                    const allEnd = (0, $c286ea535d926598$export$52baac22726c72bf).atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) return;
                    const isEmpty = $aceda74b73705131$export$cd58ff1081f6abe9(newState.doc);
                    if (!isEmpty) return;
                    const tr = newState.tr;
                    const state = $aceda74b73705131$export$83e24c5933427696({
                        state: newState,
                        transaction: tr
                    });
                    const { commands: commands } = new $aceda74b73705131$export$475014de15a4c342({
                        editor: this.editor,
                        state: state
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) return;
                    return tr;
                }
            })
        ];
    }
});
const $aceda74b73705131$var$Paste = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "paste",
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("tiptapPaste"),
                props: {
                    handlePaste: (_view, e, slice)=>{
                        this.editor.emit("paste", {
                            editor: this.editor,
                            event: e,
                            slice: slice
                        });
                    }
                }
            })
        ];
    }
});
const $aceda74b73705131$var$Tabindex = $aceda74b73705131$export$eeddbf09bb970356.create({
    name: "tabindex",
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("tabindex"),
                props: {
                    attributes: ()=>this.editor.isEditable ? {
                            tabindex: "0"
                        } : {}
                }
            })
        ];
    }
});
var $aceda74b73705131$export$cc3e2d3244e01b7f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ClipboardTextSerializer: $aceda74b73705131$var$ClipboardTextSerializer,
    Commands: $aceda74b73705131$var$Commands,
    Drop: $aceda74b73705131$var$Drop,
    Editable: $aceda74b73705131$var$Editable,
    FocusEvents: $aceda74b73705131$var$FocusEvents,
    Keymap: $aceda74b73705131$var$Keymap,
    Paste: $aceda74b73705131$var$Paste,
    Tabindex: $aceda74b73705131$var$Tabindex
});
class $aceda74b73705131$export$50c0270e74640068 {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null){
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can\u{2019}t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({
            from: from,
            to: to
        }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) return this.pos;
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to
        };
    }
    get to() {
        if (this.isBlock) return this.pos + this.size;
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) return null;
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new $aceda74b73705131$export$50c0270e74640068($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.from - 3);
        return new $aceda74b73705131$export$50c0270e74640068($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.to + 3);
        return new $aceda74b73705131$export$50c0270e74640068($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset)=>{
            const isBlock = node.isBlock && !node.isTextblock;
            const targetPos = this.pos + offset + 1;
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) return;
            const childNodePos = new $aceda74b73705131$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) childNodePos.actualDepth = this.depth + 1;
            children.push(new $aceda74b73705131$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while(currentNode && !node){
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for(let index = 0; index < attrKeys.length; index += 1){
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) break;
                    }
                } else node = currentNode;
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) return nodes;
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */ this.children.forEach((childPos)=>{
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) return;
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every((key)=>attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) nodes.push(childPos);
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) return;
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const oldSelection = this.editor.state.selection;
        this.editor.chain().setTextSelection(this.from).updateAttributes(this.node.type.name, attributes).setTextSelection(oldSelection.from).run();
    }
}
const $aceda74b73705131$var$style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function $aceda74b73705131$export$48321b481dd8a36(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ""}]`);
    if (tiptapStyleTag !== null) return tiptapStyleTag;
    const styleNode = document.createElement("style");
    if (nonce) styleNode.setAttribute("nonce", nonce);
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ""}`, "");
    styleNode.innerHTML = style;
    document.getElementsByTagName("head")[0].appendChild(styleNode);
    return styleNode;
}
class $aceda74b73705131$export$7cda8d932e2f33c0 extends $aceda74b73705131$var$EventEmitter {
    constructor(options = {}){
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */ this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement("div"),
            content: "",
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            onBeforeCreate: ()=>null,
            onCreate: ()=>null,
            onUpdate: ()=>null,
            onSelectionUpdate: ()=>null,
            onTransaction: ()=>null,
            onFocus: ()=>null,
            onBlur: ()=>null,
            onDestroy: ()=>null,
            onContentError: ({ error: error })=>{
                throw error;
            },
            onPaste: ()=>null,
            onDrop: ()=>null
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on("beforeCreate", this.options.onBeforeCreate);
        this.emit("beforeCreate", {
            editor: this
        });
        this.on("contentError", this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on("create", this.options.onCreate);
        this.on("update", this.options.onUpdate);
        this.on("selectionUpdate", this.options.onSelectionUpdate);
        this.on("transaction", this.options.onTransaction);
        this.on("focus", this.options.onFocus);
        this.on("blur", this.options.onBlur);
        this.on("destroy", this.options.onDestroy);
        this.on("drop", ({ event: event, slice: slice, moved: moved })=>this.options.onDrop(event, slice, moved));
        this.on("paste", ({ event: event, slice: slice })=>this.options.onPaste(event, slice));
        window.setTimeout(()=>{
            if (this.isDestroyed) return;
            this.commands.focus(this.options.autofocus);
            this.emit("create", {
                editor: this
            });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */ get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */ get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */ chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */ can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */ injectCSS() {
        if (this.options.injectCSS && document) this.css = $aceda74b73705131$export$48321b481dd8a36($aceda74b73705131$var$style, this.options.injectNonce);
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */ setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options
        };
        if (!this.view || !this.state || this.isDestroyed) return;
        if (this.options.editorProps) this.view.setProps(this.options.editorProps);
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */ setEditable(editable, emitUpdate = true) {
        this.setOptions({
            editable: editable
        });
        if (emitUpdate) this.emit("update", {
            editor: this,
            transaction: this.state.tr
        });
    }
    /**
     * Returns whether the editor is editable.
     */ get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */ get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */ registerPlugin(plugin, handlePlugins) {
        const plugins = $aceda74b73705131$export$f6e2535fb5126e54(handlePlugins) ? handlePlugins(plugin, [
            ...this.state.plugins
        ]) : [
            ...this.state.plugins,
            plugin
        ];
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKey The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */ unregisterPlugin(nameOrPluginKey) {
        if (this.isDestroyed) return undefined;
        // @ts-ignore
        const name = typeof nameOrPluginKey === "string" ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
        const state = this.state.reconfigure({
            // @ts-ignore
            plugins: this.state.plugins.filter((plugin)=>!plugin.key.startsWith(name))
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */ createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            $aceda74b73705131$var$Editable,
            $aceda74b73705131$var$ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
            }),
            $aceda74b73705131$var$Commands,
            $aceda74b73705131$var$FocusEvents,
            $aceda74b73705131$var$Keymap,
            $aceda74b73705131$var$Tabindex,
            $aceda74b73705131$var$Drop,
            $aceda74b73705131$var$Paste
        ].filter((ext)=>{
            if (typeof this.options.enableCoreExtensions === "object") return this.options.enableCoreExtensions[ext.name] !== false;
            return true;
        }) : [];
        const allExtensions = [
            ...coreExtensions,
            ...this.options.extensions
        ].filter((extension)=>{
            return [
                "extension",
                "node",
                "mark"
            ].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new $aceda74b73705131$var$ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */ createCommandManager() {
        this.commandManager = new $aceda74b73705131$export$475014de15a4c342({
            editor: this
        });
    }
    /**
     * Creates a ProseMirror schema.
     */ createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */ createView() {
        let doc;
        try {
            doc = $aceda74b73705131$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: this.options.enableContentCheck
            });
        } catch (e) {
            if (!(e instanceof Error) || ![
                "[tiptap error]: Invalid JSON content",
                "[tiptap error]: Invalid HTML content"
            ].includes(e.message)) // Not the content error we were expecting
            throw e;
            this.emit("contentError", {
                editor: this,
                error: e,
                disableCollaboration: ()=>{
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter((extension)=>extension.name !== "collaboration");
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                }
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = $aceda74b73705131$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: false
            });
        }
        const selection = $aceda74b73705131$export$225b0233b78e0d61(doc, this.options.autofocus);
        this.view = new (0, $0e46bf1b6d57978f$export$eece2fccabbb77c5)(this.options.element, {
            ...this.options.editorProps,
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: (0, $c286ea535d926598$export$afa855cbfaff27f2).create({
                doc: doc,
                selection: selection || undefined
            })
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */ createNodeViews() {
        if (this.view.isDestroyed) return;
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews
        });
    }
    /**
     * Prepend class name to element.
     */ prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */ dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) return;
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach((step)=>{
                var _a;
                return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
            });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit("beforeTransaction", {
            editor: this,
            transaction: transaction,
            nextState: state
        });
        this.view.updateState(state);
        this.emit("transaction", {
            editor: this,
            transaction: transaction
        });
        if (selectionHasChanged) this.emit("selectionUpdate", {
            editor: this,
            transaction: transaction
        });
        const focus = transaction.getMeta("focus");
        const blur = transaction.getMeta("blur");
        if (focus) this.emit("focus", {
            editor: this,
            event: focus.event,
            transaction: transaction
        });
        if (blur) this.emit("blur", {
            editor: this,
            event: blur.event,
            transaction: transaction
        });
        if (!transaction.docChanged || transaction.getMeta("preventUpdate")) return;
        this.emit("update", {
            editor: this,
            transaction: transaction
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */ getAttributes(nameOrType) {
        return $aceda74b73705131$export$fe94072fee8a6976(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === "string" ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === "string" ? attributesOrUndefined : nameOrAttributes;
        return $aceda74b73705131$export$39e04e72f972b885(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */ getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */ getHTML() {
        return $aceda74b73705131$export$d1b60002472b2c81(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */ getText(options) {
        const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
        return $aceda74b73705131$export$c72d34660a162238(this.state.doc, {
            blockSeparator: blockSeparator,
            textSerializers: {
                ...$aceda74b73705131$export$fdd92b7d22ac071c(this.schema),
                ...textSerializers
            }
        });
    }
    /**
     * Check if there is no content.
     */ get isEmpty() {
        return $aceda74b73705131$export$cd58ff1081f6abe9(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */ getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */ destroy() {
        this.emit("destroy");
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) delete dom.editor;
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */ get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new $aceda74b73705131$export$50c0270e74640068($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $aceda74b73705131$export$9f2cb743ab9131de(config) {
    return new $aceda74b73705131$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $aceda74b73705131$export$592682234826c0bd(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $aceda74b73705131$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $aceda74b73705131$export$6ca56856dfeaf9b6(config) {
    return new $aceda74b73705131$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $aceda74b73705131$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const { tr: tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) matchStart = end;
                else end = matchStart + match[1].length;
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            } else if (match[0]) {
                const insertionStart = config.type.isInline ? start : start - 1;
                tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            }
            tr.scrollIntoView();
        }
    });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $aceda74b73705131$export$cc081314d3f6ffb0(config) {
    return new $aceda74b73705131$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const $start = state.doc.resolve(range.from);
            const attributes = $aceda74b73705131$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) return null;
            state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
        }
    });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $aceda74b73705131$export$3ba5a5a15d18a35c(config) {
    return new $aceda74b73705131$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/guide/custom-extensions/#input-rules
 */ function $aceda74b73705131$export$f7316d89abe4e1c1(config) {
    return new $aceda74b73705131$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match, chain: chain })=>{
            const attributes = $aceda74b73705131$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && (0, $62ded6a368f04ea2$export$118cb9a83e81ba37)(blockRange, config.type, attributes);
            if (!wrapping) return null;
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection: selection, storedMarks: storedMarks } = state;
                const { splittableMarks: splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                if (marks) {
                    const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */ const nodeType = config.type.name === "bulletList" || config.type.name === "orderedList" ? "listItem" : "taskList";
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before && before.type === config.type && (0, $62ded6a368f04ea2$export$f15f89fd9d8cc98a)(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) tr.join(range.from - 1);
        }
    });
}
/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $aceda74b73705131$export$85c928794f8d04d4 {
    constructor(config = {}){
        this.type = "node";
        this.name = "node";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $aceda74b73705131$export$85c928794f8d04d4(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $aceda74b73705131$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $aceda74b73705131$export$85c928794f8d04d4(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $aceda74b73705131$export$592682234826c0bd($aceda74b73705131$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
function $aceda74b73705131$var$isAndroid() {
    return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */ class $aceda74b73705131$export$77c6811359a01a6f {
    constructor(component, props, options){
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.innerDecorations = props.innerDecorations;
        this.view = props.view;
        this.HTMLAttributes = props.HTMLAttributes;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view: view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest("[data-drag-handle]") : target.closest("[data-drag-handle]");
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) return;
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        (_g = event.dataTransfer) === null || _g === void 0 || _g.setDragImage(this.dom, x, y);
        const pos = this.getPos();
        if (typeof pos !== "number") return;
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = (0, $c286ea535d926598$export$e2940151ac854c0b).create(view.state.doc, pos);
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) return false;
        if (typeof this.options.stopEvent === "function") return this.options.stopEvent({
            event: event
        });
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) return false;
        const isDragEvent = event.type.startsWith("drag");
        const isDropEvent = event.type === "drop";
        const isInput = [
            "INPUT",
            "BUTTON",
            "SELECT",
            "TEXTAREA"
        ].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) return true;
        const { isEditable: isEditable } = this.editor;
        const { isDragging: isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = (0, $c286ea535d926598$export$e2940151ac854c0b).isSelectable(this.node);
        const isCopyEvent = event.type === "copy";
        const isPasteEvent = event.type === "paste";
        const isCutEvent = event.type === "cut";
        const isClickEvent = event.type === "mousedown";
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent) event.preventDefault();
        if (isDraggable && isDragEvent && !isDragging) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest("[data-drag-handle]");
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener("dragend", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener("drop", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener("mouseup", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
            }
        }
        // these events are handled by prosemirror
        if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) return false;
        return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */ ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) return true;
        if (typeof this.options.ignoreMutation === "function") return this.options.ignoreMutation({
            mutation: mutation
        });
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) return true;
        // ProseMirror should handle any selections
        if (mutation.type === "selection") return false;
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target) && mutation.type === "childList" && ($aceda74b73705131$export$86c1a3f9ab33da5c() || $aceda74b73705131$var$isAndroid()) && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes)
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every((node)=>node.isContentEditable)) return false;
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === "attributes") return true;
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) return false;
        return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */ updateAttributes(attributes) {
        this.editor.commands.command(({ tr: tr })=>{
            const pos = this.getPos();
            if (typeof pos !== "number") return false;
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes
            });
            return true;
        });
    }
    /**
     * Delete the node.
     */ deleteNode() {
        const from = this.getPos();
        if (typeof from !== "number") return;
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({
            from: from,
            to: to
        });
    }
}
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ function $aceda74b73705131$export$3845eb97abe74944(config) {
    return new $aceda74b73705131$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match, pasteEvent: pasteEvent })=>{
            const attributes = $aceda74b73705131$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $aceda74b73705131$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
// source: https://stackoverflow.com/a/6969486
function $aceda74b73705131$export$d3f82eb9fcc60fbc(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function $aceda74b73705131$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ function $aceda74b73705131$export$3cb77ada4d0e5bd5(config) {
    return new $aceda74b73705131$export$e75df4392d073e98({
        find: config.find,
        handler ({ match: match, chain: chain, range: range, pasteEvent: pasteEvent }) {
            const attributes = $aceda74b73705131$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            const content = $aceda74b73705131$export$592682234826c0bd(config.getContent, undefined, attributes);
            if (attributes === false || attributes === null) return null;
            const node = {
                type: config.type.name,
                attrs: attributes
            };
            if (content) node.content = content;
            if (match.input) chain().deleteRange(range).insertContentAt(range.from, node);
        }
    });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/guide/custom-extensions/#paste-rules
 */ function $aceda74b73705131$export$1aff23e8795559fa(config) {
    return new $aceda74b73705131$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
class $aceda74b73705131$export$254d9747e34ddc90 {
    constructor(transaction){
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps.slice(this.currentStep).reduce((newPosition, step)=>{
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) deleted = true;
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted: deleted
        };
    }
}


// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const $a65b6102f2fcfdb4$var$encodedTlds = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5m\xf6gensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
// Internationalized domain names containing non-ASCII
const $a65b6102f2fcfdb4$var$encodedUtlds = "\u03B5\u03BB1\u03C52\u0431\u04331\u0435\u043B3\u0434\u0435\u0442\u04384\u0435\u044E2\u043A\u0430\u0442\u043E\u043B\u0438\u043A6\u043E\u043C3\u043C\u043A\u04342\u043E\u043D1\u0441\u043A\u0432\u04306\u043E\u043D\u043B\u0430\u0439\u043D5\u0440\u04333\u0440\u0443\u04412\u04442\u0441\u0430\u0439\u04423\u0440\u04313\u0443\u043A\u04403\u049B\u0430\u04373\u0570\u0561\u05753\u05D9\u05E9\u05E8\u05D0\u05DC5\u05E7\u05D5\u05DD3\u0627\u0628\u0648\u0638\u0628\u064A5\u0631\u0627\u0645\u0643\u06485\u0644\u0627\u0631\u062F\u06464\u0628\u062D\u0631\u064A\u06465\u062C\u0632\u0627\u0626\u06315\u0633\u0639\u0648\u062F\u064A\u06296\u0639\u0644\u064A\u0627\u06465\u0645\u063A\u0631\u06285\u0645\u0627\u0631\u0627\u062A5\u06CC\u0631\u0627\u06465\u0628\u0627\u0631\u062A2\u0632\u0627\u06314\u064A\u062A\u06433\u06BE\u0627\u0631\u062A5\u062A\u0648\u0646\u06334\u0633\u0648\u062F\u0627\u06463\u0631\u064A\u06295\u0634\u0628\u0643\u06294\u0639\u0631\u0627\u06422\u06282\u0645\u0627\u06464\u0641\u0644\u0633\u0637\u064A\u06466\u0642\u0637\u06313\u0643\u0627\u062B\u0648\u0644\u064A\u06436\u0648\u06453\u0645\u0635\u06312\u0644\u064A\u0633\u064A\u06275\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u06277\u0642\u06394\u0647\u0645\u0631\u0627\u06475\u067E\u0627\u06A9\u0633\u062A\u0627\u06467\u0680\u0627\u0631\u062A4\u0915\u0949\u092E3\u0928\u0947\u091F3\u092D\u093E\u0930\u09240\u092E\u094D3\u094B\u09245\u0938\u0902\u0917\u0920\u09285\u09AC\u09BE\u0982\u09B2\u09BE5\u09AD\u09BE\u09B0\u09A42\u09F0\u09A44\u0A2D\u0A3E\u0A30\u0A244\u0AAD\u0ABE\u0AB0\u0AA44\u0B2D\u0B3E\u0B30\u0B244\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE6\u0BB2\u0B99\u0BCD\u0B95\u0BC86\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD11\u0C2D\u0C3E\u0C30\u0C24\u0C4D5\u0CAD\u0CBE\u0CB0\u0CA44\u0D2D\u0D3E\u0D30\u0D24\u0D025\u0DBD\u0D82\u0D9A\u0DCF4\u0E04\u0E2D\u0E213\u0E44\u0E17\u0E223\u0EA5\u0EB2\u0EA73\u10D2\u10D42\u307F\u3093\u306A3\u30A2\u30DE\u30BE\u30F34\u30AF\u30E9\u30A6\u30C94\u30B0\u30FC\u30B0\u30EB4\u30B3\u30E02\u30B9\u30C8\u30A23\u30BB\u30FC\u30EB3\u30D5\u30A1\u30C3\u30B7\u30E7\u30F36\u30DD\u30A4\u30F3\u30C84\u4E16\u754C2\u4E2D\u4FE11\u56FD1\u570B1\u6587\u7F513\u4E9A\u9A6C\u900A3\u4F01\u4E1A2\u4F5B\u5C712\u4FE1\u606F2\u5065\u5EB72\u516B\u53662\u516C\u53F81\u76CA2\u53F0\u6E7E1\u70632\u5546\u57CE1\u5E971\u68072\u5609\u91CC0\u5927\u9152\u5E975\u5728\u7EBF2\u5927\u62FF2\u5929\u4E3B\u65593\u5A31\u4E502\u5BB6\u96FB2\u5E7F\u4E1C2\u5FAE\u535A2\u6148\u55842\u6211\u7231\u4F603\u624B\u673A2\u62DB\u80582\u653F\u52A11\u5E9C2\u65B0\u52A0\u57612\u95FB2\u65F6\u5C1A2\u66F8\u7C4D2\u673A\u67842\u6DE1\u9A6C\u95213\u6E38\u620F2\u6FB3\u95802\u70B9\u770B2\u79FB\u52A82\u7EC4\u7EC7\u673A\u67844\u7F51\u57401\u5E971\u7AD91\u7EDC2\u8054\u901A2\u8C37\u6B4C2\u8D2D\u72692\u901A\u8CA92\u96C6\u56E22\u96FB\u8A0A\u76C8\u79D14\u98DE\u5229\u6D663\u98DF\u54C12\u9910\u53852\u9999\u683C\u91CC\u62C93\u6E2F2\uB2F7\uB1371\uCEF42\uC0BC\uC1312\uD55C\uAD6D2";
/**
 * Finite State Machine generation utilities
 */ /**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */ /**
 * @typedef {{ [group: string]: true }} Flags
 */ // Keys in scanner Collections instances
const $a65b6102f2fcfdb4$var$numeric = "numeric";
const $a65b6102f2fcfdb4$var$ascii = "ascii";
const $a65b6102f2fcfdb4$var$alpha = "alpha";
const $a65b6102f2fcfdb4$var$asciinumeric = "asciinumeric";
const $a65b6102f2fcfdb4$var$alphanumeric = "alphanumeric";
const $a65b6102f2fcfdb4$var$domain = "domain";
const $a65b6102f2fcfdb4$var$emoji = "emoji";
const $a65b6102f2fcfdb4$var$scheme = "scheme";
const $a65b6102f2fcfdb4$var$slashscheme = "slashscheme";
const $a65b6102f2fcfdb4$var$whitespace = "whitespace";
/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */ function $a65b6102f2fcfdb4$var$registerGroup(name, groups) {
    if (!(name in groups)) groups[name] = [];
    return groups[name];
}
/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */ function $a65b6102f2fcfdb4$var$addToGroups(t, flags, groups) {
    if (flags[$a65b6102f2fcfdb4$var$numeric]) {
        flags[$a65b6102f2fcfdb4$var$asciinumeric] = true;
        flags[$a65b6102f2fcfdb4$var$alphanumeric] = true;
    }
    if (flags[$a65b6102f2fcfdb4$var$ascii]) {
        flags[$a65b6102f2fcfdb4$var$asciinumeric] = true;
        flags[$a65b6102f2fcfdb4$var$alpha] = true;
    }
    if (flags[$a65b6102f2fcfdb4$var$asciinumeric]) flags[$a65b6102f2fcfdb4$var$alphanumeric] = true;
    if (flags[$a65b6102f2fcfdb4$var$alpha]) flags[$a65b6102f2fcfdb4$var$alphanumeric] = true;
    if (flags[$a65b6102f2fcfdb4$var$alphanumeric]) flags[$a65b6102f2fcfdb4$var$domain] = true;
    if (flags[$a65b6102f2fcfdb4$var$emoji]) flags[$a65b6102f2fcfdb4$var$domain] = true;
    for(const k in flags){
        const group = $a65b6102f2fcfdb4$var$registerGroup(k, groups);
        if (group.indexOf(t) < 0) group.push(t);
    }
}
/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */ function $a65b6102f2fcfdb4$var$flagsForToken(t, groups) {
    const result = {};
    for(const c in groups)if (groups[c].indexOf(t) >= 0) result[c] = true;
    return result;
}
/**
 * @template T
 * @typedef {null | T } Transition
 */ /**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */ function $a65b6102f2fcfdb4$export$7254cc27399e90bd(token = null) {
    // this.n = null; // DEBUG: State name
    /** @type {{ [input: string]: State<T> }} j */ this.j = {}; // IMPLEMENTATION 1
    // this.j = []; // IMPLEMENTATION 2
    /** @type {[RegExp, State<T>][]} jr */ this.jr = [];
    /** @type {?State<T>} jd */ this.jd = null;
    /** @type {?T} t */ this.t = token;
}
/**
 * Scanner token groups
 * @type Collections<string>
 */ $a65b6102f2fcfdb4$export$7254cc27399e90bd.groups = {};
$a65b6102f2fcfdb4$export$7254cc27399e90bd.prototype = {
    accepts () {
        return !!this.t;
    },
    /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */ go (input) {
        const state = this;
        const nextState = state.j[input];
        if (nextState) return nextState;
        for(let i = 0; i < state.jr.length; i++){
            const regex = state.jr[i][0];
            const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
            if (nextState && regex.test(input)) return nextState;
        }
        // Nowhere left to jump! Return default, if any
        return state.jd;
    },
    /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */ has (input, exactOnly = false) {
        return exactOnly ? input in this.j : !!this.go(input);
    },
    /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */ ta (inputs, next, flags, groups) {
        for(let i = 0; i < inputs.length; i++)this.tt(inputs[i], next, flags, groups);
    },
    /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ tr (regexp, next, flags, groups) {
        groups = groups || $a65b6102f2fcfdb4$export$7254cc27399e90bd.groups;
        let nextState;
        if (next && next.j) nextState = next;
        else {
            // Token with maybe token groups
            nextState = new $a65b6102f2fcfdb4$export$7254cc27399e90bd(next);
            if (flags && groups) $a65b6102f2fcfdb4$var$addToGroups(next, flags, groups);
        }
        this.jr.push([
            regexp,
            nextState
        ]);
        return nextState;
    },
    /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ ts (input, next, flags, groups) {
        let state = this;
        const len = input.length;
        if (!len) return state;
        for(let i = 0; i < len - 1; i++)state = state.tt(input[i]);
        return state.tt(input[len - 1], next, flags, groups);
    },
    /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */ tt (input, next, flags, groups) {
        groups = groups || $a65b6102f2fcfdb4$export$7254cc27399e90bd.groups;
        const state = this;
        // Check if existing state given, just a basic transition
        if (next && next.j) {
            state.j[input] = next;
            return next;
        }
        const t = next;
        // Take the transition with the usual default mechanisms and use that as
        // a template for creating the next state
        let nextState, templateState = state.go(input);
        if (templateState) {
            nextState = new $a65b6102f2fcfdb4$export$7254cc27399e90bd();
            Object.assign(nextState.j, templateState.j);
            nextState.jr.push.apply(nextState.jr, templateState.jr);
            nextState.jd = templateState.jd;
            nextState.t = templateState.t;
        } else nextState = new $a65b6102f2fcfdb4$export$7254cc27399e90bd();
        if (t) {
            // Ensure newly token is in the same groups as the old token
            if (groups) {
                if (nextState.t && typeof nextState.t === "string") {
                    const allFlags = Object.assign($a65b6102f2fcfdb4$var$flagsForToken(nextState.t, groups), flags);
                    $a65b6102f2fcfdb4$var$addToGroups(t, allFlags, groups);
                } else if (flags) $a65b6102f2fcfdb4$var$addToGroups(t, flags, groups);
            }
            nextState.t = t; // overwrite anything that was previously there
        }
        state.j[input] = nextState;
        return nextState;
    }
};
// Helper functions to improve minification (not exported outside linkifyjs module)
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $a65b6102f2fcfdb4$var$ta = (state, input, next, flags, groups)=>state.ta(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $a65b6102f2fcfdb4$var$tr = (state, regexp, next, flags, groups)=>state.tr(regexp, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $a65b6102f2fcfdb4$var$ts = (state, input, next, flags, groups)=>state.ts(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */ const $a65b6102f2fcfdb4$var$tt = (state, input, next, flags, groups)=>state.tt(input, next, flags, groups);
/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/ // A valid web domain token
const $a65b6102f2fcfdb4$var$WORD = "WORD"; // only contains a-z
const $a65b6102f2fcfdb4$var$UWORD = "UWORD"; // contains letters other than a-z, used for IDN
const $a65b6102f2fcfdb4$var$ASCIINUMERICAL = "ASCIINUMERICAL"; // contains a-z, 0-9
const $a65b6102f2fcfdb4$var$ALPHANUMERICAL = "ALPHANUMERICAL"; // contains numbers and letters other than a-z, used for IDN
// Special case of word
const $a65b6102f2fcfdb4$var$LOCALHOST = "LOCALHOST";
// Valid top-level domain, special case of WORD (see tlds.js)
const $a65b6102f2fcfdb4$var$TLD = "TLD";
// Valid IDN TLD, special case of UWORD (see tlds.js)
const $a65b6102f2fcfdb4$var$UTLD = "UTLD";
// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const $a65b6102f2fcfdb4$var$SCHEME = "SCHEME";
// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const $a65b6102f2fcfdb4$var$SLASH_SCHEME = "SLASH_SCHEME";
// Any sequence of digits 0-9
const $a65b6102f2fcfdb4$var$NUM = "NUM";
// Any number of consecutive whitespace characters that are not newline
const $a65b6102f2fcfdb4$var$WS = "WS";
// New line (unix style)
const $a65b6102f2fcfdb4$var$NL = "NL"; // \n
// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const $a65b6102f2fcfdb4$var$OPENBRACE = "OPENBRACE"; // {
const $a65b6102f2fcfdb4$var$CLOSEBRACE = "CLOSEBRACE"; // }
const $a65b6102f2fcfdb4$var$OPENBRACKET = "OPENBRACKET"; // [
const $a65b6102f2fcfdb4$var$CLOSEBRACKET = "CLOSEBRACKET"; // ]
const $a65b6102f2fcfdb4$var$OPENPAREN = "OPENPAREN"; // (
const $a65b6102f2fcfdb4$var$CLOSEPAREN = "CLOSEPAREN"; // )
const $a65b6102f2fcfdb4$var$OPENANGLEBRACKET = "OPENANGLEBRACKET"; // <
const $a65b6102f2fcfdb4$var$CLOSEANGLEBRACKET = "CLOSEANGLEBRACKET"; // >
const $a65b6102f2fcfdb4$var$FULLWIDTHLEFTPAREN = "FULLWIDTHLEFTPAREN"; // （
const $a65b6102f2fcfdb4$var$FULLWIDTHRIGHTPAREN = "FULLWIDTHRIGHTPAREN"; // ）
const $a65b6102f2fcfdb4$var$LEFTCORNERBRACKET = "LEFTCORNERBRACKET"; // 「
const $a65b6102f2fcfdb4$var$RIGHTCORNERBRACKET = "RIGHTCORNERBRACKET"; // 」
const $a65b6102f2fcfdb4$var$LEFTWHITECORNERBRACKET = "LEFTWHITECORNERBRACKET"; // 『
const $a65b6102f2fcfdb4$var$RIGHTWHITECORNERBRACKET = "RIGHTWHITECORNERBRACKET"; // 』
const $a65b6102f2fcfdb4$var$FULLWIDTHLESSTHAN = "FULLWIDTHLESSTHAN"; // ＜
const $a65b6102f2fcfdb4$var$FULLWIDTHGREATERTHAN = "FULLWIDTHGREATERTHAN"; // ＞
// Various symbols
const $a65b6102f2fcfdb4$var$AMPERSAND = "AMPERSAND"; // &
const $a65b6102f2fcfdb4$var$APOSTROPHE = "APOSTROPHE"; // '
const $a65b6102f2fcfdb4$var$ASTERISK = "ASTERISK"; // *
const $a65b6102f2fcfdb4$var$AT = "AT"; // @
const $a65b6102f2fcfdb4$var$BACKSLASH = "BACKSLASH"; // \
const $a65b6102f2fcfdb4$var$BACKTICK = "BACKTICK"; // `
const $a65b6102f2fcfdb4$var$CARET = "CARET"; // ^
const $a65b6102f2fcfdb4$var$COLON = "COLON"; // :
const $a65b6102f2fcfdb4$var$COMMA = "COMMA"; // ,
const $a65b6102f2fcfdb4$var$DOLLAR = "DOLLAR"; // $
const $a65b6102f2fcfdb4$var$DOT = "DOT"; // .
const $a65b6102f2fcfdb4$var$EQUALS = "EQUALS"; // =
const $a65b6102f2fcfdb4$var$EXCLAMATION = "EXCLAMATION"; // !
const $a65b6102f2fcfdb4$var$HYPHEN = "HYPHEN"; // -
const $a65b6102f2fcfdb4$var$PERCENT = "PERCENT"; // %
const $a65b6102f2fcfdb4$var$PIPE = "PIPE"; // |
const $a65b6102f2fcfdb4$var$PLUS = "PLUS"; // +
const $a65b6102f2fcfdb4$var$POUND = "POUND"; // #
const $a65b6102f2fcfdb4$var$QUERY = "QUERY"; // ?
const $a65b6102f2fcfdb4$var$QUOTE = "QUOTE"; // "
const $a65b6102f2fcfdb4$var$FULLWIDTHMIDDLEDOT = "FULLWIDTHMIDDLEDOT"; // ・
const $a65b6102f2fcfdb4$var$SEMI = "SEMI"; // ;
const $a65b6102f2fcfdb4$var$SLASH = "SLASH"; // /
const $a65b6102f2fcfdb4$var$TILDE = "TILDE"; // ~
const $a65b6102f2fcfdb4$var$UNDERSCORE = "UNDERSCORE"; // _
// Emoji symbol
const $a65b6102f2fcfdb4$var$EMOJI$1 = "EMOJI";
// Default token - anything that is not one of the above
const $a65b6102f2fcfdb4$var$SYM = "SYM";
var $a65b6102f2fcfdb4$var$tk = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ALPHANUMERICAL: $a65b6102f2fcfdb4$var$ALPHANUMERICAL,
    AMPERSAND: $a65b6102f2fcfdb4$var$AMPERSAND,
    APOSTROPHE: $a65b6102f2fcfdb4$var$APOSTROPHE,
    ASCIINUMERICAL: $a65b6102f2fcfdb4$var$ASCIINUMERICAL,
    ASTERISK: $a65b6102f2fcfdb4$var$ASTERISK,
    AT: $a65b6102f2fcfdb4$var$AT,
    BACKSLASH: $a65b6102f2fcfdb4$var$BACKSLASH,
    BACKTICK: $a65b6102f2fcfdb4$var$BACKTICK,
    CARET: $a65b6102f2fcfdb4$var$CARET,
    CLOSEANGLEBRACKET: $a65b6102f2fcfdb4$var$CLOSEANGLEBRACKET,
    CLOSEBRACE: $a65b6102f2fcfdb4$var$CLOSEBRACE,
    CLOSEBRACKET: $a65b6102f2fcfdb4$var$CLOSEBRACKET,
    CLOSEPAREN: $a65b6102f2fcfdb4$var$CLOSEPAREN,
    COLON: $a65b6102f2fcfdb4$var$COLON,
    COMMA: $a65b6102f2fcfdb4$var$COMMA,
    DOLLAR: $a65b6102f2fcfdb4$var$DOLLAR,
    DOT: $a65b6102f2fcfdb4$var$DOT,
    EMOJI: $a65b6102f2fcfdb4$var$EMOJI$1,
    EQUALS: $a65b6102f2fcfdb4$var$EQUALS,
    EXCLAMATION: $a65b6102f2fcfdb4$var$EXCLAMATION,
    FULLWIDTHGREATERTHAN: $a65b6102f2fcfdb4$var$FULLWIDTHGREATERTHAN,
    FULLWIDTHLEFTPAREN: $a65b6102f2fcfdb4$var$FULLWIDTHLEFTPAREN,
    FULLWIDTHLESSTHAN: $a65b6102f2fcfdb4$var$FULLWIDTHLESSTHAN,
    FULLWIDTHMIDDLEDOT: $a65b6102f2fcfdb4$var$FULLWIDTHMIDDLEDOT,
    FULLWIDTHRIGHTPAREN: $a65b6102f2fcfdb4$var$FULLWIDTHRIGHTPAREN,
    HYPHEN: $a65b6102f2fcfdb4$var$HYPHEN,
    LEFTCORNERBRACKET: $a65b6102f2fcfdb4$var$LEFTCORNERBRACKET,
    LEFTWHITECORNERBRACKET: $a65b6102f2fcfdb4$var$LEFTWHITECORNERBRACKET,
    LOCALHOST: $a65b6102f2fcfdb4$var$LOCALHOST,
    NL: $a65b6102f2fcfdb4$var$NL,
    NUM: $a65b6102f2fcfdb4$var$NUM,
    OPENANGLEBRACKET: $a65b6102f2fcfdb4$var$OPENANGLEBRACKET,
    OPENBRACE: $a65b6102f2fcfdb4$var$OPENBRACE,
    OPENBRACKET: $a65b6102f2fcfdb4$var$OPENBRACKET,
    OPENPAREN: $a65b6102f2fcfdb4$var$OPENPAREN,
    PERCENT: $a65b6102f2fcfdb4$var$PERCENT,
    PIPE: $a65b6102f2fcfdb4$var$PIPE,
    PLUS: $a65b6102f2fcfdb4$var$PLUS,
    POUND: $a65b6102f2fcfdb4$var$POUND,
    QUERY: $a65b6102f2fcfdb4$var$QUERY,
    QUOTE: $a65b6102f2fcfdb4$var$QUOTE,
    RIGHTCORNERBRACKET: $a65b6102f2fcfdb4$var$RIGHTCORNERBRACKET,
    RIGHTWHITECORNERBRACKET: $a65b6102f2fcfdb4$var$RIGHTWHITECORNERBRACKET,
    SCHEME: $a65b6102f2fcfdb4$var$SCHEME,
    SEMI: $a65b6102f2fcfdb4$var$SEMI,
    SLASH: $a65b6102f2fcfdb4$var$SLASH,
    SLASH_SCHEME: $a65b6102f2fcfdb4$var$SLASH_SCHEME,
    SYM: $a65b6102f2fcfdb4$var$SYM,
    TILDE: $a65b6102f2fcfdb4$var$TILDE,
    TLD: $a65b6102f2fcfdb4$var$TLD,
    UNDERSCORE: $a65b6102f2fcfdb4$var$UNDERSCORE,
    UTLD: $a65b6102f2fcfdb4$var$UTLD,
    UWORD: $a65b6102f2fcfdb4$var$UWORD,
    WORD: $a65b6102f2fcfdb4$var$WORD,
    WS: $a65b6102f2fcfdb4$var$WS
});
// Note that these two Unicode ones expand into a really big one with Babel
const $a65b6102f2fcfdb4$var$ASCII_LETTER = /[a-z]/;
const $a65b6102f2fcfdb4$var$LETTER = /\p{L}/u; // Any Unicode character with letter data type
const $a65b6102f2fcfdb4$var$EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const $a65b6102f2fcfdb4$var$EMOJI_VARIATION$1 = /\ufe0f/;
const $a65b6102f2fcfdb4$var$DIGIT = /\d/;
const $a65b6102f2fcfdb4$var$SPACE = /\s/;
var $a65b6102f2fcfdb4$export$efdc1e5bdb609bb = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ASCII_LETTER: $a65b6102f2fcfdb4$var$ASCII_LETTER,
    DIGIT: $a65b6102f2fcfdb4$var$DIGIT,
    EMOJI: $a65b6102f2fcfdb4$var$EMOJI,
    EMOJI_VARIATION: $a65b6102f2fcfdb4$var$EMOJI_VARIATION$1,
    LETTER: $a65b6102f2fcfdb4$var$LETTER,
    SPACE: $a65b6102f2fcfdb4$var$SPACE
});
/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/ const $a65b6102f2fcfdb4$var$CR = "\r"; // carriage-return character
const $a65b6102f2fcfdb4$var$LF = "\n"; // line-feed character
const $a65b6102f2fcfdb4$var$EMOJI_VARIATION = "\uFE0F"; // Variation selector, follows heart and others
const $a65b6102f2fcfdb4$var$EMOJI_JOINER = "\u200D"; // zero-width joiner
const $a65b6102f2fcfdb4$var$OBJECT_REPLACEMENT = "\uFFFC"; // whitespace placeholder that sometimes appears in rich text editors
let $a65b6102f2fcfdb4$var$tlds = null, $a65b6102f2fcfdb4$var$utlds = null; // don't change so only have to be computed once
/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */ /**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */ /**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */ function $a65b6102f2fcfdb4$var$init$2(customSchemes = []) {
    // Frequently used states (name argument removed during minification)
    /** @type Collections<string> */ const groups = {}; // of tokens
    $a65b6102f2fcfdb4$export$7254cc27399e90bd.groups = groups;
    /** @type State<string> */ const Start = new $a65b6102f2fcfdb4$export$7254cc27399e90bd();
    if ($a65b6102f2fcfdb4$var$tlds == null) $a65b6102f2fcfdb4$var$tlds = $a65b6102f2fcfdb4$var$decodeTlds($a65b6102f2fcfdb4$var$encodedTlds);
    if ($a65b6102f2fcfdb4$var$utlds == null) $a65b6102f2fcfdb4$var$utlds = $a65b6102f2fcfdb4$var$decodeTlds($a65b6102f2fcfdb4$var$encodedUtlds);
    // States for special URL symbols that accept immediately after start
    $a65b6102f2fcfdb4$var$tt(Start, "'", $a65b6102f2fcfdb4$var$APOSTROPHE);
    $a65b6102f2fcfdb4$var$tt(Start, "{", $a65b6102f2fcfdb4$var$OPENBRACE);
    $a65b6102f2fcfdb4$var$tt(Start, "}", $a65b6102f2fcfdb4$var$CLOSEBRACE);
    $a65b6102f2fcfdb4$var$tt(Start, "[", $a65b6102f2fcfdb4$var$OPENBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "]", $a65b6102f2fcfdb4$var$CLOSEBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "(", $a65b6102f2fcfdb4$var$OPENPAREN);
    $a65b6102f2fcfdb4$var$tt(Start, ")", $a65b6102f2fcfdb4$var$CLOSEPAREN);
    $a65b6102f2fcfdb4$var$tt(Start, "<", $a65b6102f2fcfdb4$var$OPENANGLEBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, ">", $a65b6102f2fcfdb4$var$CLOSEANGLEBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "\uFF08", $a65b6102f2fcfdb4$var$FULLWIDTHLEFTPAREN);
    $a65b6102f2fcfdb4$var$tt(Start, "\uFF09", $a65b6102f2fcfdb4$var$FULLWIDTHRIGHTPAREN);
    $a65b6102f2fcfdb4$var$tt(Start, "\u300C", $a65b6102f2fcfdb4$var$LEFTCORNERBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "\u300D", $a65b6102f2fcfdb4$var$RIGHTCORNERBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "\u300E", $a65b6102f2fcfdb4$var$LEFTWHITECORNERBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "\u300F", $a65b6102f2fcfdb4$var$RIGHTWHITECORNERBRACKET);
    $a65b6102f2fcfdb4$var$tt(Start, "\uFF1C", $a65b6102f2fcfdb4$var$FULLWIDTHLESSTHAN);
    $a65b6102f2fcfdb4$var$tt(Start, "\uFF1E", $a65b6102f2fcfdb4$var$FULLWIDTHGREATERTHAN);
    $a65b6102f2fcfdb4$var$tt(Start, "&", $a65b6102f2fcfdb4$var$AMPERSAND);
    $a65b6102f2fcfdb4$var$tt(Start, "*", $a65b6102f2fcfdb4$var$ASTERISK);
    $a65b6102f2fcfdb4$var$tt(Start, "@", $a65b6102f2fcfdb4$var$AT);
    $a65b6102f2fcfdb4$var$tt(Start, "`", $a65b6102f2fcfdb4$var$BACKTICK);
    $a65b6102f2fcfdb4$var$tt(Start, "^", $a65b6102f2fcfdb4$var$CARET);
    $a65b6102f2fcfdb4$var$tt(Start, ":", $a65b6102f2fcfdb4$var$COLON);
    $a65b6102f2fcfdb4$var$tt(Start, ",", $a65b6102f2fcfdb4$var$COMMA);
    $a65b6102f2fcfdb4$var$tt(Start, "$", $a65b6102f2fcfdb4$var$DOLLAR);
    $a65b6102f2fcfdb4$var$tt(Start, ".", $a65b6102f2fcfdb4$var$DOT);
    $a65b6102f2fcfdb4$var$tt(Start, "=", $a65b6102f2fcfdb4$var$EQUALS);
    $a65b6102f2fcfdb4$var$tt(Start, "!", $a65b6102f2fcfdb4$var$EXCLAMATION);
    $a65b6102f2fcfdb4$var$tt(Start, "-", $a65b6102f2fcfdb4$var$HYPHEN);
    $a65b6102f2fcfdb4$var$tt(Start, "%", $a65b6102f2fcfdb4$var$PERCENT);
    $a65b6102f2fcfdb4$var$tt(Start, "|", $a65b6102f2fcfdb4$var$PIPE);
    $a65b6102f2fcfdb4$var$tt(Start, "+", $a65b6102f2fcfdb4$var$PLUS);
    $a65b6102f2fcfdb4$var$tt(Start, "#", $a65b6102f2fcfdb4$var$POUND);
    $a65b6102f2fcfdb4$var$tt(Start, "?", $a65b6102f2fcfdb4$var$QUERY);
    $a65b6102f2fcfdb4$var$tt(Start, '"', $a65b6102f2fcfdb4$var$QUOTE);
    $a65b6102f2fcfdb4$var$tt(Start, "/", $a65b6102f2fcfdb4$var$SLASH);
    $a65b6102f2fcfdb4$var$tt(Start, ";", $a65b6102f2fcfdb4$var$SEMI);
    $a65b6102f2fcfdb4$var$tt(Start, "~", $a65b6102f2fcfdb4$var$TILDE);
    $a65b6102f2fcfdb4$var$tt(Start, "_", $a65b6102f2fcfdb4$var$UNDERSCORE);
    $a65b6102f2fcfdb4$var$tt(Start, "\\", $a65b6102f2fcfdb4$var$BACKSLASH);
    $a65b6102f2fcfdb4$var$tt(Start, "\u30FB", $a65b6102f2fcfdb4$var$FULLWIDTHMIDDLEDOT);
    const Num = $a65b6102f2fcfdb4$var$tr(Start, $a65b6102f2fcfdb4$var$DIGIT, $a65b6102f2fcfdb4$var$NUM, {
        [$a65b6102f2fcfdb4$var$numeric]: true
    });
    $a65b6102f2fcfdb4$var$tr(Num, $a65b6102f2fcfdb4$var$DIGIT, Num);
    const Asciinumeric = $a65b6102f2fcfdb4$var$tr(Num, $a65b6102f2fcfdb4$var$ASCII_LETTER, $a65b6102f2fcfdb4$var$ASCIINUMERICAL, {
        [$a65b6102f2fcfdb4$var$asciinumeric]: true
    });
    const Alphanumeric = $a65b6102f2fcfdb4$var$tr(Num, $a65b6102f2fcfdb4$var$LETTER, $a65b6102f2fcfdb4$var$ALPHANUMERICAL, {
        [$a65b6102f2fcfdb4$var$alphanumeric]: true
    });
    // State which emits a word token
    const Word = $a65b6102f2fcfdb4$var$tr(Start, $a65b6102f2fcfdb4$var$ASCII_LETTER, $a65b6102f2fcfdb4$var$WORD, {
        [$a65b6102f2fcfdb4$var$ascii]: true
    });
    $a65b6102f2fcfdb4$var$tr(Word, $a65b6102f2fcfdb4$var$DIGIT, Asciinumeric);
    $a65b6102f2fcfdb4$var$tr(Word, $a65b6102f2fcfdb4$var$ASCII_LETTER, Word);
    $a65b6102f2fcfdb4$var$tr(Asciinumeric, $a65b6102f2fcfdb4$var$DIGIT, Asciinumeric);
    $a65b6102f2fcfdb4$var$tr(Asciinumeric, $a65b6102f2fcfdb4$var$ASCII_LETTER, Asciinumeric);
    // Same as previous, but specific to non-fsm.ascii alphabet words
    const UWord = $a65b6102f2fcfdb4$var$tr(Start, $a65b6102f2fcfdb4$var$LETTER, $a65b6102f2fcfdb4$var$UWORD, {
        [$a65b6102f2fcfdb4$var$alpha]: true
    });
    $a65b6102f2fcfdb4$var$tr(UWord, $a65b6102f2fcfdb4$var$ASCII_LETTER); // Non-accepting
    $a65b6102f2fcfdb4$var$tr(UWord, $a65b6102f2fcfdb4$var$DIGIT, Alphanumeric);
    $a65b6102f2fcfdb4$var$tr(UWord, $a65b6102f2fcfdb4$var$LETTER, UWord);
    $a65b6102f2fcfdb4$var$tr(Alphanumeric, $a65b6102f2fcfdb4$var$DIGIT, Alphanumeric);
    $a65b6102f2fcfdb4$var$tr(Alphanumeric, $a65b6102f2fcfdb4$var$ASCII_LETTER); // Non-accepting
    $a65b6102f2fcfdb4$var$tr(Alphanumeric, $a65b6102f2fcfdb4$var$LETTER, Alphanumeric); // Non-accepting
    // Whitespace jumps
    // Tokens of only non-newline whitespace are arbitrarily long
    // If any whitespace except newline, more whitespace!
    const Nl = $a65b6102f2fcfdb4$var$tt(Start, $a65b6102f2fcfdb4$var$LF, $a65b6102f2fcfdb4$var$NL, {
        [$a65b6102f2fcfdb4$var$whitespace]: true
    });
    const Cr = $a65b6102f2fcfdb4$var$tt(Start, $a65b6102f2fcfdb4$var$CR, $a65b6102f2fcfdb4$var$WS, {
        [$a65b6102f2fcfdb4$var$whitespace]: true
    });
    const Ws = $a65b6102f2fcfdb4$var$tr(Start, $a65b6102f2fcfdb4$var$SPACE, $a65b6102f2fcfdb4$var$WS, {
        [$a65b6102f2fcfdb4$var$whitespace]: true
    });
    $a65b6102f2fcfdb4$var$tt(Start, $a65b6102f2fcfdb4$var$OBJECT_REPLACEMENT, Ws);
    $a65b6102f2fcfdb4$var$tt(Cr, $a65b6102f2fcfdb4$var$LF, Nl); // \r\n
    $a65b6102f2fcfdb4$var$tt(Cr, $a65b6102f2fcfdb4$var$OBJECT_REPLACEMENT, Ws);
    $a65b6102f2fcfdb4$var$tr(Cr, $a65b6102f2fcfdb4$var$SPACE, Ws);
    $a65b6102f2fcfdb4$var$tt(Ws, $a65b6102f2fcfdb4$var$CR); // non-accepting state to avoid mixing whitespaces
    $a65b6102f2fcfdb4$var$tt(Ws, $a65b6102f2fcfdb4$var$LF); // non-accepting state to avoid mixing whitespaces
    $a65b6102f2fcfdb4$var$tr(Ws, $a65b6102f2fcfdb4$var$SPACE, Ws);
    $a65b6102f2fcfdb4$var$tt(Ws, $a65b6102f2fcfdb4$var$OBJECT_REPLACEMENT, Ws);
    // Emoji tokens. They are not grouped by the scanner except in cases where a
    // zero-width joiner is present
    const Emoji = $a65b6102f2fcfdb4$var$tr(Start, $a65b6102f2fcfdb4$var$EMOJI, $a65b6102f2fcfdb4$var$EMOJI$1, {
        [$a65b6102f2fcfdb4$var$emoji]: true
    });
    $a65b6102f2fcfdb4$var$tt(Emoji, "#"); // no transition, emoji regex seems to match #
    $a65b6102f2fcfdb4$var$tr(Emoji, $a65b6102f2fcfdb4$var$EMOJI, Emoji);
    $a65b6102f2fcfdb4$var$tt(Emoji, $a65b6102f2fcfdb4$var$EMOJI_VARIATION, Emoji);
    // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy
    const EmojiJoiner = $a65b6102f2fcfdb4$var$tt(Emoji, $a65b6102f2fcfdb4$var$EMOJI_JOINER);
    $a65b6102f2fcfdb4$var$tt(EmojiJoiner, "#");
    $a65b6102f2fcfdb4$var$tr(EmojiJoiner, $a65b6102f2fcfdb4$var$EMOJI, Emoji);
    // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy
    // Generates states for top-level domains
    // Note that this is most accurate when tlds are in alphabetical order
    const wordjr = [
        [
            $a65b6102f2fcfdb4$var$ASCII_LETTER,
            Word
        ],
        [
            $a65b6102f2fcfdb4$var$DIGIT,
            Asciinumeric
        ]
    ];
    const uwordjr = [
        [
            $a65b6102f2fcfdb4$var$ASCII_LETTER,
            null
        ],
        [
            $a65b6102f2fcfdb4$var$LETTER,
            UWord
        ],
        [
            $a65b6102f2fcfdb4$var$DIGIT,
            Alphanumeric
        ]
    ];
    for(let i = 0; i < $a65b6102f2fcfdb4$var$tlds.length; i++)$a65b6102f2fcfdb4$var$fastts(Start, $a65b6102f2fcfdb4$var$tlds[i], $a65b6102f2fcfdb4$var$TLD, $a65b6102f2fcfdb4$var$WORD, wordjr);
    for(let i = 0; i < $a65b6102f2fcfdb4$var$utlds.length; i++)$a65b6102f2fcfdb4$var$fastts(Start, $a65b6102f2fcfdb4$var$utlds[i], $a65b6102f2fcfdb4$var$UTLD, $a65b6102f2fcfdb4$var$UWORD, uwordjr);
    $a65b6102f2fcfdb4$var$addToGroups($a65b6102f2fcfdb4$var$TLD, {
        tld: true,
        ascii: true
    }, groups);
    $a65b6102f2fcfdb4$var$addToGroups($a65b6102f2fcfdb4$var$UTLD, {
        utld: true,
        alpha: true
    }, groups);
    // Collect the states generated by different protocols. NOTE: If any new TLDs
    // get added that are also protocols, set the token to be the same as the
    // protocol to ensure parsing works as expected.
    $a65b6102f2fcfdb4$var$fastts(Start, "file", $a65b6102f2fcfdb4$var$SCHEME, $a65b6102f2fcfdb4$var$WORD, wordjr);
    $a65b6102f2fcfdb4$var$fastts(Start, "mailto", $a65b6102f2fcfdb4$var$SCHEME, $a65b6102f2fcfdb4$var$WORD, wordjr);
    $a65b6102f2fcfdb4$var$fastts(Start, "http", $a65b6102f2fcfdb4$var$SLASH_SCHEME, $a65b6102f2fcfdb4$var$WORD, wordjr);
    $a65b6102f2fcfdb4$var$fastts(Start, "https", $a65b6102f2fcfdb4$var$SLASH_SCHEME, $a65b6102f2fcfdb4$var$WORD, wordjr);
    $a65b6102f2fcfdb4$var$fastts(Start, "ftp", $a65b6102f2fcfdb4$var$SLASH_SCHEME, $a65b6102f2fcfdb4$var$WORD, wordjr);
    $a65b6102f2fcfdb4$var$fastts(Start, "ftps", $a65b6102f2fcfdb4$var$SLASH_SCHEME, $a65b6102f2fcfdb4$var$WORD, wordjr);
    $a65b6102f2fcfdb4$var$addToGroups($a65b6102f2fcfdb4$var$SCHEME, {
        scheme: true,
        ascii: true
    }, groups);
    $a65b6102f2fcfdb4$var$addToGroups($a65b6102f2fcfdb4$var$SLASH_SCHEME, {
        slashscheme: true,
        ascii: true
    }, groups);
    // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
    customSchemes = customSchemes.sort((a, b)=>a[0] > b[0] ? 1 : -1);
    for(let i = 0; i < customSchemes.length; i++){
        const sch = customSchemes[i][0];
        const optionalSlashSlash = customSchemes[i][1];
        const flags = optionalSlashSlash ? {
            [$a65b6102f2fcfdb4$var$scheme]: true
        } : {
            [$a65b6102f2fcfdb4$var$slashscheme]: true
        };
        if (sch.indexOf("-") >= 0) flags[$a65b6102f2fcfdb4$var$domain] = true;
        else if (!$a65b6102f2fcfdb4$var$ASCII_LETTER.test(sch)) flags[$a65b6102f2fcfdb4$var$numeric] = true; // numbers only
        else if ($a65b6102f2fcfdb4$var$DIGIT.test(sch)) flags[$a65b6102f2fcfdb4$var$asciinumeric] = true;
        else flags[$a65b6102f2fcfdb4$var$ascii] = true;
        $a65b6102f2fcfdb4$var$ts(Start, sch, sch, flags);
    }
    // Localhost token
    $a65b6102f2fcfdb4$var$ts(Start, "localhost", $a65b6102f2fcfdb4$var$LOCALHOST, {
        ascii: true
    });
    // Set default transition for start state (some symbol)
    Start.jd = new $a65b6102f2fcfdb4$export$7254cc27399e90bd($a65b6102f2fcfdb4$var$SYM);
    return {
        start: Start,
        tokens: Object.assign({
            groups: groups
        }, $a65b6102f2fcfdb4$var$tk)
    };
}
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/ function $a65b6102f2fcfdb4$var$run$1(start, str) {
    // State machine is not case sensitive, so input is tokenized in lowercased
    // form (still returns regular case). Uses selective `toLowerCase` because
    // lowercasing the entire string causes the length and character position to
    // vary in some non-English strings with V8-based runtimes.
    const iterable = $a65b6102f2fcfdb4$export$b9ca061da17f2d30(str.replace(/[A-Z]/g, (c)=>c.toLowerCase()));
    const charCount = iterable.length; // <= len if there are emojis, etc
    const tokens = []; // return value
    // cursor through the string itself, accounting for characters that have
    // width with length 2 such as emojis
    let cursor = 0;
    // Cursor through the array-representation of the string
    let charCursor = 0;
    // Tokenize the string
    while(charCursor < charCount){
        let state = start;
        let nextState = null;
        let tokenLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        let charsSinceAccepts = -1;
        while(charCursor < charCount && (nextState = state.go(iterable[charCursor]))){
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                charsSinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) {
                sinceAccepts += iterable[charCursor].length;
                charsSinceAccepts++;
            }
            tokenLength += iterable[charCursor].length;
            cursor += iterable[charCursor].length;
            charCursor++;
        }
        // Roll back to the latest accepting state
        cursor -= sinceAccepts;
        charCursor -= charsSinceAccepts;
        tokenLength -= sinceAccepts;
        // No more jumps, just make a new token from the last accepting one
        tokens.push({
            t: latestAccepting.t,
            // token type/name
            v: str.slice(cursor - tokenLength, cursor),
            // string value
            s: cursor - tokenLength,
            // start index
            e: cursor // end index (excluding)
        });
    }
    return tokens;
}
/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */ function $a65b6102f2fcfdb4$export$b9ca061da17f2d30(str) {
    const result = [];
    const len = str.length;
    let index = 0;
    while(index < len){
        let first = str.charCodeAt(index);
        let second;
        let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
         : str.slice(index, index + 2); // two-index characters
        result.push(char);
        index += char.length;
    }
    return result;
}
/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */ function $a65b6102f2fcfdb4$var$fastts(state, input, t, defaultt, jr) {
    let next;
    const len = input.length;
    for(let i = 0; i < len - 1; i++){
        const char = input[i];
        if (state.j[char]) next = state.j[char];
        else {
            next = new $a65b6102f2fcfdb4$export$7254cc27399e90bd(defaultt);
            next.jr = jr.slice();
            state.j[char] = next;
        }
        state = next;
    }
    next = new $a65b6102f2fcfdb4$export$7254cc27399e90bd(t);
    next.jr = jr.slice();
    state.j[input[len - 1]] = next;
    return next;
}
/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */ function $a65b6102f2fcfdb4$var$decodeTlds(encoded) {
    const words = [];
    const stack = [];
    let i = 0;
    let digits = "0123456789";
    while(i < encoded.length){
        let popDigitCount = 0;
        while(digits.indexOf(encoded[i + popDigitCount]) >= 0)popDigitCount++; // encountered some digits, have to pop to go one level up trie
        if (popDigitCount > 0) {
            words.push(stack.join("")); // whatever preceded the pop digits must be a word
            for(let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--)stack.pop();
            i += popDigitCount;
        } else {
            stack.push(encoded[i]); // drop down a level into the trie
            i++;
        }
    }
    return words;
}
/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */ /**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */ /**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */ /**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */ /**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */ /**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */ /**
 * @type Required<Opts>
 */ const $a65b6102f2fcfdb4$var$defaults = {
    defaultProtocol: "http",
    events: null,
    format: $a65b6102f2fcfdb4$var$noop,
    formatHref: $a65b6102f2fcfdb4$var$noop,
    nl2br: false,
    tagName: "a",
    target: null,
    rel: null,
    validate: true,
    truncate: Infinity,
    className: null,
    attributes: null,
    ignoreTags: [],
    render: null
};
/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */ function $a65b6102f2fcfdb4$export$c019608e5b5bb4cb(opts, defaultRender = null) {
    let o = Object.assign({}, $a65b6102f2fcfdb4$var$defaults);
    if (opts) o = Object.assign(o, opts instanceof $a65b6102f2fcfdb4$export$c019608e5b5bb4cb ? opts.o : opts);
    // Ensure all ignored tags are uppercase
    const ignoredTags = o.ignoreTags;
    const uppercaseIgnoredTags = [];
    for(let i = 0; i < ignoredTags.length; i++)uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
    /** @protected */ this.o = o;
    if (defaultRender) this.defaultRender = defaultRender;
    this.ignoreTags = uppercaseIgnoredTags;
}
$a65b6102f2fcfdb4$export$c019608e5b5bb4cb.prototype = {
    o: $a65b6102f2fcfdb4$var$defaults,
    /**
   * @type string[]
   */ ignoreTags: [],
    /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */ defaultRender (ir) {
        return ir;
    },
    /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */ check (token) {
        return this.get("validate", token.toString(), token);
    },
    // Private methods
    /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */ get (key, operator, token) {
        const isCallable = operator != null;
        let option = this.o[key];
        if (!option) return option;
        if (typeof option === "object") {
            option = token.t in option ? option[token.t] : $a65b6102f2fcfdb4$var$defaults[key];
            if (typeof option === "function" && isCallable) option = option(operator, token);
        } else if (typeof option === "function" && isCallable) option = option(operator, token.t, token);
        return option;
    },
    /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */ getObj (key, operator, token) {
        let obj = this.o[key];
        if (typeof obj === "function" && operator != null) obj = obj(operator, token.t, token);
        return obj;
    },
    /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */ render (token) {
        const ir = token.render(this); // intermediate representation
        const renderFn = this.get("render", null, token) || this.defaultRender;
        return renderFn(ir, token.t, token);
    }
};
function $a65b6102f2fcfdb4$var$noop(val) {
    return val;
}
var $a65b6102f2fcfdb4$export$41c562ebe57d11e2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Options: $a65b6102f2fcfdb4$export$c019608e5b5bb4cb,
    defaults: $a65b6102f2fcfdb4$var$defaults
});
/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/ /**
 * @param {string} value
 * @param {Token[]} tokens
 */ function $a65b6102f2fcfdb4$export$28075db42e06f164(value, tokens) {
    this.t = "token";
    this.v = value;
    this.tk = tokens;
}
/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */ $a65b6102f2fcfdb4$export$28075db42e06f164.prototype = {
    isLink: false,
    /**
   * Return the string this token represents.
   * @return {string}
   */ toString () {
        return this.v;
    },
    /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */ toHref (scheme) {
        return this.toString();
    },
    /**
   * @param {Options} options Formatting options
   * @returns {string}
   */ toFormattedString (options) {
        const val = this.toString();
        const truncate = options.get("truncate", val, this);
        const formatted = options.get("format", val, this);
        return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + "\u2026" : formatted;
    },
    /**
   *
   * @param {Options} options
   * @returns {string}
   */ toFormattedHref (options) {
        return options.get("formatHref", this.toHref(options.get("defaultProtocol")), this);
    },
    /**
   * The start index of this token in the original input string
   * @returns {number}
   */ startIndex () {
        return this.tk[0].s;
    },
    /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */ endIndex () {
        return this.tk[this.tk.length - 1].e;
    },
    /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */ toObject (protocol = $a65b6102f2fcfdb4$var$defaults.defaultProtocol) {
        return {
            type: this.t,
            value: this.toString(),
            isLink: this.isLink,
            href: this.toHref(protocol),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   *
   * @param {Options} options Formatting option
   */ toFormattedObject (options) {
        return {
            type: this.t,
            value: this.toFormattedString(options),
            isLink: this.isLink,
            href: this.toFormattedHref(options),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */ validate (options) {
        return options.get("validate", this.toString(), this);
    },
    /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */ render (options) {
        const token = this;
        const href = this.toHref(options.get("defaultProtocol"));
        const formattedHref = options.get("formatHref", href, this);
        const tagName = options.get("tagName", href, token);
        const content = this.toFormattedString(options);
        const attributes = {};
        const className = options.get("className", href, token);
        const target = options.get("target", href, token);
        const rel = options.get("rel", href, token);
        const attrs = options.getObj("attributes", href, token);
        const eventListeners = options.getObj("events", href, token);
        attributes.href = formattedHref;
        if (className) attributes.class = className;
        if (target) attributes.target = target;
        if (rel) attributes.rel = rel;
        if (attrs) Object.assign(attributes, attrs);
        return {
            tagName: tagName,
            attributes: attributes,
            content: content,
            eventListeners: eventListeners
        };
    }
};
/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */ function $a65b6102f2fcfdb4$export$21042e7280c1baba(type, props) {
    class Token extends $a65b6102f2fcfdb4$export$28075db42e06f164 {
        constructor(value, tokens){
            super(value, tokens);
            this.t = type;
        }
    }
    for(const p in props)Token.prototype[p] = props[p];
    Token.t = type;
    return Token;
}
/**
	Represents a list of tokens making up a valid email address
*/ const $a65b6102f2fcfdb4$var$Email = $a65b6102f2fcfdb4$export$21042e7280c1baba("email", {
    isLink: true,
    toHref () {
        return "mailto:" + this.toString();
    }
});
/**
	Represents some plain text
*/ const $a65b6102f2fcfdb4$var$Text = $a65b6102f2fcfdb4$export$21042e7280c1baba("text");
/**
	Multi-linebreak token - represents a line break
	@class Nl
*/ const $a65b6102f2fcfdb4$var$Nl = $a65b6102f2fcfdb4$export$21042e7280c1baba("nl");
/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/ const $a65b6102f2fcfdb4$var$Url = $a65b6102f2fcfdb4$export$21042e7280c1baba("url", {
    isLink: true,
    /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */ toHref (scheme = $a65b6102f2fcfdb4$var$defaults.defaultProtocol) {
        // Check if already has a prefix scheme
        return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
    },
    /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */ hasProtocol () {
        const tokens = this.tk;
        return tokens.length >= 2 && tokens[0].t !== $a65b6102f2fcfdb4$var$LOCALHOST && tokens[1].t === $a65b6102f2fcfdb4$var$COLON;
    }
});
var $a65b6102f2fcfdb4$export$13e2537ceeaf8a3a = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Base: $a65b6102f2fcfdb4$export$28075db42e06f164,
    Email: $a65b6102f2fcfdb4$var$Email,
    MultiToken: $a65b6102f2fcfdb4$export$28075db42e06f164,
    Nl: $a65b6102f2fcfdb4$var$Nl,
    Text: $a65b6102f2fcfdb4$var$Text,
    Url: $a65b6102f2fcfdb4$var$Url,
    createTokenClass: $a65b6102f2fcfdb4$export$21042e7280c1baba
});
/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/ const $a65b6102f2fcfdb4$var$makeState = (arg)=>new $a65b6102f2fcfdb4$export$7254cc27399e90bd(arg);
/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */ function $a65b6102f2fcfdb4$var$init$1({ groups: groups }) {
    // Types of characters the URL can definitely end in
    const qsAccepting = groups.domain.concat([
        $a65b6102f2fcfdb4$var$AMPERSAND,
        $a65b6102f2fcfdb4$var$ASTERISK,
        $a65b6102f2fcfdb4$var$AT,
        $a65b6102f2fcfdb4$var$BACKSLASH,
        $a65b6102f2fcfdb4$var$BACKTICK,
        $a65b6102f2fcfdb4$var$CARET,
        $a65b6102f2fcfdb4$var$DOLLAR,
        $a65b6102f2fcfdb4$var$EQUALS,
        $a65b6102f2fcfdb4$var$HYPHEN,
        $a65b6102f2fcfdb4$var$NUM,
        $a65b6102f2fcfdb4$var$PERCENT,
        $a65b6102f2fcfdb4$var$PIPE,
        $a65b6102f2fcfdb4$var$PLUS,
        $a65b6102f2fcfdb4$var$POUND,
        $a65b6102f2fcfdb4$var$SLASH,
        $a65b6102f2fcfdb4$var$SYM,
        $a65b6102f2fcfdb4$var$TILDE,
        $a65b6102f2fcfdb4$var$UNDERSCORE
    ]);
    // Types of tokens that can follow a URL and be part of the query string
    // but cannot be the very last characters
    // Characters that cannot appear in the URL at all should be excluded
    const qsNonAccepting = [
        $a65b6102f2fcfdb4$var$APOSTROPHE,
        $a65b6102f2fcfdb4$var$COLON,
        $a65b6102f2fcfdb4$var$COMMA,
        $a65b6102f2fcfdb4$var$DOT,
        $a65b6102f2fcfdb4$var$EXCLAMATION,
        $a65b6102f2fcfdb4$var$PERCENT,
        $a65b6102f2fcfdb4$var$QUERY,
        $a65b6102f2fcfdb4$var$QUOTE,
        $a65b6102f2fcfdb4$var$SEMI,
        $a65b6102f2fcfdb4$var$OPENANGLEBRACKET,
        $a65b6102f2fcfdb4$var$CLOSEANGLEBRACKET,
        $a65b6102f2fcfdb4$var$OPENBRACE,
        $a65b6102f2fcfdb4$var$CLOSEBRACE,
        $a65b6102f2fcfdb4$var$CLOSEBRACKET,
        $a65b6102f2fcfdb4$var$OPENBRACKET,
        $a65b6102f2fcfdb4$var$OPENPAREN,
        $a65b6102f2fcfdb4$var$CLOSEPAREN,
        $a65b6102f2fcfdb4$var$FULLWIDTHLEFTPAREN,
        $a65b6102f2fcfdb4$var$FULLWIDTHRIGHTPAREN,
        $a65b6102f2fcfdb4$var$LEFTCORNERBRACKET,
        $a65b6102f2fcfdb4$var$RIGHTCORNERBRACKET,
        $a65b6102f2fcfdb4$var$LEFTWHITECORNERBRACKET,
        $a65b6102f2fcfdb4$var$RIGHTWHITECORNERBRACKET,
        $a65b6102f2fcfdb4$var$FULLWIDTHLESSTHAN,
        $a65b6102f2fcfdb4$var$FULLWIDTHGREATERTHAN
    ];
    // For addresses without the mailto prefix
    // Tokens allowed in the localpart of the email
    const localpartAccepting = [
        $a65b6102f2fcfdb4$var$AMPERSAND,
        $a65b6102f2fcfdb4$var$APOSTROPHE,
        $a65b6102f2fcfdb4$var$ASTERISK,
        $a65b6102f2fcfdb4$var$BACKSLASH,
        $a65b6102f2fcfdb4$var$BACKTICK,
        $a65b6102f2fcfdb4$var$CARET,
        $a65b6102f2fcfdb4$var$DOLLAR,
        $a65b6102f2fcfdb4$var$EQUALS,
        $a65b6102f2fcfdb4$var$HYPHEN,
        $a65b6102f2fcfdb4$var$OPENBRACE,
        $a65b6102f2fcfdb4$var$CLOSEBRACE,
        $a65b6102f2fcfdb4$var$PERCENT,
        $a65b6102f2fcfdb4$var$PIPE,
        $a65b6102f2fcfdb4$var$PLUS,
        $a65b6102f2fcfdb4$var$POUND,
        $a65b6102f2fcfdb4$var$QUERY,
        $a65b6102f2fcfdb4$var$SLASH,
        $a65b6102f2fcfdb4$var$SYM,
        $a65b6102f2fcfdb4$var$TILDE,
        $a65b6102f2fcfdb4$var$UNDERSCORE
    ];
    // The universal starting state.
    /**
   * @type State<Token>
   */ const Start = $a65b6102f2fcfdb4$var$makeState();
    const Localpart = $a65b6102f2fcfdb4$var$tt(Start, $a65b6102f2fcfdb4$var$TILDE); // Local part of the email address
    $a65b6102f2fcfdb4$var$ta(Localpart, localpartAccepting, Localpart);
    $a65b6102f2fcfdb4$var$ta(Localpart, groups.domain, Localpart);
    const Domain = $a65b6102f2fcfdb4$var$makeState(), Scheme = $a65b6102f2fcfdb4$var$makeState(), SlashScheme = $a65b6102f2fcfdb4$var$makeState();
    $a65b6102f2fcfdb4$var$ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
    $a65b6102f2fcfdb4$var$ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
    $a65b6102f2fcfdb4$var$ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'
    $a65b6102f2fcfdb4$var$ta(Domain, localpartAccepting, Localpart);
    $a65b6102f2fcfdb4$var$ta(Domain, groups.domain, Domain);
    const LocalpartAt = $a65b6102f2fcfdb4$var$tt(Domain, $a65b6102f2fcfdb4$var$AT); // Local part of the email address plus @
    $a65b6102f2fcfdb4$var$tt(Localpart, $a65b6102f2fcfdb4$var$AT, LocalpartAt); // close to an email address now
    // Local part of an email address can be e.g. 'http' or 'mailto'
    $a65b6102f2fcfdb4$var$tt(Scheme, $a65b6102f2fcfdb4$var$AT, LocalpartAt);
    $a65b6102f2fcfdb4$var$tt(SlashScheme, $a65b6102f2fcfdb4$var$AT, LocalpartAt);
    const LocalpartDot = $a65b6102f2fcfdb4$var$tt(Localpart, $a65b6102f2fcfdb4$var$DOT); // Local part of the email address plus '.' (localpart cannot end in .)
    $a65b6102f2fcfdb4$var$ta(LocalpartDot, localpartAccepting, Localpart);
    $a65b6102f2fcfdb4$var$ta(LocalpartDot, groups.domain, Localpart);
    const EmailDomain = $a65b6102f2fcfdb4$var$makeState();
    $a65b6102f2fcfdb4$var$ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
    $a65b6102f2fcfdb4$var$ta(EmailDomain, groups.domain, EmailDomain);
    const EmailDomainDot = $a65b6102f2fcfdb4$var$tt(EmailDomain, $a65b6102f2fcfdb4$var$DOT); // domain followed by DOT
    $a65b6102f2fcfdb4$var$ta(EmailDomainDot, groups.domain, EmailDomain);
    const Email$1 = $a65b6102f2fcfdb4$var$makeState($a65b6102f2fcfdb4$var$Email); // Possible email address (could have more tlds)
    $a65b6102f2fcfdb4$var$ta(EmailDomainDot, groups.tld, Email$1);
    $a65b6102f2fcfdb4$var$ta(EmailDomainDot, groups.utld, Email$1);
    $a65b6102f2fcfdb4$var$tt(LocalpartAt, $a65b6102f2fcfdb4$var$LOCALHOST, Email$1);
    // Hyphen can jump back to a domain name
    const EmailDomainHyphen = $a65b6102f2fcfdb4$var$tt(EmailDomain, $a65b6102f2fcfdb4$var$HYPHEN); // parsed string starts with local email info + @ with a potential domain name
    $a65b6102f2fcfdb4$var$tt(EmailDomainHyphen, $a65b6102f2fcfdb4$var$HYPHEN, EmailDomainHyphen);
    $a65b6102f2fcfdb4$var$ta(EmailDomainHyphen, groups.domain, EmailDomain);
    $a65b6102f2fcfdb4$var$ta(Email$1, groups.domain, EmailDomain);
    $a65b6102f2fcfdb4$var$tt(Email$1, $a65b6102f2fcfdb4$var$DOT, EmailDomainDot);
    $a65b6102f2fcfdb4$var$tt(Email$1, $a65b6102f2fcfdb4$var$HYPHEN, EmailDomainHyphen);
    // Final possible email states
    const EmailColon = $a65b6102f2fcfdb4$var$tt(Email$1, $a65b6102f2fcfdb4$var$COLON); // URL followed by colon (potential port number here)
    /*const EmailColonPort = */ $a65b6102f2fcfdb4$var$ta(EmailColon, groups.numeric, $a65b6102f2fcfdb4$var$Email); // URL followed by colon and port number
    // Account for dots and hyphens. Hyphens are usually parts of domain names
    // (but not TLDs)
    const DomainHyphen = $a65b6102f2fcfdb4$var$tt(Domain, $a65b6102f2fcfdb4$var$HYPHEN); // domain followed by hyphen
    const DomainDot = $a65b6102f2fcfdb4$var$tt(Domain, $a65b6102f2fcfdb4$var$DOT); // domain followed by DOT
    $a65b6102f2fcfdb4$var$tt(DomainHyphen, $a65b6102f2fcfdb4$var$HYPHEN, DomainHyphen);
    $a65b6102f2fcfdb4$var$ta(DomainHyphen, groups.domain, Domain);
    $a65b6102f2fcfdb4$var$ta(DomainDot, localpartAccepting, Localpart);
    $a65b6102f2fcfdb4$var$ta(DomainDot, groups.domain, Domain);
    const DomainDotTld = $a65b6102f2fcfdb4$var$makeState($a65b6102f2fcfdb4$var$Url); // Simplest possible URL with no query string
    $a65b6102f2fcfdb4$var$ta(DomainDot, groups.tld, DomainDotTld);
    $a65b6102f2fcfdb4$var$ta(DomainDot, groups.utld, DomainDotTld);
    $a65b6102f2fcfdb4$var$ta(DomainDotTld, groups.domain, Domain);
    $a65b6102f2fcfdb4$var$ta(DomainDotTld, localpartAccepting, Localpart);
    $a65b6102f2fcfdb4$var$tt(DomainDotTld, $a65b6102f2fcfdb4$var$DOT, DomainDot);
    $a65b6102f2fcfdb4$var$tt(DomainDotTld, $a65b6102f2fcfdb4$var$HYPHEN, DomainHyphen);
    $a65b6102f2fcfdb4$var$tt(DomainDotTld, $a65b6102f2fcfdb4$var$AT, LocalpartAt);
    const DomainDotTldColon = $a65b6102f2fcfdb4$var$tt(DomainDotTld, $a65b6102f2fcfdb4$var$COLON); // URL followed by colon (potential port number here)
    const DomainDotTldColonPort = $a65b6102f2fcfdb4$var$makeState($a65b6102f2fcfdb4$var$Url); // TLD followed by a port number
    $a65b6102f2fcfdb4$var$ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);
    // Long URL with optional port and maybe query string
    const Url$1 = $a65b6102f2fcfdb4$var$makeState($a65b6102f2fcfdb4$var$Url);
    // URL with extra symbols at the end, followed by an opening bracket
    const UrlNonaccept = $a65b6102f2fcfdb4$var$makeState(); // URL followed by some symbols (will not be part of the final URL)
    // Query strings
    $a65b6102f2fcfdb4$var$ta(Url$1, qsAccepting, Url$1);
    $a65b6102f2fcfdb4$var$ta(Url$1, qsNonAccepting, UrlNonaccept);
    $a65b6102f2fcfdb4$var$ta(UrlNonaccept, qsAccepting, Url$1);
    $a65b6102f2fcfdb4$var$ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);
    // Become real URLs after `SLASH` or `COLON NUM SLASH`
    // Here works with or without scheme:// prefix
    $a65b6102f2fcfdb4$var$tt(DomainDotTld, $a65b6102f2fcfdb4$var$SLASH, Url$1);
    $a65b6102f2fcfdb4$var$tt(DomainDotTldColonPort, $a65b6102f2fcfdb4$var$SLASH, Url$1);
    // Note that domains that begin with schemes are treated slighly differently
    const SchemeColon = $a65b6102f2fcfdb4$var$tt(Scheme, $a65b6102f2fcfdb4$var$COLON); // e.g., 'mailto:'
    const SlashSchemeColon = $a65b6102f2fcfdb4$var$tt(SlashScheme, $a65b6102f2fcfdb4$var$COLON); // e.g., 'http:'
    const SlashSchemeColonSlash = $a65b6102f2fcfdb4$var$tt(SlashSchemeColon, $a65b6102f2fcfdb4$var$SLASH); // e.g., 'http:/'
    const UriPrefix = $a65b6102f2fcfdb4$var$tt(SlashSchemeColonSlash, $a65b6102f2fcfdb4$var$SLASH); // e.g., 'http://'
    // Scheme states can transition to domain states
    $a65b6102f2fcfdb4$var$ta(Scheme, groups.domain, Domain);
    $a65b6102f2fcfdb4$var$tt(Scheme, $a65b6102f2fcfdb4$var$DOT, DomainDot);
    $a65b6102f2fcfdb4$var$tt(Scheme, $a65b6102f2fcfdb4$var$HYPHEN, DomainHyphen);
    $a65b6102f2fcfdb4$var$ta(SlashScheme, groups.domain, Domain);
    $a65b6102f2fcfdb4$var$tt(SlashScheme, $a65b6102f2fcfdb4$var$DOT, DomainDot);
    $a65b6102f2fcfdb4$var$tt(SlashScheme, $a65b6102f2fcfdb4$var$HYPHEN, DomainHyphen);
    // Force URL with scheme prefix followed by anything sane
    $a65b6102f2fcfdb4$var$ta(SchemeColon, groups.domain, Url$1);
    $a65b6102f2fcfdb4$var$tt(SchemeColon, $a65b6102f2fcfdb4$var$SLASH, Url$1);
    $a65b6102f2fcfdb4$var$tt(SchemeColon, $a65b6102f2fcfdb4$var$QUERY, Url$1);
    $a65b6102f2fcfdb4$var$ta(UriPrefix, groups.domain, Url$1);
    $a65b6102f2fcfdb4$var$ta(UriPrefix, qsAccepting, Url$1);
    $a65b6102f2fcfdb4$var$tt(UriPrefix, $a65b6102f2fcfdb4$var$SLASH, Url$1);
    const bracketPairs = [
        [
            $a65b6102f2fcfdb4$var$OPENBRACE,
            $a65b6102f2fcfdb4$var$CLOSEBRACE
        ],
        // {}
        [
            $a65b6102f2fcfdb4$var$OPENBRACKET,
            $a65b6102f2fcfdb4$var$CLOSEBRACKET
        ],
        // []
        [
            $a65b6102f2fcfdb4$var$OPENPAREN,
            $a65b6102f2fcfdb4$var$CLOSEPAREN
        ],
        // ()
        [
            $a65b6102f2fcfdb4$var$OPENANGLEBRACKET,
            $a65b6102f2fcfdb4$var$CLOSEANGLEBRACKET
        ],
        // <>
        [
            $a65b6102f2fcfdb4$var$FULLWIDTHLEFTPAREN,
            $a65b6102f2fcfdb4$var$FULLWIDTHRIGHTPAREN
        ],
        // （）
        [
            $a65b6102f2fcfdb4$var$LEFTCORNERBRACKET,
            $a65b6102f2fcfdb4$var$RIGHTCORNERBRACKET
        ],
        // 「」
        [
            $a65b6102f2fcfdb4$var$LEFTWHITECORNERBRACKET,
            $a65b6102f2fcfdb4$var$RIGHTWHITECORNERBRACKET
        ],
        // 『』
        [
            $a65b6102f2fcfdb4$var$FULLWIDTHLESSTHAN,
            $a65b6102f2fcfdb4$var$FULLWIDTHGREATERTHAN
        ] // ＜＞
    ];
    for(let i = 0; i < bracketPairs.length; i++){
        const [OPEN, CLOSE] = bracketPairs[i];
        const UrlOpen = $a65b6102f2fcfdb4$var$tt(Url$1, OPEN); // URL followed by open bracket
        // Continue not accepting for open brackets
        $a65b6102f2fcfdb4$var$tt(UrlNonaccept, OPEN, UrlOpen);
        // Closing bracket component. This character WILL be included in the URL
        $a65b6102f2fcfdb4$var$tt(UrlOpen, CLOSE, Url$1);
        // URL that beings with an opening bracket, followed by a symbols.
        // Note that the final state can still be `UrlOpen` (if the URL has a
        // single opening bracket for some reason).
        const UrlOpenQ = $a65b6102f2fcfdb4$var$makeState($a65b6102f2fcfdb4$var$Url);
        $a65b6102f2fcfdb4$var$ta(UrlOpen, qsAccepting, UrlOpenQ);
        const UrlOpenSyms = $a65b6102f2fcfdb4$var$makeState(); // UrlOpen followed by some symbols it cannot end it
        $a65b6102f2fcfdb4$var$ta(UrlOpen, qsNonAccepting);
        // URL that begins with an opening bracket, followed by some symbols
        $a65b6102f2fcfdb4$var$ta(UrlOpenQ, qsAccepting, UrlOpenQ);
        $a65b6102f2fcfdb4$var$ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
        $a65b6102f2fcfdb4$var$ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
        $a65b6102f2fcfdb4$var$ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);
        // Close brace/bracket to become regular URL
        $a65b6102f2fcfdb4$var$tt(UrlOpenQ, CLOSE, Url$1);
        $a65b6102f2fcfdb4$var$tt(UrlOpenSyms, CLOSE, Url$1);
    }
    $a65b6102f2fcfdb4$var$tt(Start, $a65b6102f2fcfdb4$var$LOCALHOST, DomainDotTld); // localhost is a valid URL state
    $a65b6102f2fcfdb4$var$tt(Start, $a65b6102f2fcfdb4$var$NL, $a65b6102f2fcfdb4$var$Nl); // single new line
    return {
        start: Start,
        tokens: $a65b6102f2fcfdb4$var$tk
    };
}
/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */ function $a65b6102f2fcfdb4$var$run(start, input, tokens) {
    let len = tokens.length;
    let cursor = 0;
    let multis = [];
    let textTokens = [];
    while(cursor < len){
        let state = start;
        let secondState = null;
        let nextState = null;
        let multiLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        while(cursor < len && !(secondState = state.go(tokens[cursor].t)))// Starting tokens with nowhere to jump to.
        // Consider these to be just plain text
        textTokens.push(tokens[cursor++]);
        while(cursor < len && (nextState = secondState || state.go(tokens[cursor].t))){
            // Get the next state
            secondState = null;
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) sinceAccepts++;
            cursor++;
            multiLength++;
        }
        if (sinceAccepts < 0) {
            // No accepting state was found, part of a regular text token add
            // the first text token to the text tokens array and try again from
            // the next
            cursor -= multiLength;
            if (cursor < len) {
                textTokens.push(tokens[cursor]);
                cursor++;
            }
        } else {
            // Accepting state!
            // First close off the textTokens (if available)
            if (textTokens.length > 0) {
                multis.push($a65b6102f2fcfdb4$var$initMultiToken($a65b6102f2fcfdb4$var$Text, input, textTokens));
                textTokens = [];
            }
            // Roll back to the latest accepting state
            cursor -= sinceAccepts;
            multiLength -= sinceAccepts;
            // Create a new multitoken
            const Multi = latestAccepting.t;
            const subtokens = tokens.slice(cursor - multiLength, cursor);
            multis.push($a65b6102f2fcfdb4$var$initMultiToken(Multi, input, subtokens));
        }
    }
    // Finally close off the textTokens (if available)
    if (textTokens.length > 0) multis.push($a65b6102f2fcfdb4$var$initMultiToken($a65b6102f2fcfdb4$var$Text, input, textTokens));
    return multis;
}
/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */ function $a65b6102f2fcfdb4$var$initMultiToken(Multi, input, tokens) {
    const startIdx = tokens[0].s;
    const endIdx = tokens[tokens.length - 1].e;
    const value = input.slice(startIdx, endIdx);
    return new Multi(value, tokens);
}
const $a65b6102f2fcfdb4$var$warn = typeof console !== "undefined" && console && console.warn || (()=>{});
const $a65b6102f2fcfdb4$var$warnAdvice = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.";
// Side-effect initialization state
const $a65b6102f2fcfdb4$var$INIT = {
    scanner: null,
    parser: null,
    tokenQueue: [],
    pluginQueue: [],
    customSchemes: [],
    initialized: false
};
/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */ /**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */ /**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */ /**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */ /**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */ function $a65b6102f2fcfdb4$export$aad8462122ac592b() {
    $a65b6102f2fcfdb4$export$7254cc27399e90bd.groups = {};
    $a65b6102f2fcfdb4$var$INIT.scanner = null;
    $a65b6102f2fcfdb4$var$INIT.parser = null;
    $a65b6102f2fcfdb4$var$INIT.tokenQueue = [];
    $a65b6102f2fcfdb4$var$INIT.pluginQueue = [];
    $a65b6102f2fcfdb4$var$INIT.customSchemes = [];
    $a65b6102f2fcfdb4$var$INIT.initialized = false;
    return $a65b6102f2fcfdb4$var$INIT;
}
/**
 * Register a token plugin to allow the scanner to recognize additional token
 * types before the parser state machine is constructed from the results.
 * @param {string} name of plugin to register
 * @param {TokenPlugin} plugin function that accepts the scanner state machine
 * and available scanner tokens and collections and extends the state machine to
 * recognize additional tokens or groups.
 */ function $a65b6102f2fcfdb4$export$56d1f1cb1f3c0e96(name, plugin) {
    if (typeof plugin !== "function") throw new Error(`linkifyjs: Invalid token plugin ${plugin} (expects function)`);
    for(let i = 0; i < $a65b6102f2fcfdb4$var$INIT.tokenQueue.length; i++)if (name === $a65b6102f2fcfdb4$var$INIT.tokenQueue[i][0]) {
        $a65b6102f2fcfdb4$var$warn(`linkifyjs: token plugin "${name}" already registered - will be overwritten`);
        $a65b6102f2fcfdb4$var$INIT.tokenQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $a65b6102f2fcfdb4$var$INIT.tokenQueue.push([
        name,
        plugin
    ]);
    if ($a65b6102f2fcfdb4$var$INIT.initialized) $a65b6102f2fcfdb4$var$warn(`linkifyjs: already initialized - will not register token plugin "${name}" ${$a65b6102f2fcfdb4$var$warnAdvice}`);
}
/**
 * Register a linkify plugin
 * @param {string} name of plugin to register
 * @param {Plugin} plugin function that accepts the parser state machine and
 * extends the parser to recognize additional link types
 */ function $a65b6102f2fcfdb4$export$7612db19fb8beb1e(name, plugin) {
    if (typeof plugin !== "function") throw new Error(`linkifyjs: Invalid plugin ${plugin} (expects function)`);
    for(let i = 0; i < $a65b6102f2fcfdb4$var$INIT.pluginQueue.length; i++)if (name === $a65b6102f2fcfdb4$var$INIT.pluginQueue[i][0]) {
        $a65b6102f2fcfdb4$var$warn(`linkifyjs: plugin "${name}" already registered - will be overwritten`);
        $a65b6102f2fcfdb4$var$INIT.pluginQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $a65b6102f2fcfdb4$var$INIT.pluginQueue.push([
        name,
        plugin
    ]);
    if ($a65b6102f2fcfdb4$var$INIT.initialized) $a65b6102f2fcfdb4$var$warn(`linkifyjs: already initialized - will not register plugin "${name}" ${$a65b6102f2fcfdb4$var$warnAdvice}`);
}
/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} scheme
 * @param {boolean} [optionalSlashSlash]
 */ function $a65b6102f2fcfdb4$export$821627edc2d26f5f(scheme, optionalSlashSlash = false) {
    if ($a65b6102f2fcfdb4$var$INIT.initialized) $a65b6102f2fcfdb4$var$warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${$a65b6102f2fcfdb4$var$warnAdvice}`);
    if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
    $a65b6102f2fcfdb4$var$INIT.customSchemes.push([
        scheme,
        optionalSlashSlash
    ]);
}
/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */ function $a65b6102f2fcfdb4$export$2cd8252107eb640b() {
    // Initialize scanner state machine and plugins
    $a65b6102f2fcfdb4$var$INIT.scanner = $a65b6102f2fcfdb4$var$init$2($a65b6102f2fcfdb4$var$INIT.customSchemes);
    for(let i = 0; i < $a65b6102f2fcfdb4$var$INIT.tokenQueue.length; i++)$a65b6102f2fcfdb4$var$INIT.tokenQueue[i][1]({
        scanner: $a65b6102f2fcfdb4$var$INIT.scanner
    });
    // Initialize parser state machine and plugins
    $a65b6102f2fcfdb4$var$INIT.parser = $a65b6102f2fcfdb4$var$init$1($a65b6102f2fcfdb4$var$INIT.scanner.tokens);
    for(let i = 0; i < $a65b6102f2fcfdb4$var$INIT.pluginQueue.length; i++)$a65b6102f2fcfdb4$var$INIT.pluginQueue[i][1]({
        scanner: $a65b6102f2fcfdb4$var$INIT.scanner,
        parser: $a65b6102f2fcfdb4$var$INIT.parser
    });
    $a65b6102f2fcfdb4$var$INIT.initialized = true;
    return $a65b6102f2fcfdb4$var$INIT;
}
/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */ function $a65b6102f2fcfdb4$export$660b2ee2d4fb4eff(str) {
    if (!$a65b6102f2fcfdb4$var$INIT.initialized) $a65b6102f2fcfdb4$export$2cd8252107eb640b();
    return $a65b6102f2fcfdb4$var$run($a65b6102f2fcfdb4$var$INIT.parser.start, str, $a65b6102f2fcfdb4$var$run$1($a65b6102f2fcfdb4$var$INIT.scanner.start, str));
}
$a65b6102f2fcfdb4$export$660b2ee2d4fb4eff.scan = $a65b6102f2fcfdb4$var$run$1; // for testing
/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */ function $a65b6102f2fcfdb4$export$71aa6c912b956294(str, type = null, opts = null) {
    if (type && typeof type === "object") {
        if (opts) throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
        opts = type;
        type = null;
    }
    const options = new $a65b6102f2fcfdb4$export$c019608e5b5bb4cb(opts);
    const tokens = $a65b6102f2fcfdb4$export$660b2ee2d4fb4eff(str);
    const filtered = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.isLink && (!type || token.t === type) && options.check(token)) filtered.push(token.toFormattedObject(options));
    }
    return filtered;
}
/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */ function $a65b6102f2fcfdb4$export$e0969da9b8fb378d(str, type = null) {
    const tokens = $a65b6102f2fcfdb4$export$660b2ee2d4fb4eff(str);
    return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}



/**
 * Check if the provided tokens form a valid link structure, which can either be a single link token
 * or a link token surrounded by parentheses or square brackets.
 *
 * This ensures that only complete and valid text is hyperlinked, preventing cases where a valid
 * top-level domain (TLD) is immediately followed by an invalid character, like a number. For
 * example, with the `find` method from Linkify, entering `example.com1` would result in
 * `example.com` being linked and the trailing `1` left as plain text. By using the `tokenize`
 * method, we can perform more comprehensive validation on the input text.
 */ function $4aa5a1942f39557a$var$isValidLinkStructure(tokens) {
    if (tokens.length === 1) return tokens[0].isLink;
    if (tokens.length === 3 && tokens[1].isLink) return [
        "()",
        "[]"
    ].includes(tokens[0].value + tokens[2].value);
    return false;
}
/**
 * This plugin allows you to automatically add links to your editor.
 * @param options The plugin options
 * @returns The plugin instance
 */ function $4aa5a1942f39557a$var$autolink(options) {
    return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("autolink"),
        appendTransaction: (transactions, oldState, newState)=>{
            /**
             * Does the transaction change the document?
             */ const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
            /**
             * Prevent autolink if the transaction is not a document change or if the transaction has the meta `preventAutolink`.
             */ const preventAutolink = transactions.some((transaction)=>transaction.getMeta("preventAutolink"));
            /**
             * Prevent autolink if the transaction is not a document change
             * or if the transaction has the meta `preventAutolink`.
             */ if (!docChanges || preventAutolink) return;
            const { tr: tr } = newState;
            const transform = (0, $aceda74b73705131$export$f945f1716a5df33d)(oldState.doc, [
                ...transactions
            ]);
            const changes = (0, $aceda74b73705131$export$ba396fc65ff2f439)(transform);
            changes.forEach(({ newRange: newRange })=>{
                // Now let’s see if we can add new links.
                const nodesInChangedRanges = (0, $aceda74b73705131$export$6a2a251dde98a23)(newState.doc, newRange, (node)=>node.isTextblock);
                let textBlock;
                let textBeforeWhitespace;
                if (nodesInChangedRanges.length > 1) {
                    // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, " ");
                } else if (nodesInChangedRanges.length && newState.doc.textBetween(newRange.from, newRange.to, " ", " ").endsWith(" ")) {
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, " ");
                }
                if (textBlock && textBeforeWhitespace) {
                    const wordsBeforeWhitespace = textBeforeWhitespace.split(" ").filter((s)=>s !== "");
                    if (wordsBeforeWhitespace.length <= 0) return false;
                    const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
                    const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
                    if (!lastWordBeforeSpace) return false;
                    const linksBeforeSpace = (0, $a65b6102f2fcfdb4$export$660b2ee2d4fb4eff)(lastWordBeforeSpace).map((t)=>t.toObject());
                    if (!$4aa5a1942f39557a$var$isValidLinkStructure(linksBeforeSpace)) return false;
                    linksBeforeSpace.filter((link)=>link.isLink)// Calculate link position.
                    .map((link)=>({
                            ...link,
                            from: lastWordAndBlockOffset + link.start + 1,
                            to: lastWordAndBlockOffset + link.end + 1
                        }))// ignore link inside code mark
                    .filter((link)=>{
                        if (!newState.schema.marks.code) return true;
                        return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
                    })// validate link
                    .filter((link)=>{
                        if (options.validate) return options.validate(link.value);
                        return true;
                    })// Add link mark.
                    .forEach((link)=>{
                        if ((0, $aceda74b73705131$export$c5fd7af7c5c1efa)(link.from, link.to, newState.doc).some((item)=>item.mark.type === options.type)) return;
                        tr.addMark(link.from, link.to, options.type.create({
                            href: link.href
                        }));
                    });
                }
            });
            if (!tr.steps.length) return;
            return tr;
        }
    });
}
function $4aa5a1942f39557a$var$clickHandler(options) {
    return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("handleClickLink"),
        props: {
            handleClick: (view, pos, event)=>{
                var _a, _b;
                if (options.whenNotEditable && view.editable) return false;
                if (event.button !== 0) return false;
                let a = event.target;
                const els = [];
                while(a.nodeName !== "DIV"){
                    els.push(a);
                    a = a.parentNode;
                }
                if (!els.find((value)=>value.nodeName === "A")) return false;
                const attrs = (0, $aceda74b73705131$export$fe94072fee8a6976)(view.state, options.type.name);
                const link = event.target;
                const href = (_a = link === null || link === void 0 ? void 0 : link.href) !== null && _a !== void 0 ? _a : attrs.href;
                const target = (_b = link === null || link === void 0 ? void 0 : link.target) !== null && _b !== void 0 ? _b : attrs.target;
                if (link && href) {
                    window.open(href, target);
                    return true;
                }
                return false;
            }
        }
    });
}
function $4aa5a1942f39557a$var$pasteHandler(options) {
    return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("handlePasteLink"),
        props: {
            handlePaste: (view, event, slice)=>{
                const { state: state } = view;
                const { selection: selection } = state;
                const { empty: empty } = selection;
                if (empty) return false;
                let textContent = "";
                slice.content.forEach((node)=>{
                    textContent += node.textContent;
                });
                const link = (0, $a65b6102f2fcfdb4$export$71aa6c912b956294)(textContent).find((item)=>item.isLink && item.value === textContent);
                if (!textContent || !link) return false;
                options.editor.commands.setMark(options.type, {
                    href: link.href
                });
                return true;
            }
        }
    });
}
const $4aa5a1942f39557a$export$4ed30f8936af1979 = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi;
/**
 * This extension allows you to create links.
 * @see https://www.tiptap.dev/api/marks/link
 */ const $4aa5a1942f39557a$export$a6c7ac8248d6e38a = (0, $aceda74b73705131$export$c9d15bcfc6d42044).create({
    name: "link",
    priority: 1000,
    keepOnSplit: false,
    onCreate () {
        this.options.protocols.forEach((protocol)=>{
            if (typeof protocol === "string") {
                (0, $a65b6102f2fcfdb4$export$821627edc2d26f5f)(protocol);
                return;
            }
            (0, $a65b6102f2fcfdb4$export$821627edc2d26f5f)(protocol.scheme, protocol.optionalSlashes);
        });
    },
    onDestroy () {
        (0, $a65b6102f2fcfdb4$export$aad8462122ac592b)();
    },
    inclusive () {
        return this.options.autolink;
    },
    addOptions () {
        return {
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
            protocols: [],
            HTMLAttributes: {
                target: "_blank",
                rel: "noopener noreferrer nofollow",
                class: null
            },
            validate: undefined
        };
    },
    addAttributes () {
        return {
            href: {
                default: null
            },
            target: {
                default: this.options.HTMLAttributes.target
            },
            rel: {
                default: this.options.HTMLAttributes.rel
            },
            class: {
                default: this.options.HTMLAttributes.class
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: 'a[href]:not([href *= "javascript:" i])'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        var _a;
        // False positive; we're explicitly checking for javascript: links to ignore them
        // eslint-disable-next-line no-script-url
        if ((_a = HTMLAttributes.href) === null || _a === void 0 ? void 0 : _a.startsWith("javascript:")) // strip out the href
        return [
            "a",
            (0, $aceda74b73705131$export$9f98db6234c4bd78)(this.options.HTMLAttributes, {
                ...HTMLAttributes,
                href: ""
            }),
            0
        ];
        return [
            "a",
            (0, $aceda74b73705131$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setLink: (attributes)=>({ chain: chain })=>{
                    return chain().setMark(this.name, attributes).setMeta("preventAutolink", true).run();
                },
            toggleLink: (attributes)=>({ chain: chain })=>{
                    return chain().toggleMark(this.name, attributes, {
                        extendEmptyMarkRange: true
                    }).setMeta("preventAutolink", true).run();
                },
            unsetLink: ()=>({ chain: chain })=>{
                    return chain().unsetMark(this.name, {
                        extendEmptyMarkRange: true
                    }).setMeta("preventAutolink", true).run();
                }
        };
    },
    addPasteRules () {
        return [
            (0, $aceda74b73705131$export$3845eb97abe74944)({
                find: (text)=>{
                    const foundLinks = [];
                    if (text) {
                        const links = (0, $a65b6102f2fcfdb4$export$71aa6c912b956294)(text).filter((item)=>item.isLink);
                        if (links.length) links.forEach((link)=>foundLinks.push({
                                text: link.value,
                                data: {
                                    href: link.href
                                },
                                index: link.start
                            }));
                    }
                    return foundLinks;
                },
                type: this.type,
                getAttributes: (match)=>{
                    var _a;
                    return {
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href
                    };
                }
            })
        ];
    },
    addProseMirrorPlugins () {
        const plugins = [];
        if (this.options.autolink) plugins.push($4aa5a1942f39557a$var$autolink({
            type: this.type,
            validate: this.options.validate
        }));
        if (this.options.openOnClick) plugins.push($4aa5a1942f39557a$var$clickHandler({
            type: this.type,
            whenNotEditable: this.options.openOnClick === "whenNotEditable"
        }));
        if (this.options.linkOnPaste) plugins.push($4aa5a1942f39557a$var$pasteHandler({
            editor: this.editor,
            type: this.type
        }));
        return plugins;
    }
});




/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $aOl9t = parcelRequire("aOl9t");
var $3tUi5 = parcelRequire("3tUi5");
var $43bf50b0fa1441ac$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $43bf50b0fa1441ac$var$BOX_CLASS = "tippy-box";
var $43bf50b0fa1441ac$var$CONTENT_CLASS = "tippy-content";
var $43bf50b0fa1441ac$var$BACKDROP_CLASS = "tippy-backdrop";
var $43bf50b0fa1441ac$var$ARROW_CLASS = "tippy-arrow";
var $43bf50b0fa1441ac$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $43bf50b0fa1441ac$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $43bf50b0fa1441ac$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $43bf50b0fa1441ac$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $43bf50b0fa1441ac$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $43bf50b0fa1441ac$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $43bf50b0fa1441ac$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $43bf50b0fa1441ac$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $43bf50b0fa1441ac$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $43bf50b0fa1441ac$var$normalizeToArray(value) {
    return [].concat(value);
}
function $43bf50b0fa1441ac$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $43bf50b0fa1441ac$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $43bf50b0fa1441ac$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $43bf50b0fa1441ac$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $43bf50b0fa1441ac$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $43bf50b0fa1441ac$var$div() {
    return document.createElement("div");
}
function $43bf50b0fa1441ac$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $43bf50b0fa1441ac$var$isType(value, type);
    });
}
function $43bf50b0fa1441ac$var$isNodeList(value) {
    return $43bf50b0fa1441ac$var$isType(value, "NodeList");
}
function $43bf50b0fa1441ac$var$isMouseEvent(value) {
    return $43bf50b0fa1441ac$var$isType(value, "MouseEvent");
}
function $43bf50b0fa1441ac$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $43bf50b0fa1441ac$var$getArrayOfElements(value) {
    if ($43bf50b0fa1441ac$var$isElement(value)) return [
        value
    ];
    if ($43bf50b0fa1441ac$var$isNodeList(value)) return $43bf50b0fa1441ac$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $43bf50b0fa1441ac$var$arrayFrom(document.querySelectorAll(value));
}
function $43bf50b0fa1441ac$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $43bf50b0fa1441ac$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $43bf50b0fa1441ac$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $43bf50b0fa1441ac$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $43bf50b0fa1441ac$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $43bf50b0fa1441ac$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $43bf50b0fa1441ac$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $43bf50b0fa1441ac$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $43bf50b0fa1441ac$var$currentInput = {
    isTouch: false
};
var $43bf50b0fa1441ac$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $43bf50b0fa1441ac$var$onDocumentTouchStart() {
    if ($43bf50b0fa1441ac$var$currentInput.isTouch) return;
    $43bf50b0fa1441ac$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $43bf50b0fa1441ac$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $43bf50b0fa1441ac$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $43bf50b0fa1441ac$var$lastMouseMoveTime < 20) {
        $43bf50b0fa1441ac$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $43bf50b0fa1441ac$var$onDocumentMouseMove);
    }
    $43bf50b0fa1441ac$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $43bf50b0fa1441ac$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($43bf50b0fa1441ac$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $43bf50b0fa1441ac$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $43bf50b0fa1441ac$var$onDocumentTouchStart, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $43bf50b0fa1441ac$var$onWindowBlur);
}
var $43bf50b0fa1441ac$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $43bf50b0fa1441ac$var$isIE11 = $43bf50b0fa1441ac$var$isBrowser ? !!window.msCrypto : false;
function $43bf50b0fa1441ac$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $43bf50b0fa1441ac$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $43bf50b0fa1441ac$var$getDevMessage(message) {
    return $43bf50b0fa1441ac$var$clean("\n  %ctippy.js\n\n  %c" + $43bf50b0fa1441ac$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $43bf50b0fa1441ac$var$getFormattedMessage(message) {
    return [
        $43bf50b0fa1441ac$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $43bf50b0fa1441ac$var$visitedMessages;
function $43bf50b0fa1441ac$var$resetVisitedMessages() {
    $43bf50b0fa1441ac$var$visitedMessages = new Set();
}
function $43bf50b0fa1441ac$var$warnWhen(condition, message) {
    if (condition && !$43bf50b0fa1441ac$var$visitedMessages.has(message)) {
        var _console;
        $43bf50b0fa1441ac$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $43bf50b0fa1441ac$var$getFormattedMessage(message));
    }
}
function $43bf50b0fa1441ac$var$errorWhen(condition, message) {
    if (condition && !$43bf50b0fa1441ac$var$visitedMessages.has(message)) {
        var _console2;
        $43bf50b0fa1441ac$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $43bf50b0fa1441ac$var$getFormattedMessage(message));
    }
}
function $43bf50b0fa1441ac$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $43bf50b0fa1441ac$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $43bf50b0fa1441ac$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $43bf50b0fa1441ac$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $43bf50b0fa1441ac$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $43bf50b0fa1441ac$var$defaultProps = Object.assign({
    appendTo: $43bf50b0fa1441ac$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $43bf50b0fa1441ac$var$pluginProps, $43bf50b0fa1441ac$var$renderProps);
var $43bf50b0fa1441ac$var$defaultKeys = Object.keys($43bf50b0fa1441ac$var$defaultProps);
var $43bf50b0fa1441ac$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $43bf50b0fa1441ac$var$defaultProps[key] = partialProps[key];
    });
};
function $43bf50b0fa1441ac$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $43bf50b0fa1441ac$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $43bf50b0fa1441ac$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($43bf50b0fa1441ac$var$getExtendedPassedProps(Object.assign({}, $43bf50b0fa1441ac$var$defaultProps, {
        plugins: plugins
    }))) : $43bf50b0fa1441ac$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $43bf50b0fa1441ac$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $43bf50b0fa1441ac$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $43bf50b0fa1441ac$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $43bf50b0fa1441ac$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $43bf50b0fa1441ac$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $43bf50b0fa1441ac$var$removeProperties($43bf50b0fa1441ac$var$defaultProps, Object.keys($43bf50b0fa1441ac$var$pluginProps));
        var didPassUnknownProp = !$43bf50b0fa1441ac$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $43bf50b0fa1441ac$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $43bf50b0fa1441ac$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(element, html) {
    element[$43bf50b0fa1441ac$var$innerHTML()] = html;
}
function $43bf50b0fa1441ac$var$createArrowElement(value) {
    var arrow = $43bf50b0fa1441ac$var$div();
    if (value === true) arrow.className = $43bf50b0fa1441ac$var$ARROW_CLASS;
    else {
        arrow.className = $43bf50b0fa1441ac$var$SVG_ARROW_CLASS;
        if ($43bf50b0fa1441ac$var$isElement(value)) arrow.appendChild(value);
        else $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $43bf50b0fa1441ac$var$setContent(content, props) {
    if ($43bf50b0fa1441ac$var$isElement(props.content)) {
        $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $43bf50b0fa1441ac$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $43bf50b0fa1441ac$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($43bf50b0fa1441ac$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($43bf50b0fa1441ac$var$ARROW_CLASS) || node.classList.contains($43bf50b0fa1441ac$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($43bf50b0fa1441ac$var$BACKDROP_CLASS);
        })
    };
}
function $43bf50b0fa1441ac$var$render(instance) {
    var popper = $43bf50b0fa1441ac$var$div();
    var box = $43bf50b0fa1441ac$var$div();
    box.className = $43bf50b0fa1441ac$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $43bf50b0fa1441ac$var$div();
    content.className = $43bf50b0fa1441ac$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $43bf50b0fa1441ac$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $43bf50b0fa1441ac$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $43bf50b0fa1441ac$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($43bf50b0fa1441ac$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($43bf50b0fa1441ac$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$43bf50b0fa1441ac$var$render.$$tippy = true;
var $43bf50b0fa1441ac$var$idCounter = 1;
var $43bf50b0fa1441ac$var$mouseMoveListeners = []; // Used by `hideAll()`
var $43bf50b0fa1441ac$var$mountedInstances = [];
function $43bf50b0fa1441ac$var$createTippy(reference, passedProps) {
    var props = $43bf50b0fa1441ac$var$evaluateProps(reference, Object.assign({}, $43bf50b0fa1441ac$var$defaultProps, $43bf50b0fa1441ac$var$getExtendedPassedProps($43bf50b0fa1441ac$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $43bf50b0fa1441ac$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $43bf50b0fa1441ac$var$idCounter++;
    var popperInstance = null;
    var plugins = $43bf50b0fa1441ac$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $43bf50b0fa1441ac$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $43bf50b0fa1441ac$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $43bf50b0fa1441ac$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $43bf50b0fa1441ac$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $43bf50b0fa1441ac$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $43bf50b0fa1441ac$var$mouseMoveListeners = $43bf50b0fa1441ac$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($43bf50b0fa1441ac$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $43bf50b0fa1441ac$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $43bf50b0fa1441ac$var$actualContains(el, actualTarget);
        })) {
            if ($43bf50b0fa1441ac$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $43bf50b0fa1441ac$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $43bf50b0fa1441ac$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $43bf50b0fa1441ac$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $43bf50b0fa1441ac$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($43bf50b0fa1441ac$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $43bf50b0fa1441ac$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $43bf50b0fa1441ac$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($43bf50b0fa1441ac$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $43bf50b0fa1441ac$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $43bf50b0fa1441ac$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $3tUi5.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $43bf50b0fa1441ac$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $43bf50b0fa1441ac$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $43bf50b0fa1441ac$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($43bf50b0fa1441ac$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $43bf50b0fa1441ac$var$evaluateProps(reference, Object.assign({}, prevProps, $43bf50b0fa1441ac$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $43bf50b0fa1441ac$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $43bf50b0fa1441ac$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $43bf50b0fa1441ac$var$currentInput.isTouch && !instance.props.touch;
        var duration = $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(instance.props.duration, 0, $43bf50b0fa1441ac$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $43bf50b0fa1441ac$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $43bf50b0fa1441ac$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $43bf50b0fa1441ac$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $43bf50b0fa1441ac$var$pushIfUnique($43bf50b0fa1441ac$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(instance.props.duration, 1, $43bf50b0fa1441ac$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $43bf50b0fa1441ac$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $43bf50b0fa1441ac$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $43bf50b0fa1441ac$var$pushIfUnique($43bf50b0fa1441ac$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $43bf50b0fa1441ac$var$mountedInstances = $43bf50b0fa1441ac$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $43bf50b0fa1441ac$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $43bf50b0fa1441ac$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $43bf50b0fa1441ac$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $43bf50b0fa1441ac$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $43bf50b0fa1441ac$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $43bf50b0fa1441ac$var$isElement(targets) ? instances[0] : instances;
}
$43bf50b0fa1441ac$var$tippy.defaultProps = $43bf50b0fa1441ac$var$defaultProps;
$43bf50b0fa1441ac$var$tippy.setDefaultProps = $43bf50b0fa1441ac$var$setDefaultProps;
$43bf50b0fa1441ac$var$tippy.currentInput = $43bf50b0fa1441ac$var$currentInput;
var $43bf50b0fa1441ac$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $43bf50b0fa1441ac$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $43bf50b0fa1441ac$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $43bf50b0fa1441ac$var$applyStylesModifier = Object.assign({}, (0, $aOl9t.default), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $43bf50b0fa1441ac$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $43bf50b0fa1441ac$var$tippy($43bf50b0fa1441ac$var$div(), Object.assign({}, $43bf50b0fa1441ac$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $43bf50b0fa1441ac$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $43bf50b0fa1441ac$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $43bf50b0fa1441ac$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $43bf50b0fa1441ac$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $43bf50b0fa1441ac$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $43bf50b0fa1441ac$var$tippy(targets, parentProps);
    var normalizedReturnValue = $43bf50b0fa1441ac$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $43bf50b0fa1441ac$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($43bf50b0fa1441ac$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $43bf50b0fa1441ac$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $43bf50b0fa1441ac$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $43bf50b0fa1441ac$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $43bf50b0fa1441ac$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $43bf50b0fa1441ac$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $43bf50b0fa1441ac$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $43bf50b0fa1441ac$var$createBackdropElement() {
    var backdrop = $43bf50b0fa1441ac$var$div();
    backdrop.className = $43bf50b0fa1441ac$var$BACKDROP_CLASS;
    $43bf50b0fa1441ac$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $43bf50b0fa1441ac$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $43bf50b0fa1441ac$var$activeInstances = [];
function $43bf50b0fa1441ac$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $43bf50b0fa1441ac$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $43bf50b0fa1441ac$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $43bf50b0fa1441ac$var$storeMouseCoords);
}
function $43bf50b0fa1441ac$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $43bf50b0fa1441ac$var$storeMouseCoords);
}
var $43bf50b0fa1441ac$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $43bf50b0fa1441ac$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $43bf50b0fa1441ac$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $43bf50b0fa1441ac$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $43bf50b0fa1441ac$var$activeInstances = $43bf50b0fa1441ac$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($43bf50b0fa1441ac$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $43bf50b0fa1441ac$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($43bf50b0fa1441ac$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($43bf50b0fa1441ac$var$isMouseEvent(event)) $43bf50b0fa1441ac$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $43bf50b0fa1441ac$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $43bf50b0fa1441ac$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $43bf50b0fa1441ac$var$getInlineBoundingClientRect($43bf50b0fa1441ac$var$getBasePlacement(placement), reference.getBoundingClientRect(), $43bf50b0fa1441ac$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($43bf50b0fa1441ac$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($43bf50b0fa1441ac$var$isMouseEvent(event)) {
                    var rects = $43bf50b0fa1441ac$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $43bf50b0fa1441ac$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $43bf50b0fa1441ac$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $43bf50b0fa1441ac$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $43bf50b0fa1441ac$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $43bf50b0fa1441ac$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$43bf50b0fa1441ac$var$tippy.setDefaultProps({
    render: $43bf50b0fa1441ac$var$render
});
var $43bf50b0fa1441ac$export$2e2bcd8739ae039 = $43bf50b0fa1441ac$var$tippy;


class $dfd8bb3ed0b8ae84$export$1518b7671d88a5b3 {
    constructor({ editor: editor, element: element, view: view, tippyOptions: tippyOptions = {}, updateDelay: updateDelay = 250, shouldShow: shouldShow }){
        this.preventHide = false;
        this.shouldShow = ({ view: view, state: state, from: from, to: to })=>{
            const { doc: doc, selection: selection } = state;
            const { empty: empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length && (0, $aceda74b73705131$export$38b50bf35e79aaf3)(state.selection);
            // When clicking on a element inside the bubble menu the editor "blur" event
            // is called and the bubble menu item is focussed. In this case we should
            // consider the menu as part of the editor and keep showing the menu
            const isChildOfMenu = this.element.contains(document.activeElement);
            const hasEditorFocus = view.hasFocus() || isChildOfMenu;
            if (!hasEditorFocus || empty || isEmptyTextBlock || !this.editor.isEditable) return false;
            return true;
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.dragstartHandler = ()=>{
            this.hide();
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) return;
            this.hide();
        };
        this.tippyBlurHandler = (event)=>{
            this.blurHandler({
                event: event
            });
        };
        this.handleDebouncedUpdate = (view, oldState)=>{
            const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
            const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
            if (!selectionChanged && !docChanged) return;
            if (this.updateDebounceTimer) clearTimeout(this.updateDebounceTimer);
            this.updateDebounceTimer = window.setTimeout(()=>{
                this.updateHandler(view, selectionChanged, docChanged, oldState);
            }, this.updateDelay);
        };
        this.updateHandler = (view, selectionChanged, docChanged, oldState)=>{
            var _a, _b, _c;
            const { state: state, composing: composing } = view;
            const { selection: selection } = state;
            const isSame = !selectionChanged && !docChanged;
            if (composing || isSame) return;
            this.createTooltip();
            // support for CellSelections
            const { ranges: ranges } = selection;
            const from = Math.min(...ranges.map((range)=>range.$from.pos));
            const to = Math.max(...ranges.map((range)=>range.$to.pos));
            const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
                editor: this.editor,
                element: this.element,
                view: view,
                state: state,
                oldState: oldState,
                from: from,
                to: to
            });
            if (!shouldShow) {
                this.hide();
                return;
            }
            (_b = this.tippy) === null || _b === void 0 || _b.setProps({
                getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (()=>{
                    if ((0, $aceda74b73705131$export$a8c1d2c13abf8822)(state.selection)) {
                        let node = view.nodeDOM(from);
                        if (node) {
                            const nodeViewWrapper = node.dataset.nodeViewWrapper ? node : node.querySelector("[data-node-view-wrapper]");
                            if (nodeViewWrapper) node = nodeViewWrapper.firstChild;
                            if (node) return node.getBoundingClientRect();
                        }
                    }
                    return (0, $aceda74b73705131$export$660ecae6cde71645)(view, from, to);
                })
            });
            this.show();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        this.updateDelay = updateDelay;
        if (shouldShow) this.shouldShow = shouldShow;
        this.element.addEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.view.dom.addEventListener("dragstart", this.dragstartHandler);
        this.editor.on("focus", this.focusHandler);
        this.editor.on("blur", this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = "visible";
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        this.element.tabIndex = 0;
        if (this.tippy || !editorIsAttached) return;
        this.tippy = (0, $43bf50b0fa1441ac$export$2e2bcd8739ae039)(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: "manual",
            placement: "top",
            hideOnClick: "toggle",
            ...this.tippyOptions
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler);
    }
    update(view, oldState) {
        const { state: state } = view;
        const hasValidSelection = state.selection.from !== state.selection.to;
        if (this.updateDelay > 0 && hasValidSelection) {
            this.handleDebouncedUpdate(view, oldState);
            return;
        }
        const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
        const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
        this.updateHandler(view, selectionChanged, docChanged, oldState);
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler);
        (_b = this.tippy) === null || _b === void 0 || _b.destroy();
        this.element.removeEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.view.dom.removeEventListener("dragstart", this.dragstartHandler);
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
    }
}
const $dfd8bb3ed0b8ae84$export$20c12548414ed018 = (options)=>{
    return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        key: typeof options.pluginKey === "string" ? new (0, $c286ea535d926598$export$1692d8b0e89cecc3)(options.pluginKey) : options.pluginKey,
        view: (view)=>new $dfd8bb3ed0b8ae84$export$1518b7671d88a5b3({
                view: view,
                ...options
            })
    });
};
/**
 * This extension allows you to create a bubble menu.
 * @see https://tiptap.dev/api/extensions/bubble-menu
 */ const $dfd8bb3ed0b8ae84$export$79c1bf6a55bce827 = (0, $aceda74b73705131$export$eeddbf09bb970356).create({
    name: "bubbleMenu",
    addOptions () {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: "bubbleMenu",
            updateDelay: undefined,
            shouldShow: null
        };
    },
    addProseMirrorPlugins () {
        if (!this.options.element) return [];
        return [
            $dfd8bb3ed0b8ae84$export$20c12548414ed018({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                updateDelay: this.options.updateDelay,
                shouldShow: this.options.shouldShow
            })
        ];
    }
});



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




class $cebd4abc190a834e$export$8787fd8a369cb5a5 {
    getTextContent(node) {
        return (0, $aceda74b73705131$export$c72d34660a162238)(node, {
            textSerializers: (0, $aceda74b73705131$export$fdd92b7d22ac071c)(this.editor.schema)
        });
    }
    constructor({ editor: editor, element: element, view: view, tippyOptions: tippyOptions = {}, shouldShow: shouldShow }){
        this.preventHide = false;
        this.shouldShow = ({ view: view, state: state })=>{
            const { selection: selection } = state;
            const { $anchor: $anchor, empty: empty } = selection;
            const isRootDepth = $anchor.depth === 1;
            const isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent && $anchor.parent.childCount === 0 && !this.getTextContent($anchor.parent);
            if (!view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !this.editor.isEditable) return false;
            return true;
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) return;
            this.hide();
        };
        this.tippyBlurHandler = (event)=>{
            this.blurHandler({
                event: event
            });
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) this.shouldShow = shouldShow;
        this.element.addEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.editor.on("focus", this.focusHandler);
        this.editor.on("blur", this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = "visible";
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        this.element.tabIndex = 0;
        if (this.tippy || !editorIsAttached) return;
        this.tippy = (0, $43bf50b0fa1441ac$export$2e2bcd8739ae039)(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: "manual",
            placement: "right",
            hideOnClick: "toggle",
            ...this.tippyOptions
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler);
    }
    update(view, oldState) {
        var _a, _b, _c;
        const { state: state } = view;
        const { doc: doc, selection: selection } = state;
        const { from: from, to: to } = selection;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (isSame) return;
        this.createTooltip();
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view: view,
            state: state,
            oldState: oldState
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 || _b.setProps({
            getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (()=>(0, $aceda74b73705131$export$660ecae6cde71645)(view, from, to))
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler);
        (_b = this.tippy) === null || _b === void 0 || _b.destroy();
        this.element.removeEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
    }
}
const $cebd4abc190a834e$export$5e50896e3f3c0d7b = (options)=>{
    return new (0, $c286ea535d926598$export$901cf72dabf2112a)({
        key: typeof options.pluginKey === "string" ? new (0, $c286ea535d926598$export$1692d8b0e89cecc3)(options.pluginKey) : options.pluginKey,
        view: (view)=>new $cebd4abc190a834e$export$8787fd8a369cb5a5({
                view: view,
                ...options
            })
    });
};
/**
 * This extension allows you to create a floating menu.
 * @see https://tiptap.dev/api/extensions/floating-menu
 */ const $cebd4abc190a834e$export$695cda69e78edecd = (0, $aceda74b73705131$export$eeddbf09bb970356).create({
    name: "floatingMenu",
    addOptions () {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: "floatingMenu",
            shouldShow: null
        };
    },
    addProseMirrorPlugins () {
        if (!this.options.element) return [];
        return [
            $cebd4abc190a834e$export$5e50896e3f3c0d7b({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow
            })
        ];
    }
});


const $5acb492c1fc680b7$var$mergeRefs = (...refs)=>{
    return (node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
        });
    };
};
const $5acb492c1fc680b7$var$Portals = ({ renderers: renderers })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Object.entries(renderers).map(([key, renderer])=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(renderer.reactElement, renderer.element, key);
    }));
};
class $5acb492c1fc680b7$export$2a77c1f2ea046ea6 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.editorContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        this.initialized = false;
        this.state = {
            renderers: {}
        };
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate() {
        this.init();
    }
    init() {
        const { editor: editor } = this.props;
        if (editor && editor.options.element) {
            if (editor.contentComponent) return;
            const element = this.editorContentRef.current;
            element.append(...editor.options.element.childNodes);
            editor.setOptions({
                element: element
            });
            editor.contentComponent = this;
            editor.createNodeViews();
            this.initialized = true;
        }
    }
    maybeFlushSync(fn) {
        // Avoid calling flushSync until the editor is initialized.
        // Initialization happens during the componentDidMount or componentDidUpdate
        // lifecycle methods, and React doesn't allow calling flushSync from inside
        // a lifecycle method.
        if (this.initialized) (0, $1u0KT.flushSync)(fn);
        else fn();
    }
    setRenderer(id, renderer) {
        this.maybeFlushSync(()=>{
            this.setState(({ renderers: renderers })=>({
                    renderers: {
                        ...renderers,
                        [id]: renderer
                    }
                }));
        });
    }
    removeRenderer(id) {
        this.maybeFlushSync(()=>{
            this.setState(({ renderers: renderers })=>{
                const nextRenderers = {
                    ...renderers
                };
                delete nextRenderers[id];
                return {
                    renderers: nextRenderers
                };
            });
        });
    }
    componentWillUnmount() {
        const { editor: editor } = this.props;
        if (!editor) return;
        this.initialized = false;
        if (!editor.isDestroyed) editor.view.setProps({
            nodeViews: {}
        });
        editor.contentComponent = null;
        if (!editor.options.element.firstChild) return;
        const newElement = document.createElement("div");
        newElement.append(...editor.options.element.childNodes);
        editor.setOptions({
            element: newElement
        });
    }
    render() {
        const { editor: editor, innerRef: innerRef, ...rest } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: $5acb492c1fc680b7$var$mergeRefs(innerRef, this.editorContentRef),
            ...rest
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5acb492c1fc680b7$var$Portals, {
            renderers: this.state.renderers
        }));
    }
}
// EditorContent should be re-created whenever the Editor instance changes
const $5acb492c1fc680b7$var$EditorContentWithKey = (0, $acw62.forwardRef)((props, ref)=>{
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return Math.floor(Math.random() * 0xFFFFFFFF).toString();
    }, [
        props.editor
    ]);
    // Can't use JSX here because it conflicts with the type definition of Vue's JSX, so use createElement
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5acb492c1fc680b7$export$2a77c1f2ea046ea6, {
        key: key,
        innerRef: ref,
        ...props
    });
});
const $5acb492c1fc680b7$export$a92c4e92ed722350 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($5acb492c1fc680b7$var$EditorContentWithKey);
class $5acb492c1fc680b7$export$7cda8d932e2f33c0 extends (0, $aceda74b73705131$export$7cda8d932e2f33c0) {
    constructor(){
        super(...arguments);
        this.contentComponent = null;
    }
}
/**
 * This hook allows you to create an editor instance.
 * @param options The editor options
 * @param deps The dependencies to watch for changes
 * @returns The editor instance
 * @example const editor = useEditor({ extensions: [...] })
 */ const $5acb492c1fc680b7$export$43711a1418203bbc = (options = {}, deps = [])=>{
    const editorRef = (0, $acw62.useRef)(null);
    const [, forceUpdate] = (0, $acw62.useState)({});
    const { onBeforeCreate: onBeforeCreate, onBlur: onBlur, onCreate: onCreate, onDestroy: onDestroy, onFocus: onFocus, onSelectionUpdate: onSelectionUpdate, onTransaction: onTransaction, onUpdate: onUpdate } = options;
    const onBeforeCreateRef = (0, $acw62.useRef)(onBeforeCreate);
    const onBlurRef = (0, $acw62.useRef)(onBlur);
    const onCreateRef = (0, $acw62.useRef)(onCreate);
    const onDestroyRef = (0, $acw62.useRef)(onDestroy);
    const onFocusRef = (0, $acw62.useRef)(onFocus);
    const onSelectionUpdateRef = (0, $acw62.useRef)(onSelectionUpdate);
    const onTransactionRef = (0, $acw62.useRef)(onTransaction);
    const onUpdateRef = (0, $acw62.useRef)(onUpdate);
    // This effect will handle updating the editor instance
    // when the event handlers change.
    (0, $acw62.useEffect)(()=>{
        if (!editorRef.current) return;
        if (onBeforeCreate) {
            editorRef.current.off("beforeCreate", onBeforeCreateRef.current);
            editorRef.current.on("beforeCreate", onBeforeCreate);
            onBeforeCreateRef.current = onBeforeCreate;
        }
        if (onBlur) {
            editorRef.current.off("blur", onBlurRef.current);
            editorRef.current.on("blur", onBlur);
            onBlurRef.current = onBlur;
        }
        if (onCreate) {
            editorRef.current.off("create", onCreateRef.current);
            editorRef.current.on("create", onCreate);
            onCreateRef.current = onCreate;
        }
        if (onDestroy) {
            editorRef.current.off("destroy", onDestroyRef.current);
            editorRef.current.on("destroy", onDestroy);
            onDestroyRef.current = onDestroy;
        }
        if (onFocus) {
            editorRef.current.off("focus", onFocusRef.current);
            editorRef.current.on("focus", onFocus);
            onFocusRef.current = onFocus;
        }
        if (onSelectionUpdate) {
            editorRef.current.off("selectionUpdate", onSelectionUpdateRef.current);
            editorRef.current.on("selectionUpdate", onSelectionUpdate);
            onSelectionUpdateRef.current = onSelectionUpdate;
        }
        if (onTransaction) {
            editorRef.current.off("transaction", onTransactionRef.current);
            editorRef.current.on("transaction", onTransaction);
            onTransactionRef.current = onTransaction;
        }
        if (onUpdate) {
            editorRef.current.off("update", onUpdateRef.current);
            editorRef.current.on("update", onUpdate);
            onUpdateRef.current = onUpdate;
        }
    }, [
        onBeforeCreate,
        onBlur,
        onCreate,
        onDestroy,
        onFocus,
        onSelectionUpdate,
        onTransaction,
        onUpdate,
        editorRef.current
    ]);
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const editor = new $5acb492c1fc680b7$export$7cda8d932e2f33c0(options);
        editorRef.current = editor;
        editorRef.current.on("transaction", ()=>{
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (isMounted) forceUpdate({});
                });
            });
        });
        return ()=>{
            isMounted = false;
            editor.destroy();
        };
    }, deps);
    return editorRef.current;
};
const $5acb492c1fc680b7$export$27b8dd149e32f6c7 = (0, $acw62.createContext)({
    editor: null
});
const $5acb492c1fc680b7$export$ce13247582c535f7 = $5acb492c1fc680b7$export$27b8dd149e32f6c7.Consumer;
const $5acb492c1fc680b7$export$96c4d2ffb4c40e50 = ()=>(0, $acw62.useContext)($5acb492c1fc680b7$export$27b8dd149e32f6c7);
const $5acb492c1fc680b7$export$b0c14a64ec1678d5 = ({ children: children, slotAfter: slotAfter, slotBefore: slotBefore, ...editorOptions })=>{
    const editor = $5acb492c1fc680b7$export$43711a1418203bbc(editorOptions);
    if (!editor) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5acb492c1fc680b7$export$27b8dd149e32f6c7.Provider, {
        value: {
            editor: editor
        }
    }, slotBefore, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5acb492c1fc680b7$export$ce13247582c535f7, null, ({ editor: currentEditor })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5acb492c1fc680b7$export$a92c4e92ed722350, {
            editor: currentEditor
        })), children, slotAfter);
};
const $5acb492c1fc680b7$export$79c1bf6a55bce827 = (props)=>{
    const [element, setElement] = (0, $acw62.useState)(null);
    const { editor: currentEditor } = $5acb492c1fc680b7$export$96c4d2ffb4c40e50();
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (!element) return;
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) return;
        const { pluginKey: pluginKey = "bubbleMenu", editor: editor, tippyOptions: tippyOptions = {}, updateDelay: updateDelay, shouldShow: shouldShow = null } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
            return;
        }
        const plugin = (0, $dfd8bb3ed0b8ae84$export$20c12548414ed018)({
            updateDelay: updateDelay,
            editor: menuEditor,
            element: element,
            pluginKey: pluginKey,
            shouldShow: shouldShow,
            tippyOptions: tippyOptions
        });
        menuEditor.registerPlugin(plugin);
        return ()=>menuEditor.unregisterPlugin(pluginKey);
    }, [
        props.editor,
        currentEditor,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setElement,
        className: props.className,
        style: {
            visibility: "hidden"
        }
    }, props.children);
};
const $5acb492c1fc680b7$export$695cda69e78edecd = (props)=>{
    const [element, setElement] = (0, $acw62.useState)(null);
    const { editor: currentEditor } = $5acb492c1fc680b7$export$96c4d2ffb4c40e50();
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (!element) return;
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) return;
        const { pluginKey: pluginKey = "floatingMenu", editor: editor, tippyOptions: tippyOptions = {}, shouldShow: shouldShow = null } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn("FloatingMenu component is not rendered inside of an editor component or does not have editor prop.");
            return;
        }
        const plugin = (0, $cebd4abc190a834e$export$5e50896e3f3c0d7b)({
            pluginKey: pluginKey,
            editor: menuEditor,
            element: element,
            tippyOptions: tippyOptions,
            shouldShow: shouldShow
        });
        menuEditor.registerPlugin(plugin);
        return ()=>menuEditor.unregisterPlugin(pluginKey);
    }, [
        props.editor,
        currentEditor,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setElement,
        className: props.className,
        style: {
            visibility: "hidden"
        }
    }, props.children);
};
const $5acb492c1fc680b7$export$3fef6c3187641c77 = (0, $acw62.createContext)({
    onDragStart: undefined
});
const $5acb492c1fc680b7$export$b6657ee1f2411c6 = ()=>(0, $acw62.useContext)($5acb492c1fc680b7$export$3fef6c3187641c77);
const $5acb492c1fc680b7$export$e44d28a41a78cbbb = (props)=>{
    const Tag = props.as || "div";
    const { nodeViewContentRef: nodeViewContentRef } = $5acb492c1fc680b7$export$b6657ee1f2411c6();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...props,
        ref: nodeViewContentRef,
        "data-node-view-content": "",
        style: {
            whiteSpace: "pre-wrap",
            ...props.style
        }
    });
};
const $5acb492c1fc680b7$export$d02cc1f3e4390991 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { onDragStart: onDragStart } = $5acb492c1fc680b7$export$b6657ee1f2411c6();
    const Tag = props.as || "div";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...props,
        ref: ref,
        "data-node-view-wrapper": "",
        onDragStart: onDragStart,
        style: {
            whiteSpace: "normal",
            ...props.style
        }
    });
});
/**
 * Check if a component is a class component.
 * @param Component
 * @returns {boolean}
 */ function $5acb492c1fc680b7$var$isClassComponent(Component) {
    return !!(typeof Component === "function" && Component.prototype && Component.prototype.isReactComponent);
}
/**
 * Check if a component is a forward ref component.
 * @param Component
 * @returns {boolean}
 */ function $5acb492c1fc680b7$var$isForwardRefComponent(Component) {
    var _a;
    return !!(typeof Component === "object" && ((_a = Component.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === "Symbol(react.forward_ref)");
}
/**
 * The ReactRenderer class. It's responsible for rendering React components inside the editor.
 * @example
 * new ReactRenderer(MyComponent, {
 *   editor,
 *   props: {
 *     foo: 'bar',
 *   },
 *   as: 'span',
 * })
*/ class $5acb492c1fc680b7$export$687d546b0584d31b {
    constructor(component, { editor: editor, props: props = {}, as: as = "div", className: className = "", attrs: attrs }){
        this.ref = null;
        this.id = Math.floor(Math.random() * 0xFFFFFFFF).toString();
        this.component = component;
        this.editor = editor;
        this.props = props;
        this.element = document.createElement(as);
        this.element.classList.add("react-renderer");
        if (className) this.element.classList.add(...className.split(" "));
        if (attrs) Object.keys(attrs).forEach((key)=>{
            this.element.setAttribute(key, attrs[key]);
        });
        this.render();
    }
    render() {
        var _a, _b;
        const Component = this.component;
        const props = this.props;
        if ($5acb492c1fc680b7$var$isClassComponent(Component) || $5acb492c1fc680b7$var$isForwardRefComponent(Component)) props.ref = (ref)=>{
            this.ref = ref;
        };
        this.reactElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ...props
        });
        (_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) === null || _b === void 0 || _b.setRenderer(this.id, this);
    }
    updateProps(props = {}) {
        this.props = {
            ...this.props,
            ...props
        };
        this.render();
    }
    destroy() {
        var _a, _b;
        (_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) === null || _b === void 0 || _b.removeRenderer(this.id);
    }
}
class $5acb492c1fc680b7$var$ReactNodeView extends (0, $aceda74b73705131$export$77c6811359a01a6f) {
    mount() {
        const props = {
            editor: this.editor,
            node: this.node,
            decorations: this.decorations,
            selected: false,
            extension: this.extension,
            getPos: ()=>this.getPos(),
            updateAttributes: (attributes = {})=>this.updateAttributes(attributes),
            deleteNode: ()=>this.deleteNode()
        };
        if (!this.component.displayName) {
            const capitalizeFirstChar = (string)=>{
                return string.charAt(0).toUpperCase() + string.substring(1);
            };
            this.component.displayName = capitalizeFirstChar(this.extension.name);
        }
        const ReactNodeViewProvider = (componentProps)=>{
            const Component = this.component;
            const onDragStart = this.onDragStart.bind(this);
            const nodeViewContentRef = (element)=>{
                if (element && this.contentDOMElement && element.firstChild !== this.contentDOMElement) element.appendChild(this.contentDOMElement);
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5acb492c1fc680b7$export$3fef6c3187641c77.Provider, {
                value: {
                    onDragStart: onDragStart,
                    nodeViewContentRef: nodeViewContentRef
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                ...componentProps
            })));
        };
        ReactNodeViewProvider.displayName = "ReactNodeView";
        if (this.node.isLeaf) this.contentDOMElement = null;
        else if (this.options.contentDOMElementTag) this.contentDOMElement = document.createElement(this.options.contentDOMElementTag);
        else this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div");
        if (this.contentDOMElement) // For some reason the whiteSpace prop is not inherited properly in Chrome and Safari
        // With this fix it seems to work fine
        // See: https://github.com/ueberdosis/tiptap/issues/1197
        this.contentDOMElement.style.whiteSpace = "inherit";
        let as = this.node.isInline ? "span" : "div";
        if (this.options.as) as = this.options.as;
        const { className: className = "" } = this.options;
        this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
        this.editor.on("selectionUpdate", this.handleSelectionUpdate);
        this.renderer = new $5acb492c1fc680b7$export$687d546b0584d31b(ReactNodeViewProvider, {
            editor: this.editor,
            props: props,
            as: as,
            className: `node-${this.node.type.name} ${className}`.trim(),
            attrs: this.options.attrs
        });
    }
    get dom() {
        var _a;
        if (this.renderer.element.firstElementChild && !((_a = this.renderer.element.firstElementChild) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-node-view-wrapper"))) throw Error("Please use the NodeViewWrapper component for your node view.");
        return this.renderer.element;
    }
    get contentDOM() {
        if (this.node.isLeaf) return null;
        return this.contentDOMElement;
    }
    handleSelectionUpdate() {
        const { from: from, to: to } = this.editor.state.selection;
        if (from <= this.getPos() && to >= this.getPos() + this.node.nodeSize) {
            if (this.renderer.props.selected) return;
            this.selectNode();
        } else {
            if (!this.renderer.props.selected) return;
            this.deselectNode();
        }
    }
    update(node, decorations) {
        const updateProps = (props)=>{
            this.renderer.updateProps(props);
        };
        if (node.type !== this.node.type) return false;
        if (typeof this.options.update === "function") {
            const oldNode = this.node;
            const oldDecorations = this.decorations;
            this.node = node;
            this.decorations = decorations;
            return this.options.update({
                oldNode: oldNode,
                oldDecorations: oldDecorations,
                newNode: node,
                newDecorations: decorations,
                updateProps: ()=>updateProps({
                        node: node,
                        decorations: decorations
                    })
            });
        }
        if (node === this.node && this.decorations === decorations) return true;
        this.node = node;
        this.decorations = decorations;
        updateProps({
            node: node,
            decorations: decorations
        });
        return true;
    }
    selectNode() {
        this.renderer.updateProps({
            selected: true
        });
        this.renderer.element.classList.add("ProseMirror-selectednode");
    }
    deselectNode() {
        this.renderer.updateProps({
            selected: false
        });
        this.renderer.element.classList.remove("ProseMirror-selectednode");
    }
    destroy() {
        this.renderer.destroy();
        this.editor.off("selectionUpdate", this.handleSelectionUpdate);
        this.contentDOMElement = null;
    }
}
function $5acb492c1fc680b7$export$478a6cea73a8df20(component, options) {
    return (props)=>{
        // try to get the parent component
        // this is important for vue devtools to show the component hierarchy correctly
        // maybe it’s `undefined` because <editor-content> isn’t rendered yet
        if (!props.editor.contentComponent) return {};
        return new $5acb492c1fc680b7$var$ReactNodeView(component, props, options);
    };
}






/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */ const $3b4cee6cdd9c93c9$export$358a232cca1ab2ac = (0, $aceda74b73705131$export$85c928794f8d04d4).create({
    name: "paragraph",
    priority: 1000,
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: "block",
    content: "inline*",
    parseHTML () {
        return [
            {
                tag: "p"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "p",
            (0, $aceda74b73705131$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setParagraph: ()=>({ commands: commands })=>{
                    return commands.setNode(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Alt-0": ()=>this.editor.commands.setParagraph()
        };
    }
});



/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */ const $1f6ef15eda3e480d$export$5f1af8db9871e1d6 = (0, $aceda74b73705131$export$85c928794f8d04d4).create({
    name: "text",
    group: "inline"
});




/**
 * This extension allows you to count the characters and words of your document.
 * @see https://tiptap.dev/api/extensions/character-count
 */ const $ccb96de2d25320cf$export$5740cdd52697d95d = (0, $aceda74b73705131$export$eeddbf09bb970356).create({
    name: "characterCount",
    addOptions () {
        return {
            limit: null,
            mode: "textSize"
        };
    },
    addStorage () {
        return {
            characters: ()=>0,
            words: ()=>0
        };
    },
    onBeforeCreate () {
        this.storage.characters = (options)=>{
            const node = (options === null || options === void 0 ? void 0 : options.node) || this.editor.state.doc;
            const mode = (options === null || options === void 0 ? void 0 : options.mode) || this.options.mode;
            if (mode === "textSize") {
                const text = node.textBetween(0, node.content.size, undefined, " ");
                return text.length;
            }
            return node.nodeSize;
        };
        this.storage.words = (options)=>{
            const node = (options === null || options === void 0 ? void 0 : options.node) || this.editor.state.doc;
            const text = node.textBetween(0, node.content.size, " ", " ");
            const words = text.split(" ").filter((word)=>word !== "");
            return words.length;
        };
    },
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                key: new (0, $c286ea535d926598$export$1692d8b0e89cecc3)("characterCount"),
                filterTransaction: (transaction, state)=>{
                    const limit = this.options.limit;
                    // Nothing has changed or no limit is defined. Ignore it.
                    if (!transaction.docChanged || limit === 0 || limit === null || limit === undefined) return true;
                    const oldSize = this.storage.characters({
                        node: state.doc
                    });
                    const newSize = this.storage.characters({
                        node: transaction.doc
                    });
                    // Everything is in the limit. Good.
                    if (newSize <= limit) return true;
                    // The limit has already been exceeded but will be reduced.
                    if (oldSize > limit && newSize > limit && newSize <= oldSize) return true;
                    // The limit has already been exceeded and will be increased further.
                    if (oldSize > limit && newSize > limit && newSize > oldSize) return false;
                    const isPaste = transaction.getMeta("paste");
                    // Block all exceeding transactions that were not pasted.
                    if (!isPaste) return false;
                    // For pasted content, we try to remove the exceeding content.
                    const pos = transaction.selection.$head.pos;
                    const over = newSize - limit;
                    const from = pos - over;
                    const to = pos;
                    // It’s probably a bad idea to mutate transactions within `filterTransaction`
                    // but for now this is working fine.
                    transaction.deleteRange(from, to);
                    // In some situations, the limit will continue to be exceeded after trimming.
                    // This happens e.g. when truncating within a complex node (e.g. table)
                    // and ProseMirror has to close this node again.
                    // If this is the case, we prevent the transaction completely.
                    const updatedSize = this.storage.characters({
                        node: transaction.doc
                    });
                    if (updatedSize > limit) return false;
                    return true;
                }
            })
        ];
    }
});


const $526f4c9d45be0f0e$export$bceacc74c2212615 = (0, $aceda74b73705131$export$85c928794f8d04d4).create({
    name: "Doc",
    topNode: true,
    content: "block"
});
const $526f4c9d45be0f0e$var$ExtendedLink = (0, $4aa5a1942f39557a$export$a6c7ac8248d6e38a).extend({
    name: "editorLink",
    inclusive: false
});
// This extension replaces new lines and breaks with spaces on paste
const $526f4c9d45be0f0e$var$PasteHandler = (0, $aceda74b73705131$export$eeddbf09bb970356).create({
    name: "pasteHandler",
    addProseMirrorPlugins () {
        return [
            new (0, $c286ea535d926598$export$901cf72dabf2112a)({
                props: {
                    handlePaste: (view, event)=>{
                        event.preventDefault();
                        const text = event.clipboardData?.getData("text/plain") || "";
                        const formattedText = text.replace(/[\r\n]+/g, " ");
                        const { tr: tr } = view.state;
                        tr.insertText(formattedText, view.state.selection.from);
                        view.dispatch(tr);
                        return true;
                    }
                }
            })
        ];
    }
});
const $526f4c9d45be0f0e$export$a43430dbd5ca5abe = (changeHandler, defaultValue)=>{
    return (0, $5acb492c1fc680b7$export$43711a1418203bbc)({
        extensions: [
            (0, $ccb96de2d25320cf$export$5740cdd52697d95d),
            $526f4c9d45be0f0e$export$bceacc74c2212615,
            (0, $3b4cee6cdd9c93c9$export$358a232cca1ab2ac),
            (0, $1f6ef15eda3e480d$export$5f1af8db9871e1d6),
            $526f4c9d45be0f0e$var$ExtendedLink.configure({
                openOnClick: false
            }),
            $526f4c9d45be0f0e$var$PasteHandler
        ],
        onUpdate ({ editor: editor }) {
            changeHandler(editor.getHTML());
        },
        content: defaultValue
    });
};






var $acw62 = parcelRequire("acw62");
const $6749aa95c3970fca$export$94d5810279943527 = (ref, maxLines, callback)=>{
    const [isOverflowing, setIsOverflowing] = (0, $acw62.useState)(false);
    const [resizeObserver, setResizeObserver] = (0, $acw62.useState)(null);
    const trigger = ()=>{
        const { current: current } = ref || {};
        if (current) {
            let hasOverflow;
            if (maxLines) {
                const computedLineHeight = window.getComputedStyle(current).lineHeight;
                let lineHeight;
                if (computedLineHeight === "normal") {
                    const fontSizeInPx = window.getComputedStyle(current).fontSize;
                    const fontSize = parseInt(fontSizeInPx, 10);
                    lineHeight = 1.2 * fontSize;
                    console.warn("line-height is set to normal, which may cause unexpected behavior");
                } else lineHeight = parseInt(computedLineHeight, 10);
                // number of lines * line height returns the max expected height
                hasOverflow = current.scrollHeight > maxLines * lineHeight;
            } else hasOverflow = current.scrollHeight > current.clientHeight;
            setIsOverflowing(hasOverflow);
            if (callback) callback(hasOverflow);
        }
    };
    (0, $acw62.useLayoutEffect)(()=>{
        if (ref.current && resizeObserver) {
            resizeObserver.unobserve(ref.current);
            resizeObserver.observe(ref.current);
        }
        trigger();
    }, [
        ref,
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if ("ResizeObserver" in window) setResizeObserver(new ResizeObserver(trigger));
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, []);
    return isOverflowing;
};



/* Expander.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");



const $9ef86a66202cd720$export$1cfea591e85f6e12 = ({ expanded: expanded, toggleExpanded: toggleExpanded })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        onClick: toggleExpanded,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_bfhk1j28 _19itglyw _19pkxjmg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1kw7 _11c81kw7 _2rkoidpf _r06hglyw _k48p1nn1 _ect41jhi _30l31jij _d0altlke _1knv1eg3 _1xtnfqd3"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1wybxjmg _vwz4l6l0"
                    ]),
                    children: expanded ? "Show less " : "Show more  "
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ba2b898ae605882c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b00d9b82db872ffa$exports))),
                    alt: "Show more",
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_4t3il6l0 _1bsbl6l0 _2rko1y44 _18u0h461 _irr31eg3"
                    ])
                })
            ]
        })
    });
};
const $9ef86a66202cd720$var$showMoreButtonStyles = null;
const $9ef86a66202cd720$var$showText = null;
const $9ef86a66202cd720$var$showStyles = null;
const $9ef86a66202cd720$var$chevronStyles = null;



// Giving this a name to avoid the "duplicate link" console warning
const $14b92f04d765d7af$var$ExtendedLink = (0, $4aa5a1942f39557a$export$a6c7ac8248d6e38a).extend({
    name: "inclusiveLink",
    inclusive: false
});
const $14b92f04d765d7af$export$3775f2ee64ada265 = ({ htmlText: htmlText, isPersonalView: isPersonalView })=>{
    const editor = (0, $5acb492c1fc680b7$export$43711a1418203bbc)({
        editable: false,
        editorProps: {
            attributes: {
                class: "editor"
            }
        },
        content: htmlText,
        extensions: [
            (0, $526f4c9d45be0f0e$export$bceacc74c2212615),
            (0, $3b4cee6cdd9c93c9$export$358a232cca1ab2ac),
            (0, $1f6ef15eda3e480d$export$5f1af8db9871e1d6),
            $14b92f04d765d7af$var$ExtendedLink.configure({
                openOnClick: false
            })
        ]
    });
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    const contentRef = (0, $acw62.useRef)(null);
    const [isOverflowing, setIsOverflowing] = (0, $acw62.useState)(false);
    const toggleExpanded = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Grab the DOM element for the text content
    if (editor) {
        const $paragraph = editor.$node("paragraph");
        if ($paragraph) contentRef.current = $paragraph.element;
    }
    (0, $6749aa95c3970fca$export$94d5810279943527)(contentRef, 4, (isOverflowing)=>{
        setIsOverflowing(isOverflowing);
    });
    const onClickEditor = (event)=>{
        const target = event.target;
        if (target.tagName === "A") {
            event.preventDefault();
            const url = target.getAttribute("href") || "";
            if (url) {
                (0, $54c3da6cbab5f73d$export$e3ca08d12c0376d3)(isPersonalView);
                window.open((0, $79e6cb5b828d5745$export$4dac87d8635f2155)(url));
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClickEditor,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1wyb7vkz _ect41jhi _k48p1nn1 _vwz41tcg",
            !isExpanded && "_n9spcj1k _qygj1e54 _1vmbegat _1e0v15vq _12mr15vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5acb492c1fc680b7$export$a92c4e92ed722350), {
                editor: editor
            }),
            isOverflowing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ef86a66202cd720$export$1cfea591e85f6e12), {
                expanded: isExpanded,
                toggleExpanded: toggleExpanded
            })
        ]
    });
};
const $14b92f04d765d7af$var$bioStyles = null;
// Turn off this rule so that we can style TipTap elements
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ const $14b92f04d765d7af$var$bioOverflowStyles = null; // Turn the rule back on
 /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */ 



parcelRequire("acw62");

/* CertificationCardSidePanel.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");
const $4c13ae0f7e4a6872$var$certificationCardStyles = null;
const $4c13ae0f7e4a6872$var$certificationImageStyles = null;
const $4c13ae0f7e4a6872$var$imgStyles = null;
const $4c13ae0f7e4a6872$var$certificationNameStyles = null;
const $4c13ae0f7e4a6872$var$CertificationCardSidePannel = ({ name: name, imageUrl: imageUrl })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _p12f1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1bsb1qjk _4t3i1qjk _2rko1ssb _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: imageUrl ?? "",
                    alt: `${name}'s profile`,
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1bsb1osq _4t3i1osq"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_ect4kwxw _k48pni7l _1wyb7vkz _18u01crf _1reo15vq _18m915vq _1bto1l2s _o5724jg8 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                ]),
                children: name
            })
        ]
    });
};
var $4c13ae0f7e4a6872$export$2e2bcd8739ae039 = $4c13ae0f7e4a6872$var$CertificationCardSidePannel;


const $7d118f59dc99c849$export$4356a026cf67d76f = ({ certifications: certifications })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
            title: "Designations",
            children: certifications.slice(0, 6).map((cert)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c13ae0f7e4a6872$export$2e2bcd8739ae039), {
                    name: cert.name,
                    imageUrl: cert.imageUrl
                }, cert.name))
        })
    });
};










/* Products.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");



const $d81eeda824c7b71f$export$92e44ea1079b9ec6 = ({ products: products, source: source, isPersonalView: isPersonalView })=>{
    const filteredProducts = products.filter((product)=>product?.title?.toLowerCase() !== "community announcements".toLowerCase());
    const onClickProduct = (productId, url)=>{
        (0, $54c3da6cbab5f73d$export$a809453cb4b83dfe)(productId, isPersonalView, source);
        if (url) window.open((0, $79e6cb5b828d5745$export$4dac87d8635f2155)("https://community.atlassian.com" + url));
    };
    return filteredProducts.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "products-container",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_otyr1dnh"
        ]),
        children: filteredProducts.map((product)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                "data-testid": `product-${product.id}`,
                onClick: ()=>onClickProduct(product.id, product.viewHref ?? ""),
                role: "link",
                target: "_blank",
                rel: "noopener noreferrer nofollow",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_80omtlke _bfhk4puc _19it7v06 _2rko8vuz _1yt41dzv _1e0c1o8l _2hwx1eps _otyroxav _bfw71gpy _9oik1r31 _1bnxglyw _jf4cnqa1 _30l31kw7 _n7dw5dpx",
                    "_k48pzul8 _vwz4f6fq _ect41q02 _1p1dangw _1wybdlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1blv"
                ]),
                children: product.title
            }, product.id))
    }) : null;
};
// Adding negative margin to counteract the bottom margin of the last product pill
const $d81eeda824c7b71f$var$productsContainerStyles = null;
const $d81eeda824c7b71f$var$productPillStyles = null;
const $d81eeda824c7b71f$var$productNameStyles = null;



var $3b90ca0e257e9379$var$_AtlassianProductsFragment;

const $3b90ca0e257e9379$export$982323b17d6c516c = $3b90ca0e257e9379$var$_AtlassianProductsFragment !== void 0 ? $3b90ca0e257e9379$var$_AtlassianProductsFragment : $3b90ca0e257e9379$var$_AtlassianProductsFragment = (parcelRequire("97pkx"));









const $7c35a174dfe5a78a$var$AboutMe = ({ data: data })=>{
    const [unifiedProfileUsername] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(unifiedProfileUsername);
    const isProfileBanned = (0, $7f1303b450ad1698$export$2e2bcd8739ae039)(unifiedProfileUsername);
    const isLoggedInUserModerator = (0, $09c953719a360ef8$export$2e2bcd8739ae039)();
    const unifiedProfile = data?.unified?.unifiedProfile;
    const profileData = unifiedProfile && `__fragments` in unifiedProfile ? (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), data?.unified?.unifiedProfile) : null;
    const atlassianProducts = data?.unified?.atlassianProducts;
    const productData = atlassianProducts && `__fragments` in atlassianProducts ? (0, $2d93712440e0508b$exports.useFragment)((0, $3b90ca0e257e9379$export$982323b17d6c516c), data.unified?.atlassianProducts) : null;
    const allProducts = productData && productData.edges ? (0, $ffa1c9c6a8a97c90$export$3e0a9d9c71b68dbb)(productData) : [];
    const selectedProducts = profileData?.products ? (0, $ffa1c9c6a8a97c90$export$df8cfbb1033cc959)(profileData?.products, allProducts) : [];
    const isBioDataEmpty = !profileData?.bio?.trim();
    const sendEditProfileAnalytics = ()=>{
        (0, $54c3da6cbab5f73d$export$3d544e2ec22d45ce)(isPersonalView);
    };
    const { certificates: certificates } = (0, $235eb8ab1660c314$export$2e2bcd8739ae039)({
        username: profileData?.username ?? "",
        status: (0, $77d0522707ddb581$export$6e66959687be02fe).ACTIVE,
        type: [
            "STANDING"
        ],
        sortField: "ACTIVE_DATE",
        sortDirection: "DESC"
    });
    const rawCertificates = certificates ?? [];
    const filteredCertificationData = (0, $2291a83d8de96232$export$44a1b87e52fd4ed5)(rawCertificates, true);
    let certificationDesignations = [];
    const seenNames = new Set();
    filteredCertificationData.forEach((certification)=>{
        if (!seenNames.has(certification.name)) {
            seenNames.add(certification.name);
            certificationDesignations.push(certification);
        }
    });
    const hasProfileOwnerConsent = (0, $0ee606ad15f500d3$export$7a0549bb2cff767b)(profileData?.isProfileOwnerConsented ?? undefined);
    if (!hasProfileOwnerConsent) certificationDesignations = [];
    const isProfileDataEmpty = !profileData || isBioDataEmpty && !$7c35a174dfe5a78a$var$hasWhereToFindMe(profileData) && !selectedProducts.length && !certificationDesignations.length;
    if (!isPersonalView && isProfileDataEmpty) return null;
    const shouldRenderContent = isPersonalView && (!isProfileBanned || isLoggedInUserModerator);
    const certificationSection = hasProfileOwnerConsent && certificationDesignations.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d118f59dc99c849$export$4356a026cf67d76f), {
        certifications: certificationDesignations
    }) : null;
    const bioSection = profileData && !isBioDataEmpty ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
        title: "About Me",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14b92f04d765d7af$export$3775f2ee64ada265), {
            htmlText: profileData.bio,
            isPersonalView: isPersonalView
        })
    }) : isBioDataEmpty && shouldRenderContent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
        title: "About Me",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92160255da0d8a25$export$2e2bcd8739ae039), {
            message: "Tell others about yourself and your skills.",
            linkTo: `/profile/${unifiedProfileUsername}/edit`,
            linkType: "internal",
            sendAnalyticsEvent: sendEditProfileAnalytics,
            linkText: "Edit profile"
        })
    }) : null;
    const productsSection = selectedProducts.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
        title: "My Apps",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d81eeda824c7b71f$export$92e44ea1079b9ec6), {
            products: selectedProducts,
            isPersonalView: isPersonalView,
            source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE
        })
    }) : null;
    const whereToFindMeSection = profileData && $7c35a174dfe5a78a$var$hasWhereToFindMe(profileData) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78ff1af2299d0634$export$2e2bcd8739ae039), {
        title: "Where to Find Me",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c35a174dfe5a78a$var$WhereToFindMe, {
            data: profileData,
            isPersonalView: isPersonalView
        })
    }) : null;
    // Only hide the entire container if there's no content to show
    const hasAnyContent = certificationSection || bioSection || whereToFindMeSection || productsSection;
    if (!isPersonalView && !hasAnyContent) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e11946d314b99a3d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "about-me-container",
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _2lx21bp4 _zulpa5zd _oe5xhiv4"
            ]),
            children: [
                certificationSection,
                bioSection,
                whereToFindMeSection,
                productsSection
            ]
        })
    });
};
var $7c35a174dfe5a78a$export$2e2bcd8739ae039 = $7c35a174dfe5a78a$var$AboutMe;
var $7c35a174dfe5a78a$var$SocialLink;
(function(SocialLink) {
    SocialLink["Website"] = "website";
    SocialLink["LinkedIn"] = "linkedin";
    SocialLink["YouTube"] = "youtube";
    SocialLink["X"] = "x";
})($7c35a174dfe5a78a$var$SocialLink || ($7c35a174dfe5a78a$var$SocialLink = {}));
const $7c35a174dfe5a78a$var$WhereToFindMe = ({ data: data, isPersonalView: isPersonalView })=>{
    const onClickSocialLink = (linkType, url)=>{
        (0, $54c3da6cbab5f73d$export$1e6f0ad6ac50506f)(linkType, isPersonalView);
        if (url) window.open((0, $79e6cb5b828d5745$export$4dac87d8635f2155)(url));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o"
        ]),
        children: [
            data.websiteUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                onClick: ()=>onClickSocialLink("website", data.websiteUrl),
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2hwxxjmg _1bsbhiv4 _4t3ihiv4 _80omtlke _2rko1y44 _irr31eg3 _1di6fqd3"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($539fd25154d65022$exports))),
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug",
                        "_1bsbhiv4 _4t3ihiv4"
                    ])
                })
            }),
            data.linkedinUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                onClick: ()=>onClickSocialLink("linkedin", data.linkedinUrl),
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2hwxxjmg _1bsbhiv4 _4t3ihiv4 _80omtlke _2rko1y44 _irr31eg3 _1di6fqd3"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($462a916399c305fe$exports))),
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug",
                        "_1bsbl6l0 _4t3il6l0"
                    ])
                })
            }),
            data.youtubeUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                onClick: ()=>onClickSocialLink("youtube", data.youtubeUrl),
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2hwxxjmg _1bsbhiv4 _4t3ihiv4 _80omtlke _2rko1y44 _irr31eg3 _1di6fqd3"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c8f4f953ff00ae60$exports))),
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug",
                        "_1bsb1ul9 _4t3i1ul9"
                    ])
                })
            })
        ]
    });
};
const $7c35a174dfe5a78a$var$aboutMeContainerStyles = null;
const $7c35a174dfe5a78a$var$hasWhereToFindMe = (data)=>!!data.websiteUrl || !!data.linkedinUrl;
const $7c35a174dfe5a78a$var$iconContainerStyles = null;
const $7c35a174dfe5a78a$var$iconBorderStyles = null;
const $7c35a174dfe5a78a$var$socialIconStyles = null;
const $7c35a174dfe5a78a$var$linkIconStyles = null;
const $7c35a174dfe5a78a$var$linkedInIconStyles = null;
const $7c35a174dfe5a78a$var$youtubeIconStyles = null; // const xIconStyles = css({
 //   width: token('space.300'),
 //   height: token('space.300'),
 // });









const $436e335f1693d291$var$SidePanel = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const unifiedProfileData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: pathProfileId
    });
    const screenType = (0, $c46d6ad15b094b20$export$73fc99e2307f4d2e)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx21bp4 _y8atnvl5 _1yw7a5zd"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb75c5d43001c98$export$65eada320cc2f47c), {}),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c35a174dfe5a78a$export$2e2bcd8739ae039), {
                        data: unifiedProfileData
                    })
                })
            }),
            screenType === "desktop" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aeee297ca0427ed$export$9d29d4e8402ec840), {
                        internalId: pathProfileId,
                        isMainPanel: false
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4681896e22cc2dc9$export$2e2bcd8739ae039), {})
                ]
            }) : null
        ]
    });
};
var $436e335f1693d291$export$2e2bcd8739ae039 = $436e335f1693d291$var$SidePanel;
const $436e335f1693d291$var$containerStyles = null;











var $acw62 = parcelRequire("acw62");
const $4b399cfb19f70f4d$export$10acc2d30344565d = (eventFunction, options)=>{
    const { shouldSendEvent: shouldSendEvent = true } = options ?? {};
    (0, $acw62.useEffect)(()=>{
        if (shouldSendEvent) eventFunction();
    }, []);
};
var $4b399cfb19f70f4d$export$2e2bcd8739ae039 = $4b399cfb19f70f4d$export$10acc2d30344565d;




// https://data-portal.internal.atlassian.com/analytics/registry/84833
const $4bff37f495adcdfa$export$574784435215f928 = (badgeTitle, badgeType, isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).BADGES,
        action: "clicked",
        actionSubject: "card",
        actionSubjectId: "unifiedProfileBadgeCard",
        attributes: {
            badgeTitle: badgeTitle.substring(0, 50),
            badgeType: badgeType
        },
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71731
const $4bff37f495adcdfa$export$7b031c96c2af5305 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).PROFILE,
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71735
const $4bff37f495adcdfa$export$57c8cee302d78413 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).GROUPS,
        isPersonalView: isPersonalView
    });
};









/**
 * Used to verify if a particular username exists.
 *
 * @param username - username to validate
 * @returns boolean - true if the username exists, false otherwise
 */ const $cb1702665bca5068$var$useValidatePublicUser = (pathProfileId)=>{
    if (!pathProfileId) {
        console.warn("useValidatePublicUser hook receied an empty pathProfileId");
        return false;
    }
    const unifiedProfileData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    let isProfileDataAvailable = false;
    const unifiedProfile = unifiedProfileData?.unified?.unifiedProfile;
    if (unifiedProfile && "__fragments" in unifiedProfile) {
        const profileFragmentData = (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile);
        if (profileFragmentData?.accountInternalId) isProfileDataAvailable = true;
    }
    return isProfileDataAvailable;
};
var $cb1702665bca5068$export$2e2bcd8739ae039 = $cb1702665bca5068$var$useValidatePublicUser;


/**
 * This hook is only intended to be used on paths that start with /username.
 *
 * @returns boolean - true if the path is valid, false otherwise
 */ const $f7731a0c63562c44$var$useValidateProfileIdPath = ()=>{
    const [routerState] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    if (!routerState.location.pathname?.startsWith(`/user/profile/${pathProfileId}`)) throw new Error("useValidatePublicUser hook can only be used on paths that start with /profile/username");
    return (0, $cb1702665bca5068$export$2e2bcd8739ae039)(pathProfileId);
};
var $f7731a0c63562c44$export$2e2bcd8739ae039 = $f7731a0c63562c44$var$useValidateProfileIdPath;


/* PrivateProfile.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");




const $a0edad62f95dba54$var$PrivateProfile = ()=>{
    const handleGoBack = (event)=>{
        event.preventDefault();
        window.history.back();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "private-profile-container",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _19pka5zd _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                "data-testid": "private-profile-image",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d572cd9d3c22273f$exports))),
                alt: "Padlock Icon",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1bsb1lit _4t3i1lit _otyrl6l0"
                ])
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$a8a3e93435678ff9), {
                level: 4,
                "data-testid": "private-profile-message",
                children: "This profile is private."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_19pkxjmg"
                ])
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                href: "#",
                onClick: handleGoBack,
                "data-testid": "private-profile-back-link",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz1jwt _ect41q02 _1wyb7s5t _zg8l4jg8 _k48pzul8 _vwz4gktf _80omtlke"
                ]),
                children: "Go back"
            })
        ]
    });
};
var $a0edad62f95dba54$export$2e2bcd8739ae039 = $a0edad62f95dba54$var$PrivateProfile;
const $a0edad62f95dba54$var$containerStyles = null;
const $a0edad62f95dba54$var$padlockStyles = null;
const $a0edad62f95dba54$var$headingLinkSpacer = null;
const $a0edad62f95dba54$var$linkStyles = null;










const $b08f67dec19c15db$var$PrivateProfileComponent = ({ children: children })=>{
    const [internalId = ""] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const isValid = (0, $f7731a0c63562c44$export$2e2bcd8739ae039)();
    if (!isValid) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/invalid_path"
    });
    const unifiedProfileData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: internalId
    });
    const unifiedProfile = unifiedProfileData?.unified?.unifiedProfile;
    const profileData = unifiedProfile && `__fragments` in unifiedProfile ? (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile) : null;
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    const showPrivateProfileMessage = !isPersonalView && profileData?.isPrivate;
    if (showPrivateProfileMessage) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04daab201c140829$export$a65e282337ff0f53), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $04daab201c140829$export$b5bdfcb4cafd161b), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $703c47fb157a7467$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04daab201c140829$export$5c0547b091a4b556), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a0edad62f95dba54$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
    return children;
};
var $b08f67dec19c15db$export$2e2bcd8739ae039 = $b08f67dec19c15db$var$PrivateProfileComponent;


const $04daab201c140829$var$ProfileComponent = ({ internalId: internalId })=>{
    const unifiedProfileData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $39c545ba55bc3de2$export$39d254c0229da0b3), {
        internalId: internalId
    });
    const unifiedProfile = unifiedProfileData?.unified?.unifiedProfile;
    const profileData = unifiedProfile && `__fragments` in unifiedProfile ? (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile) : null;
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $4bff37f495adcdfa$export$7b031c96c2af5305)(isPersonalView), {
        shouldSendEvent: Boolean(unifiedProfile)
    });
    // if a linked profile is tried to be visited then redirect to the primary profile
    if (profileData?.internalId !== internalId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: `/profile/${profileData?.internalId}`
    });
    if (!unifiedProfile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/user_not_found"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b08f67dec19c15db$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($04daab201c140829$export$a65e282337ff0f53, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($04daab201c140829$export$b5bdfcb4cafd161b, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                            FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                            onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $703c47fb157a7467$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($04daab201c140829$export$5c0547b091a4b556, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_1bsb1osq _1f49cs5v _k24tkb7n _yuwch3it"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                                        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                                        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6626375f8a1be53$export$2e2bcd8739ae039), {
                                            data: unifiedProfileData
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_1f49kb7n _1bsb1osq _k24tcs5v _yuwcnvl5"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                                        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                                        onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $436e335f1693d291$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $04daab201c140829$export$2e2bcd8739ae039 = $04daab201c140829$var$ProfileComponent;
const $04daab201c140829$export$2be3f11171664f06 = 175;
const $04daab201c140829$export$255c584be29e1f6d = 194;
const $04daab201c140829$export$4ad54acafc203c36 = 275;
const $04daab201c140829$export$b5bdfcb4cafd161b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_p12fhmfw _19pkl6l0 _2hwx1wug _18u01wug _otyridpf _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _fsvx1ru3 _1x0lxjmg _9tv81wug _13761wug _14i6idpf _jlq1skd2"
        ]),
        children: children
    });
};
const $04daab201c140829$var$mainContentContainerStyles = null;
const $04daab201c140829$export$a65e282337ff0f53 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($00322900b96ac3ac$exports))),
        alt: "cover-image",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1ule _1bsb1osq _5ral1dfr _kqswstnw _154iidpf _4t3ijidk _qgvjdyal _1b5y7rrr"
        ])
    });
};
const $04daab201c140829$var$coverImageStyles = null;
const $04daab201c140829$export$5c0547b091a4b556 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _zulpa5zd _1ozw1txw _7bznvrvc _1wao1yb4 _oe5xhiv4"
        ]),
        children: children
    });
};
const $04daab201c140829$var$mainContentStyles = null;
const $04daab201c140829$var$mainPanelStyles = null;
const $04daab201c140829$var$sidePanelStyles = null;







const $e2b8f23d4e767bfa$var$ProfilePage = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const isValid = (0, $f7731a0c63562c44$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: isValid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
                onError: (0, $ff917de846b535b7$export$e11d707ed8ea628b),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04daab201c140829$export$2e2bcd8739ae039), {
                    internalId: pathProfileId
                })
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
            to: "/error/invalid_path"
        })
    });
};
var $e2b8f23d4e767bfa$export$2e2bcd8739ae039 = $e2b8f23d4e767bfa$var$ProfilePage;




const $22e87b22cf7071d9$var$NotFound = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/user_not_found"
    });
};
var $22e87b22cf7071d9$export$2e2bcd8739ae039 = $22e87b22cf7071d9$var$NotFound;


/* Home.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");


/* Loader.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");


const $183c2e7b7636555c$var$Loader = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_kqsw1n9t _1ltv1ssb _154i1edt"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d847f661580efa86$export$2e2bcd8739ae039), {
            interactionName: "load",
            size: "xlarge"
        })
    });
var $183c2e7b7636555c$export$2e2bcd8739ae039 = $183c2e7b7636555c$var$Loader;
const $183c2e7b7636555c$var$spinnerStyles = null;


/* PageError.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");





const $03d31106a6937204$var$ANALYTICS_SOURCE = (0, $77d0522707ddb581$export$d2cea8e85c08e64c).ERROR;
// https://data-portal.internal.atlassian.com/analytics/registry/84835
const $03d31106a6937204$export$2e3e2390cceeaef9 = (errorType, errorDescription)=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: $03d31106a6937204$var$ANALYTICS_SOURCE,
        attributes: {
            errorType: errorType,
            errorDescription: errorDescription.substring(0, 100)
        },
        isPersonalView: false
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84832
const $03d31106a6937204$export$53b96e08518aa4ae = (errorType, recoveryAction, destination)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $03d31106a6937204$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "unifiedProfileErrorRecovery",
        attributes: {
            errorType: errorType,
            recoveryAction: recoveryAction,
            destination: destination
        },
        isPersonalView: false
    });
};


const $403b11bf679d9061$export$ece78e4633e29053 = ({ image: image, heading: heading, description: description, link: link, linkText: linkText })=>{
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $03d31106a6937204$export$2e3e2390cceeaef9)(heading, description));
    const handleErrorRecoveryClick = ()=>{
        (0, $03d31106a6937204$export$53b96e08518aa4ae)(heading, linkText, link);
        window.open(link, "_self");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_p12f1c3h _1ul9ixjv _1e0c1txw _2lx21bp4 _4cvr1h6o _1yt4a5zd"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: image,
                alt: "Error",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_otyrl6l0"
                ])
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_otyrxjmg _ect4kwxw _1wyb1tcg _k48pzul8 _vwz4zwfg _y3gn1h6o"
                ]),
                children: heading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_otyrxjmg _syaz1blv _ect41v9d _k48p1nn1 _vwz4gktf _y3gn1h6o _1wyb7vkz"
                ]),
                children: description
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                label: linkText,
                appearance: (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).LINK,
                onClick: handleErrorRecoveryClick
            })
        ]
    });
};
const $403b11bf679d9061$var$containerStyles = null;
const $403b11bf679d9061$var$dangerTriangleStyles = null;
const $403b11bf679d9061$var$headingStyles = null;
const $403b11bf679d9061$var$descriptionStyles = null;




var $acw62 = parcelRequire("acw62");
const $2368c384ef7b2574$export$c505fc0a856a63f6 = (0, $acw62.createContext)({
    profileInternalId: null
});


const $630eea5ce1cff89e$var$HomePage = ()=>{
    const { profileInternalId: profileInternalId } = (0, $acw62.useContext)((0, $2368c384ef7b2574$export$c505fc0a856a63f6));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {}),
        children: profileInternalId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
            to: `/profile/${profileInternalId}`
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1pse _vchhusvi"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
                image: (0, (/*@__PURE__*/$parcel$interopDefault($707d35ecd7f38950$exports))),
                heading: "We couldn't find this profile",
                description: "Either user is not logged in or it may have been deleted or there is a typo. Check the link, or visit our homepage.",
                link: "/user",
                linkText: "Go home"
            })
        })
    });
};
const $630eea5ce1cff89e$var$pageErrorWrapperStyles = null;
var $630eea5ce1cff89e$export$2e2bcd8739ae039 = $630eea5ce1cff89e$var$HomePage;


/* GroupsFullList.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");














const $aa769698f6afb608$var$useHasLinkedAccounts = ()=>{
    const loggedInUser = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)();
    const accountId = loggedInUser?.accountId || "";
    if (!accountId) return false;
    const account = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $69f7bb7bdecca370$export$d483224631a5893c), {
        aaid: accountId
    }, {
        fetchPolicy: "store-or-network"
    }).unified;
    return Boolean(account?.account?.isLinked);
};
var $aa769698f6afb608$export$2e2bcd8739ae039 = $aa769698f6afb608$var$useHasLinkedAccounts;






// Could use ElevatedCard here, but the padding in the Figma is different
// from a normal ElevatedCard
const $d1cb8e8fe2e334f7$var$Card = ({ title: title, members: members, viewHref: viewHref, topicsCount: topicsCount, avatarUrl: avatarUrl, isPersonalView: isPersonalView, testId: testId })=>{
    const onClickGroup = (groupLink, groupName)=>{
        (0, $5ac37411c5201f22$export$c91eb30a2badd38b)(groupName ?? "not-named", isPersonalView, (0, $77d0522707ddb581$export$d2cea8e85c08e64c).GROUPS);
        window.open(groupLink);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_2rko1l7b _ca0q7vkz _u5f37vkz _n3td1tcg _19bv7vkz _1bsb124j _1tkeq9yo _y3gn1h6o _16qs188r _11q71sht _1e0c1txw _2lx21bp4 _1bah1yb4 _jlq1p59q _ffv71vd0"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _4cvrjp4b _1bah1e5h"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2554c0e6dc1d8696$exports))),
                                alt: "Group icon",
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1bsbl6l0 _4t3il6l0 _bfhkis24 _2hwx1eps"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1wybxjmg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pzul8 _vwz4l6l0 _y3gn1e5h _ect4kwxw"
                                ]),
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1bsb1osq _4t3i1w81 _bfhku67f _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _5ral1dfr _1e0c1txw _1bah1h6o _4cvr1h6o _1reo15vq _18m915vq _19it107u"
                        ]),
                        children: avatarUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: avatarUrl,
                            alt: `${title} image`,
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1bsb1osq _4t3i1osq"
                            ])
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _4cvr1q9y"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_syazalr3 _1wybxjmg _k48pzul8 _vwz4l6l0 _19pkidpf _2hwx1l7b _otyridpf _18u0idpf _ect4kwxw"
                                ]),
                                children: members
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_syaz1jij _1wybdlk8 _k48pc13d _vwz41bcc _2hwx1v6z _ect41v9d"
                                ]),
                                children: "members"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_syazalr3 _1wybxjmg _k48pzul8 _vwz4l6l0 _19pkidpf _2hwx1l7b _otyridpf _18u0idpf _ect4kwxw"
                                ]),
                                children: topicsCount
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_syaz1jij _1wybdlk8 _k48pc13d _vwz41bcc _2hwx1v6z _ect41v9d"
                                ]),
                                children: "posts"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        onClick: ()=>onClickGroup((0, $28b1e818e05d15e3$export$5eec9c5057ec9561)(viewHref), title),
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_80omtlke _syaz1jwt _ect41q02 _1wybxjmg _k48pzul8 _vwz41bcc"
                        ]),
                        children: "View"
                    })
                ]
            })
        ]
    });
};
const $d1cb8e8fe2e334f7$var$CardContainer = ({ aaid: aaid })=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    if (!pathProfileId) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1cb8e8fe2e334f7$var$CardContainerContent, {
        aaid: aaid,
        pathProfileId: pathProfileId
    });
};
const $d1cb8e8fe2e334f7$var$CardContainerContent = ({ aaid: aaid, pathProfileId: pathProfileId })=>{
    const hasLinkedAccounts = (0, $aa769698f6afb608$export$2e2bcd8739ae039)();
    const unifiedGroupsResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $0b2fc169eb37e823$export$32494925c577d61b), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(pathProfileId);
    const filteredGroups = (unifiedGroupsResponse?.unified?.unifiedProfile?.forums?.groups?.edges ?? []).map((edge)=>edge?.node);
    const loggedInUserGroups = [];
    const linkedUserGroups = [];
    filteredGroups.forEach((group)=>{
        if (group && group.aaid) {
            if (group.aaid === aaid) loggedInUserGroups.push(group);
            else linkedUserGroups.push(group);
        }
    });
    const loggedInUserGroupsCount = loggedInUserGroups.length;
    const linkedUserGroupsCount = linkedUserGroups.length;
    const loggedInHeadingTitle = loggedInUserGroupsCount === 1 ? `${loggedInUserGroupsCount} Group` : `${loggedInUserGroupsCount} Groups`;
    const linkedHeadingTitle = linkedUserGroupsCount === 1 ? `${linkedUserGroupsCount} Group` : `${linkedUserGroupsCount} Groups`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _ca0qgosd _igasgosd _otyrgosd _1supl6l0 _be4bl6l0",
            hasLinkedAccounts && "_x3do7v06"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _4cvr1h6o _1wpz1y6m _otyrl6l0 _fipvxjmg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1wybhiv4 _syaz1blv _vwz4gosd _k48pzul8 _ect4kwxw _2hwx1crf _1mqwl6l0 _1cf8hiv4"
                        ]),
                        children: loggedInHeadingTitle
                    }),
                    isPersonalView && hasLinkedAccounts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$8bee5cfdbbc2fc0c), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "groups-full-list-container",
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c11p5 _yv0e16hb _zulpl6l0 _10lofsjm _1v57hkll _oe5xxjmg"
                ]),
                children: loggedInUserGroups.map((group, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _2lx21bp4"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1cb8e8fe2e334f7$var$Card, {
                            testId: `groups-card-${group?.title || "no-title"}`,
                            title: group?.title || "",
                            members: group?.groupMemberCount || 0,
                            viewHref: group?.viewHref ?? undefined,
                            topicsCount: group?.topicsCount || 0,
                            avatarUrl: (0, $28b1e818e05d15e3$export$4e1c4af5d80537e4)(group?.avatar?.mediumHref),
                            isPersonalView: isPersonalView
                        })
                    }, index))
            }),
            linkedUserGroups.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_4t3ipzf8 _n7zl7v06"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_4t3i1ylp"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _4cvr1h6o _1wpz1y6m _otyrl6l0 _fipvxjmg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1wybhiv4 _syaz1blv _vwz4gosd _k48pzul8 _ect4kwxw _2hwx1crf _1mqwl6l0 _1cf8hiv4"
                                ]),
                                children: linkedHeadingTitle
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$446c53c437a3d14a), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "groups-full-list-container",
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c11p5 _yv0e16hb _zulpl6l0 _10lofsjm _1v57hkll _oe5xxjmg"
                        ]),
                        children: linkedUserGroups.map((group, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1e0c1txw _2lx21bp4"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1cb8e8fe2e334f7$var$Card, {
                                    testId: `groups-card-${group?.title || "no-title"}`,
                                    title: group?.title || "",
                                    members: group?.groupMemberCount || 0,
                                    viewHref: group?.viewHref ?? undefined,
                                    topicsCount: group?.topicsCount || 0,
                                    avatarUrl: (0, $28b1e818e05d15e3$export$4e1c4af5d80537e4)(group?.avatar?.mediumHref),
                                    isPersonalView: isPersonalView
                                })
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $d1cb8e8fe2e334f7$var$GroupsFullList = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    (0, $acw62.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    if (!pathProfileId) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1cb8e8fe2e334f7$var$GroupsFullListContent, {
        pathProfileId: pathProfileId
    });
};
const $d1cb8e8fe2e334f7$var$GroupsFullListContent = ({ pathProfileId: pathProfileId })=>{
    const hasLinkedAccounts = (0, $aa769698f6afb608$export$2e2bcd8739ae039)();
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(pathProfileId);
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $4bff37f495adcdfa$export$57c8cee302d78413)(isPersonalView), {
        shouldSendEvent: true
    });
    const profileResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $fe73a947836bf836$export$9d9de7756b13ecf), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const profileData = profileResponseData?.unified?.unifiedProfile;
    const userResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: profileData?.aaid
    }, {
        fetchPolicy: "store-or-network"
    });
    const userData = userResponseData?.user;
    const mainHeading = userData?.nickname ? `${userData.nickname}'s groups` : "User groups";
    const onClickBackToProfile = ()=>{
        (0, $5ac37411c5201f22$export$247741b7e547d5b0)(isPersonalView);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b08f67dec19c15db$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _1bah1h6o _1bsb1osq _19pkgosd"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1faz _p12f1osq _19pk1ylp _jlq11yw0 _17frzwfg _ffv71vd0"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                        to: `profile/${pathProfileId}`,
                        onClick: onClickBackToProfile,
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1wpz1y6m _syaz1jwt _ect41q02 _1wybxjmg _k48pzul8 _vwz41bcc"
                        ]),
                        children: "\u2190 Back to profile"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1wpz1y6m _1bsb1yw0 _19pkgosd _otyrl6l0 _syaz1blv _ect4kwxw _1wybgosd _vwz4a5zd _k48pbogh _jlq11yw0 _ffv71vd0 _17frl6l0 _fipvl6l0 _1mqwhiv4 _1cf8gosd"
                        ]),
                        children: mainHeading
                    }),
                    isPersonalView && hasLinkedAccounts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_ect41v9d _zg8l4jg8 _1p1dglyw _k48pc13d _1wyb7vkz _1wpz1y6m _otyrl6l0 _jlq11yw0 _ffv71vd0"
                        ]),
                        children: [
                            "To participate in a group from a linked account, log in to that account. Learn about ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://www.atlassian.com",
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_syaz1jwt _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41v9d _1wyb7vkz _k48pc13d"
                                ]),
                                children: "linking accounts."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1cb8e8fe2e334f7$var$CardContainer, {
                        aaid: profileData?.aaid ?? ""
                    })
                ]
            })
        })
    });
};
const $d1cb8e8fe2e334f7$var$styles = {
    linkText: null,
    spacerTop: null,
    spacerBottom: null,
    subHeadingStyle: null,
    card: null,
    cardContent: null,
    container: null,
    cardWrapper: null,
    header: null,
    icon: null,
    title: null,
    imagePlaceholder: null,
    image: null,
    details: null,
    infoContainer: null,
    digit: null,
    description: null,
    link: null,
    groupsFullList: null,
    contentWrapper: null,
    backLink: null,
    mainContainer: null,
    mainContainerTopBorder: null,
    headingContainer: null,
    headingText: null,
    mainHeading: null
};
var $d1cb8e8fe2e334f7$export$2e2bcd8739ae039 = $d1cb8e8fe2e334f7$var$GroupsFullList;


/* Settings.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");
var $56eaca9fc81d24c7$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $56eaca9fc81d24c7$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($56eaca9fc81d24c7$export$1ca2a26fecb070ae);
};
$56eaca9fc81d24c7$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");
var $8b42c41570452cba$export$4ef52930e33717cd = "data-theme";
var $8b42c41570452cba$export$a00eac3f8684bcd0 = "data-color-mode";
var $8b42c41570452cba$export$2112803007239c61 = "data-contrast-mode";
var $8b42c41570452cba$export$352e418ed5b6193a = "data-custom-theme";
var $8b42c41570452cba$export$2faeed762aac6741 = "light";
var $8b42c41570452cba$export$6f0c6fb8c80fcc92 = "ds";
var $8b42c41570452cba$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $8b42c41570452cba$export$dddac1532e822863 = "--".concat($8b42c41570452cba$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8b42c41570452cba$export$9d7b58831ae93caa = "--".concat($8b42c41570452cba$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $8d47224d9534a622$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d47224d9534a622$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d47224d9534a622$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d47224d9534a622$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d47224d9534a622$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $8d47224d9534a622$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $8d47224d9534a622$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $8d47224d9534a622$export$632685d741f3dbbf = $8d47224d9534a622$var$_objectSpread($8d47224d9534a622$var$_objectSpread({}, $8d47224d9534a622$export$958d0ae7f2977ae4), $8d47224d9534a622$export$d2dc61f58390201c);
var $8d47224d9534a622$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $8d47224d9534a622$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $8d47224d9534a622$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $8d47224d9534a622$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $8d47224d9534a622$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $8d47224d9534a622$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $8d47224d9534a622$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $8d47224d9534a622$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $8d47224d9534a622$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $8d47224d9534a622$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $8d47224d9534a622$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $8d47224d9534a622$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $8d47224d9534a622$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $8d47224d9534a622$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $8d47224d9534a622$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $8d47224d9534a622$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $8d47224d9534a622$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $8d47224d9534a622$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $8d47224d9534a622$export$e615f061ca585a6c = $8d47224d9534a622$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8d47224d9534a622$export$ca0f9c2de39ffed7(spacingProperty, $8d47224d9534a622$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8d47224d9534a622$export$bf46c3f9eeafc71f = $8d47224d9534a622$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8d47224d9534a622$export$ca0f9c2de39ffed7(spacingProperty, $8d47224d9534a622$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8d47224d9534a622$export$e7af83bafe7f9e63 = $8d47224d9534a622$export$ca0f9c2de39ffed7("backgroundColor", $8d47224d9534a622$export$d1d79bf68ac056bd);
var $8d47224d9534a622$export$3a1bcba60b23d7f0 = $8d47224d9534a622$export$ca0f9c2de39ffed7("color", $8d47224d9534a622$export$8473307aa00d6ea1);
var $8d47224d9534a622$export$45f3f4fe16f9f7d5 = $8d47224d9534a622$export$ca0f9c2de39ffed7("fontWeight", $8d47224d9534a622$export$303e322c6b1ed114);
var $8d47224d9534a622$export$68cc305da27dbaa4 = $8d47224d9534a622$export$ca0f9c2de39ffed7("fontFamily", $8d47224d9534a622$export$3c7e9587132614b4);
var $8d47224d9534a622$export$128f10c238242f83 = $8d47224d9534a622$export$ca0f9c2de39ffed7("font", $8d47224d9534a622$export$6ffa317d5e70375);
var $8d47224d9534a622$export$219d364c0da35ae4 = $8d47224d9534a622$export$ca0f9c2de39ffed7("font", $8d47224d9534a622$export$236bfe3a33ef1292);
var $8d47224d9534a622$export$38845ca010b93505 = $8d47224d9534a622$export$ca0f9c2de39ffed7("fontWeight", $8d47224d9534a622$export$855cfd311192d666);
var $8d47224d9534a622$export$ff257d957d48c421 = $8d47224d9534a622$export$ca0f9c2de39ffed7((0, $8b42c41570452cba$export$9d7b58831ae93caa), $8d47224d9534a622$export$41a358c9c2356760);
var $8d47224d9534a622$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $8d47224d9534a622$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $jjlaj = parcelRequire("jjlaj");


var $hPtJY = parcelRequire("hPtJY");
function $c039fc6d474cec13$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c039fc6d474cec13$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c039fc6d474cec13$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c039fc6d474cec13$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c039fc6d474cec13$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c039fc6d474cec13$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c039fc6d474cec13$export$9a199fbafee0014e = {
    backgroundColor: (0, $8d47224d9534a622$export$d1d79bf68ac056bd),
    blockSize: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderBottomColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderLeftColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $8d47224d9534a622$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    borderWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    bottom: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    boxShadow: (0, $8d47224d9534a622$export$7aff6e7ba39bb774),
    color: (0, $8d47224d9534a622$export$8473307aa00d6ea1),
    columnGap: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    font: (0, $8d47224d9534a622$export$6ffa317d5e70375),
    fontFamily: (0, $8d47224d9534a622$export$3c7e9587132614b4),
    fontWeight: (0, $8d47224d9534a622$export$303e322c6b1ed114),
    gap: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    height: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    inlineSize: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    inset: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    insetBlock: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    insetBlockEnd: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    insetBlockStart: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    insetInline: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    insetInlineEnd: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    insetInlineStart: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    left: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    margin: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginBlock: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginBlockEnd: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginBlockStart: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginBottom: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginInline: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginInlineEnd: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginInlineStart: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginLeft: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginRight: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    marginTop: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    maxBlockSize: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    maxHeight: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    maxWidth: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    minBlockSize: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    minHeight: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    minInlineSize: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    minWidth: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    opacity: (0, $8d47224d9534a622$export$daf94a976c798b4f),
    outlineColor: (0, $8d47224d9534a622$export$1531ad5bb3fbedac),
    outlineOffset: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    outlineWidth: (0, $8d47224d9534a622$export$e1b83c5210c471b8),
    padding: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingBlock: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingBottom: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingInline: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingLeft: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingRight: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    paddingTop: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    right: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    rowGap: (0, $8d47224d9534a622$export$958d0ae7f2977ae4),
    top: (0, $8d47224d9534a622$export$632685d741f3dbbf),
    width: (0, $8d47224d9534a622$export$6ccdbebca2ee545f),
    zIndex: (0, $8d47224d9534a622$export$b5f31a7e431d2eab)
};
var $c039fc6d474cec13$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $c039fc6d474cec13$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $c039fc6d474cec13$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c039fc6d474cec13$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c039fc6d474cec13$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($c039fc6d474cec13$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $c039fc6d474cec13$var$safeSelectors.test(key)) {
            styleObj[key] = $c039fc6d474cec13$var$_transformStyles(value);
            return;
        }
        if ($c039fc6d474cec13$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c039fc6d474cec13$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $c039fc6d474cec13$export$9a199fbafee0014e)) return;
        var tokenValue = $c039fc6d474cec13$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c039fc6d474cec13$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c039fc6d474cec13$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $c039fc6d474cec13$var$uniqueSymbol, (0, $jjlaj.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $c039fc6d474cec13$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $c039fc6d474cec13$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $c039fc6d474cec13$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$c039fc6d474cec13$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $c039fc6d474cec13$export$f6c783d06584602c(style) {
    return $c039fc6d474cec13$var$baseXcss(style);
}


var $d3428acf9eef9f22$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d3428acf9eef9f22$var$_excluded2 = [
    "className"
];
var $d3428acf9eef9f22$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d3428acf9eef9f22$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $d3428acf9eef9f22$var$_excluded2);
    var resolvedStyles = (0, $c039fc6d474cec13$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d3428acf9eef9f22$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8d47224d9534a622$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8d47224d9534a622$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $8d47224d9534a622$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $8d47224d9534a622$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $8d47224d9534a622$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $8d47224d9534a622$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $8d47224d9534a622$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $8d47224d9534a622$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $8d47224d9534a622$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $8d47224d9534a622$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jjlaj.jsx)((0, $56eaca9fc81d24c7$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d3428acf9eef9f22$export$2e2bcd8739ae039 = $d3428acf9eef9f22$export$e71c4d32a2263218;
var $d3428acf9eef9f22$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $aa93300f50747e56$var$justifyContentMap = {
    start: (0, $jjlaj.css)({
        justifyContent: "start"
    }),
    center: (0, $jjlaj.css)({
        justifyContent: "center"
    }),
    end: (0, $jjlaj.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jjlaj.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jjlaj.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jjlaj.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jjlaj.css)({
        justifyContent: "stretch"
    })
};
var $aa93300f50747e56$var$flexDirectionMap = {
    column: (0, $jjlaj.css)({
        flexDirection: "column"
    }),
    row: (0, $jjlaj.css)({
        flexDirection: "row"
    })
};
var $aa93300f50747e56$var$flexWrapMap = {
    wrap: (0, $jjlaj.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jjlaj.css)({
        flexWrap: "nowrap"
    })
};
var $aa93300f50747e56$var$alignItemsMap = {
    start: (0, $jjlaj.css)({
        alignItems: "start"
    }),
    center: (0, $jjlaj.css)({
        alignItems: "center"
    }),
    baseline: (0, $jjlaj.css)({
        alignItems: "baseline"
    }),
    end: (0, $jjlaj.css)({
        alignItems: "end"
    }),
    stretch: (0, $jjlaj.css)({
        alignItems: "stretch"
    })
};
var $aa93300f50747e56$var$baseStyles = (0, $jjlaj.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $aa93300f50747e56$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $c039fc6d474cec13$export$a9c84988c8f81f2d)(xcss);
    return (0, $jjlaj.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $aa93300f50747e56$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $8d47224d9534a622$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $8d47224d9534a622$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $8d47224d9534a622$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $aa93300f50747e56$var$alignItemsMap[alignItems],
            direction && $aa93300f50747e56$var$flexDirectionMap[direction],
            justifyContent && $aa93300f50747e56$var$justifyContentMap[justifyContent],
            wrap && $aa93300f50747e56$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$aa93300f50747e56$var$Flex.displayName = "Flex";
var $aa93300f50747e56$export$2e2bcd8739ae039 = $aa93300f50747e56$var$Flex;


var $8193e98259b97760$var$flexGrowMap = {
    hug: (0, $c039fc6d474cec13$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $c039fc6d474cec13$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $8193e98259b97760$var$separatorStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $8193e98259b97760$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jjlaj.jsx)("span", {
        css: $8193e98259b97760$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $8193e98259b97760$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jjlaj.jsx)($8193e98259b97760$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jjlaj.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $8193e98259b97760$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jjlaj.jsx)((0, $aa93300f50747e56$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$8193e98259b97760$var$Inline.displayName = "Inline";
var $8193e98259b97760$export$2e2bcd8739ae039 = $8193e98259b97760$var$Inline;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $569fad26df11f405$var$flexGrowMap = {
    hug: (0, $c039fc6d474cec13$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $c039fc6d474cec13$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $569fad26df11f405$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $569fad26df11f405$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jjlaj.jsx)((0, $aa93300f50747e56$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$569fad26df11f405$var$Stack.displayName = "Stack";
var $569fad26df11f405$export$2e2bcd8739ae039 = $569fad26df11f405$var$Stack;



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
var $05dbc67eba456bdb$exports = {};
"use strict";
Object.defineProperty($05dbc67eba456bdb$exports, "__esModule", {
    value: true
});
$05dbc67eba456bdb$exports.default = void 0;

var $05dbc67eba456bdb$var$_react = $05dbc67eba456bdb$var$_interopRequireDefault((parcelRequire("acw62")));

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $eZkTu = parcelRequire("eZkTu");

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $290676b6f33586ef$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $290676b6f33586ef$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $290676b6f33586ef$export$62ad7b0c781000e9 = {
    small: {
        width: $290676b6f33586ef$export$c647cb0ee6e282fe.small,
        height: $290676b6f33586ef$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $290676b6f33586ef$export$c647cb0ee6e282fe.medium,
        height: $290676b6f33586ef$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $290676b6f33586ef$export$c647cb0ee6e282fe.large,
        height: $290676b6f33586ef$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $290676b6f33586ef$export$c647cb0ee6e282fe.xlarge,
        height: $290676b6f33586ef$export$c647cb0ee6e282fe.xlarge
    }
};



var $jjlaj = parcelRequire("jjlaj");
var $78847e578314c1f5$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $78847e578314c1f5$var$smallStyles = (0, $jjlaj.css)((0, $290676b6f33586ef$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $78847e578314c1f5$var$mediumStyles = (0, $jjlaj.css)((0, $290676b6f33586ef$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $78847e578314c1f5$var$largeStyles = (0, $jjlaj.css)((0, $290676b6f33586ef$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $78847e578314c1f5$var$xlargeStyles = (0, $jjlaj.css)((0, $290676b6f33586ef$export$62ad7b0c781000e9).xlarge);
var $78847e578314c1f5$export$ef0ad74202575b64 = {
    small: $78847e578314c1f5$var$smallStyles,
    medium: $78847e578314c1f5$var$mediumStyles,
    large: $78847e578314c1f5$var$largeStyles,
    xlarge: $78847e578314c1f5$var$xlargeStyles
};
var $78847e578314c1f5$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $290676b6f33586ef$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $ca1ce1730c6153ac$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $907a8411aef5913a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $907a8411aef5913a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $907a8411aef5913a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $907a8411aef5913a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $907a8411aef5913a$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $907a8411aef5913a$var$_objectSpread($907a8411aef5913a$var$_objectSpread({}, (0, $78847e578314c1f5$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $907a8411aef5913a$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $907a8411aef5913a$var$primaryEqualsSecondaryHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $907a8411aef5913a$var$secondaryTransparentHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $907a8411aef5913a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jjlaj.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $78847e578314c1f5$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jjlaj.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $ca1ce1730c6153ac$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $907a8411aef5913a$var$iconStyles,
            $907a8411aef5913a$var$baseHcmStyles,
            primaryColor === secondaryColor && $907a8411aef5913a$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $907a8411aef5913a$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jjlaj.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $907a8411aef5913a$export$2e2bcd8739ae039 = $907a8411aef5913a$export$f04a61298a47a40f;


var $bc8bffb95b6ddbe8$var$_excluded = [
    "dangerouslySetGlyph"
];
var $bc8bffb95b6ddbe8$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $bc8bffb95b6ddbe8$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $bc8bffb95b6ddbe8$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $eZkTu.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $eZkTu.fg)("platform-visual-refresh-icons-facade-button-fix") ? $bc8bffb95b6ddbe8$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $bc8bffb95b6ddbe8$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $907a8411aef5913a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $bc8bffb95b6ddbe8$export$2e2bcd8739ae039 = $bc8bffb95b6ddbe8$export$3cfb73f70dfca966;



var $05dbc67eba456bdb$var$_success = $05dbc67eba456bdb$var$_interopRequireDefault((parcelRequire("9gV2o")));
function $05dbc67eba456bdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $05dbc67eba456bdb$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $05dbc67eba456bdb$var$_react.default.createElement($bc8bffb95b6ddbe8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $05dbc67eba456bdb$var$_success.default
    }));
$05dbc67eba456bdb$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $05dbc67eba456bdb$var$_default = $05dbc67eba456bdb$exports.default = $05dbc67eba456bdb$var$CheckCircleIcon;


var $51d38391d900dce4$exports = {};
"use strict";
Object.defineProperty($51d38391d900dce4$exports, "__esModule", {
    value: true
});
$51d38391d900dce4$exports.default = void 0;

var $51d38391d900dce4$var$_react = $51d38391d900dce4$var$_interopRequireDefault((parcelRequire("acw62")));


var $51d38391d900dce4$var$_error = $51d38391d900dce4$var$_interopRequireDefault((parcelRequire("dGBQZ")));
function $51d38391d900dce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $51d38391d900dce4$var$ErrorIcon = (props)=>/*#__PURE__*/ $51d38391d900dce4$var$_react.default.createElement($bc8bffb95b6ddbe8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $51d38391d900dce4$var$_error.default
    }));
$51d38391d900dce4$var$ErrorIcon.displayName = "ErrorIcon";
var $51d38391d900dce4$var$_default = $51d38391d900dce4$exports.default = $51d38391d900dce4$var$ErrorIcon;


var $dfad6fa9dbd1cd26$exports = {};
"use strict";
Object.defineProperty($dfad6fa9dbd1cd26$exports, "__esModule", {
    value: true
});
$dfad6fa9dbd1cd26$exports.default = void 0;

var $dfad6fa9dbd1cd26$var$_react = $dfad6fa9dbd1cd26$var$_interopRequireDefault((parcelRequire("acw62")));


var $dfad6fa9dbd1cd26$var$_information = $dfad6fa9dbd1cd26$var$_interopRequireDefault((parcelRequire("h8pw5")));
function $dfad6fa9dbd1cd26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfad6fa9dbd1cd26$var$InfoIcon = (props)=>/*#__PURE__*/ $dfad6fa9dbd1cd26$var$_react.default.createElement($bc8bffb95b6ddbe8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $dfad6fa9dbd1cd26$var$_information.default
    }));
$dfad6fa9dbd1cd26$var$InfoIcon.displayName = "InfoIcon";
var $dfad6fa9dbd1cd26$var$_default = $dfad6fa9dbd1cd26$exports.default = $dfad6fa9dbd1cd26$var$InfoIcon;


var $ee2a562d52787622$exports = {};
"use strict";
Object.defineProperty($ee2a562d52787622$exports, "__esModule", {
    value: true
});
$ee2a562d52787622$exports.default = void 0;

var $ee2a562d52787622$var$_react = $ee2a562d52787622$var$_interopRequireDefault((parcelRequire("acw62")));


var $ee2a562d52787622$var$_questionCircle = $ee2a562d52787622$var$_interopRequireDefault((parcelRequire("8n8UJ")));
function $ee2a562d52787622$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ee2a562d52787622$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $ee2a562d52787622$var$_react.default.createElement($bc8bffb95b6ddbe8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $ee2a562d52787622$var$_questionCircle.default
    }));
$ee2a562d52787622$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $ee2a562d52787622$var$_default = $ee2a562d52787622$exports.default = $ee2a562d52787622$var$QuestionCircleIcon;


var $eea7c5eae4c3d73b$exports = {};
"use strict";
Object.defineProperty($eea7c5eae4c3d73b$exports, "__esModule", {
    value: true
});
$eea7c5eae4c3d73b$exports.default = void 0;

var $eea7c5eae4c3d73b$var$_react = $eea7c5eae4c3d73b$var$_interopRequireDefault((parcelRequire("acw62")));


var $eea7c5eae4c3d73b$var$_warning = $eea7c5eae4c3d73b$var$_interopRequireDefault((parcelRequire("PPNXY")));
function $eea7c5eae4c3d73b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eea7c5eae4c3d73b$var$WarningIcon = (props)=>/*#__PURE__*/ $eea7c5eae4c3d73b$var$_react.default.createElement($bc8bffb95b6ddbe8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $eea7c5eae4c3d73b$var$_warning.default
    }));
$eea7c5eae4c3d73b$var$WarningIcon.displayName = "WarningIcon";
var $eea7c5eae4c3d73b$var$_default = $eea7c5eae4c3d73b$exports.default = $eea7c5eae4c3d73b$var$WarningIcon;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $2ac65851ab6a955c$export$4b84fd0e2c617bd = "#FFEBE6";
var $2ac65851ab6a955c$export$b34b069eff244586 = "#FFBDAD";
var $2ac65851ab6a955c$export$be802dd0d8b57f35 = "#FF8F73";
var $2ac65851ab6a955c$export$60847d42f9da92a6 = "#FF7452";
var $2ac65851ab6a955c$export$4a7404f376229999 = "#FF5630";
var $2ac65851ab6a955c$export$2010d0fb4295b346 = "#DE350B";
var $2ac65851ab6a955c$export$2837b5a1a71d5c02 = "#BF2600";
var $2ac65851ab6a955c$export$8d9596b529bbb9cf = "#FFFAE6";
var $2ac65851ab6a955c$export$41060a744ab0b7ae = "#FFF0B3";
var $2ac65851ab6a955c$export$1cc05bbbf340e559 = "#FFE380";
var $2ac65851ab6a955c$export$5aae31392d72caaa = "#FFC400";
var $2ac65851ab6a955c$export$c6930421db9fa514 = "#FFAB00";
var $2ac65851ab6a955c$export$59619663aa6500fb = "#FF991F";
var $2ac65851ab6a955c$export$874739ea9e379ab6 = "#FF8B00";
var $2ac65851ab6a955c$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $2ac65851ab6a955c$export$69a3bf21b9686c2b = "#ABF5D1";
var $2ac65851ab6a955c$export$afbce1382ec95f73 = "#79F2C0";
var $2ac65851ab6a955c$export$747d86715d4175de = "#57D9A3";
var $2ac65851ab6a955c$export$940e1f69e873f202 = "#36B37E";
var $2ac65851ab6a955c$export$a49394138f7b8e85 = "#00875A";
var $2ac65851ab6a955c$export$6fa04827ac68a4fb = "#006644";
var $2ac65851ab6a955c$export$226de0355ed012f8 = "#DEEBFF";
var $2ac65851ab6a955c$export$8c13c2ee36917869 = "#B3D4FF";
var $2ac65851ab6a955c$export$ecfc1dff386a3e7a = "#4C9AFF";
var $2ac65851ab6a955c$export$215b7063051591f1 = "#2684FF";
var $2ac65851ab6a955c$export$e62e8919cca44969 = "#0065FF";
var $2ac65851ab6a955c$export$b3de0ae08da2ce64 = "#0052CC";
var $2ac65851ab6a955c$export$a6ee3d71bc067634 = "#0747A6";
var $2ac65851ab6a955c$export$67f15409e87642a1 = "#669DF1";
var $2ac65851ab6a955c$export$f0539dbc42dbb067 = "#8FB8F6";
var $2ac65851ab6a955c$export$363e4475840015bb = "#EAE6FF";
var $2ac65851ab6a955c$export$4b0a4417ed59760f = "#C0B6F2";
var $2ac65851ab6a955c$export$6011520a64d9a187 = "#998DD9";
var $2ac65851ab6a955c$export$a7175d4e9206bc80 = "#8777D9";
var $2ac65851ab6a955c$export$b48405b95304b5a1 = "#6554C0";
var $2ac65851ab6a955c$export$c71e4279dd54a18d = "#5243AA";
var $2ac65851ab6a955c$export$147899de772240ec = "#403294";
var $2ac65851ab6a955c$export$2cf711fe14c66f06 = "#E6FCFF";
var $2ac65851ab6a955c$export$7a8f4d33f6f9772c = "#B3F5FF";
var $2ac65851ab6a955c$export$776c9c497ef08533 = "#79E2F2";
var $2ac65851ab6a955c$export$69cb3ca10c1e330e = "#00C7E6";
var $2ac65851ab6a955c$export$9dc1ef0f3f48059b = "#00B8D9";
var $2ac65851ab6a955c$export$7c835c78b6fcdef8 = "#00A3BF";
var $2ac65851ab6a955c$export$6036577f95c3877e = "#008DA6";
var $2ac65851ab6a955c$export$29a4f05edc054374 = "#FFFFFF";
var $2ac65851ab6a955c$export$e655ef011c4aa1a2 = "#FAFBFC";
var $2ac65851ab6a955c$export$9fdfb749e33cdf97 = "#F4F5F7";
var $2ac65851ab6a955c$export$3e51e8f1440314ba = "#EBECF0";
var $2ac65851ab6a955c$export$1ce2d1575d444ceb = "#DFE1E6";
var $2ac65851ab6a955c$export$8754fc7e6d8b3000 = "#C1C7D0";
var $2ac65851ab6a955c$export$c2e91cbeada39b8b = "#B3BAC5";
var $2ac65851ab6a955c$export$5f71e19f3a7ad9de = "#A5ADBA";
var $2ac65851ab6a955c$export$eaa8c8a70ac22806 = "#97A0AF";
var $2ac65851ab6a955c$export$7c87d337fb91a97d = "#8993A4";
var $2ac65851ab6a955c$export$d6447c357493214f = "#7A869A";
var $2ac65851ab6a955c$export$f563ee71e9ee74cd = "#6B778C";
var $2ac65851ab6a955c$export$e2ef2124cf4024b1 = "#5E6C84";
var $2ac65851ab6a955c$export$eece5f492e429f08 = "#505F79";
var $2ac65851ab6a955c$export$c39c0fe0f26207ae = "#42526E";
var $2ac65851ab6a955c$export$7090862dc3038a9f = "#344563";
var $2ac65851ab6a955c$export$ad0bacf983b7ddaa = "#253858";
var $2ac65851ab6a955c$export$7d61b15e0da132af = "#172B4D";
var $2ac65851ab6a955c$export$fbda843f0a27fe96 = "#091E42";
var $2ac65851ab6a955c$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $2ac65851ab6a955c$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $2ac65851ab6a955c$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $2ac65851ab6a955c$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $2ac65851ab6a955c$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $2ac65851ab6a955c$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $2ac65851ab6a955c$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $2ac65851ab6a955c$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $2ac65851ab6a955c$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $2ac65851ab6a955c$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $2ac65851ab6a955c$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $2ac65851ab6a955c$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $2ac65851ab6a955c$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $2ac65851ab6a955c$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $2ac65851ab6a955c$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $2ac65851ab6a955c$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $2ac65851ab6a955c$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $2ac65851ab6a955c$export$2f6319cf7d736c2a = "#E6EDFA";
var $2ac65851ab6a955c$export$95126bc8884d6634 = "#DCE5F5";
var $2ac65851ab6a955c$export$8338d8c35d44ff1 = "#CED9EB";
var $2ac65851ab6a955c$export$5368d76ae4fbbda7 = "#B8C7E0";
var $2ac65851ab6a955c$export$9f0a771d16ec8d36 = "#ABBBD6";
var $2ac65851ab6a955c$export$abcf8c38338b4aa5 = "#9FB0CC";
var $2ac65851ab6a955c$export$97e81faa16a182c7 = "#8C9CB8";
var $2ac65851ab6a955c$export$bfe21c59123ecf33 = "#7988A3";
var $2ac65851ab6a955c$export$ee82aa2ea6a1558 = "#67758F";
var $2ac65851ab6a955c$export$682927c6ed76be02 = "#56637A";
var $2ac65851ab6a955c$export$91fd9994c5be9757 = "#455166";
var $2ac65851ab6a955c$export$d281fbfe3cff2df6 = "#3B475C";
var $2ac65851ab6a955c$export$3902c91d8b98a753 = "#313D52";
var $2ac65851ab6a955c$export$8e8133c1ba5845b5 = "#283447";
var $2ac65851ab6a955c$export$33ff357f6620b39 = "#202B3D";
var $2ac65851ab6a955c$export$633847cf062b69e0 = "#1B2638";
var $2ac65851ab6a955c$export$9776a6e503bdbf76 = "#121A29";
var $2ac65851ab6a955c$export$6c813d5160dff5db = "#0E1624";
var $2ac65851ab6a955c$export$3d4f271a500072a = "#0D1424";
var $2ac65851ab6a955c$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $2ac65851ab6a955c$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $2ac65851ab6a955c$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $2ac65851ab6a955c$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $2ac65851ab6a955c$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $2ac65851ab6a955c$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $2ac65851ab6a955c$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $2ac65851ab6a955c$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $2ac65851ab6a955c$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $2ac65851ab6a955c$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $2ac65851ab6a955c$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $2ac65851ab6a955c$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $2ac65851ab6a955c$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $2ac65851ab6a955c$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $2ac65851ab6a955c$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $2ac65851ab6a955c$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $2ac65851ab6a955c$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $2ac65851ab6a955c$export$d2adc5dedf09fced = "#292A2E";
var $2ac65851ab6a955c$export$f51762073d2bb381 = "#94C748";
var $2ac65851ab6a955c$export$95e26d54def96891 = "#B3DF72";


function $ed17b649aca0e172$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed17b649aca0e172$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed17b649aca0e172$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed17b649aca0e172$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed17b649aca0e172$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $2ac65851ab6a955c$export$226de0355ed012f8), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dfad6fa9dbd1cd26$exports))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $2ac65851ab6a955c$export$a6ee3d71bc067634), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $2ac65851ab6a955c$export$8d9596b529bbb9cf), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eea7c5eae4c3d73b$exports))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $2ac65851ab6a955c$export$874739ea9e379ab6), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $2ac65851ab6a955c$export$4b84fd0e2c617bd), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($51d38391d900dce4$exports))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $2ac65851ab6a955c$export$2837b5a1a71d5c02), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $2ac65851ab6a955c$export$8a6341c32b6a3ee6), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($05dbc67eba456bdb$exports))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $2ac65851ab6a955c$export$6fa04827ac68a4fb), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $2ac65851ab6a955c$export$363e4475840015bb), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ee2a562d52787622$exports))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $2ac65851ab6a955c$export$147899de772240ec), ")")
    }
};
function $ed17b649aca0e172$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $ed17b649aca0e172$export$faa35441caff5bb6[appearance] || $ed17b649aca0e172$export$faa35441caff5bb6.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $ed17b649aca0e172$var$_objectSpread($ed17b649aca0e172$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}


var $2154909317384aee$var$containerStyles = (0, $c039fc6d474cec13$export$f6c783d06584602c)({
    wordBreak: "break-word",
    borderRadius: "border.radius"
});
var $2154909317384aee$var$bleedStyles = (0, $c039fc6d474cec13$export$f6c783d06584602c)({
    display: "flex",
    marginBlock: "space.negative.025"
});
var $2154909317384aee$var$contentStyles = (0, $c039fc6d474cec13$export$f6c783d06584602c)({
    color: "color.text",
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $2154909317384aee$var$SectionMessage = /*#__PURE__*/ (0, $acw62.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $ed17b649aca0e172$export$e9b82d2e21ac0c1f)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3428acf9eef9f22$export$2e2bcd8739ae039), {
        as: "section",
        backgroundColor: $2154909317384aee$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $2154909317384aee$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8193e98259b97760$export$2e2bcd8739ae039), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3428acf9eef9f22$export$2e2bcd8739ae039), {
        xcss: $2154909317384aee$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $569fad26df11f405$export$2e2bcd8739ae039), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7d9e81ef639116d5$export$2e2bcd8739ae039), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d3428acf9eef9f22$export$2e2bcd8739ae039), {
        xcss: $2154909317384aee$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8193e98259b97760$export$2e2bcd8739ae039), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map(function(action, id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8193e98259b97760$export$2e2bcd8739ae039), {
            role: "listitem",
            key: id
        }, action);
    })))));
});
var $2154909317384aee$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$2154909317384aee$var$SectionMessage.displayName = "SectionMessage";
var $2154909317384aee$export$2e2bcd8739ae039 = $2154909317384aee$var$SectionMessage;




var $eJz0f = parcelRequire("eJz0f");


var $2d8eb9f733f1818f$var$_InitializeTransactionMutation;

const $2d8eb9f733f1818f$export$4db6a852f0f416dc = $2d8eb9f733f1818f$var$_InitializeTransactionMutation !== void 0 ? $2d8eb9f733f1818f$var$_InitializeTransactionMutation : $2d8eb9f733f1818f$var$_InitializeTransactionMutation = (parcelRequire("eg3Lf"));


var $5c01f74a0fd87013$var$_UnlinkMutation;

const $5c01f74a0fd87013$export$728a7916b6a83fa7 = $5c01f74a0fd87013$var$_UnlinkMutation !== void 0 ? $5c01f74a0fd87013$var$_UnlinkMutation : $5c01f74a0fd87013$var$_UnlinkMutation = (parcelRequire("bv5au"));




const $ee89958484c722a6$var$isChangePrimaryDisabled = true;
const $ee89958484c722a6$export$614c70537f470f74 = (accountProperties, dropdownActions)=>{
    const { isPrimaryAccount: isPrimaryAccount, isOrgOwned: isOrgOwned, isLoggedInAccountNotPrimary: isLoggedInAccountNotPrimary = false } = accountProperties;
    if (isLoggedInAccountNotPrimary) return [
        {
            text: (0, $77d0522707ddb581$export$1e6863d38ecd9f1e).UNLINK_ACCOUNT,
            onClick: dropdownActions.unlinkAccount
        }
    ];
    // Primary and NOT Org-Owned
    if (isPrimaryAccount && !isOrgOwned && !$ee89958484c722a6$var$isChangePrimaryDisabled) return [
        {
            text: (0, $77d0522707ddb581$export$1e6863d38ecd9f1e).CHANGE_PRIMARY,
            onClick: dropdownActions.changePrimary
        }
    ];
    // NOT Primary and NOT Org-Owned
    if (!isPrimaryAccount && !isOrgOwned) return [
        {
            text: (0, $77d0522707ddb581$export$1e6863d38ecd9f1e).MAKE_PRIMARY,
            onClick: dropdownActions.makePrimary
        },
        {
            text: (0, $77d0522707ddb581$export$1e6863d38ecd9f1e).UNLINK_ACCOUNT,
            onClick: dropdownActions.unlinkAccount
        }
    ];
    // NOT Primary and Org-Owned
    if (!isPrimaryAccount && isOrgOwned) return [
        {
            text: (0, $77d0522707ddb581$export$1e6863d38ecd9f1e).UNLINK_ACCOUNT,
            onClick: dropdownActions.unlinkAccount
        }
    ];
    return [];
};


var $8640f175d71906c5$var$_SetPrimaryAccountMutation;

const $8640f175d71906c5$export$7a6ca33386c38b9b = $8640f175d71906c5$var$_SetPrimaryAccountMutation !== void 0 ? $8640f175d71906c5$var$_SetPrimaryAccountMutation : $8640f175d71906c5$var$_SetPrimaryAccountMutation = (parcelRequire("5rJ4o"));




parcelRequire("acw62");

const $84707e704ae72238$var$FlagList = ({ flags: flags, onDismiss: onDismiss, linkedEmail: linkedEmail })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38132a618d93e205$export$2e2bcd8739ae039), {
        children: flags.map((flag)=>{
            const FlagComponent = flag.component;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FlagComponent, {
                onDismiss: ()=>onDismiss(flag.code),
                linkedEmail: linkedEmail
            }, flag.code);
        })
    });
var $84707e704ae72238$export$2e2bcd8739ae039 = $84707e704ae72238$var$FlagList;


/* eslint-disable react/prop-types */ 

var $190add46bd1af531$exports = {};
"use strict";
Object.defineProperty($190add46bd1af531$exports, "__esModule", {
    value: true
});
$190add46bd1af531$exports.default = void 0;

var $190add46bd1af531$var$_react = $190add46bd1af531$var$_interopRequireDefault((parcelRequire("acw62")));

function $190add46bd1af531$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $190add46bd1af531$var$ErrorIcon = (props)=>/*#__PURE__*/ $190add46bd1af531$var$_react.default.createElement($909afc01458e2b41$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$190add46bd1af531$var$ErrorIcon.displayName = "ErrorIcon";
var $190add46bd1af531$var$_default = $190add46bd1af531$var$ErrorIcon;
$190add46bd1af531$exports.default = $190add46bd1af531$var$_default;


const $c9940aa9edc30022$var$OrgOwnedAccountErrorFlag = ({ onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($190add46bd1af531$exports))), {
            label: "Error",
            primaryColor: "var(--ds-background-danger-bold)"
        }),
        appearance: "normal",
        id: "OrgOwnedAccountErrorFlag",
        onDismissed: onDismiss,
        title: "Unable to link account",
        description: "This email is managed by a company or organization. Enter a personal account instead.",
        actions: [
            {
                content: "Learn More"
            }
        ]
    });
};
var $c9940aa9edc30022$export$2e2bcd8739ae039 = $c9940aa9edc30022$var$OrgOwnedAccountErrorFlag;


/* eslint-disable react/prop-types */ 


const $87e36e7f8625f39b$var$OrgOwnedAccountLinkSuccessFlag = ({ onDismiss: onDismiss, linkedEmail: linkedEmail })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33b93c4ae7cd1380$exports))), {
            label: "Success",
            primaryColor: "var(--ds-background-success-bold)"
        }),
        appearance: "normal",
        onDismissed: onDismiss,
        id: "OrgOwnedAccountLinkSuccessFlag",
        title: "Account added",
        description: `We've linked ${linkedEmail} to your account.`,
        actions: [
            {
                content: "Log in"
            }
        ]
    });
};
var $87e36e7f8625f39b$export$2e2bcd8739ae039 = $87e36e7f8625f39b$var$OrgOwnedAccountLinkSuccessFlag;


/* eslint-disable react/prop-types */ 


const $255c02812216258b$var$LinkPersonalMakePrimarySuccessFlag = ({ onDismiss: onDismiss, linkedEmail: linkedEmail })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), {
        appearance: "normal",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33b93c4ae7cd1380$exports))), {
            label: "Success",
            primaryColor: "var(--ds-background-success-bold)"
        }),
        onDismissed: onDismiss,
        id: "LinkPersonalMakePrimarySuccessFlag",
        title: "Account added",
        description: `We've linked ${linkedEmail} and made it your primary account. Log in to link more accounts.`,
        actions: [
            {
                content: "Log in"
            }
        ]
    });
};
var $255c02812216258b$export$2e2bcd8739ae039 = $255c02812216258b$var$LinkPersonalMakePrimarySuccessFlag;


/* eslint-disable react/prop-types */ 


const $c578d09ff8879515$var$UnlinkAccountSuccessFlag = ({ onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33b93c4ae7cd1380$exports))), {
            label: "Success",
            size: "medium",
            primaryColor: "var(--ds-icon-success)"
        }),
        appearance: "normal",
        id: "UnlinkAccountSuccessFlag",
        title: "Account removed",
        description: "We've unlinked your account.",
        onDismissed: onDismiss
    });
};
var $c578d09ff8879515$export$2e2bcd8739ae039 = $c578d09ff8879515$var$UnlinkAccountSuccessFlag;


/* eslint-disable react/prop-types */ 


const $85249fe68fa9bade$var$GenericErrorFlag = ({ onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($190add46bd1af531$exports))), {
            label: "Error",
            primaryColor: "var(--ds-background-danger-bold)"
        }),
        appearance: "normal",
        id: "GenericErrorFlag",
        onDismissed: onDismiss,
        title: "Something went wrong",
        description: "We couldn\u2019t update your linked accounts.",
        actions: [
            {
                content: "Learn More",
                onClick: ()=>{
                    window.open("https://community.atlassian.com/forums/x/x/ba-p/2958563", "_blank", "noopener,noreferrer");
                }
            }
        ]
    });
};
var $85249fe68fa9bade$export$2e2bcd8739ae039 = $85249fe68fa9bade$var$GenericErrorFlag;


/* eslint-disable react/prop-types */ 


const $a8b21de79cd5d5bc$var$GenericAccountLinkError = ({ onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($190add46bd1af531$exports))), {
            label: "Error",
            primaryColor: "var(--ds-background-danger-bold)"
        }),
        appearance: "normal",
        id: "GenericAccountLinkErrorFlag",
        onDismissed: onDismiss,
        title: "Something went wrong",
        description: "We couldn\u2019t link your accounts.",
        actions: [
            {
                content: "Learn More",
                onClick: ()=>{
                    window.open("https://community.atlassian.com/forums/x/x/ba-p/2958563", "_blank", "noopener,noreferrer");
                }
            }
        ]
    });
};
var $a8b21de79cd5d5bc$export$2e2bcd8739ae039 = $a8b21de79cd5d5bc$var$GenericAccountLinkError;


const $21cc3992c36ca633$export$96c0b759f91580bf = {
    generic_error: (0, $85249fe68fa9bade$export$2e2bcd8739ae039),
    org_owned: (0, $c9940aa9edc30022$export$2e2bcd8739ae039),
    org_owned_linked: (0, $87e36e7f8625f39b$export$2e2bcd8739ae039),
    unlink_success: (0, $c578d09ff8879515$export$2e2bcd8739ae039),
    make_primary: (0, $255c02812216258b$export$2e2bcd8739ae039),
    unlink: (0, $c9940aa9edc30022$export$2e2bcd8739ae039)
};
const $21cc3992c36ca633$export$b273cc070e72e889 = {
    generic_error: (0, $85249fe68fa9bade$export$2e2bcd8739ae039),
    generic_account_link_error: (0, $a8b21de79cd5d5bc$export$2e2bcd8739ae039)
};


const $0e2101cfd53e472b$export$88f68187db5ede92 = (str)=>{
    if (str?.length > 27) return str.slice(0, 27) + "...";
    return str;
};





const $e341ce091835a224$var$ANALYTICS_SOURCE = (0, $77d0522707ddb581$export$d2cea8e85c08e64c).SETTINGS;
// https://data-portal.internal.atlassian.com/analytics/registry/84834
const $e341ce091835a224$export$a2aa3e55782e4a96 = ()=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: $e341ce091835a224$var$ANALYTICS_SOURCE,
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84863
const $e341ce091835a224$export$d36c13f6a12e4dd3 = ()=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "unifiedProfileLinkAccount",
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84864
const $e341ce091835a224$export$338f4d94ddfbca81 = (attributes)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "succeeded",
        actionSubject: "unifiedProfileAccountLinking",
        attributes: attributes,
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84865
const $e341ce091835a224$export$57f4cafbcf24bdad = (errorCode, phase, attributes)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "failed",
        actionSubject: "unifiedProfileAccountLinking",
        attributes: {
            errorCode: errorCode,
            ...phase && {
                phase: phase
            },
            ...attributes
        },
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84866
const $e341ce091835a224$export$be34a5889c5ab40a = ()=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "unifiedProfileUnlinkAccount",
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84867
const $e341ce091835a224$export$2b0b122948b77a82 = (attributes)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "succeeded",
        actionSubject: "unifiedProfileAccountUnlinking",
        attributes: attributes,
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84868
const $e341ce091835a224$export$d218a919727bdce = (errorCode, attributes)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "failed",
        actionSubject: "unifiedProfileAccountUnlinking",
        attributes: {
            errorCode: errorCode,
            ...attributes
        },
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84870
const $e341ce091835a224$export$a6aef8a6d077bbbb = ()=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "unifiedProfileMakePrimaryAccount",
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84871
const $e341ce091835a224$export$85cbff5916a03d45 = (attributes)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "succeeded",
        actionSubject: "unifiedProfileMakePrimaryAccount",
        attributes: attributes,
        isPersonalView: true
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/84872
const $e341ce091835a224$export$b4d03427248345e8 = (errorCode, attributes)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $e341ce091835a224$var$ANALYTICS_SOURCE,
        action: "failed",
        actionSubject: "unifiedProfileMakePrimaryAccount",
        attributes: {
            errorCode: errorCode,
            ...attributes
        },
        isPersonalView: true
    });
};



var $acw62 = parcelRequire("acw62");
const $bf7744c04ecc60a1$export$80f9d339f92cf0d9 = ()=>{
    const COOKIE_NAME = "analytics-session-timestamp";
    const COOKIE_DOMAIN = ".atlassian.com";
    const COOKIE_PATH = "/";
    const COOKIE_SECURE = "true";
    const COOKIE_SAME_SITE = "None";
    const setTimeStamp = (0, $acw62.useCallback)(()=>{
        try {
            const timestamp = Date.now();
            document.cookie = `${COOKIE_NAME}=${timestamp}; domain=${COOKIE_DOMAIN}; path=${COOKIE_PATH}; secure=${COOKIE_SECURE}; SameSite=${COOKIE_SAME_SITE}`;
        } catch (error) {
            console.warn("Failed to set session timestamp:", error);
        }
    }, []);
    const getTimeStamp = (0, $acw62.useCallback)(()=>{
        try {
            const cookies = document.cookie.split(";");
            const cookie = cookies.find((c)=>c.trim().startsWith(`${COOKIE_NAME}=`));
            const stored = cookie ? cookie.split("=")[1] : null;
            return stored ? parseFloat(stored) : null;
        } catch (error) {
            console.warn("Failed to get session timestamp:", error);
            return null;
        }
    }, []);
    const clearTimeStamp = (0, $acw62.useCallback)(()=>{
        try {
            document.cookie = `${COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; path=${COOKIE_PATH}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        } catch (error) {
            console.warn("Failed to clear session timestamp:", error);
        }
    }, []);
    const calculateTimeDiff = (0, $acw62.useCallback)(()=>{
        try {
            const timestamp = getTimeStamp();
            if (timestamp === null) return -1;
            const currentTime = Date.now();
            const timeDiff = currentTime - timestamp;
            // Clear the timestamp after calculating
            clearTimeStamp();
            return timeDiff;
        } catch (error) {
            console.warn("Failed to calculate time difference:", error);
            return -1;
        }
    }, [
        getTimeStamp,
        clearTimeStamp
    ]);
    return {
        setTimeStamp: setTimeStamp,
        getTimeStamp: getTimeStamp,
        clearTimeStamp: clearTimeStamp,
        calculateTimeDiff: calculateTimeDiff
    };
};
var $bf7744c04ecc60a1$export$2e2bcd8739ae039 = $bf7744c04ecc60a1$export$80f9d339f92cf0d9;


const $727171566fe8dac8$var$initializeTransaction = (input = {})=>{
    return new Promise((resolve, reject)=>{
        (0, $eJz0f.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $2d8eb9f733f1818f$export$4db6a852f0f416dc),
            variables: input,
            onCompleted: (response, errors)=>{
                const initializeTransactionVal = response?.unified?.linking?.initializeLinkingWithLoggedInAccount;
                if (initializeTransactionVal?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Initialization of transaction failed", errors);
                    else errorCode = initializeTransactionVal?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode
                    });
                } else {
                    if (!initializeTransactionVal?.token) throw new Error("Token not found in response");
                    resolve(initializeTransactionVal?.token);
                }
            },
            onError: (error)=>{
                console.error("Initialization of transaction failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $727171566fe8dac8$var$unlink = (aaid)=>{
    return new Promise((resolve, reject)=>{
        (0, $eJz0f.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $5c01f74a0fd87013$export$728a7916b6a83fa7),
            variables: {
                aaid: aaid
            },
            onCompleted: (response, errors)=>{
                const unlinkResponse = response?.unified?.account?.unlinkAccount;
                if (unlinkResponse?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Initialization of transaction failed", errors);
                    else errorCode = unlinkResponse?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode
                    });
                } else resolve(unlinkResponse?.success);
            },
            onError: (error)=>{
                console.error("Initialization of transaction failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $727171566fe8dac8$var$setPrimaryAccount = (aaid)=>{
    return new Promise((resolve, reject)=>{
        (0, $eJz0f.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $8640f175d71906c5$export$7a6ca33386c38b9b),
            variables: {
                aaid: aaid
            },
            onCompleted: (response, errors)=>{
                const accountResponse = response?.unified?.account?.setPrimaryAccount;
                if (accountResponse?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Initialization of transaction failed", errors);
                    else errorCode = accountResponse?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode
                    });
                } else {
                    console.log("Mutation successful", accountResponse?.message);
                    resolve(accountResponse?.success);
                    window.location.reload();
                }
            },
            onError: (error)=>{
                console.error("Initialization of transaction failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $727171566fe8dac8$var$REACT_APP_IDENTITY_BASE_URL = "https://id.atlassian.com", $727171566fe8dac8$var$REACT_APP_ACCOUNT_LINK_BASE_URL = "https://community-link.atlassian.com";
const $727171566fe8dac8$var$LinkComponent = ({ loggedInAccountEmail: loggedInAccountEmail, isLoggedInLinked: isLoggedInLinked, isLoggedInPrimary: isLoggedInPrimary, onFailure: onFailure })=>{
    if (!isLoggedInPrimary && isLoggedInLinked) return null;
    const handleLinkAccountClick = async ()=>{
        try {
            (0, $e341ce091835a224$export$d36c13f6a12e4dd3)();
            const input = {};
            const token = await $727171566fe8dac8$var$initializeTransaction(input);
            const encryptedToken = encodeURIComponent(token); // this is very important, tokens can have / leading to unknown path.
            // https://atlassian.slack.com/archives/CFJ9DJ7P0/p1733439088988988559?thread_ts=1733403825.184989&cid=CFJ9DJ7P0
            const continueUrl = encodeURIComponent(`${$727171566fe8dac8$var$REACT_APP_ACCOUNT_LINK_BASE_URL}/user/authenticate/${encryptedToken}`);
            window.sessionStorage.setItem("sourceLinkingEmail", loggedInAccountEmail);
            const link = `${$727171566fe8dac8$var$REACT_APP_IDENTITY_BASE_URL}/login?application=community--account-linking&sourceLinkingEmail=${loggedInAccountEmail}&prompt=login&continue=${continueUrl}`;
            window.open(link, "_self");
        } catch (e) {
            console.error("Failed to initialize linking", e);
            const errorCodeReceived = e?.errorCode || "generic_error";
            (0, $e341ce091835a224$export$57f4cafbcf24bdad)(errorCodeReceived, "initialization");
            onFailure(errorCodeReceived);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$c9d2f1697787ae74), {
        onClick: handleLinkAccountClick,
        isAddAccount: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$fc13faf098015d3a), {})
    });
};
const $727171566fe8dac8$var$getTaggedComponents = (isPrimary, isLoggedIn, isLinked)=>{
    const tags = [];
    if (isLoggedIn) tags.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$8bee5cfdbbc2fc0c), {}, "tag-logged-in"));
    if (isPrimary) tags.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$be7f7dedc3a0e1ad), {}, "tag-primary"));
    if (isLinked && !isPrimary) tags.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$446c53c437a3d14a), {}, "tag-linked"));
    return tags;
};
const $727171566fe8dac8$var$Settings = ()=>{
    const [, { replace: replace }] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const [errorCodeQueryParam] = (0, $1f125c4828fc1621$export$ae316f0eeb712a36)("errorCode");
    const [errorCode, setErrorCode] = (0, $acw62.useState)(errorCodeQueryParam);
    const [flags, setFlags] = (0, $acw62.useState)([]);
    const { setTimeStamp: setTimeStamp, calculateTimeDiff: calculateTimeDiff } = (0, $bf7744c04ecc60a1$export$80f9d339f92cf0d9)(); // set the timestamp for the session
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $e341ce091835a224$export$a2aa3e55782e4a96)());
    (0, $acw62.useEffect)(()=>{
        // clear the errorCode query parameter after consuming it. that way error doesn't persist.
        if (errorCodeQueryParam) {
            const url = new URL(window.location.href);
            url.searchParams.delete("errorCode");
            const newUrl = `${url.origin}${url.pathname}${url.search}`;
            replace(newUrl);
        }
    }, [
        errorCodeQueryParam,
        replace
    ]);
    (0, $acw62.useEffect)(()=>{
        if (errorCode) setFlags([
            {
                code: errorCode,
                component: [
                    "invalid_primary_account_index",
                    "invalid_primary_account",
                    "invalid_non_primary_account"
                ].includes(errorCode) ? (0, $21cc3992c36ca633$export$b273cc070e72e889)["generic_account_link_error"] : (0, $21cc3992c36ca633$export$b273cc070e72e889)["generic_error"]
            }
        ]);
        else setFlags([]);
    }, [
        errorCode
    ]);
    const handleLinkFailure = (failureErrorCode)=>{
        setErrorCode(failureErrorCode);
    };
    const handleDismiss = (code)=>{
        setFlags((prevFlags)=>prevFlags.filter((flag)=>flag.code !== code));
        setErrorCode(undefined);
    };
    const loggedInUser = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5b4d113e3efb8585$export$75493bef044c2fa0), {}, {
        fetchPolicy: "store-or-network"
    })?.me?.user;
    if (!loggedInUser?.accountId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/not_authorized"
    });
    const accountId = loggedInUser.accountId;
    const account = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $69f7bb7bdecca370$export$d483224631a5893c), {
        aaid: accountId
    }, {
        fetchPolicy: "store-or-network"
    })?.unified?.account;
    const isLoggedInAccountNotPrimary = account?.aaid === accountId && !account.isPrimary;
    const handleUnlink = async (aaid)=>{
        setTimeStamp();
        (0, $e341ce091835a224$export$be34a5889c5ab40a)();
        try {
            const success = await $727171566fe8dac8$var$unlink(aaid);
            if (success) {
                const duration = calculateTimeDiff();
                (0, $e341ce091835a224$export$2b0b122948b77a82)({
                    duration: duration
                });
                window.location.reload();
            } else {
                const duration = calculateTimeDiff();
                (0, $e341ce091835a224$export$d218a919727bdce)("unlink_returned_false", {
                    duration: duration
                });
            }
        } catch (e) {
            console.error("Failed to unlink", e);
            const errorCodeReceived = e?.errorCode || "generic_error";
            const duration = calculateTimeDiff();
            (0, $e341ce091835a224$export$d218a919727bdce)(errorCodeReceived, {
                duration: duration
            });
            setErrorCode(errorCodeReceived);
        }
    };
    const infoPanelSectionMessage = ()=>{
        let title = "";
        let message = "";
        if (!account?.isLinked) {
            title = "Add a primary account";
            message = "Having a primary account ensures you retain access to your profile and achievements, even if you move companies. Your primary account must be an account you own and manage yourself - it can't be managed by your company.";
        } else if (isLoggedInAccountNotPrimary) {
            title = "";
            message = "Log in to your primary account to link and unlink accounts";
        }
        if (!message) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2154909317384aee$export$2e2bcd8739ae039), {
            title: title,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: message
            })
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _19pkt9kd _1bsb1nlw _jlq11yw0 _12yo1tcg _17fr1ou6 _ffv71vd0"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1bsb1nlw _16jlkb7n _1o9zkb7n _i0dlf1ug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$a8a3e93435678ff9), {
                        level: 1,
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_19pk1ady"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$a8a3e93435678ff9), {
                                level: 3,
                                children: "Linked accounts"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_19pkftgi _1bsb1osq _1e0c1txw _2lx21bp4 _zulpftgi"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                    children: [
                                        "You can link multiple Atlassian accounts together to combine all of your Community achievements under one profile. Learn about ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "/forums/x/x/ba-p/2958563",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_syaz1jwt _4bfu1r31 _1hmsglyw _ajmmnqa1"
                                            ]),
                                            children: "linking accounts."
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_19pkzwfg"
                        ]),
                        children: infoPanelSectionMessage()
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _1bah1e5h _1bsb1osq _1n261g80 _19pk1ylp _zulp1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1pyaidpf _1w3x1h6o _jlq11yw0 _17frhiv4 _wv5q1h6o _fipvhiv4 _ffv71vd0"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_kqswh2mm"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$c9d2f1697787ae74), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$c031b829a2452999), {
                                        email: (0, $0e2101cfd53e472b$export$88f68187db5ede92)(account?.emailId || account?.aaid),
                                        tags: $727171566fe8dac8$var$getTaggedComponents(!!account?.isPrimary, true, !!account?.isLinked),
                                        // change primary account temporarily disabled. (logged in to primary thus has no options, so disabling kebab menu)
                                        // also, doesn't make sense to allow unlinking on an account that isn't linked
                                        disableMenu: !isLoggedInAccountNotPrimary || !account.isLinked,
                                        actions: (0, $ee89958484c722a6$export$614c70537f470f74)({
                                            isPrimaryAccount: account?.isPrimary ?? false,
                                            isOrgOwned: account?.isManaged ?? true,
                                            isLoggedInAccountNotPrimary: isLoggedInAccountNotPrimary
                                        }, {
                                            unlinkAccount: async ()=>{
                                                await handleUnlink(account?.aaid);
                                            },
                                            changePrimary: ()=>{
                                                return;
                                            },
                                            makePrimary: async ()=>{
                                                setTimeStamp();
                                                (0, $e341ce091835a224$export$a6aef8a6d077bbbb)();
                                                try {
                                                    await $727171566fe8dac8$var$setPrimaryAccount(account?.aaid);
                                                    const duration = calculateTimeDiff();
                                                    (0, $e341ce091835a224$export$85cbff5916a03d45)({
                                                        duration: duration
                                                    });
                                                } catch (e) {
                                                    console.error("Failed to make primary", e);
                                                    const errorCodeReceived = e?.errorCode || "generic_error";
                                                    const duration = calculateTimeDiff();
                                                    (0, $e341ce091835a224$export$b4d03427248345e8)(errorCodeReceived, {
                                                        duration: duration
                                                    });
                                                    setErrorCode(errorCodeReceived);
                                                }
                                            }
                                        }),
                                        "data-testid": `account-card-${account?.emailId || account?.aaid}`
                                    })
                                })
                            }, account?.aaid),
                            account?.isLinked ? account.linkedAccounts?.edges?.map((edge)=>{
                                const { aaid: aaid, emailId: emailId, isPrimary: isPrimary, isManaged: isManaged, isLinked: isLinked } = edge?.node ?? {};
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_kqswh2mm"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$c9d2f1697787ae74), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$c031b829a2452999), {
                                            email: (0, $0e2101cfd53e472b$export$88f68187db5ede92)(emailId),
                                            tags: $727171566fe8dac8$var$getTaggedComponents(isPrimary, false, !!isLinked),
                                            disableMenu: isLoggedInAccountNotPrimary,
                                            actions: (0, $ee89958484c722a6$export$614c70537f470f74)({
                                                isPrimaryAccount: isPrimary ?? false,
                                                isOrgOwned: isManaged ?? true
                                            }, {
                                                unlinkAccount: async ()=>{
                                                    await handleUnlink(aaid);
                                                },
                                                changePrimary: ()=>{
                                                    return;
                                                },
                                                makePrimary: async ()=>{
                                                    setTimeStamp();
                                                    (0, $e341ce091835a224$export$a6aef8a6d077bbbb)();
                                                    try {
                                                        await $727171566fe8dac8$var$setPrimaryAccount(aaid);
                                                        const duration = calculateTimeDiff();
                                                        (0, $e341ce091835a224$export$85cbff5916a03d45)({
                                                            duration: duration
                                                        });
                                                    } catch (e) {
                                                        console.error("Failed to make primary", e);
                                                        const errorCodeReceived = e?.errorCode || "generic_error";
                                                        const duration = calculateTimeDiff();
                                                        (0, $e341ce091835a224$export$b4d03427248345e8)(errorCodeReceived, {
                                                            duration: duration
                                                        });
                                                        setErrorCode(errorCodeReceived);
                                                    }
                                                }
                                            }),
                                            "data-testid": `account-card-${emailId}`
                                        })
                                    })
                                }, aaid);
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($727171566fe8dac8$var$LinkComponent, {
                                    loggedInAccountEmail: account?.emailId || "",
                                    isLoggedInLinked: !!account?.isLinked,
                                    isLoggedInPrimary: !!account?.isPrimary,
                                    onFailure: handleLinkFailure
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84707e704ae72238$export$2e2bcd8739ae039), {
                        flags: flags,
                        onDismiss: handleDismiss,
                        linkedEmail: "testEmail"
                    })
                ]
            })
        })
    });
};
var $727171566fe8dac8$export$2e2bcd8739ae039 = $727171566fe8dac8$var$Settings;
const $727171566fe8dac8$var$parentContentContainer = null;
const $727171566fe8dac8$var$cardsContainer = null;
const $727171566fe8dac8$var$infoSectionContainer = null;
const $727171566fe8dac8$var$descriptionContentContainer = null;
const $727171566fe8dac8$var$descriptionContainer = null;
const $727171566fe8dac8$var$containerStyles = null;
const $727171566fe8dac8$var$mainPanelStyles = null;
const $727171566fe8dac8$var$linkStyle = null;
const $727171566fe8dac8$var$tempCardContainerWrapperStyes = null;


/* Error.tsx generated by @compiled/babel-plugin v0.29.1 */ 

parcelRequire("acw62");



const $ce3e35d292696439$var$ERRORS = {
    generic_error: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cfd5dd4fef2e3758$exports))),
        heading: "Something went wrong",
        description: "We're working to fix the problem. Try again later, or visit our homepage.",
        link: "/user",
        linkText: "Go home"
    }),
    user_not_found: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($707d35ecd7f38950$exports))),
        heading: "We couldn't find this profile",
        description: "It may have been deleted, or there might be a typo in the URL. Check the link, or visit our homepage.",
        link: "/user",
        linkText: "Go home"
    }),
    initialization_failed: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($707d35ecd7f38950$exports))),
        heading: "We couldn't initialize user",
        description: "User could not be initialized due to an unknown error",
        link: "/user",
        linkText: "Go home"
    }),
    not_authorized: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cfd5dd4fef2e3758$exports))),
        heading: "Not Authorized",
        description: "User is not authorized to visit this page",
        link: "/user",
        linkText: "Go home"
    }),
    invalid_path: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($707d35ecd7f38950$exports))),
        heading: "Invalid Path",
        description: "This path does not exist",
        link: "/user",
        linkText: "Go home"
    }),
    consent_failed: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403b11bf679d9061$export$ece78e4633e29053), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($707d35ecd7f38950$exports))),
        heading: "Consent Failed",
        description: "Something went wrong. Please try again later or contact support.",
        link: "/user",
        linkText: "Go home"
    })
};
const $ce3e35d292696439$var$ErrorPage = ()=>{
    const [errorId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("errorId");
    const errorComponent = !errorId || !$ce3e35d292696439$var$ERRORS[errorId] ? $ce3e35d292696439$var$ERRORS.generic_error : $ce3e35d292696439$var$ERRORS[errorId];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _1e0c1txw _1bah1h6o"
        ]),
        children: errorComponent
    });
};
const $ce3e35d292696439$var$errorContainerStyles = null;
var $ce3e35d292696439$export$2e2bcd8739ae039 = $ce3e35d292696439$var$ErrorPage;


/* BadgesFullList.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");

/* BadgeCard.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");
var $65ff5384663eb2b7$export$4ef52930e33717cd = "data-theme";
var $65ff5384663eb2b7$export$a00eac3f8684bcd0 = "data-color-mode";
var $65ff5384663eb2b7$export$2112803007239c61 = "data-contrast-mode";
var $65ff5384663eb2b7$export$352e418ed5b6193a = "data-custom-theme";
var $65ff5384663eb2b7$export$2faeed762aac6741 = "light";
var $65ff5384663eb2b7$export$6f0c6fb8c80fcc92 = "ds";
var $65ff5384663eb2b7$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $65ff5384663eb2b7$export$dddac1532e822863 = "--".concat($65ff5384663eb2b7$export$6f0c6fb8c80fcc92, "-token-not-found");
var $65ff5384663eb2b7$export$9d7b58831ae93caa = "--".concat($65ff5384663eb2b7$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $e04a1ee8cf63d832$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $e04a1ee8cf63d832$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $e04a1ee8cf63d832$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $e04a1ee8cf63d832$export$ba8a43b83ecc69f8 = [];
var $e04a1ee8cf63d832$export$92ba366331403db2 = [].concat($e04a1ee8cf63d832$export$7d43e72a58e3283f, $e04a1ee8cf63d832$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $e04a1ee8cf63d832$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $e04a1ee8cf63d832$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $e04a1ee8cf63d832$export$2e2bcd8739ae039 = $e04a1ee8cf63d832$var$themeConfig;



var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $c15e22a82d76d0eb$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $c15e22a82d76d0eb$var$customThemeOptions = "UNSAFE_themeOptions";
var $c15e22a82d76d0eb$var$isThemeKind = function isThemeKind(themeKind) {
    return $c15e22a82d76d0eb$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $c15e22a82d76d0eb$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $e04a1ee8cf63d832$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $c15e22a82d76d0eb$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $c15e22a82d76d0eb$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $c15e22a82d76d0eb$var$isColorMode(id)) themeObject[kind] = id;
        if ($c15e22a82d76d0eb$var$isThemeKind(kind) && $c15e22a82d76d0eb$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $c15e22a82d76d0eb$var$customThemeOptions) try {
            themeObject[$c15e22a82d76d0eb$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $c15e22a82d76d0eb$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $c15e22a82d76d0eb$var$isColorMode(id) || // custom theme state
        kind === $c15e22a82d76d0eb$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $c15e22a82d76d0eb$var$isThemeKind(kind) && typeof id === "string" && $c15e22a82d76d0eb$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};


function $6875bef27c5bbb57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6875bef27c5bbb57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6875bef27c5bbb57$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6875bef27c5bbb57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6875bef27c5bbb57$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $e04a1ee8cf63d832$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $6875bef27c5bbb57$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $65ff5384663eb2b7$export$a00eac3f8684bcd0)) || "";
    var theme = element.getAttribute((0, $65ff5384663eb2b7$export$4ef52930e33717cd)) || "";
    return $6875bef27c5bbb57$var$_objectSpread($6875bef27c5bbb57$var$_objectSpread({}, (0, $c15e22a82d76d0eb$export$f19b488f7c0547ee)(theme)), $6875bef27c5bbb57$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $6875bef27c5bbb57$export$2e2bcd8739ae039 = $6875bef27c5bbb57$var$getGlobalTheme;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $f86b438abac17e9c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $6875bef27c5bbb57$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $65ff5384663eb2b7$export$4ef52930e33717cd),
                            (0, $65ff5384663eb2b7$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
    return ThemeMutationObserver;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($f86b438abac17e9c$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($f86b438abac17e9c$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $a550ae592c1ea76e$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $acw62.useState)((0, $6875bef27c5bbb57$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $acw62.useEffect)(function() {
        var observer = new (0, $f86b438abac17e9c$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a550ae592c1ea76e$export$2e2bcd8739ae039 = $a550ae592c1ea76e$var$useThemeObserver;


var $3bd26b6fddb52586$var$_excluded = [
    "src",
    "srcDark",
    "alt",
    "testId"
];
var $3bd26b6fddb52586$var$imageStyles = (0, $jjlaj.css)({
    maxWidth: "100%",
    height: "auto"
});
function $3bd26b6fddb52586$export$2e2bcd8739ae039(_ref) {
    var src = _ref.src, srcDark = _ref.srcDark, alt = _ref.alt, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3bd26b6fddb52586$var$_excluded);
    var imgRef = (0, $acw62.useRef)(null);
    var _useThemeObserver = (0, $a550ae592c1ea76e$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    (0, $acw62.useEffect)(function() {
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === "dark") imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return (0, $jjlaj.jsx)("img", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        alt: alt,
        css: $3bd26b6fddb52586$var$imageStyles,
        "data-testid": testId,
        src: src,
        ref: imgRef
    }, props));
}


/* BadgeCardWrapper.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");


const $4fbfb0112361e085$export$aaf21fcc60b73128 = ({ isClickable: isClickable, children: children, to: to = "#", badgeTitle: badgeTitle, badgeType: badgeType = "forums", isPersonalView: isPersonalView = false })=>{
    if (!isClickable) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _2rko1y44 _ca0q7vkz _u5f31crf _n3td7vkz _19bv1crf _19it7v06"
        ]),
        children: children
    });
    const onClickCard = ()=>{
        (0, $4bff37f495adcdfa$export$574784435215f928)(badgeTitle, badgeType, isPersonalView);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        onClick: onClickCard,
        href: to,
        target: "_blank",
        rel: "noreferrer",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _2rko1y44 _ca0q7vkz _u5f31crf _n3td7vkz _19bv1crf _16qsj9yf _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1kw7 _v564wzwm _d0altlke _1dbz17er _9oik1r31 _1bnxglyw _jf4cnqa1 _30l31kw7 _n7dw1egq"
        ]),
        children: children
    });
};
const $4fbfb0112361e085$var$containerStyles = null;
const $4fbfb0112361e085$var$notClickableContainerStyles = null;


const $2914a7430b82e82a$export$22da447a4012011 = ({ image: image, badgeTitle: badgeTitle, link: link, isPersonalView: isPersonalView = false, badgeType: badgeType = "forums" })=>{
    function truncateString(input) {
        if (input.length > 65) return input.substring(0, 65) + "...";
        return input;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4fbfb0112361e085$export$aaf21fcc60b73128), {
        isClickable: Boolean(link),
        to: link,
        badgeTitle: badgeTitle,
        badgeType: badgeType,
        isPersonalView: isPersonalView,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_1o9zidpf _1bsbr5k8 _4t3ir5k8 _1e0c1txw _1bah1h6o _4cvr1h6o _1reo15vq _18m915vq _2rko1ssb"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3bd26b6fddb52586$export$2e2bcd8739ae039), {
                    src: image.src,
                    alt: image.alt,
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1bsb1osq _4t3i1osq _5ral1dfr _2rko1ssb"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_18u07vkz"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1wyb7vkz _ect4kwxw _k48pzul8 _vwz41tcg _1nmz1hna _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    children: truncateString(badgeTitle)
                })
            })
        ]
    });
};
const $2914a7430b82e82a$var$imageContainerStyles = null;
const $2914a7430b82e82a$var$imageStyles = null;
const $2914a7430b82e82a$var$contentContainerStyles = null;
const $2914a7430b82e82a$var$badgeTitleStyles = null;













const $2fd427e8cffe987d$var$BadgesFullList = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const badgesResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5c5c0f6b82e5b280$export$15a2e43f9400c215), {
        internalId: pathProfileId
    }).unified?.unifiedProfile;
    const forumsBadgesEdges = badgesResponse?.badges?.edges || [];
    const recentLearningAchievementBadgesEdges = badgesResponse?.learning?.recentLearningAchievementBadges?.edges || [];
    const forumsBadges = forumsBadgesEdges.map((edge)=>({
            ...edge?.node ?? {},
            src: edge?.node?.imageUrl
        }));
    const recentLearningAchievementBadges = recentLearningAchievementBadgesEdges.map((edge)=>({
            ...edge?.node ?? {},
            src: edge?.node?.imageUrl
        }));
    const profileResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $fe73a947836bf836$export$9d9de7756b13ecf), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const profileData = profileResponseData?.unified?.unifiedProfile;
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(pathProfileId);
    const hasProfileOwnerConsent = (0, $0ee606ad15f500d3$export$7a0549bb2cff767b)(badgesResponse?.isProfileOwnerConsented ?? undefined);
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $f1acffce3b3355bb$export$d3077750ed35a580)(isPersonalView), {
        shouldSendEvent: Boolean(profileData)
    });
    if (!profileData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch profile data"
    });
    const userResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: profileData.aaid
    }, {
        fetchPolicy: "store-or-network"
    });
    const userData = userResponseData.user;
    const onClickBackToProfile = ()=>{
        (0, $f1acffce3b3355bb$export$42caad678751a45d)(isPersonalView);
    };
    const BackToProfileButton = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
            to: `/profile/${pathProfileId}`,
            onClick: onClickBackToProfile,
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1wpz1y6m _syaz1jwt _ect41q02 _1wybxjmg _k48pzul8 _vwz41bcc"
            ]),
            children: "\u2190 Back to profile"
        });
    };
    const shouldShowLearningBadges = hasProfileOwnerConsent && recentLearningAchievementBadges.length > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b08f67dec19c15db$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": "badges-full-list",
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _1bah1h6o _1tke1deq _1bsb1osq"
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_19pkgosd _1bsb1faz _18u01wug _2hwx1wug _p12f1osq _1ltk1yw0 _12yogosd _1qnwidpf _19mhidpf _2tididpf _wez5idpf _17frhiv4 _ffv71vd0"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_n3td1tcg _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1faz _be4b7vkz",
                            !shouldShowLearningBadges && "_n3tdidpf _be4bidpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BackToProfileButton, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_19pk1ylp _1wybgosd _k48pbogh _ect4kwxw _vwz4a5zd _n3td1ylp _n7zl7v06 _otyr1ylp _be4b1tcg _17fr1tcg _fipv1tcg _1mqwzwfg _1cf81ylp"
                                ]),
                                children: `${userData?.nickname}'s badges`
                            }),
                            shouldShowLearningBadges && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b09ec013b267e49$export$2e2bcd8739ae039), {
                                testId: "learning-achievements-full-list-title",
                                title: `${recentLearningAchievementBadges.length} Learning achievement${recentLearningAchievementBadges.length === 1 ? "" : "s"}`
                            })
                        ]
                    }),
                    shouldShowLearningBadges && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                "data-testid": "learning-achievements-full-list-container",
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c11p5 _zulp1tcg _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _yv0ehkll _18xy1rmm _oe5x7vkz"
                                ]),
                                children: recentLearningAchievementBadges.map((achievement)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2914a7430b82e82a$export$22da447a4012011), {
                                            badgeTitle: achievement.name || "Unknown Learning achievement",
                                            link: achievement.actionUrl || "",
                                            image: {
                                                src: achievement.src || "default_image_path",
                                                alt: achievement.name || "Learning achievement image"
                                            },
                                            isPersonalView: isPersonalView,
                                            badgeType: "learning"
                                        })
                                    }, achievement.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_19pk1ylp _17frzwfg"
                                ])
                            })
                        ]
                    }),
                    forumsBadges.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_n3td1tcg _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1faz _be4b7vkz"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b09ec013b267e49$export$2e2bcd8739ae039), {
                                    testId: "recent-badges-full-list-title",
                                    title: `${forumsBadges.length} ${forumsBadges.length === 1 ? "Badge" : "Badges"}`
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                "data-testid": "recent-badges-full-list-container",
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c11p5 _zulp1tcg _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _yv0ehkll _18xy1rmm _oe5x7vkz"
                                ]),
                                children: forumsBadges.map((badge)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2914a7430b82e82a$export$22da447a4012011), {
                                            badgeTitle: badge.name || "Unknown Badge",
                                            link: badge.actionUrl || "",
                                            image: {
                                                src: badge.src || "https://demofree.sirv.com/nope-not-here.jpg",
                                                // In styled version, what do we do if no image?
                                                alt: badge.name || "Course Image"
                                            },
                                            isPersonalView: isPersonalView,
                                            badgeType: "forums"
                                        })
                                    }, badge.id))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $2fd427e8cffe987d$var$sectionSpacer = null;
const $2fd427e8cffe987d$var$listItemMargin = null;
const $2fd427e8cffe987d$var$parentContainer = null;
const $2fd427e8cffe987d$var$contentWrapper = null;
const $2fd427e8cffe987d$var$backLinkStyle = null;
const $2fd427e8cffe987d$var$headerAndBadgesContainer = null;
const $2fd427e8cffe987d$var$headerAndBadgesContainerNoCourses = null;
const $2fd427e8cffe987d$var$titleStyles = null;
const $2fd427e8cffe987d$var$badgesContainer = null;
var $2fd427e8cffe987d$export$2e2bcd8739ae039 = $2fd427e8cffe987d$var$BadgesFullList;


/* EditProfileForm.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");



var $1273dc8eae8f1aca$export$c24727297075ec6a = /*#__PURE__*/ (0, $acw62.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $1273dc8eae8f1aca$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $1273dc8eae8f1aca$export$2e2bcd8739ae039(props) {
    var formRef = (0, $acw62.useRef)(null);
    var onSubmitRef = (0, $acw62.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    var _useState = (0, $acw62.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $7f17f1906b9f3211$export$f681a8129d2e9d28)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var _initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === "function" ? defaultValue(_initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($616ab74e95c8680a$exports)))(_initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($616ab74e95c8680a$exports)))(values, name, _value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $485f8543f71f3f87$export$2e2bcd8739ae039)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll("input")) : [];
        })(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $acw62.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $acw62.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $acw62.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $acw62.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $acw62.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1273dc8eae8f1aca$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1273dc8eae8f1aca$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: function getState() {
            return form.getState();
        },
        getValues: function getValues() {
            return form.getState().values;
        },
        // TODO: deprecate
        setFieldValue: form.change
    })));
}


var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $acw62 = parcelRequire("acw62");
var $6aef6ef376234231$export$3c4232819458a302 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



/** @jsx jsx */ 
var $jjlaj = parcelRequire("jjlaj");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 

var $486737e365f3c084$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $486737e365f3c084$export$c93026a968943f95 = "light";
var $486737e365f3c084$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $486737e365f3c084$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $486737e365f3c084$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $486737e365f3c084$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $486737e365f3c084$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $486737e365f3c084$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $486737e365f3c084$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $486737e365f3c084$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $a5f58aaa12937e99$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $486737e365f3c084$export$6d8204c2cb2e06b8() / 4;
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $486737e365f3c084$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $486737e365f3c084$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $486737e365f3c084$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $486737e365f3c084$export$ba1d834b86d72a09 = $486737e365f3c084$export$a1b3edb637fb4f35;
var $486737e365f3c084$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $a5f58aaa12937e99$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $a5f58aaa12937e99$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $a5f58aaa12937e99$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $d1a01a9cf1a6cdf6$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $486737e365f3c084$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $486737e365f3c084$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $486737e365f3c084$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $486737e365f3c084$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $04c45a3f40248065$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $d1a01a9cf1a6cdf6$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $04c45a3f40248065$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $04c45a3f40248065$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $d1a01a9cf1a6cdf6$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $a5f58aaa12937e99$export$4b84fd0e2c617bd = "#FFEBE6";
var $a5f58aaa12937e99$export$b34b069eff244586 = "#FFBDAD";
var $a5f58aaa12937e99$export$be802dd0d8b57f35 = "#FF8F73";
var $a5f58aaa12937e99$export$60847d42f9da92a6 = "#FF7452";
var $a5f58aaa12937e99$export$4a7404f376229999 = "#FF5630";
var $a5f58aaa12937e99$export$2010d0fb4295b346 = "#DE350B";
var $a5f58aaa12937e99$export$2837b5a1a71d5c02 = "#BF2600";
var $a5f58aaa12937e99$export$8d9596b529bbb9cf = "#FFFAE6";
var $a5f58aaa12937e99$export$41060a744ab0b7ae = "#FFF0B3";
var $a5f58aaa12937e99$export$1cc05bbbf340e559 = "#FFE380";
var $a5f58aaa12937e99$export$5aae31392d72caaa = "#FFC400";
var $a5f58aaa12937e99$export$c6930421db9fa514 = "#FFAB00";
var $a5f58aaa12937e99$export$59619663aa6500fb = "#FF991F";
var $a5f58aaa12937e99$export$874739ea9e379ab6 = "#FF8B00";
var $a5f58aaa12937e99$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $a5f58aaa12937e99$export$69a3bf21b9686c2b = "#ABF5D1";
var $a5f58aaa12937e99$export$afbce1382ec95f73 = "#79F2C0";
var $a5f58aaa12937e99$export$747d86715d4175de = "#57D9A3";
var $a5f58aaa12937e99$export$940e1f69e873f202 = "#36B37E";
var $a5f58aaa12937e99$export$a49394138f7b8e85 = "#00875A";
var $a5f58aaa12937e99$export$6fa04827ac68a4fb = "#006644";
var $a5f58aaa12937e99$export$226de0355ed012f8 = "#DEEBFF";
var $a5f58aaa12937e99$export$8c13c2ee36917869 = "#B3D4FF";
var $a5f58aaa12937e99$export$ecfc1dff386a3e7a = "#4C9AFF";
var $a5f58aaa12937e99$export$215b7063051591f1 = "#2684FF";
var $a5f58aaa12937e99$export$e62e8919cca44969 = "#0065FF";
var $a5f58aaa12937e99$export$b3de0ae08da2ce64 = "#0052CC";
var $a5f58aaa12937e99$export$a6ee3d71bc067634 = "#0747A6";
var $a5f58aaa12937e99$export$363e4475840015bb = "#EAE6FF";
var $a5f58aaa12937e99$export$4b0a4417ed59760f = "#C0B6F2";
var $a5f58aaa12937e99$export$6011520a64d9a187 = "#998DD9";
var $a5f58aaa12937e99$export$a7175d4e9206bc80 = "#8777D9";
var $a5f58aaa12937e99$export$b48405b95304b5a1 = "#6554C0";
var $a5f58aaa12937e99$export$c71e4279dd54a18d = "#5243AA";
var $a5f58aaa12937e99$export$147899de772240ec = "#403294";
var $a5f58aaa12937e99$export$2cf711fe14c66f06 = "#E6FCFF";
var $a5f58aaa12937e99$export$7a8f4d33f6f9772c = "#B3F5FF";
var $a5f58aaa12937e99$export$776c9c497ef08533 = "#79E2F2";
var $a5f58aaa12937e99$export$69cb3ca10c1e330e = "#00C7E6";
var $a5f58aaa12937e99$export$9dc1ef0f3f48059b = "#00B8D9";
var $a5f58aaa12937e99$export$7c835c78b6fcdef8 = "#00A3BF";
var $a5f58aaa12937e99$export$6036577f95c3877e = "#008DA6";
var $a5f58aaa12937e99$export$29a4f05edc054374 = "#FFFFFF";
var $a5f58aaa12937e99$export$e655ef011c4aa1a2 = "#FAFBFC";
var $a5f58aaa12937e99$export$9fdfb749e33cdf97 = "#F4F5F7";
var $a5f58aaa12937e99$export$3e51e8f1440314ba = "#EBECF0";
var $a5f58aaa12937e99$export$1ce2d1575d444ceb = "#DFE1E6";
var $a5f58aaa12937e99$export$8754fc7e6d8b3000 = "#C1C7D0";
var $a5f58aaa12937e99$export$c2e91cbeada39b8b = "#B3BAC5";
var $a5f58aaa12937e99$export$5f71e19f3a7ad9de = "#A5ADBA";
var $a5f58aaa12937e99$export$eaa8c8a70ac22806 = "#97A0AF";
var $a5f58aaa12937e99$export$7c87d337fb91a97d = "#8993A4";
var $a5f58aaa12937e99$export$d6447c357493214f = "#7A869A";
var $a5f58aaa12937e99$export$f563ee71e9ee74cd = "#6B778C";
var $a5f58aaa12937e99$export$e2ef2124cf4024b1 = "#5E6C84";
var $a5f58aaa12937e99$export$eece5f492e429f08 = "#505F79";
var $a5f58aaa12937e99$export$c39c0fe0f26207ae = "#42526E";
var $a5f58aaa12937e99$export$7090862dc3038a9f = "#344563";
var $a5f58aaa12937e99$export$ad0bacf983b7ddaa = "#253858";
var $a5f58aaa12937e99$export$7d61b15e0da132af = "#172B4D";
var $a5f58aaa12937e99$export$fbda843f0a27fe96 = "#091E42";
var $a5f58aaa12937e99$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $a5f58aaa12937e99$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $a5f58aaa12937e99$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $a5f58aaa12937e99$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $a5f58aaa12937e99$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $a5f58aaa12937e99$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $a5f58aaa12937e99$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $a5f58aaa12937e99$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $a5f58aaa12937e99$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $a5f58aaa12937e99$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $a5f58aaa12937e99$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $a5f58aaa12937e99$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $a5f58aaa12937e99$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $a5f58aaa12937e99$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $a5f58aaa12937e99$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $a5f58aaa12937e99$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $a5f58aaa12937e99$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $a5f58aaa12937e99$export$2f6319cf7d736c2a = "#E6EDFA";
var $a5f58aaa12937e99$export$95126bc8884d6634 = "#DCE5F5";
var $a5f58aaa12937e99$export$8338d8c35d44ff1 = "#CED9EB";
var $a5f58aaa12937e99$export$5368d76ae4fbbda7 = "#B8C7E0";
var $a5f58aaa12937e99$export$9f0a771d16ec8d36 = "#ABBBD6";
var $a5f58aaa12937e99$export$abcf8c38338b4aa5 = "#9FB0CC";
var $a5f58aaa12937e99$export$97e81faa16a182c7 = "#8C9CB8";
var $a5f58aaa12937e99$export$bfe21c59123ecf33 = "#7988A3";
var $a5f58aaa12937e99$export$ee82aa2ea6a1558 = "#67758F";
var $a5f58aaa12937e99$export$682927c6ed76be02 = "#56637A";
var $a5f58aaa12937e99$export$91fd9994c5be9757 = "#455166";
var $a5f58aaa12937e99$export$d281fbfe3cff2df6 = "#3B475C";
var $a5f58aaa12937e99$export$3902c91d8b98a753 = "#313D52";
var $a5f58aaa12937e99$export$8e8133c1ba5845b5 = "#283447";
var $a5f58aaa12937e99$export$33ff357f6620b39 = "#202B3D";
var $a5f58aaa12937e99$export$633847cf062b69e0 = "#1B2638";
var $a5f58aaa12937e99$export$9776a6e503bdbf76 = "#121A29";
var $a5f58aaa12937e99$export$6c813d5160dff5db = "#0E1624";
var $a5f58aaa12937e99$export$3d4f271a500072a = "#0D1424";
var $a5f58aaa12937e99$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $a5f58aaa12937e99$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $a5f58aaa12937e99$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $a5f58aaa12937e99$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $a5f58aaa12937e99$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $a5f58aaa12937e99$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $a5f58aaa12937e99$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $a5f58aaa12937e99$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $a5f58aaa12937e99$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $a5f58aaa12937e99$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $a5f58aaa12937e99$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $a5f58aaa12937e99$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $a5f58aaa12937e99$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $a5f58aaa12937e99$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $a5f58aaa12937e99$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $a5f58aaa12937e99$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $a5f58aaa12937e99$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $a5f58aaa12937e99$export$8ce1fd94bee2f412 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($a5f58aaa12937e99$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($a5f58aaa12937e99$export$633847cf062b69e0, ")")
});
var $a5f58aaa12937e99$export$b861914ea877b580 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($a5f58aaa12937e99$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($a5f58aaa12937e99$export$8c13c2ee36917869, ")")
});
var $a5f58aaa12937e99$export$3f1b020df94387af = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($a5f58aaa12937e99$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($a5f58aaa12937e99$export$d281fbfe3cff2df6, ")")
});
var $a5f58aaa12937e99$export$c0183dbab98ca63e = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($a5f58aaa12937e99$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($a5f58aaa12937e99$export$8e8133c1ba5845b5, ")")
});
var $a5f58aaa12937e99$export$6f093cfa640b7166 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($a5f58aaa12937e99$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($a5f58aaa12937e99$export$5368d76ae4fbbda7, ")")
});
var $a5f58aaa12937e99$export$42f8e9c698766e7a = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($a5f58aaa12937e99$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($a5f58aaa12937e99$export$5368d76ae4fbbda7, ")")
});
var $a5f58aaa12937e99$export$c2d157ca1c34b6e3 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($a5f58aaa12937e99$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($a5f58aaa12937e99$export$b3de0ae08da2ce64, ")")
});
var $a5f58aaa12937e99$export$1905ba28d7cf066f = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($a5f58aaa12937e99$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a5f58aaa12937e99$export$97e81faa16a182c7, ")")
});
var $a5f58aaa12937e99$export$bd9002130d306d39 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($a5f58aaa12937e99$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a5f58aaa12937e99$export$bfe21c59123ecf33, ")")
});
var $a5f58aaa12937e99$export$46e4a324ac90507f = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($a5f58aaa12937e99$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($a5f58aaa12937e99$export$5368d76ae4fbbda7, ")")
});
var $a5f58aaa12937e99$export$79f3f2b82beb0d36 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($a5f58aaa12937e99$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a5f58aaa12937e99$export$97e81faa16a182c7, ")")
});
var $a5f58aaa12937e99$export$7bb0d5c671655cc4 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$9fdfb749e33cdf97,
    dark: $a5f58aaa12937e99$export$8e8133c1ba5845b5
});
var $a5f58aaa12937e99$export$9c30223ca0a664fb = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($a5f58aaa12937e99$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($a5f58aaa12937e99$export$ecfc1dff386a3e7a, ")")
});
var $a5f58aaa12937e99$export$7ed258b0728b004b = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($a5f58aaa12937e99$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($a5f58aaa12937e99$export$215b7063051591f1, ")")
});
var $a5f58aaa12937e99$export$dfa920d8decc8a59 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($a5f58aaa12937e99$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($a5f58aaa12937e99$export$ecfc1dff386a3e7a, ")")
});
var $a5f58aaa12937e99$export$6069e6ad5c78f632 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($a5f58aaa12937e99$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($a5f58aaa12937e99$export$215b7063051591f1, ")")
});
var $a5f58aaa12937e99$export$9ad721cf3b3debe0 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($a5f58aaa12937e99$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($a5f58aaa12937e99$export$ecfc1dff386a3e7a, ")")
});
var $a5f58aaa12937e99$export$2aa0182783e7e9de = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$b3de0ae08da2ce64,
    dark: $a5f58aaa12937e99$export$ecfc1dff386a3e7a
});
var $a5f58aaa12937e99$export$8bf7dff220b82b4a = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$9dc1ef0f3f48059b,
    dark: $a5f58aaa12937e99$export$69cb3ca10c1e330e
});
var $a5f58aaa12937e99$export$e13cce2a2d16a9d4 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$b48405b95304b5a1,
    dark: $a5f58aaa12937e99$export$6011520a64d9a187
});
var $a5f58aaa12937e99$export$a90204d1394caf30 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$4a7404f376229999,
    dark: $a5f58aaa12937e99$export$4a7404f376229999
});
var $a5f58aaa12937e99$export$594c5a8758200c32 = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$c6930421db9fa514,
    dark: $a5f58aaa12937e99$export$c6930421db9fa514
});
var $a5f58aaa12937e99$export$955a2ebd2fb142ae = (0, $04c45a3f40248065$export$2e2bcd8739ae039)({
    light: $a5f58aaa12937e99$export$940e1f69e873f202,
    dark: $a5f58aaa12937e99$export$940e1f69e873f202
});
var $a5f58aaa12937e99$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($a5f58aaa12937e99$export$8d43898f60b96a82, ")");
};




var $g5Zhu = parcelRequire("g5Zhu");


function $c8885e011681ed45$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8885e011681ed45$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8885e011681ed45$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8885e011681ed45$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c8885e011681ed45$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $c8885e011681ed45$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $c8885e011681ed45$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $c8885e011681ed45$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h900.size, $c8885e011681ed45$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 6.5, "px")
    });
};
var $c8885e011681ed45$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h800.size, $c8885e011681ed45$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 5, "px")
    });
};
var $c8885e011681ed45$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h700.size, $c8885e011681ed45$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 5, "px")
    });
};
var $c8885e011681ed45$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h600.size, $c8885e011681ed45$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 3.5, "px")
    });
};
var $c8885e011681ed45$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h500.size, $c8885e011681ed45$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 3, "px")
    });
};
var $c8885e011681ed45$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h400.size, $c8885e011681ed45$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};
var $c8885e011681ed45$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h300.size, $c8885e011681ed45$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $a5f58aaa12937e99$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $c8885e011681ed45$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h200.size, $c8885e011681ed45$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $a5f58aaa12937e99$export$79f3f2b82beb0d36)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};
var $c8885e011681ed45$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $c8885e011681ed45$var$_objectSpread($c8885e011681ed45$var$_objectSpread({}, $c8885e011681ed45$var$baseHeading($c8885e011681ed45$export$bc02e067df412c3b.h100.size, $c8885e011681ed45$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $a5f58aaa12937e99$export$79f3f2b82beb0d36)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $486737e365f3c084$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};


var $fca5071e52876da9$var$fontFamily = (0, $486737e365f3c084$export$a5975749f0374264)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $fca5071e52876da9$var$fieldsetLabelStyles = (0, $jjlaj.css)([
    (0, $c8885e011681ed45$export$7ccf32eb2150ac7e)({
        theme: {
            mode: "light"
        }
    }),
    {
        display: "inline-block",
        marginTop: 0,
        marginBottom: "var(--ds-space-050, 4px)",
        color: "var(--ds-text-subtle, ".concat((0, $a5f58aaa12937e99$export$f563ee71e9ee74cd), ")"),
        fontFamily: $fca5071e52876da9$var$fontFamily
    }
]);
var $fca5071e52876da9$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return (0, $jjlaj.jsx)("label", {
        css: $fca5071e52876da9$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
};
var $fca5071e52876da9$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return (0, $jjlaj.jsx)("legend", {
        css: $fca5071e52876da9$var$fieldsetLabelStyles
    }, children);
};
var $fca5071e52876da9$export$2e2bcd8739ae039 = $fca5071e52876da9$export$b04be29aa201d4f5;


/** @jsx jsx */ 
var $jjlaj = parcelRequire("jjlaj");

var $07b930dcf3fef6be$var$requiredIndicatorStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-danger, ".concat((0, $a5f58aaa12937e99$export$2010d0fb4295b346), ")"),
    fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $07b930dcf3fef6be$export$2e2bcd8739ae039() {
    return (0, $jjlaj.jsx)("span", {
        css: $07b930dcf3fef6be$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}



var $hPtJY = parcelRequire("hPtJY");
function $5afe8b9e8d12362c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5afe8b9e8d12362c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5afe8b9e8d12362c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5afe8b9e8d12362c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5afe8b9e8d12362c$var$fieldWrapperStyles = (0, $jjlaj.css)({
    marginBlockStart: "var(--ds-space-100, 8px)"
});
function $5afe8b9e8d12362c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $5afe8b9e8d12362c$var$isFunction(x) {
    return typeof x === "function";
}
function $5afe8b9e8d12362c$var$usePreviousRef(current) {
    var ref = (0, $acw62.useRef)(current);
    // will be updated on the next render
    (0, $acw62.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $5afe8b9e8d12362c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === "function" && typeof currentValue === "function") return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(previousValue) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(currentValue) === "object") return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $5afe8b9e8d12362c$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _useContext = (0, $acw62.useContext)((0, $1273dc8eae8f1aca$export$c24727297075ec6a)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $acw62.useContext)((0, $1273dc8eae8f1aca$export$c17cf6b332a82dbc)) || props.isDisabled || false;
    var defaultValue = $5afe8b9e8d12362c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $5afe8b9e8d12362c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$5afe8b9e8d12362c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $acw62.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explictly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $5afe8b9e8d12362c$var$usePreviousRef(state);
    (0, $acw62.useEffect)(function() {
        typeof $hPtJY;
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $5afe8b9e8d12362c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($5afe8b9e8d12362c$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === "checkbox") {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var fieldId = (0, $acw62.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    function() {
        return props.id ? props.id : "".concat(props.name, "-").concat((0, $fd05be839c660684$export$e2a22331486dcca0)({
            id: props.name
        }));
    }, [
        props.id,
        props.name
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = "";
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $5afe8b9e8d12362c$var$_objectSpread($5afe8b9e8d12362c$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        "aria-invalid": state.error ? "true" : "false",
        "aria-describedby": getDescribedBy(),
        "aria-labelledby": "".concat(fieldId, "-label"),
        id: fieldId
    });
    return (0, $jjlaj.jsx)("div", {
        css: $5afe8b9e8d12362c$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && (0, $jjlaj.jsx)((0, $fca5071e52876da9$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && (0, $jjlaj.jsx)((0, $07b930dcf3fef6be$export$2e2bcd8739ae039), null), props.elementAfterLabel), (0, $jjlaj.jsx)((0, $6aef6ef376234231$export$3c4232819458a302).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

// Constantized to avoid a new object reference built every call
var $20f67900dc335877$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ var $20f67900dc335877$var$getSubscriptionHash = function getSubscriptionHash(subscriptionConfig) {
    var hash = "";
    for(var key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += "".concat(key, ":").concat(subscriptionConfig[key], "|");
    return hash;
};
var $20f67900dc335877$export$606f11b2eb45ecc6 = function useFormState() {
    var subscriptionConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $20f67900dc335877$var$defaultSubscriptionConfig;
    var _useContext = (0, $acw62.useContext)((0, $1273dc8eae8f1aca$export$c24727297075ec6a)), subscribe = _useContext.subscribe;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    /**
   * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
   * We avoid computing the hash if the subscription config has referential equality altogether.
   */ var subscriptionConfigHash = (0, $acw62.useMemo)(function() {
        return $20f67900dc335877$var$getSubscriptionHash(subscriptionConfig);
    }, [
        subscriptionConfig
    ]);
    /**
   * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
   * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
   * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
   */ var config = (0, $acw62.useMemo)(function() {
        return subscriptionConfig;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $acw62.useEffect)(function() {
        var unsubscribe = subscribe(function(formState) {
            setState(formState);
        }, config);
        return function() {
            return unsubscribe();
        };
    }, [
        subscribe,
        config
    ]);
    return state;
};




/* TextEditor.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");



const $a6f3b6a8ea1374eb$export$c79b9d6b4cc92af7 = ({ percentage: percentage })=>{
    const radius = 7;
    const viewBoxSize = 16;
    const getStrokeDashArray = ()=>{
        const circleCircumference = 2 * Math.PI * radius;
        const filledPercentage = percentage * circleCircumference;
        return `${filledPercentage} ${circleCircumference}`;
    };
    const strokeColor = percentage <= 1 ? "var(--ds-text-success)" : "var(--ds-text-danger)";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: viewBoxSize,
        height: viewBoxSize,
        viewBox: `0 0 ${viewBoxSize} ${viewBoxSize}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: viewBoxSize / 2,
                    cy: viewBoxSize / 2,
                    r: radius,
                    stroke: `${"var(--ds-border)"}`,
                    strokeWidth: "2",
                    fill: "transparent"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: viewBoxSize / 2,
                    cy: viewBoxSize / 2,
                    r: radius,
                    stroke: `${strokeColor}`,
                    strokeWidth: "2",
                    fill: "transparent",
                    strokeDasharray: getStrokeDashArray(),
                    transform: `rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`
                })
            ]
        })
    });
};



/* UnstyledButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 


var $acw62 = parcelRequire("acw62");
// This button will take any HTML button props
const $9403b4fac03971ab$var$unstyledButtonStyles = null;
const $9403b4fac03971ab$export$3167f6ecaaaa3457 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        ...props,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _11q7glyw _syaz1kw7 _19itglyw _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ect41q02"
        ]),
        children: props.children
    });
});
$9403b4fac03971ab$export$3167f6ecaaaa3457.displayName = "UnstyledButton";


/* AddLinkPopup.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $1b14a2bd3685fd20$var$_excluded = [
    "children"
];
function $1b14a2bd3685fd20$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $acw62.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $1b14a2bd3685fd20$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $acw62.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $acw62.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $5c933b2f483821de$var$_createTheme = (0, $1b14a2bd3685fd20$export$25d302a5b900a763)(function() {
    return {
        mode: "light"
    };
}), $5c933b2f483821de$var$Provider = $5c933b2f483821de$var$_createTheme.Provider, $5c933b2f483821de$var$Consumer = $5c933b2f483821de$var$_createTheme.Consumer, $5c933b2f483821de$export$7692396083754928 = $5c933b2f483821de$var$_createTheme.useTheme;
var $5c933b2f483821de$var$Theme = {
    Provider: $5c933b2f483821de$var$Provider,
    Consumer: $5c933b2f483821de$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c933b2f483821de$export$2e2bcd8739ae039 = $5c933b2f483821de$var$Theme;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");





var $24bdd66558946491$var$_ref, $24bdd66558946491$var$_process, $24bdd66558946491$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $24bdd66558946491$var$TESTS_MODE = ($24bdd66558946491$var$_ref = (globalThis === null || globalThis === void 0 || ($24bdd66558946491$var$_process = globalThis.process) === null || $24bdd66558946491$var$_process === void 0 || ($24bdd66558946491$var$_process = $24bdd66558946491$var$_process.env) === null || $24bdd66558946491$var$_process === void 0 ? void 0 : $24bdd66558946491$var$_process.JEST_WORKER_ID) !== undefined, $24bdd66558946491$var$_ref !== void 0) ? $24bdd66558946491$var$_ref : false;
var $24bdd66558946491$var$DEBUG_MODE = !$24bdd66558946491$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($24bdd66558946491$var$_process2 = globalThis.process) === null || $24bdd66558946491$var$_process2 === void 0 || ($24bdd66558946491$var$_process2 = $24bdd66558946491$var$_process2.env) === null || $24bdd66558946491$var$_process2 === void 0 ? void 0 : $24bdd66558946491$var$_process2.NODE_ENV) !== "production";
var $24bdd66558946491$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$24bdd66558946491$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $hPtJY = parcelRequire("hPtJY");
var $1b05d9d138c2d9f5$var$pkgName = "@atlaskit/platform-feature-flags";
var $1b05d9d138c2d9f5$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $1b05d9d138c2d9f5$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $1b05d9d138c2d9f5$var$ENV_ENABLE_PLATFORM_FF = $1b05d9d138c2d9f5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $1b05d9d138c2d9f5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $1b05d9d138c2d9f5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $1b05d9d138c2d9f5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $1b05d9d138c2d9f5$var$ENV_ENABLE_PLATFORM_FF || $1b05d9d138c2d9f5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $1b05d9d138c2d9f5$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $1b05d9d138c2d9f5$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$1b05d9d138c2d9f5$var$globalVar[$1b05d9d138c2d9f5$export$7e41b1b2bdee3f98] = $1b05d9d138c2d9f5$var$globalVar[$1b05d9d138c2d9f5$export$7e41b1b2bdee3f98] || $1b05d9d138c2d9f5$var$DEFAULT_PFF_GLOBAL;
function $1b05d9d138c2d9f5$export$f2b591175b3e424c(resolver) {
    $1b05d9d138c2d9f5$var$globalVar[$1b05d9d138c2d9f5$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $1b05d9d138c2d9f5$export$6333b6aff9fc6275(flagKey) {
    if ($1b05d9d138c2d9f5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $24bdd66558946491$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $1b05d9d138c2d9f5$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $1b05d9d138c2d9f5$var$globalVar[$1b05d9d138c2d9f5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $2a87f13bf47a100b$export$ba05d765b8392e5e(flagResolver) {
    (0, $1b05d9d138c2d9f5$export$f2b591175b3e424c)(flagResolver);
}
function $2a87f13bf47a100b$export$470e5c2be1411c89(name) {
    return (0, $1b05d9d138c2d9f5$export$6333b6aff9fc6275)(name);
}
function $2a87f13bf47a100b$export$b40ec24ac8275656(name) {
    return (0, $1b05d9d138c2d9f5$export$6333b6aff9fc6275)(name);
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 

var $3905396cdcbea3f4$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $3905396cdcbea3f4$export$c93026a968943f95 = "light";
var $3905396cdcbea3f4$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $3905396cdcbea3f4$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $3905396cdcbea3f4$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $3905396cdcbea3f4$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $3905396cdcbea3f4$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $3905396cdcbea3f4$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $3905396cdcbea3f4$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $3905396cdcbea3f4$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $b5931d75aa865c10$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3905396cdcbea3f4$export$6d8204c2cb2e06b8() / 4;
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $3905396cdcbea3f4$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $3905396cdcbea3f4$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $3905396cdcbea3f4$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $3905396cdcbea3f4$export$ba1d834b86d72a09 = $3905396cdcbea3f4$export$a1b3edb637fb4f35;
var $3905396cdcbea3f4$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $b5931d75aa865c10$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $b5931d75aa865c10$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $b5931d75aa865c10$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $002fc0392e649409$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $3905396cdcbea3f4$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $3905396cdcbea3f4$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $3905396cdcbea3f4$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $3905396cdcbea3f4$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $06e4014eaf591d8e$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $002fc0392e649409$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $06e4014eaf591d8e$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $06e4014eaf591d8e$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $002fc0392e649409$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $b5931d75aa865c10$export$4b84fd0e2c617bd = "#FFEBE6";
var $b5931d75aa865c10$export$b34b069eff244586 = "#FFBDAD";
var $b5931d75aa865c10$export$be802dd0d8b57f35 = "#FF8F73";
var $b5931d75aa865c10$export$60847d42f9da92a6 = "#FF7452";
var $b5931d75aa865c10$export$4a7404f376229999 = "#FF5630";
var $b5931d75aa865c10$export$2010d0fb4295b346 = "#DE350B";
var $b5931d75aa865c10$export$2837b5a1a71d5c02 = "#BF2600";
var $b5931d75aa865c10$export$8d9596b529bbb9cf = "#FFFAE6";
var $b5931d75aa865c10$export$41060a744ab0b7ae = "#FFF0B3";
var $b5931d75aa865c10$export$1cc05bbbf340e559 = "#FFE380";
var $b5931d75aa865c10$export$5aae31392d72caaa = "#FFC400";
var $b5931d75aa865c10$export$c6930421db9fa514 = "#FFAB00";
var $b5931d75aa865c10$export$59619663aa6500fb = "#FF991F";
var $b5931d75aa865c10$export$874739ea9e379ab6 = "#FF8B00";
var $b5931d75aa865c10$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $b5931d75aa865c10$export$69a3bf21b9686c2b = "#ABF5D1";
var $b5931d75aa865c10$export$afbce1382ec95f73 = "#79F2C0";
var $b5931d75aa865c10$export$747d86715d4175de = "#57D9A3";
var $b5931d75aa865c10$export$940e1f69e873f202 = "#36B37E";
var $b5931d75aa865c10$export$a49394138f7b8e85 = "#00875A";
var $b5931d75aa865c10$export$6fa04827ac68a4fb = "#006644";
var $b5931d75aa865c10$export$226de0355ed012f8 = "#DEEBFF";
var $b5931d75aa865c10$export$8c13c2ee36917869 = "#B3D4FF";
var $b5931d75aa865c10$export$ecfc1dff386a3e7a = "#4C9AFF";
var $b5931d75aa865c10$export$215b7063051591f1 = "#2684FF";
var $b5931d75aa865c10$export$e62e8919cca44969 = "#0065FF";
var $b5931d75aa865c10$export$b3de0ae08da2ce64 = "#0052CC";
var $b5931d75aa865c10$export$a6ee3d71bc067634 = "#0747A6";
var $b5931d75aa865c10$export$363e4475840015bb = "#EAE6FF";
var $b5931d75aa865c10$export$4b0a4417ed59760f = "#C0B6F2";
var $b5931d75aa865c10$export$6011520a64d9a187 = "#998DD9";
var $b5931d75aa865c10$export$a7175d4e9206bc80 = "#8777D9";
var $b5931d75aa865c10$export$b48405b95304b5a1 = "#6554C0";
var $b5931d75aa865c10$export$c71e4279dd54a18d = "#5243AA";
var $b5931d75aa865c10$export$147899de772240ec = "#403294";
var $b5931d75aa865c10$export$2cf711fe14c66f06 = "#E6FCFF";
var $b5931d75aa865c10$export$7a8f4d33f6f9772c = "#B3F5FF";
var $b5931d75aa865c10$export$776c9c497ef08533 = "#79E2F2";
var $b5931d75aa865c10$export$69cb3ca10c1e330e = "#00C7E6";
var $b5931d75aa865c10$export$9dc1ef0f3f48059b = "#00B8D9";
var $b5931d75aa865c10$export$7c835c78b6fcdef8 = "#00A3BF";
var $b5931d75aa865c10$export$6036577f95c3877e = "#008DA6";
var $b5931d75aa865c10$export$29a4f05edc054374 = "#FFFFFF";
var $b5931d75aa865c10$export$e655ef011c4aa1a2 = "#FAFBFC";
var $b5931d75aa865c10$export$9fdfb749e33cdf97 = "#F4F5F7";
var $b5931d75aa865c10$export$3e51e8f1440314ba = "#EBECF0";
var $b5931d75aa865c10$export$1ce2d1575d444ceb = "#DFE1E6";
var $b5931d75aa865c10$export$8754fc7e6d8b3000 = "#C1C7D0";
var $b5931d75aa865c10$export$c2e91cbeada39b8b = "#B3BAC5";
var $b5931d75aa865c10$export$5f71e19f3a7ad9de = "#A5ADBA";
var $b5931d75aa865c10$export$eaa8c8a70ac22806 = "#97A0AF";
var $b5931d75aa865c10$export$7c87d337fb91a97d = "#8993A4";
var $b5931d75aa865c10$export$d6447c357493214f = "#7A869A";
var $b5931d75aa865c10$export$f563ee71e9ee74cd = "#6B778C";
var $b5931d75aa865c10$export$e2ef2124cf4024b1 = "#5E6C84";
var $b5931d75aa865c10$export$eece5f492e429f08 = "#505F79";
var $b5931d75aa865c10$export$c39c0fe0f26207ae = "#42526E";
var $b5931d75aa865c10$export$7090862dc3038a9f = "#344563";
var $b5931d75aa865c10$export$ad0bacf983b7ddaa = "#253858";
var $b5931d75aa865c10$export$7d61b15e0da132af = "#172B4D";
var $b5931d75aa865c10$export$fbda843f0a27fe96 = "#091E42";
var $b5931d75aa865c10$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $b5931d75aa865c10$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $b5931d75aa865c10$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $b5931d75aa865c10$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $b5931d75aa865c10$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $b5931d75aa865c10$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $b5931d75aa865c10$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $b5931d75aa865c10$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $b5931d75aa865c10$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $b5931d75aa865c10$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $b5931d75aa865c10$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $b5931d75aa865c10$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $b5931d75aa865c10$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $b5931d75aa865c10$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $b5931d75aa865c10$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $b5931d75aa865c10$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $b5931d75aa865c10$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $b5931d75aa865c10$export$2f6319cf7d736c2a = "#E6EDFA";
var $b5931d75aa865c10$export$95126bc8884d6634 = "#DCE5F5";
var $b5931d75aa865c10$export$8338d8c35d44ff1 = "#CED9EB";
var $b5931d75aa865c10$export$5368d76ae4fbbda7 = "#B8C7E0";
var $b5931d75aa865c10$export$9f0a771d16ec8d36 = "#ABBBD6";
var $b5931d75aa865c10$export$abcf8c38338b4aa5 = "#9FB0CC";
var $b5931d75aa865c10$export$97e81faa16a182c7 = "#8C9CB8";
var $b5931d75aa865c10$export$bfe21c59123ecf33 = "#7988A3";
var $b5931d75aa865c10$export$ee82aa2ea6a1558 = "#67758F";
var $b5931d75aa865c10$export$682927c6ed76be02 = "#56637A";
var $b5931d75aa865c10$export$91fd9994c5be9757 = "#455166";
var $b5931d75aa865c10$export$d281fbfe3cff2df6 = "#3B475C";
var $b5931d75aa865c10$export$3902c91d8b98a753 = "#313D52";
var $b5931d75aa865c10$export$8e8133c1ba5845b5 = "#283447";
var $b5931d75aa865c10$export$33ff357f6620b39 = "#202B3D";
var $b5931d75aa865c10$export$633847cf062b69e0 = "#1B2638";
var $b5931d75aa865c10$export$9776a6e503bdbf76 = "#121A29";
var $b5931d75aa865c10$export$6c813d5160dff5db = "#0E1624";
var $b5931d75aa865c10$export$3d4f271a500072a = "#0D1424";
var $b5931d75aa865c10$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $b5931d75aa865c10$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $b5931d75aa865c10$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $b5931d75aa865c10$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $b5931d75aa865c10$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $b5931d75aa865c10$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $b5931d75aa865c10$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $b5931d75aa865c10$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $b5931d75aa865c10$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $b5931d75aa865c10$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $b5931d75aa865c10$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $b5931d75aa865c10$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $b5931d75aa865c10$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $b5931d75aa865c10$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $b5931d75aa865c10$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $b5931d75aa865c10$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $b5931d75aa865c10$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $b5931d75aa865c10$export$8ce1fd94bee2f412 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($b5931d75aa865c10$export$633847cf062b69e0, ")")
});
var $b5931d75aa865c10$export$b861914ea877b580 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$8c13c2ee36917869, ")")
});
var $b5931d75aa865c10$export$3f1b020df94387af = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($b5931d75aa865c10$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($b5931d75aa865c10$export$d281fbfe3cff2df6, ")")
});
var $b5931d75aa865c10$export$c0183dbab98ca63e = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($b5931d75aa865c10$export$8e8133c1ba5845b5, ")")
});
var $b5931d75aa865c10$export$6f093cfa640b7166 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($b5931d75aa865c10$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$5368d76ae4fbbda7, ")")
});
var $b5931d75aa865c10$export$42f8e9c698766e7a = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$5368d76ae4fbbda7, ")")
});
var $b5931d75aa865c10$export$c2d157ca1c34b6e3 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")")
});
var $b5931d75aa865c10$export$1905ba28d7cf066f = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($b5931d75aa865c10$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($b5931d75aa865c10$export$97e81faa16a182c7, ")")
});
var $b5931d75aa865c10$export$bd9002130d306d39 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($b5931d75aa865c10$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($b5931d75aa865c10$export$bfe21c59123ecf33, ")")
});
var $b5931d75aa865c10$export$46e4a324ac90507f = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$5368d76ae4fbbda7, ")")
});
var $b5931d75aa865c10$export$79f3f2b82beb0d36 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($b5931d75aa865c10$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($b5931d75aa865c10$export$97e81faa16a182c7, ")")
});
var $b5931d75aa865c10$export$7bb0d5c671655cc4 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$9fdfb749e33cdf97,
    dark: $b5931d75aa865c10$export$8e8133c1ba5845b5
});
var $b5931d75aa865c10$export$9c30223ca0a664fb = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($b5931d75aa865c10$export$ecfc1dff386a3e7a, ")")
});
var $b5931d75aa865c10$export$7ed258b0728b004b = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($b5931d75aa865c10$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($b5931d75aa865c10$export$215b7063051591f1, ")")
});
var $b5931d75aa865c10$export$dfa920d8decc8a59 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($b5931d75aa865c10$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($b5931d75aa865c10$export$ecfc1dff386a3e7a, ")")
});
var $b5931d75aa865c10$export$6069e6ad5c78f632 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($b5931d75aa865c10$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($b5931d75aa865c10$export$215b7063051591f1, ")")
});
var $b5931d75aa865c10$export$9ad721cf3b3debe0 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($b5931d75aa865c10$export$ecfc1dff386a3e7a, ")")
});
var $b5931d75aa865c10$export$2aa0182783e7e9de = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$b3de0ae08da2ce64,
    dark: $b5931d75aa865c10$export$ecfc1dff386a3e7a
});
var $b5931d75aa865c10$export$8bf7dff220b82b4a = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$9dc1ef0f3f48059b,
    dark: $b5931d75aa865c10$export$69cb3ca10c1e330e
});
var $b5931d75aa865c10$export$e13cce2a2d16a9d4 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$b48405b95304b5a1,
    dark: $b5931d75aa865c10$export$6011520a64d9a187
});
var $b5931d75aa865c10$export$a90204d1394caf30 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$4a7404f376229999,
    dark: $b5931d75aa865c10$export$4a7404f376229999
});
var $b5931d75aa865c10$export$594c5a8758200c32 = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$c6930421db9fa514,
    dark: $b5931d75aa865c10$export$c6930421db9fa514
});
var $b5931d75aa865c10$export$955a2ebd2fb142ae = (0, $06e4014eaf591d8e$export$2e2bcd8739ae039)({
    light: $b5931d75aa865c10$export$940e1f69e873f202,
    dark: $b5931d75aa865c10$export$940e1f69e873f202
});
var $b5931d75aa865c10$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($b5931d75aa865c10$export$8d43898f60b96a82, ")");
};


function $78777a3643a439ce$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $78777a3643a439ce$var$tabKeyCode = 9;
function $78777a3643a439ce$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $78777a3643a439ce$var$tabKeyCode) return;
    $78777a3643a439ce$var$abort(event);
}
var $78777a3643a439ce$var$block = {
    onMouseDownCapture: $78777a3643a439ce$var$abort,
    onMouseUpCapture: $78777a3643a439ce$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $78777a3643a439ce$var$onKey,
    onKeyUpCapture: $78777a3643a439ce$var$onKey,
    onTouchStartCapture: $78777a3643a439ce$var$abort,
    onTouchEndCapture: $78777a3643a439ce$var$abort,
    onPointerDownCapture: $78777a3643a439ce$var$abort,
    onPointerUpCapture: $78777a3643a439ce$var$abort,
    onClickCapture: $78777a3643a439ce$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $78777a3643a439ce$var$abort
};
var $78777a3643a439ce$var$doNotBlock = {};
function $78777a3643a439ce$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $78777a3643a439ce$var$doNotBlock : $78777a3643a439ce$var$block;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");


// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $93899cb209aae547$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $93899cb209aae547$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($b5931d75aa865c10$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($b5931d75aa865c10$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($b5931d75aa865c10$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($b5931d75aa865c10$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($93899cb209aae547$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($b5931d75aa865c10$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($b5931d75aa865c10$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($b5931d75aa865c10$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($b5931d75aa865c10$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($b5931d75aa865c10$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($b5931d75aa865c10$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($b5931d75aa865c10$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($b5931d75aa865c10$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($b5931d75aa865c10$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($b5931d75aa865c10$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($b5931d75aa865c10$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($b5931d75aa865c10$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($b5931d75aa865c10$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($b5931d75aa865c10$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($b5931d75aa865c10$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($b5931d75aa865c10$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($b5931d75aa865c10$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($b5931d75aa865c10$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($b5931d75aa865c10$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($b5931d75aa865c10$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($b5931d75aa865c10$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($93899cb209aae547$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($b5931d75aa865c10$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$3d4f271a500072a, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($b5931d75aa865c10$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($b5931d75aa865c10$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($b5931d75aa865c10$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($b5931d75aa865c10$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($b5931d75aa865c10$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($b5931d75aa865c10$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($b5931d75aa865c10$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($b5931d75aa865c10$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($b5931d75aa865c10$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($b5931d75aa865c10$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($b5931d75aa865c10$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($b5931d75aa865c10$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($b5931d75aa865c10$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($b5931d75aa865c10$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($b5931d75aa865c10$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $93899cb209aae547$export$2e2bcd8739ae039 = $93899cb209aae547$var$values;


function $6f444228c2c7eea6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f444228c2c7eea6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f444228c2c7eea6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f444228c2c7eea6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f444228c2c7eea6$var$gridSize = (0, $3905396cdcbea3f4$export$6d8204c2cb2e06b8)();
var $6f444228c2c7eea6$var$fontSize = (0, $3905396cdcbea3f4$export$85e3c3ca0c6fb93)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $6f444228c2c7eea6$var$heights = {
    default: "".concat($6f444228c2c7eea6$var$gridSize * 4 / $6f444228c2c7eea6$var$fontSize, "em"),
    // 32px
    compact: "".concat($6f444228c2c7eea6$var$gridSize * 3 / $6f444228c2c7eea6$var$fontSize, "em"),
    none: "auto"
};
var $6f444228c2c7eea6$var$lineHeights = {
    default: $6f444228c2c7eea6$var$heights.default,
    compact: $6f444228c2c7eea6$var$heights.compact,
    none: "inherit"
};
var $6f444228c2c7eea6$var$padding = {
    // 10px gutter
    default: "0 ".concat($6f444228c2c7eea6$var$gridSize + $6f444228c2c7eea6$var$gridSize / 4, "px"),
    compact: "0 ".concat($6f444228c2c7eea6$var$gridSize + $6f444228c2c7eea6$var$gridSize / 4, "px"),
    none: "0"
};
var $6f444228c2c7eea6$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px"),
    default: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px"),
    none: "0"
};
var $6f444228c2c7eea6$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $6f444228c2c7eea6$var$innerMargin = {
    content: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px"),
    icon: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px")
};
function $6f444228c2c7eea6$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $6f444228c2c7eea6$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $6f444228c2c7eea6$var$getColor({
            group: (0, $93899cb209aae547$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($6f444228c2c7eea6$var$getColor({
            group: (0, $93899cb209aae547$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $6f444228c2c7eea6$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $6f444228c2c7eea6$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $6f444228c2c7eea6$var$heights[spacing],
        lineHeight: $6f444228c2c7eea6$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $6f444228c2c7eea6$var$singleIconPadding[spacing] : $6f444228c2c7eea6$var$padding[spacing],
        verticalAlign: $6f444228c2c7eea6$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $6f444228c2c7eea6$var$_objectSpread({}, baseColors),
        "&:hover": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $6f444228c2c7eea6$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jjlaj.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $6f444228c2c7eea6$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $6f444228c2c7eea6$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $6f444228c2c7eea6$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $6f444228c2c7eea6$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jjlaj.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $6f444228c2c7eea6$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $acw62 = parcelRequire("acw62");

var $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $acw62.isValidElement)(children) && children.type === (0, $8568069ac023c6f7$export$2e2bcd8739ae039);
};


var $18e2b6fea76e317b$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $18e2b6fea76e317b$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $18e2b6fea76e317b$var$iconBeforeSpacingFixStyle = (0, $jjlaj.css)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $18e2b6fea76e317b$var$iconAfterSpacingFixStyle = (0, $jjlaj.css)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
var $18e2b6fea76e317b$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!(0, $2a87f13bf47a100b$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") || !children || (0, $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $18e2b6fea76e317b$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $jjlaj.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $18e2b6fea76e317b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $18e2b6fea76e317b$var$_excluded);
    var ourRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $3f80dbe144e57bfc$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $acw62.useContext)((0, $0c27aa7a20d367fb$export$2e2bcd8739ae039));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $jjlaj.css)((0, $6f444228c2c7eea6$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $b5931d75aa865c10$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $b5931d75aa865c10$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $18e2b6fea76e317b$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $78777a3643a439ce$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            (0, $6f444228c2c7eea6$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $18e2b6fea76e317b$var$getSpacingFix(children, $18e2b6fea76e317b$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $2a87f13bf47a100b$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && children ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            (0, $6f444228c2c7eea6$export$7ad0316cc0dd65a)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $2a87f13bf47a100b$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && $18e2b6fea76e317b$var$getChildren(children, [
        fadeStyles,
        (0, $6f444228c2c7eea6$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            (0, $6f444228c2c7eea6$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $18e2b6fea76e317b$var$getSpacingFix(children, $18e2b6fea76e317b$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jjlaj.jsx)("span", {
        css: [
            (0, $6f444228c2c7eea6$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});





function $e5b38769158951a0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $2a87f13bf47a100b$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && (0, $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $b68af4c645c75ad0$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $b68af4c645c75ad0$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $b68af4c645c75ad0$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b68af4c645c75ad0$var$_excluded);
    var _useGlobalTheme = (0, $5c933b2f483821de$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $e5b38769158951a0$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($b68af4c645c75ad0$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $acw62.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($b68af4c645c75ad0$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $acw62.useMemo)(function() {
        return (0, $6f444228c2c7eea6$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18e2b6fea76e317b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$b68af4c645c75ad0$var$Button.displayName = "Button";
var $b68af4c645c75ad0$export$2e2bcd8739ae039 = $b68af4c645c75ad0$var$Button;





const $c53f55cd8afa3f62$export$480eefc01de43ac9 = ({ editor: editor, onSubmitForm: onSubmitForm, onCancel: onCancel, selectedText: selectedText, selectedLink: selectedLink })=>{
    const [link, setLink] = (0, $acw62.useState)(selectedLink ?? "");
    const [text, setText] = (0, $acw62.useState)(selectedText ?? "");
    const [validLink, setValidLink] = (0, $acw62.useState)(true);
    // Sometimes, the editor hasn't updated when this component is created
    // So we need to update the link and text if the props change
    (0, $acw62.useEffect)(()=>{
        setLink(selectedLink ?? "");
        setText(selectedText ?? "");
        return ()=>{
            setLink("");
            setText("");
            setValidLink(true);
        };
    }, [
        selectedLink,
        selectedText
    ]);
    const onChangeLink = (e)=>{
        setValidLink(true);
        setLink(e.currentTarget.value);
    };
    const onSubmit = ()=>{
        if (link && !(0, $11b44da27d1a9b8a$export$bef94a5618bf18bf)(link)) {
            setValidLink(false);
            // Not sure if this is necessary but if there are errors,
            // this will show the red border around the input element instead of remaining foucsed
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
            return;
        }
        onSubmitForm(editor, link, text);
    };
    const onKeyDown = (e)=>{
        if (e.key === "Enter") onSubmitForm(editor, link, text);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        onKeyDown: onKeyDown,
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsbnklw _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rko1eps _16qs6ota _bfhku67f _19it7v06"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _2lx21bp4 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                            isRequired: false,
                            labelText: "Add a link"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                            value: link,
                            onChange: onChangeLink,
                            placeholder: "Add a new link",
                            isInvalid: !validLink
                        }),
                        !validLink && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                            type: "error",
                            message: "Please enter a valid link"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                            isRequired: false,
                            labelText: "Display text"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                            value: text,
                            onChange: (e)=>{
                                setText(e.currentTarget.value);
                            },
                            placeholder: "Display text"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _1bahesu3 _1wyb7vkz _zulpftgi"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9403b4fac03971ab$export$3167f6ecaaaa3457), {
                            onClick: onCancel,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1yt41dzv"
                                ]),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_syaz1jwt _1wyb7vkz"
                                    ]),
                                    children: "Cancel"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b68af4c645c75ad0$export$2e2bcd8739ae039), {
                            onClick: onSubmit,
                            appearance: "primary",
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
};
const $c53f55cd8afa3f62$var$popupStyles = null;
const $c53f55cd8afa3f62$var$flexColumn = null;
const $c53f55cd8afa3f62$var$addLinkButtonsStyles = null;
const $c53f55cd8afa3f62$var$cancelContainerStyles = null;
const $c53f55cd8afa3f62$var$cancelTextStyles = null;



// Should move this to some constants file
// Not sure where though
const $5921ba59f371d157$var$CHARACTER_LIMIT = 200;
const $5921ba59f371d157$export$3e10f1206980ab22 = ({ changeHandler: changeHandler, defaultValue: defaultValue, isInvalid: isInvalid })=>{
    const editor = (0, $526f4c9d45be0f0e$export$a43430dbd5ca5abe)(changeHandler, defaultValue);
    const [isAddingLink, setIsAddingLink] = (0, $acw62.useState)(false);
    const [buttonRef, setButtonRef] = (0, $acw62.useState)();
    /**
   * @param editor Editor
   * @param {string} link URL to be added to the text
   * @param {string} displayText Text to be displayed
   * @description This function replaces or adds some display text
   * and sets a link on this text.
   * It will also handle cases where there is no link or display text.
   */ const setLink = (editor, link, displayText)=>{
        let selection = editor.view.state.selection;
        if (editor.isActive("editorLink")) selection = selectLink(editor);
        if (!link) {
            // No link, only display text
            if (displayText) {
                editor.commands.unsetLink();
                editor.commands.focus(selection.to);
                return;
            } else {
                editor.commands.deleteSelection();
                editor.commands.focus(selection.from);
                return;
            }
        }
        // No display text, only link
        if (!displayText) {
            editor.commands.insertContentAt({
                from: selection.from,
                to: selection.to
            }, link && `<a href="${link}">${link}</a>`);
            editor.commands.focus(selection.to + link.length);
            return;
        }
        editor.commands.insertContentAt({
            from: selection.from,
            to: selection.to
        }, link ? `<a href="${link}">${displayText}</a>` : displayText);
        editor.commands.focus(selection.to);
    };
    /**
   *
   * @param editor Editor
   * @returns {string} Selected link
   * @description This function selects a link under the cursor
   * and returns the selected link.
   */ const selectLink = (editor)=>{
        editor.chain().focus().extendMarkRange("editorLink").run();
        return editor.view.state.selection;
    };
    /**
   *
   * @param editor Editor
   * @returns {string} Selected text
   * @description This function returns the selected text
   * in the editor.
   */ const getSelection = (editor)=>{
        const { view: view, state: state } = editor;
        const { from: from, to: to } = view.state.selection;
        return state.doc.textBetween(from, to, "");
    };
    /**
   *
   * @param editor Editor
   * @returns {string} Link
   * @description This function returns the active link in the editor.
   */ const getLink = (editor)=>{
        const link = editor.getAttributes("editorLink").href;
        return link;
    };
    /**
   *
   * @param editor Editor
   * @returns {string} Display text
   * @description This function returns the display text
   * of the active link in the editor.
   * If the cursor is in the linked text, but no text is selected,
   * it will still return the linked text.
   */ const getDisplayTextFromLink = (editor)=>{
        let selection = getSelection(editor);
        if (selection) return selection;
        const { state: state } = editor;
        const { $from: $from, $to: $to } = state.selection;
        const before = $from.nodeBefore ? $from.nodeBefore.textContent : "";
        const after = $to.nodeAfter ? $to.nodeAfter.textContent : "";
        selection = before + after;
        return selection;
    };
    /**
   *
   * @param editor Editor
   * @returns {boolean} True if the button should be disabled
   * @description This function checks if the add link button should be disabled.
   * We disable the button if a link is active in the editor.
   * This prevents adding a link to an existing link.
   */ const buttonIsDisabled = (editor)=>{
        if (!buttonRef) return true;
        // When you click on the button, the editor loses focus
        // This causes the button's onClick callback to not fire
        // So only disable the button if the button is not focused
        if (!editor.isFocused && document.activeElement !== buttonRef) return true;
        return !!getLink(editor);
    };
    /**
   *
   * @param e React.MouseEvent<HTMLElement>
   * @description This function sets the isAddingLink state to true to enable the BubbleMenu.
   */ const handleAddLink = (e)=>{
        e.preventDefault();
        setIsAddingLink(true);
    };
    // This is necessary to get the position of the bubble menu when no text is selected
    /**
   *
   * @param editor Editor
   * @returns {DOMRect} Position to render the bubble menu
   * @description This function returns the position to render the bubble menu.
   * Normally, this would be handled automatically, but we need to handle the case
   * when no text is selected.
   */ const getPosition = (editor)=>{
        if (getSelection(editor)) return (0, $aceda74b73705131$export$660ecae6cde71645)(editor.view, editor.view.state.selection.from, editor.view.state.selection.to);
        return (0, $aceda74b73705131$export$660ecae6cde71645)(editor.view, editor.view.state.selection.from, editor.view.state.selection.from);
    };
    const onSubmitLink = (editor, link, displayText)=>{
        setLink(editor, link, displayText);
        setIsAddingLink(false);
        editor.commands.focus("end");
    };
    const onCancel = (e)=>{
        e.preventDefault();
        editor && editor.commands.focus("end");
        setIsAddingLink(false);
    };
    const onHideBubbleMenu = ()=>{
        setIsAddingLink(false);
        buttonRef?.blur();
    };
    const shouldShowBubbleMenu = ()=>{
        return isAddingLink;
    };
    const shouldShowFloatingMenu = (editor)=>{
        return editor.isActive("editorLink") || false;
    };
    if (!editor) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_19it1wy5 _2rko1y44 _14dp1n1a _110y1n1a _lh7h1n1a _wmvc1n1a _6gnp4suz",
            isInvalid && "_19itmjui _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a"
        ]),
        children: [
            buttonRef && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5acb492c1fc680b7$export$79c1bf6a55bce827), {
                editor: editor,
                shouldShow: shouldShowBubbleMenu,
                tippyOptions: {
                    duration: 200,
                    placement: "auto",
                    trigger: "click",
                    triggerTarget: buttonRef,
                    getReferenceClientRect: ()=>getPosition(editor),
                    onClickOutside: ()=>onHideBubbleMenu()
                },
                children: isAddingLink && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c53f55cd8afa3f62$export$480eefc01de43ac9), {
                    editor: editor,
                    onSubmitForm: onSubmitLink,
                    onCancel: onCancel,
                    selectedLink: getLink(editor),
                    selectedText: getSelection(editor)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5acb492c1fc680b7$export$695cda69e78edecd), {
                editor: editor,
                shouldShow: ()=>shouldShowFloatingMenu(editor),
                tippyOptions: {
                    duration: 0,
                    placement: "auto",
                    onClickOutside: ()=>onHideBubbleMenu()
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c53f55cd8afa3f62$export$480eefc01de43ac9), {
                    editor: editor,
                    onSubmitForm: onSubmitLink,
                    onCancel: onCancel,
                    selectedLink: getLink(editor),
                    selectedText: getDisplayTextFromLink(editor)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _1wjo1et3 _1q8t1tcg _7mte1osq _j1x21v9d _1nqy7vkz _wqno1r31 _wqd9glyw _jl7o1o36 _c6lqglyw _wqnoglyw"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5acb492c1fc680b7$export$a92c4e92ed722350), {
                    editor: editor
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_x3do7v06 _4t3i1ylp _1e0c1txw _4cvr1h6o _1bahesu3 _ca0q19bv _n3td19bv _u5f37vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _1yt41t1g _4cvr1h6o _1s7z7v06 _2hwxoxav"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_2hwx1oug _ect41v9d _syaz1jij"
                                ]),
                                children: `${editor.storage.characterCount.characters()}/${$5921ba59f371d157$var$CHARACTER_LIMIT}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6f3b6a8ea1374eb$export$c79b9d6b4cc92af7), {
                                percentage: editor.storage.characterCount.characters() / $5921ba59f371d157$var$CHARACTER_LIMIT
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9403b4fac03971ab$export$3167f6ecaaaa3457), {
                        onClick: handleAddLink,
                        disabled: buttonIsDisabled(editor),
                        ref: (buttonRef)=>setButtonRef(buttonRef),
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_1e0c1txw _4cvr1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _11q7glyw _syaz1kw7 _19itglyw _1yt41ki8 _80omtlke",
                            buttonIsDisabled(editor) && "_lcxvglyw"
                        ]),
                        children: [
                            buttonIsDisabled(editor) || isAddingLink ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6c9c4bf79e4b0623$exports))),
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_2hwx1y44 _1bsb1tcg _4t3i1tcg _syaz1izd"
                                ])
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3d3dc7339317df4e$exports))),
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_2hwx1y44 _1bsb1tcg _4t3i1tcg _syaz1izd"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1jwt",
                                    buttonIsDisabled(editor) && "_syazdqsh",
                                    isAddingLink && "_syazdqsh"
                                ]),
                                children: "Add a link"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $5921ba59f371d157$var$containerStyles = null;
const $5921ba59f371d157$var$invalidStyles = null;
const $5921ba59f371d157$var$editorContainerStyles = null;
const $5921ba59f371d157$var$toolbarStyles = null;
const $5921ba59f371d157$var$characterProgressStyles = null;
const $5921ba59f371d157$var$characterCountTextStyles = null;
const $5921ba59f371d157$var$unstyledButtonStyles = null;
const $5921ba59f371d157$var$disabledButtonStyles = null;
const $5921ba59f371d157$var$addLinkIconStyles = null;
const $5921ba59f371d157$var$addLinkTextStyles = null;
const $5921ba59f371d157$var$disabledLinkTextStyles = null;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");
var $bec19d42af2a32fb$export$4ef52930e33717cd = "data-theme";
var $bec19d42af2a32fb$export$a00eac3f8684bcd0 = "data-color-mode";
var $bec19d42af2a32fb$export$2112803007239c61 = "data-contrast-mode";
var $bec19d42af2a32fb$export$352e418ed5b6193a = "data-custom-theme";
var $bec19d42af2a32fb$export$2faeed762aac6741 = "light";
var $bec19d42af2a32fb$export$6f0c6fb8c80fcc92 = "ds";
var $bec19d42af2a32fb$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $bec19d42af2a32fb$export$dddac1532e822863 = "--".concat($bec19d42af2a32fb$export$6f0c6fb8c80fcc92, "-token-not-found");
var $bec19d42af2a32fb$export$9d7b58831ae93caa = "--".concat($bec19d42af2a32fb$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $bcbfa6eabcc99f23$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bcbfa6eabcc99f23$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bcbfa6eabcc99f23$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bcbfa6eabcc99f23$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bcbfa6eabcc99f23$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $bcbfa6eabcc99f23$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $bcbfa6eabcc99f23$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $bcbfa6eabcc99f23$export$632685d741f3dbbf = $bcbfa6eabcc99f23$var$_objectSpread($bcbfa6eabcc99f23$var$_objectSpread({}, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4), $bcbfa6eabcc99f23$export$d2dc61f58390201c);
var $bcbfa6eabcc99f23$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $bcbfa6eabcc99f23$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $bcbfa6eabcc99f23$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $bcbfa6eabcc99f23$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $bcbfa6eabcc99f23$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $bcbfa6eabcc99f23$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $bcbfa6eabcc99f23$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $bcbfa6eabcc99f23$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $bcbfa6eabcc99f23$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $bcbfa6eabcc99f23$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $bcbfa6eabcc99f23$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $bcbfa6eabcc99f23$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $bcbfa6eabcc99f23$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $bcbfa6eabcc99f23$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $bcbfa6eabcc99f23$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $bcbfa6eabcc99f23$export$e615f061ca585a6c = $bcbfa6eabcc99f23$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $bcbfa6eabcc99f23$var$getSerializedStylesMap(spacingProperty, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f = $bcbfa6eabcc99f23$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $bcbfa6eabcc99f23$var$getSerializedStylesMap(spacingProperty, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $bcbfa6eabcc99f23$export$e7af83bafe7f9e63 = $bcbfa6eabcc99f23$var$getSerializedStylesMap("backgroundColor", $bcbfa6eabcc99f23$export$d1d79bf68ac056bd);
var $bcbfa6eabcc99f23$export$3a1bcba60b23d7f0 = $bcbfa6eabcc99f23$var$getSerializedStylesMap("color", $bcbfa6eabcc99f23$export$8473307aa00d6ea1);
var $bcbfa6eabcc99f23$export$45f3f4fe16f9f7d5 = $bcbfa6eabcc99f23$var$getSerializedStylesMap("fontWeight", $bcbfa6eabcc99f23$export$303e322c6b1ed114);
var $bcbfa6eabcc99f23$export$68cc305da27dbaa4 = $bcbfa6eabcc99f23$var$getSerializedStylesMap("fontFamily", $bcbfa6eabcc99f23$export$3c7e9587132614b4);
var $bcbfa6eabcc99f23$export$128f10c238242f83 = $bcbfa6eabcc99f23$var$getSerializedStylesMap("font", $bcbfa6eabcc99f23$export$6cc560b4dedf3816);
var $bcbfa6eabcc99f23$export$ff257d957d48c421 = $bcbfa6eabcc99f23$var$getSerializedStylesMap((0, $bec19d42af2a32fb$export$9d7b58831ae93caa), $bcbfa6eabcc99f23$export$41a358c9c2356760);
var $bcbfa6eabcc99f23$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $bcbfa6eabcc99f23$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $jjlaj = parcelRequire("jjlaj");


var $hPtJY = parcelRequire("hPtJY");
function $d8fb25f1eb78afec$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d8fb25f1eb78afec$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d8fb25f1eb78afec$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d8fb25f1eb78afec$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d8fb25f1eb78afec$var$_arrayLikeToArray(o, minLen);
}
function $d8fb25f1eb78afec$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d8fb25f1eb78afec$export$9a199fbafee0014e = {
    backgroundColor: (0, $bcbfa6eabcc99f23$export$d1d79bf68ac056bd),
    blockSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderBottomColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderLeftColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    bottom: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    boxShadow: (0, $bcbfa6eabcc99f23$export$7aff6e7ba39bb774),
    color: (0, $bcbfa6eabcc99f23$export$8473307aa00d6ea1),
    columnGap: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    gap: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    height: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    inlineSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    inset: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetBlock: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetBlockEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetBlockStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetInline: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetInlineEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetInlineStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    left: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    margin: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBlock: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBlockEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBlockStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBottom: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginInline: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginInlineEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginInlineStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginLeft: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginRight: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginTop: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    maxBlockSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    maxHeight: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    maxWidth: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minBlockSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minHeight: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minInlineSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minWidth: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    opacity: (0, $bcbfa6eabcc99f23$export$daf94a976c798b4f),
    outlineColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    outlineOffset: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    outlineWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    padding: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBlock: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBottom: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingInline: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingLeft: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingRight: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingTop: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    right: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    rowGap: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    top: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    width: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    zIndex: (0, $bcbfa6eabcc99f23$export$b5f31a7e431d2eab)
};
var $d8fb25f1eb78afec$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $d8fb25f1eb78afec$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $d8fb25f1eb78afec$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $d8fb25f1eb78afec$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $d8fb25f1eb78afec$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $d8fb25f1eb78afec$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($d8fb25f1eb78afec$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($d8fb25f1eb78afec$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $d8fb25f1eb78afec$export$9a199fbafee0014e)) return;
        var tokenValue = $d8fb25f1eb78afec$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $d8fb25f1eb78afec$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $d8fb25f1eb78afec$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $d8fb25f1eb78afec$var$uniqueSymbol, (0, $jjlaj.css)(transformedStyles));
};
var $d8fb25f1eb78afec$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $d8fb25f1eb78afec$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$d8fb25f1eb78afec$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $d8fb25f1eb78afec$export$f6c783d06584602c(style) {
    return $d8fb25f1eb78afec$var$baseXcss(style);
}



var $acw62 = parcelRequire("acw62");
var $1fb2baf78524847d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $1fb2baf78524847d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($1fb2baf78524847d$export$1ca2a26fecb070ae);
};
$1fb2baf78524847d$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $9c14666919da07a2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $9c14666919da07a2$var$_excluded2 = [
    "className"
];
var $9c14666919da07a2$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $9c14666919da07a2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $9c14666919da07a2$var$_excluded2);
    var resolvedStyles = (0, $d8fb25f1eb78afec$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $9c14666919da07a2$var$baseStyles,
            backgroundColor && (0, $bcbfa6eabcc99f23$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $bcbfa6eabcc99f23$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $bcbfa6eabcc99f23$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jjlaj.jsx)((0, $1fb2baf78524847d$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $9c14666919da07a2$export$2e2bcd8739ae039 = $9c14666919da07a2$export$e71c4d32a2263218;
var $9c14666919da07a2$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $1e55c401149496ac$var$_EditProfileFormQuery;

const $1e55c401149496ac$export$88789cf4c1a09574 = $1e55c401149496ac$var$_EditProfileFormQuery !== void 0 ? $1e55c401149496ac$var$_EditProfileFormQuery : $1e55c401149496ac$var$_EditProfileFormQuery = (parcelRequire("dON29"));


var $1f2cadad3625e877$var$_EditProfileFormMutation;

const $1f2cadad3625e877$export$bfb4e7fc0a9623f4 = $1f2cadad3625e877$var$_EditProfileFormMutation !== void 0 ? $1f2cadad3625e877$var$_EditProfileFormMutation : $1f2cadad3625e877$var$_EditProfileFormMutation = (parcelRequire("2XvW0"));


var $a01d2e1451332982$var$_AtlassianAccountUserFragment;

const $a01d2e1451332982$export$b93dbd06c33445c4 = $a01d2e1451332982$var$_AtlassianAccountUserFragment !== void 0 ? $a01d2e1451332982$var$_AtlassianAccountUserFragment : $a01d2e1451332982$var$_AtlassianAccountUserFragment = (parcelRequire("81DfT"));







/* ManageProducts.tsx generated by @compiled/babel-plugin v0.29.1 */ 

var $acw62 = parcelRequire("acw62");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $e3e39e92bb52ee4d$var$_ref, $e3e39e92bb52ee4d$var$_process, $e3e39e92bb52ee4d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $e3e39e92bb52ee4d$var$TESTS_MODE = ($e3e39e92bb52ee4d$var$_ref = (globalThis === null || globalThis === void 0 || ($e3e39e92bb52ee4d$var$_process = globalThis.process) === null || $e3e39e92bb52ee4d$var$_process === void 0 || ($e3e39e92bb52ee4d$var$_process = $e3e39e92bb52ee4d$var$_process.env) === null || $e3e39e92bb52ee4d$var$_process === void 0 ? void 0 : $e3e39e92bb52ee4d$var$_process.JEST_WORKER_ID) !== undefined, $e3e39e92bb52ee4d$var$_ref !== void 0) ? $e3e39e92bb52ee4d$var$_ref : false;
var $e3e39e92bb52ee4d$var$DEBUG_MODE = !$e3e39e92bb52ee4d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($e3e39e92bb52ee4d$var$_process2 = globalThis.process) === null || $e3e39e92bb52ee4d$var$_process2 === void 0 || ($e3e39e92bb52ee4d$var$_process2 = $e3e39e92bb52ee4d$var$_process2.env) === null || $e3e39e92bb52ee4d$var$_process2 === void 0 ? void 0 : $e3e39e92bb52ee4d$var$_process2.NODE_ENV) !== "production";
var $e3e39e92bb52ee4d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$e3e39e92bb52ee4d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $hPtJY = parcelRequire("hPtJY");
var $b302f4751d8fb963$var$pkgName = "@atlaskit/platform-feature-flags";
var $b302f4751d8fb963$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $b302f4751d8fb963$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $b302f4751d8fb963$var$ENV_ENABLE_PLATFORM_FF = $b302f4751d8fb963$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $b302f4751d8fb963$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $b302f4751d8fb963$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $b302f4751d8fb963$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $b302f4751d8fb963$var$ENV_ENABLE_PLATFORM_FF || $b302f4751d8fb963$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $b302f4751d8fb963$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $b302f4751d8fb963$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$b302f4751d8fb963$var$globalVar[$b302f4751d8fb963$export$7e41b1b2bdee3f98] = $b302f4751d8fb963$var$globalVar[$b302f4751d8fb963$export$7e41b1b2bdee3f98] || $b302f4751d8fb963$var$DEFAULT_PFF_GLOBAL;
function $b302f4751d8fb963$export$f2b591175b3e424c(resolver) {
    $b302f4751d8fb963$var$globalVar[$b302f4751d8fb963$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $b302f4751d8fb963$export$6333b6aff9fc6275(flagKey) {
    if ($b302f4751d8fb963$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $e3e39e92bb52ee4d$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $b302f4751d8fb963$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $b302f4751d8fb963$var$globalVar[$b302f4751d8fb963$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $4dfc03128c9b001f$export$ba05d765b8392e5e(flagResolver) {
    (0, $b302f4751d8fb963$export$f2b591175b3e424c)(flagResolver);
}
function $4dfc03128c9b001f$export$470e5c2be1411c89(name) {
    return (0, $b302f4751d8fb963$export$6333b6aff9fc6275)(name);
}
function $4dfc03128c9b001f$export$b40ec24ac8275656(name) {
    return (0, $b302f4751d8fb963$export$6333b6aff9fc6275)(name);
}



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");
var $20ca42a6bc95cb39$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $20ca42a6bc95cb39$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($20ca42a6bc95cb39$export$1ca2a26fecb070ae);
};
$20ca42a6bc95cb39$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");
var $63ba7a6917aaf00f$export$4ef52930e33717cd = "data-theme";
var $63ba7a6917aaf00f$export$a00eac3f8684bcd0 = "data-color-mode";
var $63ba7a6917aaf00f$export$2112803007239c61 = "data-contrast-mode";
var $63ba7a6917aaf00f$export$352e418ed5b6193a = "data-custom-theme";
var $63ba7a6917aaf00f$export$2faeed762aac6741 = "light";
var $63ba7a6917aaf00f$export$6f0c6fb8c80fcc92 = "ds";
var $63ba7a6917aaf00f$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $63ba7a6917aaf00f$export$dddac1532e822863 = "--".concat($63ba7a6917aaf00f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $63ba7a6917aaf00f$export$9d7b58831ae93caa = "--".concat($63ba7a6917aaf00f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $81fc08456e27707c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81fc08456e27707c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81fc08456e27707c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81fc08456e27707c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $81fc08456e27707c$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $81fc08456e27707c$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $81fc08456e27707c$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $81fc08456e27707c$export$632685d741f3dbbf = $81fc08456e27707c$var$_objectSpread($81fc08456e27707c$var$_objectSpread({}, $81fc08456e27707c$export$958d0ae7f2977ae4), $81fc08456e27707c$export$d2dc61f58390201c);
var $81fc08456e27707c$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $81fc08456e27707c$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $81fc08456e27707c$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $81fc08456e27707c$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $81fc08456e27707c$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $81fc08456e27707c$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $81fc08456e27707c$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $81fc08456e27707c$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $81fc08456e27707c$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $81fc08456e27707c$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $81fc08456e27707c$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $81fc08456e27707c$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $81fc08456e27707c$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $81fc08456e27707c$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $81fc08456e27707c$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $81fc08456e27707c$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $81fc08456e27707c$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $81fc08456e27707c$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $81fc08456e27707c$export$e615f061ca585a6c = $81fc08456e27707c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $81fc08456e27707c$export$ca0f9c2de39ffed7(spacingProperty, $81fc08456e27707c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $81fc08456e27707c$export$bf46c3f9eeafc71f = $81fc08456e27707c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $81fc08456e27707c$export$ca0f9c2de39ffed7(spacingProperty, $81fc08456e27707c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $81fc08456e27707c$export$e7af83bafe7f9e63 = $81fc08456e27707c$export$ca0f9c2de39ffed7("backgroundColor", $81fc08456e27707c$export$d1d79bf68ac056bd);
var $81fc08456e27707c$export$3a1bcba60b23d7f0 = $81fc08456e27707c$export$ca0f9c2de39ffed7("color", $81fc08456e27707c$export$8473307aa00d6ea1);
var $81fc08456e27707c$export$45f3f4fe16f9f7d5 = $81fc08456e27707c$export$ca0f9c2de39ffed7("fontWeight", $81fc08456e27707c$export$303e322c6b1ed114);
var $81fc08456e27707c$export$68cc305da27dbaa4 = $81fc08456e27707c$export$ca0f9c2de39ffed7("fontFamily", $81fc08456e27707c$export$3c7e9587132614b4);
var $81fc08456e27707c$export$128f10c238242f83 = $81fc08456e27707c$export$ca0f9c2de39ffed7("font", $81fc08456e27707c$export$6ffa317d5e70375);
var $81fc08456e27707c$export$219d364c0da35ae4 = $81fc08456e27707c$export$ca0f9c2de39ffed7("font", $81fc08456e27707c$export$236bfe3a33ef1292);
var $81fc08456e27707c$export$38845ca010b93505 = $81fc08456e27707c$export$ca0f9c2de39ffed7("fontWeight", $81fc08456e27707c$export$855cfd311192d666);
var $81fc08456e27707c$export$ff257d957d48c421 = $81fc08456e27707c$export$ca0f9c2de39ffed7((0, $63ba7a6917aaf00f$export$9d7b58831ae93caa), $81fc08456e27707c$export$41a358c9c2356760);
var $81fc08456e27707c$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $81fc08456e27707c$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $jjlaj = parcelRequire("jjlaj");


var $hPtJY = parcelRequire("hPtJY");
function $b059e9c08e6a312d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b059e9c08e6a312d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b059e9c08e6a312d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b059e9c08e6a312d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b059e9c08e6a312d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b059e9c08e6a312d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b059e9c08e6a312d$export$9a199fbafee0014e = {
    backgroundColor: (0, $81fc08456e27707c$export$d1d79bf68ac056bd),
    blockSize: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderBottomColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderLeftColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $81fc08456e27707c$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    borderWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    bottom: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    boxShadow: (0, $81fc08456e27707c$export$7aff6e7ba39bb774),
    color: (0, $81fc08456e27707c$export$8473307aa00d6ea1),
    columnGap: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    font: (0, $81fc08456e27707c$export$6ffa317d5e70375),
    fontFamily: (0, $81fc08456e27707c$export$3c7e9587132614b4),
    fontWeight: (0, $81fc08456e27707c$export$303e322c6b1ed114),
    gap: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    height: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    inlineSize: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    inset: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    insetBlock: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    insetBlockEnd: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    insetBlockStart: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    insetInline: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    insetInlineEnd: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    insetInlineStart: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    left: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    margin: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginBlock: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginBlockEnd: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginBlockStart: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginBottom: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginInline: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginInlineEnd: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginInlineStart: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginLeft: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginRight: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    marginTop: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    maxBlockSize: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    maxHeight: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    maxWidth: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    minBlockSize: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    minHeight: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    minInlineSize: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    minWidth: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    opacity: (0, $81fc08456e27707c$export$daf94a976c798b4f),
    outlineColor: (0, $81fc08456e27707c$export$1531ad5bb3fbedac),
    outlineOffset: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    outlineWidth: (0, $81fc08456e27707c$export$e1b83c5210c471b8),
    padding: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingBlock: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingBottom: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingInline: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingLeft: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingRight: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    paddingTop: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    right: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    rowGap: (0, $81fc08456e27707c$export$958d0ae7f2977ae4),
    top: (0, $81fc08456e27707c$export$632685d741f3dbbf),
    width: (0, $81fc08456e27707c$export$6ccdbebca2ee545f),
    zIndex: (0, $81fc08456e27707c$export$b5f31a7e431d2eab)
};
var $b059e9c08e6a312d$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $b059e9c08e6a312d$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $b059e9c08e6a312d$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $b059e9c08e6a312d$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $b059e9c08e6a312d$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b059e9c08e6a312d$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $b059e9c08e6a312d$var$safeSelectors.test(key)) {
            styleObj[key] = $b059e9c08e6a312d$var$_transformStyles(value);
            return;
        }
        if ($b059e9c08e6a312d$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b059e9c08e6a312d$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b059e9c08e6a312d$export$9a199fbafee0014e)) return;
        var tokenValue = $b059e9c08e6a312d$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $b059e9c08e6a312d$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $b059e9c08e6a312d$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $b059e9c08e6a312d$var$uniqueSymbol, (0, $jjlaj.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $b059e9c08e6a312d$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $b059e9c08e6a312d$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $b059e9c08e6a312d$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$b059e9c08e6a312d$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b059e9c08e6a312d$export$f6c783d06584602c(style) {
    return $b059e9c08e6a312d$var$baseXcss(style);
}


var $24b238c4242240d3$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $24b238c4242240d3$var$_excluded2 = [
    "className"
];
var $24b238c4242240d3$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $24b238c4242240d3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $24b238c4242240d3$var$_excluded2);
    var resolvedStyles = (0, $b059e9c08e6a312d$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $24b238c4242240d3$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $81fc08456e27707c$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $81fc08456e27707c$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $81fc08456e27707c$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $81fc08456e27707c$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $81fc08456e27707c$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $81fc08456e27707c$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $81fc08456e27707c$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $81fc08456e27707c$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $81fc08456e27707c$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $81fc08456e27707c$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jjlaj.jsx)((0, $20ca42a6bc95cb39$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $24b238c4242240d3$export$2e2bcd8739ae039 = $24b238c4242240d3$export$e71c4d32a2263218;
var $24b238c4242240d3$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $bv4qN = parcelRequire("bv4qN");

var $acw62 = parcelRequire("acw62");
var $fff851c36d2f7c03$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $fff851c36d2f7c03$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($fff851c36d2f7c03$var$HasTextAncestorContext);
};
var $fff851c36d2f7c03$export$ae933c6cbe5643ad = $fff851c36d2f7c03$var$HasTextAncestorContext.Provider;




var $09508445b8f0d582$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $09508445b8f0d582$var$resetStyles = (0, $jjlaj.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $09508445b8f0d582$var$strongStyles = (0, $jjlaj.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $09508445b8f0d582$var$emStyles = (0, $jjlaj.css)({
    fontStyle: "italic"
});
var $09508445b8f0d582$var$textAlignMap = {
    center: (0, $jjlaj.css)({
        textAlign: "center"
    }),
    end: (0, $jjlaj.css)({
        textAlign: "end"
    }),
    start: (0, $jjlaj.css)({
        textAlign: "start"
    })
};
var $09508445b8f0d582$var$truncationStyles = (0, $jjlaj.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $09508445b8f0d582$var$wordBreakMap = {
    breakAll: (0, $jjlaj.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $09508445b8f0d582$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $20ca42a6bc95cb39$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $81fc08456e27707c$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $81fc08456e27707c$export$2185ce37f9bdd963)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $09508445b8f0d582$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $bv4qN.default)($09508445b8f0d582$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $fff851c36d2f7c03$export$9322276ec105d055)();
    var color = $09508445b8f0d582$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $jjlaj.jsx)(Component, {
        ref: ref,
        css: [
            $09508445b8f0d582$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $81fc08456e27707c$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $81fc08456e27707c$export$3a1bcba60b23d7f0)[color],
            maxLines && $09508445b8f0d582$var$truncationStyles,
            maxLines === 1 && $09508445b8f0d582$var$wordBreakMap.breakAll,
            align && $09508445b8f0d582$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $81fc08456e27707c$export$38845ca010b93505)[weight],
            Component === "em" && $09508445b8f0d582$var$emStyles,
            Component === "strong" && $09508445b8f0d582$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $jjlaj.jsx)((0, $fff851c36d2f7c03$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $09508445b8f0d582$export$2e2bcd8739ae039 = $09508445b8f0d582$var$Text;


function $3fb635f825c32cbc$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $3fb635f825c32cbc$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $3fb635f825c32cbc$var$getSafeValue(value);
    var safeMax = $3fb635f825c32cbc$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


var $ffa17d49c79e49e4$var$boxStyles = (0, $b059e9c08e6a312d$export$f6c783d06584602c)({
    borderRadius: "border.radius.200",
    display: "inline-flex",
    blockSize: "min-content",
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $ffa17d49c79e49e4$var$neutral300 = "#DDDEE1";
var $ffa17d49c79e49e4$var$red300 = "#FD9891";
var $ffa17d49c79e49e4$var$blue300 = "#8FB8F6";
var $ffa17d49c79e49e4$var$neutral1000 = "#292A2E";
var $ffa17d49c79e49e4$var$styles = {
    root: (0, $jjlaj.css)({
        display: "inline-flex",
        boxSizing: "border-box",
        minWidth: "var(--ds-space-300, 24px)",
        justifyContent: "center",
        flexShrink: 0,
        blockSize: "min-content",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    added: (0, $jjlaj.css)({
        backgroundColor: "var(--ds-background-success, #DCFFF1)",
        color: "var(--ds-text, #172B4D)"
    }),
    default: (0, $jjlaj.css)({
        backgroundColor: $ffa17d49c79e49e4$var$neutral300,
        color: $ffa17d49c79e49e4$var$neutral1000
    }),
    important: (0, $jjlaj.css)({
        backgroundColor: $ffa17d49c79e49e4$var$red300,
        color: $ffa17d49c79e49e4$var$neutral1000
    }),
    primary: (0, $jjlaj.css)({
        backgroundColor: $ffa17d49c79e49e4$var$blue300,
        color: $ffa17d49c79e49e4$var$neutral1000
    }),
    primaryInverted: (0, $jjlaj.css)({
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        color: "var(--ds-text-brand, #0C66E4)"
    }),
    removed: (0, $jjlaj.css)({
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text, #172B4D)"
    })
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $ffa17d49c79e49e4$var$Badge = /*#__PURE__*/ (0, $acw62.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $4dfc03128c9b001f$export$b40ec24ac8275656)("platform-component-visual-refresh")) return (0, $jjlaj.jsx)("span", {
        "data-testid": testId,
        css: [
            $ffa17d49c79e49e4$var$styles.root,
            $ffa17d49c79e49e4$var$styles[appearance]
        ],
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        }
    }, (0, $jjlaj.jsx)((0, $09508445b8f0d582$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === "number" && max ? (0, $3fb635f825c32cbc$export$7c4d25c0c3217d8c)(children, max) : children));
    return (0, $jjlaj.jsx)((0, $24b238c4242240d3$export$2e2bcd8739ae039), {
        testId: testId,
        as: "span",
        backgroundColor: $ffa17d49c79e49e4$var$backgroundColors[appearance],
        xcss: $ffa17d49c79e49e4$var$boxStyles,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        paddingInline: "space.075"
    }, (0, $jjlaj.jsx)((0, $09508445b8f0d582$export$2e2bcd8739ae039), {
        size: "UNSAFE_small",
        align: "center",
        color: style !== null && style !== void 0 && style.color ? "inherit" : $ffa17d49c79e49e4$var$textColors[appearance]
    }, typeof children === "number" && max ? (0, $3fb635f825c32cbc$export$7c4d25c0c3217d8c)(children, max) : children));
});
$ffa17d49c79e49e4$var$Badge.displayName = "Badge";
var $ffa17d49c79e49e4$export$2e2bcd8739ae039 = $ffa17d49c79e49e4$var$Badge;
var $ffa17d49c79e49e4$var$backgroundColors = {
    added: "color.background.success",
    default: "color.background.neutral",
    important: "color.background.danger.bold",
    primary: "color.background.brand.bold",
    primaryInverted: "elevation.surface",
    removed: "color.background.danger"
};
var $ffa17d49c79e49e4$var$textColors = {
    added: "color.text.success",
    default: "color.text",
    important: "color.text.inverse",
    primary: "color.text.inverse",
    primaryInverted: "color.text.brand",
    removed: "color.text.danger"
};


const $daa8402929e7663e$var$ManageProducts = ({ preselectedProducts: preselectedProducts, allProducts: allProducts, changeHandler: changeHandler, closeModal: closeModal })=>{
    const [selectedProducts, setSelectedProducts] = (0, $acw62.useState)({});
    const initialSelectedProducts = preselectedProducts ? preselectedProducts.split(",") : null;
    (0, $acw62.useEffect)(()=>{
        const initialState = {};
        allProducts.forEach((product)=>{
            if (initialSelectedProducts && initialSelectedProducts.includes(product.id)) initialState[product.id] = true;
            else initialState[product.id] = false;
        });
        setSelectedProducts(initialState);
    }, [
        allProducts
    ]);
    const handleCheckboxChange = (id)=>{
        setSelectedProducts((prevState)=>({
                ...prevState,
                [id]: !prevState[id]
            }));
    };
    const clearCheckboxes = ()=>{
        setSelectedProducts((prevState)=>{
            const newState = {};
            Object.keys(prevState).forEach((key)=>{
                newState[key] = false;
            });
            return newState;
        });
    };
    const onSubmit = ()=>{
        const selectedProductIds = Object.entries(selectedProducts).filter(([, isSelected])=>isSelected).map(([id])=>id);
        changeHandler(selectedProductIds.join(","));
        closeModal();
    };
    const selectedProductsCount = Object.values(selectedProducts).filter((isSelected)=>isSelected).length;
    const totalProductsCount = Object.entries(selectedProducts).length;
    const leftColumnCount = totalProductsCount ? Math.ceil(totalProductsCount / 2) : 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: "Loading..."
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1bsb1yw0 _4t3irska _1e0c1txw _2lx21bp4 _ffv71osq _1fis1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1o9zidpf _n3td1tcg _16jlidpf _1o9zkb7n _i0dl1wug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_ect4kwxw _1wybzwfg _k48pzul8 _vwz41ylp"
                            ]),
                            children: "Manage your Atlassian apps"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_19pkftgi _1e0c1txw _4cvr1h6o _zulp1y44"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_ect41v9d _syaz1k3w _1wyb7vkz _vwz41tcg"
                                    ]),
                                    children: "Selected: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa17d49c79e49e4$export$2e2bcd8739ae039), {
                                    appearance: "primary",
                                    children: selectedProductsCount
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _zulp1et3 _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _x3do17rq _n7zl17rq _16jlkb7n _1o9zkb7n _i0dl1wug _18m91wug _vwz4gktf _iyz51bp4 _oe5x7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1e0c1txw _2lx21bp4 _zulp7vkz"
                            ]),
                            children: allProducts.slice(0, leftColumnCount).map((product)=>{
                                if (product && product.title) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$48513f6b9f8ce62d), {
                                        label: product.title,
                                        isChecked: selectedProducts[product.id] || false,
                                        onChange: ()=>{
                                            handleCheckboxChange(product.id);
                                        }
                                    }, product.id)
                                }, product.id + "container");
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                    "_1e0c1txw _2lx21bp4 _zulp7vkz"
                                ]),
                                children: allProducts.slice(leftColumnCount).map((product)=>{
                                    if (product && product.title) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$48513f6b9f8ce62d), {
                                            label: product.title,
                                            isChecked: selectedProducts[product.id] || false,
                                            onChange: ()=>{
                                                handleCheckboxChange(product.id);
                                            }
                                        }, product.id)
                                    }, product.id + "container");
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c1txw _1bahesu3 _zulp1tcg _16jlidpf _1o9zkb7n _i0dl1wug _ca0q7vkz _u5f3idpf _n3tdzwfg _19bvidpf _1gfd1tcg _16hr7vkz _167yidpf _3y2o7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: clearCheckboxes,
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1jwt _1wyb7vkz _k48pzul8 _1e0c1txw _4cvr1h6o _11q7glyw _19itglyw _80omtlke"
                            ]),
                            children: "Clear all"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                            appearance: (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).PRIMARY,
                            label: "Save Changes",
                            onClick: onSubmit
                        })
                    ]
                })
            ]
        })
    });
};
const $daa8402929e7663e$var$modalContainerStyles = null;
const $daa8402929e7663e$var$headerStyles = null;
const $daa8402929e7663e$var$titleStyles = null;
const $daa8402929e7663e$var$productsStyles = null;
const $daa8402929e7663e$var$buttonsStyles = null;
const $daa8402929e7663e$var$clearButtonStyles = null;
const $daa8402929e7663e$var$selectedCountContainerStyles = null;
const $daa8402929e7663e$var$selectedCountTextStyles = null;
const $daa8402929e7663e$var$productsColumnStyles = null;
const $daa8402929e7663e$var$checkboxStyles = null;
var $daa8402929e7663e$export$2e2bcd8739ae039 = $daa8402929e7663e$var$ManageProducts;



var $jjlaj = parcelRequire("jjlaj");










const $6764fb43c1a86ce4$var$ANALYTICS_SOURCE = (0, $77d0522707ddb581$export$d2cea8e85c08e64c).EDIT_PROFILE;
// https://data-portal.internal.atlassian.com/analytics/registry/71734
const $6764fb43c1a86ce4$export$b4f40a26ef24a2db = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$22a3b1671f38a193)({
        screenName: $6764fb43c1a86ce4$var$ANALYTICS_SOURCE,
        isPersonalView: isPersonalView
    });
};
//https://data-portal.internal.atlassian.com/analytics/registry/71746
const $6764fb43c1a86ce4$export$ee8d96c9d7080a5 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $6764fb43c1a86ce4$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "link",
        actionSubjectId: "backToProfile",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71747
const $6764fb43c1a86ce4$export$a9ad6d4b83dd5627 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $6764fb43c1a86ce4$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "closeEditProfile",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71748
const $6764fb43c1a86ce4$export$4e74c6156da758d2 = (isPersonalView)=>{
    (0, $0ee39200de55b7f1$export$1aecf263098db667)({
        source: $6764fb43c1a86ce4$var$ANALYTICS_SOURCE,
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "saveEditProfileChanges",
        isPersonalView: isPersonalView
    });
};
// https://data-portal.internal.atlassian.com/analytics/registry/71743
const $6764fb43c1a86ce4$export$364e95eca095ae7f = (attributes, isPersonalView, duration)=>{
    (0, $0ee39200de55b7f1$export$1ba525b8a711eaac)({
        source: $6764fb43c1a86ce4$var$ANALYTICS_SOURCE,
        action: "updated",
        actionSubject: "profile",
        attributes: {
            ...attributes,
            ...duration !== undefined && {
                duration: duration
            }
        },
        isPersonalView: isPersonalView
    });
};





var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");



var $eb77deb211f1d0a4$var$_excluded = [
    "isAutoDismiss"
];
function $eb77deb211f1d0a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb77deb211f1d0a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb77deb211f1d0a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb77deb211f1d0a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eb77deb211f1d0a4$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $eb77deb211f1d0a4$export$2879604e6aec4ab() {
    var api = (0, $acw62.useContext)($eb77deb211f1d0a4$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
}
var $eb77deb211f1d0a4$var$getUniqueId = function() {
    var count = 0;
    return function() {
        return "flag-provider-unique-id:".concat(count++);
    };
}();
function $eb77deb211f1d0a4$export$a4270ab432ac8a58(_ref) {
    var children = _ref.children, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useState = (0, $acw62.useState)([]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), flags = _useState2[0], setFlags = _useState2[1];
    var removeFlag = (0, $acw62.useCallback)(function(id) {
        setFlags(function(current) {
            return current.slice(0).filter(function(flag) {
                return flag.id !== id;
            });
        });
    }, []);
    var api = (0, $acw62.useMemo)(function() {
        return {
            showFlag: function show(value) {
                var flag = $eb77deb211f1d0a4$var$_objectSpread($eb77deb211f1d0a4$var$_objectSpread({}, value), {}, {
                    id: value.id || $eb77deb211f1d0a4$var$getUniqueId()
                });
                setFlags(function(current) {
                    var index = current.findIndex(function(value) {
                        return value.id === flag.id;
                    });
                    // If flag is not found add it
                    if (index === -1) return [
                        flag
                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(current));
                    // If flag already exists with the same id, then replace it
                    var shallow = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(current);
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        };
    }, [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eb77deb211f1d0a4$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $38132a618d93e205$export$2e2bcd8739ae039), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map(function(flag) {
        var isAutoDismiss = flag.isAutoDismiss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(flag, $eb77deb211f1d0a4$var$_excluded);
        var FlagType = isAutoDismiss ? (0, $9f175d156b67ed04$export$2e2bcd8739ae039) : (0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FlagType, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, restProps, {
            key: flag.id
        }));
    })));
}
var $eb77deb211f1d0a4$export$7b676815c264eaf3 = function withFlagsProvider(fn) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eb77deb211f1d0a4$export$a4270ab432ac8a58, null, fn());
};



var $acw62 = parcelRequire("acw62");
var $3c90dbc86fe024f7$exports = {};
"use strict";
Object.defineProperty($3c90dbc86fe024f7$exports, "__esModule", {
    value: true
});
$3c90dbc86fe024f7$exports.default = void 0;

var $3c90dbc86fe024f7$var$_react = $3c90dbc86fe024f7$var$_interopRequireDefault((parcelRequire("acw62")));

function $3c90dbc86fe024f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3c90dbc86fe024f7$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3c90dbc86fe024f7$var$_react.default.createElement($909afc01458e2b41$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M13.477 9.113l-4.36 4.386a1 1 0 101.418 1.41l4.36-4.386a1 1 0 00-1.418-1.41z" fill="inherit"/><path d="M9.084 10.501l4.358 4.377a1 1 0 101.418-1.411L10.5 9.09a1 1 0 00-1.417 1.411z" fill="inherit"/></g></svg>`
    }, props));
$3c90dbc86fe024f7$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $3c90dbc86fe024f7$var$_default = $3c90dbc86fe024f7$var$CrossCircleIcon;
$3c90dbc86fe024f7$exports.default = $3c90dbc86fe024f7$var$_default;


const $5fb65680e1d6274c$export$e57ae005c983768a = (title, description)=>{
    const flagCount = (0, $acw62.useRef)(1);
    const { showFlag: showFlag } = (0, $eb77deb211f1d0a4$export$2879604e6aec4ab)();
    const flagTitle = title ?? "Something went wrong";
    const flagDescription = description ?? "Wait a few moments, then try again.";
    const addFlag = ()=>{
        const id = flagCount.current++;
        showFlag({
            description: flagDescription,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c90dbc86fe024f7$exports))), {
                label: "Error",
                primaryColor: "var(--ds-icon-danger)"
            }),
            id: id,
            title: flagTitle
        });
    };
    return addFlag;
};




const $4e1455c09aaa84bb$export$4fed017f35d6025b = (userId, actionData)=>{
    try {
        (0, $73d0a2cdf35f1275$export$299ba2dee77727e9)(`/gateway/api/v1/community/kudos/users/${userId}/actions`, {
            ...actionData,
            consumerKey: "profile"
        }, {
            credentials: "include"
        });
    } catch (e) {
        console.log("catching!");
        (0, $ff917de846b535b7$export$a3bc9b8ed74fc)("error-kms", "sendUserActionError", "Error sending user action", e);
    }
};







const $5b5660f686f14cd3$var$ProductsContent = ({ allProducts: allProducts, setHasSelectedProducts: setHasSelectedProducts })=>{
    const formState = (0, $20f67900dc335877$export$606f11b2eb45ecc6)({
        values: true
    });
    const selectedProducts = formState?.values?.products ? (0, $ffa1c9c6a8a97c90$export$df8cfbb1033cc959)(formState.values.products, allProducts) : [];
    // Informing "Add my products" button about if there are selected products
    (0, $acw62.useEffect)(()=>{
        setHasSelectedProducts(selectedProducts.length > 0);
    }, [
        selectedProducts
    ]);
    if (!selectedProducts.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_ect41jhi _1wybxjmg _vwz41tcg"
        ]),
        children: "Which Atlassian apps do you use?"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_otyrl6l0 _1reagosd"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d81eeda824c7b71f$export$92e44ea1079b9ec6), {
            products: selectedProducts,
            isPersonalView: true,
            source: (0, $77d0522707ddb581$export$d2cea8e85c08e64c).EDIT_PROFILE
        })
    });
};
const $5b5660f686f14cd3$var$EditProfileForm = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const openModal = (0, $acw62.useCallback)(()=>setIsModalOpen(true), []);
    const closeModal = (0, $acw62.useCallback)(()=>setIsModalOpen(false), []);
    const { push: push } = (0, $9a1d980dc90c7cfe$export$402e82ff1b20594b)();
    const isValid = (0, $f7731a0c63562c44$export$2e2bcd8739ae039)();
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(pathProfileId);
    const isProfilePersonalView = (0, $718f65897de78705$export$2e2bcd8739ae039)(pathProfileId);
    const [hasSelectedProducts, setHasSelectedProducts] = (0, $acw62.useState)(false);
    const addErrorFlag = (0, $5fb65680e1d6274c$export$e57ae005c983768a)();
    const { calculateTimeDiff: calculateTimeDiff, setTimeStamp: setTimeStamp } = (0, $bf7744c04ecc60a1$export$2e2bcd8739ae039)();
    const loggedInUser = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)();
    const accountId = loggedInUser?.accountId || "";
    const account = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $69f7bb7bdecca370$export$d483224631a5893c), {
        aaid: accountId
    }, {
        fetchPolicy: "store-or-network"
    })?.unified;
    const accountHasLinkedAccounts = account?.account?.isLinked;
    const onFinishEdit = (0, $acw62.useCallback)(()=>{
        push(`/profile/${pathProfileId}`);
    }, [
        push,
        pathProfileId
    ]);
    const toggleModal = (0, $acw62.useCallback)((modalShouldBeOpen)=>{
        if (modalShouldBeOpen !== undefined) setIsModalOpen(modalShouldBeOpen);
        else setIsModalOpen(!isModalOpen);
    }, [
        isModalOpen
    ]);
    const data = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $1e55c401149496ac$export$88789cf4c1a09574), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const atlassianProducts = data?.unified?.atlassianProducts;
    const productData = (0, $2d93712440e0508b$exports.useFragment)((0, $3b90ca0e257e9379$export$982323b17d6c516c), atlassianProducts ?? null);
    const allProducts = (0, $ffa1c9c6a8a97c90$export$3e0a9d9c71b68dbb)(productData);
    const atlassianUserDetailsData = (0, $2d93712440e0508b$exports.useFragment)((0, $a01d2e1451332982$export$b93dbd06c33445c4), data?.me?.user);
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $6764fb43c1a86ce4$export$b4f40a26ef24a2db)(isPersonalView), {
        shouldSendEvent: Boolean(isValid && isPersonalView && pathProfileId)
    });
    if (!isValid || !isPersonalView) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/user_not_found"
    });
    const unifiedProfile = data?.unified?.unifiedProfile;
    const unifiedProfileDetailsData = unifiedProfile && `__fragments` in unifiedProfile ? (0, $2d93712440e0508b$exports.readInlineData)((0, $59d8cbc6a227cd2a$export$213ff35a3d3f0461), unifiedProfile) : null;
    const onClickBackToProfile = ()=>{
        (0, $6764fb43c1a86ce4$export$ee8d96c9d7080a5)(isPersonalView);
        onFinishEdit();
    };
    const onClickClose = ()=>{
        (0, $6764fb43c1a86ce4$export$a9ad6d4b83dd5627)(isPersonalView);
        onFinishEdit();
    };
    const getTrackAttributes = (data)=>{
        const profile = data?.unified?.updateUnifiedProfile?.unifiedProfile;
        return {
            hasBio: !!profile?.bio,
            hasCompany: !!profile?.company,
            hasLinkedinUrl: !!profile?.linkedinUrl,
            hasLocation: !!profile?.location,
            hasRole: !!profile?.role,
            hasWebsiteUrl: !!profile?.websiteUrl,
            hasXUrl: !!profile?.xUrl,
            hasYoutubeUrl: !!profile?.youtubeUrl,
            productCount: profile?.products ? profile?.products.split(",").length : 0
        };
    };
    const onSuccess = (response, errors)=>{
        if (!errors) {
            const duration = calculateTimeDiff();
            (0, $6764fb43c1a86ce4$export$364e95eca095ae7f)(getTrackAttributes(response), isPersonalView, duration);
            push(`/profile/${pathProfileId}`);
        }
        onFinishEdit();
    };
    function getPrimaryAccountDetails(account, defaults = {}) {
        const defaultResult = {
            primaryAccountEmail: defaults.email || "",
            primaryAccountPicture: defaults.picture || "",
            primaryAccountNickname: defaults.nickname || "",
            primaryAccountAaid: false
        };
        if (account?.account?.isLinked) {
            const primaryAccount = account.account.linkedAccounts?.edges?.find((edge)=>edge?.node?.isPrimary === true);
            if (primaryAccount?.node) return {
                primaryAccountEmail: primaryAccount.node.emailId || defaults.email || "",
                primaryAccountPicture: primaryAccount.node.picture || defaults.picture || "",
                primaryAccountNickname: primaryAccount.node.nickname || defaults.nickname || "",
                primaryAccountAaid: primaryAccount.node.aaid || false
            };
        }
        return defaultResult;
    }
    const primaryAccountData = getPrimaryAccountDetails(account);
    const primaryAccountAaid = primaryAccountData.primaryAccountAaid;
    let primaryUserResponse;
    if (account?.account?.isLinked && primaryAccountAaid) primaryUserResponse = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: primaryAccountAaid
    }, {
        fetchPolicy: "store-or-network"
    });
    const primaryUserData = primaryUserResponse?.user;
    const primaryUserNickname = primaryUserData?.nickname ?? null;
    const primaryUserPicture = primaryUserData?.picture ?? null;
    const primaryAccountPicture = primaryAccountData.primaryAccountPicture;
    const primaryAccountNickname = primaryAccountData.primaryAccountNickname;
    const accountEmail = primaryAccountData.primaryAccountEmail || atlassianUserDetailsData?.email || "";
    let accountPicture;
    let accountNickname;
    if (isProfilePersonalView) {
        accountPicture = primaryAccountPicture || atlassianUserDetailsData?.picture || (0, (/*@__PURE__*/$parcel$interopDefault($2d8beca2420f46b5$exports)));
        accountNickname = primaryAccountNickname || atlassianUserDetailsData?.nickname || "";
    } else {
        accountPicture = primaryUserPicture || atlassianUserDetailsData?.picture || (0, (/*@__PURE__*/$parcel$interopDefault($2d8beca2420f46b5$exports)));
        accountNickname = primaryUserNickname || atlassianUserDetailsData?.nickname || "";
    }
    if (!unifiedProfile || !unifiedProfileDetailsData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch profile data"
    });
    if (!atlassianUserDetailsData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch user data"
    });
    let manageIdentityProfile = "https://id.atlassian.com/login?continue=https%3A%2F%2Fid.atlassian.com%2Fmanage-profile";
    if (accountEmail) manageIdentityProfile += `&login_hint=${encodeURIComponent(accountEmail)}&prompt=none&application=community--entry-auth`;
    const validateBio = (value)=>{
        if (value) {
            const text = (0, $29b4de728b246ef8$export$e4d2cb79f7781e1c)(value);
            return (0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).characterLimit(200, text);
        }
        return undefined;
    };
    async function commitAddUser(input, onCompleted, onError) {
        if (unifiedProfile) {
            input.internalId = unifiedProfileDetailsData?.internalId;
            (0, $2d93712440e0508b$exports.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
                mutation: (0, $1f2cadad3625e877$export$bfb4e7fc0a9623f4),
                variables: {
                    input: input
                },
                onCompleted: onCompleted,
                onError: onError
            });
        }
    }
    const onSubmitForm = (data)=>{
        setTimeStamp();
        (0, $6764fb43c1a86ce4$export$4e74c6156da758d2)(isPersonalView);
        if (data?.bio) {
            const bioText = (0, $29b4de728b246ef8$export$e4d2cb79f7781e1c)(data.bio);
            if (!bioText?.trim()) data.bio = "";
        }
        const hasNonEmptyField = Object.values(data).some((value)=>{
            if (typeof value === "string") return value.trim() !== "";
            return false;
        });
        if (hasNonEmptyField) {
            const userId = atlassianUserDetailsData?.accountId;
            if (userId) (0, $4e1455c09aaa84bb$export$4fed017f35d6025b)(userId, {
                name: "PROFILE_EDITED"
            });
        }
        commitAddUser(data, onSuccess, (error)=>{
            console.error("Error: ", error);
            addErrorFlag();
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1bsb1osq _ca0qzwfg _u5f37vkz _n3td53f4 _19bv7vkz _1o3j1yw0 _fii91ylp _ebtg1wug _1reaidpf _rk7t1wug _1gfd1ylp _16hridpf _167yuuw1 _3y2oidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9403b4fac03971ab$export$3167f6ecaaaa3457), {
                onClick: onClickBackToProfile,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_syaz1jwt _ect41q02 _1wyb7vkz _k48pzul8 _vwz4gktf"
                    ]),
                    children: "\u2190 Back to profile"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_syaz1blv _ect4kwxw _19pk1tcg _1wybzwfg _k48pbogh _vwz41ylp _1dyzy1zs _fii91ylp _1gw8gosd _1paha5zd _yb5xbogh"
                ]),
                children: "Edit profile"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_19pk1tcg _fii91ylp"
                ]),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1273dc8eae8f1aca$export$2e2bcd8739ae039), {
                    onSubmit: onSubmitForm,
                    children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            ...formProps,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    "data-testid": "edit-about-me-section",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyr7vkz _ect4kwxw _k48pzul8 _syaz1blv _1wyb1tcg _vwz4zwfg _1gw8zwfg _1pahgosd _ob8skwxw"
                                            ]),
                                            children: "Name and photo"
                                        }),
                                        accountHasLinkedAccounts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyrxjmg"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2154909317384aee$export$2e2bcd8739ae039), {
                                                children: "Your public name, photo, and email are controlled by your primary Atlassian account. "
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_2rko1eps _16qsj9yf _otyrzwfg _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1gfd1tcg _16hr1tcg _167y1tcg _3y2o1tcg _1rea1ylp"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                    "_1o2q1txw _1o3j1osq _6hdn1yb4 _1rea1ylp _16gockbl",
                                                    "_1reaidpf"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                            "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                            "_uwwn1txw _iyz51bp4 _ffv71osq",
                                                            "_fipv7vkz"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_otyr1eps"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                    labelText: "Profile photo",
                                                                    isRequired: false
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3bd26b6fddb52586$export$2e2bcd8739ae039), {
                                                                src: accountPicture,
                                                                role: "img",
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_1bsb16xz _4t3i16xz _2rko1ssb"
                                                                ])
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_19pkl6l0"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9403b4fac03971ab$export$3167f6ecaaaa3457), {
                                                                    type: "button",
                                                                    onClick: ()=>{
                                                                        window.open(manageIdentityProfile, "_blank");
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                                "_ect41q02 _1wyb7vkz _syaz1jwt _k48pzul8 _vwz4gktf _2hwx1y44"
                                                                            ]),
                                                                            children: "Edit in Atlassian account"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f691eb74fa5ba594$exports))),
                                                                            alt: "offsite",
                                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                                "_1bsb1tcg _4t3i1tcg"
                                                                            ])
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                            "_1o2q1txw _1s5n1bp4 _1o3j1osq"
                                                        ]),
                                                        children: [
                                                            accountHasLinkedAccounts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_1e0c1txw _1bahesu3"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$be7f7dedc3a0e1ad), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                labelText: "Public name",
                                                                isRequired: true
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                isDisabled: true,
                                                                isInvalid: false,
                                                                value: accountNickname
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_19pk1tcg"
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                        labelText: "Email",
                                                                        isRequired: true
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                        isDisabled: true,
                                                                        isInvalid: false,
                                                                        value: accountEmail
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_x3do7v06 _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _1gfd1ylp _16hridpf _167y1ylp _3y2oidpf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_otyr7vkz _ect4kwxw _k48pzul8 _syaz1blv _1wyb1tcg _vwz4zwfg _1gw8zwfg _1pahgosd _ob8skwxw"
                                                    ]),
                                                    children: "About me"
                                                }),
                                                accountHasLinkedAccounts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_otyrxjmg"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2154909317384aee$export$2e2bcd8739ae039), {
                                                        children: "Changes to sections below will be reflected across all your linked accounts."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    "data-testid": "edit-current-job-section",
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1o2q1txw _1o3j1osq _6hdn1yb4 _1rea1ylp _16gockbl"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                                "_1j3t1tcg"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                                testId: "role-input",
                                                                name: "role",
                                                                defaultValue: unifiedProfileDetailsData?.role || "",
                                                                validate: (value)=>(0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).characterLimit(40, value),
                                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                            "_fii91bs0"
                                                                        ]),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                                labelText: "Current position",
                                                                                isRequired: fieldProps.isRequired
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                                ...fieldProps
                                                                            }),
                                                                            fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                                type: "error",
                                                                                message: "Current position must be 40 characters or less."
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                                "_1j3t1tcg"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                                testId: "company-input",
                                                                name: "company",
                                                                defaultValue: unifiedProfileDetailsData?.company || "",
                                                                validate: (value)=>(0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).characterLimit(30, value),
                                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                            "_fii91bs0"
                                                                        ]),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                                labelText: "Company",
                                                                                isRequired: fieldProps.isRequired
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                                ...fieldProps
                                                                            }),
                                                                            fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                                type: "error",
                                                                                message: "Company must be 30 characters or less."
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    "data-testid": "edit-location-details-section",
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1o2q1txw _1o3j1osq _6hdn1yb4 _1rea1ylp _16gockbl"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                                "_1j3t1tcg"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                                testId: "location-input",
                                                                name: "location",
                                                                defaultValue: unifiedProfileDetailsData?.location || "",
                                                                validate: (value)=>(0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).characterLimit(30, value),
                                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                            "_fii91bs0"
                                                                        ]),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                                labelText: "Location",
                                                                                isRequired: fieldProps.isRequired
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                                ...fieldProps
                                                                            }),
                                                                            fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                                type: "error",
                                                                                message: "Location must be 30 characters or less."
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                                "_1j3t1tcg"
                                                            ])
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    "data-testid": "edit-bio-section",
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1bsb1osq"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                        name: "bio",
                                                        defaultValue: unifiedProfileDetailsData?.bio || "",
                                                        validate: validateBio,
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                                                "data-name": fieldProps.id,
                                                                "data-value": fieldProps.value,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                        labelText: "Short bio",
                                                                        isRequired: fieldProps.isRequired
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5921ba59f371d157$export$3e10f1206980ab22), {
                                                                        changeHandler: fieldProps.onChange,
                                                                        defaultValue: fieldProps.value,
                                                                        isInvalid: fieldProps.isInvalid
                                                                    }),
                                                                    fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                        type: "error",
                                                                        message: "Bio must be 200 characters or less."
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    "data-testid": "edit-contacts-section",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_x3do7v06 _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _1gfd1ylp _16hridpf _167y1ylp _3y2oidpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyr7vkz _ect4kwxw _k48pzul8 _syaz1blv _1wyb1tcg _vwz4zwfg _1gw8zwfg _1pahgosd _ob8skwxw"
                                            ]),
                                            children: "Where to find me"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_1o2q1txw _1o3j1osq _6hdn1yb4 _1rea1ylp _16gockbl"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                        "_1j3t1tcg"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                        testId: "websiteUrl-input",
                                                        name: "websiteUrl",
                                                        defaultValue: unifiedProfileDetailsData?.websiteUrl || "",
                                                        validate: (value)=>(0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).validateUrl(value),
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_fii91bs0"
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                        labelText: "My website",
                                                                        isRequired: fieldProps.isRequired
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                        ...fieldProps
                                                                    }),
                                                                    fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                        type: "error",
                                                                        message: "Enter a valid URL."
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                        "_1j3t1tcg"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                        testId: "linkedinUrl-input",
                                                        name: "linkedinUrl",
                                                        defaultValue: unifiedProfileDetailsData?.linkedinUrl || "",
                                                        validate: (value)=>(0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).validateUrl(value),
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_fii91bs0"
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                        labelText: "LinkedIn",
                                                                        isRequired: fieldProps.isRequired
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                        ...fieldProps,
                                                                        placeholder: "linkedin.com/in/"
                                                                    }),
                                                                    fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                        type: "error",
                                                                        message: "Enter a valid LinkedIn URL."
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_1o2q1txw _1o3j1osq _6hdn1yb4 _1rea1ylp _16gockbl",
                                                "_1reaidpf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1o2q1txw _1s5n1bp4 _1o3j1osq",
                                                        "_1j3t1tcg"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                                        testId: "youtubeUrl-input",
                                                        name: "youtubeUrl",
                                                        defaultValue: unifiedProfileDetailsData?.youtubeUrl || "",
                                                        validate: (value)=>(0, $11b44da27d1a9b8a$export$d78505ea49a0d35b).validateUrl(value),
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_fii91bs0"
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$76375b2580d1f8ac), {
                                                                        labelText: "YouTube",
                                                                        isRequired: fieldProps.isRequired
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2c73285ae9390cec), {
                                                                        ...fieldProps,
                                                                        placeholder: "youtube.com/"
                                                                    }),
                                                                    fieldProps.isInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$9144c5f9beecc4b7), {
                                                                        type: "error",
                                                                        message: "Enter a valid YouTube URL."
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_1o2q1txw _1s5n1bp4 _1o3j1osq"
                                                    ])
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    "data-testid": "edit-products-section",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_x3do7v06 _ca0qzwfg _1gfd1ylp _167yzwfg _1j3tzwfg",
                                        "_1dpwidpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyr7vkz _ect4kwxw _k48pzul8 _syaz1blv _1wyb1tcg _vwz4zwfg _1gw8zwfg _1pahgosd _ob8skwxw",
                                                "_otyr1crf _1rea7vkz"
                                            ]),
                                            children: "My apps"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyrl6l0 _1reagosd"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5b5660f686f14cd3$var$ProductsContent, {
                                                allProducts: allProducts,
                                                setHasSelectedProducts: setHasSelectedProducts
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                                            type: "button",
                                            appearance: (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).SECONDARY,
                                            label: hasSelectedProducts ? "Manage apps" : "Add apps",
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                openModal();
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                    name: "products",
                                    defaultValue: unifiedProfileDetailsData.products ?? null,
                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$8577c1390d697bac), {
                                            isOpen: isModalOpen,
                                            toggleModal: toggleModal,
                                            modalDescriptionLabel: "Manage your Atlassian apps",
                                            styles: $5b5660f686f14cd3$var$modalStyles,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $daa8402929e7663e$export$2e2bcd8739ae039), {
                                                preselectedProducts: fieldProps.value,
                                                allProducts: allProducts,
                                                changeHandler: fieldProps.onChange,
                                                closeModal: closeModal
                                            })
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    "data-testid": "profile-privacy-section",
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_x3do7v06 _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _1gfd1ylp _16hridpf _167y1ylp _3y2oidpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyr7vkz _ect4kwxw _k48pzul8 _syaz1blv _1wyb1tcg _vwz4zwfg _1gw8zwfg _1pahgosd _ob8skwxw",
                                                "_otyr1crf _1rea7vkz"
                                            ]),
                                            children: "Visibility settings"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                            paddingBlockEnd: "space.200",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                                children: `Public profiles are visible to all users.`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                            children: `If your Community profile is private:`
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_otyr7vkz _19bv7vkz _1x8w1vji _1p57ftgi _1e0c1n7u"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                                        children: `Your public name and Community Forums activity (posts, likes, and comments) will remain public.`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                                        children: `Your profile photo will respect your Atlassian account visibility settings*.`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                                        children: `Your Community user data (Community stats, certifications, badges, kudos, groups) will only be visible to you.`
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$5f1af8db9871e1d6), {
                                            fontWeight: "semibold",
                                            size: "small",
                                            children: `*If there is no profile photo in your Atlassian account, your Community Forum profile photo will default to an avatar containing your full name initials.`
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                            name: "isPrivate",
                                            defaultValue: unifiedProfileDetailsData?.isPrivate ?? false,
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    role: "radiogroup",
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_19pk1ylp"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$d7b12c4107be0d61), {
                                                            isChecked: !fieldProps.value,
                                                            setIsChecked: ()=>fieldProps.onChange(false),
                                                            label: "Public"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                "_19pk7vkz"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$d7b12c4107be0d61), {
                                                            isChecked: fieldProps.value,
                                                            setIsChecked: ()=>fieldProps.onChange(true),
                                                            label: "Private"
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_kqsw1n9t _94n5idpf _1ltvidpf _4t3it9kd _1bsb1osq _bfhk3etr _16qskajx"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                            "_1e0c1txw _4cvr1h6o _1bahesu3 _4t3i1osq _19pk1wug _2hwx7vkz _otyr1wug _18u01wug _1o3j1yw0 _fii91wug _ebtg1wug _1rea1wug _rk7t1wug"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9403b4fac03971ab$export$3167f6ecaaaa3457), {
                                                onClick: onClickClose,
                                                style: $5b5660f686f14cd3$var$cancelButtonStyles,
                                                type: "button",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                        "_syaz1jwt _ect41q02 _1wyb7vkz _k48pzul8 _vwz4gktf"
                                                    ]),
                                                    children: "Close"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                                                as: "button",
                                                appearance: (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).PRIMARY,
                                                label: "Save changes",
                                                type: "submit"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                })
            })
        ]
    });
};
var $5b5660f686f14cd3$export$2e2bcd8739ae039 = $5b5660f686f14cd3$var$EditProfileForm;
const $5b5660f686f14cd3$var$radioButtonContainer = null;
const $5b5660f686f14cd3$var$primaryEmailField = null;
const $5b5660f686f14cd3$var$primaryAccountTagStyle = null;
const $5b5660f686f14cd3$var$editInAccountButton = null;
const $5b5660f686f14cd3$var$profilePhotoLabelWrapper = null;
const $5b5660f686f14cd3$var$visibilitySettingsList = null;
const $5b5660f686f14cd3$var$radioButtonSpacer = null;
const $5b5660f686f14cd3$var$infoPanelStyle = null;
const $5b5660f686f14cd3$var$containerStyles = null;
const $5b5660f686f14cd3$var$backToProfileTextStyles = null;
const $5b5660f686f14cd3$var$editProfileHeaderStyles = null;
const $5b5660f686f14cd3$var$formContainerStyles = null;
const $5b5660f686f14cd3$var$removeFieldMarginStyles = null;
const $5b5660f686f14cd3$var$sectionContainerStyles = null;
const $5b5660f686f14cd3$var$myProductsSectionContainerStyles = null;
const $5b5660f686f14cd3$var$finalMobileSection = null;
const $5b5660f686f14cd3$var$sectionHeaderStyles = null;
const $5b5660f686f14cd3$var$identityCardStyles = null;
const $5b5660f686f14cd3$var$mobileProfilePhotoSectionStyles = null;
const $5b5660f686f14cd3$var$editOnIdentityTextStyles = null;
const $5b5660f686f14cd3$var$editOnIdentityIconStyles = null;
const $5b5660f686f14cd3$var$rowStyles = null;
const $5b5660f686f14cd3$var$secondRowDesktopStyles = null;
const $5b5660f686f14cd3$var$identityCardRowStyles = null;
const $5b5660f686f14cd3$var$mobileRowStyles = null;
const $5b5660f686f14cd3$var$bioRowStyles = null;
const $5b5660f686f14cd3$var$columnStyles = null;
const $5b5660f686f14cd3$var$mobileColumnStyles = null;
const $5b5660f686f14cd3$var$profilePhotoStyles = null;
const $5b5660f686f14cd3$var$productsHeaderStyles = null;
const $5b5660f686f14cd3$var$productsQuestionStyles = null;
const $5b5660f686f14cd3$var$productsContentStyles = null;
const $5b5660f686f14cd3$var$modalStyles = (0, $jjlaj.css)({
    padding: "0",
    borderRadius: "0",
    height: "100%",
    "@media (max-width: 767px)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ">div": {
            borderRadius: "0",
            height: "100%",
            width: "100%",
            padding: `48px ${"var(--ds-space-200)"} ${"var(--ds-space-200)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ">div>div": {
            height: "100%"
        }
    }
});
const $5b5660f686f14cd3$var$bottomBarStyles = null;
const $5b5660f686f14cd3$var$formButtonsStyles = null;
const $5b5660f686f14cd3$var$cancelButtonStyles = {
    padding: `${"var(--ds-space-100)"} ${"var(--ds-space-150)"}`,
    marginRight: "var(--ds-space-300)"
};
const $5b5660f686f14cd3$var$closeButtonStyles = null;


/* CertificationsFullList.tsx generated by @compiled/babel-plugin v0.29.1 */ 
parcelRequire("acw62");













const $db4029a64eae59d0$var$CertificationsFullList = ({ internalId: internalId, accountId: accountId })=>{
    const { certificates: certificates } = (0, $235eb8ab1660c314$export$2e2bcd8739ae039)({
        internalId: internalId,
        status: (0, $77d0522707ddb581$export$6e66959687be02fe).ACTIVE,
        type: [
            "CERTIFICATION"
        ],
        sortField: "ACTIVE_DATE",
        sortDirection: "DESC"
    });
    const userResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ec6ff1b76abaa9b1$export$91596656064cbe02), {
        accountId: accountId
    }, {
        fetchPolicy: "store-or-network"
    });
    const userData = userResponseData.user;
    const isPersonalView = (0, $52d03cd4712fbe1d$export$2e2bcd8739ae039)(internalId);
    (0, $4b399cfb19f70f4d$export$10acc2d30344565d)(()=>(0, $5b5d3839c457cab4$export$9a1f20343cd61c4d)(isPersonalView), {
        shouldSendEvent: Boolean(certificates)
    });
    const onClickBackToProfile = ()=>{
        (0, $5b5d3839c457cab4$export$ee8d96c9d7080a5)(isPersonalView);
    };
    const BackToProfileButton = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
            to: `/profile/${internalId}`,
            onClick: onClickBackToProfile,
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1wpz1y6m _syaz1jwt _ect41q02 _1wybxjmg _k48pzul8 _vwz41bcc"
            ]),
            children: "\u2190 Back to profile"
        });
    };
    if (!certificates) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _be4bzwfg"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                "_1e0c1txw _2lx21bp4 _19pkgosd _4cvr1h6o _1bsb1faz _p12f1osq _jlq11yw0 _17frhiv4 _ffv71vd0"
            ]),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1bsb1faz _p12f1osq _1e0c1txw _2lx21bp4 _4cvr1y6m _jlq11yw0 _ffv71vd0"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BackToProfileButton, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_1wybgosd _k48pbogh _ect4kwxw _vwz4a5zd _19pk1ylp _n3td1ylp _n7zl7v06 _otyr1ylp _1bsb1osq _be4b1tcg _fipv1tcg _17fr1tcg _1mqwhiv4"
                            ]),
                            children: `${userData?.nickname}'s certifications`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b09ec013b267e49$export$2e2bcd8739ae039), {
                            testId: "certifications-full-list-title",
                            title: `${certificates.length} ${certificates.length === 1 ? "Certification" : "Certifications"}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "certifications-full-list",
                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                        "_1e0c11p5 _yv0e16hb _zulp1tcg _19pk1tcg _1bsb1osq _10lofsjm _1v57hkll _oe5xxjmg _17fr7vkz"
                    ]),
                    children: certificates?.length > 0 ? certificates.map((cert, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                "_vchhusvi _1bsb1osq _p12fp59q _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq _ovu81vd0"
                            ]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a849b9ec5f55f3e6$export$2e2bcd8739ae039), {
                                testId: `certification-card-${i}`,
                                isPersonalView: isPersonalView,
                                data: {
                                    name: cert?.name ?? null,
                                    imageUrl: cert?.imageUrl ?? null,
                                    publicUrl: cert?.imageUrl ?? null,
                                    // temporary fix
                                    nameAbbr: cert?.nameAbbr ?? null
                                }
                            })
                        }, i)) : null
                })
            ]
        })
    });
};
const $db4029a64eae59d0$var$CertificationsFullListProfileContainer = ()=>{
    const [pathProfileId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("pathProfileId");
    const profileResponseData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $fe73a947836bf836$export$9d9de7756b13ecf), {
        internalId: pathProfileId
    }, {
        fetchPolicy: "store-or-network"
    });
    const profileData = profileResponseData?.unified?.unifiedProfile;
    if (!profileData?.aaid) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Could not fetch profile data"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b08f67dec19c15db$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db4029a64eae59d0$var$CertificationsFullList, {
            internalId: pathProfileId,
            accountId: profileData.aaid
        })
    });
};
const $db4029a64eae59d0$var$styles = {
    wrapper: null,
    contentWrapper: null,
    container: null,
    title: null,
    certificationContainer: null,
    certificationItem: null,
    backLink: null
};
var $db4029a64eae59d0$export$2e2bcd8739ae039 = $db4029a64eae59d0$var$CertificationsFullListProfileContainer;







var $72885950e49249b6$var$_CompleteTransactionMutation;

const $72885950e49249b6$export$cdea5e1b8b610058 = $72885950e49249b6$var$_CompleteTransactionMutation !== void 0 ? $72885950e49249b6$var$_CompleteTransactionMutation : $72885950e49249b6$var$_CompleteTransactionMutation = (parcelRequire("049wC"));



var $acw62 = parcelRequire("acw62");



const $777675ad22ddace9$var$completeTransaction = (input)=>{
    return new Promise((resolve, reject)=>{
        (0, $2d93712440e0508b$exports.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $72885950e49249b6$export$cdea5e1b8b610058),
            variables: input,
            onCompleted: (response, errors)=>{
                const authenticateTransactionVal = response?.unified?.linking?.completeTransaction;
                if (authenticateTransactionVal?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Initialization of transaction failed", errors);
                    else errorCode = authenticateTransactionVal?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode
                    });
                } else resolve(authenticateTransactionVal?.success ?? false);
            },
            onError: (error)=>{
                console.error("Initialization of transaction failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $777675ad22ddace9$var$Complete = ()=>{
    const [encryptedToken] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("token");
    const [isCompleted, setIsCompleted] = (0, $acw62.useState)(null);
    const { calculateTimeDiff: calculateTimeDiff } = (0, $bf7744c04ecc60a1$export$2e2bcd8739ae039)();
    if (!encryptedToken) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/invalid_path"
    });
    const token = decodeURIComponent(encryptedToken);
    const loggedInUser = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5b4d113e3efb8585$export$75493bef044c2fa0), {}, {
        fetchPolicy: "store-or-network"
    })?.me?.user;
    if (!loggedInUser?.accountId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/not_authorized"
    });
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            try {
                const status = await $777675ad22ddace9$var$completeTransaction({
                    token: token
                });
                if (status) {
                    const duration = calculateTimeDiff();
                    (0, $e341ce091835a224$export$338f4d94ddfbca81)({
                        duration: duration
                    });
                    setIsCompleted(true);
                } else throw {
                    errorCode: "generic_error"
                };
            } catch (e) {
                console.error("Failed to complete transaction", e);
                const errorCodeReceived = e?.errorCode || "generic_error";
                const duration = calculateTimeDiff();
                (0, $e341ce091835a224$export$57f4cafbcf24bdad)(errorCodeReceived, "completion", {
                    duration: duration
                });
                window.open(`/user/settings?errorCode=${errorCodeReceived}`, "_self");
            }
        })();
    }, []);
    if (isCompleted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: `/settings`
    });
    else if (isCompleted === false) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error"
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {});
};
var $777675ad22ddace9$export$2e2bcd8739ae039 = $777675ad22ddace9$var$Complete;






var $3c31216b3a373bd9$var$_AuthenticateTransactionMutation;

const $3c31216b3a373bd9$export$917169cbc3b4e9b1 = $3c31216b3a373bd9$var$_AuthenticateTransactionMutation !== void 0 ? $3c31216b3a373bd9$var$_AuthenticateTransactionMutation : $3c31216b3a373bd9$var$_AuthenticateTransactionMutation = (parcelRequire("bCVIL"));




var $acw62 = parcelRequire("acw62");

/* PrimaryAccountModal.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable react/prop-types */ 

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d935d45ecc0a58cd$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $183a833228617892$export$2e2bcd8739ae039), {
        appear: true
    }, props.children);
};
var $d935d45ecc0a58cd$export$2e2bcd8739ae039 = $d935d45ecc0a58cd$var$ModalTransition;





/* radio.tsx generated by @compiled/babel-plugin v0.32.2 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $72ffb3d8dea43d8c$var$ATOMIC_GROUP_LENGTH = 5;
function $72ffb3d8dea43d8c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $72ffb3d8dea43d8c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9ca2ce5d8906bc28$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $45984e5d925e11b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45984e5d925e11b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45984e5d925e11b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45984e5d925e11b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $45984e5d925e11b5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $45984e5d925e11b5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $45984e5d925e11b5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $45984e5d925e11b5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $45984e5d925e11b5$var$_objectSpread($45984e5d925e11b5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $d7c4a4f98ddc38d4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $d7c4a4f98ddc38d4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $d7c4a4f98ddc38d4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d7c4a4f98ddc38d4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d7c4a4f98ddc38d4$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d7c4a4f98ddc38d4$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d7c4a4f98ddc38d4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $d7c4a4f98ddc38d4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $d7c4a4f98ddc38d4$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $d7c4a4f98ddc38d4$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $45984e5d925e11b5$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $73bebbfb489c0b09$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $025517dbaab8c128$export$2e2bcd8739ae039));
};


function $83279c48e63282b1$export$5bf35293e545f20c() {
    var analyticsContext = (0, $73bebbfb489c0b09$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $d29f5b3d0d51225a$export$33752cf3ee811995)(function(payload) {
        return new (0, $d7c4a4f98ddc38d4$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $128f354580737abf$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $c866d9b071fa39fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c866d9b071fa39fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c866d9b071fa39fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c866d9b071fa39fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c866d9b071fa39fc$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $83279c48e63282b1$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $128f354580737abf$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $128f354580737abf$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c866d9b071fa39fc$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $61f4dff9450671bf$export$2e2bcd8739ae039() {}


var $c18c90b304549c3f$var$_ref, $c18c90b304549c3f$var$_process, $c18c90b304549c3f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c18c90b304549c3f$var$TESTS_MODE = ($c18c90b304549c3f$var$_ref = (globalThis === null || globalThis === void 0 || ($c18c90b304549c3f$var$_process = globalThis.process) === null || $c18c90b304549c3f$var$_process === void 0 || ($c18c90b304549c3f$var$_process = $c18c90b304549c3f$var$_process.env) === null || $c18c90b304549c3f$var$_process === void 0 ? void 0 : $c18c90b304549c3f$var$_process.JEST_WORKER_ID) !== undefined, $c18c90b304549c3f$var$_ref !== void 0) ? $c18c90b304549c3f$var$_ref : false;
var $c18c90b304549c3f$var$DEBUG_MODE = !$c18c90b304549c3f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c18c90b304549c3f$var$_process2 = globalThis.process) === null || $c18c90b304549c3f$var$_process2 === void 0 || ($c18c90b304549c3f$var$_process2 = $c18c90b304549c3f$var$_process2.env) === null || $c18c90b304549c3f$var$_process2 === void 0 ? void 0 : $c18c90b304549c3f$var$_process2.NODE_ENV) !== "production";
var $c18c90b304549c3f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c18c90b304549c3f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $hPtJY = parcelRequire("hPtJY");
var $4be542ac0b2cd180$var$pkgName = "@atlaskit/platform-feature-flags";
var $4be542ac0b2cd180$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $4be542ac0b2cd180$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $4be542ac0b2cd180$var$ENV_ENABLE_PLATFORM_FF = $4be542ac0b2cd180$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4be542ac0b2cd180$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4be542ac0b2cd180$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4be542ac0b2cd180$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4be542ac0b2cd180$var$ENV_ENABLE_PLATFORM_FF || $4be542ac0b2cd180$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4be542ac0b2cd180$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $4be542ac0b2cd180$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$4be542ac0b2cd180$var$globalVar[$4be542ac0b2cd180$export$7e41b1b2bdee3f98] = $4be542ac0b2cd180$var$globalVar[$4be542ac0b2cd180$export$7e41b1b2bdee3f98] || $4be542ac0b2cd180$var$DEFAULT_PFF_GLOBAL;
function $4be542ac0b2cd180$export$f2b591175b3e424c(resolver) {
    $4be542ac0b2cd180$var$globalVar[$4be542ac0b2cd180$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $4be542ac0b2cd180$export$6333b6aff9fc6275(flagKey) {
    if ($4be542ac0b2cd180$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $c18c90b304549c3f$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4be542ac0b2cd180$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $4be542ac0b2cd180$var$globalVar[$4be542ac0b2cd180$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $514f7c66a6cd81b6$export$ba05d765b8392e5e(flagResolver) {
    (0, $4be542ac0b2cd180$export$f2b591175b3e424c)(flagResolver);
}
function $514f7c66a6cd81b6$export$470e5c2be1411c89(name) {
    return (0, $4be542ac0b2cd180$export$6333b6aff9fc6275)(name);
}
function $514f7c66a6cd81b6$export$b40ec24ac8275656(name) {
    return (0, $4be542ac0b2cd180$export$6333b6aff9fc6275)(name);
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4430f8da81177e28$export$4b84fd0e2c617bd = "#FFEBE6";
var $4430f8da81177e28$export$b34b069eff244586 = "#FFBDAD";
var $4430f8da81177e28$export$be802dd0d8b57f35 = "#FF8F73";
var $4430f8da81177e28$export$60847d42f9da92a6 = "#FF7452";
var $4430f8da81177e28$export$4a7404f376229999 = "#FF5630";
var $4430f8da81177e28$export$2010d0fb4295b346 = "#DE350B";
var $4430f8da81177e28$export$2837b5a1a71d5c02 = "#BF2600";
var $4430f8da81177e28$export$8d9596b529bbb9cf = "#FFFAE6";
var $4430f8da81177e28$export$41060a744ab0b7ae = "#FFF0B3";
var $4430f8da81177e28$export$1cc05bbbf340e559 = "#FFE380";
var $4430f8da81177e28$export$5aae31392d72caaa = "#FFC400";
var $4430f8da81177e28$export$c6930421db9fa514 = "#FFAB00";
var $4430f8da81177e28$export$59619663aa6500fb = "#FF991F";
var $4430f8da81177e28$export$874739ea9e379ab6 = "#FF8B00";
var $4430f8da81177e28$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4430f8da81177e28$export$69a3bf21b9686c2b = "#ABF5D1";
var $4430f8da81177e28$export$afbce1382ec95f73 = "#79F2C0";
var $4430f8da81177e28$export$747d86715d4175de = "#57D9A3";
var $4430f8da81177e28$export$940e1f69e873f202 = "#36B37E";
var $4430f8da81177e28$export$a49394138f7b8e85 = "#00875A";
var $4430f8da81177e28$export$6fa04827ac68a4fb = "#006644";
var $4430f8da81177e28$export$226de0355ed012f8 = "#DEEBFF";
var $4430f8da81177e28$export$8c13c2ee36917869 = "#B3D4FF";
var $4430f8da81177e28$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4430f8da81177e28$export$215b7063051591f1 = "#2684FF";
var $4430f8da81177e28$export$e62e8919cca44969 = "#0065FF";
var $4430f8da81177e28$export$b3de0ae08da2ce64 = "#0052CC";
var $4430f8da81177e28$export$a6ee3d71bc067634 = "#0747A6";
var $4430f8da81177e28$export$67f15409e87642a1 = "#669DF1";
var $4430f8da81177e28$export$f0539dbc42dbb067 = "#8FB8F6";
var $4430f8da81177e28$export$363e4475840015bb = "#EAE6FF";
var $4430f8da81177e28$export$4b0a4417ed59760f = "#C0B6F2";
var $4430f8da81177e28$export$6011520a64d9a187 = "#998DD9";
var $4430f8da81177e28$export$a7175d4e9206bc80 = "#8777D9";
var $4430f8da81177e28$export$b48405b95304b5a1 = "#6554C0";
var $4430f8da81177e28$export$c71e4279dd54a18d = "#5243AA";
var $4430f8da81177e28$export$147899de772240ec = "#403294";
var $4430f8da81177e28$export$2cf711fe14c66f06 = "#E6FCFF";
var $4430f8da81177e28$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4430f8da81177e28$export$776c9c497ef08533 = "#79E2F2";
var $4430f8da81177e28$export$69cb3ca10c1e330e = "#00C7E6";
var $4430f8da81177e28$export$9dc1ef0f3f48059b = "#00B8D9";
var $4430f8da81177e28$export$7c835c78b6fcdef8 = "#00A3BF";
var $4430f8da81177e28$export$6036577f95c3877e = "#008DA6";
var $4430f8da81177e28$export$29a4f05edc054374 = "#FFFFFF";
var $4430f8da81177e28$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4430f8da81177e28$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4430f8da81177e28$export$3e51e8f1440314ba = "#EBECF0";
var $4430f8da81177e28$export$1ce2d1575d444ceb = "#DFE1E6";
var $4430f8da81177e28$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4430f8da81177e28$export$c2e91cbeada39b8b = "#B3BAC5";
var $4430f8da81177e28$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4430f8da81177e28$export$eaa8c8a70ac22806 = "#97A0AF";
var $4430f8da81177e28$export$7c87d337fb91a97d = "#8993A4";
var $4430f8da81177e28$export$d6447c357493214f = "#7A869A";
var $4430f8da81177e28$export$f563ee71e9ee74cd = "#6B778C";
var $4430f8da81177e28$export$e2ef2124cf4024b1 = "#5E6C84";
var $4430f8da81177e28$export$eece5f492e429f08 = "#505F79";
var $4430f8da81177e28$export$c39c0fe0f26207ae = "#42526E";
var $4430f8da81177e28$export$7090862dc3038a9f = "#344563";
var $4430f8da81177e28$export$ad0bacf983b7ddaa = "#253858";
var $4430f8da81177e28$export$7d61b15e0da132af = "#172B4D";
var $4430f8da81177e28$export$fbda843f0a27fe96 = "#091E42";
var $4430f8da81177e28$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4430f8da81177e28$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4430f8da81177e28$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4430f8da81177e28$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4430f8da81177e28$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4430f8da81177e28$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4430f8da81177e28$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4430f8da81177e28$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4430f8da81177e28$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4430f8da81177e28$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4430f8da81177e28$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4430f8da81177e28$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4430f8da81177e28$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4430f8da81177e28$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4430f8da81177e28$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4430f8da81177e28$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4430f8da81177e28$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4430f8da81177e28$export$2f6319cf7d736c2a = "#E6EDFA";
var $4430f8da81177e28$export$95126bc8884d6634 = "#DCE5F5";
var $4430f8da81177e28$export$8338d8c35d44ff1 = "#CED9EB";
var $4430f8da81177e28$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4430f8da81177e28$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4430f8da81177e28$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4430f8da81177e28$export$97e81faa16a182c7 = "#8C9CB8";
var $4430f8da81177e28$export$bfe21c59123ecf33 = "#7988A3";
var $4430f8da81177e28$export$ee82aa2ea6a1558 = "#67758F";
var $4430f8da81177e28$export$682927c6ed76be02 = "#56637A";
var $4430f8da81177e28$export$91fd9994c5be9757 = "#455166";
var $4430f8da81177e28$export$d281fbfe3cff2df6 = "#3B475C";
var $4430f8da81177e28$export$3902c91d8b98a753 = "#313D52";
var $4430f8da81177e28$export$8e8133c1ba5845b5 = "#283447";
var $4430f8da81177e28$export$33ff357f6620b39 = "#202B3D";
var $4430f8da81177e28$export$633847cf062b69e0 = "#1B2638";
var $4430f8da81177e28$export$9776a6e503bdbf76 = "#121A29";
var $4430f8da81177e28$export$6c813d5160dff5db = "#0E1624";
var $4430f8da81177e28$export$3d4f271a500072a = "#0D1424";
var $4430f8da81177e28$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4430f8da81177e28$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4430f8da81177e28$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4430f8da81177e28$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4430f8da81177e28$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4430f8da81177e28$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4430f8da81177e28$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4430f8da81177e28$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4430f8da81177e28$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4430f8da81177e28$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4430f8da81177e28$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4430f8da81177e28$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4430f8da81177e28$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4430f8da81177e28$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4430f8da81177e28$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4430f8da81177e28$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4430f8da81177e28$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4430f8da81177e28$export$d2adc5dedf09fced = "#292A2E";
var $4430f8da81177e28$export$f51762073d2bb381 = "#94C748";
var $4430f8da81177e28$export$95e26d54def96891 = "#B3DF72";


var $6fc2f8a1fc7bd3a6$var$_excluded = [
    "ariaLabel",
    "isDisabled",
    "isRequired",
    "isInvalid",
    "isChecked",
    "label",
    "name",
    "onChange",
    "value",
    "testId",
    "analyticsContext"
];
var $6fc2f8a1fc7bd3a6$var$packageName = "@atlaskit/radio";
var $6fc2f8a1fc7bd3a6$var$packageVersion = "7.0.0";
var $6fc2f8a1fc7bd3a6$var$noop = (0, $61f4dff9450671bf$export$2e2bcd8739ae039);
var $6fc2f8a1fc7bd3a6$var$labelPaddingStyles = null;
var $6fc2f8a1fc7bd3a6$var$labelStyles = null;
var $6fc2f8a1fc7bd3a6$var$radioStyles = null;
var $6fc2f8a1fc7bd3a6$var$newRadioStyles = null;
var $6fc2f8a1fc7bd3a6$var$InnerRadio = /*#__PURE__*/ (0, $acw62.forwardRef)(function Radio(props, ref) {
    var ariaLabel = props.ariaLabel, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, isRequired = props.isRequired, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isChecked = props.isChecked, isChecked = _props$isChecked === void 0 ? false : _props$isChecked, label = props.label, name = props.name, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $6fc2f8a1fc7bd3a6$var$noop : _props$onChange, value = props.value, testId = props.testId, analyticsContext = props.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $6fc2f8a1fc7bd3a6$var$_excluded);
    var onChangeAnalytics = (0, $c866d9b071fa39fc$export$a4687b0234b40e28)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "radio",
        packageName: $6fc2f8a1fc7bd3a6$var$packageName,
        packageVersion: $6fc2f8a1fc7bd3a6$var$packageVersion
    });
    return /*#__PURE__*/ $acw62.createElement("label", {
        "data-testid": testId && "".concat(testId, "--radio-label"),
        "data-disabled": isDisabled ? "true" : undefined,
        className: (0, $72ffb3d8dea43d8c$export$2e2bcd8739ae039)([
            "_1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazovqm _11c81oud _mqf87wap _g7st13gf"
        ]),
        style: {
            "--_5xk3r4": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-text, ".concat((0, $4430f8da81177e28$export$fbda843f0a27fe96), ")")),
            "--_1ynhf1h": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-text-disabled, ".concat((0, $4430f8da81177e28$export$eaa8c8a70ac22806), ")"))
        }
    }, /*#__PURE__*/ $acw62.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && "".concat(testId, "--radio-input"),
        "data-invalid": isInvalid ? "true" : undefined,
        ref: ref,
        className: (0, $72ffb3d8dea43d8c$export$2e2bcd8739ae039)([
            "_1e0c1txw _1bsb1tcg _4t3i1tcg _18s8ze3t _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _19itbyy8 _2rko1q5u _13diglyw _12ji1r31 _1qu2glyw _12y31o36 _1q6q1kd8 _1151ddza _1s6weh7q _tqbwidpf _t9ec1s1q _v56415j1 _s7n4jp4b _wstuglyw _z0ai1cbz _1qdg1cbz _18postnw _16r2ucr4 _14mj1q5u _aetrb3bt _1peq1xmd _qc5orqeg _iosi1j4g _11jy1j4g _f3ett94y _19ybua6f _1d7pua6f _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1ouc _o1bd1ouc _nxi61ouc _neoe1ouc _1el21ouc _lekr1pl2 _11v71pl2 _1f8c1pl2 _s2ft1pl2 _17a11pl2 _x48asnw8 _1ib2snw8 _1yk9snw8 _gdmbsnw8 _pmm4snw8 _y2mv1ri4 _1bg4jfq9 _6tjk1ri4 _awqnjfq9 _1rvq12ci _1p9jddza _x2tz1ehr _1iwz1ehr _sj8ye8ep _jckowjs8 _1dvdddza _60akxz7c",
            (0, $514f7c66a6cd81b6$export$b40ec24ac8275656)("platform-visual-refresh-icons") && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $514f7c66a6cd81b6$export$b40ec24ac8275656)("platform-icon-control-migration") && "_t9ec1soj _z0ai120g _1qdg120g"
        ]),
        style: {
            "--_1q9y51y": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-border-width, 1px)".concat(" solid var(--radio-border-color)")),
            "--_4mkb4g": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-input, ".concat((0, $4430f8da81177e28$export$e655ef011c4aa1a2), ")")),
            "--_vnm8xo": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-border-input, ".concat((0, $4430f8da81177e28$export$d6447c357493214f), ")")),
            "--_jf353p": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-icon-inverse, ".concat((0, $4430f8da81177e28$export$e655ef011c4aa1a2), ")")),
            "--_1z08gfx": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-input-hovered, ".concat((0, $4430f8da81177e28$export$3e51e8f1440314ba), ")")),
            "--_174hl94": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-input-pressed, ".concat((0, $4430f8da81177e28$export$3e51e8f1440314ba), ")")),
            "--_1rdyq0k": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-border-width-outline, 3px)".concat(" solid ", "var(--ds-border-focused, ".concat((0, $4430f8da81177e28$export$215b7063051591f1), ")"))),
            "--_1gcp7nr": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-selected-bold, ".concat((0, $4430f8da81177e28$export$b3de0ae08da2ce64), ")")),
            "--_14y1fod": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-selected-bold-hovered, ".concat((0, $4430f8da81177e28$export$e62e8919cca44969), ")")),
            "--_9b0jbo": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-selected-bold-pressed, ".concat((0, $4430f8da81177e28$export$226de0355ed012f8), ")")),
            "--_uq1ko9": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-icon-inverse, ".concat((0, $4430f8da81177e28$export$b3de0ae08da2ce64), ")")),
            "--_m4cp67": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-icon-danger, ".concat((0, $4430f8da81177e28$export$4a7404f376229999), ")")),
            "--_r5pknd": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-background-disabled, ".concat((0, $4430f8da81177e28$export$9fdfb749e33cdf97), ")")),
            "--_1ufdgqf": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-border-disabled, ".concat((0, $4430f8da81177e28$export$9fdfb749e33cdf97), ")")),
            "--_1xmcmw9": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-icon-disabled, ".concat((0, $4430f8da81177e28$export$5f71e19f3a7ad9de), ")"))
        }
    })), label ? /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $72ffb3d8dea43d8c$export$2e2bcd8739ae039)([
            "_1yt41j1s"
        ]),
        style: {
            "--_1kppzk3": (0, $9ca2ce5d8906bc28$export$2e2bcd8739ae039)("var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"))
        }
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ var $6fc2f8a1fc7bd3a6$var$Radio = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ $acw62.createElement($6fc2f8a1fc7bd3a6$var$InnerRadio, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        ref: ref
    }));
}));
var $6fc2f8a1fc7bd3a6$export$2e2bcd8739ae039 = $6fc2f8a1fc7bd3a6$var$Radio;


const $0b06477b805dae11$var$sectionMessageWrapper = null;
const $0b06477b805dae11$var$modalContentContainer = null;
const $0b06477b805dae11$var$radioButtonContainer = null;
const $0b06477b805dae11$var$radioButtonSpacer = null;
const $0b06477b805dae11$var$eyebrowWrapper = null;
const $0b06477b805dae11$var$modalFooterStyles = null;
const $0b06477b805dae11$var$radioLabelStyle = null;
const $0b06477b805dae11$var$PrimaryAccountModal = ({ linkedEmails: linkedEmails, currentPrimaryEmail: currentPrimaryEmail, isOpen: isOpen, onPrimaryAccountSelection: onPrimaryAccountSelection })=>{
    const [selectedEmail, setSelectedEmail] = (0, $acw62.useState)(currentPrimaryEmail || "");
    const handleSubmit = ()=>{
        if (selectedEmail) onPrimaryAccountSelection(selectedEmail);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d935d45ecc0a58cd$export$2e2bcd8739ae039), {
        children: isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49f7c216070fc3db$export$2e2bcd8739ae039), {
            width: "624px",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                    "_19bv1ylp _u5f31ylp _19pkckbl"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$a8a3e93435678ff9), {
                        level: 3,
                        children: "Choose a primary account"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                            "_19pk7vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2154909317384aee$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "To proceed, select a primary account. Having a primary account ensures you retain access to your profile and achievements, even if you move companies."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$71f050e2efa708bb), {
                        size: "medium",
                        children: "LINKED ACCOUNTS"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1273dc8eae8f1aca$export$2e2bcd8739ae039), {
                        onSubmit: handleSubmit,
                        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                ...formProps,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                            "_19pk7vkz _otyrmyb0"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afe8b9e8d12362c$export$2e2bcd8739ae039), {
                                            name: "primaryAccount",
                                            defaultValue: currentPrimaryEmail,
                                            children: ({ fieldProps: fieldProps })=>linkedEmails.map((email, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fc2f8a1fc7bd3a6$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                        "_ect4oyw7 _1wyb7vkz"
                                                                    ]),
                                                                    children: email
                                                                }),
                                                                value: email,
                                                                name: fieldProps.name,
                                                                isChecked: selectedEmail === email,
                                                                onChange: ()=>setSelectedEmail(email),
                                                                // this is an odd error that occurs sometimes with ADS components. searched slack, and this is the best workaround for now
                                                                onPointerEnterCapture: undefined,
                                                                onPointerLeaveCapture: undefined
                                                            }),
                                                            index < linkedEmails.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_otyrftgi _19pkftgi"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$2e0a83ec2e27ecbb), {
                                                                    color: "var(--ds-border)",
                                                                    height: 2
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                                    "_19pkftgi _otyrftgi"
                                                                ])
                                                            })
                                                        ]
                                                    }, email))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $246b20cce3342d64$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                                "_2hwx8am7"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$353f5b6fc5456de1), {
                                                label: "Save as primary",
                                                appearance: (0, $cb0e8fe57b0fd046$export$261c9483fc4a455a).PRIMARY,
                                                type: "submit",
                                                as: "button",
                                                disabled: !selectedEmail
                                            })
                                        })
                                    })
                                ]
                            })
                    })
                ]
            })
        })
    });
};
var $0b06477b805dae11$export$2e2bcd8739ae039 = $0b06477b805dae11$var$PrimaryAccountModal;



var $829c37f8544eb841$var$_UpdateTransactionPrimaryMutation;

const $829c37f8544eb841$export$de34b5356ab74d99 = $829c37f8544eb841$var$_UpdateTransactionPrimaryMutation !== void 0 ? $829c37f8544eb841$var$_UpdateTransactionPrimaryMutation : $829c37f8544eb841$var$_UpdateTransactionPrimaryMutation = (parcelRequire("9IH1r"));



const $0bac49f839fe37ad$var$REACT_APP_ACCOUNT_LINK_BASE_URL = "https://community-link.atlassian.com", $0bac49f839fe37ad$var$REACT_APP_UPP_BASE_URL = "https://community.atlassian.com";
const $0bac49f839fe37ad$var$getRedirectOptionalParams = (email)=>{
    const redirectEmail = email || window.sessionStorage.getItem("sourceLinkingEmail") || null;
    window.sessionStorage.removeItem("sourceLinkingEmail");
    return redirectEmail ? {
        email: redirectEmail,
        prompt: "none"
    } : {};
};
const $0bac49f839fe37ad$var$authenticateTransaction = (input)=>{
    return new Promise((resolve, reject)=>{
        (0, $2d93712440e0508b$exports.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $3c31216b3a373bd9$export$917169cbc3b4e9b1),
            variables: input,
            onCompleted: (response, errors)=>{
                const authenticateTransactionRes = response?.unified?.linking?.authenticateLinkingWithLoggedInAccount;
                const account1Email = authenticateTransactionRes?.account1?.emailId;
                if (authenticateTransactionRes?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Initialization of transaction failed", errors);
                    else errorCode = authenticateTransactionRes?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode,
                        account1Email: account1Email
                    });
                } else if (!authenticateTransactionRes?.token) reject({
                    errorCode: "token_not_found",
                    account1Email: account1Email
                });
                else resolve(authenticateTransactionRes);
            },
            onError: (error)=>{
                console.error("Initialization of transaction failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $0bac49f839fe37ad$var$updateTransactionPrimary = (input)=>{
    return new Promise((resolve, reject)=>{
        (0, $2d93712440e0508b$exports.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $829c37f8544eb841$export$de34b5356ab74d99),
            variables: input,
            onCompleted: (response, errors)=>{
                const authenticateTransactionRes = response?.unified?.linking?.updateLinkingWithPrimaryAccountAaid;
                if (authenticateTransactionRes?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Initialization of transaction failed", errors);
                    else errorCode = authenticateTransactionRes?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode
                    });
                } else resolve(authenticateTransactionRes?.success ?? false);
            },
            onError: (error)=>{
                console.error("Initialization of transaction failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $0bac49f839fe37ad$var$Authenticate = ()=>{
    const [encryptedToken] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("token");
    const [authenticationResponse, setAuthenticationResponse] = (0, $acw62.useState)(null);
    const { setTimeStamp: setTimeStamp } = (0, $bf7744c04ecc60a1$export$2e2bcd8739ae039)();
    if (window.location.origin !== $0bac49f839fe37ad$var$REACT_APP_ACCOUNT_LINK_BASE_URL || !encryptedToken) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/invalid_path"
    });
    const token = decodeURIComponent(encryptedToken);
    const loggedInUser = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $5b4d113e3efb8585$export$75493bef044c2fa0), {}, {
        fetchPolicy: "store-or-network"
    })?.me?.user;
    if (!loggedInUser?.accountId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/not_authorized"
    });
    const handlePrimaryAccountSelection = (selectedEmailId)=>{
        const account1 = authenticationResponse?.account1;
        const account2 = authenticationResponse?.account2;
        const primaryAccountAaid = selectedEmailId === account1?.emailId ? account1.aaid : account2?.aaid;
        (async ()=>{
            try {
                const success = await $0bac49f839fe37ad$var$updateTransactionPrimary({
                    token: token,
                    aaid: primaryAccountAaid
                });
                if (success) proceedToCompletion(token, account1?.emailId ?? "");
                else backToSettings("generic_error", account1?.emailId ?? "");
            } catch (e) {
                console.error("Failed to handle primary account selection linking", e);
                const errorCodeReceived = e?.errorCode || "generic_error";
                backToSettings(errorCodeReceived);
            }
        })();
    };
    const proceedToCompletion = (0, $acw62.useCallback)((token, email)=>{
        const encryptedAuthenticatedToken = encodeURIComponent(token);
        const completeUrl = `${$0bac49f839fe37ad$var$REACT_APP_UPP_BASE_URL}/user/settings/complete/${encryptedAuthenticatedToken}`;
        if (email) {
            const optionalParams = $0bac49f839fe37ad$var$getRedirectOptionalParams(email);
            const authUrl = (0, $7ef8d8aa49ecf9c6$export$1ecea9365b9c733c)("login", {
                experience: "entry-auth",
                redirectUrl: encodeURIComponent(completeUrl),
                ...optionalParams
            });
            window.open(authUrl, "_self");
        } else window.open(completeUrl, "_self");
        setAuthenticationResponse({
            success: true
        });
    }, []);
    const backToSettings = (0, $acw62.useCallback)((errorCode, email)=>{
        const completeUrl = `${$0bac49f839fe37ad$var$REACT_APP_UPP_BASE_URL}/user/settings?errorCode=${errorCode}`;
        if (email) {
            const optionalParams = $0bac49f839fe37ad$var$getRedirectOptionalParams(email);
            const authUrl = (0, $7ef8d8aa49ecf9c6$export$1ecea9365b9c733c)("login", {
                experience: "entry-auth",
                redirectUrl: encodeURIComponent(completeUrl),
                ...optionalParams
            });
            window.open(authUrl, "_self");
        } else window.open(completeUrl, "_self");
        setAuthenticationResponse({
            success: true
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            try {
                setTimeStamp(); // Set timestamp when actual linking starts
                const authenticationResponse = await $0bac49f839fe37ad$var$authenticateTransaction({
                    token: token
                });
                if (authenticationResponse.token && (authenticationResponse.primaryAccountIndex === 1 || authenticationResponse.primaryAccountIndex === 2)) proceedToCompletion(authenticationResponse.token, authenticationResponse.account1?.emailId || "");
                else setAuthenticationResponse(authenticationResponse);
            } catch (e) {
                console.error("Failed to authenticate linking", e);
                const errorCodeReceived = e?.errorCode || "generic_error";
                const account1Email = e?.account1Email || "";
                backToSettings(errorCodeReceived, account1Email);
            }
        })();
    }, []);
    if (authenticationResponse?.success === false) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/generic_error"
    });
    if (authenticationResponse?.token && authenticationResponse?.primaryAccountIndex !== 1 && authenticationResponse?.primaryAccountIndex !== 2) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b06477b805dae11$export$2e2bcd8739ae039), {
        linkedEmails: [
            authenticationResponse.account1?.emailId || "",
            authenticationResponse.account2?.emailId || ""
        ],
        onPrimaryAccountSelection: handlePrimaryAccountSelection,
        isOpen: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {});
};
var $0bac49f839fe37ad$export$2e2bcd8739ae039 = $0bac49f839fe37ad$var$Authenticate;




var $acw62 = parcelRequire("acw62");


var $39fa4134cc256f3e$var$_GetExistingOrNewProfileFromKhorosUserIdMutation;

const $39fa4134cc256f3e$export$b6f7d0edce05f833 = $39fa4134cc256f3e$var$_GetExistingOrNewProfileFromKhorosUserIdMutation !== void 0 ? $39fa4134cc256f3e$var$_GetExistingOrNewProfileFromKhorosUserIdMutation : $39fa4134cc256f3e$var$_GetExistingOrNewProfileFromKhorosUserIdMutation = (parcelRequire("fST0w"));




const $f6b37eb3220053d4$var$connectKhorosUserToUpp = (khorosUserId)=>{
    return new Promise((resolve, reject)=>{
        (0, $2d93712440e0508b$exports.commitMutation)((0, $b0a24095f82369bb$export$6bc7b24d4e862158), {
            mutation: (0, $39fa4134cc256f3e$export$b6f7d0edce05f833),
            variables: {
                khorosUserId: khorosUserId
            },
            onCompleted: (response, errors)=>{
                const getProfileFromKhoros = response?.unified?.profile?.getExistingOrNewProfileFromKhorosUserId;
                if (getProfileFromKhoros?.success === false || errors) {
                    let errorCode = "generic_error";
                    if (errors) console.error("Fetching profile for khoros user id failed", errors);
                    else errorCode = getProfileFromKhoros?.errors?.[0]?.code || "generic_error";
                    reject({
                        errorCode: errorCode
                    });
                } else resolve(getProfileFromKhoros?.unifiedProfile ?? null);
            },
            onError: (error)=>{
                console.error("Fetching profile for khoros user id failed", error);
                reject({
                    errorCode: "generic_error"
                });
            }
        });
    });
};
const $f6b37eb3220053d4$var$Connect = ()=>{
    const [appname] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("appname");
    const [khorosUserId] = (0, $2b48cf5702e8d29d$export$8c8591dcd57728e6)("id");
    const [responseStatus, setResponseStatus] = (0, $acw62.useState)(null);
    const [internalId, setInternalId] = (0, $acw62.useState)(null);
    if (appname !== "forums" || !khorosUserId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/invalid_path"
    });
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            try {
                const khorosUserUppProfile = await $f6b37eb3220053d4$var$connectKhorosUserToUpp(khorosUserId);
                const internalId = khorosUserUppProfile?.internalId;
                if (internalId) {
                    setInternalId(internalId);
                    setResponseStatus(true);
                }
            } catch (e) {
                setResponseStatus(false);
            }
        })();
    }, []);
    if (responseStatus === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {});
    else if (responseStatus === true && internalId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: `/profile/${internalId}`
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/invalid_path"
    });
};
var $f6b37eb3220053d4$export$2e2bcd8739ae039 = $f6b37eb3220053d4$var$Connect;


const $b3c1eeb19c22229f$var$homeRoute = {
    name: "home",
    path: "/",
    exact: true,
    component: (0, $630eea5ce1cff89e$export$2e2bcd8739ae039)
};
/**
 * As of now, Need to support both /:id and /.
 * /:id is required for vanity url redirection and
 * / is used during within app navigation. This uses session information to obtain aaid.
 */ const $b3c1eeb19c22229f$var$groupsRoute = {
    name: "groups",
    path: "/profile/:pathProfileId/groups",
    exact: true,
    component: (0, $d1cb8e8fe2e334f7$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$badgesRoute = {
    name: "badges",
    path: "/profile/:pathProfileId/badges",
    exact: true,
    component: (0, $2fd427e8cffe987d$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$connectRoute = {
    name: "connect",
    path: "/connect/:appname/:id",
    exact: true,
    component: (0, $f6b37eb3220053d4$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$certificationsRoute = {
    name: "certifications",
    path: "/profile/:pathProfileId/certifications",
    exact: true,
    component: (0, $db4029a64eae59d0$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$profileRoute = {
    name: "profile",
    path: "/profile/:pathProfileId",
    exact: true,
    component: (0, $e2b8f23d4e767bfa$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$settingsRoute = {
    name: "settings",
    path: "/settings",
    exact: true,
    component: (0, $727171566fe8dac8$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$settingsCompleteRoute = {
    name: "complete",
    path: "/settings/complete/:token",
    exact: true,
    component: (0, $777675ad22ddace9$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$authenticateRoute = {
    name: "authenticate",
    path: "/authenticate/:token",
    exact: true,
    component: (0, $0bac49f839fe37ad$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$editProfileRoute = {
    name: "edit-profile",
    path: "/profile/:pathProfileId/edit",
    exact: true,
    component: (0, $5b5660f686f14cd3$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$defaultComponentRoute = {
    name: "404",
    path: "",
    component: (0, $22e87b22cf7071d9$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$var$errorRoute = {
    name: "error",
    path: "/error/:errorId",
    exact: true,
    component: (0, $ce3e35d292696439$export$2e2bcd8739ae039)
};
const $b3c1eeb19c22229f$export$61147a57d3c24ac8 = [
    $b3c1eeb19c22229f$var$homeRoute,
    $b3c1eeb19c22229f$var$connectRoute,
    $b3c1eeb19c22229f$var$settingsRoute,
    $b3c1eeb19c22229f$var$authenticateRoute,
    $b3c1eeb19c22229f$var$settingsCompleteRoute,
    $b3c1eeb19c22229f$var$profileRoute,
    $b3c1eeb19c22229f$var$editProfileRoute,
    $b3c1eeb19c22229f$var$certificationsRoute,
    $b3c1eeb19c22229f$var$groupsRoute,
    $b3c1eeb19c22229f$var$badgesRoute,
    $b3c1eeb19c22229f$var$errorRoute,
    $b3c1eeb19c22229f$var$defaultComponentRoute
];





var $acw62 = parcelRequire("acw62");







function $48f995eee78c0a2d$var$getLoginUrl(queryParamValues, env) {
    if ((0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) return $48f995eee78c0a2d$var$getHlvVanillaLoginUrl(env);
    return (0, $768c2bb36d671034$exports.getCommunityLoginUrl)(queryParamValues, env);
}
function $48f995eee78c0a2d$var$getLogoutUrl(queryParamValues, env) {
    if ((0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) return $48f995eee78c0a2d$var$getHlvVanillaLogoutUrl(env);
    return (0, $768c2bb36d671034$exports.getCommunityLogoutUrl)(queryParamValues, env);
}
const $48f995eee78c0a2d$var$HLV_LOGIN_URL_CONFIG = {
    [(0, $b4f35ae695e9f7f6$export$be46596bc6608f3b).LOCAL]: {
        communityBaseUrl: "https://community.dev.atlassian.com",
        identityLoginUrl: "https://id.stg.internal.atlassian.com/login",
        identitySignupUrl: "https://id.stg.internal.atlassian.com/signup",
        identityLogoutUrl: "https://id.stg.internal.atlassian.com/logout"
    },
    [(0, $b4f35ae695e9f7f6$export$be46596bc6608f3b).DEV]: {
        communityBaseUrl: "https://community.dev.atlassian.com",
        identityLoginUrl: "https://id.stg.internal.atlassian.com/login",
        identitySignupUrl: "https://id.stg.internal.atlassian.com/signup",
        identityLogoutUrl: "https://id.stg.internal.atlassian.com/logout"
    },
    [(0, $b4f35ae695e9f7f6$export$be46596bc6608f3b).STAGING]: {
        communityBaseUrl: "https://community.stg.atlassian.com",
        identityLoginUrl: "https://id.stg.internal.atlassian.com/login",
        identitySignupUrl: "https://id.stg.internal.atlassian.com/signup",
        identityLogoutUrl: "https://id.stg.internal.atlassian.com/logout"
    },
    [(0, $b4f35ae695e9f7f6$export$be46596bc6608f3b).PROD]: {
        communityBaseUrl: "https://community.atlassian.com",
        identityLoginUrl: "https://id.atlassian.com/login",
        identitySignupUrl: "https://id.atlassian.com/signup",
        identityLogoutUrl: "https://id.atlassian.com/logout"
    }
};
const $48f995eee78c0a2d$var$getHlvVanillaEntryBaseUrl = (communityBaseUrl)=>"https://atlassian.vanillacommunities.com";
const $48f995eee78c0a2d$var$getHlvVanillaForumsBaseUrl = (env)=>{
    const { communityBaseUrl: communityBaseUrl } = $48f995eee78c0a2d$var$HLV_LOGIN_URL_CONFIG[env];
    return "https://atlassian.vanillacommunities.com";
};
const $48f995eee78c0a2d$var$getHlvVanillaAppButtonHrefOverrides = (env)=>{
    if (!(0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) return undefined;
    const forumsBaseUrl = $48f995eee78c0a2d$var$getHlvVanillaForumsBaseUrl(env);
    return {
        [(0, $cb0e8fe57b0fd046$export$93d048dc21eb282a).FORUMS]: {
            loggedIn: forumsBaseUrl,
            loggedOut: forumsBaseUrl
        }
    };
};
function $48f995eee78c0a2d$var$getHlvVanillaLoginUrl(env) {
    const { communityBaseUrl: communityBaseUrl, identityLoginUrl: identityLoginUrl } = $48f995eee78c0a2d$var$HLV_LOGIN_URL_CONFIG[env];
    const entryBaseUrl = $48f995eee78c0a2d$var$getHlvVanillaEntryBaseUrl(communityBaseUrl);
    const continueUrl = `${entryBaseUrl}/entry/signin?Target=${encodeURIComponent(entryBaseUrl)}`;
    return `${identityLoginUrl}?application=community--entry-auth&continue=${encodeURIComponent(continueUrl)}`;
}
function $48f995eee78c0a2d$var$getHlvVanillaLogoutUrl(env) {
    const { communityBaseUrl: communityBaseUrl, identityLogoutUrl: identityLogoutUrl } = $48f995eee78c0a2d$var$HLV_LOGIN_URL_CONFIG[env];
    const entryBaseUrl = $48f995eee78c0a2d$var$getHlvVanillaEntryBaseUrl(communityBaseUrl);
    const targetUrl = "https://atlassian.vanillacommunities.com";
    const continueUrl = `${entryBaseUrl}/entry/signout?Target=${encodeURIComponent(targetUrl)}`;
    return `${identityLogoutUrl}?application=community--entry-auth&continue=${encodeURIComponent(continueUrl)}`;
}
function $48f995eee78c0a2d$var$getSignupUrl(queryParamValues, env) {
    if ((0, $4fca6bd638ae6930$export$73f46a93e1216cfe)()) {
        const { communityBaseUrl: communityBaseUrl, identitySignupUrl: identitySignupUrl } = $48f995eee78c0a2d$var$HLV_LOGIN_URL_CONFIG[env];
        const entryBaseUrl = $48f995eee78c0a2d$var$getHlvVanillaEntryBaseUrl(communityBaseUrl);
        const targetUrl = `${"https://atlassian.vanillacommunities.com"}/user`;
        const continueUrl = `${entryBaseUrl}/entry/register?Target=${encodeURIComponent(targetUrl)}`;
        return `${identitySignupUrl}?application=community--entry-auth&continue=${encodeURIComponent(continueUrl)}`;
    }
    return (0, $7ef8d8aa49ecf9c6$export$1ecea9365b9c733c)("signup", queryParamValues);
}
const $48f995eee78c0a2d$export$ef8da11641c635de = ()=>{
    const currentUrl = globalThis?.location?.href ?? window?.location?.href ?? "";
    const communityUrl = `${"https://community.atlassian.com"}`;
    let updatedUrl;
    // temporary fix: conx-700
    if (currentUrl.includes("/settings")) {
        const url = new URL(currentUrl);
        url.searchParams.delete("errorCode");
        updatedUrl = `${url.origin}${url.pathname}${url.search}`;
    } else updatedUrl = currentUrl;
    const currentPage = encodeURIComponent(updatedUrl);
    const { accountId: accountId, name: name, picture: picture, email: email } = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)() || {};
    const isLoggedIn = (0, $e68713997378eddf$export$2e2bcd8739ae039)();
    const normalizedUser = {
        id: accountId || "",
        publicName: name || "",
        avatar: picture
    };
    const loginHref = (0, $acw62.useMemo)(()=>$48f995eee78c0a2d$var$getLoginUrl({
            experience: "entry-auth",
            email: email || "",
            redirectUrl: currentPage
        }, (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)()), [
        currentPage
    ]);
    const logoutHref = (0, $acw62.useMemo)(()=>{
        // CONX-892: When a user logs out from settings page, redirect them to the home page
        const redirectUrl = decodeURIComponent(currentPage).endsWith("/user/settings") ? encodeURIComponent(communityUrl) : currentPage;
        return $48f995eee78c0a2d$var$getLogoutUrl({
            experience: "entry-auth",
            email: email || "",
            redirectUrl: redirectUrl
        }, (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)());
    }, [
        currentPage
    ]);
    const signupHref = (0, $acw62.useMemo)(()=>$48f995eee78c0a2d$var$getSignupUrl({
            experience: "entry-auth",
            email: email || "",
            redirectUrl: currentPage
        }, (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)()), [
        currentPage
    ]);
    const switchHref = (0, $acw62.useMemo)(()=>(0, $4fca6bd638ae6930$export$c70e28e0bbfc9705)() ? $48f995eee78c0a2d$var$getLoginUrl({
            redirectUrl: currentPage,
            experience: "entry-auth",
            prompt: "select_account"
        }, (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)()) : "", [
        currentPage
    ]);
    const appButtonHrefOverrides = (0, $acw62.useMemo)(()=>$48f995eee78c0a2d$var$getHlvVanillaAppButtonHrefOverrides((0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)()), []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$901cb8c9de2be2aa), {
            currentApp: (0, $cb0e8fe57b0fd046$export$93d048dc21eb282a).PROFILE,
            isLoggedIn: isLoggedIn,
            user: normalizedUser,
            loginHref: loginHref,
            logoutHref: logoutHref,
            signupHref: signupHref,
            switchHref: switchHref,
            appButtonHrefOverrides: appButtonHrefOverrides,
            showNewMenu: (0, $4fca6bd638ae6930$export$ded3174c200d604a)(),
            onAnalyticsSendEvent: (type, payload)=>(0, $768c2bb36d671034$exports.CommunityAnalyticsClient).sendEvent(type, payload),
            email: email || ""
        })
    });
};





const $58dcafbbd6a14d1d$export$a06f1c675e846f6f = ()=>{
    const user = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)();
    const isLoggedIn = !!user;
    const email = user?.email || "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb0e8fe57b0fd046$export$7a92b4adf6bd95bb), {
        isLoggedIn: isLoggedIn,
        email: email
    });
};




var $acw62 = parcelRequire("acw62");




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7a8edf80f542b65c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $54de22820fe8f5c8$export$31499a9cd224b78c = "8.27.0";


/** Get's the global object for the current JavaScript runtime */ const $daf9a5aa340ffc23$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $daf9a5aa340ffc23$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $daf9a5aa340ffc23$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] = __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $eddf779ebbe9b538$var$PREFIX = "Sentry Logger ";
const $eddf779ebbe9b538$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $eddf779ebbe9b538$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $eddf779ebbe9b538$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($eddf779ebbe9b538$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $eddf779ebbe9b538$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $eddf779ebbe9b538$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $7a8edf80f542b65c$export$16a28057038b10ef) $eddf779ebbe9b538$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $eddf779ebbe9b538$export$cda52e2a8927a2ca(()=>{
                (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console[name](`${$eddf779ebbe9b538$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $eddf779ebbe9b538$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $eddf779ebbe9b538$export$af88d00dbe7f521 = $eddf779ebbe9b538$var$makeLogger();


const $53d728fa04e56ec9$var$STACKTRACE_FRAME_LIMIT = 50;
const $53d728fa04e56ec9$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $53d728fa04e56ec9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $53d728fa04e56ec9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $53d728fa04e56ec9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $53d728fa04e56ec9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($53d728fa04e56ec9$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $53d728fa04e56ec9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $53d728fa04e56ec9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $53d728fa04e56ec9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $53d728fa04e56ec9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $53d728fa04e56ec9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($53d728fa04e56ec9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($53d728fa04e56ec9$var$STRIP_FRAME_REGEXP.test($53d728fa04e56ec9$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($53d728fa04e56ec9$var$STRIP_FRAME_REGEXP.test($53d728fa04e56ec9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $53d728fa04e56ec9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $53d728fa04e56ec9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $53d728fa04e56ec9$export$27c7e15d453fc0ac
        }));
}
function $53d728fa04e56ec9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $53d728fa04e56ec9$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $53d728fa04e56ec9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $53d728fa04e56ec9$var$defaultFunctionName;
        return fn.name || $53d728fa04e56ec9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $53d728fa04e56ec9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $53d728fa04e56ec9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $3fec3b92cacfb9e4$var$handlers = {};
const $3fec3b92cacfb9e4$var$instrumented = {};
/** Add a handler function. */ function $3fec3b92cacfb9e4$export$a4e09611e30da72e(type, handler) {
    $3fec3b92cacfb9e4$var$handlers[type] = $3fec3b92cacfb9e4$var$handlers[type] || [];
    $3fec3b92cacfb9e4$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $3fec3b92cacfb9e4$export$b17eab759a1cb5fe() {
    Object.keys($3fec3b92cacfb9e4$var$handlers).forEach((key)=>{
        $3fec3b92cacfb9e4$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $3fec3b92cacfb9e4$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$3fec3b92cacfb9e4$var$instrumented[type]) {
        instrumentFn();
        $3fec3b92cacfb9e4$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $3fec3b92cacfb9e4$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $3fec3b92cacfb9e4$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $53d728fa04e56ec9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $9ddc5321bbc17588$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$e6127cc7fe7395c3(wat) {
    switch($9ddc5321bbc17588$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $9ddc5321bbc17588$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$var$isBuiltin(wat, className) {
    return $9ddc5321bbc17588$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$9f9636d330b71954(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$ef9e2056653f0c8e(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$12e869b2a583f783(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$844ec244b1367d54(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$c3825b437cbdea5c(wat) {
    return wat === null || $9ddc5321bbc17588$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$53b83ca8eaab0383(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $9ddc5321bbc17588$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $9ddc5321bbc17588$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$49841c62b9eff15(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9ddc5321bbc17588$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$bc2894c7158efbac(wat) {
    return $9ddc5321bbc17588$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



const $b1794bb8b282584f$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
const $b1794bb8b282584f$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b1794bb8b282584f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b1794bb8b282584f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b1794bb8b282584f$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b1794bb8b282584f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($b1794bb8b282584f$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9ddc5321bbc17588$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $b1794bb8b282584f$export$1cfafeee2987818b() {
    try {
        return $b1794bb8b282584f$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1794bb8b282584f$export$c660c1f3ab49225c(selector) {
    if ($b1794bb8b282584f$var$WINDOW.document && $b1794bb8b282584f$var$WINDOW.document.querySelector) return $b1794bb8b282584f$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precendence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b1794bb8b282584f$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b1794bb8b282584f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $ef17463c720dc68b$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $ef17463c720dc68b$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ef17463c720dc68b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9ddc5321bbc17588$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $ef17463c720dc68b$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9ddc5321bbc17588$export$844ec244b1367d54)(value)) return false;
    if ((0, $9ddc5321bbc17588$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9ddc5321bbc17588$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $ef17463c720dc68b$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$ef17463c720dc68b$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7c0b78736d11cf4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $7c0b78736d11cf4a$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7c0b78736d11cf4a$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7c0b78736d11cf4a$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7c0b78736d11cf4a$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $7c0b78736d11cf4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $7c0b78736d11cf4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $7c0b78736d11cf4a$export$62ff257738bf57f5(value) {
    if ((0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$7c0b78736d11cf4a$var$getOwnProperties(value)
    };
    else if ((0, $9ddc5321bbc17588$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $7c0b78736d11cf4a$var$serializeEventTarget(value.target),
            currentTarget: $7c0b78736d11cf4a$var$serializeEventTarget(value.currentTarget),
            ...$7c0b78736d11cf4a$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $9ddc5321bbc17588$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7c0b78736d11cf4a$var$serializeEventTarget(target) {
    try {
        return (0, $9ddc5321bbc17588$export$45a5e7f76e0caa8d)(target) ? (0, $b1794bb8b282584f$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $7c0b78736d11cf4a$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7c0b78736d11cf4a$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7c0b78736d11cf4a$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $ef17463c720dc68b$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $ef17463c720dc68b$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $7c0b78736d11cf4a$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7c0b78736d11cf4a$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7c0b78736d11cf4a$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($7c0b78736d11cf4a$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $7c0b78736d11cf4a$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($7c0b78736d11cf4a$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $7c0b78736d11cf4a$var$isPojo(input) {
    if (!(0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7c0b78736d11cf4a$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $a6e59daa000c77fc$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a6e59daa000c77fc$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a6e59daa000c77fc$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a6e59daa000c77fc$var$WINDOW && !!$a6e59daa000c77fc$var$WINDOW.history.pushState && !!$a6e59daa000c77fc$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);


let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    if (!(0, $a6e59daa000c77fc$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate;
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}




const $f43df6ba426daa1c$export$9ca9946bd449ac06 = "baggage";
const $f43df6ba426daa1c$export$6e69537d67fa20f = "sentry-";
const $f43df6ba426daa1c$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $f43df6ba426daa1c$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $f43df6ba426daa1c$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $f43df6ba426daa1c$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($f43df6ba426daa1c$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($f43df6ba426daa1c$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $f43df6ba426daa1c$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$f43df6ba426daa1c$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $f43df6ba426daa1c$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $f43df6ba426daa1c$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9ddc5321bbc17588$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $f43df6ba426daa1c$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $f43df6ba426daa1c$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $f43df6ba426daa1c$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $f43df6ba426daa1c$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $f43df6ba426daa1c$export$bdd844ddb2def819) {
            (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $f61010b781c81ec1$export$19f53698e68b2496() {
    const gbl = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $f61010b781c81ec1$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $f61010b781c81ec1$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $f61010b781c81ec1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $f61010b781c81ec1$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $f61010b781c81ec1$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $f61010b781c81ec1$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $f61010b781c81ec1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $f61010b781c81ec1$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $f61010b781c81ec1$export$d364f2020ab30578(input) {
    const match = input.match($f61010b781c81ec1$var$SEMVER_REGEXP) || [];
    const major = $f61010b781c81ec1$var$_parseInt(match[1]);
    const minor = $f61010b781c81ec1$var$_parseInt(match[2]);
    const patch = $f61010b781c81ec1$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $f61010b781c81ec1$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $ef17463c720dc68b$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $ef17463c720dc68b$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $ef17463c720dc68b$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $f61010b781c81ec1$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $f61010b781c81ec1$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $fb06ed6aa7675875$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $fb06ed6aa7675875$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($fb06ed6aa7675875$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $fb06ed6aa7675875$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $fb06ed6aa7675875$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $f43df6ba426daa1c$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        spanId: (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16),
        spanId: (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $fb06ed6aa7675875$export$f35d907436da45cf(traceId = (0, $f61010b781c81ec1$export$19f53698e68b2496)(), spanId = (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


const $dce7651ce4194f00$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $dce7651ce4194f00$export$7740643b9eeaf0c4() {
    return Date.now() / $dce7651ce4194f00$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $dce7651ce4194f00$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $dce7651ce4194f00$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $dce7651ce4194f00$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $dce7651ce4194f00$export$ee52dced521e3e18 = $dce7651ce4194f00$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $dce7651ce4194f00$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $dce7651ce4194f00$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $dce7651ce4194f00$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $dce7651ce4194f00$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $dce7651ce4194f00$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $dce7651ce4194f00$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1));
    return 0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $54de22820fe8f5c8$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] = __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] || {};
}





/**
 * Returns a new minimal propagation context
 */ function $8cd423ca54f15ed2$export$37f0f2f9cf343e5e() {
    return {
        traceId: (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        spanId: (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $33c387bb26fe522d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = (0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $33c387bb26fe522d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this._propagationContext = (0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $33c387bb26fe522d$export$775b6bb06e53a214 = $33c387bb26fe522d$var$ScopeClass;


/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $daf9a5aa340ffc23$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $daf9a5aa340ffc23$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}




/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}







/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $daf9a5aa340ffc23$export$7e223ec222791509)("globalScope", ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}



/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $deb2e427fa07e3b2$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $deb2e427fa07e3b2$export$2e7205e45c58797d(span) {
    const storage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $deb2e427fa07e3b2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * The id of the profile that this span occured in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = "sentry.profile_id";
const $068c396dceb690a1$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $068c396dceb690a1$export$b016f89ac1066ec = "cache.hit";
const $068c396dceb690a1$export$3110e4c3f4386399 = "cache.key";
const $068c396dceb690a1$export$86be76deee227ff2 = "cache.item_size";


const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $fb06ed6aa7675875$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
                status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
                op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
                origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
                _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $36b15c0d755e29f6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $36b15c0d755e29f6$export$1be426a8e585c83e();
    if (span) (0, $deb2e427fa07e3b2$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}



/**
 * Adds a measurement to the current active transaction.
 */ function $3ed76239c787a980$export$7cc31b475d33a706(name, value, unit) {
    const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) rootSpan.addEvent(name, {
        [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: value,
        [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: unit
    });
}
/**
 * Convert timed events to measurements.
 */ function $3ed76239c787a980$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $068c396dceb690a1$export$f5f95cff026507b5];
        const value = attributes[0, $068c396dceb690a1$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}





/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a328b345a75725bb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a328b345a75725bb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $a328b345a75725bb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e426c875bd1d2890$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}





const $3592a0510b526070$export$849dbeeeda01ae98 = "production";





/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed((0, $36b15c0d755e29f6$export$92d8c23565496537)(span).trace_id || "", client);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $f43df6ba426daa1c$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const jsonSpan = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== "url" && name) dsc.transaction = name;
    dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $f43df6ba426daa1c$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $09ada9a941cee5f6$export$2f3d84e767c9592b(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $09ada9a941cee5f6$export$b77c830667a4d630(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(msg);
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db2bd6d2ef458b60$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") sampleRate = options.tracesSampler(samplingContext);
    else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $d899755a957e1f50$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being comliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being comliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being comliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}







/** Regular expression used to parse a Dsn. */ const $3a0c11012bdf3bae$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $3a0c11012bdf3bae$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $3a0c11012bdf3bae$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $3a0c11012bdf3bae$export$b892860177f70a30(str) {
    const match = $3a0c11012bdf3bae$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $3a0c11012bdf3bae$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $3a0c11012bdf3bae$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $3a0c11012bdf3bae$var$validateDsn(dsn) {
    if (!(0, $7a8edf80f542b65c$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$3a0c11012bdf3bae$var$isValidProtocol(protocol)) {
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $3a0c11012bdf3bae$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $3a0c11012bdf3bae$export$b892860177f70a30(from) : $3a0c11012bdf3bae$var$dsnFromComponents(from);
    if (!components || !$3a0c11012bdf3bae$var$validateDsn(components)) return undefined;
    return components;
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $a9e7543d7f9a899b$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $95721a1f8e4d79f8$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $95721a1f8e4d79f8$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $95721a1f8e4d79f8$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $95721a1f8e4d79f8$export$a3295358bff77e(object, depth);
    if ($95721a1f8e4d79f8$var$jsonSize(normalized) > maxSize) return $95721a1f8e4d79f8$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $95721a1f8e4d79f8$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $a9e7543d7f9a899b$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !Number.isNaN(value)) return value;
    const stringified = $95721a1f8e4d79f8$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $95721a1f8e4d79f8$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $7c0b78736d11cf4a$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $95721a1f8e4d79f8$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $95721a1f8e4d79f8$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $9ddc5321bbc17588$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $9ddc5321bbc17588$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $53d728fa04e56ec9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $95721a1f8e4d79f8$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $95721a1f8e4d79f8$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $95721a1f8e4d79f8$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $95721a1f8e4d79f8$var$jsonSize(value) {
    return $95721a1f8e4d79f8$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $95721a1f8e4d79f8$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $19ddf33da467375a$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $19ddf33da467375a$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $19ddf33da467375a$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $19ddf33da467375a$export$604a45d95a155e2b(envelope, types) {
    return $19ddf33da467375a$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $19ddf33da467375a$var$encodeUTF8(input) {
    return (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $19ddf33da467375a$var$decodeUTF8(input) {
    return (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $19ddf33da467375a$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $19ddf33da467375a$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $19ddf33da467375a$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $95721a1f8e4d79f8$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $19ddf33da467375a$var$concatBuffers(parts);
}
function $19ddf33da467375a$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $19ddf33da467375a$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $19ddf33da467375a$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($19ddf33da467375a$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $19ddf33da467375a$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $19ddf33da467375a$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $19ddf33da467375a$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $19ddf33da467375a$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $19ddf33da467375a$export$b11169581eeaf237(type) {
    return $19ddf33da467375a$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $19ddf33da467375a$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $19ddf33da467375a$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $19ddf33da467375a$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $19ddf33da467375a$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $19ddf33da467375a$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(span)) : (span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $19ddf33da467375a$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(headers, items);
}









const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $e47c8865bba9bc73$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e47c8865bba9bc73$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "manual",
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $36b15c0d755e29f6$export$eb571cd9b5d98de8) : (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(endTimestamp);
        (0, $09ada9a941cee5f6$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $36b15c0d755e29f6$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $068c396dceb690a1$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $068c396dceb690a1$export$fea48ba9f4550879],
            measurements: (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
        const attributes = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e47c8865bba9bc73$var$sendSpanEnvelope((0, $b89a3b4f1056006b$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this).scope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e47c8865bba9bc73$var$isFullFinishedSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$e47c8865bba9bc73$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span)).filter($e47c8865bba9bc73$var$isFullFinishedSpan);
        const source = this._attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        const transaction = {
            contexts: {
                trace: (0, $36b15c0d755e29f6$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e47c8865bba9bc73$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e47c8865bba9bc73$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e47c8865bba9bc73$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e47c8865bba9bc73$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e47c8865bba9bc73$var$isStandaloneSpan(span) {
    return span instanceof $e47c8865bba9bc73$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e47c8865bba9bc73$var$sendSpanEnvelope(envelope) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    const transport = client.getTransport();
    if (transport) transport.send(envelope).then(null, (reason)=>{
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Error while sending span:", reason);
    });
}




const $038737f78c636108$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$a1bd95187356f372(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$c10292ad04b92aea(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$63dbba021a6b4047(options) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$038737f78c636108$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const parentSpan = $038737f78c636108$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
        return $038737f78c636108$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $038737f78c636108$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $fb06ed6aa7675875$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $038737f78c636108$export$e57ac09b143d92a2(span, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $038737f78c636108$export$869298f9835abc68(callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$038737f78c636108$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $038737f78c636108$export$f90b03291402f553(callback) {
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext((0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)());
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $038737f78c636108$export$e57ac09b143d92a2(null, callback);
    });
}
function $038737f78c636108$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $09ada9a941cee5f6$export$2f3d84e767c9592b)(span);
    (0, $4509d165411fd11c$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $038737f78c636108$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $038737f78c636108$var$getAcs() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    return (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
}
function $038737f78c636108$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $db2bd6d2ef458b60$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: "custom",
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $068c396dceb690a1$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? false : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $038737f78c636108$var$getParentSpan(scope) {
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $038737f78c636108$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $038737f78c636108$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $cc4acb8fa68987a7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $cc4acb8fa68987a7$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $cc4acb8fa68987a7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $cc4acb8fa68987a7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $c2017e0e66bad871$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}






const $7f25ffc87954188c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $7f25ffc87954188c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7f25ffc87954188c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $dd0ab4bb8fd34918$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $44a719e67f846077$export$6431553786c94949 = ()=>{
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $087abae3f457004d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $21249b77f35afbbd$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering || (0, $087abae3f457004d$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $dd0ab4bb8fd34918$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3c3fb26ba7f6478b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $02a4610d4ee5af80$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden") cb(event);
    };
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9bb6b2adff68632$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return (arg)=>{
        if (!called) {
            cb(arg);
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bf61d7f7ca9bd10a$var$firstHiddenTime = -1;
const $bf61d7f7ca9bd10a$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    $bf61d7f7ca9bd10a$var$firstHiddenTime = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bf61d7f7ca9bd10a$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && $bf61d7f7ca9bd10a$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        removeEventListener("visibilitychange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
        removeEventListener("prerenderingchange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    }
};
const $bf61d7f7ca9bd10a$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && $bf61d7f7ca9bd10a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bf61d7f7ca9bd10a$var$initHiddenTime();
        $bf61d7f7ca9bd10a$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bf61d7f7ca9bd10a$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6f9bc735dd2b9313$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $c372737293087726$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $c372737293087726$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c372737293087726$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c8cc3356aaa35be1$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c8cc3356aaa35be1$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $c372737293087726$export$fe3c86b74e15d5de)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c8cc3356aaa35be1$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $88c48014ef58cf68$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $88c48014ef58cf68$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("first-input", handleEntries);
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $88c48014ef58cf68$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};








let $cc83e22cb516f528$var$interactionCountEstimate = 0;
let $cc83e22cb516f528$var$minKnownInteractionId = Infinity;
let $cc83e22cb516f528$var$maxKnownInteractionId = 0;
const $cc83e22cb516f528$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cc83e22cb516f528$var$minKnownInteractionId = Math.min($cc83e22cb516f528$var$minKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$maxKnownInteractionId = Math.max($cc83e22cb516f528$var$maxKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$interactionCountEstimate = $cc83e22cb516f528$var$maxKnownInteractionId ? ($cc83e22cb516f528$var$maxKnownInteractionId - $cc83e22cb516f528$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cc83e22cb516f528$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $cc83e22cb516f528$export$8a962f2683a476d1 = ()=>{
    return $cc83e22cb516f528$var$po ? $cc83e22cb516f528$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $cc83e22cb516f528$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $cc83e22cb516f528$var$po) return;
    $cc83e22cb516f528$var$po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("event", $cc83e22cb516f528$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c2ceebba2f8f4181$export$7f4cb060ded9173c = [
    200,
    500
];
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
const $c2ceebba2f8f4181$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $c2ceebba2f8f4181$var$getInteractionCountForNavigation = ()=>{
    return (0, $cc83e22cb516f528$export$8a962f2683a476d1)() - $c2ceebba2f8f4181$var$prevInteractionCount;
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $c2ceebba2f8f4181$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $c2ceebba2f8f4181$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $c2ceebba2f8f4181$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $c2ceebba2f8f4181$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $c2ceebba2f8f4181$var$longestInteractionList[$c2ceebba2f8f4181$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $c2ceebba2f8f4181$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $c2ceebba2f8f4181$var$longestInteractionList.length < $c2ceebba2f8f4181$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $c2ceebba2f8f4181$var$longestInteractionMap[interaction.id] = interaction;
            $c2ceebba2f8f4181$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $c2ceebba2f8f4181$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $c2ceebba2f8f4181$var$longestInteractionList.splice($c2ceebba2f8f4181$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $c2ceebba2f8f4181$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $c2ceebba2f8f4181$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($c2ceebba2f8f4181$var$longestInteractionList.length - 1, Math.floor($c2ceebba2f8f4181$var$getInteractionCountForNavigation() / 50));
    return $c2ceebba2f8f4181$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c2ceebba2f8f4181$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $cc83e22cb516f528$export$67d90cda6b78a2eb)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.interactionId) $c2ceebba2f8f4181$var$processEntry(entry);
                // Entries of type `first-input` don't currently have an `interactionId`,
                // so to consider them in INP we have to first check that an existing
                // entry doesn't match the `duration` and `startTime`.
                // Note that this logic assumes that `event` entries are dispatched
                // before `first-input` entries. This is true in Chrome (the only browser
                // that currently supports INP).
                // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
                if (entry.entryType === "first-input") {
                    const noMatchingEntry = !$c2ceebba2f8f4181$var$longestInteractionList.some((interaction)=>{
                        return interaction.entries.some((prevEntry)=>{
                            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                        });
                    });
                    if (noMatchingEntry) $c2ceebba2f8f4181$var$processEntry(entry);
                }
            });
            const inp = $c2ceebba2f8f4181$var$estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = inp.entries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : 40
        });
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c2ceebba2f8f4181$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // If browser supports interactionId (and so supports INP), also
            // observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            if ("PerformanceEventTiming" in (0, $955496f5d3029976$export$56d8a8a25bd48b81) && "interactionId" in PerformanceEventTiming.prototype) po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                // If the interaction count shows that there were interactions but
                // none were captured by the PerformanceObserver, report a latency of 0.
                if (metric.value < 0 && $c2ceebba2f8f4181$var$getInteractionCountForNavigation() > 0) {
                    metric.value = 0;
                    metric.entries = [];
                }
                report(true);
            });
        }
    });
};











/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $c89cf1e13796625e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $c89cf1e13796625e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $c89cf1e13796625e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("LCP");
        let report;
        const handleEntries = (entries)=>{
            const lastEntry = entries[entries.length - 1];
            if (lastEntry) // Only report if the page wasn't hidden prior to LCP.
            {
                if (lastEntry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(lastEntry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        lastEntry
                    ];
                    report();
                }
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c89cf1e13796625e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
                if (!$c89cf1e13796625e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $c89cf1e13796625e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                addEventListener(type, ()=>setTimeout(stopListening, 0), true);
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $f3a7825c3a5278be$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f3a7825c3a5278be$var$whenReady = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>$f3a7825c3a5278be$var$whenReady(callback));
    else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$f3a7825c3a5278be$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f3a7825c3a5278be$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("TTFB");
    const report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $f3a7825c3a5278be$export$65c59ea8064668fc, opts.reportAllChanges);
    $f3a7825c3a5278be$var$whenReady(()=>{
        const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
        if (navEntry) {
            const responseStart = navEntry.responseStart;
            // In some cases no value is reported by the browser (for
            // privacy/security reasons), and in other cases (bugs) the value is
            // negative or is larger than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            // https://github.com/GoogleChrome/web-vitals/issues/275
            if (responseStart <= 0 || responseStart > performance.now()) return;
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(responseStart - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $31f3d198369e5cbf$var$handlers = {};
const $31f3d198369e5cbf$var$instrumented = {};
let $31f3d198369e5cbf$var$_previousCls;
let $31f3d198369e5cbf$var$_previousFid;
let $31f3d198369e5cbf$var$_previousLcp;
let $31f3d198369e5cbf$var$_previousTtfb;
let $31f3d198369e5cbf$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31f3d198369e5cbf$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver("cls", callback, $31f3d198369e5cbf$var$instrumentCls, $31f3d198369e5cbf$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31f3d198369e5cbf$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver("lcp", callback, $31f3d198369e5cbf$var$instrumentLcp, $31f3d198369e5cbf$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$2707d7471c0b918f(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("fid", callback, $31f3d198369e5cbf$var$instrumentFid, $31f3d198369e5cbf$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31f3d198369e5cbf$export$699d9529c099a797(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("ttfb", callback, $31f3d198369e5cbf$var$instrumentTtfb, $31f3d198369e5cbf$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$da3b76aa2022cbd7(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("inp", callback, $31f3d198369e5cbf$var$instrumentInp, $31f3d198369e5cbf$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$69816c1a049f8db6(type, callback) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        $31f3d198369e5cbf$var$instrumentPerformanceObserver(type);
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31f3d198369e5cbf$var$triggerHandlers(type, data) {
    const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $53d728fa04e56ec9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $31f3d198369e5cbf$var$instrumentCls() {
    return (0, $c8cc3356aaa35be1$export$a7873055838e5ad8)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("cls", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentFid() {
    return (0, $88c48014ef58cf68$export$39705a25c49af873)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("fid", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousFid = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentLcp() {
    return (0, $c89cf1e13796625e$export$947b1626ab8d5632)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("lcp", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentTtfb() {
    return (0, $f3a7825c3a5278be$export$33a01e6c5f2c7e33)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousTtfb = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentInp() {
    return (0, $c2ceebba2f8f4181$export$7df4b36ecaed99e1)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("inp", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousInp = metric;
    });
}
function $31f3d198369e5cbf$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    let stopListening;
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31f3d198369e5cbf$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $3c3fb26ba7f6478b$export$d1203567a167490e)(type, (entries)=>{
        $31f3d198369e5cbf$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31f3d198369e5cbf$var$addHandler(type, handler) {
    $31f3d198369e5cbf$var$handlers[type] = $31f3d198369e5cbf$var$handlers[type] || [];
    $31f3d198369e5cbf$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $31f3d198369e5cbf$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}




/**
 * Checks if a given value is a valid measurement value.
 */ function $b0d1d845a8fb2673$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $b0d1d845a8fb2673$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $038737f78c636108$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay && replay.getReplayId();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId = undefined;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator && (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $b0d1d845a8fb2673$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81) && (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b0d1d845a8fb2673$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $b444d11e9edd543f$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$b444d11e9edd543f$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $b444d11e9edd543f$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        const unsubscribeStartNavigation = (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            client,
            "optionalAccess",
            (_)=>_.on,
            "call",
            (_2)=>_2("startNavigationSpan", ()=>{
                    _collectClsOnce();
                    unsubscribeStartNavigation && unsubscribeStartNavigation();
                })
        ]);
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        const spanJSON = rootSpan && (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        if (spanJSON && spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $b444d11e9edd543f$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf)) + ((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        entry,
        "optionalAccess",
        (_3)=>_3.startTime
    ]) || 0);
    const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        entry,
        "optionalAccess",
        (_4)=>_4.duration
    ]) || 0);
    const routeName = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $b1794bb8b282584f$export$5647df6b7814ac86)((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        entry,
        "access",
        (_5)=>_5.sources,
        "access",
        (_6)=>_6[0],
        "optionalAccess",
        (_7)=>_7.node
    ])) : "Layout shift";
    const attributes = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            entry,
            "optionalAccess",
            (_8)=>_8.duration
        ]) || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    });
    const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        span,
        "optionalAccess",
        (_9)=>_9.addEvent,
        "call",
        (_10)=>_10("cls", {
                [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: "",
                [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: clsValue
            })
    ]);
    (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        span,
        "optionalAccess",
        (_11)=>_11.end,
        "call",
        (_12)=>_12(startTime + duration)
    ]);
}
function $b444d11e9edd543f$var$supportsLayoutShift() {
    try {
        return (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            PerformanceObserver,
            "access",
            (_13)=>_13.supportedEntryTypes,
            "optionalAccess",
            (_14)=>_14.includes,
            "call",
            (_15)=>_15("layout-shift")
        ]);
    } catch (e) {
        return false;
    }
}






/* eslint-disable max-lines */ const $4ca18541755f3f2c$var$MAX_INT_AS_BYTES = 2147483647;
let $4ca18541755f3f2c$var$_performanceCursor = 0;
let $4ca18541755f3f2c$var$_measurements = {};
let $4ca18541755f3f2c$var$_lcpEntry;
let $4ca18541755f3f2c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ca18541755f3f2c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $dce7651ce4194f00$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $4ca18541755f3f2c$var$_trackFID();
        const lcpCleanupCallback = $4ca18541755f3f2c$var$_trackLCP();
        const ttfbCleanupCallback = $4ca18541755f3f2c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $b444d11e9edd543f$export$585bab03c6c18c45)() : $4ca18541755f3f2c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ca18541755f3f2c$export$f396d19077034ad2() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        if (!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) return;
        for (const entry of entries){
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
                name: "Main UI thread blocked",
                op: "ui.long-task",
                startTime: startTime,
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            if (span) span.end(startTime + duration);
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $4ca18541755f3f2c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        if (!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                startTime: startTime,
                attributes: attributes
            });
            if (span) span.end(startTime + duration);
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $4ca18541755f3f2c$export$e27543e0976315e4() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        if (!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $b1794bb8b282584f$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $b1794bb8b282584f$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            const span = (0, $038737f78c636108$export$63dbba021a6b4047)(spanOptions);
            if (span) span.end(startTime + duration);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $4ca18541755f3f2c$var$_trackCLS() {
    return (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Measurements] Adding CLS ${metric.value}`);
        $4ca18541755f3f2c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $4ca18541755f3f2c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ca18541755f3f2c$var$_trackLCP() {
    return (0, $31f3d198369e5cbf$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $4ca18541755f3f2c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ca18541755f3f2c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ca18541755f3f2c$var$_trackFID() {
    return (0, $31f3d198369e5cbf$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf));
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $4ca18541755f3f2c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ca18541755f3f2c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $4ca18541755f3f2c$var$_trackTtfb() {
    return (0, $31f3d198369e5cbf$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $4ca18541755f3f2c$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $4ca18541755f3f2c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (!performance || !(0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntries || !(0, $dce7651ce4194f00$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($4ca18541755f3f2c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $4ca18541755f3f2c$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $4ca18541755f3f2c$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ca18541755f3f2c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ca18541755f3f2c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements($4ca18541755f3f2c$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            const measurement = $4ca18541755f3f2c$var$_measurements[name];
            if (!measurement || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the span span data, so these web vitals will need
            // to be adjusted to be relative to span.startTimestamp.
            const oldValue = measurement.value;
            const measurementTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            measurement.value = normalizedValue;
        });
        const fidMark = $4ca18541755f3f2c$var$_measurements["mark.fid"];
        if (fidMark && $4ca18541755f3f2c$var$_measurements["fid"]) {
            // create span for FID
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)($4ca18541755f3f2c$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ca18541755f3f2c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $4ca18541755f3f2c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $4ca18541755f3f2c$var$_measurements.cls;
        Object.entries($4ca18541755f3f2c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $3ed76239c787a980$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        $4ca18541755f3f2c$var$_tagMetricInfo(span);
    }
    $4ca18541755f3f2c$var$_lcpEntry = undefined;
    $4ca18541755f3f2c$var$_clsEntry = undefined;
    $4ca18541755f3f2c$var$_measurements = {};
}
/** Create measure related spans */ function $4ca18541755f3f2c$export$bc93b84e4d45912d(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    const requestTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccruate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, name, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(end), {
        op: "browser",
        name: name || event,
        attributes: {
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
        }
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser",
            name: "request",
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser",
            name: "response",
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/** Create resource-related spans */ function $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) attributes["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin, ""),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ca18541755f3f2c$var$_trackNavigator(span) {
    const navigator = (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(connection.rtt)) $4ca18541755f3f2c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $4ca18541755f3f2c$var$_tagMetricInfo(span) {
    if ($4ca18541755f3f2c$var$_lcpEntry) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ca18541755f3f2c$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $b1794bb8b282584f$export$5647df6b7814ac86)($4ca18541755f3f2c$var$_lcpEntry.element));
        if ($4ca18541755f3f2c$var$_lcpEntry.id) span.setAttribute("lcp.id", $4ca18541755f3f2c$var$_lcpEntry.id);
        if ($4ca18541755f3f2c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $4ca18541755f3f2c$var$_lcpEntry.url.trim().slice(0, 200));
        span.setAttribute("lcp.size", $4ca18541755f3f2c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ca18541755f3f2c$var$_clsEntry && $4ca18541755f3f2c$var$_clsEntry.sources) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $4ca18541755f3f2c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $b1794bb8b282584f$export$5647df6b7814ac86)(source.node)));
    }
}
function $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ca18541755f3f2c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}





const $751b596e3029fa17$var$LAST_INTERACTIONS = [];
const $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $751b596e3029fa17$export$f17d06681a4744a3() {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $dce7651ce4194f00$export$baf075a948ffc0bf)) {
        const inpCallback = $751b596e3029fa17$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $751b596e3029fa17$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $751b596e3029fa17$var$_trackINP() {
    return (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $36b15c0d755e29f6$export$92d8c23565496537)(spanToUse).description : (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $b1794bb8b282584f$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: entry.duration
        });
        const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            span,
            "optionalAccess",
            (_)=>_.addEvent,
            "call",
            (_2)=>_2("inp", {
                    [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: "millisecond",
                    [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: metric.value
                })
        ]);
        (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            span,
            "optionalAccess",
            (_3)=>_3.end,
            "call",
            (_4)=>_4(startTime + duration)
        ]);
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $751b596e3029fa17$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $31f3d198369e5cbf$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($751b596e3029fa17$var$LAST_INTERACTIONS.length > 10) {
                const last = $751b596e3029fa17$var$LAST_INTERACTIONS.shift();
                $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $751b596e3029fa17$var$LAST_INTERACTIONS.push(interactionId);
            $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("event", handleEntries);
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("first-input", handleEntries);
}




let $18dd1219fff07956$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $18dd1219fff07956$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $18dd1219fff07956$var$instrumentError);
}
function $18dd1219fff07956$var$instrumentError() {
    $18dd1219fff07956$var$_oldOnErrorHandler = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onerror;
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("error", handlerData);
        if ($18dd1219fff07956$var$_oldOnErrorHandler && !$18dd1219fff07956$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $18dd1219fff07956$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $d65fa0065561a897$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d65fa0065561a897$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $d65fa0065561a897$var$instrumentUnhandledRejection);
}
function $d65fa0065561a897$var$instrumentUnhandledRejection() {
    $d65fa0065561a897$var$_oldOnUnhandledRejectionHandler = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($d65fa0065561a897$var$_oldOnUnhandledRejectionHandler && !$d65fa0065561a897$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d65fa0065561a897$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $d4be1d52827a3f28$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d4be1d52827a3f28$export$b0914730ee1f6c80() {
    if ($d4be1d52827a3f28$var$errorsInstrumented) return;
    $d4be1d52827a3f28$var$errorsInstrumented = true;
    (0, $18dd1219fff07956$export$55b5c3ba2194f0c6)($d4be1d52827a3f28$var$errorCallback);
    (0, $d65fa0065561a897$export$8bf4fc6858821a4e)($d4be1d52827a3f28$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d4be1d52827a3f28$var$errorCallback() {
    const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occured`);
        rootSpan.setStatus({
            code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d4be1d52827a3f28$var$errorCallback.tag = "sentry_tracingErrorCallback";











const $fd927ea1b5d85956$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $fd927ea1b5d85956$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = $fd927ea1b5d85956$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $068c396dceb690a1$export$ba73f34502b7a3b3]) span.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), _finishReason);
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $36b15c0d755e29f6$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $36b15c0d755e29f6$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $fd927ea1b5d85956$var$_startIdleSpan(options) {
    const span = (0, $038737f78c636108$export$63dbba021a6b4047)(options);
    (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), span);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Started span is an idle span");
    return span;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;











/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $3b138310ed7801df$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($3b138310ed7801df$var$States || ($3b138310ed7801df$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $3b138310ed7801df$export$1fda8aa4d135f8aa(value) {
    return new $3b138310ed7801df$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $3b138310ed7801df$export$78e43115b553f358(reason) {
    return new $3b138310ed7801df$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $3b138310ed7801df$export$6f292d4960313241 {
    constructor(executor){
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init.call(this);
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init2.call(this);
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init3.call(this);
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $3b138310ed7801df$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $3b138310ed7801df$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $3b138310ed7801df$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($3b138310ed7801df$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($3b138310ed7801df$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $3b138310ed7801df$var$States.PENDING) return;
            if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $3b138310ed7801df$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $3b138310ed7801df$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $3b138310ed7801df$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $3b138310ed7801df$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}






/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "extra", extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "tags", tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "user", user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "contexts", contexts);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $f61010b781c81ec1$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$var$applyClientOptions(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $baba650ac852ba0c$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $baba650ac852ba0c$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $baba650ac852ba0c$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.entries(debugIdMap).reduce((acc, [debugIdStackTrace, debugIdValue])=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdValue;
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === "function";
}
const $baba650ac852ba0c$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $f61010b781c81ec1$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, ()=>{
            finishCheckIn("error");
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}



const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $7c0b78736d11cf4a$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $f61010b781c81ec1$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $7c0b78736d11cf4a$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}






/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $755e6178fce08d17$export$6f18f55521af71a1() {
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9ddc5321bbc17588$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9ddc5321bbc17588$export$844ec244b1367d54)(header) && (0, $9ddc5321bbc17588$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                startTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                xhr: this
            };
            (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $9ddc5321bbc17588$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}













/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0b4497afe5c251f9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $0b4497afe5c251f9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $0b4497afe5c251f9$var$getFullURL(url);
    const host = fullUrl ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: "http.client"
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        options.headers = $0b4497afe5c251f9$export$6717acf674206871(request, client, scope, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $0b4497afe5c251f9$export$6717acf674206871(request, client, scope, options, span) {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $36b15c0d755e29f6$export$7e9f8ae9e4a328ab)(span) : (0, $fb06ed6aa7675875$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $f43df6ba426daa1c$export$56766feef403f365)(dsc || (span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(traceId, client)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $9ddc5321bbc17588$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $9ddc5321bbc17588$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $f43df6ba426daa1c$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $f43df6ba426daa1c$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $0b4497afe5c251f9$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $0b4497afe5c251f9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}







const $1772a056d037fd67$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $1772a056d037fd67$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1772a056d037fd67$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $1772a056d037fd67$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$1772a056d037fd67$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($1772a056d037fd67$export$d5f608b368e73f38($1772a056d037fd67$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $1772a056d037fd67$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $1772a056d037fd67$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$531055a6c684a70a() {
    return "ReportingObserver" in $1772a056d037fd67$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$1772a056d037fd67$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $30557b1c7e561fce$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, ()=>$30557b1c7e561fce$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $30557b1c7e561fce$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, ()=>$30557b1c7e561fce$var$instrumentFetch($30557b1c7e561fce$var$streamHandler));
}
function $30557b1c7e561fce$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $1772a056d037fd67$export$c82d238e23c40b21)()) return;
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $30557b1c7e561fce$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // We capture the stack right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualStackTrace = new Error().stack;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualStackTrace;
                    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $30557b1c7e561fce$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body && res.body.getReader) {
        const responseReader = res.body.getReader();
        // eslint-disable-next-line no-inner-declarations
        async function consumeChunks({ done: done }) {
            if (!done) try {
                // abort reading if read op takes more than 5s
                const result = await Promise.race([
                    responseReader.read(),
                    new Promise((res)=>{
                        setTimeout(()=>{
                            res({
                                done: true
                            });
                        }, 5000);
                    })
                ]);
                await consumeChunks(result);
            } catch (error) {
            // handle error if needed
            }
            else return Promise.resolve();
        }
        return responseReader.read().then(consumeChunks).then(onFinishedResolving).catch(()=>undefined);
    }
}
async function $30557b1c7e561fce$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    await $30557b1c7e561fce$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $30557b1c7e561fce$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $30557b1c7e561fce$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($30557b1c7e561fce$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $30557b1c7e561fce$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $30557b1c7e561fce$var$getUrlFromResource(url),
            method: $30557b1c7e561fce$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $30557b1c7e561fce$var$getUrlFromResource(arg),
        method: $30557b1c7e561fce$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}



/** Options for Request Instrumentation */ const $edec20d6c9712df6$var$responseToSpanId = new WeakMap();
const $edec20d6c9712df6$var$spanIdToEndTimestamp = new Map();
const $edec20d6c9712df6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true
};
/** Registers span creators for xhr and fetch requests  */ function $edec20d6c9712df6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$edec20d6c9712df6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the intial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $edec20d6c9712df6$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $edec20d6c9712df6$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        (0, $30557b1c7e561fce$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $edec20d6c9712df6$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $edec20d6c9712df6$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $30557b1c7e561fce$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $0b4497afe5c251f9$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $edec20d6c9712df6$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $edec20d6c9712df6$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
    });
}
function $edec20d6c9712df6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $edec20d6c9712df6$var$addHTTPTimings(span) {
    const { url: url } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($edec20d6c9712df6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $edec20d6c9712df6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $edec20d6c9712df6$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $edec20d6c9712df6$var$getAbsoluteTime(time = 0) {
    return (((0, $dce7651ce4194f00$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $edec20d6c9712df6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $edec20d6c9712df6$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $dce7651ce4194f00$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $edec20d6c9712df6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $edec20d6c9712df6$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.http.browser",
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: "http.client"
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, client, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, client, span) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span && (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() ? (0, $36b15c0d755e29f6$export$7e9f8ae9e4a328ab)(span) : (0, $fb06ed6aa7675875$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $f43df6ba426daa1c$export$56766feef403f365)(dsc || (span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(traceId, client)));
    $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
}
function $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $f43df6ba426daa1c$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $edec20d6c9712df6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $400f75f99113439b$export$bbd2089f30bd3708 = "BrowserTracing";
const $400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $fd927ea1b5d85956$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $edec20d6c9712df6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $400f75f99113439b$export$b4109253475213e9 = (_options = {})=>{
    (0, $d4be1d52827a3f28$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $4ca18541755f3f2c$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $751b596e3029fa17$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $4ca18541755f3f2c$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $4ca18541755f3f2c$export$f396d19077034ad2)();
    if (enableInteractions) (0, $4ca18541755f3f2c$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $068c396dceb690a1$export$d7a7d984b0791405] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        const idleSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $4ca18541755f3f2c$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                "interactive",
                "complete"
            ].includes((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
            (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $400f75f99113439b$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan && !(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                activeSpan = _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan && !(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                const sentryTrace = traceOptions.sentryTrace || $400f75f99113439b$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $400f75f99113439b$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $fb06ed6aa7675875$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on("spanEnd", (span)=>{
                const op = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
                if (span !== (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span) || op !== "navigation" && op !== "pageload") return;
                const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span)
                });
            });
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $400f75f99113439b$export$aa44a07f82af519f(client, {
                    name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $dce7651ce4194f00$export$baf075a948ffc0bf) ? (0, $dce7651ce4194f00$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: "url",
                        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.pageload.browser"
                    }
                });
                if (instrumentNavigation) (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $400f75f99113439b$export$7d159749bd9969ad(client, {
                            name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: "url",
                                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.navigation.browser"
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $755e6178fce08d17$export$6f18f55521af71a1)();
            if (enableInteractions) $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $751b596e3029fa17$export$e4e04d43e223cce2)();
            (0, $edec20d6c9712df6$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $400f75f99113439b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $400f75f99113439b$export$7d159749bd9969ad(client, spanOptions) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setPropagationContext((0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)());
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext((0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)());
    client.emit("startNavigationSpan", spanOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $400f75f99113439b$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $b1794bb8b282584f$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}





const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $f61010b781c81ec1$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $fbb22756c9507e85$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === "Debug");
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}



const $b99d5bb3db344fdd$var$INTEGRATION_NAME = "Dedupe";
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $53d728fa04e56ec9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $53d728fa04e56ec9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = "FunctionToString";
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $7c0b78736d11cf4a$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);


const $0e303f054920e2b1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $7c0b78736d11cf4a$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $3a0c11012bdf3bae$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler"
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = "InboundFilters";
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $67b350191b117f2b$var$_getPossibleEventMessages(event).some((message)=>(0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $67b350191b117f2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}





/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $54de22820fe8f5c8$export$31499a9cd224b78c)
            })),
        version: (0, $54de22820fe8f5c8$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $9a56b3ff3570ceec$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/** An error emitted by Sentry SDKs and related utilities. */ class $ea7cef744a918cc0$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}











const $4f30d529f2099042$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4f30d529f2099042$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $3a0c11012bdf3bae$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $f61010b781c81ec1$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9ddc5321bbc17588$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $f61010b781c81ec1$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $19ddf33da467375a$export$d650323442802f6f)(env, (0, $19ddf33da467375a$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assue the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assue the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Error while sending event:", reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $3b138310ed7801df$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4f30d529f2099042$var$isTransactionEvent(event);
        const isError = $4f30d529f2099042$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $3b138310ed7801df$export$78e43115b553f358)(new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4f30d529f2099042$var$processBeforeSend(this, options, prepared, hint);
            return $4f30d529f2099042$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $9a56b3ff3570ceec$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4f30d529f2099042$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4f30d529f2099042$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($4f30d529f2099042$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($4f30d529f2099042$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else client.recordDroppedEvent("before_send", "span");
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $4f30d529f2099042$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4f30d529f2099042$var$isTransactionEvent(event) {
    return event.type === "transaction";
}


/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $e4a9904d531a9658$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $e4a9904d531a9658$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}





/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $23dde874fe12fd4c$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $95721a1f8e4d79f8$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9ddc5321bbc17588$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9ddc5321bbc17588$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9ddc5321bbc17588$export$ef9e2056653f0c8e)(exception) || (0, $9ddc5321bbc17588$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9ddc5321bbc17588$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $f61010b781c81ec1$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(exception) || (0, $9ddc5321bbc17588$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $f61010b781c81ec1$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $9ddc5321bbc17588$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $7c0b78736d11cf4a$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9ddc5321bbc17588$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9ddc5321bbc17588$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $4f30d529f2099042$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $e4a9904d531a9658$export$8ad33f488b1ab046)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
}






const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $3fec3b92cacfb9e4$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[target] && (0, $955496f5d3029976$export$56d8a8a25bd48b81)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(target, "_sentryId", (0, $f61010b781c81ec1$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}






/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8444b49f56f15ce4$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $8444b49f56f15ce4$var$instrumentConsole);
}
function $8444b49f56f15ce4$var$instrumentConsole() {
    if (!("console" in (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1))) return;
    (0, $eddf779ebbe9b538$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console)) return;
        (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $eddf779ebbe9b538$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $eddf779ebbe9b538$export$77c4ce905194557b)[level];
                log && log.apply((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $575cb5410d2010d0$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $575cb5410d2010d0$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $575cb5410d2010d0$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = "Breadcrumbs";
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $8444b49f56f15ce4$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $30557b1c7e561fce$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $f61010b781c81ec1$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $b1794bb8b282584f$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b1794bb8b282584f$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $575cb5410d2010d0$export$d771ef054122c30a)(handlerData.level),
            message: (0, $ef17463c720dc68b$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $ef17463c720dc68b$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = "BrowserApiErrors";
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "setTimeout", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "setInterval", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "requestAnimationFrame", $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4e018dbe28beb052$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $7c0b78736d11cf4a$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $53d728fa04e56ec9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}







const $3920039f2d643754$var$INTEGRATION_NAME = "GlobalHandlers";
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $18dd1219fff07956$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $d65fa0065561a897$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $9ddc5321bbc17588$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $b1794bb8b282584f$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $bdc874c42642b289$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9ddc5321bbc17588$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $bdc874c42642b289$var$truncateAggregateExceptions($bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9ddc5321bbc17588$export$49034edbe6b62415)(error[key], Error)) {
        $bdc874c42642b289$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $bdc874c42642b289$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9ddc5321bbc17588$export$49034edbe6b62415)(childError, Error)) {
            $bdc874c42642b289$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $bdc874c42642b289$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $bdc874c42642b289$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $bdc874c42642b289$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $bdc874c42642b289$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = "cause";
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = "LinkedErrors";
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $bdc874c42642b289$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $53d728fa04e56ec9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $1772a056d037fd67$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("setTimeout")(...rest);
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $bde3819d7b9aaee7$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $bde3819d7b9aaee7$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $bde3819d7b9aaee7$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $bde3819d7b9aaee7$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $bde3819d7b9aaee7$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $bde3819d7b9aaee7$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $bde3819d7b9aaee7$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $bde3819d7b9aaee7$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $bd33167c8fcedc8a$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $3b138310ed7801df$export$78e43115b553f358)(new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $3b138310ed7801df$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $bd33167c8fcedc8a$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $19ddf33da467375a$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $19ddf33da467375a$export$b11169581eeaf237)(type);
            if ((0, $bde3819d7b9aaee7$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $19ddf33da467375a$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $19ddf33da467375a$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $19ddf33da467375a$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $19ddf33da467375a$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $bde3819d7b9aaee7$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $edfbff9038a67171$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)("fetch");
            return (0, $3b138310ed7801df$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $3b138310ed7801df$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $67b350191b117f2b$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)()
    ];
}
function $928f566aa50bb77a$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== "undefined" && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$var$applyDefaultOptions(browserOptions);
    if ($928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
        if (!(0, $1772a056d037fd67$export$edf3cb81fd7d2a3e)()) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $53d728fa04e56ec9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    const client = (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $928f566aa50bb77a$var$startSessionTracking();
    return client;
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $928f566aa50bb77a$var$startSessionTracking() {
    if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $928f566aa50bb77a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, "react");
    (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)("react", {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}




var $acw62 = parcelRequire("acw62");
parcelRequire("26Mrv");
var $a9hho = parcelRequire("a9hho");
var $99ab2b0d4f97b94a$exports = {};
"use strict";
var $99ab2b0d4f97b94a$var$__createBinding = $99ab2b0d4f97b94a$exports && $99ab2b0d4f97b94a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $99ab2b0d4f97b94a$var$__exportStar = $99ab2b0d4f97b94a$exports && $99ab2b0d4f97b94a$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $99ab2b0d4f97b94a$var$__createBinding(exports1, m, p);
};
Object.defineProperty($99ab2b0d4f97b94a$exports, "__esModule", {
    value: true
});

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("5vuWi")), $99ab2b0d4f97b94a$exports);

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("1FExB")), $99ab2b0d4f97b94a$exports);

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("eWJCq")), $99ab2b0d4f97b94a$exports);






// import { PageError } from 'components/errors/PageError';
// import { NotFound } from 'assets/images';
const $5142175f1233da6c$var$statsigEnvironment = ()=>{
    return (0, $a9hho.FeatureGateEnvironment).Production;
};
// Function to get cookie value by name
const $5142175f1233da6c$var$getCookieValue = (name)=>{
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match && match[2] ? decodeURIComponent(match[2]) : null;
};
const $5142175f1233da6c$export$dd73e24062026fcb = (props)=>{
    const [statsigState, setStatsigState] = (0, $acw62.useState)((0, $77d0522707ddb581$export$5762c0b139f625b2).LOADING);
    const user = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)();
    const identifiers = (0, $acw62.useMemo)(()=>{
        const anonymousId = $5142175f1233da6c$var$getCookieValue("ajs_anonymous_id");
        return {
            atlassianAccountId: user?.accountId || "",
            analyticsAnonymousId: anonymousId || ""
        };
    }, [
        user
    ]);
    const statsigRenderByState = (0, $acw62.useCallback)((currentStatsigState)=>{
        switch(currentStatsigState){
            case (0, $77d0522707ddb581$export$5762c0b139f625b2).INITIALIZED:
                return props.children;
            case (0, $77d0522707ddb581$export$5762c0b139f625b2).LOADING:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {});
            case (0, $77d0522707ddb581$export$5762c0b139f625b2).ERROR:
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: props.children
                });
        }
    }, [
        props.children
    ]);
    const onStatsigReady = (0, $acw62.useCallback)((err)=>{
        if (err) {
            setStatsigState((0, $77d0522707ddb581$export$5762c0b139f625b2).ERROR);
            (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(err, {
                data: {
                    message: "Statsig initialization failed, but FeatureGatesInitialization was loaded",
                    environment: $5142175f1233da6c$var$statsigEnvironment,
                    identifiers: identifiers
                }
            });
        } else setStatsigState((0, $77d0522707ddb581$export$5762c0b139f625b2).INITIALIZED);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99ab2b0d4f97b94a$exports.FeatureGatesInitialization), {
        options: {
            apiKey: "a0cfa8cf-39f3-4218-a9fd-95bde50adbed",
            environment: $5142175f1233da6c$var$statsigEnvironment(),
            targetApp: "unified-portable-profile_web"
        },
        identifiers: identifiers,
        onReady: onStatsigReady,
        initializingComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {}),
        children: statsigRenderByState(statsigState)
    });
};





var $gQkqH = parcelRequire("gQkqH");



var $acw62 = parcelRequire("acw62");



var $23ae3e20135e968a$exports = {};
$23ae3e20135e968a$exports = new URL("welcome-illustration.5af9c8d1.png", import.meta.url).toString();


const $999951262786c164$export$1455dbbf212c122f = ({ profileHasConsented: profileHasConsented, children: children })=>{
    const { push: push } = (0, $9a1d980dc90c7cfe$export$402e82ff1b20594b)();
    const currentPage = encodeURIComponent(globalThis.location.href);
    const user = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)() || {};
    const logoutHref = (0, $acw62.useMemo)(()=>{
        return (0, $7ef8d8aa49ecf9c6$export$1ecea9365b9c733c)("logout", {
            prompt: "none",
            experience: "entry-auth",
            redirectUrl: currentPage
        });
    }, [
        currentPage
    ]);
    const onConsentError = ()=>{
        push("/user/error/consent_failed");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $768c2bb36d671034$exports.ConsentValidator), {
        onLogout: ()=>push(logoutHref),
        aaid: user.accountId,
        coverImageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($23ae3e20135e968a$exports))),
        isUserConsented: profileHasConsented,
        onConsentError: onConsentError,
        children: children
    });
};





var $ccb3e071647be521$var$_UnifiedConsentQuery;

const $ccb3e071647be521$export$3d9fda3f5baf935d = $ccb3e071647be521$var$_UnifiedConsentQuery !== void 0 ? $ccb3e071647be521$var$_UnifiedConsentQuery : $ccb3e071647be521$var$_UnifiedConsentQuery = (parcelRequire("2TRci"));


var $8a41766802ad99b6$var$_CommunityInitializeMutation;

const $8a41766802ad99b6$export$468bbccb754d8e = $8a41766802ad99b6$var$_CommunityInitializeMutation !== void 0 ? $8a41766802ad99b6$var$_CommunityInitializeMutation : $8a41766802ad99b6$var$_CommunityInitializeMutation = (parcelRequire("6Jc1D"));



const $2b65debe690d9af5$var$CommunityInitializer = ({ children: children, loggedInUser: loggedInUser })=>{
    const [isCommunityInitialized, setIsCommunityInitialized] = (0, $acw62.useState)(null);
    const [commit] = (0, $2d93712440e0508b$exports.useMutation)((0, $8a41766802ad99b6$export$468bbccb754d8e));
    const [profileInternalId, setProfileInternalId] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (loggedInUser?.accountId) (async ()=>{
            try {
                if (!loggedInUser.email || !loggedInUser.accountId) throw new Error("User email or aaid is not available");
                commit({
                    variables: {
                        aaid: loggedInUser.accountId
                    },
                    onCompleted: (data)=>{
                        setIsCommunityInitialized(true);
                        const profileInternalIdValue = data?.unified?.community?.initializeCommunity?.unifiedProfile?.internalId ?? "";
                        setProfileInternalId(profileInternalIdValue);
                    },
                    onError: ()=>{
                        setIsCommunityInitialized(false);
                        $f2b90654edf2c0a1$export$f5282963edea4a68(new Error("Error initialize community"), {
                            data: {
                                message: "Initialize community failied",
                                environment: (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)(),
                                identifiers: {
                                    accountId: loggedInUser.accountId
                                }
                            }
                        });
                    }
                });
            } catch (e) {
                setIsCommunityInitialized(false);
            }
        })();
    }, [
        loggedInUser?.accountId
    ]);
    if (!loggedInUser?.accountId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    if (isCommunityInitialized === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gQkqH))), {});
    if (!isCommunityInitialized) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/user/error/invalid_path"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2368c384ef7b2574$export$c505fc0a856a63f6).Provider, {
        value: {
            profileInternalId: profileInternalId
        },
        children: children
    });
};
const $2b65debe690d9af5$export$3b2542ef59fb8ba = "https://community-link.atlassian.com";
const $2b65debe690d9af5$export$9e14a7677ef1423c = (props)=>{
    // a top level component to handle any initialization logic
    if ((0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)() !== "local" && window.location.origin === $2b65debe690d9af5$export$3b2542ef59fb8ba && !window.location.pathname.includes("/authenticate/") // update this logic to match a more accurate path.
    ) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/error/invalid_path"
    });
    (0, $acw62.useEffect)(()=>{
        $07b303fd558e140e$export$2cd8252107eb640b({
            dsn: "https://5fa66ef9a8ff88865fbd3d073ebe4dfa@o55978.ingest.us.sentry.io/4507855280209920",
            enabled: true,
            environment: "production",
            integrations: [
                $400f75f99113439b$export$b4109253475213e9()
            ],
            // Tracing
            release: "9064-1789387345" ?? "local",
            tracesSampleRate: 1.0,
            //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [
                "localhost",
                "/gateway/api/graphql"
            ]
        });
    }, []);
    const [profileIconPosition] = (0, $acw62.useState)(()=>{
        const randomValues = new Uint32Array(1);
        crypto.getRandomValues(randomValues);
        return randomValues[0] % (0, $77d0522707ddb581$export$9ac4f3be5daa21fe).length;
    });
    const user = (0, $f26dd37926a562a3$export$2e2bcd8739ae039)() || {};
    (0, $acw62.useEffect)(()=>{
        if (user?.accountId) (0, $0ee39200de55b7f1$export$ec05d93a265a7799)(user.accountId);
    }, [
        user?.accountId
    ]);
    const profileConsentData = (0, $2d93712440e0508b$exports.useLazyLoadQuery)((0, $ccb3e071647be521$export$3d9fda3f5baf935d), {
        aaid: user?.accountId ?? ""
    }, {
        fetchPolicy: "store-or-network"
    });
    const profileHasConsented = (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)() !== "local" ? (0, $acw62.useMemo)(()=>(0, $0ee606ad15f500d3$export$df86adc920cb0162)(profileConsentData.unified?.consent?.getConsent?.consentObj ?? []), [
        profileConsentData
    ]) : true;
    const { push: push } = (0, $9a1d980dc90c7cfe$export$402e82ff1b20594b)();
    const onConsentError = ()=>{
        push("/user/error/consent_failed");
    };
    const isErrorPage = window.location.pathname.includes("/error/");
    return !isErrorPage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
        onError: onConsentError,
        FallbackComponent: (0, $449db7dc91aabb25$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gQkqH))), {}),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $999951262786c164$export$1455dbbf212c122f), {
                profileHasConsented: profileHasConsented,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2b65debe690d9af5$var$CommunityInitializer, {
                    loggedInUser: user,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51c84bb9511e1e8b$export$122994dc05ba4308).Provider, {
                        value: {
                            profileAvatar: (0, $77d0522707ddb581$export$9ac4f3be5daa21fe)[profileIconPosition]
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5142175f1233da6c$export$dd73e24062026fcb), {
                            children: props.children
                        })
                    })
                })
            })
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51c84bb9511e1e8b$export$122994dc05ba4308).Provider, {
        value: {
            profileAvatar: (0, $77d0522707ddb581$export$9ac4f3be5daa21fe)[profileIconPosition]
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5142175f1233da6c$export$dd73e24062026fcb), {
            children: props.children
        })
    });
};







// src/index.tsx

var $acw62 = parcelRequire("acw62");

var $ai2Pb = parcelRequire("ai2Pb");

var $aaXwj = parcelRequire("aaXwj");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $142fd31a8786eb6d$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($142fd31a8786eb6d$var$TAG_NAMES || {});
var $142fd31a8786eb6d$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $142fd31a8786eb6d$var$VALID_TAG_NAMES = Object.values($142fd31a8786eb6d$var$TAG_NAMES);
var $142fd31a8786eb6d$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $142fd31a8786eb6d$var$HTML_TAG_MAP = Object.entries($142fd31a8786eb6d$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $142fd31a8786eb6d$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $142fd31a8786eb6d$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $142fd31a8786eb6d$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $142fd31a8786eb6d$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $142fd31a8786eb6d$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $142fd31a8786eb6d$var$getInnermostProperty(propsList, $142fd31a8786eb6d$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $142fd31a8786eb6d$var$getInnermostProperty(propsList, $142fd31a8786eb6d$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $142fd31a8786eb6d$var$getOnChangeClientState = (propsList)=>$142fd31a8786eb6d$var$getInnermostProperty(propsList, $142fd31a8786eb6d$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $142fd31a8786eb6d$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $142fd31a8786eb6d$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $142fd31a8786eb6d$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $142fd31a8786eb6d$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $142fd31a8786eb6d$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $142fd31a8786eb6d$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $142fd31a8786eb6d$var$reducePropsToState = (propsList)=>({
        baseTag: $142fd31a8786eb6d$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $142fd31a8786eb6d$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $142fd31a8786eb6d$var$getInnermostProperty(propsList, $142fd31a8786eb6d$var$HELMET_PROPS.DEFER),
        encode: $142fd31a8786eb6d$var$getInnermostProperty(propsList, $142fd31a8786eb6d$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $142fd31a8786eb6d$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $142fd31a8786eb6d$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $142fd31a8786eb6d$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $142fd31a8786eb6d$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $142fd31a8786eb6d$var$getOnChangeClientState(propsList),
        scriptTags: $142fd31a8786eb6d$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $142fd31a8786eb6d$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $142fd31a8786eb6d$var$getTitleFromPropsList(propsList),
        titleAttributes: $142fd31a8786eb6d$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $142fd31a8786eb6d$var$getAnyTrueFromPropsList(propsList, $142fd31a8786eb6d$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $142fd31a8786eb6d$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $142fd31a8786eb6d$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $142fd31a8786eb6d$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($142fd31a8786eb6d$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $142fd31a8786eb6d$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $142fd31a8786eb6d$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $142fd31a8786eb6d$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $142fd31a8786eb6d$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $142fd31a8786eb6d$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $142fd31a8786eb6d$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $142fd31a8786eb6d$var$flattenArray(title);
    return attributeString ? `<${type} ${$142fd31a8786eb6d$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$142fd31a8786eb6d$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$142fd31a8786eb6d$var$HELMET_ATTRIBUTE}="true">${$142fd31a8786eb6d$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $142fd31a8786eb6d$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$142fd31a8786eb6d$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $142fd31a8786eb6d$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$142fd31a8786eb6d$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $142fd31a8786eb6d$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $142fd31a8786eb6d$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $142fd31a8786eb6d$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$142fd31a8786eb6d$var$HELMET_ATTRIBUTE]: true
    };
    const props = $142fd31a8786eb6d$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $142fd31a8786eb6d$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$142fd31a8786eb6d$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $142fd31a8786eb6d$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, mappedTag);
    });
var $142fd31a8786eb6d$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$142fd31a8786eb6d$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$142fd31a8786eb6d$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$142fd31a8786eb6d$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$142fd31a8786eb6d$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$142fd31a8786eb6d$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$142fd31a8786eb6d$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $142fd31a8786eb6d$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $142fd31a8786eb6d$var$prioritizer(metaTags, $142fd31a8786eb6d$var$SEO_PRIORITY_TAGS.meta);
    const link = $142fd31a8786eb6d$var$prioritizer(linkTags, $142fd31a8786eb6d$var$SEO_PRIORITY_TAGS.link);
    const script = $142fd31a8786eb6d$var$prioritizer(scriptTags, $142fd31a8786eb6d$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$142fd31a8786eb6d$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$142fd31a8786eb6d$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$142fd31a8786eb6d$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$142fd31a8786eb6d$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$142fd31a8786eb6d$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$142fd31a8786eb6d$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $142fd31a8786eb6d$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $142fd31a8786eb6d$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $142fd31a8786eb6d$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $142fd31a8786eb6d$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $142fd31a8786eb6d$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $142fd31a8786eb6d$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $142fd31a8786eb6d$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $142fd31a8786eb6d$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $142fd31a8786eb6d$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $142fd31a8786eb6d$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $142fd31a8786eb6d$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $142fd31a8786eb6d$var$server_default = $142fd31a8786eb6d$var$mapStateOnServer;
// src/HelmetData.ts
var $142fd31a8786eb6d$var$instances = [];
var $142fd31a8786eb6d$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $142fd31a8786eb6d$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $142fd31a8786eb6d$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $142fd31a8786eb6d$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $142fd31a8786eb6d$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $142fd31a8786eb6d$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $142fd31a8786eb6d$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $142fd31a8786eb6d$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var $142fd31a8786eb6d$var$defaultValue = {};
var $142fd31a8786eb6d$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($142fd31a8786eb6d$var$defaultValue);
var $142fd31a8786eb6d$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $acw62.Component) {
    static canUseDOM = $142fd31a8786eb6d$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new $142fd31a8786eb6d$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($142fd31a8786eb6d$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $142fd31a8786eb6d$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$142fd31a8786eb6d$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($142fd31a8786eb6d$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $142fd31a8786eb6d$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($142fd31a8786eb6d$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($142fd31a8786eb6d$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($142fd31a8786eb6d$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($142fd31a8786eb6d$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $142fd31a8786eb6d$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $142fd31a8786eb6d$var$flattenArray(title);
    $142fd31a8786eb6d$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $142fd31a8786eb6d$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $142fd31a8786eb6d$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $142fd31a8786eb6d$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $142fd31a8786eb6d$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $142fd31a8786eb6d$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $142fd31a8786eb6d$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $142fd31a8786eb6d$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $142fd31a8786eb6d$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $142fd31a8786eb6d$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $142fd31a8786eb6d$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $142fd31a8786eb6d$var$_helmetCallback = null;
var $142fd31a8786eb6d$var$handleStateChangeOnClient = (newState)=>{
    if ($142fd31a8786eb6d$var$_helmetCallback) cancelAnimationFrame($142fd31a8786eb6d$var$_helmetCallback);
    if (newState.defer) $142fd31a8786eb6d$var$_helmetCallback = requestAnimationFrame(()=>{
        $142fd31a8786eb6d$var$commitTagChanges(newState, ()=>{
            $142fd31a8786eb6d$var$_helmetCallback = null;
        });
    });
    else {
        $142fd31a8786eb6d$var$commitTagChanges(newState);
        $142fd31a8786eb6d$var$_helmetCallback = null;
    }
};
var $142fd31a8786eb6d$var$client_default = $142fd31a8786eb6d$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $142fd31a8786eb6d$var$HelmetDispatcher = class extends (0, $acw62.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $142fd31a8786eb6d$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if ($142fd31a8786eb6d$export$4719288a8f5f7e71.canUseDOM) $142fd31a8786eb6d$var$client_default(state);
        else if ($142fd31a8786eb6d$var$server_default) serverState = $142fd31a8786eb6d$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var $142fd31a8786eb6d$export$dcef8f9bb9a41431 = class extends (0, $acw62.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))($142fd31a8786eb6d$var$without(this.props, "helmetData"), $142fd31a8786eb6d$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))($142fd31a8786eb6d$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$142fd31a8786eb6d$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$142fd31a8786eb6d$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $142fd31a8786eb6d$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $142fd31a8786eb6d$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($142fd31a8786eb6d$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($142fd31a8786eb6d$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($142fd31a8786eb6d$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};


const $d13d68576b159df9$var$history = (0, $6d23e34a443a4a03$export$719fc203c4e16dee)();
const $d13d68576b159df9$export$86fbec116b87613f = ()=>{
    const [currentPath, setCurrentPath] = (0, $acw62.useState)($d13d68576b159df9$var$history.location.pathname);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            // Wait for OneTrust to publish OnetrustActiveGroups before
            // initialising the wrapper, so CookieCompliance has a real signal to
            // read when it gates non-operational events. Feature-detected so this
            // keeps working against older library versions; if the helper is not
            // present the per-event optOutPerfTracking() check still gates events.
            const cookieCompliance = (0, $768c2bb36d671034$exports.CookieCompliance);
            if (typeof cookieCompliance?.waitForOneTrustToInit === "function") await cookieCompliance.waitForOneTrustToInit(3000);
            if (cancelled) return;
            // Pass `null` for the userId so community-library skips the
            // legacy identity-cookie hydration and defensively clears any stale AAID
            // on the underlying analytics-web-client. Once useLoggedInUser resolves,
            // services/analytics.setUserInfo(aaid) will call setAnalyticsUserInfo to
            // attach the real AAID for authenticated sessions.
            (0, $768c2bb36d671034$exports.CommunityAnalyticsClient).initWithPageAnalytics((0, $768c2bb36d671034$exports.CommunityAnalyticsClient).SUB_APP.UNIFIED_PORTABLE_PROFILE, null, (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)(), {}, null);
        })();
        const unlisten = $d13d68576b159df9$var$history.listen(({ location: location })=>{
            setCurrentPath(location.pathname);
        });
        return ()=>{
            cancelled = true;
            unlisten();
        };
    }, []);
    // We don't want the footer on 'edit profile' view
    const shouldShowFooter = !currentPath.includes("edit");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: "app-container",
        className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
            "_1rquusvi"
        ]),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d93712440e0508b$exports.RelayEnvironmentProvider), {
            environment: (0, $b0a24095f82369bb$export$6bc7b24d4e862158),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $183c2e7b7636555c$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1bd54bdf397d06fd$export$cdecc1356a028a96), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b65debe690d9af5$export$9e14a7677ef1423c), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $eb77deb211f1d0a4$export$a4270ab432ac8a58), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $142fd31a8786eb6d$export$4719288a8f5f7e71), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $54d5bb126d55fb0e$export$55185c17a0fcbe46), {
                                        routes: (0, $b3c1eeb19c22229f$export$61147a57d3c24ac8),
                                        history: $d13d68576b159df9$var$history,
                                        basePath: "/user",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $142fd31a8786eb6d$export$dcef8f9bb9a41431), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("script", {
                                                    src: `https://${"atl-onetrust-wrapper.atlassian.com"}/assets/atl-onetrust-wrapper.min.js`,
                                                    type: "text/javascript",
                                                    "data-domain": "336ea4c3-54ae-40f0-9331-b4500ffed1ee",
                                                    "data-test": false,
                                                    "data-geofence": "false",
                                                    "data-sync": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f995eee78c0a2d$export$ef8da11641c635de), {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c1d9ab94a99f286$export$7903e4b73fc7d6c3), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $40e3d5b564ddd8a9$export$2e2bcd8739ae039)([
                                        "_4t3i1ylp _1fiszwfg"
                                    ])
                                }),
                                shouldShowFooter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58dcafbbd6a14d1d$export$a06f1c675e846f6f), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};
const $d13d68576b159df9$var$appContainerStyles = null;
const $d13d68576b159df9$var$footerSpacerStyles = null;


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
var $6485651202b333d6$var$_ref, $6485651202b333d6$var$_process, $6485651202b333d6$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $6485651202b333d6$var$TESTS_MODE = ($6485651202b333d6$var$_ref = (globalThis === null || globalThis === void 0 || ($6485651202b333d6$var$_process = globalThis.process) === null || $6485651202b333d6$var$_process === void 0 || ($6485651202b333d6$var$_process = $6485651202b333d6$var$_process.env) === null || $6485651202b333d6$var$_process === void 0 ? void 0 : $6485651202b333d6$var$_process.JEST_WORKER_ID) !== undefined, $6485651202b333d6$var$_ref !== void 0) ? $6485651202b333d6$var$_ref : false;
var $6485651202b333d6$var$DEBUG_MODE = !$6485651202b333d6$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($6485651202b333d6$var$_process2 = globalThis.process) === null || $6485651202b333d6$var$_process2 === void 0 || ($6485651202b333d6$var$_process2 = $6485651202b333d6$var$_process2.env) === null || $6485651202b333d6$var$_process2 === void 0 ? void 0 : $6485651202b333d6$var$_process2.NODE_ENV) !== "production";
var $6485651202b333d6$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$6485651202b333d6$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $hPtJY = parcelRequire("hPtJY");
var $246ced622ddb3a56$var$pkgName = "@atlaskit/platform-feature-flags";
var $246ced622ddb3a56$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $246ced622ddb3a56$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $246ced622ddb3a56$var$ENV_ENABLE_PLATFORM_FF = $246ced622ddb3a56$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $246ced622ddb3a56$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $246ced622ddb3a56$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $246ced622ddb3a56$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $246ced622ddb3a56$var$ENV_ENABLE_PLATFORM_FF || $246ced622ddb3a56$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $246ced622ddb3a56$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $246ced622ddb3a56$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$246ced622ddb3a56$var$globalVar[$246ced622ddb3a56$export$7e41b1b2bdee3f98] = $246ced622ddb3a56$var$globalVar[$246ced622ddb3a56$export$7e41b1b2bdee3f98] || $246ced622ddb3a56$var$DEFAULT_PFF_GLOBAL;
function $246ced622ddb3a56$export$f2b591175b3e424c(resolver) {
    $246ced622ddb3a56$var$globalVar[$246ced622ddb3a56$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $246ced622ddb3a56$export$6333b6aff9fc6275(flagKey) {
    if ($246ced622ddb3a56$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6485651202b333d6$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $246ced622ddb3a56$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $246ced622ddb3a56$var$globalVar[$246ced622ddb3a56$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $3a533a199f1ca779$export$ba05d765b8392e5e(flagResolver) {
    (0, $246ced622ddb3a56$export$f2b591175b3e424c)(flagResolver);
}
function $3a533a199f1ca779$export$470e5c2be1411c89(name) {
    return (0, $246ced622ddb3a56$export$6333b6aff9fc6275)(name);
}
function $3a533a199f1ca779$export$b40ec24ac8275656(name) {
    return (0, $246ced622ddb3a56$export$6333b6aff9fc6275)(name);
}



var $5NceL = parcelRequire("5NceL");

var $hM7vC = parcelRequire("hM7vC");

var $02Ztr = parcelRequire("02Ztr");


var $g5Zhu = parcelRequire("g5Zhu");


var $cfuBi = parcelRequire("cfuBi");

var $5NceL = parcelRequire("5NceL");

var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $5NceL = parcelRequire("5NceL");
var $162ad34f339133e7$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $162ad34f339133e7$var$customThemeOptions = "UNSAFE_themeOptions";
var $162ad34f339133e7$var$isThemeKind = function isThemeKind(themeKind) {
    return $162ad34f339133e7$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $162ad34f339133e7$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $5NceL.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $162ad34f339133e7$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $162ad34f339133e7$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $162ad34f339133e7$var$isColorMode(id)) themeObject[kind] = id;
        if ($162ad34f339133e7$var$isThemeKind(kind) && $162ad34f339133e7$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $162ad34f339133e7$var$customThemeOptions) try {
            themeObject[$162ad34f339133e7$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $162ad34f339133e7$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $162ad34f339133e7$var$isColorMode(id) || // custom theme state
        kind === $162ad34f339133e7$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $162ad34f339133e7$var$isThemeKind(kind) && typeof id === "string" && $162ad34f339133e7$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};



var $hM7vC = parcelRequire("hM7vC");

var $klQHf = parcelRequire("klQHf");
function $cc5e48d73cadaad1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc5e48d73cadaad1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc5e48d73cadaad1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc5e48d73cadaad1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cc5e48d73cadaad1$var$defaultColorMode = "light";
var $cc5e48d73cadaad1$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $cc5e48d73cadaad1$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _result;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $5NceL.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $5NceL.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $5NceL.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $5NceL.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $5NceL.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $5NceL.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $5NceL.themeStateDefaults)["typography"] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $5NceL.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $162ad34f339133e7$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (_result = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_result, (0, $cfuBi.THEME_DATA_ATTRIBUTE), themeAttribute), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_result, (0, $cfuBi.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $cc5e48d73cadaad1$var$defaultColorMode : colorMode), _result);
    if ((0, $3a533a199f1ca779$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) result = $cc5e48d73cadaad1$var$_objectSpread($cc5e48d73cadaad1$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $cfuBi.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $cc5e48d73cadaad1$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $hM7vC.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $klQHf.hash)(optionString);
        result[0, $cfuBi.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $cc5e48d73cadaad1$export$2e2bcd8739ae039 = $cc5e48d73cadaad1$var$getThemeHtmlAttrs;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $cfuBi = parcelRequire("cfuBi");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::63d467c8d0d48afd8fdc4e213175480c>>
 * @codegenCommand yarn build tokens
 */ 











var $6ce83c425fa21faf$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("8Ex6V"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("lH96A"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("1Lc0l"));
    },
    "dark": function dark() {
        return (parcelRequire("9Bi5g"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("3J0Ly"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("b7Xwx"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("hR0TH"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("n9MS2"));
    },
    "spacing": function spacing() {
        return (parcelRequire("k92Of"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("kBQNP"));
    },
    "shape": function shape() {
        return (parcelRequire("g5OPz"));
    },
    "typography-minor3": function typographyMinor3() {
        return (parcelRequire("04BA7"));
    }
};
var $6ce83c425fa21faf$export$2e2bcd8739ae039 = $6ce83c425fa21faf$var$themeImportsMap;



var $cfuBi = parcelRequire("cfuBi");
var $110c0ce7e3838fd9$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $cfuBi.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $cfuBi.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $110c0ce7e3838fd9$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $110c0ce7e3838fd9$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $6ce83c425fa21faf$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $110c0ce7e3838fd9$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $110c0ce7e3838fd9$export$8662df6937d86fcb = "(prefers-contrast: more)";


var $fe260825269bd5b0$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $fe260825269bd5b0$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $cfuBi.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $fe260825269bd5b0$var$darkModeMql = $fe260825269bd5b0$var$isMatchMediaAvailable && window.matchMedia((0, $110c0ce7e3838fd9$export$bb1e815119d30f8b));
var $fe260825269bd5b0$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindThemeChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$fe260825269bd5b0$var$darkModeMql) return "light";
                return $fe260825269bd5b0$var$darkModeMql !== null && $fe260825269bd5b0$var$darkModeMql !== void 0 && $fe260825269bd5b0$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($fe260825269bd5b0$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $8fY35.bind)($fe260825269bd5b0$var$darkModeMql, {
                    type: "change",
                    listener: $fe260825269bd5b0$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $fe260825269bd5b0$var$SingletonColorModeObserver = new $fe260825269bd5b0$var$ColorModeObserver();
var $fe260825269bd5b0$export$2e2bcd8739ae039 = $fe260825269bd5b0$var$SingletonColorModeObserver;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $cfuBi = parcelRequire("cfuBi");

var $cc5d31fdc3f20457$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $cc5d31fdc3f20457$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $cfuBi.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $cc5d31fdc3f20457$var$contrastModeMql = $cc5d31fdc3f20457$var$isMatchMediaAvailable && window.matchMedia((0, $110c0ce7e3838fd9$export$8662df6937d86fcb));
var $cc5d31fdc3f20457$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindContrastChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$cc5d31fdc3f20457$var$contrastModeMql) return "no-preference";
                return $cc5d31fdc3f20457$var$contrastModeMql !== null && $cc5d31fdc3f20457$var$contrastModeMql !== void 0 && $cc5d31fdc3f20457$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($cc5d31fdc3f20457$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $8fY35.bind)($cc5d31fdc3f20457$var$contrastModeMql, {
                    type: "change",
                    listener: $cc5d31fdc3f20457$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $cc5d31fdc3f20457$var$SingletonContrastModeObserver = new $cc5d31fdc3f20457$var$ContrastModeObserver();
var $cc5d31fdc3f20457$export$2e2bcd8739ae039 = $cc5d31fdc3f20457$var$SingletonContrastModeObserver;


function $fed0594986187182$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $fe260825269bd5b0$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $fe260825269bd5b0$export$2e2bcd8739ae039).bind();
    } else (0, $fe260825269bd5b0$export$2e2bcd8739ae039).unbind();
    if ((0, $3a533a199f1ca779$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).bind();
        } else (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $cc5e48d73cadaad1$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $fe260825269bd5b0$export$2e2bcd8739ae039).unbind();
        if ((0, $3a533a199f1ca779$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).unbind();
    };
}



var $lXhZa = parcelRequire("lXhZa");

var $fUHKi = parcelRequire("fUHKi");


var $02Ztr = parcelRequire("02Ztr");

var $5NceL = parcelRequire("5NceL");
function $c2acf3889ed29d53$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $5NceL.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $51f20e30bcac41e5$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $3a533a199f1ca779$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $c2acf3889ed29d53$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $3a533a199f1ca779$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) {
            var increasedContrastTheme = (0, $c2acf3889ed29d53$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themePreferences));
};
var $51f20e30bcac41e5$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themeOverridePreferences));
};



function $5a654a09224e2d18$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $5a654a09224e2d18$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $5a654a09224e2d18$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5a654a09224e2d18$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5a654a09224e2d18$var$_arrayLikeToArray(o, minLen);
}
function $5a654a09224e2d18$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $5a654a09224e2d18$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $5NceL.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $5NceL.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $5NceL.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $5NceL.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $5NceL.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $5NceL.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $5NceL.themeStateDefaults)["typography"] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $5NceL.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $3a533a199f1ca779$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $51f20e30bcac41e5$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $110c0ce7e3838fd9$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $hM7vC.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $5NceL.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $lXhZa.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("ifbJw"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $51f20e30bcac41e5$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $5a654a09224e2d18$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $fed0594986187182$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $5a654a09224e2d18$export$2e2bcd8739ae039 = $5a654a09224e2d18$var$setGlobalTheme;



(0, $5a654a09224e2d18$export$2e2bcd8739ae039)({
    colorMode: "light",
    typography: "typography-adg3"
});
const $70fc9a727fa662ae$var$container = document.getElementById("root");
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d13d68576b159df9$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.302a6fa0.js.map
